/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		1: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + chunkId + ".build.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/Content/dist/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 341);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var core = __webpack_require__(44);
var hide = __webpack_require__(32);
var redefine = __webpack_require__(33);
var ctx = __webpack_require__(45);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(556)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_BlockUI_jquery_blockUI__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__backendApi__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["a"] = ({
    blockUI: function blockUI(target, message, opts) {
        var options = {
            message: '<div class="loading-message loading-message-boxed"><span>&nbsp;&nbsp;' + message + '</span></div>',
            overlayCSS: {
                backgroundColor: '#000',
                opacity: 0.1 }
        };
        if (opts) {
            options = Object.assign(options, opts);
        }
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(target).block(options);
    },

    unblockUI: function unblockUI(target) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(target).unblock();
    },

    toastr: {
        error: function error(text) {
            __WEBPACK_IMPORTED_MODULE_2_toastr___default.a.error(text);
        },

        success: function success(text) {
            __WEBPACK_IMPORTED_MODULE_2_toastr___default.a.success(text);
        }
    },

    /**
     * форматирует ссылки из текста при отображении в кликабельный url
     * формат текста [название](ссылка) позволяет задать имя ссылке
     * @param val
     * @returns {*}
     */
    format_text_to_url: function format_text_to_url(val) {
        var total = val;
        var urlRegexWithName = /\[(.+?)\]\(<a(.+?)a>\)/g;
        var urlRegex = /(https?:\/\/[^\s]+)/g;
        var urlInHref = /(href="(.+?)")/g;
        total = total.replace(urlRegex, function (url) {
            var lastSimbol = '';
            if (url.lastIndexOf(')') > -1) {
                lastSimbol = ')';
                url = url.replace(')', '');
            }
            return '<a class="view-link" href="' + url + '" target="_blank" title="' + url + '">' + url + '</a>' + lastSimbol;
        });
        total = total.replace(urlRegexWithName, function (url) {
            var href_url = url.match(urlInHref)[0];
            href_url = href_url.substring(6, href_url.length - 1);
            return '<a class="view-link" href="' + href_url + '" target="_blank" title="' + href_url + '">' + url.substring(url.indexOf('[') + 1, url.indexOf('](')) + '</a>';
        });
        return total;
    },
    //для форматирования текста 
    format_text_helper: function format_text_helper(val) {
        var n = 0;
        var spliter = val.split('**');
        if (spliter.length > 1) {
            val = "";
            while (n < spliter.length - 1) {
                val = val + spliter[n] + (n % 2 === 0 ? '<strong>' : '</strong>');
                n++;
            }
            val = val + spliter[n];
            n = 0;
        }
        return val;
    },
    //сворачивание-разворачивание блоков
    block_collapse: function block_collapse(e) {
        var $base = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e).parent();
        if ($base.hasClass('closed')) {
            $base.removeClass('closed').addClass('opened');
        } else {
            $base.removeClass('opened').addClass('closed');
        }
    },

    pdf_view: function pdf_view(url) {
        return '<div class="pdf-view"><object data="' + url + '" type="application/pdf" width="100%" height="100%">' + '<p>Браузер не поддерживает просмотр PDF. <a href="' + url + '" target="_blanc">Нажмите здесь, чтобы скачать</a>.</p>' + '</object>' + '<a class="pdf-view-mob" href="' + url + '" target="_blanc">Нажмите, чтобы скачать презентацию</a>' + '</div>';
    },

    project_colors: function project_colors(id) {
        var color = "";
        switch (id) {
            case 1:
                color = "rgb(85, 202, 222)";break;
            case 2:
                color = "rgb(236, 126, 1)";break;
            case 6:
                color = "rgb(17, 175, 223)";break;
            case 9:
                color = "rgb(236, 126, 1)";break;
            case 15:
                color = "rgb(15, 89, 212)";break;
            case 16:
                color = "rgb(101, 141, 27)";break;
            case 18:
                color = "rgb(238, 102, 0)";break;
            case 19:
                color = "rgb(0, 173, 239)";break;
            case 22:
                color = "rgb(77, 77, 77)";break;
            case 26:
                color = "rgb(255, 0, 0)";break;
            case 28:
                color = "rgb(244, 158, 178)";break;
            case 31:
                color = "rgb(137, 214, 31)";break;
            case 32:
                color = "rgb(0, 146, 216)";break;
            default:
                color = "rgb(13, 119, 233)";
        }
        return color;
    },

    blockTillDownloaded: function blockTillDownloaded(guid, element, delay) {
        var that = this;

        this.blockUI(element);
        var backendApi = new __WEBPACK_IMPORTED_MODULE_3__backendApi__["a" /* default */]();
        var interval = setInterval(function () {
            backendApi.checkDownloaded(guid).then(function (resp) {
                if (resp.hasError || resp.data.exists === false) {
                    that.unblockUI(element);
                    clearInterval(interval);
                }
            });
        }, delay || 1000);
    },

    check_mobile: function check_mobile() {
        var check = false;
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    },

    downloadFileByBytes: function downloadFileByBytes(data, filename, typein) {
        var binaryString = window.atob(data);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }

        var blob = new Blob([bytes], { type: typein });
        var urlStr = URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = urlStr;
        link.download = filename;
        link.click();
        link.remove();
        URL.revokeObjectURL(urlStr);
    }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(79);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var endpoints = {
    reportList: '/report/list',
    report: '/report',
    //reportFns: '/report/fns',
    reportSettings: '/report/settings',
    reportDelete: '/report/delete',
    reportCheckTT: '/report/checkTradePoint',
    reportImageRotation: '/report/RotateImage',
    reportImport: '/report/import',
    qrCodeImport: '/report/qrcode',
    reportExport: '/report/export',
    reportDistinctValues: '/report/distinctValues',
    reportMultipleApprove: '/report/multipleApprove',
    newsList: '/news/list',
    news: '/news',
    newsDelete: '/news/delete',
    newsMakeVote: '/news/makeVote',
    commentsList: '/news/comments',
    commentSave: '/news/comment',
    commentDelete: '/news/commentDelete',
    // newsLikesList: '/news/likes',
    // newsViewsList: '/news/views',
    newsUsersList: '/news/users',
    newsExportUsers: '/news/exportUsers',
    project: '/project',
    projectList: '/project/list',
    projectInfo: '/project/info',
    projectInfoFilter: '/project/infoFilter',
    projectOrderSave: '/project/orderSave',
    motivationDelete: '/project/motivation/delete',
    motivationYoutubeLinkSave: '/project/motivation/linkSave',
    projectRegisterCode: '/project/registerCode',
    projectValidateCode: '/project/validateCode',
    projectVisualDesign: '/project/visualDesign',
    projectAppAccess: '/project/appAccess',
    user: '/user',
    usersList: '/user/list',
    usersCount: '/user/count',
    userDistinctValues: '/user/distinctValues',
    userSave: '/user/save',
    userDelete: '/user/delete',
    userDocumentRotation: '/user/RotateDocument',
    userSearch: '/user/search',
    userRecover: '/user/recover',
    userResetPassword: '/user/reset',
    userConfirmEmail: '/user/confirm',
    userChangePassword: '/user/changePassword',
    userSavePassword: '/user/savePassword',
    userRegister: '/user/register',
    userRefuse: '/user/refuse',
    userActivation: '/user/activation',
    userActivationInfo: '/user/activationInfo',
    userPaymentSettings: '/user/paymentSettings',
    userExport: '/user/export',
    userExportReport: '/user/exportReport',
    userCheckInn: '/user/checkInn',
    tradePointList: '/tradepoints/list',
    tradePointSave: '/tradepoints/',
    tradePointDelete: '/tradepoints/delete/',
    tradePointSearch: '/tradepoints/search',
    tradePointListForReport: '/tradepoints/listForReport',
    tradePointListForRegister: '/tradepoints/listForRegister',
    tradePointDistinctValues: '/tradepoints/distinctValues',
    tradePointExport: '/tradepoints/export',
    commonDistinctValues: '/common/distinctValues',
    sku: '/sku',
    skuGet: '/sku?api-version=1.1',
    skuList: '/sku/list?api-version=1.1',
    skuShortList: '/sku/shortList',
    skuDelete: '/sku/delete',
    skuSettings: '/sku/settingsList',
    skuSettingsSave: '/sku/settingsSave',
    skuGroupsSave: '/sku/saveGroups',
    skuSearch: '/sku/search',
    skuSearchForTable: '/sku/searchForTable',
    skuLinksSearch: '/sku/linksSearch',
    skuApplyLinks: '/sku/applyLinks',
    skuGroupList: '/sku/skuGroups',
    skuExport: '/sku/export',
    skuExportLink: '/sku/exportLink',
    profile: '/profile',
    profileSaveAgreements: '/profile/saveAgreements',
    profileRemoveExternal: '/profile/externalRemove',
    profileInfo: '/profile/info',
    profileDocs: '/profile/docs',
    profileCard: '/profile/card',
    summary: '/dashboard/summary',
    firstActionsComplete: '/dashboard/firstActionsComplete',
    roles: '/roles',
    rolesList: '/roles/list',
    rolesSaveList: '/roles/saveList',
    rolesDelete: '/roles/delete',
    rewards: '/rewards',
    rewardsList: '/rewards/list',
    rewardsAggregateList: '/rewards/aggregatedList',
    rewardsDelete: '/rewards/delete',
    rewardGroupList: '/rewards/rewardGroups',
    rewardsGroupsSave: '/rewards/saveGroups',
    rewardsExport: '/rewards/export',
    giftery: '/rewards/giftery',
    orders: '/orders',
    ordersList: '/orders/list',
    ordersProcess: '/orders/process',
    ordersCancel: '/orders/cancel',
    orderExtraData: '/orders/extraData',
    orderExtraDataRemove: '/orders/extraDataRemove',
    ordersComplete: '/orders/complete',
    ordersReceive: '/orders/receive',
    ordersRemove: '/orders/remove',
    orderDistinctValues: '/orders/distinctValues',
    ordersExport: '/orders/export',
    orderAddressList: '/orders/addresses',
    orderAddress: '/orders/address',
    orderConfirmAddress: '/orders/addressConfirm',
    makeGifteryOrder: '/orders/gifteryOrder',
    gifteryBalance: '/orders/gifteryBalance',
    makeOzonOrder: '/orders/ozonOrder',
    orderStatuses: '/orders/orderStatuses',
    orderHistory: '/orders/history',
    materials: '/materials',
    materialsTestResults: '/materials/testResults',
    materialsTestRating: '/materials/testRating',
    materialsList: '/materials/list',
    materialSave: '/materials/save',
    materialDelete: '/materials/delete',
    materialQuestionsSave: '/materials/saveQuestions',
    materialQuestionsImport: '/materials/importQuestions',
    materialStartTest: '/materials/startTest',
    materialMakeAnswer: '/materials/makeAnswer',
    materialResultsExport: '/materials/results/export',
    materialResultsExportDistinctValues: '/materials/results/DistinctValues',
    materialUpdateTestSession: '/materials/updateTestSession',
    materialFailTestSession: '/materials/failTestSession',
    materialStats: '/materials/stats',
    materialMakeVote: '/materials/makeVote',
    materialUsersList: '/materials/users',
    materialUpdateProgress: '/materials/progress',
    materialExportUsers: '/materials/exportUsers',
    materialCertificate: '/materials/certificate',
    materialCertificateData: '/materials/certificateData',
    materialCertificateDownload: '/materials/certificateDownload',
    materialCertificateExport: '/materials/certificateExport',
    materialCertificateDistinctValues: '/materials/certificate/DistinctValues',
    materialResultsExportUsers: '/materials/results/exportUsers',
    folderList: '/folder/list',
    folderDelete: '/folder/delete',
    folder: '/folder',
    folderArchive: '/folder/archive',
    folderRestore: '/folder/restore',
    analytics: '/stats',
    analyticsDetails: '/stats/details',
    analyticsExport: '/stats/export',
    analyticsExportByReports: '/stats/exportByReports',
    analyticsDistinctValues: '/common/statsValues',
    rating: '/rating',
    ratingDistinctValues: '/rating/distinctValues',
    ratingExport: '/rating/export',
    ratingSettings: '/rating/settings',
    bonusHistoryList: '/bonusHistory/list',
    bonusHistoryDistinctValues: '/bonusHistory/distinctValues',
    bonusHistoryExport: '/bonusHistory/export',
    domainFoldersList: '/domainFolder/list',
    domainFolderDelete: '/domainFolder/delete',
    domainFolder: '/domainFolder',
    domainFolderArchive: '/domainFolder/archive',
    domainFolderRestore: '/domainFolder/restore',
    checkDownloaded: '/common/checkDownloaded',
    newsletter: '/newsletter',
    bulkSendingTemplates: '/bulkSending/templates',
    bulkSendingTemplateSave: '/bulkSending/templateSave',
    bulkSendingTemplateDelete: '/bulkSending/templateDelete',
    bulkSendingTest: '/bulkSending/test',
    bulkSending: '/bulkSending/',
    bulkSendingSave: '/bulkSending',
    bulkSendingDelete: '/bulkSending/delete',
    bulkSendingList: '/bulkSending/list',
    bulkSendingReceiversList: '/bulkSending/receivers',
    bulkSendingStats: '/bulkSending/stats',
    bulkSendingLogsList: '/bulkSending/logs',
    bulkSendingExportDetails: '/bulkSending/exportDetails',
    smtpSettingsList: '/bulkSending/smtp',
    smsLimits: '/bulkSending/smslimits',
    changeUser: '/account/change-user',
    returnUser: '/account/return-to-user',
    checkUser: '/account/checkUser',
    confirmationCode: '/user/code',
    checkConfirmationCode: '/user/checkcode',
    saveSecondsProgress: '/common/secondsProgress',
    getBankNameByBik: '/common/bik',
    getFileExport: '/common/exported',
    commonBulkSending: '/common/bulkSending',
    commonOzonAccounts: '/common/ozonAccounts',
    commonCountries: '/common/countries',
    commonNotificationList: '/common/notification/list',
    commonImageRotation: '/common/image/rotate',
    tasksList: '/tasks/list?api-version=1.0',
    tasks: '/tasks',
    tasksGet: '/tasks?api-version=1.1',
    tasksAnswerGet: '/tasks/answer?api-version=1.1',
    tasksAnswer: '/tasks/answer',
    tasksAnswers: '/tasks/answers',
    tasksDistinctValues: '/tasks/distinctValues',
    tasksMemberFilter: '/tasks/memberFilter',
    tasksAnswerAccept: '/tasks/answerAccept',
    tasksDelete: '/tasks/delete',
    tasksExport: '/tasks/export',
    tasksGeneralExport: '/tasks/generalExport',
    tasksExportReport: '/tasks/exportReport',
    tasksExportAnalyticsCersanit: '/tasks/exportAnalyticsCersanit',
    tasksExportAnalyticsJeelex: '/tasks/exportAnalyticsJeelex',
    tasksAnswersDetail: '/tasks/answers/detail',
    tasksDetailExport: '/tasks/detail/export',
    tasksBonus: '/tasks/bonus',
    tasksResponsible: '/tasks/responsible',
    tasksResponsibleRefuse: '/tasks/responsible/refuse',
    taskCheckResponsible: '/tasks/checkResponsible',
    tasksExportSku: '/tasks/export/sku',
    tasksImportSku: '/tasks/import/sku',
    tasksCopy: '/tasks/copy',
    tasksUsersOnRoles: '/tasks/usersOnRoles'
};

var _class = function () {
    function _class() {
        var apiServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__config___default.a.apiUrl + '/api';

        _classCallCheck(this, _class);

        this.apiServer = apiServer;
    }

    _createClass(_class, [{
        key: 'callApi',
        value: function callApi(endpoint, data) {
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var responseType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
            var timeout = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

            timeout = timeout || 60000;
            var url = '' + this.apiServer + endpoint;
            var queryConfig = {
                params: {},
                timeout: timeout
            };
            if (responseType) {
                queryConfig.responseType = responseType;
            }
            var headers = {};
            var tokenInfo = JSON.parse(localStorage.getItem('tokenInfo') == null ? sessionStorage.getItem('tokenInfo') : localStorage.getItem('tokenInfo'));
            var projectId = localStorage.getItem('selectedProjectId');

            if (tokenInfo) {
                headers = {
                    Authorization: 'bearer ' + tokenInfo.access_token,
                    ProjectId: projectId
                };
                queryConfig.headers = headers;
            } else {
                var searchParam = new URLSearchParams(window.location.search);
                if (searchParam && searchParam.get('token') && searchParam.get('projectId')) {
                    headers = {
                        Authorization: 'bearer ' + searchParam.get('token'),
                        ProjectId: searchParam.get('projectId')
                    };
                    queryConfig.headers = headers;
                }
            }

            if (data) {
                Object.assign(queryConfig.params, data);
            }

            var succesAction = function succesAction(res) {
                if (res.data.code !== 0) {
                    return {
                        hasError: true,
                        status: res.data.code
                        //message: res.data.message
                    };
                }

                return {
                    hasError: false,
                    data: res.data.result ? res.data.result.data || res.data.result : null
                };
            };
            var catchAction = function catchAction(error) {
                if (error.response && error.response.status === 401) {
                    return {
                        hasError: true,
                        status: 401,
                        message: 'Unauthorized access'
                    };
                }

                if (error.data) {
                    console.error(error.data);
                }
                var exceptionMessage = error.response && error.response.data && error.response.data.ExceptionMessage ? error.response.data.ExceptionMessage : 'Inernal Server Error';
                return {
                    hasError: true,
                    status: 500,
                    message: exceptionMessage
                };
            };
            if (method === 'GET') {
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, queryConfig).then(succesAction).catch(catchAction);
            } else if (method === 'POST') {
                return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, data, { headers: headers, timeout: timeout }).then(succesAction).catch(catchAction);
            }
        }
    }, {
        key: 'reportLoad',
        value: function reportLoad(id, projectId) {
            return this.callApi(endpoints.report, { id: id, projectId: projectId });
        }
    }, {
        key: 'reportList',
        value: function reportList(skip, take, projectId, stateId, dateTypeId, dateStart, dateEnd, filter) {
            return this.callApi(endpoints.reportList, {
                skip: skip,
                take: take,
                projectId: projectId,
                stateId: stateId,
                dateTypeId: dateTypeId,
                dateStart: dateStart,
                dateEnd: dateEnd,
                filter: filter ? filter : ''
            });
        }
    }, {
        key: 'reportSettingsList',
        value: function reportSettingsList(projectId) {
            return this.callApi(endpoints.reportSettings, { projectId: projectId });
        }
    }, {
        key: 'reportSave',
        value: function reportSave(report) {
            return this.callApi(endpoints.report, report, 'POST');
        }

        // reportFnsSave (report){
        //     return this.callApi(endpoints.reportFns, report, 'POST');
        // }

    }, {
        key: 'reportDelete',
        value: function reportDelete(id) {
            return this.callApi(endpoints.reportDelete + ('/' + id), {}, 'POST');
        }
    }, {
        key: 'reportCheckTT',
        value: function reportCheckTT(tradePointId) {
            return this.callApi(endpoints.reportCheckTT, { tradePointId: tradePointId });
        }
    }, {
        key: 'rotateReportImage',
        value: function rotateReportImage(id, direction) {
            return this.callApi(endpoints.reportImageRotation, {
                imageId: id,
                direction: direction
            });
        }
    }, {
        key: 'reportImport',
        value: function reportImport(projectId, data) {
            return this.callApi(endpoints.reportImport + ('?projectId=' + projectId), data, 'POST');
        }
    }, {
        key: 'qrCodeImport',
        value: function qrCodeImport(data) {
            return this.callApi(endpoints.qrCodeImport, data, 'POST');
        }
    }, {
        key: 'reportExport',
        value: function reportExport(projectId, filter, stateId, dateTypeId, dateStart, dateEnd) {
            return this.callApi(endpoints.reportExport, {
                projectId: projectId,
                stateId: stateId,
                dateTypeId: dateTypeId,
                dateStart: dateStart,
                dateEnd: dateEnd,
                filter: filter ? filter : ''
            }, 'GET', null, 300000);
        }
    }, {
        key: 'reportDistinctValues',
        value: function reportDistinctValues(columnName, projectId, search, filter, skip, take) {
            return this.callApi(endpoints.reportDistinctValues, {
                columnName: columnName,
                projectId: projectId,
                search: search,
                filter: filter ? filter : '',
                skip: skip,
                take: take
            }, 'POST');
        }
    }, {
        key: 'reportMultipleApprove',
        value: function reportMultipleApprove(reports) {
            return this.callApi(endpoints.reportMultipleApprove, reports, 'POST');
        }
    }, {
        key: 'newsList',
        value: function newsList(skip, take, projectId) {
            return this.callApi(endpoints.newsList, {
                skip: skip,
                take: take,
                projectId: projectId
            });
        }
    }, {
        key: 'newsLoad',
        value: function newsLoad(id) {
            return this.callApi(endpoints.news, {
                id: id
            });
        }
    }, {
        key: 'newsSave',
        value: function newsSave(news) {
            return this.callApi(endpoints.news, news, 'POST');
        }
    }, {
        key: 'newsDelete',
        value: function newsDelete(id) {
            return this.callApi(endpoints.newsDelete + ('/' + id), {}, 'POST');
        }
    }, {
        key: 'newsMakeVote',
        value: function newsMakeVote(id) {
            return this.callApi(endpoints.newsMakeVote, {
                Id: id
            }, 'POST');
        }
    }, {
        key: 'commentsList',
        value: function commentsList(skip, take, newsId) {
            return this.callApi(endpoints.commentsList, {
                skip: skip,
                take: take,
                newsId: newsId
            });
        }

        // newsLikesList(skip, take, newsId){
        //     return this.callApi(endpoints.newsLikesList, {
        //         skip,
        //         take,
        //         newsId
        //     })
        // }
        //
        // newsViewsList(skip, take, newsId){
        //     return this.callApi(endpoints.newsViewsList, {
        //         skip,
        //         take,
        //         newsId
        //     })
        // }

    }, {
        key: 'newsUsersList',
        value: function newsUsersList(skip, take, newsId) {
            return this.callApi(endpoints.newsUsersList, {
                skip: skip,
                take: take,
                newsId: newsId
            });
        }
    }, {
        key: 'newsExportUsers',
        value: function newsExportUsers(id) {
            return this.callApi(endpoints.newsExportUsers, { id: id }, 'GET', null, 300000);
        }
    }, {
        key: 'commentSave',
        value: function commentSave(data) {
            return this.callApi(endpoints.commentSave, data, 'POST');
        }
    }, {
        key: 'commentDelete',
        value: function commentDelete(id) {
            return this.callApi(endpoints.commentDelete + ('/' + id), {}, 'POST');
        }
    }, {
        key: 'projectList',
        value: function projectList(skip, take, active) {
            return this.callApi(endpoints.projectList, {
                Skip: skip,
                Take: take,
                accessId: 0,
                Active: active
            });
        }
    }, {
        key: 'projectInfo',
        value: function projectInfo() {
            return this.callApi(endpoints.projectInfo);
        }
    }, {
        key: 'projectInfoSave',
        value: function projectInfoSave(project) {
            return this.callApi(endpoints.projectInfo, project, 'POST');
        }
    }, {
        key: 'projectInfoFilter',
        value: function projectInfoFilter() {
            return this.callApi(endpoints.projectInfoFilter);
        }
    }, {
        key: 'projectOrderSave',
        value: function projectOrderSave(projects) {
            return this.callApi(endpoints.projectOrderSave, projects, 'POST');
        }
    }, {
        key: 'projectLoad',
        value: function projectLoad(id) {
            return this.callApi(endpoints.project, { id: id });
        }
    }, {
        key: 'projectSave',
        value: function projectSave(project) {
            return this.callApi(endpoints.project, project, 'POST');
        }
    }, {
        key: 'projectDelete',
        value: function projectDelete(projectId) {
            return this.callApi(endpoints.project + '/delete/' + projectId, null, 'POST');
        }
    }, {
        key: 'projectRegisterCode',
        value: function projectRegisterCode() {
            return this.callApi(endpoints.projectRegisterCode);
        }
    }, {
        key: 'projectValidateCode',
        value: function projectValidateCode(code) {
            return this.callApi(endpoints.projectValidateCode, { code: code });
        }
    }, {
        key: 'projectVisualDesign',
        value: function projectVisualDesign(projectId) {
            return this.callApi(endpoints.projectVisualDesign, { projectId: projectId });
        }
    }, {
        key: 'projectAppAccess',
        value: function projectAppAccess(skip, take, accessId) {
            return this.callApi(endpoints.projectAppAccess, { skip: skip, take: take, accessId: accessId });
        }
    }, {
        key: 'projectAppAccessSave',
        value: function projectAppAccessSave(project) {
            return this.callApi(endpoints.projectAppAccess, project, 'POST');
        }
    }, {
        key: 'userLoad',
        value: function userLoad(userName, projectId) {
            return this.callApi(endpoints.user, { userName: userName, projectId: projectId });
        }
    }, {
        key: 'usersList',
        value: function usersList(skip, take, projectId, filter, roleId, dateSortEmpty, dateSortType, dateStart, dateEnd) {
            return this.callApi(endpoints.usersList, {
                skip: skip,
                take: take,
                projectId: projectId,
                filter: filter ? filter : '',
                roleId: roleId,
                dateSortEmpty: dateSortEmpty,
                dateSortType: dateSortType,
                dateStart: dateStart,
                dateEnd: dateEnd
            });
        }
    }, {
        key: 'usersCount',
        value: function usersCount(projectId, filter, roleId, dateSortEmpty, dateSortType, dateStart, dateEnd) {
            return this.callApi(endpoints.usersCount, {
                projectId: projectId,
                filter: filter ? filter : '',
                roleId: roleId,
                dateSortEmpty: dateSortEmpty,
                dateSortType: dateSortType,
                dateStart: dateStart,
                dateEnd: dateEnd
            });
        }
    }, {
        key: 'userDistinctValues',
        value: function userDistinctValues(columnName, projectId, search, filter, skip, take) {
            return this.callApi(endpoints.userDistinctValues, {
                columnName: columnName,
                projectId: projectId,
                search: search,
                filter: filter ? filter : '',
                skip: skip,
                take: take
            }, 'POST');
        }
    }, {
        key: 'userSave',
        value: function userSave(user) {
            return this.callApi(endpoints.userSave, user, 'POST');
        }
    }, {
        key: 'userDelete',
        value: function userDelete(userName) {
            return this.callApi(endpoints.userDelete, { userName: userName }, 'POST');
        }
    }, {
        key: 'rotateUserDocument',
        value: function rotateUserDocument(id, direction) {
            return this.callApi(endpoints.userDocumentRotation, {
                imageId: id,
                direction: direction
            });
        }
    }, {
        key: 'userSearch',
        value: function userSearch(skip, take, projectId, roleId, searchText) {
            return this.callApi(endpoints.userSearch, {
                skip: skip,
                take: take,
                projectId: projectId,
                roleId: roleId,
                searchText: searchText ? searchText : ''
            });
        }
    }, {
        key: 'userRecover',
        value: function userRecover(email) {
            return this.callApi(endpoints.userRecover + ('/' + email), {}, 'POST');
        }
    }, {
        key: 'userResetPassword',
        value: function userResetPassword(hash) {
            return this.callApi(endpoints.userResetPassword + ('/' + hash), {});
        }
    }, {
        key: 'userChangePassword',
        value: function userChangePassword(oldPassword, newPassword) {
            return this.callApi(endpoints.userChangePassword, {
                oldPassword: oldPassword,
                newPassword: newPassword
            }, 'POST');
        }
    }, {
        key: 'userSavePassword',
        value: function userSavePassword(userName, password) {
            return this.callApi(endpoints.userSavePassword, {
                userName: userName,
                password: password
            }, 'POST');
        }
    }, {
        key: 'userRegister',
        value: function userRegister(user) {
            return this.callApi(endpoints.userRegister, user, 'POST');
        }
    }, {
        key: 'userRefuse',
        value: function userRefuse(user) {
            return this.callApi(endpoints.userRefuse, user, 'POST');
        }
    }, {
        key: 'userConfirmEmail',
        value: function userConfirmEmail(hash) {
            return this.callApi(endpoints.userConfirmEmail + ('/' + hash), {});
        }
    }, {
        key: 'userActivationInfo',
        value: function userActivationInfo(hash) {
            return this.callApi(endpoints.userActivationInfo + ('/' + hash), {});
        }
    }, {
        key: 'userActivation',
        value: function userActivation(activationCode, password) {
            return this.callApi(endpoints.userActivation, {
                activationCode: activationCode,
                password: password
            }, 'POST');
        }
    }, {
        key: 'savePaymentSettings',
        value: function savePaymentSettings(obj) {
            return this.callApi(endpoints.userPaymentSettings, obj, 'POST');
        }
    }, {
        key: 'userExport',
        value: function userExport(projectId, filter, roleId, dateSortEmpty, dateSortType, dateStart, dateEnd, notIncluded) {
            return this.callApi(endpoints.userExport, { projectId: projectId, filter: filter, roleId: roleId, dateSortEmpty: dateSortEmpty, dateSortType: dateSortType, dateStart: dateStart, dateEnd: dateEnd, notIncluded: notIncluded }, 'GET', null, 300000);
        }
    }, {
        key: 'userExportReport',
        value: function userExportReport(projectId, filter) {
            return this.callApi(endpoints.userExportReport, { projectId: projectId, filter: filter }, 'GET', null, 300000);
        }
    }, {
        key: 'userCheckInn',
        value: function userCheckInn(obj) {
            return this.callApi(endpoints.userCheckInn, obj, 'POST');
        }
    }, {
        key: 'tradePointList',
        value: function tradePointList(skip, take, projectId, filter) {
            return this.callApi(endpoints.tradePointList, {
                skip: skip,
                take: take,
                projectId: projectId,
                filter: filter ? filter : ''
            });
        }
    }, {
        key: 'tradePointSave',
        value: function tradePointSave(user) {
            return this.callApi(endpoints.tradePointSave, user, 'POST');
        }
    }, {
        key: 'tradePointDelete',
        value: function tradePointDelete(id) {
            return this.callApi(endpoints.tradePointDelete + ('/' + id), {}, 'POST');
        }
    }, {
        key: 'tradePointSearch',
        value: function tradePointSearch(skip, take, projectId, searchText) {
            return this.callApi(endpoints.tradePointSearch, {
                skip: skip,
                take: take,
                projectId: projectId,
                searchText: searchText
            });
        }
    }, {
        key: 'tradePointListForReport',
        value: function tradePointListForReport(skip, take, projectId, searchText, allowed) {
            return this.callApi(endpoints.tradePointListForReport, {
                skip: skip,
                take: take,
                projectId: projectId || '',
                searchText: searchText,
                allowed: allowed
            });
        }
    }, {
        key: 'tradePointListForRegister',
        value: function tradePointListForRegister(skip, take, searchText) {
            return this.callApi(endpoints.tradePointListForRegister, {
                skip: skip,
                take: take,
                searchText: searchText
            });
        }
    }, {
        key: 'tradePointDistinctValues',
        value: function tradePointDistinctValues(columnName, projectId, search, filter, skip, take) {
            return this.callApi(endpoints.tradePointDistinctValues, {
                columnName: columnName,
                projectId: projectId,
                search: search,
                filter: filter ? filter : '',
                skip: skip,
                take: take
            }, 'POST');
        }
    }, {
        key: 'tradePointExport',
        value: function tradePointExport(projectId, filter) {
            return this.callApi(endpoints.tradePointExport, { projectId: projectId, filter: filter ? filter : '' }, 'GET', null, 300000);
        }
    }, {
        key: 'skuList',
        value: function skuList(skip, take, projectId, search, active, folderId) {
            return this.callApi(endpoints.skuList, {
                skip: skip,
                take: take,
                projectId: projectId,
                search: search == null ? '' : search,
                active: active,
                folderId: folderId
            });
        }
    }, {
        key: 'skuShortList',
        value: function skuShortList(skip, take, projectId) {
            return this.callApi(endpoints.skuShortList, { skip: skip, take: take, projectId: projectId });
        }
    }, {
        key: 'skuGroupList',
        value: function skuGroupList(projectId) {
            return this.callApi(endpoints.skuGroupList, {
                projectId: projectId || ''
            });
        }
    }, {
        key: 'skuApplyLinks',
        value: function skuApplyLinks(id, selectedIds, links) {
            return this.callApi(endpoints.skuApplyLinks, {
                id: id,
                ids: selectedIds,
                links: links
            }, 'POST');
        }
    }, {
        key: 'skuLoad',
        value: function skuLoad(id, projectId, forEdit) {
            return this.callApi(endpoints.skuGet, {
                id: id,
                projectId: projectId ? projectId : '',
                forEdit: forEdit
            });
        }
    }, {
        key: 'skuSave',
        value: function skuSave(sku) {
            return this.callApi(endpoints.sku, sku, 'POST');
        }
    }, {
        key: 'skuDelete',
        value: function skuDelete(id) {
            return this.callApi(endpoints.skuDelete + ('/' + id), {}, 'POST');
        }
    }, {
        key: 'skuSearch',
        value: function skuSearch(skip, take, tradePointId, searchText, fieldName) {
            return this.callApi(endpoints.skuSearch, {
                skip: skip,
                take: take,
                tradePointId: tradePointId,
                searchText: searchText ? searchText : '',
                fieldName: fieldName
            });
        }
    }, {
        key: 'skuSearchForTable',
        value: function skuSearchForTable(skip, take, tradePointId, searchText, fieldName, fieldId, skuView) {
            return this.callApi(endpoints.skuSearchForTable, {
                skip: skip,
                take: take,
                tradePointId: tradePointId,
                searchText: searchText ? searchText : '',
                fieldName: fieldName, fieldId: fieldId, skuView: skuView
            });
        }
    }, {
        key: 'skuLinksSearch',
        value: function skuLinksSearch(skip, take, projectId, searchText, linksExcepted) {
            return this.callApi(endpoints.skuLinksSearch, {
                skip: skip,
                take: take,
                projectId: projectId,
                searchText: searchText ? searchText : '',
                linksExcepted: linksExcepted
            });
        }
    }, {
        key: 'skuExport',
        value: function skuExport(projectId, search, active) {
            return this.callApi(endpoints.skuExport, { projectId: projectId || '', search: search, active: active }, 'GET', null, 300000);
        }
    }, {
        key: 'skuExportLink',
        value: function skuExportLink(projectId, search, active) {
            return this.callApi(endpoints.skuExportLink, { projectId: projectId || '', search: search, active: active }, 'GET', null, 300000);
        }
    }, {
        key: 'commonDistinctValues',
        value: function commonDistinctValues(tableName, columnName, projectId, search, filter, skip, take) {
            return this.callApi(endpoints.commonDistinctValues, {
                tableName: tableName,
                columnName: columnName,
                projectId: projectId,
                search: search,
                filter: filter ? filter : '',
                skip: skip,
                take: take
            }, 'POST');
        }
    }, {
        key: 'domainFoldersList',
        value: function domainFoldersList(projectId, domainTypeId, folderId) {
            return this.callApi(endpoints.domainFoldersList, {
                projectId: projectId || '',
                domainTypeId: domainTypeId,
                folderId: folderId || ''
            });
        }
    }, {
        key: 'profileLoad',
        value: function profileLoad() {
            return this.callApi(endpoints.profile);
        }
    }, {
        key: 'profileSaveInfo',
        value: function profileSaveInfo(profile) {
            return this.callApi(endpoints.profileInfo, profile, 'POST');
        }
    }, {
        key: 'profileSaveDocs',
        value: function profileSaveDocs(profile) {
            return this.callApi(endpoints.profileDocs, profile, 'POST');
        }
    }, {
        key: 'profileSaveCard',
        value: function profileSaveCard(profile) {
            return this.callApi(endpoints.profileCard, profile, 'POST');
        }
    }, {
        key: 'profileSaveAgreements',
        value: function profileSaveAgreements(termsConfirmed, notificationsEnabled, personalDataEditingAccept) {
            return this.callApi(endpoints.profileSaveAgreements, {
                termsConfirmed: termsConfirmed,
                notificationsEnabled: notificationsEnabled,
                personalDataEditingAccept: personalDataEditingAccept
            }, 'POST');
        }
    }, {
        key: 'removeExternalLogin',
        value: function removeExternalLogin(loginProvider) {
            return this.callApi(endpoints.profileRemoveExternal, { loginProvider: loginProvider }, 'GET');
        }
    }, {
        key: 'summaryInfo',
        value: function summaryInfo(projectId) {
            return this.callApi(endpoints.summary, {
                projectId: projectId ? projectId : ''
            });
        }
    }, {
        key: 'firstActionsComplete',
        value: function firstActionsComplete() {
            return this.callApi(endpoints.firstActionsComplete, {});
        }
    }, {
        key: 'skuSettings',
        value: function skuSettings(projectId) {
            return this.callApi(endpoints.skuSettings, { projectId: projectId });
        }
    }, {
        key: 'skuSettingsSave',
        value: function skuSettingsSave(projectId, settingsDict) {
            return this.callApi(endpoints.skuSettingsSave, {
                ProjectId: projectId,
                Fields: settingsDict
            }, 'POST');
        }
    }, {
        key: 'skuGroupsSave',
        value: function skuGroupsSave(projectId, groups) {
            return this.callApi(endpoints.skuGroupsSave + '/' + projectId, groups, 'POST');
        }
    }, {
        key: 'rolesList',
        value: function rolesList(projectId) {
            return this.callApi(endpoints.rolesList, {
                projectId: projectId
            });
        }
    }, {
        key: 'rolesSave',
        value: function rolesSave(role) {
            return this.callApi(endpoints.roles, role, 'POST');
        }
    }, {
        key: 'rolesSaveList',
        value: function rolesSaveList(roles) {
            return this.callApi(endpoints.rolesSaveList, roles, 'POST');
        }
    }, {
        key: 'rolesDelete',
        value: function rolesDelete(id) {
            return this.callApi(endpoints.rolesDelete + ('/' + id), {}, 'POST');
        }
    }, {
        key: 'motivationSave',
        value: function motivationSave(formData) {}
    }, {
        key: 'motivationDelete',
        value: function motivationDelete(projectId) {
            return this.callApi(endpoints.motivationDelete + ('/' + projectId), {}, 'POST');
        }
    }, {
        key: 'motivationYoutubeLinkSave',
        value: function motivationYoutubeLinkSave(projectId, youtubeLink, videoName) {
            return this.callApi(endpoints.motivationYoutubeLinkSave, { projectId: projectId, youtubeLink: youtubeLink, videoName: videoName }, 'POST');
        }
    }, {
        key: 'rewardsList',
        value: function rewardsList(skip, take, projectId, search, onlyActive) {
            return this.callApi(endpoints.rewardsList, {
                skip: skip,
                take: take,
                projectId: projectId ? projectId : '',
                search: search == null ? '' : search,
                onlyActive: onlyActive
            });
        }
    }, {
        key: 'rewardsAggregateList',
        value: function rewardsAggregateList(skip, take, projectId, search, onlyActive, folderId, rewardType, active) {
            return this.callApi(endpoints.rewardsAggregateList, {
                skip: skip,
                take: take,
                projectId: projectId ? projectId : '',
                search: search == null ? '' : search,
                onlyActive: onlyActive,
                folderId: folderId,
                rewardType: rewardType,
                active: active
            });
        }
    }, {
        key: 'rewardsLoad',
        value: function rewardsLoad(id) {
            return this.callApi(endpoints.rewards, {
                id: id
            });
        }
    }, {
        key: 'rewardsSave',
        value: function rewardsSave(data) {
            return this.callApi(endpoints.rewards, data, 'POST');
        }
    }, {
        key: 'rewardsDelete',
        value: function rewardsDelete(id) {
            return this.callApi(endpoints.rewardsDelete + ('/' + id), {}, 'POST');
        }
    }, {
        key: 'rewardGroupList',
        value: function rewardGroupList(projectId) {
            return this.callApi(endpoints.rewardGroupList, {
                projectId: projectId || ''
            });
        }
    }, {
        key: 'rewardsGroupsSave',
        value: function rewardsGroupsSave(projectId, groups) {
            return this.callApi(endpoints.rewardsGroupsSave + '/' + projectId, groups, 'POST');
        }
    }, {
        key: 'rewardsExport',
        value: function rewardsExport(folderId, search, active, rewardType) {
            return this.callApi(endpoints.rewardsExport, {
                search: search == null ? '' : search,
                folderId: folderId,
                rewardType: rewardType,
                active: active
            }, 'GET', null, 300000);
        }
    }, {
        key: 'ordersList',
        value: function ordersList(skip, take, projectId, dateStart, dateEnd, orderDateTypeId, orderStatus, filter, rewardTypeId) {
            return this.callApi(endpoints.ordersList, {
                skip: skip,
                take: take,
                projectId: projectId ? projectId : '',
                dateStart: dateStart || '',
                dateEnd: dateEnd || '',
                orderStatus: orderStatus || '',
                orderDateTypeId: orderDateTypeId,
                filter: filter || '',
                rewardTypeId: rewardTypeId
            }, 'GET');
        }
    }, {
        key: 'orderDistinctValues',
        value: function orderDistinctValues(columnName, projectId, search, filter, skip, take) {
            return this.callApi(endpoints.orderDistinctValues, {
                columnName: columnName,
                projectId: projectId,
                search: search,
                filter: filter ? filter : '',
                skip: skip,
                take: take
            }, 'POST');
        }
    }, {
        key: 'orderPlace',
        value: function orderPlace(order) {
            return this.callApi(endpoints.orders, order, 'POST');
        }
    }, {
        key: 'orderExtraData',
        value: function orderExtraData(orderId, fileData, fileName) {
            return this.callApi(endpoints.orderExtraData, {
                orderId: orderId,
                fileData: fileData,
                fileName: fileName
            }, 'POST');
        }
    }, {
        key: 'orderExtraDataRemove',
        value: function orderExtraDataRemove(orderId) {
            return this.callApi(endpoints.orderExtraDataRemove + '/' + orderId, {}, 'POST');
        }
    }, {
        key: 'orderProcess',
        value: function orderProcess(orderIds) {
            return this.callApi(endpoints.ordersProcess, {
                orderIds: orderIds
            }, 'POST');
        }
    }, {
        key: 'orderCancel',
        value: function orderCancel(orderId, comment) {
            return this.callApi(endpoints.ordersCancel, {
                orderId: orderId,
                comment: comment
            }, 'POST');
        }
    }, {
        key: 'orderComplete',
        value: function orderComplete(orderIds) {
            return this.callApi(endpoints.ordersComplete, {
                orderIds: orderIds
            }, 'POST');
        }

        // orderComplete (orderId, fileData, fileName){
        //     return this.callApi(endpoints.ordersComplete, {
        //         orderId,
        //         fileData,
        //         fileName
        //     }, 'POST');
        // }

    }, {
        key: 'orderReceive',
        value: function orderReceive(orderId) {
            return this.callApi(endpoints.ordersReceive + '/' + orderId, {}, 'GET');
        }
    }, {
        key: 'orderReceiveWithDate',
        value: function orderReceiveWithDate(orderId, date) {
            return this.callApi(endpoints.ordersReceive, { orderId: orderId, date: date }, 'POST');
        }
    }, {
        key: 'orderRemove',
        value: function orderRemove(orderId) {
            return this.callApi(endpoints.ordersRemove + '/' + orderId, {}, 'POST');
        }
    }, {
        key: 'ordersExport',
        value: function ordersExport(projectId, dateStart, dateEnd, filter, orderDateTypeId, orderStatus) {
            return this.callApi(endpoints.ordersExport, {
                projectId: projectId ? projectId : '',
                dateStart: dateStart,
                dateEnd: dateEnd,
                filter: filter ? filter : '',
                orderDateTypeId: orderDateTypeId,
                orderStatus: orderStatus
            }, 'POST', null, 300000);
        }
    }, {
        key: 'orderAddressList',
        value: function orderAddressList(userId) {
            return this.callApi(endpoints.orderAddressList, {
                userId: userId ? userId : ''
            });
        }
    }, {
        key: 'orderConfirmAddress',
        value: function orderConfirmAddress(address) {
            return this.callApi(endpoints.orderConfirmAddress, address, 'POST');
        }
    }, {
        key: 'orderNewAddress',
        value: function orderNewAddress(fio, phoneNumber, fullAddress) {
            return this.callApi(endpoints.orderAddress, {
                fio: fio,
                phoneNumber: phoneNumber,
                fullAddress: fullAddress
            }, 'POST');
        }
    }, {
        key: 'exportUsers',
        value: function exportUsers() {
            return this.callApi('/user/export', {}, 'GET', 'arraybuffer');
        }
    }, {
        key: 'materialsList',
        value: function materialsList(skip, take, projectId, folderId, active) {
            return this.callApi(endpoints.materialsList, {
                skip: skip,
                take: take,
                projectId: projectId,
                folderId: folderId,
                active: active
            });
        }
    }, {
        key: 'materialLoad',
        value: function materialLoad(id) {
            var forTest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            return this.callApi(endpoints.materials, {
                id: id,
                forTest: forTest
            });
        }
    }, {
        key: 'materialLoadTestResults',
        value: function materialLoadTestResults(id) {
            return this.callApi(endpoints.materialsTestResults, {
                id: id
            });
        }
    }, {
        key: 'materialLoadTestRating',
        value: function materialLoadTestRating(id) {
            return this.callApi(endpoints.materialsTestRating, {
                id: id
            });
        }
    }, {
        key: 'materialSave',
        value: function materialSave(data) {
            return this.callApi(endpoints.materials, data, 'POST');
        }
    }, {
        key: 'materialDelete',
        value: function materialDelete(id) {
            return this.callApi(endpoints.materialDelete + ('/' + id), {}, 'POST');
        }
    }, {
        key: 'materialQuestionsSave',
        value: function materialQuestionsSave(data) {
            return this.callApi(endpoints.materialQuestionsSave, data, 'POST');
        }
    }, {
        key: 'materialMakeAnswer',
        value: function materialMakeAnswer(data) {
            return this.callApi(endpoints.materialMakeAnswer, data, 'POST');
        }
    }, {
        key: 'materialStartTest',
        value: function materialStartTest(id) {
            return this.callApi(endpoints.materialStartTest + ('/' + id), {}, 'POST');
        }
    }, {
        key: 'materialUpdateTestSession',
        value: function materialUpdateTestSession(id) {
            return this.callApi(endpoints.materialUpdateTestSession + ('/' + id), {}, 'POST');
        }
    }, {
        key: 'materialFailTestSession',
        value: function materialFailTestSession(id) {
            return this.callApi(endpoints.materialFailTestSession + ('/' + id), {}, 'POST');
        }
    }, {
        key: 'materialQuestionsImport',
        value: function materialQuestionsImport(data) {
            return this.callApi(endpoints.materialQuestionsImport, data, 'POST');
        }
    }, {
        key: 'materialStats',
        value: function materialStats(projectId) {
            return this.callApi(endpoints.materialStats, { projectId: projectId });
        }
    }, {
        key: 'materialResultsExport',
        value: function materialResultsExport(materialId, filter, dateStart, dateEnd) {
            return this.callApi(endpoints.materialResultsExport, {
                materialId: materialId,
                dateStart: dateStart,
                dateEnd: dateEnd,
                filter: filter ? filter : ''
            }, 'POST', null, 300000);
        }
    }, {
        key: 'materialResultsExportDistinctValues',
        value: function materialResultsExportDistinctValues(columnName, materialId, search, filter, skip, take) {
            return this.callApi(endpoints.materialResultsExportDistinctValues, {
                columnName: columnName,
                materialId: materialId,
                search: search,
                filter: filter ? filter : '',
                skip: skip,
                take: take
            }, 'POST', null, 300000);
        }
    }, {
        key: 'materialResultsExportUsers',
        value: function materialResultsExportUsers(materialId) {
            return this.callApi(endpoints.materialResultsExportUsers, { materialId: materialId }, 'GET', null, 300000);
        }
    }, {
        key: 'materialMakeVote',
        value: function materialMakeVote(id) {
            return this.callApi(endpoints.materialMakeVote, {
                Id: id
            }, 'POST');
        }
    }, {
        key: 'materialUsersList',
        value: function materialUsersList(skip, take, id) {
            return this.callApi(endpoints.materialUsersList, {
                skip: skip,
                take: take,
                id: id
            });
        }
    }, {
        key: 'materialUpdateProgress',
        value: function materialUpdateProgress(materialFileId, page, duration) {
            return this.callApi(endpoints.materialUpdateProgress, { materialFileId: materialFileId, page: page, duration: duration || null }, 'POST');
        }
    }, {
        key: 'materialCertificate',
        value: function materialCertificate(skip, take, projectId, folderId, filter) {
            return this.callApi(endpoints.materialCertificate, {
                folderId: folderId,
                tableName: '',
                columnName: '',
                projectId: projectId,
                search: '',
                filter: filter,
                skip: skip,
                take: take //skip, take, projectId, folderId, filter
            }, 'GET');
        }
    }, {
        key: 'materialExportUsers',
        value: function materialExportUsers(id) {
            return this.callApi(endpoints.materialExportUsers, { id: id }, 'GET', null, 300000);
        }
    }, {
        key: 'materialCertificateData',
        value: function materialCertificateData(Id, FileData, FileName, Delete) {
            return this.callApi(endpoints.materialCertificateData, { Id: Id, FileData: FileData, FileName: FileName, Delete: Delete }, 'POST');
        }
    }, {
        key: 'materialCertificateDownload',
        value: function materialCertificateDownload(sessionId, fixDownload) {
            return this.callApi(endpoints.materialCertificateDownload, { sessionId: sessionId, fixDownload: fixDownload });
        }
    }, {
        key: 'materialCertificateExport',
        value: function materialCertificateExport(projectId, folderId, filter) {
            return this.callApi(endpoints.materialCertificateExport, { projectId: projectId, folderId: folderId, filter: filter }, 'GET', null, 300000);
        }
    }, {
        key: 'materialCertificateDistinctValues',
        value: function materialCertificateDistinctValues(skip, take, columnName, projectId, search, filter, folderId) {
            return this.callApi(endpoints.materialCertificateDistinctValues, { skip: skip, take: take, columnName: columnName, projectId: projectId, search: search, filter: filter, folderId: folderId }, 'POST');
        }
    }, {
        key: 'folderList',
        value: function folderList(projectId) {
            return this.callApi(endpoints.folderList, {
                projectId: projectId || ''
            });
        }
    }, {
        key: 'folderLoad',
        value: function folderLoad(id) {
            return this.callApi(endpoints.folder, {
                id: id
            });
        }
    }, {
        key: 'folderSave',
        value: function folderSave(data) {
            return this.callApi(endpoints.folder, data, 'POST');
        }
    }, {
        key: 'folderDelete',
        value: function folderDelete(id) {
            return this.callApi(endpoints.folderDelete + ('/' + id), {}, 'POST');
        }
    }, {
        key: 'folderArchive',
        value: function folderArchive(obj) {
            return this.callApi(endpoints.folderArchive, obj, 'POST');
        }
    }, {
        key: 'folderRestore',
        value: function folderRestore(obj) {
            return this.callApi(endpoints.folderRestore, obj, 'POST');
        }
    }, {
        key: 'domainFolderLoad',
        value: function domainFolderLoad(id) {
            return this.callApi(endpoints.domainFolder, {
                id: id
            });
        }
    }, {
        key: 'domainFolderSave',
        value: function domainFolderSave(obj) {
            return this.callApi(endpoints.domainFolder, obj, 'POST');
        }
    }, {
        key: 'domainFolderDelete',
        value: function domainFolderDelete(id) {
            return this.callApi(endpoints.domainFolderDelete + ('/' + id), {}, 'POST');
        }
    }, {
        key: 'domainFolderArchive',
        value: function domainFolderArchive(obj) {
            return this.callApi(endpoints.domainFolderArchive, obj, 'POST');
        }
    }, {
        key: 'domainFolderRestore',
        value: function domainFolderRestore(obj) {
            return this.callApi(endpoints.domainFolderRestore, obj, 'POST');
        }
    }, {
        key: 'analyticsGetData',
        value: function analyticsGetData(projectId, dateStart, dateEnd, unit, filter, measureType, skuId) {
            var asTable = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;

            return this.callApi(endpoints.analytics, {
                projectId: projectId ? projectId : '',
                dateStart: dateStart,
                dateEnd: dateEnd,
                unit: unit,
                filter: filter ? filter : '',
                measureType: measureType,
                skuId: skuId,
                asTable: asTable
            }, 'GET');
        }
    }, {
        key: 'analyticsGetDetails',
        value: function analyticsGetDetails(projectId, dateStart, dateEnd, unit, filter, measureType, skuId, asTable, customField) {
            return this.callApi(endpoints.analyticsDetails, {
                projectId: projectId ? projectId : '',
                dateStart: dateStart,
                dateEnd: dateEnd,
                unit: unit,
                filter: filter ? filter : '',
                measureType: measureType,
                skuId: skuId,
                customField: customField,
                asTable: asTable
            }, 'GET');
        }
    }, {
        key: 'analyticsExport',
        value: function analyticsExport(projectId, dateStart, dateEnd, unit, filter, measureType, skuId) {
            return this.callApi(endpoints.analyticsExport, {
                projectId: projectId ? projectId : '',
                dateStart: dateStart,
                dateEnd: dateEnd,
                unit: unit,
                filter: filter ? filter : '',
                measureType: measureType,
                skuId: skuId
            }, 'POST', null, 180000);
        }
    }, {
        key: 'analyticsExportByReports',
        value: function analyticsExportByReports(projectId, dateStart, dateEnd, unit, filter, measureType, skuId) {
            return this.callApi(endpoints.analyticsExportByReports, {
                projectId: projectId ? projectId : '',
                dateStart: dateStart,
                dateEnd: dateEnd,
                unit: unit,
                filter: filter ? filter : '',
                measureType: measureType,
                skuId: skuId
            }, 'POST', null, 180000);
        }
    }, {
        key: 'analyticsDistinctValues',
        value: function analyticsDistinctValues(projectId, columnName) {
            return this.callApi(endpoints.analyticsDistinctValues, {
                projectId: projectId ? projectId : '',
                columnName: columnName
            });
        }
    }, {
        key: 'ratingGetTop',
        value: function ratingGetTop(skip, take, projectId, filter, sortColumn, sortDirection, ratingRole) {
            return this.callApi(endpoints.rating, {
                skip: skip,
                take: take,
                projectId: projectId ? projectId : '',
                filter: filter || '',
                sortColumn: sortColumn,
                sortDirection: sortDirection,
                ratingRole: ratingRole
            }, 'GET');
        }
    }, {
        key: 'ratingDistinctValues',
        value: function ratingDistinctValues(columnName, projectId, search, filter, skip, take) {
            return this.callApi(endpoints.ratingDistinctValues, {
                columnName: columnName,
                projectId: projectId,
                search: search,
                filter: filter ? filter : '',
                skip: skip,
                take: take
            }, 'POST');
        }
    }, {
        key: 'ratingExport',
        value: function ratingExport(projectId, filter, sortColumn, sortDirection, ratingRole) {
            return this.callApi(endpoints.ratingExport, {
                projectId: projectId,
                filter: filter ? filter : '',
                sortColumn: sortColumn,
                sortDirection: sortDirection,
                ratingRole: ratingRole
            }, 'POST', null, 300000);
        }
    }, {
        key: 'ratingSettings',
        value: function ratingSettings() {
            return this.callApi(endpoints.ratingSettings, {}, 'GET');
        }
    }, {
        key: 'bonusHistoryList',
        value: function bonusHistoryList(skip, take, dateStart, dateEnd, bonusOperationTypeId, search, unit, monthAndYear, projectId) {
            return this.callApi(endpoints.bonusHistoryList, {
                skip: skip,
                take: take,
                dateStart: dateStart,
                dateEnd: dateEnd,
                bonusOperationTypeId: bonusOperationTypeId,
                search: search,
                unit: unit,
                monthAndYear: monthAndYear,
                projectId: projectId
            });
        }
    }, {
        key: 'bonusHistoryDistinctValues',
        value: function bonusHistoryDistinctValues(columnName, dateStart, dateEnd, bonusOperationTypeId, search, monthAndYear, skip, take, projectId) {
            return this.callApi(endpoints.bonusHistoryDistinctValues, {
                columnName: columnName,
                dateStart: dateStart,
                dateEnd: dateEnd,
                bonusOperationTypeId: bonusOperationTypeId,
                search: search,
                monthAndYear: monthAndYear,
                skip: skip,
                take: take,
                projectId: projectId
            });
        }
    }, {
        key: 'bonusHistoryExport',
        value: function bonusHistoryExport(dateStart, dateEnd, bonusOperationTypeId, search, unit, monthAndYear, projectId) {
            return this.callApi(endpoints.bonusHistoryExport, { dateStart: dateStart, dateEnd: dateEnd, bonusOperationTypeId: bonusOperationTypeId, search: search, unit: unit, monthAndYear: monthAndYear, projectId: projectId }, 'GET', null, 300000);
        }
    }, {
        key: 'checkDownloaded',
        value: function checkDownloaded(guid) {
            return this.callApi(endpoints.checkDownloaded, { guid: guid });
        }
    }, {
        key: 'bulkSendingTemplateSave',
        value: function bulkSendingTemplateSave(data) {
            return this.callApi(endpoints.bulkSendingTemplateSave, data, 'POST');
        }
    }, {
        key: 'bulkSendingTemplates',
        value: function bulkSendingTemplates(projectId) {
            return this.callApi(endpoints.bulkSendingTemplates, {
                projectId: projectId || ''
            });
        }
    }, {
        key: 'bulkSendingTemplateDelete',
        value: function bulkSendingTemplateDelete(id) {
            return this.callApi(endpoints.bulkSendingTemplateDelete + ('/' + id), {}, 'POST');
        }
    }, {
        key: 'bulkSendingTest',
        value: function bulkSendingTest(text, subject, bulkSendingType, smtpServerId, projectId) {
            return this.callApi(endpoints.bulkSendingTest, { text: text, subject: subject, bulkSendingType: bulkSendingType, smtpServerId: smtpServerId, projectId: projectId }, 'POST');
        }

        //bulkSending(templateId, notIncluded, filter, projectId, templateName, body, bulkSendingTypeId, smtpServerId, roleId, dateSortEmpty, dateSortType, dateStart, dateEnd,allCurrentUsersSelected) {
        //    return this.callApi(endpoints.bulkSending, {
        //        templateId,
        //        notIncluded,
        //        filter,
        //        projectId,
        //        templateName,
        //        body,
        //        bulkSendingTypeId,
        //        smtpServerId,
        //        roleId,
        //        dateSortEmpty,
        //        dateSortType,
        //        dateStart,
        //        dateEnd,
        //        allCurrentUsersSelected
        //    }, 'POST');
        //}

    }, {
        key: 'bulkSending',
        value: function bulkSending(id) {
            return this.callApi(endpoints.bulkSending, { id: id }, 'GET');
        }
    }, {
        key: 'bulkSendingDelete',
        value: function bulkSendingDelete(id) {
            return this.callApi(endpoints.bulkSendingDelete + ('/' + id), {}, 'POST');
        }
    }, {
        key: 'bulkSendingSave',
        value: function bulkSendingSave(model) {
            return this.callApi(endpoints.bulkSendingSave, model, 'POST');
        }
    }, {
        key: 'bulkSendingList',
        value: function bulkSendingList(skip, take, bulkSendingType, projectId, startDate, endDate) {
            return this.callApi(endpoints.bulkSendingList, {
                skip: skip,
                take: take,
                bulkSendingType: bulkSendingType || '',
                projectId: projectId || '',
                startDate: startDate,
                endDate: endDate
            }, 'GET');
        }
    }, {
        key: 'bulkSendingLogs',
        value: function bulkSendingLogs(skip, take, projectId) {
            return this.callApi(endpoints.bulkSendingLogsList, {
                skip: skip,
                take: take,
                projectId: projectId || ''
            }, 'GET');
        }
    }, {
        key: 'bulkSendingReceiversList',
        value: function bulkSendingReceiversList(skip, take, bulkSendingId) {
            return this.callApi(endpoints.bulkSendingReceiversList, {
                skip: skip,
                take: take,
                bulkSendingId: bulkSendingId
            }, 'GET');
        }
    }, {
        key: 'bulkSendingStats',
        value: function bulkSendingStats(projectId, startDate, endDate) {
            return this.callApi(endpoints.bulkSendingStats, {
                projectId: projectId || '',
                startDate: startDate,
                endDate: endDate
            }, 'GET');
        }
    }, {
        key: 'bulkSendingExportDetails',
        value: function bulkSendingExportDetails(bulkSendingId, bulkSendingType, projectId, startDate, endDate) {
            return this.callApi(endpoints.bulkSendingExportDetails, { bulkSendingId: bulkSendingId, bulkSendingType: bulkSendingType, projectId: projectId, startDate: startDate, endDate: endDate }, 'GET', null, 300000);
        }
    }, {
        key: 'smtpSettings',
        value: function smtpSettings() {
            return this.callApi(endpoints.smtpSettingsList, {}, 'GET');
        }
    }, {
        key: 'smsLimits',
        value: function smsLimits() {
            return this.callApi(endpoints.smsLimits, {});
        }
    }, {
        key: 'changeUser',
        value: function changeUser(userId) {
            return this.callApi(endpoints.changeUser, {
                userId: userId
            }, 'GET');
        }
    }, {
        key: 'returnToUser',
        value: function returnToUser(checkData) {
            return this.callApi(endpoints.returnUser, {
                checkData: checkData
            }, 'GET');
        }
    }, {
        key: 'checkUser',
        value: function checkUser(userId) {
            return this.callApi(endpoints.checkUser, {
                userId: userId
            }, 'GET');
        }
    }, {
        key: 'gifteryProducts',
        value: function gifteryProducts() {
            return this.callApi(endpoints.giftery);
        }
    }, {
        key: 'requestConfirmationCode',
        value: function requestConfirmationCode(newemail) {
            return this.callApi(endpoints.confirmationCode, { newemail: newemail });
        }
    }, {
        key: 'checkConfirmationCode',
        value: function checkConfirmationCode(code) {
            return this.callApi(endpoints.checkConfirmationCode, { code: code });
        }
    }, {
        key: 'makeGifteryOrder',
        value: function makeGifteryOrder(orderId) {
            return this.callApi(endpoints.makeGifteryOrder, { orderId: orderId }, 'GET');
        }
    }, {
        key: 'getGifteryBalance',
        value: function getGifteryBalance(projectId) {
            return this.callApi(endpoints.gifteryBalance, { projectId: projectId });
        }
    }, {
        key: 'makeOzonOrder',
        value: function makeOzonOrder(orderId) {
            return this.callApi(endpoints.makeOzonOrder, { orderId: orderId }, 'GET');
        }
    }, {
        key: 'getOrderStatuses',
        value: function getOrderStatuses(orderIds) {
            return this.callApi(endpoints.orderStatuses, { orderIds: orderIds && orderIds.length ? orderIds : [0] });
        }
    }, {
        key: 'saveSecondsProgress',
        value: function saveSecondsProgress(seconds) {
            return this.callApi(endpoints.saveSecondsProgress, { seconds: seconds });
        }
    }, {
        key: 'orderHistory',
        value: function orderHistory(id) {
            return this.callApi(endpoints.orderHistory, { id: id });
        }
    }, {
        key: 'getBankNameByBik',
        value: function getBankNameByBik(bik) {
            return this.callApi(endpoints.getBankNameByBik, { bik: bik });
        }
    }, {
        key: 'fileExported',
        value: function fileExported(exportFile) {
            return this.callApi(endpoints.getFileExport, { exportFile: exportFile }, 'GET', null, 300000);
        }
    }, {
        key: 'commonBulkSending',
        value: function commonBulkSending(model) {
            return this.callApi(endpoints.commonBulkSending, model, 'POST');
        }
    }, {
        key: 'commonOzonAccounts',
        value: function commonOzonAccounts() {
            return this.callApi(endpoints.commonOzonAccounts);
        }
    }, {
        key: 'commonCountries',
        value: function commonCountries() {
            return this.callApi(endpoints.commonCountries);
        }
    }, {
        key: 'commonNotificationList',
        value: function commonNotificationList(skip, take) {
            return this.callApi(endpoints.commonNotificationList, { skip: skip, take: take });
        }
    }, {
        key: 'commonImageRotation',
        value: function commonImageRotation(filePath, direction) {
            return this.callApi(endpoints.commonImageRotation, {
                filePath: filePath,
                direction: direction
            });
        }
    }, {
        key: 'tasksList',
        value: function tasksList(skip, take, projectId, completed) {
            return this.callApi(endpoints.tasksList, { skip: skip, take: take, projectId: projectId, completed: completed });
        }
    }, {
        key: 'tasksLoad',
        value: function tasksLoad(id) {
            var forDetail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            return this.callApi(endpoints.tasksGet, { id: id, forDetail: forDetail });
        }
    }, {
        key: 'tasksSave',
        value: function tasksSave(task) {
            return this.callApi(endpoints.tasks, task, 'POST');
        }
    }, {
        key: 'tasksAnswerSave',
        value: function tasksAnswerSave(tasks) {
            return this.callApi(endpoints.tasksAnswer, tasks, 'POST');
        }
    }, {
        key: 'tasksAnswerLoad',
        value: function tasksAnswerLoad(tasksId, answerId) {
            var tradePointId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            return this.callApi(endpoints.tasksAnswerGet, { tasksId: tasksId, answerId: answerId, tradePointId: tradePointId }, 'GET');
        }
    }, {
        key: 'tasksAnswers',
        value: function tasksAnswers(skip, take, projectId, taskId, stateId, dateTypeId, dateStart, dateEnd, filter) {
            var author = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;

            return this.callApi(endpoints.tasksAnswers, {
                skip: skip,
                take: take,
                projectId: projectId,
                taskId: taskId,
                stateId: stateId,
                dateTypeId: dateTypeId,
                dateStart: dateStart,
                dateEnd: dateEnd,
                filter: filter ? filter : '',
                author: author
            }, 'GET');
        }
    }, {
        key: 'tasksDistinctValues',
        value: function tasksDistinctValues(columnName, projectId, parentId, search, filter, skip, take) {
            return this.callApi(endpoints.tasksDistinctValues, {
                columnName: columnName,
                projectId: projectId,
                search: search,
                filter: filter ? filter : '',
                skip: skip,
                take: take,
                parentId: parentId
            }, 'POST');
        }
    }, {
        key: 'tasksMemberFilter',
        value: function tasksMemberFilter(field, projectId, skip, take, filterVariant, taskId) {
            return this.callApi(endpoints.tasksMemberFilter, { field: field, projectId: projectId, skip: skip, take: take, filterVariant: filterVariant, taskId: taskId }, 'GET');
        }
    }, {
        key: 'tasksAnswerAccept',
        value: function tasksAnswerAccept(taskId, answerId, status, comment) {
            return this.callApi(endpoints.tasksAnswerAccept, { taskId: taskId, answerId: answerId, status: status, comment: comment }, 'POST');
        }
    }, {
        key: 'tasksDelete',
        value: function tasksDelete(id) {
            return this.callApi(endpoints.tasksDelete + ('/' + id), {}, 'POST');
        }
    }, {
        key: 'tasksExport',
        value: function tasksExport(projectId, stateId, dateTypeId, dateStart, dateEnd, filter) {
            return this.callApi(endpoints.tasksExport, {
                projectId: projectId,
                stateId: stateId,
                dateTypeId: dateTypeId,
                dateStart: dateStart,
                dateEnd: dateEnd,
                filter: filter ? filter : ''
            }, 'GET', null, 300000);
        }
    }, {
        key: 'tasksGeneralExport',
        value: function tasksGeneralExport(projectId, stateId, dateTypeId, dateStart, dateEnd, filter) {
            return this.callApi(endpoints.tasksGeneralExport, {
                projectId: projectId,
                stateId: stateId,
                dateTypeId: dateTypeId,
                dateStart: dateStart,
                dateEnd: dateEnd,
                filter: filter ? filter : ''
            }, 'GET', null, 300000);
        }
    }, {
        key: 'tasksExportReport',
        value: function tasksExportReport() {
            return this.callApi(endpoints.tasksExportReport, {}, 'GET', null, 300000);
        }
    }, {
        key: 'tasksExportAnalyticsJeelex',
        value: function tasksExportAnalyticsJeelex(projectId, stateId, dateTypeId, dateStart, dateEnd, filter) {
            return this.callApi(endpoints.tasksExportAnalyticsJeelex, {
                projectId: projectId,
                stateId: stateId,
                dateTypeId: dateTypeId,
                dateStart: dateStart,
                dateEnd: dateEnd,
                filter: filter ? filter : ''
            }, 'GET', null, 300000);
        }
    }, {
        key: 'tasksExportAnalyticsCersanit',
        value: function tasksExportAnalyticsCersanit() {
            return this.callApi(endpoints.tasksExportAnalyticsCersanit, {}, 'GET', null, 300000);
        }
    }, {
        key: 'tasksAnswersDetail',
        value: function tasksAnswersDetail(taskId, answerId) {
            return this.callApi(endpoints.tasksAnswersDetail, { taskId: taskId, answerId: answerId }, 'GET');
        }
    }, {
        key: 'tasksDetailExport',
        value: function tasksDetailExport(taskId, stateId, dateTypeId, dateStart, dateEnd, filter) {
            return this.callApi(endpoints.tasksDetailExport, { taskId: taskId, stateId: stateId, dateTypeId: dateTypeId, dateStart: dateStart, dateEnd: dateEnd, filter: filter ? filter : '' }, 'GET', null, 300000);
        }
    }, {
        key: 'tasksBonus',
        value: function tasksBonus(taskid) {
            return this.callApi(endpoints.tasksBonus, { taskid: taskid }, 'GET');
        }
    }, {
        key: 'tasksResponsible',
        value: function tasksResponsible(taskId, mode, tradePointId) {
            return this.callApi(endpoints.tasksResponsible, { taskId: taskId, mode: mode, tradePointId: tradePointId }, 'POST');
        }
    }, {
        key: 'tasksResponsibleRefuse',
        value: function tasksResponsibleRefuse(taskId, tradePointId) {
            return this.callApi(endpoints.tasksResponsibleRefuse, { taskId: taskId, tradePointId: tradePointId }, 'POST');
        }
    }, {
        key: 'taskCheckResponsible',
        value: function taskCheckResponsible(taskId, tradePointId) {
            return this.callApi(endpoints.taskCheckResponsible, { taskId: taskId, tradePointId: tradePointId }, 'GET');
        }
    }, {
        key: 'tasksExportSku',
        value: function tasksExportSku(skuList) {
            return this.callApi(endpoints.tasksExportSku, { skuList: skuList }, 'POST', null, 300000);
        }
    }, {
        key: 'tasksImportSku',
        value: function tasksImportSku(data) {
            return this.callApi(endpoints.tasksImportSku, data, 'POST');
        }
    }, {
        key: 'tasksCopy',
        value: function tasksCopy(taskCopy) {
            return this.callApi(endpoints.tasksCopy, taskCopy, 'POST');
        }
    }, {
        key: 'tasksUsersOnRoles',
        value: function tasksUsersOnRoles(skip, take, taskId, searchText, roleValues, gradeValues) {
            return this.callApi(endpoints.tasksUsersOnRoles, {
                skip: skip,
                take: take,
                taskId: taskId,
                searchText: searchText ? searchText : '',
                roleValues: roleValues,
                gradeValues: gradeValues
            });
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);
;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.6.0
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2021-03-02T17:08Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.6.0",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.6
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2021-02-16
 */
( function( window ) {
var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ( {} ).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	pushNative = arr.push,
	push = arr.push,
	slice = arr.slice,

	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[ i ] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
		"ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5]
		// or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
		whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
		"*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
			whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
			whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		return nonHex ?

			// Strip the backslash prefix from a non-hex escape sequence
			nonHex :

			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" +
				ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android<4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;

			// Can't trust NodeList.length
			while ( ( target[ j++ ] = els[ i++ ] ) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

				// Support: IE 8 only
				// Exclude object elements
				( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					if ( newContext !== context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split( "|" ),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[ i ] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( ( cur = cur.nextSibling ) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return ( name === "input" || name === "button" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
					inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem && elem.namespaceURI,
		docElem = elem && ( elem.ownerDocument || elem ).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
	// Safari 4 - 5 only, Opera <=11.6 - 12.x only
	// IE/Edge & older browsers don't support the :scope pseudo-class.
	// Support: Safari 6.0 only
	// Safari 6.0 supports :scope but it's an alias of :root there.
	support.scope = assert( function( el ) {
		docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
		return typeof el.querySelectorAll !== "undefined" &&
			!el.querySelectorAll( ":scope fieldset div" ).length;
	} );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert( function( el ) {
		el.className = "i";
		return !el.getAttribute( "className" );
	} );

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert( function( el ) {
		el.appendChild( document.createComment( "" ) );
		return !el.getElementsByTagName( "*" ).length;
	} );

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter[ "ID" ] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter[ "ID" ] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find[ "TAG" ] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,

				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( ( elem = results[ i++ ] ) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {

			var input;

			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}

			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}

			// Support: Firefox <=3.6 - 5 only
			// Old Firefox doesn't throw on a badly-escaped identifier.
			el.querySelectorAll( "\\\f" );
			rbuggyQSA.push( "[\\r\\n\\f]" );
		} );

		assert( function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll( "[name=d]" ).length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: Opera 10 - 11 only
			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll( "*,:x" );
			rbuggyQSA.push( ",.*:" );
		} );
	}

	if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector ) ) ) ) {

		assert( function( el ) {

			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		} );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			) );
		} :
		function( a, b ) {
			if ( b ) {
				while ( ( b = b.parentNode ) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a == document || a.ownerDocument == preferredDoc &&
				contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b == document || b.ownerDocument == preferredDoc &&
				contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {

		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			return a == document ? -1 :
				b == document ? 1 :
				/* eslint-enable eqeqeq */
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( ( cur = cur.parentNode ) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( ( cur = cur.parentNode ) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[ i ] === bp[ i ] ) {
			i++;
		}

		return i ?

			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[ i ], bp[ i ] ) :

			// Otherwise nodes in our document sort first
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			ap[ i ] == preferredDoc ? -1 :
			bp[ i ] == preferredDoc ? 1 :
			/* eslint-enable eqeqeq */
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

				// As well, disconnected nodes are said to be in a document
				// fragment in IE 9
				elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			( val = elem.getAttributeNode( name ) ) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {

		// If no nodeType, this is expected to be an array
		while ( ( node = elem[ i++ ] ) ) {

			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {

			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}

	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
				match[ 5 ] || "" ).replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

				// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				Sizzle.error( match[ 0 ] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace +
					")" + className + "(" + whitespace + "|$)" ) ) && classCache(
						className, function( elem ) {
							return pattern.test(
								typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
							);
				} );
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				/* eslint-disable max-len */

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
				/* eslint-enable max-len */

			};
		},

		"CHILD": function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || ( node[ expando ] = {} );

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								( outerCache[ node.uniqueID ] = {} );

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {

								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || ( node[ expando ] = {} );

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												( outerCache[ node.uniqueID ] = {} );

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		"not": markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element (issue #299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		"has": markFunction( function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		} ),

		"contains": markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement &&
				( !document.hasFocus || document.hasFocus() ) &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return ( nodeName === "input" && !!elem.checked ) ||
				( nodeName === "option" && !!elem.selected );
		},

		"selected": function( elem ) {

			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {

			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos[ "empty" ]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		"last": createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		"even": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"odd": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rcombinators.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrim, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :

			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] ||
							( outerCache[ elem.uniqueID ] = {} );

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = uniqueCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts(
				selector || "*",
				context.nodeType ? [ context ] : context,
				[]
			),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?

				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

					// If the preceding token was a descendant combinator, insert an implicit any-element `*`
					tokens
						.slice( 0, i - 1 )
						.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache(
			selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers )
		);

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
			context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
				.replace( runescape, funescape ), context ) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
						context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert( function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute( "href" ) === "#";
} ) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	} );
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert( function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
} ) ) {
	addHandle( "value", function( elem, _name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	} );
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert( function( el ) {
	return el.getAttribute( "disabled" ) == null;
} ) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
		}
	} );
}

return Sizzle;

} )( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						// Support: Chrome 86+
						// In Chrome, if an element having a focusout handler is blurred by
						// clicking outside of it, it invokes the handler synchronously. If
						// that handler calls `.remove()` on the element, the data is cleared,
						// leaving `result` undefined. We need to guard against this.
						return result && result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		// Suppress native focus or blur as it's already being fired
		// in leverageNative.
		_default: function() {
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is display: block
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {

				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 8 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_moment_moment__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_moment_calendar__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_locale_locale__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_duration_duration__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_units_units__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_is_date__ = __webpack_require__(117);
//! moment.js
//! version : 2.29.3
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com



__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].version = '2.29.3';













Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["b" /* setHookCallback */])(__WEBPACK_IMPORTED_MODULE_1__lib_moment_moment__["c" /* createLocal */]);

__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].fn = __WEBPACK_IMPORTED_MODULE_1__lib_moment_moment__["i" /* momentPrototype */];
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].min = __WEBPACK_IMPORTED_MODULE_1__lib_moment_moment__["h" /* min */];
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].max = __WEBPACK_IMPORTED_MODULE_1__lib_moment_moment__["g" /* max */];
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].now = __WEBPACK_IMPORTED_MODULE_1__lib_moment_moment__["j" /* now */];
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].utc = __WEBPACK_IMPORTED_MODULE_1__lib_moment_moment__["d" /* createUTC */];
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].unix = __WEBPACK_IMPORTED_MODULE_1__lib_moment_moment__["e" /* createUnix */];
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].months = __WEBPACK_IMPORTED_MODULE_3__lib_locale_locale__["e" /* listMonths */];
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].isDate = __WEBPACK_IMPORTED_MODULE_6__lib_utils_is_date__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].locale = __WEBPACK_IMPORTED_MODULE_3__lib_locale_locale__["c" /* getSetGlobalLocale */];
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].invalid = __WEBPACK_IMPORTED_MODULE_1__lib_moment_moment__["b" /* createInvalid */];
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].duration = __WEBPACK_IMPORTED_MODULE_4__lib_duration_duration__["a" /* createDuration */];
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].isMoment = __WEBPACK_IMPORTED_MODULE_1__lib_moment_moment__["f" /* isMoment */];
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].weekdays = __WEBPACK_IMPORTED_MODULE_3__lib_locale_locale__["g" /* listWeekdays */];
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].parseZone = __WEBPACK_IMPORTED_MODULE_1__lib_moment_moment__["a" /* createInZone */];
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].localeData = __WEBPACK_IMPORTED_MODULE_3__lib_locale_locale__["b" /* getLocale */];
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].isDuration = __WEBPACK_IMPORTED_MODULE_4__lib_duration_duration__["d" /* isDuration */];
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].monthsShort = __WEBPACK_IMPORTED_MODULE_3__lib_locale_locale__["f" /* listMonthsShort */];
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].weekdaysMin = __WEBPACK_IMPORTED_MODULE_3__lib_locale_locale__["h" /* listWeekdaysMin */];
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].defineLocale = __WEBPACK_IMPORTED_MODULE_3__lib_locale_locale__["a" /* defineLocale */];
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].updateLocale = __WEBPACK_IMPORTED_MODULE_3__lib_locale_locale__["j" /* updateLocale */];
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].locales = __WEBPACK_IMPORTED_MODULE_3__lib_locale_locale__["d" /* listLocales */];
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].weekdaysShort = __WEBPACK_IMPORTED_MODULE_3__lib_locale_locale__["i" /* listWeekdaysShort */];
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].normalizeUnits = __WEBPACK_IMPORTED_MODULE_5__lib_units_units__["a" /* normalizeUnits */];
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].relativeTimeRounding = __WEBPACK_IMPORTED_MODULE_4__lib_duration_duration__["b" /* getSetRelativeTimeRounding */];
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].relativeTimeThreshold = __WEBPACK_IMPORTED_MODULE_4__lib_duration_duration__["c" /* getSetRelativeTimeThreshold */];
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].calendarFormat = __WEBPACK_IMPORTED_MODULE_2__lib_moment_calendar__["b" /* getCalendarFormat */];
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].prototype = __WEBPACK_IMPORTED_MODULE_1__lib_moment_moment__["i" /* momentPrototype */];

// currently HTML5 input type only supports 24-hour formats
__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */].HTML5_FMT = {
    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
    DATE: 'YYYY-MM-DD', // <input type="date" />
    TIME: 'HH:mm', // <input type="time" />
    TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
    TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
    WEEK: 'GGGG-[W]WW', // <input type="week" />
    MONTH: 'YYYY-MM', // <input type="month" />
};

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__lib_utils_hooks__["a" /* hooks */]);


/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backendApi__ = __webpack_require__(5);

var backendApi = new __WEBPACK_IMPORTED_MODULE_0__backendApi__["a" /* default */]();

var projectMixin = {
    data: function data() {
        return {
            projectId: null
        };
    },


    methods: {},

    mounted: function mounted() {
        var vm = this;

        var selectedProjectId = localStorage.getItem('selectedProjectId');
        if (selectedProjectId != null) {
            vm.projectId = parseInt(selectedProjectId);
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (projectMixin);

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49), __webpack_require__(210)(module)))

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var devConfig = {
    mode: 'dev',
    apiUrl: 'http://localhost:52610',
    yandexCloudBucketName: 'foxinbox',
    vkAppId: 6925192,
    vkAppScopes: 'offline,email',
    vkVersion: 5.85,
    googleAppId: '434146614201-9fnsn4ucuekeciiitbornn046d8jjuld.apps.googleusercontent.com',
    googleAppScopes: 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile',
    facebookAppId: 447424085992802,
    facebookAppScopes: 'public_profile,email'
};

var prodConfig = {
    mode: 'prod',
    apiUrl: '',
    yandexCloudBucketName: 'foxinbox',
    vkAppId: 6925192,
    vkAppScopes: 'offline,email',
    vkVersion: 5.85,
    googleAppId: '434146614201-9fnsn4ucuekeciiitbornn046d8jjuld.apps.googleusercontent.com',
    googleAppScopes: 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile',
    facebookAppId: 447424085992802,
    facebookAppScopes: 'public_profile,email'
};

var config =  true ? prodConfig : devConfig;

module.exports = config;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(91)('wks');
var uid = __webpack_require__(69);
var Symbol = __webpack_require__(8).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(47);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon-del.png?b07a2b35f43564181a98bf69cc08a70d";

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(10)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ReportTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ReportPhotoTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return OrderStatuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return RewardTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ClaimEnums; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BonusStrategyAccrualTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RegisterTradePointTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return VerificationStates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return TaskTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FieldTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PurposeType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ScoringAccrualTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ScoringBurningTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MemberFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ScoringActivation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CurrencyDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return TaskAnswerStates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ScoringAccrualType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return UserLevelCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ProjectIds; });
var _CurrencyDetails;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var VerificationStates = {
    /// <summary>
    /// Документы отсутствуют
    /// </summary>
    Empty: 0,
    /// <summary>
    /// Нужна проверка
    /// </summary>
    NeedToCheck: 1,
    /// <summary>
    /// Проверены
    /// </summary>
    Verified: 2,
    Cancelled: 3
};
var ReportTypes = {
    Disabled: 0,
    Manual: 1,
    QrCode: 2
};

var ReportPhotoTypes = {
    General: 0,
    Check: 1,
    QrCode: 2,
    File: 3
};

var OrderStatuses = {
    New: 1,
    InPocess: 2,
    Cancelled: 3,
    Complete: 4,
    Received: 5,
    ReadyToComplete: 6,
    GifteryRequested: 7,
    GifteryDelayed: 8,
    OrdersMonitoringTry: 101
};

var RewardTypes = {
    ElectronicGiftCard: 1,
    PrepaidBankCard: 2,
    PhysicalBankCard: 3,
    PhysicalPrize: 4
};

var BonusStrategyAccrualTypes = {
    //Процент от суммы
    SumPercent: 1,

    //Умножить на сумму
    SumMultiplication: 2
};

var RegisterTradePointTypes = {
    //Ввод текста
    Text: 0,

    //Выбор из адрески
    Select: 1
};

var ClaimEnums = {
    'newsCreate': 1,
    'materialCreate': 3,
    'reportAdd': 5,
    'reportCheck': 6,
    'bonusSpend': 7,
    'skuCreate': 8,
    'ttAccess': 9,
    'ratingExport': 10,
    'faqEdit': 11,
    'motivationEdit': 12,
    'rewardsEdit': 13,
    'ratingSwitcher': 14,
    'skuLinkExport': 15,
    'tasksController': 16,
    'tasksEdit': 17,
    'newRepliesNotification': 18,

    'mainPageSettings': 20,
    'projectPage': 21,
    'newsPage': 22,
    'materialsPage': 23,
    'reportsPage': 24,
    'ratingPage': 25,
    'spendBonusesPage': 26,
    'analyticsPage': 27,
    'sellersPage': 28,
    'skuPage': 29,
    'motivationPage': 30,
    'faqPage': 31,
    'ordersPage': 32,
    'senderPage': 33,
    'tasksPage': 34,
    'feedbackPage': 35,
    'myProgressPage': 36
};

var TaskTypes = {
    Cumulative: 1,
    Simple: 2
};

var FieldTypes = {
    Single: 1,
    Table: 2
};

var PurposeType = {
    Count: 1,
    Summ: 2
};

var ScoringAccrualTypes = {
    Fixed: 1,
    SumPercent: 2,
    DependingOnSku: 3
};

var ScoringBurningTime = {
    Eternal: 1,
    InDays: 2,
    OnDate: 3
};

var MemberFilters = {
    Users: 1,
    TradePoints: 2,
    Roles: 3
};

var ScoringActivation = {
    OnDay: 1,
    InDays: 2,
    MonthInDay: 3,
    CumulativeForPeriod: 4
};

var Countries = {
    RUSSIA: 1,
    BELARUS: 2,
    KAZAKHSTAN: 3
};

var CurrencyDetails = (_CurrencyDetails = {}, _defineProperty(_CurrencyDetails, Countries.RUSSIA, { symbol: '₽', name: 'рублей', commissionText: 'Сумма в рублях с учетом комиссии:' }), _defineProperty(_CurrencyDetails, Countries.BELARUS, { symbol: 'Br', name: 'белорусских рублей', commissionText: 'Сумма в белорусских рублях с учетом комиссии:' }), _defineProperty(_CurrencyDetails, Countries.KAZAKHSTAN, { symbol: '₸', name: 'тенге', commissionText: 'Сумма в тенге с учетом комиссии:' }), _CurrencyDetails);

var TaskAnswerStates = {
    /// Ждет проверки
    WaitingVerification: 1,
    /// принято
    Accepted: 2,
    /// доработано
    Finalized: 3,
    /// на доработке
    OnEdition: 4,
    /// отклонено
    Rejected: 5,
    /// удалить
    Remove: 10
};

var ScoringAccrualType = {
    FACT: 1,
    PERCENT: 2,
    PER_SKU: 3
};

var UserLevelCode = {
    Bronze: 1,
    Silver: 2,
    Gold: 3,
    Platina: 4,
    GradeB: 5,
    GradeA: 6,
    GradeS: 7
};

var ProjectIds = {
    dev: {
        Froneri: 1,
        Project2: 2,
        KrasniyOktyabr: 4,
        Rusklimat: 5,
        ASBIS: 6,
        ASBIS_TSMir: 7,
        ASBIS_Mvideo: 2, // В dev нет
        Demo: 2, // В dev нет
        A1: 2, // В dev нет
        Ariston: 2, // В dev нет
        Greenworks: 2, // В dev нет
        Bonduelle: 2, // В dev нет
        KIVI_1: 2, // В dev нет
        KIVI_2: 2, // В dev нет
        Veres: 2, // В dev нет
        TestProject: 2, // В dev нет
        Denvue: 2, // В dev нет
        Rusproduct: 2, // В dev нет
        Denvue_MCL: 2, // В dev нет
        Test: 2, // В dev нет
        MHI: 2, // В dev нет
        Yarmarka: 2, // В dev нет
        Marka1: 2, // В dev нет
        WORX_Kress: 2, // В dev нет
        General: 2, // В dev нет
        Knauf: 10,
        Opus: 2, // В dev нет
        Einhell: 2, // В dev нет
        Cersanit: 2, // В dev нет
        DIYProgram: 2, // В dev нет
        AYA: 2, // В dev нет
        Cersanit_RB: 2, // В dev нет
        Cersanit_RK: 2, // В dev нет
        ProjectTest: 2, // В dev нет
        Froneri_Prod: 2, // В dev нет
        Jeelex: 2, // В dev нет
        PROD_Project: 2, // В dev нет
        Daccord: 39
    },
    prod: {
        Froneri: 1,
        Project2: 2,
        KrasniyOktyabr: 4,
        Rusklimat: 5,
        ASBIS: 6,
        ASBIS_TSMir: 7,
        ASBIS_Mvideo: 8,
        Demo: 9,
        A1: 10,
        Ariston: 11,
        Greenworks: 12,
        Bonduelle: 13,
        KIVI_1: 14,
        KIVI_2: 15,
        Veres: 16,
        TestProject: 17,
        Denvue: 18,
        Rusproduct: 19,
        Denvue_MCL: 20,
        Test: 21,
        MHI: 22,
        Yarmarka: 23,
        Marka1: 24,
        WORX_Kress: 25,
        General: 26,
        Knauf: 27,
        Opus: 28,
        Einhell: 29,
        Cersanit: 30,
        DIYProgram: 31,
        AYA: 32,
        Cersanit_RB: 33,
        Cersanit_RK: 34,
        ProjectTest: 35,
        Froneri_Prod: 36,
        Jeelex: 37,
        PROD_Project: 38,
        Daccord: 39
    }
};



/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(7);
var IE8_DOM_DEFINE = __webpack_require__(168);
var toPrimitive = __webpack_require__(50);
var dP = Object.defineProperty;

exports.f = __webpack_require__(18) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addUnitAlias;
/* harmony export (immutable) */ __webpack_exports__["c"] = normalizeUnits;
/* harmony export (immutable) */ __webpack_exports__["b"] = normalizeObjectUnits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_has_own_prop__ = __webpack_require__(26);


var aliases = {};

function addUnitAlias(unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string'
        ? aliases[units] || aliases[units.toLowerCase()]
        : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_has_own_prop__["a" /* default */])(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(51);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return formattingTokens; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatTokenFunctions; });
/* harmony export (immutable) */ __webpack_exports__["a"] = addFormatToken;
/* harmony export (immutable) */ __webpack_exports__["c"] = formatMoment;
/* harmony export (immutable) */ __webpack_exports__["b"] = expandFormat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_zero_fill__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_is_function__ = __webpack_require__(66);



var formattingTokens =
        /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
    localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
    formatFunctions = {},
    formatTokenFunctions = {};



// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken(token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__utils_zero_fill__["a" /* default */])(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(
                func.apply(this, arguments),
                token
            );
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens),
        i,
        length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '',
            i;
        for (i = 0; i < length; i++) {
            output += Object(__WEBPACK_IMPORTED_MODULE_1__utils_is_function__["a" /* default */])(array[i])
                ? array[i].call(mom, format)
                : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] =
        formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(
            localFormattingTokens,
            replaceLongDateFormatTokens
        );
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toInt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__abs_floor__ = __webpack_require__(97);


function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = Object(__WEBPACK_IMPORTED_MODULE_0__abs_floor__["a" /* default */])(coercedNumber);
    }

    return value;
}


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hooks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setHookCallback; });


var hookCallback;

function hooks() {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback(callback) {
    hookCallback = callback;
}


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasOwnProp;
function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return match1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return match2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return match3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return match4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return match6; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return match1to2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return match3to4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return match5to6; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return match1to3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return match1to4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return match1to6; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return matchUnsigned; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return matchSigned; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return matchOffset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return matchShortOffset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return matchTimestamp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return matchWord; });
/* harmony export (immutable) */ __webpack_exports__["a"] = addRegexToken;
/* harmony export (immutable) */ __webpack_exports__["b"] = getParseRegexForToken;
/* harmony export (immutable) */ __webpack_exports__["t"] = regexEscape;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_has_own_prop__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_is_function__ = __webpack_require__(66);
var match1 = /\d/, //       0 - 9
    match2 = /\d\d/, //      00 - 99
    match3 = /\d{3}/, //     000 - 999
    match4 = /\d{4}/, //    0000 - 9999
    match6 = /[+-]?\d{6}/, // -999999 - 999999
    match1to2 = /\d\d?/, //       0 - 99
    match3to4 = /\d\d\d\d?/, //     999 - 9999
    match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
    match1to3 = /\d{1,3}/, //       0 - 999
    match1to4 = /\d{1,4}/, //       0 - 9999
    match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
    matchUnsigned = /\d+/, //       0 - inf
    matchSigned = /[+-]?\d+/, //    -inf - inf
    matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
    matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
    matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord =
        /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
    regexes;






regexes = {};

function addRegexToken(token, regex, strictRegex) {
    regexes[token] = Object(__WEBPACK_IMPORTED_MODULE_1__utils_is_function__["a" /* default */])(regex)
        ? regex
        : function (isStrict, localeData) {
              return isStrict && strictRegex ? strictRegex : regex;
          };
}

function getParseRegexForToken(token, config) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__utils_has_own_prop__["a" /* default */])(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(
        s
            .replace('\\', '')
            .replace(
                /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                function (matched, p1, p2, p3, p4) {
                    return p1 || p2 || p3 || p4;
                }
            )
    );
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addParseToken;
/* harmony export (immutable) */ __webpack_exports__["c"] = addWeekParseToken;
/* harmony export (immutable) */ __webpack_exports__["b"] = addTimeToArrayFromToken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_has_own_prop__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_is_number__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_to_int__ = __webpack_require__(24);




var tokens = {};

function addParseToken(token, callback) {
    var i,
        func = callback,
        tokenLen;
    if (typeof token === 'string') {
        token = [token];
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_is_number__["a" /* default */])(callback)) {
        func = function (input, array) {
            array[callback] = Object(__WEBPACK_IMPORTED_MODULE_2__utils_to_int__["a" /* default */])(input);
        };
    }
    tokenLen = token.length;
    for (i = 0; i < tokenLen; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken(token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && Object(__WEBPACK_IMPORTED_MODULE_0__utils_has_own_prop__["a" /* default */])(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.6.0
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2021-03-02T17:08Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.6.0",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.6
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2021-02-16
 */
( function( window ) {
var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ( {} ).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	pushNative = arr.push,
	push = arr.push,
	slice = arr.slice,

	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[ i ] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
		"ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5]
		// or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
		whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
		"*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
			whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
			whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		return nonHex ?

			// Strip the backslash prefix from a non-hex escape sequence
			nonHex :

			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" +
				ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android<4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;

			// Can't trust NodeList.length
			while ( ( target[ j++ ] = els[ i++ ] ) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

				// Support: IE 8 only
				// Exclude object elements
				( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					if ( newContext !== context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split( "|" ),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[ i ] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( ( cur = cur.nextSibling ) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return ( name === "input" || name === "button" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
					inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem && elem.namespaceURI,
		docElem = elem && ( elem.ownerDocument || elem ).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
	// Safari 4 - 5 only, Opera <=11.6 - 12.x only
	// IE/Edge & older browsers don't support the :scope pseudo-class.
	// Support: Safari 6.0 only
	// Safari 6.0 supports :scope but it's an alias of :root there.
	support.scope = assert( function( el ) {
		docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
		return typeof el.querySelectorAll !== "undefined" &&
			!el.querySelectorAll( ":scope fieldset div" ).length;
	} );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert( function( el ) {
		el.className = "i";
		return !el.getAttribute( "className" );
	} );

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert( function( el ) {
		el.appendChild( document.createComment( "" ) );
		return !el.getElementsByTagName( "*" ).length;
	} );

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter[ "ID" ] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter[ "ID" ] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find[ "TAG" ] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,

				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( ( elem = results[ i++ ] ) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {

			var input;

			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}

			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}

			// Support: Firefox <=3.6 - 5 only
			// Old Firefox doesn't throw on a badly-escaped identifier.
			el.querySelectorAll( "\\\f" );
			rbuggyQSA.push( "[\\r\\n\\f]" );
		} );

		assert( function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll( "[name=d]" ).length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: Opera 10 - 11 only
			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll( "*,:x" );
			rbuggyQSA.push( ",.*:" );
		} );
	}

	if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector ) ) ) ) {

		assert( function( el ) {

			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		} );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			) );
		} :
		function( a, b ) {
			if ( b ) {
				while ( ( b = b.parentNode ) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a == document || a.ownerDocument == preferredDoc &&
				contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b == document || b.ownerDocument == preferredDoc &&
				contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {

		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			return a == document ? -1 :
				b == document ? 1 :
				/* eslint-enable eqeqeq */
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( ( cur = cur.parentNode ) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( ( cur = cur.parentNode ) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[ i ] === bp[ i ] ) {
			i++;
		}

		return i ?

			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[ i ], bp[ i ] ) :

			// Otherwise nodes in our document sort first
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			ap[ i ] == preferredDoc ? -1 :
			bp[ i ] == preferredDoc ? 1 :
			/* eslint-enable eqeqeq */
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

				// As well, disconnected nodes are said to be in a document
				// fragment in IE 9
				elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			( val = elem.getAttributeNode( name ) ) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {

		// If no nodeType, this is expected to be an array
		while ( ( node = elem[ i++ ] ) ) {

			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {

			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}

	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
				match[ 5 ] || "" ).replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

				// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				Sizzle.error( match[ 0 ] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace +
					")" + className + "(" + whitespace + "|$)" ) ) && classCache(
						className, function( elem ) {
							return pattern.test(
								typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
							);
				} );
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				/* eslint-disable max-len */

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
				/* eslint-enable max-len */

			};
		},

		"CHILD": function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || ( node[ expando ] = {} );

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								( outerCache[ node.uniqueID ] = {} );

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {

								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || ( node[ expando ] = {} );

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												( outerCache[ node.uniqueID ] = {} );

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		"not": markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element (issue #299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		"has": markFunction( function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		} ),

		"contains": markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement &&
				( !document.hasFocus || document.hasFocus() ) &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return ( nodeName === "input" && !!elem.checked ) ||
				( nodeName === "option" && !!elem.selected );
		},

		"selected": function( elem ) {

			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {

			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos[ "empty" ]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		"last": createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		"even": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"odd": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rcombinators.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrim, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :

			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] ||
							( outerCache[ elem.uniqueID ] = {} );

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = uniqueCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts(
				selector || "*",
				context.nodeType ? [ context ] : context,
				[]
			),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?

				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

					// If the preceding token was a descendant combinator, insert an implicit any-element `*`
					tokens
						.slice( 0, i - 1 )
						.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache(
			selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers )
		);

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
			context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
				.replace( runescape, funescape ), context ) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
						context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert( function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute( "href" ) === "#";
} ) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	} );
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert( function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
} ) ) {
	addHandle( "value", function( elem, _name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	} );
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert( function( el ) {
	return el.getAttribute( "disabled" ) == null;
} ) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
		}
	} );
}

return Sizzle;

} )( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						// Support: Chrome 86+
						// In Chrome, if an element having a focusout handler is blurred by
						// clicking outside of it, it invokes the handler synchronously. If
						// that handler calls `.remove()` on the element, the data is cleared,
						// leaving `result` undefined. We need to guard against this.
						return result && result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		// Suppress native focus or blur as it's already being fired
		// in leverageNative.
		_default: function() {
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is display: block
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {

				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "pencil-edit-button.png?72aad6c8b6f90c32cfb952e23e7e6ada";

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(20);
var createDesc = __webpack_require__(68);
module.exports = __webpack_require__(18) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var hide = __webpack_require__(32);
var has = __webpack_require__(37);
var SRC = __webpack_require__(69)('src');
var $toString = __webpack_require__(345);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(44).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var fails = __webpack_require__(10);
var defined = __webpack_require__(51);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addUnitPriority;
/* harmony export (immutable) */ __webpack_exports__["b"] = getPrioritizedUnits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_has_own_prop__ = __webpack_require__(26);


var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [],
        u;
    for (u in unitsObj) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_has_own_prop__["a" /* default */])(unitsObj, u)) {
            units.push({ unit: u, priority: priorities[u] });
        }
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return YEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MINUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SECOND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MILLISECOND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return WEEK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return WEEKDAY; });
var YEAR = 0,
    MONTH = 1,
    DATE = 2,
    HOUR = 3,
    MINUTE = 4,
    SECOND = 5,
    MILLISECOND = 6,
    WEEK = 7,
    WEEKDAY = 8;


/***/ }),
/* 37 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(92);
var defined = __webpack_require__(51);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(93);
var createDesc = __webpack_require__(68);
var toIObject = __webpack_require__(38);
var toPrimitive = __webpack_require__(50);
var has = __webpack_require__(37);
var IE8_DOM_DEFINE = __webpack_require__(168);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(18) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(37);
var toObject = __webpack_require__(22);
var IE_PROTO = __webpack_require__(129)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(211);
var isBuffer = __webpack_require__(569);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getParsingFlags;
function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty: false,
        unusedTokens: [],
        unusedInput: [],
        overflow: -2,
        charsLeftOver: 0,
        nullInput: false,
        invalidEra: null,
        invalidMonth: null,
        invalidFormat: false,
        userInvalidated: false,
        iso: false,
        parsedDateParts: [],
        era: null,
        meridiem: null,
        rfc2822: false,
        weekdayMismatch: false,
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon-plus-2.png?a9f0723289447b25b2247e038a5d6326";

/***/ }),
/* 44 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(29);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(10);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 49 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(11);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(44);
var fails = __webpack_require__(10);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(45);
var IObject = __webpack_require__(92);
var toObject = __webpack_require__(22);
var toLength = __webpack_require__(16);
var asc = __webpack_require__(145);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = copyConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = Moment;
/* harmony export (immutable) */ __webpack_exports__["c"] = isMoment;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_hooks__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_is_undefined__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__create_parsing_flags__ = __webpack_require__(42);




// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = (__WEBPACK_IMPORTED_MODULE_0__utils_hooks__["a" /* hooks */].momentProperties = []),
    updateInProgress = false;

function copyConfig(to, from) {
    var i,
        prop,
        val,
        momentPropertiesLen = momentProperties.length;

    if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_is_undefined__["a" /* default */])(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_is_undefined__["a" /* default */])(from._i)) {
        to._i = from._i;
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_is_undefined__["a" /* default */])(from._f)) {
        to._f = from._f;
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_is_undefined__["a" /* default */])(from._l)) {
        to._l = from._l;
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_is_undefined__["a" /* default */])(from._strict)) {
        to._strict = from._strict;
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_is_undefined__["a" /* default */])(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_is_undefined__["a" /* default */])(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_is_undefined__["a" /* default */])(from._offset)) {
        to._offset = from._offset;
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_is_undefined__["a" /* default */])(from._pf)) {
        to._pf = Object(__WEBPACK_IMPORTED_MODULE_2__create_parsing_flags__["a" /* default */])(from);
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_is_undefined__["a" /* default */])(from._locale)) {
        to._locale = from._locale;
    }

    if (momentPropertiesLen > 0) {
        for (i = 0; i < momentPropertiesLen; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_is_undefined__["a" /* default */])(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        __WEBPACK_IMPORTED_MODULE_0__utils_hooks__["a" /* hooks */].updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment(obj) {
    return (
        obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
    );
}


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "u57.png?8086c90d0f97c1cfc5e9063400e9b32c";

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Draggable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_smooth_dnd__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_smooth_dnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_smooth_dnd__);
/**
 * Bundle of: vue-smooth-dnd
 * Generated: 2018-11-28
 * Version: 0.2.8
 */



var isArray = function (obj) {
  return Object.prototype.toString.call(obj) === '[object Array]'
};

function getTagProps (ctx, tagClasses) {
  var tag = ctx.$props.tag;
  if (tag) {
    if (typeof tag === 'string') {
      var result = { value: tag };
      if (tagClasses) {
        result.props = { class: tagClasses };
      }
      return result
    } else if (typeof tag === 'object') {
      var result$1 = { value: tag.value || 'div', props: tag.props || {} };

      if (tagClasses) {
        if (result$1.props.class) {
          if (isArray(result$1.props.class)) {
            result$1.props.class.push(tagClasses);
          } else {
            result$1.props.class = [tagClasses, result$1.props.class];
          }
        } else {
          result$1.props.class = tagClasses;
        }
      }

      return result$1
    }
  }
  return { value: 'div' }
}

function validateTagProp (tag) {
  if (tag) {
    if (typeof tag === 'string') { return true }
    if (typeof tag === 'object') {
      if (
        typeof tag.value === 'string' ||
        typeof tag.value === 'function' ||
        typeof tag.value === 'object'
      ) {
        return true
      }
    }
    return false
  }
  return true
}

/* eslint-disable curly */

__WEBPACK_IMPORTED_MODULE_0_smooth_dnd___default.a.dropHandler = __WEBPACK_IMPORTED_MODULE_0_smooth_dnd__["dropHandlers"].reactDropHandler().handler;
__WEBPACK_IMPORTED_MODULE_0_smooth_dnd___default.a.wrapChild = function (p) { return p; }; // don't wrap children they will already be wrapped

var mapOptions = function (context) {
  var props = Object.assign({}, context.$props, context.$listeners);
  var options = {};
  if (props.behaviour) { options.behaviour = props.behaviour; }
  if (props.groupName) { options.groupName = props.groupName; }
  if (props.orientation) { options.orientation = props.orientation; }
  if (props.dragHandleSelector)
    { options.dragHandleSelector = props.dragHandleSelector; }
  if (props.nonDragAreaSelector)
    { options.nonDragAreaSelector = props.nonDragAreaSelector; }
  if (props.dragBeginDelay !== undefined)
    { options.dragBeginDelay = props.dragBeginDelay; }
  if (props.animationDuration !== undefined)
    { options.animationDuration = props.animationDuration; }
  if (props.autoScrollEnabled !== undefined)
    { options.autoScrollEnabled = props.autoScrollEnabled; }
  if (props.lockAxis) { options.lockAxis = props.lockAxis; }
  if (props.dragClass) { options.dragClass = props.dragClass; }
  if (props.dropClass) { options.dropClass = props.dropClass; }
  if (props.removeOnDropOut) { options.removeOnDropOut = props.removeOnDropOut; }
  if (props['drag-start']) {
    options.onDragStart = function (params) {
      context.$emit('drag-start', params);
    };
  }
  if (props['drag-end']) {
    options.onDragEnd = function (params) {
      context.$emit('drag-end', params);
    };
  }
  if (props['drop']) {
    options.onDrop = function (dragResult) {
      context.$emit('drop', dragResult);
    };
  }
  if (props.getChildPayload) { options.getChildPayload = props.getChildPayload; }
  if (props.shouldAnimateDrop)
    { options.shouldAnimateDrop = props.shouldAnimateDrop; }
  if (props.shouldAcceptDrop) { options.shouldAcceptDrop = props.shouldAcceptDrop; }
  if (props['drag-enter']) {
    options.onDragEnter = function () {
      context.$emit('drag-enter');
    };
  }
  if (props['drag-leave']) {
    options.onDragLeave = function () {
      context.$emit('drag-leave');
    };
  }
  if (props.getGhostParent) { options.getGhostParent = props.getGhostParent; }

  if (props['drop-ready']) {
    options.onDropReady = function (dropResult) {
      context.$emit('drop-ready', dropResult);
    };
  }
  return options
};

var Container = {
  name: 'Container',
  mounted: function mounted () {
    this.containerElement = this.$refs.container || this.$el;
    this.container = __WEBPACK_IMPORTED_MODULE_0_smooth_dnd___default()(this.containerElement, mapOptions(this));
  },
  updated: function updated () {
    if (
      this.$refs.container !== this.containerElement &&
      this.$el !== this.containerElement
    ) {
      if (this.container) {
        this.container.dispose();
      }
      this.containerElement = this.$refs.container || this.$el;
      this.container = __WEBPACK_IMPORTED_MODULE_0_smooth_dnd___default()(this.containerElement, mapOptions(this));
    }
  },
  destroyed: function destroyed () {
    if (this.container) {
      this.container.dispose();
    }
  },
  props: {
    behaviour: String,
    groupName: String,
    orientation: String,
    dragHandleSelector: String,
    nonDragAreaSelector: String,
    dragBeginDelay: Number,
    animationDuration: Number,
    autoScrollEnabled: { type: Boolean, default: true },
    lockAxis: String,
    dragClass: String,
    dropClass: String,
    removeOnDropOut: { type: Boolean, default: false },
    'drag-start': Function,
    'drag-end': Function,
    drop: Function,
    getChildPayload: Function,
    shouldAnimateDrop: Function,
    shouldAcceptDrop: Function,
    'drag-enter': Function,
    'drag-leave': Function,
    tag: {
      validator: validateTagProp,
      default: 'div',
    },
    getGhostParent: Function,
    'drop-ready': Function,
  },
  render: function (createElement) {
    var tagProps = getTagProps(this);
    return createElement(
      tagProps.value,
      Object.assign({}, { ref: 'container' }, tagProps.props),
      this.$slots.default
    )
  }
};

var wrapChild = function (createElement, ctx) {
  var tagProps = getTagProps(ctx, __WEBPACK_IMPORTED_MODULE_0_smooth_dnd__["constants"].wrapperClass);
  return createElement(
    tagProps.value,
    Object.assign({}, tagProps.props),
    ctx.$slots.default
  )
};

var Draggable = {
  name: 'Draggable',
  props: {
    tag: {
      validator: validateTagProp,
      default: 'div'
    }
  },
  render: function (createElement) {
    return wrapChild(createElement, this)
  }
};




/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(18)) {
  var LIBRARY = __webpack_require__(62);
  var global = __webpack_require__(8);
  var fails = __webpack_require__(10);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(110);
  var $buffer = __webpack_require__(153);
  var ctx = __webpack_require__(45);
  var anInstance = __webpack_require__(75);
  var propertyDesc = __webpack_require__(68);
  var hide = __webpack_require__(32);
  var redefineAll = __webpack_require__(77);
  var toInteger = __webpack_require__(47);
  var toLength = __webpack_require__(16);
  var toIndex = __webpack_require__(196);
  var toAbsoluteIndex = __webpack_require__(71);
  var toPrimitive = __webpack_require__(50);
  var has = __webpack_require__(37);
  var classof = __webpack_require__(83);
  var isObject = __webpack_require__(11);
  var toObject = __webpack_require__(22);
  var isArrayIter = __webpack_require__(142);
  var create = __webpack_require__(72);
  var getPrototypeOf = __webpack_require__(40);
  var gOPN = __webpack_require__(73).f;
  var getIterFn = __webpack_require__(144);
  var uid = __webpack_require__(69);
  var wks = __webpack_require__(15);
  var createArrayMethod = __webpack_require__(53);
  var createArrayIncludes = __webpack_require__(100);
  var speciesConstructor = __webpack_require__(95);
  var ArrayIterators = __webpack_require__(147);
  var Iterators = __webpack_require__(85);
  var $iterDetect = __webpack_require__(105);
  var setSpecies = __webpack_require__(74);
  var arrayFill = __webpack_require__(146);
  var arrayCopyWithin = __webpack_require__(185);
  var $DP = __webpack_require__(20);
  var $GOPD = __webpack_require__(39);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(191);
var $export = __webpack_require__(0);
var shared = __webpack_require__(91)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(194))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createLocal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__from_anything__ = __webpack_require__(156);


function createLocal(input, format, locale, strict) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__from_anything__["a" /* createLocalOrUTC */])(input, format, locale, strict, false);
}


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = makeGetSet;
/* harmony export (immutable) */ __webpack_exports__["a"] = get;
/* harmony export (immutable) */ __webpack_exports__["c"] = set;
/* harmony export (immutable) */ __webpack_exports__["d"] = stringGet;
/* harmony export (immutable) */ __webpack_exports__["e"] = stringSet;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__units_aliases__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__units_priorities__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_hooks__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_is_function__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__units_month__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_is_leap_year__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_to_int__ = __webpack_require__(24);








function makeGetSet(unit, keepTime) {
    return function (value) {
        if (value != null) {
            set(this, unit, value);
            __WEBPACK_IMPORTED_MODULE_2__utils_hooks__["a" /* hooks */].updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get(mom, unit) {
    return mom.isValid()
        ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
        : NaN;
}

function set(mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (
            unit === 'FullYear' &&
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_is_leap_year__["a" /* isLeapYear */])(mom.year()) &&
            mom.month() === 1 &&
            mom.date() === 29
        ) {
            value = Object(__WEBPACK_IMPORTED_MODULE_6__utils_to_int__["a" /* default */])(value);
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                value,
                mom.month(),
                Object(__WEBPACK_IMPORTED_MODULE_4__units_month__["a" /* daysInMonth */])(value, mom.month())
            );
        } else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet(units) {
    units = Object(__WEBPACK_IMPORTED_MODULE_0__units_aliases__["c" /* normalizeUnits */])(units);
    if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_is_function__["a" /* default */])(this[units])) {
        return this[units]();
    }
    return this;
}

function stringSet(units, value) {
    if (typeof units === 'object') {
        units = Object(__WEBPACK_IMPORTED_MODULE_0__units_aliases__["b" /* normalizeObjectUnits */])(units);
        var prioritized = Object(__WEBPACK_IMPORTED_MODULE_1__units_priorities__["b" /* getPrioritizedUnits */])(units),
            i,
            prioritizedLen = prioritized.length;
        for (i = 0; i < prioritizedLen; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = Object(__WEBPACK_IMPORTED_MODULE_0__units_aliases__["c" /* normalizeUnits */])(units);
        if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_is_function__["a" /* default */])(this[units])) {
            return this[units](value);
        }
    }
    return this;
}


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createDuration;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constructor__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_is_number__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_to_int__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_abs_round__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_has_own_prop__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__units_constants__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__units_offset__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__create_local__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__valid__ = __webpack_require__(164);










// ASP.NET json date format regex
var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex =
        /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration(input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (Object(__WEBPACK_IMPORTED_MODULE_0__constructor__["b" /* isDuration */])(input)) {
        duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months,
        };
    } else if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_is_number__["a" /* default */])(input) || !isNaN(+input)) {
        duration = {};
        if (key) {
            duration[key] = +input;
        } else {
            duration.milliseconds = +input;
        }
    } else if ((match = aspNetRegex.exec(input))) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
            y: 0,
            d: Object(__WEBPACK_IMPORTED_MODULE_2__utils_to_int__["a" /* default */])(match[__WEBPACK_IMPORTED_MODULE_5__units_constants__["a" /* DATE */]]) * sign,
            h: Object(__WEBPACK_IMPORTED_MODULE_2__utils_to_int__["a" /* default */])(match[__WEBPACK_IMPORTED_MODULE_5__units_constants__["b" /* HOUR */]]) * sign,
            m: Object(__WEBPACK_IMPORTED_MODULE_2__utils_to_int__["a" /* default */])(match[__WEBPACK_IMPORTED_MODULE_5__units_constants__["d" /* MINUTE */]]) * sign,
            s: Object(__WEBPACK_IMPORTED_MODULE_2__utils_to_int__["a" /* default */])(match[__WEBPACK_IMPORTED_MODULE_5__units_constants__["f" /* SECOND */]]) * sign,
            ms: Object(__WEBPACK_IMPORTED_MODULE_2__utils_to_int__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__utils_abs_round__["a" /* default */])(match[__WEBPACK_IMPORTED_MODULE_5__units_constants__["c" /* MILLISECOND */]] * 1000)) * sign, // the millisecond decimal point is included in the match
        };
    } else if ((match = isoRegex.exec(input))) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
            y: parseIso(match[2], sign),
            M: parseIso(match[3], sign),
            w: parseIso(match[4], sign),
            d: parseIso(match[5], sign),
            h: parseIso(match[6], sign),
            m: parseIso(match[7], sign),
            s: parseIso(match[8], sign),
        };
    } else if (duration == null) {
        // checks for null or undefined
        duration = {};
    } else if (
        typeof duration === 'object' &&
        ('from' in duration || 'to' in duration)
    ) {
        diffRes = momentsDifference(
            Object(__WEBPACK_IMPORTED_MODULE_7__create_local__["a" /* createLocal */])(duration.from),
            Object(__WEBPACK_IMPORTED_MODULE_7__create_local__["a" /* createLocal */])(duration.to)
        );

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new __WEBPACK_IMPORTED_MODULE_0__constructor__["a" /* Duration */](duration);

    if (Object(__WEBPACK_IMPORTED_MODULE_0__constructor__["b" /* isDuration */])(input) && Object(__WEBPACK_IMPORTED_MODULE_4__utils_has_own_prop__["a" /* default */])(input, '_locale')) {
        ret._locale = input._locale;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_0__constructor__["b" /* isDuration */])(input) && Object(__WEBPACK_IMPORTED_MODULE_4__utils_has_own_prop__["a" /* default */])(input, '_isValid')) {
        ret._isValid = input._isValid;
    }

    return ret;
}

createDuration.fn = __WEBPACK_IMPORTED_MODULE_0__constructor__["a" /* Duration */].prototype;
createDuration.invalid = __WEBPACK_IMPORTED_MODULE_8__valid__["a" /* createInvalid */];

function parseIso(inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {};

    res.months =
        other.month() - base.month() + (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +base.clone().add(res.months, 'M');

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return { milliseconds: 0, months: 0 };
    }

    other = Object(__WEBPACK_IMPORTED_MODULE_6__units_offset__["a" /* cloneWithOffset */])(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}


/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(69)('meta');
var isObject = __webpack_require__(11);
var has = __webpack_require__(37);
var setDesc = __webpack_require__(20).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(10)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(15)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(32)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = deprecate;
/* harmony export (immutable) */ __webpack_exports__["b"] = deprecateSimple;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extend__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hooks__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__has_own_prop__ = __webpack_require__(26);




function warn(msg) {
    if (
        __WEBPACK_IMPORTED_MODULE_1__hooks__["a" /* hooks */].suppressDeprecationWarnings === false &&
        typeof console !== 'undefined' &&
        console.warn
    ) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return Object(__WEBPACK_IMPORTED_MODULE_0__extend__["a" /* default */])(function () {
        if (__WEBPACK_IMPORTED_MODULE_1__hooks__["a" /* hooks */].deprecationHandler != null) {
            __WEBPACK_IMPORTED_MODULE_1__hooks__["a" /* hooks */].deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [],
                arg,
                i,
                key,
                argLen = arguments.length;
            for (i = 0; i < argLen; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (key in arguments[0]) {
                        if (Object(__WEBPACK_IMPORTED_MODULE_2__has_own_prop__["a" /* default */])(arguments[0], key)) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(
                msg +
                    '\nArguments: ' +
                    Array.prototype.slice.call(args).join('') +
                    '\n' +
                    new Error().stack
            );
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (__WEBPACK_IMPORTED_MODULE_1__hooks__["a" /* hooks */].deprecationHandler != null) {
        __WEBPACK_IMPORTED_MODULE_1__hooks__["a" /* hooks */].deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

__WEBPACK_IMPORTED_MODULE_1__hooks__["a" /* hooks */].suppressDeprecationWarnings = false;
__WEBPACK_IMPORTED_MODULE_1__hooks__["a" /* hooks */].deprecationHandler = null;


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isFunction;
function isFunction(input) {
    return (
        (typeof Function !== 'undefined' && input instanceof Function) ||
        Object.prototype.toString.call(input) === '[object Function]'
    );
}


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = daysInMonth;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultLocaleMonths; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return defaultLocaleMonthsShort; });
/* harmony export (immutable) */ __webpack_exports__["f"] = localeMonths;
/* harmony export (immutable) */ __webpack_exports__["h"] = localeMonthsShort;
/* harmony export (immutable) */ __webpack_exports__["g"] = localeMonthsParse;
/* harmony export (immutable) */ __webpack_exports__["k"] = setMonth;
/* harmony export (immutable) */ __webpack_exports__["e"] = getSetMonth;
/* harmony export (immutable) */ __webpack_exports__["d"] = getDaysInMonth;
/* harmony export (immutable) */ __webpack_exports__["j"] = monthsShortRegex;
/* harmony export (immutable) */ __webpack_exports__["i"] = monthsRegex;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__moment_get_set__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_has_own_prop__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__format_format__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aliases__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__priorities__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parse_regex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parse_token__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_hooks__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_to_int__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_is_array__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_is_number__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_mod__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_index_of__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__create_utc__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__create_parsing_flags__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_is_leap_year__ = __webpack_require__(158);


















function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = Object(__WEBPACK_IMPORTED_MODULE_12__utils_mod__["a" /* default */])(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1
        ? Object(__WEBPACK_IMPORTED_MODULE_16__utils_is_leap_year__["a" /* isLeapYear */])(year)
            ? 29
            : 28
        : 31 - ((modMonth % 7) % 2);
}

// FORMATTING

Object(__WEBPACK_IMPORTED_MODULE_2__format_format__["a" /* addFormatToken */])('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

Object(__WEBPACK_IMPORTED_MODULE_2__format_format__["a" /* addFormatToken */])('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

Object(__WEBPACK_IMPORTED_MODULE_2__format_format__["a" /* addFormatToken */])('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

Object(__WEBPACK_IMPORTED_MODULE_3__aliases__["a" /* addUnitAlias */])('month', 'M');

// PRIORITY

Object(__WEBPACK_IMPORTED_MODULE_4__priorities__["a" /* addUnitPriority */])('month', 8);

// PARSING

Object(__WEBPACK_IMPORTED_MODULE_5__parse_regex__["a" /* addRegexToken */])('M', __WEBPACK_IMPORTED_MODULE_5__parse_regex__["d" /* match1to2 */]);
Object(__WEBPACK_IMPORTED_MODULE_5__parse_regex__["a" /* addRegexToken */])('MM', __WEBPACK_IMPORTED_MODULE_5__parse_regex__["d" /* match1to2 */], __WEBPACK_IMPORTED_MODULE_5__parse_regex__["h" /* match2 */]);
Object(__WEBPACK_IMPORTED_MODULE_5__parse_regex__["a" /* addRegexToken */])('MMM', function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
Object(__WEBPACK_IMPORTED_MODULE_5__parse_regex__["a" /* addRegexToken */])('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

Object(__WEBPACK_IMPORTED_MODULE_6__parse_token__["a" /* addParseToken */])(['M', 'MM'], function (input, array) {
    array[__WEBPACK_IMPORTED_MODULE_8__constants__["e" /* MONTH */]] = Object(__WEBPACK_IMPORTED_MODULE_9__utils_to_int__["a" /* default */])(input) - 1;
});

Object(__WEBPACK_IMPORTED_MODULE_6__parse_token__["a" /* addParseToken */])(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[__WEBPACK_IMPORTED_MODULE_8__constants__["e" /* MONTH */]] = month;
    } else {
        Object(__WEBPACK_IMPORTED_MODULE_15__create_parsing_flags__["a" /* default */])(config).invalidMonth = input;
    }
});

// LOCALES

var defaultLocaleMonths =
        'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
    defaultLocaleMonthsShort =
        'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
    defaultMonthsShortRegex = __WEBPACK_IMPORTED_MODULE_5__parse_regex__["s" /* matchWord */],
    defaultMonthsRegex = __WEBPACK_IMPORTED_MODULE_5__parse_regex__["s" /* matchWord */];



function localeMonths(m, format) {
    if (!m) {
        return Object(__WEBPACK_IMPORTED_MODULE_10__utils_is_array__["a" /* default */])(this._months)
            ? this._months
            : this._months['standalone'];
    }
    return Object(__WEBPACK_IMPORTED_MODULE_10__utils_is_array__["a" /* default */])(this._months)
        ? this._months[m.month()]
        : this._months[
              (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                  ? 'format'
                  : 'standalone'
          ][m.month()];
}

function localeMonthsShort(m, format) {
    if (!m) {
        return Object(__WEBPACK_IMPORTED_MODULE_10__utils_is_array__["a" /* default */])(this._monthsShort)
            ? this._monthsShort
            : this._monthsShort['standalone'];
    }
    return Object(__WEBPACK_IMPORTED_MODULE_10__utils_is_array__["a" /* default */])(this._monthsShort)
        ? this._monthsShort[m.month()]
        : this._monthsShort[
              MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
          ][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i,
        ii,
        mom,
        llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = Object(__WEBPACK_IMPORTED_MODULE_14__create_utc__["a" /* createUTC */])([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(
                mom,
                ''
            ).toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = __WEBPACK_IMPORTED_MODULE_13__utils_index_of__["a" /* default */].call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = __WEBPACK_IMPORTED_MODULE_13__utils_index_of__["a" /* default */].call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = __WEBPACK_IMPORTED_MODULE_13__utils_index_of__["a" /* default */].call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = __WEBPACK_IMPORTED_MODULE_13__utils_index_of__["a" /* default */].call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = __WEBPACK_IMPORTED_MODULE_13__utils_index_of__["a" /* default */].call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = __WEBPACK_IMPORTED_MODULE_13__utils_index_of__["a" /* default */].call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse(monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = Object(__WEBPACK_IMPORTED_MODULE_14__create_utc__["a" /* createUTC */])([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp(
                '^' + this.months(mom, '').replace('.', '') + '$',
                'i'
            );
            this._shortMonthsParse[i] = new RegExp(
                '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                'i'
            );
        }
        if (!strict && !this._monthsParse[i]) {
            regex =
                '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (
            strict &&
            format === 'MMMM' &&
            this._longMonthsParse[i].test(monthName)
        ) {
            return i;
        } else if (
            strict &&
            format === 'MMM' &&
            this._shortMonthsParse[i].test(monthName)
        ) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth(mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = Object(__WEBPACK_IMPORTED_MODULE_9__utils_to_int__["a" /* default */])(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!Object(__WEBPACK_IMPORTED_MODULE_11__utils_is_number__["a" /* default */])(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth(value) {
    if (value != null) {
        setMonth(this, value);
        __WEBPACK_IMPORTED_MODULE_7__utils_hooks__["a" /* hooks */].updateOffset(this, true);
        return this;
    } else {
        return Object(__WEBPACK_IMPORTED_MODULE_0__moment_get_set__["a" /* get */])(this, 'Month');
    }
}

function getDaysInMonth() {
    return daysInMonth(this.year(), this.month());
}

function monthsShortRegex(isStrict) {
    if (this._monthsParseExact) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_has_own_prop__["a" /* default */])(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_has_own_prop__["a" /* default */])(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict
            ? this._monthsShortStrictRegex
            : this._monthsShortRegex;
    }
}

function monthsRegex(isStrict) {
    if (this._monthsParseExact) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_has_own_prop__["a" /* default */])(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_has_own_prop__["a" /* default */])(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict
            ? this._monthsStrictRegex
            : this._monthsRegex;
    }
}

function computeMonthsParse() {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = Object(__WEBPACK_IMPORTED_MODULE_14__create_utc__["a" /* createUTC */])([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = Object(__WEBPACK_IMPORTED_MODULE_5__parse_regex__["t" /* regexEscape */])(shortPieces[i]);
        longPieces[i] = Object(__WEBPACK_IMPORTED_MODULE_5__parse_regex__["t" /* regexEscape */])(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = Object(__WEBPACK_IMPORTED_MODULE_5__parse_regex__["t" /* regexEscape */])(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp(
        '^(' + longPieces.join('|') + ')',
        'i'
    );
    this._monthsShortStrictRegex = new RegExp(
        '^(' + shortPieces.join('|') + ')',
        'i'
    );
}


/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 69 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(170);
var enumBugKeys = __webpack_require__(130);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(47);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(7);
var dPs = __webpack_require__(171);
var enumBugKeys = __webpack_require__(130);
var IE_PROTO = __webpack_require__(129)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(127)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(131).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(170);
var hiddenKeys = __webpack_require__(130).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(8);
var dP = __webpack_require__(20);
var DESCRIPTORS = __webpack_require__(18);
var SPECIES = __webpack_require__(15)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(45);
var call = __webpack_require__(183);
var isArrayIter = __webpack_require__(142);
var anObject = __webpack_require__(7);
var toLength = __webpack_require__(16);
var getIterFn = __webpack_require__(144);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(33);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.14
 * (c) 2014-2021 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i], vm);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  var haveExpectedTypes = expectedTypes.some(function (t) { return t; });
  if (!valid && haveExpectedTypes) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;

function assertType (value, type, vm) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    try {
      valid = value instanceof type;
    } catch (e) {
      warn('Invalid prop type: "' + String(type) + '" is not a constructor', vm);
      valid = false;
    }
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

var functionTypeCheckRE = /^\s*function (\w+)/;

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(functionTypeCheckRE);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  // check if we need to specify expected value
  if (
    expectedTypes.length === 1 &&
    isExplicable(expectedType) &&
    isExplicable(typeof value) &&
    !isBoolean(expectedType, receivedType)
  ) {
    message += " with value " + (styleValue(value, expectedType));
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + (styleValue(value, receivedType)) + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

var EXPLICABLE_TYPES = ['string', 'number', 'boolean'];
function isExplicable (value) {
  return EXPLICABLE_TYPES.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    var vnode = res && res[0];
    return res && (
      !vnode ||
      (res.length === 1 && vnode.isComment && !isAsyncPlaceholder(vnode)) // #9658, #10391
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallbackRender,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) {
    // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn('slot v-bind without argument expects an Object', this);
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes =
      scopedSlotFn(props) ||
      (typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
  } else {
    nodes =
      this.$slots[name] ||
      (typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
  return eventKeyCode === undefined
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  // we know it's MountedComponentVNode but flow doesn't
  vnode,
  // activeInstance in lifecycle state
  parent
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key) ||
    (!newScopedSlots && vm.$scopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        var info = "callback for watcher \"" + (this.expression) + "\"";
        invokeWithErrorHandling(this.cb, this.vm, [value, oldValue], this.vm, info);
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      } else if (vm.$options.methods && key in vm.$options.methods) {
        warn(("The computed property \"" + key + "\" is already defined as a method."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      var info = "callback for immediate watcher \"" + (watcher.expression) + "\"";
      pushTarget();
      invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
      popTarget();
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */





function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var entry = cache[key];
    if (entry) {
      var name = entry.name;
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var entry = cache[key];
  if (entry && (!current || entry.tag !== current.tag)) {
    entry.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  methods: {
    cacheVNode: function cacheVNode() {
      var ref = this;
      var cache = ref.cache;
      var keys = ref.keys;
      var vnodeToCache = ref.vnodeToCache;
      var keyToCache = ref.keyToCache;
      if (vnodeToCache) {
        var tag = vnodeToCache.tag;
        var componentInstance = vnodeToCache.componentInstance;
        var componentOptions = vnodeToCache.componentOptions;
        cache[keyToCache] = {
          name: getComponentName(componentOptions),
          tag: tag,
          componentInstance: componentInstance,
        };
        keys.push(keyToCache);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
        this.vnodeToCache = null;
      }
    }
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.cacheVNode();
    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  updated: function updated () {
    this.cacheVNode();
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        // delay setting the cache until update
        this.vnodeToCache = vnode;
        this.keyToCache = key;
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.14';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key &&
    a.asyncFactory === b.asyncFactory && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur, vnode.data.pre);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value, isInPre) {
  if (isInPre || el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /[ \f\t\r\n]+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!(
    el.component ||
    el.attrsMap[':is'] ||
    el.attrsMap['v-bind:is'] ||
    !(el.attrsMap.is ? isReservedTag(el.attrsMap.is) : isReservedTag(el.tag))
  ); };
  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + ".apply(null, arguments)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ").apply(null, arguments)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  // fix #11483, Root level <script> tags should not be rendered.
  var code = ast ? (ast.tag === 'script' ? 'null' : genElement(ast, state)) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? (",function(){return " + children + "}") : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(49), __webpack_require__(545).setImmediate))

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["c"] = getSetGlobalLocale;
/* harmony export (immutable) */ __webpack_exports__["a"] = defineLocale;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateLocale;
/* harmony export (immutable) */ __webpack_exports__["b"] = getLocale;
/* harmony export (immutable) */ __webpack_exports__["d"] = listLocales;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_is_array__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_is_undefined__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_deprecate__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__set__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constructor__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_keys__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__base_config__ = __webpack_require__(591);
var require;








// internal storage for locale config files
var locales = {},
    localeFamilies = {},
    globalLocale;

function commonPrefix(arr1, arr2) {
    var i,
        minl = Math.min(arr1.length, arr2.length);
    for (i = 0; i < minl; i += 1) {
        if (arr1[i] !== arr2[i]) {
            return i;
        }
    }
    return minl;
}

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0,
        j,
        next,
        locale,
        split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (
                next &&
                next.length >= j &&
                commonPrefix(split, next) >= j - 1
            ) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return globalLocale;
}

function isLocaleNameSane(name) {
    // Prevent names that look like filesystem paths, i.e contain '/' or '\'
    return name.match('^[^/\\\\]*$') != null;
}

function loadLocale(name) {
    var oldLocale = null,
        aliasedRequire;
    // TODO: Find a better way to register and load all the locales in Node
    if (
        locales[name] === undefined &&
        typeof module !== 'undefined' &&
        module &&
        module.exports &&
        isLocaleNameSane(name)
    ) {
        try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = require;
            !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale(key, values) {
    var data;
    if (key) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_is_undefined__["a" /* default */])(values)) {
            data = getLocale(key);
        } else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        } else {
            if (typeof console !== 'undefined' && console.warn) {
                //warn user if arguments are passed but the locale could not be set
                console.warn(
                    'Locale ' + key + ' not found. Did you forget to load it?'
                );
            }
        }
    }

    return globalLocale._abbr;
}

function defineLocale(name, config) {
    if (config !== null) {
        var locale,
            parentConfig = __WEBPACK_IMPORTED_MODULE_6__base_config__["a" /* baseConfig */];
        config.abbr = name;
        if (locales[name] != null) {
            Object(__WEBPACK_IMPORTED_MODULE_2__utils_deprecate__["b" /* deprecateSimple */])(
                'defineLocaleOverride',
                'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
            );
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                locale = loadLocale(config.parentLocale);
                if (locale != null) {
                    parentConfig = locale._config;
                } else {
                    if (!localeFamilies[config.parentLocale]) {
                        localeFamilies[config.parentLocale] = [];
                    }
                    localeFamilies[config.parentLocale].push({
                        name: name,
                        config: config,
                    });
                    return null;
                }
            }
        }
        locales[name] = new __WEBPACK_IMPORTED_MODULE_4__constructor__["a" /* Locale */](Object(__WEBPACK_IMPORTED_MODULE_3__set__["a" /* mergeConfigs */])(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);

        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale,
            tmpLocale,
            parentConfig = __WEBPACK_IMPORTED_MODULE_6__base_config__["a" /* baseConfig */];

        if (locales[name] != null && locales[name].parentLocale != null) {
            // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(Object(__WEBPACK_IMPORTED_MODULE_3__set__["a" /* mergeConfigs */])(locales[name]._config, config));
        } else {
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = Object(__WEBPACK_IMPORTED_MODULE_3__set__["a" /* mergeConfigs */])(parentConfig, config);
            if (tmpLocale == null) {
                // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
            }
            locale = new __WEBPACK_IMPORTED_MODULE_4__constructor__["a" /* Locale */](config);
            locale.parentLocale = locales[name];
            locales[name] = locale;
        }

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) {
                    getSetGlobalLocale(name);
                }
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale(key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!Object(__WEBPACK_IMPORTED_MODULE_0__utils_is_array__["a" /* default */])(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return Object(__WEBPACK_IMPORTED_MODULE_5__utils_keys__["a" /* default */])(locales);
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(589)(module)))

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var claimsCheckingMixin = {

    props: ['info'],

    mounted: function mounted() {

        //console.info('claimsCheckingMixin -> mounted -> this.info:', this.info);

    }
};

/* harmony default export */ __webpack_exports__["a"] = (claimsCheckingMixin);

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(20).f;
var has = __webpack_require__(37);
var TAG = __webpack_require__(15)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(46);
var TAG = __webpack_require__(15)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var defined = __webpack_require__(51);
var fails = __webpack_require__(10);
var spaces = __webpack_require__(133);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isArray;
function isArray(input) {
    return (
        input instanceof Array ||
        Object.prototype.toString.call(input) === '[object Array]'
    );
}


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isNumber;
function isNumber(input) {
    return (
        typeof input === 'number' ||
        Object.prototype.toString.call(input) === '[object Number]'
    );
}


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isValid;
/* harmony export (immutable) */ __webpack_exports__["a"] = createInvalid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_extend__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utc__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__create_parsing_flags__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_some__ = __webpack_require__(588);





function isValid(m) {
    if (m._isValid == null) {
        var flags = Object(__WEBPACK_IMPORTED_MODULE_2__create_parsing_flags__["a" /* default */])(m),
            parsedParts = __WEBPACK_IMPORTED_MODULE_3__utils_some__["a" /* default */].call(flags.parsedDateParts, function (i) {
                return i != null;
            }),
            isNowValid =
                !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid =
                isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid(flags) {
    var m = Object(__WEBPACK_IMPORTED_MODULE_1__utc__["a" /* createUTC */])(NaN);
    if (flags != null) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils_extend__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__create_parsing_flags__["a" /* default */])(m), flags);
    } else {
        Object(__WEBPACK_IMPORTED_MODULE_2__create_parsing_flags__["a" /* default */])(m).userInvalidated = true;
    }

    return m;
}


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createUTC;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__from_anything__ = __webpack_require__(156);


function createUTC(input, format, locale, strict) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__from_anything__["a" /* createLocalOrUTC */])(input, format, locale, strict, true).utc();
}


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_FancyBox_jquery_fancybox_pack_js__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_FancyBox_jquery_fancybox_css__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_FancyBox_jquery_fancybox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_FancyBox_jquery_fancybox_css__);




var imgMixin = {

    // data() {
    //     return {
    //
    //     }
    // },

    methods: {
        zoomIn: function zoomIn() {
            var $img = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap.find('img.fancybox-image');
            var scale = $img.data('scale') || 1.0;
            scale += 0.2;
            $img.css('transform', 'scale(' + scale + ')');
            $img.data('scale', scale);
        },
        zoomOut: function zoomOut() {
            var $img = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap.find('img.fancybox-image');
            var scale = $img.data('scale') || 1.0;
            scale -= 0.2;
            if (scale < 0.5) {
                return false;
            }
            $img.css('transform', 'scale(' + scale + ')');
            $img.data('scale', scale);
        },
        imgmixin_lightzoomInit: function imgmixin_lightzoomInit() {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.lightzoom').fancybox({
                beforeShow: function beforeShow() {
                    var downloadpath = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap.find('.fancybox-image').attr('src');
                    var $btn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<a href="' + downloadpath + '" class="btn" download>Скачать</a>');
                    var $div = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div class="btns flex">\n<button type="button" class="btn btn-primary margin-top-15 zoom-plus btn-img"><img src="/Content/dist/icon-plus-2.png" alt=""></button>\n<button type="button" class="btn btn-primary margin-top-15 zoom-minus btn-img"><img src="/Content/dist/icon-minus-2.png" alt=""></button>\n</div>');
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap.find('.fancybox-outer').after($btn);
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap.find('.fancybox-outer').before($div);
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap.find('img.fancybox-image').draggable();

                    //                    let $div = $(`<div class="btns flex">
                    //<button type="button" class="btn btn-primary zoom-plus"><img src="/Content/dist/icon-plus-2.png" alt="" class="btn-img"></button>
                    //<button type="button" class="btn btn-primary zoom-minus"><img src="/Content/dist/icon-minus-2.png" alt="" class="btn-img"></button>
                    //</div>`);
                    //                    $.fancybox.wrap.find('.fancybox-outer').before($div);
                    //                    $.fancybox.wrap.find('img.fancybox-image').draggable();
                },
                afterClose: function afterClose() {
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.lightzoom').css({ "display": "block" });
                }
            });
        }
    },

    mounted: function mounted() {
        var vm = this;

        vm.imgmixin_lightzoomInit();

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click', '.zoom-plus', function () {
            vm.zoomIn();
        });
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click', '.zoom-minus', function () {
            vm.zoomOut();
        });

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).bind('mousewheel DOMMouseScroll', function (event) {
            if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap != null) {
                if (event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0) {
                    vm.zoomOut();
                } else {
                    vm.zoomIn();
                }
            }
        });
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).unbind('mousewheel DOMMouseScroll');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('click', '.zoom-plus');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('click', '.zoom-minus');
    }
};

/* harmony default export */ __webpack_exports__["a"] = (imgMixin);

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(44);
var global = __webpack_require__(8);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(62) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(46);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(7);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(7);
var aFunction = __webpack_require__(29);
var SPECIES = __webpack_require__(15)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extend;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__has_own_prop__ = __webpack_require__(26);


function extend(a, b) {
    for (var i in b) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__has_own_prop__["a" /* default */])(b, i)) {
            a[i] = b[i];
        }
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_0__has_own_prop__["a" /* default */])(b, 'toString')) {
        a.toString = b.toString;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_0__has_own_prop__["a" /* default */])(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = absFloor;
function absFloor(number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultLocaleWeekdays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return defaultLocaleWeekdaysShort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultLocaleWeekdaysMin; });
/* harmony export (immutable) */ __webpack_exports__["g"] = localeWeekdays;
/* harmony export (immutable) */ __webpack_exports__["j"] = localeWeekdaysShort;
/* harmony export (immutable) */ __webpack_exports__["h"] = localeWeekdaysMin;
/* harmony export (immutable) */ __webpack_exports__["i"] = localeWeekdaysParse;
/* harmony export (immutable) */ __webpack_exports__["d"] = getSetDayOfWeek;
/* harmony export (immutable) */ __webpack_exports__["f"] = getSetLocaleDayOfWeek;
/* harmony export (immutable) */ __webpack_exports__["e"] = getSetISODayOfWeek;
/* harmony export (immutable) */ __webpack_exports__["l"] = weekdaysRegex;
/* harmony export (immutable) */ __webpack_exports__["m"] = weekdaysShortRegex;
/* harmony export (immutable) */ __webpack_exports__["k"] = weekdaysMinRegex;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_format__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aliases__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__priorities__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parse_regex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parse_token__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_to_int__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_is_array__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_index_of__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_has_own_prop__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__create_utc__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__create_parsing_flags__ = __webpack_require__(42);












// FORMATTING

Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('d', 0, 'do', 'day');

Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('e', 0, 0, 'weekday');
Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('E', 0, 0, 'isoWeekday');

// ALIASES

Object(__WEBPACK_IMPORTED_MODULE_1__aliases__["a" /* addUnitAlias */])('day', 'd');
Object(__WEBPACK_IMPORTED_MODULE_1__aliases__["a" /* addUnitAlias */])('weekday', 'e');
Object(__WEBPACK_IMPORTED_MODULE_1__aliases__["a" /* addUnitAlias */])('isoWeekday', 'E');

// PRIORITY
Object(__WEBPACK_IMPORTED_MODULE_2__priorities__["a" /* addUnitPriority */])('day', 11);
Object(__WEBPACK_IMPORTED_MODULE_2__priorities__["a" /* addUnitPriority */])('weekday', 11);
Object(__WEBPACK_IMPORTED_MODULE_2__priorities__["a" /* addUnitPriority */])('isoWeekday', 11);

// PARSING

Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('d', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["d" /* match1to2 */]);
Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('e', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["d" /* match1to2 */]);
Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('E', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["d" /* match1to2 */]);
Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('dd', function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('ddd', function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('dddd', function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

Object(__WEBPACK_IMPORTED_MODULE_4__parse_token__["c" /* addWeekParseToken */])(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        Object(__WEBPACK_IMPORTED_MODULE_10__create_parsing_flags__["a" /* default */])(config).invalidWeekday = input;
    }
});

Object(__WEBPACK_IMPORTED_MODULE_4__parse_token__["c" /* addWeekParseToken */])(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = Object(__WEBPACK_IMPORTED_MODULE_5__utils_to_int__["a" /* default */])(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES
function shiftWeekdays(ws, n) {
    return ws.slice(n, 7).concat(ws.slice(0, n));
}

var defaultLocaleWeekdays =
        'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    defaultWeekdaysRegex = __WEBPACK_IMPORTED_MODULE_3__parse_regex__["s" /* matchWord */],
    defaultWeekdaysShortRegex = __WEBPACK_IMPORTED_MODULE_3__parse_regex__["s" /* matchWord */],
    defaultWeekdaysMinRegex = __WEBPACK_IMPORTED_MODULE_3__parse_regex__["s" /* matchWord */];



function localeWeekdays(m, format) {
    var weekdays = Object(__WEBPACK_IMPORTED_MODULE_6__utils_is_array__["a" /* default */])(this._weekdays)
        ? this._weekdays
        : this._weekdays[
              m && m !== true && this._weekdays.isFormat.test(format)
                  ? 'format'
                  : 'standalone'
          ];
    return m === true
        ? shiftWeekdays(weekdays, this._week.dow)
        : m
        ? weekdays[m.day()]
        : weekdays;
}

function localeWeekdaysShort(m) {
    return m === true
        ? shiftWeekdays(this._weekdaysShort, this._week.dow)
        : m
        ? this._weekdaysShort[m.day()]
        : this._weekdaysShort;
}

function localeWeekdaysMin(m) {
    return m === true
        ? shiftWeekdays(this._weekdaysMin, this._week.dow)
        : m
        ? this._weekdaysMin[m.day()]
        : this._weekdaysMin;
}

function handleStrictParse(weekdayName, format, strict) {
    var i,
        ii,
        mom,
        llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = Object(__WEBPACK_IMPORTED_MODULE_9__create_utc__["a" /* createUTC */])([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(
                mom,
                ''
            ).toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(
                mom,
                ''
            ).toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = __WEBPACK_IMPORTED_MODULE_7__utils_index_of__["a" /* default */].call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = __WEBPACK_IMPORTED_MODULE_7__utils_index_of__["a" /* default */].call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = __WEBPACK_IMPORTED_MODULE_7__utils_index_of__["a" /* default */].call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = __WEBPACK_IMPORTED_MODULE_7__utils_index_of__["a" /* default */].call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = __WEBPACK_IMPORTED_MODULE_7__utils_index_of__["a" /* default */].call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = __WEBPACK_IMPORTED_MODULE_7__utils_index_of__["a" /* default */].call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = __WEBPACK_IMPORTED_MODULE_7__utils_index_of__["a" /* default */].call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = __WEBPACK_IMPORTED_MODULE_7__utils_index_of__["a" /* default */].call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = __WEBPACK_IMPORTED_MODULE_7__utils_index_of__["a" /* default */].call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = __WEBPACK_IMPORTED_MODULE_7__utils_index_of__["a" /* default */].call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = __WEBPACK_IMPORTED_MODULE_7__utils_index_of__["a" /* default */].call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = __WEBPACK_IMPORTED_MODULE_7__utils_index_of__["a" /* default */].call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse(weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = Object(__WEBPACK_IMPORTED_MODULE_9__create_utc__["a" /* createUTC */])([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp(
                '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                'i'
            );
            this._shortWeekdaysParse[i] = new RegExp(
                '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                'i'
            );
            this._minWeekdaysParse[i] = new RegExp(
                '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                'i'
            );
        }
        if (!this._weekdaysParse[i]) {
            regex =
                '^' +
                this.weekdays(mom, '') +
                '|^' +
                this.weekdaysShort(mom, '') +
                '|^' +
                this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (
            strict &&
            format === 'dddd' &&
            this._fullWeekdaysParse[i].test(weekdayName)
        ) {
            return i;
        } else if (
            strict &&
            format === 'ddd' &&
            this._shortWeekdaysParse[i].test(weekdayName)
        ) {
            return i;
        } else if (
            strict &&
            format === 'dd' &&
            this._minWeekdaysParse[i].test(weekdayName)
        ) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek(input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek(input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek(input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

function weekdaysRegex(isStrict) {
    if (this._weekdaysParseExact) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_8__utils_has_own_prop__["a" /* default */])(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!Object(__WEBPACK_IMPORTED_MODULE_8__utils_has_own_prop__["a" /* default */])(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict
            ? this._weekdaysStrictRegex
            : this._weekdaysRegex;
    }
}

function weekdaysShortRegex(isStrict) {
    if (this._weekdaysParseExact) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_8__utils_has_own_prop__["a" /* default */])(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!Object(__WEBPACK_IMPORTED_MODULE_8__utils_has_own_prop__["a" /* default */])(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict
            ? this._weekdaysShortStrictRegex
            : this._weekdaysShortRegex;
    }
}

function weekdaysMinRegex(isStrict) {
    if (this._weekdaysParseExact) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_8__utils_has_own_prop__["a" /* default */])(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!Object(__WEBPACK_IMPORTED_MODULE_8__utils_has_own_prop__["a" /* default */])(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict
            ? this._weekdaysMinStrictRegex
            : this._weekdaysMinRegex;
    }
}

function computeWeekdaysParse() {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [],
        shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom,
        minp,
        shortp,
        longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = Object(__WEBPACK_IMPORTED_MODULE_9__create_utc__["a" /* createUTC */])([2000, 1]).day(i);
        minp = Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["t" /* regexEscape */])(this.weekdaysMin(mom, ''));
        shortp = Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["t" /* regexEscape */])(this.weekdaysShort(mom, ''));
        longp = Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["t" /* regexEscape */])(this.weekdays(mom, ''));
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp(
        '^(' + longPieces.join('|') + ')',
        'i'
    );
    this._weekdaysShortStrictRegex = new RegExp(
        '^(' + shortPieces.join('|') + ')',
        'i'
    );
    this._weekdaysMinStrictRegex = new RegExp(
        '^(' + minPieces.join('|') + ')',
        'i'
    );
}


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cloneWithOffset;
/* harmony export (immutable) */ __webpack_exports__["b"] = getSetOffset;
/* harmony export (immutable) */ __webpack_exports__["c"] = getSetZone;
/* harmony export (immutable) */ __webpack_exports__["l"] = setOffsetToUTC;
/* harmony export (immutable) */ __webpack_exports__["j"] = setOffsetToLocal;
/* harmony export (immutable) */ __webpack_exports__["k"] = setOffsetToParsedOffset;
/* harmony export (immutable) */ __webpack_exports__["d"] = hasAlignedHourOffset;
/* harmony export (immutable) */ __webpack_exports__["e"] = isDaylightSavingTime;
/* harmony export (immutable) */ __webpack_exports__["f"] = isDaylightSavingTimeShifted;
/* harmony export (immutable) */ __webpack_exports__["g"] = isLocal;
/* harmony export (immutable) */ __webpack_exports__["i"] = isUtcOffset;
/* harmony export (immutable) */ __webpack_exports__["h"] = isUtc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_zero_fill__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_create__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__moment_add_subtract__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__moment_constructor__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__format_format__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parse_regex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parse_token__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__create_local__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__create_from_anything__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__create_utc__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_is_date__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_to_int__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_is_undefined__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_compare_arrays__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_hooks__ = __webpack_require__(25);
















// FORMATTING

function offset(token, separator) {
    Object(__WEBPACK_IMPORTED_MODULE_4__format_format__["a" /* addFormatToken */])(token, 0, 0, function () {
        var offset = this.utcOffset(),
            sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return (
            sign +
            Object(__WEBPACK_IMPORTED_MODULE_0__utils_zero_fill__["a" /* default */])(~~(offset / 60), 2) +
            separator +
            Object(__WEBPACK_IMPORTED_MODULE_0__utils_zero_fill__["a" /* default */])(~~offset % 60, 2)
        );
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

Object(__WEBPACK_IMPORTED_MODULE_5__parse_regex__["a" /* addRegexToken */])('Z', __WEBPACK_IMPORTED_MODULE_5__parse_regex__["o" /* matchShortOffset */]);
Object(__WEBPACK_IMPORTED_MODULE_5__parse_regex__["a" /* addRegexToken */])('ZZ', __WEBPACK_IMPORTED_MODULE_5__parse_regex__["o" /* matchShortOffset */]);
Object(__WEBPACK_IMPORTED_MODULE_6__parse_token__["a" /* addParseToken */])(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(__WEBPACK_IMPORTED_MODULE_5__parse_regex__["o" /* matchShortOffset */], input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher),
        chunk,
        parts,
        minutes;

    if (matches === null) {
        return null;
    }

    chunk = matches[matches.length - 1] || [];
    parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    minutes = +(parts[1] * 60) + Object(__WEBPACK_IMPORTED_MODULE_11__utils_to_int__["a" /* default */])(parts[2]);

    return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff =
            (Object(__WEBPACK_IMPORTED_MODULE_3__moment_constructor__["c" /* isMoment */])(input) || Object(__WEBPACK_IMPORTED_MODULE_10__utils_is_date__["a" /* default */])(input)
                ? input.valueOf()
                : Object(__WEBPACK_IMPORTED_MODULE_7__create_local__["a" /* createLocal */])(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        __WEBPACK_IMPORTED_MODULE_14__utils_hooks__["a" /* hooks */].updateOffset(res, false);
        return res;
    } else {
        return Object(__WEBPACK_IMPORTED_MODULE_7__create_local__["a" /* createLocal */])(input).local();
    }
}

function getDateOffset(m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset());
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
__WEBPACK_IMPORTED_MODULE_14__utils_hooks__["a" /* hooks */].updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset(input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(__WEBPACK_IMPORTED_MODULE_5__parse_regex__["o" /* matchShortOffset */], input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                Object(__WEBPACK_IMPORTED_MODULE_2__moment_add_subtract__["b" /* addSubtract */])(
                    this,
                    Object(__WEBPACK_IMPORTED_MODULE_1__duration_create__["a" /* createDuration */])(input - offset, 'm'),
                    1,
                    false
                );
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                __WEBPACK_IMPORTED_MODULE_14__utils_hooks__["a" /* hooks */].updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone(input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC(keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal(keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset() {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(__WEBPACK_IMPORTED_MODULE_5__parse_regex__["n" /* matchOffset */], this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        } else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset(input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? Object(__WEBPACK_IMPORTED_MODULE_7__create_local__["a" /* createLocal */])(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime() {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted() {
    if (!Object(__WEBPACK_IMPORTED_MODULE_12__utils_is_undefined__["a" /* default */])(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {},
        other;

    Object(__WEBPACK_IMPORTED_MODULE_3__moment_constructor__["b" /* copyConfig */])(c, this);
    c = Object(__WEBPACK_IMPORTED_MODULE_8__create_from_anything__["b" /* prepareConfig */])(c);

    if (c._a) {
        other = c._isUTC ? Object(__WEBPACK_IMPORTED_MODULE_9__create_utc__["a" /* createUTC */])(c._a) : Object(__WEBPACK_IMPORTED_MODULE_7__create_local__["a" /* createLocal */])(c._a);
        this._isDSTShifted =
            this.isValid() && Object(__WEBPACK_IMPORTED_MODULE_13__utils_compare_arrays__["a" /* default */])(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal() {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset() {
    return this.isValid() ? this._isUTC : false;
}

function isUtc() {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(38);
var toLength = __webpack_require__(16);
var toAbsoluteIndex = __webpack_require__(71);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 101 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(46);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(47);
var defined = __webpack_require__(51);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(11);
var cof = __webpack_require__(46);
var MATCH = __webpack_require__(15)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(15)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(83);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(187);
var redefine = __webpack_require__(33);
var hide = __webpack_require__(32);
var fails = __webpack_require__(10);
var defined = __webpack_require__(51);
var wks = __webpack_require__(15);
var regexpExec = __webpack_require__(148);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(8);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(33);
var redefineAll = __webpack_require__(77);
var meta = __webpack_require__(63);
var forOf = __webpack_require__(76);
var anInstance = __webpack_require__(75);
var isObject = __webpack_require__(11);
var fails = __webpack_require__(10);
var $iterDetect = __webpack_require__(105);
var setToStringTag = __webpack_require__(82);
var inheritIfRequired = __webpack_require__(134);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var hide = __webpack_require__(32);
var uid = __webpack_require__(69);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(62) || !__webpack_require__(10)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(8)[K];
});


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(29);
var ctx = __webpack_require__(45);
var forOf = __webpack_require__(76);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(9);


var commonMixin = {

    methods: {
        onShowModal: function onShowModal(modal) {
            var _this = this;

            this.$nextTick(function () {
                _this.$refs[modal].show();
            });
        },
        closeModal: function closeModal(modal) {
            var _this2 = this;

            this.$nextTick(function () {
                _this2.$refs[modal].close();
            });
        },
        formatDate: function formatDate(date) {
            var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD.MM.YYYY';

            if (date == undefined) return '';

            var d = Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(date);
            if (d.isValid()) {
                return d.format(format);
            } else {
                return '';
            }
        },
        formatDateFromUtcToLocal: function formatDateFromUtcToLocal(date) {
            var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD.MM.YYYY';

            if (date == undefined) return '';

            var d = __WEBPACK_IMPORTED_MODULE_0_moment__["default"].utc(date);
            if (d.isValid()) {
                return d.local().format(format);
            } else {
                return '';
            }
        },
        formatDateLong: function formatDateLong(date) {
            var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD.MM.YYYY HH:mm';

            if (date == undefined) return '';

            var d = Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(date);
            if (d.isValid()) {
                return d.format(format);
            } else {
                return '';
            }
        },


        /**
         * добавляет десятичный разделитель (пробел) в int значение
         * @param val
         * @returns {string}
         */
        formatInt: function formatInt(val) {
            return ('' + val).replace(/(\d)(?=(\d\d\d)+([^\d]|$|\.))/g, '$1 ');
        },

        //текущий месяц на русском
        currentMonth: function currentMonth() {
            var v = new Date().toLocaleString('ru', {
                year: 'numeric',
                month: 'long'
            });
            v = v.replace(' г.', '');
            v = v.charAt(0).toUpperCase() + v.substr(1);
            return v;
        },

        /**
         * замена разметки html элементами
         * @param val
         * @returns {string}
         */
        formatMarkdownLiteToHtml: function formatMarkdownLiteToHtml(val) {
            return (val + '').replace(/(\*\*)([^\*]+)(\*\*)/ig, '<b>$2</b>').replace(/(\-\-)([^\-]+)(\-\-)/ig, '<p class="p-header-1 margin-top-20">$2</p>').replace(/(<\/p>)([^<]+)((<p class="p-header-1 margin-top-20">)|$)/ig, '$1<p class="caption-help">$2</p>$3');
        },


        //окончание текста с учетом количества
        get_text_ending: function get_text_ending(int, endArr) {
            //int - число для которого подбирается концовка
            //endArr - 3 варианта концовки, для 1, для 2-4, для 5-9 и 11-19
            var sEnding = void 0;
            int = int % 100;
            if (int >= 11 && int <= 19) {
                sEnding = endArr[2];
            } else {
                var i = int % 10;
                switch (i) {
                    case 1:
                        sEnding = endArr[0];
                        break;
                    case 2:
                    case 3:
                    case 4:
                        sEnding = endArr[1];
                        break;
                    default:
                        sEnding = endArr[2];
                        break;
                }
            }
            return sEnding;
        },

        /**
         * уникальный идентификатор вида a837179b-05d6-4dfb-bc6c-8aa5c3bfd8bd
         * https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
         */
        generateGuid: function generateGuid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0,
                    v = c === 'x' ? r : r & 0x3 | 0x8;
                return v.toString(16);
            });
        },

        getPageTitle: function getPageTitle(path) {
            if (!path) {
                path = this.$route.path;
            }
            var title = void 0;
            if (this.info && this.info.Pages && this.info.Pages.find(function (x) {
                return x.Path === path;
            })) {
                title = this.info.Pages.find(function (x) {
                    return x.Path === path;
                }).Name;
            }

            if (!title) {
                switch (path) {
                    case '/':
                    case '/news':
                        title = 'Новости';
                        break;
                    case '/reports/0':
                    case '/reports/fns/0':
                        title = 'Новый отчёт';
                        break;
                    case '/materials':
                        title = 'Материалы';
                        break;
                    case '/sku':
                        title = 'SKU';
                        break;
                    case '/spend-bonuses':
                        title = 'Потратить бонусы';
                        break;
                    case '/cart':
                        title = 'Корзина';
                        break;
                    case '/rating':
                        title = 'Рейтинг';
                        break;
                    case '/analytics':
                        title = 'Аналитика';
                        break;
                    case '/faq':
                        title = 'Faq';
                        break;
                    case '/motivation':
                        title = 'Мотивация';
                        break;
                    case '/reports':
                        title = 'Отчёты';
                        break;
                    case '/orders':
                        title = 'Заказы';
                        break;
                    case '/sender':
                        title = 'Рассылка';
                        break;
                    case '/tasks':
                    case '/tasks/table':
                        title = 'Задания';
                        break;
                }
            }

            return title;
        },

        CommonMixin_UsersProcessFilter: function CommonMixin_UsersProcessFilter(filter) {
            if (!filter) {
                return null;
            }
            var filterCopy = JSON.parse(JSON.stringify(filter));
            var stateEnums = {
                '[dbo].[AspNetUsers].[TermsConfirmed]': {
                    'Да': 1,
                    'Нет': 0
                },
                '[dbo].[AspNetUsers].[PersonalDataEditingAccept]': {
                    'Да': 1,
                    'Нет': 0
                },
                '[dbo].[AspNetUsers].[NotificationsEnabled]': {
                    'Да': 1,
                    'Нет': 0
                },
                '[dbo].[AspNetUsers].[PassportVerificationState]': {
                    'документы отсутствуют': 0,
                    'проверь документы!': 1,
                    'документы подтверждены': 2,
                    'документы возвращены': 3
                },
                '[dbo].[AspNetUsers].[RegisterStatus]': {
                    'неактивен': 0,
                    'проверка': 1,
                    'активен': 2,
                    'отказано': 3,
                    'отключен': 4,
                    'заблокирован': 5
                }
            };

            var resultFilter = [];

            var _loop = function _loop(item) {
                var filterField = item[0];
                var dontPushItem = false;
                if (filterField === '[dbo].[AspNetUsers].[TermsConfirmed]' || filterField === '[dbo].[AspNetUsers].[PersonalDataEditingAccept]' || filterField === '[dbo].[AspNetUsers].[NotificationsEnabled]' || filterField === '[dbo].[AspNetUsers].[PassportVerificationState]' || filterField === '[dbo].[AspNetUsers].[RegisterStatus]') {

                    var values = item[2].substring(1, item[2].length - 1).split(';').map(function (x) {
                        return decodeURI(x);
                    }).map(function (x) {
                        var name = x.substring(1, x.length - 1);
                        var state = stateEnums[filterField][name];
                        return state;
                    });

                    if (filterField === '[dbo].[AspNetUsers].[TermsConfirmed]' || filterField === '[dbo].[AspNetUsers].[PersonalDataEditingAccept]' || filterField === '[dbo].[AspNetUsers].[NotificationsEnabled]' || filterField === '[dbo].[AspNetUsers].[PassportVerificationState]' || filterField === '[dbo].[AspNetUsers].[RegisterStatus]') {

                        item[0] = 'isnull(' + filterField + '%comma%0)';

                        if (filterField === '[dbo].[AspNetUsers].[RegisterStatus]') {
                            var dateFilters = values.filter(function (x) {
                                return x === 4 || x === 5 || x === 2;
                            });
                            var statusFilters = values.filter(function (x) {
                                return x !== 4 && x !== 5 && x !== 2;
                            });

                            var dateFilterPart = '';
                            if (dateFilters.length) {
                                if (values.indexOf(4) > -1 && values.indexOf(5) === -1) {
                                    // только Отключен
                                    dateFilterPart = '[dbo].[AspNetUsers].[DisabledDateTime] <= getdate() and ([dbo].[AspNetUsers].[BlockedDateTime] is null or [dbo].[AspNetUsers].[BlockedDateTime] > getdate())';
                                }
                                if (values.indexOf(5) > -1 && values.indexOf(4) === -1) {
                                    // только Заблокирован
                                    dateFilterPart = '[dbo].[AspNetUsers].[BlockedDateTime] <= getdate()';
                                }
                                if (values.indexOf(5) > -1 && values.indexOf(4) > -1) {
                                    // оба фильтра
                                    dateFilterPart = '([dbo].[AspNetUsers].[DisabledDateTime] <= getdate() or [dbo].[AspNetUsers].[BlockedDateTime] <= getdate())';
                                }

                                // если есть фильтр "Активен"
                                if (values.indexOf(2) > -1) {
                                    if (dateFilterPart) {
                                        // если уже указаны фильтры Заблокирован или Отключен
                                        dateFilterPart = '( (' + dateFilterPart + ') or [dbo].[AspNetUsers].[RegisterStatus] = 2' + ')';
                                    } else {
                                        // только фильтр Активен
                                        dateFilterPart = '[dbo].[AspNetUsers].[RegisterStatus] = 2 and ([dbo].[AspNetUsers].[BlockedDateTime] is null or [dbo].[AspNetUsers].[BlockedDateTime] > getdate())' + 'and ([dbo].[AspNetUsers].[DisabledDateTime] is null or [dbo].[AspNetUsers].[DisabledDateTime] > getdate())';
                                    }
                                }
                            }

                            if (statusFilters.length) {
                                item[2] = '(' + values.filter(function (x) {
                                    return x !== 4 && x !== 5 && x !== 2;
                                }).map(function (item) {
                                    return '' + encodeURI(item);
                                }).join(';') + ')';
                            } else {
                                dontPushItem = true;
                            }

                            if (dateFilters.length && !statusFilters.length) {
                                resultFilter.push(['', '', dateFilterPart]);
                            }

                            if (dateFilters.length && statusFilters.length) {
                                dontPushItem = true;

                                resultFilter.push(['', '', '(' + item.join(' ') + ' or ' + dateFilterPart + ')']);
                            }
                        } else {
                            item[2] = '(' + values.map(function (item) {
                                return '' + encodeURI(item);
                            }).join(';') + ')';
                        }
                    } else {
                        item[2] = '(' + values.map(function (item) {
                            return '\'' + encodeURI(item) + '\'';
                        }).join(';') + ')';
                    }
                }

                if (filterField === '[dbo].[AspNetUsers].[UserRole]') {
                    item[0] = '[dbo].[DynamicRole]';
                }

                if (!dontPushItem) {
                    resultFilter.push(item);
                }
            };

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = filterCopy[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    _loop(item);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return resultFilter;
        },

        getUrlParameter: function getUrlParameter(sParam) {
            var sPageURL = decodeURIComponent(window.location.search.substring(1)),
                sURLVariables = sPageURL.split('&'),
                sParameterName,
                i;

            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split('=');

                if (sParameterName[0] === sParam) {
                    return sParameterName[1] === undefined ? true : sParameterName[1];
                }
            }
        },

        CommonMixin_doubleRequestAnimationFrame: function CommonMixin_doubleRequestAnimationFrame(callback) {
            requestAnimationFrame(function () {
                requestAnimationFrame(callback);
            });
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (commonMixin);

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isObject;
function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return (
        input != null &&
        Object.prototype.toString.call(input) === '[object Object]'
    );
}


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isUndefined;
function isUndefined(input) {
    return input === void 0;
}


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isDate;
function isDate(input) {
    return (
        input instanceof Date ||
        Object.prototype.toString.call(input) === '[object Date]'
    );
}


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = zeroFill;
function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (
        (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
        absNumber
    );
}


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = localeWeek;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultLocaleWeek; });
/* harmony export (immutable) */ __webpack_exports__["d"] = localeFirstDayOfWeek;
/* harmony export (immutable) */ __webpack_exports__["e"] = localeFirstDayOfYear;
/* harmony export (immutable) */ __webpack_exports__["c"] = getSetWeek;
/* harmony export (immutable) */ __webpack_exports__["b"] = getSetISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_format__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aliases__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__priorities__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parse_regex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parse_token__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_to_int__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__week_calendar_utils__ = __webpack_require__(160);








// FORMATTING

Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('w', ['ww', 2], 'wo', 'week');
Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

Object(__WEBPACK_IMPORTED_MODULE_1__aliases__["a" /* addUnitAlias */])('week', 'w');
Object(__WEBPACK_IMPORTED_MODULE_1__aliases__["a" /* addUnitAlias */])('isoWeek', 'W');

// PRIORITIES

Object(__WEBPACK_IMPORTED_MODULE_2__priorities__["a" /* addUnitPriority */])('week', 5);
Object(__WEBPACK_IMPORTED_MODULE_2__priorities__["a" /* addUnitPriority */])('isoWeek', 5);

// PARSING

Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('w', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["d" /* match1to2 */]);
Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('ww', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["d" /* match1to2 */], __WEBPACK_IMPORTED_MODULE_3__parse_regex__["h" /* match2 */]);
Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('W', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["d" /* match1to2 */]);
Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('WW', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["d" /* match1to2 */], __WEBPACK_IMPORTED_MODULE_3__parse_regex__["h" /* match2 */]);

Object(__WEBPACK_IMPORTED_MODULE_4__parse_token__["c" /* addWeekParseToken */])(
    ['w', 'ww', 'W', 'WW'],
    function (input, week, config, token) {
        week[token.substr(0, 1)] = Object(__WEBPACK_IMPORTED_MODULE_5__utils_to_int__["a" /* default */])(input);
    }
);

// HELPERS

// LOCALES

function localeWeek(mom) {
    return Object(__WEBPACK_IMPORTED_MODULE_6__week_calendar_utils__["b" /* weekOfYear */])(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow: 0, // Sunday is the first day of the week.
    doy: 6, // The week that contains Jan 6th is the first week of the year.
};

function localeFirstDayOfWeek() {
    return this._week.dow;
}

function localeFirstDayOfYear() {
    return this._week.doy;
}

// MOMENTS

function getSetWeek(input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek(input) {
    var week = Object(__WEBPACK_IMPORTED_MODULE_6__week_calendar_utils__["b" /* weekOfYear */])(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = daysInYear;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSetYear; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getIsLeapYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__moment_get_set__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__format_format__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aliases__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__priorities__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parse_regex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parse_token__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_is_leap_year__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_hooks__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_to_int__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_zero_fill__ = __webpack_require__(118);
/* unused harmony reexport isLeapYear */












// FORMATTING

Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_zero_fill__["a" /* default */])(y, 4) : '+' + y;
});

Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])(0, ['YYYY', 4], 0, 'year');
Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])(0, ['YYYYY', 5], 0, 'year');
Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

Object(__WEBPACK_IMPORTED_MODULE_2__aliases__["a" /* addUnitAlias */])('year', 'y');

// PRIORITIES

Object(__WEBPACK_IMPORTED_MODULE_3__priorities__["a" /* addUnitPriority */])('year', 1);

// PARSING

Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('Y', __WEBPACK_IMPORTED_MODULE_4__parse_regex__["p" /* matchSigned */]);
Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('YY', __WEBPACK_IMPORTED_MODULE_4__parse_regex__["d" /* match1to2 */], __WEBPACK_IMPORTED_MODULE_4__parse_regex__["h" /* match2 */]);
Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('YYYY', __WEBPACK_IMPORTED_MODULE_4__parse_regex__["f" /* match1to4 */], __WEBPACK_IMPORTED_MODULE_4__parse_regex__["k" /* match4 */]);
Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('YYYYY', __WEBPACK_IMPORTED_MODULE_4__parse_regex__["g" /* match1to6 */], __WEBPACK_IMPORTED_MODULE_4__parse_regex__["m" /* match6 */]);
Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('YYYYYY', __WEBPACK_IMPORTED_MODULE_4__parse_regex__["g" /* match1to6 */], __WEBPACK_IMPORTED_MODULE_4__parse_regex__["m" /* match6 */]);

Object(__WEBPACK_IMPORTED_MODULE_5__parse_token__["a" /* addParseToken */])(['YYYYY', 'YYYYYY'], __WEBPACK_IMPORTED_MODULE_8__constants__["i" /* YEAR */]);
Object(__WEBPACK_IMPORTED_MODULE_5__parse_token__["a" /* addParseToken */])('YYYY', function (input, array) {
    array[__WEBPACK_IMPORTED_MODULE_8__constants__["i" /* YEAR */]] =
        input.length === 2 ? __WEBPACK_IMPORTED_MODULE_7__utils_hooks__["a" /* hooks */].parseTwoDigitYear(input) : Object(__WEBPACK_IMPORTED_MODULE_9__utils_to_int__["a" /* default */])(input);
});
Object(__WEBPACK_IMPORTED_MODULE_5__parse_token__["a" /* addParseToken */])('YY', function (input, array) {
    array[__WEBPACK_IMPORTED_MODULE_8__constants__["i" /* YEAR */]] = __WEBPACK_IMPORTED_MODULE_7__utils_hooks__["a" /* hooks */].parseTwoDigitYear(input);
});
Object(__WEBPACK_IMPORTED_MODULE_5__parse_token__["a" /* addParseToken */])('Y', function (input, array) {
    array[__WEBPACK_IMPORTED_MODULE_8__constants__["i" /* YEAR */]] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return Object(__WEBPACK_IMPORTED_MODULE_6__utils_is_leap_year__["a" /* isLeapYear */])(year) ? 366 : 365;
}



// HOOKS

__WEBPACK_IMPORTED_MODULE_7__utils_hooks__["a" /* hooks */].parseTwoDigitYear = function (input) {
    return Object(__WEBPACK_IMPORTED_MODULE_9__utils_to_int__["a" /* default */])(input) + (Object(__WEBPACK_IMPORTED_MODULE_9__utils_to_int__["a" /* default */])(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = Object(__WEBPACK_IMPORTED_MODULE_0__moment_get_set__["b" /* makeGetSet */])('FullYear', true);

function getIsLeapYear() {
    return Object(__WEBPACK_IMPORTED_MODULE_6__utils_is_leap_year__["a" /* isLeapYear */])(this.year());
}


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createDate;
/* harmony export (immutable) */ __webpack_exports__["b"] = createUTCDate;
function createDate(y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date;
    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        date = new Date(y + 400, m, d, h, M, s, ms);
        if (isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
    } else {
        date = new Date(y, m, d, h, M, s, ms);
    }

    return date;
}

function createUTCDate(y) {
    var date, args;
    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
        args = Array.prototype.slice.call(arguments);
        // preserve leap years using a full 400 year cycle, then reset
        args[0] = y + 400;
        date = new Date(Date.UTC.apply(null, args));
        if (isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
    } else {
        date = new Date(Date.UTC.apply(null, arguments));
    }

    return date;
}


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = localeIsPM;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultLocaleMeridiemParse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSetHour; });
/* harmony export (immutable) */ __webpack_exports__["d"] = localeMeridiem;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__moment_get_set__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__format_format__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aliases__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__priorities__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parse_regex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parse_token__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_to_int__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_zero_fill__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__create_parsing_flags__ = __webpack_require__(42);











// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])('H', ['HH', 2], 0, 'hour');
Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])('h', ['hh', 2], 0, hFormat);
Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])('k', ['kk', 2], 0, kFormat);

Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + Object(__WEBPACK_IMPORTED_MODULE_8__utils_zero_fill__["a" /* default */])(this.minutes(), 2);
});

Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])('hmmss', 0, 0, function () {
    return (
        '' +
        hFormat.apply(this) +
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_zero_fill__["a" /* default */])(this.minutes(), 2) +
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_zero_fill__["a" /* default */])(this.seconds(), 2)
    );
});

Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])('Hmm', 0, 0, function () {
    return '' + this.hours() + Object(__WEBPACK_IMPORTED_MODULE_8__utils_zero_fill__["a" /* default */])(this.minutes(), 2);
});

Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])('Hmmss', 0, 0, function () {
    return (
        '' +
        this.hours() +
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_zero_fill__["a" /* default */])(this.minutes(), 2) +
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_zero_fill__["a" /* default */])(this.seconds(), 2)
    );
});

function meridiem(token, lowercase) {
    Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])(token, 0, 0, function () {
        return this.localeData().meridiem(
            this.hours(),
            this.minutes(),
            lowercase
        );
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

Object(__WEBPACK_IMPORTED_MODULE_2__aliases__["a" /* addUnitAlias */])('hour', 'h');

// PRIORITY
Object(__WEBPACK_IMPORTED_MODULE_3__priorities__["a" /* addUnitPriority */])('hour', 13);

// PARSING

function matchMeridiem(isStrict, locale) {
    return locale._meridiemParse;
}

Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('a', matchMeridiem);
Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('A', matchMeridiem);
Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('H', __WEBPACK_IMPORTED_MODULE_4__parse_regex__["d" /* match1to2 */]);
Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('h', __WEBPACK_IMPORTED_MODULE_4__parse_regex__["d" /* match1to2 */]);
Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('k', __WEBPACK_IMPORTED_MODULE_4__parse_regex__["d" /* match1to2 */]);
Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('HH', __WEBPACK_IMPORTED_MODULE_4__parse_regex__["d" /* match1to2 */], __WEBPACK_IMPORTED_MODULE_4__parse_regex__["h" /* match2 */]);
Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('hh', __WEBPACK_IMPORTED_MODULE_4__parse_regex__["d" /* match1to2 */], __WEBPACK_IMPORTED_MODULE_4__parse_regex__["h" /* match2 */]);
Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('kk', __WEBPACK_IMPORTED_MODULE_4__parse_regex__["d" /* match1to2 */], __WEBPACK_IMPORTED_MODULE_4__parse_regex__["h" /* match2 */]);

Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('hmm', __WEBPACK_IMPORTED_MODULE_4__parse_regex__["j" /* match3to4 */]);
Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('hmmss', __WEBPACK_IMPORTED_MODULE_4__parse_regex__["l" /* match5to6 */]);
Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('Hmm', __WEBPACK_IMPORTED_MODULE_4__parse_regex__["j" /* match3to4 */]);
Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('Hmmss', __WEBPACK_IMPORTED_MODULE_4__parse_regex__["l" /* match5to6 */]);

Object(__WEBPACK_IMPORTED_MODULE_5__parse_token__["a" /* addParseToken */])(['H', 'HH'], __WEBPACK_IMPORTED_MODULE_6__constants__["b" /* HOUR */]);
Object(__WEBPACK_IMPORTED_MODULE_5__parse_token__["a" /* addParseToken */])(['k', 'kk'], function (input, array, config) {
    var kInput = Object(__WEBPACK_IMPORTED_MODULE_7__utils_to_int__["a" /* default */])(input);
    array[__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* HOUR */]] = kInput === 24 ? 0 : kInput;
});
Object(__WEBPACK_IMPORTED_MODULE_5__parse_token__["a" /* addParseToken */])(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
Object(__WEBPACK_IMPORTED_MODULE_5__parse_token__["a" /* addParseToken */])(['h', 'hh'], function (input, array, config) {
    array[__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* HOUR */]] = Object(__WEBPACK_IMPORTED_MODULE_7__utils_to_int__["a" /* default */])(input);
    Object(__WEBPACK_IMPORTED_MODULE_9__create_parsing_flags__["a" /* default */])(config).bigHour = true;
});
Object(__WEBPACK_IMPORTED_MODULE_5__parse_token__["a" /* addParseToken */])('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* HOUR */]] = Object(__WEBPACK_IMPORTED_MODULE_7__utils_to_int__["a" /* default */])(input.substr(0, pos));
    array[__WEBPACK_IMPORTED_MODULE_6__constants__["d" /* MINUTE */]] = Object(__WEBPACK_IMPORTED_MODULE_7__utils_to_int__["a" /* default */])(input.substr(pos));
    Object(__WEBPACK_IMPORTED_MODULE_9__create_parsing_flags__["a" /* default */])(config).bigHour = true;
});
Object(__WEBPACK_IMPORTED_MODULE_5__parse_token__["a" /* addParseToken */])('hmmss', function (input, array, config) {
    var pos1 = input.length - 4,
        pos2 = input.length - 2;
    array[__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* HOUR */]] = Object(__WEBPACK_IMPORTED_MODULE_7__utils_to_int__["a" /* default */])(input.substr(0, pos1));
    array[__WEBPACK_IMPORTED_MODULE_6__constants__["d" /* MINUTE */]] = Object(__WEBPACK_IMPORTED_MODULE_7__utils_to_int__["a" /* default */])(input.substr(pos1, 2));
    array[__WEBPACK_IMPORTED_MODULE_6__constants__["f" /* SECOND */]] = Object(__WEBPACK_IMPORTED_MODULE_7__utils_to_int__["a" /* default */])(input.substr(pos2));
    Object(__WEBPACK_IMPORTED_MODULE_9__create_parsing_flags__["a" /* default */])(config).bigHour = true;
});
Object(__WEBPACK_IMPORTED_MODULE_5__parse_token__["a" /* addParseToken */])('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* HOUR */]] = Object(__WEBPACK_IMPORTED_MODULE_7__utils_to_int__["a" /* default */])(input.substr(0, pos));
    array[__WEBPACK_IMPORTED_MODULE_6__constants__["d" /* MINUTE */]] = Object(__WEBPACK_IMPORTED_MODULE_7__utils_to_int__["a" /* default */])(input.substr(pos));
});
Object(__WEBPACK_IMPORTED_MODULE_5__parse_token__["a" /* addParseToken */])('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4,
        pos2 = input.length - 2;
    array[__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* HOUR */]] = Object(__WEBPACK_IMPORTED_MODULE_7__utils_to_int__["a" /* default */])(input.substr(0, pos1));
    array[__WEBPACK_IMPORTED_MODULE_6__constants__["d" /* MINUTE */]] = Object(__WEBPACK_IMPORTED_MODULE_7__utils_to_int__["a" /* default */])(input.substr(pos1, 2));
    array[__WEBPACK_IMPORTED_MODULE_6__constants__["f" /* SECOND */]] = Object(__WEBPACK_IMPORTED_MODULE_7__utils_to_int__["a" /* default */])(input.substr(pos2));
});

// LOCALES

function localeIsPM(input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return (input + '').toLowerCase().charAt(0) === 'p';
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = Object(__WEBPACK_IMPORTED_MODULE_0__moment_get_set__["b" /* makeGetSet */])('Hours', true);

function localeMeridiem(hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! DataTables 1.10.13
 * ©2008-2016 SpryMedia Ltd - datatables.net/license
 */

/**
 * @summary     DataTables
 * @description Paginate, search and order HTML tables
 * @version     1.10.13
 * @file        jquery.dataTables.js
 * @author      SpryMedia Ltd
 * @contact     www.datatables.net
 * @copyright   Copyright 2008-2016 SpryMedia Ltd.
 *
 * This source file is free software, available under the following license:
 *   MIT license - http://datatables.net/license
 *
 * This source file is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE. See the license files for details.
 *
 * For details please refer to: http://www.datatables.net
 */

/*jslint evil: true, undef: true, browser: true */
/*globals $,require,jQuery,define,_selector_run,_selector_opts,_selector_first,_selector_row_indexes,_ext,_Api,_api_register,_api_registerPlural,_re_new_lines,_re_html,_re_formatted_numeric,_re_escape_regex,_empty,_intVal,_numToDecimal,_isNumber,_isHtml,_htmlNumeric,_pluck,_pluck_order,_range,_stripHtml,_unique,_fnBuildAjax,_fnAjaxUpdate,_fnAjaxParameters,_fnAjaxUpdateDraw,_fnAjaxDataSrc,_fnAddColumn,_fnColumnOptions,_fnAdjustColumnSizing,_fnVisibleToColumnIndex,_fnColumnIndexToVisible,_fnVisbleColumns,_fnGetColumns,_fnColumnTypes,_fnApplyColumnDefs,_fnHungarianMap,_fnCamelToHungarian,_fnLanguageCompat,_fnBrowserDetect,_fnAddData,_fnAddTr,_fnNodeToDataIndex,_fnNodeToColumnIndex,_fnGetCellData,_fnSetCellData,_fnSplitObjNotation,_fnGetObjectDataFn,_fnSetObjectDataFn,_fnGetDataMaster,_fnClearTable,_fnDeleteIndex,_fnInvalidate,_fnGetRowElements,_fnCreateTr,_fnBuildHead,_fnDrawHead,_fnDraw,_fnReDraw,_fnAddOptionsHtml,_fnDetectHeader,_fnGetUniqueThs,_fnFeatureHtmlFilter,_fnFilterComplete,_fnFilterCustom,_fnFilterColumn,_fnFilter,_fnFilterCreateSearch,_fnEscapeRegex,_fnFilterData,_fnFeatureHtmlInfo,_fnUpdateInfo,_fnInfoMacros,_fnInitialise,_fnInitComplete,_fnLengthChange,_fnFeatureHtmlLength,_fnFeatureHtmlPaginate,_fnPageChange,_fnFeatureHtmlProcessing,_fnProcessingDisplay,_fnFeatureHtmlTable,_fnScrollDraw,_fnApplyToChildren,_fnCalculateColumnWidths,_fnThrottle,_fnConvertToWidth,_fnGetWidestNode,_fnGetMaxLenString,_fnStringToCss,_fnSortFlatten,_fnSort,_fnSortAria,_fnSortListener,_fnSortAttachListener,_fnSortingClasses,_fnSortData,_fnSaveState,_fnLoadState,_fnSettingsFromNode,_fnLog,_fnMap,_fnBindAction,_fnCallbackReg,_fnCallbackFire,_fnLengthOverflow,_fnRenderer,_fnDataSource,_fnRowAttributes*/

(function( factory ) {
	"use strict";

	if ( true ) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function ( $ ) {
			return factory( $, window, document );
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				// CommonJS environments without a window global must pass a
				// root. This will give an error otherwise
				root = window;
			}

			if ( ! $ ) {
				$ = typeof window !== 'undefined' ? // jQuery's factory checks for a global window
					require('jquery') :
					require('jquery')( root );
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}
(function( $, window, document, undefined ) {
	"use strict";

	/**
	 * DataTables is a plug-in for the jQuery Javascript library. It is a highly
	 * flexible tool, based upon the foundations of progressive enhancement,
	 * which will add advanced interaction controls to any HTML table. For a
	 * full list of features please refer to
	 * [DataTables.net](href="http://datatables.net).
	 *
	 * Note that the `DataTable` object is not a global variable but is aliased
	 * to `jQuery.fn.DataTable` and `jQuery.fn.dataTable` through which it may
	 * be  accessed.
	 *
	 *  @class
	 *  @param {object} [init={}] Configuration object for DataTables. Options
	 *    are defined by {@link DataTable.defaults}
	 *  @requires jQuery 1.7+
	 *
	 *  @example
	 *    // Basic initialisation
	 *    $(document).ready( function {
	 *      $('#example').dataTable();
	 *    } );
	 *
	 *  @example
	 *    // Initialisation with configuration options - in this case, disable
	 *    // pagination and sorting.
	 *    $(document).ready( function {
	 *      $('#example').dataTable( {
	 *        "paginate": false,
	 *        "sort": false
	 *      } );
	 *    } );
	 */
	var DataTable = function ( options )
	{
		/**
		 * Perform a jQuery selector action on the table's TR elements (from the tbody) and
		 * return the resulting jQuery object.
		 *  @param {string|node|jQuery} sSelector jQuery selector or node collection to act on
		 *  @param {object} [oOpts] Optional parameters for modifying the rows to be included
		 *  @param {string} [oOpts.filter=none] Select TR elements that meet the current filter
		 *    criterion ("applied") or all TR elements (i.e. no filter).
		 *  @param {string} [oOpts.order=current] Order of the TR elements in the processed array.
		 *    Can be either 'current', whereby the current sorting of the table is used, or
		 *    'original' whereby the original order the data was read into the table is used.
		 *  @param {string} [oOpts.page=all] Limit the selection to the currently displayed page
		 *    ("current") or not ("all"). If 'current' is given, then order is assumed to be
		 *    'current' and filter is 'applied', regardless of what they might be given as.
		 *  @returns {object} jQuery object, filtered by the given selector.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Highlight every second row
		 *      oTable.$('tr:odd').css('backgroundColor', 'blue');
		 *    } );
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Filter to rows with 'Webkit' in them, add a background colour and then
		 *      // remove the filter, thus highlighting the 'Webkit' rows only.
		 *      oTable.fnFilter('Webkit');
		 *      oTable.$('tr', {"search": "applied"}).css('backgroundColor', 'blue');
		 *      oTable.fnFilter('');
		 *    } );
		 */
		this.$ = function ( sSelector, oOpts )
		{
			return this.api(true).$( sSelector, oOpts );
		};
		
		
		/**
		 * Almost identical to $ in operation, but in this case returns the data for the matched
		 * rows - as such, the jQuery selector used should match TR row nodes or TD/TH cell nodes
		 * rather than any descendants, so the data can be obtained for the row/cell. If matching
		 * rows are found, the data returned is the original data array/object that was used to
		 * create the row (or a generated array if from a DOM source).
		 *
		 * This method is often useful in-combination with $ where both functions are given the
		 * same parameters and the array indexes will match identically.
		 *  @param {string|node|jQuery} sSelector jQuery selector or node collection to act on
		 *  @param {object} [oOpts] Optional parameters for modifying the rows to be included
		 *  @param {string} [oOpts.filter=none] Select elements that meet the current filter
		 *    criterion ("applied") or all elements (i.e. no filter).
		 *  @param {string} [oOpts.order=current] Order of the data in the processed array.
		 *    Can be either 'current', whereby the current sorting of the table is used, or
		 *    'original' whereby the original order the data was read into the table is used.
		 *  @param {string} [oOpts.page=all] Limit the selection to the currently displayed page
		 *    ("current") or not ("all"). If 'current' is given, then order is assumed to be
		 *    'current' and filter is 'applied', regardless of what they might be given as.
		 *  @returns {array} Data for the matched elements. If any elements, as a result of the
		 *    selector, were not TR, TD or TH elements in the DataTable, they will have a null
		 *    entry in the array.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Get the data from the first row in the table
		 *      var data = oTable._('tr:first');
		 *
		 *      // Do something useful with the data
		 *      alert( "First cell is: "+data[0] );
		 *    } );
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Filter to 'Webkit' and get all data for
		 *      oTable.fnFilter('Webkit');
		 *      var data = oTable._('tr', {"search": "applied"});
		 *
		 *      // Do something with the data
		 *      alert( data.length+" rows matched the search" );
		 *    } );
		 */
		this._ = function ( sSelector, oOpts )
		{
			return this.api(true).rows( sSelector, oOpts ).data();
		};
		
		
		/**
		 * Create a DataTables Api instance, with the currently selected tables for
		 * the Api's context.
		 * @param {boolean} [traditional=false] Set the API instance's context to be
		 *   only the table referred to by the `DataTable.ext.iApiIndex` option, as was
		 *   used in the API presented by DataTables 1.9- (i.e. the traditional mode),
		 *   or if all tables captured in the jQuery object should be used.
		 * @return {DataTables.Api}
		 */
		this.api = function ( traditional )
		{
			return traditional ?
				new _Api(
					_fnSettingsFromNode( this[ _ext.iApiIndex ] )
				) :
				new _Api( this );
		};
		
		
		/**
		 * Add a single new row or multiple rows of data to the table. Please note
		 * that this is suitable for client-side processing only - if you are using
		 * server-side processing (i.e. "bServerSide": true), then to add data, you
		 * must add it to the data source, i.e. the server-side, through an Ajax call.
		 *  @param {array|object} data The data to be added to the table. This can be:
		 *    <ul>
		 *      <li>1D array of data - add a single row with the data provided</li>
		 *      <li>2D array of arrays - add multiple rows in a single call</li>
		 *      <li>object - data object when using <i>mData</i></li>
		 *      <li>array of objects - multiple data objects when using <i>mData</i></li>
		 *    </ul>
		 *  @param {bool} [redraw=true] redraw the table or not
		 *  @returns {array} An array of integers, representing the list of indexes in
		 *    <i>aoData</i> ({@link DataTable.models.oSettings}) that have been added to
		 *    the table.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    // Global var for counter
		 *    var giCount = 2;
		 *
		 *    $(document).ready(function() {
		 *      $('#example').dataTable();
		 *    } );
		 *
		 *    function fnClickAddRow() {
		 *      $('#example').dataTable().fnAddData( [
		 *        giCount+".1",
		 *        giCount+".2",
		 *        giCount+".3",
		 *        giCount+".4" ]
		 *      );
		 *
		 *      giCount++;
		 *    }
		 */
		this.fnAddData = function( data, redraw )
		{
			var api = this.api( true );
		
			/* Check if we want to add multiple rows or not */
			var rows = $.isArray(data) && ( $.isArray(data[0]) || $.isPlainObject(data[0]) ) ?
				api.rows.add( data ) :
				api.row.add( data );
		
			if ( redraw === undefined || redraw ) {
				api.draw();
			}
		
			return rows.flatten().toArray();
		};
		
		
		/**
		 * This function will make DataTables recalculate the column sizes, based on the data
		 * contained in the table and the sizes applied to the columns (in the DOM, CSS or
		 * through the sWidth parameter). This can be useful when the width of the table's
		 * parent element changes (for example a window resize).
		 *  @param {boolean} [bRedraw=true] Redraw the table or not, you will typically want to
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable( {
		 *        "sScrollY": "200px",
		 *        "bPaginate": false
		 *      } );
		 *
		 *      $(window).on('resize', function () {
		 *        oTable.fnAdjustColumnSizing();
		 *      } );
		 *    } );
		 */
		this.fnAdjustColumnSizing = function ( bRedraw )
		{
			var api = this.api( true ).columns.adjust();
			var settings = api.settings()[0];
			var scroll = settings.oScroll;
		
			if ( bRedraw === undefined || bRedraw ) {
				api.draw( false );
			}
			else if ( scroll.sX !== "" || scroll.sY !== "" ) {
				/* If not redrawing, but scrolling, we want to apply the new column sizes anyway */
				_fnScrollDraw( settings );
			}
		};
		
		
		/**
		 * Quickly and simply clear a table
		 *  @param {bool} [bRedraw=true] redraw the table or not
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Immediately 'nuke' the current rows (perhaps waiting for an Ajax callback...)
		 *      oTable.fnClearTable();
		 *    } );
		 */
		this.fnClearTable = function( bRedraw )
		{
			var api = this.api( true ).clear();
		
			if ( bRedraw === undefined || bRedraw ) {
				api.draw();
			}
		};
		
		
		/**
		 * The exact opposite of 'opening' a row, this function will close any rows which
		 * are currently 'open'.
		 *  @param {node} nTr the table row to 'close'
		 *  @returns {int} 0 on success, or 1 if failed (can't find the row)
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable;
		 *
		 *      // 'open' an information row when a row is clicked on
		 *      $('#example tbody tr').click( function () {
		 *        if ( oTable.fnIsOpen(this) ) {
		 *          oTable.fnClose( this );
		 *        } else {
		 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
		 *        }
		 *      } );
		 *
		 *      oTable = $('#example').dataTable();
		 *    } );
		 */
		this.fnClose = function( nTr )
		{
			this.api( true ).row( nTr ).child.hide();
		};
		
		
		/**
		 * Remove a row for the table
		 *  @param {mixed} target The index of the row from aoData to be deleted, or
		 *    the TR element you want to delete
		 *  @param {function|null} [callBack] Callback function
		 *  @param {bool} [redraw=true] Redraw the table or not
		 *  @returns {array} The row that was deleted
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Immediately remove the first row
		 *      oTable.fnDeleteRow( 0 );
		 *    } );
		 */
		this.fnDeleteRow = function( target, callback, redraw )
		{
			var api = this.api( true );
			var rows = api.rows( target );
			var settings = rows.settings()[0];
			var data = settings.aoData[ rows[0][0] ];
		
			rows.remove();
		
			if ( callback ) {
				callback.call( this, settings, data );
			}
		
			if ( redraw === undefined || redraw ) {
				api.draw();
			}
		
			return data;
		};
		
		
		/**
		 * Restore the table to it's original state in the DOM by removing all of DataTables
		 * enhancements, alterations to the DOM structure of the table and event listeners.
		 *  @param {boolean} [remove=false] Completely remove the table from the DOM
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      // This example is fairly pointless in reality, but shows how fnDestroy can be used
		 *      var oTable = $('#example').dataTable();
		 *      oTable.fnDestroy();
		 *    } );
		 */
		this.fnDestroy = function ( remove )
		{
			this.api( true ).destroy( remove );
		};
		
		
		/**
		 * Redraw the table
		 *  @param {bool} [complete=true] Re-filter and resort (if enabled) the table before the draw.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Re-draw the table - you wouldn't want to do it here, but it's an example :-)
		 *      oTable.fnDraw();
		 *    } );
		 */
		this.fnDraw = function( complete )
		{
			// Note that this isn't an exact match to the old call to _fnDraw - it takes
			// into account the new data, but can hold position.
			this.api( true ).draw( complete );
		};
		
		
		/**
		 * Filter the input based on data
		 *  @param {string} sInput String to filter the table on
		 *  @param {int|null} [iColumn] Column to limit filtering to
		 *  @param {bool} [bRegex=false] Treat as regular expression or not
		 *  @param {bool} [bSmart=true] Perform smart filtering or not
		 *  @param {bool} [bShowGlobal=true] Show the input global filter in it's input box(es)
		 *  @param {bool} [bCaseInsensitive=true] Do case-insensitive matching (true) or not (false)
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Sometime later - filter...
		 *      oTable.fnFilter( 'test string' );
		 *    } );
		 */
		this.fnFilter = function( sInput, iColumn, bRegex, bSmart, bShowGlobal, bCaseInsensitive )
		{
			var api = this.api( true );
		
			if ( iColumn === null || iColumn === undefined ) {
				api.search( sInput, bRegex, bSmart, bCaseInsensitive );
			}
			else {
				api.column( iColumn ).search( sInput, bRegex, bSmart, bCaseInsensitive );
			}
		
			api.draw();
		};
		
		
		/**
		 * Get the data for the whole table, an individual row or an individual cell based on the
		 * provided parameters.
		 *  @param {int|node} [src] A TR row node, TD/TH cell node or an integer. If given as
		 *    a TR node then the data source for the whole row will be returned. If given as a
		 *    TD/TH cell node then iCol will be automatically calculated and the data for the
		 *    cell returned. If given as an integer, then this is treated as the aoData internal
		 *    data index for the row (see fnGetPosition) and the data for that row used.
		 *  @param {int} [col] Optional column index that you want the data of.
		 *  @returns {array|object|string} If mRow is undefined, then the data for all rows is
		 *    returned. If mRow is defined, just data for that row, and is iCol is
		 *    defined, only data for the designated cell is returned.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    // Row data
		 *    $(document).ready(function() {
		 *      oTable = $('#example').dataTable();
		 *
		 *      oTable.$('tr').click( function () {
		 *        var data = oTable.fnGetData( this );
		 *        // ... do something with the array / object of data for the row
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Individual cell data
		 *    $(document).ready(function() {
		 *      oTable = $('#example').dataTable();
		 *
		 *      oTable.$('td').click( function () {
		 *        var sData = oTable.fnGetData( this );
		 *        alert( 'The cell clicked on had the value of '+sData );
		 *      } );
		 *    } );
		 */
		this.fnGetData = function( src, col )
		{
			var api = this.api( true );
		
			if ( src !== undefined ) {
				var type = src.nodeName ? src.nodeName.toLowerCase() : '';
		
				return col !== undefined || type == 'td' || type == 'th' ?
					api.cell( src, col ).data() :
					api.row( src ).data() || null;
			}
		
			return api.data().toArray();
		};
		
		
		/**
		 * Get an array of the TR nodes that are used in the table's body. Note that you will
		 * typically want to use the '$' API method in preference to this as it is more
		 * flexible.
		 *  @param {int} [iRow] Optional row index for the TR element you want
		 *  @returns {array|node} If iRow is undefined, returns an array of all TR elements
		 *    in the table's body, or iRow is defined, just the TR element requested.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Get the nodes from the table
		 *      var nNodes = oTable.fnGetNodes( );
		 *    } );
		 */
		this.fnGetNodes = function( iRow )
		{
			var api = this.api( true );
		
			return iRow !== undefined ?
				api.row( iRow ).node() :
				api.rows().nodes().flatten().toArray();
		};
		
		
		/**
		 * Get the array indexes of a particular cell from it's DOM element
		 * and column index including hidden columns
		 *  @param {node} node this can either be a TR, TD or TH in the table's body
		 *  @returns {int} If nNode is given as a TR, then a single index is returned, or
		 *    if given as a cell, an array of [row index, column index (visible),
		 *    column index (all)] is given.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      $('#example tbody td').click( function () {
		 *        // Get the position of the current data from the node
		 *        var aPos = oTable.fnGetPosition( this );
		 *
		 *        // Get the data array for this row
		 *        var aData = oTable.fnGetData( aPos[0] );
		 *
		 *        // Update the data array and return the value
		 *        aData[ aPos[1] ] = 'clicked';
		 *        this.innerHTML = 'clicked';
		 *      } );
		 *
		 *      // Init DataTables
		 *      oTable = $('#example').dataTable();
		 *    } );
		 */
		this.fnGetPosition = function( node )
		{
			var api = this.api( true );
			var nodeName = node.nodeName.toUpperCase();
		
			if ( nodeName == 'TR' ) {
				return api.row( node ).index();
			}
			else if ( nodeName == 'TD' || nodeName == 'TH' ) {
				var cell = api.cell( node ).index();
		
				return [
					cell.row,
					cell.columnVisible,
					cell.column
				];
			}
			return null;
		};
		
		
		/**
		 * Check to see if a row is 'open' or not.
		 *  @param {node} nTr the table row to check
		 *  @returns {boolean} true if the row is currently open, false otherwise
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable;
		 *
		 *      // 'open' an information row when a row is clicked on
		 *      $('#example tbody tr').click( function () {
		 *        if ( oTable.fnIsOpen(this) ) {
		 *          oTable.fnClose( this );
		 *        } else {
		 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
		 *        }
		 *      } );
		 *
		 *      oTable = $('#example').dataTable();
		 *    } );
		 */
		this.fnIsOpen = function( nTr )
		{
			return this.api( true ).row( nTr ).child.isShown();
		};
		
		
		/**
		 * This function will place a new row directly after a row which is currently
		 * on display on the page, with the HTML contents that is passed into the
		 * function. This can be used, for example, to ask for confirmation that a
		 * particular record should be deleted.
		 *  @param {node} nTr The table row to 'open'
		 *  @param {string|node|jQuery} mHtml The HTML to put into the row
		 *  @param {string} sClass Class to give the new TD cell
		 *  @returns {node} The row opened. Note that if the table row passed in as the
		 *    first parameter, is not found in the table, this method will silently
		 *    return.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable;
		 *
		 *      // 'open' an information row when a row is clicked on
		 *      $('#example tbody tr').click( function () {
		 *        if ( oTable.fnIsOpen(this) ) {
		 *          oTable.fnClose( this );
		 *        } else {
		 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
		 *        }
		 *      } );
		 *
		 *      oTable = $('#example').dataTable();
		 *    } );
		 */
		this.fnOpen = function( nTr, mHtml, sClass )
		{
			return this.api( true )
				.row( nTr )
				.child( mHtml, sClass )
				.show()
				.child()[0];
		};
		
		
		/**
		 * Change the pagination - provides the internal logic for pagination in a simple API
		 * function. With this function you can have a DataTables table go to the next,
		 * previous, first or last pages.
		 *  @param {string|int} mAction Paging action to take: "first", "previous", "next" or "last"
		 *    or page number to jump to (integer), note that page 0 is the first page.
		 *  @param {bool} [bRedraw=true] Redraw the table or not
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *      oTable.fnPageChange( 'next' );
		 *    } );
		 */
		this.fnPageChange = function ( mAction, bRedraw )
		{
			var api = this.api( true ).page( mAction );
		
			if ( bRedraw === undefined || bRedraw ) {
				api.draw(false);
			}
		};
		
		
		/**
		 * Show a particular column
		 *  @param {int} iCol The column whose display should be changed
		 *  @param {bool} bShow Show (true) or hide (false) the column
		 *  @param {bool} [bRedraw=true] Redraw the table or not
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Hide the second column after initialisation
		 *      oTable.fnSetColumnVis( 1, false );
		 *    } );
		 */
		this.fnSetColumnVis = function ( iCol, bShow, bRedraw )
		{
			var api = this.api( true ).column( iCol ).visible( bShow );
		
			if ( bRedraw === undefined || bRedraw ) {
				api.columns.adjust().draw();
			}
		};
		
		
		/**
		 * Get the settings for a particular table for external manipulation
		 *  @returns {object} DataTables settings object. See
		 *    {@link DataTable.models.oSettings}
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *      var oSettings = oTable.fnSettings();
		 *
		 *      // Show an example parameter from the settings
		 *      alert( oSettings._iDisplayStart );
		 *    } );
		 */
		this.fnSettings = function()
		{
			return _fnSettingsFromNode( this[_ext.iApiIndex] );
		};
		
		
		/**
		 * Sort the table by a particular column
		 *  @param {int} iCol the data index to sort on. Note that this will not match the
		 *    'display index' if you have hidden data entries
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Sort immediately with columns 0 and 1
		 *      oTable.fnSort( [ [0,'asc'], [1,'asc'] ] );
		 *    } );
		 */
		this.fnSort = function( aaSort )
		{
			this.api( true ).order( aaSort ).draw();
		};
		
		
		/**
		 * Attach a sort listener to an element for a given column
		 *  @param {node} nNode the element to attach the sort listener to
		 *  @param {int} iColumn the column that a click on this node will sort on
		 *  @param {function} [fnCallback] callback function when sort is run
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Sort on column 1, when 'sorter' is clicked on
		 *      oTable.fnSortListener( document.getElementById('sorter'), 1 );
		 *    } );
		 */
		this.fnSortListener = function( nNode, iColumn, fnCallback )
		{
			this.api( true ).order.listener( nNode, iColumn, fnCallback );
		};
		
		
		/**
		 * Update a table cell or row - this method will accept either a single value to
		 * update the cell with, an array of values with one element for each column or
		 * an object in the same format as the original data source. The function is
		 * self-referencing in order to make the multi column updates easier.
		 *  @param {object|array|string} mData Data to update the cell/row with
		 *  @param {node|int} mRow TR element you want to update or the aoData index
		 *  @param {int} [iColumn] The column to update, give as null or undefined to
		 *    update a whole row.
		 *  @param {bool} [bRedraw=true] Redraw the table or not
		 *  @param {bool} [bAction=true] Perform pre-draw actions or not
		 *  @returns {int} 0 on success, 1 on error
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *      oTable.fnUpdate( 'Example update', 0, 0 ); // Single cell
		 *      oTable.fnUpdate( ['a', 'b', 'c', 'd', 'e'], $('tbody tr')[0] ); // Row
		 *    } );
		 */
		this.fnUpdate = function( mData, mRow, iColumn, bRedraw, bAction )
		{
			var api = this.api( true );
		
			if ( iColumn === undefined || iColumn === null ) {
				api.row( mRow ).data( mData );
			}
			else {
				api.cell( mRow, iColumn ).data( mData );
			}
		
			if ( bAction === undefined || bAction ) {
				api.columns.adjust();
			}
		
			if ( bRedraw === undefined || bRedraw ) {
				api.draw();
			}
			return 0;
		};
		
		
		/**
		 * Provide a common method for plug-ins to check the version of DataTables being used, in order
		 * to ensure compatibility.
		 *  @param {string} sVersion Version string to check for, in the format "X.Y.Z". Note that the
		 *    formats "X" and "X.Y" are also acceptable.
		 *  @returns {boolean} true if this version of DataTables is greater or equal to the required
		 *    version, or false if this version of DataTales is not suitable
		 *  @method
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *      alert( oTable.fnVersionCheck( '1.9.0' ) );
		 *    } );
		 */
		this.fnVersionCheck = _ext.fnVersionCheck;
		

		var _that = this;
		var emptyInit = options === undefined;
		var len = this.length;

		if ( emptyInit ) {
			options = {};
		}

		this.oApi = this.internal = _ext.internal;

		// Extend with old style plug-in API methods
		for ( var fn in DataTable.ext.internal ) {
			if ( fn ) {
				this[fn] = _fnExternApiFunc(fn);
			}
		}

		this.each(function() {
			// For each initialisation we want to give it a clean initialisation
			// object that can be bashed around
			var o = {};
			var oInit = len > 1 ? // optimisation for single table case
				_fnExtend( o, options, true ) :
				options;

			/*global oInit,_that,emptyInit*/
			var i=0, iLen, j, jLen, k, kLen;
			var sId = this.getAttribute( 'id' );
			var bInitHandedOff = false;
			var defaults = DataTable.defaults;
			var $this = $(this);
			
			
			/* Sanity check */
			if ( this.nodeName.toLowerCase() != 'table' )
			{
				_fnLog( null, 0, 'Non-table node initialisation ('+this.nodeName+')', 2 );
				return;
			}
			
			/* Backwards compatibility for the defaults */
			_fnCompatOpts( defaults );
			_fnCompatCols( defaults.column );
			
			/* Convert the camel-case defaults to Hungarian */
			_fnCamelToHungarian( defaults, defaults, true );
			_fnCamelToHungarian( defaults.column, defaults.column, true );
			
			/* Setting up the initialisation object */
			_fnCamelToHungarian( defaults, $.extend( oInit, $this.data() ) );
			
			
			
			/* Check to see if we are re-initialising a table */
			var allSettings = DataTable.settings;
			for ( i=0, iLen=allSettings.length ; i<iLen ; i++ )
			{
				var s = allSettings[i];
			
				/* Base check on table node */
				if ( s.nTable == this || s.nTHead.parentNode == this || (s.nTFoot && s.nTFoot.parentNode == this) )
				{
					var bRetrieve = oInit.bRetrieve !== undefined ? oInit.bRetrieve : defaults.bRetrieve;
					var bDestroy = oInit.bDestroy !== undefined ? oInit.bDestroy : defaults.bDestroy;
			
					if ( emptyInit || bRetrieve )
					{
						return s.oInstance;
					}
					else if ( bDestroy )
					{
						s.oInstance.fnDestroy();
						break;
					}
					else
					{
						_fnLog( s, 0, 'Cannot reinitialise DataTable', 3 );
						return;
					}
				}
			
				/* If the element we are initialising has the same ID as a table which was previously
				 * initialised, but the table nodes don't match (from before) then we destroy the old
				 * instance by simply deleting it. This is under the assumption that the table has been
				 * destroyed by other methods. Anyone using non-id selectors will need to do this manually
				 */
				if ( s.sTableId == this.id )
				{
					allSettings.splice( i, 1 );
					break;
				}
			}
			
			/* Ensure the table has an ID - required for accessibility */
			if ( sId === null || sId === "" )
			{
				sId = "DataTables_Table_"+(DataTable.ext._unique++);
				this.id = sId;
			}
			
			/* Create the settings object for this table and set some of the default parameters */
			var oSettings = $.extend( true, {}, DataTable.models.oSettings, {
				"sDestroyWidth": $this[0].style.width,
				"sInstance":     sId,
				"sTableId":      sId
			} );
			oSettings.nTable = this;
			oSettings.oApi   = _that.internal;
			oSettings.oInit  = oInit;
			
			allSettings.push( oSettings );
			
			// Need to add the instance after the instance after the settings object has been added
			// to the settings array, so we can self reference the table instance if more than one
			oSettings.oInstance = (_that.length===1) ? _that : $this.dataTable();
			
			// Backwards compatibility, before we apply all the defaults
			_fnCompatOpts( oInit );
			
			if ( oInit.oLanguage )
			{
				_fnLanguageCompat( oInit.oLanguage );
			}
			
			// If the length menu is given, but the init display length is not, use the length menu
			if ( oInit.aLengthMenu && ! oInit.iDisplayLength )
			{
				oInit.iDisplayLength = $.isArray( oInit.aLengthMenu[0] ) ?
					oInit.aLengthMenu[0][0] : oInit.aLengthMenu[0];
			}
			
			// Apply the defaults and init options to make a single init object will all
			// options defined from defaults and instance options.
			oInit = _fnExtend( $.extend( true, {}, defaults ), oInit );
			
			
			// Map the initialisation options onto the settings object
			_fnMap( oSettings.oFeatures, oInit, [
				"bPaginate",
				"bLengthChange",
				"bFilter",
				"bSort",
				"bSortMulti",
				"bInfo",
				"bProcessing",
				"bAutoWidth",
				"bSortClasses",
				"bServerSide",
				"bDeferRender"
			] );
			_fnMap( oSettings, oInit, [
				"asStripeClasses",
				"ajax",
				"fnServerData",
				"fnFormatNumber",
				"sServerMethod",
				"aaSorting",
				"aaSortingFixed",
				"aLengthMenu",
				"sPaginationType",
				"sAjaxSource",
				"sAjaxDataProp",
				"iStateDuration",
				"sDom",
				"bSortCellsTop",
				"iTabIndex",
				"fnStateLoadCallback",
				"fnStateSaveCallback",
				"renderer",
				"searchDelay",
				"rowId",
				[ "iCookieDuration", "iStateDuration" ], // backwards compat
				[ "oSearch", "oPreviousSearch" ],
				[ "aoSearchCols", "aoPreSearchCols" ],
				[ "iDisplayLength", "_iDisplayLength" ],
				[ "bJQueryUI", "bJUI" ]
			] );
			_fnMap( oSettings.oScroll, oInit, [
				[ "sScrollX", "sX" ],
				[ "sScrollXInner", "sXInner" ],
				[ "sScrollY", "sY" ],
				[ "bScrollCollapse", "bCollapse" ]
			] );
			_fnMap( oSettings.oLanguage, oInit, "fnInfoCallback" );
			
			/* Callback functions which are array driven */
			_fnCallbackReg( oSettings, 'aoDrawCallback',       oInit.fnDrawCallback,      'user' );
			_fnCallbackReg( oSettings, 'aoServerParams',       oInit.fnServerParams,      'user' );
			_fnCallbackReg( oSettings, 'aoStateSaveParams',    oInit.fnStateSaveParams,   'user' );
			_fnCallbackReg( oSettings, 'aoStateLoadParams',    oInit.fnStateLoadParams,   'user' );
			_fnCallbackReg( oSettings, 'aoStateLoaded',        oInit.fnStateLoaded,       'user' );
			_fnCallbackReg( oSettings, 'aoRowCallback',        oInit.fnRowCallback,       'user' );
			_fnCallbackReg( oSettings, 'aoRowCreatedCallback', oInit.fnCreatedRow,        'user' );
			_fnCallbackReg( oSettings, 'aoHeaderCallback',     oInit.fnHeaderCallback,    'user' );
			_fnCallbackReg( oSettings, 'aoFooterCallback',     oInit.fnFooterCallback,    'user' );
			_fnCallbackReg( oSettings, 'aoInitComplete',       oInit.fnInitComplete,      'user' );
			_fnCallbackReg( oSettings, 'aoPreDrawCallback',    oInit.fnPreDrawCallback,   'user' );
			
			oSettings.rowIdFn = _fnGetObjectDataFn( oInit.rowId );
			
			/* Browser support detection */
			_fnBrowserDetect( oSettings );
			
			var oClasses = oSettings.oClasses;
			
			// @todo Remove in 1.11
			if ( oInit.bJQueryUI )
			{
				/* Use the JUI classes object for display. You could clone the oStdClasses object if
				 * you want to have multiple tables with multiple independent classes
				 */
				$.extend( oClasses, DataTable.ext.oJUIClasses, oInit.oClasses );
			
				if ( oInit.sDom === defaults.sDom && defaults.sDom === "lfrtip" )
				{
					/* Set the DOM to use a layout suitable for jQuery UI's theming */
					oSettings.sDom = '<"H"lfr>t<"F"ip>';
				}
			
				if ( ! oSettings.renderer ) {
					oSettings.renderer = 'jqueryui';
				}
				else if ( $.isPlainObject( oSettings.renderer ) && ! oSettings.renderer.header ) {
					oSettings.renderer.header = 'jqueryui';
				}
			}
			else
			{
				$.extend( oClasses, DataTable.ext.classes, oInit.oClasses );
			}
			$this.addClass( oClasses.sTable );
			
			
			if ( oSettings.iInitDisplayStart === undefined )
			{
				/* Display start point, taking into account the save saving */
				oSettings.iInitDisplayStart = oInit.iDisplayStart;
				oSettings._iDisplayStart = oInit.iDisplayStart;
			}
			
			if ( oInit.iDeferLoading !== null )
			{
				oSettings.bDeferLoading = true;
				var tmp = $.isArray( oInit.iDeferLoading );
				oSettings._iRecordsDisplay = tmp ? oInit.iDeferLoading[0] : oInit.iDeferLoading;
				oSettings._iRecordsTotal = tmp ? oInit.iDeferLoading[1] : oInit.iDeferLoading;
			}
			
			/* Language definitions */
			var oLanguage = oSettings.oLanguage;
			$.extend( true, oLanguage, oInit.oLanguage );
			
			if ( oLanguage.sUrl )
			{
				/* Get the language definitions from a file - because this Ajax call makes the language
				 * get async to the remainder of this function we use bInitHandedOff to indicate that
				 * _fnInitialise will be fired by the returned Ajax handler, rather than the constructor
				 */
				$.ajax( {
					dataType: 'json',
					url: oLanguage.sUrl,
					success: function ( json ) {
						_fnLanguageCompat( json );
						_fnCamelToHungarian( defaults.oLanguage, json );
						$.extend( true, oLanguage, json );
						_fnInitialise( oSettings );
					},
					error: function () {
						// Error occurred loading language file, continue on as best we can
						_fnInitialise( oSettings );
					}
				} );
				bInitHandedOff = true;
			}
			
			/*
			 * Stripes
			 */
			if ( oInit.asStripeClasses === null )
			{
				oSettings.asStripeClasses =[
					oClasses.sStripeOdd,
					oClasses.sStripeEven
				];
			}
			
			/* Remove row stripe classes if they are already on the table row */
			var stripeClasses = oSettings.asStripeClasses;
			var rowOne = $this.children('tbody').find('tr').eq(0);
			if ( $.inArray( true, $.map( stripeClasses, function(el, i) {
				return rowOne.hasClass(el);
			} ) ) !== -1 ) {
				$('tbody tr', this).removeClass( stripeClasses.join(' ') );
				oSettings.asDestroyStripes = stripeClasses.slice();
			}
			
			/*
			 * Columns
			 * See if we should load columns automatically or use defined ones
			 */
			var anThs = [];
			var aoColumnsInit;
			var nThead = this.getElementsByTagName('thead');
			if ( nThead.length !== 0 )
			{
				_fnDetectHeader( oSettings.aoHeader, nThead[0] );
				anThs = _fnGetUniqueThs( oSettings );
			}
			
			/* If not given a column array, generate one with nulls */
			if ( oInit.aoColumns === null )
			{
				aoColumnsInit = [];
				for ( i=0, iLen=anThs.length ; i<iLen ; i++ )
				{
					aoColumnsInit.push( null );
				}
			}
			else
			{
				aoColumnsInit = oInit.aoColumns;
			}
			
			/* Add the columns */
			for ( i=0, iLen=aoColumnsInit.length ; i<iLen ; i++ )
			{
				_fnAddColumn( oSettings, anThs ? anThs[i] : null );
			}
			
			/* Apply the column definitions */
			_fnApplyColumnDefs( oSettings, oInit.aoColumnDefs, aoColumnsInit, function (iCol, oDef) {
				_fnColumnOptions( oSettings, iCol, oDef );
			} );
			
			/* HTML5 attribute detection - build an mData object automatically if the
			 * attributes are found
			 */
			if ( rowOne.length ) {
				var a = function ( cell, name ) {
					return cell.getAttribute( 'data-'+name ) !== null ? name : null;
				};
			
				$( rowOne[0] ).children('th, td').each( function (i, cell) {
					var col = oSettings.aoColumns[i];
			
					if ( col.mData === i ) {
						var sort = a( cell, 'sort' ) || a( cell, 'order' );
						var filter = a( cell, 'filter' ) || a( cell, 'search' );
			
						if ( sort !== null || filter !== null ) {
							col.mData = {
								_:      i+'.display',
								sort:   sort !== null   ? i+'.@data-'+sort   : undefined,
								type:   sort !== null   ? i+'.@data-'+sort   : undefined,
								filter: filter !== null ? i+'.@data-'+filter : undefined
							};
			
							_fnColumnOptions( oSettings, i );
						}
					}
				} );
			}
			
			var features = oSettings.oFeatures;
			var loadedInit = function () {
				/*
				 * Sorting
				 * @todo For modularisation (1.11) this needs to do into a sort start up handler
				 */
			
				// If aaSorting is not defined, then we use the first indicator in asSorting
				// in case that has been altered, so the default sort reflects that option
				if ( oInit.aaSorting === undefined ) {
					var sorting = oSettings.aaSorting;
					for ( i=0, iLen=sorting.length ; i<iLen ; i++ ) {
						sorting[i][1] = oSettings.aoColumns[ i ].asSorting[0];
					}
				}
			
				/* Do a first pass on the sorting classes (allows any size changes to be taken into
				 * account, and also will apply sorting disabled classes if disabled
				 */
				_fnSortingClasses( oSettings );
			
				if ( features.bSort ) {
					_fnCallbackReg( oSettings, 'aoDrawCallback', function () {
						if ( oSettings.bSorted ) {
							var aSort = _fnSortFlatten( oSettings );
							var sortedColumns = {};
			
							$.each( aSort, function (i, val) {
								sortedColumns[ val.src ] = val.dir;
							} );
			
							_fnCallbackFire( oSettings, null, 'order', [oSettings, aSort, sortedColumns] );
							_fnSortAria( oSettings );
						}
					} );
				}
			
				_fnCallbackReg( oSettings, 'aoDrawCallback', function () {
					if ( oSettings.bSorted || _fnDataSource( oSettings ) === 'ssp' || features.bDeferRender ) {
						_fnSortingClasses( oSettings );
					}
				}, 'sc' );
			
			
				/*
				 * Final init
				 * Cache the header, body and footer as required, creating them if needed
				 */
			
				// Work around for Webkit bug 83867 - store the caption-side before removing from doc
				var captions = $this.children('caption').each( function () {
					this._captionSide = $(this).css('caption-side');
				} );
			
				var thead = $this.children('thead');
				if ( thead.length === 0 ) {
					thead = $('<thead/>').appendTo($this);
				}
				oSettings.nTHead = thead[0];
			
				var tbody = $this.children('tbody');
				if ( tbody.length === 0 ) {
					tbody = $('<tbody/>').appendTo($this);
				}
				oSettings.nTBody = tbody[0];
			
				var tfoot = $this.children('tfoot');
				if ( tfoot.length === 0 && captions.length > 0 && (oSettings.oScroll.sX !== "" || oSettings.oScroll.sY !== "") ) {
					// If we are a scrolling table, and no footer has been given, then we need to create
					// a tfoot element for the caption element to be appended to
					tfoot = $('<tfoot/>').appendTo($this);
				}
			
				if ( tfoot.length === 0 || tfoot.children().length === 0 ) {
					$this.addClass( oClasses.sNoFooter );
				}
				else if ( tfoot.length > 0 ) {
					oSettings.nTFoot = tfoot[0];
					_fnDetectHeader( oSettings.aoFooter, oSettings.nTFoot );
				}
			
				/* Check if there is data passing into the constructor */
				if ( oInit.aaData ) {
					for ( i=0 ; i<oInit.aaData.length ; i++ ) {
						_fnAddData( oSettings, oInit.aaData[ i ] );
					}
				}
				else if ( oSettings.bDeferLoading || _fnDataSource( oSettings ) == 'dom' ) {
					/* Grab the data from the page - only do this when deferred loading or no Ajax
					 * source since there is no point in reading the DOM data if we are then going
					 * to replace it with Ajax data
					 */
					_fnAddTr( oSettings, $(oSettings.nTBody).children('tr') );
				}
			
				/* Copy the data index array */
				oSettings.aiDisplay = oSettings.aiDisplayMaster.slice();
			
				/* Initialisation complete - table can be drawn */
				oSettings.bInitialised = true;
			
				/* Check if we need to initialise the table (it might not have been handed off to the
				 * language processor)
				 */
				if ( bInitHandedOff === false ) {
					_fnInitialise( oSettings );
				}
			};
			
			/* Must be done after everything which can be overridden by the state saving! */
			if ( oInit.bStateSave )
			{
				features.bStateSave = true;
				_fnCallbackReg( oSettings, 'aoDrawCallback', _fnSaveState, 'state_save' );
				_fnLoadState( oSettings, oInit, loadedInit );
			}
			else {
				loadedInit();
			}
			
		} );
		_that = null;
		return this;
	};

	
	/*
	 * It is useful to have variables which are scoped locally so only the
	 * DataTables functions can access them and they don't leak into global space.
	 * At the same time these functions are often useful over multiple files in the
	 * core and API, so we list, or at least document, all variables which are used
	 * by DataTables as private variables here. This also ensures that there is no
	 * clashing of variable names and that they can easily referenced for reuse.
	 */
	
	
	// Defined else where
	//  _selector_run
	//  _selector_opts
	//  _selector_first
	//  _selector_row_indexes
	
	var _ext; // DataTable.ext
	var _Api; // DataTable.Api
	var _api_register; // DataTable.Api.register
	var _api_registerPlural; // DataTable.Api.registerPlural
	
	var _re_dic = {};
	var _re_new_lines = /[\r\n]/g;
	var _re_html = /<.*?>/g;
	
	// This is not strict ISO8601 - Date.parse() is quite lax, although
	// implementations differ between browsers.
	var _re_date = /^\d{2,4}[\.\/\-]\d{1,2}[\.\/\-]\d{1,2}([T ]{1}\d{1,2}[:\.]\d{2}([\.:]\d{2})?)?$/;
	
	// Escape regular expression special characters
	var _re_escape_regex = new RegExp( '(\\' + [ '/', '.', '*', '+', '?', '|', '(', ')', '[', ']', '{', '}', '\\', '$', '^', '-' ].join('|\\') + ')', 'g' );
	
	// http://en.wikipedia.org/wiki/Foreign_exchange_market
	// - \u20BD - Russian ruble.
	// - \u20a9 - South Korean Won
	// - \u20BA - Turkish Lira
	// - \u20B9 - Indian Rupee
	// - R - Brazil (R$) and South Africa
	// - fr - Swiss Franc
	// - kr - Swedish krona, Norwegian krone and Danish krone
	// - \u2009 is thin space and \u202F is narrow no-break space, both used in many
	//   standards as thousands separators.
	var _re_formatted_numeric = /[',$£€¥%\u2009\u202F\u20BD\u20a9\u20BArfk]/gi;
	
	
	var _empty = function ( d ) {
		return !d || d === true || d === '-' ? true : false;
	};
	
	
	var _intVal = function ( s ) {
		var integer = parseInt( s, 10 );
		return !isNaN(integer) && isFinite(s) ? integer : null;
	};
	
	// Convert from a formatted number with characters other than `.` as the
	// decimal place, to a Javascript number
	var _numToDecimal = function ( num, decimalPoint ) {
		// Cache created regular expressions for speed as this function is called often
		if ( ! _re_dic[ decimalPoint ] ) {
			_re_dic[ decimalPoint ] = new RegExp( _fnEscapeRegex( decimalPoint ), 'g' );
		}
		return typeof num === 'string' && decimalPoint !== '.' ?
			num.replace( /\./g, '' ).replace( _re_dic[ decimalPoint ], '.' ) :
			num;
	};
	
	
	var _isNumber = function ( d, decimalPoint, formatted ) {
		var strType = typeof d === 'string';
	
		// If empty return immediately so there must be a number if it is a
		// formatted string (this stops the string "k", or "kr", etc being detected
		// as a formatted number for currency
		if ( _empty( d ) ) {
			return true;
		}
	
		if ( decimalPoint && strType ) {
			d = _numToDecimal( d, decimalPoint );
		}
	
		if ( formatted && strType ) {
			d = d.replace( _re_formatted_numeric, '' );
		}
	
		return !isNaN( parseFloat(d) ) && isFinite( d );
	};
	
	
	// A string without HTML in it can be considered to be HTML still
	var _isHtml = function ( d ) {
		return _empty( d ) || typeof d === 'string';
	};
	
	
	var _htmlNumeric = function ( d, decimalPoint, formatted ) {
		if ( _empty( d ) ) {
			return true;
		}
	
		var html = _isHtml( d );
		return ! html ?
			null :
			_isNumber( _stripHtml( d ), decimalPoint, formatted ) ?
				true :
				null;
	};
	
	
	var _pluck = function ( a, prop, prop2 ) {
		var out = [];
		var i=0, ien=a.length;
	
		// Could have the test in the loop for slightly smaller code, but speed
		// is essential here
		if ( prop2 !== undefined ) {
			for ( ; i<ien ; i++ ) {
				if ( a[i] && a[i][ prop ] ) {
					out.push( a[i][ prop ][ prop2 ] );
				}
			}
		}
		else {
			for ( ; i<ien ; i++ ) {
				if ( a[i] ) {
					out.push( a[i][ prop ] );
				}
			}
		}
	
		return out;
	};
	
	
	// Basically the same as _pluck, but rather than looping over `a` we use `order`
	// as the indexes to pick from `a`
	var _pluck_order = function ( a, order, prop, prop2 )
	{
		var out = [];
		var i=0, ien=order.length;
	
		// Could have the test in the loop for slightly smaller code, but speed
		// is essential here
		if ( prop2 !== undefined ) {
			for ( ; i<ien ; i++ ) {
				if ( a[ order[i] ][ prop ] ) {
					out.push( a[ order[i] ][ prop ][ prop2 ] );
				}
			}
		}
		else {
			for ( ; i<ien ; i++ ) {
				out.push( a[ order[i] ][ prop ] );
			}
		}
	
		return out;
	};
	
	
	var _range = function ( len, start )
	{
		var out = [];
		var end;
	
		if ( start === undefined ) {
			start = 0;
			end = len;
		}
		else {
			end = start;
			start = len;
		}
	
		for ( var i=start ; i<end ; i++ ) {
			out.push( i );
		}
	
		return out;
	};
	
	
	var _removeEmpty = function ( a )
	{
		var out = [];
	
		for ( var i=0, ien=a.length ; i<ien ; i++ ) {
			if ( a[i] ) { // careful - will remove all falsy values!
				out.push( a[i] );
			}
		}
	
		return out;
	};
	
	
	var _stripHtml = function ( d ) {
		return d.replace( _re_html, '' );
	};
	
	
	/**
	 * Find the unique elements in a source array.
	 *
	 * @param  {array} src Source array
	 * @return {array} Array of unique items
	 * @ignore
	 */
	var _unique = function ( src )
	{
		// A faster unique method is to use object keys to identify used values,
		// but this doesn't work with arrays or objects, which we must also
		// consider. See jsperf.com/compare-array-unique-versions/4 for more
		// information.
		var
			out = [],
			val,
			i, ien=src.length,
			j, k=0;
	
		again: for ( i=0 ; i<ien ; i++ ) {
			val = src[i];
	
			for ( j=0 ; j<k ; j++ ) {
				if ( out[j] === val ) {
					continue again;
				}
			}
	
			out.push( val );
			k++;
		}
	
		return out;
	};
	
	
	/**
	 * DataTables utility methods
	 * 
	 * This namespace provides helper methods that DataTables uses internally to
	 * create a DataTable, but which are not exclusively used only for DataTables.
	 * These methods can be used by extension authors to save the duplication of
	 * code.
	 *
	 *  @namespace
	 */
	DataTable.util = {
		/**
		 * Throttle the calls to a function. Arguments and context are maintained
		 * for the throttled function.
		 *
		 * @param {function} fn Function to be called
		 * @param {integer} freq Call frequency in mS
		 * @return {function} Wrapped function
		 */
		throttle: function ( fn, freq ) {
			var
				frequency = freq !== undefined ? freq : 200,
				last,
				timer;
	
			return function () {
				var
					that = this,
					now  = +new Date(),
					args = arguments;
	
				if ( last && now < last + frequency ) {
					clearTimeout( timer );
	
					timer = setTimeout( function () {
						last = undefined;
						fn.apply( that, args );
					}, frequency );
				}
				else {
					last = now;
					fn.apply( that, args );
				}
			};
		},
	
	
		/**
		 * Escape a string such that it can be used in a regular expression
		 *
		 *  @param {string} val string to escape
		 *  @returns {string} escaped string
		 */
		escapeRegex: function ( val ) {
			return val.replace( _re_escape_regex, '\\$1' );
		}
	};
	
	
	
	/**
	 * Create a mapping object that allows camel case parameters to be looked up
	 * for their Hungarian counterparts. The mapping is stored in a private
	 * parameter called `_hungarianMap` which can be accessed on the source object.
	 *  @param {object} o
	 *  @memberof DataTable#oApi
	 */
	function _fnHungarianMap ( o )
	{
		var
			hungarian = 'a aa ai ao as b fn i m o s ',
			match,
			newKey,
			map = {};
	
		$.each( o, function (key, val) {
			match = key.match(/^([^A-Z]+?)([A-Z])/);
	
			if ( match && hungarian.indexOf(match[1]+' ') !== -1 )
			{
				newKey = key.replace( match[0], match[2].toLowerCase() );
				map[ newKey ] = key;
	
				if ( match[1] === 'o' )
				{
					_fnHungarianMap( o[key] );
				}
			}
		} );
	
		o._hungarianMap = map;
	}
	
	
	/**
	 * Convert from camel case parameters to Hungarian, based on a Hungarian map
	 * created by _fnHungarianMap.
	 *  @param {object} src The model object which holds all parameters that can be
	 *    mapped.
	 *  @param {object} user The object to convert from camel case to Hungarian.
	 *  @param {boolean} force When set to `true`, properties which already have a
	 *    Hungarian value in the `user` object will be overwritten. Otherwise they
	 *    won't be.
	 *  @memberof DataTable#oApi
	 */
	function _fnCamelToHungarian ( src, user, force )
	{
		if ( ! src._hungarianMap ) {
			_fnHungarianMap( src );
		}
	
		var hungarianKey;
	
		$.each( user, function (key, val) {
			hungarianKey = src._hungarianMap[ key ];
	
			if ( hungarianKey !== undefined && (force || user[hungarianKey] === undefined) )
			{
				// For objects, we need to buzz down into the object to copy parameters
				if ( hungarianKey.charAt(0) === 'o' )
				{
					// Copy the camelCase options over to the hungarian
					if ( ! user[ hungarianKey ] ) {
						user[ hungarianKey ] = {};
					}
					$.extend( true, user[hungarianKey], user[key] );
	
					_fnCamelToHungarian( src[hungarianKey], user[hungarianKey], force );
				}
				else {
					user[hungarianKey] = user[ key ];
				}
			}
		} );
	}
	
	
	/**
	 * Language compatibility - when certain options are given, and others aren't, we
	 * need to duplicate the values over, in order to provide backwards compatibility
	 * with older language files.
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnLanguageCompat( lang )
	{
		var defaults = DataTable.defaults.oLanguage;
		var zeroRecords = lang.sZeroRecords;
	
		/* Backwards compatibility - if there is no sEmptyTable given, then use the same as
		 * sZeroRecords - assuming that is given.
		 */
		if ( ! lang.sEmptyTable && zeroRecords &&
			defaults.sEmptyTable === "No data available in table" )
		{
			_fnMap( lang, lang, 'sZeroRecords', 'sEmptyTable' );
		}
	
		/* Likewise with loading records */
		if ( ! lang.sLoadingRecords && zeroRecords &&
			defaults.sLoadingRecords === "Loading..." )
		{
			_fnMap( lang, lang, 'sZeroRecords', 'sLoadingRecords' );
		}
	
		// Old parameter name of the thousands separator mapped onto the new
		if ( lang.sInfoThousands ) {
			lang.sThousands = lang.sInfoThousands;
		}
	
		var decimal = lang.sDecimal;
		if ( decimal ) {
			_addNumericSort( decimal );
		}
	}
	
	
	/**
	 * Map one parameter onto another
	 *  @param {object} o Object to map
	 *  @param {*} knew The new parameter name
	 *  @param {*} old The old parameter name
	 */
	var _fnCompatMap = function ( o, knew, old ) {
		if ( o[ knew ] !== undefined ) {
			o[ old ] = o[ knew ];
		}
	};
	
	
	/**
	 * Provide backwards compatibility for the main DT options. Note that the new
	 * options are mapped onto the old parameters, so this is an external interface
	 * change only.
	 *  @param {object} init Object to map
	 */
	function _fnCompatOpts ( init )
	{
		_fnCompatMap( init, 'ordering',      'bSort' );
		_fnCompatMap( init, 'orderMulti',    'bSortMulti' );
		_fnCompatMap( init, 'orderClasses',  'bSortClasses' );
		_fnCompatMap( init, 'orderCellsTop', 'bSortCellsTop' );
		_fnCompatMap( init, 'order',         'aaSorting' );
		_fnCompatMap( init, 'orderFixed',    'aaSortingFixed' );
		_fnCompatMap( init, 'paging',        'bPaginate' );
		_fnCompatMap( init, 'pagingType',    'sPaginationType' );
		_fnCompatMap( init, 'pageLength',    'iDisplayLength' );
		_fnCompatMap( init, 'searching',     'bFilter' );
	
		// Boolean initialisation of x-scrolling
		if ( typeof init.sScrollX === 'boolean' ) {
			init.sScrollX = init.sScrollX ? '100%' : '';
		}
		if ( typeof init.scrollX === 'boolean' ) {
			init.scrollX = init.scrollX ? '100%' : '';
		}
	
		// Column search objects are in an array, so it needs to be converted
		// element by element
		var searchCols = init.aoSearchCols;
	
		if ( searchCols ) {
			for ( var i=0, ien=searchCols.length ; i<ien ; i++ ) {
				if ( searchCols[i] ) {
					_fnCamelToHungarian( DataTable.models.oSearch, searchCols[i] );
				}
			}
		}
	}
	
	
	/**
	 * Provide backwards compatibility for column options. Note that the new options
	 * are mapped onto the old parameters, so this is an external interface change
	 * only.
	 *  @param {object} init Object to map
	 */
	function _fnCompatCols ( init )
	{
		_fnCompatMap( init, 'orderable',     'bSortable' );
		_fnCompatMap( init, 'orderData',     'aDataSort' );
		_fnCompatMap( init, 'orderSequence', 'asSorting' );
		_fnCompatMap( init, 'orderDataType', 'sortDataType' );
	
		// orderData can be given as an integer
		var dataSort = init.aDataSort;
		if ( dataSort && ! $.isArray( dataSort ) ) {
			init.aDataSort = [ dataSort ];
		}
	}
	
	
	/**
	 * Browser feature detection for capabilities, quirks
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnBrowserDetect( settings )
	{
		// We don't need to do this every time DataTables is constructed, the values
		// calculated are specific to the browser and OS configuration which we
		// don't expect to change between initialisations
		if ( ! DataTable.__browser ) {
			var browser = {};
			DataTable.__browser = browser;
	
			// Scrolling feature / quirks detection
			var n = $('<div/>')
				.css( {
					position: 'fixed',
					top: 0,
					left: $(window).scrollLeft()*-1, // allow for scrolling
					height: 1,
					width: 1,
					overflow: 'hidden'
				} )
				.append(
					$('<div/>')
						.css( {
							position: 'absolute',
							top: 1,
							left: 1,
							width: 100,
							overflow: 'scroll'
						} )
						.append(
							$('<div/>')
								.css( {
									width: '100%',
									height: 10
								} )
						)
				)
				.appendTo( 'body' );
	
			var outer = n.children();
			var inner = outer.children();
	
			// Numbers below, in order, are:
			// inner.offsetWidth, inner.clientWidth, outer.offsetWidth, outer.clientWidth
			//
			// IE6 XP:                           100 100 100  83
			// IE7 Vista:                        100 100 100  83
			// IE 8+ Windows:                     83  83 100  83
			// Evergreen Windows:                 83  83 100  83
			// Evergreen Mac with scrollbars:     85  85 100  85
			// Evergreen Mac without scrollbars: 100 100 100 100
	
			// Get scrollbar width
			browser.barWidth = outer[0].offsetWidth - outer[0].clientWidth;
	
			// IE6/7 will oversize a width 100% element inside a scrolling element, to
			// include the width of the scrollbar, while other browsers ensure the inner
			// element is contained without forcing scrolling
			browser.bScrollOversize = inner[0].offsetWidth === 100 && outer[0].clientWidth !== 100;
	
			// In rtl text layout, some browsers (most, but not all) will place the
			// scrollbar on the left, rather than the right.
			browser.bScrollbarLeft = Math.round( inner.offset().left ) !== 1;
	
			// IE8- don't provide height and width for getBoundingClientRect
			browser.bBounding = n[0].getBoundingClientRect().width ? true : false;
	
			n.remove();
		}
	
		$.extend( settings.oBrowser, DataTable.__browser );
		settings.oScroll.iBarWidth = DataTable.__browser.barWidth;
	}
	
	
	/**
	 * Array.prototype reduce[Right] method, used for browsers which don't support
	 * JS 1.6. Done this way to reduce code size, since we iterate either way
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnReduce ( that, fn, init, start, end, inc )
	{
		var
			i = start,
			value,
			isSet = false;
	
		if ( init !== undefined ) {
			value = init;
			isSet = true;
		}
	
		while ( i !== end ) {
			if ( ! that.hasOwnProperty(i) ) {
				continue;
			}
	
			value = isSet ?
				fn( value, that[i], i, that ) :
				that[i];
	
			isSet = true;
			i += inc;
		}
	
		return value;
	}
	
	/**
	 * Add a column to the list used for the table with default values
	 *  @param {object} oSettings dataTables settings object
	 *  @param {node} nTh The th element for this column
	 *  @memberof DataTable#oApi
	 */
	function _fnAddColumn( oSettings, nTh )
	{
		// Add column to aoColumns array
		var oDefaults = DataTable.defaults.column;
		var iCol = oSettings.aoColumns.length;
		var oCol = $.extend( {}, DataTable.models.oColumn, oDefaults, {
			"nTh": nTh ? nTh : document.createElement('th'),
			"sTitle":    oDefaults.sTitle    ? oDefaults.sTitle    : nTh ? nTh.innerHTML : '',
			"aDataSort": oDefaults.aDataSort ? oDefaults.aDataSort : [iCol],
			"mData": oDefaults.mData ? oDefaults.mData : iCol,
			idx: iCol
		} );
		oSettings.aoColumns.push( oCol );
	
		// Add search object for column specific search. Note that the `searchCols[ iCol ]`
		// passed into extend can be undefined. This allows the user to give a default
		// with only some of the parameters defined, and also not give a default
		var searchCols = oSettings.aoPreSearchCols;
		searchCols[ iCol ] = $.extend( {}, DataTable.models.oSearch, searchCols[ iCol ] );
	
		// Use the default column options function to initialise classes etc
		_fnColumnOptions( oSettings, iCol, $(nTh).data() );
	}
	
	
	/**
	 * Apply options for a column
	 *  @param {object} oSettings dataTables settings object
	 *  @param {int} iCol column index to consider
	 *  @param {object} oOptions object with sType, bVisible and bSearchable etc
	 *  @memberof DataTable#oApi
	 */
	function _fnColumnOptions( oSettings, iCol, oOptions )
	{
		var oCol = oSettings.aoColumns[ iCol ];
		var oClasses = oSettings.oClasses;
		var th = $(oCol.nTh);
	
		// Try to get width information from the DOM. We can't get it from CSS
		// as we'd need to parse the CSS stylesheet. `width` option can override
		if ( ! oCol.sWidthOrig ) {
			// Width attribute
			oCol.sWidthOrig = th.attr('width') || null;
	
			// Style attribute
			var t = (th.attr('style') || '').match(/width:\s*(\d+[pxem%]+)/);
			if ( t ) {
				oCol.sWidthOrig = t[1];
			}
		}
	
		/* User specified column options */
		if ( oOptions !== undefined && oOptions !== null )
		{
			// Backwards compatibility
			_fnCompatCols( oOptions );
	
			// Map camel case parameters to their Hungarian counterparts
			_fnCamelToHungarian( DataTable.defaults.column, oOptions );
	
			/* Backwards compatibility for mDataProp */
			if ( oOptions.mDataProp !== undefined && !oOptions.mData )
			{
				oOptions.mData = oOptions.mDataProp;
			}
	
			if ( oOptions.sType )
			{
				oCol._sManualType = oOptions.sType;
			}
	
			// `class` is a reserved word in Javascript, so we need to provide
			// the ability to use a valid name for the camel case input
			if ( oOptions.className && ! oOptions.sClass )
			{
				oOptions.sClass = oOptions.className;
			}
	
			$.extend( oCol, oOptions );
			_fnMap( oCol, oOptions, "sWidth", "sWidthOrig" );
	
			/* iDataSort to be applied (backwards compatibility), but aDataSort will take
			 * priority if defined
			 */
			if ( oOptions.iDataSort !== undefined )
			{
				oCol.aDataSort = [ oOptions.iDataSort ];
			}
			_fnMap( oCol, oOptions, "aDataSort" );
		}
	
		/* Cache the data get and set functions for speed */
		var mDataSrc = oCol.mData;
		var mData = _fnGetObjectDataFn( mDataSrc );
		var mRender = oCol.mRender ? _fnGetObjectDataFn( oCol.mRender ) : null;
	
		var attrTest = function( src ) {
			return typeof src === 'string' && src.indexOf('@') !== -1;
		};
		oCol._bAttrSrc = $.isPlainObject( mDataSrc ) && (
			attrTest(mDataSrc.sort) || attrTest(mDataSrc.type) || attrTest(mDataSrc.filter)
		);
		oCol._setter = null;
	
		oCol.fnGetData = function (rowData, type, meta) {
			var innerData = mData( rowData, type, undefined, meta );
	
			return mRender && type ?
				mRender( innerData, type, rowData, meta ) :
				innerData;
		};
		oCol.fnSetData = function ( rowData, val, meta ) {
			return _fnSetObjectDataFn( mDataSrc )( rowData, val, meta );
		};
	
		// Indicate if DataTables should read DOM data as an object or array
		// Used in _fnGetRowElements
		if ( typeof mDataSrc !== 'number' ) {
			oSettings._rowReadObject = true;
		}
	
		/* Feature sorting overrides column specific when off */
		if ( !oSettings.oFeatures.bSort )
		{
			oCol.bSortable = false;
			th.addClass( oClasses.sSortableNone ); // Have to add class here as order event isn't called
		}
	
		/* Check that the class assignment is correct for sorting */
		var bAsc = $.inArray('asc', oCol.asSorting) !== -1;
		var bDesc = $.inArray('desc', oCol.asSorting) !== -1;
		if ( !oCol.bSortable || (!bAsc && !bDesc) )
		{
			oCol.sSortingClass = oClasses.sSortableNone;
			oCol.sSortingClassJUI = "";
		}
		else if ( bAsc && !bDesc )
		{
			oCol.sSortingClass = oClasses.sSortableAsc;
			oCol.sSortingClassJUI = oClasses.sSortJUIAscAllowed;
		}
		else if ( !bAsc && bDesc )
		{
			oCol.sSortingClass = oClasses.sSortableDesc;
			oCol.sSortingClassJUI = oClasses.sSortJUIDescAllowed;
		}
		else
		{
			oCol.sSortingClass = oClasses.sSortable;
			oCol.sSortingClassJUI = oClasses.sSortJUI;
		}
	}
	
	
	/**
	 * Adjust the table column widths for new data. Note: you would probably want to
	 * do a redraw after calling this function!
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnAdjustColumnSizing ( settings )
	{
		/* Not interested in doing column width calculation if auto-width is disabled */
		if ( settings.oFeatures.bAutoWidth !== false )
		{
			var columns = settings.aoColumns;
	
			_fnCalculateColumnWidths( settings );
			for ( var i=0 , iLen=columns.length ; i<iLen ; i++ )
			{
				columns[i].nTh.style.width = columns[i].sWidth;
			}
		}
	
		var scroll = settings.oScroll;
		if ( scroll.sY !== '' || scroll.sX !== '')
		{
			_fnScrollDraw( settings );
		}
	
		_fnCallbackFire( settings, null, 'column-sizing', [settings] );
	}
	
	
	/**
	 * Covert the index of a visible column to the index in the data array (take account
	 * of hidden columns)
	 *  @param {object} oSettings dataTables settings object
	 *  @param {int} iMatch Visible column index to lookup
	 *  @returns {int} i the data index
	 *  @memberof DataTable#oApi
	 */
	function _fnVisibleToColumnIndex( oSettings, iMatch )
	{
		var aiVis = _fnGetColumns( oSettings, 'bVisible' );
	
		return typeof aiVis[iMatch] === 'number' ?
			aiVis[iMatch] :
			null;
	}
	
	
	/**
	 * Covert the index of an index in the data array and convert it to the visible
	 *   column index (take account of hidden columns)
	 *  @param {int} iMatch Column index to lookup
	 *  @param {object} oSettings dataTables settings object
	 *  @returns {int} i the data index
	 *  @memberof DataTable#oApi
	 */
	function _fnColumnIndexToVisible( oSettings, iMatch )
	{
		var aiVis = _fnGetColumns( oSettings, 'bVisible' );
		var iPos = $.inArray( iMatch, aiVis );
	
		return iPos !== -1 ? iPos : null;
	}
	
	
	/**
	 * Get the number of visible columns
	 *  @param {object} oSettings dataTables settings object
	 *  @returns {int} i the number of visible columns
	 *  @memberof DataTable#oApi
	 */
	function _fnVisbleColumns( oSettings )
	{
		var vis = 0;
	
		// No reduce in IE8, use a loop for now
		$.each( oSettings.aoColumns, function ( i, col ) {
			if ( col.bVisible && $(col.nTh).css('display') !== 'none' ) {
				vis++;
			}
		} );
	
		return vis;
	}
	
	
	/**
	 * Get an array of column indexes that match a given property
	 *  @param {object} oSettings dataTables settings object
	 *  @param {string} sParam Parameter in aoColumns to look for - typically
	 *    bVisible or bSearchable
	 *  @returns {array} Array of indexes with matched properties
	 *  @memberof DataTable#oApi
	 */
	function _fnGetColumns( oSettings, sParam )
	{
		var a = [];
	
		$.map( oSettings.aoColumns, function(val, i) {
			if ( val[sParam] ) {
				a.push( i );
			}
		} );
	
		return a;
	}
	
	
	/**
	 * Calculate the 'type' of a column
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnColumnTypes ( settings )
	{
		var columns = settings.aoColumns;
		var data = settings.aoData;
		var types = DataTable.ext.type.detect;
		var i, ien, j, jen, k, ken;
		var col, cell, detectedType, cache;
	
		// For each column, spin over the 
		for ( i=0, ien=columns.length ; i<ien ; i++ ) {
			col = columns[i];
			cache = [];
	
			if ( ! col.sType && col._sManualType ) {
				col.sType = col._sManualType;
			}
			else if ( ! col.sType ) {
				for ( j=0, jen=types.length ; j<jen ; j++ ) {
					for ( k=0, ken=data.length ; k<ken ; k++ ) {
						// Use a cache array so we only need to get the type data
						// from the formatter once (when using multiple detectors)
						if ( cache[k] === undefined ) {
							cache[k] = _fnGetCellData( settings, k, i, 'type' );
						}
	
						detectedType = types[j]( cache[k], settings );
	
						// If null, then this type can't apply to this column, so
						// rather than testing all cells, break out. There is an
						// exception for the last type which is `html`. We need to
						// scan all rows since it is possible to mix string and HTML
						// types
						if ( ! detectedType && j !== types.length-1 ) {
							break;
						}
	
						// Only a single match is needed for html type since it is
						// bottom of the pile and very similar to string
						if ( detectedType === 'html' ) {
							break;
						}
					}
	
					// Type is valid for all data points in the column - use this
					// type
					if ( detectedType ) {
						col.sType = detectedType;
						break;
					}
				}
	
				// Fall back - if no type was detected, always use string
				if ( ! col.sType ) {
					col.sType = 'string';
				}
			}
		}
	}
	
	
	/**
	 * Take the column definitions and static columns arrays and calculate how
	 * they relate to column indexes. The callback function will then apply the
	 * definition found for a column to a suitable configuration object.
	 *  @param {object} oSettings dataTables settings object
	 *  @param {array} aoColDefs The aoColumnDefs array that is to be applied
	 *  @param {array} aoCols The aoColumns array that defines columns individually
	 *  @param {function} fn Callback function - takes two parameters, the calculated
	 *    column index and the definition for that column.
	 *  @memberof DataTable#oApi
	 */
	function _fnApplyColumnDefs( oSettings, aoColDefs, aoCols, fn )
	{
		var i, iLen, j, jLen, k, kLen, def;
		var columns = oSettings.aoColumns;
	
		// Column definitions with aTargets
		if ( aoColDefs )
		{
			/* Loop over the definitions array - loop in reverse so first instance has priority */
			for ( i=aoColDefs.length-1 ; i>=0 ; i-- )
			{
				def = aoColDefs[i];
	
				/* Each definition can target multiple columns, as it is an array */
				var aTargets = def.targets !== undefined ?
					def.targets :
					def.aTargets;
	
				if ( ! $.isArray( aTargets ) )
				{
					aTargets = [ aTargets ];
				}
	
				for ( j=0, jLen=aTargets.length ; j<jLen ; j++ )
				{
					if ( typeof aTargets[j] === 'number' && aTargets[j] >= 0 )
					{
						/* Add columns that we don't yet know about */
						while( columns.length <= aTargets[j] )
						{
							_fnAddColumn( oSettings );
						}
	
						/* Integer, basic index */
						fn( aTargets[j], def );
					}
					else if ( typeof aTargets[j] === 'number' && aTargets[j] < 0 )
					{
						/* Negative integer, right to left column counting */
						fn( columns.length+aTargets[j], def );
					}
					else if ( typeof aTargets[j] === 'string' )
					{
						/* Class name matching on TH element */
						for ( k=0, kLen=columns.length ; k<kLen ; k++ )
						{
							if ( aTargets[j] == "_all" ||
							     $(columns[k].nTh).hasClass( aTargets[j] ) )
							{
								fn( k, def );
							}
						}
					}
				}
			}
		}
	
		// Statically defined columns array
		if ( aoCols )
		{
			for ( i=0, iLen=aoCols.length ; i<iLen ; i++ )
			{
				fn( i, aoCols[i] );
			}
		}
	}
	
	/**
	 * Add a data array to the table, creating DOM node etc. This is the parallel to
	 * _fnGatherData, but for adding rows from a Javascript source, rather than a
	 * DOM source.
	 *  @param {object} oSettings dataTables settings object
	 *  @param {array} aData data array to be added
	 *  @param {node} [nTr] TR element to add to the table - optional. If not given,
	 *    DataTables will create a row automatically
	 *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
	 *    if nTr is.
	 *  @returns {int} >=0 if successful (index of new aoData entry), -1 if failed
	 *  @memberof DataTable#oApi
	 */
	function _fnAddData ( oSettings, aDataIn, nTr, anTds )
	{
		/* Create the object for storing information about this new row */
		var iRow = oSettings.aoData.length;
		var oData = $.extend( true, {}, DataTable.models.oRow, {
			src: nTr ? 'dom' : 'data',
			idx: iRow
		} );
	
		oData._aData = aDataIn;
		oSettings.aoData.push( oData );
	
		/* Create the cells */
		var nTd, sThisType;
		var columns = oSettings.aoColumns;
	
		// Invalidate the column types as the new data needs to be revalidated
		for ( var i=0, iLen=columns.length ; i<iLen ; i++ )
		{
			columns[i].sType = null;
		}
	
		/* Add to the display array */
		oSettings.aiDisplayMaster.push( iRow );
	
		var id = oSettings.rowIdFn( aDataIn );
		if ( id !== undefined ) {
			oSettings.aIds[ id ] = oData;
		}
	
		/* Create the DOM information, or register it if already present */
		if ( nTr || ! oSettings.oFeatures.bDeferRender )
		{
			_fnCreateTr( oSettings, iRow, nTr, anTds );
		}
	
		return iRow;
	}
	
	
	/**
	 * Add one or more TR elements to the table. Generally we'd expect to
	 * use this for reading data from a DOM sourced table, but it could be
	 * used for an TR element. Note that if a TR is given, it is used (i.e.
	 * it is not cloned).
	 *  @param {object} settings dataTables settings object
	 *  @param {array|node|jQuery} trs The TR element(s) to add to the table
	 *  @returns {array} Array of indexes for the added rows
	 *  @memberof DataTable#oApi
	 */
	function _fnAddTr( settings, trs )
	{
		var row;
	
		// Allow an individual node to be passed in
		if ( ! (trs instanceof $) ) {
			trs = $(trs);
		}
	
		return trs.map( function (i, el) {
			row = _fnGetRowElements( settings, el );
			return _fnAddData( settings, row.data, el, row.cells );
		} );
	}
	
	
	/**
	 * Take a TR element and convert it to an index in aoData
	 *  @param {object} oSettings dataTables settings object
	 *  @param {node} n the TR element to find
	 *  @returns {int} index if the node is found, null if not
	 *  @memberof DataTable#oApi
	 */
	function _fnNodeToDataIndex( oSettings, n )
	{
		return (n._DT_RowIndex!==undefined) ? n._DT_RowIndex : null;
	}
	
	
	/**
	 * Take a TD element and convert it into a column data index (not the visible index)
	 *  @param {object} oSettings dataTables settings object
	 *  @param {int} iRow The row number the TD/TH can be found in
	 *  @param {node} n The TD/TH element to find
	 *  @returns {int} index if the node is found, -1 if not
	 *  @memberof DataTable#oApi
	 */
	function _fnNodeToColumnIndex( oSettings, iRow, n )
	{
		return $.inArray( n, oSettings.aoData[ iRow ].anCells );
	}
	
	
	/**
	 * Get the data for a given cell from the internal cache, taking into account data mapping
	 *  @param {object} settings dataTables settings object
	 *  @param {int} rowIdx aoData row id
	 *  @param {int} colIdx Column index
	 *  @param {string} type data get type ('display', 'type' 'filter' 'sort')
	 *  @returns {*} Cell data
	 *  @memberof DataTable#oApi
	 */
	function _fnGetCellData( settings, rowIdx, colIdx, type )
	{
		var draw           = settings.iDraw;
		var col            = settings.aoColumns[colIdx];
		var rowData        = settings.aoData[rowIdx]._aData;
		var defaultContent = col.sDefaultContent;
		var cellData       = col.fnGetData( rowData, type, {
			settings: settings,
			row:      rowIdx,
			col:      colIdx
		} );
	
		if ( cellData === undefined ) {
			if ( settings.iDrawError != draw && defaultContent === null ) {
				_fnLog( settings, 0, "Requested unknown parameter "+
					(typeof col.mData=='function' ? '{function}' : "'"+col.mData+"'")+
					" for row "+rowIdx+", column "+colIdx, 4 );
				settings.iDrawError = draw;
			}
			return defaultContent;
		}
	
		// When the data source is null and a specific data type is requested (i.e.
		// not the original data), we can use default column data
		if ( (cellData === rowData || cellData === null) && defaultContent !== null && type !== undefined ) {
			cellData = defaultContent;
		}
		else if ( typeof cellData === 'function' ) {
			// If the data source is a function, then we run it and use the return,
			// executing in the scope of the data object (for instances)
			return cellData.call( rowData );
		}
	
		if ( cellData === null && type == 'display' ) {
			return '';
		}
		return cellData;
	}
	
	
	/**
	 * Set the value for a specific cell, into the internal data cache
	 *  @param {object} settings dataTables settings object
	 *  @param {int} rowIdx aoData row id
	 *  @param {int} colIdx Column index
	 *  @param {*} val Value to set
	 *  @memberof DataTable#oApi
	 */
	function _fnSetCellData( settings, rowIdx, colIdx, val )
	{
		var col     = settings.aoColumns[colIdx];
		var rowData = settings.aoData[rowIdx]._aData;
	
		col.fnSetData( rowData, val, {
			settings: settings,
			row:      rowIdx,
			col:      colIdx
		}  );
	}
	
	
	// Private variable that is used to match action syntax in the data property object
	var __reArray = /\[.*?\]$/;
	var __reFn = /\(\)$/;
	
	/**
	 * Split string on periods, taking into account escaped periods
	 * @param  {string} str String to split
	 * @return {array} Split string
	 */
	function _fnSplitObjNotation( str )
	{
		return $.map( str.match(/(\\.|[^\.])+/g) || [''], function ( s ) {
			return s.replace(/\\\./g, '.');
		} );
	}
	
	
	/**
	 * Return a function that can be used to get data from a source object, taking
	 * into account the ability to use nested objects as a source
	 *  @param {string|int|function} mSource The data source for the object
	 *  @returns {function} Data get function
	 *  @memberof DataTable#oApi
	 */
	function _fnGetObjectDataFn( mSource )
	{
		if ( $.isPlainObject( mSource ) )
		{
			/* Build an object of get functions, and wrap them in a single call */
			var o = {};
			$.each( mSource, function (key, val) {
				if ( val ) {
					o[key] = _fnGetObjectDataFn( val );
				}
			} );
	
			return function (data, type, row, meta) {
				var t = o[type] || o._;
				return t !== undefined ?
					t(data, type, row, meta) :
					data;
			};
		}
		else if ( mSource === null )
		{
			/* Give an empty string for rendering / sorting etc */
			return function (data) { // type, row and meta also passed, but not used
				return data;
			};
		}
		else if ( typeof mSource === 'function' )
		{
			return function (data, type, row, meta) {
				return mSource( data, type, row, meta );
			};
		}
		else if ( typeof mSource === 'string' && (mSource.indexOf('.') !== -1 ||
			      mSource.indexOf('[') !== -1 || mSource.indexOf('(') !== -1) )
		{
			/* If there is a . in the source string then the data source is in a
			 * nested object so we loop over the data for each level to get the next
			 * level down. On each loop we test for undefined, and if found immediately
			 * return. This allows entire objects to be missing and sDefaultContent to
			 * be used if defined, rather than throwing an error
			 */
			var fetchData = function (data, type, src) {
				var arrayNotation, funcNotation, out, innerSrc;
	
				if ( src !== "" )
				{
					var a = _fnSplitObjNotation( src );
	
					for ( var i=0, iLen=a.length ; i<iLen ; i++ )
					{
						// Check if we are dealing with special notation
						arrayNotation = a[i].match(__reArray);
						funcNotation = a[i].match(__reFn);
	
						if ( arrayNotation )
						{
							// Array notation
							a[i] = a[i].replace(__reArray, '');
	
							// Condition allows simply [] to be passed in
							if ( a[i] !== "" ) {
								data = data[ a[i] ];
							}
							out = [];
	
							// Get the remainder of the nested object to get
							a.splice( 0, i+1 );
							innerSrc = a.join('.');
	
							// Traverse each entry in the array getting the properties requested
							if ( $.isArray( data ) ) {
								for ( var j=0, jLen=data.length ; j<jLen ; j++ ) {
									out.push( fetchData( data[j], type, innerSrc ) );
								}
							}
	
							// If a string is given in between the array notation indicators, that
							// is used to join the strings together, otherwise an array is returned
							var join = arrayNotation[0].substring(1, arrayNotation[0].length-1);
							data = (join==="") ? out : out.join(join);
	
							// The inner call to fetchData has already traversed through the remainder
							// of the source requested, so we exit from the loop
							break;
						}
						else if ( funcNotation )
						{
							// Function call
							a[i] = a[i].replace(__reFn, '');
							data = data[ a[i] ]();
							continue;
						}
	
						if ( data === null || data[ a[i] ] === undefined )
						{
							return undefined;
						}
						data = data[ a[i] ];
					}
				}
	
				return data;
			};
	
			return function (data, type) { // row and meta also passed, but not used
				return fetchData( data, type, mSource );
			};
		}
		else
		{
			/* Array or flat object mapping */
			return function (data, type) { // row and meta also passed, but not used
				return data[mSource];
			};
		}
	}
	
	
	/**
	 * Return a function that can be used to set data from a source object, taking
	 * into account the ability to use nested objects as a source
	 *  @param {string|int|function} mSource The data source for the object
	 *  @returns {function} Data set function
	 *  @memberof DataTable#oApi
	 */
	function _fnSetObjectDataFn( mSource )
	{
		if ( $.isPlainObject( mSource ) )
		{
			/* Unlike get, only the underscore (global) option is used for for
			 * setting data since we don't know the type here. This is why an object
			 * option is not documented for `mData` (which is read/write), but it is
			 * for `mRender` which is read only.
			 */
			return _fnSetObjectDataFn( mSource._ );
		}
		else if ( mSource === null )
		{
			/* Nothing to do when the data source is null */
			return function () {};
		}
		else if ( typeof mSource === 'function' )
		{
			return function (data, val, meta) {
				mSource( data, 'set', val, meta );
			};
		}
		else if ( typeof mSource === 'string' && (mSource.indexOf('.') !== -1 ||
			      mSource.indexOf('[') !== -1 || mSource.indexOf('(') !== -1) )
		{
			/* Like the get, we need to get data from a nested object */
			var setData = function (data, val, src) {
				var a = _fnSplitObjNotation( src ), b;
				var aLast = a[a.length-1];
				var arrayNotation, funcNotation, o, innerSrc;
	
				for ( var i=0, iLen=a.length-1 ; i<iLen ; i++ )
				{
					// Check if we are dealing with an array notation request
					arrayNotation = a[i].match(__reArray);
					funcNotation = a[i].match(__reFn);
	
					if ( arrayNotation )
					{
						a[i] = a[i].replace(__reArray, '');
						data[ a[i] ] = [];
	
						// Get the remainder of the nested object to set so we can recurse
						b = a.slice();
						b.splice( 0, i+1 );
						innerSrc = b.join('.');
	
						// Traverse each entry in the array setting the properties requested
						if ( $.isArray( val ) )
						{
							for ( var j=0, jLen=val.length ; j<jLen ; j++ )
							{
								o = {};
								setData( o, val[j], innerSrc );
								data[ a[i] ].push( o );
							}
						}
						else
						{
							// We've been asked to save data to an array, but it
							// isn't array data to be saved. Best that can be done
							// is to just save the value.
							data[ a[i] ] = val;
						}
	
						// The inner call to setData has already traversed through the remainder
						// of the source and has set the data, thus we can exit here
						return;
					}
					else if ( funcNotation )
					{
						// Function call
						a[i] = a[i].replace(__reFn, '');
						data = data[ a[i] ]( val );
					}
	
					// If the nested object doesn't currently exist - since we are
					// trying to set the value - create it
					if ( data[ a[i] ] === null || data[ a[i] ] === undefined )
					{
						data[ a[i] ] = {};
					}
					data = data[ a[i] ];
				}
	
				// Last item in the input - i.e, the actual set
				if ( aLast.match(__reFn ) )
				{
					// Function call
					data = data[ aLast.replace(__reFn, '') ]( val );
				}
				else
				{
					// If array notation is used, we just want to strip it and use the property name
					// and assign the value. If it isn't used, then we get the result we want anyway
					data[ aLast.replace(__reArray, '') ] = val;
				}
			};
	
			return function (data, val) { // meta is also passed in, but not used
				return setData( data, val, mSource );
			};
		}
		else
		{
			/* Array or flat object mapping */
			return function (data, val) { // meta is also passed in, but not used
				data[mSource] = val;
			};
		}
	}
	
	
	/**
	 * Return an array with the full table data
	 *  @param {object} oSettings dataTables settings object
	 *  @returns array {array} aData Master data array
	 *  @memberof DataTable#oApi
	 */
	function _fnGetDataMaster ( settings )
	{
		return _pluck( settings.aoData, '_aData' );
	}
	
	
	/**
	 * Nuke the table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnClearTable( settings )
	{
		settings.aoData.length = 0;
		settings.aiDisplayMaster.length = 0;
		settings.aiDisplay.length = 0;
		settings.aIds = {};
	}
	
	
	 /**
	 * Take an array of integers (index array) and remove a target integer (value - not
	 * the key!)
	 *  @param {array} a Index array to target
	 *  @param {int} iTarget value to find
	 *  @memberof DataTable#oApi
	 */
	function _fnDeleteIndex( a, iTarget, splice )
	{
		var iTargetIndex = -1;
	
		for ( var i=0, iLen=a.length ; i<iLen ; i++ )
		{
			if ( a[i] == iTarget )
			{
				iTargetIndex = i;
			}
			else if ( a[i] > iTarget )
			{
				a[i]--;
			}
		}
	
		if ( iTargetIndex != -1 && splice === undefined )
		{
			a.splice( iTargetIndex, 1 );
		}
	}
	
	
	/**
	 * Mark cached data as invalid such that a re-read of the data will occur when
	 * the cached data is next requested. Also update from the data source object.
	 *
	 * @param {object} settings DataTables settings object
	 * @param {int}    rowIdx   Row index to invalidate
	 * @param {string} [src]    Source to invalidate from: undefined, 'auto', 'dom'
	 *     or 'data'
	 * @param {int}    [colIdx] Column index to invalidate. If undefined the whole
	 *     row will be invalidated
	 * @memberof DataTable#oApi
	 *
	 * @todo For the modularisation of v1.11 this will need to become a callback, so
	 *   the sort and filter methods can subscribe to it. That will required
	 *   initialisation options for sorting, which is why it is not already baked in
	 */
	function _fnInvalidate( settings, rowIdx, src, colIdx )
	{
		var row = settings.aoData[ rowIdx ];
		var i, ien;
		var cellWrite = function ( cell, col ) {
			// This is very frustrating, but in IE if you just write directly
			// to innerHTML, and elements that are overwritten are GC'ed,
			// even if there is a reference to them elsewhere
			while ( cell.childNodes.length ) {
				cell.removeChild( cell.firstChild );
			}
	
			cell.innerHTML = _fnGetCellData( settings, rowIdx, col, 'display' );
		};
	
		// Are we reading last data from DOM or the data object?
		if ( src === 'dom' || ((! src || src === 'auto') && row.src === 'dom') ) {
			// Read the data from the DOM
			row._aData = _fnGetRowElements(
					settings, row, colIdx, colIdx === undefined ? undefined : row._aData
				)
				.data;
		}
		else {
			// Reading from data object, update the DOM
			var cells = row.anCells;
	
			if ( cells ) {
				if ( colIdx !== undefined ) {
					cellWrite( cells[colIdx], colIdx );
				}
				else {
					for ( i=0, ien=cells.length ; i<ien ; i++ ) {
						cellWrite( cells[i], i );
					}
				}
			}
		}
	
		// For both row and cell invalidation, the cached data for sorting and
		// filtering is nulled out
		row._aSortData = null;
		row._aFilterData = null;
	
		// Invalidate the type for a specific column (if given) or all columns since
		// the data might have changed
		var cols = settings.aoColumns;
		if ( colIdx !== undefined ) {
			cols[ colIdx ].sType = null;
		}
		else {
			for ( i=0, ien=cols.length ; i<ien ; i++ ) {
				cols[i].sType = null;
			}
	
			// Update DataTables special `DT_*` attributes for the row
			_fnRowAttributes( settings, row );
		}
	}
	
	
	/**
	 * Build a data source object from an HTML row, reading the contents of the
	 * cells that are in the row.
	 *
	 * @param {object} settings DataTables settings object
	 * @param {node|object} TR element from which to read data or existing row
	 *   object from which to re-read the data from the cells
	 * @param {int} [colIdx] Optional column index
	 * @param {array|object} [d] Data source object. If `colIdx` is given then this
	 *   parameter should also be given and will be used to write the data into.
	 *   Only the column in question will be written
	 * @returns {object} Object with two parameters: `data` the data read, in
	 *   document order, and `cells` and array of nodes (they can be useful to the
	 *   caller, so rather than needing a second traversal to get them, just return
	 *   them from here).
	 * @memberof DataTable#oApi
	 */
	function _fnGetRowElements( settings, row, colIdx, d )
	{
		var
			tds = [],
			td = row.firstChild,
			name, col, o, i=0, contents,
			columns = settings.aoColumns,
			objectRead = settings._rowReadObject;
	
		// Allow the data object to be passed in, or construct
		d = d !== undefined ?
			d :
			objectRead ?
				{} :
				[];
	
		var attr = function ( str, td  ) {
			if ( typeof str === 'string' ) {
				var idx = str.indexOf('@');
	
				if ( idx !== -1 ) {
					var attr = str.substring( idx+1 );
					var setter = _fnSetObjectDataFn( str );
					setter( d, td.getAttribute( attr ) );
				}
			}
		};
	
		// Read data from a cell and store into the data object
		var cellProcess = function ( cell ) {
			if ( colIdx === undefined || colIdx === i ) {
				col = columns[i];
				contents = $.trim(cell.innerHTML);
	
				if ( col && col._bAttrSrc ) {
					var setter = _fnSetObjectDataFn( col.mData._ );
					setter( d, contents );
	
					attr( col.mData.sort, cell );
					attr( col.mData.type, cell );
					attr( col.mData.filter, cell );
				}
				else {
					// Depending on the `data` option for the columns the data can
					// be read to either an object or an array.
					if ( objectRead ) {
						if ( ! col._setter ) {
							// Cache the setter function
							col._setter = _fnSetObjectDataFn( col.mData );
						}
						col._setter( d, contents );
					}
					else {
						d[i] = contents;
					}
				}
			}
	
			i++;
		};
	
		if ( td ) {
			// `tr` element was passed in
			while ( td ) {
				name = td.nodeName.toUpperCase();
	
				if ( name == "TD" || name == "TH" ) {
					cellProcess( td );
					tds.push( td );
				}
	
				td = td.nextSibling;
			}
		}
		else {
			// Existing row object passed in
			tds = row.anCells;
	
			for ( var j=0, jen=tds.length ; j<jen ; j++ ) {
				cellProcess( tds[j] );
			}
		}
	
		// Read the ID from the DOM if present
		var rowNode = row.firstChild ? row : row.nTr;
	
		if ( rowNode ) {
			var id = rowNode.getAttribute( 'id' );
	
			if ( id ) {
				_fnSetObjectDataFn( settings.rowId )( d, id );
			}
		}
	
		return {
			data: d,
			cells: tds
		};
	}
	/**
	 * Create a new TR element (and it's TD children) for a row
	 *  @param {object} oSettings dataTables settings object
	 *  @param {int} iRow Row to consider
	 *  @param {node} [nTrIn] TR element to add to the table - optional. If not given,
	 *    DataTables will create a row automatically
	 *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
	 *    if nTr is.
	 *  @memberof DataTable#oApi
	 */
	function _fnCreateTr ( oSettings, iRow, nTrIn, anTds )
	{
		var
			row = oSettings.aoData[iRow],
			rowData = row._aData,
			cells = [],
			nTr, nTd, oCol,
			i, iLen;
	
		if ( row.nTr === null )
		{
			nTr = nTrIn || document.createElement('tr');
	
			row.nTr = nTr;
			row.anCells = cells;
	
			/* Use a private property on the node to allow reserve mapping from the node
			 * to the aoData array for fast look up
			 */
			nTr._DT_RowIndex = iRow;
	
			/* Special parameters can be given by the data source to be used on the row */
			_fnRowAttributes( oSettings, row );
	
			/* Process each column */
			for ( i=0, iLen=oSettings.aoColumns.length ; i<iLen ; i++ )
			{
				oCol = oSettings.aoColumns[i];
	
				nTd = nTrIn ? anTds[i] : document.createElement( oCol.sCellType );
				nTd._DT_CellIndex = {
					row: iRow,
					column: i
				};
				
				cells.push( nTd );
	
				// Need to create the HTML if new, or if a rendering function is defined
				if ( (!nTrIn || oCol.mRender || oCol.mData !== i) &&
					 (!$.isPlainObject(oCol.mData) || oCol.mData._ !== i+'.display')
				) {
					nTd.innerHTML = _fnGetCellData( oSettings, iRow, i, 'display' );
				}
	
				/* Add user defined class */
				if ( oCol.sClass )
				{
					nTd.className += ' '+oCol.sClass;
				}
	
				// Visibility - add or remove as required
				if ( oCol.bVisible && ! nTrIn )
				{
					nTr.appendChild( nTd );
				}
				else if ( ! oCol.bVisible && nTrIn )
				{
					nTd.parentNode.removeChild( nTd );
				}
	
				if ( oCol.fnCreatedCell )
				{
					oCol.fnCreatedCell.call( oSettings.oInstance,
						nTd, _fnGetCellData( oSettings, iRow, i ), rowData, iRow, i
					);
				}
			}
	
			_fnCallbackFire( oSettings, 'aoRowCreatedCallback', null, [nTr, rowData, iRow] );
		}
	
		// Remove once webkit bug 131819 and Chromium bug 365619 have been resolved
		// and deployed
		row.nTr.setAttribute( 'role', 'row' );
	}
	
	
	/**
	 * Add attributes to a row based on the special `DT_*` parameters in a data
	 * source object.
	 *  @param {object} settings DataTables settings object
	 *  @param {object} DataTables row object for the row to be modified
	 *  @memberof DataTable#oApi
	 */
	function _fnRowAttributes( settings, row )
	{
		var tr = row.nTr;
		var data = row._aData;
	
		if ( tr ) {
			var id = settings.rowIdFn( data );
	
			if ( id ) {
				tr.id = id;
			}
	
			if ( data.DT_RowClass ) {
				// Remove any classes added by DT_RowClass before
				var a = data.DT_RowClass.split(' ');
				row.__rowc = row.__rowc ?
					_unique( row.__rowc.concat( a ) ) :
					a;
	
				$(tr)
					.removeClass( row.__rowc.join(' ') )
					.addClass( data.DT_RowClass );
			}
	
			if ( data.DT_RowAttr ) {
				$(tr).attr( data.DT_RowAttr );
			}
	
			if ( data.DT_RowData ) {
				$(tr).data( data.DT_RowData );
			}
		}
	}
	
	
	/**
	 * Create the HTML header for the table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnBuildHead( oSettings )
	{
		var i, ien, cell, row, column;
		var thead = oSettings.nTHead;
		var tfoot = oSettings.nTFoot;
		var createHeader = $('th, td', thead).length === 0;
		var classes = oSettings.oClasses;
		var columns = oSettings.aoColumns;
	
		if ( createHeader ) {
			row = $('<tr/>').appendTo( thead );
		}
	
		for ( i=0, ien=columns.length ; i<ien ; i++ ) {
			column = columns[i];
			cell = $( column.nTh ).addClass( column.sClass );
	
			if ( createHeader ) {
				cell.appendTo( row );
			}
	
			// 1.11 move into sorting
			if ( oSettings.oFeatures.bSort ) {
				cell.addClass( column.sSortingClass );
	
				if ( column.bSortable !== false ) {
					cell
						.attr( 'tabindex', oSettings.iTabIndex )
						.attr( 'aria-controls', oSettings.sTableId );
	
					_fnSortAttachListener( oSettings, column.nTh, i );
				}
			}
	
			if ( column.sTitle != cell[0].innerHTML ) {
				cell.html( column.sTitle );
			}
	
			_fnRenderer( oSettings, 'header' )(
				oSettings, cell, column, classes
			);
		}
	
		if ( createHeader ) {
			_fnDetectHeader( oSettings.aoHeader, thead );
		}
		
		/* ARIA role for the rows */
	 	$(thead).find('>tr').attr('role', 'row');
	
		/* Deal with the footer - add classes if required */
		$(thead).find('>tr>th, >tr>td').addClass( classes.sHeaderTH );
		$(tfoot).find('>tr>th, >tr>td').addClass( classes.sFooterTH );
	
		// Cache the footer cells. Note that we only take the cells from the first
		// row in the footer. If there is more than one row the user wants to
		// interact with, they need to use the table().foot() method. Note also this
		// allows cells to be used for multiple columns using colspan
		if ( tfoot !== null ) {
			var cells = oSettings.aoFooter[0];
	
			for ( i=0, ien=cells.length ; i<ien ; i++ ) {
				column = columns[i];
				column.nTf = cells[i].cell;
	
				if ( column.sClass ) {
					$(column.nTf).addClass( column.sClass );
				}
			}
		}
	}
	
	
	/**
	 * Draw the header (or footer) element based on the column visibility states. The
	 * methodology here is to use the layout array from _fnDetectHeader, modified for
	 * the instantaneous column visibility, to construct the new layout. The grid is
	 * traversed over cell at a time in a rows x columns grid fashion, although each
	 * cell insert can cover multiple elements in the grid - which is tracks using the
	 * aApplied array. Cell inserts in the grid will only occur where there isn't
	 * already a cell in that position.
	 *  @param {object} oSettings dataTables settings object
	 *  @param array {objects} aoSource Layout array from _fnDetectHeader
	 *  @param {boolean} [bIncludeHidden=false] If true then include the hidden columns in the calc,
	 *  @memberof DataTable#oApi
	 */
	function _fnDrawHead( oSettings, aoSource, bIncludeHidden )
	{
		var i, iLen, j, jLen, k, kLen, n, nLocalTr;
		var aoLocal = [];
		var aApplied = [];
		var iColumns = oSettings.aoColumns.length;
		var iRowspan, iColspan;
	
		if ( ! aoSource )
		{
			return;
		}
	
		if (  bIncludeHidden === undefined )
		{
			bIncludeHidden = false;
		}
	
		/* Make a copy of the master layout array, but without the visible columns in it */
		for ( i=0, iLen=aoSource.length ; i<iLen ; i++ )
		{
			aoLocal[i] = aoSource[i].slice();
			aoLocal[i].nTr = aoSource[i].nTr;
	
			/* Remove any columns which are currently hidden */
			for ( j=iColumns-1 ; j>=0 ; j-- )
			{
				if ( !oSettings.aoColumns[j].bVisible && !bIncludeHidden )
				{
					aoLocal[i].splice( j, 1 );
				}
			}
	
			/* Prep the applied array - it needs an element for each row */
			aApplied.push( [] );
		}
	
		for ( i=0, iLen=aoLocal.length ; i<iLen ; i++ )
		{
			nLocalTr = aoLocal[i].nTr;
	
			/* All cells are going to be replaced, so empty out the row */
			if ( nLocalTr )
			{
				while( (n = nLocalTr.firstChild) )
				{
					nLocalTr.removeChild( n );
				}
			}
	
			for ( j=0, jLen=aoLocal[i].length ; j<jLen ; j++ )
			{
				iRowspan = 1;
				iColspan = 1;
	
				/* Check to see if there is already a cell (row/colspan) covering our target
				 * insert point. If there is, then there is nothing to do.
				 */
				if ( aApplied[i][j] === undefined )
				{
					nLocalTr.appendChild( aoLocal[i][j].cell );
					aApplied[i][j] = 1;
	
					/* Expand the cell to cover as many rows as needed */
					while ( aoLocal[i+iRowspan] !== undefined &&
					        aoLocal[i][j].cell == aoLocal[i+iRowspan][j].cell )
					{
						aApplied[i+iRowspan][j] = 1;
						iRowspan++;
					}
	
					/* Expand the cell to cover as many columns as needed */
					while ( aoLocal[i][j+iColspan] !== undefined &&
					        aoLocal[i][j].cell == aoLocal[i][j+iColspan].cell )
					{
						/* Must update the applied array over the rows for the columns */
						for ( k=0 ; k<iRowspan ; k++ )
						{
							aApplied[i+k][j+iColspan] = 1;
						}
						iColspan++;
					}
	
					/* Do the actual expansion in the DOM */
					$(aoLocal[i][j].cell)
						.attr('rowspan', iRowspan)
						.attr('colspan', iColspan);
				}
			}
		}
	}
	
	
	/**
	 * Insert the required TR nodes into the table for display
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnDraw( oSettings )
	{
		/* Provide a pre-callback function which can be used to cancel the draw is false is returned */
		var aPreDraw = _fnCallbackFire( oSettings, 'aoPreDrawCallback', 'preDraw', [oSettings] );
		if ( $.inArray( false, aPreDraw ) !== -1 )
		{
			_fnProcessingDisplay( oSettings, false );
			return;
		}
	
		var i, iLen, n;
		var anRows = [];
		var iRowCount = 0;
		var asStripeClasses = oSettings.asStripeClasses;
		var iStripes = asStripeClasses.length;
		var iOpenRows = oSettings.aoOpenRows.length;
		var oLang = oSettings.oLanguage;
		var iInitDisplayStart = oSettings.iInitDisplayStart;
		var bServerSide = _fnDataSource( oSettings ) == 'ssp';
		var aiDisplay = oSettings.aiDisplay;
	
		oSettings.bDrawing = true;
	
		/* Check and see if we have an initial draw position from state saving */
		if ( iInitDisplayStart !== undefined && iInitDisplayStart !== -1 )
		{
			oSettings._iDisplayStart = bServerSide ?
				iInitDisplayStart :
				iInitDisplayStart >= oSettings.fnRecordsDisplay() ?
					0 :
					iInitDisplayStart;
	
			oSettings.iInitDisplayStart = -1;
		}
	
		var iDisplayStart = oSettings._iDisplayStart;
		var iDisplayEnd = oSettings.fnDisplayEnd();
	
		/* Server-side processing draw intercept */
		if ( oSettings.bDeferLoading )
		{
			oSettings.bDeferLoading = false;
			oSettings.iDraw++;
			_fnProcessingDisplay( oSettings, false );
		}
		else if ( !bServerSide )
		{
			oSettings.iDraw++;
		}
		else if ( !oSettings.bDestroying && !_fnAjaxUpdate( oSettings ) )
		{
			return;
		}
	
		if ( aiDisplay.length !== 0 )
		{
			var iStart = bServerSide ? 0 : iDisplayStart;
			var iEnd = bServerSide ? oSettings.aoData.length : iDisplayEnd;
	
			for ( var j=iStart ; j<iEnd ; j++ )
			{
				var iDataIndex = aiDisplay[j];
				var aoData = oSettings.aoData[ iDataIndex ];
				if ( aoData.nTr === null )
				{
					_fnCreateTr( oSettings, iDataIndex );
				}
	
				var nRow = aoData.nTr;
	
				/* Remove the old striping classes and then add the new one */
				if ( iStripes !== 0 )
				{
					var sStripe = asStripeClasses[ iRowCount % iStripes ];
					if ( aoData._sRowStripe != sStripe )
					{
						$(nRow).removeClass( aoData._sRowStripe ).addClass( sStripe );
						aoData._sRowStripe = sStripe;
					}
				}
	
				// Row callback functions - might want to manipulate the row
				// iRowCount and j are not currently documented. Are they at all
				// useful?
				_fnCallbackFire( oSettings, 'aoRowCallback', null,
					[nRow, aoData._aData, iRowCount, j] );
	
				anRows.push( nRow );
				iRowCount++;
			}
		}
		else
		{
			/* Table is empty - create a row with an empty message in it */
			var sZero = oLang.sZeroRecords;
			if ( oSettings.iDraw == 1 &&  _fnDataSource( oSettings ) == 'ajax' )
			{
				sZero = oLang.sLoadingRecords;
			}
			else if ( oLang.sEmptyTable && oSettings.fnRecordsTotal() === 0 )
			{
				sZero = oLang.sEmptyTable;
			}
	
			anRows[ 0 ] = $( '<tr/>', { 'class': iStripes ? asStripeClasses[0] : '' } )
				.append( $('<td />', {
					'valign':  'top',
					'colSpan': _fnVisbleColumns( oSettings ),
					'class':   oSettings.oClasses.sRowEmpty
				} ).html( sZero ) )[0];
		}
	
		/* Header and footer callbacks */
		_fnCallbackFire( oSettings, 'aoHeaderCallback', 'header', [ $(oSettings.nTHead).children('tr')[0],
			_fnGetDataMaster( oSettings ), iDisplayStart, iDisplayEnd, aiDisplay ] );
	
		_fnCallbackFire( oSettings, 'aoFooterCallback', 'footer', [ $(oSettings.nTFoot).children('tr')[0],
			_fnGetDataMaster( oSettings ), iDisplayStart, iDisplayEnd, aiDisplay ] );
	
		var body = $(oSettings.nTBody);
	
		body.children().detach();
		body.append( $(anRows) );
	
		/* Call all required callback functions for the end of a draw */
		_fnCallbackFire( oSettings, 'aoDrawCallback', 'draw', [oSettings] );
	
		/* Draw is complete, sorting and filtering must be as well */
		oSettings.bSorted = false;
		oSettings.bFiltered = false;
		oSettings.bDrawing = false;
	}
	
	
	/**
	 * Redraw the table - taking account of the various features which are enabled
	 *  @param {object} oSettings dataTables settings object
	 *  @param {boolean} [holdPosition] Keep the current paging position. By default
	 *    the paging is reset to the first page
	 *  @memberof DataTable#oApi
	 */
	function _fnReDraw( settings, holdPosition )
	{
		var
			features = settings.oFeatures,
			sort     = features.bSort,
			filter   = features.bFilter;
	
		if ( sort ) {
			_fnSort( settings );
		}
	
		if ( filter ) {
			_fnFilterComplete( settings, settings.oPreviousSearch );
		}
		else {
			// No filtering, so we want to just use the display master
			settings.aiDisplay = settings.aiDisplayMaster.slice();
		}
	
		if ( holdPosition !== true ) {
			settings._iDisplayStart = 0;
		}
	
		// Let any modules know about the draw hold position state (used by
		// scrolling internally)
		settings._drawHold = holdPosition;
	
		_fnDraw( settings );
	
		settings._drawHold = false;
	}
	
	
	/**
	 * Add the options to the page HTML for the table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnAddOptionsHtml ( oSettings )
	{
		var classes = oSettings.oClasses;
		var table = $(oSettings.nTable);
		var holding = $('<div/>').insertBefore( table ); // Holding element for speed
		var features = oSettings.oFeatures;
	
		// All DataTables are wrapped in a div
		var insert = $('<div/>', {
			id:      oSettings.sTableId+'_wrapper',
			'class': classes.sWrapper + (oSettings.nTFoot ? '' : ' '+classes.sNoFooter)
		} );
	
		oSettings.nHolding = holding[0];
		oSettings.nTableWrapper = insert[0];
		oSettings.nTableReinsertBefore = oSettings.nTable.nextSibling;
	
		/* Loop over the user set positioning and place the elements as needed */
		var aDom = oSettings.sDom.split('');
		var featureNode, cOption, nNewNode, cNext, sAttr, j;
		for ( var i=0 ; i<aDom.length ; i++ )
		{
			featureNode = null;
			cOption = aDom[i];
	
			if ( cOption == '<' )
			{
				/* New container div */
				nNewNode = $('<div/>')[0];
	
				/* Check to see if we should append an id and/or a class name to the container */
				cNext = aDom[i+1];
				if ( cNext == "'" || cNext == '"' )
				{
					sAttr = "";
					j = 2;
					while ( aDom[i+j] != cNext )
					{
						sAttr += aDom[i+j];
						j++;
					}
	
					/* Replace jQuery UI constants @todo depreciated */
					if ( sAttr == "H" )
					{
						sAttr = classes.sJUIHeader;
					}
					else if ( sAttr == "F" )
					{
						sAttr = classes.sJUIFooter;
					}
	
					/* The attribute can be in the format of "#id.class", "#id" or "class" This logic
					 * breaks the string into parts and applies them as needed
					 */
					if ( sAttr.indexOf('.') != -1 )
					{
						var aSplit = sAttr.split('.');
						nNewNode.id = aSplit[0].substr(1, aSplit[0].length-1);
						nNewNode.className = aSplit[1];
					}
					else if ( sAttr.charAt(0) == "#" )
					{
						nNewNode.id = sAttr.substr(1, sAttr.length-1);
					}
					else
					{
						nNewNode.className = sAttr;
					}
	
					i += j; /* Move along the position array */
				}
	
				insert.append( nNewNode );
				insert = $(nNewNode);
			}
			else if ( cOption == '>' )
			{
				/* End container div */
				insert = insert.parent();
			}
			// @todo Move options into their own plugins?
			else if ( cOption == 'l' && features.bPaginate && features.bLengthChange )
			{
				/* Length */
				featureNode = _fnFeatureHtmlLength( oSettings );
			}
			else if ( cOption == 'f' && features.bFilter )
			{
				/* Filter */
				featureNode = _fnFeatureHtmlFilter( oSettings );
			}
			else if ( cOption == 'r' && features.bProcessing )
			{
				/* pRocessing */
				featureNode = _fnFeatureHtmlProcessing( oSettings );
			}
			else if ( cOption == 't' )
			{
				/* Table */
				featureNode = _fnFeatureHtmlTable( oSettings );
			}
			else if ( cOption ==  'i' && features.bInfo )
			{
				/* Info */
				featureNode = _fnFeatureHtmlInfo( oSettings );
			}
			else if ( cOption == 'p' && features.bPaginate )
			{
				/* Pagination */
				featureNode = _fnFeatureHtmlPaginate( oSettings );
			}
			else if ( DataTable.ext.feature.length !== 0 )
			{
				/* Plug-in features */
				var aoFeatures = DataTable.ext.feature;
				for ( var k=0, kLen=aoFeatures.length ; k<kLen ; k++ )
				{
					if ( cOption == aoFeatures[k].cFeature )
					{
						featureNode = aoFeatures[k].fnInit( oSettings );
						break;
					}
				}
			}
	
			/* Add to the 2D features array */
			if ( featureNode )
			{
				var aanFeatures = oSettings.aanFeatures;
	
				if ( ! aanFeatures[cOption] )
				{
					aanFeatures[cOption] = [];
				}
	
				aanFeatures[cOption].push( featureNode );
				insert.append( featureNode );
			}
		}
	
		/* Built our DOM structure - replace the holding div with what we want */
		holding.replaceWith( insert );
		oSettings.nHolding = null;
	}
	
	
	/**
	 * Use the DOM source to create up an array of header cells. The idea here is to
	 * create a layout grid (array) of rows x columns, which contains a reference
	 * to the cell that that point in the grid (regardless of col/rowspan), such that
	 * any column / row could be removed and the new grid constructed
	 *  @param array {object} aLayout Array to store the calculated layout in
	 *  @param {node} nThead The header/footer element for the table
	 *  @memberof DataTable#oApi
	 */
	function _fnDetectHeader ( aLayout, nThead )
	{
		var nTrs = $(nThead).children('tr');
		var nTr, nCell;
		var i, k, l, iLen, jLen, iColShifted, iColumn, iColspan, iRowspan;
		var bUnique;
		var fnShiftCol = function ( a, i, j ) {
			var k = a[i];
	                while ( k[j] ) {
				j++;
			}
			return j;
		};
	
		aLayout.splice( 0, aLayout.length );
	
		/* We know how many rows there are in the layout - so prep it */
		for ( i=0, iLen=nTrs.length ; i<iLen ; i++ )
		{
			aLayout.push( [] );
		}
	
		/* Calculate a layout array */
		for ( i=0, iLen=nTrs.length ; i<iLen ; i++ )
		{
			nTr = nTrs[i];
			iColumn = 0;
	
			/* For every cell in the row... */
			nCell = nTr.firstChild;
			while ( nCell ) {
				if ( nCell.nodeName.toUpperCase() == "TD" ||
				     nCell.nodeName.toUpperCase() == "TH" )
				{
					/* Get the col and rowspan attributes from the DOM and sanitise them */
					iColspan = nCell.getAttribute('colspan') * 1;
					iRowspan = nCell.getAttribute('rowspan') * 1;
					iColspan = (!iColspan || iColspan===0 || iColspan===1) ? 1 : iColspan;
					iRowspan = (!iRowspan || iRowspan===0 || iRowspan===1) ? 1 : iRowspan;
	
					/* There might be colspan cells already in this row, so shift our target
					 * accordingly
					 */
					iColShifted = fnShiftCol( aLayout, i, iColumn );
	
					/* Cache calculation for unique columns */
					bUnique = iColspan === 1 ? true : false;
	
					/* If there is col / rowspan, copy the information into the layout grid */
					for ( l=0 ; l<iColspan ; l++ )
					{
						for ( k=0 ; k<iRowspan ; k++ )
						{
							aLayout[i+k][iColShifted+l] = {
								"cell": nCell,
								"unique": bUnique
							};
							aLayout[i+k].nTr = nTr;
						}
					}
				}
				nCell = nCell.nextSibling;
			}
		}
	}
	
	
	/**
	 * Get an array of unique th elements, one for each column
	 *  @param {object} oSettings dataTables settings object
	 *  @param {node} nHeader automatically detect the layout from this node - optional
	 *  @param {array} aLayout thead/tfoot layout from _fnDetectHeader - optional
	 *  @returns array {node} aReturn list of unique th's
	 *  @memberof DataTable#oApi
	 */
	function _fnGetUniqueThs ( oSettings, nHeader, aLayout )
	{
		var aReturn = [];
		if ( !aLayout )
		{
			aLayout = oSettings.aoHeader;
			if ( nHeader )
			{
				aLayout = [];
				_fnDetectHeader( aLayout, nHeader );
			}
		}
	
		for ( var i=0, iLen=aLayout.length ; i<iLen ; i++ )
		{
			for ( var j=0, jLen=aLayout[i].length ; j<jLen ; j++ )
			{
				if ( aLayout[i][j].unique &&
					 (!aReturn[j] || !oSettings.bSortCellsTop) )
				{
					aReturn[j] = aLayout[i][j].cell;
				}
			}
		}
	
		return aReturn;
	}
	
	/**
	 * Create an Ajax call based on the table's settings, taking into account that
	 * parameters can have multiple forms, and backwards compatibility.
	 *
	 * @param {object} oSettings dataTables settings object
	 * @param {array} data Data to send to the server, required by
	 *     DataTables - may be augmented by developer callbacks
	 * @param {function} fn Callback function to run when data is obtained
	 */
	function _fnBuildAjax( oSettings, data, fn )
	{
		// Compatibility with 1.9-, allow fnServerData and event to manipulate
		_fnCallbackFire( oSettings, 'aoServerParams', 'serverParams', [data] );
	
		// Convert to object based for 1.10+ if using the old array scheme which can
		// come from server-side processing or serverParams
		if ( data && $.isArray(data) ) {
			var tmp = {};
			var rbracket = /(.*?)\[\]$/;
	
			$.each( data, function (key, val) {
				var match = val.name.match(rbracket);
	
				if ( match ) {
					// Support for arrays
					var name = match[0];
	
					if ( ! tmp[ name ] ) {
						tmp[ name ] = [];
					}
					tmp[ name ].push( val.value );
				}
				else {
					tmp[val.name] = val.value;
				}
			} );
			data = tmp;
		}
	
		var ajaxData;
		var ajax = oSettings.ajax;
		var instance = oSettings.oInstance;
		var callback = function ( json ) {
			_fnCallbackFire( oSettings, null, 'xhr', [oSettings, json, oSettings.jqXHR] );
			fn( json );
		};
	
		if ( $.isPlainObject( ajax ) && ajax.data )
		{
			ajaxData = ajax.data;
	
			var newData = $.isFunction( ajaxData ) ?
				ajaxData( data, oSettings ) :  // fn can manipulate data or return
				ajaxData;                      // an object object or array to merge
	
			// If the function returned something, use that alone
			data = $.isFunction( ajaxData ) && newData ?
				newData :
				$.extend( true, data, newData );
	
			// Remove the data property as we've resolved it already and don't want
			// jQuery to do it again (it is restored at the end of the function)
			delete ajax.data;
		}
	
		var baseAjax = {
			"data": data,
			"success": function (json) {
				var error = json.error || json.sError;
				if ( error ) {
					_fnLog( oSettings, 0, error );
				}
	
				oSettings.json = json;
				callback( json );
			},
			"dataType": "json",
			"cache": false,
			"type": oSettings.sServerMethod,
			"error": function (xhr, error, thrown) {
				var ret = _fnCallbackFire( oSettings, null, 'xhr', [oSettings, null, oSettings.jqXHR] );
	
				if ( $.inArray( true, ret ) === -1 ) {
					if ( error == "parsererror" ) {
						_fnLog( oSettings, 0, 'Invalid JSON response', 1 );
					}
					else if ( xhr.readyState === 4 ) {
						_fnLog( oSettings, 0, 'Ajax error', 7 );
					}
				}
	
				_fnProcessingDisplay( oSettings, false );
			}
		};
	
		// Store the data submitted for the API
		oSettings.oAjaxData = data;
	
		// Allow plug-ins and external processes to modify the data
		_fnCallbackFire( oSettings, null, 'preXhr', [oSettings, data] );
	
		if ( oSettings.fnServerData )
		{
			// DataTables 1.9- compatibility
			oSettings.fnServerData.call( instance,
				oSettings.sAjaxSource,
				$.map( data, function (val, key) { // Need to convert back to 1.9 trad format
					return { name: key, value: val };
				} ),
				callback,
				oSettings
			);
		}
		else if ( oSettings.sAjaxSource || typeof ajax === 'string' )
		{
			// DataTables 1.9- compatibility
			oSettings.jqXHR = $.ajax( $.extend( baseAjax, {
				url: ajax || oSettings.sAjaxSource
			} ) );
		}
		else if ( $.isFunction( ajax ) )
		{
			// Is a function - let the caller define what needs to be done
			oSettings.jqXHR = ajax.call( instance, data, callback, oSettings );
		}
		else
		{
			// Object to extend the base settings
			oSettings.jqXHR = $.ajax( $.extend( baseAjax, ajax ) );
	
			// Restore for next time around
			ajax.data = ajaxData;
		}
	}
	
	
	/**
	 * Update the table using an Ajax call
	 *  @param {object} settings dataTables settings object
	 *  @returns {boolean} Block the table drawing or not
	 *  @memberof DataTable#oApi
	 */
	function _fnAjaxUpdate( settings )
	{
		if ( settings.bAjaxDataGet ) {
			settings.iDraw++;
			_fnProcessingDisplay( settings, true );
	
			_fnBuildAjax(
				settings,
				_fnAjaxParameters( settings ),
				function(json) {
					_fnAjaxUpdateDraw( settings, json );
				}
			);
	
			return false;
		}
		return true;
	}
	
	
	/**
	 * Build up the parameters in an object needed for a server-side processing
	 * request. Note that this is basically done twice, is different ways - a modern
	 * method which is used by default in DataTables 1.10 which uses objects and
	 * arrays, or the 1.9- method with is name / value pairs. 1.9 method is used if
	 * the sAjaxSource option is used in the initialisation, or the legacyAjax
	 * option is set.
	 *  @param {object} oSettings dataTables settings object
	 *  @returns {bool} block the table drawing or not
	 *  @memberof DataTable#oApi
	 */
	function _fnAjaxParameters( settings )
	{
		var
			columns = settings.aoColumns,
			columnCount = columns.length,
			features = settings.oFeatures,
			preSearch = settings.oPreviousSearch,
			preColSearch = settings.aoPreSearchCols,
			i, data = [], dataProp, column, columnSearch,
			sort = _fnSortFlatten( settings ),
			displayStart = settings._iDisplayStart,
			displayLength = features.bPaginate !== false ?
				settings._iDisplayLength :
				-1;
	
		var param = function ( name, value ) {
			data.push( { 'name': name, 'value': value } );
		};
	
		// DataTables 1.9- compatible method
		param( 'sEcho',          settings.iDraw );
		param( 'iColumns',       columnCount );
		param( 'sColumns',       _pluck( columns, 'sName' ).join(',') );
		param( 'iDisplayStart',  displayStart );
		param( 'iDisplayLength', displayLength );
	
		// DataTables 1.10+ method
		var d = {
			draw:    settings.iDraw,
			columns: [],
			order:   [],
			start:   displayStart,
			length:  displayLength,
			search:  {
				value: preSearch.sSearch,
				regex: preSearch.bRegex
			}
		};
	
		for ( i=0 ; i<columnCount ; i++ ) {
			column = columns[i];
			columnSearch = preColSearch[i];
			dataProp = typeof column.mData=="function" ? 'function' : column.mData ;
	
			d.columns.push( {
				data:       dataProp,
				name:       column.sName,
				searchable: column.bSearchable,
				orderable:  column.bSortable,
				search:     {
					value: columnSearch.sSearch,
					regex: columnSearch.bRegex
				}
			} );
	
			param( "mDataProp_"+i, dataProp );
	
			if ( features.bFilter ) {
				param( 'sSearch_'+i,     columnSearch.sSearch );
				param( 'bRegex_'+i,      columnSearch.bRegex );
				param( 'bSearchable_'+i, column.bSearchable );
			}
	
			if ( features.bSort ) {
				param( 'bSortable_'+i, column.bSortable );
			}
		}
	
		if ( features.bFilter ) {
			param( 'sSearch', preSearch.sSearch );
			param( 'bRegex', preSearch.bRegex );
		}
	
		if ( features.bSort ) {
			$.each( sort, function ( i, val ) {
				d.order.push( { column: val.col, dir: val.dir } );
	
				param( 'iSortCol_'+i, val.col );
				param( 'sSortDir_'+i, val.dir );
			} );
	
			param( 'iSortingCols', sort.length );
		}
	
		// If the legacy.ajax parameter is null, then we automatically decide which
		// form to use, based on sAjaxSource
		var legacy = DataTable.ext.legacy.ajax;
		if ( legacy === null ) {
			return settings.sAjaxSource ? data : d;
		}
	
		// Otherwise, if legacy has been specified then we use that to decide on the
		// form
		return legacy ? data : d;
	}
	
	
	/**
	 * Data the data from the server (nuking the old) and redraw the table
	 *  @param {object} oSettings dataTables settings object
	 *  @param {object} json json data return from the server.
	 *  @param {string} json.sEcho Tracking flag for DataTables to match requests
	 *  @param {int} json.iTotalRecords Number of records in the data set, not accounting for filtering
	 *  @param {int} json.iTotalDisplayRecords Number of records in the data set, accounting for filtering
	 *  @param {array} json.aaData The data to display on this page
	 *  @param {string} [json.sColumns] Column ordering (sName, comma separated)
	 *  @memberof DataTable#oApi
	 */
	function _fnAjaxUpdateDraw ( settings, json )
	{
		// v1.10 uses camelCase variables, while 1.9 uses Hungarian notation.
		// Support both
		var compat = function ( old, modern ) {
			return json[old] !== undefined ? json[old] : json[modern];
		};
	
		var data = _fnAjaxDataSrc( settings, json );
		var draw            = compat( 'sEcho',                'draw' );
		var recordsTotal    = compat( 'iTotalRecords',        'recordsTotal' );
		var recordsFiltered = compat( 'iTotalDisplayRecords', 'recordsFiltered' );
	
		if ( draw ) {
			// Protect against out of sequence returns
			if ( draw*1 < settings.iDraw ) {
				return;
			}
			settings.iDraw = draw * 1;
		}
	
		_fnClearTable( settings );
		settings._iRecordsTotal   = parseInt(recordsTotal, 10);
		settings._iRecordsDisplay = parseInt(recordsFiltered, 10);
	
		for ( var i=0, ien=data.length ; i<ien ; i++ ) {
			_fnAddData( settings, data[i] );
		}
		settings.aiDisplay = settings.aiDisplayMaster.slice();
	
		settings.bAjaxDataGet = false;
		_fnDraw( settings );
	
		if ( ! settings._bInitComplete ) {
			_fnInitComplete( settings, json );
		}
	
		settings.bAjaxDataGet = true;
		_fnProcessingDisplay( settings, false );
	}
	
	
	/**
	 * Get the data from the JSON data source to use for drawing a table. Using
	 * `_fnGetObjectDataFn` allows the data to be sourced from a property of the
	 * source object, or from a processing function.
	 *  @param {object} oSettings dataTables settings object
	 *  @param  {object} json Data source object / array from the server
	 *  @return {array} Array of data to use
	 */
	function _fnAjaxDataSrc ( oSettings, json )
	{
		var dataSrc = $.isPlainObject( oSettings.ajax ) && oSettings.ajax.dataSrc !== undefined ?
			oSettings.ajax.dataSrc :
			oSettings.sAjaxDataProp; // Compatibility with 1.9-.
	
		// Compatibility with 1.9-. In order to read from aaData, check if the
		// default has been changed, if not, check for aaData
		if ( dataSrc === 'data' ) {
			return json.aaData || json[dataSrc];
		}
	
		return dataSrc !== "" ?
			_fnGetObjectDataFn( dataSrc )( json ) :
			json;
	}
	
	/**
	 * Generate the node required for filtering text
	 *  @returns {node} Filter control element
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnFeatureHtmlFilter ( settings )
	{
		var classes = settings.oClasses;
		var tableId = settings.sTableId;
		var language = settings.oLanguage;
		var previousSearch = settings.oPreviousSearch;
		var features = settings.aanFeatures;
		var input = '<input type="search" class="'+classes.sFilterInput+'"/>';
	
		var str = language.sSearch;
		str = str.match(/_INPUT_/) ?
			str.replace('_INPUT_', input) :
			str+input;
	
		var filter = $('<div/>', {
				'id': ! features.f ? tableId+'_filter' : null,
				'class': classes.sFilter
			} )
			.append( $('<label/>' ).append( str ) );
	
		var searchFn = function() {
			/* Update all other filter input elements for the new display */
			var n = features.f;
			var val = !this.value ? "" : this.value; // mental IE8 fix :-(
	
			/* Now do the filter */
			if ( val != previousSearch.sSearch ) {
				_fnFilterComplete( settings, {
					"sSearch": val,
					"bRegex": previousSearch.bRegex,
					"bSmart": previousSearch.bSmart ,
					"bCaseInsensitive": previousSearch.bCaseInsensitive
				} );
	
				// Need to redraw, without resorting
				settings._iDisplayStart = 0;
				_fnDraw( settings );
			}
		};
	
		var searchDelay = settings.searchDelay !== null ?
			settings.searchDelay :
			_fnDataSource( settings ) === 'ssp' ?
				400 :
				0;
	
		var jqFilter = $('input', filter)
			.val( previousSearch.sSearch )
			.attr( 'placeholder', language.sSearchPlaceholder )
			.on(
				'keyup.DT search.DT input.DT paste.DT cut.DT',
				searchDelay ?
					_fnThrottle( searchFn, searchDelay ) :
					searchFn
			)
			.on( 'keypress.DT', function(e) {
				/* Prevent form submission */
				if ( e.keyCode == 13 ) {
					return false;
				}
			} )
			.attr('aria-controls', tableId);
	
		// Update the input elements whenever the table is filtered
		$(settings.nTable).on( 'search.dt.DT', function ( ev, s ) {
			if ( settings === s ) {
				// IE9 throws an 'unknown error' if document.activeElement is used
				// inside an iframe or frame...
				try {
					if ( jqFilter[0] !== document.activeElement ) {
						jqFilter.val( previousSearch.sSearch );
					}
				}
				catch ( e ) {}
			}
		} );
	
		return filter[0];
	}
	
	
	/**
	 * Filter the table using both the global filter and column based filtering
	 *  @param {object} oSettings dataTables settings object
	 *  @param {object} oSearch search information
	 *  @param {int} [iForce] force a research of the master array (1) or not (undefined or 0)
	 *  @memberof DataTable#oApi
	 */
	function _fnFilterComplete ( oSettings, oInput, iForce )
	{
		var oPrevSearch = oSettings.oPreviousSearch;
		var aoPrevSearch = oSettings.aoPreSearchCols;
		var fnSaveFilter = function ( oFilter ) {
			/* Save the filtering values */
			oPrevSearch.sSearch = oFilter.sSearch;
			oPrevSearch.bRegex = oFilter.bRegex;
			oPrevSearch.bSmart = oFilter.bSmart;
			oPrevSearch.bCaseInsensitive = oFilter.bCaseInsensitive;
		};
		var fnRegex = function ( o ) {
			// Backwards compatibility with the bEscapeRegex option
			return o.bEscapeRegex !== undefined ? !o.bEscapeRegex : o.bRegex;
		};
	
		// Resolve any column types that are unknown due to addition or invalidation
		// @todo As per sort - can this be moved into an event handler?
		_fnColumnTypes( oSettings );
	
		/* In server-side processing all filtering is done by the server, so no point hanging around here */
		if ( _fnDataSource( oSettings ) != 'ssp' )
		{
			/* Global filter */
			_fnFilter( oSettings, oInput.sSearch, iForce, fnRegex(oInput), oInput.bSmart, oInput.bCaseInsensitive );
			fnSaveFilter( oInput );
	
			/* Now do the individual column filter */
			for ( var i=0 ; i<aoPrevSearch.length ; i++ )
			{
				_fnFilterColumn( oSettings, aoPrevSearch[i].sSearch, i, fnRegex(aoPrevSearch[i]),
					aoPrevSearch[i].bSmart, aoPrevSearch[i].bCaseInsensitive );
			}
	
			/* Custom filtering */
			_fnFilterCustom( oSettings );
		}
		else
		{
			fnSaveFilter( oInput );
		}
	
		/* Tell the draw function we have been filtering */
		oSettings.bFiltered = true;
		_fnCallbackFire( oSettings, null, 'search', [oSettings] );
	}
	
	
	/**
	 * Apply custom filtering functions
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnFilterCustom( settings )
	{
		var filters = DataTable.ext.search;
		var displayRows = settings.aiDisplay;
		var row, rowIdx;
	
		for ( var i=0, ien=filters.length ; i<ien ; i++ ) {
			var rows = [];
	
			// Loop over each row and see if it should be included
			for ( var j=0, jen=displayRows.length ; j<jen ; j++ ) {
				rowIdx = displayRows[ j ];
				row = settings.aoData[ rowIdx ];
	
				if ( filters[i]( settings, row._aFilterData, rowIdx, row._aData, j ) ) {
					rows.push( rowIdx );
				}
			}
	
			// So the array reference doesn't break set the results into the
			// existing array
			displayRows.length = 0;
			$.merge( displayRows, rows );
		}
	}
	
	
	/**
	 * Filter the table on a per-column basis
	 *  @param {object} oSettings dataTables settings object
	 *  @param {string} sInput string to filter on
	 *  @param {int} iColumn column to filter
	 *  @param {bool} bRegex treat search string as a regular expression or not
	 *  @param {bool} bSmart use smart filtering or not
	 *  @param {bool} bCaseInsensitive Do case insenstive matching or not
	 *  @memberof DataTable#oApi
	 */
	function _fnFilterColumn ( settings, searchStr, colIdx, regex, smart, caseInsensitive )
	{
		if ( searchStr === '' ) {
			return;
		}
	
		var data;
		var out = [];
		var display = settings.aiDisplay;
		var rpSearch = _fnFilterCreateSearch( searchStr, regex, smart, caseInsensitive );
	
		for ( var i=0 ; i<display.length ; i++ ) {
			data = settings.aoData[ display[i] ]._aFilterData[ colIdx ];
	
			if ( rpSearch.test( data ) ) {
				out.push( display[i] );
			}
		}
	
		settings.aiDisplay = out;
	}
	
	
	/**
	 * Filter the data table based on user input and draw the table
	 *  @param {object} settings dataTables settings object
	 *  @param {string} input string to filter on
	 *  @param {int} force optional - force a research of the master array (1) or not (undefined or 0)
	 *  @param {bool} regex treat as a regular expression or not
	 *  @param {bool} smart perform smart filtering or not
	 *  @param {bool} caseInsensitive Do case insenstive matching or not
	 *  @memberof DataTable#oApi
	 */
	function _fnFilter( settings, input, force, regex, smart, caseInsensitive )
	{
		var rpSearch = _fnFilterCreateSearch( input, regex, smart, caseInsensitive );
		var prevSearch = settings.oPreviousSearch.sSearch;
		var displayMaster = settings.aiDisplayMaster;
		var display, invalidated, i;
		var filtered = [];
	
		// Need to take account of custom filtering functions - always filter
		if ( DataTable.ext.search.length !== 0 ) {
			force = true;
		}
	
		// Check if any of the rows were invalidated
		invalidated = _fnFilterData( settings );
	
		// If the input is blank - we just want the full data set
		if ( input.length <= 0 ) {
			settings.aiDisplay = displayMaster.slice();
		}
		else {
			// New search - start from the master array
			if ( invalidated ||
				 force ||
				 prevSearch.length > input.length ||
				 input.indexOf(prevSearch) !== 0 ||
				 settings.bSorted // On resort, the display master needs to be
				                  // re-filtered since indexes will have changed
			) {
				settings.aiDisplay = displayMaster.slice();
			}
	
			// Search the display array
			display = settings.aiDisplay;
	
			for ( i=0 ; i<display.length ; i++ ) {
				if ( rpSearch.test( settings.aoData[ display[i] ]._sFilterRow ) ) {
					filtered.push( display[i] );
				}
			}
	
			settings.aiDisplay = filtered;
		}
	}
	
	
	/**
	 * Build a regular expression object suitable for searching a table
	 *  @param {string} sSearch string to search for
	 *  @param {bool} bRegex treat as a regular expression or not
	 *  @param {bool} bSmart perform smart filtering or not
	 *  @param {bool} bCaseInsensitive Do case insensitive matching or not
	 *  @returns {RegExp} constructed object
	 *  @memberof DataTable#oApi
	 */
	function _fnFilterCreateSearch( search, regex, smart, caseInsensitive )
	{
		search = regex ?
			search :
			_fnEscapeRegex( search );
		
		if ( smart ) {
			/* For smart filtering we want to allow the search to work regardless of
			 * word order. We also want double quoted text to be preserved, so word
			 * order is important - a la google. So this is what we want to
			 * generate:
			 * 
			 * ^(?=.*?\bone\b)(?=.*?\btwo three\b)(?=.*?\bfour\b).*$
			 */
			var a = $.map( search.match( /"[^"]+"|[^ ]+/g ) || [''], function ( word ) {
				if ( word.charAt(0) === '"' ) {
					var m = word.match( /^"(.*)"$/ );
					word = m ? m[1] : word;
				}
	
				return word.replace('"', '');
			} );
	
			search = '^(?=.*?'+a.join( ')(?=.*?' )+').*$';
		}
	
		return new RegExp( search, caseInsensitive ? 'i' : '' );
	}
	
	
	/**
	 * Escape a string such that it can be used in a regular expression
	 *  @param {string} sVal string to escape
	 *  @returns {string} escaped string
	 *  @memberof DataTable#oApi
	 */
	var _fnEscapeRegex = DataTable.util.escapeRegex;
	
	var __filter_div = $('<div>')[0];
	var __filter_div_textContent = __filter_div.textContent !== undefined;
	
	// Update the filtering data for each row if needed (by invalidation or first run)
	function _fnFilterData ( settings )
	{
		var columns = settings.aoColumns;
		var column;
		var i, j, ien, jen, filterData, cellData, row;
		var fomatters = DataTable.ext.type.search;
		var wasInvalidated = false;
	
		for ( i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
			row = settings.aoData[i];
	
			if ( ! row._aFilterData ) {
				filterData = [];
	
				for ( j=0, jen=columns.length ; j<jen ; j++ ) {
					column = columns[j];
	
					if ( column.bSearchable ) {
						cellData = _fnGetCellData( settings, i, j, 'filter' );
	
						if ( fomatters[ column.sType ] ) {
							cellData = fomatters[ column.sType ]( cellData );
						}
	
						// Search in DataTables 1.10 is string based. In 1.11 this
						// should be altered to also allow strict type checking.
						if ( cellData === null ) {
							cellData = '';
						}
	
						if ( typeof cellData !== 'string' && cellData.toString ) {
							cellData = cellData.toString();
						}
					}
					else {
						cellData = '';
					}
	
					// If it looks like there is an HTML entity in the string,
					// attempt to decode it so sorting works as expected. Note that
					// we could use a single line of jQuery to do this, but the DOM
					// method used here is much faster http://jsperf.com/html-decode
					if ( cellData.indexOf && cellData.indexOf('&') !== -1 ) {
						__filter_div.innerHTML = cellData;
						cellData = __filter_div_textContent ?
							__filter_div.textContent :
							__filter_div.innerText;
					}
	
					if ( cellData.replace ) {
						cellData = cellData.replace(/[\r\n]/g, '');
					}
	
					filterData.push( cellData );
				}
	
				row._aFilterData = filterData;
				row._sFilterRow = filterData.join('  ');
				wasInvalidated = true;
			}
		}
	
		return wasInvalidated;
	}
	
	
	/**
	 * Convert from the internal Hungarian notation to camelCase for external
	 * interaction
	 *  @param {object} obj Object to convert
	 *  @returns {object} Inverted object
	 *  @memberof DataTable#oApi
	 */
	function _fnSearchToCamel ( obj )
	{
		return {
			search:          obj.sSearch,
			smart:           obj.bSmart,
			regex:           obj.bRegex,
			caseInsensitive: obj.bCaseInsensitive
		};
	}
	
	
	
	/**
	 * Convert from camelCase notation to the internal Hungarian. We could use the
	 * Hungarian convert function here, but this is cleaner
	 *  @param {object} obj Object to convert
	 *  @returns {object} Inverted object
	 *  @memberof DataTable#oApi
	 */
	function _fnSearchToHung ( obj )
	{
		return {
			sSearch:          obj.search,
			bSmart:           obj.smart,
			bRegex:           obj.regex,
			bCaseInsensitive: obj.caseInsensitive
		};
	}
	
	/**
	 * Generate the node required for the info display
	 *  @param {object} oSettings dataTables settings object
	 *  @returns {node} Information element
	 *  @memberof DataTable#oApi
	 */
	function _fnFeatureHtmlInfo ( settings )
	{
		var
			tid = settings.sTableId,
			nodes = settings.aanFeatures.i,
			n = $('<div/>', {
				'class': settings.oClasses.sInfo,
				'id': ! nodes ? tid+'_info' : null
			} );
	
		if ( ! nodes ) {
			// Update display on each draw
			settings.aoDrawCallback.push( {
				"fn": _fnUpdateInfo,
				"sName": "information"
			} );
	
			n
				.attr( 'role', 'status' )
				.attr( 'aria-live', 'polite' );
	
			// Table is described by our info div
			$(settings.nTable).attr( 'aria-describedby', tid+'_info' );
		}
	
		return n[0];
	}
	
	
	/**
	 * Update the information elements in the display
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnUpdateInfo ( settings )
	{
		/* Show information about the table */
		var nodes = settings.aanFeatures.i;
		if ( nodes.length === 0 ) {
			return;
		}
	
		var
			lang  = settings.oLanguage,
			start = settings._iDisplayStart+1,
			end   = settings.fnDisplayEnd(),
			max   = settings.fnRecordsTotal(),
			total = settings.fnRecordsDisplay(),
			out   = total ?
				lang.sInfo :
				lang.sInfoEmpty;
	
		if ( total !== max ) {
			/* Record set after filtering */
			out += ' ' + lang.sInfoFiltered;
		}
	
		// Convert the macros
		out += lang.sInfoPostFix;
		out = _fnInfoMacros( settings, out );
	
		var callback = lang.fnInfoCallback;
		if ( callback !== null ) {
			out = callback.call( settings.oInstance,
				settings, start, end, max, total, out
			);
		}
	
		$(nodes).html( out );
	}
	
	
	function _fnInfoMacros ( settings, str )
	{
		// When infinite scrolling, we are always starting at 1. _iDisplayStart is used only
		// internally
		var
			formatter  = settings.fnFormatNumber,
			start      = settings._iDisplayStart+1,
			len        = settings._iDisplayLength,
			vis        = settings.fnRecordsDisplay(),
			all        = len === -1;
	
		return str.
			replace(/_START_/g, formatter.call( settings, start ) ).
			replace(/_END_/g,   formatter.call( settings, settings.fnDisplayEnd() ) ).
			replace(/_MAX_/g,   formatter.call( settings, settings.fnRecordsTotal() ) ).
			replace(/_TOTAL_/g, formatter.call( settings, vis ) ).
			replace(/_PAGE_/g,  formatter.call( settings, all ? 1 : Math.ceil( start / len ) ) ).
			replace(/_PAGES_/g, formatter.call( settings, all ? 1 : Math.ceil( vis / len ) ) );
	}
	
	
	
	/**
	 * Draw the table for the first time, adding all required features
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnInitialise ( settings )
	{
		var i, iLen, iAjaxStart=settings.iInitDisplayStart;
		var columns = settings.aoColumns, column;
		var features = settings.oFeatures;
		var deferLoading = settings.bDeferLoading; // value modified by the draw
	
		/* Ensure that the table data is fully initialised */
		if ( ! settings.bInitialised ) {
			setTimeout( function(){ _fnInitialise( settings ); }, 200 );
			return;
		}
	
		/* Show the display HTML options */
		_fnAddOptionsHtml( settings );
	
		/* Build and draw the header / footer for the table */
		_fnBuildHead( settings );
		_fnDrawHead( settings, settings.aoHeader );
		_fnDrawHead( settings, settings.aoFooter );
	
		/* Okay to show that something is going on now */
		_fnProcessingDisplay( settings, true );
	
		/* Calculate sizes for columns */
		if ( features.bAutoWidth ) {
			_fnCalculateColumnWidths( settings );
		}
	
		for ( i=0, iLen=columns.length ; i<iLen ; i++ ) {
			column = columns[i];
	
			if ( column.sWidth ) {
				column.nTh.style.width = _fnStringToCss( column.sWidth );
			}
		}
	
		_fnCallbackFire( settings, null, 'preInit', [settings] );
	
		// If there is default sorting required - let's do it. The sort function
		// will do the drawing for us. Otherwise we draw the table regardless of the
		// Ajax source - this allows the table to look initialised for Ajax sourcing
		// data (show 'loading' message possibly)
		_fnReDraw( settings );
	
		// Server-side processing init complete is done by _fnAjaxUpdateDraw
		var dataSrc = _fnDataSource( settings );
		if ( dataSrc != 'ssp' || deferLoading ) {
			// if there is an ajax source load the data
			if ( dataSrc == 'ajax' ) {
				_fnBuildAjax( settings, [], function(json) {
					var aData = _fnAjaxDataSrc( settings, json );
	
					// Got the data - add it to the table
					for ( i=0 ; i<aData.length ; i++ ) {
						_fnAddData( settings, aData[i] );
					}
	
					// Reset the init display for cookie saving. We've already done
					// a filter, and therefore cleared it before. So we need to make
					// it appear 'fresh'
					settings.iInitDisplayStart = iAjaxStart;
	
					_fnReDraw( settings );
	
					_fnProcessingDisplay( settings, false );
					_fnInitComplete( settings, json );
				}, settings );
			}
			else {
				_fnProcessingDisplay( settings, false );
				_fnInitComplete( settings );
			}
		}
	}
	
	
	/**
	 * Draw the table for the first time, adding all required features
	 *  @param {object} oSettings dataTables settings object
	 *  @param {object} [json] JSON from the server that completed the table, if using Ajax source
	 *    with client-side processing (optional)
	 *  @memberof DataTable#oApi
	 */
	function _fnInitComplete ( settings, json )
	{
		settings._bInitComplete = true;
	
		// When data was added after the initialisation (data or Ajax) we need to
		// calculate the column sizing
		if ( json || settings.oInit.aaData ) {
			_fnAdjustColumnSizing( settings );
		}
	
		_fnCallbackFire( settings, null, 'plugin-init', [settings, json] );
		_fnCallbackFire( settings, 'aoInitComplete', 'init', [settings, json] );
	}
	
	
	function _fnLengthChange ( settings, val )
	{
		var len = parseInt( val, 10 );
		settings._iDisplayLength = len;
	
		_fnLengthOverflow( settings );
	
		// Fire length change event
		_fnCallbackFire( settings, null, 'length', [settings, len] );
	}
	
	
	/**
	 * Generate the node required for user display length changing
	 *  @param {object} settings dataTables settings object
	 *  @returns {node} Display length feature node
	 *  @memberof DataTable#oApi
	 */
	function _fnFeatureHtmlLength ( settings )
	{
		var
			classes  = settings.oClasses,
			tableId  = settings.sTableId,
			menu     = settings.aLengthMenu,
			d2       = $.isArray( menu[0] ),
			lengths  = d2 ? menu[0] : menu,
			language = d2 ? menu[1] : menu;
	
		var select = $('<select/>', {
			'name':          tableId+'_length',
			'aria-controls': tableId,
			'class':         classes.sLengthSelect
		} );
	
		for ( var i=0, ien=lengths.length ; i<ien ; i++ ) {
			select[0][ i ] = new Option( language[i], lengths[i] );
		}
	
		var div = $('<div><label/></div>').addClass( classes.sLength );
		if ( ! settings.aanFeatures.l ) {
			div[0].id = tableId+'_length';
		}
	
		div.children().append(
			settings.oLanguage.sLengthMenu.replace( '_MENU_', select[0].outerHTML )
		);
	
		// Can't use `select` variable as user might provide their own and the
		// reference is broken by the use of outerHTML
		$('select', div)
			.val( settings._iDisplayLength )
			.on( 'change.DT', function(e) {
				_fnLengthChange( settings, $(this).val() );
				_fnDraw( settings );
			} );
	
		// Update node value whenever anything changes the table's length
		$(settings.nTable).on( 'length.dt.DT', function (e, s, len) {
			if ( settings === s ) {
				$('select', div).val( len );
			}
		} );
	
		return div[0];
	}
	
	
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Note that most of the paging logic is done in
	 * DataTable.ext.pager
	 */
	
	/**
	 * Generate the node required for default pagination
	 *  @param {object} oSettings dataTables settings object
	 *  @returns {node} Pagination feature node
	 *  @memberof DataTable#oApi
	 */
	function _fnFeatureHtmlPaginate ( settings )
	{
		var
			type   = settings.sPaginationType,
			plugin = DataTable.ext.pager[ type ],
			modern = typeof plugin === 'function',
			redraw = function( settings ) {
				_fnDraw( settings );
			},
			node = $('<div/>').addClass( settings.oClasses.sPaging + type )[0],
			features = settings.aanFeatures;
	
		if ( ! modern ) {
			plugin.fnInit( settings, node, redraw );
		}
	
		/* Add a draw callback for the pagination on first instance, to update the paging display */
		if ( ! features.p )
		{
			node.id = settings.sTableId+'_paginate';
	
			settings.aoDrawCallback.push( {
				"fn": function( settings ) {
					if ( modern ) {
						var
							start      = settings._iDisplayStart,
							len        = settings._iDisplayLength,
							visRecords = settings.fnRecordsDisplay(),
							all        = len === -1,
							page = all ? 0 : Math.ceil( start / len ),
							pages = all ? 1 : Math.ceil( visRecords / len ),
							buttons = plugin(page, pages),
							i, ien;
	
						for ( i=0, ien=features.p.length ; i<ien ; i++ ) {
							_fnRenderer( settings, 'pageButton' )(
								settings, features.p[i], i, buttons, page, pages
							);
						}
					}
					else {
						plugin.fnUpdate( settings, redraw );
					}
				},
				"sName": "pagination"
			} );
		}
	
		return node;
	}
	
	
	/**
	 * Alter the display settings to change the page
	 *  @param {object} settings DataTables settings object
	 *  @param {string|int} action Paging action to take: "first", "previous",
	 *    "next" or "last" or page number to jump to (integer)
	 *  @param [bool] redraw Automatically draw the update or not
	 *  @returns {bool} true page has changed, false - no change
	 *  @memberof DataTable#oApi
	 */
	function _fnPageChange ( settings, action, redraw )
	{
		var
			start     = settings._iDisplayStart,
			len       = settings._iDisplayLength,
			records   = settings.fnRecordsDisplay();
	
		if ( records === 0 || len === -1 )
		{
			start = 0;
		}
		else if ( typeof action === "number" )
		{
			start = action * len;
	
			if ( start > records )
			{
				start = 0;
			}
		}
		else if ( action == "first" )
		{
			start = 0;
		}
		else if ( action == "previous" )
		{
			start = len >= 0 ?
				start - len :
				0;
	
			if ( start < 0 )
			{
			  start = 0;
			}
		}
		else if ( action == "next" )
		{
			if ( start + len < records )
			{
				start += len;
			}
		}
		else if ( action == "last" )
		{
			start = Math.floor( (records-1) / len) * len;
		}
		else
		{
			_fnLog( settings, 0, "Unknown paging action: "+action, 5 );
		}
	
		var changed = settings._iDisplayStart !== start;
		settings._iDisplayStart = start;
	
		if ( changed ) {
			_fnCallbackFire( settings, null, 'page', [settings] );
	
			if ( redraw ) {
				_fnDraw( settings );
			}
		}
	
		return changed;
	}
	
	
	
	/**
	 * Generate the node required for the processing node
	 *  @param {object} settings dataTables settings object
	 *  @returns {node} Processing element
	 *  @memberof DataTable#oApi
	 */
	function _fnFeatureHtmlProcessing ( settings )
	{
		return $('<div/>', {
				'id': ! settings.aanFeatures.r ? settings.sTableId+'_processing' : null,
				'class': settings.oClasses.sProcessing
			} )
			.html( settings.oLanguage.sProcessing )
			.insertBefore( settings.nTable )[0];
	}
	
	
	/**
	 * Display or hide the processing indicator
	 *  @param {object} settings dataTables settings object
	 *  @param {bool} show Show the processing indicator (true) or not (false)
	 *  @memberof DataTable#oApi
	 */
	function _fnProcessingDisplay ( settings, show )
	{
		if ( settings.oFeatures.bProcessing ) {
			$(settings.aanFeatures.r).css( 'display', show ? 'block' : 'none' );
		}
	
		_fnCallbackFire( settings, null, 'processing', [settings, show] );
	}
	
	/**
	 * Add any control elements for the table - specifically scrolling
	 *  @param {object} settings dataTables settings object
	 *  @returns {node} Node to add to the DOM
	 *  @memberof DataTable#oApi
	 */
	function _fnFeatureHtmlTable ( settings )
	{
		var table = $(settings.nTable);
	
		// Add the ARIA grid role to the table
		table.attr( 'role', 'grid' );
	
		// Scrolling from here on in
		var scroll = settings.oScroll;
	
		if ( scroll.sX === '' && scroll.sY === '' ) {
			return settings.nTable;
		}
	
		var scrollX = scroll.sX;
		var scrollY = scroll.sY;
		var classes = settings.oClasses;
		var caption = table.children('caption');
		var captionSide = caption.length ? caption[0]._captionSide : null;
		var headerClone = $( table[0].cloneNode(false) );
		var footerClone = $( table[0].cloneNode(false) );
		var footer = table.children('tfoot');
		var _div = '<div/>';
		var size = function ( s ) {
			return !s ? null : _fnStringToCss( s );
		};
	
		if ( ! footer.length ) {
			footer = null;
		}
	
		/*
		 * The HTML structure that we want to generate in this function is:
		 *  div - scroller
		 *    div - scroll head
		 *      div - scroll head inner
		 *        table - scroll head table
		 *          thead - thead
		 *    div - scroll body
		 *      table - table (master table)
		 *        thead - thead clone for sizing
		 *        tbody - tbody
		 *    div - scroll foot
		 *      div - scroll foot inner
		 *        table - scroll foot table
		 *          tfoot - tfoot
		 */
		var scroller = $( _div, { 'class': classes.sScrollWrapper } )
			.append(
				$(_div, { 'class': classes.sScrollHead } )
					.css( {
						overflow: 'hidden',
						position: 'relative',
						border: 0,
						width: scrollX ? size(scrollX) : '100%'
					} )
					.append(
						$(_div, { 'class': classes.sScrollHeadInner } )
							.css( {
								'box-sizing': 'content-box',
								width: scroll.sXInner || '100%'
							} )
							.append(
								headerClone
									.removeAttr('id')
									.css( 'margin-left', 0 )
									.append( captionSide === 'top' ? caption : null )
									.append(
										table.children('thead')
									)
							)
					)
			)
			.append(
				$(_div, { 'class': classes.sScrollBody } )
					.css( {
						position: 'relative',
						overflow: 'auto',
						width: size( scrollX )
					} )
					.append( table )
			);
	
		if ( footer ) {
			scroller.append(
				$(_div, { 'class': classes.sScrollFoot } )
					.css( {
						overflow: 'hidden',
						border: 0,
						width: scrollX ? size(scrollX) : '100%'
					} )
					.append(
						$(_div, { 'class': classes.sScrollFootInner } )
							.append(
								footerClone
									.removeAttr('id')
									.css( 'margin-left', 0 )
									.append( captionSide === 'bottom' ? caption : null )
									.append(
										table.children('tfoot')
									)
							)
					)
			);
		}
	
		var children = scroller.children();
		var scrollHead = children[0];
		var scrollBody = children[1];
		var scrollFoot = footer ? children[2] : null;
	
		// When the body is scrolled, then we also want to scroll the headers
		if ( scrollX ) {
			$(scrollBody).on( 'scroll.DT', function (e) {
				var scrollLeft = this.scrollLeft;
	
				scrollHead.scrollLeft = scrollLeft;
	
				if ( footer ) {
					scrollFoot.scrollLeft = scrollLeft;
				}
			} );
		}
	
		$(scrollBody).css(
			scrollY && scroll.bCollapse ? 'max-height' : 'height', 
			scrollY
		);
	
		settings.nScrollHead = scrollHead;
		settings.nScrollBody = scrollBody;
		settings.nScrollFoot = scrollFoot;
	
		// On redraw - align columns
		settings.aoDrawCallback.push( {
			"fn": _fnScrollDraw,
			"sName": "scrolling"
		} );
	
		return scroller[0];
	}
	
	
	
	/**
	 * Update the header, footer and body tables for resizing - i.e. column
	 * alignment.
	 *
	 * Welcome to the most horrible function DataTables. The process that this
	 * function follows is basically:
	 *   1. Re-create the table inside the scrolling div
	 *   2. Take live measurements from the DOM
	 *   3. Apply the measurements to align the columns
	 *   4. Clean up
	 *
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnScrollDraw ( settings )
	{
		// Given that this is such a monster function, a lot of variables are use
		// to try and keep the minimised size as small as possible
		var
			scroll         = settings.oScroll,
			scrollX        = scroll.sX,
			scrollXInner   = scroll.sXInner,
			scrollY        = scroll.sY,
			barWidth       = scroll.iBarWidth,
			divHeader      = $(settings.nScrollHead),
			divHeaderStyle = divHeader[0].style,
			divHeaderInner = divHeader.children('div'),
			divHeaderInnerStyle = divHeaderInner[0].style,
			divHeaderTable = divHeaderInner.children('table'),
			divBodyEl      = settings.nScrollBody,
			divBody        = $(divBodyEl),
			divBodyStyle   = divBodyEl.style,
			divFooter      = $(settings.nScrollFoot),
			divFooterInner = divFooter.children('div'),
			divFooterTable = divFooterInner.children('table'),
			header         = $(settings.nTHead),
			table          = $(settings.nTable),
			tableEl        = table[0],
			tableStyle     = tableEl.style,
			footer         = settings.nTFoot ? $(settings.nTFoot) : null,
			browser        = settings.oBrowser,
			ie67           = browser.bScrollOversize,
			dtHeaderCells  = _pluck( settings.aoColumns, 'nTh' ),
			headerTrgEls, footerTrgEls,
			headerSrcEls, footerSrcEls,
			headerCopy, footerCopy,
			headerWidths=[], footerWidths=[],
			headerContent=[], footerContent=[],
			idx, correction, sanityWidth,
			zeroOut = function(nSizer) {
				var style = nSizer.style;
				style.paddingTop = "0";
				style.paddingBottom = "0";
				style.borderTopWidth = "0";
				style.borderBottomWidth = "0";
				style.height = 0;
			};
	
		// If the scrollbar visibility has changed from the last draw, we need to
		// adjust the column sizes as the table width will have changed to account
		// for the scrollbar
		var scrollBarVis = divBodyEl.scrollHeight > divBodyEl.clientHeight;
		
		if ( settings.scrollBarVis !== scrollBarVis && settings.scrollBarVis !== undefined ) {
			settings.scrollBarVis = scrollBarVis;
			_fnAdjustColumnSizing( settings );
			return; // adjust column sizing will call this function again
		}
		else {
			settings.scrollBarVis = scrollBarVis;
		}
	
		/*
		 * 1. Re-create the table inside the scrolling div
		 */
	
		// Remove the old minimised thead and tfoot elements in the inner table
		table.children('thead, tfoot').remove();
	
		if ( footer ) {
			footerCopy = footer.clone().prependTo( table );
			footerTrgEls = footer.find('tr'); // the original tfoot is in its own table and must be sized
			footerSrcEls = footerCopy.find('tr');
		}
	
		// Clone the current header and footer elements and then place it into the inner table
		headerCopy = header.clone().prependTo( table );
		headerTrgEls = header.find('tr'); // original header is in its own table
		headerSrcEls = headerCopy.find('tr');
		headerCopy.find('th, td').removeAttr('tabindex');
	
	
		/*
		 * 2. Take live measurements from the DOM - do not alter the DOM itself!
		 */
	
		// Remove old sizing and apply the calculated column widths
		// Get the unique column headers in the newly created (cloned) header. We want to apply the
		// calculated sizes to this header
		if ( ! scrollX )
		{
			divBodyStyle.width = '100%';
			divHeader[0].style.width = '100%';
		}
	
		$.each( _fnGetUniqueThs( settings, headerCopy ), function ( i, el ) {
			idx = _fnVisibleToColumnIndex( settings, i );
			el.style.width = settings.aoColumns[idx].sWidth;
		} );
	
		if ( footer ) {
			_fnApplyToChildren( function(n) {
				n.style.width = "";
			}, footerSrcEls );
		}
	
		// Size the table as a whole
		sanityWidth = table.outerWidth();
		if ( scrollX === "" ) {
			// No x scrolling
			tableStyle.width = "100%";
	
			// IE7 will make the width of the table when 100% include the scrollbar
			// - which is shouldn't. When there is a scrollbar we need to take this
			// into account.
			if ( ie67 && (table.find('tbody').height() > divBodyEl.offsetHeight ||
				divBody.css('overflow-y') == "scroll")
			) {
				tableStyle.width = _fnStringToCss( table.outerWidth() - barWidth);
			}
	
			// Recalculate the sanity width
			sanityWidth = table.outerWidth();
		}
		else if ( scrollXInner !== "" ) {
			// legacy x scroll inner has been given - use it
			tableStyle.width = _fnStringToCss(scrollXInner);
	
			// Recalculate the sanity width
			sanityWidth = table.outerWidth();
		}
	
		// Hidden header should have zero height, so remove padding and borders. Then
		// set the width based on the real headers
	
		// Apply all styles in one pass
		_fnApplyToChildren( zeroOut, headerSrcEls );
	
		// Read all widths in next pass
		_fnApplyToChildren( function(nSizer) {
			headerContent.push( nSizer.innerHTML );
			headerWidths.push( _fnStringToCss( $(nSizer).css('width') ) );
		}, headerSrcEls );
	
		// Apply all widths in final pass
		_fnApplyToChildren( function(nToSize, i) {
			// Only apply widths to the DataTables detected header cells - this
			// prevents complex headers from having contradictory sizes applied
			if ( $.inArray( nToSize, dtHeaderCells ) !== -1 ) {
				nToSize.style.width = headerWidths[i];
			}
		}, headerTrgEls );
	
		$(headerSrcEls).height(0);
	
		/* Same again with the footer if we have one */
		if ( footer )
		{
			_fnApplyToChildren( zeroOut, footerSrcEls );
	
			_fnApplyToChildren( function(nSizer) {
				footerContent.push( nSizer.innerHTML );
				footerWidths.push( _fnStringToCss( $(nSizer).css('width') ) );
			}, footerSrcEls );
	
			_fnApplyToChildren( function(nToSize, i) {
				nToSize.style.width = footerWidths[i];
			}, footerTrgEls );
	
			$(footerSrcEls).height(0);
		}
	
	
		/*
		 * 3. Apply the measurements
		 */
	
		// "Hide" the header and footer that we used for the sizing. We need to keep
		// the content of the cell so that the width applied to the header and body
		// both match, but we want to hide it completely. We want to also fix their
		// width to what they currently are
		_fnApplyToChildren( function(nSizer, i) {
			nSizer.innerHTML = '<div class="dataTables_sizing" style="height:0;overflow:hidden;">'+headerContent[i]+'</div>';
			nSizer.style.width = headerWidths[i];
		}, headerSrcEls );
	
		if ( footer )
		{
			_fnApplyToChildren( function(nSizer, i) {
				nSizer.innerHTML = '<div class="dataTables_sizing" style="height:0;overflow:hidden;">'+footerContent[i]+'</div>';
				nSizer.style.width = footerWidths[i];
			}, footerSrcEls );
		}
	
		// Sanity check that the table is of a sensible width. If not then we are going to get
		// misalignment - try to prevent this by not allowing the table to shrink below its min width
		if ( table.outerWidth() < sanityWidth )
		{
			// The min width depends upon if we have a vertical scrollbar visible or not */
			correction = ((divBodyEl.scrollHeight > divBodyEl.offsetHeight ||
				divBody.css('overflow-y') == "scroll")) ?
					sanityWidth+barWidth :
					sanityWidth;
	
			// IE6/7 are a law unto themselves...
			if ( ie67 && (divBodyEl.scrollHeight >
				divBodyEl.offsetHeight || divBody.css('overflow-y') == "scroll")
			) {
				tableStyle.width = _fnStringToCss( correction-barWidth );
			}
	
			// And give the user a warning that we've stopped the table getting too small
			if ( scrollX === "" || scrollXInner !== "" ) {
				_fnLog( settings, 1, 'Possible column misalignment', 6 );
			}
		}
		else
		{
			correction = '100%';
		}
	
		// Apply to the container elements
		divBodyStyle.width = _fnStringToCss( correction );
		divHeaderStyle.width = _fnStringToCss( correction );
	
		if ( footer ) {
			settings.nScrollFoot.style.width = _fnStringToCss( correction );
		}
	
	
		/*
		 * 4. Clean up
		 */
		if ( ! scrollY ) {
			/* IE7< puts a vertical scrollbar in place (when it shouldn't be) due to subtracting
			 * the scrollbar height from the visible display, rather than adding it on. We need to
			 * set the height in order to sort this. Don't want to do it in any other browsers.
			 */
			if ( ie67 ) {
				divBodyStyle.height = _fnStringToCss( tableEl.offsetHeight+barWidth );
			}
		}
	
		/* Finally set the width's of the header and footer tables */
		var iOuterWidth = table.outerWidth();
		divHeaderTable[0].style.width = _fnStringToCss( iOuterWidth );
		divHeaderInnerStyle.width = _fnStringToCss( iOuterWidth );
	
		// Figure out if there are scrollbar present - if so then we need a the header and footer to
		// provide a bit more space to allow "overflow" scrolling (i.e. past the scrollbar)
		var bScrolling = table.height() > divBodyEl.clientHeight || divBody.css('overflow-y') == "scroll";
		var padding = 'padding' + (browser.bScrollbarLeft ? 'Left' : 'Right' );
		divHeaderInnerStyle[ padding ] = bScrolling ? barWidth+"px" : "0px";
	
		if ( footer ) {
			divFooterTable[0].style.width = _fnStringToCss( iOuterWidth );
			divFooterInner[0].style.width = _fnStringToCss( iOuterWidth );
			divFooterInner[0].style[padding] = bScrolling ? barWidth+"px" : "0px";
		}
	
		// Correct DOM ordering for colgroup - comes before the thead
		table.children('colgroup').insertBefore( table.children('thead') );
	
		/* Adjust the position of the header in case we loose the y-scrollbar */
		divBody.scroll();
	
		// If sorting or filtering has occurred, jump the scrolling back to the top
		// only if we aren't holding the position
		if ( (settings.bSorted || settings.bFiltered) && ! settings._drawHold ) {
			divBodyEl.scrollTop = 0;
		}
	}
	
	
	
	/**
	 * Apply a given function to the display child nodes of an element array (typically
	 * TD children of TR rows
	 *  @param {function} fn Method to apply to the objects
	 *  @param array {nodes} an1 List of elements to look through for display children
	 *  @param array {nodes} an2 Another list (identical structure to the first) - optional
	 *  @memberof DataTable#oApi
	 */
	function _fnApplyToChildren( fn, an1, an2 )
	{
		var index=0, i=0, iLen=an1.length;
		var nNode1, nNode2;
	
		while ( i < iLen ) {
			nNode1 = an1[i].firstChild;
			nNode2 = an2 ? an2[i].firstChild : null;
	
			while ( nNode1 ) {
				if ( nNode1.nodeType === 1 ) {
					if ( an2 ) {
						fn( nNode1, nNode2, index );
					}
					else {
						fn( nNode1, index );
					}
	
					index++;
				}
	
				nNode1 = nNode1.nextSibling;
				nNode2 = an2 ? nNode2.nextSibling : null;
			}
	
			i++;
		}
	}
	
	
	
	var __re_html_remove = /<.*?>/g;
	
	
	/**
	 * Calculate the width of columns for the table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnCalculateColumnWidths ( oSettings )
	{
		var
			table = oSettings.nTable,
			columns = oSettings.aoColumns,
			scroll = oSettings.oScroll,
			scrollY = scroll.sY,
			scrollX = scroll.sX,
			scrollXInner = scroll.sXInner,
			columnCount = columns.length,
			visibleColumns = _fnGetColumns( oSettings, 'bVisible' ),
			headerCells = $('th', oSettings.nTHead),
			tableWidthAttr = table.getAttribute('width'), // from DOM element
			tableContainer = table.parentNode,
			userInputs = false,
			i, column, columnIdx, width, outerWidth,
			browser = oSettings.oBrowser,
			ie67 = browser.bScrollOversize;
	
		var styleWidth = table.style.width;
		if ( styleWidth && styleWidth.indexOf('%') !== -1 ) {
			tableWidthAttr = styleWidth;
		}
	
		/* Convert any user input sizes into pixel sizes */
		for ( i=0 ; i<visibleColumns.length ; i++ ) {
			column = columns[ visibleColumns[i] ];
	
			if ( column.sWidth !== null ) {
				column.sWidth = _fnConvertToWidth( column.sWidthOrig, tableContainer );
	
				userInputs = true;
			}
		}
	
		/* If the number of columns in the DOM equals the number that we have to
		 * process in DataTables, then we can use the offsets that are created by
		 * the web- browser. No custom sizes can be set in order for this to happen,
		 * nor scrolling used
		 */
		if ( ie67 || ! userInputs && ! scrollX && ! scrollY &&
		     columnCount == _fnVisbleColumns( oSettings ) &&
		     columnCount == headerCells.length
		) {
			for ( i=0 ; i<columnCount ; i++ ) {
				var colIdx = _fnVisibleToColumnIndex( oSettings, i );
	
				if ( colIdx !== null ) {
					columns[ colIdx ].sWidth = _fnStringToCss( headerCells.eq(i).width() );
				}
			}
		}
		else
		{
			// Otherwise construct a single row, worst case, table with the widest
			// node in the data, assign any user defined widths, then insert it into
			// the DOM and allow the browser to do all the hard work of calculating
			// table widths
			var tmpTable = $(table).clone() // don't use cloneNode - IE8 will remove events on the main table
				.css( 'visibility', 'hidden' )
				.removeAttr( 'id' );
	
			// Clean up the table body
			tmpTable.find('tbody tr').remove();
			var tr = $('<tr/>').appendTo( tmpTable.find('tbody') );
	
			// Clone the table header and footer - we can't use the header / footer
			// from the cloned table, since if scrolling is active, the table's
			// real header and footer are contained in different table tags
			tmpTable.find('thead, tfoot').remove();
			tmpTable
				.append( $(oSettings.nTHead).clone() )
				.append( $(oSettings.nTFoot).clone() );
	
			// Remove any assigned widths from the footer (from scrolling)
			tmpTable.find('tfoot th, tfoot td').css('width', '');
	
			// Apply custom sizing to the cloned header
			headerCells = _fnGetUniqueThs( oSettings, tmpTable.find('thead')[0] );
	
			for ( i=0 ; i<visibleColumns.length ; i++ ) {
				column = columns[ visibleColumns[i] ];
	
				headerCells[i].style.width = column.sWidthOrig !== null && column.sWidthOrig !== '' ?
					_fnStringToCss( column.sWidthOrig ) :
					'';
	
				// For scrollX we need to force the column width otherwise the
				// browser will collapse it. If this width is smaller than the
				// width the column requires, then it will have no effect
				if ( column.sWidthOrig && scrollX ) {
					$( headerCells[i] ).append( $('<div/>').css( {
						width: column.sWidthOrig,
						margin: 0,
						padding: 0,
						border: 0,
						height: 1
					} ) );
				}
			}
	
			// Find the widest cell for each column and put it into the table
			if ( oSettings.aoData.length ) {
				for ( i=0 ; i<visibleColumns.length ; i++ ) {
					columnIdx = visibleColumns[i];
					column = columns[ columnIdx ];
	
					$( _fnGetWidestNode( oSettings, columnIdx ) )
						.clone( false )
						.append( column.sContentPadding )
						.appendTo( tr );
				}
			}
	
			// Tidy the temporary table - remove name attributes so there aren't
			// duplicated in the dom (radio elements for example)
			$('[name]', tmpTable).removeAttr('name');
	
			// Table has been built, attach to the document so we can work with it.
			// A holding element is used, positioned at the top of the container
			// with minimal height, so it has no effect on if the container scrolls
			// or not. Otherwise it might trigger scrolling when it actually isn't
			// needed
			var holder = $('<div/>').css( scrollX || scrollY ?
					{
						position: 'absolute',
						top: 0,
						left: 0,
						height: 1,
						right: 0,
						overflow: 'hidden'
					} :
					{}
				)
				.append( tmpTable )
				.appendTo( tableContainer );
	
			// When scrolling (X or Y) we want to set the width of the table as 
			// appropriate. However, when not scrolling leave the table width as it
			// is. This results in slightly different, but I think correct behaviour
			if ( scrollX && scrollXInner ) {
				tmpTable.width( scrollXInner );
			}
			else if ( scrollX ) {
				tmpTable.css( 'width', 'auto' );
				tmpTable.removeAttr('width');
	
				// If there is no width attribute or style, then allow the table to
				// collapse
				if ( tmpTable.width() < tableContainer.clientWidth && tableWidthAttr ) {
					tmpTable.width( tableContainer.clientWidth );
				}
			}
			else if ( scrollY ) {
				tmpTable.width( tableContainer.clientWidth );
			}
			else if ( tableWidthAttr ) {
				tmpTable.width( tableWidthAttr );
			}
	
			// Get the width of each column in the constructed table - we need to
			// know the inner width (so it can be assigned to the other table's
			// cells) and the outer width so we can calculate the full width of the
			// table. This is safe since DataTables requires a unique cell for each
			// column, but if ever a header can span multiple columns, this will
			// need to be modified.
			var total = 0;
			for ( i=0 ; i<visibleColumns.length ; i++ ) {
				var cell = $(headerCells[i]);
				var border = cell.outerWidth() - cell.width();
	
				// Use getBounding... where possible (not IE8-) because it can give
				// sub-pixel accuracy, which we then want to round up!
				var bounding = browser.bBounding ?
					Math.ceil( headerCells[i].getBoundingClientRect().width ) :
					cell.outerWidth();
	
				// Total is tracked to remove any sub-pixel errors as the outerWidth
				// of the table might not equal the total given here (IE!).
				total += bounding;
	
				// Width for each column to use
				columns[ visibleColumns[i] ].sWidth = _fnStringToCss( bounding - border );
			}
	
			table.style.width = _fnStringToCss( total );
	
			// Finished with the table - ditch it
			holder.remove();
		}
	
		// If there is a width attr, we want to attach an event listener which
		// allows the table sizing to automatically adjust when the window is
		// resized. Use the width attr rather than CSS, since we can't know if the
		// CSS is a relative value or absolute - DOM read is always px.
		if ( tableWidthAttr ) {
			table.style.width = _fnStringToCss( tableWidthAttr );
		}
	
		if ( (tableWidthAttr || scrollX) && ! oSettings._reszEvt ) {
			var bindResize = function () {
				$(window).on('resize.DT-'+oSettings.sInstance, _fnThrottle( function () {
					_fnAdjustColumnSizing( oSettings );
				} ) );
			};
	
			// IE6/7 will crash if we bind a resize event handler on page load.
			// To be removed in 1.11 which drops IE6/7 support
			if ( ie67 ) {
				setTimeout( bindResize, 1000 );
			}
			else {
				bindResize();
			}
	
			oSettings._reszEvt = true;
		}
	}
	
	
	/**
	 * Throttle the calls to a function. Arguments and context are maintained for
	 * the throttled function
	 *  @param {function} fn Function to be called
	 *  @param {int} [freq=200] call frequency in mS
	 *  @returns {function} wrapped function
	 *  @memberof DataTable#oApi
	 */
	var _fnThrottle = DataTable.util.throttle;
	
	
	/**
	 * Convert a CSS unit width to pixels (e.g. 2em)
	 *  @param {string} width width to be converted
	 *  @param {node} parent parent to get the with for (required for relative widths) - optional
	 *  @returns {int} width in pixels
	 *  @memberof DataTable#oApi
	 */
	function _fnConvertToWidth ( width, parent )
	{
		if ( ! width ) {
			return 0;
		}
	
		var n = $('<div/>')
			.css( 'width', _fnStringToCss( width ) )
			.appendTo( parent || document.body );
	
		var val = n[0].offsetWidth;
		n.remove();
	
		return val;
	}
	
	
	/**
	 * Get the widest node
	 *  @param {object} settings dataTables settings object
	 *  @param {int} colIdx column of interest
	 *  @returns {node} widest table node
	 *  @memberof DataTable#oApi
	 */
	function _fnGetWidestNode( settings, colIdx )
	{
		var idx = _fnGetMaxLenString( settings, colIdx );
		if ( idx < 0 ) {
			return null;
		}
	
		var data = settings.aoData[ idx ];
		return ! data.nTr ? // Might not have been created when deferred rendering
			$('<td/>').html( _fnGetCellData( settings, idx, colIdx, 'display' ) )[0] :
			data.anCells[ colIdx ];
	}
	
	
	/**
	 * Get the maximum strlen for each data column
	 *  @param {object} settings dataTables settings object
	 *  @param {int} colIdx column of interest
	 *  @returns {string} max string length for each column
	 *  @memberof DataTable#oApi
	 */
	function _fnGetMaxLenString( settings, colIdx )
	{
		var s, max=-1, maxIdx = -1;
	
		for ( var i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
			s = _fnGetCellData( settings, i, colIdx, 'display' )+'';
			s = s.replace( __re_html_remove, '' );
			s = s.replace( /&nbsp;/g, ' ' );
	
			if ( s.length > max ) {
				max = s.length;
				maxIdx = i;
			}
		}
	
		return maxIdx;
	}
	
	
	/**
	 * Append a CSS unit (only if required) to a string
	 *  @param {string} value to css-ify
	 *  @returns {string} value with css unit
	 *  @memberof DataTable#oApi
	 */
	function _fnStringToCss( s )
	{
		if ( s === null ) {
			return '0px';
		}
	
		if ( typeof s == 'number' ) {
			return s < 0 ?
				'0px' :
				s+'px';
		}
	
		// Check it has a unit character already
		return s.match(/\d$/) ?
			s+'px' :
			s;
	}
	
	
	
	function _fnSortFlatten ( settings )
	{
		var
			i, iLen, k, kLen,
			aSort = [],
			aiOrig = [],
			aoColumns = settings.aoColumns,
			aDataSort, iCol, sType, srcCol,
			fixed = settings.aaSortingFixed,
			fixedObj = $.isPlainObject( fixed ),
			nestedSort = [],
			add = function ( a ) {
				if ( a.length && ! $.isArray( a[0] ) ) {
					// 1D array
					nestedSort.push( a );
				}
				else {
					// 2D array
					$.merge( nestedSort, a );
				}
			};
	
		// Build the sort array, with pre-fix and post-fix options if they have been
		// specified
		if ( $.isArray( fixed ) ) {
			add( fixed );
		}
	
		if ( fixedObj && fixed.pre ) {
			add( fixed.pre );
		}
	
		add( settings.aaSorting );
	
		if (fixedObj && fixed.post ) {
			add( fixed.post );
		}
	
		for ( i=0 ; i<nestedSort.length ; i++ )
		{
			srcCol = nestedSort[i][0];
			aDataSort = aoColumns[ srcCol ].aDataSort;
	
			for ( k=0, kLen=aDataSort.length ; k<kLen ; k++ )
			{
				iCol = aDataSort[k];
				sType = aoColumns[ iCol ].sType || 'string';
	
				if ( nestedSort[i]._idx === undefined ) {
					nestedSort[i]._idx = $.inArray( nestedSort[i][1], aoColumns[iCol].asSorting );
				}
	
				aSort.push( {
					src:       srcCol,
					col:       iCol,
					dir:       nestedSort[i][1],
					index:     nestedSort[i]._idx,
					type:      sType,
					formatter: DataTable.ext.type.order[ sType+"-pre" ]
				} );
			}
		}
	
		return aSort;
	}
	
	/**
	 * Change the order of the table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 *  @todo This really needs split up!
	 */
	function _fnSort ( oSettings )
	{
		var
			i, ien, iLen, j, jLen, k, kLen,
			sDataType, nTh,
			aiOrig = [],
			oExtSort = DataTable.ext.type.order,
			aoData = oSettings.aoData,
			aoColumns = oSettings.aoColumns,
			aDataSort, data, iCol, sType, oSort,
			formatters = 0,
			sortCol,
			displayMaster = oSettings.aiDisplayMaster,
			aSort;
	
		// Resolve any column types that are unknown due to addition or invalidation
		// @todo Can this be moved into a 'data-ready' handler which is called when
		//   data is going to be used in the table?
		_fnColumnTypes( oSettings );
	
		aSort = _fnSortFlatten( oSettings );
	
		for ( i=0, ien=aSort.length ; i<ien ; i++ ) {
			sortCol = aSort[i];
	
			// Track if we can use the fast sort algorithm
			if ( sortCol.formatter ) {
				formatters++;
			}
	
			// Load the data needed for the sort, for each cell
			_fnSortData( oSettings, sortCol.col );
		}
	
		/* No sorting required if server-side or no sorting array */
		if ( _fnDataSource( oSettings ) != 'ssp' && aSort.length !== 0 )
		{
			// Create a value - key array of the current row positions such that we can use their
			// current position during the sort, if values match, in order to perform stable sorting
			for ( i=0, iLen=displayMaster.length ; i<iLen ; i++ ) {
				aiOrig[ displayMaster[i] ] = i;
			}
	
			/* Do the sort - here we want multi-column sorting based on a given data source (column)
			 * and sorting function (from oSort) in a certain direction. It's reasonably complex to
			 * follow on it's own, but this is what we want (example two column sorting):
			 *  fnLocalSorting = function(a,b){
			 *    var iTest;
			 *    iTest = oSort['string-asc']('data11', 'data12');
			 *      if (iTest !== 0)
			 *        return iTest;
			 *    iTest = oSort['numeric-desc']('data21', 'data22');
			 *    if (iTest !== 0)
			 *      return iTest;
			 *    return oSort['numeric-asc']( aiOrig[a], aiOrig[b] );
			 *  }
			 * Basically we have a test for each sorting column, if the data in that column is equal,
			 * test the next column. If all columns match, then we use a numeric sort on the row
			 * positions in the original data array to provide a stable sort.
			 *
			 * Note - I know it seems excessive to have two sorting methods, but the first is around
			 * 15% faster, so the second is only maintained for backwards compatibility with sorting
			 * methods which do not have a pre-sort formatting function.
			 */
			if ( formatters === aSort.length ) {
				// All sort types have formatting functions
				displayMaster.sort( function ( a, b ) {
					var
						x, y, k, test, sort,
						len=aSort.length,
						dataA = aoData[a]._aSortData,
						dataB = aoData[b]._aSortData;
	
					for ( k=0 ; k<len ; k++ ) {
						sort = aSort[k];
	
						x = dataA[ sort.col ];
						y = dataB[ sort.col ];
	
						test = x<y ? -1 : x>y ? 1 : 0;
						if ( test !== 0 ) {
							return sort.dir === 'asc' ? test : -test;
						}
					}
	
					x = aiOrig[a];
					y = aiOrig[b];
					return x<y ? -1 : x>y ? 1 : 0;
				} );
			}
			else {
				// Depreciated - remove in 1.11 (providing a plug-in option)
				// Not all sort types have formatting methods, so we have to call their sorting
				// methods.
				displayMaster.sort( function ( a, b ) {
					var
						x, y, k, l, test, sort, fn,
						len=aSort.length,
						dataA = aoData[a]._aSortData,
						dataB = aoData[b]._aSortData;
	
					for ( k=0 ; k<len ; k++ ) {
						sort = aSort[k];
	
						x = dataA[ sort.col ];
						y = dataB[ sort.col ];
	
						fn = oExtSort[ sort.type+"-"+sort.dir ] || oExtSort[ "string-"+sort.dir ];
						test = fn( x, y );
						if ( test !== 0 ) {
							return test;
						}
					}
	
					x = aiOrig[a];
					y = aiOrig[b];
					return x<y ? -1 : x>y ? 1 : 0;
				} );
			}
		}
	
		/* Tell the draw function that we have sorted the data */
		oSettings.bSorted = true;
	}
	
	
	function _fnSortAria ( settings )
	{
		var label;
		var nextSort;
		var columns = settings.aoColumns;
		var aSort = _fnSortFlatten( settings );
		var oAria = settings.oLanguage.oAria;
	
		// ARIA attributes - need to loop all columns, to update all (removing old
		// attributes as needed)
		for ( var i=0, iLen=columns.length ; i<iLen ; i++ )
		{
			var col = columns[i];
			var asSorting = col.asSorting;
			var sTitle = col.sTitle.replace( /<.*?>/g, "" );
			var th = col.nTh;
	
			// IE7 is throwing an error when setting these properties with jQuery's
			// attr() and removeAttr() methods...
			th.removeAttribute('aria-sort');
	
			/* In ARIA only the first sorting column can be marked as sorting - no multi-sort option */
			if ( col.bSortable ) {
				if ( aSort.length > 0 && aSort[0].col == i ) {
					th.setAttribute('aria-sort', aSort[0].dir=="asc" ? "ascending" : "descending" );
					nextSort = asSorting[ aSort[0].index+1 ] || asSorting[0];
				}
				else {
					nextSort = asSorting[0];
				}
	
				label = sTitle + ( nextSort === "asc" ?
					oAria.sSortAscending :
					oAria.sSortDescending
				);
			}
			else {
				label = sTitle;
			}
	
			th.setAttribute('aria-label', label);
		}
	}
	
	
	/**
	 * Function to run on user sort request
	 *  @param {object} settings dataTables settings object
	 *  @param {node} attachTo node to attach the handler to
	 *  @param {int} colIdx column sorting index
	 *  @param {boolean} [append=false] Append the requested sort to the existing
	 *    sort if true (i.e. multi-column sort)
	 *  @param {function} [callback] callback function
	 *  @memberof DataTable#oApi
	 */
	function _fnSortListener ( settings, colIdx, append, callback )
	{
		var col = settings.aoColumns[ colIdx ];
		var sorting = settings.aaSorting;
		var asSorting = col.asSorting;
		var nextSortIdx;
		var next = function ( a, overflow ) {
			var idx = a._idx;
			if ( idx === undefined ) {
				idx = $.inArray( a[1], asSorting );
			}
	
			return idx+1 < asSorting.length ?
				idx+1 :
				overflow ?
					null :
					0;
		};
	
		// Convert to 2D array if needed
		if ( typeof sorting[0] === 'number' ) {
			sorting = settings.aaSorting = [ sorting ];
		}
	
		// If appending the sort then we are multi-column sorting
		if ( append && settings.oFeatures.bSortMulti ) {
			// Are we already doing some kind of sort on this column?
			var sortIdx = $.inArray( colIdx, _pluck(sorting, '0') );
	
			if ( sortIdx !== -1 ) {
				// Yes, modify the sort
				nextSortIdx = next( sorting[sortIdx], true );
	
				if ( nextSortIdx === null && sorting.length === 1 ) {
					nextSortIdx = 0; // can't remove sorting completely
				}
	
				if ( nextSortIdx === null ) {
					sorting.splice( sortIdx, 1 );
				}
				else {
					sorting[sortIdx][1] = asSorting[ nextSortIdx ];
					sorting[sortIdx]._idx = nextSortIdx;
				}
			}
			else {
				// No sort on this column yet
				sorting.push( [ colIdx, asSorting[0], 0 ] );
				sorting[sorting.length-1]._idx = 0;
			}
		}
		else if ( sorting.length && sorting[0][0] == colIdx ) {
			// Single column - already sorting on this column, modify the sort
			nextSortIdx = next( sorting[0] );
	
			sorting.length = 1;
			sorting[0][1] = asSorting[ nextSortIdx ];
			sorting[0]._idx = nextSortIdx;
		}
		else {
			// Single column - sort only on this column
			sorting.length = 0;
			sorting.push( [ colIdx, asSorting[0] ] );
			sorting[0]._idx = 0;
		}
	
		// Run the sort by calling a full redraw
		_fnReDraw( settings );
	
		// callback used for async user interaction
		if ( typeof callback == 'function' ) {
			callback( settings );
		}
	}
	
	
	/**
	 * Attach a sort handler (click) to a node
	 *  @param {object} settings dataTables settings object
	 *  @param {node} attachTo node to attach the handler to
	 *  @param {int} colIdx column sorting index
	 *  @param {function} [callback] callback function
	 *  @memberof DataTable#oApi
	 */
	function _fnSortAttachListener ( settings, attachTo, colIdx, callback )
	{
		var col = settings.aoColumns[ colIdx ];
	
		_fnBindAction( attachTo, {}, function (e) {
			/* If the column is not sortable - don't to anything */
			if ( col.bSortable === false ) {
				return;
			}
	
			// If processing is enabled use a timeout to allow the processing
			// display to be shown - otherwise to it synchronously
			if ( settings.oFeatures.bProcessing ) {
				_fnProcessingDisplay( settings, true );
	
				setTimeout( function() {
					_fnSortListener( settings, colIdx, e.shiftKey, callback );
	
					// In server-side processing, the draw callback will remove the
					// processing display
					if ( _fnDataSource( settings ) !== 'ssp' ) {
						_fnProcessingDisplay( settings, false );
					}
				}, 0 );
			}
			else {
				_fnSortListener( settings, colIdx, e.shiftKey, callback );
			}
		} );
	}
	
	
	/**
	 * Set the sorting classes on table's body, Note: it is safe to call this function
	 * when bSort and bSortClasses are false
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnSortingClasses( settings )
	{
		var oldSort = settings.aLastSort;
		var sortClass = settings.oClasses.sSortColumn;
		var sort = _fnSortFlatten( settings );
		var features = settings.oFeatures;
		var i, ien, colIdx;
	
		if ( features.bSort && features.bSortClasses ) {
			// Remove old sorting classes
			for ( i=0, ien=oldSort.length ; i<ien ; i++ ) {
				colIdx = oldSort[i].src;
	
				// Remove column sorting
				$( _pluck( settings.aoData, 'anCells', colIdx ) )
					.removeClass( sortClass + (i<2 ? i+1 : 3) );
			}
	
			// Add new column sorting
			for ( i=0, ien=sort.length ; i<ien ; i++ ) {
				colIdx = sort[i].src;
	
				$( _pluck( settings.aoData, 'anCells', colIdx ) )
					.addClass( sortClass + (i<2 ? i+1 : 3) );
			}
		}
	
		settings.aLastSort = sort;
	}
	
	
	// Get the data to sort a column, be it from cache, fresh (populating the
	// cache), or from a sort formatter
	function _fnSortData( settings, idx )
	{
		// Custom sorting function - provided by the sort data type
		var column = settings.aoColumns[ idx ];
		var customSort = DataTable.ext.order[ column.sSortDataType ];
		var customData;
	
		if ( customSort ) {
			customData = customSort.call( settings.oInstance, settings, idx,
				_fnColumnIndexToVisible( settings, idx )
			);
		}
	
		// Use / populate cache
		var row, cellData;
		var formatter = DataTable.ext.type.order[ column.sType+"-pre" ];
	
		for ( var i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
			row = settings.aoData[i];
	
			if ( ! row._aSortData ) {
				row._aSortData = [];
			}
	
			if ( ! row._aSortData[idx] || customSort ) {
				cellData = customSort ?
					customData[i] : // If there was a custom sort function, use data from there
					_fnGetCellData( settings, i, idx, 'sort' );
	
				row._aSortData[ idx ] = formatter ?
					formatter( cellData ) :
					cellData;
			}
		}
	}
	
	
	
	/**
	 * Save the state of a table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnSaveState ( settings )
	{
		if ( !settings.oFeatures.bStateSave || settings.bDestroying )
		{
			return;
		}
	
		/* Store the interesting variables */
		var state = {
			time:    +new Date(),
			start:   settings._iDisplayStart,
			length:  settings._iDisplayLength,
			order:   $.extend( true, [], settings.aaSorting ),
			search:  _fnSearchToCamel( settings.oPreviousSearch ),
			columns: $.map( settings.aoColumns, function ( col, i ) {
				return {
					visible: col.bVisible,
					search: _fnSearchToCamel( settings.aoPreSearchCols[i] )
				};
			} )
		};
	
		_fnCallbackFire( settings, "aoStateSaveParams", 'stateSaveParams', [settings, state] );
	
		settings.oSavedState = state;
		settings.fnStateSaveCallback.call( settings.oInstance, settings, state );
	}
	
	
	/**
	 * Attempt to load a saved table state
	 *  @param {object} oSettings dataTables settings object
	 *  @param {object} oInit DataTables init object so we can override settings
	 *  @param {function} callback Callback to execute when the state has been loaded
	 *  @memberof DataTable#oApi
	 */
	function _fnLoadState ( settings, oInit, callback )
	{
		var i, ien;
		var columns = settings.aoColumns;
		var loaded = function ( s ) {
			if ( ! s || ! s.time ) {
				callback();
				return;
			}
	
			// Allow custom and plug-in manipulation functions to alter the saved data set and
			// cancelling of loading by returning false
			var abStateLoad = _fnCallbackFire( settings, 'aoStateLoadParams', 'stateLoadParams', [settings, state] );
			if ( $.inArray( false, abStateLoad ) !== -1 ) {
				callback();
				return;
			}
	
			// Reject old data
			var duration = settings.iStateDuration;
			if ( duration > 0 && s.time < +new Date() - (duration*1000) ) {
				callback();
				return;
			}
	
			// Number of columns have changed - all bets are off, no restore of settings
			if ( s.columns && columns.length !== s.columns.length ) {
				callback();
				return;
			}
	
			// Store the saved state so it might be accessed at any time
			settings.oLoadedState = $.extend( true, {}, state );
	
			// Restore key features - todo - for 1.11 this needs to be done by
			// subscribed events
			if ( s.start !== undefined ) {
				settings._iDisplayStart    = s.start;
				settings.iInitDisplayStart = s.start;
			}
			if ( s.length !== undefined ) {
				settings._iDisplayLength   = s.length;
			}
	
			// Order
			if ( s.order !== undefined ) {
				settings.aaSorting = [];
				$.each( s.order, function ( i, col ) {
					settings.aaSorting.push( col[0] >= columns.length ?
						[ 0, col[1] ] :
						col
					);
				} );
			}
	
			// Search
			if ( s.search !== undefined ) {
				$.extend( settings.oPreviousSearch, _fnSearchToHung( s.search ) );
			}
	
			// Columns
			// 
			if ( s.columns ) {
				for ( i=0, ien=s.columns.length ; i<ien ; i++ ) {
					var col = s.columns[i];
	
					// Visibility
					if ( col.visible !== undefined ) {
						columns[i].bVisible = col.visible;
					}
	
					// Search
					if ( col.search !== undefined ) {
						$.extend( settings.aoPreSearchCols[i], _fnSearchToHung( col.search ) );
					}
				}
			}
	
			_fnCallbackFire( settings, 'aoStateLoaded', 'stateLoaded', [settings, state] );
			callback();
		}
	
		if ( ! settings.oFeatures.bStateSave ) {
			callback();
			return;
		}
	
		var state = settings.fnStateLoadCallback.call( settings.oInstance, settings, loaded );
	
		if ( state !== undefined ) {
			loaded( state );
		}
		// otherwise, wait for the loaded callback to be executed
	}
	
	
	/**
	 * Return the settings object for a particular table
	 *  @param {node} table table we are using as a dataTable
	 *  @returns {object} Settings object - or null if not found
	 *  @memberof DataTable#oApi
	 */
	function _fnSettingsFromNode ( table )
	{
		var settings = DataTable.settings;
		var idx = $.inArray( table, _pluck( settings, 'nTable' ) );
	
		return idx !== -1 ?
			settings[ idx ] :
			null;
	}
	
	
	/**
	 * Log an error message
	 *  @param {object} settings dataTables settings object
	 *  @param {int} level log error messages, or display them to the user
	 *  @param {string} msg error message
	 *  @param {int} tn Technical note id to get more information about the error.
	 *  @memberof DataTable#oApi
	 */
	function _fnLog( settings, level, msg, tn )
	{
		msg = 'DataTables warning: '+
			(settings ? 'table id='+settings.sTableId+' - ' : '')+msg;
	
		if ( tn ) {
			msg += '. For more information about this error, please see '+
			'http://datatables.net/tn/'+tn;
		}
	
		if ( ! level  ) {
			// Backwards compatibility pre 1.10
			var ext = DataTable.ext;
			var type = ext.sErrMode || ext.errMode;
	
			if ( settings ) {
				_fnCallbackFire( settings, null, 'error', [ settings, tn, msg ] );
			}
	
			if ( type == 'alert' ) {
				alert( msg );
			}
			else if ( type == 'throw' ) {
				throw new Error(msg);
			}
			else if ( typeof type == 'function' ) {
				type( settings, tn, msg );
			}
		}
		else if ( window.console && console.log ) {
			console.log( msg );
		}
	}
	
	
	/**
	 * See if a property is defined on one object, if so assign it to the other object
	 *  @param {object} ret target object
	 *  @param {object} src source object
	 *  @param {string} name property
	 *  @param {string} [mappedName] name to map too - optional, name used if not given
	 *  @memberof DataTable#oApi
	 */
	function _fnMap( ret, src, name, mappedName )
	{
		if ( $.isArray( name ) ) {
			$.each( name, function (i, val) {
				if ( $.isArray( val ) ) {
					_fnMap( ret, src, val[0], val[1] );
				}
				else {
					_fnMap( ret, src, val );
				}
			} );
	
			return;
		}
	
		if ( mappedName === undefined ) {
			mappedName = name;
		}
	
		if ( src[name] !== undefined ) {
			ret[mappedName] = src[name];
		}
	}
	
	
	/**
	 * Extend objects - very similar to jQuery.extend, but deep copy objects, and
	 * shallow copy arrays. The reason we need to do this, is that we don't want to
	 * deep copy array init values (such as aaSorting) since the dev wouldn't be
	 * able to override them, but we do want to deep copy arrays.
	 *  @param {object} out Object to extend
	 *  @param {object} extender Object from which the properties will be applied to
	 *      out
	 *  @param {boolean} breakRefs If true, then arrays will be sliced to take an
	 *      independent copy with the exception of the `data` or `aaData` parameters
	 *      if they are present. This is so you can pass in a collection to
	 *      DataTables and have that used as your data source without breaking the
	 *      references
	 *  @returns {object} out Reference, just for convenience - out === the return.
	 *  @memberof DataTable#oApi
	 *  @todo This doesn't take account of arrays inside the deep copied objects.
	 */
	function _fnExtend( out, extender, breakRefs )
	{
		var val;
	
		for ( var prop in extender ) {
			if ( extender.hasOwnProperty(prop) ) {
				val = extender[prop];
	
				if ( $.isPlainObject( val ) ) {
					if ( ! $.isPlainObject( out[prop] ) ) {
						out[prop] = {};
					}
					$.extend( true, out[prop], val );
				}
				else if ( breakRefs && prop !== 'data' && prop !== 'aaData' && $.isArray(val) ) {
					out[prop] = val.slice();
				}
				else {
					out[prop] = val;
				}
			}
		}
	
		return out;
	}
	
	
	/**
	 * Bind an event handers to allow a click or return key to activate the callback.
	 * This is good for accessibility since a return on the keyboard will have the
	 * same effect as a click, if the element has focus.
	 *  @param {element} n Element to bind the action to
	 *  @param {object} oData Data object to pass to the triggered function
	 *  @param {function} fn Callback function for when the event is triggered
	 *  @memberof DataTable#oApi
	 */
	function _fnBindAction( n, oData, fn )
	{
		$(n)
			.on( 'click.DT', oData, function (e) {
					n.blur(); // Remove focus outline for mouse users
					fn(e);
				} )
			.on( 'keypress.DT', oData, function (e){
					if ( e.which === 13 ) {
						e.preventDefault();
						fn(e);
					}
				} )
			.on( 'selectstart.DT', function () {
					/* Take the brutal approach to cancelling text selection */
					return false;
				} );
	}
	
	
	/**
	 * Register a callback function. Easily allows a callback function to be added to
	 * an array store of callback functions that can then all be called together.
	 *  @param {object} oSettings dataTables settings object
	 *  @param {string} sStore Name of the array storage for the callbacks in oSettings
	 *  @param {function} fn Function to be called back
	 *  @param {string} sName Identifying name for the callback (i.e. a label)
	 *  @memberof DataTable#oApi
	 */
	function _fnCallbackReg( oSettings, sStore, fn, sName )
	{
		if ( fn )
		{
			oSettings[sStore].push( {
				"fn": fn,
				"sName": sName
			} );
		}
	}
	
	
	/**
	 * Fire callback functions and trigger events. Note that the loop over the
	 * callback array store is done backwards! Further note that you do not want to
	 * fire off triggers in time sensitive applications (for example cell creation)
	 * as its slow.
	 *  @param {object} settings dataTables settings object
	 *  @param {string} callbackArr Name of the array storage for the callbacks in
	 *      oSettings
	 *  @param {string} eventName Name of the jQuery custom event to trigger. If
	 *      null no trigger is fired
	 *  @param {array} args Array of arguments to pass to the callback function /
	 *      trigger
	 *  @memberof DataTable#oApi
	 */
	function _fnCallbackFire( settings, callbackArr, eventName, args )
	{
		var ret = [];
	
		if ( callbackArr ) {
			ret = $.map( settings[callbackArr].slice().reverse(), function (val, i) {
				return val.fn.apply( settings.oInstance, args );
			} );
		}
	
		if ( eventName !== null ) {
			var e = $.Event( eventName+'.dt' );
	
			$(settings.nTable).trigger( e, args );
	
			ret.push( e.result );
		}
	
		return ret;
	}
	
	
	function _fnLengthOverflow ( settings )
	{
		var
			start = settings._iDisplayStart,
			end = settings.fnDisplayEnd(),
			len = settings._iDisplayLength;
	
		/* If we have space to show extra rows (backing up from the end point - then do so */
		if ( start >= end )
		{
			start = end - len;
		}
	
		// Keep the start record on the current page
		start -= (start % len);
	
		if ( len === -1 || start < 0 )
		{
			start = 0;
		}
	
		settings._iDisplayStart = start;
	}
	
	
	function _fnRenderer( settings, type )
	{
		var renderer = settings.renderer;
		var host = DataTable.ext.renderer[type];
	
		if ( $.isPlainObject( renderer ) && renderer[type] ) {
			// Specific renderer for this type. If available use it, otherwise use
			// the default.
			return host[renderer[type]] || host._;
		}
		else if ( typeof renderer === 'string' ) {
			// Common renderer - if there is one available for this type use it,
			// otherwise use the default
			return host[renderer] || host._;
		}
	
		// Use the default
		return host._;
	}
	
	
	/**
	 * Detect the data source being used for the table. Used to simplify the code
	 * a little (ajax) and to make it compress a little smaller.
	 *
	 *  @param {object} settings dataTables settings object
	 *  @returns {string} Data source
	 *  @memberof DataTable#oApi
	 */
	function _fnDataSource ( settings )
	{
		if ( settings.oFeatures.bServerSide ) {
			return 'ssp';
		}
		else if ( settings.ajax || settings.sAjaxSource ) {
			return 'ajax';
		}
		return 'dom';
	}
	

	
	
	/**
	 * Computed structure of the DataTables API, defined by the options passed to
	 * `DataTable.Api.register()` when building the API.
	 *
	 * The structure is built in order to speed creation and extension of the Api
	 * objects since the extensions are effectively pre-parsed.
	 *
	 * The array is an array of objects with the following structure, where this
	 * base array represents the Api prototype base:
	 *
	 *     [
	 *       {
	 *         name:      'data'                -- string   - Property name
	 *         val:       function () {},       -- function - Api method (or undefined if just an object
	 *         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
	 *         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
	 *       },
	 *       {
	 *         name:     'row'
	 *         val:       {},
	 *         methodExt: [ ... ],
	 *         propExt:   [
	 *           {
	 *             name:      'data'
	 *             val:       function () {},
	 *             methodExt: [ ... ],
	 *             propExt:   [ ... ]
	 *           },
	 *           ...
	 *         ]
	 *       }
	 *     ]
	 *
	 * @type {Array}
	 * @ignore
	 */
	var __apiStruct = [];
	
	
	/**
	 * `Array.prototype` reference.
	 *
	 * @type object
	 * @ignore
	 */
	var __arrayProto = Array.prototype;
	
	
	/**
	 * Abstraction for `context` parameter of the `Api` constructor to allow it to
	 * take several different forms for ease of use.
	 *
	 * Each of the input parameter types will be converted to a DataTables settings
	 * object where possible.
	 *
	 * @param  {string|node|jQuery|object} mixed DataTable identifier. Can be one
	 *   of:
	 *
	 *   * `string` - jQuery selector. Any DataTables' matching the given selector
	 *     with be found and used.
	 *   * `node` - `TABLE` node which has already been formed into a DataTable.
	 *   * `jQuery` - A jQuery object of `TABLE` nodes.
	 *   * `object` - DataTables settings object
	 *   * `DataTables.Api` - API instance
	 * @return {array|null} Matching DataTables settings objects. `null` or
	 *   `undefined` is returned if no matching DataTable is found.
	 * @ignore
	 */
	var _toSettings = function ( mixed )
	{
		var idx, jq;
		var settings = DataTable.settings;
		var tables = $.map( settings, function (el, i) {
			return el.nTable;
		} );
	
		if ( ! mixed ) {
			return [];
		}
		else if ( mixed.nTable && mixed.oApi ) {
			// DataTables settings object
			return [ mixed ];
		}
		else if ( mixed.nodeName && mixed.nodeName.toLowerCase() === 'table' ) {
			// Table node
			idx = $.inArray( mixed, tables );
			return idx !== -1 ? [ settings[idx] ] : null;
		}
		else if ( mixed && typeof mixed.settings === 'function' ) {
			return mixed.settings().toArray();
		}
		else if ( typeof mixed === 'string' ) {
			// jQuery selector
			jq = $(mixed);
		}
		else if ( mixed instanceof $ ) {
			// jQuery object (also DataTables instance)
			jq = mixed;
		}
	
		if ( jq ) {
			return jq.map( function(i) {
				idx = $.inArray( this, tables );
				return idx !== -1 ? settings[idx] : null;
			} ).toArray();
		}
	};
	
	
	/**
	 * DataTables API class - used to control and interface with  one or more
	 * DataTables enhanced tables.
	 *
	 * The API class is heavily based on jQuery, presenting a chainable interface
	 * that you can use to interact with tables. Each instance of the API class has
	 * a "context" - i.e. the tables that it will operate on. This could be a single
	 * table, all tables on a page or a sub-set thereof.
	 *
	 * Additionally the API is designed to allow you to easily work with the data in
	 * the tables, retrieving and manipulating it as required. This is done by
	 * presenting the API class as an array like interface. The contents of the
	 * array depend upon the actions requested by each method (for example
	 * `rows().nodes()` will return an array of nodes, while `rows().data()` will
	 * return an array of objects or arrays depending upon your table's
	 * configuration). The API object has a number of array like methods (`push`,
	 * `pop`, `reverse` etc) as well as additional helper methods (`each`, `pluck`,
	 * `unique` etc) to assist your working with the data held in a table.
	 *
	 * Most methods (those which return an Api instance) are chainable, which means
	 * the return from a method call also has all of the methods available that the
	 * top level object had. For example, these two calls are equivalent:
	 *
	 *     // Not chained
	 *     api.row.add( {...} );
	 *     api.draw();
	 *
	 *     // Chained
	 *     api.row.add( {...} ).draw();
	 *
	 * @class DataTable.Api
	 * @param {array|object|string|jQuery} context DataTable identifier. This is
	 *   used to define which DataTables enhanced tables this API will operate on.
	 *   Can be one of:
	 *
	 *   * `string` - jQuery selector. Any DataTables' matching the given selector
	 *     with be found and used.
	 *   * `node` - `TABLE` node which has already been formed into a DataTable.
	 *   * `jQuery` - A jQuery object of `TABLE` nodes.
	 *   * `object` - DataTables settings object
	 * @param {array} [data] Data to initialise the Api instance with.
	 *
	 * @example
	 *   // Direct initialisation during DataTables construction
	 *   var api = $('#example').DataTable();
	 *
	 * @example
	 *   // Initialisation using a DataTables jQuery object
	 *   var api = $('#example').dataTable().api();
	 *
	 * @example
	 *   // Initialisation as a constructor
	 *   var api = new $.fn.DataTable.Api( 'table.dataTable' );
	 */
	_Api = function ( context, data )
	{
		if ( ! (this instanceof _Api) ) {
			return new _Api( context, data );
		}
	
		var settings = [];
		var ctxSettings = function ( o ) {
			var a = _toSettings( o );
			if ( a ) {
				settings = settings.concat( a );
			}
		};
	
		if ( $.isArray( context ) ) {
			for ( var i=0, ien=context.length ; i<ien ; i++ ) {
				ctxSettings( context[i] );
			}
		}
		else {
			ctxSettings( context );
		}
	
		// Remove duplicates
		this.context = _unique( settings );
	
		// Initial data
		if ( data ) {
			$.merge( this, data );
		}
	
		// selector
		this.selector = {
			rows: null,
			cols: null,
			opts: null
		};
	
		_Api.extend( this, this, __apiStruct );
	};
	
	DataTable.Api = _Api;
	
	// Don't destroy the existing prototype, just extend it. Required for jQuery 2's
	// isPlainObject.
	$.extend( _Api.prototype, {
		any: function ()
		{
			return this.count() !== 0;
		},
	
	
		concat:  __arrayProto.concat,
	
	
		context: [], // array of table settings objects
	
	
		count: function ()
		{
			return this.flatten().length;
		},
	
	
		each: function ( fn )
		{
			for ( var i=0, ien=this.length ; i<ien; i++ ) {
				fn.call( this, this[i], i, this );
			}
	
			return this;
		},
	
	
		eq: function ( idx )
		{
			var ctx = this.context;
	
			return ctx.length > idx ?
				new _Api( ctx[idx], this[idx] ) :
				null;
		},
	
	
		filter: function ( fn )
		{
			var a = [];
	
			if ( __arrayProto.filter ) {
				a = __arrayProto.filter.call( this, fn, this );
			}
			else {
				// Compatibility for browsers without EMCA-252-5 (JS 1.6)
				for ( var i=0, ien=this.length ; i<ien ; i++ ) {
					if ( fn.call( this, this[i], i, this ) ) {
						a.push( this[i] );
					}
				}
			}
	
			return new _Api( this.context, a );
		},
	
	
		flatten: function ()
		{
			var a = [];
			return new _Api( this.context, a.concat.apply( a, this.toArray() ) );
		},
	
	
		join:    __arrayProto.join,
	
	
		indexOf: __arrayProto.indexOf || function (obj, start)
		{
			for ( var i=(start || 0), ien=this.length ; i<ien ; i++ ) {
				if ( this[i] === obj ) {
					return i;
				}
			}
			return -1;
		},
	
		iterator: function ( flatten, type, fn, alwaysNew ) {
			var
				a = [], ret,
				i, ien, j, jen,
				context = this.context,
				rows, items, item,
				selector = this.selector;
	
			// Argument shifting
			if ( typeof flatten === 'string' ) {
				alwaysNew = fn;
				fn = type;
				type = flatten;
				flatten = false;
			}
	
			for ( i=0, ien=context.length ; i<ien ; i++ ) {
				var apiInst = new _Api( context[i] );
	
				if ( type === 'table' ) {
					ret = fn.call( apiInst, context[i], i );
	
					if ( ret !== undefined ) {
						a.push( ret );
					}
				}
				else if ( type === 'columns' || type === 'rows' ) {
					// this has same length as context - one entry for each table
					ret = fn.call( apiInst, context[i], this[i], i );
	
					if ( ret !== undefined ) {
						a.push( ret );
					}
				}
				else if ( type === 'column' || type === 'column-rows' || type === 'row' || type === 'cell' ) {
					// columns and rows share the same structure.
					// 'this' is an array of column indexes for each context
					items = this[i];
	
					if ( type === 'column-rows' ) {
						rows = _selector_row_indexes( context[i], selector.opts );
					}
	
					for ( j=0, jen=items.length ; j<jen ; j++ ) {
						item = items[j];
	
						if ( type === 'cell' ) {
							ret = fn.call( apiInst, context[i], item.row, item.column, i, j );
						}
						else {
							ret = fn.call( apiInst, context[i], item, i, j, rows );
						}
	
						if ( ret !== undefined ) {
							a.push( ret );
						}
					}
				}
			}
	
			if ( a.length || alwaysNew ) {
				var api = new _Api( context, flatten ? a.concat.apply( [], a ) : a );
				var apiSelector = api.selector;
				apiSelector.rows = selector.rows;
				apiSelector.cols = selector.cols;
				apiSelector.opts = selector.opts;
				return api;
			}
			return this;
		},
	
	
		lastIndexOf: __arrayProto.lastIndexOf || function (obj, start)
		{
			// Bit cheeky...
			return this.indexOf.apply( this.toArray.reverse(), arguments );
		},
	
	
		length:  0,
	
	
		map: function ( fn )
		{
			var a = [];
	
			if ( __arrayProto.map ) {
				a = __arrayProto.map.call( this, fn, this );
			}
			else {
				// Compatibility for browsers without EMCA-252-5 (JS 1.6)
				for ( var i=0, ien=this.length ; i<ien ; i++ ) {
					a.push( fn.call( this, this[i], i ) );
				}
			}
	
			return new _Api( this.context, a );
		},
	
	
		pluck: function ( prop )
		{
			return this.map( function ( el ) {
				return el[ prop ];
			} );
		},
	
		pop:     __arrayProto.pop,
	
	
		push:    __arrayProto.push,
	
	
		// Does not return an API instance
		reduce: __arrayProto.reduce || function ( fn, init )
		{
			return _fnReduce( this, fn, init, 0, this.length, 1 );
		},
	
	
		reduceRight: __arrayProto.reduceRight || function ( fn, init )
		{
			return _fnReduce( this, fn, init, this.length-1, -1, -1 );
		},
	
	
		reverse: __arrayProto.reverse,
	
	
		// Object with rows, columns and opts
		selector: null,
	
	
		shift:   __arrayProto.shift,
	
	
		sort:    __arrayProto.sort, // ? name - order?
	
	
		splice:  __arrayProto.splice,
	
	
		toArray: function ()
		{
			return __arrayProto.slice.call( this );
		},
	
	
		to$: function ()
		{
			return $( this );
		},
	
	
		toJQuery: function ()
		{
			return $( this );
		},
	
	
		unique: function ()
		{
			return new _Api( this.context, _unique(this) );
		},
	
	
		unshift: __arrayProto.unshift
	} );
	
	
	_Api.extend = function ( scope, obj, ext )
	{
		// Only extend API instances and static properties of the API
		if ( ! ext.length || ! obj || ( ! (obj instanceof _Api) && ! obj.__dt_wrapper ) ) {
			return;
		}
	
		var
			i, ien,
			j, jen,
			struct, inner,
			methodScoping = function ( scope, fn, struc ) {
				return function () {
					var ret = fn.apply( scope, arguments );
	
					// Method extension
					_Api.extend( ret, ret, struc.methodExt );
					return ret;
				};
			};
	
		for ( i=0, ien=ext.length ; i<ien ; i++ ) {
			struct = ext[i];
	
			// Value
			obj[ struct.name ] = typeof struct.val === 'function' ?
				methodScoping( scope, struct.val, struct ) :
				$.isPlainObject( struct.val ) ?
					{} :
					struct.val;
	
			obj[ struct.name ].__dt_wrapper = true;
	
			// Property extension
			_Api.extend( scope, obj[ struct.name ], struct.propExt );
		}
	};
	
	
	// @todo - Is there need for an augment function?
	// _Api.augment = function ( inst, name )
	// {
	// 	// Find src object in the structure from the name
	// 	var parts = name.split('.');
	
	// 	_Api.extend( inst, obj );
	// };
	
	
	//     [
	//       {
	//         name:      'data'                -- string   - Property name
	//         val:       function () {},       -- function - Api method (or undefined if just an object
	//         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
	//         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
	//       },
	//       {
	//         name:     'row'
	//         val:       {},
	//         methodExt: [ ... ],
	//         propExt:   [
	//           {
	//             name:      'data'
	//             val:       function () {},
	//             methodExt: [ ... ],
	//             propExt:   [ ... ]
	//           },
	//           ...
	//         ]
	//       }
	//     ]
	
	_Api.register = _api_register = function ( name, val )
	{
		if ( $.isArray( name ) ) {
			for ( var j=0, jen=name.length ; j<jen ; j++ ) {
				_Api.register( name[j], val );
			}
			return;
		}
	
		var
			i, ien,
			heir = name.split('.'),
			struct = __apiStruct,
			key, method;
	
		var find = function ( src, name ) {
			for ( var i=0, ien=src.length ; i<ien ; i++ ) {
				if ( src[i].name === name ) {
					return src[i];
				}
			}
			return null;
		};
	
		for ( i=0, ien=heir.length ; i<ien ; i++ ) {
			method = heir[i].indexOf('()') !== -1;
			key = method ?
				heir[i].replace('()', '') :
				heir[i];
	
			var src = find( struct, key );
			if ( ! src ) {
				src = {
					name:      key,
					val:       {},
					methodExt: [],
					propExt:   []
				};
				struct.push( src );
			}
	
			if ( i === ien-1 ) {
				src.val = val;
			}
			else {
				struct = method ?
					src.methodExt :
					src.propExt;
			}
		}
	};
	
	
	_Api.registerPlural = _api_registerPlural = function ( pluralName, singularName, val ) {
		_Api.register( pluralName, val );
	
		_Api.register( singularName, function () {
			var ret = val.apply( this, arguments );
	
			if ( ret === this ) {
				// Returned item is the API instance that was passed in, return it
				return this;
			}
			else if ( ret instanceof _Api ) {
				// New API instance returned, want the value from the first item
				// in the returned array for the singular result.
				return ret.length ?
					$.isArray( ret[0] ) ?
						new _Api( ret.context, ret[0] ) : // Array results are 'enhanced'
						ret[0] :
					undefined;
			}
	
			// Non-API return - just fire it back
			return ret;
		} );
	};
	
	
	/**
	 * Selector for HTML tables. Apply the given selector to the give array of
	 * DataTables settings objects.
	 *
	 * @param {string|integer} [selector] jQuery selector string or integer
	 * @param  {array} Array of DataTables settings objects to be filtered
	 * @return {array}
	 * @ignore
	 */
	var __table_selector = function ( selector, a )
	{
		// Integer is used to pick out a table by index
		if ( typeof selector === 'number' ) {
			return [ a[ selector ] ];
		}
	
		// Perform a jQuery selector on the table nodes
		var nodes = $.map( a, function (el, i) {
			return el.nTable;
		} );
	
		return $(nodes)
			.filter( selector )
			.map( function (i) {
				// Need to translate back from the table node to the settings
				var idx = $.inArray( this, nodes );
				return a[ idx ];
			} )
			.toArray();
	};
	
	
	
	/**
	 * Context selector for the API's context (i.e. the tables the API instance
	 * refers to.
	 *
	 * @name    DataTable.Api#tables
	 * @param {string|integer} [selector] Selector to pick which tables the iterator
	 *   should operate on. If not given, all tables in the current context are
	 *   used. This can be given as a jQuery selector (for example `':gt(0)'`) to
	 *   select multiple tables or as an integer to select a single table.
	 * @returns {DataTable.Api} Returns a new API instance if a selector is given.
	 */
	_api_register( 'tables()', function ( selector ) {
		// A new instance is created if there was a selector specified
		return selector ?
			new _Api( __table_selector( selector, this.context ) ) :
			this;
	} );
	
	
	_api_register( 'table()', function ( selector ) {
		var tables = this.tables( selector );
		var ctx = tables.context;
	
		// Truncate to the first matched table
		return ctx.length ?
			new _Api( ctx[0] ) :
			tables;
	} );
	
	
	_api_registerPlural( 'tables().nodes()', 'table().node()' , function () {
		return this.iterator( 'table', function ( ctx ) {
			return ctx.nTable;
		}, 1 );
	} );
	
	
	_api_registerPlural( 'tables().body()', 'table().body()' , function () {
		return this.iterator( 'table', function ( ctx ) {
			return ctx.nTBody;
		}, 1 );
	} );
	
	
	_api_registerPlural( 'tables().header()', 'table().header()' , function () {
		return this.iterator( 'table', function ( ctx ) {
			return ctx.nTHead;
		}, 1 );
	} );
	
	
	_api_registerPlural( 'tables().footer()', 'table().footer()' , function () {
		return this.iterator( 'table', function ( ctx ) {
			return ctx.nTFoot;
		}, 1 );
	} );
	
	
	_api_registerPlural( 'tables().containers()', 'table().container()' , function () {
		return this.iterator( 'table', function ( ctx ) {
			return ctx.nTableWrapper;
		}, 1 );
	} );
	
	
	
	/**
	 * Redraw the tables in the current context.
	 */
	_api_register( 'draw()', function ( paging ) {
		return this.iterator( 'table', function ( settings ) {
			if ( paging === 'page' ) {
				_fnDraw( settings );
			}
			else {
				if ( typeof paging === 'string' ) {
					paging = paging === 'full-hold' ?
						false :
						true;
				}
	
				_fnReDraw( settings, paging===false );
			}
		} );
	} );
	
	
	
	/**
	 * Get the current page index.
	 *
	 * @return {integer} Current page index (zero based)
	 *//**
	 * Set the current page.
	 *
	 * Note that if you attempt to show a page which does not exist, DataTables will
	 * not throw an error, but rather reset the paging.
	 *
	 * @param {integer|string} action The paging action to take. This can be one of:
	 *  * `integer` - The page index to jump to
	 *  * `string` - An action to take:
	 *    * `first` - Jump to first page.
	 *    * `next` - Jump to the next page
	 *    * `previous` - Jump to previous page
	 *    * `last` - Jump to the last page.
	 * @returns {DataTables.Api} this
	 */
	_api_register( 'page()', function ( action ) {
		if ( action === undefined ) {
			return this.page.info().page; // not an expensive call
		}
	
		// else, have an action to take on all tables
		return this.iterator( 'table', function ( settings ) {
			_fnPageChange( settings, action );
		} );
	} );
	
	
	/**
	 * Paging information for the first table in the current context.
	 *
	 * If you require paging information for another table, use the `table()` method
	 * with a suitable selector.
	 *
	 * @return {object} Object with the following properties set:
	 *  * `page` - Current page index (zero based - i.e. the first page is `0`)
	 *  * `pages` - Total number of pages
	 *  * `start` - Display index for the first record shown on the current page
	 *  * `end` - Display index for the last record shown on the current page
	 *  * `length` - Display length (number of records). Note that generally `start
	 *    + length = end`, but this is not always true, for example if there are
	 *    only 2 records to show on the final page, with a length of 10.
	 *  * `recordsTotal` - Full data set length
	 *  * `recordsDisplay` - Data set length once the current filtering criterion
	 *    are applied.
	 */
	_api_register( 'page.info()', function ( action ) {
		if ( this.context.length === 0 ) {
			return undefined;
		}
	
		var
			settings   = this.context[0],
			start      = settings._iDisplayStart,
			len        = settings.oFeatures.bPaginate ? settings._iDisplayLength : -1,
			visRecords = settings.fnRecordsDisplay(),
			all        = len === -1;
	
		return {
			"page":           all ? 0 : Math.floor( start / len ),
			"pages":          all ? 1 : Math.ceil( visRecords / len ),
			"start":          start,
			"end":            settings.fnDisplayEnd(),
			"length":         len,
			"recordsTotal":   settings.fnRecordsTotal(),
			"recordsDisplay": visRecords,
			"serverSide":     _fnDataSource( settings ) === 'ssp'
		};
	} );
	
	
	/**
	 * Get the current page length.
	 *
	 * @return {integer} Current page length. Note `-1` indicates that all records
	 *   are to be shown.
	 *//**
	 * Set the current page length.
	 *
	 * @param {integer} Page length to set. Use `-1` to show all records.
	 * @returns {DataTables.Api} this
	 */
	_api_register( 'page.len()', function ( len ) {
		// Note that we can't call this function 'length()' because `length`
		// is a Javascript property of functions which defines how many arguments
		// the function expects.
		if ( len === undefined ) {
			return this.context.length !== 0 ?
				this.context[0]._iDisplayLength :
				undefined;
		}
	
		// else, set the page length
		return this.iterator( 'table', function ( settings ) {
			_fnLengthChange( settings, len );
		} );
	} );
	
	
	
	var __reload = function ( settings, holdPosition, callback ) {
		// Use the draw event to trigger a callback
		if ( callback ) {
			var api = new _Api( settings );
	
			api.one( 'draw', function () {
				callback( api.ajax.json() );
			} );
		}
	
		if ( _fnDataSource( settings ) == 'ssp' ) {
			_fnReDraw( settings, holdPosition );
		}
		else {
			_fnProcessingDisplay( settings, true );
	
			// Cancel an existing request
			var xhr = settings.jqXHR;
			if ( xhr && xhr.readyState !== 4 ) {
				xhr.abort();
			}
	
			// Trigger xhr
			_fnBuildAjax( settings, [], function( json ) {
				_fnClearTable( settings );
	
				var data = _fnAjaxDataSrc( settings, json );
				for ( var i=0, ien=data.length ; i<ien ; i++ ) {
					_fnAddData( settings, data[i] );
				}
	
				_fnReDraw( settings, holdPosition );
				_fnProcessingDisplay( settings, false );
			} );
		}
	};
	
	
	/**
	 * Get the JSON response from the last Ajax request that DataTables made to the
	 * server. Note that this returns the JSON from the first table in the current
	 * context.
	 *
	 * @return {object} JSON received from the server.
	 */
	_api_register( 'ajax.json()', function () {
		var ctx = this.context;
	
		if ( ctx.length > 0 ) {
			return ctx[0].json;
		}
	
		// else return undefined;
	} );
	
	
	/**
	 * Get the data submitted in the last Ajax request
	 */
	_api_register( 'ajax.params()', function () {
		var ctx = this.context;
	
		if ( ctx.length > 0 ) {
			return ctx[0].oAjaxData;
		}
	
		// else return undefined;
	} );
	
	
	/**
	 * Reload tables from the Ajax data source. Note that this function will
	 * automatically re-draw the table when the remote data has been loaded.
	 *
	 * @param {boolean} [reset=true] Reset (default) or hold the current paging
	 *   position. A full re-sort and re-filter is performed when this method is
	 *   called, which is why the pagination reset is the default action.
	 * @returns {DataTables.Api} this
	 */
	_api_register( 'ajax.reload()', function ( callback, resetPaging ) {
		return this.iterator( 'table', function (settings) {
			__reload( settings, resetPaging===false, callback );
		} );
	} );
	
	
	/**
	 * Get the current Ajax URL. Note that this returns the URL from the first
	 * table in the current context.
	 *
	 * @return {string} Current Ajax source URL
	 *//**
	 * Set the Ajax URL. Note that this will set the URL for all tables in the
	 * current context.
	 *
	 * @param {string} url URL to set.
	 * @returns {DataTables.Api} this
	 */
	_api_register( 'ajax.url()', function ( url ) {
		var ctx = this.context;
	
		if ( url === undefined ) {
			// get
			if ( ctx.length === 0 ) {
				return undefined;
			}
			ctx = ctx[0];
	
			return ctx.ajax ?
				$.isPlainObject( ctx.ajax ) ?
					ctx.ajax.url :
					ctx.ajax :
				ctx.sAjaxSource;
		}
	
		// set
		return this.iterator( 'table', function ( settings ) {
			if ( $.isPlainObject( settings.ajax ) ) {
				settings.ajax.url = url;
			}
			else {
				settings.ajax = url;
			}
			// No need to consider sAjaxSource here since DataTables gives priority
			// to `ajax` over `sAjaxSource`. So setting `ajax` here, renders any
			// value of `sAjaxSource` redundant.
		} );
	} );
	
	
	/**
	 * Load data from the newly set Ajax URL. Note that this method is only
	 * available when `ajax.url()` is used to set a URL. Additionally, this method
	 * has the same effect as calling `ajax.reload()` but is provided for
	 * convenience when setting a new URL. Like `ajax.reload()` it will
	 * automatically redraw the table once the remote data has been loaded.
	 *
	 * @returns {DataTables.Api} this
	 */
	_api_register( 'ajax.url().load()', function ( callback, resetPaging ) {
		// Same as a reload, but makes sense to present it for easy access after a
		// url change
		return this.iterator( 'table', function ( ctx ) {
			__reload( ctx, resetPaging===false, callback );
		} );
	} );
	
	
	
	
	var _selector_run = function ( type, selector, selectFn, settings, opts )
	{
		var
			out = [], res,
			a, i, ien, j, jen,
			selectorType = typeof selector;
	
		// Can't just check for isArray here, as an API or jQuery instance might be
		// given with their array like look
		if ( ! selector || selectorType === 'string' || selectorType === 'function' || selector.length === undefined ) {
			selector = [ selector ];
		}
	
		for ( i=0, ien=selector.length ; i<ien ; i++ ) {
			// Only split on simple strings - complex expressions will be jQuery selectors
			a = selector[i] && selector[i].split && ! selector[i].match(/[\[\(:]/) ?
				selector[i].split(',') :
				[ selector[i] ];
	
			for ( j=0, jen=a.length ; j<jen ; j++ ) {
				res = selectFn( typeof a[j] === 'string' ? $.trim(a[j]) : a[j] );
	
				if ( res && res.length ) {
					out = out.concat( res );
				}
			}
		}
	
		// selector extensions
		var ext = _ext.selector[ type ];
		if ( ext.length ) {
			for ( i=0, ien=ext.length ; i<ien ; i++ ) {
				out = ext[i]( settings, opts, out );
			}
		}
	
		return _unique( out );
	};
	
	
	var _selector_opts = function ( opts )
	{
		if ( ! opts ) {
			opts = {};
		}
	
		// Backwards compatibility for 1.9- which used the terminology filter rather
		// than search
		if ( opts.filter && opts.search === undefined ) {
			opts.search = opts.filter;
		}
	
		return $.extend( {
			search: 'none',
			order: 'current',
			page: 'all'
		}, opts );
	};
	
	
	var _selector_first = function ( inst )
	{
		// Reduce the API instance to the first item found
		for ( var i=0, ien=inst.length ; i<ien ; i++ ) {
			if ( inst[i].length > 0 ) {
				// Assign the first element to the first item in the instance
				// and truncate the instance and context
				inst[0] = inst[i];
				inst[0].length = 1;
				inst.length = 1;
				inst.context = [ inst.context[i] ];
	
				return inst;
			}
		}
	
		// Not found - return an empty instance
		inst.length = 0;
		return inst;
	};
	
	
	var _selector_row_indexes = function ( settings, opts )
	{
		var
			i, ien, tmp, a=[],
			displayFiltered = settings.aiDisplay,
			displayMaster = settings.aiDisplayMaster;
	
		var
			search = opts.search,  // none, applied, removed
			order  = opts.order,   // applied, current, index (original - compatibility with 1.9)
			page   = opts.page;    // all, current
	
		if ( _fnDataSource( settings ) == 'ssp' ) {
			// In server-side processing mode, most options are irrelevant since
			// rows not shown don't exist and the index order is the applied order
			// Removed is a special case - for consistency just return an empty
			// array
			return search === 'removed' ?
				[] :
				_range( 0, displayMaster.length );
		}
		else if ( page == 'current' ) {
			// Current page implies that order=current and fitler=applied, since it is
			// fairly senseless otherwise, regardless of what order and search actually
			// are
			for ( i=settings._iDisplayStart, ien=settings.fnDisplayEnd() ; i<ien ; i++ ) {
				a.push( displayFiltered[i] );
			}
		}
		else if ( order == 'current' || order == 'applied' ) {
			a = search == 'none' ?
				displayMaster.slice() :                      // no search
				search == 'applied' ?
					displayFiltered.slice() :                // applied search
					$.map( displayMaster, function (el, i) { // removed search
						return $.inArray( el, displayFiltered ) === -1 ? el : null;
					} );
		}
		else if ( order == 'index' || order == 'original' ) {
			for ( i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
				if ( search == 'none' ) {
					a.push( i );
				}
				else { // applied | removed
					tmp = $.inArray( i, displayFiltered );
	
					if ((tmp === -1 && search == 'removed') ||
						(tmp >= 0   && search == 'applied') )
					{
						a.push( i );
					}
				}
			}
		}
	
		return a;
	};
	
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Rows
	 *
	 * {}          - no selector - use all available rows
	 * {integer}   - row aoData index
	 * {node}      - TR node
	 * {string}    - jQuery selector to apply to the TR elements
	 * {array}     - jQuery array of nodes, or simply an array of TR nodes
	 *
	 */
	
	
	var __row_selector = function ( settings, selector, opts )
	{
		var rows;
		var run = function ( sel ) {
			var selInt = _intVal( sel );
			var i, ien;
	
			// Short cut - selector is a number and no options provided (default is
			// all records, so no need to check if the index is in there, since it
			// must be - dev error if the index doesn't exist).
			if ( selInt !== null && ! opts ) {
				return [ selInt ];
			}
	
			if ( ! rows ) {
				rows = _selector_row_indexes( settings, opts );
			}
	
			if ( selInt !== null && $.inArray( selInt, rows ) !== -1 ) {
				// Selector - integer
				return [ selInt ];
			}
			else if ( sel === null || sel === undefined || sel === '' ) {
				// Selector - none
				return rows;
			}
	
			// Selector - function
			if ( typeof sel === 'function' ) {
				return $.map( rows, function (idx) {
					var row = settings.aoData[ idx ];
					return sel( idx, row._aData, row.nTr ) ? idx : null;
				} );
			}
	
			// Get nodes in the order from the `rows` array with null values removed
			var nodes = _removeEmpty(
				_pluck_order( settings.aoData, rows, 'nTr' )
			);
	
			// Selector - node
			if ( sel.nodeName ) {
				if ( sel._DT_RowIndex !== undefined ) {
					return [ sel._DT_RowIndex ]; // Property added by DT for fast lookup
				}
				else if ( sel._DT_CellIndex ) {
					return [ sel._DT_CellIndex.row ];
				}
				else {
					var host = $(sel).closest('*[data-dt-row]');
					return host.length ?
						[ host.data('dt-row') ] :
						[];
				}
			}
	
			// ID selector. Want to always be able to select rows by id, regardless
			// of if the tr element has been created or not, so can't rely upon
			// jQuery here - hence a custom implementation. This does not match
			// Sizzle's fast selector or HTML4 - in HTML5 the ID can be anything,
			// but to select it using a CSS selector engine (like Sizzle or
			// querySelect) it would need to need to be escaped for some characters.
			// DataTables simplifies this for row selectors since you can select
			// only a row. A # indicates an id any anything that follows is the id -
			// unescaped.
			if ( typeof sel === 'string' && sel.charAt(0) === '#' ) {
				// get row index from id
				var rowObj = settings.aIds[ sel.replace( /^#/, '' ) ];
				if ( rowObj !== undefined ) {
					return [ rowObj.idx ];
				}
	
				// need to fall through to jQuery in case there is DOM id that
				// matches
			}
	
			// Selector - jQuery selector string, array of nodes or jQuery object/
			// As jQuery's .filter() allows jQuery objects to be passed in filter,
			// it also allows arrays, so this will cope with all three options
			return $(nodes)
				.filter( sel )
				.map( function () {
					return this._DT_RowIndex;
				} )
				.toArray();
		};
	
		return _selector_run( 'row', selector, run, settings, opts );
	};
	
	
	_api_register( 'rows()', function ( selector, opts ) {
		// argument shifting
		if ( selector === undefined ) {
			selector = '';
		}
		else if ( $.isPlainObject( selector ) ) {
			opts = selector;
			selector = '';
		}
	
		opts = _selector_opts( opts );
	
		var inst = this.iterator( 'table', function ( settings ) {
			return __row_selector( settings, selector, opts );
		}, 1 );
	
		// Want argument shifting here and in __row_selector?
		inst.selector.rows = selector;
		inst.selector.opts = opts;
	
		return inst;
	} );
	
	_api_register( 'rows().nodes()', function () {
		return this.iterator( 'row', function ( settings, row ) {
			return settings.aoData[ row ].nTr || undefined;
		}, 1 );
	} );
	
	_api_register( 'rows().data()', function () {
		return this.iterator( true, 'rows', function ( settings, rows ) {
			return _pluck_order( settings.aoData, rows, '_aData' );
		}, 1 );
	} );
	
	_api_registerPlural( 'rows().cache()', 'row().cache()', function ( type ) {
		return this.iterator( 'row', function ( settings, row ) {
			var r = settings.aoData[ row ];
			return type === 'search' ? r._aFilterData : r._aSortData;
		}, 1 );
	} );
	
	_api_registerPlural( 'rows().invalidate()', 'row().invalidate()', function ( src ) {
		return this.iterator( 'row', function ( settings, row ) {
			_fnInvalidate( settings, row, src );
		} );
	} );
	
	_api_registerPlural( 'rows().indexes()', 'row().index()', function () {
		return this.iterator( 'row', function ( settings, row ) {
			return row;
		}, 1 );
	} );
	
	_api_registerPlural( 'rows().ids()', 'row().id()', function ( hash ) {
		var a = [];
		var context = this.context;
	
		// `iterator` will drop undefined values, but in this case we want them
		for ( var i=0, ien=context.length ; i<ien ; i++ ) {
			for ( var j=0, jen=this[i].length ; j<jen ; j++ ) {
				var id = context[i].rowIdFn( context[i].aoData[ this[i][j] ]._aData );
				a.push( (hash === true ? '#' : '' )+ id );
			}
		}
	
		return new _Api( context, a );
	} );
	
	_api_registerPlural( 'rows().remove()', 'row().remove()', function () {
		var that = this;
	
		this.iterator( 'row', function ( settings, row, thatIdx ) {
			var data = settings.aoData;
			var rowData = data[ row ];
			var i, ien, j, jen;
			var loopRow, loopCells;
	
			data.splice( row, 1 );
	
			// Update the cached indexes
			for ( i=0, ien=data.length ; i<ien ; i++ ) {
				loopRow = data[i];
				loopCells = loopRow.anCells;
	
				// Rows
				if ( loopRow.nTr !== null ) {
					loopRow.nTr._DT_RowIndex = i;
				}
	
				// Cells
				if ( loopCells !== null ) {
					for ( j=0, jen=loopCells.length ; j<jen ; j++ ) {
						loopCells[j]._DT_CellIndex.row = i;
					}
				}
			}
	
			// Delete from the display arrays
			_fnDeleteIndex( settings.aiDisplayMaster, row );
			_fnDeleteIndex( settings.aiDisplay, row );
			_fnDeleteIndex( that[ thatIdx ], row, false ); // maintain local indexes
	
			// Check for an 'overflow' they case for displaying the table
			_fnLengthOverflow( settings );
	
			// Remove the row's ID reference if there is one
			var id = settings.rowIdFn( rowData._aData );
			if ( id !== undefined ) {
				delete settings.aIds[ id ];
			}
		} );
	
		this.iterator( 'table', function ( settings ) {
			for ( var i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
				settings.aoData[i].idx = i;
			}
		} );
	
		return this;
	} );
	
	
	_api_register( 'rows.add()', function ( rows ) {
		var newRows = this.iterator( 'table', function ( settings ) {
				var row, i, ien;
				var out = [];
	
				for ( i=0, ien=rows.length ; i<ien ; i++ ) {
					row = rows[i];
	
					if ( row.nodeName && row.nodeName.toUpperCase() === 'TR' ) {
						out.push( _fnAddTr( settings, row )[0] );
					}
					else {
						out.push( _fnAddData( settings, row ) );
					}
				}
	
				return out;
			}, 1 );
	
		// Return an Api.rows() extended instance, so rows().nodes() etc can be used
		var modRows = this.rows( -1 );
		modRows.pop();
		$.merge( modRows, newRows );
	
		return modRows;
	} );
	
	
	
	
	
	/**
	 *
	 */
	_api_register( 'row()', function ( selector, opts ) {
		return _selector_first( this.rows( selector, opts ) );
	} );
	
	
	_api_register( 'row().data()', function ( data ) {
		var ctx = this.context;
	
		if ( data === undefined ) {
			// Get
			return ctx.length && this.length ?
				ctx[0].aoData[ this[0] ]._aData :
				undefined;
		}
	
		// Set
		ctx[0].aoData[ this[0] ]._aData = data;
	
		// Automatically invalidate
		_fnInvalidate( ctx[0], this[0], 'data' );
	
		return this;
	} );
	
	
	_api_register( 'row().node()', function () {
		var ctx = this.context;
	
		return ctx.length && this.length ?
			ctx[0].aoData[ this[0] ].nTr || null :
			null;
	} );
	
	
	_api_register( 'row.add()', function ( row ) {
		// Allow a jQuery object to be passed in - only a single row is added from
		// it though - the first element in the set
		if ( row instanceof $ && row.length ) {
			row = row[0];
		}
	
		var rows = this.iterator( 'table', function ( settings ) {
			if ( row.nodeName && row.nodeName.toUpperCase() === 'TR' ) {
				return _fnAddTr( settings, row )[0];
			}
			return _fnAddData( settings, row );
		} );
	
		// Return an Api.rows() extended instance, with the newly added row selected
		return this.row( rows[0] );
	} );
	
	
	
	var __details_add = function ( ctx, row, data, klass )
	{
		// Convert to array of TR elements
		var rows = [];
		var addRow = function ( r, k ) {
			// Recursion to allow for arrays of jQuery objects
			if ( $.isArray( r ) || r instanceof $ ) {
				for ( var i=0, ien=r.length ; i<ien ; i++ ) {
					addRow( r[i], k );
				}
				return;
			}
	
			// If we get a TR element, then just add it directly - up to the dev
			// to add the correct number of columns etc
			if ( r.nodeName && r.nodeName.toLowerCase() === 'tr' ) {
				rows.push( r );
			}
			else {
				// Otherwise create a row with a wrapper
				var created = $('<tr><td/></tr>').addClass( k );
				$('td', created)
					.addClass( k )
					.html( r )
					[0].colSpan = _fnVisbleColumns( ctx );
	
				rows.push( created[0] );
			}
		};
	
		addRow( data, klass );
	
		if ( row._details ) {
			row._details.detach();
		}
	
		row._details = $(rows);
	
		// If the children were already shown, that state should be retained
		if ( row._detailsShow ) {
			row._details.insertAfter( row.nTr );
		}
	};
	
	
	var __details_remove = function ( api, idx )
	{
		var ctx = api.context;
	
		if ( ctx.length ) {
			var row = ctx[0].aoData[ idx !== undefined ? idx : api[0] ];
	
			if ( row && row._details ) {
				row._details.remove();
	
				row._detailsShow = undefined;
				row._details = undefined;
			}
		}
	};
	
	
	var __details_display = function ( api, show ) {
		var ctx = api.context;
	
		if ( ctx.length && api.length ) {
			var row = ctx[0].aoData[ api[0] ];
	
			if ( row._details ) {
				row._detailsShow = show;
	
				if ( show ) {
					row._details.insertAfter( row.nTr );
				}
				else {
					row._details.detach();
				}
	
				__details_events( ctx[0] );
			}
		}
	};
	
	
	var __details_events = function ( settings )
	{
		var api = new _Api( settings );
		var namespace = '.dt.DT_details';
		var drawEvent = 'draw'+namespace;
		var colvisEvent = 'column-visibility'+namespace;
		var destroyEvent = 'destroy'+namespace;
		var data = settings.aoData;
	
		api.off( drawEvent +' '+ colvisEvent +' '+ destroyEvent );
	
		if ( _pluck( data, '_details' ).length > 0 ) {
			// On each draw, insert the required elements into the document
			api.on( drawEvent, function ( e, ctx ) {
				if ( settings !== ctx ) {
					return;
				}
	
				api.rows( {page:'current'} ).eq(0).each( function (idx) {
					// Internal data grab
					var row = data[ idx ];
	
					if ( row._detailsShow ) {
						row._details.insertAfter( row.nTr );
					}
				} );
			} );
	
			// Column visibility change - update the colspan
			api.on( colvisEvent, function ( e, ctx, idx, vis ) {
				if ( settings !== ctx ) {
					return;
				}
	
				// Update the colspan for the details rows (note, only if it already has
				// a colspan)
				var row, visible = _fnVisbleColumns( ctx );
	
				for ( var i=0, ien=data.length ; i<ien ; i++ ) {
					row = data[i];
	
					if ( row._details ) {
						row._details.children('td[colspan]').attr('colspan', visible );
					}
				}
			} );
	
			// Table destroyed - nuke any child rows
			api.on( destroyEvent, function ( e, ctx ) {
				if ( settings !== ctx ) {
					return;
				}
	
				for ( var i=0, ien=data.length ; i<ien ; i++ ) {
					if ( data[i]._details ) {
						__details_remove( api, i );
					}
				}
			} );
		}
	};
	
	// Strings for the method names to help minification
	var _emp = '';
	var _child_obj = _emp+'row().child';
	var _child_mth = _child_obj+'()';
	
	// data can be:
	//  tr
	//  string
	//  jQuery or array of any of the above
	_api_register( _child_mth, function ( data, klass ) {
		var ctx = this.context;
	
		if ( data === undefined ) {
			// get
			return ctx.length && this.length ?
				ctx[0].aoData[ this[0] ]._details :
				undefined;
		}
		else if ( data === true ) {
			// show
			this.child.show();
		}
		else if ( data === false ) {
			// remove
			__details_remove( this );
		}
		else if ( ctx.length && this.length ) {
			// set
			__details_add( ctx[0], ctx[0].aoData[ this[0] ], data, klass );
		}
	
		return this;
	} );
	
	
	_api_register( [
		_child_obj+'.show()',
		_child_mth+'.show()' // only when `child()` was called with parameters (without
	], function ( show ) {   // it returns an object and this method is not executed)
		__details_display( this, true );
		return this;
	} );
	
	
	_api_register( [
		_child_obj+'.hide()',
		_child_mth+'.hide()' // only when `child()` was called with parameters (without
	], function () {         // it returns an object and this method is not executed)
		__details_display( this, false );
		return this;
	} );
	
	
	_api_register( [
		_child_obj+'.remove()',
		_child_mth+'.remove()' // only when `child()` was called with parameters (without
	], function () {           // it returns an object and this method is not executed)
		__details_remove( this );
		return this;
	} );
	
	
	_api_register( _child_obj+'.isShown()', function () {
		var ctx = this.context;
	
		if ( ctx.length && this.length ) {
			// _detailsShown as false or undefined will fall through to return false
			return ctx[0].aoData[ this[0] ]._detailsShow || false;
		}
		return false;
	} );
	
	
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Columns
	 *
	 * {integer}           - column index (>=0 count from left, <0 count from right)
	 * "{integer}:visIdx"  - visible column index (i.e. translate to column index)  (>=0 count from left, <0 count from right)
	 * "{integer}:visible" - alias for {integer}:visIdx  (>=0 count from left, <0 count from right)
	 * "{string}:name"     - column name
	 * "{string}"          - jQuery selector on column header nodes
	 *
	 */
	
	// can be an array of these items, comma separated list, or an array of comma
	// separated lists
	
	var __re_column_selector = /^([^:]+):(name|visIdx|visible)$/;
	
	
	// r1 and r2 are redundant - but it means that the parameters match for the
	// iterator callback in columns().data()
	var __columnData = function ( settings, column, r1, r2, rows ) {
		var a = [];
		for ( var row=0, ien=rows.length ; row<ien ; row++ ) {
			a.push( _fnGetCellData( settings, rows[row], column ) );
		}
		return a;
	};
	
	
	var __column_selector = function ( settings, selector, opts )
	{
		var
			columns = settings.aoColumns,
			names = _pluck( columns, 'sName' ),
			nodes = _pluck( columns, 'nTh' );
	
		var run = function ( s ) {
			var selInt = _intVal( s );
	
			// Selector - all
			if ( s === '' ) {
				return _range( columns.length );
			}
	
			// Selector - index
			if ( selInt !== null ) {
				return [ selInt >= 0 ?
					selInt : // Count from left
					columns.length + selInt // Count from right (+ because its a negative value)
				];
			}
	
			// Selector = function
			if ( typeof s === 'function' ) {
				var rows = _selector_row_indexes( settings, opts );
	
				return $.map( columns, function (col, idx) {
					return s(
							idx,
							__columnData( settings, idx, 0, 0, rows ),
							nodes[ idx ]
						) ? idx : null;
				} );
			}
	
			// jQuery or string selector
			var match = typeof s === 'string' ?
				s.match( __re_column_selector ) :
				'';
	
			if ( match ) {
				switch( match[2] ) {
					case 'visIdx':
					case 'visible':
						var idx = parseInt( match[1], 10 );
						// Visible index given, convert to column index
						if ( idx < 0 ) {
							// Counting from the right
							var visColumns = $.map( columns, function (col,i) {
								return col.bVisible ? i : null;
							} );
							return [ visColumns[ visColumns.length + idx ] ];
						}
						// Counting from the left
						return [ _fnVisibleToColumnIndex( settings, idx ) ];
	
					case 'name':
						// match by name. `names` is column index complete and in order
						return $.map( names, function (name, i) {
							return name === match[1] ? i : null;
						} );
	
					default:
						return [];
				}
			}
	
			// Cell in the table body
			if ( s.nodeName && s._DT_CellIndex ) {
				return [ s._DT_CellIndex.column ];
			}
	
			// jQuery selector on the TH elements for the columns
			var jqResult = $( nodes )
				.filter( s )
				.map( function () {
					return $.inArray( this, nodes ); // `nodes` is column index complete and in order
				} )
				.toArray();
	
			if ( jqResult.length || ! s.nodeName ) {
				return jqResult;
			}
	
			// Otherwise a node which might have a `dt-column` data attribute, or be
			// a child or such an element
			var host = $(s).closest('*[data-dt-column]');
			return host.length ?
				[ host.data('dt-column') ] :
				[];
		};
	
		return _selector_run( 'column', selector, run, settings, opts );
	};
	
	
	var __setColumnVis = function ( settings, column, vis ) {
		var
			cols = settings.aoColumns,
			col  = cols[ column ],
			data = settings.aoData,
			row, cells, i, ien, tr;
	
		// Get
		if ( vis === undefined ) {
			return col.bVisible;
		}
	
		// Set
		// No change
		if ( col.bVisible === vis ) {
			return;
		}
	
		if ( vis ) {
			// Insert column
			// Need to decide if we should use appendChild or insertBefore
			var insertBefore = $.inArray( true, _pluck(cols, 'bVisible'), column+1 );
	
			for ( i=0, ien=data.length ; i<ien ; i++ ) {
				tr = data[i].nTr;
				cells = data[i].anCells;
	
				if ( tr ) {
					// insertBefore can act like appendChild if 2nd arg is null
					tr.insertBefore( cells[ column ], cells[ insertBefore ] || null );
				}
			}
		}
		else {
			// Remove column
			$( _pluck( settings.aoData, 'anCells', column ) ).detach();
		}
	
		// Common actions
		col.bVisible = vis;
		_fnDrawHead( settings, settings.aoHeader );
		_fnDrawHead( settings, settings.aoFooter );
	
		_fnSaveState( settings );
	};
	
	
	_api_register( 'columns()', function ( selector, opts ) {
		// argument shifting
		if ( selector === undefined ) {
			selector = '';
		}
		else if ( $.isPlainObject( selector ) ) {
			opts = selector;
			selector = '';
		}
	
		opts = _selector_opts( opts );
	
		var inst = this.iterator( 'table', function ( settings ) {
			return __column_selector( settings, selector, opts );
		}, 1 );
	
		// Want argument shifting here and in _row_selector?
		inst.selector.cols = selector;
		inst.selector.opts = opts;
	
		return inst;
	} );
	
	_api_registerPlural( 'columns().header()', 'column().header()', function ( selector, opts ) {
		return this.iterator( 'column', function ( settings, column ) {
			return settings.aoColumns[column].nTh;
		}, 1 );
	} );
	
	_api_registerPlural( 'columns().footer()', 'column().footer()', function ( selector, opts ) {
		return this.iterator( 'column', function ( settings, column ) {
			return settings.aoColumns[column].nTf;
		}, 1 );
	} );
	
	_api_registerPlural( 'columns().data()', 'column().data()', function () {
		return this.iterator( 'column-rows', __columnData, 1 );
	} );
	
	_api_registerPlural( 'columns().dataSrc()', 'column().dataSrc()', function () {
		return this.iterator( 'column', function ( settings, column ) {
			return settings.aoColumns[column].mData;
		}, 1 );
	} );
	
	_api_registerPlural( 'columns().cache()', 'column().cache()', function ( type ) {
		return this.iterator( 'column-rows', function ( settings, column, i, j, rows ) {
			return _pluck_order( settings.aoData, rows,
				type === 'search' ? '_aFilterData' : '_aSortData', column
			);
		}, 1 );
	} );
	
	_api_registerPlural( 'columns().nodes()', 'column().nodes()', function () {
		return this.iterator( 'column-rows', function ( settings, column, i, j, rows ) {
			return _pluck_order( settings.aoData, rows, 'anCells', column ) ;
		}, 1 );
	} );
	
	_api_registerPlural( 'columns().visible()', 'column().visible()', function ( vis, calc ) {
		var ret = this.iterator( 'column', function ( settings, column ) {
			if ( vis === undefined ) {
				return settings.aoColumns[ column ].bVisible;
			} // else
			__setColumnVis( settings, column, vis );
		} );
	
		// Group the column visibility changes
		if ( vis !== undefined ) {
			// Second loop once the first is done for events
			this.iterator( 'column', function ( settings, column ) {
				_fnCallbackFire( settings, null, 'column-visibility', [settings, column, vis, calc] );
			} );
	
			if ( calc === undefined || calc ) {
				this.columns.adjust();
			}
		}
	
		return ret;
	} );
	
	_api_registerPlural( 'columns().indexes()', 'column().index()', function ( type ) {
		return this.iterator( 'column', function ( settings, column ) {
			return type === 'visible' ?
				_fnColumnIndexToVisible( settings, column ) :
				column;
		}, 1 );
	} );
	
	_api_register( 'columns.adjust()', function () {
		return this.iterator( 'table', function ( settings ) {
			_fnAdjustColumnSizing( settings );
		}, 1 );
	} );
	
	_api_register( 'column.index()', function ( type, idx ) {
		if ( this.context.length !== 0 ) {
			var ctx = this.context[0];
	
			if ( type === 'fromVisible' || type === 'toData' ) {
				return _fnVisibleToColumnIndex( ctx, idx );
			}
			else if ( type === 'fromData' || type === 'toVisible' ) {
				return _fnColumnIndexToVisible( ctx, idx );
			}
		}
	} );
	
	_api_register( 'column()', function ( selector, opts ) {
		return _selector_first( this.columns( selector, opts ) );
	} );
	
	
	
	var __cell_selector = function ( settings, selector, opts )
	{
		var data = settings.aoData;
		var rows = _selector_row_indexes( settings, opts );
		var cells = _removeEmpty( _pluck_order( data, rows, 'anCells' ) );
		var allCells = $( [].concat.apply([], cells) );
		var row;
		var columns = settings.aoColumns.length;
		var a, i, ien, j, o, host;
	
		var run = function ( s ) {
			var fnSelector = typeof s === 'function';
	
			if ( s === null || s === undefined || fnSelector ) {
				// All cells and function selectors
				a = [];
	
				for ( i=0, ien=rows.length ; i<ien ; i++ ) {
					row = rows[i];
	
					for ( j=0 ; j<columns ; j++ ) {
						o = {
							row: row,
							column: j
						};
	
						if ( fnSelector ) {
							// Selector - function
							host = data[ row ];
	
							if ( s( o, _fnGetCellData(settings, row, j), host.anCells ? host.anCells[j] : null ) ) {
								a.push( o );
							}
						}
						else {
							// Selector - all
							a.push( o );
						}
					}
				}
	
				return a;
			}
			
			// Selector - index
			if ( $.isPlainObject( s ) ) {
				return [s];
			}
	
			// Selector - jQuery filtered cells
			var jqResult = allCells
				.filter( s )
				.map( function (i, el) {
					return { // use a new object, in case someone changes the values
						row:    el._DT_CellIndex.row,
						column: el._DT_CellIndex.column
	 				};
				} )
				.toArray();
	
			if ( jqResult.length || ! s.nodeName ) {
				return jqResult;
			}
	
			// Otherwise the selector is a node, and there is one last option - the
			// element might be a child of an element which has dt-row and dt-column
			// data attributes
			host = $(s).closest('*[data-dt-row]');
			return host.length ?
				[ {
					row: host.data('dt-row'),
					column: host.data('dt-column')
				} ] :
				[];
		};
	
		return _selector_run( 'cell', selector, run, settings, opts );
	};
	
	
	
	
	_api_register( 'cells()', function ( rowSelector, columnSelector, opts ) {
		// Argument shifting
		if ( $.isPlainObject( rowSelector ) ) {
			// Indexes
			if ( rowSelector.row === undefined ) {
				// Selector options in first parameter
				opts = rowSelector;
				rowSelector = null;
			}
			else {
				// Cell index objects in first parameter
				opts = columnSelector;
				columnSelector = null;
			}
		}
		if ( $.isPlainObject( columnSelector ) ) {
			opts = columnSelector;
			columnSelector = null;
		}
	
		// Cell selector
		if ( columnSelector === null || columnSelector === undefined ) {
			return this.iterator( 'table', function ( settings ) {
				return __cell_selector( settings, rowSelector, _selector_opts( opts ) );
			} );
		}
	
		// Row + column selector
		var columns = this.columns( columnSelector, opts );
		var rows = this.rows( rowSelector, opts );
		var a, i, ien, j, jen;
	
		var cells = this.iterator( 'table', function ( settings, idx ) {
			a = [];
	
			for ( i=0, ien=rows[idx].length ; i<ien ; i++ ) {
				for ( j=0, jen=columns[idx].length ; j<jen ; j++ ) {
					a.push( {
						row:    rows[idx][i],
						column: columns[idx][j]
					} );
				}
			}
	
			return a;
		}, 1 );
	
		$.extend( cells.selector, {
			cols: columnSelector,
			rows: rowSelector,
			opts: opts
		} );
	
		return cells;
	} );
	
	
	_api_registerPlural( 'cells().nodes()', 'cell().node()', function () {
		return this.iterator( 'cell', function ( settings, row, column ) {
			var data = settings.aoData[ row ];
	
			return data && data.anCells ?
				data.anCells[ column ] :
				undefined;
		}, 1 );
	} );
	
	
	_api_register( 'cells().data()', function () {
		return this.iterator( 'cell', function ( settings, row, column ) {
			return _fnGetCellData( settings, row, column );
		}, 1 );
	} );
	
	
	_api_registerPlural( 'cells().cache()', 'cell().cache()', function ( type ) {
		type = type === 'search' ? '_aFilterData' : '_aSortData';
	
		return this.iterator( 'cell', function ( settings, row, column ) {
			return settings.aoData[ row ][ type ][ column ];
		}, 1 );
	} );
	
	
	_api_registerPlural( 'cells().render()', 'cell().render()', function ( type ) {
		return this.iterator( 'cell', function ( settings, row, column ) {
			return _fnGetCellData( settings, row, column, type );
		}, 1 );
	} );
	
	
	_api_registerPlural( 'cells().indexes()', 'cell().index()', function () {
		return this.iterator( 'cell', function ( settings, row, column ) {
			return {
				row: row,
				column: column,
				columnVisible: _fnColumnIndexToVisible( settings, column )
			};
		}, 1 );
	} );
	
	
	_api_registerPlural( 'cells().invalidate()', 'cell().invalidate()', function ( src ) {
		return this.iterator( 'cell', function ( settings, row, column ) {
			_fnInvalidate( settings, row, src, column );
		} );
	} );
	
	
	
	_api_register( 'cell()', function ( rowSelector, columnSelector, opts ) {
		return _selector_first( this.cells( rowSelector, columnSelector, opts ) );
	} );
	
	
	_api_register( 'cell().data()', function ( data ) {
		var ctx = this.context;
		var cell = this[0];
	
		if ( data === undefined ) {
			// Get
			return ctx.length && cell.length ?
				_fnGetCellData( ctx[0], cell[0].row, cell[0].column ) :
				undefined;
		}
	
		// Set
		_fnSetCellData( ctx[0], cell[0].row, cell[0].column, data );
		_fnInvalidate( ctx[0], cell[0].row, 'data', cell[0].column );
	
		return this;
	} );
	
	
	
	/**
	 * Get current ordering (sorting) that has been applied to the table.
	 *
	 * @returns {array} 2D array containing the sorting information for the first
	 *   table in the current context. Each element in the parent array represents
	 *   a column being sorted upon (i.e. multi-sorting with two columns would have
	 *   2 inner arrays). The inner arrays may have 2 or 3 elements. The first is
	 *   the column index that the sorting condition applies to, the second is the
	 *   direction of the sort (`desc` or `asc`) and, optionally, the third is the
	 *   index of the sorting order from the `column.sorting` initialisation array.
	 *//**
	 * Set the ordering for the table.
	 *
	 * @param {integer} order Column index to sort upon.
	 * @param {string} direction Direction of the sort to be applied (`asc` or `desc`)
	 * @returns {DataTables.Api} this
	 *//**
	 * Set the ordering for the table.
	 *
	 * @param {array} order 1D array of sorting information to be applied.
	 * @param {array} [...] Optional additional sorting conditions
	 * @returns {DataTables.Api} this
	 *//**
	 * Set the ordering for the table.
	 *
	 * @param {array} order 2D array of sorting information to be applied.
	 * @returns {DataTables.Api} this
	 */
	_api_register( 'order()', function ( order, dir ) {
		var ctx = this.context;
	
		if ( order === undefined ) {
			// get
			return ctx.length !== 0 ?
				ctx[0].aaSorting :
				undefined;
		}
	
		// set
		if ( typeof order === 'number' ) {
			// Simple column / direction passed in
			order = [ [ order, dir ] ];
		}
		else if ( order.length && ! $.isArray( order[0] ) ) {
			// Arguments passed in (list of 1D arrays)
			order = Array.prototype.slice.call( arguments );
		}
		// otherwise a 2D array was passed in
	
		return this.iterator( 'table', function ( settings ) {
			settings.aaSorting = order.slice();
		} );
	} );
	
	
	/**
	 * Attach a sort listener to an element for a given column
	 *
	 * @param {node|jQuery|string} node Identifier for the element(s) to attach the
	 *   listener to. This can take the form of a single DOM node, a jQuery
	 *   collection of nodes or a jQuery selector which will identify the node(s).
	 * @param {integer} column the column that a click on this node will sort on
	 * @param {function} [callback] callback function when sort is run
	 * @returns {DataTables.Api} this
	 */
	_api_register( 'order.listener()', function ( node, column, callback ) {
		return this.iterator( 'table', function ( settings ) {
			_fnSortAttachListener( settings, node, column, callback );
		} );
	} );
	
	
	_api_register( 'order.fixed()', function ( set ) {
		if ( ! set ) {
			var ctx = this.context;
			var fixed = ctx.length ?
				ctx[0].aaSortingFixed :
				undefined;
	
			return $.isArray( fixed ) ?
				{ pre: fixed } :
				fixed;
		}
	
		return this.iterator( 'table', function ( settings ) {
			settings.aaSortingFixed = $.extend( true, {}, set );
		} );
	} );
	
	
	// Order by the selected column(s)
	_api_register( [
		'columns().order()',
		'column().order()'
	], function ( dir ) {
		var that = this;
	
		return this.iterator( 'table', function ( settings, i ) {
			var sort = [];
	
			$.each( that[i], function (j, col) {
				sort.push( [ col, dir ] );
			} );
	
			settings.aaSorting = sort;
		} );
	} );
	
	
	
	_api_register( 'search()', function ( input, regex, smart, caseInsen ) {
		var ctx = this.context;
	
		if ( input === undefined ) {
			// get
			return ctx.length !== 0 ?
				ctx[0].oPreviousSearch.sSearch :
				undefined;
		}
	
		// set
		return this.iterator( 'table', function ( settings ) {
			if ( ! settings.oFeatures.bFilter ) {
				return;
			}
	
			_fnFilterComplete( settings, $.extend( {}, settings.oPreviousSearch, {
				"sSearch": input+"",
				"bRegex":  regex === null ? false : regex,
				"bSmart":  smart === null ? true  : smart,
				"bCaseInsensitive": caseInsen === null ? true : caseInsen
			} ), 1 );
		} );
	} );
	
	
	_api_registerPlural(
		'columns().search()',
		'column().search()',
		function ( input, regex, smart, caseInsen ) {
			return this.iterator( 'column', function ( settings, column ) {
				var preSearch = settings.aoPreSearchCols;
	
				if ( input === undefined ) {
					// get
					return preSearch[ column ].sSearch;
				}
	
				// set
				if ( ! settings.oFeatures.bFilter ) {
					return;
				}
	
				$.extend( preSearch[ column ], {
					"sSearch": input+"",
					"bRegex":  regex === null ? false : regex,
					"bSmart":  smart === null ? true  : smart,
					"bCaseInsensitive": caseInsen === null ? true : caseInsen
				} );
	
				_fnFilterComplete( settings, settings.oPreviousSearch, 1 );
			} );
		}
	);
	
	/*
	 * State API methods
	 */
	
	_api_register( 'state()', function () {
		return this.context.length ?
			this.context[0].oSavedState :
			null;
	} );
	
	
	_api_register( 'state.clear()', function () {
		return this.iterator( 'table', function ( settings ) {
			// Save an empty object
			settings.fnStateSaveCallback.call( settings.oInstance, settings, {} );
		} );
	} );
	
	
	_api_register( 'state.loaded()', function () {
		return this.context.length ?
			this.context[0].oLoadedState :
			null;
	} );
	
	
	_api_register( 'state.save()', function () {
		return this.iterator( 'table', function ( settings ) {
			_fnSaveState( settings );
		} );
	} );
	
	
	
	/**
	 * Provide a common method for plug-ins to check the version of DataTables being
	 * used, in order to ensure compatibility.
	 *
	 *  @param {string} version Version string to check for, in the format "X.Y.Z".
	 *    Note that the formats "X" and "X.Y" are also acceptable.
	 *  @returns {boolean} true if this version of DataTables is greater or equal to
	 *    the required version, or false if this version of DataTales is not
	 *    suitable
	 *  @static
	 *  @dtopt API-Static
	 *
	 *  @example
	 *    alert( $.fn.dataTable.versionCheck( '1.9.0' ) );
	 */
	DataTable.versionCheck = DataTable.fnVersionCheck = function( version )
	{
		var aThis = DataTable.version.split('.');
		var aThat = version.split('.');
		var iThis, iThat;
	
		for ( var i=0, iLen=aThat.length ; i<iLen ; i++ ) {
			iThis = parseInt( aThis[i], 10 ) || 0;
			iThat = parseInt( aThat[i], 10 ) || 0;
	
			// Parts are the same, keep comparing
			if (iThis === iThat) {
				continue;
			}
	
			// Parts are different, return immediately
			return iThis > iThat;
		}
	
		return true;
	};
	
	
	/**
	 * Check if a `<table>` node is a DataTable table already or not.
	 *
	 *  @param {node|jquery|string} table Table node, jQuery object or jQuery
	 *      selector for the table to test. Note that if more than more than one
	 *      table is passed on, only the first will be checked
	 *  @returns {boolean} true the table given is a DataTable, or false otherwise
	 *  @static
	 *  @dtopt API-Static
	 *
	 *  @example
	 *    if ( ! $.fn.DataTable.isDataTable( '#example' ) ) {
	 *      $('#example').dataTable();
	 *    }
	 */
	DataTable.isDataTable = DataTable.fnIsDataTable = function ( table )
	{
		var t = $(table).get(0);
		var is = false;
	
		if ( table instanceof DataTable.Api ) {
			return true;
		}
	
		$.each( DataTable.settings, function (i, o) {
			var head = o.nScrollHead ? $('table', o.nScrollHead)[0] : null;
			var foot = o.nScrollFoot ? $('table', o.nScrollFoot)[0] : null;
	
			if ( o.nTable === t || head === t || foot === t ) {
				is = true;
			}
		} );
	
		return is;
	};
	
	
	/**
	 * Get all DataTable tables that have been initialised - optionally you can
	 * select to get only currently visible tables.
	 *
	 *  @param {boolean} [visible=false] Flag to indicate if you want all (default)
	 *    or visible tables only.
	 *  @returns {array} Array of `table` nodes (not DataTable instances) which are
	 *    DataTables
	 *  @static
	 *  @dtopt API-Static
	 *
	 *  @example
	 *    $.each( $.fn.dataTable.tables(true), function () {
	 *      $(table).DataTable().columns.adjust();
	 *    } );
	 */
	DataTable.tables = DataTable.fnTables = function ( visible )
	{
		var api = false;
	
		if ( $.isPlainObject( visible ) ) {
			api = visible.api;
			visible = visible.visible;
		}
	
		var a = $.map( DataTable.settings, function (o) {
			if ( !visible || (visible && $(o.nTable).is(':visible')) ) {
				return o.nTable;
			}
		} );
	
		return api ?
			new _Api( a ) :
			a;
	};
	
	
	/**
	 * Convert from camel case parameters to Hungarian notation. This is made public
	 * for the extensions to provide the same ability as DataTables core to accept
	 * either the 1.9 style Hungarian notation, or the 1.10+ style camelCase
	 * parameters.
	 *
	 *  @param {object} src The model object which holds all parameters that can be
	 *    mapped.
	 *  @param {object} user The object to convert from camel case to Hungarian.
	 *  @param {boolean} force When set to `true`, properties which already have a
	 *    Hungarian value in the `user` object will be overwritten. Otherwise they
	 *    won't be.
	 */
	DataTable.camelToHungarian = _fnCamelToHungarian;
	
	
	
	/**
	 *
	 */
	_api_register( '$()', function ( selector, opts ) {
		var
			rows   = this.rows( opts ).nodes(), // Get all rows
			jqRows = $(rows);
	
		return $( [].concat(
			jqRows.filter( selector ).toArray(),
			jqRows.find( selector ).toArray()
		) );
	} );
	
	
	// jQuery functions to operate on the tables
	$.each( [ 'on', 'one', 'off' ], function (i, key) {
		_api_register( key+'()', function ( /* event, handler */ ) {
			var args = Array.prototype.slice.call(arguments);
	
			// Add the `dt` namespace automatically if it isn't already present
			args[0] = $.map( args[0].split( /\s/ ), function ( e ) {
				return ! e.match(/\.dt\b/) ?
					e+'.dt' :
					e;
				} ).join( ' ' );
	
			var inst = $( this.tables().nodes() );
			inst[key].apply( inst, args );
			return this;
		} );
	} );
	
	
	_api_register( 'clear()', function () {
		return this.iterator( 'table', function ( settings ) {
			_fnClearTable( settings );
		} );
	} );
	
	
	_api_register( 'settings()', function () {
		return new _Api( this.context, this.context );
	} );
	
	
	_api_register( 'init()', function () {
		var ctx = this.context;
		return ctx.length ? ctx[0].oInit : null;
	} );
	
	
	_api_register( 'data()', function () {
		return this.iterator( 'table', function ( settings ) {
			return _pluck( settings.aoData, '_aData' );
		} ).flatten();
	} );
	
	
	_api_register( 'destroy()', function ( remove ) {
		remove = remove || false;
	
		return this.iterator( 'table', function ( settings ) {
			var orig      = settings.nTableWrapper.parentNode;
			var classes   = settings.oClasses;
			var table     = settings.nTable;
			var tbody     = settings.nTBody;
			var thead     = settings.nTHead;
			var tfoot     = settings.nTFoot;
			var jqTable   = $(table);
			var jqTbody   = $(tbody);
			var jqWrapper = $(settings.nTableWrapper);
			var rows      = $.map( settings.aoData, function (r) { return r.nTr; } );
			var i, ien;
	
			// Flag to note that the table is currently being destroyed - no action
			// should be taken
			settings.bDestroying = true;
	
			// Fire off the destroy callbacks for plug-ins etc
			_fnCallbackFire( settings, "aoDestroyCallback", "destroy", [settings] );
	
			// If not being removed from the document, make all columns visible
			if ( ! remove ) {
				new _Api( settings ).columns().visible( true );
			}
	
			// Blitz all `DT` namespaced events (these are internal events, the
			// lowercase, `dt` events are user subscribed and they are responsible
			// for removing them
			jqWrapper.off('.DT').find(':not(tbody *)').off('.DT');
			$(window).off('.DT-'+settings.sInstance);
	
			// When scrolling we had to break the table up - restore it
			if ( table != thead.parentNode ) {
				jqTable.children('thead').detach();
				jqTable.append( thead );
			}
	
			if ( tfoot && table != tfoot.parentNode ) {
				jqTable.children('tfoot').detach();
				jqTable.append( tfoot );
			}
	
			settings.aaSorting = [];
			settings.aaSortingFixed = [];
			_fnSortingClasses( settings );
	
			$( rows ).removeClass( settings.asStripeClasses.join(' ') );
	
			$('th, td', thead).removeClass( classes.sSortable+' '+
				classes.sSortableAsc+' '+classes.sSortableDesc+' '+classes.sSortableNone
			);
	
			if ( settings.bJUI ) {
				$('th span.'+classes.sSortIcon+ ', td span.'+classes.sSortIcon, thead).detach();
				$('th, td', thead).each( function () {
					var wrapper = $('div.'+classes.sSortJUIWrapper, this);
					$(this).append( wrapper.contents() );
					wrapper.detach();
				} );
			}
	
			// Add the TR elements back into the table in their original order
			jqTbody.children().detach();
			jqTbody.append( rows );
	
			// Remove the DataTables generated nodes, events and classes
			var removedMethod = remove ? 'remove' : 'detach';
			jqTable[ removedMethod ]();
			jqWrapper[ removedMethod ]();
	
			// If we need to reattach the table to the document
			if ( ! remove && orig ) {
				// insertBefore acts like appendChild if !arg[1]
				orig.insertBefore( table, settings.nTableReinsertBefore );
	
				// Restore the width of the original table - was read from the style property,
				// so we can restore directly to that
				jqTable
					.css( 'width', settings.sDestroyWidth )
					.removeClass( classes.sTable );
	
				// If the were originally stripe classes - then we add them back here.
				// Note this is not fool proof (for example if not all rows had stripe
				// classes - but it's a good effort without getting carried away
				ien = settings.asDestroyStripes.length;
	
				if ( ien ) {
					jqTbody.children().each( function (i) {
						$(this).addClass( settings.asDestroyStripes[i % ien] );
					} );
				}
			}
	
			/* Remove the settings object from the settings array */
			var idx = $.inArray( settings, DataTable.settings );
			if ( idx !== -1 ) {
				DataTable.settings.splice( idx, 1 );
			}
		} );
	} );
	
	
	// Add the `every()` method for rows, columns and cells in a compact form
	$.each( [ 'column', 'row', 'cell' ], function ( i, type ) {
		_api_register( type+'s().every()', function ( fn ) {
			var opts = this.selector.opts;
			var api = this;
	
			return this.iterator( type, function ( settings, arg1, arg2, arg3, arg4 ) {
				// Rows and columns:
				//  arg1 - index
				//  arg2 - table counter
				//  arg3 - loop counter
				//  arg4 - undefined
				// Cells:
				//  arg1 - row index
				//  arg2 - column index
				//  arg3 - table counter
				//  arg4 - loop counter
				fn.call(
					api[ type ](
						arg1,
						type==='cell' ? arg2 : opts,
						type==='cell' ? opts : undefined
					),
					arg1, arg2, arg3, arg4
				);
			} );
		} );
	} );
	
	
	// i18n method for extensions to be able to use the language object from the
	// DataTable
	_api_register( 'i18n()', function ( token, def, plural ) {
		var ctx = this.context[0];
		var resolved = _fnGetObjectDataFn( token )( ctx.oLanguage );
	
		if ( resolved === undefined ) {
			resolved = def;
		}
	
		if ( plural !== undefined && $.isPlainObject( resolved ) ) {
			resolved = resolved[ plural ] !== undefined ?
				resolved[ plural ] :
				resolved._;
		}
	
		return resolved.replace( '%d', plural ); // nb: plural might be undefined,
	} );
	/**
	 * Version string for plug-ins to check compatibility. Allowed format is
	 * `a.b.c-d` where: a:int, b:int, c:int, d:string(dev|beta|alpha). `d` is used
	 * only for non-release builds. See http://semver.org/ for more information.
	 *  @member
	 *  @type string
	 *  @default Version number
	 */
	DataTable.version = "1.10.13";

	/**
	 * Private data store, containing all of the settings objects that are
	 * created for the tables on a given page.
	 *
	 * Note that the `DataTable.settings` object is aliased to
	 * `jQuery.fn.dataTableExt` through which it may be accessed and
	 * manipulated, or `jQuery.fn.dataTable.settings`.
	 *  @member
	 *  @type array
	 *  @default []
	 *  @private
	 */
	DataTable.settings = [];

	/**
	 * Object models container, for the various models that DataTables has
	 * available to it. These models define the objects that are used to hold
	 * the active state and configuration of the table.
	 *  @namespace
	 */
	DataTable.models = {};
	
	
	
	/**
	 * Template object for the way in which DataTables holds information about
	 * search information for the global filter and individual column filters.
	 *  @namespace
	 */
	DataTable.models.oSearch = {
		/**
		 * Flag to indicate if the filtering should be case insensitive or not
		 *  @type boolean
		 *  @default true
		 */
		"bCaseInsensitive": true,
	
		/**
		 * Applied search term
		 *  @type string
		 *  @default <i>Empty string</i>
		 */
		"sSearch": "",
	
		/**
		 * Flag to indicate if the search term should be interpreted as a
		 * regular expression (true) or not (false) and therefore and special
		 * regex characters escaped.
		 *  @type boolean
		 *  @default false
		 */
		"bRegex": false,
	
		/**
		 * Flag to indicate if DataTables is to use its smart filtering or not.
		 *  @type boolean
		 *  @default true
		 */
		"bSmart": true
	};
	
	
	
	
	/**
	 * Template object for the way in which DataTables holds information about
	 * each individual row. This is the object format used for the settings
	 * aoData array.
	 *  @namespace
	 */
	DataTable.models.oRow = {
		/**
		 * TR element for the row
		 *  @type node
		 *  @default null
		 */
		"nTr": null,
	
		/**
		 * Array of TD elements for each row. This is null until the row has been
		 * created.
		 *  @type array nodes
		 *  @default []
		 */
		"anCells": null,
	
		/**
		 * Data object from the original data source for the row. This is either
		 * an array if using the traditional form of DataTables, or an object if
		 * using mData options. The exact type will depend on the passed in
		 * data from the data source, or will be an array if using DOM a data
		 * source.
		 *  @type array|object
		 *  @default []
		 */
		"_aData": [],
	
		/**
		 * Sorting data cache - this array is ostensibly the same length as the
		 * number of columns (although each index is generated only as it is
		 * needed), and holds the data that is used for sorting each column in the
		 * row. We do this cache generation at the start of the sort in order that
		 * the formatting of the sort data need be done only once for each cell
		 * per sort. This array should not be read from or written to by anything
		 * other than the master sorting methods.
		 *  @type array
		 *  @default null
		 *  @private
		 */
		"_aSortData": null,
	
		/**
		 * Per cell filtering data cache. As per the sort data cache, used to
		 * increase the performance of the filtering in DataTables
		 *  @type array
		 *  @default null
		 *  @private
		 */
		"_aFilterData": null,
	
		/**
		 * Filtering data cache. This is the same as the cell filtering cache, but
		 * in this case a string rather than an array. This is easily computed with
		 * a join on `_aFilterData`, but is provided as a cache so the join isn't
		 * needed on every search (memory traded for performance)
		 *  @type array
		 *  @default null
		 *  @private
		 */
		"_sFilterRow": null,
	
		/**
		 * Cache of the class name that DataTables has applied to the row, so we
		 * can quickly look at this variable rather than needing to do a DOM check
		 * on className for the nTr property.
		 *  @type string
		 *  @default <i>Empty string</i>
		 *  @private
		 */
		"_sRowStripe": "",
	
		/**
		 * Denote if the original data source was from the DOM, or the data source
		 * object. This is used for invalidating data, so DataTables can
		 * automatically read data from the original source, unless uninstructed
		 * otherwise.
		 *  @type string
		 *  @default null
		 *  @private
		 */
		"src": null,
	
		/**
		 * Index in the aoData array. This saves an indexOf lookup when we have the
		 * object, but want to know the index
		 *  @type integer
		 *  @default -1
		 *  @private
		 */
		"idx": -1
	};
	
	
	/**
	 * Template object for the column information object in DataTables. This object
	 * is held in the settings aoColumns array and contains all the information that
	 * DataTables needs about each individual column.
	 *
	 * Note that this object is related to {@link DataTable.defaults.column}
	 * but this one is the internal data store for DataTables's cache of columns.
	 * It should NOT be manipulated outside of DataTables. Any configuration should
	 * be done through the initialisation options.
	 *  @namespace
	 */
	DataTable.models.oColumn = {
		/**
		 * Column index. This could be worked out on-the-fly with $.inArray, but it
		 * is faster to just hold it as a variable
		 *  @type integer
		 *  @default null
		 */
		"idx": null,
	
		/**
		 * A list of the columns that sorting should occur on when this column
		 * is sorted. That this property is an array allows multi-column sorting
		 * to be defined for a column (for example first name / last name columns
		 * would benefit from this). The values are integers pointing to the
		 * columns to be sorted on (typically it will be a single integer pointing
		 * at itself, but that doesn't need to be the case).
		 *  @type array
		 */
		"aDataSort": null,
	
		/**
		 * Define the sorting directions that are applied to the column, in sequence
		 * as the column is repeatedly sorted upon - i.e. the first value is used
		 * as the sorting direction when the column if first sorted (clicked on).
		 * Sort it again (click again) and it will move on to the next index.
		 * Repeat until loop.
		 *  @type array
		 */
		"asSorting": null,
	
		/**
		 * Flag to indicate if the column is searchable, and thus should be included
		 * in the filtering or not.
		 *  @type boolean
		 */
		"bSearchable": null,
	
		/**
		 * Flag to indicate if the column is sortable or not.
		 *  @type boolean
		 */
		"bSortable": null,
	
		/**
		 * Flag to indicate if the column is currently visible in the table or not
		 *  @type boolean
		 */
		"bVisible": null,
	
		/**
		 * Store for manual type assignment using the `column.type` option. This
		 * is held in store so we can manipulate the column's `sType` property.
		 *  @type string
		 *  @default null
		 *  @private
		 */
		"_sManualType": null,
	
		/**
		 * Flag to indicate if HTML5 data attributes should be used as the data
		 * source for filtering or sorting. True is either are.
		 *  @type boolean
		 *  @default false
		 *  @private
		 */
		"_bAttrSrc": false,
	
		/**
		 * Developer definable function that is called whenever a cell is created (Ajax source,
		 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
		 * allowing you to modify the DOM element (add background colour for example) when the
		 * element is available.
		 *  @type function
		 *  @param {element} nTd The TD node that has been created
		 *  @param {*} sData The Data for the cell
		 *  @param {array|object} oData The data for the whole row
		 *  @param {int} iRow The row index for the aoData data store
		 *  @default null
		 */
		"fnCreatedCell": null,
	
		/**
		 * Function to get data from a cell in a column. You should <b>never</b>
		 * access data directly through _aData internally in DataTables - always use
		 * the method attached to this property. It allows mData to function as
		 * required. This function is automatically assigned by the column
		 * initialisation method
		 *  @type function
		 *  @param {array|object} oData The data array/object for the array
		 *    (i.e. aoData[]._aData)
		 *  @param {string} sSpecific The specific data type you want to get -
		 *    'display', 'type' 'filter' 'sort'
		 *  @returns {*} The data for the cell from the given row's data
		 *  @default null
		 */
		"fnGetData": null,
	
		/**
		 * Function to set data for a cell in the column. You should <b>never</b>
		 * set the data directly to _aData internally in DataTables - always use
		 * this method. It allows mData to function as required. This function
		 * is automatically assigned by the column initialisation method
		 *  @type function
		 *  @param {array|object} oData The data array/object for the array
		 *    (i.e. aoData[]._aData)
		 *  @param {*} sValue Value to set
		 *  @default null
		 */
		"fnSetData": null,
	
		/**
		 * Property to read the value for the cells in the column from the data
		 * source array / object. If null, then the default content is used, if a
		 * function is given then the return from the function is used.
		 *  @type function|int|string|null
		 *  @default null
		 */
		"mData": null,
	
		/**
		 * Partner property to mData which is used (only when defined) to get
		 * the data - i.e. it is basically the same as mData, but without the
		 * 'set' option, and also the data fed to it is the result from mData.
		 * This is the rendering method to match the data method of mData.
		 *  @type function|int|string|null
		 *  @default null
		 */
		"mRender": null,
	
		/**
		 * Unique header TH/TD element for this column - this is what the sorting
		 * listener is attached to (if sorting is enabled.)
		 *  @type node
		 *  @default null
		 */
		"nTh": null,
	
		/**
		 * Unique footer TH/TD element for this column (if there is one). Not used
		 * in DataTables as such, but can be used for plug-ins to reference the
		 * footer for each column.
		 *  @type node
		 *  @default null
		 */
		"nTf": null,
	
		/**
		 * The class to apply to all TD elements in the table's TBODY for the column
		 *  @type string
		 *  @default null
		 */
		"sClass": null,
	
		/**
		 * When DataTables calculates the column widths to assign to each column,
		 * it finds the longest string in each column and then constructs a
		 * temporary table and reads the widths from that. The problem with this
		 * is that "mmm" is much wider then "iiii", but the latter is a longer
		 * string - thus the calculation can go wrong (doing it properly and putting
		 * it into an DOM object and measuring that is horribly(!) slow). Thus as
		 * a "work around" we provide this option. It will append its value to the
		 * text that is found to be the longest string for the column - i.e. padding.
		 *  @type string
		 */
		"sContentPadding": null,
	
		/**
		 * Allows a default value to be given for a column's data, and will be used
		 * whenever a null data source is encountered (this can be because mData
		 * is set to null, or because the data source itself is null).
		 *  @type string
		 *  @default null
		 */
		"sDefaultContent": null,
	
		/**
		 * Name for the column, allowing reference to the column by name as well as
		 * by index (needs a lookup to work by name).
		 *  @type string
		 */
		"sName": null,
	
		/**
		 * Custom sorting data type - defines which of the available plug-ins in
		 * afnSortData the custom sorting will use - if any is defined.
		 *  @type string
		 *  @default std
		 */
		"sSortDataType": 'std',
	
		/**
		 * Class to be applied to the header element when sorting on this column
		 *  @type string
		 *  @default null
		 */
		"sSortingClass": null,
	
		/**
		 * Class to be applied to the header element when sorting on this column -
		 * when jQuery UI theming is used.
		 *  @type string
		 *  @default null
		 */
		"sSortingClassJUI": null,
	
		/**
		 * Title of the column - what is seen in the TH element (nTh).
		 *  @type string
		 */
		"sTitle": null,
	
		/**
		 * Column sorting and filtering type
		 *  @type string
		 *  @default null
		 */
		"sType": null,
	
		/**
		 * Width of the column
		 *  @type string
		 *  @default null
		 */
		"sWidth": null,
	
		/**
		 * Width of the column when it was first "encountered"
		 *  @type string
		 *  @default null
		 */
		"sWidthOrig": null
	};
	
	
	/*
	 * Developer note: The properties of the object below are given in Hungarian
	 * notation, that was used as the interface for DataTables prior to v1.10, however
	 * from v1.10 onwards the primary interface is camel case. In order to avoid
	 * breaking backwards compatibility utterly with this change, the Hungarian
	 * version is still, internally the primary interface, but is is not documented
	 * - hence the @name tags in each doc comment. This allows a Javascript function
	 * to create a map from Hungarian notation to camel case (going the other direction
	 * would require each property to be listed, which would at around 3K to the size
	 * of DataTables, while this method is about a 0.5K hit.
	 *
	 * Ultimately this does pave the way for Hungarian notation to be dropped
	 * completely, but that is a massive amount of work and will break current
	 * installs (therefore is on-hold until v2).
	 */
	
	/**
	 * Initialisation options that can be given to DataTables at initialisation
	 * time.
	 *  @namespace
	 */
	DataTable.defaults = {
		/**
		 * An array of data to use for the table, passed in at initialisation which
		 * will be used in preference to any data which is already in the DOM. This is
		 * particularly useful for constructing tables purely in Javascript, for
		 * example with a custom Ajax call.
		 *  @type array
		 *  @default null
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.data
		 *
		 *  @example
		 *    // Using a 2D array data source
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "data": [
		 *          ['Trident', 'Internet Explorer 4.0', 'Win 95+', 4, 'X'],
		 *          ['Trident', 'Internet Explorer 5.0', 'Win 95+', 5, 'C'],
		 *        ],
		 *        "columns": [
		 *          { "title": "Engine" },
		 *          { "title": "Browser" },
		 *          { "title": "Platform" },
		 *          { "title": "Version" },
		 *          { "title": "Grade" }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using an array of objects as a data source (`data`)
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "data": [
		 *          {
		 *            "engine":   "Trident",
		 *            "browser":  "Internet Explorer 4.0",
		 *            "platform": "Win 95+",
		 *            "version":  4,
		 *            "grade":    "X"
		 *          },
		 *          {
		 *            "engine":   "Trident",
		 *            "browser":  "Internet Explorer 5.0",
		 *            "platform": "Win 95+",
		 *            "version":  5,
		 *            "grade":    "C"
		 *          }
		 *        ],
		 *        "columns": [
		 *          { "title": "Engine",   "data": "engine" },
		 *          { "title": "Browser",  "data": "browser" },
		 *          { "title": "Platform", "data": "platform" },
		 *          { "title": "Version",  "data": "version" },
		 *          { "title": "Grade",    "data": "grade" }
		 *        ]
		 *      } );
		 *    } );
		 */
		"aaData": null,
	
	
		/**
		 * If ordering is enabled, then DataTables will perform a first pass sort on
		 * initialisation. You can define which column(s) the sort is performed
		 * upon, and the sorting direction, with this variable. The `sorting` array
		 * should contain an array for each column to be sorted initially containing
		 * the column's index and a direction string ('asc' or 'desc').
		 *  @type array
		 *  @default [[0,'asc']]
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.order
		 *
		 *  @example
		 *    // Sort by 3rd column first, and then 4th column
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "order": [[2,'asc'], [3,'desc']]
		 *      } );
		 *    } );
		 *
		 *    // No initial sorting
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "order": []
		 *      } );
		 *    } );
		 */
		"aaSorting": [[0,'asc']],
	
	
		/**
		 * This parameter is basically identical to the `sorting` parameter, but
		 * cannot be overridden by user interaction with the table. What this means
		 * is that you could have a column (visible or hidden) which the sorting
		 * will always be forced on first - any sorting after that (from the user)
		 * will then be performed as required. This can be useful for grouping rows
		 * together.
		 *  @type array
		 *  @default null
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.orderFixed
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "orderFixed": [[0,'asc']]
		 *      } );
		 *    } )
		 */
		"aaSortingFixed": [],
	
	
		/**
		 * DataTables can be instructed to load data to display in the table from a
		 * Ajax source. This option defines how that Ajax call is made and where to.
		 *
		 * The `ajax` property has three different modes of operation, depending on
		 * how it is defined. These are:
		 *
		 * * `string` - Set the URL from where the data should be loaded from.
		 * * `object` - Define properties for `jQuery.ajax`.
		 * * `function` - Custom data get function
		 *
		 * `string`
		 * --------
		 *
		 * As a string, the `ajax` property simply defines the URL from which
		 * DataTables will load data.
		 *
		 * `object`
		 * --------
		 *
		 * As an object, the parameters in the object are passed to
		 * [jQuery.ajax](http://api.jquery.com/jQuery.ajax/) allowing fine control
		 * of the Ajax request. DataTables has a number of default parameters which
		 * you can override using this option. Please refer to the jQuery
		 * documentation for a full description of the options available, although
		 * the following parameters provide additional options in DataTables or
		 * require special consideration:
		 *
		 * * `data` - As with jQuery, `data` can be provided as an object, but it
		 *   can also be used as a function to manipulate the data DataTables sends
		 *   to the server. The function takes a single parameter, an object of
		 *   parameters with the values that DataTables has readied for sending. An
		 *   object may be returned which will be merged into the DataTables
		 *   defaults, or you can add the items to the object that was passed in and
		 *   not return anything from the function. This supersedes `fnServerParams`
		 *   from DataTables 1.9-.
		 *
		 * * `dataSrc` - By default DataTables will look for the property `data` (or
		 *   `aaData` for compatibility with DataTables 1.9-) when obtaining data
		 *   from an Ajax source or for server-side processing - this parameter
		 *   allows that property to be changed. You can use Javascript dotted
		 *   object notation to get a data source for multiple levels of nesting, or
		 *   it my be used as a function. As a function it takes a single parameter,
		 *   the JSON returned from the server, which can be manipulated as
		 *   required, with the returned value being that used by DataTables as the
		 *   data source for the table. This supersedes `sAjaxDataProp` from
		 *   DataTables 1.9-.
		 *
		 * * `success` - Should not be overridden it is used internally in
		 *   DataTables. To manipulate / transform the data returned by the server
		 *   use `ajax.dataSrc`, or use `ajax` as a function (see below).
		 *
		 * `function`
		 * ----------
		 *
		 * As a function, making the Ajax call is left up to yourself allowing
		 * complete control of the Ajax request. Indeed, if desired, a method other
		 * than Ajax could be used to obtain the required data, such as Web storage
		 * or an AIR database.
		 *
		 * The function is given four parameters and no return is required. The
		 * parameters are:
		 *
		 * 1. _object_ - Data to send to the server
		 * 2. _function_ - Callback function that must be executed when the required
		 *    data has been obtained. That data should be passed into the callback
		 *    as the only parameter
		 * 3. _object_ - DataTables settings object for the table
		 *
		 * Note that this supersedes `fnServerData` from DataTables 1.9-.
		 *
		 *  @type string|object|function
		 *  @default null
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.ajax
		 *  @since 1.10.0
		 *
		 * @example
		 *   // Get JSON data from a file via Ajax.
		 *   // Note DataTables expects data in the form `{ data: [ ...data... ] }` by default).
		 *   $('#example').dataTable( {
		 *     "ajax": "data.json"
		 *   } );
		 *
		 * @example
		 *   // Get JSON data from a file via Ajax, using `dataSrc` to change
		 *   // `data` to `tableData` (i.e. `{ tableData: [ ...data... ] }`)
		 *   $('#example').dataTable( {
		 *     "ajax": {
		 *       "url": "data.json",
		 *       "dataSrc": "tableData"
		 *     }
		 *   } );
		 *
		 * @example
		 *   // Get JSON data from a file via Ajax, using `dataSrc` to read data
		 *   // from a plain array rather than an array in an object
		 *   $('#example').dataTable( {
		 *     "ajax": {
		 *       "url": "data.json",
		 *       "dataSrc": ""
		 *     }
		 *   } );
		 *
		 * @example
		 *   // Manipulate the data returned from the server - add a link to data
		 *   // (note this can, should, be done using `render` for the column - this
		 *   // is just a simple example of how the data can be manipulated).
		 *   $('#example').dataTable( {
		 *     "ajax": {
		 *       "url": "data.json",
		 *       "dataSrc": function ( json ) {
		 *         for ( var i=0, ien=json.length ; i<ien ; i++ ) {
		 *           json[i][0] = '<a href="/message/'+json[i][0]+'>View message</a>';
		 *         }
		 *         return json;
		 *       }
		 *     }
		 *   } );
		 *
		 * @example
		 *   // Add data to the request
		 *   $('#example').dataTable( {
		 *     "ajax": {
		 *       "url": "data.json",
		 *       "data": function ( d ) {
		 *         return {
		 *           "extra_search": $('#extra').val()
		 *         };
		 *       }
		 *     }
		 *   } );
		 *
		 * @example
		 *   // Send request as POST
		 *   $('#example').dataTable( {
		 *     "ajax": {
		 *       "url": "data.json",
		 *       "type": "POST"
		 *     }
		 *   } );
		 *
		 * @example
		 *   // Get the data from localStorage (could interface with a form for
		 *   // adding, editing and removing rows).
		 *   $('#example').dataTable( {
		 *     "ajax": function (data, callback, settings) {
		 *       callback(
		 *         JSON.parse( localStorage.getItem('dataTablesData') )
		 *       );
		 *     }
		 *   } );
		 */
		"ajax": null,
	
	
		/**
		 * This parameter allows you to readily specify the entries in the length drop
		 * down menu that DataTables shows when pagination is enabled. It can be
		 * either a 1D array of options which will be used for both the displayed
		 * option and the value, or a 2D array which will use the array in the first
		 * position as the value, and the array in the second position as the
		 * displayed options (useful for language strings such as 'All').
		 *
		 * Note that the `pageLength` property will be automatically set to the
		 * first value given in this array, unless `pageLength` is also provided.
		 *  @type array
		 *  @default [ 10, 25, 50, 100 ]
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.lengthMenu
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]]
		 *      } );
		 *    } );
		 */
		"aLengthMenu": [ 10, 25, 50, 100 ],
	
	
		/**
		 * The `columns` option in the initialisation parameter allows you to define
		 * details about the way individual columns behave. For a full list of
		 * column options that can be set, please see
		 * {@link DataTable.defaults.column}. Note that if you use `columns` to
		 * define your columns, you must have an entry in the array for every single
		 * column that you have in your table (these can be null if you don't which
		 * to specify any options).
		 *  @member
		 *
		 *  @name DataTable.defaults.column
		 */
		"aoColumns": null,
	
		/**
		 * Very similar to `columns`, `columnDefs` allows you to target a specific
		 * column, multiple columns, or all columns, using the `targets` property of
		 * each object in the array. This allows great flexibility when creating
		 * tables, as the `columnDefs` arrays can be of any length, targeting the
		 * columns you specifically want. `columnDefs` may use any of the column
		 * options available: {@link DataTable.defaults.column}, but it _must_
		 * have `targets` defined in each object in the array. Values in the `targets`
		 * array may be:
		 *   <ul>
		 *     <li>a string - class name will be matched on the TH for the column</li>
		 *     <li>0 or a positive integer - column index counting from the left</li>
		 *     <li>a negative integer - column index counting from the right</li>
		 *     <li>the string "_all" - all columns (i.e. assign a default)</li>
		 *   </ul>
		 *  @member
		 *
		 *  @name DataTable.defaults.columnDefs
		 */
		"aoColumnDefs": null,
	
	
		/**
		 * Basically the same as `search`, this parameter defines the individual column
		 * filtering state at initialisation time. The array must be of the same size
		 * as the number of columns, and each element be an object with the parameters
		 * `search` and `escapeRegex` (the latter is optional). 'null' is also
		 * accepted and the default will be used.
		 *  @type array
		 *  @default []
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.searchCols
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "searchCols": [
		 *          null,
		 *          { "search": "My filter" },
		 *          null,
		 *          { "search": "^[0-9]", "escapeRegex": false }
		 *        ]
		 *      } );
		 *    } )
		 */
		"aoSearchCols": [],
	
	
		/**
		 * An array of CSS classes that should be applied to displayed rows. This
		 * array may be of any length, and DataTables will apply each class
		 * sequentially, looping when required.
		 *  @type array
		 *  @default null <i>Will take the values determined by the `oClasses.stripe*`
		 *    options</i>
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.stripeClasses
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stripeClasses": [ 'strip1', 'strip2', 'strip3' ]
		 *      } );
		 *    } )
		 */
		"asStripeClasses": null,
	
	
		/**
		 * Enable or disable automatic column width calculation. This can be disabled
		 * as an optimisation (it takes some time to calculate the widths) if the
		 * tables widths are passed in using `columns`.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.autoWidth
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "autoWidth": false
		 *      } );
		 *    } );
		 */
		"bAutoWidth": true,
	
	
		/**
		 * Deferred rendering can provide DataTables with a huge speed boost when you
		 * are using an Ajax or JS data source for the table. This option, when set to
		 * true, will cause DataTables to defer the creation of the table elements for
		 * each row until they are needed for a draw - saving a significant amount of
		 * time.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.deferRender
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "ajax": "sources/arrays.txt",
		 *        "deferRender": true
		 *      } );
		 *    } );
		 */
		"bDeferRender": false,
	
	
		/**
		 * Replace a DataTable which matches the given selector and replace it with
		 * one which has the properties of the new initialisation object passed. If no
		 * table matches the selector, then the new DataTable will be constructed as
		 * per normal.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.destroy
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "srollY": "200px",
		 *        "paginate": false
		 *      } );
		 *
		 *      // Some time later....
		 *      $('#example').dataTable( {
		 *        "filter": false,
		 *        "destroy": true
		 *      } );
		 *    } );
		 */
		"bDestroy": false,
	
	
		/**
		 * Enable or disable filtering of data. Filtering in DataTables is "smart" in
		 * that it allows the end user to input multiple words (space separated) and
		 * will match a row containing those words, even if not in the order that was
		 * specified (this allow matching across multiple columns). Note that if you
		 * wish to use filtering in DataTables this must remain 'true' - to remove the
		 * default filtering input box and retain filtering abilities, please use
		 * {@link DataTable.defaults.dom}.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.searching
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "searching": false
		 *      } );
		 *    } );
		 */
		"bFilter": true,
	
	
		/**
		 * Enable or disable the table information display. This shows information
		 * about the data that is currently visible on the page, including information
		 * about filtered data if that action is being performed.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.info
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "info": false
		 *      } );
		 *    } );
		 */
		"bInfo": true,
	
	
		/**
		 * Enable jQuery UI ThemeRoller support (required as ThemeRoller requires some
		 * slightly different and additional mark-up from what DataTables has
		 * traditionally used).
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.jQueryUI
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "jQueryUI": true
		 *      } );
		 *    } );
		 */
		"bJQueryUI": false,
	
	
		/**
		 * Allows the end user to select the size of a formatted page from a select
		 * menu (sizes are 10, 25, 50 and 100). Requires pagination (`paginate`).
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.lengthChange
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "lengthChange": false
		 *      } );
		 *    } );
		 */
		"bLengthChange": true,
	
	
		/**
		 * Enable or disable pagination.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.paging
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "paging": false
		 *      } );
		 *    } );
		 */
		"bPaginate": true,
	
	
		/**
		 * Enable or disable the display of a 'processing' indicator when the table is
		 * being processed (e.g. a sort). This is particularly useful for tables with
		 * large amounts of data where it can take a noticeable amount of time to sort
		 * the entries.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.processing
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "processing": true
		 *      } );
		 *    } );
		 */
		"bProcessing": false,
	
	
		/**
		 * Retrieve the DataTables object for the given selector. Note that if the
		 * table has already been initialised, this parameter will cause DataTables
		 * to simply return the object that has already been set up - it will not take
		 * account of any changes you might have made to the initialisation object
		 * passed to DataTables (setting this parameter to true is an acknowledgement
		 * that you understand this). `destroy` can be used to reinitialise a table if
		 * you need.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.retrieve
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      initTable();
		 *      tableActions();
		 *    } );
		 *
		 *    function initTable ()
		 *    {
		 *      return $('#example').dataTable( {
		 *        "scrollY": "200px",
		 *        "paginate": false,
		 *        "retrieve": true
		 *      } );
		 *    }
		 *
		 *    function tableActions ()
		 *    {
		 *      var table = initTable();
		 *      // perform API operations with oTable
		 *    }
		 */
		"bRetrieve": false,
	
	
		/**
		 * When vertical (y) scrolling is enabled, DataTables will force the height of
		 * the table's viewport to the given height at all times (useful for layout).
		 * However, this can look odd when filtering data down to a small data set,
		 * and the footer is left "floating" further down. This parameter (when
		 * enabled) will cause DataTables to collapse the table's viewport down when
		 * the result set will fit within the given Y height.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.scrollCollapse
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "scrollY": "200",
		 *        "scrollCollapse": true
		 *      } );
		 *    } );
		 */
		"bScrollCollapse": false,
	
	
		/**
		 * Configure DataTables to use server-side processing. Note that the
		 * `ajax` parameter must also be given in order to give DataTables a
		 * source to obtain the required data for each draw.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Features
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.serverSide
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "serverSide": true,
		 *        "ajax": "xhr.php"
		 *      } );
		 *    } );
		 */
		"bServerSide": false,
	
	
		/**
		 * Enable or disable sorting of columns. Sorting of individual columns can be
		 * disabled by the `sortable` option for each column.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.ordering
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "ordering": false
		 *      } );
		 *    } );
		 */
		"bSort": true,
	
	
		/**
		 * Enable or display DataTables' ability to sort multiple columns at the
		 * same time (activated by shift-click by the user).
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.orderMulti
		 *
		 *  @example
		 *    // Disable multiple column sorting ability
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "orderMulti": false
		 *      } );
		 *    } );
		 */
		"bSortMulti": true,
	
	
		/**
		 * Allows control over whether DataTables should use the top (true) unique
		 * cell that is found for a single column, or the bottom (false - default).
		 * This is useful when using complex headers.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.orderCellsTop
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "orderCellsTop": true
		 *      } );
		 *    } );
		 */
		"bSortCellsTop": false,
	
	
		/**
		 * Enable or disable the addition of the classes `sorting\_1`, `sorting\_2` and
		 * `sorting\_3` to the columns which are currently being sorted on. This is
		 * presented as a feature switch as it can increase processing time (while
		 * classes are removed and added) so for large data sets you might want to
		 * turn this off.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.orderClasses
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "orderClasses": false
		 *      } );
		 *    } );
		 */
		"bSortClasses": true,
	
	
		/**
		 * Enable or disable state saving. When enabled HTML5 `localStorage` will be
		 * used to save table display information such as pagination information,
		 * display length, filtering and sorting. As such when the end user reloads
		 * the page the display display will match what thy had previously set up.
		 *
		 * Due to the use of `localStorage` the default state saving is not supported
		 * in IE6 or 7. If state saving is required in those browsers, use
		 * `stateSaveCallback` to provide a storage solution such as cookies.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.stateSave
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "stateSave": true
		 *      } );
		 *    } );
		 */
		"bStateSave": false,
	
	
		/**
		 * This function is called when a TR element is created (and all TD child
		 * elements have been inserted), or registered if using a DOM source, allowing
		 * manipulation of the TR element (adding classes etc).
		 *  @type function
		 *  @param {node} row "TR" element for the current row
		 *  @param {array} data Raw data array for this row
		 *  @param {int} dataIndex The index of this row in the internal aoData array
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.createdRow
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "createdRow": function( row, data, dataIndex ) {
		 *          // Bold the grade for all 'A' grade browsers
		 *          if ( data[4] == "A" )
		 *          {
		 *            $('td:eq(4)', row).html( '<b>A</b>' );
		 *          }
		 *        }
		 *      } );
		 *    } );
		 */
		"fnCreatedRow": null,
	
	
		/**
		 * This function is called on every 'draw' event, and allows you to
		 * dynamically modify any aspect you want about the created DOM.
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.drawCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "drawCallback": function( settings ) {
		 *          alert( 'DataTables has redrawn the table' );
		 *        }
		 *      } );
		 *    } );
		 */
		"fnDrawCallback": null,
	
	
		/**
		 * Identical to fnHeaderCallback() but for the table footer this function
		 * allows you to modify the table footer on every 'draw' event.
		 *  @type function
		 *  @param {node} foot "TR" element for the footer
		 *  @param {array} data Full table data (as derived from the original HTML)
		 *  @param {int} start Index for the current display starting point in the
		 *    display array
		 *  @param {int} end Index for the current display ending point in the
		 *    display array
		 *  @param {array int} display Index array to translate the visual position
		 *    to the full data array
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.footerCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "footerCallback": function( tfoot, data, start, end, display ) {
		 *          tfoot.getElementsByTagName('th')[0].innerHTML = "Starting index is "+start;
		 *        }
		 *      } );
		 *    } )
		 */
		"fnFooterCallback": null,
	
	
		/**
		 * When rendering large numbers in the information element for the table
		 * (i.e. "Showing 1 to 10 of 57 entries") DataTables will render large numbers
		 * to have a comma separator for the 'thousands' units (e.g. 1 million is
		 * rendered as "1,000,000") to help readability for the end user. This
		 * function will override the default method DataTables uses.
		 *  @type function
		 *  @member
		 *  @param {int} toFormat number to be formatted
		 *  @returns {string} formatted string for DataTables to show the number
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.formatNumber
		 *
		 *  @example
		 *    // Format a number using a single quote for the separator (note that
		 *    // this can also be done with the language.thousands option)
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "formatNumber": function ( toFormat ) {
		 *          return toFormat.toString().replace(
		 *            /\B(?=(\d{3})+(?!\d))/g, "'"
		 *          );
		 *        };
		 *      } );
		 *    } );
		 */
		"fnFormatNumber": function ( toFormat ) {
			return toFormat.toString().replace(
				/\B(?=(\d{3})+(?!\d))/g,
				this.oLanguage.sThousands
			);
		},
	
	
		/**
		 * This function is called on every 'draw' event, and allows you to
		 * dynamically modify the header row. This can be used to calculate and
		 * display useful information about the table.
		 *  @type function
		 *  @param {node} head "TR" element for the header
		 *  @param {array} data Full table data (as derived from the original HTML)
		 *  @param {int} start Index for the current display starting point in the
		 *    display array
		 *  @param {int} end Index for the current display ending point in the
		 *    display array
		 *  @param {array int} display Index array to translate the visual position
		 *    to the full data array
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.headerCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "fheaderCallback": function( head, data, start, end, display ) {
		 *          head.getElementsByTagName('th')[0].innerHTML = "Displaying "+(end-start)+" records";
		 *        }
		 *      } );
		 *    } )
		 */
		"fnHeaderCallback": null,
	
	
		/**
		 * The information element can be used to convey information about the current
		 * state of the table. Although the internationalisation options presented by
		 * DataTables are quite capable of dealing with most customisations, there may
		 * be times where you wish to customise the string further. This callback
		 * allows you to do exactly that.
		 *  @type function
		 *  @param {object} oSettings DataTables settings object
		 *  @param {int} start Starting position in data for the draw
		 *  @param {int} end End position in data for the draw
		 *  @param {int} max Total number of rows in the table (regardless of
		 *    filtering)
		 *  @param {int} total Total number of rows in the data set, after filtering
		 *  @param {string} pre The string that DataTables has formatted using it's
		 *    own rules
		 *  @returns {string} The string to be displayed in the information element.
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.infoCallback
		 *
		 *  @example
		 *    $('#example').dataTable( {
		 *      "infoCallback": function( settings, start, end, max, total, pre ) {
		 *        return start +" to "+ end;
		 *      }
		 *    } );
		 */
		"fnInfoCallback": null,
	
	
		/**
		 * Called when the table has been initialised. Normally DataTables will
		 * initialise sequentially and there will be no need for this function,
		 * however, this does not hold true when using external language information
		 * since that is obtained using an async XHR call.
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *  @param {object} json The JSON object request from the server - only
		 *    present if client-side Ajax sourced data is used
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.initComplete
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "initComplete": function(settings, json) {
		 *          alert( 'DataTables has finished its initialisation.' );
		 *        }
		 *      } );
		 *    } )
		 */
		"fnInitComplete": null,
	
	
		/**
		 * Called at the very start of each table draw and can be used to cancel the
		 * draw by returning false, any other return (including undefined) results in
		 * the full draw occurring).
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *  @returns {boolean} False will cancel the draw, anything else (including no
		 *    return) will allow it to complete.
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.preDrawCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "preDrawCallback": function( settings ) {
		 *          if ( $('#test').val() == 1 ) {
		 *            return false;
		 *          }
		 *        }
		 *      } );
		 *    } );
		 */
		"fnPreDrawCallback": null,
	
	
		/**
		 * This function allows you to 'post process' each row after it have been
		 * generated for each table draw, but before it is rendered on screen. This
		 * function might be used for setting the row class name etc.
		 *  @type function
		 *  @param {node} row "TR" element for the current row
		 *  @param {array} data Raw data array for this row
		 *  @param {int} displayIndex The display index for the current table draw
		 *  @param {int} displayIndexFull The index of the data in the full list of
		 *    rows (after filtering)
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.rowCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "rowCallback": function( row, data, displayIndex, displayIndexFull ) {
		 *          // Bold the grade for all 'A' grade browsers
		 *          if ( data[4] == "A" ) {
		 *            $('td:eq(4)', row).html( '<b>A</b>' );
		 *          }
		 *        }
		 *      } );
		 *    } );
		 */
		"fnRowCallback": null,
	
	
		/**
		 * __Deprecated__ The functionality provided by this parameter has now been
		 * superseded by that provided through `ajax`, which should be used instead.
		 *
		 * This parameter allows you to override the default function which obtains
		 * the data from the server so something more suitable for your application.
		 * For example you could use POST data, or pull information from a Gears or
		 * AIR database.
		 *  @type function
		 *  @member
		 *  @param {string} source HTTP source to obtain the data from (`ajax`)
		 *  @param {array} data A key/value pair object containing the data to send
		 *    to the server
		 *  @param {function} callback to be called on completion of the data get
		 *    process that will draw the data on the page.
		 *  @param {object} settings DataTables settings object
		 *
		 *  @dtopt Callbacks
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.serverData
		 *
		 *  @deprecated 1.10. Please use `ajax` for this functionality now.
		 */
		"fnServerData": null,
	
	
		/**
		 * __Deprecated__ The functionality provided by this parameter has now been
		 * superseded by that provided through `ajax`, which should be used instead.
		 *
		 *  It is often useful to send extra data to the server when making an Ajax
		 * request - for example custom filtering information, and this callback
		 * function makes it trivial to send extra information to the server. The
		 * passed in parameter is the data set that has been constructed by
		 * DataTables, and you can add to this or modify it as you require.
		 *  @type function
		 *  @param {array} data Data array (array of objects which are name/value
		 *    pairs) that has been constructed by DataTables and will be sent to the
		 *    server. In the case of Ajax sourced data with server-side processing
		 *    this will be an empty array, for server-side processing there will be a
		 *    significant number of parameters!
		 *  @returns {undefined} Ensure that you modify the data array passed in,
		 *    as this is passed by reference.
		 *
		 *  @dtopt Callbacks
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.serverParams
		 *
		 *  @deprecated 1.10. Please use `ajax` for this functionality now.
		 */
		"fnServerParams": null,
	
	
		/**
		 * Load the table state. With this function you can define from where, and how, the
		 * state of a table is loaded. By default DataTables will load from `localStorage`
		 * but you might wish to use a server-side database or cookies.
		 *  @type function
		 *  @member
		 *  @param {object} settings DataTables settings object
		 *  @param {object} callback Callback that can be executed when done. It
		 *    should be passed the loaded state object.
		 *  @return {object} The DataTables state object to be loaded
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.stateLoadCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateLoadCallback": function (settings, callback) {
		 *          $.ajax( {
		 *            "url": "/state_load",
		 *            "dataType": "json",
		 *            "success": function (json) {
		 *              callback( json );
		 *            }
		 *          } );
		 *        }
		 *      } );
		 *    } );
		 */
		"fnStateLoadCallback": function ( settings ) {
			try {
				return JSON.parse(
					(settings.iStateDuration === -1 ? sessionStorage : localStorage).getItem(
						'DataTables_'+settings.sInstance+'_'+location.pathname
					)
				);
			} catch (e) {}
		},
	
	
		/**
		 * Callback which allows modification of the saved state prior to loading that state.
		 * This callback is called when the table is loading state from the stored data, but
		 * prior to the settings object being modified by the saved state. Note that for
		 * plug-in authors, you should use the `stateLoadParams` event to load parameters for
		 * a plug-in.
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *  @param {object} data The state object that is to be loaded
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.stateLoadParams
		 *
		 *  @example
		 *    // Remove a saved filter, so filtering is never loaded
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateLoadParams": function (settings, data) {
		 *          data.oSearch.sSearch = "";
		 *        }
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Disallow state loading by returning false
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateLoadParams": function (settings, data) {
		 *          return false;
		 *        }
		 *      } );
		 *    } );
		 */
		"fnStateLoadParams": null,
	
	
		/**
		 * Callback that is called when the state has been loaded from the state saving method
		 * and the DataTables settings object has been modified as a result of the loaded state.
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *  @param {object} data The state object that was loaded
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.stateLoaded
		 *
		 *  @example
		 *    // Show an alert with the filtering value that was saved
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateLoaded": function (settings, data) {
		 *          alert( 'Saved filter was: '+data.oSearch.sSearch );
		 *        }
		 *      } );
		 *    } );
		 */
		"fnStateLoaded": null,
	
	
		/**
		 * Save the table state. This function allows you to define where and how the state
		 * information for the table is stored By default DataTables will use `localStorage`
		 * but you might wish to use a server-side database or cookies.
		 *  @type function
		 *  @member
		 *  @param {object} settings DataTables settings object
		 *  @param {object} data The state object to be saved
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.stateSaveCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateSaveCallback": function (settings, data) {
		 *          // Send an Ajax request to the server with the state object
		 *          $.ajax( {
		 *            "url": "/state_save",
		 *            "data": data,
		 *            "dataType": "json",
		 *            "method": "POST"
		 *            "success": function () {}
		 *          } );
		 *        }
		 *      } );
		 *    } );
		 */
		"fnStateSaveCallback": function ( settings, data ) {
			try {
				(settings.iStateDuration === -1 ? sessionStorage : localStorage).setItem(
					'DataTables_'+settings.sInstance+'_'+location.pathname,
					JSON.stringify( data )
				);
			} catch (e) {}
		},
	
	
		/**
		 * Callback which allows modification of the state to be saved. Called when the table
		 * has changed state a new state save is required. This method allows modification of
		 * the state saving object prior to actually doing the save, including addition or
		 * other state properties or modification. Note that for plug-in authors, you should
		 * use the `stateSaveParams` event to save parameters for a plug-in.
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *  @param {object} data The state object to be saved
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.stateSaveParams
		 *
		 *  @example
		 *    // Remove a saved filter, so filtering is never saved
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateSaveParams": function (settings, data) {
		 *          data.oSearch.sSearch = "";
		 *        }
		 *      } );
		 *    } );
		 */
		"fnStateSaveParams": null,
	
	
		/**
		 * Duration for which the saved state information is considered valid. After this period
		 * has elapsed the state will be returned to the default.
		 * Value is given in seconds.
		 *  @type int
		 *  @default 7200 <i>(2 hours)</i>
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.stateDuration
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateDuration": 60*60*24; // 1 day
		 *      } );
		 *    } )
		 */
		"iStateDuration": 7200,
	
	
		/**
		 * When enabled DataTables will not make a request to the server for the first
		 * page draw - rather it will use the data already on the page (no sorting etc
		 * will be applied to it), thus saving on an XHR at load time. `deferLoading`
		 * is used to indicate that deferred loading is required, but it is also used
		 * to tell DataTables how many records there are in the full table (allowing
		 * the information element and pagination to be displayed correctly). In the case
		 * where a filtering is applied to the table on initial load, this can be
		 * indicated by giving the parameter as an array, where the first element is
		 * the number of records available after filtering and the second element is the
		 * number of records without filtering (allowing the table information element
		 * to be shown correctly).
		 *  @type int | array
		 *  @default null
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.deferLoading
		 *
		 *  @example
		 *    // 57 records available in the table, no filtering applied
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "serverSide": true,
		 *        "ajax": "scripts/server_processing.php",
		 *        "deferLoading": 57
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // 57 records after filtering, 100 without filtering (an initial filter applied)
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "serverSide": true,
		 *        "ajax": "scripts/server_processing.php",
		 *        "deferLoading": [ 57, 100 ],
		 *        "search": {
		 *          "search": "my_filter"
		 *        }
		 *      } );
		 *    } );
		 */
		"iDeferLoading": null,
	
	
		/**
		 * Number of rows to display on a single page when using pagination. If
		 * feature enabled (`lengthChange`) then the end user will be able to override
		 * this to a custom setting using a pop-up menu.
		 *  @type int
		 *  @default 10
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.pageLength
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "pageLength": 50
		 *      } );
		 *    } )
		 */
		"iDisplayLength": 10,
	
	
		/**
		 * Define the starting point for data display when using DataTables with
		 * pagination. Note that this parameter is the number of records, rather than
		 * the page number, so if you have 10 records per page and want to start on
		 * the third page, it should be "20".
		 *  @type int
		 *  @default 0
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.displayStart
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "displayStart": 20
		 *      } );
		 *    } )
		 */
		"iDisplayStart": 0,
	
	
		/**
		 * By default DataTables allows keyboard navigation of the table (sorting, paging,
		 * and filtering) by adding a `tabindex` attribute to the required elements. This
		 * allows you to tab through the controls and press the enter key to activate them.
		 * The tabindex is default 0, meaning that the tab follows the flow of the document.
		 * You can overrule this using this parameter if you wish. Use a value of -1 to
		 * disable built-in keyboard navigation.
		 *  @type int
		 *  @default 0
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.tabIndex
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "tabIndex": 1
		 *      } );
		 *    } );
		 */
		"iTabIndex": 0,
	
	
		/**
		 * Classes that DataTables assigns to the various components and features
		 * that it adds to the HTML table. This allows classes to be configured
		 * during initialisation in addition to through the static
		 * {@link DataTable.ext.oStdClasses} object).
		 *  @namespace
		 *  @name DataTable.defaults.classes
		 */
		"oClasses": {},
	
	
		/**
		 * All strings that DataTables uses in the user interface that it creates
		 * are defined in this object, allowing you to modified them individually or
		 * completely replace them all as required.
		 *  @namespace
		 *  @name DataTable.defaults.language
		 */
		"oLanguage": {
			/**
			 * Strings that are used for WAI-ARIA labels and controls only (these are not
			 * actually visible on the page, but will be read by screenreaders, and thus
			 * must be internationalised as well).
			 *  @namespace
			 *  @name DataTable.defaults.language.aria
			 */
			"oAria": {
				/**
				 * ARIA label that is added to the table headers when the column may be
				 * sorted ascending by activing the column (click or return when focused).
				 * Note that the column header is prefixed to this string.
				 *  @type string
				 *  @default : activate to sort column ascending
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.aria.sortAscending
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "aria": {
				 *            "sortAscending": " - click/return to sort ascending"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */
				"sSortAscending": ": activate to sort column ascending",
	
				/**
				 * ARIA label that is added to the table headers when the column may be
				 * sorted descending by activing the column (click or return when focused).
				 * Note that the column header is prefixed to this string.
				 *  @type string
				 *  @default : activate to sort column ascending
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.aria.sortDescending
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "aria": {
				 *            "sortDescending": " - click/return to sort descending"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */
				"sSortDescending": ": activate to sort column descending"
			},
	
			/**
			 * Pagination string used by DataTables for the built-in pagination
			 * control types.
			 *  @namespace
			 *  @name DataTable.defaults.language.paginate
			 */
			"oPaginate": {
				/**
				 * Text to use when using the 'full_numbers' type of pagination for the
				 * button to take the user to the first page.
				 *  @type string
				 *  @default First
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.paginate.first
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "paginate": {
				 *            "first": "First page"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */
				"sFirst": "First",
	
	
				/**
				 * Text to use when using the 'full_numbers' type of pagination for the
				 * button to take the user to the last page.
				 *  @type string
				 *  @default Last
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.paginate.last
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "paginate": {
				 *            "last": "Last page"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */
				"sLast": "Last",
	
	
				/**
				 * Text to use for the 'next' pagination button (to take the user to the
				 * next page).
				 *  @type string
				 *  @default Next
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.paginate.next
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "paginate": {
				 *            "next": "Next page"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */
				"sNext": "Next",
	
	
				/**
				 * Text to use for the 'previous' pagination button (to take the user to
				 * the previous page).
				 *  @type string
				 *  @default Previous
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.paginate.previous
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "paginate": {
				 *            "previous": "Previous page"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */
				"sPrevious": "Previous"
			},
	
			/**
			 * This string is shown in preference to `zeroRecords` when the table is
			 * empty of data (regardless of filtering). Note that this is an optional
			 * parameter - if it is not given, the value of `zeroRecords` will be used
			 * instead (either the default or given value).
			 *  @type string
			 *  @default No data available in table
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.emptyTable
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "emptyTable": "No data available in table"
			 *        }
			 *      } );
			 *    } );
			 */
			"sEmptyTable": "No data available in table",
	
	
			/**
			 * This string gives information to the end user about the information
			 * that is current on display on the page. The following tokens can be
			 * used in the string and will be dynamically replaced as the table
			 * display updates. This tokens can be placed anywhere in the string, or
			 * removed as needed by the language requires:
			 *
			 * * `\_START\_` - Display index of the first record on the current page
			 * * `\_END\_` - Display index of the last record on the current page
			 * * `\_TOTAL\_` - Number of records in the table after filtering
			 * * `\_MAX\_` - Number of records in the table without filtering
			 * * `\_PAGE\_` - Current page number
			 * * `\_PAGES\_` - Total number of pages of data in the table
			 *
			 *  @type string
			 *  @default Showing _START_ to _END_ of _TOTAL_ entries
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.info
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "info": "Showing page _PAGE_ of _PAGES_"
			 *        }
			 *      } );
			 *    } );
			 */
			"sInfo": "Showing _START_ to _END_ of _TOTAL_ entries",
	
	
			/**
			 * Display information string for when the table is empty. Typically the
			 * format of this string should match `info`.
			 *  @type string
			 *  @default Showing 0 to 0 of 0 entries
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.infoEmpty
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "infoEmpty": "No entries to show"
			 *        }
			 *      } );
			 *    } );
			 */
			"sInfoEmpty": "Showing 0 to 0 of 0 entries",
	
	
			/**
			 * When a user filters the information in a table, this string is appended
			 * to the information (`info`) to give an idea of how strong the filtering
			 * is. The variable _MAX_ is dynamically updated.
			 *  @type string
			 *  @default (filtered from _MAX_ total entries)
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.infoFiltered
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "infoFiltered": " - filtering from _MAX_ records"
			 *        }
			 *      } );
			 *    } );
			 */
			"sInfoFiltered": "(filtered from _MAX_ total entries)",
	
	
			/**
			 * If can be useful to append extra information to the info string at times,
			 * and this variable does exactly that. This information will be appended to
			 * the `info` (`infoEmpty` and `infoFiltered` in whatever combination they are
			 * being used) at all times.
			 *  @type string
			 *  @default <i>Empty string</i>
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.infoPostFix
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "infoPostFix": "All records shown are derived from real information."
			 *        }
			 *      } );
			 *    } );
			 */
			"sInfoPostFix": "",
	
	
			/**
			 * This decimal place operator is a little different from the other
			 * language options since DataTables doesn't output floating point
			 * numbers, so it won't ever use this for display of a number. Rather,
			 * what this parameter does is modify the sort methods of the table so
			 * that numbers which are in a format which has a character other than
			 * a period (`.`) as a decimal place will be sorted numerically.
			 *
			 * Note that numbers with different decimal places cannot be shown in
			 * the same table and still be sortable, the table must be consistent.
			 * However, multiple different tables on the page can use different
			 * decimal place characters.
			 *  @type string
			 *  @default 
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.decimal
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "decimal": ","
			 *          "thousands": "."
			 *        }
			 *      } );
			 *    } );
			 */
			"sDecimal": "",
	
	
			/**
			 * DataTables has a build in number formatter (`formatNumber`) which is
			 * used to format large numbers that are used in the table information.
			 * By default a comma is used, but this can be trivially changed to any
			 * character you wish with this parameter.
			 *  @type string
			 *  @default ,
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.thousands
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "thousands": "'"
			 *        }
			 *      } );
			 *    } );
			 */
			"sThousands": ",",
	
	
			/**
			 * Detail the action that will be taken when the drop down menu for the
			 * pagination length option is changed. The '_MENU_' variable is replaced
			 * with a default select list of 10, 25, 50 and 100, and can be replaced
			 * with a custom select box if required.
			 *  @type string
			 *  @default Show _MENU_ entries
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.lengthMenu
			 *
			 *  @example
			 *    // Language change only
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "lengthMenu": "Display _MENU_ records"
			 *        }
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Language and options change
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "lengthMenu": 'Display <select>'+
			 *            '<option value="10">10</option>'+
			 *            '<option value="20">20</option>'+
			 *            '<option value="30">30</option>'+
			 *            '<option value="40">40</option>'+
			 *            '<option value="50">50</option>'+
			 *            '<option value="-1">All</option>'+
			 *            '</select> records'
			 *        }
			 *      } );
			 *    } );
			 */
			"sLengthMenu": "Show _MENU_ entries",
	
	
			/**
			 * When using Ajax sourced data and during the first draw when DataTables is
			 * gathering the data, this message is shown in an empty row in the table to
			 * indicate to the end user the the data is being loaded. Note that this
			 * parameter is not used when loading data by server-side processing, just
			 * Ajax sourced data with client-side processing.
			 *  @type string
			 *  @default Loading...
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.loadingRecords
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "loadingRecords": "Please wait - loading..."
			 *        }
			 *      } );
			 *    } );
			 */
			"sLoadingRecords": "Loading...",
	
	
			/**
			 * Text which is displayed when the table is processing a user action
			 * (usually a sort command or similar).
			 *  @type string
			 *  @default Processing...
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.processing
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "processing": "DataTables is currently busy"
			 *        }
			 *      } );
			 *    } );
			 */
			"sProcessing": "Processing...",
	
	
			/**
			 * Details the actions that will be taken when the user types into the
			 * filtering input text box. The variable "_INPUT_", if used in the string,
			 * is replaced with the HTML text box for the filtering input allowing
			 * control over where it appears in the string. If "_INPUT_" is not given
			 * then the input box is appended to the string automatically.
			 *  @type string
			 *  @default Search:
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.search
			 *
			 *  @example
			 *    // Input text box will be appended at the end automatically
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "search": "Filter records:"
			 *        }
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Specify where the filter should appear
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "search": "Apply filter _INPUT_ to table"
			 *        }
			 *      } );
			 *    } );
			 */
			"sSearch": "Search:",
	
	
			/**
			 * Assign a `placeholder` attribute to the search `input` element
			 *  @type string
			 *  @default 
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.searchPlaceholder
			 */
			"sSearchPlaceholder": "",
	
	
			/**
			 * All of the language information can be stored in a file on the
			 * server-side, which DataTables will look up if this parameter is passed.
			 * It must store the URL of the language file, which is in a JSON format,
			 * and the object has the same properties as the oLanguage object in the
			 * initialiser object (i.e. the above parameters). Please refer to one of
			 * the example language files to see how this works in action.
			 *  @type string
			 *  @default <i>Empty string - i.e. disabled</i>
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.url
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "url": "http://www.sprymedia.co.uk/dataTables/lang.txt"
			 *        }
			 *      } );
			 *    } );
			 */
			"sUrl": "",
	
	
			/**
			 * Text shown inside the table records when the is no information to be
			 * displayed after filtering. `emptyTable` is shown when there is simply no
			 * information in the table at all (regardless of filtering).
			 *  @type string
			 *  @default No matching records found
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.zeroRecords
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "zeroRecords": "No records to display"
			 *        }
			 *      } );
			 *    } );
			 */
			"sZeroRecords": "No matching records found"
		},
	
	
		/**
		 * This parameter allows you to have define the global filtering state at
		 * initialisation time. As an object the `search` parameter must be
		 * defined, but all other parameters are optional. When `regex` is true,
		 * the search string will be treated as a regular expression, when false
		 * (default) it will be treated as a straight string. When `smart`
		 * DataTables will use it's smart filtering methods (to word match at
		 * any point in the data), when false this will not be done.
		 *  @namespace
		 *  @extends DataTable.models.oSearch
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.search
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "search": {"search": "Initial search"}
		 *      } );
		 *    } )
		 */
		"oSearch": $.extend( {}, DataTable.models.oSearch ),
	
	
		/**
		 * __Deprecated__ The functionality provided by this parameter has now been
		 * superseded by that provided through `ajax`, which should be used instead.
		 *
		 * By default DataTables will look for the property `data` (or `aaData` for
		 * compatibility with DataTables 1.9-) when obtaining data from an Ajax
		 * source or for server-side processing - this parameter allows that
		 * property to be changed. You can use Javascript dotted object notation to
		 * get a data source for multiple levels of nesting.
		 *  @type string
		 *  @default data
		 *
		 *  @dtopt Options
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.ajaxDataProp
		 *
		 *  @deprecated 1.10. Please use `ajax` for this functionality now.
		 */
		"sAjaxDataProp": "data",
	
	
		/**
		 * __Deprecated__ The functionality provided by this parameter has now been
		 * superseded by that provided through `ajax`, which should be used instead.
		 *
		 * You can instruct DataTables to load data from an external
		 * source using this parameter (use aData if you want to pass data in you
		 * already have). Simply provide a url a JSON object can be obtained from.
		 *  @type string
		 *  @default null
		 *
		 *  @dtopt Options
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.ajaxSource
		 *
		 *  @deprecated 1.10. Please use `ajax` for this functionality now.
		 */
		"sAjaxSource": null,
	
	
		/**
		 * This initialisation variable allows you to specify exactly where in the
		 * DOM you want DataTables to inject the various controls it adds to the page
		 * (for example you might want the pagination controls at the top of the
		 * table). DIV elements (with or without a custom class) can also be added to
		 * aid styling. The follow syntax is used:
		 *   <ul>
		 *     <li>The following options are allowed:
		 *       <ul>
		 *         <li>'l' - Length changing</li>
		 *         <li>'f' - Filtering input</li>
		 *         <li>'t' - The table!</li>
		 *         <li>'i' - Information</li>
		 *         <li>'p' - Pagination</li>
		 *         <li>'r' - pRocessing</li>
		 *       </ul>
		 *     </li>
		 *     <li>The following constants are allowed:
		 *       <ul>
		 *         <li>'H' - jQueryUI theme "header" classes ('fg-toolbar ui-widget-header ui-corner-tl ui-corner-tr ui-helper-clearfix')</li>
		 *         <li>'F' - jQueryUI theme "footer" classes ('fg-toolbar ui-widget-header ui-corner-bl ui-corner-br ui-helper-clearfix')</li>
		 *       </ul>
		 *     </li>
		 *     <li>The following syntax is expected:
		 *       <ul>
		 *         <li>'&lt;' and '&gt;' - div elements</li>
		 *         <li>'&lt;"class" and '&gt;' - div with a class</li>
		 *         <li>'&lt;"#id" and '&gt;' - div with an ID</li>
		 *       </ul>
		 *     </li>
		 *     <li>Examples:
		 *       <ul>
		 *         <li>'&lt;"wrapper"flipt&gt;'</li>
		 *         <li>'&lt;lf&lt;t&gt;ip&gt;'</li>
		 *       </ul>
		 *     </li>
		 *   </ul>
		 *  @type string
		 *  @default lfrtip <i>(when `jQueryUI` is false)</i> <b>or</b>
		 *    <"H"lfr>t<"F"ip> <i>(when `jQueryUI` is true)</i>
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.dom
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "dom": '&lt;"top"i&gt;rt&lt;"bottom"flp&gt;&lt;"clear"&gt;'
		 *      } );
		 *    } );
		 */
		"sDom": "lfrtip",
	
	
		/**
		 * Search delay option. This will throttle full table searches that use the
		 * DataTables provided search input element (it does not effect calls to
		 * `dt-api search()`, providing a delay before the search is made.
		 *  @type integer
		 *  @default 0
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.searchDelay
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "searchDelay": 200
		 *      } );
		 *    } )
		 */
		"searchDelay": null,
	
	
		/**
		 * DataTables features six different built-in options for the buttons to
		 * display for pagination control:
		 *
		 * * `numbers` - Page number buttons only
		 * * `simple` - 'Previous' and 'Next' buttons only
		 * * 'simple_numbers` - 'Previous' and 'Next' buttons, plus page numbers
		 * * `full` - 'First', 'Previous', 'Next' and 'Last' buttons
		 * * `full_numbers` - 'First', 'Previous', 'Next' and 'Last' buttons, plus page numbers
		 * * `first_last_numbers` - 'First' and 'Last' buttons, plus page numbers
		 *  
		 * Further methods can be added using {@link DataTable.ext.oPagination}.
		 *  @type string
		 *  @default simple_numbers
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.pagingType
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "pagingType": "full_numbers"
		 *      } );
		 *    } )
		 */
		"sPaginationType": "simple_numbers",
	
	
		/**
		 * Enable horizontal scrolling. When a table is too wide to fit into a
		 * certain layout, or you have a large number of columns in the table, you
		 * can enable x-scrolling to show the table in a viewport, which can be
		 * scrolled. This property can be `true` which will allow the table to
		 * scroll horizontally when needed, or any CSS unit, or a number (in which
		 * case it will be treated as a pixel measurement). Setting as simply `true`
		 * is recommended.
		 *  @type boolean|string
		 *  @default <i>blank string - i.e. disabled</i>
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.scrollX
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "scrollX": true,
		 *        "scrollCollapse": true
		 *      } );
		 *    } );
		 */
		"sScrollX": "",
	
	
		/**
		 * This property can be used to force a DataTable to use more width than it
		 * might otherwise do when x-scrolling is enabled. For example if you have a
		 * table which requires to be well spaced, this parameter is useful for
		 * "over-sizing" the table, and thus forcing scrolling. This property can by
		 * any CSS unit, or a number (in which case it will be treated as a pixel
		 * measurement).
		 *  @type string
		 *  @default <i>blank string - i.e. disabled</i>
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.scrollXInner
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "scrollX": "100%",
		 *        "scrollXInner": "110%"
		 *      } );
		 *    } );
		 */
		"sScrollXInner": "",
	
	
		/**
		 * Enable vertical scrolling. Vertical scrolling will constrain the DataTable
		 * to the given height, and enable scrolling for any data which overflows the
		 * current viewport. This can be used as an alternative to paging to display
		 * a lot of data in a small area (although paging and scrolling can both be
		 * enabled at the same time). This property can be any CSS unit, or a number
		 * (in which case it will be treated as a pixel measurement).
		 *  @type string
		 *  @default <i>blank string - i.e. disabled</i>
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.scrollY
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "scrollY": "200px",
		 *        "paginate": false
		 *      } );
		 *    } );
		 */
		"sScrollY": "",
	
	
		/**
		 * __Deprecated__ The functionality provided by this parameter has now been
		 * superseded by that provided through `ajax`, which should be used instead.
		 *
		 * Set the HTTP method that is used to make the Ajax call for server-side
		 * processing or Ajax sourced data.
		 *  @type string
		 *  @default GET
		 *
		 *  @dtopt Options
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.serverMethod
		 *
		 *  @deprecated 1.10. Please use `ajax` for this functionality now.
		 */
		"sServerMethod": "GET",
	
	
		/**
		 * DataTables makes use of renderers when displaying HTML elements for
		 * a table. These renderers can be added or modified by plug-ins to
		 * generate suitable mark-up for a site. For example the Bootstrap
		 * integration plug-in for DataTables uses a paging button renderer to
		 * display pagination buttons in the mark-up required by Bootstrap.
		 *
		 * For further information about the renderers available see
		 * DataTable.ext.renderer
		 *  @type string|object
		 *  @default null
		 *
		 *  @name DataTable.defaults.renderer
		 *
		 */
		"renderer": null,
	
	
		/**
		 * Set the data property name that DataTables should use to get a row's id
		 * to set as the `id` property in the node.
		 *  @type string
		 *  @default DT_RowId
		 *
		 *  @name DataTable.defaults.rowId
		 */
		"rowId": "DT_RowId"
	};
	
	_fnHungarianMap( DataTable.defaults );
	
	
	
	/*
	 * Developer note - See note in model.defaults.js about the use of Hungarian
	 * notation and camel case.
	 */
	
	/**
	 * Column options that can be given to DataTables at initialisation time.
	 *  @namespace
	 */
	DataTable.defaults.column = {
		/**
		 * Define which column(s) an order will occur on for this column. This
		 * allows a column's ordering to take multiple columns into account when
		 * doing a sort or use the data from a different column. For example first
		 * name / last name columns make sense to do a multi-column sort over the
		 * two columns.
		 *  @type array|int
		 *  @default null <i>Takes the value of the column index automatically</i>
		 *
		 *  @name DataTable.defaults.column.orderData
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "orderData": [ 0, 1 ], "targets": [ 0 ] },
		 *          { "orderData": [ 1, 0 ], "targets": [ 1 ] },
		 *          { "orderData": 2, "targets": [ 2 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "orderData": [ 0, 1 ] },
		 *          { "orderData": [ 1, 0 ] },
		 *          { "orderData": 2 },
		 *          null,
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */
		"aDataSort": null,
		"iDataSort": -1,
	
	
		/**
		 * You can control the default ordering direction, and even alter the
		 * behaviour of the sort handler (i.e. only allow ascending ordering etc)
		 * using this parameter.
		 *  @type array
		 *  @default [ 'asc', 'desc' ]
		 *
		 *  @name DataTable.defaults.column.orderSequence
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "orderSequence": [ "asc" ], "targets": [ 1 ] },
		 *          { "orderSequence": [ "desc", "asc", "asc" ], "targets": [ 2 ] },
		 *          { "orderSequence": [ "desc" ], "targets": [ 3 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          null,
		 *          { "orderSequence": [ "asc" ] },
		 *          { "orderSequence": [ "desc", "asc", "asc" ] },
		 *          { "orderSequence": [ "desc" ] },
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */
		"asSorting": [ 'asc', 'desc' ],
	
	
		/**
		 * Enable or disable filtering on the data in this column.
		 *  @type boolean
		 *  @default true
		 *
		 *  @name DataTable.defaults.column.searchable
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "searchable": false, "targets": [ 0 ] }
		 *        ] } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "searchable": false },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ] } );
		 *    } );
		 */
		"bSearchable": true,
	
	
		/**
		 * Enable or disable ordering on this column.
		 *  @type boolean
		 *  @default true
		 *
		 *  @name DataTable.defaults.column.orderable
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "orderable": false, "targets": [ 0 ] }
		 *        ] } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "orderable": false },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ] } );
		 *    } );
		 */
		"bSortable": true,
	
	
		/**
		 * Enable or disable the display of this column.
		 *  @type boolean
		 *  @default true
		 *
		 *  @name DataTable.defaults.column.visible
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "visible": false, "targets": [ 0 ] }
		 *        ] } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "visible": false },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ] } );
		 *    } );
		 */
		"bVisible": true,
	
	
		/**
		 * Developer definable function that is called whenever a cell is created (Ajax source,
		 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
		 * allowing you to modify the DOM element (add background colour for example) when the
		 * element is available.
		 *  @type function
		 *  @param {element} td The TD node that has been created
		 *  @param {*} cellData The Data for the cell
		 *  @param {array|object} rowData The data for the whole row
		 *  @param {int} row The row index for the aoData data store
		 *  @param {int} col The column index for aoColumns
		 *
		 *  @name DataTable.defaults.column.createdCell
		 *  @dtopt Columns
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [3],
		 *          "createdCell": function (td, cellData, rowData, row, col) {
		 *            if ( cellData == "1.7" ) {
		 *              $(td).css('color', 'blue')
		 *            }
		 *          }
		 *        } ]
		 *      });
		 *    } );
		 */
		"fnCreatedCell": null,
	
	
		/**
		 * This parameter has been replaced by `data` in DataTables to ensure naming
		 * consistency. `dataProp` can still be used, as there is backwards
		 * compatibility in DataTables for this option, but it is strongly
		 * recommended that you use `data` in preference to `dataProp`.
		 *  @name DataTable.defaults.column.dataProp
		 */
	
	
		/**
		 * This property can be used to read data from any data source property,
		 * including deeply nested objects / properties. `data` can be given in a
		 * number of different ways which effect its behaviour:
		 *
		 * * `integer` - treated as an array index for the data source. This is the
		 *   default that DataTables uses (incrementally increased for each column).
		 * * `string` - read an object property from the data source. There are
		 *   three 'special' options that can be used in the string to alter how
		 *   DataTables reads the data from the source object:
		 *    * `.` - Dotted Javascript notation. Just as you use a `.` in
		 *      Javascript to read from nested objects, so to can the options
		 *      specified in `data`. For example: `browser.version` or
		 *      `browser.name`. If your object parameter name contains a period, use
		 *      `\\` to escape it - i.e. `first\\.name`.
		 *    * `[]` - Array notation. DataTables can automatically combine data
		 *      from and array source, joining the data with the characters provided
		 *      between the two brackets. For example: `name[, ]` would provide a
		 *      comma-space separated list from the source array. If no characters
		 *      are provided between the brackets, the original array source is
		 *      returned.
		 *    * `()` - Function notation. Adding `()` to the end of a parameter will
		 *      execute a function of the name given. For example: `browser()` for a
		 *      simple function on the data source, `browser.version()` for a
		 *      function in a nested property or even `browser().version` to get an
		 *      object property if the function called returns an object. Note that
		 *      function notation is recommended for use in `render` rather than
		 *      `data` as it is much simpler to use as a renderer.
		 * * `null` - use the original data source for the row rather than plucking
		 *   data directly from it. This action has effects on two other
		 *   initialisation options:
		 *    * `defaultContent` - When null is given as the `data` option and
		 *      `defaultContent` is specified for the column, the value defined by
		 *      `defaultContent` will be used for the cell.
		 *    * `render` - When null is used for the `data` option and the `render`
		 *      option is specified for the column, the whole data source for the
		 *      row is used for the renderer.
		 * * `function` - the function given will be executed whenever DataTables
		 *   needs to set or get the data for a cell in the column. The function
		 *   takes three parameters:
		 *    * Parameters:
		 *      * `{array|object}` The data source for the row
		 *      * `{string}` The type call data requested - this will be 'set' when
		 *        setting data or 'filter', 'display', 'type', 'sort' or undefined
		 *        when gathering data. Note that when `undefined` is given for the
		 *        type DataTables expects to get the raw data for the object back<
		 *      * `{*}` Data to set when the second parameter is 'set'.
		 *    * Return:
		 *      * The return value from the function is not required when 'set' is
		 *        the type of call, but otherwise the return is what will be used
		 *        for the data requested.
		 *
		 * Note that `data` is a getter and setter option. If you just require
		 * formatting of data for output, you will likely want to use `render` which
		 * is simply a getter and thus simpler to use.
		 *
		 * Note that prior to DataTables 1.9.2 `data` was called `mDataProp`. The
		 * name change reflects the flexibility of this property and is consistent
		 * with the naming of mRender. If 'mDataProp' is given, then it will still
		 * be used by DataTables, as it automatically maps the old name to the new
		 * if required.
		 *
		 *  @type string|int|function|null
		 *  @default null <i>Use automatically calculated column index</i>
		 *
		 *  @name DataTable.defaults.column.data
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Read table data from objects
		 *    // JSON structure for each row:
		 *    //   {
		 *    //      "engine": {value},
		 *    //      "browser": {value},
		 *    //      "platform": {value},
		 *    //      "version": {value},
		 *    //      "grade": {value}
		 *    //   }
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "ajaxSource": "sources/objects.txt",
		 *        "columns": [
		 *          { "data": "engine" },
		 *          { "data": "browser" },
		 *          { "data": "platform" },
		 *          { "data": "version" },
		 *          { "data": "grade" }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Read information from deeply nested objects
		 *    // JSON structure for each row:
		 *    //   {
		 *    //      "engine": {value},
		 *    //      "browser": {value},
		 *    //      "platform": {
		 *    //         "inner": {value}
		 *    //      },
		 *    //      "details": [
		 *    //         {value}, {value}
		 *    //      ]
		 *    //   }
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "ajaxSource": "sources/deep.txt",
		 *        "columns": [
		 *          { "data": "engine" },
		 *          { "data": "browser" },
		 *          { "data": "platform.inner" },
		 *          { "data": "platform.details.0" },
		 *          { "data": "platform.details.1" }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `data` as a function to provide different information for
		 *    // sorting, filtering and display. In this case, currency (price)
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": function ( source, type, val ) {
		 *            if (type === 'set') {
		 *              source.price = val;
		 *              // Store the computed dislay and filter values for efficiency
		 *              source.price_display = val=="" ? "" : "$"+numberFormat(val);
		 *              source.price_filter  = val=="" ? "" : "$"+numberFormat(val)+" "+val;
		 *              return;
		 *            }
		 *            else if (type === 'display') {
		 *              return source.price_display;
		 *            }
		 *            else if (type === 'filter') {
		 *              return source.price_filter;
		 *            }
		 *            // 'sort', 'type' and undefined all just use the integer
		 *            return source.price;
		 *          }
		 *        } ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using default content
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": null,
		 *          "defaultContent": "Click to edit"
		 *        } ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using array notation - outputting a list from an array
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": "name[, ]"
		 *        } ]
		 *      } );
		 *    } );
		 *
		 */
		"mData": null,
	
	
		/**
		 * This property is the rendering partner to `data` and it is suggested that
		 * when you want to manipulate data for display (including filtering,
		 * sorting etc) without altering the underlying data for the table, use this
		 * property. `render` can be considered to be the the read only companion to
		 * `data` which is read / write (then as such more complex). Like `data`
		 * this option can be given in a number of different ways to effect its
		 * behaviour:
		 *
		 * * `integer` - treated as an array index for the data source. This is the
		 *   default that DataTables uses (incrementally increased for each column).
		 * * `string` - read an object property from the data source. There are
		 *   three 'special' options that can be used in the string to alter how
		 *   DataTables reads the data from the source object:
		 *    * `.` - Dotted Javascript notation. Just as you use a `.` in
		 *      Javascript to read from nested objects, so to can the options
		 *      specified in `data`. For example: `browser.version` or
		 *      `browser.name`. If your object parameter name contains a period, use
		 *      `\\` to escape it - i.e. `first\\.name`.
		 *    * `[]` - Array notation. DataTables can automatically combine data
		 *      from and array source, joining the data with the characters provided
		 *      between the two brackets. For example: `name[, ]` would provide a
		 *      comma-space separated list from the source array. If no characters
		 *      are provided between the brackets, the original array source is
		 *      returned.
		 *    * `()` - Function notation. Adding `()` to the end of a parameter will
		 *      execute a function of the name given. For example: `browser()` for a
		 *      simple function on the data source, `browser.version()` for a
		 *      function in a nested property or even `browser().version` to get an
		 *      object property if the function called returns an object.
		 * * `object` - use different data for the different data types requested by
		 *   DataTables ('filter', 'display', 'type' or 'sort'). The property names
		 *   of the object is the data type the property refers to and the value can
		 *   defined using an integer, string or function using the same rules as
		 *   `render` normally does. Note that an `_` option _must_ be specified.
		 *   This is the default value to use if you haven't specified a value for
		 *   the data type requested by DataTables.
		 * * `function` - the function given will be executed whenever DataTables
		 *   needs to set or get the data for a cell in the column. The function
		 *   takes three parameters:
		 *    * Parameters:
		 *      * {array|object} The data source for the row (based on `data`)
		 *      * {string} The type call data requested - this will be 'filter',
		 *        'display', 'type' or 'sort'.
		 *      * {array|object} The full data source for the row (not based on
		 *        `data`)
		 *    * Return:
		 *      * The return value from the function is what will be used for the
		 *        data requested.
		 *
		 *  @type string|int|function|object|null
		 *  @default null Use the data source value.
		 *
		 *  @name DataTable.defaults.column.render
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Create a comma separated list from an array of objects
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "ajaxSource": "sources/deep.txt",
		 *        "columns": [
		 *          { "data": "engine" },
		 *          { "data": "browser" },
		 *          {
		 *            "data": "platform",
		 *            "render": "[, ].name"
		 *          }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Execute a function to obtain data
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": null, // Use the full data source object for the renderer's source
		 *          "render": "browserName()"
		 *        } ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // As an object, extracting different data for the different types
		 *    // This would be used with a data source such as:
		 *    //   { "phone": 5552368, "phone_filter": "5552368 555-2368", "phone_display": "555-2368" }
		 *    // Here the `phone` integer is used for sorting and type detection, while `phone_filter`
		 *    // (which has both forms) is used for filtering for if a user inputs either format, while
		 *    // the formatted phone number is the one that is shown in the table.
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": null, // Use the full data source object for the renderer's source
		 *          "render": {
		 *            "_": "phone",
		 *            "filter": "phone_filter",
		 *            "display": "phone_display"
		 *          }
		 *        } ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Use as a function to create a link from the data source
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": "download_link",
		 *          "render": function ( data, type, full ) {
		 *            return '<a href="'+data+'">Download</a>';
		 *          }
		 *        } ]
		 *      } );
		 *    } );
		 */
		"mRender": null,
	
	
		/**
		 * Change the cell type created for the column - either TD cells or TH cells. This
		 * can be useful as TH cells have semantic meaning in the table body, allowing them
		 * to act as a header for a row (you may wish to add scope='row' to the TH elements).
		 *  @type string
		 *  @default td
		 *
		 *  @name DataTable.defaults.column.cellType
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Make the first column use TH cells
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "cellType": "th"
		 *        } ]
		 *      } );
		 *    } );
		 */
		"sCellType": "td",
	
	
		/**
		 * Class to give to each cell in this column.
		 *  @type string
		 *  @default <i>Empty string</i>
		 *
		 *  @name DataTable.defaults.column.class
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "class": "my_class", "targets": [ 0 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "class": "my_class" },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */
		"sClass": "",
	
		/**
		 * When DataTables calculates the column widths to assign to each column,
		 * it finds the longest string in each column and then constructs a
		 * temporary table and reads the widths from that. The problem with this
		 * is that "mmm" is much wider then "iiii", but the latter is a longer
		 * string - thus the calculation can go wrong (doing it properly and putting
		 * it into an DOM object and measuring that is horribly(!) slow). Thus as
		 * a "work around" we provide this option. It will append its value to the
		 * text that is found to be the longest string for the column - i.e. padding.
		 * Generally you shouldn't need this!
		 *  @type string
		 *  @default <i>Empty string<i>
		 *
		 *  @name DataTable.defaults.column.contentPadding
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          null,
		 *          null,
		 *          null,
		 *          {
		 *            "contentPadding": "mmm"
		 *          }
		 *        ]
		 *      } );
		 *    } );
		 */
		"sContentPadding": "",
	
	
		/**
		 * Allows a default value to be given for a column's data, and will be used
		 * whenever a null data source is encountered (this can be because `data`
		 * is set to null, or because the data source itself is null).
		 *  @type string
		 *  @default null
		 *
		 *  @name DataTable.defaults.column.defaultContent
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          {
		 *            "data": null,
		 *            "defaultContent": "Edit",
		 *            "targets": [ -1 ]
		 *          }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          null,
		 *          null,
		 *          null,
		 *          {
		 *            "data": null,
		 *            "defaultContent": "Edit"
		 *          }
		 *        ]
		 *      } );
		 *    } );
		 */
		"sDefaultContent": null,
	
	
		/**
		 * This parameter is only used in DataTables' server-side processing. It can
		 * be exceptionally useful to know what columns are being displayed on the
		 * client side, and to map these to database fields. When defined, the names
		 * also allow DataTables to reorder information from the server if it comes
		 * back in an unexpected order (i.e. if you switch your columns around on the
		 * client-side, your server-side code does not also need updating).
		 *  @type string
		 *  @default <i>Empty string</i>
		 *
		 *  @name DataTable.defaults.column.name
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "name": "engine", "targets": [ 0 ] },
		 *          { "name": "browser", "targets": [ 1 ] },
		 *          { "name": "platform", "targets": [ 2 ] },
		 *          { "name": "version", "targets": [ 3 ] },
		 *          { "name": "grade", "targets": [ 4 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "name": "engine" },
		 *          { "name": "browser" },
		 *          { "name": "platform" },
		 *          { "name": "version" },
		 *          { "name": "grade" }
		 *        ]
		 *      } );
		 *    } );
		 */
		"sName": "",
	
	
		/**
		 * Defines a data source type for the ordering which can be used to read
		 * real-time information from the table (updating the internally cached
		 * version) prior to ordering. This allows ordering to occur on user
		 * editable elements such as form inputs.
		 *  @type string
		 *  @default std
		 *
		 *  @name DataTable.defaults.column.orderDataType
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "orderDataType": "dom-text", "targets": [ 2, 3 ] },
		 *          { "type": "numeric", "targets": [ 3 ] },
		 *          { "orderDataType": "dom-select", "targets": [ 4 ] },
		 *          { "orderDataType": "dom-checkbox", "targets": [ 5 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          null,
		 *          null,
		 *          { "orderDataType": "dom-text" },
		 *          { "orderDataType": "dom-text", "type": "numeric" },
		 *          { "orderDataType": "dom-select" },
		 *          { "orderDataType": "dom-checkbox" }
		 *        ]
		 *      } );
		 *    } );
		 */
		"sSortDataType": "std",
	
	
		/**
		 * The title of this column.
		 *  @type string
		 *  @default null <i>Derived from the 'TH' value for this column in the
		 *    original HTML table.</i>
		 *
		 *  @name DataTable.defaults.column.title
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "title": "My column title", "targets": [ 0 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "title": "My column title" },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */
		"sTitle": null,
	
	
		/**
		 * The type allows you to specify how the data for this column will be
		 * ordered. Four types (string, numeric, date and html (which will strip
		 * HTML tags before ordering)) are currently available. Note that only date
		 * formats understood by Javascript's Date() object will be accepted as type
		 * date. For example: "Mar 26, 2008 5:03 PM". May take the values: 'string',
		 * 'numeric', 'date' or 'html' (by default). Further types can be adding
		 * through plug-ins.
		 *  @type string
		 *  @default null <i>Auto-detected from raw data</i>
		 *
		 *  @name DataTable.defaults.column.type
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "type": "html", "targets": [ 0 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "type": "html" },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */
		"sType": null,
	
	
		/**
		 * Defining the width of the column, this parameter may take any CSS value
		 * (3em, 20px etc). DataTables applies 'smart' widths to columns which have not
		 * been given a specific width through this interface ensuring that the table
		 * remains readable.
		 *  @type string
		 *  @default null <i>Automatic</i>
		 *
		 *  @name DataTable.defaults.column.width
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "width": "20%", "targets": [ 0 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "width": "20%" },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */
		"sWidth": null
	};
	
	_fnHungarianMap( DataTable.defaults.column );
	
	
	
	/**
	 * DataTables settings object - this holds all the information needed for a
	 * given table, including configuration, data and current application of the
	 * table options. DataTables does not have a single instance for each DataTable
	 * with the settings attached to that instance, but rather instances of the
	 * DataTable "class" are created on-the-fly as needed (typically by a
	 * $().dataTable() call) and the settings object is then applied to that
	 * instance.
	 *
	 * Note that this object is related to {@link DataTable.defaults} but this
	 * one is the internal data store for DataTables's cache of columns. It should
	 * NOT be manipulated outside of DataTables. Any configuration should be done
	 * through the initialisation options.
	 *  @namespace
	 *  @todo Really should attach the settings object to individual instances so we
	 *    don't need to create new instances on each $().dataTable() call (if the
	 *    table already exists). It would also save passing oSettings around and
	 *    into every single function. However, this is a very significant
	 *    architecture change for DataTables and will almost certainly break
	 *    backwards compatibility with older installations. This is something that
	 *    will be done in 2.0.
	 */
	DataTable.models.oSettings = {
		/**
		 * Primary features of DataTables and their enablement state.
		 *  @namespace
		 */
		"oFeatures": {
	
			/**
			 * Flag to say if DataTables should automatically try to calculate the
			 * optimum table and columns widths (true) or not (false).
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bAutoWidth": null,
	
			/**
			 * Delay the creation of TR and TD elements until they are actually
			 * needed by a driven page draw. This can give a significant speed
			 * increase for Ajax source and Javascript source data, but makes no
			 * difference at all fro DOM and server-side processing tables.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bDeferRender": null,
	
			/**
			 * Enable filtering on the table or not. Note that if this is disabled
			 * then there is no filtering at all on the table, including fnFilter.
			 * To just remove the filtering input use sDom and remove the 'f' option.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bFilter": null,
	
			/**
			 * Table information element (the 'Showing x of y records' div) enable
			 * flag.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bInfo": null,
	
			/**
			 * Present a user control allowing the end user to change the page size
			 * when pagination is enabled.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bLengthChange": null,
	
			/**
			 * Pagination enabled or not. Note that if this is disabled then length
			 * changing must also be disabled.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bPaginate": null,
	
			/**
			 * Processing indicator enable flag whenever DataTables is enacting a
			 * user request - typically an Ajax request for server-side processing.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bProcessing": null,
	
			/**
			 * Server-side processing enabled flag - when enabled DataTables will
			 * get all data from the server for every draw - there is no filtering,
			 * sorting or paging done on the client-side.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bServerSide": null,
	
			/**
			 * Sorting enablement flag.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bSort": null,
	
			/**
			 * Multi-column sorting
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bSortMulti": null,
	
			/**
			 * Apply a class to the columns which are being sorted to provide a
			 * visual highlight or not. This can slow things down when enabled since
			 * there is a lot of DOM interaction.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bSortClasses": null,
	
			/**
			 * State saving enablement flag.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bStateSave": null
		},
	
	
		/**
		 * Scrolling settings for a table.
		 *  @namespace
		 */
		"oScroll": {
			/**
			 * When the table is shorter in height than sScrollY, collapse the
			 * table container down to the height of the table (when true).
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bCollapse": null,
	
			/**
			 * Width of the scrollbar for the web-browser's platform. Calculated
			 * during table initialisation.
			 *  @type int
			 *  @default 0
			 */
			"iBarWidth": 0,
	
			/**
			 * Viewport width for horizontal scrolling. Horizontal scrolling is
			 * disabled if an empty string.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type string
			 */
			"sX": null,
	
			/**
			 * Width to expand the table to when using x-scrolling. Typically you
			 * should not need to use this.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type string
			 *  @deprecated
			 */
			"sXInner": null,
	
			/**
			 * Viewport height for vertical scrolling. Vertical scrolling is disabled
			 * if an empty string.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type string
			 */
			"sY": null
		},
	
		/**
		 * Language information for the table.
		 *  @namespace
		 *  @extends DataTable.defaults.oLanguage
		 */
		"oLanguage": {
			/**
			 * Information callback function. See
			 * {@link DataTable.defaults.fnInfoCallback}
			 *  @type function
			 *  @default null
			 */
			"fnInfoCallback": null
		},
	
		/**
		 * Browser support parameters
		 *  @namespace
		 */
		"oBrowser": {
			/**
			 * Indicate if the browser incorrectly calculates width:100% inside a
			 * scrolling element (IE6/7)
			 *  @type boolean
			 *  @default false
			 */
			"bScrollOversize": false,
	
			/**
			 * Determine if the vertical scrollbar is on the right or left of the
			 * scrolling container - needed for rtl language layout, although not
			 * all browsers move the scrollbar (Safari).
			 *  @type boolean
			 *  @default false
			 */
			"bScrollbarLeft": false,
	
			/**
			 * Flag for if `getBoundingClientRect` is fully supported or not
			 *  @type boolean
			 *  @default false
			 */
			"bBounding": false,
	
			/**
			 * Browser scrollbar width
			 *  @type integer
			 *  @default 0
			 */
			"barWidth": 0
		},
	
	
		"ajax": null,
	
	
		/**
		 * Array referencing the nodes which are used for the features. The
		 * parameters of this object match what is allowed by sDom - i.e.
		 *   <ul>
		 *     <li>'l' - Length changing</li>
		 *     <li>'f' - Filtering input</li>
		 *     <li>'t' - The table!</li>
		 *     <li>'i' - Information</li>
		 *     <li>'p' - Pagination</li>
		 *     <li>'r' - pRocessing</li>
		 *   </ul>
		 *  @type array
		 *  @default []
		 */
		"aanFeatures": [],
	
		/**
		 * Store data information - see {@link DataTable.models.oRow} for detailed
		 * information.
		 *  @type array
		 *  @default []
		 */
		"aoData": [],
	
		/**
		 * Array of indexes which are in the current display (after filtering etc)
		 *  @type array
		 *  @default []
		 */
		"aiDisplay": [],
	
		/**
		 * Array of indexes for display - no filtering
		 *  @type array
		 *  @default []
		 */
		"aiDisplayMaster": [],
	
		/**
		 * Map of row ids to data indexes
		 *  @type object
		 *  @default {}
		 */
		"aIds": {},
	
		/**
		 * Store information about each column that is in use
		 *  @type array
		 *  @default []
		 */
		"aoColumns": [],
	
		/**
		 * Store information about the table's header
		 *  @type array
		 *  @default []
		 */
		"aoHeader": [],
	
		/**
		 * Store information about the table's footer
		 *  @type array
		 *  @default []
		 */
		"aoFooter": [],
	
		/**
		 * Store the applied global search information in case we want to force a
		 * research or compare the old search to a new one.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @namespace
		 *  @extends DataTable.models.oSearch
		 */
		"oPreviousSearch": {},
	
		/**
		 * Store the applied search for each column - see
		 * {@link DataTable.models.oSearch} for the format that is used for the
		 * filtering information for each column.
		 *  @type array
		 *  @default []
		 */
		"aoPreSearchCols": [],
	
		/**
		 * Sorting that is applied to the table. Note that the inner arrays are
		 * used in the following manner:
		 * <ul>
		 *   <li>Index 0 - column number</li>
		 *   <li>Index 1 - current sorting direction</li>
		 * </ul>
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type array
		 *  @todo These inner arrays should really be objects
		 */
		"aaSorting": null,
	
		/**
		 * Sorting that is always applied to the table (i.e. prefixed in front of
		 * aaSorting).
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type array
		 *  @default []
		 */
		"aaSortingFixed": [],
	
		/**
		 * Classes to use for the striping of a table.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type array
		 *  @default []
		 */
		"asStripeClasses": null,
	
		/**
		 * If restoring a table - we should restore its striping classes as well
		 *  @type array
		 *  @default []
		 */
		"asDestroyStripes": [],
	
		/**
		 * If restoring a table - we should restore its width
		 *  @type int
		 *  @default 0
		 */
		"sDestroyWidth": 0,
	
		/**
		 * Callback functions array for every time a row is inserted (i.e. on a draw).
		 *  @type array
		 *  @default []
		 */
		"aoRowCallback": [],
	
		/**
		 * Callback functions for the header on each draw.
		 *  @type array
		 *  @default []
		 */
		"aoHeaderCallback": [],
	
		/**
		 * Callback function for the footer on each draw.
		 *  @type array
		 *  @default []
		 */
		"aoFooterCallback": [],
	
		/**
		 * Array of callback functions for draw callback functions
		 *  @type array
		 *  @default []
		 */
		"aoDrawCallback": [],
	
		/**
		 * Array of callback functions for row created function
		 *  @type array
		 *  @default []
		 */
		"aoRowCreatedCallback": [],
	
		/**
		 * Callback functions for just before the table is redrawn. A return of
		 * false will be used to cancel the draw.
		 *  @type array
		 *  @default []
		 */
		"aoPreDrawCallback": [],
	
		/**
		 * Callback functions for when the table has been initialised.
		 *  @type array
		 *  @default []
		 */
		"aoInitComplete": [],
	
	
		/**
		 * Callbacks for modifying the settings to be stored for state saving, prior to
		 * saving state.
		 *  @type array
		 *  @default []
		 */
		"aoStateSaveParams": [],
	
		/**
		 * Callbacks for modifying the settings that have been stored for state saving
		 * prior to using the stored values to restore the state.
		 *  @type array
		 *  @default []
		 */
		"aoStateLoadParams": [],
	
		/**
		 * Callbacks for operating on the settings object once the saved state has been
		 * loaded
		 *  @type array
		 *  @default []
		 */
		"aoStateLoaded": [],
	
		/**
		 * Cache the table ID for quick access
		 *  @type string
		 *  @default <i>Empty string</i>
		 */
		"sTableId": "",
	
		/**
		 * The TABLE node for the main table
		 *  @type node
		 *  @default null
		 */
		"nTable": null,
	
		/**
		 * Permanent ref to the thead element
		 *  @type node
		 *  @default null
		 */
		"nTHead": null,
	
		/**
		 * Permanent ref to the tfoot element - if it exists
		 *  @type node
		 *  @default null
		 */
		"nTFoot": null,
	
		/**
		 * Permanent ref to the tbody element
		 *  @type node
		 *  @default null
		 */
		"nTBody": null,
	
		/**
		 * Cache the wrapper node (contains all DataTables controlled elements)
		 *  @type node
		 *  @default null
		 */
		"nTableWrapper": null,
	
		/**
		 * Indicate if when using server-side processing the loading of data
		 * should be deferred until the second draw.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 *  @default false
		 */
		"bDeferLoading": false,
	
		/**
		 * Indicate if all required information has been read in
		 *  @type boolean
		 *  @default false
		 */
		"bInitialised": false,
	
		/**
		 * Information about open rows. Each object in the array has the parameters
		 * 'nTr' and 'nParent'
		 *  @type array
		 *  @default []
		 */
		"aoOpenRows": [],
	
		/**
		 * Dictate the positioning of DataTables' control elements - see
		 * {@link DataTable.model.oInit.sDom}.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 *  @default null
		 */
		"sDom": null,
	
		/**
		 * Search delay (in mS)
		 *  @type integer
		 *  @default null
		 */
		"searchDelay": null,
	
		/**
		 * Which type of pagination should be used.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 *  @default two_button
		 */
		"sPaginationType": "two_button",
	
		/**
		 * The state duration (for `stateSave`) in seconds.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type int
		 *  @default 0
		 */
		"iStateDuration": 0,
	
		/**
		 * Array of callback functions for state saving. Each array element is an
		 * object with the following parameters:
		 *   <ul>
		 *     <li>function:fn - function to call. Takes two parameters, oSettings
		 *       and the JSON string to save that has been thus far created. Returns
		 *       a JSON string to be inserted into a json object
		 *       (i.e. '"param": [ 0, 1, 2]')</li>
		 *     <li>string:sName - name of callback</li>
		 *   </ul>
		 *  @type array
		 *  @default []
		 */
		"aoStateSave": [],
	
		/**
		 * Array of callback functions for state loading. Each array element is an
		 * object with the following parameters:
		 *   <ul>
		 *     <li>function:fn - function to call. Takes two parameters, oSettings
		 *       and the object stored. May return false to cancel state loading</li>
		 *     <li>string:sName - name of callback</li>
		 *   </ul>
		 *  @type array
		 *  @default []
		 */
		"aoStateLoad": [],
	
		/**
		 * State that was saved. Useful for back reference
		 *  @type object
		 *  @default null
		 */
		"oSavedState": null,
	
		/**
		 * State that was loaded. Useful for back reference
		 *  @type object
		 *  @default null
		 */
		"oLoadedState": null,
	
		/**
		 * Source url for AJAX data for the table.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 *  @default null
		 */
		"sAjaxSource": null,
	
		/**
		 * Property from a given object from which to read the table data from. This
		 * can be an empty string (when not server-side processing), in which case
		 * it is  assumed an an array is given directly.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 */
		"sAjaxDataProp": null,
	
		/**
		 * Note if draw should be blocked while getting data
		 *  @type boolean
		 *  @default true
		 */
		"bAjaxDataGet": true,
	
		/**
		 * The last jQuery XHR object that was used for server-side data gathering.
		 * This can be used for working with the XHR information in one of the
		 * callbacks
		 *  @type object
		 *  @default null
		 */
		"jqXHR": null,
	
		/**
		 * JSON returned from the server in the last Ajax request
		 *  @type object
		 *  @default undefined
		 */
		"json": undefined,
	
		/**
		 * Data submitted as part of the last Ajax request
		 *  @type object
		 *  @default undefined
		 */
		"oAjaxData": undefined,
	
		/**
		 * Function to get the server-side data.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type function
		 */
		"fnServerData": null,
	
		/**
		 * Functions which are called prior to sending an Ajax request so extra
		 * parameters can easily be sent to the server
		 *  @type array
		 *  @default []
		 */
		"aoServerParams": [],
	
		/**
		 * Send the XHR HTTP method - GET or POST (could be PUT or DELETE if
		 * required).
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 */
		"sServerMethod": null,
	
		/**
		 * Format numbers for display.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type function
		 */
		"fnFormatNumber": null,
	
		/**
		 * List of options that can be used for the user selectable length menu.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type array
		 *  @default []
		 */
		"aLengthMenu": null,
	
		/**
		 * Counter for the draws that the table does. Also used as a tracker for
		 * server-side processing
		 *  @type int
		 *  @default 0
		 */
		"iDraw": 0,
	
		/**
		 * Indicate if a redraw is being done - useful for Ajax
		 *  @type boolean
		 *  @default false
		 */
		"bDrawing": false,
	
		/**
		 * Draw index (iDraw) of the last error when parsing the returned data
		 *  @type int
		 *  @default -1
		 */
		"iDrawError": -1,
	
		/**
		 * Paging display length
		 *  @type int
		 *  @default 10
		 */
		"_iDisplayLength": 10,
	
		/**
		 * Paging start point - aiDisplay index
		 *  @type int
		 *  @default 0
		 */
		"_iDisplayStart": 0,
	
		/**
		 * Server-side processing - number of records in the result set
		 * (i.e. before filtering), Use fnRecordsTotal rather than
		 * this property to get the value of the number of records, regardless of
		 * the server-side processing setting.
		 *  @type int
		 *  @default 0
		 *  @private
		 */
		"_iRecordsTotal": 0,
	
		/**
		 * Server-side processing - number of records in the current display set
		 * (i.e. after filtering). Use fnRecordsDisplay rather than
		 * this property to get the value of the number of records, regardless of
		 * the server-side processing setting.
		 *  @type boolean
		 *  @default 0
		 *  @private
		 */
		"_iRecordsDisplay": 0,
	
		/**
		 * Flag to indicate if jQuery UI marking and classes should be used.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bJUI": null,
	
		/**
		 * The classes to use for the table
		 *  @type object
		 *  @default {}
		 */
		"oClasses": {},
	
		/**
		 * Flag attached to the settings object so you can check in the draw
		 * callback if filtering has been done in the draw. Deprecated in favour of
		 * events.
		 *  @type boolean
		 *  @default false
		 *  @deprecated
		 */
		"bFiltered": false,
	
		/**
		 * Flag attached to the settings object so you can check in the draw
		 * callback if sorting has been done in the draw. Deprecated in favour of
		 * events.
		 *  @type boolean
		 *  @default false
		 *  @deprecated
		 */
		"bSorted": false,
	
		/**
		 * Indicate that if multiple rows are in the header and there is more than
		 * one unique cell per column, if the top one (true) or bottom one (false)
		 * should be used for sorting / title by DataTables.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bSortCellsTop": null,
	
		/**
		 * Initialisation object that is used for the table
		 *  @type object
		 *  @default null
		 */
		"oInit": null,
	
		/**
		 * Destroy callback functions - for plug-ins to attach themselves to the
		 * destroy so they can clean up markup and events.
		 *  @type array
		 *  @default []
		 */
		"aoDestroyCallback": [],
	
	
		/**
		 * Get the number of records in the current record set, before filtering
		 *  @type function
		 */
		"fnRecordsTotal": function ()
		{
			return _fnDataSource( this ) == 'ssp' ?
				this._iRecordsTotal * 1 :
				this.aiDisplayMaster.length;
		},
	
		/**
		 * Get the number of records in the current record set, after filtering
		 *  @type function
		 */
		"fnRecordsDisplay": function ()
		{
			return _fnDataSource( this ) == 'ssp' ?
				this._iRecordsDisplay * 1 :
				this.aiDisplay.length;
		},
	
		/**
		 * Get the display end point - aiDisplay index
		 *  @type function
		 */
		"fnDisplayEnd": function ()
		{
			var
				len      = this._iDisplayLength,
				start    = this._iDisplayStart,
				calc     = start + len,
				records  = this.aiDisplay.length,
				features = this.oFeatures,
				paginate = features.bPaginate;
	
			if ( features.bServerSide ) {
				return paginate === false || len === -1 ?
					start + records :
					Math.min( start+len, this._iRecordsDisplay );
			}
			else {
				return ! paginate || calc>records || len===-1 ?
					records :
					calc;
			}
		},
	
		/**
		 * The DataTables object for this table
		 *  @type object
		 *  @default null
		 */
		"oInstance": null,
	
		/**
		 * Unique identifier for each instance of the DataTables object. If there
		 * is an ID on the table node, then it takes that value, otherwise an
		 * incrementing internal counter is used.
		 *  @type string
		 *  @default null
		 */
		"sInstance": null,
	
		/**
		 * tabindex attribute value that is added to DataTables control elements, allowing
		 * keyboard navigation of the table and its controls.
		 */
		"iTabIndex": 0,
	
		/**
		 * DIV container for the footer scrolling table if scrolling
		 */
		"nScrollHead": null,
	
		/**
		 * DIV container for the footer scrolling table if scrolling
		 */
		"nScrollFoot": null,
	
		/**
		 * Last applied sort
		 *  @type array
		 *  @default []
		 */
		"aLastSort": [],
	
		/**
		 * Stored plug-in instances
		 *  @type object
		 *  @default {}
		 */
		"oPlugins": {},
	
		/**
		 * Function used to get a row's id from the row's data
		 *  @type function
		 *  @default null
		 */
		"rowIdFn": null,
	
		/**
		 * Data location where to store a row's id
		 *  @type string
		 *  @default null
		 */
		"rowId": null
	};

	/**
	 * Extension object for DataTables that is used to provide all extension
	 * options.
	 *
	 * Note that the `DataTable.ext` object is available through
	 * `jQuery.fn.dataTable.ext` where it may be accessed and manipulated. It is
	 * also aliased to `jQuery.fn.dataTableExt` for historic reasons.
	 *  @namespace
	 *  @extends DataTable.models.ext
	 */
	
	
	/**
	 * DataTables extensions
	 * 
	 * This namespace acts as a collection area for plug-ins that can be used to
	 * extend DataTables capabilities. Indeed many of the build in methods
	 * use this method to provide their own capabilities (sorting methods for
	 * example).
	 *
	 * Note that this namespace is aliased to `jQuery.fn.dataTableExt` for legacy
	 * reasons
	 *
	 *  @namespace
	 */
	DataTable.ext = _ext = {
		/**
		 * Buttons. For use with the Buttons extension for DataTables. This is
		 * defined here so other extensions can define buttons regardless of load
		 * order. It is _not_ used by DataTables core.
		 *
		 *  @type object
		 *  @default {}
		 */
		buttons: {},
	
	
		/**
		 * Element class names
		 *
		 *  @type object
		 *  @default {}
		 */
		classes: {},
	
	
		/**
		 * DataTables build type (expanded by the download builder)
		 *
		 *  @type string
		 */
		builder: "-source-",
	
	
		/**
		 * Error reporting.
		 * 
		 * How should DataTables report an error. Can take the value 'alert',
		 * 'throw', 'none' or a function.
		 *
		 *  @type string|function
		 *  @default alert
		 */
		errMode: "alert",
	
	
		/**
		 * Feature plug-ins.
		 * 
		 * This is an array of objects which describe the feature plug-ins that are
		 * available to DataTables. These feature plug-ins are then available for
		 * use through the `dom` initialisation option.
		 * 
		 * Each feature plug-in is described by an object which must have the
		 * following properties:
		 * 
		 * * `fnInit` - function that is used to initialise the plug-in,
		 * * `cFeature` - a character so the feature can be enabled by the `dom`
		 *   instillation option. This is case sensitive.
		 *
		 * The `fnInit` function has the following input parameters:
		 *
		 * 1. `{object}` DataTables settings object: see
		 *    {@link DataTable.models.oSettings}
		 *
		 * And the following return is expected:
		 * 
		 * * {node|null} The element which contains your feature. Note that the
		 *   return may also be void if your plug-in does not require to inject any
		 *   DOM elements into DataTables control (`dom`) - for example this might
		 *   be useful when developing a plug-in which allows table control via
		 *   keyboard entry
		 *
		 *  @type array
		 *
		 *  @example
		 *    $.fn.dataTable.ext.features.push( {
		 *      "fnInit": function( oSettings ) {
		 *        return new TableTools( { "oDTSettings": oSettings } );
		 *      },
		 *      "cFeature": "T"
		 *    } );
		 */
		feature: [],
	
	
		/**
		 * Row searching.
		 * 
		 * This method of searching is complimentary to the default type based
		 * searching, and a lot more comprehensive as it allows you complete control
		 * over the searching logic. Each element in this array is a function
		 * (parameters described below) that is called for every row in the table,
		 * and your logic decides if it should be included in the searching data set
		 * or not.
		 *
		 * Searching functions have the following input parameters:
		 *
		 * 1. `{object}` DataTables settings object: see
		 *    {@link DataTable.models.oSettings}
		 * 2. `{array|object}` Data for the row to be processed (same as the
		 *    original format that was passed in as the data source, or an array
		 *    from a DOM data source
		 * 3. `{int}` Row index ({@link DataTable.models.oSettings.aoData}), which
		 *    can be useful to retrieve the `TR` element if you need DOM interaction.
		 *
		 * And the following return is expected:
		 *
		 * * {boolean} Include the row in the searched result set (true) or not
		 *   (false)
		 *
		 * Note that as with the main search ability in DataTables, technically this
		 * is "filtering", since it is subtractive. However, for consistency in
		 * naming we call it searching here.
		 *
		 *  @type array
		 *  @default []
		 *
		 *  @example
		 *    // The following example shows custom search being applied to the
		 *    // fourth column (i.e. the data[3] index) based on two input values
		 *    // from the end-user, matching the data in a certain range.
		 *    $.fn.dataTable.ext.search.push(
		 *      function( settings, data, dataIndex ) {
		 *        var min = document.getElementById('min').value * 1;
		 *        var max = document.getElementById('max').value * 1;
		 *        var version = data[3] == "-" ? 0 : data[3]*1;
		 *
		 *        if ( min == "" && max == "" ) {
		 *          return true;
		 *        }
		 *        else if ( min == "" && version < max ) {
		 *          return true;
		 *        }
		 *        else if ( min < version && "" == max ) {
		 *          return true;
		 *        }
		 *        else if ( min < version && version < max ) {
		 *          return true;
		 *        }
		 *        return false;
		 *      }
		 *    );
		 */
		search: [],
	
	
		/**
		 * Selector extensions
		 *
		 * The `selector` option can be used to extend the options available for the
		 * selector modifier options (`selector-modifier` object data type) that
		 * each of the three built in selector types offer (row, column and cell +
		 * their plural counterparts). For example the Select extension uses this
		 * mechanism to provide an option to select only rows, columns and cells
		 * that have been marked as selected by the end user (`{selected: true}`),
		 * which can be used in conjunction with the existing built in selector
		 * options.
		 *
		 * Each property is an array to which functions can be pushed. The functions
		 * take three attributes:
		 *
		 * * Settings object for the host table
		 * * Options object (`selector-modifier` object type)
		 * * Array of selected item indexes
		 *
		 * The return is an array of the resulting item indexes after the custom
		 * selector has been applied.
		 *
		 *  @type object
		 */
		selector: {
			cell: [],
			column: [],
			row: []
		},
	
	
		/**
		 * Internal functions, exposed for used in plug-ins.
		 * 
		 * Please note that you should not need to use the internal methods for
		 * anything other than a plug-in (and even then, try to avoid if possible).
		 * The internal function may change between releases.
		 *
		 *  @type object
		 *  @default {}
		 */
		internal: {},
	
	
		/**
		 * Legacy configuration options. Enable and disable legacy options that
		 * are available in DataTables.
		 *
		 *  @type object
		 */
		legacy: {
			/**
			 * Enable / disable DataTables 1.9 compatible server-side processing
			 * requests
			 *
			 *  @type boolean
			 *  @default null
			 */
			ajax: null
		},
	
	
		/**
		 * Pagination plug-in methods.
		 * 
		 * Each entry in this object is a function and defines which buttons should
		 * be shown by the pagination rendering method that is used for the table:
		 * {@link DataTable.ext.renderer.pageButton}. The renderer addresses how the
		 * buttons are displayed in the document, while the functions here tell it
		 * what buttons to display. This is done by returning an array of button
		 * descriptions (what each button will do).
		 *
		 * Pagination types (the four built in options and any additional plug-in
		 * options defined here) can be used through the `paginationType`
		 * initialisation parameter.
		 *
		 * The functions defined take two parameters:
		 *
		 * 1. `{int} page` The current page index
		 * 2. `{int} pages` The number of pages in the table
		 *
		 * Each function is expected to return an array where each element of the
		 * array can be one of:
		 *
		 * * `first` - Jump to first page when activated
		 * * `last` - Jump to last page when activated
		 * * `previous` - Show previous page when activated
		 * * `next` - Show next page when activated
		 * * `{int}` - Show page of the index given
		 * * `{array}` - A nested array containing the above elements to add a
		 *   containing 'DIV' element (might be useful for styling).
		 *
		 * Note that DataTables v1.9- used this object slightly differently whereby
		 * an object with two functions would be defined for each plug-in. That
		 * ability is still supported by DataTables 1.10+ to provide backwards
		 * compatibility, but this option of use is now decremented and no longer
		 * documented in DataTables 1.10+.
		 *
		 *  @type object
		 *  @default {}
		 *
		 *  @example
		 *    // Show previous, next and current page buttons only
		 *    $.fn.dataTableExt.oPagination.current = function ( page, pages ) {
		 *      return [ 'previous', page, 'next' ];
		 *    };
		 */
		pager: {},
	
	
		renderer: {
			pageButton: {},
			header: {}
		},
	
	
		/**
		 * Ordering plug-ins - custom data source
		 * 
		 * The extension options for ordering of data available here is complimentary
		 * to the default type based ordering that DataTables typically uses. It
		 * allows much greater control over the the data that is being used to
		 * order a column, but is necessarily therefore more complex.
		 * 
		 * This type of ordering is useful if you want to do ordering based on data
		 * live from the DOM (for example the contents of an 'input' element) rather
		 * than just the static string that DataTables knows of.
		 * 
		 * The way these plug-ins work is that you create an array of the values you
		 * wish to be ordering for the column in question and then return that
		 * array. The data in the array much be in the index order of the rows in
		 * the table (not the currently ordering order!). Which order data gathering
		 * function is run here depends on the `dt-init columns.orderDataType`
		 * parameter that is used for the column (if any).
		 *
		 * The functions defined take two parameters:
		 *
		 * 1. `{object}` DataTables settings object: see
		 *    {@link DataTable.models.oSettings}
		 * 2. `{int}` Target column index
		 *
		 * Each function is expected to return an array:
		 *
		 * * `{array}` Data for the column to be ordering upon
		 *
		 *  @type array
		 *
		 *  @example
		 *    // Ordering using `input` node values
		 *    $.fn.dataTable.ext.order['dom-text'] = function  ( settings, col )
		 *    {
		 *      return this.api().column( col, {order:'index'} ).nodes().map( function ( td, i ) {
		 *        return $('input', td).val();
		 *      } );
		 *    }
		 */
		order: {},
	
	
		/**
		 * Type based plug-ins.
		 *
		 * Each column in DataTables has a type assigned to it, either by automatic
		 * detection or by direct assignment using the `type` option for the column.
		 * The type of a column will effect how it is ordering and search (plug-ins
		 * can also make use of the column type if required).
		 *
		 * @namespace
		 */
		type: {
			/**
			 * Type detection functions.
			 *
			 * The functions defined in this object are used to automatically detect
			 * a column's type, making initialisation of DataTables super easy, even
			 * when complex data is in the table.
			 *
			 * The functions defined take two parameters:
			 *
		     *  1. `{*}` Data from the column cell to be analysed
		     *  2. `{settings}` DataTables settings object. This can be used to
		     *     perform context specific type detection - for example detection
		     *     based on language settings such as using a comma for a decimal
		     *     place. Generally speaking the options from the settings will not
		     *     be required
			 *
			 * Each function is expected to return:
			 *
			 * * `{string|null}` Data type detected, or null if unknown (and thus
			 *   pass it on to the other type detection functions.
			 *
			 *  @type array
			 *
			 *  @example
			 *    // Currency type detection plug-in:
			 *    $.fn.dataTable.ext.type.detect.push(
			 *      function ( data, settings ) {
			 *        // Check the numeric part
			 *        if ( ! $.isNumeric( data.substring(1) ) ) {
			 *          return null;
			 *        }
			 *
			 *        // Check prefixed by currency
			 *        if ( data.charAt(0) == '$' || data.charAt(0) == '&pound;' ) {
			 *          return 'currency';
			 *        }
			 *        return null;
			 *      }
			 *    );
			 */
			detect: [],
	
	
			/**
			 * Type based search formatting.
			 *
			 * The type based searching functions can be used to pre-format the
			 * data to be search on. For example, it can be used to strip HTML
			 * tags or to de-format telephone numbers for numeric only searching.
			 *
			 * Note that is a search is not defined for a column of a given type,
			 * no search formatting will be performed.
			 * 
			 * Pre-processing of searching data plug-ins - When you assign the sType
			 * for a column (or have it automatically detected for you by DataTables
			 * or a type detection plug-in), you will typically be using this for
			 * custom sorting, but it can also be used to provide custom searching
			 * by allowing you to pre-processing the data and returning the data in
			 * the format that should be searched upon. This is done by adding
			 * functions this object with a parameter name which matches the sType
			 * for that target column. This is the corollary of <i>afnSortData</i>
			 * for searching data.
			 *
			 * The functions defined take a single parameter:
			 *
		     *  1. `{*}` Data from the column cell to be prepared for searching
			 *
			 * Each function is expected to return:
			 *
			 * * `{string|null}` Formatted string that will be used for the searching.
			 *
			 *  @type object
			 *  @default {}
			 *
			 *  @example
			 *    $.fn.dataTable.ext.type.search['title-numeric'] = function ( d ) {
			 *      return d.replace(/\n/g," ").replace( /<.*?>/g, "" );
			 *    }
			 */
			search: {},
	
	
			/**
			 * Type based ordering.
			 *
			 * The column type tells DataTables what ordering to apply to the table
			 * when a column is sorted upon. The order for each type that is defined,
			 * is defined by the functions available in this object.
			 *
			 * Each ordering option can be described by three properties added to
			 * this object:
			 *
			 * * `{type}-pre` - Pre-formatting function
			 * * `{type}-asc` - Ascending order function
			 * * `{type}-desc` - Descending order function
			 *
			 * All three can be used together, only `{type}-pre` or only
			 * `{type}-asc` and `{type}-desc` together. It is generally recommended
			 * that only `{type}-pre` is used, as this provides the optimal
			 * implementation in terms of speed, although the others are provided
			 * for compatibility with existing Javascript sort functions.
			 *
			 * `{type}-pre`: Functions defined take a single parameter:
			 *
		     *  1. `{*}` Data from the column cell to be prepared for ordering
			 *
			 * And return:
			 *
			 * * `{*}` Data to be sorted upon
			 *
			 * `{type}-asc` and `{type}-desc`: Functions are typical Javascript sort
			 * functions, taking two parameters:
			 *
		     *  1. `{*}` Data to compare to the second parameter
		     *  2. `{*}` Data to compare to the first parameter
			 *
			 * And returning:
			 *
			 * * `{*}` Ordering match: <0 if first parameter should be sorted lower
			 *   than the second parameter, ===0 if the two parameters are equal and
			 *   >0 if the first parameter should be sorted height than the second
			 *   parameter.
			 * 
			 *  @type object
			 *  @default {}
			 *
			 *  @example
			 *    // Numeric ordering of formatted numbers with a pre-formatter
			 *    $.extend( $.fn.dataTable.ext.type.order, {
			 *      "string-pre": function(x) {
			 *        a = (a === "-" || a === "") ? 0 : a.replace( /[^\d\-\.]/g, "" );
			 *        return parseFloat( a );
			 *      }
			 *    } );
			 *
			 *  @example
			 *    // Case-sensitive string ordering, with no pre-formatting method
			 *    $.extend( $.fn.dataTable.ext.order, {
			 *      "string-case-asc": function(x,y) {
			 *        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
			 *      },
			 *      "string-case-desc": function(x,y) {
			 *        return ((x < y) ? 1 : ((x > y) ? -1 : 0));
			 *      }
			 *    } );
			 */
			order: {}
		},
	
		/**
		 * Unique DataTables instance counter
		 *
		 * @type int
		 * @private
		 */
		_unique: 0,
	
	
		//
		// Depreciated
		// The following properties are retained for backwards compatiblity only.
		// The should not be used in new projects and will be removed in a future
		// version
		//
	
		/**
		 * Version check function.
		 *  @type function
		 *  @depreciated Since 1.10
		 */
		fnVersionCheck: DataTable.fnVersionCheck,
	
	
		/**
		 * Index for what 'this' index API functions should use
		 *  @type int
		 *  @deprecated Since v1.10
		 */
		iApiIndex: 0,
	
	
		/**
		 * jQuery UI class container
		 *  @type object
		 *  @deprecated Since v1.10
		 */
		oJUIClasses: {},
	
	
		/**
		 * Software version
		 *  @type string
		 *  @deprecated Since v1.10
		 */
		sVersion: DataTable.version
	};
	
	
	//
	// Backwards compatibility. Alias to pre 1.10 Hungarian notation counter parts
	//
	$.extend( _ext, {
		afnFiltering: _ext.search,
		aTypes:       _ext.type.detect,
		ofnSearch:    _ext.type.search,
		oSort:        _ext.type.order,
		afnSortData:  _ext.order,
		aoFeatures:   _ext.feature,
		oApi:         _ext.internal,
		oStdClasses:  _ext.classes,
		oPagination:  _ext.pager
	} );
	
	
	$.extend( DataTable.ext.classes, {
		"sTable": "dataTable",
		"sNoFooter": "no-footer",
	
		/* Paging buttons */
		"sPageButton": "paginate_button",
		"sPageButtonActive": "current",
		"sPageButtonDisabled": "disabled",
	
		/* Striping classes */
		"sStripeOdd": "odd",
		"sStripeEven": "even",
	
		/* Empty row */
		"sRowEmpty": "dataTables_empty",
	
		/* Features */
		"sWrapper": "dataTables_wrapper",
		"sFilter": "dataTables_filter",
		"sInfo": "dataTables_info",
		"sPaging": "dataTables_paginate paging_", /* Note that the type is postfixed */
		"sLength": "dataTables_length",
		"sProcessing": "dataTables_processing",
	
		/* Sorting */
		"sSortAsc": "sorting_asc",
		"sSortDesc": "sorting_desc",
		"sSortable": "sorting", /* Sortable in both directions */
		"sSortableAsc": "sorting_asc_disabled",
		"sSortableDesc": "sorting_desc_disabled",
		"sSortableNone": "sorting_disabled",
		"sSortColumn": "sorting_", /* Note that an int is postfixed for the sorting order */
	
		/* Filtering */
		"sFilterInput": "",
	
		/* Page length */
		"sLengthSelect": "",
	
		/* Scrolling */
		"sScrollWrapper": "dataTables_scroll",
		"sScrollHead": "dataTables_scrollHead",
		"sScrollHeadInner": "dataTables_scrollHeadInner",
		"sScrollBody": "dataTables_scrollBody",
		"sScrollFoot": "dataTables_scrollFoot",
		"sScrollFootInner": "dataTables_scrollFootInner",
	
		/* Misc */
		"sHeaderTH": "",
		"sFooterTH": "",
	
		// Deprecated
		"sSortJUIAsc": "",
		"sSortJUIDesc": "",
		"sSortJUI": "",
		"sSortJUIAscAllowed": "",
		"sSortJUIDescAllowed": "",
		"sSortJUIWrapper": "",
		"sSortIcon": "",
		"sJUIHeader": "",
		"sJUIFooter": ""
	} );
	
	
	(function() {
	
	// Reused strings for better compression. Closure compiler appears to have a
	// weird edge case where it is trying to expand strings rather than use the
	// variable version. This results in about 200 bytes being added, for very
	// little preference benefit since it this run on script load only.
	var _empty = '';
	_empty = '';
	
	var _stateDefault = _empty + 'ui-state-default';
	var _sortIcon     = _empty + 'css_right ui-icon ui-icon-';
	var _headerFooter = _empty + 'fg-toolbar ui-toolbar ui-widget-header ui-helper-clearfix';
	
	$.extend( DataTable.ext.oJUIClasses, DataTable.ext.classes, {
		/* Full numbers paging buttons */
		"sPageButton":         "fg-button ui-button "+_stateDefault,
		"sPageButtonActive":   "ui-state-disabled",
		"sPageButtonDisabled": "ui-state-disabled",
	
		/* Features */
		"sPaging": "dataTables_paginate fg-buttonset ui-buttonset fg-buttonset-multi "+
			"ui-buttonset-multi paging_", /* Note that the type is postfixed */
	
		/* Sorting */
		"sSortAsc":            _stateDefault+" sorting_asc",
		"sSortDesc":           _stateDefault+" sorting_desc",
		"sSortable":           _stateDefault+" sorting",
		"sSortableAsc":        _stateDefault+" sorting_asc_disabled",
		"sSortableDesc":       _stateDefault+" sorting_desc_disabled",
		"sSortableNone":       _stateDefault+" sorting_disabled",
		"sSortJUIAsc":         _sortIcon+"triangle-1-n",
		"sSortJUIDesc":        _sortIcon+"triangle-1-s",
		"sSortJUI":            _sortIcon+"carat-2-n-s",
		"sSortJUIAscAllowed":  _sortIcon+"carat-1-n",
		"sSortJUIDescAllowed": _sortIcon+"carat-1-s",
		"sSortJUIWrapper":     "DataTables_sort_wrapper",
		"sSortIcon":           "DataTables_sort_icon",
	
		/* Scrolling */
		"sScrollHead": "dataTables_scrollHead "+_stateDefault,
		"sScrollFoot": "dataTables_scrollFoot "+_stateDefault,
	
		/* Misc */
		"sHeaderTH":  _stateDefault,
		"sFooterTH":  _stateDefault,
		"sJUIHeader": _headerFooter+" ui-corner-tl ui-corner-tr",
		"sJUIFooter": _headerFooter+" ui-corner-bl ui-corner-br"
	} );
	
	}());
	
	
	
	var extPagination = DataTable.ext.pager;
	
	function _numbers ( page, pages ) {
		var
			numbers = [],
			buttons = extPagination.numbers_length,
			half = Math.floor( buttons / 2 ),
			i = 1;
	
		if ( pages <= buttons ) {
			numbers = _range( 0, pages );
		}
		else if ( page <= half ) {
			numbers = _range( 0, buttons-2 );
			numbers.push( 'ellipsis' );
			numbers.push( pages-1 );
		}
		else if ( page >= pages - 1 - half ) {
			numbers = _range( pages-(buttons-2), pages );
			numbers.splice( 0, 0, 'ellipsis' ); // no unshift in ie6
			numbers.splice( 0, 0, 0 );
		}
		else {
			numbers = _range( page-half+2, page+half-1 );
			numbers.push( 'ellipsis' );
			numbers.push( pages-1 );
			numbers.splice( 0, 0, 'ellipsis' );
			numbers.splice( 0, 0, 0 );
		}
	
		numbers.DT_el = 'span';
		return numbers;
	}
	
	
	$.extend( extPagination, {
		simple: function ( page, pages ) {
			return [ 'previous', 'next' ];
		},
	
		full: function ( page, pages ) {
			return [  'first', 'previous', 'next', 'last' ];
		},
	
		numbers: function ( page, pages ) {
			return [ _numbers(page, pages) ];
		},
	
		simple_numbers: function ( page, pages ) {
			return [ 'previous', _numbers(page, pages), 'next' ];
		},
	
		full_numbers: function ( page, pages ) {
			return [ 'first', 'previous', _numbers(page, pages), 'next', 'last' ];
		},
		
		first_last_numbers: function (page, pages) {
	 		return ['first', _numbers(page, pages), 'last'];
	 	},
	
		// For testing and plug-ins to use
		_numbers: _numbers,
	
		// Number of number buttons (including ellipsis) to show. _Must be odd!_
		numbers_length: 7
	} );
	
	
	$.extend( true, DataTable.ext.renderer, {
		pageButton: {
			_: function ( settings, host, idx, buttons, page, pages ) {
				var classes = settings.oClasses;
				var lang = settings.oLanguage.oPaginate;
				var aria = settings.oLanguage.oAria.paginate || {};
				var btnDisplay, btnClass, counter=0;
	
				var attach = function( container, buttons ) {
					var i, ien, node, button;
					var clickHandler = function ( e ) {
						_fnPageChange( settings, e.data.action, true );
					};
	
					for ( i=0, ien=buttons.length ; i<ien ; i++ ) {
						button = buttons[i];
	
						if ( $.isArray( button ) ) {
							var inner = $( '<'+(button.DT_el || 'div')+'/>' )
								.appendTo( container );
							attach( inner, button );
						}
						else {
							btnDisplay = null;
							btnClass = '';
	
							switch ( button ) {
								case 'ellipsis':
									container.append('<span class="ellipsis">&#x2026;</span>');
									break;
	
								case 'first':
									btnDisplay = lang.sFirst;
									btnClass = button + (page > 0 ?
										'' : ' '+classes.sPageButtonDisabled);
									break;
	
								case 'previous':
									btnDisplay = lang.sPrevious;
									btnClass = button + (page > 0 ?
										'' : ' '+classes.sPageButtonDisabled);
									break;
	
								case 'next':
									btnDisplay = lang.sNext;
									btnClass = button + (page < pages-1 ?
										'' : ' '+classes.sPageButtonDisabled);
									break;
	
								case 'last':
									btnDisplay = lang.sLast;
									btnClass = button + (page < pages-1 ?
										'' : ' '+classes.sPageButtonDisabled);
									break;
	
								default:
									btnDisplay = button + 1;
									btnClass = page === button ?
										classes.sPageButtonActive : '';
									break;
							}
	
							if ( btnDisplay !== null ) {
								node = $('<a>', {
										'class': classes.sPageButton+' '+btnClass,
										'aria-controls': settings.sTableId,
										'aria-label': aria[ button ],
										'data-dt-idx': counter,
										'tabindex': settings.iTabIndex,
										'id': idx === 0 && typeof button === 'string' ?
											settings.sTableId +'_'+ button :
											null
									} )
									.html( btnDisplay )
									.appendTo( container );
	
								_fnBindAction(
									node, {action: button}, clickHandler
								);
	
								counter++;
							}
						}
					}
				};
	
				// IE9 throws an 'unknown error' if document.activeElement is used
				// inside an iframe or frame. Try / catch the error. Not good for
				// accessibility, but neither are frames.
				var activeEl;
	
				try {
					// Because this approach is destroying and recreating the paging
					// elements, focus is lost on the select button which is bad for
					// accessibility. So we want to restore focus once the draw has
					// completed
					activeEl = $(host).find(document.activeElement).data('dt-idx');
				}
				catch (e) {}
	
				attach( $(host).empty(), buttons );
	
				if ( activeEl !== undefined ) {
					$(host).find( '[data-dt-idx='+activeEl+']' ).focus();
				}
			}
		}
	} );
	
	
	
	// Built in type detection. See model.ext.aTypes for information about
	// what is required from this methods.
	$.extend( DataTable.ext.type.detect, [
		// Plain numbers - first since V8 detects some plain numbers as dates
		// e.g. Date.parse('55') (but not all, e.g. Date.parse('22')...).
		function ( d, settings )
		{
			var decimal = settings.oLanguage.sDecimal;
			return _isNumber( d, decimal ) ? 'num'+decimal : null;
		},
	
		// Dates (only those recognised by the browser's Date.parse)
		function ( d, settings )
		{
			// V8 tries _very_ hard to make a string passed into `Date.parse()`
			// valid, so we need to use a regex to restrict date formats. Use a
			// plug-in for anything other than ISO8601 style strings
			if ( d && !(d instanceof Date) && ! _re_date.test(d) ) {
				return null;
			}
			var parsed = Date.parse(d);
			return (parsed !== null && !isNaN(parsed)) || _empty(d) ? 'date' : null;
		},
	
		// Formatted numbers
		function ( d, settings )
		{
			var decimal = settings.oLanguage.sDecimal;
			return _isNumber( d, decimal, true ) ? 'num-fmt'+decimal : null;
		},
	
		// HTML numeric
		function ( d, settings )
		{
			var decimal = settings.oLanguage.sDecimal;
			return _htmlNumeric( d, decimal ) ? 'html-num'+decimal : null;
		},
	
		// HTML numeric, formatted
		function ( d, settings )
		{
			var decimal = settings.oLanguage.sDecimal;
			return _htmlNumeric( d, decimal, true ) ? 'html-num-fmt'+decimal : null;
		},
	
		// HTML (this is strict checking - there must be html)
		function ( d, settings )
		{
			return _empty( d ) || (typeof d === 'string' && d.indexOf('<') !== -1) ?
				'html' : null;
		}
	] );
	
	
	
	// Filter formatting functions. See model.ext.ofnSearch for information about
	// what is required from these methods.
	// 
	// Note that additional search methods are added for the html numbers and
	// html formatted numbers by `_addNumericSort()` when we know what the decimal
	// place is
	
	
	$.extend( DataTable.ext.type.search, {
		html: function ( data ) {
			return _empty(data) ?
				data :
				typeof data === 'string' ?
					data
						.replace( _re_new_lines, " " )
						.replace( _re_html, "" ) :
					'';
		},
	
		string: function ( data ) {
			return _empty(data) ?
				data :
				typeof data === 'string' ?
					data.replace( _re_new_lines, " " ) :
					data;
		}
	} );
	
	
	
	var __numericReplace = function ( d, decimalPlace, re1, re2 ) {
		if ( d !== 0 && (!d || d === '-') ) {
			return -Infinity;
		}
	
		// If a decimal place other than `.` is used, it needs to be given to the
		// function so we can detect it and replace with a `.` which is the only
		// decimal place Javascript recognises - it is not locale aware.
		if ( decimalPlace ) {
			d = _numToDecimal( d, decimalPlace );
		}
	
		if ( d.replace ) {
			if ( re1 ) {
				d = d.replace( re1, '' );
			}
	
			if ( re2 ) {
				d = d.replace( re2, '' );
			}
		}
	
		return d * 1;
	};
	
	
	// Add the numeric 'deformatting' functions for sorting and search. This is done
	// in a function to provide an easy ability for the language options to add
	// additional methods if a non-period decimal place is used.
	function _addNumericSort ( decimalPlace ) {
		$.each(
			{
				// Plain numbers
				"num": function ( d ) {
					return __numericReplace( d, decimalPlace );
				},
	
				// Formatted numbers
				"num-fmt": function ( d ) {
					return __numericReplace( d, decimalPlace, _re_formatted_numeric );
				},
	
				// HTML numeric
				"html-num": function ( d ) {
					return __numericReplace( d, decimalPlace, _re_html );
				},
	
				// HTML numeric, formatted
				"html-num-fmt": function ( d ) {
					return __numericReplace( d, decimalPlace, _re_html, _re_formatted_numeric );
				}
			},
			function ( key, fn ) {
				// Add the ordering method
				_ext.type.order[ key+decimalPlace+'-pre' ] = fn;
	
				// For HTML types add a search formatter that will strip the HTML
				if ( key.match(/^html\-/) ) {
					_ext.type.search[ key+decimalPlace ] = _ext.type.search.html;
				}
			}
		);
	}
	
	
	// Default sort methods
	$.extend( _ext.type.order, {
		// Dates
		"date-pre": function ( d ) {
			return Date.parse( d ) || -Infinity;
		},
	
		// html
		"html-pre": function ( a ) {
			return _empty(a) ?
				'' :
				a.replace ?
					a.replace( /<.*?>/g, "" ).toLowerCase() :
					a+'';
		},
	
		// string
		"string-pre": function ( a ) {
			// This is a little complex, but faster than always calling toString,
			// http://jsperf.com/tostring-v-check
			return _empty(a) ?
				'' :
				typeof a === 'string' ?
					a.toLowerCase() :
					! a.toString ?
						'' :
						a.toString();
		},
	
		// string-asc and -desc are retained only for compatibility with the old
		// sort methods
		"string-asc": function ( x, y ) {
			return ((x < y) ? -1 : ((x > y) ? 1 : 0));
		},
	
		"string-desc": function ( x, y ) {
			return ((x < y) ? 1 : ((x > y) ? -1 : 0));
		}
	} );
	
	
	// Numeric sorting types - order doesn't matter here
	_addNumericSort( '' );
	
	
	$.extend( true, DataTable.ext.renderer, {
		header: {
			_: function ( settings, cell, column, classes ) {
				// No additional mark-up required
				// Attach a sort listener to update on sort - note that using the
				// `DT` namespace will allow the event to be removed automatically
				// on destroy, while the `dt` namespaced event is the one we are
				// listening for
				$(settings.nTable).on( 'order.dt.DT', function ( e, ctx, sorting, columns ) {
					if ( settings !== ctx ) { // need to check this this is the host
						return;               // table, not a nested one
					}
	
					var colIdx = column.idx;
	
					cell
						.removeClass(
							column.sSortingClass +' '+
							classes.sSortAsc +' '+
							classes.sSortDesc
						)
						.addClass( columns[ colIdx ] == 'asc' ?
							classes.sSortAsc : columns[ colIdx ] == 'desc' ?
								classes.sSortDesc :
								column.sSortingClass
						);
				} );
			},
	
			jqueryui: function ( settings, cell, column, classes ) {
				$('<div/>')
					.addClass( classes.sSortJUIWrapper )
					.append( cell.contents() )
					.append( $('<span/>')
						.addClass( classes.sSortIcon+' '+column.sSortingClassJUI )
					)
					.appendTo( cell );
	
				// Attach a sort listener to update on sort
				$(settings.nTable).on( 'order.dt.DT', function ( e, ctx, sorting, columns ) {
					if ( settings !== ctx ) {
						return;
					}
	
					var colIdx = column.idx;
	
					cell
						.removeClass( classes.sSortAsc +" "+classes.sSortDesc )
						.addClass( columns[ colIdx ] == 'asc' ?
							classes.sSortAsc : columns[ colIdx ] == 'desc' ?
								classes.sSortDesc :
								column.sSortingClass
						);
	
					cell
						.find( 'span.'+classes.sSortIcon )
						.removeClass(
							classes.sSortJUIAsc +" "+
							classes.sSortJUIDesc +" "+
							classes.sSortJUI +" "+
							classes.sSortJUIAscAllowed +" "+
							classes.sSortJUIDescAllowed
						)
						.addClass( columns[ colIdx ] == 'asc' ?
							classes.sSortJUIAsc : columns[ colIdx ] == 'desc' ?
								classes.sSortJUIDesc :
								column.sSortingClassJUI
						);
				} );
			}
		}
	} );
	
	/*
	 * Public helper functions. These aren't used internally by DataTables, or
	 * called by any of the options passed into DataTables, but they can be used
	 * externally by developers working with DataTables. They are helper functions
	 * to make working with DataTables a little bit easier.
	 */
	
	var __htmlEscapeEntities = function ( d ) {
		return typeof d === 'string' ?
			d.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;') :
			d;
	};
	
	/**
	 * Helpers for `columns.render`.
	 *
	 * The options defined here can be used with the `columns.render` initialisation
	 * option to provide a display renderer. The following functions are defined:
	 *
	 * * `number` - Will format numeric data (defined by `columns.data`) for
	 *   display, retaining the original unformatted data for sorting and filtering.
	 *   It takes 5 parameters:
	 *   * `string` - Thousands grouping separator
	 *   * `string` - Decimal point indicator
	 *   * `integer` - Number of decimal points to show
	 *   * `string` (optional) - Prefix.
	 *   * `string` (optional) - Postfix (/suffix).
	 * * `text` - Escape HTML to help prevent XSS attacks. It has no optional
	 *   parameters.
	 *
	 * @example
	 *   // Column definition using the number renderer
	 *   {
	 *     data: "salary",
	 *     render: $.fn.dataTable.render.number( '\'', '.', 0, '$' )
	 *   }
	 *
	 * @namespace
	 */
	DataTable.render = {
		number: function ( thousands, decimal, precision, prefix, postfix ) {
			return {
				display: function ( d ) {
					if ( typeof d !== 'number' && typeof d !== 'string' ) {
						return d;
					}
	
					var negative = d < 0 ? '-' : '';
					var flo = parseFloat( d );
	
					// If NaN then there isn't much formatting that we can do - just
					// return immediately, escaping any HTML (this was supposed to
					// be a number after all)
					if ( isNaN( flo ) ) {
						return __htmlEscapeEntities( d );
					}
	
					flo = flo.toFixed( precision );
					d = Math.abs( flo );
	
					var intPart = parseInt( d, 10 );
					var floatPart = precision ?
						decimal+(d - intPart).toFixed( precision ).substring( 2 ):
						'';
	
					return negative + (prefix||'') +
						intPart.toString().replace(
							/\B(?=(\d{3})+(?!\d))/g, thousands
						) +
						floatPart +
						(postfix||'');
				}
			};
		},
	
		text: function () {
			return {
				display: __htmlEscapeEntities
			};
		}
	};
	
	
	/*
	 * This is really a good bit rubbish this method of exposing the internal methods
	 * publicly... - To be fixed in 2.0 using methods on the prototype
	 */
	
	
	/**
	 * Create a wrapper function for exporting an internal functions to an external API.
	 *  @param {string} fn API function name
	 *  @returns {function} wrapped function
	 *  @memberof DataTable#internal
	 */
	function _fnExternApiFunc (fn)
	{
		return function() {
			var args = [_fnSettingsFromNode( this[DataTable.ext.iApiIndex] )].concat(
				Array.prototype.slice.call(arguments)
			);
			return DataTable.ext.internal[fn].apply( this, args );
		};
	}
	
	
	/**
	 * Reference to internal functions for use by plug-in developers. Note that
	 * these methods are references to internal functions and are considered to be
	 * private. If you use these methods, be aware that they are liable to change
	 * between versions.
	 *  @namespace
	 */
	$.extend( DataTable.ext.internal, {
		_fnExternApiFunc: _fnExternApiFunc,
		_fnBuildAjax: _fnBuildAjax,
		_fnAjaxUpdate: _fnAjaxUpdate,
		_fnAjaxParameters: _fnAjaxParameters,
		_fnAjaxUpdateDraw: _fnAjaxUpdateDraw,
		_fnAjaxDataSrc: _fnAjaxDataSrc,
		_fnAddColumn: _fnAddColumn,
		_fnColumnOptions: _fnColumnOptions,
		_fnAdjustColumnSizing: _fnAdjustColumnSizing,
		_fnVisibleToColumnIndex: _fnVisibleToColumnIndex,
		_fnColumnIndexToVisible: _fnColumnIndexToVisible,
		_fnVisbleColumns: _fnVisbleColumns,
		_fnGetColumns: _fnGetColumns,
		_fnColumnTypes: _fnColumnTypes,
		_fnApplyColumnDefs: _fnApplyColumnDefs,
		_fnHungarianMap: _fnHungarianMap,
		_fnCamelToHungarian: _fnCamelToHungarian,
		_fnLanguageCompat: _fnLanguageCompat,
		_fnBrowserDetect: _fnBrowserDetect,
		_fnAddData: _fnAddData,
		_fnAddTr: _fnAddTr,
		_fnNodeToDataIndex: _fnNodeToDataIndex,
		_fnNodeToColumnIndex: _fnNodeToColumnIndex,
		_fnGetCellData: _fnGetCellData,
		_fnSetCellData: _fnSetCellData,
		_fnSplitObjNotation: _fnSplitObjNotation,
		_fnGetObjectDataFn: _fnGetObjectDataFn,
		_fnSetObjectDataFn: _fnSetObjectDataFn,
		_fnGetDataMaster: _fnGetDataMaster,
		_fnClearTable: _fnClearTable,
		_fnDeleteIndex: _fnDeleteIndex,
		_fnInvalidate: _fnInvalidate,
		_fnGetRowElements: _fnGetRowElements,
		_fnCreateTr: _fnCreateTr,
		_fnBuildHead: _fnBuildHead,
		_fnDrawHead: _fnDrawHead,
		_fnDraw: _fnDraw,
		_fnReDraw: _fnReDraw,
		_fnAddOptionsHtml: _fnAddOptionsHtml,
		_fnDetectHeader: _fnDetectHeader,
		_fnGetUniqueThs: _fnGetUniqueThs,
		_fnFeatureHtmlFilter: _fnFeatureHtmlFilter,
		_fnFilterComplete: _fnFilterComplete,
		_fnFilterCustom: _fnFilterCustom,
		_fnFilterColumn: _fnFilterColumn,
		_fnFilter: _fnFilter,
		_fnFilterCreateSearch: _fnFilterCreateSearch,
		_fnEscapeRegex: _fnEscapeRegex,
		_fnFilterData: _fnFilterData,
		_fnFeatureHtmlInfo: _fnFeatureHtmlInfo,
		_fnUpdateInfo: _fnUpdateInfo,
		_fnInfoMacros: _fnInfoMacros,
		_fnInitialise: _fnInitialise,
		_fnInitComplete: _fnInitComplete,
		_fnLengthChange: _fnLengthChange,
		_fnFeatureHtmlLength: _fnFeatureHtmlLength,
		_fnFeatureHtmlPaginate: _fnFeatureHtmlPaginate,
		_fnPageChange: _fnPageChange,
		_fnFeatureHtmlProcessing: _fnFeatureHtmlProcessing,
		_fnProcessingDisplay: _fnProcessingDisplay,
		_fnFeatureHtmlTable: _fnFeatureHtmlTable,
		_fnScrollDraw: _fnScrollDraw,
		_fnApplyToChildren: _fnApplyToChildren,
		_fnCalculateColumnWidths: _fnCalculateColumnWidths,
		_fnThrottle: _fnThrottle,
		_fnConvertToWidth: _fnConvertToWidth,
		_fnGetWidestNode: _fnGetWidestNode,
		_fnGetMaxLenString: _fnGetMaxLenString,
		_fnStringToCss: _fnStringToCss,
		_fnSortFlatten: _fnSortFlatten,
		_fnSort: _fnSort,
		_fnSortAria: _fnSortAria,
		_fnSortListener: _fnSortListener,
		_fnSortAttachListener: _fnSortAttachListener,
		_fnSortingClasses: _fnSortingClasses,
		_fnSortData: _fnSortData,
		_fnSaveState: _fnSaveState,
		_fnLoadState: _fnLoadState,
		_fnSettingsFromNode: _fnSettingsFromNode,
		_fnLog: _fnLog,
		_fnMap: _fnMap,
		_fnBindAction: _fnBindAction,
		_fnCallbackReg: _fnCallbackReg,
		_fnCallbackFire: _fnCallbackFire,
		_fnLengthOverflow: _fnLengthOverflow,
		_fnRenderer: _fnRenderer,
		_fnDataSource: _fnDataSource,
		_fnRowAttributes: _fnRowAttributes,
		_fnCalculateEnd: function () {} // Used by a lot of plug-ins, but redundant
		                                // in 1.10, so this dead-end function is
		                                // added to prevent errors
	} );
	

	// jQuery access
	$.fn.dataTable = DataTable;

	// Provide access to the host jQuery object (circular reference)
	DataTable.$ = $;

	// Legacy aliases
	$.fn.dataTableSettings = DataTable.settings;
	$.fn.dataTableExt = DataTable.ext;

	// With a capital `D` we return a DataTables API instance rather than a
	// jQuery object
	$.fn.DataTable = function ( opts ) {
		return $(this).dataTable( opts ).api();
	};

	// All properties that are available to $.fn.dataTable should also be
	// available on $.fn.DataTable
	$.each( DataTable, function ( prop, val ) {
		$.fn.DataTable[ prop ] = val;
	} );


	// Information about events fired by DataTables - for documentation.
	/**
	 * Draw event, fired whenever the table is redrawn on the page, at the same
	 * point as fnDrawCallback. This may be useful for binding events or
	 * performing calculations when the table is altered at all.
	 *  @name DataTable#draw.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 */

	/**
	 * Search event, fired when the searching applied to the table (using the
	 * built-in global search, or column filters) is altered.
	 *  @name DataTable#search.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 */

	/**
	 * Page change event, fired when the paging of the table is altered.
	 *  @name DataTable#page.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 */

	/**
	 * Order event, fired when the ordering applied to the table is altered.
	 *  @name DataTable#order.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 */

	/**
	 * DataTables initialisation complete event, fired when the table is fully
	 * drawn, including Ajax data loaded, if Ajax data is required.
	 *  @name DataTable#init.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} oSettings DataTables settings object
	 *  @param {object} json The JSON object request from the server - only
	 *    present if client-side Ajax sourced data is used</li></ol>
	 */

	/**
	 * State save event, fired when the table has changed state a new state save
	 * is required. This event allows modification of the state saving object
	 * prior to actually doing the save, including addition or other state
	 * properties (for plug-ins) or modification of a DataTables core property.
	 *  @name DataTable#stateSaveParams.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} oSettings DataTables settings object
	 *  @param {object} json The state information to be saved
	 */

	/**
	 * State load event, fired when the table is loading state from the stored
	 * data, but prior to the settings object being modified by the saved state
	 * - allowing modification of the saved state is required or loading of
	 * state for a plug-in.
	 *  @name DataTable#stateLoadParams.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} oSettings DataTables settings object
	 *  @param {object} json The saved state information
	 */

	/**
	 * State loaded event, fired when state has been loaded from stored data and
	 * the settings object has been modified by the loaded data.
	 *  @name DataTable#stateLoaded.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} oSettings DataTables settings object
	 *  @param {object} json The saved state information
	 */

	/**
	 * Processing event, fired when DataTables is doing some kind of processing
	 * (be it, order, searcg or anything else). It can be used to indicate to
	 * the end user that there is something happening, or that something has
	 * finished.
	 *  @name DataTable#processing.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} oSettings DataTables settings object
	 *  @param {boolean} bShow Flag for if DataTables is doing processing or not
	 */

	/**
	 * Ajax (XHR) event, fired whenever an Ajax request is completed from a
	 * request to made to the server for new data. This event is called before
	 * DataTables processed the returned data, so it can also be used to pre-
	 * process the data returned from the server, if needed.
	 *
	 * Note that this trigger is called in `fnServerData`, if you override
	 * `fnServerData` and which to use this event, you need to trigger it in you
	 * success function.
	 *  @name DataTable#xhr.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 *  @param {object} json JSON returned from the server
	 *
	 *  @example
	 *     // Use a custom property returned from the server in another DOM element
	 *     $('#table').dataTable().on('xhr.dt', function (e, settings, json) {
	 *       $('#status').html( json.status );
	 *     } );
	 *
	 *  @example
	 *     // Pre-process the data returned from the server
	 *     $('#table').dataTable().on('xhr.dt', function (e, settings, json) {
	 *       for ( var i=0, ien=json.aaData.length ; i<ien ; i++ ) {
	 *         json.aaData[i].sum = json.aaData[i].one + json.aaData[i].two;
	 *       }
	 *       // Note no return - manipulate the data directly in the JSON object.
	 *     } );
	 */

	/**
	 * Destroy event, fired when the DataTable is destroyed by calling fnDestroy
	 * or passing the bDestroy:true parameter in the initialisation object. This
	 * can be used to remove bound events, added DOM nodes, etc.
	 *  @name DataTable#destroy.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 */

	/**
	 * Page length change event, fired when number of records to show on each
	 * page (the length) is changed.
	 *  @name DataTable#length.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 *  @param {integer} len New length
	 */

	/**
	 * Column sizing has changed.
	 *  @name DataTable#column-sizing.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 */

	/**
	 * Column visibility has changed.
	 *  @name DataTable#column-visibility.dt
	 *  @event
	 *  @param {event} e jQuery event object
	 *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	 *  @param {int} column Column index
	 *  @param {bool} vis `false` if column now hidden, or `true` if visible
	 */

	return $.fn.dataTable;
}));


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/*! fancyBox v2.1.5 fancyapps.com | fancyapps.com/fancybox/#license */
(function (r, G, f, v) {
    var J = f("html"),
        n = f(r),
        p = f(G),
        b = f.fancybox = function () {
        b.open.apply(this, arguments);
    },
        I = navigator.userAgent.match(/msie/i),
        B = null,
        s = G.createTouch !== v,
        t = function t(a) {
        return a && a.hasOwnProperty && a instanceof f;
    },
        q = function q(a) {
        return a && "string" === f.type(a);
    },
        E = function E(a) {
        return q(a) && 0 < a.indexOf("%");
    },
        l = function l(a, d) {
        var e = parseInt(a, 10) || 0;d && E(a) && (e *= b.getViewport()[d] / 100);return Math.ceil(e);
    },
        w = function w(a, b) {
        return l(a, b) + "px";
    };f.extend(b, { version: "2.1.5", defaults: { padding: 15, margin: 20,
            width: 800, height: 600, minWidth: 100, minHeight: 100, maxWidth: 9999, maxHeight: 9999, pixelRatio: 1, autoSize: !0, autoHeight: !1, autoWidth: !1, autoResize: !0, autoCenter: !s, fitToView: !0, aspectRatio: !1, topRatio: 0.5, leftRatio: 0.5, scrolling: "auto", wrapCSS: "", arrows: !0, closeBtn: !0, closeClick: !1, nextClick: !1, mouseWheel: !0, autoPlay: !1, playSpeed: 3E3, preload: 3, modal: !1, loop: !0, ajax: { dataType: "html", headers: { "X-fancyBox": !0 } }, iframe: { scrolling: "auto", preload: !0 }, swf: { wmode: "transparent", allowfullscreen: "true", allowscriptaccess: "always" },
            keys: { next: { 13: "left", 34: "up", 39: "left", 40: "up" }, prev: { 8: "right", 33: "down", 37: "right", 38: "down" }, close: [27], play: [32], toggle: [70] }, direction: { next: "left", prev: "right" }, scrollOutside: !0, index: 0, type: null, href: null, content: null, title: null, tpl: { wrap: '<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>', image: '<img class="fancybox-image" src="{href}" alt="" />', iframe: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen' + (I ? ' allowtransparency="true"' : "") + "></iframe>", error: '<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>', closeBtn: '<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>', next: '<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>', prev: '<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>' }, openEffect: "fade", openSpeed: 250, openEasing: "swing", openOpacity: !0,
            openMethod: "zoomIn", closeEffect: "fade", closeSpeed: 250, closeEasing: "swing", closeOpacity: !0, closeMethod: "zoomOut", nextEffect: "elastic", nextSpeed: 250, nextEasing: "swing", nextMethod: "changeIn", prevEffect: "elastic", prevSpeed: 250, prevEasing: "swing", prevMethod: "changeOut", helpers: { overlay: !0, title: !0 }, onCancel: f.noop, beforeLoad: f.noop, afterLoad: f.noop, beforeShow: f.noop, afterShow: f.noop, beforeChange: f.noop, beforeClose: f.noop, afterClose: f.noop }, group: {}, opts: {}, previous: null, coming: null, current: null, isActive: !1,
        isOpen: !1, isOpened: !1, wrap: null, skin: null, outer: null, inner: null, player: { timer: null, isActive: !1 }, ajaxLoad: null, imgPreload: null, transitions: {}, helpers: {}, open: function open(a, d) {
            if (a && (f.isPlainObject(d) || (d = {}), !1 !== b.close(!0))) return f.isArray(a) || (a = t(a) ? f(a).get() : [a]), f.each(a, function (e, c) {
                var k = {},
                    g,
                    h,
                    j,
                    m,
                    l;"object" === f.type(c) && (c.nodeType && (c = f(c)), t(c) ? (k = { href: c.data("fancybox-href") || c.attr("href"), title: c.data("fancybox-title") || c.attr("title"), isDom: !0, element: c }, f.metadata && f.extend(!0, k, c.metadata())) : k = c);g = d.href || k.href || (q(c) ? c : null);h = d.title !== v ? d.title : k.title || "";m = (j = d.content || k.content) ? "html" : d.type || k.type;!m && k.isDom && (m = c.data("fancybox-type"), m || (m = (m = c.prop("class").match(/fancybox\.(\w+)/)) ? m[1] : null));q(g) && (m || (b.isImage(g) ? m = "image" : b.isSWF(g) ? m = "swf" : "#" === g.charAt(0) ? m = "inline" : q(c) && (m = "html", j = c)), "ajax" === m && (l = g.split(/\s+/, 2), g = l.shift(), l = l.shift()));j || ("inline" === m ? g ? j = f(q(g) ? g.replace(/.*(?=#[^\s]+$)/, "") : g) : k.isDom && (j = c) : "html" === m ? j = g : !m && !g && k.isDom && (m = "inline", j = c));f.extend(k, { href: g, type: m, content: j, title: h, selector: l });a[e] = k;
            }), b.opts = f.extend(!0, {}, b.defaults, d), d.keys !== v && (b.opts.keys = d.keys ? f.extend({}, b.defaults.keys, d.keys) : !1), b.group = a, b._start(b.opts.index);
        }, cancel: function cancel() {
            var a = b.coming;a && !1 !== b.trigger("onCancel") && (b.hideLoading(), b.ajaxLoad && b.ajaxLoad.abort(), b.ajaxLoad = null, b.imgPreload && (b.imgPreload.onload = b.imgPreload.onerror = null), a.wrap && a.wrap.stop(!0, !0).trigger("onReset").remove(), b.coming = null, b.current || b._afterZoomOut(a));
        }, close: function close(a) {
            b.cancel();!1 !== b.trigger("beforeClose") && (b.unbindEvents(), b.isActive && (!b.isOpen || !0 === a ? (f(".fancybox-wrap").stop(!0).trigger("onReset").remove(), b._afterZoomOut()) : (b.isOpen = b.isOpened = !1, b.isClosing = !0, f(".fancybox-item, .fancybox-nav").remove(), b.wrap.stop(!0, !0).removeClass("fancybox-opened"), b.transitions[b.current.closeMethod]())));
        }, play: function play(a) {
            var d = function d() {
                clearTimeout(b.player.timer);
            },
                e = function e() {
                d();b.current && b.player.isActive && (b.player.timer = setTimeout(b.next, b.current.playSpeed));
            },
                c = function c() {
                d();p.unbind(".player");b.player.isActive = !1;b.trigger("onPlayEnd");
            };if (!0 === a || !b.player.isActive && !1 !== a) {
                if (b.current && (b.current.loop || b.current.index < b.group.length - 1)) b.player.isActive = !0, p.bind({ "onCancel.player beforeClose.player": c, "onUpdate.player": e, "beforeLoad.player": d }), e(), b.trigger("onPlayStart");
            } else c();
        }, next: function next(a) {
            var d = b.current;d && (q(a) || (a = d.direction.next), b.jumpto(d.index + 1, a, "next"));
        }, prev: function prev(a) {
            var d = b.current;
            d && (q(a) || (a = d.direction.prev), b.jumpto(d.index - 1, a, "prev"));
        }, jumpto: function jumpto(a, d, e) {
            var c = b.current;c && (a = l(a), b.direction = d || c.direction[a >= c.index ? "next" : "prev"], b.router = e || "jumpto", c.loop && (0 > a && (a = c.group.length + a % c.group.length), a %= c.group.length), c.group[a] !== v && (b.cancel(), b._start(a)));
        }, reposition: function reposition(a, d) {
            var e = b.current,
                c = e ? e.wrap : null,
                k;c && (k = b._getPosition(d), a && "scroll" === a.type ? (delete k.position, c.stop(!0, !0).animate(k, 200)) : (c.css(k), e.pos = f.extend({}, e.dim, k)));
        }, update: function update(a) {
            var d = a && a.type,
                e = !d || "orientationchange" === d;e && (clearTimeout(B), B = null);b.isOpen && !B && (B = setTimeout(function () {
                var c = b.current;c && !b.isClosing && (b.wrap.removeClass("fancybox-tmp"), (e || "load" === d || "resize" === d && c.autoResize) && b._setDimension(), "scroll" === d && c.canShrink || b.reposition(a), b.trigger("onUpdate"), B = null);
            }, e && !s ? 0 : 300));
        }, toggle: function toggle(a) {
            b.isOpen && (b.current.fitToView = "boolean" === f.type(a) ? a : !b.current.fitToView, s && (b.wrap.removeAttr("style").addClass("fancybox-tmp"), b.trigger("onUpdate")), b.update());
        }, hideLoading: function hideLoading() {
            p.unbind(".loading");f("#fancybox-loading").remove();
        }, showLoading: function showLoading() {
            var a, d;b.hideLoading();a = f('<div id="fancybox-loading"><div></div></div>').click(b.cancel).appendTo("body");p.bind("keydown.loading", function (a) {
                if (27 === (a.which || a.keyCode)) a.preventDefault(), b.cancel();
            });b.defaults.fixed || (d = b.getViewport(), a.css({ position: "absolute", top: 0.5 * d.h + d.y, left: 0.5 * d.w + d.x }));
        }, getViewport: function getViewport() {
            var a = b.current && b.current.locked || !1,
                d = { x: n.scrollLeft(),
                y: n.scrollTop() };a ? (d.w = a[0].clientWidth, d.h = a[0].clientHeight) : (d.w = s && r.innerWidth ? r.innerWidth : n.width(), d.h = s && r.innerHeight ? r.innerHeight : n.height());return d;
        }, unbindEvents: function unbindEvents() {
            b.wrap && t(b.wrap) && b.wrap.unbind(".fb");p.unbind(".fb");n.unbind(".fb");
        }, bindEvents: function bindEvents() {
            var a = b.current,
                d;a && (n.bind("orientationchange.fb" + (s ? "" : " resize.fb") + (a.autoCenter && !a.locked ? " scroll.fb" : ""), b.update), (d = a.keys) && p.bind("keydown.fb", function (e) {
                var c = e.which || e.keyCode,
                    k = e.target || e.srcElement;
                if (27 === c && b.coming) return !1;!e.ctrlKey && !e.altKey && !e.shiftKey && !e.metaKey && (!k || !k.type && !f(k).is("[contenteditable]")) && f.each(d, function (d, k) {
                    if (1 < a.group.length && k[c] !== v) return b[d](k[c]), e.preventDefault(), !1;if (-1 < f.inArray(c, k)) return b[d](), e.preventDefault(), !1;
                });
            }), f.fn.mousewheel && a.mouseWheel && b.wrap.bind("mousewheel.fb", function (d, c, k, g) {
                for (var h = f(d.target || null), j = !1; h.length && !j && !h.is(".fancybox-skin") && !h.is(".fancybox-wrap");) {
                    j = h[0] && !(h[0].style.overflow && "hidden" === h[0].style.overflow) && (h[0].clientWidth && h[0].scrollWidth > h[0].clientWidth || h[0].clientHeight && h[0].scrollHeight > h[0].clientHeight), h = f(h).parent();
                }if (0 !== c && !j && 1 < b.group.length && !a.canShrink) {
                    if (0 < g || 0 < k) b.prev(0 < g ? "down" : "left");else if (0 > g || 0 > k) b.next(0 > g ? "up" : "right");d.preventDefault();
                }
            }));
        }, trigger: function trigger(a, d) {
            var e,
                c = d || b.coming || b.current;if (c) {
                f.isFunction(c[a]) && (e = c[a].apply(c, Array.prototype.slice.call(arguments, 1)));if (!1 === e) return !1;c.helpers && f.each(c.helpers, function (d, e) {
                    if (e && b.helpers[d] && f.isFunction(b.helpers[d][a])) b.helpers[d][a](f.extend(!0, {}, b.helpers[d].defaults, e), c);
                });p.trigger(a);
            }
        }, isImage: function isImage(a) {
            return q(a) && a.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i);
        }, isSWF: function isSWF(a) {
            return q(a) && a.match(/\.(swf)((\?|#).*)?$/i);
        }, _start: function _start(a) {
            var d = {},
                e,
                c;a = l(a);e = b.group[a] || null;if (!e) return !1;d = f.extend(!0, {}, b.opts, e);e = d.margin;c = d.padding;"number" === f.type(e) && (d.margin = [e, e, e, e]);"number" === f.type(c) && (d.padding = [c, c, c, c]);d.modal && f.extend(!0, d, { closeBtn: !1, closeClick: !1, nextClick: !1, arrows: !1,
                mouseWheel: !1, keys: null, helpers: { overlay: { closeClick: !1 } } });d.autoSize && (d.autoWidth = d.autoHeight = !0);"auto" === d.width && (d.autoWidth = !0);"auto" === d.height && (d.autoHeight = !0);d.group = b.group;d.index = a;b.coming = d;if (!1 === b.trigger("beforeLoad")) b.coming = null;else {
                c = d.type;e = d.href;if (!c) return b.coming = null, b.current && b.router && "jumpto" !== b.router ? (b.current.index = a, b[b.router](b.direction)) : !1;b.isActive = !0;if ("image" === c || "swf" === c) d.autoHeight = d.autoWidth = !1, d.scrolling = "visible";"image" === c && (d.aspectRatio = !0);"iframe" === c && s && (d.scrolling = "scroll");d.wrap = f(d.tpl.wrap).addClass("fancybox-" + (s ? "mobile" : "desktop") + " fancybox-type-" + c + " fancybox-tmp " + d.wrapCSS).appendTo(d.parent || "body");f.extend(d, { skin: f(".fancybox-skin", d.wrap), outer: f(".fancybox-outer", d.wrap), inner: f(".fancybox-inner", d.wrap) });f.each(["Top", "Right", "Bottom", "Left"], function (a, b) {
                    d.skin.css("padding" + b, w(d.padding[a]));
                });b.trigger("onReady");if ("inline" === c || "html" === c) {
                    if (!d.content || !d.content.length) return b._error("content");
                } else if (!e) return b._error("href");
                "image" === c ? b._loadImage() : "ajax" === c ? b._loadAjax() : "iframe" === c ? b._loadIframe() : b._afterLoad();
            }
        }, _error: function _error(a) {
            f.extend(b.coming, { type: "html", autoWidth: !0, autoHeight: !0, minWidth: 0, minHeight: 0, scrolling: "no", hasError: a, content: b.coming.tpl.error });b._afterLoad();
        }, _loadImage: function _loadImage() {
            var a = b.imgPreload = new Image();a.onload = function () {
                this.onload = this.onerror = null;b.coming.width = this.width / b.opts.pixelRatio;b.coming.height = this.height / b.opts.pixelRatio;b._afterLoad();
            };a.onerror = function () {
                this.onload = this.onerror = null;b._error("image");
            };a.src = b.coming.href;!0 !== a.complete && b.showLoading();
        }, _loadAjax: function _loadAjax() {
            var a = b.coming;b.showLoading();b.ajaxLoad = f.ajax(f.extend({}, a.ajax, { url: a.href, error: function error(a, e) {
                    b.coming && "abort" !== e ? b._error("ajax", a) : b.hideLoading();
                }, success: function success(d, e) {
                    "success" === e && (a.content = d, b._afterLoad());
                } }));
        }, _loadIframe: function _loadIframe() {
            var a = b.coming,
                d = f(a.tpl.iframe.replace(/\{rnd\}/g, new Date().getTime())).attr("scrolling", s ? "auto" : a.iframe.scrolling).attr("src", a.href);
            f(a.wrap).bind("onReset", function () {
                try {
                    f(this).find("iframe").hide().attr("src", "//about:blank").end().empty();
                } catch (a) {}
            });a.iframe.preload && (b.showLoading(), d.one("load", function () {
                f(this).data("ready", 1);s || f(this).bind("load.fb", b.update);f(this).parents(".fancybox-wrap").width("100%").removeClass("fancybox-tmp").show();b._afterLoad();
            }));a.content = d.appendTo(a.inner);a.iframe.preload || b._afterLoad();
        }, _preloadImages: function _preloadImages() {
            var a = b.group,
                d = b.current,
                e = a.length,
                c = d.preload ? Math.min(d.preload, e - 1) : 0,
                f,
                g;for (g = 1; g <= c; g += 1) {
                f = a[(d.index + g) % e], "image" === f.type && f.href && (new Image().src = f.href);
            }
        }, _afterLoad: function _afterLoad() {
            var a = b.coming,
                d = b.current,
                e,
                c,
                k,
                g,
                h;b.hideLoading();if (a && !1 !== b.isActive) if (!1 === b.trigger("afterLoad", a, d)) a.wrap.stop(!0).trigger("onReset").remove(), b.coming = null;else {
                d && (b.trigger("beforeChange", d), d.wrap.stop(!0).removeClass("fancybox-opened").find(".fancybox-item, .fancybox-nav").remove());b.unbindEvents();e = a.content;c = a.type;k = a.scrolling;f.extend(b, { wrap: a.wrap, skin: a.skin,
                    outer: a.outer, inner: a.inner, current: a, previous: d });g = a.href;switch (c) {case "inline":case "ajax":case "html":
                        a.selector ? e = f("<div>").html(e).find(a.selector) : t(e) && (e.data("fancybox-placeholder") || e.data("fancybox-placeholder", f('<div class="fancybox-placeholder"></div>').insertAfter(e).hide()), e = e.show().detach(), a.wrap.bind("onReset", function () {
                            f(this).find(e).length && e.hide().replaceAll(e.data("fancybox-placeholder")).data("fancybox-placeholder", !1);
                        }));break;case "image":
                        e = a.tpl.image.replace("{href}", g);break;case "swf":
                        e = '<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="' + g + '"></param>', h = "", f.each(a.swf, function (a, b) {
                            e += '<param name="' + a + '" value="' + b + '"></param>';h += " " + a + '="' + b + '"';
                        }), e += '<embed src="' + g + '" type="application/x-shockwave-flash" width="100%" height="100%"' + h + "></embed></object>";}(!t(e) || !e.parent().is(a.inner)) && a.inner.append(e);b.trigger("beforeShow");a.inner.css("overflow", "yes" === k ? "scroll" : "no" === k ? "hidden" : k);b._setDimension();b.reposition();b.isOpen = !1;b.coming = null;b.bindEvents();if (b.isOpened) {
                    if (d.prevMethod) b.transitions[d.prevMethod]();
                } else f(".fancybox-wrap").not(a.wrap).stop(!0).trigger("onReset").remove();b.transitions[b.isOpened ? a.nextMethod : a.openMethod]();b._preloadImages();
            }
        }, _setDimension: function _setDimension() {
            var a = b.getViewport(),
                d = 0,
                e = !1,
                c = !1,
                e = b.wrap,
                k = b.skin,
                g = b.inner,
                h = b.current,
                c = h.width,
                j = h.height,
                m = h.minWidth,
                u = h.minHeight,
                n = h.maxWidth,
                p = h.maxHeight,
                s = h.scrolling,
                q = h.scrollOutside ? h.scrollbarWidth : 0,
                x = h.margin,
                y = l(x[1] + x[3]),
                r = l(x[0] + x[2]),
                v,
                z,
                t,
                C,
                A,
                F,
                B,
                D,
                H;e.add(k).add(g).width("auto").height("auto").removeClass("fancybox-tmp");x = l(k.outerWidth(!0) - k.width());v = l(k.outerHeight(!0) - k.height());z = y + x;t = r + v;C = E(c) ? (a.w - z) * l(c) / 100 : c;A = E(j) ? (a.h - t) * l(j) / 100 : j;if ("iframe" === h.type) {
                if (H = h.content, h.autoHeight && 1 === H.data("ready")) try {
                    H[0].contentWindow.document.location && (g.width(C).height(9999), F = H.contents().find("body"), q && F.css("overflow-x", "hidden"), A = F.outerHeight(!0));
                } catch (G) {}
            } else if (h.autoWidth || h.autoHeight) g.addClass("fancybox-tmp"), h.autoWidth || g.width(C), h.autoHeight || g.height(A), h.autoWidth && (C = g.width()), h.autoHeight && (A = g.height()), g.removeClass("fancybox-tmp");c = l(C);j = l(A);D = C / A;m = l(E(m) ? l(m, "w") - z : m);n = l(E(n) ? l(n, "w") - z : n);u = l(E(u) ? l(u, "h") - t : u);p = l(E(p) ? l(p, "h") - t : p);F = n;B = p;h.fitToView && (n = Math.min(a.w - z, n), p = Math.min(a.h - t, p));z = a.w - y;r = a.h - r;h.aspectRatio ? (c > n && (c = n, j = l(c / D)), j > p && (j = p, c = l(j * D)), c < m && (c = m, j = l(c / D)), j < u && (j = u, c = l(j * D))) : (c = Math.max(m, Math.min(c, n)), h.autoHeight && "iframe" !== h.type && (g.width(c), j = g.height()), j = Math.max(u, Math.min(j, p)));if (h.fitToView) if (g.width(c).height(j), e.width(c + x), a = e.width(), y = e.height(), h.aspectRatio) for (; (a > z || y > r) && c > m && j > u && !(19 < d++);) {
                j = Math.max(u, Math.min(p, j - 10)), c = l(j * D), c < m && (c = m, j = l(c / D)), c > n && (c = n, j = l(c / D)), g.width(c).height(j), e.width(c + x), a = e.width(), y = e.height();
            } else c = Math.max(m, Math.min(c, c - (a - z))), j = Math.max(u, Math.min(j, j - (y - r)));q && "auto" === s && j < A && c + x + q < z && (c += q);g.width(c).height(j);e.width(c + x);a = e.width();
            y = e.height();e = (a > z || y > r) && c > m && j > u;c = h.aspectRatio ? c < F && j < B && c < C && j < A : (c < F || j < B) && (c < C || j < A);f.extend(h, { dim: { width: w(a), height: w(y) }, origWidth: C, origHeight: A, canShrink: e, canExpand: c, wPadding: x, hPadding: v, wrapSpace: y - k.outerHeight(!0), skinSpace: k.height() - j });!H && h.autoHeight && j > u && j < p && !c && g.height("auto");
        }, _getPosition: function _getPosition(a) {
            var d = b.current,
                e = b.getViewport(),
                c = d.margin,
                f = b.wrap.width() + c[1] + c[3],
                g = b.wrap.height() + c[0] + c[2],
                c = { position: "absolute", top: c[0], left: c[3] };d.autoCenter && d.fixed && !a && g <= e.h && f <= e.w ? c.position = "fixed" : d.locked || (c.top += e.y, c.left += e.x);c.top = w(Math.max(c.top, c.top + (e.h - g) * d.topRatio));c.left = w(Math.max(c.left, c.left + (e.w - f) * d.leftRatio));return c;
        }, _afterZoomIn: function _afterZoomIn() {
            var a = b.current;a && (b.isOpen = b.isOpened = !0, b.wrap.css("overflow", "visible").addClass("fancybox-opened"), b.update(), (a.closeClick || a.nextClick && 1 < b.group.length) && b.inner.css("cursor", "pointer").bind("click.fb", function (d) {
                !f(d.target).is("a") && !f(d.target).parent().is("a") && (d.preventDefault(), b[a.closeClick ? "close" : "next"]());
            }), a.closeBtn && f(a.tpl.closeBtn).appendTo(b.skin).bind("click.fb", function (a) {
                a.preventDefault();b.close();
            }), a.arrows && 1 < b.group.length && ((a.loop || 0 < a.index) && f(a.tpl.prev).appendTo(b.outer).bind("click.fb", b.prev), (a.loop || a.index < b.group.length - 1) && f(a.tpl.next).appendTo(b.outer).bind("click.fb", b.next)), b.trigger("afterShow"), !a.loop && a.index === a.group.length - 1 ? b.play(!1) : b.opts.autoPlay && !b.player.isActive && (b.opts.autoPlay = !1, b.play()));
        }, _afterZoomOut: function _afterZoomOut(a) {
            a = a || b.current;f(".fancybox-wrap").trigger("onReset").remove();f.extend(b, { group: {}, opts: {}, router: !1, current: null, isActive: !1, isOpened: !1, isOpen: !1, isClosing: !1, wrap: null, skin: null, outer: null, inner: null });b.trigger("afterClose", a);
        } });b.transitions = { getOrigPosition: function getOrigPosition() {
            var a = b.current,
                d = a.element,
                e = a.orig,
                c = {},
                f = 50,
                g = 50,
                h = a.hPadding,
                j = a.wPadding,
                m = b.getViewport();!e && a.isDom && d.is(":visible") && (e = d.find("img:first"), e.length || (e = d));t(e) ? (c = e.offset(), e.is("img") && (f = e.outerWidth(), g = e.outerHeight())) : (c.top = m.y + (m.h - g) * a.topRatio, c.left = m.x + (m.w - f) * a.leftRatio);if ("fixed" === b.wrap.css("position") || a.locked) c.top -= m.y, c.left -= m.x;return c = { top: w(c.top - h * a.topRatio), left: w(c.left - j * a.leftRatio), width: w(f + j), height: w(g + h) };
        }, step: function step(a, d) {
            var e,
                c,
                f = d.prop;c = b.current;var g = c.wrapSpace,
                h = c.skinSpace;if ("width" === f || "height" === f) e = d.end === d.start ? 1 : (a - d.start) / (d.end - d.start), b.isClosing && (e = 1 - e), c = "width" === f ? c.wPadding : c.hPadding, c = a - c, b.skin[f](l("width" === f ? c : c - g * e)), b.inner[f](l("width" === f ? c : c - g * e - h * e));
        }, zoomIn: function zoomIn() {
            var a = b.current,
                d = a.pos,
                e = a.openEffect,
                c = "elastic" === e,
                k = f.extend({ opacity: 1 }, d);delete k.position;c ? (d = this.getOrigPosition(), a.openOpacity && (d.opacity = 0.1)) : "fade" === e && (d.opacity = 0.1);b.wrap.css(d).animate(k, { duration: "none" === e ? 0 : a.openSpeed, easing: a.openEasing, step: c ? this.step : null, complete: b._afterZoomIn });
        }, zoomOut: function zoomOut() {
            var a = b.current,
                d = a.closeEffect,
                e = "elastic" === d,
                c = { opacity: 0.1 };e && (c = this.getOrigPosition(), a.closeOpacity && (c.opacity = 0.1));b.wrap.animate(c, { duration: "none" === d ? 0 : a.closeSpeed, easing: a.closeEasing, step: e ? this.step : null, complete: b._afterZoomOut });
        }, changeIn: function changeIn() {
            var a = b.current,
                d = a.nextEffect,
                e = a.pos,
                c = { opacity: 1 },
                f = b.direction,
                g;e.opacity = 0.1;"elastic" === d && (g = "down" === f || "up" === f ? "top" : "left", "down" === f || "right" === f ? (e[g] = w(l(e[g]) - 200), c[g] = "+=200px") : (e[g] = w(l(e[g]) + 200), c[g] = "-=200px"));"none" === d ? b._afterZoomIn() : b.wrap.css(e).animate(c, { duration: a.nextSpeed, easing: a.nextEasing, complete: b._afterZoomIn });
        }, changeOut: function changeOut() {
            var a = b.previous,
                d = a.prevEffect,
                e = { opacity: 0.1 },
                c = b.direction;"elastic" === d && (e["down" === c || "up" === c ? "top" : "left"] = ("up" === c || "left" === c ? "-" : "+") + "=200px");a.wrap.animate(e, { duration: "none" === d ? 0 : a.prevSpeed, easing: a.prevEasing, complete: function complete() {
                    f(this).trigger("onReset").remove();
                } });
        } };b.helpers.overlay = { defaults: { closeClick: !0, speedOut: 200, showEarly: !0, css: {}, locked: !s, fixed: !0 }, overlay: null, fixed: !1, el: f("html"), create: function create(a) {
            a = f.extend({}, this.defaults, a);this.overlay && this.close();this.overlay = f('<div class="fancybox-overlay"></div>').appendTo(b.coming ? b.coming.parent : a.parent);
            this.fixed = !1;a.fixed && b.defaults.fixed && (this.overlay.addClass("fancybox-overlay-fixed"), this.fixed = !0);
        }, open: function open(a) {
            var d = this;
            a = f.extend({}, this.defaults, a);
            this.overlay ? this.overlay.unbind(".overlay").width("auto").height("auto") : this.create(a);f("#form1").addClass('blur');this.fixed || (n.bind("resize.overlay", f.proxy(this.update, this)), this.update());
            a.closeClick && this.overlay.bind("click.overlay", function (a) {
                if (f(a.target).hasClass("fancybox-overlay")) return b.isActive ? b.close() : d.close(), !1;
            });this.overlay.css(a.css).show();
        },
        close: function close() {
            f("#form1").removeClass('blur');console.log('now');var a, b;n.unbind("resize.overlay");this.el.hasClass("fancybox-lock") && (f(".fancybox-margin").removeClass("fancybox-margin"), a = n.scrollTop(), b = n.scrollLeft(), this.el.removeClass("fancybox-lock"), n.scrollTop(a).scrollLeft(b));f(".fancybox-overlay").remove().hide();f.extend(this, { overlay: null, fixed: !1 });
        }, update: function update() {
            var a = "100%",
                b;this.overlay.width(a).height("100%");I ? (b = Math.max(G.documentElement.offsetWidth, G.body.offsetWidth), p.width() > b && (a = p.width())) : p.width() > n.width() && (a = p.width());this.overlay.width(a).height(p.height());
        }, onReady: function onReady(a, b) {
            var e = this.overlay;f(".fancybox-overlay").stop(!0, !0);e || this.create(a);a.locked && this.fixed && b.fixed && (e || (this.margin = p.height() > n.height() ? f("html").css("margin-right").replace("px", "") : !1), b.locked = this.overlay.append(b.wrap), b.fixed = !1);!0 === a.showEarly && this.beforeShow.apply(this, arguments);
        }, beforeShow: function beforeShow(a, b) {
            var e, c;b.locked && (!1 !== this.margin && (f("*").filter(function () {
                return "fixed" === f(this).css("position") && !f(this).hasClass("fancybox-overlay") && !f(this).hasClass("fancybox-wrap");
            }).addClass("fancybox-margin"), this.el.addClass("fancybox-margin")), e = n.scrollTop(), c = n.scrollLeft(), this.el.addClass("fancybox-lock"), n.scrollTop(e).scrollLeft(c));this.open(a);
        }, onUpdate: function onUpdate() {
            this.fixed || this.update();
        }, afterClose: function afterClose(a) {
            this.overlay && !b.coming && this.overlay.fadeOut(a.speedOut, f.proxy(this.close, this));
        } };b.helpers.title = { defaults: { type: "float", position: "bottom" }, beforeShow: function beforeShow(a) {
            var d = b.current,
                e = d.title,
                c = a.type;f.isFunction(e) && (e = e.call(d.element, d));if (q(e) && "" !== f.trim(e)) {
                d = f('<div class="fancybox-title fancybox-title-' + c + '-wrap">' + e + "</div>");switch (c) {case "inside":
                        c = b.skin;break;case "outside":
                        c = b.wrap;break;case "over":
                        c = b.inner;break;default:
                        c = b.skin, d.appendTo("body"), I && d.width(d.width()), d.wrapInner('<span class="child"></span>'), b.current.margin[2] += Math.abs(l(d.css("margin-bottom")));}d["top" === a.position ? "prependTo" : "appendTo"](c);
            }
        } };f.fn.fancybox = function (a) {
        var d,
            e = f(this),
            c = this.selector || "",
            k = function k(g) {
            var h = f(this).blur(),
                j = d,
                k,
                l;!g.ctrlKey && !g.altKey && !g.shiftKey && !g.metaKey && !h.is(".fancybox-wrap") && (k = a.groupAttr || "data-fancybox-group", l = h.attr(k), l || (k = "rel", l = h.get(0)[k]), l && "" !== l && "nofollow" !== l && (h = c.length ? f(c) : e, h = h.filter("[" + k + '="' + l + '"]'), j = h.index(this)), a.index = j, !1 !== b.open(h, a) && g.preventDefault());
        };a = a || {};d = a.index || 0;!c || !1 === a.live ? e.unbind("click.fb-start").bind("click.fb-start", k) : p.undelegate(c, "click.fb-start").delegate(c + ":not('.fancybox-item, .fancybox-nav')", "click.fb-start", k);this.filter("[data-fancybox-start=1]").trigger("click");return this;
    };p.ready(function () {
        var a, d;f.scrollbarWidth === v && (f.scrollbarWidth = function () {
            var a = f('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo("body"),
                b = a.children(),
                b = b.innerWidth() - b.height(99).innerWidth();a.remove();return b;
        });if (f.support.fixedPosition === v) {
            a = f.support;d = f('<div style="position:fixed;top:20px;"></div>').appendTo("body");var e = 20 === d[0].offsetTop || 15 === d[0].offsetTop;d.remove();a.fixedPosition = e;
        }f.extend(b.defaults, { scrollbarWidth: f.scrollbarWidth(), fixed: f.support.fixedPosition, parent: f("body") });a = f(r).width();J.addClass("fancybox-lock-test");d = f(r).width();J.removeClass("fancybox-lock-test");f("<style type='text/css'>.fancybox-margin{margin-right:" + (d - a) + "px;}</style>").appendTo("head");
    });
})(window, document, __WEBPACK_IMPORTED_MODULE_0_jquery___default.a);

/***/ }),
/* 125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 126 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
var document = __webpack_require__(8).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var core = __webpack_require__(44);
var LIBRARY = __webpack_require__(62);
var wksExt = __webpack_require__(169);
var defineProperty = __webpack_require__(20).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(91)('keys');
var uid = __webpack_require__(69);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 130 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(8).document;
module.exports = document && document.documentElement;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(11);
var anObject = __webpack_require__(7);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(45)(Function.call, __webpack_require__(39).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
var setPrototypeOf = __webpack_require__(132).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(47);
var defined = __webpack_require__(51);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 136 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 137 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(62);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(33);
var hide = __webpack_require__(32);
var Iterators = __webpack_require__(85);
var $iterCreate = __webpack_require__(139);
var setToStringTag = __webpack_require__(82);
var getPrototypeOf = __webpack_require__(40);
var ITERATOR = __webpack_require__(15)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(72);
var descriptor = __webpack_require__(68);
var setToStringTag = __webpack_require__(82);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(32)(IteratorPrototype, __webpack_require__(15)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(104);
var defined = __webpack_require__(51);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(15)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(85);
var ITERATOR = __webpack_require__(15)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(20);
var createDesc = __webpack_require__(68);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(83);
var ITERATOR = __webpack_require__(15)('iterator');
var Iterators = __webpack_require__(85);
module.exports = __webpack_require__(44).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(434);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(22);
var toAbsoluteIndex = __webpack_require__(71);
var toLength = __webpack_require__(16);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(64);
var step = __webpack_require__(186);
var Iterators = __webpack_require__(85);
var toIObject = __webpack_require__(38);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(138)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(94);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(103)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(45);
var invoke = __webpack_require__(176);
var html = __webpack_require__(131);
var cel = __webpack_require__(127);
var global = __webpack_require__(8);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(46)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var macrotask = __webpack_require__(150).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(46)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(29);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(8);
var DESCRIPTORS = __webpack_require__(18);
var LIBRARY = __webpack_require__(62);
var $typed = __webpack_require__(110);
var hide = __webpack_require__(32);
var redefineAll = __webpack_require__(77);
var fails = __webpack_require__(10);
var anInstance = __webpack_require__(75);
var toInteger = __webpack_require__(47);
var toLength = __webpack_require__(16);
var toIndex = __webpack_require__(196);
var gOPN = __webpack_require__(73).f;
var dP = __webpack_require__(20).f;
var arrayFill = __webpack_require__(146);
var setToStringTag = __webpack_require__(82);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(41);
var normalizeHeaderName = __webpack_require__(571);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(212);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(212);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(126)))

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var cart = {
    getItems: function getItems() {
        var cart = JSON.parse(localStorage.getItem('cart'));
        if (cart == null) {
            cart = [];
        }
        return cart;
    },
    getItemsCount: function getItemsCount() {
        var count = 0;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = this.getItems()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                count += item.Count;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return count;
    },
    addItem: function addItem(rewardId, priceId, rewardType, price, addressId) {
        //console.info('[rewardId, priceId, rewardType, addressId]', [rewardId, priceId, rewardType, addressId])
        var cart = this.getItems();
        // let item = cart.find(x => {
        //     return x.Id === rewardId && x.PriceId === priceId;
        // });
        // if (item === undefined || rewardType === 1 || rewardType === 2) {
        //     cart.push({Id: rewardId, PriceId: priceId, Count: 1});
        // } else {
        //     item.Count += 1;
        // }
        cart.push({ Id: rewardId, PriceId: priceId, Count: 1, Price: price, AddressId: addressId });

        this.saveCart(cart);
    },
    removeItem: function removeItem(id) {
        var cart = this.getItems();

        for (var i = 0; i < cart.length; i++) {
            if (cart[i].Id === id) {
                cart.splice(i, 1);
                break;
            }
        }

        this.saveCart(cart);
    },
    updateItemCount: function updateItemCount(cartItem) {
        var cart = this.getItems();

        var item = cart.find(function (x) {
            return x.Id === cartItem.Id && x.PriceId === cartItem.PriceId;
        });
        if (item !== undefined) {
            item.Count = cartItem.Count;
            this.saveCart(cart);
        }
    },
    saveCart: function saveCart(cart) {
        localStorage.setItem('cart', JSON.stringify(cart));
    }
};

/* harmony default export */ __webpack_exports__["a"] = (cart);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = prepareConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = createLocalOrUTC;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_is_array__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_is_object__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_is_object_empty__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_is_undefined__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_is_number__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_is_date__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_map__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__valid__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__moment_constructor__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locale_locales__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_hooks__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__check_overflow__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__from_string_and_array__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__from_string_and_format__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__from_string__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__from_array__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__from_object__ = __webpack_require__(595);




















function createFromConfig(config) {
    var res = new __WEBPACK_IMPORTED_MODULE_8__moment_constructor__["a" /* Moment */](Object(__WEBPACK_IMPORTED_MODULE_11__check_overflow__["a" /* default */])(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig(config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || Object(__WEBPACK_IMPORTED_MODULE_9__locale_locales__["b" /* getLocale */])(config._l);

    if (input === null || (format === undefined && input === '')) {
        return Object(__WEBPACK_IMPORTED_MODULE_7__valid__["a" /* createInvalid */])({ nullInput: true });
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_8__moment_constructor__["c" /* isMoment */])(input)) {
        return new __WEBPACK_IMPORTED_MODULE_8__moment_constructor__["a" /* Moment */](Object(__WEBPACK_IMPORTED_MODULE_11__check_overflow__["a" /* default */])(input));
    } else if (Object(__WEBPACK_IMPORTED_MODULE_5__utils_is_date__["a" /* default */])(input)) {
        config._d = input;
    } else if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_is_array__["a" /* default */])(format)) {
        Object(__WEBPACK_IMPORTED_MODULE_12__from_string_and_array__["a" /* configFromStringAndArray */])(config);
    } else if (format) {
        Object(__WEBPACK_IMPORTED_MODULE_13__from_string_and_format__["a" /* configFromStringAndFormat */])(config);
    } else {
        configFromInput(config);
    }

    if (!Object(__WEBPACK_IMPORTED_MODULE_7__valid__["b" /* isValid */])(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_is_undefined__["a" /* default */])(input)) {
        config._d = new Date(__WEBPACK_IMPORTED_MODULE_10__utils_hooks__["a" /* hooks */].now());
    } else if (Object(__WEBPACK_IMPORTED_MODULE_5__utils_is_date__["a" /* default */])(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_14__from_string__["c" /* configFromString */])(config);
    } else if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_is_array__["a" /* default */])(input)) {
        config._a = Object(__WEBPACK_IMPORTED_MODULE_6__utils_map__["a" /* default */])(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        Object(__WEBPACK_IMPORTED_MODULE_15__from_array__["a" /* configFromArray */])(config);
    } else if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_is_object__["a" /* default */])(input)) {
        Object(__WEBPACK_IMPORTED_MODULE_16__from_object__["a" /* configFromObject */])(config);
    } else if (Object(__WEBPACK_IMPORTED_MODULE_4__utils_is_number__["a" /* default */])(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        __WEBPACK_IMPORTED_MODULE_10__utils_hooks__["a" /* hooks */].createFromInputFallback(config);
    }
}

function createLocalOrUTC(input, format, locale, strict, isUTC) {
    var c = {};

    if (format === true || format === false) {
        strict = format;
        format = undefined;
    }

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if (
        (Object(__WEBPACK_IMPORTED_MODULE_1__utils_is_object__["a" /* default */])(input) && Object(__WEBPACK_IMPORTED_MODULE_2__utils_is_object_empty__["a" /* default */])(input)) ||
        (Object(__WEBPACK_IMPORTED_MODULE_0__utils_is_array__["a" /* default */])(input) && input.length === 0)
    ) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isObjectEmpty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__has_own_prop__ = __webpack_require__(26);


function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return Object.getOwnPropertyNames(obj).length === 0;
    } else {
        var k;
        for (k in obj) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__has_own_prop__["a" /* default */])(obj, k)) {
                return false;
            }
        }
        return true;
    }
}


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isLeapYear;
function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return indexOf; });
var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}




/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dayOfYearFromWeeks;
/* harmony export (immutable) */ __webpack_exports__["b"] = weekOfYear;
/* harmony export (immutable) */ __webpack_exports__["c"] = weeksInYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__year__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create_date_from_array__ = __webpack_require__(121);



// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + Object(__WEBPACK_IMPORTED_MODULE_1__create_date_from_array__["b" /* createUTCDate */])(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear,
        resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = Object(__WEBPACK_IMPORTED_MODULE_0__year__["a" /* daysInYear */])(resYear) + dayOfYear;
    } else if (dayOfYear > Object(__WEBPACK_IMPORTED_MODULE_0__year__["a" /* daysInYear */])(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - Object(__WEBPACK_IMPORTED_MODULE_0__year__["a" /* daysInYear */])(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear,
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek,
        resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear,
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (Object(__WEBPACK_IMPORTED_MODULE_0__year__["a" /* daysInYear */])(year) - weekOffset + weekOffsetNext) / 7;
}


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = configFromStringAndFormat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__from_string__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__from_array__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parse_regex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parse_token__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__format_format__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__check_overflow__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__units_constants__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_hooks__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__parsing_flags__ = __webpack_require__(42);










// constant that refers to the ISO standard
__WEBPACK_IMPORTED_MODULE_7__utils_hooks__["a" /* hooks */].ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
__WEBPACK_IMPORTED_MODULE_7__utils_hooks__["a" /* hooks */].RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === __WEBPACK_IMPORTED_MODULE_7__utils_hooks__["a" /* hooks */].ISO_8601) {
        Object(__WEBPACK_IMPORTED_MODULE_0__from_string__["a" /* configFromISO */])(config);
        return;
    }
    if (config._f === __WEBPACK_IMPORTED_MODULE_7__utils_hooks__["a" /* hooks */].RFC_2822) {
        Object(__WEBPACK_IMPORTED_MODULE_0__from_string__["b" /* configFromRFC2822 */])(config);
        return;
    }
    config._a = [];
    Object(__WEBPACK_IMPORTED_MODULE_8__parsing_flags__["a" /* default */])(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i,
        parsedInput,
        tokens,
        token,
        skipped,
        stringLength = string.length,
        totalParsedInputLength = 0,
        era,
        tokenLen;

    tokens =
        Object(__WEBPACK_IMPORTED_MODULE_4__format_format__["b" /* expandFormat */])(config._f, config._locale).match(__WEBPACK_IMPORTED_MODULE_4__format_format__["e" /* formattingTokens */]) || [];
    tokenLen = tokens.length;
    for (i = 0; i < tokenLen; i++) {
        token = tokens[i];
        parsedInput = (string.match(Object(__WEBPACK_IMPORTED_MODULE_2__parse_regex__["b" /* getParseRegexForToken */])(token, config)) ||
            [])[0];
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                Object(__WEBPACK_IMPORTED_MODULE_8__parsing_flags__["a" /* default */])(config).unusedInput.push(skipped);
            }
            string = string.slice(
                string.indexOf(parsedInput) + parsedInput.length
            );
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (__WEBPACK_IMPORTED_MODULE_4__format_format__["d" /* formatTokenFunctions */][token]) {
            if (parsedInput) {
                Object(__WEBPACK_IMPORTED_MODULE_8__parsing_flags__["a" /* default */])(config).empty = false;
            } else {
                Object(__WEBPACK_IMPORTED_MODULE_8__parsing_flags__["a" /* default */])(config).unusedTokens.push(token);
            }
            Object(__WEBPACK_IMPORTED_MODULE_3__parse_token__["b" /* addTimeToArrayFromToken */])(token, parsedInput, config);
        } else if (config._strict && !parsedInput) {
            Object(__WEBPACK_IMPORTED_MODULE_8__parsing_flags__["a" /* default */])(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    Object(__WEBPACK_IMPORTED_MODULE_8__parsing_flags__["a" /* default */])(config).charsLeftOver =
        stringLength - totalParsedInputLength;
    if (string.length > 0) {
        Object(__WEBPACK_IMPORTED_MODULE_8__parsing_flags__["a" /* default */])(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (
        config._a[__WEBPACK_IMPORTED_MODULE_6__units_constants__["b" /* HOUR */]] <= 12 &&
        Object(__WEBPACK_IMPORTED_MODULE_8__parsing_flags__["a" /* default */])(config).bigHour === true &&
        config._a[__WEBPACK_IMPORTED_MODULE_6__units_constants__["b" /* HOUR */]] > 0
    ) {
        Object(__WEBPACK_IMPORTED_MODULE_8__parsing_flags__["a" /* default */])(config).bigHour = undefined;
    }

    Object(__WEBPACK_IMPORTED_MODULE_8__parsing_flags__["a" /* default */])(config).parsedDateParts = config._a.slice(0);
    Object(__WEBPACK_IMPORTED_MODULE_8__parsing_flags__["a" /* default */])(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[__WEBPACK_IMPORTED_MODULE_6__units_constants__["b" /* HOUR */]] = meridiemFixWrap(
        config._locale,
        config._a[__WEBPACK_IMPORTED_MODULE_6__units_constants__["b" /* HOUR */]],
        config._meridiem
    );

    // handle era
    era = Object(__WEBPACK_IMPORTED_MODULE_8__parsing_flags__["a" /* default */])(config).era;
    if (era !== null) {
        config._a[__WEBPACK_IMPORTED_MODULE_6__units_constants__["i" /* YEAR */]] = config._locale.erasConvertYear(era, config._a[__WEBPACK_IMPORTED_MODULE_6__units_constants__["i" /* YEAR */]]);
    }

    Object(__WEBPACK_IMPORTED_MODULE_1__from_array__["a" /* configFromArray */])(config);
    Object(__WEBPACK_IMPORTED_MODULE_5__check_overflow__["a" /* default */])(config);
}

function meridiemFixWrap(locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = configFromArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_hooks__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__date_from_array__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__units_year__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__units_week_calendar_utils__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__units_constants__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__local__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_defaults__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__parsing_flags__ = __webpack_require__(42);









function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(__WEBPACK_IMPORTED_MODULE_0__utils_hooks__["a" /* hooks */].now());
    if (config._useUTC) {
        return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate(),
        ];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray(config) {
    var i,
        date,
        input = [],
        currentDate,
        expectedWeekday,
        yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[__WEBPACK_IMPORTED_MODULE_4__units_constants__["a" /* DATE */]] == null && config._a[__WEBPACK_IMPORTED_MODULE_4__units_constants__["e" /* MONTH */]] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = Object(__WEBPACK_IMPORTED_MODULE_6__utils_defaults__["a" /* default */])(config._a[__WEBPACK_IMPORTED_MODULE_4__units_constants__["i" /* YEAR */]], currentDate[__WEBPACK_IMPORTED_MODULE_4__units_constants__["i" /* YEAR */]]);

        if (
            config._dayOfYear > Object(__WEBPACK_IMPORTED_MODULE_2__units_year__["a" /* daysInYear */])(yearToUse) ||
            config._dayOfYear === 0
        ) {
            Object(__WEBPACK_IMPORTED_MODULE_7__parsing_flags__["a" /* default */])(config)._overflowDayOfYear = true;
        }

        date = Object(__WEBPACK_IMPORTED_MODULE_1__date_from_array__["b" /* createUTCDate */])(yearToUse, 0, config._dayOfYear);
        config._a[__WEBPACK_IMPORTED_MODULE_4__units_constants__["e" /* MONTH */]] = date.getUTCMonth();
        config._a[__WEBPACK_IMPORTED_MODULE_4__units_constants__["a" /* DATE */]] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] =
            config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (
        config._a[__WEBPACK_IMPORTED_MODULE_4__units_constants__["b" /* HOUR */]] === 24 &&
        config._a[__WEBPACK_IMPORTED_MODULE_4__units_constants__["d" /* MINUTE */]] === 0 &&
        config._a[__WEBPACK_IMPORTED_MODULE_4__units_constants__["f" /* SECOND */]] === 0 &&
        config._a[__WEBPACK_IMPORTED_MODULE_4__units_constants__["c" /* MILLISECOND */]] === 0
    ) {
        config._nextDay = true;
        config._a[__WEBPACK_IMPORTED_MODULE_4__units_constants__["b" /* HOUR */]] = 0;
    }

    config._d = (config._useUTC ? __WEBPACK_IMPORTED_MODULE_1__date_from_array__["b" /* createUTCDate */] : __WEBPACK_IMPORTED_MODULE_1__date_from_array__["a" /* createDate */]).apply(
        null,
        input
    );
    expectedWeekday = config._useUTC
        ? config._d.getUTCDay()
        : config._d.getDay();

    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[__WEBPACK_IMPORTED_MODULE_4__units_constants__["b" /* HOUR */]] = 24;
    }

    // check for mismatching day of week
    if (
        config._w &&
        typeof config._w.d !== 'undefined' &&
        config._w.d !== expectedWeekday
    ) {
        Object(__WEBPACK_IMPORTED_MODULE_7__parsing_flags__["a" /* default */])(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = Object(__WEBPACK_IMPORTED_MODULE_6__utils_defaults__["a" /* default */])(
            w.GG,
            config._a[__WEBPACK_IMPORTED_MODULE_4__units_constants__["i" /* YEAR */]],
            Object(__WEBPACK_IMPORTED_MODULE_3__units_week_calendar_utils__["b" /* weekOfYear */])(Object(__WEBPACK_IMPORTED_MODULE_5__local__["a" /* createLocal */])(), 1, 4).year
        );
        week = Object(__WEBPACK_IMPORTED_MODULE_6__utils_defaults__["a" /* default */])(w.W, 1);
        weekday = Object(__WEBPACK_IMPORTED_MODULE_6__utils_defaults__["a" /* default */])(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        curWeek = Object(__WEBPACK_IMPORTED_MODULE_3__units_week_calendar_utils__["b" /* weekOfYear */])(Object(__WEBPACK_IMPORTED_MODULE_5__local__["a" /* createLocal */])(), dow, doy);

        weekYear = Object(__WEBPACK_IMPORTED_MODULE_6__utils_defaults__["a" /* default */])(w.gg, config._a[__WEBPACK_IMPORTED_MODULE_4__units_constants__["i" /* YEAR */]], curWeek.year);

        // Default to current week.
        week = Object(__WEBPACK_IMPORTED_MODULE_6__utils_defaults__["a" /* default */])(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from beginning of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to beginning of week
            weekday = dow;
        }
    }
    if (week < 1 || week > Object(__WEBPACK_IMPORTED_MODULE_3__units_week_calendar_utils__["c" /* weeksInYear */])(weekYear, dow, doy)) {
        Object(__WEBPACK_IMPORTED_MODULE_7__parsing_flags__["a" /* default */])(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        Object(__WEBPACK_IMPORTED_MODULE_7__parsing_flags__["a" /* default */])(config)._overflowWeekday = true;
    } else {
        temp = Object(__WEBPACK_IMPORTED_MODULE_3__units_week_calendar_utils__["a" /* dayOfYearFromWeeks */])(weekYear, week, weekday, dow, doy);
        config._a[__WEBPACK_IMPORTED_MODULE_4__units_constants__["i" /* YEAR */]] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Duration;
/* harmony export (immutable) */ __webpack_exports__["b"] = isDuration;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__units_aliases__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale_locales__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__valid_js__ = __webpack_require__(164);




function Duration(duration) {
    var normalizedInput = Object(__WEBPACK_IMPORTED_MODULE_0__units_aliases__["b" /* normalizeObjectUnits */])(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = Object(__WEBPACK_IMPORTED_MODULE_2__valid_js__["b" /* default */])(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds =
        +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days + weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months + quarters * 3 + years * 12;

    this._data = {};

    this._locale = Object(__WEBPACK_IMPORTED_MODULE_1__locale_locales__["b" /* getLocale */])();

    this._bubble();
}

function isDuration(obj) {
    return obj instanceof Duration;
}


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isDurationValid;
/* harmony export (immutable) */ __webpack_exports__["c"] = isValid;
/* harmony export (immutable) */ __webpack_exports__["a"] = createInvalid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_has_own_prop__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_to_int__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index_of__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__create__ = __webpack_require__(61);





var ordering = [
    'year',
    'quarter',
    'month',
    'week',
    'day',
    'hour',
    'minute',
    'second',
    'millisecond',
];

function isDurationValid(m) {
    var key,
        unitHasDecimal = false,
        i,
        orderLen = ordering.length;
    for (key in m) {
        if (
            Object(__WEBPACK_IMPORTED_MODULE_0__utils_has_own_prop__["a" /* default */])(m, key) &&
            !(
                __WEBPACK_IMPORTED_MODULE_2__utils_index_of__["a" /* default */].call(ordering, key) !== -1 &&
                (m[key] == null || !isNaN(m[key]))
            )
        ) {
            return false;
        }
    }

    for (i = 0; i < orderLen; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== Object(__WEBPACK_IMPORTED_MODULE_1__utils_to_int__["a" /* default */])(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid() {
    return this._isValid;
}

function createInvalid() {
    return Object(__WEBPACK_IMPORTED_MODULE_3__create__["a" /* createDuration */])(NaN);
}


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportItemsTable_vue__ = __webpack_require__(249);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c91e1020_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportItemsTable_vue__ = __webpack_require__(643);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportItemsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c91e1020_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportItemsTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! jQuery UI - v1.12.1 - 2016-09-14
* http://jqueryui.com
* Includes: widget.js, position.js, data.js, disable-selection.js, effect.js, effects/effect-blind.js, effects/effect-bounce.js, effects/effect-clip.js, effects/effect-drop.js, effects/effect-explode.js, effects/effect-fade.js, effects/effect-fold.js, effects/effect-highlight.js, effects/effect-puff.js, effects/effect-pulsate.js, effects/effect-scale.js, effects/effect-shake.js, effects/effect-size.js, effects/effect-slide.js, effects/effect-transfer.js, focusable.js, form-reset-mixin.js, jquery-1-7.js, keycode.js, labels.js, scroll-parent.js, tabbable.js, unique-id.js, widgets/accordion.js, widgets/autocomplete.js, widgets/button.js, widgets/checkboxradio.js, widgets/controlgroup.js, widgets/datepicker.js, widgets/dialog.js, widgets/draggable.js, widgets/droppable.js, widgets/menu.js, widgets/mouse.js, widgets/progressbar.js, widgets/resizable.js, widgets/selectable.js, widgets/selectmenu.js, widgets/slider.js, widgets/sortable.js, widgets/spinner.js, widgets/tabs.js, widgets/tooltip.js
* Copyright jQuery Foundation and other contributors; Licensed MIT */

(function (t) {
   true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6)], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : t(jQuery);
})(function (t) {
  function e(t) {
    for (var e = t.css("visibility"); "inherit" === e;) {
      t = t.parent(), e = t.css("visibility");
    }return "hidden" !== e;
  }function i(t) {
    for (var e, i; t.length && t[0] !== document;) {
      if (e = t.css("position"), ("absolute" === e || "relative" === e || "fixed" === e) && (i = parseInt(t.css("zIndex"), 10), !isNaN(i) && 0 !== i)) return i;t = t.parent();
    }return 0;
  }function s() {
    this._curInst = null, this._keyEvent = !1, this._disabledInputs = [], this._datepickerShowing = !1, this._inDialog = !1, this._mainDivId = "ui-datepicker-div", this._inlineClass = "ui-datepicker-inline", this._appendClass = "ui-datepicker-append", this._triggerClass = "ui-datepicker-trigger", this._dialogClass = "ui-datepicker-dialog", this._disableClass = "ui-datepicker-disabled", this._unselectableClass = "ui-datepicker-unselectable", this._currentClass = "ui-datepicker-current-day", this._dayOverClass = "ui-datepicker-days-cell-over", this.regional = [], this.regional[""] = { closeText: "Done", prevText: "Prev", nextText: "Next", currentText: "Today", monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"], weekHeader: "Wk", dateFormat: "mm/dd/yy", firstDay: 0, isRTL: !1, showMonthAfterYear: !1, yearSuffix: "" }, this._defaults = { showOn: "focus", showAnim: "fadeIn", showOptions: {}, defaultDate: null, appendText: "", buttonText: "...", buttonImage: "", buttonImageOnly: !1, hideIfNoPrevNext: !1, navigationAsDateFormat: !1, gotoCurrent: !1, changeMonth: !1, changeYear: !1, yearRange: "c-10:c+10", showOtherMonths: !1, selectOtherMonths: !1, showWeek: !1, calculateWeek: this.iso8601Week, shortYearCutoff: "+10", minDate: null, maxDate: null, duration: "fast", beforeShowDay: null, beforeShow: null, onSelect: null, onChangeMonthYear: null, onClose: null, numberOfMonths: 1, showCurrentAtPos: 0, stepMonths: 1, stepBigMonths: 12, altField: "", altFormat: "", constrainInput: !0, showButtonPanel: !1, autoSize: !1, disabled: !1 }, t.extend(this._defaults, this.regional[""]), this.regional.en = t.extend(!0, {}, this.regional[""]), this.regional["en-US"] = t.extend(!0, {}, this.regional.en), this.dpDiv = n(t("<div id='" + this._mainDivId + "' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"));
  }function n(e) {
    var i = "button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";return e.on("mouseout", i, function () {
      t(this).removeClass("ui-state-hover"), -1 !== this.className.indexOf("ui-datepicker-prev") && t(this).removeClass("ui-datepicker-prev-hover"), -1 !== this.className.indexOf("ui-datepicker-next") && t(this).removeClass("ui-datepicker-next-hover");
    }).on("mouseover", i, o);
  }function o() {
    t.datepicker._isDisabledDatepicker(m.inline ? m.dpDiv.parent()[0] : m.input[0]) || (t(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover"), t(this).addClass("ui-state-hover"), -1 !== this.className.indexOf("ui-datepicker-prev") && t(this).addClass("ui-datepicker-prev-hover"), -1 !== this.className.indexOf("ui-datepicker-next") && t(this).addClass("ui-datepicker-next-hover"));
  }function a(e, i) {
    t.extend(e, i);for (var s in i) {
      null == i[s] && (e[s] = i[s]);
    }return e;
  }function r(t) {
    return function () {
      var e = this.element.val();t.apply(this, arguments), this._refresh(), e !== this.element.val() && this._trigger("change");
    };
  }t.ui = t.ui || {}, t.ui.version = "1.12.1";var h = 0,
      l = Array.prototype.slice;t.cleanData = function (e) {
    return function (i) {
      var s, n, o;for (o = 0; null != (n = i[o]); o++) {
        try {
          s = t._data(n, "events"), s && s.remove && t(n).triggerHandler("remove");
        } catch (a) {}
      }e(i);
    };
  }(t.cleanData), t.widget = function (e, i, s) {
    var n,
        o,
        a,
        r = {},
        h = e.split(".")[0];e = e.split(".")[1];var l = h + "-" + e;return s || (s = i, i = t.Widget), t.isArray(s) && (s = t.extend.apply(null, [{}].concat(s))), t.expr[":"][l.toLowerCase()] = function (e) {
      return !!t.data(e, l);
    }, t[h] = t[h] || {}, n = t[h][e], o = t[h][e] = function (t, e) {
      return this._createWidget ? (arguments.length && this._createWidget(t, e), void 0) : new o(t, e);
    }, t.extend(o, n, { version: s.version, _proto: t.extend({}, s), _childConstructors: [] }), a = new i(), a.options = t.widget.extend({}, a.options), t.each(s, function (e, s) {
      return t.isFunction(s) ? (r[e] = function () {
        function t() {
          return i.prototype[e].apply(this, arguments);
        }function n(t) {
          return i.prototype[e].apply(this, t);
        }return function () {
          var e,
              i = this._super,
              o = this._superApply;return this._super = t, this._superApply = n, e = s.apply(this, arguments), this._super = i, this._superApply = o, e;
        };
      }(), void 0) : (r[e] = s, void 0);
    }), o.prototype = t.widget.extend(a, { widgetEventPrefix: n ? a.widgetEventPrefix || e : e }, r, { constructor: o, namespace: h, widgetName: e, widgetFullName: l }), n ? (t.each(n._childConstructors, function (e, i) {
      var s = i.prototype;t.widget(s.namespace + "." + s.widgetName, o, i._proto);
    }), delete n._childConstructors) : i._childConstructors.push(o), t.widget.bridge(e, o), o;
  }, t.widget.extend = function (e) {
    for (var i, s, n = l.call(arguments, 1), o = 0, a = n.length; a > o; o++) {
      for (i in n[o]) {
        s = n[o][i], n[o].hasOwnProperty(i) && void 0 !== s && (e[i] = t.isPlainObject(s) ? t.isPlainObject(e[i]) ? t.widget.extend({}, e[i], s) : t.widget.extend({}, s) : s);
      }
    }return e;
  }, t.widget.bridge = function (e, i) {
    var s = i.prototype.widgetFullName || e;t.fn[e] = function (n) {
      var o = "string" == typeof n,
          a = l.call(arguments, 1),
          r = this;return o ? this.length || "instance" !== n ? this.each(function () {
        var i,
            o = t.data(this, s);return "instance" === n ? (r = o, !1) : o ? t.isFunction(o[n]) && "_" !== n.charAt(0) ? (i = o[n].apply(o, a), i !== o && void 0 !== i ? (r = i && i.jquery ? r.pushStack(i.get()) : i, !1) : void 0) : t.error("no such method '" + n + "' for " + e + " widget instance") : t.error("cannot call methods on " + e + " prior to initialization; " + "attempted to call method '" + n + "'");
      }) : r = void 0 : (a.length && (n = t.widget.extend.apply(null, [n].concat(a))), this.each(function () {
        var e = t.data(this, s);e ? (e.option(n || {}), e._init && e._init()) : t.data(this, s, new i(n, this));
      })), r;
    };
  }, t.Widget = function () {}, t.Widget._childConstructors = [], t.Widget.prototype = { widgetName: "widget", widgetEventPrefix: "", defaultElement: "<div>", options: { classes: {}, disabled: !1, create: null }, _createWidget: function _createWidget(e, i) {
      i = t(i || this.defaultElement || this)[0], this.element = t(i), this.uuid = h++, this.eventNamespace = "." + this.widgetName + this.uuid, this.bindings = t(), this.hoverable = t(), this.focusable = t(), this.classesElementLookup = {}, i !== this && (t.data(i, this.widgetFullName, this), this._on(!0, this.element, { remove: function remove(t) {
          t.target === i && this.destroy();
        } }), this.document = t(i.style ? i.ownerDocument : i.document || i), this.window = t(this.document[0].defaultView || this.document[0].parentWindow)), this.options = t.widget.extend({}, this.options, this._getCreateOptions(), e), this._create(), this.options.disabled && this._setOptionDisabled(this.options.disabled), this._trigger("create", null, this._getCreateEventData()), this._init();
    }, _getCreateOptions: function _getCreateOptions() {
      return {};
    }, _getCreateEventData: t.noop, _create: t.noop, _init: t.noop, destroy: function destroy() {
      var e = this;this._destroy(), t.each(this.classesElementLookup, function (t, i) {
        e._removeClass(i, t);
      }), this.element.off(this.eventNamespace).removeData(this.widgetFullName), this.widget().off(this.eventNamespace).removeAttr("aria-disabled"), this.bindings.off(this.eventNamespace);
    }, _destroy: t.noop, widget: function widget() {
      return this.element;
    }, option: function option(e, i) {
      var s,
          n,
          o,
          a = e;if (0 === arguments.length) return t.widget.extend({}, this.options);if ("string" == typeof e) if (a = {}, s = e.split("."), e = s.shift(), s.length) {
        for (n = a[e] = t.widget.extend({}, this.options[e]), o = 0; s.length - 1 > o; o++) {
          n[s[o]] = n[s[o]] || {}, n = n[s[o]];
        }if (e = s.pop(), 1 === arguments.length) return void 0 === n[e] ? null : n[e];n[e] = i;
      } else {
        if (1 === arguments.length) return void 0 === this.options[e] ? null : this.options[e];a[e] = i;
      }return this._setOptions(a), this;
    }, _setOptions: function _setOptions(t) {
      var e;for (e in t) {
        this._setOption(e, t[e]);
      }return this;
    }, _setOption: function _setOption(t, e) {
      return "classes" === t && this._setOptionClasses(e), this.options[t] = e, "disabled" === t && this._setOptionDisabled(e), this;
    }, _setOptionClasses: function _setOptionClasses(e) {
      var i, s, n;for (i in e) {
        n = this.classesElementLookup[i], e[i] !== this.options.classes[i] && n && n.length && (s = t(n.get()), this._removeClass(n, i), s.addClass(this._classes({ element: s, keys: i, classes: e, add: !0 })));
      }
    }, _setOptionDisabled: function _setOptionDisabled(t) {
      this._toggleClass(this.widget(), this.widgetFullName + "-disabled", null, !!t), t && (this._removeClass(this.hoverable, null, "ui-state-hover"), this._removeClass(this.focusable, null, "ui-state-focus"));
    }, enable: function enable() {
      return this._setOptions({ disabled: !1 });
    }, disable: function disable() {
      return this._setOptions({ disabled: !0 });
    }, _classes: function _classes(e) {
      function i(i, o) {
        var a, r;for (r = 0; i.length > r; r++) {
          a = n.classesElementLookup[i[r]] || t(), a = e.add ? t(t.unique(a.get().concat(e.element.get()))) : t(a.not(e.element).get()), n.classesElementLookup[i[r]] = a, s.push(i[r]), o && e.classes[i[r]] && s.push(e.classes[i[r]]);
        }
      }var s = [],
          n = this;return e = t.extend({ element: this.element, classes: this.options.classes || {} }, e), this._on(e.element, { remove: "_untrackClassesElement" }), e.keys && i(e.keys.match(/\S+/g) || [], !0), e.extra && i(e.extra.match(/\S+/g) || []), s.join(" ");
    }, _untrackClassesElement: function _untrackClassesElement(e) {
      var i = this;t.each(i.classesElementLookup, function (s, n) {
        -1 !== t.inArray(e.target, n) && (i.classesElementLookup[s] = t(n.not(e.target).get()));
      });
    }, _removeClass: function _removeClass(t, e, i) {
      return this._toggleClass(t, e, i, !1);
    }, _addClass: function _addClass(t, e, i) {
      return this._toggleClass(t, e, i, !0);
    }, _toggleClass: function _toggleClass(t, e, i, s) {
      s = "boolean" == typeof s ? s : i;var n = "string" == typeof t || null === t,
          o = { extra: n ? e : i, keys: n ? t : e, element: n ? this.element : t, add: s };return o.element.toggleClass(this._classes(o), s), this;
    }, _on: function _on(e, i, s) {
      var n,
          o = this;"boolean" != typeof e && (s = i, i = e, e = !1), s ? (i = n = t(i), this.bindings = this.bindings.add(i)) : (s = i, i = this.element, n = this.widget()), t.each(s, function (s, a) {
        function r() {
          return e || o.options.disabled !== !0 && !t(this).hasClass("ui-state-disabled") ? ("string" == typeof a ? o[a] : a).apply(o, arguments) : void 0;
        }"string" != typeof a && (r.guid = a.guid = a.guid || r.guid || t.guid++);var h = s.match(/^([\w:-]*)\s*(.*)$/),
            l = h[1] + o.eventNamespace,
            c = h[2];c ? n.on(l, c, r) : i.on(l, r);
      });
    }, _off: function _off(e, i) {
      i = (i || "").split(" ").join(this.eventNamespace + " ") + this.eventNamespace, e.off(i).off(i), this.bindings = t(this.bindings.not(e).get()), this.focusable = t(this.focusable.not(e).get()), this.hoverable = t(this.hoverable.not(e).get());
    }, _delay: function _delay(t, e) {
      function i() {
        return ("string" == typeof t ? s[t] : t).apply(s, arguments);
      }var s = this;return setTimeout(i, e || 0);
    }, _hoverable: function _hoverable(e) {
      this.hoverable = this.hoverable.add(e), this._on(e, { mouseenter: function mouseenter(e) {
          this._addClass(t(e.currentTarget), null, "ui-state-hover");
        }, mouseleave: function mouseleave(e) {
          this._removeClass(t(e.currentTarget), null, "ui-state-hover");
        } });
    }, _focusable: function _focusable(e) {
      this.focusable = this.focusable.add(e), this._on(e, { focusin: function focusin(e) {
          this._addClass(t(e.currentTarget), null, "ui-state-focus");
        }, focusout: function focusout(e) {
          this._removeClass(t(e.currentTarget), null, "ui-state-focus");
        } });
    }, _trigger: function _trigger(e, i, s) {
      var n,
          o,
          a = this.options[e];if (s = s || {}, i = t.Event(i), i.type = (e === this.widgetEventPrefix ? e : this.widgetEventPrefix + e).toLowerCase(), i.target = this.element[0], o = i.originalEvent) for (n in o) {
        n in i || (i[n] = o[n]);
      }return this.element.trigger(i, s), !(t.isFunction(a) && a.apply(this.element[0], [i].concat(s)) === !1 || i.isDefaultPrevented());
    } }, t.each({ show: "fadeIn", hide: "fadeOut" }, function (e, i) {
    t.Widget.prototype["_" + e] = function (s, n, o) {
      "string" == typeof n && (n = { effect: n });var a,
          r = n ? n === !0 || "number" == typeof n ? i : n.effect || i : e;n = n || {}, "number" == typeof n && (n = { duration: n }), a = !t.isEmptyObject(n), n.complete = o, n.delay && s.delay(n.delay), a && t.effects && t.effects.effect[r] ? s[e](n) : r !== e && s[r] ? s[r](n.duration, n.easing, o) : s.queue(function (i) {
        t(this)[e](), o && o.call(s[0]), i();
      });
    };
  }), t.widget, function () {
    function e(t, e, i) {
      return [parseFloat(t[0]) * (u.test(t[0]) ? e / 100 : 1), parseFloat(t[1]) * (u.test(t[1]) ? i / 100 : 1)];
    }function i(e, i) {
      return parseInt(t.css(e, i), 10) || 0;
    }function s(e) {
      var i = e[0];return 9 === i.nodeType ? { width: e.width(), height: e.height(), offset: { top: 0, left: 0 } } : t.isWindow(i) ? { width: e.width(), height: e.height(), offset: { top: e.scrollTop(), left: e.scrollLeft() } } : i.preventDefault ? { width: 0, height: 0, offset: { top: i.pageY, left: i.pageX } } : { width: e.outerWidth(), height: e.outerHeight(), offset: e.offset() };
    }var n,
        o = Math.max,
        a = Math.abs,
        r = /left|center|right/,
        h = /top|center|bottom/,
        l = /[\+\-]\d+(\.[\d]+)?%?/,
        c = /^\w+/,
        u = /%$/,
        d = t.fn.position;t.position = { scrollbarWidth: function scrollbarWidth() {
        if (void 0 !== n) return n;var e,
            i,
            s = t("<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>"),
            o = s.children()[0];return t("body").append(s), e = o.offsetWidth, s.css("overflow", "scroll"), i = o.offsetWidth, e === i && (i = s[0].clientWidth), s.remove(), n = e - i;
      }, getScrollInfo: function getScrollInfo(e) {
        var i = e.isWindow || e.isDocument ? "" : e.element.css("overflow-x"),
            s = e.isWindow || e.isDocument ? "" : e.element.css("overflow-y"),
            n = "scroll" === i || "auto" === i && e.width < e.element[0].scrollWidth,
            o = "scroll" === s || "auto" === s && e.height < e.element[0].scrollHeight;return { width: o ? t.position.scrollbarWidth() : 0, height: n ? t.position.scrollbarWidth() : 0 };
      }, getWithinInfo: function getWithinInfo(e) {
        var i = t(e || window),
            s = t.isWindow(i[0]),
            n = !!i[0] && 9 === i[0].nodeType,
            o = !s && !n;return { element: i, isWindow: s, isDocument: n, offset: o ? t(e).offset() : { left: 0, top: 0 }, scrollLeft: i.scrollLeft(), scrollTop: i.scrollTop(), width: i.outerWidth(), height: i.outerHeight() };
      } }, t.fn.position = function (n) {
      if (!n || !n.of) return d.apply(this, arguments);n = t.extend({}, n);var u,
          p,
          f,
          g,
          m,
          _,
          v = t(n.of),
          b = t.position.getWithinInfo(n.within),
          y = t.position.getScrollInfo(b),
          w = (n.collision || "flip").split(" "),
          k = {};return _ = s(v), v[0].preventDefault && (n.at = "left top"), p = _.width, f = _.height, g = _.offset, m = t.extend({}, g), t.each(["my", "at"], function () {
        var t,
            e,
            i = (n[this] || "").split(" ");1 === i.length && (i = r.test(i[0]) ? i.concat(["center"]) : h.test(i[0]) ? ["center"].concat(i) : ["center", "center"]), i[0] = r.test(i[0]) ? i[0] : "center", i[1] = h.test(i[1]) ? i[1] : "center", t = l.exec(i[0]), e = l.exec(i[1]), k[this] = [t ? t[0] : 0, e ? e[0] : 0], n[this] = [c.exec(i[0])[0], c.exec(i[1])[0]];
      }), 1 === w.length && (w[1] = w[0]), "right" === n.at[0] ? m.left += p : "center" === n.at[0] && (m.left += p / 2), "bottom" === n.at[1] ? m.top += f : "center" === n.at[1] && (m.top += f / 2), u = e(k.at, p, f), m.left += u[0], m.top += u[1], this.each(function () {
        var s,
            r,
            h = t(this),
            l = h.outerWidth(),
            c = h.outerHeight(),
            d = i(this, "marginLeft"),
            _ = i(this, "marginTop"),
            x = l + d + i(this, "marginRight") + y.width,
            C = c + _ + i(this, "marginBottom") + y.height,
            D = t.extend({}, m),
            I = e(k.my, h.outerWidth(), h.outerHeight());"right" === n.my[0] ? D.left -= l : "center" === n.my[0] && (D.left -= l / 2), "bottom" === n.my[1] ? D.top -= c : "center" === n.my[1] && (D.top -= c / 2), D.left += I[0], D.top += I[1], s = { marginLeft: d, marginTop: _ }, t.each(["left", "top"], function (e, i) {
          t.ui.position[w[e]] && t.ui.position[w[e]][i](D, { targetWidth: p, targetHeight: f, elemWidth: l, elemHeight: c, collisionPosition: s, collisionWidth: x, collisionHeight: C, offset: [u[0] + I[0], u[1] + I[1]], my: n.my, at: n.at, within: b, elem: h });
        }), n.using && (r = function r(t) {
          var e = g.left - D.left,
              i = e + p - l,
              s = g.top - D.top,
              r = s + f - c,
              u = { target: { element: v, left: g.left, top: g.top, width: p, height: f }, element: { element: h, left: D.left, top: D.top, width: l, height: c }, horizontal: 0 > i ? "left" : e > 0 ? "right" : "center", vertical: 0 > r ? "top" : s > 0 ? "bottom" : "middle" };l > p && p > a(e + i) && (u.horizontal = "center"), c > f && f > a(s + r) && (u.vertical = "middle"), u.important = o(a(e), a(i)) > o(a(s), a(r)) ? "horizontal" : "vertical", n.using.call(this, t, u);
        }), h.offset(t.extend(D, { using: r }));
      });
    }, t.ui.position = { fit: { left: function left(t, e) {
          var i,
              s = e.within,
              n = s.isWindow ? s.scrollLeft : s.offset.left,
              a = s.width,
              r = t.left - e.collisionPosition.marginLeft,
              h = n - r,
              l = r + e.collisionWidth - a - n;e.collisionWidth > a ? h > 0 && 0 >= l ? (i = t.left + h + e.collisionWidth - a - n, t.left += h - i) : t.left = l > 0 && 0 >= h ? n : h > l ? n + a - e.collisionWidth : n : h > 0 ? t.left += h : l > 0 ? t.left -= l : t.left = o(t.left - r, t.left);
        }, top: function top(t, e) {
          var i,
              s = e.within,
              n = s.isWindow ? s.scrollTop : s.offset.top,
              a = e.within.height,
              r = t.top - e.collisionPosition.marginTop,
              h = n - r,
              l = r + e.collisionHeight - a - n;e.collisionHeight > a ? h > 0 && 0 >= l ? (i = t.top + h + e.collisionHeight - a - n, t.top += h - i) : t.top = l > 0 && 0 >= h ? n : h > l ? n + a - e.collisionHeight : n : h > 0 ? t.top += h : l > 0 ? t.top -= l : t.top = o(t.top - r, t.top);
        } }, flip: { left: function left(t, e) {
          var i,
              s,
              n = e.within,
              o = n.offset.left + n.scrollLeft,
              r = n.width,
              h = n.isWindow ? n.scrollLeft : n.offset.left,
              l = t.left - e.collisionPosition.marginLeft,
              c = l - h,
              u = l + e.collisionWidth - r - h,
              d = "left" === e.my[0] ? -e.elemWidth : "right" === e.my[0] ? e.elemWidth : 0,
              p = "left" === e.at[0] ? e.targetWidth : "right" === e.at[0] ? -e.targetWidth : 0,
              f = -2 * e.offset[0];0 > c ? (i = t.left + d + p + f + e.collisionWidth - r - o, (0 > i || a(c) > i) && (t.left += d + p + f)) : u > 0 && (s = t.left - e.collisionPosition.marginLeft + d + p + f - h, (s > 0 || u > a(s)) && (t.left += d + p + f));
        }, top: function top(t, e) {
          var i,
              s,
              n = e.within,
              o = n.offset.top + n.scrollTop,
              r = n.height,
              h = n.isWindow ? n.scrollTop : n.offset.top,
              l = t.top - e.collisionPosition.marginTop,
              c = l - h,
              u = l + e.collisionHeight - r - h,
              d = "top" === e.my[1],
              p = d ? -e.elemHeight : "bottom" === e.my[1] ? e.elemHeight : 0,
              f = "top" === e.at[1] ? e.targetHeight : "bottom" === e.at[1] ? -e.targetHeight : 0,
              g = -2 * e.offset[1];0 > c ? (s = t.top + p + f + g + e.collisionHeight - r - o, (0 > s || a(c) > s) && (t.top += p + f + g)) : u > 0 && (i = t.top - e.collisionPosition.marginTop + p + f + g - h, (i > 0 || u > a(i)) && (t.top += p + f + g));
        } }, flipfit: { left: function left() {
          t.ui.position.flip.left.apply(this, arguments), t.ui.position.fit.left.apply(this, arguments);
        }, top: function top() {
          t.ui.position.flip.top.apply(this, arguments), t.ui.position.fit.top.apply(this, arguments);
        } } };
  }(), t.ui.position, t.extend(t.expr[":"], { data: t.expr.createPseudo ? t.expr.createPseudo(function (e) {
      return function (i) {
        return !!t.data(i, e);
      };
    }) : function (e, i, s) {
      return !!t.data(e, s[3]);
    } }), t.fn.extend({ disableSelection: function () {
      var t = "onselectstart" in document.createElement("div") ? "selectstart" : "mousedown";return function () {
        return this.on(t + ".ui-disableSelection", function (t) {
          t.preventDefault();
        });
      };
    }(), enableSelection: function enableSelection() {
      return this.off(".ui-disableSelection");
    } });var c = "ui-effects-",
      u = "ui-effects-style",
      d = "ui-effects-animated",
      p = t;t.effects = { effect: {} }, function (t, e) {
    function i(t, e, i) {
      var s = u[e.type] || {};return null == t ? i || !e.def ? null : e.def : (t = s.floor ? ~~t : parseFloat(t), isNaN(t) ? e.def : s.mod ? (t + s.mod) % s.mod : 0 > t ? 0 : t > s.max ? s.max : t);
    }function s(i) {
      var s = l(),
          n = s._rgba = [];return i = i.toLowerCase(), f(h, function (t, o) {
        var a,
            r = o.re.exec(i),
            h = r && o.parse(r),
            l = o.space || "rgba";return h ? (a = s[l](h), s[c[l].cache] = a[c[l].cache], n = s._rgba = a._rgba, !1) : e;
      }), n.length ? ("0,0,0,0" === n.join() && t.extend(n, o.transparent), s) : o[i];
    }function n(t, e, i) {
      return i = (i + 1) % 1, 1 > 6 * i ? t + 6 * (e - t) * i : 1 > 2 * i ? e : 2 > 3 * i ? t + 6 * (e - t) * (2 / 3 - i) : t;
    }var o,
        a = "backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",
        r = /^([\-+])=\s*(\d+\.?\d*)/,
        h = [{ re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/, parse: function parse(t) {
        return [t[1], t[2], t[3], t[4]];
      } }, { re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/, parse: function parse(t) {
        return [2.55 * t[1], 2.55 * t[2], 2.55 * t[3], t[4]];
      } }, { re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/, parse: function parse(t) {
        return [parseInt(t[1], 16), parseInt(t[2], 16), parseInt(t[3], 16)];
      } }, { re: /#([a-f0-9])([a-f0-9])([a-f0-9])/, parse: function parse(t) {
        return [parseInt(t[1] + t[1], 16), parseInt(t[2] + t[2], 16), parseInt(t[3] + t[3], 16)];
      } }, { re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/, space: "hsla", parse: function parse(t) {
        return [t[1], t[2] / 100, t[3] / 100, t[4]];
      } }],
        l = t.Color = function (e, i, s, n) {
      return new t.Color.fn.parse(e, i, s, n);
    },
        c = { rgba: { props: { red: { idx: 0, type: "byte" }, green: { idx: 1, type: "byte" }, blue: { idx: 2, type: "byte" } } }, hsla: { props: { hue: { idx: 0, type: "degrees" }, saturation: { idx: 1, type: "percent" }, lightness: { idx: 2, type: "percent" } } } },
        u = { "byte": { floor: !0, max: 255 }, percent: { max: 1 }, degrees: { mod: 360, floor: !0 } },
        d = l.support = {},
        p = t("<p>")[0],
        f = t.each;p.style.cssText = "background-color:rgba(1,1,1,.5)", d.rgba = p.style.backgroundColor.indexOf("rgba") > -1, f(c, function (t, e) {
      e.cache = "_" + t, e.props.alpha = { idx: 3, type: "percent", def: 1 };
    }), l.fn = t.extend(l.prototype, { parse: function parse(n, a, r, h) {
        if (n === e) return this._rgba = [null, null, null, null], this;(n.jquery || n.nodeType) && (n = t(n).css(a), a = e);var u = this,
            d = t.type(n),
            p = this._rgba = [];return a !== e && (n = [n, a, r, h], d = "array"), "string" === d ? this.parse(s(n) || o._default) : "array" === d ? (f(c.rgba.props, function (t, e) {
          p[e.idx] = i(n[e.idx], e);
        }), this) : "object" === d ? (n instanceof l ? f(c, function (t, e) {
          n[e.cache] && (u[e.cache] = n[e.cache].slice());
        }) : f(c, function (e, s) {
          var o = s.cache;f(s.props, function (t, e) {
            if (!u[o] && s.to) {
              if ("alpha" === t || null == n[t]) return;u[o] = s.to(u._rgba);
            }u[o][e.idx] = i(n[t], e, !0);
          }), u[o] && 0 > t.inArray(null, u[o].slice(0, 3)) && (u[o][3] = 1, s.from && (u._rgba = s.from(u[o])));
        }), this) : e;
      }, is: function is(t) {
        var i = l(t),
            s = !0,
            n = this;return f(c, function (t, o) {
          var a,
              r = i[o.cache];return r && (a = n[o.cache] || o.to && o.to(n._rgba) || [], f(o.props, function (t, i) {
            return null != r[i.idx] ? s = r[i.idx] === a[i.idx] : e;
          })), s;
        }), s;
      }, _space: function _space() {
        var t = [],
            e = this;return f(c, function (i, s) {
          e[s.cache] && t.push(i);
        }), t.pop();
      }, transition: function transition(t, e) {
        var s = l(t),
            n = s._space(),
            o = c[n],
            a = 0 === this.alpha() ? l("transparent") : this,
            r = a[o.cache] || o.to(a._rgba),
            h = r.slice();return s = s[o.cache], f(o.props, function (t, n) {
          var o = n.idx,
              a = r[o],
              l = s[o],
              c = u[n.type] || {};null !== l && (null === a ? h[o] = l : (c.mod && (l - a > c.mod / 2 ? a += c.mod : a - l > c.mod / 2 && (a -= c.mod)), h[o] = i((l - a) * e + a, n)));
        }), this[n](h);
      }, blend: function blend(e) {
        if (1 === this._rgba[3]) return this;var i = this._rgba.slice(),
            s = i.pop(),
            n = l(e)._rgba;return l(t.map(i, function (t, e) {
          return (1 - s) * n[e] + s * t;
        }));
      }, toRgbaString: function toRgbaString() {
        var e = "rgba(",
            i = t.map(this._rgba, function (t, e) {
          return null == t ? e > 2 ? 1 : 0 : t;
        });return 1 === i[3] && (i.pop(), e = "rgb("), e + i.join() + ")";
      }, toHslaString: function toHslaString() {
        var e = "hsla(",
            i = t.map(this.hsla(), function (t, e) {
          return null == t && (t = e > 2 ? 1 : 0), e && 3 > e && (t = Math.round(100 * t) + "%"), t;
        });return 1 === i[3] && (i.pop(), e = "hsl("), e + i.join() + ")";
      }, toHexString: function toHexString(e) {
        var i = this._rgba.slice(),
            s = i.pop();return e && i.push(~~(255 * s)), "#" + t.map(i, function (t) {
          return t = (t || 0).toString(16), 1 === t.length ? "0" + t : t;
        }).join("");
      }, toString: function toString() {
        return 0 === this._rgba[3] ? "transparent" : this.toRgbaString();
      } }), l.fn.parse.prototype = l.fn, c.hsla.to = function (t) {
      if (null == t[0] || null == t[1] || null == t[2]) return [null, null, null, t[3]];var e,
          i,
          s = t[0] / 255,
          n = t[1] / 255,
          o = t[2] / 255,
          a = t[3],
          r = Math.max(s, n, o),
          h = Math.min(s, n, o),
          l = r - h,
          c = r + h,
          u = .5 * c;return e = h === r ? 0 : s === r ? 60 * (n - o) / l + 360 : n === r ? 60 * (o - s) / l + 120 : 60 * (s - n) / l + 240, i = 0 === l ? 0 : .5 >= u ? l / c : l / (2 - c), [Math.round(e) % 360, i, u, null == a ? 1 : a];
    }, c.hsla.from = function (t) {
      if (null == t[0] || null == t[1] || null == t[2]) return [null, null, null, t[3]];var e = t[0] / 360,
          i = t[1],
          s = t[2],
          o = t[3],
          a = .5 >= s ? s * (1 + i) : s + i - s * i,
          r = 2 * s - a;return [Math.round(255 * n(r, a, e + 1 / 3)), Math.round(255 * n(r, a, e)), Math.round(255 * n(r, a, e - 1 / 3)), o];
    }, f(c, function (s, n) {
      var o = n.props,
          a = n.cache,
          h = n.to,
          c = n.from;l.fn[s] = function (s) {
        if (h && !this[a] && (this[a] = h(this._rgba)), s === e) return this[a].slice();var n,
            r = t.type(s),
            u = "array" === r || "object" === r ? s : arguments,
            d = this[a].slice();return f(o, function (t, e) {
          var s = u["object" === r ? t : e.idx];null == s && (s = d[e.idx]), d[e.idx] = i(s, e);
        }), c ? (n = l(c(d)), n[a] = d, n) : l(d);
      }, f(o, function (e, i) {
        l.fn[e] || (l.fn[e] = function (n) {
          var o,
              a = t.type(n),
              h = "alpha" === e ? this._hsla ? "hsla" : "rgba" : s,
              l = this[h](),
              c = l[i.idx];return "undefined" === a ? c : ("function" === a && (n = n.call(this, c), a = t.type(n)), null == n && i.empty ? this : ("string" === a && (o = r.exec(n), o && (n = c + parseFloat(o[2]) * ("+" === o[1] ? 1 : -1))), l[i.idx] = n, this[h](l)));
        });
      });
    }), l.hook = function (e) {
      var i = e.split(" ");f(i, function (e, i) {
        t.cssHooks[i] = { set: function set(e, n) {
            var o,
                a,
                r = "";if ("transparent" !== n && ("string" !== t.type(n) || (o = s(n)))) {
              if (n = l(o || n), !d.rgba && 1 !== n._rgba[3]) {
                for (a = "backgroundColor" === i ? e.parentNode : e; ("" === r || "transparent" === r) && a && a.style;) {
                  try {
                    r = t.css(a, "backgroundColor"), a = a.parentNode;
                  } catch (h) {}
                }n = n.blend(r && "transparent" !== r ? r : "_default");
              }n = n.toRgbaString();
            }try {
              e.style[i] = n;
            } catch (h) {}
          } }, t.fx.step[i] = function (e) {
          e.colorInit || (e.start = l(e.elem, i), e.end = l(e.end), e.colorInit = !0), t.cssHooks[i].set(e.elem, e.start.transition(e.end, e.pos));
        };
      });
    }, l.hook(a), t.cssHooks.borderColor = { expand: function expand(t) {
        var e = {};return f(["Top", "Right", "Bottom", "Left"], function (i, s) {
          e["border" + s + "Color"] = t;
        }), e;
      } }, o = t.Color.names = { aqua: "#00ffff", black: "#000000", blue: "#0000ff", fuchsia: "#ff00ff", gray: "#808080", green: "#008000", lime: "#00ff00", maroon: "#800000", navy: "#000080", olive: "#808000", purple: "#800080", red: "#ff0000", silver: "#c0c0c0", teal: "#008080", white: "#ffffff", yellow: "#ffff00", transparent: [null, null, null, 0], _default: "#ffffff" };
  }(p), function () {
    function e(e) {
      var i,
          s,
          n = e.ownerDocument.defaultView ? e.ownerDocument.defaultView.getComputedStyle(e, null) : e.currentStyle,
          o = {};if (n && n.length && n[0] && n[n[0]]) for (s = n.length; s--;) {
        i = n[s], "string" == typeof n[i] && (o[t.camelCase(i)] = n[i]);
      } else for (i in n) {
        "string" == typeof n[i] && (o[i] = n[i]);
      }return o;
    }function i(e, i) {
      var s,
          o,
          a = {};for (s in i) {
        o = i[s], e[s] !== o && (n[s] || (t.fx.step[s] || !isNaN(parseFloat(o))) && (a[s] = o));
      }return a;
    }var s = ["add", "remove", "toggle"],
        n = { border: 1, borderBottom: 1, borderColor: 1, borderLeft: 1, borderRight: 1, borderTop: 1, borderWidth: 1, margin: 1, padding: 1 };t.each(["borderLeftStyle", "borderRightStyle", "borderBottomStyle", "borderTopStyle"], function (e, i) {
      t.fx.step[i] = function (t) {
        ("none" !== t.end && !t.setAttr || 1 === t.pos && !t.setAttr) && (p.style(t.elem, i, t.end), t.setAttr = !0);
      };
    }), t.fn.addBack || (t.fn.addBack = function (t) {
      return this.add(null == t ? this.prevObject : this.prevObject.filter(t));
    }), t.effects.animateClass = function (n, o, a, r) {
      var h = t.speed(o, a, r);return this.queue(function () {
        var o,
            a = t(this),
            r = a.attr("class") || "",
            l = h.children ? a.find("*").addBack() : a;l = l.map(function () {
          var i = t(this);return { el: i, start: e(this) };
        }), o = function o() {
          t.each(s, function (t, e) {
            n[e] && a[e + "Class"](n[e]);
          });
        }, o(), l = l.map(function () {
          return this.end = e(this.el[0]), this.diff = i(this.start, this.end), this;
        }), a.attr("class", r), l = l.map(function () {
          var e = this,
              i = t.Deferred(),
              s = t.extend({}, h, { queue: !1, complete: function complete() {
              i.resolve(e);
            } });return this.el.animate(this.diff, s), i.promise();
        }), t.when.apply(t, l.get()).done(function () {
          o(), t.each(arguments, function () {
            var e = this.el;t.each(this.diff, function (t) {
              e.css(t, "");
            });
          }), h.complete.call(a[0]);
        });
      });
    }, t.fn.extend({ addClass: function (e) {
        return function (i, s, n, o) {
          return s ? t.effects.animateClass.call(this, { add: i }, s, n, o) : e.apply(this, arguments);
        };
      }(t.fn.addClass), removeClass: function (e) {
        return function (i, s, n, o) {
          return arguments.length > 1 ? t.effects.animateClass.call(this, { remove: i }, s, n, o) : e.apply(this, arguments);
        };
      }(t.fn.removeClass), toggleClass: function (e) {
        return function (i, s, n, o, a) {
          return "boolean" == typeof s || void 0 === s ? n ? t.effects.animateClass.call(this, s ? { add: i } : { remove: i }, n, o, a) : e.apply(this, arguments) : t.effects.animateClass.call(this, { toggle: i }, s, n, o);
        };
      }(t.fn.toggleClass), switchClass: function switchClass(e, i, s, n, o) {
        return t.effects.animateClass.call(this, { add: i, remove: e }, s, n, o);
      } });
  }(), function () {
    function e(e, i, s, n) {
      return t.isPlainObject(e) && (i = e, e = e.effect), e = { effect: e }, null == i && (i = {}), t.isFunction(i) && (n = i, s = null, i = {}), ("number" == typeof i || t.fx.speeds[i]) && (n = s, s = i, i = {}), t.isFunction(s) && (n = s, s = null), i && t.extend(e, i), s = s || i.duration, e.duration = t.fx.off ? 0 : "number" == typeof s ? s : s in t.fx.speeds ? t.fx.speeds[s] : t.fx.speeds._default, e.complete = n || i.complete, e;
    }function i(e) {
      return !e || "number" == typeof e || t.fx.speeds[e] ? !0 : "string" != typeof e || t.effects.effect[e] ? t.isFunction(e) ? !0 : "object" != (typeof e === "undefined" ? "undefined" : _typeof(e)) || e.effect ? !1 : !0 : !0;
    }function s(t, e) {
      var i = e.outerWidth(),
          s = e.outerHeight(),
          n = /^rect\((-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto)\)$/,
          o = n.exec(t) || ["", 0, i, s, 0];return { top: parseFloat(o[1]) || 0, right: "auto" === o[2] ? i : parseFloat(o[2]), bottom: "auto" === o[3] ? s : parseFloat(o[3]), left: parseFloat(o[4]) || 0 };
    }t.expr && t.expr.filters && t.expr.filters.animated && (t.expr.filters.animated = function (e) {
      return function (i) {
        return !!t(i).data(d) || e(i);
      };
    }(t.expr.filters.animated)), t.uiBackCompat !== !1 && t.extend(t.effects, { save: function save(t, e) {
        for (var i = 0, s = e.length; s > i; i++) {
          null !== e[i] && t.data(c + e[i], t[0].style[e[i]]);
        }
      }, restore: function restore(t, e) {
        for (var i, s = 0, n = e.length; n > s; s++) {
          null !== e[s] && (i = t.data(c + e[s]), t.css(e[s], i));
        }
      }, setMode: function setMode(t, e) {
        return "toggle" === e && (e = t.is(":hidden") ? "show" : "hide"), e;
      }, createWrapper: function createWrapper(e) {
        if (e.parent().is(".ui-effects-wrapper")) return e.parent();var i = { width: e.outerWidth(!0), height: e.outerHeight(!0), "float": e.css("float") },
            s = t("<div></div>").addClass("ui-effects-wrapper").css({ fontSize: "100%", background: "transparent", border: "none", margin: 0, padding: 0 }),
            n = { width: e.width(), height: e.height() },
            o = document.activeElement;try {
          o.id;
        } catch (a) {
          o = document.body;
        }return e.wrap(s), (e[0] === o || t.contains(e[0], o)) && t(o).trigger("focus"), s = e.parent(), "static" === e.css("position") ? (s.css({ position: "relative" }), e.css({ position: "relative" })) : (t.extend(i, { position: e.css("position"), zIndex: e.css("z-index") }), t.each(["top", "left", "bottom", "right"], function (t, s) {
          i[s] = e.css(s), isNaN(parseInt(i[s], 10)) && (i[s] = "auto");
        }), e.css({ position: "relative", top: 0, left: 0, right: "auto", bottom: "auto" })), e.css(n), s.css(i).show();
      }, removeWrapper: function removeWrapper(e) {
        var i = document.activeElement;return e.parent().is(".ui-effects-wrapper") && (e.parent().replaceWith(e), (e[0] === i || t.contains(e[0], i)) && t(i).trigger("focus")), e;
      } }), t.extend(t.effects, { version: "1.12.1", define: function define(e, i, s) {
        return s || (s = i, i = "effect"), t.effects.effect[e] = s, t.effects.effect[e].mode = i, s;
      }, scaledDimensions: function scaledDimensions(t, e, i) {
        if (0 === e) return { height: 0, width: 0, outerHeight: 0, outerWidth: 0 };var s = "horizontal" !== i ? (e || 100) / 100 : 1,
            n = "vertical" !== i ? (e || 100) / 100 : 1;return { height: t.height() * n, width: t.width() * s, outerHeight: t.outerHeight() * n, outerWidth: t.outerWidth() * s };
      }, clipToBox: function clipToBox(t) {
        return { width: t.clip.right - t.clip.left, height: t.clip.bottom - t.clip.top, left: t.clip.left, top: t.clip.top };
      }, unshift: function unshift(t, e, i) {
        var s = t.queue();e > 1 && s.splice.apply(s, [1, 0].concat(s.splice(e, i))), t.dequeue();
      }, saveStyle: function saveStyle(t) {
        t.data(u, t[0].style.cssText);
      }, restoreStyle: function restoreStyle(t) {
        t[0].style.cssText = t.data(u) || "", t.removeData(u);
      }, mode: function mode(t, e) {
        var i = t.is(":hidden");return "toggle" === e && (e = i ? "show" : "hide"), (i ? "hide" === e : "show" === e) && (e = "none"), e;
      }, getBaseline: function getBaseline(t, e) {
        var i, s;switch (t[0]) {case "top":
            i = 0;break;case "middle":
            i = .5;break;case "bottom":
            i = 1;break;default:
            i = t[0] / e.height;}switch (t[1]) {case "left":
            s = 0;break;case "center":
            s = .5;break;case "right":
            s = 1;break;default:
            s = t[1] / e.width;}return { x: s, y: i };
      }, createPlaceholder: function createPlaceholder(e) {
        var i,
            s = e.css("position"),
            n = e.position();return e.css({ marginTop: e.css("marginTop"), marginBottom: e.css("marginBottom"), marginLeft: e.css("marginLeft"), marginRight: e.css("marginRight") }).outerWidth(e.outerWidth()).outerHeight(e.outerHeight()), /^(static|relative)/.test(s) && (s = "absolute", i = t("<" + e[0].nodeName + ">").insertAfter(e).css({ display: /^(inline|ruby)/.test(e.css("display")) ? "inline-block" : "block", visibility: "hidden", marginTop: e.css("marginTop"), marginBottom: e.css("marginBottom"), marginLeft: e.css("marginLeft"), marginRight: e.css("marginRight"), "float": e.css("float") }).outerWidth(e.outerWidth()).outerHeight(e.outerHeight()).addClass("ui-effects-placeholder"), e.data(c + "placeholder", i)), e.css({ position: s, left: n.left, top: n.top }), i;
      }, removePlaceholder: function removePlaceholder(t) {
        var e = c + "placeholder",
            i = t.data(e);i && (i.remove(), t.removeData(e));
      }, cleanUp: function cleanUp(e) {
        t.effects.restoreStyle(e), t.effects.removePlaceholder(e);
      }, setTransition: function setTransition(e, i, s, n) {
        return n = n || {}, t.each(i, function (t, i) {
          var o = e.cssUnit(i);o[0] > 0 && (n[i] = o[0] * s + o[1]);
        }), n;
      } }), t.fn.extend({ effect: function effect() {
        function i(e) {
          function i() {
            r.removeData(d), t.effects.cleanUp(r), "hide" === s.mode && r.hide(), a();
          }function a() {
            t.isFunction(h) && h.call(r[0]), t.isFunction(e) && e();
          }var r = t(this);s.mode = c.shift(), t.uiBackCompat === !1 || o ? "none" === s.mode ? (r[l](), a()) : n.call(r[0], s, i) : (r.is(":hidden") ? "hide" === l : "show" === l) ? (r[l](), a()) : n.call(r[0], s, a);
        }var s = e.apply(this, arguments),
            n = t.effects.effect[s.effect],
            o = n.mode,
            a = s.queue,
            r = a || "fx",
            h = s.complete,
            l = s.mode,
            c = [],
            u = function u(e) {
          var i = t(this),
              s = t.effects.mode(i, l) || o;i.data(d, !0), c.push(s), o && ("show" === s || s === o && "hide" === s) && i.show(), o && "none" === s || t.effects.saveStyle(i), t.isFunction(e) && e();
        };return t.fx.off || !n ? l ? this[l](s.duration, h) : this.each(function () {
          h && h.call(this);
        }) : a === !1 ? this.each(u).each(i) : this.queue(r, u).queue(r, i);
      }, show: function (t) {
        return function (s) {
          if (i(s)) return t.apply(this, arguments);var n = e.apply(this, arguments);return n.mode = "show", this.effect.call(this, n);
        };
      }(t.fn.show), hide: function (t) {
        return function (s) {
          if (i(s)) return t.apply(this, arguments);var n = e.apply(this, arguments);return n.mode = "hide", this.effect.call(this, n);
        };
      }(t.fn.hide), toggle: function (t) {
        return function (s) {
          if (i(s) || "boolean" == typeof s) return t.apply(this, arguments);var n = e.apply(this, arguments);return n.mode = "toggle", this.effect.call(this, n);
        };
      }(t.fn.toggle), cssUnit: function cssUnit(e) {
        var i = this.css(e),
            s = [];return t.each(["em", "px", "%", "pt"], function (t, e) {
          i.indexOf(e) > 0 && (s = [parseFloat(i), e]);
        }), s;
      }, cssClip: function cssClip(t) {
        return t ? this.css("clip", "rect(" + t.top + "px " + t.right + "px " + t.bottom + "px " + t.left + "px)") : s(this.css("clip"), this);
      }, transfer: function transfer(e, i) {
        var s = t(this),
            n = t(e.to),
            o = "fixed" === n.css("position"),
            a = t("body"),
            r = o ? a.scrollTop() : 0,
            h = o ? a.scrollLeft() : 0,
            l = n.offset(),
            c = { top: l.top - r, left: l.left - h, height: n.innerHeight(), width: n.innerWidth() },
            u = s.offset(),
            d = t("<div class='ui-effects-transfer'></div>").appendTo("body").addClass(e.className).css({ top: u.top - r, left: u.left - h, height: s.innerHeight(), width: s.innerWidth(), position: o ? "fixed" : "absolute" }).animate(c, e.duration, e.easing, function () {
          d.remove(), t.isFunction(i) && i();
        });
      } }), t.fx.step.clip = function (e) {
      e.clipInit || (e.start = t(e.elem).cssClip(), "string" == typeof e.end && (e.end = s(e.end, e.elem)), e.clipInit = !0), t(e.elem).cssClip({ top: e.pos * (e.end.top - e.start.top) + e.start.top, right: e.pos * (e.end.right - e.start.right) + e.start.right, bottom: e.pos * (e.end.bottom - e.start.bottom) + e.start.bottom, left: e.pos * (e.end.left - e.start.left) + e.start.left });
    };
  }(), function () {
    var e = {};t.each(["Quad", "Cubic", "Quart", "Quint", "Expo"], function (t, i) {
      e[i] = function (e) {
        return Math.pow(e, t + 2);
      };
    }), t.extend(e, { Sine: function Sine(t) {
        return 1 - Math.cos(t * Math.PI / 2);
      }, Circ: function Circ(t) {
        return 1 - Math.sqrt(1 - t * t);
      }, Elastic: function Elastic(t) {
        return 0 === t || 1 === t ? t : -Math.pow(2, 8 * (t - 1)) * Math.sin((80 * (t - 1) - 7.5) * Math.PI / 15);
      }, Back: function Back(t) {
        return t * t * (3 * t - 2);
      }, Bounce: function Bounce(t) {
        for (var e, i = 4; ((e = Math.pow(2, --i)) - 1) / 11 > t;) {}return 1 / Math.pow(4, 3 - i) - 7.5625 * Math.pow((3 * e - 2) / 22 - t, 2);
      } }), t.each(e, function (e, i) {
      t.easing["easeIn" + e] = i, t.easing["easeOut" + e] = function (t) {
        return 1 - i(1 - t);
      }, t.easing["easeInOut" + e] = function (t) {
        return .5 > t ? i(2 * t) / 2 : 1 - i(-2 * t + 2) / 2;
      };
    });
  }();var f = t.effects;t.effects.define("blind", "hide", function (e, i) {
    var s = { up: ["bottom", "top"], vertical: ["bottom", "top"], down: ["top", "bottom"], left: ["right", "left"], horizontal: ["right", "left"], right: ["left", "right"] },
        n = t(this),
        o = e.direction || "up",
        a = n.cssClip(),
        r = { clip: t.extend({}, a) },
        h = t.effects.createPlaceholder(n);r.clip[s[o][0]] = r.clip[s[o][1]], "show" === e.mode && (n.cssClip(r.clip), h && h.css(t.effects.clipToBox(r)), r.clip = a), h && h.animate(t.effects.clipToBox(r), e.duration, e.easing), n.animate(r, { queue: !1, duration: e.duration, easing: e.easing, complete: i });
  }), t.effects.define("bounce", function (e, i) {
    var s,
        n,
        o,
        a = t(this),
        r = e.mode,
        h = "hide" === r,
        l = "show" === r,
        c = e.direction || "up",
        u = e.distance,
        d = e.times || 5,
        p = 2 * d + (l || h ? 1 : 0),
        f = e.duration / p,
        g = e.easing,
        m = "up" === c || "down" === c ? "top" : "left",
        _ = "up" === c || "left" === c,
        v = 0,
        b = a.queue().length;for (t.effects.createPlaceholder(a), o = a.css(m), u || (u = a["top" === m ? "outerHeight" : "outerWidth"]() / 3), l && (n = { opacity: 1 }, n[m] = o, a.css("opacity", 0).css(m, _ ? 2 * -u : 2 * u).animate(n, f, g)), h && (u /= Math.pow(2, d - 1)), n = {}, n[m] = o; d > v; v++) {
      s = {}, s[m] = (_ ? "-=" : "+=") + u, a.animate(s, f, g).animate(n, f, g), u = h ? 2 * u : u / 2;
    }h && (s = { opacity: 0 }, s[m] = (_ ? "-=" : "+=") + u, a.animate(s, f, g)), a.queue(i), t.effects.unshift(a, b, p + 1);
  }), t.effects.define("clip", "hide", function (e, i) {
    var s,
        n = {},
        o = t(this),
        a = e.direction || "vertical",
        r = "both" === a,
        h = r || "horizontal" === a,
        l = r || "vertical" === a;s = o.cssClip(), n.clip = { top: l ? (s.bottom - s.top) / 2 : s.top, right: h ? (s.right - s.left) / 2 : s.right, bottom: l ? (s.bottom - s.top) / 2 : s.bottom, left: h ? (s.right - s.left) / 2 : s.left }, t.effects.createPlaceholder(o), "show" === e.mode && (o.cssClip(n.clip), n.clip = s), o.animate(n, { queue: !1, duration: e.duration, easing: e.easing, complete: i });
  }), t.effects.define("drop", "hide", function (e, i) {
    var s,
        n = t(this),
        o = e.mode,
        a = "show" === o,
        r = e.direction || "left",
        h = "up" === r || "down" === r ? "top" : "left",
        l = "up" === r || "left" === r ? "-=" : "+=",
        c = "+=" === l ? "-=" : "+=",
        u = { opacity: 0 };t.effects.createPlaceholder(n), s = e.distance || n["top" === h ? "outerHeight" : "outerWidth"](!0) / 2, u[h] = l + s, a && (n.css(u), u[h] = c + s, u.opacity = 1), n.animate(u, { queue: !1, duration: e.duration, easing: e.easing, complete: i });
  }), t.effects.define("explode", "hide", function (e, i) {
    function s() {
      b.push(this), b.length === u * d && n();
    }function n() {
      p.css({ visibility: "visible" }), t(b).remove(), i();
    }var o,
        a,
        r,
        h,
        l,
        c,
        u = e.pieces ? Math.round(Math.sqrt(e.pieces)) : 3,
        d = u,
        p = t(this),
        f = e.mode,
        g = "show" === f,
        m = p.show().css("visibility", "hidden").offset(),
        _ = Math.ceil(p.outerWidth() / d),
        v = Math.ceil(p.outerHeight() / u),
        b = [];for (o = 0; u > o; o++) {
      for (h = m.top + o * v, c = o - (u - 1) / 2, a = 0; d > a; a++) {
        r = m.left + a * _, l = a - (d - 1) / 2, p.clone().appendTo("body").wrap("<div></div>").css({ position: "absolute", visibility: "visible", left: -a * _, top: -o * v }).parent().addClass("ui-effects-explode").css({ position: "absolute", overflow: "hidden", width: _, height: v, left: r + (g ? l * _ : 0), top: h + (g ? c * v : 0), opacity: g ? 0 : 1 }).animate({ left: r + (g ? 0 : l * _), top: h + (g ? 0 : c * v), opacity: g ? 1 : 0 }, e.duration || 500, e.easing, s);
      }
    }
  }), t.effects.define("fade", "toggle", function (e, i) {
    var s = "show" === e.mode;t(this).css("opacity", s ? 0 : 1).animate({ opacity: s ? 1 : 0 }, { queue: !1, duration: e.duration, easing: e.easing, complete: i });
  }), t.effects.define("fold", "hide", function (e, i) {
    var s = t(this),
        n = e.mode,
        o = "show" === n,
        a = "hide" === n,
        r = e.size || 15,
        h = /([0-9]+)%/.exec(r),
        l = !!e.horizFirst,
        c = l ? ["right", "bottom"] : ["bottom", "right"],
        u = e.duration / 2,
        d = t.effects.createPlaceholder(s),
        p = s.cssClip(),
        f = { clip: t.extend({}, p) },
        g = { clip: t.extend({}, p) },
        m = [p[c[0]], p[c[1]]],
        _ = s.queue().length;h && (r = parseInt(h[1], 10) / 100 * m[a ? 0 : 1]), f.clip[c[0]] = r, g.clip[c[0]] = r, g.clip[c[1]] = 0, o && (s.cssClip(g.clip), d && d.css(t.effects.clipToBox(g)), g.clip = p), s.queue(function (i) {
      d && d.animate(t.effects.clipToBox(f), u, e.easing).animate(t.effects.clipToBox(g), u, e.easing), i();
    }).animate(f, u, e.easing).animate(g, u, e.easing).queue(i), t.effects.unshift(s, _, 4);
  }), t.effects.define("highlight", "show", function (e, i) {
    var s = t(this),
        n = { backgroundColor: s.css("backgroundColor") };"hide" === e.mode && (n.opacity = 0), t.effects.saveStyle(s), s.css({ backgroundImage: "none", backgroundColor: e.color || "#ffff99" }).animate(n, { queue: !1, duration: e.duration, easing: e.easing, complete: i });
  }), t.effects.define("size", function (e, i) {
    var s,
        n,
        o,
        a = t(this),
        r = ["fontSize"],
        h = ["borderTopWidth", "borderBottomWidth", "paddingTop", "paddingBottom"],
        l = ["borderLeftWidth", "borderRightWidth", "paddingLeft", "paddingRight"],
        c = e.mode,
        u = "effect" !== c,
        d = e.scale || "both",
        p = e.origin || ["middle", "center"],
        f = a.css("position"),
        g = a.position(),
        m = t.effects.scaledDimensions(a),
        _ = e.from || m,
        v = e.to || t.effects.scaledDimensions(a, 0);t.effects.createPlaceholder(a), "show" === c && (o = _, _ = v, v = o), n = { from: { y: _.height / m.height, x: _.width / m.width }, to: { y: v.height / m.height, x: v.width / m.width } }, ("box" === d || "both" === d) && (n.from.y !== n.to.y && (_ = t.effects.setTransition(a, h, n.from.y, _), v = t.effects.setTransition(a, h, n.to.y, v)), n.from.x !== n.to.x && (_ = t.effects.setTransition(a, l, n.from.x, _), v = t.effects.setTransition(a, l, n.to.x, v))), ("content" === d || "both" === d) && n.from.y !== n.to.y && (_ = t.effects.setTransition(a, r, n.from.y, _), v = t.effects.setTransition(a, r, n.to.y, v)), p && (s = t.effects.getBaseline(p, m), _.top = (m.outerHeight - _.outerHeight) * s.y + g.top, _.left = (m.outerWidth - _.outerWidth) * s.x + g.left, v.top = (m.outerHeight - v.outerHeight) * s.y + g.top, v.left = (m.outerWidth - v.outerWidth) * s.x + g.left), a.css(_), ("content" === d || "both" === d) && (h = h.concat(["marginTop", "marginBottom"]).concat(r), l = l.concat(["marginLeft", "marginRight"]), a.find("*[width]").each(function () {
      var i = t(this),
          s = t.effects.scaledDimensions(i),
          o = { height: s.height * n.from.y, width: s.width * n.from.x, outerHeight: s.outerHeight * n.from.y, outerWidth: s.outerWidth * n.from.x },
          a = { height: s.height * n.to.y, width: s.width * n.to.x, outerHeight: s.height * n.to.y, outerWidth: s.width * n.to.x };n.from.y !== n.to.y && (o = t.effects.setTransition(i, h, n.from.y, o), a = t.effects.setTransition(i, h, n.to.y, a)), n.from.x !== n.to.x && (o = t.effects.setTransition(i, l, n.from.x, o), a = t.effects.setTransition(i, l, n.to.x, a)), u && t.effects.saveStyle(i), i.css(o), i.animate(a, e.duration, e.easing, function () {
        u && t.effects.restoreStyle(i);
      });
    })), a.animate(v, { queue: !1, duration: e.duration, easing: e.easing, complete: function complete() {
        var e = a.offset();0 === v.opacity && a.css("opacity", _.opacity), u || (a.css("position", "static" === f ? "relative" : f).offset(e), t.effects.saveStyle(a)), i();
      } });
  }), t.effects.define("scale", function (e, i) {
    var s = t(this),
        n = e.mode,
        o = parseInt(e.percent, 10) || (0 === parseInt(e.percent, 10) ? 0 : "effect" !== n ? 0 : 100),
        a = t.extend(!0, { from: t.effects.scaledDimensions(s), to: t.effects.scaledDimensions(s, o, e.direction || "both"), origin: e.origin || ["middle", "center"] }, e);e.fade && (a.from.opacity = 1, a.to.opacity = 0), t.effects.effect.size.call(this, a, i);
  }), t.effects.define("puff", "hide", function (e, i) {
    var s = t.extend(!0, {}, e, { fade: !0, percent: parseInt(e.percent, 10) || 150 });t.effects.effect.scale.call(this, s, i);
  }), t.effects.define("pulsate", "show", function (e, i) {
    var s = t(this),
        n = e.mode,
        o = "show" === n,
        a = "hide" === n,
        r = o || a,
        h = 2 * (e.times || 5) + (r ? 1 : 0),
        l = e.duration / h,
        c = 0,
        u = 1,
        d = s.queue().length;for ((o || !s.is(":visible")) && (s.css("opacity", 0).show(), c = 1); h > u; u++) {
      s.animate({ opacity: c }, l, e.easing), c = 1 - c;
    }s.animate({ opacity: c }, l, e.easing), s.queue(i), t.effects.unshift(s, d, h + 1);
  }), t.effects.define("shake", function (e, i) {
    var s = 1,
        n = t(this),
        o = e.direction || "left",
        a = e.distance || 20,
        r = e.times || 3,
        h = 2 * r + 1,
        l = Math.round(e.duration / h),
        c = "up" === o || "down" === o ? "top" : "left",
        u = "up" === o || "left" === o,
        d = {},
        p = {},
        f = {},
        g = n.queue().length;for (t.effects.createPlaceholder(n), d[c] = (u ? "-=" : "+=") + a, p[c] = (u ? "+=" : "-=") + 2 * a, f[c] = (u ? "-=" : "+=") + 2 * a, n.animate(d, l, e.easing); r > s; s++) {
      n.animate(p, l, e.easing).animate(f, l, e.easing);
    }n.animate(p, l, e.easing).animate(d, l / 2, e.easing).queue(i), t.effects.unshift(n, g, h + 1);
  }), t.effects.define("slide", "show", function (e, i) {
    var s,
        n,
        o = t(this),
        a = { up: ["bottom", "top"], down: ["top", "bottom"], left: ["right", "left"], right: ["left", "right"] },
        r = e.mode,
        h = e.direction || "left",
        l = "up" === h || "down" === h ? "top" : "left",
        c = "up" === h || "left" === h,
        u = e.distance || o["top" === l ? "outerHeight" : "outerWidth"](!0),
        d = {};t.effects.createPlaceholder(o), s = o.cssClip(), n = o.position()[l], d[l] = (c ? -1 : 1) * u + n, d.clip = o.cssClip(), d.clip[a[h][1]] = d.clip[a[h][0]], "show" === r && (o.cssClip(d.clip), o.css(l, d[l]), d.clip = s, d[l] = n), o.animate(d, { queue: !1, duration: e.duration, easing: e.easing, complete: i });
  });var f;t.uiBackCompat !== !1 && (f = t.effects.define("transfer", function (e, i) {
    t(this).transfer(e, i);
  })), t.ui.focusable = function (i, s) {
    var n,
        o,
        a,
        r,
        h,
        l = i.nodeName.toLowerCase();return "area" === l ? (n = i.parentNode, o = n.name, i.href && o && "map" === n.nodeName.toLowerCase() ? (a = t("img[usemap='#" + o + "']"), a.length > 0 && a.is(":visible")) : !1) : (/^(input|select|textarea|button|object)$/.test(l) ? (r = !i.disabled, r && (h = t(i).closest("fieldset")[0], h && (r = !h.disabled))) : r = "a" === l ? i.href || s : s, r && t(i).is(":visible") && e(t(i)));
  }, t.extend(t.expr[":"], { focusable: function focusable(e) {
      return t.ui.focusable(e, null != t.attr(e, "tabindex"));
    } }), t.ui.focusable, t.fn.form = function () {
    return "string" == typeof this[0].form ? this.closest("form") : t(this[0].form);
  }, t.ui.formResetMixin = { _formResetHandler: function _formResetHandler() {
      var e = t(this);setTimeout(function () {
        var i = e.data("ui-form-reset-instances");t.each(i, function () {
          this.refresh();
        });
      });
    }, _bindFormResetHandler: function _bindFormResetHandler() {
      if (this.form = this.element.form(), this.form.length) {
        var t = this.form.data("ui-form-reset-instances") || [];t.length || this.form.on("reset.ui-form-reset", this._formResetHandler), t.push(this), this.form.data("ui-form-reset-instances", t);
      }
    }, _unbindFormResetHandler: function _unbindFormResetHandler() {
      if (this.form.length) {
        var e = this.form.data("ui-form-reset-instances");e.splice(t.inArray(this, e), 1), e.length ? this.form.data("ui-form-reset-instances", e) : this.form.removeData("ui-form-reset-instances").off("reset.ui-form-reset");
      }
    } }, "1.7" === t.fn.jquery.substring(0, 3) && (t.each(["Width", "Height"], function (e, i) {
    function s(e, i, s, o) {
      return t.each(n, function () {
        i -= parseFloat(t.css(e, "padding" + this)) || 0, s && (i -= parseFloat(t.css(e, "border" + this + "Width")) || 0), o && (i -= parseFloat(t.css(e, "margin" + this)) || 0);
      }), i;
    }var n = "Width" === i ? ["Left", "Right"] : ["Top", "Bottom"],
        o = i.toLowerCase(),
        a = { innerWidth: t.fn.innerWidth, innerHeight: t.fn.innerHeight, outerWidth: t.fn.outerWidth, outerHeight: t.fn.outerHeight };t.fn["inner" + i] = function (e) {
      return void 0 === e ? a["inner" + i].call(this) : this.each(function () {
        t(this).css(o, s(this, e) + "px");
      });
    }, t.fn["outer" + i] = function (e, n) {
      return "number" != typeof e ? a["outer" + i].call(this, e) : this.each(function () {
        t(this).css(o, s(this, e, !0, n) + "px");
      });
    };
  }), t.fn.addBack = function (t) {
    return this.add(null == t ? this.prevObject : this.prevObject.filter(t));
  }), t.ui.keyCode = { BACKSPACE: 8, COMMA: 188, DELETE: 46, DOWN: 40, END: 35, ENTER: 13, ESCAPE: 27, HOME: 36, LEFT: 37, PAGE_DOWN: 34, PAGE_UP: 33, PERIOD: 190, RIGHT: 39, SPACE: 32, TAB: 9, UP: 38 }, t.ui.escapeSelector = function () {
    var t = /([!"#$%&'()*+,./:;<=>?@[\]^`{|}~])/g;return function (e) {
      return e.replace(t, "\\$1");
    };
  }(), t.fn.labels = function () {
    var e, i, s, n, o;return this[0].labels && this[0].labels.length ? this.pushStack(this[0].labels) : (n = this.eq(0).parents("label"), s = this.attr("id"), s && (e = this.eq(0).parents().last(), o = e.add(e.length ? e.siblings() : this.siblings()), i = "label[for='" + t.ui.escapeSelector(s) + "']", n = n.add(o.find(i).addBack(i))), this.pushStack(n));
  }, t.fn.scrollParent = function (e) {
    var i = this.css("position"),
        s = "absolute" === i,
        n = e ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
        o = this.parents().filter(function () {
      var e = t(this);return s && "static" === e.css("position") ? !1 : n.test(e.css("overflow") + e.css("overflow-y") + e.css("overflow-x"));
    }).eq(0);return "fixed" !== i && o.length ? o : t(this[0].ownerDocument || document);
  }, t.extend(t.expr[":"], { tabbable: function tabbable(e) {
      var i = t.attr(e, "tabindex"),
          s = null != i;return (!s || i >= 0) && t.ui.focusable(e, s);
    } }), t.fn.extend({ uniqueId: function () {
      var t = 0;return function () {
        return this.each(function () {
          this.id || (this.id = "ui-id-" + ++t);
        });
      };
    }(), removeUniqueId: function removeUniqueId() {
      return this.each(function () {
        /^ui-id-\d+$/.test(this.id) && t(this).removeAttr("id");
      });
    } }), t.widget("ui.accordion", { version: "1.12.1", options: { active: 0, animate: {}, classes: { "ui-accordion-header": "ui-corner-top", "ui-accordion-header-collapsed": "ui-corner-all", "ui-accordion-content": "ui-corner-bottom" }, collapsible: !1, event: "click", header: "> li > :first-child, > :not(li):even", heightStyle: "auto", icons: { activeHeader: "ui-icon-triangle-1-s", header: "ui-icon-triangle-1-e" }, activate: null, beforeActivate: null }, hideProps: { borderTopWidth: "hide", borderBottomWidth: "hide", paddingTop: "hide", paddingBottom: "hide", height: "hide" }, showProps: { borderTopWidth: "show", borderBottomWidth: "show", paddingTop: "show", paddingBottom: "show", height: "show" }, _create: function _create() {
      var e = this.options;this.prevShow = this.prevHide = t(), this._addClass("ui-accordion", "ui-widget ui-helper-reset"), this.element.attr("role", "tablist"), e.collapsible || e.active !== !1 && null != e.active || (e.active = 0), this._processPanels(), 0 > e.active && (e.active += this.headers.length), this._refresh();
    }, _getCreateEventData: function _getCreateEventData() {
      return { header: this.active, panel: this.active.length ? this.active.next() : t() };
    }, _createIcons: function _createIcons() {
      var e,
          i,
          s = this.options.icons;s && (e = t("<span>"), this._addClass(e, "ui-accordion-header-icon", "ui-icon " + s.header), e.prependTo(this.headers), i = this.active.children(".ui-accordion-header-icon"), this._removeClass(i, s.header)._addClass(i, null, s.activeHeader)._addClass(this.headers, "ui-accordion-icons"));
    }, _destroyIcons: function _destroyIcons() {
      this._removeClass(this.headers, "ui-accordion-icons"), this.headers.children(".ui-accordion-header-icon").remove();
    }, _destroy: function _destroy() {
      var t;this.element.removeAttr("role"), this.headers.removeAttr("role aria-expanded aria-selected aria-controls tabIndex").removeUniqueId(), this._destroyIcons(), t = this.headers.next().css("display", "").removeAttr("role aria-hidden aria-labelledby").removeUniqueId(), "content" !== this.options.heightStyle && t.css("height", "");
    }, _setOption: function _setOption(t, e) {
      return "active" === t ? (this._activate(e), void 0) : ("event" === t && (this.options.event && this._off(this.headers, this.options.event), this._setupEvents(e)), this._super(t, e), "collapsible" !== t || e || this.options.active !== !1 || this._activate(0), "icons" === t && (this._destroyIcons(), e && this._createIcons()), void 0);
    }, _setOptionDisabled: function _setOptionDisabled(t) {
      this._super(t), this.element.attr("aria-disabled", t), this._toggleClass(null, "ui-state-disabled", !!t), this._toggleClass(this.headers.add(this.headers.next()), null, "ui-state-disabled", !!t);
    }, _keydown: function _keydown(e) {
      if (!e.altKey && !e.ctrlKey) {
        var i = t.ui.keyCode,
            s = this.headers.length,
            n = this.headers.index(e.target),
            o = !1;switch (e.keyCode) {case i.RIGHT:case i.DOWN:
            o = this.headers[(n + 1) % s];break;case i.LEFT:case i.UP:
            o = this.headers[(n - 1 + s) % s];break;case i.SPACE:case i.ENTER:
            this._eventHandler(e);break;case i.HOME:
            o = this.headers[0];break;case i.END:
            o = this.headers[s - 1];}o && (t(e.target).attr("tabIndex", -1), t(o).attr("tabIndex", 0), t(o).trigger("focus"), e.preventDefault());
      }
    }, _panelKeyDown: function _panelKeyDown(e) {
      e.keyCode === t.ui.keyCode.UP && e.ctrlKey && t(e.currentTarget).prev().trigger("focus");
    }, refresh: function refresh() {
      var e = this.options;this._processPanels(), e.active === !1 && e.collapsible === !0 || !this.headers.length ? (e.active = !1, this.active = t()) : e.active === !1 ? this._activate(0) : this.active.length && !t.contains(this.element[0], this.active[0]) ? this.headers.length === this.headers.find(".ui-state-disabled").length ? (e.active = !1, this.active = t()) : this._activate(Math.max(0, e.active - 1)) : e.active = this.headers.index(this.active), this._destroyIcons(), this._refresh();
    }, _processPanels: function _processPanels() {
      var t = this.headers,
          e = this.panels;this.headers = this.element.find(this.options.header), this._addClass(this.headers, "ui-accordion-header ui-accordion-header-collapsed", "ui-state-default"), this.panels = this.headers.next().filter(":not(.ui-accordion-content-active)").hide(), this._addClass(this.panels, "ui-accordion-content", "ui-helper-reset ui-widget-content"), e && (this._off(t.not(this.headers)), this._off(e.not(this.panels)));
    }, _refresh: function _refresh() {
      var e,
          i = this.options,
          s = i.heightStyle,
          n = this.element.parent();this.active = this._findActive(i.active), this._addClass(this.active, "ui-accordion-header-active", "ui-state-active")._removeClass(this.active, "ui-accordion-header-collapsed"), this._addClass(this.active.next(), "ui-accordion-content-active"), this.active.next().show(), this.headers.attr("role", "tab").each(function () {
        var e = t(this),
            i = e.uniqueId().attr("id"),
            s = e.next(),
            n = s.uniqueId().attr("id");e.attr("aria-controls", n), s.attr("aria-labelledby", i);
      }).next().attr("role", "tabpanel"), this.headers.not(this.active).attr({ "aria-selected": "false", "aria-expanded": "false", tabIndex: -1 }).next().attr({ "aria-hidden": "true" }).hide(), this.active.length ? this.active.attr({ "aria-selected": "true", "aria-expanded": "true", tabIndex: 0 }).next().attr({ "aria-hidden": "false" }) : this.headers.eq(0).attr("tabIndex", 0), this._createIcons(), this._setupEvents(i.event), "fill" === s ? (e = n.height(), this.element.siblings(":visible").each(function () {
        var i = t(this),
            s = i.css("position");"absolute" !== s && "fixed" !== s && (e -= i.outerHeight(!0));
      }), this.headers.each(function () {
        e -= t(this).outerHeight(!0);
      }), this.headers.next().each(function () {
        t(this).height(Math.max(0, e - t(this).innerHeight() + t(this).height()));
      }).css("overflow", "auto")) : "auto" === s && (e = 0, this.headers.next().each(function () {
        var i = t(this).is(":visible");i || t(this).show(), e = Math.max(e, t(this).css("height", "").height()), i || t(this).hide();
      }).height(e));
    }, _activate: function _activate(e) {
      var i = this._findActive(e)[0];i !== this.active[0] && (i = i || this.active[0], this._eventHandler({ target: i, currentTarget: i, preventDefault: t.noop }));
    }, _findActive: function _findActive(e) {
      return "number" == typeof e ? this.headers.eq(e) : t();
    }, _setupEvents: function _setupEvents(e) {
      var i = { keydown: "_keydown" };e && t.each(e.split(" "), function (t, e) {
        i[e] = "_eventHandler";
      }), this._off(this.headers.add(this.headers.next())), this._on(this.headers, i), this._on(this.headers.next(), { keydown: "_panelKeyDown" }), this._hoverable(this.headers), this._focusable(this.headers);
    }, _eventHandler: function _eventHandler(e) {
      var i,
          s,
          n = this.options,
          o = this.active,
          a = t(e.currentTarget),
          r = a[0] === o[0],
          h = r && n.collapsible,
          l = h ? t() : a.next(),
          c = o.next(),
          u = { oldHeader: o, oldPanel: c, newHeader: h ? t() : a, newPanel: l };e.preventDefault(), r && !n.collapsible || this._trigger("beforeActivate", e, u) === !1 || (n.active = h ? !1 : this.headers.index(a), this.active = r ? t() : a, this._toggle(u), this._removeClass(o, "ui-accordion-header-active", "ui-state-active"), n.icons && (i = o.children(".ui-accordion-header-icon"), this._removeClass(i, null, n.icons.activeHeader)._addClass(i, null, n.icons.header)), r || (this._removeClass(a, "ui-accordion-header-collapsed")._addClass(a, "ui-accordion-header-active", "ui-state-active"), n.icons && (s = a.children(".ui-accordion-header-icon"), this._removeClass(s, null, n.icons.header)._addClass(s, null, n.icons.activeHeader)), this._addClass(a.next(), "ui-accordion-content-active")));
    }, _toggle: function _toggle(e) {
      var i = e.newPanel,
          s = this.prevShow.length ? this.prevShow : e.oldPanel;this.prevShow.add(this.prevHide).stop(!0, !0), this.prevShow = i, this.prevHide = s, this.options.animate ? this._animate(i, s, e) : (s.hide(), i.show(), this._toggleComplete(e)), s.attr({ "aria-hidden": "true" }), s.prev().attr({ "aria-selected": "false", "aria-expanded": "false" }), i.length && s.length ? s.prev().attr({ tabIndex: -1, "aria-expanded": "false" }) : i.length && this.headers.filter(function () {
        return 0 === parseInt(t(this).attr("tabIndex"), 10);
      }).attr("tabIndex", -1), i.attr("aria-hidden", "false").prev().attr({ "aria-selected": "true", "aria-expanded": "true", tabIndex: 0 });
    }, _animate: function _animate(t, e, i) {
      var s,
          n,
          o,
          a = this,
          r = 0,
          h = t.css("box-sizing"),
          l = t.length && (!e.length || t.index() < e.index()),
          c = this.options.animate || {},
          u = l && c.down || c,
          d = function d() {
        a._toggleComplete(i);
      };return "number" == typeof u && (o = u), "string" == typeof u && (n = u), n = n || u.easing || c.easing, o = o || u.duration || c.duration, e.length ? t.length ? (s = t.show().outerHeight(), e.animate(this.hideProps, { duration: o, easing: n, step: function step(t, e) {
          e.now = Math.round(t);
        } }), t.hide().animate(this.showProps, { duration: o, easing: n, complete: d, step: function step(t, i) {
          i.now = Math.round(t), "height" !== i.prop ? "content-box" === h && (r += i.now) : "content" !== a.options.heightStyle && (i.now = Math.round(s - e.outerHeight() - r), r = 0);
        } }), void 0) : e.animate(this.hideProps, o, n, d) : t.animate(this.showProps, o, n, d);
    }, _toggleComplete: function _toggleComplete(t) {
      var e = t.oldPanel,
          i = e.prev();this._removeClass(e, "ui-accordion-content-active"), this._removeClass(i, "ui-accordion-header-active")._addClass(i, "ui-accordion-header-collapsed"), e.length && (e.parent()[0].className = e.parent()[0].className), this._trigger("activate", null, t);
    } }), t.ui.safeActiveElement = function (t) {
    var e;try {
      e = t.activeElement;
    } catch (i) {
      e = t.body;
    }return e || (e = t.body), e.nodeName || (e = t.body), e;
  }, t.widget("ui.menu", { version: "1.12.1", defaultElement: "<ul>", delay: 300, options: { icons: { submenu: "ui-icon-caret-1-e" }, items: "> *", menus: "ul", position: { my: "left top", at: "right top" }, role: "menu", blur: null, focus: null, select: null }, _create: function _create() {
      this.activeMenu = this.element, this.mouseHandled = !1, this.element.uniqueId().attr({ role: this.options.role, tabIndex: 0 }), this._addClass("ui-menu", "ui-widget ui-widget-content"), this._on({ "mousedown .ui-menu-item": function mousedownUiMenuItem(t) {
          t.preventDefault();
        }, "click .ui-menu-item": function clickUiMenuItem(e) {
          var i = t(e.target),
              s = t(t.ui.safeActiveElement(this.document[0]));!this.mouseHandled && i.not(".ui-state-disabled").length && (this.select(e), e.isPropagationStopped() || (this.mouseHandled = !0), i.has(".ui-menu").length ? this.expand(e) : !this.element.is(":focus") && s.closest(".ui-menu").length && (this.element.trigger("focus", [!0]), this.active && 1 === this.active.parents(".ui-menu").length && clearTimeout(this.timer)));
        }, "mouseenter .ui-menu-item": function mouseenterUiMenuItem(e) {
          if (!this.previousFilter) {
            var i = t(e.target).closest(".ui-menu-item"),
                s = t(e.currentTarget);i[0] === s[0] && (this._removeClass(s.siblings().children(".ui-state-active"), null, "ui-state-active"), this.focus(e, s));
          }
        }, mouseleave: "collapseAll", "mouseleave .ui-menu": "collapseAll", focus: function focus(t, e) {
          var i = this.active || this.element.find(this.options.items).eq(0);e || this.focus(t, i);
        }, blur: function blur(e) {
          this._delay(function () {
            var i = !t.contains(this.element[0], t.ui.safeActiveElement(this.document[0]));i && this.collapseAll(e);
          });
        }, keydown: "_keydown" }), this.refresh(), this._on(this.document, { click: function click(t) {
          this._closeOnDocumentClick(t) && this.collapseAll(t), this.mouseHandled = !1;
        } });
    }, _destroy: function _destroy() {
      var e = this.element.find(".ui-menu-item").removeAttr("role aria-disabled"),
          i = e.children(".ui-menu-item-wrapper").removeUniqueId().removeAttr("tabIndex role aria-haspopup");this.element.removeAttr("aria-activedescendant").find(".ui-menu").addBack().removeAttr("role aria-labelledby aria-expanded aria-hidden aria-disabled tabIndex").removeUniqueId().show(), i.children().each(function () {
        var e = t(this);e.data("ui-menu-submenu-caret") && e.remove();
      });
    }, _keydown: function _keydown(e) {
      var i,
          s,
          n,
          o,
          a = !0;switch (e.keyCode) {case t.ui.keyCode.PAGE_UP:
          this.previousPage(e);break;case t.ui.keyCode.PAGE_DOWN:
          this.nextPage(e);break;case t.ui.keyCode.HOME:
          this._move("first", "first", e);break;case t.ui.keyCode.END:
          this._move("last", "last", e);break;case t.ui.keyCode.UP:
          this.previous(e);break;case t.ui.keyCode.DOWN:
          this.next(e);break;case t.ui.keyCode.LEFT:
          this.collapse(e);break;case t.ui.keyCode.RIGHT:
          this.active && !this.active.is(".ui-state-disabled") && this.expand(e);break;case t.ui.keyCode.ENTER:case t.ui.keyCode.SPACE:
          this._activate(e);break;case t.ui.keyCode.ESCAPE:
          this.collapse(e);break;default:
          a = !1, s = this.previousFilter || "", o = !1, n = e.keyCode >= 96 && 105 >= e.keyCode ? "" + (e.keyCode - 96) : String.fromCharCode(e.keyCode), clearTimeout(this.filterTimer), n === s ? o = !0 : n = s + n, i = this._filterMenuItems(n), i = o && -1 !== i.index(this.active.next()) ? this.active.nextAll(".ui-menu-item") : i, i.length || (n = String.fromCharCode(e.keyCode), i = this._filterMenuItems(n)), i.length ? (this.focus(e, i), this.previousFilter = n, this.filterTimer = this._delay(function () {
            delete this.previousFilter;
          }, 1e3)) : delete this.previousFilter;}a && e.preventDefault();
    }, _activate: function _activate(t) {
      this.active && !this.active.is(".ui-state-disabled") && (this.active.children("[aria-haspopup='true']").length ? this.expand(t) : this.select(t));
    }, refresh: function refresh() {
      var e,
          i,
          s,
          n,
          o,
          a = this,
          r = this.options.icons.submenu,
          h = this.element.find(this.options.menus);this._toggleClass("ui-menu-icons", null, !!this.element.find(".ui-icon").length), s = h.filter(":not(.ui-menu)").hide().attr({ role: this.options.role, "aria-hidden": "true", "aria-expanded": "false" }).each(function () {
        var e = t(this),
            i = e.prev(),
            s = t("<span>").data("ui-menu-submenu-caret", !0);a._addClass(s, "ui-menu-icon", "ui-icon " + r), i.attr("aria-haspopup", "true").prepend(s), e.attr("aria-labelledby", i.attr("id"));
      }), this._addClass(s, "ui-menu", "ui-widget ui-widget-content ui-front"), e = h.add(this.element), i = e.find(this.options.items), i.not(".ui-menu-item").each(function () {
        var e = t(this);a._isDivider(e) && a._addClass(e, "ui-menu-divider", "ui-widget-content");
      }), n = i.not(".ui-menu-item, .ui-menu-divider"), o = n.children().not(".ui-menu").uniqueId().attr({ tabIndex: -1, role: this._itemRole() }), this._addClass(n, "ui-menu-item")._addClass(o, "ui-menu-item-wrapper"), i.filter(".ui-state-disabled").attr("aria-disabled", "true"), this.active && !t.contains(this.element[0], this.active[0]) && this.blur();
    }, _itemRole: function _itemRole() {
      return { menu: "menuitem", listbox: "option" }[this.options.role];
    }, _setOption: function _setOption(t, e) {
      if ("icons" === t) {
        var i = this.element.find(".ui-menu-icon");this._removeClass(i, null, this.options.icons.submenu)._addClass(i, null, e.submenu);
      }this._super(t, e);
    }, _setOptionDisabled: function _setOptionDisabled(t) {
      this._super(t), this.element.attr("aria-disabled", t + ""), this._toggleClass(null, "ui-state-disabled", !!t);
    }, focus: function focus(t, e) {
      var i, s, n;this.blur(t, t && "focus" === t.type), this._scrollIntoView(e), this.active = e.first(), s = this.active.children(".ui-menu-item-wrapper"), this._addClass(s, null, "ui-state-active"), this.options.role && this.element.attr("aria-activedescendant", s.attr("id")), n = this.active.parent().closest(".ui-menu-item").children(".ui-menu-item-wrapper"), this._addClass(n, null, "ui-state-active"), t && "keydown" === t.type ? this._close() : this.timer = this._delay(function () {
        this._close();
      }, this.delay), i = e.children(".ui-menu"), i.length && t && /^mouse/.test(t.type) && this._startOpening(i), this.activeMenu = e.parent(), this._trigger("focus", t, { item: e });
    }, _scrollIntoView: function _scrollIntoView(e) {
      var i, s, n, o, a, r;this._hasScroll() && (i = parseFloat(t.css(this.activeMenu[0], "borderTopWidth")) || 0, s = parseFloat(t.css(this.activeMenu[0], "paddingTop")) || 0, n = e.offset().top - this.activeMenu.offset().top - i - s, o = this.activeMenu.scrollTop(), a = this.activeMenu.height(), r = e.outerHeight(), 0 > n ? this.activeMenu.scrollTop(o + n) : n + r > a && this.activeMenu.scrollTop(o + n - a + r));
    }, blur: function blur(t, e) {
      e || clearTimeout(this.timer), this.active && (this._removeClass(this.active.children(".ui-menu-item-wrapper"), null, "ui-state-active"), this._trigger("blur", t, { item: this.active }), this.active = null);
    }, _startOpening: function _startOpening(t) {
      clearTimeout(this.timer), "true" === t.attr("aria-hidden") && (this.timer = this._delay(function () {
        this._close(), this._open(t);
      }, this.delay));
    }, _open: function _open(e) {
      var i = t.extend({ of: this.active }, this.options.position);clearTimeout(this.timer), this.element.find(".ui-menu").not(e.parents(".ui-menu")).hide().attr("aria-hidden", "true"), e.show().removeAttr("aria-hidden").attr("aria-expanded", "true").position(i);
    }, collapseAll: function collapseAll(e, i) {
      clearTimeout(this.timer), this.timer = this._delay(function () {
        var s = i ? this.element : t(e && e.target).closest(this.element.find(".ui-menu"));s.length || (s = this.element), this._close(s), this.blur(e), this._removeClass(s.find(".ui-state-active"), null, "ui-state-active"), this.activeMenu = s;
      }, this.delay);
    }, _close: function _close(t) {
      t || (t = this.active ? this.active.parent() : this.element), t.find(".ui-menu").hide().attr("aria-hidden", "true").attr("aria-expanded", "false");
    }, _closeOnDocumentClick: function _closeOnDocumentClick(e) {
      return !t(e.target).closest(".ui-menu").length;
    }, _isDivider: function _isDivider(t) {
      return !/[^\-\u2014\u2013\s]/.test(t.text());
    }, collapse: function collapse(t) {
      var e = this.active && this.active.parent().closest(".ui-menu-item", this.element);e && e.length && (this._close(), this.focus(t, e));
    }, expand: function expand(t) {
      var e = this.active && this.active.children(".ui-menu ").find(this.options.items).first();e && e.length && (this._open(e.parent()), this._delay(function () {
        this.focus(t, e);
      }));
    }, next: function next(t) {
      this._move("next", "first", t);
    }, previous: function previous(t) {
      this._move("prev", "last", t);
    }, isFirstItem: function isFirstItem() {
      return this.active && !this.active.prevAll(".ui-menu-item").length;
    }, isLastItem: function isLastItem() {
      return this.active && !this.active.nextAll(".ui-menu-item").length;
    }, _move: function _move(t, e, i) {
      var s;this.active && (s = "first" === t || "last" === t ? this.active["first" === t ? "prevAll" : "nextAll"](".ui-menu-item").eq(-1) : this.active[t + "All"](".ui-menu-item").eq(0)), s && s.length && this.active || (s = this.activeMenu.find(this.options.items)[e]()), this.focus(i, s);
    }, nextPage: function nextPage(e) {
      var i, s, n;return this.active ? (this.isLastItem() || (this._hasScroll() ? (s = this.active.offset().top, n = this.element.height(), this.active.nextAll(".ui-menu-item").each(function () {
        return i = t(this), 0 > i.offset().top - s - n;
      }), this.focus(e, i)) : this.focus(e, this.activeMenu.find(this.options.items)[this.active ? "last" : "first"]())), void 0) : (this.next(e), void 0);
    }, previousPage: function previousPage(e) {
      var i, s, n;return this.active ? (this.isFirstItem() || (this._hasScroll() ? (s = this.active.offset().top, n = this.element.height(), this.active.prevAll(".ui-menu-item").each(function () {
        return i = t(this), i.offset().top - s + n > 0;
      }), this.focus(e, i)) : this.focus(e, this.activeMenu.find(this.options.items).first())), void 0) : (this.next(e), void 0);
    }, _hasScroll: function _hasScroll() {
      return this.element.outerHeight() < this.element.prop("scrollHeight");
    }, select: function select(e) {
      this.active = this.active || t(e.target).closest(".ui-menu-item");var i = { item: this.active };this.active.has(".ui-menu").length || this.collapseAll(e, !0), this._trigger("select", e, i);
    }, _filterMenuItems: function _filterMenuItems(e) {
      var i = e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&"),
          s = RegExp("^" + i, "i");return this.activeMenu.find(this.options.items).filter(".ui-menu-item").filter(function () {
        return s.test(t.trim(t(this).children(".ui-menu-item-wrapper").text()));
      });
    } }), t.widget("ui.autocomplete", { version: "1.12.1", defaultElement: "<input>", options: { appendTo: null, autoFocus: !1, delay: 300, minLength: 1, position: { my: "left top", at: "left bottom", collision: "none" }, source: null, change: null, close: null, focus: null, open: null, response: null, search: null, select: null }, requestIndex: 0, pending: 0, _create: function _create() {
      var e,
          i,
          s,
          n = this.element[0].nodeName.toLowerCase(),
          o = "textarea" === n,
          a = "input" === n;
      this.isMultiLine = o || !a && this._isContentEditable(this.element), this.valueMethod = this.element[o || a ? "val" : "text"], this.isNewMenu = !0, this._addClass("ui-autocomplete-input"), this.element.attr("autocomplete", "off"), this._on(this.element, { keydown: function keydown(n) {
          if (this.element.prop("readOnly")) return e = !0, s = !0, i = !0, void 0;e = !1, s = !1, i = !1;var o = t.ui.keyCode;switch (n.keyCode) {case o.PAGE_UP:
              e = !0, this._move("previousPage", n);break;case o.PAGE_DOWN:
              e = !0, this._move("nextPage", n);break;case o.UP:
              e = !0, this._keyEvent("previous", n);break;case o.DOWN:
              e = !0, this._keyEvent("next", n);break;case o.ENTER:
              this.menu.active && (e = !0, n.preventDefault(), this.menu.select(n));break;case o.TAB:
              this.menu.active && this.menu.select(n);break;case o.ESCAPE:
              this.menu.element.is(":visible") && (this.isMultiLine || this._value(this.term), this.close(n), n.preventDefault());break;default:
              i = !0, this._searchTimeout(n);}
        }, keypress: function keypress(s) {
          if (e) return e = !1, (!this.isMultiLine || this.menu.element.is(":visible")) && s.preventDefault(), void 0;if (!i) {
            var n = t.ui.keyCode;switch (s.keyCode) {case n.PAGE_UP:
                this._move("previousPage", s);break;case n.PAGE_DOWN:
                this._move("nextPage", s);break;case n.UP:
                this._keyEvent("previous", s);break;case n.DOWN:
                this._keyEvent("next", s);}
          }
        }, input: function input(t) {
          return s ? (s = !1, t.preventDefault(), void 0) : (this._searchTimeout(t), void 0);
        }, focus: function focus() {
          this.selectedItem = null, this.previous = this._value();
        }, blur: function blur(t) {
          return this.cancelBlur ? (delete this.cancelBlur, void 0) : (clearTimeout(this.searching), this.close(t), this._change(t), void 0);
        } }), this._initSource(), this.menu = t("<ul>").appendTo(this._appendTo()).menu({ role: null }).hide().menu("instance"), this._addClass(this.menu.element, "ui-autocomplete", "ui-front"), this._on(this.menu.element, { mousedown: function mousedown(e) {
          e.preventDefault(), this.cancelBlur = !0, this._delay(function () {
            delete this.cancelBlur, this.element[0] !== t.ui.safeActiveElement(this.document[0]) && this.element.trigger("focus");
          });
        }, menufocus: function menufocus(e, i) {
          var s, n;return this.isNewMenu && (this.isNewMenu = !1, e.originalEvent && /^mouse/.test(e.originalEvent.type)) ? (this.menu.blur(), this.document.one("mousemove", function () {
            t(e.target).trigger(e.originalEvent);
          }), void 0) : (n = i.item.data("ui-autocomplete-item"), !1 !== this._trigger("focus", e, { item: n }) && e.originalEvent && /^key/.test(e.originalEvent.type) && this._value(n.value), s = i.item.attr("aria-label") || n.value, s && t.trim(s).length && (this.liveRegion.children().hide(), t("<div>").text(s).appendTo(this.liveRegion)), void 0);
        }, menuselect: function menuselect(e, i) {
          var s = i.item.data("ui-autocomplete-item"),
              n = this.previous;this.element[0] !== t.ui.safeActiveElement(this.document[0]) && (this.element.trigger("focus"), this.previous = n, this._delay(function () {
            this.previous = n, this.selectedItem = s;
          })), !1 !== this._trigger("select", e, { item: s }) && this._value(s.value), this.term = this._value(), this.close(e), this.selectedItem = s;
        } }), this.liveRegion = t("<div>", { role: "status", "aria-live": "assertive", "aria-relevant": "additions" }).appendTo(this.document[0].body), this._addClass(this.liveRegion, null, "ui-helper-hidden-accessible"), this._on(this.window, { beforeunload: function beforeunload() {
          this.element.removeAttr("autocomplete");
        } });
    }, _destroy: function _destroy() {
      clearTimeout(this.searching), this.element.removeAttr("autocomplete"), this.menu.element.remove(), this.liveRegion.remove();
    }, _setOption: function _setOption(t, e) {
      this._super(t, e), "source" === t && this._initSource(), "appendTo" === t && this.menu.element.appendTo(this._appendTo()), "disabled" === t && e && this.xhr && this.xhr.abort();
    }, _isEventTargetInWidget: function _isEventTargetInWidget(e) {
      var i = this.menu.element[0];return e.target === this.element[0] || e.target === i || t.contains(i, e.target);
    }, _closeOnClickOutside: function _closeOnClickOutside(t) {
      this._isEventTargetInWidget(t) || this.close();
    }, _appendTo: function _appendTo() {
      var e = this.options.appendTo;return e && (e = e.jquery || e.nodeType ? t(e) : this.document.find(e).eq(0)), e && e[0] || (e = this.element.closest(".ui-front, dialog")), e.length || (e = this.document[0].body), e;
    }, _initSource: function _initSource() {
      var e,
          i,
          s = this;t.isArray(this.options.source) ? (e = this.options.source, this.source = function (i, s) {
        s(t.ui.autocomplete.filter(e, i.term));
      }) : "string" == typeof this.options.source ? (i = this.options.source, this.source = function (e, n) {
        s.xhr && s.xhr.abort(), s.xhr = t.ajax({ url: i, data: e, dataType: "json", success: function success(t) {
            n(t);
          }, error: function error() {
            n([]);
          } });
      }) : this.source = this.options.source;
    }, _searchTimeout: function _searchTimeout(t) {
      clearTimeout(this.searching), this.searching = this._delay(function () {
        var e = this.term === this._value(),
            i = this.menu.element.is(":visible"),
            s = t.altKey || t.ctrlKey || t.metaKey || t.shiftKey;(!e || e && !i && !s) && (this.selectedItem = null, this.search(null, t));
      }, this.options.delay);
    }, search: function search(t, e) {
      return t = null != t ? t : this._value(), this.term = this._value(), t.length < this.options.minLength ? this.close(e) : this._trigger("search", e) !== !1 ? this._search(t) : void 0;
    }, _search: function _search(t) {
      this.pending++, this._addClass("ui-autocomplete-loading"), this.cancelSearch = !1, this.source({ term: t }, this._response());
    }, _response: function _response() {
      var e = ++this.requestIndex;return t.proxy(function (t) {
        e === this.requestIndex && this.__response(t), this.pending--, this.pending || this._removeClass("ui-autocomplete-loading");
      }, this);
    }, __response: function __response(t) {
      t && (t = this._normalize(t)), this._trigger("response", null, { content: t }), !this.options.disabled && t && t.length && !this.cancelSearch ? (this._suggest(t), this._trigger("open")) : this._close();
    }, close: function close(t) {
      this.cancelSearch = !0, this._close(t);
    }, _close: function _close(t) {
      this._off(this.document, "mousedown"), this.menu.element.is(":visible") && (this.menu.element.hide(), this.menu.blur(), this.isNewMenu = !0, this._trigger("close", t));
    }, _change: function _change(t) {
      this.previous !== this._value() && this._trigger("change", t, { item: this.selectedItem });
    }, _normalize: function _normalize(e) {
      return e.length && e[0].label && e[0].value ? e : t.map(e, function (e) {
        return "string" == typeof e ? { label: e, value: e } : t.extend({}, e, { label: e.label || e.value, value: e.value || e.label });
      });
    }, _suggest: function _suggest(e) {
      var i = this.menu.element.empty();this._renderMenu(i, e), this.isNewMenu = !0, this.menu.refresh(), i.show(), this._resizeMenu(), i.position(t.extend({ of: this.element }, this.options.position)), this.options.autoFocus && this.menu.next(), this._on(this.document, { mousedown: "_closeOnClickOutside" });
    }, _resizeMenu: function _resizeMenu() {
      var t = this.menu.element;t.outerWidth(Math.max(t.width("").outerWidth() + 1, this.element.outerWidth()));
    }, _renderMenu: function _renderMenu(e, i) {
      var s = this;t.each(i, function (t, i) {
        s._renderItemData(e, i);
      });
    }, _renderItemData: function _renderItemData(t, e) {
      return this._renderItem(t, e).data("ui-autocomplete-item", e);
    }, _renderItem: function _renderItem(e, i) {
      return t("<li>").append(t("<div>").text(i.label)).appendTo(e);
    }, _move: function _move(t, e) {
      return this.menu.element.is(":visible") ? this.menu.isFirstItem() && /^previous/.test(t) || this.menu.isLastItem() && /^next/.test(t) ? (this.isMultiLine || this._value(this.term), this.menu.blur(), void 0) : (this.menu[t](e), void 0) : (this.search(null, e), void 0);
    }, widget: function widget() {
      return this.menu.element;
    }, _value: function _value() {
      return this.valueMethod.apply(this.element, arguments);
    }, _keyEvent: function _keyEvent(t, e) {
      (!this.isMultiLine || this.menu.element.is(":visible")) && (this._move(t, e), e.preventDefault());
    }, _isContentEditable: function _isContentEditable(t) {
      if (!t.length) return !1;var e = t.prop("contentEditable");return "inherit" === e ? this._isContentEditable(t.parent()) : "true" === e;
    } }), t.extend(t.ui.autocomplete, { escapeRegex: function escapeRegex(t) {
      return t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
    }, filter: function filter(e, i) {
      var s = RegExp(t.ui.autocomplete.escapeRegex(i), "i");return t.grep(e, function (t) {
        return s.test(t.label || t.value || t);
      });
    } }), t.widget("ui.autocomplete", t.ui.autocomplete, { options: { messages: { noResults: "No search results.", results: function results(t) {
          return t + (t > 1 ? " results are" : " result is") + " available, use up and down arrow keys to navigate.";
        } } }, __response: function __response(e) {
      var i;this._superApply(arguments), this.options.disabled || this.cancelSearch || (i = e && e.length ? this.options.messages.results(e.length) : this.options.messages.noResults, this.liveRegion.children().hide(), t("<div>").text(i).appendTo(this.liveRegion));
    } }), t.ui.autocomplete;var g = /ui-corner-([a-z]){2,6}/g;t.widget("ui.controlgroup", { version: "1.12.1", defaultElement: "<div>", options: { direction: "horizontal", disabled: null, onlyVisible: !0, items: { button: "input[type=button], input[type=submit], input[type=reset], button, a", controlgroupLabel: ".ui-controlgroup-label", checkboxradio: "input[type='checkbox'], input[type='radio']", selectmenu: "select", spinner: ".ui-spinner-input" } }, _create: function _create() {
      this._enhance();
    }, _enhance: function _enhance() {
      this.element.attr("role", "toolbar"), this.refresh();
    }, _destroy: function _destroy() {
      this._callChildMethod("destroy"), this.childWidgets.removeData("ui-controlgroup-data"), this.element.removeAttr("role"), this.options.items.controlgroupLabel && this.element.find(this.options.items.controlgroupLabel).find(".ui-controlgroup-label-contents").contents().unwrap();
    }, _initWidgets: function _initWidgets() {
      var e = this,
          i = [];t.each(this.options.items, function (s, n) {
        var o,
            a = {};return n ? "controlgroupLabel" === s ? (o = e.element.find(n), o.each(function () {
          var e = t(this);e.children(".ui-controlgroup-label-contents").length || e.contents().wrapAll("<span class='ui-controlgroup-label-contents'></span>");
        }), e._addClass(o, null, "ui-widget ui-widget-content ui-state-default"), i = i.concat(o.get()), void 0) : (t.fn[s] && (a = e["_" + s + "Options"] ? e["_" + s + "Options"]("middle") : { classes: {} }, e.element.find(n).each(function () {
          var n = t(this),
              o = n[s]("instance"),
              r = t.widget.extend({}, a);if ("button" !== s || !n.parent(".ui-spinner").length) {
            o || (o = n[s]()[s]("instance")), o && (r.classes = e._resolveClassesValues(r.classes, o)), n[s](r);var h = n[s]("widget");t.data(h[0], "ui-controlgroup-data", o ? o : n[s]("instance")), i.push(h[0]);
          }
        })), void 0) : void 0;
      }), this.childWidgets = t(t.unique(i)), this._addClass(this.childWidgets, "ui-controlgroup-item");
    }, _callChildMethod: function _callChildMethod(e) {
      this.childWidgets.each(function () {
        var i = t(this),
            s = i.data("ui-controlgroup-data");s && s[e] && s[e]();
      });
    }, _updateCornerClass: function _updateCornerClass(t, e) {
      var i = "ui-corner-top ui-corner-bottom ui-corner-left ui-corner-right ui-corner-all",
          s = this._buildSimpleOptions(e, "label").classes.label;this._removeClass(t, null, i), this._addClass(t, null, s);
    }, _buildSimpleOptions: function _buildSimpleOptions(t, e) {
      var i = "vertical" === this.options.direction,
          s = { classes: {} };return s.classes[e] = { middle: "", first: "ui-corner-" + (i ? "top" : "left"), last: "ui-corner-" + (i ? "bottom" : "right"), only: "ui-corner-all" }[t], s;
    }, _spinnerOptions: function _spinnerOptions(t) {
      var e = this._buildSimpleOptions(t, "ui-spinner");return e.classes["ui-spinner-up"] = "", e.classes["ui-spinner-down"] = "", e;
    }, _buttonOptions: function _buttonOptions(t) {
      return this._buildSimpleOptions(t, "ui-button");
    }, _checkboxradioOptions: function _checkboxradioOptions(t) {
      return this._buildSimpleOptions(t, "ui-checkboxradio-label");
    }, _selectmenuOptions: function _selectmenuOptions(t) {
      var e = "vertical" === this.options.direction;return { width: e ? "auto" : !1, classes: { middle: { "ui-selectmenu-button-open": "", "ui-selectmenu-button-closed": "" }, first: { "ui-selectmenu-button-open": "ui-corner-" + (e ? "top" : "tl"), "ui-selectmenu-button-closed": "ui-corner-" + (e ? "top" : "left") }, last: { "ui-selectmenu-button-open": e ? "" : "ui-corner-tr", "ui-selectmenu-button-closed": "ui-corner-" + (e ? "bottom" : "right") }, only: { "ui-selectmenu-button-open": "ui-corner-top", "ui-selectmenu-button-closed": "ui-corner-all" } }[t] };
    }, _resolveClassesValues: function _resolveClassesValues(e, i) {
      var s = {};return t.each(e, function (n) {
        var o = i.options.classes[n] || "";o = t.trim(o.replace(g, "")), s[n] = (o + " " + e[n]).replace(/\s+/g, " ");
      }), s;
    }, _setOption: function _setOption(t, e) {
      return "direction" === t && this._removeClass("ui-controlgroup-" + this.options.direction), this._super(t, e), "disabled" === t ? (this._callChildMethod(e ? "disable" : "enable"), void 0) : (this.refresh(), void 0);
    }, refresh: function refresh() {
      var e,
          i = this;this._addClass("ui-controlgroup ui-controlgroup-" + this.options.direction), "horizontal" === this.options.direction && this._addClass(null, "ui-helper-clearfix"), this._initWidgets(), e = this.childWidgets, this.options.onlyVisible && (e = e.filter(":visible")), e.length && (t.each(["first", "last"], function (t, s) {
        var n = e[s]().data("ui-controlgroup-data");if (n && i["_" + n.widgetName + "Options"]) {
          var o = i["_" + n.widgetName + "Options"](1 === e.length ? "only" : s);o.classes = i._resolveClassesValues(o.classes, n), n.element[n.widgetName](o);
        } else i._updateCornerClass(e[s](), s);
      }), this._callChildMethod("refresh"));
    } }), t.widget("ui.checkboxradio", [t.ui.formResetMixin, { version: "1.12.1", options: { disabled: null, label: null, icon: !0, classes: { "ui-checkboxradio-label": "ui-corner-all", "ui-checkboxradio-icon": "ui-corner-all" } }, _getCreateOptions: function _getCreateOptions() {
      var e,
          i,
          s = this,
          n = this._super() || {};return this._readType(), i = this.element.labels(), this.label = t(i[i.length - 1]), this.label.length || t.error("No label found for checkboxradio widget"), this.originalLabel = "", this.label.contents().not(this.element[0]).each(function () {
        s.originalLabel += 3 === this.nodeType ? t(this).text() : this.outerHTML;
      }), this.originalLabel && (n.label = this.originalLabel), e = this.element[0].disabled, null != e && (n.disabled = e), n;
    }, _create: function _create() {
      var t = this.element[0].checked;this._bindFormResetHandler(), null == this.options.disabled && (this.options.disabled = this.element[0].disabled), this._setOption("disabled", this.options.disabled), this._addClass("ui-checkboxradio", "ui-helper-hidden-accessible"), this._addClass(this.label, "ui-checkboxradio-label", "ui-button ui-widget"), "radio" === this.type && this._addClass(this.label, "ui-checkboxradio-radio-label"), this.options.label && this.options.label !== this.originalLabel ? this._updateLabel() : this.originalLabel && (this.options.label = this.originalLabel), this._enhance(), t && (this._addClass(this.label, "ui-checkboxradio-checked", "ui-state-active"), this.icon && this._addClass(this.icon, null, "ui-state-hover")), this._on({ change: "_toggleClasses", focus: function focus() {
          this._addClass(this.label, null, "ui-state-focus ui-visual-focus");
        }, blur: function blur() {
          this._removeClass(this.label, null, "ui-state-focus ui-visual-focus");
        } });
    }, _readType: function _readType() {
      var e = this.element[0].nodeName.toLowerCase();this.type = this.element[0].type, "input" === e && /radio|checkbox/.test(this.type) || t.error("Can't create checkboxradio on element.nodeName=" + e + " and element.type=" + this.type);
    }, _enhance: function _enhance() {
      this._updateIcon(this.element[0].checked);
    }, widget: function widget() {
      return this.label;
    }, _getRadioGroup: function _getRadioGroup() {
      var e,
          i = this.element[0].name,
          s = "input[name='" + t.ui.escapeSelector(i) + "']";return i ? (e = this.form.length ? t(this.form[0].elements).filter(s) : t(s).filter(function () {
        return 0 === t(this).form().length;
      }), e.not(this.element)) : t([]);
    }, _toggleClasses: function _toggleClasses() {
      var e = this.element[0].checked;this._toggleClass(this.label, "ui-checkboxradio-checked", "ui-state-active", e), this.options.icon && "checkbox" === this.type && this._toggleClass(this.icon, null, "ui-icon-check ui-state-checked", e)._toggleClass(this.icon, null, "ui-icon-blank", !e), "radio" === this.type && this._getRadioGroup().each(function () {
        var e = t(this).checkboxradio("instance");e && e._removeClass(e.label, "ui-checkboxradio-checked", "ui-state-active");
      });
    }, _destroy: function _destroy() {
      this._unbindFormResetHandler(), this.icon && (this.icon.remove(), this.iconSpace.remove());
    }, _setOption: function _setOption(t, e) {
      return "label" !== t || e ? (this._super(t, e), "disabled" === t ? (this._toggleClass(this.label, null, "ui-state-disabled", e), this.element[0].disabled = e, void 0) : (this.refresh(), void 0)) : void 0;
    }, _updateIcon: function _updateIcon(e) {
      var i = "ui-icon ui-icon-background ";this.options.icon ? (this.icon || (this.icon = t("<span>"), this.iconSpace = t("<span> </span>"), this._addClass(this.iconSpace, "ui-checkboxradio-icon-space")), "checkbox" === this.type ? (i += e ? "ui-icon-check ui-state-checked" : "ui-icon-blank", this._removeClass(this.icon, null, e ? "ui-icon-blank" : "ui-icon-check")) : i += "ui-icon-blank", this._addClass(this.icon, "ui-checkboxradio-icon", i), e || this._removeClass(this.icon, null, "ui-icon-check ui-state-checked"), this.icon.prependTo(this.label).after(this.iconSpace)) : void 0 !== this.icon && (this.icon.remove(), this.iconSpace.remove(), delete this.icon);
    }, _updateLabel: function _updateLabel() {
      var t = this.label.contents().not(this.element[0]);this.icon && (t = t.not(this.icon[0])), this.iconSpace && (t = t.not(this.iconSpace[0])), t.remove(), this.label.append(this.options.label);
    }, refresh: function refresh() {
      var t = this.element[0].checked,
          e = this.element[0].disabled;this._updateIcon(t), this._toggleClass(this.label, "ui-checkboxradio-checked", "ui-state-active", t), null !== this.options.label && this._updateLabel(), e !== this.options.disabled && this._setOptions({ disabled: e });
    } }]), t.ui.checkboxradio, t.widget("ui.button", { version: "1.12.1", defaultElement: "<button>", options: { classes: { "ui-button": "ui-corner-all" }, disabled: null, icon: null, iconPosition: "beginning", label: null, showLabel: !0 }, _getCreateOptions: function _getCreateOptions() {
      var t,
          e = this._super() || {};return this.isInput = this.element.is("input"), t = this.element[0].disabled, null != t && (e.disabled = t), this.originalLabel = this.isInput ? this.element.val() : this.element.html(), this.originalLabel && (e.label = this.originalLabel), e;
    }, _create: function _create() {
      !this.option.showLabel & !this.options.icon && (this.options.showLabel = !0), null == this.options.disabled && (this.options.disabled = this.element[0].disabled || !1), this.hasTitle = !!this.element.attr("title"), this.options.label && this.options.label !== this.originalLabel && (this.isInput ? this.element.val(this.options.label) : this.element.html(this.options.label)), this._addClass("ui-button", "ui-widget"), this._setOption("disabled", this.options.disabled), this._enhance(), this.element.is("a") && this._on({ keyup: function keyup(e) {
          e.keyCode === t.ui.keyCode.SPACE && (e.preventDefault(), this.element[0].click ? this.element[0].click() : this.element.trigger("click"));
        } });
    }, _enhance: function _enhance() {
      this.element.is("button") || this.element.attr("role", "button"), this.options.icon && (this._updateIcon("icon", this.options.icon), this._updateTooltip());
    }, _updateTooltip: function _updateTooltip() {
      this.title = this.element.attr("title"), this.options.showLabel || this.title || this.element.attr("title", this.options.label);
    }, _updateIcon: function _updateIcon(e, i) {
      var s = "iconPosition" !== e,
          n = s ? this.options.iconPosition : i,
          o = "top" === n || "bottom" === n;this.icon ? s && this._removeClass(this.icon, null, this.options.icon) : (this.icon = t("<span>"), this._addClass(this.icon, "ui-button-icon", "ui-icon"), this.options.showLabel || this._addClass("ui-button-icon-only")), s && this._addClass(this.icon, null, i), this._attachIcon(n), o ? (this._addClass(this.icon, null, "ui-widget-icon-block"), this.iconSpace && this.iconSpace.remove()) : (this.iconSpace || (this.iconSpace = t("<span> </span>"), this._addClass(this.iconSpace, "ui-button-icon-space")), this._removeClass(this.icon, null, "ui-wiget-icon-block"), this._attachIconSpace(n));
    }, _destroy: function _destroy() {
      this.element.removeAttr("role"), this.icon && this.icon.remove(), this.iconSpace && this.iconSpace.remove(), this.hasTitle || this.element.removeAttr("title");
    }, _attachIconSpace: function _attachIconSpace(t) {
      this.icon[/^(?:end|bottom)/.test(t) ? "before" : "after"](this.iconSpace);
    }, _attachIcon: function _attachIcon(t) {
      this.element[/^(?:end|bottom)/.test(t) ? "append" : "prepend"](this.icon);
    }, _setOptions: function _setOptions(t) {
      var e = void 0 === t.showLabel ? this.options.showLabel : t.showLabel,
          i = void 0 === t.icon ? this.options.icon : t.icon;e || i || (t.showLabel = !0), this._super(t);
    }, _setOption: function _setOption(t, e) {
      "icon" === t && (e ? this._updateIcon(t, e) : this.icon && (this.icon.remove(), this.iconSpace && this.iconSpace.remove())), "iconPosition" === t && this._updateIcon(t, e), "showLabel" === t && (this._toggleClass("ui-button-icon-only", null, !e), this._updateTooltip()), "label" === t && (this.isInput ? this.element.val(e) : (this.element.html(e), this.icon && (this._attachIcon(this.options.iconPosition), this._attachIconSpace(this.options.iconPosition)))), this._super(t, e), "disabled" === t && (this._toggleClass(null, "ui-state-disabled", e), this.element[0].disabled = e, e && this.element.blur());
    }, refresh: function refresh() {
      var t = this.element.is("input, button") ? this.element[0].disabled : this.element.hasClass("ui-button-disabled");t !== this.options.disabled && this._setOptions({ disabled: t }), this._updateTooltip();
    } }), t.uiBackCompat !== !1 && (t.widget("ui.button", t.ui.button, { options: { text: !0, icons: { primary: null, secondary: null } }, _create: function _create() {
      this.options.showLabel && !this.options.text && (this.options.showLabel = this.options.text), !this.options.showLabel && this.options.text && (this.options.text = this.options.showLabel), this.options.icon || !this.options.icons.primary && !this.options.icons.secondary ? this.options.icon && (this.options.icons.primary = this.options.icon) : this.options.icons.primary ? this.options.icon = this.options.icons.primary : (this.options.icon = this.options.icons.secondary, this.options.iconPosition = "end"), this._super();
    }, _setOption: function _setOption(t, e) {
      return "text" === t ? (this._super("showLabel", e), void 0) : ("showLabel" === t && (this.options.text = e), "icon" === t && (this.options.icons.primary = e), "icons" === t && (e.primary ? (this._super("icon", e.primary), this._super("iconPosition", "beginning")) : e.secondary && (this._super("icon", e.secondary), this._super("iconPosition", "end"))), this._superApply(arguments), void 0);
    } }), t.fn.button = function (e) {
    return function () {
      return !this.length || this.length && "INPUT" !== this[0].tagName || this.length && "INPUT" === this[0].tagName && "checkbox" !== this.attr("type") && "radio" !== this.attr("type") ? e.apply(this, arguments) : (t.ui.checkboxradio || t.error("Checkboxradio widget missing"), 0 === arguments.length ? this.checkboxradio({ icon: !1 }) : this.checkboxradio.apply(this, arguments));
    };
  }(t.fn.button), t.fn.buttonset = function () {
    return t.ui.controlgroup || t.error("Controlgroup widget missing"), "option" === arguments[0] && "items" === arguments[1] && arguments[2] ? this.controlgroup.apply(this, [arguments[0], "items.button", arguments[2]]) : "option" === arguments[0] && "items" === arguments[1] ? this.controlgroup.apply(this, [arguments[0], "items.button"]) : ("object" == _typeof(arguments[0]) && arguments[0].items && (arguments[0].items = { button: arguments[0].items }), this.controlgroup.apply(this, arguments));
  }), t.ui.button, t.extend(t.ui, { datepicker: { version: "1.12.1" } });var m;t.extend(s.prototype, { markerClassName: "hasDatepicker", maxRows: 4, _widgetDatepicker: function _widgetDatepicker() {
      return this.dpDiv;
    }, setDefaults: function setDefaults(t) {
      return a(this._defaults, t || {}), this;
    }, _attachDatepicker: function _attachDatepicker(e, i) {
      var s, n, o;s = e.nodeName.toLowerCase(), n = "div" === s || "span" === s, e.id || (this.uuid += 1, e.id = "dp" + this.uuid), o = this._newInst(t(e), n), o.settings = t.extend({}, i || {}), "input" === s ? this._connectDatepicker(e, o) : n && this._inlineDatepicker(e, o);
    }, _newInst: function _newInst(e, i) {
      var s = e[0].id.replace(/([^A-Za-z0-9_\-])/g, "\\\\$1");return { id: s, input: e, selectedDay: 0, selectedMonth: 0, selectedYear: 0, drawMonth: 0, drawYear: 0, inline: i, dpDiv: i ? n(t("<div class='" + this._inlineClass + " ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")) : this.dpDiv };
    }, _connectDatepicker: function _connectDatepicker(e, i) {
      var s = t(e);i.append = t([]), i.trigger = t([]), s.hasClass(this.markerClassName) || (this._attachments(s, i), s.addClass(this.markerClassName).on("keydown", this._doKeyDown).on("keypress", this._doKeyPress).on("keyup", this._doKeyUp), this._autoSize(i), t.data(e, "datepicker", i), i.settings.disabled && this._disableDatepicker(e));
    }, _attachments: function _attachments(e, i) {
      var s,
          n,
          o,
          a = this._get(i, "appendText"),
          r = this._get(i, "isRTL");i.append && i.append.remove(), a && (i.append = t("<span class='" + this._appendClass + "'>" + a + "</span>"), e[r ? "before" : "after"](i.append)), e.off("focus", this._showDatepicker), i.trigger && i.trigger.remove(), s = this._get(i, "showOn"), ("focus" === s || "both" === s) && e.on("focus", this._showDatepicker), ("button" === s || "both" === s) && (n = this._get(i, "buttonText"), o = this._get(i, "buttonImage"), i.trigger = t(this._get(i, "buttonImageOnly") ? t("<img/>").addClass(this._triggerClass).attr({ src: o, alt: n, title: n }) : t("<button type='button'></button>").addClass(this._triggerClass).html(o ? t("<img/>").attr({ src: o, alt: n, title: n }) : n)), e[r ? "before" : "after"](i.trigger), i.trigger.on("click", function () {
        return t.datepicker._datepickerShowing && t.datepicker._lastInput === e[0] ? t.datepicker._hideDatepicker() : t.datepicker._datepickerShowing && t.datepicker._lastInput !== e[0] ? (t.datepicker._hideDatepicker(), t.datepicker._showDatepicker(e[0])) : t.datepicker._showDatepicker(e[0]), !1;
      }));
    }, _autoSize: function _autoSize(t) {
      if (this._get(t, "autoSize") && !t.inline) {
        var e,
            i,
            s,
            n,
            o = new Date(2009, 11, 20),
            a = this._get(t, "dateFormat");a.match(/[DM]/) && (e = function e(t) {
          for (i = 0, s = 0, n = 0; t.length > n; n++) {
            t[n].length > i && (i = t[n].length, s = n);
          }return s;
        }, o.setMonth(e(this._get(t, a.match(/MM/) ? "monthNames" : "monthNamesShort"))), o.setDate(e(this._get(t, a.match(/DD/) ? "dayNames" : "dayNamesShort")) + 20 - o.getDay())), t.input.attr("size", this._formatDate(t, o).length);
      }
    }, _inlineDatepicker: function _inlineDatepicker(e, i) {
      var s = t(e);s.hasClass(this.markerClassName) || (s.addClass(this.markerClassName).append(i.dpDiv), t.data(e, "datepicker", i), this._setDate(i, this._getDefaultDate(i), !0), this._updateDatepicker(i), this._updateAlternate(i), i.settings.disabled && this._disableDatepicker(e), i.dpDiv.css("display", "block"));
    }, _dialogDatepicker: function _dialogDatepicker(e, i, s, n, o) {
      var r,
          h,
          l,
          c,
          u,
          d = this._dialogInst;return d || (this.uuid += 1, r = "dp" + this.uuid, this._dialogInput = t("<input type='text' id='" + r + "' style='position: absolute; top: -100px; width: 0px;'/>"), this._dialogInput.on("keydown", this._doKeyDown), t("body").append(this._dialogInput), d = this._dialogInst = this._newInst(this._dialogInput, !1), d.settings = {}, t.data(this._dialogInput[0], "datepicker", d)), a(d.settings, n || {}), i = i && i.constructor === Date ? this._formatDate(d, i) : i, this._dialogInput.val(i), this._pos = o ? o.length ? o : [o.pageX, o.pageY] : null, this._pos || (h = document.documentElement.clientWidth, l = document.documentElement.clientHeight, c = document.documentElement.scrollLeft || document.body.scrollLeft, u = document.documentElement.scrollTop || document.body.scrollTop, this._pos = [h / 2 - 100 + c, l / 2 - 150 + u]), this._dialogInput.css("left", this._pos[0] + 20 + "px").css("top", this._pos[1] + "px"), d.settings.onSelect = s, this._inDialog = !0, this.dpDiv.addClass(this._dialogClass), this._showDatepicker(this._dialogInput[0]), t.blockUI && t.blockUI(this.dpDiv), t.data(this._dialogInput[0], "datepicker", d), this;
    }, _destroyDatepicker: function _destroyDatepicker(e) {
      var i,
          s = t(e),
          n = t.data(e, "datepicker");s.hasClass(this.markerClassName) && (i = e.nodeName.toLowerCase(), t.removeData(e, "datepicker"), "input" === i ? (n.append.remove(), n.trigger.remove(), s.removeClass(this.markerClassName).off("focus", this._showDatepicker).off("keydown", this._doKeyDown).off("keypress", this._doKeyPress).off("keyup", this._doKeyUp)) : ("div" === i || "span" === i) && s.removeClass(this.markerClassName).empty(), m === n && (m = null));
    }, _enableDatepicker: function _enableDatepicker(e) {
      var i,
          s,
          n = t(e),
          o = t.data(e, "datepicker");n.hasClass(this.markerClassName) && (i = e.nodeName.toLowerCase(), "input" === i ? (e.disabled = !1, o.trigger.filter("button").each(function () {
        this.disabled = !1;
      }).end().filter("img").css({ opacity: "1.0", cursor: "" })) : ("div" === i || "span" === i) && (s = n.children("." + this._inlineClass), s.children().removeClass("ui-state-disabled"), s.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled", !1)), this._disabledInputs = t.map(this._disabledInputs, function (t) {
        return t === e ? null : t;
      }));
    }, _disableDatepicker: function _disableDatepicker(e) {
      var i,
          s,
          n = t(e),
          o = t.data(e, "datepicker");n.hasClass(this.markerClassName) && (i = e.nodeName.toLowerCase(), "input" === i ? (e.disabled = !0, o.trigger.filter("button").each(function () {
        this.disabled = !0;
      }).end().filter("img").css({ opacity: "0.5", cursor: "default" })) : ("div" === i || "span" === i) && (s = n.children("." + this._inlineClass), s.children().addClass("ui-state-disabled"), s.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled", !0)), this._disabledInputs = t.map(this._disabledInputs, function (t) {
        return t === e ? null : t;
      }), this._disabledInputs[this._disabledInputs.length] = e);
    }, _isDisabledDatepicker: function _isDisabledDatepicker(t) {
      if (!t) return !1;for (var e = 0; this._disabledInputs.length > e; e++) {
        if (this._disabledInputs[e] === t) return !0;
      }return !1;
    }, _getInst: function _getInst(e) {
      try {
        return t.data(e, "datepicker");
      } catch (i) {
        throw "Missing instance data for this datepicker";
      }
    }, _optionDatepicker: function _optionDatepicker(e, i, s) {
      var n,
          o,
          r,
          h,
          l = this._getInst(e);return 2 === arguments.length && "string" == typeof i ? "defaults" === i ? t.extend({}, t.datepicker._defaults) : l ? "all" === i ? t.extend({}, l.settings) : this._get(l, i) : null : (n = i || {}, "string" == typeof i && (n = {}, n[i] = s), l && (this._curInst === l && this._hideDatepicker(), o = this._getDateDatepicker(e, !0), r = this._getMinMaxDate(l, "min"), h = this._getMinMaxDate(l, "max"), a(l.settings, n), null !== r && void 0 !== n.dateFormat && void 0 === n.minDate && (l.settings.minDate = this._formatDate(l, r)), null !== h && void 0 !== n.dateFormat && void 0 === n.maxDate && (l.settings.maxDate = this._formatDate(l, h)), "disabled" in n && (n.disabled ? this._disableDatepicker(e) : this._enableDatepicker(e)), this._attachments(t(e), l), this._autoSize(l), this._setDate(l, o), this._updateAlternate(l), this._updateDatepicker(l)), void 0);
    }, _changeDatepicker: function _changeDatepicker(t, e, i) {
      this._optionDatepicker(t, e, i);
    }, _refreshDatepicker: function _refreshDatepicker(t) {
      var e = this._getInst(t);e && this._updateDatepicker(e);
    }, _setDateDatepicker: function _setDateDatepicker(t, e) {
      var i = this._getInst(t);i && (this._setDate(i, e), this._updateDatepicker(i), this._updateAlternate(i));
    }, _getDateDatepicker: function _getDateDatepicker(t, e) {
      var i = this._getInst(t);return i && !i.inline && this._setDateFromField(i, e), i ? this._getDate(i) : null;
    }, _doKeyDown: function _doKeyDown(e) {
      var i,
          s,
          n,
          o = t.datepicker._getInst(e.target),
          a = !0,
          r = o.dpDiv.is(".ui-datepicker-rtl");if (o._keyEvent = !0, t.datepicker._datepickerShowing) switch (e.keyCode) {case 9:
          t.datepicker._hideDatepicker(), a = !1;break;case 13:
          return n = t("td." + t.datepicker._dayOverClass + ":not(." + t.datepicker._currentClass + ")", o.dpDiv), n[0] && t.datepicker._selectDay(e.target, o.selectedMonth, o.selectedYear, n[0]), i = t.datepicker._get(o, "onSelect"), i ? (s = t.datepicker._formatDate(o), i.apply(o.input ? o.input[0] : null, [s, o])) : t.datepicker._hideDatepicker(), !1;case 27:
          t.datepicker._hideDatepicker();break;case 33:
          t.datepicker._adjustDate(e.target, e.ctrlKey ? -t.datepicker._get(o, "stepBigMonths") : -t.datepicker._get(o, "stepMonths"), "M");break;case 34:
          t.datepicker._adjustDate(e.target, e.ctrlKey ? +t.datepicker._get(o, "stepBigMonths") : +t.datepicker._get(o, "stepMonths"), "M");break;case 35:
          (e.ctrlKey || e.metaKey) && t.datepicker._clearDate(e.target), a = e.ctrlKey || e.metaKey;break;case 36:
          (e.ctrlKey || e.metaKey) && t.datepicker._gotoToday(e.target), a = e.ctrlKey || e.metaKey;break;case 37:
          (e.ctrlKey || e.metaKey) && t.datepicker._adjustDate(e.target, r ? 1 : -1, "D"), a = e.ctrlKey || e.metaKey, e.originalEvent.altKey && t.datepicker._adjustDate(e.target, e.ctrlKey ? -t.datepicker._get(o, "stepBigMonths") : -t.datepicker._get(o, "stepMonths"), "M");break;case 38:
          (e.ctrlKey || e.metaKey) && t.datepicker._adjustDate(e.target, -7, "D"), a = e.ctrlKey || e.metaKey;break;case 39:
          (e.ctrlKey || e.metaKey) && t.datepicker._adjustDate(e.target, r ? -1 : 1, "D"), a = e.ctrlKey || e.metaKey, e.originalEvent.altKey && t.datepicker._adjustDate(e.target, e.ctrlKey ? +t.datepicker._get(o, "stepBigMonths") : +t.datepicker._get(o, "stepMonths"), "M");break;case 40:
          (e.ctrlKey || e.metaKey) && t.datepicker._adjustDate(e.target, 7, "D"), a = e.ctrlKey || e.metaKey;break;default:
          a = !1;} else 36 === e.keyCode && e.ctrlKey ? t.datepicker._showDatepicker(this) : a = !1;a && (e.preventDefault(), e.stopPropagation());
    }, _doKeyPress: function _doKeyPress(e) {
      var i,
          s,
          n = t.datepicker._getInst(e.target);return t.datepicker._get(n, "constrainInput") ? (i = t.datepicker._possibleChars(t.datepicker._get(n, "dateFormat")), s = String.fromCharCode(null == e.charCode ? e.keyCode : e.charCode), e.ctrlKey || e.metaKey || " " > s || !i || i.indexOf(s) > -1) : void 0;
    }, _doKeyUp: function _doKeyUp(e) {
      var i,
          s = t.datepicker._getInst(e.target);if (s.input.val() !== s.lastVal) try {
        i = t.datepicker.parseDate(t.datepicker._get(s, "dateFormat"), s.input ? s.input.val() : null, t.datepicker._getFormatConfig(s)), i && (t.datepicker._setDateFromField(s), t.datepicker._updateAlternate(s), t.datepicker._updateDatepicker(s));
      } catch (n) {}return !0;
    }, _showDatepicker: function _showDatepicker(e) {
      if (e = e.target || e, "input" !== e.nodeName.toLowerCase() && (e = t("input", e.parentNode)[0]), !t.datepicker._isDisabledDatepicker(e) && t.datepicker._lastInput !== e) {
        var s, n, o, r, h, l, c;s = t.datepicker._getInst(e), t.datepicker._curInst && t.datepicker._curInst !== s && (t.datepicker._curInst.dpDiv.stop(!0, !0), s && t.datepicker._datepickerShowing && t.datepicker._hideDatepicker(t.datepicker._curInst.input[0])), n = t.datepicker._get(s, "beforeShow"), o = n ? n.apply(e, [e, s]) : {}, o !== !1 && (a(s.settings, o), s.lastVal = null, t.datepicker._lastInput = e, t.datepicker._setDateFromField(s), t.datepicker._inDialog && (e.value = ""), t.datepicker._pos || (t.datepicker._pos = t.datepicker._findPos(e), t.datepicker._pos[1] += e.offsetHeight), r = !1, t(e).parents().each(function () {
          return r |= "fixed" === t(this).css("position"), !r;
        }), h = { left: t.datepicker._pos[0], top: t.datepicker._pos[1] }, t.datepicker._pos = null, s.dpDiv.empty(), s.dpDiv.css({ position: "absolute", display: "block", top: "-1000px" }), t.datepicker._updateDatepicker(s), h = t.datepicker._checkOffset(s, h, r), s.dpDiv.css({ position: t.datepicker._inDialog && t.blockUI ? "static" : r ? "fixed" : "absolute", display: "none", left: h.left + "px", top: h.top + "px" }), s.inline || (l = t.datepicker._get(s, "showAnim"), c = t.datepicker._get(s, "duration"), s.dpDiv.css("z-index", i(t(e)) + 1), t.datepicker._datepickerShowing = !0, t.effects && t.effects.effect[l] ? s.dpDiv.show(l, t.datepicker._get(s, "showOptions"), c) : s.dpDiv[l || "show"](l ? c : null), t.datepicker._shouldFocusInput(s) && s.input.trigger("focus"), t.datepicker._curInst = s));
      }
    }, _updateDatepicker: function _updateDatepicker(e) {
      this.maxRows = 4, m = e, e.dpDiv.empty().append(this._generateHTML(e)), this._attachHandlers(e);var i,
          s = this._getNumberOfMonths(e),
          n = s[1],
          a = 17,
          r = e.dpDiv.find("." + this._dayOverClass + " a");r.length > 0 && o.apply(r.get(0)), e.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width(""), n > 1 && e.dpDiv.addClass("ui-datepicker-multi-" + n).css("width", a * n + "em"), e.dpDiv[(1 !== s[0] || 1 !== s[1] ? "add" : "remove") + "Class"]("ui-datepicker-multi"), e.dpDiv[(this._get(e, "isRTL") ? "add" : "remove") + "Class"]("ui-datepicker-rtl"), e === t.datepicker._curInst && t.datepicker._datepickerShowing && t.datepicker._shouldFocusInput(e) && e.input.trigger("focus"), e.yearshtml && (i = e.yearshtml, setTimeout(function () {
        i === e.yearshtml && e.yearshtml && e.dpDiv.find("select.ui-datepicker-year:first").replaceWith(e.yearshtml), i = e.yearshtml = null;
      }, 0));
    }, _shouldFocusInput: function _shouldFocusInput(t) {
      return t.input && t.input.is(":visible") && !t.input.is(":disabled") && !t.input.is(":focus");
    }, _checkOffset: function _checkOffset(e, i, s) {
      var n = e.dpDiv.outerWidth(),
          o = e.dpDiv.outerHeight(),
          a = e.input ? e.input.outerWidth() : 0,
          r = e.input ? e.input.outerHeight() : 0,
          h = document.documentElement.clientWidth + (s ? 0 : t(document).scrollLeft()),
          l = document.documentElement.clientHeight + (s ? 0 : t(document).scrollTop());return i.left -= this._get(e, "isRTL") ? n - a : 0, i.left -= s && i.left === e.input.offset().left ? t(document).scrollLeft() : 0, i.top -= s && i.top === e.input.offset().top + r ? t(document).scrollTop() : 0, i.left -= Math.min(i.left, i.left + n > h && h > n ? Math.abs(i.left + n - h) : 0), i.top -= Math.min(i.top, i.top + o > l && l > o ? Math.abs(o + r) : 0), i;
    }, _findPos: function _findPos(e) {
      for (var i, s = this._getInst(e), n = this._get(s, "isRTL"); e && ("hidden" === e.type || 1 !== e.nodeType || t.expr.filters.hidden(e));) {
        e = e[n ? "previousSibling" : "nextSibling"];
      }return i = t(e).offset(), [i.left, i.top];
    }, _hideDatepicker: function _hideDatepicker(e) {
      var i,
          s,
          n,
          o,
          a = this._curInst;!a || e && a !== t.data(e, "datepicker") || this._datepickerShowing && (i = this._get(a, "showAnim"), s = this._get(a, "duration"), n = function n() {
        t.datepicker._tidyDialog(a);
      }, t.effects && (t.effects.effect[i] || t.effects[i]) ? a.dpDiv.hide(i, t.datepicker._get(a, "showOptions"), s, n) : a.dpDiv["slideDown" === i ? "slideUp" : "fadeIn" === i ? "fadeOut" : "hide"](i ? s : null, n), i || n(), this._datepickerShowing = !1, o = this._get(a, "onClose"), o && o.apply(a.input ? a.input[0] : null, [a.input ? a.input.val() : "", a]), this._lastInput = null, this._inDialog && (this._dialogInput.css({ position: "absolute", left: "0", top: "-100px" }), t.blockUI && (t.unblockUI(), t("body").append(this.dpDiv))), this._inDialog = !1);
    }, _tidyDialog: function _tidyDialog(t) {
      t.dpDiv.removeClass(this._dialogClass).off(".ui-datepicker-calendar");
    }, _checkExternalClick: function _checkExternalClick(e) {
      if (t.datepicker._curInst) {
        var i = t(e.target),
            s = t.datepicker._getInst(i[0]);(i[0].id !== t.datepicker._mainDivId && 0 === i.parents("#" + t.datepicker._mainDivId).length && !i.hasClass(t.datepicker.markerClassName) && !i.closest("." + t.datepicker._triggerClass).length && t.datepicker._datepickerShowing && (!t.datepicker._inDialog || !t.blockUI) || i.hasClass(t.datepicker.markerClassName) && t.datepicker._curInst !== s) && t.datepicker._hideDatepicker();
      }
    }, _adjustDate: function _adjustDate(e, i, s) {
      var n = t(e),
          o = this._getInst(n[0]);this._isDisabledDatepicker(n[0]) || (this._adjustInstDate(o, i + ("M" === s ? this._get(o, "showCurrentAtPos") : 0), s), this._updateDatepicker(o));
    }, _gotoToday: function _gotoToday(e) {
      var i,
          s = t(e),
          n = this._getInst(s[0]);this._get(n, "gotoCurrent") && n.currentDay ? (n.selectedDay = n.currentDay, n.drawMonth = n.selectedMonth = n.currentMonth, n.drawYear = n.selectedYear = n.currentYear) : (i = new Date(), n.selectedDay = i.getDate(), n.drawMonth = n.selectedMonth = i.getMonth(), n.drawYear = n.selectedYear = i.getFullYear()), this._notifyChange(n), this._adjustDate(s);
    }, _selectMonthYear: function _selectMonthYear(e, i, s) {
      var n = t(e),
          o = this._getInst(n[0]);o["selected" + ("M" === s ? "Month" : "Year")] = o["draw" + ("M" === s ? "Month" : "Year")] = parseInt(i.options[i.selectedIndex].value, 10), this._notifyChange(o), this._adjustDate(n);
    }, _selectDay: function _selectDay(e, i, s, n) {
      var o,
          a = t(e);t(n).hasClass(this._unselectableClass) || this._isDisabledDatepicker(a[0]) || (o = this._getInst(a[0]), o.selectedDay = o.currentDay = t("a", n).html(), o.selectedMonth = o.currentMonth = i, o.selectedYear = o.currentYear = s, this._selectDate(e, this._formatDate(o, o.currentDay, o.currentMonth, o.currentYear)));
    }, _clearDate: function _clearDate(e) {
      var i = t(e);this._selectDate(i, "");
    }, _selectDate: function _selectDate(e, i) {
      var s,
          n = t(e),
          o = this._getInst(n[0]);i = null != i ? i : this._formatDate(o), o.input && o.input.val(i), this._updateAlternate(o), s = this._get(o, "onSelect"), s ? s.apply(o.input ? o.input[0] : null, [i, o]) : o.input && o.input.trigger("change"), o.inline ? this._updateDatepicker(o) : (this._hideDatepicker(), this._lastInput = o.input[0], "object" != _typeof(o.input[0]) && o.input.trigger("focus"), this._lastInput = null);
    }, _updateAlternate: function _updateAlternate(e) {
      var i,
          s,
          n,
          o = this._get(e, "altField");o && (i = this._get(e, "altFormat") || this._get(e, "dateFormat"), s = this._getDate(e), n = this.formatDate(i, s, this._getFormatConfig(e)), t(o).val(n));
    }, noWeekends: function noWeekends(t) {
      var e = t.getDay();return [e > 0 && 6 > e, ""];
    }, iso8601Week: function iso8601Week(t) {
      var e,
          i = new Date(t.getTime());return i.setDate(i.getDate() + 4 - (i.getDay() || 7)), e = i.getTime(), i.setMonth(0), i.setDate(1), Math.floor(Math.round((e - i) / 864e5) / 7) + 1;
    }, parseDate: function parseDate(e, i, s) {
      if (null == e || null == i) throw "Invalid arguments";if (i = "object" == (typeof i === "undefined" ? "undefined" : _typeof(i)) ? "" + i : i + "", "" === i) return null;var n,
          o,
          a,
          r,
          h = 0,
          l = (s ? s.shortYearCutoff : null) || this._defaults.shortYearCutoff,
          c = "string" != typeof l ? l : new Date().getFullYear() % 100 + parseInt(l, 10),
          u = (s ? s.dayNamesShort : null) || this._defaults.dayNamesShort,
          d = (s ? s.dayNames : null) || this._defaults.dayNames,
          p = (s ? s.monthNamesShort : null) || this._defaults.monthNamesShort,
          f = (s ? s.monthNames : null) || this._defaults.monthNames,
          g = -1,
          m = -1,
          _ = -1,
          v = -1,
          b = !1,
          y = function y(t) {
        var i = e.length > n + 1 && e.charAt(n + 1) === t;return i && n++, i;
      },
          w = function w(t) {
        var e = y(t),
            s = "@" === t ? 14 : "!" === t ? 20 : "y" === t && e ? 4 : "o" === t ? 3 : 2,
            n = "y" === t ? s : 1,
            o = RegExp("^\\d{" + n + "," + s + "}"),
            a = i.substring(h).match(o);if (!a) throw "Missing number at position " + h;return h += a[0].length, parseInt(a[0], 10);
      },
          k = function k(e, s, n) {
        var o = -1,
            a = t.map(y(e) ? n : s, function (t, e) {
          return [[e, t]];
        }).sort(function (t, e) {
          return -(t[1].length - e[1].length);
        });if (t.each(a, function (t, e) {
          var s = e[1];return i.substr(h, s.length).toLowerCase() === s.toLowerCase() ? (o = e[0], h += s.length, !1) : void 0;
        }), -1 !== o) return o + 1;throw "Unknown name at position " + h;
      },
          x = function x() {
        if (i.charAt(h) !== e.charAt(n)) throw "Unexpected literal at position " + h;h++;
      };for (n = 0; e.length > n; n++) {
        if (b) "'" !== e.charAt(n) || y("'") ? x() : b = !1;else switch (e.charAt(n)) {case "d":
            _ = w("d");break;case "D":
            k("D", u, d);break;case "o":
            v = w("o");break;case "m":
            m = w("m");break;case "M":
            m = k("M", p, f);break;case "y":
            g = w("y");break;case "@":
            r = new Date(w("@")), g = r.getFullYear(), m = r.getMonth() + 1, _ = r.getDate();break;case "!":
            r = new Date((w("!") - this._ticksTo1970) / 1e4), g = r.getFullYear(), m = r.getMonth() + 1, _ = r.getDate();break;case "'":
            y("'") ? x() : b = !0;break;default:
            x();}
      }if (i.length > h && (a = i.substr(h), !/^\s+/.test(a))) throw "Extra/unparsed characters found in date: " + a;if (-1 === g ? g = new Date().getFullYear() : 100 > g && (g += new Date().getFullYear() - new Date().getFullYear() % 100 + (c >= g ? 0 : -100)), v > -1) for (m = 1, _ = v;;) {
        if (o = this._getDaysInMonth(g, m - 1), o >= _) break;m++, _ -= o;
      }if (r = this._daylightSavingAdjust(new Date(g, m - 1, _)), r.getFullYear() !== g || r.getMonth() + 1 !== m || r.getDate() !== _) throw "Invalid date";return r;
    }, ATOM: "yy-mm-dd", COOKIE: "D, dd M yy", ISO_8601: "yy-mm-dd", RFC_822: "D, d M y", RFC_850: "DD, dd-M-y", RFC_1036: "D, d M y", RFC_1123: "D, d M yy", RFC_2822: "D, d M yy", RSS: "D, d M y", TICKS: "!", TIMESTAMP: "@", W3C: "yy-mm-dd", _ticksTo1970: 1e7 * 60 * 60 * 24 * (718685 + Math.floor(492.5) - Math.floor(19.7) + Math.floor(4.925)), formatDate: function formatDate(t, e, i) {
      if (!e) return "";var s,
          n = (i ? i.dayNamesShort : null) || this._defaults.dayNamesShort,
          o = (i ? i.dayNames : null) || this._defaults.dayNames,
          a = (i ? i.monthNamesShort : null) || this._defaults.monthNamesShort,
          r = (i ? i.monthNames : null) || this._defaults.monthNames,
          h = function h(e) {
        var i = t.length > s + 1 && t.charAt(s + 1) === e;return i && s++, i;
      },
          l = function l(t, e, i) {
        var s = "" + e;if (h(t)) for (; i > s.length;) {
          s = "0" + s;
        }return s;
      },
          c = function c(t, e, i, s) {
        return h(t) ? s[e] : i[e];
      },
          u = "",
          d = !1;if (e) for (s = 0; t.length > s; s++) {
        if (d) "'" !== t.charAt(s) || h("'") ? u += t.charAt(s) : d = !1;else switch (t.charAt(s)) {case "d":
            u += l("d", e.getDate(), 2);break;case "D":
            u += c("D", e.getDay(), n, o);break;case "o":
            u += l("o", Math.round((new Date(e.getFullYear(), e.getMonth(), e.getDate()).getTime() - new Date(e.getFullYear(), 0, 0).getTime()) / 864e5), 3);break;case "m":
            u += l("m", e.getMonth() + 1, 2);break;case "M":
            u += c("M", e.getMonth(), a, r);break;case "y":
            u += h("y") ? e.getFullYear() : (10 > e.getFullYear() % 100 ? "0" : "") + e.getFullYear() % 100;break;case "@":
            u += e.getTime();break;case "!":
            u += 1e4 * e.getTime() + this._ticksTo1970;break;case "'":
            h("'") ? u += "'" : d = !0;break;default:
            u += t.charAt(s);}
      }return u;
    }, _possibleChars: function _possibleChars(t) {
      var e,
          i = "",
          s = !1,
          n = function n(i) {
        var s = t.length > e + 1 && t.charAt(e + 1) === i;return s && e++, s;
      };for (e = 0; t.length > e; e++) {
        if (s) "'" !== t.charAt(e) || n("'") ? i += t.charAt(e) : s = !1;else switch (t.charAt(e)) {case "d":case "m":case "y":case "@":
            i += "0123456789";break;case "D":case "M":
            return null;case "'":
            n("'") ? i += "'" : s = !0;break;default:
            i += t.charAt(e);}
      }return i;
    }, _get: function _get(t, e) {
      return void 0 !== t.settings[e] ? t.settings[e] : this._defaults[e];
    }, _setDateFromField: function _setDateFromField(t, e) {
      if (t.input.val() !== t.lastVal) {
        var i = this._get(t, "dateFormat"),
            s = t.lastVal = t.input ? t.input.val() : null,
            n = this._getDefaultDate(t),
            o = n,
            a = this._getFormatConfig(t);try {
          o = this.parseDate(i, s, a) || n;
        } catch (r) {
          s = e ? "" : s;
        }t.selectedDay = o.getDate(), t.drawMonth = t.selectedMonth = o.getMonth(), t.drawYear = t.selectedYear = o.getFullYear(), t.currentDay = s ? o.getDate() : 0, t.currentMonth = s ? o.getMonth() : 0, t.currentYear = s ? o.getFullYear() : 0, this._adjustInstDate(t);
      }
    }, _getDefaultDate: function _getDefaultDate(t) {
      return this._restrictMinMax(t, this._determineDate(t, this._get(t, "defaultDate"), new Date()));
    }, _determineDate: function _determineDate(e, i, s) {
      var n = function n(t) {
        var e = new Date();return e.setDate(e.getDate() + t), e;
      },
          o = function o(i) {
        try {
          return t.datepicker.parseDate(t.datepicker._get(e, "dateFormat"), i, t.datepicker._getFormatConfig(e));
        } catch (s) {}for (var n = (i.toLowerCase().match(/^c/) ? t.datepicker._getDate(e) : null) || new Date(), o = n.getFullYear(), a = n.getMonth(), r = n.getDate(), h = /([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g, l = h.exec(i); l;) {
          switch (l[2] || "d") {case "d":case "D":
              r += parseInt(l[1], 10);break;case "w":case "W":
              r += 7 * parseInt(l[1], 10);break;case "m":case "M":
              a += parseInt(l[1], 10), r = Math.min(r, t.datepicker._getDaysInMonth(o, a));break;case "y":case "Y":
              o += parseInt(l[1], 10), r = Math.min(r, t.datepicker._getDaysInMonth(o, a));}l = h.exec(i);
        }return new Date(o, a, r);
      },
          a = null == i || "" === i ? s : "string" == typeof i ? o(i) : "number" == typeof i ? isNaN(i) ? s : n(i) : new Date(i.getTime());return a = a && "Invalid Date" == "" + a ? s : a, a && (a.setHours(0), a.setMinutes(0), a.setSeconds(0), a.setMilliseconds(0)), this._daylightSavingAdjust(a);
    }, _daylightSavingAdjust: function _daylightSavingAdjust(t) {
      return t ? (t.setHours(t.getHours() > 12 ? t.getHours() + 2 : 0), t) : null;
    }, _setDate: function _setDate(t, e, i) {
      var s = !e,
          n = t.selectedMonth,
          o = t.selectedYear,
          a = this._restrictMinMax(t, this._determineDate(t, e, new Date()));t.selectedDay = t.currentDay = a.getDate(), t.drawMonth = t.selectedMonth = t.currentMonth = a.getMonth(), t.drawYear = t.selectedYear = t.currentYear = a.getFullYear(), n === t.selectedMonth && o === t.selectedYear || i || this._notifyChange(t), this._adjustInstDate(t), t.input && t.input.val(s ? "" : this._formatDate(t));
    }, _getDate: function _getDate(t) {
      var e = !t.currentYear || t.input && "" === t.input.val() ? null : this._daylightSavingAdjust(new Date(t.currentYear, t.currentMonth, t.currentDay));return e;
    }, _attachHandlers: function _attachHandlers(e) {
      var i = this._get(e, "stepMonths"),
          s = "#" + e.id.replace(/\\\\/g, "\\");e.dpDiv.find("[data-handler]").map(function () {
        var e = { prev: function prev() {
            t.datepicker._adjustDate(s, -i, "M");
          }, next: function next() {
            t.datepicker._adjustDate(s, +i, "M");
          }, hide: function hide() {
            t.datepicker._hideDatepicker();
          }, today: function today() {
            t.datepicker._gotoToday(s);
          }, selectDay: function selectDay() {
            return t.datepicker._selectDay(s, +this.getAttribute("data-month"), +this.getAttribute("data-year"), this), !1;
          }, selectMonth: function selectMonth() {
            return t.datepicker._selectMonthYear(s, this, "M"), !1;
          }, selectYear: function selectYear() {
            return t.datepicker._selectMonthYear(s, this, "Y"), !1;
          } };t(this).on(this.getAttribute("data-event"), e[this.getAttribute("data-handler")]);
      });
    }, _generateHTML: function _generateHTML(t) {
      var e,
          i,
          s,
          n,
          o,
          a,
          r,
          h,
          l,
          c,
          u,
          d,
          p,
          f,
          g,
          m,
          _,
          v,
          b,
          y,
          w,
          k,
          x,
          C,
          D,
          I,
          T,
          P,
          M,
          S,
          H,
          z,
          O,
          A,
          N,
          W,
          E,
          F,
          L,
          R = new Date(),
          B = this._daylightSavingAdjust(new Date(R.getFullYear(), R.getMonth(), R.getDate())),
          Y = this._get(t, "isRTL"),
          j = this._get(t, "showButtonPanel"),
          q = this._get(t, "hideIfNoPrevNext"),
          K = this._get(t, "navigationAsDateFormat"),
          U = this._getNumberOfMonths(t),
          V = this._get(t, "showCurrentAtPos"),
          $ = this._get(t, "stepMonths"),
          X = 1 !== U[0] || 1 !== U[1],
          G = this._daylightSavingAdjust(t.currentDay ? new Date(t.currentYear, t.currentMonth, t.currentDay) : new Date(9999, 9, 9)),
          Q = this._getMinMaxDate(t, "min"),
          J = this._getMinMaxDate(t, "max"),
          Z = t.drawMonth - V,
          te = t.drawYear;if (0 > Z && (Z += 12, te--), J) for (e = this._daylightSavingAdjust(new Date(J.getFullYear(), J.getMonth() - U[0] * U[1] + 1, J.getDate())), e = Q && Q > e ? Q : e; this._daylightSavingAdjust(new Date(te, Z, 1)) > e;) {
        Z--, 0 > Z && (Z = 11, te--);
      }for (t.drawMonth = Z, t.drawYear = te, i = this._get(t, "prevText"), i = K ? this.formatDate(i, this._daylightSavingAdjust(new Date(te, Z - $, 1)), this._getFormatConfig(t)) : i, s = this._canAdjustMonth(t, -1, te, Z) ? "<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click' title='" + i + "'><span class='ui-icon ui-icon-circle-triangle-" + (Y ? "e" : "w") + "'>" + i + "</span></a>" : q ? "" : "<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='" + i + "'><span class='ui-icon ui-icon-circle-triangle-" + (Y ? "e" : "w") + "'>" + i + "</span></a>", n = this._get(t, "nextText"), n = K ? this.formatDate(n, this._daylightSavingAdjust(new Date(te, Z + $, 1)), this._getFormatConfig(t)) : n, o = this._canAdjustMonth(t, 1, te, Z) ? "<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click' title='" + n + "'><span class='ui-icon ui-icon-circle-triangle-" + (Y ? "w" : "e") + "'>" + n + "</span></a>" : q ? "" : "<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='" + n + "'><span class='ui-icon ui-icon-circle-triangle-" + (Y ? "w" : "e") + "'>" + n + "</span></a>", a = this._get(t, "currentText"), r = this._get(t, "gotoCurrent") && t.currentDay ? G : B, a = K ? this.formatDate(a, r, this._getFormatConfig(t)) : a, h = t.inline ? "" : "<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>" + this._get(t, "closeText") + "</button>", l = j ? "<div class='ui-datepicker-buttonpane ui-widget-content'>" + (Y ? h : "") + (this._isInRange(t, r) ? "<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'>" + a + "</button>" : "") + (Y ? "" : h) + "</div>" : "", c = parseInt(this._get(t, "firstDay"), 10), c = isNaN(c) ? 0 : c, u = this._get(t, "showWeek"), d = this._get(t, "dayNames"), p = this._get(t, "dayNamesMin"), f = this._get(t, "monthNames"), g = this._get(t, "monthNamesShort"), m = this._get(t, "beforeShowDay"), _ = this._get(t, "showOtherMonths"), v = this._get(t, "selectOtherMonths"), b = this._getDefaultDate(t), y = "", k = 0; U[0] > k; k++) {
        for (x = "", this.maxRows = 4, C = 0; U[1] > C; C++) {
          if (D = this._daylightSavingAdjust(new Date(te, Z, t.selectedDay)), I = " ui-corner-all", T = "", X) {
            if (T += "<div class='ui-datepicker-group", U[1] > 1) switch (C) {case 0:
                T += " ui-datepicker-group-first", I = " ui-corner-" + (Y ? "right" : "left");break;case U[1] - 1:
                T += " ui-datepicker-group-last", I = " ui-corner-" + (Y ? "left" : "right");break;default:
                T += " ui-datepicker-group-middle", I = "";}T += "'>";
          }for (T += "<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix" + I + "'>" + (/all|left/.test(I) && 0 === k ? Y ? o : s : "") + (/all|right/.test(I) && 0 === k ? Y ? s : o : "") + this._generateMonthYearHeader(t, Z, te, Q, J, k > 0 || C > 0, f, g) + "</div><table class='ui-datepicker-calendar'><thead>" + "<tr>", P = u ? "<th class='ui-datepicker-week-col'>" + this._get(t, "weekHeader") + "</th>" : "", w = 0; 7 > w; w++) {
            M = (w + c) % 7, P += "<th scope='col'" + ((w + c + 6) % 7 >= 5 ? " class='ui-datepicker-week-end'" : "") + ">" + "<span title='" + d[M] + "'>" + p[M] + "</span></th>";
          }for (T += P + "</tr></thead><tbody>", S = this._getDaysInMonth(te, Z), te === t.selectedYear && Z === t.selectedMonth && (t.selectedDay = Math.min(t.selectedDay, S)), H = (this._getFirstDayOfMonth(te, Z) - c + 7) % 7, z = Math.ceil((H + S) / 7), O = X ? this.maxRows > z ? this.maxRows : z : z, this.maxRows = O, A = this._daylightSavingAdjust(new Date(te, Z, 1 - H)), N = 0; O > N; N++) {
            for (T += "<tr>", W = u ? "<td class='ui-datepicker-week-col'>" + this._get(t, "calculateWeek")(A) + "</td>" : "", w = 0; 7 > w; w++) {
              E = m ? m.apply(t.input ? t.input[0] : null, [A]) : [!0, ""], F = A.getMonth() !== Z, L = F && !v || !E[0] || Q && Q > A || J && A > J, W += "<td class='" + ((w + c + 6) % 7 >= 5 ? " ui-datepicker-week-end" : "") + (F ? " ui-datepicker-other-month" : "") + (A.getTime() === D.getTime() && Z === t.selectedMonth && t._keyEvent || b.getTime() === A.getTime() && b.getTime() === D.getTime() ? " " + this._dayOverClass : "") + (L ? " " + this._unselectableClass + " ui-state-disabled" : "") + (F && !_ ? "" : " " + E[1] + (A.getTime() === G.getTime() ? " " + this._currentClass : "") + (A.getTime() === B.getTime() ? " ui-datepicker-today" : "")) + "'" + (F && !_ || !E[2] ? "" : " title='" + E[2].replace(/'/g, "&#39;") + "'") + (L ? "" : " data-handler='selectDay' data-event='click' data-month='" + A.getMonth() + "' data-year='" + A.getFullYear() + "'") + ">" + (F && !_ ? "&#xa0;" : L ? "<span class='ui-state-default'>" + A.getDate() + "</span>" : "<a class='ui-state-default" + (A.getTime() === B.getTime() ? " ui-state-highlight" : "") + (A.getTime() === G.getTime() ? " ui-state-active" : "") + (F ? " ui-priority-secondary" : "") + "' href='#'>" + A.getDate() + "</a>") + "</td>", A.setDate(A.getDate() + 1), A = this._daylightSavingAdjust(A);
            }T += W + "</tr>";
          }Z++, Z > 11 && (Z = 0, te++), T += "</tbody></table>" + (X ? "</div>" + (U[0] > 0 && C === U[1] - 1 ? "<div class='ui-datepicker-row-break'></div>" : "") : ""), x += T;
        }y += x;
      }return y += l, t._keyEvent = !1, y;
    }, _generateMonthYearHeader: function _generateMonthYearHeader(t, e, i, s, n, o, a, r) {
      var h,
          l,
          c,
          u,
          d,
          p,
          f,
          g,
          m = this._get(t, "changeMonth"),
          _ = this._get(t, "changeYear"),
          v = this._get(t, "showMonthAfterYear"),
          b = "<div class='ui-datepicker-title'>",
          y = "";if (o || !m) y += "<span class='ui-datepicker-month'>" + a[e] + "</span>";else {
        for (h = s && s.getFullYear() === i, l = n && n.getFullYear() === i, y += "<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>", c = 0; 12 > c; c++) {
          (!h || c >= s.getMonth()) && (!l || n.getMonth() >= c) && (y += "<option value='" + c + "'" + (c === e ? " selected='selected'" : "") + ">" + r[c] + "</option>");
        }y += "</select>";
      }if (v || (b += y + (!o && m && _ ? "" : "&#xa0;")), !t.yearshtml) if (t.yearshtml = "", o || !_) b += "<span class='ui-datepicker-year'>" + i + "</span>";else {
        for (u = this._get(t, "yearRange").split(":"), d = new Date().getFullYear(), p = function p(t) {
          var e = t.match(/c[+\-].*/) ? i + parseInt(t.substring(1), 10) : t.match(/[+\-].*/) ? d + parseInt(t, 10) : parseInt(t, 10);return isNaN(e) ? d : e;
        }, f = p(u[0]), g = Math.max(f, p(u[1] || "")), f = s ? Math.max(f, s.getFullYear()) : f, g = n ? Math.min(g, n.getFullYear()) : g, t.yearshtml += "<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>"; g >= f; f++) {
          t.yearshtml += "<option value='" + f + "'" + (f === i ? " selected='selected'" : "") + ">" + f + "</option>";
        }t.yearshtml += "</select>", b += t.yearshtml, t.yearshtml = null;
      }return b += this._get(t, "yearSuffix"), v && (b += (!o && m && _ ? "" : "&#xa0;") + y), b += "</div>";
    }, _adjustInstDate: function _adjustInstDate(t, e, i) {
      var s = t.selectedYear + ("Y" === i ? e : 0),
          n = t.selectedMonth + ("M" === i ? e : 0),
          o = Math.min(t.selectedDay, this._getDaysInMonth(s, n)) + ("D" === i ? e : 0),
          a = this._restrictMinMax(t, this._daylightSavingAdjust(new Date(s, n, o)));t.selectedDay = a.getDate(), t.drawMonth = t.selectedMonth = a.getMonth(), t.drawYear = t.selectedYear = a.getFullYear(), ("M" === i || "Y" === i) && this._notifyChange(t);
    }, _restrictMinMax: function _restrictMinMax(t, e) {
      var i = this._getMinMaxDate(t, "min"),
          s = this._getMinMaxDate(t, "max"),
          n = i && i > e ? i : e;return s && n > s ? s : n;
    }, _notifyChange: function _notifyChange(t) {
      var e = this._get(t, "onChangeMonthYear");e && e.apply(t.input ? t.input[0] : null, [t.selectedYear, t.selectedMonth + 1, t]);
    }, _getNumberOfMonths: function _getNumberOfMonths(t) {
      var e = this._get(t, "numberOfMonths");return null == e ? [1, 1] : "number" == typeof e ? [1, e] : e;
    }, _getMinMaxDate: function _getMinMaxDate(t, e) {
      return this._determineDate(t, this._get(t, e + "Date"), null);
    }, _getDaysInMonth: function _getDaysInMonth(t, e) {
      return 32 - this._daylightSavingAdjust(new Date(t, e, 32)).getDate();
    }, _getFirstDayOfMonth: function _getFirstDayOfMonth(t, e) {
      return new Date(t, e, 1).getDay();
    }, _canAdjustMonth: function _canAdjustMonth(t, e, i, s) {
      var n = this._getNumberOfMonths(t),
          o = this._daylightSavingAdjust(new Date(i, s + (0 > e ? e : n[0] * n[1]), 1));return 0 > e && o.setDate(this._getDaysInMonth(o.getFullYear(), o.getMonth())), this._isInRange(t, o);
    }, _isInRange: function _isInRange(t, e) {
      var i,
          s,
          n = this._getMinMaxDate(t, "min"),
          o = this._getMinMaxDate(t, "max"),
          a = null,
          r = null,
          h = this._get(t, "yearRange");return h && (i = h.split(":"), s = new Date().getFullYear(), a = parseInt(i[0], 10), r = parseInt(i[1], 10), i[0].match(/[+\-].*/) && (a += s), i[1].match(/[+\-].*/) && (r += s)), (!n || e.getTime() >= n.getTime()) && (!o || e.getTime() <= o.getTime()) && (!a || e.getFullYear() >= a) && (!r || r >= e.getFullYear());
    }, _getFormatConfig: function _getFormatConfig(t) {
      var e = this._get(t, "shortYearCutoff");return e = "string" != typeof e ? e : new Date().getFullYear() % 100 + parseInt(e, 10), { shortYearCutoff: e, dayNamesShort: this._get(t, "dayNamesShort"), dayNames: this._get(t, "dayNames"), monthNamesShort: this._get(t, "monthNamesShort"), monthNames: this._get(t, "monthNames") };
    }, _formatDate: function _formatDate(t, e, i, s) {
      e || (t.currentDay = t.selectedDay, t.currentMonth = t.selectedMonth, t.currentYear = t.selectedYear);var n = e ? "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) ? e : this._daylightSavingAdjust(new Date(s, i, e)) : this._daylightSavingAdjust(new Date(t.currentYear, t.currentMonth, t.currentDay));return this.formatDate(this._get(t, "dateFormat"), n, this._getFormatConfig(t));
    } }), t.fn.datepicker = function (e) {
    if (!this.length) return this;t.datepicker.initialized || (t(document).on("mousedown", t.datepicker._checkExternalClick), t.datepicker.initialized = !0), 0 === t("#" + t.datepicker._mainDivId).length && t("body").append(t.datepicker.dpDiv);var i = Array.prototype.slice.call(arguments, 1);return "string" != typeof e || "isDisabled" !== e && "getDate" !== e && "widget" !== e ? "option" === e && 2 === arguments.length && "string" == typeof arguments[1] ? t.datepicker["_" + e + "Datepicker"].apply(t.datepicker, [this[0]].concat(i)) : this.each(function () {
      "string" == typeof e ? t.datepicker["_" + e + "Datepicker"].apply(t.datepicker, [this].concat(i)) : t.datepicker._attachDatepicker(this, e);
    }) : t.datepicker["_" + e + "Datepicker"].apply(t.datepicker, [this[0]].concat(i));
  }, t.datepicker = new s(), t.datepicker.initialized = !1, t.datepicker.uuid = new Date().getTime(), t.datepicker.version = "1.12.1", t.datepicker, t.ui.ie = !!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase());var _ = !1;t(document).on("mouseup", function () {
    _ = !1;
  }), t.widget("ui.mouse", { version: "1.12.1", options: { cancel: "input, textarea, button, select, option", distance: 1, delay: 0 }, _mouseInit: function _mouseInit() {
      var e = this;this.element.on("mousedown." + this.widgetName, function (t) {
        return e._mouseDown(t);
      }).on("click." + this.widgetName, function (i) {
        return !0 === t.data(i.target, e.widgetName + ".preventClickEvent") ? (t.removeData(i.target, e.widgetName + ".preventClickEvent"), i.stopImmediatePropagation(), !1) : void 0;
      }), this.started = !1;
    }, _mouseDestroy: function _mouseDestroy() {
      this.element.off("." + this.widgetName), this._mouseMoveDelegate && this.document.off("mousemove." + this.widgetName, this._mouseMoveDelegate).off("mouseup." + this.widgetName, this._mouseUpDelegate);
    }, _mouseDown: function _mouseDown(e) {
      if (!_) {
        this._mouseMoved = !1, this._mouseStarted && this._mouseUp(e), this._mouseDownEvent = e;var i = this,
            s = 1 === e.which,
            n = "string" == typeof this.options.cancel && e.target.nodeName ? t(e.target).closest(this.options.cancel).length : !1;return s && !n && this._mouseCapture(e) ? (this.mouseDelayMet = !this.options.delay, this.mouseDelayMet || (this._mouseDelayTimer = setTimeout(function () {
          i.mouseDelayMet = !0;
        }, this.options.delay)), this._mouseDistanceMet(e) && this._mouseDelayMet(e) && (this._mouseStarted = this._mouseStart(e) !== !1, !this._mouseStarted) ? (e.preventDefault(), !0) : (!0 === t.data(e.target, this.widgetName + ".preventClickEvent") && t.removeData(e.target, this.widgetName + ".preventClickEvent"), this._mouseMoveDelegate = function (t) {
          return i._mouseMove(t);
        }, this._mouseUpDelegate = function (t) {
          return i._mouseUp(t);
        }, this.document.on("mousemove." + this.widgetName, this._mouseMoveDelegate).on("mouseup." + this.widgetName, this._mouseUpDelegate), e.preventDefault(), _ = !0, !0)) : !0;
      }
    }, _mouseMove: function _mouseMove(e) {
      if (this._mouseMoved) {
        if (t.ui.ie && (!document.documentMode || 9 > document.documentMode) && !e.button) return this._mouseUp(e);if (!e.which) if (e.originalEvent.altKey || e.originalEvent.ctrlKey || e.originalEvent.metaKey || e.originalEvent.shiftKey) this.ignoreMissingWhich = !0;else if (!this.ignoreMissingWhich) return this._mouseUp(e);
      }return (e.which || e.button) && (this._mouseMoved = !0), this._mouseStarted ? (this._mouseDrag(e), e.preventDefault()) : (this._mouseDistanceMet(e) && this._mouseDelayMet(e) && (this._mouseStarted = this._mouseStart(this._mouseDownEvent, e) !== !1, this._mouseStarted ? this._mouseDrag(e) : this._mouseUp(e)), !this._mouseStarted);
    }, _mouseUp: function _mouseUp(e) {
      this.document.off("mousemove." + this.widgetName, this._mouseMoveDelegate).off("mouseup." + this.widgetName, this._mouseUpDelegate), this._mouseStarted && (this._mouseStarted = !1, e.target === this._mouseDownEvent.target && t.data(e.target, this.widgetName + ".preventClickEvent", !0), this._mouseStop(e)), this._mouseDelayTimer && (clearTimeout(this._mouseDelayTimer), delete this._mouseDelayTimer), this.ignoreMissingWhich = !1, _ = !1, e.preventDefault();
    }, _mouseDistanceMet: function _mouseDistanceMet(t) {
      return Math.max(Math.abs(this._mouseDownEvent.pageX - t.pageX), Math.abs(this._mouseDownEvent.pageY - t.pageY)) >= this.options.distance;
    }, _mouseDelayMet: function _mouseDelayMet() {
      return this.mouseDelayMet;
    }, _mouseStart: function _mouseStart() {}, _mouseDrag: function _mouseDrag() {}, _mouseStop: function _mouseStop() {}, _mouseCapture: function _mouseCapture() {
      return !0;
    } }), t.ui.plugin = { add: function add(e, i, s) {
      var n,
          o = t.ui[e].prototype;for (n in s) {
        o.plugins[n] = o.plugins[n] || [], o.plugins[n].push([i, s[n]]);
      }
    }, call: function call(t, e, i, s) {
      var n,
          o = t.plugins[e];if (o && (s || t.element[0].parentNode && 11 !== t.element[0].parentNode.nodeType)) for (n = 0; o.length > n; n++) {
        t.options[o[n][0]] && o[n][1].apply(t.element, i);
      }
    } }, t.ui.safeBlur = function (e) {
    e && "body" !== e.nodeName.toLowerCase() && t(e).trigger("blur");
  }, t.widget("ui.draggable", t.ui.mouse, { version: "1.12.1", widgetEventPrefix: "drag", options: { addClasses: !0, appendTo: "parent", axis: !1, connectToSortable: !1, containment: !1, cursor: "auto", cursorAt: !1, grid: !1, handle: !1, helper: "original", iframeFix: !1, opacity: !1, refreshPositions: !1, revert: !1, revertDuration: 500, scope: "default", scroll: !0, scrollSensitivity: 20, scrollSpeed: 20, snap: !1, snapMode: "both", snapTolerance: 20, stack: !1, zIndex: !1, drag: null, start: null, stop: null }, _create: function _create() {
      "original" === this.options.helper && this._setPositionRelative(), this.options.addClasses && this._addClass("ui-draggable"), this._setHandleClassName(), this._mouseInit();
    }, _setOption: function _setOption(t, e) {
      this._super(t, e), "handle" === t && (this._removeHandleClassName(), this._setHandleClassName());
    }, _destroy: function _destroy() {
      return (this.helper || this.element).is(".ui-draggable-dragging") ? (this.destroyOnClear = !0, void 0) : (this._removeHandleClassName(), this._mouseDestroy(), void 0);
    }, _mouseCapture: function _mouseCapture(e) {
      var i = this.options;return this.helper || i.disabled || t(e.target).closest(".ui-resizable-handle").length > 0 ? !1 : (this.handle = this._getHandle(e), this.handle ? (this._blurActiveElement(e), this._blockFrames(i.iframeFix === !0 ? "iframe" : i.iframeFix), !0) : !1);
    }, _blockFrames: function _blockFrames(e) {
      this.iframeBlocks = this.document.find(e).map(function () {
        var e = t(this);return t("<div>").css("position", "absolute").appendTo(e.parent()).outerWidth(e.outerWidth()).outerHeight(e.outerHeight()).offset(e.offset())[0];
      });
    }, _unblockFrames: function _unblockFrames() {
      this.iframeBlocks && (this.iframeBlocks.remove(), delete this.iframeBlocks);
    }, _blurActiveElement: function _blurActiveElement(e) {
      var i = t.ui.safeActiveElement(this.document[0]),
          s = t(e.target);s.closest(i).length || t.ui.safeBlur(i);
    }, _mouseStart: function _mouseStart(e) {
      var i = this.options;return this.helper = this._createHelper(e), this._addClass(this.helper, "ui-draggable-dragging"), this._cacheHelperProportions(), t.ui.ddmanager && (t.ui.ddmanager.current = this), this._cacheMargins(), this.cssPosition = this.helper.css("position"), this.scrollParent = this.helper.scrollParent(!0), this.offsetParent = this.helper.offsetParent(), this.hasFixedAncestor = this.helper.parents().filter(function () {
        return "fixed" === t(this).css("position");
      }).length > 0, this.positionAbs = this.element.offset(), this._refreshOffsets(e), this.originalPosition = this.position = this._generatePosition(e, !1), this.originalPageX = e.pageX, this.originalPageY = e.pageY, i.cursorAt && this._adjustOffsetFromHelper(i.cursorAt), this._setContainment(), this._trigger("start", e) === !1 ? (this._clear(), !1) : (this._cacheHelperProportions(), t.ui.ddmanager && !i.dropBehaviour && t.ui.ddmanager.prepareOffsets(this, e), this._mouseDrag(e, !0), t.ui.ddmanager && t.ui.ddmanager.dragStart(this, e), !0);
    }, _refreshOffsets: function _refreshOffsets(t) {
      this.offset = { top: this.positionAbs.top - this.margins.top, left: this.positionAbs.left - this.margins.left, scroll: !1, parent: this._getParentOffset(), relative: this._getRelativeOffset() }, this.offset.click = { left: t.pageX - this.offset.left, top: t.pageY - this.offset.top };
    }, _mouseDrag: function _mouseDrag(e, i) {
      if (this.hasFixedAncestor && (this.offset.parent = this._getParentOffset()), this.position = this._generatePosition(e, !0), this.positionAbs = this._convertPositionTo("absolute"), !i) {
        var s = this._uiHash();if (this._trigger("drag", e, s) === !1) return this._mouseUp(new t.Event("mouseup", e)), !1;this.position = s.position;
      }return this.helper[0].style.left = this.position.left + "px", this.helper[0].style.top = this.position.top + "px", t.ui.ddmanager && t.ui.ddmanager.drag(this, e), !1;
    }, _mouseStop: function _mouseStop(e) {
      var i = this,
          s = !1;return t.ui.ddmanager && !this.options.dropBehaviour && (s = t.ui.ddmanager.drop(this, e)), this.dropped && (s = this.dropped, this.dropped = !1), "invalid" === this.options.revert && !s || "valid" === this.options.revert && s || this.options.revert === !0 || t.isFunction(this.options.revert) && this.options.revert.call(this.element, s) ? t(this.helper).animate(this.originalPosition, parseInt(this.options.revertDuration, 10), function () {
        i._trigger("stop", e) !== !1 && i._clear();
      }) : this._trigger("stop", e) !== !1 && this._clear(), !1;
    }, _mouseUp: function _mouseUp(e) {
      return this._unblockFrames(), t.ui.ddmanager && t.ui.ddmanager.dragStop(this, e), this.handleElement.is(e.target) && this.element.trigger("focus"), t.ui.mouse.prototype._mouseUp.call(this, e);
    }, cancel: function cancel() {
      return this.helper.is(".ui-draggable-dragging") ? this._mouseUp(new t.Event("mouseup", { target: this.element[0] })) : this._clear(), this;
    }, _getHandle: function _getHandle(e) {
      return this.options.handle ? !!t(e.target).closest(this.element.find(this.options.handle)).length : !0;
    }, _setHandleClassName: function _setHandleClassName() {
      this.handleElement = this.options.handle ? this.element.find(this.options.handle) : this.element, this._addClass(this.handleElement, "ui-draggable-handle");
    }, _removeHandleClassName: function _removeHandleClassName() {
      this._removeClass(this.handleElement, "ui-draggable-handle");
    }, _createHelper: function _createHelper(e) {
      var i = this.options,
          s = t.isFunction(i.helper),
          n = s ? t(i.helper.apply(this.element[0], [e])) : "clone" === i.helper ? this.element.clone().removeAttr("id") : this.element;return n.parents("body").length || n.appendTo("parent" === i.appendTo ? this.element[0].parentNode : i.appendTo), s && n[0] === this.element[0] && this._setPositionRelative(), n[0] === this.element[0] || /(fixed|absolute)/.test(n.css("position")) || n.css("position", "absolute"), n;
    }, _setPositionRelative: function _setPositionRelative() {
      /^(?:r|a|f)/.test(this.element.css("position")) || (this.element[0].style.position = "relative");
    }, _adjustOffsetFromHelper: function _adjustOffsetFromHelper(e) {
      "string" == typeof e && (e = e.split(" ")), t.isArray(e) && (e = { left: +e[0], top: +e[1] || 0 }), "left" in e && (this.offset.click.left = e.left + this.margins.left), "right" in e && (this.offset.click.left = this.helperProportions.width - e.right + this.margins.left), "top" in e && (this.offset.click.top = e.top + this.margins.top), "bottom" in e && (this.offset.click.top = this.helperProportions.height - e.bottom + this.margins.top);
    }, _isRootNode: function _isRootNode(t) {
      return (/(html|body)/i.test(t.tagName) || t === this.document[0]
      );
    }, _getParentOffset: function _getParentOffset() {
      var e = this.offsetParent.offset(),
          i = this.document[0];return "absolute" === this.cssPosition && this.scrollParent[0] !== i && t.contains(this.scrollParent[0], this.offsetParent[0]) && (e.left += this.scrollParent.scrollLeft(), e.top += this.scrollParent.scrollTop()), this._isRootNode(this.offsetParent[0]) && (e = { top: 0, left: 0 }), { top: e.top + (parseInt(this.offsetParent.css("borderTopWidth"), 10) || 0), left: e.left + (parseInt(this.offsetParent.css("borderLeftWidth"), 10) || 0) };
    }, _getRelativeOffset: function _getRelativeOffset() {
      if ("relative" !== this.cssPosition) return { top: 0, left: 0 };var t = this.element.position(),
          e = this._isRootNode(this.scrollParent[0]);return { top: t.top - (parseInt(this.helper.css("top"), 10) || 0) + (e ? 0 : this.scrollParent.scrollTop()), left: t.left - (parseInt(this.helper.css("left"), 10) || 0) + (e ? 0 : this.scrollParent.scrollLeft()) };
    }, _cacheMargins: function _cacheMargins() {
      this.margins = { left: parseInt(this.element.css("marginLeft"), 10) || 0, top: parseInt(this.element.css("marginTop"), 10) || 0, right: parseInt(this.element.css("marginRight"), 10) || 0, bottom: parseInt(this.element.css("marginBottom"), 10) || 0 };
    }, _cacheHelperProportions: function _cacheHelperProportions() {
      this.helperProportions = { width: this.helper.outerWidth(), height: this.helper.outerHeight() };
    }, _setContainment: function _setContainment() {
      var e,
          i,
          s,
          n = this.options,
          o = this.document[0];return this.relativeContainer = null, n.containment ? "window" === n.containment ? (this.containment = [t(window).scrollLeft() - this.offset.relative.left - this.offset.parent.left, t(window).scrollTop() - this.offset.relative.top - this.offset.parent.top, t(window).scrollLeft() + t(window).width() - this.helperProportions.width - this.margins.left, t(window).scrollTop() + (t(window).height() || o.body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top], void 0) : "document" === n.containment ? (this.containment = [0, 0, t(o).width() - this.helperProportions.width - this.margins.left, (t(o).height() || o.body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top], void 0) : n.containment.constructor === Array ? (this.containment = n.containment, void 0) : ("parent" === n.containment && (n.containment = this.helper[0].parentNode), i = t(n.containment), s = i[0], s && (e = /(scroll|auto)/.test(i.css("overflow")), this.containment = [(parseInt(i.css("borderLeftWidth"), 10) || 0) + (parseInt(i.css("paddingLeft"), 10) || 0), (parseInt(i.css("borderTopWidth"), 10) || 0) + (parseInt(i.css("paddingTop"), 10) || 0), (e ? Math.max(s.scrollWidth, s.offsetWidth) : s.offsetWidth) - (parseInt(i.css("borderRightWidth"), 10) || 0) - (parseInt(i.css("paddingRight"), 10) || 0) - this.helperProportions.width - this.margins.left - this.margins.right, (e ? Math.max(s.scrollHeight, s.offsetHeight) : s.offsetHeight) - (parseInt(i.css("borderBottomWidth"), 10) || 0) - (parseInt(i.css("paddingBottom"), 10) || 0) - this.helperProportions.height - this.margins.top - this.margins.bottom], this.relativeContainer = i), void 0) : (this.containment = null, void 0);
    }, _convertPositionTo: function _convertPositionTo(t, e) {
      e || (e = this.position);var i = "absolute" === t ? 1 : -1,
          s = this._isRootNode(this.scrollParent[0]);return { top: e.top + this.offset.relative.top * i + this.offset.parent.top * i - ("fixed" === this.cssPosition ? -this.offset.scroll.top : s ? 0 : this.offset.scroll.top) * i, left: e.left + this.offset.relative.left * i + this.offset.parent.left * i - ("fixed" === this.cssPosition ? -this.offset.scroll.left : s ? 0 : this.offset.scroll.left) * i };
    }, _generatePosition: function _generatePosition(t, e) {
      var i,
          s,
          n,
          o,
          a = this.options,
          r = this._isRootNode(this.scrollParent[0]),
          h = t.pageX,
          l = t.pageY;return r && this.offset.scroll || (this.offset.scroll = { top: this.scrollParent.scrollTop(), left: this.scrollParent.scrollLeft() }), e && (this.containment && (this.relativeContainer ? (s = this.relativeContainer.offset(), i = [this.containment[0] + s.left, this.containment[1] + s.top, this.containment[2] + s.left, this.containment[3] + s.top]) : i = this.containment, t.pageX - this.offset.click.left < i[0] && (h = i[0] + this.offset.click.left), t.pageY - this.offset.click.top < i[1] && (l = i[1] + this.offset.click.top), t.pageX - this.offset.click.left > i[2] && (h = i[2] + this.offset.click.left), t.pageY - this.offset.click.top > i[3] && (l = i[3] + this.offset.click.top)), a.grid && (n = a.grid[1] ? this.originalPageY + Math.round((l - this.originalPageY) / a.grid[1]) * a.grid[1] : this.originalPageY, l = i ? n - this.offset.click.top >= i[1] || n - this.offset.click.top > i[3] ? n : n - this.offset.click.top >= i[1] ? n - a.grid[1] : n + a.grid[1] : n, o = a.grid[0] ? this.originalPageX + Math.round((h - this.originalPageX) / a.grid[0]) * a.grid[0] : this.originalPageX, h = i ? o - this.offset.click.left >= i[0] || o - this.offset.click.left > i[2] ? o : o - this.offset.click.left >= i[0] ? o - a.grid[0] : o + a.grid[0] : o), "y" === a.axis && (h = this.originalPageX), "x" === a.axis && (l = this.originalPageY)), { top: l - this.offset.click.top - this.offset.relative.top - this.offset.parent.top + ("fixed" === this.cssPosition ? -this.offset.scroll.top : r ? 0 : this.offset.scroll.top), left: h - this.offset.click.left - this.offset.relative.left - this.offset.parent.left + ("fixed" === this.cssPosition ? -this.offset.scroll.left : r ? 0 : this.offset.scroll.left) };
    }, _clear: function _clear() {
      this._removeClass(this.helper, "ui-draggable-dragging"), this.helper[0] === this.element[0] || this.cancelHelperRemoval || this.helper.remove(), this.helper = null, this.cancelHelperRemoval = !1, this.destroyOnClear && this.destroy();
    }, _trigger: function _trigger(e, i, s) {
      return s = s || this._uiHash(), t.ui.plugin.call(this, e, [i, s, this], !0), /^(drag|start|stop)/.test(e) && (this.positionAbs = this._convertPositionTo("absolute"), s.offset = this.positionAbs), t.Widget.prototype._trigger.call(this, e, i, s);
    }, plugins: {}, _uiHash: function _uiHash() {
      return { helper: this.helper, position: this.position, originalPosition: this.originalPosition, offset: this.positionAbs };
    } }), t.ui.plugin.add("draggable", "connectToSortable", { start: function start(e, i, s) {
      var n = t.extend({}, i, { item: s.element });s.sortables = [], t(s.options.connectToSortable).each(function () {
        var i = t(this).sortable("instance");i && !i.options.disabled && (s.sortables.push(i), i.refreshPositions(), i._trigger("activate", e, n));
      });
    }, stop: function stop(e, i, s) {
      var n = t.extend({}, i, { item: s.element });s.cancelHelperRemoval = !1, t.each(s.sortables, function () {
        var t = this;t.isOver ? (t.isOver = 0, s.cancelHelperRemoval = !0, t.cancelHelperRemoval = !1, t._storedCSS = { position: t.placeholder.css("position"), top: t.placeholder.css("top"), left: t.placeholder.css("left") }, t._mouseStop(e), t.options.helper = t.options._helper) : (t.cancelHelperRemoval = !0, t._trigger("deactivate", e, n));
      });
    }, drag: function drag(e, i, s) {
      t.each(s.sortables, function () {
        var n = !1,
            o = this;o.positionAbs = s.positionAbs, o.helperProportions = s.helperProportions, o.offset.click = s.offset.click, o._intersectsWith(o.containerCache) && (n = !0, t.each(s.sortables, function () {
          return this.positionAbs = s.positionAbs, this.helperProportions = s.helperProportions, this.offset.click = s.offset.click, this !== o && this._intersectsWith(this.containerCache) && t.contains(o.element[0], this.element[0]) && (n = !1), n;
        })), n ? (o.isOver || (o.isOver = 1, s._parent = i.helper.parent(), o.currentItem = i.helper.appendTo(o.element).data("ui-sortable-item", !0), o.options._helper = o.options.helper, o.options.helper = function () {
          return i.helper[0];
        }, e.target = o.currentItem[0], o._mouseCapture(e, !0), o._mouseStart(e, !0, !0), o.offset.click.top = s.offset.click.top, o.offset.click.left = s.offset.click.left, o.offset.parent.left -= s.offset.parent.left - o.offset.parent.left, o.offset.parent.top -= s.offset.parent.top - o.offset.parent.top, s._trigger("toSortable", e), s.dropped = o.element, t.each(s.sortables, function () {
          this.refreshPositions();
        }), s.currentItem = s.element, o.fromOutside = s), o.currentItem && (o._mouseDrag(e), i.position = o.position)) : o.isOver && (o.isOver = 0, o.cancelHelperRemoval = !0, o.options._revert = o.options.revert, o.options.revert = !1, o._trigger("out", e, o._uiHash(o)), o._mouseStop(e, !0), o.options.revert = o.options._revert, o.options.helper = o.options._helper, o.placeholder && o.placeholder.remove(), i.helper.appendTo(s._parent), s._refreshOffsets(e), i.position = s._generatePosition(e, !0), s._trigger("fromSortable", e), s.dropped = !1, t.each(s.sortables, function () {
          this.refreshPositions();
        }));
      });
    } }), t.ui.plugin.add("draggable", "cursor", { start: function start(e, i, s) {
      var n = t("body"),
          o = s.options;n.css("cursor") && (o._cursor = n.css("cursor")), n.css("cursor", o.cursor);
    }, stop: function stop(e, i, s) {
      var n = s.options;n._cursor && t("body").css("cursor", n._cursor);
    } }), t.ui.plugin.add("draggable", "opacity", { start: function start(e, i, s) {
      var n = t(i.helper),
          o = s.options;n.css("opacity") && (o._opacity = n.css("opacity")), n.css("opacity", o.opacity);
    }, stop: function stop(e, i, s) {
      var n = s.options;n._opacity && t(i.helper).css("opacity", n._opacity);
    } }), t.ui.plugin.add("draggable", "scroll", { start: function start(t, e, i) {
      i.scrollParentNotHidden || (i.scrollParentNotHidden = i.helper.scrollParent(!1)), i.scrollParentNotHidden[0] !== i.document[0] && "HTML" !== i.scrollParentNotHidden[0].tagName && (i.overflowOffset = i.scrollParentNotHidden.offset());
    }, drag: function drag(e, i, s) {
      var n = s.options,
          o = !1,
          a = s.scrollParentNotHidden[0],
          r = s.document[0];a !== r && "HTML" !== a.tagName ? (n.axis && "x" === n.axis || (s.overflowOffset.top + a.offsetHeight - e.pageY < n.scrollSensitivity ? a.scrollTop = o = a.scrollTop + n.scrollSpeed : e.pageY - s.overflowOffset.top < n.scrollSensitivity && (a.scrollTop = o = a.scrollTop - n.scrollSpeed)), n.axis && "y" === n.axis || (s.overflowOffset.left + a.offsetWidth - e.pageX < n.scrollSensitivity ? a.scrollLeft = o = a.scrollLeft + n.scrollSpeed : e.pageX - s.overflowOffset.left < n.scrollSensitivity && (a.scrollLeft = o = a.scrollLeft - n.scrollSpeed))) : (n.axis && "x" === n.axis || (e.pageY - t(r).scrollTop() < n.scrollSensitivity ? o = t(r).scrollTop(t(r).scrollTop() - n.scrollSpeed) : t(window).height() - (e.pageY - t(r).scrollTop()) < n.scrollSensitivity && (o = t(r).scrollTop(t(r).scrollTop() + n.scrollSpeed))), n.axis && "y" === n.axis || (e.pageX - t(r).scrollLeft() < n.scrollSensitivity ? o = t(r).scrollLeft(t(r).scrollLeft() - n.scrollSpeed) : t(window).width() - (e.pageX - t(r).scrollLeft()) < n.scrollSensitivity && (o = t(r).scrollLeft(t(r).scrollLeft() + n.scrollSpeed)))), o !== !1 && t.ui.ddmanager && !n.dropBehaviour && t.ui.ddmanager.prepareOffsets(s, e);
    } }), t.ui.plugin.add("draggable", "snap", { start: function start(e, i, s) {
      var n = s.options;s.snapElements = [], t(n.snap.constructor !== String ? n.snap.items || ":data(ui-draggable)" : n.snap).each(function () {
        var e = t(this),
            i = e.offset();this !== s.element[0] && s.snapElements.push({ item: this, width: e.outerWidth(), height: e.outerHeight(), top: i.top, left: i.left });
      });
    }, drag: function drag(e, i, s) {
      var n,
          o,
          a,
          r,
          h,
          l,
          c,
          u,
          d,
          p,
          f = s.options,
          g = f.snapTolerance,
          m = i.offset.left,
          _ = m + s.helperProportions.width,
          v = i.offset.top,
          b = v + s.helperProportions.height;for (d = s.snapElements.length - 1; d >= 0; d--) {
        h = s.snapElements[d].left - s.margins.left, l = h + s.snapElements[d].width, c = s.snapElements[d].top - s.margins.top, u = c + s.snapElements[d].height, h - g > _ || m > l + g || c - g > b || v > u + g || !t.contains(s.snapElements[d].item.ownerDocument, s.snapElements[d].item) ? (s.snapElements[d].snapping && s.options.snap.release && s.options.snap.release.call(s.element, e, t.extend(s._uiHash(), { snapItem: s.snapElements[d].item })), s.snapElements[d].snapping = !1) : ("inner" !== f.snapMode && (n = g >= Math.abs(c - b), o = g >= Math.abs(u - v), a = g >= Math.abs(h - _), r = g >= Math.abs(l - m), n && (i.position.top = s._convertPositionTo("relative", { top: c - s.helperProportions.height, left: 0 }).top), o && (i.position.top = s._convertPositionTo("relative", { top: u, left: 0 }).top), a && (i.position.left = s._convertPositionTo("relative", { top: 0, left: h - s.helperProportions.width }).left), r && (i.position.left = s._convertPositionTo("relative", { top: 0, left: l }).left)), p = n || o || a || r, "outer" !== f.snapMode && (n = g >= Math.abs(c - v), o = g >= Math.abs(u - b), a = g >= Math.abs(h - m), r = g >= Math.abs(l - _), n && (i.position.top = s._convertPositionTo("relative", { top: c, left: 0 }).top), o && (i.position.top = s._convertPositionTo("relative", { top: u - s.helperProportions.height, left: 0 }).top), a && (i.position.left = s._convertPositionTo("relative", { top: 0, left: h }).left), r && (i.position.left = s._convertPositionTo("relative", { top: 0, left: l - s.helperProportions.width }).left)), !s.snapElements[d].snapping && (n || o || a || r || p) && s.options.snap.snap && s.options.snap.snap.call(s.element, e, t.extend(s._uiHash(), { snapItem: s.snapElements[d].item })), s.snapElements[d].snapping = n || o || a || r || p);
      }
    } }), t.ui.plugin.add("draggable", "stack", { start: function start(e, i, s) {
      var n,
          o = s.options,
          a = t.makeArray(t(o.stack)).sort(function (e, i) {
        return (parseInt(t(e).css("zIndex"), 10) || 0) - (parseInt(t(i).css("zIndex"), 10) || 0);
      });a.length && (n = parseInt(t(a[0]).css("zIndex"), 10) || 0, t(a).each(function (e) {
        t(this).css("zIndex", n + e);
      }), this.css("zIndex", n + a.length));
    } }), t.ui.plugin.add("draggable", "zIndex", { start: function start(e, i, s) {
      var n = t(i.helper),
          o = s.options;n.css("zIndex") && (o._zIndex = n.css("zIndex")), n.css("zIndex", o.zIndex);
    }, stop: function stop(e, i, s) {
      var n = s.options;n._zIndex && t(i.helper).css("zIndex", n._zIndex);
    } }), t.ui.draggable, t.widget("ui.resizable", t.ui.mouse, { version: "1.12.1", widgetEventPrefix: "resize", options: { alsoResize: !1, animate: !1, animateDuration: "slow", animateEasing: "swing", aspectRatio: !1, autoHide: !1, classes: { "ui-resizable-se": "ui-icon ui-icon-gripsmall-diagonal-se" }, containment: !1, ghost: !1, grid: !1, handles: "e,s,se", helper: !1, maxHeight: null, maxWidth: null, minHeight: 10, minWidth: 10, zIndex: 90, resize: null, start: null, stop: null }, _num: function _num(t) {
      return parseFloat(t) || 0;
    }, _isNumber: function _isNumber(t) {
      return !isNaN(parseFloat(t));
    }, _hasScroll: function _hasScroll(e, i) {
      if ("hidden" === t(e).css("overflow")) return !1;var s = i && "left" === i ? "scrollLeft" : "scrollTop",
          n = !1;return e[s] > 0 ? !0 : (e[s] = 1, n = e[s] > 0, e[s] = 0, n);
    }, _create: function _create() {
      var e,
          i = this.options,
          s = this;this._addClass("ui-resizable"), t.extend(this, { _aspectRatio: !!i.aspectRatio, aspectRatio: i.aspectRatio, originalElement: this.element, _proportionallyResizeElements: [], _helper: i.helper || i.ghost || i.animate ? i.helper || "ui-resizable-helper" : null }), this.element[0].nodeName.match(/^(canvas|textarea|input|select|button|img)$/i) && (this.element.wrap(t("<div class='ui-wrapper' style='overflow: hidden;'></div>").css({ position: this.element.css("position"), width: this.element.outerWidth(), height: this.element.outerHeight(), top: this.element.css("top"), left: this.element.css("left") })), this.element = this.element.parent().data("ui-resizable", this.element.resizable("instance")), this.elementIsWrapper = !0, e = { marginTop: this.originalElement.css("marginTop"), marginRight: this.originalElement.css("marginRight"), marginBottom: this.originalElement.css("marginBottom"), marginLeft: this.originalElement.css("marginLeft") }, this.element.css(e), this.originalElement.css("margin", 0), this.originalResizeStyle = this.originalElement.css("resize"), this.originalElement.css("resize", "none"), this._proportionallyResizeElements.push(this.originalElement.css({ position: "static", zoom: 1, display: "block" })), this.originalElement.css(e), this._proportionallyResize()), this._setupHandles(), i.autoHide && t(this.element).on("mouseenter", function () {
        i.disabled || (s._removeClass("ui-resizable-autohide"), s._handles.show());
      }).on("mouseleave", function () {
        i.disabled || s.resizing || (s._addClass("ui-resizable-autohide"), s._handles.hide());
      }), this._mouseInit();
    }, _destroy: function _destroy() {
      this._mouseDestroy();var e,
          i = function i(e) {
        t(e).removeData("resizable").removeData("ui-resizable").off(".resizable").find(".ui-resizable-handle").remove();
      };return this.elementIsWrapper && (i(this.element), e = this.element, this.originalElement.css({ position: e.css("position"), width: e.outerWidth(), height: e.outerHeight(), top: e.css("top"), left: e.css("left") }).insertAfter(e), e.remove()), this.originalElement.css("resize", this.originalResizeStyle), i(this.originalElement), this;
    }, _setOption: function _setOption(t, e) {
      switch (this._super(t, e), t) {case "handles":
          this._removeHandles(), this._setupHandles();break;default:}
    }, _setupHandles: function _setupHandles() {
      var e,
          i,
          s,
          n,
          o,
          a = this.options,
          r = this;if (this.handles = a.handles || (t(".ui-resizable-handle", this.element).length ? { n: ".ui-resizable-n", e: ".ui-resizable-e", s: ".ui-resizable-s", w: ".ui-resizable-w", se: ".ui-resizable-se", sw: ".ui-resizable-sw", ne: ".ui-resizable-ne", nw: ".ui-resizable-nw" } : "e,s,se"), this._handles = t(), this.handles.constructor === String) for ("all" === this.handles && (this.handles = "n,e,s,w,se,sw,ne,nw"), s = this.handles.split(","), this.handles = {}, i = 0; s.length > i; i++) {
        e = t.trim(s[i]), n = "ui-resizable-" + e, o = t("<div>"), this._addClass(o, "ui-resizable-handle " + n), o.css({ zIndex: a.zIndex }), this.handles[e] = ".ui-resizable-" + e, this.element.append(o);
      }this._renderAxis = function (e) {
        var i, s, n, o;e = e || this.element;for (i in this.handles) {
          this.handles[i].constructor === String ? this.handles[i] = this.element.children(this.handles[i]).first().show() : (this.handles[i].jquery || this.handles[i].nodeType) && (this.handles[i] = t(this.handles[i]), this._on(this.handles[i], { mousedown: r._mouseDown })), this.elementIsWrapper && this.originalElement[0].nodeName.match(/^(textarea|input|select|button)$/i) && (s = t(this.handles[i], this.element), o = /sw|ne|nw|se|n|s/.test(i) ? s.outerHeight() : s.outerWidth(), n = ["padding", /ne|nw|n/.test(i) ? "Top" : /se|sw|s/.test(i) ? "Bottom" : /^e$/.test(i) ? "Right" : "Left"].join(""), e.css(n, o), this._proportionallyResize()), this._handles = this._handles.add(this.handles[i]);
        }
      }, this._renderAxis(this.element), this._handles = this._handles.add(this.element.find(".ui-resizable-handle")), this._handles.disableSelection(), this._handles.on("mouseover", function () {
        r.resizing || (this.className && (o = this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i)), r.axis = o && o[1] ? o[1] : "se");
      }), a.autoHide && (this._handles.hide(), this._addClass("ui-resizable-autohide"));
    }, _removeHandles: function _removeHandles() {
      this._handles.remove();
    }, _mouseCapture: function _mouseCapture(e) {
      var i,
          s,
          n = !1;for (i in this.handles) {
        s = t(this.handles[i])[0], (s === e.target || t.contains(s, e.target)) && (n = !0);
      }return !this.options.disabled && n;
    }, _mouseStart: function _mouseStart(e) {
      var i,
          s,
          n,
          o = this.options,
          a = this.element;return this.resizing = !0, this._renderProxy(), i = this._num(this.helper.css("left")), s = this._num(this.helper.css("top")), o.containment && (i += t(o.containment).scrollLeft() || 0, s += t(o.containment).scrollTop() || 0), this.offset = this.helper.offset(), this.position = { left: i, top: s }, this.size = this._helper ? { width: this.helper.width(), height: this.helper.height() } : { width: a.width(), height: a.height() }, this.originalSize = this._helper ? { width: a.outerWidth(), height: a.outerHeight() } : { width: a.width(), height: a.height() }, this.sizeDiff = { width: a.outerWidth() - a.width(), height: a.outerHeight() - a.height() }, this.originalPosition = { left: i, top: s }, this.originalMousePosition = { left: e.pageX, top: e.pageY }, this.aspectRatio = "number" == typeof o.aspectRatio ? o.aspectRatio : this.originalSize.width / this.originalSize.height || 1, n = t(".ui-resizable-" + this.axis).css("cursor"), t("body").css("cursor", "auto" === n ? this.axis + "-resize" : n), this._addClass("ui-resizable-resizing"), this._propagate("start", e), !0;
    }, _mouseDrag: function _mouseDrag(e) {
      var i,
          s,
          n = this.originalMousePosition,
          o = this.axis,
          a = e.pageX - n.left || 0,
          r = e.pageY - n.top || 0,
          h = this._change[o];return this._updatePrevProperties(), h ? (i = h.apply(this, [e, a, r]), this._updateVirtualBoundaries(e.shiftKey), (this._aspectRatio || e.shiftKey) && (i = this._updateRatio(i, e)), i = this._respectSize(i, e), this._updateCache(i), this._propagate("resize", e), s = this._applyChanges(), !this._helper && this._proportionallyResizeElements.length && this._proportionallyResize(), t.isEmptyObject(s) || (this._updatePrevProperties(), this._trigger("resize", e, this.ui()), this._applyChanges()), !1) : !1;
    }, _mouseStop: function _mouseStop(e) {
      this.resizing = !1;var i,
          s,
          n,
          o,
          a,
          r,
          h,
          l = this.options,
          c = this;return this._helper && (i = this._proportionallyResizeElements, s = i.length && /textarea/i.test(i[0].nodeName), n = s && this._hasScroll(i[0], "left") ? 0 : c.sizeDiff.height, o = s ? 0 : c.sizeDiff.width, a = { width: c.helper.width() - o, height: c.helper.height() - n }, r = parseFloat(c.element.css("left")) + (c.position.left - c.originalPosition.left) || null, h = parseFloat(c.element.css("top")) + (c.position.top - c.originalPosition.top) || null, l.animate || this.element.css(t.extend(a, { top: h, left: r })), c.helper.height(c.size.height), c.helper.width(c.size.width), this._helper && !l.animate && this._proportionallyResize()), t("body").css("cursor", "auto"), this._removeClass("ui-resizable-resizing"), this._propagate("stop", e), this._helper && this.helper.remove(), !1;
    }, _updatePrevProperties: function _updatePrevProperties() {
      this.prevPosition = { top: this.position.top, left: this.position.left }, this.prevSize = { width: this.size.width, height: this.size.height };
    }, _applyChanges: function _applyChanges() {
      var t = {};return this.position.top !== this.prevPosition.top && (t.top = this.position.top + "px"), this.position.left !== this.prevPosition.left && (t.left = this.position.left + "px"), this.size.width !== this.prevSize.width && (t.width = this.size.width + "px"), this.size.height !== this.prevSize.height && (t.height = this.size.height + "px"), this.helper.css(t), t;
    }, _updateVirtualBoundaries: function _updateVirtualBoundaries(t) {
      var e,
          i,
          s,
          n,
          o,
          a = this.options;o = { minWidth: this._isNumber(a.minWidth) ? a.minWidth : 0, maxWidth: this._isNumber(a.maxWidth) ? a.maxWidth : 1 / 0, minHeight: this._isNumber(a.minHeight) ? a.minHeight : 0, maxHeight: this._isNumber(a.maxHeight) ? a.maxHeight : 1 / 0 }, (this._aspectRatio || t) && (e = o.minHeight * this.aspectRatio, s = o.minWidth / this.aspectRatio, i = o.maxHeight * this.aspectRatio, n = o.maxWidth / this.aspectRatio, e > o.minWidth && (o.minWidth = e), s > o.minHeight && (o.minHeight = s), o.maxWidth > i && (o.maxWidth = i), o.maxHeight > n && (o.maxHeight = n)), this._vBoundaries = o;
    }, _updateCache: function _updateCache(t) {
      this.offset = this.helper.offset(), this._isNumber(t.left) && (this.position.left = t.left), this._isNumber(t.top) && (this.position.top = t.top), this._isNumber(t.height) && (this.size.height = t.height), this._isNumber(t.width) && (this.size.width = t.width);
    }, _updateRatio: function _updateRatio(t) {
      var e = this.position,
          i = this.size,
          s = this.axis;return this._isNumber(t.height) ? t.width = t.height * this.aspectRatio : this._isNumber(t.width) && (t.height = t.width / this.aspectRatio), "sw" === s && (t.left = e.left + (i.width - t.width), t.top = null), "nw" === s && (t.top = e.top + (i.height - t.height), t.left = e.left + (i.width - t.width)), t;
    }, _respectSize: function _respectSize(t) {
      var e = this._vBoundaries,
          i = this.axis,
          s = this._isNumber(t.width) && e.maxWidth && e.maxWidth < t.width,
          n = this._isNumber(t.height) && e.maxHeight && e.maxHeight < t.height,
          o = this._isNumber(t.width) && e.minWidth && e.minWidth > t.width,
          a = this._isNumber(t.height) && e.minHeight && e.minHeight > t.height,
          r = this.originalPosition.left + this.originalSize.width,
          h = this.originalPosition.top + this.originalSize.height,
          l = /sw|nw|w/.test(i),
          c = /nw|ne|n/.test(i);return o && (t.width = e.minWidth), a && (t.height = e.minHeight), s && (t.width = e.maxWidth), n && (t.height = e.maxHeight), o && l && (t.left = r - e.minWidth), s && l && (t.left = r - e.maxWidth), a && c && (t.top = h - e.minHeight), n && c && (t.top = h - e.maxHeight), t.width || t.height || t.left || !t.top ? t.width || t.height || t.top || !t.left || (t.left = null) : t.top = null, t;
    }, _getPaddingPlusBorderDimensions: function _getPaddingPlusBorderDimensions(t) {
      for (var e = 0, i = [], s = [t.css("borderTopWidth"), t.css("borderRightWidth"), t.css("borderBottomWidth"), t.css("borderLeftWidth")], n = [t.css("paddingTop"), t.css("paddingRight"), t.css("paddingBottom"), t.css("paddingLeft")]; 4 > e; e++) {
        i[e] = parseFloat(s[e]) || 0, i[e] += parseFloat(n[e]) || 0;
      }return { height: i[0] + i[2], width: i[1] + i[3] };
    }, _proportionallyResize: function _proportionallyResize() {
      if (this._proportionallyResizeElements.length) for (var t, e = 0, i = this.helper || this.element; this._proportionallyResizeElements.length > e; e++) {
        t = this._proportionallyResizeElements[e], this.outerDimensions || (this.outerDimensions = this._getPaddingPlusBorderDimensions(t)), t.css({ height: i.height() - this.outerDimensions.height || 0, width: i.width() - this.outerDimensions.width || 0 });
      }
    }, _renderProxy: function _renderProxy() {
      var e = this.element,
          i = this.options;this.elementOffset = e.offset(), this._helper ? (this.helper = this.helper || t("<div style='overflow:hidden;'></div>"), this._addClass(this.helper, this._helper), this.helper.css({ width: this.element.outerWidth(), height: this.element.outerHeight(), position: "absolute", left: this.elementOffset.left + "px", top: this.elementOffset.top + "px", zIndex: ++i.zIndex }), this.helper.appendTo("body").disableSelection()) : this.helper = this.element;
    }, _change: { e: function e(t, _e) {
        return { width: this.originalSize.width + _e };
      }, w: function w(t, e) {
        var i = this.originalSize,
            s = this.originalPosition;return { left: s.left + e, width: i.width - e };
      }, n: function n(t, e, i) {
        var s = this.originalSize,
            n = this.originalPosition;return { top: n.top + i, height: s.height - i };
      }, s: function s(t, e, i) {
        return { height: this.originalSize.height + i };
      }, se: function se(e, i, s) {
        return t.extend(this._change.s.apply(this, arguments), this._change.e.apply(this, [e, i, s]));
      }, sw: function sw(e, i, s) {
        return t.extend(this._change.s.apply(this, arguments), this._change.w.apply(this, [e, i, s]));
      }, ne: function ne(e, i, s) {
        return t.extend(this._change.n.apply(this, arguments), this._change.e.apply(this, [e, i, s]));
      }, nw: function nw(e, i, s) {
        return t.extend(this._change.n.apply(this, arguments), this._change.w.apply(this, [e, i, s]));
      } }, _propagate: function _propagate(e, i) {
      t.ui.plugin.call(this, e, [i, this.ui()]), "resize" !== e && this._trigger(e, i, this.ui());
    }, plugins: {}, ui: function ui() {
      return { originalElement: this.originalElement, element: this.element, helper: this.helper, position: this.position, size: this.size, originalSize: this.originalSize, originalPosition: this.originalPosition };
    } }), t.ui.plugin.add("resizable", "animate", { stop: function stop(e) {
      var i = t(this).resizable("instance"),
          s = i.options,
          n = i._proportionallyResizeElements,
          o = n.length && /textarea/i.test(n[0].nodeName),
          a = o && i._hasScroll(n[0], "left") ? 0 : i.sizeDiff.height,
          r = o ? 0 : i.sizeDiff.width,
          h = { width: i.size.width - r, height: i.size.height - a },
          l = parseFloat(i.element.css("left")) + (i.position.left - i.originalPosition.left) || null,
          c = parseFloat(i.element.css("top")) + (i.position.top - i.originalPosition.top) || null;i.element.animate(t.extend(h, c && l ? { top: c, left: l } : {}), { duration: s.animateDuration, easing: s.animateEasing, step: function step() {
          var s = { width: parseFloat(i.element.css("width")), height: parseFloat(i.element.css("height")), top: parseFloat(i.element.css("top")), left: parseFloat(i.element.css("left")) };n && n.length && t(n[0]).css({ width: s.width, height: s.height }), i._updateCache(s), i._propagate("resize", e);
        } });
    } }), t.ui.plugin.add("resizable", "containment", { start: function start() {
      var e,
          i,
          s,
          n,
          o,
          a,
          r,
          h = t(this).resizable("instance"),
          l = h.options,
          c = h.element,
          u = l.containment,
          d = u instanceof t ? u.get(0) : /parent/.test(u) ? c.parent().get(0) : u;d && (h.containerElement = t(d), /document/.test(u) || u === document ? (h.containerOffset = { left: 0, top: 0 }, h.containerPosition = { left: 0, top: 0 }, h.parentData = { element: t(document), left: 0, top: 0, width: t(document).width(), height: t(document).height() || document.body.parentNode.scrollHeight }) : (e = t(d), i = [], t(["Top", "Right", "Left", "Bottom"]).each(function (t, s) {
        i[t] = h._num(e.css("padding" + s));
      }), h.containerOffset = e.offset(), h.containerPosition = e.position(), h.containerSize = { height: e.innerHeight() - i[3], width: e.innerWidth() - i[1] }, s = h.containerOffset, n = h.containerSize.height, o = h.containerSize.width, a = h._hasScroll(d, "left") ? d.scrollWidth : o, r = h._hasScroll(d) ? d.scrollHeight : n, h.parentData = { element: d, left: s.left, top: s.top, width: a, height: r }));
    }, resize: function resize(e) {
      var i,
          s,
          n,
          o,
          a = t(this).resizable("instance"),
          r = a.options,
          h = a.containerOffset,
          l = a.position,
          c = a._aspectRatio || e.shiftKey,
          u = { top: 0, left: 0 },
          d = a.containerElement,
          p = !0;d[0] !== document && /static/.test(d.css("position")) && (u = h), l.left < (a._helper ? h.left : 0) && (a.size.width = a.size.width + (a._helper ? a.position.left - h.left : a.position.left - u.left), c && (a.size.height = a.size.width / a.aspectRatio, p = !1), a.position.left = r.helper ? h.left : 0), l.top < (a._helper ? h.top : 0) && (a.size.height = a.size.height + (a._helper ? a.position.top - h.top : a.position.top), c && (a.size.width = a.size.height * a.aspectRatio, p = !1), a.position.top = a._helper ? h.top : 0), n = a.containerElement.get(0) === a.element.parent().get(0), o = /relative|absolute/.test(a.containerElement.css("position")), n && o ? (a.offset.left = a.parentData.left + a.position.left, a.offset.top = a.parentData.top + a.position.top) : (a.offset.left = a.element.offset().left, a.offset.top = a.element.offset().top), i = Math.abs(a.sizeDiff.width + (a._helper ? a.offset.left - u.left : a.offset.left - h.left)), s = Math.abs(a.sizeDiff.height + (a._helper ? a.offset.top - u.top : a.offset.top - h.top)), i + a.size.width >= a.parentData.width && (a.size.width = a.parentData.width - i, c && (a.size.height = a.size.width / a.aspectRatio, p = !1)), s + a.size.height >= a.parentData.height && (a.size.height = a.parentData.height - s, c && (a.size.width = a.size.height * a.aspectRatio, p = !1)), p || (a.position.left = a.prevPosition.left, a.position.top = a.prevPosition.top, a.size.width = a.prevSize.width, a.size.height = a.prevSize.height);
    }, stop: function stop() {
      var e = t(this).resizable("instance"),
          i = e.options,
          s = e.containerOffset,
          n = e.containerPosition,
          o = e.containerElement,
          a = t(e.helper),
          r = a.offset(),
          h = a.outerWidth() - e.sizeDiff.width,
          l = a.outerHeight() - e.sizeDiff.height;e._helper && !i.animate && /relative/.test(o.css("position")) && t(this).css({ left: r.left - n.left - s.left, width: h, height: l }), e._helper && !i.animate && /static/.test(o.css("position")) && t(this).css({ left: r.left - n.left - s.left, width: h, height: l });
    } }), t.ui.plugin.add("resizable", "alsoResize", { start: function start() {
      var e = t(this).resizable("instance"),
          i = e.options;t(i.alsoResize).each(function () {
        var e = t(this);e.data("ui-resizable-alsoresize", { width: parseFloat(e.width()), height: parseFloat(e.height()), left: parseFloat(e.css("left")), top: parseFloat(e.css("top")) });
      });
    }, resize: function resize(e, i) {
      var s = t(this).resizable("instance"),
          n = s.options,
          o = s.originalSize,
          a = s.originalPosition,
          r = { height: s.size.height - o.height || 0, width: s.size.width - o.width || 0, top: s.position.top - a.top || 0, left: s.position.left - a.left || 0 };t(n.alsoResize).each(function () {
        var e = t(this),
            s = t(this).data("ui-resizable-alsoresize"),
            n = {},
            o = e.parents(i.originalElement[0]).length ? ["width", "height"] : ["width", "height", "top", "left"];t.each(o, function (t, e) {
          var i = (s[e] || 0) + (r[e] || 0);i && i >= 0 && (n[e] = i || null);
        }), e.css(n);
      });
    }, stop: function stop() {
      t(this).removeData("ui-resizable-alsoresize");
    } }), t.ui.plugin.add("resizable", "ghost", { start: function start() {
      var e = t(this).resizable("instance"),
          i = e.size;e.ghost = e.originalElement.clone(), e.ghost.css({ opacity: .25, display: "block", position: "relative", height: i.height, width: i.width, margin: 0, left: 0, top: 0 }), e._addClass(e.ghost, "ui-resizable-ghost"), t.uiBackCompat !== !1 && "string" == typeof e.options.ghost && e.ghost.addClass(this.options.ghost), e.ghost.appendTo(e.helper);
    }, resize: function resize() {
      var e = t(this).resizable("instance");e.ghost && e.ghost.css({ position: "relative", height: e.size.height, width: e.size.width });
    }, stop: function stop() {
      var e = t(this).resizable("instance");e.ghost && e.helper && e.helper.get(0).removeChild(e.ghost.get(0));
    } }), t.ui.plugin.add("resizable", "grid", { resize: function resize() {
      var e,
          i = t(this).resizable("instance"),
          s = i.options,
          n = i.size,
          o = i.originalSize,
          a = i.originalPosition,
          r = i.axis,
          h = "number" == typeof s.grid ? [s.grid, s.grid] : s.grid,
          l = h[0] || 1,
          c = h[1] || 1,
          u = Math.round((n.width - o.width) / l) * l,
          d = Math.round((n.height - o.height) / c) * c,
          p = o.width + u,
          f = o.height + d,
          g = s.maxWidth && p > s.maxWidth,
          m = s.maxHeight && f > s.maxHeight,
          _ = s.minWidth && s.minWidth > p,
          v = s.minHeight && s.minHeight > f;s.grid = h, _ && (p += l), v && (f += c), g && (p -= l), m && (f -= c), /^(se|s|e)$/.test(r) ? (i.size.width = p, i.size.height = f) : /^(ne)$/.test(r) ? (i.size.width = p, i.size.height = f, i.position.top = a.top - d) : /^(sw)$/.test(r) ? (i.size.width = p, i.size.height = f, i.position.left = a.left - u) : ((0 >= f - c || 0 >= p - l) && (e = i._getPaddingPlusBorderDimensions(this)), f - c > 0 ? (i.size.height = f, i.position.top = a.top - d) : (f = c - e.height, i.size.height = f, i.position.top = a.top + o.height - f), p - l > 0 ? (i.size.width = p, i.position.left = a.left - u) : (p = l - e.width, i.size.width = p, i.position.left = a.left + o.width - p));
    } }), t.ui.resizable, t.widget("ui.dialog", { version: "1.12.1", options: { appendTo: "body", autoOpen: !0, buttons: [], classes: { "ui-dialog": "ui-corner-all", "ui-dialog-titlebar": "ui-corner-all" }, closeOnEscape: !0, closeText: "Close", draggable: !0, hide: null, height: "auto", maxHeight: null, maxWidth: null, minHeight: 150, minWidth: 150, modal: !1, position: { my: "center", at: "center", of: window, collision: "fit", using: function using(e) {
          var i = t(this).css(e).offset().top;0 > i && t(this).css("top", e.top - i);
        } }, resizable: !0, show: null, title: null, width: 300, beforeClose: null, close: null, drag: null, dragStart: null, dragStop: null, focus: null, open: null, resize: null, resizeStart: null, resizeStop: null }, sizeRelatedOptions: { buttons: !0, height: !0, maxHeight: !0, maxWidth: !0, minHeight: !0, minWidth: !0, width: !0 }, resizableRelatedOptions: { maxHeight: !0, maxWidth: !0, minHeight: !0, minWidth: !0 }, _create: function _create() {
      this.originalCss = { display: this.element[0].style.display, width: this.element[0].style.width, minHeight: this.element[0].style.minHeight, maxHeight: this.element[0].style.maxHeight, height: this.element[0].style.height }, this.originalPosition = { parent: this.element.parent(), index: this.element.parent().children().index(this.element) }, this.originalTitle = this.element.attr("title"), null == this.options.title && null != this.originalTitle && (this.options.title = this.originalTitle), this.options.disabled && (this.options.disabled = !1), this._createWrapper(), this.element.show().removeAttr("title").appendTo(this.uiDialog), this._addClass("ui-dialog-content", "ui-widget-content"), this._createTitlebar(), this._createButtonPane(), this.options.draggable && t.fn.draggable && this._makeDraggable(), this.options.resizable && t.fn.resizable && this._makeResizable(), this._isOpen = !1, this._trackFocus();
    }, _init: function _init() {
      this.options.autoOpen && this.open();
    }, _appendTo: function _appendTo() {
      var e = this.options.appendTo;return e && (e.jquery || e.nodeType) ? t(e) : this.document.find(e || "body").eq(0);
    }, _destroy: function _destroy() {
      var t,
          e = this.originalPosition;this._untrackInstance(), this._destroyOverlay(), this.element.removeUniqueId().css(this.originalCss).detach(), this.uiDialog.remove(), this.originalTitle && this.element.attr("title", this.originalTitle), t = e.parent.children().eq(e.index), t.length && t[0] !== this.element[0] ? t.before(this.element) : e.parent.append(this.element);
    }, widget: function widget() {
      return this.uiDialog;
    }, disable: t.noop, enable: t.noop, close: function close(e) {
      var i = this;this._isOpen && this._trigger("beforeClose", e) !== !1 && (this._isOpen = !1, this._focusedElement = null, this._destroyOverlay(), this._untrackInstance(), this.opener.filter(":focusable").trigger("focus").length || t.ui.safeBlur(t.ui.safeActiveElement(this.document[0])), this._hide(this.uiDialog, this.options.hide, function () {
        i._trigger("close", e);
      }));
    }, isOpen: function isOpen() {
      return this._isOpen;
    }, moveToTop: function moveToTop() {
      this._moveToTop();
    }, _moveToTop: function _moveToTop(e, i) {
      var s = !1,
          n = this.uiDialog.siblings(".ui-front:visible").map(function () {
        return +t(this).css("z-index");
      }).get(),
          o = Math.max.apply(null, n);return o >= +this.uiDialog.css("z-index") && (this.uiDialog.css("z-index", o + 1), s = !0), s && !i && this._trigger("focus", e), s;
    }, open: function open() {
      var e = this;return this._isOpen ? (this._moveToTop() && this._focusTabbable(), void 0) : (this._isOpen = !0, this.opener = t(t.ui.safeActiveElement(this.document[0])), this._size(), this._position(), this._createOverlay(), this._moveToTop(null, !0), this.overlay && this.overlay.css("z-index", this.uiDialog.css("z-index") - 1), this._show(this.uiDialog, this.options.show, function () {
        e._focusTabbable(), e._trigger("focus");
      }), this._makeFocusTarget(), this._trigger("open"), void 0);
    }, _focusTabbable: function _focusTabbable() {
      var t = this._focusedElement;t || (t = this.element.find("[autofocus]")), t.length || (t = this.element.find(":tabbable")), t.length || (t = this.uiDialogButtonPane.find(":tabbable")), t.length || (t = this.uiDialogTitlebarClose.filter(":tabbable")), t.length || (t = this.uiDialog), t.eq(0).trigger("focus");
    }, _keepFocus: function _keepFocus(e) {
      function i() {
        var e = t.ui.safeActiveElement(this.document[0]),
            i = this.uiDialog[0] === e || t.contains(this.uiDialog[0], e);i || this._focusTabbable();
      }e.preventDefault(), i.call(this), this._delay(i);
    }, _createWrapper: function _createWrapper() {
      this.uiDialog = t("<div>").hide().attr({ tabIndex: -1, role: "dialog" }).appendTo(this._appendTo()), this._addClass(this.uiDialog, "ui-dialog", "ui-widget ui-widget-content ui-front"), this._on(this.uiDialog, { keydown: function keydown(e) {
          if (this.options.closeOnEscape && !e.isDefaultPrevented() && e.keyCode && e.keyCode === t.ui.keyCode.ESCAPE) return e.preventDefault(), this.close(e), void 0;if (e.keyCode === t.ui.keyCode.TAB && !e.isDefaultPrevented()) {
            var i = this.uiDialog.find(":tabbable"),
                s = i.filter(":first"),
                n = i.filter(":last");e.target !== n[0] && e.target !== this.uiDialog[0] || e.shiftKey ? e.target !== s[0] && e.target !== this.uiDialog[0] || !e.shiftKey || (this._delay(function () {
              n.trigger("focus");
            }), e.preventDefault()) : (this._delay(function () {
              s.trigger("focus");
            }), e.preventDefault());
          }
        }, mousedown: function mousedown(t) {
          this._moveToTop(t) && this._focusTabbable();
        } }), this.element.find("[aria-describedby]").length || this.uiDialog.attr({ "aria-describedby": this.element.uniqueId().attr("id") });
    }, _createTitlebar: function _createTitlebar() {
      var e;this.uiDialogTitlebar = t("<div>"), this._addClass(this.uiDialogTitlebar, "ui-dialog-titlebar", "ui-widget-header ui-helper-clearfix"), this._on(this.uiDialogTitlebar, { mousedown: function mousedown(e) {
          t(e.target).closest(".ui-dialog-titlebar-close") || this.uiDialog.trigger("focus");
        } }), this.uiDialogTitlebarClose = t("<button type='button'></button>").button({ label: t("<a>").text(this.options.closeText).html(), icon: "ui-icon-closethick", showLabel: !1 }).appendTo(this.uiDialogTitlebar), this._addClass(this.uiDialogTitlebarClose, "ui-dialog-titlebar-close"), this._on(this.uiDialogTitlebarClose, { click: function click(t) {
          t.preventDefault(), this.close(t);
        } }), e = t("<span>").uniqueId().prependTo(this.uiDialogTitlebar), this._addClass(e, "ui-dialog-title"), this._title(e), this.uiDialogTitlebar.prependTo(this.uiDialog), this.uiDialog.attr({ "aria-labelledby": e.attr("id") });
    }, _title: function _title(t) {
      this.options.title ? t.text(this.options.title) : t.html("&#160;");
    }, _createButtonPane: function _createButtonPane() {
      this.uiDialogButtonPane = t("<div>"), this._addClass(this.uiDialogButtonPane, "ui-dialog-buttonpane", "ui-widget-content ui-helper-clearfix"), this.uiButtonSet = t("<div>").appendTo(this.uiDialogButtonPane), this._addClass(this.uiButtonSet, "ui-dialog-buttonset"), this._createButtons();
    }, _createButtons: function _createButtons() {
      var e = this,
          i = this.options.buttons;return this.uiDialogButtonPane.remove(), this.uiButtonSet.empty(), t.isEmptyObject(i) || t.isArray(i) && !i.length ? (this._removeClass(this.uiDialog, "ui-dialog-buttons"), void 0) : (t.each(i, function (i, s) {
        var n, o;s = t.isFunction(s) ? { click: s, text: i } : s, s = t.extend({ type: "button" }, s), n = s.click, o = { icon: s.icon, iconPosition: s.iconPosition, showLabel: s.showLabel, icons: s.icons, text: s.text }, delete s.click, delete s.icon, delete s.iconPosition, delete s.showLabel, delete s.icons, "boolean" == typeof s.text && delete s.text, t("<button></button>", s).button(o).appendTo(e.uiButtonSet).on("click", function () {
          n.apply(e.element[0], arguments);
        });
      }), this._addClass(this.uiDialog, "ui-dialog-buttons"), this.uiDialogButtonPane.appendTo(this.uiDialog), void 0);
    }, _makeDraggable: function _makeDraggable() {
      function e(t) {
        return { position: t.position, offset: t.offset };
      }var i = this,
          s = this.options;this.uiDialog.draggable({ cancel: ".ui-dialog-content, .ui-dialog-titlebar-close", handle: ".ui-dialog-titlebar", containment: "document", start: function start(s, n) {
          i._addClass(t(this), "ui-dialog-dragging"), i._blockFrames(), i._trigger("dragStart", s, e(n));
        }, drag: function drag(t, s) {
          i._trigger("drag", t, e(s));
        }, stop: function stop(n, o) {
          var a = o.offset.left - i.document.scrollLeft(),
              r = o.offset.top - i.document.scrollTop();s.position = { my: "left top", at: "left" + (a >= 0 ? "+" : "") + a + " " + "top" + (r >= 0 ? "+" : "") + r, of: i.window }, i._removeClass(t(this), "ui-dialog-dragging"), i._unblockFrames(), i._trigger("dragStop", n, e(o));
        } });
    }, _makeResizable: function _makeResizable() {
      function e(t) {
        return { originalPosition: t.originalPosition, originalSize: t.originalSize, position: t.position, size: t.size };
      }var i = this,
          s = this.options,
          n = s.resizable,
          o = this.uiDialog.css("position"),
          a = "string" == typeof n ? n : "n,e,s,w,se,sw,ne,nw";this.uiDialog.resizable({ cancel: ".ui-dialog-content", containment: "document", alsoResize: this.element, maxWidth: s.maxWidth, maxHeight: s.maxHeight, minWidth: s.minWidth, minHeight: this._minHeight(), handles: a, start: function start(s, n) {
          i._addClass(t(this), "ui-dialog-resizing"), i._blockFrames(), i._trigger("resizeStart", s, e(n));
        }, resize: function resize(t, s) {
          i._trigger("resize", t, e(s));
        }, stop: function stop(n, o) {
          var a = i.uiDialog.offset(),
              r = a.left - i.document.scrollLeft(),
              h = a.top - i.document.scrollTop();s.height = i.uiDialog.height(), s.width = i.uiDialog.width(), s.position = { my: "left top", at: "left" + (r >= 0 ? "+" : "") + r + " " + "top" + (h >= 0 ? "+" : "") + h, of: i.window }, i._removeClass(t(this), "ui-dialog-resizing"), i._unblockFrames(), i._trigger("resizeStop", n, e(o));
        } }).css("position", o);
    }, _trackFocus: function _trackFocus() {
      this._on(this.widget(), { focusin: function focusin(e) {
          this._makeFocusTarget(), this._focusedElement = t(e.target);
        } });
    }, _makeFocusTarget: function _makeFocusTarget() {
      this._untrackInstance(), this._trackingInstances().unshift(this);
    }, _untrackInstance: function _untrackInstance() {
      var e = this._trackingInstances(),
          i = t.inArray(this, e);-1 !== i && e.splice(i, 1);
    }, _trackingInstances: function _trackingInstances() {
      var t = this.document.data("ui-dialog-instances");return t || (t = [], this.document.data("ui-dialog-instances", t)), t;
    }, _minHeight: function _minHeight() {
      var t = this.options;return "auto" === t.height ? t.minHeight : Math.min(t.minHeight, t.height);
    }, _position: function _position() {
      var t = this.uiDialog.is(":visible");t || this.uiDialog.show(), this.uiDialog.position(this.options.position), t || this.uiDialog.hide();
    }, _setOptions: function _setOptions(e) {
      var i = this,
          s = !1,
          n = {};t.each(e, function (t, e) {
        i._setOption(t, e), t in i.sizeRelatedOptions && (s = !0), t in i.resizableRelatedOptions && (n[t] = e);
      }), s && (this._size(), this._position()), this.uiDialog.is(":data(ui-resizable)") && this.uiDialog.resizable("option", n);
    }, _setOption: function _setOption(e, i) {
      var s,
          n,
          o = this.uiDialog;"disabled" !== e && (this._super(e, i), "appendTo" === e && this.uiDialog.appendTo(this._appendTo()), "buttons" === e && this._createButtons(), "closeText" === e && this.uiDialogTitlebarClose.button({ label: t("<a>").text("" + this.options.closeText).html() }), "draggable" === e && (s = o.is(":data(ui-draggable)"), s && !i && o.draggable("destroy"), !s && i && this._makeDraggable()), "position" === e && this._position(), "resizable" === e && (n = o.is(":data(ui-resizable)"), n && !i && o.resizable("destroy"), n && "string" == typeof i && o.resizable("option", "handles", i), n || i === !1 || this._makeResizable()), "title" === e && this._title(this.uiDialogTitlebar.find(".ui-dialog-title")));
    }, _size: function _size() {
      var t,
          e,
          i,
          s = this.options;this.element.show().css({ width: "auto", minHeight: 0, maxHeight: "none", height: 0 }), s.minWidth > s.width && (s.width = s.minWidth), t = this.uiDialog.css({ height: "auto", width: s.width }).outerHeight(), e = Math.max(0, s.minHeight - t), i = "number" == typeof s.maxHeight ? Math.max(0, s.maxHeight - t) : "none", "auto" === s.height ? this.element.css({ minHeight: e, maxHeight: i, height: "auto" }) : this.element.height(Math.max(0, s.height - t)), this.uiDialog.is(":data(ui-resizable)") && this.uiDialog.resizable("option", "minHeight", this._minHeight());
    }, _blockFrames: function _blockFrames() {
      this.iframeBlocks = this.document.find("iframe").map(function () {
        var e = t(this);return t("<div>").css({ position: "absolute", width: e.outerWidth(), height: e.outerHeight() }).appendTo(e.parent()).offset(e.offset())[0];
      });
    }, _unblockFrames: function _unblockFrames() {
      this.iframeBlocks && (this.iframeBlocks.remove(), delete this.iframeBlocks);
    }, _allowInteraction: function _allowInteraction(e) {
      return t(e.target).closest(".ui-dialog").length ? !0 : !!t(e.target).closest(".ui-datepicker").length;
    }, _createOverlay: function _createOverlay() {
      if (this.options.modal) {
        var e = !0;this._delay(function () {
          e = !1;
        }), this.document.data("ui-dialog-overlays") || this._on(this.document, { focusin: function focusin(t) {
            e || this._allowInteraction(t) || (t.preventDefault(), this._trackingInstances()[0]._focusTabbable());
          } }), this.overlay = t("<div>").appendTo(this._appendTo()), this._addClass(this.overlay, null, "ui-widget-overlay ui-front"), this._on(this.overlay, { mousedown: "_keepFocus" }), this.document.data("ui-dialog-overlays", (this.document.data("ui-dialog-overlays") || 0) + 1);
      }
    }, _destroyOverlay: function _destroyOverlay() {
      if (this.options.modal && this.overlay) {
        var t = this.document.data("ui-dialog-overlays") - 1;t ? this.document.data("ui-dialog-overlays", t) : (this._off(this.document, "focusin"), this.document.removeData("ui-dialog-overlays")), this.overlay.remove(), this.overlay = null;
      }
    } }), t.uiBackCompat !== !1 && t.widget("ui.dialog", t.ui.dialog, { options: { dialogClass: "" }, _createWrapper: function _createWrapper() {
      this._super(), this.uiDialog.addClass(this.options.dialogClass);
    }, _setOption: function _setOption(t, e) {
      "dialogClass" === t && this.uiDialog.removeClass(this.options.dialogClass).addClass(e), this._superApply(arguments);
    } }), t.ui.dialog, t.widget("ui.droppable", { version: "1.12.1", widgetEventPrefix: "drop", options: { accept: "*", addClasses: !0, greedy: !1, scope: "default", tolerance: "intersect", activate: null, deactivate: null, drop: null, out: null, over: null }, _create: function _create() {
      var e,
          i = this.options,
          s = i.accept;this.isover = !1, this.isout = !0, this.accept = t.isFunction(s) ? s : function (t) {
        return t.is(s);
      }, this.proportions = function () {
        return arguments.length ? (e = arguments[0], void 0) : e ? e : e = { width: this.element[0].offsetWidth, height: this.element[0].offsetHeight };
      }, this._addToManager(i.scope), i.addClasses && this._addClass("ui-droppable");
    }, _addToManager: function _addToManager(e) {
      t.ui.ddmanager.droppables[e] = t.ui.ddmanager.droppables[e] || [], t.ui.ddmanager.droppables[e].push(this);
    }, _splice: function _splice(t) {
      for (var e = 0; t.length > e; e++) {
        t[e] === this && t.splice(e, 1);
      }
    }, _destroy: function _destroy() {
      var e = t.ui.ddmanager.droppables[this.options.scope];this._splice(e);
    }, _setOption: function _setOption(e, i) {
      if ("accept" === e) this.accept = t.isFunction(i) ? i : function (t) {
        return t.is(i);
      };else if ("scope" === e) {
        var s = t.ui.ddmanager.droppables[this.options.scope];this._splice(s), this._addToManager(i);
      }this._super(e, i);
    }, _activate: function _activate(e) {
      var i = t.ui.ddmanager.current;this._addActiveClass(), i && this._trigger("activate", e, this.ui(i));
    }, _deactivate: function _deactivate(e) {
      var i = t.ui.ddmanager.current;this._removeActiveClass(), i && this._trigger("deactivate", e, this.ui(i));
    }, _over: function _over(e) {
      var i = t.ui.ddmanager.current;i && (i.currentItem || i.element)[0] !== this.element[0] && this.accept.call(this.element[0], i.currentItem || i.element) && (this._addHoverClass(), this._trigger("over", e, this.ui(i)));
    }, _out: function _out(e) {
      var i = t.ui.ddmanager.current;i && (i.currentItem || i.element)[0] !== this.element[0] && this.accept.call(this.element[0], i.currentItem || i.element) && (this._removeHoverClass(), this._trigger("out", e, this.ui(i)));
    }, _drop: function _drop(e, i) {
      var s = i || t.ui.ddmanager.current,
          n = !1;return s && (s.currentItem || s.element)[0] !== this.element[0] ? (this.element.find(":data(ui-droppable)").not(".ui-draggable-dragging").each(function () {
        var i = t(this).droppable("instance");return i.options.greedy && !i.options.disabled && i.options.scope === s.options.scope && i.accept.call(i.element[0], s.currentItem || s.element) && v(s, t.extend(i, { offset: i.element.offset() }), i.options.tolerance, e) ? (n = !0, !1) : void 0;
      }), n ? !1 : this.accept.call(this.element[0], s.currentItem || s.element) ? (this._removeActiveClass(), this._removeHoverClass(), this._trigger("drop", e, this.ui(s)), this.element) : !1) : !1;
    }, ui: function ui(t) {
      return { draggable: t.currentItem || t.element, helper: t.helper, position: t.position, offset: t.positionAbs };
    }, _addHoverClass: function _addHoverClass() {
      this._addClass("ui-droppable-hover");
    }, _removeHoverClass: function _removeHoverClass() {
      this._removeClass("ui-droppable-hover");
    }, _addActiveClass: function _addActiveClass() {
      this._addClass("ui-droppable-active");
    }, _removeActiveClass: function _removeActiveClass() {
      this._removeClass("ui-droppable-active");
    } });var v = t.ui.intersect = function () {
    function t(t, e, i) {
      return t >= e && e + i > t;
    }return function (e, i, s, n) {
      if (!i.offset) return !1;var o = (e.positionAbs || e.position.absolute).left + e.margins.left,
          a = (e.positionAbs || e.position.absolute).top + e.margins.top,
          r = o + e.helperProportions.width,
          h = a + e.helperProportions.height,
          l = i.offset.left,
          c = i.offset.top,
          u = l + i.proportions().width,
          d = c + i.proportions().height;switch (s) {case "fit":
          return o >= l && u >= r && a >= c && d >= h;case "intersect":
          return o + e.helperProportions.width / 2 > l && u > r - e.helperProportions.width / 2 && a + e.helperProportions.height / 2 > c && d > h - e.helperProportions.height / 2;case "pointer":
          return t(n.pageY, c, i.proportions().height) && t(n.pageX, l, i.proportions().width);case "touch":
          return (a >= c && d >= a || h >= c && d >= h || c > a && h > d) && (o >= l && u >= o || r >= l && u >= r || l > o && r > u);default:
          return !1;}
    };
  }();t.ui.ddmanager = { current: null, droppables: { "default": [] }, prepareOffsets: function prepareOffsets(e, i) {
      var s,
          n,
          o = t.ui.ddmanager.droppables[e.options.scope] || [],
          a = i ? i.type : null,
          r = (e.currentItem || e.element).find(":data(ui-droppable)").addBack();t: for (s = 0; o.length > s; s++) {
        if (!(o[s].options.disabled || e && !o[s].accept.call(o[s].element[0], e.currentItem || e.element))) {
          for (n = 0; r.length > n; n++) {
            if (r[n] === o[s].element[0]) {
              o[s].proportions().height = 0;continue t;
            }
          }o[s].visible = "none" !== o[s].element.css("display"), o[s].visible && ("mousedown" === a && o[s]._activate.call(o[s], i), o[s].offset = o[s].element.offset(), o[s].proportions({ width: o[s].element[0].offsetWidth, height: o[s].element[0].offsetHeight }));
        }
      }
    }, drop: function drop(e, i) {
      var s = !1;return t.each((t.ui.ddmanager.droppables[e.options.scope] || []).slice(), function () {
        this.options && (!this.options.disabled && this.visible && v(e, this, this.options.tolerance, i) && (s = this._drop.call(this, i) || s), !this.options.disabled && this.visible && this.accept.call(this.element[0], e.currentItem || e.element) && (this.isout = !0, this.isover = !1, this._deactivate.call(this, i)));
      }), s;
    }, dragStart: function dragStart(e, i) {
      e.element.parentsUntil("body").on("scroll.droppable", function () {
        e.options.refreshPositions || t.ui.ddmanager.prepareOffsets(e, i);
      });
    }, drag: function drag(e, i) {
      e.options.refreshPositions && t.ui.ddmanager.prepareOffsets(e, i), t.each(t.ui.ddmanager.droppables[e.options.scope] || [], function () {
        if (!this.options.disabled && !this.greedyChild && this.visible) {
          var s,
              n,
              o,
              a = v(e, this, this.options.tolerance, i),
              r = !a && this.isover ? "isout" : a && !this.isover ? "isover" : null;r && (this.options.greedy && (n = this.options.scope, o = this.element.parents(":data(ui-droppable)").filter(function () {
            return t(this).droppable("instance").options.scope === n;
          }), o.length && (s = t(o[0]).droppable("instance"), s.greedyChild = "isover" === r)), s && "isover" === r && (s.isover = !1, s.isout = !0, s._out.call(s, i)), this[r] = !0, this["isout" === r ? "isover" : "isout"] = !1, this["isover" === r ? "_over" : "_out"].call(this, i), s && "isout" === r && (s.isout = !1, s.isover = !0, s._over.call(s, i)));
        }
      });
    }, dragStop: function dragStop(e, i) {
      e.element.parentsUntil("body").off("scroll.droppable"), e.options.refreshPositions || t.ui.ddmanager.prepareOffsets(e, i);
    } }, t.uiBackCompat !== !1 && t.widget("ui.droppable", t.ui.droppable, { options: { hoverClass: !1, activeClass: !1 }, _addActiveClass: function _addActiveClass() {
      this._super(), this.options.activeClass && this.element.addClass(this.options.activeClass);
    }, _removeActiveClass: function _removeActiveClass() {
      this._super(), this.options.activeClass && this.element.removeClass(this.options.activeClass);
    }, _addHoverClass: function _addHoverClass() {
      this._super(), this.options.hoverClass && this.element.addClass(this.options.hoverClass);
    }, _removeHoverClass: function _removeHoverClass() {
      this._super(), this.options.hoverClass && this.element.removeClass(this.options.hoverClass);
    } }), t.ui.droppable, t.widget("ui.progressbar", { version: "1.12.1", options: { classes: { "ui-progressbar": "ui-corner-all", "ui-progressbar-value": "ui-corner-left", "ui-progressbar-complete": "ui-corner-right" }, max: 100, value: 0, change: null, complete: null }, min: 0, _create: function _create() {
      this.oldValue = this.options.value = this._constrainedValue(), this.element.attr({ role: "progressbar", "aria-valuemin": this.min }), this._addClass("ui-progressbar", "ui-widget ui-widget-content"), this.valueDiv = t("<div>").appendTo(this.element), this._addClass(this.valueDiv, "ui-progressbar-value", "ui-widget-header"), this._refreshValue();
    }, _destroy: function _destroy() {
      this.element.removeAttr("role aria-valuemin aria-valuemax aria-valuenow"), this.valueDiv.remove();
    }, value: function value(t) {
      return void 0 === t ? this.options.value : (this.options.value = this._constrainedValue(t), this._refreshValue(), void 0);
    }, _constrainedValue: function _constrainedValue(t) {
      return void 0 === t && (t = this.options.value), this.indeterminate = t === !1, "number" != typeof t && (t = 0), this.indeterminate ? !1 : Math.min(this.options.max, Math.max(this.min, t));
    }, _setOptions: function _setOptions(t) {
      var e = t.value;delete t.value, this._super(t), this.options.value = this._constrainedValue(e), this._refreshValue();
    }, _setOption: function _setOption(t, e) {
      "max" === t && (e = Math.max(this.min, e)), this._super(t, e);
    }, _setOptionDisabled: function _setOptionDisabled(t) {
      this._super(t), this.element.attr("aria-disabled", t), this._toggleClass(null, "ui-state-disabled", !!t);
    }, _percentage: function _percentage() {
      return this.indeterminate ? 100 : 100 * (this.options.value - this.min) / (this.options.max - this.min);
    }, _refreshValue: function _refreshValue() {
      var e = this.options.value,
          i = this._percentage();this.valueDiv.toggle(this.indeterminate || e > this.min).width(i.toFixed(0) + "%"), this._toggleClass(this.valueDiv, "ui-progressbar-complete", null, e === this.options.max)._toggleClass("ui-progressbar-indeterminate", null, this.indeterminate), this.indeterminate ? (this.element.removeAttr("aria-valuenow"), this.overlayDiv || (this.overlayDiv = t("<div>").appendTo(this.valueDiv), this._addClass(this.overlayDiv, "ui-progressbar-overlay"))) : (this.element.attr({ "aria-valuemax": this.options.max, "aria-valuenow": e }), this.overlayDiv && (this.overlayDiv.remove(), this.overlayDiv = null)), this.oldValue !== e && (this.oldValue = e, this._trigger("change")), e === this.options.max && this._trigger("complete");
    } }), t.widget("ui.selectable", t.ui.mouse, { version: "1.12.1", options: { appendTo: "body", autoRefresh: !0, distance: 0, filter: "*", tolerance: "touch", selected: null, selecting: null, start: null, stop: null, unselected: null, unselecting: null }, _create: function _create() {
      var e = this;this._addClass("ui-selectable"), this.dragged = !1, this.refresh = function () {
        e.elementPos = t(e.element[0]).offset(), e.selectees = t(e.options.filter, e.element[0]), e._addClass(e.selectees, "ui-selectee"), e.selectees.each(function () {
          var i = t(this),
              s = i.offset(),
              n = { left: s.left - e.elementPos.left, top: s.top - e.elementPos.top };t.data(this, "selectable-item", { element: this, $element: i, left: n.left, top: n.top, right: n.left + i.outerWidth(), bottom: n.top + i.outerHeight(), startselected: !1, selected: i.hasClass("ui-selected"), selecting: i.hasClass("ui-selecting"), unselecting: i.hasClass("ui-unselecting") });
        });
      }, this.refresh(), this._mouseInit(), this.helper = t("<div>"), this._addClass(this.helper, "ui-selectable-helper");
    }, _destroy: function _destroy() {
      this.selectees.removeData("selectable-item"), this._mouseDestroy();
    }, _mouseStart: function _mouseStart(e) {
      var i = this,
          s = this.options;this.opos = [e.pageX, e.pageY], this.elementPos = t(this.element[0]).offset(), this.options.disabled || (this.selectees = t(s.filter, this.element[0]), this._trigger("start", e), t(s.appendTo).append(this.helper), this.helper.css({ left: e.pageX, top: e.pageY, width: 0, height: 0 }), s.autoRefresh && this.refresh(), this.selectees.filter(".ui-selected").each(function () {
        var s = t.data(this, "selectable-item");s.startselected = !0, e.metaKey || e.ctrlKey || (i._removeClass(s.$element, "ui-selected"), s.selected = !1, i._addClass(s.$element, "ui-unselecting"), s.unselecting = !0, i._trigger("unselecting", e, { unselecting: s.element }));
      }), t(e.target).parents().addBack().each(function () {
        var s,
            n = t.data(this, "selectable-item");return n ? (s = !e.metaKey && !e.ctrlKey || !n.$element.hasClass("ui-selected"), i._removeClass(n.$element, s ? "ui-unselecting" : "ui-selected")._addClass(n.$element, s ? "ui-selecting" : "ui-unselecting"), n.unselecting = !s, n.selecting = s, n.selected = s, s ? i._trigger("selecting", e, { selecting: n.element }) : i._trigger("unselecting", e, { unselecting: n.element }), !1) : void 0;
      }));
    }, _mouseDrag: function _mouseDrag(e) {
      if (this.dragged = !0, !this.options.disabled) {
        var i,
            s = this,
            n = this.options,
            o = this.opos[0],
            a = this.opos[1],
            r = e.pageX,
            h = e.pageY;return o > r && (i = r, r = o, o = i), a > h && (i = h, h = a, a = i), this.helper.css({ left: o, top: a, width: r - o, height: h - a }), this.selectees.each(function () {
          var i = t.data(this, "selectable-item"),
              l = !1,
              c = {};i && i.element !== s.element[0] && (c.left = i.left + s.elementPos.left, c.right = i.right + s.elementPos.left, c.top = i.top + s.elementPos.top, c.bottom = i.bottom + s.elementPos.top, "touch" === n.tolerance ? l = !(c.left > r || o > c.right || c.top > h || a > c.bottom) : "fit" === n.tolerance && (l = c.left > o && r > c.right && c.top > a && h > c.bottom), l ? (i.selected && (s._removeClass(i.$element, "ui-selected"), i.selected = !1), i.unselecting && (s._removeClass(i.$element, "ui-unselecting"), i.unselecting = !1), i.selecting || (s._addClass(i.$element, "ui-selecting"), i.selecting = !0, s._trigger("selecting", e, { selecting: i.element }))) : (i.selecting && ((e.metaKey || e.ctrlKey) && i.startselected ? (s._removeClass(i.$element, "ui-selecting"), i.selecting = !1, s._addClass(i.$element, "ui-selected"), i.selected = !0) : (s._removeClass(i.$element, "ui-selecting"), i.selecting = !1, i.startselected && (s._addClass(i.$element, "ui-unselecting"), i.unselecting = !0), s._trigger("unselecting", e, { unselecting: i.element }))), i.selected && (e.metaKey || e.ctrlKey || i.startselected || (s._removeClass(i.$element, "ui-selected"), i.selected = !1, s._addClass(i.$element, "ui-unselecting"), i.unselecting = !0, s._trigger("unselecting", e, { unselecting: i.element })))));
        }), !1;
      }
    }, _mouseStop: function _mouseStop(e) {
      var i = this;return this.dragged = !1, t(".ui-unselecting", this.element[0]).each(function () {
        var s = t.data(this, "selectable-item");i._removeClass(s.$element, "ui-unselecting"), s.unselecting = !1, s.startselected = !1, i._trigger("unselected", e, { unselected: s.element });
      }), t(".ui-selecting", this.element[0]).each(function () {
        var s = t.data(this, "selectable-item");i._removeClass(s.$element, "ui-selecting")._addClass(s.$element, "ui-selected"), s.selecting = !1, s.selected = !0, s.startselected = !0, i._trigger("selected", e, { selected: s.element });
      }), this._trigger("stop", e), this.helper.remove(), !1;
    } }), t.widget("ui.selectmenu", [t.ui.formResetMixin, { version: "1.12.1", defaultElement: "<select>", options: { appendTo: null, classes: { "ui-selectmenu-button-open": "ui-corner-top", "ui-selectmenu-button-closed": "ui-corner-all" }, disabled: null, icons: { button: "ui-icon-triangle-1-s" }, position: { my: "left top", at: "left bottom", collision: "none" }, width: !1, change: null, close: null, focus: null, open: null, select: null }, _create: function _create() {
      var e = this.element.uniqueId().attr("id");this.ids = { element: e, button: e + "-button", menu: e + "-menu" }, this._drawButton(), this._drawMenu(), this._bindFormResetHandler(), this._rendered = !1, this.menuItems = t();
    }, _drawButton: function _drawButton() {
      var e,
          i = this,
          s = this._parseOption(this.element.find("option:selected"), this.element[0].selectedIndex);this.labels = this.element.labels().attr("for", this.ids.button), this._on(this.labels, { click: function click(t) {
          this.button.focus(), t.preventDefault();
        } }), this.element.hide(), this.button = t("<span>", { tabindex: this.options.disabled ? -1 : 0, id: this.ids.button, role: "combobox", "aria-expanded": "false", "aria-autocomplete": "list", "aria-owns": this.ids.menu, "aria-haspopup": "true", title: this.element.attr("title") }).insertAfter(this.element), this._addClass(this.button, "ui-selectmenu-button ui-selectmenu-button-closed", "ui-button ui-widget"), e = t("<span>").appendTo(this.button), this._addClass(e, "ui-selectmenu-icon", "ui-icon " + this.options.icons.button), this.buttonItem = this._renderButtonItem(s).appendTo(this.button), this.options.width !== !1 && this._resizeButton(), this._on(this.button, this._buttonEvents), this.button.one("focusin", function () {
        i._rendered || i._refreshMenu();
      });
    }, _drawMenu: function _drawMenu() {
      var e = this;this.menu = t("<ul>", { "aria-hidden": "true", "aria-labelledby": this.ids.button, id: this.ids.menu }), this.menuWrap = t("<div>").append(this.menu), this._addClass(this.menuWrap, "ui-selectmenu-menu", "ui-front"), this.menuWrap.appendTo(this._appendTo()), this.menuInstance = this.menu.menu({ classes: { "ui-menu": "ui-corner-bottom" }, role: "listbox", select: function select(t, i) {
          t.preventDefault(), e._setSelection(), e._select(i.item.data("ui-selectmenu-item"), t);
        }, focus: function focus(t, i) {
          var s = i.item.data("ui-selectmenu-item");null != e.focusIndex && s.index !== e.focusIndex && (e._trigger("focus", t, { item: s }), e.isOpen || e._select(s, t)), e.focusIndex = s.index, e.button.attr("aria-activedescendant", e.menuItems.eq(s.index).attr("id"));
        } }).menu("instance"), this.menuInstance._off(this.menu, "mouseleave"), this.menuInstance._closeOnDocumentClick = function () {
        return !1;
      }, this.menuInstance._isDivider = function () {
        return !1;
      };
    }, refresh: function refresh() {
      this._refreshMenu(), this.buttonItem.replaceWith(this.buttonItem = this._renderButtonItem(this._getSelectedItem().data("ui-selectmenu-item") || {})), null === this.options.width && this._resizeButton();
    }, _refreshMenu: function _refreshMenu() {
      var t,
          e = this.element.find("option");this.menu.empty(), this._parseOptions(e), this._renderMenu(this.menu, this.items), this.menuInstance.refresh(), this.menuItems = this.menu.find("li").not(".ui-selectmenu-optgroup").find(".ui-menu-item-wrapper"), this._rendered = !0, e.length && (t = this._getSelectedItem(), this.menuInstance.focus(null, t), this._setAria(t.data("ui-selectmenu-item")), this._setOption("disabled", this.element.prop("disabled")));
    }, open: function open(t) {
      this.options.disabled || (this._rendered ? (this._removeClass(this.menu.find(".ui-state-active"), null, "ui-state-active"), this.menuInstance.focus(null, this._getSelectedItem())) : this._refreshMenu(), this.menuItems.length && (this.isOpen = !0, this._toggleAttr(), this._resizeMenu(), this._position(), this._on(this.document, this._documentClick), this._trigger("open", t)));
    }, _position: function _position() {
      this.menuWrap.position(t.extend({ of: this.button }, this.options.position));
    }, close: function close(t) {
      this.isOpen && (this.isOpen = !1, this._toggleAttr(), this.range = null, this._off(this.document), this._trigger("close", t));
    }, widget: function widget() {
      return this.button;
    }, menuWidget: function menuWidget() {
      return this.menu;
    }, _renderButtonItem: function _renderButtonItem(e) {
      var i = t("<span>");return this._setText(i, e.label), this._addClass(i, "ui-selectmenu-text"), i;
    }, _renderMenu: function _renderMenu(e, i) {
      var s = this,
          n = "";t.each(i, function (i, o) {
        var a;o.optgroup !== n && (a = t("<li>", { text: o.optgroup }), s._addClass(a, "ui-selectmenu-optgroup", "ui-menu-divider" + (o.element.parent("optgroup").prop("disabled") ? " ui-state-disabled" : "")), a.appendTo(e), n = o.optgroup), s._renderItemData(e, o);
      });
    }, _renderItemData: function _renderItemData(t, e) {
      return this._renderItem(t, e).data("ui-selectmenu-item", e);
    }, _renderItem: function _renderItem(e, i) {
      var s = t("<li>"),
          n = t("<div>", { title: i.element.attr("title") });return i.disabled && this._addClass(s, null, "ui-state-disabled"), this._setText(n, i.label), s.append(n).appendTo(e);
    }, _setText: function _setText(t, e) {
      e ? t.text(e) : t.html("&#160;");
    }, _move: function _move(t, e) {
      var i,
          s,
          n = ".ui-menu-item";this.isOpen ? i = this.menuItems.eq(this.focusIndex).parent("li") : (i = this.menuItems.eq(this.element[0].selectedIndex).parent("li"), n += ":not(.ui-state-disabled)"), s = "first" === t || "last" === t ? i["first" === t ? "prevAll" : "nextAll"](n).eq(-1) : i[t + "All"](n).eq(0), s.length && this.menuInstance.focus(e, s);
    }, _getSelectedItem: function _getSelectedItem() {
      return this.menuItems.eq(this.element[0].selectedIndex).parent("li");
    }, _toggle: function _toggle(t) {
      this[this.isOpen ? "close" : "open"](t);
    }, _setSelection: function _setSelection() {
      var t;this.range && (window.getSelection ? (t = window.getSelection(), t.removeAllRanges(), t.addRange(this.range)) : this.range.select(), this.button.focus());
    }, _documentClick: { mousedown: function mousedown(e) {
        this.isOpen && (t(e.target).closest(".ui-selectmenu-menu, #" + t.ui.escapeSelector(this.ids.button)).length || this.close(e));
      } }, _buttonEvents: { mousedown: function mousedown() {
        var t;window.getSelection ? (t = window.getSelection(), t.rangeCount && (this.range = t.getRangeAt(0))) : this.range = document.selection.createRange();
      }, click: function click(t) {
        this._setSelection(), this._toggle(t);
      }, keydown: function keydown(e) {
        var i = !0;switch (e.keyCode) {case t.ui.keyCode.TAB:case t.ui.keyCode.ESCAPE:
            this.close(e), i = !1;break;case t.ui.keyCode.ENTER:
            this.isOpen && this._selectFocusedItem(e);break;case t.ui.keyCode.UP:
            e.altKey ? this._toggle(e) : this._move("prev", e);break;case t.ui.keyCode.DOWN:
            e.altKey ? this._toggle(e) : this._move("next", e);break;case t.ui.keyCode.SPACE:
            this.isOpen ? this._selectFocusedItem(e) : this._toggle(e);break;case t.ui.keyCode.LEFT:
            this._move("prev", e);break;case t.ui.keyCode.RIGHT:
            this._move("next", e);break;case t.ui.keyCode.HOME:case t.ui.keyCode.PAGE_UP:
            this._move("first", e);break;case t.ui.keyCode.END:case t.ui.keyCode.PAGE_DOWN:
            this._move("last", e);break;default:
            this.menu.trigger(e), i = !1;}i && e.preventDefault();
      } }, _selectFocusedItem: function _selectFocusedItem(t) {
      var e = this.menuItems.eq(this.focusIndex).parent("li");e.hasClass("ui-state-disabled") || this._select(e.data("ui-selectmenu-item"), t);
    }, _select: function _select(t, e) {
      var i = this.element[0].selectedIndex;this.element[0].selectedIndex = t.index, this.buttonItem.replaceWith(this.buttonItem = this._renderButtonItem(t)), this._setAria(t), this._trigger("select", e, { item: t }), t.index !== i && this._trigger("change", e, { item: t }), this.close(e);
    }, _setAria: function _setAria(t) {
      var e = this.menuItems.eq(t.index).attr("id");this.button.attr({ "aria-labelledby": e, "aria-activedescendant": e }), this.menu.attr("aria-activedescendant", e);
    }, _setOption: function _setOption(t, e) {
      if ("icons" === t) {
        var i = this.button.find("span.ui-icon");this._removeClass(i, null, this.options.icons.button)._addClass(i, null, e.button);
      }this._super(t, e), "appendTo" === t && this.menuWrap.appendTo(this._appendTo()), "width" === t && this._resizeButton();
    }, _setOptionDisabled: function _setOptionDisabled(t) {
      this._super(t), this.menuInstance.option("disabled", t), this.button.attr("aria-disabled", t), this._toggleClass(this.button, null, "ui-state-disabled", t), this.element.prop("disabled", t), t ? (this.button.attr("tabindex", -1), this.close()) : this.button.attr("tabindex", 0);
    }, _appendTo: function _appendTo() {
      var e = this.options.appendTo;return e && (e = e.jquery || e.nodeType ? t(e) : this.document.find(e).eq(0)), e && e[0] || (e = this.element.closest(".ui-front, dialog")), e.length || (e = this.document[0].body), e;
    }, _toggleAttr: function _toggleAttr() {
      this.button.attr("aria-expanded", this.isOpen), this._removeClass(this.button, "ui-selectmenu-button-" + (this.isOpen ? "closed" : "open"))._addClass(this.button, "ui-selectmenu-button-" + (this.isOpen ? "open" : "closed"))._toggleClass(this.menuWrap, "ui-selectmenu-open", null, this.isOpen), this.menu.attr("aria-hidden", !this.isOpen);
    }, _resizeButton: function _resizeButton() {
      var t = this.options.width;return t === !1 ? (this.button.css("width", ""), void 0) : (null === t && (t = this.element.show().outerWidth(), this.element.hide()), this.button.outerWidth(t), void 0);
    }, _resizeMenu: function _resizeMenu() {
      this.menu.outerWidth(Math.max(this.button.outerWidth(), this.menu.width("").outerWidth() + 1));
    }, _getCreateOptions: function _getCreateOptions() {
      var t = this._super();return t.disabled = this.element.prop("disabled"), t;
    }, _parseOptions: function _parseOptions(e) {
      var i = this,
          s = [];e.each(function (e, n) {
        s.push(i._parseOption(t(n), e));
      }), this.items = s;
    }, _parseOption: function _parseOption(t, e) {
      var i = t.parent("optgroup");return { element: t, index: e, value: t.val(), label: t.text(), optgroup: i.attr("label") || "", disabled: i.prop("disabled") || t.prop("disabled") };
    }, _destroy: function _destroy() {
      this._unbindFormResetHandler(), this.menuWrap.remove(), this.button.remove(), this.element.show(), this.element.removeUniqueId(), this.labels.attr("for", this.ids.element);
    } }]), t.widget("ui.slider", t.ui.mouse, { version: "1.12.1", widgetEventPrefix: "slide", options: { animate: !1, classes: { "ui-slider": "ui-corner-all", "ui-slider-handle": "ui-corner-all", "ui-slider-range": "ui-corner-all ui-widget-header" }, distance: 0, max: 100, min: 0, orientation: "horizontal", range: !1, step: 1, value: 0, values: null, change: null, slide: null, start: null, stop: null }, numPages: 5, _create: function _create() {
      this._keySliding = !1, this._mouseSliding = !1, this._animateOff = !0, this._handleIndex = null, this._detectOrientation(), this._mouseInit(), this._calculateNewMax(), this._addClass("ui-slider ui-slider-" + this.orientation, "ui-widget ui-widget-content"), this._refresh(), this._animateOff = !1;
    }, _refresh: function _refresh() {
      this._createRange(), this._createHandles(), this._setupEvents(), this._refreshValue();
    }, _createHandles: function _createHandles() {
      var e,
          i,
          s = this.options,
          n = this.element.find(".ui-slider-handle"),
          o = "<span tabindex='0'></span>",
          a = [];for (i = s.values && s.values.length || 1, n.length > i && (n.slice(i).remove(), n = n.slice(0, i)), e = n.length; i > e; e++) {
        a.push(o);
      }this.handles = n.add(t(a.join("")).appendTo(this.element)), this._addClass(this.handles, "ui-slider-handle", "ui-state-default"), this.handle = this.handles.eq(0), this.handles.each(function (e) {
        t(this).data("ui-slider-handle-index", e).attr("tabIndex", 0);
      });
    }, _createRange: function _createRange() {
      var e = this.options;e.range ? (e.range === !0 && (e.values ? e.values.length && 2 !== e.values.length ? e.values = [e.values[0], e.values[0]] : t.isArray(e.values) && (e.values = e.values.slice(0)) : e.values = [this._valueMin(), this._valueMin()]), this.range && this.range.length ? (this._removeClass(this.range, "ui-slider-range-min ui-slider-range-max"), this.range.css({ left: "", bottom: "" })) : (this.range = t("<div>").appendTo(this.element), this._addClass(this.range, "ui-slider-range")), ("min" === e.range || "max" === e.range) && this._addClass(this.range, "ui-slider-range-" + e.range)) : (this.range && this.range.remove(), this.range = null);
    }, _setupEvents: function _setupEvents() {
      this._off(this.handles), this._on(this.handles, this._handleEvents), this._hoverable(this.handles), this._focusable(this.handles);
    }, _destroy: function _destroy() {
      this.handles.remove(), this.range && this.range.remove(), this._mouseDestroy();
    }, _mouseCapture: function _mouseCapture(e) {
      var i,
          s,
          n,
          o,
          a,
          r,
          h,
          l,
          c = this,
          u = this.options;return u.disabled ? !1 : (this.elementSize = { width: this.element.outerWidth(), height: this.element.outerHeight() }, this.elementOffset = this.element.offset(), i = { x: e.pageX, y: e.pageY }, s = this._normValueFromMouse(i), n = this._valueMax() - this._valueMin() + 1, this.handles.each(function (e) {
        var i = Math.abs(s - c.values(e));(n > i || n === i && (e === c._lastChangedValue || c.values(e) === u.min)) && (n = i, o = t(this), a = e);
      }), r = this._start(e, a), r === !1 ? !1 : (this._mouseSliding = !0, this._handleIndex = a, this._addClass(o, null, "ui-state-active"), o.trigger("focus"), h = o.offset(), l = !t(e.target).parents().addBack().is(".ui-slider-handle"), this._clickOffset = l ? { left: 0, top: 0 } : { left: e.pageX - h.left - o.width() / 2, top: e.pageY - h.top - o.height() / 2 - (parseInt(o.css("borderTopWidth"), 10) || 0) - (parseInt(o.css("borderBottomWidth"), 10) || 0) + (parseInt(o.css("marginTop"), 10) || 0) }, this.handles.hasClass("ui-state-hover") || this._slide(e, a, s), this._animateOff = !0, !0));
    }, _mouseStart: function _mouseStart() {
      return !0;
    }, _mouseDrag: function _mouseDrag(t) {
      var e = { x: t.pageX, y: t.pageY },
          i = this._normValueFromMouse(e);return this._slide(t, this._handleIndex, i), !1;
    }, _mouseStop: function _mouseStop(t) {
      return this._removeClass(this.handles, null, "ui-state-active"), this._mouseSliding = !1, this._stop(t, this._handleIndex), this._change(t, this._handleIndex), this._handleIndex = null, this._clickOffset = null, this._animateOff = !1, !1;
    }, _detectOrientation: function _detectOrientation() {
      this.orientation = "vertical" === this.options.orientation ? "vertical" : "horizontal";
    }, _normValueFromMouse: function _normValueFromMouse(t) {
      var e, i, s, n, o;return "horizontal" === this.orientation ? (e = this.elementSize.width, i = t.x - this.elementOffset.left - (this._clickOffset ? this._clickOffset.left : 0)) : (e = this.elementSize.height, i = t.y - this.elementOffset.top - (this._clickOffset ? this._clickOffset.top : 0)), s = i / e, s > 1 && (s = 1), 0 > s && (s = 0), "vertical" === this.orientation && (s = 1 - s), n = this._valueMax() - this._valueMin(), o = this._valueMin() + s * n, this._trimAlignValue(o);
    }, _uiHash: function _uiHash(t, e, i) {
      var s = { handle: this.handles[t], handleIndex: t, value: void 0 !== e ? e : this.value() };return this._hasMultipleValues() && (s.value = void 0 !== e ? e : this.values(t), s.values = i || this.values()), s;
    }, _hasMultipleValues: function _hasMultipleValues() {
      return this.options.values && this.options.values.length;
    }, _start: function _start(t, e) {
      return this._trigger("start", t, this._uiHash(e));
    }, _slide: function _slide(t, e, i) {
      var s,
          n,
          o = this.value(),
          a = this.values();this._hasMultipleValues() && (n = this.values(e ? 0 : 1), o = this.values(e), 2 === this.options.values.length && this.options.range === !0 && (i = 0 === e ? Math.min(n, i) : Math.max(n, i)), a[e] = i), i !== o && (s = this._trigger("slide", t, this._uiHash(e, i, a)), s !== !1 && (this._hasMultipleValues() ? this.values(e, i) : this.value(i)));
    }, _stop: function _stop(t, e) {
      this._trigger("stop", t, this._uiHash(e));
    }, _change: function _change(t, e) {
      this._keySliding || this._mouseSliding || (this._lastChangedValue = e, this._trigger("change", t, this._uiHash(e)));
    }, value: function value(t) {
      return arguments.length ? (this.options.value = this._trimAlignValue(t), this._refreshValue(), this._change(null, 0), void 0) : this._value();
    }, values: function values(e, i) {
      var s, n, o;if (arguments.length > 1) return this.options.values[e] = this._trimAlignValue(i), this._refreshValue(), this._change(null, e), void 0;if (!arguments.length) return this._values();if (!t.isArray(arguments[0])) return this._hasMultipleValues() ? this._values(e) : this.value();for (s = this.options.values, n = arguments[0], o = 0; s.length > o; o += 1) {
        s[o] = this._trimAlignValue(n[o]), this._change(null, o);
      }this._refreshValue();
    }, _setOption: function _setOption(e, i) {
      var s,
          n = 0;switch ("range" === e && this.options.range === !0 && ("min" === i ? (this.options.value = this._values(0), this.options.values = null) : "max" === i && (this.options.value = this._values(this.options.values.length - 1), this.options.values = null)), t.isArray(this.options.values) && (n = this.options.values.length), this._super(e, i), e) {case "orientation":
          this._detectOrientation(), this._removeClass("ui-slider-horizontal ui-slider-vertical")._addClass("ui-slider-" + this.orientation), this._refreshValue(), this.options.range && this._refreshRange(i), this.handles.css("horizontal" === i ? "bottom" : "left", "");break;case "value":
          this._animateOff = !0, this._refreshValue(), this._change(null, 0), this._animateOff = !1;break;case "values":
          for (this._animateOff = !0, this._refreshValue(), s = n - 1; s >= 0; s--) {
            this._change(null, s);
          }this._animateOff = !1;break;case "step":case "min":case "max":
          this._animateOff = !0, this._calculateNewMax(), this._refreshValue(), this._animateOff = !1;break;case "range":
          this._animateOff = !0, this._refresh(), this._animateOff = !1;}
    }, _setOptionDisabled: function _setOptionDisabled(t) {
      this._super(t), this._toggleClass(null, "ui-state-disabled", !!t);
    }, _value: function _value() {
      var t = this.options.value;return t = this._trimAlignValue(t);
    }, _values: function _values(t) {
      var e, i, s;if (arguments.length) return e = this.options.values[t], e = this._trimAlignValue(e);if (this._hasMultipleValues()) {
        for (i = this.options.values.slice(), s = 0; i.length > s; s += 1) {
          i[s] = this._trimAlignValue(i[s]);
        }return i;
      }return [];
    }, _trimAlignValue: function _trimAlignValue(t) {
      if (this._valueMin() >= t) return this._valueMin();if (t >= this._valueMax()) return this._valueMax();var e = this.options.step > 0 ? this.options.step : 1,
          i = (t - this._valueMin()) % e,
          s = t - i;return 2 * Math.abs(i) >= e && (s += i > 0 ? e : -e), parseFloat(s.toFixed(5));
    }, _calculateNewMax: function _calculateNewMax() {
      var t = this.options.max,
          e = this._valueMin(),
          i = this.options.step,
          s = Math.round((t - e) / i) * i;t = s + e, t > this.options.max && (t -= i), this.max = parseFloat(t.toFixed(this._precision()));
    }, _precision: function _precision() {
      var t = this._precisionOf(this.options.step);return null !== this.options.min && (t = Math.max(t, this._precisionOf(this.options.min))), t;
    }, _precisionOf: function _precisionOf(t) {
      var e = "" + t,
          i = e.indexOf(".");return -1 === i ? 0 : e.length - i - 1;
    }, _valueMin: function _valueMin() {
      return this.options.min;
    }, _valueMax: function _valueMax() {
      return this.max;
    }, _refreshRange: function _refreshRange(t) {
      "vertical" === t && this.range.css({ width: "", left: "" }), "horizontal" === t && this.range.css({ height: "", bottom: "" });
    }, _refreshValue: function _refreshValue() {
      var e,
          i,
          s,
          n,
          o,
          a = this.options.range,
          r = this.options,
          h = this,
          l = this._animateOff ? !1 : r.animate,
          c = {};this._hasMultipleValues() ? this.handles.each(function (s) {
        i = 100 * ((h.values(s) - h._valueMin()) / (h._valueMax() - h._valueMin())), c["horizontal" === h.orientation ? "left" : "bottom"] = i + "%", t(this).stop(1, 1)[l ? "animate" : "css"](c, r.animate), h.options.range === !0 && ("horizontal" === h.orientation ? (0 === s && h.range.stop(1, 1)[l ? "animate" : "css"]({ left: i + "%" }, r.animate), 1 === s && h.range[l ? "animate" : "css"]({ width: i - e + "%" }, { queue: !1, duration: r.animate })) : (0 === s && h.range.stop(1, 1)[l ? "animate" : "css"]({ bottom: i + "%" }, r.animate), 1 === s && h.range[l ? "animate" : "css"]({ height: i - e + "%" }, { queue: !1, duration: r.animate }))), e = i;
      }) : (s = this.value(), n = this._valueMin(), o = this._valueMax(), i = o !== n ? 100 * ((s - n) / (o - n)) : 0, c["horizontal" === this.orientation ? "left" : "bottom"] = i + "%", this.handle.stop(1, 1)[l ? "animate" : "css"](c, r.animate), "min" === a && "horizontal" === this.orientation && this.range.stop(1, 1)[l ? "animate" : "css"]({ width: i + "%" }, r.animate), "max" === a && "horizontal" === this.orientation && this.range.stop(1, 1)[l ? "animate" : "css"]({ width: 100 - i + "%" }, r.animate), "min" === a && "vertical" === this.orientation && this.range.stop(1, 1)[l ? "animate" : "css"]({ height: i + "%" }, r.animate), "max" === a && "vertical" === this.orientation && this.range.stop(1, 1)[l ? "animate" : "css"]({ height: 100 - i + "%" }, r.animate));
    }, _handleEvents: { keydown: function keydown(e) {
        var i,
            s,
            n,
            o,
            a = t(e.target).data("ui-slider-handle-index");switch (e.keyCode) {case t.ui.keyCode.HOME:case t.ui.keyCode.END:case t.ui.keyCode.PAGE_UP:case t.ui.keyCode.PAGE_DOWN:case t.ui.keyCode.UP:case t.ui.keyCode.RIGHT:case t.ui.keyCode.DOWN:case t.ui.keyCode.LEFT:
            if (e.preventDefault(), !this._keySliding && (this._keySliding = !0, this._addClass(t(e.target), null, "ui-state-active"), i = this._start(e, a), i === !1)) return;}switch (o = this.options.step, s = n = this._hasMultipleValues() ? this.values(a) : this.value(), e.keyCode) {case t.ui.keyCode.HOME:
            n = this._valueMin();break;case t.ui.keyCode.END:
            n = this._valueMax();break;case t.ui.keyCode.PAGE_UP:
            n = this._trimAlignValue(s + (this._valueMax() - this._valueMin()) / this.numPages);break;case t.ui.keyCode.PAGE_DOWN:
            n = this._trimAlignValue(s - (this._valueMax() - this._valueMin()) / this.numPages);break;case t.ui.keyCode.UP:case t.ui.keyCode.RIGHT:
            if (s === this._valueMax()) return;n = this._trimAlignValue(s + o);break;case t.ui.keyCode.DOWN:case t.ui.keyCode.LEFT:
            if (s === this._valueMin()) return;n = this._trimAlignValue(s - o);}this._slide(e, a, n);
      }, keyup: function keyup(e) {
        var i = t(e.target).data("ui-slider-handle-index");this._keySliding && (this._keySliding = !1, this._stop(e, i), this._change(e, i), this._removeClass(t(e.target), null, "ui-state-active"));
      } } }), t.widget("ui.sortable", t.ui.mouse, { version: "1.12.1", widgetEventPrefix: "sort", ready: !1, options: { appendTo: "parent", axis: !1, connectWith: !1, containment: !1, cursor: "auto", cursorAt: !1, dropOnEmpty: !0, forcePlaceholderSize: !1, forceHelperSize: !1, grid: !1, handle: !1, helper: "original", items: "> *", opacity: !1, placeholder: !1, revert: !1, scroll: !0, scrollSensitivity: 20, scrollSpeed: 20, scope: "default", tolerance: "intersect", zIndex: 1e3, activate: null, beforeStop: null, change: null, deactivate: null, out: null, over: null, receive: null, remove: null, sort: null, start: null, stop: null, update: null }, _isOverAxis: function _isOverAxis(t, e, i) {
      return t >= e && e + i > t;
    }, _isFloating: function _isFloating(t) {
      return (/left|right/.test(t.css("float")) || /inline|table-cell/.test(t.css("display"))
      );
    }, _create: function _create() {
      this.containerCache = {}, this._addClass("ui-sortable"), this.refresh(), this.offset = this.element.offset(), this._mouseInit(), this._setHandleClassName(), this.ready = !0;
    }, _setOption: function _setOption(t, e) {
      this._super(t, e), "handle" === t && this._setHandleClassName();
    }, _setHandleClassName: function _setHandleClassName() {
      var e = this;this._removeClass(this.element.find(".ui-sortable-handle"), "ui-sortable-handle"), t.each(this.items, function () {
        e._addClass(this.instance.options.handle ? this.item.find(this.instance.options.handle) : this.item, "ui-sortable-handle");
      });
    }, _destroy: function _destroy() {
      this._mouseDestroy();for (var t = this.items.length - 1; t >= 0; t--) {
        this.items[t].item.removeData(this.widgetName + "-item");
      }return this;
    }, _mouseCapture: function _mouseCapture(e, i) {
      var s = null,
          n = !1,
          o = this;return this.reverting ? !1 : this.options.disabled || "static" === this.options.type ? !1 : (this._refreshItems(e), t(e.target).parents().each(function () {
        return t.data(this, o.widgetName + "-item") === o ? (s = t(this), !1) : void 0;
      }), t.data(e.target, o.widgetName + "-item") === o && (s = t(e.target)), s ? !this.options.handle || i || (t(this.options.handle, s).find("*").addBack().each(function () {
        this === e.target && (n = !0);
      }), n) ? (this.currentItem = s, this._removeCurrentsFromItems(), !0) : !1 : !1);
    }, _mouseStart: function _mouseStart(e, i, s) {
      var n,
          o,
          a = this.options;if (this.currentContainer = this, this.refreshPositions(), this.helper = this._createHelper(e), this._cacheHelperProportions(), this._cacheMargins(), this.scrollParent = this.helper.scrollParent(), this.offset = this.currentItem.offset(), this.offset = { top: this.offset.top - this.margins.top, left: this.offset.left - this.margins.left }, t.extend(this.offset, { click: { left: e.pageX - this.offset.left, top: e.pageY - this.offset.top }, parent: this._getParentOffset(), relative: this._getRelativeOffset() }), this.helper.css("position", "absolute"), this.cssPosition = this.helper.css("position"), this.originalPosition = this._generatePosition(e), this.originalPageX = e.pageX, this.originalPageY = e.pageY, a.cursorAt && this._adjustOffsetFromHelper(a.cursorAt), this.domPosition = { prev: this.currentItem.prev()[0], parent: this.currentItem.parent()[0] }, this.helper[0] !== this.currentItem[0] && this.currentItem.hide(), this._createPlaceholder(), a.containment && this._setContainment(), a.cursor && "auto" !== a.cursor && (o = this.document.find("body"), this.storedCursor = o.css("cursor"), o.css("cursor", a.cursor), this.storedStylesheet = t("<style>*{ cursor: " + a.cursor + " !important; }</style>").appendTo(o)), a.opacity && (this.helper.css("opacity") && (this._storedOpacity = this.helper.css("opacity")), this.helper.css("opacity", a.opacity)), a.zIndex && (this.helper.css("zIndex") && (this._storedZIndex = this.helper.css("zIndex")), this.helper.css("zIndex", a.zIndex)), this.scrollParent[0] !== this.document[0] && "HTML" !== this.scrollParent[0].tagName && (this.overflowOffset = this.scrollParent.offset()), this._trigger("start", e, this._uiHash()), this._preserveHelperProportions || this._cacheHelperProportions(), !s) for (n = this.containers.length - 1; n >= 0; n--) {
        this.containers[n]._trigger("activate", e, this._uiHash(this));
      }return t.ui.ddmanager && (t.ui.ddmanager.current = this), t.ui.ddmanager && !a.dropBehaviour && t.ui.ddmanager.prepareOffsets(this, e), this.dragging = !0, this._addClass(this.helper, "ui-sortable-helper"), this._mouseDrag(e), !0;
    }, _mouseDrag: function _mouseDrag(e) {
      var i,
          s,
          n,
          o,
          a = this.options,
          r = !1;for (this.position = this._generatePosition(e), this.positionAbs = this._convertPositionTo("absolute"), this.lastPositionAbs || (this.lastPositionAbs = this.positionAbs), this.options.scroll && (this.scrollParent[0] !== this.document[0] && "HTML" !== this.scrollParent[0].tagName ? (this.overflowOffset.top + this.scrollParent[0].offsetHeight - e.pageY < a.scrollSensitivity ? this.scrollParent[0].scrollTop = r = this.scrollParent[0].scrollTop + a.scrollSpeed : e.pageY - this.overflowOffset.top < a.scrollSensitivity && (this.scrollParent[0].scrollTop = r = this.scrollParent[0].scrollTop - a.scrollSpeed), this.overflowOffset.left + this.scrollParent[0].offsetWidth - e.pageX < a.scrollSensitivity ? this.scrollParent[0].scrollLeft = r = this.scrollParent[0].scrollLeft + a.scrollSpeed : e.pageX - this.overflowOffset.left < a.scrollSensitivity && (this.scrollParent[0].scrollLeft = r = this.scrollParent[0].scrollLeft - a.scrollSpeed)) : (e.pageY - this.document.scrollTop() < a.scrollSensitivity ? r = this.document.scrollTop(this.document.scrollTop() - a.scrollSpeed) : this.window.height() - (e.pageY - this.document.scrollTop()) < a.scrollSensitivity && (r = this.document.scrollTop(this.document.scrollTop() + a.scrollSpeed)), e.pageX - this.document.scrollLeft() < a.scrollSensitivity ? r = this.document.scrollLeft(this.document.scrollLeft() - a.scrollSpeed) : this.window.width() - (e.pageX - this.document.scrollLeft()) < a.scrollSensitivity && (r = this.document.scrollLeft(this.document.scrollLeft() + a.scrollSpeed))), r !== !1 && t.ui.ddmanager && !a.dropBehaviour && t.ui.ddmanager.prepareOffsets(this, e)), this.positionAbs = this._convertPositionTo("absolute"), this.options.axis && "y" === this.options.axis || (this.helper[0].style.left = this.position.left + "px"), this.options.axis && "x" === this.options.axis || (this.helper[0].style.top = this.position.top + "px"), i = this.items.length - 1; i >= 0; i--) {
        if (s = this.items[i], n = s.item[0], o = this._intersectsWithPointer(s), o && s.instance === this.currentContainer && n !== this.currentItem[0] && this.placeholder[1 === o ? "next" : "prev"]()[0] !== n && !t.contains(this.placeholder[0], n) && ("semi-dynamic" === this.options.type ? !t.contains(this.element[0], n) : !0)) {
          if (this.direction = 1 === o ? "down" : "up", "pointer" !== this.options.tolerance && !this._intersectsWithSides(s)) break;this._rearrange(e, s), this._trigger("change", e, this._uiHash());break;
        }
      }return this._contactContainers(e), t.ui.ddmanager && t.ui.ddmanager.drag(this, e), this._trigger("sort", e, this._uiHash()), this.lastPositionAbs = this.positionAbs, !1;
    }, _mouseStop: function _mouseStop(e, i) {
      if (e) {
        if (t.ui.ddmanager && !this.options.dropBehaviour && t.ui.ddmanager.drop(this, e), this.options.revert) {
          var s = this,
              n = this.placeholder.offset(),
              o = this.options.axis,
              a = {};o && "x" !== o || (a.left = n.left - this.offset.parent.left - this.margins.left + (this.offsetParent[0] === this.document[0].body ? 0 : this.offsetParent[0].scrollLeft)), o && "y" !== o || (a.top = n.top - this.offset.parent.top - this.margins.top + (this.offsetParent[0] === this.document[0].body ? 0 : this.offsetParent[0].scrollTop)), this.reverting = !0, t(this.helper).animate(a, parseInt(this.options.revert, 10) || 500, function () {
            s._clear(e);
          });
        } else this._clear(e, i);return !1;
      }
    }, cancel: function cancel() {
      if (this.dragging) {
        this._mouseUp(new t.Event("mouseup", { target: null })), "original" === this.options.helper ? (this.currentItem.css(this._storedCSS), this._removeClass(this.currentItem, "ui-sortable-helper")) : this.currentItem.show();for (var e = this.containers.length - 1; e >= 0; e--) {
          this.containers[e]._trigger("deactivate", null, this._uiHash(this)), this.containers[e].containerCache.over && (this.containers[e]._trigger("out", null, this._uiHash(this)), this.containers[e].containerCache.over = 0);
        }
      }return this.placeholder && (this.placeholder[0].parentNode && this.placeholder[0].parentNode.removeChild(this.placeholder[0]), "original" !== this.options.helper && this.helper && this.helper[0].parentNode && this.helper.remove(), t.extend(this, { helper: null, dragging: !1, reverting: !1, _noFinalSort: null }), this.domPosition.prev ? t(this.domPosition.prev).after(this.currentItem) : t(this.domPosition.parent).prepend(this.currentItem)), this;
    }, serialize: function serialize(e) {
      var i = this._getItemsAsjQuery(e && e.connected),
          s = [];return e = e || {}, t(i).each(function () {
        var i = (t(e.item || this).attr(e.attribute || "id") || "").match(e.expression || /(.+)[\-=_](.+)/);i && s.push((e.key || i[1] + "[]") + "=" + (e.key && e.expression ? i[1] : i[2]));
      }), !s.length && e.key && s.push(e.key + "="), s.join("&");
    }, toArray: function toArray(e) {
      var i = this._getItemsAsjQuery(e && e.connected),
          s = [];return e = e || {}, i.each(function () {
        s.push(t(e.item || this).attr(e.attribute || "id") || "");
      }), s;
    }, _intersectsWith: function _intersectsWith(t) {
      var e = this.positionAbs.left,
          i = e + this.helperProportions.width,
          s = this.positionAbs.top,
          n = s + this.helperProportions.height,
          o = t.left,
          a = o + t.width,
          r = t.top,
          h = r + t.height,
          l = this.offset.click.top,
          c = this.offset.click.left,
          u = "x" === this.options.axis || s + l > r && h > s + l,
          d = "y" === this.options.axis || e + c > o && a > e + c,
          p = u && d;return "pointer" === this.options.tolerance || this.options.forcePointerForContainers || "pointer" !== this.options.tolerance && this.helperProportions[this.floating ? "width" : "height"] > t[this.floating ? "width" : "height"] ? p : e + this.helperProportions.width / 2 > o && a > i - this.helperProportions.width / 2 && s + this.helperProportions.height / 2 > r && h > n - this.helperProportions.height / 2;
    }, _intersectsWithPointer: function _intersectsWithPointer(t) {
      var e,
          i,
          s = "x" === this.options.axis || this._isOverAxis(this.positionAbs.top + this.offset.click.top, t.top, t.height),
          n = "y" === this.options.axis || this._isOverAxis(this.positionAbs.left + this.offset.click.left, t.left, t.width),
          o = s && n;return o ? (e = this._getDragVerticalDirection(), i = this._getDragHorizontalDirection(), this.floating ? "right" === i || "down" === e ? 2 : 1 : e && ("down" === e ? 2 : 1)) : !1;
    }, _intersectsWithSides: function _intersectsWithSides(t) {
      var e = this._isOverAxis(this.positionAbs.top + this.offset.click.top, t.top + t.height / 2, t.height),
          i = this._isOverAxis(this.positionAbs.left + this.offset.click.left, t.left + t.width / 2, t.width),
          s = this._getDragVerticalDirection(),
          n = this._getDragHorizontalDirection();return this.floating && n ? "right" === n && i || "left" === n && !i : s && ("down" === s && e || "up" === s && !e);
    }, _getDragVerticalDirection: function _getDragVerticalDirection() {
      var t = this.positionAbs.top - this.lastPositionAbs.top;return 0 !== t && (t > 0 ? "down" : "up");
    }, _getDragHorizontalDirection: function _getDragHorizontalDirection() {
      var t = this.positionAbs.left - this.lastPositionAbs.left;return 0 !== t && (t > 0 ? "right" : "left");
    }, refresh: function refresh(t) {
      return this._refreshItems(t), this._setHandleClassName(), this.refreshPositions(), this;
    }, _connectWith: function _connectWith() {
      var t = this.options;return t.connectWith.constructor === String ? [t.connectWith] : t.connectWith;
    }, _getItemsAsjQuery: function _getItemsAsjQuery(e) {
      function i() {
        r.push(this);
      }var s,
          n,
          o,
          a,
          r = [],
          h = [],
          l = this._connectWith();if (l && e) for (s = l.length - 1; s >= 0; s--) {
        for (o = t(l[s], this.document[0]), n = o.length - 1; n >= 0; n--) {
          a = t.data(o[n], this.widgetFullName), a && a !== this && !a.options.disabled && h.push([t.isFunction(a.options.items) ? a.options.items.call(a.element) : t(a.options.items, a.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"), a]);
        }
      }for (h.push([t.isFunction(this.options.items) ? this.options.items.call(this.element, null, { options: this.options, item: this.currentItem }) : t(this.options.items, this.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"), this]), s = h.length - 1; s >= 0; s--) {
        h[s][0].each(i);
      }return t(r);
    }, _removeCurrentsFromItems: function _removeCurrentsFromItems() {
      var e = this.currentItem.find(":data(" + this.widgetName + "-item)");this.items = t.grep(this.items, function (t) {
        for (var i = 0; e.length > i; i++) {
          if (e[i] === t.item[0]) return !1;
        }return !0;
      });
    }, _refreshItems: function _refreshItems(e) {
      this.items = [], this.containers = [this];var i,
          s,
          n,
          o,
          a,
          r,
          h,
          l,
          c = this.items,
          u = [[t.isFunction(this.options.items) ? this.options.items.call(this.element[0], e, { item: this.currentItem }) : t(this.options.items, this.element), this]],
          d = this._connectWith();if (d && this.ready) for (i = d.length - 1; i >= 0; i--) {
        for (n = t(d[i], this.document[0]), s = n.length - 1; s >= 0; s--) {
          o = t.data(n[s], this.widgetFullName), o && o !== this && !o.options.disabled && (u.push([t.isFunction(o.options.items) ? o.options.items.call(o.element[0], e, { item: this.currentItem }) : t(o.options.items, o.element), o]), this.containers.push(o));
        }
      }for (i = u.length - 1; i >= 0; i--) {
        for (a = u[i][1], r = u[i][0], s = 0, l = r.length; l > s; s++) {
          h = t(r[s]), h.data(this.widgetName + "-item", a), c.push({ item: h, instance: a, width: 0, height: 0, left: 0, top: 0 });
        }
      }
    }, refreshPositions: function refreshPositions(e) {
      this.floating = this.items.length ? "x" === this.options.axis || this._isFloating(this.items[0].item) : !1, this.offsetParent && this.helper && (this.offset.parent = this._getParentOffset());var i, s, n, o;for (i = this.items.length - 1; i >= 0; i--) {
        s = this.items[i], s.instance !== this.currentContainer && this.currentContainer && s.item[0] !== this.currentItem[0] || (n = this.options.toleranceElement ? t(this.options.toleranceElement, s.item) : s.item, e || (s.width = n.outerWidth(), s.height = n.outerHeight()), o = n.offset(), s.left = o.left, s.top = o.top);
      }if (this.options.custom && this.options.custom.refreshContainers) this.options.custom.refreshContainers.call(this);else for (i = this.containers.length - 1; i >= 0; i--) {
        o = this.containers[i].element.offset(), this.containers[i].containerCache.left = o.left, this.containers[i].containerCache.top = o.top, this.containers[i].containerCache.width = this.containers[i].element.outerWidth(), this.containers[i].containerCache.height = this.containers[i].element.outerHeight();
      }return this;
    }, _createPlaceholder: function _createPlaceholder(e) {
      e = e || this;var i,
          s = e.options;s.placeholder && s.placeholder.constructor !== String || (i = s.placeholder, s.placeholder = { element: function element() {
          var s = e.currentItem[0].nodeName.toLowerCase(),
              n = t("<" + s + ">", e.document[0]);return e._addClass(n, "ui-sortable-placeholder", i || e.currentItem[0].className)._removeClass(n, "ui-sortable-helper"), "tbody" === s ? e._createTrPlaceholder(e.currentItem.find("tr").eq(0), t("<tr>", e.document[0]).appendTo(n)) : "tr" === s ? e._createTrPlaceholder(e.currentItem, n) : "img" === s && n.attr("src", e.currentItem.attr("src")), i || n.css("visibility", "hidden"), n;
        }, update: function update(t, n) {
          (!i || s.forcePlaceholderSize) && (n.height() || n.height(e.currentItem.innerHeight() - parseInt(e.currentItem.css("paddingTop") || 0, 10) - parseInt(e.currentItem.css("paddingBottom") || 0, 10)), n.width() || n.width(e.currentItem.innerWidth() - parseInt(e.currentItem.css("paddingLeft") || 0, 10) - parseInt(e.currentItem.css("paddingRight") || 0, 10)));
        } }), e.placeholder = t(s.placeholder.element.call(e.element, e.currentItem)), e.currentItem.after(e.placeholder), s.placeholder.update(e, e.placeholder);
    }, _createTrPlaceholder: function _createTrPlaceholder(e, i) {
      var s = this;e.children().each(function () {
        t("<td>&#160;</td>", s.document[0]).attr("colspan", t(this).attr("colspan") || 1).appendTo(i);
      });
    }, _contactContainers: function _contactContainers(e) {
      var i,
          s,
          n,
          o,
          a,
          r,
          h,
          l,
          c,
          u,
          d = null,
          p = null;for (i = this.containers.length - 1; i >= 0; i--) {
        if (!t.contains(this.currentItem[0], this.containers[i].element[0])) if (this._intersectsWith(this.containers[i].containerCache)) {
          if (d && t.contains(this.containers[i].element[0], d.element[0])) continue;d = this.containers[i], p = i;
        } else this.containers[i].containerCache.over && (this.containers[i]._trigger("out", e, this._uiHash(this)), this.containers[i].containerCache.over = 0);
      }if (d) if (1 === this.containers.length) this.containers[p].containerCache.over || (this.containers[p]._trigger("over", e, this._uiHash(this)), this.containers[p].containerCache.over = 1);else {
        for (n = 1e4, o = null, c = d.floating || this._isFloating(this.currentItem), a = c ? "left" : "top", r = c ? "width" : "height", u = c ? "pageX" : "pageY", s = this.items.length - 1; s >= 0; s--) {
          t.contains(this.containers[p].element[0], this.items[s].item[0]) && this.items[s].item[0] !== this.currentItem[0] && (h = this.items[s].item.offset()[a], l = !1, e[u] - h > this.items[s][r] / 2 && (l = !0), n > Math.abs(e[u] - h) && (n = Math.abs(e[u] - h), o = this.items[s], this.direction = l ? "up" : "down"));
        }if (!o && !this.options.dropOnEmpty) return;if (this.currentContainer === this.containers[p]) return this.currentContainer.containerCache.over || (this.containers[p]._trigger("over", e, this._uiHash()), this.currentContainer.containerCache.over = 1), void 0;o ? this._rearrange(e, o, null, !0) : this._rearrange(e, null, this.containers[p].element, !0), this._trigger("change", e, this._uiHash()), this.containers[p]._trigger("change", e, this._uiHash(this)), this.currentContainer = this.containers[p], this.options.placeholder.update(this.currentContainer, this.placeholder), this.containers[p]._trigger("over", e, this._uiHash(this)), this.containers[p].containerCache.over = 1;
      }
    }, _createHelper: function _createHelper(e) {
      var i = this.options,
          s = t.isFunction(i.helper) ? t(i.helper.apply(this.element[0], [e, this.currentItem])) : "clone" === i.helper ? this.currentItem.clone() : this.currentItem;return s.parents("body").length || t("parent" !== i.appendTo ? i.appendTo : this.currentItem[0].parentNode)[0].appendChild(s[0]), s[0] === this.currentItem[0] && (this._storedCSS = { width: this.currentItem[0].style.width, height: this.currentItem[0].style.height, position: this.currentItem.css("position"), top: this.currentItem.css("top"), left: this.currentItem.css("left") }), (!s[0].style.width || i.forceHelperSize) && s.width(this.currentItem.width()), (!s[0].style.height || i.forceHelperSize) && s.height(this.currentItem.height()), s;
    }, _adjustOffsetFromHelper: function _adjustOffsetFromHelper(e) {
      "string" == typeof e && (e = e.split(" ")), t.isArray(e) && (e = { left: +e[0], top: +e[1] || 0 }), "left" in e && (this.offset.click.left = e.left + this.margins.left), "right" in e && (this.offset.click.left = this.helperProportions.width - e.right + this.margins.left), "top" in e && (this.offset.click.top = e.top + this.margins.top), "bottom" in e && (this.offset.click.top = this.helperProportions.height - e.bottom + this.margins.top);
    }, _getParentOffset: function _getParentOffset() {
      this.offsetParent = this.helper.offsetParent();var e = this.offsetParent.offset();return "absolute" === this.cssPosition && this.scrollParent[0] !== this.document[0] && t.contains(this.scrollParent[0], this.offsetParent[0]) && (e.left += this.scrollParent.scrollLeft(), e.top += this.scrollParent.scrollTop()), (this.offsetParent[0] === this.document[0].body || this.offsetParent[0].tagName && "html" === this.offsetParent[0].tagName.toLowerCase() && t.ui.ie) && (e = { top: 0, left: 0 }), { top: e.top + (parseInt(this.offsetParent.css("borderTopWidth"), 10) || 0), left: e.left + (parseInt(this.offsetParent.css("borderLeftWidth"), 10) || 0) };
    }, _getRelativeOffset: function _getRelativeOffset() {
      if ("relative" === this.cssPosition) {
        var t = this.currentItem.position();return { top: t.top - (parseInt(this.helper.css("top"), 10) || 0) + this.scrollParent.scrollTop(), left: t.left - (parseInt(this.helper.css("left"), 10) || 0) + this.scrollParent.scrollLeft() };
      }return { top: 0, left: 0 };
    }, _cacheMargins: function _cacheMargins() {
      this.margins = { left: parseInt(this.currentItem.css("marginLeft"), 10) || 0, top: parseInt(this.currentItem.css("marginTop"), 10) || 0 };
    }, _cacheHelperProportions: function _cacheHelperProportions() {
      this.helperProportions = { width: this.helper.outerWidth(), height: this.helper.outerHeight() };
    }, _setContainment: function _setContainment() {
      var e,
          i,
          s,
          n = this.options;"parent" === n.containment && (n.containment = this.helper[0].parentNode), ("document" === n.containment || "window" === n.containment) && (this.containment = [0 - this.offset.relative.left - this.offset.parent.left, 0 - this.offset.relative.top - this.offset.parent.top, "document" === n.containment ? this.document.width() : this.window.width() - this.helperProportions.width - this.margins.left, ("document" === n.containment ? this.document.height() || document.body.parentNode.scrollHeight : this.window.height() || this.document[0].body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top]), /^(document|window|parent)$/.test(n.containment) || (e = t(n.containment)[0], i = t(n.containment).offset(), s = "hidden" !== t(e).css("overflow"), this.containment = [i.left + (parseInt(t(e).css("borderLeftWidth"), 10) || 0) + (parseInt(t(e).css("paddingLeft"), 10) || 0) - this.margins.left, i.top + (parseInt(t(e).css("borderTopWidth"), 10) || 0) + (parseInt(t(e).css("paddingTop"), 10) || 0) - this.margins.top, i.left + (s ? Math.max(e.scrollWidth, e.offsetWidth) : e.offsetWidth) - (parseInt(t(e).css("borderLeftWidth"), 10) || 0) - (parseInt(t(e).css("paddingRight"), 10) || 0) - this.helperProportions.width - this.margins.left, i.top + (s ? Math.max(e.scrollHeight, e.offsetHeight) : e.offsetHeight) - (parseInt(t(e).css("borderTopWidth"), 10) || 0) - (parseInt(t(e).css("paddingBottom"), 10) || 0) - this.helperProportions.height - this.margins.top]);
    }, _convertPositionTo: function _convertPositionTo(e, i) {
      i || (i = this.position);var s = "absolute" === e ? 1 : -1,
          n = "absolute" !== this.cssPosition || this.scrollParent[0] !== this.document[0] && t.contains(this.scrollParent[0], this.offsetParent[0]) ? this.scrollParent : this.offsetParent,
          o = /(html|body)/i.test(n[0].tagName);return { top: i.top + this.offset.relative.top * s + this.offset.parent.top * s - ("fixed" === this.cssPosition ? -this.scrollParent.scrollTop() : o ? 0 : n.scrollTop()) * s, left: i.left + this.offset.relative.left * s + this.offset.parent.left * s - ("fixed" === this.cssPosition ? -this.scrollParent.scrollLeft() : o ? 0 : n.scrollLeft()) * s };
    }, _generatePosition: function _generatePosition(e) {
      var i,
          s,
          n = this.options,
          o = e.pageX,
          a = e.pageY,
          r = "absolute" !== this.cssPosition || this.scrollParent[0] !== this.document[0] && t.contains(this.scrollParent[0], this.offsetParent[0]) ? this.scrollParent : this.offsetParent,
          h = /(html|body)/i.test(r[0].tagName);return "relative" !== this.cssPosition || this.scrollParent[0] !== this.document[0] && this.scrollParent[0] !== this.offsetParent[0] || (this.offset.relative = this._getRelativeOffset()), this.originalPosition && (this.containment && (e.pageX - this.offset.click.left < this.containment[0] && (o = this.containment[0] + this.offset.click.left), e.pageY - this.offset.click.top < this.containment[1] && (a = this.containment[1] + this.offset.click.top), e.pageX - this.offset.click.left > this.containment[2] && (o = this.containment[2] + this.offset.click.left), e.pageY - this.offset.click.top > this.containment[3] && (a = this.containment[3] + this.offset.click.top)), n.grid && (i = this.originalPageY + Math.round((a - this.originalPageY) / n.grid[1]) * n.grid[1], a = this.containment ? i - this.offset.click.top >= this.containment[1] && i - this.offset.click.top <= this.containment[3] ? i : i - this.offset.click.top >= this.containment[1] ? i - n.grid[1] : i + n.grid[1] : i, s = this.originalPageX + Math.round((o - this.originalPageX) / n.grid[0]) * n.grid[0], o = this.containment ? s - this.offset.click.left >= this.containment[0] && s - this.offset.click.left <= this.containment[2] ? s : s - this.offset.click.left >= this.containment[0] ? s - n.grid[0] : s + n.grid[0] : s)), { top: a - this.offset.click.top - this.offset.relative.top - this.offset.parent.top + ("fixed" === this.cssPosition ? -this.scrollParent.scrollTop() : h ? 0 : r.scrollTop()), left: o - this.offset.click.left - this.offset.relative.left - this.offset.parent.left + ("fixed" === this.cssPosition ? -this.scrollParent.scrollLeft() : h ? 0 : r.scrollLeft()) };
    }, _rearrange: function _rearrange(t, e, i, s) {
      i ? i[0].appendChild(this.placeholder[0]) : e.item[0].parentNode.insertBefore(this.placeholder[0], "down" === this.direction ? e.item[0] : e.item[0].nextSibling), this.counter = this.counter ? ++this.counter : 1;var n = this.counter;
      this._delay(function () {
        n === this.counter && this.refreshPositions(!s);
      });
    }, _clear: function _clear(t, e) {
      function i(t, e, i) {
        return function (s) {
          i._trigger(t, s, e._uiHash(e));
        };
      }this.reverting = !1;var s,
          n = [];if (!this._noFinalSort && this.currentItem.parent().length && this.placeholder.before(this.currentItem), this._noFinalSort = null, this.helper[0] === this.currentItem[0]) {
        for (s in this._storedCSS) {
          ("auto" === this._storedCSS[s] || "static" === this._storedCSS[s]) && (this._storedCSS[s] = "");
        }this.currentItem.css(this._storedCSS), this._removeClass(this.currentItem, "ui-sortable-helper");
      } else this.currentItem.show();for (this.fromOutside && !e && n.push(function (t) {
        this._trigger("receive", t, this._uiHash(this.fromOutside));
      }), !this.fromOutside && this.domPosition.prev === this.currentItem.prev().not(".ui-sortable-helper")[0] && this.domPosition.parent === this.currentItem.parent()[0] || e || n.push(function (t) {
        this._trigger("update", t, this._uiHash());
      }), this !== this.currentContainer && (e || (n.push(function (t) {
        this._trigger("remove", t, this._uiHash());
      }), n.push(function (t) {
        return function (e) {
          t._trigger("receive", e, this._uiHash(this));
        };
      }.call(this, this.currentContainer)), n.push(function (t) {
        return function (e) {
          t._trigger("update", e, this._uiHash(this));
        };
      }.call(this, this.currentContainer)))), s = this.containers.length - 1; s >= 0; s--) {
        e || n.push(i("deactivate", this, this.containers[s])), this.containers[s].containerCache.over && (n.push(i("out", this, this.containers[s])), this.containers[s].containerCache.over = 0);
      }if (this.storedCursor && (this.document.find("body").css("cursor", this.storedCursor), this.storedStylesheet.remove()), this._storedOpacity && this.helper.css("opacity", this._storedOpacity), this._storedZIndex && this.helper.css("zIndex", "auto" === this._storedZIndex ? "" : this._storedZIndex), this.dragging = !1, e || this._trigger("beforeStop", t, this._uiHash()), this.placeholder[0].parentNode.removeChild(this.placeholder[0]), this.cancelHelperRemoval || (this.helper[0] !== this.currentItem[0] && this.helper.remove(), this.helper = null), !e) {
        for (s = 0; n.length > s; s++) {
          n[s].call(this, t);
        }this._trigger("stop", t, this._uiHash());
      }return this.fromOutside = !1, !this.cancelHelperRemoval;
    }, _trigger: function _trigger() {
      t.Widget.prototype._trigger.apply(this, arguments) === !1 && this.cancel();
    }, _uiHash: function _uiHash(e) {
      var i = e || this;return { helper: i.helper, placeholder: i.placeholder || t([]), position: i.position, originalPosition: i.originalPosition, offset: i.positionAbs, item: i.currentItem, sender: e ? e.element : null };
    } }), t.widget("ui.spinner", { version: "1.12.1", defaultElement: "<input>", widgetEventPrefix: "spin", options: { classes: { "ui-spinner": "ui-corner-all", "ui-spinner-down": "ui-corner-br", "ui-spinner-up": "ui-corner-tr" }, culture: null, icons: { down: "ui-icon-triangle-1-s", up: "ui-icon-triangle-1-n" }, incremental: !0, max: null, min: null, numberFormat: null, page: 10, step: 1, change: null, spin: null, start: null, stop: null }, _create: function _create() {
      this._setOption("max", this.options.max), this._setOption("min", this.options.min), this._setOption("step", this.options.step), "" !== this.value() && this._value(this.element.val(), !0), this._draw(), this._on(this._events), this._refresh(), this._on(this.window, { beforeunload: function beforeunload() {
          this.element.removeAttr("autocomplete");
        } });
    }, _getCreateOptions: function _getCreateOptions() {
      var e = this._super(),
          i = this.element;return t.each(["min", "max", "step"], function (t, s) {
        var n = i.attr(s);null != n && n.length && (e[s] = n);
      }), e;
    }, _events: { keydown: function keydown(t) {
        this._start(t) && this._keydown(t) && t.preventDefault();
      }, keyup: "_stop", focus: function focus() {
        this.previous = this.element.val();
      }, blur: function blur(t) {
        return this.cancelBlur ? (delete this.cancelBlur, void 0) : (this._stop(), this._refresh(), this.previous !== this.element.val() && this._trigger("change", t), void 0);
      }, mousewheel: function mousewheel(t, e) {
        if (e) {
          if (!this.spinning && !this._start(t)) return !1;this._spin((e > 0 ? 1 : -1) * this.options.step, t), clearTimeout(this.mousewheelTimer), this.mousewheelTimer = this._delay(function () {
            this.spinning && this._stop(t);
          }, 100), t.preventDefault();
        }
      }, "mousedown .ui-spinner-button": function mousedownUiSpinnerButton(e) {
        function i() {
          var e = this.element[0] === t.ui.safeActiveElement(this.document[0]);e || (this.element.trigger("focus"), this.previous = s, this._delay(function () {
            this.previous = s;
          }));
        }var s;s = this.element[0] === t.ui.safeActiveElement(this.document[0]) ? this.previous : this.element.val(), e.preventDefault(), i.call(this), this.cancelBlur = !0, this._delay(function () {
          delete this.cancelBlur, i.call(this);
        }), this._start(e) !== !1 && this._repeat(null, t(e.currentTarget).hasClass("ui-spinner-up") ? 1 : -1, e);
      }, "mouseup .ui-spinner-button": "_stop", "mouseenter .ui-spinner-button": function mouseenterUiSpinnerButton(e) {
        return t(e.currentTarget).hasClass("ui-state-active") ? this._start(e) === !1 ? !1 : (this._repeat(null, t(e.currentTarget).hasClass("ui-spinner-up") ? 1 : -1, e), void 0) : void 0;
      }, "mouseleave .ui-spinner-button": "_stop" }, _enhance: function _enhance() {
      this.uiSpinner = this.element.attr("autocomplete", "off").wrap("<span>").parent().append("<a></a><a></a>");
    }, _draw: function _draw() {
      this._enhance(), this._addClass(this.uiSpinner, "ui-spinner", "ui-widget ui-widget-content"), this._addClass("ui-spinner-input"), this.element.attr("role", "spinbutton"), this.buttons = this.uiSpinner.children("a").attr("tabIndex", -1).attr("aria-hidden", !0).button({ classes: { "ui-button": "" } }), this._removeClass(this.buttons, "ui-corner-all"), this._addClass(this.buttons.first(), "ui-spinner-button ui-spinner-up"), this._addClass(this.buttons.last(), "ui-spinner-button ui-spinner-down"), this.buttons.first().button({ icon: this.options.icons.up, showLabel: !1 }), this.buttons.last().button({ icon: this.options.icons.down, showLabel: !1 }), this.buttons.height() > Math.ceil(.5 * this.uiSpinner.height()) && this.uiSpinner.height() > 0 && this.uiSpinner.height(this.uiSpinner.height());
    }, _keydown: function _keydown(e) {
      var i = this.options,
          s = t.ui.keyCode;switch (e.keyCode) {case s.UP:
          return this._repeat(null, 1, e), !0;case s.DOWN:
          return this._repeat(null, -1, e), !0;case s.PAGE_UP:
          return this._repeat(null, i.page, e), !0;case s.PAGE_DOWN:
          return this._repeat(null, -i.page, e), !0;}return !1;
    }, _start: function _start(t) {
      return this.spinning || this._trigger("start", t) !== !1 ? (this.counter || (this.counter = 1), this.spinning = !0, !0) : !1;
    }, _repeat: function _repeat(t, e, i) {
      t = t || 500, clearTimeout(this.timer), this.timer = this._delay(function () {
        this._repeat(40, e, i);
      }, t), this._spin(e * this.options.step, i);
    }, _spin: function _spin(t, e) {
      var i = this.value() || 0;this.counter || (this.counter = 1), i = this._adjustValue(i + t * this._increment(this.counter)), this.spinning && this._trigger("spin", e, { value: i }) === !1 || (this._value(i), this.counter++);
    }, _increment: function _increment(e) {
      var i = this.options.incremental;return i ? t.isFunction(i) ? i(e) : Math.floor(e * e * e / 5e4 - e * e / 500 + 17 * e / 200 + 1) : 1;
    }, _precision: function _precision() {
      var t = this._precisionOf(this.options.step);return null !== this.options.min && (t = Math.max(t, this._precisionOf(this.options.min))), t;
    }, _precisionOf: function _precisionOf(t) {
      var e = "" + t,
          i = e.indexOf(".");return -1 === i ? 0 : e.length - i - 1;
    }, _adjustValue: function _adjustValue(t) {
      var e,
          i,
          s = this.options;return e = null !== s.min ? s.min : 0, i = t - e, i = Math.round(i / s.step) * s.step, t = e + i, t = parseFloat(t.toFixed(this._precision())), null !== s.max && t > s.max ? s.max : null !== s.min && s.min > t ? s.min : t;
    }, _stop: function _stop(t) {
      this.spinning && (clearTimeout(this.timer), clearTimeout(this.mousewheelTimer), this.counter = 0, this.spinning = !1, this._trigger("stop", t));
    }, _setOption: function _setOption(t, e) {
      var i, s, n;return "culture" === t || "numberFormat" === t ? (i = this._parse(this.element.val()), this.options[t] = e, this.element.val(this._format(i)), void 0) : (("max" === t || "min" === t || "step" === t) && "string" == typeof e && (e = this._parse(e)), "icons" === t && (s = this.buttons.first().find(".ui-icon"), this._removeClass(s, null, this.options.icons.up), this._addClass(s, null, e.up), n = this.buttons.last().find(".ui-icon"), this._removeClass(n, null, this.options.icons.down), this._addClass(n, null, e.down)), this._super(t, e), void 0);
    }, _setOptionDisabled: function _setOptionDisabled(t) {
      this._super(t), this._toggleClass(this.uiSpinner, null, "ui-state-disabled", !!t), this.element.prop("disabled", !!t), this.buttons.button(t ? "disable" : "enable");
    }, _setOptions: r(function (t) {
      this._super(t);
    }), _parse: function _parse(t) {
      return "string" == typeof t && "" !== t && (t = window.Globalize && this.options.numberFormat ? Globalize.parseFloat(t, 10, this.options.culture) : +t), "" === t || isNaN(t) ? null : t;
    }, _format: function _format(t) {
      return "" === t ? "" : window.Globalize && this.options.numberFormat ? Globalize.format(t, this.options.numberFormat, this.options.culture) : t;
    }, _refresh: function _refresh() {
      this.element.attr({ "aria-valuemin": this.options.min, "aria-valuemax": this.options.max, "aria-valuenow": this._parse(this.element.val()) });
    }, isValid: function isValid() {
      var t = this.value();return null === t ? !1 : t === this._adjustValue(t);
    }, _value: function _value(t, e) {
      var i;"" !== t && (i = this._parse(t), null !== i && (e || (i = this._adjustValue(i)), t = this._format(i))), this.element.val(t), this._refresh();
    }, _destroy: function _destroy() {
      this.element.prop("disabled", !1).removeAttr("autocomplete role aria-valuemin aria-valuemax aria-valuenow"), this.uiSpinner.replaceWith(this.element);
    }, stepUp: r(function (t) {
      this._stepUp(t);
    }), _stepUp: function _stepUp(t) {
      this._start() && (this._spin((t || 1) * this.options.step), this._stop());
    }, stepDown: r(function (t) {
      this._stepDown(t);
    }), _stepDown: function _stepDown(t) {
      this._start() && (this._spin((t || 1) * -this.options.step), this._stop());
    }, pageUp: r(function (t) {
      this._stepUp((t || 1) * this.options.page);
    }), pageDown: r(function (t) {
      this._stepDown((t || 1) * this.options.page);
    }), value: function value(t) {
      return arguments.length ? (r(this._value).call(this, t), void 0) : this._parse(this.element.val());
    }, widget: function widget() {
      return this.uiSpinner;
    } }), t.uiBackCompat !== !1 && t.widget("ui.spinner", t.ui.spinner, { _enhance: function _enhance() {
      this.uiSpinner = this.element.attr("autocomplete", "off").wrap(this._uiSpinnerHtml()).parent().append(this._buttonHtml());
    }, _uiSpinnerHtml: function _uiSpinnerHtml() {
      return "<span>";
    }, _buttonHtml: function _buttonHtml() {
      return "<a></a><a></a>";
    } }), t.ui.spinner, t.widget("ui.tabs", { version: "1.12.1", delay: 300, options: { active: null, classes: { "ui-tabs": "ui-corner-all", "ui-tabs-nav": "ui-corner-all", "ui-tabs-panel": "ui-corner-bottom", "ui-tabs-tab": "ui-corner-top" }, collapsible: !1, event: "click", heightStyle: "content", hide: null, show: null, activate: null, beforeActivate: null, beforeLoad: null, load: null }, _isLocal: function () {
      var t = /#.*$/;return function (e) {
        var i, s;i = e.href.replace(t, ""), s = location.href.replace(t, "");try {
          i = decodeURIComponent(i);
        } catch (n) {}try {
          s = decodeURIComponent(s);
        } catch (n) {}return e.hash.length > 1 && i === s;
      };
    }(), _create: function _create() {
      var e = this,
          i = this.options;this.running = !1, this._addClass("ui-tabs", "ui-widget ui-widget-content"), this._toggleClass("ui-tabs-collapsible", null, i.collapsible), this._processTabs(), i.active = this._initialActive(), t.isArray(i.disabled) && (i.disabled = t.unique(i.disabled.concat(t.map(this.tabs.filter(".ui-state-disabled"), function (t) {
        return e.tabs.index(t);
      }))).sort()), this.active = this.options.active !== !1 && this.anchors.length ? this._findActive(i.active) : t(), this._refresh(), this.active.length && this.load(i.active);
    }, _initialActive: function _initialActive() {
      var e = this.options.active,
          i = this.options.collapsible,
          s = location.hash.substring(1);return null === e && (s && this.tabs.each(function (i, n) {
        return t(n).attr("aria-controls") === s ? (e = i, !1) : void 0;
      }), null === e && (e = this.tabs.index(this.tabs.filter(".ui-tabs-active"))), (null === e || -1 === e) && (e = this.tabs.length ? 0 : !1)), e !== !1 && (e = this.tabs.index(this.tabs.eq(e)), -1 === e && (e = i ? !1 : 0)), !i && e === !1 && this.anchors.length && (e = 0), e;
    }, _getCreateEventData: function _getCreateEventData() {
      return { tab: this.active, panel: this.active.length ? this._getPanelForTab(this.active) : t() };
    }, _tabKeydown: function _tabKeydown(e) {
      var i = t(t.ui.safeActiveElement(this.document[0])).closest("li"),
          s = this.tabs.index(i),
          n = !0;if (!this._handlePageNav(e)) {
        switch (e.keyCode) {case t.ui.keyCode.RIGHT:case t.ui.keyCode.DOWN:
            s++;break;case t.ui.keyCode.UP:case t.ui.keyCode.LEFT:
            n = !1, s--;break;case t.ui.keyCode.END:
            s = this.anchors.length - 1;break;case t.ui.keyCode.HOME:
            s = 0;break;case t.ui.keyCode.SPACE:
            return e.preventDefault(), clearTimeout(this.activating), this._activate(s), void 0;case t.ui.keyCode.ENTER:
            return e.preventDefault(), clearTimeout(this.activating), this._activate(s === this.options.active ? !1 : s), void 0;default:
            return;}e.preventDefault(), clearTimeout(this.activating), s = this._focusNextTab(s, n), e.ctrlKey || e.metaKey || (i.attr("aria-selected", "false"), this.tabs.eq(s).attr("aria-selected", "true"), this.activating = this._delay(function () {
          this.option("active", s);
        }, this.delay));
      }
    }, _panelKeydown: function _panelKeydown(e) {
      this._handlePageNav(e) || e.ctrlKey && e.keyCode === t.ui.keyCode.UP && (e.preventDefault(), this.active.trigger("focus"));
    }, _handlePageNav: function _handlePageNav(e) {
      return e.altKey && e.keyCode === t.ui.keyCode.PAGE_UP ? (this._activate(this._focusNextTab(this.options.active - 1, !1)), !0) : e.altKey && e.keyCode === t.ui.keyCode.PAGE_DOWN ? (this._activate(this._focusNextTab(this.options.active + 1, !0)), !0) : void 0;
    }, _findNextTab: function _findNextTab(e, i) {
      function s() {
        return e > n && (e = 0), 0 > e && (e = n), e;
      }for (var n = this.tabs.length - 1; -1 !== t.inArray(s(), this.options.disabled);) {
        e = i ? e + 1 : e - 1;
      }return e;
    }, _focusNextTab: function _focusNextTab(t, e) {
      return t = this._findNextTab(t, e), this.tabs.eq(t).trigger("focus"), t;
    }, _setOption: function _setOption(t, e) {
      return "active" === t ? (this._activate(e), void 0) : (this._super(t, e), "collapsible" === t && (this._toggleClass("ui-tabs-collapsible", null, e), e || this.options.active !== !1 || this._activate(0)), "event" === t && this._setupEvents(e), "heightStyle" === t && this._setupHeightStyle(e), void 0);
    }, _sanitizeSelector: function _sanitizeSelector(t) {
      return t ? t.replace(/[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g, "\\$&") : "";
    }, refresh: function refresh() {
      var e = this.options,
          i = this.tablist.children(":has(a[href])");e.disabled = t.map(i.filter(".ui-state-disabled"), function (t) {
        return i.index(t);
      }), this._processTabs(), e.active !== !1 && this.anchors.length ? this.active.length && !t.contains(this.tablist[0], this.active[0]) ? this.tabs.length === e.disabled.length ? (e.active = !1, this.active = t()) : this._activate(this._findNextTab(Math.max(0, e.active - 1), !1)) : e.active = this.tabs.index(this.active) : (e.active = !1, this.active = t()), this._refresh();
    }, _refresh: function _refresh() {
      this._setOptionDisabled(this.options.disabled), this._setupEvents(this.options.event), this._setupHeightStyle(this.options.heightStyle), this.tabs.not(this.active).attr({ "aria-selected": "false", "aria-expanded": "false", tabIndex: -1 }), this.panels.not(this._getPanelForTab(this.active)).hide().attr({ "aria-hidden": "true" }), this.active.length ? (this.active.attr({ "aria-selected": "true", "aria-expanded": "true", tabIndex: 0 }), this._addClass(this.active, "ui-tabs-active", "ui-state-active"), this._getPanelForTab(this.active).show().attr({ "aria-hidden": "false" })) : this.tabs.eq(0).attr("tabIndex", 0);
    }, _processTabs: function _processTabs() {
      var e = this,
          i = this.tabs,
          s = this.anchors,
          n = this.panels;this.tablist = this._getList().attr("role", "tablist"), this._addClass(this.tablist, "ui-tabs-nav", "ui-helper-reset ui-helper-clearfix ui-widget-header"), this.tablist.on("mousedown" + this.eventNamespace, "> li", function (e) {
        t(this).is(".ui-state-disabled") && e.preventDefault();
      }).on("focus" + this.eventNamespace, ".ui-tabs-anchor", function () {
        t(this).closest("li").is(".ui-state-disabled") && this.blur();
      }), this.tabs = this.tablist.find("> li:has(a[href])").attr({ role: "tab", tabIndex: -1 }), this._addClass(this.tabs, "ui-tabs-tab", "ui-state-default"), this.anchors = this.tabs.map(function () {
        return t("a", this)[0];
      }).attr({ role: "presentation", tabIndex: -1 }), this._addClass(this.anchors, "ui-tabs-anchor"), this.panels = t(), this.anchors.each(function (i, s) {
        var n,
            o,
            a,
            r = t(s).uniqueId().attr("id"),
            h = t(s).closest("li"),
            l = h.attr("aria-controls");e._isLocal(s) ? (n = s.hash, a = n.substring(1), o = e.element.find(e._sanitizeSelector(n))) : (a = h.attr("aria-controls") || t({}).uniqueId()[0].id, n = "#" + a, o = e.element.find(n), o.length || (o = e._createPanel(a), o.insertAfter(e.panels[i - 1] || e.tablist)), o.attr("aria-live", "polite")), o.length && (e.panels = e.panels.add(o)), l && h.data("ui-tabs-aria-controls", l), h.attr({ "aria-controls": a, "aria-labelledby": r }), o.attr("aria-labelledby", r);
      }), this.panels.attr("role", "tabpanel"), this._addClass(this.panels, "ui-tabs-panel", "ui-widget-content"), i && (this._off(i.not(this.tabs)), this._off(s.not(this.anchors)), this._off(n.not(this.panels)));
    }, _getList: function _getList() {
      return this.tablist || this.element.find("ol, ul").eq(0);
    }, _createPanel: function _createPanel(e) {
      return t("<div>").attr("id", e).data("ui-tabs-destroy", !0);
    }, _setOptionDisabled: function _setOptionDisabled(e) {
      var i, s, n;for (t.isArray(e) && (e.length ? e.length === this.anchors.length && (e = !0) : e = !1), n = 0; s = this.tabs[n]; n++) {
        i = t(s), e === !0 || -1 !== t.inArray(n, e) ? (i.attr("aria-disabled", "true"), this._addClass(i, null, "ui-state-disabled")) : (i.removeAttr("aria-disabled"), this._removeClass(i, null, "ui-state-disabled"));
      }this.options.disabled = e, this._toggleClass(this.widget(), this.widgetFullName + "-disabled", null, e === !0);
    }, _setupEvents: function _setupEvents(e) {
      var i = {};e && t.each(e.split(" "), function (t, e) {
        i[e] = "_eventHandler";
      }), this._off(this.anchors.add(this.tabs).add(this.panels)), this._on(!0, this.anchors, { click: function click(t) {
          t.preventDefault();
        } }), this._on(this.anchors, i), this._on(this.tabs, { keydown: "_tabKeydown" }), this._on(this.panels, { keydown: "_panelKeydown" }), this._focusable(this.tabs), this._hoverable(this.tabs);
    }, _setupHeightStyle: function _setupHeightStyle(e) {
      var i,
          s = this.element.parent();"fill" === e ? (i = s.height(), i -= this.element.outerHeight() - this.element.height(), this.element.siblings(":visible").each(function () {
        var e = t(this),
            s = e.css("position");"absolute" !== s && "fixed" !== s && (i -= e.outerHeight(!0));
      }), this.element.children().not(this.panels).each(function () {
        i -= t(this).outerHeight(!0);
      }), this.panels.each(function () {
        t(this).height(Math.max(0, i - t(this).innerHeight() + t(this).height()));
      }).css("overflow", "auto")) : "auto" === e && (i = 0, this.panels.each(function () {
        i = Math.max(i, t(this).height("").height());
      }).height(i));
    }, _eventHandler: function _eventHandler(e) {
      var i = this.options,
          s = this.active,
          n = t(e.currentTarget),
          o = n.closest("li"),
          a = o[0] === s[0],
          r = a && i.collapsible,
          h = r ? t() : this._getPanelForTab(o),
          l = s.length ? this._getPanelForTab(s) : t(),
          c = { oldTab: s, oldPanel: l, newTab: r ? t() : o, newPanel: h };e.preventDefault(), o.hasClass("ui-state-disabled") || o.hasClass("ui-tabs-loading") || this.running || a && !i.collapsible || this._trigger("beforeActivate", e, c) === !1 || (i.active = r ? !1 : this.tabs.index(o), this.active = a ? t() : o, this.xhr && this.xhr.abort(), l.length || h.length || t.error("jQuery UI Tabs: Mismatching fragment identifier."), h.length && this.load(this.tabs.index(o), e), this._toggle(e, c));
    }, _toggle: function _toggle(e, i) {
      function s() {
        o.running = !1, o._trigger("activate", e, i);
      }function n() {
        o._addClass(i.newTab.closest("li"), "ui-tabs-active", "ui-state-active"), a.length && o.options.show ? o._show(a, o.options.show, s) : (a.show(), s());
      }var o = this,
          a = i.newPanel,
          r = i.oldPanel;this.running = !0, r.length && this.options.hide ? this._hide(r, this.options.hide, function () {
        o._removeClass(i.oldTab.closest("li"), "ui-tabs-active", "ui-state-active"), n();
      }) : (this._removeClass(i.oldTab.closest("li"), "ui-tabs-active", "ui-state-active"), r.hide(), n()), r.attr("aria-hidden", "true"), i.oldTab.attr({ "aria-selected": "false", "aria-expanded": "false" }), a.length && r.length ? i.oldTab.attr("tabIndex", -1) : a.length && this.tabs.filter(function () {
        return 0 === t(this).attr("tabIndex");
      }).attr("tabIndex", -1), a.attr("aria-hidden", "false"), i.newTab.attr({ "aria-selected": "true", "aria-expanded": "true", tabIndex: 0 });
    }, _activate: function _activate(e) {
      var i,
          s = this._findActive(e);s[0] !== this.active[0] && (s.length || (s = this.active), i = s.find(".ui-tabs-anchor")[0], this._eventHandler({ target: i, currentTarget: i, preventDefault: t.noop }));
    }, _findActive: function _findActive(e) {
      return e === !1 ? t() : this.tabs.eq(e);
    }, _getIndex: function _getIndex(e) {
      return "string" == typeof e && (e = this.anchors.index(this.anchors.filter("[href$='" + t.ui.escapeSelector(e) + "']"))), e;
    }, _destroy: function _destroy() {
      this.xhr && this.xhr.abort(), this.tablist.removeAttr("role").off(this.eventNamespace), this.anchors.removeAttr("role tabIndex").removeUniqueId(), this.tabs.add(this.panels).each(function () {
        t.data(this, "ui-tabs-destroy") ? t(this).remove() : t(this).removeAttr("role tabIndex aria-live aria-busy aria-selected aria-labelledby aria-hidden aria-expanded");
      }), this.tabs.each(function () {
        var e = t(this),
            i = e.data("ui-tabs-aria-controls");i ? e.attr("aria-controls", i).removeData("ui-tabs-aria-controls") : e.removeAttr("aria-controls");
      }), this.panels.show(), "content" !== this.options.heightStyle && this.panels.css("height", "");
    }, enable: function enable(e) {
      var i = this.options.disabled;i !== !1 && (void 0 === e ? i = !1 : (e = this._getIndex(e), i = t.isArray(i) ? t.map(i, function (t) {
        return t !== e ? t : null;
      }) : t.map(this.tabs, function (t, i) {
        return i !== e ? i : null;
      })), this._setOptionDisabled(i));
    }, disable: function disable(e) {
      var i = this.options.disabled;if (i !== !0) {
        if (void 0 === e) i = !0;else {
          if (e = this._getIndex(e), -1 !== t.inArray(e, i)) return;i = t.isArray(i) ? t.merge([e], i).sort() : [e];
        }this._setOptionDisabled(i);
      }
    }, load: function load(e, i) {
      e = this._getIndex(e);var s = this,
          n = this.tabs.eq(e),
          o = n.find(".ui-tabs-anchor"),
          a = this._getPanelForTab(n),
          r = { tab: n, panel: a },
          h = function h(t, e) {
        "abort" === e && s.panels.stop(!1, !0), s._removeClass(n, "ui-tabs-loading"), a.removeAttr("aria-busy"), t === s.xhr && delete s.xhr;
      };this._isLocal(o[0]) || (this.xhr = t.ajax(this._ajaxSettings(o, i, r)), this.xhr && "canceled" !== this.xhr.statusText && (this._addClass(n, "ui-tabs-loading"), a.attr("aria-busy", "true"), this.xhr.done(function (t, e, n) {
        setTimeout(function () {
          a.html(t), s._trigger("load", i, r), h(n, e);
        }, 1);
      }).fail(function (t, e) {
        setTimeout(function () {
          h(t, e);
        }, 1);
      })));
    }, _ajaxSettings: function _ajaxSettings(e, i, s) {
      var n = this;return { url: e.attr("href").replace(/#.*$/, ""), beforeSend: function beforeSend(e, o) {
          return n._trigger("beforeLoad", i, t.extend({ jqXHR: e, ajaxSettings: o }, s));
        } };
    }, _getPanelForTab: function _getPanelForTab(e) {
      var i = t(e).attr("aria-controls");return this.element.find(this._sanitizeSelector("#" + i));
    } }), t.uiBackCompat !== !1 && t.widget("ui.tabs", t.ui.tabs, { _processTabs: function _processTabs() {
      this._superApply(arguments), this._addClass(this.tabs, "ui-tab");
    } }), t.ui.tabs, t.widget("ui.tooltip", { version: "1.12.1", options: { classes: { "ui-tooltip": "ui-corner-all ui-widget-shadow" }, content: function content() {
        var e = t(this).attr("title") || "";return t("<a>").text(e).html();
      }, hide: !0, items: "[title]:not([disabled])", position: { my: "left top+15", at: "left bottom", collision: "flipfit flip" }, show: !0, track: !1, close: null, open: null }, _addDescribedBy: function _addDescribedBy(e, i) {
      var s = (e.attr("aria-describedby") || "").split(/\s+/);s.push(i), e.data("ui-tooltip-id", i).attr("aria-describedby", t.trim(s.join(" ")));
    }, _removeDescribedBy: function _removeDescribedBy(e) {
      var i = e.data("ui-tooltip-id"),
          s = (e.attr("aria-describedby") || "").split(/\s+/),
          n = t.inArray(i, s);-1 !== n && s.splice(n, 1), e.removeData("ui-tooltip-id"), s = t.trim(s.join(" ")), s ? e.attr("aria-describedby", s) : e.removeAttr("aria-describedby");
    }, _create: function _create() {
      this._on({ mouseover: "open", focusin: "open" }), this.tooltips = {}, this.parents = {}, this.liveRegion = t("<div>").attr({ role: "log", "aria-live": "assertive", "aria-relevant": "additions" }).appendTo(this.document[0].body), this._addClass(this.liveRegion, null, "ui-helper-hidden-accessible"), this.disabledTitles = t([]);
    }, _setOption: function _setOption(e, i) {
      var s = this;this._super(e, i), "content" === e && t.each(this.tooltips, function (t, e) {
        s._updateContent(e.element);
      });
    }, _setOptionDisabled: function _setOptionDisabled(t) {
      this[t ? "_disable" : "_enable"]();
    }, _disable: function _disable() {
      var e = this;t.each(this.tooltips, function (i, s) {
        var n = t.Event("blur");n.target = n.currentTarget = s.element[0], e.close(n, !0);
      }), this.disabledTitles = this.disabledTitles.add(this.element.find(this.options.items).addBack().filter(function () {
        var e = t(this);return e.is("[title]") ? e.data("ui-tooltip-title", e.attr("title")).removeAttr("title") : void 0;
      }));
    }, _enable: function _enable() {
      this.disabledTitles.each(function () {
        var e = t(this);e.data("ui-tooltip-title") && e.attr("title", e.data("ui-tooltip-title"));
      }), this.disabledTitles = t([]);
    }, open: function open(e) {
      var i = this,
          s = t(e ? e.target : this.element).closest(this.options.items);s.length && !s.data("ui-tooltip-id") && (s.attr("title") && s.data("ui-tooltip-title", s.attr("title")), s.data("ui-tooltip-open", !0), e && "mouseover" === e.type && s.parents().each(function () {
        var e,
            s = t(this);s.data("ui-tooltip-open") && (e = t.Event("blur"), e.target = e.currentTarget = this, i.close(e, !0)), s.attr("title") && (s.uniqueId(), i.parents[this.id] = { element: this, title: s.attr("title") }, s.attr("title", ""));
      }), this._registerCloseHandlers(e, s), this._updateContent(s, e));
    }, _updateContent: function _updateContent(t, e) {
      var i,
          s = this.options.content,
          n = this,
          o = e ? e.type : null;return "string" == typeof s || s.nodeType || s.jquery ? this._open(e, t, s) : (i = s.call(t[0], function (i) {
        n._delay(function () {
          t.data("ui-tooltip-open") && (e && (e.type = o), this._open(e, t, i));
        });
      }), i && this._open(e, t, i), void 0);
    }, _open: function _open(e, i, s) {
      function n(t) {
        l.of = t, a.is(":hidden") || a.position(l);
      }var o,
          a,
          r,
          h,
          l = t.extend({}, this.options.position);if (s) {
        if (o = this._find(i)) return o.tooltip.find(".ui-tooltip-content").html(s), void 0;i.is("[title]") && (e && "mouseover" === e.type ? i.attr("title", "") : i.removeAttr("title")), o = this._tooltip(i), a = o.tooltip, this._addDescribedBy(i, a.attr("id")), a.find(".ui-tooltip-content").html(s), this.liveRegion.children().hide(), h = t("<div>").html(a.find(".ui-tooltip-content").html()), h.removeAttr("name").find("[name]").removeAttr("name"), h.removeAttr("id").find("[id]").removeAttr("id"), h.appendTo(this.liveRegion), this.options.track && e && /^mouse/.test(e.type) ? (this._on(this.document, { mousemove: n }), n(e)) : a.position(t.extend({ of: i }, this.options.position)), a.hide(), this._show(a, this.options.show), this.options.track && this.options.show && this.options.show.delay && (r = this.delayedShow = setInterval(function () {
          a.is(":visible") && (n(l.of), clearInterval(r));
        }, t.fx.interval)), this._trigger("open", e, { tooltip: a });
      }
    }, _registerCloseHandlers: function _registerCloseHandlers(e, i) {
      var s = { keyup: function keyup(e) {
          if (e.keyCode === t.ui.keyCode.ESCAPE) {
            var s = t.Event(e);s.currentTarget = i[0], this.close(s, !0);
          }
        } };i[0] !== this.element[0] && (s.remove = function () {
        this._removeTooltip(this._find(i).tooltip);
      }), e && "mouseover" !== e.type || (s.mouseleave = "close"), e && "focusin" !== e.type || (s.focusout = "close"), this._on(!0, i, s);
    }, close: function close(e) {
      var i,
          s = this,
          n = t(e ? e.currentTarget : this.element),
          o = this._find(n);return o ? (i = o.tooltip, o.closing || (clearInterval(this.delayedShow), n.data("ui-tooltip-title") && !n.attr("title") && n.attr("title", n.data("ui-tooltip-title")), this._removeDescribedBy(n), o.hiding = !0, i.stop(!0), this._hide(i, this.options.hide, function () {
        s._removeTooltip(t(this));
      }), n.removeData("ui-tooltip-open"), this._off(n, "mouseleave focusout keyup"), n[0] !== this.element[0] && this._off(n, "remove"), this._off(this.document, "mousemove"), e && "mouseleave" === e.type && t.each(this.parents, function (e, i) {
        t(i.element).attr("title", i.title), delete s.parents[e];
      }), o.closing = !0, this._trigger("close", e, { tooltip: i }), o.hiding || (o.closing = !1)), void 0) : (n.removeData("ui-tooltip-open"), void 0);
    }, _tooltip: function _tooltip(e) {
      var i = t("<div>").attr("role", "tooltip"),
          s = t("<div>").appendTo(i),
          n = i.uniqueId().attr("id");return this._addClass(s, "ui-tooltip-content"), this._addClass(i, "ui-tooltip", "ui-widget ui-widget-content"), i.appendTo(this._appendTo(e)), this.tooltips[n] = { element: e, tooltip: i };
    }, _find: function _find(t) {
      var e = t.data("ui-tooltip-id");return e ? this.tooltips[e] : null;
    }, _removeTooltip: function _removeTooltip(t) {
      t.remove(), delete this.tooltips[t.attr("id")];
    }, _appendTo: function _appendTo(t) {
      var e = t.closest(".ui-front, dialog");return e.length || (e = this.document[0].body), e;
    }, _destroy: function _destroy() {
      var e = this;t.each(this.tooltips, function (i, s) {
        var n = t.Event("blur"),
            o = s.element;n.target = n.currentTarget = o[0], e.close(n, !0), t("#" + i).remove(), o.data("ui-tooltip-title") && (o.attr("title") || o.attr("title", o.data("ui-tooltip-title")), o.removeData("ui-tooltip-title"));
      }), this.liveRegion.remove();
    } }), t.uiBackCompat !== !1 && t.widget("ui.tooltip", t.ui.tooltip, { options: { tooltipClass: null }, _tooltip: function _tooltip() {
      var t = this._superApply(arguments);return this.options.tooltipClass && t.tooltip.addClass(this.options.tooltipClass), t;
    } }), t.ui.tooltip;
});

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "replace-icon.png?1e31a579b671f07fc6004121a92ddc15";

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(18) && !__webpack_require__(10)(function () {
  return Object.defineProperty(__webpack_require__(127)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(15);


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(37);
var toIObject = __webpack_require__(38);
var arrayIndexOf = __webpack_require__(100)(false);
var IE_PROTO = __webpack_require__(129)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(20);
var anObject = __webpack_require__(7);
var getKeys = __webpack_require__(70);

module.exports = __webpack_require__(18) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(38);
var gOPN = __webpack_require__(73).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(18);
var getKeys = __webpack_require__(70);
var gOPS = __webpack_require__(101);
var pIE = __webpack_require__(93);
var toObject = __webpack_require__(22);
var IObject = __webpack_require__(92);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(10)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 174 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(29);
var isObject = __webpack_require__(11);
var invoke = __webpack_require__(176);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 176 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(8).parseInt;
var $trim = __webpack_require__(84).trim;
var ws = __webpack_require__(133);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(8).parseFloat;
var $trim = __webpack_require__(84).trim;

module.exports = 1 / $parseFloat(__webpack_require__(133) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(46);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(11);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 181 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(136);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(7);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(29);
var toObject = __webpack_require__(22);
var IObject = __webpack_require__(92);
var toLength = __webpack_require__(16);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(22);
var toAbsoluteIndex = __webpack_require__(71);
var toLength = __webpack_require__(16);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(148);
__webpack_require__(0)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(18) && /./g.flags != 'g') __webpack_require__(20).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(94)
});


/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(7);
var isObject = __webpack_require__(11);
var newPromiseCapability = __webpack_require__(152);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(192);
var validate = __webpack_require__(78);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(109)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(20).f;
var create = __webpack_require__(72);
var redefineAll = __webpack_require__(77);
var ctx = __webpack_require__(45);
var anInstance = __webpack_require__(75);
var forOf = __webpack_require__(76);
var $iterDefine = __webpack_require__(138);
var step = __webpack_require__(186);
var setSpecies = __webpack_require__(74);
var DESCRIPTORS = __webpack_require__(18);
var fastKey = __webpack_require__(63).fastKey;
var validate = __webpack_require__(78);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(192);
var validate = __webpack_require__(78);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(109)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(8);
var each = __webpack_require__(53)(0);
var redefine = __webpack_require__(33);
var meta = __webpack_require__(63);
var assign = __webpack_require__(173);
var weak = __webpack_require__(195);
var isObject = __webpack_require__(11);
var validate = __webpack_require__(78);
var NATIVE_WEAK_MAP = __webpack_require__(78);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(109)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(77);
var getWeak = __webpack_require__(63).getWeak;
var anObject = __webpack_require__(7);
var isObject = __webpack_require__(11);
var anInstance = __webpack_require__(75);
var forOf = __webpack_require__(76);
var createArrayMethod = __webpack_require__(53);
var $has = __webpack_require__(37);
var validate = __webpack_require__(78);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(47);
var toLength = __webpack_require__(16);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(73);
var gOPS = __webpack_require__(101);
var anObject = __webpack_require__(7);
var Reflect = __webpack_require__(8).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(102);
var isObject = __webpack_require__(11);
var toLength = __webpack_require__(16);
var ctx = __webpack_require__(45);
var IS_CONCAT_SPREADABLE = __webpack_require__(15)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(16);
var repeat = __webpack_require__(135);
var defined = __webpack_require__(51);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(18);
var getKeys = __webpack_require__(70);
var toIObject = __webpack_require__(38);
var isEnum = __webpack_require__(93).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(83);
var from = __webpack_require__(202);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(76);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 203 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ErrorBag */
/* unused harmony export Rules */
/* unused harmony export ValidationObserver */
/* unused harmony export ValidationProvider */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Validator; });
/* unused harmony export directive */
/* unused harmony export install */
/* unused harmony export mapFields */
/* unused harmony export mixin */
/* unused harmony export version */
/* unused harmony export withValidation */
/**
  * vee-validate v2.2.15
  * (c) 2019 Abdelrahman Awad
  * @license MIT
  */
// 

var isTextInput = function (el) {
  return includes(['text', 'password', 'search', 'email', 'tel', 'url', 'textarea', 'number'], el.type);
};

var isCheckboxOrRadioInput = function (el) {
  return includes(['radio', 'checkbox'], el.type);
};

var isDateInput = function (el) {
  return includes(['date', 'week', 'month', 'datetime-local', 'time'], el.type);
};

/**
 * Gets the data attribute. the name must be kebab-case.
 */
var getDataAttribute = function (el, name) { return el.getAttribute(("data-vv-" + name)); };

var isNaN$1 = function (value) {
  if ('isNaN' in Number) {
    return Number.isNaN(value);
  }

  // eslint-disable-next-line
  return typeof(value) === 'number' && value !== value;
};

/**
 * Checks if the values are either null or undefined.
 */
var isNullOrUndefined = function () {
  var values = [], len = arguments.length;
  while ( len-- ) values[ len ] = arguments[ len ];

  return values.every(function (value) {
    return value === null || value === undefined;
  });
};

/**
 * Creates the default flags object.
 */
var createFlags = function () { return ({
  untouched: true,
  touched: false,
  dirty: false,
  pristine: true,
  valid: null,
  invalid: null,
  validated: false,
  pending: false,
  required: false,
  changed: false
}); };

/**
 * Shallow object comparison.
 */
var isEqual = function (lhs, rhs) {
  if (lhs instanceof RegExp && rhs instanceof RegExp) {
    return isEqual(lhs.source, rhs.source) && isEqual(lhs.flags, rhs.flags);
  }

  if (Array.isArray(lhs) && Array.isArray(rhs)) {
    if (lhs.length !== rhs.length) { return false; }

    for (var i = 0; i < lhs.length; i++) {
      if (!isEqual(lhs[i], rhs[i])) {
        return false;
      }
    }

    return true;
  }

  // if both are objects, compare each key recursively.
  if (isObject(lhs) && isObject(rhs)) {
    return Object.keys(lhs).every(function (key) {
      return isEqual(lhs[key], rhs[key]);
    }) && Object.keys(rhs).every(function (key) {
      return isEqual(lhs[key], rhs[key]);
    });
  }

  if (isNaN$1(lhs) && isNaN$1(rhs)) {
    return true;
  }

  return lhs === rhs;
};

/**
 * Determines the input field scope.
 */
var getScope = function (el) {
  var scope = getDataAttribute(el, 'scope');
  if (isNullOrUndefined(scope)) {
    var form = getForm(el);

    if (form) {
      scope = getDataAttribute(form, 'scope');
    }
  }

  return !isNullOrUndefined(scope) ? scope : null;
};

/**
 * Get the closest form element.
 */
var getForm = function (el) {
  if (isNullOrUndefined(el)) { return null; }

  if (el.tagName === 'FORM') { return el; }

  if (!isNullOrUndefined(el.form)) { return el.form; }

  return !isNullOrUndefined(el.parentNode) ? getForm(el.parentNode) : null;
};

/**
 * Gets the value in an object safely.
 */
var getPath = function (path, target, def) {
  if ( def === void 0 ) def = undefined;

  if (!path || !target) { return def; }

  var value = target;
  path.split('.').every(function (prop) {
    if (prop in value) {
      value = value[prop];

      return true;
    }

    value = def;

    return false;
  });

  return value;
};

/**
 * Checks if path exists within an object.
 */
var hasPath = function (path, target) {
  var obj = target;
  var previousPath = null;
  var isNullOrNonObject = false;
  var isValidPath = path.split('.').reduce(function (reducer, prop) {
    if (obj == null || typeof obj !== 'object') {
      isNullOrNonObject = true;
      return reducer && false;
    }

    if (prop in obj) {
      obj = obj[prop];
      previousPath = previousPath === null ? prop : previousPath + '.' + prop;

      return reducer && true;
    }

    return reducer && false;
  }, true);

  if (false) {
    if (isNullOrNonObject) {
      throw new Error(previousPath + ' is not an object');
    }
  }

  return isValidPath;
};

/**
 * Parses a rule string expression.
 */
var parseRule = function (rule) {
  var params = [];
  var name = rule.split(':')[0];

  if (includes(rule, ':')) {
    params = rule.split(':').slice(1).join(':').split(',');
  }

  return { name: name, params: params };
};

/**
 * Debounces a function.
 */
var debounce = function (fn, wait, token) {
  if ( wait === void 0 ) wait = 0;
  if ( token === void 0 ) token = { cancelled: false };

  if (wait === 0) {
    return fn;
  }

  var timeout;

  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var later = function () {
      timeout = null;

      // check if the fn call was cancelled.
      if (!token.cancelled) { fn.apply(void 0, args); }
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (!timeout) { fn.apply(void 0, args); }
  };
};

/**
 * Appends a rule definition to a list of rules.
 */
var appendRule = function (rule, rules) {
  if (!rules) {
    return normalizeRules(rule);
  }

  if (!rule) {
    return normalizeRules(rules);
  }

  if (typeof rules === 'string') {
    rules = normalizeRules(rules);
  }

  return assign({}, rules, normalizeRules(rule));
};

/**
 * Normalizes the given rules expression.
 */
var normalizeRules = function (rules) {
  // if falsy value return an empty object.
  if (!rules) {
    return {};
  }

  if (isObject(rules)) {
    // $FlowFixMe
    return Object.keys(rules).reduce(function (prev, curr) {
      var params = [];
      // $FlowFixMe
      if (rules[curr] === true) {
        params = [];
      } else if (Array.isArray(rules[curr])) {
        params = rules[curr];
      } else if (isObject(rules[curr])) {
        params = rules[curr];
      } else {
        params = [rules[curr]];
      }

      // $FlowFixMe
      if (rules[curr] !== false) {
        prev[curr] = params;
      }

      return prev;
    }, {});
  }

  if (typeof rules !== 'string') {
    warn('rules must be either a string or an object.');
    return {};
  }

  return rules.split('|').reduce(function (prev, rule) {
    var parsedRule = parseRule(rule);
    if (!parsedRule.name) {
      return prev;
    }

    prev[parsedRule.name] = parsedRule.params;
    return prev;
  }, {});
};

/**
 * Emits a warning to the console.
 */
var warn = function (message) {
  console.warn(("[vee-validate] " + message)); // eslint-disable-line
};

/**
 * Creates a branded error object.
 */
var createError = function (message) { return new Error(("[vee-validate] " + message)); };

/**
 * Checks if the value is an object.
 */
var isObject = function (obj) { return obj !== null && obj && typeof obj === 'object' && ! Array.isArray(obj); };

/**
 * Checks if a function is callable.
 */
var isCallable = function (func) { return typeof func === 'function'; };

/**
 * Check if element has the css class on it.
 */
var hasClass = function (el, className) {
  if (el.classList) {
    return el.classList.contains(className);
  }

  return !!el.className.match(new RegExp(("(\\s|^)" + className + "(\\s|$)")));
};

/**
 * Adds the provided css className to the element.
 */
var addClass = function (el, className) {
  if (el.classList) {
    el.classList.add(className);
    return;
  }

  if (!hasClass(el, className)) {
    el.className += " " + className;
  }
};

/**
 * Remove the provided css className from the element.
 */
var removeClass = function (el, className) {
  if (el.classList) {
    el.classList.remove(className);
    return;
  }

  if (hasClass(el, className)) {
    var reg = new RegExp(("(\\s|^)" + className + "(\\s|$)"));
    el.className = el.className.replace(reg, ' ');
  }
};

/**
 * Adds or removes a class name on the input depending on the status flag.
 */
var toggleClass = function (el, className, status) {
  if (!el || !className) { return; }

  if (Array.isArray(className)) {
    className.forEach(function (item) { return toggleClass(el, item, status); });
    return;
  }

  if (status) {
    return addClass(el, className);
  }

  removeClass(el, className);
};

/**
 * Converts an array-like object to array, provides a simple polyfill for Array.from
 */
var toArray = function (arrayLike) {
  if (isCallable(Array.from)) {
    return Array.from(arrayLike);
  }

  var array = [];
  var length = arrayLike.length;
  /* istanbul ignore next */
  for (var i = 0; i < length; i++) {
    array.push(arrayLike[i]);
  }

  /* istanbul ignore next */
  return array;
};

/**
 * Converts an array-like object to array and place other elements in an array
 */
var ensureArray = function (arrayLike) {
  if (Array.isArray(arrayLike)) {
    return [].concat( arrayLike );
  }
  var array = toArray(arrayLike);
  return isEmptyArray(array) ? [arrayLike] : array;
};

/**
 * Assign polyfill from the mdn.
 */
var assign = function (target) {
  var others = [], len = arguments.length - 1;
  while ( len-- > 0 ) others[ len ] = arguments[ len + 1 ];

  /* istanbul ignore else */
  if (isCallable(Object.assign)) {
    return Object.assign.apply(Object, [ target ].concat( others ));
  }

  /* istanbul ignore next */
  if (target == null) {
    throw new TypeError('Cannot convert undefined or null to object');
  }

  /* istanbul ignore next */
  var to = Object(target);
  /* istanbul ignore next */
  others.forEach(function (arg) {
    // Skip over if undefined or null
    if (arg != null) {
      Object.keys(arg).forEach(function (key) {
        to[key] = arg[key];
      });
    }
  });
  /* istanbul ignore next */
  return to;
};

var id = 0;
var idTemplate = '{id}';

/**
 * Generates a unique id.
 */
var uniqId = function () {
  // handle too many uses of uniqId, although unlikely.
  if (id >= 9999) {
    id = 0;
    // shift the template.
    idTemplate = idTemplate.replace('{id}', '_{id}');
  }

  id++;
  var newId = idTemplate.replace('{id}', String(id));

  return newId;
};

var findIndex = function (arrayLike, predicate) {
  var array = Array.isArray(arrayLike) ? arrayLike : toArray(arrayLike);
  for (var i = 0; i < array.length; i++) {
    if (predicate(array[i])) {
      return i;
    }
  }

  return -1;
};

/**
 * finds the first element that satisfies the predicate callback, polyfills array.find
 */
var find = function (arrayLike, predicate) {
  var array = Array.isArray(arrayLike) ? arrayLike : toArray(arrayLike);
  var idx = findIndex(array, predicate);

  return idx === -1 ? undefined : array[idx];
};

var isBuiltInComponent = function (vnode) {
  if (!vnode) {
    return false;
  }

  var tag = vnode.componentOptions.tag;

  return /^(keep-alive|transition|transition-group)$/.test(tag);
};

var makeDelayObject = function (events, delay, delayConfig) {
  if (typeof delay === 'number') {
    return events.reduce(function (prev, e) {
      prev[e] = delay;
      return prev;
    }, {});
  }

  return events.reduce(function (prev, e) {
    if (typeof delay === 'object' && e in delay) {
      prev[e] = delay[e];
      return prev;
    }

    if (typeof delayConfig === 'number') {
      prev[e] = delayConfig;
      return prev;
    }

    prev[e] = (delayConfig && delayConfig[e]) || 0;

    return prev;
  }, {});
};

var deepParseInt = function (input) {
  if (typeof input === 'number') { return input; }

  if (typeof input === 'string') { return parseInt(input); }

  var map = {};
  for (var element in input) {
    map[element] = parseInt(input[element]);
  }

  return map;
};

var merge = function (target, source) {
  if (! (isObject(target) && isObject(source))) {
    return target;
  }

  Object.keys(source).forEach(function (key) {
    var obj, obj$1;

    if (isObject(source[key])) {
      if (! target[key]) {
        assign(target, ( obj = {}, obj[key] = {}, obj ));
      }

      merge(target[key], source[key]);
      return;
    }

    assign(target, ( obj$1 = {}, obj$1[key] = source[key], obj$1 ));
  });

  return target;
};

var fillRulesFromElement = function (el, rules) {
  if (el.required) {
    rules = appendRule('required', rules);
  }

  if (isTextInput(el)) {
    if (el.type === 'email') {
      rules = appendRule(("email" + (el.multiple ? ':multiple' : '')), rules);
    }

    if (el.pattern) {
      rules = appendRule({ regex: el.pattern }, rules);
    }

    // 524288 is the max on some browsers and test environments.
    if (el.maxLength >= 0 && el.maxLength < 524288) {
      rules = appendRule(("max:" + (el.maxLength)), rules);
    }

    if (el.minLength > 0) {
      rules = appendRule(("min:" + (el.minLength)), rules);
    }

    if (el.type === 'number') {
      rules = appendRule('decimal', rules);
      if (el.min !== '') {
        rules = appendRule(("min_value:" + (el.min)), rules);
      }

      if (el.max !== '') {
        rules = appendRule(("max_value:" + (el.max)), rules);
      }
    }

    return rules;
  }

  if (isDateInput(el)) {
    var timeFormat = el.step && Number(el.step) < 60 ? 'HH:mm:ss' : 'HH:mm';

    if (el.type === 'date') {
      return appendRule('date_format:yyyy-MM-dd', rules);
    }

    if (el.type === 'datetime-local') {
      return appendRule(("date_format:yyyy-MM-ddT" + timeFormat), rules);
    }

    if (el.type === 'month') {
      return appendRule('date_format:yyyy-MM', rules);
    }

    if (el.type === 'week') {
      return appendRule('date_format:yyyy-[W]WW', rules);
    }

    if (el.type === 'time') {
      return appendRule(("date_format:" + timeFormat), rules);
    }
  }

  return rules;
};

var values = function (obj) {
  if (isCallable(Object.values)) {
    return Object.values(obj);
  }

  // fallback to keys()
  /* istanbul ignore next */
  return Object.keys(obj).map(function (k) { return obj[k]; });
};

var parseSelector = function (selector) {
  var rule = null;
  if (includes(selector, ':')) {
    rule = selector.split(':').pop();
    selector = selector.replace((":" + rule), '');
  }

  if (selector[0] === '#') {
    return {
      id: selector.slice(1),
      rule: rule,
      name: null,
      scope: null
    };
  }

  var scope = null;
  var name = selector;
  if (includes(selector, '.')) {
    var parts = selector.split('.');
    scope = parts[0];
    name = parts.slice(1).join('.');
  }

  return {
    id: null,
    scope: scope,
    name: name,
    rule: rule
  };
};

var includes = function (collection, item) {
  return collection.indexOf(item) !== -1;
};

var isEmptyArray = function (arr) {
  return Array.isArray(arr) && arr.length === 0;
};

var defineNonReactive = function (obj, prop, value) {
  Object.defineProperty(obj, prop, {
    configurable: false,
    writable: true,
    value: value
  });
};

// 

var LOCALE = 'en';

var Dictionary = function Dictionary (dictionary) {
  if ( dictionary === void 0 ) dictionary = {};

  this.container = {};
  this.merge(dictionary);
};

var prototypeAccessors = { locale: { configurable: true } };

prototypeAccessors.locale.get = function () {
  return LOCALE;
};

prototypeAccessors.locale.set = function (value) {
  LOCALE = value || 'en';
};

Dictionary.prototype.hasLocale = function hasLocale (locale) {
  return !!this.container[locale];
};

Dictionary.prototype.setDateFormat = function setDateFormat (locale, format) {
  if (!this.container[locale]) {
    this.container[locale] = {};
  }

  this.container[locale].dateFormat = format;
};

Dictionary.prototype.getDateFormat = function getDateFormat (locale) {
  if (!this.container[locale] || !this.container[locale].dateFormat) {
    return null;
  }

  return this.container[locale].dateFormat;
};

Dictionary.prototype.getMessage = function getMessage (locale, key, data) {
  var message = null;
  if (!this.hasMessage(locale, key)) {
    message = this._getDefaultMessage(locale);
  } else {
    message = this.container[locale].messages[key];
  }

  return isCallable(message) ? message.apply(void 0, data) : message;
};

/**
 * Gets a specific message for field. falls back to the rule message.
 */
Dictionary.prototype.getFieldMessage = function getFieldMessage (locale, field, key, data) {
  if (!this.hasLocale(locale)) {
    return this.getMessage(locale, key, data);
  }

  var dict = this.container[locale].custom && this.container[locale].custom[field];
  if (!dict || !dict[key]) {
    return this.getMessage(locale, key, data);
  }

  var message = dict[key];
  return isCallable(message) ? message.apply(void 0, data) : message;
};

Dictionary.prototype._getDefaultMessage = function _getDefaultMessage (locale) {
  if (this.hasMessage(locale, '_default')) {
    return this.container[locale].messages._default;
  }

  return this.container.en.messages._default;
};

Dictionary.prototype.getAttribute = function getAttribute (locale, key, fallback) {
    if ( fallback === void 0 ) fallback = '';

  if (!this.hasAttribute(locale, key)) {
    return fallback;
  }

  return this.container[locale].attributes[key];
};

Dictionary.prototype.hasMessage = function hasMessage (locale, key) {
  return !! (
    this.hasLocale(locale) &&
          this.container[locale].messages &&
          this.container[locale].messages[key]
  );
};

Dictionary.prototype.hasAttribute = function hasAttribute (locale, key) {
  return !! (
    this.hasLocale(locale) &&
          this.container[locale].attributes &&
          this.container[locale].attributes[key]
  );
};

Dictionary.prototype.merge = function merge$1 (dictionary) {
  merge(this.container, dictionary);
};

Dictionary.prototype.setMessage = function setMessage (locale, key, message) {
  if (! this.hasLocale(locale)) {
    this.container[locale] = {
      messages: {},
      attributes: {}
    };
  }
    
  if (!this.container[locale].messages) {
    this.container[locale].messages = {};
  }

  this.container[locale].messages[key] = message;
};

Dictionary.prototype.setAttribute = function setAttribute (locale, key, attribute) {
  if (! this.hasLocale(locale)) {
    this.container[locale] = {
      messages: {},
      attributes: {}
    };
  }

  this.container[locale].attributes[key] = attribute;
};

Object.defineProperties( Dictionary.prototype, prototypeAccessors );

var drivers = {
  default: new Dictionary({
    en: {
      messages: {},
      attributes: {},
      custom: {}
    }
  })
};

var currentDriver = 'default';

var DictionaryResolver = function DictionaryResolver () {};

DictionaryResolver._checkDriverName = function _checkDriverName (driver) {
  if (!driver) {
    throw createError('you must provide a name to the dictionary driver');
  }
};

DictionaryResolver.setDriver = function setDriver (driver, implementation) {
    if ( implementation === void 0 ) implementation = null;

  this._checkDriverName(driver);
  if (implementation) {
    drivers[driver] = implementation;
  }

  currentDriver = driver;
};

DictionaryResolver.getDriver = function getDriver () {
  return drivers[currentDriver];
};

// 

var ErrorBag = function ErrorBag (errorBag, id) {
  if ( errorBag === void 0 ) errorBag = null;
  if ( id === void 0 ) id = null;

  this.vmId = id || null;
  // make this bag a mirror of the provided one, sharing the same items reference.
  if (errorBag && errorBag instanceof ErrorBag) {
    this.items = errorBag.items;
  } else {
    this.items = [];
  }
};

ErrorBag.prototype[typeof Symbol === 'function' ? Symbol.iterator : '@@iterator'] = function () {
    var this$1 = this;

  var index = 0;
  return {
    next: function () {
      return { value: this$1.items[index++], done: index > this$1.items.length };
    }
  };
};

/**
 * Adds an error to the internal array.
 */
ErrorBag.prototype.add = function add (error) {
    var ref;

  (ref = this.items).push.apply(
    ref, this._normalizeError(error)
  );
};

/**
 * Normalizes passed errors to an error array.
 */
ErrorBag.prototype._normalizeError = function _normalizeError (error) {
    var this$1 = this;

  if (Array.isArray(error)) {
    return error.map(function (e) {
      e.scope = !isNullOrUndefined(e.scope) ? e.scope : null;
      e.vmId = !isNullOrUndefined(e.vmId) ? e.vmId : (this$1.vmId || null);

      return e;
    });
  }

  error.scope = !isNullOrUndefined(error.scope) ? error.scope : null;
  error.vmId = !isNullOrUndefined(error.vmId) ? error.vmId : (this.vmId || null);

  return [error];
};

/**
 * Regenrates error messages if they have a generator function.
 */
ErrorBag.prototype.regenerate = function regenerate () {
  this.items.forEach(function (i) {
    i.msg = isCallable(i.regenerate) ? i.regenerate() : i.msg;
  });
};

/**
 * Updates a field error with the new field scope.
 */
ErrorBag.prototype.update = function update (id, error) {
  var item = find(this.items, function (i) { return i.id === id; });
  if (!item) {
    return;
  }

  var idx = this.items.indexOf(item);
  this.items.splice(idx, 1);
  item.scope = error.scope;
  this.items.push(item);
};

/**
 * Gets all error messages from the internal array.
 */
ErrorBag.prototype.all = function all (scope) {
    var this$1 = this;

  var filterFn = function (item) {
    var matchesScope = true;
    var matchesVM = true;
    if (!isNullOrUndefined(scope)) {
      matchesScope = item.scope === scope;
    }

    if (!isNullOrUndefined(this$1.vmId)) {
      matchesVM = item.vmId === this$1.vmId;
    }

    return matchesVM && matchesScope;
  };

  return this.items.filter(filterFn).map(function (e) { return e.msg; });
};

/**
 * Checks if there are any errors in the internal array.
 */
ErrorBag.prototype.any = function any (scope) {
    var this$1 = this;

  var filterFn = function (item) {
    var matchesScope = true;
    var matchesVM = true;
    if (!isNullOrUndefined(scope)) {
      matchesScope = item.scope === scope;
    }

    if (!isNullOrUndefined(this$1.vmId)) {
      matchesVM = item.vmId === this$1.vmId;
    }

    return matchesVM && matchesScope;
  };

  return !!this.items.filter(filterFn).length;
};

/**
 * Removes all items from the internal array.
 */
ErrorBag.prototype.clear = function clear (scope) {
    var this$1 = this;

  var matchesVM = isNullOrUndefined(this.vmId) ? function () { return true; } : function (i) { return i.vmId === this$1.vmId; };
  var matchesScope = function (i) { return i.scope === scope; };
  if (arguments.length === 0) {
    matchesScope = function () { return true; };
  } else if (isNullOrUndefined(scope)) {
    scope = null;
  }

  for (var i = 0; i < this.items.length; ++i) {
    if (matchesVM(this.items[i]) && matchesScope(this.items[i])) {
      this.items.splice(i, 1);
      --i;
    }
  }
};

/**
 * Collects errors into groups or for a specific field.
 */
ErrorBag.prototype.collect = function collect (field, scope, map) {
    var this$1 = this;
    if ( map === void 0 ) map = true;

  var isSingleField = !isNullOrUndefined(field) && !field.includes('*');
  var groupErrors = function (items) {
    var errors = items.reduce(function (collection, error) {
      if (!isNullOrUndefined(this$1.vmId) && error.vmId !== this$1.vmId) {
        return collection;
      }

      if (!collection[error.field]) {
        collection[error.field] = [];
      }

      collection[error.field].push(map ? error.msg : error);

      return collection;
    }, {});

    // reduce the collection to be a single array.
    if (isSingleField) {
      return values(errors)[0] || [];
    }

    return errors;
  };

  if (isNullOrUndefined(field)) {
    return groupErrors(this.items);
  }

  var selector = isNullOrUndefined(scope) ? String(field) : (scope + "." + field);
  var ref = this._makeCandidateFilters(selector);
    var isPrimary = ref.isPrimary;
    var isAlt = ref.isAlt;

  var collected = this.items.reduce(function (prev, curr) {
    if (isPrimary(curr)) {
      prev.primary.push(curr);
    }

    if (isAlt(curr)) {
      prev.alt.push(curr);
    }

    return prev;
  }, { primary: [], alt: [] });

  collected = collected.primary.length ? collected.primary : collected.alt;

  return groupErrors(collected);
};

/**
 * Gets the internal array length.
 */
ErrorBag.prototype.count = function count () {
    var this$1 = this;

  if (this.vmId) {
    return this.items.filter(function (e) { return e.vmId === this$1.vmId; }).length;
  }

  return this.items.length;
};

/**
 * Finds and fetches the first error message for the specified field id.
 */
ErrorBag.prototype.firstById = function firstById (id) {
  var error = find(this.items, function (i) { return i.id === id; });

  return error ? error.msg : undefined;
};

/**
 * Gets the first error message for a specific field.
 */
ErrorBag.prototype.first = function first (field, scope) {
    if ( scope === void 0 ) scope = null;

  var selector = isNullOrUndefined(scope) ? field : (scope + "." + field);
  var match = this._match(selector);

  return match && match.msg;
};

/**
 * Returns the first error rule for the specified field
 */
ErrorBag.prototype.firstRule = function firstRule (field, scope) {
  var errors = this.collect(field, scope, false);

  return (errors.length && errors[0].rule) || undefined;
};

/**
 * Checks if the internal array has at least one error for the specified field.
 */
ErrorBag.prototype.has = function has (field, scope) {
    if ( scope === void 0 ) scope = null;

  return !!this.first(field, scope);
};

/**
 * Gets the first error message for a specific field and a rule.
 */
ErrorBag.prototype.firstByRule = function firstByRule (name, rule, scope) {
    if ( scope === void 0 ) scope = null;

  var error = this.collect(name, scope, false).filter(function (e) { return e.rule === rule; })[0];

  return (error && error.msg) || undefined;
};

/**
 * Gets the first error message for a specific field that not match the rule.
 */
ErrorBag.prototype.firstNot = function firstNot (name, rule, scope) {
    if ( rule === void 0 ) rule = 'required';
    if ( scope === void 0 ) scope = null;

  var error = this.collect(name, scope, false).filter(function (e) { return e.rule !== rule; })[0];

  return (error && error.msg) || undefined;
};

/**
 * Removes errors by matching against the id or ids.
 */
ErrorBag.prototype.removeById = function removeById (id) {
  var condition = function (item) { return item.id === id; };
  if (Array.isArray(id)) {
    condition = function (item) { return id.indexOf(item.id) !== -1; };
  }

  for (var i = 0; i < this.items.length; ++i) {
    if (condition(this.items[i])) {
      this.items.splice(i, 1);
      --i;
    }
  }
};

/**
 * Removes all error messages associated with a specific field.
 */
ErrorBag.prototype.remove = function remove (field, scope, vmId) {
  if (isNullOrUndefined(field)) {
    return;
  }

  var selector = isNullOrUndefined(scope) ? String(field) : (scope + "." + field);
  var ref = this._makeCandidateFilters(selector);
    var isPrimary = ref.isPrimary;
    var isAlt = ref.isAlt;
  var matches = function (item) { return isPrimary(item) || isAlt(item); };
  var shouldRemove = function (item) {
    if (isNullOrUndefined(vmId)) { return matches(item); }

    return matches(item) && item.vmId === vmId;
  };

  for (var i = 0; i < this.items.length; ++i) {
    if (shouldRemove(this.items[i])) {
      this.items.splice(i, 1);
      --i;
    }
  }
};

ErrorBag.prototype._makeCandidateFilters = function _makeCandidateFilters (selector) {
    var this$1 = this;

  var matchesRule = function () { return true; };
  var matchesScope = function () { return true; };
  var matchesName = function () { return true; };
  var matchesVM = function () { return true; };

  var ref = parseSelector(selector);
    var id = ref.id;
    var rule = ref.rule;
    var scope = ref.scope;
    var name = ref.name;

  if (rule) {
    matchesRule = function (item) { return item.rule === rule; };
  }

  // match by id, can be combined with rule selection.
  if (id) {
    return {
      isPrimary: function (item) { return matchesRule(item) && (function (item) { return id === item.id; }); },
      isAlt: function () { return false; }
    };
  }

  if (isNullOrUndefined(scope)) {
    // if no scope specified, make sure the found error has no scope.
    matchesScope = function (item) { return isNullOrUndefined(item.scope); };
  } else {
    matchesScope = function (item) { return item.scope === scope; };
  }

  if (!isNullOrUndefined(name) && name !== '*') {
    matchesName = function (item) { return item.field === name; };
  }

  if (!isNullOrUndefined(this.vmId)) {
    matchesVM = function (item) { return item.vmId === this$1.vmId; };
  }

  // matches the first candidate.
  var isPrimary = function (item) {
    return matchesVM(item) && matchesName(item) && matchesRule(item) && matchesScope(item);
  };

  // matches a second candidate, which is a field with a name containing the '.' character.
  var isAlt = function (item) {
    return matchesVM(item) && matchesRule(item) && item.field === (scope + "." + name);
  };

  return {
    isPrimary: isPrimary,
    isAlt: isAlt
  };
};

ErrorBag.prototype._match = function _match (selector) {
  if (isNullOrUndefined(selector)) {
    return undefined;
  }

  var ref = this._makeCandidateFilters(selector);
    var isPrimary = ref.isPrimary;
    var isAlt = ref.isAlt;

  return this.items.reduce(function (prev, item, idx, arr) {
    var isLast = idx === arr.length - 1;
    if (prev.primary) {
      return isLast ? prev.primary : prev;
    }

    if (isPrimary(item)) {
      prev.primary = item;
    }

    if (isAlt(item)) {
      prev.alt = item;
    }

    // keep going.
    if (!isLast) {
      return prev;
    }

    return prev.primary || prev.alt;
  }, {});
};

var DEFAULT_CONFIG = {
  locale: 'en',
  delay: 0,
  errorBagName: 'errors',
  dictionary: null,
  fieldsBagName: 'fields',
  classes: false,
  classNames: null,
  events: 'input',
  inject: true,
  fastExit: true,
  aria: true,
  validity: false,
  mode: 'aggressive',
  useConstraintAttrs: true,
  i18n: null,
  i18nRootKey: 'validation'
};

var currentConfig = assign({}, DEFAULT_CONFIG);

var resolveConfig = function (ctx) {
  var selfConfig = getPath('$options.$_veeValidate', ctx, {});

  return assign({}, currentConfig, selfConfig);
};

var getConfig = function () { return currentConfig; };

var setConfig = function (newConf) {
  currentConfig = assign({}, currentConfig, newConf);
};

// VNode Utils

// Gets the model object on the vnode.
function findModel (vnode) {
  if (!vnode.data) {
    return null;
  }

  // Component Model
  if (vnode.data.model) {
    return vnode.data.model;
  }

  return !!(vnode.data.directives) && find(vnode.data.directives, function (d) { return d.name === 'model'; });
}

function extractChildren (vnode) {
  if (Array.isArray(vnode)) {
    return vnode;
  }

  if (Array.isArray(vnode.children)) {
    return vnode.children;
  }

  if (vnode.componentOptions && Array.isArray(vnode.componentOptions.children)) {
    return vnode.componentOptions.children;
  }

  return [];
}

function extractVNodes (vnode) {
  if (findModel(vnode)) {
    return [vnode];
  }

  var children = extractChildren(vnode);

  return children.reduce(function (nodes, node) {
    var candidates = extractVNodes(node);
    if (candidates.length) {
      nodes.push.apply(nodes, candidates);
    }

    return nodes;
  }, []);
}

// Resolves v-model config if exists.
function findModelConfig (vnode) {
  if (!vnode.componentOptions) { return null; }

  return vnode.componentOptions.Ctor.options.model;
}
// Adds a listener to vnode listener object.
function mergeVNodeListeners (obj, eventName, handler) {
  // Has a single listener, convert to array.
  if (isCallable(obj[eventName])) {
    var prevHandler = obj[eventName];
    obj[eventName] = [prevHandler];
  }

  // no listeners, create the array.
  if (isNullOrUndefined(obj[eventName])) {
    obj[eventName] = [];
  }

  obj[eventName].push(handler);
}

// Adds a listener to a native HTML vnode.
function addNativeNodeListener (node, eventName, handler) {
  if (isNullOrUndefined(node.data.on)) {
    node.data.on = {};
  }

  mergeVNodeListeners(node.data.on, eventName, handler);
}

// Adds a listener to a Vue component vnode.
function addComponentNodeListener (node, eventName, handler) {
  /* istanbul ignore next */
  if (!node.componentOptions.listeners) {
    node.componentOptions.listeners = {};
  }

  mergeVNodeListeners(node.componentOptions.listeners, eventName, handler);
}
function addVNodeListener (vnode, eventName, handler) {
  if (vnode.componentOptions) {
    addComponentNodeListener(vnode, eventName, handler);
    return;
  }

  addNativeNodeListener(vnode, eventName, handler);
}
// Determines if `change` should be used over `input` for listeners.
function getInputEventName (vnode, model) {
  // Is a component.
  if (vnode.componentOptions) {
    var ref = findModelConfig(vnode) || { event: 'input' };
    var event = ref.event;

    return event;
  }

  // Lazy Models and select tag typically use change event
  if ((model && model.modifiers && model.modifiers.lazy) || vnode.tag === 'select') {
    return 'change';
  }

  // is a textual-type input.
  if (vnode.data.attrs && isTextInput({ type: vnode.data.attrs.type || 'text' })) {
    return 'input';
  }

  return 'change';
}

function normalizeSlots (slots, ctx) {
  return Object.keys(slots).reduce(function (arr, key) {
    slots[key].forEach(function (vnode) {
      if (!vnode.context) {
        slots[key].context = ctx;
        if (!vnode.data) {
          vnode.data = {};
        }
        vnode.data.slot = key;
      }
    });

    return arr.concat(slots[key]);
  }, []);
}
function createRenderless (h, children) {
  // Only render the first item of the node.
  if (Array.isArray(children) && children[0]) {
    return children[0];
  }

  // a single node.
  if (children) {
    return children;
  }

  // No slots, render nothing.
  return h();
}

/**
 * Generates the options required to construct a field.
 */
var Resolver = function Resolver () {};

Resolver.generate = function generate (el, binding, vnode) {
  var model = Resolver.resolveModel(binding, vnode);
  var options = resolveConfig(vnode.context);

  return {
    name: Resolver.resolveName(el, vnode),
    el: el,
    listen: !binding.modifiers.disable,
    bails: binding.modifiers.bails ? true : (binding.modifiers.continues === true ? false : undefined),
    scope: Resolver.resolveScope(el, binding, vnode),
    vm: vnode.context,
    expression: binding.value,
    component: vnode.componentInstance,
    classes: options.classes,
    classNames: options.classNames,
    getter: Resolver.resolveGetter(el, vnode, model),
    events: Resolver.resolveEvents(el, vnode) || options.events,
    model: model,
    delay: Resolver.resolveDelay(el, vnode, options),
    rules: Resolver.resolveRules(el, binding, vnode),
    immediate: !!binding.modifiers.initial || !!binding.modifiers.immediate,
    persist: !!binding.modifiers.persist,
    validity: options.validity && !vnode.componentInstance,
    aria: options.aria && !vnode.componentInstance,
    initialValue: Resolver.resolveInitialValue(vnode)
  };
};

Resolver.getCtorConfig = function getCtorConfig (vnode) {
  if (!vnode.componentInstance) { return null; }

  var config = getPath('componentInstance.$options.$_veeValidate', vnode);

  return config;
};

/**
 * Resolves the rules defined on an element.
 */
Resolver.resolveRules = function resolveRules (el, binding, vnode) {
  var rules = '';
  if (!binding.value && (!binding || !binding.expression)) {
    rules = getDataAttribute(el, 'rules');
  }

  if (binding.value && includes(['string', 'object'], typeof binding.value.rules)) {
    rules = binding.value.rules;
  } else if (binding.value) {
    rules = binding.value;
  }

  if (vnode.componentInstance) {
    return rules;
  }

  // If validity is disabled, ignore field rules.
  var normalized = normalizeRules(rules);
  if (!getConfig().useConstraintAttrs) {
    return normalized;
  }

  return assign({}, fillRulesFromElement(el, {}), normalized);
};

/**
 * @param {*} vnode
 */
Resolver.resolveInitialValue = function resolveInitialValue (vnode) {
  var model = vnode.data.model || find(vnode.data.directives, function (d) { return d.name === 'model'; });

  return model && model.value;
};

/**
 * Resolves the delay value.
 * @param {*} el
 * @param {*} vnode
 * @param {Object} options
 */
Resolver.resolveDelay = function resolveDelay (el, vnode, options) {
  var delay = getDataAttribute(el, 'delay');
  var globalDelay = (options && 'delay' in options) ? options.delay : 0;

  if (!delay && vnode.componentInstance && vnode.componentInstance.$attrs) {
    delay = vnode.componentInstance.$attrs['data-vv-delay'];
  }

  if (!isObject(globalDelay)) {
    return deepParseInt(delay || globalDelay);
  }

  if (!isNullOrUndefined(delay)) {
    globalDelay.input = delay;
  }

  return deepParseInt(globalDelay);
};

/**
 * Resolves the events to validate in response to.
 * @param {*} el
 * @param {*} vnode
 */
Resolver.resolveEvents = function resolveEvents (el, vnode) {
  // resolve it from the root element.
  var events = getDataAttribute(el, 'validate-on');

  // resolve from data-vv-validate-on if its a vue component.
  if (!events && vnode.componentInstance && vnode.componentInstance.$attrs) {
    events = vnode.componentInstance.$attrs['data-vv-validate-on'];
  }

  // resolve it from $_veeValidate options.
  if (!events && vnode.componentInstance) {
    var config = Resolver.getCtorConfig(vnode);
    events = config && config.events;
  }

  if (!events && getConfig().events) {
    events = getConfig().events;
  }

  // resolve the model event if its configured for custom components.
  if (events && vnode.componentInstance && includes(events, 'input')) {
    var ref = vnode.componentInstance.$options.model || { event: 'input' };
      var event = ref.event;
    // if the prop was configured but not the model.
    if (!event) {
      return events;
    }

    events = events.replace('input', event);
  }

  return events;
};

/**
 * Resolves the scope for the field.
 * @param {*} el
 * @param {*} binding
 */
Resolver.resolveScope = function resolveScope (el, binding, vnode) {
    if ( vnode === void 0 ) vnode = {};

  var scope = null;
  if (vnode.componentInstance && isNullOrUndefined(scope)) {
    scope = vnode.componentInstance.$attrs && vnode.componentInstance.$attrs['data-vv-scope'];
  }

  return !isNullOrUndefined(scope) ? scope : getScope(el);
};

/**
 * Checks if the node directives contains a v-model or a specified arg.
 * Args take priority over models.
 *
 * @return {Object}
 */
Resolver.resolveModel = function resolveModel (binding, vnode) {
  if (binding.arg) {
    return { expression: binding.arg };
  }

  var model = findModel(vnode);
  if (!model) {
    return null;
  }

  // https://github.com/vuejs/vue/blob/dev/src/core/util/lang.js#L26
  var watchable = !/[^\w.$]/.test(model.expression) && hasPath(model.expression, vnode.context);
  var lazy = !!(model.modifiers && model.modifiers.lazy);

  if (!watchable) {
    return { expression: null, lazy: lazy };
  }

  return { expression: model.expression, lazy: lazy };
};

/**
 * Resolves the field name to trigger validations.
 * @return {String} The field name.
 */
Resolver.resolveName = function resolveName (el, vnode) {
  var name = getDataAttribute(el, 'name');

  if (!name && !vnode.componentInstance) {
    return el.name;
  }

  if (!name && vnode.componentInstance && vnode.componentInstance.$attrs) {
    name = vnode.componentInstance.$attrs['data-vv-name'] || vnode.componentInstance.$attrs['name'];
  }

  if (!name && vnode.componentInstance) {
    var config = Resolver.getCtorConfig(vnode);
    if (config && isCallable(config.name)) {
      var boundGetter = config.name.bind(vnode.componentInstance);

      return boundGetter();
    }

    return vnode.componentInstance.name;
  }

  return name;
};

/**
 * Returns a value getter input type.
 */
Resolver.resolveGetter = function resolveGetter (el, vnode, model) {
  if (model && model.expression) {
    return function () {
      return getPath(model.expression, vnode.context);
    };
  }

  if (vnode.componentInstance) {
    var path = getDataAttribute(el, 'value-path') || (vnode.componentInstance.$attrs && vnode.componentInstance.$attrs['data-vv-value-path']);
    if (path) {
      return function () {
        return getPath(path, vnode.componentInstance);
      };
    }

    var config = Resolver.getCtorConfig(vnode);
    if (config && isCallable(config.value)) {
      var boundGetter = config.value.bind(vnode.componentInstance);

      return function () {
        return boundGetter();
      };
    }

    var ref = vnode.componentInstance.$options.model || { prop: 'value' };
      var prop = ref.prop;

    return function () {
      return vnode.componentInstance[prop];
    };
  }

  switch (el.type) {
  case 'checkbox': return function () {
    var els = document.querySelectorAll(("input[name=\"" + (el.name) + "\"]"));

    els = toArray(els).filter(function (el) { return el.checked; });
    if (!els.length) { return undefined; }

    return els.map(function (checkbox) { return checkbox.value; });
  };
  case 'radio': return function () {
    var els = document.querySelectorAll(("input[name=\"" + (el.name) + "\"]"));
    var elm = find(els, function (el) { return el.checked; });

    return elm && elm.value;
  };
  case 'file': return function (context) {
    return toArray(el.files);
  };
  case 'select-multiple': return function () {
    return toArray(el.options).filter(function (opt) { return opt.selected; }).map(function (opt) { return opt.value; });
  };
  default: return function () {
    return el && el.value;
  };
  }
};

var RULES = {};

var RuleContainer = function RuleContainer () {};

var staticAccessors = { rules: { configurable: true } };

RuleContainer.add = function add (name, ref) {
    var validate = ref.validate;
    var options = ref.options;
    var paramNames = ref.paramNames;

  RULES[name] = {
    validate: validate,
    options: options,
    paramNames: paramNames
  };
};

staticAccessors.rules.get = function () {
  return RULES;
};

RuleContainer.has = function has (name) {
  return !!RULES[name];
};

RuleContainer.isImmediate = function isImmediate (name) {
  return !!(RULES[name] && RULES[name].options.immediate);
};

RuleContainer.isRequireRule = function isRequireRule (name) {
  return !!(RULES[name] && RULES[name].options.computesRequired);
};

RuleContainer.isTargetRule = function isTargetRule (name) {
  return !!(RULES[name] && RULES[name].options.hasTarget);
};

RuleContainer.remove = function remove (ruleName) {
  delete RULES[ruleName];
};

RuleContainer.getParamNames = function getParamNames (ruleName) {
  return RULES[ruleName] && RULES[ruleName].paramNames;
};

RuleContainer.getOptions = function getOptions (ruleName) {
  return RULES[ruleName] && RULES[ruleName].options;
};

RuleContainer.getValidatorMethod = function getValidatorMethod (ruleName) {
  return RULES[ruleName] ? RULES[ruleName].validate : null;
};

Object.defineProperties( RuleContainer, staticAccessors );

// 

var isEvent = function (evt) {
  return (typeof Event !== 'undefined' && isCallable(Event) && evt instanceof Event) || (evt && evt.srcElement);
};

var normalizeEvents = function (evts) {
  if (!evts) { return []; }

  return (typeof evts === 'string' ? evts.split('|') : evts);
};

var supportsPassive = true;

var detectPassiveSupport = function () {
  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get () {
        supportsPassive = true;
      }
    });
    window.addEventListener('testPassive', null, opts);
    window.removeEventListener('testPassive', null, opts);
  } catch (e) {
    supportsPassive = false;
  }
  return supportsPassive;
};

var addEventListener = function (el, eventName, cb) {
  el.addEventListener(eventName, cb, supportsPassive ? { passive: true } : false);
};

// 

var DEFAULT_OPTIONS = {
  targetOf: null,
  immediate: false,
  persist: false,
  scope: null,
  listen: true,
  name: null,
  rules: {},
  vm: null,
  classes: false,
  validity: true,
  aria: true,
  events: 'input|blur',
  delay: 0,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  }
};

var Field = function Field (options) {
  if ( options === void 0 ) options = {};

  this.id = uniqId();
  this.el = options.el;
  this.updated = false;
  this.vmId = options.vmId;
  defineNonReactive(this, 'dependencies', []);
  defineNonReactive(this, 'watchers', []);
  defineNonReactive(this, 'events', []);
  this.delay = 0;
  this.rules = {};
  this.forceRequired = false;
  this._cacheId(options);
  this.classNames = assign({}, DEFAULT_OPTIONS.classNames);
  options = assign({}, DEFAULT_OPTIONS, options);
  this._delay = !isNullOrUndefined(options.delay) ? options.delay : 0; // cache initial delay
  this.validity = options.validity;
  this.aria = options.aria;
  this.flags = options.flags || createFlags();
  defineNonReactive(this, 'vm', options.vm);
  defineNonReactive(this, 'componentInstance', options.component);
  this.ctorConfig = this.componentInstance ? getPath('$options.$_veeValidate', this.componentInstance) : undefined;
  this.update(options);
  // set initial value.
  this.initialValue = this.value;
  this.updated = false;
};

var prototypeAccessors$1 = { validator: { configurable: true },isRequired: { configurable: true },isDisabled: { configurable: true },alias: { configurable: true },value: { configurable: true },bails: { configurable: true },rejectsFalse: { configurable: true } };

prototypeAccessors$1.validator.get = function () {
  if (!this.vm || !this.vm.$validator) {
    return { validate: function () { return Promise.resolve(true); } };
  }

  return this.vm.$validator;
};

prototypeAccessors$1.isRequired.get = function () {
  return !!this.rules.required || this.forceRequired;
};

prototypeAccessors$1.isDisabled.get = function () {
  return !!(this.el && this.el.disabled);
};

/**
 * Gets the display name (user-friendly name).
 */
prototypeAccessors$1.alias.get = function () {
  if (this._alias) {
    return this._alias;
  }

  var alias = null;
  if (this.ctorConfig && this.ctorConfig.alias) {
    alias = isCallable(this.ctorConfig.alias) ? this.ctorConfig.alias.call(this.componentInstance) : this.ctorConfig.alias;
  }

  if (!alias && this.el) {
    alias = getDataAttribute(this.el, 'as');
  }

  if (!alias && this.componentInstance) {
    return this.componentInstance.$attrs && this.componentInstance.$attrs['data-vv-as'];
  }

  return alias;
};

/**
 * Gets the input value.
 */

prototypeAccessors$1.value.get = function () {
  if (!isCallable(this.getter)) {
    return undefined;
  }

  return this.getter();
};

prototypeAccessors$1.bails.get = function () {
  return this._bails;
};

/**
 * If the field rejects false as a valid value for the required rule.
 */

prototypeAccessors$1.rejectsFalse.get = function () {
  if (this.componentInstance && this.ctorConfig) {
    return !!this.ctorConfig.rejectsFalse;
  }

  if (!this.el) {
    return false;
  }

  return this.el.type === 'checkbox';
};

/**
 * Determines if the instance matches the options provided.
 */
Field.prototype.matches = function matches (options) {
    var this$1 = this;

  if (!options) {
    return true;
  }

  if (options.id) {
    return this.id === options.id;
  }

  var matchesComponentId = isNullOrUndefined(options.vmId) ? function () { return true; } : function (id) { return id === this$1.vmId; };
  if (!matchesComponentId(options.vmId)) {
    return false;
  }

  if (options.name === undefined && options.scope === undefined) {
    return true;
  }

  if (options.scope === undefined) {
    return this.name === options.name;
  }

  if (options.name === undefined) {
    return this.scope === options.scope;
  }

  return options.name === this.name && options.scope === this.scope;
};

/**
 * Caches the field id.
 */
Field.prototype._cacheId = function _cacheId (options) {
  if (this.el && !options.targetOf) {
    this.el._veeValidateId = this.id;
  }
};

/**
 * Keeps a reference of the most current validation run.
 */
Field.prototype.waitFor = function waitFor (pendingPromise) {
  this._waitingFor = pendingPromise;
};

Field.prototype.isWaitingFor = function isWaitingFor (promise) {
  return this._waitingFor === promise;
};

/**
 * Updates the field with changed data.
 */
Field.prototype.update = function update (options) {
    var this$1 = this;

  this.targetOf = options.targetOf || null;
  this.immediate = options.immediate || this.immediate || false;
  this.persist = options.persist || this.persist || false;

  // update errors scope if the field scope was changed.
  if (!isNullOrUndefined(options.scope) && options.scope !== this.scope && isCallable(this.validator.update)) {
    this.validator.update(this.id, { scope: options.scope });
  }
  this.scope = !isNullOrUndefined(options.scope) ? options.scope
    : !isNullOrUndefined(this.scope) ? this.scope : null;
  this.name = (!isNullOrUndefined(options.name) ? String(options.name) : options.name) || this.name || null;
  this.rules = options.rules !== undefined ? normalizeRules(options.rules) : this.rules;
  this._bails = options.bails !== undefined ? options.bails : this._bails;
  this.model = options.model || this.model;
  this.listen = options.listen !== undefined ? options.listen : this.listen;
  this.classes = (options.classes || this.classes || false) && !this.componentInstance;
  this.classNames = isObject(options.classNames) ? merge(this.classNames, options.classNames) : this.classNames;
  this.getter = isCallable(options.getter) ? options.getter : this.getter;
  this._alias = options.alias || this._alias;
  this.events = (options.events) ? normalizeEvents(options.events) : this.events;
  this.delay = makeDelayObject(this.events, options.delay || this.delay, this._delay);
  this.updateDependencies();
  this.addActionListeners();

  if (false) {
    warn('A field is missing a "name" or "data-vv-name" attribute');
  }

  // update required flag flags
  if (options.rules !== undefined) {
    this.flags.required = this.isRequired;
  }

  if (Object.keys(options.rules || {}).length === 0 && this.updated) {
    var resetFlag = this.flags.validated;
    this.validator.validate(("#" + (this.id))).then(function () {
      this$1.flags.validated = resetFlag;
    });
  }

  // validate if it was validated before and field was updated and there was a rules mutation.
  if (this.flags.validated && options.rules !== undefined && this.updated) {
    this.validator.validate(("#" + (this.id)));
  }

  this.updated = true;
  this.addValueListeners();

  // no need to continue.
  if (!this.el) {
    return;
  }
  this.updateClasses();
  this.updateAriaAttrs();
};

/**
 * Resets field flags and errors.
 */
Field.prototype.reset = function reset () {
    var this$1 = this;

  if (this._cancellationToken) {
    this._cancellationToken.cancelled = true;
    delete this._cancellationToken;
  }

  var defaults = createFlags();
  Object.keys(this.flags).filter(function (flag) { return flag !== 'required'; }).forEach(function (flag) {
    this$1.flags[flag] = defaults[flag];
  });

  // update initial value
  this.initialValue = this.value;
  this.flags.changed = false;

  this.addValueListeners();
  this.addActionListeners();
  this.updateClasses(true);
  this.updateAriaAttrs();
  this.updateCustomValidity();
};

/**
 * Sets the flags and their negated counterparts, and updates the classes and re-adds action listeners.
 */
Field.prototype.setFlags = function setFlags (flags) {
    var this$1 = this;

  var negated = {
    pristine: 'dirty',
    dirty: 'pristine',
    valid: 'invalid',
    invalid: 'valid',
    touched: 'untouched',
    untouched: 'touched'
  };

  Object.keys(flags).forEach(function (flag) {
    this$1.flags[flag] = flags[flag];
    // if it has a negation and was not specified, set it as well.
    if (negated[flag] && flags[negated[flag]] === undefined) {
      this$1.flags[negated[flag]] = !flags[flag];
    }
  });

  if (
    flags.untouched !== undefined ||
    flags.touched !== undefined ||
    flags.dirty !== undefined ||
    flags.pristine !== undefined
  ) {
    this.addActionListeners();
  }
  this.updateClasses();
  this.updateAriaAttrs();
  this.updateCustomValidity();
};

/**
 * Determines if the field requires references to target fields.
*/
Field.prototype.updateDependencies = function updateDependencies () {
    var this$1 = this;

  // reset dependencies.
  this.dependencies.forEach(function (d) { return d.field.destroy(); });
  this.dependencies = [];

  // we get the selectors for each field.
  var fields = Object.keys(this.rules).reduce(function (prev, r) {
    if (RuleContainer.isTargetRule(r)) {
      prev.push({ selector: this$1.rules[r][0], name: r });
    }

    return prev;
  }, []);

  if (!fields.length || !this.vm || !this.vm.$el) { return; }

  // must be contained within the same component, so we use the vm root element constrain our dom search.
  fields.forEach(function (ref$1) {
      var selector = ref$1.selector;
      var name = ref$1.name;

    var ref = this$1.vm.$refs[selector];
    var el = Array.isArray(ref) ? ref[0] : ref;
    if (!el) {
      return;
    }

    var options = {
      vm: this$1.vm,
      classes: this$1.classes,
      classNames: this$1.classNames,
      delay: this$1.delay,
      scope: this$1.scope,
      events: this$1.events.join('|'),
      immediate: this$1.immediate,
      targetOf: this$1.id
    };

    // probably a component.
    if (isCallable(el.$watch)) {
      options.component = el;
      options.el = el.$el;
      options.getter = Resolver.resolveGetter(el.$el, el.$vnode);
    } else {
      options.el = el;
      options.getter = Resolver.resolveGetter(el, {});
    }

    this$1.dependencies.push({ name: name, field: new Field(options) });
  });
};

/**
 * Removes listeners.
 */
Field.prototype.unwatch = function unwatch (tag) {
    if ( tag === void 0 ) tag = null;

  if (!tag) {
    this.watchers.forEach(function (w) { return w.unwatch(); });
    this.watchers = [];
    return;
  }

  this.watchers.filter(function (w) { return tag.test(w.tag); }).forEach(function (w) { return w.unwatch(); });
  this.watchers = this.watchers.filter(function (w) { return !tag.test(w.tag); });
};

/**
 * Updates the element classes depending on each field flag status.
 */
Field.prototype.updateClasses = function updateClasses (isReset) {
    var this$1 = this;
    if ( isReset === void 0 ) isReset = false;

  if (!this.classes || this.isDisabled) { return; }
  var applyClasses = function (el) {
    toggleClass(el, this$1.classNames.dirty, this$1.flags.dirty);
    toggleClass(el, this$1.classNames.pristine, this$1.flags.pristine);
    toggleClass(el, this$1.classNames.touched, this$1.flags.touched);
    toggleClass(el, this$1.classNames.untouched, this$1.flags.untouched);

    // remove valid/invalid classes on reset.
    if (isReset) {
      toggleClass(el, this$1.classNames.valid, false);
      toggleClass(el, this$1.classNames.invalid, false);
    }

    // make sure we don't set any classes if the state is undetermined.
    if (!isNullOrUndefined(this$1.flags.valid) && this$1.flags.validated) {
      toggleClass(el, this$1.classNames.valid, this$1.flags.valid);
    }

    if (!isNullOrUndefined(this$1.flags.invalid) && this$1.flags.validated) {
      toggleClass(el, this$1.classNames.invalid, this$1.flags.invalid);
    }
  };

  if (!isCheckboxOrRadioInput(this.el)) {
    applyClasses(this.el);
    return;
  }

  var els = document.querySelectorAll(("input[name=\"" + (this.el.name) + "\"]"));
  toArray(els).forEach(applyClasses);
};

/**
 * Adds the listeners required for automatic classes and some flags.
 */
Field.prototype.addActionListeners = function addActionListeners () {
    var this$1 = this;

  // remove previous listeners.
  this.unwatch(/class/);

  if (!this.el) { return; }

  var onBlur = function () {
    this$1.flags.touched = true;
    this$1.flags.untouched = false;
    if (this$1.classes) {
      toggleClass(this$1.el, this$1.classNames.touched, true);
      toggleClass(this$1.el, this$1.classNames.untouched, false);
    }

    // only needed once.
    this$1.unwatch(/^class_blur$/);
  };

  var inputEvent = isTextInput(this.el) ? 'input' : 'change';
  var onInput = function () {
    this$1.flags.dirty = true;
    this$1.flags.pristine = false;
    if (this$1.classes) {
      toggleClass(this$1.el, this$1.classNames.pristine, false);
      toggleClass(this$1.el, this$1.classNames.dirty, true);
    }

    // only needed once.
    this$1.unwatch(/^class_input$/);
  };

  if (this.componentInstance && isCallable(this.componentInstance.$once)) {
    this.componentInstance.$once('input', onInput);
    this.componentInstance.$once('blur', onBlur);
    this.watchers.push({
      tag: 'class_input',
      unwatch: function () {
        this$1.componentInstance.$off('input', onInput);
      }
    });
    this.watchers.push({
      tag: 'class_blur',
      unwatch: function () {
        this$1.componentInstance.$off('blur', onBlur);
      }
    });
    return;
  }

  if (!this.el) { return; }

  addEventListener(this.el, inputEvent, onInput);
  // Checkboxes and radio buttons on Mac don't emit blur naturally, so we listen on click instead.
  var blurEvent = isCheckboxOrRadioInput(this.el) ? 'change' : 'blur';
  addEventListener(this.el, blurEvent, onBlur);
  this.watchers.push({
    tag: 'class_input',
    unwatch: function () {
      this$1.el.removeEventListener(inputEvent, onInput);
    }
  });

  this.watchers.push({
    tag: 'class_blur',
    unwatch: function () {
      this$1.el.removeEventListener(blurEvent, onBlur);
    }
  });
};

Field.prototype.checkValueChanged = function checkValueChanged () {
  // handle some people initialize the value to null, since text inputs have empty string value.
  if (this.initialValue === null && this.value === '' && isTextInput(this.el)) {
    return false;
  }

  return this.value !== this.initialValue;
};

/**
 * Determines the suitable primary event to listen for.
 */
Field.prototype._determineInputEvent = function _determineInputEvent () {
  // if its a custom component, use the customized model event or the input event.
  if (this.componentInstance) {
    return (this.componentInstance.$options.model && this.componentInstance.$options.model.event) || 'input';
  }

  if (this.model && this.model.lazy) {
    return 'change';
  }

  if (isTextInput(this.el)) {
    return 'input';
  }

  return 'change';
};

/**
 * Determines the list of events to listen to.
 */
Field.prototype._determineEventList = function _determineEventList (defaultInputEvent) {
    var this$1 = this;

  // if no event is configured, or it is a component or a text input then respect the user choice.
  if (!this.events.length || this.componentInstance || isTextInput(this.el)) {
    return [].concat( this.events ).map(function (evt) {
      if (evt === 'input' && this$1.model && this$1.model.lazy) {
        return 'change';
      }

      return evt;
    });
  }

  // force suitable event for non-text type fields.
  return this.events.map(function (e) {
    if (e === 'input') {
      return defaultInputEvent;
    }

    return e;
  });
};

/**
 * Adds the listeners required for validation.
 */
Field.prototype.addValueListeners = function addValueListeners () {
    var this$1 = this;

  this.unwatch(/^input_.+/);
  if (!this.listen || !this.el) { return; }

  var token = { cancelled: false };
  var fn = this.targetOf ? function () {
    var target = this$1.validator._resolveField(("#" + (this$1.targetOf)));
    if (target && target.flags.validated) {
      this$1.validator.validate(("#" + (this$1.targetOf)));
    }
  } : function () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

    // if its a DOM event, resolve the value, otherwise use the first parameter as the value.
    if (args.length === 0 || isEvent(args[0])) {
      args[0] = this$1.value;
    }

    this$1.flags.pending = true;
    this$1._cancellationToken = token;
    this$1.validator.validate(("#" + (this$1.id)), args[0]);
  };

  var inputEvent = this._determineInputEvent();
  var events = this._determineEventList(inputEvent);

  // if on input validation is requested.
  if (includes(events, inputEvent)) {
    var ctx = null;
    var expression = null;
    var watchCtxVm = false;
    // if its watchable from the context vm.
    if (this.model && this.model.expression) {
      ctx = this.vm;
      expression = this.model.expression;
      watchCtxVm = true;
    }

    // watch it from the custom component vm instead.
    if (!expression && this.componentInstance && this.componentInstance.$options.model) {
      ctx = this.componentInstance;
      expression = this.componentInstance.$options.model.prop || 'value';
    }

    if (ctx && expression) {
      var debouncedFn = debounce(fn, this.delay[inputEvent], token);
      var unwatch = ctx.$watch(expression, debouncedFn);
      this.watchers.push({
        tag: 'input_model',
        unwatch: function () {
          this$1.vm.$nextTick(function () {
            unwatch();
          });
        }
      });

      // filter out input event when we are watching from the context vm.
      if (watchCtxVm) {
        events = events.filter(function (e) { return e !== inputEvent; });
      }
    }
  }

  // Add events.
  events.forEach(function (e) {
    var debouncedFn = debounce(fn, this$1.delay[e], token);

    this$1._addComponentEventListener(e, debouncedFn);
    this$1._addHTMLEventListener(e, debouncedFn);
  });
};

Field.prototype._addComponentEventListener = function _addComponentEventListener (evt, validate) {
    var this$1 = this;

  if (!this.componentInstance) { return; }

  this.componentInstance.$on(evt, validate);
  this.watchers.push({
    tag: 'input_vue',
    unwatch: function () {
      this$1.componentInstance.$off(evt, validate);
    }
  });
};

Field.prototype._addHTMLEventListener = function _addHTMLEventListener (evt, validate) {
    var this$1 = this;

  if (!this.el || this.componentInstance) { return; }

  // listen for the current element.
  var addListener = function (el) {
    addEventListener(el, evt, validate);
    this$1.watchers.push({
      tag: 'input_native',
      unwatch: function () {
        el.removeEventListener(evt, validate);
      }
    });
  };

  addListener(this.el);
  if (!isCheckboxOrRadioInput(this.el)) {
    return;
  }

  var els = document.querySelectorAll(("input[name=\"" + (this.el.name) + "\"]"));
  toArray(els).forEach(function (el) {
    // skip if it is added by v-validate and is not the current element.
    if (el._veeValidateId && el !== this$1.el) {
      return;
    }

    addListener(el);
  });
};

/**
 * Updates aria attributes on the element.
 */
Field.prototype.updateAriaAttrs = function updateAriaAttrs () {
    var this$1 = this;

  if (!this.aria || !this.el || !isCallable(this.el.setAttribute)) { return; }

  var applyAriaAttrs = function (el) {
    el.setAttribute('aria-required', this$1.isRequired ? 'true' : 'false');
    el.setAttribute('aria-invalid', this$1.flags.invalid ? 'true' : 'false');
  };

  if (!isCheckboxOrRadioInput(this.el)) {
    applyAriaAttrs(this.el);
    return;
  }

  var els = document.querySelectorAll(("input[name=\"" + (this.el.name) + "\"]"));
  toArray(els).forEach(applyAriaAttrs);
};

/**
 * Updates the custom validity for the field.
 */
Field.prototype.updateCustomValidity = function updateCustomValidity () {
  if (!this.validity || !this.el || !isCallable(this.el.setCustomValidity) || !this.validator.errors) { return; }

  this.el.setCustomValidity(this.flags.valid ? '' : (this.validator.errors.firstById(this.id) || ''));
};

/**
 * Removes all listeners.
 */
Field.prototype.destroy = function destroy () {
  // ignore the result of any ongoing validation.
  if (this._cancellationToken) {
    this._cancellationToken.cancelled = true;
  }

  this.unwatch();
  this.dependencies.forEach(function (d) { return d.field.destroy(); });
  this.dependencies = [];
};

Object.defineProperties( Field.prototype, prototypeAccessors$1 );

// 

var FieldBag = function FieldBag (items) {
  if ( items === void 0 ) items = [];

  this.items = items || [];
  this.itemsById = this.items.reduce(function (itemsById, item) {
    itemsById[item.id] = item;
    return itemsById;
  }, {});
};

var prototypeAccessors$2 = { length: { configurable: true } };

FieldBag.prototype[typeof Symbol === 'function' ? Symbol.iterator : '@@iterator'] = function () {
    var this$1 = this;

  var index = 0;
  return {
    next: function () {
      return { value: this$1.items[index++], done: index > this$1.items.length };
    }
  };
};

/**
 * Gets the current items length.
 */

prototypeAccessors$2.length.get = function () {
  return this.items.length;
};

/**
 * Finds the first field that matches the provided matcher object.
 */
FieldBag.prototype.find = function find$1 (matcher) {
  return find(this.items, function (item) { return item.matches(matcher); });
};

/**
 * Finds the field with the given id, using a plain object as a map to link
 * ids to items faster than by looping over the array and matching.
 */
FieldBag.prototype.findById = function findById (id) {
  return this.itemsById[id] || null;
};

/**
 * Filters the items down to the matched fields.
 */
FieldBag.prototype.filter = function filter (matcher) {
  // multiple matchers to be tried.
  if (Array.isArray(matcher)) {
    return this.items.filter(function (item) { return matcher.some(function (m) { return item.matches(m); }); });
  }

  return this.items.filter(function (item) { return item.matches(matcher); });
};

/**
 * Maps the field items using the mapping function.
 */
FieldBag.prototype.map = function map (mapper) {
  return this.items.map(mapper);
};

/**
 * Finds and removes the first field that matches the provided matcher object, returns the removed item.
 */
FieldBag.prototype.remove = function remove (matcher) {
  var item = null;
  if (matcher instanceof Field) {
    item = matcher;
  } else {
    item = this.find(matcher);
  }

  if (!item) { return null; }

  var index = this.items.indexOf(item);
  this.items.splice(index, 1);
  delete this.itemsById[item.id];

  return item;
};

/**
 * Adds a field item to the list.
 */
FieldBag.prototype.push = function push (item) {
  if (! (item instanceof Field)) {
    throw createError('FieldBag only accepts instances of Field that has an id defined.');
  }

  if (!item.id) {
    throw createError('Field id must be defined.');
  }

  if (this.findById(item.id)) {
    throw createError(("Field with id " + (item.id) + " is already added."));
  }

  this.items.push(item);
  this.itemsById[item.id] = item;
};

Object.defineProperties( FieldBag.prototype, prototypeAccessors$2 );

var ScopedValidator = function ScopedValidator (base, vm) {
  this.id = vm._uid;
  this._base = base;
  this._paused = false;

  // create a mirror bag with limited component scope.
  this.errors = new ErrorBag(base.errors, this.id);
};

var prototypeAccessors$3 = { flags: { configurable: true },rules: { configurable: true },fields: { configurable: true },dictionary: { configurable: true },locale: { configurable: true } };

prototypeAccessors$3.flags.get = function () {
    var this$1 = this;

  return this._base.fields.items.filter(function (f) { return f.vmId === this$1.id; }).reduce(function (acc, field) {
    if (field.scope) {
      if (!acc[("$" + (field.scope))]) {
        acc[("$" + (field.scope))] = {};
      }

      acc[("$" + (field.scope))][field.name] = field.flags;
    }

    acc[field.name] = field.flags;

    return acc;
  }, {});
};

prototypeAccessors$3.rules.get = function () {
  return this._base.rules;
};

prototypeAccessors$3.fields.get = function () {
  return new FieldBag(this._base.fields.filter({ vmId: this.id }));
};

prototypeAccessors$3.dictionary.get = function () {
  return this._base.dictionary;
};

prototypeAccessors$3.locale.get = function () {
  return this._base.locale;
};

prototypeAccessors$3.locale.set = function (val) {
  this._base.locale = val;
};

ScopedValidator.prototype.localize = function localize () {
    var ref;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
  return (ref = this._base).localize.apply(ref, args);
};

ScopedValidator.prototype.update = function update () {
    var ref;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
  return (ref = this._base).update.apply(ref, args);
};

ScopedValidator.prototype.attach = function attach (opts) {
  var attachOpts = assign({}, opts, { vmId: this.id });

  return this._base.attach(attachOpts);
};

ScopedValidator.prototype.pause = function pause () {
  this._paused = true;
};

ScopedValidator.prototype.resume = function resume () {
  this._paused = false;
};

ScopedValidator.prototype.remove = function remove (ruleName) {
  return this._base.remove(ruleName);
};

ScopedValidator.prototype.detach = function detach (name, scope) {
  return this._base.detach(name, scope, this.id);
};

ScopedValidator.prototype.extend = function extend () {
    var ref;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
  return (ref = this._base).extend.apply(ref, args);
};

ScopedValidator.prototype.validate = function validate (descriptor, value, opts) {
    if ( opts === void 0 ) opts = {};

  if (this._paused) { return Promise.resolve(true); }

  return this._base.validate(descriptor, value, assign({}, { vmId: this.id }, opts || {}));
};

ScopedValidator.prototype.verify = function verify () {
    var ref;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
  return (ref = this._base).verify.apply(ref, args);
};

ScopedValidator.prototype.validateAll = function validateAll (values, opts) {
    if ( opts === void 0 ) opts = {};

  if (this._paused) { return Promise.resolve(true); }

  return this._base.validateAll(values, assign({}, { vmId: this.id }, opts || {}));
};

ScopedValidator.prototype.validateScopes = function validateScopes (opts) {
    if ( opts === void 0 ) opts = {};

  if (this._paused) { return Promise.resolve(true); }

  return this._base.validateScopes(assign({}, { vmId: this.id }, opts || {}));
};

ScopedValidator.prototype.destroy = function destroy () {
  delete this.id;
  delete this._base;
};

ScopedValidator.prototype.reset = function reset (matcher) {
  return this._base.reset(Object.assign({}, matcher || {}, { vmId: this.id }));
};

ScopedValidator.prototype.flag = function flag () {
    var ref;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
  return (ref = this._base).flag.apply(ref, args.concat( [this.id] ));
};

ScopedValidator.prototype._resolveField = function _resolveField () {
    var ref;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
  return (ref = this._base)._resolveField.apply(ref, args);
};

Object.defineProperties( ScopedValidator.prototype, prototypeAccessors$3 );

var VALIDATOR = null;

var getValidator = function () {
  return VALIDATOR;
};

var setValidator = function (value) {
  VALIDATOR = value;

  return value;
};

// 

/**
 * Checks if a parent validator instance was requested.
 */
var requestsValidator = function (injections) {
  if (isObject(injections) && injections.$validator) {
    return true;
  }

  return false;
};

var mixin = {
  provide: function provide () {
    if (this.$validator && !isBuiltInComponent(this.$vnode)) {
      return {
        $validator: this.$validator
      };
    }

    return {};
  },
  beforeCreate: function beforeCreate () {
    // if built in do nothing.
    if (isBuiltInComponent(this.$vnode) || this.$options.$__veeInject === false) {
      return;
    }

    // if its a root instance set the config if it exists.
    if (!this.$parent) {
      setConfig(this.$options.$_veeValidate || {});
    }

    var options = resolveConfig(this);

    // if its a root instance, inject anyways, or if it requested a new instance.
    if (!this.$parent || (this.$options.$_veeValidate && /new/.test(this.$options.$_veeValidate.validator))) {
      this.$validator = new ScopedValidator(getValidator(), this);
    }

    var requested = requestsValidator(this.$options.inject);

    // if automatic injection is enabled and no instance was requested.
    if (! this.$validator && options.inject && !requested) {
      this.$validator = new ScopedValidator(getValidator(), this);
    }

    // don't inject errors or fieldBag as no validator was resolved.
    if (!requested && !this.$validator) {
      return;
    }

    // There is a validator but it isn't injected, mark as reactive.
    if (!requested && this.$validator) {
      var Vue = this.$options._base; // the vue constructor.
      Vue.util.defineReactive(this.$validator, 'errors', this.$validator.errors);
    }

    if (!this.$options.computed) {
      this.$options.computed = {};
    }

    this.$options.computed[options.errorBagName || 'errors'] = function errorBagGetter () {
      return this.$validator.errors;
    };
    this.$options.computed[options.fieldsBagName || 'fields'] = function fieldBagGetter () {
      return this.$validator.fields.items.reduce(function (acc, field) {
        if (field.scope) {
          if (!acc[("$" + (field.scope))]) {
            acc[("$" + (field.scope))] = {};
          }

          acc[("$" + (field.scope))][field.name] = field.flags;

          return acc;
        }

        acc[field.name] = field.flags;

        return acc;
      }, {});
    };
  },
  beforeDestroy: function beforeDestroy () {
    if (this.$validator && this._uid === this.$validator.id) {
      this.$validator.errors.clear(); // remove errors generated by this component.
    }
  }
};

// 

/**
 * Finds the requested field by id from the context object.
 */
function findField (el, context) {
  if (!context || !context.$validator) {
    return null;
  }

  return context.$validator.fields.findById(el._veeValidateId);
}
var directive = {
  bind: function bind (el, binding, vnode) {
    var validator = vnode.context.$validator;
    if (!validator) {
      if (false) {
        warn("No validator instance is present on vm, did you forget to inject '$validator'?");
      }

      return;
    }

    var fieldOptions = Resolver.generate(el, binding, vnode);
    validator.attach(fieldOptions);
  },
  inserted: function inserted (el, binding, vnode) {
    var field = findField(el, vnode.context);
    var scope = Resolver.resolveScope(el, binding, vnode);

    // skip if scope hasn't changed.
    if (!field || scope === field.scope) { return; }

    // only update scope.
    field.update({ scope: scope });

    // allows the field to re-evaluated once more in the update hook.
    field.updated = false;
  },
  update: function update (el, binding, vnode) {
    var field = findField(el, vnode.context);

    // make sure we don't do unneccasary work if no important change was done.
    if (!field || (field.updated && isEqual(binding.value, binding.oldValue))) { return; }
    var scope = Resolver.resolveScope(el, binding, vnode);
    var rules = Resolver.resolveRules(el, binding, vnode);

    field.update({
      scope: scope,
      rules: rules
    });
  },
  unbind: function unbind (el, binding, ref) {
    var context = ref.context;

    var field = findField(el, context);
    if (!field) { return; }

    context.$validator.detach(field);
  }
};

// 

var Validator = function Validator (validations, options, pluginContainer) {
  if ( options === void 0 ) options = { fastExit: true };
  if ( pluginContainer === void 0 ) pluginContainer = null;

  this.errors = new ErrorBag();
  this.fields = new FieldBag();
  this._createFields(validations);
  this.paused = false;
  this.fastExit = !isNullOrUndefined(options && options.fastExit) ? options.fastExit : true;
  this.$vee = pluginContainer || {
    _vm: {
      $nextTick: function (cb) { return isCallable(cb) ? cb() : Promise.resolve(); },
      $emit: function () {},
      $off: function () {}
    }
  };
};

var prototypeAccessors$4 = { rules: { configurable: true },dictionary: { configurable: true },flags: { configurable: true },locale: { configurable: true } };
var staticAccessors$1 = { rules: { configurable: true },dictionary: { configurable: true },locale: { configurable: true } };

/**
 * @deprecated
 */
staticAccessors$1.rules.get = function () {
  if (false) {
    warn('this accessor will be deprecated, use `import { rules } from "vee-validate"` instead.');
  }

  return RuleContainer.rules;
};

/**
 * @deprecated
 */
prototypeAccessors$4.rules.get = function () {
  if (false) {
    warn('this accessor will be deprecated, use `import { rules } from "vee-validate"` instead.');
  }

  return RuleContainer.rules;
};

prototypeAccessors$4.dictionary.get = function () {
  return DictionaryResolver.getDriver();
};

staticAccessors$1.dictionary.get = function () {
  return DictionaryResolver.getDriver();
};

prototypeAccessors$4.flags.get = function () {
  return this.fields.items.reduce(function (acc, field) {
      var obj;

    if (field.scope) {
      acc[("$" + (field.scope))] = ( obj = {}, obj[field.name] = field.flags, obj );

      return acc;
    }

    acc[field.name] = field.flags;

    return acc;
  }, {});
};

/**
 * Getter for the current locale.
 */
prototypeAccessors$4.locale.get = function () {
  return Validator.locale;
};

/**
 * Setter for the validator locale.
 */
prototypeAccessors$4.locale.set = function (value) {
  Validator.locale = value;
};

staticAccessors$1.locale.get = function () {
  return DictionaryResolver.getDriver().locale;
};

/**
 * Setter for the validator locale.
 */
staticAccessors$1.locale.set = function (value) {
  var hasChanged = value !== DictionaryResolver.getDriver().locale;
  DictionaryResolver.getDriver().locale = value;
  if (hasChanged && Validator.$vee && Validator.$vee._vm) {
    Validator.$vee._vm.$emit('localeChanged');
  }
};

/**
 * Static constructor.
 * @deprecated
 */
Validator.create = function create (validations, options) {
  if (false) {
    warn('Please use `new` to create new validator instances.');
  }

  return new Validator(validations, options);
};

/**
 * Adds a custom validator to the list of validation rules.
 */
Validator.extend = function extend (name, validator, options) {
    if ( options === void 0 ) options = {};

  Validator._guardExtend(name, validator);
  // rules imported from the minimal bundle
  // will have the options embedded in them
  var mergedOpts = validator.options || {};
  Validator._merge(name, {
    validator: validator,
    paramNames: (options && options.paramNames) || validator.paramNames,
    options: assign({ hasTarget: false, immediate: true }, mergedOpts, options || {})
  });
};

/**
 * Removes a rule from the list of validators.
 * @deprecated
 */
Validator.remove = function remove (name) {
  if (false) {
    warn('this method will be deprecated, you can still override your rules with `extend`');
  }

  RuleContainer.remove(name);
};

/**
 * Adds and sets the current locale for the validator.
*/
Validator.prototype.localize = function localize (lang, dictionary) {
  Validator.localize(lang, dictionary);
};

/**
 * Adds and sets the current locale for the validator.
 */
Validator.localize = function localize (lang, dictionary) {
    var obj;

  if (isObject(lang)) {
    DictionaryResolver.getDriver().merge(lang);
    return;
  }

  // merge the dictionary.
  if (dictionary) {
    var locale = lang || dictionary.name;
    dictionary = assign({}, dictionary);
    DictionaryResolver.getDriver().merge(( obj = {}, obj[locale] = dictionary, obj ));
  }

  if (lang) {
    // set the locale.
    Validator.locale = lang;
  }
};

/**
 * Registers a field to be validated.
 */
Validator.prototype.attach = function attach (fieldOpts) {
    var this$1 = this;

  // We search for a field with the same name & scope, having persist enabled
  var oldFieldMatcher = { name: fieldOpts.name, scope: fieldOpts.scope, persist: true };
  var oldField = fieldOpts.persist ? this.fields.find(oldFieldMatcher) : null;

  if (oldField) {
    // We keep the flags of the old field, then we remove its instance
    fieldOpts.flags = oldField.flags;
    oldField.destroy();
    this.fields.remove(oldField);
  }

  // fixes initial value detection with v-model and select elements.
  var value = fieldOpts.initialValue;
  var field = new Field(fieldOpts);
  this.fields.push(field);

  // validate the field initially
  if (field.immediate) {
    this.$vee._vm.$nextTick(function () { return this$1.validate(("#" + (field.id)), value || field.value, { vmId: fieldOpts.vmId }); });
  } else {
    this._validate(field, value || field.value, { initial: true }).then(function (result) {
      field.flags.valid = result.valid;
      field.flags.invalid = !result.valid;
    });
  }

  return field;
};

/**
 * Sets the flags on a field.
 */
Validator.prototype.flag = function flag (name, flags, uid) {
    if ( uid === void 0 ) uid = null;

  var field = this._resolveField(name, undefined, uid);
  if (!field || !flags) {
    return;
  }

  field.setFlags(flags);
};

/**
 * Removes a field from the validator.
 */
Validator.prototype.detach = function detach (name, scope, uid) {
  var field = isCallable(name.destroy) ? name : this._resolveField(name, scope, uid);
  if (!field) { return; }

  // We destroy/remove the field & error instances if it's not a `persist` one
  if (!field.persist) {
    field.destroy();
    this.errors.remove(field.name, field.scope, field.vmId);
    this.fields.remove(field);
  }
};

/**
 * Adds a custom validator to the list of validation rules.
 */
Validator.prototype.extend = function extend (name, validator, options) {
    if ( options === void 0 ) options = {};

  Validator.extend(name, validator, options);
};

Validator.prototype.reset = function reset (matcher) {
    var this$1 = this;

  // two ticks
  return this.$vee._vm.$nextTick().then(function () {
    return this$1.$vee._vm.$nextTick();
  }).then(function () {
    this$1.fields.filter(matcher).forEach(function (field) {
      field.waitFor(null);
      field.reset(); // reset field flags.
      this$1.errors.remove(field.name, field.scope, matcher && matcher.vmId);
    });
  });
};

/**
 * Updates a field, updating both errors and flags.
 */
Validator.prototype.update = function update (id, ref) {
    var scope = ref.scope;

  var field = this._resolveField(("#" + id));
  if (!field) { return; }

  // remove old scope.
  this.errors.update(id, { scope: scope });
};

/**
 * Removes a rule from the list of validators.
 * @deprecated
 */
Validator.prototype.remove = function remove (name) {
  Validator.remove(name);
};

/**
 * Validates a value against a registered field validations.
 */
Validator.prototype.validate = function validate (fieldDescriptor, value, ref) {
    var this$1 = this;
    if ( ref === void 0 ) ref = {};
    var silent = ref.silent;
    var vmId = ref.vmId;

  if (this.paused) { return Promise.resolve(true); }

  // overload to validate all.
  if (isNullOrUndefined(fieldDescriptor)) {
    return this.validateScopes({ silent: silent, vmId: vmId });
  }

  // overload to validate scope-less fields.
  if (fieldDescriptor === '*') {
    return this.validateAll(undefined, { silent: silent, vmId: vmId });
  }

  // if scope validation was requested.
  if (/^(.+)\.\*$/.test(fieldDescriptor)) {
    var matched = fieldDescriptor.match(/^(.+)\.\*$/)[1];
    return this.validateAll(matched);
  }

  var field = this._resolveField(fieldDescriptor);
  if (!field) {
    return this._handleFieldNotFound(fieldDescriptor);
  }

  if (!silent) { field.flags.pending = true; }
  if (value === undefined) {
    value = field.value;
  }

  var validationPromise = this._validate(field, value);
  field.waitFor(validationPromise);

  return validationPromise.then(function (result) {
    if (!silent && field.isWaitingFor(validationPromise)) {
      // allow next validation to mutate the state.
      field.waitFor(null);
      this$1._handleValidationResults([result], vmId);
    }

    return result.valid;
  });
};

/**
 * Pauses the validator.
 */
Validator.prototype.pause = function pause () {
  this.paused = true;

  return this;
};

/**
 * Resumes the validator.
 */
Validator.prototype.resume = function resume () {
  this.paused = false;

  return this;
};

/**
 * Validates each value against the corresponding field validations.
 */
Validator.prototype.validateAll = function validateAll (values, ref) {
    var this$1 = this;
    if ( ref === void 0 ) ref = {};
    var silent = ref.silent;
    var vmId = ref.vmId;

  if (this.paused) { return Promise.resolve(true); }

  var matcher = null;
  var providedValues = false;

  if (typeof values === 'string') {
    matcher = { scope: values, vmId: vmId };
  } else if (isObject(values)) {
    matcher = Object.keys(values).map(function (key) {
      return { name: key, vmId: vmId, scope: null };
    });
    providedValues = true;
  } else if (Array.isArray(values)) {
    matcher = values.map(function (key) {
      return typeof key === 'object' ? Object.assign({ vmId: vmId }, key) : { name: key, vmId: vmId };
    });
  } else {
    matcher = { scope: null, vmId: vmId };
  }

  return Promise.all(
    this.fields.filter(matcher).map(function (field) { return this$1._validate(field, providedValues ? values[field.name] : field.value); })
  ).then(function (results) {
    if (!silent) {
      this$1._handleValidationResults(results, vmId);
    }

    return results.every(function (t) { return t.valid; });
  });
};

/**
 * Validates all scopes.
 */
Validator.prototype.validateScopes = function validateScopes (ref) {
    var this$1 = this;
    if ( ref === void 0 ) ref = {};
    var silent = ref.silent;
    var vmId = ref.vmId;

  if (this.paused) { return Promise.resolve(true); }

  return Promise.all(
    this.fields.filter({ vmId: vmId }).map(function (field) { return this$1._validate(field, field.value); })
  ).then(function (results) {
    if (!silent) {
      this$1._handleValidationResults(results, vmId);
    }

    return results.every(function (t) { return t.valid; });
  });
};

/**
 * Validates a value against the rules.
 */
Validator.prototype.verify = function verify (value, rules, options) {
    if ( options === void 0 ) options = {};

  var field = {
    name: (options && options.name) || '{field}',
    rules: normalizeRules(rules),
    bails: getPath('bails', options, true),
    forceRequired: false,
    get isRequired () {
      return !!this.rules.required || this.forceRequired;
    }
  };

  var targetRules = Object.keys(field.rules).filter(RuleContainer.isTargetRule);
  if (targetRules.length && options && isObject(options.values)) {
    field.dependencies = targetRules.map(function (rule) {
      var ref = field.rules[rule];
        var targetKey = ref[0];

      return {
        name: rule,
        field: { value: options.values[targetKey] }
      };
    });
  }

  return this._validate(field, value).then(function (result) {
    var errors = [];
    var ruleMap = {};
    result.errors.forEach(function (e) {
      errors.push(e.msg);
      ruleMap[e.rule] = e.msg;
    });

    return {
      valid: result.valid,
      errors: errors,
      failedRules: ruleMap
    };
  });
};

/**
 * Perform cleanup.
 */
Validator.prototype.destroy = function destroy () {
  this.$vee._vm.$off('localeChanged');
};

/**
 * Creates the fields to be validated.
 */
Validator.prototype._createFields = function _createFields (validations) {
    var this$1 = this;

  if (!validations) { return; }

  Object.keys(validations).forEach(function (field) {
    var options = assign({}, { name: field, rules: validations[field] });
    this$1.attach(options);
  });
};

/**
 * Date rules need the existence of a format, so date_format must be supplied.
 */
Validator.prototype._getDateFormat = function _getDateFormat (validations) {
  var format = null;
  if (validations.date_format && Array.isArray(validations.date_format)) {
    format = validations.date_format[0];
  }

  return format || DictionaryResolver.getDriver().getDateFormat(this.locale);
};

/**
 * Formats an error message for field and a rule.
 */
Validator.prototype._formatErrorMessage = function _formatErrorMessage (field, rule, data, targetName) {
    if ( data === void 0 ) data = {};
    if ( targetName === void 0 ) targetName = null;

  var name = this._getFieldDisplayName(field);
  var params = this._getLocalizedParams(rule, targetName);

  return DictionaryResolver.getDriver().getFieldMessage(this.locale, field.name, rule.name, [name, params, data]);
};

/**
 * We need to convert any object param to an array format since the locales do not handle params as objects yet.
 */
Validator.prototype._convertParamObjectToArray = function _convertParamObjectToArray (obj, ruleName) {
  if (Array.isArray(obj)) {
    return obj;
  }

  var paramNames = RuleContainer.getParamNames(ruleName);
  if (!paramNames || !isObject(obj)) {
    return obj;
  }

  return paramNames.reduce(function (prev, paramName) {
    if (paramName in obj) {
      prev.push(obj[paramName]);
    }

    return prev;
  }, []);
};

/**
 * Translates the parameters passed to the rule (mainly for target fields).
 */
Validator.prototype._getLocalizedParams = function _getLocalizedParams (rule, targetName) {
    if ( targetName === void 0 ) targetName = null;

  var params = this._convertParamObjectToArray(rule.params, rule.name);
  if (rule.options.hasTarget && params && params[0]) {
    var localizedName = targetName || DictionaryResolver.getDriver().getAttribute(this.locale, params[0], params[0]);
    return [localizedName].concat(params.slice(1));
  }

  return params;
};

/**
 * Resolves an appropriate display name, first checking 'data-as' or the registered 'prettyName'
 */
Validator.prototype._getFieldDisplayName = function _getFieldDisplayName (field) {
  return field.alias || DictionaryResolver.getDriver().getAttribute(this.locale, field.name, field.name);
};

/**
 * Converts an array of params to an object with named properties.
 * Only works if the rule is configured with a paramNames array.
 * Returns the same params if it cannot convert it.
 */
Validator.prototype._convertParamArrayToObj = function _convertParamArrayToObj (params, ruleName) {
  var paramNames = RuleContainer.getParamNames(ruleName);
  if (!paramNames) {
    return params;
  }

  if (isObject(params)) {
    // check if the object is either a config object or a single parameter that is an object.
    var hasKeys = paramNames.some(function (name) { return Object.keys(params).indexOf(name) !== -1; });
    // if it has some of the keys, return it as is.
    if (hasKeys) {
      return params;
    }
    // otherwise wrap the object in an array.
    params = [params];
  }

  // Reduce the paramsNames to a param object.
  return params.reduce(function (prev, value, idx) {
    prev[paramNames[idx]] = value;

    return prev;
  }, {});
};

/**
 * Tests a single input value against a rule.
 */
Validator.prototype._test = function _test (field, value, rule) {
    var this$1 = this;

  var validator = RuleContainer.getValidatorMethod(rule.name);
  var params = Array.isArray(rule.params) ? toArray(rule.params) : rule.params;
  if (!params) {
    params = [];
  }

  var targetName = null;
  if (!validator || typeof validator !== 'function') {
    return Promise.reject(createError(("No such validator '" + (rule.name) + "' exists.")));
  }

  // has field dependencies.
  if (rule.options.hasTarget && field.dependencies) {
    var target = find(field.dependencies, function (d) { return d.name === rule.name; });
    if (target) {
      targetName = target.field.alias;
      params = [target.field.value].concat(params.slice(1));
    }
  } else if (rule.name === 'required' && field.rejectsFalse) {
    // invalidate false if no args were specified and the field rejects false by default.
    params = params.length ? params : [true];
  }

  if (rule.options.isDate) {
    var dateFormat = this._getDateFormat(field.rules);
    if (rule.name !== 'date_format') {
      params.push(dateFormat);
    }
  }

  var result = validator(value, this._convertParamArrayToObj(params, rule.name));

  // If it is a promise.
  if (isCallable(result.then)) {
    return result.then(function (values) {
      var allValid = true;
      var data = {};
      if (Array.isArray(values)) {
        allValid = values.every(function (t) { return (isObject(t) ? t.valid : t); });
      } else { // Is a single object/boolean.
        allValid = isObject(values) ? values.valid : values;
        data = values.data;
      }

      return {
        valid: allValid,
        data: result.data,
        errors: allValid ? [] : [this$1._createFieldError(field, rule, data, targetName)]
      };
    });
  }

  if (!isObject(result)) {
    result = { valid: result, data: {} };
  }

  return {
    valid: result.valid,
    data: result.data,
    errors: result.valid ? [] : [this._createFieldError(field, rule, result.data, targetName)]
  };
};

/**
 * Merges a validator object into the RULES and Messages.
 */
Validator._merge = function _merge (name, ref) {
    var validator = ref.validator;
    var options = ref.options;
    var paramNames = ref.paramNames;

  var validate = isCallable(validator) ? validator : validator.validate;
  if (validator.getMessage) {
    DictionaryResolver.getDriver().setMessage(Validator.locale, name, validator.getMessage);
  }

  RuleContainer.add(name, {
    validate: validate,
    options: options,
    paramNames: paramNames
  });
};

/**
 * Guards from extension violations.
 */
Validator._guardExtend = function _guardExtend (name, validator) {
  if (isCallable(validator)) {
    return;
  }

  if (!isCallable(validator.validate)) {
    throw createError(
      ("Extension Error: The validator '" + name + "' must be a function or have a 'validate' method.")
    );
  }
};

/**
 * Creates a Field Error Object.
 */
Validator.prototype._createFieldError = function _createFieldError (field, rule, data, targetName) {
    var this$1 = this;

  return {
    id: field.id,
    vmId: field.vmId,
    field: field.name,
    msg: this._formatErrorMessage(field, rule, data, targetName),
    rule: rule.name,
    scope: field.scope,
    regenerate: function () {
      return this$1._formatErrorMessage(field, rule, data, targetName);
    }
  };
};

/**
 * Tries different strategies to find a field.
 */
Validator.prototype._resolveField = function _resolveField (name, scope, uid) {
  if (name[0] === '#') {
    return this.fields.findById(name.slice(1));
  }

  if (!isNullOrUndefined(scope)) {
    return this.fields.find({ name: name, scope: scope, vmId: uid });
  }

  if (includes(name, '.')) {
    var ref = name.split('.');
      var fieldScope = ref[0];
      var fieldName = ref.slice(1);
    var field = this.fields.find({ name: fieldName.join('.'), scope: fieldScope, vmId: uid });
    if (field) {
      return field;
    }
  }

  return this.fields.find({ name: name, scope: null, vmId: uid });
};

/**
 * Handles when a field is not found.
 */
Validator.prototype._handleFieldNotFound = function _handleFieldNotFound (name, scope) {
  var fullName = isNullOrUndefined(scope) ? name : ("" + (!isNullOrUndefined(scope) ? scope + '.' : '') + name);

  return Promise.reject(createError(
    ("Validating a non-existent field: \"" + fullName + "\". Use \"attach()\" first.")
  ));
};

/**
 * Handles validation results.
 */
Validator.prototype._handleValidationResults = function _handleValidationResults (results, vmId) {
    var this$1 = this;

  var matchers = results.map(function (result) { return ({ id: result.id }); });
  this.errors.removeById(matchers.map(function (m) { return m.id; }));
  // remove by name and scope to remove any custom errors added.
  results.forEach(function (result) {
    this$1.errors.remove(result.field, result.scope, vmId);
  });
  var allErrors = results.reduce(function (prev, curr) {
    prev.push.apply(prev, curr.errors);

    return prev;
  }, []);

  this.errors.add(allErrors);

  // handle flags.
  this.fields.filter(matchers).forEach(function (field) {
    var result = find(results, function (r) { return r.id === field.id; });
    field.setFlags({
      pending: false,
      valid: result.valid,
      validated: true
    });
  });
};

Validator.prototype._shouldSkip = function _shouldSkip (field, value) {
  // field is configured to run through the pipeline regardless
  if (field.bails === false) {
    return false;
  }

  // disabled fields are skipped if useConstraintAttrs is enabled in config
  if (field.isDisabled && getConfig().useConstraintAttrs) {
    return true;
  }

  // skip if the field is not required and has an empty value.
  return !field.isRequired && (isNullOrUndefined(value) || value === '' || isEmptyArray(value));
};

Validator.prototype._shouldBail = function _shouldBail (field) {
  // if the field was configured explicitly.
  if (field.bails !== undefined) {
    return field.bails;
  }

  return this.fastExit;
};

/**
 * Starts the validation process.
 */
Validator.prototype._validate = function _validate (field, value, ref) {
    var this$1 = this;
    if ( ref === void 0 ) ref = {};
    var initial = ref.initial;

  var requireRules = Object.keys(field.rules).filter(RuleContainer.isRequireRule);

  field.forceRequired = false;
  requireRules.forEach(function (rule) {
    var ruleOptions = RuleContainer.getOptions(rule);
    var result = this$1._test(field, value, { name: rule, params: field.rules[rule], options: ruleOptions });

    if (isCallable(result.then)) { throw createError('Require rules cannot be async'); }
    if (!isObject(result)) { throw createError('Require rules has to return an object (see docs)'); }

    if (result.data.required === true) {
      field.forceRequired = true;
    }
  });

  if (this._shouldSkip(field, value)) {
    return Promise.resolve({ valid: true, id: field.id, field: field.name, scope: field.scope, errors: [] });
  }

  var promises = [];
  var errors = [];
  var isExitEarly = false;
  if (isCallable(field.checkValueChanged)) {
    field.flags.changed = field.checkValueChanged();
  }

  // use of '.some()' is to break iteration in middle by returning true
  Object.keys(field.rules).filter(function (rule) {
    if (!initial || !RuleContainer.has(rule)) { return true; }

    return RuleContainer.isImmediate(rule);
  }).some(function (rule) {
    var ruleOptions = RuleContainer.getOptions(rule);
    var result = this$1._test(field, value, { name: rule, params: field.rules[rule], options: ruleOptions });
    if (isCallable(result.then)) {
      promises.push(result);
    } else if (!result.valid && this$1._shouldBail(field)) {
      errors.push.apply(errors, result.errors);
      isExitEarly = true;
    } else {
      // promisify the result.
      promises.push(new Promise(function (resolve) { return resolve(result); }));
    }

    return isExitEarly;
  });

  if (isExitEarly) {
    return Promise.resolve({ valid: false, errors: errors, id: field.id, field: field.name, scope: field.scope });
  }

  return Promise.all(promises).then(function (results) {
    return results.reduce(function (prev, v) {
        var ref;

      if (!v.valid) {
        (ref = prev.errors).push.apply(ref, v.errors);
      }

      prev.valid = prev.valid && v.valid;

      return prev;
    }, { valid: true, errors: errors, id: field.id, field: field.name, scope: field.scope });
  });
};

Object.defineProperties( Validator.prototype, prototypeAccessors$4 );
Object.defineProperties( Validator, staticAccessors$1 );

// 

var normalizeValue = function (value) {
  if (isObject(value)) {
    return Object.keys(value).reduce(function (prev, key) {
      prev[key] = normalizeValue(value[key]);

      return prev;
    }, {});
  }

  if (isCallable(value)) {
    return value('{0}', ['{1}', '{2}', '{3}']);
  }

  return value;
};

var normalizeFormat = function (locale) {
  // normalize messages
  var dictionary = {};
  if (locale.messages) {
    dictionary.messages = normalizeValue(locale.messages);
  }

  if (locale.custom) {
    dictionary.custom = normalizeValue(locale.custom);
  }

  if (locale.attributes) {
    dictionary.attributes = locale.attributes;
  }

  if (!isNullOrUndefined(locale.dateFormat)) {
    dictionary.dateFormat = locale.dateFormat;
  }

  return dictionary;
};

var I18nDictionary = function I18nDictionary (i18n, rootKey) {
  this.i18n = i18n;
  this.rootKey = rootKey;
};

var prototypeAccessors$5 = { locale: { configurable: true } };

prototypeAccessors$5.locale.get = function () {
  return this.i18n.locale;
};

prototypeAccessors$5.locale.set = function (value) {
  warn('Cannot set locale from the validator when using vue-i18n, use i18n.locale setter instead');
};

I18nDictionary.prototype.getDateFormat = function getDateFormat (locale) {
  return this.i18n.getDateTimeFormat(locale || this.locale);
};

I18nDictionary.prototype.setDateFormat = function setDateFormat (locale, value) {
  this.i18n.setDateTimeFormat(locale || this.locale, value);
};

I18nDictionary.prototype.getMessage = function getMessage (_, key, data) {
  var path = (this.rootKey) + ".messages." + key;
  var dataOptions = data;

  if (Array.isArray(data)) {
    dataOptions = [].concat.apply([], data);
  }

  if (this.i18n.te(path)) {
    return this.i18n.t(path, dataOptions);
  }

  // fallback to the fallback message
  if (this.i18n.te(path, this.i18n.fallbackLocale)) {
    return this.i18n.t(path, this.i18n.fallbackLocale, dataOptions);
  }

  // fallback to the root message
  return this.i18n.t(((this.rootKey) + ".messages._default"), dataOptions);
};

I18nDictionary.prototype.getAttribute = function getAttribute (_, key, fallback) {
    if ( fallback === void 0 ) fallback = '';

  var path = (this.rootKey) + ".attributes." + key;
  if (this.i18n.te(path)) {
    return this.i18n.t(path);
  }

  return fallback;
};

I18nDictionary.prototype.getFieldMessage = function getFieldMessage (_, field, key, data) {
  var path = (this.rootKey) + ".custom." + field + "." + key;
  if (this.i18n.te(path)) {
    return this.i18n.t(path, data);
  }

  return this.getMessage(_, key, data);
};

I18nDictionary.prototype.merge = function merge$1 (dictionary) {
    var this$1 = this;

  Object.keys(dictionary).forEach(function (localeKey) {
      var obj;

    // i18n doesn't deep merge
    // first clone the existing locale (avoid mutations to locale)
    var clone = merge({}, getPath((localeKey + "." + (this$1.rootKey)), this$1.i18n.messages, {}));
    // Merge cloned locale with new one
    var locale = merge(clone, normalizeFormat(dictionary[localeKey]));
    this$1.i18n.mergeLocaleMessage(localeKey, ( obj = {}, obj[this$1.rootKey] = locale, obj ));
    if (locale.dateFormat) {
      this$1.i18n.setDateTimeFormat(localeKey, locale.dateFormat);
    }
  });
};

I18nDictionary.prototype.setMessage = function setMessage (locale, key, value) {
    var obj, obj$1;

  this.merge(( obj$1 = {}, obj$1[locale] = {
      messages: ( obj = {}, obj[key] = value, obj )
    }, obj$1 ));
};

I18nDictionary.prototype.setAttribute = function setAttribute (locale, key, value) {
    var obj, obj$1;

  this.merge(( obj$1 = {}, obj$1[locale] = {
      attributes: ( obj = {}, obj[key] = value, obj )
    }, obj$1 ));
};

Object.defineProperties( I18nDictionary.prototype, prototypeAccessors$5 );

var aggressive = function () { return ({
  on: ['input']
}); };

var lazy = function () { return ({
  on: ['change']
}); };

var eager = function (ref) {
  var errors = ref.errors;

  if (errors.length) {
    return {
      on: ['input']
    };
  }

  return {
    on: ['change', 'blur']
  };
};

var passive = function () { return ({
  on: []
}); };

var modes = {
  aggressive: aggressive,
  eager: eager,
  passive: passive,
  lazy: lazy
};

// 

var Vue;
var pendingPlugins;
var pluginInstance;

var VeeValidate$1 = function VeeValidate (config, _Vue) {
  this.configure(config);
  pluginInstance = this;
  if (_Vue) {
    Vue = _Vue;
  }
  this._validator = setValidator(
    new Validator(null, { fastExit: config && config.fastExit }, this)
  );
  this._initVM(this.config);
  this._initI18n(this.config);
};

var prototypeAccessors$6 = { i18nDriver: { configurable: true },config: { configurable: true } };
var staticAccessors$2 = { i18nDriver: { configurable: true },config: { configurable: true } };

VeeValidate$1.setI18nDriver = function setI18nDriver (driver, instance) {
  DictionaryResolver.setDriver(driver, instance);
};

VeeValidate$1.configure = function configure (cfg) {
  setConfig(cfg);
};

VeeValidate$1.setMode = function setMode (mode, implementation) {
  setConfig({ mode: mode });
  if (!implementation) {
    return;
  }

  if (!isCallable(implementation)) {
    throw new Error('A mode implementation must be a function');
  }

  modes[mode] = implementation;
};

VeeValidate$1.use = function use (plugin, options) {
    if ( options === void 0 ) options = {};

  if (!isCallable(plugin)) {
    return warn('The plugin must be a callable function');
  }

  // Don't install plugins until vee-validate is installed.
  if (!pluginInstance) {
    if (!pendingPlugins) {
      pendingPlugins = [];
    }
    pendingPlugins.push({ plugin: plugin, options: options });
    return;
  }

  plugin({ Validator: Validator, ErrorBag: ErrorBag, Rules: Validator.rules }, options);
};
VeeValidate$1.install = function install (_Vue, opts) {
  if (Vue && _Vue === Vue) {
    if (false) {
      warn('already installed, Vue.use(VeeValidate) should only be called once.');
    }
    return;
  }

  Vue = _Vue;
  pluginInstance = new VeeValidate$1(opts);
  // inject the plugin container statically into the validator class
  Validator.$vee = pluginInstance;

  detectPassiveSupport();

  Vue.mixin(mixin);
  Vue.directive('validate', directive);
  if (pendingPlugins) {
    pendingPlugins.forEach(function (ref) {
        var plugin = ref.plugin;
        var options = ref.options;

      VeeValidate$1.use(plugin, options);
    });
    pendingPlugins = null;
  }
};

prototypeAccessors$6.i18nDriver.get = function () {
  return DictionaryResolver.getDriver();
};

staticAccessors$2.i18nDriver.get = function () {
  return DictionaryResolver.getDriver();
};

prototypeAccessors$6.config.get = function () {
  return getConfig();
};

staticAccessors$2.config.get = function () {
  return getConfig();
};

VeeValidate$1.prototype._initVM = function _initVM (config) {
    var this$1 = this;

  this._vm = new Vue({
    data: function () { return ({
      errors: this$1._validator.errors,
      fields: this$1._validator.fields
    }); }
  });
};

VeeValidate$1.prototype._initI18n = function _initI18n (config) {
    var this$1 = this;

  var dictionary = config.dictionary;
    var i18n = config.i18n;
    var i18nRootKey = config.i18nRootKey;
    var locale = config.locale;
  var onLocaleChanged = function () {
    if (dictionary) {
      this$1.i18nDriver.merge(dictionary);
    }

    this$1._validator.errors.regenerate();
  };

  // i18 is being used for localization.
  if (i18n) {
    VeeValidate$1.setI18nDriver('i18n', new I18nDictionary(i18n, i18nRootKey));
    i18n._vm.$watch('locale', onLocaleChanged);
  } else if (typeof window !== 'undefined') {
    this._vm.$on('localeChanged', onLocaleChanged);
  }

  if (dictionary) {
    this.i18nDriver.merge(dictionary);
  }

  if (locale && !i18n) {
    this._validator.localize(locale);
  }
};

VeeValidate$1.prototype.configure = function configure (cfg) {
  setConfig(cfg);
};

Object.defineProperties( VeeValidate$1.prototype, prototypeAccessors$6 );
Object.defineProperties( VeeValidate$1, staticAccessors$2 );

VeeValidate$1.mixin = mixin;
VeeValidate$1.directive = directive;
VeeValidate$1.Validator = Validator;
VeeValidate$1.ErrorBag = ErrorBag;

/**
 * Formates file size.
 *
 * @param {Number|String} size
 */
var formatFileSize = function (size) {
  var units = ['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var threshold = 1024;
  size = Number(size) * threshold;
  var i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(threshold));
  return (((size / Math.pow(threshold, i)).toFixed(2) * 1) + " " + (units[i]));
};

/**
 * Checks if vee-validate is defined globally.
 */
var isDefinedGlobally = function () {
  return typeof VeeValidate !== 'undefined';
};

var obj;

var messages = {
  _default: function (field) { return ("The " + field + " value is not valid"); },
  after: function (field, ref) {
    var target = ref[0];
    var inclusion = ref[1];

    return ("The " + field + " must be after " + (inclusion ? 'or equal to ' : '') + target);
},
  alpha: function (field) { return ("The " + field + " field may only contain alphabetic characters"); },
  alpha_dash: function (field) { return ("The " + field + " field may contain alpha-numeric characters as well as dashes and underscores"); },
  alpha_num: function (field) { return ("The " + field + " field may only contain alpha-numeric characters"); },
  alpha_spaces: function (field) { return ("The " + field + " field may only contain alphabetic characters as well as spaces"); },
  before: function (field, ref) {
    var target = ref[0];
    var inclusion = ref[1];

    return ("The " + field + " must be before " + (inclusion ? 'or equal to ' : '') + target);
},
  between: function (field, ref) {
    var min = ref[0];
    var max = ref[1];

    return ("The " + field + " field must be between " + min + " and " + max);
},
  confirmed: function (field) { return ("The " + field + " confirmation does not match"); },
  credit_card: function (field) { return ("The " + field + " field is invalid"); },
  date_between: function (field, ref) {
    var min = ref[0];
    var max = ref[1];

    return ("The " + field + " must be between " + min + " and " + max);
},
  date_format: function (field, ref) {
    var format = ref[0];

    return ("The " + field + " must be in the format " + format);
},
  decimal: function (field, ref) {
    if ( ref === void 0 ) ref = [];
    var decimals = ref[0]; if ( decimals === void 0 ) decimals = '*';

    return ("The " + field + " field must be numeric and may contain" + (!decimals || decimals === '*' ? '' : ' ' + decimals) + " decimal points");
},
  digits: function (field, ref) {
    var length = ref[0];

    return ("The " + field + " field must be numeric and contains exactly " + length + " digits");
},
  dimensions: function (field, ref) {
    var width = ref[0];
    var height = ref[1];

    return ("The " + field + " field must be " + width + " pixels by " + height + " pixels");
},
  email: function (field) { return ("The " + field + " field must be a valid email"); },
  excluded: function (field) { return ("The " + field + " field must be a valid value"); },
  ext: function (field) { return ("The " + field + " field must be a valid file"); },
  image: function (field) { return ("The " + field + " field must be an image"); },
  included: function (field) { return ("The " + field + " field must be a valid value"); },
  integer: function (field) { return ("The " + field + " field must be an integer"); },
  ip: function (field) { return ("The " + field + " field must be a valid ip address"); },
  ip_or_fqdn: function (field) { return ("The " + field + " field must be a valid ip address or FQDN"); },
  length: function (field, ref) {
    var length = ref[0];
    var max = ref[1];

    if (max) {
      return ("The " + field + " length must be between " + length + " and " + max);
    }

    return ("The " + field + " length must be " + length);
  },
  max: function (field, ref) {
    var length = ref[0];

    return ("The " + field + " field may not be greater than " + length + " characters");
},
  max_value: function (field, ref) {
    var max = ref[0];

    return ("The " + field + " field must be " + max + " or less");
},
  mimes: function (field) { return ("The " + field + " field must have a valid file type"); },
  min: function (field, ref) {
    var length = ref[0];

    return ("The " + field + " field must be at least " + length + " characters");
},
  min_value: function (field, ref) {
    var min = ref[0];

    return ("The " + field + " field must be " + min + " or more");
},
  numeric: function (field) { return ("The " + field + " field may only contain numeric characters"); },
  regex: function (field) { return ("The " + field + " field format is invalid"); },
  required: function (field) { return ("The " + field + " field is required"); },
  required_if: function (field, ref) {
    var target = ref[0];

    return ("The " + field + " field is required when the " + target + " field has this value");
},
  size: function (field, ref) {
    var size = ref[0];

    return ("The " + field + " size must be less than " + (formatFileSize(size)));
},
  url: function (field) { return ("The " + field + " field is not a valid URL"); }
};

var locale = {
  name: 'en',
  messages: messages,
  attributes: {}
};

if (isDefinedGlobally()) {
  // eslint-disable-next-line
  VeeValidate.Validator.localize(( obj = {}, obj[locale.name] = locale, obj ));
}

function toInteger (dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number)
}

var MILLISECONDS_IN_MINUTE = 60000;

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds (dirtyDate) {
  var date = new Date(dirtyDate.getTime());
  var baseTimezoneOffset = date.getTimezoneOffset();
  date.setSeconds(0, 0);
  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE;

  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset
}

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE$1 = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;

var patterns = {
  dateTimeDelimeter: /[T ]/,
  plainTime: /:/,
  timeZoneDelimeter: /[Z ]/i,

  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/, // 0 additional digits
    /^([+-]\d{3})$/, // 1 additional digit
    /^([+-]\d{4})$/ // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/, // 0 additional digits
    /^([+-]\d{5})/, // 1 additional digit
    /^([+-]\d{6})/ // 2 additional digits
  ],

  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,

  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,

  // timezone tokens
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-])(\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 * If the function cannot parse the string or the values are invalid, it returns Invalid Date.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 * All *date-fns* functions will throw `RangeError` if `options.additionalDigits` is not 0, 1, 2 or undefined.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = toDate('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = toDate('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function toDate (argument, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  if (argument === null) {
    return new Date(NaN)
  }

  var options = dirtyOptions || {};

  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : toInteger(options.additionalDigits);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2')
  }

  // Clone the date
  if (argument instanceof Date ||
    (typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]')
  ) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') {
    return new Date(argument)
  } else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN)
  }

  var dateStrings = splitDateString(argument);

  var parseYearResult = parseYear(dateStrings.date, additionalDigits);
  var year = parseYearResult.year;
  var restDateString = parseYearResult.restDateString;

  var date = parseDate(restDateString, year);

  if (isNaN(date)) {
    return new Date(NaN)
  }

  if (date) {
    var timestamp = date.getTime();
    var time = 0;
    var offset;

    if (dateStrings.time) {
      time = parseTime(dateStrings.time);

      if (isNaN(time)) {
        return new Date(NaN)
      }
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone);
      if (isNaN(offset)) {
        return new Date(NaN)
      }
    } else {
      // get offset accurate to hour in timezones that change offset
      offset = getTimezoneOffsetInMilliseconds(new Date(timestamp + time));
      offset = getTimezoneOffsetInMilliseconds(new Date(timestamp + time + offset));
    }

    return new Date(timestamp + time + offset)
  } else {
    return new Date(NaN)
  }
}

function splitDateString (dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimeter);
  var timeString;

  if (patterns.plainTime.test(array[0])) {
    dateStrings.date = null;
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimeter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimeter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings
}

function parseYear (dateString, additionalDigits) {
  var patternYYY = patterns.YYY[additionalDigits];
  var patternYYYYY = patterns.YYYYY[additionalDigits];

  var token;

  // YYYY or ±YYYYY
  token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
  if (token) {
    var yearString = token[1];
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    }
  }

  // YY or ±YYY
  token = patterns.YY.exec(dateString) || patternYYY.exec(dateString);
  if (token) {
    var centuryString = token[1];
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null
  }
}

function parseDate (dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token;
  var date;
  var month;
  var week;

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0);
    date.setUTCFullYear(year);
    return date
  }

  // YYYY-MM
  token = patterns.MM.exec(dateString);
  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;

    if (!validateDate(year, month)) {
      return new Date(NaN)
    }

    date.setUTCFullYear(year, month);
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = patterns.DDD.exec(dateString);
  if (token) {
    date = new Date(0);
    var dayOfYear = parseInt(token[1], 10);

    if (!validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN)
    }

    date.setUTCFullYear(year, 0, dayOfYear);
    return date
  }

  // YYYY-MM-DD or YYYYMMDD
  token = patterns.MMDD.exec(dateString);
  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;
    var day = parseInt(token[2], 10);

    if (!validateDate(year, month, day)) {
      return new Date(NaN)
    }

    date.setUTCFullYear(year, month, day);
    return date
  }

  // YYYY-Www or YYYYWww
  token = patterns.Www.exec(dateString);
  if (token) {
    week = parseInt(token[1], 10) - 1;

    if (!validateWeekDate(year, week)) {
      return new Date(NaN)
    }

    return dayOfISOWeekYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = patterns.WwwD.exec(dateString);
  if (token) {
    week = parseInt(token[1], 10) - 1;
    var dayOfWeek = parseInt(token[2], 10) - 1;

    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN)
    }

    return dayOfISOWeekYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime (timeString) {
  var token;
  var hours;
  var minutes;

  // hh
  token = patterns.HH.exec(timeString);
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'));

    if (!validateTime(hours)) {
      return NaN
    }

    return (hours % 24) * MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = patterns.HHMM.exec(timeString);
  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseFloat(token[2].replace(',', '.'));

    if (!validateTime(hours, minutes)) {
      return NaN
    }

    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE$1
  }

  // hh:mm:ss or hhmmss
  token = patterns.HHMMSS.exec(timeString);
  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseInt(token[2], 10);
    var seconds = parseFloat(token[3].replace(',', '.'));

    if (!validateTime(hours, minutes, seconds)) {
      return NaN
    }

    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE$1 +
      seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function parseTimezone (timezoneString) {
  var token;
  var absoluteOffset;

  // Z
  token = patterns.timezoneZ.exec(timezoneString);
  if (token) {
    return 0
  }

  var hours;

  // ±hh
  token = patterns.timezoneHH.exec(timezoneString);
  if (token) {
    hours = parseInt(token[2], 10);

    if (!validateTimezone()) {
      return NaN
    }

    absoluteOffset = hours * MILLISECONDS_IN_HOUR;
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  // ±hh:mm or ±hhmm
  token = patterns.timezoneHHMM.exec(timezoneString);
  if (token) {
    hours = parseInt(token[2], 10);
    var minutes = parseInt(token[3], 10);

    if (!validateTimezone(hours, minutes)) {
      return NaN
    }

    absoluteOffset = hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE$1;
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  return 0
}

function dayOfISOWeekYear (isoWeekYear, week, day) {
  week = week || 0;
  day = day || 0;
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date
}

// Validation functions

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex (year) {
  return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0)
}

function validateDate (year, month, date) {
  if (month < 0 || month > 11) {
    return false
  }

  if (date != null) {
    if (date < 1) {
      return false
    }

    var isLeapYear = isLeapYearIndex(year);
    if (isLeapYear && date > DAYS_IN_MONTH_LEAP_YEAR[month]) {
      return false
    }
    if (!isLeapYear && date > DAYS_IN_MONTH[month]) {
      return false
    }
  }

  return true
}

function validateDayOfYearDate (year, dayOfYear) {
  if (dayOfYear < 1) {
    return false
  }

  var isLeapYear = isLeapYearIndex(year);
  if (isLeapYear && dayOfYear > 366) {
    return false
  }
  if (!isLeapYear && dayOfYear > 365) {
    return false
  }

  return true
}

function validateWeekDate (year, week, day) {
  if (week < 0 || week > 52) {
    return false
  }

  if (day != null && (day < 0 || day > 6)) {
    return false
  }

  return true
}

function validateTime (hours, minutes, seconds) {
  if (hours != null && (hours < 0 || hours >= 25)) {
    return false
  }

  if (minutes != null && (minutes < 0 || minutes >= 60)) {
    return false
  }

  if (seconds != null && (seconds < 0 || seconds >= 60)) {
    return false
  }

  return true
}

function validateTimezone (hours, minutes) {
  if (minutes != null && (minutes < 0 || minutes > 59)) {
    return false
  }

  return true
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var timestamp = toDate(dirtyDate, dirtyOptions).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount)
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid('2014-02-31')
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  return !isNaN(date)
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },

  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },

  halfAMinute: 'half a minute',

  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },

  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },

  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },

  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },

  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },

  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },

  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },

  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },

  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },

  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },

  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

function formatDistance (token, count, options) {
  options = options || {};

  var result;
  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'in ' + result
    } else {
      return result + ' ago'
    }
  }

  return result
}

function buildFormatLongFn (args) {
  return function (dirtyOptions) {
    var options = dirtyOptions || {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format
  }
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};

var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};

var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};

var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),

  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),

  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

function formatRelative (token, date, baseDate, options) {
  return formatRelativeLocale[token]
}

function buildLocalizeFn (args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var context = options.context ? String(options.context) : 'standalone';

    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      valuesArray = args.formattingValues[width] || args.formattingValues[args.defaultFormattingWidth];
    } else {
      valuesArray = args.values[width] || args.values[args.defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index]
  }
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};

var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};

var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};

var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

function ordinalNumber (dirtyNumber, dirtyOptions) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st'
      case 2:
        return number + 'nd'
      case 3:
        return number + 'rd'
    }
  }
  return number + 'th'
}

var localize = {
  ordinalNumber: ordinalNumber,

  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),

  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1
    }
  }),

  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),

  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),

  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaulFormattingWidth: 'wide'
  })
};

function buildMatchPatternFn (args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};

    var matchResult = string.match(args.matchPattern);
    if (!matchResult) {
      return null
    }
    var matchedString = matchResult[0];

    var parseResult = string.match(args.parsePattern);
    if (!parseResult) {
      return null
    }
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;

    return {
      value: value,
      rest: string.slice(matchedString.length)
    }
  }
}

function buildMatchFn (args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var width = options.width;

    var matchPattern = (width && args.matchPatterns[width]) || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null
    }
    var matchedString = matchResult[0];

    var parsePatterns = (width && args.parsePatterns[width]) || args.parsePatterns[args.defaultParseWidth];

    var value;
    if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
      value = parsePatterns.findIndex(function (pattern) {
        return pattern.test(string)
      });
    } else {
      value = findKey(parsePatterns, function (pattern) {
        return pattern.test(string)
      });
    }

    value = args.valueCallback ? args.valueCallback(value) : value;
    value = options.valueCallback ? options.valueCallback(value) : value;

    return {
      value: value,
      rest: string.slice(matchedString.length)
    }
  }
}

function findKey (object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key
    }
  }
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;

var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};

var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};

var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};

var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};

var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};

var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10)
    }
  }),

  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),

  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1
    }
  }),

  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),

  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),

  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale$1 = {
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};

var MILLISECONDS_IN_DAY = 86400000;

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCDayOfYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCISOWeek (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var weekStartsOn = 1;

  var date = toDate(dirtyDate, dirtyOptions);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCISOWeekYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();

  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear, dirtyOptions);

  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCISOWeekYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var year = getUTCISOWeekYear(dirtyDate, dirtyOptions);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary, dirtyOptions);
  return date
}

var MILLISECONDS_IN_WEEK = 604800000;

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCISOWeek (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var diff = startOfUTCISOWeek(date, dirtyOptions).getTime() - startOfUTCISOWeekYear(date, dirtyOptions).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCWeek (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  }

  var date = toDate(dirtyDate, options);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCWeekYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale &&
    locale.options &&
    locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate =
    localeFirstWeekContainsDate == null
      ? 1
      : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate =
    options.firstWeekContainsDate == null
      ? defaultFirstWeekContainsDate
      : toInteger(options.firstWeekContainsDate);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively')
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);

  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCWeekYear (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale &&
    locale.options &&
    locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate =
    localeFirstWeekContainsDate == null
      ? 1
      : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate =
    options.firstWeekContainsDate == null
      ? defaultFirstWeekContainsDate
      : toInteger(options.firstWeekContainsDate);

  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date
}

var MILLISECONDS_IN_WEEK$1 = 604800000;

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCWeek (dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var diff = startOfUTCWeek(date, dirtyOptions).getTime() - startOfUTCWeekYear(date, dirtyOptions).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1
}

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {width: 'abbreviated'})
      // A, B
      case 'GGGGG':
        return localize.era(era, {width: 'narrow'})
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {width: 'wide'})
    }
  },

  // Year
  y: function (date, token, localize, options) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();

    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;

    // Two digit year
    if (token === 'yy') {
      var twoDigitYear = year % 100;
      return addLeadingZeros(twoDigitYear, 2)
    }

    // Ordinal number
    if (token === 'yo') {
      return localize.ordinalNumber(year, {unit: 'year'})
    }

    // Padding
    return addLeadingZeros(year, token.length)
  },

  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2)
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {unit: 'year'})
    }

    // Padding
    return addLeadingZeros(weekYear, token.length)
  },

  // ISO week-numbering year
  R: function (date, token, localize, options) {
    var isoWeekYear = getUTCISOWeekYear(date, options);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length)
  },

  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token, localize, options) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length)
  },

  // Quarter
  Q: function (date, token, localize, options) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter)
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros(quarter, 2)
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {unit: 'quarter'})
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {width: 'abbreviated', context: 'formatting'})
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {width: 'narrow', context: 'formatting'})
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {width: 'wide', context: 'formatting'})
    }
  },

  // Stand-alone quarter
  q: function (date, token, localize, options) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter)
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros(quarter, 2)
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {unit: 'quarter'})
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {width: 'abbreviated', context: 'standalone'})
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {width: 'narrow', context: 'standalone'})
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {width: 'wide', context: 'standalone'})
    }
  },

  // Month
  M: function (date, token, localize, options) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'M':
        return String(month + 1)
      // 01, 02, ..., 12
      case 'MM':
        return addLeadingZeros(month + 1, 2)
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {unit: 'month'})
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {width: 'abbreviated', context: 'formatting'})
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {width: 'narrow', context: 'formatting'})
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {width: 'wide', context: 'formatting'})
    }
  },

  // Stand-alone month
  L: function (date, token, localize, options) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1)
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros(month + 1, 2)
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {unit: 'month'})
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {width: 'abbreviated', context: 'standalone'})
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {width: 'narrow', context: 'standalone'})
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {width: 'wide', context: 'standalone'})
    }
  },

  // Local week of year
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {unit: 'week'})
    }

    return addLeadingZeros(week, token.length)
  },

  // ISO week of year
  I: function (date, token, localize, options) {
    var isoWeek = getUTCISOWeek(date, options);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {unit: 'week'})
    }

    return addLeadingZeros(isoWeek, token.length)
  },

  // Day of the month
  d: function (date, token, localize, options) {
    var dayOfMonth = date.getUTCDate();

    if (token === 'do') {
      return localize.ordinalNumber(dayOfMonth, {unit: 'date'})
    }

    return addLeadingZeros(dayOfMonth, token.length)
  },

  // Day of year
  D: function (date, token, localize, options) {
    var dayOfYear = getUTCDayOfYear(date, options);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {unit: 'dayOfYear'})
    }

    return addLeadingZeros(dayOfYear, token.length)
  },

  // Day of week
  E: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {width: 'abbreviated', context: 'formatting'})
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {width: 'narrow', context: 'formatting'})
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {width: 'short', context: 'formatting'})
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {width: 'wide', context: 'formatting'})
    }
  },

  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = ((dayOfWeek - options.weekStartsOn + 8) % 7) || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek)
      // Padded numerical value
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2)
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {unit: 'day'})
      case 'eee':
        return localize.day(dayOfWeek, {width: 'abbreviated', context: 'formatting'})
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {width: 'narrow', context: 'formatting'})
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {width: 'short', context: 'formatting'})
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {width: 'wide', context: 'formatting'})
    }
  },

  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = ((dayOfWeek - options.weekStartsOn + 8) % 7) || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek)
      // Padded numberical value
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length)
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {unit: 'day'})
      case 'ccc':
        return localize.day(dayOfWeek, {width: 'abbreviated', context: 'standalone'})
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {width: 'narrow', context: 'standalone'})
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {width: 'short', context: 'standalone'})
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {width: 'wide', context: 'standalone'})
    }
  },

  // ISO day of week
  i: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek)
      // 02
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length)
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {unit: 'day'})
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {width: 'abbreviated', context: 'formatting'})
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {width: 'narrow', context: 'formatting'})
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {width: 'short', context: 'formatting'})
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {width: 'wide', context: 'formatting'})
    }
  },

  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = (hours / 12) >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'abbreviated', context: 'formatting'})
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'narrow', context: 'formatting'})
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'wide', context: 'formatting'})
    }
  },

  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = (hours / 12) >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'abbreviated', context: 'formatting'})
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'narrow', context: 'formatting'})
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'wide', context: 'formatting'})
    }
  },

  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'abbreviated', context: 'formatting'})
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'narrow', context: 'formatting'})
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {width: 'wide', context: 'formatting'})
    }
  },

  // Hour [1-12]
  h: function (date, token, localize, options) {
    var hours = date.getUTCHours() % 12;

    if (hours === 0) {
      hours = 12;
    }

    if (token === 'ho') {
      return localize.ordinalNumber(hours, {unit: 'hour'})
    }

    return addLeadingZeros(hours, token.length)
  },

  // Hour [0-23]
  H: function (date, token, localize, options) {
    var hours = date.getUTCHours();

    if (token === 'Ho') {
      return localize.ordinalNumber(hours, {unit: 'hour'})
    }

    return addLeadingZeros(hours, token.length)
  },

  // Hour [0-11]
  K: function (date, token, localize, options) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {unit: 'hour'})
    }

    return addLeadingZeros(hours, token.length)
  },

  // Hour [1-24]
  k: function (date, token, localize, options) {
    var hours = date.getUTCHours();

    if (hours === 0) {
      hours = 24;
    }

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {unit: 'hour'})
    }

    return addLeadingZeros(hours, token.length)
  },

  // Minute
  m: function (date, token, localize, options) {
    var minutes = date.getUTCMinutes();

    if (token === 'mo') {
      return localize.ordinalNumber(minutes, {unit: 'minute'})
    }

    return addLeadingZeros(minutes, token.length)
  },

  // Second
  s: function (date, token, localize, options) {
    var seconds = date.getUTCSeconds();

    if (token === 'so') {
      return localize.ordinalNumber(seconds, {unit: 'second'})
    }

    return addLeadingZeros(seconds, token.length)
  },

  // Fraction of second
  S: function (date, token, localize, options) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, numberOfDigits)
  },

  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z'
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset)

      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX': // Hours and minutes without `:` delimeter
        return formatTimezone(timezoneOffset)

      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimeter
      default:
        return formatTimezone(timezoneOffset, ':')
    }
  },

  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset)

      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx': // Hours and minutes without `:` delimeter
        return formatTimezone(timezoneOffset)

      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimeter
      default:
        return formatTimezone(timezoneOffset, ':')
    }
  },

  // Timezone (GMT)
  O: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':')
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':')
    }
  },

  // Timezone (specific non-location)
  z: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':')
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':')
    }
  },

  // Seconds timestamp
  t: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length)
  },

  // Milliseconds timestamp
  T: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length)
  }
};

function addLeadingZeros (number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output
}

function formatTimezone (offset, dirtyDelimeter) {
  var delimeter = dirtyDelimeter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimeter + minutes
}

function formatTimezoneWithOptionalMinutes (offset, dirtyDelimeter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2)
  }
  return formatTimezone(offset, dirtyDelimeter)
}

function formatTimezoneShort (offset, dirtyDelimeter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours)
  }
  var delimeter = dirtyDelimeter || '';
  return sign + String(hours) + delimeter + addLeadingZeros(minutes, 2)
}

function dateLongFormatter (pattern, formatLong, options) {
  switch (pattern) {
    case 'P':
      return formatLong.date({width: 'short'})
    case 'PP':
      return formatLong.date({width: 'medium'})
    case 'PPP':
      return formatLong.date({width: 'long'})
    case 'PPPP':
    default:
      return formatLong.date({width: 'full'})
  }
}

function timeLongFormatter (pattern, formatLong, options) {
  switch (pattern) {
    case 'p':
      return formatLong.time({width: 'short'})
    case 'pp':
      return formatLong.time({width: 'medium'})
    case 'ppp':
      return formatLong.time({width: 'long'})
    case 'pppp':
    default:
      return formatLong.time({width: 'full'})
  }
}

function dateTimeLongFormatter (pattern, formatLong, options) {
  var matchResult = pattern.match(/(P+)(p+)?/);
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong)
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({width: 'short'});
      break
    case 'PP':
      dateTimeFormat = formatLong.dateTime({width: 'medium'});
      break
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({width: 'long'});
      break
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({width: 'full'});
      break
  }

  return dateTimeFormat
    .replace('{{date}}', dateLongFormatter(datePattern, formatLong))
    .replace('{{time}}', timeLongFormatter(timePattern, formatLong))
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds (dirtyDate, dirtyAmount, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount, dirtyOptions)
}

var protectedTokens = ['D', 'DD', 'YY', 'YYYY'];

function isProtectedToken(token) {
  return protectedTokens.indexOf(token) !== -1
}

function throwProtectedError(token) {
  throw new RangeError(
    '`options.awareOfUnicodeTokens` must be set to `true` to use `' +
      token +
      '` token; see: https://git.io/fxCyr'
  )
}

// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;

var escapedStringRegExp = /^'(.*?)'?$/;
var doubleQuoteRegExp = /''/g;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 8     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 8     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Su            | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aaa  | AM, PM                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 1, 2, ..., 11, 0                  |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 0001, ..., 999               |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 05/29/1453                        | 7     |
 * |                                 | PP      | May 29, 1453                      | 7     |
 * |                                 | PPP     | May 29th, 1453                    | 7     |
 * |                                 | PPPP    | Sunday, May 29th, 1453            | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 05/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | May 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | May 29th, 1453 at ...             | 7     |
 * |                                 | PPPPpppp| Sunday, May 29th, 1453 at ...     | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. These tokens are often confused with others. See: https://git.io/fxCyr
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {Boolean} [options.awareOfUnicodeTokens=false] - if true, allows usage of Unicode tokens causes confusion:
 *   - Some of the day of year tokens (`D`, `DD`) that are confused with the day of month tokens (`d`, `dd`).
 *   - Some of the local week-numbering year tokens (`YY`, `YYYY`) that are confused with the calendar year tokens (`yy`, `yyyy`).
 *   See: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.awareOfUnicodeTokens` must be set to `true` to use `XX` token; see: https://git.io/fxCyr
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(
 *   new Date(2014, 1, 11),
 *   'MM/dd/yyyy'
 * )
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(
 *   new Date(2014, 6, 2),
 *   "do 'de' MMMM yyyy",
 *   {locale: eoLocale}
 * )
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(
 *   new Date(2014, 6, 2, 15),
 *   "h 'o''clock'"
 * )
 * //=> "3 o'clock"
 */
function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError(
      '2 arguments required, but only ' + arguments.length + ' present'
    )
  }

  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};

  var locale = options.locale || locale$1;

  var localeFirstWeekContainsDate =
    locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate =
    localeFirstWeekContainsDate == null
      ? 1
      : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate =
    options.firstWeekContainsDate == null
      ? defaultFirstWeekContainsDate
      : toInteger(options.firstWeekContainsDate);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError(
      'firstWeekContainsDate must be between 1 and 7 inclusively'
    )
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn =
    localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn =
    options.weekStartsOn == null
      ? defaultWeekStartsOn
      : toInteger(options.weekStartsOn);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property')
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property')
  }

  var originalDate = toDate(dirtyDate, options);

  if (!isValid(originalDate, options)) {
    return 'Invalid Date'
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset, options);

  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };

  var result = formatStr
    .match(longFormattingTokensRegExp)
    .map(function(substring) {
      var firstCharacter = substring[0];
      if (firstCharacter === 'p' || firstCharacter === 'P') {
        var longFormatter = longFormatters[firstCharacter];
        return longFormatter(substring, locale.formatLong, formatterOptions)
      }
      return substring
    })
    .join('')
    .match(formattingTokensRegExp)
    .map(function(substring) {
      // Replace two single quote characters with one single quote character
      if (substring === "''") {
        return "'"
      }

      var firstCharacter = substring[0];
      if (firstCharacter === "'") {
        return cleanEscapedString(substring)
      }

      var formatter = formatters[firstCharacter];
      if (formatter) {
        if (!options.awareOfUnicodeTokens && isProtectedToken(substring)) {
          throwProtectedError(substring);
        }
        return formatter(utcDate, substring, locale.localize, formatterOptions)
      }

      return substring
    })
    .join('');

  return result
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'")
}

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|String|Number} date - the date that should be after the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter (dirtyDate, dirtyDateToCompare, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var dateToCompare = toDate(dirtyDateToCompare, dirtyOptions);
  return date.getTime() > dateToCompare.getTime()
}

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|String|Number} date - the date that should be before the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore (dirtyDate, dirtyDateToCompare, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var dateToCompare = toDate(dirtyDateToCompare, dirtyOptions);
  return date.getTime() < dateToCompare.getTime()
}

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0)
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual$1 (dirtyLeftDate, dirtyRightDate, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var dateLeft = toDate(dirtyLeftDate, dirtyOptions);
  var dateRight = toDate(dirtyRightDate, dirtyOptions);
  return dateLeft.getTime() === dateRight.getTime()
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCDay (dirtyDate, dirtyDay, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var day = toInteger(dirtyDay);

  var currentDay = date.getUTCDay();

  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;

  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;

  date.setUTCDate(date.getUTCDate() + diff);
  return date
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCWeek (dirtyDate, dirtyWeek, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var week = toInteger(dirtyWeek);
  var diff = getUTCWeek(date, dirtyOptions) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCISODay (dirtyDate, dirtyDay, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var day = toInteger(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = toDate(dirtyDate, dirtyOptions);
  var currentDay = date.getUTCDay();

  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;

  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;

  date.setUTCDate(date.getUTCDate() + diff);
  return date
}

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function setUTCISOWeek (dirtyDate, dirtyISOWeek, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
  }

  var date = toDate(dirtyDate, dirtyOptions);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getUTCISOWeek(date, dirtyOptions) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date
}

var MILLISECONDS_IN_HOUR$1 = 3600000;
var MILLISECONDS_IN_MINUTE$2 = 60000;
var MILLISECONDS_IN_SECOND = 1000;

var numericPatterns = {
  month: /^(1[0-2]|0?\d)/, // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/, // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/, // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/, // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/, // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/, // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/, // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/, // 0 to 12
  minute: /^[0-5]?\d/, // 0 to 59
  second: /^[0-5]?\d/, // 0 to 59

  singleDigit: /^\d/, // 0 to 9
  twoDigits: /^\d{1,2}/, // 0 to 99
  threeDigits: /^\d{1,3}/, // 0 to 999
  fourDigits: /^\d{1,4}/, // 0 to 9999

  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/, // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/, // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/, // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};

var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

function parseNumericPattern (pattern, string, valueCallback) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null
  }

  var value = parseInt(matchResult[0], 10);

  return {
    value: valueCallback ? valueCallback(value) : value,
    rest: string.slice(matchResult[0].length)
  }
}

function parseTimezonePattern (pattern, string) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null
  }

  // Input is 'Z'
  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: string.slice(1)
    }
  }

  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;

  return {
    value: sign * (
      hours * MILLISECONDS_IN_HOUR$1 +
        minutes * MILLISECONDS_IN_MINUTE$2 +
        seconds * MILLISECONDS_IN_SECOND
    ),
    rest: string.slice(matchResult[0].length)
  }
}

function parseAnyDigitsSigned (string, valueCallback) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback)
}

function parseNDigits (n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback)
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback)
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback)
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback)
    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback)
  }
}

function parseNDigitsSigned (n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback)
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback)
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback)
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback)
    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback)
  }
}

function dayPeriodEnumToHours (enumValue) {
  switch (enumValue) {
    case 'morning':
      return 4
    case 'evening':
      return 17
    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12
    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0
  }
}

function normalizeTwoDigitYear (twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0;
  // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC
  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;

  var result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result
}

var DAYS_IN_MONTH$1 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR$1 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

// User for validation
function isLeapYearIndex$1 (year) {
  return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0)
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */
var parsers = {
  // Era
  G: {
    priority: 140,
    parse: function (string, token, match, options) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(string, {width: 'abbreviated'}) ||
            match.era(string, {width: 'narrow'})
        // A, B
        case 'GGGGG':
          return match.era(string, {width: 'narrow'})
        // Anno Domini, Before Christ
        case 'GGGG':
        default:
          return match.era(string, {width: 'wide'}) ||
            match.era(string, {width: 'abbreviated'}) ||
            match.era(string, {width: 'narrow'})
      }
    },
    set: function (date, value, options) {
      // Sets year 10 BC if BC, or 10 AC if AC
      date.setUTCFullYear(value === 1 ? 10 : -9, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Year
  y: {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    priority: 130,
    parse: function (string, token, match, options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        }
      };

      switch (token) {
        case 'y':
          return parseNDigits(4, string, valueCallback)
        case 'yo':
          return match.ordinalNumber(string, {unit: 'year', valueCallback: valueCallback})
        default:
          return parseNDigits(token.length, string, valueCallback)
      }
    },
    validate: function (date, value, options) {
      return value.isTwoDigitYear || value.year > 0
    },
    set: function (date, value, options) {
      var currentYear = getUTCWeekYear(date, options);

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date
      }

      var year = currentYear > 0 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Local week-numbering year
  Y: {
    priority: 130,
    parse: function (string, token, match, options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        }
      };

      switch (token) {
        case 'Y':
          return parseNDigits(4, string, valueCallback)
        case 'Yo':
          return match.ordinalNumber(string, {unit: 'year', valueCallback: valueCallback})
        default:
          return parseNDigits(token.length, string, valueCallback)
      }
    },
    validate: function (date, value, options) {
      return value.isTwoDigitYear || value.year > 0
    },
    set: function (date, value, options) {
      var currentYear = date.getUTCFullYear();

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options)
      }

      var year = currentYear > 0 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date, options)
    }
  },

  // ISO week-numbering year
  R: {
    priority: 130,
    parse: function (string, token, match, options) {
      if (token === 'R') {
        return parseNDigitsSigned(4, string)
      }

      return parseNDigitsSigned(token.length, string)
    },
    set: function (date, value, options) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear)
    }
  },

  // Extended year
  u: {
    priority: 130,
    parse: function (string, token, match, options) {
      if (token === 'u') {
        return parseNDigitsSigned(4, string)
      }

      return parseNDigitsSigned(token.length, string)
    },
    set: function (date, value, options) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Quarter
  Q: {
    priority: 120,
    parse: function (string, token, match, options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ': // 01, 02, 03, 04
          return parseNDigits(token.length, string)
        // 1st, 2nd, 3rd, 4th
        case 'Qo':
          return match.ordinalNumber(string, {unit: 'quarter'})
        // Q1, Q2, Q3, Q4
        case 'QQQ':
          return match.quarter(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.quarter(string, {width: 'narrow', context: 'formatting'})
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'QQQQQ':
          return match.quarter(string, {width: 'narrow', context: 'formatting'})
        // 1st quarter, 2nd quarter, ...
        case 'QQQQ':
        default:
          return match.quarter(string, {width: 'wide', context: 'formatting'}) ||
            match.quarter(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.quarter(string, {width: 'narrow', context: 'formatting'})
      }
    },
    validate: function (date, value, options) {
      return value >= 1 && value <= 4
    },
    set: function (date, value, options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Stand-alone quarter
  q: {
    priority: 120,
    parse: function (string, token, match, options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq': // 01, 02, 03, 04
          return parseNDigits(token.length, string)
        // 1st, 2nd, 3rd, 4th
        case 'qo':
          return match.ordinalNumber(string, {unit: 'quarter'})
        // Q1, Q2, Q3, Q4
        case 'qqq':
          return match.quarter(string, {width: 'abbreviated', context: 'standalone'}) ||
            match.quarter(string, {width: 'narrow', context: 'standalone'})
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'qqqqq':
          return match.quarter(string, {width: 'narrow', context: 'standalone'})
        // 1st quarter, 2nd quarter, ...
        case 'qqqq':
        default:
          return match.quarter(string, {width: 'wide', context: 'standalone'}) ||
            match.quarter(string, {width: 'abbreviated', context: 'standalone'}) ||
            match.quarter(string, {width: 'narrow', context: 'standalone'})
      }
    },
    validate: function (date, value, options) {
      return value >= 1 && value <= 4
    },
    set: function (date, value, options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Month
  M: {
    priority: 110,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        return value - 1
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return parseNumericPattern(numericPatterns.month, string, valueCallback)
        // 01, 02, ..., 12
        case 'MM':
          return parseNDigits(2, string, valueCallback)
        // 1st, 2nd, ..., 12th
        case 'Mo':
          return match.ordinalNumber(string, {unit: 'month', valueCallback: valueCallback})
        // Jan, Feb, ..., Dec
        case 'MMM':
          return match.month(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.month(string, {width: 'narrow', context: 'formatting'})
        // J, F, ..., D
        case 'MMMMM':
          return match.month(string, {width: 'narrow', context: 'formatting'})
        // January, February, ..., December
        case 'MMMM':
        default:
          return match.month(string, {width: 'wide', context: 'formatting'}) ||
            match.month(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.month(string, {width: 'narrow', context: 'formatting'})
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 11
    },
    set: function (date, value, options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Stand-alone month
  L: {
    priority: 110,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        return value - 1
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return parseNumericPattern(numericPatterns.month, string, valueCallback)
        // 01, 02, ..., 12
        case 'LL':
          return parseNDigits(2, string, valueCallback)
        // 1st, 2nd, ..., 12th
        case 'Lo':
          return match.ordinalNumber(string, {unit: 'month', valueCallback: valueCallback})
        // Jan, Feb, ..., Dec
        case 'LLL':
          return match.month(string, {width: 'abbreviated', context: 'standalone'}) ||
            match.month(string, {width: 'narrow', context: 'standalone'})
        // J, F, ..., D
        case 'LLLLL':
          return match.month(string, {width: 'narrow', context: 'standalone'})
        // January, February, ..., December
        case 'LLLL':
        default:
          return match.month(string, {width: 'wide', context: 'standalone'}) ||
            match.month(string, {width: 'abbreviated', context: 'standalone'}) ||
            match.month(string, {width: 'narrow', context: 'standalone'})
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 11
    },
    set: function (date, value, options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Local week of year
  w: {
    priority: 100,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, string)
        case 'wo':
          return match.ordinalNumber(string, {unit: 'week'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      return value >= 1 && value <= 53
    },
    set: function (date, value, options) {
      return startOfUTCWeek(setUTCWeek(date, value, options), options)
    }
  },

  // ISO week of year
  I: {
    priority: 100,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, string)
        case 'Io':
          return match.ordinalNumber(string, {unit: 'week'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      return value >= 1 && value <= 53
    },
    set: function (date, value, options) {
      return startOfUTCISOWeek(setUTCISOWeek(date, value, options), options)
    }
  },

  // Day of the month
  d: {
    priority: 90,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, string)
        case 'do':
          return match.ordinalNumber(string, {unit: 'date'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);
      var month = date.getUTCMonth();
      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR$1[month]
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH$1[month]
      }
    },
    set: function (date, value, options) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Day of year
  D: {
    priority: 90,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, string)
        case 'Do':
          return match.ordinalNumber(string, {unit: 'date'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);
      if (isLeapYear) {
        return value >= 1 && value <= 366
      } else {
        return value >= 1 && value <= 365
      }
    },
    set: function (date, value, options) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Day of week
  E: {
    priority: 90,
    parse: function (string, token, match, options) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.day(string, {width: 'short', context: 'formatting'}) ||
            match.day(string, {width: 'narrow', context: 'formatting'})
        // T
        case 'EEEEE':
          return match.day(string, {width: 'narrow', context: 'formatting'})
        // Tu
        case 'EEEEEE':
          return match.day(string, {width: 'short', context: 'formatting'}) ||
          match.day(string, {width: 'narrow', context: 'formatting'})
        // Tuesday
        case 'EEEE':
        default:
          return match.day(string, {width: 'wide', context: 'formatting'}) ||
            match.day(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.day(string, {width: 'short', context: 'formatting'}) ||
            match.day(string, {width: 'narrow', context: 'formatting'})
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 6
    },
    set: function (date, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Local day of week
  e: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays
      };

      switch (token) {
        // 3
        case 'e':
        case 'ee': // 03
          return parseNDigits(token.length, string, valueCallback)
        // 3rd
        case 'eo':
          return match.ordinalNumber(string, {unit: 'day', valueCallback: valueCallback})
        // Tue
        case 'eee':
          return match.day(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.day(string, {width: 'short', context: 'formatting'}) ||
            match.day(string, {width: 'narrow', context: 'formatting'})
        // T
        case 'eeeee':
          return match.day(string, {width: 'narrow', context: 'formatting'})
        // Tu
        case 'eeeeee':
          return match.day(string, {width: 'short', context: 'formatting'}) ||
          match.day(string, {width: 'narrow', context: 'formatting'})
        // Tuesday
        case 'eeee':
        default:
          return match.day(string, {width: 'wide', context: 'formatting'}) ||
            match.day(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.day(string, {width: 'short', context: 'formatting'}) ||
            match.day(string, {width: 'narrow', context: 'formatting'})
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 6
    },
    set: function (date, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // Stand-alone local day of week
  c: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays
      };

      switch (token) {
        // 3
        case 'c':
        case 'cc': // 03
          return parseNDigits(token.length, string, valueCallback)
        // 3rd
        case 'co':
          return match.ordinalNumber(string, {unit: 'day', valueCallback: valueCallback})
        // Tue
        case 'ccc':
          return match.day(string, {width: 'abbreviated', context: 'standalone'}) ||
            match.day(string, {width: 'short', context: 'standalone'}) ||
            match.day(string, {width: 'narrow', context: 'standalone'})
        // T
        case 'ccccc':
          return match.day(string, {width: 'narrow', context: 'standalone'})
        // Tu
        case 'cccccc':
          return match.day(string, {width: 'short', context: 'standalone'}) ||
          match.day(string, {width: 'narrow', context: 'standalone'})
        // Tuesday
        case 'cccc':
        default:
          return match.day(string, {width: 'wide', context: 'standalone'}) ||
            match.day(string, {width: 'abbreviated', context: 'standalone'}) ||
            match.day(string, {width: 'short', context: 'standalone'}) ||
            match.day(string, {width: 'narrow', context: 'standalone'})
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 6
    },
    set: function (date, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // ISO day of week
  i: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        if (value === 0) {
          return 7
        }
        return value
      };

      switch (token) {
        // 2
        case 'i':
        case 'ii': // 02
          return parseNDigits(token.length, string)
        // 2nd
        case 'io':
          return match.ordinalNumber(string, {unit: 'day'})
        // Tue
        case 'iii':
          return match.day(string, {width: 'abbreviated', context: 'formatting', valueCallback: valueCallback}) ||
            match.day(string, {width: 'short', context: 'formatting', valueCallback: valueCallback}) ||
            match.day(string, {width: 'narrow', context: 'formatting', valueCallback: valueCallback})
        // T
        case 'iiiii':
          return match.day(string, {width: 'narrow', context: 'formatting', valueCallback: valueCallback})
        // Tu
        case 'iiiiii':
          return match.day(string, {width: 'short', context: 'formatting', valueCallback: valueCallback}) ||
          match.day(string, {width: 'narrow', context: 'formatting', valueCallback: valueCallback})
        // Tuesday
        case 'iiii':
        default:
          return match.day(string, {width: 'wide', context: 'formatting', valueCallback: valueCallback}) ||
            match.day(string, {width: 'abbreviated', context: 'formatting', valueCallback: valueCallback}) ||
            match.day(string, {width: 'short', context: 'formatting', valueCallback: valueCallback}) ||
            match.day(string, {width: 'narrow', context: 'formatting', valueCallback: valueCallback})
      }
    },
    validate: function (date, value, options) {
      return value >= 1 && value <= 7
    },
    set: function (date, value, options) {
      date = setUTCISODay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date
    }
  },

  // AM or PM
  a: {
    priority: 80,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
        case 'aaaaa':
          return match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
        case 'aaaa':
        default:
          return match.dayPeriod(string, {width: 'wide', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
      }
    },
    set: function (date, value, options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date
    }
  },

  // AM, PM, midnight
  b: {
    priority: 80,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
        case 'bbbbb':
          return match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
        case 'bbbb':
        default:
          return match.dayPeriod(string, {width: 'wide', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
      }
    },
    set: function (date, value, options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date
    }
  },

  // in the morning, in the afternoon, in the evening, at night
  B: {
    priority: 80,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
        case 'BBBBB':
          return match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
        case 'BBBB':
        default:
          return match.dayPeriod(string, {width: 'wide', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'abbreviated', context: 'formatting'}) ||
            match.dayPeriod(string, {width: 'narrow', context: 'formatting'})
      }
    },
    set: function (date, value, options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date
    }
  },

  // Hour [1-12]
  h: {
    priority: 70,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, string)
        case 'ho':
          return match.ordinalNumber(string, {unit: 'hour'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      return value >= 1 && value <= 12
    },
    set: function (date, value, options) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date
    }
  },

  // Hour [0-23]
  H: {
    priority: 70,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, string)
        case 'Ho':
          return match.ordinalNumber(string, {unit: 'hour'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 23
    },
    set: function (date, value, options) {
      date.setUTCHours(value, 0, 0, 0);
      return date
    }
  },

  // Hour [0-11]
  K: {
    priority: 70,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, string)
        case 'Ko':
          return match.ordinalNumber(string, {unit: 'hour'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 11
    },
    set: function (date, value, options) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date
    }
  },

  // Hour [1-24]
  k: {
    priority: 70,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, string)
        case 'ko':
          return match.ordinalNumber(string, {unit: 'hour'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      return value >= 1 && value <= 24
    },
    set: function (date, value, options) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date
    }
  },

  // Minute
  m: {
    priority: 60,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, string)
        case 'mo':
          return match.ordinalNumber(string, {unit: 'minute'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 59
    },
    set: function (date, value, options) {
      date.setUTCMinutes(value, 0, 0);
      return date
    }
  },

  // Second
  s: {
    priority: 50,
    parse: function (string, token, match, options) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, string)
        case 'so':
          return match.ordinalNumber(string, {unit: 'second'})
        default:
          return parseNDigits(token.length, string)
      }
    },
    validate: function (date, value, options) {
      return value >= 0 && value <= 59
    },
    set: function (date, value, options) {
      date.setUTCSeconds(value, 0);
      return date
    }
  },

  // Fraction of second
  S: {
    priority: 40,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        return Math.floor(value * Math.pow(10, -token.length + 3))
      };
      return parseNDigits(token.length, string, valueCallback)
    },
    set: function (date, value, options) {
      date.setUTCMilliseconds(value);
      return date
    }
  },

  // Timezone (ISO-8601. +00:00 is `'Z'`)
  X: {
    priority: 20,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string)
        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, string)
        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string)
        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string)
        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string)
      }
    },
    set: function (date, value, options) {
      return new Date(date.getTime() - value)
    }
  },

  // Timezone (ISO-8601)
  x: {
    priority: 20,
    parse: function (string, token, match, options) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string)
        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, string)
        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string)
        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string)
        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string)
      }
    },
    set: function (date, value, options) {
      return new Date(date.getTime() - value)
    }
  },

  // Seconds timestamp
  t: {
    priority: 10,
    parse: function (string, token, match, options) {
      return parseAnyDigitsSigned(string)
    },
    set: function (date, value, options) {
      return new Date(value * 1000)
    }
  },

  // Milliseconds timestamp
  T: {
    priority: 10,
    parse: function (string, token, match, options) {
      return parseAnyDigitsSigned(string)
    },
    set: function (date, value, options) {
      return new Date(value)
    }
  }
};

var TIMEZONE_UNIT_PRIORITY = 20;

// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

var escapedStringRegExp$1 = /^'(.*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;

var notWhitespaceRegExp = /\S/;

/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 6     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 6     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 1, 2, ..., 11, 0                  |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              |  40 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  20 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  20 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Seconds timestamp               |  10 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Milliseconds timestamp          |  10 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `baseDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *
 * 6. These tokens are often confused with others. See: https://git.io/fxCyr
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `baseDate` which works as a context of parsing.
 *
 * `baseDate` must be passed for correct work of the function.
 * If you're not sure which `baseDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `baseDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `baseDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|String|Number} baseDate - defines values missing from the parsed dateString
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.awareOfUnicodeTokens=false] - if true, allows usage of Unicode tokens causes confusion:
 *   - Some of the day of year tokens (`D`, `DD`) that are confused with the day of month tokens (`d`, `dd`).
 *   - Some of the local week-numbering year tokens (`YY`, `YYYY`) that are confused with the calendar year tokens (`yy`, `yyyy`).
 *   See: https://git.io/fxCyr
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} `options.awareOfUnicodeTokens` must be set to `true` to use `XX` token; see: https://git.io/fxCyr
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse(
 *   '02/11/2014',
 *   'MM/dd/yyyy',
 *   new Date()
 * )
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse(
 *   '28-a de februaro',
 *   "do 'de' MMMM",
 *   new Date(2010, 0, 1),
 *   {locale: eo}
 * )
 * //=> Sun Feb 28 2010 00:00:00
 */
function parse(
  dirtyDateString,
  dirtyFormatString,
  dirtyBaseDate,
  dirtyOptions
) {
  if (arguments.length < 3) {
    throw new TypeError(
      '3 arguments required, but only ' + arguments.length + ' present'
    )
  }

  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var options = dirtyOptions || {};

  var locale = options.locale || locale$1;

  if (!locale.match) {
    throw new RangeError('locale must contain match property')
  }

  var localeFirstWeekContainsDate =
    locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate =
    localeFirstWeekContainsDate == null
      ? 1
      : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate =
    options.firstWeekContainsDate == null
      ? defaultFirstWeekContainsDate
      : toInteger(options.firstWeekContainsDate);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError(
      'firstWeekContainsDate must be between 1 and 7 inclusively'
    )
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn =
    localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn =
    options.weekStartsOn == null
      ? defaultWeekStartsOn
      : toInteger(options.weekStartsOn);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  }

  if (formatString === '') {
    if (dateString === '') {
      return toDate(dirtyBaseDate, options)
    } else {
      return new Date(NaN)
    }
  }

  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale
  };

  // If timezone isn't specified, it will be set to the system timezone
  var setters = [
    {
      priority: TIMEZONE_UNIT_PRIORITY,
      set: dateToSystemTimezone,
      index: 0
    }
  ];

  var i;

  var tokens = formatString.match(formattingTokensRegExp$1);

  for (i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (!options.awareOfUnicodeTokens && isProtectedToken(token)) {
      throwProtectedError(token);
    }

    var firstCharacter = token[0];
    var parser = parsers[firstCharacter];
    if (parser) {
      var parseResult = parser.parse(
        dateString,
        token,
        locale.match,
        subFnOptions
      );

      if (!parseResult) {
        return new Date(NaN)
      }

      setters.push({
        priority: parser.priority,
        set: parser.set,
        validate: parser.validate,
        value: parseResult.value,
        index: setters.length
      });

      dateString = parseResult.rest;
    } else {
      // Replace two single quote characters with one single quote character
      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString$1(token);
      }

      // Cut token from string, or, if string doesn't match the token, return Invalid Date
      if (dateString.indexOf(token) === 0) {
        dateString = dateString.slice(token.length);
      } else {
        return new Date(NaN)
      }
    }
  }

  // Check if the remaining input contains something other than whitespace
  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN)
  }

  var uniquePrioritySetters = setters
    .map(function(setter) {
      return setter.priority
    })
    .sort(function(a, b) {
      return b - a
    })
    .filter(function(priority, index, array) {
      return array.indexOf(priority) === index
    })
    .map(function(priority) {
      return setters
        .filter(function(setter) {
          return setter.priority === priority
        })
        .reverse()
    })
    .map(function(setterArray) {
      return setterArray[0]
    });

  var date = toDate(dirtyBaseDate, options);

  if (isNaN(date)) {
    return new Date(NaN)
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37
  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));

  for (i = 0; i < uniquePrioritySetters.length; i++) {
    var setter = uniquePrioritySetters[i];

    if (
      setter.validate &&
      !setter.validate(utcDate, setter.value, subFnOptions)
    ) {
      return new Date(NaN)
    }

    utcDate = setter.set(utcDate, setter.value, subFnOptions);
  }

  return utcDate
}

function dateToSystemTimezone(date) {
  var convertedDate = new Date(0);
  convertedDate.setFullYear(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate()
  );
  convertedDate.setHours(
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds(),
    date.getUTCMilliseconds()
  );
  return convertedDate
}

function cleanEscapedString$1(input) {
  return input.match(escapedStringRegExp$1)[1].replace(doubleQuoteRegExp$1, "'")
}

// 

/**
 * Custom parse behavior on top of date-fns parse function.
 */
function parseDate$1 (date, format$1) {
  if (typeof date !== 'string') {
    return isValid(date) ? date : null;
  }

  var parsed = parse(date, format$1, new Date());

  // if date is not valid or the formatted output after parsing does not match
  // the string value passed in (avoids overflows)
  if (!isValid(parsed) || format(parsed, format$1) !== date) {
    return null;
  }

  return parsed;
}

var afterValidator = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var targetValue = ref.targetValue;
  var inclusion = ref.inclusion; if ( inclusion === void 0 ) inclusion = false;
  var format = ref.format;

  if (typeof format === 'undefined') {
    format = inclusion;
    inclusion = false;
  }

  value = parseDate$1(value, format);
  targetValue = parseDate$1(targetValue, format);

  // if either is not valid.
  if (!value || !targetValue) {
    return false;
  }

  return isAfter(value, targetValue) || (inclusion && isEqual$1(value, targetValue));
};

var options = {
  hasTarget: true,
  isDate: true
};

// required to convert from a list of array values to an object.
var paramNames = ['targetValue', 'inclusion', 'format'];

var after = {
  validate: afterValidator,
  options: options,
  paramNames: paramNames
};

/**
 * Some Alpha Regex helpers.
 * https://github.com/chriso/validator.js/blob/master/src/lib/alpha.js
 */

var alpha = {
  en: /^[A-Z]*$/i,
  cs: /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,
  da: /^[A-ZÆØÅ]*$/i,
  de: /^[A-ZÄÖÜß]*$/i,
  es: /^[A-ZÁÉÍÑÓÚÜ]*$/i,
  fa: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی]*$/,
  fr: /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,
  it: /^[A-Z\xC0-\xFF]*$/i,
  lt: /^[A-ZĄČĘĖĮŠŲŪŽ]*$/i,
  nl: /^[A-ZÉËÏÓÖÜ]*$/i,
  hu: /^[A-ZÁÉÍÓÖŐÚÜŰ]*$/i,
  pl: /^[A-ZĄĆĘŚŁŃÓŻŹ]*$/i,
  pt: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,
  ru: /^[А-ЯЁ]*$/i,
  sk: /^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,
  sr: /^[A-ZČĆŽŠĐ]*$/i,
  sv: /^[A-ZÅÄÖ]*$/i,
  tr: /^[A-ZÇĞİıÖŞÜ]*$/i,
  uk: /^[А-ЩЬЮЯЄІЇҐ]*$/i,
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/,
  az: /^[A-ZÇƏĞİıÖŞÜ]*$/i
};

var alphaSpaces = {
  en: /^[A-Z\s]*$/i,
  cs: /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ\s]*$/i,
  da: /^[A-ZÆØÅ\s]*$/i,
  de: /^[A-ZÄÖÜß\s]*$/i,
  es: /^[A-ZÁÉÍÑÓÚÜ\s]*$/i,
  fa: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی\s]*$/,
  fr: /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ\s]*$/i,
  it: /^[A-Z\xC0-\xFF\s]*$/i,
  lt: /^[A-ZĄČĘĖĮŠŲŪŽ\s]*$/i,
  nl: /^[A-ZÉËÏÓÖÜ\s]*$/i,
  hu: /^[A-ZÁÉÍÓÖŐÚÜŰ\s]*$/i,
  pl: /^[A-ZĄĆĘŚŁŃÓŻŹ\s]*$/i,
  pt: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ\s]*$/i,
  ru: /^[А-ЯЁ\s]*$/i,
  sk: /^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ\s]*$/i,
  sr: /^[A-ZČĆŽŠĐ\s]*$/i,
  sv: /^[A-ZÅÄÖ\s]*$/i,
  tr: /^[A-ZÇĞİıÖŞÜ\s]*$/i,
  uk: /^[А-ЩЬЮЯЄІЇҐ\s]*$/i,
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ\s]*$/,
  az: /^[A-ZÇƏĞİıÖŞÜ\s]*$/i
};

var alphanumeric = {
  en: /^[0-9A-Z]*$/i,
  cs: /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,
  da: /^[0-9A-ZÆØÅ]$/i,
  de: /^[0-9A-ZÄÖÜß]*$/i,
  es: /^[0-9A-ZÁÉÍÑÓÚÜ]*$/i,
  fa: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی]*$/,
  fr: /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,
  it: /^[0-9A-Z\xC0-\xFF]*$/i,
  lt: /^[0-9A-ZĄČĘĖĮŠŲŪŽ]*$/i,
  hu: /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]*$/i,
  nl: /^[0-9A-ZÉËÏÓÖÜ]*$/i,
  pl: /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]*$/i,
  pt: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,
  ru: /^[0-9А-ЯЁ]*$/i,
  sk: /^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,
  sr: /^[0-9A-ZČĆŽŠĐ]*$/i,
  sv: /^[0-9A-ZÅÄÖ]*$/i,
  tr: /^[0-9A-ZÇĞİıÖŞÜ]*$/i,
  uk: /^[0-9А-ЩЬЮЯЄІЇҐ]*$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/,
  az: /^[0-9A-ZÇƏĞİıÖŞÜ]*$/i
};

var alphaDash = {
  en: /^[0-9A-Z_-]*$/i,
  cs: /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ_-]*$/i,
  da: /^[0-9A-ZÆØÅ_-]*$/i,
  de: /^[0-9A-ZÄÖÜß_-]*$/i,
  es: /^[0-9A-ZÁÉÍÑÓÚÜ_-]*$/i,
  fa: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی_-]*$/,
  fr: /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ_-]*$/i,
  it: /^[0-9A-Z\xC0-\xFF_-]*$/i,
  lt: /^[0-9A-ZĄČĘĖĮŠŲŪŽ_-]*$/i,
  nl: /^[0-9A-ZÉËÏÓÖÜ_-]*$/i,
  hu: /^[0-9A-ZÁÉÍÓÖŐÚÜŰ_-]*$/i,
  pl: /^[0-9A-ZĄĆĘŚŁŃÓŻŹ_-]*$/i,
  pt: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ_-]*$/i,
  ru: /^[0-9А-ЯЁ_-]*$/i,
  sk: /^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ_-]*$/i,
  sr: /^[0-9A-ZČĆŽŠĐ_-]*$/i,
  sv: /^[0-9A-ZÅÄÖ_-]*$/i,
  tr: /^[0-9A-ZÇĞİıÖŞÜ_-]*$/i,
  uk: /^[0-9А-ЩЬЮЯЄІЇҐ_-]*$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ_-]*$/,
  az: /^[0-9A-ZÇƏĞİıÖŞÜ_-]*$/i
};

var validate = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var locale = ref.locale;

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate(val, [locale]); });
  }

  // Match at least one locale.
  if (! locale) {
    return Object.keys(alpha).some(function (loc) { return alpha[loc].test(value); });
  }

  return (alpha[locale] || alpha.en).test(value);
};

var paramNames$1 = ['locale'];

var alpha$1 = {
  validate: validate,
  paramNames: paramNames$1
};

var validate$1 = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var locale = ref.locale;

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$1(val, [locale]); });
  }

  // Match at least one locale.
  if (! locale) {
    return Object.keys(alphaDash).some(function (loc) { return alphaDash[loc].test(value); });
  }

  return (alphaDash[locale] || alphaDash.en).test(value);
};

var paramNames$2 = ['locale'];

var alpha_dash = {
  validate: validate$1,
  paramNames: paramNames$2
};

var validate$2 = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var locale = ref.locale;

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$2(val, [locale]); });
  }

  // Match at least one locale.
  if (! locale) {
    return Object.keys(alphanumeric).some(function (loc) { return alphanumeric[loc].test(value); });
  }

  return (alphanumeric[locale] || alphanumeric.en).test(value);
};

var paramNames$3 = ['locale'];

var alpha_num = {
  validate: validate$2,
  paramNames: paramNames$3
};

var validate$3 = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var locale = ref.locale;

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$3(val, [locale]); });
  }

  // Match at least one locale.
  if (! locale) {
    return Object.keys(alphaSpaces).some(function (loc) { return alphaSpaces[loc].test(value); });
  }

  return (alphaSpaces[locale] || alphaSpaces.en).test(value);
};

var paramNames$4 = ['locale'];

var alpha_spaces = {
  validate: validate$3,
  paramNames: paramNames$4
};

var validate$4 = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var targetValue = ref.targetValue;
  var inclusion = ref.inclusion; if ( inclusion === void 0 ) inclusion = false;
  var format = ref.format;

  if (typeof format === 'undefined') {
    format = inclusion;
    inclusion = false;
  }

  value = parseDate$1(value, format);
  targetValue = parseDate$1(targetValue, format);

  // if either is not valid.
  if (!value || !targetValue) {
    return false;
  }

  return isBefore(value, targetValue) || (inclusion && isEqual$1(value, targetValue));
};

var options$1 = {
  hasTarget: true,
  isDate: true
};

var paramNames$5 = ['targetValue', 'inclusion', 'format'];

var before = {
  validate: validate$4,
  options: options$1,
  paramNames: paramNames$5
};

var validate$5 = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var min = ref.min;
  var max = ref.max;

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$5(val, { min: min, max: max }); });
  }

  return Number(min) <= value && Number(max) >= value;
};

var paramNames$6 = ['min', 'max'];

var between = {
  validate: validate$5,
  paramNames: paramNames$6
};

var validate$6 = function (value, ref) {
  var targetValue = ref.targetValue;

  return String(value) === String(targetValue);
};
var options$2 = {
  hasTarget: true
};

var paramNames$7 = ['targetValue'];

var confirmed = {
  validate: validate$6,
  options: options$2,
  paramNames: paramNames$7
};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var assertString_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assertString;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function assertString(input) {
  var isString = typeof input === 'string' || input instanceof String;

  if (!isString) {
    var invalidType;

    if (input === null) {
      invalidType = 'null';
    } else {
      invalidType = _typeof(input);

      if (invalidType === 'object' && input.constructor && input.constructor.hasOwnProperty('name')) {
        invalidType = input.constructor.name;
      } else {
        invalidType = "a ".concat(invalidType);
      }
    }

    throw new TypeError("Expected string but received ".concat(invalidType, "."));
  }
}

module.exports = exports.default;
module.exports.default = exports.default;
});

unwrapExports(assertString_1);

var isCreditCard_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isCreditCard;

var _assertString = _interopRequireDefault(assertString_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|6[27][0-9]{14})$/;
/* eslint-enable max-len */

function isCreditCard(str) {
  (0, _assertString.default)(str);
  var sanitized = str.replace(/[- ]+/g, '');

  if (!creditCard.test(sanitized)) {
    return false;
  }

  var sum = 0;
  var digit;
  var tmpNum;
  var shouldDouble;

  for (var i = sanitized.length - 1; i >= 0; i--) {
    digit = sanitized.substring(i, i + 1);
    tmpNum = parseInt(digit, 10);

    if (shouldDouble) {
      tmpNum *= 2;

      if (tmpNum >= 10) {
        sum += tmpNum % 10 + 1;
      } else {
        sum += tmpNum;
      }
    } else {
      sum += tmpNum;
    }

    shouldDouble = !shouldDouble;
  }

  return !!(sum % 10 === 0 ? sanitized : false);
}

module.exports = exports.default;
module.exports.default = exports.default;
});

var isCreditCard = unwrapExports(isCreditCard_1);

var validate$7 = function (value) { return isCreditCard(String(value)); };

var credit_card = {
  validate: validate$7
};

var validate$8 = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var min = ref.min;
  var max = ref.max;
  var inclusivity = ref.inclusivity; if ( inclusivity === void 0 ) inclusivity = '()';
  var format = ref.format;

  if (typeof format === 'undefined') {
    format = inclusivity;
    inclusivity = '()';
  }

  var minDate = parseDate$1(String(min), format);
  var maxDate = parseDate$1(String(max), format);
  var dateVal = parseDate$1(String(value), format);

  if (!minDate || !maxDate || !dateVal) {
    return false;
  }

  if (inclusivity === '()') {
    return isAfter(dateVal, minDate) && isBefore(dateVal, maxDate);
  }

  if (inclusivity === '(]') {
    return isAfter(dateVal, minDate) && (isEqual$1(dateVal, maxDate) || isBefore(dateVal, maxDate));
  }

  if (inclusivity === '[)') {
    return isBefore(dateVal, maxDate) && (isEqual$1(dateVal, minDate) || isAfter(dateVal, minDate));
  }

  return isEqual$1(dateVal, maxDate) || isEqual$1(dateVal, minDate) ||
    (isBefore(dateVal, maxDate) && isAfter(dateVal, minDate));
};

var options$3 = {
  isDate: true
};

var paramNames$8 = ['min', 'max', 'inclusivity', 'format'];

var date_between = {
  validate: validate$8,
  options: options$3,
  paramNames: paramNames$8
};

var validate$9 = function (value, ref) {
  var format = ref.format;

  return !!parseDate$1(value, format);
};

var options$4 = {
  isDate: true
};

var paramNames$9 = ['format'];

var date_format = {
  validate: validate$9,
  options: options$4,
  paramNames: paramNames$9
};

var validate$a = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var decimals = ref.decimals; if ( decimals === void 0 ) decimals = '*';
  var separator = ref.separator; if ( separator === void 0 ) separator = '.';

  if (isNullOrUndefined(value) || value === '') {
    return false;
  }

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$a(val, { decimals: decimals, separator: separator }); });
  }

  // if is 0.
  if (Number(decimals) === 0) {
    return /^-?\d*$/.test(value);
  }

  var regexPart = decimals === '*' ? '+' : ("{1," + decimals + "}");
  var regex = new RegExp(("^[-+]?\\d*(\\" + separator + "\\d" + regexPart + ")?([eE]{1}[-]?\\d+)?$"));

  if (! regex.test(value)) {
    return false;
  }

  var parsedValue = parseFloat(value);

  // eslint-disable-next-line
  return parsedValue === parsedValue;
};

var paramNames$a = ['decimals', 'separator'];

var decimal = {
  validate: validate$a,
  paramNames: paramNames$a
};

var validate$b = function (value, ref) {
  var length = ref[0];

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$b(val, [length]); });
  }
  var strVal = String(value);

  return /^[0-9]*$/.test(strVal) && strVal.length === Number(length);
};

var digits = {
  validate: validate$b
};

var imageRegex = /\.(jpg|svg|jpeg|png|bmp|gif)$/i;

var validateImage = function (file, width, height) {
  var URL = window.URL || window.webkitURL;
  return new Promise(function (resolve) {
    var image = new Image();
    image.onerror = function () { return resolve({ valid: false }); };
    image.onload = function () { return resolve({
      valid: image.width === Number(width) && image.height === Number(height)
    }); };

    image.src = URL.createObjectURL(file);
  });
};

var validate$c = function (files, ref) {
  var width = ref[0];
  var height = ref[1];

  var images = ensureArray(files).filter(function (file) { return imageRegex.test(file.name); });
  if (images.length === 0) {
    return false;
  }
  return Promise.all(images.map(function (image) { return validateImage(image, width, height); }));
};

var dimensions = {
  validate: validate$c
};

var merge_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = merge;

function merge() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaults = arguments.length > 1 ? arguments[1] : undefined;

  for (var key in defaults) {
    if (typeof obj[key] === 'undefined') {
      obj[key] = defaults[key];
    }
  }

  return obj;
}

module.exports = exports.default;
module.exports.default = exports.default;
});

unwrapExports(merge_1);

var isByteLength_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isByteLength;

var _assertString = _interopRequireDefault(assertString_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* eslint-disable prefer-rest-params */
function isByteLength(str, options) {
  (0, _assertString.default)(str);
  var min;
  var max;

  if (_typeof(options) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isByteLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }

  var len = encodeURI(str).split(/%..|./).length - 1;
  return len >= min && (typeof max === 'undefined' || len <= max);
}

module.exports = exports.default;
module.exports.default = exports.default;
});

unwrapExports(isByteLength_1);

var isFQDN_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFQDN;

var _assertString = _interopRequireDefault(assertString_1);

var _merge = _interopRequireDefault(merge_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_fqdn_options = {
  require_tld: true,
  allow_underscores: false,
  allow_trailing_dot: false
};

function isFQDN(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_fqdn_options);
  /* Remove the optional trailing dot before checking validity */

  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
    str = str.substring(0, str.length - 1);
  }

  var parts = str.split('.');

  for (var i = 0; i < parts.length; i++) {
    if (parts[i].length > 63) {
      return false;
    }
  }

  if (options.require_tld) {
    var tld = parts.pop();

    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
      return false;
    } // disallow spaces


    if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
      return false;
    }
  }

  for (var part, _i = 0; _i < parts.length; _i++) {
    part = parts[_i];

    if (options.allow_underscores) {
      part = part.replace(/_/g, '');
    }

    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
      return false;
    } // disallow full-width chars


    if (/[\uff01-\uff5e]/.test(part)) {
      return false;
    }

    if (part[0] === '-' || part[part.length - 1] === '-') {
      return false;
    }
  }

  return true;
}

module.exports = exports.default;
module.exports.default = exports.default;
});

var isFQDN = unwrapExports(isFQDN_1);

var isIP_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isIP;

var _assertString = _interopRequireDefault(assertString_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ipv4Maybe = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
var ipv6Block = /^[0-9A-F]{1,4}$/i;

function isIP(str) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  (0, _assertString.default)(str);
  version = String(version);

  if (!version) {
    return isIP(str, 4) || isIP(str, 6);
  } else if (version === '4') {
    if (!ipv4Maybe.test(str)) {
      return false;
    }

    var parts = str.split('.').sort(function (a, b) {
      return a - b;
    });
    return parts[3] <= 255;
  } else if (version === '6') {
    var blocks = str.split(':');
    var foundOmissionBlock = false; // marker to indicate ::
    // At least some OS accept the last 32 bits of an IPv6 address
    // (i.e. 2 of the blocks) in IPv4 notation, and RFC 3493 says
    // that '::ffff:a.b.c.d' is valid for IPv4-mapped IPv6 addresses,
    // and '::a.b.c.d' is deprecated, but also valid.

    var foundIPv4TransitionBlock = isIP(blocks[blocks.length - 1], 4);
    var expectedNumberOfBlocks = foundIPv4TransitionBlock ? 7 : 8;

    if (blocks.length > expectedNumberOfBlocks) {
      return false;
    } // initial or final ::


    if (str === '::') {
      return true;
    } else if (str.substr(0, 2) === '::') {
      blocks.shift();
      blocks.shift();
      foundOmissionBlock = true;
    } else if (str.substr(str.length - 2) === '::') {
      blocks.pop();
      blocks.pop();
      foundOmissionBlock = true;
    }

    for (var i = 0; i < blocks.length; ++i) {
      // test for a :: which can not be at the string start/end
      // since those cases have been handled above
      if (blocks[i] === '' && i > 0 && i < blocks.length - 1) {
        if (foundOmissionBlock) {
          return false; // multiple :: in address
        }

        foundOmissionBlock = true;
      } else if (foundIPv4TransitionBlock && i === blocks.length - 1) ; else if (!ipv6Block.test(blocks[i])) {
        return false;
      }
    }

    if (foundOmissionBlock) {
      return blocks.length >= 1;
    }

    return blocks.length === expectedNumberOfBlocks;
  }

  return false;
}

module.exports = exports.default;
module.exports.default = exports.default;
});

var isIP = unwrapExports(isIP_1);

var isEmail_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmail;

var _assertString = _interopRequireDefault(assertString_1);

var _merge = _interopRequireDefault(merge_1);

var _isByteLength = _interopRequireDefault(isByteLength_1);

var _isFQDN = _interopRequireDefault(isFQDN_1);

var _isIP = _interopRequireDefault(isIP_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_email_options = {
  allow_display_name: false,
  require_display_name: false,
  allow_utf8_local_part: true,
  require_tld: true
};
/* eslint-disable max-len */

/* eslint-disable no-control-regex */

var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\,\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var gmailUserPart = /^[a-z\d]+$/;
var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
/* eslint-enable max-len */

/* eslint-enable no-control-regex */

function isEmail(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_email_options);

  if (options.require_display_name || options.allow_display_name) {
    var display_email = str.match(displayName);

    if (display_email) {
      str = display_email[1];
    } else if (options.require_display_name) {
      return false;
    }
  }

  var parts = str.split('@');
  var domain = parts.pop();
  var user = parts.join('@');
  var lower_domain = domain.toLowerCase();

  if (options.domain_specific_validation && (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com')) {
    /*
      Previously we removed dots for gmail addresses before validating.
      This was removed because it allows `multiple..dots@gmail.com`
      to be reported as valid, but it is not.
      Gmail only normalizes single dots, removing them from here is pointless,
      should be done in normalizeEmail
    */
    user = user.toLowerCase(); // Removing sub-address from username before gmail validation

    var username = user.split('+')[0]; // Dots are not included in gmail length restriction

    if (!(0, _isByteLength.default)(username.replace('.', ''), {
      min: 6,
      max: 30
    })) {
      return false;
    }

    var _user_parts = username.split('.');

    for (var i = 0; i < _user_parts.length; i++) {
      if (!gmailUserPart.test(_user_parts[i])) {
        return false;
      }
    }
  }

  if (!(0, _isByteLength.default)(user, {
    max: 64
  }) || !(0, _isByteLength.default)(domain, {
    max: 254
  })) {
    return false;
  }

  if (!(0, _isFQDN.default)(domain, {
    require_tld: options.require_tld
  })) {
    if (!options.allow_ip_domain) {
      return false;
    }

    if (!(0, _isIP.default)(domain)) {
      if (!domain.startsWith('[') || !domain.endsWith(']')) {
        return false;
      }

      var noBracketdomain = domain.substr(1, domain.length - 2);

      if (noBracketdomain.length === 0 || !(0, _isIP.default)(noBracketdomain)) {
        return false;
      }
    }
  }

  if (user[0] === '"') {
    user = user.slice(1, user.length - 1);
    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
  }

  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
  var user_parts = user.split('.');

  for (var _i = 0; _i < user_parts.length; _i++) {
    if (!pattern.test(user_parts[_i])) {
      return false;
    }
  }

  return true;
}

module.exports = exports.default;
module.exports.default = exports.default;
});

var isEmail = unwrapExports(isEmail_1);

function objectWithoutProperties (obj, exclude) { var target = {}; for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k]; return target; }

var validate$d = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var multiple = ref.multiple; if ( multiple === void 0 ) multiple = false;
  var rest = objectWithoutProperties( ref, ["multiple"] );
  var options = rest;

  if (multiple && !Array.isArray(value)) {
    value = String(value).split(',').map(function (emailStr) { return emailStr.trim(); });
  }

  var validatorOptions = assign({}, options);

  if (Array.isArray(value)) {
    return value.every(function (val) { return isEmail(String(val), validatorOptions); });
  }

  return isEmail(String(value), validatorOptions);
};

var email = {
  validate: validate$d
};

var validate$e = function (value, options) {
  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$e(val, options); });
  }

  return toArray(options).some(function (item) {
    // eslint-disable-next-line
    return item == value;
  });
};

var included = {
  validate: validate$e
};

var validate$f = function () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return !validate$e.apply(void 0, args);
};

var excluded = {
  validate: validate$f
};

var validate$g = function (files, extensions) {
  var regex = new RegExp((".(" + (extensions.join('|')) + ")$"), 'i');
  return ensureArray(files).every(function (file) { return regex.test(file.name); });
};

var ext = {
  validate: validate$g
};

var validate$h = function (files) { return (Array.isArray(files) ? files : [files]).every(function (file) { return /\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(file.name); }); };

var image = {
  validate: validate$h
};

var validate$i = function (value) {
  if (Array.isArray(value)) {
    return value.every(function (val) { return /^-?[0-9]+$/.test(String(val)); });
  }

  return /^-?[0-9]+$/.test(String(value));
};

var integer = {
  validate: validate$i
};

var validate$j = function (value, ref) {
  if ( ref === void 0 ) ref = {};
  var version = ref.version; if ( version === void 0 ) version = 4;

  if (isNullOrUndefined(value)) {
    value = '';
  }

  if (Array.isArray(value)) {
    return value.every(function (val) { return isIP(val, version); });
  }

  return isIP(value, version);
};

var paramNames$b = ['version'];

var ip = {
  validate: validate$j,
  paramNames: paramNames$b
};

var validate$k = function (value) {
  if (isNullOrUndefined(value)) {
    value = '';
  }

  if (Array.isArray(value)) {
    return value.every(function (val) { return (isIP(val, '') || isFQDN(val)); });
  }

  return isIP(value, '') || isFQDN(value);
};

var ip_or_fqdn = {
  validate: validate$k
};

var validate$l = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var other = ref[0];

  return value === other;
};

var is = {
  validate: validate$l
};

var validate$m = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var other = ref[0];

  return value !== other;
};

var is_not = {
  validate: validate$m
};

/**
 * @param {Array|String} value
 * @param {Number} length
 * @param {Number} max
 */
var compare = function (value, length, max) {
  if (max === undefined) {
    return value.length === length;
  }

  // cast to number.
  max = Number(max);

  return value.length >= length && value.length <= max;
};

var validate$n = function (value, ref) {
  var length = ref[0];
  var max = ref[1]; if ( max === void 0 ) max = undefined;

  if (isNullOrUndefined(value)) {
    return false;
  }

  length = Number(length);
  if (typeof value === 'number') {
    value = String(value);
  }

  if (!value.length) {
    value = toArray(value);
  }

  return compare(value, length, max);
};

var length = {
  validate: validate$n
};

var validate$o = function (value, ref) {
  var length = ref[0];

  if (isNullOrUndefined(value)) {
    return length >= 0;
  }

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$o(val, [length]); });
  }

  return String(value).length <= length;
};

var max = {
  validate: validate$o
};

var validate$p = function (value, ref) {
  var max = ref[0];

  if (isNullOrUndefined(value) || value === '') {
    return false;
  }

  if (Array.isArray(value)) {
    return value.length > 0 && value.every(function (val) { return validate$p(val, [max]); });
  }

  return Number(value) <= max;
};

var max_value = {
  validate: validate$p
};

var validate$q = function (files, mimes) {
  var regex = new RegExp(((mimes.join('|').replace('*', '.+')) + "$"), 'i');
  return ensureArray(files).every(function (file) { return regex.test(file.type); });
};

var mimes = {
  validate: validate$q
};

var validate$r = function (value, ref) {
  var length = ref[0];

  if (isNullOrUndefined(value)) {
    return false;
  }

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$r(val, [length]); });
  }

  return String(value).length >= length;
};

var min = {
  validate: validate$r
};

var validate$s = function (value, ref) {
  var min = ref[0];

  if (isNullOrUndefined(value) || value === '') {
    return false;
  }

  if (Array.isArray(value)) {
    return value.length > 0 && value.every(function (val) { return validate$s(val, [min]); });
  }

  return Number(value) >= min;
};

var min_value = {
  validate: validate$s
};

var ar = /^[٠١٢٣٤٥٦٧٨٩]+$/;
var en = /^[0-9]+$/;

var validate$t = function (value) {
  var testValue = function (val) {
    var strValue = String(val);

    return en.test(strValue) || ar.test(strValue);
  };

  if (Array.isArray(value)) {
    return value.every(testValue);
  }

  return testValue(value);
};

var numeric = {
  validate: validate$t
};

var validate$u = function (value, ref) {
  var expression = ref.expression;

  if (typeof expression === 'string') {
    expression = new RegExp(expression);
  }

  if (Array.isArray(value)) {
    return value.every(function (val) { return validate$u(val, { expression: expression }); });
  }

  return expression.test(String(value));
};

var paramNames$c = ['expression'];

var regex = {
  validate: validate$u,
  paramNames: paramNames$c
};

var validate$v = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var invalidateFalse = ref[0]; if ( invalidateFalse === void 0 ) invalidateFalse = false;

  if (isNullOrUndefined(value) || isEmptyArray(value)) {
    return false;
  }

  // incase a field considers `false` as an empty value like checkboxes.
  if (value === false && invalidateFalse) {
    return false;
  }

  return !!String(value).trim().length;
};

var required = {
  validate: validate$v
};

var validate$w = function (value, ref) {
  if ( ref === void 0 ) ref = [];
  var otherFieldVal = ref[0];
  var possibleVals = ref.slice(1);

  var required = possibleVals.includes(String(otherFieldVal).trim());

  if (!required) {
    return {
      valid: true,
      data: {
        required: required
      }
    };
  }

  var invalid = (isEmptyArray(value) || [false, null, undefined].includes(value));

  invalid = invalid || !String(value).trim().length;

  return {
    valid: !invalid,
    data: {
      required: required
    }
  };
};

var options$5 = {
  hasTarget: true,
  computesRequired: true
};

var required_if = {
  validate: validate$w,
  options: options$5
};

var validate$x = function (files, ref) {
  var size = ref[0];

  if (isNaN(size)) {
    return false;
  }
  var nSize = Number(size) * 1024;
  return ensureArray(files).every(function (file) { return file.size <= nSize; });
};

var size = {
  validate: validate$x
};

var isURL_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isURL;

var _assertString = _interopRequireDefault(assertString_1);

var _isFQDN = _interopRequireDefault(isFQDN_1);

var _isIP = _interopRequireDefault(isIP_1);

var _merge = _interopRequireDefault(merge_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_url_options = {
  protocols: ['http', 'https', 'ftp'],
  require_tld: true,
  require_protocol: false,
  require_host: true,
  require_valid_protocol: true,
  allow_underscores: false,
  allow_trailing_dot: false,
  allow_protocol_relative_urls: false
};
var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;

function isRegExp(obj) {
  return Object.prototype.toString.call(obj) === '[object RegExp]';
}

function checkHost(host, matches) {
  for (var i = 0; i < matches.length; i++) {
    var match = matches[i];

    if (host === match || isRegExp(match) && match.test(host)) {
      return true;
    }
  }

  return false;
}

function isURL(url, options) {
  (0, _assertString.default)(url);

  if (!url || url.length >= 2083 || /[\s<>]/.test(url)) {
    return false;
  }

  if (url.indexOf('mailto:') === 0) {
    return false;
  }

  options = (0, _merge.default)(options, default_url_options);
  var protocol, auth, host, hostname, port, port_str, split, ipv6;
  split = url.split('#');
  url = split.shift();
  split = url.split('?');
  url = split.shift();
  split = url.split('://');

  if (split.length > 1) {
    protocol = split.shift().toLowerCase();

    if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
      return false;
    }
  } else if (options.require_protocol) {
    return false;
  } else if (url.substr(0, 2) === '//') {
    if (!options.allow_protocol_relative_urls) {
      return false;
    }

    split[0] = url.substr(2);
  }

  url = split.join('://');

  if (url === '') {
    return false;
  }

  split = url.split('/');
  url = split.shift();

  if (url === '' && !options.require_host) {
    return true;
  }

  split = url.split('@');

  if (split.length > 1) {
    if (options.disallow_auth) {
      return false;
    }

    auth = split.shift();

    if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
      return false;
    }
  }

  hostname = split.join('@');
  port_str = null;
  ipv6 = null;
  var ipv6_match = hostname.match(wrapped_ipv6);

  if (ipv6_match) {
    host = '';
    ipv6 = ipv6_match[1];
    port_str = ipv6_match[2] || null;
  } else {
    split = hostname.split(':');
    host = split.shift();

    if (split.length) {
      port_str = split.join(':');
    }
  }

  if (port_str !== null) {
    port = parseInt(port_str, 10);

    if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
      return false;
    }
  }

  if (!(0, _isIP.default)(host) && !(0, _isFQDN.default)(host, options) && (!ipv6 || !(0, _isIP.default)(ipv6, 6))) {
    return false;
  }

  host = host || ipv6;

  if (options.host_whitelist && !checkHost(host, options.host_whitelist)) {
    return false;
  }

  if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
    return false;
  }

  return true;
}

module.exports = exports.default;
module.exports.default = exports.default;
});

var isURL = unwrapExports(isURL_1);

var validate$y = function (value, options) {
  if ( options === void 0 ) options = {};

  if (isNullOrUndefined(value)) {
    value = '';
  }

  var validatorOptions = assign({}, options);

  if (Array.isArray(value)) {
    return value.every(function (val) { return isURL(val, validatorOptions); });
  }

  return isURL(value, validatorOptions);
};

var url = {
  validate: validate$y
};

/* eslint-disable camelcase */

var Rules = /*#__PURE__*/Object.freeze({
  after: after,
  alpha_dash: alpha_dash,
  alpha_num: alpha_num,
  alpha_spaces: alpha_spaces,
  alpha: alpha$1,
  before: before,
  between: between,
  confirmed: confirmed,
  credit_card: credit_card,
  date_between: date_between,
  date_format: date_format,
  decimal: decimal,
  digits: digits,
  dimensions: dimensions,
  email: email,
  ext: ext,
  image: image,
  included: included,
  integer: integer,
  length: length,
  ip: ip,
  ip_or_fqdn: ip_or_fqdn,
  is_not: is_not,
  is: is,
  max: max,
  max_value: max_value,
  mimes: mimes,
  min: min,
  min_value: min_value,
  excluded: excluded,
  numeric: numeric,
  regex: regex,
  required: required,
  required_if: required_if,
  size: size,
  url: url
});

// 

var normalize = function (fields) {
  if (Array.isArray(fields)) {
    return fields.reduce(function (prev, curr) {
      if (includes(curr, '.')) {
        prev[curr.split('.')[1]] = curr;
      } else {
        prev[curr] = curr;
      }

      return prev;
    }, {});
  }

  return fields;
};

// Combines two flags using either AND or OR depending on the flag type.
var combine = function (lhs, rhs) {
  var mapper = {
    pristine: function (lhs, rhs) { return lhs && rhs; },
    dirty: function (lhs, rhs) { return lhs || rhs; },
    touched: function (lhs, rhs) { return lhs || rhs; },
    untouched: function (lhs, rhs) { return lhs && rhs; },
    valid: function (lhs, rhs) { return lhs && rhs; },
    invalid: function (lhs, rhs) { return lhs || rhs; },
    pending: function (lhs, rhs) { return lhs || rhs; },
    required: function (lhs, rhs) { return lhs || rhs; },
    validated: function (lhs, rhs) { return lhs && rhs; }
  };

  return Object.keys(mapper).reduce(function (flags, flag) {
    flags[flag] = mapper[flag](lhs[flag], rhs[flag]);

    return flags;
  }, {});
};

var mapScope = function (scope, deep) {
  if ( deep === void 0 ) deep = true;

  return Object.keys(scope).reduce(function (flags, field) {
    if (!flags) {
      flags = assign({}, scope[field]);
      return flags;
    }

    // scope.
    var isScope = field.indexOf('$') === 0;
    if (deep && isScope) {
      return combine(mapScope(scope[field]), flags);
    } else if (!deep && isScope) {
      return flags;
    }

    flags = combine(flags, scope[field]);

    return flags;
  }, null);
};

/**
 * Maps fields to computed functions.
 */
var mapFields = function (fields) {
  if (!fields) {
    return function () {
      return mapScope(this.$validator.flags);
    };
  }

  var normalized = normalize(fields);
  return Object.keys(normalized).reduce(function (prev, curr) {
    var field = normalized[curr];
    prev[curr] = function mappedField () {
      // if field exists
      if (this.$validator.flags[field]) {
        return this.$validator.flags[field];
      }

      // scopeless fields were selected.
      if (normalized[curr] === '*') {
        return mapScope(this.$validator.flags, false);
      }

      // if it has a scope defined
      var index = field.indexOf('.');
      if (index <= 0) {
        return {};
      }

      var ref = field.split('.');
      var scope = ref[0];
      var name = ref.slice(1);

      scope = this.$validator.flags[("$" + scope)];
      name = name.join('.');

      // an entire scope was selected: scope.*
      if (name === '*' && scope) {
        return mapScope(scope);
      }

      if (scope && scope[name]) {
        return scope[name];
      }

      return {};
    };

    return prev;
  }, {});
};

var $validator = null;

var PROVIDER_COUNTER = 0;

var ValidationProvider = {
  $__veeInject: false,
  inject: {
    $_veeObserver: {
      from: '$_veeObserver',
      default: function default$1 () {
        if (!this.$vnode.context.$_veeObserver) {
          this.$vnode.context.$_veeObserver = createObserver();
        }

        return this.$vnode.context.$_veeObserver;
      }
    }
  },
  props: {
    vid: {
      type: [String, Number],
      default: function () {
        PROVIDER_COUNTER++;

        return ("_vee_" + PROVIDER_COUNTER);
      }
    },
    name: {
      type: String,
      default: null
    },
    mode: {
      type: [String, Function],
      default: function () {
        return getConfig().mode;
      }
    },
    events: {
      type: Array,
      validate: function () {
        /* istanbul ignore next */
        if (false) {
          warn('events prop and config will be deprecated in future version please use the interaction modes instead');
        }

        return true;
      },
      default: function () {
        var events = getConfig().events;
        if (typeof events === 'string') {
          return events.split('|');
        }

        return events;
      }
    },
    rules: {
      type: [Object, String],
      default: null
    },
    immediate: {
      type: Boolean,
      default: false
    },
    persist: {
      type: Boolean,
      default: false
    },
    bails: {
      type: Boolean,
      default: function () { return getConfig().fastExit; }
    },
    debounce: {
      type: Number,
      default: function () { return getConfig().delay || 0; }
    },
    tag: {
      type: String,
      default: 'span'
    },
    slim: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    rules: {
      deep: true,
      handler: function handler (val, oldVal) {
        this._needsValidation = !isEqual(val, oldVal);
      }
    }
  },
  data: function () { return ({
    messages: [],
    value: undefined,
    initialized: false,
    initialValue: undefined,
    flags: createFlags(),
    failedRules: {},
    forceRequired: false,
    isDeactivated: false,
    id: null
  }); },
  computed: {
    isValid: function isValid () {
      return this.flags.valid;
    },
    fieldDeps: function fieldDeps () {
      var this$1 = this;

      var rules = normalizeRules(this.rules);

      return Object.keys(rules).filter(RuleContainer.isTargetRule).map(function (rule) {
        var depName = rules[rule][0];
        watchCrossFieldDep(this$1, depName);

        return depName;
      });
    },
    normalizedEvents: function normalizedEvents () {
      var this$1 = this;

      var ref = computeModeSetting(this);
      var on = ref.on;

      return normalizeEvents(on || this.events || []).map(function (e) {
        if (e === 'input') {
          return this$1._inputEventName;
        }

        return e;
      });
    },
    isRequired: function isRequired () {
      var rules = normalizeRules(this.rules);
      var forceRequired = this.forceRequired;

      var isRequired = rules.required || forceRequired;
      this.flags.required = isRequired;

      return isRequired;
    },
    classes: function classes () {
      var this$1 = this;

      var names = getConfig().classNames;
      return Object.keys(this.flags).reduce(function (classes, flag) {
        var className = (names && names[flag]) || flag;
        if (isNullOrUndefined(this$1.flags[flag])) {
          return classes;
        }

        if (className) {
          classes[className] = this$1.flags[flag];
        }

        return classes;
      }, {});
    }
  },
  render: function render (h) {
    var this$1 = this;

    this.registerField();
    var ctx = createValidationCtx(this);

    // Gracefully handle non-existent scoped slots.
    var slot = this.$scopedSlots.default;
    /* istanbul ignore next */
    if (!isCallable(slot)) {
      if (false) {
        warn('ValidationProvider expects a scoped slot. Did you forget to add "v-slot" to your slot?');
      }

      return h(this.tag, this.$slots.default);
    }

    var nodes = slot(ctx);
    // Handle single-root slot.
    extractVNodes(nodes).forEach(function (input) {
      addListeners.call(this$1, input);
    });

    return this.slim ? createRenderless(h, nodes) : h(this.tag, nodes);
  },
  beforeDestroy: function beforeDestroy () {
    // cleanup reference.
    this.$_veeObserver.unsubscribe(this);
  },
  activated: function activated () {
    this.$_veeObserver.subscribe(this);
    this.isDeactivated = false;
  },
  deactivated: function deactivated () {
    this.$_veeObserver.unsubscribe(this);
    this.isDeactivated = true;
  },
  methods: {
    setFlags: function setFlags (flags) {
      var this$1 = this;

      Object.keys(flags).forEach(function (flag) {
        this$1.flags[flag] = flags[flag];
      });
    },
    syncValue: function syncValue (e) {
      var value = normalizeValue$1(e);
      this.value = value;
      this.flags.changed = this.initialValue !== value;
    },
    reset: function reset () {
      this.messages = [];
      this._pendingValidation = null;
      this.initialValue = this.value;
      var flags = createFlags();
      this.setFlags(flags);
    },
    validate: function validate () {
      var this$1 = this;
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      if (args.length > 0) {
        this.syncValue(args[0]);
      }

      return this.validateSilent().then(function (result) {
        this$1.applyResult(result);

        return result;
      });
    },
    validateSilent: function validateSilent () {
      var this$1 = this;

      this.setFlags({ pending: true });

      return $validator.verify(this.value, this.rules, {
        name: this.name,
        values: createValuesLookup(this),
        bails: this.bails
      }).then(function (result) {
        this$1.setFlags({ pending: false });
        if (!this$1.isRequired) {
          this$1.setFlags({ valid: result.valid, invalid: !result.valid });
        }

        return result;
      });
    },
    applyResult: function applyResult (ref) {
      var errors = ref.errors;
      var failedRules = ref.failedRules;

      this.messages = errors;
      this.failedRules = assign({}, failedRules);
      this.setFlags({
        valid: !errors.length,
        changed: this.value !== this.initialValue,
        invalid: !!errors.length,
        validated: true
      });
    },
    registerField: function registerField () {
      if (!$validator) {
        $validator = getValidator() || new Validator(null, { fastExit: getConfig().fastExit });
      }

      updateRenderingContextRefs(this);
    }
  }
};

function createValidationCtx (ctx) {
  return {
    errors: ctx.messages,
    flags: ctx.flags,
    classes: ctx.classes,
    valid: ctx.isValid,
    failedRules: ctx.failedRules,
    reset: function () { return ctx.reset(); },
    validate: function () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      return ctx.validate.apply(ctx, args);
  },
    aria: {
      'aria-invalid': ctx.flags.invalid ? 'true' : 'false',
      'aria-required': ctx.isRequired ? 'true' : 'false'
    }
  };
}

function normalizeValue$1 (value) {
  if (isEvent(value)) {
    return value.target.type === 'file' ? toArray(value.target.files) : value.target.value;
  }

  return value;
}

/**
 * Determines if a provider needs to run validation.
 */
function shouldValidate (ctx, model) {
  // when an immediate/initial validation is needed and wasn't done before.
  if (!ctx._ignoreImmediate && ctx.immediate) {
    return true;
  }

  // when the value changes for whatever reason.
  if (ctx.value !== model.value) {
    return true;
  }

  // when it needs validation due to props/cross-fields changes.
  if (ctx._needsValidation) {
    return true;
  }

  // when the initial value is undefined and the field wasn't rendered yet.
  if (!ctx.initialized && model.value === undefined) {
    return true;
  }

  return false;
}

function computeModeSetting (ctx) {
  var compute = isCallable(ctx.mode) ? ctx.mode : modes[ctx.mode];

  return compute({
    errors: ctx.messages,
    value: ctx.value,
    flags: ctx.flags
  });
}

function onRenderUpdate (model) {
  if (!this.initialized) {
    this.initialValue = model.value;
  }

  var validateNow = shouldValidate(this, model);
  this._needsValidation = false;
  this.value = model.value;
  this._ignoreImmediate = true;

  if (!validateNow) {
    return;
  }

  this.validateSilent().then(this.immediate || this.flags.validated ? this.applyResult : function (x) { return x; });
}

// Creates the common handlers for a validatable context.
function createCommonHandlers (ctx) {
  var onInput = function (e) {
    ctx.syncValue(e); // track and keep the value updated.
    ctx.setFlags({ dirty: true, pristine: false });
  };

  // Blur event listener.
  var onBlur = function () {
    ctx.setFlags({ touched: true, untouched: false });
  };

  var onValidate = ctx.$veeHandler;
  var mode = computeModeSetting(ctx);

  // Handle debounce changes.
  if (!onValidate || ctx.$veeDebounce !== ctx.debounce) {
    onValidate = debounce(
      function () {
        ctx.$nextTick(function () {
          var pendingPromise = ctx.validateSilent();
          // avoids race conditions between successive validations.
          ctx._pendingValidation = pendingPromise;
          pendingPromise.then(function (result) {
            if (pendingPromise === ctx._pendingValidation) {
              ctx.applyResult(result);
              ctx._pendingValidation = null;
            }
          });
        });
      },
      mode.debounce || ctx.debounce
    );

    // Cache the handler so we don't create it each time.
    ctx.$veeHandler = onValidate;
    // cache the debounce value so we detect if it was changed.
    ctx.$veeDebounce = ctx.debounce;
  }

  return { onInput: onInput, onBlur: onBlur, onValidate: onValidate };
}

// Adds all plugin listeners to the vnode.
function addListeners (node) {
  var model = findModel(node);
  // cache the input eventName.
  this._inputEventName = this._inputEventName || getInputEventName(node, model);

  onRenderUpdate.call(this, model);

  var ref = createCommonHandlers(this);
  var onInput = ref.onInput;
  var onBlur = ref.onBlur;
  var onValidate = ref.onValidate;
  addVNodeListener(node, this._inputEventName, onInput);
  addVNodeListener(node, 'blur', onBlur);

  // add the validation listeners.
  this.normalizedEvents.forEach(function (evt) {
    addVNodeListener(node, evt, onValidate);
  });

  this.initialized = true;
}

function createValuesLookup (ctx) {
  var providers = ctx.$_veeObserver.refs;

  return ctx.fieldDeps.reduce(function (acc, depName) {
    if (!providers[depName]) {
      return acc;
    }

    acc[depName] = providers[depName].value;

    return acc;
  }, {});
}

function updateRenderingContextRefs (ctx) {
  // IDs should not be nullable.
  if (isNullOrUndefined(ctx.id) && ctx.id === ctx.vid) {
    ctx.id = PROVIDER_COUNTER;
    PROVIDER_COUNTER++;
  }

  var id = ctx.id;
  var vid = ctx.vid;
  // Nothing has changed.
  if (ctx.isDeactivated || (id === vid && ctx.$_veeObserver.refs[id])) {
    return;
  }

  // vid was changed.
  if (id !== vid && ctx.$_veeObserver.refs[id] === ctx) {
    ctx.$_veeObserver.unsubscribe({ vid: id });
  }

  ctx.$_veeObserver.subscribe(ctx);
  ctx.id = vid;
}

function createObserver () {
  return {
    refs: {},
    subscribe: function subscribe (ctx) {
      this.refs[ctx.vid] = ctx;
    },
    unsubscribe: function unsubscribe (ctx) {
      delete this.refs[ctx.vid];
    }
  };
}

function watchCrossFieldDep (ctx, depName, withHooks) {
  if ( withHooks === void 0 ) withHooks = true;

  var providers = ctx.$_veeObserver.refs;
  if (!ctx._veeWatchers) {
    ctx._veeWatchers = {};
  }

  if (!providers[depName] && withHooks) {
    return ctx.$once('hook:mounted', function () {
      watchCrossFieldDep(ctx, depName, false);
    });
  }

  if (!isCallable(ctx._veeWatchers[depName]) && providers[depName]) {
    ctx._veeWatchers[depName] = providers[depName].$watch('value', function () {
      if (ctx.flags.validated) {
        ctx._needsValidation = true;
        ctx.validate();
      }
    });
  }
}

var flagMergingStrategy = {
  pristine: 'every',
  dirty: 'some',
  touched: 'some',
  untouched: 'every',
  valid: 'every',
  invalid: 'some',
  pending: 'some',
  validated: 'every'
};

function mergeFlags (lhs, rhs, strategy) {
  var stratName = flagMergingStrategy[strategy];

  return [lhs, rhs][stratName](function (f) { return f; });
}

var OBSERVER_COUNTER = 0;

var ValidationObserver = {
  name: 'ValidationObserver',
  provide: function provide () {
    return {
      $_veeObserver: this
    };
  },
  inject: {
    $_veeObserver: {
      from: '$_veeObserver',
      default: function default$1 () {
        if (!this.$vnode.context.$_veeObserver) {
          return null;
        }

        return this.$vnode.context.$_veeObserver;
      }
    }
  },
  props: {
    tag: {
      type: String,
      default: 'span'
    },
    slim: {
      type: Boolean,
      default: false
    }
  },
  data: function () { return ({
    vid: ("obs_" + (OBSERVER_COUNTER++)),
    refs: {},
    observers: [],
    persistedStore: {}
  }); },
  computed: {
    ctx: function ctx () {
      var this$1 = this;

      var ctx = {
        errors: {},
        validate: function (arg) {
          var promise = this$1.validate(arg);

          return {
            then: function then (thenable) {
              return promise.then(function (success) {
                if (success && isCallable(thenable)) {
                  return Promise.resolve(thenable());
                }

                return Promise.resolve(success);
              });
            }
          };
        },
        reset: function () { return this$1.reset(); }
      };

      return values(this.refs).concat( Object.keys(this.persistedStore).map(function (key) {
          return {
            vid: key,
            flags: this$1.persistedStore[key].flags,
            messages: this$1.persistedStore[key].errors
          };
        }),
        this.observers ).reduce(function (acc, provider) {
        Object.keys(flagMergingStrategy).forEach(function (flag) {
          var flags = provider.flags || provider.ctx;
          if (!(flag in acc)) {
            acc[flag] = flags[flag];
            return;
          }

          acc[flag] = mergeFlags(acc[flag], flags[flag], flag);
        });

        acc.errors[provider.vid] = provider.messages || values(provider.ctx.errors).reduce(function (errs, obsErrors) {
          return errs.concat(obsErrors);
        }, []);

        return acc;
      }, ctx);
    }
  },
  created: function created () {
    if (this.$_veeObserver) {
      this.$_veeObserver.subscribe(this, 'observer');
    }
  },
  activated: function activated () {
    if (this.$_veeObserver) {
      this.$_veeObserver.subscribe(this, 'observer');
    }
  },
  deactivated: function deactivated () {
    if (this.$_veeObserver) {
      this.$_veeObserver.unsubscribe(this, 'observer');
    }
  },
  beforeDestroy: function beforeDestroy () {
    if (this.$_veeObserver) {
      this.$_veeObserver.unsubscribe(this, 'observer');
    }
  },
  render: function render (h) {
    var slots = this.$slots.default || this.$scopedSlots.default || [];
    if (isCallable(slots)) {
      slots = slots(this.ctx);
    }

    return this.slim ? createRenderless(h, slots) : h(this.tag, { on: this.$listeners, attrs: this.$attrs }, slots);
  },
  methods: {
    subscribe: function subscribe (subscriber, kind) {
      var obj;

      if ( kind === void 0 ) kind = 'provider';
      if (kind === 'observer') {
        this.observers.push(subscriber);
        return;
      }

      this.refs = Object.assign({}, this.refs, ( obj = {}, obj[subscriber.vid] = subscriber, obj ));
      if (subscriber.persist && this.persistedStore[subscriber.vid]) {
        this.restoreProviderState(subscriber);
      }
    },
    unsubscribe: function unsubscribe (ref, kind) {
      var vid = ref.vid;
      if ( kind === void 0 ) kind = 'provider';

      if (kind === 'provider') {
        this.removeProvider(vid);
      }

      var idx = findIndex(this.observers, function (o) { return o.vid === vid; });
      if (idx !== -1) {
        this.observers.splice(idx, 1);
      }
    },
    validate: function validate (ref) {
      if ( ref === void 0 ) ref = { silent: false };
      var silent = ref.silent;

      return Promise.all(values(this.refs).map(function (ref) { return ref[silent ? 'validateSilent' : 'validate']().then(function (r) { return r.valid; }); }).concat( this.observers.map(function (obs) { return obs.validate({ silent: silent }); })
      )).then(function (results) { return results.every(function (r) { return r; }); });
    },
    reset: function reset () {
      var this$1 = this;

      Object.keys(this.persistedStore).forEach(function (key) {
        this$1.$delete(this$1.persistedStore, key);
      });
      return values(this.refs).concat( this.observers).forEach(function (ref) { return ref.reset(); });
    },
    restoreProviderState: function restoreProviderState (provider) {
      var state = this.persistedStore[provider.vid];
      provider.setFlags(state.flags);
      provider.applyResult(state);
      this.$delete(this.persistedStore, provider.vid);
    },
    removeProvider: function removeProvider (vid) {
      var obj;

      var provider = this.refs[vid];
      // save it for the next time.
      if (provider && provider.persist) {
        /* istanbul ignore else */
        if (false) {
          if (vid.indexOf('_vee_') === 0) {
            warn('Please provide a `vid` prop when using `persist`, there might be unexpected issues otherwise.');
          }
        }

        this.persistedStore = assign({}, this.persistedStore, ( obj = {}, obj[vid] = {
            flags: provider.flags,
            errors: provider.messages,
            failedRules: provider.failedRules
          }, obj ));
      }

      this.$delete(this.refs, vid);
    },
  }
};

function withValidation (component, ctxToProps) {
  if ( ctxToProps === void 0 ) ctxToProps = null;

  var options = isCallable(component) ? component.options : component;
  options.$__veeInject = false;
  var hoc = {
    name: ((options.name || 'AnonymousHoc') + "WithValidation"),
    props: assign({}, ValidationProvider.props),
    data: ValidationProvider.data,
    computed: assign({}, ValidationProvider.computed),
    methods: assign({}, ValidationProvider.methods),
    $__veeInject: false,
    beforeDestroy: ValidationProvider.beforeDestroy,
    inject: ValidationProvider.inject
  };

  // Default ctx converts ctx props to component props.
  if (!ctxToProps) {
    ctxToProps = function (ctx) { return ctx; };
  }

  var eventName = (options.model && options.model.event) || 'input';

  hoc.render = function (h) {
    var obj;

    this.registerField();
    var vctx = createValidationCtx(this);
    var listeners = assign({}, this.$listeners);

    var model = findModel(this.$vnode);
    this._inputEventName = this._inputEventName || getInputEventName(this.$vnode, model);
    onRenderUpdate.call(this, model);

    var ref = createCommonHandlers(this);
    var onInput = ref.onInput;
    var onBlur = ref.onBlur;
    var onValidate = ref.onValidate;

    mergeVNodeListeners(listeners, eventName, onInput);
    mergeVNodeListeners(listeners, 'blur', onBlur);
    this.normalizedEvents.forEach(function (evt, idx) {
      mergeVNodeListeners(listeners, evt, onValidate);
    });

    // Props are any attrs not associated with ValidationProvider Plus the model prop.
    // WARNING: Accidental prop overwrite will probably happen.
    var ref$1 = findModelConfig(this.$vnode) || { prop: 'value' };
    var prop = ref$1.prop;
    var props = assign({}, this.$attrs, ( obj = {}, obj[prop] = model.value, obj ), ctxToProps(vctx));

    return h(options, {
      attrs: this.$attrs,
      props: props,
      on: listeners
    }, normalizeSlots(this.$slots, this.$vnode.context));
  };

  return hoc;
}

var version = '2.2.15';

Object.keys(Rules).forEach(function (rule) {
  Validator.extend(rule, Rules[rule].validate, assign({}, Rules[rule].options, { paramNames: Rules[rule].paramNames }));
});

// Merge the english messages.
Validator.localize({ en: locale });

var install = VeeValidate$1.install;

VeeValidate$1.version = version;
VeeValidate$1.mapFields = mapFields;
VeeValidate$1.ValidationProvider = ValidationProvider;
VeeValidate$1.ValidationObserver = ValidationObserver;
VeeValidate$1.withValidation = withValidation;

/* harmony default export */ __webpack_exports__["b"] = (VeeValidate$1);



/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jivoService__ = __webpack_require__(557);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            menuCollapsed: false
        };
    },

    methods: {
        onToggled: function onToggled() {
            this.menuCollapsed = !this.menuCollapsed;
        }
    },
    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_0__jivoService__["a" /* default */].init();
    },

    watch: {
        '$route': function $route(to) {
            __WEBPACK_IMPORTED_MODULE_0__jivoService__["a" /* default */].checkUrl();
        }
    }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SideMenu__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cart__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_common_mixin__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_image_svg_svg__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_image_svg_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__img_image_svg_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__img_images_svg__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__img_images_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__img_images_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__enums__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var backendApi = new __WEBPACK_IMPORTED_MODULE_2__backendApi__["a" /* default */]();
var tokenKey = "tokenInfo";

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "layout",

    props: ['appMenuCollapsed'],

    components: {
        SideMenu: __WEBPACK_IMPORTED_MODULE_1__SideMenu__["a" /* default */]
    },

    watch: {
        '$route': function $route(to, from) {
            this.loadSummary();
            this.saveSecondsProgress();
            this.totalSeconds = 0;
        }
    },

    data: function data() {
        return {
            profileMenuOpen: false,
            menuCollapsed: false,
            menuMobShow: false,
            info: {
                User: null
            },
            cartItemsCount: 0,
            selectedProject: null, // todo: можно поставить здесь дефолтный
            about: {
                isEditing: false,
                text: '',
                origin: ''
            },
            firstLaunchItems: null,
            firstLaunchItemsShow: false,
            NotificationsEnabled: null,
            TermsConfirmed: null,
            PersonalDataEditingAccept: null,

            loggedByUser: false,
            userToChange: {
                fio: null,
                id: null,
                redirectUrl: null,
                found: null
            },
            confirmation: {
                state: 'init', // init,code,confirmed,newemail
                email: null,
                newemail: null,
                errors: {
                    code: null,
                    newemail: null
                },
                code: {
                    disabled: false,
                    value: null
                },
                showInfoText: false,
                isSending: false
            },
            totalSeconds: 0,
            layoutActive: true,
            newProjectId: null,
            isMobile: __WEBPACK_IMPORTED_MODULE_5__helpers_ui_helpers__["a" /* default */].check_mobile(),
            //showSpanDetails: false
            menuColor: ''
        };
    },


    computed: {
        UserLevelCode: function UserLevelCode() {
            return __WEBPACK_IMPORTED_MODULE_10__enums__["s" /* UserLevelCode */];
        },

        /*userPlanFactData(){
          let display = [], tooltip = [], donePercent = null;
          if(this.info.User.SalesPlan != null){
            display.push(this.formatInt(this.info.User.SalesPlan.toFixed(0)) + ' руб.');
            tooltip.push('План: ' + this.formatInt(this.info.User.SalesPlan) + ' руб.');
          }
          if(this.info.User.SalesFact != null){
            display.push(this.formatInt(this.info.User.SalesFact.toFixed(0)) + ' руб.');
            tooltip.push('Продано: ' + this.formatInt(this.info.User.SalesFact) + ' руб.')
          }
          if(this.info.User.SalesPlan > 0 && this.info.User.SalesFact != null){
            donePercent = (this.info.User.SalesFact / this.info.User.SalesPlan)*100;
            tooltip.push('Выполнено: ' +donePercent.toFixed(2)+ '%');
          }
          display.reverse();
          return {
            Display: display.join(' / ') + (donePercent != null ? ' (' + donePercent.toFixed(0) + '%)' : ''),
            Tooltip: tooltip.join(',<br>')
          }
        }*/
        LevelInProjectIcon: function LevelInProjectIcon() {
            switch (this.info.User.LevelInProject) {
                case 1:
                    return "/Content/dist/image_svg.svg?#User2";
                    break;
                case 2:
                    break;
                case 3:
                    break;
                case 4:
                    break;
            }
        }
    },

    methods: {
        getLevelIconClass: function getLevelIconClass(level) {
            switch (level) {
                case __WEBPACK_IMPORTED_MODULE_10__enums__["s" /* UserLevelCode */].Bronze:
                case __WEBPACK_IMPORTED_MODULE_10__enums__["s" /* UserLevelCode */].GradeB:
                    return 'levelinproject-icon-bronze';
                case __WEBPACK_IMPORTED_MODULE_10__enums__["s" /* UserLevelCode */].Silver:
                case __WEBPACK_IMPORTED_MODULE_10__enums__["s" /* UserLevelCode */].GradeA:
                    return 'levelinproject-icon-silver';
                case __WEBPACK_IMPORTED_MODULE_10__enums__["s" /* UserLevelCode */].Gold:
                case __WEBPACK_IMPORTED_MODULE_10__enums__["s" /* UserLevelCode */].GradeS:
                    return 'levelinproject-icon-gold';
                case __WEBPACK_IMPORTED_MODULE_10__enums__["s" /* UserLevelCode */].Platina:
                    return 'levelinproject-icon-platinum';
            }
        },
        getLevelName: function getLevelName(level) {
            switch (level) {
                case __WEBPACK_IMPORTED_MODULE_10__enums__["s" /* UserLevelCode */].Bronze:
                    return 'Бронза';
                case __WEBPACK_IMPORTED_MODULE_10__enums__["s" /* UserLevelCode */].Silver:
                    return 'Серебро';
                case __WEBPACK_IMPORTED_MODULE_10__enums__["s" /* UserLevelCode */].Gold:
                    return 'Золото';
                case __WEBPACK_IMPORTED_MODULE_10__enums__["s" /* UserLevelCode */].Platina:
                    return 'Платина';
                case __WEBPACK_IMPORTED_MODULE_10__enums__["s" /* UserLevelCode */].GradeB:
                    return 'Грейд B';
                case __WEBPACK_IMPORTED_MODULE_10__enums__["s" /* UserLevelCode */].GradeA:
                    return 'Грейд A';
                case __WEBPACK_IMPORTED_MODULE_10__enums__["s" /* UserLevelCode */].GradeS:
                    return 'Грейд S';
                default:
                    return '';
            }
        },
        onUserProjectChange: function onUserProjectChange() {
            var vm = this;
            localStorage.setItem('selectedProjectId', vm.newProjectId);
            location.reload();
        },
        saveSecondsProgress: function saveSecondsProgress() {
            return;
            // временно отключаем
            if (this.totalSeconds > 0) {
                this.callApiWrapper(backendApi.saveSecondsProgress(this.totalSeconds));
            }
        },


        onUserIdChange: __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.debounce(function () {
            var vm = this;

            if (!vm.userToChange.id) {
                vm.userToChange.found = null;
                return;
            }

            vm.callApiWrapper(backendApi.checkUser(vm.userToChange.id)).then(function (resp) {
                if (!resp.hasError && resp.data.Exists === true) {
                    vm.userToChange.fio = resp.data.UserFio;
                    vm.userToChange.found = true;
                    vm.userToChange.redirectUrl = resp.data.RedirectUrl;
                } else {
                    vm.userToChange.fio = null;
                    vm.userToChange.found = false;
                    vm.userToChange.redirectUrl = null;
                }
            });
        }, 300),

        onChangeUser: function onChangeUser() {
            var vm = this;

            vm.callApiWrapper(backendApi.changeUser(vm.userToChange.id)).then(function (resp) {
                if (!resp.hasError) {

                    localStorage.setItem('loggedByUser', resp.data.CheckData);

                    localStorage.removeItem(tokenKey);
                    sessionStorage.removeItem(tokenKey);
                    localStorage.removeItem('cart');
                    localStorage.removeItem('usersComplexFilter');
                    sessionStorage.removeItem('selectedProjectId');
                    localStorage.removeItem('selectedProjectId');

                    localStorage.setItem(tokenKey, JSON.stringify({
                        access_token: resp.data.Token
                    }));

                    localStorage.setItem('firstLogin', 'true');

                    var redirectUrl = '/';
                    // if(vm.userToChange.redirectUrl && vm.userToChange.redirectUrl !== '/'){
                    //     redirectUrl = (vm.userToChange.redirectUrl !== 'demo.promoclub.online' ? 'https://' : 'http://') + vm.userToChange.redirectUrl;
                    // }
                    location.href = redirectUrl;
                } else {
                    __WEBPACK_IMPORTED_MODULE_5__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при смене пользователя');
                }

                vm.$refs['ppChangeUser'].close();
            });
        },
        onReturnFromUser: function onReturnFromUser() {
            var vm = this;

            var loggedByUser = localStorage.getItem('loggedByUser');
            localStorage.removeItem('loggedByUser');

            vm.callApiWrapper(backendApi.returnToUser(loggedByUser)).then(function (resp) {
                if (!resp.hasError) {

                    localStorage.removeItem(tokenKey);
                    sessionStorage.removeItem(tokenKey);
                    localStorage.removeItem('cart');
                    localStorage.removeItem('usersComplexFilter');

                    localStorage.setItem(tokenKey, JSON.stringify({
                        access_token: resp.data.Token
                    }));

                    location.href = '/';
                } else {
                    __WEBPACK_IMPORTED_MODULE_5__helpers_ui_helpers__["a" /* default */].toastr.error('Внутренняя ошибка сервера');
                    location.href = '/login';
                }
            });
        },
        fileExtensionIsHtml: function fileExtensionIsHtml(filename) {
            return filename.endsWith('.html');
        },
        saveAgreements: function saveAgreements() {
            var vm = this;

            vm.callApiWrapper(backendApi.profileSaveAgreements(vm.TermsConfirmed, vm.NotificationsEnabled, vm.PersonalDataEditingAccept)).then(function (resp) {
                if (!resp.hasError) {
                    vm.info.User.TermsConfirmed = true;
                    vm.$refs['ppAgreements'].close();
                    vm.processUserLogin();
                } else {
                    __WEBPACK_IMPORTED_MODULE_5__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении');
                }
            });
        },
        appElementClick: function appElementClick() {
            this.profileMenuOpen = false;
        },
        logOut: function logOut() {
            var vm = this;
            var headers = {};
            var tokenInfo = JSON.parse(localStorage.getItem('tokenInfo') == null ? sessionStorage.getItem('tokenInfo') : localStorage.getItem('tokenInfo'));
            if (tokenInfo) {
                headers.Authorization = "bearer " + tokenInfo.access_token;
            }

            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
                type: 'POST',
                url: __WEBPACK_IMPORTED_MODULE_4__config___default.a.apiUrl + '/api/account/logout',
                headers: headers,
                success: function success() {
                    localStorage.removeItem('tokenInfo');
                    sessionStorage.removeItem('tokenInfo');
                    vm.$router.push('/login');
                },
                error: function error(data, e, a) {
                    console.info('logOut fail -> data, e, a', data, e, a);
                }
            });

            // localStorage.removeItem('tokenInfo');
            // sessionStorage.removeItem('tokenInfo');
            // this.$router.push('/login')
        },
        toggleMenu: function toggleMenu() {
            this.menuCollapsed = !this.menuCollapsed;
            this.$emit('menu-toggled');
        },
        toggleMenuMob: function toggleMenuMob() {
            this.menuMobShow = !this.menuMobShow;
            //this.$emit('menu-toggled')
        },
        onShowModal: function onShowModal(modal) {
            var _this = this;

            this.$nextTick(function () {

                _this.$refs[modal].show();
            });
        },
        refreshMenuData: function refreshMenuData() {
            this.$refs.menu.refreshMenuData();
        },
        refreshCart: function refreshCart() {
            this.cartItemsCount = __WEBPACK_IMPORTED_MODULE_3__cart__["a" /* default */].getItemsCount();
        },
        userUpdated: function userUpdated() {
            this.loadSummary();
        },
        getUserNameToDisplay: function getUserNameToDisplay() {
            var user = this.info.User;
            if (!user) {
                return "";
            }

            var fio = (user.LastName + ' ' + user.FirstName).trim(); //${user.MiddleName ? user.MiddleName : ''}
            return fio ? fio : user.UserName;
        },
        getUserBonusToDisplay: function getUserBonusToDisplay(type, short) {
            var user = this.info.User;
            var val = type === 'active' ? user.ActiveBalanceWithOrders.toFixed(0) : user.PotentialBalance.toFixed(0);
            return (short ? '' : type === 'active' ? 'Доступно ' : 'Всего ') + val + (short ? '' : __WEBPACK_IMPORTED_MODULE_6__helpers_common_mixin__["a" /* default */].methods.get_text_ending(val, [' балл', ' балла', ' баллов']));
        },
        loadSummary: function loadSummary() {
            var vm = this;
            return this.callApiWrapper(backendApi.summaryInfo(localStorage.getItem('selectedProjectId'))).then(function (resp) {
                if (!resp.hasError && resp.data) {
                    //console.info('resp.data', resp.data);
                    vm.info = Object.assign({}, resp.data);
                    vm.info.FeedbackSettings = JSON.parse(vm.info.FeedbackSettings || '{}');

                    //if (resp.data.User && resp.data.User.ProjectId) {
                    localStorage.setItem('selectedProjectId', resp.data.SelectedProject.Id);
                    //}

                    vm.selectedProject = resp.data.SelectedProject; //Projects.find(x => x.Id === resp.data.SelectedProjectId);
                    vm.newProjectId = resp.data.SelectedProject.Id;
                    if (vm.selectedProject.MenuColor) vm.menuColor = vm.selectedProject.MenuColor;else vm.menuColor = '#8198AE';
                    //vm.about.text = resp.data.AboutText ? resp.data.AboutText : '';
                    //vm.about.origin = resp.data.AboutText ? resp.data.AboutText : '';
                    vm.firstLaunchItems = resp.data.FirstLaunch;

                    if (localStorage.getItem('loggedByUser') != null) {
                        vm.loggedByUser = true;
                    }

                    vm.processUserLogin();
                }
            });
        },
        processUserLogin: function processUserLogin() {
            var vm = this;

            if (!vm.loggedByUser && vm.info && !vm.info.User.TermsConfirmed) {
                // показываем окно с галочками о согласии
                vm.$refs['ppAgreements'].show();
            } else if (!vm.loggedByUser && vm.info && !vm.info.User.EmailConfirmed) {
                vm.confirmation.email = vm.info.User.Email;
                vm.$refs['ppEmailConfirmed'].show();

                window.setTimeout(function () {
                    // если div удалили вручную
                    var $emailConfirmedDiv = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[name=ppEmailConfirmed]');
                    if (!$emailConfirmedDiv.length) {
                        location.href = '/';
                    }
                }, 50);
            } else {
                // проверяем версию бандла (только на продакшене)
                if (__WEBPACK_IMPORTED_MODULE_4__config___default.a.mode === 'prod' && window['BundleVersion'] != vm.info.BundleVersion) {
                    location.reload();
                }

                var mainRole = vm.info.User.MainRole;
                var dynamicRole = vm.info.User.DynamicRole;
                var firstLogin = localStorage.getItem('firstLogin');

                if (mainRole !== 'administrators') {
                    // проверяем доступ к странице
                    var pageClaim = void 0;
                    switch (vm.$route.name) {
                        case 'materials':
                            pageClaim = vm.claimEnums.materialsPage;
                            break;
                        case 'materialEdit':
                        case 'folderEdit':
                        case 'questionEdit':
                            pageClaim = vm.claimEnums.materialCreate;
                            break;
                        case 'motivation':
                            pageClaim = vm.claimEnums.motivationPage;
                            break;
                        case 'news':
                        case 'newsEdit':
                        case 'newsDetails':
                            pageClaim = vm.claimEnums.newsPage;
                            break;
                        case 'projects':
                        case 'projectEdit':
                        case 'trade-points':
                        case 'users':
                        case 'userEdit':
                        case 'roles':
                            pageClaim = vm.claimEnums.projectPage;
                            break;
                        case 'rewardEdit':
                        case 'rewardFolderEdit':
                            pageClaim = vm.claimEnums.rewardsEdit;
                            break;
                        case 'rating':
                            pageClaim = vm.claimEnums.ratingPage;
                            break;
                        case 'reports':
                        case 'reportDetails':
                            pageClaim = vm.claimEnums.reportsPage;
                            break;
                        case 'spend-bonuses':
                            pageClaim = vm.claimEnums.spendBonusesPage;
                            break;
                        case 'analytics':
                            pageClaim = vm.claimEnums.analyticsPage;
                            break;
                        case 'sku':
                        case 'skuDetails':
                            pageClaim = vm.claimEnums.skuPage;
                            break;
                        case 'skuEdit':
                        case 'skuFolderEdit':
                            pageClaim = vm.claimEnums.skuCreate;
                            break;
                        case 'cart':
                            pageClaim = vm.claimEnums.bonusSpend;
                            break;
                        case 'orders':
                            pageClaim = vm.claimEnums.ordersPage;
                            break;
                        case 'sender':
                            pageClaim = vm.claimEnums.senderPage;
                            break;
                        case 'faq':
                            pageClaim = vm.claimEnums.faqPage;
                            break;
                        case 'tasks':
                            pageClaim = vm.claimEnums.tasksPage;
                            break;
                        case 'tasksEdit':
                            pageClaim = vm.claimEnums.tasksEdit;
                            break;
                    }

                    if (vm.info.User.IsDisabled && !['profile', 'cart', 'spend-bonuses', 'bonus-history'].some(function (x) {
                        return x === vm.$route.name;
                    })) {
                        vm.$router.push('/spend-bonuses');
                    }

                    // todo: уточнить условия и переделать
                    // не проверяем для стартовой страницы
                    if (vm.$route.path !== '/' && pageClaim !== undefined && dynamicRole.Claims.find(function (x) {
                        return x.ClaimId === pageClaim;
                    }) === undefined) {
                        vm.$router.push('/');
                        return;
                    }
                }

                if (firstLogin === 'true' && dynamicRole != null) {
                    localStorage.removeItem('firstLogin');
                    var mainPageClaim = dynamicRole.Claims.find(function (x) {
                        return x.ClaimId === vm.claimEnums.mainPageSettings;
                    });
                    if (mainPageClaim !== undefined && mainPageClaim.Value) {
                        vm.$router.push(mainPageClaim.Value);
                    }
                }

                if (vm.firstLaunchItems && vm.firstLaunchItems.length) {
                    //console.info('layout-> показываем firstItems');
                    vm.firstLaunchItemsShow = true;
                }
            }
        },
        onActionsComplete: function onActionsComplete() {
            return this.callApiWrapper(backendApi.firstActionsComplete());
        },
        requestConfirmationCode: function requestConfirmationCode() {
            var vm = this;
            vm.confirmation.isSending = true;
            vm.callApiWrapper(backendApi.requestConfirmationCode()).then(function (resp) {
                vm.confirmation.isSending = false;
                if (resp.hasError) {
                    if (resp.status === 11 || resp.status === 12) {
                        if (resp.status === 11) {
                            vm.confirmation.errors.newemail = 'В указанной почте допущены ошибки. Введите правильный адрес.';
                        } else {
                            vm.confirmation.errors.newemail = 'Нам не удается доставить сообщения на данный адрес. Пожалуйста, укажите правильный.';
                        }
                        vm.confirmation.state = 'newemail';
                        vm.confirmation.newemail = vm.confirmation.email;
                    } else {
                        __WEBPACK_IMPORTED_MODULE_5__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время отправки кода');
                    }

                    return;
                }
                if (resp.data.Value == null) {
                    __WEBPACK_IMPORTED_MODULE_5__helpers_ui_helpers__["a" /* default */].toastr.error(resp.data.Message.Errors[0]);
                }

                vm.confirmation.state = 'code';
            });
        },
        onConfirmationCodeKeyUp: function onConfirmationCodeKeyUp() {
            var vm = this;
            var trimmedCode = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.trim(vm.confirmation.code.value);
            if (trimmedCode.length === 4) {
                vm.confirmation.code.disabled = true;

                this.callApiWrapper(backendApi.checkConfirmationCode(trimmedCode)).then(function (resp) {
                    if (resp.hasError) {
                        __WEBPACK_IMPORTED_MODULE_5__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время проверки кода');
                    } else {
                        if (resp.data === true) {
                            vm.confirmation.errors.code = null;
                            vm.confirmation.state = 'confirmed';
                            vm.info.User.TermsConfirmed = true;

                            setTimeout(function () {
                                vm.$refs['ppEmailConfirmed'].close();
                            }, 1000);
                        } else {
                            vm.confirmation.errors.code = 'Не верный код';
                        }
                    }
                    vm.confirmation.code.disabled = false;
                });
            }
        },
        onConfirmationShowNewEmail: function onConfirmationShowNewEmail() {
            var vm = this;

            vm.confirmation.errors.newemail = null;
            vm.confirmation.showInfoText = false;
            vm.confirmation.state = 'newemail';
        },
        onConfirmationNewEmailSave: function onConfirmationNewEmailSave() {
            var vm = this;

            this.$validator.validateAll('newemail').then(function (result) {
                if (!result) {
                    __WEBPACK_IMPORTED_MODULE_5__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                    return;
                }

                vm.confirmation.errors.newemail = null;

                vm.callApiWrapper(backendApi.requestConfirmationCode(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.trim(vm.confirmation.newemail))).then(function (resp) {
                    if (resp.hasError) {
                        if (resp.status === 8) {
                            vm.confirmation.errors.newemail = 'Этот email уже используется';
                        } else if (resp.status === 11) {
                            vm.confirmation.errors.newemail = 'В указанной почте допущены ошибки. Введите правильный адрес.';
                        } else if (resp.status === 12) {
                            vm.confirmation.errors.newemail = 'Нам не удается доставить сообщения на данный адрес. Пожалуйста, укажите правильный.';
                        } else {
                            __WEBPACK_IMPORTED_MODULE_5__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время отправки кода');
                        }

                        return;
                    }
                    if (resp.data.Value == null) {
                        __WEBPACK_IMPORTED_MODULE_5__helpers_ui_helpers__["a" /* default */].toastr.error(resp.data.Message.Errors[0]);
                    }

                    vm.confirmation.state = 'code';
                });
            });
        },
        onShowRulesClick: function onShowRulesClick() {
            var vm = this;

            vm.$refs.ppRules.show();
            vm.$nextTick(function () {
                if (vm.$refs.pdfViewRules) vm.$refs.pdfViewRules.show(vm.info.RulesFile);
                // vm.$nextTick(()=>{
                //     vm.$refs.pdfViewRules.toggleFullScreen();
                // });
            });
        },
        onShowPolicyClick: function onShowPolicyClick() {
            var vm = this;

            vm.$refs.ppPolicy.show();
            vm.$nextTick(function () {
                if (vm.$refs.pdfViewPolicy) vm.$refs.pdfViewPolicy.show(vm.info.PolicyFile);
                // vm.$nextTick(()=>{
                //     vm.$refs.pdfViewPolicy.toggleFullScreen();
                // });
            });
        }
    },

    mounted: function mounted() {
        console.info('LAYOUT mounted, mode', __WEBPACK_IMPORTED_MODULE_4__config___default.a.mode);
        __WEBPACK_IMPORTED_MODULE_5__helpers_ui_helpers__["a" /* default */].blockUI('.login-page-bg', 'Загрузка...', { overlayCSS: { backgroundColor: '#fff', opacity: 1 } });
        var vm = this;

        if (vm.$route.query.token && vm.$route.query.projectId) {
            var _tokenKey = "tokenInfo";
            localStorage.removeItem('cart');
            localStorage.removeItem('usersComplexFilter');
            localStorage.setItem(_tokenKey, JSON.stringify({ access_token: vm.$route.query.token }));
            localStorage.setItem('selectedProjectId', vm.$route.query.projectId);

            window.location = window.location.pathname;
        }

        vm.menuCollapsed = vm.appMenuCollapsed;

        this.loadSummary().then(function () {

            __WEBPACK_IMPORTED_MODULE_5__helpers_ui_helpers__["a" /* default */].unblockUI('.login-page-bg');

            var interval = window.setInterval(function () {
                if (typeof jivo_api !== 'undefined') {

                    window.jivo_onOpen = function () {
                        var contactinfo = {
                            "name": vm.info.User.Fio,
                            "email": vm.info.User.Email,
                            "phone": vm.info.User.Phone
                        };
                        if (vm.info.selectedProject) {
                            contactinfo.description = vm.info.selectedProject.ProjectName;
                        }

                        jivo_api.setContactInfo(contactinfo);
                    };

                    window.clearInterval(interval);
                }
            }, 100);
        });

        this.cartItemsCount = __WEBPACK_IMPORTED_MODULE_3__cart__["a" /* default */].getItemsCount();

        var interval = setInterval(function () {
            vm.totalSeconds++;
        }, 1000);

        window.addEventListener("beforeunload", function (e) {
            vm.saveSecondsProgress();
        });

        var notIE = document.documentMode === undefined,
            isChromium = window.chrome;

        var onFocus = function onFocus() {
            if (!vm.layoutActive) {
                return;
            }
            //console.info('onFocus')
            if (!interval) {
                interval = setInterval(function () {
                    vm.totalSeconds++;
                }, 1000);
            }
        };
        var onBlur = function onBlur() {
            if (!vm.layoutActive) {
                return;
            }
            //console.info('onBlur')
            vm.saveSecondsProgress();
            clearInterval(interval);
            interval = null;
            vm.totalSeconds = 0;
        };

        if (notIE && !isChromium) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on("focusin", onFocus).on("focusout", onBlur);
        } else {
            // checks for IE and Chromium versions
            if (window.addEventListener) {
                window.addEventListener("focus", onFocus, false);
                window.addEventListener("blur", onBlur, false);
            } else {
                window.attachEvent("focus", onFocus);
                window.attachEvent("blur", onBlur);
            }
        }

        // document.addEventListener('visibilitychange', function(){
        //     console.info(new Date(),', document.visibilityState', document.visibilityState);
        // })
    },
    destroyed: function destroyed() {
        console.info('LAYOUT destroyed');
        this.layoutActive = false;
    }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_auth_mixin__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_image_svg_svg__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_image_svg_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__img_image_svg_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: "side-menu",

    props: ['collapsed', 'info', 'cartItemsCount', 'menuColor'],

    mixins: [__WEBPACK_IMPORTED_MODULE_0__helpers_auth_mixin__["a" /* default */]],

    data: function data() {
        return {
            pages: [],
            addReportLinkName: null,
            showSpanDetails: false
        };
    },


    watch: {
        '$route': function $route() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.pages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var page = _step.value;

                    switch (page.Path) {
                        case '/':
                            page.active = this.$route.name === 'news' || this.$route.name === 'newsDetails' || this.$route.name === 'newsEdit';
                            break;
                        case '/materials':
                            page.active = this.$route.path.startsWith('/materials');
                            break;
                        default:
                            page.active = this.$route.name === page.Path.replace('/', '');
                            break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        'info': function info() {
            this.setPages();
        }
    },

    computed: {
        pagesOrdered: function pagesOrdered() {
            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(this.pages, 'PageOrder');
        },

        userPlanFactData: function userPlanFactData() {
            var display = [],
                tooltip = [],
                donePercent = null;
            if (this.info.User.SalesPlan != null) {
                var salesPlan = this.formatInt(this.info.User.SalesPlan.toFixed(0));
                display.push(salesPlan + ' шт.'); // (salesPlan < 1000 ? ' шт.' : ' руб.'));
                tooltip.push('План: ' + salesPlan + ' шт.'); // (salesPlan < 1000 ? ' шт.' : ' руб.'));
            }
            if (this.info.User.SalesFact != null) {
                var salesFact = this.formatInt(this.info.User.SalesFact.toFixed(0));
                display.push(salesFact + ' шт.'); // (salesFact < 1000 ? ' шт.' : ' руб.'));
                tooltip.push('Продано: ' + salesFact + ' шт.'); // (salesFact < 1000 ? ' шт.' : ' руб.'))
            }
            if (this.info.User.SalesPlan > 0 && this.info.User.SalesFact != null) {
                donePercent = this.info.User.SalesFact / this.info.User.SalesPlan * 100;
                tooltip.push('Выполнено: ' + donePercent.toFixed(2) + '%');
            }
            display.reverse();
            return {
                Display: display.join(' / ') + (donePercent != null ? ' (' + donePercent.toFixed(0) + '%)' : ''),
                Tooltip: tooltip.join(',<br>')
            };
        }
    },

    methods: {
        onSpanEnter: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function () {
            this.showSpanDetails = true;
        }, 200),

        onSpanLeave: function onSpanLeave() {
            this.showSpanDetails = false;
        },
        refreshMenuData: function refreshMenuData() {
            // todo:
        },
        setPages: function setPages() {
            var _this = this;

            var url = '/Content/dist/images.svg?v3#Menu';
            this.pages = [{
                Path: '/',
                Name: 'Новости',
                PageOrder: 1,
                active: this.$route.name === 'news' || this.$route.name === 'newsDetails' || this.$route.name === 'newsEdit',
                hasClaims: this.hasClaims(this.info.User.DynamicRole, this.claimEnums.newsPage) && !this.info.User.IsDisabled || this.info.User.MainRole === 'administrators',
                img: url + 'News',
                span: this.info.User.NotReadNews > 0 ? { css: '', value: this.info.User.NotReadNews } : null
            }, {
                Path: '/materials',
                Name: 'Материалы',
                PageOrder: 2,
                active: this.$route.path.startsWith('/materials'),
                hasClaims: this.hasClaims(this.info.User.DynamicRole, this.claimEnums.materialsPage) && !this.info.User.IsDisabled || this.info.User.MainRole === 'administrators',
                img: url + 'Material',
                span: this.info.User.NotLearnedMaterials > 0 ? { css: '', value: this.info.User.NotLearnedMaterials } : null
            }, {
                Path: '/reports',
                Name: 'Отчеты',
                PageOrder: 3,
                active: this.$route.name === 'reports',
                hasClaims: this.hasClaims(this.info.User.DynamicRole, this.claimEnums.reportsPage) && !this.info.User.IsDisabled || this.info.User.MainRole === 'administrators',
                img: url + 'Doc',
                span: this.info.User.ReportsOnEdition > 0 ? { css: '', value: this.info.User.ReportsOnEdition } : null
            }, {
                Path: '/rating',
                Name: 'Рейтинг',
                PageOrder: 4,
                active: this.$route.name === 'rating',
                hasClaims: this.hasClaims(this.info.User.DynamicRole, this.claimEnums.ratingPage) && !this.info.User.IsDisabled || this.info.User.MainRole === 'administrators',
                img: url + 'Rating'
            }, {
                Path: '/spend-bonuses',
                Name: 'Потратить бонусы',
                PageOrder: 5,
                active: this.$route.name === 'spend-bonuses' || this.$route.path.startsWith('/rewards'),
                hasClaims: this.hasClaims(this.info.User.DynamicRole, this.claimEnums.spendBonusesPage) || this.info.User.MainRole === 'administrators',
                img: url + 'Bonus',
                span: this.info.User.ActiveBalanceWithOrders > 0 ? { css: '', value: this.info.User.ActiveBalanceWithOrders } : null
            }, {
                Path: '/analytics',
                Name: 'Аналитика',
                PageOrder: 6,
                active: this.$route.name === 'analytics',
                hasClaims: this.hasClaims(this.info.User.DynamicRole, this.claimEnums.analyticsPage) && !this.info.User.IsDisabled || this.info.User.MainRole === 'administrators',
                img: url + 'Analit'
            }, {
                Path: '/sku',
                Name: 'SKU',
                PageOrder: 7,
                active: this.$route.path.startsWith('/sku'),
                hasClaims: this.hasClaims(this.info.User.DynamicRole, this.claimEnums.skuPage) && !this.info.User.IsDisabled || this.info.User.MainRole === 'administrators',
                img: url + 'Sku'
            }, {
                Path: '/motivation',
                Name: 'Программа мотивации',
                PageOrder: 8,
                active: this.$route.name === 'motivation',
                hasClaims: this.hasClaims(this.info.User.DynamicRole, this.claimEnums.motivationPage) && !this.info.User.IsDisabled || this.info.User.MainRole === 'administrators',
                img: url + 'Help'
            }, {
                Path: '/faq',
                Name: 'FAQ',
                PageOrder: 9,
                active: this.$route.name === 'faqPage',
                hasClaims: this.hasClaims(this.info.User.DynamicRole, this.claimEnums.faqPage) && !this.info.User.IsDisabled || this.info.User.MainRole === 'administrators',
                img: url + 'Faq'
            }, {
                Path: '/orders',
                Name: 'Заказы',
                PageOrder: 10,
                active: this.$route.name === 'orders',
                hasClaims: this.hasClaims(this.info.User.DynamicRole, this.claimEnums.ordersPage) && !this.info.User.IsDisabled || this.info.User.MainRole === 'administrators',
                img: url + 'Cabinet',
                span: this.info.User.OrdersToProcess > 0 ? { css: '', value: this.info.User.OrdersToProcess } : null
            }, {
                Path: '/cart',
                Name: 'Мои заказы',
                PageOrder: 11,
                active: this.$route.name === 'cart',
                hasClaims: this.hasClaims(this.info.User.DynamicRole, this.claimEnums.bonusSpend) && this.info.User.ProjectId !== 7,
                img: url + 'Cabinet'
            }, {
                Path: '/sender',
                Name: 'Рассылка',
                PageOrder: 12,
                active: this.$route.name === 'sender',
                hasClaims: this.hasClaims(this.info.User.DynamicRole, this.claimEnums.senderPage) || this.info.User.MainRole === 'administrators',
                img: url + 'Mail'
            }, {
                Path: '/tasks',
                Name: 'Задания',
                PageOrder: 13,
                active: this.$route.path.startsWith('/tasks'),
                hasClaims: this.hasClaims(this.info.User.DynamicRole, this.claimEnums.tasksPage) && !this.info.User.IsDisabled || this.info.User.MainRole === 'administrators',
                img: url + 'Tasks'
            }, {
                Path: '/my-progress',
                Name: 'Мои достижения',
                PageOrder: 14,
                active: this.$route.path.startsWith('/my-progress'),
                hasClaims: this.hasClaims(this.info.User.DynamicRole, this.claimEnums.myProgressPage) && !this.info.User.IsDisabled || this.info.User.MainRole === 'administrators',
                img: url + 'MyProgress'
            }];

            var _loop = function _loop(page) {
                var projectPage = _this.info.Pages.find(function (x) {
                    return x.Path === page.Path;
                });
                if (projectPage) {
                    page.PageOrder = projectPage.PageOrder;
                    if (projectPage.Name) {
                        page.Name = projectPage.Name;
                    }
                }
            };

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = this.pages[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var page = _step2.value;

                    _loop(page);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            if (this.hasClaims(this.info.User.DynamicRole, this.claimEnums.reportAdd) && !this.info.User.IsDisabled) {
                var reportAddPage = this.info.Pages.find(function (x) {
                    return x.Path === '/reports/0';
                });
                if (reportAddPage) {
                    if (reportAddPage.Name) {
                        this.addReportLinkName = reportAddPage.Name;
                    } else {
                        this.addReportLinkName = 'Добавить отчёт';
                    }
                }
            }
        }
    },

    mounted: function mounted() {
        var vm = this;
        vm.setPages();
        vm.$nextTick(function () {
            document.querySelector('.body-panel').appendChild(vm.$refs['spanTooltip']);
        });
    }
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums__ = __webpack_require__(19);


var authMixin = {

    // todo: refactor this!
    data: function data() {
        return {
            claimEnums: __WEBPACK_IMPORTED_MODULE_0__enums__["b" /* ClaimEnums */]
        };
    },


    methods: {
        hasClaims: function hasClaims(userRole, claim) {
            if (userRole == null) {
                return false;
            }
            var claimId = typeof claim === 'string' ? this.claimEnums[claim] : claim;
            //console.info('claimId', claimId)
            //console.info('userRole.Claims.find(x => x.ClaimId === claimId)', userRole.Claims.find(x => x.ClaimId === claimId) !== undefined)
            return userRole.Claims.find(function (x) {
                return x.ClaimId === claimId;
            }) !== undefined;
        },
        hasClaimsOrAdmin: function hasClaimsOrAdmin(user, claim) {
            if (user == null) {
                return false;
            }
            if (user.MainRole === 'administrators') {
                return true;
            }
            if (user.DynamicRole == null) {
                return false;
            }
            var claimId = typeof claim === 'string' ? this.claimEnums[claim] : claim;
            //console.info('claimId', claimId)
            //console.info('userRole.Claims.find(x => x.ClaimId === claimId)', userRole.Claims.find(x => x.ClaimId === claimId) !== undefined)
            return user.DynamicRole.Claims.find(function (x) {
                return x.ClaimId === claimId;
            }) !== undefined;
        },
        callApiWrapper: function callApiWrapper(promise) {
            var _this = this;

            var vm = this;
            return promise.then(function (resp) {
                if (resp.hasError) {

                    if (resp.status === 401) {
                        var loginUrlWithUTM = _this.getLoginUrlWithUTM();
                        vm.$router.push(loginUrlWithUTM);
                        return {
                            data: null,
                            status: 401,
                            hasError: true
                        };
                    }
                }

                return resp;
            });
        },


        // Функция для формирования URL с UTM-параметрами
        getLoginUrlWithUTM: function getLoginUrlWithUTM() {
            var urlParams = new URLSearchParams(window.location.search);
            var utmSource = urlParams.get('utm_source');
            var utmMedium = urlParams.get('utm_medium');
            var utmCampaign = urlParams.get('utm_campaign');

            // Базовый путь страницы логина
            var loginUrl = '/login';

            // Добавляем UTM-параметры, если они есть
            if (utmSource || utmMedium || utmCampaign) {
                loginUrl += '?';
                if (utmSource) loginUrl += 'utm_source=' + utmSource + '&';
                if (utmMedium) loginUrl += 'utm_medium=' + utmMedium + '&';
                if (utmCampaign) loginUrl += 'utm_campaign=' + utmCampaign;
                loginUrl = loginUrl.replace(/&$/, ''); // Убираем лишний символ '&' в конце
            }

            return loginUrl;
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (authMixin);

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "image_svg.svg?7b0d60351f903c0066853adabbc638ec";

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);
var settle = __webpack_require__(572);
var buildURL = __webpack_require__(574);
var parseHeaders = __webpack_require__(575);
var isURLSameOrigin = __webpack_require__(576);
var createError = __webpack_require__(213);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(577);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(573);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 216 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 217 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = map;
function map(arr, fn) {
    var res = [],
        i,
        arrLen = arr.length;
    for (i = 0; i < arrLen; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}


/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = set;
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeConfigs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_is_function__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_extend__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_is_object__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_has_own_prop__ = __webpack_require__(26);





function set(config) {
    var prop, i;
    for (i in config) {
        if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_has_own_prop__["a" /* default */])(config, i)) {
            prop = config[i];
            if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_is_function__["a" /* default */])(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' +
            /\d{1,2}/.source
    );
}

function mergeConfigs(parentConfig, childConfig) {
    var res = Object(__WEBPACK_IMPORTED_MODULE_1__utils_extend__["a" /* default */])({}, parentConfig),
        prop;
    for (prop in childConfig) {
        if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_has_own_prop__["a" /* default */])(childConfig, prop)) {
            if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_is_object__["a" /* default */])(parentConfig[prop]) && Object(__WEBPACK_IMPORTED_MODULE_2__utils_is_object__["a" /* default */])(childConfig[prop])) {
                res[prop] = {};
                Object(__WEBPACK_IMPORTED_MODULE_1__utils_extend__["a" /* default */])(res[prop], parentConfig[prop]);
                Object(__WEBPACK_IMPORTED_MODULE_1__utils_extend__["a" /* default */])(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (
            Object(__WEBPACK_IMPORTED_MODULE_3__utils_has_own_prop__["a" /* default */])(parentConfig, prop) &&
            !Object(__WEBPACK_IMPORTED_MODULE_3__utils_has_own_prop__["a" /* default */])(childConfig, prop) &&
            Object(__WEBPACK_IMPORTED_MODULE_2__utils_is_object__["a" /* default */])(parentConfig[prop])
        ) {
            // make sure changes to properties don't modify parent config
            res[prop] = Object(__WEBPACK_IMPORTED_MODULE_1__utils_extend__["a" /* default */])({}, res[prop]);
        }
    }
    return res;
}


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Locale;
function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultCalendar; });
/* harmony export (immutable) */ __webpack_exports__["a"] = calendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_is_function__ = __webpack_require__(66);
var defaultCalendar = {
    sameDay: '[Today at] LT',
    nextDay: '[Tomorrow at] LT',
    nextWeek: 'dddd [at] LT',
    lastDay: '[Yesterday at] LT',
    lastWeek: '[Last] dddd [at] LT',
    sameElse: 'L',
};



function calendar(key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_is_function__["a" /* default */])(output) ? output.call(mom, now) : output;
}


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultLongDateFormat; });
/* harmony export (immutable) */ __webpack_exports__["b"] = longDateFormat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_format__ = __webpack_require__(23);


var defaultLongDateFormat = {
    LTS: 'h:mm:ss A',
    LT: 'h:mm A',
    L: 'MM/DD/YYYY',
    LL: 'MMMM D, YYYY',
    LLL: 'MMMM D, YYYY h:mm A',
    LLLL: 'dddd, MMMM D, YYYY h:mm A',
};

function longDateFormat(key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper
        .match(__WEBPACK_IMPORTED_MODULE_0__format_format__["e" /* formattingTokens */])
        .map(function (tok) {
            if (
                tok === 'MMMM' ||
                tok === 'MM' ||
                tok === 'DD' ||
                tok === 'dddd'
            ) {
                return tok.slice(1);
            }
            return tok;
        })
        .join('');

    return this._longDateFormat[key];
}


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultInvalidDate; });
/* harmony export (immutable) */ __webpack_exports__["b"] = invalidDate;
var defaultInvalidDate = 'Invalid date';

function invalidDate() {
    return this._invalidDate;
}


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultOrdinal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultDayOfMonthOrdinalParse; });
/* harmony export (immutable) */ __webpack_exports__["c"] = ordinal;
var defaultOrdinal = '%d',
    defaultDayOfMonthOrdinalParse = /\d{1,2}/;



function ordinal(number) {
    return this._ordinal.replace('%d', number);
}


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultRelativeTime; });
/* harmony export (immutable) */ __webpack_exports__["c"] = relativeTime;
/* harmony export (immutable) */ __webpack_exports__["b"] = pastFuture;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_is_function__ = __webpack_require__(66);
var defaultRelativeTime = {
    future: 'in %s',
    past: '%s ago',
    s: 'a few seconds',
    ss: '%d seconds',
    m: 'a minute',
    mm: '%d minutes',
    h: 'an hour',
    hh: '%d hours',
    d: 'a day',
    dd: '%d days',
    w: 'a week',
    ww: '%d weeks',
    M: 'a month',
    MM: '%d months',
    y: 'a year',
    yy: '%d years',
};



function relativeTime(number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_is_function__["a" /* default */])(output)
        ? output(number, withoutSuffix, string, isFuture)
        : output.replace(/%d/i, number);
}

function pastFuture(diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_is_function__["a" /* default */])(format) ? format(output) : format.replace(/%s/i, output);
}


/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = checkOverflow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__units_month__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__units_constants__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__create_parsing_flags__ = __webpack_require__(42);




function checkOverflow(m) {
    var overflow,
        a = m._a;

    if (a && Object(__WEBPACK_IMPORTED_MODULE_2__create_parsing_flags__["a" /* default */])(m).overflow === -2) {
        overflow =
            a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["e" /* MONTH */]] < 0 || a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["e" /* MONTH */]] > 11
                ? __WEBPACK_IMPORTED_MODULE_1__units_constants__["e" /* MONTH */]
                : a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["a" /* DATE */]] < 1 || a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["a" /* DATE */]] > Object(__WEBPACK_IMPORTED_MODULE_0__units_month__["a" /* daysInMonth */])(a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["i" /* YEAR */]], a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["e" /* MONTH */]])
                ? __WEBPACK_IMPORTED_MODULE_1__units_constants__["a" /* DATE */]
                : a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["b" /* HOUR */]] < 0 ||
                  a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["b" /* HOUR */]] > 24 ||
                  (a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["b" /* HOUR */]] === 24 &&
                      (a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["d" /* MINUTE */]] !== 0 ||
                          a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["f" /* SECOND */]] !== 0 ||
                          a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["c" /* MILLISECOND */]] !== 0))
                ? __WEBPACK_IMPORTED_MODULE_1__units_constants__["b" /* HOUR */]
                : a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["d" /* MINUTE */]] < 0 || a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["d" /* MINUTE */]] > 59
                ? __WEBPACK_IMPORTED_MODULE_1__units_constants__["d" /* MINUTE */]
                : a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["f" /* SECOND */]] < 0 || a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["f" /* SECOND */]] > 59
                ? __WEBPACK_IMPORTED_MODULE_1__units_constants__["f" /* SECOND */]
                : a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["c" /* MILLISECOND */]] < 0 || a[__WEBPACK_IMPORTED_MODULE_1__units_constants__["c" /* MILLISECOND */]] > 999
                ? __WEBPACK_IMPORTED_MODULE_1__units_constants__["c" /* MILLISECOND */]
                : -1;

        if (
            Object(__WEBPACK_IMPORTED_MODULE_2__create_parsing_flags__["a" /* default */])(m)._overflowDayOfYear &&
            (overflow < __WEBPACK_IMPORTED_MODULE_1__units_constants__["i" /* YEAR */] || overflow > __WEBPACK_IMPORTED_MODULE_1__units_constants__["a" /* DATE */])
        ) {
            overflow = __WEBPACK_IMPORTED_MODULE_1__units_constants__["a" /* DATE */];
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_2__create_parsing_flags__["a" /* default */])(m)._overflowWeeks && overflow === -1) {
            overflow = __WEBPACK_IMPORTED_MODULE_1__units_constants__["g" /* WEEK */];
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_2__create_parsing_flags__["a" /* default */])(m)._overflowWeekday && overflow === -1) {
            overflow = __WEBPACK_IMPORTED_MODULE_1__units_constants__["h" /* WEEKDAY */];
        }

        Object(__WEBPACK_IMPORTED_MODULE_2__create_parsing_flags__["a" /* default */])(m).overflow = overflow;
    }

    return m;
}


/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = configFromISO;
/* harmony export (immutable) */ __webpack_exports__["b"] = configFromRFC2822;
/* harmony export (immutable) */ __webpack_exports__["c"] = configFromString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__from_string_and_format__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__date_from_array__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_hooks__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_deprecate__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parsing_flags__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__units_month__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__units_day_of_week__ = __webpack_require__(98);








// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex =
        /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
    basicIsoRegex =
        /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
    tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
    isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/],
        ['YYYYMM', /\d{6}/, false],
        ['YYYY', /\d{4}/, false],
    ],
    // iso time formats and regexes
    isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/],
    ],
    aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 =
        /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
    obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60,
    };

// date from iso format
function configFromISO(config) {
    var i,
        l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime,
        dateFormat,
        timeFormat,
        tzFormat,
        isoDatesLen = isoDates.length,
        isoTimesLen = isoTimes.length;

    if (match) {
        Object(__WEBPACK_IMPORTED_MODULE_4__parsing_flags__["a" /* default */])(config).iso = true;
        for (i = 0, l = isoDatesLen; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimesLen; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        Object(__WEBPACK_IMPORTED_MODULE_0__from_string_and_format__["a" /* configFromStringAndFormat */])(config);
    } else {
        config._isValid = false;
    }
}

function extractFromRFC2822Strings(
    yearStr,
    monthStr,
    dayStr,
    hourStr,
    minuteStr,
    secondStr
) {
    var result = [
        untruncateYear(yearStr),
        __WEBPACK_IMPORTED_MODULE_5__units_month__["c" /* defaultLocaleMonthsShort */].indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10),
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s
        .replace(/\([^)]*\)|[\n\t]/g, ' ')
        .replace(/(\s\s+)/g, ' ')
        .replace(/^\s\s*/, '')
        .replace(/\s\s*$/, '');
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
        var weekdayProvided = __WEBPACK_IMPORTED_MODULE_6__units_day_of_week__["c" /* defaultLocaleWeekdaysShort */].indexOf(weekdayStr),
            weekdayActual = new Date(
                parsedInput[0],
                parsedInput[1],
                parsedInput[2]
            ).getDay();
        if (weekdayProvided !== weekdayActual) {
            Object(__WEBPACK_IMPORTED_MODULE_4__parsing_flags__["a" /* default */])(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10),
            m = hm % 100,
            h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i)),
        parsedArray;
    if (match) {
        parsedArray = extractFromRFC2822Strings(
            match[4],
            match[3],
            match[2],
            match[5],
            match[6],
            match[7]
        );
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = __WEBPACK_IMPORTED_MODULE_1__date_from_array__["b" /* createUTCDate */].apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        Object(__WEBPACK_IMPORTED_MODULE_4__parsing_flags__["a" /* default */])(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);
    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    if (config._strict) {
        config._isValid = false;
    } else {
        // Final attempt, use Input Fallback
        __WEBPACK_IMPORTED_MODULE_2__utils_hooks__["a" /* hooks */].createFromInputFallback(config);
    }
}

__WEBPACK_IMPORTED_MODULE_2__utils_hooks__["a" /* hooks */].createFromInputFallback = Object(__WEBPACK_IMPORTED_MODULE_3__utils_deprecate__["a" /* deprecate */])(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);


/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return prototypeMin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return prototypeMax; });
/* harmony export (immutable) */ __webpack_exports__["b"] = min;
/* harmony export (immutable) */ __webpack_exports__["a"] = max;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_deprecate__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_is_array__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__create_local__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__create_valid__ = __webpack_require__(88);





var prototypeMin = Object(__WEBPACK_IMPORTED_MODULE_0__utils_deprecate__["a" /* deprecate */])(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = __WEBPACK_IMPORTED_MODULE_2__create_local__["a" /* createLocal */].apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return Object(__WEBPACK_IMPORTED_MODULE_3__create_valid__["a" /* createInvalid */])();
            }
        }
    ),
    prototypeMax = Object(__WEBPACK_IMPORTED_MODULE_0__utils_deprecate__["a" /* deprecate */])(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = __WEBPACK_IMPORTED_MODULE_2__create_local__["a" /* createLocal */].apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return Object(__WEBPACK_IMPORTED_MODULE_3__create_valid__["a" /* createInvalid */])();
            }
        }
    );

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && Object(__WEBPACK_IMPORTED_MODULE_1__utils_is_array__["a" /* default */])(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__create_local__["a" /* createLocal */])();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min() {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max() {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}


/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = addSubtract;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return add; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return subtract; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__get_set__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__units_month__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__duration_create__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_deprecate__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_hooks__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_abs_round__ = __webpack_require__(230);







// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            Object(__WEBPACK_IMPORTED_MODULE_3__utils_deprecate__["b" /* deprecateSimple */])(
                name,
                'moment().' +
                    name +
                    '(period, number) is deprecated. Please use moment().' +
                    name +
                    '(number, period). ' +
                    'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
            );
            tmp = val;
            val = period;
            period = tmp;
        }

        dur = Object(__WEBPACK_IMPORTED_MODULE_2__duration_create__["a" /* createDuration */])(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract(mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = Object(__WEBPACK_IMPORTED_MODULE_5__utils_abs_round__["a" /* default */])(duration._days),
        months = Object(__WEBPACK_IMPORTED_MODULE_5__utils_abs_round__["a" /* default */])(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        Object(__WEBPACK_IMPORTED_MODULE_1__units_month__["k" /* setMonth */])(mom, Object(__WEBPACK_IMPORTED_MODULE_0__get_set__["a" /* get */])(mom, 'Month') + months * isAdding);
    }
    if (days) {
        Object(__WEBPACK_IMPORTED_MODULE_0__get_set__["c" /* set */])(mom, 'Date', Object(__WEBPACK_IMPORTED_MODULE_0__get_set__["a" /* get */])(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        __WEBPACK_IMPORTED_MODULE_4__utils_hooks__["a" /* hooks */].updateOffset(mom, days || months);
    }
}

var add = createAdder(1, 'add'),
    subtract = createAdder(-1, 'subtract');


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = absRound;
function absRound(number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}


/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getCalendarFormat;
/* harmony export (immutable) */ __webpack_exports__["a"] = calendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create_local__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__units_offset__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_is_function__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_hooks__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_is_moment_input__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_is_calendar_spec__ = __webpack_require__(601);







function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6
        ? 'sameElse'
        : diff < -1
        ? 'lastWeek'
        : diff < 0
        ? 'lastDay'
        : diff < 1
        ? 'sameDay'
        : diff < 2
        ? 'nextDay'
        : diff < 7
        ? 'nextWeek'
        : 'sameElse';
}

function calendar(time, formats) {
    // Support for single parameter, formats only overload to the calendar function
    if (arguments.length === 1) {
        if (!arguments[0]) {
            time = undefined;
            formats = undefined;
        } else if (Object(__WEBPACK_IMPORTED_MODULE_4__utils_is_moment_input__["a" /* isMomentInput */])(arguments[0])) {
            time = arguments[0];
            formats = undefined;
        } else if (Object(__WEBPACK_IMPORTED_MODULE_5__utils_is_calendar_spec__["a" /* default */])(arguments[0])) {
            formats = arguments[0];
            time = undefined;
        }
    }
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || Object(__WEBPACK_IMPORTED_MODULE_0__create_local__["a" /* createLocal */])(),
        sod = Object(__WEBPACK_IMPORTED_MODULE_1__units_offset__["a" /* cloneWithOffset */])(now, this).startOf('day'),
        format = __WEBPACK_IMPORTED_MODULE_3__utils_hooks__["a" /* hooks */].calendarFormat(this, sod) || 'sameElse',
        output =
            formats &&
            (Object(__WEBPACK_IMPORTED_MODULE_2__utils_is_function__["a" /* default */])(formats[format])
                ? formats[format].call(this, now)
                : formats[format]);

    return this.format(
        output || this.localeData().calendar(format, this, Object(__WEBPACK_IMPORTED_MODULE_0__create_local__["a" /* createLocal */])(now))
    );
}


/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = locale;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return lang; });
/* harmony export (immutable) */ __webpack_exports__["c"] = localeData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_locales__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_deprecate__ = __webpack_require__(65);



// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale(key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = Object(__WEBPACK_IMPORTED_MODULE_0__locale_locales__["b" /* getLocale */])(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = Object(__WEBPACK_IMPORTED_MODULE_1__utils_deprecate__["a" /* deprecate */])(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData() {
    return this._locale;
}


/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = localeEras;
/* harmony export (immutable) */ __webpack_exports__["j"] = localeErasParse;
/* harmony export (immutable) */ __webpack_exports__["i"] = localeErasConvertYear;
/* harmony export (immutable) */ __webpack_exports__["e"] = getEraName;
/* harmony export (immutable) */ __webpack_exports__["f"] = getEraNarrow;
/* harmony export (immutable) */ __webpack_exports__["d"] = getEraAbbr;
/* harmony export (immutable) */ __webpack_exports__["g"] = getEraYear;
/* harmony export (immutable) */ __webpack_exports__["b"] = erasNameRegex;
/* harmony export (immutable) */ __webpack_exports__["a"] = erasAbbrRegex;
/* harmony export (immutable) */ __webpack_exports__["c"] = erasNarrowRegex;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_format__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse_regex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parse_token__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_hooks__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__locale_locales__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__create_parsing_flags__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_has_own_prop__ = __webpack_require__(26);









Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('N', 0, 0, 'eraAbbr');
Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('NN', 0, 0, 'eraAbbr');
Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('NNN', 0, 0, 'eraAbbr');
Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('NNNN', 0, 0, 'eraName');
Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('NNNNN', 0, 0, 'eraNarrow');

Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('y', ['y', 1], 'yo', 'eraYear');
Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('y', ['yy', 2], 0, 'eraYear');
Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('y', ['yyy', 3], 0, 'eraYear');
Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('y', ['yyyy', 4], 0, 'eraYear');

Object(__WEBPACK_IMPORTED_MODULE_1__parse_regex__["a" /* addRegexToken */])('N', matchEraAbbr);
Object(__WEBPACK_IMPORTED_MODULE_1__parse_regex__["a" /* addRegexToken */])('NN', matchEraAbbr);
Object(__WEBPACK_IMPORTED_MODULE_1__parse_regex__["a" /* addRegexToken */])('NNN', matchEraAbbr);
Object(__WEBPACK_IMPORTED_MODULE_1__parse_regex__["a" /* addRegexToken */])('NNNN', matchEraName);
Object(__WEBPACK_IMPORTED_MODULE_1__parse_regex__["a" /* addRegexToken */])('NNNNN', matchEraNarrow);

Object(__WEBPACK_IMPORTED_MODULE_2__parse_token__["a" /* addParseToken */])(
    ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
    function (input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            Object(__WEBPACK_IMPORTED_MODULE_6__create_parsing_flags__["a" /* default */])(config).era = era;
        } else {
            Object(__WEBPACK_IMPORTED_MODULE_6__create_parsing_flags__["a" /* default */])(config).invalidEra = input;
        }
    }
);

Object(__WEBPACK_IMPORTED_MODULE_1__parse_regex__["a" /* addRegexToken */])('y', __WEBPACK_IMPORTED_MODULE_1__parse_regex__["r" /* matchUnsigned */]);
Object(__WEBPACK_IMPORTED_MODULE_1__parse_regex__["a" /* addRegexToken */])('yy', __WEBPACK_IMPORTED_MODULE_1__parse_regex__["r" /* matchUnsigned */]);
Object(__WEBPACK_IMPORTED_MODULE_1__parse_regex__["a" /* addRegexToken */])('yyy', __WEBPACK_IMPORTED_MODULE_1__parse_regex__["r" /* matchUnsigned */]);
Object(__WEBPACK_IMPORTED_MODULE_1__parse_regex__["a" /* addRegexToken */])('yyyy', __WEBPACK_IMPORTED_MODULE_1__parse_regex__["r" /* matchUnsigned */]);
Object(__WEBPACK_IMPORTED_MODULE_1__parse_regex__["a" /* addRegexToken */])('yo', matchEraYearOrdinal);

Object(__WEBPACK_IMPORTED_MODULE_2__parse_token__["a" /* addParseToken */])(['y', 'yy', 'yyy', 'yyyy'], __WEBPACK_IMPORTED_MODULE_3__constants__["i" /* YEAR */]);
Object(__WEBPACK_IMPORTED_MODULE_2__parse_token__["a" /* addParseToken */])(['yo'], function (input, array, config, token) {
    var match;
    if (config._locale._eraYearOrdinalRegex) {
        match = input.match(config._locale._eraYearOrdinalRegex);
    }

    if (config._locale.eraYearOrdinalParse) {
        array[__WEBPACK_IMPORTED_MODULE_3__constants__["i" /* YEAR */]] = config._locale.eraYearOrdinalParse(input, match);
    } else {
        array[__WEBPACK_IMPORTED_MODULE_3__constants__["i" /* YEAR */]] = parseInt(input, 10);
    }
});

function localeEras(m, format) {
    var i,
        l,
        date,
        eras = this._eras || Object(__WEBPACK_IMPORTED_MODULE_5__locale_locales__["b" /* getLocale */])('en')._eras;
    for (i = 0, l = eras.length; i < l; ++i) {
        switch (typeof eras[i].since) {
            case 'string':
                // truncate time
                date = Object(__WEBPACK_IMPORTED_MODULE_4__utils_hooks__["a" /* hooks */])(eras[i].since).startOf('day');
                eras[i].since = date.valueOf();
                break;
        }

        switch (typeof eras[i].until) {
            case 'undefined':
                eras[i].until = +Infinity;
                break;
            case 'string':
                // truncate time
                date = Object(__WEBPACK_IMPORTED_MODULE_4__utils_hooks__["a" /* hooks */])(eras[i].until).startOf('day').valueOf();
                eras[i].until = date.valueOf();
                break;
        }
    }
    return eras;
}

function localeErasParse(eraName, format, strict) {
    var i,
        l,
        eras = this.eras(),
        name,
        abbr,
        narrow;
    eraName = eraName.toUpperCase();

    for (i = 0, l = eras.length; i < l; ++i) {
        name = eras[i].name.toUpperCase();
        abbr = eras[i].abbr.toUpperCase();
        narrow = eras[i].narrow.toUpperCase();

        if (strict) {
            switch (format) {
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) {
                        return eras[i];
                    }
                    break;

                case 'NNNN':
                    if (name === eraName) {
                        return eras[i];
                    }
                    break;

                case 'NNNNN':
                    if (narrow === eraName) {
                        return eras[i];
                    }
                    break;
            }
        } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
            return eras[i];
        }
    }
}

function localeErasConvertYear(era, year) {
    var dir = era.since <= era.until ? +1 : -1;
    if (year === undefined) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__utils_hooks__["a" /* hooks */])(era.since).year();
    } else {
        return Object(__WEBPACK_IMPORTED_MODULE_4__utils_hooks__["a" /* hooks */])(era.since).year() + (year - era.offset) * dir;
    }
}

function getEraName() {
    var i,
        l,
        val,
        eras = this.localeData().eras();
    for (i = 0, l = eras.length; i < l; ++i) {
        // truncate time
        val = this.clone().startOf('day').valueOf();

        if (eras[i].since <= val && val <= eras[i].until) {
            return eras[i].name;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
            return eras[i].name;
        }
    }

    return '';
}

function getEraNarrow() {
    var i,
        l,
        val,
        eras = this.localeData().eras();
    for (i = 0, l = eras.length; i < l; ++i) {
        // truncate time
        val = this.clone().startOf('day').valueOf();

        if (eras[i].since <= val && val <= eras[i].until) {
            return eras[i].narrow;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
            return eras[i].narrow;
        }
    }

    return '';
}

function getEraAbbr() {
    var i,
        l,
        val,
        eras = this.localeData().eras();
    for (i = 0, l = eras.length; i < l; ++i) {
        // truncate time
        val = this.clone().startOf('day').valueOf();

        if (eras[i].since <= val && val <= eras[i].until) {
            return eras[i].abbr;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
            return eras[i].abbr;
        }
    }

    return '';
}

function getEraYear() {
    var i,
        l,
        dir,
        val,
        eras = this.localeData().eras();
    for (i = 0, l = eras.length; i < l; ++i) {
        dir = eras[i].since <= eras[i].until ? +1 : -1;

        // truncate time
        val = this.clone().startOf('day').valueOf();

        if (
            (eras[i].since <= val && val <= eras[i].until) ||
            (eras[i].until <= val && val <= eras[i].since)
        ) {
            return (
                (this.year() - Object(__WEBPACK_IMPORTED_MODULE_4__utils_hooks__["a" /* hooks */])(eras[i].since).year()) * dir +
                eras[i].offset
            );
        }
    }

    return this.year();
}

function erasNameRegex(isStrict) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_7__utils_has_own_prop__["a" /* default */])(this, '_erasNameRegex')) {
        computeErasParse.call(this);
    }
    return isStrict ? this._erasNameRegex : this._erasRegex;
}

function erasAbbrRegex(isStrict) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_7__utils_has_own_prop__["a" /* default */])(this, '_erasAbbrRegex')) {
        computeErasParse.call(this);
    }
    return isStrict ? this._erasAbbrRegex : this._erasRegex;
}

function erasNarrowRegex(isStrict) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_7__utils_has_own_prop__["a" /* default */])(this, '_erasNarrowRegex')) {
        computeErasParse.call(this);
    }
    return isStrict ? this._erasNarrowRegex : this._erasRegex;
}

function matchEraAbbr(isStrict, locale) {
    return locale.erasAbbrRegex(isStrict);
}

function matchEraName(isStrict, locale) {
    return locale.erasNameRegex(isStrict);
}

function matchEraNarrow(isStrict, locale) {
    return locale.erasNarrowRegex(isStrict);
}

function matchEraYearOrdinal(isStrict, locale) {
    return locale._eraYearOrdinalRegex || __WEBPACK_IMPORTED_MODULE_1__parse_regex__["r" /* matchUnsigned */];
}

function computeErasParse() {
    var abbrPieces = [],
        namePieces = [],
        narrowPieces = [],
        mixedPieces = [],
        i,
        l,
        eras = this.eras();

    for (i = 0, l = eras.length; i < l; ++i) {
        namePieces.push(Object(__WEBPACK_IMPORTED_MODULE_1__parse_regex__["t" /* regexEscape */])(eras[i].name));
        abbrPieces.push(Object(__WEBPACK_IMPORTED_MODULE_1__parse_regex__["t" /* regexEscape */])(eras[i].abbr));
        narrowPieces.push(Object(__WEBPACK_IMPORTED_MODULE_1__parse_regex__["t" /* regexEscape */])(eras[i].narrow));

        mixedPieces.push(Object(__WEBPACK_IMPORTED_MODULE_1__parse_regex__["t" /* regexEscape */])(eras[i].name));
        mixedPieces.push(Object(__WEBPACK_IMPORTED_MODULE_1__parse_regex__["t" /* regexEscape */])(eras[i].abbr));
        mixedPieces.push(Object(__WEBPACK_IMPORTED_MODULE_1__parse_regex__["t" /* regexEscape */])(eras[i].narrow));
    }

    this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
    this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
    this._erasNarrowRegex = new RegExp(
        '^(' + narrowPieces.join('|') + ')',
        'i'
    );
}


/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getSetWeekYear;
/* harmony export (immutable) */ __webpack_exports__["c"] = getSetISOWeekYear;
/* harmony export (immutable) */ __webpack_exports__["b"] = getISOWeeksInYear;
/* harmony export (immutable) */ __webpack_exports__["a"] = getISOWeeksInISOWeekYear;
/* harmony export (immutable) */ __webpack_exports__["f"] = getWeeksInYear;
/* harmony export (immutable) */ __webpack_exports__["e"] = getWeeksInWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_format__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aliases__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__priorities__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parse_regex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parse_token__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__week_calendar_utils__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_to_int__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_hooks__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__create_date_from_array__ = __webpack_require__(121);










// FORMATTING

Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken(token, getter) {
    Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg', 'weekYear');
addWeekYearFormatToken('ggggg', 'weekYear');
addWeekYearFormatToken('GGGG', 'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

Object(__WEBPACK_IMPORTED_MODULE_1__aliases__["a" /* addUnitAlias */])('weekYear', 'gg');
Object(__WEBPACK_IMPORTED_MODULE_1__aliases__["a" /* addUnitAlias */])('isoWeekYear', 'GG');

// PRIORITY

Object(__WEBPACK_IMPORTED_MODULE_2__priorities__["a" /* addUnitPriority */])('weekYear', 1);
Object(__WEBPACK_IMPORTED_MODULE_2__priorities__["a" /* addUnitPriority */])('isoWeekYear', 1);

// PARSING

Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('G', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["p" /* matchSigned */]);
Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('g', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["p" /* matchSigned */]);
Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('GG', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["d" /* match1to2 */], __WEBPACK_IMPORTED_MODULE_3__parse_regex__["h" /* match2 */]);
Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('gg', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["d" /* match1to2 */], __WEBPACK_IMPORTED_MODULE_3__parse_regex__["h" /* match2 */]);
Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('GGGG', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["f" /* match1to4 */], __WEBPACK_IMPORTED_MODULE_3__parse_regex__["k" /* match4 */]);
Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('gggg', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["f" /* match1to4 */], __WEBPACK_IMPORTED_MODULE_3__parse_regex__["k" /* match4 */]);
Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('GGGGG', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["g" /* match1to6 */], __WEBPACK_IMPORTED_MODULE_3__parse_regex__["m" /* match6 */]);
Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('ggggg', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["g" /* match1to6 */], __WEBPACK_IMPORTED_MODULE_3__parse_regex__["m" /* match6 */]);

Object(__WEBPACK_IMPORTED_MODULE_4__parse_token__["c" /* addWeekParseToken */])(
    ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
    function (input, week, config, token) {
        week[token.substr(0, 2)] = Object(__WEBPACK_IMPORTED_MODULE_6__utils_to_int__["a" /* default */])(input);
    }
);

Object(__WEBPACK_IMPORTED_MODULE_4__parse_token__["c" /* addWeekParseToken */])(['gg', 'GG'], function (input, week, config, token) {
    week[token] = __WEBPACK_IMPORTED_MODULE_7__utils_hooks__["a" /* hooks */].parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear(input) {
    return getSetWeekYearHelper.call(
        this,
        input,
        this.week(),
        this.weekday(),
        this.localeData()._week.dow,
        this.localeData()._week.doy
    );
}

function getSetISOWeekYear(input) {
    return getSetWeekYearHelper.call(
        this,
        input,
        this.isoWeek(),
        this.isoWeekday(),
        1,
        4
    );
}

function getISOWeeksInYear() {
    return Object(__WEBPACK_IMPORTED_MODULE_5__week_calendar_utils__["c" /* weeksInYear */])(this.year(), 1, 4);
}

function getISOWeeksInISOWeekYear() {
    return Object(__WEBPACK_IMPORTED_MODULE_5__week_calendar_utils__["c" /* weeksInYear */])(this.isoWeekYear(), 1, 4);
}

function getWeeksInYear() {
    var weekInfo = this.localeData()._week;
    return Object(__WEBPACK_IMPORTED_MODULE_5__week_calendar_utils__["c" /* weeksInYear */])(this.year(), weekInfo.dow, weekInfo.doy);
}

function getWeeksInWeekYear() {
    var weekInfo = this.localeData()._week;
    return Object(__WEBPACK_IMPORTED_MODULE_5__week_calendar_utils__["c" /* weeksInYear */])(this.weekYear(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__week_calendar_utils__["b" /* weekOfYear */])(this, dow, doy).year;
    } else {
        weeksTarget = Object(__WEBPACK_IMPORTED_MODULE_5__week_calendar_utils__["c" /* weeksInYear */])(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = Object(__WEBPACK_IMPORTED_MODULE_5__week_calendar_utils__["a" /* dayOfYearFromWeeks */])(weekYear, week, weekday, dow, doy),
        date = Object(__WEBPACK_IMPORTED_MODULE_8__create_date_from_array__["b" /* createUTCDate */])(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}


/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSetQuarter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_format__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aliases__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__priorities__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parse_regex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parse_token__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_to_int__ = __webpack_require__(24);








// FORMATTING

Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('Q', 0, 'Qo', 'quarter');

// ALIASES

Object(__WEBPACK_IMPORTED_MODULE_1__aliases__["a" /* addUnitAlias */])('quarter', 'Q');

// PRIORITY

Object(__WEBPACK_IMPORTED_MODULE_2__priorities__["a" /* addUnitPriority */])('quarter', 7);

// PARSING

Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('Q', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["c" /* match1 */]);
Object(__WEBPACK_IMPORTED_MODULE_4__parse_token__["a" /* addParseToken */])('Q', function (input, array) {
    array[__WEBPACK_IMPORTED_MODULE_5__constants__["e" /* MONTH */]] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_to_int__["a" /* default */])(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter(input) {
    return input == null
        ? Math.ceil((this.month() + 1) / 3)
        : this.month((input - 1) * 3 + (this.month() % 3));
}


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSetDayOfMonth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__moment_get_set__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__format_format__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aliases__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__priorities__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parse_regex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parse_token__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_to_int__ = __webpack_require__(24);









// FORMATTING

Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])('D', ['DD', 2], 'Do', 'date');

// ALIASES

Object(__WEBPACK_IMPORTED_MODULE_2__aliases__["a" /* addUnitAlias */])('date', 'D');

// PRIORITY
Object(__WEBPACK_IMPORTED_MODULE_3__priorities__["a" /* addUnitPriority */])('date', 9);

// PARSING

Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('D', __WEBPACK_IMPORTED_MODULE_4__parse_regex__["d" /* match1to2 */]);
Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('DD', __WEBPACK_IMPORTED_MODULE_4__parse_regex__["d" /* match1to2 */], __WEBPACK_IMPORTED_MODULE_4__parse_regex__["h" /* match2 */]);
Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict
        ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
        : locale._dayOfMonthOrdinalParseLenient;
});

Object(__WEBPACK_IMPORTED_MODULE_5__parse_token__["a" /* addParseToken */])(['D', 'DD'], __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* DATE */]);
Object(__WEBPACK_IMPORTED_MODULE_5__parse_token__["a" /* addParseToken */])('Do', function (input, array) {
    array[__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* DATE */]] = Object(__WEBPACK_IMPORTED_MODULE_7__utils_to_int__["a" /* default */])(input.match(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["d" /* match1to2 */])[0]);
});

// MOMENTS

var getSetDayOfMonth = Object(__WEBPACK_IMPORTED_MODULE_0__moment_get_set__["b" /* makeGetSet */])('Date', true);


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSetDayOfYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_format__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aliases__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__priorities__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parse_regex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parse_token__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_to_int__ = __webpack_require__(24);







// FORMATTING

Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

Object(__WEBPACK_IMPORTED_MODULE_1__aliases__["a" /* addUnitAlias */])('dayOfYear', 'DDD');

// PRIORITY
Object(__WEBPACK_IMPORTED_MODULE_2__priorities__["a" /* addUnitPriority */])('dayOfYear', 4);

// PARSING

Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('DDD', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["e" /* match1to3 */]);
Object(__WEBPACK_IMPORTED_MODULE_3__parse_regex__["a" /* addRegexToken */])('DDDD', __WEBPACK_IMPORTED_MODULE_3__parse_regex__["i" /* match3 */]);
Object(__WEBPACK_IMPORTED_MODULE_4__parse_token__["a" /* addParseToken */])(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = Object(__WEBPACK_IMPORTED_MODULE_5__utils_to_int__["a" /* default */])(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear(input) {
    var dayOfYear =
        Math.round(
            (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
        ) + 1;
    return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
}


/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSetMinute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__moment_get_set__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__format_format__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aliases__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__priorities__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parse_regex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parse_token__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(36);








// FORMATTING

Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])('m', ['mm', 2], 0, 'minute');

// ALIASES

Object(__WEBPACK_IMPORTED_MODULE_2__aliases__["a" /* addUnitAlias */])('minute', 'm');

// PRIORITY

Object(__WEBPACK_IMPORTED_MODULE_3__priorities__["a" /* addUnitPriority */])('minute', 14);

// PARSING

Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('m', __WEBPACK_IMPORTED_MODULE_4__parse_regex__["d" /* match1to2 */]);
Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('mm', __WEBPACK_IMPORTED_MODULE_4__parse_regex__["d" /* match1to2 */], __WEBPACK_IMPORTED_MODULE_4__parse_regex__["h" /* match2 */]);
Object(__WEBPACK_IMPORTED_MODULE_5__parse_token__["a" /* addParseToken */])(['m', 'mm'], __WEBPACK_IMPORTED_MODULE_6__constants__["d" /* MINUTE */]);

// MOMENTS

var getSetMinute = Object(__WEBPACK_IMPORTED_MODULE_0__moment_get_set__["b" /* makeGetSet */])('Minutes', false);


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSetSecond; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__moment_get_set__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__format_format__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aliases__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__priorities__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parse_regex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parse_token__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(36);








// FORMATTING

Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])('s', ['ss', 2], 0, 'second');

// ALIASES

Object(__WEBPACK_IMPORTED_MODULE_2__aliases__["a" /* addUnitAlias */])('second', 's');

// PRIORITY

Object(__WEBPACK_IMPORTED_MODULE_3__priorities__["a" /* addUnitPriority */])('second', 15);

// PARSING

Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('s', __WEBPACK_IMPORTED_MODULE_4__parse_regex__["d" /* match1to2 */]);
Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('ss', __WEBPACK_IMPORTED_MODULE_4__parse_regex__["d" /* match1to2 */], __WEBPACK_IMPORTED_MODULE_4__parse_regex__["h" /* match2 */]);
Object(__WEBPACK_IMPORTED_MODULE_5__parse_token__["a" /* addParseToken */])(['s', 'ss'], __WEBPACK_IMPORTED_MODULE_6__constants__["f" /* SECOND */]);

// MOMENTS

var getSetSecond = Object(__WEBPACK_IMPORTED_MODULE_0__moment_get_set__["b" /* makeGetSet */])('Seconds', false);


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSetMillisecond; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__moment_get_set__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__format_format__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aliases__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__priorities__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parse_regex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parse_token__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_to_int__ = __webpack_require__(24);









// FORMATTING

Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])(0, ['SSS', 3], 0, 'millisecond');
Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
Object(__WEBPACK_IMPORTED_MODULE_1__format_format__["a" /* addFormatToken */])(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});

// ALIASES

Object(__WEBPACK_IMPORTED_MODULE_2__aliases__["a" /* addUnitAlias */])('millisecond', 'ms');

// PRIORITY

Object(__WEBPACK_IMPORTED_MODULE_3__priorities__["a" /* addUnitPriority */])('millisecond', 16);

// PARSING

Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('S', __WEBPACK_IMPORTED_MODULE_4__parse_regex__["e" /* match1to3 */], __WEBPACK_IMPORTED_MODULE_4__parse_regex__["c" /* match1 */]);
Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('SS', __WEBPACK_IMPORTED_MODULE_4__parse_regex__["e" /* match1to3 */], __WEBPACK_IMPORTED_MODULE_4__parse_regex__["h" /* match2 */]);
Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])('SSS', __WEBPACK_IMPORTED_MODULE_4__parse_regex__["e" /* match1to3 */], __WEBPACK_IMPORTED_MODULE_4__parse_regex__["i" /* match3 */]);

var token, getSetMillisecond;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    Object(__WEBPACK_IMPORTED_MODULE_4__parse_regex__["a" /* addRegexToken */])(token, __WEBPACK_IMPORTED_MODULE_4__parse_regex__["r" /* matchUnsigned */]);
}

function parseMs(input, array) {
    array[__WEBPACK_IMPORTED_MODULE_6__constants__["c" /* MILLISECOND */]] = Object(__WEBPACK_IMPORTED_MODULE_7__utils_to_int__["a" /* default */])(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    Object(__WEBPACK_IMPORTED_MODULE_5__parse_token__["a" /* addParseToken */])(token, parseMs);
}

getSetMillisecond = Object(__WEBPACK_IMPORTED_MODULE_0__moment_get_set__["b" /* makeGetSet */])('Milliseconds', false);




/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getZoneAbbr;
/* harmony export (immutable) */ __webpack_exports__["b"] = getZoneName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_format__ = __webpack_require__(23);


// FORMATTING

Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('z', 0, 0, 'zoneAbbr');
Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr() {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName() {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constructor__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calendar__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formats__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__invalid__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ordinal__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pre_post_format__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__relative__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__set__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__units_era__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__units_month__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__units_week__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__units_day_of_week__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__units_hour__ = __webpack_require__(122);


var proto = __WEBPACK_IMPORTED_MODULE_0__constructor__["a" /* Locale */].prototype;









proto.calendar = __WEBPACK_IMPORTED_MODULE_1__calendar__["a" /* calendar */];
proto.longDateFormat = __WEBPACK_IMPORTED_MODULE_2__formats__["b" /* longDateFormat */];
proto.invalidDate = __WEBPACK_IMPORTED_MODULE_3__invalid__["b" /* invalidDate */];
proto.ordinal = __WEBPACK_IMPORTED_MODULE_4__ordinal__["c" /* ordinal */];
proto.preparse = __WEBPACK_IMPORTED_MODULE_5__pre_post_format__["a" /* preParsePostFormat */];
proto.postformat = __WEBPACK_IMPORTED_MODULE_5__pre_post_format__["a" /* preParsePostFormat */];
proto.relativeTime = __WEBPACK_IMPORTED_MODULE_6__relative__["c" /* relativeTime */];
proto.pastFuture = __WEBPACK_IMPORTED_MODULE_6__relative__["b" /* pastFuture */];
proto.set = __WEBPACK_IMPORTED_MODULE_7__set__["b" /* set */];

// Eras

proto.eras = __WEBPACK_IMPORTED_MODULE_8__units_era__["h" /* localeEras */];
proto.erasParse = __WEBPACK_IMPORTED_MODULE_8__units_era__["j" /* localeErasParse */];
proto.erasConvertYear = __WEBPACK_IMPORTED_MODULE_8__units_era__["i" /* localeErasConvertYear */];
proto.erasAbbrRegex = __WEBPACK_IMPORTED_MODULE_8__units_era__["a" /* erasAbbrRegex */];
proto.erasNameRegex = __WEBPACK_IMPORTED_MODULE_8__units_era__["b" /* erasNameRegex */];
proto.erasNarrowRegex = __WEBPACK_IMPORTED_MODULE_8__units_era__["c" /* erasNarrowRegex */];

// Month


proto.months = __WEBPACK_IMPORTED_MODULE_9__units_month__["f" /* localeMonths */];
proto.monthsShort = __WEBPACK_IMPORTED_MODULE_9__units_month__["h" /* localeMonthsShort */];
proto.monthsParse = __WEBPACK_IMPORTED_MODULE_9__units_month__["g" /* localeMonthsParse */];
proto.monthsRegex = __WEBPACK_IMPORTED_MODULE_9__units_month__["i" /* monthsRegex */];
proto.monthsShortRegex = __WEBPACK_IMPORTED_MODULE_9__units_month__["j" /* monthsShortRegex */];

// Week

proto.week = __WEBPACK_IMPORTED_MODULE_10__units_week__["f" /* localeWeek */];
proto.firstDayOfYear = __WEBPACK_IMPORTED_MODULE_10__units_week__["e" /* localeFirstDayOfYear */];
proto.firstDayOfWeek = __WEBPACK_IMPORTED_MODULE_10__units_week__["d" /* localeFirstDayOfWeek */];

// Day of Week


proto.weekdays = __WEBPACK_IMPORTED_MODULE_11__units_day_of_week__["g" /* localeWeekdays */];
proto.weekdaysMin = __WEBPACK_IMPORTED_MODULE_11__units_day_of_week__["h" /* localeWeekdaysMin */];
proto.weekdaysShort = __WEBPACK_IMPORTED_MODULE_11__units_day_of_week__["j" /* localeWeekdaysShort */];
proto.weekdaysParse = __WEBPACK_IMPORTED_MODULE_11__units_day_of_week__["i" /* localeWeekdaysParse */];

proto.weekdaysRegex = __WEBPACK_IMPORTED_MODULE_11__units_day_of_week__["l" /* weekdaysRegex */];
proto.weekdaysShortRegex = __WEBPACK_IMPORTED_MODULE_11__units_day_of_week__["m" /* weekdaysShortRegex */];
proto.weekdaysMinRegex = __WEBPACK_IMPORTED_MODULE_11__units_day_of_week__["k" /* weekdaysMinRegex */];

// Hours


proto.isPM = __WEBPACK_IMPORTED_MODULE_12__units_hour__["c" /* localeIsPM */];
proto.meridiem = __WEBPACK_IMPORTED_MODULE_12__units_hour__["d" /* localeMeridiem */];


/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bubble;
/* harmony export (immutable) */ __webpack_exports__["b"] = daysToMonths;
/* harmony export (immutable) */ __webpack_exports__["c"] = monthsToDays;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_abs_floor__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_abs_ceil__ = __webpack_require__(621);



function bubble() {
    var milliseconds = this._milliseconds,
        days = this._days,
        months = this._months,
        data = this._data,
        seconds,
        minutes,
        hours,
        years,
        monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (
        !(
            (milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0)
        )
    ) {
        milliseconds += Object(__WEBPACK_IMPORTED_MODULE_1__utils_abs_ceil__["a" /* default */])(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds = Object(__WEBPACK_IMPORTED_MODULE_0__utils_abs_floor__["a" /* default */])(milliseconds / 1000);
    data.seconds = seconds % 60;

    minutes = Object(__WEBPACK_IMPORTED_MODULE_0__utils_abs_floor__["a" /* default */])(seconds / 60);
    data.minutes = minutes % 60;

    hours = Object(__WEBPACK_IMPORTED_MODULE_0__utils_abs_floor__["a" /* default */])(minutes / 60);
    data.hours = hours % 24;

    days += Object(__WEBPACK_IMPORTED_MODULE_0__utils_abs_floor__["a" /* default */])(hours / 24);

    // convert days to months
    monthsFromDays = Object(__WEBPACK_IMPORTED_MODULE_0__utils_abs_floor__["a" /* default */])(daysToMonths(days));
    months += monthsFromDays;
    days -= Object(__WEBPACK_IMPORTED_MODULE_1__utils_abs_ceil__["a" /* default */])(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = Object(__WEBPACK_IMPORTED_MODULE_0__utils_abs_floor__["a" /* default */])(months / 12);
    months %= 12;

    data.days = days;
    data.months = months;
    data.years = years;

    return this;
}

function daysToMonths(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return (days * 4800) / 146097;
}

function monthsToDays(months) {
    // the reverse of daysToMonths
    return (months * 146097) / 4800;
}


/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSetRelativeTimeRounding;
/* harmony export (immutable) */ __webpack_exports__["b"] = getSetRelativeTimeThreshold;
/* harmony export (immutable) */ __webpack_exports__["c"] = humanize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create__ = __webpack_require__(61);


var round = Math.round,
    thresholds = {
        ss: 44, // a few seconds to seconds
        s: 45, // seconds to minute
        m: 45, // minutes to hour
        h: 22, // hours to day
        d: 26, // days to month/week
        w: null, // weeks to month
        M: 11, // months to year
    };

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime(posNegDuration, withoutSuffix, thresholds, locale) {
    var duration = Object(__WEBPACK_IMPORTED_MODULE_0__create__["a" /* createDuration */])(posNegDuration).abs(),
        seconds = round(duration.as('s')),
        minutes = round(duration.as('m')),
        hours = round(duration.as('h')),
        days = round(duration.as('d')),
        months = round(duration.as('M')),
        weeks = round(duration.as('w')),
        years = round(duration.as('y')),
        a =
            (seconds <= thresholds.ss && ['s', seconds]) ||
            (seconds < thresholds.s && ['ss', seconds]) ||
            (minutes <= 1 && ['m']) ||
            (minutes < thresholds.m && ['mm', minutes]) ||
            (hours <= 1 && ['h']) ||
            (hours < thresholds.h && ['hh', hours]) ||
            (days <= 1 && ['d']) ||
            (days < thresholds.d && ['dd', days]);

    if (thresholds.w != null) {
        a =
            a ||
            (weeks <= 1 && ['w']) ||
            (weeks < thresholds.w && ['ww', weeks]);
    }
    a = a ||
        (months <= 1 && ['M']) ||
        (months < thresholds.M && ['MM', months]) ||
        (years <= 1 && ['y']) || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding(roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof roundingFunction === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold(threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize(argWithSuffix, argThresholds) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var withSuffix = false,
        th = thresholds,
        locale,
        output;

    if (typeof argWithSuffix === 'object') {
        argThresholds = argWithSuffix;
        argWithSuffix = false;
    }
    if (typeof argWithSuffix === 'boolean') {
        withSuffix = argWithSuffix;
    }
    if (typeof argThresholds === 'object') {
        th = Object.assign({}, thresholds, argThresholds);
        if (argThresholds.s != null && argThresholds.ss == null) {
            th.ss = argThresholds.s - 1;
        }
    }

    locale = this.localeData();
    output = relativeTime(this, !withSuffix, th, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}


/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__backendApi__ = __webpack_require__(5);
//
//
//
//
//




var backendApi = new __WEBPACK_IMPORTED_MODULE_1__backendApi__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "auth-layout",

    data: function data() {
        return {
            info: null
        };
    },
    mounted: function mounted() {
        var vm = this;

        backendApi.projectInfo().then(function (response) {
            //console.info('auth-layout -> backendApi.projectInfo, response:', response.data);
            if (response.hasError) {
                __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке страницы');
            } else {
                if (response.data != null) {
                    vm.info = response.data;
                }
            }
        });
    }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_claims_checking_mixin__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(79);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var backendApi = new __WEBPACK_IMPORTED_MODULE_2__backendApi__["a" /* default */]();
var cacheKey = 'newsState';

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "news",

    mixins: [__WEBPACK_IMPORTED_MODULE_3__helpers_project_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__helpers_claims_checking_mixin__["a" /* default */]], // projectId

    data: function data() {
        return {
            news: [],
            loading: false,
            canBeLoaded: true,
            page: 1,
            projectId: null,
            rowsPerPage: 20,
            scrollTop: null,
            firstLoad: true
        };
    },


    methods: {
        onMakeMark: function onMakeMark(newsItem, index) {
            var vm = this;

            backendApi.newsMakeVote(newsItem.Id).then(function (response) {
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при выполнении запроса. Попробуйте позже');
                } else {
                    newsItem.MyVote = !newsItem.MyVote;
                    if (newsItem.MyVote) {
                        newsItem.LikesCount++;
                    } else {
                        newsItem.LikesCount--;
                    }

                    __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].set(vm.news, index, newsItem);
                }
            });
        },
        getImageStyleFormatted: function getImageStyleFormatted(imageStyle) {
            if (!imageStyle) {
                return null;
            }

            var settings = {
                left: imageStyle.left + '%',
                top: imageStyle.top + '%',
                transform: 'translateY(' + imageStyle.translateY + '%) translateX(' + imageStyle.translateX + '%)'
            };
            if (imageStyle.resizeType === 1 && parseInt(imageStyle.size)) {
                settings.height = imageStyle.size + '%';
            }
            if (imageStyle.resizeType === 2 && parseInt(imageStyle.size)) {
                settings.width = imageStyle.size + '%';
            }
            return settings;
        },
        loadNext: function loadNext() {
            var vm = this;
            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.news', 'Загрузка...');

            var skip = (vm.page - 1) * vm.rowsPerPage;
            var take = vm.rowsPerPage;
            if (vm.firstLoad && vm.page > 1) {
                skip = 0;
                take = vm.page * vm.rowsPerPage;
            }

            this.callApiWrapper(backendApi.newsList(skip, take, vm.projectId)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки новостей');
                } else {
                    if (resp.data && resp.data.length) {
                        var _vm$news;

                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = resp.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var item = _step.value;

                                item.PreviewFormatted = item.Preview ? __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].format_text_helper(__WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].format_text_to_url(item.Preview.replace(/\n/g, '<br>'))) : null;
                                if (item.ImageStyle) {
                                    item.ImageStyle = JSON.parse(item.ImageStyle);
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        (_vm$news = vm.news).push.apply(_vm$news, _toConsumableArray(resp.data));

                        if (vm.firstLoad) {
                            vm.firstLoad = false;
                            if (vm.scrollTop) {
                                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').animate({ scrollTop: vm.scrollTop }, 500);
                            }
                        }
                    } else {
                        vm.canBeLoaded = false;
                    }
                }
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.news');
                vm.loading = false;
            });
        },
        goToNews: function goToNews(id) {
            this.saveFilterState();
            this.$router.push('/news/' + id);
        },
        onAddNews: function onAddNews() {
            this.$router.push('/news/edit/0');
        },
        goToEditNews: function goToEditNews(id) {
            this.$router.push('/news/edit/' + id);
        },
        onProjectChange: function onProjectChange(item) {
            this.projectId = item.Id;
            this.page = 1;
            this.news = [];
            this.canBeLoaded = true;

            this.loadNext();
            this.$emit('user-updated');
        },
        saveFilterState: function saveFilterState() {
            var stateObj = {
                projectId: this.projectId,
                page: this.page,
                scrollTop: this.scrollTop
            };
            sessionStorage.setItem(cacheKey, JSON.stringify(stateObj));
        },
        recoverFilterState: function recoverFilterState() {
            var stateObj = JSON.parse(sessionStorage.getItem(cacheKey));
            //console.info('recoverFilterState', stateObj);
            if (stateObj) {
                if (stateObj.projectId == this.projectId) {
                    if (stateObj.page) {
                        this.page = stateObj.page;
                    }
                    if (stateObj.scrollTop) {
                        this.scrollTop = stateObj.scrollTop;
                    }
                }
                this.clearFilterState();
            }
        },
        clearFilterState: function clearFilterState() {
            sessionStorage.removeItem(cacheKey);
        }
    },

    mounted: function mounted() {
        var vm = this;

        vm.recoverFilterState();

        this.loadNext();

        vm.$nextTick(function () {

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').on('scroll', function () {
                var elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
                vm.scrollTop = elem.scrollTop();

                if (!vm.loading && vm.canBeLoaded && !vm.firstLoad) {
                    if (elem[0].scrollHeight - elem.scrollTop() - 200 <= elem.outerHeight()) {
                        vm.page++;
                        vm.loadNext();
                    }
                }
            });
        });
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').off('scroll');
    }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__enums__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_FancyBox_jquery_fancybox_pack_js__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_FancyBox_jquery_fancybox_css__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_FancyBox_jquery_fancybox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_FancyBox_jquery_fancybox_css__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var backendApi = new __WEBPACK_IMPORTED_MODULE_2__backendApi__["a" /* default */]();
var DateTypes = {
    /*
    Дата заполнения
     */
    FillingDate: 1,
    /*
    Дата отчета
     */
    ReportDate: 2,
    /*
    Дата изменения статуса
     */
    StatusDate: 3
};

var processFilter = function processFilter(filter) {
    var resultFilter = JSON.parse(JSON.stringify(filter));
    if (resultFilter) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = resultFilter[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                var filterField = item[0];
                if (filterField === '[dbo].[AspNetUsers].[r.Id]') {
                    item[0] = 'r.[Id]';
                    item[2] = item[2].replace(new RegExp('\'', 'g'), '');
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return resultFilter;
};

var cacheKey = 'reportsFilter';

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "reports",

    props: ['info'],

    mixins: [__WEBPACK_IMPORTED_MODULE_6__helpers_project_mixin__["a" /* default */]], // projectId

    data: function data() {
        return {
            statusId: DateTypes.FillingDate,
            dateTypeId: null,
            dateStart: null,
            dateEnd: null,
            reportSettingsLoaded: false,
            reportSettings: null,
            reportType: null,
            statuses: [{ Id: 0, Name: 'Все отчеты' }, { Id: 1, Name: 'Не проверенные' }, { Id: 2, Name: 'Проверенные' }, { Id: 3, Name: 'Доработанные' }, { Id: 4, Name: 'На доработке' }, { Id: 5, Name: 'Отклоненные' }],
            dateTypes: [{ Id: DateTypes.FillingDate, Name: ' Дата заполнения' }, { Id: DateTypes.ReportDate, Name: 'Дата отчета' }, { Id: DateTypes.StatusDate, Name: 'Дата изменения статуса' }],
            page: 1,
            reports: [],
            projectId: null,
            ReportTypes: __WEBPACK_IMPORTED_MODULE_7__enums__["k" /* ReportTypes */],
            scrollTop: null,
            firstLoad: true,
            loading: false,
            canBeLoaded: true,
            filter: null,
            userFilters: [{
                Value: 'LastName', Name: 'Фамилия'
            }, {
                Value: 'FirstName', Name: 'Имя'
            }, {
                Value: 'MiddleName', Name: 'Отчество'
            }, {
                Value: 'r.Id', Name: 'Id отчёта'
            }],
            selectAll: false,
            selectedReports: [],
            editionComment: '',
            approvedResult: {
                skipped: [], changed: []
            },
            totalCount: 0
        };
    },


    computed: {
        headerColumns: function headerColumns() {
            if (!this.reportSettings) {
                return [];
            }
            return this.reportSettings.filter(function (item) {
                return item.showInReportList === true;
            });
        }
    },

    methods: {
        openNewTab: function openNewTab(id) {
            window.open('/reports/' + (this.info.ReportType === __WEBPACK_IMPORTED_MODULE_7__enums__["k" /* ReportTypes */].QrCode ? 'fns/' : '') + id);
        },
        getStateClass: function getStateClass(item) {
            switch (item.State) {
                case 1:
                    return 'not-approved';
                case 2:
                    return 'approved';
            }
        },
        onAddReport: function onAddReport() {
            this.$router.push('/reports/' + (this.info.ReportType === __WEBPACK_IMPORTED_MODULE_7__enums__["k" /* ReportTypes */].QrCode ? 'fns/' : '') + '0');
        },
        onStatusChange: function onStatusChange() {
            this.reload();
            this.saveFilterState();
        },
        onDateChange: function onDateChange() {
            this.reload();
            this.saveFilterState();
        },
        onProjectChange: function onProjectChange(item) {
            var vm = this;

            vm.filter = null;
            vm.$refs['complexFilter'].clear();

            vm.projectId = item.Id;
            vm.statusId = '';
            vm.dateTypeId = DateTypes.FillingDate;
            vm.dateStart = '';
            vm.dateEnd = '';
            vm.scrollTop = null;
            vm.saveFilterState();

            vm.loadSettings().then(function () {
                vm.reload();

                vm.$emit('user-updated');
            });
        },
        openReport: function openReport(item) {
            this.saveFilterState();
            this.$router.push('/reports/' + (this.reportType === __WEBPACK_IMPORTED_MODULE_7__enums__["k" /* ReportTypes */].QrCode ? 'fns/' : '') + item.Id);
        },
        reload: function reload() {
            this.page = 1;
            this.reports = [];
            this.loading = false;
            this.canBeLoaded = true;

            this.loadNext();
        },
        onExport: function onExport() {
            var vm = this;
            var dateStart = Object(__WEBPACK_IMPORTED_MODULE_4_moment__["default"])(vm.dateStart, 'DD.MM.YYYY').format();
            var dateEnd = Object(__WEBPACK_IMPORTED_MODULE_4_moment__["default"])(vm.dateEnd, 'DD.MM.YYYY').format();

            var resultFilter = processFilter(vm.filter);
            if (vm.selectedReports.length > 0) {
                if (!resultFilter) {
                    resultFilter = [];
                }
                var ids = _.map(vm.selectedReports, function (item) {
                    return item.Id;
                });
                resultFilter.push(['r.[Id]', 'IN', '(' + ids.join(';') + ')']);
            }

            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('#app');
            vm.callApiWrapper(backendApi.reportExport(vm.projectId, resultFilter, vm.statusId, vm.dateTypeId, dateStart, dateEnd)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время экспорта отчётов');
                } else {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].downloadFileByBytes(resp.data, 'Отчёты.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                    //iOS Chrome
                    //var reader = new FileReader();
                    //reader.onload = function (e) {
                    //    location.href = reader.result;
                    //}
                    //reader.readAsDataURL(blob);
                }

                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            });
        },
        loadNext: function loadNext() {
            var vm = this;
            var rowsPerPage = 25;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
            var timeZone = new Date().getTimezoneOffset();
            var dateStart = Object(__WEBPACK_IMPORTED_MODULE_4_moment__["default"])(vm.dateStart, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
            var dateEnd = Object(__WEBPACK_IMPORTED_MODULE_4_moment__["default"])(vm.dateEnd, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();

            var skip = (vm.page - 1) * rowsPerPage;
            var take = rowsPerPage;
            if (vm.firstLoad && vm.page > 1) {
                skip = 0;
                take = vm.page * rowsPerPage;
            }

            this.callApiWrapper(backendApi.reportList(skip, take, vm.projectId, vm.statusId, vm.dateTypeId, dateStart, dateEnd, processFilter(vm.filter))).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    //UI.toastr.error('Ошибка во время загрузки отчётов');
                } else {
                    if (resp.data.list && resp.data.list.length) {
                        var _vm$reports;

                        (_vm$reports = vm.reports).push.apply(_vm$reports, _toConsumableArray(resp.data.list));
                        vm.totalCount = resp.data.totalCount;

                        console.info('[vm.firstLoad, vm.scrollTop]', [vm.firstLoad, vm.scrollTop]);
                        if (vm.firstLoad) {
                            vm.firstLoad = false;
                            if (vm.scrollTop) {
                                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').animate({ scrollTop: vm.scrollTop }, 500, function () {
                                    // перезаписываем значение после анимации, чтобы не было скролла при перезагрузке
                                    vm.scrollTop = 0;
                                    vm.saveFilterState();
                                });
                            }
                        }

                        if (vm.selectAll && vm.selectedReports.length < vm.reports.length) {
                            vm.selectAll = false;
                        }

                        if (vm.selectedReports.length > 0) {
                            var reportIds = _.map(vm.reports, function (item) {
                                return item.Id;
                            });
                            _.remove(vm.selectedReports, function (item) {
                                return _.indexOf(reportIds, item.Id) === -1;
                            });
                        }
                    } else {
                        vm.canBeLoaded = false;
                    }
                }
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                vm.loading = false;

                vm.$nextTick(function () {
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.report-photo').fancybox({});
                });
            });
        },
        loadSettings: function loadSettings() {
            var vm = this;

            return vm.callApiWrapper(backendApi.reportSettingsList(vm.projectId)).then(function (resp) {
                vm.reportSettings = resp.data.reportSettings;
                vm.reportType = resp.data.ReportType;
                vm.reportSettingsLoaded = true;

                //vm.dateStart = vm.formatDate(moment().startOf('month'));
                //vm.dateEnd = vm.formatDate(moment().endOf('month'));
                return resp;
            }).catch(function (err) {
                console.info(err);
            });
        },
        clearFilterState: function clearFilterState() {
            this.dateStart = '';
            this.dateEnd = '';
            this.statusId = '';
            this.dateTypeId = DateTypes.FillingDate;

            localStorage.removeItem(cacheKey);
            this.reload();
        },
        saveFilterState: function saveFilterState() {
            console.info('this.statusId:', this.statusId);

            var stateObj = {
                statusId: this.statusId,
                dateTypeId: this.dateTypeId,
                dateStart: this.dateStart,
                dateEnd: this.dateEnd,
                projectId: this.projectId,
                page: this.page,
                scrollTop: this.scrollTop
            };
            localStorage.setItem(cacheKey, JSON.stringify(stateObj));
        },
        recoverFilterState: function recoverFilterState() {
            var stateObj = JSON.parse(localStorage.getItem(cacheKey));
            console.info('recoverFilterState -> stateObj:', stateObj);
            if (stateObj) {
                if (stateObj.statusId != null) {
                    this.statusId = stateObj.statusId;
                }
                if (stateObj.dateTypeId) {
                    this.dateTypeId = stateObj.dateTypeId;
                }
                if (stateObj.dateStart) {
                    this.dateStart = stateObj.dateStart;
                }
                if (stateObj.dateEnd) {
                    this.dateEnd = stateObj.dateEnd;
                }
                if (stateObj.projectId == this.projectId) {
                    if (stateObj.page) {
                        this.page = stateObj.page;
                    }
                    if (stateObj.scrollTop) {
                        this.scrollTop = stateObj.scrollTop;
                    }
                }
            }
        },
        onScroll: function onScroll(e) {
            var vm = this;
            if (!vm.loading && vm.canBeLoaded) {
                var elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target);
                vm.scrollTop = elem.scrollTop();
                if (elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight() + 100) {
                    vm.page++;
                    vm.loadNext();
                }
            }
        },
        searchFunction: function searchFunction(tableName, columnName, search, filters, searchPage, callback) {
            if (columnName === 'TermsConfirmed' || columnName === 'PersonalDataEditingAccept' || columnName === 'NotificationsEnabled') {
                callback(['Да', 'Нет']);
            } else if (columnName === 'PassportVerificationState') {
                callback(['документы отсутствуют', 'проверь документы!', 'документы подтверждены', 'документы возвращены']);
            } else if (columnName === 'RegisterStatus') {
                callback(['неактивен', 'проверка', 'активен', 'отказано', 'отключен', 'заблокирован']);
            } else {
                var filterFormatted = '';
                if (filters) {
                    filterFormatted = processFilter(filters).map(function (x) {
                        return JSON.stringify(x);
                    });
                }

                this.callApiWrapper(backendApi.reportDistinctValues(columnName, this.projectId, search, filterFormatted, (searchPage - 1) * 30, 30)).then(function (resp) {
                    callback(resp.data);
                });
            }
        },
        onFilterChange: function onFilterChange(filter) {
            this.filter = filter;
            this.reports = [];
            this.loading = false;
            this.canBeLoaded = true;
            this.page = 1;

            this.loadNext();
        },
        onSelectAllChange: function onSelectAllChange(e) {
            var vm = this;

            vm.selectedReports = [];
            if (vm.selectAll) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = vm.reports[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var report = _step2.value;

                        vm.selectedReports.push(report);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
        },
        onCheckChange: function onCheckChange(item) {
            var vm = this;
            if (vm.selectedReports.filter(function (x) {
                return x == item;
            }).length === 0) {
                vm.selectAll = false;
            } else if (vm.selectedReports.length === vm.reports.length) {
                vm.selectAll = true;
            }
        },


        // принятие отчётов
        tryApproveReports: function tryApproveReports(state, comment) {
            var vm = this;
            if (vm.selectedReports.length === 0) return;

            var saveObj = this.selectedReports.map(function (x) {
                return {
                    Id: x.Id,
                    State: state,
                    EditionComment: comment
                };
            });
            console.info('tryApproveReports', saveObj);

            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'принятие отчётов...');
            backendApi.reportMultipleApprove(saveObj).then(function (resp) {
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                if (resp.hasError) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении');
                } else {
                    vm.approvedResult = resp.data;
                    vm.editionComment = '';
                    if (vm.approvedResult.changed.length > 0) {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');
                        vm.selectedReports = [];
                        vm.reload();
                    }
                    vm.$refs['ppApprovedResultModal'].show();
                }
            });
        },


        //показываем окно с вводом комментария
        sendReportsToEditionModal: function sendReportsToEditionModal() {
            var vm = this;
            vm.$nextTick(function () {
                vm.$refs.ppEditModal.show();
            });
        },


        // отправка на доработку
        sendReportsToEdition: function sendReportsToEdition() {
            var vm = this;
            vm.$validator.validateAll('edition').then(function (result) {
                if (result) {
                    vm.tryApproveReports(4, vm.editionComment);
                    vm.$refs['ppEditModal'].close();
                }
            });
        },
        rejectReportsModal: function rejectReportsModal() {
            var vm = this;
            vm.$nextTick(function () {
                vm.$refs.ppRejectModal.show();
            });
        },
        rejectReports: function rejectReports() {
            var _this = this;

            var vm = this;
            vm.$validator.validateAll('rejection').then(function (result) {
                if (result) {
                    _this.$refs.ppRejectModal.close();
                    vm.tryApproveReports(5, vm.editionComment);
                }
            });
        },
        selectedCancel: function selectedCancel() {
            this.selectAll = false;
            this.selectedReports = [];
        }
    },

    mounted: function mounted() {
        var vm = this;

        vm.recoverFilterState();
        vm.filter = vm.$refs['complexFilter'].getExpotData();

        vm.$nextTick(function () {

            vm.loadSettings().then(function (resp) {
                vm.loadNext();
            });
        });
    }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ReportItemsTable__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_FancyBox_jquery_fancybox_pack_js__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_FancyBox_jquery_fancybox_css__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_FancyBox_jquery_fancybox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_FancyBox_jquery_fancybox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_JqueryUI_jquery_ui_min__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_JqueryUI_jquery_ui_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_JqueryUI_jquery_ui_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__img_icon_minus_2_png__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__img_icon_minus_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__img_icon_minus_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__enums__ = __webpack_require__(19);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















var backendApi = new __WEBPACK_IMPORTED_MODULE_2__backendApi__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = ({
    name: "report-edit",

    mixins: [__WEBPACK_IMPORTED_MODULE_5__helpers_project_mixin__["a" /* default */]],

    props: ['info'],

    data: function data() {
        return {
            report: null,
            origin: null,
            reportSettings: null,
            equipmentTypes: [],
            sku: [],
            reportFields: null,
            reportDateSettings: null,
            importResult: null,
            ReportExcelEnabled: false,
            ReportOnlyOneItemAllowed: false,
            bonusSettings: null,
            ReportPdfAndExcelFilesEnabled: false,
            dateToBonus: { reportDate: null },

            ttSearch: null,
            ttAllowed: true,
            ttData: [],
            ttPage: 1,
            ttIsLoading: false,
            ttCanBeLoaded: true,
            ttSearched: false,
            ReportPhotoTypes: __WEBPACK_IMPORTED_MODULE_12__enums__["j" /* ReportPhotoTypes */]
        };
    },


    components: { ReportItemsTable: __WEBPACK_IMPORTED_MODULE_4__components_ReportItemsTable__["a" /* default */] },

    computed: {
        tradePointSelected: function tradePointSelected() {
            return this.report.TradePoint && this.report.TradePoint.Id && this.report.TradePoint.Error == null;
        },
        photoFieldsValid: function photoFieldsValid() {
            var _this = this;

            var photoError = false;

            var _loop = function _loop(field) {
                if (field.Required && !_this.report.Photos.filter(function (x) {
                    return x.FieldId === field.Id;
                }).length) {
                    photoError = true;
                    return 'break';
                }
            };

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.reportFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var field = _step.value;

                    var _ret = _loop(field);

                    if (_ret === 'break') break;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return !photoError;
        },
        maxItems: function maxItems() {
            return this.ReportOnlyOneItemAllowed === true ? 1 : 0;
        }
    },

    methods: {
        getAvailableExtensions: function getAvailableExtensions(field) {
            return ['.jpg', '.jpeg', '.png'].concat(_toConsumableArray(field.PdfAndExcelFilesEnabled === true ? ['.pdf', '.xlsx'] : []));
        },
        onFileChange: function onFileChange() {
            var vm = this;
            var files = document.getElementById('dropFiles').files;
            if (files.length > 0) {
                if (window.FormData !== undefined) {
                    var data = new FormData();
                    for (var x = 0; x < files.length; x++) {
                        data.append("file" + x, files[x]);
                    }
                    //let tokenInfo = JSON.parse(localStorage.getItem('tokenInfo') == null ? sessionStorage.getItem('tokenInfo') : localStorage.getItem('tokenInfo'));
                    vm.importResult = null;

                    this.callApiWrapper(backendApi.reportImport(vm.projectId, data)).then(function (response) {
                        document.getElementById('dropFiles').value = '';
                        if (response.hasError) {
                            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка импорта');
                        } else {
                            if (response.data) {
                                vm.importResult = response.data;

                                if (vm.$refs.reportItems) {
                                    vm.$refs.reportItems.importItems(vm.importResult.Data);
                                }

                                vm.$refs['ppImportResultsModal'].show();
                            }
                        }
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Браузер не поддерживает загрузку файлов HTML5!');
                }
            }
        },
        back: function back() {
            this.$router.push('/reports');
        },
        cancel: function cancel() {
            this.$router.back();
            console.info('this', this);
        },
        onChangeDate: function onChangeDate(item, formatted, raw) {
            item[raw] = Object(__WEBPACK_IMPORTED_MODULE_9_moment__["default"])(item[formatted], 'DD.MM.YYYY').format();
        },
        getEditProcessState: function getEditProcessState() {
            var _this2 = this;

            if (this.report.new && !this.tradePointSelected) {
                return 'Выберите торговую точку...';
            }
            if (!this.report.ReportItems.length) {
                return 'Добавьте информацию в таблицу...';
            }

            var photoError = false;

            var _loop2 = function _loop2(field) {
                if (field.Required && !_this2.report.Photos.filter(function (x) {
                    return x.FieldId === field.Id;
                }).length) {
                    photoError = true;
                    return 'break';
                }
            };

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = this.reportFields[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var field = _step2.value;

                    var _ret2 = _loop2(field);

                    if (_ret2 === 'break') break;
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            if (photoError && this.info.User.MainRole !== 'administrators') {
                return 'Добавьте фотоотчет...';
            }
        },
        formatTradePointName: function formatTradePointName(tradePoint) {

            var arr = [];
            if (tradePoint.Region) {
                arr.push(tradePoint.Region);
            }
            if (tradePoint.City) {
                arr.push(tradePoint.City);
            }
            if (tradePoint.Address) {
                arr.push(tradePoint.Address);
            }

            return tradePoint.Name + (arr.length ? ' (' + arr.join(', ') + ')' : '');
        },
        loadReport: function loadReport() {
            var that = this;
            var id = parseInt(this.$route.params.id);

            return this.callApiWrapper(backendApi.reportLoad(id, that.projectId)).then(function (response) {
                //console.info('details -> load, response:', JSON.stringify(response.data));
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке отчета');
                } else {
                    if (response.data) {
                        if (id === 0) {
                            that.report = {
                                new: true,
                                ReportItems: [],
                                Photos: [],
                                TradePoint: null,
                                ProjectId: that.projectId,
                                canBeEdited: true,
                                ReportDateFormatted: null
                            };
                            if (response.data.reportDateSettings.ReportDateRequired && response.data.reportDateSettings.ReportDateDefault) {
                                that.report.ReportDateFormatted = that.formatDate(Object(__WEBPACK_IMPORTED_MODULE_9_moment__["default"])());
                                that.report.ReportDate = Object(__WEBPACK_IMPORTED_MODULE_9_moment__["default"])().format();
                            }

                            if (response.data.tradePoint) {
                                that.report.TradePoint = response.data.tradePoint;
                            } else {
                                that.loadNextTradePoints();
                            }
                            that.dateToBonus.createDate = that.report.ReportDate;
                            that.dateToBonus.approvementDate = null;
                        } else {
                            that.report = response.data.report;

                            if (that.info && that.info.User) {
                                // продавцы могут редактировать новый отчет, доработанный или на доработке
                                if ((that.report.State === 1 || that.report.State === 4 || that.report.State === 3) && that.hasClaims(that.info.User.DynamicRole, that.claimEnums.reportAdd) || (that.report.State === 1 || that.report.State === 3) && (that.hasClaims(that.info.User.DynamicRole, that.claimEnums.reportCheck) || that.info.User.MainRole === 'administrators')) {
                                    that.report.canBeEdited = true;
                                } else {
                                    that.report.canBeEdited = false;
                                }
                            }

                            that.report.ReportDateFormatted = that.formatDate(response.data.report.ReportDate);

                            that.origin = JSON.parse(JSON.stringify(response.data.report));
                            that.dateToBonus.createDate = that.report.CreateDate;
                            that.dateToBonus.approvementDate = that.report.ApprovementDate;
                        }
                        //console.info('response.data.reportSettings', response.data.reportSettings)
                        that.reportSettings = response.data.reportSettings;
                        that.bonusSettings = response.data.bonusSettings;
                        that.sku = response.data.sku; // узкое место - лучше грузить непосредственно при выборе sku в dropdown'e в таблице
                        that.equipmentTypes = response.data.equipmentTypes;
                        that.reportFields = response.data.fields;
                        that.reportDateSettings = response.data.reportDateSettings;

                        that.ReportExcelEnabled = response.data.ReportExcelEnabled;
                        that.ReportOnlyOneItemAllowed = response.data.ReportOnlyOneItemAllowed;
                        that.ReportPdfAndExcelFilesEnabled = response.data.ReportPdfAndExcelFilesEnabled;
                        that.dateToBonus.reportDate = that.report.ReportDate;
                        if (that.bonusSettings.bonusStrategy.type === 'data') {
                            that.bonusSettings.bonusStrategy.data.dateBonusItems = [];
                            var _iteratorNormalCompletion3 = true;
                            var _didIteratorError3 = false;
                            var _iteratorError3 = undefined;

                            try {
                                for (var _iterator3 = that.bonusSettings.bonusStrategy.data.ValueItems[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                    var s = _step3.value;

                                    var item = {};
                                    var _iteratorNormalCompletion4 = true;
                                    var _didIteratorError4 = false;
                                    var _iteratorError4 = undefined;

                                    try {
                                        for (var _iterator4 = s.Fields[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                            var field = _step4.value;

                                            switch (field.Name) {
                                                case 'value':
                                                    item.value = field.Value;break;
                                                case 'dateBeg':
                                                    item.dateBeg = Object(__WEBPACK_IMPORTED_MODULE_9_moment__["default"])(field.Value, 'DD.MM.YYYY');break;
                                                case 'dateEnd':
                                                    item.dateEnd = Object(__WEBPACK_IMPORTED_MODULE_9_moment__["default"])(field.Value, 'DD.MM.YYYY');break;
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError4 = true;
                                        _iteratorError4 = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                                _iterator4.return();
                                            }
                                        } finally {
                                            if (_didIteratorError4) {
                                                throw _iteratorError4;
                                            }
                                        }
                                    }

                                    that.bonusSettings.bonusStrategy.data.dateBonusItems.push(item);
                                }
                            } catch (err) {
                                _didIteratorError3 = true;
                                _iteratorError3 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                        _iterator3.return();
                                    }
                                } finally {
                                    if (_didIteratorError3) {
                                        throw _iteratorError3;
                                    }
                                }
                            }
                        }
                        console.info('that.bonusSettings', that.bonusSettings);
                    }
                }
            }).catch(function (response) {
                console.info('catch', response);
            });
        },
        saveReport: function saveReport() {
            var vm = this;

            // проверяем фотки
            if (!vm.photoFieldsValid && vm.info.User.MainRole !== 'administrators' && !vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.reportCheck)) {
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Нужно добавить фотографий к отчёту');
            } else {
                Promise.all([vm.$refs.reportItems.validate(), vm.$validator.validate()]).then(function (results) {
                    if (!results[0] || !results[1]) {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Сохранение...');

                        var saveObj = Object.assign({}, vm.report);
                        if (vm.reportDateSettings && vm.reportDateSettings.ReportDateRequired) {
                            var timeZone = new Date().getTimezoneOffset();
                            saveObj.ReportDate = Object(__WEBPACK_IMPORTED_MODULE_9_moment__["default"])(vm.report.ReportDateFormatted, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
                        }

                        backendApi.reportSave(saveObj).then(function (response) {
                            console.info('details -> reportSave, response:', response.data);
                            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                            if (response.hasError) {
                                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении отчета');
                            } else {
                                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');
                                vm.$router.push('/reports');
                            }
                        });
                    }
                });
            }
        },


        //показываем окно с вводом комментария
        sendReportToEditionModal: function sendReportToEditionModal() {
            var vm = this;
            vm.$nextTick(function () {
                vm.$refs.ppEditModal.show();
            });
        },


        // отправка на доработку
        sendReportToEdition: function sendReportToEdition() {
            var vm = this;
            vm.$validator.validateAll('edition').then(function (result) {
                if (result) {
                    vm.report.State = 4;
                    vm.saveReport();
                    vm.$refs['ppEditModal'].close();
                }
            });
        },


        // принятие отчёта
        tryApproveReport: function tryApproveReport() {
            var vm = this;

            // проверяем что ничего в отчёте не менялось контролёром
            // если поменялось - показываем окно с комментарием
            if (this.isReportChanged()) {
                vm.$nextTick(function () {
                    vm.$refs.ppApproveModal.show();
                });
            } else {
                this.report.State = 2;
                this.report.ModificationComment = '';
                this.saveReport();
            }
        },
        approveReport: function approveReport() {

            if (!this.report.ModificationComment) {
                return;
            }

            this.report.State = 2;
            this.$refs['ppApproveModal'].close();
            this.saveReport();
        },
        closeModal: function closeModal(popupName) {
            this.$refs[popupName].close();
        },
        rejectReportModal: function rejectReportModal() {
            var vm = this;
            vm.$nextTick(function () {

                vm.$refs.ppRejectModal.show();
            });
        },
        rejectReport: function rejectReport() {
            var _this3 = this;

            var vm = this;
            vm.$validator.validateAll('rejection').then(function (result) {
                if (result) {
                    _this3.$refs.ppRejectModal.close();
                    _this3.report.State = 5;
                    _this3.saveReport();
                }
            });
        },
        deleteReport: function deleteReport() {
            if (confirm('Вы уверены, что хотите удалить отчет?')) {
                if (confirm('Отчет будет удален безвозвратно! Подтвердите действие!')) {
                    var vm = this;
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Удаление...');

                    backendApi.reportDelete(vm.report.Id).then(function (response) {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                        if (response.hasError) {
                            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при удалении отчета');
                        } else {
                            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно удалено');
                            vm.$router.push('/reports');
                        }
                    });
                }
            }
        },
        onSelectTradePoint: function onSelectTradePoint(tt) {
            this.report.TradePoint = tt;
        },


        onChangeTradeSearch: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function () {
            this.ttPage = 1;
            this.ttData = [];
            this.loadNextTradePoints();
        }, 300),

        onChangeTradeAllowed: function onChangeTradeAllowed() {
            this.ttPage = 1;
            this.ttData = [];
            this.loadNextTradePoints();
        },
        onReportItemsScroll: function onReportItemsScroll(e) {
            var vm = this;
            if (vm.report.TradePoint == null && !vm.ttIsLoading && vm.ttCanBeLoaded) {
                var elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target);
                if (elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight() + 100) {
                    vm.ttPage++;
                    vm.loadNextTradePoints();
                }
            }
        },
        loadNextTradePoints: function loadNextTradePoints() {
            var vm = this;

            vm.ttSearched = true;

            var searchText = vm.ttSearch;
            vm.ttIsLoading = true;
            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
            vm.callApiWrapper(backendApi.tradePointListForReport((this.ttPage - 1) * 50, 50, vm.projectId, searchText, vm.ttAllowed)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки торговых точек');
                } else {
                    if (resp.data && resp.data.length) {
                        var _vm$ttData;

                        (_vm$ttData = vm.ttData).push.apply(_vm$ttData, _toConsumableArray(resp.data));
                    } else {
                        vm.ttCanBeLoaded = false;
                    }
                }

                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                vm.ttIsLoading = false;
            });
        },
        removeImage: function removeImage(i, fieldId) {
            if (confirm('Удалить изображение?')) {
                var k = 0,
                    index = 0;
                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                    for (var _iterator5 = this.report.Photos[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                        var x = _step5.value;

                        if (x.FieldId === fieldId) {
                            if (k === i) {
                                this.report.Photos.splice(index, 1);
                                break;
                            }
                            k++;
                        }
                        index++;
                    }
                } catch (err) {
                    _didIteratorError5 = true;
                    _iteratorError5 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                            _iterator5.return();
                        }
                    } finally {
                        if (_didIteratorError5) {
                            throw _iteratorError5;
                        }
                    }
                }
            }
        },
        removeFile: function removeFile(i) {
            if (confirm('Удалить файл?')) {
                var k = 0,
                    index = 0;
                var _iteratorNormalCompletion6 = true;
                var _didIteratorError6 = false;
                var _iteratorError6 = undefined;

                try {
                    for (var _iterator6 = this.report.Photos[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                        var x = _step6.value;

                        if (x.TypeId === __WEBPACK_IMPORTED_MODULE_12__enums__["j" /* ReportPhotoTypes */].File) {
                            if (k === i) {
                                this.report.Photos.splice(index, 1);
                                break;
                            }
                            k++;
                        }
                        index++;
                    }
                } catch (err) {
                    _didIteratorError6 = true;
                    _iteratorError6 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion6 && _iterator6.return) {
                            _iterator6.return();
                        }
                    } finally {
                        if (_didIteratorError6) {
                            throw _iteratorError6;
                        }
                    }
                }
            }
        },
        rotateImage: function rotateImage(direction, img) {
            var vm = this;

            vm.callApiWrapper(backendApi.rotateReportImage(img.Id, direction)).then(function (response) {
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при изменении изображения');
                } else {
                    img.FileName = response.data;
                }
            });
        },
        isReportChanged: function isReportChanged() {
            return JSON.stringify(this.report) !== JSON.stringify(this.origin);
        },
        zoomIn: function zoomIn() {
            var $img = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap.find('img.fancybox-image');
            var scale = $img.data('scale') || 1.0;
            scale += 0.2;
            $img.css('transform', 'scale(' + scale + ')');
            $img.data('scale', scale);
        },
        zoomOut: function zoomOut() {
            var $img = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap.find('img.fancybox-image');
            var scale = $img.data('scale') || 1.0;
            scale -= 0.2;
            if (scale < 0.5) {
                return false;
            }
            $img.css('transform', 'scale(' + scale + ')');
            $img.data('scale', scale);
        }
    },

    mounted: function mounted() {
        var vm = this;

        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
        vm.loadReport().then(function () {
            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('change', '[name="dropFilesPhotos"]', function () {
                var fieldId = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('fieldid');
                console.info('dropFilesPhotos -> typeId:', __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('typeid'));
                if (this.files && this.files.length) {
                    var _iteratorNormalCompletion7 = true;
                    var _didIteratorError7 = false;
                    var _iteratorError7 = undefined;

                    try {
                        for (var _iterator7 = this.files[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                            var file = _step7.value;

                            if (file.size > 50 * 1024 * 1024) {
                                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Превышен размер. Выберите другой файл');
                                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[name="dropFiles"]').val('');
                            } else {
                                (function () {
                                    console.info('file:', file);
                                    var typeId = 0;
                                    if (file.name.indexOf('.xlsx') > -1 || file.name.indexOf('.pdf') > -1) {
                                        typeId = __WEBPACK_IMPORTED_MODULE_12__enums__["j" /* ReportPhotoTypes */].File;
                                    }
                                    var img = { FileName: file.name, FileData: null, Delete: false, FieldId: fieldId, TypeId: typeId };
                                    var reader = new FileReader();
                                    reader.onload = function (e) {
                                        img.FileData = e.target.result;

                                        vm.report.Photos.push(img);

                                        /*$('.lightzoom').fancybox({
                                          beforeShow: function () {
                                            let downloadpath = $.fancybox.wrap.find('.fancybox-image').attr('src');
                                            let $btn = $('<a href="' + downloadpath + '" class="btn" download>Скачать</a>');
                                            $.fancybox.wrap.find('.fancybox-outer').after($btn);
                                          }
                                        });*/
                                    };
                                    reader.readAsDataURL(file);
                                })();
                            }
                        }
                    } catch (err) {
                        _didIteratorError7 = true;
                        _iteratorError7 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                _iterator7.return();
                            }
                        } finally {
                            if (_didIteratorError7) {
                                throw _iteratorError7;
                            }
                        }
                    }
                }
            });

            /*$(document).on('change', '[name="dropFilesExternal"]', function () {
                let fieldId = $(this).data('fieldid');
                if (this.files && this.files.length) {
                    for (let file of this.files) {
                        if (file.size > 50 * 1024 * 1024) {
                            UI.toastr.error('Превышен размер. Выберите другой файл');
                            $('[name="dropFilesExternal"]').val('');
                        } else {
                            let img = { FileName: file.name, FileData: null, Delete: false,
                              TypeId: ReportPhotoTypes.File, FieldId: fieldId };
                            let reader = new FileReader();
                            reader.onload = function (e) {
                                img.FileData = e.target.result;
                                vm.report.Photos.push(img);
                            };
                            reader.readAsDataURL(file);
                        }
                    }
                }
            });
            */
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.lightzoom').fancybox({
                beforeShow: function beforeShow() {
                    var downloadpath = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap.find('.fancybox-image').attr('src');
                    var $btn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<a href="' + downloadpath + '" class="btn" download>Скачать</a>');
                    var $div = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div class="btns flex">\n<button type="button" class="btn btn-primary margin-top-15 zoom-plus btn-img"><img src="/Content/dist/icon-plus-2.png" alt=""></button>\n<button type="button" class="btn btn-primary margin-top-15 zoom-minus btn-img"><img src="/Content/dist/icon-minus-2.png" alt=""></button>\n</div>');
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap.find('.fancybox-outer').after($btn);
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap.find('.fancybox-outer').before($div);
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap.find('img.fancybox-image').draggable();
                }
            });

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click', '.zoom-plus', function () {
                vm.zoomIn();
            });
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click', '.zoom-minus', function () {
                vm.zoomOut();
            });

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).bind('mousewheel DOMMouseScroll', function (event) {
                if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap != null) {
                    if (event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0) {
                        vm.zoomOut();
                    } else {
                        vm.zoomIn();
                    }
                }
            });
        });
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).unbind('mousewheel DOMMouseScroll');
    }
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var backendApi = new __WEBPACK_IMPORTED_MODULE_1__backendApi__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "report-items-table",

    props: ['bonusSettings', 'value', 'reportSettings', 'sku', 'equipmentTypes', 'canBeEdited', 'tradePoint', 'minItems', 'maxItems', 'dateToBonus', 'skuBonusList', 'isNewAnswer'],

    data: function data() {
        return {
            reportItems: [],
            localReportSettings: []
        };
    },


    watch: {
        reportItems: function reportItems() {
            this.$emit('input', this.getExportData());
        }
    },

    computed: {
        reportItemsInfo: function reportItemsInfo() {
            var vm = this;
            if (vm.bonusSettings.noReport) return null;

            var sumObj = {
                BonusAmount: 0
            };

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.reportItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = this.localReportSettings[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var sItem = _step2.value;

                            if (sItem.sumUp) {
                                if (!sumObj[sItem.name]) {
                                    sumObj[sItem.name] = 0;
                                }

                                var _iteratorNormalCompletion3 = true;
                                var _didIteratorError3 = false;
                                var _iteratorError3 = undefined;

                                try {
                                    for (var _iterator3 = item.Fields[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                        var field = _step3.value;

                                        if (field.Name === sItem.name && field.Value !== '') {
                                            sumObj[sItem.name] += field.Value;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError3 = true;
                                    _iteratorError3 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                            _iterator3.return();
                                        }
                                    } finally {
                                        if (_didIteratorError3) {
                                            throw _iteratorError3;
                                        }
                                    }
                                }
                            }
                        }

                        // считаем баллы по позиции
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    if (vm.bonusSettings.bonusStrategy.type !== 'fact') {
                        sumObj.BonusAmount += vm.getBonusAmount(item);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (this.reportItems.length && vm.bonusSettings.bonusStrategy.type === 'fact') {
                sumObj.BonusAmount += vm.getBonusAmount();
            }

            return sumObj;
        },

        reportColumnsSettings: function reportColumnsSettings() {
            return this.localReportSettings.filter(function (item) {
                return !item.deleted;
            });
        }
    },

    methods: {
        logFieldData: function logFieldData(field) {
            console.log(field);
        },
        getStyle: function getStyle(sett) {
            var css = "";
            switch (sett.type) {
                case "int":
                    css = "value-big";break;
                case "decimal":
                    css = "value-big";break;
                case "string":
                    css = "string";break;
                case "bool":
                    css = "bit";break;
                case "select":
                    css = "string";break;
                case "sku":
                    css = "string";break;
                case "date":
                    css = "datetime";break;
            }
            return css;
        },
        getBonusAmount: function getBonusAmount(item) {
            if (!this.bonusSettings || !this.bonusSettings.bonusStrategy) {
                return 0;
            }

            var bonusAmount = 0;
            var strategy = this.bonusSettings.bonusStrategy;

            switch (strategy.type) {
                case 'sku':
                    bonusAmount = this.calculateSkuBonus(item, strategy);
                    break;

                case 'fact':
                    bonusAmount = parseFloat(strategy.data.value);
                    break;

                case 'data':
                    bonusAmount = this.calculateDataBonus(item, strategy);
                    break;

                case 'percent':
                    bonusAmount = this.calculatePercentBonus(item, strategy);
                    break;

                case 'perSku':
                    bonusAmount = this.calculatePerSkuBonus(item, strategy);
                    break;

                default:
                    console.error('Unknown strategy type: ' + strategy.type);
                    break;
            }

            return Math.round(bonusAmount * 100) / 100;
        },
        getFieldValue: function getFieldValue(item, fieldName) {
            var field = item.Fields.find(function (x) {
                return x.Name === fieldName;
            });
            return field ? parseFloat(field.Value) : 0;
        },
        calculateSkuBonus: function calculateSkuBonus(item, strategy) {
            var _this = this;

            if (item.BonusAmount) {
                return item.BonusAmount;
            }
            var countFieldValue = this.getFieldValue(item, strategy.data.countFieldName);
            var count = strategy.data.bonusType === 'percent' ? countFieldValue / 100 : parseInt(countFieldValue, 10);
            var skuId = parseInt(this.getFieldValue(item, strategy.data.fieldName), 10);
            var skuItem = this.sku.find(function (x) {
                return x.Id === skuId;
            });
            var bonusAmount = 0;

            if (skuItem) {
                var skuLinkItem = skuItem.SkuLink.find(function (x) {
                    return x.Name === _this.tradePoint.SkuLink;
                });
                if (skuLinkItem) {
                    bonusAmount = skuLinkItem.Amount * count;
                    var reportDate = this.dateToBonus.reportDate ? Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(this.dateToBonus.reportDate, 'DD.MM.YYYY') : Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])();

                    if (strategy.data.reportDateType === 'selldate') {
                        var fieldVal = this.getFieldValue(item, strategy.data.reportSellDateFieldName);
                        reportDate = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(fieldVal, 'DD.MM.YYYY');
                    }

                    var period = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(skuLinkItem.SkuLinkPeriod, function (el) {
                        return Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(el.DateStart) <= reportDate && (!el.DateEnd || Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(el.DateEnd) >= reportDate);
                    });
                    if (period) {
                        bonusAmount = period.Amount * count;
                    }
                }
            }

            return bonusAmount;
        },
        calculateDataBonus: function calculateDataBonus(item, strategy) {
            var baseFieldValue = this.getFieldValue(item, strategy.data.fieldName);
            var multiplier = parseFloat(strategy.data.value);
            var date = void 0;

            if (strategy.data.accrualType == __WEBPACK_IMPORTED_MODULE_2__enums__["a" /* BonusStrategyAccrualTypes */].SumPercent) {
                switch (strategy.data.accrualValueDate) {
                    case 'none':
                        break;
                    case 'dateCreate':
                        date = this.dateToBonus.createDate ? Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(this.dateToBonus.createDate, 'DD.MM.YYYY') : Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])();
                        break;
                    case 'dateAccept':
                        date = this.dateToBonus.approvementDate ? Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(this.dateToBonus.approvementDate, 'DD.MM.YYYY') : Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])();
                        break;
                    case 'dateReport':
                        date = this.dateToBonus.reportDate ? Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(this.dateToBonus.reportDate, 'DD.MM.YYYY') : Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])();
                        break;
                    default:
                        var field = item.Fields.find(function (x) {
                            return x.Name === strategy.data.accrualValueDate;
                        });
                        if (field) {
                            date = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(field.Value, 'DD.MM.YYYY');
                        }
                        break;
                }

                if (date) {
                    var period = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(strategy.data.dateBonusItems, function (el) {
                        return el.dateBeg <= date && el.dateEnd >= date;
                    });
                    if (period) {
                        multiplier = parseFloat(period.value);
                    }
                }
                multiplier /= 100.0;
            }

            return baseFieldValue * multiplier;
        },
        calculatePercentBonus: function calculatePercentBonus(item, strategy) {
            var fieldIndex = this.localReportSettings.findIndex(function (x) {
                return x.id === strategy.data.fieldId;
            });
            if (fieldIndex === -1) return 0;

            var field = item.Fields[fieldIndex];
            var baseFieldValue = field ? parseFloat(field.Value) : 0;
            var multiplier = parseFloat(strategy.data.value);

            return baseFieldValue * multiplier / 100;
        },
        calculatePerSkuBonus: function calculatePerSkuBonus(item, strategy) {
            var countFieldIndex = this.localReportSettings.findIndex(function (x) {
                return x.id === strategy.data.fieldId;
            });
            if (countFieldIndex === -1) return 0;

            var countField = item.Fields[countFieldIndex];
            var count = countField ? parseFloat(countField.Value) : 0;

            var skuFieldIndex = this.localReportSettings.findIndex(function (x) {
                return x.type === 'sku';
            });
            if (skuFieldIndex === -1) return 0;

            var skuField = item.Fields[skuFieldIndex];
            var skuId = skuField ? skuField.Value : null;

            var bonus = this.skuBonusList.find(function (x) {
                return x.SkuId === skuId;
            });
            var bonusValue = bonus ? bonus.Bonus : 0;

            return isNaN(count) ? 0 : count * bonusValue;
        },
        onItemChange: function onItemChange() {
            this.$emit('input', this.getExportData());
        },
        getSkuSelectedItem: function getSkuSelectedItem(field) {
            return {
                Id: field.Value,
                Name: field.Title
            };
        },
        searchSkuFunction: function searchSkuFunction(searchText, callback, extra, page, fieldName) {
            var vm = this;
            //console.info('searchSkuFunction', searchText, callback, extra, page, fieldName);
            if (vm.bonusSettings.skuView === 'tasks') {
                var colSetting = this.localReportSettings.find(function (x) {
                    return x.name === fieldName;
                });
                //console.info('searchSkuFunction', field, colSetting, fieldName);
                //if ((page - 1) === 0) callback(vm.sku);
                vm.callApiWrapper(backendApi.skuSearchForTable((page - 1) * 20, 20, vm.tradePoint.Id, searchText, fieldName, colSetting.id, vm.bonusSettings.skuView)).then(function (resp) {
                    callback(resp.data);
                });
            } else {
                var field = this.reportItems[extra].Fields.find(function (x) {
                    return x.Type === 'sku';
                });
                vm.callApiWrapper(backendApi.skuSearch((page - 1) * 20, 20, vm.tradePoint.Id, searchText, field.Name)).then(function (resp) {
                    callback(resp.data);
                });
            }
        },
        onChangeSkuSearch: function onChangeSkuSearch(listItem, extra, fieldName) {
            var field = this.reportItems[extra].Fields.find(function (x) {
                return x.Type === 'sku' && x.Name === fieldName;
            });
            field.Value = listItem ? listItem.Id : null;
            field.Title = listItem ? listItem.Name : field.Title;
        },
        addItem: function addItem() {
            var vm = this;
            var newItem = { Id: 0, Fields: [] };

            // Если это массив Vue с реактивной оберткой
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = this.localReportSettings[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var settingsItem = _step4.value;


                    if (!settingsItem.deleted) {
                        var newField = { Name: settingsItem.name, Value: null, Type: null, Title: null };
                        newField.Type = settingsItem.type;

                        if (settingsItem.type === 'bool') {
                            newField.Value = false;
                        } else if (settingsItem.type === 'int' || settingsItem.type === 'decimal') {
                            newField.Value = 0;
                        }

                        if (settingsItem.name === 'EquipmentType') {
                            if (!vm.equipmentTypes.length) {
                                console.error('Не загружены справочники');
                                return;
                            }
                            newField.Value = vm.equipmentTypes[0].Id;
                        }

                        newItem.Fields.push(newField);
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            this.reportItems.push(newItem);
        },
        getExportData: function getExportData() {
            return this.reportItems;
        },
        removeItem: function removeItem(item, index) {
            var vm = this;
            if (vm.localReportSettings[0].type === 'sku') {
                this.$nextTick(function () {
                    vm.reportItems.splice(index, 1);
                });
            } else {
                // пока непонятно что не обновляется. чистится sku у предыдущих новых строк
                var name = vm.localReportSettings[0].name;
                vm.localReportSettings[0].name = 'as';
                this.$nextTick(function () {
                    vm.reportItems.splice(index, 1);
                    vm.localReportSettings[0].name = name;
                });
            }
            //без этих телодвижений, строки в таблице не обновляются
        },
        getSelectItems: function getSelectItems(item, settingsItem) {
            var vm = this;

            if (settingsItem.options && settingsItem.options.length) {
                var mapped = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(JSON.parse(settingsItem.options), function (itm) {
                    return {
                        Id: itm,
                        Name: itm,
                        Selected: false
                    };
                });

                return mapped;
            }
            // если в options ничего не указано - ищем зарезервированные поля (Sku/Type)
            if (settingsItem.name === 'EquipmentType') {
                var data = [];
                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                    for (var _iterator5 = vm.equipmentTypes[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                        var i = _step5.value;

                        data.push({
                            Id: i.Id,
                            Name: i.Name
                        });
                    }
                } catch (err) {
                    _didIteratorError5 = true;
                    _iteratorError5 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                            _iterator5.return();
                        }
                    } finally {
                        if (_didIteratorError5) {
                            throw _iteratorError5;
                        }
                    }
                }

                return data;
            }
            // if(settingsItem.name === 'SkuId') {
            //     let data = [];
            //     for(let i of vm.sku)
            //     {
            //         data.push({
            //             Id: i.Id,
            //             Name: i.Name
            //         });
            //     }
            //     return data;
            // }

            return [];
        },
        validate: function validate() {
            return this.$validator.validate();
        },
        importItems: function importItems(items) {
            if (items && items.length) {
                var _iteratorNormalCompletion6 = true;
                var _didIteratorError6 = false;
                var _iteratorError6 = undefined;

                try {
                    for (var _iterator6 = items[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                        var item = _step6.value;

                        this.reportItems.push(item);
                    }
                } catch (err) {
                    _didIteratorError6 = true;
                    _iteratorError6 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion6 && _iterator6.return) {
                            _iterator6.return();
                        }
                    } finally {
                        if (_didIteratorError6) {
                            throw _iteratorError6;
                        }
                    }
                }
            }
        },
        reportItemsTable_Init: function reportItemsTable_Init() {
            var vm = this;
            if (vm.canBeEdited && vm.value.length === 0) {
                for (var i = 0; i < vm.minItems; ++i) {
                    vm.addItem();
                }
            }
        }
    },

    mounted: function mounted() {
        var _this2 = this;

        this.reportItems = this.value;
        this.localReportSettings = this.reportSettings;
        if (this.isNewAnswer) {
            setTimeout(function () {
                _this2.reportItemsTable_Init();
            }, 250);
        }
    }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__enums__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_img_mixin__ = __webpack_require__(90);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var backendApi = new __WEBPACK_IMPORTED_MODULE_2__backendApi__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "Fns-Report-Edit",

    mixins: [__WEBPACK_IMPORTED_MODULE_6__helpers_project_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__helpers_img_mixin__["a" /* default */]],

    props: ['info'],

    data: function data() {
        return {
            report: null,
            origin: null,
            reportSettings: null,
            importResult: null,
            ReportExcelEnabled: false,

            numberOfLoads: 0,
            qrCodeLoadingSucceeded: false
        };
    },


    computed: {
        EditingProcessState: function EditingProcessState() {
            if (this.checkLoadBtnDisabled) {
                return 'Загрузите QR код';
            }
            if (!this.report.Photos.filter(function (x) {
                return x.TypeId === __WEBPACK_IMPORTED_MODULE_7__enums__["j" /* ReportPhotoTypes */].Check;
            }).length) return 'Загрузите фото чека';
        },
        checkLoadBtnDisabled: function checkLoadBtnDisabled() {
            return !this.qrCodeLoadingSucceeded && this.numberOfLoads < 3;
        }
    },

    methods: {
        onCheckChange: function onCheckChange($event) {
            var vm = this;

            var files = $event.target.files;
            if (files.length > 0) {
                if (files.length > 1) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Выберите 1 файл');
                    return;
                }

                var reader = new FileReader();
                reader.onload = function (e) {
                    vm.report.Photos.push({
                        FileData: e.target.result,
                        FileName: files[0].name,
                        TypeId: __WEBPACK_IMPORTED_MODULE_7__enums__["j" /* ReportPhotoTypes */].Check
                    });
                };
                reader.readAsDataURL(files[0]);
            }
        },
        onQrCodeChange: function onQrCodeChange($event) {
            var vm = this;

            var files = $event.target.files;
            if (files.length > 0) {
                if (files.length > 1) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Выберите 1 файл');
                    return;
                }
                //if (window.FormData !== undefined) {
                // let data = new FormData();
                // data.append("file", files[0]);

                var reader = new FileReader();
                reader.onload = function (e) {
                    vm.callApiWrapper(backendApi.qrCodeImport({
                        Data: e.target.result,
                        FileName: files[0].name
                    })).then(function (response) {
                        if (response.hasError) {
                            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка загрузки!');
                        } else {
                            if (response.data) {
                                //console.info('response.data', response.data);
                                vm.report.Photos = [];

                                if (response.data) {
                                    vm.report.Photos.push({
                                        FileData: e.target.result,
                                        FileName: files[0].name,
                                        TypeId: __WEBPACK_IMPORTED_MODULE_7__enums__["j" /* ReportPhotoTypes */].QrCode
                                    });
                                    vm.qrCodeLoadingSucceeded = true;
                                } else {
                                    vm.qrCodeLoadingSucceeded = false;
                                    vm.numberOfLoads++;
                                    if (vm.numberOfLoads > 2) {
                                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('QR код не распознан. Попробуйте еще раз или загрузите чек');
                                    } else {
                                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('QR код не распознан, попробуйте еще раз');
                                    }
                                }
                            }
                        }
                        document.getElementById('qrCodeDropFiles').value = '';
                    });
                };
                reader.readAsDataURL(files[0]);

                // } else {
                //     UI.toastr.error('Браузер не поддерживает загрузку файлов HTML5!');
                // }
            }
        },
        loadReport: function loadReport() {
            var vm = this;
            var id = parseInt(this.$route.params.id);

            return this.callApiWrapper(backendApi.reportLoad(id, vm.projectId)).then(function (response) {
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке отчета');
                } else {
                    if (response.data) {
                        if (id === 0) {
                            vm.report = {
                                new: true,
                                Photos: [],
                                ProjectId: vm.projectId,
                                canBeEdited: true,
                                ReportDateFormatted: null
                            };
                        } else {
                            vm.report = response.data.report;

                            if (vm.info && vm.info.User) {
                                // продавцы могут редактировать новый отчет, доработанный или на доработке
                                if ((vm.report.State === 1 || vm.report.State === 4 || vm.report.State === 3) && vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.reportAdd) || (vm.report.State === 1 || vm.report.State === 3) && (vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.reportCheck) || vm.info.User.MainRole === 'administrators')) {
                                    vm.report.canBeEdited = true;
                                } else {
                                    vm.report.canBeEdited = false;
                                }
                            }
                            vm.origin = JSON.parse(JSON.stringify(response.data.report));
                        }

                        vm.reportSettings = response.data.reportSettings;
                        vm.ReportExcelEnabled = response.data.ReportExcelEnabled;
                    }
                }
            });
        },
        saveReport: function saveReport() {
            var vm = this;

            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Сохранение...');

            backendApi.reportSave(vm.report).then(function (response) {
                console.info('details -> reportSave, response:', response.data);
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');

                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении отчета');
                } else {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');
                    vm.$router.push('/reports');
                }
            });
        },


        //показываем окно с вводом комментария
        sendReportToEditionModal: function sendReportToEditionModal() {
            var vm = this;
            vm.$nextTick(function () {

                vm.report.EditionComment = '';
                vm.$refs.ppEditModal.show();
            });
        },


        // отправка на доработку
        sendReportToEdition: function sendReportToEdition() {
            if (!this.report.EditionComment) {
                return;
            }

            this.report.State = 4;
            this.saveReport();
            this.$refs['ppEditModal'].close();
        },
        isReportChanged: function isReportChanged() {
            return JSON.stringify(this.report) !== JSON.stringify(this.origin);
        },


        // принятие отчёта
        tryApproveReport: function tryApproveReport() {
            var vm = this;

            // проверяем что ничего в отчёте не менялось контролёром
            // если поменялось - показываем окно с комментарием
            if (this.isReportChanged()) {
                vm.$nextTick(function () {
                    vm.$refs.ppApproveModal.show();
                });
            } else {
                this.report.State = 2;
                this.report.ModificationComment = '';
                this.saveReport();
            }
        },
        approveReport: function approveReport() {

            if (!this.report.ModificationComment) {
                return;
            }

            this.report.State = 2;
            this.saveReport();
            this.$refs['ppApproveModal'].close();
        },
        rejectReportModal: function rejectReportModal() {
            var vm = this;
            vm.$nextTick(function () {

                vm.$refs.ppRejectModal.show();
            });
        },
        rejectReport: function rejectReport() {
            if (!this.report.CancellationComment) {
                return;
            }

            this.report.State = 5;
            this.saveReport();
        },
        deleteReport: function deleteReport() {
            if (confirm('Вы уверены, что хотите удалить отчет?')) {
                if (confirm('Отчет будет удален безвозвратно! Подтвердите действие!')) {
                    var vm = this;
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Удаление...');

                    backendApi.reportDelete(vm.report.Id).then(function (response) {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                        if (response.hasError) {
                            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при удалении отчета');
                        } else {
                            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно удалено');
                            vm.$router.push('/reports');
                        }
                    });
                }
            }
        },
        removeImage: function removeImage(i) {
            if (confirm('Удалить изображение?')) {
                var k = 0;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = this.report.Photos[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var x = _step.value;

                        if (k === i) {
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                this.report.Photos.splice(k, 1);
            }
        }
    },

    mounted: function mounted() {
        var vm = this;

        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
        vm.loadReport().then(function () {
            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.lightzoom').fancybox({
                beforeShow: function beforeShow() {
                    var downloadpath = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap.find('.fancybox-image').attr('src');
                    var $btn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<a href="' + downloadpath + '" class="btn" download>Скачать</a>');
                    var $div = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div class="btns flex">\n<button type="button" class="btn btn-primary margin-top-15 zoom-plus btn-img"><img src="/Content/dist/icon-plus-2.png" alt=""></button>\n<button type="button" class="btn btn-primary margin-top-15 zoom-minus btn-img"><img src="/Content/dist/icon-minus-2.png" alt=""></button>\n</div>');
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap.find('.fancybox-outer').after($btn);
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap.find('.fancybox-outer').before($div);
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap.find('img.fancybox-image').draggable();
                }
            });
            //
            //                 $(document).on('click', '.zoom-plus', function(){
            //                     vm.zoomIn();
            //                 });
            //                 $(document).on('click', '.zoom-minus', function(){
            //                     vm.zoomOut();
            //                 });
            //
            //                 $(window).bind('mousewheel DOMMouseScroll', function(event){
            //                     if($.fancybox.wrap != null){
            //                         if (event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0) {
            //                             vm.zoomOut();
            //                         }
            //                         else {
            //                             vm.zoomIn();
            //                         }
            //                     }
            //                 });
        });
    },
    destroyed: function destroyed() {
        // $(window).unbind('mousewheel DOMMouseScroll');
        // $(document).off('click', '.zoom-plus');
        // $(document).off('click', '.zoom-minus');
    }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var backendApi = new __WEBPACK_IMPORTED_MODULE_0__backendApi__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "news-details",

    props: ['info'],

    data: function data() {
        return {
            news: null,
            commentBody: null,
            comments: {
                data: [],
                page: 1,
                loading: false,
                canBeLoaded: true
            },
            users: {
                data: [],
                page: 1,
                loading: false,
                canBeLoaded: true
            },
            commentShow: false,
            showWhoLiked: false
        };
    },


    computed: {
        // todo remove computed?
        BodyFormatted: function BodyFormatted() {
            if (this.news != null) {
                var body = this.news.Body.replace(/\n/g, '<br>');
                return body; //UI.format_text_helper(body);
            }
        }
    },

    methods: {
        cancel: function cancel() {
            this.$router.back();
        },
        formatBody: function formatBody(body) {
            return body ? body.replace(/\n/g, '<br>') : null;
        },
        onEditNews: function onEditNews() {
            this.$router.push('/news/edit/' + this.news.Id);
        },
        loadNews: function loadNews() {
            var that = this;
            var id = parseInt(this.$route.params.id);
            return this.callApiWrapper(backendApi.newsLoad(id)).then(function (response) {
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке новости');
                } else {
                    if (response.data == null) {
                        that.$router.push('/news');
                    } else {
                        that.news = response.data;

                        if (response.data.CommentsEnabled && that.$route.query.comments !== undefined) {
                            that.onShowComments();
                        }
                    }
                }
            });
        },
        onShowComments: function onShowComments() {
            var vm = this;
            this.commentShow = !this.commentShow;
            if (this.commentShow) {
                vm.reloadComments();
            }
        },
        onMakeMark: function onMakeMark() {
            var vm = this;
            backendApi.newsMakeVote(this.news.Id).then(function (response) {
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при выполнении запроса. Попробуйте позже');
                } else {
                    vm.news.MyVote = !vm.news.MyVote;
                }
            });
        },


        onMarkEnter: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function () {
            this.showWhoLiked = true;
        }, 300),

        onMarkLeave: function onMarkLeave() {
            this.showWhoLiked = false;
        },
        onShowUsers: function onShowUsers() {
            var _this = this;

            if (this.info.User.MainRole !== 'administrators') return;

            this.$nextTick(function () {

                _this.users.data = [];
                _this.users.page = 1;
                _this.users.canBeLoaded = true;
                _this.users.loading = false;
                _this.loadNextUsers();
                _this.$refs['ppUsers'].show();
            });
        },
        loadNextUsers: function loadNextUsers() {
            var vm = this;

            vm.users.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.popup', 'Загрузка...');
            this.callApiWrapper(backendApi.newsUsersList((this.users.page - 1) * 20, 20, this.news.Id)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки лайков');
                } else {
                    if (resp.data && resp.data.length) {
                        var _vm$users$data;

                        (_vm$users$data = vm.users.data).push.apply(_vm$users$data, _toConsumableArray(resp.data));
                    } else {
                        vm.users.canBeLoaded = false;
                    }
                }
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.popup');
                vm.users.loading = false;
            });
        },
        onExport: function onExport() {
            var vm = this;

            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('#app');
            vm.callApiWrapper(backendApi.newsExportUsers(vm.news.Id)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время экспорта');
                } else {
                    var exportFile = resp.data;
                    if (exportFile != null) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].downloadFileByBytes(exportFile, 'Пользователи, просмотревшие новость.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                    }
                }
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            });
        },
        onBottomScrolledUsers: function onBottomScrolledUsers() {
            var vm = this;

            if (!vm.users.loading && vm.users.canBeLoaded) {
                vm.users.page++;
                vm.loadNextUsers();
            }
        },
        loadNextComments: function loadNextComments() {
            var vm = this;

            vm.comments.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.comments', 'Загрузка...');
            this.callApiWrapper(backendApi.commentsList((this.comments.page - 1) * 8, 8, this.news.Id)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки комментариев');
                } else {
                    if (resp.data && resp.data.length) {
                        var _vm$comments$data;

                        //let comments = [];
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = resp.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var item = _step.value;

                                //item.BodyFormatted = item.Body ? item.Body.replace(/\n/g, '<br>') : null;
                                item.BodyOrigin = item.Body;
                                item.Edited = false;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        (_vm$comments$data = vm.comments.data).unshift.apply(_vm$comments$data, _toConsumableArray(resp.data));

                        vm.$nextTick(function () {
                            $('#CommentsBody').scrollTop($('#CommentsBody').outerHeight());
                        });
                    } else {
                        vm.comments.canBeLoaded = false;
                    }
                }
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.comments');
                vm.comments.loading = false;
            });
        },
        onCommentSave: function onCommentSave(comment) {
            var vm = this;
            var scope = comment == null ? 'addForm' : 'editForm';
            this.$validator.validateAll(scope).then(function (result) {
                if (!result) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                } else {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Сохранение...');
                    if (comment == null) {
                        comment = {
                            NewsId: vm.news.Id,
                            Body: vm.commentBody
                        };
                    }
                    backendApi.commentSave(comment).then(function (response) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                        if (response.hasError) {
                            if (response.status === 203) {
                                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Комментарий доступен только для удаления');
                            } else {
                                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении комментария');
                            }
                        } else {
                            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');
                            vm.reloadComments();
                        }
                    });
                }
            });
        },
        onCommentCancel: function onCommentCancel(comment) {
            comment.Body = comment.BodyOrigin;
            comment.Edited = false;
        },
        onCommentDelete: function onCommentDelete(id) {
            var vm = this;

            if (confirm('Вы уверены?')) {
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Удаление...');
                backendApi.commentDelete(id).then(function (response) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                    if (response.hasError) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при удалении комментария');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно удалено');

                        vm.reloadComments();
                    }
                });
            }
        },
        onCommentEdit: function onCommentEdit(comment) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = this.comments.data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var c = _step2.value;

                    c.Body = c.BodyOrigin;
                    c.Edited = false;
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            comment.Edited = true;
        },
        reloadComments: function reloadComments() {
            var _this2 = this;

            this.comments.page = 1;
            this.comments.canBeLoaded = true;
            this.comments.data = [];
            this.commentBody = null;
            this.loadNextComments();

            this.$nextTick(function () {
                _this2.$validator.reset();
            });
        },
        onScrollComments: function onScrollComments(e) {
            var vm = this;
            if (!vm.comments.loading && vm.comments.canBeLoaded) {
                var elem = $(e.target);
                if (elem.scrollTop() < 100) {
                    vm.comments.page++;
                    vm.loadNextComments();
                }
            }
        }
    },

    mounted: function mounted() {
        var vm = this;
        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.page-content', 'Загрузка...');
        this.loadNews().then(function () {
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.page-content');
            vm.$emit('user-updated');
        });
    },
    destroyed: function destroyed() {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(30)))

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var backendApi = new __WEBPACK_IMPORTED_MODULE_0__backendApi__["a" /* default */]();
var skuCacheKey = 'skuState';

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "sku-details",

    props: ['info'],

    mixins: [__WEBPACK_IMPORTED_MODULE_2__helpers_project_mixin__["a" /* default */]], // projectId

    data: function data() {
        return {
            sku: null,
            skuSettings: null
        };
    },


    computed: {
        DescriptionFormatted: function DescriptionFormatted() {
            if (this.sku != null && this.sku.Description) {
                return this.sku.Description.replace(/\n/g, '<br>');
            } else {
                return null;
            }
        },

        skuSettingsOrdered: function skuSettingsOrdered() {
            var _this = this;

            if (this.skuSettings == null) {
                return null;
            }

            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.orderBy(this.skuSettings.filter(function (x) {
                return x.ShowInDetails && x.FieldName !== 'Name' && _this.sku[x.FieldName] !== null;
            }), 'SettingsOrder');
        },
        skuSettingsNameField: function skuSettingsNameField() {
            return this.skuSettings.find(function (x) {
                return x.FieldName === 'Name';
            });
        }
    },

    methods: {
        cancel: function cancel() {
            this.$router.back();
        },
        onEditSku: function onEditSku() {
            this.$router.push('/sku/edit/' + this.sku.Id);
        },
        loadSku: function loadSku() {
            var that = this;
            var id = parseInt(this.$route.params.id);
            return this.callApiWrapper(backendApi.skuLoad(id, this.projectId)).then(function (response) {
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке sku');
                } else {
                    if (response.data == null) {
                        that.$router.push('/sku');
                    } else {
                        that.sku = response.data;
                    }
                }
            });
        },
        loadSettings: function loadSettings() {
            var vm = this;
            return this.callApiWrapper(backendApi.skuSettings(vm.projectId)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки настроек sku');
                } else {
                    if (resp.data) {
                        // let dict = {};
                        // for(let s of resp.data){
                        //     if(!dict[s.FieldName]){
                        //         dict[s.FieldName] = s;
                        //     }
                        // }
                        vm.skuSettings = resp.data;
                    }
                }
            });
        },
        back: function back() {
            if (this.$route.query.saved !== undefined) {
                // возвращаем строго на страницу sku, но с учётом folder
                var stateObj = JSON.parse(sessionStorage.getItem(skuCacheKey));
                if (stateObj && stateObj.folderId != null) {
                    this.$router.push('/sku/?folderId=' + stateObj.folderId);
                } else {
                    this.$router.push('/sku');
                }
            } else {
                this.$router.back();
            }
        }
    },

    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.page-content', 'Загрузка...');
        Promise.all([this.loadSku(), this.loadSettings()]).then(function () {
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.page-content');
        });
        // this.loadSku().then(() => {
        //     UI.unblockUI('.page-content');
        // });
    }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var backendApi = new __WEBPACK_IMPORTED_MODULE_0__backendApi__["a" /* default */]();

var iFrame = void 0;

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "material-details",

    props: ['info'],

    data: function data() {
        return {
            material: null,
            timeLeft: null,
            users: {
                data: [],
                page: 1,
                loading: false,
                canBeLoaded: true
            },
            activeTab: 'info',
            analyticsType: 'top',
            results: null,
            isMobile: __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].check_mobile(),
            rating: null,
            currentMaterialFile: null
        };
    },


    watch: {
        '$route.params': function $routeParams() {
            //console.info('this.$route.query.test', this.$route.query)
            this.activeTab = this.$route.query.tab ? 'test' : 'info';
        }
    },

    computed: {
        TestAvailable: function TestAvailable() {
            return this.material.Files.filter(function (x) {
                return x.ProgressPercent !== 1;
            }).length === 0;
        },
        TesCanBeShown: function TesCanBeShown() {
            return this.material && !this.material.TestDisabled && this.material.Questions.filter(function (x) {
                return x.Active;
            }).length;
        },


        // myPlace(){
        //     if(this.results != null){
        //         let item = this.results.Top10.find(x => x.UserId === this.info.User.Id);
        //         if(item){
        //             return item.Place;
        //         }
        //     }
        //     return 0;
        // },

        testBtnShow: function testBtnShow() {
            var flag = true;

            //console.info('testBtnShow', [this.material.AllowedAttemptTime, this.material.AttemptsLeft, this.material.TestComplete]);

            if (this.material.AllowedAttemptTime != null || this.material.AttemptsLeft === 0 || this.material.TestComplete) {
                flag = false;
            }

            return flag;
        }
    },

    methods: {
        onTestResultsClosed: function onTestResultsClosed() {
            // let tab = this.$route.query.tab;
            // if(tab){
            //     if(['results'].indexOf(tab.toLowerCase()) !== -1){
            //         this.$router.push('/materials/' + this.material.Id);
            //     }
            // }
        },
        onBack: function onBack() {
            if (this.activeTab === 'test') {
                this.$router.push('/materials/' + this.material.Id);
            } else {
                this.$router.push('/materials');
                //this.$router.back();
            }
        },
        onTestTabClick: function onTestTabClick() {
            if (this.TestAvailable) {
                this.activeTab = 'test';
                this.$router.push('?tab=test');
            } else {
                alert('Пройдите все обучающие материалы. После этого тест станет доступен');
            }
        },
        onViewMaterialFile: function onViewMaterialFile(materialFile) {
            this.$router.push('/materials/' + this.material.Id + '/' + materialFile.Id);

            // this.currentMaterialFile = materialFile;
            // let page = materialFile.ProgressPage;
            // if(page == null){
            //     page = materialFile.ActiveContentType === 3 ? 1 : 0;
            // }
            // this.onContinueViewing(page);
        },


        // onPageChanged(page, duration){
        //     //console.info('onPageChanged:', page);
        //     this.updateProgress(page, duration);
        // },
        //
        // updateProgress(page, duration){
        //     let vm = this;
        //     if(vm.currentMaterialFile == null)
        //     {
        //         console.info('currentMaterialFile is null');
        //         return;
        //     }
        //     this.callApiWrapper(backendApi.materialUpdateProgress(vm.currentMaterialFile.Id, page, duration))
        //         .then(function (resp) {
        //             if (!resp.hasError) {
        //                 if(resp.data.ProgressPercent === 1){
        //                     vm.currentMaterialFile.ProgressStatus = 'Завершён';
        //                 }
        //                 else{
        //                     vm.currentMaterialFile.ProgressStatus = `Изучено ${(resp.data.ProgressPercent*100).toFixed(0)}%`;
        //                 }
        //                 vm.currentMaterialFile.ProgressPage = resp.data.ProgressPage;
        //                 vm.currentMaterialFile.ProgressPercent = resp.data.ProgressPercent;
        //
        //                 if(resp.data.ProgressPercent === 1) {
        //                     for (let i = 0; i < vm.material.Files.length; i++) {
        //                         if (!vm.material.FilesOrderLocked || i === 0 || vm.material.Files[i - 1].ProgressPercent == 1) {
        //                             vm.material.Files[i].Available = true;
        //                         }
        //                     }
        //                 }
        //             }
        //         });
        // },
        //
        // onContinueViewing(page) {
        //     let materialFile = this.currentMaterialFile;
        //     if (materialFile.ActiveContentType === 4) {
        //
        //         this.$refs['videoView'].show('https://storage.yandexcloud.net/' + config.yandexCloudBucketName + '/' + materialFile.ContentFileName, page);
        //
        //     } else if (materialFile.ActiveContentType === 3) {
        //         this.$refs['pdfView'].show('https://storage.yandexcloud.net/' + config.yandexCloudBucketName + '/' + materialFile.ContentFileName, page);
        //     } else if(materialFile.ActiveContentType === 2){
        //         this.$refs['videoView'].show(materialFile.ContentFileName, page, true);
        //     }
        //     else if(materialFile.ActiveContentType === 1){
        //         this.$refs['presentationView'].show(config.apiUrl + '/Home/Player?materialId=' + this.material.Id + '&page=' + page);
        //     }
        //     else if(materialFile.ActiveContentType === 5){
        //         this.$refs['scormView'].show(`/uploads/materials/${this.material.ProjectId}/${this.material.Id}/${materialFile.Id}/${materialFile.ScormStartPath}`);
        //     }
        // },

        // toggleAnalytics(){
        //     this.analyticsType = this.analyticsType === 'top' ? 'all' : 'top';
        //     if(this.rating == null && this.analyticsType === 'all'){
        //         this.loadMaterialTestRating();
        //     }
        // },

        formatAnswerStats: function formatAnswerStats(questionsRight, questionsWrong) {
            var count = questionsRight + questionsWrong;
            var questionsRightPercent = questionsRight * 100 / (count === 0 ? 1 : count);

            return questionsRight + ' (' + questionsRightPercent.toFixed(2) + '%) / ' + count;
        },
        formatTimeLeft: function formatTimeLeft(ms) {
            if (ms <= 0) {
                return null;
            }

            var time = new Date(ms);

            var hours = time.getUTCHours();
            var minutes = time.getUTCMinutes();
            var seconds = time.getUTCSeconds();

            var days = Math.floor((ms - hours * 60 * 60 * 1000 - minutes * 60 * 1000 - seconds * 1000) / (24 * 60 * 60 * 1000));

            var formatted = (days > 0 ? days + ' ' + this.get_text_ending(days, ['день', 'дня', 'дней']) : '') + (hours > 0 ? ' ' + hours + ' ' + this.get_text_ending(hours, ['час', 'часа', 'часов']) : '') + (hours > 0 || minutes > 0 ? ' ' + minutes + ' ' + this.get_text_ending(minutes, ['минуту', 'минуты', 'минут']) : '') + (hours > 0 || minutes > 0 || seconds > 0 ? ' ' + seconds + ' ' + this.get_text_ending(seconds, ['секунду', 'секунды', 'секунд']) : '');

            return formatted.trim();
        },
        getImageStyleFormatted: function getImageStyleFormatted(imageStyle) {

            if (!imageStyle) {
                return null;
            }

            var settings = {
                left: imageStyle.left + '%',
                top: imageStyle.top + '%',
                transform: 'translateY(' + imageStyle.translateY + '%) translateX(' + imageStyle.translateX + '%)'
            };
            if (imageStyle.resizeType === 1 && parseInt(imageStyle.size)) {
                settings.height = imageStyle.size + '%';
            }
            if (imageStyle.resizeType === 2 && parseInt(imageStyle.size)) {
                settings.width = imageStyle.size + '%';
            }

            return settings;
        },
        onMakeMark: function onMakeMark() {
            var vm = this;
            backendApi.materialMakeVote(this.material.Id).then(function (response) {
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при выполнении запроса. Попробуйте позже');
                } else {
                    vm.material.MyVote = !vm.material.MyVote;
                    vm.material.LikesCount = response.data.LikesCount;
                }
            });
        },
        onEditMaterial: function onEditMaterial() {
            this.$router.push('/materials/edit/' + this.material.Id);
        },
        onExportMaterial: function onExportMaterial() {
            var vm = this;

            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('#app');
            vm.callApiWrapper(backendApi.materialResultsExportUsers(vm.material.Id)).then(function (resp) {
                console.info('export', resp, vm.material);
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время экспорта');
                } else {
                    var exportFile = resp.data;
                    if (exportFile != null) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].downloadFileByBytes(exportFile, vm.material.Name + '.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Пустой материал');
                    }
                }
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            });
        },
        onMaterialTest: function onMaterialTest() {
            this.$router.push('/materials/' + this.material.Id + '/test?start');
        },


        // onMaterialTest53() {
        //     this.$router.push('/materials/' + this.material.Id + '/okko');
        // },
        //
        // onMaterialTestResults() {
        //     this.$router.push('/materials/' + this.material.Id + '/testresults');
        // },

        onShowUsers: function onShowUsers() {
            var _this = this;

            if (this.info.User.MainRole !== 'administrators') return;

            this.$nextTick(function () {

                _this.users.data = [];
                _this.users.page = 1;
                _this.users.canBeLoaded = true;
                _this.users.loading = false;
                _this.loadNextUsers();
                _this.$refs['ppUsers'].show();
            });
        },
        loadNextUsers: function loadNextUsers() {
            var vm = this;

            vm.users.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.popup', 'Загрузка...');
            this.callApiWrapper(backendApi.materialUsersList((this.users.page - 1) * 20, 20, this.material.Id)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки лайков');
                } else {
                    if (resp.data && resp.data.length) {
                        var _vm$users$data;

                        (_vm$users$data = vm.users.data).push.apply(_vm$users$data, _toConsumableArray(resp.data));
                    } else {
                        vm.users.canBeLoaded = false;
                    }
                }
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.popup');
                vm.users.loading = false;
            });
        },
        onExport: function onExport() {
            var vm = this;

            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('#app');
            vm.callApiWrapper(backendApi.materialExportUsers(vm.material.Id)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время экспорта');
                } else {
                    var exportFile = resp.data;
                    if (exportFile != null) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].downloadFileByBytes(exportFile, 'Пользователи, просмотревшие материал.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                    }
                }
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            });
        },
        onBottomScrolledUsers: function onBottomScrolledUsers() {
            var vm = this;

            if (!vm.users.loading && vm.users.canBeLoaded) {
                vm.users.page++;
                vm.loadNextUsers();
            }
        },
        loadMaterial: function loadMaterial() {
            var vm = this;
            var id = parseInt(this.$route.params.id);
            return this.callApiWrapper(backendApi.materialLoad(id)).then(function (response) {
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке материала');
                } else {
                    if (response.data == null) {
                        vm.$router.push('/materials');
                    } else {
                        vm.material = response.data;

                        if (vm.material.AllowedAttemptTime) {
                            var allowedAttemptTime = new Date(vm.material.AllowedAttemptTime);
                            vm.timeLeft = vm.formatTimeLeft(allowedAttemptTime - new Date());

                            var interval = window.setInterval(function runImmediately() {
                                var ms = allowedAttemptTime - new Date();
                                if (ms <= 0) {
                                    vm.timeLeft = null;
                                    vm.material.AllowedAttemptTime = null;
                                    window.clearInterval(interval);
                                } else {
                                    vm.timeLeft = vm.formatTimeLeft(ms);
                                }
                            }, 1000);
                        }

                        if (vm.material.CertificateSettings) {
                            vm.material.CertificateSettings = JSON.parse(vm.material.CertificateSettings);
                        }
                    }
                }
            });
        },
        loadMaterialTestResults: function loadMaterialTestResults() {
            var vm = this;
            var id = parseInt(this.$route.params.id);

            return this.callApiWrapper(backendApi.materialLoadTestResults(id)).then(function (response) {
                if (response.hasError) {
                    //UI.toastr.error('Ошибка при загрузке результатов теста');
                } else {
                    if (response.data != null) {
                        vm.results = response.data.Results;

                        var totalAnswers = vm.results.QuestionsRight + vm.results.QuestionsWrong;
                        vm.results.QuestionsRightPercent = (vm.results.QuestionsRight * 100 / (totalAnswers > 0 ? totalAnswers : 1)).toFixed(2);
                    }
                }
            });
        },


        // loadMaterialTestRating() {
        //     let vm = this;
        //     let id = parseInt(this.$route.params.id);
        //
        //     return this.callApiWrapper(backendApi.materialLoadTestRating(id)).then(function (response) {
        //         if (response.hasError) {
        //             UI.toastr.error('Ошибка при загрузке рейтинга');
        //         }
        //         else {
        //             if (response.data != null) {
        //                 vm.rating = response.data;
        //             }
        //         }
        //     });
        // }

        onCertificateDownload: function onCertificateDownload(sessionId) {
            var vm = this;
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('dataContent', 'Просмотр сертификата');
            vm.callApiWrapper(backendApi.materialCertificateDownload(sessionId, true)).then(function (resp) {
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время скачивания');
                    console.info('error status', resp.status);
                } else {
                    console.info('resp.data', resp.data, resp);
                    //window.location.href = resp.data;
                    window.open(resp.data, '_blank');
                }
            });
        }
    },

    mounted: function mounted() {
        var vm = this;

        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
        Promise.all([this.loadMaterial(), this.loadMaterialTestResults()]).then(function () {
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');

            vm.$nextTick(function () {

                if (vm.material.ActiveContentType === 1 && (vm.material.Status === 2 || vm.info.User.MainRole === 'administrators')) {

                    var materialId = parseInt(vm.$route.params.id);
                    var playerContainer = document.getElementById('playContent');

                    if (playerContainer != null) {
                        iFrame = document.createElement('iframe');
                        iFrame.src = __WEBPACK_IMPORTED_MODULE_2__config___default.a.apiUrl + '/Home/Player?materialId=' + materialId;
                        var div = document.createElement('div');
                        div.className = "scroll_frame";
                        div.appendChild(iFrame);
                        playerContainer.appendChild(div);
                    }
                }

                var tab = vm.$route.query.tab;
                if (tab) {
                    if (['test'].indexOf(tab.toLowerCase()) !== -1) {
                        vm.activeTab = tab.toLowerCase();
                    }

                    if (['results'].indexOf(tab.toLowerCase()) !== -1) {
                        vm.$refs['ppTestResults'].show();
                    }
                }
            });
        });
    },
    destroyed: function destroyed() {
        if (iFrame != null) {
            iFrame.parentNode.removeChild(iFrame);
        }
    }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var backendApi = new __WEBPACK_IMPORTED_MODULE_0__backendApi__["a" /* default */]();

var iFrame = void 0;

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "materialfile-details",

    props: ['info'],

    data: function data() {
        return {
            material: null,
            currentMaterialFile: null,
            isMobile: __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].check_mobile()
        };
    },


    computed: {
        materialFilePath: function materialFilePath() {
            if (this.currentMaterialFile.ActiveContentType === 3 || this.currentMaterialFile.ActiveContentType === 4) {
                return 'https://storage.yandexcloud.net/' + __WEBPACK_IMPORTED_MODULE_2__config___default.a.yandexCloudBucketName + '/' + this.currentMaterialFile.ContentFileName;
            }
            return null;
        }
    },

    methods: {
        onViewMaterialFile: function onViewMaterialFile(materialFile) {

            this.currentMaterialFile = materialFile;
            var page = materialFile.ProgressPage;
            //console.info('onViewMaterialFile, page', page)
            if (page == null) {
                page = materialFile.ActiveContentType === 3 ? 1 : 0;
            }
            this.onContinueViewing(page);
        },
        onPageChanged: function onPageChanged(page, duration) {
            //console.info('onPageChanged:', page);
            this.updateProgress(page, duration);
        },
        updateProgress: function updateProgress(page, duration) {
            var vm = this;
            if (vm.currentMaterialFile == null) {
                console.info('currentMaterialFile is null');
                return;
            }
            this.callApiWrapper(backendApi.materialUpdateProgress(vm.currentMaterialFile.Id, page, duration)).then(function (resp) {
                if (!resp.hasError) {
                    if (resp.data.ProgressPercent === 1) {
                        vm.currentMaterialFile.ProgressStatus = 'Завершён';
                    } else {
                        vm.currentMaterialFile.ProgressStatus = '\u0418\u0437\u0443\u0447\u0435\u043D\u043E ' + (resp.data.ProgressPercent * 100).toFixed(0) + '%';
                    }
                    vm.currentMaterialFile.ProgressPage = resp.data.ProgressPage;
                    vm.currentMaterialFile.ProgressPercent = resp.data.ProgressPercent;

                    // if(resp.data.ProgressPercent === 1) {
                    //     for (let i = 0; i < vm.material.Files.length; i++) {
                    //         if (!vm.material.FilesOrderLocked || i === 0 || vm.material.Files[i - 1].ProgressPercent == 1) {
                    //             vm.material.Files[i].Available = true;
                    //         }
                    //     }
                    // }
                }
            });
        },
        onContinueViewing: function onContinueViewing(page) {
            var vm = this;
            var materialFile = this.currentMaterialFile;

            this.$nextTick(function () {
                if (materialFile.ActiveContentType === 4) {
                    vm.$refs['videoView'].show(materialFile.ContentFileName, page, materialFile.ProgressPage);
                } else if (materialFile.ActiveContentType === 3) {
                    vm.$refs['pdfView'].show(materialFile.ContentFileName, page, materialFile.ProgressPage);
                } else if (materialFile.ActiveContentType === 2) {
                    vm.$refs['videoView'].show(materialFile.ContentFileName, page, materialFile.ProgressPercent, true);
                } else if (materialFile.ActiveContentType === 1) {
                    vm.$refs['presentationView'].show(__WEBPACK_IMPORTED_MODULE_2__config___default.a.apiUrl + '/Home/Player?materialId=' + vm.material.Id + '&page=' + page);
                } else if (materialFile.ActiveContentType === 5) {
                    vm.$refs['scormView'].show('/uploads/materials/' + vm.material.ProjectId + '/' + vm.material.Id + '/' + materialFile.Id + '/' + materialFile.ScormStartPath, materialFile.ScormStubFileName);
                }
            });
        },
        loadMaterial: function loadMaterial() {
            var vm = this;
            var id = parseInt(this.$route.params.materialId);
            var materialFileId = parseInt(this.$route.params.id);

            return this.callApiWrapper(backendApi.materialLoad(id)).then(function (response) {
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке материала');
                } else {
                    if (response.data == null) {
                        vm.$router.push('/materials');
                    } else {

                        var materialFile = response.data.Files.find(function (x) {
                            return x.Id === materialFileId;
                        });

                        var page = materialFile.ProgressPage;
                        if (page == null || materialFile.ProgressPercent === 1) {
                            page = materialFile.ActiveContentType === 3 ? 1 : 0;
                        }

                        vm.material = response.data;
                        vm.currentMaterialFile = materialFile;

                        vm.onContinueViewing(page);
                    }
                }
            });
        }
    },

    mounted: function mounted() {
        var vm = this;

        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
        Promise.all([this.loadMaterial()]).then(function () {
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');

            vm.$nextTick(function () {

                if (vm.material.ActiveContentType === 1 && (vm.material.Status === 2 || vm.info.User.MainRole === 'administrators')) {

                    var materialId = parseInt(vm.$route.params.id);
                    var playerContainer = document.getElementById('playContent');

                    if (playerContainer != null) {
                        iFrame = document.createElement('iframe');
                        iFrame.src = __WEBPACK_IMPORTED_MODULE_2__config___default.a.apiUrl + '/Home/Player?materialId=' + materialId;
                        var div = document.createElement('div');
                        div.className = "scroll_frame";
                        div.appendChild(iFrame);
                        playerContainer.appendChild(div);
                    }
                }
            });
        });
    },
    destroyed: function destroyed() {
        if (iFrame != null) {
            iFrame.parentNode.removeChild(iFrame);
        }
    }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_common_mixin__ = __webpack_require__(114);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var backendApi = new __WEBPACK_IMPORTED_MODULE_0__backendApi__["a" /* default */]();

var iFrame = void 0;

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "materialfile-details-mobileapp",

    props: ['info'],

    data: function data() {
        return {
            material: null,
            currentMaterialFile: null,
            isWebView: false
        };
    },


    computed: {},

    methods: {
        onPageChanged: function onPageChanged(page, duration) {
            //console.info('onPageChanged:', page);
            this.updateProgress(page, duration);
        },
        updateProgress: function updateProgress(page, duration) {
            var vm = this;
            if (vm.currentMaterialFile == null) {
                console.info('currentMaterialFile is null');
                return;
            }
            this.callApiWrapper(backendApi.materialUpdateProgress(vm.currentMaterialFile.Id, page, duration)).then(function (resp) {
                if (!resp.hasError) {
                    if (resp.data.ProgressPercent === 1) {
                        vm.currentMaterialFile.ProgressStatus = 'Завершён';
                    } else {
                        vm.currentMaterialFile.ProgressStatus = '\u0418\u0437\u0443\u0447\u0435\u043D\u043E ' + (resp.data.ProgressPercent * 100).toFixed(0) + '%';
                    }
                    vm.currentMaterialFile.ProgressPage = resp.data.ProgressPage;
                    vm.currentMaterialFile.ProgressPercent = resp.data.ProgressPercent;
                }
            });
        },
        onContinueViewing: function onContinueViewing(page) {
            var vm = this;
            var materialFile = this.currentMaterialFile;

            this.$nextTick(function () {
                if (materialFile.ActiveContentType === 5) {
                    vm.$refs['scormView'].show('/uploads/materials/' + vm.material.ProjectId + '/' + vm.material.Id + '/' + materialFile.Id + '/' + materialFile.ScormStartPath, materialFile.ScormStubFileName);
                }
            });
        },
        loadMaterial: function loadMaterial() {
            var vm = this;
            var id = parseInt(this.$route.params.materialId);
            var materialFileId = parseInt(this.$route.params.id);

            return this.callApiWrapper(backendApi.materialLoad(id)).then(function (response) {
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке материала');
                } else {
                    if (response.data == null) {
                        //vm.$router.push('/materials');
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Материал не найден');
                    } else {

                        var materialFile = response.data.Files.find(function (x) {
                            return x.Id === materialFileId;
                        });

                        var page = materialFile.ProgressPage;
                        if (page == null || materialFile.ProgressPercent === 1) {
                            page = materialFile.ActiveContentType === 3 ? 1 : 0;
                        }

                        vm.material = response.data;
                        vm.currentMaterialFile = materialFile;

                        vm.onContinueViewing(page);
                    }
                }
            });
        }
    },

    mounted: function mounted() {
        var vm = this;

        vm.isWebView = __WEBPACK_IMPORTED_MODULE_3__helpers_common_mixin__["a" /* default */].methods.getUrlParameter('view') == 'webview';

        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
        Promise.all([this.loadMaterial()]).then(function () {
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');

            vm.$nextTick(function () {

                if (vm.material && vm.material.ActiveContentType === 1 && (vm.material.Status === 2 || vm.info.User.MainRole === 'administrators')) {

                    var materialId = parseInt(vm.$route.params.id);
                    var playerContainer = document.getElementById('playContent');

                    if (playerContainer != null) {
                        iFrame = document.createElement('iframe');
                        iFrame.src = __WEBPACK_IMPORTED_MODULE_2__config___default.a.apiUrl + '/Home/Player?materialId=' + materialId;
                        var div = document.createElement('div');
                        div.className = "scroll_frame";
                        div.appendChild(iFrame);
                        playerContainer.appendChild(div);
                    }
                }
            });
        });
    },
    destroyed: function destroyed() {
        if (iFrame != null) {
            iFrame.parentNode.removeChild(iFrame);
        }
    }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_img_mixin__ = __webpack_require__(90);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var backendApi = new __WEBPACK_IMPORTED_MODULE_0__backendApi__["a" /* default */]();


var sessionTimeOut = null,
    secondsInterval = null;

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "material-test",

    props: ['info'],

    mixins: [__WEBPACK_IMPORTED_MODULE_3__helpers_img_mixin__["a" /* default */]],

    data: function data() {
        return {
            material: null,
            started: false,
            currentState: {
                question: null,
                index: null,
                answers: []
            },
            materialTestSessionId: null,
            results: null,
            bonus: null,
            time: null,
            resultTabs: {
                active: 'info'
            },
            bonusAdd: false,
            bonusDel: false,
            bonusDx: 0,
            bonusAnimationTimeout: null,
            isMobile: __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].check_mobile(),
            makingAnswerProgress: false
        };
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (this.started) {
            if (confirm('Вы уверены, что хотите уйти?')) {
                next();
            }
        } else {
            next();
        }
    },


    methods: {
        formatAnswerStats: function formatAnswerStats(questionsRight, questionsWrong) {
            var count = questionsRight + questionsWrong;
            var questionsRightPercent = questionsRight * 100 / (count === 0 ? 1 : count);

            return questionsRight + ' (' + questionsRightPercent.toFixed(2) + '%) / ' + count;
        },
        showBonusAdd: function showBonusAdd(dx) {
            var vm = this;

            this.bonusDx = dx;
            if (dx > 0) {
                this.bonusAdd = true;
                this.bonusDel = false;
                window.clearTimeout(this.bonusAnimationTimeout);
                this.bonusAnimationTimeout = window.setTimeout(function () {
                    vm.bonusAdd = false;
                }, 3000);
            } else {
                this.bonusDel = true;
                this.bonusAdd = false;
                window.clearTimeout(this.bonusAnimationTimeout);
                this.bonusAnimationTimeout = window.setTimeout(function () {
                    vm.bonusDel = false;
                }, 1900);
            }
        },
        formatLine: function formatLine(text) {
            return text ? text.replace(/\n/g, '<br>') : null;
        },
        onChangeDate: function onChangeDate(item) {
            item['answers'] = Object(__WEBPACK_IMPORTED_MODULE_2_moment__["default"])(item['date'], 'DD.MM.YYYY').format('DD.MM.YYYY');
        },
        loadMaterial: function loadMaterial() {
            var vm = this;
            var id = parseInt(this.$route.params.id);
            return this.callApiWrapper(backendApi.materialLoad(id, true)).then(function (response) {
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке материала');
                } else {
                    if (response.data == null) {
                        vm.$router.push('/materials');
                    } else {
                        if (response.data.TestComplete) {
                            vm.$router.push('/materials/' + id + '/testresults');
                        }

                        vm.material = response.data;

                        vm.time = response.data.TestTime * 60;
                        vm.bonus = response.data.Bonus;

                        //vm.onStartTest();
                    }
                }
            });
        },
        onStartTest: function onStartTest() {
            this.started = true;
            this.startTest();
        },
        startTest: function startTest() {
            var vm = this;
            var materialId = this.$route.params.id;

            this.callApiWrapper(backendApi.materialStartTest(materialId)).then(function (response) {
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка запуска теста');
                } else {
                    vm.materialTestSessionId = response.data;
                    vm.currentState.index = 1;
                    vm.currentState.question = vm.material.Questions[0];

                    vm.$nextTick(function () {
                        vm.imgmixin_lightzoomInit();
                    });

                    window.clearInterval(sessionTimeOut);
                    sessionTimeOut = window.setInterval(function () {

                        vm.updateTestSession();
                    }, 5000);

                    if (vm.time) {
                        window.clearInterval(secondsInterval);
                        secondsInterval = window.setInterval(function () {

                            vm.time--;

                            if (vm.material.TestSecondBonus) {
                                vm.bonus -= vm.material.TestSecondBonus;
                            }

                            vm.checkBonusAndTime();
                        }, 1000);
                    }
                }
            });
        },
        checkBonusAndTime: function checkBonusAndTime() {
            var vm = this;

            if (vm.material.Bonus) {
                if (vm.bonus > vm.material.Bonus) {
                    vm.bonus = vm.material.Bonus;
                }
                if (vm.bonus < 0) {
                    vm.bonus = 0;
                }
            }

            if (vm.material.TestTime && vm.time <= 0 || vm.material.Bonus && vm.bonus <= 0) {
                // тест закончен
                vm.callApiWrapper(backendApi.materialFailTestSession(vm.materialTestSessionId)).then(function (response) {
                    if (response.hasError) {
                        console.error('materialFailTestSession', response);
                    } else {

                        vm.results = response.data;

                        var totalAnswers = vm.results.QuestionsRight + vm.results.QuestionsWrong;
                        vm.results.QuestionsRightPercent = (vm.results.QuestionsRight * 100 / (totalAnswers > 0 ? totalAnswers : 1)).toFixed(2);

                        vm.currentState = {
                            question: null,
                            index: null,
                            answers: []
                        };

                        vm.started = false;

                        if (vm.$route.query.start !== undefined) {
                            vm.$router.push('/materials/' + id + '/?tab=results');
                        }
                    }
                });

                window.clearInterval(secondsInterval);
                window.clearInterval(sessionTimeOut);
            }
        },
        updateTestSession: function updateTestSession() {
            this.callApiWrapper(backendApi.materialUpdateTestSession(this.materialTestSessionId));
        },
        makeAnswer: function makeAnswer() {
            var _this = this;

            var vm = this;

            if (vm.makingAnswerProgress) {
                return;
            }

            var obj = {
                MaterialTestSessionId: vm.materialTestSessionId,
                QuestionId: vm.currentState.question.Id,
                Answers: null
            };

            if (vm.currentState.answers.length === 0) {
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Необходимо указать ответ');
                return;
            }

            vm.makingAnswerProgress = true;

            if (_typeof(vm.currentState.answers) === 'object') {
                obj.Answers = vm.currentState.answers;
            } else {
                obj.Answers = [vm.currentState.answers];
            }

            this.$validator.validate().then(function (result) {
                if (!result) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                    vm.makingAnswerProgress = false;
                } else {
                    _this.callApiWrapper(backendApi.materialMakeAnswer(obj)).then(function (response) {
                        if (response.hasError && response.status !== 401) {
                            if (response.status === 702) {
                                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('На этот вопрос уже дан ответ');
                            } else {
                                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время обработки ответа');
                            }
                        } else {

                            if (response.data.Correct === true && vm.material.TestRightAnswerBonus) {
                                vm.bonus += vm.material.TestRightAnswerBonus;
                                vm.checkBonusAndTime();
                                vm.showBonusAdd(vm.material.TestRightAnswerBonus);
                            }
                            if (response.data.Correct === false && vm.material.TestWrongAnswerBonus) {
                                vm.bonus -= vm.material.TestWrongAnswerBonus;
                                vm.checkBonusAndTime();
                                vm.showBonusAdd(-vm.material.TestWrongAnswerBonus);
                            }

                            if (vm.currentState.index === vm.material.Questions.length) {

                                vm.results = response.data;

                                var totalAnswers = vm.results.QuestionsRight + vm.results.QuestionsWrong;
                                vm.results.QuestionsRightPercent = (vm.results.QuestionsRight * 100 / (totalAnswers > 0 ? totalAnswers : 1)).toFixed(2);

                                vm.currentState = {
                                    question: null,
                                    index: null,
                                    answers: []
                                };

                                vm.$emit('user-updated');

                                window.clearInterval(sessionTimeOut);
                                window.clearInterval(secondsInterval);

                                vm.started = false;

                                if (vm.$route.query.start !== undefined) {
                                    vm.$router.push('/materials/' + vm.material.Id + '/?tab=results');
                                }
                            } else {
                                vm.currentState.index++;
                                vm.currentState.question = vm.material.Questions[vm.currentState.index - 1];
                                vm.currentState.answers = [];

                                vm.$nextTick(function () {
                                    vm.imgmixin_lightzoomInit();
                                });
                            }
                        }

                        vm.makingAnswerProgress = false;
                    });
                }
            });
        }
    },

    mounted: function mounted() {
        var _this2 = this;

        var vm = this;

        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.login-page-bg', 'Загрузка...');
        this.loadMaterial().then(function () {
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.login-page-bg');

            if (_this2.$route.query.start !== undefined) {
                vm.onStartTest();
            }
        });

        // для теста вёрстки

        // vm.results = {
        //     Complete: true, // тест сдан
        //     QuestionsRightPercent: 33.33,
        //     QuestionsRight: 1,
        //     QuestionsWrong: 2,
        //     TestTime: '01:20',
        //     Attempt: 10,
        //     Bonus: 500,
        //     Rating: [
        //         { Fio: 'Fio - 1', TestTime: '1:23', StatsFormatted: '16 (100%) / 16', Bonus: 500},
        //         { Fio: 'Fio - 2', TestTime: '1:22', StatsFormatted: '16 (100%) / 16', Bonus: 400},
        //         { Fio: 'Fio - 3', TestTime: '1:21', StatsFormatted: '16 (100%) / 16', Bonus: 300},
        //         { Fio: 'Fio - 4', TestTime: '1:20', StatsFormatted: '16 (100%) / 16', Bonus: 200},
        //         { Fio: 'Fio - 5', TestTime: '1:19', StatsFormatted: '16 (100%) / 16', Bonus: 100}
        //     ],
        //     Answers: [
        //         { QuestionName: 'Вопрос-1', Correct: true, AnswerTime: '00:15' },
        //         { QuestionName: 'Вопрос-2', Correct: false, AnswerTime: '00:05' },
        //         { QuestionName: 'Вопрос-3', Correct: true, AnswerTime: '00:20' }
        //     ]
        // };
    },
    destroyed: function destroyed() {
        if (sessionTimeOut != null) {
            window.clearInterval(sessionTimeOut);
        }
        if (secondsInterval != null) {
            window.clearInterval(secondsInterval);
        }
    }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var backendApi = new __WEBPACK_IMPORTED_MODULE_0__backendApi__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "material-testresults",

    props: ['info'],

    data: function data() {
        return {
            material: null,
            results: null,
            resultTabs: {
                active: 'info'
            },
            isMobile: __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].check_mobile()
        };
    },


    methods: {
        goToTest: function goToTest() {
            this.$router.push('/materials/' + this.material.Id + '/test');
        },
        formatAnswerStats: function formatAnswerStats(questionsRight, questionsWrong) {
            var count = questionsRight + questionsWrong;
            var questionsRightPercent = questionsRight * 100 / (count === 0 ? 1 : count);

            return questionsRight + ' (' + questionsRightPercent.toFixed(2) + '%) / ' + count;
        },
        loadMaterialTestResults: function loadMaterialTestResults() {
            var vm = this;
            var id = parseInt(this.$route.params.id);
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.login-page-bg', 'Загрузка...');

            return this.callApiWrapper(backendApi.materialLoadTestResults(id)).then(function (response) {
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке результатов теста');
                } else {
                    if (response.data == null) {
                        vm.$router.push('/materials');
                    } else {
                        vm.results = response.data.Results;
                        vm.material = response.data.Material;

                        var totalAnswers = vm.results.QuestionsRight + vm.results.QuestionsWrong;
                        vm.results.QuestionsRightPercent = (vm.results.QuestionsRight * 100 / (totalAnswers > 0 ? totalAnswers : 1)).toFixed(2);
                    }
                }
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.login-page-bg');
            });
        }
    },

    mounted: function mounted() {

        this.loadMaterialTestResults();

        // для теста вёрстки

        // this.results = {
        //     Complete: true, // тест сдан
        //     QuestionsRightPercent: 33.33,
        //     QuestionsRight: 1,
        //     QuestionsWrong: 2,
        //     TestTime: '01:20',
        //     Attempt: 10,
        //     Bonus: 500,
        //     Rating: [
        //         { Fio: 'Fio - 1', TestTime: '1:23', StatsFormatted: '16 (100%) / 16', Bonus: 500},
        //         { Fio: 'Fio - 2', TestTime: '1:22', StatsFormatted: '16 (100%) / 16', Bonus: 400},
        //         { Fio: 'Fio - 3', TestTime: '1:21', StatsFormatted: '16 (100%) / 16', Bonus: 300},
        //         { Fio: 'Fio - 4', TestTime: '1:20', StatsFormatted: '16 (100%) / 16', Bonus: 200},
        //         { Fio: 'Fio - 5', TestTime: '1:19', StatsFormatted: '16 (100%) / 16', Bonus: 100}
        //     ],
        //     Answers: [
        //         { QuestionName: 'Вопрос-1', Correct: true, AnswerTime: '00:15' },
        //         { QuestionName: 'Вопрос-2', Correct: false, AnswerTime: '00:05' },
        //         { QuestionName: 'Вопрос-3', Correct: true, AnswerTime: '00:20' }
        //     ]
        // };
    }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(9);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var backendApi = new __WEBPACK_IMPORTED_MODULE_0__backendApi__["a" /* default */]();

var ImageStyleDefault = {
    top: 0,
    left: 100,
    translateY: 0,
    translateX: -50,
    size: 100,
    resizeType: 1
};

var rowsPerPage = 50;

var processFilter = function processFilter(filter) {
    var resultFilter = JSON.parse(JSON.stringify(filter));
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = resultFilter[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            item[0] = item[0].replace("[dbo].[FakeTable].", "");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return resultFilter;
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "material-certificate",

    data: function data() {
        return {
            users: [],
            totalUsers: 0,
            rewardTypes: [],
            canBeLoaded: true,
            isLoading: false,
            projectId: 0,
            folderId: null,
            page: 1,
            filter: null,
            filters: [{
                Value: 'UserFIO', Name: 'ФИО'
            }, {
                Value: 'MaterialName', Name: 'Название курса'
            }, {
                Value: 'StartDate', Name: 'Дата сдачи'
            }, {
                Value: 'CreationDate', Name: 'Дата выдачи'
            }, {
                Value: 'DownloadDate', Name: 'Дата скачивания'
            }]
        };
    },


    methods: {
        back: function back() {
            this.$router.back();
        },
        loadUsers: function loadUsers() {
            var vm = this;
            vm.folderId = vm.$route.query.folderId;
            vm.projectId = parseInt(vm.$route.params.projectId);
            var filterFormatted = '';
            if (vm.filter) {
                filterFormatted = processFilter(vm.filter).map(function (x) {
                    return JSON.stringify(x);
                });
                if (filterFormatted == '') filterFormatted = null;
            }

            return this.callApiWrapper(backendApi.materialCertificate((this.page - 1) * rowsPerPage, rowsPerPage, vm.projectId, vm.folderId, filterFormatted)).then(function (resp) {
                if (resp.hasError) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при при получении списка');
                } else {
                    if (resp.data && resp.data.list.length) {
                        var _vm$users;

                        (_vm$users = vm.users).push.apply(_vm$users, _toConsumableArray(resp.data.list));

                        vm.totalUsers = resp.data.totalUsers;
                    } else {
                        vm.canBeLoaded = false;
                    }
                }
            });
        },
        reload: function reload() {
            this.page = 1;
            this.canBeLoaded = true;
            this.users = [];
            this.loadUsers();
        },
        searchFunction: function searchFunction(tableName, columnName, search, filters, searchPage, callback) {
            var filterFormatted = '';
            if (filters) {
                filterFormatted = processFilter(filters).map(function (x) {
                    return JSON.stringify(x);
                });
            }
            //console.info(tbName, columnName, this.projectId, search, filterFormatted, this.folderId);
            console.info('searchFunction search', search);
            this.callApiWrapper(backendApi.materialCertificateDistinctValues((searchPage - 1) * 100, 100, columnName, this.projectId, search, filterFormatted, this.folderId)).then(function (resp) {
                console.info(resp);
                callback(resp.data);
            });
        },
        onFilterChange: function onFilterChange(filter) {
            this.filter = filter;
            this.reload();
        },
        onCertificateClick: function onCertificateClick(dropFiles) {
            var vm = this;
            vm.$refs[dropFiles][0].click();
        },
        onCertificateDelete: function onCertificateDelete(sessionId) {
            var vm = this;
            if (confirm('Удалить сертификат?')) {
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('dataContent', 'Удаление сертификата');
                vm.callApiWrapper(backendApi.materialCertificateData(sessionId, null, null, true)).then(function (response) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                    if (response.hasError) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при удалении сертификата');
                        console.info('error status', response.status);
                    } else {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.success('Сертификата успешно удален');

                        vm.reload();
                    }
                });
            }
        },
        onCertificateDownload: function onCertificateDownload(sessionId) {
            var vm = this;
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('dataContent', 'Просмотр сертификата');
            vm.callApiWrapper(backendApi.materialCertificateDownload(sessionId, false)).then(function (resp) {
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время скачивания');
                    console.info('error status', resp.status);
                } else {
                    console.info('resp.data', resp.data, resp);
                    //window.location.href = resp.data;
                    window.open(resp.data, '_blank');
                }
            });
        },
        onCertificateChange: function onCertificateChange(sessionId, dropFiles, userId, materialName) {
            var vm = this;

            if (vm.$refs[dropFiles][0].files && vm.$refs[dropFiles][0].files[0]) {
                if (vm.$refs[dropFiles][0].files[0].size > 50 * 1024 * 1024) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Превышен размер. Выберите другой файл');
                } else {
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        var fileData = e.target.result;
                        var fileName = vm.$refs[dropFiles][0].files[0].name;
                        //console.info(sessionId, dropFiles);
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('dataContent', 'Загрузка сертификата');
                        vm.callApiWrapper(backendApi.materialCertificateData(sessionId, fileData, fileName, false)).then(function (response) {
                            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                            if (response.hasError) {
                                if (response.status === 2001) {
                                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Неверный формат файла');
                                } else {
                                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке сертификата');
                                }
                                console.info('error status', response.status);
                            } else {
                                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.success('Сертификат успешно загружен');

                                var _iteratorNormalCompletion2 = true;
                                var _didIteratorError2 = false;
                                var _iteratorError2 = undefined;

                                try {
                                    for (var _iterator2 = vm.users[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                        var user = _step2.value;

                                        if (user.SessionId === sessionId) {
                                            user.CreationDate = new Date();
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                            _iterator2.return();
                                        }
                                    } finally {
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }

                                var certSettings = response.data;
                                if (certSettings) {
                                    certSettings = JSON.parse(certSettings);
                                }
                                console.info(certSettings);
                                if (certSettings && certSettings.Issuance !== 'undefined' && certSettings.Issuance.Actived) {
                                    var sendingTemplate = {
                                        Id: 0,
                                        Body: 'Сертификат в ' + materialName + ' доступен для скачивания',
                                        Name: 'Сертификат материала'
                                    };
                                    console.info(certSettings.Issuance.data.email, certSettings.Issuance.data.sms, sendingTemplate);
                                    if (certSettings.Issuance.data.email) {
                                        vm.onStartSending(sendingTemplate, userId, 2);
                                    }
                                    if (certSettings.Issuance.data.sms) {
                                        vm.onStartSending(sendingTemplate, userId, 1);
                                    }
                                }
                            }
                        });
                    };
                    reader.readAsDataURL(this.$refs[dropFiles][0].files[0]);
                }
            }
        },
        onStartSending: function onStartSending(sendingTemplate, userId, bulkSendingTypeId) {
            var vm = this;

            if (vm.activeTab === 'email' && !this.currentTemplate.Name) {
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Укажите тему письма');
            } else {
                var notIncluded = [];
                notIncluded.push(userId);
                var smtpServerId = 1;
                var roleId = null;
                var dateSortEmpty = null;
                var dateSortType = '';
                var dateStart = new Date();
                var dateEnd = new Date();
                var allCurrentUsersSelected = false;

                var filterFormatted = '';
                //if (this.filter) {
                //    filterFormatted = processFilter(this.filter).map(x => { return JSON.stringify(x) });
                //}
                var saveObj = {
                    TemplateId: sendingTemplate.Id,
                    NotIncluded: notIncluded,
                    Filter: filterFormatted,
                    ProjectId: this.projectId,
                    TemplateName: sendingTemplate.Name,
                    Body: sendingTemplate.Body,
                    BulkSendingTypeId: bulkSendingTypeId,
                    SmtpServerId: smtpServerId,
                    RoleId: roleId,
                    DateSortEmpty: dateSortEmpty,
                    DateSortType: dateSortType,
                    DateStart: Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(dateStart, 'DD.MM.YYYY').format(),
                    DateEnd: Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(dateEnd, 'DD.MM.YYYY').format(),
                    AllCurrentUsersSelected: allCurrentUsersSelected
                };
                this.callApiWrapper(backendApi.commonBulkSending(saveObj)).then(function (response) {
                    if (response.hasError) {
                        if (response.status === 401) {
                            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Недостаточно прав для отправки уведомления');
                        } else {
                            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при создании рассылки');
                        }
                    } else {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно создано');
                        //vm.onTabChange('history');
                    }

                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
                });
            }
        },
        onScroll: function onScroll(e) {
            var vm = this;
            if (!vm.isLoading && vm.canBeLoaded) {
                var elem = $(e.target);
                if (elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight() + 100) {
                    vm.page++;
                    vm.loadUsers();
                }
            }
        },
        onExport: function onExport() {
            var vm = this;

            var projectId = vm.projectId;
            var filterFormatted = '';
            if (vm.filter) {
                filterFormatted = processFilter(vm.filter).map(function (x) {
                    return JSON.stringify(x);
                });
            }

            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('#app');
            this.callApiWrapper(backendApi.materialCertificateExport(projectId, vm.folderId, filterFormatted)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время экспорта');
                    console.info('resp', resp);
                } else {
                    var exportFile = resp.data;
                    if (exportFile != null) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].downloadFileByBytes(exportFile, "Пользователи.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                    }
                }
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            });
        }
    },

    mounted: function mounted() {
        var vm = this;
        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.page-content', 'Загрузка...');
        vm.loadUsers().then(function () {
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.page-content');
        });
        //vm.$refs.complexFilter.applyFilter();
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(30)))

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "test-okko",

    data: function data() {
        return {};
    },
    mounted: function mounted() {
        this.$refs['frame'].height = $('.page-content').height();
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(30)))

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backendApi__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var backendApi = new __WEBPACK_IMPORTED_MODULE_2__backendApi__["a" /* default */]();

var tokenKey = "tokenInfo";
/* harmony default export */ __webpack_exports__["a"] = ({
    name: "login",

    props: ['info'],

    data: function data() {
        return {
            UserName: null,
            Password: null,
            error: null,
            external: [],
            vkLoginHref: null,
            showPassword: false // состояние для видимости пароля
        };
    },


    methods: {
        logIn: function logIn() {
            var vm = this;

            this.$validator.validate().then(function (result) {
                if (result) {
                    var loginData = {
                        grant_type: 'password',
                        username: vm.UserName,
                        password: vm.Password,
                        isMobile: false
                    };

                    vm.error = null;
                    $.ajax({
                        type: 'POST',
                        url: __WEBPACK_IMPORTED_MODULE_1__config___default.a.apiUrl + '/Token',
                        data: loginData,
                        success: function success(data) {
                            vm.processSuccessLogin(data);
                        },
                        error: function error(data) {
                            vm.processErrorLogin(data);
                        }
                    });
                }
            });
        },
        processSuccessLogin: function processSuccessLogin(data) {
            console.info('processSuccessLogin ->', data.userName);
            $('.userName').text(data.userName);
            $('.userInfo').css('display', 'block');
            $('.loginForm').css('display', 'none');

            localStorage.removeItem(tokenKey);
            sessionStorage.removeItem(tokenKey);
            localStorage.removeItem('cart');
            localStorage.removeItem('usersComplexFilter');
            localStorage.removeItem('selectedProjectId');

            if ($('#rememberMe').is(':checked')) {
                localStorage.setItem(tokenKey, JSON.stringify(data));
            } else {
                sessionStorage.setItem(tokenKey, JSON.stringify(data));
            }

            localStorage.setItem('firstLogin', 'true');

            console.info('processSuccessLogin -> redirect');
            location.href = '/';
        },
        processErrorLogin: function processErrorLogin(data) {
            var vm = this;

            console.info(data.responseJSON);
            if (data.responseJSON.error === 'invalid_grant') {
                vm.error = 'Неверные имя пользователя или пароль';
            } else if (data.responseJSON.error === 'user_blocked') {
                vm.error = 'Ваш аккаунт заблокирован. Обратитесь в службу поддержки';
            } else if (data.responseJSON.error === 'email_notconfirmed') {
                vm.error = 'Вам отправлено сообщение. Пожалуйста, пройдите по ссылке для завершения регистрации.';
            } else if (data.responseJSON.error === 'user_needapprovement') {
                vm.error = 'В ближайшее время Ваши данные проверит Администратор, после чего Вы получите уведомление на Email и сможете авторизоваться.';
            } else if (data.responseJSON.error === 'user_refused') {
                var err = 'Вам отказано в регистрации.';
                if (data.responseJSON.error_description) {
                    err = err + ' \u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u043E\u0442\u043A\u0430\u0437\u0430: ' + data.responseJSON.error_description;
                }
                vm.error = err;
            } else {
                __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__["a" /* default */].toastr.error('При логине возникла ошибка');
            }
        },
        togglePasswordVisibility: function togglePasswordVisibility() {
            this.showPassword = !this.showPassword;
        }
    },

    mounted: function mounted() {
        var vm = this;

        var externalLoginStatus = vm.$route.query.externalLoginStatus;

        if (externalLoginStatus) {
            if (externalLoginStatus == 200) {
                var token = vm.$route.query.token,
                    userName = vm.$route.query.userName;
                vm.processSuccessLogin({
                    userName: userName,
                    access_token: token
                });

                return;
            } else {
                __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__["a" /* default */].toastr.error(externalLoginStatus == 404 ? 'Пользователь не найден' : 'Возникла ошибка. Обратитесь к администратору');

                var query = Object.assign({}, vm.$route.query);
                delete query.externalLoginStatus;
                vm.$router.replace({ query: query });
            }
        }

        var baseHost = location.origin;
        if (baseHost.indexOf('localhost') > -1 && __WEBPACK_IMPORTED_MODULE_1__config___default.a.apiUrl) {
            baseHost = __WEBPACK_IMPORTED_MODULE_1__config___default.a.apiUrl;
        }
        var redirectUri = baseHost + '/External/Login/?provider=%provider%';

        if (vm.info.ExternalVk) {
            vm.external.push({
                providerName: 'Vk',
                cssClass: 'fa fa-vk fa-2x',
                attachLink: "https://oauth.vk.com/authorize" + "?client_id=" + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_1__config___default.a.vkAppId) + "&redirect_uri=" + encodeURIComponent(redirectUri.replace('%provider%', 'vk')) + "&scope=" + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_1__config___default.a.vkAppScopes) + "&response_type=code" + "&v=" + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_1__config___default.a.vkVersion)
            });
        }
        if (vm.info.ExternalGoogle) {
            vm.external.push({
                providerName: 'Google',
                cssClass: 'fa fa-google fa-2x',
                attachLink: "https://accounts.google.com/o/oauth2/auth" + "?client_id=" + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_1__config___default.a.googleAppId) + "&redirect_uri=" + encodeURIComponent(redirectUri.replace('%provider%', 'google')) + "&access_type=offline&prompt=consent" + "&scope=" + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_1__config___default.a.googleAppScopes) + "&response_type=code"
            });
        }
        //if (vm.info.ExternalFacebook) {
        //    vm.external.push({
        //        providerName: 'Facebook',
        //        cssClass: 'fa fa-facebook fa-2x',
        //        attachLink: "https://www.facebook.com/dialog/oauth" +
        //            "?client_id=" + encodeURIComponent(config.facebookAppId) +
        //            "&redirect_uri=" + encodeURIComponent(redirectUri.replace('%provider%', 'facebook')) +
        //            "&scope=" + encodeURIComponent(config.facebookAppScopes) +
        //            "&response_type=code"
        //    });
        //}
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(30)))

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__backendApi__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var backendApi = new __WEBPACK_IMPORTED_MODULE_1__backendApi__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "forgot-password",

    props: ['info'],

    data: function data() {
        return {
            Email: null,
            error: null,
            result: null
        };
    },


    methods: {
        recover: function recover() {
            var vm = this;
            vm.result = null;
            this.$validator.validate().then(function (result) {
                if (result) {
                    backendApi.userRecover(vm.Email).then(function (response) {
                        console.info('backendApi.userRecover, response:', response);

                        if (response.hasError) {
                            if (response.status === 1404) {
                                vm.error = 'Указанный email не найден';
                            } else {
                                __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при восстановлении логина');
                            }
                        } else {
                            if (response.data != null) {
                                vm.result = response.data;
                            }
                        }
                    });
                }
            });
        }
    }

});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__backendApi__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var backendApi = new __WEBPACK_IMPORTED_MODULE_1__backendApi__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "reset-password",

    props: ['info'],

    data: function data() {
        return {
            result: null
        };
    },
    mounted: function mounted() {
        var vm = this;

        var hash = vm.$route.params.hash;
        if (!hash) {
            vm.$router.push('/login');
        }

        backendApi.userResetPassword(hash).then(function (response) {
            //console.info('reset -> backendApi.checkResetHash, response:', response);
            if (response.hasError) {
                if (response.status === 1404) {
                    // неверный hash
                    console.info('неверный hash');
                    vm.$router.push('/login');
                } else {
                    __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке страницы');
                }
            } else {
                if (response.data != null) {
                    vm.result = response.data;
                }
            }
        });
    }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__backendApi__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var backendApi = new __WEBPACK_IMPORTED_MODULE_1__backendApi__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "confirm-email",

    props: ['info'],

    data: function data() {
        return {
            result: null,
            status: null
        };
    },
    mounted: function mounted() {
        var vm = this;

        var hash = vm.$route.params.hash;
        if (!hash) {
            vm.$router.push('/login');
        }

        backendApi.userConfirmEmail(hash).then(function (response) {
            console.info('reset -> backendApi.userConfirmEmail, response:', response);
            if (response.hasError) {
                if (response.status === 1404) {
                    // неверный hash
                    console.info('неверный hash');
                    vm.$router.push('/login');
                } else {
                    __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке страницы');
                }
            } else {
                if (response.data != null) {
                    vm.status = response.data;
                }
                vm.result = true;
            }
        });
    }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enums__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cities_json__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cities_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__cities_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_CitySearch_vue__ = __webpack_require__(705);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var backendApi = new __WEBPACK_IMPORTED_MODULE_3__backendApi__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "register",
    components: { CitySearch: __WEBPACK_IMPORTED_MODULE_6__components_CitySearch_vue__["a" /* default */] },

    props: ['info'],

    data: function data() {
        return {
            error: null,
            passwordError: null,
            result: null,
            user: {},
            apiUrl: __WEBPACK_IMPORTED_MODULE_2__config___default.a.apiUrl,
            tradePoints: [],
            tradePointSelected: {},
            RegisterTradePointTypes: __WEBPACK_IMPORTED_MODULE_4__enums__["i" /* RegisterTradePointTypes */],
            regFields: [],
            rulesFile: {},
            policyFile: {},
            currentStep: 1,
            totalSteps: 1,
            currentRegFields: [],
            showPassword: false,
            selectedCity: null, // Выбранный город
            citiesData: __WEBPACK_IMPORTED_MODULE_5__cities_json___default.a, // Данные с городами
            isDaccord: false,
            isCampari: false
        };
    },


    methods: {
        searchCities: function searchCities(searchText, callback) {
            var results = this.citiesData.filter(function (city) {
                return city.city.toLowerCase().includes(searchText.toLowerCase());
            }).map(function (city) {
                return { Name: city.city + ', ' + city.region, Id: city.city + ', ' + city.region };
            });

            // Если не найдено — добавляем введенный текст
            if (results.length === 0) {
                results.push({ Name: searchText });
            }

            callback(results);
        },

        // Обработка выбора города
        onCitySelected: function onCitySelected(city, fieldName) {
            var field = this.currentRegFields.find(function (x) {
                return x.FieldName === fieldName;
            });
            field.Value = city.Name;
            this.selectedCity = city;
        },
        register: function register() {
            var vm = this;

            vm.error = null;
            this.$validator.validate().then(function (result) {
                if (result) {
                    vm.user.RegFields = [];
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = vm.regFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var field = _step.value;

                            vm.user.RegFields.push({ FieldToAnswer: field.FieldToAnswer, FieldValue: field.Value });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    var saveObj = Object.assign({}, vm.user, {});
                    console.info('register', saveObj);
                    backendApi.userRegister(saveObj).then(function (response) {
                        console.info('backendApi.userRegister, response:', response);
                        if (response.hasError) {
                            if (response.status === 201) {
                                vm.error = 'Ошибка. Проверьте введённые данные';
                            } else if (response.status === 8) {
                                vm.error = 'Email уже используется';
                            } else if (response.status === 9) {
                                vm.passwordError = 'Некорректное значение';
                            } else {
                                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при регистрации');
                            }
                        } else {
                            if (response.data != null) {
                                vm.result = response.data;
                            }
                        }
                    });
                }
            });
        },
        onNewPasswordChange: function onNewPasswordChange() {
            this.passwordError = null;

            if (!this.user.Password || !this.user.Password.trim()) {
                this.password.Error = null;
            } else {
                var newpass = this.user.Password;

                if (newpass.length < 6) {
                    this.passwordError = 'Введите минимум 6 символов';
                } else if (!/(?=.*\d).*\D.*/ig.test(newpass)) {
                    this.passwordError = 'Обязательно наличие и букв и цифр';
                } else if (!/(?=.*[A-ZА-Я]).*[a-zа-я].*/g.test(newpass)) {
                    this.passwordError = 'Обязательно наличие заглавной и прописной буквы';
                }
            }
        },
        onShowRulesClick: function onShowRulesClick() {
            var vm = this;
            vm.$refs.ppRules.show();
            if (!vm.rulesFile.ishtml) {
                vm.$nextTick(function () {
                    vm.$refs.pdfViewRules.show(vm.rulesFile.url);
                });
            }
        },
        onShowPolicyClick: function onShowPolicyClick() {
            var vm = this;
            vm.$refs.ppPolicy.show();
            if (!vm.policyFile.ishtml) {
                vm.$nextTick(function () {
                    vm.$refs.pdfViewPolicy.show(vm.policyFile.url);
                });
            }
        },
        loadTradePoints: function loadTradePoints() {
            var vm = this;
            vm.callApiWrapper(backendApi.tradePointListForRegister(0, 100)).then(function (resp) {
                vm.tradePoints = resp.data;
                vm.tradePointsOriginal = resp.data;
            });
        },
        getSkuSelectedItem: function getSkuSelectedItem(tradePointSelected) {
            return {
                Name: tradePointSelected.Name,
                Id: tradePointSelected.Id
            };
        },
        searchTPFunction: function searchTPFunction(searchText, callback, extra, page) {
            var vm = this;
            vm.callApiWrapper(backendApi.tradePointListForRegister((page - 1) * 20, 20, searchText)).then(function (resp) {
                callback(resp.data);
            });
        },
        onChangeTPLinkSearch: function onChangeTPLinkSearch(listItem, extra, fieldName) {
            if (listItem) {
                this.user.TradePointName = listItem.Name;
                this.user.TradePointId = listItem.Id;
                this.tradePointSelected = listItem;
            } else {
                this.user.TradePointName = '';
                this.user.TradePointId = null;
                this.tradePointSelected = {};
            }
        },
        nextStep: function nextStep() {
            var _this = this;

            this.$validator.validateAll().then(function (result) {
                if (!result) {
                    console.log("Ошибки валидации:", _this.errors.items);
                    return; // Остановить переход на следующий шаг, если есть ошибки
                }

                // Проверяем, есть ли ошибка в поле пароля
                if (_this.passwordError) {
                    console.log("Ошибка пароля:", _this.passwordError);
                    return; // Остановить переход, если есть ошибка в пароле
                }

                /*// Логика для расчета общего количества шагов (например, если это первый шаг)
                if (this.currentStep === 1) {
                    this.totalSteps = 2 + Math.ceil((this.regFields.length + (this.info.RegisterSettings.RegisterTradePointDisabled ? 0 : 1)) / 4);
                }*/

                // Переход на следующий шаг, если ошибок нет
                if (_this.currentStep < _this.totalSteps) {
                    _this.currentStep++;
                    _this.updateCurrentRegFields();
                }
            });
        },
        prevStep: function prevStep() {
            if (this.currentStep > 1) {
                this.currentStep--;
                this.updateCurrentRegFields();
            }
        },
        updateCurrentRegFields: function updateCurrentRegFields() {
            var startIndex = (this.currentStep - 2) * 4;
            if (!this.info.RegisterSettings.RegisterTradePointDisabled) {
                if (this.isDaccord) {
                    if (this.currentStep === 1) {
                        this.currentRegFields = [this.regFields[0], this.tradePointField].concat(_toConsumableArray(this.regFields.slice(1, this.regFields.length - 1)));
                    } else {
                        this.currentRegFields = [this.regFields[this.regFields.length - 1]];
                    }
                } else {
                    if (this.currentStep === 2) {
                        this.currentRegFields = [this.tradePointField].concat(_toConsumableArray(this.regFields.slice(startIndex, startIndex + 3)));
                    } else {
                        startIndex -= 1;
                        this.currentRegFields = this.regFields.slice(startIndex, startIndex + 4);
                    }
                }
            } else {
                this.currentRegFields = this.regFields.slice(startIndex, startIndex + 4);
            }
        },
        initPage: function initPage() {
            var vm = this;
            var fields = this.info.RegisterSettings.RegFields;
            for (var x = 0; x < fields.length; x++) {
                var field = { Id: fields[x].Id, FieldName: fields[x].FieldName, FieldType: fields[x].FieldType, Options: fields[x].Options, FieldToAnswer: fields[x].FieldToAnswer, Value: '' };
                if (fields[x].FieldType === 'select') field.optionsItems = JSON.parse(fields[x].Options).map(function (y) {
                    return { Value: y, Name: y };
                });
                vm.regFields.push(field);
            }

            if (!this.info.RegisterSettings.RegisterTradePointDisabled) {
                this.tradePointField = {
                    FieldName: this.info.RegisterSettings.RegisterTradePointName,
                    FieldType: this.info.RegisterSettings.RegisterTradePointType,
                    Value: this.user.TradePointName,
                    isTradePoint: true
                };
                if (this.info.RegisterSettings.RegisterTradePointType === 'select') {
                    this.tradePointField.optionsItems = this.tradePoints.map(function (tp) {
                        return { Value: tp.Name, Name: tp.Name };
                    });
                }
            }

            vm.policyFile.url = vm.info.PolicyFile.indexOf('https') > -1 ? vm.info.PolicyFile : __WEBPACK_IMPORTED_MODULE_2__config___default.a.apiUrl + vm.info.PolicyFile;
            vm.policyFile.ishtml = vm.policyFile.url.indexOf('.html') > -1;
            vm.rulesFile.url = vm.info.RulesFile.indexOf('https') > -1 ? vm.info.RulesFile : __WEBPACK_IMPORTED_MODULE_2__config___default.a.apiUrl + vm.info.RulesFile;
            vm.rulesFile.ishtml = vm.rulesFile.url.indexOf('.html') > -1;

            if (this.regFields.length > 0 || !this.info.RegisterSettings.RegisterTradePointDisabled) if (this.isDaccord) {
                this.totalSteps = 3;
            } else {
                this.totalSteps = 2 + Math.ceil((this.regFields.length + (this.info.RegisterSettings.RegisterTradePointDisabled ? 0 : 1)) / 4);
            }
            this.updateCurrentRegFields();
        },
        togglePasswordVisibility: function togglePasswordVisibility() {
            this.showPassword = !this.showPassword;
        }
    },

    mounted: function mounted() {
        this.isDaccord = this.info.PolicyFile && (this.info.PolicyFile.includes("promo.ofrs.su") || this.info.PolicyFile.includes("daccord.club"));
        this.isCampari = this.info.PolicyFile && (this.info.PolicyFile.includes("promo.ofrs.su") || this.info.PolicyFile.includes("campari.pro"));
        //console.info('this.info.RegisterSettings', this.info.RegisterSettings);
        if (!this.info.RegisterSettings.Enabled) {
            this.$router.push('/');
        } else {
            this.initPage();
        }
        //else if (this.info.RegisterSettings.RegisterTradePointType === RegisterTradePointTypes.Select) {
        //    this.loadTradePoints();
        //}
    }
});

/***/ }),
/* 265 */
/***/ (function(module, exports) {

module.exports = [{"region":"Москва и Московская обл.","city":"Москва"},{"region":"Москва и Московская обл.","city":"Абрамцево"},{"region":"Москва и Московская обл.","city":"Алабино"},{"region":"Москва и Московская обл.","city":"Апрелевка"},{"region":"Москва и Московская обл.","city":"Архангельское"},{"region":"Москва и Московская обл.","city":"Ашитково"},{"region":"Москва и Московская обл.","city":"Байконур"},{"region":"Москва и Московская обл.","city":"Бакшеево"},{"region":"Москва и Московская обл.","city":"Балашиха"},{"region":"Москва и Московская обл.","city":"Барыбино"},{"region":"Москва и Московская обл.","city":"Белоомут"},{"region":"Москва и Московская обл.","city":"Белые Столбы"},{"region":"Москва и Московская обл.","city":"Бородино"},{"region":"Москва и Московская обл.","city":"Бронницы"},{"region":"Москва и Московская обл.","city":"Быково"},{"region":"Москва и Московская обл.","city":"Валуево"},{"region":"Москва и Московская обл.","city":"Вербилки"},{"region":"Москва и Московская обл.","city":"Верея"},{"region":"Москва и Московская обл.","city":"Видное"},{"region":"Москва и Московская обл.","city":"Внуково"},{"region":"Москва и Московская обл.","city":"Вождь Пролетариата"},{"region":"Москва и Московская обл.","city":"Волоколамск"},{"region":"Москва и Московская обл.","city":"Вороново"},{"region":"Москва и Московская обл.","city":"Воскресенск"},{"region":"Москва и Московская обл.","city":"Восточный"},{"region":"Москва и Московская обл.","city":"Востряково"},{"region":"Москва и Московская обл.","city":"Высоковск"},{"region":"Москва и Московская обл.","city":"Голицино"},{"region":"Москва и Московская обл.","city":"Деденево"},{"region":"Москва и Московская обл.","city":"Дедовск"},{"region":"Москва и Московская обл.","city":"Джержинский"},{"region":"Москва и Московская обл.","city":"Дмитров"},{"region":"Москва и Московская обл.","city":"Долгопрудный"},{"region":"Москва и Московская обл.","city":"Домодедово"},{"region":"Москва и Московская обл.","city":"Дорохово"},{"region":"Москва и Московская обл.","city":"Дрезна"},{"region":"Москва и Московская обл.","city":"Дубки"},{"region":"Москва и Московская обл.","city":"Дубна"},{"region":"Москва и Московская обл.","city":"Егорьевск"},{"region":"Москва и Московская обл.","city":"Железнодорожный"},{"region":"Москва и Московская обл.","city":"Жилево"},{"region":"Москва и Московская обл.","city":"Жуковский"},{"region":"Москва и Московская обл.","city":"Загорск"},{"region":"Москва и Московская обл.","city":"Загорянский"},{"region":"Москва и Московская обл.","city":"Запрудная"},{"region":"Москва и Московская обл.","city":"Зарайск"},{"region":"Москва и Московская обл.","city":"Звенигород"},{"region":"Москва и Московская обл.","city":"Зеленоград"},{"region":"Москва и Московская обл.","city":"Ивантеевка"},{"region":"Москва и Московская обл.","city":"Икша"},{"region":"Москва и Московская обл.","city":"Ильинский"},{"region":"Москва и Московская обл.","city":"Истра"},{"region":"Москва и Московская обл.","city":"Калининград"},{"region":"Москва и Московская обл.","city":"Кашира"},{"region":"Москва и Московская обл.","city":"Керва"},{"region":"Москва и Московская обл.","city":"Климовск"},{"region":"Москва и Московская обл.","city":"Клин"},{"region":"Москва и Московская обл.","city":"Клязьма"},{"region":"Москва и Московская обл.","city":"Кожино"},{"region":"Москва и Московская обл.","city":"Кокошкино"},{"region":"Москва и Московская обл.","city":"Коломна"},{"region":"Москва и Московская обл.","city":"Колюбакино"},{"region":"Москва и Московская обл.","city":"Королев"},{"region":"Москва и Московская обл.","city":"Косино"},{"region":"Москва и Московская обл.","city":"Котельники"},{"region":"Москва и Московская обл.","city":"Красково"},{"region":"Москва и Московская обл.","city":"Красноармейск"},{"region":"Москва и Московская обл.","city":"Красногорск"},{"region":"Москва и Московская обл.","city":"Краснозаводск"},{"region":"Москва и Московская обл.","city":"Краснознаменск"},{"region":"Москва и Московская обл.","city":"Красный Ткач"},{"region":"Москва и Московская обл.","city":"Крюково"},{"region":"Москва и Московская обл.","city":"Кубинка"},{"region":"Москва и Московская обл.","city":"Купавна"},{"region":"Москва и Московская обл.","city":"Куровское"},{"region":"Москва и Московская обл.","city":"Лесной Городок"},{"region":"Москва и Московская обл.","city":"Ликино-Дулево"},{"region":"Москва и Московская обл.","city":"Лобня"},{"region":"Москва и Московская обл.","city":"Лопатинский"},{"region":"Москва и Московская обл.","city":"Лосино-Петровский"},{"region":"Москва и Московская обл.","city":"Лотошино"},{"region":"Москва и Московская обл.","city":"Лукино"},{"region":"Москва и Московская обл.","city":"Луховицы"},{"region":"Москва и Московская обл.","city":"Лыткарино"},{"region":"Москва и Московская обл.","city":"Львовский"},{"region":"Москва и Московская обл.","city":"Люберцы"},{"region":"Москва и Московская обл.","city":"Малаховка"},{"region":"Москва и Московская обл.","city":"Михайловское"},{"region":"Москва и Московская обл.","city":"Михнево"},{"region":"Москва и Московская обл.","city":"Можайск"},{"region":"Москва и Московская обл.","city":"Монино"},{"region":"Москва и Московская обл.","city":"Муханово"},{"region":"Москва и Московская обл.","city":"Мытищи"},{"region":"Москва и Московская обл.","city":"Нарофоминск"},{"region":"Москва и Московская обл.","city":"Нахабино"},{"region":"Москва и Московская обл.","city":"Некрасовка"},{"region":"Москва и Московская обл.","city":"Немчиновка"},{"region":"Москва и Московская обл.","city":"Новобратцевский"},{"region":"Москва и Московская обл.","city":"Новоподрезково"},{"region":"Москва и Московская обл.","city":"Ногинск"},{"region":"Москва и Московская обл.","city":"Обухово"},{"region":"Москва и Московская обл.","city":"Одинцово"},{"region":"Москва и Московская обл.","city":"Ожерелье"},{"region":"Москва и Московская обл.","city":"Озеры"},{"region":"Москва и Московская обл.","city":"Октябрьский"},{"region":"Москва и Московская обл.","city":"Опалиха"},{"region":"Москва и Московская обл.","city":"Орехово-Зуево"},{"region":"Москва и Московская обл.","city":"Павловский Посад"},{"region":"Москва и Московская обл.","city":"Первомайский"},{"region":"Москва и Московская обл.","city":"Пески"},{"region":"Москва и Московская обл.","city":"Пироговский"},{"region":"Москва и Московская обл.","city":"Подольск"},{"region":"Москва и Московская обл.","city":"Полушкино"},{"region":"Москва и Московская обл.","city":"Правдинский"},{"region":"Москва и Московская обл.","city":"Привокзальный"},{"region":"Москва и Московская обл.","city":"Пролетарский"},{"region":"Москва и Московская обл.","city":"Протвино"},{"region":"Москва и Московская обл.","city":"Пушкино"},{"region":"Москва и Московская обл.","city":"Пущино"},{"region":"Москва и Московская обл.","city":"Радовицкий"},{"region":"Москва и Московская обл.","city":"Раменское"},{"region":"Москва и Московская обл.","city":"Реутов"},{"region":"Москва и Московская обл.","city":"Решетниково"},{"region":"Москва и Московская обл.","city":"Родники"},{"region":"Москва и Московская обл.","city":"Рошаль"},{"region":"Москва и Московская обл.","city":"Рублево"},{"region":"Москва и Московская обл.","city":"Руза"},{"region":"Москва и Московская обл.","city":"Салтыковка"},{"region":"Москва и Московская обл.","city":"Северный"},{"region":"Москва и Московская обл.","city":"Сергиев Посад"},{"region":"Москва и Московская обл.","city":"Серебряные Пруды"},{"region":"Москва и Московская обл.","city":"Серпухов"},{"region":"Москва и Московская обл.","city":"Солнечногорск"},{"region":"Москва и Московская обл.","city":"Солнцево"},{"region":"Москва и Московская обл.","city":"Софрино"},{"region":"Москва и Московская обл.","city":"Старая Купавна"},{"region":"Москва и Московская обл.","city":"Старбеево"},{"region":"Москва и Московская обл.","city":"Ступино"},{"region":"Москва и Московская обл.","city":"Сходня"},{"region":"Москва и Московская обл.","city":"Талдом"},{"region":"Москва и Московская обл.","city":"Текстильщик"},{"region":"Москва и Московская обл.","city":"Темпы"},{"region":"Москва и Московская обл.","city":"Тишково"},{"region":"Москва и Московская обл.","city":"Томилино"},{"region":"Москва и Московская обл.","city":"Троицк"},{"region":"Москва и Московская обл.","city":"Туголесский Бор"},{"region":"Москва и Московская обл.","city":"Тучково"},{"region":"Москва и Московская обл.","city":"Уваровка"},{"region":"Москва и Московская обл.","city":"Удельная"},{"region":"Москва и Московская обл.","city":"Успенское"},{"region":"Москва и Московская обл.","city":"Фирсановка"},{"region":"Москва и Московская обл.","city":"Фосфоритный"},{"region":"Москва и Московская обл.","city":"Фрязино"},{"region":"Москва и Московская обл.","city":"Фряново"},{"region":"Москва и Московская обл.","city":"Химки"},{"region":"Москва и Московская обл.","city":"Хорлово"},{"region":"Москва и Московская обл.","city":"Хотьково"},{"region":"Москва и Московская обл.","city":"Черкизово"},{"region":"Москва и Московская обл.","city":"Черноголовка"},{"region":"Москва и Московская обл.","city":"Черусти"},{"region":"Москва и Московская обл.","city":"Чехов"},{"region":"Москва и Московская обл.","city":"Шарапово"},{"region":"Москва и Московская обл.","city":"Шатура"},{"region":"Москва и Московская обл.","city":"Шатурторф"},{"region":"Москва и Московская обл.","city":"Шаховская"},{"region":"Москва и Московская обл.","city":"Шереметьевский"},{"region":"Москва и Московская обл.","city":"Щелково"},{"region":"Москва и Московская обл.","city":"Щербинка"},{"region":"Москва и Московская обл.","city":"Электрогорск"},{"region":"Москва и Московская обл.","city":"Электросталь"},{"region":"Москва и Московская обл.","city":"Электроугли"},{"region":"Москва и Московская обл.","city":"Яхрома"},{"region":"Санкт-Петербург и область","city":"Санкт-Петербург"},{"region":"Санкт-Петербург и область","city":"Александровская"},{"region":"Санкт-Петербург и область","city":"Бокситогорск"},{"region":"Санкт-Петербург и область","city":"Большая Ижора"},{"region":"Санкт-Петербург и область","city":"Будогощь"},{"region":"Санкт-Петербург и область","city":"Вознесенье"},{"region":"Санкт-Петербург и область","city":"Волосово"},{"region":"Санкт-Петербург и область","city":"Волхов"},{"region":"Санкт-Петербург и область","city":"Всеволожск"},{"region":"Санкт-Петербург и область","city":"Выборг"},{"region":"Санкт-Петербург и область","city":"Вырица"},{"region":"Санкт-Петербург и область","city":"Высоцк"},{"region":"Санкт-Петербург и область","city":"Гатчина"},{"region":"Санкт-Петербург и область","city":"Дружная Горка"},{"region":"Санкт-Петербург и область","city":"Дубровка"},{"region":"Санкт-Петербург и область","city":"Ефимовский"},{"region":"Санкт-Петербург и область","city":"Зеленогорск"},{"region":"Санкт-Петербург и область","city":"Ивангород"},{"region":"Санкт-Петербург и область","city":"Каменногорск"},{"region":"Санкт-Петербург и область","city":"Кикерино"},{"region":"Санкт-Петербург и область","city":"Кингисепп"},{"region":"Санкт-Петербург и область","city":"Кириши"},{"region":"Санкт-Петербург и область","city":"Кировск"},{"region":"Санкт-Петербург и область","city":"Кобринское"},{"region":"Санкт-Петербург и область","city":"Колпино"},{"region":"Санкт-Петербург и область","city":"Коммунар"},{"region":"Санкт-Петербург и область","city":"Кронштадт"},{"region":"Санкт-Петербург и область","city":"Лисий Нос"},{"region":"Санкт-Петербург и область","city":"Лодейное Поле"},{"region":"Санкт-Петербург и область","city":"Ломоносов"},{"region":"Санкт-Петербург и область","city":"Луга"},{"region":"Санкт-Петербург и область","city":"Павловск"},{"region":"Санкт-Петербург и область","city":"Парголово"},{"region":"Санкт-Петербург и область","city":"Петродворец"},{"region":"Санкт-Петербург и область","city":"Пикалёво"},{"region":"Санкт-Петербург и область","city":"Подпорожье"},{"region":"Санкт-Петербург и область","city":"Приозерск"},{"region":"Санкт-Петербург и область","city":"Пушкин"},{"region":"Санкт-Петербург и область","city":"Сестрорецк"},{"region":"Санкт-Петербург и область","city":"Сланцы"},{"region":"Санкт-Петербург и область","city":"Сосновый Бор"},{"region":"Санкт-Петербург и область","city":"Тихвин"},{"region":"Санкт-Петербург и область","city":"Тосно"},{"region":"Санкт-Петербург и область","city":"Шлиссельбург"},{"region":"Адыгея","city":"Адыгейск"},{"region":"Адыгея","city":"Майкоп"},{"region":"Алтайский край","city":"Акташ"},{"region":"Алтайский край","city":"Акутиха"},{"region":"Алтайский край","city":"Алейск"},{"region":"Алтайский край","city":"Алтайский"},{"region":"Алтайский край","city":"Баево"},{"region":"Алтайский край","city":"Барнаул"},{"region":"Алтайский край","city":"Белово"},{"region":"Алтайский край","city":"Белокуриха"},{"region":"Алтайский край","city":"Белоярск"},{"region":"Алтайский край","city":"Бийск"},{"region":"Алтайский край","city":"Благовещенск"},{"region":"Алтайский край","city":"Боровлянка"},{"region":"Алтайский край","city":"Бурла"},{"region":"Алтайский край","city":"Бурсоль"},{"region":"Алтайский край","city":"Волчиха"},{"region":"Алтайский край","city":"Горно-Алтайск"},{"region":"Алтайский край","city":"Горняк"},{"region":"Алтайский край","city":"Ельцовка"},{"region":"Алтайский край","city":"Залесово"},{"region":"Алтайский край","city":"Заринск"},{"region":"Алтайский край","city":"Заток"},{"region":"Алтайский край","city":"Змеиногорск"},{"region":"Алтайский край","city":"Камень-на-Оби"},{"region":"Алтайский край","city":"Ключи"},{"region":"Алтайский край","city":"Кош-Агач"},{"region":"Алтайский край","city":"Красногорское"},{"region":"Алтайский край","city":"Краснощеково"},{"region":"Алтайский край","city":"Кулунда"},{"region":"Алтайский край","city":"Кытманово"},{"region":"Алтайский край","city":"Мамонтово"},{"region":"Алтайский край","city":"Новичиха"},{"region":"Алтайский край","city":"Новоалтайск"},{"region":"Алтайский край","city":"Онгудай"},{"region":"Алтайский край","city":"Павловск"},{"region":"Алтайский край","city":"Петропавловское"},{"region":"Алтайский край","city":"Поспелиха"},{"region":"Алтайский край","city":"Ребриха"},{"region":"Алтайский край","city":"Родино"},{"region":"Алтайский край","city":"Рубцовск"},{"region":"Алтайский край","city":"Славгород"},{"region":"Алтайский край","city":"Смоленское"},{"region":"Алтайский край","city":"Солонешное"},{"region":"Алтайский край","city":"Солтон"},{"region":"Алтайский край","city":"Староаллейское"},{"region":"Алтайский край","city":"Табуны"},{"region":"Алтайский край","city":"Тальменка"},{"region":"Алтайский край","city":"Топчиха"},{"region":"Алтайский край","city":"Троицкое"},{"region":"Алтайский край","city":"Турочак"},{"region":"Алтайский край","city":"Тюменцево"},{"region":"Алтайский край","city":"Угловское"},{"region":"Алтайский край","city":"Усть-Калманка"},{"region":"Алтайский край","city":"Усть-Кан"},{"region":"Алтайский край","city":"Усть-Кокса"},{"region":"Алтайский край","city":"Усть-Улаган"},{"region":"Алтайский край","city":"Усть-Чарышская Пристань"},{"region":"Алтайский край","city":"Хабары"},{"region":"Алтайский край","city":"Целинное"},{"region":"Алтайский край","city":"Чарышское"},{"region":"Алтайский край","city":"Шебалино"},{"region":"Алтайский край","city":"Шелаболиха"},{"region":"Алтайский край","city":"Шипуново"},{"region":"Амурская обл.","city":"Айгунь"},{"region":"Амурская обл.","city":"Архара"},{"region":"Амурская обл.","city":"Белогорск"},{"region":"Амурская обл.","city":"Благовещенск (Амурская обл.)"},{"region":"Амурская обл.","city":"Бурея"},{"region":"Амурская обл.","city":"Возжаевка"},{"region":"Амурская обл.","city":"Екатеринославка"},{"region":"Амурская обл.","city":"Ерофей Павлович"},{"region":"Амурская обл.","city":"Завитинск"},{"region":"Амурская обл.","city":"Зея"},{"region":"Амурская обл.","city":"Златоустовск"},{"region":"Амурская обл.","city":"Ивановка"},{"region":"Амурская обл.","city":"Коболдо"},{"region":"Амурская обл.","city":"Магдагачи"},{"region":"Амурская обл.","city":"Новобурейский"},{"region":"Амурская обл.","city":"Поярково"},{"region":"Амурская обл.","city":"Райчихинск"},{"region":"Амурская обл.","city":"Ромны"},{"region":"Амурская обл.","city":"Свободный"},{"region":"Амурская обл.","city":"Серышево"},{"region":"Амурская обл.","city":"Сковородино"},{"region":"Амурская обл.","city":"Стойба"},{"region":"Амурская обл.","city":"Тамбовка"},{"region":"Амурская обл.","city":"Тында"},{"region":"Амурская обл.","city":"Шимановск"},{"region":"Амурская обл.","city":"Экимчан"},{"region":"Амурская обл.","city":"Ядрино"},{"region":"Архангельская обл.","city":"Амдерма"},{"region":"Архангельская обл.","city":"Архангельск"},{"region":"Архангельская обл.","city":"Березник"},{"region":"Архангельская обл.","city":"Вельск"},{"region":"Архангельская обл.","city":"Верхняя Тойма"},{"region":"Архангельская обл.","city":"Волошка"},{"region":"Архангельская обл.","city":"Вычегодский"},{"region":"Архангельская обл.","city":"Емца"},{"region":"Архангельская обл.","city":"Илеза"},{"region":"Архангельская обл.","city":"Ильинско-Подомское"},{"region":"Архангельская обл.","city":"Каргополь"},{"region":"Архангельская обл.","city":"Карпогоры"},{"region":"Архангельская обл.","city":"Кодино"},{"region":"Архангельская обл.","city":"Коноша"},{"region":"Архангельская обл.","city":"Коряжма"},{"region":"Архангельская обл.","city":"Котлас"},{"region":"Архангельская обл.","city":"Красноборск"},{"region":"Архангельская обл.","city":"Лешуконское"},{"region":"Архангельская обл.","city":"Мезень"},{"region":"Архангельская обл.","city":"Мирный"},{"region":"Архангельская обл.","city":"Нарьян-Мар"},{"region":"Архангельская обл.","city":"Новодвинск"},{"region":"Архангельская обл.","city":"Няндома"},{"region":"Архангельская обл.","city":"Онега"},{"region":"Архангельская обл.","city":"Пинега"},{"region":"Архангельская обл.","city":"Плесецк"},{"region":"Архангельская обл.","city":"Северодвинск"},{"region":"Архангельская обл.","city":"Сольвычегодск"},{"region":"Архангельская обл.","city":"Холмогоры"},{"region":"Архангельская обл.","city":"Шенкурск"},{"region":"Архангельская обл.","city":"Яренск"},{"region":"Астраханская обл.","city":"Астрахань"},{"region":"Астраханская обл.","city":"Ахтубинск"},{"region":"Астраханская обл.","city":"Верхний Баскунчак"},{"region":"Астраханская обл.","city":"Володарский"},{"region":"Астраханская обл.","city":"Енотаевка"},{"region":"Астраханская обл.","city":"Икряное"},{"region":"Астраханская обл.","city":"Камызяк"},{"region":"Астраханская обл.","city":"Капустин Яр"},{"region":"Астраханская обл.","city":"Красный Яр"},{"region":"Астраханская обл.","city":"Лиман"},{"region":"Астраханская обл.","city":"Началово"},{"region":"Астраханская обл.","city":"Харабали"},{"region":"Астраханская обл.","city":"Черный Яр"},{"region":"Башкортостан(Башкирия)","city":"Аксаково"},{"region":"Башкортостан(Башкирия)","city":"Амзя"},{"region":"Башкортостан(Башкирия)","city":"Аскино"},{"region":"Башкортостан(Башкирия)","city":"Баймак"},{"region":"Башкортостан(Башкирия)","city":"Бакалы"},{"region":"Башкортостан(Башкирия)","city":"Белебей"},{"region":"Башкортостан(Башкирия)","city":"Белорецк"},{"region":"Башкортостан(Башкирия)","city":"Бижбуляк"},{"region":"Башкортостан(Башкирия)","city":"Бирск"},{"region":"Башкортостан(Башкирия)","city":"Благовещенск"},{"region":"Башкортостан(Башкирия)","city":"Большеустьикинское"},{"region":"Башкортостан(Башкирия)","city":"Бураево"},{"region":"Башкортостан(Башкирия)","city":"Верхнеяркеево"},{"region":"Башкортостан(Башкирия)","city":"Верхние Киги"},{"region":"Башкортостан(Башкирия)","city":"Верхние Татышлы"},{"region":"Башкортостан(Башкирия)","city":"Верхний Авзян"},{"region":"Башкортостан(Башкирия)","city":"Давлеканово"},{"region":"Башкортостан(Башкирия)","city":"Дуван"},{"region":"Башкортостан(Башкирия)","city":"Дюртюли"},{"region":"Башкортостан(Башкирия)","city":"Ермекеево"},{"region":"Башкортостан(Башкирия)","city":"Ермолаево"},{"region":"Башкортостан(Башкирия)","city":"Зилаир"},{"region":"Башкортостан(Башкирия)","city":"Зирган"},{"region":"Башкортостан(Башкирия)","city":"Иглино"},{"region":"Башкортостан(Башкирия)","city":"Инзер"},{"region":"Башкортостан(Башкирия)","city":"Исянгулово"},{"region":"Башкортостан(Башкирия)","city":"Ишимбай"},{"region":"Башкортостан(Башкирия)","city":"Кананикольское"},{"region":"Башкортостан(Башкирия)","city":"Кандры"},{"region":"Башкортостан(Башкирия)","city":"Караидель"},{"region":"Башкортостан(Башкирия)","city":"Караидельский"},{"region":"Башкортостан(Башкирия)","city":"Киргиз-Мияки"},{"region":"Башкортостан(Башкирия)","city":"Красноусольский"},{"region":"Башкортостан(Башкирия)","city":"Кумертау"},{"region":"Башкортостан(Башкирия)","city":"Кушнаренково"},{"region":"Башкортостан(Башкирия)","city":"Малояз"},{"region":"Башкортостан(Башкирия)","city":"Мелеуз"},{"region":"Башкортостан(Башкирия)","city":"Месягутово"},{"region":"Башкортостан(Башкирия)","city":"Мраково"},{"region":"Башкортостан(Башкирия)","city":"Нефтекамск"},{"region":"Башкортостан(Башкирия)","city":"Октябрьский"},{"region":"Башкортостан(Башкирия)","city":"Раевский"},{"region":"Башкортостан(Башкирия)","city":"Салават"},{"region":"Башкортостан(Башкирия)","city":"Сибай"},{"region":"Башкортостан(Башкирия)","city":"Старобалтачево"},{"region":"Башкортостан(Башкирия)","city":"Старосубхангулово"},{"region":"Башкортостан(Башкирия)","city":"Стерлибашево"},{"region":"Башкортостан(Башкирия)","city":"Стерлитамак"},{"region":"Башкортостан(Башкирия)","city":"Туймазы"},{"region":"Башкортостан(Башкирия)","city":"Уфа"},{"region":"Башкортостан(Башкирия)","city":"Учалы"},{"region":"Башкортостан(Башкирия)","city":"Федоровка"},{"region":"Башкортостан(Башкирия)","city":"Чекмагуш"},{"region":"Башкортостан(Башкирия)","city":"Чишмы"},{"region":"Башкортостан(Башкирия)","city":"Шаран"},{"region":"Башкортостан(Башкирия)","city":"Янаул"},{"region":"Белгородская обл.","city":"Алексеевка"},{"region":"Белгородская обл.","city":"Белгород"},{"region":"Белгородская обл.","city":"Борисовка"},{"region":"Белгородская обл.","city":"Валуйки"},{"region":"Белгородская обл.","city":"Вейделевка"},{"region":"Белгородская обл.","city":"Волоконовка"},{"region":"Белгородская обл.","city":"Грайворон"},{"region":"Белгородская обл.","city":"Губкин"},{"region":"Белгородская обл.","city":"Ивня"},{"region":"Белгородская обл.","city":"Короча"},{"region":"Белгородская обл.","city":"Красногвардейское"},{"region":"Белгородская обл.","city":"Новый Оскол"},{"region":"Белгородская обл.","city":"Ракитное"},{"region":"Белгородская обл.","city":"Ровеньки"},{"region":"Белгородская обл.","city":"Старый Оскол"},{"region":"Белгородская обл.","city":"Строитель"},{"region":"Белгородская обл.","city":"Чернянка"},{"region":"Белгородская обл.","city":"Шебекино"},{"region":"Брянская обл.","city":"Алтухово"},{"region":"Брянская обл.","city":"Белая Березка"},{"region":"Брянская обл.","city":"Белые Берега"},{"region":"Брянская обл.","city":"Большое Полпино"},{"region":"Брянская обл.","city":"Брянск"},{"region":"Брянская обл.","city":"Бытошь"},{"region":"Брянская обл.","city":"Выгоничи"},{"region":"Брянская обл.","city":"Вышков"},{"region":"Брянская обл.","city":"Гордеевка"},{"region":"Брянская обл.","city":"Дубровка"},{"region":"Брянская обл.","city":"Дятьково"},{"region":"Брянская обл.","city":"Жирятино"},{"region":"Брянская обл.","city":"Жуковка"},{"region":"Брянская обл.","city":"Злынка"},{"region":"Брянская обл.","city":"Ивот"},{"region":"Брянская обл.","city":"Карачев"},{"region":"Брянская обл.","city":"Клетня"},{"region":"Брянская обл.","city":"Климово"},{"region":"Брянская обл.","city":"Клинцы"},{"region":"Брянская обл.","city":"Кокаревка"},{"region":"Брянская обл.","city":"Комаричи"},{"region":"Брянская обл.","city":"Красная Гора"},{"region":"Брянская обл.","city":"Локоть"},{"region":"Брянская обл.","city":"Мглин"},{"region":"Брянская обл.","city":"Навля"},{"region":"Брянская обл.","city":"Новозыбков"},{"region":"Брянская обл.","city":"Погар"},{"region":"Брянская обл.","city":"Почеп"},{"region":"Брянская обл.","city":"Ржаница"},{"region":"Брянская обл.","city":"Рогнедино"},{"region":"Брянская обл.","city":"Севск"},{"region":"Брянская обл.","city":"Стародуб"},{"region":"Брянская обл.","city":"Суземка"},{"region":"Брянская обл.","city":"Сураж"},{"region":"Брянская обл.","city":"Трубчевск"},{"region":"Брянская обл.","city":"Унеча"},{"region":"Бурятия","city":"Бабушкин"},{"region":"Бурятия","city":"Багдарин"},{"region":"Бурятия","city":"Баргузин"},{"region":"Бурятия","city":"Баянгол"},{"region":"Бурятия","city":"Бичура"},{"region":"Бурятия","city":"Выдрино"},{"region":"Бурятия","city":"Гусиное Озеро"},{"region":"Бурятия","city":"Гусиноозерск"},{"region":"Бурятия","city":"Заиграево"},{"region":"Бурятия","city":"Закаменск"},{"region":"Бурятия","city":"Иволгинск"},{"region":"Бурятия","city":"Илька"},{"region":"Бурятия","city":"Кабанск"},{"region":"Бурятия","city":"Каменск"},{"region":"Бурятия","city":"Кижинга"},{"region":"Бурятия","city":"Курумкан"},{"region":"Бурятия","city":"Кырен"},{"region":"Бурятия","city":"Кяхта"},{"region":"Бурятия","city":"Монды"},{"region":"Бурятия","city":"Мухоршибирь"},{"region":"Бурятия","city":"Нижнеангарск"},{"region":"Бурятия","city":"Орлик"},{"region":"Бурятия","city":"Петропавловка"},{"region":"Бурятия","city":"Романовка"},{"region":"Бурятия","city":"Северобайкальск"},{"region":"Бурятия","city":"Селенгинск"},{"region":"Бурятия","city":"Сосново-Озерское"},{"region":"Бурятия","city":"Таксимо"},{"region":"Бурятия","city":"Турунтаево"},{"region":"Бурятия","city":"Улан-Удэ"},{"region":"Бурятия","city":"Хоринск"},{"region":"Владимирская обл.","city":"Александров"},{"region":"Владимирская обл.","city":"Андреево"},{"region":"Владимирская обл.","city":"Анопино"},{"region":"Владимирская обл.","city":"Бавлены"},{"region":"Владимирская обл.","city":"Балакирево"},{"region":"Владимирская обл.","city":"Боголюбово"},{"region":"Владимирская обл.","city":"Великодворский"},{"region":"Владимирская обл.","city":"Вербовский"},{"region":"Владимирская обл.","city":"Владимир"},{"region":"Владимирская обл.","city":"Вязники"},{"region":"Владимирская обл.","city":"Городищи"},{"region":"Владимирская обл.","city":"Гороховец"},{"region":"Владимирская обл.","city":"Гусевский"},{"region":"Владимирская обл.","city":"Гусь Хрустальный"},{"region":"Владимирская обл.","city":"Золотково"},{"region":"Владимирская обл.","city":"Иванищи"},{"region":"Владимирская обл.","city":"Камешково"},{"region":"Владимирская обл.","city":"Карабаново"},{"region":"Владимирская обл.","city":"Киржач"},{"region":"Владимирская обл.","city":"Ковров"},{"region":"Владимирская обл.","city":"Кольчугино"},{"region":"Владимирская обл.","city":"Красная Горбатка"},{"region":"Владимирская обл.","city":"Меленки"},{"region":"Владимирская обл.","city":"Муром"},{"region":"Владимирская обл.","city":"Петушки"},{"region":"Владимирская обл.","city":"Покров"},{"region":"Владимирская обл.","city":"Собинка"},{"region":"Владимирская обл.","city":"Судогда"},{"region":"Владимирская обл.","city":"Суздаль"},{"region":"Владимирская обл.","city":"Юрьев-Польский"},{"region":"Волгоградская обл.","city":"Алексеевская"},{"region":"Волгоградская обл.","city":"Алущевск"},{"region":"Волгоградская обл.","city":"Быково"},{"region":"Волгоградская обл.","city":"Волгоград"},{"region":"Волгоградская обл.","city":"Волжский"},{"region":"Волгоградская обл.","city":"Городище"},{"region":"Волгоградская обл.","city":"Дубовка"},{"region":"Волгоградская обл.","city":"Елань"},{"region":"Волгоградская обл.","city":"Жирновск"},{"region":"Волгоградская обл.","city":"Иловля"},{"region":"Волгоградская обл.","city":"Калач-на-Дону"},{"region":"Волгоградская обл.","city":"Камышин"},{"region":"Волгоградская обл.","city":"Кириллов"},{"region":"Волгоградская обл.","city":"Клетский"},{"region":"Волгоградская обл.","city":"Котельниково"},{"region":"Волгоградская обл.","city":"Котово"},{"region":"Волгоградская обл.","city":"Кумылженская"},{"region":"Волгоградская обл.","city":"Ленинск"},{"region":"Волгоградская обл.","city":"Михайловка"},{"region":"Волгоградская обл.","city":"Нехаевский"},{"region":"Волгоградская обл.","city":"Николаевск"},{"region":"Волгоградская обл.","city":"Новоаннинский"},{"region":"Волгоградская обл.","city":"Новониколаевский"},{"region":"Волгоградская обл.","city":"Ольховка"},{"region":"Волгоградская обл.","city":"Палласовка"},{"region":"Волгоградская обл.","city":"Рудня"},{"region":"Волгоградская обл.","city":"Светлый Яр"},{"region":"Волгоградская обл.","city":"Серафимович"},{"region":"Волгоградская обл.","city":"Средняя Ахтуба"},{"region":"Волгоградская обл.","city":"Сталинград"},{"region":"Волгоградская обл.","city":"Старая Полтавка"},{"region":"Волгоградская обл.","city":"Суровикино"},{"region":"Волгоградская обл.","city":"Урюпинск"},{"region":"Волгоградская обл.","city":"Фролово"},{"region":"Волгоградская обл.","city":"Чернышковский"},{"region":"Вологодская обл.","city":"Бабаево"},{"region":"Вологодская обл.","city":"Белозерск"},{"region":"Вологодская обл.","city":"Великий Устюг"},{"region":"Вологодская обл.","city":"Верховажье"},{"region":"Вологодская обл.","city":"Вожега"},{"region":"Вологодская обл.","city":"Вологда"},{"region":"Вологодская обл.","city":"Вохтога"},{"region":"Вологодская обл.","city":"Вытегра"},{"region":"Вологодская обл.","city":"Грязовец"},{"region":"Вологодская обл.","city":"Кадников"},{"region":"Вологодская обл.","city":"Кадуй"},{"region":"Вологодская обл.","city":"Кичменгский Городок"},{"region":"Вологодская обл.","city":"Липин Бор"},{"region":"Вологодская обл.","city":"Никольск"},{"region":"Вологодская обл.","city":"Нюксеница"},{"region":"Вологодская обл.","city":"Сокол"},{"region":"Вологодская обл.","city":"Сямжа"},{"region":"Вологодская обл.","city":"Тарногский Городок"},{"region":"Вологодская обл.","city":"Тотьма"},{"region":"Вологодская обл.","city":"Устюжна"},{"region":"Вологодская обл.","city":"Харовск"},{"region":"Вологодская обл.","city":"Чагода"},{"region":"Вологодская обл.","city":"Череповец"},{"region":"Вологодская обл.","city":"Шексна"},{"region":"Вологодская обл.","city":"Шуйское"},{"region":"Воронежская обл.","city":"Анна"},{"region":"Воронежская обл.","city":"Бобров"},{"region":"Воронежская обл.","city":"Богучар"},{"region":"Воронежская обл.","city":"Борисоглебск"},{"region":"Воронежская обл.","city":"Бутурлиновка"},{"region":"Воронежская обл.","city":"Верхний Мамон"},{"region":"Воронежская обл.","city":"Верхняя Хава"},{"region":"Воронежская обл.","city":"Воробьевка"},{"region":"Воронежская обл.","city":"Воронеж"},{"region":"Воронежская обл.","city":"Грибановский"},{"region":"Воронежская обл.","city":"Давыдовка"},{"region":"Воронежская обл.","city":"Елань-Коленовский"},{"region":"Воронежская обл.","city":"Калач"},{"region":"Воронежская обл.","city":"Кантемировка"},{"region":"Воронежская обл.","city":"Лиски"},{"region":"Воронежская обл.","city":"Нижнедевицк"},{"region":"Воронежская обл.","city":"Новая Усмань"},{"region":"Воронежская обл.","city":"Новохоперск"},{"region":"Воронежская обл.","city":"Ольховатка"},{"region":"Воронежская обл.","city":"Острогожск"},{"region":"Воронежская обл.","city":"Павловск"},{"region":"Воронежская обл.","city":"Панино"},{"region":"Воронежская обл.","city":"Петропавловка"},{"region":"Воронежская обл.","city":"Поворино"},{"region":"Воронежская обл.","city":"Подгоренский"},{"region":"Воронежская обл.","city":"Рамонь"},{"region":"Воронежская обл.","city":"Репьевка"},{"region":"Воронежская обл.","city":"Россошь"},{"region":"Воронежская обл.","city":"Семилуки"},{"region":"Воронежская обл.","city":"Таловая"},{"region":"Воронежская обл.","city":"Терновка"},{"region":"Воронежская обл.","city":"Хохольский"},{"region":"Воронежская обл.","city":"Эртиль"},{"region":"Воронежская обл.","city":"нововоронеж"},{"region":"Дагестан","city":"Агвали"},{"region":"Дагестан","city":"Акуша"},{"region":"Дагестан","city":"Ахты"},{"region":"Дагестан","city":"Ачису"},{"region":"Дагестан","city":"Бабаюрт"},{"region":"Дагестан","city":"Бежта"},{"region":"Дагестан","city":"Ботлих"},{"region":"Дагестан","city":"Буйнакск"},{"region":"Дагестан","city":"Вачи"},{"region":"Дагестан","city":"Гергебиль"},{"region":"Дагестан","city":"Гуниб"},{"region":"Дагестан","city":"Дагестанские Огни"},{"region":"Дагестан","city":"Дербент"},{"region":"Дагестан","city":"Дылым"},{"region":"Дагестан","city":"Ершовка"},{"region":"Дагестан","city":"Избербаш"},{"region":"Дагестан","city":"Карабудахкент"},{"region":"Дагестан","city":"Карата"},{"region":"Дагестан","city":"Каспийск"},{"region":"Дагестан","city":"Касумкент"},{"region":"Дагестан","city":"Кизилюрт"},{"region":"Дагестан","city":"Кизляр"},{"region":"Дагестан","city":"Кочубей"},{"region":"Дагестан","city":"Кумух"},{"region":"Дагестан","city":"Курах"},{"region":"Дагестан","city":"Магарамкент"},{"region":"Дагестан","city":"Маджалис"},{"region":"Дагестан","city":"Махачкала"},{"region":"Дагестан","city":"Мехельта"},{"region":"Дагестан","city":"Новолакское"},{"region":"Дагестан","city":"Рутул"},{"region":"Дагестан","city":"Советское"},{"region":"Дагестан","city":"Тарумовка"},{"region":"Дагестан","city":"Терекли-Мектеб"},{"region":"Дагестан","city":"Тлярата"},{"region":"Дагестан","city":"Тпиг"},{"region":"Дагестан","city":"Уркарах"},{"region":"Дагестан","city":"Хасавюрт"},{"region":"Дагестан","city":"Хив"},{"region":"Дагестан","city":"Хунзах"},{"region":"Дагестан","city":"Цуриб"},{"region":"Дагестан","city":"Южно-Сухокумск"},{"region":"Еврейская обл.","city":"Биробиджан"},{"region":"Ивановская обл.","city":"Архиповка"},{"region":"Ивановская обл.","city":"Верхний Ландех"},{"region":"Ивановская обл.","city":"Вичуга"},{"region":"Ивановская обл.","city":"Гаврилов Посад"},{"region":"Ивановская обл.","city":"Долматовский"},{"region":"Ивановская обл.","city":"Дуляпино"},{"region":"Ивановская обл.","city":"Заволжск"},{"region":"Ивановская обл.","city":"Заречный"},{"region":"Ивановская обл.","city":"Иваново"},{"region":"Ивановская обл.","city":"Иваньковский"},{"region":"Ивановская обл.","city":"Ильинское-Хованское"},{"region":"Ивановская обл.","city":"Каминский"},{"region":"Ивановская обл.","city":"Кинешма"},{"region":"Ивановская обл.","city":"Комсомольск"},{"region":"Ивановская обл.","city":"Кохма"},{"region":"Ивановская обл.","city":"Лух"},{"region":"Ивановская обл.","city":"Палех"},{"region":"Ивановская обл.","city":"Пестяки"},{"region":"Ивановская обл.","city":"Приволжск"},{"region":"Ивановская обл.","city":"Пучеж"},{"region":"Ивановская обл.","city":"Родники"},{"region":"Ивановская обл.","city":"Савино"},{"region":"Ивановская обл.","city":"Сокольское"},{"region":"Ивановская обл.","city":"Тейково"},{"region":"Ивановская обл.","city":"Фурманов"},{"region":"Ивановская обл.","city":"Шуя"},{"region":"Ивановская обл.","city":"Южа"},{"region":"Ивановская обл.","city":"Юрьевец"},{"region":"Иркутская обл.","city":"Алексеевск"},{"region":"Иркутская обл.","city":"Алзамай"},{"region":"Иркутская обл.","city":"Алыгжер"},{"region":"Иркутская обл.","city":"Ангарск"},{"region":"Иркутская обл.","city":"Артемовский"},{"region":"Иркутская обл.","city":"Атагай"},{"region":"Иркутская обл.","city":"Байкал"},{"region":"Иркутская обл.","city":"Байкальск"},{"region":"Иркутская обл.","city":"Балаганск"},{"region":"Иркутская обл.","city":"Баяндай"},{"region":"Иркутская обл.","city":"Бирюсинск"},{"region":"Иркутская обл.","city":"Бодайбо"},{"region":"Иркутская обл.","city":"Большая Речка"},{"region":"Иркутская обл.","city":"Большой Луг"},{"region":"Иркутская обл.","city":"Бохан"},{"region":"Иркутская обл.","city":"Братск"},{"region":"Иркутская обл.","city":"Видим"},{"region":"Иркутская обл.","city":"Витимский"},{"region":"Иркутская обл.","city":"Вихоревка"},{"region":"Иркутская обл.","city":"Еланцы"},{"region":"Иркутская обл.","city":"Ербогачен"},{"region":"Иркутская обл.","city":"Железногорск-Илимский"},{"region":"Иркутская обл.","city":"Жигалово"},{"region":"Иркутская обл.","city":"Забитуй"},{"region":"Иркутская обл.","city":"Залари"},{"region":"Иркутская обл.","city":"Звездный"},{"region":"Иркутская обл.","city":"Зима"},{"region":"Иркутская обл.","city":"Иркутск"},{"region":"Иркутская обл.","city":"Казачинское"},{"region":"Иркутская обл.","city":"Качуг"},{"region":"Иркутская обл.","city":"Квиток"},{"region":"Иркутская обл.","city":"Киренск"},{"region":"Иркутская обл.","city":"Куйтун"},{"region":"Иркутская обл.","city":"Култук"},{"region":"Иркутская обл.","city":"Кутулик"},{"region":"Иркутская обл.","city":"Мама"},{"region":"Иркутская обл.","city":"Нижнеудинск"},{"region":"Иркутская обл.","city":"Оса"},{"region":"Иркутская обл.","city":"Саянск"},{"region":"Иркутская обл.","city":"Слюдянка"},{"region":"Иркутская обл.","city":"Тайшет"},{"region":"Иркутская обл.","city":"Тулун"},{"region":"Иркутская обл.","city":"Усолье-Сибирское"},{"region":"Иркутская обл.","city":"Усть-Илимск"},{"region":"Иркутская обл.","city":"Усть-Кут"},{"region":"Иркутская обл.","city":"Усть-Ордынский"},{"region":"Иркутская обл.","city":"Усть-Уда"},{"region":"Иркутская обл.","city":"Черемхово"},{"region":"Иркутская обл.","city":"Чунский"},{"region":"Иркутская обл.","city":"Шелехов"},{"region":"Кабардино-Балкария","city":"Баксан"},{"region":"Кабардино-Балкария","city":"Майский"},{"region":"Кабардино-Балкария","city":"Нальчик"},{"region":"Кабардино-Балкария","city":"Нарткала"},{"region":"Кабардино-Балкария","city":"Прохладный"},{"region":"Кабардино-Балкария","city":"Советское"},{"region":"Кабардино-Балкария","city":"Терек"},{"region":"Кабардино-Балкария","city":"Тырныауз"},{"region":"Кабардино-Балкария","city":"Чегем-Первый"},{"region":"Калининградская обл.","city":"Багратионовск"},{"region":"Калининградская обл.","city":"Балтийск"},{"region":"Калининградская обл.","city":"Гвардейск"},{"region":"Калининградская обл.","city":"Гурьевск"},{"region":"Калининградская обл.","city":"Гусев"},{"region":"Калининградская обл.","city":"Железнодорожный"},{"region":"Калининградская обл.","city":"Зеленоградск"},{"region":"Калининградская обл.","city":"Знаменск"},{"region":"Калининградская обл.","city":"Кёнигсберг"},{"region":"Калининградская обл.","city":"Калининград"},{"region":"Калининградская обл.","city":"Кенисберг"},{"region":"Калининградская обл.","city":"Краснознаменск"},{"region":"Калининградская обл.","city":"Мамоново"},{"region":"Калининградская обл.","city":"Неман"},{"region":"Калининградская обл.","city":"Нестеров"},{"region":"Калининградская обл.","city":"Озерск"},{"region":"Калининградская обл.","city":"Полесск"},{"region":"Калининградская обл.","city":"Правдинск"},{"region":"Калининградская обл.","city":"Светлогорск"},{"region":"Калининградская обл.","city":"Светлый"},{"region":"Калининградская обл.","city":"Славск"},{"region":"Калининградская обл.","city":"Советск"},{"region":"Калининградская обл.","city":"Черняховск"},{"region":"Калмыкия","city":"Аршань"},{"region":"Калмыкия","city":"Каспийский"},{"region":"Калмыкия","city":"Комсомольский"},{"region":"Калмыкия","city":"Малые Дербеты"},{"region":"Калмыкия","city":"Приютное"},{"region":"Калмыкия","city":"Советское"},{"region":"Калмыкия","city":"Троицкое"},{"region":"Калмыкия","city":"Утта"},{"region":"Калмыкия","city":"Цаган-Аман"},{"region":"Калмыкия","city":"Элиста"},{"region":"Калмыкия","city":"Юста"},{"region":"Калмыкия","city":"Яшалта"},{"region":"Калмыкия","city":"Яшкуль"},{"region":"Калужская обл.","city":"Бабынино"},{"region":"Калужская обл.","city":"Балабаново"},{"region":"Калужская обл.","city":"Барятино"},{"region":"Калужская обл.","city":"Белоусово"},{"region":"Калужская обл.","city":"Бетлица"},{"region":"Калужская обл.","city":"Боровск"},{"region":"Калужская обл.","city":"Дугна"},{"region":"Калужская обл.","city":"Дудоровский"},{"region":"Калужская обл.","city":"Думиничи"},{"region":"Калужская обл.","city":"Еленский"},{"region":"Калужская обл.","city":"Жиздра"},{"region":"Калужская обл.","city":"Износки"},{"region":"Калужская обл.","city":"Калуга"},{"region":"Калужская обл.","city":"Киров"},{"region":"Калужская обл.","city":"Козельск"},{"region":"Калужская обл.","city":"Кондрово"},{"region":"Калужская обл.","city":"Людиново"},{"region":"Калужская обл.","city":"Малоярославец"},{"region":"Калужская обл.","city":"Медынь"},{"region":"Калужская обл.","city":"Мещовск"},{"region":"Калужская обл.","city":"Мосальск"},{"region":"Калужская обл.","city":"Обнинск"},{"region":"Калужская обл.","city":"Перемышль"},{"region":"Калужская обл.","city":"Спас-Деменск"},{"region":"Калужская обл.","city":"Сухиничи"},{"region":"Калужская обл.","city":"Таруса"},{"region":"Калужская обл.","city":"Ульяново"},{"region":"Калужская обл.","city":"Ферзиково"},{"region":"Калужская обл.","city":"Хвастовичи"},{"region":"Калужская обл.","city":"Юхнов"},{"region":"Камчатская обл.","city":"Атласово"},{"region":"Камчатская обл.","city":"Аянка"},{"region":"Камчатская обл.","city":"Большерецк"},{"region":"Камчатская обл.","city":"Вилючинск"},{"region":"Камчатская обл.","city":"Елизово"},{"region":"Камчатская обл.","city":"Ильпырский"},{"region":"Камчатская обл.","city":"Каменское"},{"region":"Камчатская обл.","city":"Кировский"},{"region":"Камчатская обл.","city":"Ключи"},{"region":"Камчатская обл.","city":"Крапивная"},{"region":"Камчатская обл.","city":"Мильково"},{"region":"Камчатская обл.","city":"Никольское"},{"region":"Камчатская обл.","city":"Озерновский"},{"region":"Камчатская обл.","city":"Оссора"},{"region":"Камчатская обл.","city":"Палана"},{"region":"Камчатская обл.","city":"Парень"},{"region":"Камчатская обл.","city":"Пахачи"},{"region":"Камчатская обл.","city":"Петропавловск-Камчатский"},{"region":"Камчатская обл.","city":"Тигиль"},{"region":"Камчатская обл.","city":"Тиличики"},{"region":"Камчатская обл.","city":"Усть-Большерецк"},{"region":"Камчатская обл.","city":"Усть-Камчатск"},{"region":"Карелия","city":"Амбарный"},{"region":"Карелия","city":"Беломорск"},{"region":"Карелия","city":"Валаам"},{"region":"Карелия","city":"Вирандозеро"},{"region":"Карелия","city":"Гирвас"},{"region":"Карелия","city":"Деревянка"},{"region":"Карелия","city":"Идель"},{"region":"Карелия","city":"Ильинский"},{"region":"Карелия","city":"Импалахти"},{"region":"Карелия","city":"Калевала"},{"region":"Карелия","city":"Кемь"},{"region":"Карелия","city":"Кестеньга"},{"region":"Карелия","city":"Кондопога"},{"region":"Карелия","city":"Костомукша"},{"region":"Карелия","city":"Лахденпохья"},{"region":"Карелия","city":"Лоухи"},{"region":"Карелия","city":"Медвежьегорск"},{"region":"Карелия","city":"Муезерский"},{"region":"Карелия","city":"Олонец"},{"region":"Карелия","city":"Петрозаводск"},{"region":"Карелия","city":"Питкяранта"},{"region":"Карелия","city":"Повенец"},{"region":"Карелия","city":"Пряжа"},{"region":"Карелия","city":"Пудож"},{"region":"Карелия","city":"Сегежа"},{"region":"Карелия","city":"Сортавала"},{"region":"Карелия","city":"Софпорог"},{"region":"Карелия","city":"Суоярви"},{"region":"Кемеровская обл.","city":"Анжеро-Судженск"},{"region":"Кемеровская обл.","city":"Барзас"},{"region":"Кемеровская обл.","city":"Белово"},{"region":"Кемеровская обл.","city":"Белогорск"},{"region":"Кемеровская обл.","city":"Березовский"},{"region":"Кемеровская обл.","city":"Грамотеино"},{"region":"Кемеровская обл.","city":"Гурьевск"},{"region":"Кемеровская обл.","city":"Ижморский"},{"region":"Кемеровская обл.","city":"Итатский"},{"region":"Кемеровская обл.","city":"Калтан"},{"region":"Кемеровская обл.","city":"Кедровка"},{"region":"Кемеровская обл.","city":"Кемерово"},{"region":"Кемеровская обл.","city":"Киселевск"},{"region":"Кемеровская обл.","city":"Крапивинский"},{"region":"Кемеровская обл.","city":"Ленинск-Кузнецкий"},{"region":"Кемеровская обл.","city":"Мариинск"},{"region":"Кемеровская обл.","city":"Междуреченск"},{"region":"Кемеровская обл.","city":"Мыски"},{"region":"Кемеровская обл.","city":"Новокузнецк"},{"region":"Кемеровская обл.","city":"Осинники"},{"region":"Кемеровская обл.","city":"Прокопьевск"},{"region":"Кемеровская обл.","city":"Промышленная"},{"region":"Кемеровская обл.","city":"Тайга"},{"region":"Кемеровская обл.","city":"Таштагол"},{"region":"Кемеровская обл.","city":"Тисуль"},{"region":"Кемеровская обл.","city":"Топки"},{"region":"Кемеровская обл.","city":"Тяжинский"},{"region":"Кемеровская обл.","city":"Юрга"},{"region":"Кемеровская обл.","city":"Яшкино"},{"region":"Кемеровская обл.","city":"Яя"},{"region":"Кировская обл.","city":"Арбаж"},{"region":"Кировская обл.","city":"Аркуль"},{"region":"Кировская обл.","city":"Белая Холуница"},{"region":"Кировская обл.","city":"Богородское"},{"region":"Кировская обл.","city":"Боровой"},{"region":"Кировская обл.","city":"Верхошижемье"},{"region":"Кировская обл.","city":"Вятские Поляны"},{"region":"Кировская обл.","city":"Зуевка"},{"region":"Кировская обл.","city":"Каринторф"},{"region":"Кировская обл.","city":"Кикнур"},{"region":"Кировская обл.","city":"Кильмезь"},{"region":"Кировская обл.","city":"Киров"},{"region":"Кировская обл.","city":"Кирово-Чепецк"},{"region":"Кировская обл.","city":"Кирс"},{"region":"Кировская обл.","city":"Кобра"},{"region":"Кировская обл.","city":"Котельнич"},{"region":"Кировская обл.","city":"Кумены"},{"region":"Кировская обл.","city":"Ленинское"},{"region":"Кировская обл.","city":"Луза"},{"region":"Кировская обл.","city":"Малмыж"},{"region":"Кировская обл.","city":"Мураши"},{"region":"Кировская обл.","city":"Нагорск"},{"region":"Кировская обл.","city":"Нема"},{"region":"Кировская обл.","city":"Нововятск"},{"region":"Кировская обл.","city":"Нолинск"},{"region":"Кировская обл.","city":"Омутнинск"},{"region":"Кировская обл.","city":"Опарино"},{"region":"Кировская обл.","city":"Оричи"},{"region":"Кировская обл.","city":"Пижанка"},{"region":"Кировская обл.","city":"Подосиновец"},{"region":"Кировская обл.","city":"Санчурск"},{"region":"Кировская обл.","city":"Свеча"},{"region":"Кировская обл.","city":"Слободской"},{"region":"Кировская обл.","city":"Советск"},{"region":"Кировская обл.","city":"Суна"},{"region":"Кировская обл.","city":"Тужа"},{"region":"Кировская обл.","city":"Уни"},{"region":"Кировская обл.","city":"Уржум"},{"region":"Кировская обл.","city":"Фаленки"},{"region":"Кировская обл.","city":"Халтурин"},{"region":"Кировская обл.","city":"Юрья"},{"region":"Кировская обл.","city":"Яранск"},{"region":"Коми","city":"Абезь"},{"region":"Коми","city":"Айкино"},{"region":"Коми","city":"Верхняя Инта"},{"region":"Коми","city":"Визинга"},{"region":"Коми","city":"Водный"},{"region":"Коми","city":"Вожаель"},{"region":"Коми","city":"Воркута"},{"region":"Коми","city":"Вуктыл"},{"region":"Коми","city":"Гешарт"},{"region":"Коми","city":"Елецкий"},{"region":"Коми","city":"Емва"},{"region":"Коми","city":"Заполярный"},{"region":"Коми","city":"Ижма"},{"region":"Коми","city":"Инта"},{"region":"Коми","city":"Ираель"},{"region":"Коми","city":"Каджером"},{"region":"Коми","city":"Кажым"},{"region":"Коми","city":"Кожым"},{"region":"Коми","city":"Койгородок"},{"region":"Коми","city":"Корткерос"},{"region":"Коми","city":"Кослан"},{"region":"Коми","city":"Объячево"},{"region":"Коми","city":"Печора"},{"region":"Коми","city":"Сосногорск"},{"region":"Коми","city":"Сыктывкар"},{"region":"Коми","city":"Троицко-Печерск"},{"region":"Коми","city":"Усинск"},{"region":"Коми","city":"Усогорск"},{"region":"Коми","city":"Усть-Кулом"},{"region":"Коми","city":"Усть-Цильма"},{"region":"Коми","city":"Ухта"},{"region":"Костромская обл.","city":"Антропово"},{"region":"Костромская обл.","city":"Боговарово"},{"region":"Костромская обл.","city":"Буй"},{"region":"Костромская обл.","city":"Волгореченск"},{"region":"Костромская обл.","city":"Галич"},{"region":"Костромская обл.","city":"Горчуха"},{"region":"Костромская обл.","city":"Зебляки"},{"region":"Костромская обл.","city":"Кадый"},{"region":"Костромская обл.","city":"Кологрив"},{"region":"Костромская обл.","city":"Кострома"},{"region":"Костромская обл.","city":"Красное-на-Волге"},{"region":"Костромская обл.","city":"Макарьев"},{"region":"Костромская обл.","city":"Мантурово"},{"region":"Костромская обл.","city":"Нерехта"},{"region":"Костромская обл.","city":"Нея"},{"region":"Костромская обл.","city":"Островское"},{"region":"Костромская обл.","city":"Павино"},{"region":"Костромская обл.","city":"Парфентьево"},{"region":"Костромская обл.","city":"Поназырево"},{"region":"Костромская обл.","city":"Солигалич"},{"region":"Костромская обл.","city":"Судиславль"},{"region":"Костромская обл.","city":"Сусанино"},{"region":"Костромская обл.","city":"Чухлома"},{"region":"Костромская обл.","city":"Шарья"},{"region":"Костромская обл.","city":"Шемятино"},{"region":"Краснодарский край","city":"Абинск"},{"region":"Краснодарский край","city":"Абрау-Дюрсо"},{"region":"Краснодарский край","city":"Анапа"},{"region":"Краснодарский край","city":"Апшеронск"},{"region":"Краснодарский край","city":"Армавир"},{"region":"Краснодарский край","city":"Архипо-Осиповка"},{"region":"Краснодарский край","city":"Афипский"},{"region":"Краснодарский край","city":"Ахтырский"},{"region":"Краснодарский край","city":"Ачуево"},{"region":"Краснодарский край","city":"Белореченск"},{"region":"Краснодарский край","city":"Верхнебаканский"},{"region":"Краснодарский край","city":"Выселки"},{"region":"Краснодарский край","city":"Геленджик"},{"region":"Краснодарский край","city":"Гиагинская"},{"region":"Краснодарский край","city":"Горячий Ключ"},{"region":"Краснодарский край","city":"Джубга"},{"region":"Краснодарский край","city":"Динская"},{"region":"Краснодарский край","city":"Ейск"},{"region":"Краснодарский край","city":"Ильский"},{"region":"Краснодарский край","city":"Кабардинка"},{"region":"Краснодарский край","city":"Калинино"},{"region":"Краснодарский край","city":"Калининская"},{"region":"Краснодарский край","city":"Каменномостский"},{"region":"Краснодарский край","city":"Каневская"},{"region":"Краснодарский край","city":"Кореновск"},{"region":"Краснодарский край","city":"Красноармейская"},{"region":"Краснодарский край","city":"Краснодар"},{"region":"Краснодарский край","city":"Кропоткин"},{"region":"Краснодарский край","city":"Крыловская"},{"region":"Краснодарский край","city":"Крымск"},{"region":"Краснодарский край","city":"Курганинск"},{"region":"Краснодарский край","city":"Кущевская"},{"region":"Краснодарский край","city":"Лабинск"},{"region":"Краснодарский край","city":"Лениградская"},{"region":"Краснодарский край","city":"Майкоп"},{"region":"Краснодарский край","city":"Мостовской"},{"region":"Краснодарский край","city":"Новороссийск"},{"region":"Краснодарский край","city":"Отрадная"},{"region":"Краснодарский край","city":"Павловская"},{"region":"Краснодарский край","city":"Приморско-Ахтарск"},{"region":"Краснодарский край","city":"Северская"},{"region":"Краснодарский край","city":"Славянск-на-Кубани"},{"region":"Краснодарский край","city":"Сочи"},{"region":"Краснодарский край","city":"Староминская"},{"region":"Краснодарский край","city":"Старощербиновская"},{"region":"Краснодарский край","city":"Тбилисская"},{"region":"Краснодарский край","city":"Темрюк"},{"region":"Краснодарский край","city":"Тимашевск"},{"region":"Краснодарский край","city":"Тихорецк"},{"region":"Краснодарский край","city":"Туапсе"},{"region":"Краснодарский край","city":"Тульский"},{"region":"Краснодарский край","city":"Усть-Лабинск"},{"region":"Краснодарский край","city":"Шовгеновский"},{"region":"Красноярский край","city":" Железногорск"},{"region":"Красноярский край","city":"Абаза"},{"region":"Красноярский край","city":"Абакан"},{"region":"Красноярский край","city":"Абан"},{"region":"Красноярский край","city":"Агинское"},{"region":"Красноярский край","city":"Артемовск"},{"region":"Красноярский край","city":"Аскиз"},{"region":"Красноярский край","city":"Ачинск"},{"region":"Красноярский край","city":"Байкит"},{"region":"Красноярский край","city":"Балахта"},{"region":"Красноярский край","city":"Балыкса"},{"region":"Красноярский край","city":"Белый Яр"},{"region":"Красноярский край","city":"Бельтырский"},{"region":"Красноярский край","city":"Бея"},{"region":"Красноярский край","city":"Бискамжа"},{"region":"Красноярский край","city":"Боготол"},{"region":"Красноярский край","city":"Боград"},{"region":"Красноярский край","city":"Богучаны"},{"region":"Красноярский край","city":"Большая Мурта"},{"region":"Красноярский край","city":"Большой Улуй"},{"region":"Красноярский край","city":"Бородино"},{"region":"Красноярский край","city":"Ванавара"},{"region":"Красноярский край","city":"Верхнеимбатск"},{"region":"Красноярский край","city":"Горячегорск"},{"region":"Красноярский край","city":"Дзержинское"},{"region":"Красноярский край","city":"Дивногорск"},{"region":"Красноярский край","city":"Диксон"},{"region":"Красноярский край","city":"Дудинка"},{"region":"Красноярский край","city":"Емельяново"},{"region":"Красноярский край","city":"Енисейск"},{"region":"Красноярский край","city":"Ермаковское"},{"region":"Красноярский край","city":"Заозерный"},{"region":"Красноярский край","city":"Зеленогорск"},{"region":"Красноярский край","city":"Игарка"},{"region":"Красноярский край","city":"Идринское"},{"region":"Красноярский край","city":"Иланский"},{"region":"Красноярский край","city":"Ирбейское"},{"region":"Красноярский край","city":"Казачинское"},{"region":"Красноярский край","city":"Канск"},{"region":"Красноярский край","city":"Каратузское"},{"region":"Красноярский край","city":"Караул"},{"region":"Красноярский край","city":"Кежма"},{"region":"Красноярский край","city":"Кодинск"},{"region":"Красноярский край","city":"Козулька"},{"region":"Красноярский край","city":"Копьево"},{"region":"Красноярский край","city":"Краснотуранск"},{"region":"Красноярский край","city":"Красноярск"},{"region":"Красноярский край","city":"Курагино"},{"region":"Красноярский край","city":"Лесосибирск"},{"region":"Красноярский край","city":"Минусинск"},{"region":"Красноярский край","city":"Мотыгино"},{"region":"Красноярский край","city":"Назарово"},{"region":"Красноярский край","city":"Нижний Ингаш"},{"region":"Красноярский край","city":"Новоселово"},{"region":"Красноярский край","city":"Норильск"},{"region":"Красноярский край","city":"Партизанское"},{"region":"Красноярский край","city":"Пировское"},{"region":"Красноярский край","city":"Саяногорск"},{"region":"Красноярский край","city":"Северо-Енисейский"},{"region":"Красноярский край","city":"Сосновоборск"},{"region":"Красноярский край","city":"Тасеево"},{"region":"Красноярский край","city":"Таштып"},{"region":"Красноярский край","city":"Тура"},{"region":"Красноярский край","city":"Туруханск"},{"region":"Красноярский край","city":"Тюхтет"},{"region":"Красноярский край","city":"Ужур"},{"region":"Красноярский край","city":"Усть-Авам"},{"region":"Красноярский край","city":"Уяр"},{"region":"Красноярский край","city":"Хатанга"},{"region":"Красноярский край","city":"Черемушки"},{"region":"Красноярский край","city":"Черногорск"},{"region":"Красноярский край","city":"Шалинское"},{"region":"Красноярский край","city":"Шарыпово"},{"region":"Красноярский край","city":"Шира"},{"region":"Красноярский край","city":"Шушенское"},{"region":"Курганская обл.","city":"Варгаши"},{"region":"Курганская обл.","city":"Глядянское"},{"region":"Курганская обл.","city":"Далматово"},{"region":"Курганская обл.","city":"Каргаполье"},{"region":"Курганская обл.","city":"Катайск"},{"region":"Курганская обл.","city":"Кетово"},{"region":"Курганская обл.","city":"Курган"},{"region":"Курганская обл.","city":"Куртамыш"},{"region":"Курганская обл.","city":"Лебяжье"},{"region":"Курганская обл.","city":"Макушино"},{"region":"Курганская обл.","city":"Мишкино"},{"region":"Курганская обл.","city":"Мокроусово"},{"region":"Курганская обл.","city":"Петухово"},{"region":"Курганская обл.","city":"Половинное"},{"region":"Курганская обл.","city":"Сафакулево"},{"region":"Курганская обл.","city":"Целинное"},{"region":"Курганская обл.","city":"Шадринск"},{"region":"Курганская обл.","city":"Шатрово"},{"region":"Курганская обл.","city":"Шумиха"},{"region":"Курганская обл.","city":"Щучье"},{"region":"Курганская обл.","city":"Юргамыш"},{"region":"Курская обл.","city":"Альменево"},{"region":"Курская обл.","city":"Белая"},{"region":"Курская обл.","city":"Большое Солдатское"},{"region":"Курская обл.","city":"Глушково"},{"region":"Курская обл.","city":"Горшечное"},{"region":"Курская обл.","city":"Дмитриев-Льговский"},{"region":"Курская обл.","city":"Железногорск"},{"region":"Курская обл.","city":"Золотухино"},{"region":"Курская обл.","city":"Касторное"},{"region":"Курская обл.","city":"Конышевка"},{"region":"Курская обл.","city":"Коренево"},{"region":"Курская обл.","city":"Курск"},{"region":"Курская обл.","city":"Курчатов"},{"region":"Курская обл.","city":"Кшенский"},{"region":"Курская обл.","city":"Льгов"},{"region":"Курская обл.","city":"Мантурово"},{"region":"Курская обл.","city":"Медвенка"},{"region":"Курская обл.","city":"Обоянь"},{"region":"Курская обл.","city":"Поныри"},{"region":"Курская обл.","city":"Пристень"},{"region":"Курская обл.","city":"Прямицыно"},{"region":"Курская обл.","city":"Рыльск"},{"region":"Курская обл.","city":"Суджа"},{"region":"Курская обл.","city":"Тим"},{"region":"Курская обл.","city":"Фатеж"},{"region":"Курская обл.","city":"Хомутовка"},{"region":"Курская обл.","city":"Черемисиново"},{"region":"Курская обл.","city":"Щигры"},{"region":"Липецкая обл.","city":"Грязи"},{"region":"Липецкая обл.","city":"Данхов"},{"region":"Липецкая обл.","city":"Доброе"},{"region":"Липецкая обл.","city":"Долгоруково"},{"region":"Липецкая обл.","city":"Елец"},{"region":"Липецкая обл.","city":"Задонск"},{"region":"Липецкая обл.","city":"Измалково"},{"region":"Липецкая обл.","city":"Казинка"},{"region":"Липецкая обл.","city":"Лебедянь"},{"region":"Липецкая обл.","city":"Лев Толстой"},{"region":"Липецкая обл.","city":"Липецк"},{"region":"Липецкая обл.","city":"Тербуны"},{"region":"Липецкая обл.","city":"Усмань"},{"region":"Липецкая обл.","city":"Хлевное"},{"region":"Липецкая обл.","city":"Чаплыгин"},{"region":"Магаданская обл.","city":"Анадырь"},{"region":"Магаданская обл.","city":"Атка"},{"region":"Магаданская обл.","city":"Балыгычан"},{"region":"Магаданская обл.","city":"Беринговский"},{"region":"Магаданская обл.","city":"Билибино"},{"region":"Магаданская обл.","city":"Большевик"},{"region":"Магаданская обл.","city":"Ванкарем"},{"region":"Магаданская обл.","city":"Иульитин"},{"region":"Магаданская обл.","city":"Кадыкчан"},{"region":"Магаданская обл.","city":"Лаврентия"},{"region":"Магаданская обл.","city":"Магадан"},{"region":"Магаданская обл.","city":"Мыс Шмидта"},{"region":"Магаданская обл.","city":"Ола"},{"region":"Магаданская обл.","city":"Омонск"},{"region":"Магаданская обл.","city":"Омсукчан"},{"region":"Магаданская обл.","city":"Палатка"},{"region":"Магаданская обл.","city":"Певек"},{"region":"Магаданская обл.","city":"Провидения"},{"region":"Магаданская обл.","city":"Сеймчан"},{"region":"Магаданская обл.","city":"Синегорье"},{"region":"Магаданская обл.","city":"Сусуман"},{"region":"Магаданская обл.","city":"Усть-Белая"},{"region":"Магаданская обл.","city":"Усть-Омчуг"},{"region":"Магаданская обл.","city":"Эвенск"},{"region":"Магаданская обл.","city":"Эгвекинот"},{"region":"Магаданская обл.","city":"Ягодное"},{"region":"Марий Эл","city":"Волжск"},{"region":"Марий Эл","city":"Дубовский"},{"region":"Марий Эл","city":"Звенигово"},{"region":"Марий Эл","city":"Йошкар-Ола"},{"region":"Марий Эл","city":"Килемары"},{"region":"Марий Эл","city":"Козьмодемьянск"},{"region":"Марий Эл","city":"Куженер"},{"region":"Марий Эл","city":"Мари-Турек"},{"region":"Марий Эл","city":"Медведево"},{"region":"Марий Эл","city":"Морки"},{"region":"Марий Эл","city":"Новый Торьял"},{"region":"Марий Эл","city":"Оршанка"},{"region":"Марий Эл","city":"Параньга"},{"region":"Марий Эл","city":"Сернур"},{"region":"Марий Эл","city":"Советский"},{"region":"Марий Эл","city":"Юрино"},{"region":"Мордовия","city":"Ардатов"},{"region":"Мордовия","city":"Атюрьево"},{"region":"Мордовия","city":"Атяшево"},{"region":"Мордовия","city":"Большие Березники"},{"region":"Мордовия","city":"Большое Игнатово"},{"region":"Мордовия","city":"Выша"},{"region":"Мордовия","city":"Ельники"},{"region":"Мордовия","city":"Зубова Поляна"},{"region":"Мордовия","city":"Инсар"},{"region":"Мордовия","city":"Кадошкино"},{"region":"Мордовия","city":"Кемля"},{"region":"Мордовия","city":"Ковылкино"},{"region":"Мордовия","city":"Комсомольский"},{"region":"Мордовия","city":"Кочкурово"},{"region":"Мордовия","city":"Краснослободск"},{"region":"Мордовия","city":"Лямбирь"},{"region":"Мордовия","city":"Ромоданово"},{"region":"Мордовия","city":"Рузаевка"},{"region":"Мордовия","city":"Саранск"},{"region":"Мордовия","city":"Старое Шайгово"},{"region":"Мордовия","city":"Темников"},{"region":"Мордовия","city":"Теньгушево"},{"region":"Мордовия","city":"Торбеево"},{"region":"Мордовия","city":"Чамзинка"},{"region":"Мурманская обл.","city":"Апатиты"},{"region":"Мурманская обл.","city":"Африканда"},{"region":"Мурманская обл.","city":"Верхнетуломский"},{"region":"Мурманская обл.","city":"Заозерск"},{"region":"Мурманская обл.","city":"Заполярный"},{"region":"Мурманская обл.","city":"Зареченск"},{"region":"Мурманская обл.","city":"Зашеек"},{"region":"Мурманская обл.","city":"Зеленоборский"},{"region":"Мурманская обл.","city":"Кандалакша"},{"region":"Мурманская обл.","city":"Кильдинстрой"},{"region":"Мурманская обл.","city":"Кировск"},{"region":"Мурманская обл.","city":"Ковдор"},{"region":"Мурманская обл.","city":"Кола"},{"region":"Мурманская обл.","city":"Конда"},{"region":"Мурманская обл.","city":"Мончегорск"},{"region":"Мурманская обл.","city":"Мурманск"},{"region":"Мурманская обл.","city":"Мурмаши"},{"region":"Мурманская обл.","city":"Никель"},{"region":"Мурманская обл.","city":"Оленегорск"},{"region":"Мурманская обл.","city":"Полярные Зори"},{"region":"Мурманская обл.","city":"Полярный"},{"region":"Мурманская обл.","city":"Североморск"},{"region":"Мурманская обл.","city":"Снежногорск"},{"region":"Мурманская обл.","city":"Умба"},{"region":"Нижегородская (Горьковская)","city":"Ардатов"},{"region":"Нижегородская (Горьковская)","city":"Арзамас"},{"region":"Нижегородская (Горьковская)","city":"Арья"},{"region":"Нижегородская (Горьковская)","city":"Балахна"},{"region":"Нижегородская (Горьковская)","city":"Богородск"},{"region":"Нижегородская (Горьковская)","city":"Большереченск"},{"region":"Нижегородская (Горьковская)","city":"Большое Болдино"},{"region":"Нижегородская (Горьковская)","city":"Большое Козино"},{"region":"Нижегородская (Горьковская)","city":"Большое Мурашкино"},{"region":"Нижегородская (Горьковская)","city":"Большое Пикино"},{"region":"Нижегородская (Горьковская)","city":"Бор"},{"region":"Нижегородская (Горьковская)","city":"Бутурлино"},{"region":"Нижегородская (Горьковская)","city":"Вад"},{"region":"Нижегородская (Горьковская)","city":"Варнавино"},{"region":"Нижегородская (Горьковская)","city":"Васильсурск"},{"region":"Нижегородская (Горьковская)","city":"Вахтан"},{"region":"Нижегородская (Горьковская)","city":"Вача"},{"region":"Нижегородская (Горьковская)","city":"Велетьма"},{"region":"Нижегородская (Горьковская)","city":"Ветлуга"},{"region":"Нижегородская (Горьковская)","city":"Виля"},{"region":"Нижегородская (Горьковская)","city":"Вознесенское"},{"region":"Нижегородская (Горьковская)","city":"Володарск"},{"region":"Нижегородская (Горьковская)","city":"Воротынец"},{"region":"Нижегородская (Горьковская)","city":"Ворсма"},{"region":"Нижегородская (Горьковская)","city":"Воскресенское"},{"region":"Нижегородская (Горьковская)","city":"Выездное"},{"region":"Нижегородская (Горьковская)","city":"Выкса"},{"region":"Нижегородская (Горьковская)","city":"Гагино"},{"region":"Нижегородская (Горьковская)","city":"Гидроторф"},{"region":"Нижегородская (Горьковская)","city":"Горбатов"},{"region":"Нижегородская (Горьковская)","city":"Горбатовка"},{"region":"Нижегородская (Горьковская)","city":"Городец"},{"region":"Нижегородская (Горьковская)","city":"Горький"},{"region":"Нижегородская (Горьковская)","city":"Дальнее Константиново"},{"region":"Нижегородская (Горьковская)","city":"Дзержинск"},{"region":"Нижегородская (Горьковская)","city":"Дивеево"},{"region":"Нижегородская (Горьковская)","city":"Досчатое"},{"region":"Нижегородская (Горьковская)","city":"Заволжье"},{"region":"Нижегородская (Горьковская)","city":"Катунки"},{"region":"Нижегородская (Горьковская)","city":"Керженец"},{"region":"Нижегородская (Горьковская)","city":"Княгинино"},{"region":"Нижегородская (Горьковская)","city":"Ковернино"},{"region":"Нижегородская (Горьковская)","city":"Красные Баки"},{"region":"Нижегородская (Горьковская)","city":"Кстово"},{"region":"Нижегородская (Горьковская)","city":"Кулебаки"},{"region":"Нижегородская (Горьковская)","city":"Лукоянов"},{"region":"Нижегородская (Горьковская)","city":"Лысково"},{"region":"Нижегородская (Горьковская)","city":"Навашино"},{"region":"Нижегородская (Горьковская)","city":"Нижний Новгород"},{"region":"Нижегородская (Горьковская)","city":"Павлово"},{"region":"Нижегородская (Горьковская)","city":"Первомайск"},{"region":"Нижегородская (Горьковская)","city":"Перевоз"},{"region":"Нижегородская (Горьковская)","city":"Пильна"},{"region":"Нижегородская (Горьковская)","city":"Починки"},{"region":"Нижегородская (Горьковская)","city":"Саров"},{"region":"Нижегородская (Горьковская)","city":"Сергач"},{"region":"Нижегородская (Горьковская)","city":"Сеченово"},{"region":"Нижегородская (Горьковская)","city":"Сосновское"},{"region":"Нижегородская (Горьковская)","city":"Спасское"},{"region":"Нижегородская (Горьковская)","city":"Тонкино"},{"region":"Нижегородская (Горьковская)","city":"Тоншаево"},{"region":"Нижегородская (Горьковская)","city":"Уразовка"},{"region":"Нижегородская (Горьковская)","city":"Урень"},{"region":"Нижегородская (Горьковская)","city":"Чкаловск"},{"region":"Нижегородская (Горьковская)","city":"Шаранга"},{"region":"Нижегородская (Горьковская)","city":"Шатки"},{"region":"Нижегородская (Горьковская)","city":"Шахунья"},{"region":"Новгородская обл.","city":"Анциферово"},{"region":"Новгородская обл.","city":"Батецкий"},{"region":"Новгородская обл.","city":"Большая Вишера"},{"region":"Новгородская обл.","city":"Боровичи"},{"region":"Новгородская обл.","city":"Валдай"},{"region":"Новгородская обл.","city":"Волот"},{"region":"Новгородская обл.","city":"Деманск"},{"region":"Новгородская обл.","city":"Зарубино"},{"region":"Новгородская обл.","city":"Кресцы"},{"region":"Новгородская обл.","city":"Любытино"},{"region":"Новгородская обл.","city":"Малая Вишера"},{"region":"Новгородская обл.","city":"Марево"},{"region":"Новгородская обл.","city":"Мошенское"},{"region":"Новгородская обл.","city":"Новгород"},{"region":"Новгородская обл.","city":"Окуловка"},{"region":"Новгородская обл.","city":"Парфино"},{"region":"Новгородская обл.","city":"Пестово"},{"region":"Новгородская обл.","city":"Поддорье"},{"region":"Новгородская обл.","city":"Сольцы"},{"region":"Новгородская обл.","city":"Старая Русса"},{"region":"Новгородская обл.","city":"Хвойное"},{"region":"Новгородская обл.","city":"Холм"},{"region":"Новгородская обл.","city":"Чудово"},{"region":"Новгородская обл.","city":"Шимск"},{"region":"Новосибирская обл.","city":"Баган"},{"region":"Новосибирская обл.","city":"Барабинск"},{"region":"Новосибирская обл.","city":"Бердск"},{"region":"Новосибирская обл.","city":"Биаза"},{"region":"Новосибирская обл.","city":"Болотное"},{"region":"Новосибирская обл.","city":"Венгерово"},{"region":"Новосибирская обл.","city":"Довольное"},{"region":"Новосибирская обл.","city":"Завьялово"},{"region":"Новосибирская обл.","city":"Искитим"},{"region":"Новосибирская обл.","city":"Карасук"},{"region":"Новосибирская обл.","city":"Каргат"},{"region":"Новосибирская обл.","city":"Колывань"},{"region":"Новосибирская обл.","city":"Краснозерское"},{"region":"Новосибирская обл.","city":"Крутиха"},{"region":"Новосибирская обл.","city":"Куйбышев"},{"region":"Новосибирская обл.","city":"Купино"},{"region":"Новосибирская обл.","city":"Кыштовка"},{"region":"Новосибирская обл.","city":"Маслянино"},{"region":"Новосибирская обл.","city":"Михайловский"},{"region":"Новосибирская обл.","city":"Мошково"},{"region":"Новосибирская обл.","city":"Новосибирск"},{"region":"Новосибирская обл.","city":"Ордынское"},{"region":"Новосибирская обл.","city":"Северное"},{"region":"Новосибирская обл.","city":"Сузун"},{"region":"Новосибирская обл.","city":"Татарск"},{"region":"Новосибирская обл.","city":"Тогучин"},{"region":"Новосибирская обл.","city":"Убинское"},{"region":"Новосибирская обл.","city":"Усть-Тарка"},{"region":"Новосибирская обл.","city":"Чаны"},{"region":"Новосибирская обл.","city":"Черепаново"},{"region":"Новосибирская обл.","city":"Чистоозерное"},{"region":"Новосибирская обл.","city":"Чулым"},{"region":"Омская обл.","city":"Береговой"},{"region":"Омская обл.","city":"Большеречье"},{"region":"Омская обл.","city":"Большие Уки"},{"region":"Омская обл.","city":"Горьковское"},{"region":"Омская обл.","city":"Знаменское"},{"region":"Омская обл.","city":"Исилькуль"},{"region":"Омская обл.","city":"Калачинск"},{"region":"Омская обл.","city":"Колосовка"},{"region":"Омская обл.","city":"Кормиловка"},{"region":"Омская обл.","city":"Крутинка"},{"region":"Омская обл.","city":"Любинский"},{"region":"Омская обл.","city":"Марьяновка"},{"region":"Омская обл.","city":"Муромцево"},{"region":"Омская обл.","city":"Называевск"},{"region":"Омская обл.","city":"Нижняя Омка"},{"region":"Омская обл.","city":"Нововаршавка"},{"region":"Омская обл.","city":"Одесское"},{"region":"Омская обл.","city":"Оконешниково"},{"region":"Омская обл.","city":"Омск"},{"region":"Омская обл.","city":"Павлоградка"},{"region":"Омская обл.","city":"Полтавка"},{"region":"Омская обл.","city":"Русская Поляна"},{"region":"Омская обл.","city":"Саргатское"},{"region":"Омская обл.","city":"Седельниково"},{"region":"Омская обл.","city":"Таврическое"},{"region":"Омская обл.","city":"Тара"},{"region":"Омская обл.","city":"Тевриз"},{"region":"Омская обл.","city":"Тюкалинск"},{"region":"Омская обл.","city":"Усть-Ишим"},{"region":"Омская обл.","city":"Черлак"},{"region":"Омская обл.","city":"Шербакуль"},{"region":"Оренбургская обл.","city":"Абдулино"},{"region":"Оренбургская обл.","city":"Адамовка"},{"region":"Оренбургская обл.","city":"Айдырлинский"},{"region":"Оренбургская обл.","city":"Акбулак"},{"region":"Оренбургская обл.","city":"Аккермановка"},{"region":"Оренбургская обл.","city":"Асекеево"},{"region":"Оренбургская обл.","city":"Беляевка"},{"region":"Оренбургская обл.","city":"Бугуруслан"},{"region":"Оренбургская обл.","city":"Бузулук"},{"region":"Оренбургская обл.","city":"Гай"},{"region":"Оренбургская обл.","city":"Грачевка"},{"region":"Оренбургская обл.","city":"Домбаровский"},{"region":"Оренбургская обл.","city":"Дубенский"},{"region":"Оренбургская обл.","city":"Илек"},{"region":"Оренбургская обл.","city":"Ириклинский"},{"region":"Оренбургская обл.","city":"Кувандык"},{"region":"Оренбургская обл.","city":"Курманаевка"},{"region":"Оренбургская обл.","city":"Матвеевка"},{"region":"Оренбургская обл.","city":"Медногорск"},{"region":"Оренбургская обл.","city":"Новоорск"},{"region":"Оренбургская обл.","city":"Новосергиевка"},{"region":"Оренбургская обл.","city":"Новотроицк"},{"region":"Оренбургская обл.","city":"Октябрьское"},{"region":"Оренбургская обл.","city":"Оренбург"},{"region":"Оренбургская обл.","city":"Орск"},{"region":"Оренбургская обл.","city":"Первомайский"},{"region":"Оренбургская обл.","city":"Переволоцкий"},{"region":"Оренбургская обл.","city":"Пономаревка"},{"region":"Оренбургская обл.","city":"Саракташ"},{"region":"Оренбургская обл.","city":"Светлый"},{"region":"Оренбургская обл.","city":"Северное"},{"region":"Оренбургская обл.","city":"Соль-Илецк"},{"region":"Оренбургская обл.","city":"Сорочинск"},{"region":"Оренбургская обл.","city":"Ташла"},{"region":"Оренбургская обл.","city":"Тоцкое"},{"region":"Оренбургская обл.","city":"Тюльган"},{"region":"Оренбургская обл.","city":"Шарлык"},{"region":"Оренбургская обл.","city":"Энергетик"},{"region":"Оренбургская обл.","city":"Ясный"},{"region":"Орловская обл.","city":"Болхов"},{"region":"Орловская обл.","city":"Верховье"},{"region":"Орловская обл.","city":"Глазуновка"},{"region":"Орловская обл.","city":"Дмитровск-Орловский"},{"region":"Орловская обл.","city":"Долгое"},{"region":"Орловская обл.","city":"Залегощь"},{"region":"Орловская обл.","city":"Змиевка"},{"region":"Орловская обл.","city":"Знаменское"},{"region":"Орловская обл.","city":"Колпны"},{"region":"Орловская обл.","city":"Красная Заря"},{"region":"Орловская обл.","city":"Кромы"},{"region":"Орловская обл.","city":"Ливны"},{"region":"Орловская обл.","city":"Малоархангельск"},{"region":"Орловская обл.","city":"Мценск"},{"region":"Орловская обл.","city":"Нарышкино"},{"region":"Орловская обл.","city":"Новосиль"},{"region":"Орловская обл.","city":"Орел"},{"region":"Орловская обл.","city":"Покровское"},{"region":"Орловская обл.","city":"Сосково"},{"region":"Орловская обл.","city":"Тросна"},{"region":"Орловская обл.","city":"Хомутово"},{"region":"Орловская обл.","city":"Хотынец"},{"region":"Орловская обл.","city":"Шаблыкино"},{"region":"Пензенская обл.","city":"Башмаково"},{"region":"Пензенская обл.","city":"Беднодемьяновск"},{"region":"Пензенская обл.","city":"Беково"},{"region":"Пензенская обл.","city":"Белинский"},{"region":"Пензенская обл.","city":"Бессоновка"},{"region":"Пензенская обл.","city":"Вадинск"},{"region":"Пензенская обл.","city":"Верхозим"},{"region":"Пензенская обл.","city":"Городище"},{"region":"Пензенская обл.","city":"Евлашево"},{"region":"Пензенская обл.","city":"Земетчино"},{"region":"Пензенская обл.","city":"Золотаревка"},{"region":"Пензенская обл.","city":"Исса"},{"region":"Пензенская обл.","city":"Каменка"},{"region":"Пензенская обл.","city":"Колышлей"},{"region":"Пензенская обл.","city":"Кондоль"},{"region":"Пензенская обл.","city":"Кузнецк"},{"region":"Пензенская обл.","city":"Лопатино"},{"region":"Пензенская обл.","city":"Малая Сердоба"},{"region":"Пензенская обл.","city":"Мокшан"},{"region":"Пензенская обл.","city":"Наровчат"},{"region":"Пензенская обл.","city":"Неверкино"},{"region":"Пензенская обл.","city":"Нижний Ломов"},{"region":"Пензенская обл.","city":"Никольск"},{"region":"Пензенская обл.","city":"Пачелма"},{"region":"Пензенская обл.","city":"Пенза"},{"region":"Пензенская обл.","city":"Русский Камешкир"},{"region":"Пензенская обл.","city":"Сердобск"},{"region":"Пензенская обл.","city":"Сосновоборск"},{"region":"Пензенская обл.","city":"Сура"},{"region":"Пензенская обл.","city":"Тамала"},{"region":"Пензенская обл.","city":"Шемышейка"},{"region":"Пермская обл.","city":"Барда"},{"region":"Пермская обл.","city":"Березники"},{"region":"Пермская обл.","city":"Большая Соснова"},{"region":"Пермская обл.","city":"Верещагино"},{"region":"Пермская обл.","city":"Гайны"},{"region":"Пермская обл.","city":"Горнозаводск"},{"region":"Пермская обл.","city":"Гремячинск"},{"region":"Пермская обл.","city":"Губаха"},{"region":"Пермская обл.","city":"Добрянка"},{"region":"Пермская обл.","city":"Елово"},{"region":"Пермская обл.","city":"Зюкайка"},{"region":"Пермская обл.","city":"Ильинский"},{"region":"Пермская обл.","city":"Карагай"},{"region":"Пермская обл.","city":"Керчевский"},{"region":"Пермская обл.","city":"Кизел"},{"region":"Пермская обл.","city":"Коса"},{"region":"Пермская обл.","city":"Кочево"},{"region":"Пермская обл.","city":"Красновишерск"},{"region":"Пермская обл.","city":"Краснокамск"},{"region":"Пермская обл.","city":"Кудымкар"},{"region":"Пермская обл.","city":"Куеда"},{"region":"Пермская обл.","city":"Кунгур"},{"region":"Пермская обл.","city":"Лысьва"},{"region":"Пермская обл.","city":"Ныроб"},{"region":"Пермская обл.","city":"Нытва"},{"region":"Пермская обл.","city":"Октябрьский"},{"region":"Пермская обл.","city":"Орда"},{"region":"Пермская обл.","city":"Оса"},{"region":"Пермская обл.","city":"Оханск"},{"region":"Пермская обл.","city":"Очер"},{"region":"Пермская обл.","city":"Пермь"},{"region":"Пермская обл.","city":"Соликамск"},{"region":"Пермская обл.","city":"Суксун"},{"region":"Пермская обл.","city":"Уинское"},{"region":"Пермская обл.","city":"Усолье"},{"region":"Пермская обл.","city":"Усть-Кишерть"},{"region":"Пермская обл.","city":"Чайковский"},{"region":"Пермская обл.","city":"Частые"},{"region":"Пермская обл.","city":"Чердынь"},{"region":"Пермская обл.","city":"Чернореченский"},{"region":"Пермская обл.","city":"Чернушка"},{"region":"Пермская обл.","city":"Чусовой"},{"region":"Пермская обл.","city":"Юрла"},{"region":"Пермская обл.","city":"Юсьва"},{"region":"Приморский край","city":"Анучино"},{"region":"Приморский край","city":"Арсеньев"},{"region":"Приморский край","city":"Артем"},{"region":"Приморский край","city":"Артемовский"},{"region":"Приморский край","city":"Большой Камень"},{"region":"Приморский край","city":"Валентин"},{"region":"Приморский край","city":"Владивосток"},{"region":"Приморский край","city":"Высокогорск"},{"region":"Приморский край","city":"Горные Ключи"},{"region":"Приморский край","city":"Горный"},{"region":"Приморский край","city":"Дальнегорск"},{"region":"Приморский край","city":"Дальнереченск"},{"region":"Приморский край","city":"Зарубино"},{"region":"Приморский край","city":"Кавалерово"},{"region":"Приморский край","city":"Каменка"},{"region":"Приморский край","city":"Камень-Рыболов"},{"region":"Приморский край","city":"Кировский"},{"region":"Приморский край","city":"Лазо"},{"region":"Приморский край","city":"Лесозаводск"},{"region":"Приморский край","city":"Лучегорск"},{"region":"Приморский край","city":"Михайловка"},{"region":"Приморский край","city":"Находка"},{"region":"Приморский край","city":"Новопокровка"},{"region":"Приморский край","city":"Ольга"},{"region":"Приморский край","city":"Партизанск"},{"region":"Приморский край","city":"Пограничный"},{"region":"Приморский край","city":"Покровка"},{"region":"Приморский край","city":"Русский"},{"region":"Приморский край","city":"Самарга"},{"region":"Приморский край","city":"Славянка"},{"region":"Приморский край","city":"Спасск-Дальний"},{"region":"Приморский край","city":"Терней"},{"region":"Приморский край","city":"Уссурийск"},{"region":"Приморский край","city":"Фокино"},{"region":"Приморский край","city":"Хасан"},{"region":"Приморский край","city":"Хороль"},{"region":"Приморский край","city":"Черниговка"},{"region":"Приморский край","city":"Чугуевка"},{"region":"Приморский край","city":"Яковлевка"},{"region":"Псковская обл.","city":"Бежаницы"},{"region":"Псковская обл.","city":"Великие Луки"},{"region":"Псковская обл.","city":"Гдов"},{"region":"Псковская обл.","city":"Дедовичи"},{"region":"Псковская обл.","city":"Дно"},{"region":"Псковская обл.","city":"Заплюсье"},{"region":"Псковская обл.","city":"Идрица"},{"region":"Псковская обл.","city":"Красногородское"},{"region":"Псковская обл.","city":"Кунья"},{"region":"Псковская обл.","city":"Локня"},{"region":"Псковская обл.","city":"Невель"},{"region":"Псковская обл.","city":"Новоржев"},{"region":"Псковская обл.","city":"Новосокольники"},{"region":"Псковская обл.","city":"Опочка"},{"region":"Псковская обл.","city":"Остров"},{"region":"Псковская обл.","city":"Палкино"},{"region":"Псковская обл.","city":"Печоры"},{"region":"Псковская обл.","city":"Плюсса"},{"region":"Псковская обл.","city":"Порхов"},{"region":"Псковская обл.","city":"Псков"},{"region":"Псковская обл.","city":"Пустошка"},{"region":"Псковская обл.","city":"Пушкинские Горы"},{"region":"Псковская обл.","city":"Пыталово"},{"region":"Псковская обл.","city":"Себеж"},{"region":"Псковская обл.","city":"Струги-Красные"},{"region":"Псковская обл.","city":"Усвяты"},{"region":"Ростовская обл.","city":"Азов"},{"region":"Ростовская обл.","city":"Аксай"},{"region":"Ростовская обл.","city":"Алмазный"},{"region":"Ростовская обл.","city":"Аютинск"},{"region":"Ростовская обл.","city":"Багаевский"},{"region":"Ростовская обл.","city":"Батайск"},{"region":"Ростовская обл.","city":"Белая Калитва"},{"region":"Ростовская обл.","city":"Боковская"},{"region":"Ростовская обл.","city":"Большая Мартыновка"},{"region":"Ростовская обл.","city":"Вешенская"},{"region":"Ростовская обл.","city":"Волгодонск"},{"region":"Ростовская обл.","city":"Восход"},{"region":"Ростовская обл.","city":"Гигант"},{"region":"Ростовская обл.","city":"Горняцкий"},{"region":"Ростовская обл.","city":"Гуково"},{"region":"Ростовская обл.","city":"Донецк"},{"region":"Ростовская обл.","city":"Донской"},{"region":"Ростовская обл.","city":"Дубовское"},{"region":"Ростовская обл.","city":"Егорлыкская"},{"region":"Ростовская обл.","city":"Жирнов"},{"region":"Ростовская обл.","city":"Заветное"},{"region":"Ростовская обл.","city":"Заводской"},{"region":"Ростовская обл.","city":"Зверево"},{"region":"Ростовская обл.","city":"Зерноград"},{"region":"Ростовская обл.","city":"Зимовники"},{"region":"Ростовская обл.","city":"Кагальницкая"},{"region":"Ростовская обл.","city":"Казанская"},{"region":"Ростовская обл.","city":"Каменоломни"},{"region":"Ростовская обл.","city":"Каменск-Шахтинский"},{"region":"Ростовская обл.","city":"Кашары"},{"region":"Ростовская обл.","city":"Коксовый"},{"region":"Ростовская обл.","city":"Константиновск"},{"region":"Ростовская обл.","city":"Красный Сулин"},{"region":"Ростовская обл.","city":"Куйбышево"},{"region":"Ростовская обл.","city":"Матвеев Курган"},{"region":"Ростовская обл.","city":"Мигулинская"},{"region":"Ростовская обл.","city":"Миллерово"},{"region":"Ростовская обл.","city":"Милютинская"},{"region":"Ростовская обл.","city":"Морозовск"},{"region":"Ростовская обл.","city":"Новочеркасск"},{"region":"Ростовская обл.","city":"Новошахтинск"},{"region":"Ростовская обл.","city":"Обливская"},{"region":"Ростовская обл.","city":"Орловский"},{"region":"Ростовская обл.","city":"Песчанокопское"},{"region":"Ростовская обл.","city":"Покровское"},{"region":"Ростовская обл.","city":"Пролетарск"},{"region":"Ростовская обл.","city":"Ремонтное"},{"region":"Ростовская обл.","city":"Родионово-Несветайская"},{"region":"Ростовская обл.","city":"Ростов-на-Дону"},{"region":"Ростовская обл.","city":"Сальск"},{"region":"Ростовская обл.","city":"Семикаракорск"},{"region":"Ростовская обл.","city":"Таганрог"},{"region":"Ростовская обл.","city":"Тарасовский"},{"region":"Ростовская обл.","city":"Тацинский"},{"region":"Ростовская обл.","city":"Усть-Донецкий"},{"region":"Ростовская обл.","city":"Целина"},{"region":"Ростовская обл.","city":"Цимлянск"},{"region":"Ростовская обл.","city":"Чалтырь"},{"region":"Ростовская обл.","city":"Чертково"},{"region":"Ростовская обл.","city":"Шахты"},{"region":"Ростовская обл.","city":"Шолоховский"},{"region":"Рязанская обл.","city":"Александро-Невский"},{"region":"Рязанская обл.","city":"Горняк"},{"region":"Рязанская обл.","city":"Гусь Железный"},{"region":"Рязанская обл.","city":"Елатьма"},{"region":"Рязанская обл.","city":"Ермишь"},{"region":"Рязанская обл.","city":"Заречный"},{"region":"Рязанская обл.","city":"Захарово"},{"region":"Рязанская обл.","city":"Кадом"},{"region":"Рязанская обл.","city":"Касимов"},{"region":"Рязанская обл.","city":"Кораблино"},{"region":"Рязанская обл.","city":"Милославское"},{"region":"Рязанская обл.","city":"Михайлов"},{"region":"Рязанская обл.","city":"Пителино"},{"region":"Рязанская обл.","city":"Пронск"},{"region":"Рязанская обл.","city":"Путятино"},{"region":"Рязанская обл.","city":"Рыбное"},{"region":"Рязанская обл.","city":"Ряжск"},{"region":"Рязанская обл.","city":"Рязань"},{"region":"Рязанская обл.","city":"Сапожок"},{"region":"Рязанская обл.","city":"Сараи"},{"region":"Рязанская обл.","city":"Сасово"},{"region":"Рязанская обл.","city":"Скопин"},{"region":"Рязанская обл.","city":"Спас-Клепики"},{"region":"Рязанская обл.","city":"Спасск-Рязанский"},{"region":"Рязанская обл.","city":"Старожилово"},{"region":"Рязанская обл.","city":"Ухолово"},{"region":"Рязанская обл.","city":"Чучково"},{"region":"Рязанская обл.","city":"Шацк"},{"region":"Рязанская обл.","city":"Шилово"},{"region":"Самарская обл.","city":"Алексеевка"},{"region":"Самарская обл.","city":"Безенчук"},{"region":"Самарская обл.","city":"Богатое"},{"region":"Самарская обл.","city":"Богатырь"},{"region":"Самарская обл.","city":"Большая Глущица"},{"region":"Самарская обл.","city":"Большая Черниговка"},{"region":"Самарская обл.","city":"Борское"},{"region":"Самарская обл.","city":"Волжский"},{"region":"Самарская обл.","city":"Жигулевск"},{"region":"Самарская обл.","city":"Зольное"},{"region":"Самарская обл.","city":"Исаклы"},{"region":"Самарская обл.","city":"Камышла"},{"region":"Самарская обл.","city":"Кинель"},{"region":"Самарская обл.","city":"Кинель-Черкасы"},{"region":"Самарская обл.","city":"Клявлино"},{"region":"Самарская обл.","city":"Кошки"},{"region":"Самарская обл.","city":"Красноармейское"},{"region":"Самарская обл.","city":"Красный Яр"},{"region":"Самарская обл.","city":"Куйбышев"},{"region":"Самарская обл.","city":"Нефтегорск"},{"region":"Самарская обл.","city":"Новокуйбышевск"},{"region":"Самарская обл.","city":"Октябрьск"},{"region":"Самарская обл.","city":"Отрадный"},{"region":"Самарская обл.","city":"Пестравка"},{"region":"Самарская обл.","city":"Похвистнево"},{"region":"Самарская обл.","city":"Приволжье"},{"region":"Самарская обл.","city":"Самара"},{"region":"Самарская обл.","city":"Сургут (Самарская обл.)"},{"region":"Самарская обл.","city":"Сызрань"},{"region":"Самарская обл.","city":"Тольятти"},{"region":"Самарская обл.","city":"Хворостянка"},{"region":"Самарская обл.","city":"Чапаевск"},{"region":"Самарская обл.","city":"Челно-Вершины"},{"region":"Самарская обл.","city":"Шентала"},{"region":"Самарская обл.","city":"Шигоны"},{"region":"Саратовская обл.","city":"Александров Гай"},{"region":"Саратовская обл.","city":"Аркадак"},{"region":"Саратовская обл.","city":"Аткарск"},{"region":"Саратовская обл.","city":"Базарный Карабулак"},{"region":"Саратовская обл.","city":"Балаково"},{"region":"Саратовская обл.","city":"Балашов"},{"region":"Саратовская обл.","city":"Балтай"},{"region":"Саратовская обл.","city":"Возрождение"},{"region":"Саратовская обл.","city":"Вольск"},{"region":"Саратовская обл.","city":"Воскресенское"},{"region":"Саратовская обл.","city":"Горный"},{"region":"Саратовская обл.","city":"Дергачи"},{"region":"Саратовская обл.","city":"Духовницкое"},{"region":"Саратовская обл.","city":"Екатериновка"},{"region":"Саратовская обл.","city":"Ершов"},{"region":"Саратовская обл.","city":"Заречный"},{"region":"Саратовская обл.","city":"Ивантеевка"},{"region":"Саратовская обл.","city":"Калининск"},{"region":"Саратовская обл.","city":"Каменский"},{"region":"Саратовская обл.","city":"Красноармейск"},{"region":"Саратовская обл.","city":"Красный Кут"},{"region":"Саратовская обл.","city":"Лысые Горы"},{"region":"Саратовская обл.","city":"Маркс"},{"region":"Саратовская обл.","city":"Мокроус"},{"region":"Саратовская обл.","city":"Новоузенск"},{"region":"Саратовская обл.","city":"Новые Бурасы"},{"region":"Саратовская обл.","city":"Озинки"},{"region":"Саратовская обл.","city":"Перелюб"},{"region":"Саратовская обл.","city":"Петровск"},{"region":"Саратовская обл.","city":"Питерка"},{"region":"Саратовская обл.","city":"Пугачев"},{"region":"Саратовская обл.","city":"Ровное"},{"region":"Саратовская обл.","city":"Романовка"},{"region":"Саратовская обл.","city":"Ртищево"},{"region":"Саратовская обл.","city":"Самойловка"},{"region":"Саратовская обл.","city":"Саратов"},{"region":"Саратовская обл.","city":"Степное"},{"region":"Саратовская обл.","city":"Татищево"},{"region":"Саратовская обл.","city":"Турки"},{"region":"Саратовская обл.","city":"Хвалынск"},{"region":"Саратовская обл.","city":"Энгельс"},{"region":"Саха (Якутия)","city":"Абый"},{"region":"Саха (Якутия)","city":"Алдан"},{"region":"Саха (Якутия)","city":"Амга"},{"region":"Саха (Якутия)","city":"Батагай"},{"region":"Саха (Якутия)","city":"Бердигестях"},{"region":"Саха (Якутия)","city":"Беркакит"},{"region":"Саха (Якутия)","city":"Бестях"},{"region":"Саха (Якутия)","city":"Борогонцы"},{"region":"Саха (Якутия)","city":"Верхневилюйск"},{"region":"Саха (Якутия)","city":"Верхнеколымск"},{"region":"Саха (Якутия)","city":"Верхоянск"},{"region":"Саха (Якутия)","city":"Вилюйск"},{"region":"Саха (Якутия)","city":"Витим"},{"region":"Саха (Якутия)","city":"Власово"},{"region":"Саха (Якутия)","city":"Жиганск"},{"region":"Саха (Якутия)","city":"Зырянка"},{"region":"Саха (Якутия)","city":"Кангалассы"},{"region":"Саха (Якутия)","city":"Канкунский"},{"region":"Саха (Якутия)","city":"Ленск"},{"region":"Саха (Якутия)","city":"Майя"},{"region":"Саха (Якутия)","city":"Менкеря"},{"region":"Саха (Якутия)","city":"Мирный"},{"region":"Саха (Якутия)","city":"Нерюнгри"},{"region":"Саха (Якутия)","city":"Нычалах"},{"region":"Саха (Якутия)","city":"Нюрба"},{"region":"Саха (Якутия)","city":"Олекминск"},{"region":"Саха (Якутия)","city":"Покровск"},{"region":"Саха (Якутия)","city":"Сангар"},{"region":"Саха (Якутия)","city":"Саскылах"},{"region":"Саха (Якутия)","city":"Среднеколымск"},{"region":"Саха (Якутия)","city":"Сунтар"},{"region":"Саха (Якутия)","city":"Тикси"},{"region":"Саха (Якутия)","city":"Усть-Мая"},{"region":"Саха (Якутия)","city":"Усть-Нера"},{"region":"Саха (Якутия)","city":"Хандыга"},{"region":"Саха (Якутия)","city":"Хонуу"},{"region":"Саха (Якутия)","city":"Черский"},{"region":"Саха (Якутия)","city":"Чокурдах"},{"region":"Саха (Якутия)","city":"Чурапча"},{"region":"Саха (Якутия)","city":"Якутск"},{"region":"Сахалин","city":"Александровск-Сахалинский"},{"region":"Сахалин","city":"Анбэцу"},{"region":"Сахалин","city":"Анива"},{"region":"Сахалин","city":"Бошняково"},{"region":"Сахалин","city":"Быков"},{"region":"Сахалин","city":"Вахрушев"},{"region":"Сахалин","city":"Взморье"},{"region":"Сахалин","city":"Гастелло"},{"region":"Сахалин","city":"Горнозаводск"},{"region":"Сахалин","city":"Долинск"},{"region":"Сахалин","city":"Ильинский"},{"region":"Сахалин","city":"Катангли"},{"region":"Сахалин","city":"Корсаков"},{"region":"Сахалин","city":"Курильск"},{"region":"Сахалин","city":"Макаров"},{"region":"Сахалин","city":"Невельск"},{"region":"Сахалин","city":"Ноглики"},{"region":"Сахалин","city":"Оха"},{"region":"Сахалин","city":"Поронайск"},{"region":"Сахалин","city":"Северо-Курильск"},{"region":"Сахалин","city":"Смирных"},{"region":"Сахалин","city":"Томари"},{"region":"Сахалин","city":"Тымовское"},{"region":"Сахалин","city":"Углегорск"},{"region":"Сахалин","city":"Холмск"},{"region":"Сахалин","city":"Шахтерск"},{"region":"Сахалин","city":"Южно-Курильск"},{"region":"Сахалин","city":"Южно-Сахалинск"},{"region":"Свердловская обл.","city":"Алапаевск"},{"region":"Свердловская обл.","city":"Алтынай"},{"region":"Свердловская обл.","city":"Арамиль"},{"region":"Свердловская обл.","city":"Артемовский"},{"region":"Свердловская обл.","city":"Арти"},{"region":"Свердловская обл.","city":"Асбест"},{"region":"Свердловская обл.","city":"Ачит"},{"region":"Свердловская обл.","city":"Байкалово"},{"region":"Свердловская обл.","city":"Басьяновский"},{"region":"Свердловская обл.","city":"Белоярский"},{"region":"Свердловская обл.","city":"Березовский"},{"region":"Свердловская обл.","city":"Богданович"},{"region":"Свердловская обл.","city":"Буланаш"},{"region":"Свердловская обл.","city":"Верхний Тагил"},{"region":"Свердловская обл.","city":"Верхняя Пышма"},{"region":"Свердловская обл.","city":"Верхняя Салда"},{"region":"Свердловская обл.","city":"Верхняя Синячиха"},{"region":"Свердловская обл.","city":"Верхняя Сысерть"},{"region":"Свердловская обл.","city":"Верхняя Тура"},{"region":"Свердловская обл.","city":"Верхотурье"},{"region":"Свердловская обл.","city":"Висим"},{"region":"Свердловская обл.","city":"Волчанск"},{"region":"Свердловская обл.","city":"Воронцовка"},{"region":"Свердловская обл.","city":"Гари"},{"region":"Свердловская обл.","city":"Дегтярск"},{"region":"Свердловская обл.","city":"Екатеринбург"},{"region":"Свердловская обл.","city":"Ертарский"},{"region":"Свердловская обл.","city":"Заводоуспенское"},{"region":"Свердловская обл.","city":"Зыряновский"},{"region":"Свердловская обл.","city":"Зюзельский"},{"region":"Свердловская обл.","city":"Ивдель"},{"region":"Свердловская обл.","city":"Изумруд"},{"region":"Свердловская обл.","city":"Ирбит"},{"region":"Свердловская обл.","city":"Ис"},{"region":"Свердловская обл.","city":"Каменск-Уральский"},{"region":"Свердловская обл.","city":"Камышлов"},{"region":"Свердловская обл.","city":"Карпинск"},{"region":"Свердловская обл.","city":"Карпунинский"},{"region":"Свердловская обл.","city":"Качканар"},{"region":"Свердловская обл.","city":"Кировград"},{"region":"Свердловская обл.","city":"Краснотурьинск"},{"region":"Свердловская обл.","city":"Красноуральск"},{"region":"Свердловская обл.","city":"Красноуфимск"},{"region":"Свердловская обл.","city":"Кушва"},{"region":"Свердловская обл.","city":"Лесной"},{"region":"Свердловская обл.","city":"Михайловск"},{"region":"Свердловская обл.","city":"Невьянск"},{"region":"Свердловская обл.","city":"Нижние Серги"},{"region":"Свердловская обл.","city":"Нижний Тагил"},{"region":"Свердловская обл.","city":"Нижняя Салда"},{"region":"Свердловская обл.","city":"Нижняя Тура"},{"region":"Свердловская обл.","city":"Новая Ляля"},{"region":"Свердловская обл.","city":"Новоуральск"},{"region":"Свердловская обл.","city":"Оус"},{"region":"Свердловская обл.","city":"Первоуральск"},{"region":"Свердловская обл.","city":"Полевской"},{"region":"Свердловская обл.","city":"Пышма"},{"region":"Свердловская обл.","city":"Ревда"},{"region":"Свердловская обл.","city":"Реж"},{"region":"Свердловская обл.","city":"Свердловск"},{"region":"Свердловская обл.","city":"Североуральск"},{"region":"Свердловская обл.","city":"Серов"},{"region":"Свердловская обл.","city":"Сосьва"},{"region":"Свердловская обл.","city":"Среднеуральск"},{"region":"Свердловская обл.","city":"Сухой Лог"},{"region":"Свердловская обл.","city":"Сысерть"},{"region":"Свердловская обл.","city":"Таборы"},{"region":"Свердловская обл.","city":"Тавда"},{"region":"Свердловская обл.","city":"Талица"},{"region":"Свердловская обл.","city":"Тугулым"},{"region":"Свердловская обл.","city":"Туринск"},{"region":"Свердловская обл.","city":"Туринская Слобода"},{"region":"Северная Осетия","city":"Алагир"},{"region":"Северная Осетия","city":"Ардон"},{"region":"Северная Осетия","city":"Беслан"},{"region":"Северная Осетия","city":"Бурон"},{"region":"Северная Осетия","city":"Владикавказ"},{"region":"Северная Осетия","city":"Дигора"},{"region":"Северная Осетия","city":"Моздок"},{"region":"Северная Осетия","city":"Орджоникидзе"},{"region":"Северная Осетия","city":"Чикола"},{"region":"Смоленская обл.","city":"Велиж"},{"region":"Смоленская обл.","city":"Верхнеднепровский"},{"region":"Смоленская обл.","city":"Ворга"},{"region":"Смоленская обл.","city":"Вязьма"},{"region":"Смоленская обл.","city":"Гагарин"},{"region":"Смоленская обл.","city":"Глинка"},{"region":"Смоленская обл.","city":"Голынки"},{"region":"Смоленская обл.","city":"Демидов"},{"region":"Смоленская обл.","city":"Десногорск"},{"region":"Смоленская обл.","city":"Дорогобуж"},{"region":"Смоленская обл.","city":"Духовщина"},{"region":"Смоленская обл.","city":"Екимовичи"},{"region":"Смоленская обл.","city":"Ельня"},{"region":"Смоленская обл.","city":"Ершичи"},{"region":"Смоленская обл.","city":"Издешково"},{"region":"Смоленская обл.","city":"Кардымово"},{"region":"Смоленская обл.","city":"Красный"},{"region":"Смоленская обл.","city":"Монастырщина"},{"region":"Смоленская обл.","city":"Новодугино"},{"region":"Смоленская обл.","city":"Починок"},{"region":"Смоленская обл.","city":"Рославль"},{"region":"Смоленская обл.","city":"Рудня"},{"region":"Смоленская обл.","city":"Сафоново"},{"region":"Смоленская обл.","city":"Смоленск"},{"region":"Смоленская обл.","city":"Сычевка"},{"region":"Смоленская обл.","city":"Угра"},{"region":"Смоленская обл.","city":"Хиславичи"},{"region":"Смоленская обл.","city":"Холм-Жирковский"},{"region":"Смоленская обл.","city":"Шумячи"},{"region":"Смоленская обл.","city":"Ярцево"},{"region":"Ставропольский край","city":"Александровское"},{"region":"Ставропольский край","city":"Арзгир"},{"region":"Ставропольский край","city":"Благодарный"},{"region":"Ставропольский край","city":"Буденновск"},{"region":"Ставропольский край","city":"Георгиевск"},{"region":"Ставропольский край","city":"Дивное"},{"region":"Ставропольский край","city":"Домбай"},{"region":"Ставропольский край","city":"Донское"},{"region":"Ставропольский край","city":"Ессентуки"},{"region":"Ставропольский край","city":"Железноводск"},{"region":"Ставропольский край","city":"Зеленокумск"},{"region":"Ставропольский край","city":"Изобильный"},{"region":"Ставропольский край","city":"Иноземцево"},{"region":"Ставропольский край","city":"Ипатово"},{"region":"Ставропольский край","city":"Карачаевск"},{"region":"Ставропольский край","city":"Кисловодск"},{"region":"Ставропольский край","city":"Кочубеевское"},{"region":"Ставропольский край","city":"Красногвардейское"},{"region":"Ставропольский край","city":"Курсавка"},{"region":"Ставропольский край","city":"Левокумское"},{"region":"Ставропольский край","city":"Минеральные Воды"},{"region":"Ставропольский край","city":"Невинномысск"},{"region":"Ставропольский край","city":"Нефтекумск"},{"region":"Ставропольский край","city":"Новоалександровск"},{"region":"Ставропольский край","city":"Новоалександровская"},{"region":"Ставропольский край","city":"Новопавловск"},{"region":"Ставропольский край","city":"Новоселицкое"},{"region":"Ставропольский край","city":"Преградная"},{"region":"Ставропольский край","city":"Пятигорск"},{"region":"Ставропольский край","city":"Светлоград"},{"region":"Ставропольский край","city":"Солнечнодольск"},{"region":"Ставропольский край","city":"Ставрополь"},{"region":"Ставропольский край","city":"Степное"},{"region":"Ставропольский край","city":"Теберда"},{"region":"Ставропольский край","city":"Усть-Джегута"},{"region":"Ставропольский край","city":"Хабез"},{"region":"Ставропольский край","city":"Черкесск"},{"region":"Тамбовская обл.","city":"Бондари"},{"region":"Тамбовская обл.","city":"Гавриловка Вторая"},{"region":"Тамбовская обл.","city":"Жердевка"},{"region":"Тамбовская обл.","city":"Знаменка"},{"region":"Тамбовская обл.","city":"Инжавино"},{"region":"Тамбовская обл.","city":"Кирсанов"},{"region":"Тамбовская обл.","city":"Котовск"},{"region":"Тамбовская обл.","city":"Мичуринск"},{"region":"Тамбовская обл.","city":"Мордово"},{"region":"Тамбовская обл.","city":"Моршанск"},{"region":"Тамбовская обл.","city":"Мучкапский"},{"region":"Тамбовская обл.","city":"Первомайский"},{"region":"Тамбовская обл.","city":"Петровское"},{"region":"Тамбовская обл.","city":"Пичаево"},{"region":"Тамбовская обл.","city":"Рассказово"},{"region":"Тамбовская обл.","city":"Ржакса"},{"region":"Тамбовская обл.","city":"Староюрьево"},{"region":"Тамбовская обл.","city":"Тамбов"},{"region":"Тамбовская обл.","city":"Токаревка"},{"region":"Тамбовская обл.","city":"Уварово"},{"region":"Тамбовская обл.","city":"Умет"},{"region":"Татарстан","city":"Агрыз"},{"region":"Татарстан","city":"Азнакаево"},{"region":"Татарстан","city":"Аксубаево"},{"region":"Татарстан","city":"Актюбинский"},{"region":"Татарстан","city":"Алексеевское"},{"region":"Татарстан","city":"Альметьевск"},{"region":"Татарстан","city":"Апастово"},{"region":"Татарстан","city":"Арск"},{"region":"Татарстан","city":"Бавлы"},{"region":"Татарстан","city":"Базарные Матаки"},{"region":"Татарстан","city":"Балтаси"},{"region":"Татарстан","city":"Богатые Сабы"},{"region":"Татарстан","city":"Брежнев"},{"region":"Татарстан","city":"Бугульма"},{"region":"Татарстан","city":"Буинск"},{"region":"Татарстан","city":"Васильево"},{"region":"Татарстан","city":"Верхний Услон"},{"region":"Татарстан","city":"Высокая Гора"},{"region":"Татарстан","city":"Дербешкинский"},{"region":"Татарстан","city":"Елабуга"},{"region":"Татарстан","city":"Заинск"},{"region":"Татарстан","city":"Зеленодольск"},{"region":"Татарстан","city":"Казань"},{"region":"Татарстан","city":"Камское Устье"},{"region":"Татарстан","city":"Карабаш"},{"region":"Татарстан","city":"Куйбышев"},{"region":"Татарстан","city":"Кукмод"},{"region":"Татарстан","city":"Кукмор"},{"region":"Татарстан","city":"Лаишево"},{"region":"Татарстан","city":"Лениногорск"},{"region":"Татарстан","city":"Мамадыш"},{"region":"Татарстан","city":"Менделеевск"},{"region":"Татарстан","city":"Мензелинск"},{"region":"Татарстан","city":"Муслюмово"},{"region":"Татарстан","city":"Набережные Челны"},{"region":"Татарстан","city":"Нижнекамск"},{"region":"Татарстан","city":"Новошешминск"},{"region":"Татарстан","city":"Нурлат"},{"region":"Татарстан","city":"Пестрецы"},{"region":"Татарстан","city":"Рыбная Слобода"},{"region":"Татарстан","city":"Сарманово"},{"region":"Татарстан","city":"Старое Дрожжаное"},{"region":"Татарстан","city":"Тетюши"},{"region":"Татарстан","city":"Чистополь"},{"region":"Тверская обл.","city":"Андреаполь"},{"region":"Тверская обл.","city":"Бежецк"},{"region":"Тверская обл.","city":"Белый"},{"region":"Тверская обл.","city":"Белый Городок"},{"region":"Тверская обл.","city":"Березайка"},{"region":"Тверская обл.","city":"Бологое"},{"region":"Тверская обл.","city":"Васильевский Мох"},{"region":"Тверская обл.","city":"Выползово"},{"region":"Тверская обл.","city":"Вышний Волочек"},{"region":"Тверская обл.","city":"Жарковский"},{"region":"Тверская обл.","city":"Западная Двина"},{"region":"Тверская обл.","city":"Заречье"},{"region":"Тверская обл.","city":"Зубцов"},{"region":"Тверская обл.","city":"Изоплит"},{"region":"Тверская обл.","city":"Калашниково"},{"region":"Тверская обл.","city":"Калинин"},{"region":"Тверская обл.","city":"Калязин"},{"region":"Тверская обл.","city":"Кашин"},{"region":"Тверская обл.","city":"Кесова Гора"},{"region":"Тверская обл.","city":"Кимры"},{"region":"Тверская обл.","city":"Конаково"},{"region":"Тверская обл.","city":"Красный Холм"},{"region":"Тверская обл.","city":"Кувшиново"},{"region":"Тверская обл.","city":"Лесное"},{"region":"Тверская обл.","city":"Лихославль"},{"region":"Тверская обл.","city":"Максатиха"},{"region":"Тверская обл.","city":"Молоково"},{"region":"Тверская обл.","city":"Нелидово"},{"region":"Тверская обл.","city":"Оленино"},{"region":"Тверская обл.","city":"Осташков"},{"region":"Тверская обл.","city":"Пено"},{"region":"Тверская обл.","city":"Рамешки"},{"region":"Тверская обл.","city":"Ржев"},{"region":"Тверская обл.","city":"Сандово"},{"region":"Тверская обл.","city":"Селижарово"},{"region":"Тверская обл.","city":"Сонково"},{"region":"Тверская обл.","city":"Спирово"},{"region":"Тверская обл.","city":"Старица"},{"region":"Тверская обл.","city":"Тверь"},{"region":"Тверская обл.","city":"Торжок"},{"region":"Тверская обл.","city":"Торопец"},{"region":"Тверская обл.","city":"Удомля"},{"region":"Тверская обл.","city":"Фирово"},{"region":"Томская обл.","city":"Александровское"},{"region":"Томская обл.","city":"Асино"},{"region":"Томская обл.","city":"Бакчар"},{"region":"Томская обл.","city":"Батурино"},{"region":"Томская обл.","city":"Белый Яр"},{"region":"Томская обл.","city":"Зырянское"},{"region":"Томская обл.","city":"Итатка"},{"region":"Томская обл.","city":"Каргасок"},{"region":"Томская обл.","city":"Катайга"},{"region":"Томская обл.","city":"Кожевниково"},{"region":"Томская обл.","city":"Колпашево"},{"region":"Томская обл.","city":"Кривошеино"},{"region":"Томская обл.","city":"Мельниково"},{"region":"Томская обл.","city":"Молчаново"},{"region":"Томская обл.","city":"Парабель"},{"region":"Томская обл.","city":"Первомайское"},{"region":"Томская обл.","city":"Подгорное"},{"region":"Томская обл.","city":"Северск"},{"region":"Томская обл.","city":"Стрежевой"},{"region":"Томская обл.","city":"Томск"},{"region":"Томская обл.","city":"Тымск"},{"region":"Тува (Тувинская Респ.)","city":"Ак-Довурак"},{"region":"Тува (Тувинская Респ.)","city":"Бай Хаак"},{"region":"Тува (Тувинская Респ.)","city":"Кызыл"},{"region":"Тува (Тувинская Респ.)","city":"Самагалтай"},{"region":"Тува (Тувинская Респ.)","city":"Сарыг-Сеп"},{"region":"Тува (Тувинская Респ.)","city":"Суть-Холь"},{"region":"Тува (Тувинская Респ.)","city":"Тоора-Хем"},{"region":"Тува (Тувинская Респ.)","city":"Туран"},{"region":"Тува (Тувинская Респ.)","city":"Тээли"},{"region":"Тува (Тувинская Респ.)","city":"Хову-Аксы"},{"region":"Тува (Тувинская Респ.)","city":"Чадан"},{"region":"Тува (Тувинская Респ.)","city":"Шагонар"},{"region":"Тува (Тувинская Респ.)","city":"Эрзин"},{"region":"Тульская обл.","city":"Агеево"},{"region":"Тульская обл.","city":"Алексин"},{"region":"Тульская обл.","city":"Арсеньево"},{"region":"Тульская обл.","city":"Барсуки"},{"region":"Тульская обл.","city":"Бегичевский"},{"region":"Тульская обл.","city":"Белев"},{"region":"Тульская обл.","city":"Богородицк"},{"region":"Тульская обл.","city":"Болохово"},{"region":"Тульская обл.","city":"Велегож"},{"region":"Тульская обл.","city":"Венев"},{"region":"Тульская обл.","city":"Волово"},{"region":"Тульская обл.","city":"Горелки"},{"region":"Тульская обл.","city":"Донской"},{"region":"Тульская обл.","city":"Дубна"},{"region":"Тульская обл.","city":"Епифань"},{"region":"Тульская обл.","city":"Ефремов"},{"region":"Тульская обл.","city":"Заокский"},{"region":"Тульская обл.","city":"Казановка"},{"region":"Тульская обл.","city":"Кимовск"},{"region":"Тульская обл.","city":"Киреевск"},{"region":"Тульская обл.","city":"Куркино"},{"region":"Тульская обл.","city":"Ленинский"},{"region":"Тульская обл.","city":"Новомосковск"},{"region":"Тульская обл.","city":"Одоев"},{"region":"Тульская обл.","city":"Плавск"},{"region":"Тульская обл.","city":"Суворов"},{"region":"Тульская обл.","city":"Тула"},{"region":"Тульская обл.","city":"Узловая"},{"region":"Тульская обл.","city":"Щекино"},{"region":"Тульская обл.","city":"Ясногорск"},{"region":"Тюменская обл.","city":"Абатский"},{"region":"Тюменская обл.","city":"Аксарка"},{"region":"Тюменская обл.","city":"Армизонское"},{"region":"Тюменская обл.","city":"Аромашево"},{"region":"Тюменская обл.","city":"Белоярский"},{"region":"Тюменская обл.","city":"Бердюжье"},{"region":"Тюменская обл.","city":"Большое Сорокино"},{"region":"Тюменская обл.","city":"Вагай"},{"region":"Тюменская обл.","city":"Викулово"},{"region":"Тюменская обл.","city":"Винзили"},{"region":"Тюменская обл.","city":"Голышманово"},{"region":"Тюменская обл.","city":"Губкинский"},{"region":"Тюменская обл.","city":"Заводопетровский"},{"region":"Тюменская обл.","city":"Заводоуковск"},{"region":"Тюменская обл.","city":"Излучинск"},{"region":"Тюменская обл.","city":"Исетское"},{"region":"Тюменская обл.","city":"Ишим"},{"region":"Тюменская обл.","city":"Казанское"},{"region":"Тюменская обл.","city":"Казым-Мыс"},{"region":"Тюменская обл.","city":"Когалым"},{"region":"Тюменская обл.","city":"Кондинское"},{"region":"Тюменская обл.","city":"Красноселькуп"},{"region":"Тюменская обл.","city":"Лабытнанги"},{"region":"Тюменская обл.","city":"Ларьяк"},{"region":"Тюменская обл.","city":"Мегион"},{"region":"Тюменская обл.","city":"Мужи"},{"region":"Тюменская обл.","city":"Муравленко"},{"region":"Тюменская обл.","city":"Надым"},{"region":"Тюменская обл.","city":"Находка"},{"region":"Тюменская обл.","city":"Нефтеюганск"},{"region":"Тюменская обл.","city":"Нижневартовск"},{"region":"Тюменская обл.","city":"Нижняя Тавда"},{"region":"Тюменская обл.","city":"Новый Уренгой"},{"region":"Тюменская обл.","city":"Ноябрьск"},{"region":"Тюменская обл.","city":"Нягань"},{"region":"Тюменская обл.","city":"Октябрьское"},{"region":"Тюменская обл.","city":"Омутинский"},{"region":"Тюменская обл.","city":"Радужный"},{"region":"Тюменская обл.","city":"Салехард"},{"region":"Тюменская обл.","city":"Сладково"},{"region":"Тюменская обл.","city":"Советский"},{"region":"Тюменская обл.","city":"Сургут"},{"region":"Тюменская обл.","city":"Тазовский"},{"region":"Тюменская обл.","city":"Тарко-Сале"},{"region":"Тюменская обл.","city":"Тобольск"},{"region":"Тюменская обл.","city":"Тюмень"},{"region":"Тюменская обл.","city":"Уват"},{"region":"Тюменская обл.","city":"Унъюган"},{"region":"Тюменская обл.","city":"Упорово"},{"region":"Тюменская обл.","city":"Урай"},{"region":"Тюменская обл.","city":"Ханты-Мансийск"},{"region":"Тюменская обл.","city":"Юрибей"},{"region":"Тюменская обл.","city":"Ялуторовск"},{"region":"Тюменская обл.","city":"Яр-Сале"},{"region":"Тюменская обл.","city":"Ярково"},{"region":"Удмуртия","city":"Алнаши"},{"region":"Удмуртия","city":"Балезино"},{"region":"Удмуртия","city":"Вавож"},{"region":"Удмуртия","city":"Воткинск"},{"region":"Удмуртия","city":"Глазов"},{"region":"Удмуртия","city":"Грахово"},{"region":"Удмуртия","city":"Дебесы"},{"region":"Удмуртия","city":"Завьялово"},{"region":"Удмуртия","city":"Игра"},{"region":"Удмуртия","city":"Ижевск"},{"region":"Удмуртия","city":"Кама"},{"region":"Удмуртия","city":"Камбарка"},{"region":"Удмуртия","city":"Каракулино"},{"region":"Удмуртия","city":"Кез"},{"region":"Удмуртия","city":"Кизнер"},{"region":"Удмуртия","city":"Киясово"},{"region":"Удмуртия","city":"Красногорское"},{"region":"Удмуртия","city":"Можга"},{"region":"Удмуртия","city":"Сарапул"},{"region":"Удмуртия","city":"Селты"},{"region":"Удмуртия","city":"Сюмси"},{"region":"Удмуртия","city":"Ува"},{"region":"Удмуртия","city":"Устинов"},{"region":"Удмуртия","city":"Шаркан"},{"region":"Удмуртия","city":"Юкаменское"},{"region":"Удмуртия","city":"Якшур-Бодья"},{"region":"Удмуртия","city":"Яр"},{"region":"Ульяновская обл.","city":"Базарный Сызган"},{"region":"Ульяновская обл.","city":"Барыш"},{"region":"Ульяновская обл.","city":"Большое Нагаткино"},{"region":"Ульяновская обл.","city":"Вешкайма"},{"region":"Ульяновская обл.","city":"Глотовка"},{"region":"Ульяновская обл.","city":"Димитровград"},{"region":"Ульяновская обл.","city":"Игнатовка"},{"region":"Ульяновская обл.","city":"Измайлово"},{"region":"Ульяновская обл.","city":"Инза"},{"region":"Ульяновская обл.","city":"Ишеевка"},{"region":"Ульяновская обл.","city":"Канадей"},{"region":"Ульяновская обл.","city":"Карсун"},{"region":"Ульяновская обл.","city":"Кузоватово"},{"region":"Ульяновская обл.","city":"Майна"},{"region":"Ульяновская обл.","city":"Новая Малыкла"},{"region":"Ульяновская обл.","city":"Новоспасское"},{"region":"Ульяновская обл.","city":"Павловка"},{"region":"Ульяновская обл.","city":"Радищево"},{"region":"Ульяновская обл.","city":"Сенгилей"},{"region":"Ульяновская обл.","city":"Старая Кулатка"},{"region":"Ульяновская обл.","city":"Старая Майна"},{"region":"Ульяновская обл.","city":"Сурское"},{"region":"Ульяновская обл.","city":"Тереньга"},{"region":"Ульяновская обл.","city":"Ульяновск"},{"region":"Ульяновская обл.","city":"Чердаклы"},{"region":"Уральская обл.","city":"Аксай"},{"region":"Уральская обл.","city":"Дарьинское"},{"region":"Уральская обл.","city":"Деркул"},{"region":"Уральская обл.","city":"Джамбейты"},{"region":"Уральская обл.","city":"Джаныбек"},{"region":"Уральская обл.","city":"Казталовка"},{"region":"Уральская обл.","city":"Калмыково"},{"region":"Уральская обл.","city":"Каратобе"},{"region":"Уральская обл.","city":"Переметное"},{"region":"Уральская обл.","city":"Сайхин"},{"region":"Уральская обл.","city":"Уральск"},{"region":"Уральская обл.","city":"Федоровка"},{"region":"Уральская обл.","city":"Фурманово"},{"region":"Уральская обл.","city":"Чапаев"},{"region":"Хабаровский край","city":"Амурск"},{"region":"Хабаровский край","city":"Аян"},{"region":"Хабаровский край","city":"Березовый"},{"region":"Хабаровский край","city":"Бикин"},{"region":"Хабаровский край","city":"Бира"},{"region":"Хабаровский край","city":"Биракан"},{"region":"Хабаровский край","city":"Богородское"},{"region":"Хабаровский край","city":"Болонь"},{"region":"Хабаровский край","city":"Ванино"},{"region":"Хабаровский край","city":"Волочаевка Вторая"},{"region":"Хабаровский край","city":"Высокогорный"},{"region":"Хабаровский край","city":"Вяземский"},{"region":"Хабаровский край","city":"Горный"},{"region":"Хабаровский край","city":"Гурское"},{"region":"Хабаровский край","city":"Дормидонтовка"},{"region":"Хабаровский край","city":"Заветы Ильича"},{"region":"Хабаровский край","city":"Известковый"},{"region":"Хабаровский край","city":"Иннокентьевка"},{"region":"Хабаровский край","city":"Комсомольск-на-Амуре"},{"region":"Хабаровский край","city":"Ленинское"},{"region":"Хабаровский край","city":"Нелькан"},{"region":"Хабаровский край","city":"Николаевск-на-Амуре"},{"region":"Хабаровский край","city":"Облучье"},{"region":"Хабаровский край","city":"Охотск"},{"region":"Хабаровский край","city":"Переяславка"},{"region":"Хабаровский край","city":"Смидович"},{"region":"Хабаровский край","city":"Советская Гавань"},{"region":"Хабаровский край","city":"Софийск"},{"region":"Хабаровский край","city":"Троицкое"},{"region":"Хабаровский край","city":"Тугур"},{"region":"Хабаровский край","city":"Хабаровск"},{"region":"Хабаровский край","city":"Чегдомын"},{"region":"Хабаровский край","city":"Чумикан"},{"region":"Хакасия","city":"Абакан"},{"region":"Хакасия","city":"Саяногорск"},{"region":"Ханты-Мансийский АО","city":"Аган"},{"region":"Ханты-Мансийский АО","city":"Игрим"},{"region":"Ханты-Мансийский АО","city":"Излучинск"},{"region":"Ханты-Мансийский АО","city":"Лангепас"},{"region":"Ханты-Мансийский АО","city":"Лянтор"},{"region":"Ханты-Мансийский АО","city":"Мегион"},{"region":"Ханты-Мансийский АО","city":"Нефтеюганск"},{"region":"Ханты-Мансийский АО","city":"Нижневартовск"},{"region":"Ханты-Мансийский АО","city":"Нягань"},{"region":"Ханты-Мансийский АО","city":"Покачи"},{"region":"Ханты-Мансийский АО","city":"Приобье"},{"region":"Ханты-Мансийский АО","city":"Пыть-Ях"},{"region":"Ханты-Мансийский АО","city":"Радужный"},{"region":"Ханты-Мансийский АО","city":"Сургут"},{"region":"Ханты-Мансийский АО","city":"Урай"},{"region":"Ханты-Мансийский АО","city":"Ханты-Мансийск"},{"region":"Ханты-Мансийский АО","city":"Югорск"},{"region":"Челябинская обл.","city":"Агаповка"},{"region":"Челябинская обл.","city":"Аргаяш"},{"region":"Челябинская обл.","city":"Аша"},{"region":"Челябинская обл.","city":"Бакал"},{"region":"Челябинская обл.","city":"Бреды"},{"region":"Челябинская обл.","city":"Варна"},{"region":"Челябинская обл.","city":"Верхнеуральск"},{"region":"Челябинская обл.","city":"Верхний Уфалей"},{"region":"Челябинская обл.","city":"Еманжелинск"},{"region":"Челябинская обл.","city":"Златоуст"},{"region":"Челябинская обл.","city":"Карабаш"},{"region":"Челябинская обл.","city":"Карталы"},{"region":"Челябинская обл.","city":"Касли"},{"region":"Челябинская обл.","city":"Катав-Ивановск"},{"region":"Челябинская обл.","city":"Копейск"},{"region":"Челябинская обл.","city":"Коркино"},{"region":"Челябинская обл.","city":"Кунашак"},{"region":"Челябинская обл.","city":"Куса"},{"region":"Челябинская обл.","city":"Кыштым"},{"region":"Челябинская обл.","city":"Магнитогорск"},{"region":"Челябинская обл.","city":"Миасс"},{"region":"Челябинская обл.","city":"Озерск"},{"region":"Челябинская обл.","city":"Октябрьское"},{"region":"Челябинская обл.","city":"Пласт"},{"region":"Челябинская обл.","city":"Сатка"},{"region":"Челябинская обл.","city":"Сим"},{"region":"Челябинская обл.","city":"Снежинск"},{"region":"Челябинская обл.","city":"Трехгорный"},{"region":"Челябинская обл.","city":"Троицк"},{"region":"Челябинская обл.","city":"Увельский"},{"region":"Челябинская обл.","city":"Уйское"},{"region":"Челябинская обл.","city":"Усть-Катав"},{"region":"Челябинская обл.","city":"Фершампенуаз"},{"region":"Челябинская обл.","city":"Чебаркуль"},{"region":"Челябинская обл.","city":"Челябинск"},{"region":"Челябинская обл.","city":"Чесма"},{"region":"Челябинская обл.","city":"Южно-Уральск"},{"region":"Челябинская обл.","city":"Юрюзань"},{"region":"Чечено-Ингушетия","city":"Аргун"},{"region":"Чечено-Ингушетия","city":"Грозный"},{"region":"Чечено-Ингушетия","city":"Гудермез"},{"region":"Чечено-Ингушетия","city":"Малгобек"},{"region":"Чечено-Ингушетия","city":"Назрань"},{"region":"Чечено-Ингушетия","city":"Наурская"},{"region":"Чечено-Ингушетия","city":"Ножай-Юрт"},{"region":"Чечено-Ингушетия","city":"Орджоникидзевская"},{"region":"Чечено-Ингушетия","city":"Советское"},{"region":"Чечено-Ингушетия","city":"Урус-Мартан"},{"region":"Чечено-Ингушетия","city":"Шали"},{"region":"Читинская обл.","city":"Агинское"},{"region":"Читинская обл.","city":"Аксеново-Зиловское"},{"region":"Читинская обл.","city":"Акша"},{"region":"Читинская обл.","city":"Александровский Завод"},{"region":"Читинская обл.","city":"Амазар"},{"region":"Читинская обл.","city":"Арбагар"},{"region":"Читинская обл.","city":"Атамановка"},{"region":"Читинская обл.","city":"Балей"},{"region":"Читинская обл.","city":"Борзя"},{"region":"Читинская обл.","city":"Букачача"},{"region":"Читинская обл.","city":"Газимурский Завод"},{"region":"Читинская обл.","city":"Давенда"},{"region":"Читинская обл.","city":"Дарасун"},{"region":"Читинская обл.","city":"Дровяная"},{"region":"Читинская обл.","city":"Дульдурга"},{"region":"Читинская обл.","city":"Жиндо"},{"region":"Читинская обл.","city":"Забайкальск"},{"region":"Читинская обл.","city":"Итака"},{"region":"Читинская обл.","city":"Калга"},{"region":"Читинская обл.","city":"Карымское"},{"region":"Читинская обл.","city":"Кличка"},{"region":"Читинская обл.","city":"Ключевский"},{"region":"Читинская обл.","city":"Кокуй"},{"region":"Читинская обл.","city":"Краснокаменск"},{"region":"Читинская обл.","city":"Красный Чикой"},{"region":"Читинская обл.","city":"Кыра"},{"region":"Читинская обл.","city":"Моготуй"},{"region":"Читинская обл.","city":"Могоча"},{"region":"Читинская обл.","city":"Нерчинск"},{"region":"Читинская обл.","city":"Нерчинский Завод"},{"region":"Читинская обл.","city":"Нижний Часучей"},{"region":"Читинская обл.","city":"Оловянная"},{"region":"Читинская обл.","city":"Первомайский"},{"region":"Читинская обл.","city":"Петровск-Забайкальский"},{"region":"Читинская обл.","city":"Приаргунск"},{"region":"Читинская обл.","city":"Сретенск"},{"region":"Читинская обл.","city":"Тупик"},{"region":"Читинская обл.","city":"Улеты"},{"region":"Читинская обл.","city":"Хилок"},{"region":"Читинская обл.","city":"Чара"},{"region":"Читинская обл.","city":"Чернышевск"},{"region":"Читинская обл.","city":"Чита"},{"region":"Читинская обл.","city":"Шелопугино"},{"region":"Читинская обл.","city":"Шилка"},{"region":"Чувашия","city":"Алатырь"},{"region":"Чувашия","city":"Аликово"},{"region":"Чувашия","city":"Батырева"},{"region":"Чувашия","city":"Буинск"},{"region":"Чувашия","city":"Вурнары"},{"region":"Чувашия","city":"Ибреси"},{"region":"Чувашия","city":"Канаш"},{"region":"Чувашия","city":"Киря"},{"region":"Чувашия","city":"Комсомольское"},{"region":"Чувашия","city":"Красноармейское"},{"region":"Чувашия","city":"Красные Четаи"},{"region":"Чувашия","city":"Кугеси"},{"region":"Чувашия","city":"Мариинский Посад"},{"region":"Чувашия","city":"Моргауши"},{"region":"Чувашия","city":"Новочебоксарск"},{"region":"Чувашия","city":"Порецкое"},{"region":"Чувашия","city":"Урмары"},{"region":"Чувашия","city":"Цивильск"},{"region":"Чувашия","city":"Чебоксары"},{"region":"Чувашия","city":"Шемурша"},{"region":"Чувашия","city":"Шумерля"},{"region":"Чувашия","city":"Ядрин"},{"region":"Чувашия","city":"Яльчики"},{"region":"Чувашия","city":"Янтиково"},{"region":"Чукотский АО","city":"Анадырь"},{"region":"Чукотский АО","city":"Билибино"},{"region":"Ямало-Ненецкий АО","city":"Губкинский"},{"region":"Ямало-Ненецкий АО","city":"Заполярный"},{"region":"Ямало-Ненецкий АО","city":"Муравленко"},{"region":"Ямало-Ненецкий АО","city":"Надым"},{"region":"Ямало-Ненецкий АО","city":"Новый Уренгой"},{"region":"Ямало-Ненецкий АО","city":"Ноябрьск"},{"region":"Ямало-Ненецкий АО","city":"Пуровск"},{"region":"Ямало-Ненецкий АО","city":"Салехард"},{"region":"Ямало-Ненецкий АО","city":"Тарко"},{"region":"Ярославская обл.","city":"Андропов"},{"region":"Ярославская обл.","city":"Берендеево"},{"region":"Ярославская обл.","city":"Большое Село"},{"region":"Ярославская обл.","city":"Борисоглебский"},{"region":"Ярославская обл.","city":"Брейтово"},{"region":"Ярославская обл.","city":"Бурмакино"},{"region":"Ярославская обл.","city":"Варегово"},{"region":"Ярославская обл.","city":"Волга"},{"region":"Ярославская обл.","city":"Гаврилов Ям"},{"region":"Ярославская обл.","city":"Данилов"},{"region":"Ярославская обл.","city":"Любим"},{"region":"Ярославская обл.","city":"Мышкино"},{"region":"Ярославская обл.","city":"Некрасовское"},{"region":"Ярославская обл.","city":"Новый Некоуз"},{"region":"Ярославская обл.","city":"Переславль-Залесский"},{"region":"Ярославская обл.","city":"Пошехонье-Володарск"},{"region":"Ярославская обл.","city":"Ростов"},{"region":"Ярославская обл.","city":"Рыбинск"},{"region":"Ярославская обл.","city":"Тутаев"},{"region":"Ярославская обл.","city":"Углич"},{"region":"Ярославская обл.","city":"Ярославль"}]

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "city-search",

    props: ['name', 'selectedCity', 'hasErrors', 'disabled'],

    $_veeValidate: {
        value: function value() {
            return this.searchText;
        },
        name: function name() {
            return this.name;
        }
    },

    data: function data() {
        return {
            searchText: this.selectedCity ? this.selectedCity.Name : '',
            filteredCities: [],
            dropDownOpen: false,
            citiesData: [] // данные с городами
        };
    },


    methods: {
        // Метод фильтрации городов
        filterCities: function filterCities(searchText) {
            return this.citiesData.filter(function (city) {
                return city.city.toLowerCase().includes(searchText.toLowerCase()) || city.region.toLowerCase().includes(searchText.toLowerCase());
            }).map(function (city) {
                return {
                    Name: city.city + ', ' + city.region,
                    Id: city.city + ', ' + city.region
                };
            });
        },


        // Дебаунс для поиска
        onSearchInput: Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["debounce"])(function () {
            if (this.searchText) {
                this.filteredCities = this.filterCities(this.searchText);
                this.dropDownOpen = this.filteredCities.length > 0;
            } else {
                this.filteredCities = [];
                this.dropDownOpen = false;
            }
        }, 500),

        // Обработка выбора города
        onSelectCity: function onSelectCity(item) {
            this.searchText = item.Name;
            this.dropDownOpen = false;
            this.$emit('update:selectedCity', item);
        },


        // Событие при фокусе
        onFocus: function onFocus() {
            if (!this.searchText) {
                this.filteredCities = [];
            }
            this.dropDownOpen = true;
        },


        // Событие при потере фокуса
        onBlur: function onBlur() {
            var _this = this;

            setTimeout(function () {
                _this.dropDownOpen = false;
            }, 100);
        }
    },

    watch: {
        selectedCity: function selectedCity(newVal) {
            if (newVal) {
                this.searchText = newVal.Name;
            } else {
                this.searchText = '';
            }
        }
    },

    mounted: function mounted() {
        this.citiesData = __webpack_require__(265);
    }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_claims_checking_mixin__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_smooth_dnd__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_JqueryUI_jquery_ui_min__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_JqueryUI_jquery_ui_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_JqueryUI_jquery_ui_min__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var backendApi = new __WEBPACK_IMPORTED_MODULE_2__backendApi__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "projects",

    components: { Container: __WEBPACK_IMPORTED_MODULE_8_vue_smooth_dnd__["a" /* Container */], Draggable: __WEBPACK_IMPORTED_MODULE_8_vue_smooth_dnd__["b" /* Draggable */] },

    data: function data() {
        return {
            projectList: [],
            loading: false,
            canBeLoaded: true,
            page: 1,
            active: true,
            scrollTop: null,
            firstLoad: true
        };
    },


    // computed: {
    //     projectsOrdered: function () {
    //         return _.orderBy(this.projectList, 'ProjectOrder');
    //     }
    // },

    mixins: [__WEBPACK_IMPORTED_MODULE_5__helpers_project_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__helpers_claims_checking_mixin__["a" /* default */]],

    methods: {
        onDomain: function onDomain(domain) {
            if (domain && domain !== '-') {
                window.open('https://' + domain);
            }
        },
        onChangeDate: function onChangeDate(item, formatted, raw) {
            item[raw] = Object(__WEBPACK_IMPORTED_MODULE_4_moment__["default"])(item[formatted], 'DD.MM.YYYY').format();
        },
        onNewProject: function onNewProject() {
            this.$router.push('/projects/0');
        },
        reload: function reload() {
            var vm = this;

            vm.page = 1;
            vm.projectList = [];
            vm.canBeLoaded = true;
            vm.loading = false;
            vm.firstLoad = true;
            vm.loadNext();
        },
        loadNext: function loadNext() {
            var vm = this;
            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('.projects', 'Загрузка...');
            this.callApiWrapper(backendApi.projectList((vm.page - 1) * 20, 20, vm.active)).then(function (resp) {
                if (resp.hasError) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки проектов');
                } else {
                    if (resp.data && resp.data.length) {
                        var _vm$projectList;

                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = resp.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var item = _step.value;

                                if (item.StartDate) {
                                    item.DatesFormatted = 'с ' + vm.formatDate(item.StartDate);
                                }
                                if (item.EndDate) {
                                    item.DatesFormatted += (item.StartDate ? ' по ' : '') + vm.formatDate(item.EndDate);
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        (_vm$projectList = vm.projectList).push.apply(_vm$projectList, _toConsumableArray(resp.data));
                    } else {
                        vm.canBeLoaded = false;
                    }
                }
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('.projects');
                vm.loading = false;
            });
        },
        onRowClick: function onRowClick(item) {
            this.$router.push('/projects/' + item.Id);
        },
        onDrop: function onDrop(dropResult) {
            var vm = this;

            if (dropResult.removedIndex === dropResult.addedIndex) {
                return;
            }

            var projectsTemp = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.orderBy(vm.projectList, 'ProjectOrder');
            var itemToAdd = void 0;
            if (dropResult.removedIndex != null) {
                itemToAdd = projectsTemp.splice(dropResult.removedIndex, 1)[0];
            }
            if (dropResult.addedIndex !== null) {
                projectsTemp.splice(dropResult.addedIndex, 0, itemToAdd);
            }

            var order = 1;
            projectsTemp.forEach(function (role) {
                role.ProjectOrder = order++;
            });

            vm.projectList = projectsTemp;

            this.saveProjectsOrder();
        },
        saveProjectsOrder: function saveProjectsOrder() {
            var saveObj = this.projectList.map(function (x) {
                return {
                    Id: x.Id,
                    ProjectOrder: x.ProjectOrder };
            });
            backendApi.projectOrderSave(saveObj).then(function (response) {
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении проектов');
                }
            });
        },
        onAppAccess: function onAppAccess() {
            this.$router.push('/projects/appaccess');
        }
    },

    mounted: function mounted() {
        var vm = this;

        vm.loadNext();

        vm.$nextTick(function () {

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').on('scroll', function () {
                if (!vm.loading && vm.canBeLoaded) {
                    var elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
                    var scrollTop = elem.scrollTop();
                    vm.scrollTop = scrollTop;
                    if (elem[0].scrollHeight - scrollTop - 200 <= elem.outerHeight()) {
                        vm.page++;
                        vm.loadNext();
                    }
                }
            });

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.sortable-blocks').sortable({
                revert: 100,
                stop: function stop() {
                    var order = 1;
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.sortable-blocks > .panel-block').each(function (index, item) {
                        console.info();
                        var projectId = parseInt(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(item).data('id'));
                        var projectIndex = vm.projectList.findIndex(function (x) {
                            return x.Id === projectId;
                        });
                        console.info('[projectIndex, projectId, order]', [projectIndex, projectId, order]);
                        var p = vm.projectList[projectIndex];
                        p.ProjectOrder = order;
                        vm.$set(vm.projectList, projectIndex, p);

                        order++;
                    });
                    vm.saveProjectsOrder();
                }
            });
        });
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').off('scroll');
    }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_claims_checking_mixin__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var backendApi = new __WEBPACK_IMPORTED_MODULE_2__backendApi__["a" /* default */]();

var AccessTypes = {
    /* Доступ к приложению */
    All: 0,
    /* Запрещено */
    Forbidden: 1,
    /* FoxinBox */
    FoxinBox: 2,
    /* Отдельное приложение */
    Single: 3
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "projects",

    data: function data() {
        return {
            selectedProject: { Id: 0, Name: null },
            projectList: [],
            accessId: AccessTypes.All,
            loading: false,
            canBeLoaded: true,
            page: 1,
            scrollTop: null,
            accesses: [{ Id: 0, Name: 'Доступ к приложению' }, { Id: 1, Name: 'Запрещено' }, { Id: 2, Name: 'FoxinBox' }, { Id: 3, Name: 'Отдельное приложение' }]
        };
    },


    computed: {},

    mixins: [__WEBPACK_IMPORTED_MODULE_5__helpers_project_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__helpers_claims_checking_mixin__["a" /* default */]],

    methods: {
        onAccessChange: function onAccessChange() {
            this.reload();
        },
        reload: function reload() {
            this.page = 1;
            this.projectList = [];
            this.loading = false;
            this.canBeLoaded = true;

            this.loadNext();
        },
        loadNext: function loadNext() {
            var vm = this;
            if (!vm.info.User || vm.info.User.MainRole !== 'administrators') {
                this.$router.back();
                return;
            }

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('.projects', 'Загрузка...');
            this.callApiWrapper(backendApi.projectAppAccess((vm.page - 1) * 40, 40, vm.accessId)).then(function (resp) {
                if (resp.hasError) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки проектов');
                } else {
                    if (resp.data && resp.data.length) {
                        var _vm$projectList;

                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = resp.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var p = _step.value;

                                p.AppAccessTypeName = vm.AppAccessTypeName(p.AppAccessType);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        (_vm$projectList = vm.projectList).push.apply(_vm$projectList, _toConsumableArray(resp.data));
                    } else {
                        vm.canBeLoaded = false;
                    }
                }
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('.projects');
                vm.loading = false;
            });
        },
        onScroll: function onScroll(e) {
            var vm = this;
            if (!vm.loading && vm.canBeLoaded) {
                var elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target);
                vm.scrollTop = elem.scrollTop();
                if (elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight() + 100) {
                    vm.page++;
                    vm.loadNext();
                }
            }
        },
        openProjectEdit: function openProjectEdit(item) {
            var vm = this;
            vm.selectedProject.Id = item.Id;
            vm.selectedProject.Name = item.Name;
            vm.selectedProject.Subdomain = item.Subdomain;
            vm.selectedProject.AppAccessType = item.AppAccessType;
            vm.selectedProject.UrlGooglePlay = item.UrlGooglePlay;
            vm.selectedProject.UrlAppStore = item.UrlAppStore;
            this.onShowModal('ppAppAccessControlModal');
        },
        openSubdomain: function openSubdomain(item) {
            window.open('https://' + item.Subdomain);
        },
        openGooglePlay: function openGooglePlay(item) {
            if (item.UrlGooglePlay) window.open(item.UrlGooglePlay);
        },
        openAppStore: function openAppStore(item) {
            if (item.UrlAppStore) window.open(item.UrlAppStore);
        },
        saveProject: function saveProject() {
            var vm = this;
            var saveObj = Object.assign({}, vm.selectedProject);

            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('.projects', 'Удаление...');
            backendApi.projectAppAccessSave(saveObj).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('.projects');
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при редактировании проекта');
                } else {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');

                    vm.closeModal('ppAppAccessControlModal');

                    var item = vm.projectList.find(function (x) {
                        return x.Id === vm.selectedProject.Id;
                    });
                    item.AppAccessType = vm.selectedProject.AppAccessType;
                    item.UrlGooglePlay = vm.selectedProject.UrlGooglePlay;
                    item.UrlAppStore = vm.selectedProject.UrlAppStore;
                    item.AppAccessTypeName = vm.AppAccessTypeName(item.AppAccessType);
                }
            });
        },
        AppAccessTypeName: function AppAccessTypeName(appAccessType) {
            var typeName = "Запрещено";
            switch (appAccessType) {
                case AccessTypes.FoxinBox:
                    typeName = "FoxinBox";
                    break;
                case AccessTypes.Single:
                    typeName = "Отдельное приложение";
                    break;
            }
            return typeName;
        }
    },

    mounted: function mounted() {
        var vm = this;

        vm.$nextTick(function () {
            vm.loadNext();
        });
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').off('scroll');
    }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_smooth_dnd__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ReportItemsTable__ = __webpack_require__(165);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var backendApi = new __WEBPACK_IMPORTED_MODULE_2__backendApi__["a" /* default */]();

var defaultPageNames = {
    '/reports/0': 'Добавить отчёт',
    '/': 'Новости',
    '/materials': 'Материалы',
    '/reports': 'Отчёты',
    '/rating': 'Рейтинг',
    '/spend-bonuses': 'Потратить бонусы',
    '/analytics': 'Аналитика',
    '/sku': 'SKU',
    '/motivation': 'Программа мотивации',
    '/faq': 'FAQ',
    '/orders': 'Заказы',
    '/cart': 'Мои заказы',
    '/tasks': 'Задания',
    '/feedback': 'Обратная связь',
    '/my-progress': 'Мои достижения'
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "project-edit",

    props: ['info'],

    data: function data() {
        return {
            project: null,
            file: null,
            fileStart: null,
            deleteImage: false,
            deleteStartImage: false,
            deletePolicyFile: false,
            policyFile: null,
            deleteRulesFile: false,
            rulesFile: null,
            dataLoadingFrequencies: [{ Id: 0, Name: 'Не выбрано' }, { Id: 1, Name: '1 день' }, { Id: 3, Name: '3 дня' }, { Id: 7, Name: '1 неделя' }, { Id: 30, Name: '1 месяц' }, { Id: 365, Name: '1 год' }],
            activationPeriodTypes: [{ Id: 'fact', Name: 'По каждому факту начисления' }, { Id: 'sum', Name: 'Суммарно по всем баллам за период' }],
            activationPeriods: [{ Id: 'week', Name: 'Неделя' }, { Id: 'month', Name: 'Месяц' }],
            activationFromDate: [{ Id: 'approved', Name: 'Дата проверки отчета' }, { Id: 'report', Name: 'Дата отчёта' }],
            durationPeriods: [{ Id: '0', Name: 'Не сгорают' }, { Id: '30', Name: '30 дней' }, { Id: '90', Name: '90 дней' }, { Id: '180', Name: '180 дней' }, { Id: '360', Name: '360 дней' }],
            bonusStrategies: [{ Id: 'fact', Name: 'По факту отчета' }, { Id: 'data', Name: 'По данным' }, { Id: 'sp', Name: 'Процедура' }, { Id: 'sku', Name: 'В зависимости от SKU' }],
            bonusStrategyAccrualTypes: [{ Id: '1', Name: 'Процент от суммы' }, { Id: '2', Name: 'Умножить на сумму' }],
            bonusStrategyAccrualValueDate: [],
            bonusStrategyProcedures: [{ Id: '', Name: 'Нет данных' }],
            reportSettingsTypes: [{ Id: 'select', Name: 'Список' }, { Id: 'int', Name: 'Целое число' }, { Id: 'decimal', Name: 'Дробное число' }, { Id: 'string', Name: 'Строковое значение' }, { Id: 'bool', Name: 'Галочка (да или нет)' }, { Id: 'sku', Name: 'Список SKU' }, { Id: 'date', Name: 'Дата' }],
            additionalValueFeeItems: [{ Value: 0.35, Name: '35%' }, { Value: 0.13, Name: '13%' }, { Value: 0.1, Name: '10%' }],
            filteredAdditionalValueFeeOptions: [],
            skuSettings: [],
            dialogSkuSettings: null,
            currentSkuListSettingItem: null,
            roles: [],
            ozonAccounts: [{ Id: 0, Name: 'Не выбрано' }],
            countries: [],
            RegisterTradePointTypes: __WEBPACK_IMPORTED_MODULE_5__enums__["i" /* RegisterTradePointTypes */],
            accrualValueTable: null
        };
    },


    components: { Container: __WEBPACK_IMPORTED_MODULE_0_vue_smooth_dnd__["a" /* Container */], Draggable: __WEBPACK_IMPORTED_MODULE_0_vue_smooth_dnd__["b" /* Draggable */], ReportItemsTable: __WEBPACK_IMPORTED_MODULE_6__components_ReportItemsTable__["a" /* default */] },

    computed: {
        rolesOrdered: function rolesOrdered() {
            return _.orderBy(this.roles, 'Order');
        },

        pagesOrdered: function pagesOrdered() {
            return _.orderBy(this.project.Pages.filter(function (x) {
                return x.PageOrder > 0 && x.Path !== '/reports/0';
            }), 'PageOrder');
        },

        reportAddPage: function reportAddPage() {
            return this.project.Pages.find(function (x) {
                return x.Path === '/reports/0';
            });
        },

        reportSettingsOrdered: function reportSettingsOrdered() {
            return _.orderBy(this.project.ReportSettings, 'itemOrder');
        },

        bonusSettingsStr: function bonusSettingsStr() {
            var vm = this;
            //if (vm.project.bonusSettings.bonusStrategy.type !== 'data' || vm.project.bonusSettings.bonusStrategy.data.accrualType != 1)
            //    vm.project.bonusSettings.bonusStrategy.data.ValueItems = [];
            //else
            if (vm.project.bonusSettings.bonusStrategy.type === 'data' && vm.project.bonusSettings.bonusStrategy.data.accrualType == 1) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = vm.project.bonusSettings.bonusStrategy.data.ValueItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var s = _step.value;

                        s.Id = 0;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            return JSON.stringify(this.project.bonusSettings);
        },
        reportSettingsStr: function reportSettingsStr() {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = this.project.ReportSettings[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var s = _step2.value;

                    if (s.type === 'bool') {
                        s.options = '["Нет", "Да"]';
                        s.dbType = 'bit';
                    } else if (s.type === 'int' || s.name === 'EquipmentType' || s.type === 'sku') {
                        s.dbType = 'int';
                    } else if (s.type === 'decimal') {
                        s.dbType = 'decimal(18,2)';
                    } else if (s.type === 'string') {
                        s.dbType = 'nvarchar(256)';
                    } else if (s.type === 'select') {
                        s.dbType = 'nvarchar(256)';
                    } else if (s.type === 'date') {
                        s.dbType = 'date';
                    }
                    delete s.new;
                    if (s.type !== 'sku') {
                        delete s.sku;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return JSON.stringify(this.project.ReportSettings);
        },
        bonusStrategyFields: function bonusStrategyFields() {
            //console.info('bonusStrategyFields length:', this.project.ReportSettings.length);
            return this.project.ReportSettings.filter(function (x) {
                return x.type === 'int' || x.type === 'decimal';
            }).map(function (x) {
                return {
                    Id: x.name,
                    Name: x.caption };
            });
        },
        bonusStrategySkuFields: function bonusStrategySkuFields() {
            return this.project.ReportSettings.filter(function (x) {
                return x.type === 'sku';
            }).map(function (x) {
                return {
                    Id: x.name,
                    Name: x.caption };
            });
        },
        bonusStrategyDateFields: function bonusStrategyDateFields() {
            return this.project.ReportSettings.filter(function (x) {
                return x.type === 'date';
            }).map(function (x) {
                return {
                    Id: x.name,
                    Name: x.caption };
            });
        },
        tradePointColumnsRequired: function tradePointColumnsRequired() {
            return this.project.RegisterSettings.Enabled && this.project.RegisterSettings.RegisterTradePointType === __WEBPACK_IMPORTED_MODULE_5__enums__["i" /* RegisterTradePointTypes */].Select && !this.project.RegisterSettings.TradePointColumns.length;
        },
        visualDesignStr: function visualDesignStr() {
            return JSON.stringify(this.project.VisualDesign);
        },
        skuSettingsOrdered: function skuSettingsOrdered() {
            if (this.dialogSkuSettings == null) {
                return null;
            }

            return _.orderBy(Object.values(this.dialogSkuSettings.sku), 'SettingsOrder');
        },
        feedbackSettingsStr: function feedbackSettingsStr() {
            return JSON.stringify(this.project.FeedbackSettings);
        },


        feedbackPageName: function feedbackPageName() {
            var page = this.project.Pages.filter(function (x) {
                return x.Path === '/feedback';
            })[0];
            return page && page.Name ? page.Name : 'Обратная связь';
        },

        regFieldsOrdered: function regFieldsOrdered() {
            return _.orderBy(this.project.RegisterSettings.RegFields, 'ItemOrder');
        }
    },

    methods: {
        onCountryChange: function onCountryChange() {
            this.updateAdditionalValueFeeOptions();
        },
        updateAdditionalValueFeeOptions: function updateAdditionalValueFeeOptions() {
            if (!this.project || !this.project.CountryId) return;

            switch (this.project.CountryId) {
                case 1:
                    // Россия
                    this.filteredAdditionalValueFeeOptions = this.additionalValueFeeItems.filter(function (item) {
                        return item.Value === 0.35 || item.Value === 0.13;
                    });
                    break;
                case 2:
                    // Беларусь
                    this.filteredAdditionalValueFeeOptions = this.additionalValueFeeItems.filter(function (item) {
                        return item.Value === 0.13;
                    });
                    this.project.AdditionalValueFeeValue = 0.13;
                    break;
                case 3:
                    // Казахстан
                    this.filteredAdditionalValueFeeOptions = this.additionalValueFeeItems.filter(function (item) {
                        return item.Value === 0.1;
                    });
                    this.project.AdditionalValueFeeValue = 0.1;
                    break;
                default:
                    this.filteredAdditionalValueFeeOptions = [];
                    break;
            }
        },
        getDisabledStatus: function getDisabledStatus(fieldSettings) {
            var strategy = this.project.bonusSettings.bonusStrategy;
            if (strategy.type === 'sku') {
                if (fieldSettings.name === strategy.data.countFieldName || fieldSettings.name === strategy.data.fieldName) {
                    return true;
                }
            }
            if (strategy.type === 'data') {
                if (fieldSettings.name === strategy.data.fieldName) {
                    return true;
                }
                if (strategy.data.accrualType == 1 && fieldSettings.name === strategy.data.accrualValueDate) {
                    return true;
                }
            }

            return false;
        },
        onSettingsDeletedClick: function onSettingsDeletedClick(id, fieldSettings) {
            var input = document.getElementById(id);
            if (input.disabled) {
                var strategy = this.project.bonusSettings.bonusStrategy;
                if (strategy.type === 'sku') {
                    if (fieldSettings.name === strategy.data.countFieldName || fieldSettings.name === strategy.data.fieldName) {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Поле используется в настройке начисления баллов за отчёт');
                    }
                }
                if (strategy.type === 'data') {
                    if (fieldSettings.name === strategy.data.fieldName) {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Поле используется в настройке начисления баллов за отчёт');
                    }
                }
            }
        },
        onSettingsDeletedChange: function onSettingsDeletedChange(fieldSettings) {
            if (this.project.bonusSettings.bonusStrategy.type === 'data' && fieldSettings.type === 'date') {
                this.updateReportSettingsDate();
            }
        },
        bindClaim: function bindClaim(claimId, roleClaim) {
            return {
                ClaimId: claimId,
                Value: roleClaim ? roleClaim.Value : null
            };
        },
        onByDefaultChange: function onByDefaultChange(item) {
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = this.project.RatingRoles[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var r = _step3.value;

                    r.ByDefault = false;
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            item.ByDefault = true;
        },
        getRoleClaim: function getRoleClaim(role, claimId) {
            return role.Claims.find(function (val) {
                return val.ClaimId === claimId;
            });
        },
        onDrop: function onDrop(dropResult) {
            var vm = this;

            if (dropResult.removedIndex === dropResult.addedIndex) {
                return;
            }

            var temp = _.orderBy(vm.project.Pages.filter(function (x) {
                return x.Path !== '/reports/0';
            }), 'PageOrder');
            var reportAddPage = vm.project.Pages.find(function (x) {
                return x.Path === '/reports/0';
            });

            var itemToAdd = void 0;
            if (dropResult.removedIndex != null) {
                itemToAdd = temp.splice(dropResult.removedIndex, 1)[0];
            }
            if (dropResult.addedIndex !== null) {
                temp.splice(dropResult.addedIndex, 0, itemToAdd);
            }

            var order = 1;
            temp.forEach(function (x) {
                x.PageOrder = order++;
            });
            if (reportAddPage) {
                temp = [reportAddPage].concat(_toConsumableArray(temp));
            }

            vm.project.Pages = temp;
        },
        onReportSettingsDrop: function onReportSettingsDrop(dropResult) {
            var vm = this;

            if (dropResult.removedIndex === dropResult.addedIndex) {
                return;
            }

            var temp = _.orderBy(vm.project.ReportSettings, 'itemOrder');
            var itemToAdd = void 0;
            if (dropResult.removedIndex != null) {
                itemToAdd = temp.splice(dropResult.removedIndex, 1)[0];
            }
            if (dropResult.addedIndex !== null) {
                temp.splice(dropResult.addedIndex, 0, itemToAdd);
            }

            var order = 1;
            temp.forEach(function (x) {
                x.itemOrder = order++;
            });

            vm.project.ReportSettings = temp;
        },
        onPageEdit: function onPageEdit(page) {
            this.project.Pages.forEach(function (x) {
                x.Edited = false;
            });
            page.Edited = true;
        },
        onShowModal: function onShowModal(modal) {
            var _this = this;

            this.$nextTick(function () {
                _this.$refs[modal].show();
            });
        },
        updateSkuSettingsItem: function updateSkuSettingsItem() {
            var vm = this;
            for (var s in vm.dialogSkuSettings.sku) {
                if (vm.currentSkuListSettingItem.sku[s]) {
                    vm.currentSkuListSettingItem.sku[s].search = vm.dialogSkuSettings.sku[s].search;
                    vm.currentSkuListSettingItem.sku[s].attached = vm.dialogSkuSettings.sku[s].attached;
                } else {
                    vm.currentSkuListSettingItem.sku[s] = {
                        search: vm.dialogSkuSettings.sku[s].search,
                        attached: vm.dialogSkuSettings.sku[s].attached
                    };
                }
            }
            vm.currentSkuListSettingItem.__ob__.dep.notify();

            this.$refs.ppSkuFieldSettings.close();
        },
        setUpSkuList: function setUpSkuList(settingsItem) {
            var vm = this;

            vm.currentSkuListSettingItem = settingsItem;

            for (var s in vm.dialogSkuSettings.sku) {
                if (vm.currentSkuListSettingItem.sku[s]) {
                    vm.dialogSkuSettings.sku[s].search = vm.currentSkuListSettingItem.sku[s].search;
                    vm.dialogSkuSettings.sku[s].attached = vm.currentSkuListSettingItem.sku[s].attached;
                }
            }
            vm.dialogSkuSettings.__ob__.dep.notify();

            vm.onShowModal('ppSkuFieldSettings');
        },
        onReportSettingsTypesChange: function onReportSettingsTypesChange(settings) {
            var vm = this;
            if (settings.type === 'sku') {
                settings.sku = {};
                for (var s in vm.skuSettings) {
                    settings.sku[s] = { search: false, attached: false };
                    //vm.dialogSkuSettings.sku[s] = {search: false, attached: false};
                }

                // не лучший вариант, но пока и не обязательно второе поле
                var skuSelectCount = this.project.ReportSettings.filter(function (x) {
                    return x.type === 'sku';
                }).length;
                if (skuSelectCount === 1) {
                    settings.name = 'SkuId';
                } else {
                    settings.name = 'SkuId' + skuSelectCount;
                }
            } else {
                //delete settings.sku;
            }
            vm.updateReportSettingsDate();
        },
        onReportSettingsCaptionChange: function onReportSettingsCaptionChange(settings) {
            var vm = this;
            if (settings.type === 'date') {
                vm.updateReportSettingsDate();
            }
        },
        addReportSettings: function addReportSettings() {
            var newOrder = 1;
            this.project.ReportSettings.forEach(function (x) {
                if (x.itemOrder != undefined && x.itemOrder > newOrder) {
                    newOrder = x.itemOrder + 1;
                }
            });
            this.project.ReportSettings.push({ type: 'string', deleted: false, new: true, itemOrder: newOrder });
        },
        onRemoveReportSettings: function onRemoveReportSettings(settings, i) {
            if (settings.type === 'date') this.updateReportSettingsDate();
            //settings.deleted = true;
            this.project.ReportSettings.splice(i, 1);
        },
        updateReportSettingsDate: function updateReportSettingsDate() {
            var vm = this;
            //vm.bonusStrategyAccrualValueDate = [ { Value: 'none', Name: 'Не выбрано' } ];
            vm.bonusStrategyAccrualValueDate = [{ Value: 'none', Name: 'Не выбрано' }, { Value: 'dateCreate', Name: 'Дата создания' }, { Value: 'dateAccept', Name: 'Дата принятия' }, { Value: 'dateReport', Name: 'Дата отчета' }];
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = vm.reportSettingsOrdered[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var s = _step4.value;

                    if (!s.deleted && s.type == 'date' && s.caption && s.name) {
                        vm.bonusStrategyAccrualValueDate.push({ Value: s.name, Name: s.caption });
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }
        },
        addFirstLaunchSettingsItem: function addFirstLaunchSettingsItem() {
            this.project.ProjectFirstLaunchSettings.push({ new: true });
        },
        onRemoveFirstLaunchSettings: function onRemoveFirstLaunchSettings(i) {
            this.project.ProjectFirstLaunchSettings.splice(i, 1);
        },
        addPhotoSettings: function addPhotoSettings() {
            this.project.ReportPhotoFields.push({
                Name: 'Новый блок',
                Required: false
            });
        },
        onRemovePhotoSettings: function onRemovePhotoSettings(i) {
            this.project.ReportPhotoFields.splice(i, 1);
        },
        onChangeDate: function onChangeDate(item, formatted, raw) {
            item[raw] = Object(__WEBPACK_IMPORTED_MODULE_4_moment__["default"])(item[formatted], 'DD.MM.YYYY').format();
        },
        cancel: function cancel() {
            this.$router.back();
        },
        onRoles: function onRoles() {
            this.$router.push('/projects/' + this.$route.params.id + '/roles/');
        },
        onUsers: function onUsers() {
            this.$router.push('/projects/' + this.$route.params.id + '/users/');
        },
        onTradePoints: function onTradePoints() {
            this.$router.push('/projects/' + this.$route.params.id + '/trade-points/');
        },
        loadSettings: function loadSettings() {
            var vm = this;
            var projectId = parseInt(this.$route.params.id);
            this.callApiWrapper(backendApi.skuSettings(projectId)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки настроек sku');
                } else {
                    if (resp.data) {
                        //console.info('resp.data', resp.data)
                        var dict = {};
                        var _iteratorNormalCompletion5 = true;
                        var _didIteratorError5 = false;
                        var _iteratorError5 = undefined;

                        try {
                            for (var _iterator5 = resp.data[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                var s = _step5.value;

                                if (!dict[s.FieldName]) {
                                    dict[s.FieldName] = s;
                                }
                            }
                        } catch (err) {
                            _didIteratorError5 = true;
                            _iteratorError5 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                    _iterator5.return();
                                }
                            } finally {
                                if (_didIteratorError5) {
                                    throw _iteratorError5;
                                }
                            }
                        }

                        vm.skuSettings = dict;

                        var sList = {
                            sku: {}
                        };
                        for (var _s in vm.skuSettings) {
                            sList.sku[_s] = { search: false, attached: false, Title: vm.skuSettings[_s].Title, SettingsOrder: vm.skuSettings[_s].SettingsOrder };
                        }
                        vm.dialogSkuSettings = sList;
                    }
                }
            });

            vm.accrualValueTable = {
                bonusSettings: {
                    bonusStrategy: {
                        type: ''
                    },
                    noReport: true,
                    skuView: 'none'
                },
                TradePoint: { Id: 0, SkuLink: '' },
                reportSettings: [],
                equipmentTypes: [{ Id: 0, Name: '' }],
                sku: [{ Id: -1, Name: '' }],
                ReportDate: new Date(),
                canBeEdited: true,
                minItems: 0,
                maxItems: 50,
                ReportItems: []
            };
            vm.accrualValueTable.reportSettings.push({ name: 'value', type: 'decimal', caption: 'Значение', id: 0 });
            vm.accrualValueTable.reportSettings.push({ name: 'dateBeg', type: 'date', caption: 'Дата начала', id: 1 });
            vm.accrualValueTable.reportSettings.push({ name: 'dateEnd', type: 'date', caption: 'Дата окончания', id: 2 });
        },
        loadRoles: function loadRoles() {
            var vm = this;
            return this.callApiWrapper(backendApi.rolesList(this.$route.params.id)).then(function (resp) {
                if (resp.data) {

                    vm.roles = resp.data.Roles;
                }
            });
        },
        loadOzonAccounts: function loadOzonAccounts() {
            var vm = this;
            return this.callApiWrapper(backendApi.commonOzonAccounts()).then(function (resp) {
                if (resp.data) {
                    var _vm$ozonAccounts;

                    (_vm$ozonAccounts = vm.ozonAccounts).push.apply(_vm$ozonAccounts, _toConsumableArray(resp.data));
                }
            });
        },
        loadCountries: function loadCountries() {
            var vm = this;
            return this.callApiWrapper(backendApi.commonCountries()).then(function (resp) {
                if (resp.data) {
                    var _vm$countries;

                    (_vm$countries = vm.countries).push.apply(_vm$countries, _toConsumableArray(resp.data));
                }
            });
        },
        loadProject: function loadProject() {
            var that = this;
            var id = parseInt(this.$route.params.id);
            if (id === 0) {
                var defaultPages = [];
                var order = 1;
                for (var path in defaultPageNames) {
                    defaultPages.push({
                        Path: path,
                        DefaultName: defaultPageNames[path],
                        PageOrder: order++,
                        Edited: false
                    });
                }

                this.project = {
                    new: true,
                    ReportSettings: [],
                    bonusSettings: {
                        "activationPeriod": {
                            "type": null,
                            "data": {
                                "period": null,
                                "value": 0,
                                "fromDate": "approved"
                            }
                        },
                        "durationPeriod": null,
                        "bonusStrategy": {
                            "type": null,
                            "data": {
                                "fieldName": null,
                                "value": 0,
                                "accrualType": 1,
                                "ValueItems": [],
                                "accrualValueDate": null
                            }
                        }
                    },
                    ReportPhotoFields: [{
                        Name: 'Прикрепите фотоотчет',
                        Required: true
                    }],
                    ProjectFirstLaunchSettings: [],
                    Pages: defaultPages,
                    RatingRoles: [],
                    ExternalEnabled: false,
                    ExternalVk: false,
                    ExternalGoogle: false,
                    ExternalFacebook: false,
                    RegisterSettings: {
                        AutoConfirmUser: false,
                        Enabled: false,
                        DefaultRoleId: null,
                        RegisterTradePointType: 0,
                        TradePointColumns: [],
                        RegFields: []
                    },
                    ComplimentarySettings: {},
                    RegisterCodeMobile: '',
                    VisualDesign: {},
                    FeedbackSettings: {}
                };
                that.GetRegisterCodeMobile();
                // Установить страну по умолчанию и обновить НДФЛ
                if (this.countries.length > 0) {
                    this.project.CountryId = this.countries[0].Id;
                    this.updateAdditionalValueFeeOptions();
                }

                return new Promise(function (resolve) {
                    return resolve();
                });
            } else {
                return backendApi.projectLoad(id).then(function (response) {
                    //console.info('project.edit -> load, response:', response.data);
                    if (response.hasError) {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке проекта');
                    } else {
                        var data = response.data;

                        if (data == null) {
                            that.$router.push('/projects');
                        }

                        data.StartDateFormatted = that.formatDate(data.StartDate);
                        data.EndDateFormatted = that.formatDate(data.EndDate);
                        data.FileName = null;
                        data.FileData = null;
                        data.DeleteImage = null;

                        if (data.ComplimentarySettings) {
                            data.ComplimentarySettings.PeriodStartDateFormatted = that.formatDate(data.ComplimentarySettings.PeriodStartDate);
                            data.ComplimentarySettings.PeriodEndDateFormatted = that.formatDate(data.ComplimentarySettings.PeriodEndDate);
                            data.ComplimentarySettings.ExpirationDateFormatted = that.formatDate(data.ComplimentarySettings.ExpirationDate);
                        }

                        data.bonusSettings = JSON.parse(data.BonusSettings || '[]');
                        var rsData = JSON.parse(data.ReportSettings || '[]');
                        var itemOrder = 1;
                        var _iteratorNormalCompletion6 = true;
                        var _didIteratorError6 = false;
                        var _iteratorError6 = undefined;

                        try {
                            for (var _iterator6 = rsData[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                                var item = _step6.value;

                                if (typeof item.deleted === 'undefined') {
                                    item.deleted = false;
                                }
                                item.itemOrder = itemOrder;
                                itemOrder++;
                            }
                        } catch (err) {
                            _didIteratorError6 = true;
                            _iteratorError6 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                    _iterator6.return();
                                }
                            } finally {
                                if (_didIteratorError6) {
                                    throw _iteratorError6;
                                }
                            }
                        }

                        data.ReportSettings = rsData;

                        var _iteratorNormalCompletion7 = true;
                        var _didIteratorError7 = false;
                        var _iteratorError7 = undefined;

                        try {
                            for (var _iterator7 = data.Pages[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                                var _item = _step7.value;

                                _item.DefaultName = defaultPageNames[_item.Path];
                                _item.Edited = false;
                            }
                        } catch (err) {
                            _didIteratorError7 = true;
                            _iteratorError7 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                    _iterator7.return();
                                }
                            } finally {
                                if (_didIteratorError7) {
                                    throw _iteratorError7;
                                }
                            }
                        }

                        itemOrder = data.Pages.length;

                        var _loop = function _loop(_path) {
                            newArray = data.Pages.filter(function (f) {
                                return f.DefaultName === defaultPageNames[_path];
                            });

                            if (newArray.length === 0) {
                                data.Pages.push({
                                    Path: _path,
                                    DefaultName: defaultPageNames[_path],
                                    PageOrder: itemOrder++,
                                    Edited: false
                                });
                            }
                        };

                        for (var _path in defaultPageNames) {
                            var newArray;

                            _loop(_path);
                        }

                        data.AnalyticsReportProcedureType = data.AnalyticsReportProcedureName ? 1 : 0;

                        data.ExternalEnabled = data.ExternalVk || data.ExternalGoogle || data.ExternalFacebook;
                        if (data.VisualDesign) data.VisualDesign = JSON.parse(data.VisualDesign);else data.VisualDesign = {};
                        data.FeedbackSettings = JSON.parse(data.FeedbackSettings || '{}');

                        /* for (let roleSettings of data.ProjectAnalyticsRoles){
                             let role = that.roles.find(x => x.Id === roleSettings.DynamicRoleId);
                             roleSettings.RoleName =
                         }*/
                        if (!data.bonusSettings.bonusStrategy.data.ValueItems) data.bonusSettings.bonusStrategy.data.ValueItems = [];
                        if (!data.bonusSettings.activationPeriod.data.fromDate) data.bonusSettings.activationPeriod.data.fromDate = "approved";

                        that.project = data;
                        that.updateReportSettingsDate();

                        // Установить страну по умолчанию и обновить НДФЛ, если CountryId не задан
                        if (!that.project.CountryId && that.countries.length > 0) {
                            that.project.CountryId = that.countries[0].Id;
                        }
                        that.updateAdditionalValueFeeOptions();
                    }
                });
            }
        },
        saveProject: function saveProject() {
            var vm = this;

            this.$validator.validate().then(function (result) {
                if (!result) {
                    if (vm.project.RegisterSettings.Enabled && vm.project.RegisterSettings.RegisterTradePointType === __WEBPACK_IMPORTED_MODULE_5__enums__["i" /* RegisterTradePointTypes */].Select && !vm.project.RegisterSettings.TradePointColumns.length) {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Выберите хотя бы одно поле из адрески');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                    }
                } else {
                    if (vm.project.bonusSettings.bonusStrategy.type === 'data' && vm.project.bonusSettings.bonusStrategy.data.accrualType === '1' && vm.project.bonusSettings.bonusStrategy.data.accrualValueDate !== 'none') {
                        if (vm.project.bonusSettings.bonusStrategy.data.ValueItems.length > 0) {
                            var _iteratorNormalCompletion8 = true;
                            var _didIteratorError8 = false;
                            var _iteratorError8 = undefined;

                            try {
                                for (var _iterator8 = vm.project.bonusSettings.bonusStrategy.data.ValueItems[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                                    var s = _step8.value;
                                    var _iteratorNormalCompletion10 = true;
                                    var _didIteratorError10 = false;
                                    var _iteratorError10 = undefined;

                                    try {
                                        for (var _iterator10 = s.Fields[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                                            var field = _step10.value;

                                            if (field.Value == null || field.Value.length === 0) {
                                                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные таблицы, все поля обязательны для заполнения!');
                                                return;
                                            }
                                            if (field.Name === 'dateBeg') s.Id = Object(__WEBPACK_IMPORTED_MODULE_4_moment__["default"])(field.Value, 'DD.MM.YYYY').format();
                                        }
                                    } catch (err) {
                                        _didIteratorError10 = true;
                                        _iteratorError10 = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion10 && _iterator10.return) {
                                                _iterator10.return();
                                            }
                                        } finally {
                                            if (_didIteratorError10) {
                                                throw _iteratorError10;
                                            }
                                        }
                                    }
                                }
                            } catch (err) {
                                _didIteratorError8 = true;
                                _iteratorError8 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion8 && _iterator8.return) {
                                        _iterator8.return();
                                    }
                                } finally {
                                    if (_didIteratorError8) {
                                        throw _iteratorError8;
                                    }
                                }
                            }

                            var itemsOrdered = _.orderBy(vm.project.bonusSettings.bonusStrategy.data.ValueItems, 'Id');
                            var dateBeg = itemsOrdered[0].Id;
                            var todayDate = Object(__WEBPACK_IMPORTED_MODULE_4_moment__["default"])(new Date()).format();
                            if (dateBeg > todayDate) {
                                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные таблицы, первая дата должна быть не позднее текущей!');
                                return;
                            }
                            var dateEnd = Object(__WEBPACK_IMPORTED_MODULE_4_moment__["default"])(dateBeg).add(-1, 'days').format();
                            var diffDays = 0;
                            var _iteratorNormalCompletion9 = true;
                            var _didIteratorError9 = false;
                            var _iteratorError9 = undefined;

                            try {
                                for (var _iterator9 = itemsOrdered[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                                    var _s2 = _step9.value;

                                    dateBeg = _s2.Id;
                                    diffDays = Object(__WEBPACK_IMPORTED_MODULE_4_moment__["default"])(dateBeg).diff(Object(__WEBPACK_IMPORTED_MODULE_4_moment__["default"])(dateEnd), 'days');
                                    if (diffDays < 1) {
                                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные таблицы, имеется перекрестный период!');
                                        return;
                                    }
                                    if (diffDays > 1) {
                                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные таблицы, имеется окно между периодами!');
                                        return;
                                    }
                                    dateEnd = Object(__WEBPACK_IMPORTED_MODULE_4_moment__["default"])(_s2.Fields[2].Value, 'DD.MM.YYYY').format();
                                    if (dateBeg > dateEnd) {
                                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные таблицы, дата начала не может быть позднее даты окончания!');
                                        return;
                                    }
                                    _s2.Id = 0;
                                }
                            } catch (err) {
                                _didIteratorError9 = true;
                                _iteratorError9 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion9 && _iterator9.return) {
                                        _iterator9.return();
                                    }
                                } finally {
                                    if (_didIteratorError9) {
                                        throw _iteratorError9;
                                    }
                                }
                            }

                            if (dateEnd < todayDate) {
                                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные таблицы, конечная дата должна быть позднее текущей!');
                                return;
                            }
                        } else {
                            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные таблицы, необходимо добавить хотя бы одну строку!');
                            return;
                        }
                    }
                    var reg = /^#([0-9a-f]{3}){1,2}$/i;
                    if (vm.project.VisualDesign.MenuColorSite && !reg.test(vm.project.VisualDesign.MenuColorSite)) {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные, цвет иконок меню не является цветом!');
                        return;
                    }
                    if (vm.project.VisualDesign.MenuColorLight && !reg.test(vm.project.VisualDesign.MenuColorLight)) {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные, цвет иконок меню не является цветом!');
                        return;
                    }
                    if (vm.project.VisualDesign.MenuColorDark && !reg.test(vm.project.VisualDesign.MenuColorDark)) {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные, цвет иконок меню не является цветом!');
                        return;
                    }

                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('.page-content', 'Сохранение...');

                    // that.project.StartDate = moment(that.project.StartDateFormatted, 'DD.MM.YYYY').format();
                    // that.project.EndDate = moment(that.project.EndDateFormatted, 'DD.MM.YYYY').format();

                    var saveObj = Object.assign({}, vm.project, {
                        DeleteImage: vm.deleteImage,
                        DeleteStartImage: vm.deleteStartImage,
                        DeletePolicyFile: vm.deletePolicyFile,
                        DeleteRulesFile: vm.deleteRulesFile
                    });
                    saveObj.BonusSettings = vm.bonusSettingsStr;
                    saveObj.ReportSettings = vm.reportSettingsStr;
                    saveObj.PhotoSettings = vm.photoSettingsStr;
                    saveObj.VisualDesign = vm.visualDesignStr;
                    saveObj.FeedbackSettings = vm.feedbackSettingsStr;

                    var _iteratorNormalCompletion11 = true;
                    var _didIteratorError11 = false;
                    var _iteratorError11 = undefined;

                    try {
                        for (var _iterator11 = saveObj.ProjectFirstLaunchSettings[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                            var x = _step11.value;

                            if (x.file != null) {
                                x.FileTitle = x.file.name;
                            }
                        }
                    } catch (err) {
                        _didIteratorError11 = true;
                        _iteratorError11 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion11 && _iterator11.return) {
                                _iterator11.return();
                            }
                        } finally {
                            if (_didIteratorError11) {
                                throw _iteratorError11;
                            }
                        }
                    }

                    if (vm.project.AnalyticsReportProcedureType === 0) {
                        saveObj.AnalyticsReportProcedureName = null;
                    }
                    saveObj.DynamicRoles = vm.roles.filter(function (x) {
                        return x.Claims.some(function (y) {
                            return y.ClaimId === vm.claimEnums.ratingSwitcher;
                        });
                    }).map(function (x) {
                        return x.Id;
                    });

                    delete saveObj.bonusSettings;

                    if (!saveObj.ExternalEnabled) {
                        saveObj.ExternalVk = saveObj.ExternalGoogle = saveObj.ExternalFacebook = false;
                    }

                    backendApi.projectSave(saveObj).then(function (response) {
                        //console.info('details -> projectSave, response:', response.data);
                        if (response.hasError) {
                            if (response.status === 401) {
                                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Недостаточно прав');
                            } else {
                                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении проекта');
                            }
                            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('.page-content');
                        } else {
                            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');

                            if (vm.project.new) {
                                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('.page-content');
                                vm.$router.push('/projects');
                            } else {
                                vm.loadProject().then(function () {
                                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('.page-content');
                                });
                            }
                        }
                    });
                }
            });
        },
        deleteProject: function deleteProject() {
            if (confirm('Вы уверены что хотите удалить проект?')) {
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('.page-content', 'Удаление...');
                var vm = this;

                backendApi.projectDelete(vm.$route.params.id).then(function (response) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('.page-content');
                    if (response.hasError) {
                        if (response.status === 401) {
                            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Недостаточно прав');
                        } else {
                            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при удалении проекта');
                        }
                    } else {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.success('Прокт успешно удалён');
                        vm.$router.push('/projects');
                    }
                });
            }
        },
        removeImage: function removeImage() {
            this.deleteImage = true;
        },
        removeStartImage: function removeStartImage() {
            this.deleteStartImage = true;
        },
        removeLaunchSettingsImage: function removeLaunchSettingsImage(launchSettings, i) {
            launchSettings.deleteImage = true;
            this.$set(this.project.ProjectFirstLaunchSettings, i, launchSettings);
        },
        onLaunchSettingsImageChange: function onLaunchSettingsImageChange($event, i) {
            var vm = this;
            if ($event.target.files[0].size > 5 * 1024 * 1024) {
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Превышен размер. Выберите другой файл');
                //$('[name="dropFiles"]').val('');
            } else {
                vm.project.ProjectFirstLaunchSettings[i].file = $event.target.files[0];
                //vm.project.ProjectFirstLaunchSettings[i].FileTitle = $event.target.files[0].name;
                vm.project.ProjectFirstLaunchSettings[i].deleteImage = false;
                vm.$set(vm.project.ProjectFirstLaunchSettings, i, vm.project.ProjectFirstLaunchSettings[i]);

                var reader = new FileReader();
                reader.onload = function (e) {
                    vm.project.ProjectFirstLaunchSettings[i].FileData = e.target.result;
                    vm.$set(vm.project.ProjectFirstLaunchSettings, i, vm.project.ProjectFirstLaunchSettings[i]);
                };
                reader.readAsDataURL($event.target.files[0]);
            }
        },
        addRatingRole: function addRatingRole() {
            this.project.RatingRoles.push({
                Name: 'Новая роль',
                Value: null,
                Default: false
            });
        },
        onRemoveRatingRole: function onRemoveRatingRole(i) {
            this.project.RatingRoles.splice(i, 1);
        },
        GetRegisterCodeMobile: function GetRegisterCodeMobile() {
            var vm = this;
            this.callApiWrapper(backendApi.projectRegisterCode()).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время получения кода');
                } else {
                    vm.project.RegisterCodeMobile = resp.data;
                }
                console.info('GetRegisterCodeMobile', resp.data, vm.project.RegisterCodeMobile);
            });
        },
        onRegFieldsDrop: function onRegFieldsDrop(dropResult) {
            var vm = this;

            if (dropResult.removedIndex === dropResult.addedIndex) {
                return;
            }

            var temp = _.orderBy(vm.project.RegisterSettings.RegFields, 'ItemOrder');
            var itemToAdd = void 0;
            if (dropResult.removedIndex != null) {
                itemToAdd = temp.splice(dropResult.removedIndex, 1)[0];
            }
            if (dropResult.addedIndex !== null) {
                temp.splice(dropResult.addedIndex, 0, itemToAdd);
            }

            var order = 1;
            temp.forEach(function (x) {
                x.ItemOrder = order++;
            });

            vm.project.RegisterSettings.RegFields = temp;
        },
        onRemoveRegField: function onRemoveRegField(i) {
            this.project.RegisterSettings.RegFields.splice(i, 1);
        },
        addRegField: function addRegField() {
            if (this.project.RegisterSettings.RegFields.length > 9) return;
            var newOrder = 1;
            this.project.RegisterSettings.RegFields.forEach(function (x) {
                if (x.ItemOrder != undefined && x.ItemOrder >= newOrder) {
                    newOrder = x.ItemOrder + 1;
                }
            });
            this.project.RegisterSettings.RegFields.push({ FieldType: 'string', Deleted: false, new: true, ItemOrder: newOrder });
        }
    },

    mounted: function mounted() {
        var vm = this;

        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('.page-content', 'Загрузка...');

        Promise.all([vm.loadSettings(), vm.loadRoles(), vm.loadOzonAccounts(), vm.loadCountries()]).then(function () {

            vm.loadProject().then(function () {
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('.page-content');

                vm.updateAdditionalValueFeeOptions(); // Обновить значения НДФЛ после загрузки проекта

                vm.$nextTick(function () {

                    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').on('click', function () {
                        vm.project.Pages.forEach(function (x) {
                            x.Edited = false;
                        });
                    });
                });
            });
        });

        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on('click', '.block-in-page-collapce', function () {
            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].block_collapse(this);
        });

        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on('change', '[name="dropFiles"]', function () {
            if (this.files && this.files[0]) {
                if (this.files[0].size > 5 * 1024 * 1024) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Превышен размер. Выберите другой файл');
                    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('[name="dropFiles"]').val('');
                } else {
                    vm.file = this.files[0];
                    vm.project.FileName = this.files[0].name;
                    vm.project.DeleteImage = false;

                    var reader = new FileReader();
                    reader.onload = function (e) {
                        vm.project.FileData = e.target.result;
                    };
                    reader.readAsDataURL(this.files[0]);
                }
            }
        });

        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on('change', '[name="dropFilesStart"]', function () {
            if (this.files && this.files[0]) {
                if (this.files[0].size > 5 * 1024 * 1024) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Превышен размер. Выберите другой файл');
                    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('[name="dropFilesStart"]').val('');
                } else {
                    vm.fileStart = this.files[0];
                    vm.project.StartImageName = this.files[0].name;
                    vm.project.DeleteStartImage = false;

                    var reader = new FileReader();
                    reader.onload = function (e) {
                        vm.project.StartImageData = e.target.result;
                    };
                    reader.readAsDataURL(this.files[0]);
                }
            }
        });

        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on('change', '[name="dropFiles2"]', function () {
            if (this.files && this.files[0]) {
                if (this.files[0].size > 5 * 1024 * 1024) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Превышен размер. Выберите другой файл');
                    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('[name="dropFiles2"]').val('');
                } else {
                    vm.policyFile = this.files[0];
                    vm.project.PolicyFileName = this.files[0].name;
                    vm.project.DeletePolicyFile = false;

                    var reader = new FileReader();
                    reader.onload = function (e) {
                        vm.project.PolicyFileData = e.target.result;
                    };
                    reader.readAsDataURL(this.files[0]);
                }
            }
        });

        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on('change', '[name="dropFiles3"]', function () {
            if (this.files && this.files[0]) {
                if (this.files[0].size > 5 * 1024 * 1024) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Превышен размер. Выберите другой файл');
                    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('[name="dropFiles3"]').val('');
                } else {
                    vm.rulesFile = this.files[0];
                    vm.project.RulesFileName = this.files[0].name;
                    vm.project.DeleteRulesFile = false;

                    var reader = new FileReader();
                    reader.onload = function (e) {
                        vm.project.RulesFileData = e.target.result;
                    };
                    reader.readAsDataURL(this.files[0]);
                }
            }
        });
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).off('change', '[name="dropFiles"]');
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).off('change', '[name="dropFiles2"]');
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).off('change', '[name="dropFiles3"]');
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).off('change', '[name="dropFilesStart"]');
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).off('click', '.block-in-page-collapce');
    }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_project_mixin__ = __webpack_require__(12);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var backendApi = new __WEBPACK_IMPORTED_MODULE_2__backendApi__["a" /* default */]();
var cacheKey = 'usersState';

var rowsPerPage = 30;

var processFilter = function processFilter(filter) {
    if (!filter) {
        return null;
    }
    var filterCopy = JSON.parse(JSON.stringify(filter));
    var stateEnums = {
        '[dbo].[AspNetUsers].[TermsConfirmed]': {
            'Да': 1,
            'Нет': 0
        },
        '[dbo].[AspNetUsers].[PersonalDataEditingAccept]': {
            'Да': 1,
            'Нет': 0
        },
        '[dbo].[AspNetUsers].[NotificationsEnabled]': {
            'Да': 1,
            'Нет': 0
        },
        '[dbo].[AspNetUsers].[PassportVerificationState]': {
            'паспортные данные отсутствуют': 0,
            'проверь паспортные данные!': 1,
            'паспортные данные подтверждены': 2,
            'паспортные данные возвращены': 3
        },
        '[dbo].[AspNetUsers].[RegisterStatus]': {
            'неактивен': 0,
            'проверка': 1,
            'активен': 2,
            'отказано': 3,
            'отключен': 4,
            'заблокирован': 5
        },
        '[dbo].[AspNetUsers].[PaymentSettingsVerificationState]': {
            'банковская карта отсутствует': 0,
            'проверь банковскую карту!': 1,
            'банковская карта подтверждена': 2,
            'банковская карта возвращена': 3
        }
    };

    var resultFilter = [];

    var _loop = function _loop(item) {
        var filterField = item[0];
        //console.info('item:', JSON.stringify(item))
        var dontPushItem = false;
        if (filterField === '[dbo].[AspNetUsers].[TermsConfirmed]' || filterField === '[dbo].[AspNetUsers].[PersonalDataEditingAccept]' || filterField === '[dbo].[AspNetUsers].[NotificationsEnabled]' || filterField === '[dbo].[AspNetUsers].[PassportVerificationState]' || filterField === '[dbo].[AspNetUsers].[RegisterStatus]' || filterField === '[dbo].[AspNetUsers].[PaymentSettingsVerificationState]') {

            var values = item[2].substring(1, item[2].length - 1).split(';').map(function (x) {
                return decodeURI(x);
            }).map(function (x) {
                var name = x.substring(1, x.length - 1);
                var state = stateEnums[filterField][name];
                return state;
            });

            if (filterField === '[dbo].[AspNetUsers].[TermsConfirmed]' || filterField === '[dbo].[AspNetUsers].[PersonalDataEditingAccept]' || filterField === '[dbo].[AspNetUsers].[NotificationsEnabled]' || filterField === '[dbo].[AspNetUsers].[PassportVerificationState]' || filterField === '[dbo].[AspNetUsers].[RegisterStatus]' || filterField === '[dbo].[AspNetUsers].[PaymentSettingsVerificationState]') {

                item[0] = 'isnull(' + filterField + '%comma%0)';

                if (filterField === '[dbo].[AspNetUsers].[RegisterStatus]') {
                    var dateFilters = values.filter(function (x) {
                        return x === 4 || x === 5 || x === 2;
                    });
                    var statusFilters = values.filter(function (x) {
                        return x !== 4 && x !== 5 && x !== 2;
                    });

                    var dateFilterPart = '';
                    if (dateFilters.length) {
                        if (values.indexOf(4) > -1 && values.indexOf(5) === -1) {
                            // только Отключен
                            dateFilterPart = '[dbo].[UserDynamicRoles].[DisabledDateTime] <= getdate() and ([dbo].[UserDynamicRoles].[BlockedDateTime] is null or [dbo].[UserDynamicRoles].[BlockedDateTime] > getdate())';
                        }
                        if (values.indexOf(5) > -1 && values.indexOf(4) === -1) {
                            // только Заблокирован
                            dateFilterPart = '[dbo].[UserDynamicRoles].[BlockedDateTime] <= getdate()';
                        }
                        if (values.indexOf(5) > -1 && values.indexOf(4) > -1) {
                            // оба фильтра
                            dateFilterPart = '([dbo].[UserDynamicRoles].[DisabledDateTime] <= getdate() or [dbo].[UserDynamicRoles].[BlockedDateTime] <= getdate())';
                        }

                        // если есть фильтр "Активен"
                        if (values.indexOf(2) > -1) {
                            if (dateFilterPart) {
                                // если уже указаны фильтры Заблокирован или Отключен
                                dateFilterPart = '( (' + dateFilterPart + ') or [dbo].[AspNetUsers].[RegisterStatus] = 2' + ')';
                            } else {
                                // только фильтр Активен
                                dateFilterPart = '[dbo].[AspNetUsers].[RegisterStatus] = 2 and ([dbo].[UserDynamicRoles].[BlockedDateTime] is null or [dbo].[UserDynamicRoles].[BlockedDateTime] > getdate())' + 'and ([dbo].[UserDynamicRoles].[DisabledDateTime] is null or [dbo].[UserDynamicRoles].[DisabledDateTime] > getdate())';
                            }
                        }
                    }

                    if (statusFilters.length) {
                        item[2] = '(' + values.filter(function (x) {
                            return x !== 4 && x !== 5 && x !== 2;
                        }).map(function (item) {
                            return '' + encodeURI(item);
                        }).join(';') + ')';
                    } else {
                        dontPushItem = true;
                    }

                    if (dateFilters.length && !statusFilters.length) {
                        resultFilter.push(['', '', dateFilterPart]);
                    }

                    if (dateFilters.length && statusFilters.length) {
                        dontPushItem = true;
                        resultFilter.push(['', '', '(' + item.join(' ') + ' or ' + dateFilterPart + ')']);
                    }
                } else if (filterField === '[dbo].[AspNetUsers].[PaymentSettingsVerificationState]') {
                    var hasNullStatus = values.indexOf(0) > -1;
                    var statuses = values.filter(function (x) {
                        return x !== 0;
                    });

                    if (hasNullStatus && statuses.length) {
                        resultFilter.push(['', '', '([dbo].[UserPaymentSettings].[VerificationStateId] in (' + statuses.join('%comma% ') + ') or [dbo].[UserPaymentSettings].[VerificationStateId] is null)']);
                        dontPushItem = true;
                    } else if (hasNullStatus) {
                        item[1] = 'is';
                        item[2] = 'null';
                    } else {
                        item[2] = '(' + statuses.map(function (i) {
                            return '' + encodeURI(i);
                        }).join(';') + ')';
                    }
                } else {
                    item[2] = '(' + values.map(function (item) {
                        return '' + encodeURI(item);
                    }).join(';') + ')';
                }
            } else {
                item[2] = '(' + values.map(function (item) {
                    return '\'' + encodeURI(item) + '\'';
                }).join(';') + ')';
            }
        }

        if (filterField === '[dbo].[AspNetUsers].[UserRole]') {
            item[0] = '[dbo].[DynamicRole]';
        }

        if (filterField === '[dbo].[AspNetUsers].[PaymentSettingsVerificationState]') {
            item[0] = '[dbo].[UserPaymentSettings].[VerificationStateId]';
        }

        if (!dontPushItem) {
            resultFilter.push(item);
        }
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = filterCopy[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            _loop(item);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return resultFilter;
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "users",

    data: function data() {
        return {
            page: 1,
            users: [],
            importResult: null,
            loading: false,
            canBeLoaded: true,
            filter: null,
            userFilters: [{
                Value: 'LastName', Name: 'Фамилия'
            }, {
                Value: 'FirstName', Name: 'Имя'
            }, {
                Value: 'PhoneNumber', Name: 'Телефон'
            }, {
                Value: 'Email', Name: 'Email'
            }, {
                Value: 'TermsConfirmed', Name: 'Согласен на условия'
            }, {
                Value: 'PersonalDataEditingAccept', Name: 'Согласен на обработку'
            }, {
                Value: 'NotificationsEnabled', Name: 'Согласен на рассылку'
            }, {
                Value: 'PassportVerificationState', Name: 'Статус документов'
            }, {
                Value: 'RegisterStatus', Name: 'Активность'
            }, {
                Value: 'UserRole', Name: 'Роль'
            }],
            roles: [],
            scrollTop: null,
            firstLoad: true,
            project: null,
            infoLoaded: false
        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_6__helpers_project_mixin__["a" /* default */]],

    methods: {
        onNewEntity: function onNewEntity() {
            this.$router.push('/projects/' + this.$route.params.projectId + '/users/0');
        },
        getCurrentRoleName: function getCurrentRoleName(item) {
            var projectId = this.$route.params.projectId;
            if (item.UserDynamicRoles.length) {
                return item.UserDynamicRoles.find(function (x) {
                    return x.ProjectId == projectId;
                }).RoleName;
            }
            return '';
        },
        onFileChange: function onFileChange() {
            var vm = this;

            var files = document.getElementById('dropFiles').files;
            if (files.length > 0) {
                if (window.FormData !== undefined) {
                    var data = new FormData();
                    for (var x = 0; x < files.length; x++) {
                        data.append("file" + x, files[x]);
                    }
                    var projectId = this.$route.params.projectId;
                    var tokenInfo = JSON.parse(localStorage.getItem('tokenInfo') == null ? sessionStorage.getItem('tokenInfo') : localStorage.getItem('tokenInfo'));
                    var headers = {};
                    if (tokenInfo != null) {
                        headers.Authorization = 'bearer ' + tokenInfo.access_token;
                    }

                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('#app');
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
                        type: "POST",
                        url: __WEBPACK_IMPORTED_MODULE_5__config___default.a.apiUrl + '/api/user/import?projectId=' + projectId,
                        contentType: false,
                        processData: false,
                        headers: headers,
                        data: data,
                        success: function success(resp) {
                            if (resp.hasError) {
                                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка импорта');
                            } else {
                                vm.importResult = resp.result;
                                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно импортировано');
                                vm.page = 1;
                                vm.users = [];
                                vm.loadNext();
                            }
                            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
                        },
                        error: function error(xhr, status, p3) {
                            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка на сервере');
                            console.error(xhr.responseText);
                            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
                        }
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Браузер не поддерживает загрузку файлов HTML5!');
                }
            }
        },
        onFileChange2: function onFileChange2() {
            var vm = this;

            var files = document.getElementById('dropFiles2').files;
            if (files.length > 0) {
                if (window.FormData !== undefined) {
                    var data = new FormData();
                    for (var x = 0; x < files.length; x++) {
                        data.append("file" + x, files[x]);
                    }
                    var projectId = this.$route.params.projectId;
                    var tokenInfo = JSON.parse(localStorage.getItem('tokenInfo') == null ? sessionStorage.getItem('tokenInfo') : localStorage.getItem('tokenInfo'));
                    var headers = {};
                    if (tokenInfo != null) {
                        headers.Authorization = 'bearer ' + tokenInfo.access_token;
                    }

                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('#app');
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
                        type: "POST",
                        url: __WEBPACK_IMPORTED_MODULE_5__config___default.a.apiUrl + '/api/user/import-users?projectId=' + projectId,
                        contentType: false,
                        processData: false,
                        headers: headers,
                        data: data,
                        success: function success(resp) {
                            if (resp.hasError) {
                                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка импорта');
                            } else {
                                vm.importResult = resp.result;
                                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно импортировано');
                                vm.page = 1;
                                vm.users = [];
                                vm.loadNext();
                            }
                            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
                        },
                        error: function error(xhr, status, p3) {
                            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка на сервере');
                            console.error(xhr.responseText);
                            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
                        }
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Браузер не поддерживает загрузку файлов HTML5!');
                }
            }
        },
        loadRoles: function loadRoles() {
            var vm = this;
            return this.callApiWrapper(backendApi.rolesList(vm.$route.params.projectId)).then(function (resp) {
                if (resp.data) {

                    for (var r = 0; r < resp.data.Roles.length; r++) {
                        if (!resp.data.Roles[r].Claims.find(function (x) {
                            return x.ClaimId === vm.claimEnums.ttAccess;
                        })) {
                            vm.roles.push({
                                Id: resp.data.Roles[r].Id,
                                Name: resp.data.Roles[r].Name
                            });
                        }
                    }
                }
            });
        },
        loadNext: function loadNext() {
            var vm = this;

            var projectId = this.$route.params.projectId;
            this.loading = true;

            var skip = (vm.page - 1) * rowsPerPage;
            var take = rowsPerPage;
            if (vm.firstLoad && vm.page > 1) {
                skip = 0;
                take = vm.page * rowsPerPage;
            }

            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
            console.info('processFilter(vm.filter):', processFilter(vm.filter));

            this.callApiWrapper(backendApi.usersList(skip, take, projectId, processFilter(vm.filter))).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрзуки пользователей');
                } else {
                    if (resp.data && resp.data.length) {
                        var _vm$users;

                        (_vm$users = vm.users).push.apply(_vm$users, _toConsumableArray(resp.data));

                        if (vm.firstLoad) {
                            vm.firstLoad = false;
                            if (vm.scrollTop) {
                                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').animate({ scrollTop: vm.scrollTop }, 500);
                            }
                        }
                    } else {
                        vm.canBeLoaded = false;
                    }
                }
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                vm.loading = false;
            });
        },
        loadProject: function loadProject() {
            var vm = this;

            return this.callApiWrapper(backendApi.projectLoad(vm.$route.params.projectId)).then(function (resp) {
                if (resp.data) {
                    vm.project = resp.data;
                }
            });
        },
        onItemClick: function onItemClick($event, item) {
            var vm = this;
            vm.saveFilterState();

            if ($event.ctrlKey === true) {
                window.open('/projects/' + this.$route.params.projectId + '/users/' + encodeURIComponent(item.UserName));
            } else {
                vm.$router.push('/projects/' + vm.$route.params.projectId + '/users/' + encodeURIComponent(item.UserName));
            }
        },
        formatAcception: function formatAcception(user) {
            var info = '';
            if (user.TermsConfirmed) {
                info = 'на условия';
            }
            if (user.PersonalDataEditingAccept) {
                if (info) {
                    info += '; ';
                }
                info += 'на обработку';
            }
            if (user.NotificationsEnabled) {
                if (info) {
                    info += '; ';
                }
                info += 'на рассылку';
            }

            return info;
        },
        formatPassportVerificationState: function formatPassportVerificationState(stateId) {
            switch (stateId) {
                case 1:
                    return 'проверь документы!';
                case 2:
                    return 'подтверждены';
                case 3:
                    return 'возвращены';
                default:
                    return 'отсутствуют';
            }
        },


        /*formatPaymentSettingsVerificationState(stateId){
          switch (stateId)
          {
            case 1:
              return 'проверь банковскую карту!';
            case 2:
              return 'банковская карта подтверждена';
            case 3:
              return 'банковская карта возвращена';
            default:
              return 'банковская карта отсутствует';
          }
        },*/

        formatUserStatus: function formatUserStatus(item) {
            if (item.IsBlocked) {
                return 'Заблокирован';
            }
            if (item.IsDisabled) {
                return 'Отключен';
            }
            return item.RegisterStatusFormatted;
        },
        onExport: function onExport() {
            var projectId = this.$route.params.projectId;
            var vm = this;
            var filterstr = [];

            if (vm.filter) {
                var processedFilter = processFilter(vm.filter);
                for (var i = 0; i < this.filter.length; i++) {
                    var item = processedFilter[i];
                    filterstr.push(JSON.stringify(item));
                }
            }

            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('#app');
            vm.callApiWrapper(backendApi.userExport(projectId, filterstr, '', '', '', '', '', '')).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время экспорта');
                } else {
                    var exportFile = resp.data;
                    if (exportFile != null) {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].downloadFileByBytes(exportFile, 'Пользователи.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                    }
                }
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            });
        },
        onExportReport: function onExportReport() {
            var projectId = this.$route.params.projectId;

            var vm = this;
            var filterstr = [];
            if (vm.filter) {
                var processedFilter = processFilter(vm.filter);
                for (var i = 0; i < this.filter.length; i++) {
                    var item = processedFilter[i];
                    filterstr.push(JSON.stringify(item));
                }
            }
            var nowDate = Object(__WEBPACK_IMPORTED_MODULE_4_moment__["default"])(new Date()).format('DD.MM.YYYY');

            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('#app');
            vm.callApiWrapper(backendApi.userExportReport(projectId, filterstr)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время экспорта');
                } else {
                    var exportFile = resp.data;
                    if (exportFile != null) {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].downloadFileByBytes(exportFile, 'Отчет по пользователям ' + nowDate + '.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                    }
                }

                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            });
        },
        getFilterForUri: function getFilterForUri() {
            var str = '';
            if (this.filter) {
                var processedFilter = processFilter(this.filter);
                for (var i = 0; i < processedFilter.length; i++) {
                    var item = processedFilter[i];
                    str += '&filter[' + i + ']=' + JSON.stringify(item);
                }
            }
            return str;
        },
        searchFunction: function searchFunction(tableName, columnName, search, filters, searchPage, callback) {
            console.info('columnName:', columnName);
            if (columnName === 'TermsConfirmed' || columnName === 'PersonalDataEditingAccept' || columnName === 'NotificationsEnabled') {
                callback(['Да', 'Нет']);
            } else if (columnName === 'PassportVerificationState') {
                callback(['паспортные данные отсутствуют', 'проверь паспортные данные!', 'паспортные данные подтверждены', 'паспортные данные возвращены']);
            } else if (columnName === 'RegisterStatus') {
                callback(['неактивен', 'проверка', 'активен', 'отказано', 'отключен', 'заблокирован']);
            } else if (columnName === 'PaymentSettingsVerificationState') {
                callback(['банковская карта отсутствует', 'проверь банковскую карту!', 'банковская карта подтверждена', 'банковская карта возвращена']);
            } else {
                var filterFormatted = '';
                if (filters) {
                    filterFormatted = processFilter(filters).map(function (x) {
                        return JSON.stringify(x);
                    });
                }

                this.callApiWrapper(backendApi.userDistinctValues(columnName, this.$route.params.projectId, search, filterFormatted, (searchPage - 1) * 30, 30)).then(function (resp) {
                    callback(resp.data);
                });
            }
        },
        onFilterChange: function onFilterChange(filter) {
            // спец. настройка для статусов
            // пока так, поскольку динамический фильтр не поддерживает enums
            this.filter = filter;
            this.users = [];
            this.loading = false;
            this.canBeLoaded = true;
            this.page = 1;

            this.loadNext();
        },
        saveFilterState: function saveFilterState() {
            var stateObj = {
                projectId: this.projectId,
                page: this.page,
                scrollTop: this.scrollTop,
                filter: this.filter
            };
            sessionStorage.setItem(cacheKey, JSON.stringify(stateObj));
        },
        recoverFilterState: function recoverFilterState() {
            var stateObj = JSON.parse(sessionStorage.getItem(cacheKey));
            console.info('recoverFilterState', stateObj);
            if (stateObj) {
                if (stateObj.projectId == this.projectId) {
                    if (stateObj.page) {
                        this.page = stateObj.page;
                    }
                    if (stateObj.scrollTop) {
                        this.scrollTop = stateObj.scrollTop;
                    }
                    // if (stateObj.filter) {
                    //     this.filter = stateObj.filter;
                    // }
                }
                this.clearFilterState();
            }
        },
        clearFilterState: function clearFilterState() {
            sessionStorage.removeItem(cacheKey);
        }
    },

    mounted: function mounted() {
        var vm = this;

        vm.recoverFilterState();

        Promise.all([vm.loadRoles(), vm.loadProject()]).then(function () {
            //console.info('loaded!')
            if (vm.project.ProjectHasPhysicalBankCardReward) {
                vm.userFilters.push({
                    Value: 'PaymentSettingsVerificationState', Name: 'Банковская карта'
                });
            }
            vm.infoLoaded = true;

            vm.$nextTick(function () {

                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').on('scroll', function () {
                    var elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
                    vm.scrollTop = elem.scrollTop();

                    if (!vm.loading && vm.canBeLoaded && !vm.firstLoad) {
                        if (elem[0].scrollHeight - elem.scrollTop() - 200 <= elem.outerHeight()) {
                            vm.page++;
                            vm.loadNext();
                        }
                    }
                });

                vm.filter = vm.$refs.complexFilter.getExpotData();

                vm.loadNext();
            });
        });
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').off('scroll');
    }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_FancyBox_jquery_fancybox_pack_js__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_FancyBox_jquery_fancybox_css__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_FancyBox_jquery_fancybox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_FancyBox_jquery_fancybox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_JqueryUI_jquery_ui_min__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_JqueryUI_jquery_ui_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_JqueryUI_jquery_ui_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__enums__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var backendApi = new __WEBPACK_IMPORTED_MODULE_1__backendApi__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = ({
    name: "user-edit",

    props: ['info'],

    data: function data() {
        return {
            user: null,
            roles: [],
            passwordError: null,
            userNameError: null,
            documentTypes: [{ Id: 1, Name: 'Паспорт гражданина Российской Федерации' }, { Id: 2, Name: 'Паспорт иностранного гражданина' }, { Id: 3, Name: 'Вид на жительство' }],
            genders: [{ Value: false, Name: 'Женский' }, { Value: true, Name: 'Мужской' }],
            currentUserProjects: null,
            AvailableForViewProjects: [],
            loaded: false,
            VerificationStates: __WEBPACK_IMPORTED_MODULE_8__enums__["t" /* VerificationStates */],
            levelInProject: [{ Id: 1, Name: 'Бронза' }, { Id: 2, Name: 'Серебро' }, { Id: 3, Name: 'Золото' }, { Id: 4, Name: 'Платина' }, { Id: 5, Name: 'Грейд B' }, { Id: 6, Name: 'Грейд A' }, { Id: 7, Name: 'Грейд S' }],
            checkedInn: false,
            innVerificationErrors: []
        };
    },


    computed: {
        PassportSeriesMask: function PassportSeriesMask() {
            return this.user.DocumentType === 1 ? '## ##' : '##';
        },
        PassportSeriesMaxLength: function PassportSeriesMaxLength() {
            return this.user.DocumentType === 1 ? 4 : 2;
        },
        PassportNumberMaxLength: function PassportNumberMaxLength() {
            if (this.user.DocumentType !== 2) {
                return this.user.DocumentType === 3 ? 7 : 6;
            } else {
                return false;
            }
        }
    },

    methods: {
        onAddRole: function onAddRole() {
            this.user.UserDynamicRoles.push({
                ProjectId: null,
                RoleId: null,
                ExternalId: null,
                AddedDateFormatted: this.formatDate(new Date(), 'DD.MM.YYYY')
            });
        },
        onDeleteRole: function onDeleteRole(i) {
            this.user.UserDynamicRoles.splice(i, 1);
        },
        getProjectRoles: function getProjectRoles(userRole) {
            var project = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.find(this.roles, { ProjectId: userRole.ProjectId });
            return project ? project.Roles : [];
        },
        getProjectListForRole: function getProjectListForRole(userRole) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.filter(this.roles, function (x) {
                return (x.ProjectId === userRole.ProjectId || !__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.some(_this.user.UserDynamicRoles, { ProjectId: x.ProjectId })) && __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.some(_this.AvailableForViewProjects, function (y) {
                    return y === x.ProjectId;
                });
            });
        },
        formatUserName: function formatUserName(user) {
            return [user.LastName, user.FirstName, user.MiddleName].filter(function (x) {
                return x;
            }).join(' ');
        },
        cancel: function cancel() {
            this.$router.back();
        },
        showReturnDocsModal: function showReturnDocsModal() {
            this.$refs.ppReturn.show();
        },
        returnDocs: function returnDocs() {
            this.user.PassportVerificationState = 3;
            this.$refs.ppReturn.close();
            this.saveEntity();
        },
        approveDocs: function approveDocs() {
            this.user.PassportVerificationState = 2;
            this.saveEntity();
        },
        approvePaymentSettings: function approvePaymentSettings() {
            var vm = this;
            backendApi.savePaymentSettings({
                userName: vm.$route.params.userName,
                stateId: __WEBPACK_IMPORTED_MODULE_8__enums__["t" /* VerificationStates */].Verified
            }).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении данных');
                } else {
                    vm.user.PaymentVerificationState = __WEBPACK_IMPORTED_MODULE_8__enums__["t" /* VerificationStates */].Verified;
                    vm.user.SettingsDateApprovement = response.data;

                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');
                }
            });
        },
        returnPaymentSettings: function returnPaymentSettings() {
            var vm = this;
            this.$validator.validateAll('returnPayment').then(function (result) {
                if (!result) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                } else {
                    backendApi.savePaymentSettings({
                        userName: vm.$route.params.userName,
                        comment: vm.user.PaymentComment,
                        stateId: __WEBPACK_IMPORTED_MODULE_8__enums__["t" /* VerificationStates */].Cancelled
                    }).then(function (response) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                        if (response.hasError) {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении данных');
                        } else {
                            vm.user.PaymentVerificationState = __WEBPACK_IMPORTED_MODULE_8__enums__["t" /* VerificationStates */].Cancelled;

                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');
                            vm.closeModal('ppReturnPayment');
                        }
                    });
                }
            });
        },
        closeModal: function closeModal(popupName) {
            this.$refs[popupName].close();
        },
        activateAccount: function activateAccount() {
            var vm = this;

            this.$validator.validate().then(function (result) {
                if (result) {
                    vm.user.RegisterStatus = 2;
                    vm.saveEntity();
                }
            });
        },
        showRefuseAccountModal: function showRefuseAccountModal() {
            var _this2 = this;

            this.$nextTick(function () {
                _this2.$refs.ppRefuse.show();
            });
        },
        refuseAccount: function refuseAccount() {
            var vm = this;
            vm.$validator.validateAll('refuse').then(function (result) {
                if (result) {
                    var dto = {
                        ProjectId: vm.$route.params.projectId,
                        UserName: vm.user.UserName,
                        RegisterComment: vm.user.RegisterComment

                    };
                    vm.$refs.ppRefuse.close();
                    backendApi.userRefuse(dto).then(function (response) {
                        if (response.hasError) {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении пользователя');
                        } else {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('В регистрации отказано');
                            vm.$router.push('/projects/' + vm.$route.params.projectId + '/users');
                        }
                    });
                }
            });
        },
        loadEntity: function loadEntity() {
            var vm = this;
            var userName = vm.$route.params.userName;
            var projectId = vm.$route.params.projectId;

            return backendApi.userLoad(userName, projectId).then(function (response) {
                //console.info('project.edit -> load, response:', response.data);
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке пользователя');
                } else {
                    vm.roles = response.data.Roles;

                    if (userName === '0') {
                        vm.user = {
                            new: true,
                            Id: null,
                            UserDynamicRoles: [],
                            Images: [],
                            RegFields: []
                        };
                    } else {
                        if (response.data.User == null) {
                            vm.$router.push('/projects/' + projectId + '/users/');
                        }
                        if (response.data.User.RoleId === 0) {
                            response.data.User.RoleId = '';
                        }
                        vm.user = response.data.User;
                        vm.user.RegFields = response.data.RegFields;
                        vm.user.new = false;
                        if (vm.user.BirthDate) {
                            vm.user.BirthDateFormatted = vm.formatDate(vm.user.BirthDate);
                        }
                        if (vm.user.PassportIssuedDate) {
                            vm.user.PassportIssuedDateFormatted = vm.formatDate(vm.user.PassportIssuedDate);
                        }

                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = vm.user.UserDynamicRoles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var userRole = _step.value;

                                if (userRole.DisabledDateTime) {
                                    userRole.DisabledDateFormatted = vm.formatDate(userRole.DisabledDateTime, 'DD.MM.YYYY');
                                    userRole.DisabledTimeFormatted = vm.formatDate(userRole.DisabledDateTime, 'HH:mm');
                                }
                                if (userRole.BlockedDateTime) {
                                    userRole.BlockedDateFormatted = vm.formatDate(userRole.BlockedDateTime, 'DD.MM.YYYY');
                                    userRole.BlockedTimeFormatted = vm.formatDate(userRole.BlockedDateTime, 'HH:mm');
                                }
                                if (userRole.AddedDateTime) {
                                    userRole.AddedDateFormatted = vm.formatDate(userRole.AddedDateTime, 'DD.MM.YYYY');
                                }
                                switch (userRole.LevelInProject) {
                                    case __WEBPACK_IMPORTED_MODULE_8__enums__["s" /* UserLevelCode */].Bronze:
                                        userRole.LevelName = 'Бронза';
                                        break;
                                    case __WEBPACK_IMPORTED_MODULE_8__enums__["s" /* UserLevelCode */].Silver:
                                        userRole.LevelName = 'Серебро';
                                        break;
                                    case __WEBPACK_IMPORTED_MODULE_8__enums__["s" /* UserLevelCode */].Gold:
                                        userRole.LevelName = 'Золото';
                                        break;
                                    case __WEBPACK_IMPORTED_MODULE_8__enums__["s" /* UserLevelCode */].Platina:
                                        userRole.LevelName = 'Платина';
                                        break;
                                    case __WEBPACK_IMPORTED_MODULE_8__enums__["s" /* UserLevelCode */].GradeB:
                                        userRole.LevelName = 'Грейд B';
                                        break;
                                    case __WEBPACK_IMPORTED_MODULE_8__enums__["s" /* UserLevelCode */].GradeA:
                                        userRole.LevelName = 'Грейд A';
                                        break;
                                    case __WEBPACK_IMPORTED_MODULE_8__enums__["s" /* UserLevelCode */].GradeS:
                                        userRole.LevelName = 'Грейд S';
                                        break;
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = vm.user.RegFields[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var field = _step2.value;

                                if (field.FieldType === 'select') {
                                    var options = JSON.parse(field.Options);
                                    field.optionsItems = options.map(function (y) {
                                        return { Value: y, Name: y };
                                    });
                                    if (options.length > 0 && options[0] !== '') {
                                        field.optionsItems.unshift({ Value: 'Выбор', Name: 'Выбор' });
                                    };
                                }
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                }
            });
        },
        onChangePassword: function onChangePassword() {
            var vm = this;
            this.$validator.validateAll('changepassword').then(function (result) {
                if (!result || vm.passwordError) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                } else {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Сохранение...');
                    // let saveObj = Object.assign({}, {
                    //     UserName: ,
                    //     Password:
                    // });
                    // console.info('save pass', saveObj);
                    backendApi.userSavePassword(vm.user.UserName, vm.user.Password).then(function (response) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');

                        if (response.hasError) {
                            if (response.status === 9) {
                                vm.passwordError = 'Некорректное значение';
                            }
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении пароля');
                        } else {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Пароль успешно обновлён');
                            vm.user.Password = null;
                            vm.closeModal('ppRefuse');
                        }
                    });
                }
            });
        },
        saveEntity: function saveEntity() {
            var vm = this;

            this.$validator.validate().then(function (result) {
                if (!result || !vm.user.UserDynamicRoles.length) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                } else {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Сохранение...');

                    var saveObj = Object.assign({}, vm.user, {
                        ProjectId: vm.$route.params.projectId
                    });
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = saveObj.RegFields[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var field = _step3.value;

                            if (field.FieldType === 'select' && field.Value === 'Выбор') {
                                field.Value = '';
                            }
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }

                    backendApi.userSave(saveObj).then(function (response) {
                        //console.info('details -> userSave, response:', response);
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                        if (response.hasError) {
                            if (response.status === 9) {
                                vm.passwordError = 'Некорректное значение';
                            } else if (response.status === 10) {
                                vm.userNameError = 'Email уже используется';
                            }
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении пользователя');
                        } else {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');
                            vm.$router.push('/projects/' + vm.$route.params.projectId + '/users');
                        }
                    });
                }
            });
        },
        loadUserProjects: function loadUserProjects() {
            var vm = this;
            return backendApi.projectList(0, 100).then(function (response) {
                vm.currentUserProjects = response.data;
            });
        },
        onNewPasswordChange: function onNewPasswordChange() {
            this.passwordError = null;

            if (!this.user.Password || !this.user.Password.trim()) {
                //this.password.Error = null;
            } else {
                var newpass = this.user.Password;

                if (newpass.length < 6) {
                    this.passwordError = 'Введите минимум 6 символов';
                } else if (!/(?=.*\d).*\D.*/ig.test(newpass)) {
                    this.passwordError = 'Обязательно наличие и букв и цифр';
                } else if (!/(?=.*[A-ZА-Я]).*[a-zа-я].*/g.test(newpass)) {
                    this.passwordError = 'Обязательно наличие заглавной и прописной буквы';
                }
            }
        },
        deleteEntity: function deleteEntity() {
            var that = this;

            if (confirm('Вы уверены?')) {
                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.portlet', 'Удаление...');
                backendApi.userDelete(that.user.UserName).then(function (response) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.portlet');
                    if (response.hasError) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при удалении пользователя');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно удалено');
                        that.$router.push('/projects/' + that.$route.params.projectId + '/users');
                    }
                });
            }
        },
        removeDocument: function removeDocument(i) {
            if (confirm('Удалить файл?')) {
                this.user.Images.splice(i, 1);
                this.$refs.dropFiles2.value = '';
            }
        },
        rotateImage: function rotateImage(direction, img) {
            var vm = this;

            vm.callApiWrapper(backendApi.rotateUserDocument(img.Id, direction)).then(function (response) {
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при изменении изображения');
                } else {
                    img.FileName = response.data;
                }
            });
        },
        zoomIn: function zoomIn() {
            var $img = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap.find('img.fancybox-image');
            var scale = $img.data('scale') || 1.0;
            scale += 0.2;
            $img.css('transform', 'scale(' + scale + ')');
            $img.data('scale', scale);
        },
        zoomOut: function zoomOut() {
            var $img = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap.find('img.fancybox-image');
            var scale = $img.data('scale') || 1.0;
            scale -= 0.2;
            if (scale < 0.5) {
                return false;
            }
            $img.css('transform', 'scale(' + scale + ')');
            $img.data('scale', scale);
        },
        onChangeDate: function onChangeDate(item, formatted, raw) {
            var format = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'DD.MM.YYYY';

            item[raw] = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(item[formatted], format).format();
        },
        onChangeDisabledDate: function onChangeDisabledDate(userRole) {
            userRole.DisabledDateTime = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(userRole.DisabledDateFormatted + ' ' + userRole.DisabledTimeFormatted, 'DD.MM.YYYY HH:mm').format();
        },
        onChangeBlockedDate: function onChangeBlockedDate(userRole) {
            userRole.BlockedDateTime = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(userRole.BlockedDateFormatted + ' ' + userRole.BlockedTimeFormatted, 'DD.MM.YYYY HH:mm').format();
        },
        onDisabledChange: function onDisabledChange($event, userRole) {
            var checked = $event.target.checked;
            if (!checked) {
                userRole.DisabledDateTime = null;
                userRole.DisabledDateFormatted = null;
                userRole.DisabledTimeFormatted = null;
            } else {
                var dateTime = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])().format();
                userRole.DisabledDateTime = dateTime;
                userRole.DisabledDateFormatted = this.formatDate(dateTime, 'DD.MM.YYYY');
                userRole.DisabledTimeFormatted = this.formatDate(dateTime, 'HH:mm');
            }
        },
        onBlockedChange: function onBlockedChange($event, userRole) {
            var checked = $event.target.checked;
            if (!checked) {
                userRole.BlockedDateTime = null;
                userRole.BlockedDateFormatted = null;
                userRole.BlockedTimeFormatted = null;
            } else {
                var dateTime = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])().format();
                userRole.BlockedDateTime = dateTime;
                userRole.BlockedDateFormatted = this.formatDate(dateTime, 'DD.MM.YYYY');
                userRole.BlockedTimeFormatted = this.formatDate(dateTime, 'HH:mm');
            }
        },
        requiredWhen: function requiredWhen(prop, userRole) {
            return userRole[prop] == true;
        },
        onAttachFiles: function onAttachFiles(obj) {
            var files = obj.files;
            var vm = this;
            if (files && files.length) {
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = files[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var file = _step4.value;

                        if (file.size > 50 * 1024 * 1024) {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Превышен размер. Выберите другой файл');
                            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name="dropFiles2"]').val('');
                        } else {
                            (function () {
                                //this.$refs.dropFiles2.value = file.name;
                                //dropFiles2
                                //console.info('onAttachFiles', this.$refs.dropFiles2);
                                var img = { FileName: file.name, FileData: null, Delete: false };
                                var reader = new FileReader();
                                reader.onload = function (e) {
                                    img.FileData = e.target.result;

                                    vm.user.Images.push(img);
                                };
                                reader.readAsDataURL(file);
                            })();
                        }
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }
            }
        },
        CheckInn: function CheckInn() {
            var vm = this;
            this.$validator.validate().then(function (result) {
                if (!result || !vm.user.UserDynamicRoles.length) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                } else {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Проверка...');

                    var saveObj = Object.assign({}, vm.user, {});
                    saveObj.PassportSeries = vm.user.PassportSeries.slice(0, 2) + ' ' + vm.user.PassportSeries.slice(2);
                    backendApi.userCheckInn(saveObj).then(function (response) {
                        //console.info('details -> userSave, response:', response);
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                        if (response.hasError) {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при проверке');
                        } else {
                            //UI.toastr.success('Успешно сохранено');
                            if (!response.data.inn) {
                                vm.checkedInn = false;
                                vm.innVerificationErrors = response.data.errors;
                            } else if (response.data.inn === saveObj.Inn) {
                                vm.checkedInn = true;
                                vm.innVerificationErrors = [];
                            } else {
                                vm.checkedInn = false;
                                vm.innVerificationErrors = ['ИНН не совпадает'];
                            }
                        }
                    });
                }
            });
        },
        onChangePassport: function onChangePassport() {
            this.checkedInn = false;
            this.innVerificationErrors = [];
        }
    },

    mounted: function mounted() {
        var _this3 = this;

        var vm = this;
        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
        Promise.all([this.loadEntity(), this.loadUserProjects()]).then(function () {

            vm.AvailableForViewProjects = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.concat(__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.map(_this3.currentUserProjects, function (x) {
                return x.Id;
            }), __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.map(_this3.user.UserDynamicRoles, function (x) {
                return x.ProjectId;
            })));

            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.lightzoom').fancybox({
                beforeShow: function beforeShow() {
                    var $div = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div class="btns flex">\n<button type="button" class="btn btn-primary zoom-plus btn-img"><img src="/Content/dist/icon-plus-2.png" alt=""></button>\n<button type="button" class="btn btn-primary zoom-minus btn-img"><img src="/Content/dist/icon-minus-2.png" alt=""></button>\n</div>');
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap.find('.fancybox-outer').before($div);
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap.find('img.fancybox-image').draggable();
                }
            });

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click', '.zoom-plus', function () {
                vm.zoomIn();
            });
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click', '.zoom-minus', function () {
                vm.zoomOut();
            });

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).bind('mousewheel DOMMouseScroll', function (event) {
                if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap != null) {
                    if (event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0) {
                        vm.zoomOut();
                    } else {
                        vm.zoomIn();
                    }
                }
            });

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('change', '[name="dropFiles2"]', function () {
                vm.onAttachFiles({ files: this.files });
            });

            var _loop = function _loop(role) {
                if (!__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.some(vm.currentUserProjects, function (x) {
                    return x.Id === role.ProjectId;
                })) {
                    role.ReadOnly = true;
                }
            };

            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = vm.user.UserDynamicRoles[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var role = _step5.value;

                    _loop(role);
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            vm.loaded = true;
        });
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).unbind('mousewheel DOMMouseScroll');
    }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var $ = __webpack_require__(6);
window.$ = $;
window.jQuery = $;






var backendApi = new __WEBPACK_IMPORTED_MODULE_0__backendApi__["a" /* default */]();

var ImageStyleDefault = {
    top: 0,
    left: 100,
    translateY: 0,
    translateX: -50,
    size: 100,
    resizeType: 1
};

var loadFroalaScripts = function loadFroalaScripts(callback) {
    var present = false;
    var scriptSrc = '/Content/custom/Froala/htmleditor.min.js';
    var scripts = document.getElementsByTagName('script');
    for (var i = scripts.length; i--;) {
        if (scripts[i].src === scriptSrc) {
            present = true;
            break;
        }
    }

    if (!present) {
        var link1 = document.createElement('link');
        link1.setAttribute('rel', 'stylesheet');
        link1.setAttribute('type', 'text/css');
        link1.href = '/Content/custom/Froala/htmleditor.min.css';
        document.head.appendChild(link1);

        var link2 = document.createElement('link');
        link2.href = '/Content/custom/FontAwesome/css/font-awesome.css';
        link2.setAttribute('rel', 'stylesheet');
        link2.setAttribute('type', 'text/css');
        document.head.appendChild(link2);

        var script = document.createElement('script');
        script.onload = function () {
            callback();
        };
        script.src = scriptSrc;
        document.head.appendChild(script);
    } else {
        callback();
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "news-edit",
    data: function data() {
        return {
            news: null,
            file: null,
            deleteImage: false,
            imgMobilePath: null,
            imgMobile: {},
            imgSitePath: null,
            imgSite: {},
            savingInProgress: false
        };
    },


    computed: {
        imageStyleFormatted: function imageStyleFormatted() {
            var settings = {
                left: this.news.ImageStyle.left + '%',
                top: this.news.ImageStyle.top + '%',
                transform: 'translateY(' + this.news.ImageStyle.translateY + '%) translateX(' + this.news.ImageStyle.translateX + '%)'
            };
            if (this.news.ImageStyle.resizeType === 1 && parseInt(this.news.ImageStyle.size)) {
                settings.height = this.news.ImageStyle.size + '%';
            }
            if (this.news.ImageStyle.resizeType === 2 && parseInt(this.news.ImageStyle.size)) {
                settings.width = this.news.ImageStyle.size + '%';
            }

            return settings;
        },
        imageStyleMobileFormatted: function imageStyleMobileFormatted() {
            var settings = {
                left: this.imgMobile.ImageStyle.left + '%',
                top: this.imgMobile.ImageStyle.top + '%',
                transform: 'translateY(' + this.imgMobile.ImageStyle.translateY + '%) translateX(' + this.imgMobile.ImageStyle.translateX + '%)'
            };
            if (this.imgMobile.ImageStyle.resizeType === 1 && parseInt(this.imgMobile.ImageStyle.size)) {
                settings.height = this.imgMobile.ImageStyle.size + '%';
            }
            if (this.imgMobile.ImageStyle.resizeType === 2 && parseInt(this.imgMobile.ImageStyle.size)) {
                settings.width = this.imgMobile.ImageStyle.size + '%';
            }

            return settings;
        }
    },

    watch: {
        'news.Preview': function newsPreview() {
            this.news.PreviewFormatted = this.news.Preview ? this.news.Preview.replace(/\n/g, '<br>') : null;
        }
    },

    methods: {
        back: function back() {
            this.$router.back();
        },
        loadNews: function loadNews() {
            var that = this;
            var id = parseInt(this.$route.params.id);
            if (id === 0) {
                this.news = {
                    Id: 0,
                    new: true,
                    ImageStyle: JSON.parse(JSON.stringify(ImageStyleDefault)),
                    ImageStyleMobile: JSON.parse(JSON.stringify(ImageStyleDefault)),
                    ImageMobile: {}
                };
                that.imgSite = {
                    ImageStyle: that.news.ImageStyle,
                    ImagePath: null,
                    Image: {}
                };
                that.imgMobile = {
                    ImageStyle: that.news.ImageStyleMobile,
                    ImagePath: null,
                    Image: {}
                };

                return new Promise(function (resolve) {
                    return resolve();
                });
            } else {
                return backendApi.newsLoad(id).then(function (response) {
                    //console.info('project.edit -> load, response:', response.data);
                    if (response.hasError) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке новости');
                    } else {
                        if (response.data == null) {
                            that.$router.back();
                        }

                        if (response.data.ImageStyle) {
                            response.data.ImageStyle = JSON.parse(response.data.ImageStyle);
                        } else {
                            response.data.ImageStyle = JSON.parse(JSON.stringify(ImageStyleDefault));
                        }
                        if (response.data.ImageStyleMobile) {
                            response.data.ImageStyleMobile = JSON.parse(response.data.ImageStyleMobile);
                        } else {
                            response.data.ImageStyleMobile = JSON.parse(JSON.stringify(ImageStyleDefault));
                        }

                        that.news = Object.assign(response.data, { FileData: null });
                        that.news.StartDateFormatted = Object(__WEBPACK_IMPORTED_MODULE_2_moment__["default"])(that.news.StartDate).format('DD.MM.YYYY');
                        if (that.news.EndDate) {
                            that.news.EndDateFormatted = Object(__WEBPACK_IMPORTED_MODULE_2_moment__["default"])(that.news.EndDate).format('DD.MM.YYYY');
                        }
                        that.news.ImageMobile = {};

                        that.imgMobile = {
                            ImageStyle: that.news.ImageStyleMobile,
                            ImagePath: that.news.ImageMobilePath,
                            Image: {}
                        };
                        that.imgSite = {
                            ImageStyle: that.news.ImageStyle,
                            ImagePath: that.news.Image,
                            Image: {}
                        };
                    }
                });
            }
        },
        saveNews: function saveNews() {
            var vm = this;

            this.$validator.validate().then(function (result) {
                if (!result) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                } else {
                    if (vm.savingInProgress) {
                        return;
                    }
                    vm.savingInProgress = true;
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Сохранение...');

                    var selectedProjectId = localStorage.getItem('selectedProjectId');

                    var saveObj = Object.assign({}, vm.news, {
                        StartDate: Object(__WEBPACK_IMPORTED_MODULE_2_moment__["default"])(vm.news.StartDateFormatted, 'DD.MM.YYYY').format(),
                        EndDate: Object(__WEBPACK_IMPORTED_MODULE_2_moment__["default"])(vm.news.EndDateFormatted, 'DD.MM.YYYY').format(),
                        DeleteImage: vm.imgSite.Image.Id === -1, //vm.deleteImage,
                        ProjectId: selectedProjectId != null ? parseInt(selectedProjectId) : null,
                        Body: $('[name="Body"]').froalaEditor('html.get', true)
                    });
                    saveObj.ImageStyle = JSON.stringify(vm.imgSite.ImageStyle);
                    saveObj.FileData = vm.imgSite.Image.FileData;
                    saveObj.FileName = vm.imgSite.Image.FileName;
                    saveObj.ImageMobile = vm.imgMobile.Image;
                    if (vm.imgMobile.ImageStyle.useMainPhoto) {
                        saveObj.ImageMobile.FileName = '';
                        saveObj.ImageMobile.FileData = '';
                        saveObj.ImageMobile.Id = -1;
                        saveObj.ImageMobilePath = '';
                    }
                    saveObj.ImageStyleMobile = JSON.stringify(vm.imgMobile.ImageStyle);

                    backendApi.newsSave(saveObj).then(function (response) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                        if (response.hasError) {
                            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении новости');
                        } else {
                            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');
                            vm.$router.push('/news/' + response.data);
                        }
                        vm.savingInProgress = false;
                    });
                }
            });
        },
        deleteNews: function deleteNews() {
            var that = this;

            if (confirm('Вы уверены?')) {
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.portlet', 'Удаление...');
                backendApi.newsDelete(that.news.Id).then(function (response) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.portlet');
                    if (response.hasError) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при удалении новости');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно удалено');
                        that.$router.push('/news');
                    }
                });
            }
        },
        onImageViewChanged: function onImageViewChanged(imgPath, name) {
            if (name === 'site') this.imgSitePath = imgPath;else this.imgMobilePath = imgPath;
        }
    },

    mounted: function mounted() {
        var vm = this;

        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
        this.loadNews().then(function () {
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');

            loadFroalaScripts(function () {
                $('[name="Body"]').froalaEditor({
                    language: 'ru',
                    toolbarButtons: ['undo', 'redo', '|', 'bold', 'italic', 'underline', '|', 'fontSize', 'color', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '|', 'insertLink', 'insertImage', 'insertVideo', 'insertTable', 'insertHR'],
                    charCounterCount: false,
                    //imageEditButtons: ['imageBack', '|', 'imageUpload', 'imageByURL'],
                    imageSplitHTML: true,
                    imageUploadURL: __WEBPACK_IMPORTED_MODULE_3__config___default.a.apiUrl + '/api/news/uploadFiles?fileType=NewsImages&newsId=' + (vm.news.Id || 0),
                    imageUploadMethod: 'POST',
                    imageMaxSize: 5 * 1024 * 1024,
                    imageAllowedTypes: ['jpeg', 'jpg', 'png'],

                    videoUpload: false,
                    useClasses: false
                }).on('froalaEditor.contentChanged', function (e, editor) {
                    vm.news.Body = $('[name="Body"]').froalaEditor('html.get', true);
                });
            });
        });
    },
    destroyed: function destroyed() {
        //$(document).off('change', '[name="dropFiles"]');
    }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__config__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var backendApi = new __WEBPACK_IMPORTED_MODULE_0__backendApi__["a" /* default */]();

var ImageStyleDefault = {
    top: 0,
    left: 100,
    translateY: 0,
    translateX: -50,
    size: 100,
    resizeType: 1
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "sku-edit",

    mixins: [__WEBPACK_IMPORTED_MODULE_4__helpers_project_mixin__["a" /* default */]], // projectId

    data: function data() {
        return {
            sku: null,
            skuSettings: null,
            file: null,
            deleteImage: false,
            reportDateRequired: false,
            skuSearch: {
                list: [],
                page: 1,
                rowsPerPage: 20,
                canBeLoaded: true,
                value: null
            },
            ReportSettings: null,
            tpLinksExist: null,
            tpLinksEmptyExist: null,
            domainFolders: [{
                Id: '',
                Name: 'Выбрать'
            }],
            skuGroups: [{
                Id: '',
                Name: 'Без категории'
            }],
            bonusTypeStr: 'руб',
            imgSitePath: null,
            imgSite: {},
            imgMobilePath: null,
            imgMobile: {},
            savingInProgress: false,
            config: __WEBPACK_IMPORTED_MODULE_6__config___default.a
        };
    },


    computed: {
        skuCustomSettingsOrdered: function skuCustomSettingsOrdered() {
            if (this.skuSettings == null) {
                return null;
            }

            return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.orderBy(Object.values(this.skuSettings).filter(function (x) {
                return x.FieldName.startsWith('CustomField');
            }), 'SettingsOrder');
        },
        imageStyleFormatted: function imageStyleFormatted() {
            var settings = {
                left: this.imgSite.ImageStyle.left + '%',
                top: this.imgSite.ImageStyle.top + '%',
                transform: 'translateY(' + this.imgSite.ImageStyle.translateY + '%) translateX(' + this.imgSite.ImageStyle.translateX + '%)'
            };
            if (this.imgSite.ImageStyle.resizeType === 1 && parseInt(this.imgSite.ImageStyle.size)) {
                settings.height = this.imgSite.ImageStyle.size + '%';
            }
            if (this.imgSite.ImageStyle.resizeType === 2 && parseInt(this.imgSite.ImageStyle.size)) {
                settings.width = this.imgSite.ImageStyle.size + '%';
            }

            return settings;
        },
        imageStyleMobileFormatted: function imageStyleMobileFormatted() {
            var settings = {
                left: this.imgMobile.ImageStyle.left + '%',
                top: this.imgMobile.ImageStyle.top + '%',
                transform: 'translateY(' + this.imgMobile.ImageStyle.translateY + '%) translateX(' + this.imgMobile.ImageStyle.translateX + '%)'
            };
            if (this.imgMobile.ImageStyle.resizeType === 1 && parseInt(this.imgMobile.ImageStyle.size)) {
                settings.height = this.imgMobile.ImageStyle.size + '%';
            }
            if (this.imgMobile.ImageStyle.resizeType === 2 && parseInt(this.imgMobile.ImageStyle.size)) {
                settings.width = this.imgMobile.ImageStyle.size + '%';
            }

            return settings;
        },


        linkSelected: function linkSelected() {
            var selected = this.sku.Links.filter(function (r) {
                return r.Selected;
            });
            return selected.length ? selected[0] : null;
        },

        linkingEnabled: function linkingEnabled() {
            if (this.ReportSettings) {
                return this.ReportSettings.filter(function (x) {
                    return x.type === 'sku' && !x.deleted;
                }).length > 0;
            } else {
                return false;
            }
        },
        volumeUnitRequired: function volumeUnitRequired() {
            return this.sku.Volume ? true : false;
        },
        weightUnitRequired: function weightUnitRequired() {
            return this.sku.Weight ? true : false;
        }
    },

    methods: {
        searchSkuLinkFunction: function searchSkuLinkFunction(searchText, callback, extra, page) {
            var vm = this;
            var skuLink = null;
            for (var i = 0; i < this.sku.Links.length; i++) {
                if (i === extra) {
                    skuLink = this.sku.Links[i];
                    break;
                }
            }
            var linksExcepted = vm.sku.Links.filter(function (x) {
                return skuLink === null || skuLink.Name !== x.Name;
            }).map(function (x) {
                return x.Name;
            });
            // console.info('skuLink', skuLink ? skuLink.Name : 'nil');

            vm.callApiWrapper(backendApi.skuLinksSearch((page - 1) * 20, 20, vm.projectId, searchText, linksExcepted)).then(function (resp) {
                callback(resp.data);
            });
        },
        onChangeSkuLinkSearch: function onChangeSkuLinkSearch(listItem, extra, skuLink) {
            if (listItem) {
                skuLink.Name = listItem.Name;
            } else {}
        },


        onSearchChange: __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.debounce(function () {

            this.searchSku();
        }, 1000),

        openSkuSearchModal: function openSkuSearchModal() {
            var vm = this;

            vm.$refs.ppSkuList.show();

            vm.$nextTick(function () {
                vm.onSearchChange();
            });
        },
        searchSku: function searchSku() {
            var vm = this;
            var searchVal = this.skuSearch.value;

            this.callApiWrapper(backendApi.skuList((this.skuSearch.page - 1) * this.skuSearch.rowsPerPage, this.skuSearch.rowsPerPage, vm.projectId, searchVal, true)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки SKU');
                } else {
                    vm.skuSearch.list = [];

                    if (resp.data && resp.data.length) {
                        var _vm$skuSearch$list;

                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = resp.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var item = _step.value;

                                item.Selected = false;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        (_vm$skuSearch$list = vm.skuSearch.list).push.apply(_vm$skuSearch$list, _toConsumableArray(resp.data));
                    } else {
                        vm.skuSearch.canBeLoaded = false;
                    }
                }
            });
        },
        skuSearchApply: function skuSearchApply() {
            var vm = this;
            if (vm.skuSearch.list.length) {
                var selectedIds = vm.skuSearch.list.filter(function (x) {
                    return x.Selected;
                }).map(function (x) {
                    return {
                        Id: x.Id, IsFolder: x.IsFolder
                    };
                });
                if (!selectedIds.length) {
                    alert('Ничего не выбрано!');
                    return;
                }

                this.callApiWrapper(backendApi.skuApplyLinks(this.$route.params.id, selectedIds, vm.sku.Links)).then(function (resp) {
                    if (resp.hasError && resp.status !== 401) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время выполнения операции');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно применено');
                        vm.$refs.ppSkuList.close();

                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.page-content', 'Загрузка...');
                        vm.loadSku().then(function () {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.page-content');
                        });
                    }
                });
            }
        },
        onChangeDate: function onChangeDate(item, formatted, raw) {
            item[raw] = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(item[formatted], 'DD.MM.YYYY').format();
        },
        back: function back() {
            this.$router.back();
        },
        onLinkSelect: function onLinkSelect(link) {
            this.sku.Links.forEach(function (r) {
                r.Selected = false;
            });
            link.Selected = true;
        },
        onLinkEdit: function onLinkEdit(link) {
            var vm = this;
            this.formIsValid().then(function (res) {
                if (res) {
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = vm.sku.Links[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var x = _step2.value;

                            x.Edited = false;
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    link.Edited = true;

                    link.OriginName = link.Name;
                    link.OriginAmount = link.Amount;
                }
            });
        },
        onLinkEditOk: function onLinkEditOk(link) {
            this.formIsValid().then(function (res) {
                if (res) {
                    link.Edited = false;
                }
            });
        },
        onLinkEditCancel: function onLinkEditCancel(link) {
            link.Name = link.OriginName;
            link.Amount = link.OriginAmount;
            link.Edited = false;
        },
        removeLink: function removeLink(skuLink, i) {
            this.sku.Links.splice(i, 1);
        },
        addNewLink: function addNewLink() {
            var vm = this;
            this.formIsValid().then(function (res) {
                if (res) {
                    var link = {
                        Id: 0,
                        Name: null,
                        Amount: 0,
                        Edited: false,
                        Selected: false,
                        OriginName: null,
                        OriginAmount: 0,
                        Periods: []
                    };
                    vm.sku.Links.push(link);
                    vm.onLinkSelect(link);
                    vm.onLinkEdit(link);
                }
            });
        },
        onPeriodEdit: function onPeriodEdit(item) {
            var vm = this;

            this.formIsValid().then(function (res) {
                if (res) {
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = vm.linkSelected.Periods[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var x = _step3.value;

                            x.Edited = false;
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }

                    item.Edited = true;
                    vm.linkSelected.Periods.__ob__.dep.notify();
                }
            });
        },
        onPeriodEditCancel: function onPeriodEditCancel(item) {
            var vm = this;

            this.formIsValid().then(function (res) {
                if (res) {
                    item.Edited = false;
                    vm.linkSelected.Periods.__ob__.dep.notify();
                }
            });
        },
        removePeriod: function removePeriod(item, j) {
            this.linkSelected.Periods.splice(j, 1);
        },
        addNewPeriod: function addNewPeriod() {
            var vm = this;
            // отлючил проверку - если настройка “Указывать дату отчета” не включена, то в качестве даты отчёта берём дату заполнения
            /*if(!vm.reportDateRequired){
                alert('Необходимо наличие настройки “Указывать дату отчета” в проекте');
                return;
            }*/

            this.formIsValid().then(function (res) {
                if (res) {
                    var item = {
                        Id: 0,
                        Amount: 0
                    };
                    vm.linkSelected.Periods.push(item);
                    vm.onPeriodEdit(item);
                }
            });
        },
        formIsValid: function formIsValid() {
            return this.$validator.validate().then(function (result) {
                return result;
            });
        },
        loadSku: function loadSku() {
            var vm = this;
            var id = parseInt(this.$route.params.id);

            return backendApi.skuLoad(id, vm.projectId, true).then(function (response) {
                console.info('project.edit -> load, response:', response.data);
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке SKU');
                } else {
                    if (id === 0) {
                        vm.sku = {
                            Id: 0,
                            new: true,
                            ImageStyle: JSON.parse(JSON.stringify(ImageStyleDefault)),
                            Links: [],
                            GroupId: null,
                            VolumeUnit: 'л',
                            WeightUnit: 'кг',
                            ImageStyleMobile: JSON.parse(JSON.stringify(ImageStyleDefault)),
                            ImageMobile: {}
                        };
                        vm.imgSite = {
                            ImageStyle: vm.sku.ImageStyle,
                            ImagePath: null,
                            Image: {}
                        };
                        vm.imgMobile = {
                            ImageStyle: vm.sku.ImageStyleMobile,
                            ImagePath: null,
                            Image: {}
                        };
                    } else {
                        if (response.data.sku == null) {
                            vm.$router.back();
                        }
                        if (response.data.sku.ImageStyle) {
                            response.data.sku.ImageStyle = JSON.parse(response.data.sku.ImageStyle);
                        } else {
                            response.data.sku.ImageStyle = JSON.parse(JSON.stringify(ImageStyleDefault));
                        }
                        if (response.data.sku.ImageStyleMobile) {
                            response.data.sku.ImageStyleMobile = JSON.parse(response.data.sku.ImageStyleMobile);
                        } else {
                            response.data.sku.ImageStyleMobile = JSON.parse(JSON.stringify(ImageStyleDefault));
                        }

                        response.data.sku.Links.forEach(function (r) {
                            r.Edited = false;
                            r.Selected = false;

                            r.Periods.forEach(function (p) {
                                p.Edited = false;
                                p.DateStartFormatted = vm.formatDate(p.DateStart);
                                p.DateEndFormatted = vm.formatDate(p.DateEnd);
                            });
                        });
                        response.data.sku.GroupId = response.data.sku.Group ? response.data.sku.Group.Id : null;

                        vm.sku = response.data.sku;
                        vm.sku.CreateDateFormatted = vm.formatDate(vm.sku.CreateDate);
                        if (vm.sku.EndDate) {
                            vm.sku.EndDateFormatted = vm.formatDate(vm.sku.EndDate);
                        }
                        vm.sku.ImageMobile = {};
                        vm.imgMobile = {
                            ImageStyle: vm.sku.ImageStyleMobile,
                            ImagePath: vm.sku.ImageMobilePath,
                            Image: {}
                        };
                        delete vm.sku.ImageStyle.useMainPhoto;
                        vm.imgSite = {
                            ImageStyle: vm.sku.ImageStyle,
                            ImagePath: vm.sku.Image,
                            Image: {}
                        };
                    }

                    vm.tpLinksExist = response.data.tpLinksExist;
                    vm.tpLinksEmptyExist = response.data.tpLinksEmptyExist;
                }
            });
        },
        loadSettings: function loadSettings() {
            var vm = this;
            return this.callApiWrapper(backendApi.skuSettings(vm.projectId)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки настроек sku');
                } else {
                    if (resp.data) {
                        var dict = {};
                        var _iteratorNormalCompletion4 = true;
                        var _didIteratorError4 = false;
                        var _iteratorError4 = undefined;

                        try {
                            for (var _iterator4 = resp.data[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                var s = _step4.value;

                                if (!dict[s.FieldName]) {
                                    dict[s.FieldName] = s;
                                }
                            }
                        } catch (err) {
                            _didIteratorError4 = true;
                            _iteratorError4 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                    _iterator4.return();
                                }
                            } finally {
                                if (_didIteratorError4) {
                                    throw _iteratorError4;
                                }
                            }
                        }

                        vm.skuSettings = dict;
                    }
                }
            });
        },
        loadProject: function loadProject() {
            var vm = this;
            return backendApi.projectLoad(vm.projectId).then(function (response) {
                var rsData = JSON.parse(response.data.ReportSettings || '[]');
                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                    for (var _iterator5 = rsData[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                        var item = _step5.value;

                        if (typeof item.deleted === 'undefined') {
                            item.deleted = false;
                        }
                    }
                } catch (err) {
                    _didIteratorError5 = true;
                    _iteratorError5 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                            _iterator5.return();
                        }
                    } finally {
                        if (_didIteratorError5) {
                            throw _iteratorError5;
                        }
                    }
                }

                var bsData = JSON.parse(response.data.BonusSettings || '{"bonusStrategy":{}}');

                vm.ReportSettings = rsData;
                vm.reportDateRequired = response.data.ReportDateRequired;

                if (bsData.bonusStrategy.type === 'sku' && bsData.bonusStrategy.data.bonusType === 'percent') vm.bonusTypeStr = "%";else vm.bonusTypeStr = "руб";
            });
        },
        loadFolders: function loadFolders() {
            var vm = this;
            return backendApi.domainFoldersList(vm.projectId, 1).then(function (response) {
                var _vm$domainFolders;

                (_vm$domainFolders = vm.domainFolders).push.apply(_vm$domainFolders, _toConsumableArray(response.data));
            });
        },
        loadGroups: function loadGroups() {
            var vm = this;
            return backendApi.skuGroupList(vm.projectId).then(function (response) {
                var _vm$skuGroups;

                (_vm$skuGroups = vm.skuGroups).push.apply(_vm$skuGroups, _toConsumableArray(response.data));
            });
        },
        saveSku: function saveSku() {
            var _this = this;

            var vm = this;

            this.$validator.validate().then(function (result) {
                if (!result) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                } else {
                    if (vm.savingInProgress) {
                        return;
                    }
                    vm.savingInProgress = true;
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.portlet', 'Сохранение...');

                    var selectedProjectId = localStorage.getItem('selectedProjectId');

                    var saveObj = Object.assign({}, vm.sku, {
                        //CreateDate: moment(vm.sku.CreateDateFormatted, 'DD.MM.YYYY').format(),
                        EndDate: Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(vm.sku.EndDateFormatted, 'DD.MM.YYYY').format(),
                        DeleteImage: vm.imgSite.Image.Id === -1,
                        ProjectId: selectedProjectId != null ? parseInt(selectedProjectId) : null
                    });
                    saveObj.ImageStyle = JSON.stringify(vm.imgSite.ImageStyle);
                    saveObj.FileData = vm.imgSite.Image.FileData;
                    saveObj.FileName = vm.imgSite.Image.FileName;
                    saveObj.ImageMobile = vm.imgMobile.Image;
                    if (vm.imgMobile.ImageStyle.useMainPhoto) {
                        saveObj.ImageMobile.FileName = '';
                        saveObj.ImageMobile.FileData = '';
                        saveObj.ImageMobile.Id = -1;
                        saveObj.ImageMobilePath = '';
                    }
                    saveObj.ImageStyleMobile = JSON.stringify(vm.imgMobile.ImageStyle);

                    _this.callApiWrapper(backendApi.skuSave(saveObj)).then(function (response) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.portlet');
                        if (response.hasError) {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении SKU');
                        } else {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');
                            vm.$router.push('/sku/' + response.data + '/?saved');
                        }
                        vm.savingInProgress = false;
                    });
                }
            });
        },
        deleteSku: function deleteSku() {
            var that = this;

            if (confirm('Вы уверены?')) {
                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.portlet', 'Удаление...');
                backendApi.skuDelete(that.sku.Id).then(function (response) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.portlet');
                    if (response.hasError) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при удалении SKU');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно удалено');
                        that.$router.push('/sku');
                    }
                });
            }
        },
        onImageViewChanged: function onImageViewChanged(imgPath, name) {
            if (name === 'site') this.imgSitePath = imgPath;else this.imgMobilePath = imgPath;
        }
    },

    mounted: function mounted() {
        var _this2 = this;

        var vm = this;
        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.page-content', 'Загрузка...');

        Promise.all([this.loadSettings(), this.loadProject(), this.loadFolders(), this.loadGroups()]).then(function () {
            _this2.loadSku();

            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.page-content');
        });
    },
    destroyed: function destroyed() {}
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pdfjs_dist_webpack__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pdfjs_dist_webpack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pdfjs_dist_webpack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_smooth_dnd__ = __webpack_require__(56);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var backendApi = new __WEBPACK_IMPORTED_MODULE_0__backendApi__["a" /* default */]();

var ImageStyleDefault = {
    top: 0,
    left: 100,
    translateY: 0,
    translateX: -50,
    size: 100,
    resizeType: 1
},
    StubImageStyleDefault = {
    top: 50,
    left: 50,
    translateY: -50,
    translateX: -50,
    size: 100,
    resizeType: 1
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "material-edit",

    props: ['info'],

    mixins: [__WEBPACK_IMPORTED_MODULE_4__helpers_project_mixin__["a" /* default */]],

    components: { Container: __WEBPACK_IMPORTED_MODULE_8_vue_smooth_dnd__["a" /* Container */], Draggable: __WEBPACK_IMPORTED_MODULE_8_vue_smooth_dnd__["b" /* Draggable */] },

    data: function data() {
        return {
            material: null,
            file: null,
            previousStatusId: 0,
            folders: [],
            activeContentTypes: [
            // {Id: 1, Name: 'MS PowerPoint презентация (ppt, pptx)'},
            { Id: 2, Name: 'Видео с YouTube' }, { Id: 3, Name: 'Презентация в формате PDF' }, { Id: 4, Name: 'Видео' }, { Id: 5, Name: 'Scorm-курс' }],
            testTypes: {
                Simple: 1,
                Interactive: 2
            },
            config: __WEBPACK_IMPORTED_MODULE_6__config___default.a,
            imgSitePath: null,
            imgSite: {},
            imgMobilePath: null,
            imgMobile: {},
            savingInProgress: false
        };
    },


    computed: {
        materialFilesOrdered: function materialFilesOrdered() {
            return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.orderBy(this.material.Files, 'OrderValue');
        },
        imageStyleFormatted: function imageStyleFormatted() {
            var settings = {
                left: this.imgSite.ImageStyle.left + '%',
                top: this.imgSite.ImageStyle.top + '%',
                transform: 'translateY(' + this.imgSite.ImageStyle.translateY + '%) translateX(' + this.imgSite.ImageStyle.translateX + '%)'
            };
            if (this.imgSite.ImageStyle.resizeType === 1 && parseInt(this.imgSite.ImageStyle.size)) {
                settings.height = this.imgSite.ImageStyle.size + '%';
            }
            if (this.imgSite.ImageStyle.resizeType === 2 && parseInt(this.imgSite.ImageStyle.size)) {
                settings.width = this.imgSite.ImageStyle.size + '%';
            }

            return settings;
        },
        imageStyleMobileFormatted: function imageStyleMobileFormatted() {
            var settings = {
                left: this.imgMobile.ImageStyle.left + '%',
                top: this.imgMobile.ImageStyle.top + '%',
                transform: 'translateY(' + this.imgMobile.ImageStyle.translateY + '%) translateX(' + this.imgMobile.ImageStyle.translateX + '%)'
            };
            if (this.imgMobile.ImageStyle.resizeType === 1 && parseInt(this.imgMobile.ImageStyle.size)) {
                settings.height = this.imgMobile.ImageStyle.size + '%';
            }
            if (this.imgMobile.ImageStyle.resizeType === 2 && parseInt(this.imgMobile.ImageStyle.size)) {
                settings.width = this.imgMobile.ImageStyle.size + '%';
            }

            return settings;
        },
        stubImageStyleFormatted: function stubImageStyleFormatted() {
            var settings = {
                left: this.material.StubImageStyle.left + '%',
                top: this.material.StubImageStyle.top + '%',
                transform: 'translateY(' + this.material.StubImageStyle.translateY + '%) translateX(' + this.material.StubImageStyle.translateX + '%)'
            };
            if (this.material.StubImageStyle.resizeType === 1 && parseInt(this.material.StubImageStyle.size)) {
                settings.height = this.material.StubImageStyle.size + '%';
            }
            if (this.material.StubImageStyle.resizeType === 2 && parseInt(this.material.StubImageStyle.size)) {
                settings.width = this.material.StubImageStyle.size + '%';
            }

            return settings;
        },
        testInteractiveRequiredRule: function testInteractiveRequiredRule() {
            return this.material.TestType === this.testTypes.Interactive;
        },
        testAttemptsIntervalDisabled: function testAttemptsIntervalDisabled() {
            return !(this.material.TestAttemptsNumber > 0);
        },
        testAttemptsIntervalRequiredRule: function testAttemptsIntervalRequiredRule() {
            return this.material.TestAttemptsNumber > 0;
        },
        MaxQuestionsToPass: function MaxQuestionsToPass() {
            if (this.material.QuestionsToAsk > 0) {
                return this.material.QuestionsToAsk;
            } else {
                return this.material.ActiveQuestionsCount;
            }
        }
    },

    methods: {
        onDrop: function onDrop(dropResult) {
            var vm = this;

            if (dropResult.removedIndex === dropResult.addedIndex) {
                return;
            }

            var dataTemp = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.orderBy(vm.material.Files, 'OrderValue');
            var itemToAdd = void 0;
            if (dropResult.removedIndex != null) {
                itemToAdd = dataTemp.splice(dropResult.removedIndex, 1)[0];
            }
            if (dropResult.addedIndex !== null) {
                dataTemp.splice(dropResult.addedIndex, 0, itemToAdd);
            }

            var order = 1;
            dataTemp.forEach(function (entity) {
                entity.OrderValue = order++;
            });

            vm.material.Files = dataTemp;
        },
        addFileMaterial: function addFileMaterial() {
            var orderValue = this.material.Files.length + 1;

            this.material.Files.push({
                Name: 'Новый материал',
                ActiveContentType: 3,
                ContentFileName: null,
                ContentPages: null,
                OrderValue: orderValue
            });
        },
        deleteFileMaterial: function deleteFileMaterial(i) {
            this.material.Files.splice(i, 1);
        },
        toggleTestDisabled: function toggleTestDisabled() {
            var vm = this;
            if (!vm.material.TestDisabled) {
                vm.$nextTick(function () {
                    vm.initFroala();
                });
            }
        },
        onFileChange: function onFileChange($event, materialFile) {
            var files = $event.target.files;

            if (files && files[0]) {
                if (files[0].size > 50 * 1024 * 1024) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Превышен размер. Выберите другой файл');
                    // todo:
                    //$('[name="dropFiles3"]').val('');
                } else {
                    materialFile.ContentFileName = files[0].name;

                    var reader = new FileReader();
                    reader.onload = function (e) {
                        materialFile.ContentFileData = e.target.result;

                        if (materialFile.ActiveContentType === 3) {
                            var loadingTask = __WEBPACK_IMPORTED_MODULE_5_pdfjs_dist_webpack___default.a.getDocument({ data: atob(e.target.result.replace('data:application/pdf;base64,', '')) });
                            loadingTask.promise.then(function (pdf) {
                                materialFile.ContentPages = pdf.numPages;
                                materialFile.DeleteContentFile = false;
                            });
                        }
                    };
                    reader.readAsDataURL(files[0]);
                }
            }
        },
        onActiveContentTypesChange: function onActiveContentTypesChange(materialFile) {
            materialFile.ContentFileName = null;
            materialFile.ContentFileData = null;
        },
        onVideoFileChange: function onVideoFileChange($event, materialFile) {

            var files = $event.target.files;
            if (files.length > 0) {
                if (window.FormData !== undefined) {
                    var data = new FormData();
                    for (var x = 0; x < files.length; x++) {
                        data.append("file" + x, files[x]);
                    }
                    var materialId = this.$route.params.id;
                    var tokenInfo = JSON.parse(localStorage.getItem('tokenInfo') == null ? sessionStorage.getItem('tokenInfo') : localStorage.getItem('tokenInfo'));
                    var headers = {};
                    if (tokenInfo != null) {
                        headers.Authorization = 'bearer ' + tokenInfo.access_token;
                    }

                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('#app');
                    __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.ajax({
                        type: "POST",
                        url: __WEBPACK_IMPORTED_MODULE_6__config___default.a.apiUrl + '/api/materials/import?materialId=' + materialId,
                        contentType: false,
                        processData: false,
                        headers: headers,
                        data: data,
                        success: function success(resp) {
                            console.info('materials/import -> resp:', resp);
                            if (resp.hasError) {
                                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка загрузки видео');
                            } else {
                                var _data = resp.result;
                                materialFile.ContentFileName = _data;
                                materialFile.DeleteContentFile = false;
                            }
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
                        },
                        error: function error(xhr, status, p3) {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка на сервере');
                            console.error(xhr.responseText);
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
                        }
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Браузер не поддерживает загрузку файлов HTML5!');
                }
            }
        },
        onScormStubFileChange: function onScormStubFileChange($event, materialFile) {
            var files = $event.target.files;
            if (files && files[0]) {
                if (files[0].size > 50 * 1024 * 1024) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Превышен размер. Выберите другой файл');
                    $event.target.value = '';
                } else {
                    materialFile.ScormStubFileName = files[0].name;

                    var reader = new FileReader();
                    reader.onload = function (e) {
                        materialFile.ScormStubFileData = e.target.result;
                    };
                    reader.readAsDataURL(files[0]);
                }
            }
        },
        setStubImageStyleParams: function setStubImageStyleParams(style) {
            for (var p in style) {
                this.material.StubImageStyle[p] = style[p];
            }
        },
        back: function back() {
            this.$router.back();
        },
        removeContentFile: function removeContentFile(materialFile) {
            materialFile.DeleteContentFile = true;
            materialFile.ContentFileName = null;
            materialFile.ContentFileData = null;
        },
        removeScormStubFile: function removeScormStubFile(materialFile) {
            materialFile.DeleteScormStubFile = true;
            materialFile.ScormStubFileName = null;
            materialFile.ScormStubFileData = null;
        },
        goToQuestions: function goToQuestions() {
            this.$router.push('/materials/edit/' + this.material.Id + '/questions');
        },
        onStatusChanged: function onStatusChanged($event, s) {
            var vm = this;
            if (this.material.Status === 2) {
                // if (!this.material.TestDisabled && (!this.material.Questions || !this.material.Questions.length)) {
                //
                //     UI.toastr.error('Необходимо добавить хотя бы один вопрос к презентации');
                //     this.material.Status = this.previousStatusId;
                //     return;
                // }

                // if (this.material.ConvectorStatus !== 2 && this.material.ActiveContentType == 1) {
                //
                //     // загружаем статус конвертации
                //     backendApi.materialLoad(parseInt(this.$route.params.id)).then(function (response) {
                //
                //         if(response.data.ConvectorStatus === 2){
                //             vm.material.Status = 2;
                //         }
                //         else{
                //             UI.toastr.error('Материал презентации не сконвертирован');
                //         }
                //     });
                //
                //     this.material.Status = this.previousStatusId;
                //     return;
                // }
            }

            this.previousStatusId = this.material.Status;
        },
        loadMaterial: function loadMaterial() {
            var vm = this;
            var id = parseInt(this.$route.params.id);
            if (id === 0) {
                vm.material = {
                    Id: 0,
                    new: true,
                    ImageStyle: JSON.parse(JSON.stringify(ImageStyleDefault)),
                    StubImageStyle: StubImageStyleDefault,
                    Status: 1,
                    FolderId: null,
                    ContentFileName: null,
                    FileName: null,
                    StubFileName: null,
                    StubFileData: null,
                    PresentationName: null,
                    FileData: null,
                    QuestionsToAsk: 0,
                    QuestionsToPass: 0,
                    TestAttemptsNumber: 0,
                    TestTime: 0,
                    TestRightAnswerBonus: 0,
                    TestWrongAnswerBonus: 0,
                    TestSecondBonus: 0,
                    ActiveQuestionsCount: 0,
                    Files: [],
                    FilesOrderLocked: false,
                    ProjectId: vm.projectId,
                    ScormStubFileName: null,
                    CertificateSettings: {
                        "Issuance": {
                            "Actived": null,
                            "data": {
                                "front": null,
                                "before": null,
                                "after": null,
                                "email": null,
                                "sms": null
                            }
                        }
                    },
                    ImageStyleMobile: JSON.parse(JSON.stringify(ImageStyleDefault)),
                    ImageMobile: {}
                };
                vm.previousStatusId = 1;

                var folderId = vm.$route.query.folderId;
                if (folderId) {
                    vm.material.FolderId = folderId;
                }
                vm.imgSite = {
                    ImageStyle: vm.material.ImageStyle,
                    ImagePath: null,
                    Image: {}
                };
                vm.imgMobile = {
                    ImageStyle: vm.material.ImageStyleMobile,
                    ImagePath: null,
                    Image: {}
                };

                return new Promise(function (resolve) {
                    return resolve();
                });
            } else {
                return backendApi.materialLoad(id).then(function (response) {
                    //console.info('project.edit -> load, response:', response.data);
                    if (response.hasError) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке материала');
                    } else {
                        if (response.data == null) {
                            vm.$router.back();
                        }

                        if (response.data.ImageStyle) {
                            response.data.ImageStyle = JSON.parse(response.data.ImageStyle);
                        } else {
                            response.data.ImageStyle = JSON.parse(JSON.stringify(ImageStyleDefault));
                        }
                        if (response.data.ImageStyleMobile) {
                            response.data.ImageStyleMobile = JSON.parse(response.data.ImageStyleMobile);
                        } else {
                            response.data.ImageStyleMobile = JSON.parse(JSON.stringify(ImageStyleDefault));
                        }

                        if (response.data.StubImageStyle) {
                            response.data.StubImageStyle = JSON.parse(response.data.StubImageStyle);
                        } else {
                            response.data.StubImageStyle = StubImageStyleDefault;
                        }

                        if (response.data) {
                            vm.material = Object.assign(response.data, {
                                FileName: null,
                                DeleteImage: false,
                                FileData: null,
                                StubFileName: null,
                                StubDeleteImage: false,
                                StubFileData: null
                            });

                            vm.previousStatusId = response.data.Status;
                            if (vm.material.EndDate) {
                                vm.material.EndDateFormatted = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(vm.material.EndDate).format('DD.MM.YYYY');
                            }
                            if (vm.material.StartDate) {
                                vm.material.StartDateFormatted = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(vm.material.StartDate).format('DD.MM.YYYY');
                            }

                            vm.material.ActiveQuestionsCount = vm.material.Questions.filter(function (x) {
                                return x.Active === true;
                            }).length;

                            if (vm.material.TestAttemptsIntervalSeconds) {
                                vm.material.TestAttemptsIntervalFormatted = vm.formatTime(vm.material.TestAttemptsIntervalSeconds);
                            }
                            vm.material.CertificateSettings = JSON.parse(vm.material.CertificateSettings || '{}');
                            console.info(vm.material.CertificateSettings);
                            if (typeof vm.material.CertificateSettings.Issuance === 'undefined') {
                                vm.material.CertificateSettings = {
                                    "Issuance": {
                                        "Actived": null,
                                        "data": {
                                            "front": null,
                                            "before": null,
                                            "after": null,
                                            "email": null,
                                            "sms": null
                                        }
                                    }
                                };
                            }
                            vm.material.ImageMobile = {};
                            vm.imgMobile = {
                                ImageStyle: vm.material.ImageStyleMobile,
                                ImagePath: vm.material.ImageMobilePath,
                                Image: {}
                            };
                            vm.imgSite = {
                                ImageStyle: vm.material.ImageStyle,
                                ImagePath: vm.material.Image,
                                Image: {}
                            };
                        }
                    }
                });
            }
        },
        saveMaterial: function saveMaterial() {
            var vm = this;

            vm.$validator.validate().then(function (result) {
                if (!result) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                } else {
                    if (vm.savingInProgress) {
                        return;
                    }
                    vm.savingInProgress = true;
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Сохранение...');

                    var saveObj = Object.assign({}, vm.material, {
                        ProjectId: vm.projectId
                    });
                    saveObj.DeleteImage = vm.imgSite.Image.Id === -1;
                    saveObj.ImageStyle = JSON.stringify(vm.imgSite.ImageStyle);
                    saveObj.FileData = vm.imgSite.Image.FileData;
                    saveObj.FileName = vm.imgSite.Image.FileName;
                    saveObj.ImageMobile = vm.imgMobile.Image;
                    if (vm.imgMobile.ImageStyle.useMainPhoto) {
                        saveObj.ImageMobile.FileName = '';
                        saveObj.ImageMobile.FileData = '';
                        saveObj.ImageMobile.Id = -1;
                        saveObj.ImageMobilePath = '';
                    }
                    saveObj.ImageStyleMobile = JSON.stringify(vm.imgMobile.ImageStyle);
                    //saveObj.StubImageStyle = JSON.stringify(saveObj.StubImageStyle);
                    saveObj.StartDate = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(vm.material.StartDateFormatted, 'DD.MM.YYYY').format();
                    saveObj.EndDate = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(vm.material.EndDateFormatted, 'DD.MM.YYYY').format();
                    saveObj.CertificateSettings = JSON.stringify(saveObj.CertificateSettings);

                    // todo: проверить
                    // if(!vm.material.TestDisabled){
                    //     saveObj.TestGreeting = $('[name="TestGreeting"]').froalaEditor('html.get', true);
                    // }

                    //console.info('saveObj', saveObj)
                    backendApi.materialSave(saveObj).then(function (response) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                        if (response.hasError) {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении материала');
                        } else {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');
                            if (vm.material.new) {
                                if (vm.material.TestDisabled) {
                                    vm.$router.push('/materials/edit/' + response.data.Id);
                                } else {
                                    vm.$router.push('/materials/edit/' + response.data.Id + '/questions');
                                }
                            } else {
                                vm.loadMaterial();
                            }
                        }
                        vm.savingInProgress = false;
                    });
                }
            });
        },
        deleteMaterial: function deleteMaterial() {
            var vm = this;

            if (confirm('Вы уверены?')) {
                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Удаление...');
                backendApi.materialDelete(vm.material.Id).then(function (response) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                    if (response.hasError) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при удалении материала');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно удалено');
                        vm.$router.push('/materials');
                    }
                });
            }
        },
        loadFolders: function loadFolders() {
            var vm = this;

            var projectId = vm.projectId;

            return backendApi.folderList(projectId).then(function (response) {
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке папок материалов');
                } else {
                    vm.folders = response.data;
                }
            });
        },
        onChangeTestAttemptsInterval: function onChangeTestAttemptsInterval() {
            var parts = this.material.TestAttemptsIntervalFormatted.split(':');
            var h = parseInt(parts[0]),
                m = parseInt(parts[1]),
                s = parseInt(parts[2]);

            this.material.TestAttemptsIntervalSeconds = h * 3600 + m * 60 + s;
        },
        formatTime: function formatTime(time) {
            var h = Math.floor(time / 3600);
            var m = Math.floor((time - h * 3600) / 60);
            var s = Math.floor(time - h * 3600 - m * 60);

            return (h > 9 ? h : '0' + h) + ':' + (m > 9 ? m : '0' + m) + ':' + (s > 9 ? s : '0' + s);
        },
        onImageViewChanged: function onImageViewChanged(imgPath, name) {
            if (name === 'site') this.imgSitePath = imgPath;else this.imgMobilePath = imgPath;
        }
    },

    mounted: function mounted() {
        var vm = this;

        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
        this.loadFolders().then(function () {
            return vm.loadMaterial().then(function () {
                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');

                __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on('click', '.block-in-page-collapce', function () {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].block_collapse(this);
                });
            });
        });
    },
    destroyed: function destroyed() {
        // $(document).off('change', '[name="dropFiles3"]');
        // $(document).off('change', '[name="dropFiles4"]');
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).off('click', '.block-in-page-collapce');
    }
});

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var pdfjs = __webpack_require__(742);
var PdfjsWorker = __webpack_require__(756);

if (typeof window !== 'undefined' && 'Worker' in window) {
  pdfjs.GlobalWorkerOptions.workerPort = new PdfjsWorker();
}

module.exports = pdfjs;


/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enums__ = __webpack_require__(19);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var backendApi = new __WEBPACK_IMPORTED_MODULE_0__backendApi__["a" /* default */]();

var ImageStyleDefault = {
    top: 0,
    left: 100,
    translateY: 0,
    translateX: -50,
    size: 100,
    resizeType: 1
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "reward-edit",

    mixins: [__WEBPACK_IMPORTED_MODULE_3__helpers_project_mixin__["a" /* default */]],

    data: function data() {
        return {
            reward: null,
            file: null,
            deleteImage: false,
            types: [{ Id: __WEBPACK_IMPORTED_MODULE_4__enums__["l" /* RewardTypes */].ElectronicGiftCard, Name: 'Электронная подарочная карта' }, { Id: __WEBPACK_IMPORTED_MODULE_4__enums__["l" /* RewardTypes */].PrepaidBankCard, Name: 'Предоплаченная банковская карта' }, { Id: __WEBPACK_IMPORTED_MODULE_4__enums__["l" /* RewardTypes */].PhysicalBankCard, Name: 'Пополнение личной карты' }, { Id: __WEBPACK_IMPORTED_MODULE_4__enums__["l" /* RewardTypes */].PhysicalPrize, Name: 'Физический приз' }],
            domainFolders: [{
                Id: '',
                Name: 'Выбрать'
            }],
            rewardGroups: [{
                Id: '',
                Name: 'Без категории'
            }],
            giftery: {
                data: [],
                loading: false,
                balance: null
            },
            imgSitePath: null,
            imgSite: {},
            imgMobilePath: null,
            imgMobile: {},
            savingInProgress: false,
            project: null
        };
    },


    computed: {
        currencyEquivalentLabel: function currencyEquivalentLabel() {
            if (!this.project || !this.project.CountryId) {
                return 'Эквивалент в деньгах'; // значение по умолчанию, если project или CountryId не определены
            }
            switch (this.project.CountryId) {
                case 1:
                    // Россия
                    return 'Эквивалент в рублях';
                case 2:
                    // Беларусь
                    return 'Эквивалент в белорусских рублях';
                case 3:
                    // Казахстан
                    return 'Эквивалент в тенге';
                default:
                    return 'Эквивалент в деньгах';
            }
        },
        imageStyleFormatted: function imageStyleFormatted() {
            var settings = {
                left: this.imgSite.ImageStyle.left + '%',
                top: this.imgSite.ImageStyle.top + '%',
                transform: 'translateY(' + this.imgSite.ImageStyle.translateY + '%) translateX(' + this.imgSite.ImageStyle.translateX + '%)'
            };
            if (this.imgSite.ImageStyle.resizeType === 1 && parseInt(this.imgSite.ImageStyle.size)) {
                settings.height = this.imgSite.ImageStyle.size + '%';
            }
            if (this.imgSite.ImageStyle.resizeType === 2 && parseInt(this.imgSite.ImageStyle.size)) {
                settings.width = this.imgSite.ImageStyle.size + '%';
            }

            return settings;
        },
        imageStyleMobileFormatted: function imageStyleMobileFormatted() {
            var settings = {
                left: this.imgMobile.ImageStyle.left + '%',
                top: this.imgMobile.ImageStyle.top + '%',
                transform: 'translateY(' + this.imgMobile.ImageStyle.translateY + '%) translateX(' + this.imgMobile.ImageStyle.translateX + '%)'
            };
            if (this.imgMobile.ImageStyle.resizeType === 1 && parseInt(this.imgMobile.ImageStyle.size)) {
                settings.height = this.imgMobile.ImageStyle.size + '%';
            }
            if (this.imgMobile.ImageStyle.resizeType === 2 && parseInt(this.imgMobile.ImageStyle.size)) {
                settings.width = this.imgMobile.ImageStyle.size + '%';
            }

            return settings;
        },
        allowManualNominal: function allowManualNominal() {
            //this.reward.RewardType === RewardTypes.ElectronicGiftCard && this.reward.OzonCertificate;
            return this.reward.RewardType !== __WEBPACK_IMPORTED_MODULE_4__enums__["l" /* RewardTypes */].PhysicalPrize;
        }
    },

    methods: {
        onGifteryUpdate: function onGifteryUpdate() {
            var vm = this;

            vm.loadGidteryProducts().then(function () {
                if (!vm.giftery.data.length) {
                    return;
                }

                var item = vm.giftery.data.find(function (x) {
                    return x.id == vm.reward.GifteryId;
                });
                if (!item) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка обновления, обратитесь к администратору');
                    return;
                }

                var _loop = function _loop(oldRewardPrice) {
                    if (!item.faces.find(function (x) {
                        return x === oldRewardPrice.Price;
                    }) && !oldRewardPrice.Active) {
                        oldRewardPrice.Active = false;
                        oldRewardPrice.Comment = 'Номинал недоступен';
                    }
                };

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = vm.reward.Prices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var oldRewardPrice = _step.value;

                        _loop(oldRewardPrice);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                var _loop2 = function _loop2(face) {
                    if (face === 0) {
                        return 'continue';
                    }
                    var rewardPrice = vm.reward.Prices.find(function (x) {
                        return x.Price === face;
                    });
                    if (!rewardPrice) {
                        vm.reward.Prices.push({
                            Nominal: face,
                            Price: face,
                            Active: true
                        });
                    }
                };

                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = item.faces[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var face = _step2.value;

                        var _ret2 = _loop2(face);

                        if (_ret2 === 'continue') continue;
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно обновлено');
            });
        },
        onRewardTypeChenge: function onRewardTypeChenge(item) {
            if (item.Id === __WEBPACK_IMPORTED_MODULE_4__enums__["l" /* RewardTypes */].PhysicalPrize) {
                if (!this.reward.Prices.length) {
                    this.reward.Prices.push({
                        Price: 0,
                        Nominal: '',
                        Active: true,
                        CanBeDeleted: true
                    });
                } else if (this.reward.Prices.length > 1) {
                    this.reward.Prices.splice(1, this.reward.Prices.length - 1);
                }
            }
        },
        onGifterySelect: function onGifterySelect(item) {
            var vm = this;

            vm.reward.GifteryId = item.id;
            vm.reward.Name = item.title;
            // todo: html
            vm.reward.Description = item.brief.replace('<p>', '').replace('</p>', '');

            var _loop3 = function _loop3(oldRewardPrice) {
                if (!item.faces.find(function (x) {
                    return x === oldRewardPrice.Price;
                }) && !oldRewardPrice.Active) {
                    oldRewardPrice.Active = false;
                    oldRewardPrice.Comment = 'Номинал недоступен';
                }
            };

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = vm.reward.Prices[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var oldRewardPrice = _step3.value;

                    _loop3(oldRewardPrice);
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            var _loop4 = function _loop4(face) {
                if (face === 0) {
                    return 'continue';
                }
                var rewardPrice = vm.reward.Prices.find(function (x) {
                    return x.Price === face;
                });
                if (!rewardPrice) {
                    vm.reward.Prices.push({
                        Nominal: face,
                        Price: face,
                        Active: true
                    });
                }
            };

            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = item.faces[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var face = _step4.value;

                    var _ret4 = _loop4(face);

                    if (_ret4 === 'continue') continue;
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            vm.$refs['ppGiftery'].close();
        },
        onGifteryModal: function onGifteryModal() {
            var vm = this;

            vm.$refs['ppGiftery'].show();
            vm.loadGidteryProducts();
        },
        loadGidteryProducts: function loadGidteryProducts() {
            var vm = this;

            vm.giftery.loading = true;
            vm.giftery.data = [];

            return backendApi.gifteryProducts().then(function (response) {
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке продуктов Giftery');
                } else {
                    console.info('loadGidteryProducts -> response:', JSON.parse(JSON.stringify(response.data)));
                    vm.giftery.data = response.data;
                }
                vm.giftery.loading = false;
            });
        },
        back: function back() {
            this.$router.back();
        },
        addPrice: function addPrice() {
            var vm = this;

            vm.reward.Prices.push({
                Price: 0,
                Nominal: '',
                Active: true,
                CanBeDeleted: true
            });
        },
        removePrice: function removePrice(item, index) {
            this.reward.Prices.splice(index, 1);
        },
        loadEntity: function loadEntity() {
            var that = this;
            var id = parseInt(this.$route.params.id);
            if (id === 0) {
                this.reward = {
                    new: true,
                    ImageStyle: JSON.parse(JSON.stringify(ImageStyleDefault)),
                    FileData: null,
                    Prices: [],
                    Name: null,
                    Description: null,
                    WebLink: null,
                    GifteryId: null,
                    ManualNominal: false,
                    ManualNominalPercent: 0,
                    ManualNominalMin: 0,
                    ManualNominalMax: 0,
                    ManualNominalStep: 0,
                    ImageStyleMobile: JSON.parse(JSON.stringify(ImageStyleDefault)),
                    ImageMobile: {},
                    OzonCertificate: false
                };
                that.imgSite = {
                    ImageStyle: that.reward.ImageStyle,
                    ImagePath: null,
                    Image: {}
                };
                that.imgMobile = {
                    ImageStyle: that.reward.ImageStyleMobile,
                    ImagePath: null,
                    Image: {}
                };

                return new Promise(function (resolve) {
                    return resolve();
                });
            } else {
                return backendApi.rewardsLoad(id).then(function (response) {
                    if (response.hasError) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке вознаграждения');
                    } else {
                        if (response.data == null) {
                            that.$router.back();
                        }

                        if (response.data.ImageStyle) {
                            response.data.ImageStyle = JSON.parse(response.data.ImageStyle);
                        } else {
                            response.data.ImageStyle = JSON.parse(JSON.stringify(ImageStyleDefault));
                        }
                        if (response.data.ImageStyleMobile) {
                            response.data.ImageStyleMobile = JSON.parse(response.data.ImageStyleMobile);
                        } else {
                            response.data.ImageStyleMobile = JSON.parse(JSON.stringify(ImageStyleDefault));
                        }
                        response.data.FileData = null;
                        response.data.GroupId = response.data.Group ? response.data.Group.Id : null;
                        response.data.ManualNominal = response.data.ManualNominalPercent !== null;

                        that.reward = response.data;
                        that.reward.ImageMobile = {};
                        that.imgMobile = {
                            ImageStyle: that.reward.ImageStyleMobile,
                            ImagePath: that.reward.ImageMobilePath,
                            Image: {}
                        };
                        that.imgSite = {
                            ImageStyle: that.reward.ImageStyle,
                            ImagePath: that.reward.Image,
                            Image: {}
                        };
                    }
                });
            }
        },
        saveEntity: function saveEntity() {
            var vm = this;

            this.$validator.validate().then(function (result) {
                if (!result) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                } else {
                    if (vm.savingInProgress) {
                        return;
                    }
                    vm.savingInProgress = true;
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Сохранение...');

                    var saveObj = Object.assign({}, vm.reward, {
                        DeleteImage: vm.imgSite.Image.Id === -1,
                        ProjectId: vm.projectId
                    });
                    saveObj.ImageStyle = JSON.stringify(saveObj.ImageStyle);
                    if (!vm.reward.ManualNominal) {
                        saveObj.ManualNominalPercent = null;
                    }
                    saveObj.ImageStyle = JSON.stringify(vm.imgSite.ImageStyle);
                    saveObj.FileData = vm.imgSite.Image.FileData;
                    saveObj.FileName = vm.imgSite.Image.FileName;
                    saveObj.ImageMobile = vm.imgMobile.Image;
                    if (vm.imgMobile.ImageStyle.useMainPhoto) {
                        saveObj.ImageMobile.FileName = '';
                        saveObj.ImageMobile.FileData = '';
                        saveObj.ImageMobile.Id = -1;
                        saveObj.ImageMobilePath = '';
                    }
                    saveObj.ImageStyleMobile = JSON.stringify(vm.imgMobile.ImageStyle);

                    // if(saveObj.Prices.length === 1){
                    //     saveObj.Prices[0].Nominal = '';
                    //     saveObj.Prices[0].Active = true;
                    // }
                    //console.info('saveObj', saveObj)

                    backendApi.rewardsSave(saveObj).then(function (response) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                        if (response.hasError) {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении вознаграждения');
                        } else {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');
                            vm.$router.back();
                        }
                        vm.savingInProgress = false;
                    });
                }
            });
        },
        deleteEntity: function deleteEntity() {
            var that = this;

            if (confirm('Вы уверены?')) {
                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.portlet', 'Удаление...');
                backendApi.rewardsDelete(that.reward.Id).then(function (response) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.portlet');
                    if (response.hasError) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при удалении вознаграждения');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно удалено');
                        that.$router.push('/spend-bonuses');
                    }
                });
            }
        },
        loadGroups: function loadGroups() {
            var vm = this;
            return backendApi.rewardGroupList(vm.projectId).then(function (response) {
                var _vm$rewardGroups;

                (_vm$rewardGroups = vm.rewardGroups).push.apply(_vm$rewardGroups, _toConsumableArray(response.data));
            });
        },
        loadProject: function loadProject() {
            var vm = this;

            return this.callApiWrapper(backendApi.projectLoad(vm.projectId)).then(function (resp) {
                if (resp.data) {
                    vm.project = resp.data;
                }
            });
        },
        loadFolders: function loadFolders() {
            var vm = this;
            return backendApi.domainFoldersList(vm.projectId, 2).then(function (response) {
                var _vm$domainFolders;

                (_vm$domainFolders = vm.domainFolders).push.apply(_vm$domainFolders, _toConsumableArray(response.data));
            });
        },
        loadGifteryBalance: function loadGifteryBalance() {
            var vm = this;
            return backendApi.getGifteryBalance(vm.projectId).then(function (response) {
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при получении баланса Giftery');
                } else {
                    if (response.data.HasError) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при получении баланса Giftery: ' + response.data.Error);
                    } else {
                        vm.giftery.balance = response.data.Data.balance; // ? response.data.Data.balance : 0;
                    }
                }
            });
        },
        onImageViewChanged: function onImageViewChanged(imgPath, name) {
            if (name === 'site') this.imgSitePath = imgPath;else this.imgMobilePath = imgPath;
        }
    },

    mounted: function mounted() {
        var vm = this;

        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.page-content', 'Загрузка...');
        Promise.all([this.loadFolders(), this.loadGroups(), this.loadProject()]).then(function () {
            vm.loadEntity().then(function () {
                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.page-content');
            });
            vm.loadGifteryBalance();
        });
    },
    destroyed: function destroyed() {}
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_img_mixin__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__config__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var backendApi = new __WEBPACK_IMPORTED_MODULE_0__backendApi__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "questions-edit",

    props: ['info'],

    mixins: [__WEBPACK_IMPORTED_MODULE_3__helpers_project_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__helpers_img_mixin__["a" /* default */]],

    data: function data() {
        return {
            questions: [],
            material: null,
            randomOrder: false,
            questionsToPass: null,
            questionTypes: [{ Id: 1, Name: 'Один из списка' }, { Id: 2, Name: 'Несколько из списка' }, { Id: 3, Name: 'Свободный' }],
            answerTypes: [{ Id: 1, Name: 'Текст' }, { Id: 2, Name: 'Целое число' }, { Id: 3, Name: 'Дробное число' }, { Id: 4, Name: 'Дата' }],
            importResult: null,
            exportDateStart: null,
            exportDateEnd: null,
            exportFilter: null,
            filters: [],
            roles: [],
            backgroundImage: null,
            backgroundImageTop: true,
            backgroundImageText: '',
            backgroundImageKey: 0,
            headerBackgroundPreview: ''
        };
    },


    methods: {
        onImporFileChange: function onImporFileChange() {
            var vm = this;

            var files = document.getElementById('dropFiles').files;
            if (files.length > 0) {
                if (window.FormData !== undefined) {
                    var data = new FormData();
                    for (var x = 0; x < files.length; x++) {
                        data.append("file" + x, files[x]);
                    }
                    vm.importResult = null;

                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent');
                    this.callApiWrapper(backendApi.materialQuestionsImport(data)).then(function (response) {
                        document.getElementById('dropFiles').value = '';
                        if (response.hasError) {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка импорта');
                        } else {
                            if (response.data) {
                                vm.importResult = response.data;

                                if (vm.importResult.Data.length) {
                                    var _iteratorNormalCompletion = true;
                                    var _didIteratorError = false;
                                    var _iteratorError = undefined;

                                    try {
                                        for (var _iterator = vm.importResult.Data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                            var q = _step.value;

                                            vm.questions.push(q);
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return) {
                                                _iterator.return();
                                            }
                                        } finally {
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Браузер не поддерживает загрузку файлов HTML5!');
                }
            }
        },
        back: function back() {
            this.$router.back();
        },
        onChangeDate: function onChangeDate(answer) {
            answer['Value'] = Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(answer['date'], 'DD.MM.YYYY').format('DD.MM.YYYY');
        },
        onChangeAnswerType: function onChangeAnswerType(question) {
            if (question.Answers.length === 1) {
                question.Answers[0].Value = '';
            }
        },
        addQuestion: function addQuestion() {
            this.questions.push({
                Id: 0,
                QuestionType: 1,
                Answers: [{
                    Id: 0,
                    Value: 'Вариант-1'
                }],
                AnswerType: 1,
                Images: [],
                BackgroundSite: {},
                BackgroundMobile: {}
            });
        },
        removeQuestion: function removeQuestion(i) {
            this.questions.splice(i, 1);
        },
        addAnswer: function addAnswer(question) {
            question.Answers.push({
                Id: 0
            });
        },
        removeAnswer: function removeAnswer(question, j) {
            question.Answers.splice(j, 1);
        },
        onChangeQuestionType: function onChangeQuestionType(question) {
            if (question.QuestionType === 3) {
                question.Answers = [{}];
                question.AnswerType = 1;
            } else {
                question.AnswerType = null;

                if (question.QuestionType === 1) // один из списка
                    {
                        var filtered = question.Answers.filter(function (x) {
                            return x.Correct;
                        });
                        if (filtered.length) {
                            var _iteratorNormalCompletion2 = true;
                            var _didIteratorError2 = false;
                            var _iteratorError2 = undefined;

                            try {
                                for (var _iterator2 = filtered[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                    var a = _step2.value;

                                    a.Correct = false;
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                        _iterator2.return();
                                    }
                                } finally {
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }

                            filtered[0].Correct = true;
                        }
                    }
            }
        },
        onCorrectChange: function onCorrectChange(question, answer) {
            // один из списка
            if (question.QuestionType === 1 && answer.Correct) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = question.Answers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var a = _step3.value;

                        a.Correct = false;
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }

                answer.Correct = true;
            }
        },
        loadQuestions: function loadQuestions() {
            var vm = this;

            var materialId = parseInt(this.$route.params.id);
            if (materialId === 0) {

                vm.$router.back();

                return new Promise(function (resolve) {
                    return resolve();
                });
            } else {
                return backendApi.materialLoad(materialId).then(function (response) {
                    //console.info('project.edit -> load, response:', response.data);
                    if (response.hasError) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке материала');
                    } else {
                        if (response.data == null) {
                            vm.$router.back();
                        }

                        vm.material = response.data;
                        vm.questions = response.data.Questions || [];
                        vm.randomOrder = response.data.RandomOrder;
                        vm.questionsToPass = response.data.QuestionsToPass;
                    }
                });
            }
        },
        loadRoles: function loadRoles() {
            var vm = this;
            var projectId = vm.material.ProjectId;
            vm.filters = [{
                Value: 'Name', Name: 'Название'
            }, {
                Value: 'Region', Name: 'Область'
            }, {
                Value: 'City', Name: 'Город'
            }, {
                Value: 'Address', Name: 'Адрес'
            }];
            return this.callApiWrapper(backendApi.rolesList(projectId)).then(function (resp) {
                if (resp.data) {

                    vm.roles = resp.data.Roles;

                    /*
                    для ролей соблюдаем иерархию, согласно последовательности отображения в настройках ролей
                    если роль не связана с ТТ, то она видит все роли связанные с ТТ
                    если роль связана с ТТ, то видит только роли, которые стоят ниже нее
                    */
                    if (vm.info.User.DynamicRole == null || vm.info.User.DynamicRole.Claims.find(function (x) {
                        return x.ClaimId === vm.claimEnums.ttAccess;
                    })) {
                        //alert()
                        for (var r = 0; r < vm.roles.length; r++) {
                            if (!vm.roles[r].Claims.find(function (x) {
                                return x.ClaimId === vm.claimEnums.ttAccess;
                            })) {
                                vm.filters.push({
                                    Value: 'TradePointRole_' + vm.roles[r].Id,
                                    Name: vm.roles[r].Name
                                });
                            }
                        }
                    } else {

                        for (var _r = 0; _r < vm.roles.length; _r++) {
                            if (!vm.roles[_r].Claims.find(function (x) {
                                return x.ClaimId === vm.claimEnums.ttAccess;
                            }) && vm.info.User.DynamicRole.Order < vm.roles[_r].Order) {

                                vm.filters.push({
                                    Value: 'TradePointRole_' + vm.roles[_r].Id,
                                    Name: vm.roles[_r].Name
                                });
                            }
                        }
                    }
                }
            });
        },
        saveQuestions: function saveQuestions() {
            var _this = this;

            var vm = this;

            this.$validator.validate().then(function (result) {
                if (!result) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                } else if (vm.questions.length && !vm.questions.filter(function (x) {
                    return x.Active === true;
                }).length) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Нужен хотя бы один активный вопрос');
                } else {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Сохранение...');

                    var materialId = parseInt(_this.$route.params.id);
                    var saveObj = {
                        MaterialId: materialId,
                        Questions: vm.questions,
                        RandomOrder: vm.randomOrder,
                        QuestionsToPass: vm.questionsToPass
                    };

                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                        for (var _iterator4 = saveObj.Questions[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                            var q = _step4.value;

                            if (q.QuestionType === 3 && q.Answers.length === 1) {
                                q.Answers[0].Correct = true;
                            }
                        }

                        //console.info('saveObj', saveObj);
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }
                        } finally {
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }

                    backendApi.materialQuestionsSave(saveObj).then(function (response) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                        if (response.hasError) {
                            if (response.status === 701) {
                                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Неверное значение количества обязательных вопросов');
                            } else {
                                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении вопросов');
                            }
                        } else {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');

                            vm.loadQuestions();
                        }
                    });
                }
            });
        },
        onExportModal: function onExportModal() {
            this.onShowModal('ppExport');
        },
        searchFunction: function searchFunction(tableName, columnName, search, filters, searchPage, callback) {
            var vm = this;
            var materialId = parseInt(this.$route.params.id);
            //let projectId = vm.material.ProjectId;
            var filterFormatted = '';
            if (filters) {
                filterFormatted = filters.map(function (x) {
                    return JSON.stringify(x);
                });
            }

            this.callApiWrapper(backendApi.materialResultsExportDistinctValues(columnName, materialId, search, filterFormatted, (searchPage - 1) * 30, 30)).then(function (resp) {
                callback(resp.data);
            });
        },
        onFilterChange: function onFilterChange(filter) {
            this.exportFilter = filter;
        },
        onExport: function onExport() {
            var vm = this;
            var dateStart = Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(vm.exportDateStart, 'DD.MM.YYYY').format();
            var dateEnd = Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(vm.exportDateEnd, 'DD.MM.YYYY').format();
            var materialId = parseInt(vm.$route.params.id);

            var filterFormatted = '';
            if (vm.exportFilter) {
                filterFormatted = vm.exportFilter.map(function (x) {
                    return JSON.stringify(x);
                });
            }

            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.popup');

            this.callApiWrapper(backendApi.materialResultsExport(materialId, filterFormatted, dateStart, dateEnd)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время экспорта результатов тетса');
                } else {
                    //let exportFile = resp.data;
                    //location.href = config.apiUrl + '/api/materials/results/exported?exportFile=' + exportFile;
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].downloadFileByBytes(resp.data, "Тесты. Выгрузка результатов.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                }

                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.popup');
            });
        },
        removeImage: function removeImage(questionIndex, imageIndex) {
            if (confirm('Удалить файл?')) {
                this.questions[questionIndex].Images.splice(imageIndex, 1);
                this.$refs['dropFiles' + questionIndex].value = '';
            }
        },
        removeImageBackground: function removeImageBackground(questionIndex, clientType) {
            if (confirm('Удалить файл?')) {
                if (clientType === 'site') {
                    this.questions[questionIndex].BackgroundSite.FileData = '';
                    this.questions[questionIndex].BackgroundSite.FilePath = '';
                    this.questions[questionIndex].BackgroundSite.FileName = '';
                } else if (clientType === 'mobile') {
                    this.questions[questionIndex].BackgroundMobile.FileData = '';
                    this.questions[questionIndex].BackgroundMobile.FilePath = '';
                    this.questions[questionIndex].BackgroundMobile.FileName = '';
                }
                this.backgroundImageKey += 1;
            }
        },
        onDropFilesBackgroundSite: function onDropFilesBackgroundSite(obj) {
            obj.client = 'site';
            this.onDropFilesBackground(obj);
        },
        onDropFilesBackgroundMobile: function onDropFilesBackgroundMobile(obj) {
            obj.client = 'mobile';
            this.onDropFilesBackground(obj);
        },
        onDropFilesBackground: function onDropFilesBackground(obj) {
            var files = obj.files;
            var fieldId = obj.id;
            var client = obj.client;
            var filename = '';
            //console.info('onDropFilesBackground', obj);
            var vm = this;
            if (files && files.length) {
                var _loop = function _loop(file) {
                    filename = file.name.toLowerCase();
                    if (filename.endsWith('.jpg') || filename.endsWith('.jpeg') || filename.endsWith('.png')) {
                        if (file.size > 50 * 1024 * 1024) {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Превышен размер. Выберите другой файл');
                            __WEBPACK_IMPORTED_MODULE_1_jquery___default()('[name="dropFiles"]').val('');
                        } else {
                            //console.info('file:', filename.indexOf('.doc'), filename);
                            var reader = new FileReader();
                            reader.onload = function (e) {
                                if (client === 'site') {
                                    vm.questions[fieldId].BackgroundSite.FileName = file.name;
                                    vm.questions[fieldId].BackgroundSite.FileData = e.target.result;
                                } else if (client === 'mobile') {
                                    vm.questions[fieldId].BackgroundMobile.FileName = file.name;
                                    vm.questions[fieldId].BackgroundMobile.FileData = e.target.result;
                                }
                                vm.backgroundImageKey += 1;
                            };
                            reader.readAsDataURL(file);
                        }
                    } else {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Не верный формат файла ' + filename + ', разрешено: .jpg,.jpeg,.png');
                    }
                };

                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                    for (var _iterator5 = files[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                        var file = _step5.value;

                        _loop(file);
                    }
                } catch (err) {
                    _didIteratorError5 = true;
                    _iteratorError5 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                            _iterator5.return();
                        }
                    } finally {
                        if (_didIteratorError5) {
                            throw _iteratorError5;
                        }
                    }
                }
            }
        },
        onBackgroundPreviewModal: function onBackgroundPreviewModal(background, i, client) {
            var vm = this;
            if (background.FileData) vm.backgroundImage = background.FileData;else vm.backgroundImage = background.FilePath;
            vm.backgroundImageText = vm.questions[i].Description;
            vm.backgroundImageTop = background.Align === 'top';
            if (client === 'site') {
                vm.headerBackgroundPreview = 'Предварительный просмотр отображения вопроса на сайте';
            } else {
                vm.headerBackgroundPreview = 'Предварительный просмотр отображения вопроса в мобильном приложении';
            }
            this.onShowModal('ppBackgroundPreview');
        },
        closeModal: function closeModal(popupName) {
            this.$refs[popupName].close();
        }
    },

    mounted: function mounted() {
        var vm = this;

        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
        this.loadQuestions().then(function () {

            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
            vm.loadRoles();

            __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on('change', '[name="dropFilesBackground"]', function () {
                var fieldId = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data('fieldid');
                var client = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).data('client');
                //console.info('atDropFiles2 -> typeId:', fieldId, $(this)[0].accept, client)
                if (client === 'site') {
                    vm.onDropFilesBackgroundSite({ files: this.files, id: fieldId, accept: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this)[0].accept, client: client });
                } else {
                    vm.onDropFilesBackgroundMobile({ files: this.files, id: fieldId, accept: __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this)[0].accept, client: client });
                }
            });

            vm.imgmixin_lightzoomInit();
        });

        __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).on('change', '.dropFiles', function () {
            var $this = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
            if (this.files && this.files.length) {
                var _iteratorNormalCompletion6 = true;
                var _didIteratorError6 = false;
                var _iteratorError6 = undefined;

                try {
                    for (var _iterator6 = this.files[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                        var file = _step6.value;

                        if (file.size > 50 * 1024 * 1024) {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Превышен размер. Выберите другой файл');
                            $this.val('');
                        } else {
                            (function () {
                                var img = { FileName: file.name, FileData: null, Delete: false };
                                var reader = new FileReader();
                                reader.onload = function (e) {
                                    img.FileData = e.target.result;

                                    var questionIndex = parseInt($this.data('index'));
                                    vm.questions[questionIndex].Images.push(img);

                                    vm.$nextTick(function () {
                                        vm.imgmixin_lightzoomInit();
                                    });
                                };
                                reader.readAsDataURL(file);
                            })();
                        }
                    }
                } catch (err) {
                    _didIteratorError6 = true;
                    _iteratorError6 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion6 && _iterator6.return) {
                            _iterator6.return();
                        }
                    } finally {
                        if (_didIteratorError6) {
                            throw _iteratorError6;
                        }
                    }
                }
            }
        });
    },
    destroyed: function destroyed() {}
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(9);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var backendApi = new __WEBPACK_IMPORTED_MODULE_0__backendApi__["a" /* default */]();

var ImageStyleDefault = {
    top: 0,
    left: 100,
    translateY: 0,
    translateX: -50,
    size: 100,
    resizeType: 1
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "folder-edit",
    data: function data() {
        return {
            folder: null,
            file: null,
            deleteImage: false,
            folders: [],
            imgSitePath: null,
            imgSite: {},
            imgMobilePath: null,
            imgMobile: {},
            savingInProgress: false,
            componentKey: 0
        };
    },


    computed: {
        imageStyleFormatted: function imageStyleFormatted() {
            var settings = {
                left: this.imgSite.ImageStyle.left + '%',
                top: this.imgSite.ImageStyle.top + '%',
                transform: 'translateY(' + this.imgSite.ImageStyle.translateY + '%) translateX(' + this.imgSite.ImageStyle.translateX + '%)'
            };
            if (this.imgSite.ImageStyle.resizeType === 1 && parseInt(this.imgSite.ImageStyle.size)) {
                settings.height = this.imgSite.ImageStyle.size + '%';
            }
            if (this.imgSite.ImageStyle.resizeType === 2 && parseInt(this.imgSite.ImageStyle.size)) {
                settings.width = this.imgSite.ImageStyle.size + '%';
            }

            return settings;
        },
        imageStyleMobileFormatted: function imageStyleMobileFormatted() {
            var settings = {
                left: this.imgMobile.ImageStyle.left + '%',
                top: this.imgMobile.ImageStyle.top + '%',
                transform: 'translateY(' + this.imgMobile.ImageStyle.translateY + '%) translateX(' + this.imgMobile.ImageStyle.translateX + '%)'
            };
            if (this.imgMobile.ImageStyle.resizeType === 1 && parseInt(this.imgMobile.ImageStyle.size)) {
                settings.height = this.imgMobile.ImageStyle.size + '%';
            }
            if (this.imgMobile.ImageStyle.resizeType === 2 && parseInt(this.imgMobile.ImageStyle.size)) {
                settings.width = this.imgMobile.ImageStyle.size + '%';
            }

            return settings;
        }
    },

    methods: {
        back: function back() {
            this.$router.back();
        },
        onSelectFolder: function onSelectFolder(item) {
            var vm = this;
            vm.parentId = item.Id;
            for (var i = 0; i < vm.folders.length; i++) {
                if (vm.folders[i].Checked) {
                    vm.folders[i].Checked = false;
                }
            }
            item.Checked = true;
            vm.componentKey++;
        },
        archiveFolder: function archiveFolder(full) {
            var vm = this;
            var messConfirm = full ? 'Вы уверены? Подпапки также станут архивными.' : 'Вы уверены? Подпапки останутся активными.';
            if (confirm(messConfirm)) {
                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.portlet', 'Консервация...');
                var saveObj = { Id: vm.folder.Id, Full: full };
                backendApi.folderArchive(saveObj).then(function (response) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.portlet');
                    if (response.hasError) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при архивации');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно архивировано');

                        vm.$router.back();
                    }
                });
            }
        },
        openSelectFolderModal: function openSelectFolderModal(full) {
            var vm = this;
            vm.fullRestore = full;
            vm.$refs.ppFolderList.show();
        },
        restoreFolder: function restoreFolder() {
            var vm = this;
            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.portlet', 'Восстановление...');
            var saveObj = { Id: vm.folder.Id, Full: vm.fullRestore, ParentId: vm.parentId };
            backendApi.folderRestore(saveObj).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.portlet');
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при восстановлении');
                } else {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно восстановлено');
                    vm.folder.DateArchive = null;
                    vm.$refs.ppFolderList.close();
                }
            });
        },
        loadFolders: function loadFolders() {
            var vm = this;

            var projectId = vm.folder.new ? 0 : vm.folder.ProjectId;
            //alert(projectId)
            return backendApi.folderList(projectId).then(function (response) {
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке папок материалов');
                } else {
                    var _vm$folders;

                    vm.folders = [{ Id: null, Name: 'Корневая' }];
                    (_vm$folders = vm.folders).push.apply(_vm$folders, _toConsumableArray(response.data));
                }
            });
        },
        loadFolder: function loadFolder() {
            var vm = this;
            var id = parseInt(vm.$route.params.id);
            if (id === 0) {
                var parentId = vm.$route.query.folderId;

                this.folder = {
                    new: true,
                    ImageStyle: JSON.parse(JSON.stringify(ImageStyleDefault)),
                    ParentId: parentId,
                    ImageStyleMobile: JSON.parse(JSON.stringify(ImageStyleDefault)),
                    ImageMobile: {}
                };
                vm.imgSite = {
                    ImageStyle: vm.folder.ImageStyle,
                    ImagePath: null,
                    Image: {}
                };
                vm.imgMobile = {
                    ImageStyle: vm.folder.ImageStyleMobile,
                    ImagePath: null,
                    Image: {}
                };

                return new Promise(function (resolve) {
                    return resolve();
                });
            } else {
                return backendApi.folderLoad(id).then(function (response) {
                    if (response.hasError) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке папки');
                    } else {
                        if (response.data == null) {
                            vm.$router.back();
                        }

                        if (response.data.ImageStyle) {
                            response.data.ImageStyle = JSON.parse(response.data.ImageStyle);
                        } else {
                            response.data.ImageStyle = JSON.parse(JSON.stringify(ImageStyleDefault));
                        }
                        if (response.data.ImageStyleMobile) {
                            response.data.ImageStyleMobile = JSON.parse(response.data.ImageStyleMobile);
                        } else {
                            response.data.ImageStyleMobile = JSON.parse(JSON.stringify(ImageStyleDefault));
                        }

                        response.data.FileData = null;

                        vm.folder = response.data;
                        vm.folder.ImageMobile = {};
                        vm.imgMobile = {
                            ImageStyle: vm.folder.ImageStyleMobile,
                            ImagePath: vm.folder.ImageMobilePath,
                            Image: {}
                        };
                        vm.imgSite = {
                            ImageStyle: vm.folder.ImageStyle,
                            ImagePath: vm.folder.Image,
                            Image: {}
                        };
                    }
                });
            }
        },
        saveFolder: function saveFolder() {
            var vm = this;

            this.$validator.validate().then(function (result) {
                if (!result) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                } else {
                    if (vm.savingInProgress) {
                        return;
                    }
                    vm.savingInProgress = true;
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.portlet', 'Сохранение...');
                    var selectedProjectId = localStorage.getItem('selectedProjectId');

                    var saveObj = Object.assign({}, vm.folder, {
                        ProjectId: selectedProjectId != null ? parseInt(selectedProjectId) : null,
                        DeleteImage: vm.imgSite.Image.Id === -1 //vm.deleteImage
                    });
                    saveObj.ImageStyle = JSON.stringify(vm.imgSite.ImageStyle);
                    saveObj.FileData = vm.imgSite.Image.FileData;
                    saveObj.FileName = vm.imgSite.Image.FileName;
                    saveObj.ImageMobile = vm.imgMobile.Image;
                    if (vm.imgMobile.ImageStyle.useMainPhoto) {
                        saveObj.ImageMobile.FileName = '';
                        saveObj.ImageMobile.FileData = '';
                        saveObj.ImageMobile.Id = -1;
                        saveObj.ImageMobilePath = '';
                    }
                    saveObj.ImageStyleMobile = JSON.stringify(vm.imgMobile.ImageStyle);

                    backendApi.folderSave(saveObj).then(function (response) {
                        //console.info('response.data', response.data)
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.portlet');
                        if (response.hasError) {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении папки');
                        } else {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');

                            vm.$router.back();
                            //vm.$router.push('/materials?folderId=' + response.data.Id);
                        }
                        vm.savingInProgress = false;
                    });
                }
            });
        },
        deleteFolder: function deleteFolder() {
            var that = this;

            if (confirm('Вы уверены? Подпапки и связанные материалы будут также удалены.')) {
                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.portlet', 'Удаление...');
                backendApi.folderDelete(that.folder.Id).then(function (response) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.portlet');
                    if (response.hasError) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при удалении папки');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно удалено');
                        that.$router.push('/materials');
                    }
                });
            }
        },
        onImageViewChanged: function onImageViewChanged(imgPath, name) {
            if (name === 'site') this.imgSitePath = imgPath;else this.imgMobilePath = imgPath;
        }
    },

    mounted: function mounted() {
        var vm = this;

        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.page-content', 'Загрузка...');
        vm.loadFolder().then(function () {
            return vm.loadFolders().then(function () {
                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.page-content');
            });
        });
    },
    destroyed: function destroyed() {}
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__ = __webpack_require__(4);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var backendApi = new __WEBPACK_IMPORTED_MODULE_0__backendApi__["a" /* default */]();

var ImageStyleDefault = {
    top: 0,
    left: 100,
    translateY: 0,
    translateX: -50,
    size: 100,
    resizeType: 1
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "sku-folder-edit",

    data: function data() {
        return {
            folder: null,
            imgSite: {},
            imgMobile: {},
            savingInProgress: false,
            parentId: '',
            domainFolders: [],
            fullRestore: true,
            componentKey: 0
        };
    },


    methods: {
        back: function back() {
            this.$router.back();
        },
        loadFolder: function loadFolder() {
            var vm = this;
            var id = parseInt(vm.$route.params.id);
            if (id === 0) {
                this.folder = {
                    new: true,
                    ImageStyle: JSON.parse(JSON.stringify(ImageStyleDefault)),
                    ParentId: vm.parentId,
                    DeleteImage: false,
                    FileData: null,
                    ImageStyleMobile: JSON.parse(JSON.stringify(ImageStyleDefault)),
                    ImageMobile: {}
                };

                return new Promise(function (resolve) {
                    return resolve();
                });
            } else {
                return backendApi.domainFolderLoad(id).then(function (response) {
                    if (response.hasError) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке папки');
                    } else {
                        if (response.data == null) {
                            vm.$router.back();
                        }

                        if (response.data.ImageStyle) {
                            response.data.ImageStyle = JSON.parse(response.data.ImageStyle);
                        } else {
                            response.data.ImageStyle = JSON.parse(JSON.stringify(ImageStyleDefault));
                        }
                        if (response.data.ImageStyleMobile) {
                            response.data.ImageStyleMobile = JSON.parse(response.data.ImageStyleMobile);
                        } else {
                            response.data.ImageStyleMobile = JSON.parse(JSON.stringify(ImageStyleDefault));
                        }

                        vm.folder = Object.assign({}, response.data, { DeleteImage: false, FileData: null });
                        vm.folder.ImageMobile = {};
                        vm.parentId = vm.folder.ParentId;
                        vm.loadFolders();
                    }
                });
            }
        },
        saveFolder: function saveFolder() {
            var vm = this;

            this.$validator.validate().then(function (result) {
                if (!result) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                } else {
                    if (vm.savingInProgress) {
                        return;
                    }
                    vm.savingInProgress = true;
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.portlet', 'Сохранение...');

                    var selectedProjectId = localStorage.getItem('selectedProjectId');

                    var saveObj = Object.assign({}, vm.folder, {
                        ProjectId: selectedProjectId != null ? parseInt(selectedProjectId) : null,
                        DeleteImage: vm.imgSite.Image.Id === -1,
                        DomainType: 1
                    });
                    saveObj.ImageStyle = JSON.stringify(vm.imgSite.ImageStyle);
                    saveObj.FileData = vm.imgSite.Image.FileData;
                    saveObj.FileName = vm.imgSite.Image.FileName;
                    saveObj.ImageMobile = vm.imgMobile.Image;
                    if (vm.imgMobile.ImageStyle.useMainPhoto) {
                        saveObj.ImageMobile.FileName = '';
                        saveObj.ImageMobile.FileData = '';
                        saveObj.ImageMobile.Id = -1;
                        saveObj.ImageMobilePath = '';
                    }
                    saveObj.ImageStyleMobile = JSON.stringify(vm.imgMobile.ImageStyle);

                    backendApi.domainFolderSave(saveObj).then(function (response) {
                        //console.info('response.data', response.data)
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.portlet');
                        if (response.hasError) {
                            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении папки');
                        } else {
                            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');

                            vm.$router.back();
                            //vm.$router.push('/sku?folderId=' + response.data.Id);
                        }
                        vm.savingInProgress = false;
                    });
                }
            });
        },
        deleteFolder: function deleteFolder() {
            var vm = this;

            if (confirm('Вы уверены? Подпапки будут также удалены.')) {
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.portlet', 'Удаление...');
                backendApi.domainFolderDelete(vm.folder.Id).then(function (response) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.portlet');
                    if (response.hasError) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при удалении папки');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно удалено');

                        vm.$router.back();
                        //that.$router.push('/sku');
                    }
                });
            }
        },
        onUpdate: function onUpdate(imageSite, imageMobile) {
            this.imgSite = imageSite;
            this.imgMobile = imageMobile;
        },
        archiveFolder: function archiveFolder(full) {
            var vm = this;
            var messConfirm = full ? 'Вы уверены? Подпапки также станут архивными.' : 'Вы уверены? Подпапки останутся активными.';
            if (confirm(messConfirm)) {
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.portlet', 'Консервация...');
                var saveObj = { Id: vm.folder.Id, Full: full };
                //console.info('archiveFolder', saveObj);
                backendApi.domainFolderArchive(saveObj).then(function (response) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.portlet');
                    if (response.hasError) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при архивации');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно архивировано');

                        vm.$router.back();
                        //that.$router.push('/sku');
                    }
                });
            }
        },
        openSelectFolderModal: function openSelectFolderModal(full) {
            var vm = this;
            vm.fullRestore = full;
            vm.$refs.ppFolderList.show();
        },
        restoreFolder: function restoreFolder() {
            var vm = this;
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.portlet', 'Восстановление...');
            var saveObj = { Id: vm.folder.Id, Full: vm.fullRestore, ParentId: vm.parentId };
            //console.info('restoreFolder', saveObj);
            backendApi.domainFolderRestore(saveObj).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.portlet');
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при восстановлении');
                } else {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно восстановлено');
                    vm.folder.DateArchive = null;
                    vm.$refs.ppFolderList.close();
                }
            });
        },
        loadFolders: function loadFolders() {
            var vm = this;
            var selectedProjectId = localStorage.getItem('selectedProjectId');
            return backendApi.domainFoldersList(selectedProjectId, 1).then(function (response) {
                var _vm$domainFolders;

                vm.domainFolders = [{ Id: null, Name: 'Корневая' }];
                (_vm$domainFolders = vm.domainFolders).push.apply(_vm$domainFolders, _toConsumableArray(response.data));
                for (var i = 0; i < vm.domainFolders.length; i++) {
                    vm.domainFolders[i].Checked = vm.domainFolders[i].Id === vm.parentId;
                }
            });
        },
        onSelectFolder: function onSelectFolder(item) {
            var vm = this;
            vm.parentId = item.Id;
            for (var i = 0; i < vm.domainFolders.length; i++) {
                if (vm.domainFolders[i].Checked) {
                    vm.domainFolders[i].Checked = false;
                }
            }
            item.Checked = true;
            vm.componentKey++;
        }
    },

    mounted: function mounted() {
        var vm = this;
        vm.parentId = vm.$route.query.folderId;
        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.page-content', 'Загрузка...');
        vm.loadFolder().then(function () {
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.page-content');
        });
    }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var backendApi = new __WEBPACK_IMPORTED_MODULE_0__backendApi__["a" /* default */]();

var ImageStyleDefault = {
    top: 0,
    left: 100,
    translateY: 0,
    translateX: -50,
    size: 100,
    resizeType: 1
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "sku-folder-edit",

    data: function data() {
        return {
            folder: null,
            imgSite: {},
            imgMobile: {},
            savingInProgress: false
        };
    },


    methods: {
        back: function back() {
            this.$router.back();
        },
        loadFolder: function loadFolder() {
            var vm = this;
            var id = parseInt(vm.$route.params.id);
            if (id === 0) {
                var parentId = vm.$route.query.folderId;

                this.folder = {
                    new: true,
                    ImageStyle: JSON.parse(JSON.stringify(ImageStyleDefault)),
                    ParentId: parentId,
                    DeleteImage: false,
                    FileData: null,
                    ImageStyleMobile: JSON.parse(JSON.stringify(ImageStyleDefault)),
                    ImageMobile: {}
                };

                return new Promise(function (resolve) {
                    return resolve();
                });
            } else {
                return backendApi.domainFolderLoad(id).then(function (response) {
                    if (response.hasError) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке папки');
                    } else {
                        if (response.data == null) {
                            vm.$router.back();
                        }

                        if (response.data.ImageStyle) {
                            response.data.ImageStyle = JSON.parse(response.data.ImageStyle);
                        } else {
                            response.data.ImageStyle = JSON.parse(JSON.stringify(ImageStyleDefault));
                        }
                        if (response.data.ImageStyleMobile) {
                            response.data.ImageStyleMobile = JSON.parse(response.data.ImageStyleMobile);
                        } else {
                            response.data.ImageStyleMobile = JSON.parse(JSON.stringify(ImageStyleDefault));
                        }

                        vm.folder = Object.assign({}, response.data, { DeleteImage: false, FileData: null });
                        vm.folder.ImageMobile = {};
                    }
                });
            }
        },
        saveFolder: function saveFolder() {
            var vm = this;

            this.$validator.validate().then(function (result) {
                if (!result) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                } else {
                    if (vm.savingInProgress) {
                        return;
                    }
                    vm.savingInProgress = true;
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.portlet', 'Сохранение...');

                    var selectedProjectId = localStorage.getItem('selectedProjectId');

                    var saveObj = Object.assign({}, vm.folder, {
                        ProjectId: selectedProjectId != null ? parseInt(selectedProjectId) : null,
                        DeleteImage: vm.imgSite.Image.Id === -1,
                        DomainType: 2
                    });
                    saveObj.ImageStyle = JSON.stringify(vm.imgSite.ImageStyle);
                    saveObj.FileData = vm.imgSite.Image.FileData;
                    saveObj.FileName = vm.imgSite.Image.FileName;
                    saveObj.ImageMobile = vm.imgMobile.Image;
                    if (vm.imgMobile.ImageStyle.useMainPhoto) {
                        saveObj.ImageMobile.FileName = '';
                        saveObj.ImageMobile.FileData = '';
                        saveObj.ImageMobile.Id = -1;
                        saveObj.ImageMobilePath = '';
                    }
                    saveObj.ImageStyleMobile = JSON.stringify(vm.imgMobile.ImageStyle);

                    backendApi.domainFolderSave(saveObj).then(function (response) {
                        //console.info('response.data', response.data)
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.portlet');
                        if (response.hasError) {
                            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении папки');
                        } else {
                            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');

                            vm.$router.back();
                        }
                        vm.savingInProgress = false;
                    });
                }
            });
        },
        deleteFolder: function deleteFolder() {
            var vm = this;

            if (confirm('Вы уверены? Подпапки будут также удалены.')) {
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.portlet', 'Удаление...');
                backendApi.domainFolderDelete(vm.folder.Id).then(function (response) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.portlet');
                    if (response.hasError) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при удалении папки');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно удалено');

                        vm.$router.back();
                        //that.$router.push('/sku');
                    }
                });
            }
        },
        onUpdate: function onUpdate(imageSite, imageMobile) {
            this.imgSite = imageSite;
            this.imgMobile = imageMobile;
        }
    },

    mounted: function mounted() {
        var vm = this;
        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.page-content', 'Загрузка...');
        vm.loadFolder().then(function () {
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.page-content');
        });
    }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__backendApi__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var backendApi = new __WEBPACK_IMPORTED_MODULE_1__backendApi__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "activation",

    props: ['info'],

    data: function data() {
        return {
            result: null,
            password: null,
            passwordConfirm: null,
            passwordError: null
        };
    },


    methods: {
        onNewPasswordChange: function onNewPasswordChange() {
            this.passwordError = null;

            if (!this.password || !this.password.trim()) {
                //this.password.Error = null;
            } else {
                var newpass = this.password;

                if (newpass.length < 6) {
                    this.passwordError = 'Введите минимум 6 символов';
                } else if (!/(?=.*\d).*\D.*/ig.test(newpass)) {
                    this.passwordError = 'Обязательно наличие и букв и цифр';
                } else if (!/(?=.*[A-ZА-Я]).*[a-zа-я].*/g.test(newpass)) {
                    this.passwordError = 'Обязательно наличие заглавной и прописной буквы';
                }
            }
        },
        setPassword: function setPassword() {
            var vm = this;
            this.$validator.validate().then(function (result) {
                if (result) {

                    var hash = vm.$route.params.hash;
                    backendApi.userActivation(hash, vm.password).then(function (response) {
                        console.info('response', response);
                        if (response.hasError) {
                            __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при смене пароля');
                        } else {
                            __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__["a" /* default */].toastr.success('Пароль успешно задан');
                            vm.$router.push('/login');
                        }
                    });
                }
            });
        }
    },

    mounted: function mounted() {
        var vm = this;

        var hash = vm.$route.params.hash;
        if (!hash) {
            vm.$router.push('/login');
        }

        backendApi.userActivationInfo(hash).then(function (response) {
            if (response.hasError) {
                if (response.status === 1404) {
                    // неверный hash
                    console.info('неверный hash');
                    vm.$router.push('/login');
                } else {
                    __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке страницы');
                }
            } else {
                if (response.data != null) {
                    vm.result = response.data;
                }
            }
        });
    }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_smooth_dnd__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_img_mixin__ = __webpack_require__(90);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var backendApi = new __WEBPACK_IMPORTED_MODULE_1__backendApi__["a" /* default */]();

var FieldSettingsTypes = [{ Id: 'date', Name: 'Дата' }, { Id: 'select', Name: 'Список' }, { Id: 'sku', Name: 'Список SKU' }, { Id: 'int', Name: 'Целое число' }, { Id: 'decimal', Name: 'Дробное число' }, { Id: 'string', Name: 'Строковое значение' }, { Id: 'bool', Name: 'Галочка (да или нет)' }, { Id: 'attach', Name: 'Вложение' }];
/* harmony default export */ __webpack_exports__["a"] = ({
    name: "tasks-edit",

    props: ['info'],

    mixins: [__WEBPACK_IMPORTED_MODULE_6__helpers_img_mixin__["a" /* default */]],

    components: { Container: __WEBPACK_IMPORTED_MODULE_4_vue_smooth_dnd__["a" /* Container */], Draggable: __WEBPACK_IMPORTED_MODULE_4_vue_smooth_dnd__["b" /* Draggable */] },

    data: function data() {
        return {
            task: null,
            file: null,
            deleteImage: false,
            taskTypeItems: [{ Value: 1, Name: 'Накопительное' }, { Value: 2, Name: 'Простое' }],
            fieldInputTypes: [{ Value: 1, Name: 'Отдельные поля' }, { Value: 2, Name: 'Таблица' }],

            purposeTypeItems: [{ Value: 1, Name: 'Количество принятых ответов' }, { Value: 2, Name: 'Сумма по полю ответа' }],
            purposeFieldItems: [],
            scoringAccrualItems: [{ Value: 1, Name: 'Фиксировано' }],
            scoringAccrualField: [],
            scoringActivationPeriodField: [],
            scoringActivationPeriod: [{ Value: 1, Name: 'В день начисления' }, { Value: 2, Name: 'Через N дней после начисления' }, { Value: 3, Name: 'По окончанию месяца через N дней' }, { Value: 4, Name: 'Суммарно за период (месяц)' }],
            scoringBurningTime: [{ Value: 1, Name: 'Бессрочные' }, { Value: 2, Name: 'Через N дней с даты начисления' }, { Value: 3, Name: 'В указанную дату' }],
            memberFilterVariant: [{ Value: 1, Name: 'Выбор пользователей' }, { Value: 2, Name: 'Фильтр по торговым точкам' }, { Value: 3, Name: 'Фильтр по ролям' }],
            memberFilterUsers: [],
            memberFilterField: [],
            memberFilterRoles: [],
            memberFilterValue: [],
            memberFilterGrades: [],
            memberFilterUsersOnRole: [],
            allowEdit: true,
            TaskTypes: __WEBPACK_IMPORTED_MODULE_5__enums__["r" /* TaskTypes */],
            FieldType: __WEBPACK_IMPORTED_MODULE_5__enums__["d" /* FieldTypes */],
            PurposeType: __WEBPACK_IMPORTED_MODULE_5__enums__["h" /* PurposeType */],
            ScoringAccrualTypes: __WEBPACK_IMPORTED_MODULE_5__enums__["n" /* ScoringAccrualTypes */],
            ScoringBurningTime: __WEBPACK_IMPORTED_MODULE_5__enums__["p" /* ScoringBurningTime */],
            MemberFilters: __WEBPACK_IMPORTED_MODULE_5__enums__["e" /* MemberFilters */],
            ScoringActivation: __WEBPACK_IMPORTED_MODULE_5__enums__["o" /* ScoringActivation */],
            counterField: 0,
            numberFieldExist: false,
            dialogSkuSettings: null,
            currentSkuSettings: null,
            dialogSkuList: {},
            currentSkuList: null,
            page: 1,
            canBeLoaded: true,
            pageCheckedDown: 1,
            canBeLoadedCheckedDown: true,
            loading: false,
            filter: null,
            titlePopap: 'Настройка отображения SKU',
            dictSettings: null,
            taskCopy: {},
            useGradeOnSelectedRoles: false,
            changedFilterToRoleUsers: true
        };
    },


    computed: {
        fieldSettingsOrdered: function fieldSettingsOrdered() {
            return _.orderBy(this.task.FieldSettings, 'itemOrder');
        },

        fieldSettingsStr: function fieldSettingsStr() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.task.FieldSettings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var s = _step.value;

                    if (s.type === 'bool') {
                        s.options = '["Нет", "Да"]';
                        s.dbType = 'bit';
                    } else if (s.type === 'int') {
                        s.dbType = 'int';
                    } else if (s.type === 'sku') {
                        s.dbType = 'int';
                        s.options = JSON.stringify(s.sku);
                        //delete s.sku;
                    } else if (s.type === 'decimal') {
                        s.dbType = 'decimal(18,2)';
                    } else if (s.type === 'select') {
                        s.dbType = 'nvarchar(256)';
                    } else if (s.type === 'string') {
                        s.dbType = 'nvarchar(256)';
                        s.options = {};
                        s.options.scanner = s.scanner ? true : false;
                        s.options = JSON.stringify(s.options);
                    }
                    //scanner
                    else if (s.type === 'attach') {
                            s.dbType = 'nvarchar(256)';
                            s.options = [];
                            if (s.attach_photo) s.options.push('photo');
                            if (s.attach_doc) s.options.push('doc');
                            delete s.attach_photo;
                            delete s.attach_doc;
                            s.options = JSON.stringify(s.options);
                        } else if (s.type === 'date') {
                            s.dbType = 'date';
                        }
                    delete s.new;
                    //delete s.sku;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return this.task.FieldSettings;
        },
        memberFilterUsersStr: function memberFilterUsersStr() {
            if (this.task.MemberFilterUsers) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = this.task.MemberFilterUsers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var s = _step2.value;

                        delete s.Checked;
                        delete s.Hidden;
                        //delete s.UserFio;
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                return JSON.stringify(this.task.MemberFilterUsers);
            } else return null;
        },
        memberFilterValueStr: function memberFilterValueStr() {
            if (this.task.MemberFilterValue) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = this.task.MemberFilterValue[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var s = _step3.value;

                        delete s.Checked;
                        delete s.Hidden;
                        if (!s.Id) delete s.Id;
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }

                return JSON.stringify(this.task.MemberFilterValue);
            } else return null;
        },
        MemberFilterFieldStr: function MemberFilterFieldStr() {
            if (this.task.MemberFilterVariant === this.MemberFilters.Roles && this.task.MemberFilterField) {
                if (this.task.MemberFilterField.Roles) {
                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                        for (var _iterator4 = this.task.MemberFilterField.Roles[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                            var s = _step4.value;

                            delete s.Checked;
                            delete s.Hidden;
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }
                        } finally {
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }
                }
                if (this.task.MemberFilterField.Grades) {
                    var _iteratorNormalCompletion5 = true;
                    var _didIteratorError5 = false;
                    var _iteratorError5 = undefined;

                    try {
                        for (var _iterator5 = this.task.MemberFilterField.Grades[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                            var _s = _step5.value;

                            delete _s.Checked;
                            delete _s.Hidden;
                        }
                    } catch (err) {
                        _didIteratorError5 = true;
                        _iteratorError5 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                _iterator5.return();
                            }
                        } finally {
                            if (_didIteratorError5) {
                                throw _iteratorError5;
                            }
                        }
                    }
                }
                return JSON.stringify(this.task.MemberFilterField);
            } else return this.task.MemberFilterField;
        },
        scoringHeader: function scoringHeader() {
            return this.task.TaskType === this.TaskTypes.Cumulative ? 'Баллы за успешное прохождение' : 'Баллы за каждый ответ';
        },
        scoringAccrualHeader: function scoringAccrualHeader() {
            return this.task.ScoringAccrual === this.ScoringAccrualTypes.Fixed ? 'Сумма баллов' : 'Процент';
        },
        ppSkuFieldListCaption: function ppSkuFieldListCaption() {
            return this.task != null && this.task.ScoringAccrual === this.ScoringAccrualTypes.DependingOnSku ? 'Настройка отображения и начисления баллов за каждое SKU в текущем задании' : 'Настройка отображения SKU в текущем задании';
        },
        dependingOnSku: function dependingOnSku() {
            return this.task != null && this.task.ScoringAccrual === this.ScoringAccrualTypes.DependingOnSku;
        },
        skuSettingsOrdered: function skuSettingsOrdered() {
            if (this.dialogSkuSettings == null) {
                return null;
            }

            return _.orderBy(Object.values(this.dialogSkuSettings.sku), 'SettingsOrder');
        },
        skuListForeach: function skuListForeach() {
            return Object.entries(this.dialogSkuList).sort(function (_ref, _ref2) {
                var _ref4 = _slicedToArray(_ref, 2),
                    a = _ref4[1];

                var _ref3 = _slicedToArray(_ref2, 2),
                    b = _ref3[1];

                return a.order - b.order;
            });
        }
    },

    watch: {
        'task.Preview': function taskPreview() {
            this.task.PreviewFormatted = this.task.Preview ? this.task.Preview.replace(/\n/g, '<br>') : null;
        },

        '$route': function $route(to, from) {
            // Маршрут меняется,  страница обновляется
            this.$router.go(0);
        }
    },

    methods: {
        getFieldSettingsTypes: function getFieldSettingsTypes(field) {
            if (field.deleted && field.type === 'sku') {
                return FieldSettingsTypes;
            } else if (_.some(this.task.FieldSettings, function (x) {
                return x.type === 'sku' && x.id !== field.id && !x.deleted;
            })) {
                return FieldSettingsTypes.filter(function (x) {
                    return x.Id !== 'sku';
                });
            }
            return FieldSettingsTypes;
        },
        urlFileData: function urlFileData(fileData) {
            return 'background-image: url(' + fileData + ')';
        },
        back: function back() {
            this.$router.back();
        },
        loadTask: function loadTask() {
            var vm = this;

            if (vm.info.User.MainRole !== 'administrators' && !vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.tasksEdit)) {
                vm.back();
                return new Promise(function (resolve) {
                    return resolve();
                });
            }

            var id = parseInt(this.$route.params.id);
            if (id === 0) {
                this.task = {
                    Id: 0,
                    new: true,
                    TasksAttachments: [],
                    FieldSettings: [],
                    Fact: 0,
                    QntDone: 0,
                    FieldTableMinRows: 1,
                    skuList: {},
                    VisualSettings: { AnswerBtnAddText: null }
                };

                return new Promise(function (resolve) {
                    return resolve();
                });
            } else {
                return backendApi.tasksLoad(id).then(function (response) {
                    console.info('task.edit -> load, response:', response.data);
                    if (response.hasError) {
                        if (response.status === 403) {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Запрещено');
                            vm.$router.back();
                        } else __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке задания');
                    } else {
                        if (response.data == null) {
                            vm.$router.back();
                        }

                        vm.task = Object.assign(response.data.task, { Files: [] });
                        //vm.bonus = Object.assign(response.data.bonus);
                        //vm.task = Object.assign(response.data, {FileData: null});
                        vm.task.StartDateFormatted = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(vm.task.StartDate).format('DD.MM.YYYY');
                        if (vm.task.EndDate) {
                            vm.task.EndDateFormatted = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(vm.task.EndDate).format('DD.MM.YYYY');
                        }
                        if (vm.task.ScoringBurningDate) {
                            vm.task.ScoringBurningDateFormatted = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(vm.task.ScoringBurningDate).format('DD.MM.YYYY');
                        }
                        if (vm.task.PurposeTimeToComplete) {
                            vm.task.PurposeTimeToCompleteFormatted = vm.formatTime(vm.task.PurposeTimeToComplete);
                        }
                        if (vm.task.PurposeAllowAfterComplete) {
                            vm.task.PurposeAllowAfterCompleteFormatted = vm.formatTime(vm.task.PurposeAllowAfterComplete);
                        }

                        var _iteratorNormalCompletion6 = true;
                        var _didIteratorError6 = false;
                        var _iteratorError6 = undefined;

                        try {
                            for (var _iterator6 = vm.task.FieldSettings[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                                var s = _step6.value;

                                if (s.type == 'attach' && s.options) {
                                    var options = JSON.parse(s.options);
                                    s.attach_photo = options.indexOf('photo') > -1;
                                    s.attach_doc = options.indexOf('doc') > -1;
                                } else if (s.type == 'sku') {
                                    if (s.options) s.sku = JSON.parse(s.options);else s.sku = {};
                                } else if (s.type == 'string') {
                                    if (s.options) {
                                        s.options = JSON.parse(s.options);
                                        s.scanner = s.options.scanner;
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError6 = true;
                            _iteratorError6 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                    _iterator6.return();
                                }
                            } finally {
                                if (_didIteratorError6) {
                                    throw _iteratorError6;
                                }
                            }
                        }

                        var skuList = {};
                        var _iteratorNormalCompletion7 = true;
                        var _didIteratorError7 = false;
                        var _iteratorError7 = undefined;

                        try {
                            for (var _iterator7 = vm.task.SkuBonusList[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                                var sb = _step7.value;

                                skuList[sb.SkuId.toString()] = { SkuId: sb.SkuId, Active: sb.Active, Bonus: sb.Bonus };
                            }
                        } catch (err) {
                            _didIteratorError7 = true;
                            _iteratorError7 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                    _iterator7.return();
                                }
                            } finally {
                                if (_didIteratorError7) {
                                    throw _iteratorError7;
                                }
                            }
                        }

                        vm.task.skuList = skuList;

                        if ((vm.task.MemberFilterVariant === 1 || vm.task.MemberFilterVariant === 3) && vm.task.MemberFilterUsers) vm.task.MemberFilterUsers = JSON.parse(vm.task.MemberFilterUsers);
                        if (vm.task.MemberFilterVariant === 3 && vm.task.MemberFilterField) {
                            vm.task.MemberFilterField = JSON.parse(vm.task.MemberFilterField);
                            vm.changedMemberFilterRole();
                        }
                        if (vm.task.FieldTableMinRows == null) vm.task.FieldTableMinRows = 1;
                        vm.purposeFieldItemsChange();
                        vm.scoringActivationPeriodChange();

                        vm.task.TasksAttachments.forEach(function (x) {
                            switch (x.FileName.split('.').pop()) {
                                case 'jpg':
                                case 'jpeg':
                                case 'png':
                                    x.isImage = true;
                                    break;
                                default:
                                    x.TypeId = x.FileName.split('.').pop();
                                    break;
                            }
                        });
                        if (vm.task.MemberFilterVariant === 2 && vm.task.MemberFilterValue) vm.task.MemberFilterValue = JSON.parse(vm.task.MemberFilterValue);
                        //console.info('this.task.Files', vm.task.MemberFilterVariant, vm.task.MemberFilterValue);

                        //vm.loadMemberFilter(); 
                        vm.onTaskTypeChange();
                        vm.allowEdit = vm.task.QntDone === 0 || vm.info.User.MainRole === 'administrators';
                    }
                });
            }
        },
        saveTasks: function saveTasks() {
            var _this = this;

            var vm = this;

            this.$validator.validate().then(function (result) {
                if (!result) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                } else {

                    if (vm.task.new) vm.task.ProjectId = localStorage.getItem('selectedProjectId');
                    if (vm.task.StartDate > vm.task.EndDate) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Дата окончания не может быть раньше даты начала');
                        return;
                    }

                    if (vm.task.TaskType === vm.TaskTypes.Cumulative && (vm.task.PurposeType === vm.PurposeType.Summ || vm.task.ScoringAccrual === vm.ScoringAccrualTypes.SumPercent) && !vm.numberFieldExist) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Необходимо добавить хотя бы одно числовое поле');
                        return;
                    } else {
                        var qnt = 0;
                        var qnt1 = 0;

                        var _iteratorNormalCompletion8 = true;
                        var _didIteratorError8 = false;
                        var _iteratorError8 = undefined;

                        try {
                            for (var _iterator8 = vm.task.FieldSettings[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                                var s = _step8.value;

                                if (!s.deleted) {
                                    qnt++;
                                }
                                if (s.type == 'attach' && !s.attach_photo && !s.attach_doc) {
                                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Выберите тип допустимых вложений');
                                    return;
                                }
                                if (s.type == 'sku') {
                                    qnt1 = 0;
                                    if (s.sku && s.sku.Name) {
                                        for (var s1 in vm.dictSettings) {
                                            if (s.sku[s1] && s.sku[s1].attached) qnt1++;
                                        }
                                    }
                                    if (qnt1 === 0) {
                                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Настройте отображение полей SKU для "' + s.name + '"');
                                        return;
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError8 = true;
                            _iteratorError8 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                                    _iterator8.return();
                                }
                            } finally {
                                if (_didIteratorError8) {
                                    throw _iteratorError8;
                                }
                            }
                        }

                        if (vm.task.FieldSettings.length === 0 || qnt === 0) {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Необходимо добавить хотя бы одно поле');
                            return;
                        }
                    }
                    if (vm.task.ScoringAccrual === vm.ScoringAccrualTypes.DependingOnSku) {
                        var _qnt = 0;
                        var _iteratorNormalCompletion9 = true;
                        var _didIteratorError9 = false;
                        var _iteratorError9 = undefined;

                        try {
                            for (var _iterator9 = vm.task.SkuBonusList[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                                var _s2 = _step9.value;

                                if (_s2.Active && _s2.Bonus > 0) _qnt++;
                            }
                        } catch (err) {
                            _didIteratorError9 = true;
                            _iteratorError9 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion9 && _iterator9.return) {
                                    _iterator9.return();
                                }
                            } finally {
                                if (_didIteratorError9) {
                                    throw _iteratorError9;
                                }
                            }
                        }

                        if (_qnt === 0) {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Необходимо заполнить баллы');
                            return;
                        }
                    }

                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Сохранение...');

                    //let saveObj = Object.assign({}, vm.news, {
                    //    StartDate: moment(vm.news.StartDateFormatted, 'DD.MM.YYYY').format(),
                    //    EndDate: moment(vm.news.EndDateFormatted, 'DD.MM.YYYY').format(),
                    //    DeleteImage: vm.deleteImage,
                    //    ProjectId: selectedProjectId != null ? parseInt(selectedProjectId) : null,
                    //    Body: $('[name="Body"]').froalaEditor('html.get', true)
                    //});
                    //saveObj.ImageStyle = JSON.stringify(saveObj.ImageStyle);

                    var saveObj = Object.assign({}, vm.task, {});
                    saveObj.FieldSettings = vm.fieldSettingsStr;

                    saveObj.MemberFilterUsers = vm.memberFilterUsersStr;
                    saveObj.MemberFilterValue = vm.memberFilterValueStr;
                    saveObj.MemberFilterField = vm.MemberFilterFieldStr;
                    if (!saveObj.MemberFilterActivation) {
                        saveObj.MemberFilterVariant = null;
                    }
                    if (saveObj.MemberFilterVariant === null) {
                        saveObj.MemberFilterUsers = null;
                        saveObj.MemberFilterField = null;
                        saveObj.MemberFilterValue = null;
                    } else if (saveObj.MemberFilterVariant === _this.MemberFilters.Users) {
                        saveObj.MemberFilterField = null;
                        saveObj.MemberFilterValue = null;
                    } else if (saveObj.MemberFilterVariant === _this.MemberFilters.TradePoints) {
                        saveObj.MemberFilterUsers = null;
                    }
                    if (saveObj.FieldInputType === vm.FieldType.Single) {
                        saveObj.FieldTableMinRows = null;
                        saveObj.FieldTableMaxRows = null;
                    }

                    console.info('vm.task.FieldSettings', saveObj.FieldSettings);
                    //UI.unblockUI('.dataContent');
                    //return;
                    backendApi.tasksSave(saveObj).then(function (response) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                        if (response.hasError) {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении задания');
                        } else {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');
                            //vm.$router.push('/tasks/edit/' + response.data);
                            vm.$router.push('/tasks');
                        }
                    });
                }
            });
        },
        deleteTasks: function deleteTasks() {
            var vm = this;

            if (confirm('Вы уверены?')) {
                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.portlet', 'Удаление...');
                backendApi.tasksDelete(vm.task.Id).then(function (response) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.portlet');
                    if (response.hasError) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при удалении задания');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно удалено');
                        that.$router.push('/tasks');
                    }
                });
            }
        },
        loadMemberFilter: function loadMemberFilter(isSelectAll) {
            var vm = this;
            if (!vm.task.MemberFilterActivation) return;
            var typeFilter = vm.task.MemberFilterVariant;
            if (!typeFilter) {
                typeFilter = 1;
            }
            var colName = 'Name';
            var projectId = parseInt(this.$route.params.projectId);
            if (vm.task && vm.task.MemberFilterField) {
                colName = vm.task.MemberFilterField;
                //projectId = vm.task.ProjectId;
            }
            vm.loading = true;
            //console.info('loadMemberFilter', colName, projectId, vm.task)
            //if (!projectId) projectId = localStorage.getItem('selectedProjectId');
            var take = 50;
            if (isSelectAll) take = 5000;
            return vm.callApiWrapper(backendApi.tasksMemberFilter(colName, projectId, (vm.pageCheckedDown - 1) * 50, take, typeFilter, vm.task.Id)).then(function (resp) {
                if (resp.hasError) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке списка');
                } else {
                    if (resp.data.filterValue && resp.data.filterValue.length > 0) {
                        var _vm$memberFilterValue;

                        var uniqueNames = new Set(vm.memberFilterValue.map(function (item) {
                            return item.Name;
                        }));
                        var uniqueValues = resp.data.filterValue.filter(function (item) {
                            if (!uniqueNames.has(item.Name)) {
                                uniqueNames.add(item.Name);
                                return true;
                            }
                            return false;
                        });
                        (_vm$memberFilterValue = vm.memberFilterValue).push.apply(_vm$memberFilterValue, _toConsumableArray(uniqueValues));
                    } else if (resp.data.users && resp.data.users.length > 0) {
                        vm.memberFilterUsers = Object.assign(resp.data.users);
                    } else {
                        vm.canBeLoadedCheckedDown = false;
                    }
                }
                vm.loading = false;
            }).catch(function (err) {
                console.info('err', err);
            });
        },
        onRemoveAttachment: function onRemoveAttachment(i) {
            if (confirm('Удалить файл?')) {
                this.task.TasksAttachments.splice(i, 1);
                this.$refs.dropFiles2.value = '';
            }
        },
        onChangeDate: function onChangeDate(item, formatted, raw) {
            item[raw] = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(item[formatted], 'DD.MM.YYYY').format();
        },
        onFieldSettingsDrop: function onFieldSettingsDrop(dropResult) {
            var vm = this;

            if (dropResult.removedIndex === dropResult.addedIndex) {
                return;
            }

            var temp = _.orderBy(vm.task.FieldSettings, 'itemOrder');
            var itemToAdd = void 0;
            if (dropResult.removedIndex != null) {
                itemToAdd = temp.splice(dropResult.removedIndex, 1)[0];
            }
            if (dropResult.addedIndex !== null) {
                temp.splice(dropResult.addedIndex, 0, itemToAdd);
            }

            var order = 1;
            temp.forEach(function (x) {
                x.itemOrder = order++;
            });

            vm.task.FieldSettings = temp;
        },
        onFieldSettingsTypesChange: function onFieldSettingsTypesChange(settings) {
            if (settings.type == 'int' || settings.type == 'decimal') {
                this.purposeFieldItemsChange();
            }
        },
        addFieldSettings: function addFieldSettings() {
            var newOrder = 1;
            this.task.FieldSettings.forEach(function (x) {
                if (x.itemOrder != undefined && x.itemOrder >= newOrder) {
                    newOrder = x.itemOrder + 1;
                }
            });
            this.counterField--;
            this.task.FieldSettings.push({ type: 'string', deleted: false, new: true, itemOrder: newOrder, id: this.counterField });
        },
        onRemoveFieldSettings: function onRemoveFieldSettings(settings, i) {
            //settings.deleted = true;
            this.task.FieldSettings.splice(i, 1);
            this.purposeFieldItemsChange();
        },
        purposeFieldItemsChange: function purposeFieldItemsChange() {
            var vm = this;
            vm.purposeFieldItems = [];
            vm.scoringAccrualField = [];
            if (vm.task.ScoringAccrual === vm.ScoringAccrualTypes.DependingOnSku) vm.scoringAccrualField.push({ Value: null, Name: 'Не выбрано' });
            var _iteratorNormalCompletion10 = true;
            var _didIteratorError10 = false;
            var _iteratorError10 = undefined;

            try {
                for (var _iterator10 = vm.task.FieldSettings[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                    var s = _step10.value;

                    if (!s.deleted && (s.type == 'int' || s.type == 'decimal')) {
                        vm.purposeFieldItems.push({ Value: s.id, Name: s.name });
                        vm.scoringAccrualField.push({ Value: s.id, Name: s.name });
                    }
                }
                //console.info('purposeFieldItems', this.purposeFieldItems);
            } catch (err) {
                _didIteratorError10 = true;
                _iteratorError10 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion10 && _iterator10.return) {
                        _iterator10.return();
                    }
                } finally {
                    if (_didIteratorError10) {
                        throw _iteratorError10;
                    }
                }
            }

            vm.numberFieldExist = vm.purposeFieldItems.length > 0;

            vm.scoringAccrualChanged();
        },
        scoringActivationPeriodChange: function scoringActivationPeriodChange() {
            var vm = this;
            vm.scoringActivationPeriodField = [];
            if (vm.task.ScoringActivationPeriod === __WEBPACK_IMPORTED_MODULE_5__enums__["o" /* ScoringActivation */].CumulativeForPeriod) vm.scoringActivationPeriodField.push({ Value: null, Name: 'Дата ответа' });
            var _iteratorNormalCompletion11 = true;
            var _didIteratorError11 = false;
            var _iteratorError11 = undefined;

            try {
                for (var _iterator11 = vm.task.FieldSettings[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                    var s = _step11.value;

                    if (!s.deleted && s.type == 'date') {
                        vm.scoringActivationPeriodField.push({ Value: s.id, Name: s.name });
                    }
                }
            } catch (err) {
                _didIteratorError11 = true;
                _iteratorError11 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion11 && _iterator11.return) {
                        _iterator11.return();
                    }
                } finally {
                    if (_didIteratorError11) {
                        throw _iteratorError11;
                    }
                }
            }
        },
        onSettingsFieldChange: function onSettingsFieldChange(settings, i) {
            this.purposeFieldItemsChange();
        },
        onTaskTypeChange: function onTaskTypeChange() {
            this.scoringAccrualChanged();
        },
        onFixTTChange: function onFixTTChange() {
            if (!this.task.FixTT) {
                this.task.PurposeOneAnswerTT = false;
                this.task.RunInStore = false;
            }
        },
        onPurposeOneAnswerTTChange: function onPurposeOneAnswerTTChange() {
            this.task.PurposeValue = 1;
        },
        onChangePurposeTimeToComplete: function onChangePurposeTimeToComplete(item, formatted, raw) {
            var parts = item[formatted].split(':');
            var h = parseInt(parts[0]),
                m = parseInt(parts[1]),
                s = parseInt(parts[2]);
            item[raw] = h * 3600 + m * 60 + s;
        },
        scoringAccrualChanged: function scoringAccrualChanged() {
            if (this.task.TaskType === this.TaskTypes.Cumulative) this.scoringAccrualItems = [{ Value: 1, Name: 'Фиксировано' }];else this.scoringAccrualItems = [{ Value: 1, Name: 'Фиксировано' }, { Value: 2, Name: 'Процент от суммы по полю' }];
            if (this.task.FieldSettings.find(function (x) {
                return x.type === 'sku' && !x.deleted;
            })) this.scoringAccrualItems.push({ Value: 3, Name: 'В зависимости от SKU' });
        },
        onAttachFiles: function onAttachFiles(obj) {
            var files = obj.files;
            var vm = this;
            var filename = '';
            if (files && files.length) {
                var _iteratorNormalCompletion12 = true;
                var _didIteratorError12 = false;
                var _iteratorError12 = undefined;

                try {
                    for (var _iterator12 = files[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                        var file = _step12.value;

                        filename = file.name.toLowerCase();
                        if (filename.endsWith('.jpg') || filename.endsWith('.jpeg') || filename.endsWith('.png') || filename.endsWith('.docx') || filename.endsWith('.xlsx') || filename.endsWith('.pdf')) {
                            if (file.size > 50 * 1024 * 1024) {
                                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Превышен размер. Выберите другой файл');
                                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[name="dropFiles2"]').val('');
                            } else {
                                (function () {
                                    var img = { Id: 0, FileName: file.name, FileData: null, FilePath: file.name };
                                    if (filename.endsWith('.jpg') || filename.endsWith('.jpeg') || filename.endsWith('.png')) img.isImage = true;else if (filename.endsWith('.docx')) img.TypeId = 'docx';else if (filename.endsWith('.xlsx')) img.TypeId = 'xlsx';else if (filename.endsWith('.pdf')) img.TypeId = 'pdf';
                                    var reader = new FileReader();
                                    reader.onload = function (e) {
                                        img.FileData = e.target.result;

                                        vm.task.TasksAttachments.push(img);
                                    };
                                    reader.readAsDataURL(file);
                                })();
                            }
                        } else {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Не верный формат файла ' + filename + ', разрешено: .jpg,.jpeg,.png,.pdf,.docx,.xlsx');
                        }
                    }
                } catch (err) {
                    _didIteratorError12 = true;
                    _iteratorError12 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion12 && _iterator12.return) {
                            _iterator12.return();
                        }
                    } finally {
                        if (_didIteratorError12) {
                            throw _iteratorError12;
                        }
                    }
                }
            }
        },
        skuSetUpSelection: function skuSetUpSelection(settingsItem) {
            var vm = this;

            vm.currentSkuSettings = settingsItem;
            if (!vm.currentSkuSettings.sku) vm.currentSkuSettings.sku = {};
            for (var s in vm.dialogSkuSettings.sku) {
                if (vm.currentSkuSettings.sku[s]) {
                    vm.dialogSkuSettings.sku[s].search = vm.currentSkuSettings.sku[s].search;
                    vm.dialogSkuSettings.sku[s].attached = vm.currentSkuSettings.sku[s].attached;
                } else {
                    vm.dialogSkuSettings.sku[s].search = false;
                    vm.dialogSkuSettings.sku[s].attached = false;
                }
            }
            vm.dialogSkuSettings.__ob__.dep.notify();

            vm.onShowModal('ppSkuFieldSettings');
        },
        skuSetUpList: function skuSetUpList(skuList) {
            var vm = this;
            vm.titlePopap = vm.task.ScoringAccrual === vm.ScoringAccrualTypes.DependingOnSku ? 'Настройка отображения и начисления баллов за SKU' : 'Настройка отображения SKU';

            vm.currentSkuList = skuList;

            var _iteratorNormalCompletion13 = true;
            var _didIteratorError13 = false;
            var _iteratorError13 = undefined;

            try {
                for (var _iterator13 = vm.skuListForeach[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                    var _ref5 = _step13.value;

                    var _ref6 = _slicedToArray(_ref5, 2);

                    var s = _ref6[0];
                    var e = _ref6[1];

                    if (vm.currentSkuList[s]) {
                        vm.dialogSkuList[s].active = vm.currentSkuList[s].Active;
                        vm.dialogSkuList[s].bonus = vm.currentSkuList[s].Bonus;
                    }
                }
            } catch (err) {
                _didIteratorError13 = true;
                _iteratorError13 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion13 && _iterator13.return) {
                        _iterator13.return();
                    }
                } finally {
                    if (_didIteratorError13) {
                        throw _iteratorError13;
                    }
                }
            }

            vm.onShowModal('ppSkuFieldList');
        },
        updateSkuSelectionItem: function updateSkuSelectionItem() {
            var vm = this;
            for (var s in vm.dialogSkuSettings.sku) {
                if (vm.currentSkuSettings.sku[s]) {
                    vm.currentSkuSettings.sku[s].search = vm.dialogSkuSettings.sku[s].search;
                    vm.currentSkuSettings.sku[s].attached = vm.dialogSkuSettings.sku[s].attached;
                } else {
                    vm.currentSkuSettings.sku[s] = {
                        search: vm.dialogSkuSettings.sku[s].search,
                        attached: vm.dialogSkuSettings.sku[s].attached
                    };
                }
            }
            vm.currentSkuSettings.__ob__.dep.notify();

            this.$refs.ppSkuFieldSettings.close();
        },
        updateSkuListItem: function updateSkuListItem() {
            var vm = this;
            vm.task.SkuBonusList = [];
            var _iteratorNormalCompletion14 = true;
            var _didIteratorError14 = false;
            var _iteratorError14 = undefined;

            try {
                for (var _iterator14 = vm.skuListForeach[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                    var _ref7 = _step14.value;

                    var _ref8 = _slicedToArray(_ref7, 2);

                    var s = _ref8[0];
                    var e = _ref8[1];

                    if (vm.currentSkuList[s]) {
                        vm.currentSkuList[s].Active = vm.dialogSkuList[s].active;
                        vm.currentSkuList[s].Bonus = vm.dialogSkuList[s].bonus;
                        vm.task.SkuBonusList.push({ SkuId: vm.dialogSkuList[s].id, Active: vm.dialogSkuList[s].active, Bonus: vm.dialogSkuList[s].bonus });
                    } else if (vm.dialogSkuList[s].active) {
                        vm.currentSkuList[s] = {
                            SkuId: vm.dialogSkuList[s].id,
                            Active: vm.dialogSkuList[s].active,
                            Bonus: vm.dialogSkuList[s].bonus
                        };
                    }
                }
            } catch (err) {
                _didIteratorError14 = true;
                _iteratorError14 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion14 && _iterator14.return) {
                        _iterator14.return();
                    }
                } finally {
                    if (_didIteratorError14) {
                        throw _iteratorError14;
                    }
                }
            }

            this.$refs.ppSkuFieldList.close();
        },
        loadSettings: function loadSettings() {
            var vm = this;
            var projectId = parseInt(this.$route.params.projectId);
            this.callApiWrapper(backendApi.skuSettings(projectId)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки настроек sku');
                } else {
                    if (resp.data) {
                        //console.info('resp.data', resp.data)
                        vm.dictSettings = {};
                        var _iteratorNormalCompletion15 = true;
                        var _didIteratorError15 = false;
                        var _iteratorError15 = undefined;

                        try {
                            for (var _iterator15 = resp.data[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                                var s = _step15.value;

                                if (!vm.dictSettings[s.FieldName]) {
                                    vm.dictSettings[s.FieldName] = s;
                                }
                            }
                        } catch (err) {
                            _didIteratorError15 = true;
                            _iteratorError15 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion15 && _iterator15.return) {
                                    _iterator15.return();
                                }
                            } finally {
                                if (_didIteratorError15) {
                                    throw _iteratorError15;
                                }
                            }
                        }

                        var sList = {
                            sku: {}
                        };
                        for (var _s3 in vm.dictSettings) {
                            sList.sku[_s3] = { search: false, attached: false, Title: vm.dictSettings[_s3].Title, SettingsOrder: vm.dictSettings[_s3].SettingsOrder };
                        }
                        vm.dialogSkuSettings = sList;
                    }
                }
            });

            vm.loadSkuList();
        },
        loadSkuList: function loadSkuList() {
            var vm = this;
            var projectId = parseInt(this.$route.params.projectId);
            vm.loading = true;
            this.callApiWrapper(backendApi.skuShortList((this.page - 1) * 50, 50, projectId)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки настроек sku');
                } else {
                    if (resp.data && resp.data.length) {
                        var counter = Object.entries(vm.dialogSkuList).length + 1;
                        var _iteratorNormalCompletion16 = true;
                        var _didIteratorError16 = false;
                        var _iteratorError16 = undefined;

                        try {
                            for (var _iterator16 = resp.data[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
                                var s = _step16.value;

                                var newItemKey = s.Id.toString();
                                if (!vm.dialogSkuList[newItemKey]) {
                                    var newItem = { id: s.Id, name: s.Name, active: false, bonus: 0, order: counter };
                                    if (vm.task && vm.task.skuList[newItemKey]) {
                                        newItem.active = vm.task.skuList[newItemKey].Active;
                                        newItem.bonus = vm.task.skuList[newItemKey].Bonus;
                                    }
                                    vm.$set(vm.dialogSkuList, newItemKey, newItem);
                                    counter = counter + 1;
                                }
                            }
                        } catch (err) {
                            _didIteratorError16 = true;
                            _iteratorError16 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion16 && _iterator16.return) {
                                    _iterator16.return();
                                }
                            } finally {
                                if (_didIteratorError16) {
                                    throw _iteratorError16;
                                }
                            }
                        }
                    } else vm.canBeLoaded = false;
                }
                vm.loading = false;
            });
        },
        loadRoles: function loadRoles() {
            var vm = this;
            var projectId = parseInt(this.$route.params.projectId);
            vm.memberFilterField = [{ Value: 'Name', Name: 'Название' }, { Value: 'ExternalId', Name: 'Внешний ID' }, { Value: 'SkuLink', Name: 'Поле для связи' }, { Value: 'Region', Name: 'Регион' }, { Value: 'Area', Name: 'Область' }, { Value: 'City', Name: 'Город' }, { Value: 'Address', Name: 'Адрес' }];
            return this.callApiWrapper(backendApi.rolesList(projectId)).then(function (resp) {
                if (resp.data) {
                    var roles = resp.data.Roles;

                    for (var r = 0; r < roles.length; r++) {
                        if (!roles[r].Claims.find(function (x) {
                            return x.ClaimId === vm.claimEnums.ttAccess;
                        })) {
                            vm.memberFilterField.push({ Value: 'TradePointRole_' + roles[r].Id, Name: roles[r].Name });
                        }
                        if (roles[r].Claims.find(function (x) {
                            return x.ClaimId === vm.claimEnums.tasksPage;
                        })) {
                            var item = { Value: roles[r].Id, Name: roles[r].Name, LevelsInProject: [] };
                            for (var l = 0; l < roles[r].LevelsInProject.length; l++) {
                                switch (roles[r].LevelsInProject[l]) {
                                    case __WEBPACK_IMPORTED_MODULE_5__enums__["s" /* UserLevelCode */].Bronze:
                                        item.LevelsInProject.push({ Id: 1, Name: 'Бронза' });
                                        break;
                                    case __WEBPACK_IMPORTED_MODULE_5__enums__["s" /* UserLevelCode */].Silver:
                                        item.LevelsInProject.push({ Id: 2, Name: 'Серебро' });
                                        break;
                                    case __WEBPACK_IMPORTED_MODULE_5__enums__["s" /* UserLevelCode */].Gold:
                                        item.LevelsInProject.push({ Id: 3, Name: 'Золото' });
                                        break;
                                    case __WEBPACK_IMPORTED_MODULE_5__enums__["s" /* UserLevelCode */].Platina:
                                        item.LevelsInProject.push({ Id: 4, Name: 'Платина' });
                                        break;
                                    case __WEBPACK_IMPORTED_MODULE_5__enums__["s" /* UserLevelCode */].GradeB:
                                        item.LevelsInProject.push({ Id: 5, Name: 'Грейд B' });
                                        break;
                                    case __WEBPACK_IMPORTED_MODULE_5__enums__["s" /* UserLevelCode */].GradeA:
                                        item.LevelsInProject.push({ Id: 6, Name: 'Грейд A' });
                                        break;
                                    case __WEBPACK_IMPORTED_MODULE_5__enums__["s" /* UserLevelCode */].GradeS:
                                        item.LevelsInProject.push({ Id: 7, Name: 'Грейд S' });
                                        break;
                                }
                            }
                            vm.memberFilterRoles.push(item);
                        }
                    }
                }
            });
        },
        onSkuListScroll: function onSkuListScroll() {
            var vm = this;
            if (!vm.loading && vm.canBeLoaded) {
                vm.page++;
                vm.loadSkuList();
            }
        },
        onSkuListExport: function onSkuListExport() {
            var vm = this;
            var ttObject = { taskId: vm.task.Id };
            var saveObj = Object.assign({}, vm.task.skuList, {});
            console.info('onSkuListExport', vm.task.skuList, JSON.stringify(vm.task.skuList), saveObj);
            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('#app');
            this.callApiWrapper(backendApi.tasksExportSku(Object.assign({}, vm.task.skuList, {}))).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время экспорта');
                    console.info('resp', resp);
                } else {
                    var exportFile = resp.data;
                    if (exportFile != null) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].downloadFileByBytes(exportFile, "SKU Задания.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                    }
                }
                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            });
        },
        onSkuListImport: function onSkuListImport() {
            //$('#dropFiles').click();
            document.getElementById('dropFiles').click();
        },
        onTableRowsChange: function onTableRowsChange(minmax) {
            var vm = this;
            if (vm.task.FieldTableMaxRows && vm.task.FieldTableMaxRows < vm.task.FieldTableMinRows) {
                if (minmax === 'min') vm.task.FieldTableMaxRows = vm.task.FieldTableMinRows;else vm.task.FieldTableMinRows = vm.task.FieldTableMaxRows;
            }
        },
        formatTime: function formatTime(time) {
            var h = Math.floor(time / 3600);
            var m = Math.floor((time - h * 3600) / 60);
            var s = Math.floor(time - h * 3600 - m * 60);

            return (h > 9 ? h : '0' + h) + ':' + (m > 9 ? m : '0' + m) + ':' + (s > 9 ? s : '0' + s);
        },
        onFileChange: function onFileChange() {
            var vm = this;
            var files = document.getElementById('dropFiles').files;
            if (files.length > 0) {
                if (window.FormData !== undefined) {
                    var data = new FormData();
                    for (var x = 0; x < files.length; x++) {
                        data.append("file" + x, files[x]);
                    }
                    vm.importResult = null;

                    this.callApiWrapper(backendApi.tasksImportSku(data)).then(function (response) {
                        document.getElementById('dropFiles').value = '';
                        if (response.hasError) {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка импорта');
                        } else {
                            if (response.data) {
                                var counter = Object.entries(vm.dialogSkuList).length + 1;
                                var _iteratorNormalCompletion17 = true;
                                var _didIteratorError17 = false;
                                var _iteratorError17 = undefined;

                                try {
                                    for (var _iterator17 = response.data[Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
                                        var s = _step17.value;

                                        var newItemKey = s.SkuId.toString();
                                        if (!vm.dialogSkuList[newItemKey]) {
                                            vm.$set(vm.dialogSkuList, newItemKey, { id: s.SkuId, name: s.SkuName, active: s.Active, bonus: s.Bonus, order: counter });
                                            counter = counter + 1;
                                        } else {
                                            vm.dialogSkuList[newItemKey].active = s.Active;
                                            vm.dialogSkuList[newItemKey].bonus = s.Bonus;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError17 = true;
                                    _iteratorError17 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion17 && _iterator17.return) {
                                            _iterator17.return();
                                        }
                                    } finally {
                                        if (_didIteratorError17) {
                                            throw _iteratorError17;
                                        }
                                    }
                                }
                            }
                        }
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Браузер не поддерживает загрузку файлов HTML5!');
                }
            }
        },
        copyTasksSettingsModal: function copyTasksSettingsModal() {
            var vm = this;
            vm.taskCopy = {
                Id: vm.task.Id,
                Name: vm.task.Name,
                Caption: vm.task.Caption,
                StartDateFormatted: vm.task.StartDateFormatted,
                EndDateFormatted: vm.task.EndDateFormatted,
                StartDate: vm.task.StartDate,
                EndDate: vm.task.EndDate
            };
            vm.onShowModal('ppCopyTasksSettings');
        },
        copyTasks: function copyTasks() {
            var vm = this;

            Promise.all([vm.$validator.validate('CopySettingsName'), vm.$validator.validate('CopySettingsDescription'), vm.$validator.validate('CopyStartDateFormatted'), vm.$validator.validate('CopyEndDateFormatted')]).then(function (result) {
                if (!result.every(Boolean)) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                } else {
                    if (vm.taskCopy.StartDate > vm.taskCopy.EndDate) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Дата окончания не может быть раньше даты начала');
                        return;
                    }

                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Сохранение...');

                    var saveObj = Object.assign({}, vm.taskCopy, {});
                    saveObj.FieldSettings = vm.fieldSettingsStr;

                    saveObj.MemberFilterUsers = vm.memberFilterUsersStr;
                    saveObj.MemberFilterValue = vm.memberFilterValueStr;
                    if (!saveObj.MemberFilterActivation) {
                        saveObj.MemberFilterVariant = null;
                    }

                    backendApi.tasksCopy(saveObj).then(function (response) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                        if (response.hasError) {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при дублировании задания');
                        } else {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');
                            vm.$refs.ppCopyTasksSettings.close();
                            console.info('copyTasks', response, vm.task.ProjectId);
                            vm.$router.push('/tasks/edit/' + vm.task.ProjectId + '/' + response.data);
                        }
                    });
                }
            });
        },
        changedFilterActivation: function changedFilterActivation() {
            this.changedFilterField();
        },
        changedFilterVariant: function changedFilterVariant() {
            var vm = this;
            if (vm.task) {
                switch (vm.task.MemberFilterVariant) {
                    case vm.MemberFilters.Users:
                    case vm.MemberFilters.TradePoints:
                        vm.task.MemberFilterField = null;
                        break;
                    case vm.MemberFilters.Roles:
                        vm.task.MemberFilterField = { Roles: [], Grades: [] };
                        break;
                }
            }
            this.changedFilterField();
        },
        onCheckedDownScroll: function onCheckedDownScroll(isSelectAll) {
            var vm = this;
            if (!vm.loading && vm.canBeLoadedCheckedDown) {
                vm.pageCheckedDown++;
                vm.loadMemberFilter(isSelectAll);
            }
        },
        changedFilterField: function changedFilterField() {
            this.memberFilterValue = [];
            this.pageCheckedDown = 1;
            this.canBeLoadedCheckedDown = true;
            this.loadMemberFilter(false);
        },
        changedMemberFilterRole: function changedMemberFilterRole() {
            var vm = this;
            vm.memberFilterGrades = [];
            var roles = vm.task.MemberFilterField.Roles.filter(function (x) {
                return x.LevelsInProject.length > 0;
            });
            vm.useGradeOnSelectedRoles = roles.length > 0;
            if (roles.length > 0) {
                for (var r = 0; r < roles.length; r++) {
                    for (var l = 0; l < roles[r].LevelsInProject.length; l++) {
                        vm.memberFilterGrades.push({
                            Value: roles[r].Value.toString() + '+' + roles[r].LevelsInProject[l].Id,
                            Name: roles[r].Name + '-' + roles[r].LevelsInProject[l].Name,
                            LevelId: roles[r].LevelsInProject[l].Id
                        });
                    }
                }
            }
            vm.changedFilterToRoleUsers = true;
        },
        changedMemberFilterGrade: function changedMemberFilterGrade() {
            this.changedFilterToRoleUsers = true;
        },
        memberFilterUsersLoad: function memberFilterUsersLoad(searchText, callback, page, selectAll) {
            var vm = this;
            if (vm.changedFilterToRoleUsers || page > 1) {
                var roleValues = JSON.stringify(_.map(vm.task.MemberFilterField.Roles, 'Value'));
                var gradeValues = JSON.stringify(_.map(vm.task.MemberFilterField.Grades, 'Value'));
                var rowsPerPage = 20;
                var take = rowsPerPage;
                if (selectAll) take = 5000;
                vm.changedFilterToRoleUsers = false;
                //console.info('memberFilterUsersLoad', (page - 1) * rowsPerPage, take, searchText, roleValues, gradeValues);
                vm.callApiWrapper(backendApi.tasksUsersOnRoles((page - 1) * rowsPerPage, take, vm.task.Id, searchText, roleValues, gradeValues)).then(function (resp) {
                    callback(resp.data);
                });
            } else {
                callback(null);
            }
        }
    },

    mounted: function mounted() {
        var _this2 = this;

        var vm = this;

        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');

        Promise.all([this.loadSettings(), this.loadRoles()]).then(function () {
            _this2.loadTask().then(function () {
                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');

                vm.loadMemberFilter(false);

                vm.imgmixin_lightzoomInit();
            });
            //UI.unblockUI('.dataContent');

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('change', '[name="dropFiles2"]', function () {
                vm.onAttachFiles({ files: this.files });
            });
        });

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click', '.block-in-page-collapce', function () {
            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].block_collapse(this);
        });
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('change', '[name="dropFiles2"]');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('click', '.block-in-page-collapce');
    }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_smooth_dnd__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_img_mixin__ = __webpack_require__(90);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//let $ = require('jquery');









window.$ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;
window.jQuery = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;

var backendApi = new __WEBPACK_IMPORTED_MODULE_1__backendApi__["a" /* default */]();
var DateTypes = {
    /* Дата заполнения */
    FillingDate: 1,
    /* Дата отчета */
    ReportDate: 2,
    /* Дата изменения статуса */
    StatusDate: 3
};
var cacheKey = 'answersFilter';
//let statusRejected = 5;
var projectIdEinhell = '29';

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "tasks-edit",

    props: ['info'],

    mixins: [__WEBPACK_IMPORTED_MODULE_6__helpers_img_mixin__["a" /* default */]],

    components: { Container: __WEBPACK_IMPORTED_MODULE_4_vue_smooth_dnd__["a" /* Container */], Draggable: __WEBPACK_IMPORTED_MODULE_4_vue_smooth_dnd__["b" /* Draggable */] },

    data: function data() {
        return {
            task: null,
            detail: {},
            taskId: null,
            projectId: null,
            bonus: { QntDone: 0 },
            file: null,
            answers: [],
            chartOptions: [],
            statusId: 0,
            dateTypeId: DateTypes.FillingDate,
            dateStart: null,
            dateEnd: null,
            statuses: [{ Id: 0, Name: 'Все ответы' }, { Id: 1, Name: 'Ждут проверки' }, { Id: 2, Name: 'Проверенные' }, { Id: 3, Name: 'Доработанные' }, { Id: 4, Name: 'На доработке' }, { Id: 5, Name: 'Отклоненные' }],
            dateTypes: [{ Id: DateTypes.FillingDate, Name: ' Дата заполнения' }, { Id: DateTypes.ReportDate, Name: 'Дата изменения ответа' }, { Id: DateTypes.StatusDate, Name: 'Дата изменения статуса' }],
            page: 1,
            canBeLoaded: true,
            loading: false,
            scrollTop: null,
            filter: null,
            userFilters: [{ Value: 'LastName', Name: 'Фамилия' }, { Value: 'FirstName', Name: 'Имя' }, { Value: 'MiddleName', Name: 'Отчество' }],
            allowAdd: true,
            canBeShowFIO: false,
            TaskTypes: __WEBPACK_IMPORTED_MODULE_5__enums__["r" /* TaskTypes */],
            PurposeType: __WEBPACK_IMPORTED_MODULE_5__enums__["h" /* PurposeType */],
            ScoringAccrualTypes: __WEBPACK_IMPORTED_MODULE_5__enums__["n" /* ScoringAccrualTypes */],
            isMobile: __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].check_mobile(),
            confirmOperation: '',
            tradePointSelected: {},
            selectAll: false,
            selectedAnswers: [],
            actionState: {
                currentAnswer: {
                    index: 0,
                    date: null,
                    time: 0
                },
                total: 0,
                messages: [],
                done: false
            },
            popuptitle: 'Причина отправки на доработку',
            commentStatus: '',
            selectStatus: 0
        };
    },


    computed: {
        taskAttachmentsImage: function taskAttachmentsImage() {
            return this.task.TasksAttachments.filter(function (x) {
                return x.isImage;
            });
        },

        taskAttachmentsNoImage: function taskAttachmentsNoImage() {
            return this.task.TasksAttachments.filter(function (x) {
                return !x.isImage;
            });
        },

        skuBonusList: function skuBonusList() {
            if (this.task) return this.task.SkuBonusList.filter(function (x) {
                return x.Active && x.Bonus > 0;
            });else return {};
        },

        confirmText: function confirmText() {
            if (this.confirmOperation === 'setResponsible') {
                return 'Данное задание необходимо выполнить одному сотруднику в рамках торговой точки. На выполнение задания отведено ' + this.formatTime(this.task.PurposeTimeToComplete) + ' часов. В случае невыполнения задания в указанный срок, повторно выполнить задание Вы можете не ранее чем через ' + this.formatTime(this.task.PurposeAllowAfterComplete) + ' часов с момента невыполнения. Нажимая подтвердить, Вы будете назначены на задание.';
            } else if (this.confirmOperation === 'setRefuse') {
                return 'В случае если Вы отказываетесь от выполнения задания, то повторно приступить к нему Вы сможете не ранее чем через ' + this.formatTime(this.task.PurposeAllowAfterComplete) + ' часов. Вы точно хотите отказаться от выполнения задания?';
            }
        },
        pageInfoMessage: function pageInfoMessage() {
            if (this.task.DenyExecutionOnSite) return 'Выполнение задания на сайте запрещено. Пожалуйста, добавьте ответ через мобильное приложение.';else if (this.task.PurposeOneAnswerTT && this.detail.AllowResponsibleAdd && !this.detail.ResponsibleBlock) return 'Задание доступно до ' + this.detail.DateEndStr;else return '';
        },
        exportEnabled: function exportEnabled() {
            //console.info('exportEnabled', this.info, this.projectId, projectIdEinhell)
            if (this.info && this.projectId == projectIdEinhell) return this.info.User.MainRole === 'administrators' || this.info.User.DynamicRole && (this.info.User.DynamicRole.Name === 'Клиент' || this.info.User.DynamicRole.Name === 'Аналитик');else return null;
        }
    },

    methods: {
        back: function back() {
            //this.$router.back();
            this.$router.push('/tasks');
        },
        getStateClass: function getStateClass(item) {
            return 'task-state-' + item.LastStatus;
        },
        onChangeDate: function onChangeDate(item, formatted, raw) {
            item[raw] = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(item[formatted], 'DD.MM.YYYY').format();
        },
        addAnswer: function addAnswer() {
            var _this = this;

            var vm = this;
            var id = parseInt(this.$route.params.id);
            if (vm.task.DenyExecutionOnSite) {
                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Выполнение задания на сайте запрещено. Пожалуйста, добавьте ответ через мобильное приложение.');
            } else if (vm.task.PurposeOneAnswerTT) {
                vm.onChangeTPSearch({ Name: vm.detail.SelectedTradePoint.Name, Id: vm.detail.SelectedTradePoint.Id }, null, null).then(function () {
                    if (vm.detail.ResponsibleBlock) {
                        if (vm.detail.BalanceToUnlock > 0) __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Время на выполнение задания истекло. Повторно взять задание в работу Вы можете не ранее чем через ' + vm.formatTime(vm.detail.BalanceToUnlock) + ' часов.');
                    } else {
                        _this.$router.push('/tasks/answer/' + id + '/0/add?tpid=' + vm.detail.SelectedTradePoint.Id);
                    }
                });
            } else {
                this.$router.push('/tasks/answer/' + id + '/0/add?tpid=' + vm.detail.SelectedTradePoint.Id);
            }
        },
        editAnswer: function editAnswer(answerId, status) {
            var vm = this;
            var id = parseInt(this.$route.params.id);
            //console.info('editAnswer', vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.bonusSpend), vm.info.User);
            if (vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.bonusSpend)) {
                if (status == 4) this.$router.push('/tasks/answer/' + id + '/' + answerId + '/edit');else this.$router.push('/tasks/answer/' + id + '/' + answerId + '/view');
            } else if (!vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.tasksController) && !vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.tasksEdit)) this.$router.push('/tasks/answer/' + id + '/' + answerId + '/view');else this.$router.push('/tasks/answer/' + id + '/' + answerId + '/checking');
        },
        confirmShow: function confirmShow(operation) {
            var _this2 = this;

            this.confirmOperation = operation;
            if (operation === 'setResponsible') {
                this.$validator.validate().then(function (result) {
                    if (!result) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Необходимо выбрать торговую точку');
                    } else {
                        _this2.onShowModal('ppConfirm');
                    }
                });
            } else {
                this.onShowModal('ppConfirm');
            }
        },
        confirmOk: function confirmOk() {
            var vm = this;
            if (vm.confirmOperation === 'setResponsible') {
                vm.setResponsible();
            } else if (vm.confirmOperation === 'setRefuse') {
                vm.setRefuse();
            }
        },
        setResponsible: function setResponsible() {
            var vm = this;
            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Назначение ответственным...' + vm.confirmOperation);
            backendApi.tasksResponsible(vm.task.Id, vm.confirmOperation, vm.detail.SelectedTradePoint.Id).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при назначении ответственным');
                } else {
                    vm.detail.ResponsibleBlock = response.data.ResponsibleBlock;
                    vm.detail.BalanceToUnlock = response.data.BalanceToUnlock;
                    vm.detail.ResponsibleId = response.data.ResponsibleId;
                    vm.detail.AllowResponsibleAdd = response.data.AllowResponsibleAdd;
                    vm.detail.AnswerBtnAddText = response.data.AnswerBtnAddText;
                    if (response.data.DateEnd) {
                        vm.detail.DateEndStr = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(response.data.DateEnd).format('DD-MM-YYYY HH:mm');
                    }

                    if (vm.detail.ResponsibleBlock) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Задание уже находится в работе у одного из сотрудников торговой точки.');
                    } else if (!vm.detail.ResponsibleId) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Вы успешно назначены ответственным на задание');
                        vm.detail.ResponsibleId = vm.info.User.Id;
                    }
                }
                vm.closeModal('ppConfirm');
            });
        },
        setRefuse: function setRefuse() {
            var vm = this;
            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Отказ от ответственности...' + vm.confirmOperation);
            backendApi.tasksResponsibleRefuse(vm.task.Id, vm.detail.SelectedTradePoint.Id).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при отказе от ответственности');
                } else {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Вы отказались от ответственности на задание');
                    vm.detail.ResponsibleBlock = true;
                }
                vm.closeModal('ppConfirm');
            });
        },
        moreSKU: function moreSKU() {
            this.onShowModal('ppSkuList');
        },
        onStatusChange: function onStatusChange() {
            this.reload();
            this.saveFilterState();
        },
        onDateChange: function onDateChange() {
            this.reload();
            this.saveFilterState();
        },
        searchFunction: function searchFunction(tableName, columnName, search, filters, searchPage, callback) {
            var filterFormatted = '';
            if (filters) {
                filterFormatted = this.CommonMixin_UsersProcessFilter(filters).map(function (x) {
                    return JSON.stringify(x);
                });
            }
            //console.info(filters, filterFormatted);
            this.callApiWrapper(backendApi.tasksDistinctValues(columnName, this.projectId, this.taskId, search, filterFormatted, (searchPage - 1) * 30, 30)).then(function (resp) {
                callback(resp.data);
            });
        },
        reload: function reload() {
            this.page = 1;
            this.answers = [];
            this.loading = false;
            this.canBeLoaded = true;
            this.selectedAnswers = [];
            this.loadAnswers();
        },
        loadTask: function loadTask() {
            var vm = this;
            vm.taskId = parseInt(this.$route.params.id);
            vm.projectId = localStorage.getItem('selectedProjectId');
            vm.canBeShowFIO = vm.info.User.MainRole === 'administrators' || vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.tasksController) || vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.tasksEdit) || !vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.bonusSpend);
            return backendApi.tasksLoad(vm.taskId, true).then(function (response) {
                //console.info('project.edit -> load, response:', response.data);
                if (response.hasError) {
                    if (response.status === 403) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Запрещено');
                        vm.$router.back();
                    } else __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке задания');
                } else {
                    if (response.data == null) {
                        vm.$router.back();
                    }

                    vm.task = Object.assign(response.data.task);
                    vm.task.CaptionFormatted = vm.task.Caption ? vm.task.Caption.replace(/\n/g, '<br>') : null;
                    vm.task.StartDateFormatted = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(vm.task.StartDate).format('DD.MM.YYYY'); //.format('LL');
                    if (vm.task.EndDate) {
                        vm.task.EndDateFormatted = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(vm.task.EndDate).format('DD.MM.YYYY');
                    }
                    if (vm.task.ScoringBurningDate) {
                        vm.task.ScoringBurningDateFormatted = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(vm.task.ScoringBurningDate).format('DD.MM.YYYY');
                    }
                    vm.task.TasksAttachments.forEach(function (x) {
                        x.Extension = x.FileName.toLowerCase().split('.').pop();
                    });

                    if (response.data.detail) {
                        var responsibleBlock = vm.detail.ResponsibleBlock;
                        vm.detail = Object.assign(response.data.detail);
                        if (responsibleBlock) {
                            vm.detail.ResponsibleBlock = responsibleBlock;
                        }
                        if (vm.detail.DateEnd) {
                            vm.detail.DateEndStr = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(vm.detail.DateEnd).format('DD-MM-YYYY HH:mm');
                        }
                        if (vm.task.DenyExecutionOnSite) {
                            vm.detail.ResponsibleBlock = true;
                        }
                    }
                    if (vm.task.EndDate < vm.task.Now || vm.task.StartDate > vm.task.Now) {
                        vm.allowAdd = false;
                    } else if (vm.allowAdd) {
                        vm.allowAdd = vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.bonusSpend); // && !vm.detail.ResponsibleBlock;
                    }
                    //console.info('this.task.Files', vm.allowAdd && vm.task.PurposeOneAnswerTT, vm.detail.ResponsibleId, vm.info.User.Id);
                }
            });
        },
        loadAnswers: function loadAnswers() {
            var vm = this;
            var timeZone = new Date().getTimezoneOffset();
            var dateStart = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(vm.dateStart, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
            var dateEnd = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(vm.dateEnd, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
            this.loading = true;
            var projectId = localStorage.getItem('selectedProjectId');
            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
            this.callApiWrapper(backendApi.tasksAnswers((this.page - 1) * 20, 20, projectId, vm.taskId, vm.statusId, vm.dateTypeId, dateStart, dateEnd, vm.CommonMixin_UsersProcessFilter(vm.filter))).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки ответов');
                } else {
                    if (resp.data.list && resp.data.list.length) {
                        var _vm$answers;

                        (_vm$answers = vm.answers).push.apply(_vm$answers, _toConsumableArray(resp.data.list));
                        //console.info('vm.answers', vm.answers.lengthm, vm.isMobile);
                    } else {
                        vm.canBeLoaded = false;
                    }
                }
                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                vm.loading = false;
            });
        },
        loadBonus: function loadBonus() {
            var vm = this;
            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
            this.callApiWrapper(backendApi.tasksBonus(vm.taskId)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки бонусов');
                } else {
                    vm.bonus = Object.assign(resp.data.bonus);
                    if (vm.bonus.PurposeValue === 0) {
                        vm.detail.ResponsibleBlock = true;
                    }
                }
                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
            });
        },
        clearFilterState: function clearFilterState() {
            this.dateStart = '';
            this.dateEnd = '';
            this.statusId = '';
            this.dateTypeId = DateTypes.FillingDate;

            localStorage.removeItem(cacheKey);
            this.reload();
        },
        saveFilterState: function saveFilterState() {
            //console.info('this.statusId:', this.statusId);

            var stateObj = {
                statusId: this.statusId,
                dateTypeId: this.dateTypeId,
                dateStart: this.dateStart,
                dateEnd: this.dateEnd,
                page: this.page,
                scrollTop: this.scrollTop
            };
            localStorage.setItem(cacheKey, JSON.stringify(stateObj));
        },
        recoverFilterState: function recoverFilterState() {
            var stateObj = JSON.parse(localStorage.getItem(cacheKey));
            //console.info('recoverFilterState -> stateObj:', stateObj);
            if (stateObj) {
                if (stateObj.statusId != null) {
                    this.statusId = stateObj.statusId;
                }
                if (stateObj.dateTypeId) {
                    this.dateTypeId = stateObj.dateTypeId;
                }
                if (stateObj.dateStart) {
                    this.dateStart = stateObj.dateStart;
                }
                if (stateObj.dateEnd) {
                    this.dateEnd = stateObj.dateEnd;
                }
                if (stateObj.page) {
                    this.page = stateObj.page;
                }
                if (stateObj.scrollTop) {
                    this.scrollTop = stateObj.scrollTop;
                }
            }
        },
        onScroll: function onScroll(e) {
            var vm = this;
            if (!vm.loading && vm.canBeLoaded) {
                var elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target);
                vm.scrollTop = elem.scrollTop();
                if (elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight() + 100) {
                    vm.page++;
                    vm.loadAnswers();
                }
            }
        },
        onFilterChange: function onFilterChange(filter) {
            this.filter = filter;
            this.answers = [];
            this.loading = false;
            this.canBeLoaded = true;
            this.page = 1;

            this.loadAnswers();
        },


        // https://momentjs.com/docs/#/displaying/format/
        formatTime: function formatTime(seconds) {
            var h = Math.floor(seconds / 3600);
            var m = Math.floor((seconds - h * 3600) / 60);
            var s = Math.floor(seconds - h * 3600 - m * 60);

            return (h > 9 ? h : '0' + h) + ':' + (m > 9 ? m : '0' + m) + ':' + (s > 9 ? s : '0' + s);

            //if (seconds > 86400)
            //    return moment().startOf('day').startOf('year').add(-1, 'day').seconds(seconds).format('DDD HH:mm:ss');
            //else
            //    return moment().startOf('day').seconds(seconds).format('HH:mm:ss');
        },
        getTPSelectedItem: function getTPSelectedItem() {
            return {
                Id: this.detail.SelectedTradePoint.Id,
                Name: this.detail.SelectedTradePoint.Name
            };
        },
        searchTPFunction: function searchTPFunction(searchText, callback, extra, page) {
            var vm = this;
            //console.info('searchTPFunction', searchText, page, extra);
            vm.callApiWrapper(backendApi.tradePointSearch((page - 1) * 20, 20, vm.projectId, searchText)).then(function (resp) {
                callback(resp.data);
            });
        },
        onChangeTPSearch: function onChangeTPSearch(listItem, extra, skuLink) {
            if (listItem) {
                var vm = this;
                vm.detail.SelectedTradePoint.Id = listItem.Id;
                vm.detail.SelectedTradePoint.Name = listItem.Name;

                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
                return this.callApiWrapper(backendApi.taskCheckResponsible(vm.taskId, listItem.Id)).then(function (resp) {
                    if (!resp.hasError) {
                        vm.detail.ResponsibleBlock = resp.data.ResponsibleBlock;
                        vm.detail.BalanceToUnlock = resp.data.BalanceToUnlock;
                        vm.detail.ResponsibleId = resp.data.ResponsibleId;
                        vm.detail.AllowResponsibleAdd = resp.data.AllowResponsibleAdd;
                        vm.detail.AnswerBtnAddText = resp.data.AnswerBtnAddText;
                        if (resp.data.DateEnd) {
                            vm.detail.DateEndStr = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(resp.data.DateEnd).format('DD-MM-YYYY HH:mm');
                        }

                        if (!vm.detail.ResponsibleBlock && (vm.task.DenyExecutionOnSite || vm.bonus.TradePointsIds.filter(function (x) {
                            return x === listItem.Id;
                        }).length === 0)) {
                            vm.detail.ResponsibleBlock = true;
                        }
                    }
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                });
            } else {
                return new Promise(function (resolve) {
                    return resolve();
                });
            }
        },
        onDetailExport: function onDetailExport() {
            var vm = this;

            var timeZone = new Date().getTimezoneOffset();
            var dateStart = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(vm.dateStart, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
            var dateEnd = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(vm.dateEnd, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();

            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Выгрузка...');
            this.callApiWrapper(backendApi.tasksDetailExport(vm.task.Id, vm.statusId, vm.dateTypeId, dateStart, dateEnd, vm.CommonMixin_UsersProcessFilter(vm.filter))).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время экспорта');
                    console.info('resp', resp);
                } else {
                    var exportFile = resp.data;
                    if (exportFile != null) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].downloadFileByBytes(resp.data, "Выгрузка по ответам.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                    }
                }
                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
            });
        },
        onSelectAllChange: function onSelectAllChange(e) {
            var vm = this;

            vm.selectedAnswers = [];
            if (vm.selectAll) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = vm.answers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var answer = _step.value;

                        vm.selectedAnswers.push(answer);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        onCheckChange: function onCheckChange(item) {
            var vm = this;
            if (vm.selectedAnswers.filter(function (x) {
                return x == item;
            }).length === 0) {
                vm.selectAll = false;
            } else if (vm.selectedAnswers.length === vm.answers.length) {
                vm.selectAll = true;
            }
        },
        selectedCancel: function selectedCancel() {
            this.selectAll = false;
            this.selectedAnswers = [];
        },
        ppActionModalClose: function ppActionModalClose() {
            this.closeModal('ppActionModal');
            this.reload();
        },
        btnReject: function btnReject(state) {
            var vm = this;
            vm.selectStatus = state;
            vm.commentStatus = '';

            if (state === 4) vm.popuptitle = 'Причина отправки на доработку';else vm.popuptitle = 'Причина отклонения';
            vm.$refs['ppComment'].show();
        },
        removeAnswers: function removeAnswers() {
            var vm = this;
            vm.showConfirmDeleteModal();
        },
        showConfirmDeleteModal: function showConfirmDeleteModal() {
            this.$refs.ppConfirmDelete.show();
        },
        confirmDeleteAnswers: function confirmDeleteAnswers() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var vm;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                vm = _this3;
                                _context.next = 3;
                                return vm.updateMultipleAnswerStatuses(__WEBPACK_IMPORTED_MODULE_5__enums__["q" /* TaskAnswerStates */].Remove, '');

                            case 3:
                                vm.closeModal('ppConfirmDelete');

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this3);
            }))();
        },
        cancelDelete: function cancelDelete() {
            this.$refs.ppConfirmDelete.hide();
        },
        tryChangeStatus: function tryChangeStatus() {
            var vm = this;
            vm.closeModal('ppComment');
            this.updateMultipleAnswerStatuses(vm.selectStatus, vm.commentStatus);
        },
        getAnswerWord: function getAnswerWord(count) {
            if (count % 10 === 1 && count % 100 !== 11) {
                return 'ответ';
            } else if ([2, 3, 4].includes(count % 10) && ![12, 13, 14].includes(count % 100)) {
                return 'ответа';
            } else {
                return 'ответов';
            }
        },
        updateMultipleAnswerStatuses: function updateMultipleAnswerStatuses(status, comment) {
            var vm = this;
            if (vm.selectedAnswers.length === 0) return;

            var statusLabel = void 0;
            switch (status) {
                case __WEBPACK_IMPORTED_MODULE_5__enums__["q" /* TaskAnswerStates */].Accepted:
                    statusLabel = "Принято";
                    break;
                case __WEBPACK_IMPORTED_MODULE_5__enums__["q" /* TaskAnswerStates */].OnEdition:
                    statusLabel = "Отправлено на доработку";
                    break;
                case __WEBPACK_IMPORTED_MODULE_5__enums__["q" /* TaskAnswerStates */].Rejected:
                    statusLabel = "Отклонено";
                    break;
                case __WEBPACK_IMPORTED_MODULE_5__enums__["q" /* TaskAnswerStates */].Remove:
                    statusLabel = "Удалено";
                    break;
                default:
                    statusLabel = "Неизвестный статус";
                    break;
            }

            var selectedAnswers = this.selectedAnswers.map(function (x) {
                return {
                    Id: x.Id,
                    TaskId: x.TaskId,
                    Status: status,
                    EditionComment: comment,
                    Date: x.DateStatus
                };
            });

            vm.actionState = {
                currentAnswer: {
                    index: 0,
                    date: null,
                    time: 0
                },
                total: 0,
                messages: [],
                done: false
            };

            vm.$refs.ppActionModal.show();

            (function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                    var secondsInterval, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, answer;

                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('dataContent', 'Обработка');

                                    secondsInterval = void 0;

                                    vm.actionState.total = selectedAnswers.length;
                                    _iteratorNormalCompletion2 = true;
                                    _didIteratorError2 = false;
                                    _iteratorError2 = undefined;
                                    _context2.prev = 6;
                                    _iterator2 = selectedAnswers[Symbol.iterator]();

                                case 8:
                                    if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                                        _context2.next = 20;
                                        break;
                                    }

                                    answer = _step2.value;

                                    console.log(vm.actionState.currentAnswer.index);
                                    vm.actionState.currentAnswer.index++;
                                    vm.actionState.currentAnswer.time = 0;
                                    vm.actionState.currentAnswer.date = answer.Date;

                                    secondsInterval = setInterval(function () {
                                        vm.actionState.currentAnswer.time += 1;
                                    }, 1000);
                                    _context2.next = 17;
                                    return vm.callApiWrapper(backendApi.tasksAnswerAccept(answer.TaskId, answer.Id, answer.Status, answer.EditionComment)).then(function (response) {
                                        clearInterval(secondsInterval);

                                        var answerTitle = '\u041E\u0442\u0432\u0435\u0442 ' + vm.actionState.currentAnswer.index + ' \u043E\u0442 ' + vm.formatDate(vm.actionState.currentAnswer.date, 'DD.MM.YYYY HH:mm');

                                        if (response.hasError) {
                                            switch (response.status) {
                                                case 722:
                                                    vm.actionState.messages.push({
                                                        message: answerTitle + ': \u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043D\u0430 \u0434\u043E\u0440\u0430\u0431\u043E\u0442\u043A\u0443 \u043C\u043E\u0436\u043D\u043E \u0442\u043E\u043B\u044C\u043A\u043E \u0442\u043E\u0442 \u043E\u0442\u0432\u0435\u0442, \u043F\u043E \u043A\u043E\u0442\u043E\u0440\u043E\u043C\u0443 \u0431\u043E\u043D\u0443\u0441\u044B \u043D\u0435 \u0431\u044B\u043B\u0438 \u0438\u0441\u0442\u0440\u0430\u0447\u0435\u043D\u044B',
                                                        error: true
                                                    });
                                                    break;
                                                case 723:
                                                    vm.actionState.messages.push({
                                                        message: answerTitle + ': \u041E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C \u043C\u043E\u0436\u043D\u043E \u0442\u043E\u043B\u044C\u043A\u043E \u0442\u043E\u0442 \u043E\u0442\u0432\u0435\u0442, \u043F\u043E \u043A\u043E\u0442\u043E\u0440\u043E\u043C\u0443 \u0431\u043E\u043D\u0443\u0441\u044B \u043D\u0435 \u0431\u044B\u043B\u0438 \u0438\u0441\u0442\u0440\u0430\u0447\u0435\u043D\u044B',
                                                        error: true
                                                    });
                                                    break;
                                                case 724:
                                                    vm.actionState.messages.push({
                                                        message: answerTitle + ': \u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043C\u043E\u0436\u043D\u043E \u0442\u043E\u043B\u044C\u043A\u043E \u0442\u043E\u0442 \u043E\u0442\u0432\u0435\u0442, \u043F\u043E \u043A\u043E\u0442\u043E\u0440\u043E\u043C\u0443 \u0431\u043E\u043D\u0443\u0441\u044B \u043D\u0435 \u0431\u044B\u043B\u0438 \u0438\u0441\u0442\u0440\u0430\u0447\u0435\u043D\u044B',
                                                        error: true
                                                    });
                                                    break;
                                                default:
                                                    vm.actionState.messages.push({
                                                        message: answerTitle + ': \u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0438',
                                                        error: true
                                                    });
                                                    break;
                                            }
                                        } else {
                                            vm.actionState.messages.push({ message: answerTitle + ': ' + statusLabel });
                                        }
                                        if (vm.actionState.currentAnswer.index === vm.actionState.total) {
                                            vm.actionState.done = true;
                                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('dataContent');
                                        }
                                    });

                                case 17:
                                    _iteratorNormalCompletion2 = true;
                                    _context2.next = 8;
                                    break;

                                case 20:
                                    _context2.next = 26;
                                    break;

                                case 22:
                                    _context2.prev = 22;
                                    _context2.t0 = _context2['catch'](6);
                                    _didIteratorError2 = true;
                                    _iteratorError2 = _context2.t0;

                                case 26:
                                    _context2.prev = 26;
                                    _context2.prev = 27;

                                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                        _iterator2.return();
                                    }

                                case 29:
                                    _context2.prev = 29;

                                    if (!_didIteratorError2) {
                                        _context2.next = 32;
                                        break;
                                    }

                                    throw _iteratorError2;

                                case 32:
                                    return _context2.finish(29);

                                case 33:
                                    return _context2.finish(26);

                                case 34:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, this, [[6, 22, 26, 34], [27,, 29, 33]]);
                }));

                function loop() {
                    return _ref.apply(this, arguments);
                }

                return loop;
            })()();
        }
    },

    mounted: function mounted() {
        var vm = this;

        vm.recoverFilterState();

        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');

        Promise.all([this.loadTask(), this.loadAnswers(), this.loadBonus()]).then(function () {
            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
            vm.imgmixin_lightzoomInit();
        });
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('change', '[name="dropFiles"]');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('click', '.block-in-page-collapce');
    }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_smooth_dnd__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ReportItemsTable__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_img_mixin__ = __webpack_require__(90);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//let $ = require('jquery');










var backendApi = new __WEBPACK_IMPORTED_MODULE_1__backendApi__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "tasks-edit",

    props: ['info'],

    mixins: [__WEBPACK_IMPORTED_MODULE_7__helpers_img_mixin__["a" /* default */]],

    components: { Draggable: __WEBPACK_IMPORTED_MODULE_4_vue_smooth_dnd__["b" /* Draggable */], ReportItemsTable: __WEBPACK_IMPORTED_MODULE_6__components_ReportItemsTable__["a" /* default */] },

    data: function data() {
        return {
            task: null,
            taskId: 0,
            answerId: 0,
            fixTT: false,
            commentStatus: '',
            selectStatus: 0,
            popuptitle: 'Причина отправки на доработку',
            titleName: 'Ответ',
            fieldSettingsBool: [{ Id: 1, Name: 'Да' }, { Id: 0, Name: 'Нет' }],
            fieldSettingsSelect: [],
            allowEdit: false,
            currentAnswer: {},
            isController: false,
            fieldTable: null,
            bonusSettings: null,
            FieldType: __WEBPACK_IMPORTED_MODULE_5__enums__["d" /* FieldTypes */],
            TaskTypes: __WEBPACK_IMPORTED_MODULE_5__enums__["r" /* TaskTypes */],
            existsAttach: false,
            skuValueItem: 0,

            ttSearch: null,
            ttAllowed: true,
            ttData: [],
            ttPage: 1,
            ttIsLoading: false,
            ttCanBeLoaded: true,
            ttSearched: false,
            FieldSettings: []
        };
    },


    computed: {
        TaskAnswerStates: function TaskAnswerStates() {
            return __WEBPACK_IMPORTED_MODULE_5__enums__["q" /* TaskAnswerStates */];
        },

        fieldSettingsOrdered: function fieldSettingsOrdered() {
            return _.orderBy(this.FieldSettings, 'itemOrder');
        },

        taskAttachmentsImage: function taskAttachmentsImage() {
            return this.task.TasksAttachments.filter(function (x) {
                return x.isImage;
            });
        },

        taskAttachmentsNoImage: function taskAttachmentsNoImage() {
            return this.task.TasksAttachments.filter(function (x) {
                return !x.isImage;
            });
        },

        tradePointSelected: function tradePointSelected() {
            return this.answerId > 0 || !this.task.FixTT || this.currentAnswer.TradePoint && this.currentAnswer.TradePoint.Id && this.currentAnswer.TradePoint.Error == null;
        },
        stateFormatted: function stateFormatted() {
            var state = '';
            switch (this.currentAnswer.LastStatus) {
                case 1:
                    state = 'Ждет проверки';break;
                case 2:
                    state = 'Проверено';break;
                case 3:
                    state = 'Доработано';break;
                case 4:
                    state = 'На доработке';break;
                case 5:
                    state = 'Отклонено';break;
            }
            return state;
        }
    },

    watch: {
        'task.Preview': function taskPreview() {
            this.task.PreviewFormatted = this.task.Preview ? this.task.Preview.replace(/\n/g, '<br>') : null;
        }
    },

    methods: {
        back: function back() {
            this.$router.back();
        },
        onChangeDate: function onChangeDate(item, formatted, raw) {
            item[raw] = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(item[formatted], 'DD.MM.YYYY').format();
        },
        fieldSettingsBoolStr: function fieldSettingsBoolStr(id) {
            return id == 1 ? 'Да' : 'Нет';
        },
        enableBtnSave: function enableBtnSave(lastStatus) {
            return lastStatus === __WEBPACK_IMPORTED_MODULE_5__enums__["q" /* TaskAnswerStates */].WaitingVerification;
        },
        enableBtnAccept: function enableBtnAccept(lastStatus) {
            return lastStatus === __WEBPACK_IMPORTED_MODULE_5__enums__["q" /* TaskAnswerStates */].WaitingVerification || lastStatus === __WEBPACK_IMPORTED_MODULE_5__enums__["q" /* TaskAnswerStates */].Finalized || lastStatus === __WEBPACK_IMPORTED_MODULE_5__enums__["q" /* TaskAnswerStates */].OnEdition || lastStatus === __WEBPACK_IMPORTED_MODULE_5__enums__["q" /* TaskAnswerStates */].Rejected;
        },
        enableBtnFinalize: function enableBtnFinalize(lastStatus) {
            return lastStatus === __WEBPACK_IMPORTED_MODULE_5__enums__["q" /* TaskAnswerStates */].WaitingVerification || lastStatus === __WEBPACK_IMPORTED_MODULE_5__enums__["q" /* TaskAnswerStates */].Accepted || lastStatus === __WEBPACK_IMPORTED_MODULE_5__enums__["q" /* TaskAnswerStates */].Finalized || lastStatus === __WEBPACK_IMPORTED_MODULE_5__enums__["q" /* TaskAnswerStates */].OnEdition;
        },
        enableBtnRejected: function enableBtnRejected(lastStatus) {
            return lastStatus === __WEBPACK_IMPORTED_MODULE_5__enums__["q" /* TaskAnswerStates */].WaitingVerification || lastStatus === __WEBPACK_IMPORTED_MODULE_5__enums__["q" /* TaskAnswerStates */].Accepted || lastStatus === __WEBPACK_IMPORTED_MODULE_5__enums__["q" /* TaskAnswerStates */].Finalized;
        },
        getStateClass: function getStateClass(item) {
            return 'task-state-' + item.LastStatus;
        },
        loadTask: function loadTask() {
            var vm = this;
            var taskId = parseInt(this.$route.params.taskId);
            var tradePointId = parseInt(this.$route.query.tpid);
            vm.answerId = parseInt(this.$route.params.answerId);
            vm.isController = this.$route.params.edit === 'checking' || vm.info.User.MainRole === 'administrators' || vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.tasksEdit) || vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.tasksController);
            vm.allowEdit = (this.$route.params.edit === 'add' || this.$route.params.edit === 'edit') && !vm.isController;

            if (vm.info.User.MainRole !== 'administrators' && !vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.tasksController) && !vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.tasksEdit)) {
                //if (!vm.isController && !vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.tasksPage)) {
                //    vm.back();
                //    return new Promise(resolve => resolve());
                //} else
                if (vm.isController) {
                    vm.back();
                    return new Promise(function (resolve) {
                        return resolve();
                    });
                }
            }
            if (vm.isController) vm.titleName = 'Задание на проверке';else if (vm.answerId > 0 && vm.allowEdit) vm.titleName = 'Редактирование ответа';else if (vm.answerId > 0) vm.titleName = 'Просмотр ответа';else vm.titleName = 'Добавление ответа';

            return backendApi.tasksAnswerLoad(taskId, vm.answerId, tradePointId).then(function (response) {
                //console.info('project.edit -> load, response:', response.data);
                if (response.hasError) {
                    if (response.status === 401) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Нет доступа');
                        vm.back();
                    } else __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке задания');
                } else {
                    if (response.data == null) {
                        vm.$router.back();
                    }
                    if (vm.info.User.MainRole !== 'administrators' && response.data.task.DenyExecutionOnSite && !vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.ttAccess)) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Нет доступа');
                        vm.$router.back();
                    }

                    vm.task = Object.assign(response.data.task);
                    vm.fieldTable.minItems = vm.task.FieldTableMinRows == null ? 0 : vm.task.FieldTableMinRows;
                    vm.fieldTable.maxItems = vm.task.FieldTableMaxRows == null ? 0 : vm.task.FieldTableMaxRows;
                    vm.fieldTable.ReportDate = { reportDate: vm.currentAnswer.FillingDate };

                    vm.taskId = vm.task.Id;
                    vm.task.TasksAttachments.forEach(function (x) {
                        x.Extension = x.FileName.split('.').pop();
                    });
                    vm.task.LastStatusSelectAnswer = JSON.parse(vm.task.LastStatusSelectAnswer);
                    vm.task.CaptionFormatted = vm.task.Caption ? vm.task.Caption.replace(/\n/g, '<br>') : null;
                    vm.currentAnswer = Object.assign(response.data.currentAnswer);
                    vm.currentAnswer.FillingDateFormatted = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(vm.currentAnswer.FillingDate).format('DD.MM.YYYY');
                    vm.currentAnswer.FillingDateLong = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(vm.currentAnswer.FillingDate).format('DD.MM.YYYY HH:mm');
                    if (vm.currentAnswer.DateOpen) {
                        vm.currentAnswer.DateOpenLong = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(vm.currentAnswer.DateOpen).format('DD.MM.YYYY HH:mm');
                    }

                    vm.allowEdit = vm.allowEdit && vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.bonusSpend) && vm.currentAnswer.UserId === vm.info.User.Id && (vm.task.LastStatusSelectAnswer.Id === __WEBPACK_IMPORTED_MODULE_5__enums__["q" /* TaskAnswerStates */].WaitingVerification || vm.task.LastStatusSelectAnswer.Id === __WEBPACK_IMPORTED_MODULE_5__enums__["q" /* TaskAnswerStates */].Finalized || vm.task.LastStatusSelectAnswer.Id === __WEBPACK_IMPORTED_MODULE_5__enums__["q" /* TaskAnswerStates */].OnEdition || vm.answerId === 0) || vm.isController && (vm.task.LastStatusSelectAnswer.Id === __WEBPACK_IMPORTED_MODULE_5__enums__["q" /* TaskAnswerStates */].WaitingVerification || vm.task.LastStatusSelectAnswer.Id === __WEBPACK_IMPORTED_MODULE_5__enums__["q" /* TaskAnswerStates */].Finalized);
                    if (vm.allowEdit && vm.task.LastStatusSelectAnswer.Id !== __WEBPACK_IMPORTED_MODULE_5__enums__["q" /* TaskAnswerStates */].OnEdition && vm.task.EndDate < vm.task.Now) {
                        vm.allowEdit = false;
                    }
                    vm.fieldTable.canBeEdited = vm.allowEdit;

                    if (vm.answerId === 0 && !vm.currentAnswer.TradePoint && vm.task.FixTT) {
                        vm.loadNextTradePoints();
                    } else if (vm.currentAnswer.TradePoint) {
                        vm.fieldTable.TradePoint = vm.currentAnswer.TradePoint;
                    }

                    //console.info('vm.fieldTable', vm.fieldTable, vm.fieldSettingsSku, vm.allowEdit);
                    switch (vm.task.ScoringAccrual) {
                        case __WEBPACK_IMPORTED_MODULE_5__enums__["m" /* ScoringAccrualType */].FACT:
                            vm.fieldTable.bonusSettings.bonusStrategy = {
                                type: 'fact',
                                data: {
                                    value: vm.task.ScoringAccrualSum
                                }
                            };
                            break;
                        case __WEBPACK_IMPORTED_MODULE_5__enums__["m" /* ScoringAccrualType */].PERCENT:
                            vm.fieldTable.bonusSettings.bonusStrategy = {
                                type: 'percent',
                                data: {
                                    fieldId: vm.task.ScoringAccrualField,
                                    value: vm.task.ScoringAccrualSum
                                }
                            };
                            break;
                        case __WEBPACK_IMPORTED_MODULE_5__enums__["m" /* ScoringAccrualType */].PER_SKU:
                            vm.fieldTable.bonusSettings.bonusStrategy = {
                                type: 'perSku',
                                data: {
                                    fieldId: vm.task.ScoringAccrualField,
                                    value: vm.task.ScoringAccrualSum
                                }
                            };
                            vm.fieldTable.skuBonusList = vm.task.SkuBonusList;
                            break;
                        default:
                            break;
                    }
                }
            });
        },
        saveAnswer: function saveAnswer(status, comment, saveOnly) {
            var vm = this;
            var taskId = parseInt(this.$route.params.taskId);

            Promise.all([vm.$refs.reportItems ? vm.$refs.reportItems.validate() : null, vm.$validator.validate()]).then(function (results) {
                if (vm.$refs.reportItems && !results[0] || !results[1]) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                } else {

                    vm.task.Id = taskId;
                    var saveObj = { TaskId: taskId, AnswerId: vm.answerId, Attachments: [], Status: status, Comment: comment };

                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = vm.FieldSettings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var s = _step.value;

                            if (s.type === 'attach') {
                                if (s.Attachments.length === 0) {
                                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Не добавлено вложение');
                                    return;
                                } else {
                                    saveObj.Attachments.push({ Id: s.id, Files: Object.assign(s.Attachments) });
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    if (vm.fieldTable.ReportItems.length > 0) {
                        saveObj.ReportItems = Object.assign(vm.fieldTable.ReportItems);
                    } else if (vm.task.FieldInputType === vm.FieldType.Table) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные, необходимо добавить хотя бы одну строку!');
                        return;
                    }
                    if (vm.answerId === 0 && vm.currentAnswer.TradePoint) {
                        saveObj.TradePointId = vm.currentAnswer.TradePoint.Id;
                    }

                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Сохранение...');

                    saveObj.SaveOnly = saveOnly;

                    backendApi.tasksAnswerSave(saveObj).then(function (response) {
                        if (response.hasError) {
                            switch (response.status) {
                                case 721:
                                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Время на выполнение задания истекло.');
                                    break;
                                case 722:
                                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Отправить на доработку можно только тот ответ, по которому бонусы не были истрачены.');
                                    break;
                                case 723:
                                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Отклонить можно только тот ответ, по которому бонусы не были истрачены.');
                                    break;
                                case 724:
                                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Удалить можно только тот ответ, по которому бонусы не были истрачены.');
                                    break;
                                default:
                                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении задания');
                                    break;
                            }
                        } else {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');
                            if (status > 0) {
                                vm.$refs['ppComment'].close();
                            }
                            vm.back();
                            //vm.$router.push('/tasks/' + taskId);
                        }
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                    });
                }
            });
        },
        loadAnswersDetail: function loadAnswersDetail() {
            var vm = this;
            vm.answerId = parseInt(this.$route.params.answerId);
            vm.taskId = parseInt(this.$route.params.taskId);
            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
            this.callApiWrapper(backendApi.tasksAnswersDetail(vm.taskId, vm.answerId)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки ответов');
                } else {
                    if (resp.data.items && resp.data.items.length) {
                        var _vm$fieldTable$Report;

                        (_vm$fieldTable$Report = vm.fieldTable.ReportItems).push.apply(_vm$fieldTable$Report, _toConsumableArray(resp.data.items));
                    }

                    if (resp.data.fieldSettings) {
                        (function () {
                            vm.FieldSettings = Object.assign(resp.data.fieldSettings);
                            var fields = [];
                            var totalSeconds = new Date().getTime();
                            var _iteratorNormalCompletion2 = true;
                            var _didIteratorError2 = false;
                            var _iteratorError2 = undefined;

                            try {
                                for (var _iterator2 = vm.fieldSettingsOrdered[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                    var s = _step2.value;

                                    if (s.type === 'select') {
                                        s.optionsItems = JSON.parse(s.options).map(function (x) {
                                            return { Value: x, Name: x };
                                        });
                                    } else if (s.type === 'attach') {
                                        if (s.Attachments == null) s.Attachments = [];else {
                                            s.Attachments.forEach(function (x) {
                                                x.Extension = x.FileName.toLowerCase().split('.').pop();
                                                if (x.FilePath && x.FilePath.indexOf('?') === -1) x.FilePath = x.FilePath + '?' + totalSeconds;
                                            });
                                        }
                                        vm.existsAttach = true;
                                        s.accept = "";
                                        if (s.options) {
                                            var options = JSON.parse(s.options);
                                            if (options.indexOf('photo') > -1) {
                                                s.attach_photo = true;
                                                s.accept = ".jpg,.jpeg,.png";
                                            }
                                            if (options.indexOf('doc') > -1) {
                                                s.attach_doc = true;
                                                s.accept = s.accept + ",.docx,.xlsx";
                                            }
                                        }
                                        continue;
                                    }
                                    vm.fieldTable.reportSettings.push(s);
                                    fields.push({ Name: s.name, Value: null, Title: null, Type: s.type });
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                        _iterator2.return();
                                    }
                                } finally {
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                        })();
                    }
                }
                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
            });
        },
        onRemoveAttachment: function onRemoveAttachment(settings, i) {
            if (confirm('Удалить файл?')) {
                settings.Attachments.splice(i, 1);
                //this.$refs.dropFiles2.value = '';
            }
        },
        btnAccept: function btnAccept(status, comment) {
            var vm = this;
            //vm.answerId = parseInt(this.$route.params.id);
            var taskId = parseInt(this.$route.params.id);
            //console.info(taskId, vm.answerId, status);
            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Сохранение...');
            backendApi.tasksAnswerAccept(taskId, vm.answerId, status, comment).then(function (response) {
                if (response.hasError) {
                    switch (response.status) {
                        case 722:
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Отправить на доработку можно только тот ответ, по которому бонусы не были истрачены.');
                            break;
                        case 723:
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Отклонить можно только тот ответ, по которому бонусы не были истрачены.');
                            break;
                        case 724:
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Удалить можно только тот ответ, по которому бонусы не были истрачены.');
                            break;
                        default:
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении');
                            break;
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');
                    vm.$refs['ppComment'].close();
                    vm.back();
                }
                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
            });
        },
        validatePopup: function validatePopup() {
            var vm = this;
            this.$validator.validate().then(function (result) {
                if (!result) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                    return;
                } else {
                    if (vm.selectStatus === 4) vm.saveAnswer(vm.selectStatus, vm.commentStatus);else vm.btnAccept(vm.selectStatus, vm.commentStatus);
                }
            });
        },
        btnReject: function btnReject(state) {
            var vm = this;
            vm.selectStatus = state;
            vm.commentStatus = '';

            if (state === 4) vm.popuptitle = 'Причина отправки на доработку';else vm.popuptitle = 'Причина отклонения';
            vm.$refs['ppComment'].show();

            vm.$nextTick(function () {
                vm.$refs.ppComment.show();
            });
        },
        closeModal: function closeModal(popupName) {
            this.$refs[popupName].close();
        },
        onInfoOpen: function onInfoOpen() {
            this.$refs['ppInfo'].show();
        },
        onAttachFiles: function onAttachFiles(obj) {
            var files = obj.files;
            var fieldId = obj.id;
            var accept = obj.accept;
            var filename = '';
            //console.info();
            var is_photo = accept.indexOf('jpg') > -1;
            var is_doc = accept.indexOf('docx') > -1;
            var vm = this;
            if (files && files.length) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = files[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var file = _step3.value;

                        filename = file.name.toLowerCase();
                        if (is_photo && (filename.endsWith('.jpg') || filename.endsWith('.jpeg') || filename.endsWith('.png')) || is_doc && (filename.endsWith('.docx') || filename.endsWith('.xlsx'))) {
                            if (file.size > 50 * 1024 * 1024) {
                                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Превышен размер. Выберите другой файл');
                                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[name="dropFiles"]').val('');
                            } else {
                                (function () {
                                    //console.info('file:', filename.indexOf('.doc'), filename);
                                    var img = { FileName: file.name, FileData: null, Delete: false, FieldId: fieldId, Extension: '' };
                                    if (filename.indexOf('.xls') > -1) img.Extension = 'xlsx';else if (filename.indexOf('.doc') > -1) img.Extension = 'docx';else img.isImage = true;

                                    var reader = new FileReader();
                                    reader.onload = function (e) {
                                        img.FileData = e.target.result;
                                        var field = vm.FieldSettings.find(function (x) {
                                            return x.id === fieldId;
                                        });
                                        field.Attachments.push(img);
                                    };
                                    reader.readAsDataURL(file);
                                })();
                            }
                        } else {
                            if (is_photo && is_doc) __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Не верный формат файла ' + filename + ', разрешено: .jpg,.jpeg,.png,.docx,.xlsx');else if (is_photo) __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Не верный формат файла ' + filename + ', разрешено: .jpg,.jpeg,.png');else if (is_doc) __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Не верный формат файла ' + filename + ', разрешено: .docx,.xlsx');else __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Не верный формат файла ' + filename + ', к сожалению, разрешенные форматы не указаны');
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
        },
        searchSkuFunction: function searchSkuFunction(searchText, callback, extra, page, fieldName) {
            var vm = this;
            var colSetting = vm.fieldTable.reportSettings.find(function (x) {
                return x.name === fieldName;
            });
            var tradePointId = 0;
            if (vm.currentAnswer.TradePoint) tradePointId = vm.currentAnswer.TradePoint.Id;
            //if ((page - 1) === 0) callback(vm.sku);
            vm.callApiWrapper(backendApi.skuSearchForTable((page - 1) * 20, 20, tradePointId, searchText, fieldName, colSetting.id, vm.fieldTable.bonusSettings.skuView)).then(function (resp) {
                callback(resp.data);
            });
        },
        getSkuSelectedItem: function getSkuSelectedItem(field) {
            //console.info('getSkuSelectedItem', field.ValueInt, field.Title);
            return {
                Id: field.Value,
                Name: field.Title
            };
        },
        onChangeSkuSearch: function onChangeSkuSearch(listItem, extra, fieldName) {
            var vm = this;
            // тип ввода: таблица
            if (vm.fieldTable.ReportItems.length > 0) {
                var field = vm.fieldTable.ReportItems[extra].Fields.find(function (x) {
                    return x.Type === 'sku' && x.Name === fieldName;
                });
                //field.Value = listItem ? listItem.Id : null;
                if (listItem) {
                    field.Value = listItem.Id;
                    field.Title = listItem.Name;
                } else {
                    field.Value = null;
                    field.Title = null;
                }
            }
        },
        onSelectTradePoint: function onSelectTradePoint(tt) {
            this.currentAnswer.TradePoint = tt;
            //this.loadAnswersDetail();
            this.fieldTable.TradePoint = this.currentAnswer.TradePoint;
        },


        onChangeTradeSearch: _.debounce(function () {
            this.ttPage = 1;
            this.ttData = [];
            this.loadNextTradePoints();
        }, 300),

        onReportItemsScroll: function onReportItemsScroll(e) {
            var vm = this;
            if (vm.currentAnswer.TradePoint == null && !vm.ttIsLoading && vm.ttCanBeLoaded) {
                var elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target);
                if (elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight() + 100) {
                    vm.ttPage++;
                    vm.loadNextTradePoints();
                }
            }
        },
        loadNextTradePoints: function loadNextTradePoints() {
            var vm = this;

            vm.ttSearched = true;

            var searchText = vm.ttSearch;
            vm.ttIsLoading = true;
            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
            vm.callApiWrapper(backendApi.tradePointListForReport((this.ttPage - 1) * 50, 50, vm.task.ProjectId, searchText, null)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки торговых точек');
                } else {
                    var filteredData = resp.data;

                    // Фильтрация списка точек
                    if (vm.task.MemberFilterVariant === __WEBPACK_IMPORTED_MODULE_5__enums__["e" /* MemberFilters */].TradePoints) {
                        var filterField = vm.task.MemberFilterField;
                        var filterValue = JSON.parse(vm.task.MemberFilterValue).map(function (item) {
                            return item.Name;
                        });

                        filteredData = filteredData.filter(function (point) {
                            return filterValue.includes(point[filterField]);
                        });
                    }

                    // Добавление отфильтрованных данных в общий массив
                    if (filteredData.length) {
                        var _vm$ttData;

                        (_vm$ttData = vm.ttData).push.apply(_vm$ttData, _toConsumableArray(filteredData));
                        // Проверка на количество точек в массиве
                        if (vm.ttData.length === 1) {
                            vm.currentAnswer.TradePoint = vm.ttData[0];
                            vm.fieldTable.TradePoint = vm.currentAnswer.TradePoint;
                        }
                    } else {
                        vm.ttCanBeLoaded = false;
                    }
                }

                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                vm.ttIsLoading = false;
            });
        },
        formatTradePointName: function formatTradePointName(tradePoint) {
            var arr = [];
            if (tradePoint.Region) {
                arr.push(tradePoint.Region);
            }
            if (tradePoint.City) {
                arr.push(tradePoint.City);
            }
            if (tradePoint.Address) {
                arr.push(tradePoint.Address);
            }
            return tradePoint.Name + (arr.length ? ' (' + arr.join(', ') + ')' : '');
        },
        skuSelectedItem: function skuSelectedItem() {
            var vm = this;
            if (vm.tradePointSelected && vm.task.FieldInputType === vm.FieldType.Single) {
                var field = vm.FieldSettings.find(function (x) {
                    return x.type === 'sku';
                });
                //console.info('sku_selectedItem', vm.$refs.searchfilter);
                if (field) vm.skuValueItem++;
                //vm.searchfilter_selectedItem_Init();
                //vm.$refs.searchfilter.searchfilter_selectedItem_Init();
            }
        },
        rotateImage: function rotateImage(direction, item) {
            var vm = this;

            vm.callApiWrapper(backendApi.commonImageRotation(item.FilePath, direction)).then(function (response) {
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при изменении изображения');
                } else {
                    item.FilePath = response.data;
                }
            });
        }
    },

    mounted: function mounted() {
        var vm = this;
        vm.fieldTable = {
            bonusSettings: {
                bonusStrategy: {
                    type: ''
                },
                skuView: 'tasks'
            },
            TradePoint: { Id: 0, SkuLink: '' },
            reportSettings: [],
            equipmentTypes: [{ Id: 0, Name: '' }],
            sku: [{ Id: -1, Name: '' }],
            ReportDate: { reportDate: null },
            canBeEdited: vm.allowEdit,
            minItems: 0,
            maxItems: 0,
            ReportItems: [],
            skuBonusList: []
        };

        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
        Promise.all([this.loadTask(), this.loadAnswersDetail()]).then(function () {

            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('change', '[name="atDropFiles2"]', function () {
                var fieldId = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('fieldid');
                vm.onAttachFiles({ files: this.files, id: fieldId, accept: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this)[0].accept });
            });

            vm.imgmixin_lightzoomInit();
            vm.CommonMixin_doubleRequestAnimationFrame(function () {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.lightzoom-type2').fancybox({
                    beforeShow: function beforeShow() {
                        var downloadpath = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap.find('.fancybox-image').attr('src');
                        var $btn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<a href="' + downloadpath + '" class="btn" download>Скачать</a>');
                        var $div = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div class="btns flex">\n<button type="button" class="btn btn-primary margin-top-15 zoom-plus btn-img"><img src="/Content/dist/icon-plus-2.png" alt=""></button>\n<button type="button" class="btn btn-primary margin-top-15 zoom-minus btn-img"><img src="/Content/dist/icon-minus-2.png" alt=""></button>\n</div>');
                        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap.find('.fancybox-outer').after($btn);
                        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap.find('.fancybox-outer').before($div);
                        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fancybox.wrap.find('img.fancybox-image').draggable();
                    },
                    afterClose: function afterClose() {
                        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.lightzoom-type2').css({ "display": "block" });
                    }
                });
            });
        });
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('change', '[name="atDropFiles2"]');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('click', '.block-in-page-collapce');
    }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var backendApi = new __WEBPACK_IMPORTED_MODULE_1__backendApi__["a" /* default */]();

var porjectIdWorx = 25;

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "analytics",

    props: ['info'],

    mixins: [__WEBPACK_IMPORTED_MODULE_2__helpers_project_mixin__["a" /* default */]],

    data: function data() {
        return {
            filter: null,
            dateStart: null,
            dateEnd: null,
            chartData: null,
            chartOptions: null,
            unit: 'day',
            roles: [],
            filters: [],
            units: [{ Value: 'day', Name: 'День' }, { Value: 'week', Name: 'Неделя' }, { Value: 'month', Name: 'Месяц' }],
            project: null,
            measureType: null,
            measureTypes: [{ Value: 'Рубли', Name: 'Рубли' }, { Value: 'Штуки', Name: 'Штуки' }],
            tableData: null,
            tooltipHtml: null,
            chartDetailsData: null
        };
    },


    computed: {
        analyticsSettingsForRole: function analyticsSettingsForRole() {
            var _this = this;

            if (!this.project || !this.info) {
                return null;
            }
            if (this.info.User.MainRole === 'administrators') {
                return {
                    DataTypeId: 0,
                    ReportEnabled: true,
                    SwitcherEnabled: true,
                    PeriodsEnabled: true,
                    DetailEnabled: false
                };
            }
            var projectAnalyticsRoles = this.project.ProjectAnalyticsRoles.find(function (x) {
                return x.RoleId === _this.info.User.DynamicRole.Id;
            });
            return projectAnalyticsRoles || {
                DataTypeId: 0,
                ReportEnabled: true,
                SwitcherEnabled: true,
                PeriodsEnabled: true,
                DetailEnabled: false
            };
        },
        analyticsReportEnabled: function analyticsReportEnabled() {
            if (this.info && this.projectId === porjectIdWorx) return this.info.User.MainRole === 'administrators' || this.info.User.DynamicRole && this.info.User.DynamicRole.Name === 'Клиент';else return null;
        }
    },

    methods: {
        getCurrencyNameByCountry: function getCurrencyNameByCountry(countryId) {
            switch (countryId) {
                case 1:
                    // Россия
                    return 'Рубли';
                case 2:
                    // Беларусь
                    return 'Белорусские рубли';
                case 3:
                    // Казахстан
                    return 'Тенге';
                default:
                    return 'Рубли'; // Значение по умолчанию
            }
        },
        getTdClass: function getTdClass(type) {
            switch (type) {
                case 'System.Int16':
                case 'System.Int32':
                    return 'id';
                case 'System.String':
                    return 'string';
                case 'System.Datetime':
                    return 'datetime';
                case 'System.Double':
                case 'System.Decimal':
                    return 'value';
                default:
                    return null;
            }
        },
        formatTableValue: function formatTableValue(value, type) {
            if (type === 'System.DateTime') {
                return Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(value).format('DD.MM.YYYY HH:mm');
            }
            return value;
        },
        formatTableDetailsValue: function formatTableDetailsValue(value, type) {
            if (type === 'System.DateTime') {
                return Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(value).format('DD.MM.YYYY');
            }
            return value;
        },
        onTableClick: function onTableClick(tableRow, index) {
            var vm = this;
            if (this.analyticsSettingsForRole.DetailEnabled !== true || tableRow.DetailsTable) {
                return;
            }

            for (var i = 0; i < vm.tableData.Table.length; i++) {
                if (i !== index && vm.tableData.Table[i].Expanded === true) {
                    vm.tableData.Table[i].Expanded = false;
                    vm.tableData.Table.splice(i + 1, 1);
                    if (index > i) {
                        index--;
                    }
                }
            }

            if (!tableRow.Expanded) {
                tableRow.Expanded = true;

                var projectId = vm.projectId;
                var timeZone = new Date().getTimezoneOffset();
                var dateStart = vm.dateStart && Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(vm.dateStart, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
                var dateEnd = vm.dateEnd && Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(vm.dateEnd, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
                var filterFormatted = '';
                if (vm.filter) {
                    filterFormatted = vm.filter.map(function (x) {
                        return JSON.stringify(x);
                    });
                }
                var measureType = null;
                if (vm.analyticsSettingsForRole.SwitcherEnabled === true) {
                    measureType = vm.measureType;
                }
                var skuId = null;
                if (vm.project.Id === 7) {
                    skuId = vm.skuId;
                }
                var asDataTable = vm.analyticsSettingsForRole.DataTypeId === 1;

                __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].blockUI('.table-view:first');
                vm.callApiWrapper(backendApi.analyticsGetDetails(projectId, dateStart, dateEnd, vm.unit, filterFormatted, measureType, skuId, asDataTable, tableRow.CustomField)).then(function (resp) {
                    console.info('resp.data:', resp.data);
                    vm.tableData.Table.splice(index + 1, 0, {
                        DetailsTable: Object.assign(resp.data, { ColumnsLength: Object.keys(resp.data.Columns).length })
                    });

                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('.table-view:first');
                });
            } else {
                tableRow.Expanded = false;
                vm.tableData.Table.splice(index + 1, 1);
            }
        },
        reload: function reload() {
            this.loadData();
        },
        loadRoles: function loadRoles() {
            var vm = this;
            var projectId = vm.projectId;
            vm.filters = [{
                Value: 'Name', Name: 'Название'
            }, {
                Value: 'Region', Name: 'Регион'
            }, {
                Value: 'Area', Name: 'Область'
            }, {
                Value: 'City', Name: 'Город'
            }, {
                Value: 'Address', Name: 'Адрес'
            }, { Value: 'ExternalId', Name: 'Внешний ID' }];
            if (projectId === 30) {
                return new Promise(function (resolve) {
                    return resolve();
                });
            } else {
                return this.callApiWrapper(backendApi.rolesList(projectId)).then(function (resp) {
                    if (resp.data) {

                        vm.roles = resp.data.Roles;

                        /*
                        для ролей соблюдаем иерархию, согласно последовательности отображения в настройках ролей
                        если роль не связана с ТТ, то она видит все роли связанные с ТТ
                        если роль связана с ТТ, то видит только роли, которые стоят ниже нее
                        */
                        if (vm.info.User.DynamicRole == null || vm.info.User.DynamicRole.Claims.find(function (x) {
                            return x.ClaimId === vm.claimEnums.ttAccess;
                        })) {
                            //alert()
                            for (var r = 0; r < vm.roles.length; r++) {
                                if (!vm.roles[r].Claims.find(function (x) {
                                    return x.ClaimId === vm.claimEnums.ttAccess;
                                })) {
                                    vm.filters.push({
                                        Value: 'TradePointRole_' + vm.roles[r].Id,
                                        Name: vm.roles[r].Name
                                    });
                                }
                            }
                        } else {

                            for (var _r = 0; _r < vm.roles.length; _r++) {
                                if (!vm.roles[_r].Claims.find(function (x) {
                                    return x.ClaimId === vm.claimEnums.ttAccess;
                                }) && vm.info.User.DynamicRole.Order < vm.roles[_r].Order) {

                                    vm.filters.push({
                                        Value: 'TradePointRole_' + vm.roles[_r].Id,
                                        Name: vm.roles[_r].Name
                                    });
                                }
                            }
                        }
                    }
                });
            }
        },
        loadProject: function loadProject() {
            var vm = this;

            return this.callApiWrapper(backendApi.projectLoad(vm.projectId)).then(function (resp) {
                if (resp.data) {
                    vm.project = resp.data;
                    //vm.analyticsSettingsForRole = vm.project.ProjectAnalyticsRoles.find(x => x.RoleId === vm.info.User.DynamicRole.Id);
                }
            });
        },
        loadData: function loadData() {
            var vm = this;

            var projectId = vm.projectId;
            var timeZone = new Date().getTimezoneOffset();
            var dateStart = vm.dateStart && Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(vm.dateStart, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
            var dateEnd = vm.dateEnd && Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(vm.dateEnd, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
            var filterFormatted = '';
            if (vm.filter) {
                filterFormatted = vm.filter.map(function (x) {
                    return JSON.stringify(x);
                });
            }

            var measureType = null;
            if (vm.analyticsSettingsForRole.SwitcherEnabled === true) {
                measureType = vm.measureType;
            }
            var skuId = null;
            if (vm.project.Id === 7) {
                skuId = vm.skuId;
            }

            //vm.analyticsSettingsForRole.DataTypeId = 1;
            var asDataTable = vm.analyticsSettingsForRole.DataTypeId === 1;

            this.callApiWrapper(backendApi.analyticsGetData(projectId, dateStart, dateEnd, vm.unit, filterFormatted, measureType, skuId, asDataTable)).then(function (resp) {
                if (!asDataTable) {
                    var labels = resp.data.map(function (x) {
                        return x.Name;
                    });
                    var values = resp.data.map(function (x) {
                        return x.Value;
                    });

                    vm.chartData = {
                        labels: labels,
                        datasets: [{
                            label: 'Сумма продаж',
                            data: values,
                            backgroundColor: vm.project.AnalyticsColumnsColor || 'rgba(255, 99, 132, 0.5)',
                            borderColor: vm.project.AnalyticsBorderColor || 'rgba(255, 99, 132, 1)',
                            borderWidth: 1
                        }]
                    };
                } else {
                    vm.tableData = resp.data;
                    vm.tableData.ColumnsLength = Object.keys(vm.tableData.Columns).filter(function (x) {
                        return x !== 'CustomField';
                    }).length;
                }
            });
        },
        loadSku: function loadSku() {
            var vm = this;

            vm.units.push({
                Value: 'sku',
                Name: 'Sku'
            });
        },
        searchFunction: function searchFunction(tableName, columnName, search, filters, searchPage, callback) {

            var projectId = this.projectId;
            var filterFormatted = '';
            if (filters) {
                filterFormatted = filters.map(function (x) {
                    return JSON.stringify(x);
                });
            }

            this.callApiWrapper(backendApi.tradePointDistinctValues(columnName, projectId, search, filterFormatted, (searchPage - 1) * 30, 30)).then(function (resp) {
                callback(resp.data);
            });
        },
        onProjectChange: function onProjectChange(item) {
            var vm = this;
            vm.projectId = item.Id;

            vm.filter = null;
            vm.$refs.complexFilter.clear();

            Promise.all([vm.loadRoles(), vm.loadProject()]).then(function () {
                vm.updateMeasureTypes(); // Обновляем measureTypes при изменении проекта
                vm.loadData();
                if (vm.projectId === 7 || vm.projectId === 8) {
                    vm.loadSku();
                } else {
                    vm.units = [{ Value: 'day', Name: 'День' }, { Value: 'week', Name: 'Неделя' }, { Value: 'month', Name: 'Месяц' }];
                }
            });

            vm.$emit('user-updated');
        },
        updateMeasureTypes: function updateMeasureTypes() {
            if (this.project) {
                var currencyName = this.getCurrencyNameByCountry(this.project.CountryId);
                this.measureTypes = [{ Value: 'Рубли', Name: currencyName }, { Value: 'Штуки', Name: 'Штуки' }];
            }
        },
        onFilterChange: function onFilterChange(filter) {
            //console.info('onFilterChange -> filter', filter);
            this.filter = filter;
            this.loadData();
        },
        onExport: function onExport() {
            var vm = this;

            var projectId = vm.projectId;
            var dateStart = vm.dateStart && Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(vm.dateStart, 'DD.MM.YYYY').format();
            var dateEnd = vm.dateEnd && Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(vm.dateEnd, 'DD.MM.YYYY').format();

            var filterFormatted = '';
            if (vm.filter) {
                filterFormatted = vm.filter.map(function (x) {
                    return JSON.stringify(x);
                });
            }
            var measureType = null;
            if (vm.analyticsSettingsForRole.SwitcherEnabled === true) {
                measureType = vm.measureType;
            }
            var skuId = null;
            if (vm.project.Id === 7) {
                skuId = vm.skuId;
            }

            __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].blockUI('#app');
            this.callApiWrapper(backendApi.analyticsExport(projectId, dateStart, dateEnd, vm.unit, filterFormatted, measureType, skuId)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время экспорта');
                    console.info('resp', resp);
                } else {
                    var exportFile = resp.data;
                    if (exportFile != null) {
                        //location.href = config.apiUrl + '/api/stats/exported?exportFile=' + exportFile;
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].downloadFileByBytes(resp.data, "Аналитика.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                    }
                }
                __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            });
        },
        onExportByReports: function onExportByReports() {
            var vm = this;

            var filterFormatted = '';
            if (vm.filter) {
                filterFormatted = vm.filter.map(function (x) {
                    return JSON.stringify(x);
                });
            }
            var measureType = null;
            if (vm.analyticsSettingsForRole.SwitcherEnabled === true) {
                measureType = vm.measureType;
            }
            var skuId = null;
            if (vm.project.Id === 7) {
                skuId = vm.skuId;
            }
            var dateStart = vm.dateStart && Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(vm.dateStart, 'DD.MM.YYYY').format();
            var dateEnd = vm.dateEnd && Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(vm.dateEnd, 'DD.MM.YYYY').format();

            __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].blockUI('#app');
            this.callApiWrapper(backendApi.analyticsExportByReports(vm.projectId, dateStart, dateEnd, vm.unit, filterFormatted, measureType, skuId)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время экспорта');
                    console.info('resp', resp);
                } else {
                    var exportFile = resp.data;
                    if (exportFile != null) {
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].downloadFileByBytes(resp.data, "Аналитика по отчётам.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                    }
                }
                __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            });
        },


        // [datasetIndex, dataIndex, clientX, clientY]
        onBarClick: function onBarClick(args) {
            var vm = this;
            if (args == null) {
                vm.chartDetailsData = null;
                return;
            }

            var label = this.chartData.labels[args[1]];
            var projectId = vm.projectId;
            var timeZone = new Date().getTimezoneOffset();
            var dateStart = vm.dateStart && Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(vm.dateStart, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
            var dateEnd = vm.dateEnd && Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(vm.dateEnd, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
            var filterFormatted = '';
            if (vm.filter) {
                filterFormatted = vm.filter.map(function (x) {
                    return JSON.stringify(x);
                });
            }
            var measureType = null;
            if (vm.analyticsSettingsForRole.SwitcherEnabled === true) {
                measureType = vm.measureType;
            }
            var skuId = null;
            if (vm.project.Id === 7) {
                skuId = vm.skuId;
            }
            var asDataTable = vm.analyticsSettingsForRole.DataTypeId === 1;

            __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].blockUI('#app');
            vm.callApiWrapper(backendApi.analyticsGetDetails(projectId, dateStart, dateEnd, vm.unit, filterFormatted, measureType, skuId, asDataTable, label)).then(function (resp) {
                //console.info('resp.data:', resp.data);
                vm.chartDetailsData = resp.data;

                vm.$nextTick(function () {
                    var leftPos = args[2],
                        topPos = args[3];
                    var docWidth = $(document).width(),
                        docHeight = $(document).height();
                    var elementWidth = $('#chartDetails').width(),
                        elementHeight = $('#chartDetails').height();

                    if (leftPos + elementWidth > docWidth - 50) {
                        leftPos -= elementWidth;
                    }
                    if (topPos + elementHeight > docHeight - 50) {
                        topPos -= elementHeight;
                    }

                    $('#chartDetails').css({
                        left: leftPos + 'px',
                        top: topPos + 'px'
                    }).appendTo('body');
                });

                __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            });
        }
    },

    mounted: function mounted() {
        var vm = this;

        vm.dateStart = vm.formatDate(Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])().startOf('month'));
        vm.dateEnd = vm.formatDate(Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])().endOf('month'));

        var options = {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }]
            },
            maintainAspectRatio: false,
            responsive: true,
            stacked: false,
            defaultFontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            legend: {
                display: false
            },
            tooltips: {
                enabled: true,
                /*
                custom: function(tooltipModel){
                    let tooltipEl = document.getElementById('chartjs-tooltip');
                    // Hide if no tooltip
                    if (tooltipEl && tooltipModel.opacity === 0) {
                        tooltipEl.style.opacity = 0;
                        vm.$refs['chartObj'].update({
                            tooltips:{
                                enabled: true
                            }
                        });
                        return;
                    }
                     if(vm.tooltipHtml != null){
                        if (!tooltipEl) {
                            tooltipEl = document.createElement('div');
                            tooltipEl.id = 'chartjs-tooltip';
                            //tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
                            tooltipEl.style.borderRadius = '3px';
                            tooltipEl.style.color = 'white';
                            tooltipEl.style.padding = 0;
                            tooltipEl.style.opacity = 1;
                            tooltipEl.style.pointerEvents = 'none';
                            tooltipEl.style.position = 'absolute';
                            tooltipEl.style.transform = 'translate(-50%, 0)';
                            tooltipEl.style.transition = 'all .1s ease';
                            tooltipEl.innerHTML = vm.tooltipHtml;
                            document.body.appendChild(tooltipEl);
                        }
                         // Set caret Position
                        tooltipEl.classList.remove('above', 'below', 'no-transform');
                        if (tooltipModel.yAlign) {
                            tooltipEl.classList.add(tooltipModel.yAlign);
                        } else {
                            tooltipEl.classList.add('no-transform');
                        }
                         // `this` will be the overall tooltip
                        let position = this._chart.canvas.getBoundingClientRect();
                        console.info('position:', position);
                         // Display, position, and set styles for font
                        tooltipEl.style.position = 'absolute';
                        tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
                        tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
                        tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                        tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
                        tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                        tooltipEl.style.padding = '0px';
                        tooltipEl.style.pointerEvents = 'none';
                        tooltipEl.style.opacity = 1;
                         vm.tooltipHtml = null;
                    }
                },
                */
                callbacks: {
                    label: function label(tooltipItem, data) {
                        var label = data.datasets[tooltipItem.datasetIndex].label || '';
                        label += ': ' + vm.formatInt(tooltipItem.yLabel);
                        return label;
                    }
                }
            }
        };
        vm.chartOptions = options;

        Promise.all([vm.loadRoles(), vm.loadProject()]).then(function () {
            vm.updateMeasureTypes();
            vm.loadData();

            if (vm.projectId === 7 || vm.projectId === 8) {
                vm.loadSku();
            }
        });

        $(document).on('click', function () {
            vm.chartDetailsData = null;
        });
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(30)))

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_claims_checking_mixin__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(79);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var backendApi = new __WEBPACK_IMPORTED_MODULE_1__backendApi__["a" /* default */]();
var cacheKey = 'materialsState';
var pageSize = 12;

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "materials",

    props: ['info'],

    mixins: [__WEBPACK_IMPORTED_MODULE_2__helpers_project_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__helpers_claims_checking_mixin__["a" /* default */]],

    data: function data() {
        return {
            materials: [],
            page: 1,
            projectId: null,
            canBeLoaded: true,
            loading: false,
            chartData: [],
            chartOptions: [],
            materialStats: null,
            enabledCertificate: false,
            active: true
        };
    },


    watch: {
        '$route.query.folderId': function $routeQueryFolderId(to, from) {
            this.page = 1;
            this.materials = [];
            this.canBeLoaded = true;
            this.enabledCertificate = false;

            this.loadNext();
        }
    },

    methods: {
        reload: function reload() {
            this.clearFilterState();
            this.page = 1;
            this.materials = [];
            this.canBeLoaded = true;
            this.enabledCertificate = false;

            this.loadNext();
            this.loadStats();
        },
        back: function back() {
            this.$router.back();
        },
        getImageStyleFormatted: function getImageStyleFormatted(imageStyle) {
            if (!imageStyle) {
                return null;
            }

            var settings = {
                left: imageStyle.left + '%',
                top: imageStyle.top + '%',
                transform: 'translateY(' + imageStyle.translateY + '%) translateX(' + imageStyle.translateX + '%)'
            };
            if (imageStyle.resizeType === 1 && parseInt(imageStyle.size)) {
                settings.height = imageStyle.size + '%';
            }
            if (imageStyle.resizeType === 2 && parseInt(imageStyle.size)) {
                settings.width = imageStyle.size + '%';
            }
            return settings;
        },
        loadNext: function loadNext() {
            var vm = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
            var folderId = vm.$route.query.folderId;
            this.callApiWrapper(backendApi.materialsList((this.page - 1) * pageSize, pageSize, vm.projectId, folderId, vm.active)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки материалов');
                } else {
                    if (resp.data && resp.data.length) {
                        var _vm$materials;

                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = resp.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var item = _step.value;

                                if (item.ImageStyle) {
                                    item.ImageStyle = JSON.parse(item.ImageStyle);
                                }
                                if (item.CertificateSettings) {
                                    item.CertificateSettings = JSON.parse(item.CertificateSettings);
                                    vm.enabledCertificate = vm.enabledCertificate || item.CertificateSettings.Issuance !== 'undefined' && item.CertificateSettings.Issuance.Actived;
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        (_vm$materials = vm.materials).push.apply(_vm$materials, _toConsumableArray(resp.data));
                    } else {
                        vm.canBeLoaded = false;
                    }
                }
                __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                vm.loading = false;
            });
        },
        addMaterial: function addMaterial() {
            var folderId = this.$route.query.folderId;
            this.$router.push('/materials/edit/0' + (folderId ? '?folderId=' + folderId : ''));
        },
        addFolder: function addFolder() {
            var folderId = this.$route.query.folderId;
            this.$router.push('/materials/folder/edit/0' + (folderId ? '?folderId=' + folderId : ''));
        },
        goToCertificate: function goToCertificate() {
            var folderId = this.$route.query.folderId;
            this.$router.push('/materials/certificate/' + this.projectId + '/' + (folderId ? '?folderId=' + folderId : ''));
        },
        goToMaterial: function goToMaterial(id) {
            this.saveFilterState();
            this.$router.push('/materials/' + id);
        },
        goToFolder: function goToFolder(id) {
            this.saveFilterState();
            this.$router.push('/materials/?folderId=' + id);
        },
        goToMaterialEdit: function goToMaterialEdit(id) {
            this.saveFilterState();
            this.$router.push('/materials/edit/' + id);
        },
        goToFolderEdit: function goToFolderEdit(id) {
            this.saveFilterState();
            this.$router.push('/materials/folder/edit/' + id);
        },
        onItemClick: function onItemClick(item) {
            if (item.IsFolder) {
                this.$router.push('/materials/?folderId=' + item.Id);
            } else {
                this.$router.push('/materials/' + item.Id);
            }
        },
        onProjectChange: function onProjectChange(item) {
            this.projectId = item.Id;
            this.reload();
            this.$emit('user-updated');
        },
        loadStats: function loadStats() {
            var vm = this;
            var prj_color = __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].project_colors(vm.projectId);
            __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');

            this.callApiWrapper(backendApi.materialStats(vm.projectId)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки статистики');
                } else {
                    var defaultChartOptions = {
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            yAxes: [{
                                display: false,
                                ticks: {
                                    beginAtZero: true
                                }
                            }]
                        },
                        animation: {
                            animateScale: true,
                            animateRotate: true
                        },
                        cutoutPercentage: 90,
                        tooltips: {
                            enabled: false
                        }
                    };

                    vm.chartOptions = [Object.assign({}, defaultChartOptions, {
                        elements: {
                            center: {
                                text: resp.data.learnedPercent + '%',
                                color: prj_color,
                                fontStyle: "'Segoe UI'",
                                fontSize: 20,
                                sidePadding: 20
                            }
                        }
                    }), Object.assign({}, defaultChartOptions, { elements: { center: {
                                text: resp.data.testsPercent + '%',
                                color: prj_color, fontSize: 20,
                                fontStyle: "'Segoe UI'",
                                sidePadding: 20 } } }), Object.assign({}, defaultChartOptions, { elements: { center: {
                                text: resp.data.rightAvgPercent + '%',
                                color: prj_color, fontSize: 20,
                                fontStyle: "'Segoe UI'",
                                sidePadding: 20 } } })];
                    vm.chartData = [{
                        datasets: [{
                            data: [resp.data.learnedPercent, 100 - resp.data.learnedPercent],
                            backgroundColor: [prj_color, 'rgb(234, 235, 240)'],
                            borderWidth: 0
                        }],
                        labels: []
                    }, {
                        datasets: [{
                            data: [resp.data.testsPercent, 100 - resp.data.testsPercent],
                            backgroundColor: [prj_color, 'rgb(234, 235, 240)'],
                            borderWidth: 0
                        }],
                        labels: []
                    }, {
                        datasets: [{
                            data: [resp.data.rightAvgPercent, 100 - resp.data.rightAvgPercent],
                            backgroundColor: [prj_color, 'rgb(234, 235, 240)'],
                            borderWidth: 0
                        }],
                        labels: []
                    }];

                    vm.materialStats = resp.data;
                }
                __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
            });
        },
        onMakeMark: function onMakeMark(item, index) {
            var vm = this;

            backendApi.materialMakeVote(item.Id).then(function (response) {
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при выполнении запроса. Попробуйте позже');
                } else {
                    item.MyVote = !item.MyVote;
                    item.LikesCount = response.data.LikesCount;
                    __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].set(vm.materials, index, item);
                }
            });
        },
        saveFilterState: function saveFilterState() {
            var stateObj = {
                projectId: this.projectId,
                active: this.active,
                folderId: this.$route.query.folderId,
                page: this.page
            };
            sessionStorage.setItem(cacheKey, JSON.stringify(stateObj));
        },
        recoverFilterState: function recoverFilterState() {
            var stateObj = JSON.parse(sessionStorage.getItem(cacheKey));
            if (stateObj) {
                if ((stateObj.folderId == null || stateObj.folderId == this.$route.query.folderId) && stateObj.projectId == this.projectId) {
                    this.active = stateObj.active;
                    if (stateObj.page) {
                        this.page = stateObj.page;
                    }
                } else {
                    console.info('recoverFilterState -> wrong folderId (stateObj.folderId = ' + stateObj.folderId + ') or projectId (' + stateObj.projectId + ')');
                }
                this.clearFilterState();
            }
        },
        clearFilterState: function clearFilterState() {
            sessionStorage.removeItem(cacheKey);
        }
    },

    mounted: function mounted() {
        var vm = this;

        vm.recoverFilterState();

        this.loadNext();
        this.loadStats();

        vm.$nextTick(function () {

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').on('scroll', function () {

                if (!vm.loading && vm.canBeLoaded) {
                    var elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
                    if (elem[0].scrollHeight - elem.scrollTop() - 200 <= elem.outerHeight()) {
                        vm.page++;
                        vm.loadNext();
                    }
                }
            });
        });
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').off('scroll');
    }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_claims_checking_mixin__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__backendApi__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var backendApi = new __WEBPACK_IMPORTED_MODULE_5__backendApi__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "motivation",

    props: ['info'],

    data: function data() {
        return {
            project: null
        };
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_2__helpers_project_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__helpers_claims_checking_mixin__["a" /* default */]],

    methods: {
        onFileChange: function onFileChange() {
            var vm = this;

            var files = document.getElementById('dropFiles').files;
            if (files.length > 0) {
                if (window.FormData !== undefined) {
                    var data = new FormData();
                    for (var x = 0; x < files.length; x++) {
                        data.append("file" + x, files[x]);
                    }

                    var tokenInfo = JSON.parse(localStorage.getItem('tokenInfo') == null ? sessionStorage.getItem('tokenInfo') : localStorage.getItem('tokenInfo'));
                    var headers = {};
                    if (tokenInfo != null) {
                        headers.Authorization = 'bearer ' + tokenInfo.access_token;
                    }
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
                        type: "POST",
                        url: __WEBPACK_IMPORTED_MODULE_1__config___default.a.apiUrl + '/api/project/motivation?projectId=' + vm.projectId,
                        contentType: false,
                        processData: false,
                        headers: headers,
                        data: data,
                        success: function success(resp) {
                            if (resp.hasError) {
                                __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка загрузки');
                            } else {
                                __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно загружено');

                                vm.project.MotivationFile = resp.result;
                                var url = resp.result;
                                vm.$nextTick(function () {
                                    vm.$refs['pdfView'].show(url);
                                });
                            }
                        },
                        error: function error(xhr, status, p3) {
                            __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error(xhr.responseText);
                        }
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Браузер не поддерживает загрузку файлов HTML5!');
                }
            }
        },
        onVideoFileChange: function onVideoFileChange($event) {
            var vm = this;
            var files = $event.target.files;
            if (files.length > 0) {
                if (window.FormData !== undefined) {
                    var data = new FormData();
                    for (var x = 0; x < files.length; x++) {
                        data.append("file" + x, files[x]);
                    }
                    var tokenInfo = JSON.parse(localStorage.getItem('tokenInfo') == null ? sessionStorage.getItem('tokenInfo') : localStorage.getItem('tokenInfo'));
                    var headers = {};
                    if (tokenInfo != null) {
                        headers.Authorization = 'bearer ' + tokenInfo.access_token;
                    }

                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].blockUI('#app');
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
                        type: "POST",
                        url: __WEBPACK_IMPORTED_MODULE_1__config___default.a.apiUrl + '/api/project/loadVideo?projectId=' + vm.project.Id,
                        contentType: false,
                        processData: false,
                        headers: headers,
                        data: data,
                        success: function success(resp) {
                            if (resp.hasError) {
                                __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка загрузки видео');
                            } else {
                                var _data = resp.result;
                                vm.project.MotivationVideoName = _data.FileName;
                                vm.project.DeleteMotivationVideo = false;
                            }
                            __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
                        },
                        error: function error(xhr, status, p3) {
                            __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка на сервере');
                            console.error(xhr.responseText);
                            __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
                        }
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Браузер не поддерживает загрузку файлов HTML5!');
                }
            }
        },
        removeVideo: function removeVideo() {
            this.project.DeleteMotivationVideo = true;
        },
        loadProject: function loadProject() {
            var vm = this;

            return vm.callApiWrapper(backendApi.projectLoad(vm.projectId)).then(function (response) {
                console.info('project reloaded');
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке проекта');
                } else {
                    var obj = response.data;
                    obj.DeleteMotivationVideo = false;
                    if (obj.MotivationVideoName) {
                        obj.MotivationVideoTypeId = 2;
                    } else {
                        obj.MotivationVideoTypeId = 1;
                    }

                    vm.project = obj; //Object.assign({}, vm.project, obj);

                    vm.$nextTick(function () {
                        if (vm.project.MotivationFile) {
                            var url = vm.project.MotivationFile;
                            vm.$refs['pdfView'].show(url);
                        }

                        if (vm.project.MotivationYoutubeLink) {
                            vm.$refs['videoView'].show(vm.project.MotivationYoutubeLink, 0, 0, true);
                        }

                        if (vm.project.MotivationVideoPath) {
                            vm.$refs['videoView'].show(vm.project.MotivationVideoPath, 0);
                        }
                    });
                }
            });
        },
        onProjectChange: function onProjectChange(item) {
            var vm = this;

            vm.projectId = item.Id;

            location.reload();
            // UI.blockUI('#app');
            // vm.loadProject().then(()=>{
            //     UI.unblockUI('#app');
            //     vm.$emit('user-updated');
            // });
        },
        deleteMotivation: function deleteMotivation() {
            var vm = this;
            if (confirm('Вы уверены что хотите удалить файл?')) {
                __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Удаление...');
                vm.callApiWrapper(backendApi.motivationDelete(vm.projectId)).then(function (response) {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                    if (response.hasError) {
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при удалении файла');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно удалено');
                        vm.project.MotivationFile = null;
                    }
                });
            }
        },
        onDeleteYoutubeLink: function onDeleteYoutubeLink() {
            var vm = this;
            if (confirm('Вы уверены что хотите удалить видео?')) {

                vm.project.MotivationYoutubeLink = null;
                vm.project.MotivationVideoPath = null;
                vm.project.MotivationVideoName = null;

                this.saveLink().then(function (response) {
                    if (!response.hasError) {}
                });
            }
        },
        onSaveYoutubeLink: function onSaveYoutubeLink() {
            var vm = this;

            this.$validator.validate().then(function (result) {
                if (!result) {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                } else {
                    vm.saveLink().then(function (response) {
                        if (!response.hasError) {

                            vm.closeModal('ppYoutubeLink');
                            vm.loadProject();
                        }
                    });
                }
            });
        },
        saveLink: function saveLink() {
            var vm = this;
            __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].blockUI('#app', '');
            if (vm.project.MotivationVideoTypeId === 1) {
                vm.project.MotivationVideoName = null;
            } else {
                vm.project.MotivationYoutubeLink = null;
            }
            if (vm.project.DeleteMotivationVideo) {
                vm.project.MotivationVideoName = null;
                vm.project.MotivationVideoPath = null;
            }
            return vm.callApiWrapper(backendApi.motivationYoutubeLinkSave(vm.projectId, vm.project.MotivationYoutubeLink, vm.project.MotivationVideoName)).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при обновлении видео');
                } else {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно выполнено');
                }

                return response;
            });
        }
    },

    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
        this.loadProject().then(function () {
            __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
        });
    }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var backendApi = new __WEBPACK_IMPORTED_MODULE_0__backendApi__["a" /* default */]();
var projectIdMDV = 32;
var projectDaccord = 39;
var pageSize = 50;

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "rating-new",

    props: ['info'],

    mixins: [__WEBPACK_IMPORTED_MODULE_1__helpers_project_mixin__["a" /* default */]],

    data: function data() {
        return {
            data: [],
            ratingRoles: [],
            loading: false,
            canBeLoaded: true,
            page: 1,
            filter: null,
            filters: [],
            roles: [],
            sortColumn: 'BonusesAmountMonth',
            sortDirection: 'desc',
            project: null,
            ratingRole: null,
            isMobile: __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].check_mobile(),
            faceDefault: '../../img/u57.png',
            projectId: null
        };
    },


    methods: {
        Column2Value: function Column2Value(item) {
            if (item.Column2String && item.Column2String.length > 0) return item.Column2String;else if (this.project.RatingColumn2AsPercent === true) return this.formatInt(Math.floor(item.BonusesAmount * 100)).toString() + '%';else return this.formatInt(item.BonusesAmount).toString();
        },
        reload: function reload() {
            this.page = 1;
            this.canBeLoaded = true;
            this.data = [];

            this.loadNext();
        },
        sort: function sort(columnName) {
            var vm = this;
            if (vm.sortColumn == null || vm.sortColumn !== columnName) {
                vm.sortDirection = 'desc';
            } else {
                vm.sortDirection = vm.sortDirection === 'desc' ? 'asc' : 'desc';
            }
            vm.sortColumn = columnName;

            vm.reload();
        },
        loadRoles: function loadRoles() {
            var vm = this;
            var projectId = vm.projectId;
            //data.isMobile = UI.check_mobile();
            vm.filters = [{
                Value: 'Name', Name: 'Название'
            }, {
                Value: 'Region', Name: 'Регион'
            }, {
                Value: 'Area', Name: 'Область'
            }, {
                Value: 'City', Name: 'Город'
            }, {
                Value: 'Address', Name: 'Адрес'
            }];
            return this.callApiWrapper(backendApi.rolesList(projectId)).then(function (resp) {
                if (resp.data) {

                    vm.roles = resp.data.Roles;

                    /*
                    для ролей соблюдаем иерархию, согласно последовательности отображения в настройках ролей
                    если роль не связана с ТТ, то она видит все роли связанные с ТТ
                    если роль связана с ТТ, то видит только роли, которые стоят ниже нее
                    */
                    if (vm.info.User.DynamicRole == null || vm.info.User.DynamicRole.Claims.find(function (x) {
                        return x.ClaimId === vm.claimEnums.ttAccess;
                    })) {
                        //alert()
                        for (var r = 0; r < vm.roles.length; r++) {
                            if (vm.projectId === projectDaccord) {
                                if (vm.roles[r].Name === vm.ratingRole && !vm.roles[r].Claims.find(function (x) {
                                    return x.ClaimId === vm.claimEnums.ttAccess;
                                })) {
                                    vm.filters.push({
                                        Value: 'TradePointRole_' + vm.roles[r].Id,
                                        Name: vm.roles[r].Name
                                    });
                                }
                            }
                            // Для всех остальных projectId продолжаем добавлять роли, как обычно
                            else {
                                    if (!vm.roles[r].Claims.find(function (x) {
                                        return x.ClaimId === vm.claimEnums.ttAccess;
                                    })) {
                                        vm.filters.push({
                                            Value: 'TradePointRole_' + vm.roles[r].Id,
                                            Name: vm.roles[r].Name
                                        });
                                    }
                                }
                        }
                    } else {

                        for (var _r = 0; _r < vm.roles.length; _r++) {
                            if (!vm.roles[_r].Claims.find(function (x) {
                                return x.ClaimId === vm.claimEnums.ttAccess;
                            }) && vm.info.User.DynamicRole.Order < vm.roles[_r].Order) {

                                vm.filters.push({
                                    Value: 'TradePointRole_' + vm.roles[_r].Id,
                                    Name: vm.roles[_r].Name
                                });
                            }
                        }
                    }
                }
            });
        },
        loadSettings: function loadSettings() {
            var vm = this;

            return this.callApiWrapper(backendApi.ratingSettings()).then(function (resp) {
                if (resp.data) {
                    vm.project = resp.data.project;
                    vm.ratingRole = null;
                    if (vm.project.RatingSwitcherEnabled && vm.info.User && (vm.info.User.MainRole === 'administrators' || vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.ratingSwitcher))) {
                        if (vm.project.RatingRoles) {
                            vm.ratingRoles = vm.project.RatingRoles;
                        }
                        if (vm.info.User.MainRole === 'administrators') {
                            if (vm.ratingRoles.some(function (x) {
                                return x.ByDefault === true;
                            })) {
                                vm.ratingRole = vm.ratingRoles.find(function (x) {
                                    return x.ByDefault === true;
                                }).Value;
                            }
                        } else {
                            var currentRole = vm.info.User.UserDynamicRoles.find(function (x) {
                                return x.ProjectId === vm.projectId;
                            });
                            if (vm.projectId === 1) {
                                if (currentRole && currentRole.DefaultProjectRatingRole) {
                                    vm.ratingRole = currentRole.DefaultProjectRatingRole;
                                } else if (vm.ratingRoles.some(function (x) {
                                    return x.ByDefault === true;
                                })) {
                                    vm.ratingRole = vm.ratingRoles.find(function (x) {
                                        return x.ByDefault === true;
                                    }).Value;
                                }
                            } else if (vm.ratingRoles) {
                                if (currentRole) {
                                    vm.ratingRoles = vm.ratingRoles.filter(function (x) {
                                        return x.Value == currentRole.RoleName;
                                    });
                                    if (!vm.ratingRoles || vm.ratingRoles.length === 0) vm.ratingRoles = vm.project.RatingRoles;
                                }
                                if (vm.ratingRoles.some(function (x) {
                                    return x.ByDefault === true;
                                })) {
                                    vm.ratingRole = vm.ratingRoles.find(function (x) {
                                        return x.ByDefault === true;
                                    }).Value;
                                } else if (vm.ratingRoles.length > 0) {
                                    vm.ratingRole = vm.ratingRoles[0].Value;
                                }
                            }
                        }
                    }
                    if (vm.projectId === projectIdMDV || vm.projectId === 2) {
                        vm.faceDefault = null;
                    } else {
                        vm.faceDefault = '../../img/u57.png';
                    }
                }
            });
        },
        onScroll: function onScroll(e) {
            var vm = this;
            var elem = $(e.target);
            if (!vm.loading && vm.canBeLoaded && elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight() + 100) {
                vm.page++;
                vm.loadNext();
            }
        },
        loadNext: function loadNext() {
            var vm = this;

            vm.loading = true;
            var projectId = vm.projectId;
            var filterFormatted = '';
            if (this.filter) {
                filterFormatted = this.filter.map(function (x) {
                    return JSON.stringify(x);
                });
            }

            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
            this.callApiWrapper(backendApi.ratingGetTop((vm.page - 1) * pageSize, pageSize, projectId, filterFormatted, vm.sortColumn, vm.sortDirection, vm.ratingRole)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки данных');
                } else {
                    //console.log('vm.data', vm.data);
                    if (resp.data && resp.data.length) {
                        var currentUserId = vm.info.User.Id;

                        console.log(resp.data);

                        if (vm.projectId === projectDaccord) {
                            resp.data = resp.data.map(function (item) {
                                return _extends({}, item, {
                                    BonusesAmount: Math.round(item.BonusesAmount), // Округляем общий бонус
                                    BonusesAmountMonth: Math.round(item.BonusesAmountMonth) // Округляем бонус за месяц
                                });
                            });
                        }

                        // Проверка на projectId 39 и роль "Сантехник" или "Продавец"
                        if (vm.isDaccordUser) {
                            var _vm$data;

                            // Оставляем только 15 записей
                            var top15 = resp.data.slice(0, 15);

                            // Проверяем, есть ли текущий пользователь среди первых 15
                            var userInTop15 = top15.find(function (item) {
                                return item.UserId === currentUserId;
                            });

                            if (!userInTop15) {
                                // Если текущего пользователя нет в первых 15, добавляем его в список
                                var currentUserData = resp.data.find(function (item) {
                                    return item.UserId === currentUserId;
                                });

                                if (currentUserData) {
                                    top15.push(currentUserData); // Добавляем текущего пользователя
                                }
                            }

                            // Обновляем данные
                            (_vm$data = vm.data).push.apply(_vm$data, _toConsumableArray(top15));
                        } else {
                            var _vm$data2;

                            // Если не projectId 39 или не "Сантехник"/"Продавец", добавляем все записи
                            (_vm$data2 = vm.data).push.apply(_vm$data2, _toConsumableArray(resp.data));
                        }
                    } else {
                        vm.canBeLoaded = false;
                    }
                }

                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                vm.loading = false;
            });
            if (vm.projectId === projectDaccord) this.loadRoles();
        },
        onProjectChange: function onProjectChange(item) {
            var vm = this;

            vm.projectId = item.Id;
            vm.sortDirection = 'desc';
            vm.sortColumn = 'BonusesAmount';

            Promise.all([vm.loadRoles(), vm.loadSettings()]).then(function () {
                vm.reload();
            });

            vm.$emit('user-updated');
        },
        searchFunction: function searchFunction(tableName, columnName, search, filters, searchPage, callback) {

            var projectId = this.projectId;
            var filterFormatted = '';
            if (filters) {
                filterFormatted = filters.map(function (x) {
                    return JSON.stringify(x);
                });
            }

            this.callApiWrapper(backendApi.ratingDistinctValues(columnName, projectId, search, filterFormatted, (searchPage - 1) * 30, 30)).then(function (resp) {
                callback(resp.data);
            });
        },
        onFilterChange: function onFilterChange(filter) {
            this.filter = filter;
            this.reload();
        },
        onExport: function onExport() {
            var projectId = this.projectId;
            var filterFormatted = '';
            if (this.filter) {
                filterFormatted = this.filter.map(function (x) {
                    return JSON.stringify(x);
                });
            }

            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('#app');
            this.callApiWrapper(backendApi.ratingExport(projectId, filterFormatted, this.sortColumn, this.sortDirection, this.ratingRole)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время экспорта');
                } else {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].downloadFileByBytes(resp.data, "Рейтинг участников.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                }

                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            });
        }
    },

    computed: {
        isDaccordUser: function isDaccordUser() {
            var _this = this;

            var currentRole = this.info.User.UserDynamicRoles.find(function (x) {
                return x.ProjectId === _this.projectId;
            });
            return this.projectId === projectDaccord && currentRole && (currentRole.RoleName === 'Электрик' || currentRole.RoleName === 'Продавец');
        }
    },

    mounted: function mounted() {
        var vm = this;
        if (localStorage.getItem('selectedProjectId')) vm.projectId = parseInt(localStorage.getItem('selectedProjectId'));

        Promise.all([vm.loadRoles(), vm.loadSettings()]).then(function () {
            vm.loadNext();
        });
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(30)))

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "arrow-down.png?46deb230e8fcb6dfe7a9d08f344a8811";

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "arrow-up.png?8c77f39a2ace18f7c9a3079ffc6a0169";

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "sellers"
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_smooth_dnd__ = __webpack_require__(56);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var backendApi = new __WEBPACK_IMPORTED_MODULE_2__backendApi__["a" /* default */]();
var cacheKey = 'skuState';

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "sku",

    props: ['info'],

    mixins: [__WEBPACK_IMPORTED_MODULE_3__helpers_project_mixin__["a" /* default */]], // projectId

    components: { Container: __WEBPACK_IMPORTED_MODULE_6_vue_smooth_dnd__["a" /* Container */], Draggable: __WEBPACK_IMPORTED_MODULE_6_vue_smooth_dnd__["b" /* Draggable */] },

    data: function data() {
        return {
            sku: [],
            skuSettings: null,
            loading: false,
            canBeLoaded: true,
            page: 1,
            rowsPerPage: 20,
            projectId: null,
            search: null,
            active: true,
            importResult: null,
            groups: [],
            groupsOrigin: null,
            lastGroupId: null,
            scrollTop: null,
            firstLoad: true,
            emptyResults: false
        };
    },


    computed: {
        groupsOrdered: function groupsOrdered() {
            return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(this.groups, 'GroupOrder');
        },
        skuSettingsOrdered: function skuSettingsOrdered() {
            if (this.skuSettings == null) {
                return null;
            }

            return __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(Object.values(this.skuSettings), 'SettingsOrder');
        },
        groupsChanged: function groupsChanged() {
            return !__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.some(this.groups, { Edited: true }) && JSON.stringify(this.groups) !== JSON.stringify(this.groupsOrigin);
        },
        customSettingsFieldsCount: function customSettingsFieldsCount() {
            if (this.skuSettings == null) {
                return false;
            }

            return Object.values(this.skuSettings).filter(function (x) {
                return x.FieldName.startsWith('CustomField');
            }).length;
        }
    },

    watch: {
        '$route.query.folderId': function $routeQueryFolderId(to, from) {
            this.reload();
        }
    },

    methods: {
        back: function back() {
            this.$router.back();
        },
        formatAmountForUser: function formatAmountForUser(amountForUser) {
            return amountForUser.join(', ');
        },
        checkDisabledSettingsItem: function checkDisabledSettingsItem(fieldName) {
            return ['Name', 'Code', 'SkuOrder', 'ExternalCode', 'UnitBarCode', 'BoxBarCode', 'Volume', 'Weight', 'Amount'].indexOf(fieldName) > -1;
        },
        getImageStyleFormatted: function getImageStyleFormatted(imageStyle) {
            if (!imageStyle) {
                return null;
            }

            var settings = {
                left: imageStyle.left + '%',
                top: imageStyle.top + '%',
                transform: 'translateY(' + imageStyle.translateY + '%) translateX(' + imageStyle.translateX + '%)'
            };
            if (imageStyle.resizeType === 1 && parseInt(imageStyle.size)) {
                settings.height = imageStyle.size + '%';
            }
            if (imageStyle.resizeType === 2 && parseInt(imageStyle.size)) {
                settings.width = imageStyle.size + '%';
            }

            return settings;
        },
        onCloseSettings: function onCloseSettings() {
            this.$refs.ppSkuFieldSettings.close();
        },
        onFileChange: function onFileChange() {
            var vm = this;

            var files = document.getElementById('dropFiles').files;
            if (files.length > 0) {
                if (window.FormData !== undefined) {
                    var data = new FormData();
                    for (var x = 0; x < files.length; x++) {
                        data.append("file" + x, files[x]);
                    }

                    var tokenInfo = JSON.parse(localStorage.getItem('tokenInfo') == null ? sessionStorage.getItem('tokenInfo') : localStorage.getItem('tokenInfo'));
                    var headers = {};
                    if (tokenInfo != null) {
                        headers.Authorization = 'bearer ' + tokenInfo.access_token;
                    }

                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('#app');
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
                        type: "POST",
                        url: __WEBPACK_IMPORTED_MODULE_5__config___default.a.apiUrl + '/api/sku/import?projectId=' + vm.projectId,
                        contentType: false,
                        processData: false,
                        headers: headers,
                        data: data,
                        success: function success(resp) {
                            if (resp.hasError) {
                                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка импорта');
                            } else {
                                //console.info('resp', resp)
                                vm.importResult = resp.result;
                                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно импортировано');
                                vm.reload();
                            }
                            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
                        },
                        error: function error(xhr, status, p3) {
                            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error(xhr.responseText);
                            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
                        }
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Браузер не поддерживает загрузку файлов HTML5!');
                }
            }
        },
        onFileSkuLinkChange: function onFileSkuLinkChange() {
            var vm = this;

            var files = document.getElementById('dropFiles2').files;
            if (files.length > 0) {
                if (window.FormData !== undefined) {
                    var data = new FormData();
                    for (var x = 0; x < files.length; x++) {
                        data.append("file" + x, files[x]);
                    }

                    var tokenInfo = JSON.parse(localStorage.getItem('tokenInfo') == null ? sessionStorage.getItem('tokenInfo') : localStorage.getItem('tokenInfo'));
                    var headers = {};
                    if (tokenInfo != null) {
                        headers.Authorization = 'bearer ' + tokenInfo.access_token;
                    }

                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('#app');
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
                        type: "POST",
                        url: __WEBPACK_IMPORTED_MODULE_5__config___default.a.apiUrl + '/api/sku/importLink?projectId=' + vm.projectId,
                        contentType: false,
                        processData: false,
                        headers: headers,
                        data: data,
                        success: function success(resp) {
                            if (resp.hasError) {
                                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка импорта');
                            } else {
                                vm.importResult = resp.result;
                                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно импортировано');
                                vm.reload();
                            }
                            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
                            document.getElementById('dropFiles2').value = '';
                        },
                        error: function error(xhr, status, p3) {
                            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error(xhr.responseText);
                            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
                            document.getElementById('dropFiles2').value = '';
                        }
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Браузер не поддерживает загрузку файлов HTML5!');
                }
            }
        },
        onSaveSettings: function onSaveSettings() {
            var vm = this;
            var fields = Object.values(vm.skuSettings).filter(function (x) {
                return x.Edited;
            });
            if (fields.length > 0) {
                var _loop = function _loop(i) {
                    var qnt = Object.values(vm.skuSettings).filter(function (x) {
                        return !x.Edited && x.Title === fields[i].Title;
                    }).length;
                    if (qnt > 0) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Укажите другое название поля. Поле [' + fields[i].Title + '] уже используется');
                        return {
                            v: void 0
                        };
                    }
                };

                for (var i = 0; i < fields.length; i++) {
                    var _ret = _loop(i);

                    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
                }
            }

            this.callApiWrapper(backendApi.skuSettingsSave(vm.projectId, vm.skuSettings)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время сохранения настроек sku');
                } else {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');
                    vm.$refs.ppSkuFieldSettings.close();
                }
            });
        },
        reload: function reload() {
            var vm = this;

            this.clearFilterState();
            this.page = 1;
            this.loading = false;
            this.canBeLoaded = true;
            this.sku = [];
            this.lastGroupId = null;
            this.firstLoad = true;
            this.emptyResults = false;

            Promise.all([this.loadSettings(), this.loadGroups()]).then(function () {
                if (!vm.loading && vm.canBeLoaded) {
                    vm.loadNext();
                }
            });
        },


        onSearchChange: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce(function ($event) {
            //this.search = $event.target.value;
            this.reload();
        }, 500),

        onSearchClear: function onSearchClear() {
            this.search = null;
            this.reload();
        },
        loadNext: function loadNext() {
            var vm = this;
            this.loading = true;
            var folderId = vm.$route.query.folderId;
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.sku', 'Загрузка...');
            var skip = (vm.page - 1) * vm.rowsPerPage;
            var take = vm.rowsPerPage;
            if (vm.firstLoad && vm.page > 1) {
                skip = 0;
                take = vm.page * vm.rowsPerPage;
            }

            this.callApiWrapper(backendApi.skuList(skip, take, vm.projectId, vm.search, vm.active, folderId)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрзуки SKU');
                } else {
                    if (resp.data && resp.data.length) {
                        var _vm$sku;

                        var _loop2 = function _loop2(i) {
                            var item = resp.data[i];

                            if (item.Description) {
                                item.DescriptionFormatted = item.Description.replace(/\n/g, '<br>');
                            }
                            if (item.ImageStyle) {
                                item.ImageStyle = JSON.parse(item.ImageStyle);
                            }
                            if (!item.IsFolder) {
                                if (item.Group) {
                                    if (item.Group.Id !== vm.lastGroupId) {
                                        vm.lastGroupId = item.Group.Id;
                                        item.Group.Name = vm.groups.find(function (x) {
                                            return x.Id === item.Group.Id;
                                        }).Name;
                                    } else {
                                        item.Group.Name = null;
                                    }
                                } else {
                                    if (vm.lastGroupId == null && vm.groups.length) {
                                        vm.lastGroupId = 0;
                                        item.Group = { Id: 0, Name: 'Группа не выбрана' };
                                    }
                                }
                            }
                        };

                        for (var i = 0; i < resp.data.length; i++) {
                            _loop2(i);
                        }

                        (_vm$sku = vm.sku).push.apply(_vm$sku, _toConsumableArray(resp.data));

                        if (vm.firstLoad) {
                            vm.firstLoad = false;
                            if (vm.scrollTop) {
                                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').animate({ scrollTop: vm.scrollTop }, 500);
                            }
                        }
                    } else {
                        vm.canBeLoaded = false;
                        if (vm.search && !vm.sku.length) {
                            vm.emptyResults = true;
                        }
                    }
                }
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.sku');
                vm.loading = false;
            }).catch(function (err) {
                console.info('err', err);
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки');
            });
        },
        loadSettings: function loadSettings() {
            var vm = this;
            return this.callApiWrapper(backendApi.skuSettings(vm.projectId)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки настроек sku');
                } else {
                    if (resp.data) {

                        var dict = {};
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = resp.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var s = _step.value;

                                if (!dict[s.FieldName]) {
                                    dict[s.FieldName] = s;
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        vm.skuSettings = dict;
                    }
                }
            });
        },
        loadGroups: function loadGroups() {
            var vm = this;

            return this.callApiWrapper(backendApi.skuGroupList(vm.projectId)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки групп sku');
                } else {
                    if (resp.data) {
                        resp.data.forEach(function (r) {
                            r.Edited = false;
                            r.Selected = false;
                            r.OriginName = r.Name;
                        });

                        vm.groups = resp.data;
                        vm.groupsOrigin = JSON.parse(JSON.stringify(resp.data));
                    }
                }
            });
        },
        goToSku: function goToSku(id) {
            this.saveFilterState();
            this.$router.push('/sku/' + id);
        },
        goToFolder: function goToFolder(id) {
            this.saveFilterState();
            this.$router.push('/sku/?folderId=' + id);
        },
        onItemClick: function onItemClick(item) {
            if (item.IsFolder) {
                this.goToFolder(item.Id);
            } else {
                this.goToSku(item.Id);
            }
        },
        goToSkuEdit: function goToSkuEdit(id) {
            this.saveFilterState();
            this.$router.push('/sku/edit/' + id);
        },
        goToFolderEdit: function goToFolderEdit(id) {
            this.saveFilterState();
            this.$router.push('/sku/folder/edit/' + id);
        },
        onAddSku: function onAddSku() {
            this.$router.push('/sku/edit/0');
        },
        onAddFolder: function onAddFolder() {
            var folderId = this.$route.query.folderId;
            this.$router.push('/sku/folder/edit/0' + (folderId ? '?folderId=' + folderId : ''));
        },
        onProjectChange: function onProjectChange(item) {
            this.projectId = item.Id;
            if (this.$route.query.folderId) {
                this.$router.replace({ query: {} });
            }
            this.reload();
            this.$emit('user-updated');
        },
        onShowModal: function onShowModal(modal) {
            var _this = this;

            this.$nextTick(function () {
                _this.$refs[modal].show();
            });
        },
        onExport: function onExport() {
            var vm = this;
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('#app');
            vm.callApiWrapper(backendApi.skuExport(vm.projectId, vm.search ? vm.search : '', vm.active)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время экспорта');
                } else {
                    var exportFile = resp.data;
                    if (exportFile != null) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].downloadFileByBytes(exportFile, 'SKU.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                    }
                }
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            });
        },
        onSkuLinkExport: function onSkuLinkExport() {
            var vm = this;
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('#app');
            vm.callApiWrapper(backendApi.skuExportLink(vm.projectId, vm.search ? vm.search : '', vm.active)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время экспорта');
                } else {
                    var exportFile = resp.data;
                    if (exportFile != null) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].downloadFileByBytes(exportFile, 'Связи SKU.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                    }
                }
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            });
        },
        onAddNewGroup: function onAddNewGroup() {
            var vm = this;
            var maxOrder = 1;
            this.groups.forEach(function (r) {
                if (r.GroupOrder > maxOrder) {
                    maxOrder = r.GroupOrder;
                }
                r.Edited = false;
            });

            this.groups.push({
                Id: 0,
                Name: 'Новая группа',
                OriginName: 'Новая группа',
                ProjectId: vm.projectId,
                GroupOrder: ++maxOrder,
                Edited: true,
                Selected: true
            });
        },
        onDragStart: function onDragStart() {
            var vm = this;
            vm.$nextTick(function () {
                var marginLeft = -(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).width() - __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.popup-content').width()) / 2;
                var marginTop = -(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).height() - __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.popup-content').height()) / 2;
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.smooth-dnd-ghost').css({ 'margin-left': marginLeft + 'px', 'margin-top': marginTop + 'px' });
            });
        },
        onDrop: function onDrop(dropResult) {
            var vm = this;

            if (dropResult.removedIndex === dropResult.addedIndex) {
                return;
            }

            var rolesTemp = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(vm.groups, 'GroupOrder');
            var itemToAdd = void 0;
            if (dropResult.removedIndex != null) {
                itemToAdd = rolesTemp.splice(dropResult.removedIndex, 1)[0];
            }
            if (dropResult.addedIndex !== null) {
                rolesTemp.splice(dropResult.addedIndex, 0, itemToAdd);
            }

            var order = 1;
            rolesTemp.forEach(function (role) {
                role.GroupOrder = order++;
            });

            vm.groups = rolesTemp;

            //this.saveRoles(this.groups);
        },
        onGroupEdit: function onGroupEdit(role) {
            this.groups.forEach(function (r) {
                r.Edited = false;
            });
            role.Edited = true;
        },
        onGroupSelect: function onGroupSelect(role) {
            this.groups.forEach(function (r) {
                r.Selected = false;
            });
            role.Selected = true;
        },
        onRemoveGroup: function onRemoveGroup(role) {
            var vm = this;
            var indexRemove = void 0;
            for (var i = 0; i < vm.groups.length; i++) {
                if (vm.groups[i].GroupOrder === role.GroupOrder) {
                    indexRemove = i;
                    break;
                }
            }
            vm.groups.splice(indexRemove, 1);
        },
        onSaveGroup: function onSaveGroup(group) {
            if (group.Name) {
                group.Edited = false;
                group.OriginName = group.Name;
            }
        },
        saveGroups: function saveGroups() {
            var vm = this;

            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.portlet', 'Сохранение...');
            var saveObj = [];
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = vm.groups[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var g = _step2.value;

                    saveObj.push(Object.assign({}, g, {
                        //ProjectId: vm.$route.params.projectId
                    }));
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            backendApi.skuGroupsSave(vm.projectId, saveObj).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.portlet');
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении групп');
                } else {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');
                    vm.reload();
                }
            });
        },
        onGroupEditCancel: function onGroupEditCancel(group) {
            group.Edited = false;
            group.Name = group.OriginName;
        },
        onSkuSettingsDrop: function onSkuSettingsDrop(dropResult) {
            var vm = this;

            if (dropResult.removedIndex === dropResult.addedIndex) {
                return;
            }

            var rolesTemp = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(Object.values(vm.skuSettings), 'SettingsOrder');
            var itemToAdd = void 0;
            if (dropResult.removedIndex != null) {
                itemToAdd = rolesTemp.splice(dropResult.removedIndex, 1)[0];
            }
            if (dropResult.addedIndex !== null) {
                rolesTemp.splice(dropResult.addedIndex, 0, itemToAdd);
            }

            var order = 1;
            rolesTemp.forEach(function (role) {
                role.SettingsOrder = order++;

                vm.skuSettings[role.FieldName].SettingsOrder = role.SettingsOrder;
            });
        },
        onAddNewSettings: function onAddNewSettings() {
            var vm = this;
            var fields = Object.values(vm.skuSettings).filter(function (x) {
                return x.Edited;
            });
            if (fields.length > 0) {
                var _loop3 = function _loop3(i) {
                    var qnt = Object.values(vm.skuSettings).filter(function (x) {
                        return !x.Edited && x.Title === fields[i].Title;
                    }).length;
                    if (qnt > 0) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Укажите другое название поля. Поле [' + fields[i].Title + '] уже используется');
                        return {
                            v: void 0
                        };
                    }
                };

                for (var i = 0; i < fields.length; i++) {
                    var _ret3 = _loop3(i);

                    if ((typeof _ret3 === 'undefined' ? 'undefined' : _typeof(_ret3)) === "object") return _ret3.v;
                }
            }

            var maxOrder = 1;
            var customFieldName = void 0;
            var title = void 0;
            for (var prop in this.skuSettings) {
                var s = this.skuSettings[prop];
                if (s.SettingsOrder > maxOrder) {
                    maxOrder = s.SettingsOrder;
                }
                s.Edited = false;
            }
            var arrNames = Object.values(this.skuSettings).map(function (x) {
                return x.FieldName;
            });
            var arrTitles = Object.values(this.skuSettings).map(function (x) {
                return x.Title;
            });

            var _loop4 = function _loop4(i) {
                if (!arrNames.some(function (x) {
                    return x === 'CustomField' + i;
                })) {
                    customFieldName = 'CustomField' + i;
                    return 'break';
                }
            };

            for (var i = 1; i <= 50; i++) {
                var _ret4 = _loop4(i);

                if (_ret4 === 'break') break;
            }
            if (!arrTitles.some(function (x) {
                return x === 'Новое поле';
            })) {
                title = 'Новое поле';
            } else {
                var _loop5 = function _loop5(i) {
                    if (!arrTitles.some(function (x) {
                        return x === 'Новое поле' + i;
                    })) {
                        title = 'Новое поле' + i;
                        return 'break';
                    }
                };

                for (var i = 1; i <= 50; i++) {
                    var _ret5 = _loop5(i);

                    if (_ret5 === 'break') break;
                }
            }
            if (customFieldName) {
                this.$set(this.skuSettings, customFieldName, {
                    FieldName: customFieldName,
                    Title: title,
                    SettingsOrder: ++maxOrder,
                    Edited: true,
                    Selected: true,
                    ShowInList: false,
                    ShowInDetails: false
                });
            }
        },
        onSettingsOkBtn: function onSettingsOkBtn(skuSettingsItem) {
            var qnt = Object.values(this.skuSettings).filter(function (x) {
                return !x.Edited && x.Title === skuSettingsItem.Title;
            }).length;
            if (qnt > 0) {
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Укажите другое название поля. Поле [' + skuSettingsItem.Title + '] уже используется');
            } else {
                skuSettingsItem.Edited = false;
            }
        },
        onSettingsEditBtn: function onSettingsEditBtn(skuSettingsItem) {
            for (var prop in this.skuSettings) {
                this.$set(this.skuSettings[prop], 'Edited', false);
            }
            skuSettingsItem.Edited = true;
        },
        onSettingsRemoveBtn: function onSettingsRemoveBtn(skuSettingsItem) {
            this.$delete(this.skuSettings, skuSettingsItem.FieldName);
        },
        saveFilterState: function saveFilterState() {
            var stateObj = {
                projectId: this.projectId,
                search: this.search,
                active: this.active,
                folderId: this.$route.query.folderId,
                page: this.page,
                scrollTop: this.scrollTop
            };
            sessionStorage.setItem(cacheKey, JSON.stringify(stateObj));
            //console.info('saveFilterState -> stateObj:', stateObj);
        },
        recoverFilterState: function recoverFilterState() {
            var stateObj = JSON.parse(sessionStorage.getItem(cacheKey));
            //console.info('recoverFilterState -> stateObj:', stateObj);
            if (stateObj) {
                if ((stateObj.folderId == null || stateObj.folderId == this.$route.query.folderId) && stateObj.projectId == this.projectId) {
                    if (stateObj.search) {
                        this.search = stateObj.search;
                    }
                    this.active = stateObj.active;
                    if (stateObj.page) {
                        this.page = stateObj.page;
                    }
                    if (stateObj.scrollTop) {
                        this.scrollTop = stateObj.scrollTop;
                    }
                } else {
                    console.info('recoverFilterState -> wrong folderId (stateObj.folderId = ' + stateObj.folderId + ') or projectId (' + stateObj.projectId + ')');
                }
                this.clearFilterState();
            }
        },
        clearFilterState: function clearFilterState() {
            sessionStorage.removeItem(cacheKey);
        }
    },

    mounted: function mounted() {
        var vm = this;

        vm.recoverFilterState();

        Promise.all([this.loadSettings(), this.loadGroups()]).then(function () {
            vm.loadNext();
        });

        vm.$nextTick(function () {

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').on('scroll', function () {
                var elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
                var scrollTop = elem.scrollTop();
                vm.scrollTop = scrollTop;

                if (!vm.loading && vm.canBeLoaded && !vm.firstLoad) {
                    //console.info('elem[0].scrollHeight - elem.scrollTop(), elem.outerHeight()', [elem[0].scrollHeight] - elem.scrollTop(), elem.outerHeight());
                    if (elem[0].scrollHeight - scrollTop - 700 <= elem.outerHeight()) {
                        vm.page++;
                        vm.loadNext();
                    }
                }
            });
        });
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').off('scroll');
    }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_claims_checking_mixin__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cart__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_smooth_dnd__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__enums__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var backendApi = new __WEBPACK_IMPORTED_MODULE_2__backendApi__["a" /* default */]();
var cacheKey = 'rewardsState';

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "spend-bonuses",

    mixins: [__WEBPACK_IMPORTED_MODULE_3__helpers_project_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__helpers_claims_checking_mixin__["a" /* default */]],

    components: { Container: __WEBPACK_IMPORTED_MODULE_6_vue_smooth_dnd__["a" /* Container */], Draggable: __WEBPACK_IMPORTED_MODULE_6_vue_smooth_dnd__["b" /* Draggable */] },

    data: function data() {
        return {
            rewards: [],
            rewardTypes: [],
            rewardTypeId: 0,
            loading: false,
            canBeLoaded: true,
            page: 1,
            rowsPerPage: 25,
            active: true,
            projectId: null,
            search: null,
            groups: [],
            groupsOrigin: null,
            lastGroupId: null,
            scrollTop: null,
            firstLoad: true,
            project: null,

            selectedItem: null,

            manual: {
                sum: null
            },

            address: {
                list: [],
                addressId: null,
                data: {}
            },

            currencies: {
                1: { symbol: '₽', name: 'рублей', commissionText: 'Сумма в рублях с учетом комиссии:' }, // Россия
                2: { symbol: 'Br', name: 'белорусских рублей', commissionText: 'Сумма в белорусских рублях с учетом комиссии:' }, // Беларусь
                3: { symbol: '₸', name: 'тенге', commissionText: 'Сумма в тенге с учетом комиссии:' // Казахстан
                } }
        };
    },


    computed: {
        groupsOrdered: function groupsOrdered() {
            return __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.orderBy(this.groups, 'GroupOrder');
        },
        groupsChanged: function groupsChanged() {
            return !__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.some(this.groups, { Edited: true }) && JSON.stringify(this.groups) !== JSON.stringify(this.groupsOrigin);
        },
        totalManualSumWithComission: function totalManualSumWithComission() {
            var vm = this;

            var selectedSum = parseFloat(vm.manual.sum);
            if (!isNaN(selectedSum)) {
                if (vm.selectedItem.ManualNominalPercent > 0) {
                    var totalSumm = selectedSum * (100 - vm.selectedItem.ManualNominalPercent) / 100;
                    if (vm.selectedItem.RewardType === __WEBPACK_IMPORTED_MODULE_7__enums__["l" /* RewardTypes */].ElectronicGiftCard && vm.selectedItem.OzonCertificate) {
                        totalSumm = Math.round(totalSumm);
                    }
                    return totalSumm;
                } else {
                    return selectedSum;
                }
            }
            return null;
        }
    },

    watch: {
        '$route.query.folderId': function $routeQueryFolderId(to, from) {
            this.reload();
        }
    },

    methods: {
        getCommissionText: function getCommissionText() {
            if (!this.project || !this.project.CountryId) {
                return 'Сумма с учетом комиссии:';
            }
            var currency = __WEBPACK_IMPORTED_MODULE_7__enums__["c" /* CurrencyDetails */][this.project.CountryId];
            return currency.commissionText;
        },
        onShowGroupsModal: function onShowGroupsModal() {
            var vm = this;
            vm.$refs['ppGroups'].show();
        },
        onDragStart: function onDragStart() {
            var vm = this;
            vm.$nextTick(function () {
                var marginLeft = -(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).width() - __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.popup-content').width()) / 2;
                var marginTop = -(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).height() - __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.popup-content').height()) / 2;
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.smooth-dnd-ghost').css({ 'margin-left': marginLeft + 'px', 'margin-top': marginTop + 'px' });
            });
        },
        onRewardTypeChange: function onRewardTypeChange(typeId) {
            this.rewardTypeId = typeId;
            if (this.$route.query.folderId) {
                this.$router.push(this.$route.path);
            } else {
                this.reload();
            }
        },
        onAddressChange: function onAddressChange(address) {
            this.address.data = address;
        },
        loadAddresses: function loadAddresses() {
            var vm = this;
            this.callApiWrapper(backendApi.orderAddressList()).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки адресов');
                } else {
                    var addressId = 0;
                    if (resp.data.length) {
                        addressId = resp.data[resp.data.length - 1].Id;
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = resp.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var addr = _step.value;

                                addr.DisplayName = addr.Fio + ' - ' + addr.FullAddress;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }

                    vm.address.addressId = addressId;
                    vm.address.list = [{ Id: 0, DisplayName: 'Новый адрес', PhoneNumber: vm.info.User.PhoneNumber, Fio: vm.info.User.Fio, FullAddress: null }].concat(_toConsumableArray(resp.data));
                    vm.address.data = Object.assign({}, resp.data.find(function (x) {
                        return x.Id === addressId;
                    }));
                }
            });
        },
        onGetRewardWithAddress: function onGetRewardWithAddress() {
            var _this = this;

            var vm = this;
            this.$validator.validateAll('address').then(function (result) {
                if (!result) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                } else {
                    var selectedAddress = vm.address.list.find(function (x) {
                        return x.Id === vm.address.addressId;
                    });
                    var needToSave = selectedAddress.Id === 0;
                    if (!needToSave) {
                        // проверяем что адрес не был изменён
                        console.info('[selectedAddress.FullAddress, vm.address.data.FullAddress]', [selectedAddress.FullAddress, vm.address.data.FullAddress]);
                        if (selectedAddress.Fio !== vm.address.data.Fio || selectedAddress.PhoneNumber !== vm.address.data.PhoneNumber || selectedAddress.FullAddress !== vm.address.data.FullAddress) {
                            needToSave = true;
                        }
                    } else if (__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.some(vm.address.list, function (x) {
                        return x.Id > 0 && x.FullAddress === vm.address.data.FullAddress;
                    })) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Указанный адрес уже имеется в списке');
                        return;
                    }

                    if (needToSave) {
                        _this.callApiWrapper(backendApi.orderNewAddress(vm.address.data.Fio, vm.address.data.PhoneNumber, vm.address.data.FullAddress)).then(function (resp) {
                            if (resp.hasError && resp.status !== 401) {
                                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время сохранения адреса');
                            } else {
                                if (vm.address.list.filter(function (x) {
                                    return x.Id === resp.data.Id;
                                }).length == 0) {
                                    vm.address.list.push(resp.data);
                                }

                                __WEBPACK_IMPORTED_MODULE_5__cart__["a" /* default */].addItem(vm.selectedItem.Id, vm.selectedItem.Prices[0].Id, vm.selectedItem.RewardType, null, resp.data.Id);
                                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.success('Добавлено в корзину');
                                vm.$emit('need-refresh-cart');
                                vm.$refs['ppAddress'].close();
                            }
                        });
                    } else {
                        __WEBPACK_IMPORTED_MODULE_5__cart__["a" /* default */].addItem(vm.selectedItem.Id, vm.selectedItem.Prices[0].Id, vm.selectedItem.RewardType, null, selectedAddress.Id);
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.success('Добавлено в корзину');
                        _this.$emit('need-refresh-cart');
                        vm.$refs['ppAddress'].close();
                    }
                }
            });
        },
        onShowManualNominalModal: function onShowManualNominalModal(item) {
            var vm = this;

            vm.selectedItem = item;
            vm.manual.sum = vm.$refs['ppManualNominal'].show();
        },
        onManualNominalAdd: function onManualNominalAdd() {
            var _this2 = this;

            var vm = this;
            this.$validator.validateAll('manual').then(function (result) {
                if (!result) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                } else {
                    var selectedSum = parseFloat(vm.manual.sum);
                    // Установка значений по умолчанию
                    var min = vm.selectedItem.ManualNominalMin !== null ? vm.selectedItem.ManualNominalMin : 100;
                    var max = vm.selectedItem.ManualNominalMax !== null ? vm.selectedItem.ManualNominalMax : 10000;
                    var step = vm.selectedItem.ManualNominalStep !== null ? vm.selectedItem.ManualNominalStep : 100;

                    // Проверка минимального значения
                    if (selectedSum < min) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Минимально возможная сумма - ' + min);
                        return;
                    }

                    // Проверка максимального значения
                    if (selectedSum > max) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Максимально возможная сумма - ' + max);
                        return;
                    }

                    // Проверка кратности шагу
                    var remainder = selectedSum % step;
                    if (remainder !== 0) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('\u0421\u0443\u043C\u043C\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u043A\u0440\u0430\u0442\u043D\u043E\u0439 \u0448\u0430\u0433\u0443 - ' + step);
                        return;
                    }
                    if (vm.info.User.ActiveBalance < selectedSum) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Максимально возможная сумма - ' + vm.info.User.ActiveBalance);
                        return;
                    }
                    if (vm.selectedItem.RewardType === __WEBPACK_IMPORTED_MODULE_7__enums__["l" /* RewardTypes */].ElectronicGiftCard && vm.selectedItem.OzonCertificate) {
                        var totalSumm = vm.totalManualSumWithComission;
                        if (vm.selectedItem.ManualNominalPercent > 99) {
                            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Минимально возможная сумма - 100000');
                            return;
                        } else if (totalSumm < 100) {
                            var summ = totalSumm * 100 / (100 - vm.selectedItem.ManualNominalPercent) + 1;
                            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Минимально возможная сумма - ' + Math.round(summ));
                            return;
                        }
                    }
                    __WEBPACK_IMPORTED_MODULE_5__cart__["a" /* default */].addItem(vm.selectedItem.Id, 0, vm.selectedItem.RewardType, selectedSum);
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.success('Добавлено в корзину');
                    _this2.$emit('need-refresh-cart');
                    vm.$refs['ppManualNominal'].close();
                }
            });
        },
        getRewardTypeName: function getRewardTypeName(type) {
            switch (type) {
                case __WEBPACK_IMPORTED_MODULE_7__enums__["l" /* RewardTypes */].ElectronicGiftCard:
                    return 'Электронный сертификат';
                case __WEBPACK_IMPORTED_MODULE_7__enums__["l" /* RewardTypes */].PrepaidBankCard:
                    return 'Предоплаченная карта';
                case __WEBPACK_IMPORTED_MODULE_7__enums__["l" /* RewardTypes */].PhysicalBankCard:
                    return 'Выплата на карту';
                case __WEBPACK_IMPORTED_MODULE_7__enums__["l" /* RewardTypes */].PhysicalPrize:
                    return 'Физические призы';
                default:
                    return '';
            }
        },
        getImageStyleFormatted: function getImageStyleFormatted(imageStyle) {
            if (!imageStyle) {
                return null;
            }

            var settings = {
                left: imageStyle.left + '%',
                top: imageStyle.top + '%',
                transform: 'translateY(' + imageStyle.translateY + '%) translateX(' + imageStyle.translateX + '%)'
            };
            if (imageStyle.resizeType === 1 && parseInt(imageStyle.size)) {
                settings.height = imageStyle.size + '%';
            }
            if (imageStyle.resizeType === 2 && parseInt(imageStyle.size)) {
                settings.width = imageStyle.size + '%';
            }

            return settings;
        },
        getFormattedPriceDescription: function getFormattedPriceDescription(priceItem) {
            if (!this.project || !this.project.CountryId) {
                return this.formatInt(priceItem.Price) + ' \u0431\u0430\u043B\u043B\u043E\u0432';
            }
            var currency = __WEBPACK_IMPORTED_MODULE_7__enums__["c" /* CurrencyDetails */][this.project.CountryId];
            var priceDescription = this.formatInt(priceItem.Price) + ' \u0431\u0430\u043B\u043B\u043E\u0432';

            if (priceItem.Nominal) {
                priceDescription = this.formatInt(priceItem.Nominal) + ' ' + currency.symbol + ' \u0437\u0430 ' + priceDescription;
            }

            return priceDescription;
        },
        getPriceItemsForDropdown: function getPriceItemsForDropdown(item) {
            var vm = this;

            var mapped = item.Prices.map(function (x) {
                return { Id: x.Id, RewardId: x.RewardId, Name: vm.getFormattedPriceDescription(x) };
            });
            //if ((item.RewardType === RewardTypes.PhysicalBankCard || item.RewardType === RewardTypes.ElectronicGiftCard && item.OzonCertificate)
            if (item.RewardType !== __WEBPACK_IMPORTED_MODULE_7__enums__["l" /* RewardTypes */].PhysicalPrize && item.ManualNominalPercent != null) {
                mapped.push({
                    Id: -1, RewardId: item.RewardId, Name: 'Внести вручную'
                });
            }
            return [].concat(_toConsumableArray(mapped));
        },
        onPriceChange: function onPriceChange(item, rewardItem) {
            var prices = rewardItem.Prices,
                rewardType = rewardItem.RewardType;

            if (item.Id > 0) {
                var price = void 0;
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = prices[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var itemPrice = _step2.value;

                        if (itemPrice.Id === item.Id) {
                            price = itemPrice.Price;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                if (price > this.info.User.onlyActiveBalance) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Недостаточно средств на балансе');
                } else {
                    __WEBPACK_IMPORTED_MODULE_5__cart__["a" /* default */].addItem(item.RewardId, item.Id, rewardType);

                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.success('Добавлено в корзину');

                    this.$emit('need-refresh-cart');
                }
                //} else if (item.Id === -1 && (rewardType === RewardTypes.PhysicalBankCard || rewardType === RewardTypes.ElectronicGiftCard && rewardItem.OzonCertificate)){
            } else if (item.Id === -1 && rewardType !== __WEBPACK_IMPORTED_MODULE_7__enums__["l" /* RewardTypes */].PhysicalPrize) {
                this.onShowManualNominalModal(rewardItem);
            }
        },
        getReward: function getReward(rewardId, priceId, rewardType) {
            var vm = this;
            if (rewardType === __WEBPACK_IMPORTED_MODULE_7__enums__["l" /* RewardTypes */].PhysicalPrize) {

                this.selectedItem = this.rewards.find(function (x) {
                    return x.Id === rewardId;
                });
                this.$refs['ppAddress'].show();
                this.loadAddresses();
                this.$nextTick(function () {

                    var suggestView = new ymaps.SuggestView('addressFullAddress', { results: 8 });
                    suggestView.state.events.add('change', function () {
                        var activeIndex = suggestView.state.get('activeIndex');
                        if (typeof activeIndex == 'number') {
                            var activeItem = suggestView.state.get('items')[activeIndex];
                            if (activeItem) {
                                vm.address.data.FullAddress = activeItem.value;
                            }
                        }
                    });
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_5__cart__["a" /* default */].addItem(rewardId, priceId, rewardType);
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.success('Добавлено в корзину');
                this.$emit('need-refresh-cart');
            }
        },


        // onInputAddress: _.debounce(function(){
        //     console.info('onInputAddress, this.address.data.FullAddress:', this.address.data.FullAddress)
        //     ymaps.suggest(this.address.data.FullAddress).then(function (items) {
        //         // items - массив поисковых подсказок.
        //         console.info('items:', items);
        //     });
        // }, 300),

        loadNext: function loadNext() {
            var vm = this;

            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
            var skip = (vm.page - 1) * vm.rowsPerPage;
            var take = vm.rowsPerPage;
            if (vm.firstLoad && vm.page > 1) {
                skip = 0;
                take = vm.page * vm.rowsPerPage;
            }

            vm.loading = true;
            var onlyActive = true;
            var folderId = vm.$route.query.folderId;
            if (vm.info.User.MainRole === 'administrators') {
                onlyActive = false;
            }
            this.callApiWrapper(backendApi.rewardsAggregateList(skip, take, vm.projectId, vm.search, onlyActive, folderId, vm.rewardTypeId, vm.active)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки вознаграждений');
                } else {
                    if (resp.data.list && resp.data.list.length) {
                        var _vm$rewards;

                        var _loop = function _loop(item) {
                            if (item.ImageStyle) {
                                item.ImageStyle = JSON.parse(item.ImageStyle);
                            }
                            if (item.Description) {
                                item.DescriptionFormatted = item.Description.replace(/\n/g, '<br>');
                            }
                            if (!item.IsFolder) {
                                if (item.Group) {
                                    if (item.Group.Id !== vm.lastGroupId) {
                                        vm.lastGroupId = item.Group.Id;
                                        item.Group.Name = vm.groups.find(function (x) {
                                            return x.Id === item.Group.Id;
                                        }).Name;
                                    } else {
                                        item.Group.Name = null;
                                    }
                                } else {
                                    if (vm.lastGroupId == null && vm.groups.length) {
                                        vm.lastGroupId = 0;
                                        item.Group = { Id: 0, Name: 'Группа не выбрана' };
                                    }
                                }
                            }
                        };

                        var _iteratorNormalCompletion3 = true;
                        var _didIteratorError3 = false;
                        var _iteratorError3 = undefined;

                        try {
                            for (var _iterator3 = resp.data.list[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                var item = _step3.value;

                                _loop(item);
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }
                            } finally {
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }

                        (_vm$rewards = vm.rewards).push.apply(_vm$rewards, _toConsumableArray(resp.data.list));

                        if (vm.firstLoad) {
                            vm.firstLoad = false;
                            if (vm.scrollTop) {
                                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').animate({ scrollTop: vm.scrollTop }, 500);
                            }
                        }
                    } else {
                        vm.canBeLoaded = false;
                    }
                    vm.rewardTypes = resp.data.rewardTypes;
                }
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                vm.loading = false;
            });
        },
        goToFolder: function goToFolder(id) {
            this.saveFilterState();
            this.$router.push('/spend-bonuses/?folderId=' + id);
        },
        onItemClick: function onItemClick(item) {
            if (item.IsFolder) {
                this.saveFilterState();
                this.$router.push('/spend-bonuses/?folderId=' + item.Id);
            }
        },
        editReward: function editReward(item) {
            this.saveFilterState();
            if (item.IsFolder) {
                this.$router.push('/rewards/folder/edit/' + item.Id);
            } else {
                this.$router.push('/rewards/edit/' + item.Id);
            }
        },
        goToProfile: function goToProfile(id) {
            this.$router.push('/profile');
        },
        onAddReward: function onAddReward() {
            this.saveFilterState();
            this.$router.push('/rewards/edit/0');
        },
        onAddFolder: function onAddFolder() {
            this.saveFilterState();
            var folderId = this.$route.query.folderId;
            this.$router.push('/rewards/folder/edit/0' + (folderId ? '?folderId=' + folderId : ''));
        },
        reload: function reload() {
            var vm = this;

            vm.page = 1;
            vm.rewards = [];
            vm.groups = [];
            vm.groupsOrigin = null;
            vm.canBeLoaded = true;
            vm.lastGroupId = null;
            vm.scrollTop = null;
            vm.firstLoad = true;

            vm.recoverFilterState();
            vm.loadGroups().then(function () {
                if (!vm.loading && vm.canBeLoaded) {
                    vm.loadNext();
                }
            });
        },


        onSearchChange: __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.debounce(function () {
            this.reload();
        }, 500),

        onSearchClear: function onSearchClear() {
            this.search = null;
            this.reload();
        },
        onProjectChange: function onProjectChange(item) {
            if (this.$route.query.folderId) {
                this.$router.replace({ query: {} });
            }
            this.projectId = item.Id;
            this.clearFilterState();

            this.reload();
            this.$emit('user-updated');
        },
        loadGroups: function loadGroups() {
            var vm = this;

            return this.callApiWrapper(backendApi.rewardGroupList(vm.projectId)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки групп');
                } else {
                    if (resp.data) {
                        resp.data.forEach(function (r) {
                            r.Edited = false;
                            r.Selected = false;
                            r.OriginName = r.Name;
                        });

                        vm.groups = resp.data;
                        vm.groupsOrigin = JSON.parse(JSON.stringify(resp.data));
                    }
                }
            });
        },
        loadProject: function loadProject() {
            var vm = this;

            return this.callApiWrapper(backendApi.projectLoad(vm.projectId)).then(function (resp) {
                if (resp.data) {
                    vm.project = resp.data;
                }
            });
        },
        onAddNewGroup: function onAddNewGroup() {
            var vm = this;
            var maxOrder = 1;
            this.groups.forEach(function (r) {
                if (r.GroupOrder > maxOrder) {
                    maxOrder = r.GroupOrder;
                }
                r.Edited = false;
            });

            this.groups.push({ Id: 0,
                Name: 'Новая группа',
                OriginName: 'Новая группа',
                ProjectId: vm.projectId,
                GroupOrder: ++maxOrder,
                Edited: true,
                Selected: true
            });
        },
        onDrop: function onDrop(dropResult) {
            var vm = this;

            if (dropResult.removedIndex === dropResult.addedIndex) {
                return;
            }

            var rolesTemp = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.orderBy(vm.groups, 'GroupOrder');
            var itemToAdd = void 0;
            if (dropResult.removedIndex != null) {
                itemToAdd = rolesTemp.splice(dropResult.removedIndex, 1)[0];
            }
            if (dropResult.addedIndex !== null) {
                rolesTemp.splice(dropResult.addedIndex, 0, itemToAdd);
            }

            var order = 1;
            rolesTemp.forEach(function (role) {
                role.GroupOrder = order++;
            });

            vm.groups = rolesTemp;

            //this.saveRoles(this.groups);
        },
        onGroupEdit: function onGroupEdit(role) {
            // if(_.some(this.groups, {Edited: true})){
            //     return;
            // }

            this.groups.forEach(function (r) {
                r.Edited = false;
            });
            role.Edited = true;
        },
        onGroupSelect: function onGroupSelect(role) {
            this.groups.forEach(function (r) {
                r.Selected = false;
            });
            role.Selected = true;
        },
        onRemoveGroup: function onRemoveGroup(role, index) {
            var vm = this;
            var indexRemove = void 0;
            for (var i = 0; i < vm.groups.length; i++) {
                if (vm.groups[i].GroupOrder === role.GroupOrder) {
                    indexRemove = i;
                    break;
                }
            }
            vm.groups.splice(indexRemove, 1);
        },
        onSaveGroup: function onSaveGroup(group) {
            if (group.Name) {
                group.Edited = false;
                group.OriginName = group.Name;
            }
        },
        saveGroups: function saveGroups() {
            var vm = this;

            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.portlet', 'Сохранение...');
            var saveObj = [];
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = vm.groups[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var g = _step4.value;

                    saveObj.push(Object.assign({}, g, {
                        //ProjectId: vm.$route.params.projectId
                    }));
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            backendApi.rewardsGroupsSave(vm.projectId, saveObj).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.portlet');
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении групп');
                } else {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');
                    vm.reload();
                    vm.closeModal('ppGroups');
                }
            });
        },
        onGroupEditCancel: function onGroupEditCancel(group) {
            group.Edited = false;
            group.Name = group.OriginName;
        },
        saveFilterState: function saveFilterState() {
            var stateObj = {
                projectId: this.projectId,
                search: this.search,
                folderId: this.$route.query.folderId,
                page: this.page,
                scrollTop: this.scrollTop,
                active: this.active
            };
            sessionStorage.setItem(cacheKey, JSON.stringify(stateObj));
        },
        recoverFilterState: function recoverFilterState() {
            var stateObj = JSON.parse(sessionStorage.getItem(cacheKey));
            if (stateObj) {
                if ((stateObj.folderId || 0) === (this.$route.query.folderId || 0) && stateObj.projectId == this.projectId) {
                    if (stateObj.search) {
                        this.search = stateObj.search;
                    }
                    if (stateObj.page) {
                        this.page = stateObj.page;
                    }
                    if (stateObj.scrollTop) {
                        this.scrollTop = stateObj.scrollTop;
                    }
                    if (stateObj.active != undefined) {
                        this.active = stateObj.active;
                    }
                    this.clearFilterState();
                } else {
                    sessionStorage.removeItem(cacheKey);
                }
            }
        },
        clearFilterState: function clearFilterState() {
            sessionStorage.removeItem(cacheKey);
        },
        onExport: function onExport() {
            var vm = this;
            var folderId = vm.$route.query.folderId;

            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('#app');
            vm.callApiWrapper(backendApi.rewardsExport(folderId, vm.search, vm.active, vm.rewardTypeId)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время экспорта вознаграждений');
                } else {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].downloadFileByBytes(resp.data, 'Вознаграждения.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                }

                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            });
        }
    },

    mounted: function mounted() {
        var vm = this;

        vm.recoverFilterState();

        Promise.all([vm.loadGroups(), vm.loadProject()]).then(function () {
            vm.loadNext();
            console.info('info.User.PaymentSettings', vm.info.User.PaymentSettings);
        });

        vm.$nextTick(function () {

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').on('scroll', function () {
                var elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
                var scrollTop = elem.scrollTop();
                vm.scrollTop = scrollTop;
                if (!vm.loading && vm.canBeLoaded) {
                    if (elem[0].scrollHeight - scrollTop - 200 <= elem.outerHeight()) {
                        vm.page++;
                        vm.loadNext();
                    }
                }
            });
        });
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').off('scroll');
    }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(79);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var backendApi = new __WEBPACK_IMPORTED_MODULE_2__backendApi__["a" /* default */]();

var rowsPerPage = 50;
/* harmony default export */ __webpack_exports__["a"] = ({
    name: "trade-points",

    mixins: [__WEBPACK_IMPORTED_MODULE_6__helpers_project_mixin__["a" /* default */]],

    data: function data() {
        return {
            tradePoints: [],
            loading: false,
            canBeLoaded: true,
            page: 1,
            tradePointsFilters: [{
                Value: 'Name', Name: 'Название'
            }, {
                Value: 'Region', Name: 'Регион'
            }, {
                Value: 'Area', Name: 'Область'
            }, {
                Value: 'City', Name: 'Город'
            }, {
                Value: 'Address', Name: 'Адрес'
            }],
            filter: null,
            roles: [],
            users: [],
            importResult: null,
            bonusSettings: null,
            ReportSettings: null,

            selectedTradepoint: null,
            selectedTradepointIndex: null,
            tradepointRolesGrouped: [],
            originData: null
        };
    },


    computed: {
        linkingEnabled: function linkingEnabled() {
            if (this.ReportSettings) {
                return this.ReportSettings.filter(function (x) {
                    return x.type === 'sku' && !x.deleted;
                }).length > 0;
            } else {
                return false;
            }
        }
    },

    methods: {
        getGroupedRoles: function getGroupedRoles(roles) {
            var groupedRoles = [];
            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.each(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.groupBy(roles, 'RoleId'), function (v) {
                groupedRoles.push({
                    RoleName: v[0].RoleName,
                    Users: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(v, function (x) {
                        return x.UserFio && !x.Disabled;
                    }), function (x) {
                        return x.UserFio;
                    })
                });
            });
            return groupedRoles;
        },
        tradepointEditShow: function tradepointEditShow(tt, index) {
            var vm = this;

            vm.selectedTradepoint = tt;
            vm.selectedTradepointIndex = index;
            vm.originData = JSON.parse(JSON.stringify(tt));

            vm.tradepointRolesGrouped = [];
            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.each(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.groupBy(vm.selectedTradepoint.Roles, 'RoleId'), function (v) {
                // не показываем при редактировании роли с полным доступом к тт
                if (!v[0].TtAccess) {
                    vm.tradepointRolesGrouped.push(v);
                }
            });

            vm.$nextTick(function () {
                vm.$refs['ppTradepointEdit'].show();
            });
        },
        onAddUser: function onAddUser(roles, role) {
            roles.push({
                RoleId: role.RoleId,
                RoleName: role.RoleName,
                UserId: null,
                UserFio: null,
                ControlUniqueId: Math.random().toString(36).substr(2, 9)
            });
        },
        onRemoveUser: function onRemoveUser(roles, index, rolesIndex) {
            if (roles.length === 1) {
                roles.splice(index, 1, {
                    RoleId: roles[0].Id,
                    RoleName: roles[0].Name,
                    ControlUniqueId: Math.random().toString(36).substr(2, 9)
                });
            } else {
                roles.splice(index, 1);
                this.$set(this.selectedTradepoint, roles, rolesIndex);
            }
        },
        onDisableUser: function onDisableUser(roles, index, rolesIndex) {
            roles[index].Disabled = roles[index].Disabled !== true;
            /*this.$set(roles, roles[index], index);
            this.$set(this.tradepointRolesGrouped, roles, rolesIndex);*/
        },
        onFileChange: function onFileChange() {
            var vm = this;

            var files = document.getElementById('dropFiles').files;
            if (files.length > 0) {
                if (window.FormData !== undefined) {
                    var data = new FormData();
                    for (var x = 0; x < files.length; x++) {
                        data.append("file" + x, files[x]);
                    }
                    var tokenInfo = JSON.parse(localStorage.getItem('tokenInfo') == null ? sessionStorage.getItem('tokenInfo') : localStorage.getItem('tokenInfo'));
                    vm.importResult = null;
                    var projectId = this.$route.params.projectId;
                    var headers = {};
                    if (tokenInfo != null) {
                        headers.Authorization = 'bearer ' + tokenInfo.access_token;
                    }

                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('#app');
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
                        type: "POST",
                        url: __WEBPACK_IMPORTED_MODULE_5__config___default.a.apiUrl + '/api/tradepoints/import?projectId=' + projectId,
                        contentType: false,
                        processData: false,
                        headers: headers,
                        data: data,
                        success: function success(resp) {
                            if (resp.hasError) {
                                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка импорта');
                            } else {
                                console.info('resp', resp);
                                vm.importResult = resp.result.data;
                                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно импортировано');
                                vm.page = 1;
                                vm.tradePoints = [];
                                vm.loadNext();
                            }
                            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
                        },
                        error: function error(xhr, status, p3) {
                            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error(xhr.responseText);
                            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
                        }
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Браузер не поддерживает загрузку файлов HTML5!');
                }
            }
        },
        tradePointUserChange: function tradePointUserChange(user, role) {
            if (user != null) {
                role.UserFio = user.Name;
                role.UserId = user.Id;
            } else {
                this.unselectRoleUser(role);
            }
        },
        searchUserFunction: function searchUserFunction(searchText, callback, extra) {
            var vm = this;

            vm.callApiWrapper(backendApi.userSearch(0, 50, vm.$route.params.projectId, extra, searchText)).then(function (resp) {
                // уже назначенные на роли пользователи
                var users = [];
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = vm.tradepointRolesGrouped[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var roleGroup = _step.value;

                        users = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.concat(users, __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(roleGroup, function (role) {
                            return role.UserId;
                        }));
                    }

                    // убираем таких пользователей из выдачи
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                var filteredData = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(resp.data, function (item) {
                    return !__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.includes(users, item.Id);
                });

                // console.info('users:', JSON.stringify(users));
                // console.info('resp.data', JSON.stringify(resp.data));
                // console.info('filteredData:', JSON.stringify(filteredData));
                callback(filteredData);
            });
        },
        unselectRoleUser: function unselectRoleUser(role) {
            role.UserId = null;
            role.UserFio = null;
        },
        getFilterValue: function getFilterValue(role) {
            if (!role.UserId) {
                return null;
            } else {
                return {
                    Id: role.UserId,
                    Name: role.UserFio
                };
            }
        },
        onChangeDate: function onChangeDate(item, formatted, raw) {
            item[raw] = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(item[formatted], 'DD.MM.YYYY').format();
        },
        onAddItem: function onAddItem() {
            var vm = this;

            var editedItem = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(vm.tradePoints, { Edited: true });
            if (editedItem) {
                return;
            }

            var roles = [];
            for (var r = 0; r < vm.roles.length; r++) {
                if (!vm.roles[r].Claims.find(function (x) {
                    return x.ClaimId === vm.claimEnums.ttAccess;
                })) {
                    roles.push({
                        RoleId: vm.roles[r].Id,
                        RoleName: vm.roles[r].Name
                    });
                }
            }

            vm.tradePoints.splice(0, 0, {
                Id: 0,
                Edited: true,
                Roles: roles
            });
        },
        onRemoveItem: function onRemoveItem(item, index) {
            var vm = this;
            if (item.Id > 0) {
                backendApi.tradePointDelete(item.Id).then(function (response) {
                    //console.info('onRemoveItem -> response', response)
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.portlet');
                    if (response.hasError) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при удалении торговой точки');
                    } else {
                        vm.tradePoints.splice(index, 1);
                    }
                });
            } else {
                vm.tradePoints.splice(index, 1);
            }
        },
        loadNext: function loadNext() {
            var vm = this;

            var projectId = this.$route.params.projectId;

            vm.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
            return this.callApiWrapper(backendApi.tradePointList((this.page - 1) * rowsPerPage, rowsPerPage, projectId, vm.filter)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки торговых точек');
                } else {
                    if (resp.data && resp.data.length) {
                        var _vm$tradePoints;

                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = resp.data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var item = _step2.value;

                                item.Edited = false;

                                if (item.Roles == null) {
                                    item.Roles = [];
                                }

                                var _loop = function _loop(r) {

                                    //if(!vm.roles[r].Claims.find(x => x.ClaimId === vm.claimEnums.ttAccess)) {

                                    // не исключаем из показа роли с полным доступом к тт
                                    var ttAccess = vm.roles[r].Claims.find(function (x) {
                                        return x.ClaimId === vm.claimEnums.ttAccess;
                                    }) ? true : false;
                                    var pointRoles = item.Roles.filter(function (i) {
                                        return i.RoleId === vm.roles[r].Id;
                                    });
                                    if (!pointRoles.length && !ttAccess) {
                                        item.Roles.splice(r, 0, {
                                            RoleId: vm.roles[r].Id,
                                            RoleName: vm.roles[r].Name,
                                            ControlUniqueId: 0,
                                            TtAccess: ttAccess
                                        });
                                    } else if (pointRoles.length) {
                                        __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.each(pointRoles, function (pointRole, index) {
                                            pointRole.RoleName = vm.roles[r].Name;
                                            pointRole.ControlUniqueId = index;
                                            pointRole.TtAccess = ttAccess;
                                        });
                                    }
                                    //}
                                };

                                for (var r = 0; r < vm.roles.length; r++) {
                                    _loop(r);
                                }
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }

                        (_vm$tradePoints = vm.tradePoints).push.apply(_vm$tradePoints, _toConsumableArray(resp.data));
                    } else {
                        vm.canBeLoaded = false;
                    }
                }
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                vm.loading = false;
            });
        },
        loadRoles: function loadRoles() {
            var vm = this;
            return this.callApiWrapper(backendApi.rolesList(vm.$route.params.projectId)).then(function (resp) {
                if (resp.data) {

                    vm.roles = resp.data.Roles;

                    for (var r = 0; r < vm.roles.length; r++) {
                        if (!vm.roles[r].Claims.find(function (x) {
                            return x.ClaimId === vm.claimEnums.ttAccess;
                        })) {

                            vm.tradePointsFilters.push({
                                Value: 'TradePointRole_' + vm.roles[r].Id,
                                Name: vm.roles[r].Name
                            });
                        }
                    }
                }
            });
        },
        loadBonusSettings: function loadBonusSettings() {
            var vm = this;
            return this.callApiWrapper(backendApi.projectLoad(vm.$route.params.projectId)).then(function (resp) {
                if (resp.data) {
                    var rsData = JSON.parse(resp.data.ReportSettings || '[]');
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = rsData[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var item = _step3.value;

                            if (typeof item.deleted === 'undefined') {
                                item.deleted = false;
                            }
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }

                    vm.ReportSettings = rsData;

                    vm.bonusSettings = JSON.parse(resp.data.BonusSettings || '[]');
                }
            });
        },
        loadUsers: function loadUsers() {
            var vm = this;
            return vm.callApiWrapper(backendApi.usersList(0, 100, vm.$route.params.projectId)).then(function (resp) {
                if (resp.data && resp.data.length) {
                    vm.users = resp.data;
                }
            });
        },
        saveItem: function saveItem(item) {
            var vm = this;

            return vm.$validator.validate().then(function (result) {
                if (!result) {
                    return false;
                } else {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.portlet', 'Сохранение...');

                    var projectId = vm.$route.params.projectId;

                    var saveObj = Object.assign({}, item, {
                        ProjectId: projectId
                    });

                    var roles = [];
                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                        for (var _iterator4 = vm.tradepointRolesGrouped[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                            var roleGroup = _step4.value;

                            roles = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.concat(roles, __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(roleGroup, function (role) {
                                return {
                                    RoleId: role.RoleId,
                                    UserId: role.UserId,
                                    UserFio: role.UserFio,
                                    RoleName: role.RoleName,
                                    Disabled: role.Disabled
                                };
                            }));
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }
                        } finally {
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }

                    saveObj.Roles = roles;
                    if (saveObj.Latitude != null && (saveObj.Latitude + '').length > 0) {
                        saveObj.Latitude = (saveObj.Latitude + '').replace(',', '.');
                        if (saveObj.Longitude == null || (saveObj.Longitude + '').length === 0) {
                            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Долгота обязательна при заполненной Широте');
                            return;
                        }
                    }
                    if (saveObj.Longitude != null && (saveObj.Longitude + '').length > 0) {
                        saveObj.Longitude = (saveObj.Longitude + '').replace(',', '.');
                        if (saveObj.Latitude == null || (saveObj.Latitude + '').length === 0) {
                            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Широта обязательна при заполненной Долготе');
                            return;
                        }
                    }

                    console.info('saveObj:', JSON.stringify(saveObj));

                    backendApi.tradePointSave(saveObj).then(function (response) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.portlet');
                        if (response.hasError) {
                            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении торговой точки');
                        } else {
                            // todo: перезагружать конкретную запись

                            if (item.Id === 0) {
                                item.Id = response.data;
                            }
                            item.Roles = roles;
                            item.Edited = false;
                            vm.closeModal('ppTradepointEdit');
                        }
                    });
                }
            });
        },
        onCancel: function onCancel() {
            this.closeModal('ppTradepointEdit');
            this.selectedTradepoint = Object.assign({}, this.originData);
            this.$set(this.tradePoints, this.selectedTradepointIndex, this.selectedTradepoint);
        },
        onItemClick: function onItemClick(item, index) {
            var vm = this;
            vm.tradepointEditShow(item, index);
        },
        onFilterChange: function onFilterChange(filter) {
            this.filter = filter;
            this.tradePoints = [];
            this.loading = false;
            this.canBeLoaded = true;
            this.page = 1;
            this.loadNext();
        },
        searchFunction: function searchFunction(tableName, columnName, search, filters, searchPage, callback) {
            var filterFormatted = '';
            if (filters) {
                filterFormatted = filters.map(function (x) {
                    return JSON.stringify(x);
                });
            }
            this.callApiWrapper(backendApi.tradePointDistinctValues(columnName, this.$route.params.projectId, search, filterFormatted, (searchPage - 1) * 30, 30)).then(function (resp) {
                callback(resp.data);
            });
        },
        onExport: function onExport() {
            var vm = this;
            var projectId = vm.$route.params.projectId;

            var filterstr = [];
            if (this.filter) {
                for (var i = 0; i < this.filter.length; i++) {
                    var item = this.filter[i];
                    filterstr.push(JSON.stringify(item));
                }
            }

            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('#app');
            vm.callApiWrapper(backendApi.tradePointExport(projectId, filterstr)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время экспорта');
                } else {
                    var exportFile = resp.data;
                    if (exportFile != null) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].downloadFileByBytes(exportFile, 'Торговые точки.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                    }
                }
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            });
        },
        getFilterForUri: function getFilterForUri() {
            var str = '';
            if (this.filter) {
                for (var i = 0; i < this.filter.length; i++) {
                    var item = this.filter[i];
                    str += '&filter[' + i + ']=' + encodeURIComponent(JSON.stringify(item));
                }
            }
            return str;
        }
    },

    mounted: function mounted() {
        var vm = this;

        Promise.all([this.loadRoles(), this.loadBonusSettings()]).then(function () {
            vm.loadNext();
        });
        this.loadUsers();

        vm.$nextTick(function () {

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').on('scroll', function () {
                if (!vm.loading && vm.canBeLoaded) {
                    var elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
                    if (elem[0].scrollHeight - elem.scrollTop() - 200 <= elem.outerHeight()) {
                        vm.page++;
                        vm.loadNext();
                    }
                }
            });
        });
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').off('scroll');
    }
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_cropper_dist_cropper__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_cropper_dist_cropper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__node_modules_cropper_dist_cropper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__node_modules_cropper_dist_cropper_css__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__node_modules_cropper_dist_cropper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__node_modules_cropper_dist_cropper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__enums__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var backendApi = new __WEBPACK_IMPORTED_MODULE_1__backendApi__["a" /* default */]();

var localizedFields = {
    'FirstName': 'Имя',
    'LastName': 'Фамилия',
    'Email': 'Email',
    'PhoneNumber': 'Телефон',
    'BirthDateFormatted': 'Дата рождения',
    'Sex': 'Пол',

    'PassportSeries': 'Серия паспорта',
    'PassportNumber': 'Номер паспорта',
    'PassportIssuedBy': 'Кем выдан',
    'PassportIssuedCode': 'Номер подразделения',
    'PassportIssuedDateFormatted': 'Дата выдачи',
    'PassportRegistrationAddress': 'Адрес регистрации',
    'Inn': 'ИНН'
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "profile",

    props: ['info'],

    data: function data() {
        return {
            profile: null,
            uploadedFile: null,
            genders: [{ Value: false, Name: 'Женский' }, { Value: true, Name: 'Мужской' }],
            tabs: {
                active: 'info'
            },
            documentTypes: [{ Id: 1, Name: 'Паспорт гражданина Российской Федерации' }, { Id: 2, Name: 'Паспорт иностранного гражданина' }, { Id: 3, Name: 'Вид на жительство' }],
            birthDateCompleted: false,
            external: [],
            password: {
                oldPassword: null,
                newPassword: null,
                newPasswordConfirm: null,
                error: null
            },
            VerificationStates: __WEBPACK_IMPORTED_MODULE_7__enums__["t" /* VerificationStates */]
        };
    },


    computed: {
        errorMessage: function errorMessage() {
            var _this = this;

            if (this.tabs.active === 'docs') {
                if (!this.profile.BirthDateFormatted && this.profile.Sex === '') {
                    return { message: '\u0412\u043D\u0435\u0441\u0438\u0442\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0432 \u043F\u043E\u043B\u044F \xAB\u0414\u0430\u0442\u0430 \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F\xBB \u0438 \xAB\u041F\u043E\u043B\xBB, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \xAB\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C\xBB,\n                    \u043F\u043E\u0441\u043B\u0435 \u0447\u0435\u0433\u043E \u0431\u0443\u0434\u0435\u0442 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0432\u043D\u0435\u0441\u0442\u0438 \u0434\u0430\u043D\u043D\u044B\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432', type: 'birthdate' };
                }
                if (!this.profile.BirthDateFormatted && this.profile.Sex !== '') {
                    return {
                        message: '\u041F\u043E\u043B\u044F \xAB\u0414\u0430\u043D\u043D\u044B\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432\xBB \u0441\u0442\u0430\u043D\u0443\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u043F\u043E\u0441\u043B\u0435 \u0432\u043D\u0435\u0441\u0435\u043D\u0438\u044F \u0434\u0430\u043D\u043D\u044B\u0445 \u0432 \u043F\u043E\u043B\u0435 \xAB\u0414\u0430\u0442\u0430 \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F\xBB \u043D\u0430 \u0432\u043A\u043B\u0430\u0434\u043A\u0435 \xAB\u041E\u0441\u043D\u043E\u0432\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435\xBB', type: 'birthdate' };
                }
                if (this.profile.BirthDateFormatted && this.profile.Sex === '') {
                    return { message: '\u041F\u043E\u043B\u044F \xAB\u0414\u0430\u043D\u043D\u044B\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432\xBB \u0441\u0442\u0430\u043D\u0443\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u043F\u043E\u0441\u043B\u0435 \u0432\u043D\u0435\u0441\u0435\u043D\u0438\u044F \u0434\u0430\u043D\u043D\u044B\u0445 \u0432 \u043F\u043E\u043B\u0435 \xAB\u041F\u043E\u043B\xBB \u043D\u0430 \u0432\u043A\u043B\u0430\u0434\u043A\u0435 \xAB\u041E\u0441\u043D\u043E\u0432\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435\xBB', type: 'birthdate' };
                }
                if (this.profile.BirthDateFormatted && this.profile.Sex !== '' && !this.birthDateCompleted) {
                    return { message: '\u043D\u0430\u0436\u043C\u0438\u0442\u0435 \xAB\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C\xBB \u043D\u0430 \u0432\u043A\u043B\u0430\u0434\u043A\u0435 \xAB\u041E\u0441\u043D\u043E\u0432\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435\xBB', type: 'birthdate' };
                }
            }

            if (this.errors.items.length) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = this.errors.items.filter(function (x) {
                        return x.scope === _this.tabs.active;
                    })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var error = _step.value;

                        if (localizedFields[error.field]) {
                            if (error.rule === 'regex') {
                                return { message: '\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u0430\u0442 \u0434\u0430\u043D\u043D\u044B\u0445 \u0432 \u043F\u043E\u043B\u0435 \xAB' + localizedFields[error.field] + '\xBB', type: 'field' };
                            }
                            if (error.rule === 'required') {
                                return { message: '\u0417\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u043F\u043E\u043B\u0435 \xAB' + localizedFields[error.field] + '\xBB', type: 'field' };
                            }
                            if (error.rule === 'email') {
                                return { message: '\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0432\u0432\u0435\u0434\u0451\u043D\u043D\u044B\u0439 \u0430\u0434\u0440\u0435\u0441 \u0432 \u043F\u043E\u043B\u0435 \xAB' + localizedFields[error.field] + '\xBB', type: 'field' };
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            if (this.tabs.active === 'docs' && this.passportFieldsRequired && this.profile.Images.length < 2) {
                return { message: 'Загрузите не менее двух фотографий документов', type: 'images' };
            }

            if (this.tabs.active === 'card') {
                //проверка убрана по запросу https://trello.com/c/QWnpnwFf
                //if(this.profile.PassportVerificationState !== 2){
                //    return { message: 'Требуется заполнить раздел «Документы»', type: 'card' };
                //}
            }

            return null;
        },
        passportFieldsRequired: function passportFieldsRequired() {
            //let passportFields = this.passportFields;
            return this.info.User && this.hasClaims(this.info.User.DynamicRole, this.claimEnums.bonusSpend) && (this.profile.PassportIssuedCountry != null && this.profile.PassportIssuedCountry !== '' || this.profile.PassportSeries != null && this.profile.PassportSeries !== '' || this.profile.PassportNumber != null && this.profile.PassportNumber !== '' || this.profile.PassportIssuedCode != null && this.profile.PassportIssuedCode !== '' || this.profile.PassportIssuedDateFormatted != null && this.profile.PassportIssuedDateFormatted !== '' || this.profile.PassportIssuedBy != null && this.profile.PassportIssuedBy !== '' || this.profile.Inn != null && this.profile.Inn !== '' || this.profile.Images.length !== 0);
        },
        dropFiles2Required: function dropFiles2Required() {
            return this.passportFieldsRequired && !this.profile.Images.length;
        },
        passportFields: function passportFields() {
            switch (this.profile.DocumentType) {
                case 2:
                    // паспорт ин. гражданина
                    return {
                        PassportIssuedCountry: true,
                        PassportSeries: false,
                        PassportNumber: true,
                        PassportIssuedBy: true,
                        PassportIssuedCode: false,
                        PassportIssuedDateFormatted: true,
                        PassportRegistrationAddress: true,
                        Inn: true,
                        dropFilesText: 'Прикрепите фотографию основного разворота паспорта, вида на жительство (при наличии), разрешения на временное проживание (при наличии), действующей прописки и ИНН'
                    };
                case 3:
                    // вид на жительство
                    return {
                        PassportIssuedCountry: false,
                        PassportSeries: true, //false,
                        PassportNumber: true,
                        PassportIssuedBy: true,
                        PassportIssuedCode: false,
                        PassportIssuedDateFormatted: true,
                        PassportRegistrationAddress: true,
                        Inn: true,
                        dropFilesText: 'Прикрепите фотографию основного разворота паспорта, вида на жительство (при наличии), разрешения на временное проживание (при наличии), действующей прописки и ИНН'
                    };
                default:
                    return {
                        PassportIssuedCountry: false,
                        PassportSeries: true,
                        PassportNumber: true,
                        PassportIssuedBy: true,
                        PassportIssuedCode: true,
                        PassportIssuedDateFormatted: true,
                        PassportRegistrationAddress: true,
                        Inn: true,
                        dropFilesText: 'Прикрепите фотографию второго разворота паспорта, разворота паспорта с действующей пропиской и ИНН.'
                    };
            }
        },
        PassportSeriesMask: function PassportSeriesMask() {
            return this.profile.DocumentType === 1 ? '## ##' : '##';
        },
        PassportSeriesMaxLength: function PassportSeriesMaxLength() {
            if (this.passportFieldsRequired && this.passportFields.PassportSeries) {
                return this.profile.DocumentType === 1 ? 4 : 2;
            } else {
                return false;
            }
        },
        PassportNumberMaxLength: function PassportNumberMaxLength() {
            if (this.passportFieldsRequired && this.passportFields.PassportNumber && this.profile.DocumentType !== 2) {
                return this.profile.DocumentType === 3 ? 7 : 6;
            } else {
                return false;
            }
        }
    },

    methods: {
        onBankBikChanged: __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.debounce(function () {
            var vm = this;
            vm.callApiWrapper(backendApi.getBankNameByBik(vm.profile.PaymentSettings.BankBik)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    //UI.toastr.error('Ошибка во время загрузки');
                } else {
                    if (resp.data) {
                        vm.profile.PaymentSettings.BankName = resp.data;
                    }
                }
            });
        }, 500),

        onNewPasswordChange: function onNewPasswordChange() {
            this.password.error = null;

            if (!this.password.newPassword || !this.password.newPassword.trim()) {
                this.password.regexError = null;
            } else {
                var newpass = this.password.newPassword;

                if (newpass.length < 6) {
                    this.password.regexError = 'Введите минимум 6 символов';
                } else if (!/(?=.*\d).*\D.*/ig.test(newpass)) {
                    this.password.regexError = 'Обязательно наличие и букв и цифр';
                } else if (!/(?=.*[A-ZА-Я]).*[a-zа-я].*/g.test(newpass)) {
                    this.password.regexError = 'Обязательно наличие заглавной и прописной буквы';
                } else {
                    this.password.regexError = null;
                }
            }
        },
        fileExtensionIsHtml: function fileExtensionIsHtml(filename) {
            return filename.endsWith('.html');
        },
        changePassword: function changePassword() {
            var _this2 = this;

            var vm = this;

            this.$validator.validateAll('changingPassword').then(function (result) {
                if (!result || vm.password.regexError) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                } else {
                    vm.password.error = null;
                    _this2.callApiWrapper(backendApi.userChangePassword(vm.password.oldPassword, vm.password.newPassword)).then(function (resp) {
                        if (resp.hasError) {
                            if (resp.status === 6) {
                                vm.password.error = 'Введён неверный пароль';
                            } else {
                                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при смене пароля');
                            }
                        } else {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Пароль изменён');

                            vm.$nextTick(function () {
                                vm.$refs['ppChangePassword'].close();
                            });
                        }
                    });
                }
            });
        },
        onExternalRemove: function onExternalRemove(externalItem) {
            if (confirm('Вы уверены что хотите удалить привязку к ' + externalItem.providerName)) {
                this.callApiWrapper(backendApi.removeExternalLogin(externalItem.providerName)).then(function (resp) {
                    if (resp.hasError && resp.status !== 401) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время удаления привязки');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Привязка к ' + externalItem.providerName + ' удалена');
                        externalItem.data = null;
                    }
                });
            }
        },
        loadData: function loadData() {
            var vm = this;
            return this.callApiWrapper(backendApi.profileLoad()).then(function (resp) {
                //console.info('resp', resp)
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки');
                } else {
                    if (resp.data) {
                        var obj = Object.assign(resp.data, { FileName: null, DeleteImage: false });
                        if (obj.BirthDate) {
                            obj.BirthDateFormatted = vm.formatDate(obj.BirthDate);
                        }
                        if (obj.PassportIssuedDate) {
                            obj.PassportIssuedDateFormatted = vm.formatDate(obj.PassportIssuedDate);
                        }

                        vm.birthDateCompleted = (obj.BirthDate ? true : false) && obj.Sex !== null;

                        var _loop = function _loop(login) {
                            var externalItem = vm.external.find(function (x) {
                                return x.providerName === login.ProviderName;
                            });
                            if (externalItem) {
                                externalItem.data = login;
                            }
                        };

                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = obj.ExternalLogins[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var login = _step2.value;

                                _loop(login);
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }

                        vm.profile = obj;

                        if (vm.$route.query.tabs === 'docs' && vm.info.User && vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.bonusSpend)) {
                            vm.tabs.active = 'docs';
                            vm.$validator.validateAll('docs');
                        } else if (vm.$route.query.tabs === 'card' && vm.profile.ProjectsHavePhysicalBankCardReward && vm.info.User && vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.bonusSpend)) {
                            vm.tabs.active = 'card';
                            vm.$validator.validateAll('card');
                        }
                    }
                }
            });
        },
        saveData: function saveData() {
            var vm = this;

            var saveObj = Object.assign({}, vm.profile);
            for (var prop in saveObj) {
                if (saveObj[prop] === '') {
                    saveObj[prop] = null;
                }
            }

            this.$validator.validateAll(this.tabs.active).then(function (result) {
                //console.info('result', result)
                if (!result) {
                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                } else {
                    // доп. проверки
                    if (vm.tabs.active === 'docs' && vm.passportFieldsRequired && vm.profile.Images.length < 2) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Загрузите не менее двух фотографий документов');
                        return;
                    }

                    __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Сохранение...');

                    var defferedAction = void 0;
                    var timeZone = new Date().getTimezoneOffset();
                    if (vm.tabs.active === 'info') {
                        defferedAction = backendApi.profileSaveInfo(saveObj);
                    } else if (vm.tabs.active === 'docs') {
                        defferedAction = backendApi.profileSaveDocs(saveObj);
                    } else {
                        defferedAction = backendApi.profileSaveCard(saveObj.PaymentSettings);
                    }
                    defferedAction.then(function (response) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                        if (response.hasError) {
                            if (response.status === 8) {
                                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Такой email уже используется');
                            } else {
                                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении Профиля');
                            }
                        } else {
                            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');

                            vm.$emit('user-updated');

                            vm.birthDateCompleted = true;

                            // todo: загрузка blockUI
                            vm.loadData();
                        }
                    });
                }
            });
        },


        // onTermsClick() {
        //     this.$refs.ppTerms.show();
        // },

        closeAvatarModal: function closeAvatarModal() {
            this.$refs.ppAvatar.close();
        },
        onCloseAvatarModal: function onCloseAvatarModal() {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[name="dropFiles"]').val('');
        },
        onSaveAvatarModal: function onSaveAvatarModal() {
            var vm = this;

            vm.profile.DeleteImage = false;
            vm.profile.FileName = vm.uploadedFile.FileName;
            vm.profile.FileData = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sourceImage').cropper('getCroppedCanvas').toDataURL('image/jpeg');
            vm.$refs.ppAvatar.close();
        },
        removeImage: function removeImage() {
            this.profile.DeleteImage = true;
            this.profile.FileName = null;
            this.profile.FileData = null;
            this.profile.Image = null;
        },
        removeDocument: function removeDocument(i) {
            if (confirm('Удалить файл?')) {
                this.profile.Images.splice(i, 1);
                this.$refs.dropFiles2.value = '';
            }
        },
        onChangeDate: function onChangeDate(item, formatted, raw) {
            item[raw] = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(item[formatted], 'DD.MM.YYYY').format();
        },
        onShowRulesClick: function onShowRulesClick() {
            var vm = this;
            vm.$refs.ppRules.show();
            vm.$nextTick(function () {
                if (vm.$refs.pdfViewRules) vm.$refs.pdfViewRules.show(__WEBPACK_IMPORTED_MODULE_6__config___default.a.apiUrl + vm.info.RulesFile);
            });
        },
        onShowPolicyClick: function onShowPolicyClick() {
            var vm = this;

            vm.$refs.ppPolicy.show();
            vm.$nextTick(function () {
                if (vm.$refs.pdfViewPolicy) vm.$refs.pdfViewPolicy.show(__WEBPACK_IMPORTED_MODULE_6__config___default.a.apiUrl + vm.info.PolicyFile);
            });
        }
    },

    mounted: function mounted() {
        var vm = this;
        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
        this.loadData().then(function (response) {
            __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('change', '[name="dropFiles"]', function () {
                if (this.files && this.files[0]) {
                    if (this.files[0].type !== 'image/jpeg' && this.files[0].type !== 'image/png') {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Неверный тип. Выберите другой файл');
                        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[name="dropFiles"]').val('');
                    } else if (this.files[0].size > 5 * 1024 * 1024) {
                        __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Превышен размер. Выберите другой файл');
                        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[name="dropFiles"]').val('');
                    } else {
                        vm.uploadedFile = { FileName: this.files[0].name, FileData: null };
                        var reader = new FileReader();
                        reader.onload = function (e) {
                            vm.uploadedFile.FileData = e.target.result;

                            vm.$nextTick(function () {
                                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sourceImage').cropper({
                                    aspectRatio: 1
                                });
                            });

                            vm.$refs.ppAvatar.show();
                        };
                        reader.readAsDataURL(this.files[0]);
                    }
                }
            });

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('change', '[name="dropFiles2"]', function () {
                if (this.files && this.files.length) {
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = this.files[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var file = _step3.value;

                            if (this.files[0].type !== 'image/jpeg' && this.files[0].type !== 'image/png') {
                                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Неверный тип. Выберите другой файл');
                                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[name="dropFiles"]').val('');
                            } else if (file.size > 50 * 1024 * 1024) {
                                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Превышен размер. Выберите другой файл');
                                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[name="dropFiles2"]').val('');
                            } else {
                                (function () {
                                    var img = { FileName: file.name, FileData: null, Delete: false };
                                    var reader = new FileReader();
                                    reader.onload = function (e) {
                                        img.FileData = e.target.result;

                                        vm.profile.Images.push(img);
                                    };
                                    reader.readAsDataURL(file);
                                })();
                            }
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                }
            });
        });

        var baseHost = location.origin;
        if (baseHost.indexOf('localhost') > -1 && __WEBPACK_IMPORTED_MODULE_6__config___default.a.apiUrl) {
            baseHost = __WEBPACK_IMPORTED_MODULE_6__config___default.a.apiUrl;
        }
        var redirectUri = baseHost + '/AttachCallback/?provider=%provider%&returnUrl=' + encodeURI(location.href);

        if (vm.info.ExternalVk) {
            vm.external.push({ providerName: 'Vk', data: null });
        }
        if (vm.info.ExternalGoogle) {
            vm.external.push({ providerName: 'Google', data: null });
        }
        //if (vm.info.ExternalFacebook) {
        //    vm.external.push({providerName: 'Facebook', data: null});
        //}
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
            for (var _iterator4 = vm.external[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var item = _step4.value;

                switch (item.providerName) {
                    case 'Vk':
                        item.attachLink = "https://oauth.vk.com/authorize" + "?client_id=" + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_6__config___default.a.vkAppId) + "&redirect_uri=" + encodeURIComponent(redirectUri.replace('%provider%', 'vk')) + "&scope=" + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_6__config___default.a.vkAppScopes) + "&response_type=code" + "&v=" + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_6__config___default.a.vkVersion);
                        break;
                    case 'Google':
                        item.attachLink = "https://accounts.google.com/o/oauth2/auth" + "?client_id=" + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_6__config___default.a.googleAppId) + "&redirect_uri=" + encodeURIComponent(redirectUri.replace('%provider%', 'google')) + "&access_type=offline&prompt=consent" + "&scope=" + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_6__config___default.a.googleAppScopes) + "&response_type=code";
                        break;
                    //case 'Facebook':
                    //    item.attachLink =
                    //        "https://www.facebook.com/dialog/oauth" +
                    //        "?client_id=" + encodeURIComponent(config.facebookAppId) +
                    //        "&redirect_uri=" + encodeURIComponent(`${baseHost}/AttachCallback/?provider=facebook`) +
                    //        "&scope=" + encodeURIComponent(config.facebookAppScopes) +
                    //        "&response_type=code";
                    //    break;
                }
            }
        } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                }
            } finally {
                if (_didIteratorError4) {
                    throw _iteratorError4;
                }
            }
        }
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('change', '[name="dropFiles"]');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('change', '[name="dropFiles2"]');
    }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_smooth_dnd__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_project_mixin__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var backendApi = new __WEBPACK_IMPORTED_MODULE_2__backendApi__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "roles",

    mixins: [__WEBPACK_IMPORTED_MODULE_5__helpers_project_mixin__["a" /* default */]], // projectId

    components: { Container: __WEBPACK_IMPORTED_MODULE_0_vue_smooth_dnd__["a" /* Container */], Draggable: __WEBPACK_IMPORTED_MODULE_0_vue_smooth_dnd__["b" /* Draggable */] },

    data: function data() {
        return {
            project: null,
            roles: [],
            claims: [],
            pages: [{ Path: '', Name: 'Выбрать' }, { Path: '/projects', Name: 'Проекты' }, { Path: '/news', Name: 'Новости' }, { Path: '/materials', Name: 'Материалы' }, { Path: '/reports', Name: 'Отчёты' }, { Path: '/rating', Name: 'Рейтинг' }, { Path: '/spend-bonuses', Name: 'Потратить бонусы' }, { Path: '/analytics', Name: 'Аналитика' }, { Path: '/sku', Name: 'SKU' }, { Path: '/motivation', Name: 'Программа мотивации' }, { Path: '/faq', Name: 'Faq' }, { Path: '/my-progress', Name: 'Мои достижения' }],
            tradePointFields: [{ Id: '', Name: 'Без ограничений' }, { Id: '[Name]', Name: 'Наименование' }, { Id: '[Region]', Name: 'Область' }, { Id: '[City]', Name: 'Город' }, { Id: '[ExternalId]', Name: 'Внешний идентификатор' }, { Id: '[SkuLink]', Name: 'Связь sku' }]
        };
    },


    computed: {
        isTasksControllerSelected: function isTasksControllerSelected() {
            var _this = this;

            return this.roleSelected && this.roleSelected.Claims.some(function (claim) {
                return claim.ClaimId === _this.claimEnums.tasksController;
            });
        },


        rolesOrdered: function rolesOrdered() {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.orderBy(this.roles, 'Order');
        },

        roleSelected: function roleSelected() {
            var selected = this.roles.filter(function (r) {
                return r.Selected;
            });
            return selected.length ? selected[0] : null;
        },

        mainPageSettingsClaim: function mainPageSettingsClaim() {
            var _this2 = this;

            return this.claims.find(function (x) {
                return x.Id === _this2.claimEnums.mainPageSettings;
            });
        },
        isRatingSelected: function isRatingSelected() {
            var _this3 = this;

            var selectedRole = this.roleSelected;
            if (selectedRole != null) {
                return selectedRole.Claims.find(function (x) {
                    return x.ClaimId === _this3.claimEnums.ratingPage;
                }) != null;
            }
            return false;
        }
    },

    methods: {
        bindClaim: function bindClaim(claim, roleClaim) {
            return {
                ClaimId: claim.Id,
                Value: roleClaim ? roleClaim.Value : null
            };
        },
        getRoleClaim: function getRoleClaim(role, claimId) {
            return role.Claims.find(function (val) {
                return val.ClaimId === claimId;
            });
        },
        load: function load() {
            var vm = this;
            __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
            this.callApiWrapper(backendApi.rolesList(vm.$route.params.projectId)).then(function (resp) {
                __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки ролей');
                } else {
                    if (resp.data) {
                        resp.data.Roles.forEach(function (r) {
                            r.Edited = false;
                            r.Selected = false;

                            var mainPageSettingsClaim = r.Claims.find(function (val) {
                                return val.ClaimId === vm.claimEnums.mainPageSettings;
                            });
                            if (mainPageSettingsClaim === undefined) {
                                r.Claims.push({
                                    ClaimId: vm.claimEnums.mainPageSettings,
                                    Value: null
                                });
                            }
                            if (r.RatingSettings == null) {
                                r.RatingSettings = {};
                            }
                        });

                        vm.roles = resp.data.Roles;
                        vm.claims = resp.data.Claims;
                        // [{DynamicRoleId: 5, TradePointField: '[City]', PageSize: 10}];//resp.data.ratingSettings;
                    }
                }
            });
        },
        loadProject: function loadProject() {
            var vm = this;
            var id = parseInt(vm.$route.params.projectId);
            return backendApi.projectLoad(id).then(function (response) {
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке проекта');
                } else {
                    var data = response.data;
                    vm.project = data;
                }
            });
        },
        saveRole: function saveRole(role) {
            var vm = this;

            __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].blockUI('.portlet', 'Сохранение...');
            var saveObj = Object.assign({}, role, {
                ProjectId: vm.$route.params.projectId
            });

            this.callApiWrapper(backendApi.rolesSave(saveObj)).then(function (response) {
                //console.info('rolesSave -> response', response);
                __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('.portlet');
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении роли');
                } else {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');
                    //console.info('response.data', response.data)

                    role.Id = response.data;
                }
            });
        },
        saveRoles: function saveRoles(roles) {
            var vm = this;

            __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].blockUI('.portlet', 'Сохранение...');
            var saveObj = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = roles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var role = _step.value;

                    saveObj.push(Object.assign({}, role, {
                        ProjectId: vm.$route.params.projectId
                    }));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            backendApi.rolesSaveList(saveObj).then(function (response) {
                //console.info('rolesSave -> response', response);
                __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('.portlet');
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении роли');
                } else {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');
                }
            });
        },
        removeRole: function removeRole(role, index) {
            var vm = this;
            if (role.Id > 0) {
                __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].blockUI('.portlet', 'Удаление...');

                backendApi.rolesDelete(role.Id).then(function (response) {
                    //console.info('rolesSave -> response', response);
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('.portlet');
                    if (response.hasError) {
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при удалении роли');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно удалено');
                    }

                    var indexRemove = void 0;
                    for (var i = 0; i < vm.roles.length; i++) {
                        if (vm.roles[i].Order === role.Order) {
                            indexRemove = i;
                            break;
                        }
                    }
                    vm.roles.splice(indexRemove, 1);
                });
            } else {
                var indexRemove = void 0;
                for (var i = 0; i < vm.roles.length; i++) {
                    if (vm.roles[i].Order === role.Order) {
                        indexRemove = i;
                        break;
                    }
                }
                vm.roles.splice(indexRemove, 1);
            }
        },
        onNameChange: function onNameChange(role) {
            this.saveRole(role);
        },


        onClaimChange: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (role, claim) {
            var _this4 = this;

            if (claim !== undefined) {

                // проверяем чтобы одна роль не могла иметь права на добавление и проверку отчёта
                if (claim.Id === this.claimEnums.reportAdd) {
                    for (var i = 0; i < role.Claims.length; i++) {
                        if (role.Claims[i].ClaimId === this.claimEnums.reportCheck) {
                            role.Claims.splice(i, 1);
                            break;
                        }
                    }
                } else if (claim.Id === this.claimEnums.reportCheck) {
                    for (var _i = 0; _i < role.Claims.length; _i++) {
                        if (role.Claims[_i].ClaimId === this.claimEnums.reportAdd) {
                            role.Claims.splice(_i, 1);
                            break;
                        }
                    }
                }

                if (claim.Id === this.claimEnums.mainPageSettings) {
                    for (var _i2 = 0; _i2 < role.Claims.length; _i2++) {
                        if (role.Claims[_i2].ClaimId === this.claimEnums.mainPageSettings && role.Claims[_i2] === '') {
                            role.Claims.splice(_i2, 1);
                            break;
                        }
                    }
                }

                if (claim.Id === this.claimEnums.ttAccess || claim.Id === this.claimEnums.tasksEdit) {
                    var i_ttAccess = -1;
                    var i_taskEdit = -1;
                    for (var _i3 = 0; _i3 < role.Claims.length; _i3++) {
                        if (role.Claims[_i3].ClaimId === this.claimEnums.ttAccess) i_ttAccess = _i3;
                        if (role.Claims[_i3].ClaimId === this.claimEnums.tasksEdit) i_taskEdit = _i3;
                    }
                    if (i_ttAccess < 0 && i_taskEdit > -1) role.Claims.splice(i_taskEdit, 1);
                }

                // Новая проверка
                if (claim.Id === this.claimEnums.tasksController) {
                    if (!role.Claims.some(function (c) {
                        return c.ClaimId === _this4.claimEnums.tasksController;
                    })) {
                        // Если "Контролер заданий" отключен, то отключаем "Уведомление о новых ответах"
                        for (var _i4 = 0; _i4 < role.Claims.length; _i4++) {
                            if (role.Claims[_i4].ClaimId === this.claimEnums.newRepliesNotification) {
                                role.Claims.splice(_i4, 1);
                                break;
                            }
                        }
                    }
                }
            }

            this.saveRole(role);
        }, 800),

        onRoleEdit: function onRoleEdit(role) {
            this.roles.forEach(function (r) {
                r.Edited = false;
            });
            role.Edited = true;
        },
        onRoleSelect: function onRoleSelect(role) {
            this.roles.forEach(function (r) {
                r.Selected = false;
            });
            role.Selected = true;
        },
        addNew: function addNew() {
            var vm = this;
            var maxOrder = 1;
            this.roles.forEach(function (r) {
                if (r.Order > maxOrder) {
                    maxOrder = r.Order;
                }
                r.Edited = false;
            });

            this.roles.push({ Id: 0,
                Name: 'Новая роль',
                ProjectId: vm.projectId,
                Order: ++maxOrder,
                Edited: true,
                Selected: true,
                Claims: [],
                RatingSettings: {}
            });
        },
        onDrop: function onDrop(dropResult) {
            var vm = this;

            if (dropResult.removedIndex === dropResult.addedIndex) {
                return;
            }

            var rolesTemp = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.orderBy(vm.roles, 'Order');
            var itemToAdd = void 0;
            if (dropResult.removedIndex != null) {
                itemToAdd = rolesTemp.splice(dropResult.removedIndex, 1)[0];
            }
            if (dropResult.addedIndex !== null) {
                rolesTemp.splice(dropResult.addedIndex, 0, itemToAdd);
            }

            var order = 1;
            rolesTemp.forEach(function (role) {
                role.Order = order++;
            });

            vm.roles = rolesTemp;

            this.saveRoles(this.roles);
        }
    },

    mounted: function mounted() {
        var vm = this;

        Promise.all([vm.loadProject(), vm.load()]);

        vm.$nextTick(function () {

            __WEBPACK_IMPORTED_MODULE_3_jquery___default()('body').on('click', function () {
                vm.roles.forEach(function (role) {
                    role.Edited = false;
                });
            });
        });
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()('body').off('click');
    }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cart__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enums__ = __webpack_require__(19);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var backendApi = new __WEBPACK_IMPORTED_MODULE_1__backendApi__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "cart",

    props: ['info'],

    mixins: [__WEBPACK_IMPORTED_MODULE_2__helpers_project_mixin__["a" /* default */]],

    data: function data() {
        return {
            cartItems: [],
            rewards: [],
            orders: [],
            isMobile: __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].check_mobile(),
            orderProcessing: false,
            isLoading: false,
            canBeLoaded: true,
            page: 1
        };
    },


    computed: {
        items: function items() {
            var vm = this;
            return this.cartItems.map(function (x) {
                var reward = vm.rewards.find(function (y) {
                    return x.Id === y.Id;
                });
                if (reward !== undefined) {
                    var priceItem = reward.Prices && reward.Prices.find(function (y) {
                        return x.PriceId === y.Id;
                    });
                    var price = priceItem ? priceItem.Price : null;
                    //if ((reward.RewardType == RewardTypes.PhysicalBankCard || reward.RewardType === RewardTypes.ElectronicGiftCard && reward.OzonCertificate)
                    if (reward.RewardType !== __WEBPACK_IMPORTED_MODULE_4__enums__["l" /* RewardTypes */].PhysicalPrize && !priceItem && x.Price) {
                        price = x.Price;
                    }
                    return {
                        Id: reward.Id,
                        PriceId: x.PriceId,
                        Name: reward.Name,
                        Price: price,
                        Count: x.Count,
                        Image: reward.Image,
                        RewardType: reward.RewardType,
                        AddressId: x.AddressId
                    };
                }
            }).filter(function (x) {
                return x.Price;
            });
        }
    },

    methods: {
        reload: function reload() {
            this.orders = [];
            this.page = 1;
            this.canBeLoaded = true;
            this.loadOrders();
        },
        loadRewards: function loadRewards() {
            var vm = this;
            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
            return this.callApiWrapper(backendApi.rewardsList(0, 100, vm.projectId, vm.search)).then(function (resp) {
                if (resp.data) {
                    vm.rewards = resp.data;
                }
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
            });
        },
        loadOrders: function loadOrders() {
            var vm = this;
            var rowsPerPage = 50;
            vm.isLoading = true;
            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
            this.callApiWrapper(backendApi.ordersList((this.page - 1) * rowsPerPage, rowsPerPage, vm.projectId)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки заказов');
                } else {
                    if (resp.data && resp.data.list) {
                        var _vm$orders;

                        //vm.orders = resp.data.list;
                        (_vm$orders = vm.orders).push.apply(_vm$orders, _toConsumableArray(resp.data.list));
                        vm.canBeLoaded = resp.data.list.length === rowsPerPage;
                    } else {
                        vm.canBeLoaded = false;
                    }
                }
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                vm.isLoading = false;
            });
        },
        getOrderStatus: function getOrderStatus(order) {
            var vm = this;

            switch (order.Status) {
                case 1:
                    return 'Размещён';
                case 2:
                case 8:
                    return 'В обработке';
                case 3:
                    if (order.Comment) {
                        return '\u041E\u0442\u043C\u0435\u043D\u0451\u043D \u043F\u043E \u043F\u0440\u0438\u0447\u0438\u043D\u0435:<br />' + order.Comment;
                    }
                    return 'Отменён';
                case 4:
                    if (order.Reward.RewardType === 1) {
                        // Электронная подарочная карта
                        return 'Выдан';
                    } else if (order.Reward.RewardType === 2) {
                        // Предоплаченная банковская карта
                        return 'Выдан (карта отправлена)';
                    } else if (order.Reward.RewardType === 3) {
                        // Пополнение личной карты
                        return 'Выдан (перевод осуществлён)';
                    } else if (order.Reward.RewardType === 4) {
                        // приз
                        return 'Отправлен';
                    } else {
                        return '';
                    }
                case 5:
                    if (order.Reward.RewardType === 1) {
                        // Электронная подарочная карта
                        var status = 'Скачан';

                        if (order.FirstRecievedDate) {
                            status += (vm.isMobile ? ' ' : '<br>') + vm.formatDate(order.FirstRecievedDate, 'DD.MM.YYYY HH:mm');
                        }

                        return status;
                    } else if (order.Reward.RewardType === __WEBPACK_IMPORTED_MODULE_4__enums__["l" /* RewardTypes */].PrepaidBankCard) {
                        // Предоплаченная банковская карта
                        return 'Карта получена';
                    } else if (order.Reward.RewardType === __WEBPACK_IMPORTED_MODULE_4__enums__["l" /* RewardTypes */].PhysicalPrize) {
                        // приз
                        return 'Получен';
                    } else {
                        return '';
                    }
                case 6:
                    return 'В обработке';
                default:
                    return '';
            }
        },
        onRemoveItem: function onRemoveItem(item) {
            var vm = this;

            __WEBPACK_IMPORTED_MODULE_0__cart__["a" /* default */].removeItem(item.Id);
            vm.cartItems = __WEBPACK_IMPORTED_MODULE_0__cart__["a" /* default */].getItems();
            vm.$emit('need-refresh-cart');
        },
        onCountChange: function onCountChange(item) {
            var vm = this;

            if (item.Count === 0) {
                vm.onRemoveItem(item);
            } else {
                __WEBPACK_IMPORTED_MODULE_0__cart__["a" /* default */].updateItemCount(item);
                vm.cartItems = __WEBPACK_IMPORTED_MODULE_0__cart__["a" /* default */].getItems();
                vm.$emit('need-refresh-cart');
            }
        },
        getTotalPrice: function getTotalPrice() {
            var sum = 0;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    sum += item.Price * item.Count;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return sum;
        },
        makeOrder: function makeOrder() {
            var vm = this;

            if (vm.orderProcessing) {
                return;
            }

            var counterPhysicalBankCardBan = 0;
            var orderItems = vm.items.map(function (x) {
                if (x.RewardType !== __WEBPACK_IMPORTED_MODULE_4__enums__["l" /* RewardTypes */].PhysicalBankCard || vm.info.User.PaymentSettings && vm.info.User.PaymentSettings.VerificationState === __WEBPACK_IMPORTED_MODULE_4__enums__["t" /* VerificationStates */].Verified) {
                    return { Id: x.Id, Count: x.Count, PriceId: x.PriceId, Price: x.Price, AddressId: x.AddressId };
                } else {
                    counterPhysicalBankCardBan++;
                    return { Id: 0 };
                }
            }).filter(function (x) {
                return x.Id > 0;
            });
            var orderRequest = {
                items: orderItems
            };
            if (vm.items.length === counterPhysicalBankCardBan) {
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('По некоторым вознограждениям нельзя оформлять заказ');
                return;
            }

            vm.orderProcessing = true;

            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('dataContent', 'Сохранение');
            this.callApiWrapper(backendApi.orderPlace(orderRequest)).then(function (response) {
                //console.info('orderPlace -> response.data', response.data);
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при размещении заказа');
                    // todo: customize
                } else {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.success('Заказ успешно размещён');

                    localStorage.removeItem('cart');
                    vm.cartItems = [];
                    vm.$emit('need-refresh-cart');
                    vm.$emit('user-updated');

                    vm.reload();
                }

                vm.orderProcessing = false;
            });
        },
        receiveOrder: function receiveOrder(order) {
            var vm = this;

            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('dataContent', 'Обработка');
            this.callApiWrapper(backendApi.orderReceive(order.Id)).then(function (response) {
                //console.info('receiveOrder -> response.data', response.data);
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при обработке заказа');
                } else {
                    if (order.Reward.RewardType === __WEBPACK_IMPORTED_MODULE_4__enums__["l" /* RewardTypes */].PrepaidBankCard) {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.success('Карта получена');
                    } else if (order.Reward.RewardType === __WEBPACK_IMPORTED_MODULE_4__enums__["l" /* RewardTypes */].ElectronicGiftCard) {
                        console.info('response.data', response.data);
                        vm.forceDownload(response.data, response.data.replace('/uploads/orders/', ''));
                    }

                    vm.orders = [];
                    vm.reload();
                }
            });
        },
        removeOrder: function removeOrder(order) {
            var vm = this;

            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('dataContent', 'Обработка');
            this.callApiWrapper(backendApi.orderRemove(order.Id)).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                if (response.hasError) {
                    console.info('error status', response.status);
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при удалении заказа');
                } else {
                    vm.$emit('user-updated');

                    vm.orders = [];
                    vm.reload();
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.success('Заказ удалён');
                }
            });
        },
        forceDownload: function forceDownload(href, fileName) {
            var anchor = document.createElement('a');
            anchor.href = href;
            anchor.download = fileName;
            document.body.appendChild(anchor);
            anchor.click();
            anchor.remove();
        },
        onProjectChange: function onProjectChange(item) {
            var vm = this;
            vm.projectId = item.Id;

            vm.loadRewards().then(function () {
                vm.cartItems = __WEBPACK_IMPORTED_MODULE_0__cart__["a" /* default */].getItems();
            });
            vm.reload();
        },
        onScroll: function onScroll(e) {
            var vm = this;
            if (!vm.isLoading && vm.canBeLoaded) {
                var elem = $(e.target);
                if (elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight() + 100) {
                    vm.page++;
                    vm.loadOrders();
                }
            }
        }
    },

    mounted: function mounted() {
        var vm = this;

        vm.loadRewards().then(function () {
            vm.cartItems = __WEBPACK_IMPORTED_MODULE_0__cart__["a" /* default */].getItems();
        });
        vm.loadOrders();
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(30)))

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__enums__ = __webpack_require__(19);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var backendApi = new __WEBPACK_IMPORTED_MODULE_2__backendApi__["a" /* default */]();

var rowsPerPage = 50;

var processFilter = function processFilter(filter) {
    var resultFilter = JSON.parse(JSON.stringify(filter));
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = resultFilter[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            var filterField = item[0];
            if (filterField === '[dbo].[TradePoint].[OrderStatus]') {
                item[0] = '[dbo].[Order].[StatusId]';
            }
            if (filterField === '[dbo].[TradePoint].[User]') {
                item[0] = '[dbo].[Order].[UserId]';
            }
            if (filterField === '[dbo].[TradePoint].[Reward]') {
                item[0] = '[dbo].[Reward].[Id]';
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return resultFilter;
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "orders",

    props: ['info'],

    mixins: [__WEBPACK_IMPORTED_MODULE_3__helpers_project_mixin__["a" /* default */]],

    data: function data() {
        return {
            orders: [],
            selectedOrderId: null,
            uploadedFile: null,
            roles: [],
            filter: null,
            dateStart: null,
            dateEnd: null,
            orderDateTypeId: 1,
            orderStatus: 0,
            OrderStatuses: __WEBPACK_IMPORTED_MODULE_7__enums__["f" /* OrderStatuses */],
            filters: [{
                Value: 'OrderStatus', Name: 'Статус'
            }, {
                Value: 'Name', Name: 'Название'
            }, {
                Value: 'Region', Name: 'Регион'
            }, {
                Value: 'Area', Name: 'Область'
            }, {
                Value: 'City', Name: 'Город'
            }, {
                Value: 'Address', Name: 'Адрес'
            }, {
                Value: 'User', Name: 'Пользователь'
            }, {
                Value: 'Reward', Name: 'Вознаграждение'
            }],
            selectAll: false,
            selectedOrders: [],
            isLoading: false,
            canBeLoaded: true,
            page: 1,
            actionState: {
                currentOrder: {
                    index: 0,
                    date: null,
                    time: 0
                },
                total: 0,
                messages: [],
                done: false
            },
            totalOrders: 0,
            rewardTypes: [],
            rewardTypeId: 0,
            address: {
                addressId: null,
                list: [],
                data: null
            },
            receiveDate: null,
            receiveDateFormatted: null,
            orderHistory: {
                data: null,
                id: null,
                nextTryingDate: null,
                giftery: {
                    loading: false,
                    data: null
                }
            }
        };
    },


    watch: {
        rewardTypeId: function rewardTypeId() {
            this.reload();
        }
    },

    computed: {
        showProcessAll: function showProcessAll() {
            return this.selectedOrders.filter(function (x) {
                return x.Status === 1 /*&& x.UserActiveBalance >= x.Amount*/;
            }).length > 0;
        },
        showCompleteAll: function showCompleteAll() {
            return this.selectedOrders.filter(function (x) {
                return x.Status === 2 && (x.Reward.RewardType === 2 || x.Reward.RewardType === 3 || x.Reward.RewardType === 4) || x.Status === 6 && x.Reward.RewardType === 1 && x.ExtraData;
            }).length > 0;
        },
        showGetGifteryAll: function showGetGifteryAll() {
            return this.selectedOrders.filter(function (x) {
                return x.Reward.GifteryId && x.Status === 2 && x.Reward.RewardType === 1 && !x.ExtraData;
            }).length > 0;
        }
    },

    methods: {
        onCheckGiftery: function onCheckGiftery(gifteryId) {
            var vm = this;

            vm.orderHistory.giftery.loading = true;

            return backendApi.gifteryProducts().then(function (response) {
                if (response.hasError) {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке продуктов Giftery');
                } else {
                    //console.log('response.data', response.data);
                    var item = response.data.find(function (x) {
                        return x.id == gifteryId;
                    });
                    if (!item) {
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Данный сертификат не найден в ответе Gifteri.');
                        return;
                    }
                    vm.orderHistory.giftery.data = item.faces;
                }
                vm.orderHistory.giftery.loading = false;
            });
        },
        showGifteryOrderHistory: function showGifteryOrderHistory(order) {
            var vm = this;
            vm.$refs['ppOrderHistory'].show();
            vm.orderHistory.data = null;
            vm.orderHistory.id = order.Id;
            vm.orderHistory.nextTryingDate = null;
            vm.orderHistory.giftery.data = null;
            vm.orderHistory.sert_name = order.Reward.Name;
            vm.orderHistory.sert_nominal = order.Amount;
            vm.loadOrderHistory(order.Id);
        },
        loadOrderHistory: function loadOrderHistory(id) {
            var vm = this;
            this.callApiWrapper(backendApi.orderHistory(id)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки адреса');
                } else {
                    console.info('loadOrderHistory -> resp.data', resp);
                    vm.orderHistory.data = resp.data.filter(function (x) {
                        return x.StatusId === __WEBPACK_IMPORTED_MODULE_7__enums__["f" /* OrderStatuses */].GifteryRequested || x.StatusId === __WEBPACK_IMPORTED_MODULE_7__enums__["f" /* OrderStatuses */].GifteryDelayed || x.StatusId === __WEBPACK_IMPORTED_MODULE_7__enums__["f" /* OrderStatuses */].OrdersMonitoringTry;
                    });

                    var lastTryingDate = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.max(vm.orderHistory.data.filter(function (x) {
                        return x.StatusId === __WEBPACK_IMPORTED_MODULE_7__enums__["f" /* OrderStatuses */].OrdersMonitoringTry;
                    }).map(function (x) {
                        return x.ActionDate;
                    }));
                    if (lastTryingDate) {
                        vm.orderHistory.nextTryingDate = Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(lastTryingDate).add(1, 'hours');
                    }
                }
            });
        },
        getDelayedTitle: function getDelayedTitle(orderId) {
            var order = this.orders.find(function (x) {
                return x.Id === orderId;
            });
            if (order && order.GifteryDelayedDate) {
                return 'Автоматическое получение с ' + this.formatDate(order.GifteryDelayedDate, 'DD.MM.YYYY') + ' по ' + this.formatDate(Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(order.GifteryDelayedDate).add(7, 'days'), 'DD.MM.YYYY');
            }
            return '';
        },
        getCompleteBtnTitle: function getCompleteBtnTitle(order) {
            if (order.Reward.RewardType === 2) return 'Отметить, что карта отправлена';else if (order.Reward.RewardType === 3) return 'Отметить, что перевод произведён';else if (order.Reward.RewardType === 4) return 'Выдать';

            return '';
        },
        onAddressModalOpen: function onAddressModalOpen(order) {
            this.address.data = null;
            this.address.list = [];
            this.loadAddresses(order.AddressId, order.UserId);
            this.$refs['ppAddress'].show();
        },
        loadAddresses: function loadAddresses(addressId, userId) {
            var vm = this;
            this.callApiWrapper(backendApi.orderAddressList(userId)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки адреса');
                } else {
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = resp.data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var addr = _step2.value;

                            addr.DisplayAddress = addr.FullAddress.length > 100 ? addr.FullAddress.substring(0, 100) + '...' : addr.FullAddress;
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    vm.address.addressId = addressId;
                    vm.address.data = resp.data.find(function (x) {
                        return x.Id === addressId;
                    });

                    vm.address.list = resp.data;
                }
            });
        },
        onAddressChange: function onAddressChange(address) {
            this.address.data = address;
        },
        onAddressConfirm: function onAddressConfirm() {
            var vm = this;
            this.$validator.validateAll('address').then(function (result) {
                if (!result) {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                } else {
                    vm.callApiWrapper(backendApi.orderConfirmAddress(vm.address.data)).then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время подтверждения адреса');
                        } else {
                            __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.success('Адрес подтверждён');
                            vm.reload();
                            vm.$refs['ppAddress'].close();
                        }
                    });
                }
            });
        },
        getRewardTypeName: function getRewardTypeName(type) {
            switch (type) {
                case __WEBPACK_IMPORTED_MODULE_7__enums__["l" /* RewardTypes */].ElectronicGiftCard:
                    return 'Электронный сертификат';
                case __WEBPACK_IMPORTED_MODULE_7__enums__["l" /* RewardTypes */].PrepaidBankCard:
                    return 'Предоплаченная карта';
                case __WEBPACK_IMPORTED_MODULE_7__enums__["l" /* RewardTypes */].PhysicalBankCard:
                    return 'Выплата на карту';
                case __WEBPACK_IMPORTED_MODULE_7__enums__["l" /* RewardTypes */].PhysicalPrize:
                    return 'Физические призы';
                default:
                    return '';
            }
        },
        onShowExtraDataModal: function onShowExtraDataModal(extraData, showText) {
            var _this = this;

            this.$refs['ppExtraData'].show();
            this.$nextTick(function () {
                if (showText) _this.$refs.ppExtraDataContainer.innerHTML = '<h3>' + extraData + '</h3>';else _this.$refs.ppExtraDataContainer.innerHTML = __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].pdf_view(extraData);
            });
        },
        reload: function reload() {
            this.page = 1;
            this.canBeLoaded = true;
            this.orders = [];
            this.selectedOrders = [];
            this.selectAll = false;
            this.loadOrders();
        },
        loadRoles: function loadRoles() {
            var vm = this;
            var projectId = vm.projectId;

            return this.callApiWrapper(backendApi.rolesList(projectId)).then(function (resp) {
                if (resp.data) {

                    vm.roles = resp.data.Roles;

                    /*
                    для ролей соблюдаем иерархию, согласно последовательности отображения в настройках ролей
                    если роль не связана с ТТ, то она видит все роли связанные с ТТ
                    если роль связана с ТТ, то видит только роли, которые стоят ниже нее
                    */
                    if (vm.info.User.DynamicRole == null || vm.info.User.DynamicRole.Claims.find(function (x) {
                        return x.ClaimId === vm.claimEnums.ttAccess;
                    })) {
                        //alert()
                        for (var r = 0; r < vm.roles.length; r++) {
                            if (!vm.roles[r].Claims.find(function (x) {
                                return x.ClaimId === vm.claimEnums.ttAccess;
                            })) {
                                vm.filters.push({
                                    Value: 'TradePointRole_' + vm.roles[r].Id,
                                    Name: vm.roles[r].Name
                                });
                            }
                        }
                    } else {

                        for (var _r = 0; _r < vm.roles.length; _r++) {
                            if (!vm.roles[_r].Claims.find(function (x) {
                                return x.ClaimId === vm.claimEnums.ttAccess;
                            }) && vm.info.User.DynamicRole.Order < vm.roles[_r].Order) {

                                vm.filters.push({
                                    Value: 'TradePointRole_' + vm.roles[_r].Id,
                                    Name: vm.roles[_r].Name
                                });
                            }
                        }
                    }
                }
            });
        },
        loadOrders: function loadOrders() {
            var vm = this;
            var dateStart = Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(vm.dateStart, 'DD.MM.YYYY').format();
            var dateEnd = Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(vm.dateEnd, 'DD.MM.YYYY').format();
            var filterFormatted = '';
            if (vm.filter) {
                filterFormatted = processFilter(vm.filter).map(function (x) {
                    return JSON.stringify(x);
                });
                //console.log('filterFormatted', filterFormatted);
            }

            vm.isLoading = true;
            __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
            this.callApiWrapper(backendApi.ordersList((this.page - 1) * rowsPerPage, rowsPerPage, vm.projectId, dateStart, dateEnd, vm.orderDateTypeId, vm.orderStatus, filterFormatted, vm.rewardTypeId)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки заказов');
                } else {
                    if (resp.data && resp.data.list.length) {
                        var _vm$orders;

                        (_vm$orders = vm.orders).push.apply(_vm$orders, _toConsumableArray(resp.data.list));

                        vm.totalOrders = resp.data.totalOrders;

                        vm.rewardTypes = resp.data.rewardTypes;
                        // if(vm.selectAll) {
                        //     for(let order of vm.orders){
                        //         vm.selectedOrders.push(order);
                        //     }
                        // }
                    } else {
                        vm.canBeLoaded = false;
                    }
                }

                __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                vm.isLoading = false;
            });
        },


        // В работу
        processOrder: function processOrder(orderIds) {
            var vm = this;

            __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].blockUI('dataContent', 'Обработка');
            this.callApiWrapper(backendApi.orderProcess(orderIds)).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                if (response.hasError) {
                    console.info('error status', response.status);
                    if (response.status === 600) {
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('У пользователя недостаточо средств');
                    } else if (response.status === 606) {
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Адрес не подтвержден');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при обработке заказа');
                    }
                } else {
                    if (orderIds.length === 1) {
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.success('Заказ принят в работу');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.success('Заказы обработаны');
                    }

                    // todo: можно не делать полный релоад, а только заменить статус
                    vm.reload();
                }
            });
        },


        // Отклонить заказ - модальное окно
        cancelOrderModal: function cancelOrderModal(order) {
            var vm = this;

            vm.selectedOrderId = order.Id;
            vm.$nextTick(function () {
                vm.$refs.ppCancelModal.show();
            });
        },


        // Отклонить заказ
        cancelOrder: function cancelOrder() {
            if (confirm('Заказ будет отменён, вы уверены?')) {
                var vm = this;
                var comment = this.$refs.Comment.value;

                __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].blockUI('dataContent', 'Отмена заказа');
                this.callApiWrapper(backendApi.orderCancel(vm.selectedOrderId, comment)).then(function (response) {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                    if (response.hasError) {
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при отмене заказа');
                        console.info('error status', response.status);
                    } else {
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.success('Заказ успешно отменён');

                        vm.reload();
                    }
                    vm.$refs.ppCancelModal.close();
                });
            }
        },
        receiveOrderModal: function receiveOrderModal(order) {
            var vm = this;

            vm.selectedOrderId = order.Id;
            vm.$nextTick(function () {
                vm.$refs.ppReceiveOrder.show();
            });
        },


        // Отметить приз как полученный
        receiveOrder: function receiveOrder() {
            var _this2 = this;

            this.$validator.validateAll('receive').then(function (result) {
                if (!result) {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                } else {
                    var vm = _this2;

                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].blockUI('dataContent', 'Получение заказа');
                    _this2.callApiWrapper(backendApi.orderReceiveWithDate(vm.selectedOrderId, _this2.receiveDate)).then(function (response) {
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                        if (response.hasError) {
                            __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при получении заказа');
                            console.info('error status', response.status);
                        } else {
                            __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.success('Заказ успешно отмечен как полученный');
                            vm.reload();
                        }
                        vm.$refs.ppReceiveOrder.close();
                    });
                }
            });
        },
        onChangeReceiveDate: function onChangeReceiveDate() {
            this.receiveDate = Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(this.receiveDateFormatted, 'DD.MM.YYYY').format();
        },


        // Пометить как выданный
        completeOrder: function completeOrder(orderIds) {
            var vm = this;

            __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].blockUI('dataContent', 'Обработка');
            this.callApiWrapper(backendApi.orderComplete(orderIds)).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                if (response.hasError) {
                    console.info('error status', response.status);
                    if (response.status === 603) {
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Нельзя обработать заказ в текущем статусе');
                    } else if (response.status === 605) {
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('К заказу не прикреплён файл');
                    } else if (response.status === 202) {
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Изменения сохранены. Но возникла ошибка при отправке писем');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при обработке заказа');
                    }
                } else {
                    if (orderIds.length === 1) {
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.success('Заказ отмечен как выданный');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.success('Заказы обработаны');
                    }

                    // todo: можно не делать полный релоад, а только заменить статус
                    vm.reload();
                }
            });
        },
        closeModal: function closeModal(popupName) {
            this.$refs[popupName].close();
        },
        getOrderStatus: function getOrderStatus(order) {
            switch (order.Status) {
                case 1:
                    return 'Размещён';
                case 2:
                    return 'Обработка';
                case 3:
                    return 'Отменён';
                case 4:
                    if (order.Reward && (order.Reward.RewardType === 1 || order.Reward.RewardType === 3 || order.Reward.RewardType === 4)) {
                        // Электронная подарочная карта, приз
                        return 'Выдан';
                    } else if (order.Reward && order.Reward.RewardType === 2) {
                        // Предоплаченная банковская карта
                        return 'Выдан (карта отправлена)';
                    } else {
                        return 'Выдан';
                    }
                case 5:
                    if (order.Reward && order.Reward.RewardType === 1) {
                        // Электронная подарочная карта
                        return 'Скачан';
                    } else if (order.Reward && order.Reward.RewardType === 2) {
                        // Предоплаченная банковская карта
                        return 'Карта получена';
                    } else if (order.Reward && order.Reward.RewardType === 4) {
                        // приз
                        return 'Получен';
                    } else {
                        return 'Получен';
                    }
                case 6:
                    return 'Готов к выдаче';
                case 7:
                    return 'Обработка заявки';
                case 8:
                    return 'Отложенное получение';
                case 101:
                    return 'Ошибка получения в Giftery';
                default:
                    return '';
            }
        },
        onProjectChange: function onProjectChange(item) {
            var vm = this;

            vm.projectId = item.Id;
            vm.orders = [];
            vm.page = 1;
            vm.canBeLoaded = true;

            vm.filter = null;
            vm.$refs.complexFilter.clear();

            vm.loadRoles().then(function () {
                vm.loadOrders();
            });
            vm.$emit('user-updated');
        },
        onFilterChange: function onFilterChange(filter) {
            this.filter = filter;
            this.reload();
        },


        // todo: fix
        searchFunction: function searchFunction(tableName, columnName, search, filters, searchPage, callback) {
            var projectId = this.projectId;
            var filterFormatted = '';
            if (filters) {
                filterFormatted = processFilter(filters).map(function (x) {
                    return JSON.stringify(x);
                });
            }

            this.callApiWrapper(backendApi.orderDistinctValues(columnName, projectId, search, filterFormatted, (searchPage - 1) * 100, 100)).then(function (resp) {
                callback(resp.data);
            });
        },
        onSelectAllChange: function onSelectAllChange() {
            var vm = this;

            vm.selectedOrders = [];
            if (vm.selectAll) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = vm.orders[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var order = _step3.value;

                        vm.selectedOrders.push(order);
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
        },
        completeSelected: function completeSelected() {
            var vm = this;

            vm.actionState = {
                currentOrder: {
                    index: 0,
                    date: null,
                    time: 0
                },
                total: 0,
                messages: [],
                done: false
            };

            vm.$refs.ppActionModal.show();

            (function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                    var _this3 = this;

                    var selectedOrders, secondsInterval, _loop, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, id;

                    return regeneratorRuntime.wrap(function _callee$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].blockUI('dataContent', 'Обработка');

                                    selectedOrders = vm.selectedOrders.map(function (x) {
                                        return x.Id;
                                    });
                                    secondsInterval = void 0;

                                    vm.actionState.total = selectedOrders.length;
                                    _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop(id) {
                                        var order;
                                        return regeneratorRuntime.wrap(function _loop$(_context) {
                                            while (1) {
                                                switch (_context.prev = _context.next) {
                                                    case 0:
                                                        vm.actionState.currentOrder.index++;
                                                        vm.actionState.currentOrder.time = 0;
                                                        order = vm.orders[vm.orders.findIndex(function (x) {
                                                            return x.Id === id;
                                                        })];

                                                        vm.actionState.currentOrder.date = order.CreateDate;

                                                        secondsInterval = setInterval(function () {
                                                            vm.actionState.currentOrder.time += 1;
                                                        }, 1000);
                                                        _context.next = 7;
                                                        return vm.callApiWrapper(backendApi.orderComplete([id])).then(function (response) {
                                                            clearInterval(secondsInterval);

                                                            var orderTitle = '\u0417\u0430\u043A\u0430\u0437 ' + vm.actionState.currentOrder.index + ' \u043E\u0442 ' + vm.formatDate(vm.actionState.currentOrder.date, 'DD.MM.YYYY HH:mm');
                                                            if (response.hasError) {
                                                                if (response.status === 603) {
                                                                    vm.actionState.messages.push({
                                                                        message: orderTitle + ': \u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0441\u0442\u0430\u0442\u0443\u0441 \u0437\u0430\u043A\u0430\u0437\u0430',
                                                                        error: true
                                                                    });
                                                                } else if (response.status === 605) {
                                                                    vm.actionState.messages.push({
                                                                        message: orderTitle + ': \u041D\u0435 \u043F\u0440\u0438\u043A\u0440\u0435\u043F\u043B\u0451\u043D \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442',
                                                                        error: true
                                                                    });
                                                                } else {
                                                                    vm.actionState.messages.push({
                                                                        message: orderTitle + ': \u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435',
                                                                        error: true
                                                                    });
                                                                }
                                                            } else {
                                                                vm.actionState.messages.push({ message: orderTitle + ': \u0412\u044B\u0434\u0430\u043D' });
                                                            }

                                                            if (vm.actionState.currentOrder.index === vm.actionState.total) {
                                                                vm.actionState.done = true;
                                                                __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('dataContent');
                                                            }
                                                        });

                                                    case 7:
                                                    case 'end':
                                                        return _context.stop();
                                                }
                                            }
                                        }, _loop, _this3);
                                    });
                                    _iteratorNormalCompletion4 = true;
                                    _didIteratorError4 = false;
                                    _iteratorError4 = undefined;
                                    _context2.prev = 8;
                                    _iterator4 = selectedOrders[Symbol.iterator]();

                                case 10:
                                    if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                                        _context2.next = 16;
                                        break;
                                    }

                                    id = _step4.value;
                                    return _context2.delegateYield(_loop(id), 't0', 13);

                                case 13:
                                    _iteratorNormalCompletion4 = true;
                                    _context2.next = 10;
                                    break;

                                case 16:
                                    _context2.next = 22;
                                    break;

                                case 18:
                                    _context2.prev = 18;
                                    _context2.t1 = _context2['catch'](8);
                                    _didIteratorError4 = true;
                                    _iteratorError4 = _context2.t1;

                                case 22:
                                    _context2.prev = 22;
                                    _context2.prev = 23;

                                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                        _iterator4.return();
                                    }

                                case 25:
                                    _context2.prev = 25;

                                    if (!_didIteratorError4) {
                                        _context2.next = 28;
                                        break;
                                    }

                                    throw _iteratorError4;

                                case 28:
                                    return _context2.finish(25);

                                case 29:
                                    return _context2.finish(22);

                                case 30:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee, this, [[8, 18, 22, 30], [23,, 25, 29]]);
                }));

                function loop() {
                    return _ref.apply(this, arguments);
                }

                return loop;
            })()();
        },
        processSelected: function processSelected() {
            var vm = this;

            vm.actionState = {
                currentOrder: {
                    index: 0,
                    date: null,
                    time: 0
                },
                total: 0,
                messages: [],
                done: false
            };

            vm.$refs.ppActionModal.show();

            (function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                    var _this4 = this;

                    var selectedOrders, secondsInterval, _loop2, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, id;

                    return regeneratorRuntime.wrap(function _callee2$(_context4) {
                        while (1) {
                            switch (_context4.prev = _context4.next) {
                                case 0:
                                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].blockUI('dataContent', 'Обработка');

                                    selectedOrders = vm.selectedOrders.map(function (x) {
                                        return x.Id;
                                    });
                                    secondsInterval = void 0;

                                    vm.actionState.total = selectedOrders.length;
                                    _loop2 = /*#__PURE__*/regeneratorRuntime.mark(function _loop2(id) {
                                        var order;
                                        return regeneratorRuntime.wrap(function _loop2$(_context3) {
                                            while (1) {
                                                switch (_context3.prev = _context3.next) {
                                                    case 0:
                                                        vm.actionState.currentOrder.index++;
                                                        vm.actionState.currentOrder.time = 0;
                                                        order = vm.orders[vm.orders.findIndex(function (x) {
                                                            return x.Id === id;
                                                        })];

                                                        vm.actionState.currentOrder.date = order.CreateDate;

                                                        secondsInterval = setInterval(function () {
                                                            vm.actionState.currentOrder.time += 1;
                                                        }, 1000);
                                                        _context3.next = 7;
                                                        return vm.callApiWrapper(backendApi.orderProcess([id])).then(function (response) {
                                                            clearInterval(secondsInterval);

                                                            var orderTitle = '\u0417\u0430\u043A\u0430\u0437 ' + vm.actionState.currentOrder.index + ' \u043E\u0442 ' + vm.formatDate(vm.actionState.currentOrder.date, 'DD.MM.YYYY HH:mm');
                                                            if (response.hasError) {
                                                                if (response.status === 600) {
                                                                    vm.actionState.messages.push({
                                                                        message: orderTitle + ': \u0423 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043E \u0441\u0440\u0435\u0434\u0441\u0442\u0432',
                                                                        error: true
                                                                    });
                                                                } else if (response.status === 603) {
                                                                    vm.actionState.messages.push({
                                                                        message: orderTitle + ': \u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0441\u0442\u0430\u0442\u0443\u0441 \u0437\u0430\u043A\u0430\u0437\u0430',
                                                                        error: true
                                                                    });
                                                                } else if (response.status === 606) {
                                                                    vm.actionState.messages.push({
                                                                        message: orderTitle + ': \u0410\u0434\u0440\u0435\u0441 \u043D\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D',
                                                                        error: true
                                                                    });
                                                                } else {
                                                                    vm.actionState.messages.push({
                                                                        message: orderTitle + ': \u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435',
                                                                        error: true
                                                                    });
                                                                }
                                                            } else {
                                                                vm.actionState.messages.push({ message: orderTitle + ': \u041F\u0440\u0438\u043D\u044F\u0442 \u0432 \u0440\u0430\u0431\u043E\u0442\u0443' });
                                                            }

                                                            if (vm.actionState.currentOrder.index === vm.actionState.total) {
                                                                vm.actionState.done = true;
                                                                __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('dataContent');
                                                            }
                                                        });

                                                    case 7:
                                                    case 'end':
                                                        return _context3.stop();
                                                }
                                            }
                                        }, _loop2, _this4);
                                    });
                                    _iteratorNormalCompletion5 = true;
                                    _didIteratorError5 = false;
                                    _iteratorError5 = undefined;
                                    _context4.prev = 8;
                                    _iterator5 = selectedOrders[Symbol.iterator]();

                                case 10:
                                    if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
                                        _context4.next = 16;
                                        break;
                                    }

                                    id = _step5.value;
                                    return _context4.delegateYield(_loop2(id), 't0', 13);

                                case 13:
                                    _iteratorNormalCompletion5 = true;
                                    _context4.next = 10;
                                    break;

                                case 16:
                                    _context4.next = 22;
                                    break;

                                case 18:
                                    _context4.prev = 18;
                                    _context4.t1 = _context4['catch'](8);
                                    _didIteratorError5 = true;
                                    _iteratorError5 = _context4.t1;

                                case 22:
                                    _context4.prev = 22;
                                    _context4.prev = 23;

                                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                        _iterator5.return();
                                    }

                                case 25:
                                    _context4.prev = 25;

                                    if (!_didIteratorError5) {
                                        _context4.next = 28;
                                        break;
                                    }

                                    throw _iteratorError5;

                                case 28:
                                    return _context4.finish(25);

                                case 29:
                                    return _context4.finish(22);

                                case 30:
                                case 'end':
                                    return _context4.stop();
                            }
                        }
                    }, _callee2, this, [[8, 18, 22, 30], [23,, 25, 29]]);
                }));

                function loop() {
                    return _ref2.apply(this, arguments);
                }

                return loop;
            })()();
        },
        ppActionModalClose: function ppActionModalClose() {
            this.closeModal('ppActionModal');
            this.reload();
        },
        onMarkupTest: function onMarkupTest() {
            var mess = [];
            this.actionState = {
                currentOrder: {
                    index: 1,
                    date: new Date(),
                    time: 2
                },
                total: 5,
                messages: mess,
                done: false,
                test: true
            };
            var rn = 0;
            setInterval(function () {
                rn++;
                mess.push({
                    message: 'Заказ ' + rn + ' от 26.07.2019 14:27: Принят в работу', error: false
                });
            }, 500);
            this.$refs.ppActionModal.show();
        },
        onCertificateClick: function onCertificateClick(dropFiles) {
            var vm = this;
            vm.$refs[dropFiles][0].click();
        },
        onCertificateDelete: function onCertificateDelete(orderId) {
            var vm = this;
            if (confirm('Удалить сертификат?')) {
                __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].blockUI('dataContent', 'Удаление сертификата');
                vm.callApiWrapper(backendApi.orderExtraDataRemove(orderId)).then(function (response) {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                    if (response.hasError) {
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при удалении сертификата');
                        console.info('error status', response.status);
                    } else {
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.success('Сертификата успешно удален');

                        vm.reload();
                    }
                });
            }
        },
        onCertificateChange: function onCertificateChange(orderId, dropFiles) {
            var vm = this;

            if (vm.$refs[dropFiles][0].files && vm.$refs[dropFiles][0].files[0]) {
                if (vm.$refs[dropFiles][0].files[0].size > 50 * 1024 * 1024) {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Превышен размер. Выберите другой файл');
                } else {
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        var fileData = e.target.result;
                        var fileName = vm.$refs[dropFiles][0].files[0].name;

                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].blockUI('dataContent', 'Загрузка сертификата');
                        vm.callApiWrapper(backendApi.orderExtraData(orderId, fileData, fileName)).then(function (response) {
                            __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                            if (response.hasError) {
                                if (response.status === 2001) {
                                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Неверный формат файла');
                                } else {
                                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке сертификата');
                                }
                                console.info('error status', response.status);
                            } else {
                                __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.success('Сертификат успешно загружен');

                                vm.orders = [];
                                vm.page = 1;
                                vm.canBeLoaded = true;
                                vm.loadOrders();
                            }
                        });
                    };
                    reader.readAsDataURL(this.$refs[dropFiles][0].files[0]);
                }
            }
        },
        onScroll: function onScroll(e) {
            var vm = this;
            if (!vm.isLoading && vm.canBeLoaded) {
                var elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target);
                if (elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight() + 100) {
                    vm.page++;
                    vm.loadOrders();
                }
            }
        },
        onExport: function onExport() {
            var vm = this;

            var projectId = vm.projectId;
            var dateStart = Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(vm.dateStart, 'DD.MM.YYYY').format();
            var dateEnd = Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(vm.dateEnd, 'DD.MM.YYYY').format();

            var filterFormatted = '';
            var pf = [];
            if (vm.filter) {
                pf = processFilter(vm.filter);
            }
            if (vm.selectedOrders.length > 0) {
                var selectedOrders = vm.selectedOrders.map(function (x) {
                    return x.Id;
                });
                pf.push(['[dbo].[Order].[Id]', 'IN', '(' + ('' + encodeURIComponent(selectedOrders.join(",")).replace("'", "''")) + ')']);
            }
            if (pf.length > 0) {
                filterFormatted = pf.map(function (x) {
                    return JSON.stringify(x);
                });
            }

            __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].blockUI('#app');
            this.callApiWrapper(backendApi.ordersExport(projectId, dateStart, dateEnd, filterFormatted, vm.orderDateTypeId, vm.orderStatus)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время экспорта');
                    console.info('resp', resp);
                } else {
                    var exportFile = resp.data;
                    if (exportFile != null) {
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].downloadFileByBytes(exportFile, "Заказы.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                    }
                }
                __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            });
        },
        makeGifteryOrder: function makeGifteryOrder(id) {
            var vm = this;

            vm.actionState = {
                currentOrder: {
                    index: 0,
                    date: null,
                    time: 0
                },
                total: 0,
                messages: [],
                done: false,
                ordersToCheck: {},
                doneMessage: null
            };

            vm.$refs.ppActionModal.show();

            (function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                    var _this5 = this;

                    var selectedOrders, secondsInterval, _loop3, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, _id;

                    return regeneratorRuntime.wrap(function _callee3$(_context6) {
                        while (1) {
                            switch (_context6.prev = _context6.next) {
                                case 0:
                                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].blockUI('dataContent', 'Обработка');

                                    selectedOrders = id ? [id] : vm.selectedOrders.map(function (x) {
                                        return x.Id;
                                    });

                                    console.info('selectedOrders', selectedOrders);

                                    secondsInterval = void 0;

                                    vm.actionState.total = selectedOrders.length;
                                    _loop3 = /*#__PURE__*/regeneratorRuntime.mark(function _loop3(_id) {
                                        var order;
                                        return regeneratorRuntime.wrap(function _loop3$(_context5) {
                                            while (1) {
                                                switch (_context5.prev = _context5.next) {
                                                    case 0:
                                                        vm.actionState.currentOrder.index++;
                                                        vm.actionState.currentOrder.time = 0;
                                                        order = vm.orders.find(function (x) {
                                                            return x.Id === _id;
                                                        });

                                                        vm.actionState.currentOrder.date = order.CreateDate;

                                                        secondsInterval = setInterval(function () {
                                                            vm.actionState.currentOrder.time += 1;
                                                        }, 1000);
                                                        _context5.next = 7;
                                                        return vm.callApiWrapper(backendApi.makeGifteryOrder(_id)).then(function (response) {
                                                            clearInterval(secondsInterval);

                                                            var orderTitle = '\u0421\u0442\u0430\u0442\u0443\u0441 \u0434\u043B\u044F \u0437\u0430\u043A\u0430\u0437\u0430 #' + vm.actionState.currentOrder.index + ' \u043E\u0442 ' + vm.formatDate(vm.actionState.currentOrder.date, 'DD.MM.YYYY HH:mm');
                                                            if (response.hasError) {
                                                                if (response.status === 603) {
                                                                    vm.actionState.messages.push({
                                                                        message: orderTitle + ': \u041D\u0435 \u0432\u0435\u0440\u043D\u044B\u0439 \u0441\u0442\u0430\u0442\u0443\u0441 \u0437\u0430\u043A\u0430\u0437\u0430',
                                                                        error: true
                                                                    });
                                                                } else if (response.status === 3001) {
                                                                    vm.actionState.messages.push({
                                                                        message: orderTitle + ': \u041D\u043E\u043C\u0438\u043D\u0430\u043B \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F',
                                                                        error: true
                                                                    });
                                                                } else if (response.status === 3002) {
                                                                    vm.actionState.messages.push({
                                                                        message: orderTitle + ': \u041D\u0435 \u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0441\u0440\u0435\u0434\u0441\u0442\u0432',
                                                                        error: true
                                                                    });
                                                                } else {
                                                                    vm.actionState.messages.push({
                                                                        message: orderTitle + ': \u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435',
                                                                        error: true
                                                                    });
                                                                }
                                                            } else {
                                                                vm.actionState.messages.push({ id: _id, message: orderTitle + ': \u0437\u0430\u044F\u0432\u043A\u0430 \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0430' });
                                                                vm.actionState.ordersToCheck[_id] = true;
                                                            }

                                                            if (vm.actionState.currentOrder.index === vm.actionState.total) {
                                                                vm.actionState.done = true;
                                                                vm.actionState.doneMessage = 'Создание заявок завершено.';
                                                                if (Object.keys(vm.actionState.ordersToCheck).length) {
                                                                    vm.actionState.doneMessage += ' Идёт получение сертификатов';
                                                                }
                                                                __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('dataContent');
                                                            }
                                                        });

                                                    case 7:

                                                        if (vm.actionState.currentOrder.index === 1) {
                                                            vm.runGifteryOrdersMonitoring();
                                                        }

                                                    case 8:
                                                    case 'end':
                                                        return _context5.stop();
                                                }
                                            }
                                        }, _loop3, _this5);
                                    });
                                    _iteratorNormalCompletion6 = true;
                                    _didIteratorError6 = false;
                                    _iteratorError6 = undefined;
                                    _context6.prev = 9;
                                    _iterator6 = selectedOrders[Symbol.iterator]();

                                case 11:
                                    if (_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done) {
                                        _context6.next = 17;
                                        break;
                                    }

                                    _id = _step6.value;
                                    return _context6.delegateYield(_loop3(_id), 't0', 14);

                                case 14:
                                    _iteratorNormalCompletion6 = true;
                                    _context6.next = 11;
                                    break;

                                case 17:
                                    _context6.next = 23;
                                    break;

                                case 19:
                                    _context6.prev = 19;
                                    _context6.t1 = _context6['catch'](9);
                                    _didIteratorError6 = true;
                                    _iteratorError6 = _context6.t1;

                                case 23:
                                    _context6.prev = 23;
                                    _context6.prev = 24;

                                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                        _iterator6.return();
                                    }

                                case 26:
                                    _context6.prev = 26;

                                    if (!_didIteratorError6) {
                                        _context6.next = 29;
                                        break;
                                    }

                                    throw _iteratorError6;

                                case 29:
                                    return _context6.finish(26);

                                case 30:
                                    return _context6.finish(23);

                                case 31:
                                case 'end':
                                    return _context6.stop();
                            }
                        }
                    }, _callee3, this, [[9, 19, 23, 31], [24,, 26, 30]]);
                }));

                function loop() {
                    return _ref3.apply(this, arguments);
                }

                return loop;
            })()();
        },
        runGifteryOrdersMonitoring: function runGifteryOrdersMonitoring() {
            var vm = this;

            var checkInterval = setInterval(function () {
                var orderIds = Object.keys(vm.actionState.ordersToCheck);
                console.info('orderIds', orderIds);
                if (!orderIds.length) {
                    clearInterval(checkInterval);
                    return false;
                }

                vm.callApiWrapper(backendApi.getOrderStatuses(orderIds)).then(function (response) {
                    var _loop4 = function _loop4(order) {
                        if (order.StatusId === __WEBPACK_IMPORTED_MODULE_7__enums__["f" /* OrderStatuses */].ReadyToComplete) {
                            delete vm.actionState.ordersToCheck[order.Id];

                            var item = vm.actionState.messages.find(function (x) {
                                return x.id === order.Id;
                            });
                            if (item) {
                                item.message += ', сертификат получен';
                            }
                        }
                    };

                    var _iteratorNormalCompletion7 = true;
                    var _didIteratorError7 = false;
                    var _iteratorError7 = undefined;

                    try {
                        for (var _iterator7 = response.data[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                            var order = _step7.value;

                            _loop4(order);
                        }
                    } catch (err) {
                        _didIteratorError7 = true;
                        _iteratorError7 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                _iterator7.return();
                            }
                        } finally {
                            if (_didIteratorError7) {
                                throw _iteratorError7;
                            }
                        }
                    }

                    if (!Object.keys(vm.actionState.ordersToCheck).length && vm.actionState.done) {
                        console.log('Завершаем runGifteryOrdersMonitoring');
                        clearInterval(checkInterval);
                        vm.actionState.doneMessage += '. Сертификаты получены';
                    }
                });
            }, 5000);
        },
        makeOzonOrder: function makeOzonOrder(order) {
            var vm = this;

            __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].blockUI('dataContent', 'Сохранение');
            this.callApiWrapper(backendApi.makeOzonOrder(order.Id)).then(function (response) {
                //console.info('orderPlace -> response.data', response.data);
                __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                var orderTitle = '\u0421\u0442\u0430\u0442\u0443\u0441 \u0434\u043B\u044F \u0437\u0430\u043A\u0430\u0437\u0430 #' + order.Id + ' \u043E\u0442 ' + vm.formatDate(order.CreateDate, 'DD.MM.YYYY HH:mm');
                if (response.hasError) {
                    if (response.status === 603) {
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error(orderTitle + ': \u041D\u0435 \u0432\u0435\u0440\u043D\u044B\u0439 \u0441\u0442\u0430\u0442\u0443\u0441 \u0437\u0430\u043A\u0430\u0437\u0430');
                    } else if (response.status === 3001) {
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error(orderTitle + ': \u041D\u043E\u043C\u0438\u043D\u0430\u043B \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error(orderTitle + ': \u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0435');
                    }
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при размещении заказа');
                    // todo: customize
                } else {
                    __WEBPACK_IMPORTED_MODULE_4__helpers_ui_helpers__["a" /* default */].toastr.success('Заказ успешно размещён');
                    order.Status = response.data.status;
                }
            });
        },
        clearFilterDate: function clearFilterDate() {
            this.dateStart = null;
            this.dateEnd = null;
            this.orderDateTypeId = 1;

            this.reload();
        }
    },

    mounted: function mounted() {
        var vm = this;

        vm.loadRoles().then(function () {
            vm.loadOrders();
        });
        vm.$refs.complexFilter.applyFilter();
    }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_claims_checking_mixin__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__config__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var backendApi = new __WEBPACK_IMPORTED_MODULE_2__backendApi__["a" /* default */]();

var months = [{ Id: 1, Name: 'Январь' }, { Id: 2, Name: 'Февраль' }, { Id: 3, Name: 'Март' }, { Id: 4, Name: 'Апрель' }, { Id: 5, Name: 'Май' }, { Id: 6, Name: 'Июнь' }, { Id: 7, Name: 'Июль' }, { Id: 8, Name: 'Август' }, { Id: 9, Name: 'Сентябрь' }, { Id: 10, Name: 'Октябрь' }, { Id: 11, Name: 'Ноябрь' }, { Id: 12, Name: 'Декабрь' }];

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "bonus-history",

    mixins: [__WEBPACK_IMPORTED_MODULE_3__helpers_project_mixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__helpers_claims_checking_mixin__["a" /* default */]],

    data: function data() {
        return {
            data: [],
            loading: false,
            canBeLoaded: true,
            page: 1,
            rowsPerPage: 100,
            dateStart: null,
            dateEnd: null,
            accrued: null,
            charged: null,
            total: null,
            project: null,
            isMobile: __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].check_mobile(),
            bonusOperationTypeId: null,
            search: null,
            chartData: null,
            chartOptions: null,
            filter: null,
            monthFilters: [{
                Value: 'Month', Name: 'Месяц'
            }]
        };
    },


    methods: {
        searchFunction: function searchFunction(tableName, columnName, search, filters, searchPage, callback, errorCallback) {

            var vm = this;
            var dateStart = Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(vm.dateStart, 'DD.MM.YYYY').format();
            var dateEnd = Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(vm.dateEnd, 'DD.MM.YYYY').format();
            var monthAndYear = null;
            if (filters && filters.length) {
                monthAndYear = filters[0][2].replace("('", "").replace("')", "").replace("';'", ",");
            }
            var bonusOperationTypeId = vm.bonusOperationTypeId;

            this.callApiWrapper(backendApi.bonusHistoryDistinctValues(columnName, dateStart, dateEnd, bonusOperationTypeId, search, monthAndYear, (searchPage - 1) * 30, 30, vm.projectId)).then(function (resp) {
                if (!resp.hasError) {
                    callback(resp.data);
                } else {
                    errorCallback(resp.message);
                }
            });
        },
        onFilterChange: function onFilterChange(filter) {
            this.filter = filter;

            this.historyReload();
        },
        back: function back() {
            this.$router.back();
        },
        historyReload: function historyReload() {
            if (!Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(this.dateStart, 'DD.MM.YYYY').isValid()) {
                //this.dateStart = this.formatDate(moment().startOf('month'));
            } else {
                this.dateStart = this.formatDate(Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(this.dateStart, 'DD.MM.YYYY').startOf('month'));
            }
            //this.$refs.dateStart.setDate(this.dateStart);

            if (!Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(this.dateEnd, 'DD.MM.YYYY').isValid()) {
                //this.dateEnd = this.formatDate(moment().endOf('month'));
            } else {
                this.dateEnd = this.formatDate(Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(this.dateEnd, 'DD.MM.YYYY').endOf('month'));
            }
            //this.$refs.dateEnd.setDate(this.dateEnd);
            this.page = 1;
            this.data = [];
            this.loadNext();
        },


        onSearchChange: __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.debounce(function () {

            this.historyReload();
        }, 500),

        loadNext: function loadNext() {
            var vm = this;
            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');

            var dateStart = Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(vm.dateStart, 'DD.MM.YYYY').format();
            var dateEnd = Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(vm.dateEnd, 'DD.MM.YYYY').format();
            var unit = 'day';
            if (vm.isMobile) {
                unit = 'week';
            }
            var monthAndYear = null;
            this.filter = this.$refs.complexFilter.getExpotData();
            if (this.filter && this.filter.length) {
                monthAndYear = this.filter[0][2].replace("('", "").replace("')", "").replace(/';'/g, ",");
            }
            var bonusOperationTypeId = vm.bonusOperationTypeId;
            var search = vm.search;

            this.callApiWrapper(backendApi.bonusHistoryList((this.page - 1) * this.rowsPerPage, this.rowsPerPage, dateStart, dateEnd, bonusOperationTypeId, search, unit, monthAndYear, vm.projectId)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки истории');
                } else {
                    if (resp.data && resp.data.items && resp.data.items.length) {
                        var _vm$data;

                        (_vm$data = vm.data).push.apply(_vm$data, _toConsumableArray(resp.data.items));
                        vm.total = 0;
                        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(resp.data.chart, function (i, e) {
                            vm.total += e.Value;
                        });
                        vm.chartData = {
                            labels: resp.data.chart.map(function (x) {
                                return x.Name;
                            }), //['01.02.03', '05.02.03', '06.02.03'],
                            datasets: [{
                                label: 'Доход',
                                data: resp.data.chart.map(function (x) {
                                    return x.Value;
                                }),
                                backgroundColor: 'rgba(255, 99, 132, 0.5)',
                                borderColor: 'rgba(255, 99, 132, 1)',
                                borderWidth: 1
                            }]
                        };
                    } else {
                        vm.canBeLoaded = false;
                    }
                }
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                vm.loading = false;
            });
        },
        onExport: function onExport() {
            var vm = this;
            var dateStart = Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(vm.dateStart, 'DD.MM.YYYY').toISOString(),
                dateEnd = Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(vm.dateEnd, 'DD.MM.YYYY').toISOString(),
                unit = 'day';
            if (vm.isMobile) {
                unit = 'week';
            }
            var monthAndYear = '';

            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('#app');
            vm.callApiWrapper(backendApi.bonusHistoryExport(dateStart, dateEnd, vm.bonusOperationTypeId, vm.search ? vm.search : '', unit, monthAndYear, vm.projectId)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время экспорта');
                } else {
                    var exportFile = resp.data;
                    if (exportFile != null) {
                        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].downloadFileByBytes(exportFile, 'История начислений.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                    }
                }

                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            });
        },
        loadProject: function loadProject() {
            var vm = this;

            return this.callApiWrapper(backendApi.projectLoad(vm.projectId)).then(function (resp) {
                if (resp.data) {
                    vm.project = resp.data;
                }
            });
        }
    },

    mounted: function mounted() {
        var vm = this;

        // vm.dateStart = vm.formatDate(moment().startOf('month'));
        // vm.dateEnd = vm.formatDate(moment().endOf('month'));

        var currentYear = new Date().getFullYear();
        var month = months[new Date().getMonth()];

        vm.$refs['complexFilter'].applyFilter();
        vm.$refs['complexFilter'].filterRowSetValues([{ Id: (month.Id > 9 ? month.Id : '0' + month.Id) + '.' + currentYear, Name: month.Name + ' ' + currentYear }]);

        vm.loadProject().then(function () {
            vm.loadNext();
        });

        vm.$nextTick(function () {

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').on('scroll', function () {

                if (!vm.loading && vm.canBeLoaded) {
                    var elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
                    if (elem[0].scrollHeight - elem.scrollTop() - 200 <= elem.outerHeight()) {
                        vm.page++;
                        vm.loadNext();
                    }
                }
            });
        });

        var options = _defineProperty({
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }]
            },
            maintainAspectRatio: false,
            responsive: true,
            stacked: false,
            defaultFontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            legend: {
                display: false
            },
            tooltips: {
                callbacks: {
                    label: function label(tooltipItem, data) {
                        var label = data.datasets[tooltipItem.datasetIndex].label || '';

                        label += ': ' + vm.formatInt(tooltipItem.yLabel);

                        return label;
                    }
                }
            }
        }, 'maintainAspectRatio', false);

        vm.chartOptions = options;
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').off('scroll');
    }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backendApi__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//





var backendApi = new __WEBPACK_IMPORTED_MODULE_2__backendApi__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "faq",

    props: ['info'],

    mixins: [__WEBPACK_IMPORTED_MODULE_0__helpers_project_mixin__["a" /* default */]],

    data: function data() {
        return {
            infoData: {},
            faqData: null
        };
    },


    methods: {
        onProjectChange: function onProjectChange() {
            this.$emit('user-updated');
            this.loadFaq();
        },
        loadFaq: function loadFaq() {
            var vm = this;
            return this.callApiWrapper(backendApi.projectInfoFilter()).then(function (resp) {
                if (resp.hasError) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки вопросов');
                } else {
                    if (resp.data) {
                        //console.info('resp.data', resp.data);
                        vm.infoData = Object.assign({}, resp.data);
                    }
                }
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                vm.loading = false;
            }).catch(function (err) {
                console.info('err', err);
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки');
            });
        }
    },

    mounted: function mounted() {
        var vm = this;

        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
        vm.loadFaq().then(function () {
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
        });
    }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var backendApi = new __WEBPACK_IMPORTED_MODULE_1__backendApi__["a" /* default */]();
var rowsPerPage = 30;

var MinActivityEnum = {
    Day15: { Text: 'не заходил более 15 дней', Value: 15 },
    Day30: { Text: 'не заходил более 35 дней', Value: 30 },
    Day45: { Text: 'не заходил более 45 дней', Value: 45 }
};
var MaxActivityEnum = {
    Day5: { Text: 'заходил более 5 раз в месяц', Value: 5 },
    Day15: { Text: 'заходил более 15 раз в месяц', Value: 15 },
    Day30: { Text: 'заходил более 30 раз в месяц', Value: 30 }
};
var MinBonusEnum = {
    1: { Text: 'больше нуля', Value: 1 },
    1000: { Text: 'больше 1000', Value: 1000 },
    5000: { Text: 'больше 5000', Value: 5000 },
    10000: { Text: 'больше 10000', Value: 10000 }
};

var processFilter = function processFilter(filter) {
    var filterCopy = JSON.parse(JSON.stringify(filter));
    if (filterCopy == null) {
        return null;
    }
    var stateEnums = {
        '[dbo].[AspNetUsers].[TermsConfirmed]': {
            'Да': 1,
            'Нет': 0
        },
        '[dbo].[AspNetUsers].[PersonalDataEditingAccept]': {
            'Да': 1,
            'Нет': 0
        },
        '[dbo].[AspNetUsers].[NotificationsEnabled]': {
            'Да': 1,
            'Нет': 0
        },
        '[dbo].[AspNetUsers].[PassportVerificationState]': {
            'документы отсутствуют': 0,
            'проверь документы!': 1,
            'документы подтверждены': 2,
            'документы возвращены': 3
        },
        '[dbo].[AspNetUsers].[RegisterStatus]': {
            'неактивен': 0,
            'проверка': 1,
            'активен': 2,
            'отказано': 3,
            'отключен': 4,
            'заблокирован': 5
        },
        '[dbo].[AspNetUsers].[MinActivity]': {},
        '[dbo].[AspNetUsers].[MaxActivity]': {},
        '[dbo].[AspNetUsers].[MinBonus]': {}
    };
    for (var s in MinActivityEnum) {
        stateEnums['[dbo].[AspNetUsers].[MinActivity]'][MinActivityEnum[s].Text] = MinActivityEnum[s].Value;
    }
    for (var _s in MaxActivityEnum) {
        stateEnums['[dbo].[AspNetUsers].[MaxActivity]'][MaxActivityEnum[_s].Text] = MaxActivityEnum[_s].Value;
    }
    for (var _s2 in MinBonusEnum) {
        stateEnums['[dbo].[AspNetUsers].[MinBonus]'][MinBonusEnum[_s2].Text] = MinBonusEnum[_s2].Value;
    }

    var resultFilter = [];

    var _loop = function _loop(item) {
        var filterField = item[0];
        var dontPushItem = false;
        if (filterField === '[dbo].[AspNetUsers].[TermsConfirmed]' || filterField === '[dbo].[AspNetUsers].[PersonalDataEditingAccept]' || filterField === '[dbo].[AspNetUsers].[NotificationsEnabled]' || filterField === '[dbo].[AspNetUsers].[PassportVerificationState]' || filterField === '[dbo].[AspNetUsers].[RegisterStatus]' || filterField === '[dbo].[AspNetUsers].[MinActivity]' || filterField === '[dbo].[AspNetUsers].[MaxActivity]' || filterField === '[dbo].[AspNetUsers].[MinBonus]') {

            var values = item[2].substring(1, item[2].length - 1).split(';').map(function (x) {
                return decodeURI(x);
            }).map(function (x) {
                var name = x.substring(1, x.length - 1);
                var state = stateEnums[filterField][name];
                return state;
            });

            if (filterField === '[dbo].[AspNetUsers].[TermsConfirmed]' || filterField === '[dbo].[AspNetUsers].[PersonalDataEditingAccept]' || filterField === '[dbo].[AspNetUsers].[NotificationsEnabled]' || filterField === '[dbo].[AspNetUsers].[PassportVerificationState]' || filterField === '[dbo].[AspNetUsers].[RegisterStatus]') {

                item[0] = 'isnull(' + filterField + '%comma%0)';

                if (filterField === '[dbo].[AspNetUsers].[RegisterStatus]') {
                    var dateFilters = values.filter(function (x) {
                        return x === 4 || x === 5 || x === 2;
                    });
                    var statusFilters = values.filter(function (x) {
                        return x !== 4 && x !== 5 && x !== 2;
                    });

                    var dateFilterPart = '';
                    if (dateFilters.length) {
                        if (values.indexOf(4) > -1 && values.indexOf(5) === -1) {
                            // только Отключен
                            dateFilterPart = '[dbo].[UserDynamicRoles].[DisabledDateTime] <= getdate() and ([dbo].[UserDynamicRoles].[BlockedDateTime] is null or [dbo].[UserDynamicRoles].[BlockedDateTime] > getdate())';
                        }
                        if (values.indexOf(5) > -1 && values.indexOf(4) === -1) {
                            // только Заблокирован
                            dateFilterPart = '[dbo].[UserDynamicRoles].[BlockedDateTime] <= getdate()';
                        }
                        if (values.indexOf(5) > -1 && values.indexOf(4) > -1) {
                            // оба фильтра
                            dateFilterPart = '([dbo].[UserDynamicRoles].[DisabledDateTime] <= getdate() or [dbo].[UserDynamicRoles].[BlockedDateTime] <= getdate())';
                        }

                        // если есть фильтр "Активен"
                        if (values.indexOf(2) > -1) {
                            if (dateFilterPart) {
                                // если уже указаны фильтры Заблокирован или Отключен
                                dateFilterPart = '( (' + dateFilterPart + ') or [dbo].[AspNetUsers].[RegisterStatus] = 2' + ')';
                            } else {
                                // только фильтр Активен
                                dateFilterPart = '[dbo].[AspNetUsers].[RegisterStatus] = 2 and ([dbo].[UserDynamicRoles].[BlockedDateTime] is null or [dbo].[UserDynamicRoles].[BlockedDateTime] > getdate())' + 'and ([dbo].[UserDynamicRoles].[DisabledDateTime] is null or [dbo].[UserDynamicRoles].[DisabledDateTime] > getdate())';
                            }
                        }
                    }

                    if (statusFilters.length) {
                        item[2] = '(' + values.filter(function (x) {
                            return x !== 4 && x !== 5 && x !== 2;
                        }).map(function (item) {
                            return '' + encodeURI(item);
                        }).join(';') + ')';
                    } else {
                        dontPushItem = true;
                    }

                    if (dateFilters.length && !statusFilters.length) {
                        resultFilter.push(['', '', dateFilterPart]);
                    }

                    if (dateFilters.length && statusFilters.length) {
                        dontPushItem = true;

                        resultFilter.push(['', '', '(' + item.join(' ') + ' or ' + dateFilterPart + ')']);
                    }
                } else {
                    item[2] = '(' + values.map(function (item) {
                        return '' + encodeURI(item);
                    }).join(';') + ')';
                }
            } else {
                item[2] = '(' + values.map(function (item) {
                    return '\'' + encodeURI(item) + '\'';
                }).join(';') + ')';
            }
        }

        if (filterField === '[dbo].[AspNetUsers].[UserRole]') {
            item[0] = '[dbo].[DynamicRole]';
        }

        if (!dontPushItem) {
            resultFilter.push(item);
        }
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = filterCopy[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            _loop(item);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return resultFilter;
};

var BulkSendingType = {
    sms: 1,
    email: 2,
    notification: 3
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "sender",

    props: ['info'],

    mixins: [__WEBPACK_IMPORTED_MODULE_2__helpers_project_mixin__["a" /* default */]],

    data: function data() {
        return {
            activeTab: 'email', //'history',
            filter: null,
            currentTemplate: {
                Id: null,
                Body: null,
                Name: null,
                Header: null
            },
            userFilters: [{
                Value: 'LastName', Name: 'Фамилия'
            }, {
                Value: 'FirstName', Name: 'Имя'
            }, {
                Value: 'PhoneNumber', Name: 'Телефон'
            }, {
                Value: 'Email', Name: 'Email'
            }, {
                Value: 'TermsConfirmed', Name: 'Согласен на условия'
            }, {
                Value: 'PersonalDataEditingAccept', Name: 'Согласен на обработку'
            }, {
                Value: 'NotificationsEnabled', Name: 'Согласен на рассылку'
            }, {
                Value: 'PassportVerificationState', Name: 'Статус документов'
            }, {
                Value: 'RegisterStatus', Name: 'Активность'
            }, {
                Value: 'MinActivity', Name: 'Минимальная активность'
            }, {
                Value: 'MaxActivity', Name: 'Максимальная активность'
            }, {
                Value: 'MinBonus', Name: 'Доступно баллов'
            }],
            roles: [],
            users: {
                data: [],
                page: 1,
                loading: false,
                canBeLoaded: true
            },
            usersCount: null,
            isMobile: __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].check_mobile(),
            dateSortType: 'RegisterDate',
            dateSortTypes: [{ Id: 'RegisterDate', Name: 'Дата регистрации' }, { Id: 'UserActivationDateTime', Name: 'Дата активации аккаунта' }, { Id: 'DisabledDateTime', Name: 'Дата отключения' }, { Id: 'BlockedDateTime', Name: 'Дата блокировки' }, { Id: 'LastActivityDate', Name: 'Дата последнего визита' }, { Id: 'BonusAccrualDate', Name: 'Дата начисления бонусов' }],
            dateSortEmpty: false,
            roleId: null,
            dateStart: '',
            dateEnd: '',
            dateStartSent: '',
            timeStartSent: '',
            forceNewLoadNext: false,

            templates: [],
            smsTextInfo: {
                symbolsLeft: 160,
                symbolsTotal: 0,
                messages: 0,
                averagePrice: null
            },
            bulkSending: {
                data: [],
                page: 1,
                loading: false,
                canBeLoaded: true
            },
            log: {
                data: [],
                page: 1,
                loading: false,
                canBeLoaded: true
            },
            receivers: {
                id: null,
                data: [],
                body: null,
                page: 1,
                loading: false,
                canBeLoaded: true,
                templateName: null,
                bulkSendingType: null
            },
            bulkSendingTypes: [{ Id: null, Name: 'все' }, { Id: 1, Name: 'sms' }, { Id: 2, Name: 'email' }, { Id: 3, Name: 'уведомления' }],
            historyBulkSendingType: null,
            historyDateStart: null,
            historyDateEnd: null,
            smtpSettings: [{ Id: 1, Name: 'name-1' }, { Id: 2, Name: 'name-2' }],
            smtpServerId: null,
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        display: false,
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                },
                animation: {
                    animateScale: true,
                    animateRotate: true
                },
                tooltips: {
                    enabled: true
                }
            },
            chartData: {
                datasets: [{
                    data: [],
                    backgroundColor: ['rgb(244, 255, 129)', 'rgb(114, 138, 154)', 'rgb(97, 216, 24)', 'rgb(239, 3, 72)']
                }],
                labels: ['Отправлено', 'Не отправлено', 'Доставлено', 'Не доставлено']
            },
            smsLimits: null,
            allCurrentUsersSelected: true
        };
    },


    watch: {
        usersCount: function usersCount() {
            this.calculateSmsTextInfo();
        }
    },

    computed: {
        // AllCurrentUsersSelected(){
        //     console.info('l:', this.users.data.filter(x => x.Included).length)
        //     return this.users.data.filter(x => x.Included).length === this.users.data.length;
        // },

        showAddTemplateBtn: function showAddTemplateBtn() {
            return !this.templatesByCurrentType.some(function (x) {
                return x.Id === 0;
            });
        },
        templatesByCurrentType: function templatesByCurrentType() {
            var bulkSendingTypeId = 1;
            switch (this.activeTab) {
                case 'email':
                    bulkSendingTypeId = 2;
                    break;
                case 'notification':
                    bulkSendingTypeId = 3;
                    break;
            }
            return this.templates.filter(function (x) {
                return x.BulkSendingTypeId === bulkSendingTypeId;
            });
        },
        activeBulkSendingTypeId: function activeBulkSendingTypeId() {
            var bulkSendingTypeId = 1;
            switch (this.activeTab) {
                case 'email':
                    bulkSendingTypeId = 2;
                    break;
                case 'notification':
                    bulkSendingTypeId = 3;
                    break;
            }
            return bulkSendingTypeId;
        },
        resultUsersCount: function resultUsersCount() {
            if (this.allCurrentUsersSelected) {
                return this.usersCount - this.users.data.filter(function (x) {
                    return !x.Included;
                }).map(function (x) {
                    return x.Id;
                }).length;
            } else {
                return this.users.data.filter(function (x) {
                    return x.Included;
                }).map(function (x) {
                    return x.Id;
                }).length;
            }
        },
        smsSendingAllowed: function smsSendingAllowed() {
            return this.smsLimits != null && this.smsLimits.total - this.smsLimits.today - this.resultUsersCount >= 0;
        },
        startSendingText: function startSendingText() {
            return this.activeTab === 'notification' ? 'Отправить уведомления' : 'Запустить рассылку';
        }
    },

    methods: {
        currentUsersSelectAll: function currentUsersSelectAll($event) {
            var vm = this;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = this.users.data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var u = _step2.value;

                    u.Included = vm.allCurrentUsersSelected;
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        },
        onHistoryFilterClear: function onHistoryFilterClear() {
            this.historyBulkSendingType = null;
            this.historyDateStart = null;
            this.historyDateEnd = null;

            this.bulkSendingReload();
        },
        onPushTemplateVariable: function onPushTemplateVariable(variable) {
            if (this.activeTab === 'sms') {
                var $smsBody = $(this.$refs['smsBody']);
                var index = $smsBody.prop("selectionStart");
                if (index != undefined) {
                    var arr = this.currentTemplate.Body ? this.currentTemplate.Body.split('') : [];
                    arr.splice(index, 0, variable);
                    this.currentTemplate.Body = arr.join('');
                } else {
                    this.currentTemplate.Body += variable;
                }
            }
            if (this.activeTab === 'email' || this.activeTab === 'notification') {
                this.$refs['EmailBody'].insert(variable);
            }
        },
        onPushSheduleTemplateVariable: function onPushSheduleTemplateVariable(variable) {
            this.$refs['SheduleEmailBody'].insert(variable);
        },
        onReceiversClick: function onReceiversClick(history) {
            this.$refs['ppReceivers'].show();

            this.receivers.id = history.Id;
            this.receivers.data = [];
            this.receivers.page = 1;
            this.receivers.loading = false;
            this.receivers.canBeLoaded = true;
            this.receivers.bulkSendingType = history.BulkSendingType;
            this.receivers.RecTotal = history.ReceiversCount;
            this.receivers.BulkSendingTypeId = history.BulkSendingTypeId;
            this.receivers.AllowEdit = history.AllowEdit;
            this.receiversLoadNext();
            console.info('onReceiversClick BulkSendingTypeId', this.receivers.BulkSendingTypeId, history.AllowEdit);
        },
        openCurrentUsers: function openCurrentUsers() {

            this.$refs['ppCurrentUsers'].show();

            if (!this.users.data.length || this.forceNewLoadNext) {
                if (this.forceNewLoadNext) {
                    this.forceNewLoadNext = false;
                }
                this.loadNext();
            }
        },
        ppCurrentUsersClosed: function ppCurrentUsersClosed() {
            this.calculateSmsTextInfo();

            if (this.activeTab === 'history') {
                this.$refs['ppReceiversShedule'].show();
            }
        },
        onReceiversSheduleClick: function onReceiversSheduleClick() {
            //return moment().startOf('day').seconds(seconds).format('HH:mm:ss');

            var vm = this;
            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('#app', 'Загрузка...');

            this.callApiWrapper(backendApi.bulkSending(this.receivers.id)).then(function (response) {
                if (response.hasError) {
                    if (response.status === 401) {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Недостаточно прав');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при загрузке уведомления');
                    }
                } else {
                    vm.currentTemplate = response.data;
                    if (vm.currentTemplate.StartDate) {
                        vm.currentTemplate.StartDateFormatted = Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(vm.currentTemplate.StartDate).format('DD.MM.YYYY');
                        vm.currentTemplate.StartSendTimeFormatted = Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(vm.currentTemplate.StartDate).format('HH:mm:ss');
                    }

                    vm.closeModal('ppReceivers');
                    vm.$refs['ppReceiversShedule'].show();
                    //console.info('onReceiversClick', vm.currentTemplate, vm.receivers.id);

                    vm.allCurrentUsersSelected = false;
                    vm.currentUsersSelectAll();
                    vm.forceNewLoadNext = true;

                    _.filter(vm.receivers.data, function (x) {
                        var user = vm.users.data.filter(function (y) {
                            return y.Id === x.UserId;
                        });
                        if (user.length > 0) {
                            user[0].Included = true;
                        } else {
                            vm.users.data.push({ Id: x.UserId, Included: true, Fio: x.Fio, Email: '', PhoneNumber: '' });
                        }
                        x.Included = vm.receivers.data.filter(function (y) {
                            return y.UserId === x.Id;
                        }) != null;
                    });
                }
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            });
        },
        onTemplateSave: function onTemplateSave() {
            var _this = this;

            var vm = this;
            var bulkSendingTypeId = this.activeBulkSendingTypeId;

            this.$validator.validate().then(function (result) {
                if (!result) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                } else {
                    var saveObj = {
                        Id: vm.currentTemplate.Id,
                        ProjectId: vm.projectId,
                        Body: vm.currentTemplate.Body,
                        Name: vm.currentTemplate.Name,
                        BulkSendingTypeId: bulkSendingTypeId,
                        Header: vm.currentTemplate.Header
                    };

                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('#app', 'Сохранение...');
                    _this.callApiWrapper(backendApi.bulkSendingTemplateSave(saveObj)).then(function (response) {
                        if (response.hasError) {
                            if (response.status === 401) {
                                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Недостаточно прав');
                            } else {
                                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении проекта');
                            }
                        } else {
                            vm.currentTemplate.Id = response.data;
                            vm.loadTemplates();
                        }

                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
                    });
                }
            });
        },
        onStartSending: function onStartSending() {
            var vm = this;

            if (vm.activeTab === 'email' && !this.currentTemplate.Name) {
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Укажите тему письма');
            } else {
                if (confirm('Вы уверены что хотите запустить рассылку по выбранным пользователям?')) {
                    var notIncluded = void 0;
                    if (vm.allCurrentUsersSelected) {
                        notIncluded = this.users.data.filter(function (x) {
                            return !x.Included;
                        }).map(function (x) {
                            return x.Id;
                        });
                    } else {
                        notIncluded = this.users.data.filter(function (x) {
                            return x.Included;
                        }).map(function (x) {
                            return x.Id;
                        });
                    }

                    var filterFormatted = '';
                    if (this.filter) {
                        filterFormatted = processFilter(this.filter).map(function (x) {
                            return JSON.stringify(x);
                        });
                    }
                    var saveObj = {
                        TemplateId: this.currentTemplate.Id,
                        NotIncluded: notIncluded,
                        Filter: filterFormatted,
                        ProjectId: this.projectId,
                        TemplateName: this.currentTemplate.Name,
                        Body: this.currentTemplate.Body,
                        BulkSendingTypeId: this.activeBulkSendingTypeId,
                        SmtpServerId: this.smtpServerId,
                        RoleId: this.roleId,
                        DateSortEmpty: this.dateSortEmpty,
                        DateSortType: this.dateSortType,
                        DateStart: Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(this.dateStart, 'DD.MM.YYYY').format(),
                        DateEnd: Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(this.dateEnd, 'DD.MM.YYYY').format(),
                        AllCurrentUsersSelected: this.allCurrentUsersSelected,
                        Header: this.currentTemplate.Header,
                        DateStartSent: Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(this.dateStartSent + ' ' + this.timeStartSent, 'DD.MM.YYYY HH:mm:ss').format()
                    };
                    console.info('commonBulkSending', saveObj);
                    this.callApiWrapper(backendApi.commonBulkSending(saveObj)).then(function (response) {
                        if (response.hasError) {
                            if (response.status === 401) {
                                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Недостаточно прав');
                            } else {
                                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при создании рассылки');
                            }
                        } else {
                            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно создано');
                            vm.onTabChange('history');
                        }

                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
                    });
                }
            }
        },
        onSendToMe: function onSendToMe() {
            var vm = this;
            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('#app', 'Отправка...');

            this.callApiWrapper(backendApi.bulkSendingTest(this.currentTemplate.Body, this.currentTemplate.Name, this.activeBulkSendingTypeId, this.smtpServerId, this.projectId, this.currentTemplate.Header)).then(function (response) {
                if (response.hasError) {
                    if (response.status === 401) {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Недостаточно прав');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при отправке');
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно отправлено');
                    if (vm.info) {
                        vm.info.NotificationsLength = vm.info.NotificationsLength + 1;
                    }
                }

                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            });
        },
        onRemoveTemplate: function onRemoveTemplate(template, index) {
            var _this2 = this;

            var vm = this;
            if (confirm('Удалить шаблон?')) {
                var bulkSendingTypeId = 1;
                if (this.activeTab === 'email') {
                    bulkSendingTypeId = 2;
                }

                var currentIndex = -1;

                var _loop2 = function _loop2(i) {
                    if (_this2.templates[i].BulkSendingTypeId === bulkSendingTypeId) {
                        currentIndex++;
                        if (currentIndex === index) {

                            if (_this2.templates[i].Id > 0) {
                                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('#app', 'Сохранение...');
                                _this2.callApiWrapper(backendApi.bulkSendingTemplateDelete(_this2.templates[i].Id)).then(function (response) {
                                    if (response.hasError) {
                                        if (response.status === 401) {
                                            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Недостаточно прав');
                                        } else {
                                            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при удалении шаблона');
                                        }
                                    } else {
                                        vm.templates.splice(i, 1);
                                    }

                                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
                                });
                            } else {
                                _this2.templates.splice(i, 1);
                            }
                            return 'break';
                        }
                    }
                };

                for (var i = 0; i < this.templates.length; i++) {
                    var _ret2 = _loop2(i);

                    if (_ret2 === 'break') break;
                }
            }
        },
        onBulkSendingSave: function onBulkSendingSave() {
            var id = this.receivers.id;
            var vm = this;
            vm.currentTemplate.StartDate = Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(vm.currentTemplate.StartDateFormatted + ' ' + vm.currentTemplate.StartSendTimeFormatted, 'DD.MM.YYYY HH:mm:ss').format();
            var filterFormatted = '';
            if (this.filter) {
                filterFormatted = processFilter(this.filter).map(function (x) {
                    return JSON.stringify(x);
                });
            }
            var notIncluded = void 0;
            if (vm.allCurrentUsersSelected) {
                notIncluded = this.users.data.filter(function (x) {
                    return !x.Included;
                }).map(function (x) {
                    return x.Id;
                });
            } else {
                notIncluded = this.users.data.filter(function (x) {
                    return x.Included;
                }).map(function (x) {
                    return x.Id;
                });
            }

            var saveObj = {
                Id: id,
                Name: vm.currentTemplate.Name,
                Header: vm.currentTemplate.Header,
                Body: vm.currentTemplate.Body,
                StartDateSent: vm.currentTemplate.StartDate,
                RoleId: this.roleId,
                DateSortEmpty: this.dateSortEmpty,
                DateSortType: this.dateSortType,
                DateStart: Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(this.dateStart, 'DD.MM.YYYY').format(),
                DateEnd: Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(this.dateEnd, 'DD.MM.YYYY').format(),
                Filter: filterFormatted,
                NotIncluded: notIncluded,
                AllCurrentUsersSelected: this.allCurrentUsersSelected
            };

            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('#app', 'Сохранение...');

            this.callApiWrapper(backendApi.bulkSendingSave(saveObj)).then(function (response) {
                if (response.hasError) {
                    if (response.status === 401) {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Недостаточно прав');
                    } else if (response.status === 203) {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Уведомление было отправлено ранее. Изменения невозможны');
                        var bs = vm.bulkSending.data.filter(function (x) {
                            return x.Id === id;
                        })[0];
                        if (bs) {
                            bs.AllowEdit = false;
                        }
                        vm.closeModal('ppReceiversShedule');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении уведомления');
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.success('Уведомление успешно сохранено');
                    //let bs = vm.bulkSending.data.filter(x => x.Id === id)[0];
                    //if(bs) {
                    //    //bs.AllowEdit = false;
                    //    bs.Header = saveObj.Header;
                    //    bs.Header = saveObj.Header;
                    //    bs.Header = saveObj.Header;
                    //}

                    vm.closeModal('ppReceiversShedule');
                }
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            });
        },
        onBulkSendingDelete: function onBulkSendingDelete() {
            if (!confirm('Вы уверены что хотите отменить данное уведомление?')) {
                return;
            }
            var id = this.receivers.id;
            console.info('onDeleteBulkSending', id);
            var vm = this;
            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('#app', 'Отмена...');

            this.callApiWrapper(backendApi.bulkSendingDelete(id)).then(function (response) {
                if (response.hasError) {
                    if (response.status === 401) {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Недостаточно прав');
                    } else if (response.status === 203) {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Уведомление было отправлено ранее. Изменения невозможны');
                        var bs = vm.bulkSending.data.filter(function (x) {
                            return x.Id === id;
                        })[0];
                        if (bs) {
                            bs.AllowEdit = false;
                        }
                        vm.closeModal('ppReceiversShedule');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при удалении уведомления');
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.success('Уведомление успешно удалено');
                    vm.bulkSending.data = vm.bulkSending.data.filter(function (x) {
                        return x.Id !== id;
                    });

                    vm.closeModal('ppReceiversShedule');
                }
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            });
        },
        loadTemplates: function loadTemplates() {
            var vm = this;

            return this.callApiWrapper(backendApi.bulkSendingTemplates(vm.projectId)).then(function (resp) {
                if (resp.data) {
                    vm.templates = resp.data;
                }
            });
        },
        calculateSmsTextInfo: function calculateSmsTextInfo() {
            var formattedBody = (this.currentTemplate && this.currentTemplate.Body ? this.currentTemplate.Body : '').replace('%ФИО%', '111111111111111111111111') // 24
            .replace('%Фамилия%', '11111111') // 8
            .replace('%Имя%', '11111111') // 8
            .replace('%Отчество%', '11111111') // 8
            .replace('%БаллыАктивные%', '11111') // 5
            .replace('%БаллыПотенциальные%', '11111') // 5
            .replace('%АктивацияАккаунта%', '').replace('%БаллыТекМесяц%', '11111'); // 5

            var total = formattedBody.length;
            var onlyEnglish = false;
            if (this.currentTemplate) {
                onlyEnglish = /^[A-Z0-9]*$/ig.test(this.currentTemplate.Body);
            }

            var maxSymbolsForMessage = 70;
            if (total > 70) {
                maxSymbolsForMessage = 67;
            }

            if (onlyEnglish) {
                maxSymbolsForMessage = 160;
                if (total > 160) {
                    maxSymbolsForMessage = 154;
                }
            }

            this.smsTextInfo.messages = Math.floor(total / maxSymbolsForMessage) + (total > 0 ? 1 : 0);
            this.smsTextInfo.symbolsLeft = maxSymbolsForMessage * (this.smsTextInfo.messages > 0 ? this.smsTextInfo.messages : 1) - total;
            this.smsTextInfo.symbolsTotal = total;

            this.smsTextInfo.averagePrice = (2.89 * this.smsTextInfo.messages * this.resultUsersCount).toFixed(2);
        },
        addTemplate: function addTemplate() {
            var bulkSendingTypeId = 1;
            if (this.activeTab === 'email') {
                bulkSendingTypeId = 2;
            }
            var newTemplate = {
                Id: 0,
                Name: 'Новый шаблон',
                Body: '',
                BulkSendingTypeId: bulkSendingTypeId,
                CreateDate: new Date(),
                CreatorFio: this.info.User.Fio
            };

            this.templates.push(newTemplate);
            this.currentTemplate = newTemplate;
        },
        onTemplateSelect: function onTemplateSelect(template) {
            var vm = this;

            if (!this.currentTemplate || this.currentTemplate.Id != template.Id) {
                this.users.data = [];
            }
            this.currentTemplate = template;

            if (this.activeTab === 'sms') {
                this.calculateSmsTextInfo();
            }
            if (this.activeTab === 'email' || this.activeTab === 'notification') {
                this.$nextTick(function () {
                    vm.$refs['EmailBody'].setHtml(template.Body);
                });
                this.calculateSmsTextInfo();
            }
        },
        onTabChange: function onTabChange(tab) {
            var vm = this;

            this.activeTab = tab;
            this.currentTemplate = null;

            if (tab === 'history') {
                this.bulkSendingReload();
            }

            //if(tab === 'sms' || tab === 'email' || tab === 'notification') {
            this.currentTemplate = {
                Id: null,
                Body: null,
                Name: null,
                Header: null
            };
            //}
            if (tab === 'email' || tab === 'notification') {
                this.$nextTick(function () {
                    vm.$refs['EmailBody'].setHtml('');
                });
            }
            if (tab === 'log') {
                this.log.data = [];
                this.log.page = 1;
                this.loadLogNext();
            }
            if (tab === 'sms') {
                this.loadSmsLimits();
            }
        },
        loadSmsLimits: function loadSmsLimits() {
            var vm = this;
            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('#app');

            return this.callApiWrapper(backendApi.smsLimits()).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки информации по лимитам сообщений');
                } else {
                    if (resp.data) {
                        vm.smsLimits = resp.data;
                    }
                }
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            });
        },
        searchFunction: function searchFunction(tableName, columnName, search, filters, searchPage, callback) {
            var vm = this;
            if (columnName === 'TermsConfirmed' || columnName === 'PersonalDataEditingAccept' || columnName === 'NotificationsEnabled') {
                callback(['Да', 'Нет']);
            } else if (columnName === 'PassportVerificationState') {
                callback(['документы отсутствуют', 'проверь документы!', 'документы подтверждены', 'документы возвращены']);
            } else if (columnName === 'RegisterStatus') {
                callback(['неактивен', 'проверка', 'активен', 'отказано', 'отключен', 'заблокирован']);
            } else if (columnName === 'MinActivity') {
                callback([MinActivityEnum.Day15.Text, MinActivityEnum.Day30.Text, MinActivityEnum.Day45.Text]);
            } else if (columnName === 'MaxActivity') {
                callback([MaxActivityEnum.Day5.Text, MaxActivityEnum.Day15.Text, MaxActivityEnum.Day30.Text]);
            } else if (columnName === 'MinBonus') {
                callback([MinBonusEnum["1"].Text, MinBonusEnum["1000"].Text, MinBonusEnum["5000"].Text, MinBonusEnum["10000"].Text]);
            } else {
                var filterFormatted = '';
                if (filters) {
                    filterFormatted = processFilter(filters).map(function (x) {
                        return JSON.stringify(x);
                    });
                }

                this.callApiWrapper(backendApi.userDistinctValues(columnName, vm.projectId, search, filterFormatted, (searchPage - 1) * 30, 30)).then(function (resp) {
                    callback(resp.data);
                });
            }
        },
        onFilterChange: function onFilterChange(filter) {
            console.info('onFilterChange', filter);
            this.filter = filter;
            this.users.data = [];
            this.loading = false;
            this.canBeLoaded = true;
            this.page = 1;

            this.loadUsersCount();
            this.loadNext();
        },
        loadRoles: function loadRoles() {
            var vm = this;
            return this.callApiWrapper(backendApi.rolesList(vm.projectId)).then(function (resp) {
                if (resp.data) {

                    for (var r = 0; r < resp.data.Roles.length; r++) {
                        vm.roles.push({
                            Id: resp.data.Roles[r].Id,
                            Name: resp.data.Roles[r].Name,
                            Claims: resp.data.Roles[r].Claims
                        });
                        if (vm.roleId == null && resp.data.Roles[r].Claims.find(function (x) {
                            return x.ClaimId === vm.claimEnums.bonusSpend;
                        })) {
                            vm.roleId = resp.data.Roles[r].Id;
                        }
                    }
                }
            });
        },
        loadNext: function loadNext() {
            var vm = this;

            vm.users.loading = true;
            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('#app', 'Загрузка...');

            var dateStart = Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(vm.dateStart, 'DD.MM.YYYY'),
                dateEnd = Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(vm.dateEnd, 'DD.MM.YYYY');
            if ((dateStart.year() || 0) < 2000) {
                dateStart = null;
            }
            if ((dateEnd.year() || 0) < 2000) {
                dateEnd = null;
            }

            //console.info('loadNext->[dateStart, dateEnd]', [dateStart, dateEnd]);

            this.callApiWrapper(backendApi.usersList((this.users.page - 1) * rowsPerPage, rowsPerPage, vm.projectId, processFilter(vm.filter), this.roleId, this.dateSortEmpty, vm.dateSortType, dateStart ? dateStart.format() : null, dateEnd ? dateEnd.format() : null)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки пользователей');
                } else {
                    if (resp.data && resp.data.length) {
                        if (vm.activeTab === 'history') {
                            console.info('loadNext->[dateStart, dateEnd]', resp.data);
                            _.filter(resp.data, function (x) {
                                var user = vm.users.data.filter(function (y) {
                                    return y.Id === x.Id;
                                });
                                if (user.length === 0) {
                                    vm.users.data.push({ Id: x.Id, Included: false, Fio: x.Fio, Email: x.Email, PhoneNumber: x.PhoneNumber });
                                }
                            });
                        } else {
                            var _vm$users$data;

                            for (var i = 0; i < resp.data.length; i++) {
                                resp.data[i].Included = vm.allCurrentUsersSelected;
                            }
                            (_vm$users$data = vm.users.data).push.apply(_vm$users$data, _toConsumableArray(resp.data));
                        }
                    } else {
                        vm.users.canBeLoaded = false;
                    }
                }
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
                vm.users.loading = false;
            });
        },
        loadLogNext: function loadLogNext() {
            var vm = this;

            vm.log.loading = true;
            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('#app', 'Загрузка...');

            this.callApiWrapper(backendApi.bulkSendingLogs((this.log.page - 1) * rowsPerPage, rowsPerPage, vm.projectId)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки сервисных сообщений');
                } else {
                    if (resp.data && resp.data.length) {
                        var _vm$log$data;

                        (_vm$log$data = vm.log.data).push.apply(_vm$log$data, _toConsumableArray(resp.data));
                    } else {
                        vm.log.canBeLoaded = false;
                    }
                }
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
                vm.log.loading = false;
            });
        },
        onCurrentUsersSroll: function onCurrentUsersSroll() {
            var vm = this;

            if (!vm.users.loading && vm.users.canBeLoaded) {
                vm.users.page++;
                vm.loadNext();
            }
        },
        receiversLoadNext: function receiversLoadNext() {
            var vm = this;

            vm.receivers.loading = true;
            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('#app', 'Загрузка...');
            this.callApiWrapper(backendApi.bulkSendingReceiversList((this.receivers.page - 1) * rowsPerPage, rowsPerPage, this.receivers.id)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки пользователей');
                } else {
                    if (resp.data && resp.data.list.length) {
                        var _vm$receivers$data;

                        for (var i = 0; i < resp.data.list.length; i++) {
                            var statusFormatted = 'Не отправлено';
                            if (resp.data.list[i].SentDate != null && resp.data.list[i].Sent === true || vm.receivers.BulkSendingTypeId === BulkSendingType.notification && !vm.receivers.AllowEdit) {
                                statusFormatted = 'Отправлено';
                            }
                            if (resp.data.list[i].DeliveredDate != null && resp.data.list[i].Delivered === true) {
                                statusFormatted = 'Доставлено';
                            }
                            if (resp.data.list[i].DeliveredDate != null && resp.data.list[i].Delivered === false) {
                                statusFormatted = 'Не доставлено';
                            }
                            if (resp.data.list[i].Dublicate) {
                                statusFormatted = 'Дубликат';
                            }

                            resp.data.list[i].StatusFormatted = statusFormatted;
                        }
                        (_vm$receivers$data = vm.receivers.data).push.apply(_vm$receivers$data, _toConsumableArray(resp.data.list));

                        var stats = resp.data.bulkSendingStat;

                        vm.receivers.body = stats.Body;
                        vm.receivers.templateName = stats.TemplateName;

                        if (vm.receivers.page === 1) {
                            vm.chartData = {
                                datasets: [{
                                    data: [stats.NotSentCount, stats.SentCount - stats.NotDeliveredCount - stats.DeliveredCount, stats.NotDeliveredCount, stats.DeliveredCount],
                                    backgroundColor: ['rgb(114, 138, 154)', 'rgb(244, 255, 129)', 'rgb(239, 3, 72)', 'rgb(97, 216, 24)']
                                }],
                                labels: ['Не отправлено', 'Отправлено', 'Не доставлено', 'Доставлено']
                            };
                        }
                    } else {
                        vm.receivers.canBeLoaded = false;
                    }
                }
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
                vm.receivers.loading = false;
            });
        },
        onReceiversSroll: function onReceiversSroll() {
            var vm = this;

            if (!vm.receivers.loading && vm.receivers.canBeLoaded) {
                vm.receivers.page++;
                vm.receiversLoadNext();
            }
        },
        loadUsersCount: function loadUsersCount() {
            var vm = this;

            vm.loading = true;
            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('#app', 'Загрузка...');
            var dateStart = Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(vm.dateStart, 'DD.MM.YYYY'),
                dateEnd = Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(vm.dateEnd, 'DD.MM.YYYY');
            if ((dateStart.year() || 0) < 2000) {
                dateStart = null;
            }
            if ((dateEnd.year() || 0) < 2000) {
                dateEnd = null;
            }

            this.callApiWrapper(backendApi.usersCount(vm.projectId, processFilter(vm.filter), this.roleId, this.dateSortEmpty, vm.dateSortType, dateStart ? dateStart.format() : null, dateEnd ? dateEnd.format() : null)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки пользователей');
                } else {
                    if (resp.data != null) {

                        vm.users.page = 1;
                        vm.users.data = [];
                        vm.users.canBeLoaded = true;
                        vm.users.loading = false;

                        vm.usersCount = resp.data;
                    } else {
                        vm.canBeLoaded = false;
                    }
                }
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
                vm.loading = false;
            });
        },
        onProjectChange: function onProjectChange(item) {
            var vm = this;
            this.projectId = item.Id;

            this.users.page = 1;
            this.users.data = [];
            this.users.canBeLoaded = true;
            this.users.loading = false;
            this.roles = [];

            this.bulkSending.page = 1;
            this.bulkSending.loading = false;
            this.bulkSending.canBeLoaded = false;
            this.bulkSending.data = [];

            vm.loadRoles().then(function () {
                // if(vm.roles.length){
                //     vm.roleId = vm.roles[0].Id;
                // }
                vm.loadUsersCount();
                vm.loadTemplates();
                vm.bulkSendingLoadNext();
            });
            this.$emit('user-updated');
        },
        onRoleChange: function onRoleChange(item) {
            this.loadUsersCount();
            this.forceNewLoadNext = true;
        },
        onRoleChangeFromPopup: function onRoleChangeFromPopup() {
            this.loadUsersCount();
            this.forceNewLoadNext = true;
            this.loadNext();
        },
        onDateChange: function onDateChange() {
            this.loadUsersCount();
            this.loadNext();
            //this.forceNewLoadNext = true;
        },
        onSortTypeChange: function onSortTypeChange() {
            this.loadUsersCount();
            this.loadNext();
            //this.forceNewLoadNext = true;
        },
        onDateSortEmptyChange: function onDateSortEmptyChange() {
            this.loadUsersCount();
            this.loadNext();
            //this.forceNewLoadNext = true;
        },
        clearFilterState: function clearFilterState() {
            var _this3 = this;

            this.dateStart = '';
            this.dateEnd = '';
            this.dateSortType = 'DateRegister';
            this.dateSortEmpty = false;

            for (var r = 0; r < this.roles.length; r++) {
                if (this.roles[r].Claims.find(function (x) {
                    return x.ClaimId === _this3.claimEnums.bonusSpend;
                })) {
                    this.roleId = this.roles[r].Id;
                }
            }

            localStorage.removeItem('senderCurrentUsersFilterKey');
            this.filter = null;
            this.loadUsersCount();
            this.loadNext();
        },
        bulkSendingReload: function bulkSendingReload() {
            this.bulkSending.page = 1;
            this.bulkSending.loading = false;
            this.bulkSending.canBeLoaded = false;
            this.bulkSending.data = [];
            this.bulkSendingLoadNext();
        },
        bulkSendingLoadNext: function bulkSendingLoadNext() {
            var vm = this;

            vm.bulkSending.loading = true;
            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('#app', 'Загрузка...');

            console.info('loadNext->[dateStart, dateEnd]', [Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(vm.historyDateStart, 'DD.MM.YYYY').format(), Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(vm.historyDateEnd, 'DD.MM.YYYY').format()]);
            this.callApiWrapper(backendApi.bulkSendingList((this.bulkSending.page - 1) * rowsPerPage, rowsPerPage, vm.historyBulkSendingType, vm.projectId, Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(vm.historyDateStart, 'DD.MM.YYYY').format(), Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(vm.historyDateEnd, 'DD.MM.YYYY').format())).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки пользователей');
                } else {
                    if (resp.data && resp.data.length) {
                        var _vm$bulkSending$data;

                        (_vm$bulkSending$data = vm.bulkSending.data).push.apply(_vm$bulkSending$data, _toConsumableArray(resp.data));
                    } else {
                        vm.bulkSending.canBeLoaded = false;
                    }
                }
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
                vm.bulkSending.loading = false;
            });
        },
        loadSmtpSettings: function loadSmtpSettings() {
            var vm = this;

            return this.callApiWrapper(backendApi.smtpSettings()).then(function (resp) {
                if (resp.data) {

                    vm.smtpSettings = resp.data;
                }
            });
        },
        onCurrentUsersExport: function onCurrentUsersExport() {
            var vm = this;
            var projectId = vm.projectId,
                roleId = vm.roleId,
                dateSortEmpty = vm.dateSortEmpty,
                dateSortType = vm.dateSortType,
                notIncluded = vm.users.data.filter(function (x) {
                return !x.Included;
            }).map(function (x) {
                return x.Id;
            });
            var dateStart = vm.dateStart && Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(vm.dateStart, 'DD.MM.YYYY').toISOString();
            var dateEnd = vm.dateEnd && Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(vm.dateEnd, 'DD.MM.YYYY').toISOString();

            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('#app');
            vm.callApiWrapper(backendApi.userExport(projectId, processFilter(vm.filter), roleId, dateSortEmpty, dateSortType, dateStart, dateEnd, notIncluded.join(','))).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время экспорта');
                } else {
                    var exportFile = resp.data;
                    if (exportFile != null) {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].downloadFileByBytes(exportFile, 'Пользователи.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                    }
                }

                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            });
        },
        getFilterForUri: function getFilterForUri() {
            var str = '';
            if (this.filter) {
                var processedFilter = processFilter(this.filter);
                for (var i = 0; i < processedFilter.length; i++) {
                    var item = processedFilter[i];
                    str += '&filter[' + i + ']=' + JSON.stringify(item);
                }
            }
            return str;
        },
        onExportDetails: function onExportDetails(bulkSendingId) {
            //let guid = this.generateGuid();
            var vm = this;
            var timeZone = new Date().getTimezoneOffset();
            var dateStart = vm.historyDateStart && Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(vm.historyDateStart, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
            var dateEnd = vm.historyDateEnd && Object(__WEBPACK_IMPORTED_MODULE_0_moment__["default"])(vm.historyDateEnd, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
            //console.info('export -> [dateStart, dateEnd]', [dateStart, dateEnd]);
            //UI.blockTillDownloaded(guid, '#app');
            //location.href = config.apiUrl + '/api/bulkSending/exportDetails?bulkSendingId=' + bulkSendingId + '&guid=' + guid +
            //'&historyBulkSendingType=' + this.historyBulkSendingType + '&projectId=' + this.projectId +
            //    '&startDate=' + (dateStart) + '&endDate=' + (dateEnd);

            __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].blockUI('#app');
            vm.callApiWrapper(backendApi.bulkSendingExportDetails(bulkSendingId, vm.historyBulkSendingType, vm.projectId, dateStart, dateEnd)).then(function (resp) {
                if (resp.hasError && resp.status !== 401) {
                    __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время экспорта');
                } else {
                    var exportFile = resp.data;
                    if (exportFile != null) {
                        __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].downloadFileByBytes(exportFile, 'Детализация рассылки.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                    }
                }
                __WEBPACK_IMPORTED_MODULE_3__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            });
        },
        onRepeat: function onRepeat() {
            var vm = this;

            vm.closeModal('ppReceivers');
            //console.table(vm.receivers.bulkSendingType)
            vm.activeTab = vm.receivers.bulkSendingType.toLowerCase();

            vm.currentTemplate = {
                Id: null,
                Body: vm.receivers.body,
                Name: vm.receivers.templateName
            };

            if (vm.receivers.bulkSendingType === 'Email') {
                vm.$nextTick(function () {
                    vm.$refs['EmailBody'].setHtml(vm.receivers.body);
                    vm.calculateSmsTextInfo();
                });
            } else {
                this.loadSmsLimits();
                this.calculateSmsTextInfo();
            }

            // todo: подгрузить выбранную роль, фильтры и выбранных пользователей для отправки
        }
    },

    mounted: function mounted() {
        var vm = this;
        Promise.all([vm.loadRoles()]).then(function () {
            vm.loadUsersCount();
            vm.loadTemplates();
            vm.bulkSendingLoadNext();
            vm.loadSmtpSettings();
        });
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(30)))

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__enums__ = __webpack_require__(19);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var backendApi = new __WEBPACK_IMPORTED_MODULE_2__backendApi__["a" /* default */]();
var cacheKey = 'tasks';
var DateTypes = {
    /* Дата заполнения */
    FillingDate: 1,
    /* Дата отчета */
    ReportDate: 2,
    /* Дата изменения статуса */
    StatusDate: 3
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "sku",

    props: ['info'],

    mixins: [__WEBPACK_IMPORTED_MODULE_3__helpers_project_mixin__["a" /* default */]], // projectId

    data: function data() {
        return {
            tasks: [],
            tasksCompleted: false,
            loading: false,
            canBeLoaded: true,
            page: 1,
            rowsPerPage: 20,
            projectId: null,
            search: null,
            active: true,
            importResult: null,
            groups: [],
            groupsOrigin: null,
            lastGroupId: null,
            scrollTop: null,
            firstLoad: true,
            emptyResults: false,
            statusId: DateTypes.FillingDate,
            dateTypeId: null,
            dateStart: null,
            dateEnd: null,
            statuses: [{ Id: 0, Name: 'Все ответы' }, { Id: 1, Name: 'Ждут проверки' }, { Id: 2, Name: 'Проверенные' }, { Id: 3, Name: 'Доработанные' }, { Id: 4, Name: 'На доработке' }, { Id: 5, Name: 'Отклоненные' }],
            dateTypes: [{ Id: DateTypes.FillingDate, Name: ' Дата заполнения' }, { Id: DateTypes.ReportDate, Name: 'Дата отчета' }, { Id: DateTypes.StatusDate, Name: 'Дата изменения статуса' }],
            TaskTypes: __WEBPACK_IMPORTED_MODULE_6__enums__["r" /* TaskTypes */],
            PurposeType: __WEBPACK_IMPORTED_MODULE_6__enums__["h" /* PurposeType */],
            ScoringAccrualTypes: __WEBPACK_IMPORTED_MODULE_6__enums__["n" /* ScoringAccrualTypes */]
        };
    },


    computed: {},

    watch: {
        '$route.query.folderId': function $routeQueryFolderId(to, from) {
            this.reload();
        }
    },

    methods: {
        onTasksCompleted: function onTasksCompleted(paramcompleted) {
            this.tasksCompleted = paramcompleted === 1;
            this.reload();
        },
        onItemClick: function onItemClick(id) {
            this.saveFilterState();
            this.$router.push('/tasks/' + id);
        },
        addTask: function addTask() {
            this.saveFilterState();
            this.$router.push('/tasks/edit/' + this.projectId + '/0');
        },
        onEditTask: function onEditTask(id) {
            this.saveFilterState();
            this.$router.push('/tasks/edit/' + this.projectId + '/' + id);
        },
        tasksTable: function tasksTable() {
            this.saveFilterState();
            this.$router.push('/tasks/table');
        },
        onScoringAccrualSum: function onScoringAccrualSum(item) {
            var vm = this;
            return '+' + item.ScoringAccrualSumText;
            //return '+' + item.ScoringAccrualSum + (item.ScoringAccrual === vm.ScoringAccrualTypes.SumPercent ? '%' : '');
        },
        reload: function reload() {
            var vm = this;

            this.page = 1;
            this.loading = false;
            this.canBeLoaded = true;
            this.EndDate = [];
            this.tasks = [];
            //this.lastGroupId = null;
            this.firstLoad = true;
            this.emptyResults = false;

            //Promise.all([this.loadSettings(), this.loadGroups()]).then(function () {
            //    if (!vm.loading && vm.canBeLoaded) {
            //        vm.loadNext();
            //    }
            //});
            this.loadNext();
        },
        loadNext: function loadNext() {
            var vm = this;
            this.loading = true;
            var skip = (vm.page - 1) * vm.rowsPerPage;
            var take = vm.rowsPerPage;
            if (vm.firstLoad && vm.page > 1) {
                skip = 0;
                take = vm.page * vm.rowsPerPage;
            }

            if (vm.info.User.MainRole !== 'administrators') {
                if (!vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.tasksPage)) {
                    this.$router.push('/');
                    return;
                }
                //if (!vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.tasksEdit) && vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.tasksController)) {
                //    this.tasksTable();
                //    return;
                //}
            }
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');

            this.callApiWrapper(backendApi.tasksList(skip, take, vm.projectId, vm.tasksCompleted ? 1 : 0)).then(function (resp) {
                if (resp.hasError) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки заданий');
                } else if (resp.data.tasks && resp.data.tasks.length) {
                    var _vm$tasks;

                    (_vm$tasks = vm.tasks).push.apply(_vm$tasks, _toConsumableArray(resp.data.tasks));

                    if (vm.firstLoad) {
                        vm.firstLoad = false;
                        if (vm.scrollTop) {
                            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').animate({ scrollTop: vm.scrollTop }, 500);
                        }
                    }
                } else {
                    vm.canBeLoaded = false;
                    if (vm.search && !vm.sku.length) {
                        vm.emptyResults = true;
                    }
                }
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
                vm.loading = false;
            }).catch(function (err) {
                console.info('err', err);
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки');
            });
        },
        onProjectChange: function onProjectChange(item) {
            this.projectId = item.Id;
            if (this.$route.query.folderId) {
                this.$router.replace({ query: {} });
            }
            this.reload();
            this.$emit('user-updated');
        },
        onStatusChange: function onStatusChange() {
            this.reload();
        },
        onDateChange: function onDateChange() {
            this.reload();
        },
        clearFilterState: function clearFilterState() {
            localStorage.removeItem(cacheKey);
        },
        saveFilterState: function saveFilterState() {
            //console.info('this.statusId:', this.statusId);

            var stateObj = {
                statusId: this.statusId,
                dateTypeId: this.dateTypeId,
                dateStart: this.dateStart,
                dateEnd: this.dateEnd,
                page: this.page,
                scrollTop: this.scrollTop,
                tasksCompleted: this.tasksCompleted
            };
            localStorage.setItem(cacheKey, JSON.stringify(stateObj));
        },
        recoverFilterState: function recoverFilterState() {
            var stateObj = JSON.parse(localStorage.getItem(cacheKey));
            //console.info('recoverFilterState -> stateObj:', stateObj);
            if (stateObj) {
                if (stateObj.statusId != null) {
                    this.statusId = stateObj.statusId;
                }
                if (stateObj.dateTypeId) {
                    this.dateTypeId = stateObj.dateTypeId;
                }
                if (stateObj.dateStart) {
                    this.dateStart = stateObj.dateStart;
                }
                if (stateObj.dateEnd) {
                    this.dateEnd = stateObj.dateEnd;
                }
                if (stateObj.page) {
                    this.page = stateObj.page;
                }
                if (stateObj.scrollTop) {
                    this.scrollTop = stateObj.scrollTop;
                }
                if (stateObj.tasksCompleted) {
                    this.tasksCompleted = stateObj.tasksCompleted;
                }
                this.clearFilterState();
            }
        }
    },

    mounted: function mounted() {
        var vm = this;

        vm.recoverFilterState();

        vm.loadNext();

        vm.$nextTick(function () {

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').on('scroll', function () {
                var elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
                var scrollTop = elem.scrollTop();
                vm.scrollTop = scrollTop;

                if (!vm.loading && vm.canBeLoaded && !vm.firstLoad) {
                    //console.info('elem[0].scrollHeight - elem.scrollTop(), elem.outerHeight()', [elem[0].scrollHeight] - elem.scrollTop(), elem.outerHeight());
                    if (elem[0].scrollHeight - scrollTop - 700 <= elem.outerHeight()) {
                        vm.page++;
                        vm.loadNext();
                    }
                }
            });
        });
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').off('scroll');
    }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__enums__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__config__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var backendApi = new __WEBPACK_IMPORTED_MODULE_2__backendApi__["a" /* default */]();
var cacheKey = 'answers';
var DateTypes = {
  /* Дата заполнения */
  FillingDate: 1,
  /* Дата отчета */
  ReportDate: 2,
  /* Дата изменения статуса */
  StatusDate: 3
};

var processFilter = function processFilter(filter) {
  var resultFilter = JSON.parse(JSON.stringify(filter));
  if (resultFilter) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = resultFilter[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var item = _step.value;

        var filterField = item[0];
        if (filterField === '[dbo].[AspNetUsers].[t.Name]') {
          item[0] = 't.[Name]';
        }
        if (filterField === '[dbo].[AspNetUsers].[ta.Id]') {
          item[0] = 'ta.[Id]';
          item[2] = item[2].replace(new RegExp('\'', 'g'), '');
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  return resultFilter;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "tasks",

  props: ['info'],

  mixins: [__WEBPACK_IMPORTED_MODULE_3__helpers_project_mixin__["a" /* default */]], // projectId

  data: function data() {
    return {
      answers: [],
      rowsPerPage: 20,
      projectId: null,
      search: null,
      active: true,
      importResult: null,
      groups: [],
      groupsOrigin: null,
      lastGroupId: null,
      firstLoad: true,
      emptyResults: false,
      statusId: 0,
      dateTypeId: DateTypes.FillingDate,
      dateStart: null,
      dateEnd: null,
      statuses: [{ Id: 0, Name: 'Все ответы' }, { Id: 1, Name: 'Ждут проверки' }, { Id: 2, Name: 'Проверенные' }, { Id: 3, Name: 'Доработанные' }, { Id: 4, Name: 'На доработке' }, { Id: 5, Name: 'Отклоненные' }],
      dateTypes: [{ Id: DateTypes.FillingDate, Name: ' Дата заполнения' }, { Id: DateTypes.ReportDate, Name: 'Дата изменения ответа' }, { Id: DateTypes.StatusDate, Name: 'Дата изменения статуса' }],
      page: 1,
      canBeLoaded: true,
      loading: false,
      scrollTop: null,
      filter: null,
      userFilters: [{ Value: 'LastName', Name: 'Фамилия' }, { Value: 'FirstName', Name: 'Имя' }, { Value: 'MiddleName', Name: 'Отчество' }, { Value: 't.Name', Name: 'Задание' }, { Value: 'ta.Id', Name: 'Id ответа' }],
      selectAll: false,
      selectedAnswers: [],
      totalCount: 0,
      actionState: {
        currentAnswer: {
          index: 0,
          date: null,
          time: 0
        },
        total: 0,
        messages: [],
        done: false
      },
      popuptitle: 'Причина отправки на доработку',
      commentStatus: '',
      selectStatus: 0,
      currentProjectIds: __WEBPACK_IMPORTED_MODULE_6__enums__["g" /* ProjectIds */][__WEBPACK_IMPORTED_MODULE_7__config___default.a.mode]
    };
  },


  computed: {
    filteredUserFilters: function filteredUserFilters() {
      var vm = this;
      if (vm.hasClaimsOrAdmin(vm.info.User, vm.claimEnums.tasksController) || vm.hasClaimsOrAdmin(vm.info.User, vm.claimEnums.tasksEdit)) {
        return this.userFilters;
      } else {
        return this.userFilters.filter(function (f) {
          return !['LastName', 'FirstName', 'MiddleName'].includes(f.Value);
        });
      }
    }
  },

  watch: {
    '$route.query.folderId': function $routeQueryFolderId(to, from) {
      this.reload();
    }
  },

  methods: {
    getStateClass: function getStateClass(item) {
      return 'task-state-' + item.LastStatus;
    },
    openAnswerTest: function openAnswerTest(taskId, answerId, status) {
      var vm = this;

      if (vm.hasClaimsOrAdmin(vm.info.User, vm.claimEnums.tasksController) || vm.hasClaimsOrAdmin(vm.info.User, vm.claimEnums.tasksEdit)) this.$router.push('/tasks/answer/' + taskId + '/' + answerId + '/checking');else if (vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.bonusSpend)) {
        if (status === __WEBPACK_IMPORTED_MODULE_6__enums__["q" /* TaskAnswerStates */].OnEdition) this.$router.push('/tasks/answer/' + taskId + '/' + answerId + '/edit');else this.$router.push('/tasks/answer/' + taskId + '/' + answerId + '/view');
      }
    },
    onStatusChange: function onStatusChange() {
      this.reload();
      this.saveFilterState();
    },
    onDateChange: function onDateChange() {
      this.reload();
      this.saveFilterState();
    },
    onProjectChange: function onProjectChange(item) {
      var vm = this;

      vm.filter = null;
      vm.$refs['complexFilter'].clear();

      vm.projectId = item.Id;
      vm.statusId = '';
      vm.dateTypeId = DateTypes.FillingDate;
      vm.dateStart = '';
      vm.dateEnd = '';
      vm.scrollTop = null;
      vm.saveFilterState();

      //vm.loadSettings().then(function () {
      //    vm.reload();

      //    vm.$emit('user-updated');
      //});
    },
    reload: function reload() {
      this.page = 1;
      this.answers = [];
      this.loading = false;
      this.canBeLoaded = true;
      this.selectedAnswers = [];
      this.loadNext();
    },
    loadNext: function loadNext() {
      var vm = this;
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.dataContent', 'Загрузка...');
      var skip = (vm.page - 1) * vm.rowsPerPage;
      var take = vm.rowsPerPage;
      if (vm.firstLoad && vm.page > 1) {
        skip = 0;
        take = vm.page * vm.rowsPerPage;
      }
      var timeZone = new Date().getTimezoneOffset();
      var dateStart = Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(vm.dateStart, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
      var dateEnd = Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(vm.dateEnd, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
      //vm.projectId = parseInt(this.$route.params.id);
      var filterFormatted = '';
      var author = null;
      if (vm.filter) {
        filterFormatted = processFilter(vm.filter).map(function (x) {
          return JSON.stringify(x);
        });
        //filterFormatted = this.CommonMixin_UsersProcessFilter(filters).map(x => { return JSON.stringify(x) });
        //console.log('filterFormatted', filterFormatted);
      }
      if (!vm.hasClaimsOrAdmin(vm.info.User, vm.claimEnums.tasksController) && !vm.hasClaimsOrAdmin(vm.info.User, vm.claimEnums.tasksEdit)) {
        author = vm.info.User.Id;
      }

      //console.info('info.ProjectsLength', this.info.ProjectsLength, skip, take, vm.page, vm.rowsPerPage, filterFormatted);
      //vm.CommonMixin_UsersProcessFilter(vm.filter)
      this.callApiWrapper(backendApi.tasksAnswers(skip, take, vm.projectId, 0, vm.statusId, vm.dateTypeId, dateStart, dateEnd, filterFormatted, author)).then(function (resp) {
        if (resp.hasError && resp.status === 401) {
          this.$router.push('/projects');
        } else if (resp.hasError) {
          __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки заданий');
        } else {
          if (resp.data.list && resp.data.list.length) {
            var _vm$answers;

            (_vm$answers = vm.answers).push.apply(_vm$answers, _toConsumableArray(resp.data.list));
            vm.totalCount = resp.data.totalCount;

            console.info('[vm.firstLoad, vm.scrollTop]', [vm.firstLoad, vm.scrollTop]);
            if (vm.firstLoad) {
              vm.firstLoad = false;
              if (vm.scrollTop) {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').animate({ scrollTop: vm.scrollTop }, 500, function () {
                  // перезаписываем значение после анимации, чтобы не было скролла при перезагрузке
                  vm.scrollTop = 0;
                  vm.saveFilterState();
                });
              }
            }
          } else {
            vm.canBeLoaded = false;
          }
        }
        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.dataContent');
        vm.loading = false;
      }).catch(function (err) {
        console.info('err', err);
        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время загрузки');
      });
    },
    onExport: function onExport() {
      var vm = this;

      var dateStart = Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(vm.dateStart, 'DD.MM.YYYY').format();
      var dateEnd = Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(vm.dateEnd, 'DD.MM.YYYY').format();

      var filterFormatted = '';
      if (vm.filter) {
        filterFormatted = processFilter(vm.filter).map(function (x) {
          return JSON.stringify(x);
        });
      }

      if (vm.selectedAnswers.length > 0) {
        if (!filterFormatted) {
          filterFormatted = [];
        }
        var ids = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(vm.selectedAnswers, function (item) {
          return item.Id;
        });
        filterFormatted.push(['ta.[Id]', 'IN', '(' + ids.join(';') + ')']);
      }

      __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('#app');
      this.callApiWrapper(backendApi.tasksExport(vm.projectId, vm.statusId, vm.dateTypeId, dateStart, dateEnd, filterFormatted)).then(function (resp) {
        if (resp.hasError && resp.status !== 401) {
          __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время экспорта');
          console.info('resp', resp);
        } else {
          var exportFile = resp.data;
          if (exportFile != null) {
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].downloadFileByBytes(exportFile, "Задания.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
          }
        }
        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
      });
    },
    onGeneralExport: function onGeneralExport() {
      var vm = this;

      var dateStart = Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(vm.dateStart, 'DD.MM.YYYY').format();
      var dateEnd = Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(vm.dateEnd, 'DD.MM.YYYY').format();

      var filterFormatted = '';
      if (vm.filter) {
        filterFormatted = processFilter(vm.filter).map(function (x) {
          return JSON.stringify(x);
        });
      }

      if (vm.selectedAnswers.length > 0) {
        if (!filterFormatted) {
          filterFormatted = [];
        }
        var ids = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(vm.selectedAnswers, function (item) {
          return item.Id;
        });
        filterFormatted.push(['ta.[Id]', 'IN', '(' + ids.join(';') + ')']);
      }

      __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('#app');
      this.callApiWrapper(backendApi.tasksGeneralExport(vm.projectId, vm.statusId, vm.dateTypeId, dateStart, dateEnd, filterFormatted)).then(function (resp) {
        if (resp.hasError && resp.status !== 401) {
          __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время экспорта');
          console.info('resp', resp);
        } else {
          var exportFile = resp.data;
          if (exportFile != null) {
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].downloadFileByBytes(exportFile, "Общая выгрузка.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
          }
        }
        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
      });
    },
    onFileChange: function onFileChange() {
      var vm = this;

      var files = document.getElementById('dropFiles').files;
      if (files.length > 0) {
        if (window.FormData !== undefined) {
          var data = new FormData();
          for (var x = 0; x < files.length; x++) {
            data.append("file" + x, files[x]);
          }
          var projectId = this.$route.params.projectId;
          var tokenInfo = JSON.parse(localStorage.getItem('tokenInfo') == null ? sessionStorage.getItem('tokenInfo') : localStorage.getItem('tokenInfo'));
          var headers = {};
          if (tokenInfo != null) {
            headers.Authorization = 'bearer ' + tokenInfo.access_token;
          }

          __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('#app');
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
            type: "POST",
            url: __WEBPACK_IMPORTED_MODULE_7__config___default.a.apiUrl + '/api/tasks/update-status',
            contentType: false,
            processData: false,
            headers: headers,
            data: data,
            success: function success(resp) {
              if (resp.hasError) {
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка импорта');
              } else {
                vm.importResult = resp.result;
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно импортировано');
                vm.page = 1;
                vm.users = [];
                vm.loadNext();
              }
              __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            },
            error: function error(xhr, status, p3) {
              __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка на сервере');
              console.error(xhr.responseText);
              __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
            }
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Браузер не поддерживает загрузку файлов HTML5!');
        }
      }
    },
    onExportReport: function onExportReport() {
      __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('#app');
      this.callApiWrapper(backendApi.tasksExportReport()).then(function (resp) {
        if (resp.hasError && resp.status !== 401) {
          __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время экспорта');
          console.info('resp', resp);
        } else {
          var exportFile = resp.data;
          if (exportFile != null) {
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].downloadFileByBytes(exportFile, "Отчет.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
          }
        }
        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
      });
    },
    handleExportAnalytics: function handleExportAnalytics() {
      if (this.projectId === this.currentProjectIds.Cersanit) {
        this.onExportAnalyticsCersanit();
      } else if (this.projectId === this.currentProjectIds.Jeelex) {
        this.onExportAnalyticsJeelex();
      }
    },
    onExportAnalyticsJeelex: function onExportAnalyticsJeelex() {
      var vm = this;

      var dateStart = Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(vm.dateStart, 'DD.MM.YYYY').format();
      var dateEnd = Object(__WEBPACK_IMPORTED_MODULE_5_moment__["default"])(vm.dateEnd, 'DD.MM.YYYY').format();

      var filterFormatted = '';
      if (vm.filter) {
        filterFormatted = processFilter(vm.filter).map(function (x) {
          return JSON.stringify(x);
        });
      }

      if (vm.selectedAnswers.length > 0) {
        if (!filterFormatted) {
          filterFormatted = [];
        }
        var ids = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(vm.selectedAnswers, function (item) {
          return item.Id;
        });
        filterFormatted.push(['ta.[Id]', 'IN', '(' + ids.join(';') + ')']);
      }

      __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('#app');
      this.callApiWrapper(backendApi.tasksExportAnalyticsJeelex(vm.projectId, vm.statusId, vm.dateTypeId, dateStart, dateEnd, filterFormatted)).then(function (resp) {
        if (resp.hasError && resp.status !== 401) {
          __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время экспорта');
          console.info('resp', resp);
        } else {
          var exportFile = resp.data;
          if (exportFile != null) {
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].downloadFileByBytes(exportFile, "Аналитика.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
          }
        }
        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
      });
    },
    onExportAnalyticsCersanit: function onExportAnalyticsCersanit() {
      __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('#app');
      this.callApiWrapper(backendApi.tasksExportAnalyticsCersanit()).then(function (resp) {
        if (resp.hasError && resp.status !== 401) {
          __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка во время экспорта');
          console.info('resp', resp);
        } else {
          var exportFile = resp.data;
          if (exportFile != null) {
            __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].downloadFileByBytes(exportFile, "Аналитика.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
          }
        }
        __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('#app');
      });
    },
    clearFilterState: function clearFilterState() {
      this.dateStart = '';
      this.dateEnd = '';
      this.statusId = '';
      this.dateTypeId = DateTypes.FillingDate;

      localStorage.removeItem(cacheKey);
      this.reload();
    },
    saveFilterState: function saveFilterState() {
      console.info('this.statusId:', this.statusId);

      var stateObj = {
        statusId: this.statusId,
        dateTypeId: this.dateTypeId,
        dateStart: this.dateStart,
        dateEnd: this.dateEnd,
        projectId: this.projectId,
        page: this.page,
        scrollTop: this.scrollTop
      };
      localStorage.setItem(cacheKey, JSON.stringify(stateObj));
    },
    recoverFilterState: function recoverFilterState() {
      var stateObj = JSON.parse(localStorage.getItem(cacheKey));
      console.info('recoverFilterState -> stateObj:', stateObj);
      if (stateObj) {
        if (stateObj.statusId != null) {
          this.statusId = stateObj.statusId;
        }
        if (stateObj.dateTypeId) {
          this.dateTypeId = stateObj.dateTypeId;
        }
        if (stateObj.dateStart) {
          this.dateStart = stateObj.dateStart;
        }
        if (stateObj.dateEnd) {
          this.dateEnd = stateObj.dateEnd;
        }
        if (stateObj.projectId == this.projectId) {
          if (stateObj.page) {
            this.page = stateObj.page;
          }
          if (stateObj.scrollTop) {
            this.scrollTop = stateObj.scrollTop;
          }
        }
      }
    },
    onScroll: function onScroll(e) {
      var vm = this;
      if (!vm.loading && vm.canBeLoaded) {
        var elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target);
        vm.scrollTop = elem.scrollTop();
        if (elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight() + 100) {
          vm.page++;
          vm.loadNext();
        }
      }
    },
    searchFunction: function searchFunction(tableName, columnName, search, filters, searchPage, callback) {
      var vm = this;
      var filterFormatted = '';
      if (filters) {
        //filterFormatted = this.CommonMixin_UsersProcessFilter(filters).map(x => { return JSON.stringify(x) });
        filterFormatted = processFilter(filters).map(function (x) {
          return JSON.stringify(x);
        });
      }

      if (!vm.hasClaimsOrAdmin(vm.info.User, vm.claimEnums.tasksController) && !vm.hasClaimsOrAdmin(vm.info.User, vm.claimEnums.tasksEdit)) {
        filterFormatted = processFilter([["[dbo].[AspNetUsers].[Id]", "IN", '(\'' + vm.info.User.Id + '\')']]).map(function (x) {
          return JSON.stringify(x);
        });
      }

      this.callApiWrapper(backendApi.tasksDistinctValues(columnName, this.projectId, 0, search, filterFormatted, (searchPage - 1) * 30, 30)).then(function (resp) {
        callback(resp.data);
      });
    },
    onFilterChange: function onFilterChange(filter) {
      this.filter = filter;
      this.answers = [];
      this.loading = false;
      this.canBeLoaded = true;
      this.page = 1;

      this.loadNext();
    },
    onSelectAllChange: function onSelectAllChange(e) {
      var vm = this;

      vm.selectedAnswers = [];
      if (vm.selectAll) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = vm.answers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var answer = _step2.value;

            vm.selectedAnswers.push(answer);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    },
    onCheckChange: function onCheckChange(item) {
      var vm = this;
      if (vm.selectedAnswers.filter(function (x) {
        return x == item;
      }).length === 0) {
        vm.selectAll = false;
      } else if (vm.selectedAnswers.length === vm.answers.length) {
        vm.selectAll = true;
      }
    },
    selectedCancel: function selectedCancel() {
      this.selectAll = false;
      this.selectedAnswers = [];
    },
    ppActionModalClose: function ppActionModalClose() {
      this.closeModal('ppActionModal');
      this.reload();
    },
    btnReject: function btnReject(state) {
      var vm = this;
      vm.selectStatus = state;
      vm.commentStatus = '';

      if (state === 4) vm.popuptitle = 'Причина отправки на доработку';else vm.popuptitle = 'Причина отклонения';
      vm.$refs['ppComment'].show();
    },
    removeAnswers: function removeAnswers() {
      var vm = this;
      vm.showConfirmDeleteModal();
    },
    showConfirmDeleteModal: function showConfirmDeleteModal() {
      this.$refs.ppConfirmDelete.show();
    },
    confirmDeleteAnswers: function confirmDeleteAnswers() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var vm;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                vm = _this;
                _context.next = 3;
                return vm.updateMultipleAnswerStatuses(__WEBPACK_IMPORTED_MODULE_6__enums__["q" /* TaskAnswerStates */].Remove, '');

              case 3:
                vm.closeModal('ppConfirmDelete');

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    cancelDelete: function cancelDelete() {
      this.$refs.ppConfirmDelete.hide();
    },
    tryChangeStatus: function tryChangeStatus() {
      var vm = this;
      vm.closeModal('ppComment');
      this.updateMultipleAnswerStatuses(vm.selectStatus, vm.commentStatus);
    },
    getAnswerWord: function getAnswerWord(count) {
      if (count % 10 === 1 && count % 100 !== 11) {
        return 'ответ';
      } else if ([2, 3, 4].includes(count % 10) && ![12, 13, 14].includes(count % 100)) {
        return 'ответа';
      } else {
        return 'ответов';
      }
    },
    updateMultipleAnswerStatuses: function updateMultipleAnswerStatuses(status, comment) {
      var vm = this;
      if (vm.selectedAnswers.length === 0) return;

      var statusLabel = void 0;
      switch (status) {
        case __WEBPACK_IMPORTED_MODULE_6__enums__["q" /* TaskAnswerStates */].Accepted:
          statusLabel = "Принято";
          break;
        case __WEBPACK_IMPORTED_MODULE_6__enums__["q" /* TaskAnswerStates */].OnEdition:
          statusLabel = "Отправлено на доработку";
          break;
        case __WEBPACK_IMPORTED_MODULE_6__enums__["q" /* TaskAnswerStates */].Rejected:
          statusLabel = "Отклонено";
          break;
        case __WEBPACK_IMPORTED_MODULE_6__enums__["q" /* TaskAnswerStates */].Remove:
          statusLabel = "Удалено";
          break;
        default:
          statusLabel = "Неизвестный статус";
          break;
      }

      var selectedAnswers = this.selectedAnswers.map(function (x) {
        return {
          Id: x.Id,
          TaskId: x.TaskId,
          Status: status,
          EditionComment: comment,
          Date: x.DateStatus
        };
      });

      vm.actionState = {
        currentAnswer: {
          index: 0,
          date: null,
          time: 0
        },
        total: 0,
        messages: [],
        done: false
      };

      vm.$refs.ppActionModal.show();

      (function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var secondsInterval, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, answer;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('dataContent', 'Обработка');

                  secondsInterval = void 0;

                  vm.actionState.total = selectedAnswers.length;
                  _iteratorNormalCompletion3 = true;
                  _didIteratorError3 = false;
                  _iteratorError3 = undefined;
                  _context2.prev = 6;
                  _iterator3 = selectedAnswers[Symbol.iterator]();

                case 8:
                  if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                    _context2.next = 19;
                    break;
                  }

                  answer = _step3.value;

                  vm.actionState.currentAnswer.index++;
                  vm.actionState.currentAnswer.time = 0;
                  vm.actionState.currentAnswer.date = answer.Date;

                  secondsInterval = setInterval(function () {
                    vm.actionState.currentAnswer.time += 1;
                  }, 1000);
                  _context2.next = 16;
                  return vm.callApiWrapper(backendApi.tasksAnswerAccept(answer.TaskId, answer.Id, answer.Status, answer.EditionComment)).then(function (response) {
                    clearInterval(secondsInterval);

                    var answerTitle = '\u041E\u0442\u0432\u0435\u0442 ' + vm.actionState.currentAnswer.index + ' \u043E\u0442 ' + vm.formatDate(vm.actionState.currentAnswer.date, 'DD.MM.YYYY HH:mm');

                    if (response.hasError) {
                      switch (response.status) {
                        case 722:
                          vm.actionState.messages.push({
                            message: answerTitle + ': \u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043D\u0430 \u0434\u043E\u0440\u0430\u0431\u043E\u0442\u043A\u0443 \u043C\u043E\u0436\u043D\u043E \u0442\u043E\u043B\u044C\u043A\u043E \u0442\u043E\u0442 \u043E\u0442\u0432\u0435\u0442, \u043F\u043E \u043A\u043E\u0442\u043E\u0440\u043E\u043C\u0443 \u0431\u043E\u043D\u0443\u0441\u044B \u043D\u0435 \u0431\u044B\u043B\u0438 \u0438\u0441\u0442\u0440\u0430\u0447\u0435\u043D\u044B',
                            error: true
                          });
                          break;
                        case 723:
                          vm.actionState.messages.push({
                            message: answerTitle + ': \u041E\u0442\u043A\u043B\u043E\u043D\u0438\u0442\u044C \u043C\u043E\u0436\u043D\u043E \u0442\u043E\u043B\u044C\u043A\u043E \u0442\u043E\u0442 \u043E\u0442\u0432\u0435\u0442, \u043F\u043E \u043A\u043E\u0442\u043E\u0440\u043E\u043C\u0443 \u0431\u043E\u043D\u0443\u0441\u044B \u043D\u0435 \u0431\u044B\u043B\u0438 \u0438\u0441\u0442\u0440\u0430\u0447\u0435\u043D\u044B',
                            error: true
                          });
                          break;
                        case 724:
                          vm.actionState.messages.push({
                            message: answerTitle + ': \u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043C\u043E\u0436\u043D\u043E \u0442\u043E\u043B\u044C\u043A\u043E \u0442\u043E\u0442 \u043E\u0442\u0432\u0435\u0442, \u043F\u043E \u043A\u043E\u0442\u043E\u0440\u043E\u043C\u0443 \u0431\u043E\u043D\u0443\u0441\u044B \u043D\u0435 \u0431\u044B\u043B\u0438 \u0438\u0441\u0442\u0440\u0430\u0447\u0435\u043D\u044B',
                            error: true
                          });
                          break;
                        default:
                          vm.actionState.messages.push({
                            message: answerTitle + ': \u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0438',
                            error: true
                          });
                          break;
                      }
                    } else {
                      vm.actionState.messages.push({ message: answerTitle + ': ' + statusLabel });
                    }
                    if (vm.actionState.currentAnswer.index === vm.actionState.total) {
                      vm.actionState.done = true;
                      __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('dataContent');
                    }
                  });

                case 16:
                  _iteratorNormalCompletion3 = true;
                  _context2.next = 8;
                  break;

                case 19:
                  _context2.next = 25;
                  break;

                case 21:
                  _context2.prev = 21;
                  _context2.t0 = _context2['catch'](6);
                  _didIteratorError3 = true;
                  _iteratorError3 = _context2.t0;

                case 25:
                  _context2.prev = 25;
                  _context2.prev = 26;

                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }

                case 28:
                  _context2.prev = 28;

                  if (!_didIteratorError3) {
                    _context2.next = 31;
                    break;
                  }

                  throw _iteratorError3;

                case 31:
                  return _context2.finish(28);

                case 32:
                  return _context2.finish(25);

                case 33:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[6, 21, 25, 33], [26,, 28, 32]]);
        }));

        function loop() {
          return _ref.apply(this, arguments);
        }

        return loop;
      })()();
    }
  },

  mounted: function mounted() {
    var vm = this;

    vm.recoverFilterState();

    //Promise.all([this.loadSettings(), this.loadGroups()]).then(function () {
    //    vm.loadNext();
    //});
    vm.loadNext();
    //UI.blockUI('.dataContent', 'Загрузка...');
    //vm.loadNext().then(() => {
    //    UI.unblockUI('.dataContent');
    //});

    vm.$nextTick(function () {

      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').on('scroll', function () {
        var elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
        var scrollTop = elem.scrollTop();
        vm.scrollTop = scrollTop;

        if (!vm.loading && vm.canBeLoaded && !vm.firstLoad) {
          //console.info('elem[0].scrollHeight - elem.scrollTop(), elem.outerHeight()', [elem[0].scrollHeight] - elem.scrollTop(), elem.outerHeight());
          if (elem[0].scrollHeight - scrollTop - 700 <= elem.outerHeight()) {
            vm.page++;
            vm.loadNext();
          }
        }
      });
    });
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.body-panel-content').off('scroll');
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MyProgress_Daccord_DaccordBanner_vue__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enums__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "my-progress",

  props: ["info"],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__helpers_project_mixin__["a" /* default */]],

  components: {
    DaccordBanner: __WEBPACK_IMPORTED_MODULE_2__components_MyProgress_Daccord_DaccordBanner_vue__["a" /* default */]
  },

  data: function data() {
    return {
      isMobile: __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].check_mobile(),
      currentProjectIds: __WEBPACK_IMPORTED_MODULE_3__enums__["g" /* ProjectIds */][__WEBPACK_IMPORTED_MODULE_4__config___default.a.mode]
    };
  },


  computed: {
    currentBalance: function currentBalance() {
      return this.info && this.info.User && this.info.User.PotentialBalance ? this.info.User.PotentialBalance : 0;
    }
  },

  methods: {
    onProjectChange: function onProjectChange(item) {
      this.$emit("user-updated");
    }
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_MyProgress_telegram_svg__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_MyProgress_telegram_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_MyProgress_telegram_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_MyProgress_wallet_svg__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_MyProgress_wallet_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_MyProgress_wallet_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_MyProgress_factory_svg__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_MyProgress_factory_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_MyProgress_factory_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_MyProgress_daccordLogo_png__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_MyProgress_daccordLogo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_MyProgress_daccordLogo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RoadAndCar_vue__ = __webpack_require__(871);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: "daccord-banner",

    props: ['balance'],

    components: {
        RoadAndCar: __WEBPACK_IMPORTED_MODULE_4__RoadAndCar_vue__["a" /* default */]
    },

    data: function data() {
        return {
            telegram: __WEBPACK_IMPORTED_MODULE_0__assets_MyProgress_telegram_svg___default.a,
            wallet: __WEBPACK_IMPORTED_MODULE_1__assets_MyProgress_wallet_svg___default.a,
            factory: __WEBPACK_IMPORTED_MODULE_2__assets_MyProgress_factory_svg___default.a,
            logo: __WEBPACK_IMPORTED_MODULE_3__assets_MyProgress_daccordLogo_png___default.a
        };
    },
    mounted: function mounted() {
        if (document.body.offsetWidth <= 450) document.querySelector('.body-panel-content-page').style.padding = 0;
    }
});

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "factory.svg?6edc36daac9a9e07c7ff9a4b764e525b";

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Car_vue__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Road_vue__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CheckPoint_vue__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StartFlag_vue__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FinishFlag_vue__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FlagText_vue__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FinishBanner_vue__ = __webpack_require__(904);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Car: __WEBPACK_IMPORTED_MODULE_0__Car_vue__["a" /* default */],
    CheckPoint: __WEBPACK_IMPORTED_MODULE_2__CheckPoint_vue__["a" /* default */],
    StartFlag: __WEBPACK_IMPORTED_MODULE_3__StartFlag_vue__["a" /* default */],
    FinishFlag: __WEBPACK_IMPORTED_MODULE_4__FinishFlag_vue__["a" /* default */],
    Road: __WEBPACK_IMPORTED_MODULE_1__Road_vue__["a" /* default */],
    FlagText: __WEBPACK_IMPORTED_MODULE_5__FlagText_vue__["a" /* default */],
    FinishBanner: __WEBPACK_IMPORTED_MODULE_6__FinishBanner_vue__["a" /* default */]
  },

  props: {
    newBalance: Number
  },

  data: function data() {
    return {
      visibleFlag: 0,
      currentPosition: 0,
      checkpoints: [{
        class: "point1",
        index: 1,
        element: __WEBPACK_IMPORTED_MODULE_3__StartFlag_vue__["a" /* default */],
        props: "",
        position: 0,
        text: "Приветствуем в нашей программе мотивации! Загружай чеки с продаж, выполняй задания и получай баллы. Свой путь можно отслеживать, наблюдая за перемещением гоночной машины. Чем больше баллов ты заработал, тем больше шансов поучаствовать в розыгрышах. Лучшие из лучших получат возможность добраться до финала и отправиться с нами на завод производителя! Желаем удачи и отличных продаж!"
      }, {
        class: "point2",
        index: 2,
        element: __WEBPACK_IMPORTED_MODULE_5__FlagText_vue__["a" /* default */],
        props: "1000",
        position: 0.18,
        text: 'Поздравляем! Ты получаешь шанс участвовать в розыгрыше 1000 баллов. Все розыгрыши будут проводиться после завершения программы (подробности см. в разделах "О программе" и "Новости")'
      }, {
        class: "point3",
        index: 3,
        element: __WEBPACK_IMPORTED_MODULE_5__FlagText_vue__["a" /* default */],
        props: "2500",
        position: 0.45,
        text: 'Наши поздравления! Теперь ты участвуешь в розыгрыше классных брендированных подарков (подробности см. в разделе "О программе" и "Новости"). Не останавливайся на полпути, ведь дальше следующая отправная точка!'
      }, {
        class: "point4",
        index: 4,
        element: __WEBPACK_IMPORTED_MODULE_5__FlagText_vue__["a" /* default */],
        props: "5000",
        position: 0.9,
        text: 'Наши поздравления! Теперь ты участвуешь в розыгрыше классных брендированных подарков (подробности см. в разделе "О программе" и "Новости"). Не останавливайся на полпути, ведь дальше следующая отправная точка!'
      }]
    };
  },

  methods: {
    toggleFlag: function toggleFlag(index) {
      index === this.visibleFlag ? this.visibleFlag = 0 : this.visibleFlag = index;
    },
    getPosition: function getPosition(position) {
      this.currentPosition = Number(position.toFixed(2));
    },


    // Для анимаций
    calcTiming: function calcTiming(timing) {
      return function (timeFraction) {
        return 1 - timing(1 - timeFraction);
      };
    },
    linear: function linear(timeFraction) {
      return timeFraction;
    }
  },
  computed: {
    oldPosition: function oldPosition() {
      var old = Number(localStorage.getItem("position"));

      if (old < this.newPosition) {
        return old;
      } else {
        localStorage.setItem("position", this.newPosition);
        return this.newPosition;
      }
    },
    newPosition: function newPosition() {
      return Number((this.newBalance / 5555).toFixed(2));
    }
  },
  watch: {
    currentPosition: function currentPosition(newValue) {
      localStorage.setItem("position", this.newPosition);
    }
  },
  mounted: function mounted() {
    if (this.oldPosition === 0) {
      this.visibleFlag = 1;
    }
  }
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    oldPosition: Number,
    newPosition: Number,
    currentPosition: Number,
    getPosition: Function,
    calcTiming: Function,
    linear: Function
  },
  data: function data() {
    return {
      car: null,
      positions: [{ x: 75, y: 226, angle: 4 }, // 0
      { x: 138.75, y: 214, angle: 20 }, // 250
      { x: 202.5, y: 220, angle: 23 }, // 500
      { x: 266.25, y: 225, angle: 7 }, // 750
      { x: 330, y: 190, angle: -15 }, // 1000  0.018
      { x: 374, y: 170, angle: -20 }, { x: 418, y: 130, angle: -10 }, { x: 462, y: 110, angle: 10 }, { x: 506, y: 105, angle: 14 }, { x: 550, y: 103, angle: 14 }, // 2500  0.5
      { x: 579, y: 103, angle: 14 }, { x: 608, y: 101, angle: 14 }, { x: 638, y: 99, angle: 14 }, { x: 667, y: 97, angle: 14 }, { x: 697, y: 95, angle: 14 }, { x: 726, y: 92, angle: 14 }, { x: 755, y: 88, angle: 13 }, { x: 784, y: 83, angle: 12 }, { x: 814, y: 78, angle: 11 }, // 5000  1
      { x: 850, y: 64, angle: -10 }]
    };
  },

  methods: {
    beforeFinishPositions: function beforeFinishPositions(progress) {
      var positions = [{ x: 850, y: -156, angle: -10 }, { x: 870, y: -180, angle: -30 }, { x: 870, y: -200, angle: -50 }, { x: 880, y: -250, angle: -40 }, { x: 910, y: -270, angle: -10 }, { x: 920, y: -280, angle: 0 }, { x: 940, y: -280, angle: 5 }, { x: 960, y: -285, angle: 10 }, { x: 980, y: -290, angle: 10 }, { x: 1000, y: -295, angle: 10 }, { x: 1013, y: -295, angle: -7 }];

      var currentPoint = void 0; // Текущая точка
      var nextPoint = void 0; // Следующая точка
      var currentMark = void 0; // Для вычисления прогресса, относительно следующей точки
      var nextMark = void 0;

      switch (true // Массив возможных точек
      ) {case progress >= 1 && progress < 3:
          currentPoint = positions[0];
          nextPoint = positions[1];
          currentMark = 1;
          nextMark = 3;
          break;
        case progress >= 3 && progress < 4:
          currentPoint = positions[1];
          nextPoint = positions[2];
          currentMark = 3;
          nextMark = 4;
          break;
        case progress >= 4 && progress < 6:
          currentPoint = positions[2];
          nextPoint = positions[3];
          currentMark = 4;
          nextMark = 6;
          break;
        case progress >= 6 && progress < 8:
          currentPoint = positions[3];
          nextPoint = positions[4];
          currentMark = 6;
          nextMark = 8;
          break;
        case progress >= 8 && progress < 10:
          currentPoint = positions[4];
          nextPoint = positions[5];
          currentMark = 8;
          nextMark = 10;
          break;
        case progress >= 10 && progress < 12:
          currentPoint = positions[5];
          nextPoint = positions[6];
          currentMark = 10;
          nextMark = 12;
          break;
        case progress >= 12 && progress < 40:
          currentPoint = positions[6];
          nextPoint = positions[7];
          currentMark = 12;
          nextMark = 40;
          break;
        case progress >= 40 && progress < 100:
          currentPoint = positions[7];
          nextPoint = positions[8];
          currentMark = 40;
          nextMark = 100;
          break;
        case progress >= 100:
          currentPoint = positions[8];
          nextPoint = positions[9];
          currentMark = 100;
          nextMark = 9999999999999999999999999; // Чтобы не попасть на финиш
          break;
      }

      var onProcent = (nextMark - currentMark) / 100; // % между двумя точками
      var procentOfProgress = (progress - currentMark) / onProcent / 100;

      var newX = (nextPoint.x - currentPoint.x) * procentOfProgress + currentPoint.x;
      var newY = (nextPoint.y - currentPoint.y) * procentOfProgress + currentPoint.y;
      var newAngle = (nextPoint.angle - currentPoint.angle) * procentOfProgress + currentPoint.angle;

      var nextPointIndex = positions.indexOf(nextPoint);

      return [].concat(_toConsumableArray(positions.slice(0, nextPointIndex)), [{ x: newX, y: newY, angle: newAngle }]);
    },
    drivingBeforeFinish: function drivingBeforeFinish(progress) {
      var array = this.beforeFinishPositions(this.newPosition);
      var prog = Math.round(array.length * progress);

      this.car.style.transform = "translate3d(" + array[prog].x + "px, " + array[prog].y + "px, 0) rotateZ(" + array[prog].angle + "deg)";

      if (progress >= 0.9) getProgress(this.newPosition);
    },
    drivingCar: function drivingCar(progress) {
      var _this = this;

      var array = this.positions;
      var step = array.length * progress; // Не округляем сразу

      var index = Math.round(step); // Ищем индекс первой точки

      var remainder = step - index; // Оставшаяся доля между точками

      this.centeringOnCar();

      setTimeout(function () {
        _this.car.style.transition = "1s all linear";
      }, 500);

      if (index < array.length - 1) {
        // LERP (линейная интерполяция) для более плавного движения
        var x = this.lerp(array[index].x, array[index + 1].x, remainder);
        var y = this.lerp(array[index].y, array[index + 1].y, remainder);
        var angle = this.lerp(array[index].angle, array[index + 1].angle, remainder);

        this.car.style.transform = "translate3d(" + x + "px, " + y + "px, 0) rotateZ(" + angle + "deg)";
      } else {
        this.car.style.transform = "translate3d(850px, 55px, 0) rotateZ(-10deg)"; // Если вышли за пределы массива
        this.centeringOnCar();
      }
    },
    lerp: function lerp(start, end, t) {
      return start + (end - start) * t;
    },
    animate: function animate(_ref) {
      var duration = _ref.duration,
          timing = _ref.timing,
          draw = _ref.draw,
          fn = _ref.fn;

      var start = performance.now();
      var newPosition = this.newPosition;
      var oldPosition = this.oldPosition;

      requestAnimationFrame(function animate(time) {
        var timeFraction = (time - start) / duration + oldPosition;

        if (timeFraction > 1) timeFraction = 1;

        // вычисление текущего состояния анимации
        var progress = timing(timeFraction);

        if (fn) fn(progress); // передать прогресс родителю

        draw(progress); // отрисовать её

        if (timeFraction < 1 && timeFraction <= newPosition) {
          requestAnimationFrame(animate);
        }
      }.bind(this));
    },
    centeringOnCar: function centeringOnCar() {
      this.car.scrollIntoView({
        inline: "center",
        block: "center",
        behavior: "auto"
      });
    },
    startAnimation: function startAnimation() {
      this.animate({
        duration: 20000,
        timing: this.calcTiming(this.linear),
        draw: this.drivingCar,
        fn: this.getProgress.bind(this)
      });
    },
    getProgress: function getProgress(progress) {
      this.$emit("changePosition", progress);
    }
  },
  watch: {
    currentPosition: function currentPosition(newVal, prevValue) {
      /*
      if (newVal >= 1) {
        this.animate({
          duration: 5000,
          timing: this.calcTiming(this.linear),
          draw: this.drivingBeforeFinish,
        });
      }
        */
      //if (newVal >= this.newPosition) this.car.style.transition = "none";
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.car = this.$refs.car;

    this.car.style.transition = "none";

    setTimeout(function () {
      _this2.centeringOnCar();
    }, 200);

    if (this.currentPosition <= this.newPosition) this.startAnimation();
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    oldPosition: Number,
    newPosition: Number,
    calcTiming: Function,
    linear: Function
  },
  data: function data() {
    return {
      road: null,
      positions: [{ width: 0 }, { width: 62.5 }, { width: 125 }, { width: 187.5 }, { width: 250 }, // 1000
      { width: 296 }, { width: 342 }, { width: 388 }, { width: 434 }, { width: 475 }, // 2500
      { width: 505.5 }, { width: 536 }, { width: 566.5 }, { width: 597 }, { width: 627.5 }, { width: 658 }, { width: 688.5 }, { width: 719 }, { width: 750 }, // 5000
      { width: 780 }]
    };
  },

  methods: {
    drawRoad: function drawRoad(progress) {
      var array = this.positions;
      var prog = Math.round(array.length * progress);

      prog < 20 ? this.road.style.width = array[prog].width + "px" : this.road.style.width = "780px";
    },
    animate: function animate(_ref) {
      var duration = _ref.duration,
          timing = _ref.timing,
          draw = _ref.draw;

      var start = performance.now();
      var newPosition = this.newPosition;
      var oldPosition = this.oldPosition;

      requestAnimationFrame(function animate(time) {
        var timeFraction = (time - start) / duration + oldPosition;
        if (timeFraction > 1) timeFraction = 1;

        // вычисление текущего состояния анимации
        var progress = timing(timeFraction);

        draw(progress); // отрисовать её

        if (timeFraction < 1 && timeFraction <= newPosition) {
          requestAnimationFrame(animate);
        }
      });
    },
    startAnimation: function startAnimation() {
      this.animate({
        duration: 20000,
        timing: this.calcTiming(this.linear),
        draw: this.drawRoad
      });
    }
  },

  mounted: function mounted() {
    this.road = this.$refs.road;

    this.startAnimation();
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Flag_vue__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FlagWrap_vue__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CloseIcon_vue__ = __webpack_require__(893);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    index: Number,
    checkpointPosition: Number,
    oldPosition: Number,
    currentPosition: Number,
    position: Number,
    flagIndex: Number,
    visibleFlag: Number,
    toggleFlag: Function,
    isFinish: Boolean,
    color: String
  },
  components: {
    FlagWrap: __WEBPACK_IMPORTED_MODULE_1__FlagWrap_vue__["a" /* default */],
    Flag: __WEBPACK_IMPORTED_MODULE_0__Flag_vue__["a" /* default */],
    CloseIcon: __WEBPACK_IMPORTED_MODULE_2__CloseIcon_vue__["a" /* default */]
  },

  data: function data() {
    return {
      hasShownBanner: false,
      isFlagClicked: false,
      checkpoint: null,
      changeColor: false,
      positions: [1, 0, 1]
    };
  },

  computed: {
    isCurrentFlagActive: function isCurrentFlagActive() {
      // Сравниваем активный флаг с текущим индексом флага
      return this.visibleFlag === this.index;
    },
    isActive: function isActive() {
      return this.currentPosition >= this.position;
    }
  },
  watch: {
    isActive: function isActive(newValue) {
      this.changeColor = newValue;
    },
    currentPosition: function currentPosition(newValue) {
      if (newValue === this.position) {
        this.animate({
          duration: 3000,
          timing: this.calcTiming(this.linear),
          draw: this.draw
        });
      }
    }
  },
  methods: {
    handleClick: function handleClick() {
      this.toggleFlag(this.index);

      this.isFlagClicked = this.isCurrentFlagActive;
    },
    calcTiming: function calcTiming(timing) {
      return function (timeFraction) {
        return 1 - timing(1 - timeFraction);
      };
    },
    linear: function linear(timeFraction) {
      return timeFraction;
    },
    draw: function draw(progress) {
      var array = this.positions;
      var prog = Math.round(array.length * progress);

      this.checkpoint.style.transform = "scale(" + array[prog] + ")";

      if (progress > 0.5) {
        this.changeColor = true;
        this.handleClick();
      }
    },
    animate: function animate(_ref) {
      var duration = _ref.duration,
          timing = _ref.timing,
          draw = _ref.draw;

      var start = performance.now();

      requestAnimationFrame(function animate(time) {
        var timeFraction = (time - start) / duration;
        if (timeFraction > 1) timeFraction = 1;

        // вычисление текущего состояния анимации
        var progress = timing(timeFraction);

        draw(progress); // отрисовать её

        if (timeFraction < 1) {
          requestAnimationFrame(animate);
        }
      });
    }
  },
  mounted: function mounted() {
    this.checkpoint = this.$refs.checkpoint;

    if (this.isActive) {
      this.changeColor = true;
    }
  }
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isActive: Boolean
  }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isActive: Boolean
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        color: String
    }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isActive: Boolean
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    text: String
  }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_Bootstrap_jquery_bootstrap_touchspin_min__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_Bootstrap_jquery_bootstrap_touchspin_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_Bootstrap_jquery_bootstrap_touchspin_min__);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "touch-spin",

    props: ['name', 'value', 'decimals', 'step', 'max', 'min', 'disabled', 'defaultValue'],

    $_veeValidate: {
        value: function value() {
            return this.$refs.touchInput.value;
        },
        name: function name() {
            return this.name;
        }
    },

    data: function data() {
        return {
            parentGroup: null
        };
    },


    watch: {
        max: function max(n, o) {
            var newVal = parseFloat(n);
            if (newVal) {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$refs.touchInput).trigger("touchspin.updatesettings", { max: newVal });
            }
        }
    },

    methods: {
        updateValue: function updateValue() {
            if (!this.$refs.touchInput.value || this.$refs.touchInput.value === '-' || isNaN(parseFloat(this.$refs.touchInput.value))) {
                this.$emit('input', this.$refs.touchInput.value);
            } else if (this.decimals > 0) {
                this.$emit('input', parseFloat(this.$refs.touchInput.value));
            } else {
                this.$emit('input', parseInt(this.$refs.touchInput.value));
            }
        },
        onClick: function onClick($event) {
            this.$emit('click', $event);
        }
    },

    mounted: function mounted() {
        //console.info('touch-spin -> mounted -> vm.$el:', this.$el)
        var vm = this;
        this.$nextTick(function () {
            var options = {
                verticalbuttons: true,
                min: vm.min || 0,
                max: vm.max || 1000000000,
                decimals: vm.decimals
            };
            if (vm.step) {
                options.step = vm.step;
            }
            if (vm.$refs.touchInput !== undefined) {
                var inputCssClass = vm.$refs.touchInput.className;
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()(vm.$refs.touchInput).TouchSpin(options).on('change', function (e, s) {
                    vm.updateValue();
                    if (vm.defaultValue !== undefined && isNaN(parseFloat(vm.$refs.touchInput.value))) {
                        vm.$refs.touchInput.value = vm.defaultValue;
                        vm.$emit('input', parseInt(vm.$refs.touchInput.value));
                    }
                    vm.$emit('change', vm.$refs.touchInput.value);
                });
                var wrapper = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(vm.$refs.touchInput).parent().parent();
                wrapper.removeClass(inputCssClass);
            }
        });
    },
    beforeDestroy: function beforeDestroy() {
        var vm = this;
        this.$nextTick(function () {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(vm.$refs.touchInput).trigger('touchspin.destroy');
        });
    }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_Bootstrap_bootstrap_datepicker_min__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_Bootstrap_bootstrap_datepicker_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_Bootstrap_bootstrap_datepicker_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_Bootstrap_bootstrap_datepicker_ru__ = __webpack_require__(922);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: "input-date",

    props: ['name', 'value', 'withMask', 'todayHighlight'],

    data: function data() {
        return {
            mask: '##.##.####',
            changed: false
        };
    },


    methods: {
        // _updateDate(){
        //     this.$emit('input', this.$refs.dateInput.value);
        //     console.info('_updateDate -> this.$refs.dateInput.value', this.$refs.dateInput.value)
        // },

        onBlur: function onBlur() {
            var vm = this;
            //console.info('onBlur, [vm.value, $(vm.$el).val()]', [vm.value, $(vm.$el).val()]);
            if ((vm.value || '') != __WEBPACK_IMPORTED_MODULE_0_jquery___default()(vm.$el).val()) {
                this.$emit('input', __WEBPACK_IMPORTED_MODULE_0_jquery___default()(vm.$el).val());
                this.changed = true;
            } else {
                this.changed = false;
            }
        },
        setDate: function setDate(date) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).datepicker('update', date);
        }
    },

    mounted: function mounted() {
        var vm = this;
        this.$nextTick(function () {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(vm.$el).datepicker({
                language: 'ru',
                autoclose: true,
                todayHighlight: vm.todayHighlight
            }).on('changeDate', function (val) {
                //console.info('changeDate, [$(vm.$el).val(), this.changed]', [$(vm.$el).val(), this.changed]);
                if (!this.changed) {
                    vm.$emit('input', __WEBPACK_IMPORTED_MODULE_0_jquery___default()(vm.$el).val());
                } else {
                    this.changed = false;
                }
            });
        });
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).datepicker('destroy');
    }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function isOverflown(element) {
    if (!element) {
        return false;
    }
    /*console.info('[element.scrollHeight, element.clientHeight, element.scrollWidth, element.clientWidth]',
        [element.scrollHeight, element.clientHeight, element.scrollWidth, element.clientWidth]);*/
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "drop-down",

    props: ['name', 'value', 'items', 'selectedValue', 'dataField', 'textField', 'withSelectItem', 'withSelectItemText', 'cssClass', 'disabled'],

    $_veeValidate: {
        value: function value() {
            var selectedItem = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.dropItems, { Selected: true });
            var val = selectedItem.length ? selectedItem[0][this.dataField] : null;
            if (this.withSelectItem === 'true' && val === (this.withSelectItemText || 'Выбрать')) {
                return null;
            }
            return val;
        },
        name: function name() {
            return this.name;
        }
    },

    data: function data() {
        return {
            dropDownOpen: false,
            dropItems: [],
            selectedItem: null,
            isOverflown: false
        };
    },


    watch: {
        items: function items() {
            //console.info('dd -> watch items changed');
            this.setItems();
        },
        value: function value(newVal, oldVal) {
            //console.info('dd -> watch value: newVal, oldVal', [newVal, oldVal]);
            var vm = this;

            if (newVal == null || newVal === '') {
                for (var i = 0; i < vm.dropItems.length; i++) {
                    var el = vm.dropItems[i];
                    el.Selected = vm.withSelectItem === 'true' && i === 0;
                    vm.$set(vm.dropItems, i, el);
                }
            } else {
                for (var _i = 0; _i < vm.dropItems.length; _i++) {
                    var _el = vm.dropItems[_i];
                    if (_el[vm.dataField] === newVal) {
                        _el.Selected = true;
                        vm.$set(vm.dropItems, _i, _el);
                    } else {
                        _el.Selected = false;
                    }
                }
            }

            vm.calculateSelecteditem();
        },
        dropDownOpen: function dropDownOpen() {
            var vm = this;
            if (vm.dropDownOpen) {
                vm.$nextTick(function () {
                    vm.isOverflown = isOverflown(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(vm.$el).parents('.block-in-page-detail:first').get(0));
                });
            } else {
                vm.isOverflown = false;
            }
        }
    },

    methods: {
        calculateSelecteditem: function calculateSelecteditem() {
            //console.info('dd -> calculateSelecteditem');
            var vm = this;

            if (this.dropItems === undefined) {
                vm.selectedItem = null;
            } else {
                var selected = this.dropItems.filter(function (item) {
                    return item.Selected === true;
                });

                vm.selectedItem = selected.length ? selected[0] : this.dropItems.length ? this.dropItems[0] : null;
            }
        },
        onSelect: function onSelect(item) {
            var vm = this;
            for (var i = 0; i < this.dropItems.length; i++) {
                var el = this.dropItems[i];
                el.Selected = el[vm.dataField] === item[vm.dataField];
                vm.$set(vm.dropItems, i, el);
            }
            //vm.dropItems.__ob__.dep.notify();

            this.dropDownOpen = false;
            this.calculateSelecteditem();

            this.$emit('input', item[vm.dataField]);
            this.$emit('change', item);
        },
        setItems: function setItems() {
            var vm = this;
            this.dropItems = [];

            if (this.withSelectItem === 'true') {
                var selectItem = {};
                selectItem[vm.dataField] = '';
                selectItem[vm.textField] = this.withSelectItemText || 'Выбрать';
                this.dropItems.splice(0, 0, selectItem);
            }

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    this.dropItems.push(Object.assign({ Selected: false }, item));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var selectId = vm.selectedValue || vm.value;
            var selectIdWasFound = false;

            if (selectId != null) {
                for (var i = 0; i < vm.dropItems.length; i++) {
                    var el = vm.dropItems[i];
                    if (el[vm.dataField] === selectId || el[vm.dataField] == selectId && el[vm.dataField] !== '' && this.withSelectItem !== 'true') {
                        //console.info('found el.Value', el.Value)
                        el.Selected = true;
                        vm.$set(vm.dropItems, i, el);
                        selectIdWasFound = true;
                        break;
                    }
                }
            }

            if ((selectId == null || !selectIdWasFound) && vm.dropItems.length) {
                vm.dropItems[0].Selected = true;
                this.$emit('input', vm.dropItems[0][vm.dataField]);
                vm.$set(vm.dropItems, 0, vm.dropItems[0]);
            }

            this.calculateSelecteditem();
        },
        onClickOutside: function onClickOutside(e, el) {
            this.dropDownOpen = false;
        }
    },

    mounted: function mounted() {

        this.setItems();
    },
    destroyed: function destroyed() {}
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_claimUtils__ = __webpack_require__(932);
//
//
//
//
//
//
//
//
//
//
//
//
//





var backendApi = new __WEBPACK_IMPORTED_MODULE_0__backendApi__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "project-select",

    props: ['user'],

    mixins: [__WEBPACK_IMPORTED_MODULE_1__helpers_project_mixin__["a" /* default */]],

    data: function data() {
        return {
            projects: []
        };
    },


    methods: {
        onProjectChange: function onProjectChange(item) {
            localStorage.setItem('selectedProjectId', item.Id);
            this.projectId = item.Id;

            this.$emit('onChange', item);
            //this.$emit('project-changed', item);
        }
    },

    mounted: function mounted() {
        var vm = this;
        var selectedProjectId = localStorage.getItem('selectedProjectId');

        backendApi.projectList(0, 100).then(function (resp) {
            if (resp.data && resp.data.length) {
                if (resp.data.length && selectedProjectId == null) {
                    localStorage.setItem('selectedProjectId', resp.data[0].Id);
                }
                if (vm.user.MainRole === 'administrators') {
                    vm.projects = resp.data;
                } else {
                    var routeName = vm.$route.name;

                    var _loop = function _loop(project) {
                        var dynamicRole = vm.user.DynamicRoles.find(function (x) {
                            return x.ProjectId === project.Id;
                        });
                        if (dynamicRole != null) {
                            var pageClaim = __WEBPACK_IMPORTED_MODULE_2__helpers_claimUtils__["a" /* default */].getClaimByRouteName(routeName);
                            if (pageClaim === undefined || !dynamicRole.Claims.find(function (x) {
                                return x.ClaimId === pageClaim;
                            })) {
                                return 'continue';
                            }
                        }
                        vm.projects.push(project);
                    };

                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = resp.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var project = _step.value;

                            var _ret = _loop(project);

                            if (_ret === 'continue') continue;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        });
    }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: "complex-filter",

    props: ['filters', 'searchFunction', 'tableName', 'withTableNameInClause', 'cacheKey', 'getByIdFilters'],

    data: function data() {
        return {
            filterRows: [],
            searchResults: [],
            index: 0,

            page: 1,
            loading: false,
            canBeLoaded: true,
            currentRow: null,
            currentTarget: null,
            currentI: null
        };
    },


    computed: {
        notUsedFilters: function notUsedFilters() {
            var vm = this;

            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(vm.filters, function (item, index) {
                return !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.some(vm.filterRows, { FilterValue: item.Value });
            });
        },
        exportData: function exportData() {
            var vm = this;
            var data = [];

            var _loop = function _loop(r) {
                if (r.values.length) {
                    var operand = 'IN';

                    var forceGettingById = false;
                    if (vm.getByIdFilters && vm.getByIdFilters.findIndex(function (x) {
                        return x === r.FilterValue;
                    }) > -1) {
                        forceGettingById = true;
                    }
                    data.push([vm.withTableNameInClause ? vm.tableName + '.[' + r.FilterValue + ']' : r.FilterValue, operand, '(' + r.values.map(function (item) {
                        if (forceGettingById) {
                            return '\'' + item.Id + '\'';
                        } else {
                            return '\'' + (r.FilterValue.indexOf('TradePointRole_') !== -1 || r.FilterValue.indexOf('UserRole') !== -1 || r.FilterValue.indexOf('Month') !== -1 ? item.Id : encodeURIComponent(item.Name).replace("'", "''")) + '\'';
                        }
                    }).join(';') + ')']);
                }
            };

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = vm.filterRows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var r = _step.value;

                    _loop(r);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return data;
        }
    },

    methods: {
        getNotUsedFilters: function getNotUsedFilters(filterValue) {
            var vm = this;
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(vm.filters, function (item, index) {
                return !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.some(vm.filterRows, { FilterValue: item.Value }) || filterValue && item.Value === filterValue;
            });
        },
        getUniqueSearchResults: function getUniqueSearchResults(row) {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.searchResults, function (item) {
                //console.info('getUniqueSearchResults -> row.values, item.Id, item.Name', row.values, item.Id, item.Name)
                //return !_.includes(row.values, item) && item !== '';
                return item.Name !== '' && !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.some(row.values, function (x) {
                    return item.Id != null && x.Id === item.Id || x.Name === item.Name;
                });
            });
        },
        applyFilter: function applyFilter() {
            this.filterRows.push({
                values: [],
                Selected: false,
                Index: ++this.index,
                PreviousFilterValue: this.filters[0].Value
            });
        },


        // todo:
        recalculateLeftPos: function recalculateLeftPos() {
            var vm = this;

            vm.$nextTick(function () {});
        },


        // выбор колонки для фильтрации
        onFilterChange: function onFilterChange(row, item, index) {
            //console.info('row.FilterValue:', row.FilterValue)
            if (row.FilterValue !== row.PreviousFilterValue) {
                row.PreviousFilterValue = row.FilterValue;
                this.filterRows.splice(index + 1);

                if (row.values.length) {
                    row.values = [];
                    this.$emit('onFilterChange', this.exportData);
                }
            } else {
                row.values = [];
                this.$emit('onFilterChange', this.exportData);
            }
            this.saveFilterState();
        },


        // удаление выбранного значения из строки фильтра
        onRemoveFilterValue: function onRemoveFilterValue(value, i, j) {
            this.filterRows[i].values.splice(j, 1);

            // кроме этого удаляем все фильтры ниже
            this.filterRows.splice(i + 1, 100);

            this.$emit('onFilterChange', this.exportData);
            this.recalculateLeftPos();
            this.saveFilterState();
        },
        onAddFilterValue: function onAddFilterValue(row, i) {
            var vm = this;

            row.Selected = true;
            vm.searchResults = [];

            vm.$nextTick(function () {
                vm.$refs['filterInput' + i][0].focus();

                //console.info('onAddFilterValue');

                vm.currentRow = row;
                vm.currentTarget = vm.$refs['filterInput' + i][0];
                vm.currentI = i;
                vm.page = 1;
                vm.loading = false;
                vm.canBeLoaded = true;
                vm.searchNext(row, vm.$refs['filterInput' + i][0], i);
            });

            this.recalculateLeftPos();
        },


        // новый фильтр
        onFilterRowAdd: function onFilterRowAdd() {
            var vm = this;

            vm.filterRows.push({
                values: [],
                Selected: false,
                Index: ++vm.index
            });
            this.saveFilterState();
        },


        // удаление фильтра
        onFilterRowRemove: function onFilterRowRemove(row, i) {
            this.filterRows.splice(i, 1);

            this.$emit('onFilterChange', this.exportData);
            this.saveFilterState();
        },


        // выбор результата из поиска
        onSearchResultClick: function onSearchResultClick(row, res, i) {
            row.values.push(res);

            if (row.values.length === 1) {
                // было выбрано первое значение, если есть фильтры ниже - их нужно удалить
                this.filterRows.splice(i + 1, 100);
            }

            this.$emit('onFilterChange', this.exportData);

            this.recalculateLeftPos();
            this.saveFilterState();

            row.Selected = false;
        },
        filterRowSetValues: function filterRowSetValues(values) {
            if (this.filterRows.length) {
                this.filterRows[0].values = values;
            }
        },


        // ввод символов в строке фильтра
        onFilterInputChange: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (row, e, i) {

            this.searchResults = [];
            this.searchNext(row, e, i);
        }, 500),

        getFilterForSearch: function getFilterForSearch(i) {
            var vm = this;
            var data = [];
            var index = 0;

            var _loop2 = function _loop2(r) {
                if (index < i) {
                    if (r.values.length) {
                        var operand = 'IN';

                        var forceGettingById = false;
                        if (vm.getByIdFilters && vm.getByIdFilters.findIndex(function (x) {
                            return x === r.FilterValue;
                        }) > -1) {
                            forceGettingById = true;
                        }
                        data.push([vm.withTableNameInClause ? vm.tableName + '.[' + r.FilterValue + ']' : r.FilterValue, operand, '(' + r.values.map(function (item) {
                            if (forceGettingById) {
                                return '\'' + item.Id + '\'';
                            } else {
                                return '\'' + (r.FilterValue.indexOf('TradePointRole_') !== -1 || r.FilterValue.indexOf('UserRole') !== -1 || r.FilterValue.indexOf('Month') !== -1 ? item.Id : encodeURIComponent(item.Name).replace("'", "''")) + '\'';
                            }
                        }).join(';') + ')']);
                    }
                }
                index++;
            };

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = vm.filterRows[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var r = _step2.value;

                    _loop2(r);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return data;
        },
        searchNext: function searchNext(row, e, i, addValues) {
            var vm = this;

            vm.loading = true;
            // let filter = JSON.parse(JSON.stringify(vm.exportData));
            // if (filter.length) {
            //     filter.splice(i - (vm.filterRows.length - filter.length), 100)
            // }
            var filter = this.getFilterForSearch(i);
            //console.info('filter', filter);

            vm.searchFunction(vm.tableName, row.FilterValue, e.value, filter, vm.page, function (res) {
                if (!addValues) {
                    vm.searchResults = [];
                }
                var arr = [];
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = res[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var item = _step3.value;

                        if (typeof item === 'string') {
                            arr.push({
                                Id: item,
                                Name: item
                            });
                        } else {
                            arr.push(item);
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }

                if (arr.length) {
                    var _vm$searchResults;

                    (_vm$searchResults = vm.searchResults).push.apply(_vm$searchResults, arr);
                } else {
                    vm.canBeLoaded = false;
                }

                vm.loading = false;
            }, function (err) {
                vm.loading = false;
                __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка поиска' + (err ? ': ' + err : ''));
            });
        },
        onScroll: function onScroll(e) {
            var vm = this;

            if (!vm.loading && vm.canBeLoaded) {
                var elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target);
                //console.info('onScroll', elem[0].scrollHeight - elem.scrollTop(), elem.outerHeight());
                if (elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight() + 100) {
                    vm.page++;
                    //console.info('need to search');
                    vm.searchNext(vm.currentRow, vm.currentTarget, vm.currentI, true);
                }
            }
        },
        clear: function clear() {
            this.filterRows = [];
            this.saveFilterState();
        },
        onCancelClick: function onCancelClick() {
            this.filterRows = [];
            this.saveFilterState();
            this.$emit('onFilterChange', this.exportData);
        },
        getExpotData: function getExpotData() {
            return this.exportData;
        },
        saveFilterState: function saveFilterState() {
            //console.info('saveFilterState', this.cacheKey);
            localStorage.setItem(this.cacheKey, JSON.stringify(this.filterRows));
        },
        getFilterState: function getFilterState() {
            if (this.cacheKey) {
                return JSON.parse(localStorage.getItem(this.cacheKey));
            }
            return null;
        }
    },

    mounted: function mounted() {
        var vm = this;

        var filterState = (this.getFilterState() || []).filter(function (x) {
            return vm.filters.find(function (y) {
                return y.Value === x.FilterValue;
            });
        });
        vm.filterRows = filterState;

        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
            for (var _iterator4 = vm.filterRows[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var row = _step4.value;

                row.Selected = false;
            }
        } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                }
            } finally {
                if (_didIteratorError4) {
                    throw _iteratorError4;
                }
            }
        }

        vm.$nextTick(function () {

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').on('click', function () {
                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                    for (var _iterator5 = vm.filterRows[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                        var _row = _step5.value;

                        _row.Selected = false;
                    }
                } catch (err) {
                    _didIteratorError5 = true;
                    _iteratorError5 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                            _iterator5.return();
                        }
                    } finally {
                        if (_didIteratorError5) {
                            throw _iteratorError5;
                        }
                    }
                }
            });
        });

        vm.index = 0;
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').off('click');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).find('.dyn-filter-values-select').off('scroll');
    }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "popup-window",

    props: ['name', 'title', 'width', 'height', 'modal'],

    data: function data() {
        return {
            visible: false
        };
    },


    computed: {
        windowWidth: function windowWidth() {
            var ww = this.width ? this.width : null;
            ww = ww + '';
            if (ww.indexOf('%') === -1 && ww.indexOf('vw') === -1 && ww.indexOf('px') === -1) ww = ww + 'px';

            return ww;
        },
        windowHeight: function windowHeight() {
            if (this.height) {
                var ww = this.height;
                ww = ww + '';
                if (ww.indexOf('%') === -1 && ww.indexOf('vw') === -1 && ww.indexOf('px') === -1) ww = ww + 'px';

                return ww;
            } else {
                return 'auto';
            }
        }
    },

    methods: {
        onClickOutside: function onClickOutside(e) {
            var vm = this;
            if (vm.modal === true || e.button === 2) {
                return false;
            }

            if (vm.visible) {
                vm.close();
            }
        },
        show: function show() {
            var vm = this;
            vm.visible = true;
        },
        close: function close() {
            this.visible = false;

            this.$emit('onClose');
        },
        onScroll: function onScroll(e) {
            var elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target);
            if (elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight() + 100) {
                this.$emit('onBottomScrolled');
            }
        }
    },

    mounted: function mounted() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').append(this.$el);
    },
    destroyed: function destroyed() {}
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: "search-filter",

    props: ['name', 'placeholder', 'searchFunction', 'extra', 'selectedItem', 'hasErrors', 'searchOnSelect', 'scrollable', 'disabled', 'fieldName', 'valueItem'],

    $_veeValidate: {
        value: function value() {
            return this.selectedId;
        },
        name: function name() {
            return this.name;
        }
    },

    data: function data() {
        return {
            isMobile: __WEBPACK_IMPORTED_MODULE_2__helpers_ui_helpers__["a" /* default */].check_mobile(),
            dropDownOpen: false,
            searchResults: [],
            selectedId: null,
            page: 1,
            loading: false,
            canBeLoaded: true,
            searchText: null
        };
    },


    watch: {
        selectedItem: function selectedItem(newVal, oldVal) {
            var vm = this;
            //console.info('dd -> watch selectedItem changed', vm.selectedItem, vm.selectedId, vm.searchText);
            if (vm.selectedItem && vm.selectedItem.Id > 0 && vm.selectedItem.Name) {
                //this.$refs.SearchInput.value = vm.selectedItem.Name;
                this.searchText = vm.selectedItem.Name;
                this.selectedId = vm.selectedItem.Id;
            }
        }
    },

    methods: {
        highLightItem: function highLightItem(itemName) {
            var sText = this.searchText;
            if (this.searchText) {
                sText = this.searchText.replaceAll('(', '\\(').replaceAll(')', '\\)').replaceAll('.', '\\.');
            }
            //[ ] / { } ( ) * + ? . \ ^ $ |
            return itemName.replace(new RegExp('(' + sText + ')', 'gi'), '<strong>$1</strong>');
        },
        onSelectResult: function onSelectResult(item) {
            //this.$refs.SearchInput.value = item.Name;
            this.searchText = item.Name;
            this.dropDownOpen = false;

            this.selectedId = item.Id;
            this.$emit('input', this.selectedId);
            //console.info('this.selectedId', item.Name)
            this.$emit('onFilterChange', item, this.extra);
        },
        onFocus: function onFocus() {
            this.$emit('focus');
            var vm = this;

            if (vm.searchOnSelect && !this.selectedId) {
                vm.searchResults = [];
                vm.page = 1;
                vm.loadNext('');
            }
        },
        onFocusOut: function onFocusOut() {
            var elements = document.querySelectorAll(':hover');
            var elem = elements[elements.length - 1];
            if (elem) {
                var bFind = elem.tagName.toLowerCase() === 'span' && elem.parentElement.className === 'dropdown-menu-item' || elem.tagName.toLowerCase() === 'a' && elem.className === 'dropdown-menu-item';
                if (!bFind) this.dropDownOpen = false;
            } else {
                this.dropDownOpen = false;
            }
        },


        onChangeSearchInput: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function ($event) {
            var vm = this;

            vm.selectedId = null;
            vm.$emit('input', vm.selectedId);
            vm.$emit('onFilterChange', null, this.extra);

            /*if (vm.searchText === '') {
                vm.dropDownOpen = false;
                return;
            }*/

            vm.searchResults = [];
            vm.page = 1;
            vm.loadNext();
        }, 500),

        loadNext: function loadNext() {
            var vm = this;

            vm.loading = true;
            vm.searchFunction(vm.searchText, function (res) {
                console.info('searchFunction', res);
                if (res && res.length) {
                    if (vm.page === 1) {
                        vm.searchResults = res;
                    } else {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = res[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var item = _step.value;

                                vm.searchResults.push(item);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } else {
                    vm.canBeLoaded = false;
                }
                vm.loading = false;
            }, vm.extra, vm.page, vm.fieldName);

            vm.dropDownOpen = true;
        }
    },

    mounted: function mounted() {
        var vm = this;

        if (vm.selectedItem) {
            //this.$refs.SearchInput.value = vm.selectedItem.Name;
            this.searchText = vm.selectedItem.Name;
            this.selectedId = vm.selectedItem.Id;
        }

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').on('click', function () {
            vm.dropDownOpen = false;
        });

        if (vm.scrollable) {
            vm.$nextTick(function () {

                //console.info('vm.$el', vm.$el)
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()(vm.$el).find('.dropdown-menu.dropdown-list').on('scroll', function () {

                    if (!vm.loading && vm.canBeLoaded) {
                        var elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
                        if (elem[0].scrollHeight - elem.scrollTop() - 50 <= elem.outerHeight()) {
                            vm.page++;
                            vm.loadNext();
                        }
                    }
                });
            });
        }
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.dropdown-menu.dropdown-list').off('scroll');
    }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_DoughnutPlugin__ = __webpack_require__(951);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "chart",

    props: ['chartData', 'chartOptions', 'type', 'controlClick'],

    data: function data() {
        return {
            chartObj: null
        };
    },


    watch: {
        chartData: function chartData() {
            var vm = this;
            console.info('this.chartOptions', this.chartOptions);
            var opt = vm.chartOptions;

            if (this.controlClick) {
                opt = Object.assign(vm.chartOptions, {
                    onClick: function onClick(event) {
                        if (vm.chartObj.getElementAtEvent(event)[0]) {
                            var datasetIndex = vm.chartObj.getElementAtEvent(event)[0]._datasetIndex;
                            var dataIndex = vm.chartObj.getElementsAtEvent(event)[datasetIndex]._index;
                            vm.$emit('onBarClick', [datasetIndex, dataIndex, event.clientX, event.clientY]);
                        } else {
                            vm.$emit('onBarClick', null);
                        }
                    },
                    onHover: function onHover(event) {
                        var point = vm.chartObj.getElementAtEvent(event);
                        if (point.length) event.target.style.cursor = 'pointer';else event.target.style.cursor = 'default';
                    }
                });
            }
            console.info('opt', opt);
            this.chartObj.options = opt;
            console.info('this.chartObj.options', this.chartObj.options);
            this.chartObj.data = this.chartData;

            this.chartObj.update(); /* */
        }
    },

    methods: {
        update: function update(opts) {
            this.chartObj.options.tooltips.enabled = opts.tooltips.enabled;
            this.chartObj.update();
        }
    },

    mounted: function mounted() {
        var vm = this;

        var ctx = vm.$refs['myChart'];

        var opt = vm.chartOptions;
        this.chartObj = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, {
            type: vm.type || 'bar',
            data: vm.chartData,
            options: opt
        });
    }
});

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Chart.js v2.9.4
 * https://www.chartjs.org
 * (c) 2020 Chart.js Contributors
 * Released under the MIT License
 */
(function (global, factory) {
 true ? module.exports = factory(function() { try { return __webpack_require__(9); } catch(e) { } }()) :
typeof define === 'function' && define.amd ? define(['require'], function(require) { return factory(function() { try { return require('moment'); } catch(e) { } }()); }) :
(global = global || self, global.Chart = factory(global.moment));
}(this, (function (moment) { 'use strict';

moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

var colorName = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

var conversions = createCommonjsModule(function (module) {
/* MIT license */


// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

var reverseKeywords = {};
for (var key in colorName) {
	if (colorName.hasOwnProperty(key)) {
		reverseKeywords[colorName[key]] = key;
	}
}

var convert = module.exports = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

// hide .channels and .labels properties
for (var model in convert) {
	if (convert.hasOwnProperty(model)) {
		if (!('channels' in convert[model])) {
			throw new Error('missing channels property: ' + model);
		}

		if (!('labels' in convert[model])) {
			throw new Error('missing channel labels property: ' + model);
		}

		if (convert[model].labels.length !== convert[model].channels) {
			throw new Error('channel and label counts mismatch: ' + model);
		}

		var channels = convert[model].channels;
		var labels = convert[model].labels;
		delete convert[model].channels;
		delete convert[model].labels;
		Object.defineProperty(convert[model], 'channels', {value: channels});
		Object.defineProperty(convert[model], 'labels', {value: labels});
	}
}

convert.rgb.hsl = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var delta = max - min;
	var h;
	var s;
	var l;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert.rgb.hsv = function (rgb) {
	var rdif;
	var gdif;
	var bdif;
	var h;
	var s;

	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var v = Math.max(r, g, b);
	var diff = v - Math.min(r, g, b);
	var diffc = function (c) {
		return (v - c) / 6 / diff + 1 / 2;
	};

	if (diff === 0) {
		h = s = 0;
	} else {
		s = diff / v;
		rdif = diffc(r);
		gdif = diffc(g);
		bdif = diffc(b);

		if (r === v) {
			h = bdif - gdif;
		} else if (g === v) {
			h = (1 / 3) + rdif - bdif;
		} else if (b === v) {
			h = (2 / 3) + gdif - rdif;
		}
		if (h < 0) {
			h += 1;
		} else if (h > 1) {
			h -= 1;
		}
	}

	return [
		h * 360,
		s * 100,
		v * 100
	];
};

convert.rgb.hwb = function (rgb) {
	var r = rgb[0];
	var g = rgb[1];
	var b = rgb[2];
	var h = convert.rgb.hsl(rgb)[0];
	var w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert.rgb.cmyk = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var c;
	var m;
	var y;
	var k;

	k = Math.min(1 - r, 1 - g, 1 - b);
	c = (1 - r - k) / (1 - k) || 0;
	m = (1 - g - k) / (1 - k) || 0;
	y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};

/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */
function comparativeDistance(x, y) {
	return (
		Math.pow(x[0] - y[0], 2) +
		Math.pow(x[1] - y[1], 2) +
		Math.pow(x[2] - y[2], 2)
	);
}

convert.rgb.keyword = function (rgb) {
	var reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	var currentClosestDistance = Infinity;
	var currentClosestKeyword;

	for (var keyword in colorName) {
		if (colorName.hasOwnProperty(keyword)) {
			var value = colorName[keyword];

			// Compute comparative distance
			var distance = comparativeDistance(rgb, value);

			// Check if its less, if so set as closest
			if (distance < currentClosestDistance) {
				currentClosestDistance = distance;
				currentClosestKeyword = keyword;
			}
		}
	}

	return currentClosestKeyword;
};

convert.keyword.rgb = function (keyword) {
	return colorName[keyword];
};

convert.rgb.xyz = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;

	// assume sRGB
	r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert.rgb.lab = function (rgb) {
	var xyz = convert.rgb.xyz(rgb);
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.hsl.rgb = function (hsl) {
	var h = hsl[0] / 360;
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var t1;
	var t2;
	var t3;
	var rgb;
	var val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	t1 = 2 * l - t2;

	rgb = [0, 0, 0];
	for (var i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}
		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert.hsl.hsv = function (hsl) {
	var h = hsl[0];
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var smin = s;
	var lmin = Math.max(l, 0.01);
	var sv;
	var v;

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	v = (l + s) / 2;
	sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert.hsv.rgb = function (hsv) {
	var h = hsv[0] / 60;
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var hi = Math.floor(h) % 6;

	var f = h - Math.floor(h);
	var p = 255 * v * (1 - s);
	var q = 255 * v * (1 - (s * f));
	var t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert.hsv.hsl = function (hsv) {
	var h = hsv[0];
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var vmin = Math.max(v, 0.01);
	var lmin;
	var sl;
	var l;

	l = (2 - s) * v;
	lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function (hwb) {
	var h = hwb[0] / 360;
	var wh = hwb[1] / 100;
	var bl = hwb[2] / 100;
	var ratio = wh + bl;
	var i;
	var v;
	var f;
	var n;

	// wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	i = Math.floor(6 * h);
	v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	n = wh + f * (v - wh); // linear interpolation

	var r;
	var g;
	var b;
	switch (i) {
		default:
		case 6:
		case 0: r = v; g = n; b = wh; break;
		case 1: r = n; g = v; b = wh; break;
		case 2: r = wh; g = v; b = n; break;
		case 3: r = wh; g = n; b = v; break;
		case 4: r = n; g = wh; b = v; break;
		case 5: r = v; g = wh; b = n; break;
	}

	return [r * 255, g * 255, b * 255];
};

convert.cmyk.rgb = function (cmyk) {
	var c = cmyk[0] / 100;
	var m = cmyk[1] / 100;
	var y = cmyk[2] / 100;
	var k = cmyk[3] / 100;
	var r;
	var g;
	var b;

	r = 1 - Math.min(1, c * (1 - k) + k);
	g = 1 - Math.min(1, m * (1 - k) + k);
	b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.rgb = function (xyz) {
	var x = xyz[0] / 100;
	var y = xyz[1] / 100;
	var z = xyz[2] / 100;
	var r;
	var g;
	var b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// assume sRGB
	r = r > 0.0031308
		? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.lab = function (xyz) {
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.lab.xyz = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var x;
	var y;
	var z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	var y2 = Math.pow(y, 3);
	var x2 = Math.pow(x, 3);
	var z2 = Math.pow(z, 3);
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert.lab.lch = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var hr;
	var h;
	var c;

	hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert.lch.lab = function (lch) {
	var l = lch[0];
	var c = lch[1];
	var h = lch[2];
	var a;
	var b;
	var hr;

	hr = h / 360 * 2 * Math.PI;
	a = c * Math.cos(hr);
	b = c * Math.sin(hr);

	return [l, a, b];
};

convert.rgb.ansi16 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];
	var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	var ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert.hsv.ansi16 = function (args) {
	// optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};

convert.rgb.ansi256 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];

	// we use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	var ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert.ansi16.rgb = function (args) {
	var color = args % 10;

	// handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	var mult = (~~(args > 50) + 1) * 0.5;
	var r = ((color & 1) * mult) * 255;
	var g = (((color >> 1) & 1) * mult) * 255;
	var b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert.ansi256.rgb = function (args) {
	// handle greyscale
	if (args >= 232) {
		var c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	var rem;
	var r = Math.floor(args / 36) / 5 * 255;
	var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	var b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert.rgb.hex = function (args) {
	var integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.hex.rgb = function (args) {
	var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	var colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(function (char) {
			return char + char;
		}).join('');
	}

	var integer = parseInt(colorString, 16);
	var r = (integer >> 16) & 0xFF;
	var g = (integer >> 8) & 0xFF;
	var b = integer & 0xFF;

	return [r, g, b];
};

convert.rgb.hcg = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var max = Math.max(Math.max(r, g), b);
	var min = Math.min(Math.min(r, g), b);
	var chroma = (max - min);
	var grayscale;
	var hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma + 4;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert.hsl.hcg = function (hsl) {
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var c = 1;
	var f = 0;

	if (l < 0.5) {
		c = 2.0 * s * l;
	} else {
		c = 2.0 * s * (1.0 - l);
	}

	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert.hsv.hcg = function (hsv) {
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;

	var c = s * v;
	var f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert.hcg.rgb = function (hcg) {
	var h = hcg[0] / 360;
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	var pure = [0, 0, 0];
	var hi = (h % 1) * 6;
	var v = hi % 1;
	var w = 1 - v;
	var mg = 0;

	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert.hcg.hsv = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var v = c + g * (1.0 - c);
	var f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert.hcg.hsl = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var l = g * (1.0 - c) + 0.5 * c;
	var s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert.hcg.hwb = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;
	var v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert.hwb.hcg = function (hwb) {
	var w = hwb[1] / 100;
	var b = hwb[2] / 100;
	var v = 1 - b;
	var c = v - w;
	var g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert.gray.hsl = convert.gray.hsv = function (args) {
	return [0, 0, args[0]];
};

convert.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert.gray.hex = function (gray) {
	var val = Math.round(gray[0] / 100 * 255) & 0xFF;
	var integer = (val << 16) + (val << 8) + val;

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.rgb.gray = function (rgb) {
	var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};
});
var conversions_1 = conversions.rgb;
var conversions_2 = conversions.hsl;
var conversions_3 = conversions.hsv;
var conversions_4 = conversions.hwb;
var conversions_5 = conversions.cmyk;
var conversions_6 = conversions.xyz;
var conversions_7 = conversions.lab;
var conversions_8 = conversions.lch;
var conversions_9 = conversions.hex;
var conversions_10 = conversions.keyword;
var conversions_11 = conversions.ansi16;
var conversions_12 = conversions.ansi256;
var conversions_13 = conversions.hcg;
var conversions_14 = conversions.apple;
var conversions_15 = conversions.gray;

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
	var graph = {};
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	var models = Object.keys(conversions);

	for (var len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	var graph = buildGraph();
	var queue = [fromModel]; // unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		var current = queue.pop();
		var adjacents = Object.keys(conversions[current]);

		for (var len = adjacents.length, i = 0; i < len; i++) {
			var adjacent = adjacents[i];
			var node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	var path = [graph[toModel].parent, toModel];
	var fn = conversions[graph[toModel].parent][toModel];

	var cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = link(conversions[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

var route = function (fromModel) {
	var graph = deriveBFS(fromModel);
	var conversion = {};

	var models = Object.keys(graph);
	for (var len = models.length, i = 0; i < len; i++) {
		var toModel = models[i];
		var node = graph[toModel];

		if (node.parent === null) {
			// no possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};

var convert = {};

var models = Object.keys(conversions);

function wrapRaw(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		return fn(args);
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		var result = fn(args);

		// we're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (var len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(function (fromModel) {
	convert[fromModel] = {};

	Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});

	var routes = route(fromModel);
	var routeModels = Object.keys(routes);

	routeModels.forEach(function (toModel) {
		var fn = routes[toModel];

		convert[fromModel][toModel] = wrapRounded(fn);
		convert[fromModel][toModel].raw = wrapRaw(fn);
	});
});

var colorConvert = convert;

var colorName$1 = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

/* MIT license */


var colorString = {
   getRgba: getRgba,
   getHsla: getHsla,
   getRgb: getRgb,
   getHsl: getHsl,
   getHwb: getHwb,
   getAlpha: getAlpha,

   hexString: hexString,
   rgbString: rgbString,
   rgbaString: rgbaString,
   percentString: percentString,
   percentaString: percentaString,
   hslString: hslString,
   hslaString: hslaString,
   hwbString: hwbString,
   keyword: keyword
};

function getRgba(string) {
   if (!string) {
      return;
   }
   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       keyword = /(\w+)/;

   var rgb = [0, 0, 0],
       a = 1,
       match = string.match(abbr),
       hexAlpha = "";
   if (match) {
      match = match[1];
      hexAlpha = match[3];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i] + match[i], 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(hex)) {
      hexAlpha = match[2];
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(rgba)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i + 1]);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(per)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(keyword)) {
      if (match[1] == "transparent") {
         return [0, 0, 0, 0];
      }
      rgb = colorName$1[match[1]];
      if (!rgb) {
         return;
      }
   }

   for (var i = 0; i < rgb.length; i++) {
      rgb[i] = scale(rgb[i], 0, 255);
   }
   if (!a && a != 0) {
      a = 1;
   }
   else {
      a = scale(a, 0, 1);
   }
   rgb[3] = a;
   return rgb;
}

function getHsla(string) {
   if (!string) {
      return;
   }
   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hsl);
   if (match) {
      var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
   }
}

function getHwb(string) {
   if (!string) {
      return;
   }
   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hwb);
   if (match) {
    var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
   }
}

function getRgb(string) {
   var rgba = getRgba(string);
   return rgba && rgba.slice(0, 3);
}

function getHsl(string) {
  var hsla = getHsla(string);
  return hsla && hsla.slice(0, 3);
}

function getAlpha(string) {
   var vals = getRgba(string);
   if (vals) {
      return vals[3];
   }
   else if (vals = getHsla(string)) {
      return vals[3];
   }
   else if (vals = getHwb(string)) {
      return vals[3];
   }
}

// generators
function hexString(rgba, a) {
   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
   return "#" + hexDouble(rgba[0]) 
              + hexDouble(rgba[1])
              + hexDouble(rgba[2])
              + (
                 (a >= 0 && a < 1)
                 ? hexDouble(Math.round(a * 255))
                 : ""
              );
}

function rgbString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return rgbaString(rgba, alpha);
   }
   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
}

function rgbaString(rgba, alpha) {
   if (alpha === undefined) {
      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
   }
   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
           + ", " + alpha + ")";
}

function percentString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return percentaString(rgba, alpha);
   }
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);

   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
}

function percentaString(rgba, alpha) {
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);
   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
}

function hslString(hsla, alpha) {
   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
      return hslaString(hsla, alpha);
   }
   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
}

function hslaString(hsla, alpha) {
   if (alpha === undefined) {
      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
   }
   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
           + alpha + ")";
}

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
function hwbString(hwb, alpha) {
   if (alpha === undefined) {
      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
   }
   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
}

function keyword(rgb) {
  return reverseNames[rgb.slice(0, 3)];
}

// helpers
function scale(num, min, max) {
   return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = num.toString(16).toUpperCase();
  return (str.length < 2) ? "0" + str : str;
}


//create a list of reverse color names
var reverseNames = {};
for (var name in colorName$1) {
   reverseNames[colorName$1[name]] = name;
}

/* MIT license */



var Color = function (obj) {
	if (obj instanceof Color) {
		return obj;
	}
	if (!(this instanceof Color)) {
		return new Color(obj);
	}

	this.valid = false;
	this.values = {
		rgb: [0, 0, 0],
		hsl: [0, 0, 0],
		hsv: [0, 0, 0],
		hwb: [0, 0, 0],
		cmyk: [0, 0, 0, 0],
		alpha: 1
	};

	// parse Color() argument
	var vals;
	if (typeof obj === 'string') {
		vals = colorString.getRgba(obj);
		if (vals) {
			this.setValues('rgb', vals);
		} else if (vals = colorString.getHsla(obj)) {
			this.setValues('hsl', vals);
		} else if (vals = colorString.getHwb(obj)) {
			this.setValues('hwb', vals);
		}
	} else if (typeof obj === 'object') {
		vals = obj;
		if (vals.r !== undefined || vals.red !== undefined) {
			this.setValues('rgb', vals);
		} else if (vals.l !== undefined || vals.lightness !== undefined) {
			this.setValues('hsl', vals);
		} else if (vals.v !== undefined || vals.value !== undefined) {
			this.setValues('hsv', vals);
		} else if (vals.w !== undefined || vals.whiteness !== undefined) {
			this.setValues('hwb', vals);
		} else if (vals.c !== undefined || vals.cyan !== undefined) {
			this.setValues('cmyk', vals);
		}
	}
};

Color.prototype = {
	isValid: function () {
		return this.valid;
	},
	rgb: function () {
		return this.setSpace('rgb', arguments);
	},
	hsl: function () {
		return this.setSpace('hsl', arguments);
	},
	hsv: function () {
		return this.setSpace('hsv', arguments);
	},
	hwb: function () {
		return this.setSpace('hwb', arguments);
	},
	cmyk: function () {
		return this.setSpace('cmyk', arguments);
	},

	rgbArray: function () {
		return this.values.rgb;
	},
	hslArray: function () {
		return this.values.hsl;
	},
	hsvArray: function () {
		return this.values.hsv;
	},
	hwbArray: function () {
		var values = this.values;
		if (values.alpha !== 1) {
			return values.hwb.concat([values.alpha]);
		}
		return values.hwb;
	},
	cmykArray: function () {
		return this.values.cmyk;
	},
	rgbaArray: function () {
		var values = this.values;
		return values.rgb.concat([values.alpha]);
	},
	hslaArray: function () {
		var values = this.values;
		return values.hsl.concat([values.alpha]);
	},
	alpha: function (val) {
		if (val === undefined) {
			return this.values.alpha;
		}
		this.setValues('alpha', val);
		return this;
	},

	red: function (val) {
		return this.setChannel('rgb', 0, val);
	},
	green: function (val) {
		return this.setChannel('rgb', 1, val);
	},
	blue: function (val) {
		return this.setChannel('rgb', 2, val);
	},
	hue: function (val) {
		if (val) {
			val %= 360;
			val = val < 0 ? 360 + val : val;
		}
		return this.setChannel('hsl', 0, val);
	},
	saturation: function (val) {
		return this.setChannel('hsl', 1, val);
	},
	lightness: function (val) {
		return this.setChannel('hsl', 2, val);
	},
	saturationv: function (val) {
		return this.setChannel('hsv', 1, val);
	},
	whiteness: function (val) {
		return this.setChannel('hwb', 1, val);
	},
	blackness: function (val) {
		return this.setChannel('hwb', 2, val);
	},
	value: function (val) {
		return this.setChannel('hsv', 2, val);
	},
	cyan: function (val) {
		return this.setChannel('cmyk', 0, val);
	},
	magenta: function (val) {
		return this.setChannel('cmyk', 1, val);
	},
	yellow: function (val) {
		return this.setChannel('cmyk', 2, val);
	},
	black: function (val) {
		return this.setChannel('cmyk', 3, val);
	},

	hexString: function () {
		return colorString.hexString(this.values.rgb);
	},
	rgbString: function () {
		return colorString.rgbString(this.values.rgb, this.values.alpha);
	},
	rgbaString: function () {
		return colorString.rgbaString(this.values.rgb, this.values.alpha);
	},
	percentString: function () {
		return colorString.percentString(this.values.rgb, this.values.alpha);
	},
	hslString: function () {
		return colorString.hslString(this.values.hsl, this.values.alpha);
	},
	hslaString: function () {
		return colorString.hslaString(this.values.hsl, this.values.alpha);
	},
	hwbString: function () {
		return colorString.hwbString(this.values.hwb, this.values.alpha);
	},
	keyword: function () {
		return colorString.keyword(this.values.rgb, this.values.alpha);
	},

	rgbNumber: function () {
		var rgb = this.values.rgb;
		return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.values.rgb;
		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}
		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();
		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}
		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	dark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.values.rgb;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	light: function () {
		return !this.dark();
	},

	negate: function () {
		var rgb = [];
		for (var i = 0; i < 3; i++) {
			rgb[i] = 255 - this.values.rgb[i];
		}
		this.setValues('rgb', rgb);
		return this;
	},

	lighten: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] += hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	darken: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] -= hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	saturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] += hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	desaturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] -= hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	whiten: function (ratio) {
		var hwb = this.values.hwb;
		hwb[1] += hwb[1] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	blacken: function (ratio) {
		var hwb = this.values.hwb;
		hwb[2] += hwb[2] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	greyscale: function () {
		var rgb = this.values.rgb;
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		this.setValues('rgb', [val, val, val]);
		return this;
	},

	clearer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha - (alpha * ratio));
		return this;
	},

	opaquer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha + (alpha * ratio));
		return this;
	},

	rotate: function (degrees) {
		var hsl = this.values.hsl;
		var hue = (hsl[0] + degrees) % 360;
		hsl[0] = hue < 0 ? 360 + hue : hue;
		this.setValues('hsl', hsl);
		return this;
	},

	/**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */
	mix: function (mixinColor, weight) {
		var color1 = this;
		var color2 = mixinColor;
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return this
			.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue()
			)
			.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
	},

	toJSON: function () {
		return this.rgb();
	},

	clone: function () {
		// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
		// making the final build way to big to embed in Chart.js. So let's do it manually,
		// assuming that values to clone are 1 dimension arrays containing only numbers,
		// except 'alpha' which is a number.
		var result = new Color();
		var source = this.values;
		var target = result.values;
		var value, type;

		for (var prop in source) {
			if (source.hasOwnProperty(prop)) {
				value = source[prop];
				type = ({}).toString.call(value);
				if (type === '[object Array]') {
					target[prop] = value.slice(0);
				} else if (type === '[object Number]') {
					target[prop] = value;
				} else {
					console.error('unexpected color value:', value);
				}
			}
		}

		return result;
	}
};

Color.prototype.spaces = {
	rgb: ['red', 'green', 'blue'],
	hsl: ['hue', 'saturation', 'lightness'],
	hsv: ['hue', 'saturation', 'value'],
	hwb: ['hue', 'whiteness', 'blackness'],
	cmyk: ['cyan', 'magenta', 'yellow', 'black']
};

Color.prototype.maxes = {
	rgb: [255, 255, 255],
	hsl: [360, 100, 100],
	hsv: [360, 100, 100],
	hwb: [360, 100, 100],
	cmyk: [100, 100, 100, 100]
};

Color.prototype.getValues = function (space) {
	var values = this.values;
	var vals = {};

	for (var i = 0; i < space.length; i++) {
		vals[space.charAt(i)] = values[space][i];
	}

	if (values.alpha !== 1) {
		vals.a = values.alpha;
	}

	// {r: 255, g: 255, b: 255, a: 0.4}
	return vals;
};

Color.prototype.setValues = function (space, vals) {
	var values = this.values;
	var spaces = this.spaces;
	var maxes = this.maxes;
	var alpha = 1;
	var i;

	this.valid = true;

	if (space === 'alpha') {
		alpha = vals;
	} else if (vals.length) {
		// [10, 10, 10]
		values[space] = vals.slice(0, space.length);
		alpha = vals[space.length];
	} else if (vals[space.charAt(0)] !== undefined) {
		// {r: 10, g: 10, b: 10}
		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[space.charAt(i)];
		}

		alpha = vals.a;
	} else if (vals[spaces[space][0]] !== undefined) {
		// {red: 10, green: 10, blue: 10}
		var chans = spaces[space];

		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[chans[i]];
		}

		alpha = vals.alpha;
	}

	values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));

	if (space === 'alpha') {
		return false;
	}

	var capped;

	// cap values of the space prior converting all values
	for (i = 0; i < space.length; i++) {
		capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
		values[space][i] = Math.round(capped);
	}

	// convert to all the other color spaces
	for (var sname in spaces) {
		if (sname !== space) {
			values[sname] = colorConvert[space][sname](values[space]);
		}
	}

	return true;
};

Color.prototype.setSpace = function (space, args) {
	var vals = args[0];

	if (vals === undefined) {
		// color.rgb()
		return this.getValues(space);
	}

	// color.rgb(10, 10, 10)
	if (typeof vals === 'number') {
		vals = Array.prototype.slice.call(args);
	}

	this.setValues(space, vals);
	return this;
};

Color.prototype.setChannel = function (space, index, val) {
	var svalues = this.values[space];
	if (val === undefined) {
		// color.red()
		return svalues[index];
	} else if (val === svalues[index]) {
		// color.red(color.red())
		return this;
	}

	// color.red(100)
	svalues[index] = val;
	this.setValues(space, svalues);

	return this;
};

if (typeof window !== 'undefined') {
	window.Color = Color;
}

var chartjsColor = Color;

function isValidKey(key) {
	return ['__proto__', 'prototype', 'constructor'].indexOf(key) === -1;
}

/**
 * @namespace Chart.helpers
 */
var helpers = {
	/**
	 * An empty function that can be used, for example, for optional callback.
	 */
	noop: function() {},

	/**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {number}
	 * @function
	 */
	uid: (function() {
		var id = 0;
		return function() {
			return id++;
		};
	}()),

	/**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */
	isNullOrUndef: function(value) {
		return value === null || typeof value === 'undefined';
	},

	/**
	 * Returns true if `value` is an array (including typed arrays), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @function
	 */
	isArray: function(value) {
		if (Array.isArray && Array.isArray(value)) {
			return true;
		}
		var type = Object.prototype.toString.call(value);
		if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
			return true;
		}
		return false;
	},

	/**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */
	isObject: function(value) {
		return value !== null && Object.prototype.toString.call(value) === '[object Object]';
	},

	/**
	 * Returns true if `value` is a finite number, else returns false
	 * @param {*} value  - The value to test.
	 * @returns {boolean}
	 */
	isFinite: function(value) {
		return (typeof value === 'number' || value instanceof Number) && isFinite(value);
	},

	/**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */
	valueOrDefault: function(value, defaultValue) {
		return typeof value === 'undefined' ? defaultValue : value;
	},

	/**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */
	valueAtIndexOrDefault: function(value, index, defaultValue) {
		return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
	},

	/**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */
	callback: function(fn, args, thisArg) {
		if (fn && typeof fn.call === 'function') {
			return fn.apply(thisArg, args);
		}
	},

	/**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {object|Array} loopable - The object or array to be iterated.
	 * @param {function} fn - The function to call for each item.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
	 */
	each: function(loopable, fn, thisArg, reverse) {
		var i, len, keys;
		if (helpers.isArray(loopable)) {
			len = loopable.length;
			if (reverse) {
				for (i = len - 1; i >= 0; i--) {
					fn.call(thisArg, loopable[i], i);
				}
			} else {
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[i], i);
				}
			}
		} else if (helpers.isObject(loopable)) {
			keys = Object.keys(loopable);
			len = keys.length;
			for (i = 0; i < len; i++) {
				fn.call(thisArg, loopable[keys[i]], keys[i]);
			}
		}
	},

	/**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see https://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {boolean}
	 */
	arrayEquals: function(a0, a1) {
		var i, ilen, v0, v1;

		if (!a0 || !a1 || a0.length !== a1.length) {
			return false;
		}

		for (i = 0, ilen = a0.length; i < ilen; ++i) {
			v0 = a0[i];
			v1 = a1[i];

			if (v0 instanceof Array && v1 instanceof Array) {
				if (!helpers.arrayEquals(v0, v1)) {
					return false;
				}
			} else if (v0 !== v1) {
				// NOTE: two different object instances will never be equal: {x:20} != {x:20}
				return false;
			}
		}

		return true;
	},

	/**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */
	clone: function(source) {
		if (helpers.isArray(source)) {
			return source.map(helpers.clone);
		}

		if (helpers.isObject(source)) {
			var target = Object.create(source);
			var keys = Object.keys(source);
			var klen = keys.length;
			var k = 0;

			for (; k < klen; ++k) {
				target[keys[k]] = helpers.clone(source[keys[k]]);
			}

			return target;
		}

		return source;
	},

	/**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
	 * @private
	 */
	_merger: function(key, target, source, options) {
		if (!isValidKey(key)) {
			// We want to ensure we do not copy prototypes over
			// as this can pollute global namespaces
			return;
		}

		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.merge(tval, sval, options);
		} else {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */
	_mergerIf: function(key, target, source) {
		if (!isValidKey(key)) {
			// We want to ensure we do not copy prototypes over
			// as this can pollute global namespaces
			return;
		}

		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.mergeIf(tval, sval);
		} else if (!target.hasOwnProperty(key)) {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @param {object} [options] - Merging options:
	 * @param {function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {object} The `target` object.
	 */
	merge: function(target, source, options) {
		var sources = helpers.isArray(source) ? source : [source];
		var ilen = sources.length;
		var merge, i, keys, klen, k;

		if (!helpers.isObject(target)) {
			return target;
		}

		options = options || {};
		merge = options.merger || helpers._merger;

		for (i = 0; i < ilen; ++i) {
			source = sources[i];
			if (!helpers.isObject(source)) {
				continue;
			}

			keys = Object.keys(source);
			for (k = 0, klen = keys.length; k < klen; ++k) {
				merge(keys[k], target, source, options);
			}
		}

		return target;
	},

	/**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @returns {object} The `target` object.
	 */
	mergeIf: function(target, source) {
		return helpers.merge(target, source, {merger: helpers._mergerIf});
	},

	/**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {object} target - The target object in which all objects are merged into.
	 * @param {object} arg1 - Object containing additional properties to merge in target.
	 * @param {object} argN - Additional objects containing properties to merge in target.
	 * @returns {object} The `target` object.
	 */
	extend: Object.assign || function(target) {
		return helpers.merge(target, [].slice.call(arguments, 1), {
			merger: function(key, dst, src) {
				dst[key] = src[key];
			}
		});
	},

	/**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */
	inherits: function(extensions) {
		var me = this;
		var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
			return me.apply(this, arguments);
		};

		var Surrogate = function() {
			this.constructor = ChartElement;
		};

		Surrogate.prototype = me.prototype;
		ChartElement.prototype = new Surrogate();
		ChartElement.extend = helpers.inherits;

		if (extensions) {
			helpers.extend(ChartElement.prototype, extensions);
		}

		ChartElement.__super__ = me.prototype;
		return ChartElement;
	},

	_deprecated: function(scope, value, previous, current) {
		if (value !== undefined) {
			console.warn(scope + ': "' + previous +
				'" is deprecated. Please use "' + current + '" instead');
		}
	}
};

var helpers_core = helpers;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
helpers.callCallback = helpers.callback;

/**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.indexOf = function(array, item, fromIndex) {
	return Array.prototype.indexOf.call(array, item, fromIndex);
};

/**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueOrDefault = helpers.valueOrDefault;

/**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;

/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */
var effects = {
	linear: function(t) {
		return t;
	},

	easeInQuad: function(t) {
		return t * t;
	},

	easeOutQuad: function(t) {
		return -t * (t - 2);
	},

	easeInOutQuad: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t;
		}
		return -0.5 * ((--t) * (t - 2) - 1);
	},

	easeInCubic: function(t) {
		return t * t * t;
	},

	easeOutCubic: function(t) {
		return (t = t - 1) * t * t + 1;
	},

	easeInOutCubic: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t + 2);
	},

	easeInQuart: function(t) {
		return t * t * t * t;
	},

	easeOutQuart: function(t) {
		return -((t = t - 1) * t * t * t - 1);
	},

	easeInOutQuart: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t;
		}
		return -0.5 * ((t -= 2) * t * t * t - 2);
	},

	easeInQuint: function(t) {
		return t * t * t * t * t;
	},

	easeOutQuint: function(t) {
		return (t = t - 1) * t * t * t * t + 1;
	},

	easeInOutQuint: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t * t * t + 2);
	},

	easeInSine: function(t) {
		return -Math.cos(t * (Math.PI / 2)) + 1;
	},

	easeOutSine: function(t) {
		return Math.sin(t * (Math.PI / 2));
	},

	easeInOutSine: function(t) {
		return -0.5 * (Math.cos(Math.PI * t) - 1);
	},

	easeInExpo: function(t) {
		return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
	},

	easeOutExpo: function(t) {
		return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
	},

	easeInOutExpo: function(t) {
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if ((t /= 0.5) < 1) {
			return 0.5 * Math.pow(2, 10 * (t - 1));
		}
		return 0.5 * (-Math.pow(2, -10 * --t) + 2);
	},

	easeInCirc: function(t) {
		if (t >= 1) {
			return t;
		}
		return -(Math.sqrt(1 - t * t) - 1);
	},

	easeOutCirc: function(t) {
		return Math.sqrt(1 - (t = t - 1) * t);
	},

	easeInOutCirc: function(t) {
		if ((t /= 0.5) < 1) {
			return -0.5 * (Math.sqrt(1 - t * t) - 1);
		}
		return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
	},

	easeInElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
	},

	easeOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
	},

	easeInOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if ((t /= 0.5) === 2) {
			return 1;
		}
		if (!p) {
			p = 0.45;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		if (t < 1) {
			return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		}
		return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
	},
	easeInBack: function(t) {
		var s = 1.70158;
		return t * t * ((s + 1) * t - s);
	},

	easeOutBack: function(t) {
		var s = 1.70158;
		return (t = t - 1) * t * ((s + 1) * t + s) + 1;
	},

	easeInOutBack: function(t) {
		var s = 1.70158;
		if ((t /= 0.5) < 1) {
			return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
		}
		return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
	},

	easeInBounce: function(t) {
		return 1 - effects.easeOutBounce(1 - t);
	},

	easeOutBounce: function(t) {
		if (t < (1 / 2.75)) {
			return 7.5625 * t * t;
		}
		if (t < (2 / 2.75)) {
			return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
		}
		if (t < (2.5 / 2.75)) {
			return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
		}
		return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
	},

	easeInOutBounce: function(t) {
		if (t < 0.5) {
			return effects.easeInBounce(t * 2) * 0.5;
		}
		return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
	}
};

var helpers_easing = {
	effects: effects
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.easingEffects = effects;

var PI = Math.PI;
var RAD_PER_DEG = PI / 180;
var DOUBLE_PI = PI * 2;
var HALF_PI = PI / 2;
var QUARTER_PI = PI / 4;
var TWO_THIRDS_PI = PI * 2 / 3;

/**
 * @namespace Chart.helpers.canvas
 */
var exports$1 = {
	/**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */
	clear: function(chart) {
		chart.ctx.clearRect(0, 0, chart.width, chart.height);
	},

	/**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {number} width - The rectangle's width.
	 * @param {number} height - The rectangle's height.
	 * @param {number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */
	roundedRect: function(ctx, x, y, width, height, radius) {
		if (radius) {
			var r = Math.min(radius, height / 2, width / 2);
			var left = x + r;
			var top = y + r;
			var right = x + width - r;
			var bottom = y + height - r;

			ctx.moveTo(x, top);
			if (left < right && top < bottom) {
				ctx.arc(left, top, r, -PI, -HALF_PI);
				ctx.arc(right, top, r, -HALF_PI, 0);
				ctx.arc(right, bottom, r, 0, HALF_PI);
				ctx.arc(left, bottom, r, HALF_PI, PI);
			} else if (left < right) {
				ctx.moveTo(left, y);
				ctx.arc(right, top, r, -HALF_PI, HALF_PI);
				ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
			} else if (top < bottom) {
				ctx.arc(left, top, r, -PI, 0);
				ctx.arc(left, bottom, r, 0, PI);
			} else {
				ctx.arc(left, top, r, -PI, PI);
			}
			ctx.closePath();
			ctx.moveTo(x, y);
		} else {
			ctx.rect(x, y, width, height);
		}
	},

	drawPoint: function(ctx, style, radius, x, y, rotation) {
		var type, xOffset, yOffset, size, cornerRadius;
		var rad = (rotation || 0) * RAD_PER_DEG;

		if (style && typeof style === 'object') {
			type = style.toString();
			if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
				ctx.save();
				ctx.translate(x, y);
				ctx.rotate(rad);
				ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
				ctx.restore();
				return;
			}
		}

		if (isNaN(radius) || radius <= 0) {
			return;
		}

		ctx.beginPath();

		switch (style) {
		// Default includes circle
		default:
			ctx.arc(x, y, radius, 0, DOUBLE_PI);
			ctx.closePath();
			break;
		case 'triangle':
			ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			rad += TWO_THIRDS_PI;
			ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			rad += TWO_THIRDS_PI;
			ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			ctx.closePath();
			break;
		case 'rectRounded':
			// NOTE: the rounded rect implementation changed to use `arc` instead of
			// `quadraticCurveTo` since it generates better results when rect is
			// almost a circle. 0.516 (instead of 0.5) produces results with visually
			// closer proportion to the previous impl and it is inscribed in the
			// circle with `radius`. For more details, see the following PRs:
			// https://github.com/chartjs/Chart.js/issues/5597
			// https://github.com/chartjs/Chart.js/issues/5858
			cornerRadius = radius * 0.516;
			size = radius - cornerRadius;
			xOffset = Math.cos(rad + QUARTER_PI) * size;
			yOffset = Math.sin(rad + QUARTER_PI) * size;
			ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
			ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
			ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
			ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
			ctx.closePath();
			break;
		case 'rect':
			if (!rotation) {
				size = Math.SQRT1_2 * radius;
				ctx.rect(x - size, y - size, 2 * size, 2 * size);
				break;
			}
			rad += QUARTER_PI;
			/* falls through */
		case 'rectRot':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + yOffset, y - xOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			ctx.closePath();
			break;
		case 'crossRot':
			rad += QUARTER_PI;
			/* falls through */
		case 'cross':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			break;
		case 'star':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			rad += QUARTER_PI;
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			break;
		case 'line':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			break;
		case 'dash':
			ctx.moveTo(x, y);
			ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
			break;
		}

		ctx.fill();
		ctx.stroke();
	},

	/**
	 * Returns true if the point is inside the rectangle
	 * @param {object} point - The point to test
	 * @param {object} area - The rectangle
	 * @returns {boolean}
	 * @private
	 */
	_isPointInArea: function(point, area) {
		var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.

		return point.x > area.left - epsilon && point.x < area.right + epsilon &&
			point.y > area.top - epsilon && point.y < area.bottom + epsilon;
	},

	clipArea: function(ctx, area) {
		ctx.save();
		ctx.beginPath();
		ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
		ctx.clip();
	},

	unclipArea: function(ctx) {
		ctx.restore();
	},

	lineTo: function(ctx, previous, target, flip) {
		var stepped = target.steppedLine;
		if (stepped) {
			if (stepped === 'middle') {
				var midpoint = (previous.x + target.x) / 2.0;
				ctx.lineTo(midpoint, flip ? target.y : previous.y);
				ctx.lineTo(midpoint, flip ? previous.y : target.y);
			} else if ((stepped === 'after' && !flip) || (stepped !== 'after' && flip)) {
				ctx.lineTo(previous.x, target.y);
			} else {
				ctx.lineTo(target.x, previous.y);
			}
			ctx.lineTo(target.x, target.y);
			return;
		}

		if (!target.tension) {
			ctx.lineTo(target.x, target.y);
			return;
		}

		ctx.bezierCurveTo(
			flip ? previous.controlPointPreviousX : previous.controlPointNextX,
			flip ? previous.controlPointPreviousY : previous.controlPointNextY,
			flip ? target.controlPointNextX : target.controlPointPreviousX,
			flip ? target.controlPointNextY : target.controlPointPreviousY,
			target.x,
			target.y);
	}
};

var helpers_canvas = exports$1;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.clear = exports$1.clear;

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.drawRoundedRectangle = function(ctx) {
	ctx.beginPath();
	exports$1.roundedRect.apply(exports$1, arguments);
};

var defaults = {
	/**
	 * @private
	 */
	_set: function(scope, values) {
		return helpers_core.merge(this[scope] || (this[scope] = {}), values);
	}
};

// TODO(v3): remove 'global' from namespace.  all default are global and
// there's inconsistency around which options are under 'global'
defaults._set('global', {
	defaultColor: 'rgba(0,0,0,0.1)',
	defaultFontColor: '#666',
	defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
	defaultFontSize: 12,
	defaultFontStyle: 'normal',
	defaultLineHeight: 1.2,
	showLines: true
});

var core_defaults = defaults;

var valueOrDefault = helpers_core.valueOrDefault;

/**
 * Converts the given font object into a CSS font string.
 * @param {object} font - A font object.
 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */
function toFontString(font) {
	if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
		return null;
	}

	return (font.style ? font.style + ' ' : '')
		+ (font.weight ? font.weight + ' ' : '')
		+ font.size + 'px '
		+ font.family;
}

/**
 * @alias Chart.helpers.options
 * @namespace
 */
var helpers_options = {
	/**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */
	toLineHeight: function(value, size) {
		var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
		if (!matches || matches[1] === 'normal') {
			return size * 1.2;
		}

		value = +matches[2];

		switch (matches[3]) {
		case 'px':
			return value;
		case '%':
			value /= 100;
			break;
		}

		return size * value;
	},

	/**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {number|object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */
	toPadding: function(value) {
		var t, r, b, l;

		if (helpers_core.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}

		return {
			top: t,
			right: r,
			bottom: b,
			left: l,
			height: t + b,
			width: l + r
		};
	},

	/**
	 * Parses font options and returns the font object.
	 * @param {object} options - A object that contains font options to be parsed.
	 * @return {object} The font object.
	 * @todo Support font.* options and renamed to toFont().
	 * @private
	 */
	_parseFont: function(options) {
		var globalDefaults = core_defaults.global;
		var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
		var font = {
			family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
			lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
			size: size,
			style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
			weight: null,
			string: ''
		};

		font.string = toFontString(font);
		return font;
	},

	/**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array} inputs - An array of values, falling back to the last value.
	 * @param {object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @param {object} [info] - object to return information about resolution in
	 * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
	 * @since 2.7.0
	 */
	resolve: function(inputs, context, index, info) {
		var cacheable = true;
		var i, ilen, value;

		for (i = 0, ilen = inputs.length; i < ilen; ++i) {
			value = inputs[i];
			if (value === undefined) {
				continue;
			}
			if (context !== undefined && typeof value === 'function') {
				value = value(context);
				cacheable = false;
			}
			if (index !== undefined && helpers_core.isArray(value)) {
				value = value[index];
				cacheable = false;
			}
			if (value !== undefined) {
				if (info && !cacheable) {
					info.cacheable = false;
				}
				return value;
			}
		}
	}
};

/**
 * @alias Chart.helpers.math
 * @namespace
 */
var exports$2 = {
	/**
	 * Returns an array of factors sorted from 1 to sqrt(value)
	 * @private
	 */
	_factorize: function(value) {
		var result = [];
		var sqrt = Math.sqrt(value);
		var i;

		for (i = 1; i < sqrt; i++) {
			if (value % i === 0) {
				result.push(i);
				result.push(value / i);
			}
		}
		if (sqrt === (sqrt | 0)) { // if value is a square number
			result.push(sqrt);
		}

		result.sort(function(a, b) {
			return a - b;
		}).pop();
		return result;
	},

	log10: Math.log10 || function(x) {
		var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
		// Check for whole powers of 10,
		// which due to floating point rounding error should be corrected.
		var powerOf10 = Math.round(exponent);
		var isPowerOf10 = x === Math.pow(10, powerOf10);

		return isPowerOf10 ? powerOf10 : exponent;
	}
};

var helpers_math = exports$2;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
 * @namespace Chart.helpers.log10
 * @deprecated since version 2.9.0
 * @todo remove at version 3
 * @private
 */
helpers_core.log10 = exports$2.log10;

var getRtlAdapter = function(rectX, width) {
	return {
		x: function(x) {
			return rectX + rectX + width - x;
		},
		setWidth: function(w) {
			width = w;
		},
		textAlign: function(align) {
			if (align === 'center') {
				return align;
			}
			return align === 'right' ? 'left' : 'right';
		},
		xPlus: function(x, value) {
			return x - value;
		},
		leftForLtr: function(x, itemWidth) {
			return x - itemWidth;
		},
	};
};

var getLtrAdapter = function() {
	return {
		x: function(x) {
			return x;
		},
		setWidth: function(w) { // eslint-disable-line no-unused-vars
		},
		textAlign: function(align) {
			return align;
		},
		xPlus: function(x, value) {
			return x + value;
		},
		leftForLtr: function(x, _itemWidth) { // eslint-disable-line no-unused-vars
			return x;
		},
	};
};

var getAdapter = function(rtl, rectX, width) {
	return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
};

var overrideTextDirection = function(ctx, direction) {
	var style, original;
	if (direction === 'ltr' || direction === 'rtl') {
		style = ctx.canvas.style;
		original = [
			style.getPropertyValue('direction'),
			style.getPropertyPriority('direction'),
		];

		style.setProperty('direction', direction, 'important');
		ctx.prevTextDirection = original;
	}
};

var restoreTextDirection = function(ctx) {
	var original = ctx.prevTextDirection;
	if (original !== undefined) {
		delete ctx.prevTextDirection;
		ctx.canvas.style.setProperty('direction', original[0], original[1]);
	}
};

var helpers_rtl = {
	getRtlAdapter: getAdapter,
	overrideTextDirection: overrideTextDirection,
	restoreTextDirection: restoreTextDirection,
};

var helpers$1 = helpers_core;
var easing = helpers_easing;
var canvas = helpers_canvas;
var options = helpers_options;
var math = helpers_math;
var rtl = helpers_rtl;
helpers$1.easing = easing;
helpers$1.canvas = canvas;
helpers$1.options = options;
helpers$1.math = math;
helpers$1.rtl = rtl;

function interpolate(start, view, model, ease) {
	var keys = Object.keys(model);
	var i, ilen, key, actual, origin, target, type, c0, c1;

	for (i = 0, ilen = keys.length; i < ilen; ++i) {
		key = keys[i];

		target = model[key];

		// if a value is added to the model after pivot() has been called, the view
		// doesn't contain it, so let's initialize the view to the target value.
		if (!view.hasOwnProperty(key)) {
			view[key] = target;
		}

		actual = view[key];

		if (actual === target || key[0] === '_') {
			continue;
		}

		if (!start.hasOwnProperty(key)) {
			start[key] = actual;
		}

		origin = start[key];

		type = typeof target;

		if (type === typeof origin) {
			if (type === 'string') {
				c0 = chartjsColor(origin);
				if (c0.valid) {
					c1 = chartjsColor(target);
					if (c1.valid) {
						view[key] = c1.mix(c0, ease).rgbString();
						continue;
					}
				}
			} else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
				view[key] = origin + (target - origin) * ease;
				continue;
			}
		}

		view[key] = target;
	}
}

var Element = function(configuration) {
	helpers$1.extend(this, configuration);
	this.initialize.apply(this, arguments);
};

helpers$1.extend(Element.prototype, {
	_type: undefined,

	initialize: function() {
		this.hidden = false;
	},

	pivot: function() {
		var me = this;
		if (!me._view) {
			me._view = helpers$1.extend({}, me._model);
		}
		me._start = {};
		return me;
	},

	transition: function(ease) {
		var me = this;
		var model = me._model;
		var start = me._start;
		var view = me._view;

		// No animation -> No Transition
		if (!model || ease === 1) {
			me._view = helpers$1.extend({}, model);
			me._start = null;
			return me;
		}

		if (!view) {
			view = me._view = {};
		}

		if (!start) {
			start = me._start = {};
		}

		interpolate(start, view, model, ease);

		return me;
	},

	tooltipPosition: function() {
		return {
			x: this._model.x,
			y: this._model.y
		};
	},

	hasValue: function() {
		return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
	}
});

Element.extend = helpers$1.inherits;

var core_element = Element;

var exports$3 = core_element.extend({
	chart: null, // the animation associated chart instance
	currentStep: 0, // the current animation step
	numSteps: 60, // default number of steps
	easing: '', // the easing to use for this animation
	render: null, // render function used by the animation service

	onAnimationProgress: null, // user specified callback to fire on each step of the animation
	onAnimationComplete: null, // user specified callback to fire when the animation finishes
});

var core_animation = exports$3;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.Animation instead
 * @prop Chart.Animation#animationObject
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */
Object.defineProperty(exports$3.prototype, 'animationObject', {
	get: function() {
		return this;
	}
});

/**
 * Provided for backward compatibility, use Chart.Animation#chart instead
 * @prop Chart.Animation#chartInstance
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */
Object.defineProperty(exports$3.prototype, 'chartInstance', {
	get: function() {
		return this.chart;
	},
	set: function(value) {
		this.chart = value;
	}
});

core_defaults._set('global', {
	animation: {
		duration: 1000,
		easing: 'easeOutQuart',
		onProgress: helpers$1.noop,
		onComplete: helpers$1.noop
	}
});

var core_animations = {
	animations: [],
	request: null,

	/**
	 * @param {Chart} chart - The chart to animate.
	 * @param {Chart.Animation} animation - The animation that we will animate.
	 * @param {number} duration - The animation duration in ms.
	 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
	 */
	addAnimation: function(chart, animation, duration, lazy) {
		var animations = this.animations;
		var i, ilen;

		animation.chart = chart;
		animation.startTime = Date.now();
		animation.duration = duration;

		if (!lazy) {
			chart.animating = true;
		}

		for (i = 0, ilen = animations.length; i < ilen; ++i) {
			if (animations[i].chart === chart) {
				animations[i] = animation;
				return;
			}
		}

		animations.push(animation);

		// If there are no animations queued, manually kickstart a digest, for lack of a better word
		if (animations.length === 1) {
			this.requestAnimationFrame();
		}
	},

	cancelAnimation: function(chart) {
		var index = helpers$1.findIndex(this.animations, function(animation) {
			return animation.chart === chart;
		});

		if (index !== -1) {
			this.animations.splice(index, 1);
			chart.animating = false;
		}
	},

	requestAnimationFrame: function() {
		var me = this;
		if (me.request === null) {
			// Skip animation frame requests until the active one is executed.
			// This can happen when processing mouse events, e.g. 'mousemove'
			// and 'mouseout' events will trigger multiple renders.
			me.request = helpers$1.requestAnimFrame.call(window, function() {
				me.request = null;
				me.startDigest();
			});
		}
	},

	/**
	 * @private
	 */
	startDigest: function() {
		var me = this;

		me.advance();

		// Do we have more stuff to animate?
		if (me.animations.length > 0) {
			me.requestAnimationFrame();
		}
	},

	/**
	 * @private
	 */
	advance: function() {
		var animations = this.animations;
		var animation, chart, numSteps, nextStep;
		var i = 0;

		// 1 animation per chart, so we are looping charts here
		while (i < animations.length) {
			animation = animations[i];
			chart = animation.chart;
			numSteps = animation.numSteps;

			// Make sure that currentStep starts at 1
			// https://github.com/chartjs/Chart.js/issues/6104
			nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
			animation.currentStep = Math.min(nextStep, numSteps);

			helpers$1.callback(animation.render, [chart, animation], chart);
			helpers$1.callback(animation.onAnimationProgress, [animation], chart);

			if (animation.currentStep >= numSteps) {
				helpers$1.callback(animation.onAnimationComplete, [animation], chart);
				chart.animating = false;
				animations.splice(i, 1);
			} else {
				++i;
			}
		}
	}
};

var resolve = helpers$1.options.resolve;

var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];

/**
 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
 */
function listenArrayEvents(array, listener) {
	if (array._chartjs) {
		array._chartjs.listeners.push(listener);
		return;
	}

	Object.defineProperty(array, '_chartjs', {
		configurable: true,
		enumerable: false,
		value: {
			listeners: [listener]
		}
	});

	arrayEvents.forEach(function(key) {
		var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
		var base = array[key];

		Object.defineProperty(array, key, {
			configurable: true,
			enumerable: false,
			value: function() {
				var args = Array.prototype.slice.call(arguments);
				var res = base.apply(this, args);

				helpers$1.each(array._chartjs.listeners, function(object) {
					if (typeof object[method] === 'function') {
						object[method].apply(object, args);
					}
				});

				return res;
			}
		});
	});
}

/**
 * Removes the given array event listener and cleanup extra attached properties (such as
 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
 */
function unlistenArrayEvents(array, listener) {
	var stub = array._chartjs;
	if (!stub) {
		return;
	}

	var listeners = stub.listeners;
	var index = listeners.indexOf(listener);
	if (index !== -1) {
		listeners.splice(index, 1);
	}

	if (listeners.length > 0) {
		return;
	}

	arrayEvents.forEach(function(key) {
		delete array[key];
	});

	delete array._chartjs;
}

// Base class for all dataset controllers (line, bar, etc)
var DatasetController = function(chart, datasetIndex) {
	this.initialize(chart, datasetIndex);
};

helpers$1.extend(DatasetController.prototype, {

	/**
	 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
	 * @type {Chart.core.element}
	 */
	datasetElementType: null,

	/**
	 * Element type used to generate a meta data (e.g. Chart.element.Point).
	 * @type {Chart.core.element}
	 */
	dataElementType: null,

	/**
	 * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderCapStyle',
		'borderColor',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'borderWidth'
	],

	/**
	 * Data element option keys to be resolved in _resolveDataElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'pointStyle'
	],

	initialize: function(chart, datasetIndex) {
		var me = this;
		me.chart = chart;
		me.index = datasetIndex;
		me.linkScales();
		me.addElements();
		me._type = me.getMeta().type;
	},

	updateIndex: function(datasetIndex) {
		this.index = datasetIndex;
	},

	linkScales: function() {
		var me = this;
		var meta = me.getMeta();
		var chart = me.chart;
		var scales = chart.scales;
		var dataset = me.getDataset();
		var scalesOpts = chart.options.scales;

		if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) {
			meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
		}
		if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) {
			meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
		}
	},

	getDataset: function() {
		return this.chart.data.datasets[this.index];
	},

	getMeta: function() {
		return this.chart.getDatasetMeta(this.index);
	},

	getScaleForId: function(scaleID) {
		return this.chart.scales[scaleID];
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.getMeta().yAxisID;
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.getMeta().xAxisID;
	},

	/**
	 * @private
	 */
	_getValueScale: function() {
		return this.getScaleForId(this._getValueScaleId());
	},

	/**
	 * @private
	 */
	_getIndexScale: function() {
		return this.getScaleForId(this._getIndexScaleId());
	},

	reset: function() {
		this._update(true);
	},

	/**
	 * @private
	 */
	destroy: function() {
		if (this._data) {
			unlistenArrayEvents(this._data, this);
		}
	},

	createMetaDataset: function() {
		var me = this;
		var type = me.datasetElementType;
		return type && new type({
			_chart: me.chart,
			_datasetIndex: me.index
		});
	},

	createMetaData: function(index) {
		var me = this;
		var type = me.dataElementType;
		return type && new type({
			_chart: me.chart,
			_datasetIndex: me.index,
			_index: index
		});
	},

	addElements: function() {
		var me = this;
		var meta = me.getMeta();
		var data = me.getDataset().data || [];
		var metaData = meta.data;
		var i, ilen;

		for (i = 0, ilen = data.length; i < ilen; ++i) {
			metaData[i] = metaData[i] || me.createMetaData(i);
		}

		meta.dataset = meta.dataset || me.createMetaDataset();
	},

	addElementAndReset: function(index) {
		var element = this.createMetaData(index);
		this.getMeta().data.splice(index, 0, element);
		this.updateElement(element, index, true);
	},

	buildOrUpdateElements: function() {
		var me = this;
		var dataset = me.getDataset();
		var data = dataset.data || (dataset.data = []);

		// In order to correctly handle data addition/deletion animation (an thus simulate
		// real-time charts), we need to monitor these data modifications and synchronize
		// the internal meta data accordingly.
		if (me._data !== data) {
			if (me._data) {
				// This case happens when the user replaced the data array instance.
				unlistenArrayEvents(me._data, me);
			}

			if (data && Object.isExtensible(data)) {
				listenArrayEvents(data, me);
			}
			me._data = data;
		}

		// Re-sync meta data in case the user replaced the data array or if we missed
		// any updates and so make sure that we handle number of datapoints changing.
		me.resyncElements();
	},

	/**
	 * Returns the merged user-supplied and default dataset-level options
	 * @private
	 */
	_configure: function() {
		var me = this;
		me._config = helpers$1.merge(Object.create(null), [
			me.chart.options.datasets[me._type],
			me.getDataset(),
		], {
			merger: function(key, target, source) {
				if (key !== '_meta' && key !== 'data') {
					helpers$1._merger(key, target, source);
				}
			}
		});
	},

	_update: function(reset) {
		var me = this;
		me._configure();
		me._cachedDataOpts = null;
		me.update(reset);
	},

	update: helpers$1.noop,

	transition: function(easingValue) {
		var meta = this.getMeta();
		var elements = meta.data || [];
		var ilen = elements.length;
		var i = 0;

		for (; i < ilen; ++i) {
			elements[i].transition(easingValue);
		}

		if (meta.dataset) {
			meta.dataset.transition(easingValue);
		}
	},

	draw: function() {
		var meta = this.getMeta();
		var elements = meta.data || [];
		var ilen = elements.length;
		var i = 0;

		if (meta.dataset) {
			meta.dataset.draw();
		}

		for (; i < ilen; ++i) {
			elements[i].draw();
		}
	},

	/**
	 * Returns a set of predefined style properties that should be used to represent the dataset
	 * or the data if the index is specified
	 * @param {number} index - data index
	 * @return {IStyleInterface} style object
	 */
	getStyle: function(index) {
		var me = this;
		var meta = me.getMeta();
		var dataset = meta.dataset;
		var style;

		me._configure();
		if (dataset && index === undefined) {
			style = me._resolveDatasetElementOptions(dataset || {});
		} else {
			index = index || 0;
			style = me._resolveDataElementOptions(meta.data[index] || {}, index);
		}

		if (style.fill === false || style.fill === null) {
			style.backgroundColor = style.borderColor;
		}

		return style;
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function(element, hover) {
		var me = this;
		var chart = me.chart;
		var datasetOpts = me._config;
		var custom = element.custom || {};
		var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
		var elementOptions = me._datasetElementOptions;
		var values = {};
		var i, ilen, key, readKey;

		// Scriptable options
		var context = {
			chart: chart,
			dataset: me.getDataset(),
			datasetIndex: me.index,
			hover: hover
		};

		for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
			key = elementOptions[i];
			readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
			values[key] = resolve([
				custom[readKey],
				datasetOpts[readKey],
				options[readKey]
			], context);
		}

		return values;
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function(element, index) {
		var me = this;
		var custom = element && element.custom;
		var cached = me._cachedDataOpts;
		if (cached && !custom) {
			return cached;
		}
		var chart = me.chart;
		var datasetOpts = me._config;
		var options = chart.options.elements[me.dataElementType.prototype._type] || {};
		var elementOptions = me._dataElementOptions;
		var values = {};

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: me.getDataset(),
			datasetIndex: me.index
		};

		// `resolve` sets cacheable to `false` if any option is indexed or scripted
		var info = {cacheable: !custom};

		var keys, i, ilen, key;

		custom = custom || {};

		if (helpers$1.isArray(elementOptions)) {
			for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
				key = elementOptions[i];
				values[key] = resolve([
					custom[key],
					datasetOpts[key],
					options[key]
				], context, index, info);
			}
		} else {
			keys = Object.keys(elementOptions);
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve([
					custom[key],
					datasetOpts[elementOptions[key]],
					datasetOpts[key],
					options[key]
				], context, index, info);
			}
		}

		if (info.cacheable) {
			me._cachedDataOpts = Object.freeze(values);
		}

		return values;
	},

	removeHoverStyle: function(element) {
		helpers$1.merge(element._model, element.$previousStyle || {});
		delete element.$previousStyle;
	},

	setHoverStyle: function(element) {
		var dataset = this.chart.data.datasets[element._datasetIndex];
		var index = element._index;
		var custom = element.custom || {};
		var model = element._model;
		var getHoverColor = helpers$1.getHoverColor;

		element.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth
		};

		model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
		model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
		model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
	},

	/**
	 * @private
	 */
	_removeDatasetHoverStyle: function() {
		var element = this.getMeta().dataset;

		if (element) {
			this.removeHoverStyle(element);
		}
	},

	/**
	 * @private
	 */
	_setDatasetHoverStyle: function() {
		var element = this.getMeta().dataset;
		var prev = {};
		var i, ilen, key, keys, hoverOptions, model;

		if (!element) {
			return;
		}

		model = element._model;
		hoverOptions = this._resolveDatasetElementOptions(element, true);

		keys = Object.keys(hoverOptions);
		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			prev[key] = model[key];
			model[key] = hoverOptions[key];
		}

		element.$previousStyle = prev;
	},

	/**
	 * @private
	 */
	resyncElements: function() {
		var me = this;
		var meta = me.getMeta();
		var data = me.getDataset().data;
		var numMeta = meta.data.length;
		var numData = data.length;

		if (numData < numMeta) {
			meta.data.splice(numData, numMeta - numData);
		} else if (numData > numMeta) {
			me.insertElements(numMeta, numData - numMeta);
		}
	},

	/**
	 * @private
	 */
	insertElements: function(start, count) {
		for (var i = 0; i < count; ++i) {
			this.addElementAndReset(start + i);
		}
	},

	/**
	 * @private
	 */
	onDataPush: function() {
		var count = arguments.length;
		this.insertElements(this.getDataset().data.length - count, count);
	},

	/**
	 * @private
	 */
	onDataPop: function() {
		this.getMeta().data.pop();
	},

	/**
	 * @private
	 */
	onDataShift: function() {
		this.getMeta().data.shift();
	},

	/**
	 * @private
	 */
	onDataSplice: function(start, count) {
		this.getMeta().data.splice(start, count);
		this.insertElements(start, arguments.length - 2);
	},

	/**
	 * @private
	 */
	onDataUnshift: function() {
		this.insertElements(0, arguments.length);
	}
});

DatasetController.extend = helpers$1.inherits;

var core_datasetController = DatasetController;

var TAU = Math.PI * 2;

core_defaults._set('global', {
	elements: {
		arc: {
			backgroundColor: core_defaults.global.defaultColor,
			borderColor: '#fff',
			borderWidth: 2,
			borderAlign: 'center'
		}
	}
});

function clipArc(ctx, arc) {
	var startAngle = arc.startAngle;
	var endAngle = arc.endAngle;
	var pixelMargin = arc.pixelMargin;
	var angleMargin = pixelMargin / arc.outerRadius;
	var x = arc.x;
	var y = arc.y;

	// Draw an inner border by cliping the arc and drawing a double-width border
	// Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
	ctx.beginPath();
	ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
	if (arc.innerRadius > pixelMargin) {
		angleMargin = pixelMargin / arc.innerRadius;
		ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
	} else {
		ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
	}
	ctx.closePath();
	ctx.clip();
}

function drawFullCircleBorders(ctx, vm, arc, inner) {
	var endAngle = arc.endAngle;
	var i;

	if (inner) {
		arc.endAngle = arc.startAngle + TAU;
		clipArc(ctx, arc);
		arc.endAngle = endAngle;
		if (arc.endAngle === arc.startAngle && arc.fullCircles) {
			arc.endAngle += TAU;
			arc.fullCircles--;
		}
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
	for (i = 0; i < arc.fullCircles; ++i) {
		ctx.stroke();
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
	for (i = 0; i < arc.fullCircles; ++i) {
		ctx.stroke();
	}
}

function drawBorder(ctx, vm, arc) {
	var inner = vm.borderAlign === 'inner';

	if (inner) {
		ctx.lineWidth = vm.borderWidth * 2;
		ctx.lineJoin = 'round';
	} else {
		ctx.lineWidth = vm.borderWidth;
		ctx.lineJoin = 'bevel';
	}

	if (arc.fullCircles) {
		drawFullCircleBorders(ctx, vm, arc, inner);
	}

	if (inner) {
		clipArc(ctx, arc);
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
	ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
	ctx.closePath();
	ctx.stroke();
}

var element_arc = core_element.extend({
	_type: 'arc',

	inLabelRange: function(mouseX) {
		var vm = this._view;

		if (vm) {
			return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
		}
		return false;
	},

	inRange: function(chartX, chartY) {
		var vm = this._view;

		if (vm) {
			var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {x: chartX, y: chartY});
			var angle = pointRelativePosition.angle;
			var distance = pointRelativePosition.distance;

			// Sanitise angle range
			var startAngle = vm.startAngle;
			var endAngle = vm.endAngle;
			while (endAngle < startAngle) {
				endAngle += TAU;
			}
			while (angle > endAngle) {
				angle -= TAU;
			}
			while (angle < startAngle) {
				angle += TAU;
			}

			// Check if within the range of the open/close angle
			var betweenAngles = (angle >= startAngle && angle <= endAngle);
			var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);

			return (betweenAngles && withinRadius);
		}
		return false;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var halfAngle = (vm.startAngle + vm.endAngle) / 2;
		var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
		return {
			x: vm.x + Math.cos(halfAngle) * halfRadius,
			y: vm.y + Math.sin(halfAngle) * halfRadius
		};
	},

	getArea: function() {
		var vm = this._view;
		return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
	},

	tooltipPosition: function() {
		var vm = this._view;
		var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
		var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;

		return {
			x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
			y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
		};
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var pixelMargin = (vm.borderAlign === 'inner') ? 0.33 : 0;
		var arc = {
			x: vm.x,
			y: vm.y,
			innerRadius: vm.innerRadius,
			outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
			pixelMargin: pixelMargin,
			startAngle: vm.startAngle,
			endAngle: vm.endAngle,
			fullCircles: Math.floor(vm.circumference / TAU)
		};
		var i;

		ctx.save();

		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;

		if (arc.fullCircles) {
			arc.endAngle = arc.startAngle + TAU;
			ctx.beginPath();
			ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
			ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
			ctx.closePath();
			for (i = 0; i < arc.fullCircles; ++i) {
				ctx.fill();
			}
			arc.endAngle = arc.startAngle + vm.circumference % TAU;
		}

		ctx.beginPath();
		ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
		ctx.closePath();
		ctx.fill();

		if (vm.borderWidth) {
			drawBorder(ctx, vm, arc);
		}

		ctx.restore();
	}
});

var valueOrDefault$1 = helpers$1.valueOrDefault;

var defaultColor = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		line: {
			tension: 0.4,
			backgroundColor: defaultColor,
			borderWidth: 3,
			borderColor: defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true, // do we fill in the area between the line and its base axis
		}
	}
});

var element_line = core_element.extend({
	_type: 'line',

	draw: function() {
		var me = this;
		var vm = me._view;
		var ctx = me._chart.ctx;
		var spanGaps = vm.spanGaps;
		var points = me._children.slice(); // clone array
		var globalDefaults = core_defaults.global;
		var globalOptionLineElements = globalDefaults.elements.line;
		var lastDrawnIndex = -1;
		var closePath = me._loop;
		var index, previous, currentVM;

		if (!points.length) {
			return;
		}

		if (me._loop) {
			for (index = 0; index < points.length; ++index) {
				previous = helpers$1.previousItem(points, index);
				// If the line has an open path, shift the point array
				if (!points[index]._view.skip && previous._view.skip) {
					points = points.slice(index).concat(points.slice(0, index));
					closePath = spanGaps;
					break;
				}
			}
			// If the line has a close path, add the first point again
			if (closePath) {
				points.push(points[0]);
			}
		}

		ctx.save();

		// Stroke Line Options
		ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;

		// IE 9 and 10 do not support line dash
		if (ctx.setLineDash) {
			ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
		}

		ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
		ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
		ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
		ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;

		// Stroke Line
		ctx.beginPath();

		// First point moves to it's starting position no matter what
		currentVM = points[0]._view;
		if (!currentVM.skip) {
			ctx.moveTo(currentVM.x, currentVM.y);
			lastDrawnIndex = 0;
		}

		for (index = 1; index < points.length; ++index) {
			currentVM = points[index]._view;
			previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];

			if (!currentVM.skip) {
				if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
					// There was a gap and this is the first point after the gap
					ctx.moveTo(currentVM.x, currentVM.y);
				} else {
					// Line to next point
					helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
				}
				lastDrawnIndex = index;
			}
		}

		if (closePath) {
			ctx.closePath();
		}

		ctx.stroke();
		ctx.restore();
	}
});

var valueOrDefault$2 = helpers$1.valueOrDefault;

var defaultColor$1 = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		point: {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor$1,
			borderColor: defaultColor$1,
			borderWidth: 1,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		}
	}
});

function xRange(mouseX) {
	var vm = this._view;
	return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
}

function yRange(mouseY) {
	var vm = this._view;
	return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
}

var element_point = core_element.extend({
	_type: 'point',

	inRange: function(mouseX, mouseY) {
		var vm = this._view;
		return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
	},

	inLabelRange: xRange,
	inXRange: xRange,
	inYRange: yRange,

	getCenterPoint: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	},

	getArea: function() {
		return Math.PI * Math.pow(this._view.radius, 2);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y,
			padding: vm.radius + vm.borderWidth
		};
	},

	draw: function(chartArea) {
		var vm = this._view;
		var ctx = this._chart.ctx;
		var pointStyle = vm.pointStyle;
		var rotation = vm.rotation;
		var radius = vm.radius;
		var x = vm.x;
		var y = vm.y;
		var globalDefaults = core_defaults.global;
		var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow

		if (vm.skip) {
			return;
		}

		// Clipping for Points.
		if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
			ctx.strokeStyle = vm.borderColor || defaultColor;
			ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
			ctx.fillStyle = vm.backgroundColor || defaultColor;
			helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
		}
	}
});

var defaultColor$2 = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		rectangle: {
			backgroundColor: defaultColor$2,
			borderColor: defaultColor$2,
			borderSkipped: 'bottom',
			borderWidth: 0
		}
	}
});

function isVertical(vm) {
	return vm && vm.width !== undefined;
}

/**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */
function getBarBounds(vm) {
	var x1, x2, y1, y2, half;

	if (isVertical(vm)) {
		half = vm.width / 2;
		x1 = vm.x - half;
		x2 = vm.x + half;
		y1 = Math.min(vm.y, vm.base);
		y2 = Math.max(vm.y, vm.base);
	} else {
		half = vm.height / 2;
		x1 = Math.min(vm.x, vm.base);
		x2 = Math.max(vm.x, vm.base);
		y1 = vm.y - half;
		y2 = vm.y + half;
	}

	return {
		left: x1,
		top: y1,
		right: x2,
		bottom: y2
	};
}

function swap(orig, v1, v2) {
	return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}

function parseBorderSkipped(vm) {
	var edge = vm.borderSkipped;
	var res = {};

	if (!edge) {
		return res;
	}

	if (vm.horizontal) {
		if (vm.base > vm.x) {
			edge = swap(edge, 'left', 'right');
		}
	} else if (vm.base < vm.y) {
		edge = swap(edge, 'bottom', 'top');
	}

	res[edge] = true;
	return res;
}

function parseBorderWidth(vm, maxW, maxH) {
	var value = vm.borderWidth;
	var skip = parseBorderSkipped(vm);
	var t, r, b, l;

	if (helpers$1.isObject(value)) {
		t = +value.top || 0;
		r = +value.right || 0;
		b = +value.bottom || 0;
		l = +value.left || 0;
	} else {
		t = r = b = l = +value || 0;
	}

	return {
		t: skip.top || (t < 0) ? 0 : t > maxH ? maxH : t,
		r: skip.right || (r < 0) ? 0 : r > maxW ? maxW : r,
		b: skip.bottom || (b < 0) ? 0 : b > maxH ? maxH : b,
		l: skip.left || (l < 0) ? 0 : l > maxW ? maxW : l
	};
}

function boundingRects(vm) {
	var bounds = getBarBounds(vm);
	var width = bounds.right - bounds.left;
	var height = bounds.bottom - bounds.top;
	var border = parseBorderWidth(vm, width / 2, height / 2);

	return {
		outer: {
			x: bounds.left,
			y: bounds.top,
			w: width,
			h: height
		},
		inner: {
			x: bounds.left + border.l,
			y: bounds.top + border.t,
			w: width - border.l - border.r,
			h: height - border.t - border.b
		}
	};
}

function inRange(vm, x, y) {
	var skipX = x === null;
	var skipY = y === null;
	var bounds = !vm || (skipX && skipY) ? false : getBarBounds(vm);

	return bounds
		&& (skipX || x >= bounds.left && x <= bounds.right)
		&& (skipY || y >= bounds.top && y <= bounds.bottom);
}

var element_rectangle = core_element.extend({
	_type: 'rectangle',

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var rects = boundingRects(vm);
		var outer = rects.outer;
		var inner = rects.inner;

		ctx.fillStyle = vm.backgroundColor;
		ctx.fillRect(outer.x, outer.y, outer.w, outer.h);

		if (outer.w === inner.w && outer.h === inner.h) {
			return;
		}

		ctx.save();
		ctx.beginPath();
		ctx.rect(outer.x, outer.y, outer.w, outer.h);
		ctx.clip();
		ctx.fillStyle = vm.borderColor;
		ctx.rect(inner.x, inner.y, inner.w, inner.h);
		ctx.fill('evenodd');
		ctx.restore();
	},

	height: function() {
		var vm = this._view;
		return vm.base - vm.y;
	},

	inRange: function(mouseX, mouseY) {
		return inRange(this._view, mouseX, mouseY);
	},

	inLabelRange: function(mouseX, mouseY) {
		var vm = this._view;
		return isVertical(vm)
			? inRange(vm, mouseX, null)
			: inRange(vm, null, mouseY);
	},

	inXRange: function(mouseX) {
		return inRange(this._view, mouseX, null);
	},

	inYRange: function(mouseY) {
		return inRange(this._view, null, mouseY);
	},

	getCenterPoint: function() {
		var vm = this._view;
		var x, y;
		if (isVertical(vm)) {
			x = vm.x;
			y = (vm.y + vm.base) / 2;
		} else {
			x = (vm.x + vm.base) / 2;
			y = vm.y;
		}

		return {x: x, y: y};
	},

	getArea: function() {
		var vm = this._view;

		return isVertical(vm)
			? vm.width * Math.abs(vm.y - vm.base)
			: vm.height * Math.abs(vm.x - vm.base);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	}
});

var elements = {};
var Arc = element_arc;
var Line = element_line;
var Point = element_point;
var Rectangle = element_rectangle;
elements.Arc = Arc;
elements.Line = Line;
elements.Point = Point;
elements.Rectangle = Rectangle;

var deprecated = helpers$1._deprecated;
var valueOrDefault$3 = helpers$1.valueOrDefault;

core_defaults._set('bar', {
	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			offset: true,
			gridLines: {
				offsetGridLines: true
			}
		}],

		yAxes: [{
			type: 'linear'
		}]
	}
});

core_defaults._set('global', {
	datasets: {
		bar: {
			categoryPercentage: 0.8,
			barPercentage: 0.9
		}
	}
});

/**
 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
 * @private
 */
function computeMinSampleSize(scale, pixels) {
	var min = scale._length;
	var prev, curr, i, ilen;

	for (i = 1, ilen = pixels.length; i < ilen; ++i) {
		min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
	}

	for (i = 0, ilen = scale.getTicks().length; i < ilen; ++i) {
		curr = scale.getPixelForTick(i);
		min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
		prev = curr;
	}

	return min;
}

/**
 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
 * mode currently always generates bars equally sized (until we introduce scriptable options?).
 * @private
 */
function computeFitCategoryTraits(index, ruler, options) {
	var thickness = options.barThickness;
	var count = ruler.stackCount;
	var curr = ruler.pixels[index];
	var min = helpers$1.isNullOrUndef(thickness)
		? computeMinSampleSize(ruler.scale, ruler.pixels)
		: -1;
	var size, ratio;

	if (helpers$1.isNullOrUndef(thickness)) {
		size = min * options.categoryPercentage;
		ratio = options.barPercentage;
	} else {
		// When bar thickness is enforced, category and bar percentages are ignored.
		// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
		// and deprecate barPercentage since this value is ignored when thickness is absolute.
		size = thickness * count;
		ratio = 1;
	}

	return {
		chunk: size / count,
		ratio: ratio,
		start: curr - (size / 2)
	};
}

/**
 * Computes an "optimal" category that globally arranges bars side by side (no gap when
 * percentage options are 1), based on the previous and following categories. This mode
 * generates bars with different widths when data are not evenly spaced.
 * @private
 */
function computeFlexCategoryTraits(index, ruler, options) {
	var pixels = ruler.pixels;
	var curr = pixels[index];
	var prev = index > 0 ? pixels[index - 1] : null;
	var next = index < pixels.length - 1 ? pixels[index + 1] : null;
	var percent = options.categoryPercentage;
	var start, size;

	if (prev === null) {
		// first data: its size is double based on the next point or,
		// if it's also the last data, we use the scale size.
		prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
	}

	if (next === null) {
		// last data: its size is also double based on the previous point.
		next = curr + curr - prev;
	}

	start = curr - (curr - Math.min(prev, next)) / 2 * percent;
	size = Math.abs(next - prev) / 2 * percent;

	return {
		chunk: size / ruler.stackCount,
		ratio: options.barPercentage,
		start: start
	};
}

var controller_bar = core_datasetController.extend({

	dataElementType: elements.Rectangle,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderSkipped',
		'borderWidth',
		'barPercentage',
		'barThickness',
		'categoryPercentage',
		'maxBarThickness',
		'minBarLength'
	],

	initialize: function() {
		var me = this;
		var meta, scaleOpts;

		core_datasetController.prototype.initialize.apply(me, arguments);

		meta = me.getMeta();
		meta.stack = me.getDataset().stack;
		meta.bar = true;

		scaleOpts = me._getIndexScale().options;
		deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
		deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
		deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
		deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
		deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
	},

	update: function(reset) {
		var me = this;
		var rects = me.getMeta().data;
		var i, ilen;

		me._ruler = me.getRuler();

		for (i = 0, ilen = rects.length; i < ilen; ++i) {
			me.updateElement(rects[i], i, reset);
		}
	},

	updateElement: function(rectangle, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var dataset = me.getDataset();
		var options = me._resolveDataElementOptions(rectangle, index);

		rectangle._xScale = me.getScaleForId(meta.xAxisID);
		rectangle._yScale = me.getScaleForId(meta.yAxisID);
		rectangle._datasetIndex = me.index;
		rectangle._index = index;
		rectangle._model = {
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderSkipped: options.borderSkipped,
			borderWidth: options.borderWidth,
			datasetLabel: dataset.label,
			label: me.chart.data.labels[index]
		};

		if (helpers$1.isArray(dataset.data[index])) {
			rectangle._model.borderSkipped = null;
		}

		me._updateElementGeometry(rectangle, index, reset, options);

		rectangle.pivot();
	},

	/**
	 * @private
	 */
	_updateElementGeometry: function(rectangle, index, reset, options) {
		var me = this;
		var model = rectangle._model;
		var vscale = me._getValueScale();
		var base = vscale.getBasePixel();
		var horizontal = vscale.isHorizontal();
		var ruler = me._ruler || me.getRuler();
		var vpixels = me.calculateBarValuePixels(me.index, index, options);
		var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);

		model.horizontal = horizontal;
		model.base = reset ? base : vpixels.base;
		model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
		model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
		model.height = horizontal ? ipixels.size : undefined;
		model.width = horizontal ? undefined : ipixels.size;
	},

	/**
	 * Returns the stacks based on groups and bar visibility.
	 * @param {number} [last] - The dataset index
	 * @returns {string[]} The list of stack IDs
	 * @private
	 */
	_getStacks: function(last) {
		var me = this;
		var scale = me._getIndexScale();
		var metasets = scale._getMatchingVisibleMetas(me._type);
		var stacked = scale.options.stacked;
		var ilen = metasets.length;
		var stacks = [];
		var i, meta;

		for (i = 0; i < ilen; ++i) {
			meta = metasets[i];
			// stacked   | meta.stack
			//           | found | not found | undefined
			// false     |   x   |     x     |     x
			// true      |       |     x     |
			// undefined |       |     x     |     x
			if (stacked === false || stacks.indexOf(meta.stack) === -1 ||
				(stacked === undefined && meta.stack === undefined)) {
				stacks.push(meta.stack);
			}
			if (meta.index === last) {
				break;
			}
		}

		return stacks;
	},

	/**
	 * Returns the effective number of stacks based on groups and bar visibility.
	 * @private
	 */
	getStackCount: function() {
		return this._getStacks().length;
	},

	/**
	 * Returns the stack index for the given dataset based on groups and bar visibility.
	 * @param {number} [datasetIndex] - The dataset index
	 * @param {string} [name] - The stack name to find
	 * @returns {number} The stack index
	 * @private
	 */
	getStackIndex: function(datasetIndex, name) {
		var stacks = this._getStacks(datasetIndex);
		var index = (name !== undefined)
			? stacks.indexOf(name)
			: -1; // indexOf returns -1 if element is not present

		return (index === -1)
			? stacks.length - 1
			: index;
	},

	/**
	 * @private
	 */
	getRuler: function() {
		var me = this;
		var scale = me._getIndexScale();
		var pixels = [];
		var i, ilen;

		for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
			pixels.push(scale.getPixelForValue(null, i, me.index));
		}

		return {
			pixels: pixels,
			start: scale._startPixel,
			end: scale._endPixel,
			stackCount: me.getStackCount(),
			scale: scale
		};
	},

	/**
	 * Note: pixel values are not clamped to the scale area.
	 * @private
	 */
	calculateBarValuePixels: function(datasetIndex, index, options) {
		var me = this;
		var chart = me.chart;
		var scale = me._getValueScale();
		var isHorizontal = scale.isHorizontal();
		var datasets = chart.data.datasets;
		var metasets = scale._getMatchingVisibleMetas(me._type);
		var value = scale._parseValue(datasets[datasetIndex].data[index]);
		var minBarLength = options.minBarLength;
		var stacked = scale.options.stacked;
		var stack = me.getMeta().stack;
		var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
		var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
		var ilen = metasets.length;
		var i, imeta, ivalue, base, head, size, stackLength;

		if (stacked || (stacked === undefined && stack !== undefined)) {
			for (i = 0; i < ilen; ++i) {
				imeta = metasets[i];

				if (imeta.index === datasetIndex) {
					break;
				}

				if (imeta.stack === stack) {
					stackLength = scale._parseValue(datasets[imeta.index].data[index]);
					ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;

					if ((value.min < 0 && ivalue < 0) || (value.max >= 0 && ivalue > 0)) {
						start += ivalue;
					}
				}
			}
		}

		base = scale.getPixelForValue(start);
		head = scale.getPixelForValue(start + length);
		size = head - base;

		if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
			size = minBarLength;
			if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) {
				head = base - minBarLength;
			} else {
				head = base + minBarLength;
			}
		}

		return {
			size: size,
			base: base,
			head: head,
			center: head + size / 2
		};
	},

	/**
	 * @private
	 */
	calculateBarIndexPixels: function(datasetIndex, index, ruler, options) {
		var me = this;
		var range = options.barThickness === 'flex'
			? computeFlexCategoryTraits(index, ruler, options)
			: computeFitCategoryTraits(index, ruler, options);

		var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
		var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
		var size = Math.min(
			valueOrDefault$3(options.maxBarThickness, Infinity),
			range.chunk * range.ratio);

		return {
			base: center - size / 2,
			head: center + size / 2,
			center: center,
			size: size
		};
	},

	draw: function() {
		var me = this;
		var chart = me.chart;
		var scale = me._getValueScale();
		var rects = me.getMeta().data;
		var dataset = me.getDataset();
		var ilen = rects.length;
		var i = 0;

		helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);

		for (; i < ilen; ++i) {
			var val = scale._parseValue(dataset.data[i]);
			if (!isNaN(val.min) && !isNaN(val.max)) {
				rects[i].draw();
			}
		}

		helpers$1.canvas.unclipArea(chart.ctx);
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function() {
		var me = this;
		var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
		var indexOpts = me._getIndexScale().options;
		var valueOpts = me._getValueScale().options;

		values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
		values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
		values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
		values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
		values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);

		return values;
	}

});

var valueOrDefault$4 = helpers$1.valueOrDefault;
var resolve$1 = helpers$1.options.resolve;

core_defaults._set('bubble', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			type: 'linear', // bubble should probably use a linear scale by default
			position: 'bottom',
			id: 'x-axis-0' // need an ID so datasets can reference the scale
		}],
		yAxes: [{
			type: 'linear',
			position: 'left',
			id: 'y-axis-0'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				// Title doesn't make sense for scatter since we format the data as a point
				return '';
			},
			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				var dataPoint = data.datasets[item.datasetIndex].data[item.index];
				return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
			}
		}
	}
});

var controller_bubble = core_datasetController.extend({
	/**
	 * @protected
	 */
	dataElementType: elements.Point,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
		'hoverRadius',
		'hitRadius',
		'pointStyle',
		'rotation'
	],

	/**
	 * @protected
	 */
	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var points = meta.data;

		// Update Points
		helpers$1.each(points, function(point, index) {
			me.updateElement(point, index, reset);
		});
	},

	/**
	 * @protected
	 */
	updateElement: function(point, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var custom = point.custom || {};
		var xScale = me.getScaleForId(meta.xAxisID);
		var yScale = me.getScaleForId(meta.yAxisID);
		var options = me._resolveDataElementOptions(point, index);
		var data = me.getDataset().data[index];
		var dsIndex = me.index;

		var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
		var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);

		point._xScale = xScale;
		point._yScale = yScale;
		point._options = options;
		point._datasetIndex = dsIndex;
		point._index = index;
		point._model = {
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			hitRadius: options.hitRadius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			radius: reset ? 0 : options.radius,
			skip: custom.skip || isNaN(x) || isNaN(y),
			x: x,
			y: y,
		};

		point.pivot();
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
		model.radius = options.radius + options.hoverRadius;
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function(point, index) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var custom = point.custom || {};
		var data = dataset.data[index] || {};
		var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		// In case values were cached (and thus frozen), we need to clone the values
		if (me._cachedDataOpts === values) {
			values = helpers$1.extend({}, values);
		}

		// Custom radius resolution
		values.radius = resolve$1([
			custom.radius,
			data.r,
			me._config.radius,
			chart.options.elements.point.radius
		], context, index);

		return values;
	}
});

var valueOrDefault$5 = helpers$1.valueOrDefault;

var PI$1 = Math.PI;
var DOUBLE_PI$1 = PI$1 * 2;
var HALF_PI$1 = PI$1 / 2;

core_defaults._set('doughnut', {
	animation: {
		// Boolean - Whether we animate the rotation of the Doughnut
		animateRotate: true,
		// Boolean - Whether we animate scaling the Doughnut from the centre
		animateScale: false
	},
	hover: {
		mode: 'single'
	},
	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');
		if (datasets.length) {
			for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
				if (labels[i]) {
					listItem.appendChild(document.createTextNode(labels[i]));
				}
			}
		}

		return list.outerHTML;
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var style = meta.controller.getStyle(i);

						return {
							text: label,
							fillStyle: style.backgroundColor,
							strokeStyle: style.borderColor,
							lineWidth: style.borderWidth,
							hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				// toggle visibility of index if exists
				if (meta.data[index]) {
					meta.data[index].hidden = !meta.data[index].hidden;
				}
			}

			chart.update();
		}
	},

	// The percentage of the chart that we cut out of the middle.
	cutoutPercentage: 50,

	// The rotation of the chart, where the first data arc begins.
	rotation: -HALF_PI$1,

	// The total circumference of the chart.
	circumference: DOUBLE_PI$1,

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(tooltipItem, data) {
				var dataLabel = data.labels[tooltipItem.index];
				var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

				if (helpers$1.isArray(dataLabel)) {
					// show value on first line of multiline label
					// need to clone because we are changing the value
					dataLabel = dataLabel.slice();
					dataLabel[0] += value;
				} else {
					dataLabel += value;
				}

				return dataLabel;
			}
		}
	}
});

var controller_doughnut = core_datasetController.extend({

	dataElementType: elements.Arc,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'borderAlign',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
	],

	// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
	getRingIndex: function(datasetIndex) {
		var ringIndex = 0;

		for (var j = 0; j < datasetIndex; ++j) {
			if (this.chart.isDatasetVisible(j)) {
				++ringIndex;
			}
		}

		return ringIndex;
	},

	update: function(reset) {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var ratioX = 1;
		var ratioY = 1;
		var offsetX = 0;
		var offsetY = 0;
		var meta = me.getMeta();
		var arcs = meta.data;
		var cutout = opts.cutoutPercentage / 100 || 0;
		var circumference = opts.circumference;
		var chartWeight = me._getRingWeight(me.index);
		var maxWidth, maxHeight, i, ilen;

		// If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
		if (circumference < DOUBLE_PI$1) {
			var startAngle = opts.rotation % DOUBLE_PI$1;
			startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
			var endAngle = startAngle + circumference;
			var startX = Math.cos(startAngle);
			var startY = Math.sin(startAngle);
			var endX = Math.cos(endAngle);
			var endY = Math.sin(endAngle);
			var contains0 = (startAngle <= 0 && endAngle >= 0) || endAngle >= DOUBLE_PI$1;
			var contains90 = (startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1) || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
			var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
			var contains270 = (startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1) || endAngle >= PI$1 + HALF_PI$1;
			var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
			var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
			var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
			var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
			ratioX = (maxX - minX) / 2;
			ratioY = (maxY - minY) / 2;
			offsetX = -(maxX + minX) / 2;
			offsetY = -(maxY + minY) / 2;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
		}

		chart.borderWidth = me.getMaxBorderWidth();
		maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
		maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
		chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
		chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
		chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
		chart.offsetX = offsetX * chart.outerRadius;
		chart.offsetY = offsetY * chart.outerRadius;

		meta.total = me.calculateTotal();

		me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
		me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			me.updateElement(arcs[i], i, reset);
		}
	},

	updateElement: function(arc, index, reset) {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var animationOpts = opts.animation;
		var centerX = (chartArea.left + chartArea.right) / 2;
		var centerY = (chartArea.top + chartArea.bottom) / 2;
		var startAngle = opts.rotation; // non reset case handled later
		var endAngle = opts.rotation; // non reset case handled later
		var dataset = me.getDataset();
		var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
		var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
		var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
		var options = arc._options || {};

		helpers$1.extend(arc, {
			// Utility
			_datasetIndex: me.index,
			_index: index,

			// Desired view properties
			_model: {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				borderAlign: options.borderAlign,
				x: centerX + chart.offsetX,
				y: centerY + chart.offsetY,
				startAngle: startAngle,
				endAngle: endAngle,
				circumference: circumference,
				outerRadius: outerRadius,
				innerRadius: innerRadius,
				label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
			}
		});

		var model = arc._model;

		// Set correct angles if not resetting
		if (!reset || !animationOpts.animateRotate) {
			if (index === 0) {
				model.startAngle = opts.rotation;
			} else {
				model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
			}

			model.endAngle = model.startAngle + model.circumference;
		}

		arc.pivot();
	},

	calculateTotal: function() {
		var dataset = this.getDataset();
		var meta = this.getMeta();
		var total = 0;
		var value;

		helpers$1.each(meta.data, function(element, index) {
			value = dataset.data[index];
			if (!isNaN(value) && !element.hidden) {
				total += Math.abs(value);
			}
		});

		/* if (total === 0) {
			total = NaN;
		}*/

		return total;
	},

	calculateCircumference: function(value) {
		var total = this.getMeta().total;
		if (total > 0 && !isNaN(value)) {
			return DOUBLE_PI$1 * (Math.abs(value) / total);
		}
		return 0;
	},

	// gets the max border or hover width to properly scale pie charts
	getMaxBorderWidth: function(arcs) {
		var me = this;
		var max = 0;
		var chart = me.chart;
		var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;

		if (!arcs) {
			// Find the outmost visible dataset
			for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					meta = chart.getDatasetMeta(i);
					arcs = meta.data;
					if (i !== me.index) {
						controller = meta.controller;
					}
					break;
				}
			}
		}

		if (!arcs) {
			return 0;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arc = arcs[i];
			if (controller) {
				controller._configure();
				options = controller._resolveDataElementOptions(arc, i);
			} else {
				options = arc._options;
			}
			if (options.borderAlign !== 'inner') {
				borderWidth = options.borderWidth;
				hoverWidth = options.hoverBorderWidth;

				max = borderWidth > max ? borderWidth : max;
				max = hoverWidth > max ? hoverWidth : max;
			}
		}
		return max;
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(arc) {
		var model = arc._model;
		var options = arc._options;
		var getHoverColor = helpers$1.getHoverColor;

		arc.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
		};

		model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
	},

	/**
	 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
	 * @private
	 */
	_getRingWeightOffset: function(datasetIndex) {
		var ringWeightOffset = 0;

		for (var i = 0; i < datasetIndex; ++i) {
			if (this.chart.isDatasetVisible(i)) {
				ringWeightOffset += this._getRingWeight(i);
			}
		}

		return ringWeightOffset;
	},

	/**
	 * @private
	 */
	_getRingWeight: function(dataSetIndex) {
		return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
	},

	/**
	 * Returns the sum of all visibile data set weights.  This value can be 0.
	 * @private
	 */
	_getVisibleDatasetWeightTotal: function() {
		return this._getRingWeightOffset(this.chart.data.datasets.length);
	}
});

core_defaults._set('horizontalBar', {
	hover: {
		mode: 'index',
		axis: 'y'
	},

	scales: {
		xAxes: [{
			type: 'linear',
			position: 'bottom'
		}],

		yAxes: [{
			type: 'category',
			position: 'left',
			offset: true,
			gridLines: {
				offsetGridLines: true
			}
		}]
	},

	elements: {
		rectangle: {
			borderSkipped: 'left'
		}
	},

	tooltips: {
		mode: 'index',
		axis: 'y'
	}
});

core_defaults._set('global', {
	datasets: {
		horizontalBar: {
			categoryPercentage: 0.8,
			barPercentage: 0.9
		}
	}
});

var controller_horizontalBar = controller_bar.extend({
	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.getMeta().xAxisID;
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.getMeta().yAxisID;
	}
});

var valueOrDefault$6 = helpers$1.valueOrDefault;
var resolve$2 = helpers$1.options.resolve;
var isPointInArea = helpers$1.canvas._isPointInArea;

core_defaults._set('line', {
	showLines: true,
	spanGaps: false,

	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			id: 'x-axis-0'
		}],
		yAxes: [{
			type: 'linear',
			id: 'y-axis-0'
		}]
	}
});

function scaleClip(scale, halfBorderWidth) {
	var tickOpts = scale && scale.options.ticks || {};
	var reverse = tickOpts.reverse;
	var min = tickOpts.min === undefined ? halfBorderWidth : 0;
	var max = tickOpts.max === undefined ? halfBorderWidth : 0;
	return {
		start: reverse ? max : min,
		end: reverse ? min : max
	};
}

function defaultClip(xScale, yScale, borderWidth) {
	var halfBorderWidth = borderWidth / 2;
	var x = scaleClip(xScale, halfBorderWidth);
	var y = scaleClip(yScale, halfBorderWidth);

	return {
		top: y.end,
		right: x.end,
		bottom: y.start,
		left: x.start
	};
}

function toClip(value) {
	var t, r, b, l;

	if (helpers$1.isObject(value)) {
		t = value.top;
		r = value.right;
		b = value.bottom;
		l = value.left;
	} else {
		t = r = b = l = value;
	}

	return {
		top: t,
		right: r,
		bottom: b,
		left: l
	};
}


var controller_line = core_datasetController.extend({

	datasetElementType: elements.Line,

	dataElementType: elements.Point,

	/**
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderCapStyle',
		'borderColor',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'borderWidth',
		'cubicInterpolationMode',
		'fill'
	],

	/**
	 * @private
	 */
	_dataElementOptions: {
		backgroundColor: 'pointBackgroundColor',
		borderColor: 'pointBorderColor',
		borderWidth: 'pointBorderWidth',
		hitRadius: 'pointHitRadius',
		hoverBackgroundColor: 'pointHoverBackgroundColor',
		hoverBorderColor: 'pointHoverBorderColor',
		hoverBorderWidth: 'pointHoverBorderWidth',
		hoverRadius: 'pointHoverRadius',
		pointStyle: 'pointStyle',
		radius: 'pointRadius',
		rotation: 'pointRotation'
	},

	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var line = meta.dataset;
		var points = meta.data || [];
		var options = me.chart.options;
		var config = me._config;
		var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
		var i, ilen;

		me._xScale = me.getScaleForId(meta.xAxisID);
		me._yScale = me.getScaleForId(meta.yAxisID);

		// Update Line
		if (showLine) {
			// Compatibility: If the properties are defined with only the old name, use those values
			if (config.tension !== undefined && config.lineTension === undefined) {
				config.lineTension = config.tension;
			}

			// Utility
			line._scale = me._yScale;
			line._datasetIndex = me.index;
			// Data
			line._children = points;
			// Model
			line._model = me._resolveDatasetElementOptions(line);

			line.pivot();
		}

		// Update Points
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			me.updateElement(points[i], i, reset);
		}

		if (showLine && line._model.tension !== 0) {
			me.updateBezierControlPoints();
		}

		// Now pivot the point for animation
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			points[i].pivot();
		}
	},

	updateElement: function(point, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var custom = point.custom || {};
		var dataset = me.getDataset();
		var datasetIndex = me.index;
		var value = dataset.data[index];
		var xScale = me._xScale;
		var yScale = me._yScale;
		var lineModel = meta.dataset._model;
		var x, y;

		var options = me._resolveDataElementOptions(point, index);

		x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
		y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);

		// Utility
		point._xScale = xScale;
		point._yScale = yScale;
		point._options = options;
		point._datasetIndex = datasetIndex;
		point._index = index;

		// Desired view properties
		point._model = {
			x: x,
			y: y,
			skip: custom.skip || isNaN(x) || isNaN(y),
			// Appearance
			radius: options.radius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
			steppedLine: lineModel ? lineModel.steppedLine : false,
			// Tooltip
			hitRadius: options.hitRadius
		};
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function(element) {
		var me = this;
		var config = me._config;
		var custom = element.custom || {};
		var options = me.chart.options;
		var lineOptions = options.elements.line;
		var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);

		// The default behavior of lines is to break at null values, according
		// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
		// This option gives lines the ability to span gaps
		values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
		values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
		values.steppedLine = resolve$2([custom.steppedLine, config.steppedLine, lineOptions.stepped]);
		values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));

		return values;
	},

	calculatePointY: function(value, index, datasetIndex) {
		var me = this;
		var chart = me.chart;
		var yScale = me._yScale;
		var sumPos = 0;
		var sumNeg = 0;
		var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;

		if (yScale.options.stacked) {
			rightValue = +yScale.getRightValue(value);
			metasets = chart._getSortedVisibleDatasetMetas();
			ilen = metasets.length;

			for (i = 0; i < ilen; ++i) {
				dsMeta = metasets[i];
				if (dsMeta.index === datasetIndex) {
					break;
				}

				ds = chart.data.datasets[dsMeta.index];
				if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
					stackedRightValue = +yScale.getRightValue(ds.data[index]);
					if (stackedRightValue < 0) {
						sumNeg += stackedRightValue || 0;
					} else {
						sumPos += stackedRightValue || 0;
					}
				}
			}

			if (rightValue < 0) {
				return yScale.getPixelForValue(sumNeg + rightValue);
			}
			return yScale.getPixelForValue(sumPos + rightValue);
		}
		return yScale.getPixelForValue(value);
	},

	updateBezierControlPoints: function() {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var lineModel = meta.dataset._model;
		var area = chart.chartArea;
		var points = meta.data || [];
		var i, ilen, model, controlPoints;

		// Only consider points that are drawn in case the spanGaps option is used
		if (lineModel.spanGaps) {
			points = points.filter(function(pt) {
				return !pt._model.skip;
			});
		}

		function capControlPoint(pt, min, max) {
			return Math.max(Math.min(pt, max), min);
		}

		if (lineModel.cubicInterpolationMode === 'monotone') {
			helpers$1.splineCurveMonotone(points);
		} else {
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				controlPoints = helpers$1.splineCurve(
					helpers$1.previousItem(points, i)._model,
					model,
					helpers$1.nextItem(points, i)._model,
					lineModel.tension
				);
				model.controlPointPreviousX = controlPoints.previous.x;
				model.controlPointPreviousY = controlPoints.previous.y;
				model.controlPointNextX = controlPoints.next.x;
				model.controlPointNextY = controlPoints.next.y;
			}
		}

		if (chart.options.elements.line.capBezierPoints) {
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				if (isPointInArea(model, area)) {
					if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
						model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
						model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
					}
					if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
						model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
						model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
					}
				}
			}
		}
	},

	draw: function() {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var points = meta.data || [];
		var area = chart.chartArea;
		var canvas = chart.canvas;
		var i = 0;
		var ilen = points.length;
		var clip;

		if (me._showLine) {
			clip = meta.dataset._model.clip;

			helpers$1.canvas.clipArea(chart.ctx, {
				left: clip.left === false ? 0 : area.left - clip.left,
				right: clip.right === false ? canvas.width : area.right + clip.right,
				top: clip.top === false ? 0 : area.top - clip.top,
				bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
			});

			meta.dataset.draw();

			helpers$1.canvas.unclipArea(chart.ctx);
		}

		// Draw the points
		for (; i < ilen; ++i) {
			points[i].draw(area);
		}
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
		model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
	},
});

var resolve$3 = helpers$1.options.resolve;

core_defaults._set('polarArea', {
	scale: {
		type: 'radialLinear',
		angleLines: {
			display: false
		},
		gridLines: {
			circular: true
		},
		pointLabels: {
			display: false
		},
		ticks: {
			beginAtZero: true
		}
	},

	// Boolean - Whether to animate the rotation of the chart
	animation: {
		animateRotate: true,
		animateScale: true
	},

	startAngle: -0.5 * Math.PI,
	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');
		if (datasets.length) {
			for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
				if (labels[i]) {
					listItem.appendChild(document.createTextNode(labels[i]));
				}
			}
		}

		return list.outerHTML;
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var style = meta.controller.getStyle(i);

						return {
							text: label,
							fillStyle: style.backgroundColor,
							strokeStyle: style.borderColor,
							lineWidth: style.borderWidth,
							hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				meta.data[index].hidden = !meta.data[index].hidden;
			}

			chart.update();
		}
	},

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(item, data) {
				return data.labels[item.index] + ': ' + item.yLabel;
			}
		}
	}
});

var controller_polarArea = core_datasetController.extend({

	dataElementType: elements.Arc,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'borderAlign',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
	],

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.chart.scale.id;
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.chart.scale.id;
	},

	update: function(reset) {
		var me = this;
		var dataset = me.getDataset();
		var meta = me.getMeta();
		var start = me.chart.options.startAngle || 0;
		var starts = me._starts = [];
		var angles = me._angles = [];
		var arcs = meta.data;
		var i, ilen, angle;

		me._updateRadius();

		meta.count = me.countVisibleElements();

		for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
			starts[i] = start;
			angle = me._computeAngle(i);
			angles[i] = angle;
			start += angle;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
			me.updateElement(arcs[i], i, reset);
		}
	},

	/**
	 * @private
	 */
	_updateRadius: function() {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);

		chart.outerRadius = Math.max(minSize / 2, 0);
		chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
		chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();

		me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
		me.innerRadius = me.outerRadius - chart.radiusLength;
	},

	updateElement: function(arc, index, reset) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var opts = chart.options;
		var animationOpts = opts.animation;
		var scale = chart.scale;
		var labels = chart.data.labels;

		var centerX = scale.xCenter;
		var centerY = scale.yCenter;

		// var negHalfPI = -0.5 * Math.PI;
		var datasetStartAngle = opts.startAngle;
		var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
		var startAngle = me._starts[index];
		var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);

		var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
		var options = arc._options || {};

		helpers$1.extend(arc, {
			// Utility
			_datasetIndex: me.index,
			_index: index,
			_scale: scale,

			// Desired view properties
			_model: {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				borderAlign: options.borderAlign,
				x: centerX,
				y: centerY,
				innerRadius: 0,
				outerRadius: reset ? resetRadius : distance,
				startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
				endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
				label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
			}
		});

		arc.pivot();
	},

	countVisibleElements: function() {
		var dataset = this.getDataset();
		var meta = this.getMeta();
		var count = 0;

		helpers$1.each(meta.data, function(element, index) {
			if (!isNaN(dataset.data[index]) && !element.hidden) {
				count++;
			}
		});

		return count;
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(arc) {
		var model = arc._model;
		var options = arc._options;
		var getHoverColor = helpers$1.getHoverColor;
		var valueOrDefault = helpers$1.valueOrDefault;

		arc.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
		};

		model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
	},

	/**
	 * @private
	 */
	_computeAngle: function(index) {
		var me = this;
		var count = this.getMeta().count;
		var dataset = me.getDataset();
		var meta = me.getMeta();

		if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
			return 0;
		}

		// Scriptable options
		var context = {
			chart: me.chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		return resolve$3([
			me.chart.options.elements.arc.angle,
			(2 * Math.PI) / count
		], context, index);
	}
});

core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
core_defaults._set('pie', {
	cutoutPercentage: 0
});

// Pie charts are Doughnut chart with different defaults
var controller_pie = controller_doughnut;

var valueOrDefault$7 = helpers$1.valueOrDefault;

core_defaults._set('radar', {
	spanGaps: false,
	scale: {
		type: 'radialLinear'
	},
	elements: {
		line: {
			fill: 'start',
			tension: 0 // no bezier in radar
		}
	}
});

var controller_radar = core_datasetController.extend({
	datasetElementType: elements.Line,

	dataElementType: elements.Point,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderWidth',
		'borderColor',
		'borderCapStyle',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'fill'
	],

	/**
	 * @private
	 */
	_dataElementOptions: {
		backgroundColor: 'pointBackgroundColor',
		borderColor: 'pointBorderColor',
		borderWidth: 'pointBorderWidth',
		hitRadius: 'pointHitRadius',
		hoverBackgroundColor: 'pointHoverBackgroundColor',
		hoverBorderColor: 'pointHoverBorderColor',
		hoverBorderWidth: 'pointHoverBorderWidth',
		hoverRadius: 'pointHoverRadius',
		pointStyle: 'pointStyle',
		radius: 'pointRadius',
		rotation: 'pointRotation'
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.chart.scale.id;
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.chart.scale.id;
	},

	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var line = meta.dataset;
		var points = meta.data || [];
		var scale = me.chart.scale;
		var config = me._config;
		var i, ilen;

		// Compatibility: If the properties are defined with only the old name, use those values
		if (config.tension !== undefined && config.lineTension === undefined) {
			config.lineTension = config.tension;
		}

		// Utility
		line._scale = scale;
		line._datasetIndex = me.index;
		// Data
		line._children = points;
		line._loop = true;
		// Model
		line._model = me._resolveDatasetElementOptions(line);

		line.pivot();

		// Update Points
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			me.updateElement(points[i], i, reset);
		}

		// Update bezier control points
		me.updateBezierControlPoints();

		// Now pivot the point for animation
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			points[i].pivot();
		}
	},

	updateElement: function(point, index, reset) {
		var me = this;
		var custom = point.custom || {};
		var dataset = me.getDataset();
		var scale = me.chart.scale;
		var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
		var options = me._resolveDataElementOptions(point, index);
		var lineModel = me.getMeta().dataset._model;
		var x = reset ? scale.xCenter : pointPosition.x;
		var y = reset ? scale.yCenter : pointPosition.y;

		// Utility
		point._scale = scale;
		point._options = options;
		point._datasetIndex = me.index;
		point._index = index;

		// Desired view properties
		point._model = {
			x: x, // value not used in dataset scale, but we want a consistent API between scales
			y: y,
			skip: custom.skip || isNaN(x) || isNaN(y),
			// Appearance
			radius: options.radius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),

			// Tooltip
			hitRadius: options.hitRadius
		};
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function() {
		var me = this;
		var config = me._config;
		var options = me.chart.options;
		var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);

		values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
		values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);

		return values;
	},

	updateBezierControlPoints: function() {
		var me = this;
		var meta = me.getMeta();
		var area = me.chart.chartArea;
		var points = meta.data || [];
		var i, ilen, model, controlPoints;

		// Only consider points that are drawn in case the spanGaps option is used
		if (meta.dataset._model.spanGaps) {
			points = points.filter(function(pt) {
				return !pt._model.skip;
			});
		}

		function capControlPoint(pt, min, max) {
			return Math.max(Math.min(pt, max), min);
		}

		for (i = 0, ilen = points.length; i < ilen; ++i) {
			model = points[i]._model;
			controlPoints = helpers$1.splineCurve(
				helpers$1.previousItem(points, i, true)._model,
				model,
				helpers$1.nextItem(points, i, true)._model,
				model.tension
			);

			// Prevent the bezier going outside of the bounds of the graph
			model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
			model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
			model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
			model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
		}
	},

	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
		model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
	}
});

core_defaults._set('scatter', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			id: 'x-axis-1',    // need an ID so datasets can reference the scale
			type: 'linear',    // scatter should not use a category axis
			position: 'bottom'
		}],
		yAxes: [{
			id: 'y-axis-1',
			type: 'linear',
			position: 'left'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				return '';     // doesn't make sense for scatter since data are formatted as a point
			},
			label: function(item) {
				return '(' + item.xLabel + ', ' + item.yLabel + ')';
			}
		}
	}
});

core_defaults._set('global', {
	datasets: {
		scatter: {
			showLine: false
		}
	}
});

// Scatter charts use line controllers
var controller_scatter = controller_line;

// NOTE export a map in which the key represents the controller type, not
// the class, and so must be CamelCase in order to be correctly retrieved
// by the controller in core.controller.js (`controllers[meta.type]`).

var controllers = {
	bar: controller_bar,
	bubble: controller_bubble,
	doughnut: controller_doughnut,
	horizontalBar: controller_horizontalBar,
	line: controller_line,
	polarArea: controller_polarArea,
	pie: controller_pie,
	radar: controller_radar,
	scatter: controller_scatter
};

/**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {object} the event position
 */
function getRelativePosition(e, chart) {
	if (e.native) {
		return {
			x: e.x,
			y: e.y
		};
	}

	return helpers$1.getRelativePosition(e, chart);
}

/**
 * Helper function to traverse all of the visible elements in the chart
 * @param {Chart} chart - the chart
 * @param {function} handler - the callback to execute for each visible item
 */
function parseVisibleItems(chart, handler) {
	var metasets = chart._getSortedVisibleDatasetMetas();
	var metadata, i, j, ilen, jlen, element;

	for (i = 0, ilen = metasets.length; i < ilen; ++i) {
		metadata = metasets[i].data;
		for (j = 0, jlen = metadata.length; j < jlen; ++j) {
			element = metadata[j];
			if (!element._view.skip) {
				handler(element);
			}
		}
	}
}

/**
 * Helper function to get the items that intersect the event position
 * @param {ChartElement[]} items - elements to filter
 * @param {object} position - the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */
function getIntersectItems(chart, position) {
	var elements = [];

	parseVisibleItems(chart, function(element) {
		if (element.inRange(position.x, position.y)) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param {Chart} chart - the chart to look at elements from
 * @param {object} position - the point to be nearest to
 * @param {boolean} intersect - if true, only consider items that intersect the position
 * @param {function} distanceMetric - function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */
function getNearestItems(chart, position, intersect, distanceMetric) {
	var minDistance = Number.POSITIVE_INFINITY;
	var nearestItems = [];

	parseVisibleItems(chart, function(element) {
		if (intersect && !element.inRange(position.x, position.y)) {
			return;
		}

		var center = element.getCenterPoint();
		var distance = distanceMetric(position, center);
		if (distance < minDistance) {
			nearestItems = [element];
			minDistance = distance;
		} else if (distance === minDistance) {
			// Can have multiple items at the same distance in which case we sort by size
			nearestItems.push(element);
		}
	});

	return nearestItems;
}

/**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {string} axis - the axis mode. x|y|xy
 */
function getDistanceMetricForAxis(axis) {
	var useX = axis.indexOf('x') !== -1;
	var useY = axis.indexOf('y') !== -1;

	return function(pt1, pt2) {
		var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
		var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
		return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
	};
}

function indexMode(chart, e, options) {
	var position = getRelativePosition(e, chart);
	// Default axis for index mode is 'x' to match old behaviour
	options.axis = options.axis || 'x';
	var distanceMetric = getDistanceMetricForAxis(options.axis);
	var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	var elements = [];

	if (!items.length) {
		return [];
	}

	chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
		var element = meta.data[items[0]._index];

		// don't count items that are skipped (null data)
		if (element && !element._view.skip) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * @interface IInteractionOptions
 */
/**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */

/**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */
var core_interaction = {
	// Helper function for different modes
	modes: {
		single: function(chart, e) {
			var position = getRelativePosition(e, chart);
			var elements = [];

			parseVisibleItems(chart, function(element) {
				if (element.inRange(position.x, position.y)) {
					elements.push(element);
					return elements;
				}
			});

			return elements.slice(0, 1);
		},

		/**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */
		label: indexMode,

		/**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		index: indexMode,

		/**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		dataset: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);

			if (items.length > 0) {
				items = chart.getDatasetMeta(items[0]._datasetIndex).data;
			}

			return items;
		},

		/**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */
		'x-axis': function(chart, e) {
			return indexMode(chart, e, {intersect: false});
		},

		/**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		point: function(chart, e) {
			var position = getRelativePosition(e, chart);
			return getIntersectItems(chart, position);
		},

		/**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		nearest: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			return getNearestItems(chart, position, options.intersect, distanceMetric);
		},

		/**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		x: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inXRange(position.x)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		},

		/**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		y: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inYRange(position.y)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		}
	}
};

var extend = helpers$1.extend;

function filterByPosition(array, position) {
	return helpers$1.where(array, function(v) {
		return v.pos === position;
	});
}

function sortByWeight(array, reverse) {
	return array.sort(function(a, b) {
		var v0 = reverse ? b : a;
		var v1 = reverse ? a : b;
		return v0.weight === v1.weight ?
			v0.index - v1.index :
			v0.weight - v1.weight;
	});
}

function wrapBoxes(boxes) {
	var layoutBoxes = [];
	var i, ilen, box;

	for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
		box = boxes[i];
		layoutBoxes.push({
			index: i,
			box: box,
			pos: box.position,
			horizontal: box.isHorizontal(),
			weight: box.weight
		});
	}
	return layoutBoxes;
}

function setLayoutDims(layouts, params) {
	var i, ilen, layout;
	for (i = 0, ilen = layouts.length; i < ilen; ++i) {
		layout = layouts[i];
		// store width used instead of chartArea.w in fitBoxes
		layout.width = layout.horizontal
			? layout.box.fullWidth && params.availableWidth
			: params.vBoxMaxWidth;
		// store height used instead of chartArea.h in fitBoxes
		layout.height = layout.horizontal && params.hBoxMaxHeight;
	}
}

function buildLayoutBoxes(boxes) {
	var layoutBoxes = wrapBoxes(boxes);
	var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
	var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
	var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
	var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));

	return {
		leftAndTop: left.concat(top),
		rightAndBottom: right.concat(bottom),
		chartArea: filterByPosition(layoutBoxes, 'chartArea'),
		vertical: left.concat(right),
		horizontal: top.concat(bottom)
	};
}

function getCombinedMax(maxPadding, chartArea, a, b) {
	return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}

function updateDims(chartArea, params, layout) {
	var box = layout.box;
	var maxPadding = chartArea.maxPadding;
	var newWidth, newHeight;

	if (layout.size) {
		// this layout was already counted for, lets first reduce old size
		chartArea[layout.pos] -= layout.size;
	}
	layout.size = layout.horizontal ? box.height : box.width;
	chartArea[layout.pos] += layout.size;

	if (box.getPadding) {
		var boxPadding = box.getPadding();
		maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
		maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
		maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
		maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
	}

	newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
	newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');

	if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
		chartArea.w = newWidth;
		chartArea.h = newHeight;

		// return true if chart area changed in layout's direction
		var sizes = layout.horizontal ? [newWidth, chartArea.w] : [newHeight, chartArea.h];
		return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
	}
}

function handleMaxPadding(chartArea) {
	var maxPadding = chartArea.maxPadding;

	function updatePos(pos) {
		var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
		chartArea[pos] += change;
		return change;
	}
	chartArea.y += updatePos('top');
	chartArea.x += updatePos('left');
	updatePos('right');
	updatePos('bottom');
}

function getMargins(horizontal, chartArea) {
	var maxPadding = chartArea.maxPadding;

	function marginForPositions(positions) {
		var margin = {left: 0, top: 0, right: 0, bottom: 0};
		positions.forEach(function(pos) {
			margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
		});
		return margin;
	}

	return horizontal
		? marginForPositions(['left', 'right'])
		: marginForPositions(['top', 'bottom']);
}

function fitBoxes(boxes, chartArea, params) {
	var refitBoxes = [];
	var i, ilen, layout, box, refit, changed;

	for (i = 0, ilen = boxes.length; i < ilen; ++i) {
		layout = boxes[i];
		box = layout.box;

		box.update(
			layout.width || chartArea.w,
			layout.height || chartArea.h,
			getMargins(layout.horizontal, chartArea)
		);
		if (updateDims(chartArea, params, layout)) {
			changed = true;
			if (refitBoxes.length) {
				// Dimensions changed and there were non full width boxes before this
				// -> we have to refit those
				refit = true;
			}
		}
		if (!box.fullWidth) { // fullWidth boxes don't need to be re-fitted in any case
			refitBoxes.push(layout);
		}
	}

	return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
}

function placeBoxes(boxes, chartArea, params) {
	var userPadding = params.padding;
	var x = chartArea.x;
	var y = chartArea.y;
	var i, ilen, layout, box;

	for (i = 0, ilen = boxes.length; i < ilen; ++i) {
		layout = boxes[i];
		box = layout.box;
		if (layout.horizontal) {
			box.left = box.fullWidth ? userPadding.left : chartArea.left;
			box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
			box.top = y;
			box.bottom = y + box.height;
			box.width = box.right - box.left;
			y = box.bottom;
		} else {
			box.left = x;
			box.right = x + box.width;
			box.top = chartArea.top;
			box.bottom = chartArea.top + chartArea.h;
			box.height = box.bottom - box.top;
			x = box.right;
		}
	}

	chartArea.x = x;
	chartArea.y = y;
}

core_defaults._set('global', {
	layout: {
		padding: {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		}
	}
});

/**
 * @interface ILayoutItem
 * @prop {string} position - The position of the item in the chart layout. Possible values are
 * 'left', 'top', 'right', 'bottom', and 'chartArea'
 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
 * @prop {function} update - Takes two parameters: width and height. Returns size of item
 * @prop {function} getPadding -  Returns an object with padding on the edges
 * @prop {number} width - Width of item. Must be valid after update()
 * @prop {number} height - Height of item. Must be valid after update()
 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
 */

// The layout service is very self explanatory.  It's responsible for the layout within a chart.
// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
// It is this service's responsibility of carrying out that layout.
var core_layouts = {
	defaults: {},

	/**
	 * Register a box to a chart.
	 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
	 * @param {Chart} chart - the chart to use
	 * @param {ILayoutItem} item - the item to add to be layed out
	 */
	addBox: function(chart, item) {
		if (!chart.boxes) {
			chart.boxes = [];
		}

		// initialize item with default values
		item.fullWidth = item.fullWidth || false;
		item.position = item.position || 'top';
		item.weight = item.weight || 0;
		item._layers = item._layers || function() {
			return [{
				z: 0,
				draw: function() {
					item.draw.apply(item, arguments);
				}
			}];
		};

		chart.boxes.push(item);
	},

	/**
	 * Remove a layoutItem from a chart
	 * @param {Chart} chart - the chart to remove the box from
	 * @param {ILayoutItem} layoutItem - the item to remove from the layout
	 */
	removeBox: function(chart, layoutItem) {
		var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
		if (index !== -1) {
			chart.boxes.splice(index, 1);
		}
	},

	/**
	 * Sets (or updates) options on the given `item`.
	 * @param {Chart} chart - the chart in which the item lives (or will be added to)
	 * @param {ILayoutItem} item - the item to configure with the given options
	 * @param {object} options - the new item options.
	 */
	configure: function(chart, item, options) {
		var props = ['fullWidth', 'position', 'weight'];
		var ilen = props.length;
		var i = 0;
		var prop;

		for (; i < ilen; ++i) {
			prop = props[i];
			if (options.hasOwnProperty(prop)) {
				item[prop] = options[prop];
			}
		}
	},

	/**
	 * Fits boxes of the given chart into the given size by having each box measure itself
	 * then running a fitting algorithm
	 * @param {Chart} chart - the chart
	 * @param {number} width - the width to fit into
	 * @param {number} height - the height to fit into
	 */
	update: function(chart, width, height) {
		if (!chart) {
			return;
		}

		var layoutOptions = chart.options.layout || {};
		var padding = helpers$1.options.toPadding(layoutOptions.padding);

		var availableWidth = width - padding.width;
		var availableHeight = height - padding.height;
		var boxes = buildLayoutBoxes(chart.boxes);
		var verticalBoxes = boxes.vertical;
		var horizontalBoxes = boxes.horizontal;

		// Essentially we now have any number of boxes on each of the 4 sides.
		// Our canvas looks like the following.
		// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
		// B1 is the bottom axis
		// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
		// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
		// an error will be thrown.
		//
		// |----------------------------------------------------|
		// |                  T1 (Full Width)                   |
		// |----------------------------------------------------|
		// |    |    |                 T2                  |    |
		// |    |----|-------------------------------------|----|
		// |    |    | C1 |                           | C2 |    |
		// |    |    |----|                           |----|    |
		// |    |    |                                     |    |
		// | L1 | L2 |           ChartArea (C0)            | R1 |
		// |    |    |                                     |    |
		// |    |    |----|                           |----|    |
		// |    |    | C3 |                           | C4 |    |
		// |    |----|-------------------------------------|----|
		// |    |    |                 B1                  |    |
		// |----------------------------------------------------|
		// |                  B2 (Full Width)                   |
		// |----------------------------------------------------|
		//

		var params = Object.freeze({
			outerWidth: width,
			outerHeight: height,
			padding: padding,
			availableWidth: availableWidth,
			vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
			hBoxMaxHeight: availableHeight / 2
		});
		var chartArea = extend({
			maxPadding: extend({}, padding),
			w: availableWidth,
			h: availableHeight,
			x: padding.left,
			y: padding.top
		}, padding);

		setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);

		// First fit vertical boxes
		fitBoxes(verticalBoxes, chartArea, params);

		// Then fit horizontal boxes
		if (fitBoxes(horizontalBoxes, chartArea, params)) {
			// if the area changed, re-fit vertical boxes
			fitBoxes(verticalBoxes, chartArea, params);
		}

		handleMaxPadding(chartArea);

		// Finally place the boxes to correct coordinates
		placeBoxes(boxes.leftAndTop, chartArea, params);

		// Move to opposite side of chart
		chartArea.x += chartArea.w;
		chartArea.y += chartArea.h;

		placeBoxes(boxes.rightAndBottom, chartArea, params);

		chart.chartArea = {
			left: chartArea.left,
			top: chartArea.top,
			right: chartArea.left + chartArea.w,
			bottom: chartArea.top + chartArea.h
		};

		// Finally update boxes in chartArea (radial scale for example)
		helpers$1.each(boxes.chartArea, function(layout) {
			var box = layout.box;
			extend(box, chart.chartArea);
			box.update(chartArea.w, chartArea.h);
		});
	}
};

/**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */

var platform_basic = {
	acquireContext: function(item) {
		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		return item && item.getContext('2d') || null;
	}
};

var platform_dom = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n\tfrom { opacity: 0.99; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n\tanimation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n\tposition: absolute;\r\n\tdirection: ltr;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\tvisibility: hidden;\r\n\tz-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n\tposition: absolute;\r\n\twidth: 1000000px;\r\n\theight: 1000000px;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n\tposition: absolute;\r\n\twidth: 200%;\r\n\theight: 200%;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n";

var platform_dom$1 = /*#__PURE__*/Object.freeze({
__proto__: null,
'default': platform_dom
});

var stylesheet = getCjsExportFromNamespace(platform_dom$1);

var EXPANDO_KEY = '$chartjs';
var CSS_PREFIX = 'chartjs-';
var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];

/**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */
var EVENT_TYPES = {
	touchstart: 'mousedown',
	touchmove: 'mousemove',
	touchend: 'mouseup',
	pointerenter: 'mouseenter',
	pointerdown: 'mousedown',
	pointermove: 'mousemove',
	pointerup: 'mouseup',
	pointerleave: 'mouseout',
	pointerout: 'mouseout'
};

/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {number} Size in pixels or undefined if unknown.
 */
function readUsedSize(element, property) {
	var value = helpers$1.getStyle(element, property);
	var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
	return matches ? Number(matches[1]) : undefined;
}

/**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */
function initCanvas(canvas, config) {
	var style = canvas.style;

	// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
	// returns null or '' if no explicit value has been set to the canvas attribute.
	var renderHeight = canvas.getAttribute('height');
	var renderWidth = canvas.getAttribute('width');

	// Chart.js modifies some canvas values that we want to restore on destroy
	canvas[EXPANDO_KEY] = {
		initial: {
			height: renderHeight,
			width: renderWidth,
			style: {
				display: style.display,
				height: style.height,
				width: style.width
			}
		}
	};

	// Force canvas to display as block to avoid extra space caused by inline
	// elements, which would interfere with the responsive resize process.
	// https://github.com/chartjs/Chart.js/issues/2538
	style.display = style.display || 'block';

	if (renderWidth === null || renderWidth === '') {
		var displayWidth = readUsedSize(canvas, 'width');
		if (displayWidth !== undefined) {
			canvas.width = displayWidth;
		}
	}

	if (renderHeight === null || renderHeight === '') {
		if (canvas.style.height === '') {
			// If no explicit render height and style height, let's apply the aspect ratio,
			// which one can be specified by the user but also by charts as default option
			// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
			canvas.height = canvas.width / (config.options.aspectRatio || 2);
		} else {
			var displayHeight = readUsedSize(canvas, 'height');
			if (displayWidth !== undefined) {
				canvas.height = displayHeight;
			}
		}
	}

	return canvas;
}

/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */
var supportsEventListenerOptions = (function() {
	var supports = false;
	try {
		var options = Object.defineProperty({}, 'passive', {
			// eslint-disable-next-line getter-return
			get: function() {
				supports = true;
			}
		});
		window.addEventListener('e', null, options);
	} catch (e) {
		// continue regardless of error
	}
	return supports;
}());

// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
// https://github.com/chartjs/Chart.js/issues/4287
var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;

function addListener(node, type, listener) {
	node.addEventListener(type, listener, eventListenerOptions);
}

function removeListener(node, type, listener) {
	node.removeEventListener(type, listener, eventListenerOptions);
}

function createEvent(type, chart, x, y, nativeEvent) {
	return {
		type: type,
		chart: chart,
		native: nativeEvent || null,
		x: x !== undefined ? x : null,
		y: y !== undefined ? y : null,
	};
}

function fromNativeEvent(event, chart) {
	var type = EVENT_TYPES[event.type] || event.type;
	var pos = helpers$1.getRelativePosition(event, chart);
	return createEvent(type, chart, pos.x, pos.y, event);
}

function throttled(fn, thisArg) {
	var ticking = false;
	var args = [];

	return function() {
		args = Array.prototype.slice.call(arguments);
		thisArg = thisArg || this;

		if (!ticking) {
			ticking = true;
			helpers$1.requestAnimFrame.call(window, function() {
				ticking = false;
				fn.apply(thisArg, args);
			});
		}
	};
}

function createDiv(cls) {
	var el = document.createElement('div');
	el.className = cls || '';
	return el;
}

// Implementation based on https://github.com/marcj/css-element-queries
function createResizer(handler) {
	var maxSize = 1000000;

	// NOTE(SB) Don't use innerHTML because it could be considered unsafe.
	// https://github.com/chartjs/Chart.js/issues/5902
	var resizer = createDiv(CSS_SIZE_MONITOR);
	var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
	var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');

	expand.appendChild(createDiv());
	shrink.appendChild(createDiv());

	resizer.appendChild(expand);
	resizer.appendChild(shrink);
	resizer._reset = function() {
		expand.scrollLeft = maxSize;
		expand.scrollTop = maxSize;
		shrink.scrollLeft = maxSize;
		shrink.scrollTop = maxSize;
	};

	var onScroll = function() {
		resizer._reset();
		handler();
	};

	addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
	addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));

	return resizer;
}

// https://davidwalsh.name/detect-node-insertion
function watchForRender(node, handler) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	var proxy = expando.renderProxy = function(e) {
		if (e.animationName === CSS_RENDER_ANIMATION) {
			handler();
		}
	};

	helpers$1.each(ANIMATION_START_EVENTS, function(type) {
		addListener(node, type, proxy);
	});

	// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
	// is removed then added back immediately (same animation frame?). Accessing the
	// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
	// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
	// https://github.com/chartjs/Chart.js/issues/4737
	expando.reflow = !!node.offsetParent;

	node.classList.add(CSS_RENDER_MONITOR);
}

function unwatchForRender(node) {
	var expando = node[EXPANDO_KEY] || {};
	var proxy = expando.renderProxy;

	if (proxy) {
		helpers$1.each(ANIMATION_START_EVENTS, function(type) {
			removeListener(node, type, proxy);
		});

		delete expando.renderProxy;
	}

	node.classList.remove(CSS_RENDER_MONITOR);
}

function addResizeListener(node, listener, chart) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});

	// Let's keep track of this added resizer and thus avoid DOM query when removing it.
	var resizer = expando.resizer = createResizer(throttled(function() {
		if (expando.resizer) {
			var container = chart.options.maintainAspectRatio && node.parentNode;
			var w = container ? container.clientWidth : 0;
			listener(createEvent('resize', chart));
			if (container && container.clientWidth < w && chart.canvas) {
				// If the container size shrank during chart resize, let's assume
				// scrollbar appeared. So we resize again with the scrollbar visible -
				// effectively making chart smaller and the scrollbar hidden again.
				// Because we are inside `throttled`, and currently `ticking`, scroll
				// events are ignored during this whole 2 resize process.
				// If we assumed wrong and something else happened, we are resizing
				// twice in a frame (potential performance issue)
				listener(createEvent('resize', chart));
			}
		}
	}));

	// The resizer needs to be attached to the node parent, so we first need to be
	// sure that `node` is attached to the DOM before injecting the resizer element.
	watchForRender(node, function() {
		if (expando.resizer) {
			var container = node.parentNode;
			if (container && container !== resizer.parentNode) {
				container.insertBefore(resizer, container.firstChild);
			}

			// The container size might have changed, let's reset the resizer state.
			resizer._reset();
		}
	});
}

function removeResizeListener(node) {
	var expando = node[EXPANDO_KEY] || {};
	var resizer = expando.resizer;

	delete expando.resizer;
	unwatchForRender(node);

	if (resizer && resizer.parentNode) {
		resizer.parentNode.removeChild(resizer);
	}
}

/**
 * Injects CSS styles inline if the styles are not already present.
 * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
 * @param {string} css - the CSS to be injected.
 */
function injectCSS(rootNode, css) {
	// https://stackoverflow.com/q/3922139
	var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
	if (!expando.containsStyles) {
		expando.containsStyles = true;
		css = '/* Chart.js */\n' + css;
		var style = document.createElement('style');
		style.setAttribute('type', 'text/css');
		style.appendChild(document.createTextNode(css));
		rootNode.appendChild(style);
	}
}

var platform_dom$2 = {
	/**
	 * When `true`, prevents the automatic injection of the stylesheet required to
	 * correctly detect when the chart is added to the DOM and then resized. This
	 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
	 * to be manually imported to make this library compatible with any CSP.
	 * See https://github.com/chartjs/Chart.js/issues/5208
	 */
	disableCSSInjection: false,

	/**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */
	_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',

	/**
	 * Initializes resources that depend on platform options.
	 * @param {HTMLCanvasElement} canvas - The Canvas element.
	 * @private
	 */
	_ensureLoaded: function(canvas) {
		if (!this.disableCSSInjection) {
			// If the canvas is in a shadow DOM, then the styles must also be inserted
			// into the same shadow DOM.
			// https://github.com/chartjs/Chart.js/issues/5763
			var root = canvas.getRootNode ? canvas.getRootNode() : document;
			var targetNode = root.host ? root : document.head;
			injectCSS(targetNode, stylesheet);
		}
	},

	acquireContext: function(item, config) {
		if (typeof item === 'string') {
			item = document.getElementById(item);
		} else if (item.length) {
			// Support for array based queries (such as jQuery)
			item = item[0];
		}

		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		// To prevent canvas fingerprinting, some add-ons undefine the getContext
		// method, for example: https://github.com/kkapsner/CanvasBlocker
		// https://github.com/chartjs/Chart.js/issues/2807
		var context = item && item.getContext && item.getContext('2d');

		// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
		// inside an iframe or when running in a protected environment. We could guess the
		// types from their toString() value but let's keep things flexible and assume it's
		// a sufficient condition if the item has a context2D which has item as `canvas`.
		// https://github.com/chartjs/Chart.js/issues/3887
		// https://github.com/chartjs/Chart.js/issues/4102
		// https://github.com/chartjs/Chart.js/issues/4152
		if (context && context.canvas === item) {
			// Load platform resources on first chart creation, to make it possible to
			// import the library before setting platform options.
			this._ensureLoaded(item);
			initCanvas(item, config);
			return context;
		}

		return null;
	},

	releaseContext: function(context) {
		var canvas = context.canvas;
		if (!canvas[EXPANDO_KEY]) {
			return;
		}

		var initial = canvas[EXPANDO_KEY].initial;
		['height', 'width'].forEach(function(prop) {
			var value = initial[prop];
			if (helpers$1.isNullOrUndef(value)) {
				canvas.removeAttribute(prop);
			} else {
				canvas.setAttribute(prop, value);
			}
		});

		helpers$1.each(initial.style || {}, function(value, key) {
			canvas.style[key] = value;
		});

		// The canvas render size might have been changed (and thus the state stack discarded),
		// we can't use save() and restore() to restore the initial state. So make sure that at
		// least the canvas context is reset to the default state by setting the canvas width.
		// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
		// eslint-disable-next-line no-self-assign
		canvas.width = canvas.width;

		delete canvas[EXPANDO_KEY];
	},

	addEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			addResizeListener(canvas, listener, chart);
			return;
		}

		var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
		var proxies = expando.proxies || (expando.proxies = {});
		var proxy = proxies[chart.id + '_' + type] = function(event) {
			listener(fromNativeEvent(event, chart));
		};

		addListener(canvas, type, proxy);
	},

	removeEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			removeResizeListener(canvas);
			return;
		}

		var expando = listener[EXPANDO_KEY] || {};
		var proxies = expando.proxies || {};
		var proxy = proxies[chart.id + '_' + type];
		if (!proxy) {
			return;
		}

		removeListener(canvas, type, proxy);
	}
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers$1.addEvent = addListener;

/**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers$1.removeEvent = removeListener;

// @TODO Make possible to select another platform at build time.
var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;

/**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */
var platform = helpers$1.extend({
	/**
	 * @since 2.7.0
	 */
	initialize: function() {},

	/**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */
	acquireContext: function() {},

	/**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {boolean} true if the method succeeded, else false
	 */
	releaseContext: function() {},

	/**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {string} type - The ({@link IEvent}) type to listen for
	 * @param {function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */
	addEventListener: function() {},

	/**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart - Chart from which to remove the listener
	 * @param {string} type - The ({@link IEvent}) type to remove
	 * @param {function} listener - The listener function to remove from the event target.
	 */
	removeEventListener: function() {}

}, implementation);

core_defaults._set('global', {
	plugins: {}
});

/**
 * The plugin service singleton
 * @namespace Chart.plugins
 * @since 2.1.0
 */
var core_plugins = {
	/**
	 * Globally registered plugins.
	 * @private
	 */
	_plugins: [],

	/**
	 * This identifier is used to invalidate the descriptors cache attached to each chart
	 * when a global plugin is registered or unregistered. In this case, the cache ID is
	 * incremented and descriptors are regenerated during following API calls.
	 * @private
	 */
	_cacheId: 0,

	/**
	 * Registers the given plugin(s) if not already registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */
	register: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			if (p.indexOf(plugin) === -1) {
				p.push(plugin);
			}
		});

		this._cacheId++;
	},

	/**
	 * Unregisters the given plugin(s) only if registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */
	unregister: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			var idx = p.indexOf(plugin);
			if (idx !== -1) {
				p.splice(idx, 1);
			}
		});

		this._cacheId++;
	},

	/**
	 * Remove all registered plugins.
	 * @since 2.1.5
	 */
	clear: function() {
		this._plugins = [];
		this._cacheId++;
	},

	/**
	 * Returns the number of registered plugins?
	 * @returns {number}
	 * @since 2.1.5
	 */
	count: function() {
		return this._plugins.length;
	},

	/**
	 * Returns all registered plugin instances.
	 * @returns {IPlugin[]} array of plugin objects.
	 * @since 2.1.5
	 */
	getAll: function() {
		return this._plugins;
	},

	/**
	 * Calls enabled plugins for `chart` on the specified hook and with the given args.
	 * This method immediately returns as soon as a plugin explicitly returns false. The
	 * returned value can be used, for instance, to interrupt the current action.
	 * @param {Chart} chart - The chart instance for which plugins should be called.
	 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
	 * @param {Array} [args] - Extra arguments to apply to the hook call.
	 * @returns {boolean} false if any of the plugins return false, else returns true.
	 */
	notify: function(chart, hook, args) {
		var descriptors = this.descriptors(chart);
		var ilen = descriptors.length;
		var i, descriptor, plugin, params, method;

		for (i = 0; i < ilen; ++i) {
			descriptor = descriptors[i];
			plugin = descriptor.plugin;
			method = plugin[hook];
			if (typeof method === 'function') {
				params = [chart].concat(args || []);
				params.push(descriptor.options);
				if (method.apply(plugin, params) === false) {
					return false;
				}
			}
		}

		return true;
	},

	/**
	 * Returns descriptors of enabled plugins for the given chart.
	 * @returns {object[]} [{ plugin, options }]
	 * @private
	 */
	descriptors: function(chart) {
		var cache = chart.$plugins || (chart.$plugins = {});
		if (cache.id === this._cacheId) {
			return cache.descriptors;
		}

		var plugins = [];
		var descriptors = [];
		var config = (chart && chart.config) || {};
		var options = (config.options && config.options.plugins) || {};

		this._plugins.concat(config.plugins || []).forEach(function(plugin) {
			var idx = plugins.indexOf(plugin);
			if (idx !== -1) {
				return;
			}

			var id = plugin.id;
			var opts = options[id];
			if (opts === false) {
				return;
			}

			if (opts === true) {
				opts = helpers$1.clone(core_defaults.global.plugins[id]);
			}

			plugins.push(plugin);
			descriptors.push({
				plugin: plugin,
				options: opts || {}
			});
		});

		cache.descriptors = descriptors;
		cache.id = this._cacheId;
		return descriptors;
	},

	/**
	 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
	 * but in some cases, this reference can be changed by the user when updating options.
	 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
	 * @private
	 */
	_invalidate: function(chart) {
		delete chart.$plugins;
	}
};

var core_scaleService = {
	// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
	// use the new chart options to grab the correct scale
	constructors: {},
	// Use a registration function so that we can move to an ES6 map when we no longer need to support
	// old browsers

	// Scale config defaults
	defaults: {},
	registerScaleType: function(type, scaleConstructor, scaleDefaults) {
		this.constructors[type] = scaleConstructor;
		this.defaults[type] = helpers$1.clone(scaleDefaults);
	},
	getScaleConstructor: function(type) {
		return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
	},
	getScaleDefaults: function(type) {
		// Return the scale defaults merged with the global settings so that we always use the latest ones
		return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [core_defaults.scale, this.defaults[type]]) : {};
	},
	updateScaleDefaults: function(type, additions) {
		var me = this;
		if (me.defaults.hasOwnProperty(type)) {
			me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
		}
	},
	addScalesToLayout: function(chart) {
		// Adds each scale to the chart.boxes array to be sized accordingly
		helpers$1.each(chart.scales, function(scale) {
			// Set ILayoutItem parameters for backwards compatibility
			scale.fullWidth = scale.options.fullWidth;
			scale.position = scale.options.position;
			scale.weight = scale.options.weight;
			core_layouts.addBox(chart, scale);
		});
	}
};

var valueOrDefault$8 = helpers$1.valueOrDefault;
var getRtlHelper = helpers$1.rtl.getRtlAdapter;

core_defaults._set('global', {
	tooltips: {
		enabled: true,
		custom: null,
		mode: 'nearest',
		position: 'average',
		intersect: true,
		backgroundColor: 'rgba(0,0,0,0.8)',
		titleFontStyle: 'bold',
		titleSpacing: 2,
		titleMarginBottom: 6,
		titleFontColor: '#fff',
		titleAlign: 'left',
		bodySpacing: 2,
		bodyFontColor: '#fff',
		bodyAlign: 'left',
		footerFontStyle: 'bold',
		footerSpacing: 2,
		footerMarginTop: 6,
		footerFontColor: '#fff',
		footerAlign: 'left',
		yPadding: 6,
		xPadding: 6,
		caretPadding: 2,
		caretSize: 5,
		cornerRadius: 6,
		multiKeyBackground: '#fff',
		displayColors: true,
		borderColor: 'rgba(0,0,0,0)',
		borderWidth: 0,
		callbacks: {
			// Args are: (tooltipItems, data)
			beforeTitle: helpers$1.noop,
			title: function(tooltipItems, data) {
				var title = '';
				var labels = data.labels;
				var labelCount = labels ? labels.length : 0;

				if (tooltipItems.length > 0) {
					var item = tooltipItems[0];
					if (item.label) {
						title = item.label;
					} else if (item.xLabel) {
						title = item.xLabel;
					} else if (labelCount > 0 && item.index < labelCount) {
						title = labels[item.index];
					}
				}

				return title;
			},
			afterTitle: helpers$1.noop,

			// Args are: (tooltipItems, data)
			beforeBody: helpers$1.noop,

			// Args are: (tooltipItem, data)
			beforeLabel: helpers$1.noop,
			label: function(tooltipItem, data) {
				var label = data.datasets[tooltipItem.datasetIndex].label || '';

				if (label) {
					label += ': ';
				}
				if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
					label += tooltipItem.value;
				} else {
					label += tooltipItem.yLabel;
				}
				return label;
			},
			labelColor: function(tooltipItem, chart) {
				var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
				var activeElement = meta.data[tooltipItem.index];
				var view = activeElement._view;
				return {
					borderColor: view.borderColor,
					backgroundColor: view.backgroundColor
				};
			},
			labelTextColor: function() {
				return this._options.bodyFontColor;
			},
			afterLabel: helpers$1.noop,

			// Args are: (tooltipItems, data)
			afterBody: helpers$1.noop,

			// Args are: (tooltipItems, data)
			beforeFooter: helpers$1.noop,
			footer: helpers$1.noop,
			afterFooter: helpers$1.noop
		}
	}
});

var positioners = {
	/**
	 * Average mode places the tooltip at the average position of the elements shown
	 * @function Chart.Tooltip.positioners.average
	 * @param elements {ChartElement[]} the elements being displayed in the tooltip
	 * @returns {object} tooltip position
	 */
	average: function(elements) {
		if (!elements.length) {
			return false;
		}

		var i, len;
		var x = 0;
		var y = 0;
		var count = 0;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var pos = el.tooltipPosition();
				x += pos.x;
				y += pos.y;
				++count;
			}
		}

		return {
			x: x / count,
			y: y / count
		};
	},

	/**
	 * Gets the tooltip position nearest of the item nearest to the event position
	 * @function Chart.Tooltip.positioners.nearest
	 * @param elements {Chart.Element[]} the tooltip elements
	 * @param eventPosition {object} the position of the event in canvas coordinates
	 * @returns {object} the tooltip position
	 */
	nearest: function(elements, eventPosition) {
		var x = eventPosition.x;
		var y = eventPosition.y;
		var minDistance = Number.POSITIVE_INFINITY;
		var i, len, nearestElement;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var center = el.getCenterPoint();
				var d = helpers$1.distanceBetweenPoints(eventPosition, center);

				if (d < minDistance) {
					minDistance = d;
					nearestElement = el;
				}
			}
		}

		if (nearestElement) {
			var tp = nearestElement.tooltipPosition();
			x = tp.x;
			y = tp.y;
		}

		return {
			x: x,
			y: y
		};
	}
};

// Helper to push or concat based on if the 2nd parameter is an array or not
function pushOrConcat(base, toPush) {
	if (toPush) {
		if (helpers$1.isArray(toPush)) {
			// base = base.concat(toPush);
			Array.prototype.push.apply(base, toPush);
		} else {
			base.push(toPush);
		}
	}

	return base;
}

/**
 * Returns array of strings split by newline
 * @param {string} value - The value to split by newline.
 * @returns {string[]} value if newline present - Returned from String split() method
 * @function
 */
function splitNewlines(str) {
	if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
		return str.split('\n');
	}
	return str;
}


/**
 * Private helper to create a tooltip item model
 * @param element - the chart element (point, arc, bar) to create the tooltip item for
 * @return new tooltip item
 */
function createTooltipItem(element) {
	var xScale = element._xScale;
	var yScale = element._yScale || element._scale; // handle radar || polarArea charts
	var index = element._index;
	var datasetIndex = element._datasetIndex;
	var controller = element._chart.getDatasetMeta(datasetIndex).controller;
	var indexScale = controller._getIndexScale();
	var valueScale = controller._getValueScale();

	return {
		xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
		yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
		label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
		value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
		index: index,
		datasetIndex: datasetIndex,
		x: element._model.x,
		y: element._model.y
	};
}

/**
 * Helper to get the reset model for the tooltip
 * @param tooltipOpts {object} the tooltip options
 */
function getBaseModel(tooltipOpts) {
	var globalDefaults = core_defaults.global;

	return {
		// Positioning
		xPadding: tooltipOpts.xPadding,
		yPadding: tooltipOpts.yPadding,
		xAlign: tooltipOpts.xAlign,
		yAlign: tooltipOpts.yAlign,

		// Drawing direction and text direction
		rtl: tooltipOpts.rtl,
		textDirection: tooltipOpts.textDirection,

		// Body
		bodyFontColor: tooltipOpts.bodyFontColor,
		_bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
		_bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
		_bodyAlign: tooltipOpts.bodyAlign,
		bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
		bodySpacing: tooltipOpts.bodySpacing,

		// Title
		titleFontColor: tooltipOpts.titleFontColor,
		_titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
		_titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
		titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
		_titleAlign: tooltipOpts.titleAlign,
		titleSpacing: tooltipOpts.titleSpacing,
		titleMarginBottom: tooltipOpts.titleMarginBottom,

		// Footer
		footerFontColor: tooltipOpts.footerFontColor,
		_footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
		_footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
		footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
		_footerAlign: tooltipOpts.footerAlign,
		footerSpacing: tooltipOpts.footerSpacing,
		footerMarginTop: tooltipOpts.footerMarginTop,

		// Appearance
		caretSize: tooltipOpts.caretSize,
		cornerRadius: tooltipOpts.cornerRadius,
		backgroundColor: tooltipOpts.backgroundColor,
		opacity: 0,
		legendColorBackground: tooltipOpts.multiKeyBackground,
		displayColors: tooltipOpts.displayColors,
		borderColor: tooltipOpts.borderColor,
		borderWidth: tooltipOpts.borderWidth
	};
}

/**
 * Get the size of the tooltip
 */
function getTooltipSize(tooltip, model) {
	var ctx = tooltip._chart.ctx;

	var height = model.yPadding * 2; // Tooltip Padding
	var width = 0;

	// Count of all lines in the body
	var body = model.body;
	var combinedBodyLength = body.reduce(function(count, bodyItem) {
		return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
	}, 0);
	combinedBodyLength += model.beforeBody.length + model.afterBody.length;

	var titleLineCount = model.title.length;
	var footerLineCount = model.footer.length;
	var titleFontSize = model.titleFontSize;
	var bodyFontSize = model.bodyFontSize;
	var footerFontSize = model.footerFontSize;

	height += titleLineCount * titleFontSize; // Title Lines
	height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
	height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
	height += combinedBodyLength * bodyFontSize; // Body Lines
	height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
	height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
	height += footerLineCount * (footerFontSize); // Footer Lines
	height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing

	// Title width
	var widthPadding = 0;
	var maxLineWidth = function(line) {
		width = Math.max(width, ctx.measureText(line).width + widthPadding);
	};

	ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
	helpers$1.each(model.title, maxLineWidth);

	// Body width
	ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
	helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

	// Body lines may include some extra width due to the color box
	widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
	helpers$1.each(body, function(bodyItem) {
		helpers$1.each(bodyItem.before, maxLineWidth);
		helpers$1.each(bodyItem.lines, maxLineWidth);
		helpers$1.each(bodyItem.after, maxLineWidth);
	});

	// Reset back to 0
	widthPadding = 0;

	// Footer width
	ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
	helpers$1.each(model.footer, maxLineWidth);

	// Add padding
	width += 2 * model.xPadding;

	return {
		width: width,
		height: height
	};
}

/**
 * Helper to get the alignment of a tooltip given the size
 */
function determineAlignment(tooltip, size) {
	var model = tooltip._model;
	var chart = tooltip._chart;
	var chartArea = tooltip._chart.chartArea;
	var xAlign = 'center';
	var yAlign = 'center';

	if (model.y < size.height) {
		yAlign = 'top';
	} else if (model.y > (chart.height - size.height)) {
		yAlign = 'bottom';
	}

	var lf, rf; // functions to determine left, right alignment
	var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
	var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
	var midX = (chartArea.left + chartArea.right) / 2;
	var midY = (chartArea.top + chartArea.bottom) / 2;

	if (yAlign === 'center') {
		lf = function(x) {
			return x <= midX;
		};
		rf = function(x) {
			return x > midX;
		};
	} else {
		lf = function(x) {
			return x <= (size.width / 2);
		};
		rf = function(x) {
			return x >= (chart.width - (size.width / 2));
		};
	}

	olf = function(x) {
		return x + size.width + model.caretSize + model.caretPadding > chart.width;
	};
	orf = function(x) {
		return x - size.width - model.caretSize - model.caretPadding < 0;
	};
	yf = function(y) {
		return y <= midY ? 'top' : 'bottom';
	};

	if (lf(model.x)) {
		xAlign = 'left';

		// Is tooltip too wide and goes over the right side of the chart.?
		if (olf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	} else if (rf(model.x)) {
		xAlign = 'right';

		// Is tooltip too wide and goes outside left edge of canvas?
		if (orf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	}

	var opts = tooltip._options;
	return {
		xAlign: opts.xAlign ? opts.xAlign : xAlign,
		yAlign: opts.yAlign ? opts.yAlign : yAlign
	};
}

/**
 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
 */
function getBackgroundPoint(vm, size, alignment, chart) {
	// Background Position
	var x = vm.x;
	var y = vm.y;

	var caretSize = vm.caretSize;
	var caretPadding = vm.caretPadding;
	var cornerRadius = vm.cornerRadius;
	var xAlign = alignment.xAlign;
	var yAlign = alignment.yAlign;
	var paddingAndSize = caretSize + caretPadding;
	var radiusAndPadding = cornerRadius + caretPadding;

	if (xAlign === 'right') {
		x -= size.width;
	} else if (xAlign === 'center') {
		x -= (size.width / 2);
		if (x + size.width > chart.width) {
			x = chart.width - size.width;
		}
		if (x < 0) {
			x = 0;
		}
	}

	if (yAlign === 'top') {
		y += paddingAndSize;
	} else if (yAlign === 'bottom') {
		y -= size.height + paddingAndSize;
	} else {
		y -= (size.height / 2);
	}

	if (yAlign === 'center') {
		if (xAlign === 'left') {
			x += paddingAndSize;
		} else if (xAlign === 'right') {
			x -= paddingAndSize;
		}
	} else if (xAlign === 'left') {
		x -= radiusAndPadding;
	} else if (xAlign === 'right') {
		x += radiusAndPadding;
	}

	return {
		x: x,
		y: y
	};
}

function getAlignedX(vm, align) {
	return align === 'center'
		? vm.x + vm.width / 2
		: align === 'right'
			? vm.x + vm.width - vm.xPadding
			: vm.x + vm.xPadding;
}

/**
 * Helper to build before and after body lines
 */
function getBeforeAfterBodyLines(callback) {
	return pushOrConcat([], splitNewlines(callback));
}

var exports$4 = core_element.extend({
	initialize: function() {
		this._model = getBaseModel(this._options);
		this._lastActive = [];
	},

	// Get the title
	// Args are: (tooltipItem, data)
	getTitle: function() {
		var me = this;
		var opts = me._options;
		var callbacks = opts.callbacks;

		var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
		var title = callbacks.title.apply(me, arguments);
		var afterTitle = callbacks.afterTitle.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeTitle));
		lines = pushOrConcat(lines, splitNewlines(title));
		lines = pushOrConcat(lines, splitNewlines(afterTitle));

		return lines;
	},

	// Args are: (tooltipItem, data)
	getBeforeBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
	},

	// Args are: (tooltipItem, data)
	getBody: function(tooltipItems, data) {
		var me = this;
		var callbacks = me._options.callbacks;
		var bodyItems = [];

		helpers$1.each(tooltipItems, function(tooltipItem) {
			var bodyItem = {
				before: [],
				lines: [],
				after: []
			};
			pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
			pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
			pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));

			bodyItems.push(bodyItem);
		});

		return bodyItems;
	},

	// Args are: (tooltipItem, data)
	getAfterBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
	},

	// Get the footer and beforeFooter and afterFooter lines
	// Args are: (tooltipItem, data)
	getFooter: function() {
		var me = this;
		var callbacks = me._options.callbacks;

		var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
		var footer = callbacks.footer.apply(me, arguments);
		var afterFooter = callbacks.afterFooter.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeFooter));
		lines = pushOrConcat(lines, splitNewlines(footer));
		lines = pushOrConcat(lines, splitNewlines(afterFooter));

		return lines;
	},

	update: function(changed) {
		var me = this;
		var opts = me._options;

		// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
		// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
		// which breaks any animations.
		var existingModel = me._model;
		var model = me._model = getBaseModel(opts);
		var active = me._active;

		var data = me._data;

		// In the case where active.length === 0 we need to keep these at existing values for good animations
		var alignment = {
			xAlign: existingModel.xAlign,
			yAlign: existingModel.yAlign
		};
		var backgroundPoint = {
			x: existingModel.x,
			y: existingModel.y
		};
		var tooltipSize = {
			width: existingModel.width,
			height: existingModel.height
		};
		var tooltipPosition = {
			x: existingModel.caretX,
			y: existingModel.caretY
		};

		var i, len;

		if (active.length) {
			model.opacity = 1;

			var labelColors = [];
			var labelTextColors = [];
			tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);

			var tooltipItems = [];
			for (i = 0, len = active.length; i < len; ++i) {
				tooltipItems.push(createTooltipItem(active[i]));
			}

			// If the user provided a filter function, use it to modify the tooltip items
			if (opts.filter) {
				tooltipItems = tooltipItems.filter(function(a) {
					return opts.filter(a, data);
				});
			}

			// If the user provided a sorting function, use it to modify the tooltip items
			if (opts.itemSort) {
				tooltipItems = tooltipItems.sort(function(a, b) {
					return opts.itemSort(a, b, data);
				});
			}

			// Determine colors for boxes
			helpers$1.each(tooltipItems, function(tooltipItem) {
				labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
				labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
			});


			// Build the Text Lines
			model.title = me.getTitle(tooltipItems, data);
			model.beforeBody = me.getBeforeBody(tooltipItems, data);
			model.body = me.getBody(tooltipItems, data);
			model.afterBody = me.getAfterBody(tooltipItems, data);
			model.footer = me.getFooter(tooltipItems, data);

			// Initial positioning and colors
			model.x = tooltipPosition.x;
			model.y = tooltipPosition.y;
			model.caretPadding = opts.caretPadding;
			model.labelColors = labelColors;
			model.labelTextColors = labelTextColors;

			// data points
			model.dataPoints = tooltipItems;

			// We need to determine alignment of the tooltip
			tooltipSize = getTooltipSize(this, model);
			alignment = determineAlignment(this, tooltipSize);
			// Final Size and Position
			backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
		} else {
			model.opacity = 0;
		}

		model.xAlign = alignment.xAlign;
		model.yAlign = alignment.yAlign;
		model.x = backgroundPoint.x;
		model.y = backgroundPoint.y;
		model.width = tooltipSize.width;
		model.height = tooltipSize.height;

		// Point where the caret on the tooltip points to
		model.caretX = tooltipPosition.x;
		model.caretY = tooltipPosition.y;

		me._model = model;

		if (changed && opts.custom) {
			opts.custom.call(me, model);
		}

		return me;
	},

	drawCaret: function(tooltipPoint, size) {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);

		ctx.lineTo(caretPosition.x1, caretPosition.y1);
		ctx.lineTo(caretPosition.x2, caretPosition.y2);
		ctx.lineTo(caretPosition.x3, caretPosition.y3);
	},
	getCaretPosition: function(tooltipPoint, size, vm) {
		var x1, x2, x3, y1, y2, y3;
		var caretSize = vm.caretSize;
		var cornerRadius = vm.cornerRadius;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var ptX = tooltipPoint.x;
		var ptY = tooltipPoint.y;
		var width = size.width;
		var height = size.height;

		if (yAlign === 'center') {
			y2 = ptY + (height / 2);

			if (xAlign === 'left') {
				x1 = ptX;
				x2 = x1 - caretSize;
				x3 = x1;

				y1 = y2 + caretSize;
				y3 = y2 - caretSize;
			} else {
				x1 = ptX + width;
				x2 = x1 + caretSize;
				x3 = x1;

				y1 = y2 - caretSize;
				y3 = y2 + caretSize;
			}
		} else {
			if (xAlign === 'left') {
				x2 = ptX + cornerRadius + (caretSize);
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else if (xAlign === 'right') {
				x2 = ptX + width - cornerRadius - caretSize;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else {
				x2 = vm.caretX;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			}
			if (yAlign === 'top') {
				y1 = ptY;
				y2 = y1 - caretSize;
				y3 = y1;
			} else {
				y1 = ptY + height;
				y2 = y1 + caretSize;
				y3 = y1;
				// invert drawing order
				var tmp = x3;
				x3 = x1;
				x1 = tmp;
			}
		}
		return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
	},

	drawTitle: function(pt, vm, ctx) {
		var title = vm.title;
		var length = title.length;
		var titleFontSize, titleSpacing, i;

		if (length) {
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

			pt.x = getAlignedX(vm, vm._titleAlign);

			ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
			ctx.textBaseline = 'middle';

			titleFontSize = vm.titleFontSize;
			titleSpacing = vm.titleSpacing;

			ctx.fillStyle = vm.titleFontColor;
			ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);

			for (i = 0; i < length; ++i) {
				ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
				pt.y += titleFontSize + titleSpacing; // Line Height and spacing

				if (i + 1 === length) {
					pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
				}
			}
		}
	},

	drawBody: function(pt, vm, ctx) {
		var bodyFontSize = vm.bodyFontSize;
		var bodySpacing = vm.bodySpacing;
		var bodyAlign = vm._bodyAlign;
		var body = vm.body;
		var drawColorBoxes = vm.displayColors;
		var xLinePadding = 0;
		var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;

		var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

		var fillLineOfText = function(line) {
			ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
			pt.y += bodyFontSize + bodySpacing;
		};

		var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
		var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);

		ctx.textAlign = bodyAlign;
		ctx.textBaseline = 'middle';
		ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);

		pt.x = getAlignedX(vm, bodyAlignForCalculation);

		// Before body lines
		ctx.fillStyle = vm.bodyFontColor;
		helpers$1.each(vm.beforeBody, fillLineOfText);

		xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right'
			? bodyAlign === 'center' ? (bodyFontSize / 2 + 1) : (bodyFontSize + 2)
			: 0;

		// Draw body lines now
		for (i = 0, ilen = body.length; i < ilen; ++i) {
			bodyItem = body[i];
			textColor = vm.labelTextColors[i];
			labelColors = vm.labelColors[i];

			ctx.fillStyle = textColor;
			helpers$1.each(bodyItem.before, fillLineOfText);

			lines = bodyItem.lines;
			for (j = 0, jlen = lines.length; j < jlen; ++j) {
				// Draw Legend-like boxes if needed
				if (drawColorBoxes) {
					var rtlColorX = rtlHelper.x(colorX);

					// Fill a white rect so that colours merge nicely if the opacity is < 1
					ctx.fillStyle = vm.legendColorBackground;
					ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);

					// Border
					ctx.lineWidth = 1;
					ctx.strokeStyle = labelColors.borderColor;
					ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);

					// Inner square
					ctx.fillStyle = labelColors.backgroundColor;
					ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
					ctx.fillStyle = textColor;
				}

				fillLineOfText(lines[j]);
			}

			helpers$1.each(bodyItem.after, fillLineOfText);
		}

		// Reset back to 0 for after body
		xLinePadding = 0;

		// After body lines
		helpers$1.each(vm.afterBody, fillLineOfText);
		pt.y -= bodySpacing; // Remove last body spacing
	},

	drawFooter: function(pt, vm, ctx) {
		var footer = vm.footer;
		var length = footer.length;
		var footerFontSize, i;

		if (length) {
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

			pt.x = getAlignedX(vm, vm._footerAlign);
			pt.y += vm.footerMarginTop;

			ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
			ctx.textBaseline = 'middle';

			footerFontSize = vm.footerFontSize;

			ctx.fillStyle = vm.footerFontColor;
			ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);

			for (i = 0; i < length; ++i) {
				ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
				pt.y += footerFontSize + vm.footerSpacing;
			}
		}
	},

	drawBackground: function(pt, vm, ctx, tooltipSize) {
		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = vm.borderWidth;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var x = pt.x;
		var y = pt.y;
		var width = tooltipSize.width;
		var height = tooltipSize.height;
		var radius = vm.cornerRadius;

		ctx.beginPath();
		ctx.moveTo(x + radius, y);
		if (yAlign === 'top') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width - radius, y);
		ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
		if (yAlign === 'center' && xAlign === 'right') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width, y + height - radius);
		ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
		if (yAlign === 'bottom') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + radius, y + height);
		ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
		if (yAlign === 'center' && xAlign === 'left') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x, y + radius);
		ctx.quadraticCurveTo(x, y, x + radius, y);
		ctx.closePath();

		ctx.fill();

		if (vm.borderWidth > 0) {
			ctx.stroke();
		}
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;

		if (vm.opacity === 0) {
			return;
		}

		var tooltipSize = {
			width: vm.width,
			height: vm.height
		};
		var pt = {
			x: vm.x,
			y: vm.y
		};

		// IE11/Edge does not like very small opacities, so snap to 0
		var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;

		// Truthy/falsey value for empty tooltip
		var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;

		if (this._options.enabled && hasTooltipContent) {
			ctx.save();
			ctx.globalAlpha = opacity;

			// Draw Background
			this.drawBackground(pt, vm, ctx, tooltipSize);

			// Draw Title, Body, and Footer
			pt.y += vm.yPadding;

			helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);

			// Titles
			this.drawTitle(pt, vm, ctx);

			// Body
			this.drawBody(pt, vm, ctx);

			// Footer
			this.drawFooter(pt, vm, ctx);

			helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);

			ctx.restore();
		}
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 * @returns {boolean} true if the tooltip changed
	 */
	handleEvent: function(e) {
		var me = this;
		var options = me._options;
		var changed = false;

		me._lastActive = me._lastActive || [];

		// Find Active Elements for tooltips
		if (e.type === 'mouseout') {
			me._active = [];
		} else {
			me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
			if (options.reverse) {
				me._active.reverse();
			}
		}

		// Remember Last Actives
		changed = !helpers$1.arrayEquals(me._active, me._lastActive);

		// Only handle target event on tooltip change
		if (changed) {
			me._lastActive = me._active;

			if (options.enabled || options.custom) {
				me._eventPosition = {
					x: e.x,
					y: e.y
				};

				me.update(true);
				me.pivot();
			}
		}

		return changed;
	}
});

/**
 * @namespace Chart.Tooltip.positioners
 */
var positioners_1 = positioners;

var core_tooltip = exports$4;
core_tooltip.positioners = positioners_1;

var valueOrDefault$9 = helpers$1.valueOrDefault;

core_defaults._set('global', {
	elements: {},
	events: [
		'mousemove',
		'mouseout',
		'click',
		'touchstart',
		'touchmove'
	],
	hover: {
		onHover: null,
		mode: 'nearest',
		intersect: true,
		animationDuration: 400
	},
	onClick: null,
	maintainAspectRatio: true,
	responsive: true,
	responsiveAnimationDuration: 0
});

/**
 * Recursively merge the given config objects representing the `scales` option
 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
 * returns a deep copy of the result, thus doesn't alter inputs.
 */
function mergeScaleConfig(/* config objects ... */) {
	return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
		merger: function(key, target, source, options) {
			if (key === 'xAxes' || key === 'yAxes') {
				var slen = source[key].length;
				var i, type, scale;

				if (!target[key]) {
					target[key] = [];
				}

				for (i = 0; i < slen; ++i) {
					scale = source[key][i];
					type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');

					if (i >= target[key].length) {
						target[key].push({});
					}

					if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
						// new/untyped scale or type changed: let's apply the new defaults
						// then merge source scale to correctly overwrite the defaults.
						helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
					} else {
						// scales type are the same
						helpers$1.merge(target[key][i], scale);
					}
				}
			} else {
				helpers$1._merger(key, target, source, options);
			}
		}
	});
}

/**
 * Recursively merge the given config objects as the root options by handling
 * default scale options for the `scales` and `scale` properties, then returns
 * a deep copy of the result, thus doesn't alter inputs.
 */
function mergeConfig(/* config objects ... */) {
	return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
		merger: function(key, target, source, options) {
			var tval = target[key] || Object.create(null);
			var sval = source[key];

			if (key === 'scales') {
				// scale config merging is complex. Add our own function here for that
				target[key] = mergeScaleConfig(tval, sval);
			} else if (key === 'scale') {
				// used in polar area & radar charts since there is only one scale
				target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
			} else {
				helpers$1._merger(key, target, source, options);
			}
		}
	});
}

function initConfig(config) {
	config = config || Object.create(null);

	// Do NOT use mergeConfig for the data object because this method merges arrays
	// and so would change references to labels and datasets, preventing data updates.
	var data = config.data = config.data || {};
	data.datasets = data.datasets || [];
	data.labels = data.labels || [];

	config.options = mergeConfig(
		core_defaults.global,
		core_defaults[config.type],
		config.options || {});

	return config;
}

function updateConfig(chart) {
	var newOptions = chart.options;

	helpers$1.each(chart.scales, function(scale) {
		core_layouts.removeBox(chart, scale);
	});

	newOptions = mergeConfig(
		core_defaults.global,
		core_defaults[chart.config.type],
		newOptions);

	chart.options = chart.config.options = newOptions;
	chart.ensureScalesHaveIDs();
	chart.buildOrUpdateScales();

	// Tooltip
	chart.tooltip._options = newOptions.tooltips;
	chart.tooltip.initialize();
}

function nextAvailableScaleId(axesOpts, prefix, index) {
	var id;
	var hasId = function(obj) {
		return obj.id === id;
	};

	do {
		id = prefix + index++;
	} while (helpers$1.findIndex(axesOpts, hasId) >= 0);

	return id;
}

function positionIsHorizontal(position) {
	return position === 'top' || position === 'bottom';
}

function compare2Level(l1, l2) {
	return function(a, b) {
		return a[l1] === b[l1]
			? a[l2] - b[l2]
			: a[l1] - b[l1];
	};
}

var Chart = function(item, config) {
	this.construct(item, config);
	return this;
};

helpers$1.extend(Chart.prototype, /** @lends Chart */ {
	/**
	 * @private
	 */
	construct: function(item, config) {
		var me = this;

		config = initConfig(config);

		var context = platform.acquireContext(item, config);
		var canvas = context && context.canvas;
		var height = canvas && canvas.height;
		var width = canvas && canvas.width;

		me.id = helpers$1.uid();
		me.ctx = context;
		me.canvas = canvas;
		me.config = config;
		me.width = width;
		me.height = height;
		me.aspectRatio = height ? width / height : null;
		me.options = config.options;
		me._bufferedRender = false;
		me._layers = [];

		/**
		 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
		 * the "instance" still need to be defined since it might be called from plugins.
		 * @prop Chart#chart
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */
		me.chart = me;
		me.controller = me; // chart.chart.controller #inception

		// Add the chart instance to the global namespace
		Chart.instances[me.id] = me;

		// Define alias to the config data: `chart.data === chart.config.data`
		Object.defineProperty(me, 'data', {
			get: function() {
				return me.config.data;
			},
			set: function(value) {
				me.config.data = value;
			}
		});

		if (!context || !canvas) {
			// The given item is not a compatible context2d element, let's return before finalizing
			// the chart initialization but after setting basic chart / controller properties that
			// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
			// https://github.com/chartjs/Chart.js/issues/2807
			console.error("Failed to create chart: can't acquire context from the given item");
			return;
		}

		me.initialize();
		me.update();
	},

	/**
	 * @private
	 */
	initialize: function() {
		var me = this;

		// Before init plugin notification
		core_plugins.notify(me, 'beforeInit');

		helpers$1.retinaScale(me, me.options.devicePixelRatio);

		me.bindEvents();

		if (me.options.responsive) {
			// Initial resize before chart draws (must be silent to preserve initial animations).
			me.resize(true);
		}

		me.initToolTip();

		// After init plugin notification
		core_plugins.notify(me, 'afterInit');

		return me;
	},

	clear: function() {
		helpers$1.canvas.clear(this);
		return this;
	},

	stop: function() {
		// Stops any current animation loop occurring
		core_animations.cancelAnimation(this);
		return this;
	},

	resize: function(silent) {
		var me = this;
		var options = me.options;
		var canvas = me.canvas;
		var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;

		// the canvas render width and height will be casted to integers so make sure that
		// the canvas display style uses the same integer values to avoid blurring effect.

		// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
		var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
		var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));

		if (me.width === newWidth && me.height === newHeight) {
			return;
		}

		canvas.width = me.width = newWidth;
		canvas.height = me.height = newHeight;
		canvas.style.width = newWidth + 'px';
		canvas.style.height = newHeight + 'px';

		helpers$1.retinaScale(me, options.devicePixelRatio);

		if (!silent) {
			// Notify any plugins about the resize
			var newSize = {width: newWidth, height: newHeight};
			core_plugins.notify(me, 'resize', [newSize]);

			// Notify of resize
			if (options.onResize) {
				options.onResize(me, newSize);
			}

			me.stop();
			me.update({
				duration: options.responsiveAnimationDuration
			});
		}
	},

	ensureScalesHaveIDs: function() {
		var options = this.options;
		var scalesOptions = options.scales || {};
		var scaleOptions = options.scale;

		helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
			if (!xAxisOptions.id) {
				xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
			}
		});

		helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
			if (!yAxisOptions.id) {
				yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
			}
		});

		if (scaleOptions) {
			scaleOptions.id = scaleOptions.id || 'scale';
		}
	},

	/**
	 * Builds a map of scale ID to scale object for future lookup.
	 */
	buildOrUpdateScales: function() {
		var me = this;
		var options = me.options;
		var scales = me.scales || {};
		var items = [];
		var updated = Object.keys(scales).reduce(function(obj, id) {
			obj[id] = false;
			return obj;
		}, {});

		if (options.scales) {
			items = items.concat(
				(options.scales.xAxes || []).map(function(xAxisOptions) {
					return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
				}),
				(options.scales.yAxes || []).map(function(yAxisOptions) {
					return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
				})
			);
		}

		if (options.scale) {
			items.push({
				options: options.scale,
				dtype: 'radialLinear',
				isDefault: true,
				dposition: 'chartArea'
			});
		}

		helpers$1.each(items, function(item) {
			var scaleOptions = item.options;
			var id = scaleOptions.id;
			var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);

			if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
				scaleOptions.position = item.dposition;
			}

			updated[id] = true;
			var scale = null;
			if (id in scales && scales[id].type === scaleType) {
				scale = scales[id];
				scale.options = scaleOptions;
				scale.ctx = me.ctx;
				scale.chart = me;
			} else {
				var scaleClass = core_scaleService.getScaleConstructor(scaleType);
				if (!scaleClass) {
					return;
				}
				scale = new scaleClass({
					id: id,
					type: scaleType,
					options: scaleOptions,
					ctx: me.ctx,
					chart: me
				});
				scales[scale.id] = scale;
			}

			scale.mergeTicksOptions();

			// TODO(SB): I think we should be able to remove this custom case (options.scale)
			// and consider it as a regular scale part of the "scales"" map only! This would
			// make the logic easier and remove some useless? custom code.
			if (item.isDefault) {
				me.scale = scale;
			}
		});
		// clear up discarded scales
		helpers$1.each(updated, function(hasUpdated, id) {
			if (!hasUpdated) {
				delete scales[id];
			}
		});

		me.scales = scales;

		core_scaleService.addScalesToLayout(this);
	},

	buildOrUpdateControllers: function() {
		var me = this;
		var newControllers = [];
		var datasets = me.data.datasets;
		var i, ilen;

		for (i = 0, ilen = datasets.length; i < ilen; i++) {
			var dataset = datasets[i];
			var meta = me.getDatasetMeta(i);
			var type = dataset.type || me.config.type;

			if (meta.type && meta.type !== type) {
				me.destroyDatasetMeta(i);
				meta = me.getDatasetMeta(i);
			}
			meta.type = type;
			meta.order = dataset.order || 0;
			meta.index = i;

			if (meta.controller) {
				meta.controller.updateIndex(i);
				meta.controller.linkScales();
			} else {
				var ControllerClass = controllers[meta.type];
				if (ControllerClass === undefined) {
					throw new Error('"' + meta.type + '" is not a chart type.');
				}

				meta.controller = new ControllerClass(me, i);
				newControllers.push(meta.controller);
			}
		}

		return newControllers;
	},

	/**
	 * Reset the elements of all datasets
	 * @private
	 */
	resetElements: function() {
		var me = this;
		helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
			me.getDatasetMeta(datasetIndex).controller.reset();
		}, me);
	},

	/**
	* Resets the chart back to it's state before the initial animation
	*/
	reset: function() {
		this.resetElements();
		this.tooltip.initialize();
	},

	update: function(config) {
		var me = this;
		var i, ilen;

		if (!config || typeof config !== 'object') {
			// backwards compatibility
			config = {
				duration: config,
				lazy: arguments[1]
			};
		}

		updateConfig(me);

		// plugins options references might have change, let's invalidate the cache
		// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
		core_plugins._invalidate(me);

		if (core_plugins.notify(me, 'beforeUpdate') === false) {
			return;
		}

		// In case the entire data object changed
		me.tooltip._data = me.data;

		// Make sure dataset controllers are updated and new controllers are reset
		var newControllers = me.buildOrUpdateControllers();

		// Make sure all dataset controllers have correct meta data counts
		for (i = 0, ilen = me.data.datasets.length; i < ilen; i++) {
			me.getDatasetMeta(i).controller.buildOrUpdateElements();
		}

		me.updateLayout();

		// Can only reset the new controllers after the scales have been updated
		if (me.options.animation && me.options.animation.duration) {
			helpers$1.each(newControllers, function(controller) {
				controller.reset();
			});
		}

		me.updateDatasets();

		// Need to reset tooltip in case it is displayed with elements that are removed
		// after update.
		me.tooltip.initialize();

		// Last active contains items that were previously in the tooltip.
		// When we reset the tooltip, we need to clear it
		me.lastActive = [];

		// Do this before render so that any plugins that need final scale updates can use it
		core_plugins.notify(me, 'afterUpdate');

		me._layers.sort(compare2Level('z', '_idx'));

		if (me._bufferedRender) {
			me._bufferedRequest = {
				duration: config.duration,
				easing: config.easing,
				lazy: config.lazy
			};
		} else {
			me.render(config);
		}
	},

	/**
	 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
	 * hook, in which case, plugins will not be called on `afterLayout`.
	 * @private
	 */
	updateLayout: function() {
		var me = this;

		if (core_plugins.notify(me, 'beforeLayout') === false) {
			return;
		}

		core_layouts.update(this, this.width, this.height);

		me._layers = [];
		helpers$1.each(me.boxes, function(box) {
			// _configure is called twice, once in core.scale.update and once here.
			// Here the boxes are fully updated and at their final positions.
			if (box._configure) {
				box._configure();
			}
			me._layers.push.apply(me._layers, box._layers());
		}, me);

		me._layers.forEach(function(item, index) {
			item._idx = index;
		});

		/**
		 * Provided for backward compatibility, use `afterLayout` instead.
		 * @method IPlugin#afterScaleUpdate
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */
		core_plugins.notify(me, 'afterScaleUpdate');
		core_plugins.notify(me, 'afterLayout');
	},

	/**
	 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
	 * @private
	 */
	updateDatasets: function() {
		var me = this;

		if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
			return;
		}

		for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
			me.updateDataset(i);
		}

		core_plugins.notify(me, 'afterDatasetsUpdate');
	},

	/**
	 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
	 * @private
	 */
	updateDataset: function(index) {
		var me = this;
		var meta = me.getDatasetMeta(index);
		var args = {
			meta: meta,
			index: index
		};

		if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
			return;
		}

		meta.controller._update();

		core_plugins.notify(me, 'afterDatasetUpdate', [args]);
	},

	render: function(config) {
		var me = this;

		if (!config || typeof config !== 'object') {
			// backwards compatibility
			config = {
				duration: config,
				lazy: arguments[1]
			};
		}

		var animationOptions = me.options.animation;
		var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
		var lazy = config.lazy;

		if (core_plugins.notify(me, 'beforeRender') === false) {
			return;
		}

		var onComplete = function(animation) {
			core_plugins.notify(me, 'afterRender');
			helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
		};

		if (animationOptions && duration) {
			var animation = new core_animation({
				numSteps: duration / 16.66, // 60 fps
				easing: config.easing || animationOptions.easing,

				render: function(chart, animationObject) {
					var easingFunction = helpers$1.easing.effects[animationObject.easing];
					var currentStep = animationObject.currentStep;
					var stepDecimal = currentStep / animationObject.numSteps;

					chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
				},

				onAnimationProgress: animationOptions.onProgress,
				onAnimationComplete: onComplete
			});

			core_animations.addAnimation(me, animation, duration, lazy);
		} else {
			me.draw();

			// See https://github.com/chartjs/Chart.js/issues/3781
			onComplete(new core_animation({numSteps: 0, chart: me}));
		}

		return me;
	},

	draw: function(easingValue) {
		var me = this;
		var i, layers;

		me.clear();

		if (helpers$1.isNullOrUndef(easingValue)) {
			easingValue = 1;
		}

		me.transition(easingValue);

		if (me.width <= 0 || me.height <= 0) {
			return;
		}

		if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
			return;
		}

		// Because of plugin hooks (before/afterDatasetsDraw), datasets can't
		// currently be part of layers. Instead, we draw
		// layers <= 0 before(default, backward compat), and the rest after
		layers = me._layers;
		for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
			layers[i].draw(me.chartArea);
		}

		me.drawDatasets(easingValue);

		// Rest of layers
		for (; i < layers.length; ++i) {
			layers[i].draw(me.chartArea);
		}

		me._drawTooltip(easingValue);

		core_plugins.notify(me, 'afterDraw', [easingValue]);
	},

	/**
	 * @private
	 */
	transition: function(easingValue) {
		var me = this;

		for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
			if (me.isDatasetVisible(i)) {
				me.getDatasetMeta(i).controller.transition(easingValue);
			}
		}

		me.tooltip.transition(easingValue);
	},

	/**
	 * @private
	 */
	_getSortedDatasetMetas: function(filterVisible) {
		var me = this;
		var datasets = me.data.datasets || [];
		var result = [];
		var i, ilen;

		for (i = 0, ilen = datasets.length; i < ilen; ++i) {
			if (!filterVisible || me.isDatasetVisible(i)) {
				result.push(me.getDatasetMeta(i));
			}
		}

		result.sort(compare2Level('order', 'index'));

		return result;
	},

	/**
	 * @private
	 */
	_getSortedVisibleDatasetMetas: function() {
		return this._getSortedDatasetMetas(true);
	},

	/**
	 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
	 * @private
	 */
	drawDatasets: function(easingValue) {
		var me = this;
		var metasets, i;

		if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
			return;
		}

		metasets = me._getSortedVisibleDatasetMetas();
		for (i = metasets.length - 1; i >= 0; --i) {
			me.drawDataset(metasets[i], easingValue);
		}

		core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
	},

	/**
	 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
	 * @private
	 */
	drawDataset: function(meta, easingValue) {
		var me = this;
		var args = {
			meta: meta,
			index: meta.index,
			easingValue: easingValue
		};

		if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
			return;
		}

		meta.controller.draw(easingValue);

		core_plugins.notify(me, 'afterDatasetDraw', [args]);
	},

	/**
	 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
	 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
	 * @private
	 */
	_drawTooltip: function(easingValue) {
		var me = this;
		var tooltip = me.tooltip;
		var args = {
			tooltip: tooltip,
			easingValue: easingValue
		};

		if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
			return;
		}

		tooltip.draw();

		core_plugins.notify(me, 'afterTooltipDraw', [args]);
	},

	/**
	 * Get the single element that was clicked on
	 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
	 */
	getElementAtEvent: function(e) {
		return core_interaction.modes.single(this, e);
	},

	getElementsAtEvent: function(e) {
		return core_interaction.modes.label(this, e, {intersect: true});
	},

	getElementsAtXAxis: function(e) {
		return core_interaction.modes['x-axis'](this, e, {intersect: true});
	},

	getElementsAtEventForMode: function(e, mode, options) {
		var method = core_interaction.modes[mode];
		if (typeof method === 'function') {
			return method(this, e, options);
		}

		return [];
	},

	getDatasetAtEvent: function(e) {
		return core_interaction.modes.dataset(this, e, {intersect: true});
	},

	getDatasetMeta: function(datasetIndex) {
		var me = this;
		var dataset = me.data.datasets[datasetIndex];
		if (!dataset._meta) {
			dataset._meta = {};
		}

		var meta = dataset._meta[me.id];
		if (!meta) {
			meta = dataset._meta[me.id] = {
				type: null,
				data: [],
				dataset: null,
				controller: null,
				hidden: null,			// See isDatasetVisible() comment
				xAxisID: null,
				yAxisID: null,
				order: dataset.order || 0,
				index: datasetIndex
			};
		}

		return meta;
	},

	getVisibleDatasetCount: function() {
		var count = 0;
		for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
			if (this.isDatasetVisible(i)) {
				count++;
			}
		}
		return count;
	},

	isDatasetVisible: function(datasetIndex) {
		var meta = this.getDatasetMeta(datasetIndex);

		// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
		// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
		return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
	},

	generateLegend: function() {
		return this.options.legendCallback(this);
	},

	/**
	 * @private
	 */
	destroyDatasetMeta: function(datasetIndex) {
		var id = this.id;
		var dataset = this.data.datasets[datasetIndex];
		var meta = dataset._meta && dataset._meta[id];

		if (meta) {
			meta.controller.destroy();
			delete dataset._meta[id];
		}
	},

	destroy: function() {
		var me = this;
		var canvas = me.canvas;
		var i, ilen;

		me.stop();

		// dataset controllers need to cleanup associated data
		for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
			me.destroyDatasetMeta(i);
		}

		if (canvas) {
			me.unbindEvents();
			helpers$1.canvas.clear(me);
			platform.releaseContext(me.ctx);
			me.canvas = null;
			me.ctx = null;
		}

		core_plugins.notify(me, 'destroy');

		delete Chart.instances[me.id];
	},

	toBase64Image: function() {
		return this.canvas.toDataURL.apply(this.canvas, arguments);
	},

	initToolTip: function() {
		var me = this;
		me.tooltip = new core_tooltip({
			_chart: me,
			_chartInstance: me, // deprecated, backward compatibility
			_data: me.data,
			_options: me.options.tooltips
		}, me);
	},

	/**
	 * @private
	 */
	bindEvents: function() {
		var me = this;
		var listeners = me._listeners = {};
		var listener = function() {
			me.eventHandler.apply(me, arguments);
		};

		helpers$1.each(me.options.events, function(type) {
			platform.addEventListener(me, type, listener);
			listeners[type] = listener;
		});

		// Elements used to detect size change should not be injected for non responsive charts.
		// See https://github.com/chartjs/Chart.js/issues/2210
		if (me.options.responsive) {
			listener = function() {
				me.resize();
			};

			platform.addEventListener(me, 'resize', listener);
			listeners.resize = listener;
		}
	},

	/**
	 * @private
	 */
	unbindEvents: function() {
		var me = this;
		var listeners = me._listeners;
		if (!listeners) {
			return;
		}

		delete me._listeners;
		helpers$1.each(listeners, function(listener, type) {
			platform.removeEventListener(me, type, listener);
		});
	},

	updateHoverStyle: function(elements, mode, enabled) {
		var prefix = enabled ? 'set' : 'remove';
		var element, i, ilen;

		for (i = 0, ilen = elements.length; i < ilen; ++i) {
			element = elements[i];
			if (element) {
				this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
			}
		}

		if (mode === 'dataset') {
			this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
		}
	},

	/**
	 * @private
	 */
	eventHandler: function(e) {
		var me = this;
		var tooltip = me.tooltip;

		if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
			return;
		}

		// Buffer any update calls so that renders do not occur
		me._bufferedRender = true;
		me._bufferedRequest = null;

		var changed = me.handleEvent(e);
		// for smooth tooltip animations issue #4989
		// the tooltip should be the source of change
		// Animation check workaround:
		// tooltip._start will be null when tooltip isn't animating
		if (tooltip) {
			changed = tooltip._start
				? tooltip.handleEvent(e)
				: changed | tooltip.handleEvent(e);
		}

		core_plugins.notify(me, 'afterEvent', [e]);

		var bufferedRequest = me._bufferedRequest;
		if (bufferedRequest) {
			// If we have an update that was triggered, we need to do a normal render
			me.render(bufferedRequest);
		} else if (changed && !me.animating) {
			// If entering, leaving, or changing elements, animate the change via pivot
			me.stop();

			// We only need to render at this point. Updating will cause scales to be
			// recomputed generating flicker & using more memory than necessary.
			me.render({
				duration: me.options.hover.animationDuration,
				lazy: true
			});
		}

		me._bufferedRender = false;
		me._bufferedRequest = null;

		return me;
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event the event to handle
	 * @return {boolean} true if the chart needs to re-render
	 */
	handleEvent: function(e) {
		var me = this;
		var options = me.options || {};
		var hoverOptions = options.hover;
		var changed = false;

		me.lastActive = me.lastActive || [];

		// Find Active Elements for hover and tooltips
		if (e.type === 'mouseout') {
			me.active = [];
		} else {
			me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
		}

		// Invoke onHover hook
		// Need to call with native event here to not break backwards compatibility
		helpers$1.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);

		if (e.type === 'mouseup' || e.type === 'click') {
			if (options.onClick) {
				// Use e.native here for backwards compatibility
				options.onClick.call(me, e.native, me.active);
			}
		}

		// Remove styling for last active (even if it may still be active)
		if (me.lastActive.length) {
			me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
		}

		// Built in hover styling
		if (me.active.length && hoverOptions.mode) {
			me.updateHoverStyle(me.active, hoverOptions.mode, true);
		}

		changed = !helpers$1.arrayEquals(me.active, me.lastActive);

		// Remember Last Actives
		me.lastActive = me.active;

		return changed;
	}
});

/**
 * NOTE(SB) We actually don't use this container anymore but we need to keep it
 * for backward compatibility. Though, it can still be useful for plugins that
 * would need to work on multiple charts?!
 */
Chart.instances = {};

var core_controller = Chart;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart instead.
 * @class Chart.Controller
 * @deprecated since version 2.6
 * @todo remove at version 3
 * @private
 */
Chart.Controller = Chart;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */
Chart.types = {};

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.configMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
helpers$1.configMerge = mergeConfig;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.scaleMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
helpers$1.scaleMerge = mergeScaleConfig;

var core_helpers = function() {

	// -- Basic js utility methods

	helpers$1.where = function(collection, filterCallback) {
		if (helpers$1.isArray(collection) && Array.prototype.filter) {
			return collection.filter(filterCallback);
		}
		var filtered = [];

		helpers$1.each(collection, function(item) {
			if (filterCallback(item)) {
				filtered.push(item);
			}
		});

		return filtered;
	};
	helpers$1.findIndex = Array.prototype.findIndex ?
		function(array, callback, scope) {
			return array.findIndex(callback, scope);
		} :
		function(array, callback, scope) {
			scope = scope === undefined ? array : scope;
			for (var i = 0, ilen = array.length; i < ilen; ++i) {
				if (callback.call(scope, array[i], i, array)) {
					return i;
				}
			}
			return -1;
		};
	helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to start of the array
		if (helpers$1.isNullOrUndef(startIndex)) {
			startIndex = -1;
		}
		for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};
	helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to end of the array
		if (helpers$1.isNullOrUndef(startIndex)) {
			startIndex = arrayToSearch.length;
		}
		for (var i = startIndex - 1; i >= 0; i--) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};

	// -- Math methods
	helpers$1.isNumber = function(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	};
	helpers$1.almostEquals = function(x, y, epsilon) {
		return Math.abs(x - y) < epsilon;
	};
	helpers$1.almostWhole = function(x, epsilon) {
		var rounded = Math.round(x);
		return ((rounded - epsilon) <= x) && ((rounded + epsilon) >= x);
	};
	helpers$1.max = function(array) {
		return array.reduce(function(max, value) {
			if (!isNaN(value)) {
				return Math.max(max, value);
			}
			return max;
		}, Number.NEGATIVE_INFINITY);
	};
	helpers$1.min = function(array) {
		return array.reduce(function(min, value) {
			if (!isNaN(value)) {
				return Math.min(min, value);
			}
			return min;
		}, Number.POSITIVE_INFINITY);
	};
	helpers$1.sign = Math.sign ?
		function(x) {
			return Math.sign(x);
		} :
		function(x) {
			x = +x; // convert to a number
			if (x === 0 || isNaN(x)) {
				return x;
			}
			return x > 0 ? 1 : -1;
		};
	helpers$1.toRadians = function(degrees) {
		return degrees * (Math.PI / 180);
	};
	helpers$1.toDegrees = function(radians) {
		return radians * (180 / Math.PI);
	};

	/**
	 * Returns the number of decimal places
	 * i.e. the number of digits after the decimal point, of the value of this Number.
	 * @param {number} x - A number.
	 * @returns {number} The number of decimal places.
	 * @private
	 */
	helpers$1._decimalPlaces = function(x) {
		if (!helpers$1.isFinite(x)) {
			return;
		}
		var e = 1;
		var p = 0;
		while (Math.round(x * e) / e !== x) {
			e *= 10;
			p++;
		}
		return p;
	};

	// Gets the angle from vertical upright to the point about a centre.
	helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
		var distanceFromXCenter = anglePoint.x - centrePoint.x;
		var distanceFromYCenter = anglePoint.y - centrePoint.y;
		var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);

		var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);

		if (angle < (-0.5 * Math.PI)) {
			angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
		}

		return {
			angle: angle,
			distance: radialDistanceFromCenter
		};
	};
	helpers$1.distanceBetweenPoints = function(pt1, pt2) {
		return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
	};

	/**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.helpers.aliasPixel
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	helpers$1.aliasPixel = function(pixelWidth) {
		return (pixelWidth % 2 === 0) ? 0 : 0.5;
	};

	/**
	 * Returns the aligned pixel value to avoid anti-aliasing blur
	 * @param {Chart} chart - The chart instance.
	 * @param {number} pixel - A pixel value.
	 * @param {number} width - The width of the element.
	 * @returns {number} The aligned pixel value.
	 * @private
	 */
	helpers$1._alignPixel = function(chart, pixel, width) {
		var devicePixelRatio = chart.currentDevicePixelRatio;
		var halfWidth = width / 2;
		return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
	};

	helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
		// Props to Rob Spencer at scaled innovation for his post on splining between points
		// http://scaledinnovation.com/analytics/splines/aboutSplines.html

		// This function must also respect "skipped" points

		var previous = firstPoint.skip ? middlePoint : firstPoint;
		var current = middlePoint;
		var next = afterPoint.skip ? middlePoint : afterPoint;

		var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
		var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));

		var s01 = d01 / (d01 + d12);
		var s12 = d12 / (d01 + d12);

		// If all points are the same, s01 & s02 will be inf
		s01 = isNaN(s01) ? 0 : s01;
		s12 = isNaN(s12) ? 0 : s12;

		var fa = t * s01; // scaling factor for triangle Ta
		var fb = t * s12;

		return {
			previous: {
				x: current.x - fa * (next.x - previous.x),
				y: current.y - fa * (next.y - previous.y)
			},
			next: {
				x: current.x + fb * (next.x - previous.x),
				y: current.y + fb * (next.y - previous.y)
			}
		};
	};
	helpers$1.EPSILON = Number.EPSILON || 1e-14;
	helpers$1.splineCurveMonotone = function(points) {
		// This function calculates Bézier control points in a similar way than |splineCurve|,
		// but preserves monotonicity of the provided data and ensures no local extremums are added
		// between the dataset discrete points due to the interpolation.
		// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

		var pointsWithTangents = (points || []).map(function(point) {
			return {
				model: point._model,
				deltaK: 0,
				mK: 0
			};
		});

		// Calculate slopes (deltaK) and initialize tangents (mK)
		var pointsLen = pointsWithTangents.length;
		var i, pointBefore, pointCurrent, pointAfter;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointAfter && !pointAfter.model.skip) {
				var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);

				// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
				pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
			}

			if (!pointBefore || pointBefore.model.skip) {
				pointCurrent.mK = pointCurrent.deltaK;
			} else if (!pointAfter || pointAfter.model.skip) {
				pointCurrent.mK = pointBefore.deltaK;
			} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
				pointCurrent.mK = 0;
			} else {
				pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
			}
		}

		// Adjust tangents to ensure monotonic properties
		var alphaK, betaK, tauK, squaredMagnitude;
		for (i = 0; i < pointsLen - 1; ++i) {
			pointCurrent = pointsWithTangents[i];
			pointAfter = pointsWithTangents[i + 1];
			if (pointCurrent.model.skip || pointAfter.model.skip) {
				continue;
			}

			if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
				pointCurrent.mK = pointAfter.mK = 0;
				continue;
			}

			alphaK = pointCurrent.mK / pointCurrent.deltaK;
			betaK = pointAfter.mK / pointCurrent.deltaK;
			squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
			if (squaredMagnitude <= 9) {
				continue;
			}

			tauK = 3 / Math.sqrt(squaredMagnitude);
			pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
			pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
		}

		// Compute control points
		var deltaX;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointBefore && !pointBefore.model.skip) {
				deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
				pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
				pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
			}
			if (pointAfter && !pointAfter.model.skip) {
				deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
				pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
				pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
			}
		}
	};
	helpers$1.nextItem = function(collection, index, loop) {
		if (loop) {
			return index >= collection.length - 1 ? collection[0] : collection[index + 1];
		}
		return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
	};
	helpers$1.previousItem = function(collection, index, loop) {
		if (loop) {
			return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
		}
		return index <= 0 ? collection[0] : collection[index - 1];
	};
	// Implementation of the nice number algorithm used in determining where axis labels will go
	helpers$1.niceNum = function(range, round) {
		var exponent = Math.floor(helpers$1.log10(range));
		var fraction = range / Math.pow(10, exponent);
		var niceFraction;

		if (round) {
			if (fraction < 1.5) {
				niceFraction = 1;
			} else if (fraction < 3) {
				niceFraction = 2;
			} else if (fraction < 7) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
		} else if (fraction <= 1.0) {
			niceFraction = 1;
		} else if (fraction <= 2) {
			niceFraction = 2;
		} else if (fraction <= 5) {
			niceFraction = 5;
		} else {
			niceFraction = 10;
		}

		return niceFraction * Math.pow(10, exponent);
	};
	// Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
	helpers$1.requestAnimFrame = (function() {
		if (typeof window === 'undefined') {
			return function(callback) {
				callback();
			};
		}
		return window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function(callback) {
				return window.setTimeout(callback, 1000 / 60);
			};
	}());
	// -- DOM methods
	helpers$1.getRelativePosition = function(evt, chart) {
		var mouseX, mouseY;
		var e = evt.originalEvent || evt;
		var canvas = evt.target || evt.srcElement;
		var boundingRect = canvas.getBoundingClientRect();

		var touches = e.touches;
		if (touches && touches.length > 0) {
			mouseX = touches[0].clientX;
			mouseY = touches[0].clientY;

		} else {
			mouseX = e.clientX;
			mouseY = e.clientY;
		}

		// Scale mouse coordinates into canvas coordinates
		// by following the pattern laid out by 'jerryj' in the comments of
		// https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
		var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
		var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
		var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
		var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
		var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
		var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;

		// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
		// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
		mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
		mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);

		return {
			x: mouseX,
			y: mouseY
		};

	};

	// Private helper function to convert max-width/max-height values that may be percentages into a number
	function parseMaxStyle(styleValue, node, parentProperty) {
		var valueInPixels;
		if (typeof styleValue === 'string') {
			valueInPixels = parseInt(styleValue, 10);

			if (styleValue.indexOf('%') !== -1) {
				// percentage * size in dimension
				valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
			}
		} else {
			valueInPixels = styleValue;
		}

		return valueInPixels;
	}

	/**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */
	function isConstrainedValue(value) {
		return value !== undefined && value !== null && value !== 'none';
	}

	/**
	 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
	 * @param {HTMLElement} domNode - the node to check the constraint on
	 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
	 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
	 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
	 */
	function getConstraintDimension(domNode, maxStyle, percentageProperty) {
		var view = document.defaultView;
		var parentNode = helpers$1._getParentNode(domNode);
		var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
		var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
		var hasCNode = isConstrainedValue(constrainedNode);
		var hasCContainer = isConstrainedValue(constrainedContainer);
		var infinity = Number.POSITIVE_INFINITY;

		if (hasCNode || hasCContainer) {
			return Math.min(
				hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
				hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
		}

		return 'none';
	}
	// returns Number or undefined if no constraint
	helpers$1.getConstraintWidth = function(domNode) {
		return getConstraintDimension(domNode, 'max-width', 'clientWidth');
	};
	// returns Number or undefined if no constraint
	helpers$1.getConstraintHeight = function(domNode) {
		return getConstraintDimension(domNode, 'max-height', 'clientHeight');
	};
	/**
	 * @private
 	 */
	helpers$1._calculatePadding = function(container, padding, parentDimension) {
		padding = helpers$1.getStyle(container, padding);

		return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
	};
	/**
	 * @private
	 */
	helpers$1._getParentNode = function(domNode) {
		var parent = domNode.parentNode;
		if (parent && parent.toString() === '[object ShadowRoot]') {
			parent = parent.host;
		}
		return parent;
	};
	helpers$1.getMaximumWidth = function(domNode) {
		var container = helpers$1._getParentNode(domNode);
		if (!container) {
			return domNode.clientWidth;
		}

		var clientWidth = container.clientWidth;
		var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
		var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);

		var w = clientWidth - paddingLeft - paddingRight;
		var cw = helpers$1.getConstraintWidth(domNode);
		return isNaN(cw) ? w : Math.min(w, cw);
	};
	helpers$1.getMaximumHeight = function(domNode) {
		var container = helpers$1._getParentNode(domNode);
		if (!container) {
			return domNode.clientHeight;
		}

		var clientHeight = container.clientHeight;
		var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
		var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);

		var h = clientHeight - paddingTop - paddingBottom;
		var ch = helpers$1.getConstraintHeight(domNode);
		return isNaN(ch) ? h : Math.min(h, ch);
	};
	helpers$1.getStyle = function(el, property) {
		return el.currentStyle ?
			el.currentStyle[property] :
			document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
	};
	helpers$1.retinaScale = function(chart, forceRatio) {
		var pixelRatio = chart.currentDevicePixelRatio = forceRatio || (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
		if (pixelRatio === 1) {
			return;
		}

		var canvas = chart.canvas;
		var height = chart.height;
		var width = chart.width;

		canvas.height = height * pixelRatio;
		canvas.width = width * pixelRatio;
		chart.ctx.scale(pixelRatio, pixelRatio);

		// If no style has been set on the canvas, the render size is used as display size,
		// making the chart visually bigger, so let's enforce it to the "correct" values.
		// See https://github.com/chartjs/Chart.js/issues/3575
		if (!canvas.style.height && !canvas.style.width) {
			canvas.style.height = height + 'px';
			canvas.style.width = width + 'px';
		}
	};
	// -- Canvas methods
	helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
		return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
	};
	helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
		cache = cache || {};
		var data = cache.data = cache.data || {};
		var gc = cache.garbageCollect = cache.garbageCollect || [];

		if (cache.font !== font) {
			data = cache.data = {};
			gc = cache.garbageCollect = [];
			cache.font = font;
		}

		ctx.font = font;
		var longest = 0;
		var ilen = arrayOfThings.length;
		var i, j, jlen, thing, nestedThing;
		for (i = 0; i < ilen; i++) {
			thing = arrayOfThings[i];

			// Undefined strings and arrays should not be measured
			if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
				longest = helpers$1.measureText(ctx, data, gc, longest, thing);
			} else if (helpers$1.isArray(thing)) {
				// if it is an array lets measure each element
				// to do maybe simplify this function a bit so we can do this more recursively?
				for (j = 0, jlen = thing.length; j < jlen; j++) {
					nestedThing = thing[j];
					// Undefined strings and arrays should not be measured
					if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
						longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
					}
				}
			}
		}

		var gcLen = gc.length / 2;
		if (gcLen > arrayOfThings.length) {
			for (i = 0; i < gcLen; i++) {
				delete data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
		return longest;
	};
	helpers$1.measureText = function(ctx, data, gc, longest, string) {
		var textWidth = data[string];
		if (!textWidth) {
			textWidth = data[string] = ctx.measureText(string).width;
			gc.push(string);
		}
		if (textWidth > longest) {
			longest = textWidth;
		}
		return longest;
	};

	/**
	 * @deprecated
	 */
	helpers$1.numberOfLabelLines = function(arrayOfThings) {
		var numberOfLines = 1;
		helpers$1.each(arrayOfThings, function(thing) {
			if (helpers$1.isArray(thing)) {
				if (thing.length > numberOfLines) {
					numberOfLines = thing.length;
				}
			}
		});
		return numberOfLines;
	};

	helpers$1.color = !chartjsColor ?
		function(value) {
			console.error('Color.js not found!');
			return value;
		} :
		function(value) {
			/* global CanvasGradient */
			if (value instanceof CanvasGradient) {
				value = core_defaults.global.defaultColor;
			}

			return chartjsColor(value);
		};

	helpers$1.getHoverColor = function(colorValue) {
		/* global CanvasPattern */
		return (colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient) ?
			colorValue :
			helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
	};
};

function abstract() {
	throw new Error(
		'This method is not implemented: either no adapter can ' +
		'be found or an incomplete integration was provided.'
	);
}

/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */

/**
 * Currently supported unit string values.
 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
 * @memberof Chart._adapters._date
 * @name Unit
 */

/**
 * @class
 */
function DateAdapter(options) {
	this.options = options || {};
}

helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
	/**
	 * Returns a map of time formats for the supported formatting units defined
	 * in Unit as well as 'datetime' representing a detailed date/time string.
	 * @returns {{string: string}}
	 */
	formats: abstract,

	/**
	 * Parses the given `value` and return the associated timestamp.
	 * @param {any} value - the value to parse (usually comes from the data)
	 * @param {string} [format] - the expected data format
	 * @returns {(number|null)}
	 * @function
	 */
	parse: abstract,

	/**
	 * Returns the formatted date in the specified `format` for a given `timestamp`.
	 * @param {number} timestamp - the timestamp to format
	 * @param {string} format - the date/time token
	 * @return {string}
	 * @function
	 */
	format: abstract,

	/**
	 * Adds the specified `amount` of `unit` to the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {number} amount - the amount to add
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */
	add: abstract,

	/**
	 * Returns the number of `unit` between the given timestamps.
	 * @param {number} max - the input timestamp (reference)
	 * @param {number} min - the timestamp to substract
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */
	diff: abstract,

	/**
	 * Returns start of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
	 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
	 * @function
	 */
	startOf: abstract,

	/**
	 * Returns end of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @function
	 */
	endOf: abstract,

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility for scale.getValueForPixel(),
	 * this method should be overridden only by the moment adapter.
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	_create: function(value) {
		return value;
	}
});

DateAdapter.override = function(members) {
	helpers$1.extend(DateAdapter.prototype, members);
};

var _date = DateAdapter;

var core_adapters = {
	_date: _date
};

/**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */
var core_ticks = {
	/**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */
	formatters: {
		/**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {string|string[]} the label to display
		 */
		values: function(value) {
			return helpers$1.isArray(value) ? value : '' + value;
		},

		/**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {number} the value to be formatted
		 * @param index {number} the position of the tickValue parameter in the ticks array
		 * @param ticks {number[]} the list of ticks being converted
		 * @return {string} string representation of the tickValue parameter
		 */
		linear: function(tickValue, index, ticks) {
			// If we have lots of ticks, don't use the ones
			var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];

			// If we have a number like 2.5 as the delta, figure out how many decimal places we need
			if (Math.abs(delta) > 1) {
				if (tickValue !== Math.floor(tickValue)) {
					// not an integer
					delta = tickValue - Math.floor(tickValue);
				}
			}

			var logDelta = helpers$1.log10(Math.abs(delta));
			var tickString = '';

			if (tickValue !== 0) {
				var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
				if (maxTick < 1e-4) { // all ticks are small numbers; use scientific notation
					var logTick = helpers$1.log10(Math.abs(tickValue));
					var numExponential = Math.floor(logTick) - Math.floor(logDelta);
					numExponential = Math.max(Math.min(numExponential, 20), 0);
					tickString = tickValue.toExponential(numExponential);
				} else {
					var numDecimal = -1 * Math.floor(logDelta);
					numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
					tickString = tickValue.toFixed(numDecimal);
				}
			} else {
				tickString = '0'; // never show decimal places for 0
			}

			return tickString;
		},

		logarithmic: function(tickValue, index, ticks) {
			var remain = tickValue / (Math.pow(10, Math.floor(helpers$1.log10(tickValue))));

			if (tickValue === 0) {
				return '0';
			} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
				return tickValue.toExponential();
			}
			return '';
		}
	}
};

var isArray = helpers$1.isArray;
var isNullOrUndef = helpers$1.isNullOrUndef;
var valueOrDefault$a = helpers$1.valueOrDefault;
var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;

core_defaults._set('scale', {
	display: true,
	position: 'left',
	offset: false,

	// grid line settings
	gridLines: {
		display: true,
		color: 'rgba(0,0,0,0.1)',
		lineWidth: 1,
		drawBorder: true,
		drawOnChartArea: true,
		drawTicks: true,
		tickMarkLength: 10,
		zeroLineWidth: 1,
		zeroLineColor: 'rgba(0,0,0,0.25)',
		zeroLineBorderDash: [],
		zeroLineBorderDashOffset: 0.0,
		offsetGridLines: false,
		borderDash: [],
		borderDashOffset: 0.0
	},

	// scale label
	scaleLabel: {
		// display property
		display: false,

		// actual label
		labelString: '',

		// top/bottom padding
		padding: {
			top: 4,
			bottom: 4
		}
	},

	// label settings
	ticks: {
		beginAtZero: false,
		minRotation: 0,
		maxRotation: 50,
		mirror: false,
		padding: 0,
		reverse: false,
		display: true,
		autoSkip: true,
		autoSkipPadding: 0,
		labelOffset: 0,
		// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
		callback: core_ticks.formatters.values,
		minor: {},
		major: {}
	}
});

/** Returns a new array containing numItems from arr */
function sample(arr, numItems) {
	var result = [];
	var increment = arr.length / numItems;
	var i = 0;
	var len = arr.length;

	for (; i < len; i += increment) {
		result.push(arr[Math.floor(i)]);
	}
	return result;
}

function getPixelForGridLine(scale, index, offsetGridLines) {
	var length = scale.getTicks().length;
	var validIndex = Math.min(index, length - 1);
	var lineValue = scale.getPixelForTick(validIndex);
	var start = scale._startPixel;
	var end = scale._endPixel;
	var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
	var offset;

	if (offsetGridLines) {
		if (length === 1) {
			offset = Math.max(lineValue - start, end - lineValue);
		} else if (index === 0) {
			offset = (scale.getPixelForTick(1) - lineValue) / 2;
		} else {
			offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
		}
		lineValue += validIndex < index ? offset : -offset;

		// Return undefined if the pixel is out of the range
		if (lineValue < start - epsilon || lineValue > end + epsilon) {
			return;
		}
	}
	return lineValue;
}

function garbageCollect(caches, length) {
	helpers$1.each(caches, function(cache) {
		var gc = cache.gc;
		var gcLen = gc.length / 2;
		var i;
		if (gcLen > length) {
			for (i = 0; i < gcLen; ++i) {
				delete cache.data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
	});
}

/**
 * Returns {width, height, offset} objects for the first, last, widest, highest tick
 * labels where offset indicates the anchor point offset from the top in pixels.
 */
function computeLabelSizes(ctx, tickFonts, ticks, caches) {
	var length = ticks.length;
	var widths = [];
	var heights = [];
	var offsets = [];
	var widestLabelSize = 0;
	var highestLabelSize = 0;
	var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;

	for (i = 0; i < length; ++i) {
		label = ticks[i].label;
		tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
		ctx.font = fontString = tickFont.string;
		cache = caches[fontString] = caches[fontString] || {data: {}, gc: []};
		lineHeight = tickFont.lineHeight;
		width = height = 0;
		// Undefined labels and arrays should not be measured
		if (!isNullOrUndef(label) && !isArray(label)) {
			width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
			height = lineHeight;
		} else if (isArray(label)) {
			// if it is an array let's measure each element
			for (j = 0, jlen = label.length; j < jlen; ++j) {
				nestedLabel = label[j];
				// Undefined labels and arrays should not be measured
				if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
					width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
					height += lineHeight;
				}
			}
		}
		widths.push(width);
		heights.push(height);
		offsets.push(lineHeight / 2);
		widestLabelSize = Math.max(width, widestLabelSize);
		highestLabelSize = Math.max(height, highestLabelSize);
	}
	garbageCollect(caches, length);

	widest = widths.indexOf(widestLabelSize);
	highest = heights.indexOf(highestLabelSize);

	function valueAt(idx) {
		return {
			width: widths[idx] || 0,
			height: heights[idx] || 0,
			offset: offsets[idx] || 0
		};
	}

	return {
		first: valueAt(0),
		last: valueAt(length - 1),
		widest: valueAt(widest),
		highest: valueAt(highest)
	};
}

function getTickMarkLength(options) {
	return options.drawTicks ? options.tickMarkLength : 0;
}

function getScaleLabelHeight(options) {
	var font, padding;

	if (!options.display) {
		return 0;
	}

	font = helpers$1.options._parseFont(options);
	padding = helpers$1.options.toPadding(options.padding);

	return font.lineHeight + padding.height;
}

function parseFontOptions(options, nestedOpts) {
	return helpers$1.extend(helpers$1.options._parseFont({
		fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
		fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
		fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
		lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
	}), {
		color: helpers$1.options.resolve([nestedOpts.fontColor, options.fontColor, core_defaults.global.defaultFontColor])
	});
}

function parseTickFontOptions(options) {
	var minor = parseFontOptions(options, options.minor);
	var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;

	return {minor: minor, major: major};
}

function nonSkipped(ticksToFilter) {
	var filtered = [];
	var item, index, len;
	for (index = 0, len = ticksToFilter.length; index < len; ++index) {
		item = ticksToFilter[index];
		if (typeof item._index !== 'undefined') {
			filtered.push(item);
		}
	}
	return filtered;
}

function getEvenSpacing(arr) {
	var len = arr.length;
	var i, diff;

	if (len < 2) {
		return false;
	}

	for (diff = arr[0], i = 1; i < len; ++i) {
		if (arr[i] - arr[i - 1] !== diff) {
			return false;
		}
	}
	return diff;
}

function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
	var evenMajorSpacing = getEvenSpacing(majorIndices);
	var spacing = (ticks.length - 1) / ticksLimit;
	var factors, factor, i, ilen;

	// If the major ticks are evenly spaced apart, place the minor ticks
	// so that they divide the major ticks into even chunks
	if (!evenMajorSpacing) {
		return Math.max(spacing, 1);
	}

	factors = helpers$1.math._factorize(evenMajorSpacing);
	for (i = 0, ilen = factors.length - 1; i < ilen; i++) {
		factor = factors[i];
		if (factor > spacing) {
			return factor;
		}
	}
	return Math.max(spacing, 1);
}

function getMajorIndices(ticks) {
	var result = [];
	var i, ilen;
	for (i = 0, ilen = ticks.length; i < ilen; i++) {
		if (ticks[i].major) {
			result.push(i);
		}
	}
	return result;
}

function skipMajors(ticks, majorIndices, spacing) {
	var count = 0;
	var next = majorIndices[0];
	var i, tick;

	spacing = Math.ceil(spacing);
	for (i = 0; i < ticks.length; i++) {
		tick = ticks[i];
		if (i === next) {
			tick._index = i;
			count++;
			next = majorIndices[count * spacing];
		} else {
			delete tick.label;
		}
	}
}

function skip(ticks, spacing, majorStart, majorEnd) {
	var start = valueOrDefault$a(majorStart, 0);
	var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
	var count = 0;
	var length, i, tick, next;

	spacing = Math.ceil(spacing);
	if (majorEnd) {
		length = majorEnd - majorStart;
		spacing = length / Math.floor(length / spacing);
	}

	next = start;

	while (next < 0) {
		count++;
		next = Math.round(start + count * spacing);
	}

	for (i = Math.max(start, 0); i < end; i++) {
		tick = ticks[i];
		if (i === next) {
			tick._index = i;
			count++;
			next = Math.round(start + count * spacing);
		} else {
			delete tick.label;
		}
	}
}

var Scale = core_element.extend({

	zeroLineIndex: 0,

	/**
	 * Get the padding needed for the scale
	 * @method getPadding
	 * @private
	 * @returns {Padding} the necessary padding
	 */
	getPadding: function() {
		var me = this;
		return {
			left: me.paddingLeft || 0,
			top: me.paddingTop || 0,
			right: me.paddingRight || 0,
			bottom: me.paddingBottom || 0
		};
	},

	/**
	 * Returns the scale tick objects ({label, major})
	 * @since 2.7
	 */
	getTicks: function() {
		return this._ticks;
	},

	/**
	* @private
	*/
	_getLabels: function() {
		var data = this.chart.data;
		return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
	},

	// These methods are ordered by lifecyle. Utilities then follow.
	// Any function defined here is inherited by all scale types.
	// Any function can be extended by the scale type

	/**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.Scale.mergeTicksOptions
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	mergeTicksOptions: function() {
		// noop
	},

	beforeUpdate: function() {
		helpers$1.callback(this.options.beforeUpdate, [this]);
	},

	/**
	 * @param {number} maxWidth - the max width in pixels
	 * @param {number} maxHeight - the max height in pixels
	 * @param {object} margins - the space between the edge of the other scales and edge of the chart
	 *   This space comes from two sources:
	 *     - padding - space that's required to show the labels at the edges of the scale
	 *     - thickness of scales or legends in another orientation
	 */
	update: function(maxWidth, maxHeight, margins) {
		var me = this;
		var tickOpts = me.options.ticks;
		var sampleSize = tickOpts.sampleSize;
		var i, ilen, labels, ticks, samplingEnabled;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = helpers$1.extend({
			left: 0,
			right: 0,
			top: 0,
			bottom: 0
		}, margins);

		me._ticks = null;
		me.ticks = null;
		me._labelSizes = null;
		me._maxLabelLines = 0;
		me.longestLabelWidth = 0;
		me.longestTextCache = me.longestTextCache || {};
		me._gridLineItems = null;
		me._labelItems = null;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();

		// Data min/max
		me.beforeDataLimits();
		me.determineDataLimits();
		me.afterDataLimits();

		// Ticks - `this.ticks` is now DEPRECATED!
		// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
		// and must not be accessed directly from outside this class. `this.ticks` being
		// around for long time and not marked as private, we can't change its structure
		// without unexpected breaking changes. If you need to access the scale ticks,
		// use scale.getTicks() instead.

		me.beforeBuildTicks();

		// New implementations should return an array of objects but for BACKWARD COMPAT,
		// we still support no return (`this.ticks` internally set by calling this method).
		ticks = me.buildTicks() || [];

		// Allow modification of ticks in callback.
		ticks = me.afterBuildTicks(ticks) || ticks;

		// Ensure ticks contains ticks in new tick format
		if ((!ticks || !ticks.length) && me.ticks) {
			ticks = [];
			for (i = 0, ilen = me.ticks.length; i < ilen; ++i) {
				ticks.push({
					value: me.ticks[i],
					major: false
				});
			}
		}

		me._ticks = ticks;

		// Compute tick rotation and fit using a sampled subset of labels
		// We generally don't need to compute the size of every single label for determining scale size
		samplingEnabled = sampleSize < ticks.length;
		labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);

		// _configure is called twice, once here, once from core.controller.updateLayout.
		// Here we haven't been positioned yet, but dimensions are correct.
		// Variables set in _configure are needed for calculateTickRotation, and
		// it's ok that coordinates are not correct there, only dimensions matter.
		me._configure();

		// Tick Rotation
		me.beforeCalculateTickRotation();
		me.calculateTickRotation();
		me.afterCalculateTickRotation();

		me.beforeFit();
		me.fit();
		me.afterFit();

		// Auto-skip
		me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;

		if (samplingEnabled) {
			// Generate labels using all non-skipped ticks
			labels = me._convertTicksToLabels(me._ticksToDraw);
		}

		me.ticks = labels;   // BACKWARD COMPATIBILITY

		// IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!

		me.afterUpdate();

		// TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
		// make maxWidth and maxHeight private
		return me.minSize;
	},

	/**
	 * @private
	 */
	_configure: function() {
		var me = this;
		var reversePixels = me.options.ticks.reverse;
		var startPixel, endPixel;

		if (me.isHorizontal()) {
			startPixel = me.left;
			endPixel = me.right;
		} else {
			startPixel = me.top;
			endPixel = me.bottom;
			// by default vertical scales are from bottom to top, so pixels are reversed
			reversePixels = !reversePixels;
		}
		me._startPixel = startPixel;
		me._endPixel = endPixel;
		me._reversePixels = reversePixels;
		me._length = endPixel - startPixel;
	},

	afterUpdate: function() {
		helpers$1.callback(this.options.afterUpdate, [this]);
	},

	//

	beforeSetDimensions: function() {
		helpers$1.callback(this.options.beforeSetDimensions, [this]);
	},
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;
	},
	afterSetDimensions: function() {
		helpers$1.callback(this.options.afterSetDimensions, [this]);
	},

	// Data limits
	beforeDataLimits: function() {
		helpers$1.callback(this.options.beforeDataLimits, [this]);
	},
	determineDataLimits: helpers$1.noop,
	afterDataLimits: function() {
		helpers$1.callback(this.options.afterDataLimits, [this]);
	},

	//
	beforeBuildTicks: function() {
		helpers$1.callback(this.options.beforeBuildTicks, [this]);
	},
	buildTicks: helpers$1.noop,
	afterBuildTicks: function(ticks) {
		var me = this;
		// ticks is empty for old axis implementations here
		if (isArray(ticks) && ticks.length) {
			return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
		}
		// Support old implementations (that modified `this.ticks` directly in buildTicks)
		me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
		return ticks;
	},

	beforeTickToLabelConversion: function() {
		helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
	},
	convertTicksToLabels: function() {
		var me = this;
		// Convert ticks to strings
		var tickOpts = me.options.ticks;
		me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
	},
	afterTickToLabelConversion: function() {
		helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
	},

	//

	beforeCalculateTickRotation: function() {
		helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
	},
	calculateTickRotation: function() {
		var me = this;
		var options = me.options;
		var tickOpts = options.ticks;
		var numTicks = me.getTicks().length;
		var minRotation = tickOpts.minRotation || 0;
		var maxRotation = tickOpts.maxRotation;
		var labelRotation = minRotation;
		var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;

		if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
			me.labelRotation = minRotation;
			return;
		}

		labelSizes = me._getLabelSizes();
		maxLabelWidth = labelSizes.widest.width;
		maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;

		// Estimate the width of each grid based on the canvas width, the maximum
		// label width and the number of tick intervals
		maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
		tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);

		// Allow 3 pixels x2 padding either side for label readability
		if (maxLabelWidth + 6 > tickWidth) {
			tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
			maxHeight = me.maxHeight - getTickMarkLength(options.gridLines)
				- tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
			maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
			labelRotation = helpers$1.toDegrees(Math.min(
				Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)),
				Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)
			));
			labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
		}

		me.labelRotation = labelRotation;
	},
	afterCalculateTickRotation: function() {
		helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
	},

	//

	beforeFit: function() {
		helpers$1.callback(this.options.beforeFit, [this]);
	},
	fit: function() {
		var me = this;
		// Reset
		var minSize = me.minSize = {
			width: 0,
			height: 0
		};

		var chart = me.chart;
		var opts = me.options;
		var tickOpts = opts.ticks;
		var scaleLabelOpts = opts.scaleLabel;
		var gridLineOpts = opts.gridLines;
		var display = me._isVisible();
		var isBottom = opts.position === 'bottom';
		var isHorizontal = me.isHorizontal();

		// Width
		if (isHorizontal) {
			minSize.width = me.maxWidth;
		} else if (display) {
			minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
		}

		// height
		if (!isHorizontal) {
			minSize.height = me.maxHeight; // fill all the height
		} else if (display) {
			minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
		}

		// Don't bother fitting the ticks if we are not showing the labels
		if (tickOpts.display && display) {
			var tickFonts = parseTickFontOptions(tickOpts);
			var labelSizes = me._getLabelSizes();
			var firstLabelSize = labelSizes.first;
			var lastLabelSize = labelSizes.last;
			var widestLabelSize = labelSizes.widest;
			var highestLabelSize = labelSizes.highest;
			var lineSpace = tickFonts.minor.lineHeight * 0.4;
			var tickPadding = tickOpts.padding;

			if (isHorizontal) {
				// A horizontal axis is more constrained by the height.
				var isRotated = me.labelRotation !== 0;
				var angleRadians = helpers$1.toRadians(me.labelRotation);
				var cosRotation = Math.cos(angleRadians);
				var sinRotation = Math.sin(angleRadians);

				var labelHeight = sinRotation * widestLabelSize.width
					+ cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0))
					+ (isRotated ? 0 : lineSpace); // padding

				minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);

				var offsetLeft = me.getPixelForTick(0) - me.left;
				var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
				var paddingLeft, paddingRight;

				// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
				// which means that the right padding is dominated by the font height
				if (isRotated) {
					paddingLeft = isBottom ?
						cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset :
						sinRotation * (firstLabelSize.height - firstLabelSize.offset);
					paddingRight = isBottom ?
						sinRotation * (lastLabelSize.height - lastLabelSize.offset) :
						cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
				} else {
					paddingLeft = firstLabelSize.width / 2;
					paddingRight = lastLabelSize.width / 2;
				}

				// Adjust padding taking into account changes in offsets
				// and add 3 px to move away from canvas edges
				me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
				me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
			} else {
				// A vertical axis is more constrained by the width. Labels are the
				// dominant factor here, so get that length first and account for padding
				var labelWidth = tickOpts.mirror ? 0 :
					// use lineSpace for consistency with horizontal axis
					// tickPadding is not implemented for horizontal
					widestLabelSize.width + tickPadding + lineSpace;

				minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);

				me.paddingTop = firstLabelSize.height / 2;
				me.paddingBottom = lastLabelSize.height / 2;
			}
		}

		me.handleMargins();

		if (isHorizontal) {
			me.width = me._length = chart.width - me.margins.left - me.margins.right;
			me.height = minSize.height;
		} else {
			me.width = minSize.width;
			me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
		}
	},

	/**
	 * Handle margins and padding interactions
	 * @private
	 */
	handleMargins: function() {
		var me = this;
		if (me.margins) {
			me.margins.left = Math.max(me.paddingLeft, me.margins.left);
			me.margins.top = Math.max(me.paddingTop, me.margins.top);
			me.margins.right = Math.max(me.paddingRight, me.margins.right);
			me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
		}
	},

	afterFit: function() {
		helpers$1.callback(this.options.afterFit, [this]);
	},

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},
	isFullWidth: function() {
		return this.options.fullWidth;
	},

	// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
	getRightValue: function(rawValue) {
		// Null and undefined values first
		if (isNullOrUndef(rawValue)) {
			return NaN;
		}
		// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
		if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
			return NaN;
		}

		// If it is in fact an object, dive in one more level
		if (rawValue) {
			if (this.isHorizontal()) {
				if (rawValue.x !== undefined) {
					return this.getRightValue(rawValue.x);
				}
			} else if (rawValue.y !== undefined) {
				return this.getRightValue(rawValue.y);
			}
		}

		// Value is good, return it
		return rawValue;
	},

	_convertTicksToLabels: function(ticks) {
		var me = this;
		var labels, i, ilen;

		me.ticks = ticks.map(function(tick) {
			return tick.value;
		});

		me.beforeTickToLabelConversion();

		// New implementations should return the formatted tick labels but for BACKWARD
		// COMPAT, we still support no return (`this.ticks` internally changed by calling
		// this method and supposed to contain only string values).
		labels = me.convertTicksToLabels(ticks) || me.ticks;

		me.afterTickToLabelConversion();

		// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			ticks[i].label = labels[i];
		}

		return labels;
	},

	/**
	 * @private
	 */
	_getLabelSizes: function() {
		var me = this;
		var labelSizes = me._labelSizes;

		if (!labelSizes) {
			me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
			me.longestLabelWidth = labelSizes.widest.width;
		}

		return labelSizes;
	},

	/**
	 * @private
	 */
	_parseValue: function(value) {
		var start, end, min, max;

		if (isArray(value)) {
			start = +this.getRightValue(value[0]);
			end = +this.getRightValue(value[1]);
			min = Math.min(start, end);
			max = Math.max(start, end);
		} else {
			value = +this.getRightValue(value);
			start = undefined;
			end = value;
			min = value;
			max = value;
		}

		return {
			min: min,
			max: max,
			start: start,
			end: end
		};
	},

	/**
	* @private
	*/
	_getScaleLabel: function(rawValue) {
		var v = this._parseValue(rawValue);
		if (v.start !== undefined) {
			return '[' + v.start + ', ' + v.end + ']';
		}

		return +this.getRightValue(rawValue);
	},

	/**
	 * Used to get the value to display in the tooltip for the data at the given index
	 * @param index
	 * @param datasetIndex
	 */
	getLabelForIndex: helpers$1.noop,

	/**
	 * Returns the location of the given data point. Value can either be an index or a numerical value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param value
	 * @param index
	 * @param datasetIndex
	 */
	getPixelForValue: helpers$1.noop,

	/**
	 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param pixel
	 */
	getValueForPixel: helpers$1.noop,

	/**
	 * Returns the location of the tick at the given index
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getPixelForTick: function(index) {
		var me = this;
		var offset = me.options.offset;
		var numTicks = me._ticks.length;
		var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);

		return index < 0 || index > numTicks - 1
			? null
			: me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
	},

	/**
	 * Utility for getting the pixel location of a percentage of scale
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getPixelForDecimal: function(decimal) {
		var me = this;

		if (me._reversePixels) {
			decimal = 1 - decimal;
		}

		return me._startPixel + decimal * me._length;
	},

	getDecimalForPixel: function(pixel) {
		var decimal = (pixel - this._startPixel) / this._length;
		return this._reversePixels ? 1 - decimal : decimal;
	},

	/**
	 * Returns the pixel for the minimum chart value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getBasePixel: function() {
		return this.getPixelForValue(this.getBaseValue());
	},

	getBaseValue: function() {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0;
	},

	/**
	 * Returns a subset of ticks to be plotted to avoid overlapping labels.
	 * @private
	 */
	_autoSkip: function(ticks) {
		var me = this;
		var tickOpts = me.options.ticks;
		var axisLength = me._length;
		var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
		var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
		var numMajorIndices = majorIndices.length;
		var first = majorIndices[0];
		var last = majorIndices[numMajorIndices - 1];
		var i, ilen, spacing, avgMajorSpacing;

		// If there are too many major ticks to display them all
		if (numMajorIndices > ticksLimit) {
			skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
			return nonSkipped(ticks);
		}

		spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);

		if (numMajorIndices > 0) {
			for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
				skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
			}
			avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
			skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
			skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
			return nonSkipped(ticks);
		}
		skip(ticks, spacing);
		return nonSkipped(ticks);
	},

	/**
	 * @private
	 */
	_tickSize: function() {
		var me = this;
		var optionTicks = me.options.ticks;

		// Calculate space needed by label in axis direction.
		var rot = helpers$1.toRadians(me.labelRotation);
		var cos = Math.abs(Math.cos(rot));
		var sin = Math.abs(Math.sin(rot));

		var labelSizes = me._getLabelSizes();
		var padding = optionTicks.autoSkipPadding || 0;
		var w = labelSizes ? labelSizes.widest.width + padding : 0;
		var h = labelSizes ? labelSizes.highest.height + padding : 0;

		// Calculate space needed for 1 tick in axis direction.
		return me.isHorizontal()
			? h * cos > w * sin ? w / cos : h / sin
			: h * sin < w * cos ? h / cos : w / sin;
	},

	/**
	 * @private
	 */
	_isVisible: function() {
		var me = this;
		var chart = me.chart;
		var display = me.options.display;
		var i, ilen, meta;

		if (display !== 'auto') {
			return !!display;
		}

		// When 'auto', the scale is visible if at least one associated dataset is visible.
		for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
			if (chart.isDatasetVisible(i)) {
				meta = chart.getDatasetMeta(i);
				if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
					return true;
				}
			}
		}

		return false;
	},

	/**
	 * @private
	 */
	_computeGridLineItems: function(chartArea) {
		var me = this;
		var chart = me.chart;
		var options = me.options;
		var gridLines = options.gridLines;
		var position = options.position;
		var offsetGridLines = gridLines.offsetGridLines;
		var isHorizontal = me.isHorizontal();
		var ticks = me._ticksToDraw;
		var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);

		var tl = getTickMarkLength(gridLines);
		var items = [];
		var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
		var axisHalfWidth = axisWidth / 2;
		var alignPixel = helpers$1._alignPixel;
		var alignBorderValue = function(pixel) {
			return alignPixel(chart, pixel, axisWidth);
		};
		var borderValue, i, tick, lineValue, alignedLineValue;
		var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;

		if (position === 'top') {
			borderValue = alignBorderValue(me.bottom);
			ty1 = me.bottom - tl;
			ty2 = borderValue - axisHalfWidth;
			y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
			y2 = chartArea.bottom;
		} else if (position === 'bottom') {
			borderValue = alignBorderValue(me.top);
			y1 = chartArea.top;
			y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
			ty1 = borderValue + axisHalfWidth;
			ty2 = me.top + tl;
		} else if (position === 'left') {
			borderValue = alignBorderValue(me.right);
			tx1 = me.right - tl;
			tx2 = borderValue - axisHalfWidth;
			x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
			x2 = chartArea.right;
		} else {
			borderValue = alignBorderValue(me.left);
			x1 = chartArea.left;
			x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
			tx1 = borderValue + axisHalfWidth;
			tx2 = me.left + tl;
		}

		for (i = 0; i < ticksLength; ++i) {
			tick = ticks[i] || {};

			// autoskipper skipped this tick (#4635)
			if (isNullOrUndef(tick.label) && i < ticks.length) {
				continue;
			}

			if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
				// Draw the first index specially
				lineWidth = gridLines.zeroLineWidth;
				lineColor = gridLines.zeroLineColor;
				borderDash = gridLines.zeroLineBorderDash || [];
				borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
			} else {
				lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
				lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
				borderDash = gridLines.borderDash || [];
				borderDashOffset = gridLines.borderDashOffset || 0.0;
			}

			lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);

			// Skip if the pixel is out of the range
			if (lineValue === undefined) {
				continue;
			}

			alignedLineValue = alignPixel(chart, lineValue, lineWidth);

			if (isHorizontal) {
				tx1 = tx2 = x1 = x2 = alignedLineValue;
			} else {
				ty1 = ty2 = y1 = y2 = alignedLineValue;
			}

			items.push({
				tx1: tx1,
				ty1: ty1,
				tx2: tx2,
				ty2: ty2,
				x1: x1,
				y1: y1,
				x2: x2,
				y2: y2,
				width: lineWidth,
				color: lineColor,
				borderDash: borderDash,
				borderDashOffset: borderDashOffset,
			});
		}

		items.ticksLength = ticksLength;
		items.borderValue = borderValue;

		return items;
	},

	/**
	 * @private
	 */
	_computeLabelItems: function() {
		var me = this;
		var options = me.options;
		var optionTicks = options.ticks;
		var position = options.position;
		var isMirrored = optionTicks.mirror;
		var isHorizontal = me.isHorizontal();
		var ticks = me._ticksToDraw;
		var fonts = parseTickFontOptions(optionTicks);
		var tickPadding = optionTicks.padding;
		var tl = getTickMarkLength(options.gridLines);
		var rotation = -helpers$1.toRadians(me.labelRotation);
		var items = [];
		var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;

		if (position === 'top') {
			y = me.bottom - tl - tickPadding;
			textAlign = !rotation ? 'center' : 'left';
		} else if (position === 'bottom') {
			y = me.top + tl + tickPadding;
			textAlign = !rotation ? 'center' : 'right';
		} else if (position === 'left') {
			x = me.right - (isMirrored ? 0 : tl) - tickPadding;
			textAlign = isMirrored ? 'left' : 'right';
		} else {
			x = me.left + (isMirrored ? 0 : tl) + tickPadding;
			textAlign = isMirrored ? 'right' : 'left';
		}

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			tick = ticks[i];
			label = tick.label;

			// autoskipper skipped this tick (#4635)
			if (isNullOrUndef(label)) {
				continue;
			}

			pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
			font = tick.major ? fonts.major : fonts.minor;
			lineHeight = font.lineHeight;
			lineCount = isArray(label) ? label.length : 1;

			if (isHorizontal) {
				x = pixel;
				textOffset = position === 'top'
					? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight
					: (!rotation ? 0.5 : 0) * lineHeight;
			} else {
				y = pixel;
				textOffset = (1 - lineCount) * lineHeight / 2;
			}

			items.push({
				x: x,
				y: y,
				rotation: rotation,
				label: label,
				font: font,
				textOffset: textOffset,
				textAlign: textAlign
			});
		}

		return items;
	},

	/**
	 * @private
	 */
	_drawGrid: function(chartArea) {
		var me = this;
		var gridLines = me.options.gridLines;

		if (!gridLines.display) {
			return;
		}

		var ctx = me.ctx;
		var chart = me.chart;
		var alignPixel = helpers$1._alignPixel;
		var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
		var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
		var width, color, i, ilen, item;

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			width = item.width;
			color = item.color;

			if (width && color) {
				ctx.save();
				ctx.lineWidth = width;
				ctx.strokeStyle = color;
				if (ctx.setLineDash) {
					ctx.setLineDash(item.borderDash);
					ctx.lineDashOffset = item.borderDashOffset;
				}

				ctx.beginPath();

				if (gridLines.drawTicks) {
					ctx.moveTo(item.tx1, item.ty1);
					ctx.lineTo(item.tx2, item.ty2);
				}

				if (gridLines.drawOnChartArea) {
					ctx.moveTo(item.x1, item.y1);
					ctx.lineTo(item.x2, item.y2);
				}

				ctx.stroke();
				ctx.restore();
			}
		}

		if (axisWidth) {
			// Draw the line at the edge of the axis
			var firstLineWidth = axisWidth;
			var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
			var borderValue = items.borderValue;
			var x1, x2, y1, y2;

			if (me.isHorizontal()) {
				x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
				x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
				y1 = y2 = borderValue;
			} else {
				y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
				y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
				x1 = x2 = borderValue;
			}

			ctx.lineWidth = axisWidth;
			ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
			ctx.beginPath();
			ctx.moveTo(x1, y1);
			ctx.lineTo(x2, y2);
			ctx.stroke();
		}
	},

	/**
	 * @private
	 */
	_drawLabels: function() {
		var me = this;
		var optionTicks = me.options.ticks;

		if (!optionTicks.display) {
			return;
		}

		var ctx = me.ctx;
		var items = me._labelItems || (me._labelItems = me._computeLabelItems());
		var i, j, ilen, jlen, item, tickFont, label, y;

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			tickFont = item.font;

			// Make sure we draw text in the correct color and font
			ctx.save();
			ctx.translate(item.x, item.y);
			ctx.rotate(item.rotation);
			ctx.font = tickFont.string;
			ctx.fillStyle = tickFont.color;
			ctx.textBaseline = 'middle';
			ctx.textAlign = item.textAlign;

			label = item.label;
			y = item.textOffset;
			if (isArray(label)) {
				for (j = 0, jlen = label.length; j < jlen; ++j) {
					// We just make sure the multiline element is a string here..
					ctx.fillText('' + label[j], 0, y);
					y += tickFont.lineHeight;
				}
			} else {
				ctx.fillText(label, 0, y);
			}
			ctx.restore();
		}
	},

	/**
	 * @private
	 */
	_drawTitle: function() {
		var me = this;
		var ctx = me.ctx;
		var options = me.options;
		var scaleLabel = options.scaleLabel;

		if (!scaleLabel.display) {
			return;
		}

		var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
		var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
		var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
		var halfLineHeight = scaleLabelFont.lineHeight / 2;
		var position = options.position;
		var rotation = 0;
		var scaleLabelX, scaleLabelY;

		if (me.isHorizontal()) {
			scaleLabelX = me.left + me.width / 2; // midpoint of the width
			scaleLabelY = position === 'bottom'
				? me.bottom - halfLineHeight - scaleLabelPadding.bottom
				: me.top + halfLineHeight + scaleLabelPadding.top;
		} else {
			var isLeft = position === 'left';
			scaleLabelX = isLeft
				? me.left + halfLineHeight + scaleLabelPadding.top
				: me.right - halfLineHeight - scaleLabelPadding.top;
			scaleLabelY = me.top + me.height / 2;
			rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
		}

		ctx.save();
		ctx.translate(scaleLabelX, scaleLabelY);
		ctx.rotate(rotation);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';
		ctx.fillStyle = scaleLabelFontColor; // render in correct colour
		ctx.font = scaleLabelFont.string;
		ctx.fillText(scaleLabel.labelString, 0, 0);
		ctx.restore();
	},

	draw: function(chartArea) {
		var me = this;

		if (!me._isVisible()) {
			return;
		}

		me._drawGrid(chartArea);
		me._drawTitle();
		me._drawLabels();
	},

	/**
	 * @private
	 */
	_layers: function() {
		var me = this;
		var opts = me.options;
		var tz = opts.ticks && opts.ticks.z || 0;
		var gz = opts.gridLines && opts.gridLines.z || 0;

		if (!me._isVisible() || tz === gz || me.draw !== me._draw) {
			// backward compatibility: draw has been overridden by custom scale
			return [{
				z: tz,
				draw: function() {
					me.draw.apply(me, arguments);
				}
			}];
		}

		return [{
			z: gz,
			draw: function() {
				me._drawGrid.apply(me, arguments);
				me._drawTitle.apply(me, arguments);
			}
		}, {
			z: tz,
			draw: function() {
				me._drawLabels.apply(me, arguments);
			}
		}];
	},

	/**
	 * @private
	 */
	_getMatchingVisibleMetas: function(type) {
		var me = this;
		var isHorizontal = me.isHorizontal();
		return me.chart._getSortedVisibleDatasetMetas()
			.filter(function(meta) {
				return (!type || meta.type === type)
					&& (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
			});
	}
});

Scale.prototype._draw = Scale.prototype.draw;

var core_scale = Scale;

var isNullOrUndef$1 = helpers$1.isNullOrUndef;

var defaultConfig = {
	position: 'bottom'
};

var scale_category = core_scale.extend({
	determineDataLimits: function() {
		var me = this;
		var labels = me._getLabels();
		var ticksOpts = me.options.ticks;
		var min = ticksOpts.min;
		var max = ticksOpts.max;
		var minIndex = 0;
		var maxIndex = labels.length - 1;
		var findIndex;

		if (min !== undefined) {
			// user specified min value
			findIndex = labels.indexOf(min);
			if (findIndex >= 0) {
				minIndex = findIndex;
			}
		}

		if (max !== undefined) {
			// user specified max value
			findIndex = labels.indexOf(max);
			if (findIndex >= 0) {
				maxIndex = findIndex;
			}
		}

		me.minIndex = minIndex;
		me.maxIndex = maxIndex;
		me.min = labels[minIndex];
		me.max = labels[maxIndex];
	},

	buildTicks: function() {
		var me = this;
		var labels = me._getLabels();
		var minIndex = me.minIndex;
		var maxIndex = me.maxIndex;

		// If we are viewing some subset of labels, slice the original array
		me.ticks = (minIndex === 0 && maxIndex === labels.length - 1) ? labels : labels.slice(minIndex, maxIndex + 1);
	},

	getLabelForIndex: function(index, datasetIndex) {
		var me = this;
		var chart = me.chart;

		if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
			return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
		}

		return me._getLabels()[index];
	},

	_configure: function() {
		var me = this;
		var offset = me.options.offset;
		var ticks = me.ticks;

		core_scale.prototype._configure.call(me);

		if (!me.isHorizontal()) {
			// For backward compatibility, vertical category scale reverse is inverted.
			me._reversePixels = !me._reversePixels;
		}

		if (!ticks) {
			return;
		}

		me._startValue = me.minIndex - (offset ? 0.5 : 0);
		me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
	},

	// Used to get data value locations.  Value can either be an index or a numerical value
	getPixelForValue: function(value, index, datasetIndex) {
		var me = this;
		var valueCategory, labels, idx;

		if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) {
			value = me.chart.data.datasets[datasetIndex].data[index];
		}

		// If value is a data object, then index is the index in the data array,
		// not the index of the scale. We need to change that.
		if (!isNullOrUndef$1(value)) {
			valueCategory = me.isHorizontal() ? value.x : value.y;
		}
		if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
			labels = me._getLabels();
			value = helpers$1.valueOrDefault(valueCategory, value);
			idx = labels.indexOf(value);
			index = idx !== -1 ? idx : index;
			if (isNaN(index)) {
				index = value;
			}
		}
		return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
	},

	getPixelForTick: function(index) {
		var ticks = this.ticks;
		return index < 0 || index > ticks.length - 1
			? null
			: this.getPixelForValue(ticks[index], index + this.minIndex);
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
		return Math.min(Math.max(value, 0), me.ticks.length - 1);
	},

	getBasePixel: function() {
		return this.bottom;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults = defaultConfig;
scale_category._defaults = _defaults;

var noop = helpers$1.noop;
var isNullOrUndef$2 = helpers$1.isNullOrUndef;

/**
 * Generate a set of linear ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */
function generateTicks(generationOptions, dataRange) {
	var ticks = [];
	// To get a "nice" value for the tick spacing, we will use the appropriately named
	// "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
	// for details.

	var MIN_SPACING = 1e-14;
	var stepSize = generationOptions.stepSize;
	var unit = stepSize || 1;
	var maxNumSpaces = generationOptions.maxTicks - 1;
	var min = generationOptions.min;
	var max = generationOptions.max;
	var precision = generationOptions.precision;
	var rmin = dataRange.min;
	var rmax = dataRange.max;
	var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
	var factor, niceMin, niceMax, numSpaces;

	// Beyond MIN_SPACING floating point numbers being to lose precision
	// such that we can't do the math necessary to generate ticks
	if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) {
		return [rmin, rmax];
	}

	numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
	if (numSpaces > maxNumSpaces) {
		// If the calculated num of spaces exceeds maxNumSpaces, recalculate it
		spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
	}

	if (stepSize || isNullOrUndef$2(precision)) {
		// If a precision is not specified, calculate factor based on spacing
		factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
	} else {
		// If the user specified a precision, round to that number of decimal places
		factor = Math.pow(10, precision);
		spacing = Math.ceil(spacing * factor) / factor;
	}

	niceMin = Math.floor(rmin / spacing) * spacing;
	niceMax = Math.ceil(rmax / spacing) * spacing;

	// If min, max and stepSize is set and they make an evenly spaced scale use it.
	if (stepSize) {
		// If very close to our whole number, use it.
		if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
			niceMin = min;
		}
		if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
			niceMax = max;
		}
	}

	numSpaces = (niceMax - niceMin) / spacing;
	// If very close to our rounded value, use it.
	if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
		numSpaces = Math.round(numSpaces);
	} else {
		numSpaces = Math.ceil(numSpaces);
	}

	niceMin = Math.round(niceMin * factor) / factor;
	niceMax = Math.round(niceMax * factor) / factor;
	ticks.push(isNullOrUndef$2(min) ? niceMin : min);
	for (var j = 1; j < numSpaces; ++j) {
		ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
	}
	ticks.push(isNullOrUndef$2(max) ? niceMax : max);

	return ticks;
}

var scale_linearbase = core_scale.extend({
	getRightValue: function(value) {
		if (typeof value === 'string') {
			return +value;
		}
		return core_scale.prototype.getRightValue.call(this, value);
	},

	handleTickRangeOptions: function() {
		var me = this;
		var opts = me.options;
		var tickOpts = opts.ticks;

		// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
		// do nothing since that would make the chart weird. If the user really wants a weird chart
		// axis, they can manually override it
		if (tickOpts.beginAtZero) {
			var minSign = helpers$1.sign(me.min);
			var maxSign = helpers$1.sign(me.max);

			if (minSign < 0 && maxSign < 0) {
				// move the top up to 0
				me.max = 0;
			} else if (minSign > 0 && maxSign > 0) {
				// move the bottom down to 0
				me.min = 0;
			}
		}

		var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
		var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;

		if (tickOpts.min !== undefined) {
			me.min = tickOpts.min;
		} else if (tickOpts.suggestedMin !== undefined) {
			if (me.min === null) {
				me.min = tickOpts.suggestedMin;
			} else {
				me.min = Math.min(me.min, tickOpts.suggestedMin);
			}
		}

		if (tickOpts.max !== undefined) {
			me.max = tickOpts.max;
		} else if (tickOpts.suggestedMax !== undefined) {
			if (me.max === null) {
				me.max = tickOpts.suggestedMax;
			} else {
				me.max = Math.max(me.max, tickOpts.suggestedMax);
			}
		}

		if (setMin !== setMax) {
			// We set the min or the max but not both.
			// So ensure that our range is good
			// Inverted or 0 length range can happen when
			// ticks.min is set, and no datasets are visible
			if (me.min >= me.max) {
				if (setMin) {
					me.max = me.min + 1;
				} else {
					me.min = me.max - 1;
				}
			}
		}

		if (me.min === me.max) {
			me.max++;

			if (!tickOpts.beginAtZero) {
				me.min--;
			}
		}
	},

	getTickLimit: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var stepSize = tickOpts.stepSize;
		var maxTicksLimit = tickOpts.maxTicksLimit;
		var maxTicks;

		if (stepSize) {
			maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
		} else {
			maxTicks = me._computeTickLimit();
			maxTicksLimit = maxTicksLimit || 11;
		}

		if (maxTicksLimit) {
			maxTicks = Math.min(maxTicksLimit, maxTicks);
		}

		return maxTicks;
	},

	_computeTickLimit: function() {
		return Number.POSITIVE_INFINITY;
	},

	handleDirectionalChanges: noop,

	buildTicks: function() {
		var me = this;
		var opts = me.options;
		var tickOpts = opts.ticks;

		// Figure out what the max number of ticks we can support it is based on the size of
		// the axis area. For now, we say that the minimum tick spacing in pixels must be 40
		// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
		// the graph. Make sure we always have at least 2 ticks
		var maxTicks = me.getTickLimit();
		maxTicks = Math.max(2, maxTicks);

		var numericGeneratorOptions = {
			maxTicks: maxTicks,
			min: tickOpts.min,
			max: tickOpts.max,
			precision: tickOpts.precision,
			stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
		};
		var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);

		me.handleDirectionalChanges();

		// At this point, we need to update our max and min given the tick values since we have expanded the
		// range of the scale
		me.max = helpers$1.max(ticks);
		me.min = helpers$1.min(ticks);

		if (tickOpts.reverse) {
			ticks.reverse();

			me.start = me.max;
			me.end = me.min;
		} else {
			me.start = me.min;
			me.end = me.max;
		}
	},

	convertTicksToLabels: function() {
		var me = this;
		me.ticksAsNumbers = me.ticks.slice();
		me.zeroLineIndex = me.ticks.indexOf(0);

		core_scale.prototype.convertTicksToLabels.call(me);
	},

	_configure: function() {
		var me = this;
		var ticks = me.getTicks();
		var start = me.min;
		var end = me.max;
		var offset;

		core_scale.prototype._configure.call(me);

		if (me.options.offset && ticks.length) {
			offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
			start -= offset;
			end += offset;
		}
		me._startValue = start;
		me._endValue = end;
		me._valueRange = end - start;
	}
});

var defaultConfig$1 = {
	position: 'left',
	ticks: {
		callback: core_ticks.formatters.linear
	}
};

var DEFAULT_MIN = 0;
var DEFAULT_MAX = 1;

function getOrCreateStack(stacks, stacked, meta) {
	var key = [
		meta.type,
		// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
		stacked === undefined && meta.stack === undefined ? meta.index : '',
		meta.stack
	].join('.');

	if (stacks[key] === undefined) {
		stacks[key] = {
			pos: [],
			neg: []
		};
	}

	return stacks[key];
}

function stackData(scale, stacks, meta, data) {
	var opts = scale.options;
	var stacked = opts.stacked;
	var stack = getOrCreateStack(stacks, stacked, meta);
	var pos = stack.pos;
	var neg = stack.neg;
	var ilen = data.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = scale._parseValue(data[i]);
		if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
			continue;
		}

		pos[i] = pos[i] || 0;
		neg[i] = neg[i] || 0;

		if (opts.relativePoints) {
			pos[i] = 100;
		} else if (value.min < 0 || value.max < 0) {
			neg[i] += value.min;
		} else {
			pos[i] += value.max;
		}
	}
}

function updateMinMax(scale, meta, data) {
	var ilen = data.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = scale._parseValue(data[i]);
		if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
			continue;
		}

		scale.min = Math.min(scale.min, value.min);
		scale.max = Math.max(scale.max, value.max);
	}
}

var scale_linear = scale_linearbase.extend({
	determineDataLimits: function() {
		var me = this;
		var opts = me.options;
		var chart = me.chart;
		var datasets = chart.data.datasets;
		var metasets = me._getMatchingVisibleMetas();
		var hasStacks = opts.stacked;
		var stacks = {};
		var ilen = metasets.length;
		var i, meta, data, values;

		me.min = Number.POSITIVE_INFINITY;
		me.max = Number.NEGATIVE_INFINITY;

		if (hasStacks === undefined) {
			for (i = 0; !hasStacks && i < ilen; ++i) {
				meta = metasets[i];
				hasStacks = meta.stack !== undefined;
			}
		}

		for (i = 0; i < ilen; ++i) {
			meta = metasets[i];
			data = datasets[meta.index].data;
			if (hasStacks) {
				stackData(me, stacks, meta, data);
			} else {
				updateMinMax(me, meta, data);
			}
		}

		helpers$1.each(stacks, function(stackValues) {
			values = stackValues.pos.concat(stackValues.neg);
			me.min = Math.min(me.min, helpers$1.min(values));
			me.max = Math.max(me.max, helpers$1.max(values));
		});

		me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
		me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;

		// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
		me.handleTickRangeOptions();
	},

	// Returns the maximum number of ticks based on the scale dimension
	_computeTickLimit: function() {
		var me = this;
		var tickFont;

		if (me.isHorizontal()) {
			return Math.ceil(me.width / 40);
		}
		tickFont = helpers$1.options._parseFont(me.options.ticks);
		return Math.ceil(me.height / tickFont.lineHeight);
	},

	// Called after the ticks are built. We need
	handleDirectionalChanges: function() {
		if (!this.isHorizontal()) {
			// We are in a vertical orientation. The top value is the highest. So reverse the array
			this.ticks.reverse();
		}
	},

	getLabelForIndex: function(index, datasetIndex) {
		return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
	},

	// Utils
	getPixelForValue: function(value) {
		var me = this;
		return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
	},

	getValueForPixel: function(pixel) {
		return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
	},

	getPixelForTick: function(index) {
		var ticks = this.ticksAsNumbers;
		if (index < 0 || index > ticks.length - 1) {
			return null;
		}
		return this.getPixelForValue(ticks[index]);
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$1 = defaultConfig$1;
scale_linear._defaults = _defaults$1;

var valueOrDefault$b = helpers$1.valueOrDefault;
var log10 = helpers$1.math.log10;

/**
 * Generate a set of logarithmic ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */
function generateTicks$1(generationOptions, dataRange) {
	var ticks = [];

	var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));

	var endExp = Math.floor(log10(dataRange.max));
	var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
	var exp, significand;

	if (tickVal === 0) {
		exp = Math.floor(log10(dataRange.minNotZero));
		significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));

		ticks.push(tickVal);
		tickVal = significand * Math.pow(10, exp);
	} else {
		exp = Math.floor(log10(tickVal));
		significand = Math.floor(tickVal / Math.pow(10, exp));
	}
	var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;

	do {
		ticks.push(tickVal);

		++significand;
		if (significand === 10) {
			significand = 1;
			++exp;
			precision = exp >= 0 ? 1 : precision;
		}

		tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
	} while (exp < endExp || (exp === endExp && significand < endSignificand));

	var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
	ticks.push(lastTick);

	return ticks;
}

var defaultConfig$2 = {
	position: 'left',

	// label settings
	ticks: {
		callback: core_ticks.formatters.logarithmic
	}
};

// TODO(v3): change this to positiveOrDefault
function nonNegativeOrDefault(value, defaultValue) {
	return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
}

var scale_logarithmic = core_scale.extend({
	determineDataLimits: function() {
		var me = this;
		var opts = me.options;
		var chart = me.chart;
		var datasets = chart.data.datasets;
		var isHorizontal = me.isHorizontal();
		function IDMatches(meta) {
			return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
		}
		var datasetIndex, meta, value, data, i, ilen;

		// Calculate Range
		me.min = Number.POSITIVE_INFINITY;
		me.max = Number.NEGATIVE_INFINITY;
		me.minNotZero = Number.POSITIVE_INFINITY;

		var hasStacks = opts.stacked;
		if (hasStacks === undefined) {
			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
					meta.stack !== undefined) {
					hasStacks = true;
					break;
				}
			}
		}

		if (opts.stacked || hasStacks) {
			var valuesPerStack = {};

			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				var key = [
					meta.type,
					// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
					((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
					meta.stack
				].join('.');

				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					if (valuesPerStack[key] === undefined) {
						valuesPerStack[key] = [];
					}

					data = datasets[datasetIndex].data;
					for (i = 0, ilen = data.length; i < ilen; i++) {
						var values = valuesPerStack[key];
						value = me._parseValue(data[i]);
						// invalid, hidden and negative values are ignored
						if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
							continue;
						}
						values[i] = values[i] || 0;
						values[i] += value.max;
					}
				}
			}

			helpers$1.each(valuesPerStack, function(valuesForType) {
				if (valuesForType.length > 0) {
					var minVal = helpers$1.min(valuesForType);
					var maxVal = helpers$1.max(valuesForType);
					me.min = Math.min(me.min, minVal);
					me.max = Math.max(me.max, maxVal);
				}
			});

		} else {
			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					data = datasets[datasetIndex].data;
					for (i = 0, ilen = data.length; i < ilen; i++) {
						value = me._parseValue(data[i]);
						// invalid, hidden and negative values are ignored
						if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
							continue;
						}

						me.min = Math.min(value.min, me.min);
						me.max = Math.max(value.max, me.max);

						if (value.min !== 0) {
							me.minNotZero = Math.min(value.min, me.minNotZero);
						}
					}
				}
			}
		}

		me.min = helpers$1.isFinite(me.min) ? me.min : null;
		me.max = helpers$1.isFinite(me.max) ? me.max : null;
		me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;

		// Common base implementation to handle ticks.min, ticks.max
		this.handleTickRangeOptions();
	},

	handleTickRangeOptions: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var DEFAULT_MIN = 1;
		var DEFAULT_MAX = 10;

		me.min = nonNegativeOrDefault(tickOpts.min, me.min);
		me.max = nonNegativeOrDefault(tickOpts.max, me.max);

		if (me.min === me.max) {
			if (me.min !== 0 && me.min !== null) {
				me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
				me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
			} else {
				me.min = DEFAULT_MIN;
				me.max = DEFAULT_MAX;
			}
		}
		if (me.min === null) {
			me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
		}
		if (me.max === null) {
			me.max = me.min !== 0
				? Math.pow(10, Math.floor(log10(me.min)) + 1)
				: DEFAULT_MAX;
		}
		if (me.minNotZero === null) {
			if (me.min > 0) {
				me.minNotZero = me.min;
			} else if (me.max < 1) {
				me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
			} else {
				me.minNotZero = DEFAULT_MIN;
			}
		}
	},

	buildTicks: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var reverse = !me.isHorizontal();

		var generationOptions = {
			min: nonNegativeOrDefault(tickOpts.min),
			max: nonNegativeOrDefault(tickOpts.max)
		};
		var ticks = me.ticks = generateTicks$1(generationOptions, me);

		// At this point, we need to update our max and min given the tick values since we have expanded the
		// range of the scale
		me.max = helpers$1.max(ticks);
		me.min = helpers$1.min(ticks);

		if (tickOpts.reverse) {
			reverse = !reverse;
			me.start = me.max;
			me.end = me.min;
		} else {
			me.start = me.min;
			me.end = me.max;
		}
		if (reverse) {
			ticks.reverse();
		}
	},

	convertTicksToLabels: function() {
		this.tickValues = this.ticks.slice();

		core_scale.prototype.convertTicksToLabels.call(this);
	},

	// Get the correct tooltip label
	getLabelForIndex: function(index, datasetIndex) {
		return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
	},

	getPixelForTick: function(index) {
		var ticks = this.tickValues;
		if (index < 0 || index > ticks.length - 1) {
			return null;
		}
		return this.getPixelForValue(ticks[index]);
	},

	/**
	 * Returns the value of the first tick.
	 * @param {number} value - The minimum not zero value.
	 * @return {number} The first tick value.
	 * @private
	 */
	_getFirstTickValue: function(value) {
		var exp = Math.floor(log10(value));
		var significand = Math.floor(value / Math.pow(10, exp));

		return significand * Math.pow(10, exp);
	},

	_configure: function() {
		var me = this;
		var start = me.min;
		var offset = 0;

		core_scale.prototype._configure.call(me);

		if (start === 0) {
			start = me._getFirstTickValue(me.minNotZero);
			offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
		}

		me._startValue = log10(start);
		me._valueOffset = offset;
		me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
	},

	getPixelForValue: function(value) {
		var me = this;
		var decimal = 0;

		value = +me.getRightValue(value);

		if (value > me.min && value > 0) {
			decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
		}
		return me.getPixelForDecimal(decimal);
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var decimal = me.getDecimalForPixel(pixel);
		return decimal === 0 && me.min === 0
			? 0
			: Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$2 = defaultConfig$2;
scale_logarithmic._defaults = _defaults$2;

var valueOrDefault$c = helpers$1.valueOrDefault;
var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
var resolve$4 = helpers$1.options.resolve;

var defaultConfig$3 = {
	display: true,

	// Boolean - Whether to animate scaling the chart from the centre
	animate: true,
	position: 'chartArea',

	angleLines: {
		display: true,
		color: 'rgba(0,0,0,0.1)',
		lineWidth: 1,
		borderDash: [],
		borderDashOffset: 0.0
	},

	gridLines: {
		circular: false
	},

	// label settings
	ticks: {
		// Boolean - Show a backdrop to the scale label
		showLabelBackdrop: true,

		// String - The colour of the label backdrop
		backdropColor: 'rgba(255,255,255,0.75)',

		// Number - The backdrop padding above & below the label in pixels
		backdropPaddingY: 2,

		// Number - The backdrop padding to the side of the label in pixels
		backdropPaddingX: 2,

		callback: core_ticks.formatters.linear
	},

	pointLabels: {
		// Boolean - if true, show point labels
		display: true,

		// Number - Point label font size in pixels
		fontSize: 10,

		// Function - Used to convert point labels
		callback: function(label) {
			return label;
		}
	}
};

function getTickBackdropHeight(opts) {
	var tickOpts = opts.ticks;

	if (tickOpts.display && opts.display) {
		return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
	}
	return 0;
}

function measureLabelSize(ctx, lineHeight, label) {
	if (helpers$1.isArray(label)) {
		return {
			w: helpers$1.longestText(ctx, ctx.font, label),
			h: label.length * lineHeight
		};
	}

	return {
		w: ctx.measureText(label).width,
		h: lineHeight
	};
}

function determineLimits(angle, pos, size, min, max) {
	if (angle === min || angle === max) {
		return {
			start: pos - (size / 2),
			end: pos + (size / 2)
		};
	} else if (angle < min || angle > max) {
		return {
			start: pos - size,
			end: pos
		};
	}

	return {
		start: pos,
		end: pos + size
	};
}

/**
 * Helper function to fit a radial linear scale with point labels
 */
function fitWithPointLabels(scale) {

	// Right, this is really confusing and there is a lot of maths going on here
	// The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
	//
	// Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
	//
	// Solution:
	//
	// We assume the radius of the polygon is half the size of the canvas at first
	// at each index we check if the text overlaps.
	//
	// Where it does, we store that angle and that index.
	//
	// After finding the largest index and angle we calculate how much we need to remove
	// from the shape radius to move the point inwards by that x.
	//
	// We average the left and right distances to get the maximum shape radius that can fit in the box
	// along with labels.
	//
	// Once we have that, we can find the centre point for the chart, by taking the x text protrusion
	// on each side, removing that from the size, halving it and adding the left x protrusion width.
	//
	// This will mean we have a shape fitted to the canvas, as large as it can be with the labels
	// and position it in the most space efficient manner
	//
	// https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif

	var plFont = helpers$1.options._parseFont(scale.options.pointLabels);

	// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
	// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
	var furthestLimits = {
		l: 0,
		r: scale.width,
		t: 0,
		b: scale.height - scale.paddingTop
	};
	var furthestAngles = {};
	var i, textSize, pointPosition;

	scale.ctx.font = plFont.string;
	scale._pointLabelSizes = [];

	var valueCount = scale.chart.data.labels.length;
	for (i = 0; i < valueCount; i++) {
		pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
		textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
		scale._pointLabelSizes[i] = textSize;

		// Add quarter circle to make degree 0 mean top of circle
		var angleRadians = scale.getIndexAngle(i);
		var angle = helpers$1.toDegrees(angleRadians) % 360;
		var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
		var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);

		if (hLimits.start < furthestLimits.l) {
			furthestLimits.l = hLimits.start;
			furthestAngles.l = angleRadians;
		}

		if (hLimits.end > furthestLimits.r) {
			furthestLimits.r = hLimits.end;
			furthestAngles.r = angleRadians;
		}

		if (vLimits.start < furthestLimits.t) {
			furthestLimits.t = vLimits.start;
			furthestAngles.t = angleRadians;
		}

		if (vLimits.end > furthestLimits.b) {
			furthestLimits.b = vLimits.end;
			furthestAngles.b = angleRadians;
		}
	}

	scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
}

function getTextAlignForAngle(angle) {
	if (angle === 0 || angle === 180) {
		return 'center';
	} else if (angle < 180) {
		return 'left';
	}

	return 'right';
}

function fillText(ctx, text, position, lineHeight) {
	var y = position.y + lineHeight / 2;
	var i, ilen;

	if (helpers$1.isArray(text)) {
		for (i = 0, ilen = text.length; i < ilen; ++i) {
			ctx.fillText(text[i], position.x, y);
			y += lineHeight;
		}
	} else {
		ctx.fillText(text, position.x, y);
	}
}

function adjustPointPositionForLabelHeight(angle, textSize, position) {
	if (angle === 90 || angle === 270) {
		position.y -= (textSize.h / 2);
	} else if (angle > 270 || angle < 90) {
		position.y -= textSize.h;
	}
}

function drawPointLabels(scale) {
	var ctx = scale.ctx;
	var opts = scale.options;
	var pointLabelOpts = opts.pointLabels;
	var tickBackdropHeight = getTickBackdropHeight(opts);
	var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
	var plFont = helpers$1.options._parseFont(pointLabelOpts);

	ctx.save();

	ctx.font = plFont.string;
	ctx.textBaseline = 'middle';

	for (var i = scale.chart.data.labels.length - 1; i >= 0; i--) {
		// Extra pixels out for some label spacing
		var extra = (i === 0 ? tickBackdropHeight / 2 : 0);
		var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);

		// Keep this in loop since we may support array properties here
		var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
		ctx.fillStyle = pointLabelFontColor;

		var angleRadians = scale.getIndexAngle(i);
		var angle = helpers$1.toDegrees(angleRadians);
		ctx.textAlign = getTextAlignForAngle(angle);
		adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
		fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
	}
	ctx.restore();
}

function drawRadiusLine(scale, gridLineOpts, radius, index) {
	var ctx = scale.ctx;
	var circular = gridLineOpts.circular;
	var valueCount = scale.chart.data.labels.length;
	var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
	var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
	var pointPosition;

	if ((!circular && !valueCount) || !lineColor || !lineWidth) {
		return;
	}

	ctx.save();
	ctx.strokeStyle = lineColor;
	ctx.lineWidth = lineWidth;
	if (ctx.setLineDash) {
		ctx.setLineDash(gridLineOpts.borderDash || []);
		ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
	}

	ctx.beginPath();
	if (circular) {
		// Draw circular arcs between the points
		ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
	} else {
		// Draw straight lines connecting each index
		pointPosition = scale.getPointPosition(0, radius);
		ctx.moveTo(pointPosition.x, pointPosition.y);

		for (var i = 1; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, radius);
			ctx.lineTo(pointPosition.x, pointPosition.y);
		}
	}
	ctx.closePath();
	ctx.stroke();
	ctx.restore();
}

function numberOrZero(param) {
	return helpers$1.isNumber(param) ? param : 0;
}

var scale_radialLinear = scale_linearbase.extend({
	setDimensions: function() {
		var me = this;

		// Set the unconstrained dimension before label rotation
		me.width = me.maxWidth;
		me.height = me.maxHeight;
		me.paddingTop = getTickBackdropHeight(me.options) / 2;
		me.xCenter = Math.floor(me.width / 2);
		me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
		me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
	},

	determineDataLimits: function() {
		var me = this;
		var chart = me.chart;
		var min = Number.POSITIVE_INFINITY;
		var max = Number.NEGATIVE_INFINITY;

		helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
			if (chart.isDatasetVisible(datasetIndex)) {
				var meta = chart.getDatasetMeta(datasetIndex);

				helpers$1.each(dataset.data, function(rawValue, index) {
					var value = +me.getRightValue(rawValue);
					if (isNaN(value) || meta.data[index].hidden) {
						return;
					}

					min = Math.min(value, min);
					max = Math.max(value, max);
				});
			}
		});

		me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
		me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);

		// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
		me.handleTickRangeOptions();
	},

	// Returns the maximum number of ticks based on the scale dimension
	_computeTickLimit: function() {
		return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
	},

	convertTicksToLabels: function() {
		var me = this;

		scale_linearbase.prototype.convertTicksToLabels.call(me);

		// Point labels
		me.pointLabels = me.chart.data.labels.map(function() {
			var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
			return label || label === 0 ? label : '';
		});
	},

	getLabelForIndex: function(index, datasetIndex) {
		return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
	},

	fit: function() {
		var me = this;
		var opts = me.options;

		if (opts.display && opts.pointLabels.display) {
			fitWithPointLabels(me);
		} else {
			me.setCenterPoint(0, 0, 0, 0);
		}
	},

	/**
	 * Set radius reductions and determine new radius and center point
	 * @private
	 */
	setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
		var me = this;
		var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
		var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
		var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
		var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);

		radiusReductionLeft = numberOrZero(radiusReductionLeft);
		radiusReductionRight = numberOrZero(radiusReductionRight);
		radiusReductionTop = numberOrZero(radiusReductionTop);
		radiusReductionBottom = numberOrZero(radiusReductionBottom);

		me.drawingArea = Math.min(
			Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
			Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
		me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
	},

	setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
		var me = this;
		var maxRight = me.width - rightMovement - me.drawingArea;
		var maxLeft = leftMovement + me.drawingArea;
		var maxTop = topMovement + me.drawingArea;
		var maxBottom = (me.height - me.paddingTop) - bottomMovement - me.drawingArea;

		me.xCenter = Math.floor(((maxLeft + maxRight) / 2) + me.left);
		me.yCenter = Math.floor(((maxTop + maxBottom) / 2) + me.top + me.paddingTop);
	},

	getIndexAngle: function(index) {
		var chart = this.chart;
		var angleMultiplier = 360 / chart.data.labels.length;
		var options = chart.options || {};
		var startAngle = options.startAngle || 0;

		// Start from the top instead of right, so remove a quarter of the circle
		var angle = (index * angleMultiplier + startAngle) % 360;

		return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
	},

	getDistanceFromCenterForValue: function(value) {
		var me = this;

		if (helpers$1.isNullOrUndef(value)) {
			return NaN;
		}

		// Take into account half font size + the yPadding of the top value
		var scalingFactor = me.drawingArea / (me.max - me.min);
		if (me.options.ticks.reverse) {
			return (me.max - value) * scalingFactor;
		}
		return (value - me.min) * scalingFactor;
	},

	getPointPosition: function(index, distanceFromCenter) {
		var me = this;
		var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
		return {
			x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
			y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
		};
	},

	getPointPositionForValue: function(index, value) {
		return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
	},

	getBasePosition: function(index) {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.getPointPositionForValue(index || 0,
			me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0);
	},

	/**
	 * @private
	 */
	_drawGrid: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;
		var gridLineOpts = opts.gridLines;
		var angleLineOpts = opts.angleLines;
		var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
		var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
		var i, offset, position;

		if (opts.pointLabels.display) {
			drawPointLabels(me);
		}

		if (gridLineOpts.display) {
			helpers$1.each(me.ticks, function(label, index) {
				if (index !== 0) {
					offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
					drawRadiusLine(me, gridLineOpts, offset, index);
				}
			});
		}

		if (angleLineOpts.display && lineWidth && lineColor) {
			ctx.save();
			ctx.lineWidth = lineWidth;
			ctx.strokeStyle = lineColor;
			if (ctx.setLineDash) {
				ctx.setLineDash(resolve$4([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
				ctx.lineDashOffset = resolve$4([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
			}

			for (i = me.chart.data.labels.length - 1; i >= 0; i--) {
				offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
				position = me.getPointPosition(i, offset);
				ctx.beginPath();
				ctx.moveTo(me.xCenter, me.yCenter);
				ctx.lineTo(position.x, position.y);
				ctx.stroke();
			}

			ctx.restore();
		}
	},

	/**
	 * @private
	 */
	_drawLabels: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;
		var tickOpts = opts.ticks;

		if (!tickOpts.display) {
			return;
		}

		var startAngle = me.getIndexAngle(0);
		var tickFont = helpers$1.options._parseFont(tickOpts);
		var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
		var offset, width;

		ctx.save();
		ctx.font = tickFont.string;
		ctx.translate(me.xCenter, me.yCenter);
		ctx.rotate(startAngle);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';

		helpers$1.each(me.ticks, function(label, index) {
			if (index === 0 && !tickOpts.reverse) {
				return;
			}

			offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);

			if (tickOpts.showLabelBackdrop) {
				width = ctx.measureText(label).width;
				ctx.fillStyle = tickOpts.backdropColor;

				ctx.fillRect(
					-width / 2 - tickOpts.backdropPaddingX,
					-offset - tickFont.size / 2 - tickOpts.backdropPaddingY,
					width + tickOpts.backdropPaddingX * 2,
					tickFont.size + tickOpts.backdropPaddingY * 2
				);
			}

			ctx.fillStyle = tickFontColor;
			ctx.fillText(label, 0, -offset);
		});

		ctx.restore();
	},

	/**
	 * @private
	 */
	_drawTitle: helpers$1.noop
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$3 = defaultConfig$3;
scale_radialLinear._defaults = _defaults$3;

var deprecated$1 = helpers$1._deprecated;
var resolve$5 = helpers$1.options.resolve;
var valueOrDefault$d = helpers$1.valueOrDefault;

// Integer constants are from the ES6 spec.
var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

var INTERVALS = {
	millisecond: {
		common: true,
		size: 1,
		steps: 1000
	},
	second: {
		common: true,
		size: 1000,
		steps: 60
	},
	minute: {
		common: true,
		size: 60000,
		steps: 60
	},
	hour: {
		common: true,
		size: 3600000,
		steps: 24
	},
	day: {
		common: true,
		size: 86400000,
		steps: 30
	},
	week: {
		common: false,
		size: 604800000,
		steps: 4
	},
	month: {
		common: true,
		size: 2.628e9,
		steps: 12
	},
	quarter: {
		common: false,
		size: 7.884e9,
		steps: 4
	},
	year: {
		common: true,
		size: 3.154e10
	}
};

var UNITS = Object.keys(INTERVALS);

function sorter(a, b) {
	return a - b;
}

function arrayUnique(items) {
	var hash = {};
	var out = [];
	var i, ilen, item;

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		item = items[i];
		if (!hash[item]) {
			hash[item] = true;
			out.push(item);
		}
	}

	return out;
}

function getMin(options) {
	return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
}

function getMax(options) {
	return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
}

/**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */
function buildLookupTable(timestamps, min, max, distribution) {
	if (distribution === 'linear' || !timestamps.length) {
		return [
			{time: min, pos: 0},
			{time: max, pos: 1}
		];
	}

	var table = [];
	var items = [min];
	var i, ilen, prev, curr, next;

	for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
		curr = timestamps[i];
		if (curr > min && curr < max) {
			items.push(curr);
		}
	}

	items.push(max);

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		next = items[i + 1];
		prev = items[i - 1];
		curr = items[i];

		// only add points that breaks the scale linearity
		if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
			table.push({time: curr, pos: i / (ilen - 1)});
		}
	}

	return table;
}

// @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
function lookup(table, key, value) {
	var lo = 0;
	var hi = table.length - 1;
	var mid, i0, i1;

	while (lo >= 0 && lo <= hi) {
		mid = (lo + hi) >> 1;
		i0 = table[mid - 1] || null;
		i1 = table[mid];

		if (!i0) {
			// given value is outside table (before first item)
			return {lo: null, hi: i1};
		} else if (i1[key] < value) {
			lo = mid + 1;
		} else if (i0[key] > value) {
			hi = mid - 1;
		} else {
			return {lo: i0, hi: i1};
		}
	}

	// given value is outside table (after last item)
	return {lo: i1, hi: null};
}

/**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */
function interpolate$1(table, skey, sval, tkey) {
	var range = lookup(table, skey, sval);

	// Note: the lookup table ALWAYS contains at least 2 items (min and max)
	var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
	var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;

	var span = next[skey] - prev[skey];
	var ratio = span ? (sval - prev[skey]) / span : 0;
	var offset = (next[tkey] - prev[tkey]) * ratio;

	return prev[tkey] + offset;
}

function toTimestamp(scale, input) {
	var adapter = scale._adapter;
	var options = scale.options.time;
	var parser = options.parser;
	var format = parser || options.format;
	var value = input;

	if (typeof parser === 'function') {
		value = parser(value);
	}

	// Only parse if its not a timestamp already
	if (!helpers$1.isFinite(value)) {
		value = typeof format === 'string'
			? adapter.parse(value, format)
			: adapter.parse(value);
	}

	if (value !== null) {
		return +value;
	}

	// Labels are in an incompatible format and no `parser` has been provided.
	// The user might still use the deprecated `format` option for parsing.
	if (!parser && typeof format === 'function') {
		value = format(input);

		// `format` could return something else than a timestamp, if so, parse it
		if (!helpers$1.isFinite(value)) {
			value = adapter.parse(value);
		}
	}

	return value;
}

function parse(scale, input) {
	if (helpers$1.isNullOrUndef(input)) {
		return null;
	}

	var options = scale.options.time;
	var value = toTimestamp(scale, scale.getRightValue(input));
	if (value === null) {
		return value;
	}

	if (options.round) {
		value = +scale._adapter.startOf(value, options.round);
	}

	return value;
}

/**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
	var ilen = UNITS.length;
	var i, interval, factor;

	for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
		interval = INTERVALS[UNITS[i]];
		factor = interval.steps ? interval.steps : MAX_INTEGER;

		if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
			return UNITS[i];
		}
	}

	return UNITS[ilen - 1];
}

/**
 * Figures out what unit to format a set of ticks with
 */
function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
	var i, unit;

	for (i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
		unit = UNITS[i];
		if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
			return unit;
		}
	}

	return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}

function determineMajorUnit(unit) {
	for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
		if (INTERVALS[UNITS[i]].common) {
			return UNITS[i];
		}
	}
}

/**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */
function generate(scale, min, max, capacity) {
	var adapter = scale._adapter;
	var options = scale.options;
	var timeOpts = options.time;
	var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
	var stepSize = resolve$5([timeOpts.stepSize, timeOpts.unitStepSize, 1]);
	var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
	var first = min;
	var ticks = [];
	var time;

	// For 'week' unit, handle the first day of week option
	if (weekday) {
		first = +adapter.startOf(first, 'isoWeek', weekday);
	}

	// Align first ticks on unit
	first = +adapter.startOf(first, weekday ? 'day' : minor);

	// Prevent browser from freezing in case user options request millions of milliseconds
	if (adapter.diff(max, min, minor) > 100000 * stepSize) {
		throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
	}

	for (time = first; time < max; time = +adapter.add(time, stepSize, minor)) {
		ticks.push(time);
	}

	if (time === max || options.bounds === 'ticks') {
		ticks.push(time);
	}

	return ticks;
}

/**
 * Returns the start and end offsets from edges in the form of {start, end}
 * where each value is a relative width to the scale and ranges between 0 and 1.
 * They add extra margins on the both sides by scaling down the original scale.
 * Offsets are added when the `offset` option is true.
 */
function computeOffsets(table, ticks, min, max, options) {
	var start = 0;
	var end = 0;
	var first, last;

	if (options.offset && ticks.length) {
		first = interpolate$1(table, 'time', ticks[0], 'pos');
		if (ticks.length === 1) {
			start = 1 - first;
		} else {
			start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
		}
		last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
		if (ticks.length === 1) {
			end = last;
		} else {
			end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
		}
	}

	return {start: start, end: end, factor: 1 / (start + 1 + end)};
}

function setMajorTicks(scale, ticks, map, majorUnit) {
	var adapter = scale._adapter;
	var first = +adapter.startOf(ticks[0].value, majorUnit);
	var last = ticks[ticks.length - 1].value;
	var major, index;

	for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
		index = map[major];
		if (index >= 0) {
			ticks[index].major = true;
		}
	}
	return ticks;
}

function ticksFromTimestamps(scale, values, majorUnit) {
	var ticks = [];
	var map = {};
	var ilen = values.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = values[i];
		map[value] = i;

		ticks.push({
			value: value,
			major: false
		});
	}

	// We set the major ticks separately from the above loop because calling startOf for every tick
	// is expensive when there is a large number of ticks
	return (ilen === 0 || !majorUnit) ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
}

var defaultConfig$4 = {
	position: 'bottom',

	/**
	 * Data distribution along the scale:
	 * - 'linear': data are spread according to their time (distances can vary),
	 * - 'series': data are spread at the same distance from each other.
	 * @see https://github.com/chartjs/Chart.js/pull/4507
	 * @since 2.7.0
	 */
	distribution: 'linear',

	/**
	 * Scale boundary strategy (bypassed by min/max time options)
	 * - `data`: make sure data are fully visible, ticks outside are removed
	 * - `ticks`: make sure ticks are fully visible, data outside are truncated
	 * @see https://github.com/chartjs/Chart.js/pull/4556
	 * @since 2.7.0
	 */
	bounds: 'data',

	adapters: {},
	time: {
		parser: false, // false == a pattern string from https://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
		unit: false, // false == automatic or override with week, month, year, etc.
		round: false, // none, or override with week, month, year, etc.
		displayFormat: false, // DEPRECATED
		isoWeekday: false, // override week start day - see https://momentjs.com/docs/#/get-set/iso-weekday/
		minUnit: 'millisecond',
		displayFormats: {}
	},
	ticks: {
		autoSkip: false,

		/**
		 * Ticks generation input values:
		 * - 'auto': generates "optimal" ticks based on scale size and time options.
		 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
		 * - 'labels': generates ticks from user given `data.labels` values ONLY.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		source: 'auto',

		major: {
			enabled: false
		}
	}
};

var scale_time = core_scale.extend({
	initialize: function() {
		this.mergeTicksOptions();
		core_scale.prototype.initialize.call(this);
	},

	update: function() {
		var me = this;
		var options = me.options;
		var time = options.time || (options.time = {});
		var adapter = me._adapter = new core_adapters._date(options.adapters.date);

		// DEPRECATIONS: output a message only one time per update
		deprecated$1('time scale', time.format, 'time.format', 'time.parser');
		deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
		deprecated$1('time scale', time.max, 'time.max', 'ticks.max');

		// Backward compatibility: before introducing adapter, `displayFormats` was
		// supposed to contain *all* unit/string pairs but this can't be resolved
		// when loading the scale (adapters are loaded afterward), so let's populate
		// missing formats on update
		helpers$1.mergeIf(time.displayFormats, adapter.formats());

		return core_scale.prototype.update.apply(me, arguments);
	},

	/**
	 * Allows data to be referenced via 't' attribute
	 */
	getRightValue: function(rawValue) {
		if (rawValue && rawValue.t !== undefined) {
			rawValue = rawValue.t;
		}
		return core_scale.prototype.getRightValue.call(this, rawValue);
	},

	determineDataLimits: function() {
		var me = this;
		var chart = me.chart;
		var adapter = me._adapter;
		var options = me.options;
		var unit = options.time.unit || 'day';
		var min = MAX_INTEGER;
		var max = MIN_INTEGER;
		var timestamps = [];
		var datasets = [];
		var labels = [];
		var i, j, ilen, jlen, data, timestamp, labelsAdded;
		var dataLabels = me._getLabels();

		for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
			labels.push(parse(me, dataLabels[i]));
		}

		for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
			if (chart.isDatasetVisible(i)) {
				data = chart.data.datasets[i].data;

				// Let's consider that all data have the same format.
				if (helpers$1.isObject(data[0])) {
					datasets[i] = [];

					for (j = 0, jlen = data.length; j < jlen; ++j) {
						timestamp = parse(me, data[j]);
						timestamps.push(timestamp);
						datasets[i][j] = timestamp;
					}
				} else {
					datasets[i] = labels.slice(0);
					if (!labelsAdded) {
						timestamps = timestamps.concat(labels);
						labelsAdded = true;
					}
				}
			} else {
				datasets[i] = [];
			}
		}

		if (labels.length) {
			min = Math.min(min, labels[0]);
			max = Math.max(max, labels[labels.length - 1]);
		}

		if (timestamps.length) {
			timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
			min = Math.min(min, timestamps[0]);
			max = Math.max(max, timestamps[timestamps.length - 1]);
		}

		min = parse(me, getMin(options)) || min;
		max = parse(me, getMax(options)) || max;

		// In case there is no valid min/max, set limits based on unit time option
		min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
		max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;

		// Make sure that max is strictly higher than min (required by the lookup table)
		me.min = Math.min(min, max);
		me.max = Math.max(min + 1, max);

		// PRIVATE
		me._table = [];
		me._timestamps = {
			data: timestamps,
			datasets: datasets,
			labels: labels
		};
	},

	buildTicks: function() {
		var me = this;
		var min = me.min;
		var max = me.max;
		var options = me.options;
		var tickOpts = options.ticks;
		var timeOpts = options.time;
		var timestamps = me._timestamps;
		var ticks = [];
		var capacity = me.getLabelCapacity(min);
		var source = tickOpts.source;
		var distribution = options.distribution;
		var i, ilen, timestamp;

		if (source === 'data' || (source === 'auto' && distribution === 'series')) {
			timestamps = timestamps.data;
		} else if (source === 'labels') {
			timestamps = timestamps.labels;
		} else {
			timestamps = generate(me, min, max, capacity);
		}

		if (options.bounds === 'ticks' && timestamps.length) {
			min = timestamps[0];
			max = timestamps[timestamps.length - 1];
		}

		// Enforce limits with user min/max options
		min = parse(me, getMin(options)) || min;
		max = parse(me, getMax(options)) || max;

		// Remove ticks outside the min/max range
		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			timestamp = timestamps[i];
			if (timestamp >= min && timestamp <= max) {
				ticks.push(timestamp);
			}
		}

		me.min = min;
		me.max = max;

		// PRIVATE
		// determineUnitForFormatting relies on the number of ticks so we don't use it when
		// autoSkip is enabled because we don't yet know what the final number of ticks will be
		me._unit = timeOpts.unit || (tickOpts.autoSkip
			? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity)
			: determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
		me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined
			: determineMajorUnit(me._unit);
		me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
		me._offsets = computeOffsets(me._table, ticks, min, max, options);

		if (tickOpts.reverse) {
			ticks.reverse();
		}

		return ticksFromTimestamps(me, ticks, me._majorUnit);
	},

	getLabelForIndex: function(index, datasetIndex) {
		var me = this;
		var adapter = me._adapter;
		var data = me.chart.data;
		var timeOpts = me.options.time;
		var label = data.labels && index < data.labels.length ? data.labels[index] : '';
		var value = data.datasets[datasetIndex].data[index];

		if (helpers$1.isObject(value)) {
			label = me.getRightValue(value);
		}
		if (timeOpts.tooltipFormat) {
			return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
		}
		if (typeof label === 'string') {
			return label;
		}
		return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
	},

	/**
	 * Function to format an individual tick mark
	 * @private
	 */
	tickFormatFunction: function(time, index, ticks, format) {
		var me = this;
		var adapter = me._adapter;
		var options = me.options;
		var formats = options.time.displayFormats;
		var minorFormat = formats[me._unit];
		var majorUnit = me._majorUnit;
		var majorFormat = formats[majorUnit];
		var tick = ticks[index];
		var tickOpts = options.ticks;
		var major = majorUnit && majorFormat && tick && tick.major;
		var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
		var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
		var formatter = resolve$5([
			nestedTickOpts.callback,
			nestedTickOpts.userCallback,
			tickOpts.callback,
			tickOpts.userCallback
		]);

		return formatter ? formatter(label, index, ticks) : label;
	},

	convertTicksToLabels: function(ticks) {
		var labels = [];
		var i, ilen;

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
		}

		return labels;
	},

	/**
	 * @private
	 */
	getPixelForOffset: function(time) {
		var me = this;
		var offsets = me._offsets;
		var pos = interpolate$1(me._table, 'time', time, 'pos');
		return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
	},

	getPixelForValue: function(value, index, datasetIndex) {
		var me = this;
		var time = null;

		if (index !== undefined && datasetIndex !== undefined) {
			time = me._timestamps.datasets[datasetIndex][index];
		}

		if (time === null) {
			time = parse(me, value);
		}

		if (time !== null) {
			return me.getPixelForOffset(time);
		}
	},

	getPixelForTick: function(index) {
		var ticks = this.getTicks();
		return index >= 0 && index < ticks.length ?
			this.getPixelForOffset(ticks[index].value) :
			null;
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var offsets = me._offsets;
		var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
		var time = interpolate$1(me._table, 'pos', pos, 'time');

		// DEPRECATION, we should return time directly
		return me._adapter._create(time);
	},

	/**
	 * @private
	 */
	_getLabelSize: function(label) {
		var me = this;
		var ticksOpts = me.options.ticks;
		var tickLabelWidth = me.ctx.measureText(label).width;
		var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
		var cosRotation = Math.cos(angle);
		var sinRotation = Math.sin(angle);
		var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);

		return {
			w: (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation),
			h: (tickLabelWidth * sinRotation) + (tickFontSize * cosRotation)
		};
	},

	/**
	 * Crude approximation of what the label width might be
	 * @private
	 */
	getLabelWidth: function(label) {
		return this._getLabelSize(label).w;
	},

	/**
	 * @private
	 */
	getLabelCapacity: function(exampleTime) {
		var me = this;
		var timeOpts = me.options.time;
		var displayFormats = timeOpts.displayFormats;

		// pick the longest format (milliseconds) for guestimation
		var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
		var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [exampleTime], me._majorUnit), format);
		var size = me._getLabelSize(exampleLabel);
		var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);

		if (me.options.offset) {
			capacity--;
		}

		return capacity > 0 ? capacity : 1;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$4 = defaultConfig$4;
scale_time._defaults = _defaults$4;

var scales = {
	category: scale_category,
	linear: scale_linear,
	logarithmic: scale_logarithmic,
	radialLinear: scale_radialLinear,
	time: scale_time
};

var FORMATS = {
	datetime: 'MMM D, YYYY, h:mm:ss a',
	millisecond: 'h:mm:ss.SSS a',
	second: 'h:mm:ss a',
	minute: 'h:mm a',
	hour: 'hA',
	day: 'MMM D',
	week: 'll',
	month: 'MMM YYYY',
	quarter: '[Q]Q - YYYY',
	year: 'YYYY'
};

core_adapters._date.override(typeof moment === 'function' ? {
	_id: 'moment', // DEBUG ONLY

	formats: function() {
		return FORMATS;
	},

	parse: function(value, format) {
		if (typeof value === 'string' && typeof format === 'string') {
			value = moment(value, format);
		} else if (!(value instanceof moment)) {
			value = moment(value);
		}
		return value.isValid() ? value.valueOf() : null;
	},

	format: function(time, format) {
		return moment(time).format(format);
	},

	add: function(time, amount, unit) {
		return moment(time).add(amount, unit).valueOf();
	},

	diff: function(max, min, unit) {
		return moment(max).diff(moment(min), unit);
	},

	startOf: function(time, unit, weekday) {
		time = moment(time);
		if (unit === 'isoWeek') {
			return time.isoWeekday(weekday).valueOf();
		}
		return time.startOf(unit).valueOf();
	},

	endOf: function(time, unit) {
		return moment(time).endOf(unit).valueOf();
	},

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility with scale.getValueForPixel().
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	_create: function(time) {
		return moment(time);
	},
} : {});

core_defaults._set('global', {
	plugins: {
		filler: {
			propagate: true
		}
	}
});

var mappers = {
	dataset: function(source) {
		var index = source.fill;
		var chart = source.chart;
		var meta = chart.getDatasetMeta(index);
		var visible = meta && chart.isDatasetVisible(index);
		var points = (visible && meta.dataset._children) || [];
		var length = points.length || 0;

		return !length ? null : function(point, i) {
			return (i < length && points[i]._view) || null;
		};
	},

	boundary: function(source) {
		var boundary = source.boundary;
		var x = boundary ? boundary.x : null;
		var y = boundary ? boundary.y : null;

		if (helpers$1.isArray(boundary)) {
			return function(point, i) {
				return boundary[i];
			};
		}

		return function(point) {
			return {
				x: x === null ? point.x : x,
				y: y === null ? point.y : y,
			};
		};
	}
};

// @todo if (fill[0] === '#')
function decodeFill(el, index, count) {
	var model = el._model || {};
	var fill = model.fill;
	var target;

	if (fill === undefined) {
		fill = !!model.backgroundColor;
	}

	if (fill === false || fill === null) {
		return false;
	}

	if (fill === true) {
		return 'origin';
	}

	target = parseFloat(fill, 10);
	if (isFinite(target) && Math.floor(target) === target) {
		if (fill[0] === '-' || fill[0] === '+') {
			target = index + target;
		}

		if (target === index || target < 0 || target >= count) {
			return false;
		}

		return target;
	}

	switch (fill) {
	// compatibility
	case 'bottom':
		return 'start';
	case 'top':
		return 'end';
	case 'zero':
		return 'origin';
	// supported boundaries
	case 'origin':
	case 'start':
	case 'end':
		return fill;
	// invalid fill values
	default:
		return false;
	}
}

function computeLinearBoundary(source) {
	var model = source.el._model || {};
	var scale = source.el._scale || {};
	var fill = source.fill;
	var target = null;
	var horizontal;

	if (isFinite(fill)) {
		return null;
	}

	// Backward compatibility: until v3, we still need to support boundary values set on
	// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
	// controllers might still use it (e.g. the Smith chart).

	if (fill === 'start') {
		target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
	} else if (fill === 'end') {
		target = model.scaleTop === undefined ? scale.top : model.scaleTop;
	} else if (model.scaleZero !== undefined) {
		target = model.scaleZero;
	} else if (scale.getBasePixel) {
		target = scale.getBasePixel();
	}

	if (target !== undefined && target !== null) {
		if (target.x !== undefined && target.y !== undefined) {
			return target;
		}

		if (helpers$1.isFinite(target)) {
			horizontal = scale.isHorizontal();
			return {
				x: horizontal ? target : null,
				y: horizontal ? null : target
			};
		}
	}

	return null;
}

function computeCircularBoundary(source) {
	var scale = source.el._scale;
	var options = scale.options;
	var length = scale.chart.data.labels.length;
	var fill = source.fill;
	var target = [];
	var start, end, center, i, point;

	if (!length) {
		return null;
	}

	start = options.ticks.reverse ? scale.max : scale.min;
	end = options.ticks.reverse ? scale.min : scale.max;
	center = scale.getPointPositionForValue(0, start);
	for (i = 0; i < length; ++i) {
		point = fill === 'start' || fill === 'end'
			? scale.getPointPositionForValue(i, fill === 'start' ? start : end)
			: scale.getBasePosition(i);
		if (options.gridLines.circular) {
			point.cx = center.x;
			point.cy = center.y;
			point.angle = scale.getIndexAngle(i) - Math.PI / 2;
		}
		target.push(point);
	}
	return target;
}

function computeBoundary(source) {
	var scale = source.el._scale || {};

	if (scale.getPointPositionForValue) {
		return computeCircularBoundary(source);
	}
	return computeLinearBoundary(source);
}

function resolveTarget(sources, index, propagate) {
	var source = sources[index];
	var fill = source.fill;
	var visited = [index];
	var target;

	if (!propagate) {
		return fill;
	}

	while (fill !== false && visited.indexOf(fill) === -1) {
		if (!isFinite(fill)) {
			return fill;
		}

		target = sources[fill];
		if (!target) {
			return false;
		}

		if (target.visible) {
			return fill;
		}

		visited.push(fill);
		fill = target.fill;
	}

	return false;
}

function createMapper(source) {
	var fill = source.fill;
	var type = 'dataset';

	if (fill === false) {
		return null;
	}

	if (!isFinite(fill)) {
		type = 'boundary';
	}

	return mappers[type](source);
}

function isDrawable(point) {
	return point && !point.skip;
}

function drawArea(ctx, curve0, curve1, len0, len1) {
	var i, cx, cy, r;

	if (!len0 || !len1) {
		return;
	}

	// building first area curve (normal)
	ctx.moveTo(curve0[0].x, curve0[0].y);
	for (i = 1; i < len0; ++i) {
		helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
	}

	if (curve1[0].angle !== undefined) {
		cx = curve1[0].cx;
		cy = curve1[0].cy;
		r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
		for (i = len1 - 1; i > 0; --i) {
			ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
		}
		return;
	}

	// joining the two area curves
	ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);

	// building opposite area curve (reverse)
	for (i = len1 - 1; i > 0; --i) {
		helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
	}
}

function doFill(ctx, points, mapper, view, color, loop) {
	var count = points.length;
	var span = view.spanGaps;
	var curve0 = [];
	var curve1 = [];
	var len0 = 0;
	var len1 = 0;
	var i, ilen, index, p0, p1, d0, d1, loopOffset;

	ctx.beginPath();

	for (i = 0, ilen = count; i < ilen; ++i) {
		index = i % count;
		p0 = points[index]._view;
		p1 = mapper(p0, index, view);
		d0 = isDrawable(p0);
		d1 = isDrawable(p1);

		if (loop && loopOffset === undefined && d0) {
			loopOffset = i + 1;
			ilen = count + loopOffset;
		}

		if (d0 && d1) {
			len0 = curve0.push(p0);
			len1 = curve1.push(p1);
		} else if (len0 && len1) {
			if (!span) {
				drawArea(ctx, curve0, curve1, len0, len1);
				len0 = len1 = 0;
				curve0 = [];
				curve1 = [];
			} else {
				if (d0) {
					curve0.push(p0);
				}
				if (d1) {
					curve1.push(p1);
				}
			}
		}
	}

	drawArea(ctx, curve0, curve1, len0, len1);

	ctx.closePath();
	ctx.fillStyle = color;
	ctx.fill();
}

var plugin_filler = {
	id: 'filler',

	afterDatasetsUpdate: function(chart, options) {
		var count = (chart.data.datasets || []).length;
		var propagate = options.propagate;
		var sources = [];
		var meta, i, el, source;

		for (i = 0; i < count; ++i) {
			meta = chart.getDatasetMeta(i);
			el = meta.dataset;
			source = null;

			if (el && el._model && el instanceof elements.Line) {
				source = {
					visible: chart.isDatasetVisible(i),
					fill: decodeFill(el, i, count),
					chart: chart,
					el: el
				};
			}

			meta.$filler = source;
			sources.push(source);
		}

		for (i = 0; i < count; ++i) {
			source = sources[i];
			if (!source) {
				continue;
			}

			source.fill = resolveTarget(sources, i, propagate);
			source.boundary = computeBoundary(source);
			source.mapper = createMapper(source);
		}
	},

	beforeDatasetsDraw: function(chart) {
		var metasets = chart._getSortedVisibleDatasetMetas();
		var ctx = chart.ctx;
		var meta, i, el, view, points, mapper, color;

		for (i = metasets.length - 1; i >= 0; --i) {
			meta = metasets[i].$filler;

			if (!meta || !meta.visible) {
				continue;
			}

			el = meta.el;
			view = el._view;
			points = el._children || [];
			mapper = meta.mapper;
			color = view.backgroundColor || core_defaults.global.defaultColor;

			if (mapper && color && points.length) {
				helpers$1.canvas.clipArea(ctx, chart.chartArea);
				doFill(ctx, points, mapper, view, color, el._loop);
				helpers$1.canvas.unclipArea(ctx);
			}
		}
	}
};

var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
var noop$1 = helpers$1.noop;
var valueOrDefault$e = helpers$1.valueOrDefault;

core_defaults._set('global', {
	legend: {
		display: true,
		position: 'top',
		align: 'center',
		fullWidth: true,
		reverse: false,
		weight: 1000,

		// a callback that will handle
		onClick: function(e, legendItem) {
			var index = legendItem.datasetIndex;
			var ci = this.chart;
			var meta = ci.getDatasetMeta(index);

			// See controller.isDatasetVisible comment
			meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

			// We hid a dataset ... rerender the chart
			ci.update();
		},

		onHover: null,
		onLeave: null,

		labels: {
			boxWidth: 40,
			padding: 10,
			// Generates labels shown in the legend
			// Valid properties to return:
			// text : text to display
			// fillStyle : fill of coloured box
			// strokeStyle: stroke of coloured box
			// hidden : if this legend item refers to a hidden item
			// lineCap : cap style for line
			// lineDash
			// lineDashOffset :
			// lineJoin :
			// lineWidth :
			generateLabels: function(chart) {
				var datasets = chart.data.datasets;
				var options = chart.options.legend || {};
				var usePointStyle = options.labels && options.labels.usePointStyle;

				return chart._getSortedDatasetMetas().map(function(meta) {
					var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);

					return {
						text: datasets[meta.index].label,
						fillStyle: style.backgroundColor,
						hidden: !chart.isDatasetVisible(meta.index),
						lineCap: style.borderCapStyle,
						lineDash: style.borderDash,
						lineDashOffset: style.borderDashOffset,
						lineJoin: style.borderJoinStyle,
						lineWidth: style.borderWidth,
						strokeStyle: style.borderColor,
						pointStyle: style.pointStyle,
						rotation: style.rotation,

						// Below is extra data used for toggling the datasets
						datasetIndex: meta.index
					};
				}, this);
			}
		}
	},

	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var datasets = chart.data.datasets;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');

		for (i = 0, ilen = datasets.length; i < ilen; i++) {
			listItem = list.appendChild(document.createElement('li'));
			listItemSpan = listItem.appendChild(document.createElement('span'));
			listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
			if (datasets[i].label) {
				listItem.appendChild(document.createTextNode(datasets[i].label));
			}
		}

		return list.outerHTML;
	}
});

/**
 * Helper function to get the box width based on the usePointStyle option
 * @param {object} labelopts - the label options on the legend
 * @param {number} fontSize - the label font size
 * @return {number} width of the color box area
 */
function getBoxWidth(labelOpts, fontSize) {
	return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ?
		fontSize :
		labelOpts.boxWidth;
}

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Legend = core_element.extend({

	initialize: function(config) {
		var me = this;
		helpers$1.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];

		/**
 		 * @private
 		 */
		me._hoveredItem = null;

		// Are we in doughnut mode which has a different data type
		me.doughnutMode = false;
	},

	// These methods are ordered by lifecycle. Utilities then follow.
	// Any function defined here is inherited by all legend types.
	// Any function can be extended by the legend type

	beforeUpdate: noop$1,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;
	},
	afterUpdate: noop$1,

	//

	beforeSetDimensions: noop$1,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop$1,

	//

	beforeBuildLabels: noop$1,
	buildLabels: function() {
		var me = this;
		var labelOpts = me.options.labels || {};
		var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];

		if (labelOpts.filter) {
			legendItems = legendItems.filter(function(item) {
				return labelOpts.filter(item, me.chart.data);
			});
		}

		if (me.options.reverse) {
			legendItems.reverse();
		}

		me.legendItems = legendItems;
	},
	afterBuildLabels: noop$1,

	//

	beforeFit: noop$1,
	fit: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var display = opts.display;

		var ctx = me.ctx;

		var labelFont = helpers$1.options._parseFont(labelOpts);
		var fontSize = labelFont.size;

		// Reset hit boxes
		var hitboxes = me.legendHitBoxes = [];

		var minSize = me.minSize;
		var isHorizontal = me.isHorizontal();

		if (isHorizontal) {
			minSize.width = me.maxWidth; // fill all the width
			minSize.height = display ? 10 : 0;
		} else {
			minSize.width = display ? 10 : 0;
			minSize.height = me.maxHeight; // fill all the height
		}

		// Increase sizes here
		if (!display) {
			me.width = minSize.width = me.height = minSize.height = 0;
			return;
		}
		ctx.font = labelFont.string;

		if (isHorizontal) {
			// Labels

			// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
			var lineWidths = me.lineWidths = [0];
			var totalHeight = 0;

			ctx.textAlign = 'left';
			ctx.textBaseline = 'middle';

			helpers$1.each(me.legendItems, function(legendItem, i) {
				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

				if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
					totalHeight += fontSize + labelOpts.padding;
					lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
				}

				// Store the hitbox width and height here. Final position will be updated in `draw`
				hitboxes[i] = {
					left: 0,
					top: 0,
					width: width,
					height: fontSize
				};

				lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
			});

			minSize.height += totalHeight;

		} else {
			var vPadding = labelOpts.padding;
			var columnWidths = me.columnWidths = [];
			var columnHeights = me.columnHeights = [];
			var totalWidth = labelOpts.padding;
			var currentColWidth = 0;
			var currentColHeight = 0;

			helpers$1.each(me.legendItems, function(legendItem, i) {
				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

				// If too tall, go to new column
				if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
					totalWidth += currentColWidth + labelOpts.padding;
					columnWidths.push(currentColWidth); // previous column width
					columnHeights.push(currentColHeight);
					currentColWidth = 0;
					currentColHeight = 0;
				}

				// Get max width
				currentColWidth = Math.max(currentColWidth, itemWidth);
				currentColHeight += fontSize + vPadding;

				// Store the hitbox width and height here. Final position will be updated in `draw`
				hitboxes[i] = {
					left: 0,
					top: 0,
					width: itemWidth,
					height: fontSize
				};
			});

			totalWidth += currentColWidth;
			columnWidths.push(currentColWidth);
			columnHeights.push(currentColHeight);
			minSize.width += totalWidth;
		}

		me.width = minSize.width;
		me.height = minSize.height;
	},
	afterFit: noop$1,

	// Shared Methods
	isHorizontal: function() {
		return this.options.position === 'top' || this.options.position === 'bottom';
	},

	// Actually draw the legend on the canvas
	draw: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var globalDefaults = core_defaults.global;
		var defaultColor = globalDefaults.defaultColor;
		var lineDefault = globalDefaults.elements.line;
		var legendHeight = me.height;
		var columnHeights = me.columnHeights;
		var legendWidth = me.width;
		var lineWidths = me.lineWidths;

		if (!opts.display) {
			return;
		}

		var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
		var ctx = me.ctx;
		var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
		var labelFont = helpers$1.options._parseFont(labelOpts);
		var fontSize = labelFont.size;
		var cursor;

		// Canvas setup
		ctx.textAlign = rtlHelper.textAlign('left');
		ctx.textBaseline = 'middle';
		ctx.lineWidth = 0.5;
		ctx.strokeStyle = fontColor; // for strikethrough effect
		ctx.fillStyle = fontColor; // render in correct colour
		ctx.font = labelFont.string;

		var boxWidth = getBoxWidth(labelOpts, fontSize);
		var hitboxes = me.legendHitBoxes;

		// current position
		var drawLegendBox = function(x, y, legendItem) {
			if (isNaN(boxWidth) || boxWidth <= 0) {
				return;
			}

			// Set the ctx for the box
			ctx.save();

			var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
			ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
			ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
			ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
			ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
			ctx.lineWidth = lineWidth;
			ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);

			if (ctx.setLineDash) {
				// IE 9 and 10 do not support line dash
				ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
			}

			if (labelOpts && labelOpts.usePointStyle) {
				// Recalculate x and y for drawPoint() because its expecting
				// x and y to be center of figure (instead of top left)
				var radius = boxWidth * Math.SQRT2 / 2;
				var centerX = rtlHelper.xPlus(x, boxWidth / 2);
				var centerY = y + fontSize / 2;

				// Draw pointStyle as legend symbol
				helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
			} else {
				// Draw box as legend symbol
				ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
				if (lineWidth !== 0) {
					ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
				}
			}

			ctx.restore();
		};

		var fillText = function(x, y, legendItem, textWidth) {
			var halfFontSize = fontSize / 2;
			var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
			var yMiddle = y + halfFontSize;

			ctx.fillText(legendItem.text, xLeft, yMiddle);

			if (legendItem.hidden) {
				// Strikethrough the text if hidden
				ctx.beginPath();
				ctx.lineWidth = 2;
				ctx.moveTo(xLeft, yMiddle);
				ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
				ctx.stroke();
			}
		};

		var alignmentOffset = function(dimension, blockSize) {
			switch (opts.align) {
			case 'start':
				return labelOpts.padding;
			case 'end':
				return dimension - blockSize;
			default: // center
				return (dimension - blockSize + labelOpts.padding) / 2;
			}
		};

		// Horizontal
		var isHorizontal = me.isHorizontal();
		if (isHorizontal) {
			cursor = {
				x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
				y: me.top + labelOpts.padding,
				line: 0
			};
		} else {
			cursor = {
				x: me.left + labelOpts.padding,
				y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
				line: 0
			};
		}

		helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);

		var itemHeight = fontSize + labelOpts.padding;
		helpers$1.each(me.legendItems, function(legendItem, i) {
			var textWidth = ctx.measureText(legendItem.text).width;
			var width = boxWidth + (fontSize / 2) + textWidth;
			var x = cursor.x;
			var y = cursor.y;

			rtlHelper.setWidth(me.minSize.width);

			// Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
			// instead of me.right and me.bottom because me.width and me.height
			// may have been changed since me.minSize was calculated
			if (isHorizontal) {
				if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
					y = cursor.y += itemHeight;
					cursor.line++;
					x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
				}
			} else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
				x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
				cursor.line++;
				y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
			}

			var realX = rtlHelper.x(x);

			drawLegendBox(realX, y, legendItem);

			hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
			hitboxes[i].top = y;

			// Fill the actual label
			fillText(realX, y, legendItem, textWidth);

			if (isHorizontal) {
				cursor.x += width + labelOpts.padding;
			} else {
				cursor.y += itemHeight;
			}
		});

		helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
	},

	/**
	 * @private
	 */
	_getLegendItemAt: function(x, y) {
		var me = this;
		var i, hitBox, lh;

		if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
			// See if we are touching one of the dataset boxes
			lh = me.legendHitBoxes;
			for (i = 0; i < lh.length; ++i) {
				hitBox = lh[i];

				if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
					// Touching an element
					return me.legendItems[i];
				}
			}
		}

		return null;
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 */
	handleEvent: function(e) {
		var me = this;
		var opts = me.options;
		var type = e.type === 'mouseup' ? 'click' : e.type;
		var hoveredItem;

		if (type === 'mousemove') {
			if (!opts.onHover && !opts.onLeave) {
				return;
			}
		} else if (type === 'click') {
			if (!opts.onClick) {
				return;
			}
		} else {
			return;
		}

		// Chart event already has relative position in it
		hoveredItem = me._getLegendItemAt(e.x, e.y);

		if (type === 'click') {
			if (hoveredItem && opts.onClick) {
				// use e.native for backwards compatibility
				opts.onClick.call(me, e.native, hoveredItem);
			}
		} else {
			if (opts.onLeave && hoveredItem !== me._hoveredItem) {
				if (me._hoveredItem) {
					opts.onLeave.call(me, e.native, me._hoveredItem);
				}
				me._hoveredItem = hoveredItem;
			}

			if (opts.onHover && hoveredItem) {
				// use e.native for backwards compatibility
				opts.onHover.call(me, e.native, hoveredItem);
			}
		}
	}
});

function createNewLegendAndAttach(chart, legendOpts) {
	var legend = new Legend({
		ctx: chart.ctx,
		options: legendOpts,
		chart: chart
	});

	core_layouts.configure(chart, legend, legendOpts);
	core_layouts.addBox(chart, legend);
	chart.legend = legend;
}

var plugin_legend = {
	id: 'legend',

	/**
	 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
	 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Legend,

	beforeInit: function(chart) {
		var legendOpts = chart.options.legend;

		if (legendOpts) {
			createNewLegendAndAttach(chart, legendOpts);
		}
	},

	beforeUpdate: function(chart) {
		var legendOpts = chart.options.legend;
		var legend = chart.legend;

		if (legendOpts) {
			helpers$1.mergeIf(legendOpts, core_defaults.global.legend);

			if (legend) {
				core_layouts.configure(chart, legend, legendOpts);
				legend.options = legendOpts;
			} else {
				createNewLegendAndAttach(chart, legendOpts);
			}
		} else if (legend) {
			core_layouts.removeBox(chart, legend);
			delete chart.legend;
		}
	},

	afterEvent: function(chart, e) {
		var legend = chart.legend;
		if (legend) {
			legend.handleEvent(e);
		}
	}
};

var noop$2 = helpers$1.noop;

core_defaults._set('global', {
	title: {
		display: false,
		fontStyle: 'bold',
		fullWidth: true,
		padding: 10,
		position: 'top',
		text: '',
		weight: 2000         // by default greater than legend (1000) to be above
	}
});

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Title = core_element.extend({
	initialize: function(config) {
		var me = this;
		helpers$1.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];
	},

	// These methods are ordered by lifecycle. Utilities then follow.

	beforeUpdate: noop$2,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;

	},
	afterUpdate: noop$2,

	//

	beforeSetDimensions: noop$2,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop$2,

	//

	beforeBuildLabels: noop$2,
	buildLabels: noop$2,
	afterBuildLabels: noop$2,

	//

	beforeFit: noop$2,
	fit: function() {
		var me = this;
		var opts = me.options;
		var minSize = me.minSize = {};
		var isHorizontal = me.isHorizontal();
		var lineCount, textSize;

		if (!opts.display) {
			me.width = minSize.width = me.height = minSize.height = 0;
			return;
		}

		lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
		textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;

		me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
		me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
	},
	afterFit: noop$2,

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},

	// Actually draw the title block on the canvas
	draw: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;

		if (!opts.display) {
			return;
		}

		var fontOpts = helpers$1.options._parseFont(opts);
		var lineHeight = fontOpts.lineHeight;
		var offset = lineHeight / 2 + opts.padding;
		var rotation = 0;
		var top = me.top;
		var left = me.left;
		var bottom = me.bottom;
		var right = me.right;
		var maxWidth, titleX, titleY;

		ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
		ctx.font = fontOpts.string;

		// Horizontal
		if (me.isHorizontal()) {
			titleX = left + ((right - left) / 2); // midpoint of the width
			titleY = top + offset;
			maxWidth = right - left;
		} else {
			titleX = opts.position === 'left' ? left + offset : right - offset;
			titleY = top + ((bottom - top) / 2);
			maxWidth = bottom - top;
			rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
		}

		ctx.save();
		ctx.translate(titleX, titleY);
		ctx.rotate(rotation);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';

		var text = opts.text;
		if (helpers$1.isArray(text)) {
			var y = 0;
			for (var i = 0; i < text.length; ++i) {
				ctx.fillText(text[i], 0, y, maxWidth);
				y += lineHeight;
			}
		} else {
			ctx.fillText(text, 0, 0, maxWidth);
		}

		ctx.restore();
	}
});

function createNewTitleBlockAndAttach(chart, titleOpts) {
	var title = new Title({
		ctx: chart.ctx,
		options: titleOpts,
		chart: chart
	});

	core_layouts.configure(chart, title, titleOpts);
	core_layouts.addBox(chart, title);
	chart.titleBlock = title;
}

var plugin_title = {
	id: 'title',

	/**
	 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
	 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Title,

	beforeInit: function(chart) {
		var titleOpts = chart.options.title;

		if (titleOpts) {
			createNewTitleBlockAndAttach(chart, titleOpts);
		}
	},

	beforeUpdate: function(chart) {
		var titleOpts = chart.options.title;
		var titleBlock = chart.titleBlock;

		if (titleOpts) {
			helpers$1.mergeIf(titleOpts, core_defaults.global.title);

			if (titleBlock) {
				core_layouts.configure(chart, titleBlock, titleOpts);
				titleBlock.options = titleOpts;
			} else {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		} else if (titleBlock) {
			core_layouts.removeBox(chart, titleBlock);
			delete chart.titleBlock;
		}
	}
};

var plugins = {};
var filler = plugin_filler;
var legend = plugin_legend;
var title = plugin_title;
plugins.filler = filler;
plugins.legend = legend;
plugins.title = title;

/**
 * @namespace Chart
 */


core_controller.helpers = helpers$1;

// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
core_helpers();

core_controller._adapters = core_adapters;
core_controller.Animation = core_animation;
core_controller.animationService = core_animations;
core_controller.controllers = controllers;
core_controller.DatasetController = core_datasetController;
core_controller.defaults = core_defaults;
core_controller.Element = core_element;
core_controller.elements = elements;
core_controller.Interaction = core_interaction;
core_controller.layouts = core_layouts;
core_controller.platform = platform;
core_controller.plugins = core_plugins;
core_controller.Scale = core_scale;
core_controller.scaleService = core_scaleService;
core_controller.Ticks = core_ticks;
core_controller.Tooltip = core_tooltip;

// Register built-in scales

core_controller.helpers.each(scales, function(scale, type) {
	core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
});

// Load to register built-in adapters (as side effects)


// Loading built-in plugins

for (var k in plugins) {
	if (plugins.hasOwnProperty(k)) {
		core_controller.plugins.register(plugins[k]);
	}
}

core_controller.platform.initialize();

var src = core_controller;
if (typeof window !== 'undefined') {
	window.Chart = core_controller;
}

// DEPRECATIONS

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Chart
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
core_controller.Chart = core_controller;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Legend
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.Legend = plugins.legend._element;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Title
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.Title = plugins.title._element;

/**
 * Provided for backward compatibility, use Chart.plugins instead
 * @namespace Chart.pluginService
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.pluginService = core_controller.plugins;

/**
 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
 * effect, instead simply create/register plugins via plain JavaScript objects.
 * @interface Chart.PluginBase
 * @deprecated since version 2.5.0
 * @todo remove at version 3
 * @private
 */
core_controller.PluginBase = core_controller.Element.extend({});

/**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
core_controller.canvasHelpers = core_controller.helpers.canvas;

/**
 * Provided for backward compatibility, use Chart.layouts instead.
 * @namespace Chart.layoutService
 * @deprecated since version 2.7.3
 * @todo remove at version 3
 * @private
 */
core_controller.layoutService = core_controller.layouts;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.LinearScaleBase
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */
core_controller.LinearScaleBase = scale_linearbase;

/**
 * Provided for backward compatibility, instead we should create a new Chart
 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 */
core_controller.helpers.each(
	[
		'Bar',
		'Bubble',
		'Doughnut',
		'Line',
		'PolarArea',
		'Radar',
		'Scatter'
	],
	function(klass) {
		core_controller[klass] = function(ctx, cfg) {
			return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
				type: klass.charAt(0).toLowerCase() + klass.slice(1)
			}));
		};
	}
);

return src;

})));


/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "slide-down",

    props: ['name', 'value', 'items', 'selectedValue', 'selectText', 'dataField', 'textField'],

    data: function data() {
        return {
            dropDownOpen: false,
            dropItems: [],
            selectedItem: null
        };
    },


    watch: {
        items: function items() {
            this.setItems();
        }
    },

    methods: {
        calculateSelecteditem: function calculateSelecteditem() {
            var vm = this;

            if (this.dropItems === undefined) {
                vm.selectedItem = null;
            } else {
                var selected = this.dropItems.filter(function (item) {
                    return item.Selected === true;
                });
                //console.info('calculateSelecteditem -> selected', selected);

                vm.selectedItem = selected.length ? selected[0] : null;
            }
        },
        onSelect: function onSelect(item) {
            var vm = this;
            for (var i = 0; i < this.dropItems.length; i++) {
                var el = this.dropItems[i];
                el.Selected = el[vm.dataField] === item[vm.dataField];
                vm.$set(vm.dropItems, i, el);
            }
            this.dropDownOpen = false;
            this.calculateSelecteditem();

            this.$emit('input', item[vm.dataField]);
            this.$emit('change', item);
        },
        setItems: function setItems() {
            var vm = this;
            this.dropItems = [];

            if (this.withSelectItem === 'true') {
                var selectItem = {};
                selectItem[vm.dataField] = '';
                selectItem[vm.textField] = 'Выбрать';
                this.dropItems.splice(0, 0, selectItem);
            }

            if (this.items !== undefined) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = this.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var item = _step.value;

                        this.dropItems.push(Object.assign({}, item));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                var selectId = vm.selectedValue || vm.value;
                //console.info('mounted, selectId', selectId);
                if (selectId != null) {
                    for (var i = 0; i < vm.dropItems.length; i++) {
                        var el = vm.dropItems[i];
                        if (el[vm.dataField] === selectId) {
                            //console.info('found el.Value', el.Value)
                            el.Selected = true;
                            vm.$set(vm.dropItems, i, el);
                        }
                    }
                } else if (vm.dropItems.length) {
                    // vm.dropItems[0].Selected = true;
                    // this.$emit('input', vm.dropItems[0][vm.dataField]);
                }

                this.calculateSelecteditem();
            }
        }
    },

    mounted: function mounted() {
        var vm = this;

        this.setItems();

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).on('click', function () {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('tabindex', 1).focus();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).toggleClass('active');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('.slidedown-menu').slideToggle(300);
        });
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).on('focusout', function () {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeClass('active');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('.slidedown-menu').slideUp(300);
        });
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).on('click', '.slidedown-menu li', function () {
            var val = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('id');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parents('.slidedown').find('span').text(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).text());
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parents('.slidedown').find('input').attr('value', val);

            var item = vm.dropItems.find(function (x) {
                return x[vm.dataField] == val;
            });
            vm.$emit('input', val);
            vm.$emit('change', item);
        });
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).off('click');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).off('focusout');
    },
    updated: function updated() {
        if (this.value !== undefined) {
            var vm = this;
            var val = this.value;
            for (var i = 0; i < this.dropItems.length; i++) {
                var el = this.dropItems[i];
                el.Selected = el[vm.dataField] == val;
            }
            this.calculateSelecteditem();
        }
    }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_project_mixin__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_faq_svg_svg__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_faq_svg_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__img_faq_svg_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_smooth_dnd__ = __webpack_require__(56);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var backendApi = new __WEBPACK_IMPORTED_MODULE_1__backendApi__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "faq-component",

    props: ['name', 'value', 'info'],

    mixins: [__WEBPACK_IMPORTED_MODULE_2__helpers_project_mixin__["a" /* default */]],

    components: { Container: __WEBPACK_IMPORTED_MODULE_4_vue_smooth_dnd__["a" /* Container */], Draggable: __WEBPACK_IMPORTED_MODULE_4_vue_smooth_dnd__["b" /* Draggable */] },

    data: function data() {
        return {
            origin: [],
            editItems: [],
            icons: ['Calendar', 'Chat', 'CreditCard', 'Edit', 'Eye', 'File2', 'Flag', 'Folder1', 'IdCard', 'Idea', 'Image', 'Inbox', 'Key', 'Money', 'PhoneCall', 'Reload', 'Settings', 'Trophy', 'User']
        };
    },


    computed: {
        editItemsOrdered: function editItemsOrdered() {
            return _.orderBy(this.editItems, 'itemOrder');
        },

        editItemsStr: function editItemsStr() {
            if (this.editItems) {
                var temp = JSON.parse(JSON.stringify(_.orderBy(this.editItems, 'itemOrder')));
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = temp[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var s = _step.value;

                        delete s.editing;
                        delete s.expanded;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return JSON.stringify(temp);
            } else return null;
        },
        lockAxis: function lockAxis() {
            return this.info.User.MainRole === 'administrators' || this.hasClaims(this.info.User.DynamicRole, this.claimEnums.faqEdit) ? 'y' : '1';
        }
    },

    watch: {
        value: function value(newVal) {
            //console.info('watch -> value');
            this.assignItems(newVal);
        }
    },

    methods: {
        onIconSelect: function onIconSelect(i, icon) {
            this.editItems[i].svgName = this.editItems[i].svgName === icon ? null : icon;
            this.$set(this.editItems, i, this.editItems[i]);
        },
        onItemSelect: function onItemSelect(item) {
            var flag = !item.expanded;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = this.editItems[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var i = _step2.value;

                    i.expanded = false;
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            item.expanded = flag;
        },
        onItemEdit: function onItemEdit(item, i) {
            this.itemCancelEditing();

            this.editItems[i].editing = true;
        },
        itemCancelEditing: function itemCancelEditing() {
            this.editItems = [];
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = this.origin[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var i = _step3.value;

                    this.editItems.push(Object.assign({}, i));
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        },
        deleteItem: function deleteItem(item, i) {
            if (confirm('Удалить этот вопрос?')) {
                this.editItems.splice(i, 1);
                this.save(item);
            }
        },
        save: function save(item) {
            var vm = this;
            this.$validator.validate().then(function (result) {
                if (!result) {
                    __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__["a" /* default */].toastr.error('Проверьте введённые данные');
                } else {
                    item.editing = false;
                    item.expanded = false;

                    var faqJson = vm.editItemsStr;
                    //console.info('faqJson', faqJson)

                    //let selectedProjectId = localStorage.getItem('selectedProjectId');
                    vm.callApiWrapper(backendApi.projectInfoSave({
                        projectId: vm.projectId,
                        faq: faqJson
                    })).then(function (resp) {
                        if (resp.hasError) {
                            __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__["a" /* default */].toastr.error('Ошибка при сохранении');
                        } else {
                            vm.origin = [];
                            var _iteratorNormalCompletion4 = true;
                            var _didIteratorError4 = false;
                            var _iteratorError4 = undefined;

                            try {
                                for (var _iterator4 = vm.editItems[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                    var i = _step4.value;

                                    vm.origin.push(Object.assign({}, i));
                                }
                            } catch (err) {
                                _didIteratorError4 = true;
                                _iteratorError4 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                        _iterator4.return();
                                    }
                                } finally {
                                    if (_didIteratorError4) {
                                        throw _iteratorError4;
                                    }
                                }
                            }

                            vm.$emit('input', faqJson);
                            __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__["a" /* default */].toastr.success('Успешно сохранено');
                        }
                    });
                }
            });
        },
        add: function add() {
            this.itemCancelEditing();

            var newOrder = 1;
            this.editItems.forEach(function (x) {
                if (x.itemOrder != undefined && x.itemOrder > newOrder) {
                    newOrder = x.itemOrder + 1;
                }
            });
            var item = { title: 'Новый вопрос', body: '', expanded: false, editing: true, svgName: null, itemOrder: newOrder };
            this.editItems.push(item);
            this.origin.push(Object.assign({}, item));
        },
        onProjectChange: function onProjectChange(item) {
            this.projectId = item.Id;
            this.$emit('projectChange');
        },
        assignItems: function assignItems(data) {
            var vm = this;

            if (data) {
                var items = JSON.parse(data);
                vm.editItems = [];
                var order = 1;
                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                    for (var _iterator5 = items[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                        var i = _step5.value;

                        i.expanded = false;
                        i.editing = false;
                        i.itemOrder = order++;
                        vm.editItems.push(Object.assign({}, i));
                    }
                } catch (err) {
                    _didIteratorError5 = true;
                    _iteratorError5 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                            _iterator5.return();
                        }
                    } finally {
                        if (_didIteratorError5) {
                            throw _iteratorError5;
                        }
                    }
                }

                vm.origin = items;
            } else {
                vm.editItems = [];
                vm.origin = [];
            }
        },
        onFieldSettingsDrop: function onFieldSettingsDrop(dropResult) {
            var vm = this;

            if (dropResult.removedIndex === dropResult.addedIndex) {
                return;
            }

            var temp = _.orderBy(vm.editItems, 'itemOrder');
            var itemToAdd = void 0;
            if (dropResult.removedIndex != null) {
                itemToAdd = temp.splice(dropResult.removedIndex, 1)[0];
            }
            if (dropResult.addedIndex !== null) {
                temp.splice(dropResult.addedIndex, 0, itemToAdd);
            }

            var order = 1;
            temp.forEach(function (x) {
                x.itemOrder = order++;
            });

            vm.editItems = temp;
            vm.save(itemToAdd);
        }
    },

    mounted: function mounted() {
        var vm = this;

        vm.assignItems(vm.value);
    }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "first-launch",

    props: ['firstLaunchItems'],

    data: function data() {
        return {
            currentAction: null,
            index: 0
        };
    },


    methods: {
        showNextAction: function showNextAction() {
            this.currentAction = this.firstLaunchItems[this.index];
            if (this.currentAction.ActionTypeId === 1) {
                this.$refs['ppModal'].show();
                this.setPdfContent(this.currentAction.FileName);
            }
        },
        setPdfContent: function setPdfContent(fileName) {
            var vm = this;

            vm.$nextTick(function () {
                vm.$refs.ppContent.innerHTML = '<object type="application/pdf" data="' + fileName + '" width="100%" height="100%">' + '<p>Ваш браузер не может открыть PDF. Возможно у Вас отсутствует Adobe Reader или браузер не поддерживает просмотр PDF. <a :href="' + fileName + '">Нажмите здесь, чтобы скачать</a></p>' + '</object>';
            });
        },


        // клик по закрытию текущего окна
        onActionClose: function onActionClose() {
            if (this.firstLaunchItems.length - 1 > this.index) {
                this.index++;
                this.showNextAction();
            } else {
                // все окна просмотрены
                this.$refs['ppModal'].close();
                this.$emit('actions-complete');
            }
        }
    },

    mounted: function mounted() {
        var vm = this;

        if (vm.firstLaunchItems && vm.firstLaunchItems.length) {

            vm.showNextAction();
        }
    }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "domain-folder",

    props: ['folder', 'folderPath', 'parentFolders'],

    data: function data() {
        return {
            file: null,
            imgSitePath: null,
            imgSite: {
                ImageStyle: this.folder.ImageStyle,
                ImagePath: this.folder.Image,
                Image: {}
            },
            imgMobilePath: null,
            imgMobile: {
                ImageStyle: this.folder.ImageStyleMobile,
                ImagePath: this.folder.ImageMobilePath,
                Image: {}
            }
        };
    },


    computed: {
        imageStyleFormatted: function imageStyleFormatted() {
            var settings = {
                left: this.imgSite.ImageStyle.left + '%',
                top: this.imgSite.ImageStyle.top + '%',
                transform: 'translateY(' + this.imgSite.ImageStyle.translateY + '%) translateX(' + this.imgSite.ImageStyle.translateX + '%)'
            };
            if (this.imgSite.ImageStyle.resizeType === 1 && parseInt(this.imgSite.ImageStyle.size)) {
                settings.height = this.imgSite.ImageStyle.size + '%';
            }
            if (this.imgSite.ImageStyle.resizeType === 2 && parseInt(this.imgSite.ImageStyle.size)) {
                settings.width = this.imgSite.ImageStyle.size + '%';
            }

            return settings;
        },
        imageStyleMobileFormatted: function imageStyleMobileFormatted() {
            var settings = {
                left: this.imgMobile.ImageStyle.left + '%',
                top: this.imgMobile.ImageStyle.top + '%',
                transform: 'translateY(' + this.imgMobile.ImageStyle.translateY + '%) translateX(' + this.imgMobile.ImageStyle.translateX + '%)'
            };
            if (this.imgMobile.ImageStyle.resizeType === 1 && parseInt(this.imgMobile.ImageStyle.size)) {
                settings.height = this.imgMobile.ImageStyle.size + '%';
            }
            if (this.imgMobile.ImageStyle.resizeType === 2 && parseInt(this.imgMobile.ImageStyle.size)) {
                settings.width = this.imgMobile.ImageStyle.size + '%';
            }

            return settings;
        }
    },

    methods: {
        onImageViewChanged: function onImageViewChanged(imgPath, name) {
            if (name === 'site') this.imgSitePath = imgPath;else this.imgMobilePath = imgPath;
            this.$emit('update', this.imgSite, this.imgMobile);
        },
        onImageStyleParamsChanged: function onImageStyleParamsChanged(imageStyle, name) {
            this.$emit('update', this.imgSite, this.imgMobile);
        }
    },

    mounted: function mounted() {
        var vm = this;
        vm.folder.ImageMobile = {};
        vm.imgMobile = {
            ImageStyle: vm.folder.ImageStyleMobile,
            ImagePath: vm.folder.ImageMobilePath,
            Image: {}
        };
        vm.imgSite = {
            ImageStyle: vm.folder.ImageStyle,
            ImagePath: vm.folder.Image,
            Image: {}
        };
    },
    destroyed: function destroyed() {}
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_BootstrapTimepicker_bootstrap_timepicker__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_BootstrapTimepicker_bootstrap_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_BootstrapTimepicker_bootstrap_timepicker__);
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "input-time",
    props: ['name', 'value', 'showSeconds', 'maxHours'],

    data: function data() {
        return {};
    },


    methods: {
        updateDate: function updateDate() {
            this.$emit('input', this.$refs.timeInput.value);
        },
        setTime: function setTime(time) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).timepicker('setTime', time);
        }
    },

    mounted: function mounted() {
        var _this = this;

        var that = this;
        this.$nextTick(function () {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(_this.$el).timepicker({
                defaultTime: false,
                showMeridian: false,
                maxHours: _this.maxHours,
                minuteStep: 1,
                icons: {
                    up: 'timepicker-icon-up',
                    down: 'timepicker-icon-down'
                },
                showSeconds: _this.showSeconds
            }).on('changeTime.timepicker', function () {
                that.updateDate();
            });
        });
    }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(9);
//
//
//
//
//
//



var defaultStrokeColor = 'green';
var margin = 30;

function setpixelated(context) {
    context['imageSmoothingEnabled'] = false; /* standard */
    context['mozImageSmoothingEnabled'] = false; /* Firefox */
    context['oImageSmoothingEnabled'] = false; /* Opera */
    context['webkitImageSmoothingEnabled'] = false; /* Safari */
    context['msImageSmoothingEnabled'] = false; /* IE */
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "counter",

    props: ['name', 'value', 'max', 'color', 'type', 'legend', 'compact'],

    data: function data() {
        return {};
    },


    watch: {
        value: function value(newValue, oldValue) {

            if (this.value < 0 || this.value > this.max) {
                return;
            }

            this.draw();
        }
    },

    methods: {
        draw: function draw() {
            var c = document.getElementsByName(this.name)[0];
            var ctx = c.getContext('2d');

            if (this.compact === true) {
                c.height = 30;
            } else {
                c.height = c.width + margin;
            }

            // заливка белым
            ctx.fillStyle = '#fff';
            ctx.fillRect(0, 0, c.width, c.height);

            var dx = this.value / this.max;

            if (this.compact === true) {
                // ctx.beginPath();
                // ctx.rect(margin/2, 20, c.width - margin, margin);
                // ctx.lineWidth = 0;
                // ctx.strokeStyle = '#FFF';
                // ctx.stroke();

                ctx.beginPath();
                ctx.rect(margin / 2, 10, c.width * dx - margin, margin);
                ctx.lineWidth = 2;
                ctx.strokeStyle = this.color;
                ctx.fillStyle = this.color;
                ctx.stroke();
                ctx.fill();

                this.drawValue();
            } else {
                var minSize = Math.min(c.width, c.height);
                var x = c.width / 2,
                    y = c.height / 2,
                    radius = minSize / 2 - margin;

                // основной контур
                ctx.beginPath();
                ctx.arc(x, y, radius, -1.5 * Math.PI, 1.5 * Math.PI);
                ctx.lineWidth = 2;
                ctx.strokeStyle = '#eaebf0';
                ctx.stroke();

                // подсвеченный
                var dxPI = dx * Math.PI * 2.0;
                var endAngle = 1.5 * Math.PI + dxPI;

                ctx.beginPath();
                ctx.arc(x, y, radius, 1.5 * Math.PI, endAngle);
                ctx.strokeStyle = this.color || defaultStrokeColor;
                ctx.stroke();

                // выводим значение
                this.drawValue();

                // подписи под счётчиком
                this.drawLegend();
            }
        },
        drawLegend: function drawLegend() {
            var c = document.getElementsByName(this.name)[0];
            var ctx = c.getContext('2d', { alpha: false });
            setpixelated(ctx);

            ctx.font = "18px Segoe UI";
            ctx.fillStyle = '#728a9a';
            ctx.textAlign = 'center';
            ctx.fillText(this.legend, c.width / 2, c.height - 10);
        },
        drawValue: function drawValue() {
            var c = document.getElementsByName(this.name)[0];
            var ctx = c.getContext('2d');

            ctx.font = "22px Segoe UI";
            ctx.fillStyle = '#000';
            ctx.textAlign = 'center';
            var x = c.width / 2;

            if (this.compact === true) {
                ctx.textAlign = 'left';
                x = margin;
                ctx.font = "12px Segoe UI";
            }

            ctx.fillText(this.getValueToDisplay(), x, c.height / 2 + 8);
        },
        getValueToDisplay: function getValueToDisplay() {
            var valueToDisplay = '';
            if (this.value === 0) {
                valueToDisplay = '0';
            } else {
                if (this.type === 'time') {

                    var d1 = new Date();
                    var d2 = new Date();
                    d2.setSeconds(d2.getSeconds() + this.value);

                    var diff = __WEBPACK_IMPORTED_MODULE_0_moment__["default"].duration(d2 - d1);

                    var m = diff.minutes(),
                        s = diff.seconds();

                    valueToDisplay = (m >= 10 ? m : '0' + m) + ':' + (s >= 10 ? s : '0' + s);
                } else {
                    valueToDisplay = this.value.toFixed(0);
                }
            }

            if (this.compact === true) {
                valueToDisplay = this.legend + ': ' + valueToDisplay;
            }

            return valueToDisplay;
        }
    },

    mounted: function mounted() {
        this.draw();
    }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pdfjs_dist_webpack__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pdfjs_dist_webpack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pdfjs_dist_webpack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//pdfjs.GlobalWorkerOptions.workerSrc = "../../../node_modules/pdfjs-dist/build/pdf.worker.js";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: "pdf-viewer",

    props: ['title'],

    data: function data() {
        return {
            src: null,
            pdfDoc: null,
            numPages: null,
            currentPage: null,
            visible: false,
            isMobile: __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].check_mobile(),
            pageSwitch: false,
            progress: 0,
            isRendering: false,
            maxPage: null,
            inFullMode: false
        };
    },


    watch: {
        currentPage: function currentPage(newVal) {
            this.$emit('onPageChanged', newVal);

            this.progress = this.currentPage / this.numPages;
        }
    },

    methods: {
        show: function show(url, page, progressPage) {
            var vm = this;
            if (progressPage) {
                this.maxPage = progressPage;
            }

            vm.visible = true;
            vm.src = url;
            vm.loadPdf(page);
        },
        goToPage: function goToPage(page) {
            if (page > 0 && page <= this.numPages) {

                this.renderPage(page);
            }
        },
        toggleFullScreen: function toggleFullScreen() {
            var vm = this;

            var req = void 0;
            if (vm.inFullMode) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                var elem = document.getElementsByName("ppPdfView")[0];
                req = elem.requestFullScreen || elem.webkitRequestFullScreen || elem.mozRequestFullScreen || elem.webkitEnterFullScreen;
                req.call(elem);
            }
        },
        loadPdf: function loadPdf(page) {
            var vm = this;

            this.$nextTick(function () {
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].blockUI('.material-body-content', null, {
                    overlayCSS: {
                        opacity: 1, backgroundColor: '#FFF!important'
                    }
                });
            });

            var loadingTask = __WEBPACK_IMPORTED_MODULE_0_pdfjs_dist_webpack___default.a.getDocument(vm.src);
            loadingTask.promise.then(function (pdf) {
                //console.log('PDF loaded');
                vm.pdfDoc = pdf;
                vm.numPages = pdf.numPages;

                // if (vm.maxPage && !isNaN(vm.maxPage)) {
                //     vm.progress = parseInt(vm.maxPage) / vm.numPages;
                // }

                vm.renderPage(page || 1);
                $('#PlayerContent').css('visibility', 'visible');
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.material-body-content');
            }, function (reason) {
                // PDF loading error
                //console.error(reason);
                __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].unblockUI('.player');
            });
        },
        renderPage: function renderPage(pageNumber) {
            var vm = this;
            if (!vm.pdfDoc || vm.isRendering) {
                return;
            }

            vm.isRendering = true;
            vm.pdfDoc.getPage(pageNumber).then(function (page) {
                //console.log('Page loaded');

                var $popupBody = $('[name=ppPdfView]'); // контейнер для отображения пдф
                var cWidth = $popupBody.width(),
                    cHeight = $popupBody.height();

                var scale = void 0; // масштаб листа пдф, считаем в зависимости от ширины/высоты контейнера для отображения
                scale = Math.min((cHeight - 50) / page.getViewport(1.0).height, cWidth / page.getViewport(1.0).width);

                var viewport = page.getViewport({ scale: scale });
                //console.log('viewport', viewport);
                var canvas = document.getElementById('pdfCanvas');
                var context = canvas.getContext('2d');

                // console.info('[cWidth, cHeight]', [cWidth, cHeight]);
                // console.info('[viewport.width, viewport.height]', [viewport.width, viewport.height]);

                // задаём ширину и высоту самого канваса
                canvas.height = viewport.height.toFixed(0);
                canvas.width = viewport.width.toFixed(0);
                $('#PlayerContent').width(viewport.width.toFixed(0) + 'px');
                $('[name=ppPdfView] .toolbar').width(viewport.width.toFixed(0) + 'px');

                var renderContext = {
                    canvasContext: context,
                    viewport: viewport
                };
                var renderTask = page.render(renderContext);
                renderTask.promise.then(function () {
                    //console.log('Page rendered');
                    vm.currentPage = pageNumber;
                    vm.isRendering = false;
                });

                vm.pageSwitch = true;
                setTimeout(function () {
                    vm.pageSwitch = false;
                }, 200);
            });
        },
        onkey: function onkey(event) {
            if (event.keyCode === 39) {
                this.goToPage(this.currentPage + 1);
            } else if (event.keyCode === 37) {
                this.goToPage(this.currentPage - 1);
            } else if (event.keyCode === 27) {
                //this.visible = false;
            }
        }
    },

    created: function created() {
        var vm = this;

        window.addEventListener('keydown', this.onkey);
        document.addEventListener("fullscreenchange", function () {
            vm.inFullMode = document.fullscreen;
        }, false);
        document.addEventListener("mozfullscreenchange", function () {
            vm.inFullMode = document.mozFullScreen;
        }, false);
        document.addEventListener("webkitfullscreenchange", function () {
            vm.inFullMode = document.webkitIsFullScreen;
        }, false);
    },
    mounted: function mounted() {
        var vm = this;

        $(window).on('resize orientationchange', function () {
            if (vm.visible) {
                vm.$nextTick(function () {
                    vm.renderPage(vm.currentPage);
                });
            }
        });
    },
    destroyed: function destroyed() {
        $(window).off('resize orientationchange');
        window.removeEventListener('keydown', this.onkey);
        this.pdfDoc = null;
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(30)))

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_plyr__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_plyr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_plyr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_plyr_dist_plyr_css__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_plyr_dist_plyr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__node_modules_plyr_dist_plyr_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var player = void 0;
/* harmony default export */ __webpack_exports__["a"] = ({
    name: "pdf-viewer",

    props: ['title', 'auto'],

    data: function data() {
        return {
            src: null,
            numPages: null,
            currentPage: null,
            visible: false,
            isMobile: __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__["a" /* default */].check_mobile(),
            videoPlayerLoaded: false,
            inFrame: false,
            progress: 0,
            maxPage: 0
        };
    },


    watch: {
        visible: function visible(newVal) {
            if (newVal === false) {
                player.destroy();
                this.videoPlayerLoaded = false;
            }
        }
    },

    methods: {
        show: function show(url, page, progressPage, inFrame) {
            var vm = this;

            console.info('show -> [vm.src, url]', [vm.src, url]);
            if (vm.src != url && player) {
                player.destroy();
                this.videoPlayerLoaded = false;
                console.info('destroyed');
            }

            vm.inFrame = inFrame || false;
            vm.visible = true;
            vm.src = url;

            if (progressPage) {
                this.maxPage = progressPage;
            }

            if (!this.videoPlayerLoaded) {
                this.videoPlayerLoaded = true;

                setTimeout(function () {
                    vm.$nextTick(function () {
                        vm.playerInit();

                        player.once('ready', function (event) {
                            console.info('go on from ', page);
                            player.currentTime = page;
                            if (vm.auto === true) {
                                player.play();
                            }
                        });
                    });
                }, 50);
            } else {
                player.currentTime = page;
                if (vm.auto === true) {
                    player.play();
                }
            }
        },
        setContainerSize: function setContainerSize() {
            var $ppView = $('[name=ppPdfView]');
            var ppWidth = $ppView.width(),
                ppHeight = $ppView.height();
            var scale = 16 / 9;

            if (ppWidth > ppHeight) {
                if (ppHeight * scale > ppWidth) ppHeight = (ppWidth / scale).toFixed(0);
                $('[name=ppPdfView] > .pdf-content').height(ppHeight);
                $('[name=ppPdfView] > .pdf-content').width(ppHeight * scale);
            } else {
                $('[name=ppPdfView] > .pdf-content').width(ppWidth);
            }
        },
        playerInit: function playerInit() {
            console.info('player init');
            var vm = this;

            vm.setContainerSize();

            if (!vm.isMobile) {}
            //$('#player').css('max-height', $('#playContent').height());

            // let sources = [
            //     {
            //         src: vm.src,
            //         type: 'video/mp4'
            //     }
            // ];
            // if(vm.inFrame){
            //     sources = [
            //         {
            //             src: vm.src.replace('https://youtube.com/embed/', ''),
            //             provider: 'youtube'
            //         }
            //     ];
            // }
            // console.info('sources', sources)

            player = new __WEBPACK_IMPORTED_MODULE_1_plyr___default.a('#player', {
                ratio: '16:9',
                controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'fullscreen']
            });
            // player.source = {
            //     type: 'video',
            //     sources: sources
            // };

            player.once('ended', function (event) {
                //console.info(`ended at ${Math.ceil(player.currentTime)}sec!`);
                clearInterval(playerInterval);
                //console.info('ended')
                vm.$emit('onPageChanged', Math.ceil(player.currentTime), Math.ceil(player.currentTime));
            });

            player.on('seeking', function (e) {
                if (player.currentTime > vm.maxPage) {
                    player.currentTime = vm.maxPage;
                }
            });

            //console.info('setting interval')
            var playerInterval = setInterval(function () {
                if (player.playing) {
                    //console.info(`playing on ${Math.ceil(player.currentTime)}sec`);
                    vm.$emit('onPageChanged', Math.ceil(player.currentTime), Math.ceil(player.duration));
                    vm.progress = Math.max(vm.progress, Math.ceil(player.currentTime) / Math.ceil(player.duration));
                    vm.maxPage = Math.max(vm.maxPage, Math.ceil(player.currentTime));
                }
            }, 1000);
        }
    },

    mounted: function mounted() {
        var vm = this;
        $(window).on('resize orientationchange', function () {
            if (vm.visible) {
                vm.setContainerSize();
            }
        });
    },
    destroyed: function destroyed() {
        $(window).off('resize orientationchange');
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(30)))

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "presentation-viewer",

    props: ['title'],

    data: function data() {
        return {
            src: null,
            page: 1,
            visible: false,
            isMobile: __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__["a" /* default */].check_mobile()
        };
    },


    methods: {
        show: function show(url, page) {
            var vm = this;

            vm.visible = true;
            vm.src = url;
            vm.page = page;

            vm.$nextTick(function () {
                var $ppView = $('[name=ppPdfView]');
                var ppWidth = $ppView.width(),
                    ppHeight = $ppView.height();

                $('[name=ppPdfView] iframe').height(ppHeight + 'px');
                $('[name=ppPdfView] iframe').width(ppWidth + 'px');
            });
        },
        receiveMessage: function receiveMessage(message) {
            if (message.data && typeof message.data === 'string' && message.data.startsWith('SlideChange|')) {
                var page = parseInt(message.data.replace('SlideChange|', ''));
                this.$emit('onPageChanged', page);
            }
        }
    },

    created: function created() {
        //window.addEventListener('keydown', this.onkey);
        window.addEventListener("message", this.receiveMessage, false);
    },
    mounted: function mounted() {
        //$('body').append(this.$el);
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(30)))

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_common_mixin__ = __webpack_require__(114);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "scorm-viewer",

    props: ['title'],

    data: function data() {
        return {
            src: null,
            img: null,
            visible: false,
            isMobile: __WEBPACK_IMPORTED_MODULE_0__helpers_ui_helpers__["a" /* default */].check_mobile(),
            inFullMode: false
        };
    },


    methods: {
        show: function show(url, img) {
            //console.info('show -> url', url);
            var vm = this;

            vm.visible = true;
            vm.img = 'background-image:url(' + img + ')';
            this.$nextTick(function () {
                //vm.setContainerSize();
                vm.src = url;
            });

            vm.$emit('onPageChanged', 1);
        },
        onFullScreenExited: function onFullScreenExited() {
            $('[name=ppPdfView] iframe').hide();
            $('[name=ppPdfView] .scorm-img').show();
            $('[name=ppPdfView] .player-play').show();
            if (window.Flutter) {
                window.Flutter.postMessage('onFullScreenExited');
            }
        },
        toFullScreen: function toFullScreen() {
            var isWebView = __WEBPACK_IMPORTED_MODULE_1__helpers_common_mixin__["a" /* default */].methods.getUrlParameter('view') == 'webview';
            if (navigator.platform.indexOf("iPhone") != -1 || navigator.platform.indexOf("iPod") != -1 || isWebView) {
                $('[name=ppPdfView] iframe').addClass('scorm-show');
                $('.scorm-show-close').show();
                $('#PlayerContentInfo').text('');
            } else {
                var elem = $('[name=ppPdfView] iframe').get(0);
                var req = elem.requestFullScreen || elem.webkitRequestFullScreen || elem.mozRequestFullScreen;
                req.call(elem);
            }
            $('[name=ppPdfView] .scorm-img').hide();
            $('[name=ppPdfView] iframe').show();
            $('[name=ppPdfView] .player-play').hide();
            if (window.Flutter) {
                window.Flutter.postMessage('onFullScreen');
            }
        },
        iosFullScreenClose: function iosFullScreenClose() {
            $('[name=ppPdfView] iframe').removeClass('scorm-show');
            $('.scorm-show-close').hide();
            $('[name=ppPdfView] .scorm-img').show();
            $('[name=ppPdfView] iframe').hide();
            $('[name=ppPdfView] .player-play').show();
            if (window.Flutter) {
                window.Flutter.postMessage('onFullScreenExited');
            }
        }
    },

    created: function created() {
        var vm = this;

        window.addEventListener('keydown', this.onkey);
        document.addEventListener("fullscreenchange", function () {
            vm.inFullMode = document.fullscreen;
            if (!vm.inFullMode) {
                vm.onFullScreenExited();
            }
        }, false);
        document.addEventListener("mozfullscreenchange", function () {
            vm.inFullMode = document.mozFullScreen;
            if (!vm.inFullMode) {
                vm.onFullScreenExited();
            }
        }, false);
        document.addEventListener("webkitfullscreenchange", function () {
            vm.inFullMode = document.webkitIsFullScreen;
            if (!vm.inFullMode) {
                vm.onFullScreenExited();
            }
        }, false);
    },
    mounted: function mounted() {
        //$('body').append(this.$el);
    },
    destroyed: function destroyed() {
        window.removeEventListener('keydown', this.onkey);
        // document.removeEventListener('fullscreenchange');
        // document.removeEventListener('mozfullscreenchange');
        // document.removeEventListener('webkitfullscreenchange');
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(30)))

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

var $ = __webpack_require__(6);
window.$ = $;
window.jQuery = $;

var loadFroalaScripts = function loadFroalaScripts(callback) {
    var present = false;
    var scriptSrc = '/Content/custom/Froala/htmleditor.min.js';
    var scripts = document.getElementsByTagName('script');
    for (var i = scripts.length; i--;) {
        if (scripts[i].src === scriptSrc) {
            present = true;
            break;
        }
    }

    if (!present) {
        var link1 = document.createElement('link');
        link1.setAttribute('rel', 'stylesheet');
        link1.setAttribute('type', 'text/css');
        link1.href = '/Content/custom/Froala/htmleditor.min.css';
        document.head.appendChild(link1);

        var link2 = document.createElement('link');
        link2.href = '/Content/custom/FontAwesome/css/font-awesome.css';
        link2.setAttribute('rel', 'stylesheet');
        link2.setAttribute('type', 'text/css');
        document.head.appendChild(link2);

        var script = document.createElement('script');
        script.onload = function () {
            callback();
        };
        script.src = scriptSrc;
        document.head.appendChild(script);
    } else {
        callback();
    }
};
var froala = void 0;

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "froala-editor",

    props: ['name', 'value', 'imageUploadURL', 'imageMaxSize', 'height'],

    data: function data() {
        return {
            body: null,
            queueAction: null
        };
    },


    watch: {
        value: function value(newVal, oldVal) {
            //$(this.$el).froalaEditor('html.set', newVal);
        }
    },

    methods: {
        getHtml: function getHtml() {
            return $(this.$el).froalaEditor('html.get');
        },
        setHtml: function setHtml(newVal) {
            var vm = this;
            if (froala) {
                $(this.$el).froalaEditor('html.set', newVal);
            } else {
                this.queueAction = function () {
                    $(vm.$el).froalaEditor('html.set', newVal);
                };
            }
        },
        insert: function insert(text) {
            var vm = this;
            if (froala) {
                $(vm.$el).froalaEditor('html.insert', text);
            } else {
                this.queueAction = function () {
                    $(vm.$el).froalaEditor('html.insert', text);
                };
            }
        }
    },

    mounted: function mounted() {
        var vm = this;

        loadFroalaScripts(function () {
            var toolbarButtons = ['undo', 'redo', '|', 'bold', 'italic', 'underline', '|', 'fontSize', 'color', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '|', 'insertLink', 'insertTable', 'insertHR'];
            if (vm.imageUploadURL) {
                toolbarButtons.splice(18, 0, 'insertImage');
            }

            froala = $(vm.$el).froalaEditor({
                language: 'ru',
                toolbarButtons: toolbarButtons,
                charCounterCount: false,
                videoUpload: false,
                useClasses: false,

                imageSplitHTML: true,
                imageUploadURL: vm.imageUploadURL || '',
                imageUploadMethod: 'POST',
                imageMaxSize: vm.imageMaxSize || 10 * 1024 * 1024,
                imageAllowedTypes: ['jpeg', 'jpg', 'png'],
                height: vm.height || 0
            });

            $(vm.$el).on('froalaEditor.contentChanged', function () {
                vm.$emit('input', $(vm.$el).froalaEditor('html.get', true));
            });

            if (vm.queueAction) {
                vm.queueAction();
                vm.queueAction = null;
            }
        });
    },
    destroyed: function destroyed() {
        $(this.$el).froalaEditor('destroy');
        $(this.$el).remove();
    }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function isOverflown(element) {
    if (!element) {
        return false;
    }
    //console.info('[element.scrollHeight, element.clientHeight, element.scrollWidth, element.clientWidth]',
    //    [element.scrollHeight, element.clientHeight, element.scrollWidth, element.clientWidth]);
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "checked-down",

    props: ['name', 'value', 'items', 'dataField', 'textField', 'idPref', 'disabled', 'loadFunction', 'hasErrors', 'rowsPage'],

    $_veeValidate: {
        value: function value() {
            var selectedItem = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.dropItems, { Checked: true });
            //let val = selectedItem.length ? selectedItem[0][this.dataField] : null;
            //return val;
            return selectedItem;
        },
        name: function name() {
            return this.name;
        }
    },

    data: function data() {
        return {
            dropDownOpen: false,
            dropItems: [],
            tempItems: [],
            isOverflown: false,
            selectedText: '',
            searchText: null,
            dropdownKey: 0,
            selectAll: false,
            page: 1,
            loading: false,
            canBeLoaded: true
        };
    },


    watch: {
        items: function items() {
            //console.info('dd -> watch items changed');
            this.tempItems = this.items;
            this.setItems();
        },
        value: function value(newVal, oldVal) {
            //console.info('dd -> watch value: newVal, oldVal', [newVal, oldVal]);
        },
        name: function name(newVal, oldVal) {
            //console.info('dd -> watch name: newVal, oldVal', [newVal, oldVal]);
            this.dropItems = [];
            this.selectAll = false;
        },
        dropDownOpen: function dropDownOpen() {
            var vm = this;
            if (vm.dropDownOpen) {
                vm.$nextTick(function () {
                    vm.isOverflown = isOverflown(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(vm.$el).parents('.block-in-page-detail:first').get(0));
                });
            } else {
                vm.isOverflown = false;
            }
        }
    },

    methods: {
        calculateSelecteditem: function calculateSelecteditem() {
            var vm = this;
            vm.selectedText = '';
            if (this.dropItems === undefined) {} else {
                for (var i = 1; i < vm.dropItems.length; i++) {
                    if (vm.dropItems[i].Checked) {
                        vm.selectedText = vm.selectedText + '; ' + vm.dropItems[i][vm.textField];
                    }
                }
                if (vm.selectedText.length > 2) vm.selectedText = vm.selectedText.substring(2);
            }
            //console.info('dd -> calculateSelecteditem', vm.selectedText);
        },
        onSelect: function onSelect(item, i, event) {
            var vm = this;
            var el = this.dropItems[i];
            var emitOnBottomScrolled = false;
            if (el[vm.textField] === 'Выбрать всех') {
                vm.selectAll = event.srcElement.checked;
                emitOnBottomScrolled = vm.selectAll;
                for (var j = 0; j < vm.dropItems.length; j++) {
                    vm.dropItems[j].Checked = vm.selectAll;
                    //vm.$set(vm.dropItems, j, vm.dropItems[j]);
                }
            } else {
                el.Checked = event.srcElement.checked;
                //vm.$set(vm.dropItems, i, el);
                if (vm.dropItems[0].Checked) {
                    vm.selectAll = false;
                    vm.dropItems[0].Checked = vm.selectAll;
                    //vm.$set(vm.dropItems, 0, vm.dropItems[0]);
                }
            }
            this.calculateSelecteditem();

            var selectedItems = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.dropItems, function (val, key, obj) {
                return key > 0 && val.Checked;
            });
            this.$emit('input', selectedItems);
            this.$emit('change', selectedItems);
            if (emitOnBottomScrolled) {
                this.$emit('onBottomScrolled', true);
            }
        },
        setItems: function setItems() {
            var _ref;

            var vm = this;
            vm.dropItems = [(_ref = {}, _defineProperty(_ref, vm.textField, 'Выбрать всех'), _defineProperty(_ref, 'Checked', vm.selectAll), _defineProperty(_ref, vm.dataField, null), _ref)];

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = vm.tempItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    if (item.Checked) vm.dropItems.push(Object.assign({ Checked: true }, item));else vm.dropItems.push(Object.assign({ Checked: vm.selectAll }, item));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (vm.selectAll) {
                var selectedItems = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(vm.dropItems, function (val, key, obj) {
                    return key > 0;
                });
                vm.$emit('input', selectedItems);
                vm.$emit('change', selectedItems);
            } else {
                var selItem = [];

                var _loop = function _loop(i) {
                    var el = vm.dropItems[i];
                    if (vm.dataField && el[vm.dataField]) {
                        selItem = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(vm.value, function (item) {
                            return item[vm.dataField] == el[vm.dataField];
                        });
                    } else {
                        selItem = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(vm.value, function (item) {
                            return item[vm.textField] == el[vm.textField];
                        });
                    }
                    if (selItem.length) {
                        el.Checked = true;
                    }
                };

                for (var i = 0; i < vm.dropItems.length; i++) {
                    _loop(i);
                }
            }
            this.calculateSelecteditem();
        },
        onClickOutside: function onClickOutside(e, el) {
            this.dropDownOpen = false;
        },
        onScroll: function onScroll(e) {
            var vm = this;
            if (!vm.loading && vm.canBeLoaded) {
                var elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target);
                if (elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight() + 100) {
                    this.$emit('onBottomScrolled', false);

                    vm.page++;
                    vm.loadNext();
                }
            }
        },


        onChangeSearchInput: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function ($event) {
            var vm = this;

            if (vm.searchText === '') {
                for (var i = 0; i < vm.dropItems.length; i++) {
                    vm.dropItems[i].Hidden = false;
                }
            } else {
                var textLower = vm.searchText.toLowerCase();
                for (var _i = 0; _i < vm.dropItems.length; _i++) {
                    var _el = vm.dropItems[_i];
                    _el.Hidden = _el[vm.textField].toLowerCase().indexOf(textLower) === -1;
                }
            }

            vm.dropdownKey++;
        }, 500),

        loadNext: function loadNext() {
            var vm = this;
            if (!vm.dropDownOpen || !vm.loadFunction) return;
            vm.loading = true;
            vm.loadFunction(vm.searchText, function (res) {
                //console.info('checkedown-loadFunction', res);
                if (res) {
                    if (res.length) {
                        if (vm.page == 1) {
                            vm.tempItems = Object.assign(res);
                        } else {
                            var _loop2 = function _loop2(resitem) {
                                if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(vm.tempItems, function (item) {
                                    return item[vm.textField] == resitem[vm.textField];
                                }).length === 0) {
                                    vm.tempItems.push(Object.assign(resitem));
                                }
                            };

                            //vm.tempItems.push(...Object.assign(res));
                            var _iteratorNormalCompletion2 = true;
                            var _didIteratorError2 = false;
                            var _iteratorError2 = undefined;

                            try {
                                for (var _iterator2 = res[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                    var resitem = _step2.value;

                                    _loop2(resitem);
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                        _iterator2.return();
                                    }
                                } finally {
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                        }
                        vm.setItems();
                        if (vm.rowsPage > res.length) {
                            var selectedItems = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(vm.dropItems, function (val, key, obj) {
                                return key > 0 && val.Checked;
                            });
                            vm.$emit('input', selectedItems);
                            vm.$emit('change', selectedItems);
                        }
                    } else {
                        vm.canBeLoaded = false;
                    }
                }
                vm.loading = false;
            }, vm.page, vm.selectAll);
        },
        onDropDownOpen: function onDropDownOpen() {
            var vm = this;
            if (vm.dropDownOpen) return;
            vm.dropDownOpen = true;
            vm.page = 1;
            vm.loadNext();
        }
    },

    mounted: function mounted() {
        this.tempItems = this.items;
        this.setItems();
    },
    destroyed: function destroyed() {}
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//



// setActive и setInactive используют таймауты, так что когда вы перетаскиваете элемент на дочерний элемент,
// срабатывающее событие dragleave не вызовет мерцания. Несколько мс должно быть много
// время ожидания следующего события dragenter для сброса тайм-аута и возврата его в активное состояние.
//https://github.com/joezimjs/vue-dd-uploader/blob/main/src/components/DropZone.vue

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "drop-zone",

    props: ['name', 'value', 'files-dropped', 'dataId', 'accept'],

    $_veeValidate: {
        value: function value() {
            console.info('$_veeValidate', this.selectedFile);
            return this.selectedFile;
        },
        name: function name() {
            return this.name;
        }
    },

    watch: {
        value: function value(newVal, oldVal) {
            if (newVal > 0) {
                this.selectedFile = 1;
            } else {
                this.selectedFile = null;
            }
        }
    },

    data: function data() {
        return {
            events: ['dragenter', 'dragover', 'dragleave', 'drop'],
            inActiveTimeout: null,
            active: { value: false },
            selectedFile: null
        };
    },

    methods: {
        setActive: function setActive() {
            this.active.value = true;
            clearTimeout(this.inActiveTimeout);
            //console.info('setActive');
        },
        setInactive: function setInactive() {
            var _this = this;

            this.inActiveTimeout = setTimeout(function () {
                _this.active.value = false;
            }, 50);
            //console.info('setInactive');
        },
        onDrop: function onDrop(e) {
            this.setInactive();
            this.$emit('files-dropped', { files: [].concat(_toConsumableArray(e.dataTransfer.files)), id: this.dataId, accept: this.accept });
            //console.info('onDrop');
        },
        preventDefaults: function preventDefaults(e) {
            e.preventDefault();
        }
    },
    mounted: function mounted() {
        var vm = this;
        vm.events.forEach(function (eventName) {
            document.body.addEventListener(eventName, vm.preventDefaults);
        });
        if (vm.value > 0) {
            this.selectedFile = 1;
        }
    },
    destroyed: function destroyed() {
        var vm = this;
        vm.events.forEach(function (eventName) {
            document.body.removeEventListener(eventName, vm.preventDefaults);
        });
    }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "image-setting",

    props: ['img', 'parentImgPath', 'name', 'parentImage'],

    data: function data() {
        return {
            filename: ''
        };
    },


    watch: {
        parentImgPath: function parentImgPath(newVal, oldVal) {
            //console.info('watch parent image', newVal, oldVal);
            this.img.ParentImgPath = newVal;
            this.onChangeUseMainPhoto(null);
        }
    },

    computed: {},

    methods: {
        setImageStyleParams: function setImageStyleParams(style) {
            var vm = this;
            for (var p in style) {
                vm.img.ImageStyle[p] = style[p];
            }
            //console.info('setImageStyleParams', this.name, style);
            vm.$emit('onImageStyleParamsChanged', vm.img.ImageStyle, vm.name);
        },
        removeImage: function removeImage() {
            var vm = this;
            vm.img.Image.FileName = null;
            vm.img.Image.FileData = null;
            vm.img.ImagePath = null;
            vm.img.Image.Id = -1;
            vm.img.ImageView = null;
            vm.filename = '';

            this.onChangeUseMainPhoto(null);
        },
        onChangeUseMainPhoto: function onChangeUseMainPhoto(e) {
            var vm = this;
            vm.$nextTick(function () {
                if (vm.img.ImageStyle.useMainPhoto) {
                    if (vm.img.ParentImgPath) vm.img.ImageView = vm.img.ParentImgPath;else vm.img.ImageView = null;
                } else if (vm.img.Image.FileData) {
                    vm.img.ImageView = vm.img.Image.FileData;
                } else {
                    vm.img.ImageView = vm.img.ImagePath;
                }
                vm.$emit('onImageViewChanged', vm.img.ImageView, vm.name);
            });
        }
    },

    mounted: function mounted() {
        var vm = this;

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('change', '[name="' + vm.name + 'dropFiles"]', function () {
            if (this.files && this.files[0]) {
                if (this.files[0].size > 50 * 1024 * 1024) {
                    __WEBPACK_IMPORTED_MODULE_1__helpers_ui_helpers__["a" /* default */].toastr.error('Превышен размер. Выберите другой файл');
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[name="' + vm.name + 'dropFiles"]').val('');
                } else {
                    vm.file = this.files[0];
                    vm.img.Image.FileName = vm.file.name;
                    vm.filename = '';
                    vm.img.Image.FileData = null;
                    vm.img.Image.Id = -1;

                    var reader = new FileReader();
                    reader.onload = function (e) {
                        vm.filename = vm.file.name;
                        vm.img.Image.FileData = e.target.result;
                        vm.$emit('onImageViewChanged', vm.img.Image.FileData, vm.name);
                    };
                    reader.readAsDataURL(this.files[0]);
                }
            }
        });

        vm.$nextTick(function () {
            //console.info('mountead', vm.img);
            vm.img.Image = {};
            vm.img.ImageView = vm.img.ImagePath;
            if (vm.img.ImageStyle.useMainPhoto) {
                vm.img.ImagePath = null;
            }
            vm.$emit('onImageViewChanged', vm.img.ImageView, vm.name);
        });
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('change', '[name="' + this.name + 'dropFiles"]');
    }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backendApi__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(9);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var backendApi = new __WEBPACK_IMPORTED_MODULE_2__backendApi__["a" /* default */]();

function isOverflown(element) {
    if (!element) {
        return false;
    }
    /*console.info('[element.scrollHeight, element.clientHeight, element.scrollWidth, element.clientWidth]',
        [element.scrollHeight, element.clientHeight, element.scrollWidth, element.clientWidth]);*/
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "notification",

    props: ['name', 'value', 'menuColor', 'info'],

    data: function data() {
        return {
            notificationOpen: false,
            notificationItems: [],
            isOverflown: false,
            page: 0,
            canBeLoaded: true,
            loading: false,
            scrollTop: null,
            rowsPerPage: 5,
            firstLoad: true,
            totalCount: 0
        };
    },


    watch: {
        notificationOpen: function notificationOpen() {
            var vm = this;
            if (vm.notificationOpen) {
                vm.$nextTick(function () {
                    vm.isOverflown = isOverflown(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(vm.$el).parents('.block-in-page-detail:first').get(0));
                });
            } else {
                vm.isOverflown = false;
            }
        },
        value: function value(newVal, oldVal) {
            this.totalCount = newVal;
        }
    },

    computed: {
        styleBell: function styleBell() {
            return {
                fill: this.notificationOpen ? this.menuColor : null
            };
        }
    },

    methods: {
        menuClick: function menuClick() {
            this.notificationOpen = !this.notificationOpen;
            //console.info('menuClick notificationOpen=', this.notificationOpen);
            if (this.notificationOpen) {
                this.reload();
            }
        },
        reload: function reload() {
            this.page = 0;
            this.notificationItems = [];
            this.loading = false;
            this.canBeLoaded = true;

            this.loadNext();
        },
        gotoPage: function gotoPage(item) {
            if (item.PathToOpen) {
                this.close();
                this.$router.push(item.PathToOpen);
            }
        },
        loadNext: function loadNext() {
            var vm = this;
            if (!vm.canBeLoaded || vm.loading) {
                return;
            }
            this.loading = true;
            var skip = vm.page * vm.rowsPerPage;
            var take = vm.rowsPerPage;

            return backendApi.commonNotificationList(skip, take).then(function (response) {
                console.info('commonNotificationList -> load, response:', response, vm.info);
                if (response.hasError) {
                    UI.toastr.error('Ошибка при загрузке уведомлений');
                } else {
                    if (response.data.NotificationsList && response.data.NotificationsList.length) {
                        var _vm$notificationItems;

                        vm.totalCount = response.data.NotificationsLength;
                        //vm.notificationItems = Object.assign(response.data.NotificationsList, {});

                        var oldLength = vm.notificationItems.length;

                        (_vm$notificationItems = vm.notificationItems).push.apply(_vm$notificationItems, _toConsumableArray(response.data.NotificationsList));

                        var urlImg = '/Content/dist/images.svg?v3#Menu';

                        var _loop = function _loop(r) {
                            vm.notificationItems[r].CreateDateFormatted = Object(__WEBPACK_IMPORTED_MODULE_3_moment__["default"])(vm.notificationItems[r].CreateDate).format('DD.MM.YYYY');
                            var path = '/' + vm.notificationItems[r].Page;
                            var projectPage = vm.info.Pages.find(function (x) {
                                return x.Path === path;
                            });
                            switch (vm.notificationItems[r].Page) {
                                case 'news':
                                    vm.notificationItems[r].img = urlImg + 'News';
                                    projectPage = vm.info.Pages.find(function (x) {
                                        return x.Path === '/';
                                    });
                                    break;
                                case 'materials':
                                    vm.notificationItems[r].img = urlImg + 'Material';
                                    break;
                                case 'profile':
                                    vm.notificationItems[r].img = urlImg + 'Profile';
                                    break;
                                case 'reports':
                                    vm.notificationItems[r].img = urlImg + 'Doc';
                                    break;
                                case 'tasks':
                                    vm.notificationItems[r].img = urlImg + 'Tasks';
                                    break;
                                case 'cart':
                                    vm.notificationItems[r].img = urlImg + 'Cabinet';
                                    break;
                            }
                            if (projectPage && projectPage.Name && vm.notificationItems[r].isSystem) {
                                vm.notificationItems[r].PageText = projectPage.Name;
                            }
                        };

                        for (var r = oldLength; r < vm.notificationItems.length; r++) {
                            _loop(r);
                        }
                    } else {
                        vm.canBeLoaded = false;
                    }
                }
                vm.loading = false;
                vm.page++;
            });
        },
        close: function close() {
            this.notificationOpen = !this.notificationOpen;
        },
        onClickOutside: function onClickOutside(e, el) {
            this.notificationOpen = false;
        }
    },

    mounted: function mounted() {
        this.totalCount = this.value;
    },
    destroyed: function destroyed() {}
});

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(743)
var ieee754 = __webpack_require__(744)
var isArray = __webpack_require__(745)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(342);
module.exports = __webpack_require__(544);


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(343);

__webpack_require__(540);

__webpack_require__(541);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(344);
__webpack_require__(347);
__webpack_require__(348);
__webpack_require__(349);
__webpack_require__(350);
__webpack_require__(351);
__webpack_require__(352);
__webpack_require__(353);
__webpack_require__(354);
__webpack_require__(355);
__webpack_require__(356);
__webpack_require__(357);
__webpack_require__(358);
__webpack_require__(359);
__webpack_require__(360);
__webpack_require__(361);
__webpack_require__(362);
__webpack_require__(363);
__webpack_require__(364);
__webpack_require__(365);
__webpack_require__(366);
__webpack_require__(367);
__webpack_require__(368);
__webpack_require__(369);
__webpack_require__(370);
__webpack_require__(371);
__webpack_require__(372);
__webpack_require__(373);
__webpack_require__(374);
__webpack_require__(375);
__webpack_require__(376);
__webpack_require__(377);
__webpack_require__(378);
__webpack_require__(379);
__webpack_require__(380);
__webpack_require__(381);
__webpack_require__(382);
__webpack_require__(383);
__webpack_require__(384);
__webpack_require__(385);
__webpack_require__(386);
__webpack_require__(387);
__webpack_require__(388);
__webpack_require__(389);
__webpack_require__(390);
__webpack_require__(391);
__webpack_require__(392);
__webpack_require__(393);
__webpack_require__(394);
__webpack_require__(395);
__webpack_require__(396);
__webpack_require__(397);
__webpack_require__(398);
__webpack_require__(399);
__webpack_require__(400);
__webpack_require__(401);
__webpack_require__(402);
__webpack_require__(403);
__webpack_require__(404);
__webpack_require__(405);
__webpack_require__(406);
__webpack_require__(407);
__webpack_require__(408);
__webpack_require__(409);
__webpack_require__(410);
__webpack_require__(411);
__webpack_require__(412);
__webpack_require__(413);
__webpack_require__(414);
__webpack_require__(415);
__webpack_require__(416);
__webpack_require__(417);
__webpack_require__(418);
__webpack_require__(419);
__webpack_require__(420);
__webpack_require__(421);
__webpack_require__(422);
__webpack_require__(424);
__webpack_require__(425);
__webpack_require__(427);
__webpack_require__(428);
__webpack_require__(429);
__webpack_require__(430);
__webpack_require__(431);
__webpack_require__(432);
__webpack_require__(433);
__webpack_require__(435);
__webpack_require__(436);
__webpack_require__(437);
__webpack_require__(438);
__webpack_require__(439);
__webpack_require__(440);
__webpack_require__(441);
__webpack_require__(442);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(445);
__webpack_require__(446);
__webpack_require__(447);
__webpack_require__(147);
__webpack_require__(448);
__webpack_require__(187);
__webpack_require__(449);
__webpack_require__(188);
__webpack_require__(450);
__webpack_require__(451);
__webpack_require__(452);
__webpack_require__(453);
__webpack_require__(454);
__webpack_require__(191);
__webpack_require__(193);
__webpack_require__(194);
__webpack_require__(455);
__webpack_require__(456);
__webpack_require__(457);
__webpack_require__(458);
__webpack_require__(459);
__webpack_require__(460);
__webpack_require__(461);
__webpack_require__(462);
__webpack_require__(463);
__webpack_require__(464);
__webpack_require__(465);
__webpack_require__(466);
__webpack_require__(467);
__webpack_require__(468);
__webpack_require__(469);
__webpack_require__(470);
__webpack_require__(471);
__webpack_require__(472);
__webpack_require__(473);
__webpack_require__(474);
__webpack_require__(475);
__webpack_require__(476);
__webpack_require__(477);
__webpack_require__(478);
__webpack_require__(479);
__webpack_require__(480);
__webpack_require__(481);
__webpack_require__(482);
__webpack_require__(483);
__webpack_require__(484);
__webpack_require__(485);
__webpack_require__(486);
__webpack_require__(487);
__webpack_require__(488);
__webpack_require__(489);
__webpack_require__(490);
__webpack_require__(491);
__webpack_require__(492);
__webpack_require__(493);
__webpack_require__(494);
__webpack_require__(495);
__webpack_require__(496);
__webpack_require__(497);
__webpack_require__(498);
__webpack_require__(499);
__webpack_require__(500);
__webpack_require__(501);
__webpack_require__(502);
__webpack_require__(503);
__webpack_require__(504);
__webpack_require__(505);
__webpack_require__(506);
__webpack_require__(507);
__webpack_require__(508);
__webpack_require__(509);
__webpack_require__(510);
__webpack_require__(511);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(516);
__webpack_require__(517);
__webpack_require__(518);
__webpack_require__(519);
__webpack_require__(520);
__webpack_require__(521);
__webpack_require__(522);
__webpack_require__(523);
__webpack_require__(524);
__webpack_require__(525);
__webpack_require__(526);
__webpack_require__(527);
__webpack_require__(528);
__webpack_require__(529);
__webpack_require__(530);
__webpack_require__(531);
__webpack_require__(532);
__webpack_require__(533);
__webpack_require__(534);
__webpack_require__(535);
__webpack_require__(536);
__webpack_require__(537);
__webpack_require__(538);
__webpack_require__(539);
module.exports = __webpack_require__(44);


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(8);
var has = __webpack_require__(37);
var DESCRIPTORS = __webpack_require__(18);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(33);
var META = __webpack_require__(63).KEY;
var $fails = __webpack_require__(10);
var shared = __webpack_require__(91);
var setToStringTag = __webpack_require__(82);
var uid = __webpack_require__(69);
var wks = __webpack_require__(15);
var wksExt = __webpack_require__(169);
var wksDefine = __webpack_require__(128);
var enumKeys = __webpack_require__(346);
var isArray = __webpack_require__(102);
var anObject = __webpack_require__(7);
var isObject = __webpack_require__(11);
var toObject = __webpack_require__(22);
var toIObject = __webpack_require__(38);
var toPrimitive = __webpack_require__(50);
var createDesc = __webpack_require__(68);
var _create = __webpack_require__(72);
var gOPNExt = __webpack_require__(172);
var $GOPD = __webpack_require__(39);
var $GOPS = __webpack_require__(101);
var $DP = __webpack_require__(20);
var $keys = __webpack_require__(70);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(73).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(93).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(62)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(32)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(91)('native-function-to-string', Function.toString);


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(70);
var gOPS = __webpack_require__(101);
var pIE = __webpack_require__(93);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(72) });


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(18), 'Object', { defineProperty: __webpack_require__(20).f });


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(18), 'Object', { defineProperties: __webpack_require__(171) });


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(38);
var $getOwnPropertyDescriptor = __webpack_require__(39).f;

__webpack_require__(52)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(22);
var $getPrototypeOf = __webpack_require__(40);

__webpack_require__(52)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(22);
var $keys = __webpack_require__(70);

__webpack_require__(52)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(52)('getOwnPropertyNames', function () {
  return __webpack_require__(172).f;
});


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(11);
var meta = __webpack_require__(63).onFreeze;

__webpack_require__(52)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(11);
var meta = __webpack_require__(63).onFreeze;

__webpack_require__(52)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(11);
var meta = __webpack_require__(63).onFreeze;

__webpack_require__(52)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(11);

__webpack_require__(52)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(11);

__webpack_require__(52)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(11);

__webpack_require__(52)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(173) });


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(174) });


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(132).set });


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(83);
var test = {};
test[__webpack_require__(15)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(33)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(175) });


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(20).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(18) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(11);
var getPrototypeOf = __webpack_require__(40);
var HAS_INSTANCE = __webpack_require__(15)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(20).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(177);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(178);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(8);
var has = __webpack_require__(37);
var cof = __webpack_require__(46);
var inheritIfRequired = __webpack_require__(134);
var toPrimitive = __webpack_require__(50);
var fails = __webpack_require__(10);
var gOPN = __webpack_require__(73).f;
var gOPD = __webpack_require__(39).f;
var dP = __webpack_require__(20).f;
var $trim = __webpack_require__(84).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(72)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(18) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(33)(global, NUMBER, $Number);
}


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toInteger = __webpack_require__(47);
var aNumberValue = __webpack_require__(179);
var repeat = __webpack_require__(135);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(10)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $fails = __webpack_require__(10);
var aNumberValue = __webpack_require__(179);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(8).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(180) });


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(180);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(178);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(177);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(181);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(136);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(137);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(182) });


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(10)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(181) });


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(136) });


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(137);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(10)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(137);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(71);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(38);
var toLength = __webpack_require__(16);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(84)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(103)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(138)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $at = __webpack_require__(103)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(16);
var context = __webpack_require__(140);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(141)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(140);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(141)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(135)
});


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(16);
var context = __webpack_require__(140);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(141)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(34)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(34)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(34)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(34)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(34)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(34)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(34)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(34)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(34)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(34)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(34)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(34)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(34)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(22);
var toPrimitive = __webpack_require__(50);

$export($export.P + $export.F * __webpack_require__(10)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0);
var toISOString = __webpack_require__(423);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(10);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(33)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(15)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(32)(proto, TO_PRIMITIVE, __webpack_require__(426));


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(7);
var toPrimitive = __webpack_require__(50);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(102) });


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(45);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(22);
var call = __webpack_require__(183);
var isArrayIter = __webpack_require__(142);
var toLength = __webpack_require__(16);
var createProperty = __webpack_require__(143);
var getIterFn = __webpack_require__(144);

$export($export.S + $export.F * !__webpack_require__(105)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var createProperty = __webpack_require__(143);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(10)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(38);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(92) != Object || !__webpack_require__(48)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var html = __webpack_require__(131);
var cof = __webpack_require__(46);
var toAbsoluteIndex = __webpack_require__(71);
var toLength = __webpack_require__(16);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(10)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var aFunction = __webpack_require__(29);
var toObject = __webpack_require__(22);
var fails = __webpack_require__(10);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(48)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $forEach = __webpack_require__(53)(0);
var STRICT = __webpack_require__(48)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
var isArray = __webpack_require__(102);
var SPECIES = __webpack_require__(15)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $map = __webpack_require__(53)(1);

$export($export.P + $export.F * !__webpack_require__(48)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $filter = __webpack_require__(53)(2);

$export($export.P + $export.F * !__webpack_require__(48)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $some = __webpack_require__(53)(3);

$export($export.P + $export.F * !__webpack_require__(48)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $every = __webpack_require__(53)(4);

$export($export.P + $export.F * !__webpack_require__(48)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(184);

$export($export.P + $export.F * !__webpack_require__(48)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(184);

$export($export.P + $export.F * !__webpack_require__(48)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $indexOf = __webpack_require__(100)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(48)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(38);
var toInteger = __webpack_require__(47);
var toLength = __webpack_require__(16);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(48)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(185) });

__webpack_require__(64)('copyWithin');


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(146) });

__webpack_require__(64)('fill');


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(53)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(64)(KEY);


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(53)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(64)(KEY);


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('Array');


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var inheritIfRequired = __webpack_require__(134);
var dP = __webpack_require__(20).f;
var gOPN = __webpack_require__(73).f;
var isRegExp = __webpack_require__(104);
var $flags = __webpack_require__(94);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(18) && (!CORRECT_NEW || __webpack_require__(10)(function () {
  re2[__webpack_require__(15)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(33)(global, 'RegExp', $RegExp);
}

__webpack_require__(74)('RegExp');


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(188);
var anObject = __webpack_require__(7);
var $flags = __webpack_require__(94);
var DESCRIPTORS = __webpack_require__(18);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(33)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(10)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(7);
var toLength = __webpack_require__(16);
var advanceStringIndex = __webpack_require__(149);
var regExpExec = __webpack_require__(106);

// @@match logic
__webpack_require__(107)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(7);
var toObject = __webpack_require__(22);
var toLength = __webpack_require__(16);
var toInteger = __webpack_require__(47);
var advanceStringIndex = __webpack_require__(149);
var regExpExec = __webpack_require__(106);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(107)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(7);
var sameValue = __webpack_require__(174);
var regExpExec = __webpack_require__(106);

// @@search logic
__webpack_require__(107)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(104);
var anObject = __webpack_require__(7);
var speciesConstructor = __webpack_require__(95);
var advanceStringIndex = __webpack_require__(149);
var toLength = __webpack_require__(16);
var callRegExpExec = __webpack_require__(106);
var regexpExec = __webpack_require__(148);
var fails = __webpack_require__(10);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(107)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(62);
var global = __webpack_require__(8);
var ctx = __webpack_require__(45);
var classof = __webpack_require__(83);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(11);
var aFunction = __webpack_require__(29);
var anInstance = __webpack_require__(75);
var forOf = __webpack_require__(76);
var speciesConstructor = __webpack_require__(95);
var task = __webpack_require__(150).set;
var microtask = __webpack_require__(151)();
var newPromiseCapabilityModule = __webpack_require__(152);
var perform = __webpack_require__(189);
var userAgent = __webpack_require__(108);
var promiseResolve = __webpack_require__(190);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(15)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(77)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(82)($Promise, PROMISE);
__webpack_require__(74)(PROMISE);
Wrapper = __webpack_require__(44)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(105)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(195);
var validate = __webpack_require__(78);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(109)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $typed = __webpack_require__(110);
var buffer = __webpack_require__(153);
var anObject = __webpack_require__(7);
var toAbsoluteIndex = __webpack_require__(71);
var toLength = __webpack_require__(16);
var isObject = __webpack_require__(11);
var ArrayBuffer = __webpack_require__(8).ArrayBuffer;
var speciesConstructor = __webpack_require__(95);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(10)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(74)(ARRAY_BUFFER);


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(110).ABV, {
  DataView: __webpack_require__(153).DataView
});


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(57)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(57)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(57)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(57)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(57)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(57)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(57)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(57)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(57)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(29);
var anObject = __webpack_require__(7);
var rApply = (__webpack_require__(8).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(10)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(72);
var aFunction = __webpack_require__(29);
var anObject = __webpack_require__(7);
var isObject = __webpack_require__(11);
var fails = __webpack_require__(10);
var bind = __webpack_require__(175);
var rConstruct = (__webpack_require__(8).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(20);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(7);
var toPrimitive = __webpack_require__(50);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(10)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(39).f;
var anObject = __webpack_require__(7);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(7);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(139)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(39);
var getPrototypeOf = __webpack_require__(40);
var has = __webpack_require__(37);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(11);
var anObject = __webpack_require__(7);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(39);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(7);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(40);
var anObject = __webpack_require__(7);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(7);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(197) });


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(7);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(20);
var gOPD = __webpack_require__(39);
var getPrototypeOf = __webpack_require__(40);
var has = __webpack_require__(37);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(68);
var anObject = __webpack_require__(7);
var isObject = __webpack_require__(11);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(132);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(100)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(64)('includes');


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(198);
var toObject = __webpack_require__(22);
var toLength = __webpack_require__(16);
var aFunction = __webpack_require__(29);
var arraySpeciesCreate = __webpack_require__(145);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(64)('flatMap');


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(198);
var toObject = __webpack_require__(22);
var toLength = __webpack_require__(16);
var toInteger = __webpack_require__(47);
var arraySpeciesCreate = __webpack_require__(145);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(64)('flatten');


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0);
var $at = __webpack_require__(103)(true);
var $fails = __webpack_require__(10);

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});

$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(199);
var userAgent = __webpack_require__(108);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(199);
var userAgent = __webpack_require__(108);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(84)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(84)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(0);
var defined = __webpack_require__(51);
var toLength = __webpack_require__(16);
var isRegExp = __webpack_require__(104);
var getFlags = __webpack_require__(94);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(139)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(128)('asyncIterator');


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(128)('observable');


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(197);
var toIObject = __webpack_require__(38);
var gOPD = __webpack_require__(39);
var createProperty = __webpack_require__(143);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(200)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(200)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(22);
var aFunction = __webpack_require__(29);
var $defineProperty = __webpack_require__(20);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(18) && $export($export.P + __webpack_require__(111), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(22);
var aFunction = __webpack_require__(29);
var $defineProperty = __webpack_require__(20);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(18) && $export($export.P + __webpack_require__(111), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(22);
var toPrimitive = __webpack_require__(50);
var getPrototypeOf = __webpack_require__(40);
var getOwnPropertyDescriptor = __webpack_require__(39).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(18) && $export($export.P + __webpack_require__(111), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(22);
var toPrimitive = __webpack_require__(50);
var getPrototypeOf = __webpack_require__(40);
var getOwnPropertyDescriptor = __webpack_require__(39).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(18) && $export($export.P + __webpack_require__(111), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(201)('Map') });


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(201)('Set') });


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(112)('Map');


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(112)('Set');


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(112)('WeakMap');


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(112)('WeakSet');


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(113)('Map');


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(113)('Set');


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(113)('WeakMap');


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(113)('WeakSet');


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.G, { global: __webpack_require__(8) });


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', { global: __webpack_require__(8) });


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0);
var cof = __webpack_require__(46);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var scale = __webpack_require__(203);
var fround = __webpack_require__(182);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { scale: __webpack_require__(203) });


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(0);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(0);
var core = __webpack_require__(44);
var global = __webpack_require__(8);
var speciesConstructor = __webpack_require__(95);
var promiseResolve = __webpack_require__(190);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(0);
var newPromiseCapability = __webpack_require__(152);
var perform = __webpack_require__(189);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(58);
var anObject = __webpack_require__(7);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(58);
var anObject = __webpack_require__(7);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(58);
var anObject = __webpack_require__(7);
var getPrototypeOf = __webpack_require__(40);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(193);
var from = __webpack_require__(202);
var metadata = __webpack_require__(58);
var anObject = __webpack_require__(7);
var getPrototypeOf = __webpack_require__(40);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(58);
var anObject = __webpack_require__(7);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(58);
var anObject = __webpack_require__(7);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(58);
var anObject = __webpack_require__(7);
var getPrototypeOf = __webpack_require__(40);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(58);
var anObject = __webpack_require__(7);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(58);
var anObject = __webpack_require__(7);
var aFunction = __webpack_require__(29);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(0);
var microtask = __webpack_require__(151)();
var process = __webpack_require__(8).process;
var isNode = __webpack_require__(46)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(0);
var global = __webpack_require__(8);
var core = __webpack_require__(44);
var microtask = __webpack_require__(151)();
var OBSERVABLE = __webpack_require__(15)('observable');
var aFunction = __webpack_require__(29);
var anObject = __webpack_require__(7);
var anInstance = __webpack_require__(75);
var redefineAll = __webpack_require__(77);
var hide = __webpack_require__(32);
var forOf = __webpack_require__(76);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(74)('Observable');


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(8);
var $export = __webpack_require__(0);
var userAgent = __webpack_require__(108);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(150);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(147);
var getKeys = __webpack_require__(70);
var redefine = __webpack_require__(33);
var global = __webpack_require__(8);
var hide = __webpack_require__(32);
var Iterators = __webpack_require__(85);
var wks = __webpack_require__(15);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(542);
module.exports = __webpack_require__(44).RegExp.escape;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(0);
var $re = __webpack_require__(543)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_headful__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_headful___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_headful__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_the_mask__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate_dist_locale_ru__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate_dist_locale_ru___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vee_validate_dist_locale_ru__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_vue__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__routes__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_router__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Touchspin__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_InputDate__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_DropDown__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ProjectSelect__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ComplexFilter__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_PopupWindow__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_SearchFilter__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Chart__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_SlideDown__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_FaqComponent__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_FirstLaunch__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_DomainFolder__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__helpers_filters__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__helpers_directives__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__helpers_auth_mixin__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__helpers_common_mixin__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__helpers_custom_validators__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_outside_events__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_outside_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vue_outside_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_InputTime__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_BaseCounter__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_PdfViewer__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_VideoViewer__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_PresentationViewer__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_ScormViewer__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_FroalaEditor__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_CheckedDown__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_DropZone__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_ImageSetting__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_Notification__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__css_style_css__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__css_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__css_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__node_modules_toastr_build_toastr_css__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__node_modules_toastr_build_toastr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__node_modules_toastr_build_toastr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__assets_Bootstrap_bootstrapdatepicker3_min_css__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__assets_Bootstrap_bootstrapdatepicker3_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__assets_Bootstrap_bootstrapdatepicker3_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__assets_LightBox_style_css__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__assets_LightBox_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__assets_LightBox_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__assets_BootstrapTimepicker_bootstrap_timepicker_min_css__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__assets_BootstrapTimepicker_bootstrap_timepicker_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__assets_BootstrapTimepicker_bootstrap_timepicker_min_css__);













































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_the_mask___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_26_vue_outside_events___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].localize('ru', __WEBPACK_IMPORTED_MODULE_5_vee_validate_dist_locale_ru___default.a);
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].localize({
    ru: {
        messages: {
            confirmed: function confirmed(e) {
                return '\u041F\u043E\u043B\u0435 \xAB' + e + '\xBB \u043D\u0435 \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u0435\u0442';
            },
            required: function required(e) {
                return '\u041F\u043E\u043B\u0435 \xAB' + e + '\xBB \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0434\u043B\u044F \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F';
            },
            bik: function bik(e) {
                return '\u041F\u043E\u043B\u0435 \xAB' + e + '\xBB \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043E \u043D\u0435 \u0432\u0435\u0440\u043D\u043E';
            },
            cs: function cs(e) {
                return '\u041F\u043E\u043B\u0435 \xAB' + e + '\xBB \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043E \u043D\u0435 \u0432\u0435\u0440\u043D\u043E';
            },
            rs: function rs(e) {
                return '\u041F\u043E\u043B\u0435 \xAB' + e + '\xBB \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043E \u043D\u0435 \u0432\u0435\u0440\u043D\u043E';
            },
            jsonArray: function jsonArray(e) {
                return '\u041F\u043E\u043B\u0435 \xAB' + e + '\xBB \u0438\u043C\u0435\u0435\u0442 \u043D\u0435 \u0432\u0435\u0440\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u0434\u043B\u044F \u0442\u0438\u043F\u0430 \u0421\u043F\u0438\u0441\u043E\u043A';
            },
            lonlat: function lonlat(e) {
                return '\u041F\u043E\u043B\u0435 \xAB' + e + '\xBB \u0438\u043C\u0435\u0435\u0442 \u043D\u0435 \u0432\u0435\u0440\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442';
            },
            passportSeries: function passportSeries(e, args) {
                if (args.length > 0 && args[0] === 2) {
                    return '\u0421\u0435\u0440\u0438\u044F \u043F\u0430\u0441\u043F\u043E\u0440\u0442\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0441\u043E\u0441\u0442\u043E\u044F\u0442\u044C \u0438\u0437 2 \u0446\u0438\u0444\u0440';
                } else {
                    return '\u0421\u0435\u0440\u0438\u044F \u043F\u0430\u0441\u043F\u043E\u0440\u0442\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0441\u043E\u0441\u0442\u043E\u044F\u0442\u044C \u0438\u0437 4 \u0446\u0438\u0444\u0440';
                }
            },
            passportNumber: function passportNumber(e, args) {
                if (args.length > 0 && args[0] === 7) {
                    return '\u041D\u043E\u043C\u0435\u0440 \u043F\u0430\u0441\u043F\u043E\u0440\u0442\u0430 \u0434\u043E\u043B\u0436\u0435\u043D \u0441\u043E\u0441\u0442\u043E\u044F\u0442\u044C \u0438\u0437 7 \u0446\u0438\u0444\u0440';
                } else {
                    return '\u041D\u043E\u043C\u0435\u0440 \u043F\u0430\u0441\u043F\u043E\u0440\u0442\u0430 \u0434\u043E\u043B\u0436\u0435\u043D \u0441\u043E\u0441\u0442\u043E\u044F\u0442\u044C \u0438\u0437 6 \u0446\u0438\u0444\u0440';
                }
            },
            innfl: function innfl(e) {
                return '\u0418\u041D\u041D \u0444\u0438\u0437\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u043B\u0438\u0446\u0430 \u0434\u043E\u043B\u0436\u0435\u043D \u0441\u043E\u0441\u0442\u043E\u044F\u0442\u044C \u0438\u0437 12 \u0446\u0438\u0444\u0440';
            }
        }
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('vue-headful', __WEBPACK_IMPORTED_MODULE_3_vue_headful___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('touch-spin', __WEBPACK_IMPORTED_MODULE_9__components_Touchspin__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('input-date', __WEBPACK_IMPORTED_MODULE_10__components_InputDate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('drop-down', __WEBPACK_IMPORTED_MODULE_11__components_DropDown__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('project-select', __WEBPACK_IMPORTED_MODULE_12__components_ProjectSelect__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('complex-filter', __WEBPACK_IMPORTED_MODULE_13__components_ComplexFilter__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('popup-window', __WEBPACK_IMPORTED_MODULE_14__components_PopupWindow__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('search-filter', __WEBPACK_IMPORTED_MODULE_15__components_SearchFilter__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('chart', __WEBPACK_IMPORTED_MODULE_16__components_Chart__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('slide-down', __WEBPACK_IMPORTED_MODULE_17__components_SlideDown__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('faq-component', __WEBPACK_IMPORTED_MODULE_18__components_FaqComponent__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('first-launch', __WEBPACK_IMPORTED_MODULE_19__components_FirstLaunch__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('domain-folder', __WEBPACK_IMPORTED_MODULE_20__components_DomainFolder__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('input-time', __WEBPACK_IMPORTED_MODULE_27__components_InputTime__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('base-counter', __WEBPACK_IMPORTED_MODULE_28__components_BaseCounter__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('pdf-viewer', __WEBPACK_IMPORTED_MODULE_29__components_PdfViewer__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('video-viewer', __WEBPACK_IMPORTED_MODULE_30__components_VideoViewer__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('presentation-viewer', __WEBPACK_IMPORTED_MODULE_31__components_PresentationViewer__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('scorm-viewer', __WEBPACK_IMPORTED_MODULE_32__components_ScormViewer__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('froala-editor', __WEBPACK_IMPORTED_MODULE_33__components_FroalaEditor__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('checked-down', __WEBPACK_IMPORTED_MODULE_34__components_CheckedDown__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('drop-zone', __WEBPACK_IMPORTED_MODULE_35__components_DropZone__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('image-setting', __WEBPACK_IMPORTED_MODULE_36__components_ImageSetting__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('notification', __WEBPACK_IMPORTED_MODULE_37__components_Notification__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin(__WEBPACK_IMPORTED_MODULE_23__helpers_auth_mixin__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin(__WEBPACK_IMPORTED_MODULE_24__helpers_common_mixin__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_8_vue_router__["a" /* default */]({
    routes: __WEBPACK_IMPORTED_MODULE_7__routes__["a" /* default */],
    mode: 'history'
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#root',
    router: router,
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_6__App_vue__["a" /* default */]);
    }
});

/*для отображения SVG*/
(function () {
    if ("undefined" !== typeof window && window.addEventListener) {
        var e = Object.create(null),
            l,
            d = function d() {
            clearTimeout(l);l = setTimeout(n, 100);
        },
            m = function m() {},
            t = function t() {
            window.addEventListener("resize", d, !1);window.addEventListener("orientationchange", d, !1);if (window.MutationObserver) {
                var k = new MutationObserver(d);k.observe(document.documentElement, { childList: !0, subtree: !0, attributes: !0 });m = function m() {
                    try {
                        k.disconnect(), window.removeEventListener("resize", d, !1), window.removeEventListener("orientationchange", d, !1);
                    } catch (v) {
                        console.log('error svg');
                    }
                };
            } else document.documentElement.addEventListener("DOMSubtreeModified", d, !1), m = function m() {
                document.documentElement.removeEventListener("DOMSubtreeModified", d, !1);window.removeEventListener("resize", d, !1);window.removeEventListener("orientationchange", d, !1);
            };
        },
            u = function u(k) {
            function e(a) {
                if (void 0 !== a.protocol) var c = a;else c = document.createElement("a"), c.href = a;return c.protocol.replace(/:/g, "") + c.host;
            }if (window.XMLHttpRequest) {
                var d = new XMLHttpRequest();var m = e(location);k = e(k);d = void 0 === d.withCredentials && "" !== k && k !== m ? XDomainRequest || void 0 : XMLHttpRequest;
            }return d;
        };var n = function n() {
            function d() {
                --q;0 === q && (m(), t());
            }function l(a) {
                return function () {
                    !0 !== e[a.base] && (a.useEl.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", "#" + a.hash), a.useEl.hasAttribute("href") && a.useEl.setAttribute("href", "#" + a.hash));
                };
            }function p(a) {
                return function () {
                    var c = document.body,
                        b = document.createElement("x");a.onload = null;b.innerHTML = a.responseText;if (b = b.getElementsByTagName("svg")[0]) b.setAttribute("aria-hidden", "true"), b.style.position = "absolute", b.style.width = 0, b.style.height = 0, b.style.overflow = "hidden", c.insertBefore(b, c.firstChild);d();
                };
            }function n(a) {
                return function () {
                    a.onerror = null;a.ontimeout = null;d();
                };
            }var a,
                c,
                q = 0;m();var f = document.getElementsByTagName("use");for (c = 0; c < f.length; c += 1) {
                try {
                    var g = f[c].getBoundingClientRect();
                } catch (w) {
                    g = !1;
                }var h = (a = f[c].getAttribute("href") || f[c].getAttributeNS("http://www.w3.org/1999/xlink", "href") || f[c].getAttribute("xlink:href")) && a.split ? a.split("#") : ["", ""];var b = h[0];h = h[1];var r = g && 0 === g.left && 0 === g.right && 0 === g.top && 0 === g.bottom;g && 0 === g.width && 0 === g.height && !r ? (f[c].hasAttribute("href") && f[c].setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", a), b.length && (a = e[b], !0 !== a && setTimeout(l({ useEl: f[c], base: b, hash: h }), 0), void 0 === a && (h = u(b), void 0 !== h && (a = new h(), e[b] = a, a.onload = p(a), a.onerror = n(a), a.ontimeout = n(a), a.open("GET", b), a.send(), q += 1)))) : r ? b.length && e[b] && setTimeout(l({ useEl: f[c], base: b, hash: h }), 0) : void 0 === e[b] ? e[b] = !0 : e[b].onload && (e[b].abort(), delete e[b].onload, e[b] = !0);
            }f = "";q += 1;d();
        };var p = function p() {
            window.removeEventListener("load", p, !1);l = setTimeout(n, 0);
        };"complete" !== document.readyState ? window.addEventListener("load", p, !1) : p();
    }
})();

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(546);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49), __webpack_require__(126)))

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.3
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */
var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;
function Promise$1(executor) {
  this.state = PENDING;
  this.value = undefined;
  this.deferred = [];
  var promise = this;

  try {
    executor(function (x) {
      promise.resolve(x);
    }, function (r) {
      promise.reject(r);
    });
  } catch (e) {
    promise.reject(e);
  }
}

Promise$1.reject = function (r) {
  return new Promise$1(function (resolve, reject) {
    reject(r);
  });
};

Promise$1.resolve = function (x) {
  return new Promise$1(function (resolve, reject) {
    resolve(x);
  });
};

Promise$1.all = function all(iterable) {
  return new Promise$1(function (resolve, reject) {
    var count = 0,
        result = [];

    if (iterable.length === 0) {
      resolve(result);
    }

    function resolver(i) {
      return function (x) {
        result[i] = x;
        count += 1;

        if (count === iterable.length) {
          resolve(result);
        }
      };
    }

    for (var i = 0; i < iterable.length; i += 1) {
      Promise$1.resolve(iterable[i]).then(resolver(i), reject);
    }
  });
};

Promise$1.race = function race(iterable) {
  return new Promise$1(function (resolve, reject) {
    for (var i = 0; i < iterable.length; i += 1) {
      Promise$1.resolve(iterable[i]).then(resolve, reject);
    }
  });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
  var promise = this;

  if (promise.state === PENDING) {
    if (x === promise) {
      throw new TypeError('Promise settled with itself.');
    }

    var called = false;

    try {
      var then = x && x['then'];

      if (x !== null && typeof x === 'object' && typeof then === 'function') {
        then.call(x, function (x) {
          if (!called) {
            promise.resolve(x);
          }

          called = true;
        }, function (r) {
          if (!called) {
            promise.reject(r);
          }

          called = true;
        });
        return;
      }
    } catch (e) {
      if (!called) {
        promise.reject(e);
      }

      return;
    }

    promise.state = RESOLVED;
    promise.value = x;
    promise.notify();
  }
};

p.reject = function reject(reason) {
  var promise = this;

  if (promise.state === PENDING) {
    if (reason === promise) {
      throw new TypeError('Promise settled with itself.');
    }

    promise.state = REJECTED;
    promise.value = reason;
    promise.notify();
  }
};

p.notify = function notify() {
  var promise = this;
  nextTick(function () {
    if (promise.state !== PENDING) {
      while (promise.deferred.length) {
        var deferred = promise.deferred.shift(),
            onResolved = deferred[0],
            onRejected = deferred[1],
            resolve = deferred[2],
            reject = deferred[3];

        try {
          if (promise.state === RESOLVED) {
            if (typeof onResolved === 'function') {
              resolve(onResolved.call(undefined, promise.value));
            } else {
              resolve(promise.value);
            }
          } else if (promise.state === REJECTED) {
            if (typeof onRejected === 'function') {
              resolve(onRejected.call(undefined, promise.value));
            } else {
              reject(promise.value);
            }
          }
        } catch (e) {
          reject(e);
        }
      }
    }
  });
};

p.then = function then(onResolved, onRejected) {
  var promise = this;
  return new Promise$1(function (resolve, reject) {
    promise.deferred.push([onResolved, onRejected, resolve, reject]);
    promise.notify();
  });
};

p["catch"] = function (onRejected) {
  return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
  window.Promise = Promise$1;
}

function PromiseObj(executor, context) {
  if (executor instanceof Promise) {
    this.promise = executor;
  } else {
    this.promise = new Promise(executor.bind(context));
  }

  this.context = context;
}

PromiseObj.all = function (iterable, context) {
  return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
  return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
  return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
  return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
  this.context = context;
  return this;
};

p$1.then = function (fulfilled, rejected) {
  if (fulfilled && fulfilled.bind && this.context) {
    fulfilled = fulfilled.bind(this.context);
  }

  if (rejected && rejected.bind && this.context) {
    rejected = rejected.bind(this.context);
  }

  return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1["catch"] = function (rejected) {
  if (rejected && rejected.bind && this.context) {
    rejected = rejected.bind(this.context);
  }

  return new PromiseObj(this.promise["catch"](rejected), this.context);
};

p$1["finally"] = function (callback) {
  return this.then(function (value) {
    callback.call(this);
    return value;
  }, function (reason) {
    callback.call(this);
    return Promise.reject(reason);
  });
};

/**
 * Utility functions.
 */
var _ref = {},
    hasOwnProperty = _ref.hasOwnProperty,
    slice = [].slice,
    debug = false,
    ntick;
var inBrowser = typeof window !== 'undefined';
function Util (_ref2) {
  var config = _ref2.config,
      nextTick = _ref2.nextTick;
  ntick = nextTick;
  debug = config.debug || !config.silent;
}
function warn(msg) {
  if (typeof console !== 'undefined' && debug) {
    console.warn('[VueResource warn]: ' + msg);
  }
}
function error(msg) {
  if (typeof console !== 'undefined') {
    console.error(msg);
  }
}
function nextTick(cb, ctx) {
  return ntick(cb, ctx);
}
function trim(str) {
  return str ? str.replace(/^\s*|\s*$/g, '') : '';
}
function trimEnd(str, chars) {
  if (str && chars === undefined) {
    return str.replace(/\s+$/, '');
  }

  if (!str || !chars) {
    return str;
  }

  return str.replace(new RegExp("[" + chars + "]+$"), '');
}
function toLower(str) {
  return str ? str.toLowerCase() : '';
}
function toUpper(str) {
  return str ? str.toUpperCase() : '';
}
var isArray = Array.isArray;
function isString(val) {
  return typeof val === 'string';
}
function isFunction(val) {
  return typeof val === 'function';
}
function isObject(obj) {
  return obj !== null && typeof obj === 'object';
}
function isPlainObject(obj) {
  return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}
function isBlob(obj) {
  return typeof Blob !== 'undefined' && obj instanceof Blob;
}
function isFormData(obj) {
  return typeof FormData !== 'undefined' && obj instanceof FormData;
}
function when(value, fulfilled, rejected) {
  var promise = PromiseObj.resolve(value);

  if (arguments.length < 2) {
    return promise;
  }

  return promise.then(fulfilled, rejected);
}
function options(fn, obj, opts) {
  opts = opts || {};

  if (isFunction(opts)) {
    opts = opts.call(obj);
  }

  return merge(fn.bind({
    $vm: obj,
    $options: opts
  }), fn, {
    $options: opts
  });
}
function each(obj, iterator) {
  var i, key;

  if (isArray(obj)) {
    for (i = 0; i < obj.length; i++) {
      iterator.call(obj[i], obj[i], i);
    }
  } else if (isObject(obj)) {
    for (key in obj) {
      if (hasOwnProperty.call(obj, key)) {
        iterator.call(obj[key], obj[key], key);
      }
    }
  }

  return obj;
}
var assign = Object.assign || _assign;
function merge(target) {
  var args = slice.call(arguments, 1);
  args.forEach(function (source) {
    _merge(target, source, true);
  });
  return target;
}
function defaults(target) {
  var args = slice.call(arguments, 1);
  args.forEach(function (source) {
    for (var key in source) {
      if (target[key] === undefined) {
        target[key] = source[key];
      }
    }
  });
  return target;
}

function _assign(target) {
  var args = slice.call(arguments, 1);
  args.forEach(function (source) {
    _merge(target, source);
  });
  return target;
}

function _merge(target, source, deep) {
  for (var key in source) {
    if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
      if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
        target[key] = {};
      }

      if (isArray(source[key]) && !isArray(target[key])) {
        target[key] = [];
      }

      _merge(target[key], source[key], deep);
    } else if (source[key] !== undefined) {
      target[key] = source[key];
    }
  }
}

/**
 * Root Prefix Transform.
 */
function root (options$$1, next) {
  var url = next(options$$1);

  if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
    url = trimEnd(options$$1.root, '/') + '/' + url;
  }

  return url;
}

/**
 * Query Parameter Transform.
 */
function query (options$$1, next) {
  var urlParams = Object.keys(Url.options.params),
      query = {},
      url = next(options$$1);
  each(options$$1.params, function (value, key) {
    if (urlParams.indexOf(key) === -1) {
      query[key] = value;
    }
  });
  query = Url.params(query);

  if (query) {
    url += (url.indexOf('?') == -1 ? '?' : '&') + query;
  }

  return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */
function expand(url, params, variables) {
  var tmpl = parse(url),
      expanded = tmpl.expand(params);

  if (variables) {
    variables.push.apply(variables, tmpl.vars);
  }

  return expanded;
}
function parse(template) {
  var operators = ['+', '#', '.', '/', ';', '?', '&'],
      variables = [];
  return {
    vars: variables,
    expand: function expand(context) {
      return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
        if (expression) {
          var operator = null,
              values = [];

          if (operators.indexOf(expression.charAt(0)) !== -1) {
            operator = expression.charAt(0);
            expression = expression.substr(1);
          }

          expression.split(/,/g).forEach(function (variable) {
            var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
            values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
            variables.push(tmp[1]);
          });

          if (operator && operator !== '+') {
            var separator = ',';

            if (operator === '?') {
              separator = '&';
            } else if (operator !== '#') {
              separator = operator;
            }

            return (values.length !== 0 ? operator : '') + values.join(separator);
          } else {
            return values.join(',');
          }
        } else {
          return encodeReserved(literal);
        }
      });
    }
  };
}

function getValues(context, operator, key, modifier) {
  var value = context[key],
      result = [];

  if (isDefined(value) && value !== '') {
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
      value = value.toString();

      if (modifier && modifier !== '*') {
        value = value.substring(0, parseInt(modifier, 10));
      }

      result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
    } else {
      if (modifier === '*') {
        if (Array.isArray(value)) {
          value.filter(isDefined).forEach(function (value) {
            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
          });
        } else {
          Object.keys(value).forEach(function (k) {
            if (isDefined(value[k])) {
              result.push(encodeValue(operator, value[k], k));
            }
          });
        }
      } else {
        var tmp = [];

        if (Array.isArray(value)) {
          value.filter(isDefined).forEach(function (value) {
            tmp.push(encodeValue(operator, value));
          });
        } else {
          Object.keys(value).forEach(function (k) {
            if (isDefined(value[k])) {
              tmp.push(encodeURIComponent(k));
              tmp.push(encodeValue(operator, value[k].toString()));
            }
          });
        }

        if (isKeyOperator(operator)) {
          result.push(encodeURIComponent(key) + '=' + tmp.join(','));
        } else if (tmp.length !== 0) {
          result.push(tmp.join(','));
        }
      }
    }
  } else {
    if (operator === ';') {
      result.push(encodeURIComponent(key));
    } else if (value === '' && (operator === '&' || operator === '?')) {
      result.push(encodeURIComponent(key) + '=');
    } else if (value === '') {
      result.push('');
    }
  }

  return result;
}

function isDefined(value) {
  return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
  return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {
  value = operator === '+' || operator === '#' ? encodeReserved(value) : encodeURIComponent(value);

  if (key) {
    return encodeURIComponent(key) + '=' + value;
  } else {
    return value;
  }
}

function encodeReserved(str) {
  return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
    if (!/%[0-9A-Fa-f]/.test(part)) {
      part = encodeURI(part);
    }

    return part;
  }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */
function template (options) {
  var variables = [],
      url = expand(options.url, options.params, variables);
  variables.forEach(function (key) {
    delete options.params[key];
  });
  return url;
}

/**
 * Service for URL templating.
 */
function Url(url, params) {
  var self = this || {},
      options$$1 = url,
      transform;

  if (isString(url)) {
    options$$1 = {
      url: url,
      params: params
    };
  }

  options$$1 = merge({}, Url.options, self.$options, options$$1);
  Url.transforms.forEach(function (handler) {
    if (isString(handler)) {
      handler = Url.transform[handler];
    }

    if (isFunction(handler)) {
      transform = factory(handler, transform, self.$vm);
    }
  });
  return transform(options$$1);
}
/**
 * Url options.
 */

Url.options = {
  url: '',
  root: null,
  params: {}
};
/**
 * Url transforms.
 */

Url.transform = {
  template: template,
  query: query,
  root: root
};
Url.transforms = ['template', 'query', 'root'];
/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {
  var params = [],
      escape = encodeURIComponent;

  params.add = function (key, value) {
    if (isFunction(value)) {
      value = value();
    }

    if (value === null) {
      value = '';
    }

    this.push(escape(key) + '=' + escape(value));
  };

  serialize(params, obj);
  return params.join('&').replace(/%20/g, '+');
};
/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */


Url.parse = function (url) {
  var el = document.createElement('a');

  if (document.documentMode) {
    el.href = url;
    url = el.href;
  }

  el.href = url;
  return {
    href: el.href,
    protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
    port: el.port,
    host: el.host,
    hostname: el.hostname,
    pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
    search: el.search ? el.search.replace(/^\?/, '') : '',
    hash: el.hash ? el.hash.replace(/^#/, '') : ''
  };
};

function factory(handler, next, vm) {
  return function (options$$1) {
    return handler.call(vm, options$$1, next);
  };
}

function serialize(params, obj, scope) {
  var array = isArray(obj),
      plain = isPlainObject(obj),
      hash;
  each(obj, function (value, key) {
    hash = isObject(value) || isArray(value);

    if (scope) {
      key = scope + '[' + (plain || hash ? key : '') + ']';
    }

    if (!scope && array) {
      params.add(value.name, value.value);
    } else if (hash) {
      serialize(params, value, key);
    } else {
      params.add(key, value);
    }
  });
}

/**
 * XDomain client (Internet Explorer).
 */
function xdrClient (request) {
  return new PromiseObj(function (resolve) {
    var xdr = new XDomainRequest(),
        handler = function handler(_ref) {
      var type = _ref.type;
      var status = 0;

      if (type === 'load') {
        status = 200;
      } else if (type === 'error') {
        status = 500;
      }

      resolve(request.respondWith(xdr.responseText, {
        status: status
      }));
    };

    request.abort = function () {
      return xdr.abort();
    };

    xdr.open(request.method, request.getUrl());

    if (request.timeout) {
      xdr.timeout = request.timeout;
    }

    xdr.onload = handler;
    xdr.onabort = handler;
    xdr.onerror = handler;
    xdr.ontimeout = handler;

    xdr.onprogress = function () {};

    xdr.send(request.getBody());
  });
}

/**
 * CORS Interceptor.
 */
var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();
function cors (request) {
  if (inBrowser) {
    var orgUrl = Url.parse(location.href);
    var reqUrl = Url.parse(request.getUrl());

    if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {
      request.crossOrigin = true;
      request.emulateHTTP = false;

      if (!SUPPORTS_CORS) {
        request.client = xdrClient;
      }
    }
  }
}

/**
 * Form data Interceptor.
 */
function form (request) {
  if (isFormData(request.body)) {
    request.headers["delete"]('Content-Type');
  } else if (isObject(request.body) && request.emulateJSON) {
    request.body = Url.params(request.body);
    request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
  }
}

/**
 * JSON Interceptor.
 */
function json (request) {
  var type = request.headers.get('Content-Type') || '';

  if (isObject(request.body) && type.indexOf('application/json') === 0) {
    request.body = JSON.stringify(request.body);
  }

  return function (response) {
    return response.bodyText ? when(response.text(), function (text) {
      var type = response.headers.get('Content-Type') || '';

      if (type.indexOf('application/json') === 0 || isJson(text)) {
        try {
          response.body = JSON.parse(text);
        } catch (e) {
          response.body = null;
        }
      } else {
        response.body = text;
      }

      return response;
    }) : response;
  };
}

function isJson(str) {
  var start = str.match(/^\s*(\[|\{)/);
  var end = {
    '[': /]\s*$/,
    '{': /}\s*$/
  };
  return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */
function jsonpClient (request) {
  return new PromiseObj(function (resolve) {
    var name = request.jsonp || 'callback',
        callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2),
        body = null,
        handler,
        script;

    handler = function handler(_ref) {
      var type = _ref.type;
      var status = 0;

      if (type === 'load' && body !== null) {
        status = 200;
      } else if (type === 'error') {
        status = 500;
      }

      if (status && window[callback]) {
        delete window[callback];
        document.body.removeChild(script);
      }

      resolve(request.respondWith(body, {
        status: status
      }));
    };

    window[callback] = function (result) {
      body = JSON.stringify(result);
    };

    request.abort = function () {
      handler({
        type: 'abort'
      });
    };

    request.params[name] = callback;

    if (request.timeout) {
      setTimeout(request.abort, request.timeout);
    }

    script = document.createElement('script');
    script.src = request.getUrl();
    script.type = 'text/javascript';
    script.async = true;
    script.onload = handler;
    script.onerror = handler;
    document.body.appendChild(script);
  });
}

/**
 * JSONP Interceptor.
 */
function jsonp (request) {
  if (request.method == 'JSONP') {
    request.client = jsonpClient;
  }
}

/**
 * Before Interceptor.
 */
function before (request) {
  if (isFunction(request.before)) {
    request.before.call(this, request);
  }
}

/**
 * HTTP method override Interceptor.
 */
function method (request) {
  if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
    request.headers.set('X-HTTP-Method-Override', request.method);
    request.method = 'POST';
  }
}

/**
 * Header Interceptor.
 */
function header (request) {
  var headers = assign({}, Http.headers.common, !request.crossOrigin ? Http.headers.custom : {}, Http.headers[toLower(request.method)]);
  each(headers, function (value, name) {
    if (!request.headers.has(name)) {
      request.headers.set(name, value);
    }
  });
}

/**
 * XMLHttp client (Browser).
 */
function xhrClient (request) {
  return new PromiseObj(function (resolve) {
    var xhr = new XMLHttpRequest(),
        handler = function handler(event) {
      var response = request.respondWith('response' in xhr ? xhr.response : xhr.responseText, {
        status: xhr.status === 1223 ? 204 : xhr.status,
        // IE9 status bug
        statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
      });
      each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
        response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
      });
      resolve(response);
    };

    request.abort = function () {
      return xhr.abort();
    };

    xhr.open(request.method, request.getUrl(), true);

    if (request.timeout) {
      xhr.timeout = request.timeout;
    }

    if (request.responseType && 'responseType' in xhr) {
      xhr.responseType = request.responseType;
    }

    if (request.withCredentials || request.credentials) {
      xhr.withCredentials = true;
    }

    if (!request.crossOrigin) {
      request.headers.set('X-Requested-With', 'XMLHttpRequest');
    } // deprecated use downloadProgress


    if (isFunction(request.progress) && request.method === 'GET') {
      xhr.addEventListener('progress', request.progress);
    }

    if (isFunction(request.downloadProgress)) {
      xhr.addEventListener('progress', request.downloadProgress);
    } // deprecated use uploadProgress


    if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
      xhr.upload.addEventListener('progress', request.progress);
    }

    if (isFunction(request.uploadProgress) && xhr.upload) {
      xhr.upload.addEventListener('progress', request.uploadProgress);
    }

    request.headers.forEach(function (value, name) {
      xhr.setRequestHeader(name, value);
    });
    xhr.onload = handler;
    xhr.onabort = handler;
    xhr.onerror = handler;
    xhr.ontimeout = handler;
    xhr.send(request.getBody());
  });
}

/**
 * Http client (Node).
 */
function nodeClient (request) {
  var client = __webpack_require__(548);

  return new PromiseObj(function (resolve) {
    var url = request.getUrl();
    var body = request.getBody();
    var method = request.method;
    var headers = {},
        handler;
    request.headers.forEach(function (value, name) {
      headers[name] = value;
    });
    client(url, {
      body: body,
      method: method,
      headers: headers
    }).then(handler = function handler(resp) {
      var response = request.respondWith(resp.body, {
        status: resp.statusCode,
        statusText: trim(resp.statusMessage)
      });
      each(resp.headers, function (value, name) {
        response.headers.set(name, value);
      });
      resolve(response);
    }, function (error$$1) {
      return handler(error$$1.response);
    });
  });
}

/**
 * Base client.
 */
function Client (context) {
  var reqHandlers = [sendRequest],
      resHandlers = [];

  if (!isObject(context)) {
    context = null;
  }

  function Client(request) {
    while (reqHandlers.length) {
      var handler = reqHandlers.pop();

      if (isFunction(handler)) {
        var _ret = function () {
          var response = void 0,
              next = void 0;
          response = handler.call(context, request, function (val) {
            return next = val;
          }) || next;

          if (isObject(response)) {
            return {
              v: new PromiseObj(function (resolve, reject) {
                resHandlers.forEach(function (handler) {
                  response = when(response, function (response) {
                    return handler.call(context, response) || response;
                  }, reject);
                });
                when(response, resolve, reject);
              }, context)
            };
          }

          if (isFunction(response)) {
            resHandlers.unshift(response);
          }
        }();

        if (typeof _ret === "object") return _ret.v;
      } else {
        warn("Invalid interceptor of type " + typeof handler + ", must be a function");
      }
    }
  }

  Client.use = function (handler) {
    reqHandlers.push(handler);
  };

  return Client;
}

function sendRequest(request) {
  var client = request.client || (inBrowser ? xhrClient : nodeClient);
  return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = /*#__PURE__*/function () {
  function Headers(headers) {
    var _this = this;

    this.map = {};
    each(headers, function (value, name) {
      return _this.append(name, value);
    });
  }

  var _proto = Headers.prototype;

  _proto.has = function has(name) {
    return getName(this.map, name) !== null;
  };

  _proto.get = function get(name) {
    var list = this.map[getName(this.map, name)];
    return list ? list.join() : null;
  };

  _proto.getAll = function getAll(name) {
    return this.map[getName(this.map, name)] || [];
  };

  _proto.set = function set(name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
  };

  _proto.append = function append(name, value) {
    var list = this.map[getName(this.map, name)];

    if (list) {
      list.push(trim(value));
    } else {
      this.set(name, value);
    }
  };

  _proto["delete"] = function _delete(name) {
    delete this.map[getName(this.map, name)];
  };

  _proto.deleteAll = function deleteAll() {
    this.map = {};
  };

  _proto.forEach = function forEach(callback, thisArg) {
    var _this2 = this;

    each(this.map, function (list, name) {
      each(list, function (value) {
        return callback.call(thisArg, value, name, _this2);
      });
    });
  };

  return Headers;
}();

function getName(map, name) {
  return Object.keys(map).reduce(function (prev, curr) {
    return toLower(name) === toLower(curr) ? curr : prev;
  }, null);
}

function normalizeName(name) {
  if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
    throw new TypeError('Invalid character in header field name');
  }

  return trim(name);
}

/**
 * HTTP Response.
 */

var Response = /*#__PURE__*/function () {
  function Response(body, _ref) {
    var url = _ref.url,
        headers = _ref.headers,
        status = _ref.status,
        statusText = _ref.statusText;
    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {
      this.bodyText = body;
    } else if (isBlob(body)) {
      this.bodyBlob = body;

      if (isBlobText(body)) {
        this.bodyText = blobText(body);
      }
    }
  }

  var _proto = Response.prototype;

  _proto.blob = function blob() {
    return when(this.bodyBlob);
  };

  _proto.text = function text() {
    return when(this.bodyText);
  };

  _proto.json = function json() {
    return when(this.text(), function (text) {
      return JSON.parse(text);
    });
  };

  return Response;
}();
Object.defineProperty(Response.prototype, 'data', {
  get: function get() {
    return this.body;
  },
  set: function set(body) {
    this.body = body;
  }
});

function blobText(body) {
  return new PromiseObj(function (resolve) {
    var reader = new FileReader();
    reader.readAsText(body);

    reader.onload = function () {
      resolve(reader.result);
    };
  });
}

function isBlobText(body) {
  return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = /*#__PURE__*/function () {
  function Request(options$$1) {
    this.body = null;
    this.params = {};
    assign(this, options$$1, {
      method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
      this.headers = new Headers(this.headers);
    }
  }

  var _proto = Request.prototype;

  _proto.getUrl = function getUrl() {
    return Url(this);
  };

  _proto.getBody = function getBody() {
    return this.body;
  };

  _proto.respondWith = function respondWith(body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {
      url: this.getUrl()
    }));
  };

  return Request;
}();

/**
 * Service for sending network requests.
 */
var COMMON_HEADERS = {
  'Accept': 'application/json, text/plain, */*'
};
var JSON_CONTENT_TYPE = {
  'Content-Type': 'application/json;charset=utf-8'
};
function Http(options$$1) {
  var self = this || {},
      client = Client(self.$vm);
  defaults(options$$1 || {}, self.$options, Http.options);
  Http.interceptors.forEach(function (handler) {
    if (isString(handler)) {
      handler = Http.interceptor[handler];
    }

    if (isFunction(handler)) {
      client.use(handler);
    }
  });
  return client(new Request(options$$1)).then(function (response) {
    return response.ok ? response : PromiseObj.reject(response);
  }, function (response) {
    if (response instanceof Error) {
      error(response);
    }

    return PromiseObj.reject(response);
  });
}
Http.options = {};
Http.headers = {
  put: JSON_CONTENT_TYPE,
  post: JSON_CONTENT_TYPE,
  patch: JSON_CONTENT_TYPE,
  "delete": JSON_CONTENT_TYPE,
  common: COMMON_HEADERS,
  custom: {}
};
Http.interceptor = {
  before: before,
  method: method,
  jsonp: jsonp,
  json: json,
  form: form,
  header: header,
  cors: cors
};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];
['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {
  Http[method$$1] = function (url, options$$1) {
    return this(assign(options$$1 || {}, {
      url: url,
      method: method$$1
    }));
  };
});
['post', 'put', 'patch'].forEach(function (method$$1) {
  Http[method$$1] = function (url, body, options$$1) {
    return this(assign(options$$1 || {}, {
      url: url,
      method: method$$1,
      body: body
    }));
  };
});

/**
 * Service for interacting with RESTful services.
 */
function Resource(url, params, actions, options$$1) {
  var self = this || {},
      resource = {};
  actions = assign({}, Resource.actions, actions);
  each(actions, function (action, name) {
    action = merge({
      url: url,
      params: assign({}, params)
    }, options$$1, action);

    resource[name] = function () {
      return (self.$http || Http)(opts(action, arguments));
    };
  });
  return resource;
}

function opts(action, args) {
  var options$$1 = assign({}, action),
      params = {},
      body;

  switch (args.length) {
    case 2:
      params = args[0];
      body = args[1];
      break;

    case 1:
      if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
        body = args[0];
      } else {
        params = args[0];
      }

      break;

    case 0:
      break;

    default:
      throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
  }

  options$$1.body = body;
  options$$1.params = assign({}, options$$1.params, params);
  return options$$1;
}

Resource.actions = {
  get: {
    method: 'GET'
  },
  save: {
    method: 'POST'
  },
  query: {
    method: 'GET'
  },
  update: {
    method: 'PUT'
  },
  remove: {
    method: 'DELETE'
  },
  "delete": {
    method: 'DELETE'
  }
};

/**
 * Install plugin.
 */

function plugin(Vue) {
  if (plugin.installed) {
    return;
  }

  Util(Vue);
  Vue.url = Url;
  Vue.http = Http;
  Vue.resource = Resource;
  Vue.Promise = PromiseObj;
  Object.defineProperties(Vue.prototype, {
    $url: {
      get: function get() {
        return options(Vue.url, this, this.$options.url);
      }
    },
    $http: {
      get: function get() {
        return options(Vue.http, this, this.$options.http);
      }
    },
    $resource: {
      get: function get() {
        return Vue.resource.bind(this);
      }
    },
    $promise: {
      get: function get() {
        var _this = this;

        return function (executor) {
          return new Vue.Promise(executor, _this);
        };
      }
    }
  });
}

if (typeof window !== 'undefined' && window.Vue && !window.Vue.resource) {
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 548 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _headful = __webpack_require__(550);

var _headful2 = _interopRequireDefault(_headful);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handler = function handler(props) {
    return (0, _headful2.default)(getPassedProps(props));
};

exports.default = {
    name: 'vue-headful',
    props: Object.keys(_headful2.default.props),
    watch: {
        '$props': {
            handler: handler,
            deep: true,
            immediate: true
        }
    },
    activated: function activated() {
        // required for keep-alive components https://vuejs.org/v2/api/#keep-alive
        handler(this.$props);
    },
    render: function render() {}
};


function getPassedProps(props) {
    return Object.keys(props).reduce(function (passedProps, propKey) {
        if (props[propKey] !== undefined) {
            passedProps[propKey] = props[propKey];
        }
        return passedProps;
    }, {});
}

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = headful;


var conf = {
    debug: false
};

var propertySetters = {
    html: function html(obj) {
        obj && Object.keys(obj).forEach(function (selector) {
            return setRootElementAttributes(selector, obj[selector]);
        });
    },
    head: function head(obj) {
        obj && Object.keys(obj).forEach(function (selector) {
            return setHeadElementAttributes(selector, obj[selector]);
        });
    },
    title: function title(val) {
        document.title = isRemoveValue(val) ? '' : val;
        setMetaContent('itemprop="name"', val);
        setMetaContent('property="og:title"', val);
        setMetaContent('name="twitter:title"', val);
    },
    description: function description(val) {
        setMetaContent('name="description"', val);
        setMetaContent('itemprop="description"', val);
        setMetaContent('property="og:description"', val);
        setMetaContent('name="twitter:description"', val);
    },
    keywords: function keywords(val) {
        setMetaContent('name="keywords"', Array.isArray(val) ? val.join(', ') : val);
    },
    image: function image(val) {
        setMetaContent('itemprop="image"', val);
        setMetaContent('property="og:image"', val);
        setMetaContent('name="twitter:image"', val);
    },
    lang: function lang(val, props) {
        setRootElementAttributes('html', { lang: val });
        noProp(props, this.ogLocale) && setOgLocaleIfValid(val);
    },
    ogLocale: function ogLocale(val) {
        setMetaContent('property="og:locale"', val);
    },
    url: function url(val) {
        setHeadElementAttributes('link[rel="canonical"]', { href: val });
        setMetaContent('property="og:url"', val);
        setMetaContent('name="twitter:url"', val);
    }
};

function headful(props, userConf) {
    Object.assign(conf, userConf);
    Object.keys(props).forEach(function (prop) {
        if (!propertySetters.hasOwnProperty(prop)) {
            throw new Error('Headful: Property \'' + prop + '\' is unknown.');
        }
        propertySetters[prop](props[prop], props);
    });
}

headful.props = propertySetters;

/**
 * Tests whether the given `props` object contains a property with the name of `propNameOrFunction`.
 */
function noProp(props, propNameOrFunction) {
    if (!props) {
        throw new Error('Headful: You must pass all declared props when you use headful.props.x() calls.');
    }
    var propName = typeof propNameOrFunction === 'function' ? propNameOrFunction.name : propNameOrFunction;
    return !props.hasOwnProperty(propName);
}

function setMetaContent(attr, val) {
    setHeadElementAttributes('meta[' + attr + ']', { content: val });
}

function setRootElementAttributes(selector, attributes) {
    setElementAttributes(getElement(document, selector), attributes);
}

function setHeadElementAttributes(selector, attributes) {
    setElementAttributes(getElement(document.head, selector), attributes);
}

function setElementAttributes(element, attributes) {
    if (element) {
        Object.keys(attributes).forEach(function (attrName) {
            if (isRemoveValue(attributes[attrName])) {
                element.removeAttribute(attrName);
            } else {
                element.setAttribute(attrName, attributes[attrName]);
            }
        });
    }
}

function getElement(parent, selector) {
    var element = parent.querySelector(selector);
    if (!element && conf.debug) {
        console.error('Headful: Element \'' + selector + '\' was not found.');
    }
    return element;
}

function setOgLocaleIfValid(locale) {
    if (isRemoveValue(locale)) {
        propertySetters.ogLocale(locale);
    } else if (locale.match(/^[a-z]{2}-[a-z]{2}$/i)) {
        var _locale$split = locale.split('-'),
            _locale$split2 = _slicedToArray(_locale$split, 2),
            language = _locale$split2[0],
            region = _locale$split2[1];

        var ogLocale = language + '_' + region.toUpperCase();
        propertySetters.ogLocale(ogLocale);
    }
}

function isRemoveValue(val) {
    return val === undefined || val === null;
}

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

(function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.VueTheMask=t():e.VueTheMask=t()})(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var a=n[r]={i:r,l:!1,exports:{}};return e[r].call(a.exports,a,a.exports,t),a.l=!0,a.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p=".",t(t.s=10)}([function(e,t){e.exports={"#":{pattern:/\d/},X:{pattern:/[0-9a-zA-Z]/},S:{pattern:/[a-zA-Z]/},A:{pattern:/[a-zA-Z]/,transform:function(e){return e.toLocaleUpperCase()}},a:{pattern:/[a-zA-Z]/,transform:function(e){return e.toLocaleLowerCase()}},"!":{escape:!0}}},function(e,t,n){"use strict";function r(e){var t=document.createEvent("Event");return t.initEvent(e,!0,!0),t}var a=n(2),o=n(0),i=n.n(o);t.a=function(e,t){var o=t.value;if((Array.isArray(o)||"string"==typeof o)&&(o={mask:o,tokens:i.a}),"INPUT"!==e.tagName.toLocaleUpperCase()){var u=e.getElementsByTagName("input");if(1!==u.length)throw new Error("v-mask directive requires 1 input, found "+u.length);e=u[0]}e.oninput=function(t){if(t.isTrusted){var i=e.selectionEnd,u=e.value[i-1];for(e.value=n.i(a.a)(e.value,o.mask,!0,o.tokens);i<e.value.length&&e.value.charAt(i-1)!==u;)i++;e===document.activeElement&&(e.setSelectionRange(i,i),setTimeout(function(){e.setSelectionRange(i,i)},0)),e.dispatchEvent(r("input"))}};var s=n.i(a.a)(e.value,o.mask,!0,o.tokens);s!==e.value&&(e.value=s,e.dispatchEvent(r("input")))}},function(e,t,n){"use strict";var r=n(6),a=n(5);t.a=function(e,t){var o=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],i=arguments[3];return Array.isArray(t)?n.i(a.a)(r.a,t,i)(e,t,o,i):n.i(r.a)(e,t,o,i)}},function(e,t,n){"use strict";function r(e){e.component(s.a.name,s.a),e.directive("mask",i.a)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(0),o=n.n(a),i=n(1),u=n(7),s=n.n(u);n.d(t,"TheMask",function(){return s.a}),n.d(t,"mask",function(){return i.a}),n.d(t,"tokens",function(){return o.a}),n.d(t,"version",function(){return c});var c="0.11.1";t.default=r,"undefined"!=typeof window&&window.Vue&&window.Vue.use(r)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(1),a=n(0),o=n.n(a),i=n(2);t.default={name:"TheMask",props:{value:[String,Number],mask:{type:[String,Array],required:!0},masked:{type:Boolean,default:!1},tokens:{type:Object,default:function(){return o.a}}},directives:{mask:r.a},data:function(){return{lastValue:null,display:this.value}},watch:{value:function(e){e!==this.lastValue&&(this.display=e)},masked:function(){this.refresh(this.display)}},computed:{config:function(){return{mask:this.mask,tokens:this.tokens,masked:this.masked}}},methods:{onInput:function(e){e.isTrusted||this.refresh(e.target.value)},refresh:function(e){this.display=e;var e=n.i(i.a)(e,this.mask,this.masked,this.tokens);e!==this.lastValue&&(this.lastValue=e,this.$emit("input",e))}}}},function(e,t,n){"use strict";function r(e,t,n){return t=t.sort(function(e,t){return e.length-t.length}),function(r,a){for(var o=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],i=0;i<t.length;){var u=t[i];i++;var s=t[i];if(!(s&&e(r,s,!0,n).length>u.length))return e(r,u,o,n)}return""}}t.a=r},function(e,t,n){"use strict";function r(e,t){var n=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],r=arguments[3];e=e||"",t=t||"";for(var a=0,o=0,i="";a<t.length&&o<e.length;){var u=t[a],s=r[u],c=e[o];s&&!s.escape?(s.pattern.test(c)&&(i+=s.transform?s.transform(c):c,a++),o++):(s&&s.escape&&(a++,u=t[a]),n&&(i+=u),c===u&&o++,a++)}for(var f="";a<t.length&&n;){var u=t[a];if(r[u]){f="";break}f+=u,a++}return i+f}t.a=r},function(e,t,n){var r=n(8)(n(4),n(9),null,null);e.exports=r.exports},function(e,t){e.exports=function(e,t,n,r){var a,o=e=e||{},i=typeof e.default;"object"!==i&&"function"!==i||(a=e,o=e.default);var u="function"==typeof o?o.options:o;if(t&&(u.render=t.render,u.staticRenderFns=t.staticRenderFns),n&&(u._scopeId=n),r){var s=u.computed||(u.computed={});Object.keys(r).forEach(function(e){var t=r[e];s[e]=function(){return t}})}return{esModule:a,exports:o,options:u}}},function(e,t){e.exports={render:function(){var e=this,t=e.$createElement;return(e._self._c||t)("input",{directives:[{name:"mask",rawName:"v-mask",value:e.config,expression:"config"}],attrs:{type:"text"},domProps:{value:e.display},on:{input:e.onInput}})},staticRenderFns:[]}},function(e,t,n){e.exports=n(3)}])});

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

!function(n,e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):((n=n||self).__vee_validate_locale__ru=n.__vee_validate_locale__ru||{},n.__vee_validate_locale__ru.js=e())}(this,function(){"use strict";var n,e={name:"ru",messages:{_default:function(n){return"Значение поля "+n+" недопустимо"},after:function(n,e){var t=e[0];return"В поле "+n+" должна быть дата после "+(e[1]?"или равная ":"")+t},alpha:function(n){return"Поле "+n+" может содержать только буквы"},alpha_dash:function(n){return"Поле "+n+" может содержать только буквы, цифры и дефис"},alpha_num:function(n){return"Поле "+n+" может содержать только буквы и цифры"},alpha_spaces:function(n){return"Поле "+n+" может содержать только буквы и пробелы"},before:function(n,e){var t=e[0];return"В поле "+n+" должна быть дата до "+(e[1]?"или равная ":"")+t},between:function(n,e){return"Поле "+n+" должно быть между "+e[0]+" и "+e[1]},confirmed:function(n,e){return"Поле "+n+" не совпадает с полем "+e[0]},credit_card:function(n){return"Поле "+n+" должно быть действительным номером карты"},date_between:function(n,e){return"Поле "+n+" должно быть между "+e[0]+" и "+e[1]},date_format:function(n,e){return"Поле "+n+" должно быть в формате "+e[0]},decimal:function(n,e){void 0===e&&(e=[]);var t=e[0];return void 0===t&&(t="*"),"Поле "+n+" должно быть числовым и может содержать"+("*"===t?" десятичные числа":" "+t+" десятичных чисел")},digits:function(n,e){return"Поле "+n+" должно быть числовым и точно содержать "+e[0]+" цифры"},dimensions:function(n,e){return"Поле "+n+" должно быть "+e[0]+" пикселей на "+e[1]+" пикселей"},email:function(n){return"Поле "+n+" должно быть действительным электронным адресом"},excluded:function(n){return"Поле "+n+" должно быть допустимым значением"},ext:function(n,e){return"Поле "+n+" должно быть действительным файлом ("+e[0]+")"},image:function(n){return"Поле "+n+" должно быть изображением"},included:function(n){return"Поле "+n+" должно быть допустимым значением"},integer:function(n){return"Поле "+n+" должно быть целым числом"},ip:function(n){return"Поле "+n+" должно быть действительным IP-адресом"},length:function(n,e){var t=e[0],r=e[1];return r?"Длина поля "+n+" должна быть между "+t+" и "+r:"Длина поля "+n+" должна быть "+t},max:function(n,e){return"Поле "+n+" не может быть более "+e[0]+" символов"},max_value:function(n,e){return"Поле "+n+" должно быть "+e[0]+" или менее"},mimes:function(n,e){return"Поле "+n+" должно иметь допустимый тип файла ("+e[0]+")"},min:function(n,e){return"Поле "+n+" должно быть не менее "+e[0]+" символов"},min_value:function(n,e){return"Поле "+n+" должно быть "+e[0]+" или больше"},numeric:function(n){return"Поле "+n+" должно быть числом"},regex:function(n){return"Поле "+n+" имеет ошибочный формат"},required:function(n){return"Поле "+n+" обязательно для заполнения"},size:function(n,e){return"Поле "+n+" должно быть меньше, чем "+function(n){var e=1024,t=0===(n=Number(n)*e)?0:Math.floor(Math.log(n)/Math.log(e));return 1*(n/Math.pow(e,t)).toFixed(2)+" "+["Byte","KB","MB","GB","TB","PB","EB","ZB","YB"][t]}(e[0])},url:function(n){return"Поле "+n+" имеет ошибочный формат URL"}},attributes:{}};return"undefined"!=typeof VeeValidate&&VeeValidate.Validator.localize(((n={})[e.name]=e,n)),e});

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(205);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b17f2abc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(558);
function injectStyle (ssrContext) {
  __webpack_require__(554)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b17f2abc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(555);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("305ceb35", content, true, {});

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 556 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  jivoLoaded: false,

  init: function init() {
    var _this = this;

    if (!this.jivoLoaded) {
      window.jivo_onLoadCallback = function () {
        if (!_this.jivoLoaded) {
          // Добавляем проверку, чтобы выполнить код только один раз
          _this.jivoLoaded = true; // Устанавливаем флаг, что JivoSite загружен
          _this.checkUrl(); // Проверяем URL после загрузки JivoSite
        }
      };
    }
  },


  // Показать элементы JivoSite
  showJivoSite: function showJivoSite() {
    if (this.jivoLoaded) {
      window.jivo_init(); // Показываем виджет
    }
  },


  // Скрыть элементы JivoSite
  hideJivoSite: function hideJivoSite() {
    if (this.jivoLoaded) {
      window.jivo_destroy(); // Удаляем виджет
    }
  },
  checkUrl: function checkUrl() {
    var currentUrl = window.location.href;
    if (currentUrl.includes('my-progress')) {
      this.hideJivoSite();
    } else {
      this.showJivoSite();
    }
  }
});

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body",class:{ 'page-menu-closed': _vm.menuCollapsed },attrs:{"id":"app"}},[_c('router-view',{attrs:{"appMenuCollapsed":_vm.menuCollapsed},on:{"menu-toggled":_vm.onToggled}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_shared_Layout__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_shared_AuthLayout__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_News__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Reports__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_edit_ReportEdit__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_edit_FnsReportEdit__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_details_NewsDetails__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_details_SkuDetails__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_details_MaterialDetails__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_details_MaterialFileDetails__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_details_MaterialFileDetailsMobileApp__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_details_MaterialTest__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_details_MaterialTestResults__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_details_MaterialCertificate__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_details_TestOkko__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Login__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_ForgotPassword__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_ResetPassword__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_UserConfirm__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_Register__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_Projects__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_ProjectsAppAccess__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_edit_ProjectEdit__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_Users__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_edit_UserEdit__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_edit_NewsEdit__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_edit_SkuEdit__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_edit_MaterialEdit__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_edit_RewardEdit__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_edit_QuestionsEdit__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_edit_FolderEdit__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_edit_SkuFolderEdit__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_edit_RewardFolderEdit__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_Activation__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_edit_TasksEdit__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_details_TasksDetails__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_edit_TasksAnswerEdit__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_Analytics__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_Materials__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__views_Motivation__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__views_RatingNew__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__views_Sellers__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__views_Sku__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__views_SpendBonuses__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__views_TradePoints__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__views_Profile__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__views_Roles__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__views_Cart__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__views_Orders__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__views_BonusHistory__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__views_FaqPage__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__views_Sender__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__views_Tasks__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__views_TasksTable__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__views_MyProgress_vue__ = __webpack_require__(861);

























































var routes = [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_0__views_shared_Layout__["a" /* default */],
    children: [{
        path: 'news',
        alias: '',
        name: 'news',
        component: __WEBPACK_IMPORTED_MODULE_2__views_News__["a" /* default */]
    }, {
        path: 'news/:id',
        name: 'newsDetails',
        component: __WEBPACK_IMPORTED_MODULE_6__views_details_NewsDetails__["a" /* default */]
    }, {
        path: 'news/edit/:id',
        name: 'newsEdit',
        component: __WEBPACK_IMPORTED_MODULE_25__views_edit_NewsEdit__["a" /* default */]
    }, {
        path: 'projects',
        name: 'projects',
        component: __WEBPACK_IMPORTED_MODULE_20__views_Projects__["a" /* default */]
    }, {
        path: 'projects/appaccess',
        name: 'projectsAppAccess',
        component: __WEBPACK_IMPORTED_MODULE_21__views_ProjectsAppAccess__["a" /* default */]
    }, {
        path: 'projects/:id',
        name: 'projectEdit',
        component: __WEBPACK_IMPORTED_MODULE_22__views_edit_ProjectEdit__["a" /* default */]
    }, {
        path: 'materials',
        name: 'materials',
        component: __WEBPACK_IMPORTED_MODULE_38__views_Materials__["a" /* default */]
    }, {
        path: 'materials/edit/:id',
        name: 'materialEdit',
        component: __WEBPACK_IMPORTED_MODULE_27__views_edit_MaterialEdit__["a" /* default */]
    }, {
        path: 'materials/edit/:id/questions',
        name: 'questionsEdit',
        component: __WEBPACK_IMPORTED_MODULE_29__views_edit_QuestionsEdit__["a" /* default */]
    }, {
        path: 'materials/certificate/:projectId',
        name: 'materialCertificate',
        component: __WEBPACK_IMPORTED_MODULE_13__views_details_MaterialCertificate__["a" /* default */]
    }, {
        path: 'materials/:id',
        name: 'materialDetails',
        component: __WEBPACK_IMPORTED_MODULE_8__views_details_MaterialDetails__["a" /* default */]
    }, {
        path: 'materials/:materialId/:id(\\d+)',
        name: 'materialFileDetails',
        component: __WEBPACK_IMPORTED_MODULE_9__views_details_MaterialFileDetails__["a" /* default */]
    }, {
        path: 'materials/:id/test',
        name: 'materialTest',
        component: __WEBPACK_IMPORTED_MODULE_11__views_details_MaterialTest__["a" /* default */]
    }, {
        path: 'materials/:id/testresults',
        name: 'materialTestResults',
        component: __WEBPACK_IMPORTED_MODULE_12__views_details_MaterialTestResults__["a" /* default */]
    }, {
        path: 'materials/:id/okko',
        name: 'materialTestOkko',
        component: __WEBPACK_IMPORTED_MODULE_14__views_details_TestOkko__["a" /* default */]
    }, {
        path: 'materials/folder/edit/:id',
        name: 'folderEdit',
        component: __WEBPACK_IMPORTED_MODULE_30__views_edit_FolderEdit__["a" /* default */]
    }, {
        path: 'reports',
        name: 'reports',
        component: __WEBPACK_IMPORTED_MODULE_3__views_Reports__["a" /* default */]
    }, {
        path: 'reports/:id(\\d+)',
        name: 'ReportEdit',
        component: __WEBPACK_IMPORTED_MODULE_4__views_edit_ReportEdit__["a" /* default */]
    }, {
        path: 'reports/fns/:id',
        name: 'FnsReportEdit',
        component: __WEBPACK_IMPORTED_MODULE_5__views_edit_FnsReportEdit__["a" /* default */]
    }, {
        path: 'rating',
        name: 'rating',
        component: __WEBPACK_IMPORTED_MODULE_40__views_RatingNew__["a" /* default */]
    }, {
        path: 'spend-bonuses',
        name: 'spend-bonuses',
        component: __WEBPACK_IMPORTED_MODULE_43__views_SpendBonuses__["a" /* default */]
    }, {
        path: 'bonus-history',
        name: 'bonus-history',
        component: __WEBPACK_IMPORTED_MODULE_49__views_BonusHistory__["a" /* default */]
    }, {
        path: 'rewards/edit/:id',
        name: 'rewardEdit',
        component: __WEBPACK_IMPORTED_MODULE_28__views_edit_RewardEdit__["a" /* default */]
    }, {
        path: 'rewards/folder/edit/:id',
        name: 'rewardFolderEdit',
        component: __WEBPACK_IMPORTED_MODULE_32__views_edit_RewardFolderEdit__["a" /* default */]
    }, {
        path: 'analytics',
        name: 'analytics',
        component: __WEBPACK_IMPORTED_MODULE_37__views_Analytics__["a" /* default */]
    }, {
        path: 'sellers',
        name: 'sellers',
        component: __WEBPACK_IMPORTED_MODULE_41__views_Sellers__["a" /* default */]
    }, {
        path: 'sku',
        name: 'sku',
        component: __WEBPACK_IMPORTED_MODULE_42__views_Sku__["a" /* default */]
    }, {
        path: 'sku/edit/:id',
        name: 'skuEdit',
        component: __WEBPACK_IMPORTED_MODULE_26__views_edit_SkuEdit__["a" /* default */]
    }, {
        path: 'sku/:id',
        name: 'skuDetails',
        component: __WEBPACK_IMPORTED_MODULE_7__views_details_SkuDetails__["a" /* default */]
    }, {
        path: 'sku/folder/edit/:id',
        name: 'skuFolderEdit',
        component: __WEBPACK_IMPORTED_MODULE_31__views_edit_SkuFolderEdit__["a" /* default */]
    }, {
        path: 'motivation',
        name: 'motivation',
        component: __WEBPACK_IMPORTED_MODULE_39__views_Motivation__["a" /* default */]
    }, {
        path: 'projects/:projectId/users',
        name: 'users',
        component: __WEBPACK_IMPORTED_MODULE_23__views_Users__["a" /* default */]
    }, {
        path: 'projects/:projectId/users/:userName',
        name: 'UserEdit',
        component: __WEBPACK_IMPORTED_MODULE_24__views_edit_UserEdit__["a" /* default */]
    }, {
        path: 'projects/:projectId/trade-points',
        name: 'trade-points',
        component: __WEBPACK_IMPORTED_MODULE_44__views_TradePoints__["a" /* default */]
    }, {
        path: 'projects/:projectId/roles',
        name: 'roles',
        component: __WEBPACK_IMPORTED_MODULE_46__views_Roles__["a" /* default */]
    }, {
        path: 'profile',
        name: 'profile',
        component: __WEBPACK_IMPORTED_MODULE_45__views_Profile__["a" /* default */]
    }, {
        path: 'cart',
        name: 'cart',
        component: __WEBPACK_IMPORTED_MODULE_47__views_Cart__["a" /* default */]
    }, {
        path: 'orders',
        name: 'orders',
        component: __WEBPACK_IMPORTED_MODULE_48__views_Orders__["a" /* default */]
    }, {
        path: 'faq',
        name: 'faq',
        component: __WEBPACK_IMPORTED_MODULE_50__views_FaqPage__["a" /* default */]
    }, {
        path: 'sender',
        name: 'sender',
        component: __WEBPACK_IMPORTED_MODULE_51__views_Sender__["a" /* default */]
    }, {
        path: 'tasks',
        name: 'tasks',
        component: __WEBPACK_IMPORTED_MODULE_52__views_Tasks__["a" /* default */]
    }, {
        path: 'tasks/table',
        name: 'tasksTable',
        component: __WEBPACK_IMPORTED_MODULE_53__views_TasksTable__["a" /* default */]
    }, {
        path: 'tasks/edit/:projectId/:id',
        name: 'tasksEdit',
        component: __WEBPACK_IMPORTED_MODULE_34__views_edit_TasksEdit__["a" /* default */]
    }, {
        path: 'tasks/:id',
        name: 'tasksDetails',
        component: __WEBPACK_IMPORTED_MODULE_35__views_details_TasksDetails__["a" /* default */]
    }, {
        path: 'tasks/answer/:taskId/:answerId/:edit',
        name: 'tasksAnswerEdit',
        component: __WEBPACK_IMPORTED_MODULE_36__views_edit_TasksAnswerEdit__["a" /* default */]
    }, {
        path: 'my-progress',
        name: 'myProgress',
        component: __WEBPACK_IMPORTED_MODULE_54__views_MyProgress_vue__["a" /* default */]
    }]
    // beforeEnter: (to, from, next) => {
    //     console.info('beforeEnter', )
    // }
}, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_1__views_shared_AuthLayout__["a" /* default */],
    children: [{
        path: 'login',
        name: 'login',
        component: __WEBPACK_IMPORTED_MODULE_15__views_Login__["a" /* default */]
    }, {
        path: 'forgot',
        name: 'forgot',
        component: __WEBPACK_IMPORTED_MODULE_16__views_ForgotPassword__["a" /* default */]
    }, {
        path: 'user/reset/:hash',
        name: 'reset',
        component: __WEBPACK_IMPORTED_MODULE_17__views_ResetPassword__["a" /* default */]
    }, {
        path: 'user/confirm/:hash',
        name: 'confirm',
        component: __WEBPACK_IMPORTED_MODULE_18__views_UserConfirm__["a" /* default */]
    }, {
        path: 'register',
        name: 'register',
        component: __WEBPACK_IMPORTED_MODULE_19__views_Register__["a" /* default */]
    }, {
        path: 'user/activation/:hash',
        name: 'activation',
        component: __WEBPACK_IMPORTED_MODULE_33__views_Activation__["a" /* default */]
    }]
}, {
    path: '/urltoken/materials/:materialId/:id(\\d+)',
    name: 'MaterialFileDetailsMobileApp',
    component: __WEBPACK_IMPORTED_MODULE_10__views_details_MaterialFileDetailsMobileApp__["a" /* default */]
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

function requireAuth(to, from, next) {
    // if (!auth.loggedIn()) {
    //     next({
    //         path: '/login',
    //         query: { redirect: to.fullPath }
    //     })
    // } else {
    //     next()
    // }
    // next({
    //     path: '/login',
    //     query: {redirect: to.fullPath}
    // })
    next();
}

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__ = __webpack_require__(206);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_227ab644_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__ = __webpack_require__(628);
function injectStyle (ssrContext) {
  __webpack_require__(561)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-227ab644"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Layout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_227ab644_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(562);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("7680658a", content, true, {});

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".levelinproject-icon-size[data-v-227ab644]{height:20px;width:20px;margin-left:5px}.levelinproject[data-v-227ab644]{display:flex;align-items:center;justify-content:center}", ""]);

// exports


/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideMenu_vue__ = __webpack_require__(207);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e08a3c48_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideMenu_vue__ = __webpack_require__(566);
function injectStyle (ssrContext) {
  __webpack_require__(564)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e08a3c48"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e08a3c48_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(565);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("a3643ec6", content, true, {});

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".fade-enter-active[data-v-e08a3c48],.fade-leave-active[data-v-e08a3c48]{transition:opacity .5s}.fade-enter[data-v-e08a3c48],.fade-leave-to[data-v-e08a3c48]{opacity:0}.tooltip[data-v-e08a3c48]{left:105px;top:195px;bottom:auto}", ""]);

// exports


/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.info && _vm.info.User && _vm.info.User.TermsConfirmed)?_c('div',{staticClass:"user-menu"},[(_vm.info.User.SalesPlan != null || _vm.info.User.SalesFact != null)?_c('div',{class:['page-menu-content-1', { 'collapse': _vm.collapsed }],on:{"mouseenter":_vm.onSpanEnter,"mouseleave":_vm.onSpanLeave}},[_c('div',{staticClass:"sidebar-search-wrapper"},[_c('div',{staticClass:"sidebar-search",staticStyle:{"text-align":"center"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.userPlanFactData.Display)}})])])]):_vm._e(),_vm._v(" "),(_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.reportAdd) && _vm.addReportLinkName)?_c('div',{staticClass:"page-menu-content-1",class:{ 'collapse': _vm.collapsed }},[_c('div',{staticClass:"sidebar-search-wrapper"},[_c('div',{staticClass:"sidebar-search"},[_c('router-link',{staticClass:"btn btn-primary btn-with-img",attrs:{"to":'/reports/' + (_vm.info.ReportType === 2 ? 'fns/' : '') + '0'}},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/images.svg#Plus"}})]),_vm._v(" "),_c('span',{staticClass:"btn-text"},[_vm._v(_vm._s(_vm.addReportLinkName))])])],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"page-menu-content-2",class:{ 'collapse': _vm.collapsed }},[_c('div',{class:['menu-item', { 'active': _vm.$route.path.startsWith('/profile') }]},[_c('router-link',{attrs:{"to":"/profile","disabled":""}},[_c('svg',{staticClass:"svg-icon",style:({fill: _vm.menuColor}),attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/images.svg#MenuProfile"}})]),_vm._v(" "),_c('span',[_vm._v("Профиль")])])],1),_vm._v(" "),(_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.projectPage) || _vm.info.User.MainRole === 'administrators')?_c('div',{class:['menu-item start', { 'active': _vm.$route.path.startsWith('/projects') }]},[_c('router-link',{attrs:{"to":"/projects","disabled":""}},[_c('svg',{staticClass:"svg-icon",style:({fill: _vm.menuColor}),attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/images.svg#MenuProject"}})]),_vm._v(" "),_c('span',[_vm._v("Проекты")])])],1):_vm._e(),_vm._v(" "),_vm._l((_vm.pagesOrdered),function(page){return (page.hasClaims)?_c('div',{class:['menu-item', { 'active': page.active, 'comback': page.img == '/Content/dist/images.svg?v3#MenuBonus' }]},[_c('router-link',{attrs:{"to":page.Path}},[(page.img == '/Content/dist/images.svg?v3#MenuBonus')?_c('svg',{staticClass:"svg-icon",style:({stroke: _vm.menuColor }),attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":page.img}})]):_c('svg',{staticClass:"svg-icon",style:({fill: _vm.menuColor }),attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":page.img}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(page.Name))]),_vm._v(" "),(page.span != null)?_c('span',{class:['menu-item-info', page.span.css]},[_vm._v(_vm._s(page.span.value))]):_vm._e(),_vm._v(" "),(page.Path === '/cart' && _vm.cartItemsCount > 0)?_c('span',[_vm._v(" ("+_vm._s(_vm.cartItemsCount)+")")]):_vm._e()])],1):_vm._e()})],2),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSpanDetails),expression:"showSpanDetails"}],ref:"spanTooltip",staticClass:"tooltip"},[_c('div',{staticClass:"tooltip-body",domProps:{"innerHTML":_vm._s(_vm.userPlanFactData.Tooltip)}})])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(568);

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);
var bind = __webpack_require__(211);
var Axios = __webpack_require__(570);
var defaults = __webpack_require__(154);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(215);
axios.CancelToken = __webpack_require__(583);
axios.isCancel = __webpack_require__(214);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(584);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 569 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(154);
var utils = __webpack_require__(41);
var InterceptorManager = __webpack_require__(578);
var dispatchRequest = __webpack_require__(579);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(213);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);
var transformData = __webpack_require__(580);
var isCancel = __webpack_require__(214);
var defaults = __webpack_require__(154);
var isAbsoluteURL = __webpack_require__(581);
var combineURLs = __webpack_require__(582);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(215);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/*!
 * jQuery blockUI plugin
 * Version 2.70.0-2014.11.23
 * Requires jQuery v1.7 or later
 *
 * Examples at: http://malsup.com/jquery/block/
 * Copyright (c) 2007-2013 M. Alsup
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 * Thanks to Amir-Hossein Sobhi for some excellent contributions!
 */
(function () {
	/*jshint eqeqeq:false curly:false latedef:false */
	"use strict";

	function setup($) {
		$.fn._fadeIn = $.fn.fadeIn;

		var noOp = $.noop || function () {};

		// this bit is to ensure we don't call setExpression when we shouldn't (with extra muscle to handle
		// confusing userAgent strings on Vista)
		var msie = /MSIE/.test(navigator.userAgent);
		var ie6 = /MSIE 6.0/.test(navigator.userAgent) && !/MSIE 8.0/.test(navigator.userAgent);
		var mode = document.documentMode || 0;
		var setExpr = $.isFunction(document.createElement('div').style.setExpression);

		// global $ methods for blocking/unblocking the entire page
		$.blockUI = function (opts) {
			install(window, opts);
		};
		$.unblockUI = function (opts) {
			remove(window, opts);
		};

		// convenience method for quick growl-like notifications  (http://www.google.com/search?q=growl)
		$.growlUI = function (title, message, timeout, onClose) {
			var $m = $('<div class="growlUI"></div>');
			if (title) $m.append('<h1>' + title + '</h1>');
			if (message) $m.append('<h2>' + message + '</h2>');
			if (timeout === undefined) timeout = 3000;

			// Added by konapun: Set timeout to 30 seconds if this growl is moused over, like normal toast notifications
			var callBlock = function callBlock(opts) {
				opts = opts || {};

				$.blockUI({
					message: $m,
					fadeIn: typeof opts.fadeIn !== 'undefined' ? opts.fadeIn : 700,
					fadeOut: typeof opts.fadeOut !== 'undefined' ? opts.fadeOut : 1000,
					timeout: typeof opts.timeout !== 'undefined' ? opts.timeout : timeout,
					centerY: false,
					showOverlay: false,
					onUnblock: onClose,
					css: $.blockUI.defaults.growlCSS
				});
			};

			callBlock();
			var nonmousedOpacity = $m.css('opacity');
			$m.mouseover(function () {
				callBlock({
					fadeIn: 0,
					timeout: 30000
				});

				var displayBlock = $('.blockMsg');
				displayBlock.stop(); // cancel fadeout if it has started
				displayBlock.fadeTo(300, 1); // make it easier to read the message by removing transparency
			}).mouseout(function () {
				$('.blockMsg').fadeOut(1000);
			});
			// End konapun additions
		};

		// plugin method for blocking element content
		$.fn.block = function (opts) {
			if (this[0] === window) {
				$.blockUI(opts);
				return this;
			}
			var fullOpts = $.extend({}, $.blockUI.defaults, opts || {});
			this.each(function () {
				var $el = $(this);
				if (fullOpts.ignoreIfBlocked && $el.data('blockUI.isBlocked')) return;
				$el.unblock({ fadeOut: 0 });
			});

			return this.each(function () {
				if ($.css(this, 'position') == 'static') {
					this.style.position = 'relative';
					$(this).data('blockUI.static', true);
				}
				this.style.zoom = 1; // force 'hasLayout' in ie
				install(this, opts);
			});
		};

		// plugin method for unblocking element content
		$.fn.unblock = function (opts) {
			if (this[0] === window) {
				$.unblockUI(opts);
				return this;
			}
			return this.each(function () {
				remove(this, opts);
			});
		};

		$.blockUI.version = 2.70; // 2nd generation blocking at no extra cost!

		// override these in your code to change the default behavior and style
		$.blockUI.defaults = {
			// message displayed when blocking (use null for no message)
			message: '<h1>Please wait...</h1>',

			title: null, // title string; only used when theme == true
			draggable: true, // only used when theme == true (requires jquery-ui.js to be loaded)

			theme: false, // set to true to use with jQuery UI themes

			// styles for the message when blocking; if you wish to disable
			// these and use an external stylesheet then do this in your code:
			// $.blockUI.defaults.css = {};
			css: {
				padding: 0,
				margin: 0,
				width: '30%',
				top: '40%',
				left: '35%',
				textAlign: 'center',
				color: '#000',
				border: '3px solid #aaa',
				backgroundColor: '#fff',
				cursor: 'wait'
			},

			// minimal style set used when themes are used
			themedCSS: {
				width: '30%',
				top: '40%',
				left: '35%'
			},

			// styles for the overlay
			overlayCSS: {
				backgroundColor: '#000',
				opacity: 0.6,
				cursor: 'wait'
			},

			// style to replace wait cursor before unblocking to correct issue
			// of lingering wait cursor
			cursorReset: 'default',

			// styles applied when using $.growlUI
			growlCSS: {
				width: '350px',
				top: '10px',
				left: '',
				right: '10px',
				border: 'none',
				padding: '5px',
				opacity: 0.6,
				cursor: 'default',
				color: '#fff',
				backgroundColor: '#000',
				'-webkit-border-radius': '10px',
				'-moz-border-radius': '10px',
				'border-radius': '10px'
			},

			// IE issues: 'about:blank' fails on HTTPS and javascript:false is s-l-o-w
			// (hat tip to Jorge H. N. de Vasconcelos)
			/*jshint scripturl:true */
			iframeSrc: /^https/i.test(window.location.href || '') ? 'javascript:false' : 'about:blank',

			// force usage of iframe in non-IE browsers (handy for blocking applets)
			forceIframe: false,

			// z-index for the blocking overlay
			baseZ: 1000,

			// set these to true to have the message automatically centered
			centerX: true, // <-- only effects element blocking (page block controlled via css above)
			centerY: true,

			// allow body element to be stetched in ie6; this makes blocking look better
			// on "short" pages.  disable if you wish to prevent changes to the body height
			allowBodyStretch: true,

			// enable if you want key and mouse events to be disabled for content that is blocked
			bindEvents: true,

			// be default blockUI will supress tab navigation from leaving blocking content
			// (if bindEvents is true)
			constrainTabKey: true,

			// fadeIn time in millis; set to 0 to disable fadeIn on block
			fadeIn: 200,

			// fadeOut time in millis; set to 0 to disable fadeOut on unblock
			fadeOut: 400,

			// time in millis to wait before auto-unblocking; set to 0 to disable auto-unblock
			timeout: 0,

			// disable if you don't want to show the overlay
			showOverlay: true,

			// if true, focus will be placed in the first available input field when
			// page blocking
			focusInput: true,

			// elements that can receive focus
			focusableElements: ':input:enabled:visible',

			// suppresses the use of overlay styles on FF/Linux (due to performance issues with opacity)
			// no longer needed in 2012
			// applyPlatformOpacityRules: true,

			// callback method invoked when fadeIn has completed and blocking message is visible
			onBlock: null,

			// callback method invoked when unblocking has completed; the callback is
			// passed the element that has been unblocked (which is the window object for page
			// blocks) and the options that were passed to the unblock call:
			//	onUnblock(element, options)
			onUnblock: null,

			// callback method invoked when the overlay area is clicked.
			// setting this will turn the cursor to a pointer, otherwise cursor defined in overlayCss will be used.
			onOverlayClick: null,

			// don't ask; if you really must know: http://groups.google.com/group/jquery-en/browse_thread/thread/36640a8730503595/2f6a79a77a78e493#2f6a79a77a78e493
			quirksmodeOffsetHack: 4,

			// class name of the message block
			blockMsgClass: 'blockMsg',

			// if it is already blocked, then ignore it (don't unblock and reblock)
			ignoreIfBlocked: false
		};

		// private data and functions follow...

		var pageBlock = null;
		var pageBlockEls = [];

		function install(el, opts) {
			var css, themedCSS;
			var full = el == window;
			var msg = opts && opts.message !== undefined ? opts.message : undefined;
			opts = $.extend({}, $.blockUI.defaults, opts || {});

			if (opts.ignoreIfBlocked && $(el).data('blockUI.isBlocked')) return;

			opts.overlayCSS = $.extend({}, $.blockUI.defaults.overlayCSS, opts.overlayCSS || {});
			css = $.extend({}, $.blockUI.defaults.css, opts.css || {});
			if (opts.onOverlayClick) opts.overlayCSS.cursor = 'pointer';

			themedCSS = $.extend({}, $.blockUI.defaults.themedCSS, opts.themedCSS || {});
			msg = msg === undefined ? opts.message : msg;

			// remove the current block (if there is one)
			if (full && pageBlock) remove(window, { fadeOut: 0 });

			// if an existing element is being used as the blocking content then we capture
			// its current place in the DOM (and current display style) so we can restore
			// it when we unblock
			if (msg && typeof msg != 'string' && (msg.parentNode || msg.jquery)) {
				var node = msg.jquery ? msg[0] : msg;
				var data = {};
				$(el).data('blockUI.history', data);
				data.el = node;
				data.parent = node.parentNode;
				data.display = node.style.display;
				data.position = node.style.position;
				if (data.parent) data.parent.removeChild(node);
			}

			$(el).data('blockUI.onUnblock', opts.onUnblock);
			var z = opts.baseZ;

			// blockUI uses 3 layers for blocking, for simplicity they are all used on every platform;
			// layer1 is the iframe layer which is used to supress bleed through of underlying content
			// layer2 is the overlay layer which has opacity and a wait cursor (by default)
			// layer3 is the message content that is displayed while blocking
			var lyr1, lyr2, lyr3, s;
			if (msie || opts.forceIframe) lyr1 = $('<iframe class="blockUI" style="z-index:' + z++ + ';display:none;border:none;margin:0;padding:0;position:absolute;width:100%;height:100%;top:0;left:0" src="' + opts.iframeSrc + '"></iframe>');else lyr1 = $('<div class="blockUI" style="display:none"></div>');

			if (opts.theme) lyr2 = $('<div class="blockUI blockOverlay ui-widget-overlay" style="z-index:' + z++ + ';display:none"></div>');else lyr2 = $('<div class="blockUI blockOverlay" style="z-index:' + z++ + ';display:none;border:none;margin:0;padding:0;width:100%;height:100%;top:0;left:0"></div>');

			if (opts.theme && full) {
				s = '<div class="blockUI ' + opts.blockMsgClass + ' blockPage ui-dialog ui-widget ui-corner-all" style="z-index:' + (z + 10) + ';display:none;position:fixed">';
				if (opts.title) {
					s += '<div class="ui-widget-header ui-dialog-titlebar ui-corner-all blockTitle">' + (opts.title || '&nbsp;') + '</div>';
				}
				s += '<div class="ui-widget-content ui-dialog-content"></div>';
				s += '</div>';
			} else if (opts.theme) {
				s = '<div class="blockUI ' + opts.blockMsgClass + ' blockElement ui-dialog ui-widget ui-corner-all" style="z-index:' + (z + 10) + ';display:none;position:absolute">';
				if (opts.title) {
					s += '<div class="ui-widget-header ui-dialog-titlebar ui-corner-all blockTitle">' + (opts.title || '&nbsp;') + '</div>';
				}
				s += '<div class="ui-widget-content ui-dialog-content"></div>';
				s += '</div>';
			} else if (full) {
				s = '<div class="blockUI ' + opts.blockMsgClass + ' blockPage" style="z-index:' + (z + 10) + ';display:none;position:fixed"></div>';
			} else {
				s = '<div class="blockUI ' + opts.blockMsgClass + ' blockElement" style="z-index:' + (z + 10) + ';display:none;position:absolute"></div>';
			}
			lyr3 = $(s);

			// if we have a message, style it
			if (msg) {
				if (opts.theme) {
					lyr3.css(themedCSS);
					lyr3.addClass('ui-widget-content');
				} else lyr3.css(css);
			}

			// style the overlay
			if (!opts.theme /*&& (!opts.applyPlatformOpacityRules)*/) lyr2.css(opts.overlayCSS);
			lyr2.css('position', full ? 'fixed' : 'absolute');

			// make iframe layer transparent in IE
			if (msie || opts.forceIframe) lyr1.css('opacity', 0.0);

			//$([lyr1[0],lyr2[0],lyr3[0]]).appendTo(full ? 'body' : el);
			var layers = [lyr1, lyr2, lyr3],
			    $par = full ? $('body') : $(el);
			$.each(layers, function () {
				this.appendTo($par);
			});

			if (opts.theme && opts.draggable && $.fn.draggable) {
				lyr3.draggable({
					handle: '.ui-dialog-titlebar',
					cancel: 'li'
				});
			}

			// ie7 must use absolute positioning in quirks mode and to account for activex issues (when scrolling)
			var expr = setExpr && (!$.support.boxModel || $('object,embed', full ? null : el).length > 0);
			if (ie6 || expr) {
				// give body 100% height
				if (full && opts.allowBodyStretch && $.support.boxModel) $('html,body').css('height', '100%');

				// fix ie6 issue when blocked element has a border width
				if ((ie6 || !$.support.boxModel) && !full) {
					var t = sz(el, 'borderTopWidth'),
					    l = sz(el, 'borderLeftWidth');
					var fixT = t ? '(0 - ' + t + ')' : 0;
					var fixL = l ? '(0 - ' + l + ')' : 0;
				}

				// simulate fixed position
				$.each(layers, function (i, o) {
					var s = o[0].style;
					s.position = 'absolute';
					if (i < 2) {
						if (full) s.setExpression('height', 'Math.max(document.body.scrollHeight, document.body.offsetHeight) - (jQuery.support.boxModel?0:' + opts.quirksmodeOffsetHack + ') + "px"');else s.setExpression('height', 'this.parentNode.offsetHeight + "px"');
						if (full) s.setExpression('width', 'jQuery.support.boxModel && document.documentElement.clientWidth || document.body.clientWidth + "px"');else s.setExpression('width', 'this.parentNode.offsetWidth + "px"');
						if (fixL) s.setExpression('left', fixL);
						if (fixT) s.setExpression('top', fixT);
					} else if (opts.centerY) {
						if (full) s.setExpression('top', '(document.documentElement.clientHeight || document.body.clientHeight) / 2 - (this.offsetHeight / 2) + (blah = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + "px"');
						s.marginTop = 0;
					} else if (!opts.centerY && full) {
						var top = opts.css && opts.css.top ? parseInt(opts.css.top, 10) : 0;
						var expression = '((document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + ' + top + ') + "px"';
						s.setExpression('top', expression);
					}
				});
			}

			// show the message
			if (msg) {
				if (opts.theme) lyr3.find('.ui-widget-content').append(msg);else lyr3.append(msg);
				if (msg.jquery || msg.nodeType) $(msg).show();
			}

			if ((msie || opts.forceIframe) && opts.showOverlay) lyr1.show(); // opacity is zero
			if (opts.fadeIn) {
				var cb = opts.onBlock ? opts.onBlock : noOp;
				var cb1 = opts.showOverlay && !msg ? cb : noOp;
				var cb2 = msg ? cb : noOp;
				if (opts.showOverlay) lyr2._fadeIn(opts.fadeIn, cb1);
				if (msg) lyr3._fadeIn(opts.fadeIn, cb2);
			} else {
				if (opts.showOverlay) lyr2.show();
				if (msg) lyr3.show();
				if (opts.onBlock) opts.onBlock.bind(lyr3)();
			}

			// bind key and mouse events
			bind(1, el, opts);

			if (full) {
				pageBlock = lyr3[0];
				pageBlockEls = $(opts.focusableElements, pageBlock);
				if (opts.focusInput) setTimeout(focus, 20);
			} else center(lyr3[0], opts.centerX, opts.centerY);

			if (opts.timeout) {
				// auto-unblock
				var to = setTimeout(function () {
					if (full) $.unblockUI(opts);else $(el).unblock(opts);
				}, opts.timeout);
				$(el).data('blockUI.timeout', to);
			}
		}

		// remove the block
		function remove(el, opts) {
			var count;
			var full = el == window;
			var $el = $(el);
			var data = $el.data('blockUI.history');
			var to = $el.data('blockUI.timeout');
			if (to) {
				clearTimeout(to);
				$el.removeData('blockUI.timeout');
			}
			opts = $.extend({}, $.blockUI.defaults, opts || {});
			bind(0, el, opts); // unbind events

			if (opts.onUnblock === null) {
				opts.onUnblock = $el.data('blockUI.onUnblock');
				$el.removeData('blockUI.onUnblock');
			}

			var els;
			if (full) // crazy selector to handle odd field errors in ie6/7
				els = $('body').children().filter('.blockUI').add('body > .blockUI');else els = $el.find('>.blockUI');

			// fix cursor issue
			if (opts.cursorReset) {
				if (els.length > 1) els[1].style.cursor = opts.cursorReset;
				if (els.length > 2) els[2].style.cursor = opts.cursorReset;
			}

			if (full) pageBlock = pageBlockEls = null;

			if (opts.fadeOut) {
				count = els.length;
				els.stop().fadeOut(opts.fadeOut, function () {
					if (--count === 0) reset(els, data, opts, el);
				});
			} else reset(els, data, opts, el);
		}

		// move blocking element back into the DOM where it started
		function reset(els, data, opts, el) {
			var $el = $(el);
			if ($el.data('blockUI.isBlocked')) return;

			els.each(function (i, o) {
				// remove via DOM calls so we don't lose event handlers
				if (this.parentNode) this.parentNode.removeChild(this);
			});

			if (data && data.el) {
				data.el.style.display = data.display;
				data.el.style.position = data.position;
				data.el.style.cursor = 'default'; // #59
				if (data.parent) data.parent.appendChild(data.el);
				$el.removeData('blockUI.history');
			}

			if ($el.data('blockUI.static')) {
				$el.css('position', 'static'); // #22
			}

			if (typeof opts.onUnblock == 'function') opts.onUnblock(el, opts);

			// fix issue in Safari 6 where block artifacts remain until reflow
			var body = $(document.body),
			    w = body.width(),
			    cssW = body[0].style.width;
			body.width(w - 1).width(w);
			body[0].style.width = cssW;
		}

		// bind/unbind the handler
		function bind(b, el, opts) {
			var full = el == window,
			    $el = $(el);

			// don't bother unbinding if there is nothing to unbind
			if (!b && (full && !pageBlock || !full && !$el.data('blockUI.isBlocked'))) return;

			$el.data('blockUI.isBlocked', b);

			// don't bind events when overlay is not in use or if bindEvents is false
			if (!full || !opts.bindEvents || b && !opts.showOverlay) return;

			// bind anchors and inputs for mouse and key events
			var events = 'mousedown mouseup keydown keypress keyup touchstart touchend touchmove';
			if (b) $(document).bind(events, opts, handler);else $(document).unbind(events, handler);

			// former impl...
			//		var $e = $('a,:input');
			//		b ? $e.bind(events, opts, handler) : $e.unbind(events, handler);
		}

		// event handler to suppress keyboard/mouse events when blocking
		function handler(e) {
			// allow tab navigation (conditionally)
			if (e.type === 'keydown' && e.keyCode && e.keyCode == 9) {
				if (pageBlock && e.data.constrainTabKey) {
					var els = pageBlockEls;
					var fwd = !e.shiftKey && e.target === els[els.length - 1];
					var back = e.shiftKey && e.target === els[0];
					if (fwd || back) {
						setTimeout(function () {
							focus(back);
						}, 10);
						return false;
					}
				}
			}
			var opts = e.data;
			var target = $(e.target);
			if (target.hasClass('blockOverlay') && opts.onOverlayClick) opts.onOverlayClick(e);

			// allow events within the message content
			if (target.parents('div.' + opts.blockMsgClass).length > 0) return true;

			// allow events for content that is not being blocked
			return target.parents().children().filter('div.blockUI').length === 0;
		}

		function focus(back) {
			if (!pageBlockEls) return;
			var e = pageBlockEls[back === true ? pageBlockEls.length - 1 : 0];
			if (e) e.focus();
		}

		function center(el, x, y) {
			var p = el.parentNode,
			    s = el.style;
			var l = (p.offsetWidth - el.offsetWidth) / 2 - sz(p, 'borderLeftWidth');
			var t = (p.offsetHeight - el.offsetHeight) / 2 - sz(p, 'borderTopWidth');
			if (x) s.left = l > 0 ? l + 'px' : '0';
			if (y) s.top = t > 0 ? t + 'px' : '0';
		}

		function sz(el, p) {
			return parseInt($.css(el, p), 10) || 0;
		}
	}

	/*global define:true */
	if (typeof define === 'function' && __webpack_require__(216) && __webpack_require__(216).jQuery) {
		define(['jquery'], setup);
	} else {
		setup(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a);
	}
})();

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * Toastr
 * Copyright 2012-2015
 * Authors: John Papa, Hans Fjällemark, and Tim Ferrell.
 * All Rights Reserved.
 * Use, reproduction, distribution, and modification of this code is subject to the terms and
 * conditions of the MIT license, available at http://www.opensource.org/licenses/mit-license.php
 *
 * ARIA Support: Greta Krafsig
 *
 * Project: https://github.com/CodeSeven/toastr
 */
/* global define */
(function (define) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
        return (function () {
            var $container;
            var listener;
            var toastId = 0;
            var toastType = {
                error: 'error',
                info: 'info',
                success: 'success',
                warning: 'warning'
            };

            var toastr = {
                clear: clear,
                remove: remove,
                error: error,
                getContainer: getContainer,
                info: info,
                options: {},
                subscribe: subscribe,
                success: success,
                version: '2.1.4',
                warning: warning
            };

            var previousToast;

            return toastr;

            ////////////////

            function error(message, title, optionsOverride) {
                return notify({
                    type: toastType.error,
                    iconClass: getOptions().iconClasses.error,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function getContainer(options, create) {
                if (!options) { options = getOptions(); }
                $container = $('#' + options.containerId);
                if ($container.length) {
                    return $container;
                }
                if (create) {
                    $container = createContainer(options);
                }
                return $container;
            }

            function info(message, title, optionsOverride) {
                return notify({
                    type: toastType.info,
                    iconClass: getOptions().iconClasses.info,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function subscribe(callback) {
                listener = callback;
            }

            function success(message, title, optionsOverride) {
                return notify({
                    type: toastType.success,
                    iconClass: getOptions().iconClasses.success,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function warning(message, title, optionsOverride) {
                return notify({
                    type: toastType.warning,
                    iconClass: getOptions().iconClasses.warning,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function clear($toastElement, clearOptions) {
                var options = getOptions();
                if (!$container) { getContainer(options); }
                if (!clearToast($toastElement, options, clearOptions)) {
                    clearContainer(options);
                }
            }

            function remove($toastElement) {
                var options = getOptions();
                if (!$container) { getContainer(options); }
                if ($toastElement && $(':focus', $toastElement).length === 0) {
                    removeToast($toastElement);
                    return;
                }
                if ($container.children().length) {
                    $container.remove();
                }
            }

            // internal functions

            function clearContainer (options) {
                var toastsToClear = $container.children();
                for (var i = toastsToClear.length - 1; i >= 0; i--) {
                    clearToast($(toastsToClear[i]), options);
                }
            }

            function clearToast ($toastElement, options, clearOptions) {
                var force = clearOptions && clearOptions.force ? clearOptions.force : false;
                if ($toastElement && (force || $(':focus', $toastElement).length === 0)) {
                    $toastElement[options.hideMethod]({
                        duration: options.hideDuration,
                        easing: options.hideEasing,
                        complete: function () { removeToast($toastElement); }
                    });
                    return true;
                }
                return false;
            }

            function createContainer(options) {
                $container = $('<div/>')
                    .attr('id', options.containerId)
                    .addClass(options.positionClass);

                $container.appendTo($(options.target));
                return $container;
            }

            function getDefaults() {
                return {
                    tapToDismiss: true,
                    toastClass: 'toast',
                    containerId: 'toast-container',
                    debug: false,

                    showMethod: 'fadeIn', //fadeIn, slideDown, and show are built into jQuery
                    showDuration: 300,
                    showEasing: 'swing', //swing and linear are built into jQuery
                    onShown: undefined,
                    hideMethod: 'fadeOut',
                    hideDuration: 1000,
                    hideEasing: 'swing',
                    onHidden: undefined,
                    closeMethod: false,
                    closeDuration: false,
                    closeEasing: false,
                    closeOnHover: true,

                    extendedTimeOut: 1000,
                    iconClasses: {
                        error: 'toast-error',
                        info: 'toast-info',
                        success: 'toast-success',
                        warning: 'toast-warning'
                    },
                    iconClass: 'toast-info',
                    positionClass: 'toast-top-right',
                    timeOut: 5000, // Set timeOut and extendedTimeOut to 0 to make it sticky
                    titleClass: 'toast-title',
                    messageClass: 'toast-message',
                    escapeHtml: false,
                    target: 'body',
                    closeHtml: '<button type="button">&times;</button>',
                    closeClass: 'toast-close-button',
                    newestOnTop: true,
                    preventDuplicates: false,
                    progressBar: false,
                    progressClass: 'toast-progress',
                    rtl: false
                };
            }

            function publish(args) {
                if (!listener) { return; }
                listener(args);
            }

            function notify(map) {
                var options = getOptions();
                var iconClass = map.iconClass || options.iconClass;

                if (typeof (map.optionsOverride) !== 'undefined') {
                    options = $.extend(options, map.optionsOverride);
                    iconClass = map.optionsOverride.iconClass || iconClass;
                }

                if (shouldExit(options, map)) { return; }

                toastId++;

                $container = getContainer(options, true);

                var intervalId = null;
                var $toastElement = $('<div/>');
                var $titleElement = $('<div/>');
                var $messageElement = $('<div/>');
                var $progressElement = $('<div/>');
                var $closeElement = $(options.closeHtml);
                var progressBar = {
                    intervalId: null,
                    hideEta: null,
                    maxHideTime: null
                };
                var response = {
                    toastId: toastId,
                    state: 'visible',
                    startTime: new Date(),
                    options: options,
                    map: map
                };

                personalizeToast();

                displayToast();

                handleEvents();

                publish(response);

                if (options.debug && console) {
                    console.log(response);
                }

                return $toastElement;

                function escapeHtml(source) {
                    if (source == null) {
                        source = '';
                    }

                    return source
                        .replace(/&/g, '&amp;')
                        .replace(/"/g, '&quot;')
                        .replace(/'/g, '&#39;')
                        .replace(/</g, '&lt;')
                        .replace(/>/g, '&gt;');
                }

                function personalizeToast() {
                    setIcon();
                    setTitle();
                    setMessage();
                    setCloseButton();
                    setProgressBar();
                    setRTL();
                    setSequence();
                    setAria();
                }

                function setAria() {
                    var ariaValue = '';
                    switch (map.iconClass) {
                        case 'toast-success':
                        case 'toast-info':
                            ariaValue =  'polite';
                            break;
                        default:
                            ariaValue = 'assertive';
                    }
                    $toastElement.attr('aria-live', ariaValue);
                }

                function handleEvents() {
                    if (options.closeOnHover) {
                        $toastElement.hover(stickAround, delayedHideToast);
                    }

                    if (!options.onclick && options.tapToDismiss) {
                        $toastElement.click(hideToast);
                    }

                    if (options.closeButton && $closeElement) {
                        $closeElement.click(function (event) {
                            if (event.stopPropagation) {
                                event.stopPropagation();
                            } else if (event.cancelBubble !== undefined && event.cancelBubble !== true) {
                                event.cancelBubble = true;
                            }

                            if (options.onCloseClick) {
                                options.onCloseClick(event);
                            }

                            hideToast(true);
                        });
                    }

                    if (options.onclick) {
                        $toastElement.click(function (event) {
                            options.onclick(event);
                            hideToast();
                        });
                    }
                }

                function displayToast() {
                    $toastElement.hide();

                    $toastElement[options.showMethod](
                        {duration: options.showDuration, easing: options.showEasing, complete: options.onShown}
                    );

                    if (options.timeOut > 0) {
                        intervalId = setTimeout(hideToast, options.timeOut);
                        progressBar.maxHideTime = parseFloat(options.timeOut);
                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
                        if (options.progressBar) {
                            progressBar.intervalId = setInterval(updateProgress, 10);
                        }
                    }
                }

                function setIcon() {
                    if (map.iconClass) {
                        $toastElement.addClass(options.toastClass).addClass(iconClass);
                    }
                }

                function setSequence() {
                    if (options.newestOnTop) {
                        $container.prepend($toastElement);
                    } else {
                        $container.append($toastElement);
                    }
                }

                function setTitle() {
                    if (map.title) {
                        var suffix = map.title;
                        if (options.escapeHtml) {
                            suffix = escapeHtml(map.title);
                        }
                        $titleElement.append(suffix).addClass(options.titleClass);
                        $toastElement.append($titleElement);
                    }
                }

                function setMessage() {
                    if (map.message) {
                        var suffix = map.message;
                        if (options.escapeHtml) {
                            suffix = escapeHtml(map.message);
                        }
                        $messageElement.append(suffix).addClass(options.messageClass);
                        $toastElement.append($messageElement);
                    }
                }

                function setCloseButton() {
                    if (options.closeButton) {
                        $closeElement.addClass(options.closeClass).attr('role', 'button');
                        $toastElement.prepend($closeElement);
                    }
                }

                function setProgressBar() {
                    if (options.progressBar) {
                        $progressElement.addClass(options.progressClass);
                        $toastElement.prepend($progressElement);
                    }
                }

                function setRTL() {
                    if (options.rtl) {
                        $toastElement.addClass('rtl');
                    }
                }

                function shouldExit(options, map) {
                    if (options.preventDuplicates) {
                        if (map.message === previousToast) {
                            return true;
                        } else {
                            previousToast = map.message;
                        }
                    }
                    return false;
                }

                function hideToast(override) {
                    var method = override && options.closeMethod !== false ? options.closeMethod : options.hideMethod;
                    var duration = override && options.closeDuration !== false ?
                        options.closeDuration : options.hideDuration;
                    var easing = override && options.closeEasing !== false ? options.closeEasing : options.hideEasing;
                    if ($(':focus', $toastElement).length && !override) {
                        return;
                    }
                    clearTimeout(progressBar.intervalId);
                    return $toastElement[method]({
                        duration: duration,
                        easing: easing,
                        complete: function () {
                            removeToast($toastElement);
                            clearTimeout(intervalId);
                            if (options.onHidden && response.state !== 'hidden') {
                                options.onHidden();
                            }
                            response.state = 'hidden';
                            response.endTime = new Date();
                            publish(response);
                        }
                    });
                }

                function delayedHideToast() {
                    if (options.timeOut > 0 || options.extendedTimeOut > 0) {
                        intervalId = setTimeout(hideToast, options.extendedTimeOut);
                        progressBar.maxHideTime = parseFloat(options.extendedTimeOut);
                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
                    }
                }

                function stickAround() {
                    clearTimeout(intervalId);
                    progressBar.hideEta = 0;
                    $toastElement.stop(true, true)[options.showMethod](
                        {duration: options.showDuration, easing: options.showEasing}
                    );
                }

                function updateProgress() {
                    var percentage = ((progressBar.hideEta - (new Date().getTime())) / progressBar.maxHideTime) * 100;
                    $progressElement.width(percentage + '%');
                }
            }

            function getOptions() {
                return $.extend({}, getDefaults(), toastr.options);
            }

            function removeToast($toastElement) {
                if (!$container) { $container = getContainer(); }
                if ($toastElement.is(':visible')) {
                    return;
                }
                $toastElement.remove();
                $toastElement = null;
                if ($container.children().length === 0) {
                    $container.remove();
                    previousToast = undefined;
                }
            }

        })();
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}(__webpack_require__(217)));


/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createUnix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createInZone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create_local__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create_utc__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__create_valid__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constructor__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__min_max__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__now__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__prototype__ = __webpack_require__(597);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_5__now__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_4__min_max__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__min_max__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__constructor__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__create_utc__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__create_local__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__create_valid__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__prototype__["a"]; });








function createUnix(input) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__create_local__["a" /* createLocal */])(input * 1000);
}

function createInZone() {
    return __WEBPACK_IMPORTED_MODULE_0__create_local__["a" /* createLocal */].apply(null, arguments).parseZone();
}




/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return some; });
var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this),
            len = t.length >>> 0,
            i;

        for (i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}




/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return keys; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__has_own_prop__ = __webpack_require__(26);


var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i,
            res = [];
        for (i in obj) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__has_own_prop__["a" /* default */])(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}




/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return baseConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__calendar__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formats__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__invalid__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ordinal__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__relative__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__units_month__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__units_week__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__units_day_of_week__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__units_hour__ = __webpack_require__(122);






// months


// week


// weekdays


// meridiem


var baseConfig = {
    calendar: __WEBPACK_IMPORTED_MODULE_0__calendar__["b" /* defaultCalendar */],
    longDateFormat: __WEBPACK_IMPORTED_MODULE_1__formats__["a" /* defaultLongDateFormat */],
    invalidDate: __WEBPACK_IMPORTED_MODULE_2__invalid__["a" /* defaultInvalidDate */],
    ordinal: __WEBPACK_IMPORTED_MODULE_3__ordinal__["b" /* defaultOrdinal */],
    dayOfMonthOrdinalParse: __WEBPACK_IMPORTED_MODULE_3__ordinal__["a" /* defaultDayOfMonthOrdinalParse */],
    relativeTime: __WEBPACK_IMPORTED_MODULE_4__relative__["a" /* defaultRelativeTime */],

    months: __WEBPACK_IMPORTED_MODULE_5__units_month__["b" /* defaultLocaleMonths */],
    monthsShort: __WEBPACK_IMPORTED_MODULE_5__units_month__["c" /* defaultLocaleMonthsShort */],

    week: __WEBPACK_IMPORTED_MODULE_6__units_week__["a" /* defaultLocaleWeek */],

    weekdays: __WEBPACK_IMPORTED_MODULE_7__units_day_of_week__["a" /* defaultLocaleWeekdays */],
    weekdaysMin: __WEBPACK_IMPORTED_MODULE_7__units_day_of_week__["b" /* defaultLocaleWeekdaysMin */],
    weekdaysShort: __WEBPACK_IMPORTED_MODULE_7__units_day_of_week__["c" /* defaultLocaleWeekdaysShort */],

    meridiemParse: __WEBPACK_IMPORTED_MODULE_8__units_hour__["a" /* defaultLocaleMeridiemParse */],
};


/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mod;
function mod(n, x) {
    return ((n % x) + x) % x;
}


/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = configFromStringAndArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__moment_constructor__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__from_string_and_format__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parsing_flags__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__valid__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_extend__ = __webpack_require__(96);






// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,
        scoreToBeat,
        i,
        currentScore,
        validFormatFound,
        bestFormatIsValid = false,
        configfLen = config._f.length;

    if (configfLen === 0) {
        Object(__WEBPACK_IMPORTED_MODULE_2__parsing_flags__["a" /* default */])(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < configfLen; i++) {
        currentScore = 0;
        validFormatFound = false;
        tempConfig = Object(__WEBPACK_IMPORTED_MODULE_0__moment_constructor__["b" /* copyConfig */])({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        Object(__WEBPACK_IMPORTED_MODULE_1__from_string_and_format__["a" /* configFromStringAndFormat */])(tempConfig);

        if (Object(__WEBPACK_IMPORTED_MODULE_3__valid__["b" /* isValid */])(tempConfig)) {
            validFormatFound = true;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += Object(__WEBPACK_IMPORTED_MODULE_2__parsing_flags__["a" /* default */])(tempConfig).charsLeftOver;

        //or tokens
        currentScore += Object(__WEBPACK_IMPORTED_MODULE_2__parsing_flags__["a" /* default */])(tempConfig).unusedTokens.length * 10;

        Object(__WEBPACK_IMPORTED_MODULE_2__parsing_flags__["a" /* default */])(tempConfig).score = currentScore;

        if (!bestFormatIsValid) {
            if (
                scoreToBeat == null ||
                currentScore < scoreToBeat ||
                validFormatFound
            ) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
                if (validFormatFound) {
                    bestFormatIsValid = true;
                }
            }
        } else {
            if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
    }

    Object(__WEBPACK_IMPORTED_MODULE_4__utils_extend__["a" /* default */])(config, bestMoment || tempConfig);
}


/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaults;
// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}


/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = configFromObject;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__units_aliases__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__from_array__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_map__ = __webpack_require__(218);




function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = Object(__WEBPACK_IMPORTED_MODULE_0__units_aliases__["b" /* normalizeObjectUnits */])(config._i),
        dayOrDate = i.day === undefined ? i.date : i.day;
    config._a = Object(__WEBPACK_IMPORTED_MODULE_2__utils_map__["a" /* default */])(
        [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
        function (obj) {
            return obj && parseInt(obj, 10);
        }
    );

    Object(__WEBPACK_IMPORTED_MODULE_1__from_array__["a" /* configFromArray */])(config);
}


/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return now; });
var now = function () {
    return Date.now ? Date.now() : +new Date();
};


/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constructor__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__add_subtract__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__calendar__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__clone__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compare__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__diff__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__format__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__from__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__to__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__get_set__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__locale__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__min_max__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__start_end_of__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__to_type__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__valid__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__creation_data__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__units_era__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__units_year__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__units_week_year__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__units_quarter__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__units_month__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__units_week__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__units_day_of_month__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__units_day_of_week__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__units_day_of_year__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__units_hour__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__units_minute__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__units_second__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__units_millisecond__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__units_offset__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__units_timezone__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__utils_deprecate__ = __webpack_require__(65);


var proto = __WEBPACK_IMPORTED_MODULE_0__constructor__["a" /* Moment */].prototype;

















proto.add = __WEBPACK_IMPORTED_MODULE_1__add_subtract__["a" /* add */];
proto.calendar = __WEBPACK_IMPORTED_MODULE_2__calendar__["a" /* calendar */];
proto.clone = __WEBPACK_IMPORTED_MODULE_3__clone__["a" /* clone */];
proto.diff = __WEBPACK_IMPORTED_MODULE_5__diff__["a" /* diff */];
proto.endOf = __WEBPACK_IMPORTED_MODULE_12__start_end_of__["a" /* endOf */];
proto.format = __WEBPACK_IMPORTED_MODULE_6__format__["a" /* format */];
proto.from = __WEBPACK_IMPORTED_MODULE_7__from__["a" /* from */];
proto.fromNow = __WEBPACK_IMPORTED_MODULE_7__from__["b" /* fromNow */];
proto.to = __WEBPACK_IMPORTED_MODULE_8__to__["a" /* to */];
proto.toNow = __WEBPACK_IMPORTED_MODULE_8__to__["b" /* toNow */];
proto.get = __WEBPACK_IMPORTED_MODULE_9__get_set__["d" /* stringGet */];
proto.invalidAt = __WEBPACK_IMPORTED_MODULE_14__valid__["a" /* invalidAt */];
proto.isAfter = __WEBPACK_IMPORTED_MODULE_4__compare__["a" /* isAfter */];
proto.isBefore = __WEBPACK_IMPORTED_MODULE_4__compare__["b" /* isBefore */];
proto.isBetween = __WEBPACK_IMPORTED_MODULE_4__compare__["c" /* isBetween */];
proto.isSame = __WEBPACK_IMPORTED_MODULE_4__compare__["d" /* isSame */];
proto.isSameOrAfter = __WEBPACK_IMPORTED_MODULE_4__compare__["e" /* isSameOrAfter */];
proto.isSameOrBefore = __WEBPACK_IMPORTED_MODULE_4__compare__["f" /* isSameOrBefore */];
proto.isValid = __WEBPACK_IMPORTED_MODULE_14__valid__["b" /* isValid */];
proto.lang = __WEBPACK_IMPORTED_MODULE_10__locale__["a" /* lang */];
proto.locale = __WEBPACK_IMPORTED_MODULE_10__locale__["b" /* locale */];
proto.localeData = __WEBPACK_IMPORTED_MODULE_10__locale__["c" /* localeData */];
proto.max = __WEBPACK_IMPORTED_MODULE_11__min_max__["c" /* prototypeMax */];
proto.min = __WEBPACK_IMPORTED_MODULE_11__min_max__["d" /* prototypeMin */];
proto.parsingFlags = __WEBPACK_IMPORTED_MODULE_14__valid__["c" /* parsingFlags */];
proto.set = __WEBPACK_IMPORTED_MODULE_9__get_set__["e" /* stringSet */];
proto.startOf = __WEBPACK_IMPORTED_MODULE_12__start_end_of__["b" /* startOf */];
proto.subtract = __WEBPACK_IMPORTED_MODULE_1__add_subtract__["c" /* subtract */];
proto.toArray = __WEBPACK_IMPORTED_MODULE_13__to_type__["a" /* toArray */];
proto.toObject = __WEBPACK_IMPORTED_MODULE_13__to_type__["d" /* toObject */];
proto.toDate = __WEBPACK_IMPORTED_MODULE_13__to_type__["b" /* toDate */];
proto.toISOString = __WEBPACK_IMPORTED_MODULE_6__format__["c" /* toISOString */];
proto.inspect = __WEBPACK_IMPORTED_MODULE_6__format__["b" /* inspect */];
if (typeof Symbol !== 'undefined' && Symbol.for != null) {
    proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
        return 'Moment<' + this.format() + '>';
    };
}
proto.toJSON = __WEBPACK_IMPORTED_MODULE_13__to_type__["c" /* toJSON */];
proto.toString = __WEBPACK_IMPORTED_MODULE_6__format__["d" /* toString */];
proto.unix = __WEBPACK_IMPORTED_MODULE_13__to_type__["e" /* unix */];
proto.valueOf = __WEBPACK_IMPORTED_MODULE_13__to_type__["f" /* valueOf */];
proto.creationData = __WEBPACK_IMPORTED_MODULE_15__creation_data__["a" /* creationData */];

// Era

proto.eraName = __WEBPACK_IMPORTED_MODULE_16__units_era__["e" /* getEraName */];
proto.eraNarrow = __WEBPACK_IMPORTED_MODULE_16__units_era__["f" /* getEraNarrow */];
proto.eraAbbr = __WEBPACK_IMPORTED_MODULE_16__units_era__["d" /* getEraAbbr */];
proto.eraYear = __WEBPACK_IMPORTED_MODULE_16__units_era__["g" /* getEraYear */];

// Year

proto.year = __WEBPACK_IMPORTED_MODULE_17__units_year__["c" /* getSetYear */];
proto.isLeapYear = __WEBPACK_IMPORTED_MODULE_17__units_year__["b" /* getIsLeapYear */];

// Week Year

proto.weekYear = __WEBPACK_IMPORTED_MODULE_18__units_week_year__["d" /* getSetWeekYear */];
proto.isoWeekYear = __WEBPACK_IMPORTED_MODULE_18__units_week_year__["c" /* getSetISOWeekYear */];

// Quarter

proto.quarter = proto.quarters = __WEBPACK_IMPORTED_MODULE_19__units_quarter__["a" /* getSetQuarter */];

// Month

proto.month = __WEBPACK_IMPORTED_MODULE_20__units_month__["e" /* getSetMonth */];
proto.daysInMonth = __WEBPACK_IMPORTED_MODULE_20__units_month__["d" /* getDaysInMonth */];

// Week

proto.week = proto.weeks = __WEBPACK_IMPORTED_MODULE_21__units_week__["c" /* getSetWeek */];
proto.isoWeek = proto.isoWeeks = __WEBPACK_IMPORTED_MODULE_21__units_week__["b" /* getSetISOWeek */];
proto.weeksInYear = __WEBPACK_IMPORTED_MODULE_18__units_week_year__["f" /* getWeeksInYear */];
proto.weeksInWeekYear = __WEBPACK_IMPORTED_MODULE_18__units_week_year__["e" /* getWeeksInWeekYear */];
proto.isoWeeksInYear = __WEBPACK_IMPORTED_MODULE_18__units_week_year__["b" /* getISOWeeksInYear */];
proto.isoWeeksInISOWeekYear = __WEBPACK_IMPORTED_MODULE_18__units_week_year__["a" /* getISOWeeksInISOWeekYear */];

// Day



proto.date = __WEBPACK_IMPORTED_MODULE_22__units_day_of_month__["a" /* getSetDayOfMonth */];
proto.day = proto.days = __WEBPACK_IMPORTED_MODULE_23__units_day_of_week__["d" /* getSetDayOfWeek */];
proto.weekday = __WEBPACK_IMPORTED_MODULE_23__units_day_of_week__["f" /* getSetLocaleDayOfWeek */];
proto.isoWeekday = __WEBPACK_IMPORTED_MODULE_23__units_day_of_week__["e" /* getSetISODayOfWeek */];
proto.dayOfYear = __WEBPACK_IMPORTED_MODULE_24__units_day_of_year__["a" /* getSetDayOfYear */];

// Hour

proto.hour = proto.hours = __WEBPACK_IMPORTED_MODULE_25__units_hour__["b" /* getSetHour */];

// Minute

proto.minute = proto.minutes = __WEBPACK_IMPORTED_MODULE_26__units_minute__["a" /* getSetMinute */];

// Second

proto.second = proto.seconds = __WEBPACK_IMPORTED_MODULE_27__units_second__["a" /* getSetSecond */];

// Millisecond

proto.millisecond = proto.milliseconds = __WEBPACK_IMPORTED_MODULE_28__units_millisecond__["a" /* getSetMillisecond */];

// Offset

proto.utcOffset = __WEBPACK_IMPORTED_MODULE_29__units_offset__["b" /* getSetOffset */];
proto.utc = __WEBPACK_IMPORTED_MODULE_29__units_offset__["l" /* setOffsetToUTC */];
proto.local = __WEBPACK_IMPORTED_MODULE_29__units_offset__["j" /* setOffsetToLocal */];
proto.parseZone = __WEBPACK_IMPORTED_MODULE_29__units_offset__["k" /* setOffsetToParsedOffset */];
proto.hasAlignedHourOffset = __WEBPACK_IMPORTED_MODULE_29__units_offset__["d" /* hasAlignedHourOffset */];
proto.isDST = __WEBPACK_IMPORTED_MODULE_29__units_offset__["e" /* isDaylightSavingTime */];
proto.isLocal = __WEBPACK_IMPORTED_MODULE_29__units_offset__["g" /* isLocal */];
proto.isUtcOffset = __WEBPACK_IMPORTED_MODULE_29__units_offset__["i" /* isUtcOffset */];
proto.isUtc = __WEBPACK_IMPORTED_MODULE_29__units_offset__["h" /* isUtc */];
proto.isUTC = __WEBPACK_IMPORTED_MODULE_29__units_offset__["h" /* isUtc */];

// Timezone

proto.zoneAbbr = __WEBPACK_IMPORTED_MODULE_30__units_timezone__["a" /* getZoneAbbr */];
proto.zoneName = __WEBPACK_IMPORTED_MODULE_30__units_timezone__["b" /* getZoneName */];

// Deprecations

proto.dates = Object(__WEBPACK_IMPORTED_MODULE_31__utils_deprecate__["a" /* deprecate */])(
    'dates accessor is deprecated. Use date instead.',
    __WEBPACK_IMPORTED_MODULE_22__units_day_of_month__["a" /* getSetDayOfMonth */]
);
proto.months = Object(__WEBPACK_IMPORTED_MODULE_31__utils_deprecate__["a" /* deprecate */])(
    'months accessor is deprecated. Use month instead',
    __WEBPACK_IMPORTED_MODULE_20__units_month__["e" /* getSetMonth */]
);
proto.years = Object(__WEBPACK_IMPORTED_MODULE_31__utils_deprecate__["a" /* deprecate */])(
    'years accessor is deprecated. Use year instead',
    __WEBPACK_IMPORTED_MODULE_17__units_year__["c" /* getSetYear */]
);
proto.zone = Object(__WEBPACK_IMPORTED_MODULE_31__utils_deprecate__["a" /* deprecate */])(
    'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
    __WEBPACK_IMPORTED_MODULE_29__units_offset__["c" /* getSetZone */]
);
proto.isDSTShifted = Object(__WEBPACK_IMPORTED_MODULE_31__utils_deprecate__["a" /* deprecate */])(
    'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
    __WEBPACK_IMPORTED_MODULE_29__units_offset__["f" /* isDaylightSavingTimeShifted */]
);

/* harmony default export */ __webpack_exports__["a"] = (proto);


/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compareArrays;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__to_int__ = __webpack_require__(24);


// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if (
            (dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && Object(__WEBPACK_IMPORTED_MODULE_0__to_int__["a" /* default */])(array1[i]) !== Object(__WEBPACK_IMPORTED_MODULE_0__to_int__["a" /* default */])(array2[i]))
        ) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}


/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isMomentInput;
/* unused harmony export isMomentInputObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_object_empty__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__has_own_prop__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__is_object__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__is_date__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__is_number__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__is_string__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__moment_constructor__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__is_array__ = __webpack_require__(86);









// type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
function isMomentInput(input) {
    return (
        Object(__WEBPACK_IMPORTED_MODULE_6__moment_constructor__["c" /* isMoment */])(input) ||
        Object(__WEBPACK_IMPORTED_MODULE_3__is_date__["a" /* default */])(input) ||
        Object(__WEBPACK_IMPORTED_MODULE_5__is_string__["a" /* default */])(input) ||
        Object(__WEBPACK_IMPORTED_MODULE_4__is_number__["a" /* default */])(input) ||
        isNumberOrStringArray(input) ||
        isMomentInputObject(input) ||
        input === null ||
        input === undefined
    );
}

function isMomentInputObject(input) {
    var objectTest = Object(__WEBPACK_IMPORTED_MODULE_2__is_object__["a" /* default */])(input) && !Object(__WEBPACK_IMPORTED_MODULE_0__is_object_empty__["a" /* default */])(input),
        propertyTest = false,
        properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms',
        ],
        i,
        property,
        propertyLen = properties.length;

    for (i = 0; i < propertyLen; i += 1) {
        property = properties[i];
        propertyTest = propertyTest || Object(__WEBPACK_IMPORTED_MODULE_1__has_own_prop__["a" /* default */])(input, property);
    }

    return objectTest && propertyTest;
}

function isNumberOrStringArray(input) {
    var arrayTest = Object(__WEBPACK_IMPORTED_MODULE_7__is_array__["a" /* default */])(input),
        dataTypeTest = false;
    if (arrayTest) {
        dataTypeTest =
            input.filter(function (item) {
                return !Object(__WEBPACK_IMPORTED_MODULE_4__is_number__["a" /* default */])(item) && Object(__WEBPACK_IMPORTED_MODULE_5__is_string__["a" /* default */])(input);
            }).length === 0;
    }
    return arrayTest && dataTypeTest;
}


/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isString;
function isString(input) {
    return typeof input === 'string' || input instanceof String;
}


/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isCalendarSpec;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is_object_empty__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__has_own_prop__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__is_object__ = __webpack_require__(115);




function isCalendarSpec(input) {
    var objectTest = Object(__WEBPACK_IMPORTED_MODULE_2__is_object__["a" /* default */])(input) && !Object(__WEBPACK_IMPORTED_MODULE_0__is_object_empty__["a" /* default */])(input),
        propertyTest = false,
        properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse',
        ],
        i,
        property;

    for (i = 0; i < properties.length; i += 1) {
        property = properties[i];
        propertyTest = propertyTest || Object(__WEBPACK_IMPORTED_MODULE_1__has_own_prop__["a" /* default */])(input, property);
    }

    return objectTest && propertyTest;
}


/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constructor__ = __webpack_require__(54);


function clone() {
    return new __WEBPACK_IMPORTED_MODULE_0__constructor__["a" /* Moment */](this);
}


/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isAfter;
/* harmony export (immutable) */ __webpack_exports__["b"] = isBefore;
/* harmony export (immutable) */ __webpack_exports__["c"] = isBetween;
/* harmony export (immutable) */ __webpack_exports__["d"] = isSame;
/* harmony export (immutable) */ __webpack_exports__["e"] = isSameOrAfter;
/* harmony export (immutable) */ __webpack_exports__["f"] = isSameOrBefore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constructor__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__units_aliases__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__create_local__ = __webpack_require__(59);




function isAfter(input, units) {
    var localInput = Object(__WEBPACK_IMPORTED_MODULE_0__constructor__["c" /* isMoment */])(input) ? input : Object(__WEBPACK_IMPORTED_MODULE_2__create_local__["a" /* createLocal */])(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = Object(__WEBPACK_IMPORTED_MODULE_1__units_aliases__["c" /* normalizeUnits */])(units) || 'millisecond';
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore(input, units) {
    var localInput = Object(__WEBPACK_IMPORTED_MODULE_0__constructor__["c" /* isMoment */])(input) ? input : Object(__WEBPACK_IMPORTED_MODULE_2__create_local__["a" /* createLocal */])(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = Object(__WEBPACK_IMPORTED_MODULE_1__units_aliases__["c" /* normalizeUnits */])(units) || 'millisecond';
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween(from, to, units, inclusivity) {
    var localFrom = Object(__WEBPACK_IMPORTED_MODULE_0__constructor__["c" /* isMoment */])(from) ? from : Object(__WEBPACK_IMPORTED_MODULE_2__create_local__["a" /* createLocal */])(from),
        localTo = Object(__WEBPACK_IMPORTED_MODULE_0__constructor__["c" /* isMoment */])(to) ? to : Object(__WEBPACK_IMPORTED_MODULE_2__create_local__["a" /* createLocal */])(to);
    if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
        return false;
    }
    inclusivity = inclusivity || '()';
    return (
        (inclusivity[0] === '('
            ? this.isAfter(localFrom, units)
            : !this.isBefore(localFrom, units)) &&
        (inclusivity[1] === ')'
            ? this.isBefore(localTo, units)
            : !this.isAfter(localTo, units))
    );
}

function isSame(input, units) {
    var localInput = Object(__WEBPACK_IMPORTED_MODULE_0__constructor__["c" /* isMoment */])(input) ? input : Object(__WEBPACK_IMPORTED_MODULE_2__create_local__["a" /* createLocal */])(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = Object(__WEBPACK_IMPORTED_MODULE_1__units_aliases__["c" /* normalizeUnits */])(units) || 'millisecond';
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return (
            this.clone().startOf(units).valueOf() <= inputMs &&
            inputMs <= this.clone().endOf(units).valueOf()
        );
    }
}

function isSameOrAfter(input, units) {
    return this.isSame(input, units) || this.isAfter(input, units);
}

function isSameOrBefore(input, units) {
    return this.isSame(input, units) || this.isBefore(input, units);
}


/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = diff;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_abs_floor__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__units_offset__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__units_aliases__ = __webpack_require__(21);




function diff(input, units, asFloat) {
    var that, zoneDelta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = Object(__WEBPACK_IMPORTED_MODULE_1__units_offset__["a" /* cloneWithOffset */])(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = Object(__WEBPACK_IMPORTED_MODULE_2__units_aliases__["c" /* normalizeUnits */])(units);

    switch (units) {
        case 'year':
            output = monthDiff(this, that) / 12;
            break;
        case 'month':
            output = monthDiff(this, that);
            break;
        case 'quarter':
            output = monthDiff(this, that) / 3;
            break;
        case 'second':
            output = (this - that) / 1e3;
            break; // 1000
        case 'minute':
            output = (this - that) / 6e4;
            break; // 1000 * 60
        case 'hour':
            output = (this - that) / 36e5;
            break; // 1000 * 60 * 60
        case 'day':
            output = (this - that - zoneDelta) / 864e5;
            break; // 1000 * 60 * 60 * 24, negate dst
        case 'week':
            output = (this - that - zoneDelta) / 6048e5;
            break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default:
            output = this - that;
    }

    return asFloat ? output : Object(__WEBPACK_IMPORTED_MODULE_0__utils_abs_floor__["a" /* default */])(output);
}

function monthDiff(a, b) {
    if (a.date() < b.date()) {
        // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
    }
    // difference in months
    var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2,
        adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}


/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = toString;
/* harmony export (immutable) */ __webpack_exports__["c"] = toISOString;
/* harmony export (immutable) */ __webpack_exports__["b"] = inspect;
/* harmony export (immutable) */ __webpack_exports__["a"] = format;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_format__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_hooks__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_is_function__ = __webpack_require__(66);




__WEBPACK_IMPORTED_MODULE_1__utils_hooks__["a" /* hooks */].defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
__WEBPACK_IMPORTED_MODULE_1__utils_hooks__["a" /* hooks */].defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString() {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString(keepOffset) {
    if (!this.isValid()) {
        return null;
    }
    var utc = keepOffset !== true,
        m = utc ? this.clone().utc() : this;
    if (m.year() < 0 || m.year() > 9999) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["c" /* formatMoment */])(
            m,
            utc
                ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_is_function__["a" /* default */])(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        if (utc) {
            return this.toDate().toISOString();
        } else {
            return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                .toISOString()
                .replace('Z', Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["c" /* formatMoment */])(m, 'Z'));
        }
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["c" /* formatMoment */])(
        m,
        utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
    );
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect() {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment',
        zone = '',
        prefix,
        year,
        datetime,
        suffix;
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    prefix = '[' + func + '("]';
    year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
    datetime = '-MM-DD[T]HH:mm:ss.SSS';
    suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format(inputString) {
    if (!inputString) {
        inputString = this.isUtc()
            ? __WEBPACK_IMPORTED_MODULE_1__utils_hooks__["a" /* hooks */].defaultFormatUtc
            : __WEBPACK_IMPORTED_MODULE_1__utils_hooks__["a" /* hooks */].defaultFormat;
    }
    var output = Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["c" /* formatMoment */])(this, inputString);
    return this.localeData().postformat(output);
}


/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = from;
/* harmony export (immutable) */ __webpack_exports__["b"] = fromNow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__duration_create__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create_local__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__moment_constructor__ = __webpack_require__(54);




function from(time, withoutSuffix) {
    if (
        this.isValid() &&
        ((Object(__WEBPACK_IMPORTED_MODULE_2__moment_constructor__["c" /* isMoment */])(time) && time.isValid()) || Object(__WEBPACK_IMPORTED_MODULE_1__create_local__["a" /* createLocal */])(time).isValid())
    ) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__duration_create__["a" /* createDuration */])({ to: this, from: time })
            .locale(this.locale())
            .humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow(withoutSuffix) {
    return this.from(Object(__WEBPACK_IMPORTED_MODULE_1__create_local__["a" /* createLocal */])(), withoutSuffix);
}


/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = to;
/* harmony export (immutable) */ __webpack_exports__["b"] = toNow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__duration_create__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create_local__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__moment_constructor__ = __webpack_require__(54);




function to(time, withoutSuffix) {
    if (
        this.isValid() &&
        ((Object(__WEBPACK_IMPORTED_MODULE_2__moment_constructor__["c" /* isMoment */])(time) && time.isValid()) || Object(__WEBPACK_IMPORTED_MODULE_1__create_local__["a" /* createLocal */])(time).isValid())
    ) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__duration_create__["a" /* createDuration */])({ from: this, to: time })
            .locale(this.locale())
            .humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow(withoutSuffix) {
    return this.to(Object(__WEBPACK_IMPORTED_MODULE_1__create_local__["a" /* createLocal */])(), withoutSuffix);
}


/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = startOf;
/* harmony export (immutable) */ __webpack_exports__["a"] = endOf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__units_aliases__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_hooks__ = __webpack_require__(25);



var MS_PER_SECOND = 1000,
    MS_PER_MINUTE = 60 * MS_PER_SECOND,
    MS_PER_HOUR = 60 * MS_PER_MINUTE,
    MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

// actual modulo - handles negative numbers (for dates before 1970):
function mod(dividend, divisor) {
    return ((dividend % divisor) + divisor) % divisor;
}

function localStartOfDate(y, m, d) {
    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
    } else {
        return new Date(y, m, d).valueOf();
    }
}

function utcStartOfDate(y, m, d) {
    // Date.UTC remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
    } else {
        return Date.UTC(y, m, d);
    }
}

function startOf(units) {
    var time, startOfDate;
    units = Object(__WEBPACK_IMPORTED_MODULE_0__units_aliases__["c" /* normalizeUnits */])(units);
    if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
    }

    startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

    switch (units) {
        case 'year':
            time = startOfDate(this.year(), 0, 1);
            break;
        case 'quarter':
            time = startOfDate(
                this.year(),
                this.month() - (this.month() % 3),
                1
            );
            break;
        case 'month':
            time = startOfDate(this.year(), this.month(), 1);
            break;
        case 'week':
            time = startOfDate(
                this.year(),
                this.month(),
                this.date() - this.weekday()
            );
            break;
        case 'isoWeek':
            time = startOfDate(
                this.year(),
                this.month(),
                this.date() - (this.isoWeekday() - 1)
            );
            break;
        case 'day':
        case 'date':
            time = startOfDate(this.year(), this.month(), this.date());
            break;
        case 'hour':
            time = this._d.valueOf();
            time -= mod(
                time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                MS_PER_HOUR
            );
            break;
        case 'minute':
            time = this._d.valueOf();
            time -= mod(time, MS_PER_MINUTE);
            break;
        case 'second':
            time = this._d.valueOf();
            time -= mod(time, MS_PER_SECOND);
            break;
    }

    this._d.setTime(time);
    __WEBPACK_IMPORTED_MODULE_1__utils_hooks__["a" /* hooks */].updateOffset(this, true);
    return this;
}

function endOf(units) {
    var time, startOfDate;
    units = Object(__WEBPACK_IMPORTED_MODULE_0__units_aliases__["c" /* normalizeUnits */])(units);
    if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
    }

    startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

    switch (units) {
        case 'year':
            time = startOfDate(this.year() + 1, 0, 1) - 1;
            break;
        case 'quarter':
            time =
                startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3) + 3,
                    1
                ) - 1;
            break;
        case 'month':
            time = startOfDate(this.year(), this.month() + 1, 1) - 1;
            break;
        case 'week':
            time =
                startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday() + 7
                ) - 1;
            break;
        case 'isoWeek':
            time =
                startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1) + 7
                ) - 1;
            break;
        case 'day':
        case 'date':
            time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
            break;
        case 'hour':
            time = this._d.valueOf();
            time +=
                MS_PER_HOUR -
                mod(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                ) -
                1;
            break;
        case 'minute':
            time = this._d.valueOf();
            time += MS_PER_MINUTE - mod(time, MS_PER_MINUTE) - 1;
            break;
        case 'second':
            time = this._d.valueOf();
            time += MS_PER_SECOND - mod(time, MS_PER_SECOND) - 1;
            break;
    }

    this._d.setTime(time);
    __WEBPACK_IMPORTED_MODULE_1__utils_hooks__["a" /* hooks */].updateOffset(this, true);
    return this;
}


/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = valueOf;
/* harmony export (immutable) */ __webpack_exports__["e"] = unix;
/* harmony export (immutable) */ __webpack_exports__["b"] = toDate;
/* harmony export (immutable) */ __webpack_exports__["a"] = toArray;
/* harmony export (immutable) */ __webpack_exports__["d"] = toObject;
/* harmony export (immutable) */ __webpack_exports__["c"] = toJSON;
function valueOf() {
    return this._d.valueOf() - (this._offset || 0) * 60000;
}

function unix() {
    return Math.floor(this.valueOf() / 1000);
}

function toDate() {
    return new Date(this.valueOf());
}

function toArray() {
    var m = this;
    return [
        m.year(),
        m.month(),
        m.date(),
        m.hour(),
        m.minute(),
        m.second(),
        m.millisecond(),
    ];
}

function toObject() {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds(),
    };
}

function toJSON() {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}


/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isValid;
/* harmony export (immutable) */ __webpack_exports__["c"] = parsingFlags;
/* harmony export (immutable) */ __webpack_exports__["a"] = invalidAt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create_valid__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_extend__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__create_parsing_flags__ = __webpack_require__(42);




function isValid() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__create_valid__["b" /* isValid */])(this);
}

function parsingFlags() {
    return Object(__WEBPACK_IMPORTED_MODULE_1__utils_extend__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_2__create_parsing_flags__["a" /* default */])(this));
}

function invalidAt() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__create_parsing_flags__["a" /* default */])(this).overflow;
}


/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = creationData;
function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict,
    };
}


/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__prototype__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locales__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lists__ = __webpack_require__(614);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__locales__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__locales__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__locales__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__locales__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__locales__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__lists__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__lists__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__lists__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_2__lists__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__lists__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_deprecate__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_hooks__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__en__ = __webpack_require__(615);
// Side effect imports











__WEBPACK_IMPORTED_MODULE_4__utils_hooks__["a" /* hooks */].lang = Object(__WEBPACK_IMPORTED_MODULE_3__utils_deprecate__["a" /* deprecate */])(
    'moment.lang is deprecated. Use moment.locale instead.',
    __WEBPACK_IMPORTED_MODULE_1__locales__["c" /* getSetGlobalLocale */]
);
__WEBPACK_IMPORTED_MODULE_4__utils_hooks__["a" /* hooks */].langData = Object(__WEBPACK_IMPORTED_MODULE_3__utils_deprecate__["a" /* deprecate */])(
    'moment.langData is deprecated. Use moment.localeData instead.',
    __WEBPACK_IMPORTED_MODULE_1__locales__["b" /* getLocale */]
);




/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = preParsePostFormat;
function preParsePostFormat(string) {
    return string;
}


/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = listMonths;
/* harmony export (immutable) */ __webpack_exports__["b"] = listMonthsShort;
/* harmony export (immutable) */ __webpack_exports__["c"] = listWeekdays;
/* harmony export (immutable) */ __webpack_exports__["e"] = listWeekdaysShort;
/* harmony export (immutable) */ __webpack_exports__["d"] = listWeekdaysMin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_is_number__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locales__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__create_utc__ = __webpack_require__(89);




function get(format, index, field, setter) {
    var locale = Object(__WEBPACK_IMPORTED_MODULE_1__locales__["b" /* getLocale */])(),
        utc = Object(__WEBPACK_IMPORTED_MODULE_2__create_utc__["a" /* createUTC */])().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl(format, index, field) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_is_number__["a" /* default */])(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get(format, index, field, 'month');
    }

    var i,
        out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl(localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_is_number__["a" /* default */])(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_is_number__["a" /* default */])(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = Object(__WEBPACK_IMPORTED_MODULE_1__locales__["b" /* getLocale */])(),
        shift = localeSorted ? locale._week.dow : 0,
        i,
        out = [];

    if (index != null) {
        return get(format, (index + shift) % 7, field, 'day');
    }

    for (i = 0; i < 7; i++) {
        out[i] = get(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths(format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort(format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}


/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__prototype__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locales__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_to_int__ = __webpack_require__(24);




Object(__WEBPACK_IMPORTED_MODULE_1__locales__["c" /* getSetGlobalLocale */])('en', {
    eras: [
        {
            since: '0001-01-01',
            until: +Infinity,
            offset: 1,
            name: 'Anno Domini',
            narrow: 'AD',
            abbr: 'AD',
        },
        {
            since: '0000-12-31',
            until: -Infinity,
            offset: 1,
            name: 'Before Christ',
            narrow: 'BC',
            abbr: 'BC',
        },
    ],
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal: function (number) {
        var b = number % 10,
            output =
                Object(__WEBPACK_IMPORTED_MODULE_2__utils_to_int__["a" /* default */])((number % 100) / 10) === 1
                    ? 'th'
                    : b === 1
                    ? 'st'
                    : b === 2
                    ? 'nd'
                    : b === 3
                    ? 'rd'
                    : 'th';
        return number + output;
    },
});


/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__prototype__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__create__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constructor__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__humanize__ = __webpack_require__(244);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__create__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__constructor__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__humanize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__humanize__["b"]; });
// Side effect imports









/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constructor__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__abs__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__add_subtract__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__as__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bubble__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__clone__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__get__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__humanize__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__iso_string__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__moment_locale__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__valid__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_deprecate__ = __webpack_require__(65);


var proto = __WEBPACK_IMPORTED_MODULE_0__constructor__["a" /* Duration */].prototype;












proto.isValid = __WEBPACK_IMPORTED_MODULE_10__valid__["c" /* isValid */];
proto.abs = __WEBPACK_IMPORTED_MODULE_1__abs__["a" /* abs */];
proto.add = __WEBPACK_IMPORTED_MODULE_2__add_subtract__["a" /* add */];
proto.subtract = __WEBPACK_IMPORTED_MODULE_2__add_subtract__["b" /* subtract */];
proto.as = __WEBPACK_IMPORTED_MODULE_3__as__["a" /* as */];
proto.asMilliseconds = __WEBPACK_IMPORTED_MODULE_3__as__["d" /* asMilliseconds */];
proto.asSeconds = __WEBPACK_IMPORTED_MODULE_3__as__["h" /* asSeconds */];
proto.asMinutes = __WEBPACK_IMPORTED_MODULE_3__as__["e" /* asMinutes */];
proto.asHours = __WEBPACK_IMPORTED_MODULE_3__as__["c" /* asHours */];
proto.asDays = __WEBPACK_IMPORTED_MODULE_3__as__["b" /* asDays */];
proto.asWeeks = __WEBPACK_IMPORTED_MODULE_3__as__["i" /* asWeeks */];
proto.asMonths = __WEBPACK_IMPORTED_MODULE_3__as__["f" /* asMonths */];
proto.asQuarters = __WEBPACK_IMPORTED_MODULE_3__as__["g" /* asQuarters */];
proto.asYears = __WEBPACK_IMPORTED_MODULE_3__as__["j" /* asYears */];
proto.valueOf = __WEBPACK_IMPORTED_MODULE_3__as__["k" /* valueOf */];
proto._bubble = __WEBPACK_IMPORTED_MODULE_4__bubble__["a" /* bubble */];
proto.clone = __WEBPACK_IMPORTED_MODULE_5__clone__["a" /* clone */];
proto.get = __WEBPACK_IMPORTED_MODULE_6__get__["b" /* get */];
proto.milliseconds = __WEBPACK_IMPORTED_MODULE_6__get__["d" /* milliseconds */];
proto.seconds = __WEBPACK_IMPORTED_MODULE_6__get__["g" /* seconds */];
proto.minutes = __WEBPACK_IMPORTED_MODULE_6__get__["e" /* minutes */];
proto.hours = __WEBPACK_IMPORTED_MODULE_6__get__["c" /* hours */];
proto.days = __WEBPACK_IMPORTED_MODULE_6__get__["a" /* days */];
proto.weeks = __WEBPACK_IMPORTED_MODULE_6__get__["h" /* weeks */];
proto.months = __WEBPACK_IMPORTED_MODULE_6__get__["f" /* months */];
proto.years = __WEBPACK_IMPORTED_MODULE_6__get__["i" /* years */];
proto.humanize = __WEBPACK_IMPORTED_MODULE_7__humanize__["c" /* humanize */];
proto.toISOString = __WEBPACK_IMPORTED_MODULE_8__iso_string__["a" /* toISOString */];
proto.toString = __WEBPACK_IMPORTED_MODULE_8__iso_string__["a" /* toISOString */];
proto.toJSON = __WEBPACK_IMPORTED_MODULE_8__iso_string__["a" /* toISOString */];
proto.locale = __WEBPACK_IMPORTED_MODULE_9__moment_locale__["b" /* locale */];
proto.localeData = __WEBPACK_IMPORTED_MODULE_9__moment_locale__["c" /* localeData */];

// Deprecations


proto.toIsoString = Object(__WEBPACK_IMPORTED_MODULE_11__utils_deprecate__["a" /* deprecate */])(
    'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
    __WEBPACK_IMPORTED_MODULE_8__iso_string__["a" /* toISOString */]
);
proto.lang = __WEBPACK_IMPORTED_MODULE_9__moment_locale__["a" /* lang */];


/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = abs;
var mathAbs = Math.abs;

function abs() {
    var data = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days = mathAbs(this._days);
    this._months = mathAbs(this._months);

    data.milliseconds = mathAbs(data.milliseconds);
    data.seconds = mathAbs(data.seconds);
    data.minutes = mathAbs(data.minutes);
    data.hours = mathAbs(data.hours);
    data.months = mathAbs(data.months);
    data.years = mathAbs(data.years);

    return this;
}


/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = add;
/* harmony export (immutable) */ __webpack_exports__["b"] = subtract;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create__ = __webpack_require__(61);


function addSubtract(duration, input, value, direction) {
    var other = Object(__WEBPACK_IMPORTED_MODULE_0__create__["a" /* createDuration */])(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days += direction * other._days;
    duration._months += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add(input, value) {
    return addSubtract(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract(input, value) {
    return addSubtract(this, input, value, -1);
}


/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = as;
/* harmony export (immutable) */ __webpack_exports__["k"] = valueOf;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return asMilliseconds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return asSeconds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return asMinutes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return asHours; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return asDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return asWeeks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return asMonths; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return asQuarters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return asYears; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bubble__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__units_aliases__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_to_int__ = __webpack_require__(24);




function as(units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days,
        months,
        milliseconds = this._milliseconds;

    units = Object(__WEBPACK_IMPORTED_MODULE_1__units_aliases__["c" /* normalizeUnits */])(units);

    if (units === 'month' || units === 'quarter' || units === 'year') {
        days = this._days + milliseconds / 864e5;
        months = this._months + Object(__WEBPACK_IMPORTED_MODULE_0__bubble__["b" /* daysToMonths */])(days);
        switch (units) {
            case 'month':
                return months;
            case 'quarter':
                return months / 3;
            case 'year':
                return months / 12;
        }
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(Object(__WEBPACK_IMPORTED_MODULE_0__bubble__["c" /* monthsToDays */])(this._months));
        switch (units) {
            case 'week':
                return days / 7 + milliseconds / 6048e5;
            case 'day':
                return days + milliseconds / 864e5;
            case 'hour':
                return days * 24 + milliseconds / 36e5;
            case 'minute':
                return days * 1440 + milliseconds / 6e4;
            case 'second':
                return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond':
                return Math.floor(days * 864e5) + milliseconds;
            default:
                throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf() {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_to_int__["a" /* default */])(this._months / 12) * 31536e6
    );
}

function makeAs(alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms'),
    asSeconds = makeAs('s'),
    asMinutes = makeAs('m'),
    asHours = makeAs('h'),
    asDays = makeAs('d'),
    asWeeks = makeAs('w'),
    asMonths = makeAs('M'),
    asQuarters = makeAs('Q'),
    asYears = makeAs('y');




/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = absCeil;
function absCeil(number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}


/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create__ = __webpack_require__(61);


function clone() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__create__["a" /* createDuration */])(this);
}


/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = get;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return milliseconds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return seconds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return minutes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hours; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return days; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return months; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return years; });
/* harmony export (immutable) */ __webpack_exports__["h"] = weeks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__units_aliases__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_abs_floor__ = __webpack_require__(97);



function get(units) {
    units = Object(__WEBPACK_IMPORTED_MODULE_0__units_aliases__["c" /* normalizeUnits */])(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds'),
    seconds = makeGetter('seconds'),
    minutes = makeGetter('minutes'),
    hours = makeGetter('hours'),
    days = makeGetter('days'),
    months = makeGetter('months'),
    years = makeGetter('years');



function weeks() {
    return Object(__WEBPACK_IMPORTED_MODULE_1__utils_abs_floor__["a" /* default */])(this.days() / 7);
}


/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toISOString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_abs_floor__ = __webpack_require__(97);

var abs = Math.abs;

function sign(x) {
    return (x > 0) - (x < 0) || +x;
}

function toISOString() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs(this._milliseconds) / 1000,
        days = abs(this._days),
        months = abs(this._months),
        minutes,
        hours,
        years,
        s,
        total = this.asSeconds(),
        totalSign,
        ymSign,
        daysSign,
        hmsSign;

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes = Object(__WEBPACK_IMPORTED_MODULE_0__utils_abs_floor__["a" /* default */])(seconds / 60);
    hours = Object(__WEBPACK_IMPORTED_MODULE_0__utils_abs_floor__["a" /* default */])(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years = Object(__WEBPACK_IMPORTED_MODULE_0__utils_abs_floor__["a" /* default */])(months / 12);
    months %= 12;

    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

    totalSign = total < 0 ? '-' : '';
    ymSign = sign(this._months) !== sign(total) ? '-' : '';
    daysSign = sign(this._days) !== sign(total) ? '-' : '';
    hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return (
        totalSign +
        'P' +
        (years ? ymSign + years + 'Y' : '') +
        (months ? ymSign + months + 'M' : '') +
        (days ? daysSign + days + 'D' : '') +
        (hours || minutes || seconds ? 'T' : '') +
        (hours ? hmsSign + hours + 'H' : '') +
        (minutes ? hmsSign + minutes + 'M' : '') +
        (seconds ? hmsSign + s + 'S' : '')
    );
}


/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__day_of_month__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__day_of_week__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__day_of_year__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hour__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__millisecond__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__minute__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__month__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__offset__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__quarter__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__second__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__timestamp__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__timezone__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__week_year__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__week__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__year__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__aliases__ = __webpack_require__(21);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_15__aliases__["c"]; });
// Side effect imports





















/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_format__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse_regex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parse_token__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_to_int__ = __webpack_require__(24);





// FORMATTING

Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('X', 0, 0, 'unix');
Object(__WEBPACK_IMPORTED_MODULE_0__format_format__["a" /* addFormatToken */])('x', 0, 0, 'valueOf');

// PARSING

Object(__WEBPACK_IMPORTED_MODULE_1__parse_regex__["a" /* addRegexToken */])('x', __WEBPACK_IMPORTED_MODULE_1__parse_regex__["p" /* matchSigned */]);
Object(__WEBPACK_IMPORTED_MODULE_1__parse_regex__["a" /* addRegexToken */])('X', __WEBPACK_IMPORTED_MODULE_1__parse_regex__["q" /* matchTimestamp */]);
Object(__WEBPACK_IMPORTED_MODULE_2__parse_token__["a" /* addParseToken */])('X', function (input, array, config) {
    config._d = new Date(parseFloat(input) * 1000);
});
Object(__WEBPACK_IMPORTED_MODULE_2__parse_token__["a" /* addParseToken */])('x', function (input, array, config) {
    config._d = new Date(Object(__WEBPACK_IMPORTED_MODULE_3__utils_to_int__["a" /* default */])(input));
});


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images.svg?ac3173dd86167439b1e6840bfcaeb3b4";

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel login-page-bg-old",on:{"click":_vm.appElementClick}},[_c('div',{class:['body-panel-control', { 'opened': _vm.menuMobShow }]},[_c('div',{staticClass:"header-inner flex"},[(_vm.isMobile)?_c('div',{staticClass:"header-menu-mobile",on:{"click":_vm.toggleMenuMob}},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/images.svg#Toggler"}})])]):_vm._e(),_vm._v(" "),(_vm.isMobile && _vm.info.User != null && _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.bonusSpend))?_c('div',{staticStyle:{"padding":"16px 0"}},[_c('p',{staticClass:"user-info-ball"},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/images.svg?#Balans"}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getUserBonusToDisplay('active', true)))]),_vm._v(" / "),_c('span',[_vm._v(_vm._s(_vm.getUserBonusToDisplay('potential', true)))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"header-logo"},[(_vm.selectedProject != null && _vm.selectedProject.Image != null)?_c('img',{staticClass:"header-logo-img",attrs:{"src":_vm.selectedProject.Image}}):_vm._e()]),_vm._v(" "),(!_vm.isMobile)?_c('div',{staticStyle:{"width":"100%"}}):_vm._e(),_vm._v(" "),(!_vm.isMobile && _vm.info.User != null)?_c('div',{staticClass:"header-menu-right flex"},[_c('notification',{attrs:{"menuColor":_vm.menuColor,"info":_vm.info},model:{value:(_vm.info.NotificationsLength),callback:function ($$v) {_vm.$set(_vm.info, "NotificationsLength", $$v)},expression:"info.NotificationsLength"}}),_vm._v(" "),_c('div',{staticClass:"user-logout",on:{"click":function($event){$event.stopPropagation();return _vm.logOut()}}},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/images.svg?#Logout"}})]),_vm._v(" "),_c('span',[_vm._v("Выйти")])])],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"body-panel-content"},[_c('div',{staticClass:"flex page"},[_c('div',{staticClass:"page-menu",class:{ 'opened': _vm.menuMobShow },on:{"click":_vm.toggleMenuMob}},[(_vm.info.User != null )?_c('div',{staticClass:"user-info"},[_c('div',{staticClass:"user-icon"},[(_vm.info.User.Image == null)?_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg?#User2"}})]):_vm._e(),_vm._v(" "),(_vm.info.User.Image != null)?_c('img',{attrs:{"src":_vm.info.User.Image}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"user-data"},[(!_vm.info.User.LevelInProject)?_c('p',{staticClass:"user-info-name margin-top-10"},[_vm._v(_vm._s(_vm.getUserNameToDisplay()))]):_vm._e(),_vm._v(" "),(_vm.info.User.LevelInProject)?_c('div',{staticClass:"user-info-ball margin-top-10 levelinproject"},[_c('span',[_vm._v(_vm._s(_vm.getLevelName(_vm.info.User.LevelInProject)))]),_vm._v(" "),_c('div',{staticClass:"levelinproject-icon-size",class:_vm.getLevelIconClass(_vm.info.User.LevelInProject)})]):_vm._e(),_vm._v(" "),(_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.bonusSpend))?_c('p',{staticClass:"user-info-ball margin-top-5"},[_c('span',[_vm._v(_vm._s(_vm.getUserBonusToDisplay('potential')))])]):_vm._e(),_vm._v(" "),(_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.bonusSpend))?_c('p',{staticClass:"user-info-ball margin-top-5"},[_c('span',[_vm._v(_vm._s(_vm.getUserBonusToDisplay('active')))])]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"page-menu-items"},[(_vm.info && _vm.info.Pages)?_c('side-menu',{ref:"menu",attrs:{"cartItemsCount":_vm.cartItemsCount,"collapsed":_vm.menuCollapsed,"info":_vm.info,"menuColor":_vm.menuColor}}):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('div',{staticClass:"user-exit"},[_c('div',{staticClass:"user-logout",on:{"click":function($event){$event.stopPropagation();return _vm.logOut()}}},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/images.svg?#Logout"}})])])]):_vm._e(),_vm._v(" "),(_vm.info.User != null && _vm.info.User.MainRole === 'administrators')?_c('div',{staticClass:"menu-item"},[_c('a',{on:{"click":function($event){$event.stopPropagation();return _vm.onShowModal('ppChangeUser')}}},[_c('svg',{staticClass:"svg-icon",style:({fill: _vm.menuColor}),attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/images.svg#MenuProfile"}})]),_vm._v(" "),_c('span',[_vm._v("Сменить пользователя")])])]):_vm._e(),_vm._v(" "),(_vm.loggedByUser === true)?_c('div',{staticClass:"menu-item comback"},[_c('a',{on:{"click":function($event){$event.stopPropagation();return _vm.onReturnFromUser()}}},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/images.svg#Logout"}})]),_vm._v(" "),_c('span',[_vm._v("Вернуться")])])]):_vm._e()],1),_vm._v(" "),(_vm.info.FeedbackSettings != null && (_vm.info.FeedbackSettings.PhoneSTP || _vm.info.FeedbackSettings.Email))?_c('div',{staticClass:"stp-info"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Техническая поддержка")]),_vm._v(" "),(_vm.info.FeedbackSettings.PhoneSTP)?_c('div',[_c('svg',{staticClass:"svg-icon",style:({fill: _vm.menuColor }),attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Phone2"}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.info.FeedbackSettings.PhoneSTP))])]):_vm._e(),_vm._v(" "),(_vm.info.FeedbackSettings.Email)?_c('div',[_c('svg',{staticClass:"svg-icon",style:({fill: _vm.menuColor }),attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/images.svg?v3#MenuMail"}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.info.FeedbackSettings.Email))])]):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"page-content"},[(_vm.info.User != null && _vm.info.User.IsDisabled)?_c('div',{staticClass:"error",staticStyle:{"color":"#36586f","font-weight":"600","background-color":"#FFF","border-bottom":"1px solid #eaebf0"}},[_vm._v("\n                    Ваш аккаунт отключен. Обменяйте баллы на призы\n                    "),(_vm.info.User.BlockedDateTime)?[_vm._v("\n                        до "+_vm._s(_vm.formatDate(_vm.info.User.BlockedDateTime, 'DD.MM.YYYY HH:mm'))+"\n                    ")]:_vm._e(),_vm._v(".\n                ")],2):_vm._e(),_vm._v(" "),(_vm.info.User != null)?_c('router-view',{attrs:{"info":_vm.info},on:{"need-refresh-menu":function($event){return _vm.refreshMenuData()},"need-refresh-cart":function($event){return _vm.refreshCart()},"user-updated":_vm.userUpdated}}):_vm._e()],1)])]),_vm._v(" "),_c('popup-window',{ref:"ppAgreements",attrs:{"title":'Для работы в системе, пожалуйста, ознакомьтесь с политикой конфиденциальности и правилами программы',"width":"80%","modal":true}},[_c('div',[_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.NotificationsEnabled),expression:"NotificationsEnabled"}],staticClass:"input-checkbox",attrs:{"id":"NotificationsEnabled1","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.NotificationsEnabled)?_vm._i(_vm.NotificationsEnabled,"true")>-1:(_vm.NotificationsEnabled)},on:{"change":function($event){var $$a=_vm.NotificationsEnabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.NotificationsEnabled=$$a.concat([$$v]))}else{$$i>-1&&(_vm.NotificationsEnabled=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.NotificationsEnabled=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"NotificationsEnabled1"}},[_vm._v("Я хочу получать новости и оповещения по email и sms")])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.TermsConfirmed),expression:"TermsConfirmed"}],staticClass:"input-checkbox",attrs:{"id":"TermsConfirmed1","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.TermsConfirmed)?_vm._i(_vm.TermsConfirmed,"true")>-1:(_vm.TermsConfirmed)},on:{"change":function($event){var $$a=_vm.TermsConfirmed,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.TermsConfirmed=$$a.concat([$$v]))}else{$$i>-1&&(_vm.TermsConfirmed=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.TermsConfirmed=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"TermsConfirmed1"}},[_vm._v("\n                    Я согласен с "),(_vm.info.PolicyFile)?_c('a',{staticStyle:{"color":"#ff0000"},attrs:{"href":"javascript:;"},on:{"click":function($event){$event.stopPropagation();return _vm.onShowPolicyClick.apply(null, arguments)}}},[_vm._v("политикой")]):_vm._e(),(!_vm.info.PolicyFile)?_c('span',[_vm._v("политикой")]):_vm._e(),_vm._v("\n                    конфиденциальности сервиса и "),(_vm.info.RulesFile)?_c('a',{staticStyle:{"color":"#ff0000"},attrs:{"href":"javascript:;"},on:{"click":function($event){$event.stopPropagation();return _vm.onShowRulesClick.apply(null, arguments)}}},[_vm._v("правилами программы")]):_vm._e(),_vm._v(" "),(!_vm.info.RulesFile)?_c('span',[_vm._v("правилами программы")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.PersonalDataEditingAccept),expression:"PersonalDataEditingAccept"}],staticClass:"input-checkbox",attrs:{"id":"PersonalDataEditingAccept1","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.PersonalDataEditingAccept)?_vm._i(_vm.PersonalDataEditingAccept,"true")>-1:(_vm.PersonalDataEditingAccept)},on:{"change":function($event){var $$a=_vm.PersonalDataEditingAccept,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.PersonalDataEditingAccept=$$a.concat([$$v]))}else{$$i>-1&&(_vm.PersonalDataEditingAccept=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.PersonalDataEditingAccept=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"PersonalDataEditingAccept1"}},[_vm._v("Я согласен на обработку персональных данных в соответствии с Федеральным законом N152-ФЗ")])]),_vm._v(" "),_c('div',{staticClass:"btns flex"},[(_vm.TermsConfirmed && _vm.PersonalDataEditingAccept)?_c('button',{staticClass:"btn btn-primary margin-top-15",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveAgreements()}}},[_vm._v("\n                    Сохранить\n                ")]):_vm._e()])])]),_vm._v(" "),_c('popup-window',{key:"ppEmailConfirmed",ref:"ppEmailConfirmed",attrs:{"name":"ppEmailConfirmed","title":'Для продолжения работы требуется подтвердить email',"width":"300px","modal":true}},[_c('div',{staticClass:"row"},[(_vm.confirmation.state === 'init')?_c('div',{staticClass:"form-group"},[_c('span',[_vm._v("Email для подтверждения - "),_c('strong',[_vm._v(_vm._s(_vm.confirmation.email))])]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-10"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.confirmation.isSending},on:{"click":function($event){$event.stopPropagation();return _vm.requestConfirmationCode.apply(null, arguments)}}},[_vm._v("Отправить код")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":_vm.onConfirmationShowNewEmail}},[_vm._v("Изменить email")])])]):_vm._e(),_vm._v(" "),(_vm.confirmation.state === 'code')?_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                        Введите код\n                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmation.code.value),expression:"confirmation.code.value"}],class:['input-text'],attrs:{"type":"text","name":"code","disabled":_vm.confirmation.code.disabled},domProps:{"value":(_vm.confirmation.code.value)},on:{"keyup":_vm.onConfirmationCodeKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.confirmation.code, "value", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.confirmation.errors.code))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.confirmation.showInfoText = true}}},[_vm._v("Код не пришёл")]),_vm._v(" "),(_vm.confirmation.showInfoText === true)?_c('div',{staticClass:"margin-top-10"},[_vm._v("\n                    Вы проверили папку СПАМ?\n                    "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":_vm.onConfirmationShowNewEmail}},[_vm._v("Да, письма нет")])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.confirmation.state === 'confirmed')?_c('div',{staticClass:"flex"},[_c('div',{staticClass:"test-result-body-icon"},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#ResultOk"}})])]),_vm._v(" "),_c('div',{staticClass:"test-result-body-text"},[_c('p',{staticClass:"test-hello-text"},[_vm._v("Код подтверждён")])])]):_vm._e(),_vm._v(" "),(_vm.confirmation.state === 'newemail')?_c('div',{staticClass:"form-group"},[_c('span',[_vm._v("Email для подтверждения - "),_c('strong',[_vm._v(_vm._s(_vm.confirmation.email))])]),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-10"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                        Введите новый email-адрес\n                    ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"},{name:"model",rawName:"v-model",value:(_vm.confirmation.newemail),expression:"confirmation.newemail"}],class:['input-text', {'input-error': _vm.errors.has('newemail', 'newemail')}],attrs:{"type":"text","name":"newemail","data-vv-scope":"newemail"},domProps:{"value":(_vm.confirmation.newemail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.confirmation, "newemail", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.confirmation.errors.newemail))])]),_vm._v(" "),_c('div',{staticClass:"btns flex"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-vv-scope":"newemail"},on:{"click":function($event){$event.stopPropagation();return _vm.onConfirmationNewEmailSave.apply(null, arguments)}}},[_vm._v("Сохранить")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.confirmation.state = 'init'}}},[_vm._v("Назад")])])]):_vm._e()])]),_vm._v(" "),(_vm.firstLaunchItemsShow)?_c('first-launch',{attrs:{"firstLaunchItems":_vm.firstLaunchItems},on:{"actions-complete":_vm.onActionsComplete}}):_vm._e(),_vm._v(" "),_c('popup-window',{ref:"ppPolicy",attrs:{"title":'Политика конфиденциальности сервиса',"width":800,"height":'90%'}},[_c('p',{staticClass:"p-header-1"}),_vm._v(" "),(_vm.info.PolicyFile)?[(_vm.fileExtensionIsHtml(_vm.info.PolicyFile))?_c('iframe',{attrs:{"src":_vm.info.PolicyFile}}):_c('pdf-viewer',{ref:"pdfViewPolicy"})]:_vm._e()],2),_vm._v(" "),_c('popup-window',{ref:"ppRules",attrs:{"title":'Правила программы',"width":800,"height":'90%'}},[_c('p',{staticClass:"p-header-1"}),_vm._v(" "),(_vm.info.RulesFile)?[(_vm.fileExtensionIsHtml(_vm.info.RulesFile))?_c('iframe',{attrs:{"src":"info.RulesFile"}}):_c('pdf-viewer',{ref:"pdfViewRules"})]:_vm._e()],2),_vm._v(" "),_c('popup-window',{ref:"ppChangeUser",attrs:{"title":'Смена пользователя'}},[_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userToChange.id),expression:"userToChange.id"}],staticClass:"input-text",class:['input-text'],attrs:{"name":"UserId","placeholder":"Введите Id пользователя","type":"text"},domProps:{"value":(_vm.userToChange.id)},on:{"keyup":_vm.onUserIdChange,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userToChange, "id", $event.target.value)}}}),_vm._v(" "),(_vm.userToChange.found === false)?_c('div',{staticClass:"margin-top-5 error"},[_vm._v("Пользователь не найден")]):_vm._e(),_vm._v(" "),(_vm.userToChange.found === true)?_c('div',{staticClass:"margin-top-10"},[_c('strong',[_vm._v(_vm._s(_vm.userToChange.fio))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('div',{staticClass:"form-btns"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":!_vm.userToChange.id || _vm.userToChange.found !== true},on:{"click":function($event){return _vm.onChangeUser()}}},[_vm._v("\n                    Сменить\n                ")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthLayout_vue__ = __webpack_require__(245);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3c50938_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthLayout_vue__ = __webpack_require__(632);
function injectStyle (ssrContext) {
  __webpack_require__(630)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3c50938_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(631);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("34c2c5de", content, true, {});

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.info != null)?_c('router-view',{attrs:{"info":_vm.info}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__ = __webpack_require__(246);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7df85ef5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__ = __webpack_require__(634);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7df85ef5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel news"},[(_vm.info.User && (_vm.info.User.MainRole === 'administrators' || _vm.info.ProjectsLength > 1 || _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.newsCreate)))?_c('div',{staticClass:"body-panel-control separator"},[((_vm.info.User.MainRole === 'administrators' || _vm.info.ProjectsLength > 1))?_c('div',{staticClass:"control-block-left"},[_c('project-select',{attrs:{"user":_vm.info.User},on:{"onChange":_vm.onProjectChange}})],1):_vm._e(),_vm._v(" "),(_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.newsCreate) || _vm.info.User.MainRole === 'administrators')?_c('div',{staticClass:"control-block-right"},[_c('button',{staticClass:"btn btn-news",on:{"click":function($event){return _vm.onAddNews()}}},[_vm._v("Добавить новость")])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page panel-block-news no-padding-right"},[_c('div',{staticClass:"body-panel-content-center"},_vm._l((_vm.news),function(item,i){return _c('div',{class:['panel-block', 'panel-block-new', { 'disabled': item.DateExpired }, {'not-read': !item.ReadByUser} ],on:{"click":function($event){return _vm.goToNews(item.Id)}}},[_c('div',{staticClass:"panel-block-img-base"},[_c('div',{staticClass:"panel-block-img"},[_c('img',{style:(_vm.getImageStyleFormatted(item.ImageStyle)),attrs:{"src":item.Image,"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"panel-block-info"},[_c('p',{staticClass:"panel-block-header margin-bottom-10"},[_vm._v(_vm._s(item.Title))]),_vm._v(" "),_c('p',{staticClass:"panel-body-desc",domProps:{"innerHTML":_vm._s(item.PreviewFormatted)}})]),_vm._v(" "),_c('div',{staticClass:"panel-body-actions"},[_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.goToNews(item.Id)}}},[_vm._v("Читать")]),_vm._v(" "),(item.Id > 0 && _vm.info.User && (_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.newsCreate) || _vm.info.User.MainRole === 'administrators'))?_c('button',{staticClass:"btn margin-left-10 btn-img",on:{"click":function($event){$event.stopPropagation();return _vm.goToEditNews(item.Id)}}},[_c('img',{attrs:{"src":__webpack_require__(31),"alt":""}})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"panel-body-actions-date"},[_vm._v(_vm._s(_vm._f("date-short")(item.StartDate)))])]),_vm._v(" "),(item.LikesEnabled || item.CommentsEnabled || item.DisplayViews)?_c('div',{staticClass:"panel-body-stats"},[(item.LikesEnabled)?_c('p',{class:['news-actions like', {'bold': item.MyVote === true}],attrs:{"title":"Нравится"},on:{"click":function($event){$event.stopPropagation();return _vm.onMakeMark(item, i)}}},[_c('svg',{staticClass:"svg-icon like-1",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Like"}})]),_vm._v(" "),_c('svg',{staticClass:"svg-icon like-2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Like2"}})]),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"400","line-height":"1.3"}},[_vm._v(_vm._s(item.LikesCount))])]):_vm._e(),_vm._v(" "),(item.CommentsEnabled)?_c('p',{staticClass:"news-actions",attrs:{"title":"Обсудить"},on:{"click":function($event){$event.stopPropagation();return _vm.$router.push('/news/' + item.Id + '?comments')}}},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Comm"}})]),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"400","line-height":"1.3"}},[_vm._v("\n                            "+_vm._s(item.CommentsCount)+"\n                        ")])]):_vm._e()]):_vm._e()])}),0)]),_vm._v(" "),_c('vue-headful',{attrs:{"title":_vm.getPageTitle()}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__ = __webpack_require__(247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46c0b994_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__ = __webpack_require__(639);
function injectStyle (ssrContext) {
  __webpack_require__(636)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-46c0b994"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46c0b994_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(637);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("e13c6d10", content, true, {});

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".table-view thead[data-v-46c0b994]{display:table-header-group}.table-view td[data-v-46c0b994]{text-align:center}.report-photo[data-v-46c0b994]{width:100px;display:inline-block}.report-photo img[data-v-46c0b994]{width:100%}.report-photo+.report-photo[data-v-46c0b994]{margin-left:10px}", ""]);

// exports


/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex mob-inline"},[(_vm.info.User && (_vm.info.User.MainRole === 'administrators' || _vm.info.ProjectsLength > 1))?_c('project-select',{attrs:{"user":_vm.info.User},on:{"onChange":_vm.onProjectChange}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field margin-right-20"},[_c('drop-down',{attrs:{"items":_vm.statuses,"dataField":'Id',"textField":'Name'},on:{"change":function($event){return _vm.onStatusChange($event)}},model:{value:(_vm.statusId),callback:function ($$v) {_vm.statusId=$$v},expression:"statusId"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field margin-right-20"},[_c('drop-down',{attrs:{"items":_vm.dateTypes,"dataField":'Id',"textField":'Name'},on:{"change":function($event){return _vm.onStatusChange($event)}},model:{value:(_vm.dateTypeId),callback:function ($$v) {_vm.dateTypeId=$$v},expression:"dateTypeId"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field flex mob-inline"},[_c('input-date',{staticClass:"input-text input-date",attrs:{"name":"dateStart"},on:{"input":_vm.onDateChange},model:{value:(_vm.dateStart),callback:function ($$v) {_vm.dateStart=$$v},expression:"dateStart"}}),_vm._v(" "),_c('span',{staticClass:"margin-left-10 margin-right-10 margin-top-5"},[_vm._v("-")]),_vm._v(" "),_c('input-date',{staticClass:"input-text input-date",attrs:{"name":"dateEnd"},on:{"input":_vm.onDateChange},model:{value:(_vm.dateEnd),callback:function ($$v) {_vm.dateEnd=$$v},expression:"dateEnd"}})],1),_vm._v(" "),(_vm.statusId || _vm.dateStart || _vm.dateEnd || _vm.dateTypeId)?_c('div',{staticClass:"form-field margin-left-20"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.clearFilterState}},[_vm._v("Сбросить")])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"control-block-right btns flex"},[(_vm.selectedReports.length)?_c('div',{staticStyle:{"margin":"auto 10px"}},[_vm._v("\n                Выбрано "+_vm._s(_vm.selectedReports.length)+" из "+_vm._s(_vm.totalCount)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.info.User && !_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.reportAdd) && _vm.reports.length > 0)?_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.onExport()}}},[_vm._v("\n                Экспорт\n            ")]):_vm._e(),_vm._v(" "),(_vm.info.User && _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.reportAdd))?_c('button',{staticClass:"btn",on:{"click":_vm.onAddReport}},[_vm._v("Добавить отчет")]):_vm._e(),_vm._v(" "),(_vm.selectedReports.length)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.tryApproveReports(2, '')}}},[_vm._v("Принять")]):_vm._e(),_vm._v(" "),(_vm.selectedReports.length)?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){return _vm.sendReportsToEditionModal()}}},[_vm._v("Доработать")]):_vm._e(),_vm._v(" "),(_vm.selectedReports.length)?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){return _vm.rejectReportsModal()}}},[_vm._v("Отклонить")]):_vm._e(),_vm._v(" "),(_vm.selectedReports.length)?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.selectedCancel()}}},[_vm._v("Отмена")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"body-panel-control-separator"},[_c('complex-filter',{ref:"complexFilter",attrs:{"cacheKey":'reportsComplexFilter',"filters":_vm.userFilters,"searchFunction":_vm.searchFunction,"tableName":'[dbo].[AspNetUsers]',"withTableNameInClause":true},on:{"onFilterChange":_vm.onFilterChange}})],1)]),_vm._v(" "),(_vm.reportSettingsLoaded)?_c('div',{staticClass:"body-panel-content body-panel-content-page",on:{"scroll":_vm.onScroll}},[_c('table',{staticClass:"table-view",attrs:{"id":"dataTable"}},[_c('thead',[_c('tr',{staticClass:"heading"},[(_vm.info.User && _vm.info.User.MainRole === 'administrators')?_c('th',{staticClass:"check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectAll),expression:"selectAll"}],staticClass:"input-checkbox",attrs:{"id":"selectAll","name":"selectAll","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectAll)?_vm._i(_vm.selectAll,"true")>-1:(_vm.selectAll)},on:{"change":[function($event){var $$a=_vm.selectAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectAll=$$c}},function($event){return _vm.onSelectAllChange($event)}]}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"selectAll"}})]):_vm._e(),_vm._v(" "),_c('th',[_vm._v("Id")]),_vm._v(" "),_c('th',[_vm._v("Пользователь")]),_vm._v(" "),_c('th',[_vm._v("Статус")]),_vm._v(" "),_c('th',[_vm._v("Дата")]),_vm._v(" "),_c('th',[_vm._v("Дата изменения статуса")]),_vm._v(" "),_vm._l((_vm.headerColumns),function(header){return _c('th',[_vm._v(_vm._s(header.caption))])}),_vm._v(" "),(_vm.reportType === _vm.ReportTypes.QrCode)?_c('th',[_vm._v("\n                        Чек и фото\n                    ")]):_vm._e(),_vm._v(" "),_c('th')],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.reports),function(item,i){return _c('tr',{on:{"click":function($event){return _vm.openReport(item)}}},[(_vm.info.User && _vm.info.User.MainRole === 'administrators')?_c('td',{staticClass:"check",on:{"click":function($event){$event.stopPropagation();}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReports),expression:"selectedReports"}],staticClass:"input-checkbox",attrs:{"id":'select' + i,"type":"checkbox"},domProps:{"value":item,"checked":Array.isArray(_vm.selectedReports)?_vm._i(_vm.selectedReports,item)>-1:(_vm.selectedReports)},on:{"change":[function($event){var $$a=_vm.selectedReports,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedReports=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedReports=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedReports=$$c}},function($event){return _vm.onCheckChange(item)}]}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'select' + i}})]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"id"},[_vm._v(_vm._s(item.Id))]),_vm._v(" "),_c('td',{staticClass:"userimg"},[_c('span',{staticClass:"user-icon-login"},[_vm._v("\n                            "+_vm._s(item.Seller.Fio)+"\n                        ")])]),_vm._v(" "),_c('td',{class:['state', _vm.getStateClass(item)]},[_vm._v(_vm._s(item.StateFormatted))]),_vm._v(" "),_c('td',{staticClass:"date"},[_vm._v("\n                        "+_vm._s(_vm._f("date-short")(item.CreateDate))+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"date"},[_vm._v("\n                        "+_vm._s(_vm._f("date-short")(item.LastModifiedDate))+"\n                    ")]),_vm._v(" "),_vm._l((item.SummaryItems),function(sumItem){return (_vm.reportSettings)?_c('td',{staticClass:"value"},[_vm._v("\n                        "+_vm._s(sumItem.Value)+"\n                    ")]):_vm._e()}),_vm._v(" "),(_vm.reportType === _vm.ReportTypes.QrCode)?_c('td',_vm._l((item.Photos),function(photo){return _c('a',{staticClass:"report-photo",attrs:{"rel":'reportphoto' + i,"href":photo.FileName},on:{"click":function($event){$event.stopPropagation();}}},[_c('img',{attrs:{"src":photo.FileName}})])}),0):_vm._e(),_vm._v(" "),_c('td',{staticClass:"value"},[_c('button',{staticClass:"btn",attrs:{"type":"button","title":"Открыть в новой вкладке"},on:{"click":function($event){$event.stopPropagation();return _vm.openNewTab(item.Id)}}},[_vm._v("Открыть")])])],2)}),0)])]):_vm._e(),_vm._v(" "),_c('popup-window',{ref:"ppEditModal",attrs:{"title":'Отправка на доработку',"modal":true}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                Причина отправки на доработку\n                "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.editionComment),expression:"editionComment"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-memo', { 'input-error': _vm.errors.has('EditionComment', 'edition') }],staticStyle:{"height":"150px"},attrs:{"name":"EditionComment","rows":"10","data-vv-scope":"edition"},domProps:{"value":(_vm.editionComment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editionComment=$event.target.value}}}),_vm._v(" "),(_vm.errors.has('EditionComment', 'edition'))?_c('span',{staticClass:"field-validation-valid"},[_vm._v("Заполните поле")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.sendReportsToEdition()}}},[_vm._v("Принять")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.closeModal('ppEditModal')}}},[_vm._v("Отмена")])])]),_vm._v(" "),_c('popup-window',{ref:"ppRejectModal",attrs:{"title":'Отклонение отчётов'}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                Укажите причину отклонения\n                "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.editionComment),expression:"editionComment"},{name:"validate",rawName:"v-validate",value:({required: true, min: 3}),expression:"{required: true, min: 3}"}],class:['input-memo', { 'input-error': _vm.errors.has('CancellationComment', 'rejection') }],staticStyle:{"height":"150px"},attrs:{"name":"CancellationComment","rows":"10","data-vv-scope":"rejection","data-vv-as":"Причина отклонения"},domProps:{"value":(_vm.editionComment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editionComment=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('CancellationComment', 'rejection')))])]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.rejectReports()}}},[_vm._v("\n                Отклонить\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeModal('ppRejectModal')}}},[_vm._v("Отмена")])])]),_vm._v(" "),_c('popup-window',{ref:"ppApprovedResultModal",attrs:{"title":'Результат изменения'}},[(_vm.approvedResult != null)?_c('div',[_vm._v("\n            Успешно изменено строк: "+_vm._s(_vm.approvedResult.changed.length)+"\n            "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.approvedResult.skipped.length)?[_vm._v("\n                По следующим отчетам статус не был изменен:\n                "),_c('br'),_vm._v(" "),_c('ul',_vm._l((_vm.approvedResult.skipped),function(id){return _c('li',[_vm._v("\n                        "+_vm._s(id)+"\n                    ")])}),0)]:_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeModal('ppApprovedResultModal')}}},[_vm._v("Ok")])])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":_vm.getPageTitle()}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportEdit_vue__ = __webpack_require__(248);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1653b05e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportEdit_vue__ = __webpack_require__(645);
function injectStyle (ssrContext) {
  __webpack_require__(641)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1653b05e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1653b05e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(642);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("3bc1bea1", content, true, {});

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "button.img-download[data-v-1653b05e]{left:50%;position:relative;margin-left:-35px}.fancybox-inner[data-v-1653b05e]{overflow:hidden!important}.fancybox-nav[data-v-1653b05e]{width:40px!important}.thumbnail-img-file[data-v-1653b05e]{width:auto;height:50px;padding:10px 25px 10px 10px}.thumbnail-img-file .thumbnail-img-delete[data-v-1653b05e]{right:0;bottom:16px}", ""]);

// exports


/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{staticClass:"table-view margin-top-20"},[_c('thead',{staticClass:"head-show"},[_c('tr',{staticStyle:{"text-align":"center"}},[_vm._l((_vm.reportColumnsSettings),function(settingsItem){return _c('th',[_c('span',[_vm._v(_vm._s(settingsItem.caption))]),_vm._v(" "),(settingsItem.description)?_c('span',{staticClass:"margin-left-5 table-view-head-desc"},[_c('i',{staticClass:"fa fa-info-circle",attrs:{"title":settingsItem.description}})]):_vm._e()])}),_vm._v(" "),(!_vm.bonusSettings.noReport)?_c('th',[_vm._v("Сумма баллов")]):_vm._e(),_vm._v(" "),(_vm.canBeEdited)?_c('th'):_vm._e()],2)]),_vm._v(" "),_c('tbody',[(_vm.reportItemsInfo != null)?[_c('tr',{staticClass:"total"},[_vm._l((_vm.reportColumnsSettings),function(item,i){return _c('td',[(i === 0)?_c('span',[_vm._v("Итого:")]):_vm._e(),_vm._v("\n                    "+_vm._s(_vm.reportItemsInfo[item.name])+"\n                ")])}),_vm._v(" "),_c('td',[_vm._v("\n                    "+_vm._s(_vm.reportItemsInfo.BonusAmount)+"\n                ")])],2)]:_vm._e(),_vm._v(" "),_vm._l((_vm.reportItems),function(item,i){return _c('tr',[_vm._l((_vm.reportColumnsSettings),function(settingsItem){return _c('td',{class:_vm.getStyle(settingsItem)},[(_vm.canBeEdited)?[_vm._l((item.Fields),function(field,j){return [(settingsItem.name === field.Name && settingsItem.type === 'int')?[_c('touch-spin',{directives:[{name:"validate",rawName:"v-validate",value:({ rules: { required: true} }),expression:"{ rules: { required: true} }"}],attrs:{"name":field.Name + i},on:{"input":_vm.onItemChange},model:{value:(field.Value),callback:function ($$v) {_vm.$set(field, "Value", _vm._n($$v))},expression:"field.Value"}})]:_vm._e(),_vm._v(" "),(settingsItem.name === field.Name && settingsItem.type === 'decimal')?[_c('touch-spin',{directives:[{name:"validate",rawName:"v-validate",value:({ rules: { required: true} }),expression:"{ rules: { required: true} }"}],attrs:{"name":field.Name + i,"decimals":2,"step":0.01},on:{"input":_vm.onItemChange},model:{value:(field.Value),callback:function ($$v) {_vm.$set(field, "Value", _vm._n($$v))},expression:"field.Value"}})]:_vm._e(),_vm._v(" "),(settingsItem.name === field.Name && settingsItem.type === 'string')?[_c('input',{directives:[{name:"model",rawName:"v-model",value:(field.Value),expression:"field.Value"},{name:"validate",rawName:"v-validate",value:({ rules: { required: true} }),expression:"{ rules: { required: true} }"}],class:['input-text', {'input-error': _vm.errors.has(field.Name + i)}],attrs:{"type":"text","name":field.Name + i,"autocomplete":"off"},domProps:{"value":(field.Value)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(field, "Value", $event.target.value)},_vm.onItemChange]}})]:_vm._e(),_vm._v(" "),(settingsItem.name === field.Name && settingsItem.type === 'bool')?[_c('input',{directives:[{name:"model",rawName:"v-model",value:(field.Value),expression:"field.Value"}],staticClass:"input-checkbox",attrs:{"id":'field_' + j + '_row' + i,"value":"true","type":"checkbox","autocomplete":"off"},domProps:{"checked":Array.isArray(field.Value)?_vm._i(field.Value,"true")>-1:(field.Value)},on:{"input":_vm.onItemChange,"change":function($event){var $$a=field.Value,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(field, "Value", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(field, "Value", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(field, "Value", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl no-text",attrs:{"for":'field_' + j + '_row' + i},on:{"click":function($event){$event.stopPropagation();}}})]:_vm._e(),_vm._v(" "),(settingsItem.name === field.Name && settingsItem.type === 'select')?[_c('drop-down',{attrs:{"name":settingsItem.name + '' + i,"items":_vm.getSelectItems(item, settingsItem),"dataField":'Id',"textField":'Name',"withSelectItem":'true'},on:{"input":_vm.onItemChange},model:{value:(field.Value),callback:function ($$v) {_vm.$set(field, "Value", $$v)},expression:"field.Value"}})]:_vm._e(),_vm._v(" "),(settingsItem.name === field.Name && settingsItem.type === 'sku')?[_c('search-filter',{directives:[{name:"validate",rawName:"v-validate",value:({ rules: { required: true} }),expression:"{ rules: { required: true} }"}],attrs:{"name":field.Name + i,"hasErrors":_vm.errors.has(field.Name + i),"extra":i,"placeholder":(settingsItem.placeholder || 'Выберите sku'),"searchFunction":_vm.searchSkuFunction,"selectedItem":_vm.getSkuSelectedItem(field),"searchOnSelect":true,"scrollable":true,"fieldName":field.Name},on:{"onFilterChange":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
return _vm.onChangeSkuSearch.apply(void 0, argsArray.concat( [field.Name] ))}}})]:_vm._e(),_vm._v(" "),(settingsItem.name === field.Name && settingsItem.type === 'date')?[_c('input-date',{directives:[{name:"validate",rawName:"v-validate",value:({ rules: { required: true} }),expression:"{ rules: { required: true} }"}],class:['input-date', {'input-error': _vm.errors.has(field.Name + i)}],attrs:{"name":field.Name + i,"withMask":true,"todayHighlight":_vm.bonusSettings.noReport},on:{"input":_vm.onItemChange},model:{value:(field.Value),callback:function ($$v) {_vm.$set(field, "Value", $$v)},expression:"field.Value"}})]:_vm._e()]})]:_vm._e(),_vm._v(" "),(!_vm.canBeEdited && !_vm.isNewAnswer)?_vm._l((item.Fields),function(field){return (settingsItem.name === field.Name)?_c('span',{key:("readonly-" + (field.Name) + "-" + (item.Id || i))},[_vm._v("\n                        "+_vm._s(field.Title ? field.Title: field.Value)+"\n                    ")]):_vm._e()}):_vm._e()],2)}),_vm._v(" "),(!_vm.bonusSettings.noReport)?_c('td',{staticClass:"value"},[(_vm.bonusSettings.bonusStrategy.type !== 'fact')?[_vm._v("\n                    "+_vm._s(_vm.getBonusAmount(item))+"\n                ")]:_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.canBeEdited)?_c('td',{staticClass:"obtn-short"},[_c('button',{staticClass:"btn btn-default btn-img",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeItem(item, i)}}},[_c('img',{attrs:{"src":__webpack_require__(17),"alt":""}})])]):_vm._e()],2)})],2)]),_vm._v(" "),(_vm.canBeEdited && (_vm.maxItems === 0 || (_vm.reportItems.length < _vm.maxItems)))?_c('button',{staticClass:"btn btn-primary margin-top-10",attrs:{"type":"button"},on:{"click":function($event){return _vm.addItem()}}},[_vm._v("\n        Добавить запись\n    ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon-minus-2.png?5b77d5c30b5eee03a02e3a29ad2eeff1";

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[(_vm.report != null)?[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"btn-back margin-right-10"},[_c('a',{staticClass:"router-link-active",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.back.apply(null, arguments)}}},[_vm._v("Назад")])]),_vm._v(" "),(_vm.report.new)?_c('p',{staticClass:"caption-help margin-right-10"},[_vm._v("Новый отчёт")]):_vm._e(),_vm._v(" "),(!_vm.report.new)?_c('p',{staticClass:"caption-help margin-right-10"},[_vm._v("Статус: "+_vm._s(_vm.report.StateFormatted))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[_c('div',{staticClass:"btns flex",attrs:{"data-toggle":"buttons"}},[(_vm.info.User && _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.reportAdd) && _vm.report.canBeEdited)?[_c('span',{staticClass:"caption-help margin-right-10"},[_vm._v("\n                                "+_vm._s(_vm.getEditProcessState())+"\n                            ")]),_vm._v(" "),((_vm.report.new || _vm.report.State === 1 || _vm.report.State === 3 || _vm.report.State === 4) && _vm.report.ReportItems.length && _vm.photoFieldsValid)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveReport()}}},[_vm._v("\n                                Сохранить\n                            ")]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.info.User && (_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.reportCheck) || _vm.info.User.MainRole === 'administrators')
                                    && (_vm.report.State === 1 || _vm.report.State === 3 || _vm.report.State === 5))?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.tryApproveReport()}}},[_vm._v("\n                            Принять\n                        ")]):_vm._e(),_vm._v(" "),(_vm.info.User && (_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.reportCheck) || _vm.info.User.MainRole === 'administrators')
                                    && (_vm.report.State === 1 || _vm.report.State === 2 || _vm.report.State === 3))?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.sendReportToEditionModal()}}},[_vm._v("\n                            Доработать\n                        ")]):_vm._e(),_vm._v(" "),(_vm.info.User && (_vm.info.User.MainRole === 'administrators' || _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.reportCheck)) && (_vm.report.State !== 5))?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.rejectReportModal()}}},[_vm._v("\n                            Отклонить\n                        ")]):_vm._e(),_vm._v(" "),_c('input',{ref:"dropFiles",staticClass:"file-upload-zone-btn",attrs:{"type":"file","id":"dropFiles","name":"dropFiles","accept":".xlsx"},on:{"change":function($event){return _vm.onFileChange()}}}),_vm._v(" "),(_vm.ReportExcelEnabled)?_c('button',{staticClass:"btn",attrs:{"type":"button","onclick":"document.getElementById('dropFiles').click()"}},[_vm._v("\n                            Импорт\n                        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.cancel()}}},[_vm._v("Отмена")]),_vm._v(" "),(!_vm.report.new && _vm.report.State !== 2 && _vm.info.User && _vm.info.User.MainRole === 'administrators')?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteReport()}}},[_vm._v("Удалить")]):_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page",on:{"scroll":_vm.onReportItemsScroll}},[_c('div',{staticClass:"report-block-items"},[_c('div',{staticStyle:{"padding":"30px","background":"#fff"}},[(_vm.report.new && _vm.report.TradePoint == null)?_c('div',{staticClass:"form-field"},[_c('div',[_c('div',{staticClass:"body-panel-control-separator flex"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ttSearch),expression:"ttSearch"}],staticClass:"input-text",attrs:{"type":"text","value":"1","placeholder":"Введите название или адрес торговой точки, после чего выберите из списка"},domProps:{"value":(_vm.ttSearch)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.ttSearch=$event.target.value},_vm.onChangeTradeSearch]}}),_vm._v(" "),_c('div',{staticClass:"switch margin-left-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ttAllowed),expression:"ttAllowed"}],attrs:{"type":"checkbox","id":"s5","checked":"checked"},domProps:{"checked":Array.isArray(_vm.ttAllowed)?_vm._i(_vm.ttAllowed,null)>-1:(_vm.ttAllowed)},on:{"change":[function($event){var $$a=_vm.ttAllowed,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ttAllowed=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ttAllowed=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.ttAllowed=$$c}},_vm.onChangeTradeAllowed]}}),_vm._v(" "),_c('label',{staticClass:"slider-v3",attrs:{"for":"s5"}})])])]),_vm._v(" "),_c('div',[_c('br'),_vm._v(" "),_c('table',{staticClass:"table-view",attrs:{"id":"dataTable"}},[_c('tbody',_vm._l((_vm.ttData),function(item){return _c('tr',[_c('td',[_vm._v(_vm._s(item.FullName))]),_vm._v(" "),_c('td',{staticClass:"phone"},[(!item.Error)?_c('button',{staticClass:"btn btn-primary",staticStyle:{"display":"unset"},attrs:{"type":"button"},on:{"click":function($event){return _vm.onSelectTradePoint(item)}}},[_vm._v("Добавить")]):_vm._e(),_vm._v(" "),(item.Error)?_c('span',[_vm._v("\n                                                        "+_vm._s(item.Error)+"\n                                                    ")]):_vm._e()])])}),0)]),_vm._v(" "),(_vm.ttSearched && !_vm.ttData.length && !_vm.ttIsLoading)?_c('div',[_c('span',[_vm._v("Ничего не найдено...")])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.report.TradePoint && !_vm.report.TradePoint.Error)?_c('div',[(_vm.report.Seller)?_c('p',[_vm._v("ФИО: "),_c('strong',[_vm._v(_vm._s(_vm.report.Seller.Fio))])]):_vm._e(),_vm._v(" "),(_vm.report.Seller && _vm.report.Seller.DynamicRole)?_c('p',[_vm._v("Роль: "),_c('strong',[_vm._v(_vm._s(_vm.report.Seller.DynamicRole.Name))])]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("Торговая точка: "),_c('strong',[_vm._v(_vm._s(_vm.formatTradePointName(_vm.report.TradePoint)))])])]):_vm._e(),_vm._v(" "),(_vm.report.TradePoint && _vm.report.TradePoint.Error)?_c('div',{staticClass:"error"},[_vm._v("\n                                "+_vm._s(_vm.report.TradePoint.Error)+"\n                            ")]):_vm._e(),_vm._v(" "),(_vm.report.EditionComment && _vm.report.State === 4)?_c('div',{staticClass:"error"},[_vm._v("\n                                "+_vm._s(_vm.report.EditionComment)+"\n                            ")]):(_vm.report.EditionComment)?_c('div',{staticClass:"error"},[_vm._v("\n                                Ранее отчет был отправлен на доработку с комментарием: "+_vm._s(_vm.report.EditionComment)+"\n                            ")]):_vm._e(),_vm._v(" "),(_vm.report.CancellationComment && _vm.report.State === 5)?_c('div',{staticClass:"error"},[_vm._v("\n                                "+_vm._s(_vm.report.CancellationComment)+"\n                            ")]):_vm._e(),_vm._v(" "),(_vm.tradePointSelected && _vm.reportDateSettings && _vm.reportDateSettings.ReportDateRequired)?_c('div',[_vm._v("\n                                "+_vm._s(_vm.reportDateSettings.ReportDateCaption)+":\n                                "),(_vm.report.canBeEdited)?_c('input-date',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-date', {'input-error': _vm.errors.has('ReportDateFormatted')}],staticStyle:{"margin-top":"10px"},attrs:{"name":"ReportDateFormatted"},on:{"input":function($event){return _vm.onChangeDate(_vm.report, 'ReportDateFormatted', 'ReportDate')}},model:{value:(_vm.report.ReportDateFormatted),callback:function ($$v) {_vm.$set(_vm.report, "ReportDateFormatted", $$v)},expression:"report.ReportDateFormatted"}}):_vm._e(),_vm._v(" "),(!_vm.report.canBeEdited)?_c('span',[_vm._v("\n                                    "+_vm._s(_vm.report.ReportDateFormatted)+"\n                                ")]):_vm._e()],1):_vm._e()]),_vm._v(" "),(_vm.tradePointSelected && _vm.reportSettings != null)?_c('report-items-table',{ref:"reportItems",attrs:{"bonusSettings":_vm.bonusSettings,"tradePoint":_vm.report.TradePoint,"reportSettings":_vm.reportSettings,"equipmentTypes":_vm.equipmentTypes,"sku":_vm.sku,"dateToBonus":_vm.dateToBonus,"canBeEdited":_vm.report.canBeEdited,"maxItems":_vm.maxItems},model:{value:(_vm.report.ReportItems),callback:function ($$v) {_vm.$set(_vm.report, "ReportItems", $$v)},expression:"report.ReportItems"}}):_vm._e()],1),_vm._v(" "),(_vm.tradePointSelected)?_c('div',{staticClass:"report-block-photo"},_vm._l((_vm.reportFields),function(field){return _c('div',{staticClass:"row report-photo-field"},[_c('h2',{class:{'has-error': field.Required && !_vm.report.Photos.filter(function (x) { return x.FieldId === field.Id; }).length}},[_vm._v(_vm._s(field.Name))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"thumbnail-img-block"},_vm._l((_vm.report.Photos.filter(function (x) { return x.FieldId === field.Id; })),function(img,i){return _c('div',{class:['thumbnail-img', {'thumbnail-img-file' : img.TypeId == _vm.ReportPhotoTypes.File}]},[(img.TypeId == _vm.ReportPhotoTypes.File)?[(img.FileData)?_c('span',[_vm._v(_vm._s(img.FileName))]):_vm._e(),_vm._v(" "),(!img.FileData && img.FileName)?_c('a',{attrs:{"target":"_blank","href":img.FileName}},[_vm._v("\n                                                "+_vm._s(img.FileName.replace('https://storage.yandexcloud.net/foxinbox/uploads/reports/', ''))+"\n                                              ")]):_vm._e(),_vm._v(" "),(_vm.report.canBeEdited)?_c('div',{staticClass:"thumbnail-img-delete",on:{"click":function($event){return _vm.removeFile(i)}}}):_vm._e()]:[(img.FileData)?_c('a',{attrs:{"target":"_blank"}},[_c('img',{attrs:{"src":img.FileData}})]):_vm._e(),_vm._v(" "),(!img.FileData && img.FileName)?_c('a',{staticClass:"lightzoom",attrs:{"target":"_blank","href":img.FileName,"rel":"group"}},[_c('img',{attrs:{"src":img.FileName}})]):_vm._e(),_vm._v(" "),(_vm.report.canBeEdited)?_c('div',{staticClass:"thumbnail-img-delete",on:{"click":function($event){return _vm.removeImage(i, field.Id)}}}):_vm._e(),_vm._v(" "),(_vm.report.canBeEdited)?_c('div',{staticClass:"thumbnail-img-replace",staticStyle:{"display":"none"},on:{"click":function($event){}}}):_vm._e(),_vm._v(" "),(_vm.report.canBeEdited && !img.FileData)?_c('div',{staticClass:"thumbnail-img-rotateleft",on:{"click":function($event){return _vm.rotateImage('left', img)}}}):_vm._e(),_vm._v(" "),(_vm.report.canBeEdited && !img.FileData)?_c('div',{staticClass:"thumbnail-img-rotateright",on:{"click":function($event){return _vm.rotateImage('right', img)}}}):_vm._e()],_vm._v(" "),(img.statusMessage != null)?_c('span',{staticClass:"badge badge-danger",attrs:{"title":img.statusMessage}},[_c('b',[_vm._v("!")])]):_vm._e()],2)}),0)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.report.canBeEdited)?_c('div',{staticClass:"file-upload-zone",staticStyle:{"height":"60px","width":"50%"}},[_c('input',{staticClass:"file-upload-zone-btn",attrs:{"type":"file","multiple":"","id":'dropFiles' + field.Id,"name":"dropFilesPhotos","data-fieldid":field.Id,"data-typeid":field.TypeId,"accept":_vm.getAvailableExtensions(field)}}),_vm._v(" "),_c('label',{staticClass:"file-upload-zone-lbl",attrs:{"for":'dropFiles' + field.Id}},[_vm._v("\n                                              "+_vm._s((field.PdfAndExcelFilesEnabled ? 'Добавить файл' : 'Добавить фото'))+"\n                                            ")])]):_vm._e()])])])}),0):_vm._e()]),_vm._v(" "),_c('popup-window',{ref:"ppEditModal",attrs:{"title":'Отправка на доработку',"modal":true}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                        Причина отправки на доработку\n                        "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.report.EditionComment),expression:"report.EditionComment"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-memo', { 'input-error': _vm.errors.has('EditionComment', 'edition') }],staticStyle:{"height":"150px"},attrs:{"name":"EditionComment","rows":"10","data-vv-scope":"edition"},domProps:{"value":(_vm.report.EditionComment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.report, "EditionComment", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('EditionComment', 'edition'))?_c('span',{staticClass:"field-validation-valid"},[_vm._v("Заполните поле")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.sendReportToEdition()}}},[_vm._v("Принять")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.closeModal('ppEditModal')}}},[_vm._v("Отмена")])])]),_vm._v(" "),_c('popup-window',{ref:"ppApproveModal",attrs:{"title":'Принятие отчёта'}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                        Причины изменения отчета\n                        "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.report.ModificationComment),expression:"report.ModificationComment"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-memo', { 'input-error': _vm.errors.has('ModificationComment') }],staticStyle:{"height":"150px"},attrs:{"name":"ModificationComment","rows":"10"},domProps:{"value":(_vm.report.ModificationComment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.report, "ModificationComment", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('ModificationComment'))?_c('span',{staticClass:"field-validation-valid"},[_vm._v("Заполните поле")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":!_vm.report.ModificationComment || _vm.report.ModificationComment.length < 3},on:{"click":function($event){$event.stopPropagation();return _vm.approveReport()}}},[_vm._v("\n                        Принять\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.closeModal('ppApproveModal')}}},[_vm._v("Отмена")])])]),_vm._v(" "),_c('popup-window',{ref:"ppRejectModal",attrs:{"title":'Отклонение отчёта'}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                        Укажите причину отклонения\n                        "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.report.CancellationComment),expression:"report.CancellationComment"},{name:"validate",rawName:"v-validate",value:({required: true, min: 3}),expression:"{required: true, min: 3}"}],class:['input-memo', { 'input-error': _vm.errors.has('CancellationComment', 'rejection') }],staticStyle:{"height":"150px"},attrs:{"name":"CancellationComment","rows":"10","data-vv-scope":"rejection","data-vv-as":"Причина отклонения"},domProps:{"value":(_vm.report.CancellationComment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.report, "CancellationComment", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('CancellationComment', 'rejection')))])]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.rejectReport()}}},[_vm._v("Отклонить")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeModal('ppRejectModal')}}},[_vm._v("Отмена")])])]),_vm._v(" "),_c('popup-window',{ref:"ppImportResultsModal",attrs:{"title":'Результаты импорта'}},[(_vm.importResult != null)?_c('div',[_vm._v("\n                    Успешно импортировано строк: "+_vm._s(_vm.importResult.Data.length)),_c('br'),_c('br'),_vm._v(" "),(_vm.importResult.Errors.length)?[_vm._v("\n                        Ошибки:"),_c('br'),_vm._v(" "),_c('ul',_vm._l((_vm.importResult.Errors),function(error){return _c('li',[_vm._v("\n                                "+_vm._s(error)+"\n                            ")])}),0)]:_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeModal('ppImportResultsModal')}}},[_vm._v("Ok")])])])]:_vm._e(),_vm._v(" "),_c('vue-headful',{attrs:{"title":_vm.getPageTitle()}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FnsReportEdit_vue__ = __webpack_require__(250);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c97fcf5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FnsReportEdit_vue__ = __webpack_require__(649);
function injectStyle (ssrContext) {
  __webpack_require__(647)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c97fcf5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FnsReportEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c97fcf5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FnsReportEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(648);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("5379263e", content, true, {});

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "button.img-download[data-v-2c97fcf5]{left:50%;position:relative;margin-left:-35px}.fancybox-inner[data-v-2c97fcf5]{overflow:hidden!important}.fancybox-nav[data-v-2c97fcf5]{width:40px!important}", ""]);

// exports


/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[(_vm.report != null)?[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"btn-back margin-right-10"},[_c('a',{staticClass:"router-link-active",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.$router.back()}}},[_vm._v("Назад")])]),_vm._v(" "),(_vm.report.new)?_c('p',{staticClass:"caption-help margin-right-10"},[_vm._v("Новый отчёт")]):_vm._e(),_vm._v(" "),(!_vm.report.new)?_c('p',{staticClass:"caption-help margin-right-10"},[_vm._v("Статус: "+_vm._s(_vm.report.StateFormatted))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[_c('div',{staticClass:"btns flex",attrs:{"data-toggle":"buttons"}},[(_vm.info.User && _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.reportAdd) && _vm.report.canBeEdited)?[_c('span',{staticClass:"caption-help margin-right-10"},[_vm._v("\n                            "+_vm._s(_vm.EditingProcessState)+"\n                        ")]),_vm._v(" "),((_vm.report.new || _vm.report.State === 1 || _vm.report.State === 3 || _vm.report.State === 4) && !_vm.EditingProcessState)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveReport()}}},[_vm._v("\n                            Сохранить\n                        ")]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.info.User && (_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.reportCheck) || _vm.info.User.MainRole === 'administrators')
                                && (_vm.report.State === 1 || _vm.report.State === 3))?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.tryApproveReport()}}},[_vm._v("\n                        Принять\n                    ")]):_vm._e(),_vm._v(" "),(_vm.info.User && (_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.reportCheck) || _vm.info.User.MainRole === 'administrators')
                                && (_vm.report.State === 1 || _vm.report.State === 2 || _vm.report.State === 3))?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.sendReportToEditionModal()}}},[_vm._v("\n                        Доработать\n                    ")]):_vm._e(),_vm._v(" "),(_vm.info.User && (_vm.info.User.MainRole === 'administrators' || _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.reportCheck)))?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.rejectReportModal()}}},[_vm._v("\n                        Отклонить\n                    ")]):_vm._e(),_vm._v(" "),(!_vm.report.new && _vm.info.User && _vm.info.User.MainRole === 'administrators')?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteReport()}}},[_vm._v("Удалить")]):_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page"},[(_vm.info.User && _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.reportAdd))?_c('div',{staticClass:"flex btns"},[_c('input',{staticClass:"file-upload-zone-btn",attrs:{"type":"file","id":"qrCodeDropFiles","accept":".jpg,.jpeg,.png"},on:{"change":function($event){return _vm.onQrCodeChange($event)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","onclick":"document.getElementById('qrCodeDropFiles').click()"}},[_vm._v("\n                    Загрузить QrCode\n                ")]),_vm._v(" "),_c('input',{staticClass:"file-upload-zone-btn",attrs:{"type":"file","id":"checkDropFiles","accept":".jpg,.jpeg,.png"},on:{"change":function($event){return _vm.onCheckChange($event)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","disabled":_vm.checkLoadBtnDisabled,"onclick":"document.getElementById('checkDropFiles').click()"}},[_vm._v("\n                    Загрузить фото чека\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row report-photo-field margin-top-20"},[_c('div',{staticClass:"thumbnail-img-block"},_vm._l((_vm.report.Photos),function(img,i){return _c('div',{staticClass:"thumbnail-img"},[(img.FileData)?_c('a',{attrs:{"target":"_blank"}},[_c('img',{attrs:{"src":img.FileData}})]):_vm._e(),_vm._v(" "),(!img.FileData && img.FileName)?_c('a',{staticClass:"lightzoom",attrs:{"target":"_blank","href":img.FileName,"rel":"group"}},[_c('img',{attrs:{"src":img.FileName}})]):_vm._e(),_vm._v(" "),(_vm.report.canBeEdited)?_c('div',{staticClass:"thumbnail-img-delete",on:{"click":function($event){return _vm.removeImage(i)}}}):_vm._e()])}),0)]),_vm._v(" "),(_vm.report.FnsDetails != null)?_c('div',{staticClass:"row margin-top-20"},[_c('span',[_vm._v("\n                    Проверка ФНС:\n                    "),(_vm.report.FnsDetails.LastUpdate)?[_vm._v("\n                        "+_vm._s(_vm._f("date-long")(_vm.report.FnsDetails.LastUpdate))+"\n                    ")]:[_vm._v("\n                        Не выполнена\n                    ")]],2),_vm._v(" "),(_vm.report.FnsDetails.FnsCheckMessage)?_c('div',[_c('span',[_vm._v("Результат:")]),_vm._v(" "),_c('div',[_vm._v("\n                        "+_vm._s(_vm.report.FnsDetails.FnsCheckMessage)+"\n                    ")])]):_vm._e(),_vm._v(" "),(_vm.report.FnsDetails.FnsCheckResponse)?_c('div',[_c('span',[_vm._v("Полный ответ:")]),_vm._v(" "),_c('div',[_vm._v("\n                        "+_vm._s(_vm.report.FnsDetails.FnsCheckResponse)+"\n                    ")])]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('popup-window',{ref:"ppEditModal",attrs:{"title":'Отправка на доработку'}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                    Причина отправки на доработку\n                    "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.report.EditionComment),expression:"report.EditionComment"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-memo', { 'input-error': _vm.errors.has('EditionComment') }],staticStyle:{"height":"150px"},attrs:{"name":"EditionComment","rows":"10"},domProps:{"value":(_vm.report.EditionComment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.report, "EditionComment", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('EditionComment'))?_c('span',{staticClass:"field-validation-valid"},[_vm._v("Заполните поле")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.sendReportToEdition()}}},[_vm._v("Принять")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.closeModal('ppEditModal')}}},[_vm._v("Отмена")])])]),_vm._v(" "),_c('popup-window',{ref:"ppApproveModal",attrs:{"title":'Принятие отчёта'}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                    Причины изменения отчета\n                    "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.report.ModificationComment),expression:"report.ModificationComment"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-memo', { 'input-error': _vm.errors.has('ModificationComment') }],staticStyle:{"height":"150px"},attrs:{"name":"ModificationComment","rows":"10"},domProps:{"value":(_vm.report.ModificationComment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.report, "ModificationComment", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('ModificationComment'))?_c('span',{staticClass:"field-validation-valid"},[_vm._v("Заполните поле")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":!_vm.report.ModificationComment || _vm.report.ModificationComment.length < 3},on:{"click":function($event){$event.stopPropagation();return _vm.approveReport()}}},[_vm._v("\n                    Принять\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.closeModal('ppApproveModal')}}},[_vm._v("Отмена")])])]),_vm._v(" "),_c('popup-window',{ref:"ppRejectModal",attrs:{"title":'Отклонение отчёта'}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                    Укажите причину отклонения\n                    "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.report.CancellationComment),expression:"report.CancellationComment"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-memo', { 'input-error': _vm.errors.has('CancellationComment') }],staticStyle:{"height":"150px"},attrs:{"name":"CancellationComment","rows":"10"},domProps:{"value":(_vm.report.CancellationComment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.report, "CancellationComment", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('CancellationComment'))?_c('span',{staticClass:"field-validation-valid"},[_vm._v("Заполните поле")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"})]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":!_vm.report.CancellationComment || _vm.report.CancellationComment.length < 3},on:{"click":function($event){return _vm.rejectReport()}}},[_vm._v("Отклонить")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeModal('ppRejectModal')}}},[_vm._v("Отмена")])])])]:_vm._e(),_vm._v(" "),_c('vue-headful',{attrs:{"title":_vm.getPageTitle()}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsDetails_vue__ = __webpack_require__(251);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69183067_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsDetails_vue__ = __webpack_require__(653);
function injectStyle (ssrContext) {
  __webpack_require__(651)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69183067"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69183067_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(652);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("3e041274", content, true, {});

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".news-actions.like[data-v-69183067]{position:relative}.fade-enter-active[data-v-69183067],.fade-leave-active[data-v-69183067]{transition:opacity .5s}.fade-enter[data-v-69183067],.fade-leave-to[data-v-69183067]{opacity:0}", ""]);

// exports


/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[(_vm.news != null)?[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"btn-back"},[_c('router-link',{attrs:{"to":"/news"}},[_vm._v("Назад")])],1)])]),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[_c('div',{staticClass:"btns flex"},[(_vm.info.User && (_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.newsCreate) || _vm.info.User.MainRole === 'administrators'))?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onEditNews()}}},[_vm._v("Редактировать")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page"},[_c('div',{staticClass:"body-panel page-content-block"},[_c('p',{staticClass:"news-header"},[_vm._v(_vm._s(_vm.news.Title))]),_vm._v(" "),_c('p',{staticClass:"caption-help margin-top-5"},[_vm._v(_vm._s(_vm._f("date-short")(_vm.news.StartDate)))]),_vm._v(" "),_c('div',{staticClass:"margin-top-30 fr-view",domProps:{"innerHTML":_vm._s(_vm.BodyFormatted)}}),_vm._v(" "),(_vm.news.YoutubeLink)?_c('div',{staticClass:"margin-top-20"},[_c('iframe',{staticClass:"youtube",attrs:{"width":"560","height":"315","src":_vm.news.YoutubeLink,"frameborder":"0","allow":"autoplay;encrypted-media","allowfullscreen":""}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex margin-top-30"},[(_vm.news.LikesEnabled || _vm.news.CommentsEnabled || _vm.news.DisplayViews)?_c('div',{staticClass:"flex news-stats"},[_c('div',{staticClass:"flex",on:{"click":function($event){$event.stopPropagation();return _vm.onShowUsers.apply(null, arguments)}}},[(_vm.news.LikesEnabled)?_c('div',{class:['news-actions like', {'bold': _vm.news.MyVote === true}],on:{"click":function($event){$event.stopPropagation();return _vm.onMakeMark()},"mouseenter":_vm.onMarkEnter,"mouseleave":_vm.onMarkLeave}},[_c('svg',{staticClass:"svg-icon like-1",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Like"}})]),_vm._v(" "),_c('svg',{staticClass:"svg-icon like-2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Like2"}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.news.LikesCount))]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showWhoLiked)?_c('div',{staticClass:"tooltip"},[_c('div',{staticClass:"tooltip-header"},[_vm._v("\n                                            Понравилось "+_vm._s(_vm.news.LikesCount)+" "+_vm._s(_vm.get_text_ending(_vm.news.LikesCount, ['человеку','людям','людям']))+"\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"tooltip-body"},_vm._l((_vm.news.LastLikedUsers),function(user){return _c('img',{class:['like-user', {'u57': !user.Image}],attrs:{"src":user.Image ? (user.Image) : '/Content/dist/u57.png'}})}),0)]):_vm._e()])],1):_vm._e(),_vm._v(" "),(_vm.news.DisplayViews)?_c('div',{staticClass:"news-actions margin-left-15",attrs:{"title":"Всего просмотров"}},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Eye"}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.news.ViewsCount))])]):_vm._e()]),_vm._v(" "),(_vm.news.CommentsEnabled)?_c('div',{staticClass:"news-actions margin-left-15",attrs:{"title":"Всего комментариев"}},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Comm"}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.news.CommentsCount))])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"margin-left-15"},[(_vm.news.CommentsEnabled)?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onShowComments()}}},[_vm._v("Обсудить")]):_vm._e()])])])]),_vm._v(" "),(_vm.news.CommentsEnabled)?_c('div',{staticClass:"body-panel-pp-right body-panel",style:(_vm.commentShow ? 'margin-right: 0' : ''),attrs:{"id":"Comments"}},[_c('div',{staticClass:"popup-close",attrs:{"data-v-72fb03bf":""},on:{"click":function($event){return _vm.onShowComments()}}}),_vm._v(" "),_c('div',{staticClass:"body-panel-content",attrs:{"id":"CommentsBody"},on:{"scroll":_vm.onScrollComments}},[_c('div',{staticClass:"comments"},[(_vm.comments.data.length === 0)?_c('div',{staticClass:"caption-help",staticStyle:{"text-align":"center","margin-top":"150px","font-size":"18px","padding":"0 80px","white-space":"normal"}},[_vm._v("\n                        Напишите первым сообщение к этой новости!\n                    ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.comments.data),function(comment,c){return _c('div',{class:['comment', {'comment-deleted': comment.Deleted === true}]},[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"user-icon"},[(comment.UserImage == null)?_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg?#User"}})]):_c('img',{attrs:{"src":comment.UserImage}})]),_vm._v(" "),_c('div',[_c('p',{staticClass:"comment-author"},[_vm._v(_vm._s(comment.UserFio))]),_vm._v(" "),_c('span',{staticClass:"caption-help margin-top-10"},[_vm._v(_vm._s(_vm.formatDate(comment.CreateDate, 'DD.MM.YYYY HH:mm')))])])]),_vm._v(" "),_c('div',{staticClass:"comment-info margin-top-5"},[(comment.EditedByAdminDate && (comment.UserId === _vm.info.User.Id || _vm.info.User.MainRole === 'administrators'))?_c('span',{staticClass:"caption-help"},[_vm._v("(Изменен администратором: "+_vm._s(_vm.formatDate(comment.EditedByAdminDate, 'DD.MM.YYYY HH:mm'))+")")]):_vm._e(),_vm._v(" "),(!comment.Edited)?[_c('p',{domProps:{"innerHTML":_vm._s(_vm.formatBody(comment.Body))}}),_vm._v(" "),(comment.Deleted === true)?_c('p',[_vm._v("\n                                    (Комментарий удалён"),(comment.DeletedByAdmin === true)?[_vm._v(" администратором")]:_vm._e(),_vm._v(")\n                                ")],2):_vm._e()]:[_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(comment.Body),expression:"comment.Body"}],class:['input-memo', {'input-error': _vm.errors.has('commentBody' + c, 'editForm')}],attrs:{"name":'commentBody' + c,"data-vv-scope":"editForm"},domProps:{"value":(comment.Body)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(comment, "Body", $event.target.value)}}})]],2),_vm._v(" "),_c('div',{staticClass:"comment-actions"},[(!comment.Edited)?_c('div',{staticClass:"btns"},[(comment.Deleted !== true && ((comment.UserId === _vm.info.User.Id && comment.CanBeEdited) || _vm.info.User.MainRole === 'administrators'))?_c('button',{staticClass:"btn btn-img",attrs:{"type":"button"},on:{"click":function($event){return _vm.onCommentEdit(comment)}}},[_c('img',{attrs:{"src":__webpack_require__(31),"alt":""}})]):_vm._e(),_vm._v(" "),(comment.Deleted !== true)?_c('button',{staticClass:"btn btn-img",attrs:{"type":"button"},on:{"click":function($event){return _vm.onCommentDelete(comment.Id)}}},[_c('img',{attrs:{"src":__webpack_require__(17),"alt":""}})]):_vm._e()]):_c('div',{staticClass:"btns"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onCommentSave(comment)}}},[_vm._v("\n                                    Сохранить\n                                ")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onCommentCancel(comment)}}},[_vm._v("\n                                    Отмена\n                                ")])])])])})],2)]),_vm._v(" "),_c('div',{staticClass:"body-panel-control"},[_c('div',{staticClass:"flex comment-add"},[_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.commentBody),expression:"commentBody"}],class:['input-memo', {'input-error': _vm.errors.has('comment', 'addForm')}],attrs:{"name":"comment","rows":"3","placeholder":"Ваш комментарий","data-vv-scope":"addForm"},domProps:{"value":(_vm.commentBody)},on:{"input":function($event){if($event.target.composing){ return; }_vm.commentBody=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"btns"},[_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.onCommentSave(null)}}},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg?#Send"}})])])])])])]):_vm._e()]:_vm._e(),_vm._v(" "),_c('popup-window',{ref:"ppUsers",attrs:{"title":'Пользователи, просмотревшие новость',"width":800},on:{"onBottomScrolled":_vm.onBottomScrolledUsers}},[_c('button',{staticClass:"btn",staticStyle:{"margin":"0 0 10px auto"},attrs:{"type":"button"},on:{"click":function($event){return _vm.onExport()}}},[_vm._v("Экспорт")]),_vm._v(" "),_c('table',{staticClass:"t-data",staticStyle:{"max-width":"1000px","margin":"0 auto"}},[_c('thead',[_c('tr',{staticClass:"heading"},[_c('th',{staticClass:"with-img mob-hide"},[_vm._v("Пользователь")]),_vm._v(" "),_c('th',{staticClass:"w150-r"},[_vm._v("Дата просмотра")]),_vm._v(" "),_c('th',{staticClass:"w150-r"},[_vm._v("Дата лайка")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.users.data),function(item){return [_c('tr',{class:['hide-when-not-mob']},[_c('td',{staticClass:"number"},[(item.UserImage !== null)?_c('img',{attrs:{"src":item.UserImage}}):_c('img',{attrs:{"src":__webpack_require__(55)}})]),_vm._v(" "),_c('td',{staticClass:"with-img"},[_c('span',[_vm._v(_vm._s(item.UserFio))])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"with-img mob-hide"},[(item.UserImage !== null)?_c('img',{attrs:{"src":item.UserImage}}):_c('img',{attrs:{"src":__webpack_require__(55)}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.UserFio))])]),_vm._v(" "),_c('td',{staticClass:"w150-r",staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.formatDateLong(item.ViewedDate)))]),_vm._v(" "),_c('td',{staticClass:"w150-r",staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.formatDateLong(item.LikedDate)))])])]})],2)])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Новости"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SkuDetails_vue__ = __webpack_require__(252);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12252b63_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkuDetails_vue__ = __webpack_require__(657);
function injectStyle (ssrContext) {
  __webpack_require__(655)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12252b63"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SkuDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12252b63_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkuDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(656);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("841ba9f2", content, true, {});

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".news-content-right .caption-help[data-v-12252b63]{white-space:unset}", ""]);

// exports


/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel"},[(_vm.sku != null && _vm.skuSettings != null)?[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"btn-back"},[_c('a',{staticClass:"router-link-active",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.back.apply(null, arguments)}}},[_vm._v("Назад")])])])]),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[_c('div',{staticClass:"btns flex"},[(_vm.info.User && (_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.skuCreate) || _vm.info.User.MainRole === 'administrators'))?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onEditSku()}}},[_vm._v("Редактировать")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page"},[_c('div',{staticClass:"body-panel page-content-block"},[_c('div',{staticClass:"body-panel-control"},[(_vm.skuSettingsNameField.ShowInDetails)?_c('p',{staticClass:"p-header-1"},[_vm._v("\n                        "+_vm._s(_vm.sku.Name)+"\n                    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"body-panel-content"},[(_vm.sku.Group != null)?_c('div',{staticClass:"news-content margin-top-10"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"news-content-right"},[_c('p',{staticClass:"caption-help"},[_vm._v(_vm._s(_vm.sku.Group.Name))])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.skuSettingsOrdered),function(s){return _c('div',{class:['news-content margin-top-10', s.FieldName]},[_c('div',{staticClass:"news-content-left"},[_c('p',{class:['caption-help']},[_vm._v("\n                                "+_vm._s(s.Title)),(s.FieldName === 'Volume')?[_vm._v(", "+_vm._s(_vm.sku.VolumeUnit))]:_vm._e(),(s.FieldName === 'Weight')?[_vm._v(", "+_vm._s(_vm.sku.WeightUnit))]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"news-content-right"},[(s.FieldName !== 'Description')?_c('p',{staticClass:"caption-help"},[_vm._v("\n                                "+_vm._s(_vm.sku[s.FieldName])),(s.FieldName === 'RRC')?[_vm._v(" руб.")]:_vm._e()],2):_c('p',{staticClass:"caption-help",domProps:{"innerHTML":_vm._s(_vm.DescriptionFormatted)}})])])}),_vm._v(" "),(_vm.sku.Image)?_c('div',{staticClass:"news-content"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"news-content-right"},[_c('div',{staticClass:"news-content-right-img"},[_c('img',{attrs:{"src":_vm.sku.Image,"alt":""}})])])]):_vm._e(),_vm._v(" "),(_vm.sku.StartDate)?_c('div',{staticClass:"news-content"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"news-content-right"},[_c('p',{staticClass:"caption-help"},[_vm._v(_vm._s(_vm._f("date-short")(_vm.sku.StartDate)))])])]):_vm._e(),_vm._v(" "),(_vm.sku.EndDate)?_c('div',{staticClass:"news-content margin-top-10"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"news-content-right"},[_c('p',{staticClass:"caption-help"},[_vm._v(_vm._s(_vm._f("date-short")(_vm.sku.EndDate)))])])]):_vm._e(),_vm._v(" "),(_vm.info.User && _vm.info.User.MainRole === 'administrators' && _vm.sku.Links && _vm.sku.Links.length)?_c('div',{staticClass:"news-content margin-top-10"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"news-content-right"},_vm._l((_vm.sku.Links),function(link){return _c('p',{staticClass:"caption-help"},[_vm._v(_vm._s(link.Name)+" - "+_vm._s(link.Amount)+_vm._s(link.BonusType))])}),0)]):_vm._e()],2)])])]:_vm._e(),_vm._v(" "),_c('vue-headful',{attrs:{"title":"SKU"}})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-content-left"},[_c('p',{staticClass:"caption-help"},[_vm._v("Группа")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-content-left"},[_c('p',{staticClass:"caption-help"},[_vm._v("Изображение")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-content-left"},[_c('p',{staticClass:"caption-help"},[_vm._v("Добавлено")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-content-left"},[_c('p',{staticClass:"caption-help"},[_vm._v("Отключено")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-content-left"},[_c('p',{staticClass:"caption-help"},[_vm._v("Связи с ТТ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MaterialDetails_vue__ = __webpack_require__(253);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_392ad73b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MaterialDetails_vue__ = __webpack_require__(661);
function injectStyle (ssrContext) {
  __webpack_require__(659)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-392ad73b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MaterialDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_392ad73b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MaterialDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(660);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("725992fd", content, true, {});

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".panel-body-stats[data-v-392ad73b]{position:static;padding:0}.panel-body-stats p[data-v-392ad73b]{margin-left:0}.panel-body-stats p+p[data-v-392ad73b]{margin-left:15px}", ""]);

// exports


/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[(_vm.material != null)?[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"btn-back"},[_c('a',{staticClass:"router-link-active",on:{"click":function($event){$event.stopPropagation();return _vm.onBack()}}},[(_vm.activeTab === 'test')?[_vm._v("\n                                Назад к материалу\n                            ")]:[_vm._v("\n                                Назад\n                            ")]],2)])])]),_vm._v(" "),(_vm.info.User && (_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.materialCreate) || _vm.info.User.MainRole === 'administrators'))?_c('div',{staticClass:"control-block-right flex btns"},[(_vm.info.User.MainRole === 'administrators')?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onExportMaterial()}}},[_vm._v("Экспорт")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onEditMaterial()}}},[_vm._v("Редактировать")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page",attrs:{"id":"playerContainer"}},[_c('div',{staticClass:"mob-flex-to-block height-full mob-height-auto material-conteiner"},[_c('div',{staticClass:"material-body",style:({display: _vm.activeTab === 'info' ? 'block' : 'none'})},[_c('div',{staticClass:"material-body-content flex course-content"},[_c('div',{staticClass:"course-info"},[_c('h2',[_vm._v(_vm._s(_vm.material.Name))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.material.Description)}}),_vm._v(" "),(_vm.material.LikesEnabled || _vm.material.DisplayViews)?_c('div',{staticClass:"panel-body-stats"},[(_vm.material.LikesEnabled)?_c('p',{class:['news-actions like', {'bold': _vm.material.MyVote === true}],attrs:{"title":"Нравится"},on:{"click":function($event){$event.stopPropagation();return _vm.onMakeMark.apply(null, arguments)}}},[_c('svg',{staticClass:"svg-icon like-1",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Like"}})]),_vm._v(" "),_c('svg',{staticClass:"svg-icon like-2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Like2"}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.material.LikesCount))])]):_vm._e(),_vm._v(" "),(_vm.material.DisplayViews)?_c('p',{staticClass:"news-actions margin-left-15",on:{"click":function($event){$event.stopPropagation();return _vm.onShowUsers.apply(null, arguments)}}},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Eye"}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.material.ViewsCount))])]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"course-material-files"},[(_vm.material.CertificateSettings && _vm.material.CertificateSettings.Issuance !== 'undefined' && _vm.material.CertificateSettings.Issuance.Actived)?_c('ul',[_c('li',[_c('span',{staticClass:"head"},[_vm._v("Сертификат за прохождение курса")]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',[_c('div',[(!_vm.material.TestComplete)?_c('span',{staticStyle:{"padding-top":"7px"}},[_vm._v("\n                                                    "+_vm._s(_vm.material.CertificateSettings.Issuance.data.front)+"\n                                                ")]):_vm._e(),_vm._v(" "),(_vm.results && _vm.material.TestComplete && !_vm.material.CertificateSessionId)?_c('span',{staticStyle:{"padding-top":"7px"}},[_vm._v("\n                                                    "+_vm._s(_vm.material.CertificateSettings.Issuance.data.before)+"\n                                                ")]):_vm._e(),_vm._v(" "),(_vm.results && _vm.material.TestComplete && _vm.material.CertificateSessionId)?_c('span',{staticStyle:{"padding-top":"7px"}},[_vm._v("\n                                                    "+_vm._s(_vm.material.CertificateSettings.Issuance.data.after)+"\n                                                ")]):_vm._e()]),_vm._v(" "),(_vm.results && _vm.material.TestComplete && _vm.material.CertificateSessionId)?_c('div',{staticClass:"margin-top-20"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onCertificateDownload(_vm.material.CertificateSessionId)}}},[_vm._v("Скачать")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"material-sert-icon"},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Sert"}})])])])])]):_vm._e(),_vm._v(" "),_c('h2',[_vm._v("Материалы")]),_vm._v(" "),_c('ul',_vm._l((_vm.material.Files),function(materialFile){return _c('li',[_c('span',{staticClass:"head"},[_vm._v(_vm._s(materialFile.Name))]),_vm._v(" "),_c('div',{staticClass:"flex"},[(materialFile.Available)?_c('span',{staticStyle:{"padding-top":"7px"}},[_vm._v(_vm._s(materialFile.ProgressStatus))]):_vm._e(),_vm._v(" "),(!materialFile.Available)?_c('span',{staticStyle:{"color":"#728a9a","padding-top":"7px"}},[_vm._v("Изучите предыдущий материал")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"auto","display":"flex","align-items":"center"}},[(!materialFile.Available)?_c('svg',{staticClass:"svg-icon",staticStyle:{"margin-right":"7px"},attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Lock"}})]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":!materialFile.Available},on:{"click":function($event){return _vm.onViewMaterialFile(materialFile)}}},[(materialFile.ProgressPercent == null)?[_vm._v("\n                                                    Начать изучение\n                                                ")]:_vm._e(),_vm._v(" "),(materialFile.ProgressPercent == 1)?[_vm._v("\n                                                    Изучить еще раз\n                                                ")]:_vm._e(),_vm._v(" "),(materialFile.ProgressPercent != null && materialFile.ProgressPercent < 1)?[_vm._v("\n                                                    Продолжить изучение\n                                                ")]:_vm._e()],2)])])])}),0),_vm._v(" "),(_vm.TesCanBeShown)?_c('h2',{staticClass:"margin-top-15"},[_vm._v(_vm._s(_vm.material.TestTabName || 'Тестирование'))]):_vm._e(),_vm._v(" "),(_vm.TesCanBeShown)?_c('ul',[_c('li',[_c('div',{staticClass:"flex"},[(_vm.results && _vm.material.TestComplete)?_c('span',{staticClass:"green-text",staticStyle:{"padding-top":"7px"}},[_vm._v("\n                                            Тест успешно сдан\n                                        ")]):_vm._e(),_vm._v(" "),(_vm.results && !_vm.material.TestComplete)?_c('span',{staticClass:"red-text",staticStyle:{"padding-top":"7px"}},[_vm._v("\n                                            Вы не сдали тест\n                                        ")]):_vm._e(),_vm._v(" "),(!_vm.TestAvailable && _vm.results === null)?_c('span',{staticStyle:{"color":"#728a9a","padding-top":"7px"}},[_vm._v("\n                                            Изучите материалы для сдачи теста\n                                        ")]):_vm._e(),_vm._v(" "),(_vm.TestAvailable && _vm.results === null)?_c('span',{staticClass:"green-text",staticStyle:{"padding-top":"7px"}},[_vm._v("\n                                            Пройдите тест!\n                                        ")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"auto","display":"flex","align-items":"center"}},[(!_vm.TestAvailable)?_c('svg',{staticClass:"svg-icon",staticStyle:{"margin-right":"7px"},attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Lock"}})]):_vm._e(),_vm._v(" "),(_vm.results != null)?_c('button',{staticClass:"btn margin-right-20",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.$refs['ppTestResults'].show()}}},[_vm._v("\n                                                Результат попытки\n                                            ")]):_vm._e(),_vm._v(" "),(!_vm.material.TestComplete)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":!_vm.TestAvailable || _vm.timeLeft != null || _vm.material.AttemptsLeft === 0,"title":_vm.TestAvailable ? '' : 'Пройдите все обучающие материалы. После этого тест станет доступен'},on:{"click":function($event){return _vm.onTestTabClick()}}},[_vm._v("\n                                                Сдать тест\n                                            ")]):_vm._e()])]),_vm._v(" "),(_vm.timeLeft)?_c('p',{staticClass:"margin-top-10",staticStyle:{"color":"#728a9a"}},[_vm._v("\n                                        Следующая попытка через "+_vm._s(_vm.timeLeft)+"\n                                    ")]):_vm._e(),_vm._v(" "),(_vm.material.AttemptsLeft === 0)?_c('p',{staticClass:"margin-top-10",staticStyle:{"color":"#728a9a"}},[_vm._v("\n                                        Все попытки израсходованы\n                                    ")]):_vm._e()])]):_vm._e()])])]),_vm._v(" "),(!_vm.material.TestDisabled && _vm.TestAvailable)?_c('div',{staticClass:"material-body",style:({display: _vm.activeTab === 'test' ? 'block' : 'none'})},[_c('div',{staticClass:"material-body-content flex course-content"},[_c('div',{staticClass:"course-info"},[_c('h2',[_vm._v(_vm._s(_vm.material.Name))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.material.TestGreeting)}}),_vm._v(" "),(_vm.material.AttemptsLeft === 0)?_c('p',[_vm._v("\n                                Кол-во попыток прохождения теста израсходовано\n                            ")]):_vm._e(),_vm._v(" "),(_vm.testBtnShow)?_c('button',{staticClass:"btn margin-top-20",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onMaterialTest()}}},[_vm._v("\n                                Пройти тест\n                            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"course-material-files"},[_c('ul',[_c('li',[_c('span',{staticClass:"head"},[_vm._v("Время теста")]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('span',[_vm._v(_vm._s(_vm.material.TestTime ? _vm.material.TestTime : 'Не ограничено'))])])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"head"},[_vm._v("Номер попытки")]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('span',[_vm._v("#"+_vm._s(_vm.material.Attempt)+" "+_vm._s(_vm.material.TestAttemptsNumber ? (" из " + (_vm.material.TestAttemptsNumber)) : ''))])])]),_vm._v(" "),_c('li',[_c('span',{staticClass:"head"},[_vm._v("Всего вопросов")]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('span',[_vm._v(_vm._s(_vm.material.QuestionsToAsk ? _vm.material.QuestionsToAsk : _vm.material.Questions.length))])])]),_vm._v(" "),(_vm.material.Bonus)?_c('li',[_c('span',{staticClass:"head"},[_vm._v("Итого баллов")]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('span',[_vm._v(_vm._s((_vm.material.Bonus||0)))])])]):_vm._e()])])])]):_vm._e()])])]:_vm._e(),_vm._v(" "),_c('popup-window',{ref:"ppUsers",attrs:{"title":'Пользователи, просмотревшие материал',"width":800},on:{"onBottomScrolled":_vm.onBottomScrolledUsers}},[_c('button',{staticClass:"btn",staticStyle:{"margin":"0 0 10px auto"},attrs:{"type":"button"},on:{"click":function($event){return _vm.onExport()}}},[_vm._v("Экспорт")]),_vm._v(" "),_c('table',{staticClass:"t-data",staticStyle:{"max-width":"1000px","margin":"0 auto"}},[_c('thead',[_c('tr',{staticClass:"heading"},[_c('th',{staticClass:"with-img mob-hide"},[_vm._v("Пользователь")]),_vm._v(" "),_c('th',{staticClass:"w150-r"},[_vm._v("Дата просмотра")]),_vm._v(" "),_c('th',{staticClass:"w150-r"},[_vm._v("Дата лайка")]),_vm._v(" "),_c('th',{staticClass:"w150-r"},[_vm._v("Дата последней попытки")]),_vm._v(" "),_c('th',{staticClass:"w150-r"},[_vm._v("Результат ")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.users.data),function(item){return [_c('tr',{class:['hide-when-not-mob']},[_c('td',{staticClass:"number"},[(item.UserImage !== null)?_c('img',{attrs:{"src":'/uploads/users/' + item.UserImage}}):_c('img',{attrs:{"src":__webpack_require__(55)}})]),_vm._v(" "),_c('td',{staticClass:"with-img"},[_c('span',[_vm._v(_vm._s(item.UserFio))])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"with-img mob-hide"},[(item.UserImage !== null)?_c('img',{attrs:{"src":'/uploads/users/' + item.UserImage}}):_c('img',{attrs:{"src":__webpack_require__(55)}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.UserFio))])]),_vm._v(" "),_c('td',{staticClass:"w150-r",staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.formatDateLong(item.ViewedDate)))]),_vm._v(" "),_c('td',{staticClass:"w150-r",staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.formatDateLong(item.LikedDate)))]),_vm._v(" "),_c('td',{staticClass:"w150-r",staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.formatDateLong(item.LastAttemptDate)))]),_vm._v(" "),_c('td',{staticClass:"w150-r",staticStyle:{"text-align":"center"}},[(item.LastAttemptDate)?_c('span',[_vm._v("\n                            "+_vm._s(item.LastAttemptComplete ? 'Сдал' : 'Не сдал')+"\n                        ")]):_vm._e()])])]})],2)])]),_vm._v(" "),_c('popup-window',{ref:"ppTestResults",attrs:{"title":'Результаты последней попытки',"width":'800px',"height":'95%'},on:{"onClose":_vm.onTestResultsClosed}},[_c('div',[(_vm.results != null && _vm.material != null)?_c('div',[_c('div',{staticClass:"test-result-body"},[_c('div',{staticClass:"test-result-body-header flex"},[_c('div',{staticClass:"test-result-body-icon"},[(_vm.results.Complete)?_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#ResultOk"}})]):_vm._e(),_vm._v(" "),(!_vm.results.Complete)?_c('svg',{staticClass:"svg-icon err",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#ResultErr"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"test-result-body-text"},[_c('p',{staticClass:"caption-help"},[_vm._v("Тест завершён!")]),_vm._v(" "),(!_vm.results.Complete)?_c('p',{staticClass:"test-hello-text"},[_vm._v("Вы не сдали тест")]):_vm._e(),_vm._v(" "),(_vm.results.Complete)?_c('p',{staticClass:"test-hello-text"},[_vm._v("Вы сдали тест")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"test-stats-row flex"},[_c('div',{staticClass:"test-stats-cell"},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Time"}})]),_vm._v(" "),_c('p',{staticClass:"margin-top-10 caption-help"},[_vm._v("Время теста")]),_vm._v(" "),_c('p',{staticClass:"margin-top-5 p-header-1"},[_vm._v("\n                                "+_vm._s(_vm.results.TestTime || '00:00:00 ')+"\n                                / "+_vm._s(_vm.results.MaterialTestTime ? _vm.results.MaterialTestTime : '∞')+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"test-stats-cell"},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Hash"}})]),_vm._v(" "),_c('p',{staticClass:"margin-top-10 caption-help"},[_vm._v("Номер попытки")]),_vm._v(" "),_c('p',{staticClass:"margin-top-5 p-header-1"},[_vm._v("\n                                "+_vm._s(_vm.results.Attempt)+"\n                                "),(_vm.results.MaterialAttempts)?[_vm._v("\n                                    / "+_vm._s(_vm.results.MaterialAttempts)+"\n                                ")]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"test-stats-cell"},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Check"}})]),_vm._v(" "),_c('p',{staticClass:"margin-top-10 caption-help"},[_vm._v("Статистика ответов")]),_vm._v(" "),_c('p',{staticClass:"margin-top-5 p-header-1"},[_c('span',[_vm._v(_vm._s(_vm.results.QuestionsRight)+" ("+_vm._s(_vm.results.QuestionsRightPercent)+"%)")]),_vm._v(" / "+_vm._s(_vm.results.MaterialQuestions))])]),_vm._v(" "),(_vm.material.Bonus > 0 || _vm.results.BonusMessage != null)?_c('div',{staticClass:"test-stats-cell"},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Star"}})]),_vm._v(" "),_c('p',{staticClass:"margin-top-10 caption-help"},[_vm._v("Итого баллов")]),_vm._v(" "),_c('p',{staticClass:"margin-top-5 p-header-1"},[_vm._v("\n                                "+_vm._s(_vm.results.BonusMessage == null ? (_vm.results.Bonus||0) : _vm.results.BonusMessage)+"\n                                "),(_vm.results.MaterialBonus)?[_vm._v("\n                                    / "+_vm._s(_vm.results.MaterialBonus)+"\n                                ")]:_vm._e()],2)]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.results != null && _vm.material != null && _vm.material.TestDisplayStats && _vm.results.Answers.length > 0)?_c('div',[_c('div',{staticClass:"margin-top-15 margin-bottom-10",staticStyle:{"font-weight":"600"}},[_vm._v("Ваши ответы")]),_vm._v(" "),(!_vm.isMobile)?_c('table',{staticClass:"table-view"},[_c('thead',[_c('tr',{staticClass:"heading"},[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',{attrs:{"align":"left"}},[_vm._v("Вопрос")]),_vm._v(" "),_c('th',[_vm._v("Результат")]),_vm._v(" "),_c('th',[_vm._v("Время ответа")]),_vm._v(" "),_c('th',[_vm._v("Баланс")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.results.Answers),function(item,i){return _c('tr',[_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.QuestionDescription))]),_vm._v(" "),_c('td',{class:['qwestion-result', {'err': !item.Correct }],attrs:{"align":"center"}},[_vm._v(_vm._s(item.Correct ? 'Верно': 'Не верно'))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(item.AnswerTime))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(item.Balance ? item.Balance.toFixed(0) : null))])])}),0)]):_vm._e(),_vm._v(" "),_vm._l((_vm.results.Answers),function(item,i){return (_vm.isMobile)?_c('div',{staticClass:"table-div"},[_c('div',{staticClass:"flex caption-help"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v("Вопрос")]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"right"}},[_vm._v("# "+_vm._s(i+1))])]),_vm._v(" "),_c('div',{staticClass:"margin-top-5",staticStyle:{"font-size":"14px","font-weight":"600"}},[_vm._v("\n                        "+_vm._s(item.QuestionDescription)+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"flex margin-top-5"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v("Результат")]),_vm._v(" "),_c('div',{class:['qwestion-result', {'err': !item.Correct }],staticStyle:{"width":"50%","text-align":"right"}},[_vm._v(_vm._s(item.Correct ? 'Верно': 'Не верно'))])]),_vm._v(" "),_c('div',{staticClass:"flex margin-top-2"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v("Время ответа")]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"right"}},[_vm._v(_vm._s(item.AnswerTime))])]),_vm._v(" "),(item.Balance)?_c('div',{staticClass:"flex margin-top-2"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v("Баллы")]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"right"}},[_vm._v(_vm._s(item.Balance.toFixed(0)))])]):_vm._e()]):_vm._e()})],2):_vm._e()])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Материалы"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MaterialFileDetails_vue__ = __webpack_require__(254);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b3f747e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MaterialFileDetails_vue__ = __webpack_require__(665);
function injectStyle (ssrContext) {
  __webpack_require__(663)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MaterialFileDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b3f747e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MaterialFileDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(664);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1410a446", content, true, {});

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".course-content{height:calc(100% - 40px)}", ""]);

// exports


/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[(_vm.material != null)?[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"btn-back"},[_c('router-link',{attrs:{"to":'/materials/' + _vm.$route.params.materialId}},[_vm._v("Назад к материалу")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page",attrs:{"id":"playerContainer"}},[_c('div',{staticClass:"mob-flex-to-block height-full mob-height-auto material-conteiner"},[_c('div',{staticClass:"material-body"},[_c('div',{staticClass:"material-body-content"},[_c('h2',{staticClass:"margin-bottom-20"},[_vm._v(_vm._s(_vm.currentMaterialFile.Name))]),_vm._v(" "),(_vm.material != null)?_c('video-viewer',{ref:"videoView",attrs:{"title":_vm.material.Name},on:{"onPageChanged":_vm.onPageChanged}}):_vm._e(),_vm._v(" "),(_vm.material != null)?_c('pdf-viewer',{ref:"pdfView",attrs:{"title":_vm.material.Name},on:{"onPageChanged":_vm.onPageChanged}}):_vm._e(),_vm._v(" "),(_vm.material != null)?_c('presentation-viewer',{ref:"presentationView",attrs:{"title":_vm.material.Name},on:{"onPageChanged":_vm.onPageChanged}}):_vm._e(),_vm._v(" "),(_vm.material != null)?_c('scorm-viewer',{ref:"scormView",attrs:{"title":_vm.material.Name},on:{"onPageChanged":_vm.onPageChanged}}):_vm._e(),_vm._v(" "),(_vm.isMobile && _vm.materialFilePath)?_c('div',{staticClass:"margin-top-5"},[_c('a',{attrs:{"href":_vm.materialFilePath,"target":"_blank","download":""}},[_vm._v("Скачать")])]):_vm._e()],1)])])])]:_vm._e(),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Материалы"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MaterialFileDetailsMobileApp_vue__ = __webpack_require__(255);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03e047dc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MaterialFileDetailsMobileApp_vue__ = __webpack_require__(669);
function injectStyle (ssrContext) {
  __webpack_require__(667)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MaterialFileDetailsMobileApp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03e047dc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MaterialFileDetailsMobileApp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(668);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("5cb013a7", content, true, {});

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".course-content{height:calc(100% - 40px)}jdiv{display:none!important}.margin-top-70{margin-top:70px}@media only screen and (min-width:1px) and (max-width:1024px){.body-panel-content-page{padding:12px}}", ""]);

// exports


/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['body-panel dataContent', {'margin-top-70': _vm.isWebView}]},[(_vm.material != null)?[_c('div',{staticClass:"body-panel-content body-panel-content-page",attrs:{"id":"playerContainer"}},[_c('div',{staticClass:"mob-flex-to-block height-full mob-height-auto material-conteiner"},[_c('div',{staticClass:"material-body"},[_c('div',{staticClass:"material-body-content"},[_c('h2',{staticClass:"margin-bottom-20"},[_vm._v(_vm._s(_vm.currentMaterialFile.Name))]),_vm._v(" "),(_vm.material != null)?_c('scorm-viewer',{ref:"scormView",attrs:{"title":_vm.material.Name},on:{"onPageChanged":_vm.onPageChanged}}):_vm._e()],1)])])])]:_vm._e(),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Материалы"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MaterialTest_vue__ = __webpack_require__(256);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bd6a94f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MaterialTest_vue__ = __webpack_require__(673);
function injectStyle (ssrContext) {
  __webpack_require__(671)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2bd6a94f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MaterialTest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bd6a94f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MaterialTest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(672);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("3db40bcc", content, true, {});

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".fade-enter-active[data-v-2bd6a94f],.fade-leave-active[data-v-2bd6a94f]{transition:opacity .5s}.fade-enter[data-v-2bd6a94f],.fade-leave-to[data-v-2bd6a94f]{opacity:0}", ""]);

// exports


/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[(_vm.material != null)?[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"btn-back"},[_c('router-link',{attrs:{"to":'/materials/' + _vm.$route.params.id}},[_vm._v("Назад к материалу")])],1)])]),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[(!_vm.started && !_vm.material.AllowedAttemptTime && (!_vm.material.TestAttemptsNumber || _vm.material.Attempt <= _vm.material.TestAttemptsNumber))?_c('button',{staticClass:"btn m-float-left",staticStyle:{"min-width":"120px"},attrs:{"type":"button"},on:{"click":_vm.onStartTest}},[_vm._v("\n                    "+_vm._s(_vm.material.TestButtonName || 'Пройти тест')+"\n                ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page"},[_c('div',{staticClass:"body-panel page-content-block qwestions"},[(!_vm.started && _vm.material != null && _vm.results == null)?_c('div',{staticClass:"test-start"},[(_vm.material.TestGreeting)?_c('div',{staticClass:"test-hello flex margin-bottom-20"},[_c('p',{staticClass:"test-hello-text",domProps:{"innerHTML":_vm._s(_vm.formatLine(_vm.material.TestGreeting))}})]):_vm._e(),_vm._v(" "),_c('div',[_c('div',{staticClass:"test-stats-row flex"},[_c('div',{staticClass:"test-stats-cell"},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Time"}})]),_vm._v(" "),_c('p',{staticClass:"margin-top-10 caption-help"},[_vm._v("Время теста")]),_vm._v(" "),_c('p',{staticClass:"margin-top-5 p-header-1"},[_vm._v(_vm._s(_vm.material.TestTime ? _vm.material.TestTime + ' ' + _vm.get_text_ending(_vm.material.TestTime, ['минута','минуты','минут']) : 'без ограничений'))])]),_vm._v(" "),_c('div',{staticClass:"test-stats-cell"},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Hash"}})]),_vm._v(" "),_c('p',{staticClass:"margin-top-10 caption-help"},[_vm._v("Номер попытки")]),_vm._v(" "),_c('p',{staticClass:"margin-top-5 p-header-1"},[_vm._v("\n                                    "+_vm._s(_vm.material.Attempt)+"\n                                    "),(_vm.material.TestAttemptsNumber)?[_vm._v("\n                                        / "+_vm._s(_vm.material.TestAttemptsNumber)+"\n                                    ")]:_vm._e()],2),_vm._v(" "),(_vm.material.AllowedAttemptTime)?_c('p',{staticClass:"margin-top-5 p-header-1"},[_vm._v("\n                                    Следующая попытка доступна в "+_vm._s(_vm.formatDate(_vm.material.AllowedAttemptTime, 'DD.MM.YYYY HH:mm:ss'))+"\n                                ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"test-stats-row flex"},[_c('div',{staticClass:"test-stats-cell"},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Check"}})]),_vm._v(" "),_c('p',{staticClass:"margin-top-10 caption-help"},[_vm._v("Всего вопросов")]),_vm._v(" "),_c('p',{staticClass:"margin-top-5 p-header-1"},[_vm._v(_vm._s(_vm.material.QuestionsToAsk ? _vm.material.QuestionsToAsk: _vm.material.Questions.length))])]),_vm._v(" "),(_vm.material.Bonus)?_c('div',{staticClass:"test-stats-cell"},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Star"}})]),_vm._v(" "),_c('p',{staticClass:"margin-top-10 caption-help"},[_vm._v("Максимум баллов")]),_vm._v(" "),_c('p',{staticClass:"margin-top-5 p-header-1"},[_vm._v(_vm._s(_vm.material.Bonus))])]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.started && _vm.material != null && _vm.currentState.question != null)?_c('div',{staticClass:"flex mob-flex-to-block",staticStyle:{"height":"100%","position":"relative"}},[_c('div',{staticClass:"test-qwestion"},[_c('div',{staticClass:"test-name margin-bottom-15"},[_vm._v(_vm._s(_vm.material.Name))]),_vm._v(" "),_c('div',{staticClass:"test-qwestion-num"},[_c('span',[_vm._v(_vm._s(_vm.currentState.index))]),_vm._v(" / "+_vm._s(_vm.material.Questions.length))]),_vm._v(" "),(_vm.currentState.question.BackgroundSite.FilePath)?_c('div',{staticClass:"background-image"},[_c('img',{attrs:{"src":_vm.currentState.question.BackgroundSite.FilePath}}),_vm._v(" "),_c('p',{class:[{'top': _vm.currentState.question.BackgroundSite.Align === 'top' }, {'bottom': _vm.currentState.question.BackgroundSite.Align === 'bottom' }]},[_vm._v(_vm._s(_vm.currentState.question.Description))])]):_c('p',{staticClass:"test-qwestion-text"},[_vm._v(_vm._s(_vm.currentState.question.Description))]),_vm._v(" "),(_vm.currentState.question.Images.length)?_c('div',{staticClass:"margin-top-20 margin-bottom-20"},_vm._l((_vm.currentState.question.Images),function(image){return _c('a',{staticClass:"lightzoom",attrs:{"rel":"group","href":image.Image}},[_c('img',{staticStyle:{"max-width":"200px","margin-right":"10px"},attrs:{"src":image.Image}})])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"margin-top-30"},[_vm._l((_vm.currentState.question.Answers),function(answer){return [(_vm.currentState.question.QuestionType === 1)?[_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentState.answers),expression:"currentState.answers"}],staticClass:"input-checkbox",attrs:{"type":"radio","id":'Answer_q' + _vm.currentState.question.Id  + 'a' + answer.Id,"name":'Answer_q' + _vm.currentState.question.Id  + 'a' + answer.Id},domProps:{"value":answer.Id,"checked":_vm._q(_vm.currentState.answers,answer.Id)},on:{"change":function($event){return _vm.$set(_vm.currentState, "answers", answer.Id)}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'Answer_q' + _vm.currentState.question.Id  + 'a' + answer.Id}},[_vm._v(_vm._s(answer.Value))])])]:_vm._e(),_vm._v(" "),(_vm.currentState.question.QuestionType === 2)?[_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentState.answers),expression:"currentState.answers"}],staticClass:"input-checkbox",attrs:{"type":"checkbox","id":'Answer_q' + _vm.currentState.question.Id  + 'a' + answer.Id,"name":'Answer_q' + _vm.currentState.question.Id  + 'a' + answer.Id},domProps:{"value":answer.Id,"checked":Array.isArray(_vm.currentState.answers)?_vm._i(_vm.currentState.answers,answer.Id)>-1:(_vm.currentState.answers)},on:{"change":function($event){var $$a=_vm.currentState.answers,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=answer.Id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.currentState, "answers", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.currentState, "answers", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.currentState, "answers", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'Answer_q' + _vm.currentState.question.Id  + 'a' + answer.Id}},[_vm._v(_vm._s(answer.Value))])])]:_vm._e()]}),_vm._v(" "),(_vm.currentState.question.QuestionType === 3)?[(_vm.currentState.question.AnswerType === 1)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentState.answers),expression:"currentState.answers"}],key:"type1",staticClass:"input-text",attrs:{"type":"text","name":'QuestionFreeAnswer'},domProps:{"value":(_vm.currentState.answers)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentState, "answers", $event.target.value)}}}):_vm._e(),_vm._v(" "),(_vm.currentState.question.AnswerType === 2)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentState.answers),expression:"currentState.answers"},{name:"validate",rawName:"v-validate",value:({ regex: /^\d{1,}$/ }),expression:"{ regex: /^\\d{1,}$/ }"}],key:"type2",class:['input-text', {'input-error': _vm.errors.has('QuestionFreeAnswer') }],attrs:{"type":"text","name":'QuestionFreeAnswer'},domProps:{"value":(_vm.currentState.answers)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentState, "answers", $event.target.value)}}}):_vm._e(),_vm._v(" "),(_vm.currentState.question.AnswerType === 3)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentState.answers),expression:"currentState.answers"},{name:"validate",rawName:"v-validate",value:({ regex: /^\d{1,}(\.|\,)?\d{0,}$/ }),expression:"{ regex: /^\\d{1,}(\\.|\\,)?\\d{0,}$/ }"}],key:"type3",class:['input-text', {'input-error': _vm.errors.has('QuestionFreeAnswer') }],attrs:{"type":"text","name":'QuestionFreeAnswer'},domProps:{"value":(_vm.currentState.answers)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentState, "answers", $event.target.value)}}}):_vm._e(),_vm._v(" "),(_vm.currentState.question.AnswerType === 4)?_c('input-date',{key:"type4",class:[{'input-error': _vm.errors.has('answers')}],attrs:{"name":'QuestionFreeAnswer'},model:{value:(_vm.currentState.answers),callback:function ($$v) {_vm.$set(_vm.currentState, "answers", $$v)},expression:"currentState.answers"}}):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"btns margin-top-30"},[(_vm.currentState.index !== _vm.material.Questions.length)?_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.makeAnswer()}}},[_vm._v("Следующий вопрос")]):_vm._e(),_vm._v(" "),(_vm.currentState.index === _vm.material.Questions.length)?_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.makeAnswer()}}},[_vm._v("Завершить тест")]):_vm._e()])]),_vm._v(" "),((_vm.material.Bonus || _vm.material.TestTime) )?_c('div',{staticClass:"test-timer"},[(_vm.material.Bonus)?_c('div',{staticClass:"test-timer-block"},[_c('base-counter',{attrs:{"name":"bonusCounter","value":_vm.bonus,"max":_vm.material.Bonus,"color":"#1fa7e3","legend":"Баллы","compact":_vm.isMobile}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.bonusAdd),expression:"bonusAdd"}],staticClass:"ball-animate add"},[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"plus"},[_vm._v("+")]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.bonusDx))])]),_vm._v(" "),_c('svg',{staticClass:"star star-1",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Star"}})]),_vm._v(" "),_c('svg',{staticClass:"star star-2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Star"}})]),_vm._v(" "),_c('svg',{staticClass:"star star-3",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Star"}})]),_vm._v(" "),_c('svg',{staticClass:"star star-4",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Star"}})]),_vm._v(" "),_c('svg',{staticClass:"star star-5",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Star"}})])])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.bonusDel),expression:"bonusDel"}],staticClass:"ball-animate del"},[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"plus"},[_vm._v("-")]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v(_vm._s(-_vm.bonusDx))])])])])],1):_vm._e(),_vm._v(" "),(_vm.material.TestTime)?_c('div',{staticClass:"test-timer-block"},[_c('base-counter',{attrs:{"name":"timeCounter","value":_vm.time,"max":_vm.material.TestTime * 60,"type":"time","color":"#68c45f","legend":"Время","compact":_vm.isMobile}})],1):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.results != null)?_c('div',[_c('div',{staticClass:"test-result-header flex"},[_c('div',{class:['test-result-header-div', {'select': _vm.resultTabs.active === 'info'}],on:{"click":function($event){_vm.resultTabs.active='info'}}},[_vm._v("Результаты теста")]),_vm._v(" "),(_vm.material.TestDisplayRating)?_c('div',{class:['test-result-header-div', {'select': _vm.resultTabs.active === 'top'}],on:{"click":function($event){_vm.resultTabs.active='top'}}},[_vm._v("ТОП-10")]):_vm._e(),_vm._v(" "),(_vm.material.TestDisplayStats)?_c('div',{class:['test-result-header-div', {'select': _vm.resultTabs.active === 'answers'}],on:{"click":function($event){_vm.resultTabs.active='answers'}}},[_vm._v("Ваши ответы")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"test-result-body"},[_c('div',{style:({display: _vm.resultTabs.active === 'info' ? 'block' : 'none'})},[_c('div',{staticClass:"test-result-body-header flex"},[_c('div',{staticClass:"test-result-body-icon"},[(_vm.results.Complete)?_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#ResultOk"}})]):_vm._e(),_vm._v(" "),(!_vm.results.Complete)?_c('svg',{staticClass:"svg-icon err",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#ResultErr"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"test-result-body-text"},[_c('p',{staticClass:"caption-help"},[_vm._v("Тест завершён!")]),_vm._v(" "),(!_vm.results.Complete)?_c('p',{staticClass:"test-hello-text"},[_vm._v("Вы не сдали тест")]):_vm._e(),_vm._v(" "),(_vm.results.Complete)?_c('p',{staticClass:"test-hello-text"},[_vm._v("Вы сдали тест")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"test-stats-row flex margin-top-30"},[_c('div',{staticClass:"test-stats-cell"},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Time"}})]),_vm._v(" "),_c('p',{staticClass:"margin-top-10 caption-help"},[_vm._v("Время теста")]),_vm._v(" "),_c('p',{staticClass:"margin-top-5 p-header-1"},[_vm._v(_vm._s(_vm.results.TestTime))])]),_vm._v(" "),_c('div',{staticClass:"test-stats-cell"},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Hash"}})]),_vm._v(" "),_c('p',{staticClass:"margin-top-10 caption-help"},[_vm._v("Номер попытки")]),_vm._v(" "),_c('p',{staticClass:"margin-top-5 p-header-1"},[_vm._v(_vm._s(_vm.results.Attempt))])])]),_vm._v(" "),_c('div',{staticClass:"test-stats-row flex"},[_c('div',{staticClass:"test-stats-cell"},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Check"}})]),_vm._v(" "),_c('p',{staticClass:"margin-top-10 caption-help"},[_vm._v("Статистика ответов")]),_vm._v(" "),_c('p',{staticClass:"margin-top-5 p-header-1"},[_c('span',[_vm._v(_vm._s(_vm.results.QuestionsRight)+" ("+_vm._s(_vm.results.QuestionsRightPercent)+"%)")]),_vm._v(" / "+_vm._s(_vm.results.QuestionsRight + _vm.results.QuestionsWrong))])]),_vm._v(" "),(_vm.material.Bonus > 0 || _vm.results.BonusMessage != null)?_c('div',{staticClass:"test-stats-cell"},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Star"}})]),_vm._v(" "),_c('p',{staticClass:"margin-top-10 caption-help"},[_vm._v("Итого баллов")]),_vm._v(" "),_c('p',{staticClass:"margin-top-5 p-header-1"},[_vm._v(_vm._s(_vm.results.BonusMessage == null ? _vm.results.Bonus.toFixed(0) : _vm.results.BonusMessage))])]):_vm._e()])]),_vm._v(" "),(_vm.material.TestDisplayRating)?_c('div',{style:({display: _vm.resultTabs.active === 'top' ? 'block' : 'none'})},[_c('div',{staticClass:"test-result-body-header flex"},[_c('div',{staticClass:"test-result-body-icon"},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Cup"}})])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),(!_vm.isMobile)?_c('table',{staticClass:"table-view"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.results.Top10),function(item,i){return _c('tr',[_c('td',{staticClass:"result-icon",attrs:{"align":"center"}},[(item.Place === 1)?_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#gold-icon"}})]):_vm._e(),_vm._v(" "),(item.Place === 2)?_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#silver-icon"}})]):_vm._e(),_vm._v(" "),(item.Place === 3)?_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#bronze-icon"}})]):_vm._e()]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(item.Place))]),_vm._v(" "),_c('td',{staticClass:"img userimg",staticStyle:{"padding":"5px"},attrs:{"align":"center"}},[(item.UserImage != null)?_c('img',{attrs:{"src":'/uploads/users/' + item.UserImage}}):_vm._e(),_vm._v(" "),(item.UserImage === null)?_c('img',{attrs:{"src":__webpack_require__(55)}}):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.UserFio))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(item.TestTime))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(_vm.formatAnswerStats(item.QuestionsRight, item.QuestionsWrong)))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(item.Bonus))])])}),0)]):_vm._e(),_vm._v(" "),_vm._l((_vm.results.Top10),function(item,i){return (_vm.isMobile)?_c('div',{staticClass:"table-div"},[_c('div',{staticClass:"flex",staticStyle:{"font-size":"14px","font-weight":"600"}},[_c('div',{staticClass:"result-icon"},[(item.Place === 1)?_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#gold-icon"}})]):_vm._e(),_vm._v(" "),(item.Place === 2)?_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#silver-icon"}})]):_vm._e(),_vm._v(" "),(item.Place === 3)?_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#bronze-icon"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"width":"45px","min-width":"45px"}},[_vm._v(_vm._s(item.Place))]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_vm._v(_vm._s(item.UserFio))])]),_vm._v(" "),_c('div',{staticClass:"flex margin-top-5 caption-help"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v("Время")]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"right"}},[_vm._v(_vm._s(item.TestTime))])]),_vm._v(" "),_c('div',{staticClass:"flex margin-top-2 caption-help"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v("Ответы")]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"right"}},[_vm._v(_vm._s(_vm.formatAnswerStats(item.QuestionsRight, item.QuestionsWrong)))])]),_vm._v(" "),_c('div',{staticClass:"flex margin-top-2 caption-help"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v("Баллы")]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"right"}},[_vm._v(_vm._s(item.Bonus))])])]):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.material.TestDisplayStats)?_c('div',{style:({display: _vm.resultTabs.active === 'answers' ? 'block' : 'none'})},[_c('div',{staticClass:"test-result-body-header flex"},[_c('div',{staticClass:"test-result-body-icon"},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Qwestion"}})])]),_vm._v(" "),_vm._m(2)]),_vm._v(" "),(!_vm.isMobile)?_c('table',{staticClass:"table-view"},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.results.Answers),function(item,i){return _c('tr',[_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.QuestionDescription))]),_vm._v(" "),_c('td',{class:['qwestion-result', {'err': !item.Correct }],attrs:{"align":"center"}},[_vm._v(_vm._s(item.Correct ? 'Верно': 'Не верно'))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(item.AnswerTime))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(item.Balance ? item.Balance.toFixed(0) : null))])])}),0)]):_vm._e(),_vm._v(" "),_vm._l((_vm.results.Answers),function(item,i){return (_vm.isMobile)?_c('div',{staticClass:"table-div"},[_c('div',{staticClass:"flex caption-help"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v("Вопрос")]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"right"}},[_vm._v("# "+_vm._s(i+1))])]),_vm._v(" "),_c('div',{staticClass:"margin-top-5",staticStyle:{"font-size":"14px","font-weight":"600"}},[_vm._v("\n                                    "+_vm._s(item.QuestionDescription)+"\n                                ")]),_vm._v(" "),_c('div',{staticClass:"flex margin-top-5"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v("Результат")]),_vm._v(" "),_c('div',{class:['qwestion-result', {'err': !item.Correct }],staticStyle:{"width":"50%","text-align":"right"}},[_vm._v(_vm._s(item.Correct ? 'Верно': 'Не верно'))])]),_vm._v(" "),_c('div',{staticClass:"flex margin-top-2"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v("Время ответа")]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"right"}},[_vm._v(_vm._s(item.AnswerTime))])]),_vm._v(" "),(item.Balance)?_c('div',{staticClass:"flex margin-top-2"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v("Баллы")]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"right"}},[_vm._v(_vm._s(item.Balance.toFixed(0)))])]):_vm._e()]):_vm._e()})],2):_vm._e()])]):_vm._e()])])]:_vm._e(),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Тест"}})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test-result-body-text"},[_c('p',{staticClass:"caption-help"},[_vm._v("Топ-10 специалистов")]),_vm._v(" "),_c('p',{staticClass:"test-hello-text"},[_vm._v("Лучшие из лучших")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"heading"},[_c('th'),_vm._v(" "),_c('th',[_vm._v("#")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{attrs:{"align":"left"}},[_vm._v("ФИО")]),_vm._v(" "),_c('th',[_vm._v("Время теста")]),_vm._v(" "),_c('th',[_vm._v("Статистика ответов")]),_vm._v(" "),_c('th',[_vm._v("Итого баллов")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test-result-body-text"},[_c('p',{staticClass:"caption-help"},[_vm._v("Ваши ответы на вопросы")]),_vm._v(" "),_c('p',{staticClass:"test-hello-text"},[_vm._v("Статистика ответов")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"heading"},[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',{attrs:{"align":"left"}},[_vm._v("Вопрос")]),_vm._v(" "),_c('th',[_vm._v("Результат")]),_vm._v(" "),_c('th',[_vm._v("Время ответа")]),_vm._v(" "),_c('th',[_vm._v("Баланс")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MaterialTestResults_vue__ = __webpack_require__(257);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_713b5594_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MaterialTestResults_vue__ = __webpack_require__(677);
function injectStyle (ssrContext) {
  __webpack_require__(675)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-713b5594"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MaterialTestResults_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_713b5594_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MaterialTestResults_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(676);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("606fd6b4", content, true, {});

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[(_vm.material != null)?[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"btn-back"},[_c('router-link',{attrs:{"to":'/materials/' + _vm.$route.params.id}},[_vm._v("Назад к материалу")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page"},[_c('div',{staticClass:"body-panel page-content-block qwestions"},[(_vm.results != null)?_c('div',[_c('div',{staticClass:"test-result-header flex"},[_c('div',{class:['test-result-header-div', {'select': _vm.resultTabs.active === 'info'}],on:{"click":function($event){_vm.resultTabs.active='info'}}},[_vm._v("Результаты теста")]),_vm._v(" "),(_vm.material.TestDisplayRating)?_c('div',{class:['test-result-header-div', {'select': _vm.resultTabs.active === 'top'}],on:{"click":function($event){_vm.resultTabs.active='top'}}},[_vm._v("ТОП-10")]):_vm._e(),_vm._v(" "),(_vm.material.TestDisplayStats)?_c('div',{class:['test-result-header-div', {'select': _vm.resultTabs.active === 'answers'}],on:{"click":function($event){_vm.resultTabs.active='answers'}}},[_vm._v("Ваши ответы")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"test-result-body"},[_c('div',{style:({display: _vm.resultTabs.active === 'info' ? 'block' : 'none'})},[_c('div',{staticClass:"test-result-body-header flex"},[_c('div',{staticClass:"test-result-body-icon"},[(_vm.results.Complete)?_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#ResultOk"}})]):_vm._e(),_vm._v(" "),(!_vm.results.Complete)?_c('svg',{staticClass:"svg-icon err",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#ResultErr"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"test-result-body-text"},[_c('p',{staticClass:"caption-help"},[_vm._v("Тест завершён!")]),_vm._v(" "),(!_vm.results.Complete)?_c('p',{staticClass:"test-hello-text"},[_vm._v("Вы не сдали тест")]):_vm._e(),_vm._v(" "),(_vm.results.Complete)?_c('p',{staticClass:"test-hello-text"},[_vm._v("Вы сдали тест")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"test-stats-row flex margin-top-30"},[_c('div',{staticClass:"test-stats-cell"},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Time"}})]),_vm._v(" "),_c('p',{staticClass:"margin-top-10 caption-help"},[_vm._v("Время теста")]),_vm._v(" "),_c('p',{staticClass:"margin-top-5 p-header-1"},[_vm._v(_vm._s(_vm.results.TestTime))])]),_vm._v(" "),_c('div',{staticClass:"test-stats-cell"},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Hash"}})]),_vm._v(" "),_c('p',{staticClass:"margin-top-10 caption-help"},[_vm._v("Номер попытки")]),_vm._v(" "),_c('p',{staticClass:"margin-top-5 p-header-1"},[_vm._v(_vm._s(_vm.results.Attempt))])])]),_vm._v(" "),_c('div',{staticClass:"test-stats-row flex"},[_c('div',{staticClass:"test-stats-cell"},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Check"}})]),_vm._v(" "),_c('p',{staticClass:"margin-top-10 caption-help"},[_vm._v("Статистика ответов")]),_vm._v(" "),_c('p',{staticClass:"margin-top-5 p-header-1"},[_c('span',[_vm._v(_vm._s(_vm.results.QuestionsRight)+" ("+_vm._s(_vm.results.QuestionsRightPercent)+"%)")]),_vm._v(" / "+_vm._s(_vm.results.QuestionsRight + _vm.results.QuestionsWrong))])]),_vm._v(" "),(_vm.material.Bonus > 0 || _vm.results.BonusMessage != null)?_c('div',{staticClass:"test-stats-cell"},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Star"}})]),_vm._v(" "),_c('p',{staticClass:"margin-top-10 caption-help"},[_vm._v("Итого баллов")]),_vm._v(" "),_c('p',{staticClass:"margin-top-5 p-header-1"},[_vm._v(_vm._s(_vm.results.BonusMessage == null ? _vm.results.Bonus : _vm.results.BonusMessage))])]):_vm._e()])]),_vm._v(" "),(_vm.material.TestDisplayRating)?_c('div',{style:({display: _vm.resultTabs.active === 'top' ? 'block' : 'none'})},[_c('div',{staticClass:"test-result-body-header flex"},[_c('div',{staticClass:"test-result-body-icon"},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Cup"}})])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),(!_vm.isMobile)?_c('table',{staticClass:"table-view"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.results.Top10),function(item,i){return _c('tr',[_c('td',{staticClass:"result-icon",attrs:{"align":"center"}},[(item.Place === 1)?_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#gold-icon"}})]):_vm._e(),_vm._v(" "),(item.Place === 2)?_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#silver-icon"}})]):_vm._e(),_vm._v(" "),(item.Place === 3)?_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#bronze-icon"}})]):_vm._e()]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(item.Place))]),_vm._v(" "),_c('td',{staticClass:"img userimg",staticStyle:{"padding":"5px"},attrs:{"align":"center"}},[(item.UserImage != null)?_c('img',{attrs:{"src":'/uploads/users/' + item.UserImage}}):_vm._e(),_vm._v(" "),(item.UserImage === null)?_c('img',{attrs:{"src":__webpack_require__(55)}}):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.UserFio))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(item.TestTime))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(_vm.formatAnswerStats(item.QuestionsRight, item.QuestionsWrong)))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(item.Bonus))])])}),0)]):_vm._e(),_vm._v(" "),_vm._l((_vm.results.Top10),function(item,i){return (_vm.isMobile)?_c('div',{staticClass:"table-div"},[_c('div',{staticClass:"flex",staticStyle:{"font-size":"14px","font-weight":"600"}},[_c('div',{staticClass:"result-icon"},[(item.Place === 1)?_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#gold-icon"}})]):_vm._e(),_vm._v(" "),(item.Place === 2)?_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#silver-icon"}})]):_vm._e(),_vm._v(" "),(item.Place === 3)?_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#bronze-icon"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"width":"45px","min-width":"45px"}},[_vm._v(_vm._s(item.Place))]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_vm._v(_vm._s(item.UserFio))])]),_vm._v(" "),_c('div',{staticClass:"flex margin-top-5 caption-help"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v("Время")]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"right"}},[_vm._v(_vm._s(item.TestTime))])]),_vm._v(" "),_c('div',{staticClass:"flex margin-top-2 caption-help"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v("Ответы")]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"right"}},[_vm._v(_vm._s(_vm.formatAnswerStats(item.QuestionsRight, item.QuestionsWrong)))])]),_vm._v(" "),_c('div',{staticClass:"flex margin-top-2 caption-help"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v("Баллы")]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"right"}},[_vm._v(_vm._s(item.Bonus))])])]):_vm._e()})],2):_vm._e(),_vm._v(" "),(_vm.material.TestDisplayStats)?_c('div',{style:({display: _vm.resultTabs.active === 'answers' ? 'block' : 'none'})},[_c('div',{staticClass:"test-result-body-header flex"},[_c('div',{staticClass:"test-result-body-icon"},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Qwestion"}})])]),_vm._v(" "),_vm._m(2)]),_vm._v(" "),(!_vm.isMobile)?_c('table',{staticClass:"table-view"},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.results.Answers),function(item,i){return _c('tr',[_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.QuestionDescription))]),_vm._v(" "),_c('td',{class:['qwestion-result', {'err': !item.Correct }],attrs:{"align":"center"}},[_vm._v(_vm._s(item.Correct ? 'Верно': 'Не верно'))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(item.AnswerTime))]),_vm._v(" "),_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(item.Balance ? item.Balance.toFixed(0) : null))])])}),0)]):_vm._e(),_vm._v(" "),_vm._l((_vm.results.Answers),function(item,i){return (_vm.isMobile)?_c('div',{staticClass:"table-div"},[_c('div',{staticClass:"flex caption-help"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v("Вопрос")]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"right"}},[_vm._v("# "+_vm._s(i + 1))])]),_vm._v(" "),_c('div',{staticClass:"margin-top-5",staticStyle:{"font-size":"14px","font-weight":"600"}},[_vm._v("\n                                    "+_vm._s(item.QuestionDescription)+"\n                                ")]),_vm._v(" "),_c('div',{staticClass:"flex margin-top-5"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v("Результат")]),_vm._v(" "),_c('div',{class:['qwestion-result', {'err': !item.Correct }],staticStyle:{"width":"50%","text-align":"right"}},[_vm._v(_vm._s(item.Correct ? 'Верно': 'Не верно'))])]),_vm._v(" "),_c('div',{staticClass:"flex margin-top-2"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v("Время ответа")]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"right"}},[_vm._v(_vm._s(item.AnswerTime))])]),_vm._v(" "),(item.Balance)?_c('div',{staticClass:"flex margin-top-2"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v("Баллы")]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"right"}},[_vm._v(_vm._s(item.Balance.toFixed(0)))])]):_vm._e()]):_vm._e()})],2):_vm._e()])]):_vm._e()])])]:_vm._e(),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Результаты теста"}})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test-result-body-text"},[_c('p',{staticClass:"caption-help"},[_vm._v("Топ-10 специалистов")]),_vm._v(" "),_c('p',{staticClass:"test-hello-text"},[_vm._v("Лучшие из лучших")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"heading"},[_c('th'),_vm._v(" "),_c('th',[_vm._v("#")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{attrs:{"align":"left"}},[_vm._v("ФИО")]),_vm._v(" "),_c('th',[_vm._v("Время теста")]),_vm._v(" "),_c('th',[_vm._v("Статистика ответов")]),_vm._v(" "),_c('th',[_vm._v("Итого баллов")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test-result-body-text"},[_c('p',{staticClass:"caption-help"},[_vm._v("Ваши ответы на вопросы")]),_vm._v(" "),_c('p',{staticClass:"test-hello-text"},[_vm._v("Статистика ответов")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"heading"},[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',{attrs:{"align":"left"}},[_vm._v("Вопрос")]),_vm._v(" "),_c('th',[_vm._v("Результат")]),_vm._v(" "),_c('th',[_vm._v("Время ответа")]),_vm._v(" "),_c('th',[_vm._v("Баллы")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MaterialCertificate_vue__ = __webpack_require__(258);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fc6c642_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MaterialCertificate_vue__ = __webpack_require__(681);
function injectStyle (ssrContext) {
  __webpack_require__(679)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3fc6c642"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MaterialCertificate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fc6c642_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MaterialCertificate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(680);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4f77e7a7", content, true, {});

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel"},[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"btn-back margin-right-10"},[_c('a',{staticClass:"router-link-active",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.back.apply(null, arguments)}}},[_vm._v("Назад")])])])]),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[_c('div',{staticClass:"btns flex"},[_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.onExport()}}},[_vm._v("\n                    Экспорт\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"body-panel-control-separator"},[_c('complex-filter',{ref:"complexFilter",attrs:{"filters":_vm.filters,"searchFunction":_vm.searchFunction,"tableName":'[dbo].[FakeTable]',"withTableNameInClause":true,"getByIdFilters":['User','OrderStatus']},on:{"onFilterChange":_vm.onFilterChange}})],1)]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page scroll-x-ok",on:{"scroll":_vm.onScroll}},[_c('table',{staticClass:"table-view",attrs:{"cellspacing":"0"}},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.users),function(user,i){return _c('tr',[_c('td',{staticClass:"string"},[_vm._v(_vm._s(user.UserFIO))]),_vm._v(" "),_c('td',{staticClass:"string"},[_vm._v(_vm._s(user.MaterialName))]),_vm._v(" "),_c('td',{staticClass:"datetime-2"},[_c('p',{staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(_vm.formatDateLong(user.StartDate)))])]),_vm._v(" "),_c('td',{staticClass:"datetime-2"},[_c('p',{staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(_vm.formatDateLong(user.CreationDate)))])]),_vm._v(" "),_c('td',{staticClass:"datetime-2"},[_c('p',{staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(_vm.formatDateLong(user.DownloadDate)))])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"btns flex"},[_c('input',{ref:'dropFiles' + i,refInFor:true,staticClass:"file-upload-zone-btn",attrs:{"type":"file","accept":".pdf","id":'dropFiles' + i,"name":'dropFiles' + i},on:{"change":function($event){return _vm.onCertificateChange(user.SessionId, 'dropFiles' + i, user.UserId, user.MaterialName)}}}),_vm._v(" "),(user.CreationDate)?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onCertificateDelete(user.SessionId)}}},[_vm._v("Удалить")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onCertificateClick('dropFiles' + i)}}},[_vm._v(_vm._s(user.CreationDate ? 'Заменить' : 'Выбрать'))]),_vm._v(" "),(user.CreationDate)?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onCertificateDownload(user.SessionId)}}},[_vm._v("Посмотреть")]):_vm._e()])])])}),0)])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Выдача сертификатов"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticStyle:{"display":"table-header-group !important"}},[_c('tr',{staticClass:"heading"},[_c('th',[_vm._v("ФИО")]),_vm._v(" "),_c('th',[_vm._v("Название курса")]),_vm._v(" "),_c('th',[_vm._v("Дата сдачи")]),_vm._v(" "),_c('th',[_vm._v("Дата выдачи сертификата")]),_vm._v(" "),_c('th',[_vm._v("Дата скачивания сертификата")]),_vm._v(" "),_c('th',[_vm._v("Управление сертификатом")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TestOkko_vue__ = __webpack_require__(259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c4dbf7d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TestOkko_vue__ = __webpack_require__(685);
function injectStyle (ssrContext) {
  __webpack_require__(683)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c4dbf7d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TestOkko_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c4dbf7d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TestOkko_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(684);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("7a0fd2e7", content, true, {});

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{ref:"frame",attrs:{"width":"100%","height":"600px","src":"/Content/Okko/story_html5.html"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(260);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fb30397_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(689);
function injectStyle (ssrContext) {
  __webpack_require__(687)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6fb30397"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fb30397_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(688);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("27130c8d", content, true, {});

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".external-items a[data-v-6fb30397]{display:inline-block;margin-right:15px}.password-field[data-v-6fb30397]{position:relative}.toggle-password[data-v-6fb30397]{position:absolute;right:20px;top:20px;cursor:pointer}.fa-eye-slash[data-v-6fb30397],.fa-eye[data-v-6fb30397]{font-size:1.6em}", ""]);

// exports


/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel"},[_c('div',{staticClass:"body-panel-content"},[_c('div',{staticClass:"body-panel-content-start flex"},[_c('div',{staticClass:"login-page-bg"}),_vm._v(" "),_c('div',{staticClass:"login-page"},[(_vm.info.StartImage != null)?_c('div',{staticClass:"login-logo"},[_c('img',{staticClass:"login-logo-img",attrs:{"src":_vm.info.StartImage}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"login"},[_c('div',{staticClass:"form-header"},[_vm._v("\n                        Авторизация\n                    ")]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.UserName),expression:"UserName"}],staticClass:"input-text",class:['input-text', {'input-error': _vm.errors.has('UserName')}],attrs:{"id":"UserName","name":"UserName","placeholder":"Логин или email","type":"text","data-vv-as":"Логин"},domProps:{"value":(_vm.UserName)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.UserName=$event.target.value},function($event){_vm.error = null}]}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('UserName')))])]),_vm._v(" "),_c('div',{staticClass:"form-field password-field"},[((_vm.showPassword ? 'text' : 'password')==='checkbox')?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.Password),expression:"Password"}],staticClass:"input-text",class:['input-text', {'input-error': _vm.errors.has('Password')}],attrs:{"id":"Password","name":"Password","placeholder":"Пароль","data-vv-as":"Пароль","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.Password)?_vm._i(_vm.Password,null)>-1:(_vm.Password)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.logIn.apply(null, arguments)},"change":function($event){var $$a=_vm.Password,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.Password=$$a.concat([$$v]))}else{$$i>-1&&(_vm.Password=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.Password=$$c}}}}):((_vm.showPassword ? 'text' : 'password')==='radio')?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.Password),expression:"Password"}],staticClass:"input-text",class:['input-text', {'input-error': _vm.errors.has('Password')}],attrs:{"id":"Password","name":"Password","placeholder":"Пароль","data-vv-as":"Пароль","type":"radio"},domProps:{"checked":_vm._q(_vm.Password,null)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.logIn.apply(null, arguments)},"change":function($event){_vm.Password=null}}}):_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.Password),expression:"Password"}],staticClass:"input-text",class:['input-text', {'input-error': _vm.errors.has('Password')}],attrs:{"id":"Password","name":"Password","placeholder":"Пароль","data-vv-as":"Пароль","type":_vm.showPassword ? 'text' : 'password'},domProps:{"value":(_vm.Password)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.logIn.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.Password=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"toggle-password",on:{"click":_vm.togglePasswordVisibility}},[_c('i',{class:_vm.showPassword ? 'fa fa-eye-slash' : 'fa fa-eye',attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Password'))+_vm._s(_vm.error))])]),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('input',{staticClass:"input-checkbox",attrs:{"id":"rememberMe","name":"rememberMe","value":"true","type":"checkbox","checked":""}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"rememberMe"}},[_vm._v("Запомнить")]),_vm._v(" "),_c('router-link',{staticClass:"forgot-password",attrs:{"to":"/forgot"}},[_vm._v("Забыли пароль?")]),_vm._v(" "),_c('div',{staticClass:"form-btns btns"},[_c('button',{staticClass:"btn btn-primary auth",attrs:{"type":"submit"},on:{"click":_vm.logIn}},[_vm._v("\n                                Войти\n                            ")])]),_vm._v(" "),(_vm.external.length > 0)?_c('div',{staticClass:"margin-top-10 flex"},[_c('p',{staticStyle:{"font-size":"16px","color":"#8198AE","width":"100%"}},[_vm._v("или войдите через")]),_vm._v(" "),_c('div',{staticClass:"external-items margin-left-10",staticStyle:{"white-space":"nowrap"}},_vm._l((_vm.external),function(provider){return _c('a',{attrs:{"href":provider.attachLink}},[_c('i',{class:provider.cssClass,attrs:{"aria-hidden":"true"}})])}),0)]):_vm._e(),_vm._v(" "),(_vm.info.RegisterSettings.Enabled)?_c('div',{staticClass:"reglink margin-top-20"},[_c('p',[_vm._v("Не зарегистрированы? "),_c('span',{on:{"click":function($event){return _vm.$router.push('/register')}}},[_vm._v("Регистрация")])])]):_vm._e()],1)])])])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Авторизация"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__ = __webpack_require__(261);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e4f0bc2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__ = __webpack_require__(693);
function injectStyle (ssrContext) {
  __webpack_require__(691)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e4f0bc2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e4f0bc2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(692);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("8c077f7c", content, true, {});

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel"},[_c('div',{staticClass:"body-panel-content"},[_c('div',{staticClass:"body-panel-content-start flex"},[_c('div',{staticClass:"login-page-bg"}),_vm._v(" "),_c('div',{staticClass:"login-page"},[(_vm.info.Image != null)?_c('div',{staticClass:"login-logo"},[_c('img',{staticClass:"login-logo-img",attrs:{"src":'/uploads/projects/' + (_vm.info.StartImage ? _vm.info.StartImage: _vm.info.Image)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"login"},[(_vm.result == null)?[_c('div',{staticClass:"form-header"},[_vm._v("\n                            Восстановление пароля\n                        ")]),_vm._v(" "),_c('div',{staticClass:"auth-content-block"},[_vm._v("\n                            Введите email, указанный при регистрации\n                        ")]),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-20"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.Email),expression:"Email"}],staticClass:"input-text",class:['input-text', {'input-error': _vm.errors.has('Email')}],attrs:{"id":"Email","name":"Email","placeholder":"Email","type":"text","data-vv-as":"Email"},domProps:{"value":(_vm.Email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.Email=$event.target.value},function($event){_vm.error = null}]}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Email'))+_vm._s(_vm.error))])]),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('div',{staticClass:"form-btns"},[_c('button',{staticClass:"btn btn-primary auth",attrs:{"type":"button"},on:{"click":function($event){return _vm.recover()}}},[_vm._v("\n                                    Восстановить\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"reglink margin-top-20"},[_c('p',[_vm._v("Вспомнили пароль? "),_c('span',{on:{"click":function($event){return _vm.$router.push('/login')}}},[_vm._v("Войти")])])])]:_vm._e(),_vm._v(" "),(_vm.result != null)?[_c('div',{staticClass:"auth-content-block margin-bottom-20"},[_vm._v("\n                            Инструкции отправлены на email\n                        ")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/login"}},[_vm._v("Авторизация")])]:_vm._e()],2)])])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Забыли пароль?"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__(262);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c1b3afa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__(697);
function injectStyle (ssrContext) {
  __webpack_require__(695)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c1b3afa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c1b3afa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(696);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2471f518", content, true, {});

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel"},[_c('div',{staticClass:"body-panel-content"},[_c('div',{staticClass:"body-panel-content-start flex"},[_c('div',{staticClass:"login-page-bg"}),_vm._v(" "),_c('div',{staticClass:"login-page"},[(_vm.info.StartImage != null)?_c('div',{staticClass:"login-logo"},[_c('img',{staticClass:"login-logo-img",attrs:{"src":_vm.info.StartImage}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"login"},[(_vm.result != null)?[_c('div',{staticClass:"form-header"},[_vm._v("\n                            Авторизация\n                        ")]),_vm._v(" "),_c('div',{staticClass:"auth-content-block"},[_c('div',{staticClass:"form-field"},[_c('b',[_vm._v("Логин:")]),_vm._v(" "+_vm._s(_vm.result.login)+"\n                            ")]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('b',[_vm._v("Пароль:")]),_vm._v(" "+_vm._s(_vm.result.password)+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"form-actions margin-top-20"},[_c('div',{staticClass:"form-btns"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"},on:{"click":function($event){return _vm.$router.push('/login')}}},[_vm._v("\n                                    Авторизация\n                                ")])])])]:_vm._e()],2)])])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Забыли пароль?"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserConfirm_vue__ = __webpack_require__(263);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b1c085a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserConfirm_vue__ = __webpack_require__(701);
function injectStyle (ssrContext) {
  __webpack_require__(699)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b1c085a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserConfirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b1c085a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserConfirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(700);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("62d09797", content, true, {});

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel"},[_c('div',{staticClass:"body-panel-content"},[_c('div',{staticClass:"body-panel-content-start flex"},[_c('div',{staticClass:"login-page-bg"}),_vm._v(" "),_c('div',{staticClass:"login-page"},[(_vm.info.StartImage != null)?_c('div',{staticClass:"login-logo"},[_c('img',{staticClass:"login-logo-img",attrs:{"src":_vm.info.StartImage}})]):_vm._e(),_vm._v(" "),(_vm.result != null)?_c('div',{staticClass:"login"},[(_vm.status === 2)?_c('div',[_c('div',{staticClass:"form-header"},[_vm._v("\n                            Ваш email успешно подтверждён!\n                        ")]),_vm._v(" "),_c('div',{staticClass:"auth-content-block"},[_vm._v("\n                            Теперь вы можете авторизоваться, используя свои данные для входа.\n                        ")]),_vm._v(" "),_c('div',{staticClass:"form-actions form-btns"},[_c('router-link',{attrs:{"to":"/login"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"}},[_vm._v("\n                                    Авторизация\n                                ")])])],1)]):_c('div',[_c('div',{staticClass:"form-header"},[_vm._v("\n                            Спасибо за регистрацию!\n                        ")]),_vm._v(" "),_c('div',{staticClass:"auth-content-block"},[_vm._v("\n                            В ближайшее время ваши данные проверит Администратор, после чего вы получите уведомление на email и сможете авторизоваться.\n                        ")])])]):_vm._e()])])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Подтверждение email"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__(264);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ba61c3a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__(709);
function injectStyle (ssrContext) {
  __webpack_require__(703)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ba61c3a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(704);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1942401e", content, true, {});

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".dropdown-block{height:60px}.dropdown-block a{padding-top:15px!important;text-overflow:ellipsis;overflow:hidden}.dropdown-menu-open .dropdown-list{right:0;left:auto}.register-fields{display:block;padding:0 10px 0 0}.password-field,.register-fields{position:relative}.toggle-password{position:absolute;right:20px;top:20px;cursor:pointer}.fa-eye,.fa-eye-slash{font-size:1.4em}", ""]);

// exports


/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CitySearch_vue__ = __webpack_require__(266);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68e08e60_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CitySearch_vue__ = __webpack_require__(708);
function injectStyle (ssrContext) {
  __webpack_require__(706)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68e08e60"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CitySearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68e08e60_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CitySearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(707);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("f76e7c12", content, true, {});

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-search",class:{ 'dropdown-menu-open': _vm.dropDownOpen}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],class:['input-text', {'input-error': _vm.hasErrors}],attrs:{"name":_vm.name,"type":"text","placeholder":'Введите город',"autocomplete":"off","disabled":_vm.disabled},domProps:{"value":(_vm.searchText)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value},_vm.onSearchInput],"blur":_vm.onBlur,"focus":_vm.onFocus}}),_vm._v(" "),(true)?_c('div',{staticClass:"dropdown-menu dropdown-list",staticStyle:{"max-width":"100%"}},_vm._l((_vm.filteredCities),function(item,index){return _c('a',{key:index,staticClass:"dropdown-menu-item",on:{"click":function($event){return _vm.onSelectCity(item)}}},[_c('span',[_vm._v(_vm._s(item.Name))])])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel"},[_c('div',{staticClass:"body-panel-content"},[_c('div',{staticClass:"body-panel-content-start flex"},[_c('div',{staticClass:"login-page-bg"}),_vm._v(" "),_c('div',{staticClass:"login-page"},[(_vm.info.Image != null)?_c('div',{staticClass:"login-logo"},[_c('img',{staticClass:"login-logo-img",attrs:{"src":(_vm.info.StartImage ? _vm.info.StartImage: _vm.info.Image)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"register"},[_c('div',{staticClass:"login"},[(_vm.result == null)?[(_vm.totalSteps > 1)?_c('div',{staticClass:"form-header"},[_vm._v("\n                                Регистрация шаг "+_vm._s(_vm.currentStep)+" из "+_vm._s(_vm.totalSteps)+"\n                            ")]):_vm._e(),_vm._v(" "),(_vm.isDaccord)?_c('div',[(_vm.currentStep === 1)?_c('div',{staticClass:"register-fields margin-bottom-15"},[_vm._l((_vm.currentRegFields),function(item,i){return _c('div',{key:i,staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                              "+_vm._s(item.FieldName)+"\n                                          ")]),_vm._v(" "),(item.isTradePoint)?_c('div',[(_vm.info.RegisterSettings.RegisterTradePointType === _vm.RegisterTradePointTypes.Text)?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.user.TradePointName),expression:"user.TradePointName"}],class:['input-text', {'input-error': _vm.errors.has('TradePointName')}],attrs:{"name":"TradePointName","type":"text"},domProps:{"value":(_vm.user.TradePointName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "TradePointName", $event.target.value)}}}):(_vm.info.RegisterSettings.RegisterTradePointType === _vm.RegisterTradePointTypes.Select)?_c('search-filter',{directives:[{name:"validate",rawName:"v-validate",value:({ rules: { required: true} }),expression:"{ rules: { required: true} }"}],attrs:{"name":'TradePointName',"hasErrors":_vm.errors.has('TradePointName'),"extra":0,"searchFunction":_vm.searchTPFunction,"selectedItem":_vm.getSkuSelectedItem(_vm.tradePointSelected),"searchOnSelect":true,"scrollable":true},on:{"onFilterChange":function($event){return _vm.onChangeTPLinkSearch.apply(void 0, arguments)}}}):_vm._e()],1):(item.FieldName.includes('Введите ГОРОД'))?_c('div',[_c('city-search',{directives:[{name:"validate",rawName:"v-validate",value:({ rules: { required: true} }),expression:"{ rules: { required: true} }"}],attrs:{"name":'fieldName' + i,"selectedCity":_vm.selectedCity,"hasErrors":_vm.errors.has('fieldName' + i)},on:{"update:selectedCity":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
return _vm.onCitySelected.apply(void 0, argsArray.concat( [item.FieldName] ))}}})],1):_c('div',[(item.FieldType === 'text')?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(item.Value),expression:"item.Value"}],class:['input-text', {'input-error': _vm.errors.has('fieldName' + i)}],attrs:{"name":'fieldName' + i,"type":"text"},domProps:{"value":(item.Value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "Value", $event.target.value)}}}):(item.FieldType === 'select')?_c('drop-down',{attrs:{"items":item.optionsItems,"dataField":'Value',"textField":'Name'},model:{value:(item.Value),callback:function ($$v) {_vm.$set(item, "Value", $$v)},expression:"item.Value"}}):_vm._e()],1)])])}),_vm._v(" "),(_vm.totalSteps > 1)?_c('div',{staticClass:"form-actions"},[_c('div',{staticClass:"form-btns btns flex"},[_c('button',{staticClass:"btn btn-primary auth",attrs:{"type":"button"},on:{"click":function($event){return _vm.nextStep()}}},[_vm._v("\n                                              Далее\n                                          ")])])]):_vm._e()],2):(_vm.currentStep > 1 && _vm.currentStep < _vm.totalSteps)?_c('div',{staticClass:"register-fields margin-bottom-15"},[_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"},{name:"model",rawName:"v-model",value:(_vm.user.Email),expression:"user.Email"}],class:['input-text', {'input-error': _vm.errors.has('UserEmail')}],attrs:{"name":"UserEmail","type":"text","placeholder":"Email","data-vv-as":"Email"},domProps:{"value":(_vm.user.Email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "Email", $event.target.value)},function($event){_vm.error = null}]}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('UserEmail')))]),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"text","name":"Email"}}),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"password","name":"Password"}})])]),_vm._v(" "),_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field password-field"},[((_vm.showPassword ? 'text' : 'password')==='checkbox')?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.user.Password),expression:"user.Password"}],class:['input-text', {'input-error': _vm.errors.has('UserPassword')}],attrs:{"name":"UserPassword","placeholder":"Пароль","data-vv-as":"Пароль","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.user.Password)?_vm._i(_vm.user.Password,null)>-1:(_vm.user.Password)},on:{"input":_vm.onNewPasswordChange,"change":function($event){var $$a=_vm.user.Password,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.user, "Password", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.user, "Password", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.user, "Password", $$c)}}}}):((_vm.showPassword ? 'text' : 'password')==='radio')?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.user.Password),expression:"user.Password"}],class:['input-text', {'input-error': _vm.errors.has('UserPassword')}],attrs:{"name":"UserPassword","placeholder":"Пароль","data-vv-as":"Пароль","type":"radio"},domProps:{"checked":_vm._q(_vm.user.Password,null)},on:{"input":_vm.onNewPasswordChange,"change":function($event){return _vm.$set(_vm.user, "Password", null)}}}):_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.user.Password),expression:"user.Password"}],class:['input-text', {'input-error': _vm.errors.has('UserPassword')}],attrs:{"name":"UserPassword","placeholder":"Пароль","data-vv-as":"Пароль","type":_vm.showPassword ? 'text' : 'password'},domProps:{"value":(_vm.user.Password)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "Password", $event.target.value)},_vm.onNewPasswordChange]}}),_vm._v(" "),_c('span',{staticClass:"toggle-password",on:{"click":_vm.togglePasswordVisibility}},[_c('i',{class:_vm.showPassword ? 'fa fa-eye-slash' : 'fa fa-eye',attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('UserPassword'))+_vm._s(_vm.passwordError))])]),_vm._v(" "),_c('div',{staticClass:"form-field password-field"},[((_vm.showPassword ? 'text' : 'password')==='checkbox')?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, confirmed: _vm.user.Password}),expression:"{required: true, confirmed: user.Password}"},{name:"model",rawName:"v-model",value:(_vm.user.PasswordConfirm),expression:"user.PasswordConfirm"}],class:['input-text', {'input-error': _vm.errors.has('PasswordConfirm')}],attrs:{"name":"PasswordConfirm","placeholder":"Повторите пароль","data-vv-as":"Повторите пароль","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.user.PasswordConfirm)?_vm._i(_vm.user.PasswordConfirm,null)>-1:(_vm.user.PasswordConfirm)},on:{"change":function($event){var $$a=_vm.user.PasswordConfirm,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.user, "PasswordConfirm", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.user, "PasswordConfirm", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.user, "PasswordConfirm", $$c)}}}}):((_vm.showPassword ? 'text' : 'password')==='radio')?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, confirmed: _vm.user.Password}),expression:"{required: true, confirmed: user.Password}"},{name:"model",rawName:"v-model",value:(_vm.user.PasswordConfirm),expression:"user.PasswordConfirm"}],class:['input-text', {'input-error': _vm.errors.has('PasswordConfirm')}],attrs:{"name":"PasswordConfirm","placeholder":"Повторите пароль","data-vv-as":"Повторите пароль","type":"radio"},domProps:{"checked":_vm._q(_vm.user.PasswordConfirm,null)},on:{"change":function($event){return _vm.$set(_vm.user, "PasswordConfirm", null)}}}):_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, confirmed: _vm.user.Password}),expression:"{required: true, confirmed: user.Password}"},{name:"model",rawName:"v-model",value:(_vm.user.PasswordConfirm),expression:"user.PasswordConfirm"}],class:['input-text', {'input-error': _vm.errors.has('PasswordConfirm')}],attrs:{"name":"PasswordConfirm","placeholder":"Повторите пароль","data-vv-as":"Повторите пароль","type":_vm.showPassword ? 'text' : 'password'},domProps:{"value":(_vm.user.PasswordConfirm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "PasswordConfirm", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"toggle-password",on:{"click":_vm.togglePasswordVisibility}},[_c('i',{class:_vm.showPassword ? 'fa fa-eye-slash' : 'fa fa-eye',attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('PasswordConfirm')))])])]),_vm._v(" "),_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.user.FirstName),expression:"user.FirstName"}],class:['input-text', {'input-error': _vm.errors.has('FirstName')}],attrs:{"name":"FirstName","type":"text","placeholder":"Имя","data-vv-as":"Имя"},domProps:{"value":(_vm.user.FirstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "FirstName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('FirstName')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.user.LastName),expression:"user.LastName"}],class:['input-text', {'input-error': _vm.errors.has('LastName')}],attrs:{"name":"LastName","type":"text","placeholder":"Фамилия","data-vv-as":"Фамилия"},domProps:{"value":(_vm.user.LastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "LastName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('LastName')))])])]),_vm._v(" "),_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.MiddleName),expression:"user.MiddleName"}],staticClass:"input-text",attrs:{"name":"MiddleName","type":"text","placeholder":"Отчество"},domProps:{"value":(_vm.user.MiddleName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "MiddleName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('MiddleName')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('the-mask',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, regex: /^\d{11,}$/ }),expression:"{ required: true, regex: /^\\d{11,}$/ }"}],class:['input-text', {'input-error': _vm.errors.has('PhoneNumber')}],attrs:{"name":"PhoneNumber","placeholder":"Телефон","mask":['### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ###'],"data-vv-as":"Телефон"},model:{value:(_vm.user.PhoneNumber),callback:function ($$v) {_vm.$set(_vm.user, "PhoneNumber", $$v)},expression:"user.PhoneNumber"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('PhoneNumber')))])],1)]),_vm._v(" "),_vm._l((_vm.currentRegFields),function(item,i){return _c('div',{key:i,staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                              "+_vm._s(item.FieldName)+"\n                                          ")]),_vm._v(" "),(item.isTradePoint)?_c('div',[(_vm.info.RegisterSettings.RegisterTradePointType === _vm.RegisterTradePointTypes.Text)?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.user.TradePointName),expression:"user.TradePointName"}],class:['input-text', {'input-error': _vm.errors.has('TradePointName')}],attrs:{"name":"TradePointName","type":"text"},domProps:{"value":(_vm.user.TradePointName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "TradePointName", $event.target.value)}}}):(_vm.info.RegisterSettings.RegisterTradePointType === _vm.RegisterTradePointTypes.Select)?_c('search-filter',{directives:[{name:"validate",rawName:"v-validate",value:({ rules: { required: true} }),expression:"{ rules: { required: true} }"}],attrs:{"name":'TradePointName',"hasErrors":_vm.errors.has('TradePointName'),"extra":0,"searchFunction":_vm.searchTPFunction,"selectedItem":_vm.getSkuSelectedItem(_vm.tradePointSelected),"searchOnSelect":true,"scrollable":true},on:{"onFilterChange":function($event){return _vm.onChangeTPLinkSearch.apply(void 0, arguments)}}}):_vm._e()],1):_c('div',[(item.FieldType === 'text')?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(item.Value),expression:"item.Value"}],class:['input-text', {'input-error': _vm.errors.has('fieldName' + i)}],attrs:{"name":'fieldName' + i,"type":"text"},domProps:{"value":(item.Value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "Value", $event.target.value)}}}):(item.FieldType === 'select')?_c('drop-down',{attrs:{"items":item.optionsItems,"dataField":'Value',"textField":'Name'},model:{value:(item.Value),callback:function ($$v) {_vm.$set(item, "Value", $$v)},expression:"item.Value"}}):_vm._e()],1)])])}),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('div',{staticClass:"form-btns btns flex"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.prevStep()}}},[_vm._v("\n                                              Назад\n                                          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary auth",attrs:{"type":"button"},on:{"click":function($event){return _vm.nextStep()}}},[_vm._v("\n                                              Далее\n                                          ")])])])],2):_vm._e()]):_c('div',[(_vm.currentStep === 1)?_c('div',{staticClass:"register-fields margin-bottom-15"},[_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"},{name:"model",rawName:"v-model",value:(_vm.user.Email),expression:"user.Email"}],class:['input-text', {'input-error': _vm.errors.has('UserEmail')}],attrs:{"name":"UserEmail","type":"text","placeholder":"Email","data-vv-as":"Email"},domProps:{"value":(_vm.user.Email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "Email", $event.target.value)},function($event){_vm.error = null}]}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('UserEmail')))]),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"text","name":"Email"}}),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"password","name":"Password"}})])]),_vm._v(" "),_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field password-field"},[((_vm.showPassword ? 'text' : 'password')==='checkbox')?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.user.Password),expression:"user.Password"}],class:['input-text', {'input-error': _vm.errors.has('UserPassword')}],attrs:{"name":"UserPassword","placeholder":"Пароль","data-vv-as":"Пароль","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.user.Password)?_vm._i(_vm.user.Password,null)>-1:(_vm.user.Password)},on:{"input":_vm.onNewPasswordChange,"change":function($event){var $$a=_vm.user.Password,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.user, "Password", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.user, "Password", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.user, "Password", $$c)}}}}):((_vm.showPassword ? 'text' : 'password')==='radio')?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.user.Password),expression:"user.Password"}],class:['input-text', {'input-error': _vm.errors.has('UserPassword')}],attrs:{"name":"UserPassword","placeholder":"Пароль","data-vv-as":"Пароль","type":"radio"},domProps:{"checked":_vm._q(_vm.user.Password,null)},on:{"input":_vm.onNewPasswordChange,"change":function($event){return _vm.$set(_vm.user, "Password", null)}}}):_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.user.Password),expression:"user.Password"}],class:['input-text', {'input-error': _vm.errors.has('UserPassword')}],attrs:{"name":"UserPassword","placeholder":"Пароль","data-vv-as":"Пароль","type":_vm.showPassword ? 'text' : 'password'},domProps:{"value":(_vm.user.Password)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "Password", $event.target.value)},_vm.onNewPasswordChange]}}),_vm._v(" "),_c('span',{staticClass:"toggle-password",on:{"click":_vm.togglePasswordVisibility}},[_c('i',{class:_vm.showPassword ? 'fa fa-eye-slash' : 'fa fa-eye',attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('UserPassword'))+_vm._s(_vm.passwordError))])]),_vm._v(" "),_c('div',{staticClass:"form-field password-field"},[((_vm.showPassword ? 'text' : 'password')==='checkbox')?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, confirmed: _vm.user.Password}),expression:"{required: true, confirmed: user.Password}"},{name:"model",rawName:"v-model",value:(_vm.user.PasswordConfirm),expression:"user.PasswordConfirm"}],class:['input-text', {'input-error': _vm.errors.has('PasswordConfirm')}],attrs:{"name":"PasswordConfirm","placeholder":"Повторите пароль","data-vv-as":"Повторите пароль","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.user.PasswordConfirm)?_vm._i(_vm.user.PasswordConfirm,null)>-1:(_vm.user.PasswordConfirm)},on:{"change":function($event){var $$a=_vm.user.PasswordConfirm,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.user, "PasswordConfirm", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.user, "PasswordConfirm", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.user, "PasswordConfirm", $$c)}}}}):((_vm.showPassword ? 'text' : 'password')==='radio')?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, confirmed: _vm.user.Password}),expression:"{required: true, confirmed: user.Password}"},{name:"model",rawName:"v-model",value:(_vm.user.PasswordConfirm),expression:"user.PasswordConfirm"}],class:['input-text', {'input-error': _vm.errors.has('PasswordConfirm')}],attrs:{"name":"PasswordConfirm","placeholder":"Повторите пароль","data-vv-as":"Повторите пароль","type":"radio"},domProps:{"checked":_vm._q(_vm.user.PasswordConfirm,null)},on:{"change":function($event){return _vm.$set(_vm.user, "PasswordConfirm", null)}}}):_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, confirmed: _vm.user.Password}),expression:"{required: true, confirmed: user.Password}"},{name:"model",rawName:"v-model",value:(_vm.user.PasswordConfirm),expression:"user.PasswordConfirm"}],class:['input-text', {'input-error': _vm.errors.has('PasswordConfirm')}],attrs:{"name":"PasswordConfirm","placeholder":"Повторите пароль","data-vv-as":"Повторите пароль","type":_vm.showPassword ? 'text' : 'password'},domProps:{"value":(_vm.user.PasswordConfirm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "PasswordConfirm", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"toggle-password",on:{"click":_vm.togglePasswordVisibility}},[_c('i',{class:_vm.showPassword ? 'fa fa-eye-slash' : 'fa fa-eye',attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('PasswordConfirm')))])])]),_vm._v(" "),_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.user.FirstName),expression:"user.FirstName"}],class:['input-text', {'input-error': _vm.errors.has('FirstName')}],attrs:{"name":"FirstName","type":"text","placeholder":"Имя","data-vv-as":"Имя"},domProps:{"value":(_vm.user.FirstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "FirstName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('FirstName')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.user.LastName),expression:"user.LastName"}],class:['input-text', {'input-error': _vm.errors.has('LastName')}],attrs:{"name":"LastName","type":"text","placeholder":"Фамилия","data-vv-as":"Фамилия"},domProps:{"value":(_vm.user.LastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "LastName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('LastName')))])])]),_vm._v(" "),_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.MiddleName),expression:"user.MiddleName"}],staticClass:"input-text",attrs:{"name":"MiddleName","type":"text","placeholder":"Отчество"},domProps:{"value":(_vm.user.MiddleName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "MiddleName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('MiddleName')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('the-mask',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, regex: /^\d{11,}$/ }),expression:"{ required: true, regex: /^\\d{11,}$/ }"}],class:['input-text', {'input-error': _vm.errors.has('PhoneNumber')}],attrs:{"name":"PhoneNumber","placeholder":"Телефон","mask":['### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ###'],"data-vv-as":"Телефон"},model:{value:(_vm.user.PhoneNumber),callback:function ($$v) {_vm.$set(_vm.user, "PhoneNumber", $$v)},expression:"user.PhoneNumber"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('PhoneNumber')))])],1)]),_vm._v(" "),(_vm.totalSteps > 1)?_c('div',{staticClass:"form-actions"},[_c('div',{staticClass:"form-btns btns flex"},[_c('button',{staticClass:"btn btn-primary auth",attrs:{"type":"button"},on:{"click":function($event){return _vm.nextStep()}}},[_vm._v("\n                                            Далее\n                                        ")])])]):_vm._e()]):(_vm.currentStep > 1 && _vm.currentStep < _vm.totalSteps)?_c('div',{staticClass:"register-fields margin-bottom-15"},[_vm._l((_vm.currentRegFields),function(item,i){return _c('div',{key:i,staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                            "+_vm._s(item.FieldName)+"\n                                        ")]),_vm._v(" "),(item.isTradePoint)?_c('div',[(_vm.info.RegisterSettings.RegisterTradePointType === _vm.RegisterTradePointTypes.Text)?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.user.TradePointName),expression:"user.TradePointName"}],class:['input-text', {'input-error': _vm.errors.has('TradePointName')}],attrs:{"name":"TradePointName","type":"text"},domProps:{"value":(_vm.user.TradePointName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "TradePointName", $event.target.value)}}}):(_vm.info.RegisterSettings.RegisterTradePointType === _vm.RegisterTradePointTypes.Select)?_c('search-filter',{directives:[{name:"validate",rawName:"v-validate",value:({ rules: { required: true} }),expression:"{ rules: { required: true} }"}],attrs:{"name":'TradePointName',"hasErrors":_vm.errors.has('TradePointName'),"extra":0,"searchFunction":_vm.searchTPFunction,"selectedItem":_vm.getSkuSelectedItem(_vm.tradePointSelected),"searchOnSelect":true,"scrollable":true},on:{"onFilterChange":function($event){return _vm.onChangeTPLinkSearch.apply(void 0, arguments)}}}):_vm._e()],1):_c('div',[(item.FieldType === 'text')?_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(item.Value),expression:"item.Value"}],class:['input-text', {'input-error': _vm.errors.has('fieldName' + i)}],attrs:{"name":'fieldName' + i,"type":"text"},domProps:{"value":(item.Value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "Value", $event.target.value)}}}):(item.FieldType === 'select')?_c('drop-down',{attrs:{"items":item.optionsItems,"dataField":'Value',"textField":'Name'},model:{value:(item.Value),callback:function ($$v) {_vm.$set(item, "Value", $$v)},expression:"item.Value"}}):_vm._e()],1)])])}),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('div',{staticClass:"form-btns btns flex"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.prevStep()}}},[_vm._v("\n                                            Назад\n                                        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary auth",attrs:{"type":"button"},on:{"click":function($event){return _vm.nextStep()}}},[_vm._v("\n                                            Далее\n                                        ")])])])],2):_vm._e()]),_vm._v(" "),(_vm.currentStep === _vm.totalSteps)?_c('div',[_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.NotificationsEnabled),expression:"user.NotificationsEnabled"}],staticClass:"input-checkbox",attrs:{"id":"NotificationsEnabled","name":"NotificationsEnabled","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.user.NotificationsEnabled)?_vm._i(_vm.user.NotificationsEnabled,"true")>-1:(_vm.user.NotificationsEnabled)},on:{"change":function($event){var $$a=_vm.user.NotificationsEnabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.user, "NotificationsEnabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.user, "NotificationsEnabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.user, "NotificationsEnabled", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"NotificationsEnabled"}},[_vm._v("\n                                        Я хочу получать\n                                        новости и оповещения по email и\n                                        sms\n                                    ")])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.TermsConfirmed),expression:"user.TermsConfirmed"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"input-checkbox",attrs:{"id":"TermsConfirmed","name":"TermsConfirmed","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.user.TermsConfirmed)?_vm._i(_vm.user.TermsConfirmed,"true")>-1:(_vm.user.TermsConfirmed)},on:{"change":function($event){var $$a=_vm.user.TermsConfirmed,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.user, "TermsConfirmed", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.user, "TermsConfirmed", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.user, "TermsConfirmed", $$c)}}}}),_vm._v(" "),_c('label',{class:['input-checkbox-lbl', {'error': _vm.errors.has('TermsConfirmed')}],attrs:{"for":"TermsConfirmed"}},[_vm._v("\n                                        Я согласен с "),(_vm.info.RulesFile)?_c('a',{staticStyle:{"color":"#ff0000"},attrs:{"href":"javascript:;"},on:{"click":function($event){$event.stopPropagation();return _vm.onShowRulesClick.apply(null, arguments)}}},[_vm._v("правилами программы")]):_vm._e(),_vm._v(" "),(!_vm.info.RulesFile)?_c('span',[_vm._v("правилами программы")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.PersonalDataEditingAccept),expression:"user.PersonalDataEditingAccept"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"input-checkbox",attrs:{"id":"PersonalDataEditingAccept","name":"PersonalDataEditingAccept","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.user.PersonalDataEditingAccept)?_vm._i(_vm.user.PersonalDataEditingAccept,"true")>-1:(_vm.user.PersonalDataEditingAccept)},on:{"change":function($event){var $$a=_vm.user.PersonalDataEditingAccept,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.user, "PersonalDataEditingAccept", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.user, "PersonalDataEditingAccept", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.user, "PersonalDataEditingAccept", $$c)}}}}),_vm._v(" "),_c('label',{class:['input-checkbox-lbl', {'error': _vm.errors.has('PersonalDataEditingAccept')}],attrs:{"for":"PersonalDataEditingAccept"}},[_vm._v("\n                                        Я согласен на обработку\n                                        "),(_vm.info.PolicyFile)?_c('a',{staticStyle:{"color":"#ff0000"},attrs:{"href":"javascript:;"},on:{"click":function($event){$event.stopPropagation();return _vm.onShowPolicyClick.apply(null, arguments)}}},[_vm._v("персональных данных")]):_vm._e(),(!_vm.info.PolicyFile)?_c('span',[_vm._v("персональных данных")]):_vm._e(),_vm._v(" "),(_vm.isCampari)?_c('span',[_vm._v("и с")]):_vm._e(),_vm._v(" "),(_vm.info.PolicyFile && _vm.isCampari)?_c('a',{staticStyle:{"color":"#ff0000"},attrs:{"href":"javascript:;"},on:{"click":function($event){$event.stopPropagation();return _vm.onShowPolicyClick.apply(null, arguments)}}},[_vm._v("\n                                        политикой конфиденциальности\n                                      ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('div',{staticClass:"form-btns btns flex"},[(_vm.totalSteps > 1)?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.prevStep()}}},[_vm._v("\n                                            Назад\n                                        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary auth",attrs:{"type":"button"},on:{"click":function($event){return _vm.register()}}},[_vm._v("\n                                            Зарегистрироваться\n                                        ")])])])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.error))]),_vm._v(" "),_c('div',{staticClass:"reglink margin-top-20"},[_c('p',[_vm._v("Уже зарегистрированы? "),_c('span',{on:{"click":function($event){return _vm.$router.push('/login')}}},[_vm._v("Войти")])])])]:_vm._e()],2),_vm._v(" "),(_vm.result != null)?[_vm._m(0)]:_vm._e()],2)])])]),_vm._v(" "),_c('popup-window',{ref:"ppPolicy",attrs:{"title":'Политика конфиденциальности сервиса',"width":800,"height":'90%'}},[_c('p',{staticClass:"p-header-1"}),_vm._v(" "),(_vm.info.PolicyFile)?[(_vm.policyFile.ishtml)?_c('iframe',{attrs:{"src":_vm.policyFile.url}}):_c('pdf-viewer',{ref:"pdfViewPolicy"})]:_vm._e()],2),_vm._v(" "),_c('popup-window',{ref:"ppRules",attrs:{"title":'Правила программы',"width":800,"height":'90%'}},[_c('p',{staticClass:"p-header-1"}),_vm._v(" "),(_vm.info.RulesFile)?[(_vm.rulesFile.ishtml)?_c('iframe',{attrs:{"src":_vm.rulesFile.url}}):_c('pdf-viewer',{ref:"pdfViewRules"})]:_vm._e()],2),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Регистрация"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-content-block"},[_vm._v("\n                            Для завершения регистрации требуется подтвердить указанный email."),_c('br'),_vm._v("\n                            Проверьте почту и следуйте инструкциям.\n                        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Projects_vue__ = __webpack_require__(267);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d490f52_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Projects_vue__ = __webpack_require__(714);
function injectStyle (ssrContext) {
  __webpack_require__(711)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d490f52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Projects_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d490f52_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Projects_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(712);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("7be00370", content, true, {});

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".sortable-blocks[data-v-3d490f52]{padding:14px}.sortable-blocks>div[data-v-3d490f52]{margin:0 10px 10px 0;float:left}.ui-sortable-placeholder[data-v-3d490f52]{float:left}", ""]);

// exports


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.SmoothDnD=t():e.SmoothDnD=t()}(this,function(){return function(e){var t={};function n(o){if(t[o])return t[o].exports;var r=t[o]={i:o,l:!1,exports:{}};return e[o].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=e,n.c=t,n.d=function(e,t,o){n.o(e,t)||Object.defineProperty(e,t,{configurable:!1,enumerable:!0,get:o})},n.r=function(e){Object.defineProperty(e,"__esModule",{value:!0})},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=10)}([function(e,t,n){"use strict";var o,r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};o=function(){return this}();try{o=o||Function("return this")()||(0,eval)("this")}catch(e){"object"===("undefined"==typeof window?"undefined":r(window))&&(o=window)}e.exports=o},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});t.containerInstance="smooth-dnd-container-instance",t.containersInDraggable="smooth-dnd-containers-in-draggable",t.defaultGroupName="@@smooth-dnd-default-group@@",t.wrapperClass="smooth-dnd-draggable-wrapper",t.defaultGrabHandleClass="smooth-dnd-default-grap-handle",t.animationClass="animated",t.translationValue="__smooth_dnd_draggable_translation_value",t.visibilityValue="__smooth_dnd_draggable_visibility_value",t.ghostClass="smooth-dnd-ghost",t.containerClass="smooth-dnd-container",t.extraSizeForInsertion="smooth-dnd-extra-size-for-insertion",t.stretcherElementClass="smooth-dnd-stretcher-element",t.stretcherElementInstance="smooth-dnd-stretcher-instance",t.isDraggableDetached="smoth-dnd-is-draggable-detached",t.disbaleTouchActions="smooth-dnd-disable-touch-action",t.noUserSelectClass="smooth-dnd-no-user-select"},function(e,t,n){"use strict";(function(e){Object.defineProperty(t,"__esModule",{value:!0});t.getIntersection=function(e,t){return{left:Math.max(e.left,t.left),top:Math.max(e.top,t.top),right:Math.min(e.right,t.right),bottom:Math.min(e.bottom,t.bottom)}};var n=t.getIntersectionOnAxis=function(e,t,n){return"x"===n?{left:Math.max(e.left,t.left),top:e.top,right:Math.min(e.right,t.right),bottom:e.bottom}:{left:e.left,top:Math.max(e.top,t.top),right:e.right,bottom:Math.min(e.bottom,t.bottom)}},o=t.getContainerRect=function(e){var t=e.getBoundingClientRect(),n={left:t.left,right:t.right+10,top:t.top,bottom:t.bottom};if(a(e,"x")&&!i(e,"x")){var o=n.right-n.left;n.right=n.right+e.scrollWidth-o}if(a(e,"y")&&!i(e,"y")){var r=n.bottom-n.top;n.bottom=n.bottom+e.scrollHeight-r}return n},r=(t.getScrollingAxis=function(t){var n=e.getComputedStyle(t),o=n.overflow;if("auto"===o||"scroll"===o)return"xy";var r=n["overflow-x"],i="auto"===r||"scroll"===r,a=n["overflow-y"];return(i?"x":"")+("auto"===a||"scroll"===a?"y":"")||null},t.isScrolling=function(t,n){var o=e.getComputedStyle(t),r=o.overflow,i=o["overflow-"+n];return"auto"===r||"scroll"===r||("auto"===i||"scroll"===i)}),i=t.isScrollingOrHidden=function(t,n){var o=e.getComputedStyle(t),r=o.overflow,i=o["overflow-"+n];return"auto"===r||"scroll"===r||"hidden"===r||("auto"===i||"scroll"===i||"hidden"===i)},a=t.hasBiggerChild=function(e,t){return"x"===t?e.scrollWidth>e.clientWidth:e.scrollHeight>e.clientHeight};t.hasScrollBar=function(e,t){return a(e,t)&&r(e,t)},t.getVisibleRect=function(e,t){var r=e,l=t||o(e);for(r=e.parentElement;r;)a(r,"x")&&i(r,"x")&&(l=n(l,r.getBoundingClientRect(),"x")),a(r,"y")&&i(r,"y")&&(l=n(l,r.getBoundingClientRect(),"y")),r=r.parentElement;return l},t.listenScrollParent=function(t,n){var o=[];return setTimeout(function(){for(var i=t;i;)(r(i,"x")||r(i,"y"))&&(i.addEventListener("scroll",n),o.push(i)),i=i.parentElement;e.addEventListener("scroll",n)},10),{dispose:function(){o.forEach(function(e){e.removeEventListener("scroll",n)}),e.removeEventListener("scroll",n)}}},t.hasParent=function(e,t){for(var n=e;n;){if(n===t)return!0;n=n.parentElement}return!1},t.getParent=function(e,t){for(var n=e;n;){if(n.matches(t))return n;n=n.parentElement}return null},t.hasClass=function(e,t){return e.className.split(" ").map(function(e){return e}).indexOf(t)>-1},t.addClass=function(e,t){if(e){var n=e.className.split(" ").filter(function(e){return e});-1===n.indexOf(t)&&(n.unshift(t),e.className=n.join(" "))}},t.removeClass=function(e,t){if(e){var n=e.className.split(" ").filter(function(e){return e&&e!==t});e.className=n.join(" ")}},t.debounce=function(e,t,n){var o=null;return function(){for(var r=arguments.length,i=Array(r),a=0;a<r;a++)i[a]=arguments[a];o&&clearTimeout(o),n&&!o?e.call.apply(e,[void 0].concat(i)):o=setTimeout(function(){o=null,e.call.apply(e,[void 0].concat(i))},t)}},t.removeChildAt=function(e,t){return e.removeChild(e.children[t])},t.addChildAt=function(e,t,n){n>=e.children.lenght?e.appendChild(t):e.insertBefore(t,e.children[n])},t.isMobile=function(){return"undefined"!=typeof window&&!!(e.navigator.userAgent.match(/Android/i)||e.navigator.userAgent.match(/webOS/i)||e.navigator.userAgent.match(/iPhone/i)||e.navigator.userAgent.match(/iPad/i)||e.navigator.userAgent.match(/iPod/i)||e.navigator.userAgent.match(/BlackBerry/i)||e.navigator.userAgent.match(/Windows Phone/i))},t.clearSelection=function(){e.getSelection?e.getSelection().empty?e.getSelection().empty():e.getSelection().removeAllRanges&&e.getSelection().removeAllRanges():e.document.selection&&e.document.selection.empty()},t.getElementCursor=function(t){if(t){var n=e.getComputedStyle(t);if(n)return n.cursor}return null}}).call(this,n(0))},function(e,t,n){"use strict";(function(e){Object.defineProperty(t,"__esModule",{value:!0}),t.domDropHandler=function(t){var n=t.element,i=t.draggables;t.layout,t.options;return function(t,a){var l=t.removedIndex,s=t.addedIndex,u=t.droppedElement,c=null;if(null!==l&&(c=(0,o.removeChildAt)(n,l),i.splice(l,1)),null!==s){var d=e.document.createElement("div");d.className=""+r.wrapperClass,d.appendChild(c.firstElementChild||u),d[r.containersInDraggable]=[],(0,o.addChildAt)(n,d,s),s>=i.length?i.push(d):i.splice(s,0,d)}a&&a(t)}},t.reactDropHandler=function(){return{handler:function(e){e.element,e.draggables,e.layout,e.options;return function(e,t){t&&t(e)}}}};var o=n(2),r=n(1)}).call(this,n(0))},function(e,t,n){"use strict";(function(e){Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(t,n,l){t[r.extraSizeForInsertion]=0;var s=l,u=function(e){return{get:function(t,n){var o=e[n];return t[o||n]},set:function(t,n,o){requestAnimationFrame(function(){t[e[n]]=e.setters[n]?e.setters[n](o):o})}}}("horizontal"===n?i:a),c={translation:0},d=null;e.addEventListener("resize",function(){m(t)}),setTimeout(function(){g()},10);var f=o.listenScrollParent(t,function(){m(t),d&&d()});function g(){m(t),function(e){var t=e.getBoundingClientRect();c.scaleX=e.offsetWidth?(t.right-t.left)/e.offsetWidth:1,c.scaleY=e.offsetHeight?(t.bottom-t.top)/e.offsetHeight:1}(t)}var p=void 0;function m(e){c.rect=o.getContainerRect(e),c.visibleRect=o.getVisibleRect(e,c.rect)}function v(e){return u.get(e,"size")*u.get(c,"scale")}function h(e){return u.get(e,"dragPosition")}function y(e,t){var o=c.visibleRect,r=o.left,i=o.top,a=o.right,l=o.bottom;l-i<2&&(l=i+30);var s=c.rect;return"vertical"===n?e>s.left&&e<s.right&&t>i&&t<l:e>r&&e<a&&t>s.top&&t<s.bottom}return{getSize:v,getContainerRectangles:function(){return{rect:c.rect,visibleRect:c.visibleRect}},getBeginEndOfDOMRect:function(e){return{begin:u.get(e,"begin"),end:u.get(e,"end")}},getBeginEndOfContainer:function(){var e=u.get(c.rect,"begin")+c.translation,t=u.get(c.rect,"end")+c.translation;return{begin:e,end:t}},getBeginEndOfContainerVisibleRect:function(){var e=u.get(c.visibleRect,"begin")+c.translation,t=u.get(c.visibleRect,"end")+c.translation;return{begin:e,end:t}},getBeginEnd:function(e){var n=function(e){return(u.get(e,"distanceToParent")+(e[r.translationValue]||0))*u.get(c,"scale")}(e)+(u.get(c.rect,"begin")+c.translation)-u.get(t,"scrollValue");return{begin:n,end:n+v(e)*u.get(c,"scale")}},getAxisValue:h,setTranslation:function(e,t){t?u.set(e.style,"translate",t):e.style.removeProperty("transform");e[r.translationValue]=t,e[r.containersInDraggable]&&setTimeout(function(){e[r.containersInDraggable].forEach(function(e){!function e(t){t.layout.invalidateRects();t.onTranslated();t.getChildContainers()&&t.getChildContainers().forEach(function(t){return e(t)})}(e)})},s+20)},getTranslation:function(e){return e[r.translationValue]},setVisibility:function(e,t){void 0!==e[r.visibilityValue]&&e[r.visibilityValue]===t||(t?e.style.removeProperty("visibility"):e.style.visibility="hidden",e[r.visibilityValue]=t)},isVisible:function(e){return void 0===e[r.visibilityValue]||e[r.visibilityValue]},isInVisibleRect:y,dispose:function(){f&&f.dispose();p&&(p.parentNode.removeChild(p),p=null)},getContainerScale:function(){return{scaleX:c.scaleX,scaleY:c.scaleY}},setScrollListener:function(e){d=e},setSize:function(e,t){u.set(e,"setSize",t)},getTopLeftOfElementBegin:function(e){var t=0,o=0;"horizontal"===n?(o=e,t=c.rect.top):(o=c.rect.left,t=e);return{top:t,left:o}},getScrollSize:function(e){return u.get(e,"scrollSize")},getScrollValue:function(e){return u.get(e,"scrollValue")},setScrollValue:function(e,t){return u.set(e,"scrollValue",t)},invalidate:g,invalidateRects:function(){m(t)},getPosition:function(e){return y(e.x,e.y)?h(e):null}}};var o=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(n(2)),r=n(1);var i={size:"offsetWidth",distanceToParent:"offsetLeft",translate:"transform",begin:"left",end:"right",dragPosition:"x",scrollSize:"scrollWidth",offsetSize:"offsetWidth",scrollValue:"scrollLeft",scale:"scaleX",setSize:"width",setters:{translate:function(e){return"translate3d("+e+"px, 0, 0)"}}},a={size:"offsetHeight",distanceToParent:"offsetTop",translate:"transform",begin:"top",end:"bottom",dragPosition:"y",scrollSize:"scrollHeight",offsetSize:"offsetHeight",scrollValue:"scrollTop",scale:"scaleY",setSize:"height",setters:{translate:function(e){return"translate3d(0,"+e+"px, 0)"}}}}).call(this,n(0))},function(e,t,n){"use strict";(function(e){Object.defineProperty(t,"__esModule",{value:!0});var o=n(2);function r(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var i=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"y",n=!1,o=null,r=null,i=null,a=null;return{animate:function(l,s){i=l,a=s,(n=!0)&&function n(){null===o&&(o=requestAnimationFrame(function(l){null===r&&(r=l);var s=l-r;r=l;var u=s/1e3*a;(function(e,t,n){e&&(e!==window?"x"===t?e.scrollLeft+=n:e.scrollTop+=n:"x"===t?e.scrollBy(n,0):e.scrollBy(0,n))})(e,t,u="begin"===i?0-u:u),o=null,n()}))}()},stop:function(){n&&(cancelAnimationFrame(o),n=!1,r=null,o=null)}}};function a(e){var t={element:e,rect:(0,o.getVisibleRect)(e,e.getBoundingClientRect()),descendants:[],invalidate:n,axis:null,dispose:function(){e.removeEventListener("scroll",n)}};function n(){t.rect=(0,o.getVisibleRect)(e,e.getBoundingClientRect()),t.descendants.forEach(function(e){return e.invalidate()})}return e.addEventListener("scroll",n),t}function l(e){return Object.assign(e,i(e.element,e.axis))}t.default=function(t){var n,s,u,c=(n=t.map(function(e){return e.element}),s=[],u=null,n.forEach(function(e){var t=e;for(u=null;t;){var n=(0,o.getScrollingAxis)(t);if(n&&!s.some(function(e){return e.element===t})){var r=a(t);u&&r.descendants.push(u),u=r,"xy"===n?(s.push(Object.assign({},r,{axis:"x"})),s.push(Object.assign({},r,{axis:"y"},{descendants:[]}))):s.push(Object.assign({},r,{axis:n}))}t=t.parentElement}}),s),d=[].concat(r(c.map(l)),r(function(){function t(){return{left:0,right:e.innerWidth,top:0,bottom:e.innerHeight}}return[Object.assign({rect:t(),axis:"y"},i(e)),Object.assign({rect:t(),axis:"x"},i(e,"x"))]}()));return function(e){var t=e.draggableInfo,n=e.reset;if(d.length){if(n)return d.forEach(function(e){return e.stop()}),c.forEach(function(e){return e.dispose()}),null;d.forEach(function(e){var n=function(e,t){var n=t.rect,o=n.left,r=n.right,i=n.top,a=n.bottom,l=e.x,s=e.y;if(l<o||l>r||s<i||s>a)return null;var u=void 0,c=void 0,d=void 0;return"x"===t.axis?(u=o,c=r,d=l):(u=i,c=a,d=s),c-d<100?{direction:"end",speedFactor:(100-(c-d))/100}:d-u<100?{direction:"begin",speedFactor:(100-(d-u))/100}:void 0}(t.mousePosition,e);n?e.animate(n.direction,1500*n.speedFactor):e.stop()})}}}}).call(this,n(0))},function(e,t,n){"use strict";(function(e){Object.defineProperty(t,"__esModule",{value:!0}),t.removeStyle=t.addCursorStyleToBody=t.addStyleToHead=void 0;var o,r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},i=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(n(1));function a(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}var l={overflow:"hidden",display:"block"},s={height:"100%",display:"inline-block","vertical-align":"top","white-space":"normal"},u=(a(o={},"."+i.containerClass,{position:"relative"}),a(o,"."+i.containerClass+" *",{"box-sizing":"border-box"}),a(o,"."+i.containerClass+".horizontal",{"white-space":"nowrap"}),a(o,"."+i.containerClass+".horizontal > ."+i.stretcherElementClass,{display:"inline-block"}),a(o,"."+i.containerClass+".horizontal > ."+i.wrapperClass,s),a(o,"."+i.containerClass+".vertical > ."+i.wrapperClass,l),a(o,"."+i.wrapperClass,{}),a(o,"."+i.wrapperClass+".horizontal",s),a(o,"."+i.wrapperClass+".vertical",l),a(o,"."+i.wrapperClass+".animated",{transition:"transform ease"}),a(o,"."+i.ghostClass+" *",{"box-sizing":"border-box"}),a(o,"."+i.ghostClass+".animated",{transition:"all ease-in-out"}),a(o,"."+i.disbaleTouchActions+" *",{"touch-actions":"none","-ms-touch-actions":"none"}),a(o,"."+i.noUserSelectClass+" *",{"-webkit-touch-callout":"none","-webkit-user-select":"none","-khtml-user-select":"none","-moz-user-select":"none","-ms-user-select":"none","user-select":"none"}),o);function c(e){return Object.keys(e).reduce(function(t,n){var o=e[n];return"object"===(void 0===o?"undefined":r(o))?""+t+n+"{"+c(o)+"}":""+t+n+":"+o+";"},"")}t.addStyleToHead=function(){if("undefined"!=typeof window){var t=e.document.head||e.document.getElementsByTagName("head")[0],n=e.document.createElement("style"),o=c(u);n.type="text/css",n.styleSheet?n.styleSheet.cssText=o:n.appendChild(e.document.createTextNode(o)),t.appendChild(n)}},t.addCursorStyleToBody=function(t){if(t&&"undefined"!=typeof window){var n=e.document.head||e.document.getElementsByTagName("head")[0],o=e.document.createElement("style"),r=c({"body *":{cursor:t+" !important"}});return o.type="text/css",o.styleSheet?o.styleSheet.cssText=r:o.appendChild(e.document.createTextNode(r)),n.appendChild(o),o}return null},t.removeStyle=function(t){t&&"undefined"!=typeof window&&(e.document.head||e.document.getElementsByTagName("head")[0]).removeChild(t)}}).call(this,n(0))},function(e,t,n){"use strict";(function(e){var t;(t=e.Node||e.Element)&&t.prototype&&!t.prototype.matches&&(t.prototype.matches=t.prototype.matchesSelector||t.prototype.mozMatchesSelector||t.prototype.msMatchesSelector||t.prototype.oMatchesSelector||t.prototype.webkitMatchesSelector||function(e){for(var t=(this.document||this.ownerDocument).querySelectorAll(e),n=t.length;--n>=0&&t.item(n)!==this;);return n>-1}),function(e){e&&e.prototype&&null==e.prototype.firstElementChild&&Object.defineProperty(e.prototype,"firstElementChild",{get:function(){for(var e,t=this.childNodes,n=0;e=t[n++];)if(1===e.nodeType)return e;return null}})}(e.Node||e.Element),Array.prototype.some||(Array.prototype.some=function(e){if(null==this)throw new TypeError("Array.prototype.some called on null or undefined");if("function"!=typeof e)throw new TypeError;for(var t=Object(this),n=t.length>>>0,o=arguments.length>=2?arguments[1]:void 0,r=0;r<n;r++)if(r in t&&e.call(o,t[r],r,t))return!0;return!1})}).call(this,n(0))},function(e,t,n){"use strict";(function(e){Object.defineProperty(t,"__esModule",{value:!0}),n(7);var o,r=u(n(2)),i=u(n(1)),a=n(6),l=n(5),s=(o=l)&&o.__esModule?o:{default:o};function u(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}var c=["mousedown","touchstart"],d=["mousemove","touchmove"],f=["mouseup","touchend"],g=null,p=null,m=null,v=null,h=[],y=!1,b=null,C=null,x=null,E=null,S=r.isMobile();function O(){"undefined"!=typeof window&&c.forEach(function(t){e.document.addEventListener(t,I,{passive:!1})})}function w(){return v.ghostParent?v.ghostParent:p&&p.parentElement||e.document.body}var D=function(){var t=void 0,n=void 0,o=void 0,r=null,i=1,a=5;function l(e){var o=R(e),r=o.clientX,l=o.clientY;if(n)(Math.abs(t.clientX-r)>a||Math.abs(t.clientY-l)>a)&&c();else if(Math.abs(t.clientX-r)>i||Math.abs(t.clientY-l)>i)return g()}function s(){c()}function u(){c()}function c(){clearTimeout(r),d.forEach(function(t){return e.document.removeEventListener(t,l)},{passive:!1}),f.forEach(function(t){return e.document.removeEventListener(t,s)},{passive:!1}),e.document.removeEventListener("drag",u,{passive:!1})}function g(){clearTimeout(r),c(),o()}return function(i,a,c){t=R(i),o=c,(n="number"==typeof a?a:S?200:0)&&(r=setTimeout(g,n)),d.forEach(function(t){return e.document.addEventListener(t,l)},{passive:!1}),f.forEach(function(t){return e.document.addEventListener(t,s)},{passive:!1}),e.document.addEventListener("drag",u,{passive:!1})}}();function I(t){var n=R(t);if(!y&&(void 0===n.button||0===n.button)&&(p=r.getParent(n.target,"."+i.wrapperClass))){var o=r.getParent(p,"."+i.containerClass),a=h.filter(function(e){return e.element===o})[0],l=a.getOptions().dragHandleSelector,s=a.getOptions().nonDragAreaSelector,u=!0;l&&!r.getParent(n.target,l)&&(u=!1),s&&r.getParent(n.target,s)&&(u=!1),u&&D(n,a.getOptions().dragBeginDelay,function(){r.clearSelection(),B(n,r.getElementCursor(t.target)),d.forEach(function(t){e.document.addEventListener(t,A,{passive:!1})}),f.forEach(function(t){e.document.addEventListener(t,P,{passive:!1})})})}}function P(){d.forEach(function(t){e.document.removeEventListener(t,A,{passive:!1})}),f.forEach(function(t){e.document.removeEventListener(t,P,{passive:!1})}),C({reset:!0}),E&&((0,a.removeStyle)(E),E=null),v&&function(e){function t(){r.removeClass(m.ghost,"animated"),m.ghost.style.transitionDuration=null,w().removeChild(m.ghost),e()}function n(e,n,o){var i=e.top,a=e.left;r.addClass(m.ghost,"animated"),o&&r.addClass(m.ghost.firstElementChild,o),m.ghost.style.transitionDuration=n+"ms",m.ghost.style.left=a+"px",m.ghost.style.top=i+"px",setTimeout(function(){t()},n+20)}if(v.targetElement){var o=h.filter(function(e){return e.element===v.targetElement})[0];!(p=o.getOptions()).shouldAnimateDrop||p.shouldAnimateDrop(v.container.getOptions(),v.payload)?n(o.getDragResult().shadowBeginEnd.rect,Math.max(150,o.getOptions().animationDuration/2),o.getOptions().dropClass):t()}else{var i=h.filter(function(e){return e===v.container})[0],a=i.getOptions(),l=a.behaviour,s=a.removeOnDropOut;if("move"===l&&!s&&i.getDragResult()){var u=i.getDragResult(),c=u.removedIndex,d=u.elementSize,f=i.layout;i.getTranslateCalculator({dragResult:{removedIndex:c,addedIndex:c,elementSize:d}});var g=c>0?f.getBeginEnd(i.draggables[c-1]).end:f.getBeginEndOfContainer().begin;n(f.getTopLeftOfElementBegin(g),i.getOptions().animationDuration,i.getOptions().dropClass)}else r.addClass(m.ghost,"animated"),m.ghost.style.transitionDuration=i.getOptions().animationDuration+"ms",m.ghost.style.opacity="0",m.ghost.style.transform="scale(0.90)",setTimeout(function(){t()},i.getOptions().animationDuration)}var p}(function(){r.removeClass(e.document.body,i.disbaleTouchActions),r.removeClass(e.document.body,i.noUserSelectClass),T(!1),(g||[]).forEach(function(e){e.handleDrop(v)}),g=null,p=null,m=null,v=null,y=!1,null,x=null,b=null})}function R(e){return e.touches?e.touches[0]:e}function T(e){h.forEach(function(t){var n=e?t.getOptions().onDragStart:t.getOptions().onDragEnd;if(n){var o={isSource:t===v.container,payload:v.payload};t.isDragRelevant(v.container,v.payload)?o.willAcceptDrop=!0:o.willAcceptDrop=!1,n(o)}})}function B(t,n){y=!0;var o=h.filter(function(e){return p.parentElement===e.element})[0];o.setDraggables(),o,x=o.getOptions().lockAxis?o.getOptions().lockAxis.toLowerCase():null,v=function(e){var t=h.filter(function(t){return e.parentElement===t.element})[0],n=t.draggables.indexOf(e),o=t.getOptions().getGhostParent;return{container:t,element:e,elementIndex:n,payload:t.getOptions().getChildPayload?t.getOptions().getChildPayload(n):void 0,targetElement:null,position:{x:0,y:0},groupName:t.getOptions().groupName,ghostParent:o?o():null}}(p),m=function(t,n,o,l){var s=n.x,u=n.y,c=o.getScale(),d=(c.scaleX,c.scaleY,t.getBoundingClientRect()),f=d.left,g=d.top,p=d.right,m=d.bottom,v=f+(p-f)/2,h=g+(m-g)/2,y=t.cloneNode(!0);return y.style.zIndex=1e3,y.style.boxSizing="border-box",y.style.position="fixed",y.style.left=f+"px",y.style.top=g+"px",y.style.width=p-f+"px",y.style.height=m-g+"px",y.style.overflow="visible",y.style.transition=null,y.style.removeProperty("transition"),y.style.pointerEvents="none",o.getOptions().dragClass?setTimeout(function(){r.addClass(y.firstElementChild,o.getOptions().dragClass);var t=e.getComputedStyle(y.firstElementChild).cursor;E=(0,a.addCursorStyleToBody)(t)}):E=(0,a.addCursorStyleToBody)(l),r.addClass(y,o.getOptions().orientation),r.addClass(y,i.ghostClass),{ghost:y,centerDelta:{x:v-s,y:h-u},positionDelta:{left:f-s,top:g-u}}}(p,{x:t.clientX,y:t.clientY},v.container,n),v.position={x:t.clientX+m.centerDelta.x,y:t.clientY+m.centerDelta.y},v.mousePosition={x:t.clientX,y:t.clientY},r.addClass(e.document.body,i.disbaleTouchActions),r.addClass(e.document.body,i.noUserSelectClass),g=h.filter(function(e){return e.isDragRelevant(o,v.payload)}),b=function(e){var t=e;return function(e){var n=!1;t.forEach(function(t){var o=t.handleDrag(e);n|=o.containerBoxChanged||!1,o.containerBoxChanged=!1}),C({draggableInfo:e}),n&&(n=!1,setTimeout(function(){h.forEach(function(e){e.layout.invalidateRects(),e.onTranslated()})},10))}}(g),C&&C({reset:!0}),C=function(e,t){return e.getOptions().autoScrollEnabled?(0,s.default)(t):function(){return null}}(o,g),g.forEach(function(e){return e.prepareDrag(e,g)}),T(!0),b(v),w().appendChild(m.ghost)}function A(e){e.preventDefault();var t=R(e);v?(x?"y"===x?(m.ghost.style.top=t.clientY+m.positionDelta.top+"px",v.position.y=t.clientY+m.centerDelta.y,v.mousePosition.y=t.clientY):"x"===x&&(m.ghost.style.left=t.clientX+m.positionDelta.left+"px",v.position.x=t.clientX+m.centerDelta.x,v.mousePosition.x=t.clientX):(m.ghost.style.left=t.clientX+m.positionDelta.left+"px",m.ghost.style.top=t.clientY+m.positionDelta.top+"px",v.position.x=t.clientX+m.centerDelta.x,v.position.y=t.clientY+m.centerDelta.y,v.mousePosition.x=t.clientX,v.mousePosition.y=t.clientY),b(v)):B(t,r.getElementCursor(e.target))}(0,a.addStyleToHead)(),t.default=(O(),{register:function(e){h.push(e)},unregister:function(e){h.splice(h.indexOf(e),1)}})}).call(this,n(0))},function(e,t,n){"use strict";(function(e){Object.defineProperty(t,"__esModule",{value:!0});var o=s(n(8)),r=s(n(4)),i=n(2),a=n(3),l=n(1);function s(e){return e&&e.__esModule?e:{default:e}}var u={groupName:null,behaviour:"move",orientation:"vertical",getChildPayload:null,animationDuration:250,autoScrollEnabled:!0,shouldAcceptDrop:null,shouldAnimateDrop:null};function c(e,t,n){t?((0,i.addClass)(e,l.animationClass),e.style.transitionDuration=n+"ms"):((0,i.removeClass)(e,l.animationClass),e.style.removeProperty("transition-duration"))}function d(e){return e?e[l.containerInstance]:null}function f(t){if(N.wrapChild)return N.wrapChild(t);var n=e.document.createElement("div");return n.className=""+l.wrapperClass,t.parentElement.insertBefore(n,t),n.appendChild(t),n}function g(e){var t=[];return Array.prototype.map.call(e.children,function(n){if(n.nodeType===Node.ELEMENT_NODE){var o=n;(0,i.hasClass)(n,l.wrapperClass)||(o=f(n)),o[l.containersInDraggable]=[],o[l.translationValue]=0,t.push(o)}else e.removeChild(n)}),t}function p(e){var t=e.layout;return function(e,n){var o=arguments.length>2&&void 0!==arguments[2]&&arguments[2];return function e(n,o,r,i){var a=arguments.length>4&&void 0!==arguments[4]&&arguments[4];if(i<r)return r;if(r===i){var l=t.getBeginEnd(n[r]),s=l.begin,u=l.end;return o>s&&o<=u?a?o<(u+s)/2?r:r+1:r:null}var c=Math.floor((i+r)/2),d=t.getBeginEnd(n[c]),f=d.begin,g=d.end;return o<f?e(n,o,r,c-1,a):o>g?e(n,o,c+1,i,a):a?o<(g+f)/2?c:c+1:c}(e,n,0,e.length-1,o)}}function m(e){var t=e.element,n=e.draggables,o=e.layout,r=e.options,i=function(e){var t=e.element,n=e.draggables,o=e.layout;return e.options,function(){n.forEach(function(e){c(e,!1),o.setTranslation(e,0),o.setVisibility(e,!0),e[l.containersInDraggable]=[]}),t[l.stretcherElementInstance]&&(t[l.stretcherElementInstance].parentNode.removeChild(t[l.stretcherElementInstance]),t[l.stretcherElementInstance]=null)}}({element:t,draggables:n,layout:o,options:r}),s=(N.dropHandler||a.domDropHandler)({element:t,draggables:n,layout:o,options:r});return function(e,t){var n=t.addedIndex,o=t.removedIndex;if(i(),e.targetElement||r.removeOnDropOut){var a={removedIndex:o,addedIndex:null!==n?null!==o&&o<n?n-1:n:null,payload:e.payload,droppedElement:e.element.firstElementChild};s(a,r.onDrop)}}}function v(e,t){var n=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:u;return Object.assign({},u,e)}(t),o=g(e,n.orientation,n.animationDuration);return(0,i.addClass)(e,l.containerClass+" "+n.orientation),{element:e,draggables:o,options:n,layout:(0,r.default)(e,n.orientation,n.animationDuration)}}function h(e,t){var n=function(e,t){for(var n=e.element;n;){var o=d(n.parentElement);if(o&&t.indexOf(o)>-1)return{container:o,draggable:n};n=n.parentElement}return null}(e,t);n&&(n.container.getChildContainers().push(e),e.setParentContainer(n.container),n.draggable[l.containersInDraggable].push(e))}function y(e){e.draggables;var t=e.element,n=e.options,o=null;return function(e){var r=e.draggableInfo,i=(e.dragResult,o);return null==o&&r.container.element===t&&"copy"!==n.behaviour&&(i=o=r.elementIndex),{removedIndex:i}}}function b(e){var t=e.draggables,n=e.layout;return function(e){e.draggableInfo;var o=e.dragResult;null!==o.removedIndex&&n.setVisibility(t[o.removedIndex],!1)}}function C(e){var t=e.element,n=e.layout;return function(e){var o=e.draggableInfo;return{pos:d(t).isPosInChildContainer()?null:n.getPosition(o.position)}}}function x(e){var t=e.element,n=!1;return function(e){e.draggableInfo;var o=e.dragResult;d(t).getParentContainer()&&n!==(null!==o.pos)&&(n=null!==o.pos,d(t).getParentContainer().onChildPositionCaptured(n))}}function E(e){var t=e.layout,n=null;return function(e){var o=e.draggableInfo;return null===e.dragResult.pos?n=null:{elementSize:n=n||t.getSize(o.element)}}}function S(e){var t=e.element;return function(e){var n=e.draggableInfo,o=e.dragResult;!function(e,t){var n=!(arguments.length>2&&void 0!==arguments[2])||arguments[2];t&&n?e.targetElement=t:e.targetElement===t&&(e.targetElement=null)}(n,t,!!o.pos)}}function O(e){e.draggables,e.layout;return function(e){return null!==e.dragResult.pos?{addedIndex:0}:{addedIndex:null}}}function w(e){e.draggables;var t=e.layout,n=null;return function(e){var o=e.dragResult.addedIndex;if(o!==n){n=o;var r=t.getBeginEndOfContainer(),i=r.begin,a=r.end;return{shadowBeginEnd:{rect:t.getTopLeftOfElementBegin(i,a)}}}}}function D(e){var t=B(e);return function(e){var n=e.draggableInfo,o=e.dragResult;return n.invalidateShadow?t({draggableInfo:n,dragResult:o}):null}}function I(e){var t,n,o,r=(n=(t=e).draggables,o=p({layout:t.layout}),function(e){var t=e.dragResult,r=t.shadowBeginEnd,i=t.pos;if(!r){var a=o(n,i,!0);return null!==a?a:n.length}return r.begin+r.beginAdjustment<=i&&r.end>=i?null:i<r.begin+r.beginAdjustment?o(n,i):i>r.end?o(n,i)+1:n.length});return function(e){var t=e.dragResult,n=null;return null!==t.pos&&null===(n=r({dragResult:t}))&&(n=t.addedIndex),{addedIndex:n}}}function P(){var e=null;return function(t){var n=t.dragResult,o=n.addedIndex,r=n.shadowBeginEnd;o!==e&&null!==e&&r&&(r.beginAdjustment=0),e=o}}function R(t){var n=t.element,o=t.draggables,r=t.layout,i=t.options,a=null;return function(t){var s=t.dragResult,u=s.addedIndex,c=s.removedIndex,d=s.elementSize;if(null===c)if(null!==u){if(!a){var f=r.getBeginEndOfContainer();f.end=f.begin+r.getSize(n);var g=r.getScrollSize(n)>r.getSize(n)?f.begin+r.getScrollSize(n)-r.getScrollValue(n):f.end,p=o.length>0?r.getBeginEnd(o[o.length-1]).end-o[o.length-1][l.translationValue]:f.begin;if(p+d>g){(a=e.document.createElement("div")).className=l.stretcherElementClass+" "+i.orientation;var m=d+p-g;return r.setSize(a.style,m+"px"),n.appendChild(a),n[l.stretcherElementInstance]=a,{containerBoxChanged:!0}}}}else if(a){r.setTranslation(a,0);var v=a;return a=null,n.removeChild(v),n[l.stretcherElementInstance]=null,{containerBoxChanged:!0}}}}function T(e){e.element;var t=e.draggables,n=e.layout,o=null,r=null;return function(e){var i=e.dragResult,a=i.addedIndex,l=i.removedIndex,s=i.elementSize;if(a!==o||l!==r){for(var u=0;u<t.length;u++)if(u!==l){var c=t[u],d=0;null!==l&&l<u&&(d-=n.getSize(t[l])),null!==a&&a<=u&&(d+=s),n.setTranslation(c,d)}return o=a,r=l,{addedIndex:a,removedIndex:l}}}}function B(e){var t=e.draggables,n=e.layout,o=null;return function(e){var r=e.draggableInfo,i=e.dragResult,a=i.addedIndex,l=i.removedIndex,s=i.elementSize,u=i.pos,c=i.shadowBeginEnd;if(null!==u){if(null===a||!r.invalidateShadow&&a===o)return null;o&&(o=a);var d=a-1,f=0,g=null,p=null;if(d===l&&d--,d>-1){var m=n.getSize(t[d]);if(p=n.getBeginEnd(t[d]),s<m){var v=(m-s)/2;f=p.end-v}else f=p.end}else p={end:n.getBeginEndOfContainer().begin};var h=1e4,y=a;if(y===l&&y++,y<t.length){var b=n.getSize(t[y]);if(g=n.getBeginEnd(t[y]),s<b){var C=(b-s)/2;h=g.begin+C}else h=g.begin}else g={begin:n.getContainerRectangles().end};return{shadowBeginEnd:{begin:f,end:h,rect:p&&g?n.getTopLeftOfElementBegin(p.end,g.begin):null,beginAdjustment:c?c.beginAdjustment:0}}}return o=null,{shadowBeginEnd:null}}}function A(){var e=null;return function(t){var n=t.dragResult,o=n.pos,r=n.addedIndex,i=n.shadowBeginEnd;t.draggableInfo.invalidateShadow;if(null!==o){if(null!=r&&null===e){if(o<i.begin){var a=o-i.begin-5;i.beginAdjustment=a}e=r}}else e=null}}function _(e){var t=e.options,n=!1;return function(e){var o=!!e.dragResult.pos;if(o!==n){if(n=o,!o)return t.onDragLeave&&t.onDragLeave(),{dragLeft:!0};t.onDragEnter&&t.onDragEnter()}}}function z(e){var t=e.options,n=null;return function(e){var o=e.dragResult,r=o.addedIndex,i=o.removedIndex,a=e.draggableInfo,l=a.payload,s=a.element;if(t.onDropReady&&n!==r){n=r;var u=r;null!==i&&r>i&&u--,t.onDropReady({addedIndex:u,removedIndex:i,payload:l,element:s.firstElementChild})}}}function j(e){return"drop-zone"===e.options.behaviour?M(e)(y,b,C,x,E,S,O,w,_,z):M(e)(y,b,C,x,E,S,D,I,P,R,T,B,A,_,z)}function M(e){return function(){for(var t=arguments.length,n=Array(t),o=0;o<t;o++)n[o]=arguments[o];var r=n.map(function(t){return t(e)}),i=null;return function(e){return i=r.reduce(function(t,n){return Object.assign(t,n({draggableInfo:e,dragResult:t}))},i||{addedIndex:null,removedIndex:null,elementSize:null,pos:null,shadowBeginEnd:null})}}}function L(e){return function(t){var n=null,o=null,r=v(e,t),a=j(r),s=m(r),u=null,d=!1,p=[];function y(){null!==o&&(o.invalidateShadow=!0,n=a(o),o.invalidateShadow=!1)}function b(e){d=e,u&&(u.onChildPositionCaptured(e),o&&(n=a(o)))}function C(e,t,n){for(var o=g(t,n.orientation,n.animationDuration),r=0;r<o.length;r++)e[r]=o[r];for(var i=0;i<e.length-o.length;i++)e.pop()}return r.layout.setScrollListener(function(){y()}),{element:e,draggables:r.draggables,isDragRelevant:function(e){var t=e.element,n=e.options;return function(e,o){if(n.shouldAcceptDrop)return n.shouldAcceptDrop(e.getOptions(),o);var r=e.getOptions();return"copy"!==n.behaviour&&(0,i.getParent)(t,"."+l.wrapperClass)!==e.element&&(e.element===t||!(!r.groupName||r.groupName!==n.groupName))}}(r),getScale:r.layout.getContainerScale,layout:r.layout,getChildContainers:function(){return p},onChildPositionCaptured:b,dispose:function(e){var t;t=e.element,Array.prototype.map.call(t.children,function(e){if(e.nodeType===Node.ELEMENT_NODE){var n=e;(0,i.hasClass)(e,l.wrapperClass)&&(t.insertBefore(n,f.firstElementChild),t.removeChild(n))}})},prepareDrag:function(e,t){var n=e.element,o=r.draggables,i=e.getOptions();C(o,n,i),e.layout.invalidateRects(),h(e,t),o.forEach(function(e){return c(e,!0,i.animationDuration)})},isPosInChildContainer:function(){return d},handleDrag:function(e){return o=e,(n=a(e)).dragLeft&&"drop-zone"!==r.options.behaviour&&(n.dragLeft=!1,setTimeout(function(){n&&T(r)({dragResult:n})},20)),n},handleDrop:function(e){o=null,b(!1),a=j(r),s(e,n),n=null,u=null,p=[]},getDragResult:function(){return n},getTranslateCalculator:function(){return T(r).apply(void 0,arguments)},setParentContainer:function(e){u=e},getParentContainer:function(){return u},onTranslated:function(){y()},getOptions:function(){return r.options},setDraggables:function(){C(r.draggables,e,r.options)}}}}function N(e,t){var n=L(e)(t);return e[l.containerInstance]=n,o.default.register(n),{dispose:function(){o.default.unregister(n),n.layout.dispose(),n.dispose(n)}}}t.default=N}).call(this,n(0))},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.dropHandlers=t.constants=void 0;var o,r=n(9),i=(o=r)&&o.__esModule?o:{default:o},a=s(n(1)),l=s(n(3));function s(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}t.default=i.default,t.constants=a,t.dropHandlers=l}])});

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel projects"},[(_vm.info.User && _vm.info.User.MainRole === 'administrators')?_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"}),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[(_vm.info.User && _vm.info.User.MainRole === 'administrators')?_c('div',{staticClass:"btns flex"},[_c('svg',{staticClass:"svg-icon plus-square margin-top-3",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"},on:{"click":function($event){$event.stopPropagation();return _vm.onNewProject()}}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#PlusSquare"}}),_vm._v(" "),_c('title',[_vm._v("Новый проект")])]),_vm._v(" "),_c('svg',{staticClass:"svg-icon phone margin-top-3",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"},on:{"click":function($event){$event.stopPropagation();return _vm.onAppAccess()}}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Phone"}}),_vm._v(" "),_c('title',[_vm._v("Доступ к приложению")])]),_vm._v(" "),_c('div',{staticClass:"switch margin-left-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.active),expression:"active"}],attrs:{"type":"checkbox","id":"s5","checked":"checked"},domProps:{"checked":Array.isArray(_vm.active)?_vm._i(_vm.active,null)>-1:(_vm.active)},on:{"change":[function($event){var $$a=_vm.active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.active=$$a.concat([$$v]))}else{$$i>-1&&(_vm.active=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.active=$$c}},_vm.reload]}}),_vm._v(" "),_c('label',{staticClass:"slider-v3",attrs:{"for":"s5"}})])]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page panel-block-news no-padding-right"},[_c('div',{staticClass:"body-panel-content-center"},[_c('div',{staticClass:"sortable-blocks"},_vm._l((_vm.projectList),function(item,i){return (item.HasAdminRights)?_c('div',{class:['panel-block', 'panel-block-new', { 'disabled': item.DateExpired } ],attrs:{"data-id":item.Id}},[_c('div',{staticClass:"panel-block-img-base"},[_c('div',{staticClass:"panel-block-img"},[_c('img',{attrs:{"src":item.Image,"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"panel-block-info"},[_c('p',{staticClass:"panel-block-header margin-bottom-10"},[_vm._v(_vm._s(item.Name))]),_vm._v(" "),_c('a',{staticClass:"router-link-active",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.onDomain(item.Subdomain)}}},[_vm._v(_vm._s(item.Subdomain))]),_vm._v(" "),_c('p',{staticClass:"input-text-lbl"},[_vm._v(_vm._s(item.DatesFormatted))]),_vm._v(" "),_c('p',{staticClass:"input-text-lbl"},[_vm._v("Кол-во участинков: "+_vm._s(item.UsersCount))])]),_vm._v(" "),_c('div',{staticClass:"panel-body-actions"},[_c('button',{staticClass:"btn btn-img",staticStyle:{"height":"40px"},attrs:{"title":"Настройки проекта"},on:{"click":function($event){return _vm.$router.push('/projects/' + item.Id)}}},[_c('svg',{staticClass:"svg-icon svg-big",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Setting"}})])]),_vm._v(" "),_c('button',{staticClass:"btn btn-img",staticStyle:{"height":"40px"},attrs:{"title":"Роли пользователей"},on:{"click":function($event){return _vm.$router.push('/projects/' + item.Id + '/roles?returnUrl=/projects')}}},[_c('svg',{staticClass:"svg-icon svg-big",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Peoples"}})])]),_vm._v(" "),_c('button',{staticClass:"btn btn-img",staticStyle:{"height":"40px"},attrs:{"title":"Пользователи"},on:{"click":function($event){return _vm.$router.push('/projects/' + item.Id + '/users?returnUrl=/projects')}}},[_c('svg',{staticClass:"svg-icon svg-big",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#SearchPeople"}})])]),_vm._v(" "),_c('button',{staticClass:"btn btn-img",staticStyle:{"height":"40px"},attrs:{"title":"Торговые точки"},on:{"click":function($event){return _vm.$router.push('/projects/' + item.Id + '/trade-points?returnUrl=/projects')}}},[_c('svg',{staticClass:"svg-icon svg-big",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Shop"}})])])])]):_vm._e()}),0)])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Проекты"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectsAppAccess_vue__ = __webpack_require__(268);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d97e0ecc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectsAppAccess_vue__ = __webpack_require__(718);
function injectStyle (ssrContext) {
  __webpack_require__(716)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d97e0ecc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectsAppAccess_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d97e0ecc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectsAppAccess_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(717);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("8a056532", content, true, {});

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".table-view tr[data-v-d97e0ecc]{cursor:default}.table-view td.pointer[data-v-d97e0ecc]{cursor:pointer;text-overflow:ellipsis;white-space:nowrap}", ""]);

// exports


/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel projects"},[(_vm.info.User && _vm.info.User.MainRole === 'administrators')?_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"btn-back margin-right-10"},[_c('a',{staticClass:"router-link-active",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.$router.back()}}},[_vm._v("Назад")])]),_vm._v(" "),_c('div',{staticClass:"form-field margin-right-20"},[_c('drop-down',{attrs:{"items":_vm.accesses,"dataField":'Id',"textField":'Name'},on:{"change":function($event){return _vm.onAccessChange($event)}},model:{value:(_vm.accessId),callback:function ($$v) {_vm.accessId=$$v},expression:"accessId"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"control-block-right"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page",on:{"scroll":_vm.onScroll}},[_c('table',{staticClass:"table-view",attrs:{"id":"dataTable"}},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.projectList),function(item,i){return _c('tr',[_c('td',{staticClass:"id"},[_vm._v(_vm._s(item.Name))]),_vm._v(" "),_c('td',{staticClass:"link pointer",on:{"click":function($event){$event.stopPropagation();return _vm.openSubdomain(item)}}},[_vm._v(_vm._s(item.Subdomain))]),_vm._v(" "),_c('td',{staticClass:"date-range"},[_vm._v(_vm._s(item.AppAccessTypeName))]),_vm._v(" "),_c('td',{class:['link', {'pointer': item.UrlGooglePlay}],on:{"click":function($event){$event.stopPropagation();return _vm.openGooglePlay(item)}}},[_vm._v(_vm._s(item.UrlGooglePlay))]),_vm._v(" "),_c('td',{class:['link', {'pointer': item.UrlAppStore}],on:{"click":function($event){$event.stopPropagation();return _vm.openAppStore(item)}}},[_vm._v(_vm._s(item.UrlAppStore))]),_vm._v(" "),_c('td',{staticClass:"value-center"},[_c('button',{staticClass:"btn",attrs:{"type":"button","title":"Редактировать"},on:{"click":function($event){$event.stopPropagation();return _vm.openProjectEdit(item)}}},[_vm._v("Редактировать")])])])}),0)])]),_vm._v(" "),_c('popup-window',{ref:"ppAppAccessControlModal",attrs:{"title":'Управление доступом к приложению'}},[_c('div',{staticClass:"form-field-group mob-inline"},[_c('div',{staticClass:"form-field"},[_c('div',[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Название проекта")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedProject.Name),expression:"selectedProject.Name"}],staticClass:"input-text",attrs:{"type":"text","name":"Name","disabled":true},domProps:{"value":(_vm.selectedProject.Name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedProject, "Name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"margin-top-5"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("URL адрес")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedProject.Subdomain),expression:"selectedProject.Subdomain"}],staticClass:"input-text",attrs:{"type":"text","name":"Subdomain","disabled":true},domProps:{"value":(_vm.selectedProject.Subdomain)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedProject, "Subdomain", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"margin-top-5"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Доступ к приложению")]),_vm._v(" "),_c('drop-down',{attrs:{"items":[{ Id: 1, Name: 'Запрещено' }, { Id: 2, Name: 'FoxinBox' }, { Id: 3, Name: 'Отдельное приложение' }],"dataField":'Id',"textField":'Name'},model:{value:(_vm.selectedProject.AppAccessType),callback:function ($$v) {_vm.$set(_vm.selectedProject, "AppAccessType", $$v)},expression:"selectedProject.AppAccessType"}})],1),_vm._v(" "),_c('div',[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Ссылка в Google Play")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedProject.UrlGooglePlay),expression:"selectedProject.UrlGooglePlay"}],staticClass:"input-text",attrs:{"maxlength":"256","name":"UrlGooglePlay","type":"text"},domProps:{"value":(_vm.selectedProject.UrlGooglePlay)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedProject, "UrlGooglePlay", $event.target.value)}}})]),_vm._v(" "),_c('div',[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Ссылка в App Store")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedProject.UrlAppStore),expression:"selectedProject.UrlAppStore"}],staticClass:"input-text",attrs:{"maxlength":"256","name":"UrlAppStore","type":"text"},domProps:{"value":(_vm.selectedProject.UrlAppStore)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedProject, "UrlAppStore", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.saveProject}},[_vm._v("Сохранить")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeModal('ppAppAccessControlModal')}}},[_vm._v("Отмена")])])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Доступ к приложению"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"head-show"},[_c('tr',{staticClass:"heading"},[_c('th',[_vm._v("Название проекта")]),_vm._v(" "),_c('th',[_vm._v("URL адрес")]),_vm._v(" "),_c('th',[_vm._v("Доступ к приложению")]),_vm._v(" "),_c('th',[_vm._v("Ссылка в Google Play")]),_vm._v(" "),_c('th',[_vm._v("Ссылка в App Store")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectEdit_vue__ = __webpack_require__(269);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdf0feca_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectEdit_vue__ = __webpack_require__(722);
function injectStyle (ssrContext) {
  __webpack_require__(720)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fdf0feca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdf0feca_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(721);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("08410f6b", content, true, {});

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".draggable-item.no-drag[data-v-fdf0feca]{cursor:default}.block-in-page.opened>.block-in-page-detail[data-v-fdf0feca]{min-height:250px}.form-field.form-field-auto[data-v-fdf0feca]{width:auto}", ""]);

// exports


/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel"},[(_vm.project != null)?[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"btn-back margin-right-10"},[_c('a',{staticClass:"router-link-active",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.$router.push('/projects')}}},[_vm._v("Назад")])]),_vm._v(" "),(_vm.project.new)?_c('p',{staticClass:"caption-help margin-right-10"},[_vm._v(" Новый проект")]):_vm._e(),_vm._v(" "),(!_vm.project.new)?_c('p',{staticClass:"caption-help margin-right-10"},[_vm._v(" Редактирование ")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"caption-help margin-right-10"},[_vm._v(_vm._s(_vm.project.Name))])])]),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[_c('div',{staticClass:"btns flex",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveProject()}}},[_vm._v("Сохранить")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.cancel()}}},[_vm._v("Отмена")]),_vm._v(" "),(!_vm.project.new && _vm.info.User && (_vm.info.User.MainRole === 'administrators'))?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteProject()}}},[_vm._v("Удалить")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page"},[(!_vm.project.new)?_c('div',{staticClass:"block-in-page"},[_c('div',{staticClass:"flex btns",staticStyle:{"margin-right":"25px"},attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.onRoles}},[_vm._v("\n                        Управление ролями\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.onUsers}},[_vm._v("\n                        Управление пользователями\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.onTradePoints}},[_vm._v("\n                        Торговые точки\n                    ")])])]):_vm._e(),_vm._v(" "),_c('div',[_c('form',{staticClass:"form-horizontal",attrs:{"action":"#","novalidate":"novalidate","autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return _vm.saveProject.apply(null, arguments)}}},[_c('div',{staticClass:"block-in-page closed"},[_c('h2',{staticClass:"margin-bottom-20 block-in-page-collapce"},[_vm._v("Основные настройки")]),_vm._v(" "),_c('div',{staticClass:"block-in-page-detail"},[_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.project.Name),expression:"project.Name"}],class:['input-text', {'input-error': _vm.errors.has('Name')}],attrs:{"name":"Name","type":"text"},domProps:{"value":(_vm.project.Name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project, "Name", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Name')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.project.PromoName),expression:"project.PromoName"}],class:['input-text', {'input-error': _vm.errors.has('PromoName')}],attrs:{"name":"PromoName","type":"text"},domProps:{"value":(_vm.project.PromoName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project, "PromoName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('PromoName')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.project.Subdomain),expression:"project.Subdomain"}],class:['input-text', {'input-error': _vm.errors.has('Subdomain')}],attrs:{"name":"Subdomain","type":"text"},domProps:{"value":(_vm.project.Subdomain)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project, "Subdomain", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Subdomain')))])])]),_vm._v(" "),_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-text', {'input-error': _vm.errors.has('StartDateFormatted')}],attrs:{"name":"StartDateFormatted"},on:{"input":function($event){return _vm.onChangeDate(_vm.project, 'StartDateFormatted', 'StartDate')}},model:{value:(_vm.project.StartDateFormatted),callback:function ($$v) {_vm.$set(_vm.project, "StartDateFormatted", $$v)},expression:"project.StartDateFormatted"}})],1),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('StartDateFormatted')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{staticClass:"input-text",attrs:{"name":"EndDateFormatted"},on:{"input":function($event){return _vm.onChangeDate(_vm.project, 'EndDateFormatted', 'EndDate')}},model:{value:(_vm.project.EndDateFormatted),callback:function ($$v) {_vm.$set(_vm.project, "EndDateFormatted", $$v)},expression:"project.EndDateFormatted"}})],1),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('EndDateFormatted')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Название css файла\n                                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.CssFileName),expression:"project.CssFileName"}],class:['input-text', {'input-error': _vm.errors.has('CssFileName')}],attrs:{"name":"CssFileName","placeholder":"example.css","type":"text"},domProps:{"value":(_vm.project.CssFileName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project, "CssFileName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('CssFileName')))])])]),_vm._v(" "),_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Giftery Api Id\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.GifteryApiId),expression:"project.GifteryApiId"}],class:['input-text', {'input-error': _vm.errors.has('GifteryApiId')}],attrs:{"type":"text","name":"GifteryApiId","autocomplete":"nope"},domProps:{"value":(_vm.project.GifteryApiId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project, "GifteryApiId", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Giftery Secret Key\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.GifterySecretKey),expression:"project.GifterySecretKey"}],class:['input-text', {'input-error': _vm.errors.has('GifterySecretKey')}],attrs:{"type":"text","name":"GifterySecretKey","autocomplete":"off"},domProps:{"value":(_vm.project.GifterySecretKey)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project, "GifterySecretKey", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Расчет НДФЛ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.filteredAdditionalValueFeeOptions,"dataField":'Value',"textField":'Name'},model:{value:(_vm.project.ValueAddedFee),callback:function ($$v) {_vm.$set(_vm.project, "ValueAddedFee", $$v)},expression:"project.ValueAddedFee"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Страна")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.countries,"dataField":'Id',"textField":'Name'},on:{"change":_vm.onCountryChange},model:{value:(_vm.project.CountryId),callback:function ($$v) {_vm.$set(_vm.project, "CountryId", $$v)},expression:"project.CountryId"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field"}),_vm._v(" "),_c('div',{staticClass:"form-field"})]),_vm._v(" "),_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-15"}),_vm._v(" "),_c('label',{staticClass:"input-text-lbl"},[_vm._v("Логотип проекта:")]),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-10 flex"},[(_vm.project.Image && !_vm.deleteImage)?_c('div',{staticClass:"form-field file-uploaded margin-right-20"},[_c('img',{attrs:{"src":_vm.project.Image}}),_vm._v(" "),(_vm.project.Image && !_vm.deleteImage )?_c('button',{staticClass:"btn btn-delete margin-top-15",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeImage()}}},[_vm._v("\n                                        Удалить изображение\n                                    ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('div',{staticClass:"file-upload-zone"},[_c('input',{ref:"dropFiles",staticClass:"file-upload-zone-btn",attrs:{"type":"file","id":"dropFiles","name":"dropFiles","accept":".jpg,.jpeg,.png,.gif,.bmp"}}),_vm._v(" "),_c('label',{staticClass:"file-upload-zone-lbl",attrs:{"id":"dropFilesBtnLbl","for":"dropFiles"}},[_vm._v("\n                                            Перетяните\n                                            сюда изображение или нажмите, чтобы выбрать\n                                        ")])]),_vm._v(" "),(_vm.file != null)?_c('div',{staticClass:"fileList",attrs:{"id":"fileList"}},[_vm._v("\n                                        Выбран файл: "+_vm._s(_vm.file.name)+"\n                                    ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-15"}),_vm._v(" "),_c('label',{staticClass:"input-text-lbl"},[_vm._v("Логотип для стартовой страницы:")]),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-10 flex"},[(_vm.project.StartImage && !_vm.deleteStartImage)?_c('div',{staticClass:"form-field file-uploaded margin-right-20"},[_c('img',{attrs:{"src":_vm.project.StartImage}}),_vm._v(" "),(_vm.project.StartImage && !_vm.deleteStartImage )?_c('button',{staticClass:"btn btn-delete margin-top-15",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeStartImage()}}},[_vm._v("\n                                        Удалить изображение\n                                    ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('div',{staticClass:"file-upload-zone"},[_c('input',{ref:"dropFilesStart",staticClass:"file-upload-zone-btn",attrs:{"type":"file","id":"dropFilesStart","name":"dropFilesStart","accept":".jpg,.jpeg,.png,.gif,.bmp"}}),_vm._v(" "),_c('label',{staticClass:"file-upload-zone-lbl",attrs:{"id":"dropFilesBtnLblStart","for":"dropFilesStart"}},[_vm._v("\n                                            Перетяните\n                                            сюда изображение или нажмите, чтобы выбрать\n                                        ")])]),_vm._v(" "),(_vm.fileStart != null)?_c('div',{staticClass:"fileList",attrs:{"id":"fileListStart"}},[_vm._v("\n                                        Выбран файл: "+_vm._s(_vm.fileStart.name)+"\n                                    ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-15"}),_vm._v(" "),_c('label',{staticClass:"input-text-lbl"},[_vm._v("Политика конфиденциальности сервиса:")]),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-10 flex"},[(_vm.project.PolicyFile && !_vm.deletePolicyFile)?_c('div',{staticClass:"form-field file-uploaded margin-right-20"},[_c('a',{attrs:{"href":_vm.project.PolicyFile,"target":"_blank"}},[_vm._v("Политика сервиса")]),_vm._v(" "),(_vm.project.PolicyFile && !_vm.deletePolicyFile)?_c('button',{staticClass:"btn btn-delete margin-top-15",attrs:{"type":"button"},on:{"click":function($event){_vm.deletePolicyFile = true}}},[_vm._v("\n                                        Удалить файл\n                                    ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('div',{staticClass:"file-upload-zone"},[_c('input',{ref:"dropFiles2",staticClass:"file-upload-zone-btn",attrs:{"type":"file","id":"dropFiles2","name":"dropFiles2","accept":".pdf,.html"}}),_vm._v(" "),_c('label',{staticClass:"file-upload-zone-lbl",attrs:{"for":"dropFiles2"}},[_vm._v("Перетяните сюда файл или нажмите, чтобы выбрать")])]),_vm._v(" "),(_vm.policyFile != null)?_c('div',{staticClass:"fileList"},[_vm._v("\n                                        Выбран файл: "+_vm._s(_vm.policyFile.name)+"\n                                    ")]):_vm._e()])]),_vm._v(" "),_c('label',{staticClass:"input-text-lbl"},[_vm._v("Правила программы:")]),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-10 flex"},[(_vm.project.RulesFile && !_vm.deleteRulesFile)?_c('div',{staticClass:"form-field file-uploaded margin-right-20"},[_c('a',{attrs:{"href":_vm.project.RulesFile,"target":"_blank"}},[_vm._v("Правила программы")]),_vm._v(" "),(_vm.project.RulesFile && !_vm.deleteRulesFile)?_c('button',{staticClass:"btn btn-delete margin-top-15",attrs:{"type":"button"},on:{"click":function($event){_vm.deleteRulesFile = true}}},[_vm._v("\n                                        Удалить файл\n                                    ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('div',{staticClass:"file-upload-zone"},[_c('input',{ref:"dropFiles3",staticClass:"file-upload-zone-btn",attrs:{"type":"file","id":"dropFiles3","name":"dropFiles3","accept":".pdf,.html"}}),_vm._v(" "),_c('label',{staticClass:"file-upload-zone-lbl",attrs:{"for":"dropFiles3"}},[_vm._v("Перетяните сюда файл или нажмите, чтобы выбрать")])]),_vm._v(" "),(_vm.rulesFile != null)?_c('div',{staticClass:"fileList"},[_vm._v("\n                                        Выбран файл: "+_vm._s(_vm.rulesFile.name)+"\n                                    ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-15"}),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.RegisterSettings.AutoConfirmUser),expression:"project.RegisterSettings.AutoConfirmUser"}],staticClass:"input-checkbox",attrs:{"id":"RegisterSettings.AutoConfirmUser","name":"RegisterSettings.AutoConfirmUser","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.project.RegisterSettings.AutoConfirmUser)?_vm._i(_vm.project.RegisterSettings.AutoConfirmUser,"true")>-1:(_vm.project.RegisterSettings.AutoConfirmUser)},on:{"change":function($event){var $$a=_vm.project.RegisterSettings.AutoConfirmUser,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.project.RegisterSettings, "AutoConfirmUser", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.project.RegisterSettings, "AutoConfirmUser", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.project.RegisterSettings, "AutoConfirmUser", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"RegisterSettings.AutoConfirmUser"}},[_vm._v("Автоматическое подтверждение пользователя")])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.RegisterSettings.Enabled),expression:"project.RegisterSettings.Enabled"}],staticClass:"input-checkbox",attrs:{"id":"RegisterSettings.Enabled","name":"RegisterSettings.Enabled","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.project.RegisterSettings.Enabled)?_vm._i(_vm.project.RegisterSettings.Enabled,"true")>-1:(_vm.project.RegisterSettings.Enabled)},on:{"change":function($event){var $$a=_vm.project.RegisterSettings.Enabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.project.RegisterSettings, "Enabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.project.RegisterSettings, "Enabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.project.RegisterSettings, "Enabled", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"RegisterSettings.Enabled"}},[_vm._v("Разрешить самостоятельную регистрацию")])]),_vm._v(" "),(_vm.project.RegisterSettings.Enabled)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Код для регистрации через мобильное приложение")]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticStyle:{"width":"100%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.RegisterCodeMobile),expression:"project.RegisterCodeMobile"}],staticClass:"input-text",attrs:{"type":"text","name":"RegisterCodeMobile","disabled":"true"},domProps:{"value":(_vm.project.RegisterCodeMobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project, "RegisterCodeMobile", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticStyle:{"width":"110px","min-width":"110px","margin-left":"15px"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.GetRegisterCodeMobile.apply(null, arguments)}}},[_vm._v("Обновить код")])])])]):_vm._e(),_vm._v(" "),(_vm.project.RegisterSettings.Enabled)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Роль по умолчанию")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.rolesOrdered,"dataField":'Id',"textField":'Name'},model:{value:(_vm.project.RegisterSettings.DefaultRoleId),callback:function ($$v) {_vm.$set(_vm.project.RegisterSettings, "DefaultRoleId", $$v)},expression:"project.RegisterSettings.DefaultRoleId"}})],1):_vm._e(),_vm._v(" "),(_vm.project.RegisterSettings.Enabled)?_c('div',{staticClass:"form-field draggable-item",staticStyle:{"cursor":"default"}},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.RegisterSettings.RegisterTradePointName),expression:"project.RegisterSettings.RegisterTradePointName"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-text', {'input-error': _vm.errors.has('RegisterTradePointName')}],attrs:{"type":"text","name":"RegisterTradePointName","autocomplete":"off","disabled":_vm.project.RegisterSettings.RegisterTradePointDisabled},domProps:{"value":(_vm.project.RegisterSettings.RegisterTradePointName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project.RegisterSettings, "RegisterTradePointName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('RegisterTradePointName')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('drop-down',{attrs:{"items":[{Id: 0, Name:'Ввод текста'}, {Id: 1, Name:'Выбор из адрески'}],"dataField":'Id',"textField":'Name',"disabled":_vm.project.RegisterSettings.RegisterTradePointDisabled},model:{value:(_vm.project.RegisterSettings.RegisterTradePointType),callback:function ($$v) {_vm.$set(_vm.project.RegisterSettings, "RegisterTradePointType", $$v)},expression:"project.RegisterSettings.RegisterTradePointType"}})],1)]),_vm._v(" "),(_vm.project.RegisterSettings.RegisterTradePointType === _vm.RegisterTradePointTypes.Select)?_c('div',{staticClass:"form-field"},[_c('div',{staticClass:"form-field-group"},[_c('div',{},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({ required: _vm.tradePointColumnsRequired }),expression:"{ required: tradePointColumnsRequired }"},{name:"model",rawName:"v-model",value:(_vm.project.RegisterSettings.TradePointColumns),expression:"project.RegisterSettings.TradePointColumns"}],class:['input-checkbox', {'input-error': _vm.errors.has('TradePointColumns2')}],attrs:{"id":"TradePointColumns2","name":"TradePointColumns2","value":"[Area]","type":"checkbox","disabled":_vm.project.RegisterSettings.RegisterTradePointDisabled},domProps:{"checked":Array.isArray(_vm.project.RegisterSettings.TradePointColumns)?_vm._i(_vm.project.RegisterSettings.TradePointColumns,"[Area]")>-1:(_vm.project.RegisterSettings.TradePointColumns)},on:{"change":function($event){var $$a=_vm.project.RegisterSettings.TradePointColumns,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="[Area]",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.project.RegisterSettings, "TradePointColumns", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.project.RegisterSettings, "TradePointColumns", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.project.RegisterSettings, "TradePointColumns", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"TradePointColumns2"}},[_vm._v("Область")])]),_vm._v(" "),_c('div',{staticClass:"margin-left-20"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({ required: _vm.tradePointColumnsRequired }),expression:"{ required: tradePointColumnsRequired }"},{name:"model",rawName:"v-model",value:(_vm.project.RegisterSettings.TradePointColumns),expression:"project.RegisterSettings.TradePointColumns"}],class:['input-checkbox', {'input-error': _vm.errors.has('TradePointColumns3')}],attrs:{"id":"TradePointColumns3","name":"TradePointColumns3","value":"[Region]","type":"checkbox","disabled":_vm.project.RegisterSettings.RegisterTradePointDisabled},domProps:{"checked":Array.isArray(_vm.project.RegisterSettings.TradePointColumns)?_vm._i(_vm.project.RegisterSettings.TradePointColumns,"[Region]")>-1:(_vm.project.RegisterSettings.TradePointColumns)},on:{"change":function($event){var $$a=_vm.project.RegisterSettings.TradePointColumns,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="[Region]",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.project.RegisterSettings, "TradePointColumns", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.project.RegisterSettings, "TradePointColumns", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.project.RegisterSettings, "TradePointColumns", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"TradePointColumns3"}},[_vm._v("Регион")])]),_vm._v(" "),_c('div',{staticClass:"margin-left-20"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({ required: _vm.tradePointColumnsRequired }),expression:"{ required: tradePointColumnsRequired }"},{name:"model",rawName:"v-model",value:(_vm.project.RegisterSettings.TradePointColumns),expression:"project.RegisterSettings.TradePointColumns"}],class:['input-checkbox', {'input-error': _vm.errors.has('TradePointColumns4')}],attrs:{"id":"TradePointColumns4","name":"TradePointColumns4","value":"[City]","type":"checkbox","disabled":_vm.project.RegisterSettings.RegisterTradePointDisabled},domProps:{"checked":Array.isArray(_vm.project.RegisterSettings.TradePointColumns)?_vm._i(_vm.project.RegisterSettings.TradePointColumns,"[City]")>-1:(_vm.project.RegisterSettings.TradePointColumns)},on:{"change":function($event){var $$a=_vm.project.RegisterSettings.TradePointColumns,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="[City]",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.project.RegisterSettings, "TradePointColumns", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.project.RegisterSettings, "TradePointColumns", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.project.RegisterSettings, "TradePointColumns", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"TradePointColumns4"}},[_vm._v("Город")])]),_vm._v(" "),_c('div',{staticClass:"margin-left-20"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({ required: _vm.tradePointColumnsRequired }),expression:"{ required: tradePointColumnsRequired }"},{name:"model",rawName:"v-model",value:(_vm.project.RegisterSettings.TradePointColumns),expression:"project.RegisterSettings.TradePointColumns"}],class:['input-checkbox', {'input-error': _vm.errors.has('TradePointColumns5')}],attrs:{"id":"TradePointColumns5","name":"TradePointColumns5","value":"[Address]","type":"checkbox","disabled":_vm.project.RegisterSettings.RegisterTradePointDisabled},domProps:{"checked":Array.isArray(_vm.project.RegisterSettings.TradePointColumns)?_vm._i(_vm.project.RegisterSettings.TradePointColumns,"[Address]")>-1:(_vm.project.RegisterSettings.TradePointColumns)},on:{"change":function($event){var $$a=_vm.project.RegisterSettings.TradePointColumns,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="[Address]",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.project.RegisterSettings, "TradePointColumns", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.project.RegisterSettings, "TradePointColumns", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.project.RegisterSettings, "TradePointColumns", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"TradePointColumns5"}},[_vm._v("Адрес")])]),_vm._v(" "),_c('div',{staticClass:"margin-left-20"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({ required: _vm.tradePointColumnsRequired }),expression:"{ required: tradePointColumnsRequired }"},{name:"model",rawName:"v-model",value:(_vm.project.RegisterSettings.TradePointColumns),expression:"project.RegisterSettings.TradePointColumns"}],class:['input-checkbox', {'input-error': _vm.errors.has('TradePointColumns1')}],attrs:{"id":"TradePointColumns1","name":"TradePointColumns1","value":"[Name]","type":"checkbox","disabled":_vm.project.RegisterSettings.RegisterTradePointDisabled},domProps:{"checked":Array.isArray(_vm.project.RegisterSettings.TradePointColumns)?_vm._i(_vm.project.RegisterSettings.TradePointColumns,"[Name]")>-1:(_vm.project.RegisterSettings.TradePointColumns)},on:{"change":function($event){var $$a=_vm.project.RegisterSettings.TradePointColumns,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="[Name]",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.project.RegisterSettings, "TradePointColumns", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.project.RegisterSettings, "TradePointColumns", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.project.RegisterSettings, "TradePointColumns", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"TradePointColumns1"}},[_vm._v("Наименование")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.RegisterSettings.RegisterTradePointDisabled),expression:"project.RegisterSettings.RegisterTradePointDisabled"}],staticClass:"input-checkbox",attrs:{"id":"RegisterTradePointDisabled","name":"RegisterTradePointDisabled","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.project.RegisterSettings.RegisterTradePointDisabled)?_vm._i(_vm.project.RegisterSettings.RegisterTradePointDisabled,"true")>-1:(_vm.project.RegisterSettings.RegisterTradePointDisabled)},on:{"change":function($event){var $$a=_vm.project.RegisterSettings.RegisterTradePointDisabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.project.RegisterSettings, "RegisterTradePointDisabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.project.RegisterSettings, "RegisterTradePointDisabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.project.RegisterSettings, "RegisterTradePointDisabled", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",staticStyle:{"margin-top":"0"},attrs:{"for":"RegisterTradePointDisabled"}},[_vm._v("Отключить поле")])])]):_vm._e(),_vm._v(" "),(_vm.project.RegisterSettings.Enabled)?_c('div',{staticClass:"form-field"},[_c('Container',{attrs:{"lock-axis":'y'},on:{"drop":_vm.onRegFieldsDrop}},_vm._l((_vm.regFieldsOrdered),function(field,i){return _c('Draggable',[_c('div',{staticClass:"draggable-item"},[_c('div',{staticClass:"form-field-group mob-inline"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                                            Название\n                                                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(field.FieldName),expression:"field.FieldName"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"input-text",class:['input-text', {'input-error': _vm.errors.has('fieldName' + i)}],attrs:{"type":"text","placeholder":"Название","maxlength":"245","name":'fieldName' + i,"data-vv-as":"Название"},domProps:{"value":(field.FieldName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(field, "FieldName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('fieldName' + i)))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                                            Тип поля\n                                                        ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":[{Id: 'text', Name:'Ввод текста'}, {Id: 'select', Name:'Список'}],"dataField":'Id',"textField":'Name'},model:{value:(field.FieldType),callback:function ($$v) {_vm.$set(field, "FieldType", $$v)},expression:"field.FieldType"}})],1),_vm._v(" "),(_vm.project.new || field.new || field.CanDelete)?_c('div',{staticClass:"form-field",staticStyle:{"width":"35px","min-width":"35px","padding-top":"23px"}},[_c('button',{staticClass:"btn btn-default btn-img",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onRemoveRegField(i)}}},[_c('img',{attrs:{"src":__webpack_require__(17),"alt":""}})])]):_vm._e()]),_vm._v(" "),(field.FieldType === 'select')?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                                        Массив вариантов выпадающего списка в формате [\"Вариант-1\", \"Вариант-2\"]"),_c('br'),_vm._v(" "),_c('span',{staticClass:"test-wrong"},[_vm._v("Двойные кавычки используются только для обозначения границ слова")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(field.Options),expression:"field.Options"},{name:"validate",rawName:"v-validate",value:({required: true, jsonArray: true}),expression:"{required: true, jsonArray: true}"}],class:['input-text', {'input-error': _vm.errors.has('fieldNameSelect' + i)}],attrs:{"type":"text","name":'fieldNameSelect' + i,"placeholder":"Массив вариантов через запятую, напр.: [\"Вариант-1\", \"Вариант-2\"]","data-vv-as":"Массив"},domProps:{"value":(field.Options)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(field, "Options", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('fieldNameSelect' + i)))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(field.Deleted),expression:"field.Deleted"}],staticClass:"input-checkbox",attrs:{"id":'fieldDeleted' + i,"name":'fieldDeleted' + i,"value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(field.Deleted)?_vm._i(field.Deleted,"true")>-1:(field.Deleted)},on:{"change":function($event){var $$a=field.Deleted,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(field, "Deleted", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(field, "Deleted", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(field, "Deleted", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",staticStyle:{"margin-top":"0"},attrs:{"for":'fieldDeleted' + i}},[_vm._v("Отключить поле")])])])])}),1),_vm._v(" "),_c('button',{staticClass:"btn btn-primary margin-top-15 btn-img",attrs:{"type":"button"},on:{"click":function($event){return _vm.addRegField()}}},[_c('img',{attrs:{"src":__webpack_require__(43),"alt":""}})])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-15"}),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.ExternalEnabled),expression:"project.ExternalEnabled"}],staticClass:"input-checkbox",attrs:{"id":"ExternalEnabled","value":"false","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.project.ExternalEnabled)?_vm._i(_vm.project.ExternalEnabled,"false")>-1:(_vm.project.ExternalEnabled)},on:{"change":function($event){var $$a=_vm.project.ExternalEnabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="false",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.project, "ExternalEnabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.project, "ExternalEnabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.project, "ExternalEnabled", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"ExternalEnabled"}},[_vm._v("Разрешить авторизацию через соц. сети")])]),_vm._v(" "),(_vm.project.ExternalEnabled)?_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field form-field-auto"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.ExternalVk),expression:"project.ExternalVk"}],staticClass:"input-checkbox",attrs:{"id":"ExternalVk","value":"false","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.project.ExternalVk)?_vm._i(_vm.project.ExternalVk,"false")>-1:(_vm.project.ExternalVk)},on:{"change":function($event){var $$a=_vm.project.ExternalVk,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="false",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.project, "ExternalVk", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.project, "ExternalVk", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.project, "ExternalVk", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"ExternalVk"}},[_vm._v("Vk")])]),_vm._v(" "),_c('div',{staticClass:"form-field form-field-auto"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.ExternalGoogle),expression:"project.ExternalGoogle"}],staticClass:"input-checkbox",attrs:{"id":"ExternalGoogle","value":"false","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.project.ExternalGoogle)?_vm._i(_vm.project.ExternalGoogle,"false")>-1:(_vm.project.ExternalGoogle)},on:{"change":function($event){var $$a=_vm.project.ExternalGoogle,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="false",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.project, "ExternalGoogle", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.project, "ExternalGoogle", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.project, "ExternalGoogle", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"ExternalGoogle"}},[_vm._v("Google")])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"block-in-page closed"},[_c('h2',{staticClass:"margin-bottom-20 block-in-page-collapce"},[_vm._v("Названия разделов")]),_vm._v(" "),_c('div',{staticClass:"block-in-page-detail"},[(_vm.reportAddPage)?_c('div',{staticClass:"draggable-item no-drag",on:{"dblclick":function($event){return _vm.onPageEdit(_vm.reportAddPage)}}},[(_vm.reportAddPage.Edited)?[_c('div',{staticClass:"form-field flex"},[_c('label',{staticClass:"input-text-lbl",staticStyle:{"padding-top":"8px","margin-right":"20px"}},[_vm._v(_vm._s(_vm.reportAddPage.DefaultName))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reportAddPage.Name),expression:"reportAddPage.Name"}],staticClass:"input-text",attrs:{"type":"text"},domProps:{"value":(_vm.reportAddPage.Name)},on:{"click":function($event){$event.stopPropagation();},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reportAddPage, "Name", $event.target.value)}}})])]:_vm._e(),_vm._v(" "),(!_vm.reportAddPage.Edited)?[_vm._v("\n                                    "+_vm._s(_vm.reportAddPage.DefaultName)+" - "+_vm._s(_vm.reportAddPage.Name)+"\n                                    "),_c('div',{staticClass:"btns flex",staticStyle:{"float":"right","margin-top":"-6px"}},[_c('button',{staticClass:"btn btn-default btn-img",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onPageEdit(_vm.reportAddPage)}}},[_c('img',{attrs:{"src":__webpack_require__(31),"alt":""}})])])]:_vm._e()],2):_vm._e(),_vm._v(" "),_c('Container',{attrs:{"lock-axis":'y'},on:{"drop":_vm.onDrop}},_vm._l((_vm.pagesOrdered),function(page,i){return _c('Draggable',{attrs:{"lock-axis":'x'}},[_c('div',{staticClass:"draggable-item",on:{"dblclick":function($event){return _vm.onPageEdit(page)}}},[(page.Edited)?[_c('div',{staticClass:"form-field flex"},[_c('label',{staticClass:"input-text-lbl",staticStyle:{"padding-top":"8px","margin-right":"20px"}},[_vm._v(_vm._s(page.DefaultName))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(page.Name),expression:"page.Name"}],staticClass:"input-text",attrs:{"type":"text"},domProps:{"value":(page.Name)},on:{"mousedown":function($event){$event.stopPropagation();},"click":function($event){$event.stopPropagation();},"input":function($event){if($event.target.composing){ return; }_vm.$set(page, "Name", $event.target.value)}}})])]:_vm._e(),_vm._v(" "),(!page.Edited)?[_vm._v("\n                                            "+_vm._s(page.DefaultName)+" - "+_vm._s(page.Name)+"\n                                            "),_c('div',{staticClass:"btns flex",staticStyle:{"float":"right","margin-top":"-6px"}},[_c('button',{staticClass:"btn btn-default btn-img",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onPageEdit(page)}}},[_c('img',{attrs:{"src":__webpack_require__(31),"alt":""}})])])]:_vm._e()],2)])}),1)],1)]),_vm._v(" "),_c('div',{staticClass:"block-in-page closed"},[_c('h2',{staticClass:"margin-bottom-20 block-in-page-collapce"},[_vm._v("Настройка отчета")]),_vm._v(" "),_c('div',{staticClass:"block-in-page-detail"},[_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_c('drop-down',{attrs:{"items":[{Id: 0, Name:'Выключить отчеты'},{Id: 1, Name:'Ручной режим внесения данных'},{Id: 2, Name:'Загрузка через QR код'}],"dataField":'Id',"textField":'Name'},model:{value:(_vm.project.ReportType),callback:function ($$v) {_vm.$set(_vm.project, "ReportType", $$v)},expression:"project.ReportType"}})],1)]),_vm._v(" "),(_vm.project.ReportType === 1)?[_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field",staticStyle:{"width":"30%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.ReportExcelEnabled),expression:"project.ReportExcelEnabled"}],staticClass:"input-checkbox",attrs:{"id":"ReportExcelEnabled","name":"ReportExcelEnabled","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.project.ReportExcelEnabled)?_vm._i(_vm.project.ReportExcelEnabled,"true")>-1:(_vm.project.ReportExcelEnabled)},on:{"change":function($event){var $$a=_vm.project.ReportExcelEnabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.project, "ReportExcelEnabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.project, "ReportExcelEnabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.project, "ReportExcelEnabled", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"ReportExcelEnabled"}},[_vm._v("Разрешить импорт из Excel")])])]),_vm._v(" "),_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-15"}),_vm._v(" "),_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field",staticStyle:{"width":"30%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.ReportOnlyOneItemAllowed),expression:"project.ReportOnlyOneItemAllowed"}],staticClass:"input-checkbox",attrs:{"id":"ReportOnlyOneItemAllowed","name":"ReportOnlyOneItemAllowed","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.project.ReportOnlyOneItemAllowed)?_vm._i(_vm.project.ReportOnlyOneItemAllowed,"true")>-1:(_vm.project.ReportOnlyOneItemAllowed)},on:{"change":function($event){var $$a=_vm.project.ReportOnlyOneItemAllowed,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.project, "ReportOnlyOneItemAllowed", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.project, "ReportOnlyOneItemAllowed", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.project, "ReportOnlyOneItemAllowed", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"ReportOnlyOneItemAllowed"}},[_vm._v("Можно добавить только одну запись в таблицу")])])]),_vm._v(" "),_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-15"}),_vm._v(" "),_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field",staticStyle:{"width":"250px","min-width":"250px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.ReportDateRequired),expression:"project.ReportDateRequired"}],staticClass:"input-checkbox",attrs:{"id":"ReportDateRequired","name":"ReportDateRequired","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.project.ReportDateRequired)?_vm._i(_vm.project.ReportDateRequired,"true")>-1:(_vm.project.ReportDateRequired)},on:{"change":function($event){var $$a=_vm.project.ReportDateRequired,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.project, "ReportDateRequired", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.project, "ReportDateRequired", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.project, "ReportDateRequired", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"ReportDateRequired"}},[_vm._v("Указывать дату отчета")])]),_vm._v(" "),(_vm.project.ReportDateRequired)?[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                                Название поля в отчете\n                                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.ReportDateCaption),expression:"project.ReportDateCaption"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"input-text",class:['input-text', {'input-error': _vm.errors.has('ReportDateCaption')}],attrs:{"type":"text","name":"ReportDateCaption"},domProps:{"value":(_vm.project.ReportDateCaption)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project, "ReportDateCaption", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"})]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.ReportDateDefault),expression:"project.ReportDateDefault"}],staticClass:"input-checkbox",attrs:{"id":"ReportDateDefault","name":"ReportDateDefault","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.project.ReportDateDefault)?_vm._i(_vm.project.ReportDateDefault,"true")>-1:(_vm.project.ReportDateDefault)},on:{"change":function($event){var $$a=_vm.project.ReportDateDefault,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.project, "ReportDateDefault", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.project, "ReportDateDefault", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.project, "ReportDateDefault", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"ReportDateDefault"}},[_vm._v("По умолчанию \"сегодня\"")])])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-15"}),_vm._v(" "),_c('Container',{attrs:{"lock-axis":'y'},on:{"drop":_vm.onReportSettingsDrop}},_vm._l((_vm.reportSettingsOrdered),function(settings,i){return _c('Draggable',[_c('div',{staticClass:"draggable-item"},[_c('div',{staticClass:"form-field-group"},[(settings.type !== 'sku')?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                                        Название поля в БД\n                                                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(settings.name),expression:"settings.name"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"input-text",class:['input-text', {'input-error': _vm.errors.has('settingsName' + i)}],attrs:{"type":"text","placeholder":"Поле в базе данных","name":'settingsName' + i,"disabled":!_vm.project.new && !settings.new},domProps:{"value":(settings.name)},on:{"change":function($event){return _vm.onReportSettingsCaptionChange(settings)},"input":function($event){if($event.target.composing){ return; }_vm.$set(settings, "name", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                                        Название поля в отчете\n                                                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(settings.caption),expression:"settings.caption"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"input-text",class:['input-text', {'input-error': _vm.errors.has('settingsCaption' + i)}],attrs:{"type":"text","placeholder":"Заголовок","name":'settingsCaption' + i},domProps:{"value":(settings.caption)},on:{"change":function($event){return _vm.onReportSettingsCaptionChange(settings)},"input":function($event){if($event.target.composing){ return; }_vm.$set(settings, "caption", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"})]),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"200px","min-width":"200px"}},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                                        Тип поля\n                                                    ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.reportSettingsTypes,"dataField":'Id',"textField":'Name'},on:{"change":function($event){return _vm.onReportSettingsTypesChange(settings)}},model:{value:(settings.type),callback:function ($$v) {_vm.$set(settings, "type", $$v)},expression:"settings.type"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                                        Описание\n                                                    ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(settings.description),expression:"settings.description"}],class:['input-memo', {'input-error': _vm.errors.has('SettingsDescription' + i)}],staticStyle:{"height":"50px"},attrs:{"rows":"10","name":'SettingsDescription' + i,"data-vv-as":"Описание"},domProps:{"value":(settings.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(settings, "description", $event.target.value)}}})]),_vm._v(" "),(settings.type === 'sku')?_c('div',{staticClass:"form-field",staticStyle:{"width":"200px","min-width":"200px","padding-top":"23px"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.setUpSkuList(settings)}}},[_vm._v("Настроить выбор")])]):_vm._e(),_vm._v(" "),(settings.type === 'sku')?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                                        Название подсказки при выборе\n                                                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(settings.placeholder),expression:"settings.placeholder"}],staticClass:"input-text",class:['input-text', {'input-error': _vm.errors.has('settingsPlaceholder' + i)}],attrs:{"type":"text","placeholder":"По умолчанию - Выберите sku","name":'settingsPlaceholder' + i},domProps:{"value":(settings.placeholder)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(settings, "placeholder", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.project.new || settings.new)?_c('div',{staticClass:"form-field",staticStyle:{"width":"35px","min-width":"35px","padding-top":"23px"}},[_c('button',{staticClass:"btn btn-default btn-img",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onRemoveReportSettings(settings, i)}}},[_c('img',{attrs:{"src":__webpack_require__(17),"alt":""}})])]):_vm._e(),_vm._v(" "),(!_vm.project.new && !settings.new)?_c('div',{staticClass:"form-field",staticStyle:{"width":"110px","min-width":"110px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(settings.deleted),expression:"settings.deleted"}],staticClass:"input-checkbox",attrs:{"id":'settingsDeleted' + i,"name":'settingsDeleted' + i,"value":"true","type":"checkbox","disabled":_vm.getDisabledStatus(settings)},domProps:{"checked":Array.isArray(settings.deleted)?_vm._i(settings.deleted,"true")>-1:(settings.deleted)},on:{"change":[function($event){var $$a=settings.deleted,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(settings, "deleted", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(settings, "deleted", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(settings, "deleted", $$c)}},function($event){return _vm.onSettingsDeletedChange(settings)}]}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'settingsDeleted' + i},on:{"click":function($event){$event.stopPropagation();return _vm.onSettingsDeletedClick('settingsDeleted' + i, settings)}}},[_vm._v("Неактивно")])]):_vm._e()]),_vm._v(" "),(settings.type === 'select' && settings.name !== 'EquipmentType')?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                                    Массив вариантов выпадающего списка в формате [\"Вариант-1\", \"Вариант-2\"]"),_c('br'),_vm._v(" "),_c('span',{staticClass:"test-wrong"},[_vm._v("Лишние кавычки не допускаются!")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(settings.options),expression:"settings.options"},{name:"validate",rawName:"v-validate",value:({required: true, jsonArray: true}),expression:"{required: true, jsonArray: true}"}],class:['input-text', {'input-error': _vm.errors.has('settingsSelectArray' + i)}],attrs:{"type":"text","name":'settingsSelectArray' + i,"placeholder":"Массив вариантов через запятую, напр.: [\"Вариант-1\", \"Вариант-2\"]","data-vv-as":"Массив"},domProps:{"value":(settings.options)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(settings, "options", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('settingsSelectArray' + i)))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field"},[(settings.type === 'int' || settings.type === 'decimal')?[_c('input',{directives:[{name:"model",rawName:"v-model",value:(settings.showInReportList),expression:"settings.showInReportList"}],staticClass:"input-checkbox",attrs:{"id":'showInReportList' + i,"name":'showInReportList' + i,"value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(settings.showInReportList)?_vm._i(settings.showInReportList,"true")>-1:(settings.showInReportList)},on:{"change":function($event){var $$a=settings.showInReportList,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(settings, "showInReportList", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(settings, "showInReportList", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(settings, "showInReportList", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'showInReportList' + i}},[_vm._v("\n                                                        Показывать в\n                                                        списке\n                                                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(settings.sumUp),expression:"settings.sumUp"}],staticClass:"input-checkbox",attrs:{"id":'sumUp' + i,"name":'sumUp' + i,"value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(settings.sumUp)?_vm._i(settings.sumUp,"true")>-1:(settings.sumUp)},on:{"change":function($event){var $$a=settings.sumUp,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(settings, "sumUp", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(settings, "sumUp", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(settings, "sumUp", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'sumUp' + i}},[_vm._v("Суммировать")])]:_vm._e()],2)])])}),1),_vm._v(" "),_c('button',{staticClass:"btn btn-primary margin-top-15 btn-img",attrs:{"type":"button"},on:{"click":function($event){return _vm.addReportSettings()}}},[_c('img',{attrs:{"src":__webpack_require__(43),"alt":""}})])]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"block-in-page closed"},[_c('h2',{staticClass:"margin-bottom-20 block-in-page-collapce"},[_vm._v("Настройка начисления баллов за отчеты")]),_vm._v(" "),_c('div',{staticClass:"block-in-page-detail"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Частота загрузки отчётов по торговой точке\n                                ")]),_vm._v(" "),(_vm.dataLoadingFrequencies.length > 0)?_c('drop-down',{attrs:{"items":_vm.dataLoadingFrequencies,"dataField":'Id',"textField":'Name'},model:{value:(_vm.project.DataLoadingFrequency),callback:function ($$v) {_vm.$set(_vm.project, "DataLoadingFrequency", $$v)},expression:"project.DataLoadingFrequency"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Период активации баллов\n                                ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.activationPeriodTypes,"dataField":'Id',"textField":'Name'},model:{value:(_vm.project.bonusSettings.activationPeriod.type),callback:function ($$v) {_vm.$set(_vm.project.bonusSettings.activationPeriod, "type", $$v)},expression:"project.bonusSettings.activationPeriod.type"}})],1),_vm._v(" "),(_vm.project.bonusSettings.activationPeriod.type === 'sum' ||
                                      _vm.project.bonusSettings.activationPeriod.type === 'fact')?[(_vm.project.bonusSettings.activationPeriod.type === 'sum')?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Суммарно за период\n                                    ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.activationPeriods,"dataField":'Id',"textField":'Name'},model:{value:(_vm.project.bonusSettings.activationPeriod.data.period),callback:function ($$v) {_vm.$set(_vm.project.bonusSettings.activationPeriod.data, "period", $$v)},expression:"project.bonusSettings.activationPeriod.data.period"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Баллы станут доступны для использования через (дней)\n                                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.bonusSettings.activationPeriod.data.value),expression:"project.bonusSettings.activationPeriod.data.value"}],staticClass:"input-text",attrs:{"type":"text","placeholder":"Введите количество дней"},domProps:{"value":(_vm.project.bonusSettings.activationPeriod.data.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project.bonusSettings.activationPeriod.data, "value", $event.target.value)}}})]),_vm._v(" "),(_vm.project.ReportDateRequired)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        От какой даты начинается отсчет дней:\n                                    ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.activationFromDate,"dataField":'Id',"textField":'Name'},model:{value:(_vm.project.bonusSettings.activationPeriod.data.fromDate),callback:function ($$v) {_vm.$set(_vm.project.bonusSettings.activationPeriod.data, "fromDate", $$v)},expression:"project.bonusSettings.activationPeriod.data.fromDate"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Период действия баллов\n                                ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.durationPeriods,"dataField":'Id',"textField":'Name'},model:{value:(_vm.project.bonusSettings.durationPeriod),callback:function ($$v) {_vm.$set(_vm.project.bonusSettings, "durationPeriod", $$v)},expression:"project.bonusSettings.durationPeriod"}})],1),_vm._v(" "),_c('div',{staticClass:"line-separator"}),_vm._v(" "),_c('p',{staticClass:"caption-help"},[_vm._v("Баллы, начисляемые за отчеты")]),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-5"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Принцип начисления\n                                ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.bonusStrategies,"dataField":'Id',"textField":'Name'},model:{value:(_vm.project.bonusSettings.bonusStrategy.type),callback:function ($$v) {_vm.$set(_vm.project.bonusSettings.bonusStrategy, "type", $$v)},expression:"project.bonusSettings.bonusStrategy.type"}})],1),_vm._v(" "),(_vm.project.bonusSettings.bonusStrategy.type === 'fact')?[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Количество баллов\n                                    ")]),_vm._v(" "),_c('touch-spin',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-text', {'input-error': _vm.errors.has('bonusStrategyValue')}],attrs:{"name":"bonusStrategyValue","min":0,"decimals":2,"step":0.01},model:{value:(_vm.project.bonusSettings.bonusStrategy.data.value),callback:function ($$v) {_vm.$set(_vm.project.bonusSettings.bonusStrategy.data, "value", $$v)},expression:"project.bonusSettings.bonusStrategy.data.value"}})],1)]:_vm._e(),_vm._v(" "),(_vm.project.bonusSettings.bonusStrategy.type === 'data')?[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Выберите поле отчета, на основании которого начислять баллы\n                                    ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.bonusStrategyFields,"dataField":'Id',"textField":'Name'},model:{value:(_vm.project.bonusSettings.bonusStrategy.data.fieldName),callback:function ($$v) {_vm.$set(_vm.project.bonusSettings.bonusStrategy.data, "fieldName", $$v)},expression:"project.bonusSettings.bonusStrategy.data.fieldName"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Принцип начисления\n                                    ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.bonusStrategyAccrualTypes,"dataField":'Id',"textField":'Name'},model:{value:(_vm.project.bonusSettings.bonusStrategy.data.accrualType),callback:function ($$v) {_vm.$set(_vm.project.bonusSettings.bonusStrategy.data, "accrualType", $$v)},expression:"project.bonusSettings.bonusStrategy.data.accrualType"}}),_vm._v(" "),(_vm.project.bonusSettings.bonusStrategy.data.accrualType == 1)?_c('i',[_vm._v("\n                                        по факту принятия отчета берется сумма по Полю и умножается на %\n                                    ")]):_vm._e(),_vm._v(" "),(_vm.project.bonusSettings.bonusStrategy.data.accrualType == 2)?_c('i',[_vm._v("\n                                        по факту принятия отчета берется сумма по Полю и умножается на Значение\n                                    ")]):_vm._e()],1),_vm._v(" "),(_vm.project.bonusSettings.bonusStrategy.data.accrualType == 1)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Выберите дату для определения ставки процента\n                                    ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.bonusStrategyAccrualValueDate,"dataField":'Value',"textField":'Name'},model:{value:(_vm.project.bonusSettings.bonusStrategy.data.accrualValueDate),callback:function ($$v) {_vm.$set(_vm.project.bonusSettings.bonusStrategy.data, "accrualValueDate", $$v)},expression:"project.bonusSettings.bonusStrategy.data.accrualValueDate"}})],1):_vm._e(),_vm._v(" "),(_vm.project.bonusSettings.bonusStrategy.data.accrualType == 1 && _vm.project.bonusSettings.bonusStrategy.data.accrualValueDate !== 'none')?_c('div',{staticClass:"report-block-items margin-bottom-20"},[_c('report-items-table',{ref:"reportItems",staticClass:"report-items",attrs:{"bonusSettings":_vm.accrualValueTable.bonusSettings,"tradePoint":_vm.accrualValueTable.TradePoint,"reportSettings":_vm.accrualValueTable.reportSettings,"equipmentTypes":_vm.accrualValueTable.equipmentTypes,"sku":_vm.accrualValueTable.sku,"canBeEdited":_vm.accrualValueTable.canBeEdited,"minItems":_vm.accrualValueTable.minItems,"maxItems":_vm.accrualValueTable.maxItems},model:{value:(_vm.project.bonusSettings.bonusStrategy.data.ValueItems),callback:function ($$v) {_vm.$set(_vm.project.bonusSettings.bonusStrategy.data, "ValueItems", $$v)},expression:"project.bonusSettings.bonusStrategy.data.ValueItems"}})],1):_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Значение\n                                    ")]),_vm._v(" "),_c('touch-spin',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-text', {'input-error': _vm.errors.has('bonusStrategyValue')}],attrs:{"name":"bonusStrategyValue","min":0,"decimals":2,"step":0.01},model:{value:(_vm.project.bonusSettings.bonusStrategy.data.value),callback:function ($$v) {_vm.$set(_vm.project.bonusSettings.bonusStrategy.data, "value", $$v)},expression:"project.bonusSettings.bonusStrategy.data.value"}})],1)]:_vm._e(),_vm._v(" "),(_vm.project.bonusSettings.bonusStrategy.type === 'sp')?[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Выберите процедуру из базы данных\n                                    ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.bonusStrategyProcedures,"dataField":'Id',"textField":'Name'},model:{value:(_vm.project.bonusSettings.bonusStrategy.data.value),callback:function ($$v) {_vm.$set(_vm.project.bonusSettings.bonusStrategy.data, "value", $$v)},expression:"project.bonusSettings.bonusStrategy.data.value"}})],1)]:_vm._e(),_vm._v(" "),(_vm.project.bonusSettings.bonusStrategy.type === 'sku')?[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Выберите поле Sku на основании которого начисляются баллы\n                                    ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.bonusStrategySkuFields,"dataField":'Id',"textField":'Name'},model:{value:(_vm.project.bonusSettings.bonusStrategy.data.fieldName),callback:function ($$v) {_vm.$set(_vm.project.bonusSettings.bonusStrategy.data, "fieldName", $$v)},expression:"project.bonusSettings.bonusStrategy.data.fieldName"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-20"},[_vm._m(6),_vm._v(" "),_c('drop-down',{attrs:{"items":[{Id: 'fixed', Name: 'Фиксированный за единицу'}, {Id: 'percent', Name: 'Процент от суммы'}],"dataField":'Id',"textField":'Name'},model:{value:(_vm.project.bonusSettings.bonusStrategy.data.bonusType),callback:function ($$v) {_vm.$set(_vm.project.bonusSettings.bonusStrategy.data, "bonusType", $$v)},expression:"project.bonusSettings.bonusStrategy.data.bonusType"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Выберите поле Sku - "+_vm._s(_vm.project.bonusSettings.bonusStrategy.data.bonusType === 'fixed' ? 'количество' : 'сумма продажи')+"\n                                    ")]),_vm._v(" "),_c('drop-down',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:[{'input-error': _vm.errors.has('BonusStrategyFields')}],attrs:{"name":"BonusStrategyFields","items":_vm.bonusStrategyFields,"dataField":'Id',"textField":'Name',"withSelectItem":"true"},model:{value:(_vm.project.bonusSettings.bonusStrategy.data.countFieldName),callback:function ($$v) {_vm.$set(_vm.project.bonusSettings.bonusStrategy.data, "countFieldName", $$v)},expression:"project.bonusSettings.bonusStrategy.data.countFieldName"}})],1),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-20"},[_vm._m(8),_vm._v(" "),_c('drop-down',{attrs:{"items":[{Id: 'report', Name: 'Дата заполнения отчёта'}, {Id: 'selldate', Name: 'Дата «продажи»'}],"dataField":'Id',"textField":'Name',"withSelectItem":"false"},model:{value:(_vm.project.bonusSettings.bonusStrategy.data.reportDateType),callback:function ($$v) {_vm.$set(_vm.project.bonusSettings.bonusStrategy.data, "reportDateType", $$v)},expression:"project.bonusSettings.bonusStrategy.data.reportDateType"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-20"},[_vm._m(9),_vm._v(" "),_c('drop-down',{attrs:{"items":[{Id: 'default', Name: 'По умолчанию'}, {Id: 'report', Name: 'По дате отчёта'}, {Id: 'selldate', Name: 'По дате «продажи»'}],"dataField":'Id',"textField":'Name',"withSelectItem":"false"},model:{value:(_vm.project.bonusSettings.bonusStrategy.data.reportPeriodType),callback:function ($$v) {_vm.$set(_vm.project.bonusSettings.bonusStrategy.data, "reportPeriodType", $$v)},expression:"project.bonusSettings.bonusStrategy.data.reportPeriodType"}})],1),_vm._v(" "),(_vm.project.bonusSettings.bonusStrategy.data.reportDateType === 'selldate' || _vm.project.bonusSettings.bonusStrategy.data.reportPeriodType === 'selldate')?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Выберите поле даты «продажи»\n                                    ")]),_vm._v(" "),_c('drop-down',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:[{'input-error': _vm.errors.has('BonusStrategyDateFields')}],attrs:{"name":"BonusStrategyDateFields","items":_vm.bonusStrategyDateFields,"dataField":'Id',"textField":'Name'},model:{value:(_vm.project.bonusSettings.bonusStrategy.data.reportSellDateFieldName),callback:function ($$v) {_vm.$set(_vm.project.bonusSettings.bonusStrategy.data, "reportSellDateFieldName", $$v)},expression:"project.bonusSettings.bonusStrategy.data.reportSellDateFieldName"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-20"},[_vm._m(10),_vm._v(" "),_c('drop-down',{attrs:{"items":[{Id: 'sum', Name: 'Суммарно за отчет'}, {Id: 'sku', Name: 'По SKU'}],"dataField":'Id',"textField":'Name',"withSelectItem":"false"},model:{value:(_vm.project.bonusSettings.bonusStrategy.data.reportDetalizationType),callback:function ($$v) {_vm.$set(_vm.project.bonusSettings.bonusStrategy.data, "reportDetalizationType", $$v)},expression:"project.bonusSettings.bonusStrategy.data.reportDetalizationType"}})],1)]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"block-in-page closed"},[_c('h2',{staticClass:"margin-bottom-20 block-in-page-collapce"},[_vm._v("Настройка блока фотографий")]),_vm._v(" "),_c('div',{staticClass:"block-in-page-detail"},[_vm._l((_vm.project.ReportPhotoFields),function(item,i){return _c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Заголовок блока\n                                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.Name),expression:"item.Name"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"input-text",class:[{'input-error': _vm.errors.has('photoSettingsName' + i)}],attrs:{"type":"text","placeholder":"Заголовок блока","name":'photoSettingsName' + i},domProps:{"value":(item.Name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "Name", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"})]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.Required),expression:"item.Required"}],staticClass:"input-checkbox",attrs:{"id":'photoSettingsRequired' + i,"name":'photoSettingsRequired' + i,"value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(item.Required)?_vm._i(item.Required,"true")>-1:(item.Required)},on:{"change":function($event){var $$a=item.Required,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "Required", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "Required", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "Required", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'photoSettingsRequired' + i}},[_vm._v("Обязательно")])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.PdfAndExcelFilesEnabled),expression:"item.PdfAndExcelFilesEnabled"}],staticClass:"input-checkbox",attrs:{"id":'PdfAndExcelFilesEnabled' + i,"name":'PdfAndExcelFilesEnabled' + i,"value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(item.PdfAndExcelFilesEnabled)?_vm._i(item.PdfAndExcelFilesEnabled,"true")>-1:(item.PdfAndExcelFilesEnabled)},on:{"change":function($event){var $$a=item.PdfAndExcelFilesEnabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "PdfAndExcelFilesEnabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "PdfAndExcelFilesEnabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "PdfAndExcelFilesEnabled", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'PdfAndExcelFilesEnabled' + i}},[_vm._v("Разрешить прикреплять файлы в формате PDF, Excel")])]),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"35px","min-width":"35px","padding-top":"23px"}},[_c('button',{staticClass:"btn btn-default btn-img",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onRemovePhotoSettings(i)}}},[_c('img',{attrs:{"src":__webpack_require__(17),"alt":""}})])])])}),_vm._v(" "),_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-15"}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary margin-top-15 btn-img",attrs:{"type":"button"},on:{"click":function($event){return _vm.addPhotoSettings()}}},[_c('img',{attrs:{"src":__webpack_require__(43),"alt":""}})])],2)]),_vm._v(" "),_c('div',{staticClass:"block-in-page closed"},[_c('h2',{staticClass:"margin-bottom-20 block-in-page-collapce"},[_vm._v("Первый вход участника")]),_vm._v(" "),_c('div',{staticClass:"block-in-page-detail"},[_vm._l((_vm.project.ProjectFirstLaunchSettings),function(launchSettings,i){return [_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Действие "+_vm._s(i + 1)+"\n                                    ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":[{Id: 1, Name: 'Показать всплывающее окно'}],"dataField":'Id',"textField":'Name'},model:{value:(launchSettings.actionTypeId),callback:function ($$v) {_vm.$set(launchSettings, "actionTypeId", $$v)},expression:"launchSettings.actionTypeId"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"})],1),_vm._v(" "),(launchSettings.actionTypeId === 1)?[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                            Заголовок окна\n                                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(launchSettings.Title),expression:"launchSettings.Title"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"input-text",class:[{'input-error': _vm.errors.has('launchSettingsTitle' + i)}],attrs:{"type":"text","name":'launchSettingsTitle' + i},domProps:{"value":(launchSettings.Title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(launchSettings, "Title", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"})]),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-10 flex"},[(launchSettings.FileName && !launchSettings.deleteImage)?_c('div',{staticClass:"form-field file-uploaded margin-right-20"},[_c('a',{attrs:{"href":launchSettings.FileName,"download":"launchSettings.FileTitle"}},[_vm._v(_vm._s(launchSettings.FileTitle))]),_vm._v(" "),(launchSettings.FileName && !launchSettings.deleteImage)?_c('button',{staticClass:"btn btn-delete margin-top-15",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeLaunchSettingsImage(launchSettings, i)}}},[_vm._v("\n                                                Удалить файл\n                                            ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('div',{staticClass:"file-upload-zone"},[_c('input',{ref:'launchSettingsDropFiles' + i,refInFor:true,staticClass:"file-upload-zone-btn",attrs:{"type":"file","accept":".pdf","id":'launchSettingsDropFiles' + i,"name":'launchSettingsDropFiles' + i},on:{"change":function($event){return _vm.onLaunchSettingsImageChange($event, i)}}}),_vm._v(" "),_c('label',{staticClass:"file-upload-zone-lbl",attrs:{"for":'launchSettingsDropFiles' + i}},[_vm._v("\n                                                    Перетяните\n                                                    сюда файл или нажмите, чтобы выбрать\n                                                ")])]),_vm._v(" "),(launchSettings.file != null)?_c('div',{staticClass:"fileList"},[_vm._v("\n                                                Выбран файл: "+_vm._s(launchSettings.file.name)+"\n                                            ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(launchSettings.ReadRequired),expression:"launchSettings.ReadRequired"}],staticClass:"input-checkbox",attrs:{"id":'ReadRequired' + i,"name":'ReadRequired' + i,"value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(launchSettings.ReadRequired)?_vm._i(launchSettings.ReadRequired,"true")>-1:(launchSettings.ReadRequired)},on:{"change":function($event){var $$a=launchSettings.ReadRequired,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(launchSettings, "ReadRequired", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(launchSettings, "ReadRequired", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(launchSettings, "ReadRequired", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'ReadRequired' + i}},[_vm._v("Подтвердить прочтение")])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onRemoveFirstLaunchSettings(i)}}},[_vm._v("\n                                        Удалить действие\n                                    ")])]),_vm._v(" "),_c('div',{staticClass:"line-separator margin-bottom-20 margin-top-20"})]}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary margin-top-15 btn-img",attrs:{"type":"button"},on:{"click":function($event){return _vm.addFirstLaunchSettingsItem()}}},[_c('img',{attrs:{"src":__webpack_require__(43),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"margin-top-20"},[_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.ComplimentarySettings.Enabled),expression:"project.ComplimentarySettings.Enabled"}],staticClass:"input-checkbox",attrs:{"id":"ComplimentarySettings.Enabled","name":"ComplimentarySettings.Enabled","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.project.ComplimentarySettings.Enabled)?_vm._i(_vm.project.ComplimentarySettings.Enabled,"true")>-1:(_vm.project.ComplimentarySettings.Enabled)},on:{"change":function($event){var $$a=_vm.project.ComplimentarySettings.Enabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.project.ComplimentarySettings, "Enabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.project.ComplimentarySettings, "Enabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.project.ComplimentarySettings, "Enabled", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"ComplimentarySettings.Enabled"}},[_vm._v("Баллы за активацию")])]),_vm._v(" "),(_vm.project.ComplimentarySettings.Enabled)?[_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_vm._m(11),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-text', {'input-error': _vm.errors.has('PeriodStartDateFormatted')}],attrs:{"name":"PeriodStartDateFormatted"},on:{"input":function($event){return _vm.onChangeDate(_vm.project.ComplimentarySettings, 'PeriodStartDateFormatted', 'PeriodStartDate')}},model:{value:(_vm.project.ComplimentarySettings.PeriodStartDateFormatted),callback:function ($$v) {_vm.$set(_vm.project.ComplimentarySettings, "PeriodStartDateFormatted", $$v)},expression:"project.ComplimentarySettings.PeriodStartDateFormatted"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(12),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-text', {'input-error': _vm.errors.has('PeriodEndDateFormatted')}],attrs:{"name":"PeriodEndDateFormatted"},on:{"input":function($event){return _vm.onChangeDate(_vm.project.ComplimentarySettings, 'PeriodEndDateFormatted', 'PeriodEndDate')}},model:{value:(_vm.project.ComplimentarySettings.PeriodEndDateFormatted),callback:function ($$v) {_vm.$set(_vm.project.ComplimentarySettings, "PeriodEndDateFormatted", $$v)},expression:"project.ComplimentarySettings.PeriodEndDateFormatted"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                                Дата сгорания балов\n                                            ")]),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{class:['input-text', {'input-error': _vm.errors.has('ExpirationDateFormatted')}],attrs:{"name":"ExpirationDateFormatted"},on:{"input":function($event){return _vm.onChangeDate(_vm.project.ComplimentarySettings, 'ExpirationDateFormatted', 'ExpirationDate')}},model:{value:(_vm.project.ComplimentarySettings.ExpirationDateFormatted),callback:function ($$v) {_vm.$set(_vm.project.ComplimentarySettings, "ExpirationDateFormatted", $$v)},expression:"project.ComplimentarySettings.ExpirationDateFormatted"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field",staticStyle:{"width":"calc(33% - 10px)"}},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                                Количество баллов\n                                            ")]),_vm._v(" "),_c('touch-spin',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-text', {'input-error': _vm.errors.has('ComplimentarySettings.Amount')}],attrs:{"name":"ComplimentarySettings.Amount","min":0,"decimals":2,"step":1},model:{value:(_vm.project.ComplimentarySettings.Amount),callback:function ($$v) {_vm.$set(_vm.project.ComplimentarySettings, "Amount", $$v)},expression:"project.ComplimentarySettings.Amount"}})],1)])]:_vm._e()],2)],2)]),_vm._v(" "),_c('div',{staticClass:"block-in-page closed"},[_c('h2',{staticClass:"margin-bottom-20 block-in-page-collapce"},[_vm._v("Аналитические отчеты")]),_vm._v(" "),_c('div',{staticClass:"block-in-page-detail"},[_c('div',{staticClass:"form-field",staticStyle:{"width":"30%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.AnalyticsReportEnabled),expression:"project.AnalyticsReportEnabled"}],staticClass:"input-checkbox",attrs:{"id":"AnalyticsReportEnabled","name":"AnalyticsReportEnabled","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.project.AnalyticsReportEnabled)?_vm._i(_vm.project.AnalyticsReportEnabled,"true")>-1:(_vm.project.AnalyticsReportEnabled)},on:{"change":function($event){var $$a=_vm.project.AnalyticsReportEnabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.project, "AnalyticsReportEnabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.project, "AnalyticsReportEnabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.project, "AnalyticsReportEnabled", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"AnalyticsReportEnabled"}},[_vm._v("Кнопка Отчет на стр. Аналитика")])]),_vm._v(" "),(_vm.project.AnalyticsReportEnabled)?[_c('div',{staticClass:"form-field"},[_c('drop-down',{attrs:{"items":[{Value:0, Name: 'Выгружать данные графика в Excel'}, {Value:1, Name: 'Свой отчет'}],"dataField":'Value',"textField":'Name'},model:{value:(_vm.project.AnalyticsReportProcedureType),callback:function ($$v) {_vm.$set(_vm.project, "AnalyticsReportProcedureType", $$v)},expression:"project.AnalyticsReportProcedureType"}})],1),_vm._v(" "),(_vm.project.AnalyticsReportProcedureType === 1)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Название процедуры")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.AnalyticsReportProcedureName),expression:"project.AnalyticsReportProcedureName"},{name:"validate",rawName:"v-validate",value:({ rules: { required: _vm.project.AnalyticsReportProcedureType === 1 } }),expression:"{ rules: { required: project.AnalyticsReportProcedureType === 1 } }"}],class:['input-text', {'input-error': _vm.errors.has('AnalyticsReportProcedureName')}],attrs:{"type":"text","name":"AnalyticsReportProcedureName"},domProps:{"value":(_vm.project.AnalyticsReportProcedureName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project, "AnalyticsReportProcedureName", $event.target.value)}}})]):_vm._e()]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-15"}),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Единица измерения вознаграждения\n                                ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":[{Id: 1, Name: 'Баллы'},{Id: 2, Name: 'Купоны'}],"dataField":'Id',"textField":'Name'},model:{value:(_vm.project.RewardUnitTypeId),callback:function ($$v) {_vm.$set(_vm.project, "RewardUnitTypeId", $$v)},expression:"project.RewardUnitTypeId"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Цвет колонок на графике\n                                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.AnalyticsColumnsColor),expression:"project.AnalyticsColumnsColor"}],class:['input-text', {'input-error': _vm.errors.has('AnalyticsColumnsColor')}],attrs:{"name":"AnalyticsColumnsColor","placeholder":"Например, #FFFFFF","type":"text"},domProps:{"value":(_vm.project.AnalyticsColumnsColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project, "AnalyticsColumnsColor", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('AnalyticsColumnsColor')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Цвет рамки колонок на графике\n                                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.AnalyticsBorderColor),expression:"project.AnalyticsBorderColor"}],class:['input-text', {'input-error': _vm.errors.has('AnalyticsBorderColor')}],attrs:{"name":"AnalyticsBorderColor","placeholder":"Например, #FFFFFF","type":"text"},domProps:{"value":(_vm.project.AnalyticsBorderColor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project, "AnalyticsBorderColor", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('AnalyticsBorderColor')))])])]),_vm._v(" "),_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-15"}),_vm._v(" "),_c('h2',[_vm._v("Настройки по ролям:")]),_vm._v(" "),_vm._l((_vm.project.ProjectAnalyticsRoles),function(roleSettings,i){return _c('div',{staticClass:"form-field-group margin-bottom-10"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        "+_vm._s(roleSettings.RoleName)+"\n                                    ")]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(roleSettings.DataTypeId),expression:"roleSettings.DataTypeId"}],staticClass:"input-checkbox",attrs:{"name":'dataType'+i,"id":'dataType1'+i,"value":"0","type":"radio"},domProps:{"checked":_vm._q(roleSettings.DataTypeId,"0")},on:{"change":function($event){return _vm.$set(roleSettings, "DataTypeId", "0")}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl no-margin-top",attrs:{"for":'dataType1'+i}},[_vm._v("График")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(roleSettings.DataTypeId),expression:"roleSettings.DataTypeId"}],staticClass:"input-checkbox",attrs:{"name":'dataType'+i,"id":'dataType2'+i,"value":"1","type":"radio"},domProps:{"checked":_vm._q(roleSettings.DataTypeId,"1")},on:{"change":function($event){return _vm.$set(roleSettings, "DataTypeId", "1")}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl no-margin-top",attrs:{"for":'dataType2'+i}},[_vm._v("Таблица")])])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(roleSettings.ReportEnabled),expression:"roleSettings.ReportEnabled"}],staticClass:"input-checkbox",attrs:{"id":'ReportEnabled' + i,"value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(roleSettings.ReportEnabled)?_vm._i(roleSettings.ReportEnabled,"true")>-1:(roleSettings.ReportEnabled)},on:{"change":function($event){var $$a=roleSettings.ReportEnabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(roleSettings, "ReportEnabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(roleSettings, "ReportEnabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(roleSettings, "ReportEnabled", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'ReportEnabled' + i}},[_vm._v("Отображение кнопки Отчёт")])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(roleSettings.SwitcherEnabled),expression:"roleSettings.SwitcherEnabled"}],staticClass:"input-checkbox",attrs:{"id":'SwitcherEnabled' + i,"value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(roleSettings.SwitcherEnabled)?_vm._i(roleSettings.SwitcherEnabled,"true")>-1:(roleSettings.SwitcherEnabled)},on:{"change":function($event){var $$a=roleSettings.SwitcherEnabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(roleSettings, "SwitcherEnabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(roleSettings, "SwitcherEnabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(roleSettings, "SwitcherEnabled", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'SwitcherEnabled' + i}},[_vm._v("Показывать переключатель руб./шт.")])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(roleSettings.PeriodsEnabled),expression:"roleSettings.PeriodsEnabled"}],staticClass:"input-checkbox",attrs:{"id":'PeriodsEnabled' + i,"value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(roleSettings.PeriodsEnabled)?_vm._i(roleSettings.PeriodsEnabled,"true")>-1:(roleSettings.PeriodsEnabled)},on:{"change":function($event){var $$a=roleSettings.PeriodsEnabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(roleSettings, "PeriodsEnabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(roleSettings, "PeriodsEnabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(roleSettings, "PeriodsEnabled", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'PeriodsEnabled' + i}},[_vm._v("Показывать переключатель периода (день/неделя/месяц)")])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(roleSettings.DetailEnabled),expression:"roleSettings.DetailEnabled"}],staticClass:"input-checkbox",attrs:{"id":'DetailEnabled' + i,"value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(roleSettings.DetailEnabled)?_vm._i(roleSettings.DetailEnabled,"true")>-1:(roleSettings.DetailEnabled)},on:{"change":function($event){var $$a=roleSettings.DetailEnabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(roleSettings, "DetailEnabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(roleSettings, "DetailEnabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(roleSettings, "DetailEnabled", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'DetailEnabled' + i}},[_vm._v("Детализация")])])])})],2)]),_vm._v(" "),_c('div',{staticClass:"block-in-page closed"},[_c('h2',{staticClass:"margin-bottom-20 block-in-page-collapce"},[_vm._v("Рейтинг")]),_vm._v(" "),_c('div',{staticClass:"block-in-page-detail"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Название колонки 1\n                                ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.RatingColumn1),expression:"project.RatingColumn1"}],class:['input-text', {'input-error': _vm.errors.has('RatingColumn1')}],attrs:{"name":"AnalyticsBorderColor","placeholder":"по умолчанию \"ТекМесяцГод\"","type":"text"},domProps:{"value":(_vm.project.RatingColumn1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project, "RatingColumn1", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('RatingColumn1')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Название колонки 2\n                                ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.RatingColumn2),expression:"project.RatingColumn2"}],class:['input-text', {'input-error': _vm.errors.has('RatingColumn2')}],attrs:{"name":"AnalyticsBorderColor","placeholder":"по умолчанию \"Всего\"","type":"text"},domProps:{"value":(_vm.project.RatingColumn2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project, "RatingColumn2", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('RatingColumn2')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.RatingColumn2AsPercent),expression:"project.RatingColumn2AsPercent"}],staticClass:"input-checkbox",attrs:{"id":"RatingColumn2AsPercent","name":"RatingColumn2AsPercent","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.project.RatingColumn2AsPercent)?_vm._i(_vm.project.RatingColumn2AsPercent,"true")>-1:(_vm.project.RatingColumn2AsPercent)},on:{"change":function($event){var $$a=_vm.project.RatingColumn2AsPercent,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.project, "RatingColumn2AsPercent", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.project, "RatingColumn2AsPercent", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.project, "RatingColumn2AsPercent", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"RatingColumn2AsPercent"}},[_vm._v("Выводить как %")])]),_vm._v(" "),_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-15"}),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.RatingSwitcherEnabled),expression:"project.RatingSwitcherEnabled"}],staticClass:"input-checkbox",attrs:{"id":"RatingSwitcherEnabled","name":"RatingSwitcherEnabled","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.project.RatingSwitcherEnabled)?_vm._i(_vm.project.RatingSwitcherEnabled,"true")>-1:(_vm.project.RatingSwitcherEnabled)},on:{"change":function($event){var $$a=_vm.project.RatingSwitcherEnabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.project, "RatingSwitcherEnabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.project, "RatingSwitcherEnabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.project, "RatingSwitcherEnabled", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"RatingSwitcherEnabled"}},[_vm._v("Переключатель отображаемых данных")])]),_vm._v(" "),(_vm.project.RatingSwitcherEnabled)?[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Отображать для:\n                                    ")]),_vm._v(" "),_c('div',_vm._l((_vm.rolesOrdered),function(role,i){return _c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(role.Claims),expression:"role.Claims"}],staticClass:"input-checkbox",attrs:{"type":"checkbox","value":"true","id":'switcherRole' + i,"name":'switcherRole' + i},domProps:{"value":_vm.bindClaim(_vm.claimEnums.ratingSwitcher, _vm.getRoleClaim(role, _vm.claimEnums.ratingSwitcher)),"checked":Array.isArray(role.Claims)?_vm._i(role.Claims,_vm.bindClaim(_vm.claimEnums.ratingSwitcher, _vm.getRoleClaim(role, _vm.claimEnums.ratingSwitcher)))>-1:(role.Claims)},on:{"change":function($event){var $$a=role.Claims,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.bindClaim(_vm.claimEnums.ratingSwitcher, _vm.getRoleClaim(role, _vm.claimEnums.ratingSwitcher)),$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(role, "Claims", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(role, "Claims", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(role, "Claims", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'switcherRole' + i}},[_vm._v(_vm._s(role.Name))])])}),0)]),_vm._v(" "),_c('h2',[_vm._v("Список для отображения")]),_vm._v(" "),_vm._l((_vm.project.RatingRoles),function(item,i){return _c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                            Отображаемое имя\n                                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.Name),expression:"item.Name"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"input-text",class:[{'input-error': _vm.errors.has('RatingRoleName' + i)}],attrs:{"type":"text","placeholder":"Отображаемое имя","name":'RatingRoleName' + i},domProps:{"value":(item.Name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "Name", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"})]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                            Передаваемое значение (только латиница и цифры)\n                                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.Value),expression:"item.Value"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"input-text",class:[{'input-error': _vm.errors.has('RatingRoleValue' + i)}],attrs:{"type":"text","placeholder":"Передаваемое значение","name":'RatingRoleValue' + i,"data-vv-as":"Передаваемое значение"},domProps:{"value":(item.Value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "Value", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('RatingRoleValue' + i)))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.ByDefault),expression:"item.ByDefault"}],staticClass:"input-checkbox",attrs:{"value":"true","type":"radio","id":'RatingRoleValueDefault' + i,"name":"RatingRoleValueDefault"},domProps:{"checked":_vm._q(item.ByDefault,"true")},on:{"change":[function($event){return _vm.$set(item, "ByDefault", "true")},function($event){return _vm.onByDefaultChange(item)}]}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'RatingRoleValueDefault' + i}},[_vm._v("По умолчанию")])]),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"35px","min-width":"35px","padding-top":"23px"}},[_c('button',{staticClass:"btn btn-default btn-img",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onRemoveRatingRole(i)}}},[_c('img',{attrs:{"src":__webpack_require__(17),"alt":""}})])])])}),_vm._v(" "),_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-15"}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary margin-top-15 btn-img",attrs:{"type":"button"},on:{"click":function($event){return _vm.addRatingRole()}}},[_c('img',{attrs:{"src":__webpack_require__(43),"alt":""}})])]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"block-in-page closed"},[_c('h2',{staticClass:"margin-bottom-20 block-in-page-collapce"},[_vm._v("Визуальное оформление системы")]),_vm._v(" "),_c('div',{staticClass:"block-in-page-detail"},[_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Цвет иконок меню на сайте\n                                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.VisualDesign.MenuColorSite),expression:"project.VisualDesign.MenuColorSite"}],class:['input-text'],attrs:{"name":"MenuColorSite","placeholder":"Например, #FFFFFF","type":"text"},domProps:{"value":(_vm.project.VisualDesign.MenuColorSite)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project.VisualDesign, "MenuColorSite", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Цвет иконок меню в мобильном приложении на светлой теме\n                                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.VisualDesign.MenuColorLight),expression:"project.VisualDesign.MenuColorLight"}],class:['input-text'],attrs:{"name":"MenuColorMobileLight","placeholder":"Например, #FFFFFF","type":"text"},domProps:{"value":(_vm.project.VisualDesign.MenuColorLight)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project.VisualDesign, "MenuColorLight", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Цвет иконок меню в мобильном приложении на темной теме\n                                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.VisualDesign.MenuColorDark),expression:"project.VisualDesign.MenuColorDark"}],class:['input-text'],attrs:{"name":"MenuColorMobileDark","placeholder":"Например, #FFFFFF","type":"text"},domProps:{"value":(_vm.project.VisualDesign.MenuColorDark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project.VisualDesign, "MenuColorDark", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"block-in-page closed"},[_c('h2',{staticClass:"margin-bottom-20 block-in-page-collapce"},[_vm._v(_vm._s(_vm.feedbackPageName))]),_vm._v(" "),_c('div',{staticClass:"block-in-page-detail"},[_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Информационное сообщение\n                                    ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.FeedbackSettings.InformMessage),expression:"project.FeedbackSettings.InformMessage"}],staticClass:"input-memo",attrs:{"maxlength":"256","rows":"10","name":"FeedbackInformMessage"},domProps:{"value":(_vm.project.FeedbackSettings.InformMessage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project.FeedbackSettings, "InformMessage", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                            Телефон службы поддержки\n                                        ")]),_vm._v(" "),_c('the-mask',{directives:[{name:"validate",rawName:"v-validate",value:({regex: /^\d{11}$/ }),expression:"{regex: /^\\d{11}$/ }"}],class:['input-text', {'input-error': _vm.errors.has('FeedbackPhoneSTP')}],attrs:{"mask":'# (###) ###-##-##',"name":"FeedbackPhoneSTP","data-vv-as":"Телефон службы поддержки"},model:{value:(_vm.project.FeedbackSettings.PhoneSTP),callback:function ($$v) {_vm.$set(_vm.project.FeedbackSettings, "PhoneSTP", $$v)},expression:"project.FeedbackSettings.PhoneSTP"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('FeedbackPhoneSTP')))])],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                            Email службы поддержки\n                                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.project.FeedbackSettings.Email),expression:"project.FeedbackSettings.Email"},{name:"validate",rawName:"v-validate",value:('email'),expression:"'email'"}],class:['input-text', {'input-error': _vm.errors.has('FeedbackEmail')}],attrs:{"name":"FeedbackEmail","type":"text"},domProps:{"value":(_vm.project.FeedbackSettings.Email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project.FeedbackSettings, "Email", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('FeedbackEmail')))])])])])])])])])])]:_vm._e(),_vm._v(" "),_c('popup-window',{ref:"ppSkuFieldSettings",attrs:{"title":'Настройка отображения полей SKU в отчёте',"width":800}},[_c('p',{staticClass:"caption-help"},[_vm._v("Настройка отображения и использования полей справочника в отчёте в данном проекте")]),_vm._v(" "),_c('table',{staticClass:"table-view",attrs:{"id":"tSkuFieldSett"}},[_c('thead',{staticClass:"head-show"},[_c('tr',{staticClass:"heading"},[_c('th',[_vm._v("Название поля")]),_vm._v(" "),_c('th',[_vm._v("Осуществлять поиск")]),_vm._v(" "),_c('th',[_vm._v("Сцепить для показа")])])]),_vm._v(" "),(_vm.skuSettings != null && _vm.dialogSkuSettings != null)?_c('tbody',_vm._l((_vm.skuSettingsOrdered),function(skuSettingsItem,s){return _c('tr',{key:s},[_c('td',[_vm._v("\n                        "+_vm._s(skuSettingsItem.Title)+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"bit"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(skuSettingsItem.search),expression:"skuSettingsItem.search"}],staticClass:"input-checkbox",attrs:{"id":'list' + s,"name":'list' + s,"value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(skuSettingsItem.search)?_vm._i(skuSettingsItem.search,"true")>-1:(skuSettingsItem.search)},on:{"change":function($event){var $$a=skuSettingsItem.search,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(skuSettingsItem, "search", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(skuSettingsItem, "search", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(skuSettingsItem, "search", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl no-text",attrs:{"for":'list' + s}})]),_vm._v(" "),_c('td',{staticClass:"bit"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(skuSettingsItem.attached),expression:"skuSettingsItem.attached"}],staticClass:"input-checkbox",attrs:{"id":'det' + s,"name":'det' + s,"value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(skuSettingsItem.attached)?_vm._i(skuSettingsItem.attached,"true")>-1:(skuSettingsItem.attached)},on:{"change":function($event){var $$a=skuSettingsItem.attached,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(skuSettingsItem, "attached", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(skuSettingsItem, "attached", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(skuSettingsItem, "attached", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl no-text",attrs:{"for":'det' + s}})])])}),0):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.updateSkuSettingsItem()}}},[_vm._v("Ок")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.ppSkuFieldSettings.close()}}},[_vm._v("Отмена")])])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Проекты"}})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Название\n                                        "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Название акции\n                                        "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Url адрес\n                                        "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Начало программы\n                                        "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Окончание программы\n                                        "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                            Торговая точка\n                                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_c('strong',[_vm._v("Тип бонуса")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Настройте стоимость внутри каждого SKU\n                                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_c('strong',[_vm._v("Дата отчета для выбора баллов за SKU")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_c('strong',[_vm._v("Период начисления баллов")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_c('strong',[_vm._v("Выбор детализации")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                                Начало периода активации\n                                                "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                                Окончание периода активации\n                                                "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__(270);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ae8294e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__(726);
function injectStyle (ssrContext) {
  __webpack_require__(724)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ae8294e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ae8294e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(725);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("bcce8c44", content, true, {});

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".table-view thead[data-v-7ae8294e]{display:table-row-group}", ""]);

// exports


/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"btn-back caption-help margin-right-10"},[_c('router-link',{attrs:{"to":_vm.$route.query.returnUrl ? _vm.$route.query.returnUrl : '/projects/' + _vm.$route.params.projectId}},[_vm._v("Проект")])],1),_vm._v(" "),_c('p',{staticClass:"caption-help margin-right-10"},[_vm._v("\n                    Пользователи\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[_c('div',{staticClass:"btns flex"},[_c('input',{ref:"dropFiles",staticClass:"file-upload-zone-btn",attrs:{"type":"file","id":"dropFiles","name":"dropFiles","accept":".xlsx"},on:{"change":function($event){return _vm.onFileChange()}}}),_vm._v(" "),_c('input',{ref:"dropFiles2",staticClass:"file-upload-zone-btn",attrs:{"type":"file","id":"dropFiles2","name":"dropFiles2","accept":".xlsx"},on:{"change":function($event){return _vm.onFileChange2()}}}),_vm._v(" "),_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.onExportReport()}}},[_vm._v("\n                    Отчет\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button","onclick":"document.getElementById('dropFiles2').click()"}},[_vm._v("\n                    Массовый Импорт\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button","onclick":"document.getElementById('dropFiles').click()"}},[_vm._v("\n                    Импорт\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.onExport()}}},[_vm._v("\n                    Экспорт\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"id":"sample_editable_1_2_new"},on:{"click":function($event){return _vm.onNewEntity()}}},[_vm._v("\n                    Новый пользователь\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"body-panel-control-separator"},[(_vm.infoLoaded)?_c('complex-filter',{ref:"complexFilter",attrs:{"cacheKey":'usersComplexFilter',"filters":_vm.userFilters,"searchFunction":_vm.searchFunction,"tableName":'[dbo].[AspNetUsers]',"withTableNameInClause":true},on:{"onFilterChange":_vm.onFilterChange}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page"},[(_vm.importResult != null)?_c('div',{staticClass:"margin-bottom-10"},[_vm._v("\n            Успешно импортировано: "+_vm._s(_vm.importResult.SuccessfullyExported)+" строк"),_c('br'),_c('br'),_vm._v(" "),(_vm.importResult.Errors.length)?[_vm._v("\n                Ошибки:"),_c('br'),_vm._v(" "),_c('ul',_vm._l((_vm.importResult.Errors),function(error){return _c('li',[_vm._v("\n                        "+_vm._s(error)+"\n                    ")])}),0)]:_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn",on:{"click":function($event){_vm.importResult = null;}}},[_vm._v("Закрыть")])],2):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table-view",attrs:{"id":"dataTable"}},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.users),function(item,i){return _c('tr',{class:[
                        {'check-need': item.PassportVerificationState === 1},
                        {'check-fail': item.PassportVerificationState === 3},
                        {'approve-need': item.RegisteredManually && item.RegisterStatus === 1}
                     ],on:{"click":function($event){$event.stopPropagation();return _vm.onItemClick($event, item)}}},[_c('td',{staticClass:"id"},[_vm._v(_vm._s(i+1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.LastName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.FirstName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getCurrentRoleName(item)))]),_vm._v(" "),_c('td',{staticClass:"phone"},[_vm._v(_vm._s(item.PhoneNumber))]),_vm._v(" "),_c('td',{staticClass:"left-140"},[_vm._v("\n                    "+_vm._s(_vm.formatAcception(item))+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"left-140"},[_vm._v("\n                    "+_vm._s(_vm.formatPassportVerificationState(item.PassportVerificationState))+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"left-140"},[_vm._v("\n                    "+_vm._s(_vm.formatUserStatus(item))+"\n                ")])])}),0)])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Пользователи"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"heading"},[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Фамилия")]),_vm._v(" "),_c('th',[_vm._v("Имя")]),_vm._v(" "),_c('th',[_vm._v("Роль")]),_vm._v(" "),_c('th',[_vm._v("Телефон")]),_vm._v(" "),_c('th',[_vm._v("Согласия")]),_vm._v(" "),_c('th',[_vm._v("Статус документов")]),_vm._v(" "),_c('th',[_vm._v("Активность")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserEdit_vue__ = __webpack_require__(271);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a82d4cd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserEdit_vue__ = __webpack_require__(730);
function injectStyle (ssrContext) {
  __webpack_require__(728)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a82d4cd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(729);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("38f82ad5", content, true, {});

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".fancybox-inner{overflow:hidden!important}.fancybox-nav{width:40px!important}.form-field.shrink-group{width:auto}.form-field.shrink-group .input-checkbox-lbl{margin-top:0;margin-bottom:10px}", ""]);

// exports


/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[(_vm.user != null)?[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"btn-back"},[_c('router-link',{attrs:{"to":'/projects/' + _vm.$route.params.projectId + '/users'}},[_vm._v("Пользователи")])],1),_vm._v(" "),(_vm.user.new)?_c('p',{staticClass:"caption-help margin-right-10"},[_vm._v("Новый пользователь")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"caption-help margin-right-10"},[_vm._v(" "+_vm._s(_vm.formatUserName(_vm.user)))])])]),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[_c('div',{staticClass:"btns flex"},[(_vm.user.new != true)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.$refs.ppChangePassword.show()}}},[_vm._v("Изменить пароль")]):_vm._e(),_vm._v(" "),(_vm.roles.length > 0)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveEntity()}}},[_vm._v("Сохранить")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.cancel()}}},[_vm._v("Отмена")]),_vm._v(" "),(!_vm.user.new)?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteEntity()}}},[_vm._v("Удалить")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page"},[_c('form',{attrs:{"action":"#","novalidate":"novalidate","autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return _vm.saveEntity.apply(null, arguments)}}},[_c('div',{staticClass:"block-in-page"},[(_vm.loaded)?_c('div',{staticClass:"form-field"},[(!_vm.user.UserDynamicRoles.length)?_c('p',{staticClass:"error"},[_vm._v("\n                            Необходимо выбрать минимум один проект\n                        ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.user.UserDynamicRoles),function(userRole,i){return _c('div',{staticClass:"margin-bottom-20"},[_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field",staticStyle:{"width":"12.5%"}},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Проект\n                                    ")]),_vm._v(" "),(userRole.ReadOnly)?_c('label',[_vm._v("\n                                        "+_vm._s(userRole.ProjectName)+"\n                                    ")]):_c('drop-down',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],class:[{'input-error': _vm.errors.has('ProjectId' + i)}],attrs:{"name":'ProjectId' + i,"items":_vm.getProjectListForRole(userRole),"dataField":'ProjectId',"textField":'ProjectName',"data-vv-as":"Проект"},model:{value:(userRole.ProjectId),callback:function ($$v) {_vm.$set(userRole, "ProjectId", $$v)},expression:"userRole.ProjectId"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"12.5%"}},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Уровень пользователя\n                                    ")]),_vm._v(" "),(_vm.info.User.MainRole !== 'administrators')?_c('label',[_vm._v("\n                                        "+_vm._s(userRole.LevelName)+"\n                                    ")]):_c('drop-down',{class:[{'input-error': _vm.errors.has('LevelId' + i)}],attrs:{"name":'LevelId' + i,"items":_vm.levelInProject,"dataField":'Id',"textField":'Name',"withSelectItem":'true',"data-vv-as":"Уровень пользователя"},model:{value:(userRole.LevelInProject),callback:function ($$v) {_vm.$set(userRole, "LevelInProject", $$v)},expression:"userRole.LevelInProject"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"12.5%"}},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Роль\n                                    ")]),_vm._v(" "),(userRole.ReadOnly)?_c('label',[_vm._v("\n                                        "+_vm._s(userRole.RoleName)+"\n                                    ")]):_c('drop-down',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],class:[{'input-error': _vm.errors.has('RoleId' + i)}],attrs:{"name":'RoleId' + i,"items":_vm.getProjectRoles(userRole),"dataField":'Id',"textField":'Name',"withSelectItem":'true',"data-vv-as":"Роль"},model:{value:(userRole.RoleId),callback:function ($$v) {_vm.$set(userRole, "RoleId", $$v)},expression:"userRole.RoleId"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"12.5%"}},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Внешний ID\n                                    ")]),_vm._v(" "),(userRole.ReadOnly)?_c('label',[_vm._v("\n                                        "+_vm._s(userRole.ExternalId)+"\n                                    ")]):_c('input',{directives:[{name:"model",rawName:"v-model",value:(userRole.ExternalId),expression:"userRole.ExternalId"}],staticClass:"input-text",attrs:{"name":'ExternalId' + i,"type":"text","autocomplete":"off"},domProps:{"value":(userRole.ExternalId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(userRole, "ExternalId", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"130px","min-width":"130px"}},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Дата добавления\n                                    ")]),_vm._v(" "),_c('input-date',{directives:[{name:"validate",rawName:"v-validate",value:({ rules: { required: false } }),expression:"{ rules: { required: false } }"}],class:['input-text', {'input-error': _vm.errors.has('AddedDateFormatted' + i)}],attrs:{"name":'AddedDateFormatted' + i},on:{"input":function($event){return _vm.onChangeDate(userRole, 'AddedDateFormatted', 'AddedDate')}},model:{value:(userRole.AddedDateFormatted),callback:function ($$v) {_vm.$set(userRole, "AddedDateFormatted", $$v)},expression:"userRole.AddedDateFormatted"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field flex",staticStyle:{"width":"100px","align-items":"flex-end"}},[(!userRole.ReadOnly)?_c('button',{staticClass:"btn btn-default btn-img",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onDeleteRole(i)}}},[_c('img',{attrs:{"src":__webpack_require__(17),"alt":""}})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"margin-top-10"},[_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field shrink-group",staticStyle:{"width":"200px","min-width":"200px","margin-bottom":"0","padding-top":"6px","margin-right":"5px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(userRole.DisabledDateTime != null),expression:"userRole.DisabledDateTime != null"}],staticClass:"input-checkbox",attrs:{"id":'Disabled'+i,"name":'Disabled'+i,"value":"true","type":"checkbox","autocomplete":"off"},domProps:{"checked":Array.isArray(userRole.DisabledDateTime != null)?_vm._i(userRole.DisabledDateTime != null,"true")>-1:(userRole.DisabledDateTime != null)},on:{"change":[function($event){var $$a=userRole.DisabledDateTime != null,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(userRole, "DisabledDateTime != null", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(userRole, "DisabledDateTime != null", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(userRole, "DisabledDateTime != null", $$c)}},function($event){return _vm.onDisabledChange($event, userRole)}]}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'Disabled'+i}},[_vm._v("\n                                            Отключить аккаунт\n                                            "),(userRole.DisabledDateTime)?[_vm._v("\n                                                с\n                                            ")]:_vm._e()],2)]),_vm._v(" "),(userRole.DisabledDateTime)?_c('div',{staticClass:"form-field shrink-group margin-bottom-0"},[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"input-date-lbl",staticStyle:{"width":"120px","min-width":"120px"}},[_c('input-date',{directives:[{name:"validate",rawName:"v-validate",value:({ rules: { required: _vm.requiredWhen('IsDisabled', userRole)} }),expression:"{ rules: { required: requiredWhen('IsDisabled', userRole)} }"}],class:['input-text', {'input-error': _vm.errors.has('DisabledDateFormatted' + i)}],attrs:{"name":"'DisabledDateFormatted' + i"},on:{"input":function($event){return _vm.onChangeDisabledDate(userRole)}},model:{value:(userRole.DisabledDateFormatted),callback:function ($$v) {_vm.$set(userRole, "DisabledDateFormatted", $$v)},expression:"userRole.DisabledDateFormatted"}})],1),_vm._v(" "),_c('div',{staticClass:"margin-left-5",staticStyle:{"width":"60px","min-width":"60px"}},[_c('input-time',{class:['input-text', {'input-error': _vm.errors.has('DisabledTimeFormatted' + i)}],attrs:{"name":'DisabledTimeFormatted' + i},on:{"input":function($event){return _vm.onChangeDisabledDate(userRole)}},model:{value:(userRole.DisabledTimeFormatted),callback:function ($$v) {_vm.$set(userRole, "DisabledTimeFormatted", $$v)},expression:"userRole.DisabledTimeFormatted"}})],1)])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-field-group margin-top-5"},[_c('div',{staticClass:"form-field shrink-group",staticStyle:{"width":"200px","min-width":"200px","margin-bottom":"0","padding-top":"6px","margin-right":"5px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(userRole.BlockedDateTime != null),expression:"userRole.BlockedDateTime != null"}],staticClass:"input-checkbox",attrs:{"id":'Blocked'+i,"name":'Blocked'+i,"value":"true","type":"checkbox","autocomplete":"off"},domProps:{"checked":Array.isArray(userRole.BlockedDateTime != null)?_vm._i(userRole.BlockedDateTime != null,"true")>-1:(userRole.BlockedDateTime != null)},on:{"change":[function($event){var $$a=userRole.BlockedDateTime != null,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(userRole, "BlockedDateTime != null", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(userRole, "BlockedDateTime != null", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(userRole, "BlockedDateTime != null", $$c)}},function($event){return _vm.onBlockedChange($event, userRole)}]}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'Blocked'+i}},[_vm._v("\n                                            Заблокировать вход\n                                            "),(userRole.BlockedDateTime)?[_vm._v("\n                                                с\n                                            ")]:_vm._e()],2)]),_vm._v(" "),(userRole.BlockedDateTime)?_c('div',{staticClass:"form-field shrink-group margin-bottom-0"},[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"input-date-lbl",staticStyle:{"width":"120px","min-width":"120px"}},[_c('input-date',{directives:[{name:"validate",rawName:"v-validate",value:({ rules: { required: _vm.requiredWhen('IsBlocked', userRole)} }),expression:"{ rules: { required: requiredWhen('IsBlocked', userRole)} }"}],class:['input-text', {'input-error': _vm.errors.has('BlockedDateFormatted'+i)}],attrs:{"name":'BlockedDateFormatted'+i},on:{"input":function($event){return _vm.onChangeBlockedDate(userRole)}},model:{value:(userRole.BlockedDateFormatted),callback:function ($$v) {_vm.$set(userRole, "BlockedDateFormatted", $$v)},expression:"userRole.BlockedDateFormatted"}})],1),_vm._v(" "),_c('div',{staticClass:"margin-left-5",staticStyle:{"width":"60px","min-width":"60px"}},[_c('input-time',{class:['input-text', {'input-error': _vm.errors.has('BlockedTimeFormatted'+i)}],attrs:{"name":'BlockedTimeFormatted'+i},on:{"input":function($event){return _vm.onChangeBlockedDate(userRole)}},model:{value:(userRole.BlockedTimeFormatted),callback:function ($$v) {_vm.$set(userRole, "BlockedTimeFormatted", $$v)},expression:"userRole.BlockedTimeFormatted"}})],1)])]):_vm._e()])])])}),_vm._v(" "),(_vm.user.UserDynamicRoles && _vm.user.UserDynamicRoles.length < _vm.AvailableForViewProjects.length)?_c('button',{staticClass:"btn btn-primary btn-img",attrs:{"type":"button","title":"Добавить проект"},on:{"click":_vm.onAddRole}},[_c('img',{attrs:{"src":__webpack_require__(43)}})]):_vm._e()],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"block-in-page"},[(!_vm.user.new)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            User Id\n                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.Id),expression:"user.Id"}],staticClass:"input-text",attrs:{"name":"Name","type":"text","disabled":"disabled","autocomplete":"off"},domProps:{"value":(_vm.user.Id)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "Id", $event.target.value)},function($event){_vm.userNameError = null}]}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"},{name:"model",rawName:"v-model",value:(_vm.user.Email),expression:"user.Email"}],class:['input-text', {'input-error': _vm.errors.has('Email')}],attrs:{"name":"Email","type":"text","placeholder":"Email","autocomplete":"off"},domProps:{"value":(_vm.user.Email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "Email", $event.target.value)},function($event){_vm.userNameError = null}]}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Email'))+_vm._s(_vm.userNameError))])]),_vm._v(" "),(_vm.user.new)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Новый пароль\n                        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"},{name:"model",rawName:"v-model",value:(_vm.user.Password),expression:"user.Password"}],staticClass:"input-text",class:['input-text', {'input-error': _vm.errors.has('Password')}],attrs:{"name":"Password","type":"password","autocomplete":"off","data-vv-as":"Новый пароль"},domProps:{"value":(_vm.user.Password)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "Password", $event.target.value)},_vm.onNewPasswordChange]}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Password'))+_vm._s(_vm.passwordError))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.user.FirstName),expression:"user.FirstName"}],class:['input-text', {'input-error': _vm.errors.has('FirstName')}],attrs:{"name":"FirstName","data-vv-as":"Имя","type":"text","autocomplete":"off"},domProps:{"value":(_vm.user.FirstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "FirstName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('FirstName')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.user.LastName),expression:"user.LastName"}],class:['input-text', {'input-error': _vm.errors.has('LastName')}],attrs:{"name":"LastName","data-vv-as":"Фамилия","type":"text","autocomplete":"off"},domProps:{"value":(_vm.user.LastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "LastName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('LastName')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(3),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.MiddleName),expression:"user.MiddleName"}],staticClass:"input-text",attrs:{"name":"MiddleName","type":"text","autocomplete":"off"},domProps:{"value":(_vm.user.MiddleName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "MiddleName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('MiddleName')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(4),_vm._v(" "),_c('the-mask',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, regex: /^\d{11,}$/ }),expression:"{ required: true, regex: /^\\d{11,}$/ }"}],class:['input-text', {'input-error': _vm.errors.has('PhoneNumber')}],attrs:{"data-vv-as":"Телефон","mask":['### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ###'],"name":"PhoneNumber"},model:{value:(_vm.user.PhoneNumber),callback:function ($$v) {_vm.$set(_vm.user, "PhoneNumber", $$v)},expression:"user.PhoneNumber"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('PhoneNumber')))])],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Дата рождения\n                        ")]),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{class:['input-text', {'input-error': _vm.errors.has('BirthDateFormatted')}],attrs:{"name":"BirthDateFormatted"},on:{"input":function($event){return _vm.onChangeDate(_vm.user, 'BirthDateFormatted', 'BirthDate')}},model:{value:(_vm.user.BirthDateFormatted),callback:function ($$v) {_vm.$set(_vm.user, "BirthDateFormatted", $$v)},expression:"user.BirthDateFormatted"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(5),_vm._v(" "),(_vm.genders.length > 0)?_c('drop-down',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],class:[{'input-error': _vm.errors.has('Gender')}],attrs:{"name":'Gender',"items":_vm.genders,"dataField":'Value',"textField":'Name',"withSelectItem":'true',"data-vv-as":"Пол"},model:{value:(_vm.user.Gender),callback:function ($$v) {_vm.$set(_vm.user, "Gender", $$v)},expression:"user.Gender"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Gender')))])],1),_vm._v(" "),(!_vm.user.new)?[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Торговая точка\n                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.TradePointName),expression:"user.TradePointName"}],staticClass:"input-text",attrs:{"name":"TradePointName","type":"text","autocomplete":"off"},domProps:{"value":(_vm.user.TradePointName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "TradePointName", $event.target.value)}}})]),_vm._v(" "),_vm._l((_vm.user.RegFields),function(item,i){return _c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                "+_vm._s(item.FieldName)+"\n                            ")]),_vm._v(" "),(item.FieldType === 'text')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.Value),expression:"item.Value"}],class:['input-text', {'input-error': _vm.errors.has('fieldName' + i)}],attrs:{"name":'fieldName' + i,"type":"text","placeholder":item.FieldName},domProps:{"value":(item.Value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "Value", $event.target.value)}}}):(item.FieldType === 'select')?_c('drop-down',{attrs:{"items":item.optionsItems,"dataField":'Value',"textField":'Name'},model:{value:(item.Value),callback:function ($$v) {_vm.$set(item, "Value", $$v)},expression:"item.Value"}}):_vm._e()],1)}),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Создание аккаунта: "+_vm._s(_vm.formatDate(_vm.user.RegisterDate, 'DD.MM.YYYY HH:mm')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Активация аккаунта: "+_vm._s(_vm.formatDate(_vm.user.UserActivationDateTime, 'DD.MM.YYYY HH:mm')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Проверка аккаунта: "+_vm._s(_vm.formatDate(_vm.user.RegisterApprovementDateTime, 'DD.MM.YYYY HH:mm')))])])]:_vm._e(),_vm._v(" "),(_vm.user.RegisteredManually && _vm.user.RegisterStatus === 1)?_c('div',{staticClass:"form-field"},[_c('div',{staticClass:"btns flex"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.activateAccount()}}},[_vm._v("Активировать аккаунт")]),_vm._v(" "),(_vm.user.RegisterStatus !== 3)?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.showRefuseAccountModal()}}},[_vm._v("Отказать в регистрации")]):_vm._e()])]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"block-in-page"},[(_vm.user.PassportVerificationState === _vm.VerificationStates.NeedToCheck)?_c('div',{staticClass:"form-field"},[_c('p',{staticClass:"error"},[_vm._v("Требуется подтвердить документы пользователя")]),_vm._v(" "),_c('div',{staticClass:"flex btns"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.approveDocs()}}},[_vm._v("Документы проверены")]),_vm._v(" "),_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.showReturnDocsModal()}}},[_vm._v("Отклонить документы")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.CheckInn()}}},[_vm._v("Проверить ИНН")])]),_vm._v(" "),_vm._l((_vm.innVerificationErrors),function(item,i){return _c('div',{staticClass:"task-photo"},[_c('p',{staticClass:"error"},[_vm._v(_vm._s(item))])])}),_vm._v(" "),(_vm.checkedInn)?_c('p',{staticClass:"approve"},[_vm._v("ИНН совпадает")]):_vm._e()],2):(_vm.user.PassportVerificationState === _vm.VerificationStates.Verified)?_c('div',{staticClass:"form-field"},[_c('div',{staticClass:"flex btns"},[_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.showReturnDocsModal()}}},[_vm._v("Отклонить документы")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Вид документа\n                        ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.documentTypes,"dataField":'Id',"textField":'Name'},model:{value:(_vm.user.DocumentType),callback:function ($$v) {_vm.$set(_vm.user, "DocumentType", $$v)},expression:"user.DocumentType"}})],1),_vm._v(" "),(_vm.user.DocumentType === 2)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Страна выдачи\n                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.PassportIssuedCountry),expression:"user.PassportIssuedCountry"}],class:['input-text', {'input-error': _vm.errors.has('PassportIssuedCountry')}],attrs:{"name":"PassportIssuedCountry","data-vv-scope":"docs","data-vv-as":"Страна выдачи","type":"text","autocomplete":"off"},domProps:{"value":(_vm.user.PassportIssuedCountry)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "PassportIssuedCountry", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('PassportIssuedCountry')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-15"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Серия паспорта\n                        ")]),_vm._v(" "),(_vm.user.DocumentType === 2)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.PassportSeries),expression:"user.PassportSeries"}],staticClass:"input-text",attrs:{"name":"PassportSeries2","type":"text","autocomplete":"off"},domProps:{"value":(_vm.user.PassportSeries)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "PassportSeries", $event.target.value)}}}):_c('the-mask',{directives:[{name:"validate",rawName:"v-validate",value:({passportSeries: _vm.PassportSeriesMaxLength}),expression:"{passportSeries: PassportSeriesMaxLength}"}],class:['input-text', {'input-error': _vm.errors.has('PassportSeries')}],attrs:{"mask":_vm.PassportSeriesMask,"name":"PassportSeries","data-vv-as":"Серия паспорта"},on:{"input":_vm.onChangePassport},model:{value:(_vm.user.PassportSeries),callback:function ($$v) {_vm.$set(_vm.user, "PassportSeries", $$v)},expression:"user.PassportSeries"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('PassportSeries')))])],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Номер паспорта\n                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.PassportNumber),expression:"user.PassportNumber"},{name:"validate",rawName:"v-validate",value:({passportNumber: _vm.PassportNumberMaxLength}),expression:"{passportNumber: PassportNumberMaxLength}"}],class:['input-text', {'input-error': _vm.errors.has('PassportNumber')}],attrs:{"name":"PassportNumber","data-vv-as":"Номер паспорта","type":"text","autocomplete":"off"},domProps:{"value":(_vm.user.PassportNumber)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "PassportNumber", $event.target.value)},_vm.onChangePassport]}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('PassportNumber')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Кем выдан\n                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.PassportIssuedBy),expression:"user.PassportIssuedBy"}],class:['input-text', {'input-error': _vm.errors.has('PassportIssuedBy')}],attrs:{"name":"PassportIssuedBy","data-vv-as":"Кем выдан","type":"text","autocomplete":"off"},domProps:{"value":(_vm.user.PassportIssuedBy)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "PassportIssuedBy", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('PassportIssuedBy')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Номер подразделения\n                        ")]),_vm._v(" "),_c('the-mask',{class:['input-text', {'input-error': _vm.errors.has('PassportIssuedCode')}],attrs:{"mask":'###-###',"name":"PassportIssuedCode","data-vv-as":"Номер подразделения"},model:{value:(_vm.user.PassportIssuedCode),callback:function ($$v) {_vm.$set(_vm.user, "PassportIssuedCode", $$v)},expression:"user.PassportIssuedCode"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('PassportIssuedCode')))])],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Дата выдачи\n                        ")]),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{class:['input-text', {'input-error': _vm.errors.has('PassportIssuedDateFormatted')}],attrs:{"name":"PassportIssuedDateFormatted","data-vv-as":"Дата выдачи"},on:{"input":function($event){return _vm.onChangeDate(_vm.user, 'PassportIssuedDateFormatted', 'PassportIssuedDate')}},model:{value:(_vm.user.PassportIssuedDateFormatted),callback:function ($$v) {_vm.$set(_vm.user, "PassportIssuedDateFormatted", $$v)},expression:"user.PassportIssuedDateFormatted"}})],1),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('PassportIssuedDateFormatted')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Адрес регистрации\n                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.PassportRegistrationAddress),expression:"user.PassportRegistrationAddress"}],class:['input-text', {'input-error': _vm.errors.has('PassportRegistrationAddress')}],attrs:{"name":"PassportRegistrationAddress","data-vv-as":"Адрес регистрации","type":"text","autocomplete":"off"},domProps:{"value":(_vm.user.PassportRegistrationAddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "PassportRegistrationAddress", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('PassportRegistrationAddress')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            "+_vm._s(_vm.user.DocumentType === 2 ? 'ИНН/ИНП/ИИН' : 'ИНН')+"\n                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.Inn),expression:"user.Inn"},{name:"validate",rawName:"v-validate",value:({innfl: _vm.user.DocumentType !== 2, regex: /^[0-9a-z\u017F\u0430-\u044F\u0451\u1C80-\u1C86\u212A]*$/i }),expression:"{innfl: user.DocumentType !== 2, regex: /^[a-zа-яё0-9]*$/iu }"}],class:['input-text', {'input-error': _vm.errors.has('INN')}],attrs:{"name":"INN","data-vv-as":"ИНН","type":"text","autocomplete":"off"},domProps:{"value":(_vm.user.Inn)},on:{"blur":function($event){},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "Inn", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('INN')))])]),_vm._v(" "),_c('div',{staticClass:"thumbnail-img-block"},_vm._l((_vm.user.Images),function(img,i){return _c('div',{staticClass:"thumbnail-img"},[(img.FileData)?_c('a',{staticClass:"lightzoom",attrs:{"href":img.FileData,"rel":"group"}},[_c('img',{attrs:{"src":img.FileData}})]):(img.FileName)?_c('a',{staticClass:"lightzoom",attrs:{"href":img.FileName,"rel":"group"}},[_c('img',{attrs:{"src":img.FileName}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"thumbnail-img-delete",on:{"click":function($event){return _vm.removeDocument(i)}}}),_vm._v(" "),(!img.FileData)?_c('div',{staticClass:"thumbnail-img-rotateleft",on:{"click":function($event){return _vm.rotateImage('left', img)}}}):_vm._e(),_vm._v(" "),(!img.FileData)?_c('div',{staticClass:"thumbnail-img-rotateright",on:{"click":function($event){return _vm.rotateImage('right', img)}}}):_vm._e()])}),0),_vm._v(" "),_c('div',{staticClass:"file-upload-zone",staticStyle:{"height":"100px"}},[_c('drop-zone',{staticClass:"drop-area file-upload-zone",staticStyle:{"height":"100%"},attrs:{"id":"dropZoneFiles","value":_vm.user.Images.length,"name":"dropZoneFiles","data-vv-as":"Фотография"},on:{"files-dropped":_vm.onAttachFiles}},[_c('input',{ref:"dropFiles2",staticClass:"file-upload-zone-btn",attrs:{"type":"file","id":"dropFiles2","name":"dropFiles2","accept":".jpg,.jpeg,.png","multiple":""}}),_vm._v(" "),_c('label',{class:['file-upload-zone-lbl', {'input-error': _vm.errors.has('dropZoneFiles')}],attrs:{"id":"dropFiles2BtnLbl","for":"dropFiles2"}},[_vm._v("Прикрепите фотографию второго и третьего разворота паспорта и ИНН")])])],1)]),_vm._v(" "),_c('div',{staticClass:"block-in-page"},[(_vm.user.PaymentVerificationState === _vm.VerificationStates.NeedToCheck)?_c('div',{staticClass:"form-field"},[_c('p',{staticClass:"error"},[_vm._v("Требуется подтвердить банковские реквизиты пользователя")]),_vm._v(" "),_c('div',{staticClass:"flex btns"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.approvePaymentSettings()}}},[_vm._v("Банковские реквизиты проверены")]),_vm._v(" "),_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.$refs.ppReturnPayment.show()}}},[_vm._v("Отклонить")])])]):(_vm.user.PaymentVerificationState === _vm.VerificationStates.Verified)?_c('div',{staticClass:"form-field"},[_c('p',{staticClass:"approve"},[_vm._v("\n                            Реквизиты подтверждены "),_c('span',[_vm._v(_vm._s(_vm._f("date-long")(_vm.user.SettingsDateApprovement)))])]),_vm._v(" "),_c('div',{staticClass:"flex btns"},[_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.$refs.ppReturnPayment.show()}}},[_vm._v("Отклонить")])])]):(_vm.user.PaymentVerificationState === _vm.VerificationStates.Cancelled)?_c('div',{staticClass:"form-field"},[_c('p',{staticClass:"error"},[_vm._v("\n                            Данные банковской карты были отклонены по следующей причине: "+_vm._s(_vm.user.PaymentComment)+"\n                        ")])]):_vm._e(),_vm._v(" "),(_vm.user.SettingsDateAdd)?_c('div',{staticClass:"form-field margin-top15"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Документы добавлены: "+_vm._s(_vm._f("date-long")(_vm.user.SettingsDateAdd))+"\n                        ")])]):_vm._e(),_vm._v(" "),_c('div',{class:['form-field', {'margin-top-15': !_vm.user.SettingsDateAdd}]},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            БИК банка\n                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.BankBik),expression:"user.BankBik"},{name:"validate",rawName:"v-validate",value:({ rules: { required: false } }),expression:"{ rules: { required: false } }"}],class:['input-text', {'input-error': _vm.errors.has('BankBik')}],attrs:{"name":"PassportIssuedCountry","disabled":"disabled","data-vv-scope":"docs","type":"text","autocomplete":"off"},domProps:{"value":(_vm.user.BankBik)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "BankBik", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Корреспондентский счёт\n                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.BankCorrAccount),expression:"user.BankCorrAccount"},{name:"validate",rawName:"v-validate",value:({ rules: { required: false } }),expression:"{ rules: { required: false } }"}],class:['input-text', {'input-error': _vm.errors.has('BankCorrAccount')}],attrs:{"name":"PassportIssuedCountry","disabled":"disabled","data-vv-scope":"docs","type":"text","autocomplete":"off"},domProps:{"value":(_vm.user.BankCorrAccount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "BankCorrAccount", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Наименование банка\n                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.BankName),expression:"user.BankName"},{name:"validate",rawName:"v-validate",value:({ rules: { required: false } }),expression:"{ rules: { required: false } }"}],class:['input-text', {'input-error': _vm.errors.has('BankName')}],attrs:{"name":"PassportIssuedCountry","disabled":"disabled","data-vv-scope":"docs","type":"text","autocomplete":"off"},domProps:{"value":(_vm.user.BankName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "BankName", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Расчётный счёт\n                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.BankPaymentAccount),expression:"user.BankPaymentAccount"},{name:"validate",rawName:"v-validate",value:({ rules: { required: false } }),expression:"{ rules: { required: false } }"}],class:['input-text', {'input-error': _vm.errors.has('BankPaymentAccount')}],attrs:{"name":"PassportIssuedCountry","disabled":"disabled","data-vv-scope":"docs","type":"text","autocomplete":"off"},domProps:{"value":(_vm.user.BankPaymentAccount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "BankPaymentAccount", $event.target.value)}}})])])]),_vm._v(" "),(_vm.roles.length === 0)?_c('div',[_vm._v("\n                Добавьте роли в проект!"),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"to":'/projects/' + _vm.$route.params.projectId + '/roles'}},[_vm._v("Управление ролями")])],1):_vm._e()])]:_vm._e(),_vm._v(" "),(_vm.user != null)?_c('popup-window',{ref:"ppReturn",attrs:{"title":'Вернуть документы'},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('div',{staticClass:"popup-footer"},[_c('div',{staticClass:"btns flex",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.returnDocs()}}},[_vm._v("Сохранить")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeModal('ppReturn')}}},[_vm._v("Отмена")])])])]},proxy:true}],null,false,1613770176)},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Причина возврата")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.PassportVerificationComment),expression:"user.PassportVerificationComment"}],staticClass:"input-memo",attrs:{"name":"PassportVerificationComment","rows":"10"},domProps:{"value":(_vm.user.PassportVerificationComment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "PassportVerificationComment", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),(_vm.user != null)?_c('popup-window',{ref:"ppReturnPayment",attrs:{"title":'Вернуть реквизиты'},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('div',{staticClass:"popup-footer"},[_c('div',{staticClass:"btns flex",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.returnPaymentSettings()}}},[_vm._v("Сохранить")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeModal('ppReturnPayment')}}},[_vm._v("Отмена")])])])]},proxy:true}],null,false,4247964510)},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Причина возврата")]),_vm._v(" "),_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:({ rules: { required: true} }),expression:"{ rules: { required: true} }"},{name:"model",rawName:"v-model",value:(_vm.user.PaymentComment),expression:"user.PaymentComment"}],class:['input-memo', {'input-error': _vm.errors.has('PaymentComment', 'returnPayment')}],attrs:{"name":"PaymentComment","rows":"10","data-vv-scope":"returnPayment"},domProps:{"value":(_vm.user.PaymentComment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "PaymentComment", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),(_vm.user != null)?_c('popup-window',{ref:"ppRefuse",attrs:{"title":'Отказать в регистрации'}},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Причина отказа")]),_vm._v(" "),_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"},{name:"model",rawName:"v-model",value:(_vm.user.RegisterComment),expression:"user.RegisterComment"}],class:['input-memo', { 'input-error': _vm.errors.has('RegistrationComment', 'refuse') }],attrs:{"name":"RegistrationComment","rows":"10","data-vv-scope":"refuse"},domProps:{"value":(_vm.user.RegisterComment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "RegisterComment", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.refuseAccount()}}},[_vm._v("Отказать")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeModal('ppRefuse')}}},[_vm._v("Отмена")])])]):_vm._e(),_vm._v(" "),(_vm.user != null)?_c('popup-window',{ref:"ppChangePassword",attrs:{"title":'Смена пароля'}},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                Новый пароль\n            ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"},{name:"model",rawName:"v-model",value:(_vm.user.Password),expression:"user.Password"}],staticClass:"input-text",attrs:{"name":"UserPassword","type":"password","autocomplete":"off","data-vv-scope":"changepassword"},domProps:{"value":(_vm.user.Password)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "Password", $event.target.value)},_vm.onNewPasswordChange]}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('UserPassword', 'changepassword'))+_vm._s(_vm.passwordError))])]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.onChangePassword()}}},[_vm._v("Изменить")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeModal('ppChangePassword')}}},[_vm._v("Отмена")])])]):_vm._e(),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Управление пользователями"}})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Email\n                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Имя\n                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Фамилия\n                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Отчество\n                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Телефон\n                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Пол\n                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsEdit_vue__ = __webpack_require__(272);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d32d64e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsEdit_vue__ = __webpack_require__(734);
function injectStyle (ssrContext) {
  __webpack_require__(732)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d32d64e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d32d64e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(733);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("fd2f11dc", content, true, {});

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[(_vm.news != null)?[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"btn-back margin-right-10"},[_c('a',{staticClass:"router-link-active",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.back.apply(null, arguments)}}},[_vm._v("Назад")])]),_vm._v(" "),(_vm.news.new)?_c('p',{staticClass:"caption-help margin-right-10"},[_vm._v("Добавление новости")]):_vm._e(),_vm._v(" "),(!_vm.news.new)?_c('p',{staticClass:"caption-help"},[_vm._v("Редактирование новости #"+_vm._s(_vm.news.Id))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[_c('div',{staticClass:"btns flex"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.savingInProgress},on:{"click":function($event){return _vm.saveNews()}}},[_vm._v("Сохранить")]),_vm._v(" "),_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":_vm.deleteNews}},[_vm._v("Удалить")])])])]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page"},[_c('div',{staticClass:"body-panel"},[_c('form',{ref:"myForm",staticClass:"form-horizontal",attrs:{"action":"/news","novalidate":"novalidate","method":"post","enctype":"multipart/form-data"}},[_c('input',{attrs:{"type":"hidden","name":"Id"},domProps:{"value":_vm.news.Id}}),_vm._v(" "),_c('div',{staticClass:"block-in-page"},[_c('div',{staticClass:"form-field"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.news.Title),expression:"news.Title"}],class:['input-text', {'input-error': _vm.errors.has('Title')}],attrs:{"name":"Title","type":"text"},domProps:{"value":(_vm.news.Title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.news, "Title", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Title')))])]),_vm._v(" "),_c('div',{staticClass:"form-field-group margin-top-10"},[_c('div',{staticClass:"form-field"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:[{'input-error': _vm.errors.has('StartDateFormatted')}],attrs:{"name":"StartDateFormatted"},model:{value:(_vm.news.StartDateFormatted),callback:function ($$v) {_vm.$set(_vm.news, "StartDateFormatted", $$v)},expression:"news.StartDateFormatted"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('StartDateFormatted')))])],1),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"})]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{attrs:{"name":"EndDateFormatted"},model:{value:(_vm.news.EndDateFormatted),callback:function ($$v) {_vm.$set(_vm.news, "EndDateFormatted", $$v)},expression:"news.EndDateFormatted"}})],1),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('EndDateFormatted')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.news.Pinned),expression:"news.Pinned"}],staticClass:"input-checkbox",attrs:{"id":"Pinned","name":"Pinned","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.news.Pinned)?_vm._i(_vm.news.Pinned,"true")>-1:(_vm.news.Pinned)},on:{"change":function($event){var $$a=_vm.news.Pinned,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.news, "Pinned", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.news, "Pinned", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.news, "Pinned", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"Pinned"}},[_vm._v("Закрепить первым")])])]),_vm._v(" "),_c('div',{staticClass:"margin-top-10"},[_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.news.Preview),expression:"news.Preview"}],class:['input-memo', {'input-error': _vm.errors.has('Preview')}],staticStyle:{"height":"100px"},attrs:{"name":"Preview","rows":"10"},domProps:{"value":(_vm.news.Preview)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.news, "Preview", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Preview')))])])]),_vm._v(" "),_c('div',{staticClass:"margin-top-10"},[_c('div',{staticClass:"form-group"},[_vm._m(4),_vm._v(" "),_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.news.Body),expression:"news.Body"}],class:['input-memo', {'input-error': _vm.errors.has('Body')}],staticStyle:{"height":"250px"},attrs:{"name":"Body","rows":"10"},domProps:{"value":(_vm.news.Body)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.news, "Body", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Body')))])])]),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.news.LikesEnabled),expression:"news.LikesEnabled"}],staticClass:"input-checkbox",attrs:{"id":"LikesEnabled","name":"LikesEnabled","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.news.LikesEnabled)?_vm._i(_vm.news.LikesEnabled,"true")>-1:(_vm.news.LikesEnabled)},on:{"change":function($event){var $$a=_vm.news.LikesEnabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.news, "LikesEnabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.news, "LikesEnabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.news, "LikesEnabled", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"LikesEnabled"}},[_vm._v("Разрешить ставить лайки")])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.news.CommentsEnabled),expression:"news.CommentsEnabled"}],staticClass:"input-checkbox",attrs:{"id":"CommentsEnabled","name":"CommentsEnabled","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.news.CommentsEnabled)?_vm._i(_vm.news.CommentsEnabled,"true")>-1:(_vm.news.CommentsEnabled)},on:{"change":function($event){var $$a=_vm.news.CommentsEnabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.news, "CommentsEnabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.news, "CommentsEnabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.news, "CommentsEnabled", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"CommentsEnabled"}},[_vm._v("Разрешить комментирование")])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.news.DisplayViews),expression:"news.DisplayViews"}],staticClass:"input-checkbox",attrs:{"id":"DisplayViews","name":"DisplayViews","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.news.DisplayViews)?_vm._i(_vm.news.DisplayViews,"true")>-1:(_vm.news.DisplayViews)},on:{"change":function($event){var $$a=_vm.news.DisplayViews,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.news, "DisplayViews", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.news, "DisplayViews", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.news, "DisplayViews", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"DisplayViews"}},[_vm._v("Отображать просмотры")])])]),_vm._v(" "),_c('div',{staticClass:"block-in-page"},[_c('div',{staticClass:"flex"},[_c('image-setting',{attrs:{"img":_vm.imgSite,"name":'site',"parentImage":true},on:{"onImageViewChanged":_vm.onImageViewChanged}}),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"300px","min-width":"300px","margin-left":"20px"}},[_c('div',{staticClass:"panel-block panel-block-new",staticStyle:{"margin-right":"0"}},[_c('div',{staticClass:"panel-block-img-base"},[_c('div',{staticClass:"panel-block-img"},[(_vm.imgSitePath)?_c('img',{style:(_vm.imageStyleFormatted),attrs:{"src":_vm.imgSitePath,"alt":""}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"panel-block-info"},[_c('p',{staticClass:"panel-block-header margin-bottom-10"},[_vm._v(_vm._s(_vm.news.Title))]),_vm._v(" "),_c('p',{staticClass:"panel-body-desc",domProps:{"innerHTML":_vm._s(_vm.news.PreviewFormatted)}})]),_vm._v(" "),_c('div',{staticClass:"panel-body-actions"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){}}},[_vm._v("Читать")]),_vm._v(" "),_c('span',{staticClass:"panel-body-actions-date"},[_vm._v(_vm._s(_vm._f("date-short")(_vm.news.StartDate)))])])])])],1)]),_vm._v(" "),_c('div',{staticClass:"block-in-page"},[_c('div',{staticClass:"flex"},[_c('image-setting',{attrs:{"img":_vm.imgMobile,"parentImgPath":_vm.imgSitePath,"name":'mobile'},on:{"onImageViewChanged":_vm.onImageViewChanged}}),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"500px","min-width":"500px","margin-left":"20px"}},[_c('div',{staticClass:"panel-block panel-block-new panel-block-mobile",staticStyle:{"margin-right":"0"}},[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"panel-block-img-base panel-block-img-mobile"},[_c('div',{staticClass:"panel-block-img panel-block-img-mobile"},[(_vm.imgMobilePath)?_c('img',{style:(_vm.imageStyleMobileFormatted),attrs:{"src":_vm.imgMobilePath,"alt":""}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"panel-block-info"},[_c('p',{staticClass:"panel-block-header margin-bottom-10"},[_vm._v(_vm._s(_vm.news.Title))]),_vm._v(" "),_c('p',{staticClass:"panel-body-desc",domProps:{"innerHTML":_vm._s(_vm.news.PreviewFormatted)}})])]),_vm._v(" "),_c('div',{staticClass:"panel-body-actions"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){}}},[_vm._v("Читать")]),_vm._v(" "),_c('span',{staticClass:"panel-body-actions-date"},[_vm._v(_vm._s(_vm._f("date-short")(_vm.news.StartDate)))])])])])],1)])])])])]:_vm._e(),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Новости"}})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Заголовок новости\n                                "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Начало публикации\n                                    "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Окончание публикации\n                                    "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Превью новости\n                                    "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Текст новости\n                                    "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SkuEdit_vue__ = __webpack_require__(273);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_096206b0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkuEdit_vue__ = __webpack_require__(738);
function injectStyle (ssrContext) {
  __webpack_require__(736)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-096206b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SkuEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_096206b0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkuEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(737);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("5a9eb05f", content, true, {});

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".draggable-item[data-v-096206b0]{cursor:default}", ""]);

// exports


/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel"},[(_vm.sku != null)?[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"btn-back margin-right-10"},[_c('a',{staticClass:"router-link-active",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.back.apply(null, arguments)}}},[_vm._v("Назад")])]),_vm._v(" "),(_vm.sku.new)?_c('p',{staticClass:"caption-help margin-right-10"},[_vm._v("Добавление sku")]):_vm._e(),_vm._v(" "),(!_vm.sku.new)?_c('p',{staticClass:"caption-help"},[_vm._v("Редактирование sku #"+_vm._s(_vm.sku.Id))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[_c('div',{staticClass:"btns flex"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.savingInProgress},on:{"click":function($event){return _vm.saveSku()}}},[_vm._v("Сохранить")]),_vm._v(" "),(!_vm.sku.new)?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":_vm.deleteSku}},[_vm._v("Удалить")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page"},[(_vm.skuSettings != null)?_c('div',{staticClass:"body-panel"},[_c('form',{ref:"myForm",staticClass:"form-horizontal",attrs:{"action":"/sku","novalidate":"novalidate","method":"post","enctype":"multipart/form-data"}},[_c('div',{staticClass:"block-in-page"},[_c('input',{attrs:{"type":"hidden","name":"Id"},domProps:{"value":_vm.sku.Id}}),_vm._v(" "),(_vm.skuSettings.Name.ShowInDetails)?_c('div',{staticClass:"form-field"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sku.Name),expression:"sku.Name"}],class:['input-text', {'input-error': _vm.errors.has('Name')}],attrs:{"name":"Name","type":"text"},domProps:{"value":(_vm.sku.Name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sku, "Name", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Name')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field-group"},[(!_vm.sku.new)?_c('div',{staticClass:"form-field"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{class:[{'input-error': _vm.errors.has('CreateDateFormatted')}],attrs:{"name":"CreateDateFormatted","disabled":""},model:{value:(_vm.sku.CreateDateFormatted),callback:function ($$v) {_vm.$set(_vm.sku, "CreateDateFormatted", $$v)},expression:"sku.CreateDateFormatted"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('CreateDateFormatted')))])],1),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{attrs:{"name":"EndDateFormatted"},model:{value:(_vm.sku.EndDateFormatted),callback:function ($$v) {_vm.$set(_vm.sku, "EndDateFormatted", $$v)},expression:"sku.EndDateFormatted"}})],1),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('EndDateFormatted')))])])]),_vm._v(" "),(_vm.domainFolders.length)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Папка\n                            ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.domainFolders,"dataField":'Id',"textField":'Name'},model:{value:(_vm.sku.DomainFolderId),callback:function ($$v) {_vm.$set(_vm.sku, "DomainFolderId", $$v)},expression:"sku.DomainFolderId"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('DomainFolderId')))])],1):_vm._e(),_vm._v(" "),(_vm.skuGroups.length)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Группа\n                            ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.skuGroups,"dataField":'Id',"textField":'Name'},model:{value:(_vm.sku.GroupId),callback:function ($$v) {_vm.$set(_vm.sku, "GroupId", $$v)},expression:"sku.GroupId"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('GroupId')))])],1):_vm._e(),_vm._v(" "),(_vm.skuSettings.Volume.ShowInDetails)?_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Объем единицы\n                                ")]),_vm._v(" "),_c('touch-spin',{attrs:{"decimals":2,"step":0.01},model:{value:(_vm.sku.Volume),callback:function ($$v) {_vm.$set(_vm.sku, "Volume", $$v)},expression:"sku.Volume"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Volume')))])],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Единица измерения\n                                ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sku.VolumeUnit),expression:"sku.VolumeUnit"},{name:"validate",rawName:"v-validate",value:({ rules: { required: this.volumeUnitRequired} }),expression:"{ rules: { required: this.volumeUnitRequired} }"}],class:['input-text', {'input-error': _vm.errors.has('VolumeUnit')}],attrs:{"type":"text","name":"VolumeUnit"},domProps:{"value":(_vm.sku.VolumeUnit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sku, "VolumeUnit", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('VolumeUnit')))])])]):_vm._e(),_vm._v(" "),(_vm.skuSettings.Weight.ShowInDetails)?_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Вес нетто\n                                ")]),_vm._v(" "),_c('touch-spin',{attrs:{"decimals":2,"step":0.01},model:{value:(_vm.sku.Weight),callback:function ($$v) {_vm.$set(_vm.sku, "Weight", $$v)},expression:"sku.Weight"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Weight')))])],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Вес нетто (единица измерения)\n                                ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sku.WeightUnit),expression:"sku.WeightUnit"},{name:"validate",rawName:"v-validate",value:({ rules: { required: this.weightUnitRequired} }),expression:"{ rules: { required: this.weightUnitRequired} }"}],class:['input-text', {'input-error': _vm.errors.has('WeightUnit')}],attrs:{"type":"text","name":"WeightUnit"},domProps:{"value":(_vm.sku.WeightUnit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sku, "WeightUnit", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('WeightUnit')))])])]):_vm._e(),_vm._v(" "),(_vm.skuSettings.Category.ShowInDetails)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Категория\n                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sku.Category),expression:"sku.Category"}],staticClass:"input-text",attrs:{"name":"Category","type":"text"},domProps:{"value":(_vm.sku.Category)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sku, "Category", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Category')))])]):_vm._e(),_vm._v(" "),(_vm.skuSettings.Subcategory.ShowInDetails)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Подкатегория\n                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sku.Subcategory),expression:"sku.Subcategory"}],staticClass:"input-text",attrs:{"name":"Subcategory","type":"text"},domProps:{"value":(_vm.sku.Subcategory)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sku, "Subcategory", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Subcategory')))])]):_vm._e(),_vm._v(" "),(_vm.skuSettings.Brand.ShowInDetails)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Бренд\n                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sku.Brand),expression:"sku.Brand"}],staticClass:"input-text",attrs:{"name":"Brand","type":"text"},domProps:{"value":(_vm.sku.Brand)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sku, "Brand", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Brand')))])]):_vm._e(),_vm._v(" "),(_vm.skuSettings.Code.ShowInDetails)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Код\n                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sku.Code),expression:"sku.Code"}],staticClass:"input-text",attrs:{"name":"Code","type":"text"},domProps:{"value":(_vm.sku.Code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sku, "Code", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Code')))])]):_vm._e(),_vm._v(" "),(_vm.skuSettings.VendorCode.ShowInDetails)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Артикул\n                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sku.VendorCode),expression:"sku.VendorCode"}],staticClass:"input-text",attrs:{"name":"Code","type":"text"},domProps:{"value":(_vm.sku.VendorCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sku, "VendorCode", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('VendorCode')))])]):_vm._e(),_vm._v(" "),(_vm.skuSettings.RRC.ShowInDetails)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                РРЦ\n                            ")]),_vm._v(" "),_c('touch-spin',{attrs:{"decimals":2,"step":0.01},model:{value:(_vm.sku.RRC),callback:function ($$v) {_vm.$set(_vm.sku, "RRC", $$v)},expression:"sku.RRC"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('RRC')))])],1):_vm._e(),_vm._v(" "),(_vm.skuSettings.SkuOrder.ShowInDetails)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Порядковый номер\n                            ")]),_vm._v(" "),_c('touch-spin',{model:{value:(_vm.sku.Order),callback:function ($$v) {_vm.$set(_vm.sku, "Order", _vm._n($$v))},expression:"sku.Order"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Order')))])],1):_vm._e(),_vm._v(" "),(_vm.skuSettings.ExternalCode.ShowInDetails)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Внешний код\n                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sku.ExternalCode),expression:"sku.ExternalCode"}],staticClass:"input-text",attrs:{"name":"ExternalCode","type":"text"},domProps:{"value":(_vm.sku.ExternalCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sku, "ExternalCode", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('ExternalCode')))])]):_vm._e(),_vm._v(" "),(_vm.skuSettings.UnitBarCode.ShowInDetails)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Штрихкод единицы\n                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sku.UnitBarCode),expression:"sku.UnitBarCode"}],staticClass:"input-text",attrs:{"name":"UnitBarCode","type":"text"},domProps:{"value":(_vm.sku.UnitBarCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sku, "UnitBarCode", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('UnitBarCode')))])]):_vm._e(),_vm._v(" "),(_vm.skuSettings.BoxBarCode.ShowInDetails)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Штрихкод коробки\n                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sku.BoxBarCode),expression:"sku.BoxBarCode"}],staticClass:"input-text",attrs:{"name":"BoxBarCode","type":"text"},domProps:{"value":(_vm.sku.BoxBarCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sku, "BoxBarCode", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('BoxBarCode')))])]):_vm._e(),_vm._v(" "),(_vm.skuSettings.Amount.ShowInDetails)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Количество штук в коробке\n                            ")]),_vm._v(" "),_c('touch-spin',{model:{value:(_vm.sku.Amount),callback:function ($$v) {_vm.$set(_vm.sku, "Amount", _vm._n($$v))},expression:"sku.Amount"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Amount')))])],1):_vm._e(),_vm._v(" "),(_vm.skuSettings.Description.ShowInDetails)?_c('div',{staticClass:"margin-top-10"},[_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('froala-editor',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"Description",class:[{'input-error': _vm.errors.has('Description')}],attrs:{"name":"Description","imageUploadURL":_vm.config.apiUrl + '/api/sku/uploadFiles?fileType=Image&skuId=' + _vm.sku.Id + '&projectId=' + _vm.projectId},model:{value:(_vm.sku.Description),callback:function ($$v) {_vm.$set(_vm.sku, "Description", $$v)},expression:"sku.Description"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Description')))])],1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.skuCustomSettingsOrdered),function(s){return (s.ShowInDetails)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                "+_vm._s(s.Title)+"\n                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sku[s.FieldName]),expression:"sku[s.FieldName]"}],staticClass:"input-text",attrs:{"name":s.FieldName,"type":"text"},domProps:{"value":(_vm.sku[s.FieldName])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sku, s.FieldName, $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first(s.FieldName)))])]):_vm._e()})],2),_vm._v(" "),_c('div',{staticClass:"block-in-page"},[_c('h2',[_vm._v("Настройка связи с торговыми точками")]),_vm._v(" "),(_vm.tpLinksExist && _vm.linkingEnabled)?_c('div',{staticClass:"flex"},[_c('div',{staticClass:"profile-roles"},[_vm._l((_vm.sku.Links),function(skuLink,i){return _c('div',{staticClass:"draggable-item",on:{"dblclick":function($event){return _vm.onLinkEdit(skuLink)},"click":function($event){return _vm.onLinkSelect(skuLink)}}},[(skuLink.Edited)?[_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_c('search-filter',{directives:[{name:"validate",rawName:"v-validate",value:({ rules: { required: true} }),expression:"{ rules: { required: true} }"}],attrs:{"name":'skuLinkName' + i,"hasErrors":_vm.errors.has('skuLinkName' + i),"extra":i,"placeholder":'Выберите связь',"searchFunction":_vm.searchSkuLinkFunction,"selectedItem":{Id: skuLink.Name, Name: skuLink.Name},"searchOnSelect":true,"scrollable":true},on:{"onFilterChange":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
return _vm.onChangeSkuLinkSearch.apply(void 0, argsArray.concat( [skuLink] ))}}})],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('touch-spin',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],attrs:{"name":'skuLinkAmount' + i,"cssclass":['input-text', {'input-error': _vm.errors.has('skuLinkAmount' + i)}],"decimals":2,"step":0.01},on:{"click":function($event){$event.stopPropagation();},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();return _vm.onLinkEditOk(skuLink)}},model:{value:(skuLink.Amount),callback:function ($$v) {_vm.$set(skuLink, "Amount", $$v)},expression:"skuLink.Amount"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('div',{staticClass:"btns flex",staticStyle:{"float":"right"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onLinkEditOk(skuLink)}}},[_vm._v("Ok")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onLinkEditCancel(skuLink)}}},[_vm._v("Отмена")])])])])]:_vm._e(),_vm._v(" "),(!skuLink.Edited)?[_vm._v("\n                                        "+_vm._s(skuLink.Name)+" - "+_vm._s(skuLink.Amount)+_vm._s(_vm.bonusTypeStr)+"\n                                        "),_c('div',{staticClass:"btns flex",staticStyle:{"float":"right","margin-top":"-6px"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onLinkEdit(skuLink)}}},[_vm._v("Редактировать")]),_vm._v(" "),_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.removeLink(skuLink, i)}}},[_vm._v("Удалить")])])]:_vm._e()],2)}),_vm._v(" "),_c('button',{staticClass:"btn margin-top-10",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.addNewLink.apply(null, arguments)}}},[_vm._v("Добавить")]),_vm._v(" "),(_vm.sku.Links && _vm.sku.Links.length)?_c('button',{staticClass:"btn margin-top-10",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.openSkuSearchModal()}}},[_vm._v("\n                                    Применить значения к другим SKU\n                                ")]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"profile-setting"},[(_vm.linkSelected)?[_c('p',{staticClass:"panel-block-header"},[_vm._v("Связь \""+_vm._s(_vm.linkSelected.Name)+"\"")]),_vm._v(" "),_c('p',{staticClass:"caption-help"},[_vm._v("Настройка периодов")]),_vm._v(" "),_vm._l((_vm.linkSelected.Periods),function(period,j){return _c('div',{staticClass:"draggable-item",on:{"dblclick":function($event){return _vm.onPeriodEdit(period)}}},[(period.Edited)?[_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],class:[{'input-error': _vm.errors.has('DateStartFormatted' + j)}],attrs:{"name":'DateStartFormatted' + j,"placeholder":"Начало периода"},on:{"input":function($event){return _vm.onChangeDate(period, 'DateStartFormatted', 'DateStart')}},model:{value:(period.DateStartFormatted),callback:function ($$v) {_vm.$set(period, "DateStartFormatted", $$v)},expression:"period.DateStartFormatted"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{class:[{'input-error': _vm.errors.has('DateEndFormatted' + j)}],attrs:{"name":'DateEndFormatted' + j,"placeholder":"Завершение периода"},on:{"input":function($event){return _vm.onChangeDate(period, 'DateEndFormatted', 'DateEnd')}},model:{value:(period.DateEndFormatted),callback:function ($$v) {_vm.$set(period, "DateEndFormatted", $$v)},expression:"period.DateEndFormatted"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('touch-spin',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],attrs:{"name":'skuPeriodAmount' + j,"cssclass":['input-text', {'input-error': _vm.errors.has('skuPeriodAmount' + j)}],"decimals":2,"step":0.01},on:{"click":function($event){$event.stopPropagation();}},model:{value:(period.Amount),callback:function ($$v) {_vm.$set(period, "Amount", $$v)},expression:"period.Amount"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('div',{staticClass:"btns flex",staticStyle:{"float":"right"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onPeriodEditCancel(period)}}},[_vm._v("Ok")])])])])]:_vm._e(),_vm._v(" "),(!period.Edited)?[_vm._v("\n                                            с "+_vm._s(period.DateStartFormatted)+"\n                                            "),(period.DateEndFormatted )?[_vm._v("\n                                                по "+_vm._s(period.DateEndFormatted)+"\n                                            ")]:_vm._e(),_vm._v(" - "+_vm._s(period.Amount)+_vm._s(_vm.bonusTypeStr)+"\n                                            "),_c('div',{staticClass:"btns flex",staticStyle:{"float":"right","margin-top":"-6px"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onPeriodEdit(period)}}},[_vm._v("Редактировать")]),_vm._v(" "),_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.removePeriod(period, j)}}},[_vm._v("Удалить")])])]:_vm._e()],2)}),_vm._v(" "),_c('button',{staticClass:"btn margin-top-10",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.addNewPeriod.apply(null, arguments)}}},[_vm._v("Добавить")])]:_vm._e(),_vm._v(" "),(!_vm.linkSelected && _vm.sku.Links && _vm.sku.Links.length)?[_c('p',{staticClass:"caption-help"},[_vm._v("Выберите связь с торговой точкой")])]:_vm._e()],2)]):_vm._e(),_vm._v(" "),(!_vm.tpLinksExist)?_c('div',{staticClass:"error"},[_vm._v("\n                            В торговых точках нет ни одного значения в Поле для связи\n                        ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"block-in-page"},[_c('div',{staticClass:"flex"},[_c('image-setting',{attrs:{"img":_vm.imgSite,"name":'site',"parentImage":true},on:{"onImageViewChanged":_vm.onImageViewChanged}}),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"300px","min-width":"300px","margin-left":"20px"}},[(_vm.skuSettings != null)?_c('div',{staticClass:"panel-block panel-block-new",staticStyle:{"margin-right":"0"}},[_c('div',{staticClass:"panel-block-img-base"},[_c('div',{staticClass:"panel-block-img"},[(_vm.imgSitePath)?_c('img',{style:(_vm.imageStyleFormatted),attrs:{"src":_vm.imgSitePath,"alt":""}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"panel-block-info"},[(_vm.skuSettings.Name.ShowInList)?_c('p',{staticClass:"panel-block-header margin-bottom-10"},[_vm._v(_vm._s(_vm.sku.Name))]):_vm._e(),_vm._v(" "),(_vm.skuSettings.Brand.ShowInList)?_c('p',{staticClass:"input-text-lbl"},[_c('i',[_vm._v("Бренд:  ")]),_vm._v(_vm._s(_vm.sku.Brand))]):_vm._e(),_vm._v(" "),(_vm.skuSettings.Category.ShowInList)?_c('p',{staticClass:"input-text-lbl"},[_c('i',[_vm._v("Категория:  ")]),_vm._v(_vm._s(_vm.sku.Category))]):_vm._e(),_vm._v(" "),(_vm.skuSettings.Subcategory.ShowInList)?_c('p',{staticClass:"input-text-lbl"},[_c('i',[_vm._v("Подкатегория:  ")]),_vm._v(_vm._s(_vm.sku.Subcategory))]):_vm._e(),_vm._v(" "),(_vm.skuSettings.Description.ShowInList)?_c('p',{staticClass:"panel-body-desc",domProps:{"innerHTML":_vm._s(_vm.sku.DescriptionFormatted)}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"panel-body-actions"},[_c('button',{staticClass:"btn"},[_vm._v("Подробнее")]),_vm._v(" "),_c('span',{staticClass:"panel-body-actions-date"},[_vm._v(_vm._s(_vm._f("date-short")(_vm.sku.CreateDate)))])])]):_vm._e()])],1)]),_vm._v(" "),_c('div',{staticClass:"block-in-page"},[_c('div',{staticClass:"flex"},[_c('image-setting',{attrs:{"img":_vm.imgMobile,"parentImgPath":_vm.imgSitePath,"name":'mobile'},on:{"onImageViewChanged":_vm.onImageViewChanged}}),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"500px","min-width":"500px","margin-left":"20px"}},[(_vm.skuSettings != null)?_c('div',{staticClass:"panel-block panel-block-new panel-block-mobile",staticStyle:{"margin-right":"0"}},[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"panel-block-img panel-block-img-mobile"},[(_vm.imgMobilePath)?_c('img',{style:(_vm.imageStyleMobileFormatted),attrs:{"src":_vm.imgMobilePath,"alt":""}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"panel-block-info"},[(_vm.skuSettings.Name.ShowInList)?_c('p',{staticClass:"panel-block-header margin-bottom-10"},[_vm._v(_vm._s(_vm.sku.Name))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"panel-body-actions"},[_c('button',{staticClass:"btn"},[_vm._v("Подробнее")]),_vm._v(" "),_c('span',{staticClass:"panel-body-actions-date"},[_vm._v(_vm._s(_vm._f("date-short")(_vm.sku.CreateDate)))])])]):_vm._e()])],1)])])]):_vm._e()])]:_vm._e(),_vm._v(" "),_c('popup-window',{ref:"ppSkuList",attrs:{"title":'Применение текущей настройки связей к sku',"width":800}},[_c('p',{staticClass:"caption-help"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.skuSearch.value),expression:"skuSearch.value"}],staticClass:"input-text",attrs:{"type":"text","placeholder":"Поиск sku"},domProps:{"value":(_vm.skuSearch.value)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.skuSearch, "value", $event.target.value)},_vm.onSearchChange],"click":_vm.onSearchChange}}),_vm._v(" "),_c('table',{staticClass:"table-view margin-top-10",attrs:{"id":"tSkuFieldSett"}},[_c('thead',{staticClass:"head-show"},[_c('tr',{staticClass:"heading"},[_c('th',[_vm._v("Наименование")]),_vm._v(" "),_c('th',[_vm._v("Действие")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.skuSearch.list),function(item,i){return _c('tr',[_c('td',[_vm._v(_vm._s(item.Name))]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.Selected),expression:"item.Selected"}],staticClass:"input-checkbox",attrs:{"id":'itemSelected' + i,"value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(item.Selected)?_vm._i(item.Selected,"true")>-1:(item.Selected)},on:{"change":function($event){var $$a=item.Selected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "Selected", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "Selected", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "Selected", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'itemSelected' + i}},[_vm._v("Выбрать")])])])}),_vm._v(" "),(!_vm.skuSearch.list.length)?_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_vm._v("\n                        Нет данных\n                    ")])]):_vm._e()],2)]),_vm._v(" "),(_vm.skuSearch.list.length)?_c('button',{staticClass:"btn btn-primary margin-top-10",attrs:{"type":"button"},on:{"click":function($event){return _vm.skuSearchApply()}}},[_vm._v("Применить")]):_vm._e()]),_vm._v(" "),_c('vue-headful',{attrs:{"title":"SKU"}})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Название\n                                "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Дата добавления\n                                    "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Дата выключения\n                                    "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Описание\n                                    "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MaterialEdit_vue__ = __webpack_require__(274);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b47c39e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MaterialEdit_vue__ = __webpack_require__(757);
function injectStyle (ssrContext) {
  __webpack_require__(740)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b47c39e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MaterialEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b47c39e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MaterialEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(741);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6fb44753", content, true, {});

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer, global, process) {/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2019 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("pdfjs-dist/build/pdf", [], factory);
	else if(typeof exports === 'object')
		exports["pdfjs-dist/build/pdf"] = factory();
	else
		root["pdfjs-dist/build/pdf"] = root.pdfjsLib = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __w_pdfjs_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__w_pdfjs_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__w_pdfjs_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__w_pdfjs_require__.d = function(exports, name, getter) {
/******/ 		if(!__w_pdfjs_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__w_pdfjs_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__w_pdfjs_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __w_pdfjs_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__w_pdfjs_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __w_pdfjs_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__w_pdfjs_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__w_pdfjs_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__w_pdfjs_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__w_pdfjs_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __w_pdfjs_require__(__w_pdfjs_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var pdfjsVersion = '2.2.228';
var pdfjsBuild = 'd7afb74a';

var pdfjsSharedUtil = __w_pdfjs_require__(1);

var pdfjsDisplayAPI = __w_pdfjs_require__(147);

var pdfjsDisplayTextLayer = __w_pdfjs_require__(162);

var pdfjsDisplayAnnotationLayer = __w_pdfjs_require__(163);

var pdfjsDisplayDisplayUtils = __w_pdfjs_require__(151);

var pdfjsDisplaySVG = __w_pdfjs_require__(164);

var pdfjsDisplayWorkerOptions = __w_pdfjs_require__(156);

var pdfjsDisplayAPICompatibility = __w_pdfjs_require__(153);

{
  var isNodeJS = __w_pdfjs_require__(4);

  if (isNodeJS()) {
    var PDFNodeStream = __w_pdfjs_require__(165).PDFNodeStream;

    pdfjsDisplayAPI.setPDFNetworkStreamFactory(function (params) {
      return new PDFNodeStream(params);
    });
  } else {
    var PDFNetworkStream = __w_pdfjs_require__(168).PDFNetworkStream;

    var PDFFetchStream;

    if (pdfjsDisplayDisplayUtils.isFetchSupported()) {
      PDFFetchStream = __w_pdfjs_require__(169).PDFFetchStream;
    }

    pdfjsDisplayAPI.setPDFNetworkStreamFactory(function (params) {
      if (PDFFetchStream && pdfjsDisplayDisplayUtils.isValidFetchUrl(params.url)) {
        return new PDFFetchStream(params);
      }

      return new PDFNetworkStream(params);
    });
  }
}
exports.build = pdfjsDisplayAPI.build;
exports.version = pdfjsDisplayAPI.version;
exports.getDocument = pdfjsDisplayAPI.getDocument;
exports.LoopbackPort = pdfjsDisplayAPI.LoopbackPort;
exports.PDFDataRangeTransport = pdfjsDisplayAPI.PDFDataRangeTransport;
exports.PDFWorker = pdfjsDisplayAPI.PDFWorker;
exports.renderTextLayer = pdfjsDisplayTextLayer.renderTextLayer;
exports.AnnotationLayer = pdfjsDisplayAnnotationLayer.AnnotationLayer;
exports.createPromiseCapability = pdfjsSharedUtil.createPromiseCapability;
exports.PasswordResponses = pdfjsSharedUtil.PasswordResponses;
exports.InvalidPDFException = pdfjsSharedUtil.InvalidPDFException;
exports.MissingPDFException = pdfjsSharedUtil.MissingPDFException;
exports.SVGGraphics = pdfjsDisplaySVG.SVGGraphics;
exports.NativeImageDecoding = pdfjsSharedUtil.NativeImageDecoding;
exports.CMapCompressionType = pdfjsSharedUtil.CMapCompressionType;
exports.PermissionFlag = pdfjsSharedUtil.PermissionFlag;
exports.UnexpectedResponseException = pdfjsSharedUtil.UnexpectedResponseException;
exports.OPS = pdfjsSharedUtil.OPS;
exports.VerbosityLevel = pdfjsSharedUtil.VerbosityLevel;
exports.UNSUPPORTED_FEATURES = pdfjsSharedUtil.UNSUPPORTED_FEATURES;
exports.createValidAbsoluteUrl = pdfjsSharedUtil.createValidAbsoluteUrl;
exports.createObjectURL = pdfjsSharedUtil.createObjectURL;
exports.removeNullCharacters = pdfjsSharedUtil.removeNullCharacters;
exports.shadow = pdfjsSharedUtil.shadow;
exports.Util = pdfjsSharedUtil.Util;
exports.ReadableStream = pdfjsSharedUtil.ReadableStream;
exports.URL = pdfjsSharedUtil.URL;
exports.RenderingCancelledException = pdfjsDisplayDisplayUtils.RenderingCancelledException;
exports.getFilenameFromUrl = pdfjsDisplayDisplayUtils.getFilenameFromUrl;
exports.LinkTarget = pdfjsDisplayDisplayUtils.LinkTarget;
exports.addLinkAttributes = pdfjsDisplayDisplayUtils.addLinkAttributes;
exports.loadScript = pdfjsDisplayDisplayUtils.loadScript;
exports.PDFDateString = pdfjsDisplayDisplayUtils.PDFDateString;
exports.GlobalWorkerOptions = pdfjsDisplayWorkerOptions.GlobalWorkerOptions;
exports.apiCompatibilityParams = pdfjsDisplayAPICompatibility.apiCompatibilityParams;

/***/ }),
/* 1 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayByteLength = arrayByteLength;
exports.arraysToBytes = arraysToBytes;
exports.assert = assert;
exports.bytesToString = bytesToString;
exports.createPromiseCapability = createPromiseCapability;
exports.getVerbosityLevel = getVerbosityLevel;
exports.info = info;
exports.isArrayBuffer = isArrayBuffer;
exports.isArrayEqual = isArrayEqual;
exports.isBool = isBool;
exports.isEmptyObj = isEmptyObj;
exports.isNum = isNum;
exports.isString = isString;
exports.isSpace = isSpace;
exports.isSameOrigin = isSameOrigin;
exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
exports.isLittleEndian = isLittleEndian;
exports.isEvalSupported = isEvalSupported;
exports.log2 = log2;
exports.readInt8 = readInt8;
exports.readUint16 = readUint16;
exports.readUint32 = readUint32;
exports.removeNullCharacters = removeNullCharacters;
exports.setVerbosityLevel = setVerbosityLevel;
exports.shadow = shadow;
exports.string32 = string32;
exports.stringToBytes = stringToBytes;
exports.stringToPDFString = stringToPDFString;
exports.stringToUTF8String = stringToUTF8String;
exports.utf8StringToString = utf8StringToString;
exports.warn = warn;
exports.unreachable = unreachable;
Object.defineProperty(exports, "ReadableStream", {
  enumerable: true,
  get: function get() {
    return _streams_polyfill.ReadableStream;
  }
});
Object.defineProperty(exports, "URL", {
  enumerable: true,
  get: function get() {
    return _url_polyfill.URL;
  }
});
exports.createObjectURL = exports.FormatError = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.StreamType = exports.PermissionFlag = exports.PasswordResponses = exports.PasswordException = exports.NativeImageDecoding = exports.MissingPDFException = exports.InvalidPDFException = exports.AbortException = exports.CMapCompressionType = exports.ImageKind = exports.FontType = exports.AnnotationType = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationBorderStyleType = exports.UNSUPPORTED_FEATURES = exports.VerbosityLevel = exports.OPS = exports.IDENTITY_MATRIX = exports.FONT_IDENTITY_MATRIX = void 0;

__w_pdfjs_require__(2);

var _streams_polyfill = __w_pdfjs_require__(143);

var _url_polyfill = __w_pdfjs_require__(145);

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
var FONT_IDENTITY_MATRIX = [0.001, 0, 0, 0.001, 0, 0];
exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
var NativeImageDecoding = {
  NONE: 'none',
  DECODE: 'decode',
  DISPLAY: 'display'
};
exports.NativeImageDecoding = NativeImageDecoding;
var PermissionFlag = {
  PRINT: 0x04,
  MODIFY_CONTENTS: 0x08,
  COPY: 0x10,
  MODIFY_ANNOTATIONS: 0x20,
  FILL_INTERACTIVE_FORMS: 0x100,
  COPY_FOR_ACCESSIBILITY: 0x200,
  ASSEMBLE: 0x400,
  PRINT_HIGH_QUALITY: 0x800
};
exports.PermissionFlag = PermissionFlag;
var TextRenderingMode = {
  FILL: 0,
  STROKE: 1,
  FILL_STROKE: 2,
  INVISIBLE: 3,
  FILL_ADD_TO_PATH: 4,
  STROKE_ADD_TO_PATH: 5,
  FILL_STROKE_ADD_TO_PATH: 6,
  ADD_TO_PATH: 7,
  FILL_STROKE_MASK: 3,
  ADD_TO_PATH_FLAG: 4
};
exports.TextRenderingMode = TextRenderingMode;
var ImageKind = {
  GRAYSCALE_1BPP: 1,
  RGB_24BPP: 2,
  RGBA_32BPP: 3
};
exports.ImageKind = ImageKind;
var AnnotationType = {
  TEXT: 1,
  LINK: 2,
  FREETEXT: 3,
  LINE: 4,
  SQUARE: 5,
  CIRCLE: 6,
  POLYGON: 7,
  POLYLINE: 8,
  HIGHLIGHT: 9,
  UNDERLINE: 10,
  SQUIGGLY: 11,
  STRIKEOUT: 12,
  STAMP: 13,
  CARET: 14,
  INK: 15,
  POPUP: 16,
  FILEATTACHMENT: 17,
  SOUND: 18,
  MOVIE: 19,
  WIDGET: 20,
  SCREEN: 21,
  PRINTERMARK: 22,
  TRAPNET: 23,
  WATERMARK: 24,
  THREED: 25,
  REDACT: 26
};
exports.AnnotationType = AnnotationType;
var AnnotationFlag = {
  INVISIBLE: 0x01,
  HIDDEN: 0x02,
  PRINT: 0x04,
  NOZOOM: 0x08,
  NOROTATE: 0x10,
  NOVIEW: 0x20,
  READONLY: 0x40,
  LOCKED: 0x80,
  TOGGLENOVIEW: 0x100,
  LOCKEDCONTENTS: 0x200
};
exports.AnnotationFlag = AnnotationFlag;
var AnnotationFieldFlag = {
  READONLY: 0x0000001,
  REQUIRED: 0x0000002,
  NOEXPORT: 0x0000004,
  MULTILINE: 0x0001000,
  PASSWORD: 0x0002000,
  NOTOGGLETOOFF: 0x0004000,
  RADIO: 0x0008000,
  PUSHBUTTON: 0x0010000,
  COMBO: 0x0020000,
  EDIT: 0x0040000,
  SORT: 0x0080000,
  FILESELECT: 0x0100000,
  MULTISELECT: 0x0200000,
  DONOTSPELLCHECK: 0x0400000,
  DONOTSCROLL: 0x0800000,
  COMB: 0x1000000,
  RICHTEXT: 0x2000000,
  RADIOSINUNISON: 0x2000000,
  COMMITONSELCHANGE: 0x4000000
};
exports.AnnotationFieldFlag = AnnotationFieldFlag;
var AnnotationBorderStyleType = {
  SOLID: 1,
  DASHED: 2,
  BEVELED: 3,
  INSET: 4,
  UNDERLINE: 5
};
exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
var StreamType = {
  UNKNOWN: 0,
  FLATE: 1,
  LZW: 2,
  DCT: 3,
  JPX: 4,
  JBIG: 5,
  A85: 6,
  AHX: 7,
  CCF: 8,
  RL: 9
};
exports.StreamType = StreamType;
var FontType = {
  UNKNOWN: 0,
  TYPE1: 1,
  TYPE1C: 2,
  CIDFONTTYPE0: 3,
  CIDFONTTYPE0C: 4,
  TRUETYPE: 5,
  CIDFONTTYPE2: 6,
  TYPE3: 7,
  OPENTYPE: 8,
  TYPE0: 9,
  MMTYPE1: 10
};
exports.FontType = FontType;
var VerbosityLevel = {
  ERRORS: 0,
  WARNINGS: 1,
  INFOS: 5
};
exports.VerbosityLevel = VerbosityLevel;
var CMapCompressionType = {
  NONE: 0,
  BINARY: 1,
  STREAM: 2
};
exports.CMapCompressionType = CMapCompressionType;
var OPS = {
  dependency: 1,
  setLineWidth: 2,
  setLineCap: 3,
  setLineJoin: 4,
  setMiterLimit: 5,
  setDash: 6,
  setRenderingIntent: 7,
  setFlatness: 8,
  setGState: 9,
  save: 10,
  restore: 11,
  transform: 12,
  moveTo: 13,
  lineTo: 14,
  curveTo: 15,
  curveTo2: 16,
  curveTo3: 17,
  closePath: 18,
  rectangle: 19,
  stroke: 20,
  closeStroke: 21,
  fill: 22,
  eoFill: 23,
  fillStroke: 24,
  eoFillStroke: 25,
  closeFillStroke: 26,
  closeEOFillStroke: 27,
  endPath: 28,
  clip: 29,
  eoClip: 30,
  beginText: 31,
  endText: 32,
  setCharSpacing: 33,
  setWordSpacing: 34,
  setHScale: 35,
  setLeading: 36,
  setFont: 37,
  setTextRenderingMode: 38,
  setTextRise: 39,
  moveText: 40,
  setLeadingMoveText: 41,
  setTextMatrix: 42,
  nextLine: 43,
  showText: 44,
  showSpacedText: 45,
  nextLineShowText: 46,
  nextLineSetSpacingShowText: 47,
  setCharWidth: 48,
  setCharWidthAndBounds: 49,
  setStrokeColorSpace: 50,
  setFillColorSpace: 51,
  setStrokeColor: 52,
  setStrokeColorN: 53,
  setFillColor: 54,
  setFillColorN: 55,
  setStrokeGray: 56,
  setFillGray: 57,
  setStrokeRGBColor: 58,
  setFillRGBColor: 59,
  setStrokeCMYKColor: 60,
  setFillCMYKColor: 61,
  shadingFill: 62,
  beginInlineImage: 63,
  beginImageData: 64,
  endInlineImage: 65,
  paintXObject: 66,
  markPoint: 67,
  markPointProps: 68,
  beginMarkedContent: 69,
  beginMarkedContentProps: 70,
  endMarkedContent: 71,
  beginCompat: 72,
  endCompat: 73,
  paintFormXObjectBegin: 74,
  paintFormXObjectEnd: 75,
  beginGroup: 76,
  endGroup: 77,
  beginAnnotations: 78,
  endAnnotations: 79,
  beginAnnotation: 80,
  endAnnotation: 81,
  paintJpegXObject: 82,
  paintImageMaskXObject: 83,
  paintImageMaskXObjectGroup: 84,
  paintImageXObject: 85,
  paintInlineImageXObject: 86,
  paintInlineImageXObjectGroup: 87,
  paintImageXObjectRepeat: 88,
  paintImageMaskXObjectRepeat: 89,
  paintSolidColorImageMask: 90,
  constructPath: 91
};
exports.OPS = OPS;
var UNSUPPORTED_FEATURES = {
  unknown: 'unknown',
  forms: 'forms',
  javaScript: 'javaScript',
  smask: 'smask',
  shadingPattern: 'shadingPattern',
  font: 'font'
};
exports.UNSUPPORTED_FEATURES = UNSUPPORTED_FEATURES;
var PasswordResponses = {
  NEED_PASSWORD: 1,
  INCORRECT_PASSWORD: 2
};
exports.PasswordResponses = PasswordResponses;
var verbosity = VerbosityLevel.WARNINGS;

function setVerbosityLevel(level) {
  if (Number.isInteger(level)) {
    verbosity = level;
  }
}

function getVerbosityLevel() {
  return verbosity;
}

function info(msg) {
  if (verbosity >= VerbosityLevel.INFOS) {
    console.log('Info: ' + msg);
  }
}

function warn(msg) {
  if (verbosity >= VerbosityLevel.WARNINGS) {
    console.log('Warning: ' + msg);
  }
}

function unreachable(msg) {
  throw new Error(msg);
}

function assert(cond, msg) {
  if (!cond) {
    unreachable(msg);
  }
}

function isSameOrigin(baseUrl, otherUrl) {
  try {
    var base = new _url_polyfill.URL(baseUrl);

    if (!base.origin || base.origin === 'null') {
      return false;
    }
  } catch (e) {
    return false;
  }

  var other = new _url_polyfill.URL(otherUrl, base);
  return base.origin === other.origin;
}

function _isValidProtocol(url) {
  if (!url) {
    return false;
  }

  switch (url.protocol) {
    case 'http:':
    case 'https:':
    case 'ftp:':
    case 'mailto:':
    case 'tel:':
      return true;

    default:
      return false;
  }
}

function createValidAbsoluteUrl(url, baseUrl) {
  if (!url) {
    return null;
  }

  try {
    var absoluteUrl = baseUrl ? new _url_polyfill.URL(url, baseUrl) : new _url_polyfill.URL(url);

    if (_isValidProtocol(absoluteUrl)) {
      return absoluteUrl;
    }
  } catch (ex) {}

  return null;
}

function shadow(obj, prop, value) {
  Object.defineProperty(obj, prop, {
    value: value,
    enumerable: true,
    configurable: true,
    writable: false
  });
  return value;
}

var PasswordException = function PasswordExceptionClosure() {
  function PasswordException(msg, code) {
    this.name = 'PasswordException';
    this.message = msg;
    this.code = code;
  }

  PasswordException.prototype = new Error();
  PasswordException.constructor = PasswordException;
  return PasswordException;
}();

exports.PasswordException = PasswordException;

var UnknownErrorException = function UnknownErrorExceptionClosure() {
  function UnknownErrorException(msg, details) {
    this.name = 'UnknownErrorException';
    this.message = msg;
    this.details = details;
  }

  UnknownErrorException.prototype = new Error();
  UnknownErrorException.constructor = UnknownErrorException;
  return UnknownErrorException;
}();

exports.UnknownErrorException = UnknownErrorException;

var InvalidPDFException = function InvalidPDFExceptionClosure() {
  function InvalidPDFException(msg) {
    this.name = 'InvalidPDFException';
    this.message = msg;
  }

  InvalidPDFException.prototype = new Error();
  InvalidPDFException.constructor = InvalidPDFException;
  return InvalidPDFException;
}();

exports.InvalidPDFException = InvalidPDFException;

var MissingPDFException = function MissingPDFExceptionClosure() {
  function MissingPDFException(msg) {
    this.name = 'MissingPDFException';
    this.message = msg;
  }

  MissingPDFException.prototype = new Error();
  MissingPDFException.constructor = MissingPDFException;
  return MissingPDFException;
}();

exports.MissingPDFException = MissingPDFException;

var UnexpectedResponseException = function UnexpectedResponseExceptionClosure() {
  function UnexpectedResponseException(msg, status) {
    this.name = 'UnexpectedResponseException';
    this.message = msg;
    this.status = status;
  }

  UnexpectedResponseException.prototype = new Error();
  UnexpectedResponseException.constructor = UnexpectedResponseException;
  return UnexpectedResponseException;
}();

exports.UnexpectedResponseException = UnexpectedResponseException;

var FormatError = function FormatErrorClosure() {
  function FormatError(msg) {
    this.message = msg;
  }

  FormatError.prototype = new Error();
  FormatError.prototype.name = 'FormatError';
  FormatError.constructor = FormatError;
  return FormatError;
}();

exports.FormatError = FormatError;

var AbortException = function AbortExceptionClosure() {
  function AbortException(msg) {
    this.name = 'AbortException';
    this.message = msg;
  }

  AbortException.prototype = new Error();
  AbortException.constructor = AbortException;
  return AbortException;
}();

exports.AbortException = AbortException;
var NullCharactersRegExp = /\x00/g;

function removeNullCharacters(str) {
  if (typeof str !== 'string') {
    warn('The argument for removeNullCharacters must be a string.');
    return str;
  }

  return str.replace(NullCharactersRegExp, '');
}

function bytesToString(bytes) {
  assert(bytes !== null && _typeof(bytes) === 'object' && bytes.length !== undefined, 'Invalid argument for bytesToString');
  var length = bytes.length;
  var MAX_ARGUMENT_COUNT = 8192;

  if (length < MAX_ARGUMENT_COUNT) {
    return String.fromCharCode.apply(null, bytes);
  }

  var strBuf = [];

  for (var i = 0; i < length; i += MAX_ARGUMENT_COUNT) {
    var chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
    var chunk = bytes.subarray(i, chunkEnd);
    strBuf.push(String.fromCharCode.apply(null, chunk));
  }

  return strBuf.join('');
}

function stringToBytes(str) {
  assert(typeof str === 'string', 'Invalid argument for stringToBytes');
  var length = str.length;
  var bytes = new Uint8Array(length);

  for (var i = 0; i < length; ++i) {
    bytes[i] = str.charCodeAt(i) & 0xFF;
  }

  return bytes;
}

function arrayByteLength(arr) {
  if (arr.length !== undefined) {
    return arr.length;
  }

  assert(arr.byteLength !== undefined);
  return arr.byteLength;
}

function arraysToBytes(arr) {
  if (arr.length === 1 && arr[0] instanceof Uint8Array) {
    return arr[0];
  }

  var resultLength = 0;
  var i,
      ii = arr.length;
  var item, itemLength;

  for (i = 0; i < ii; i++) {
    item = arr[i];
    itemLength = arrayByteLength(item);
    resultLength += itemLength;
  }

  var pos = 0;
  var data = new Uint8Array(resultLength);

  for (i = 0; i < ii; i++) {
    item = arr[i];

    if (!(item instanceof Uint8Array)) {
      if (typeof item === 'string') {
        item = stringToBytes(item);
      } else {
        item = new Uint8Array(item);
      }
    }

    itemLength = item.byteLength;
    data.set(item, pos);
    pos += itemLength;
  }

  return data;
}

function string32(value) {
  return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
}

function log2(x) {
  if (x <= 0) {
    return 0;
  }

  return Math.ceil(Math.log2(x));
}

function readInt8(data, start) {
  return data[start] << 24 >> 24;
}

function readUint16(data, offset) {
  return data[offset] << 8 | data[offset + 1];
}

function readUint32(data, offset) {
  return (data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3]) >>> 0;
}

function isLittleEndian() {
  var buffer8 = new Uint8Array(4);
  buffer8[0] = 1;
  var view32 = new Uint32Array(buffer8.buffer, 0, 1);
  return view32[0] === 1;
}

function isEvalSupported() {
  try {
    new Function('');
    return true;
  } catch (e) {
    return false;
  }
}

var Util = function UtilClosure() {
  function Util() {}

  var rgbBuf = ['rgb(', 0, ',', 0, ',', 0, ')'];

  Util.makeCssRgb = function Util_makeCssRgb(r, g, b) {
    rgbBuf[1] = r;
    rgbBuf[3] = g;
    rgbBuf[5] = b;
    return rgbBuf.join('');
  };

  Util.transform = function Util_transform(m1, m2) {
    return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
  };

  Util.applyTransform = function Util_applyTransform(p, m) {
    var xt = p[0] * m[0] + p[1] * m[2] + m[4];
    var yt = p[0] * m[1] + p[1] * m[3] + m[5];
    return [xt, yt];
  };

  Util.applyInverseTransform = function Util_applyInverseTransform(p, m) {
    var d = m[0] * m[3] - m[1] * m[2];
    var xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
    var yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
    return [xt, yt];
  };

  Util.getAxialAlignedBoundingBox = function Util_getAxialAlignedBoundingBox(r, m) {
    var p1 = Util.applyTransform(r, m);
    var p2 = Util.applyTransform(r.slice(2, 4), m);
    var p3 = Util.applyTransform([r[0], r[3]], m);
    var p4 = Util.applyTransform([r[2], r[1]], m);
    return [Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1])];
  };

  Util.inverseTransform = function Util_inverseTransform(m) {
    var d = m[0] * m[3] - m[1] * m[2];
    return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[4] * m[3]) / d, (m[4] * m[1] - m[5] * m[0]) / d];
  };

  Util.apply3dTransform = function Util_apply3dTransform(m, v) {
    return [m[0] * v[0] + m[1] * v[1] + m[2] * v[2], m[3] * v[0] + m[4] * v[1] + m[5] * v[2], m[6] * v[0] + m[7] * v[1] + m[8] * v[2]];
  };

  Util.singularValueDecompose2dScale = function Util_singularValueDecompose2dScale(m) {
    var transpose = [m[0], m[2], m[1], m[3]];
    var a = m[0] * transpose[0] + m[1] * transpose[2];
    var b = m[0] * transpose[1] + m[1] * transpose[3];
    var c = m[2] * transpose[0] + m[3] * transpose[2];
    var d = m[2] * transpose[1] + m[3] * transpose[3];
    var first = (a + d) / 2;
    var second = Math.sqrt((a + d) * (a + d) - 4 * (a * d - c * b)) / 2;
    var sx = first + second || 1;
    var sy = first - second || 1;
    return [Math.sqrt(sx), Math.sqrt(sy)];
  };

  Util.normalizeRect = function Util_normalizeRect(rect) {
    var r = rect.slice(0);

    if (rect[0] > rect[2]) {
      r[0] = rect[2];
      r[2] = rect[0];
    }

    if (rect[1] > rect[3]) {
      r[1] = rect[3];
      r[3] = rect[1];
    }

    return r;
  };

  Util.intersect = function Util_intersect(rect1, rect2) {
    function compare(a, b) {
      return a - b;
    }

    var orderedX = [rect1[0], rect1[2], rect2[0], rect2[2]].sort(compare),
        orderedY = [rect1[1], rect1[3], rect2[1], rect2[3]].sort(compare),
        result = [];
    rect1 = Util.normalizeRect(rect1);
    rect2 = Util.normalizeRect(rect2);

    if (orderedX[0] === rect1[0] && orderedX[1] === rect2[0] || orderedX[0] === rect2[0] && orderedX[1] === rect1[0]) {
      result[0] = orderedX[1];
      result[2] = orderedX[2];
    } else {
      return false;
    }

    if (orderedY[0] === rect1[1] && orderedY[1] === rect2[1] || orderedY[0] === rect2[1] && orderedY[1] === rect1[1]) {
      result[1] = orderedY[1];
      result[3] = orderedY[2];
    } else {
      return false;
    }

    return result;
  };

  return Util;
}();

exports.Util = Util;
var PDFStringTranslateTable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2D8, 0x2C7, 0x2C6, 0x2D9, 0x2DD, 0x2DB, 0x2DA, 0x2DC, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2022, 0x2020, 0x2021, 0x2026, 0x2014, 0x2013, 0x192, 0x2044, 0x2039, 0x203A, 0x2212, 0x2030, 0x201E, 0x201C, 0x201D, 0x2018, 0x2019, 0x201A, 0x2122, 0xFB01, 0xFB02, 0x141, 0x152, 0x160, 0x178, 0x17D, 0x131, 0x142, 0x153, 0x161, 0x17E, 0, 0x20AC];

function stringToPDFString(str) {
  var i,
      n = str.length,
      strBuf = [];

  if (str[0] === '\xFE' && str[1] === '\xFF') {
    for (i = 2; i < n; i += 2) {
      strBuf.push(String.fromCharCode(str.charCodeAt(i) << 8 | str.charCodeAt(i + 1)));
    }
  } else {
    for (i = 0; i < n; ++i) {
      var code = PDFStringTranslateTable[str.charCodeAt(i)];
      strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
    }
  }

  return strBuf.join('');
}

function stringToUTF8String(str) {
  return decodeURIComponent(escape(str));
}

function utf8StringToString(str) {
  return unescape(encodeURIComponent(str));
}

function isEmptyObj(obj) {
  for (var key in obj) {
    return false;
  }

  return true;
}

function isBool(v) {
  return typeof v === 'boolean';
}

function isNum(v) {
  return typeof v === 'number';
}

function isString(v) {
  return typeof v === 'string';
}

function isArrayBuffer(v) {
  return _typeof(v) === 'object' && v !== null && v.byteLength !== undefined;
}

function isArrayEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false;
  }

  return arr1.every(function (element, index) {
    return element === arr2[index];
  });
}

function isSpace(ch) {
  return ch === 0x20 || ch === 0x09 || ch === 0x0D || ch === 0x0A;
}

function createPromiseCapability() {
  var capability = Object.create(null);
  var isSettled = false;
  Object.defineProperty(capability, 'settled', {
    get: function get() {
      return isSettled;
    }
  });
  capability.promise = new Promise(function (resolve, reject) {
    capability.resolve = function (data) {
      isSettled = true;
      resolve(data);
    };

    capability.reject = function (reason) {
      isSettled = true;
      reject(reason);
    };
  });
  return capability;
}

var createObjectURL = function createObjectURLClosure() {
  var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  return function createObjectURL(data, contentType) {
    var forceDataSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (!forceDataSchema && _url_polyfill.URL.createObjectURL) {
      var blob = new Blob([data], {
        type: contentType
      });
      return _url_polyfill.URL.createObjectURL(blob);
    }

    var buffer = 'data:' + contentType + ';base64,';

    for (var i = 0, ii = data.length; i < ii; i += 3) {
      var b1 = data[i] & 0xFF;
      var b2 = data[i + 1] & 0xFF;
      var b3 = data[i + 2] & 0xFF;
      var d1 = b1 >> 2,
          d2 = (b1 & 3) << 4 | b2 >> 4;
      var d3 = i + 1 < ii ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
      var d4 = i + 2 < ii ? b3 & 0x3F : 64;
      buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
    }

    return buffer;
  };
}();

exports.createObjectURL = createObjectURL;

/***/ }),
/* 2 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var globalScope = __w_pdfjs_require__(3);

if (!globalScope._pdfjsCompatibilityChecked) {
  globalScope._pdfjsCompatibilityChecked = true;

  var isNodeJS = __w_pdfjs_require__(4);

  var hasDOM = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object';

  (function checkNodeBtoa() {
    if (globalScope.btoa || !isNodeJS()) {
      return;
    }

    globalScope.btoa = function (chars) {
      return Buffer.from(chars, 'binary').toString('base64');
    };
  })();

  (function checkNodeAtob() {
    if (globalScope.atob || !isNodeJS()) {
      return;
    }

    globalScope.atob = function (input) {
      return Buffer.from(input, 'base64').toString('binary');
    };
  })();

  (function checkChildNodeRemove() {
    if (!hasDOM) {
      return;
    }

    if (typeof Element.prototype.remove !== 'undefined') {
      return;
    }

    Element.prototype.remove = function () {
      if (this.parentNode) {
        this.parentNode.removeChild(this);
      }
    };
  })();

  (function checkDOMTokenListAddRemove() {
    if (!hasDOM || isNodeJS()) {
      return;
    }

    var div = document.createElement('div');
    div.classList.add('testOne', 'testTwo');

    if (div.classList.contains('testOne') === true && div.classList.contains('testTwo') === true) {
      return;
    }

    var OriginalDOMTokenListAdd = DOMTokenList.prototype.add;
    var OriginalDOMTokenListRemove = DOMTokenList.prototype.remove;

    DOMTokenList.prototype.add = function () {
      for (var _len = arguments.length, tokens = new Array(_len), _key = 0; _key < _len; _key++) {
        tokens[_key] = arguments[_key];
      }

      for (var _i = 0, _tokens = tokens; _i < _tokens.length; _i++) {
        var token = _tokens[_i];
        OriginalDOMTokenListAdd.call(this, token);
      }
    };

    DOMTokenList.prototype.remove = function () {
      for (var _len2 = arguments.length, tokens = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        tokens[_key2] = arguments[_key2];
      }

      for (var _i2 = 0, _tokens2 = tokens; _i2 < _tokens2.length; _i2++) {
        var token = _tokens2[_i2];
        OriginalDOMTokenListRemove.call(this, token);
      }
    };
  })();

  (function checkDOMTokenListToggle() {
    if (!hasDOM || isNodeJS()) {
      return;
    }

    var div = document.createElement('div');

    if (div.classList.toggle('test', 0) === false) {
      return;
    }

    DOMTokenList.prototype.toggle = function (token) {
      var force = arguments.length > 1 ? !!arguments[1] : !this.contains(token);
      return this[force ? 'add' : 'remove'](token), force;
    };
  })();

  (function checkStringStartsWith() {
    if (String.prototype.startsWith) {
      return;
    }

    __w_pdfjs_require__(5);
  })();

  (function checkStringEndsWith() {
    if (String.prototype.endsWith) {
      return;
    }

    __w_pdfjs_require__(36);
  })();

  (function checkStringIncludes() {
    if (String.prototype.includes) {
      return;
    }

    __w_pdfjs_require__(38);
  })();

  (function checkArrayIncludes() {
    if (Array.prototype.includes) {
      return;
    }

    __w_pdfjs_require__(40);
  })();

  (function checkArrayFrom() {
    if (Array.from) {
      return;
    }

    __w_pdfjs_require__(47);
  })();

  (function checkObjectAssign() {
    if (Object.assign) {
      return;
    }

    __w_pdfjs_require__(70);
  })();

  (function checkMathLog2() {
    if (Math.log2) {
      return;
    }

    Math.log2 = __w_pdfjs_require__(75);
  })();

  (function checkNumberIsNaN() {
    if (Number.isNaN) {
      return;
    }

    Number.isNaN = __w_pdfjs_require__(77);
  })();

  (function checkNumberIsInteger() {
    if (Number.isInteger) {
      return;
    }

    Number.isInteger = __w_pdfjs_require__(79);
  })();

  (function checkPromise() {
    if (globalScope.Promise && globalScope.Promise.prototype && globalScope.Promise.prototype["finally"]) {
      return;
    }

    globalScope.Promise = __w_pdfjs_require__(82);
  })();

  (function checkWeakMap() {
    if (globalScope.WeakMap) {
      return;
    }

    globalScope.WeakMap = __w_pdfjs_require__(102);
  })();

  (function checkWeakSet() {
    if (globalScope.WeakSet) {
      return;
    }

    globalScope.WeakSet = __w_pdfjs_require__(119);
  })();

  (function checkStringCodePointAt() {
    if (String.codePointAt) {
      return;
    }

    String.codePointAt = __w_pdfjs_require__(123);
  })();

  (function checkStringFromCodePoint() {
    if (String.fromCodePoint) {
      return;
    }

    String.fromCodePoint = __w_pdfjs_require__(125);
  })();

  (function checkSymbol() {
    if (globalScope.Symbol) {
      return;
    }

    __w_pdfjs_require__(127);
  })();

  (function checkStringPadStart() {
    if (String.prototype.padStart) {
      return;
    }

    __w_pdfjs_require__(134);
  })();

  (function checkStringPadEnd() {
    if (String.prototype.padEnd) {
      return;
    }

    __w_pdfjs_require__(138);
  })();

  (function checkObjectValues() {
    if (Object.values) {
      return;
    }

    Object.values = __w_pdfjs_require__(140);
  })();
}

/***/ }),
/* 3 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = typeof window !== 'undefined' && window.Math === Math ? window : typeof global !== 'undefined' && global.Math === Math ? global : typeof self !== 'undefined' && self.Math === Math ? self : {};

/***/ }),
/* 4 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function isNodeJS() {
  return (typeof process === "undefined" ? "undefined" : _typeof(process)) === 'object' && process + '' === '[object process]' && !process.versions['nw'] && !process.versions['electron'];
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(6);

module.exports = __w_pdfjs_require__(9).String.startsWith;

/***/ }),
/* 6 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);

var toLength = __w_pdfjs_require__(28);

var context = __w_pdfjs_require__(30);

var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];
$export($export.P + $export.F * __w_pdfjs_require__(35)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith ? $startsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
  }
});

/***/ }),
/* 7 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var global = __w_pdfjs_require__(8);

var core = __w_pdfjs_require__(9);

var hide = __w_pdfjs_require__(10);

var redefine = __w_pdfjs_require__(20);

var ctx = __w_pdfjs_require__(26);

var PROTOTYPE = 'prototype';

var $export = function $export(type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;

  for (key in source) {
    own = !IS_FORCED && target && target[key] !== undefined;
    out = (own ? target : source)[key];
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    if (target) redefine(target, key, out, type & $export.U);
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};

global.core = core;
$export.F = 1;
$export.G = 2;
$export.S = 4;
$export.P = 8;
$export.B = 16;
$export.W = 32;
$export.U = 64;
$export.R = 128;
module.exports = $export;

/***/ }),
/* 8 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = global;

/***/ }),
/* 9 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var core = module.exports = {
  version: '2.6.9'
};
if (typeof __e == 'number') __e = core;

/***/ }),
/* 10 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var dP = __w_pdfjs_require__(11);

var createDesc = __w_pdfjs_require__(19);

module.exports = __w_pdfjs_require__(15) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var anObject = __w_pdfjs_require__(12);

var IE8_DOM_DEFINE = __w_pdfjs_require__(14);

var toPrimitive = __w_pdfjs_require__(18);

var dP = Object.defineProperty;
exports.f = __w_pdfjs_require__(15) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) {}
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isObject = __w_pdfjs_require__(13);

module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (it) {
  return _typeof(it) === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = !__w_pdfjs_require__(15) && !__w_pdfjs_require__(16)(function () {
  return Object.defineProperty(__w_pdfjs_require__(17)('div'), 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
});

/***/ }),
/* 15 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = !__w_pdfjs_require__(16)(function () {
  return Object.defineProperty({}, 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
});

/***/ }),
/* 16 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isObject = __w_pdfjs_require__(13);

var document = __w_pdfjs_require__(8).document;

var is = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isObject = __w_pdfjs_require__(13);

module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var global = __w_pdfjs_require__(8);

var hide = __w_pdfjs_require__(10);

var has = __w_pdfjs_require__(21);

var SRC = __w_pdfjs_require__(22)('src');

var $toString = __w_pdfjs_require__(23);

var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__w_pdfjs_require__(9).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));

  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

/***/ }),
/* 21 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var id = 0;
var px = Math.random();

module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = __w_pdfjs_require__(24)('native-function-to-string', Function.toString);

/***/ }),
/* 24 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var core = __w_pdfjs_require__(9);

var global = __w_pdfjs_require__(8);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __w_pdfjs_require__(25) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});

/***/ }),
/* 25 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = false;

/***/ }),
/* 26 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var aFunction = __w_pdfjs_require__(27);

module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;

  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };

    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };

    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }

  return function () {
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var toInteger = __w_pdfjs_require__(29);

var min = Math.min;

module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0;
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var ceil = Math.ceil;
var floor = Math.floor;

module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isRegExp = __w_pdfjs_require__(31);

var defined = __w_pdfjs_require__(34);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isObject = __w_pdfjs_require__(13);

var cof = __w_pdfjs_require__(32);

var MATCH = __w_pdfjs_require__(33)('match');

module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var store = __w_pdfjs_require__(24)('wks');

var uid = __w_pdfjs_require__(22);

var _Symbol = __w_pdfjs_require__(8).Symbol;

var USE_SYMBOL = typeof _Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 34 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var MATCH = __w_pdfjs_require__(33)('match');

module.exports = function (KEY) {
  var re = /./;

  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) {}
  }

  return true;
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(37);

module.exports = __w_pdfjs_require__(9).String.endsWith;

/***/ }),
/* 37 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);

var toLength = __w_pdfjs_require__(28);

var context = __w_pdfjs_require__(30);

var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];
$export($export.P + $export.F * __w_pdfjs_require__(35)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith ? $endsWith.call(that, search, end) : that.slice(end - search.length, end) === search;
  }
});

/***/ }),
/* 38 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(39);

module.exports = __w_pdfjs_require__(9).String.includes;

/***/ }),
/* 39 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);

var context = __w_pdfjs_require__(30);

var INCLUDES = 'includes';
$export($export.P + $export.F * __w_pdfjs_require__(35)(INCLUDES), 'String', {
  includes: function includes(searchString) {
    return !!~context(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

/***/ }),
/* 40 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(41);

module.exports = __w_pdfjs_require__(9).Array.includes;

/***/ }),
/* 41 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);

var $includes = __w_pdfjs_require__(42)(true);

$export($export.P, 'Array', {
  includes: function includes(el) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__w_pdfjs_require__(46)('includes');

/***/ }),
/* 42 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var toIObject = __w_pdfjs_require__(43);

var toLength = __w_pdfjs_require__(28);

var toAbsoluteIndex = __w_pdfjs_require__(45);

module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      if (value != value) return true;
    } else for (; length > index; index++) {
      if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
    }
    return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var IObject = __w_pdfjs_require__(44);

var defined = __w_pdfjs_require__(34);

module.exports = function (it) {
  return IObject(defined(it));
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var cof = __w_pdfjs_require__(32);

module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 45 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var toInteger = __w_pdfjs_require__(29);

var max = Math.max;
var min = Math.min;

module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var UNSCOPABLES = __w_pdfjs_require__(33)('unscopables');

var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __w_pdfjs_require__(10)(ArrayProto, UNSCOPABLES, {});

module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(48);

__w_pdfjs_require__(63);

module.exports = __w_pdfjs_require__(9).Array.from;

/***/ }),
/* 48 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $at = __w_pdfjs_require__(49)(true);

__w_pdfjs_require__(50)(String, 'String', function (iterated) {
  this._t = String(iterated);
  this._i = 0;
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return {
    value: undefined,
    done: true
  };
  point = $at(O, index);
  this._i += point.length;
  return {
    value: point,
    done: false
  };
});

/***/ }),
/* 49 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var toInteger = __w_pdfjs_require__(29);

var defined = __w_pdfjs_require__(34);

module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 50 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var LIBRARY = __w_pdfjs_require__(25);

var $export = __w_pdfjs_require__(7);

var redefine = __w_pdfjs_require__(20);

var hide = __w_pdfjs_require__(10);

var Iterators = __w_pdfjs_require__(51);

var $iterCreate = __w_pdfjs_require__(52);

var setToStringTag = __w_pdfjs_require__(60);

var getPrototypeOf = __w_pdfjs_require__(61);

var ITERATOR = __w_pdfjs_require__(33)('iterator');

var BUGGY = !([].keys && 'next' in [].keys());
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function returnThis() {
  return this;
};

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);

  var getMethod = function getMethod(kind) {
    if (!BUGGY && kind in proto) return proto[kind];

    switch (kind) {
      case KEYS:
        return function keys() {
          return new Constructor(this, kind);
        };

      case VALUES:
        return function values() {
          return new Constructor(this, kind);
        };
    }

    return function entries() {
      return new Constructor(this, kind);
    };
  };

  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;

  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));

    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      setToStringTag(IteratorPrototype, TAG, true);
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }

  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;

    $default = function values() {
      return $native.call(this);
    };
  }

  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }

  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;

  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }

  return methods;
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = {};

/***/ }),
/* 52 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var create = __w_pdfjs_require__(53);

var descriptor = __w_pdfjs_require__(19);

var setToStringTag = __w_pdfjs_require__(60);

var IteratorPrototype = {};

__w_pdfjs_require__(10)(IteratorPrototype, __w_pdfjs_require__(33)('iterator'), function () {
  return this;
});

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, {
    next: descriptor(1, next)
  });
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var anObject = __w_pdfjs_require__(12);

var dPs = __w_pdfjs_require__(54);

var enumBugKeys = __w_pdfjs_require__(58);

var IE_PROTO = __w_pdfjs_require__(57)('IE_PROTO');

var Empty = function Empty() {};

var PROTOTYPE = 'prototype';

var _createDict = function createDict() {
  var iframe = __w_pdfjs_require__(17)('iframe');

  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';

  __w_pdfjs_require__(59).appendChild(iframe);

  iframe.src = 'javascript:';
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  _createDict = iframeDocument.F;

  while (i--) {
    delete _createDict[PROTOTYPE][enumBugKeys[i]];
  }

  return _createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;

  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    result[IE_PROTO] = O;
  } else result = _createDict();

  return Properties === undefined ? result : dPs(result, Properties);
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var dP = __w_pdfjs_require__(11);

var anObject = __w_pdfjs_require__(12);

var getKeys = __w_pdfjs_require__(55);

module.exports = __w_pdfjs_require__(15) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;

  while (length > i) {
    dP.f(O, P = keys[i++], Properties[P]);
  }

  return O;
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $keys = __w_pdfjs_require__(56);

var enumBugKeys = __w_pdfjs_require__(58);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var has = __w_pdfjs_require__(21);

var toIObject = __w_pdfjs_require__(43);

var arrayIndexOf = __w_pdfjs_require__(42)(false);

var IE_PROTO = __w_pdfjs_require__(57)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;

  for (key in O) {
    if (key != IE_PROTO) has(O, key) && result.push(key);
  }

  while (names.length > i) {
    if (has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
  }

  return result;
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var shared = __w_pdfjs_require__(24)('keys');

var uid = __w_pdfjs_require__(22);

module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

/***/ }),
/* 59 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var document = __w_pdfjs_require__(8).document;

module.exports = document && document.documentElement;

/***/ }),
/* 60 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var def = __w_pdfjs_require__(11).f;

var has = __w_pdfjs_require__(21);

var TAG = __w_pdfjs_require__(33)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
    configurable: true,
    value: tag
  });
};

/***/ }),
/* 61 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var has = __w_pdfjs_require__(21);

var toObject = __w_pdfjs_require__(62);

var IE_PROTO = __w_pdfjs_require__(57)('IE_PROTO');

var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];

  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  }

  return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var defined = __w_pdfjs_require__(34);

module.exports = function (it) {
  return Object(defined(it));
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var ctx = __w_pdfjs_require__(26);

var $export = __w_pdfjs_require__(7);

var toObject = __w_pdfjs_require__(62);

var call = __w_pdfjs_require__(64);

var isArrayIter = __w_pdfjs_require__(65);

var toLength = __w_pdfjs_require__(28);

var createProperty = __w_pdfjs_require__(66);

var getIterFn = __w_pdfjs_require__(67);

$export($export.S + $export.F * !__w_pdfjs_require__(69)(function (iter) {
  Array.from(iter);
}), 'Array', {
  from: function from(arrayLike) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);

    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);

      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }

    result.length = index;
    return result;
  }
});

/***/ }),
/* 64 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var anObject = __w_pdfjs_require__(12);

module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var Iterators = __w_pdfjs_require__(51);

var ITERATOR = __w_pdfjs_require__(33)('iterator');

var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $defineProperty = __w_pdfjs_require__(11);

var createDesc = __w_pdfjs_require__(19);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var classof = __w_pdfjs_require__(68);

var ITERATOR = __w_pdfjs_require__(33)('iterator');

var Iterators = __w_pdfjs_require__(51);

module.exports = __w_pdfjs_require__(9).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var cof = __w_pdfjs_require__(32);

var TAG = __w_pdfjs_require__(33)('toStringTag');

var ARG = cof(function () {
  return arguments;
}()) == 'Arguments';

var tryGet = function tryGet(it, key) {
  try {
    return it[key];
  } catch (e) {}
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T : ARG ? cof(O) : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var ITERATOR = __w_pdfjs_require__(33)('iterator');

var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();

  riter['return'] = function () {
    SAFE_CLOSING = true;
  };

  Array.from(riter, function () {
    throw 2;
  });
} catch (e) {}

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;

  try {
    var arr = [7];
    var iter = arr[ITERATOR]();

    iter.next = function () {
      return {
        done: safe = true
      };
    };

    arr[ITERATOR] = function () {
      return iter;
    };

    exec(arr);
  } catch (e) {}

  return safe;
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(71);

module.exports = __w_pdfjs_require__(9).Object.assign;

/***/ }),
/* 71 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);

$export($export.S + $export.F, 'Object', {
  assign: __w_pdfjs_require__(72)
});

/***/ }),
/* 72 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var DESCRIPTORS = __w_pdfjs_require__(15);

var getKeys = __w_pdfjs_require__(55);

var gOPS = __w_pdfjs_require__(73);

var pIE = __w_pdfjs_require__(74);

var toObject = __w_pdfjs_require__(62);

var IObject = __w_pdfjs_require__(44);

var $assign = Object.assign;
module.exports = !$assign || __w_pdfjs_require__(16)(function () {
  var A = {};
  var B = {};
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) {
    B[k] = k;
  });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;

  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;

    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  }

  return T;
} : $assign;

/***/ }),
/* 73 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 74 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 75 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(76);

module.exports = __w_pdfjs_require__(9).Math.log2;

/***/ }),
/* 76 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});

/***/ }),
/* 77 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(78);

module.exports = __w_pdfjs_require__(9).Number.isNaN;

/***/ }),
/* 78 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    return number != number;
  }
});

/***/ }),
/* 79 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(80);

module.exports = __w_pdfjs_require__(9).Number.isInteger;

/***/ }),
/* 80 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);

$export($export.S, 'Number', {
  isInteger: __w_pdfjs_require__(81)
});

/***/ }),
/* 81 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isObject = __w_pdfjs_require__(13);

var floor = Math.floor;

module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

/***/ }),
/* 82 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(83);

__w_pdfjs_require__(48);

__w_pdfjs_require__(84);

__w_pdfjs_require__(87);

__w_pdfjs_require__(100);

__w_pdfjs_require__(101);

module.exports = __w_pdfjs_require__(9).Promise;

/***/ }),
/* 83 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var classof = __w_pdfjs_require__(68);

var test = {};
test[__w_pdfjs_require__(33)('toStringTag')] = 'z';

if (test + '' != '[object z]') {
  __w_pdfjs_require__(20)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}

/***/ }),
/* 84 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $iterators = __w_pdfjs_require__(85);

var getKeys = __w_pdfjs_require__(55);

var redefine = __w_pdfjs_require__(20);

var global = __w_pdfjs_require__(8);

var hide = __w_pdfjs_require__(10);

var Iterators = __w_pdfjs_require__(51);

var wks = __w_pdfjs_require__(33);

var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;
var DOMIterables = {
  CSSRuleList: true,
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true,
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true,
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;

  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) {
      if (!proto[key]) redefine(proto, key, $iterators[key], true);
    }
  }
}

/***/ }),
/* 85 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var addToUnscopables = __w_pdfjs_require__(46);

var step = __w_pdfjs_require__(86);

var Iterators = __w_pdfjs_require__(51);

var toIObject = __w_pdfjs_require__(43);

module.exports = __w_pdfjs_require__(50)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated);
  this._i = 0;
  this._k = kind;
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;

  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }

  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');
Iterators.Arguments = Iterators.Array;
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 86 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (done, value) {
  return {
    value: value,
    done: !!done
  };
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var LIBRARY = __w_pdfjs_require__(25);

var global = __w_pdfjs_require__(8);

var ctx = __w_pdfjs_require__(26);

var classof = __w_pdfjs_require__(68);

var $export = __w_pdfjs_require__(7);

var isObject = __w_pdfjs_require__(13);

var aFunction = __w_pdfjs_require__(27);

var anInstance = __w_pdfjs_require__(88);

var forOf = __w_pdfjs_require__(89);

var speciesConstructor = __w_pdfjs_require__(90);

var task = __w_pdfjs_require__(91).set;

var microtask = __w_pdfjs_require__(93)();

var newPromiseCapabilityModule = __w_pdfjs_require__(94);

var perform = __w_pdfjs_require__(95);

var userAgent = __w_pdfjs_require__(96);

var promiseResolve = __w_pdfjs_require__(97);

var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';

var empty = function empty() {};

var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
var USE_NATIVE = !!function () {
  try {
    var promise = $Promise.resolve(1);

    var FakePromise = (promise.constructor = {})[__w_pdfjs_require__(33)('species')] = function (exec) {
      exec(empty, empty);
    };

    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise && v8.indexOf('6.6') !== 0 && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) {}
}();

var isThenable = function isThenable(it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify = function notify(promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;

    var run = function run(reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;

      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }

          if (handler === true) result = value;else {
            if (domain) domain.enter();
            result = handler(value);

            if (domain) {
              domain.exit();
              exited = true;
            }
          }

          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };

    while (chain.length > i) {
      run(chain[i++]);
    }

    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};

var onUnhandled = function onUnhandled(promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;

    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({
            promise: promise,
            reason: value
          });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    }

    promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};

var isUnhandled = function isUnhandled(promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};

var onHandleUnhandled = function onHandleUnhandled(promise) {
  task.call(global, function () {
    var handler;

    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({
        promise: promise,
        reason: promise._v
      });
    }
  });
};

var $reject = function $reject(value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise;
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};

var $resolve = function $resolve(value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise;

  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");

    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = {
          _w: promise,
          _d: false
        };

        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({
      _w: promise,
      _d: false
    }, e);
  }
};

if (!USE_NATIVE) {
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);

    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };

  Internal = function Promise(executor) {
    this._c = [];
    this._a = undefined;
    this._s = 0;
    this._d = false;
    this._v = undefined;
    this._h = 0;
    this._n = false;
  };

  Internal.prototype = __w_pdfjs_require__(98)($Promise.prototype, {
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;

      this._c.push(reaction);

      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    'catch': function _catch(onRejected) {
      return this.then(undefined, onRejected);
    }
  });

  OwnPromiseCapability = function OwnPromiseCapability() {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };

  newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
    return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {
  Promise: $Promise
});

__w_pdfjs_require__(60)($Promise, PROMISE);

__w_pdfjs_require__(99)(PROMISE);

Wrapper = __w_pdfjs_require__(9)[PROMISE];
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __w_pdfjs_require__(69)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

/***/ }),
/* 88 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
    throw TypeError(name + ': incorrect invocation!');
  }

  return it;
};

/***/ }),
/* 89 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var ctx = __w_pdfjs_require__(26);

var call = __w_pdfjs_require__(64);

var isArrayIter = __w_pdfjs_require__(65);

var anObject = __w_pdfjs_require__(12);

var toLength = __w_pdfjs_require__(28);

var getIterFn = __w_pdfjs_require__(67);

var BREAK = {};
var RETURN = {};

var _exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () {
    return iterable;
  } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};

_exports.BREAK = BREAK;
_exports.RETURN = RETURN;

/***/ }),
/* 90 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var anObject = __w_pdfjs_require__(12);

var aFunction = __w_pdfjs_require__(27);

var SPECIES = __w_pdfjs_require__(33)('species');

module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var ctx = __w_pdfjs_require__(26);

var invoke = __w_pdfjs_require__(92);

var html = __w_pdfjs_require__(59);

var cel = __w_pdfjs_require__(17);

var global = __w_pdfjs_require__(8);

var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function run() {
  var id = +this;

  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var listener = function listener(event) {
  run.call(event.data);
};

if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;

    while (arguments.length > i) {
      args.push(arguments[i++]);
    }

    queue[++counter] = function () {
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };

    defer(counter);
    return counter;
  };

  clearTask = function clearImmediate(id) {
    delete queue[id];
  };

  if (__w_pdfjs_require__(32)(process) == 'process') {
    defer = function defer(id) {
      process.nextTick(ctx(run, id, 1));
    };
  } else if (Dispatch && Dispatch.now) {
    defer = function defer(id) {
      Dispatch.now(ctx(run, id, 1));
    };
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function defer(id) {
      global.postMessage(id + '', '*');
    };

    global.addEventListener('message', listener, false);
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function defer(id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  } else {
    defer = function defer(id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}

module.exports = {
  set: setTask,
  clear: clearTask
};

/***/ }),
/* 92 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (fn, args, that) {
  var un = that === undefined;

  switch (args.length) {
    case 0:
      return un ? fn() : fn.call(that);

    case 1:
      return un ? fn(args[0]) : fn.call(that, args[0]);

    case 2:
      return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);

    case 3:
      return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);

    case 4:
      return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
  }

  return fn.apply(that, args);
};

/***/ }),
/* 93 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var global = __w_pdfjs_require__(8);

var macrotask = __w_pdfjs_require__(91).set;

var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __w_pdfjs_require__(32)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function flush() {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();

    while (head) {
      fn = head.fn;
      head = head.next;

      try {
        fn();
      } catch (e) {
        if (head) notify();else last = undefined;
        throw e;
      }
    }

    last = undefined;
    if (parent) parent.enter();
  };

  if (isNode) {
    notify = function notify() {
      process.nextTick(flush);
    };
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, {
      characterData: true
    });

    notify = function notify() {
      node.data = toggle = !toggle;
    };
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve(undefined);

    notify = function notify() {
      promise.then(flush);
    };
  } else {
    notify = function notify() {
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = {
      fn: fn,
      next: undefined
    };
    if (last) last.next = task;

    if (!head) {
      head = task;
      notify();
    }

    last = task;
  };
};

/***/ }),
/* 94 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var aFunction = __w_pdfjs_require__(27);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};

/***/ }),
/* 95 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (exec) {
  try {
    return {
      e: false,
      v: exec()
    };
  } catch (e) {
    return {
      e: true,
      v: e
    };
  }
};

/***/ }),
/* 96 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var global = __w_pdfjs_require__(8);

var navigator = global.navigator;
module.exports = navigator && navigator.userAgent || '';

/***/ }),
/* 97 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var anObject = __w_pdfjs_require__(12);

var isObject = __w_pdfjs_require__(13);

var newPromiseCapability = __w_pdfjs_require__(94);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var redefine = __w_pdfjs_require__(20);

module.exports = function (target, src, safe) {
  for (var key in src) {
    redefine(target, key, src[key], safe);
  }

  return target;
};

/***/ }),
/* 99 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var global = __w_pdfjs_require__(8);

var dP = __w_pdfjs_require__(11);

var DESCRIPTORS = __w_pdfjs_require__(15);

var SPECIES = __w_pdfjs_require__(33)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function get() {
      return this;
    }
  });
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);

var core = __w_pdfjs_require__(9);

var global = __w_pdfjs_require__(8);

var speciesConstructor = __w_pdfjs_require__(90);

var promiseResolve = __w_pdfjs_require__(97);

$export($export.P + $export.R, 'Promise', {
  'finally': function _finally(onFinally) {
    var C = speciesConstructor(this, core.Promise || global.Promise);
    var isFunction = typeof onFinally == 'function';
    return this.then(isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () {
        return x;
      });
    } : onFinally, isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () {
        throw e;
      });
    } : onFinally);
  }
});

/***/ }),
/* 101 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);

var newPromiseCapability = __w_pdfjs_require__(94);

var perform = __w_pdfjs_require__(95);

$export($export.S, 'Promise', {
  'try': function _try(callbackfn) {
    var promiseCapability = newPromiseCapability.f(this);
    var result = perform(callbackfn);
    (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
    return promiseCapability.promise;
  }
});

/***/ }),
/* 102 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(83);

__w_pdfjs_require__(84);

__w_pdfjs_require__(103);

__w_pdfjs_require__(115);

__w_pdfjs_require__(117);

module.exports = __w_pdfjs_require__(9).WeakMap;

/***/ }),
/* 103 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var global = __w_pdfjs_require__(8);

var each = __w_pdfjs_require__(104)(0);

var redefine = __w_pdfjs_require__(20);

var meta = __w_pdfjs_require__(108);

var assign = __w_pdfjs_require__(72);

var weak = __w_pdfjs_require__(109);

var isObject = __w_pdfjs_require__(13);

var validate = __w_pdfjs_require__(110);

var NATIVE_WEAK_MAP = __w_pdfjs_require__(110);

var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function wrapper(get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

var $WeakMap = module.exports = __w_pdfjs_require__(111)(WEAK_MAP, wrapper, methods, weak, true, true);

if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();

        var result = this._f[key](a, b);

        return key == 'set' ? this : result;
      }

      return method.call(this, a, b);
    });
  });
}

/***/ }),
/* 104 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var ctx = __w_pdfjs_require__(26);

var IObject = __w_pdfjs_require__(44);

var toObject = __w_pdfjs_require__(62);

var toLength = __w_pdfjs_require__(28);

var asc = __w_pdfjs_require__(105);

module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;

    for (; length > index; index++) {
      if (NO_HOLES || index in self) {
        val = self[index];
        res = f(val, index, O);

        if (TYPE) {
          if (IS_MAP) result[index] = res;else if (res) switch (TYPE) {
            case 3:
              return true;

            case 5:
              return val;

            case 6:
              return index;

            case 2:
              result.push(val);
          } else if (IS_EVERY) return false;
        }
      }
    }

    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var speciesConstructor = __w_pdfjs_require__(106);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};

/***/ }),
/* 106 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isObject = __w_pdfjs_require__(13);

var isArray = __w_pdfjs_require__(107);

var SPECIES = __w_pdfjs_require__(33)('species');

module.exports = function (original) {
  var C;

  if (isArray(original)) {
    C = original.constructor;
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;

    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  }

  return C === undefined ? Array : C;
};

/***/ }),
/* 107 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var cof = __w_pdfjs_require__(32);

module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

/***/ }),
/* 108 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var META = __w_pdfjs_require__(22)('meta');

var isObject = __w_pdfjs_require__(13);

var has = __w_pdfjs_require__(21);

var setDesc = __w_pdfjs_require__(11).f;

var id = 0;

var isExtensible = Object.isExtensible || function () {
  return true;
};

var FREEZE = !__w_pdfjs_require__(16)(function () {
  return isExtensible(Object.preventExtensions({}));
});

var setMeta = function setMeta(it) {
  setDesc(it, META, {
    value: {
      i: 'O' + ++id,
      w: {}
    }
  });
};

var fastKey = function fastKey(it, create) {
  if (!isObject(it)) return _typeof(it) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;

  if (!has(it, META)) {
    if (!isExtensible(it)) return 'F';
    if (!create) return 'E';
    setMeta(it);
  }

  return it[META].i;
};

var getWeak = function getWeak(it, create) {
  if (!has(it, META)) {
    if (!isExtensible(it)) return true;
    if (!create) return false;
    setMeta(it);
  }

  return it[META].w;
};

var onFreeze = function onFreeze(it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};

var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 109 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var redefineAll = __w_pdfjs_require__(98);

var getWeak = __w_pdfjs_require__(108).getWeak;

var anObject = __w_pdfjs_require__(12);

var isObject = __w_pdfjs_require__(13);

var anInstance = __w_pdfjs_require__(88);

var forOf = __w_pdfjs_require__(89);

var createArrayMethod = __w_pdfjs_require__(104);

var $has = __w_pdfjs_require__(21);

var validate = __w_pdfjs_require__(110);

var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

var uncaughtFrozenStore = function uncaughtFrozenStore(that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function UncaughtFrozenStore() {
  this.a = [];
};

var findUncaughtFrozen = function findUncaughtFrozen(store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function get(key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function has(key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function set(key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;else this.a.push([key, value]);
  },
  'delete': function _delete(key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};
module.exports = {
  getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;
      that._i = id++;
      that._l = undefined;
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      'delete': function _delete(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function def(that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};

/***/ }),
/* 110 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isObject = __w_pdfjs_require__(13);

module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};

/***/ }),
/* 111 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var global = __w_pdfjs_require__(8);

var $export = __w_pdfjs_require__(7);

var redefine = __w_pdfjs_require__(20);

var redefineAll = __w_pdfjs_require__(98);

var meta = __w_pdfjs_require__(108);

var forOf = __w_pdfjs_require__(89);

var anInstance = __w_pdfjs_require__(88);

var isObject = __w_pdfjs_require__(13);

var fails = __w_pdfjs_require__(16);

var $iterDetect = __w_pdfjs_require__(69);

var setToStringTag = __w_pdfjs_require__(60);

var inheritIfRequired = __w_pdfjs_require__(112);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};

  var fixMethod = function fixMethod(KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY, KEY == 'delete' ? function (a) {
      return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'has' ? function has(a) {
      return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'get' ? function get(a) {
      return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'add' ? function add(a) {
      fn.call(this, a === 0 ? 0 : a);
      return this;
    } : function set(a, b) {
      fn.call(this, a === 0 ? 0 : a, b);
      return this;
    });
  };

  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    var THROWS_ON_PRIMITIVES = fails(function () {
      instance.has(1);
    });
    var ACCEPT_ITERABLES = $iterDetect(function (iter) {
      new C(iter);
    });
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      var $instance = new C();
      var index = 5;

      while (index--) {
        $instance[ADDER](index, index);
      }

      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);
  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);
  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
  return C;
};

/***/ }),
/* 112 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isObject = __w_pdfjs_require__(13);

var setPrototypeOf = __w_pdfjs_require__(113).set;

module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;

  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  }

  return that;
};

/***/ }),
/* 113 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isObject = __w_pdfjs_require__(13);

var anObject = __w_pdfjs_require__(12);

var check = function check(O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};

module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? function (test, buggy, set) {
    try {
      set = __w_pdfjs_require__(26)(Function.call, __w_pdfjs_require__(114).f(Object.prototype, '__proto__').set, 2);
      set(test, []);
      buggy = !(test instanceof Array);
    } catch (e) {
      buggy = true;
    }

    return function setPrototypeOf(O, proto) {
      check(O, proto);
      if (buggy) O.__proto__ = proto;else set(O, proto);
      return O;
    };
  }({}, false) : undefined),
  check: check
};

/***/ }),
/* 114 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var pIE = __w_pdfjs_require__(74);

var createDesc = __w_pdfjs_require__(19);

var toIObject = __w_pdfjs_require__(43);

var toPrimitive = __w_pdfjs_require__(18);

var has = __w_pdfjs_require__(21);

var IE8_DOM_DEFINE = __w_pdfjs_require__(14);

var gOPD = Object.getOwnPropertyDescriptor;
exports.f = __w_pdfjs_require__(15) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) {}
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 115 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(116)('WeakMap');

/***/ }),
/* 116 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, {
    of: function of() {
      var length = arguments.length;
      var A = new Array(length);

      while (length--) {
        A[length] = arguments[length];
      }

      return new this(A);
    }
  });
};

/***/ }),
/* 117 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(118)('WeakMap');

/***/ }),
/* 118 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);

var aFunction = __w_pdfjs_require__(27);

var ctx = __w_pdfjs_require__(26);

var forOf = __w_pdfjs_require__(89);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, {
    from: function from(source) {
      var mapFn = arguments[1];
      var mapping, A, n, cb;
      aFunction(this);
      mapping = mapFn !== undefined;
      if (mapping) aFunction(mapFn);
      if (source == undefined) return new this();
      A = [];

      if (mapping) {
        n = 0;
        cb = ctx(mapFn, arguments[2], 2);
        forOf(source, false, function (nextItem) {
          A.push(cb(nextItem, n++));
        });
      } else {
        forOf(source, false, A.push, A);
      }

      return new this(A);
    }
  });
};

/***/ }),
/* 119 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(83);

__w_pdfjs_require__(84);

__w_pdfjs_require__(120);

__w_pdfjs_require__(121);

__w_pdfjs_require__(122);

module.exports = __w_pdfjs_require__(9).WeakSet;

/***/ }),
/* 120 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var weak = __w_pdfjs_require__(109);

var validate = __w_pdfjs_require__(110);

var WEAK_SET = 'WeakSet';

__w_pdfjs_require__(111)(WEAK_SET, function (get) {
  return function WeakSet() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
}, {
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);

/***/ }),
/* 121 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(116)('WeakSet');

/***/ }),
/* 122 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(118)('WeakSet');

/***/ }),
/* 123 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(124);

module.exports = __w_pdfjs_require__(9).String.codePointAt;

/***/ }),
/* 124 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);

var $at = __w_pdfjs_require__(49)(false);

$export($export.P, 'String', {
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(126);

module.exports = __w_pdfjs_require__(9).String.fromCodePoint;

/***/ }),
/* 126 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);

var toAbsoluteIndex = __w_pdfjs_require__(45);

var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  fromCodePoint: function fromCodePoint(x) {
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;

    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000 ? fromCharCode(code) : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00));
    }

    return res.join('');
  }
});

/***/ }),
/* 127 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(128);

__w_pdfjs_require__(83);

module.exports = __w_pdfjs_require__(9).Symbol;

/***/ }),
/* 128 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var global = __w_pdfjs_require__(8);

var has = __w_pdfjs_require__(21);

var DESCRIPTORS = __w_pdfjs_require__(15);

var $export = __w_pdfjs_require__(7);

var redefine = __w_pdfjs_require__(20);

var META = __w_pdfjs_require__(108).KEY;

var $fails = __w_pdfjs_require__(16);

var shared = __w_pdfjs_require__(24);

var setToStringTag = __w_pdfjs_require__(60);

var uid = __w_pdfjs_require__(22);

var wks = __w_pdfjs_require__(33);

var wksExt = __w_pdfjs_require__(129);

var wksDefine = __w_pdfjs_require__(130);

var enumKeys = __w_pdfjs_require__(131);

var isArray = __w_pdfjs_require__(107);

var anObject = __w_pdfjs_require__(12);

var isObject = __w_pdfjs_require__(13);

var toObject = __w_pdfjs_require__(62);

var toIObject = __w_pdfjs_require__(43);

var toPrimitive = __w_pdfjs_require__(18);

var createDesc = __w_pdfjs_require__(19);

var _create = __w_pdfjs_require__(53);

var gOPNExt = __w_pdfjs_require__(132);

var $GOPD = __w_pdfjs_require__(114);

var $GOPS = __w_pdfjs_require__(73);

var $DP = __w_pdfjs_require__(11);

var $keys = __w_pdfjs_require__(55);

var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;

var _stringify = $JSON && $JSON.stringify;

var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function get() {
      return dP(this, 'a', {
        value: 7
      }).a;
    }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function wrap(tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);

  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && _typeof($Symbol.iterator) == 'symbol' ? function (it) {
  return _typeof(it) == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);

  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, {
        enumerable: createDesc(0, false)
      });
    }

    return setSymbolDesc(it, key, D);
  }

  return dP(it, key, D);
};

var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;

  while (l > i) {
    $defineProperty(it, key = keys[i++], P[key]);
  }

  return it;
};

var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};

var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};

var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;

  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  }

  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;

  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  }

  return result;
};

if (!USE_NATIVE) {
  $Symbol = function _Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);

    var $set = function $set(value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };

    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, {
      configurable: true,
      set: $set
    });
    return wrap(tag);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });
  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __w_pdfjs_require__(133).f = gOPNExt.f = $getOwnPropertyNames;
  __w_pdfjs_require__(74).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__w_pdfjs_require__(25)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {
  Symbol: $Symbol
});

for (var es6Symbols = 'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
  wks(es6Symbols[j++]);
}

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
  wksDefine(wellKnownSymbols[k++]);
}

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  'for': function _for(key) {
    return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
  },
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');

    for (var key in SymbolRegistry) {
      if (SymbolRegistry[key] === sym) return key;
    }
  },
  useSetter: function useSetter() {
    setter = true;
  },
  useSimple: function useSimple() {
    setter = false;
  }
});
$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  create: $create,
  defineProperty: $defineProperty,
  defineProperties: $defineProperties,
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  getOwnPropertyNames: $getOwnPropertyNames,
  getOwnPropertySymbols: $getOwnPropertySymbols
});
var FAILS_ON_PRIMITIVES = $fails(function () {
  $GOPS.f(1);
});
$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  return _stringify([S]) != '[null]' || _stringify({
    a: S
  }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;

    while (arguments.length > i) {
      args.push(arguments[i++]);
    }

    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return;
    if (!isArray(replacer)) replacer = function replacer(key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __w_pdfjs_require__(10)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
setToStringTag($Symbol, 'Symbol');
setToStringTag(Math, 'Math', true);
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 129 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


exports.f = __w_pdfjs_require__(33);

/***/ }),
/* 130 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var global = __w_pdfjs_require__(8);

var core = __w_pdfjs_require__(9);

var LIBRARY = __w_pdfjs_require__(25);

var wksExt = __w_pdfjs_require__(129);

var defineProperty = __w_pdfjs_require__(11).f;

module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, {
    value: wksExt.f(name)
  });
};

/***/ }),
/* 131 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var getKeys = __w_pdfjs_require__(55);

var gOPS = __w_pdfjs_require__(73);

var pIE = __w_pdfjs_require__(74);

module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;

  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;

    while (symbols.length > i) {
      if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
  }

  return result;
};

/***/ }),
/* 132 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var toIObject = __w_pdfjs_require__(43);

var gOPN = __w_pdfjs_require__(133).f;

var toString = {}.toString;
var windowNames = (typeof window === "undefined" ? "undefined" : _typeof(window)) == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function getWindowNames(it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

/***/ }),
/* 133 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $keys = __w_pdfjs_require__(56);

var hiddenKeys = __w_pdfjs_require__(58).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 134 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(135);

module.exports = __w_pdfjs_require__(9).String.padStart;

/***/ }),
/* 135 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);

var $pad = __w_pdfjs_require__(136);

var userAgent = __w_pdfjs_require__(96);

var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});

/***/ }),
/* 136 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var toLength = __w_pdfjs_require__(28);

var repeat = __w_pdfjs_require__(137);

var defined = __w_pdfjs_require__(34);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};

/***/ }),
/* 137 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var toInteger = __w_pdfjs_require__(29);

var defined = __w_pdfjs_require__(34);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");

  for (; n > 0; (n >>>= 1) && (str += str)) {
    if (n & 1) res += str;
  }

  return res;
};

/***/ }),
/* 138 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(139);

module.exports = __w_pdfjs_require__(9).String.padEnd;

/***/ }),
/* 139 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);

var $pad = __w_pdfjs_require__(136);

var userAgent = __w_pdfjs_require__(96);

var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});

/***/ }),
/* 140 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(141);

module.exports = __w_pdfjs_require__(9).Object.values;

/***/ }),
/* 141 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(7);

var $values = __w_pdfjs_require__(142)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

/***/ }),
/* 142 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var DESCRIPTORS = __w_pdfjs_require__(15);

var getKeys = __w_pdfjs_require__(55);

var toIObject = __w_pdfjs_require__(43);

var isEnum = __w_pdfjs_require__(74).f;

module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;

    while (length > i) {
      key = keys[i++];

      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }

    return result;
  };
};

/***/ }),
/* 143 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


{
  var isReadableStreamSupported = false;

  if (typeof ReadableStream !== 'undefined') {
    try {
      new ReadableStream({
        start: function start(controller) {
          controller.close();
        }
      });
      isReadableStreamSupported = true;
    } catch (e) {}
  }

  if (isReadableStreamSupported) {
    exports.ReadableStream = ReadableStream;
  } else {
    exports.ReadableStream = __w_pdfjs_require__(144).ReadableStream;
  }
}

/***/ }),
/* 144 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

(function (e, a) {
  for (var i in a) {
    e[i] = a[i];
  }
})(exports, function (modules) {
  var installedModules = {};

  function __w_pdfjs_require__(moduleId) {
    if (installedModules[moduleId]) return installedModules[moduleId].exports;
    var module = installedModules[moduleId] = {
      i: moduleId,
      l: false,
      exports: {}
    };
    modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
    module.l = true;
    return module.exports;
  }

  __w_pdfjs_require__.m = modules;
  __w_pdfjs_require__.c = installedModules;

  __w_pdfjs_require__.i = function (value) {
    return value;
  };

  __w_pdfjs_require__.d = function (exports, name, getter) {
    if (!__w_pdfjs_require__.o(exports, name)) {
      Object.defineProperty(exports, name, {
        configurable: false,
        enumerable: true,
        get: getter
      });
    }
  };

  __w_pdfjs_require__.n = function (module) {
    var getter = module && module.__esModule ? function getDefault() {
      return module['default'];
    } : function getModuleExports() {
      return module;
    };

    __w_pdfjs_require__.d(getter, 'a', getter);

    return getter;
  };

  __w_pdfjs_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };

  __w_pdfjs_require__.p = "";
  return __w_pdfjs_require__(__w_pdfjs_require__.s = 7);
}([function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
    return _typeof2(obj);
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
  };

  var _require = __w_pdfjs_require__(1),
      assert = _require.assert;

  function IsPropertyKey(argument) {
    return typeof argument === 'string' || (typeof argument === 'undefined' ? 'undefined' : _typeof(argument)) === 'symbol';
  }

  exports.typeIsObject = function (x) {
    return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x !== null || typeof x === 'function';
  };

  exports.createDataProperty = function (o, p, v) {
    assert(exports.typeIsObject(o));
    Object.defineProperty(o, p, {
      value: v,
      writable: true,
      enumerable: true,
      configurable: true
    });
  };

  exports.createArrayFromList = function (elements) {
    return elements.slice();
  };

  exports.ArrayBufferCopy = function (dest, destOffset, src, srcOffset, n) {
    new Uint8Array(dest).set(new Uint8Array(src, srcOffset, n), destOffset);
  };

  exports.CreateIterResultObject = function (value, done) {
    assert(typeof done === 'boolean');
    var obj = {};
    Object.defineProperty(obj, 'value', {
      value: value,
      enumerable: true,
      writable: true,
      configurable: true
    });
    Object.defineProperty(obj, 'done', {
      value: done,
      enumerable: true,
      writable: true,
      configurable: true
    });
    return obj;
  };

  exports.IsFiniteNonNegativeNumber = function (v) {
    if (Number.isNaN(v)) {
      return false;
    }

    if (v === Infinity) {
      return false;
    }

    if (v < 0) {
      return false;
    }

    return true;
  };

  function Call(F, V, args) {
    if (typeof F !== 'function') {
      throw new TypeError('Argument is not a function');
    }

    return Function.prototype.apply.call(F, V, args);
  }

  exports.InvokeOrNoop = function (O, P, args) {
    assert(O !== undefined);
    assert(IsPropertyKey(P));
    assert(Array.isArray(args));
    var method = O[P];

    if (method === undefined) {
      return undefined;
    }

    return Call(method, O, args);
  };

  exports.PromiseInvokeOrNoop = function (O, P, args) {
    assert(O !== undefined);
    assert(IsPropertyKey(P));
    assert(Array.isArray(args));

    try {
      return Promise.resolve(exports.InvokeOrNoop(O, P, args));
    } catch (returnValueE) {
      return Promise.reject(returnValueE);
    }
  };

  exports.PromiseInvokeOrPerformFallback = function (O, P, args, F, argsF) {
    assert(O !== undefined);
    assert(IsPropertyKey(P));
    assert(Array.isArray(args));
    assert(Array.isArray(argsF));
    var method = void 0;

    try {
      method = O[P];
    } catch (methodE) {
      return Promise.reject(methodE);
    }

    if (method === undefined) {
      return F.apply(null, argsF);
    }

    try {
      return Promise.resolve(Call(method, O, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  exports.TransferArrayBuffer = function (O) {
    return O.slice();
  };

  exports.ValidateAndNormalizeHighWaterMark = function (highWaterMark) {
    highWaterMark = Number(highWaterMark);

    if (Number.isNaN(highWaterMark) || highWaterMark < 0) {
      throw new RangeError('highWaterMark property of a queuing strategy must be non-negative and non-NaN');
    }

    return highWaterMark;
  };

  exports.ValidateAndNormalizeQueuingStrategy = function (size, highWaterMark) {
    if (size !== undefined && typeof size !== 'function') {
      throw new TypeError('size property of a queuing strategy must be a function');
    }

    highWaterMark = exports.ValidateAndNormalizeHighWaterMark(highWaterMark);
    return {
      size: size,
      highWaterMark: highWaterMark
    };
  };
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  function rethrowAssertionErrorRejection(e) {
    if (e && e.constructor === AssertionError) {
      setTimeout(function () {
        throw e;
      }, 0);
    }
  }

  function AssertionError(message) {
    this.name = 'AssertionError';
    this.message = message || '';
    this.stack = new Error().stack;
  }

  AssertionError.prototype = Object.create(Error.prototype);
  AssertionError.prototype.constructor = AssertionError;

  function assert(value, message) {
    if (!value) {
      throw new AssertionError(message);
    }
  }

  module.exports = {
    rethrowAssertionErrorRejection: rethrowAssertionErrorRejection,
    AssertionError: AssertionError,
    assert: assert
  };
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _require = __w_pdfjs_require__(0),
      InvokeOrNoop = _require.InvokeOrNoop,
      PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
      ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
      typeIsObject = _require.typeIsObject;

  var _require2 = __w_pdfjs_require__(1),
      assert = _require2.assert,
      rethrowAssertionErrorRejection = _require2.rethrowAssertionErrorRejection;

  var _require3 = __w_pdfjs_require__(3),
      DequeueValue = _require3.DequeueValue,
      EnqueueValueWithSize = _require3.EnqueueValueWithSize,
      PeekQueueValue = _require3.PeekQueueValue,
      ResetQueue = _require3.ResetQueue;

  var WritableStream = function () {
    function WritableStream() {
      var underlyingSink = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          size = _ref.size,
          _ref$highWaterMark = _ref.highWaterMark,
          highWaterMark = _ref$highWaterMark === undefined ? 1 : _ref$highWaterMark;

      _classCallCheck(this, WritableStream);

      this._state = 'writable';
      this._storedError = undefined;
      this._writer = undefined;
      this._writableStreamController = undefined;
      this._writeRequests = [];
      this._inFlightWriteRequest = undefined;
      this._closeRequest = undefined;
      this._inFlightCloseRequest = undefined;
      this._pendingAbortRequest = undefined;
      this._backpressure = false;
      var type = underlyingSink.type;

      if (type !== undefined) {
        throw new RangeError('Invalid type is specified');
      }

      this._writableStreamController = new WritableStreamDefaultController(this, underlyingSink, size, highWaterMark);

      this._writableStreamController.__startSteps();
    }

    _createClass(WritableStream, [{
      key: 'abort',
      value: function abort(reason) {
        if (IsWritableStream(this) === false) {
          return Promise.reject(streamBrandCheckException('abort'));
        }

        if (IsWritableStreamLocked(this) === true) {
          return Promise.reject(new TypeError('Cannot abort a stream that already has a writer'));
        }

        return WritableStreamAbort(this, reason);
      }
    }, {
      key: 'getWriter',
      value: function getWriter() {
        if (IsWritableStream(this) === false) {
          throw streamBrandCheckException('getWriter');
        }

        return AcquireWritableStreamDefaultWriter(this);
      }
    }, {
      key: 'locked',
      get: function get() {
        if (IsWritableStream(this) === false) {
          throw streamBrandCheckException('locked');
        }

        return IsWritableStreamLocked(this);
      }
    }]);

    return WritableStream;
  }();

  module.exports = {
    AcquireWritableStreamDefaultWriter: AcquireWritableStreamDefaultWriter,
    IsWritableStream: IsWritableStream,
    IsWritableStreamLocked: IsWritableStreamLocked,
    WritableStream: WritableStream,
    WritableStreamAbort: WritableStreamAbort,
    WritableStreamDefaultControllerError: WritableStreamDefaultControllerError,
    WritableStreamDefaultWriterCloseWithErrorPropagation: WritableStreamDefaultWriterCloseWithErrorPropagation,
    WritableStreamDefaultWriterRelease: WritableStreamDefaultWriterRelease,
    WritableStreamDefaultWriterWrite: WritableStreamDefaultWriterWrite,
    WritableStreamCloseQueuedOrInFlight: WritableStreamCloseQueuedOrInFlight
  };

  function AcquireWritableStreamDefaultWriter(stream) {
    return new WritableStreamDefaultWriter(stream);
  }

  function IsWritableStream(x) {
    if (!typeIsObject(x)) {
      return false;
    }

    if (!Object.prototype.hasOwnProperty.call(x, '_writableStreamController')) {
      return false;
    }

    return true;
  }

  function IsWritableStreamLocked(stream) {
    assert(IsWritableStream(stream) === true, 'IsWritableStreamLocked should only be used on known writable streams');

    if (stream._writer === undefined) {
      return false;
    }

    return true;
  }

  function WritableStreamAbort(stream, reason) {
    var state = stream._state;

    if (state === 'closed') {
      return Promise.resolve(undefined);
    }

    if (state === 'errored') {
      return Promise.reject(stream._storedError);
    }

    var error = new TypeError('Requested to abort');

    if (stream._pendingAbortRequest !== undefined) {
      return Promise.reject(error);
    }

    assert(state === 'writable' || state === 'erroring', 'state must be writable or erroring');
    var wasAlreadyErroring = false;

    if (state === 'erroring') {
      wasAlreadyErroring = true;
      reason = undefined;
    }

    var promise = new Promise(function (resolve, reject) {
      stream._pendingAbortRequest = {
        _resolve: resolve,
        _reject: reject,
        _reason: reason,
        _wasAlreadyErroring: wasAlreadyErroring
      };
    });

    if (wasAlreadyErroring === false) {
      WritableStreamStartErroring(stream, error);
    }

    return promise;
  }

  function WritableStreamAddWriteRequest(stream) {
    assert(IsWritableStreamLocked(stream) === true);
    assert(stream._state === 'writable');
    var promise = new Promise(function (resolve, reject) {
      var writeRequest = {
        _resolve: resolve,
        _reject: reject
      };

      stream._writeRequests.push(writeRequest);
    });
    return promise;
  }

  function WritableStreamDealWithRejection(stream, error) {
    var state = stream._state;

    if (state === 'writable') {
      WritableStreamStartErroring(stream, error);
      return;
    }

    assert(state === 'erroring');
    WritableStreamFinishErroring(stream);
  }

  function WritableStreamStartErroring(stream, reason) {
    assert(stream._storedError === undefined, 'stream._storedError === undefined');
    assert(stream._state === 'writable', 'state must be writable');
    var controller = stream._writableStreamController;
    assert(controller !== undefined, 'controller must not be undefined');
    stream._state = 'erroring';
    stream._storedError = reason;
    var writer = stream._writer;

    if (writer !== undefined) {
      WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, reason);
    }

    if (WritableStreamHasOperationMarkedInFlight(stream) === false && controller._started === true) {
      WritableStreamFinishErroring(stream);
    }
  }

  function WritableStreamFinishErroring(stream) {
    assert(stream._state === 'erroring', 'stream._state === erroring');
    assert(WritableStreamHasOperationMarkedInFlight(stream) === false, 'WritableStreamHasOperationMarkedInFlight(stream) === false');
    stream._state = 'errored';

    stream._writableStreamController.__errorSteps();

    var storedError = stream._storedError;

    for (var i = 0; i < stream._writeRequests.length; i++) {
      var writeRequest = stream._writeRequests[i];

      writeRequest._reject(storedError);
    }

    stream._writeRequests = [];

    if (stream._pendingAbortRequest === undefined) {
      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
      return;
    }

    var abortRequest = stream._pendingAbortRequest;
    stream._pendingAbortRequest = undefined;

    if (abortRequest._wasAlreadyErroring === true) {
      abortRequest._reject(storedError);

      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
      return;
    }

    var promise = stream._writableStreamController.__abortSteps(abortRequest._reason);

    promise.then(function () {
      abortRequest._resolve();

      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
    }, function (reason) {
      abortRequest._reject(reason);

      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
    });
  }

  function WritableStreamFinishInFlightWrite(stream) {
    assert(stream._inFlightWriteRequest !== undefined);

    stream._inFlightWriteRequest._resolve(undefined);

    stream._inFlightWriteRequest = undefined;
  }

  function WritableStreamFinishInFlightWriteWithError(stream, error) {
    assert(stream._inFlightWriteRequest !== undefined);

    stream._inFlightWriteRequest._reject(error);

    stream._inFlightWriteRequest = undefined;
    assert(stream._state === 'writable' || stream._state === 'erroring');
    WritableStreamDealWithRejection(stream, error);
  }

  function WritableStreamFinishInFlightClose(stream) {
    assert(stream._inFlightCloseRequest !== undefined);

    stream._inFlightCloseRequest._resolve(undefined);

    stream._inFlightCloseRequest = undefined;
    var state = stream._state;
    assert(state === 'writable' || state === 'erroring');

    if (state === 'erroring') {
      stream._storedError = undefined;

      if (stream._pendingAbortRequest !== undefined) {
        stream._pendingAbortRequest._resolve();

        stream._pendingAbortRequest = undefined;
      }
    }

    stream._state = 'closed';
    var writer = stream._writer;

    if (writer !== undefined) {
      defaultWriterClosedPromiseResolve(writer);
    }

    assert(stream._pendingAbortRequest === undefined, 'stream._pendingAbortRequest === undefined');
    assert(stream._storedError === undefined, 'stream._storedError === undefined');
  }

  function WritableStreamFinishInFlightCloseWithError(stream, error) {
    assert(stream._inFlightCloseRequest !== undefined);

    stream._inFlightCloseRequest._reject(error);

    stream._inFlightCloseRequest = undefined;
    assert(stream._state === 'writable' || stream._state === 'erroring');

    if (stream._pendingAbortRequest !== undefined) {
      stream._pendingAbortRequest._reject(error);

      stream._pendingAbortRequest = undefined;
    }

    WritableStreamDealWithRejection(stream, error);
  }

  function WritableStreamCloseQueuedOrInFlight(stream) {
    if (stream._closeRequest === undefined && stream._inFlightCloseRequest === undefined) {
      return false;
    }

    return true;
  }

  function WritableStreamHasOperationMarkedInFlight(stream) {
    if (stream._inFlightWriteRequest === undefined && stream._inFlightCloseRequest === undefined) {
      return false;
    }

    return true;
  }

  function WritableStreamMarkCloseRequestInFlight(stream) {
    assert(stream._inFlightCloseRequest === undefined);
    assert(stream._closeRequest !== undefined);
    stream._inFlightCloseRequest = stream._closeRequest;
    stream._closeRequest = undefined;
  }

  function WritableStreamMarkFirstWriteRequestInFlight(stream) {
    assert(stream._inFlightWriteRequest === undefined, 'there must be no pending write request');
    assert(stream._writeRequests.length !== 0, 'writeRequests must not be empty');
    stream._inFlightWriteRequest = stream._writeRequests.shift();
  }

  function WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream) {
    assert(stream._state === 'errored', '_stream_.[[state]] is `"errored"`');

    if (stream._closeRequest !== undefined) {
      assert(stream._inFlightCloseRequest === undefined);

      stream._closeRequest._reject(stream._storedError);

      stream._closeRequest = undefined;
    }

    var writer = stream._writer;

    if (writer !== undefined) {
      defaultWriterClosedPromiseReject(writer, stream._storedError);

      writer._closedPromise["catch"](function () {});
    }
  }

  function WritableStreamUpdateBackpressure(stream, backpressure) {
    assert(stream._state === 'writable');
    assert(WritableStreamCloseQueuedOrInFlight(stream) === false);
    var writer = stream._writer;

    if (writer !== undefined && backpressure !== stream._backpressure) {
      if (backpressure === true) {
        defaultWriterReadyPromiseReset(writer);
      } else {
        assert(backpressure === false);
        defaultWriterReadyPromiseResolve(writer);
      }
    }

    stream._backpressure = backpressure;
  }

  var WritableStreamDefaultWriter = function () {
    function WritableStreamDefaultWriter(stream) {
      _classCallCheck(this, WritableStreamDefaultWriter);

      if (IsWritableStream(stream) === false) {
        throw new TypeError('WritableStreamDefaultWriter can only be constructed with a WritableStream instance');
      }

      if (IsWritableStreamLocked(stream) === true) {
        throw new TypeError('This stream has already been locked for exclusive writing by another writer');
      }

      this._ownerWritableStream = stream;
      stream._writer = this;
      var state = stream._state;

      if (state === 'writable') {
        if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._backpressure === true) {
          defaultWriterReadyPromiseInitialize(this);
        } else {
          defaultWriterReadyPromiseInitializeAsResolved(this);
        }

        defaultWriterClosedPromiseInitialize(this);
      } else if (state === 'erroring') {
        defaultWriterReadyPromiseInitializeAsRejected(this, stream._storedError);

        this._readyPromise["catch"](function () {});

        defaultWriterClosedPromiseInitialize(this);
      } else if (state === 'closed') {
        defaultWriterReadyPromiseInitializeAsResolved(this);
        defaultWriterClosedPromiseInitializeAsResolved(this);
      } else {
        assert(state === 'errored', 'state must be errored');
        var storedError = stream._storedError;
        defaultWriterReadyPromiseInitializeAsRejected(this, storedError);

        this._readyPromise["catch"](function () {});

        defaultWriterClosedPromiseInitializeAsRejected(this, storedError);

        this._closedPromise["catch"](function () {});
      }
    }

    _createClass(WritableStreamDefaultWriter, [{
      key: 'abort',
      value: function abort(reason) {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('abort'));
        }

        if (this._ownerWritableStream === undefined) {
          return Promise.reject(defaultWriterLockException('abort'));
        }

        return WritableStreamDefaultWriterAbort(this, reason);
      }
    }, {
      key: 'close',
      value: function close() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('close'));
        }

        var stream = this._ownerWritableStream;

        if (stream === undefined) {
          return Promise.reject(defaultWriterLockException('close'));
        }

        if (WritableStreamCloseQueuedOrInFlight(stream) === true) {
          return Promise.reject(new TypeError('cannot close an already-closing stream'));
        }

        return WritableStreamDefaultWriterClose(this);
      }
    }, {
      key: 'releaseLock',
      value: function releaseLock() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          throw defaultWriterBrandCheckException('releaseLock');
        }

        var stream = this._ownerWritableStream;

        if (stream === undefined) {
          return;
        }

        assert(stream._writer !== undefined);
        WritableStreamDefaultWriterRelease(this);
      }
    }, {
      key: 'write',
      value: function write(chunk) {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('write'));
        }

        if (this._ownerWritableStream === undefined) {
          return Promise.reject(defaultWriterLockException('write to'));
        }

        return WritableStreamDefaultWriterWrite(this, chunk);
      }
    }, {
      key: 'closed',
      get: function get() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('closed'));
        }

        return this._closedPromise;
      }
    }, {
      key: 'desiredSize',
      get: function get() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          throw defaultWriterBrandCheckException('desiredSize');
        }

        if (this._ownerWritableStream === undefined) {
          throw defaultWriterLockException('desiredSize');
        }

        return WritableStreamDefaultWriterGetDesiredSize(this);
      }
    }, {
      key: 'ready',
      get: function get() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('ready'));
        }

        return this._readyPromise;
      }
    }]);

    return WritableStreamDefaultWriter;
  }();

  function IsWritableStreamDefaultWriter(x) {
    if (!typeIsObject(x)) {
      return false;
    }

    if (!Object.prototype.hasOwnProperty.call(x, '_ownerWritableStream')) {
      return false;
    }

    return true;
  }

  function WritableStreamDefaultWriterAbort(writer, reason) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    return WritableStreamAbort(stream, reason);
  }

  function WritableStreamDefaultWriterClose(writer) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    var state = stream._state;

    if (state === 'closed' || state === 'errored') {
      return Promise.reject(new TypeError('The stream (in ' + state + ' state) is not in the writable state and cannot be closed'));
    }

    assert(state === 'writable' || state === 'erroring');
    assert(WritableStreamCloseQueuedOrInFlight(stream) === false);
    var promise = new Promise(function (resolve, reject) {
      var closeRequest = {
        _resolve: resolve,
        _reject: reject
      };
      stream._closeRequest = closeRequest;
    });

    if (stream._backpressure === true && state === 'writable') {
      defaultWriterReadyPromiseResolve(writer);
    }

    WritableStreamDefaultControllerClose(stream._writableStreamController);
    return promise;
  }

  function WritableStreamDefaultWriterCloseWithErrorPropagation(writer) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    var state = stream._state;

    if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
      return Promise.resolve();
    }

    if (state === 'errored') {
      return Promise.reject(stream._storedError);
    }

    assert(state === 'writable' || state === 'erroring');
    return WritableStreamDefaultWriterClose(writer);
  }

  function WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, error) {
    if (writer._closedPromiseState === 'pending') {
      defaultWriterClosedPromiseReject(writer, error);
    } else {
      defaultWriterClosedPromiseResetToRejected(writer, error);
    }

    writer._closedPromise["catch"](function () {});
  }

  function WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, error) {
    if (writer._readyPromiseState === 'pending') {
      defaultWriterReadyPromiseReject(writer, error);
    } else {
      defaultWriterReadyPromiseResetToRejected(writer, error);
    }

    writer._readyPromise["catch"](function () {});
  }

  function WritableStreamDefaultWriterGetDesiredSize(writer) {
    var stream = writer._ownerWritableStream;
    var state = stream._state;

    if (state === 'errored' || state === 'erroring') {
      return null;
    }

    if (state === 'closed') {
      return 0;
    }

    return WritableStreamDefaultControllerGetDesiredSize(stream._writableStreamController);
  }

  function WritableStreamDefaultWriterRelease(writer) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    assert(stream._writer === writer);
    var releasedError = new TypeError('Writer was released and can no longer be used to monitor the stream\'s closedness');
    WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, releasedError);
    WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, releasedError);
    stream._writer = undefined;
    writer._ownerWritableStream = undefined;
  }

  function WritableStreamDefaultWriterWrite(writer, chunk) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    var controller = stream._writableStreamController;
    var chunkSize = WritableStreamDefaultControllerGetChunkSize(controller, chunk);

    if (stream !== writer._ownerWritableStream) {
      return Promise.reject(defaultWriterLockException('write to'));
    }

    var state = stream._state;

    if (state === 'errored') {
      return Promise.reject(stream._storedError);
    }

    if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
      return Promise.reject(new TypeError('The stream is closing or closed and cannot be written to'));
    }

    if (state === 'erroring') {
      return Promise.reject(stream._storedError);
    }

    assert(state === 'writable');
    var promise = WritableStreamAddWriteRequest(stream);
    WritableStreamDefaultControllerWrite(controller, chunk, chunkSize);
    return promise;
  }

  var WritableStreamDefaultController = function () {
    function WritableStreamDefaultController(stream, underlyingSink, size, highWaterMark) {
      _classCallCheck(this, WritableStreamDefaultController);

      if (IsWritableStream(stream) === false) {
        throw new TypeError('WritableStreamDefaultController can only be constructed with a WritableStream instance');
      }

      if (stream._writableStreamController !== undefined) {
        throw new TypeError('WritableStreamDefaultController instances can only be created by the WritableStream constructor');
      }

      this._controlledWritableStream = stream;
      this._underlyingSink = underlyingSink;
      this._queue = undefined;
      this._queueTotalSize = undefined;
      ResetQueue(this);
      this._started = false;
      var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
      this._strategySize = normalizedStrategy.size;
      this._strategyHWM = normalizedStrategy.highWaterMark;
      var backpressure = WritableStreamDefaultControllerGetBackpressure(this);
      WritableStreamUpdateBackpressure(stream, backpressure);
    }

    _createClass(WritableStreamDefaultController, [{
      key: 'error',
      value: function error(e) {
        if (IsWritableStreamDefaultController(this) === false) {
          throw new TypeError('WritableStreamDefaultController.prototype.error can only be used on a WritableStreamDefaultController');
        }

        var state = this._controlledWritableStream._state;

        if (state !== 'writable') {
          return;
        }

        WritableStreamDefaultControllerError(this, e);
      }
    }, {
      key: '__abortSteps',
      value: function __abortSteps(reason) {
        return PromiseInvokeOrNoop(this._underlyingSink, 'abort', [reason]);
      }
    }, {
      key: '__errorSteps',
      value: function __errorSteps() {
        ResetQueue(this);
      }
    }, {
      key: '__startSteps',
      value: function __startSteps() {
        var _this = this;

        var startResult = InvokeOrNoop(this._underlyingSink, 'start', [this]);
        var stream = this._controlledWritableStream;
        Promise.resolve(startResult).then(function () {
          assert(stream._state === 'writable' || stream._state === 'erroring');
          _this._started = true;
          WritableStreamDefaultControllerAdvanceQueueIfNeeded(_this);
        }, function (r) {
          assert(stream._state === 'writable' || stream._state === 'erroring');
          _this._started = true;
          WritableStreamDealWithRejection(stream, r);
        })["catch"](rethrowAssertionErrorRejection);
      }
    }]);

    return WritableStreamDefaultController;
  }();

  function WritableStreamDefaultControllerClose(controller) {
    EnqueueValueWithSize(controller, 'close', 0);
    WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
  }

  function WritableStreamDefaultControllerGetChunkSize(controller, chunk) {
    var strategySize = controller._strategySize;

    if (strategySize === undefined) {
      return 1;
    }

    try {
      return strategySize(chunk);
    } catch (chunkSizeE) {
      WritableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
      return 1;
    }
  }

  function WritableStreamDefaultControllerGetDesiredSize(controller) {
    return controller._strategyHWM - controller._queueTotalSize;
  }

  function WritableStreamDefaultControllerWrite(controller, chunk, chunkSize) {
    var writeRecord = {
      chunk: chunk
    };

    try {
      EnqueueValueWithSize(controller, writeRecord, chunkSize);
    } catch (enqueueE) {
      WritableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
      return;
    }

    var stream = controller._controlledWritableStream;

    if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._state === 'writable') {
      var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
      WritableStreamUpdateBackpressure(stream, backpressure);
    }

    WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
  }

  function IsWritableStreamDefaultController(x) {
    if (!typeIsObject(x)) {
      return false;
    }

    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingSink')) {
      return false;
    }

    return true;
  }

  function WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller) {
    var stream = controller._controlledWritableStream;

    if (controller._started === false) {
      return;
    }

    if (stream._inFlightWriteRequest !== undefined) {
      return;
    }

    var state = stream._state;

    if (state === 'closed' || state === 'errored') {
      return;
    }

    if (state === 'erroring') {
      WritableStreamFinishErroring(stream);
      return;
    }

    if (controller._queue.length === 0) {
      return;
    }

    var writeRecord = PeekQueueValue(controller);

    if (writeRecord === 'close') {
      WritableStreamDefaultControllerProcessClose(controller);
    } else {
      WritableStreamDefaultControllerProcessWrite(controller, writeRecord.chunk);
    }
  }

  function WritableStreamDefaultControllerErrorIfNeeded(controller, error) {
    if (controller._controlledWritableStream._state === 'writable') {
      WritableStreamDefaultControllerError(controller, error);
    }
  }

  function WritableStreamDefaultControllerProcessClose(controller) {
    var stream = controller._controlledWritableStream;
    WritableStreamMarkCloseRequestInFlight(stream);
    DequeueValue(controller);
    assert(controller._queue.length === 0, 'queue must be empty once the final write record is dequeued');
    var sinkClosePromise = PromiseInvokeOrNoop(controller._underlyingSink, 'close', []);
    sinkClosePromise.then(function () {
      WritableStreamFinishInFlightClose(stream);
    }, function (reason) {
      WritableStreamFinishInFlightCloseWithError(stream, reason);
    })["catch"](rethrowAssertionErrorRejection);
  }

  function WritableStreamDefaultControllerProcessWrite(controller, chunk) {
    var stream = controller._controlledWritableStream;
    WritableStreamMarkFirstWriteRequestInFlight(stream);
    var sinkWritePromise = PromiseInvokeOrNoop(controller._underlyingSink, 'write', [chunk, controller]);
    sinkWritePromise.then(function () {
      WritableStreamFinishInFlightWrite(stream);
      var state = stream._state;
      assert(state === 'writable' || state === 'erroring');
      DequeueValue(controller);

      if (WritableStreamCloseQueuedOrInFlight(stream) === false && state === 'writable') {
        var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
        WritableStreamUpdateBackpressure(stream, backpressure);
      }

      WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
    }, function (reason) {
      WritableStreamFinishInFlightWriteWithError(stream, reason);
    })["catch"](rethrowAssertionErrorRejection);
  }

  function WritableStreamDefaultControllerGetBackpressure(controller) {
    var desiredSize = WritableStreamDefaultControllerGetDesiredSize(controller);
    return desiredSize <= 0;
  }

  function WritableStreamDefaultControllerError(controller, error) {
    var stream = controller._controlledWritableStream;
    assert(stream._state === 'writable');
    WritableStreamStartErroring(stream, error);
  }

  function streamBrandCheckException(name) {
    return new TypeError('WritableStream.prototype.' + name + ' can only be used on a WritableStream');
  }

  function defaultWriterBrandCheckException(name) {
    return new TypeError('WritableStreamDefaultWriter.prototype.' + name + ' can only be used on a WritableStreamDefaultWriter');
  }

  function defaultWriterLockException(name) {
    return new TypeError('Cannot ' + name + ' a stream using a released writer');
  }

  function defaultWriterClosedPromiseInitialize(writer) {
    writer._closedPromise = new Promise(function (resolve, reject) {
      writer._closedPromise_resolve = resolve;
      writer._closedPromise_reject = reject;
      writer._closedPromiseState = 'pending';
    });
  }

  function defaultWriterClosedPromiseInitializeAsRejected(writer, reason) {
    writer._closedPromise = Promise.reject(reason);
    writer._closedPromise_resolve = undefined;
    writer._closedPromise_reject = undefined;
    writer._closedPromiseState = 'rejected';
  }

  function defaultWriterClosedPromiseInitializeAsResolved(writer) {
    writer._closedPromise = Promise.resolve(undefined);
    writer._closedPromise_resolve = undefined;
    writer._closedPromise_reject = undefined;
    writer._closedPromiseState = 'resolved';
  }

  function defaultWriterClosedPromiseReject(writer, reason) {
    assert(writer._closedPromise_resolve !== undefined, 'writer._closedPromise_resolve !== undefined');
    assert(writer._closedPromise_reject !== undefined, 'writer._closedPromise_reject !== undefined');
    assert(writer._closedPromiseState === 'pending', 'writer._closedPromiseState is pending');

    writer._closedPromise_reject(reason);

    writer._closedPromise_resolve = undefined;
    writer._closedPromise_reject = undefined;
    writer._closedPromiseState = 'rejected';
  }

  function defaultWriterClosedPromiseResetToRejected(writer, reason) {
    assert(writer._closedPromise_resolve === undefined, 'writer._closedPromise_resolve === undefined');
    assert(writer._closedPromise_reject === undefined, 'writer._closedPromise_reject === undefined');
    assert(writer._closedPromiseState !== 'pending', 'writer._closedPromiseState is not pending');
    writer._closedPromise = Promise.reject(reason);
    writer._closedPromiseState = 'rejected';
  }

  function defaultWriterClosedPromiseResolve(writer) {
    assert(writer._closedPromise_resolve !== undefined, 'writer._closedPromise_resolve !== undefined');
    assert(writer._closedPromise_reject !== undefined, 'writer._closedPromise_reject !== undefined');
    assert(writer._closedPromiseState === 'pending', 'writer._closedPromiseState is pending');

    writer._closedPromise_resolve(undefined);

    writer._closedPromise_resolve = undefined;
    writer._closedPromise_reject = undefined;
    writer._closedPromiseState = 'resolved';
  }

  function defaultWriterReadyPromiseInitialize(writer) {
    writer._readyPromise = new Promise(function (resolve, reject) {
      writer._readyPromise_resolve = resolve;
      writer._readyPromise_reject = reject;
    });
    writer._readyPromiseState = 'pending';
  }

  function defaultWriterReadyPromiseInitializeAsRejected(writer, reason) {
    writer._readyPromise = Promise.reject(reason);
    writer._readyPromise_resolve = undefined;
    writer._readyPromise_reject = undefined;
    writer._readyPromiseState = 'rejected';
  }

  function defaultWriterReadyPromiseInitializeAsResolved(writer) {
    writer._readyPromise = Promise.resolve(undefined);
    writer._readyPromise_resolve = undefined;
    writer._readyPromise_reject = undefined;
    writer._readyPromiseState = 'fulfilled';
  }

  function defaultWriterReadyPromiseReject(writer, reason) {
    assert(writer._readyPromise_resolve !== undefined, 'writer._readyPromise_resolve !== undefined');
    assert(writer._readyPromise_reject !== undefined, 'writer._readyPromise_reject !== undefined');

    writer._readyPromise_reject(reason);

    writer._readyPromise_resolve = undefined;
    writer._readyPromise_reject = undefined;
    writer._readyPromiseState = 'rejected';
  }

  function defaultWriterReadyPromiseReset(writer) {
    assert(writer._readyPromise_resolve === undefined, 'writer._readyPromise_resolve === undefined');
    assert(writer._readyPromise_reject === undefined, 'writer._readyPromise_reject === undefined');
    writer._readyPromise = new Promise(function (resolve, reject) {
      writer._readyPromise_resolve = resolve;
      writer._readyPromise_reject = reject;
    });
    writer._readyPromiseState = 'pending';
  }

  function defaultWriterReadyPromiseResetToRejected(writer, reason) {
    assert(writer._readyPromise_resolve === undefined, 'writer._readyPromise_resolve === undefined');
    assert(writer._readyPromise_reject === undefined, 'writer._readyPromise_reject === undefined');
    writer._readyPromise = Promise.reject(reason);
    writer._readyPromiseState = 'rejected';
  }

  function defaultWriterReadyPromiseResolve(writer) {
    assert(writer._readyPromise_resolve !== undefined, 'writer._readyPromise_resolve !== undefined');
    assert(writer._readyPromise_reject !== undefined, 'writer._readyPromise_reject !== undefined');

    writer._readyPromise_resolve(undefined);

    writer._readyPromise_resolve = undefined;
    writer._readyPromise_reject = undefined;
    writer._readyPromiseState = 'fulfilled';
  }
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _require = __w_pdfjs_require__(0),
      IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber;

  var _require2 = __w_pdfjs_require__(1),
      assert = _require2.assert;

  exports.DequeueValue = function (container) {
    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: DequeueValue should only be used on containers with [[queue]] and [[queueTotalSize]].');
    assert(container._queue.length > 0, 'Spec-level failure: should never dequeue from an empty queue.');

    var pair = container._queue.shift();

    container._queueTotalSize -= pair.size;

    if (container._queueTotalSize < 0) {
      container._queueTotalSize = 0;
    }

    return pair.value;
  };

  exports.EnqueueValueWithSize = function (container, value, size) {
    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: EnqueueValueWithSize should only be used on containers with [[queue]] and ' + '[[queueTotalSize]].');
    size = Number(size);

    if (!IsFiniteNonNegativeNumber(size)) {
      throw new RangeError('Size must be a finite, non-NaN, non-negative number.');
    }

    container._queue.push({
      value: value,
      size: size
    });

    container._queueTotalSize += size;
  };

  exports.PeekQueueValue = function (container) {
    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: PeekQueueValue should only be used on containers with [[queue]] and [[queueTotalSize]].');
    assert(container._queue.length > 0, 'Spec-level failure: should never peek at an empty queue.');
    var pair = container._queue[0];
    return pair.value;
  };

  exports.ResetQueue = function (container) {
    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: ResetQueue should only be used on containers with [[queue]] and [[queueTotalSize]].');
    container._queue = [];
    container._queueTotalSize = 0;
  };
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _require = __w_pdfjs_require__(0),
      ArrayBufferCopy = _require.ArrayBufferCopy,
      CreateIterResultObject = _require.CreateIterResultObject,
      IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber,
      InvokeOrNoop = _require.InvokeOrNoop,
      PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
      TransferArrayBuffer = _require.TransferArrayBuffer,
      ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
      ValidateAndNormalizeHighWaterMark = _require.ValidateAndNormalizeHighWaterMark;

  var _require2 = __w_pdfjs_require__(0),
      createArrayFromList = _require2.createArrayFromList,
      createDataProperty = _require2.createDataProperty,
      typeIsObject = _require2.typeIsObject;

  var _require3 = __w_pdfjs_require__(1),
      assert = _require3.assert,
      rethrowAssertionErrorRejection = _require3.rethrowAssertionErrorRejection;

  var _require4 = __w_pdfjs_require__(3),
      DequeueValue = _require4.DequeueValue,
      EnqueueValueWithSize = _require4.EnqueueValueWithSize,
      ResetQueue = _require4.ResetQueue;

  var _require5 = __w_pdfjs_require__(2),
      AcquireWritableStreamDefaultWriter = _require5.AcquireWritableStreamDefaultWriter,
      IsWritableStream = _require5.IsWritableStream,
      IsWritableStreamLocked = _require5.IsWritableStreamLocked,
      WritableStreamAbort = _require5.WritableStreamAbort,
      WritableStreamDefaultWriterCloseWithErrorPropagation = _require5.WritableStreamDefaultWriterCloseWithErrorPropagation,
      WritableStreamDefaultWriterRelease = _require5.WritableStreamDefaultWriterRelease,
      WritableStreamDefaultWriterWrite = _require5.WritableStreamDefaultWriterWrite,
      WritableStreamCloseQueuedOrInFlight = _require5.WritableStreamCloseQueuedOrInFlight;

  var ReadableStream = function () {
    function ReadableStream() {
      var underlyingSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          size = _ref.size,
          highWaterMark = _ref.highWaterMark;

      _classCallCheck(this, ReadableStream);

      this._state = 'readable';
      this._reader = undefined;
      this._storedError = undefined;
      this._disturbed = false;
      this._readableStreamController = undefined;
      var type = underlyingSource.type;
      var typeString = String(type);

      if (typeString === 'bytes') {
        if (highWaterMark === undefined) {
          highWaterMark = 0;
        }

        this._readableStreamController = new ReadableByteStreamController(this, underlyingSource, highWaterMark);
      } else if (type === undefined) {
        if (highWaterMark === undefined) {
          highWaterMark = 1;
        }

        this._readableStreamController = new ReadableStreamDefaultController(this, underlyingSource, size, highWaterMark);
      } else {
        throw new RangeError('Invalid type is specified');
      }
    }

    _createClass(ReadableStream, [{
      key: 'cancel',
      value: function cancel(reason) {
        if (IsReadableStream(this) === false) {
          return Promise.reject(streamBrandCheckException('cancel'));
        }

        if (IsReadableStreamLocked(this) === true) {
          return Promise.reject(new TypeError('Cannot cancel a stream that already has a reader'));
        }

        return ReadableStreamCancel(this, reason);
      }
    }, {
      key: 'getReader',
      value: function getReader() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            mode = _ref2.mode;

        if (IsReadableStream(this) === false) {
          throw streamBrandCheckException('getReader');
        }

        if (mode === undefined) {
          return AcquireReadableStreamDefaultReader(this);
        }

        mode = String(mode);

        if (mode === 'byob') {
          return AcquireReadableStreamBYOBReader(this);
        }

        throw new RangeError('Invalid mode is specified');
      }
    }, {
      key: 'pipeThrough',
      value: function pipeThrough(_ref3, options) {
        var writable = _ref3.writable,
            readable = _ref3.readable;
        var promise = this.pipeTo(writable, options);
        ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise);
        return readable;
      }
    }, {
      key: 'pipeTo',
      value: function pipeTo(dest) {
        var _this = this;

        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            preventClose = _ref4.preventClose,
            preventAbort = _ref4.preventAbort,
            preventCancel = _ref4.preventCancel;

        if (IsReadableStream(this) === false) {
          return Promise.reject(streamBrandCheckException('pipeTo'));
        }

        if (IsWritableStream(dest) === false) {
          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo\'s first argument must be a WritableStream'));
        }

        preventClose = Boolean(preventClose);
        preventAbort = Boolean(preventAbort);
        preventCancel = Boolean(preventCancel);

        if (IsReadableStreamLocked(this) === true) {
          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream'));
        }

        if (IsWritableStreamLocked(dest) === true) {
          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream'));
        }

        var reader = AcquireReadableStreamDefaultReader(this);
        var writer = AcquireWritableStreamDefaultWriter(dest);
        var shuttingDown = false;
        var currentWrite = Promise.resolve();
        return new Promise(function (resolve, reject) {
          function pipeLoop() {
            currentWrite = Promise.resolve();

            if (shuttingDown === true) {
              return Promise.resolve();
            }

            return writer._readyPromise.then(function () {
              return ReadableStreamDefaultReaderRead(reader).then(function (_ref5) {
                var value = _ref5.value,
                    done = _ref5.done;

                if (done === true) {
                  return;
                }

                currentWrite = WritableStreamDefaultWriterWrite(writer, value)["catch"](function () {});
              });
            }).then(pipeLoop);
          }

          isOrBecomesErrored(_this, reader._closedPromise, function (storedError) {
            if (preventAbort === false) {
              shutdownWithAction(function () {
                return WritableStreamAbort(dest, storedError);
              }, true, storedError);
            } else {
              shutdown(true, storedError);
            }
          });
          isOrBecomesErrored(dest, writer._closedPromise, function (storedError) {
            if (preventCancel === false) {
              shutdownWithAction(function () {
                return ReadableStreamCancel(_this, storedError);
              }, true, storedError);
            } else {
              shutdown(true, storedError);
            }
          });
          isOrBecomesClosed(_this, reader._closedPromise, function () {
            if (preventClose === false) {
              shutdownWithAction(function () {
                return WritableStreamDefaultWriterCloseWithErrorPropagation(writer);
              });
            } else {
              shutdown();
            }
          });

          if (WritableStreamCloseQueuedOrInFlight(dest) === true || dest._state === 'closed') {
            var destClosed = new TypeError('the destination writable stream closed before all data could be piped to it');

            if (preventCancel === false) {
              shutdownWithAction(function () {
                return ReadableStreamCancel(_this, destClosed);
              }, true, destClosed);
            } else {
              shutdown(true, destClosed);
            }
          }

          pipeLoop()["catch"](function (err) {
            currentWrite = Promise.resolve();
            rethrowAssertionErrorRejection(err);
          });

          function waitForWritesToFinish() {
            var oldCurrentWrite = currentWrite;
            return currentWrite.then(function () {
              return oldCurrentWrite !== currentWrite ? waitForWritesToFinish() : undefined;
            });
          }

          function isOrBecomesErrored(stream, promise, action) {
            if (stream._state === 'errored') {
              action(stream._storedError);
            } else {
              promise["catch"](action)["catch"](rethrowAssertionErrorRejection);
            }
          }

          function isOrBecomesClosed(stream, promise, action) {
            if (stream._state === 'closed') {
              action();
            } else {
              promise.then(action)["catch"](rethrowAssertionErrorRejection);
            }
          }

          function shutdownWithAction(action, originalIsError, originalError) {
            if (shuttingDown === true) {
              return;
            }

            shuttingDown = true;

            if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
              waitForWritesToFinish().then(doTheRest);
            } else {
              doTheRest();
            }

            function doTheRest() {
              action().then(function () {
                return finalize(originalIsError, originalError);
              }, function (newError) {
                return finalize(true, newError);
              })["catch"](rethrowAssertionErrorRejection);
            }
          }

          function shutdown(isError, error) {
            if (shuttingDown === true) {
              return;
            }

            shuttingDown = true;

            if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
              waitForWritesToFinish().then(function () {
                return finalize(isError, error);
              })["catch"](rethrowAssertionErrorRejection);
            } else {
              finalize(isError, error);
            }
          }

          function finalize(isError, error) {
            WritableStreamDefaultWriterRelease(writer);
            ReadableStreamReaderGenericRelease(reader);

            if (isError) {
              reject(error);
            } else {
              resolve(undefined);
            }
          }
        });
      }
    }, {
      key: 'tee',
      value: function tee() {
        if (IsReadableStream(this) === false) {
          throw streamBrandCheckException('tee');
        }

        var branches = ReadableStreamTee(this, false);
        return createArrayFromList(branches);
      }
    }, {
      key: 'locked',
      get: function get() {
        if (IsReadableStream(this) === false) {
          throw streamBrandCheckException('locked');
        }

        return IsReadableStreamLocked(this);
      }
    }]);

    return ReadableStream;
  }();

  module.exports = {
    ReadableStream: ReadableStream,
    IsReadableStreamDisturbed: IsReadableStreamDisturbed,
    ReadableStreamDefaultControllerClose: ReadableStreamDefaultControllerClose,
    ReadableStreamDefaultControllerEnqueue: ReadableStreamDefaultControllerEnqueue,
    ReadableStreamDefaultControllerError: ReadableStreamDefaultControllerError,
    ReadableStreamDefaultControllerGetDesiredSize: ReadableStreamDefaultControllerGetDesiredSize
  };

  function AcquireReadableStreamBYOBReader(stream) {
    return new ReadableStreamBYOBReader(stream);
  }

  function AcquireReadableStreamDefaultReader(stream) {
    return new ReadableStreamDefaultReader(stream);
  }

  function IsReadableStream(x) {
    if (!typeIsObject(x)) {
      return false;
    }

    if (!Object.prototype.hasOwnProperty.call(x, '_readableStreamController')) {
      return false;
    }

    return true;
  }

  function IsReadableStreamDisturbed(stream) {
    assert(IsReadableStream(stream) === true, 'IsReadableStreamDisturbed should only be used on known readable streams');
    return stream._disturbed;
  }

  function IsReadableStreamLocked(stream) {
    assert(IsReadableStream(stream) === true, 'IsReadableStreamLocked should only be used on known readable streams');

    if (stream._reader === undefined) {
      return false;
    }

    return true;
  }

  function ReadableStreamTee(stream, cloneForBranch2) {
    assert(IsReadableStream(stream) === true);
    assert(typeof cloneForBranch2 === 'boolean');
    var reader = AcquireReadableStreamDefaultReader(stream);
    var teeState = {
      closedOrErrored: false,
      canceled1: false,
      canceled2: false,
      reason1: undefined,
      reason2: undefined
    };
    teeState.promise = new Promise(function (resolve) {
      teeState._resolve = resolve;
    });
    var pull = create_ReadableStreamTeePullFunction();
    pull._reader = reader;
    pull._teeState = teeState;
    pull._cloneForBranch2 = cloneForBranch2;
    var cancel1 = create_ReadableStreamTeeBranch1CancelFunction();
    cancel1._stream = stream;
    cancel1._teeState = teeState;
    var cancel2 = create_ReadableStreamTeeBranch2CancelFunction();
    cancel2._stream = stream;
    cancel2._teeState = teeState;
    var underlyingSource1 = Object.create(Object.prototype);
    createDataProperty(underlyingSource1, 'pull', pull);
    createDataProperty(underlyingSource1, 'cancel', cancel1);
    var branch1Stream = new ReadableStream(underlyingSource1);
    var underlyingSource2 = Object.create(Object.prototype);
    createDataProperty(underlyingSource2, 'pull', pull);
    createDataProperty(underlyingSource2, 'cancel', cancel2);
    var branch2Stream = new ReadableStream(underlyingSource2);
    pull._branch1 = branch1Stream._readableStreamController;
    pull._branch2 = branch2Stream._readableStreamController;

    reader._closedPromise["catch"](function (r) {
      if (teeState.closedOrErrored === true) {
        return;
      }

      ReadableStreamDefaultControllerError(pull._branch1, r);
      ReadableStreamDefaultControllerError(pull._branch2, r);
      teeState.closedOrErrored = true;
    });

    return [branch1Stream, branch2Stream];
  }

  function create_ReadableStreamTeePullFunction() {
    function f() {
      var reader = f._reader,
          branch1 = f._branch1,
          branch2 = f._branch2,
          teeState = f._teeState;
      return ReadableStreamDefaultReaderRead(reader).then(function (result) {
        assert(typeIsObject(result));
        var value = result.value;
        var done = result.done;
        assert(typeof done === 'boolean');

        if (done === true && teeState.closedOrErrored === false) {
          if (teeState.canceled1 === false) {
            ReadableStreamDefaultControllerClose(branch1);
          }

          if (teeState.canceled2 === false) {
            ReadableStreamDefaultControllerClose(branch2);
          }

          teeState.closedOrErrored = true;
        }

        if (teeState.closedOrErrored === true) {
          return;
        }

        var value1 = value;
        var value2 = value;

        if (teeState.canceled1 === false) {
          ReadableStreamDefaultControllerEnqueue(branch1, value1);
        }

        if (teeState.canceled2 === false) {
          ReadableStreamDefaultControllerEnqueue(branch2, value2);
        }
      });
    }

    return f;
  }

  function create_ReadableStreamTeeBranch1CancelFunction() {
    function f(reason) {
      var stream = f._stream,
          teeState = f._teeState;
      teeState.canceled1 = true;
      teeState.reason1 = reason;

      if (teeState.canceled2 === true) {
        var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
        var cancelResult = ReadableStreamCancel(stream, compositeReason);

        teeState._resolve(cancelResult);
      }

      return teeState.promise;
    }

    return f;
  }

  function create_ReadableStreamTeeBranch2CancelFunction() {
    function f(reason) {
      var stream = f._stream,
          teeState = f._teeState;
      teeState.canceled2 = true;
      teeState.reason2 = reason;

      if (teeState.canceled1 === true) {
        var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
        var cancelResult = ReadableStreamCancel(stream, compositeReason);

        teeState._resolve(cancelResult);
      }

      return teeState.promise;
    }

    return f;
  }

  function ReadableStreamAddReadIntoRequest(stream) {
    assert(IsReadableStreamBYOBReader(stream._reader) === true);
    assert(stream._state === 'readable' || stream._state === 'closed');
    var promise = new Promise(function (resolve, reject) {
      var readIntoRequest = {
        _resolve: resolve,
        _reject: reject
      };

      stream._reader._readIntoRequests.push(readIntoRequest);
    });
    return promise;
  }

  function ReadableStreamAddReadRequest(stream) {
    assert(IsReadableStreamDefaultReader(stream._reader) === true);
    assert(stream._state === 'readable');
    var promise = new Promise(function (resolve, reject) {
      var readRequest = {
        _resolve: resolve,
        _reject: reject
      };

      stream._reader._readRequests.push(readRequest);
    });
    return promise;
  }

  function ReadableStreamCancel(stream, reason) {
    stream._disturbed = true;

    if (stream._state === 'closed') {
      return Promise.resolve(undefined);
    }

    if (stream._state === 'errored') {
      return Promise.reject(stream._storedError);
    }

    ReadableStreamClose(stream);

    var sourceCancelPromise = stream._readableStreamController.__cancelSteps(reason);

    return sourceCancelPromise.then(function () {
      return undefined;
    });
  }

  function ReadableStreamClose(stream) {
    assert(stream._state === 'readable');
    stream._state = 'closed';
    var reader = stream._reader;

    if (reader === undefined) {
      return undefined;
    }

    if (IsReadableStreamDefaultReader(reader) === true) {
      for (var i = 0; i < reader._readRequests.length; i++) {
        var _resolve = reader._readRequests[i]._resolve;

        _resolve(CreateIterResultObject(undefined, true));
      }

      reader._readRequests = [];
    }

    defaultReaderClosedPromiseResolve(reader);
    return undefined;
  }

  function ReadableStreamError(stream, e) {
    assert(IsReadableStream(stream) === true, 'stream must be ReadableStream');
    assert(stream._state === 'readable', 'state must be readable');
    stream._state = 'errored';
    stream._storedError = e;
    var reader = stream._reader;

    if (reader === undefined) {
      return undefined;
    }

    if (IsReadableStreamDefaultReader(reader) === true) {
      for (var i = 0; i < reader._readRequests.length; i++) {
        var readRequest = reader._readRequests[i];

        readRequest._reject(e);
      }

      reader._readRequests = [];
    } else {
      assert(IsReadableStreamBYOBReader(reader), 'reader must be ReadableStreamBYOBReader');

      for (var _i = 0; _i < reader._readIntoRequests.length; _i++) {
        var readIntoRequest = reader._readIntoRequests[_i];

        readIntoRequest._reject(e);
      }

      reader._readIntoRequests = [];
    }

    defaultReaderClosedPromiseReject(reader, e);

    reader._closedPromise["catch"](function () {});
  }

  function ReadableStreamFulfillReadIntoRequest(stream, chunk, done) {
    var reader = stream._reader;
    assert(reader._readIntoRequests.length > 0);

    var readIntoRequest = reader._readIntoRequests.shift();

    readIntoRequest._resolve(CreateIterResultObject(chunk, done));
  }

  function ReadableStreamFulfillReadRequest(stream, chunk, done) {
    var reader = stream._reader;
    assert(reader._readRequests.length > 0);

    var readRequest = reader._readRequests.shift();

    readRequest._resolve(CreateIterResultObject(chunk, done));
  }

  function ReadableStreamGetNumReadIntoRequests(stream) {
    return stream._reader._readIntoRequests.length;
  }

  function ReadableStreamGetNumReadRequests(stream) {
    return stream._reader._readRequests.length;
  }

  function ReadableStreamHasBYOBReader(stream) {
    var reader = stream._reader;

    if (reader === undefined) {
      return false;
    }

    if (IsReadableStreamBYOBReader(reader) === false) {
      return false;
    }

    return true;
  }

  function ReadableStreamHasDefaultReader(stream) {
    var reader = stream._reader;

    if (reader === undefined) {
      return false;
    }

    if (IsReadableStreamDefaultReader(reader) === false) {
      return false;
    }

    return true;
  }

  var ReadableStreamDefaultReader = function () {
    function ReadableStreamDefaultReader(stream) {
      _classCallCheck(this, ReadableStreamDefaultReader);

      if (IsReadableStream(stream) === false) {
        throw new TypeError('ReadableStreamDefaultReader can only be constructed with a ReadableStream instance');
      }

      if (IsReadableStreamLocked(stream) === true) {
        throw new TypeError('This stream has already been locked for exclusive reading by another reader');
      }

      ReadableStreamReaderGenericInitialize(this, stream);
      this._readRequests = [];
    }

    _createClass(ReadableStreamDefaultReader, [{
      key: 'cancel',
      value: function cancel(reason) {
        if (IsReadableStreamDefaultReader(this) === false) {
          return Promise.reject(defaultReaderBrandCheckException('cancel'));
        }

        if (this._ownerReadableStream === undefined) {
          return Promise.reject(readerLockException('cancel'));
        }

        return ReadableStreamReaderGenericCancel(this, reason);
      }
    }, {
      key: 'read',
      value: function read() {
        if (IsReadableStreamDefaultReader(this) === false) {
          return Promise.reject(defaultReaderBrandCheckException('read'));
        }

        if (this._ownerReadableStream === undefined) {
          return Promise.reject(readerLockException('read from'));
        }

        return ReadableStreamDefaultReaderRead(this);
      }
    }, {
      key: 'releaseLock',
      value: function releaseLock() {
        if (IsReadableStreamDefaultReader(this) === false) {
          throw defaultReaderBrandCheckException('releaseLock');
        }

        if (this._ownerReadableStream === undefined) {
          return;
        }

        if (this._readRequests.length > 0) {
          throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
        }

        ReadableStreamReaderGenericRelease(this);
      }
    }, {
      key: 'closed',
      get: function get() {
        if (IsReadableStreamDefaultReader(this) === false) {
          return Promise.reject(defaultReaderBrandCheckException('closed'));
        }

        return this._closedPromise;
      }
    }]);

    return ReadableStreamDefaultReader;
  }();

  var ReadableStreamBYOBReader = function () {
    function ReadableStreamBYOBReader(stream) {
      _classCallCheck(this, ReadableStreamBYOBReader);

      if (!IsReadableStream(stream)) {
        throw new TypeError('ReadableStreamBYOBReader can only be constructed with a ReadableStream instance given a ' + 'byte source');
      }

      if (IsReadableByteStreamController(stream._readableStreamController) === false) {
        throw new TypeError('Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte ' + 'source');
      }

      if (IsReadableStreamLocked(stream)) {
        throw new TypeError('This stream has already been locked for exclusive reading by another reader');
      }

      ReadableStreamReaderGenericInitialize(this, stream);
      this._readIntoRequests = [];
    }

    _createClass(ReadableStreamBYOBReader, [{
      key: 'cancel',
      value: function cancel(reason) {
        if (!IsReadableStreamBYOBReader(this)) {
          return Promise.reject(byobReaderBrandCheckException('cancel'));
        }

        if (this._ownerReadableStream === undefined) {
          return Promise.reject(readerLockException('cancel'));
        }

        return ReadableStreamReaderGenericCancel(this, reason);
      }
    }, {
      key: 'read',
      value: function read(view) {
        if (!IsReadableStreamBYOBReader(this)) {
          return Promise.reject(byobReaderBrandCheckException('read'));
        }

        if (this._ownerReadableStream === undefined) {
          return Promise.reject(readerLockException('read from'));
        }

        if (!ArrayBuffer.isView(view)) {
          return Promise.reject(new TypeError('view must be an array buffer view'));
        }

        if (view.byteLength === 0) {
          return Promise.reject(new TypeError('view must have non-zero byteLength'));
        }

        return ReadableStreamBYOBReaderRead(this, view);
      }
    }, {
      key: 'releaseLock',
      value: function releaseLock() {
        if (!IsReadableStreamBYOBReader(this)) {
          throw byobReaderBrandCheckException('releaseLock');
        }

        if (this._ownerReadableStream === undefined) {
          return;
        }

        if (this._readIntoRequests.length > 0) {
          throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
        }

        ReadableStreamReaderGenericRelease(this);
      }
    }, {
      key: 'closed',
      get: function get() {
        if (!IsReadableStreamBYOBReader(this)) {
          return Promise.reject(byobReaderBrandCheckException('closed'));
        }

        return this._closedPromise;
      }
    }]);

    return ReadableStreamBYOBReader;
  }();

  function IsReadableStreamBYOBReader(x) {
    if (!typeIsObject(x)) {
      return false;
    }

    if (!Object.prototype.hasOwnProperty.call(x, '_readIntoRequests')) {
      return false;
    }

    return true;
  }

  function IsReadableStreamDefaultReader(x) {
    if (!typeIsObject(x)) {
      return false;
    }

    if (!Object.prototype.hasOwnProperty.call(x, '_readRequests')) {
      return false;
    }

    return true;
  }

  function ReadableStreamReaderGenericInitialize(reader, stream) {
    reader._ownerReadableStream = stream;
    stream._reader = reader;

    if (stream._state === 'readable') {
      defaultReaderClosedPromiseInitialize(reader);
    } else if (stream._state === 'closed') {
      defaultReaderClosedPromiseInitializeAsResolved(reader);
    } else {
      assert(stream._state === 'errored', 'state must be errored');
      defaultReaderClosedPromiseInitializeAsRejected(reader, stream._storedError);

      reader._closedPromise["catch"](function () {});
    }
  }

  function ReadableStreamReaderGenericCancel(reader, reason) {
    var stream = reader._ownerReadableStream;
    assert(stream !== undefined);
    return ReadableStreamCancel(stream, reason);
  }

  function ReadableStreamReaderGenericRelease(reader) {
    assert(reader._ownerReadableStream !== undefined);
    assert(reader._ownerReadableStream._reader === reader);

    if (reader._ownerReadableStream._state === 'readable') {
      defaultReaderClosedPromiseReject(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'));
    } else {
      defaultReaderClosedPromiseResetToRejected(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'));
    }

    reader._closedPromise["catch"](function () {});

    reader._ownerReadableStream._reader = undefined;
    reader._ownerReadableStream = undefined;
  }

  function ReadableStreamBYOBReaderRead(reader, view) {
    var stream = reader._ownerReadableStream;
    assert(stream !== undefined);
    stream._disturbed = true;

    if (stream._state === 'errored') {
      return Promise.reject(stream._storedError);
    }

    return ReadableByteStreamControllerPullInto(stream._readableStreamController, view);
  }

  function ReadableStreamDefaultReaderRead(reader) {
    var stream = reader._ownerReadableStream;
    assert(stream !== undefined);
    stream._disturbed = true;

    if (stream._state === 'closed') {
      return Promise.resolve(CreateIterResultObject(undefined, true));
    }

    if (stream._state === 'errored') {
      return Promise.reject(stream._storedError);
    }

    assert(stream._state === 'readable');
    return stream._readableStreamController.__pullSteps();
  }

  var ReadableStreamDefaultController = function () {
    function ReadableStreamDefaultController(stream, underlyingSource, size, highWaterMark) {
      _classCallCheck(this, ReadableStreamDefaultController);

      if (IsReadableStream(stream) === false) {
        throw new TypeError('ReadableStreamDefaultController can only be constructed with a ReadableStream instance');
      }

      if (stream._readableStreamController !== undefined) {
        throw new TypeError('ReadableStreamDefaultController instances can only be created by the ReadableStream constructor');
      }

      this._controlledReadableStream = stream;
      this._underlyingSource = underlyingSource;
      this._queue = undefined;
      this._queueTotalSize = undefined;
      ResetQueue(this);
      this._started = false;
      this._closeRequested = false;
      this._pullAgain = false;
      this._pulling = false;
      var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
      this._strategySize = normalizedStrategy.size;
      this._strategyHWM = normalizedStrategy.highWaterMark;
      var controller = this;
      var startResult = InvokeOrNoop(underlyingSource, 'start', [this]);
      Promise.resolve(startResult).then(function () {
        controller._started = true;
        assert(controller._pulling === false);
        assert(controller._pullAgain === false);
        ReadableStreamDefaultControllerCallPullIfNeeded(controller);
      }, function (r) {
        ReadableStreamDefaultControllerErrorIfNeeded(controller, r);
      })["catch"](rethrowAssertionErrorRejection);
    }

    _createClass(ReadableStreamDefaultController, [{
      key: 'close',
      value: function close() {
        if (IsReadableStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('close');
        }

        if (this._closeRequested === true) {
          throw new TypeError('The stream has already been closed; do not close it again!');
        }

        var state = this._controlledReadableStream._state;

        if (state !== 'readable') {
          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be closed');
        }

        ReadableStreamDefaultControllerClose(this);
      }
    }, {
      key: 'enqueue',
      value: function enqueue(chunk) {
        if (IsReadableStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('enqueue');
        }

        if (this._closeRequested === true) {
          throw new TypeError('stream is closed or draining');
        }

        var state = this._controlledReadableStream._state;

        if (state !== 'readable') {
          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be enqueued to');
        }

        return ReadableStreamDefaultControllerEnqueue(this, chunk);
      }
    }, {
      key: 'error',
      value: function error(e) {
        if (IsReadableStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('error');
        }

        var stream = this._controlledReadableStream;

        if (stream._state !== 'readable') {
          throw new TypeError('The stream is ' + stream._state + ' and so cannot be errored');
        }

        ReadableStreamDefaultControllerError(this, e);
      }
    }, {
      key: '__cancelSteps',
      value: function __cancelSteps(reason) {
        ResetQueue(this);
        return PromiseInvokeOrNoop(this._underlyingSource, 'cancel', [reason]);
      }
    }, {
      key: '__pullSteps',
      value: function __pullSteps() {
        var stream = this._controlledReadableStream;

        if (this._queue.length > 0) {
          var chunk = DequeueValue(this);

          if (this._closeRequested === true && this._queue.length === 0) {
            ReadableStreamClose(stream);
          } else {
            ReadableStreamDefaultControllerCallPullIfNeeded(this);
          }

          return Promise.resolve(CreateIterResultObject(chunk, false));
        }

        var pendingPromise = ReadableStreamAddReadRequest(stream);
        ReadableStreamDefaultControllerCallPullIfNeeded(this);
        return pendingPromise;
      }
    }, {
      key: 'desiredSize',
      get: function get() {
        if (IsReadableStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('desiredSize');
        }

        return ReadableStreamDefaultControllerGetDesiredSize(this);
      }
    }]);

    return ReadableStreamDefaultController;
  }();

  function IsReadableStreamDefaultController(x) {
    if (!typeIsObject(x)) {
      return false;
    }

    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingSource')) {
      return false;
    }

    return true;
  }

  function ReadableStreamDefaultControllerCallPullIfNeeded(controller) {
    var shouldPull = ReadableStreamDefaultControllerShouldCallPull(controller);

    if (shouldPull === false) {
      return undefined;
    }

    if (controller._pulling === true) {
      controller._pullAgain = true;
      return undefined;
    }

    assert(controller._pullAgain === false);
    controller._pulling = true;
    var pullPromise = PromiseInvokeOrNoop(controller._underlyingSource, 'pull', [controller]);
    pullPromise.then(function () {
      controller._pulling = false;

      if (controller._pullAgain === true) {
        controller._pullAgain = false;
        return ReadableStreamDefaultControllerCallPullIfNeeded(controller);
      }

      return undefined;
    }, function (e) {
      ReadableStreamDefaultControllerErrorIfNeeded(controller, e);
    })["catch"](rethrowAssertionErrorRejection);
    return undefined;
  }

  function ReadableStreamDefaultControllerShouldCallPull(controller) {
    var stream = controller._controlledReadableStream;

    if (stream._state === 'closed' || stream._state === 'errored') {
      return false;
    }

    if (controller._closeRequested === true) {
      return false;
    }

    if (controller._started === false) {
      return false;
    }

    if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
      return true;
    }

    var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);

    if (desiredSize > 0) {
      return true;
    }

    return false;
  }

  function ReadableStreamDefaultControllerClose(controller) {
    var stream = controller._controlledReadableStream;
    assert(controller._closeRequested === false);
    assert(stream._state === 'readable');
    controller._closeRequested = true;

    if (controller._queue.length === 0) {
      ReadableStreamClose(stream);
    }
  }

  function ReadableStreamDefaultControllerEnqueue(controller, chunk) {
    var stream = controller._controlledReadableStream;
    assert(controller._closeRequested === false);
    assert(stream._state === 'readable');

    if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
      ReadableStreamFulfillReadRequest(stream, chunk, false);
    } else {
      var chunkSize = 1;

      if (controller._strategySize !== undefined) {
        var strategySize = controller._strategySize;

        try {
          chunkSize = strategySize(chunk);
        } catch (chunkSizeE) {
          ReadableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
          throw chunkSizeE;
        }
      }

      try {
        EnqueueValueWithSize(controller, chunk, chunkSize);
      } catch (enqueueE) {
        ReadableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
        throw enqueueE;
      }
    }

    ReadableStreamDefaultControllerCallPullIfNeeded(controller);
    return undefined;
  }

  function ReadableStreamDefaultControllerError(controller, e) {
    var stream = controller._controlledReadableStream;
    assert(stream._state === 'readable');
    ResetQueue(controller);
    ReadableStreamError(stream, e);
  }

  function ReadableStreamDefaultControllerErrorIfNeeded(controller, e) {
    if (controller._controlledReadableStream._state === 'readable') {
      ReadableStreamDefaultControllerError(controller, e);
    }
  }

  function ReadableStreamDefaultControllerGetDesiredSize(controller) {
    var stream = controller._controlledReadableStream;
    var state = stream._state;

    if (state === 'errored') {
      return null;
    }

    if (state === 'closed') {
      return 0;
    }

    return controller._strategyHWM - controller._queueTotalSize;
  }

  var ReadableStreamBYOBRequest = function () {
    function ReadableStreamBYOBRequest(controller, view) {
      _classCallCheck(this, ReadableStreamBYOBRequest);

      this._associatedReadableByteStreamController = controller;
      this._view = view;
    }

    _createClass(ReadableStreamBYOBRequest, [{
      key: 'respond',
      value: function respond(bytesWritten) {
        if (IsReadableStreamBYOBRequest(this) === false) {
          throw byobRequestBrandCheckException('respond');
        }

        if (this._associatedReadableByteStreamController === undefined) {
          throw new TypeError('This BYOB request has been invalidated');
        }

        ReadableByteStreamControllerRespond(this._associatedReadableByteStreamController, bytesWritten);
      }
    }, {
      key: 'respondWithNewView',
      value: function respondWithNewView(view) {
        if (IsReadableStreamBYOBRequest(this) === false) {
          throw byobRequestBrandCheckException('respond');
        }

        if (this._associatedReadableByteStreamController === undefined) {
          throw new TypeError('This BYOB request has been invalidated');
        }

        if (!ArrayBuffer.isView(view)) {
          throw new TypeError('You can only respond with array buffer views');
        }

        ReadableByteStreamControllerRespondWithNewView(this._associatedReadableByteStreamController, view);
      }
    }, {
      key: 'view',
      get: function get() {
        return this._view;
      }
    }]);

    return ReadableStreamBYOBRequest;
  }();

  var ReadableByteStreamController = function () {
    function ReadableByteStreamController(stream, underlyingByteSource, highWaterMark) {
      _classCallCheck(this, ReadableByteStreamController);

      if (IsReadableStream(stream) === false) {
        throw new TypeError('ReadableByteStreamController can only be constructed with a ReadableStream instance given ' + 'a byte source');
      }

      if (stream._readableStreamController !== undefined) {
        throw new TypeError('ReadableByteStreamController instances can only be created by the ReadableStream constructor given a byte ' + 'source');
      }

      this._controlledReadableStream = stream;
      this._underlyingByteSource = underlyingByteSource;
      this._pullAgain = false;
      this._pulling = false;
      ReadableByteStreamControllerClearPendingPullIntos(this);
      this._queue = this._queueTotalSize = undefined;
      ResetQueue(this);
      this._closeRequested = false;
      this._started = false;
      this._strategyHWM = ValidateAndNormalizeHighWaterMark(highWaterMark);
      var autoAllocateChunkSize = underlyingByteSource.autoAllocateChunkSize;

      if (autoAllocateChunkSize !== undefined) {
        if (Number.isInteger(autoAllocateChunkSize) === false || autoAllocateChunkSize <= 0) {
          throw new RangeError('autoAllocateChunkSize must be a positive integer');
        }
      }

      this._autoAllocateChunkSize = autoAllocateChunkSize;
      this._pendingPullIntos = [];
      var controller = this;
      var startResult = InvokeOrNoop(underlyingByteSource, 'start', [this]);
      Promise.resolve(startResult).then(function () {
        controller._started = true;
        assert(controller._pulling === false);
        assert(controller._pullAgain === false);
        ReadableByteStreamControllerCallPullIfNeeded(controller);
      }, function (r) {
        if (stream._state === 'readable') {
          ReadableByteStreamControllerError(controller, r);
        }
      })["catch"](rethrowAssertionErrorRejection);
    }

    _createClass(ReadableByteStreamController, [{
      key: 'close',
      value: function close() {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('close');
        }

        if (this._closeRequested === true) {
          throw new TypeError('The stream has already been closed; do not close it again!');
        }

        var state = this._controlledReadableStream._state;

        if (state !== 'readable') {
          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be closed');
        }

        ReadableByteStreamControllerClose(this);
      }
    }, {
      key: 'enqueue',
      value: function enqueue(chunk) {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('enqueue');
        }

        if (this._closeRequested === true) {
          throw new TypeError('stream is closed or draining');
        }

        var state = this._controlledReadableStream._state;

        if (state !== 'readable') {
          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be enqueued to');
        }

        if (!ArrayBuffer.isView(chunk)) {
          throw new TypeError('You can only enqueue array buffer views when using a ReadableByteStreamController');
        }

        ReadableByteStreamControllerEnqueue(this, chunk);
      }
    }, {
      key: 'error',
      value: function error(e) {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('error');
        }

        var stream = this._controlledReadableStream;

        if (stream._state !== 'readable') {
          throw new TypeError('The stream is ' + stream._state + ' and so cannot be errored');
        }

        ReadableByteStreamControllerError(this, e);
      }
    }, {
      key: '__cancelSteps',
      value: function __cancelSteps(reason) {
        if (this._pendingPullIntos.length > 0) {
          var firstDescriptor = this._pendingPullIntos[0];
          firstDescriptor.bytesFilled = 0;
        }

        ResetQueue(this);
        return PromiseInvokeOrNoop(this._underlyingByteSource, 'cancel', [reason]);
      }
    }, {
      key: '__pullSteps',
      value: function __pullSteps() {
        var stream = this._controlledReadableStream;
        assert(ReadableStreamHasDefaultReader(stream) === true);

        if (this._queueTotalSize > 0) {
          assert(ReadableStreamGetNumReadRequests(stream) === 0);

          var entry = this._queue.shift();

          this._queueTotalSize -= entry.byteLength;
          ReadableByteStreamControllerHandleQueueDrain(this);
          var view = void 0;

          try {
            view = new Uint8Array(entry.buffer, entry.byteOffset, entry.byteLength);
          } catch (viewE) {
            return Promise.reject(viewE);
          }

          return Promise.resolve(CreateIterResultObject(view, false));
        }

        var autoAllocateChunkSize = this._autoAllocateChunkSize;

        if (autoAllocateChunkSize !== undefined) {
          var buffer = void 0;

          try {
            buffer = new ArrayBuffer(autoAllocateChunkSize);
          } catch (bufferE) {
            return Promise.reject(bufferE);
          }

          var pullIntoDescriptor = {
            buffer: buffer,
            byteOffset: 0,
            byteLength: autoAllocateChunkSize,
            bytesFilled: 0,
            elementSize: 1,
            ctor: Uint8Array,
            readerType: 'default'
          };

          this._pendingPullIntos.push(pullIntoDescriptor);
        }

        var promise = ReadableStreamAddReadRequest(stream);
        ReadableByteStreamControllerCallPullIfNeeded(this);
        return promise;
      }
    }, {
      key: 'byobRequest',
      get: function get() {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('byobRequest');
        }

        if (this._byobRequest === undefined && this._pendingPullIntos.length > 0) {
          var firstDescriptor = this._pendingPullIntos[0];
          var view = new Uint8Array(firstDescriptor.buffer, firstDescriptor.byteOffset + firstDescriptor.bytesFilled, firstDescriptor.byteLength - firstDescriptor.bytesFilled);
          this._byobRequest = new ReadableStreamBYOBRequest(this, view);
        }

        return this._byobRequest;
      }
    }, {
      key: 'desiredSize',
      get: function get() {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('desiredSize');
        }

        return ReadableByteStreamControllerGetDesiredSize(this);
      }
    }]);

    return ReadableByteStreamController;
  }();

  function IsReadableByteStreamController(x) {
    if (!typeIsObject(x)) {
      return false;
    }

    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingByteSource')) {
      return false;
    }

    return true;
  }

  function IsReadableStreamBYOBRequest(x) {
    if (!typeIsObject(x)) {
      return false;
    }

    if (!Object.prototype.hasOwnProperty.call(x, '_associatedReadableByteStreamController')) {
      return false;
    }

    return true;
  }

  function ReadableByteStreamControllerCallPullIfNeeded(controller) {
    var shouldPull = ReadableByteStreamControllerShouldCallPull(controller);

    if (shouldPull === false) {
      return undefined;
    }

    if (controller._pulling === true) {
      controller._pullAgain = true;
      return undefined;
    }

    assert(controller._pullAgain === false);
    controller._pulling = true;
    var pullPromise = PromiseInvokeOrNoop(controller._underlyingByteSource, 'pull', [controller]);
    pullPromise.then(function () {
      controller._pulling = false;

      if (controller._pullAgain === true) {
        controller._pullAgain = false;
        ReadableByteStreamControllerCallPullIfNeeded(controller);
      }
    }, function (e) {
      if (controller._controlledReadableStream._state === 'readable') {
        ReadableByteStreamControllerError(controller, e);
      }
    })["catch"](rethrowAssertionErrorRejection);
    return undefined;
  }

  function ReadableByteStreamControllerClearPendingPullIntos(controller) {
    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
    controller._pendingPullIntos = [];
  }

  function ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor) {
    assert(stream._state !== 'errored', 'state must not be errored');
    var done = false;

    if (stream._state === 'closed') {
      assert(pullIntoDescriptor.bytesFilled === 0);
      done = true;
    }

    var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);

    if (pullIntoDescriptor.readerType === 'default') {
      ReadableStreamFulfillReadRequest(stream, filledView, done);
    } else {
      assert(pullIntoDescriptor.readerType === 'byob');
      ReadableStreamFulfillReadIntoRequest(stream, filledView, done);
    }
  }

  function ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor) {
    var bytesFilled = pullIntoDescriptor.bytesFilled;
    var elementSize = pullIntoDescriptor.elementSize;
    assert(bytesFilled <= pullIntoDescriptor.byteLength);
    assert(bytesFilled % elementSize === 0);
    return new pullIntoDescriptor.ctor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, bytesFilled / elementSize);
  }

  function ReadableByteStreamControllerEnqueueChunkToQueue(controller, buffer, byteOffset, byteLength) {
    controller._queue.push({
      buffer: buffer,
      byteOffset: byteOffset,
      byteLength: byteLength
    });

    controller._queueTotalSize += byteLength;
  }

  function ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) {
    var elementSize = pullIntoDescriptor.elementSize;
    var currentAlignedBytes = pullIntoDescriptor.bytesFilled - pullIntoDescriptor.bytesFilled % elementSize;
    var maxBytesToCopy = Math.min(controller._queueTotalSize, pullIntoDescriptor.byteLength - pullIntoDescriptor.bytesFilled);
    var maxBytesFilled = pullIntoDescriptor.bytesFilled + maxBytesToCopy;
    var maxAlignedBytes = maxBytesFilled - maxBytesFilled % elementSize;
    var totalBytesToCopyRemaining = maxBytesToCopy;
    var ready = false;

    if (maxAlignedBytes > currentAlignedBytes) {
      totalBytesToCopyRemaining = maxAlignedBytes - pullIntoDescriptor.bytesFilled;
      ready = true;
    }

    var queue = controller._queue;

    while (totalBytesToCopyRemaining > 0) {
      var headOfQueue = queue[0];
      var bytesToCopy = Math.min(totalBytesToCopyRemaining, headOfQueue.byteLength);
      var destStart = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
      ArrayBufferCopy(pullIntoDescriptor.buffer, destStart, headOfQueue.buffer, headOfQueue.byteOffset, bytesToCopy);

      if (headOfQueue.byteLength === bytesToCopy) {
        queue.shift();
      } else {
        headOfQueue.byteOffset += bytesToCopy;
        headOfQueue.byteLength -= bytesToCopy;
      }

      controller._queueTotalSize -= bytesToCopy;
      ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesToCopy, pullIntoDescriptor);
      totalBytesToCopyRemaining -= bytesToCopy;
    }

    if (ready === false) {
      assert(controller._queueTotalSize === 0, 'queue must be empty');
      assert(pullIntoDescriptor.bytesFilled > 0);
      assert(pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize);
    }

    return ready;
  }

  function ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, size, pullIntoDescriptor) {
    assert(controller._pendingPullIntos.length === 0 || controller._pendingPullIntos[0] === pullIntoDescriptor);
    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
    pullIntoDescriptor.bytesFilled += size;
  }

  function ReadableByteStreamControllerHandleQueueDrain(controller) {
    assert(controller._controlledReadableStream._state === 'readable');

    if (controller._queueTotalSize === 0 && controller._closeRequested === true) {
      ReadableStreamClose(controller._controlledReadableStream);
    } else {
      ReadableByteStreamControllerCallPullIfNeeded(controller);
    }
  }

  function ReadableByteStreamControllerInvalidateBYOBRequest(controller) {
    if (controller._byobRequest === undefined) {
      return;
    }

    controller._byobRequest._associatedReadableByteStreamController = undefined;
    controller._byobRequest._view = undefined;
    controller._byobRequest = undefined;
  }

  function ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller) {
    assert(controller._closeRequested === false);

    while (controller._pendingPullIntos.length > 0) {
      if (controller._queueTotalSize === 0) {
        return;
      }

      var pullIntoDescriptor = controller._pendingPullIntos[0];

      if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
        ReadableByteStreamControllerShiftPendingPullInto(controller);
        ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
      }
    }
  }

  function ReadableByteStreamControllerPullInto(controller, view) {
    var stream = controller._controlledReadableStream;
    var elementSize = 1;

    if (view.constructor !== DataView) {
      elementSize = view.constructor.BYTES_PER_ELEMENT;
    }

    var ctor = view.constructor;
    var pullIntoDescriptor = {
      buffer: view.buffer,
      byteOffset: view.byteOffset,
      byteLength: view.byteLength,
      bytesFilled: 0,
      elementSize: elementSize,
      ctor: ctor,
      readerType: 'byob'
    };

    if (controller._pendingPullIntos.length > 0) {
      pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);

      controller._pendingPullIntos.push(pullIntoDescriptor);

      return ReadableStreamAddReadIntoRequest(stream);
    }

    if (stream._state === 'closed') {
      var emptyView = new view.constructor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, 0);
      return Promise.resolve(CreateIterResultObject(emptyView, true));
    }

    if (controller._queueTotalSize > 0) {
      if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
        var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
        ReadableByteStreamControllerHandleQueueDrain(controller);
        return Promise.resolve(CreateIterResultObject(filledView, false));
      }

      if (controller._closeRequested === true) {
        var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
        ReadableByteStreamControllerError(controller, e);
        return Promise.reject(e);
      }
    }

    pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);

    controller._pendingPullIntos.push(pullIntoDescriptor);

    var promise = ReadableStreamAddReadIntoRequest(stream);
    ReadableByteStreamControllerCallPullIfNeeded(controller);
    return promise;
  }

  function ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor) {
    firstDescriptor.buffer = TransferArrayBuffer(firstDescriptor.buffer);
    assert(firstDescriptor.bytesFilled === 0, 'bytesFilled must be 0');
    var stream = controller._controlledReadableStream;

    if (ReadableStreamHasBYOBReader(stream) === true) {
      while (ReadableStreamGetNumReadIntoRequests(stream) > 0) {
        var pullIntoDescriptor = ReadableByteStreamControllerShiftPendingPullInto(controller);
        ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor);
      }
    }
  }

  function ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, pullIntoDescriptor) {
    if (pullIntoDescriptor.bytesFilled + bytesWritten > pullIntoDescriptor.byteLength) {
      throw new RangeError('bytesWritten out of range');
    }

    ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesWritten, pullIntoDescriptor);

    if (pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize) {
      return;
    }

    ReadableByteStreamControllerShiftPendingPullInto(controller);
    var remainderSize = pullIntoDescriptor.bytesFilled % pullIntoDescriptor.elementSize;

    if (remainderSize > 0) {
      var end = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
      var remainder = pullIntoDescriptor.buffer.slice(end - remainderSize, end);
      ReadableByteStreamControllerEnqueueChunkToQueue(controller, remainder, 0, remainder.byteLength);
    }

    pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
    pullIntoDescriptor.bytesFilled -= remainderSize;
    ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
    ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
  }

  function ReadableByteStreamControllerRespondInternal(controller, bytesWritten) {
    var firstDescriptor = controller._pendingPullIntos[0];
    var stream = controller._controlledReadableStream;

    if (stream._state === 'closed') {
      if (bytesWritten !== 0) {
        throw new TypeError('bytesWritten must be 0 when calling respond() on a closed stream');
      }

      ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor);
    } else {
      assert(stream._state === 'readable');
      ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, firstDescriptor);
    }
  }

  function ReadableByteStreamControllerShiftPendingPullInto(controller) {
    var descriptor = controller._pendingPullIntos.shift();

    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
    return descriptor;
  }

  function ReadableByteStreamControllerShouldCallPull(controller) {
    var stream = controller._controlledReadableStream;

    if (stream._state !== 'readable') {
      return false;
    }

    if (controller._closeRequested === true) {
      return false;
    }

    if (controller._started === false) {
      return false;
    }

    if (ReadableStreamHasDefaultReader(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
      return true;
    }

    if (ReadableStreamHasBYOBReader(stream) === true && ReadableStreamGetNumReadIntoRequests(stream) > 0) {
      return true;
    }

    if (ReadableByteStreamControllerGetDesiredSize(controller) > 0) {
      return true;
    }

    return false;
  }

  function ReadableByteStreamControllerClose(controller) {
    var stream = controller._controlledReadableStream;
    assert(controller._closeRequested === false);
    assert(stream._state === 'readable');

    if (controller._queueTotalSize > 0) {
      controller._closeRequested = true;
      return;
    }

    if (controller._pendingPullIntos.length > 0) {
      var firstPendingPullInto = controller._pendingPullIntos[0];

      if (firstPendingPullInto.bytesFilled > 0) {
        var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
        ReadableByteStreamControllerError(controller, e);
        throw e;
      }
    }

    ReadableStreamClose(stream);
  }

  function ReadableByteStreamControllerEnqueue(controller, chunk) {
    var stream = controller._controlledReadableStream;
    assert(controller._closeRequested === false);
    assert(stream._state === 'readable');
    var buffer = chunk.buffer;
    var byteOffset = chunk.byteOffset;
    var byteLength = chunk.byteLength;
    var transferredBuffer = TransferArrayBuffer(buffer);

    if (ReadableStreamHasDefaultReader(stream) === true) {
      if (ReadableStreamGetNumReadRequests(stream) === 0) {
        ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
      } else {
        assert(controller._queue.length === 0);
        var transferredView = new Uint8Array(transferredBuffer, byteOffset, byteLength);
        ReadableStreamFulfillReadRequest(stream, transferredView, false);
      }
    } else if (ReadableStreamHasBYOBReader(stream) === true) {
      ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
      ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
    } else {
      assert(IsReadableStreamLocked(stream) === false, 'stream must not be locked');
      ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
    }
  }

  function ReadableByteStreamControllerError(controller, e) {
    var stream = controller._controlledReadableStream;
    assert(stream._state === 'readable');
    ReadableByteStreamControllerClearPendingPullIntos(controller);
    ResetQueue(controller);
    ReadableStreamError(stream, e);
  }

  function ReadableByteStreamControllerGetDesiredSize(controller) {
    var stream = controller._controlledReadableStream;
    var state = stream._state;

    if (state === 'errored') {
      return null;
    }

    if (state === 'closed') {
      return 0;
    }

    return controller._strategyHWM - controller._queueTotalSize;
  }

  function ReadableByteStreamControllerRespond(controller, bytesWritten) {
    bytesWritten = Number(bytesWritten);

    if (IsFiniteNonNegativeNumber(bytesWritten) === false) {
      throw new RangeError('bytesWritten must be a finite');
    }

    assert(controller._pendingPullIntos.length > 0);
    ReadableByteStreamControllerRespondInternal(controller, bytesWritten);
  }

  function ReadableByteStreamControllerRespondWithNewView(controller, view) {
    assert(controller._pendingPullIntos.length > 0);
    var firstDescriptor = controller._pendingPullIntos[0];

    if (firstDescriptor.byteOffset + firstDescriptor.bytesFilled !== view.byteOffset) {
      throw new RangeError('The region specified by view does not match byobRequest');
    }

    if (firstDescriptor.byteLength !== view.byteLength) {
      throw new RangeError('The buffer of view has different capacity than byobRequest');
    }

    firstDescriptor.buffer = view.buffer;
    ReadableByteStreamControllerRespondInternal(controller, view.byteLength);
  }

  function streamBrandCheckException(name) {
    return new TypeError('ReadableStream.prototype.' + name + ' can only be used on a ReadableStream');
  }

  function readerLockException(name) {
    return new TypeError('Cannot ' + name + ' a stream using a released reader');
  }

  function defaultReaderBrandCheckException(name) {
    return new TypeError('ReadableStreamDefaultReader.prototype.' + name + ' can only be used on a ReadableStreamDefaultReader');
  }

  function defaultReaderClosedPromiseInitialize(reader) {
    reader._closedPromise = new Promise(function (resolve, reject) {
      reader._closedPromise_resolve = resolve;
      reader._closedPromise_reject = reject;
    });
  }

  function defaultReaderClosedPromiseInitializeAsRejected(reader, reason) {
    reader._closedPromise = Promise.reject(reason);
    reader._closedPromise_resolve = undefined;
    reader._closedPromise_reject = undefined;
  }

  function defaultReaderClosedPromiseInitializeAsResolved(reader) {
    reader._closedPromise = Promise.resolve(undefined);
    reader._closedPromise_resolve = undefined;
    reader._closedPromise_reject = undefined;
  }

  function defaultReaderClosedPromiseReject(reader, reason) {
    assert(reader._closedPromise_resolve !== undefined);
    assert(reader._closedPromise_reject !== undefined);

    reader._closedPromise_reject(reason);

    reader._closedPromise_resolve = undefined;
    reader._closedPromise_reject = undefined;
  }

  function defaultReaderClosedPromiseResetToRejected(reader, reason) {
    assert(reader._closedPromise_resolve === undefined);
    assert(reader._closedPromise_reject === undefined);
    reader._closedPromise = Promise.reject(reason);
  }

  function defaultReaderClosedPromiseResolve(reader) {
    assert(reader._closedPromise_resolve !== undefined);
    assert(reader._closedPromise_reject !== undefined);

    reader._closedPromise_resolve(undefined);

    reader._closedPromise_resolve = undefined;
    reader._closedPromise_reject = undefined;
  }

  function byobReaderBrandCheckException(name) {
    return new TypeError('ReadableStreamBYOBReader.prototype.' + name + ' can only be used on a ReadableStreamBYOBReader');
  }

  function defaultControllerBrandCheckException(name) {
    return new TypeError('ReadableStreamDefaultController.prototype.' + name + ' can only be used on a ReadableStreamDefaultController');
  }

  function byobRequestBrandCheckException(name) {
    return new TypeError('ReadableStreamBYOBRequest.prototype.' + name + ' can only be used on a ReadableStreamBYOBRequest');
  }

  function byteStreamControllerBrandCheckException(name) {
    return new TypeError('ReadableByteStreamController.prototype.' + name + ' can only be used on a ReadableByteStreamController');
  }

  function ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise) {
    try {
      Promise.prototype.then.call(promise, undefined, function () {});
    } catch (e) {}
  }
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var transformStream = __w_pdfjs_require__(6);

  var readableStream = __w_pdfjs_require__(4);

  var writableStream = __w_pdfjs_require__(2);

  exports.TransformStream = transformStream.TransformStream;
  exports.ReadableStream = readableStream.ReadableStream;
  exports.IsReadableStreamDisturbed = readableStream.IsReadableStreamDisturbed;
  exports.ReadableStreamDefaultControllerClose = readableStream.ReadableStreamDefaultControllerClose;
  exports.ReadableStreamDefaultControllerEnqueue = readableStream.ReadableStreamDefaultControllerEnqueue;
  exports.ReadableStreamDefaultControllerError = readableStream.ReadableStreamDefaultControllerError;
  exports.ReadableStreamDefaultControllerGetDesiredSize = readableStream.ReadableStreamDefaultControllerGetDesiredSize;
  exports.AcquireWritableStreamDefaultWriter = writableStream.AcquireWritableStreamDefaultWriter;
  exports.IsWritableStream = writableStream.IsWritableStream;
  exports.IsWritableStreamLocked = writableStream.IsWritableStreamLocked;
  exports.WritableStream = writableStream.WritableStream;
  exports.WritableStreamAbort = writableStream.WritableStreamAbort;
  exports.WritableStreamDefaultControllerError = writableStream.WritableStreamDefaultControllerError;
  exports.WritableStreamDefaultWriterCloseWithErrorPropagation = writableStream.WritableStreamDefaultWriterCloseWithErrorPropagation;
  exports.WritableStreamDefaultWriterRelease = writableStream.WritableStreamDefaultWriterRelease;
  exports.WritableStreamDefaultWriterWrite = writableStream.WritableStreamDefaultWriterWrite;
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _require = __w_pdfjs_require__(1),
      assert = _require.assert;

  var _require2 = __w_pdfjs_require__(0),
      InvokeOrNoop = _require2.InvokeOrNoop,
      PromiseInvokeOrPerformFallback = _require2.PromiseInvokeOrPerformFallback,
      PromiseInvokeOrNoop = _require2.PromiseInvokeOrNoop,
      typeIsObject = _require2.typeIsObject;

  var _require3 = __w_pdfjs_require__(4),
      ReadableStream = _require3.ReadableStream,
      ReadableStreamDefaultControllerClose = _require3.ReadableStreamDefaultControllerClose,
      ReadableStreamDefaultControllerEnqueue = _require3.ReadableStreamDefaultControllerEnqueue,
      ReadableStreamDefaultControllerError = _require3.ReadableStreamDefaultControllerError,
      ReadableStreamDefaultControllerGetDesiredSize = _require3.ReadableStreamDefaultControllerGetDesiredSize;

  var _require4 = __w_pdfjs_require__(2),
      WritableStream = _require4.WritableStream,
      WritableStreamDefaultControllerError = _require4.WritableStreamDefaultControllerError;

  function TransformStreamCloseReadable(transformStream) {
    if (transformStream._errored === true) {
      throw new TypeError('TransformStream is already errored');
    }

    if (transformStream._readableClosed === true) {
      throw new TypeError('Readable side is already closed');
    }

    TransformStreamCloseReadableInternal(transformStream);
  }

  function TransformStreamEnqueueToReadable(transformStream, chunk) {
    if (transformStream._errored === true) {
      throw new TypeError('TransformStream is already errored');
    }

    if (transformStream._readableClosed === true) {
      throw new TypeError('Readable side is already closed');
    }

    var controller = transformStream._readableController;

    try {
      ReadableStreamDefaultControllerEnqueue(controller, chunk);
    } catch (e) {
      transformStream._readableClosed = true;
      TransformStreamErrorIfNeeded(transformStream, e);
      throw transformStream._storedError;
    }

    var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
    var maybeBackpressure = desiredSize <= 0;

    if (maybeBackpressure === true && transformStream._backpressure === false) {
      TransformStreamSetBackpressure(transformStream, true);
    }
  }

  function TransformStreamError(transformStream, e) {
    if (transformStream._errored === true) {
      throw new TypeError('TransformStream is already errored');
    }

    TransformStreamErrorInternal(transformStream, e);
  }

  function TransformStreamCloseReadableInternal(transformStream) {
    assert(transformStream._errored === false);
    assert(transformStream._readableClosed === false);

    try {
      ReadableStreamDefaultControllerClose(transformStream._readableController);
    } catch (e) {
      assert(false);
    }

    transformStream._readableClosed = true;
  }

  function TransformStreamErrorIfNeeded(transformStream, e) {
    if (transformStream._errored === false) {
      TransformStreamErrorInternal(transformStream, e);
    }
  }

  function TransformStreamErrorInternal(transformStream, e) {
    assert(transformStream._errored === false);
    transformStream._errored = true;
    transformStream._storedError = e;

    if (transformStream._writableDone === false) {
      WritableStreamDefaultControllerError(transformStream._writableController, e);
    }

    if (transformStream._readableClosed === false) {
      ReadableStreamDefaultControllerError(transformStream._readableController, e);
    }
  }

  function TransformStreamReadableReadyPromise(transformStream) {
    assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');

    if (transformStream._backpressure === false) {
      return Promise.resolve();
    }

    assert(transformStream._backpressure === true, '_backpressure should have been initialized');
    return transformStream._backpressureChangePromise;
  }

  function TransformStreamSetBackpressure(transformStream, backpressure) {
    assert(transformStream._backpressure !== backpressure, 'TransformStreamSetBackpressure() should be called only when backpressure is changed');

    if (transformStream._backpressureChangePromise !== undefined) {
      transformStream._backpressureChangePromise_resolve(backpressure);
    }

    transformStream._backpressureChangePromise = new Promise(function (resolve) {
      transformStream._backpressureChangePromise_resolve = resolve;
    });

    transformStream._backpressureChangePromise.then(function (resolution) {
      assert(resolution !== backpressure, '_backpressureChangePromise should be fulfilled only when backpressure is changed');
    });

    transformStream._backpressure = backpressure;
  }

  function TransformStreamDefaultTransform(chunk, transformStreamController) {
    var transformStream = transformStreamController._controlledTransformStream;
    TransformStreamEnqueueToReadable(transformStream, chunk);
    return Promise.resolve();
  }

  function TransformStreamTransform(transformStream, chunk) {
    assert(transformStream._errored === false);
    assert(transformStream._transforming === false);
    assert(transformStream._backpressure === false);
    transformStream._transforming = true;
    var transformer = transformStream._transformer;
    var controller = transformStream._transformStreamController;
    var transformPromise = PromiseInvokeOrPerformFallback(transformer, 'transform', [chunk, controller], TransformStreamDefaultTransform, [chunk, controller]);
    return transformPromise.then(function () {
      transformStream._transforming = false;
      return TransformStreamReadableReadyPromise(transformStream);
    }, function (e) {
      TransformStreamErrorIfNeeded(transformStream, e);
      return Promise.reject(e);
    });
  }

  function IsTransformStreamDefaultController(x) {
    if (!typeIsObject(x)) {
      return false;
    }

    if (!Object.prototype.hasOwnProperty.call(x, '_controlledTransformStream')) {
      return false;
    }

    return true;
  }

  function IsTransformStream(x) {
    if (!typeIsObject(x)) {
      return false;
    }

    if (!Object.prototype.hasOwnProperty.call(x, '_transformStreamController')) {
      return false;
    }

    return true;
  }

  var TransformStreamSink = function () {
    function TransformStreamSink(transformStream, startPromise) {
      _classCallCheck(this, TransformStreamSink);

      this._transformStream = transformStream;
      this._startPromise = startPromise;
    }

    _createClass(TransformStreamSink, [{
      key: 'start',
      value: function start(c) {
        var transformStream = this._transformStream;
        transformStream._writableController = c;
        return this._startPromise.then(function () {
          return TransformStreamReadableReadyPromise(transformStream);
        });
      }
    }, {
      key: 'write',
      value: function write(chunk) {
        var transformStream = this._transformStream;
        return TransformStreamTransform(transformStream, chunk);
      }
    }, {
      key: 'abort',
      value: function abort() {
        var transformStream = this._transformStream;
        transformStream._writableDone = true;
        TransformStreamErrorInternal(transformStream, new TypeError('Writable side aborted'));
      }
    }, {
      key: 'close',
      value: function close() {
        var transformStream = this._transformStream;
        assert(transformStream._transforming === false);
        transformStream._writableDone = true;
        var flushPromise = PromiseInvokeOrNoop(transformStream._transformer, 'flush', [transformStream._transformStreamController]);
        return flushPromise.then(function () {
          if (transformStream._errored === true) {
            return Promise.reject(transformStream._storedError);
          }

          if (transformStream._readableClosed === false) {
            TransformStreamCloseReadableInternal(transformStream);
          }

          return Promise.resolve();
        })["catch"](function (r) {
          TransformStreamErrorIfNeeded(transformStream, r);
          return Promise.reject(transformStream._storedError);
        });
      }
    }]);

    return TransformStreamSink;
  }();

  var TransformStreamSource = function () {
    function TransformStreamSource(transformStream, startPromise) {
      _classCallCheck(this, TransformStreamSource);

      this._transformStream = transformStream;
      this._startPromise = startPromise;
    }

    _createClass(TransformStreamSource, [{
      key: 'start',
      value: function start(c) {
        var transformStream = this._transformStream;
        transformStream._readableController = c;
        return this._startPromise.then(function () {
          assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');

          if (transformStream._backpressure === true) {
            return Promise.resolve();
          }

          assert(transformStream._backpressure === false, '_backpressure should have been initialized');
          return transformStream._backpressureChangePromise;
        });
      }
    }, {
      key: 'pull',
      value: function pull() {
        var transformStream = this._transformStream;
        assert(transformStream._backpressure === true, 'pull() should be never called while _backpressure is false');
        assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
        TransformStreamSetBackpressure(transformStream, false);
        return transformStream._backpressureChangePromise;
      }
    }, {
      key: 'cancel',
      value: function cancel() {
        var transformStream = this._transformStream;
        transformStream._readableClosed = true;
        TransformStreamErrorInternal(transformStream, new TypeError('Readable side canceled'));
      }
    }]);

    return TransformStreamSource;
  }();

  var TransformStreamDefaultController = function () {
    function TransformStreamDefaultController(transformStream) {
      _classCallCheck(this, TransformStreamDefaultController);

      if (IsTransformStream(transformStream) === false) {
        throw new TypeError('TransformStreamDefaultController can only be ' + 'constructed with a TransformStream instance');
      }

      if (transformStream._transformStreamController !== undefined) {
        throw new TypeError('TransformStreamDefaultController instances can ' + 'only be created by the TransformStream constructor');
      }

      this._controlledTransformStream = transformStream;
    }

    _createClass(TransformStreamDefaultController, [{
      key: 'enqueue',
      value: function enqueue(chunk) {
        if (IsTransformStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('enqueue');
        }

        TransformStreamEnqueueToReadable(this._controlledTransformStream, chunk);
      }
    }, {
      key: 'close',
      value: function close() {
        if (IsTransformStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('close');
        }

        TransformStreamCloseReadable(this._controlledTransformStream);
      }
    }, {
      key: 'error',
      value: function error(reason) {
        if (IsTransformStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('error');
        }

        TransformStreamError(this._controlledTransformStream, reason);
      }
    }, {
      key: 'desiredSize',
      get: function get() {
        if (IsTransformStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('desiredSize');
        }

        var transformStream = this._controlledTransformStream;
        var readableController = transformStream._readableController;
        return ReadableStreamDefaultControllerGetDesiredSize(readableController);
      }
    }]);

    return TransformStreamDefaultController;
  }();

  var TransformStream = function () {
    function TransformStream() {
      var transformer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, TransformStream);

      this._transformer = transformer;
      var readableStrategy = transformer.readableStrategy,
          writableStrategy = transformer.writableStrategy;
      this._transforming = false;
      this._errored = false;
      this._storedError = undefined;
      this._writableController = undefined;
      this._readableController = undefined;
      this._transformStreamController = undefined;
      this._writableDone = false;
      this._readableClosed = false;
      this._backpressure = undefined;
      this._backpressureChangePromise = undefined;
      this._backpressureChangePromise_resolve = undefined;
      this._transformStreamController = new TransformStreamDefaultController(this);
      var startPromise_resolve = void 0;
      var startPromise = new Promise(function (resolve) {
        startPromise_resolve = resolve;
      });
      var source = new TransformStreamSource(this, startPromise);
      this._readable = new ReadableStream(source, readableStrategy);
      var sink = new TransformStreamSink(this, startPromise);
      this._writable = new WritableStream(sink, writableStrategy);
      assert(this._writableController !== undefined);
      assert(this._readableController !== undefined);
      var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(this._readableController);
      TransformStreamSetBackpressure(this, desiredSize <= 0);
      var transformStream = this;
      var startResult = InvokeOrNoop(transformer, 'start', [transformStream._transformStreamController]);
      startPromise_resolve(startResult);
      startPromise["catch"](function (e) {
        if (transformStream._errored === false) {
          transformStream._errored = true;
          transformStream._storedError = e;
        }
      });
    }

    _createClass(TransformStream, [{
      key: 'readable',
      get: function get() {
        if (IsTransformStream(this) === false) {
          throw streamBrandCheckException('readable');
        }

        return this._readable;
      }
    }, {
      key: 'writable',
      get: function get() {
        if (IsTransformStream(this) === false) {
          throw streamBrandCheckException('writable');
        }

        return this._writable;
      }
    }]);

    return TransformStream;
  }();

  module.exports = {
    TransformStream: TransformStream
  };

  function defaultControllerBrandCheckException(name) {
    return new TypeError('TransformStreamDefaultController.prototype.' + name + ' can only be used on a TransformStreamDefaultController');
  }

  function streamBrandCheckException(name) {
    return new TypeError('TransformStream.prototype.' + name + ' can only be used on a TransformStream');
  }
}, function (module, exports, __w_pdfjs_require__) {
  module.exports = __w_pdfjs_require__(5);
}]));

/***/ }),
/* 145 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

{
  var isURLSupported = false;

  try {
    if (typeof URL === 'function' && _typeof(URL.prototype) === 'object' && 'origin' in URL.prototype) {
      var u = new URL('b', 'http://a');
      u.pathname = 'c%20d';
      isURLSupported = u.href === 'http://a/c%20d';
    }
  } catch (ex) {}

  if (isURLSupported) {
    exports.URL = URL;
  } else {
    var PolyfillURL = __w_pdfjs_require__(146).URL;

    var OriginalURL = __w_pdfjs_require__(3).URL;

    if (OriginalURL) {
      PolyfillURL.createObjectURL = function (blob) {
        return OriginalURL.createObjectURL.apply(OriginalURL, arguments);
      };

      PolyfillURL.revokeObjectURL = function (url) {
        OriginalURL.revokeObjectURL(url);
      };
    }

    exports.URL = PolyfillURL;
  }
}

/***/ }),
/* 146 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


(function URLConstructorClosure() {
  'use strict';

  var relative = Object.create(null);
  relative['ftp'] = 21;
  relative['file'] = 0;
  relative['gopher'] = 70;
  relative['http'] = 80;
  relative['https'] = 443;
  relative['ws'] = 80;
  relative['wss'] = 443;
  var relativePathDotMapping = Object.create(null);
  relativePathDotMapping['%2e'] = '.';
  relativePathDotMapping['.%2e'] = '..';
  relativePathDotMapping['%2e.'] = '..';
  relativePathDotMapping['%2e%2e'] = '..';

  function isRelativeScheme(scheme) {
    return relative[scheme] !== undefined;
  }

  function invalid() {
    clear.call(this);
    this._isInvalid = true;
  }

  function IDNAToASCII(h) {
    if (h === '') {
      invalid.call(this);
    }

    return h.toLowerCase();
  }

  function percentEscape(c) {
    var unicode = c.charCodeAt(0);

    if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x3F, 0x60].indexOf(unicode) === -1) {
      return c;
    }

    return encodeURIComponent(c);
  }

  function percentEscapeQuery(c) {
    var unicode = c.charCodeAt(0);

    if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x60].indexOf(unicode) === -1) {
      return c;
    }

    return encodeURIComponent(c);
  }

  var EOF,
      ALPHA = /[a-zA-Z]/,
      ALPHANUMERIC = /[a-zA-Z0-9\+\-\.]/;

  function parse(input, stateOverride, base) {
    function err(message) {
      errors.push(message);
    }

    var state = stateOverride || 'scheme start',
        cursor = 0,
        buffer = '',
        seenAt = false,
        seenBracket = false,
        errors = [];

    loop: while ((input[cursor - 1] !== EOF || cursor === 0) && !this._isInvalid) {
      var c = input[cursor];

      switch (state) {
        case 'scheme start':
          if (c && ALPHA.test(c)) {
            buffer += c.toLowerCase();
            state = 'scheme';
          } else if (!stateOverride) {
            buffer = '';
            state = 'no scheme';
            continue;
          } else {
            err('Invalid scheme.');
            break loop;
          }

          break;

        case 'scheme':
          if (c && ALPHANUMERIC.test(c)) {
            buffer += c.toLowerCase();
          } else if (c === ':') {
            this._scheme = buffer;
            buffer = '';

            if (stateOverride) {
              break loop;
            }

            if (isRelativeScheme(this._scheme)) {
              this._isRelative = true;
            }

            if (this._scheme === 'file') {
              state = 'relative';
            } else if (this._isRelative && base && base._scheme === this._scheme) {
              state = 'relative or authority';
            } else if (this._isRelative) {
              state = 'authority first slash';
            } else {
              state = 'scheme data';
            }
          } else if (!stateOverride) {
            buffer = '';
            cursor = 0;
            state = 'no scheme';
            continue;
          } else if (c === EOF) {
            break loop;
          } else {
            err('Code point not allowed in scheme: ' + c);
            break loop;
          }

          break;

        case 'scheme data':
          if (c === '?') {
            this._query = '?';
            state = 'query';
          } else if (c === '#') {
            this._fragment = '#';
            state = 'fragment';
          } else {
            if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
              this._schemeData += percentEscape(c);
            }
          }

          break;

        case 'no scheme':
          if (!base || !isRelativeScheme(base._scheme)) {
            err('Missing scheme.');
            invalid.call(this);
          } else {
            state = 'relative';
            continue;
          }

          break;

        case 'relative or authority':
          if (c === '/' && input[cursor + 1] === '/') {
            state = 'authority ignore slashes';
          } else {
            err('Expected /, got: ' + c);
            state = 'relative';
            continue;
          }

          break;

        case 'relative':
          this._isRelative = true;

          if (this._scheme !== 'file') {
            this._scheme = base._scheme;
          }

          if (c === EOF) {
            this._host = base._host;
            this._port = base._port;
            this._path = base._path.slice();
            this._query = base._query;
            this._username = base._username;
            this._password = base._password;
            break loop;
          } else if (c === '/' || c === '\\') {
            if (c === '\\') {
              err('\\ is an invalid code point.');
            }

            state = 'relative slash';
          } else if (c === '?') {
            this._host = base._host;
            this._port = base._port;
            this._path = base._path.slice();
            this._query = '?';
            this._username = base._username;
            this._password = base._password;
            state = 'query';
          } else if (c === '#') {
            this._host = base._host;
            this._port = base._port;
            this._path = base._path.slice();
            this._query = base._query;
            this._fragment = '#';
            this._username = base._username;
            this._password = base._password;
            state = 'fragment';
          } else {
            var nextC = input[cursor + 1];
            var nextNextC = input[cursor + 2];

            if (this._scheme !== 'file' || !ALPHA.test(c) || nextC !== ':' && nextC !== '|' || nextNextC !== EOF && nextNextC !== '/' && nextNextC !== '\\' && nextNextC !== '?' && nextNextC !== '#') {
              this._host = base._host;
              this._port = base._port;
              this._username = base._username;
              this._password = base._password;
              this._path = base._path.slice();

              this._path.pop();
            }

            state = 'relative path';
            continue;
          }

          break;

        case 'relative slash':
          if (c === '/' || c === '\\') {
            if (c === '\\') {
              err('\\ is an invalid code point.');
            }

            if (this._scheme === 'file') {
              state = 'file host';
            } else {
              state = 'authority ignore slashes';
            }
          } else {
            if (this._scheme !== 'file') {
              this._host = base._host;
              this._port = base._port;
              this._username = base._username;
              this._password = base._password;
            }

            state = 'relative path';
            continue;
          }

          break;

        case 'authority first slash':
          if (c === '/') {
            state = 'authority second slash';
          } else {
            err('Expected \'/\', got: ' + c);
            state = 'authority ignore slashes';
            continue;
          }

          break;

        case 'authority second slash':
          state = 'authority ignore slashes';

          if (c !== '/') {
            err('Expected \'/\', got: ' + c);
            continue;
          }

          break;

        case 'authority ignore slashes':
          if (c !== '/' && c !== '\\') {
            state = 'authority';
            continue;
          } else {
            err('Expected authority, got: ' + c);
          }

          break;

        case 'authority':
          if (c === '@') {
            if (seenAt) {
              err('@ already seen.');
              buffer += '%40';
            }

            seenAt = true;

            for (var i = 0; i < buffer.length; i++) {
              var cp = buffer[i];

              if (cp === '\t' || cp === '\n' || cp === '\r') {
                err('Invalid whitespace in authority.');
                continue;
              }

              if (cp === ':' && this._password === null) {
                this._password = '';
                continue;
              }

              var tempC = percentEscape(cp);

              if (this._password !== null) {
                this._password += tempC;
              } else {
                this._username += tempC;
              }
            }

            buffer = '';
          } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
            cursor -= buffer.length;
            buffer = '';
            state = 'host';
            continue;
          } else {
            buffer += c;
          }

          break;

        case 'file host':
          if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
            if (buffer.length === 2 && ALPHA.test(buffer[0]) && (buffer[1] === ':' || buffer[1] === '|')) {
              state = 'relative path';
            } else if (buffer.length === 0) {
              state = 'relative path start';
            } else {
              this._host = IDNAToASCII.call(this, buffer);
              buffer = '';
              state = 'relative path start';
            }

            continue;
          } else if (c === '\t' || c === '\n' || c === '\r') {
            err('Invalid whitespace in file host.');
          } else {
            buffer += c;
          }

          break;

        case 'host':
        case 'hostname':
          if (c === ':' && !seenBracket) {
            this._host = IDNAToASCII.call(this, buffer);
            buffer = '';
            state = 'port';

            if (stateOverride === 'hostname') {
              break loop;
            }
          } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
            this._host = IDNAToASCII.call(this, buffer);
            buffer = '';
            state = 'relative path start';

            if (stateOverride) {
              break loop;
            }

            continue;
          } else if (c !== '\t' && c !== '\n' && c !== '\r') {
            if (c === '[') {
              seenBracket = true;
            } else if (c === ']') {
              seenBracket = false;
            }

            buffer += c;
          } else {
            err('Invalid code point in host/hostname: ' + c);
          }

          break;

        case 'port':
          if (/[0-9]/.test(c)) {
            buffer += c;
          } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#' || stateOverride) {
            if (buffer !== '') {
              var temp = parseInt(buffer, 10);

              if (temp !== relative[this._scheme]) {
                this._port = temp + '';
              }

              buffer = '';
            }

            if (stateOverride) {
              break loop;
            }

            state = 'relative path start';
            continue;
          } else if (c === '\t' || c === '\n' || c === '\r') {
            err('Invalid code point in port: ' + c);
          } else {
            invalid.call(this);
          }

          break;

        case 'relative path start':
          if (c === '\\') {
            err('\'\\\' not allowed in path.');
          }

          state = 'relative path';

          if (c !== '/' && c !== '\\') {
            continue;
          }

          break;

        case 'relative path':
          if (c === EOF || c === '/' || c === '\\' || !stateOverride && (c === '?' || c === '#')) {
            if (c === '\\') {
              err('\\ not allowed in relative path.');
            }

            var tmp;

            if (tmp = relativePathDotMapping[buffer.toLowerCase()]) {
              buffer = tmp;
            }

            if (buffer === '..') {
              this._path.pop();

              if (c !== '/' && c !== '\\') {
                this._path.push('');
              }
            } else if (buffer === '.' && c !== '/' && c !== '\\') {
              this._path.push('');
            } else if (buffer !== '.') {
              if (this._scheme === 'file' && this._path.length === 0 && buffer.length === 2 && ALPHA.test(buffer[0]) && buffer[1] === '|') {
                buffer = buffer[0] + ':';
              }

              this._path.push(buffer);
            }

            buffer = '';

            if (c === '?') {
              this._query = '?';
              state = 'query';
            } else if (c === '#') {
              this._fragment = '#';
              state = 'fragment';
            }
          } else if (c !== '\t' && c !== '\n' && c !== '\r') {
            buffer += percentEscape(c);
          }

          break;

        case 'query':
          if (!stateOverride && c === '#') {
            this._fragment = '#';
            state = 'fragment';
          } else if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
            this._query += percentEscapeQuery(c);
          }

          break;

        case 'fragment':
          if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
            this._fragment += c;
          }

          break;
      }

      cursor++;
    }
  }

  function clear() {
    this._scheme = '';
    this._schemeData = '';
    this._username = '';
    this._password = null;
    this._host = '';
    this._port = '';
    this._path = [];
    this._query = '';
    this._fragment = '';
    this._isInvalid = false;
    this._isRelative = false;
  }

  function JURL(url, base) {
    if (base !== undefined && !(base instanceof JURL)) {
      base = new JURL(String(base));
    }

    this._url = url;
    clear.call(this);
    var input = url.replace(/^[ \t\r\n\f]+|[ \t\r\n\f]+$/g, '');
    parse.call(this, input, null, base);
  }

  JURL.prototype = {
    toString: function toString() {
      return this.href;
    },

    get href() {
      if (this._isInvalid) {
        return this._url;
      }

      var authority = '';

      if (this._username !== '' || this._password !== null) {
        authority = this._username + (this._password !== null ? ':' + this._password : '') + '@';
      }

      return this.protocol + (this._isRelative ? '//' + authority + this.host : '') + this.pathname + this._query + this._fragment;
    },

    set href(value) {
      clear.call(this);
      parse.call(this, value);
    },

    get protocol() {
      return this._scheme + ':';
    },

    set protocol(value) {
      if (this._isInvalid) {
        return;
      }

      parse.call(this, value + ':', 'scheme start');
    },

    get host() {
      return this._isInvalid ? '' : this._port ? this._host + ':' + this._port : this._host;
    },

    set host(value) {
      if (this._isInvalid || !this._isRelative) {
        return;
      }

      parse.call(this, value, 'host');
    },

    get hostname() {
      return this._host;
    },

    set hostname(value) {
      if (this._isInvalid || !this._isRelative) {
        return;
      }

      parse.call(this, value, 'hostname');
    },

    get port() {
      return this._port;
    },

    set port(value) {
      if (this._isInvalid || !this._isRelative) {
        return;
      }

      parse.call(this, value, 'port');
    },

    get pathname() {
      return this._isInvalid ? '' : this._isRelative ? '/' + this._path.join('/') : this._schemeData;
    },

    set pathname(value) {
      if (this._isInvalid || !this._isRelative) {
        return;
      }

      this._path = [];
      parse.call(this, value, 'relative path start');
    },

    get search() {
      return this._isInvalid || !this._query || this._query === '?' ? '' : this._query;
    },

    set search(value) {
      if (this._isInvalid || !this._isRelative) {
        return;
      }

      this._query = '?';

      if (value[0] === '?') {
        value = value.slice(1);
      }

      parse.call(this, value, 'query');
    },

    get hash() {
      return this._isInvalid || !this._fragment || this._fragment === '#' ? '' : this._fragment;
    },

    set hash(value) {
      if (this._isInvalid) {
        return;
      }

      this._fragment = '#';

      if (value[0] === '#') {
        value = value.slice(1);
      }

      parse.call(this, value, 'fragment');
    },

    get origin() {
      var host;

      if (this._isInvalid || !this._scheme) {
        return '';
      }

      switch (this._scheme) {
        case 'data':
        case 'file':
        case 'javascript':
        case 'mailto':
          return 'null';

        case 'blob':
          try {
            return new JURL(this._schemeData).origin || 'null';
          } catch (_) {}

          return 'null';
      }

      host = this.host;

      if (!host) {
        return '';
      }

      return this._scheme + '://' + host;
    }

  };
  exports.URL = JURL;
})();

/***/ }),
/* 147 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDocument = getDocument;
exports.setPDFNetworkStreamFactory = setPDFNetworkStreamFactory;
exports.build = exports.version = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFWorker = exports.PDFDataRangeTransport = exports.LoopbackPort = void 0;

var _regenerator = _interopRequireDefault(__w_pdfjs_require__(148));

var _util = __w_pdfjs_require__(1);

var _display_utils = __w_pdfjs_require__(151);

var _font_loader = __w_pdfjs_require__(152);

var _api_compatibility = __w_pdfjs_require__(153);

var _canvas = __w_pdfjs_require__(154);

var _global_scope = _interopRequireDefault(__w_pdfjs_require__(3));

var _worker_options = __w_pdfjs_require__(156);

var _message_handler = __w_pdfjs_require__(157);

var _metadata = __w_pdfjs_require__(158);

var _transport_stream = __w_pdfjs_require__(160);

var _webgl = __w_pdfjs_require__(161);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var DEFAULT_RANGE_CHUNK_SIZE = 65536;
var isWorkerDisabled = false;
var fallbackWorkerSrc;
var fakeWorkerFilesLoader = null;
{
  var useRequireEnsure = false;

  if (typeof window === 'undefined') {
    isWorkerDisabled = true;

    if (false) {
      require.ensure = require('node-ensure');
    }

    useRequireEnsure = true;
  } else if (true) {
    useRequireEnsure = true;
  }

  if (typeof requirejs !== 'undefined' && requirejs.toUrl) {
    fallbackWorkerSrc = requirejs.toUrl('pdfjs-dist/build/pdf.worker.js');
  }

  var dynamicLoaderSupported = typeof requirejs !== 'undefined' && requirejs.load;
  fakeWorkerFilesLoader = useRequireEnsure ? function () {
    return new Promise(function (resolve, reject) {
      __webpack_require__.e/* require.ensure */(0).then((function () {
        try {
          var worker;
          worker = __webpack_require__(1028);
          resolve(worker.WorkerMessageHandler);
        } catch (ex) {
          reject(ex);
        }
      }).bind(null, __webpack_require__)).catch(reject);
    });
  } : dynamicLoaderSupported ? function () {
    return new Promise(function (resolve, reject) {
      requirejs(['pdfjs-dist/build/pdf.worker'], function (worker) {
        try {
          resolve(worker.WorkerMessageHandler);
        } catch (ex) {
          reject(ex);
        }
      }, reject);
    });
  } : null;

  if (!fallbackWorkerSrc && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && 'currentScript' in document) {
    var pdfjsFilePath = document.currentScript && document.currentScript.src;

    if (pdfjsFilePath) {
      fallbackWorkerSrc = pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, '.worker$1$2');
    }
  }
}
var createPDFNetworkStream;

function setPDFNetworkStreamFactory(pdfNetworkStreamFactory) {
  createPDFNetworkStream = pdfNetworkStreamFactory;
}

function getDocument(src) {
  var task = new PDFDocumentLoadingTask();
  var source;

  if (typeof src === 'string') {
    source = {
      url: src
    };
  } else if ((0, _util.isArrayBuffer)(src)) {
    source = {
      data: src
    };
  } else if (src instanceof PDFDataRangeTransport) {
    source = {
      range: src
    };
  } else {
    if (_typeof(src) !== 'object') {
      throw new Error('Invalid parameter in getDocument, ' + 'need either Uint8Array, string or a parameter object');
    }

    if (!src.url && !src.data && !src.range) {
      throw new Error('Invalid parameter object: need either .data, .range or .url');
    }

    source = src;
  }

  var params = Object.create(null);
  var rangeTransport = null,
      worker = null;

  for (var key in source) {
    if (key === 'url' && typeof window !== 'undefined') {
      params[key] = new _util.URL(source[key], window.location).href;
      continue;
    } else if (key === 'range') {
      rangeTransport = source[key];
      continue;
    } else if (key === 'worker') {
      worker = source[key];
      continue;
    } else if (key === 'data' && !(source[key] instanceof Uint8Array)) {
      var pdfBytes = source[key];

      if (typeof pdfBytes === 'string') {
        params[key] = (0, _util.stringToBytes)(pdfBytes);
      } else if (_typeof(pdfBytes) === 'object' && pdfBytes !== null && !isNaN(pdfBytes.length)) {
        params[key] = new Uint8Array(pdfBytes);
      } else if ((0, _util.isArrayBuffer)(pdfBytes)) {
        params[key] = new Uint8Array(pdfBytes);
      } else {
        throw new Error('Invalid PDF binary data: either typed array, ' + 'string or array-like object is expected in the ' + 'data property.');
      }

      continue;
    }

    params[key] = source[key];
  }

  params.rangeChunkSize = params.rangeChunkSize || DEFAULT_RANGE_CHUNK_SIZE;
  params.CMapReaderFactory = params.CMapReaderFactory || _display_utils.DOMCMapReaderFactory;
  params.ignoreErrors = params.stopAtErrors !== true;
  params.pdfBug = params.pdfBug === true;
  var NativeImageDecoderValues = Object.values(_util.NativeImageDecoding);

  if (params.nativeImageDecoderSupport === undefined || !NativeImageDecoderValues.includes(params.nativeImageDecoderSupport)) {
    params.nativeImageDecoderSupport = _api_compatibility.apiCompatibilityParams.nativeImageDecoderSupport || _util.NativeImageDecoding.DECODE;
  }

  if (!Number.isInteger(params.maxImageSize)) {
    params.maxImageSize = -1;
  }

  if (typeof params.isEvalSupported !== 'boolean') {
    params.isEvalSupported = true;
  }

  if (typeof params.disableFontFace !== 'boolean') {
    params.disableFontFace = _api_compatibility.apiCompatibilityParams.disableFontFace || false;
  }

  if (typeof params.disableRange !== 'boolean') {
    params.disableRange = false;
  }

  if (typeof params.disableStream !== 'boolean') {
    params.disableStream = false;
  }

  if (typeof params.disableAutoFetch !== 'boolean') {
    params.disableAutoFetch = false;
  }

  if (typeof params.disableCreateObjectURL !== 'boolean') {
    params.disableCreateObjectURL = _api_compatibility.apiCompatibilityParams.disableCreateObjectURL || false;
  }

  (0, _util.setVerbosityLevel)(params.verbosity);

  if (!worker) {
    var workerParams = {
      postMessageTransfers: params.postMessageTransfers,
      verbosity: params.verbosity,
      port: _worker_options.GlobalWorkerOptions.workerPort
    };
    worker = workerParams.port ? PDFWorker.fromPort(workerParams) : new PDFWorker(workerParams);
    task._worker = worker;
  }

  var docId = task.docId;
  worker.promise.then(function () {
    if (task.destroyed) {
      throw new Error('Loading aborted');
    }

    return _fetchDocument(worker, params, rangeTransport, docId).then(function (workerId) {
      if (task.destroyed) {
        throw new Error('Loading aborted');
      }

      var networkStream;

      if (rangeTransport) {
        networkStream = new _transport_stream.PDFDataTransportStream({
          length: params.length,
          initialData: params.initialData,
          progressiveDone: params.progressiveDone,
          disableRange: params.disableRange,
          disableStream: params.disableStream
        }, rangeTransport);
      } else if (!params.data) {
        networkStream = createPDFNetworkStream({
          url: params.url,
          length: params.length,
          httpHeaders: params.httpHeaders,
          withCredentials: params.withCredentials,
          rangeChunkSize: params.rangeChunkSize,
          disableRange: params.disableRange,
          disableStream: params.disableStream
        });
      }

      var messageHandler = new _message_handler.MessageHandler(docId, workerId, worker.port);
      messageHandler.postMessageTransfers = worker.postMessageTransfers;
      var transport = new WorkerTransport(messageHandler, task, networkStream, params);
      task._transport = transport;
      messageHandler.send('Ready', null);
    });
  })["catch"](task._capability.reject);
  return task;
}

function _fetchDocument(worker, source, pdfDataRangeTransport, docId) {
  if (worker.destroyed) {
    return Promise.reject(new Error('Worker was destroyed'));
  }

  if (pdfDataRangeTransport) {
    source.length = pdfDataRangeTransport.length;
    source.initialData = pdfDataRangeTransport.initialData;
    source.progressiveDone = pdfDataRangeTransport.progressiveDone;
  }

  return worker.messageHandler.sendWithPromise('GetDocRequest', {
    docId: docId,
    apiVersion: '2.2.228',
    source: {
      data: source.data,
      url: source.url,
      password: source.password,
      disableAutoFetch: source.disableAutoFetch,
      rangeChunkSize: source.rangeChunkSize,
      length: source.length
    },
    maxImageSize: source.maxImageSize,
    disableFontFace: source.disableFontFace,
    disableCreateObjectURL: source.disableCreateObjectURL,
    postMessageTransfers: worker.postMessageTransfers,
    docBaseUrl: source.docBaseUrl,
    nativeImageDecoderSupport: source.nativeImageDecoderSupport,
    ignoreErrors: source.ignoreErrors,
    isEvalSupported: source.isEvalSupported
  }).then(function (workerId) {
    if (worker.destroyed) {
      throw new Error('Worker was destroyed');
    }

    return workerId;
  });
}

var PDFDocumentLoadingTask = function PDFDocumentLoadingTaskClosure() {
  var nextDocumentId = 0;

  var PDFDocumentLoadingTask =
  /*#__PURE__*/
  function () {
    function PDFDocumentLoadingTask() {
      _classCallCheck(this, PDFDocumentLoadingTask);

      this._capability = (0, _util.createPromiseCapability)();
      this._transport = null;
      this._worker = null;
      this.docId = 'd' + nextDocumentId++;
      this.destroyed = false;
      this.onPassword = null;
      this.onProgress = null;
      this.onUnsupportedFeature = null;
    }

    _createClass(PDFDocumentLoadingTask, [{
      key: "destroy",
      value: function destroy() {
        var _this = this;

        this.destroyed = true;
        var transportDestroyed = !this._transport ? Promise.resolve() : this._transport.destroy();
        return transportDestroyed.then(function () {
          _this._transport = null;

          if (_this._worker) {
            _this._worker.destroy();

            _this._worker = null;
          }
        });
      }
    }, {
      key: "then",
      value: function then(onFulfilled, onRejected) {
        (0, _display_utils.deprecated)('PDFDocumentLoadingTask.then method, ' + 'use the `promise` getter instead.');
        return this.promise.then.apply(this.promise, arguments);
      }
    }, {
      key: "promise",
      get: function get() {
        return this._capability.promise;
      }
    }]);

    return PDFDocumentLoadingTask;
  }();

  return PDFDocumentLoadingTask;
}();

var PDFDataRangeTransport =
/*#__PURE__*/
function () {
  function PDFDataRangeTransport(length, initialData) {
    var progressiveDone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck(this, PDFDataRangeTransport);

    this.length = length;
    this.initialData = initialData;
    this.progressiveDone = progressiveDone;
    this._rangeListeners = [];
    this._progressListeners = [];
    this._progressiveReadListeners = [];
    this._progressiveDoneListeners = [];
    this._readyCapability = (0, _util.createPromiseCapability)();
  }

  _createClass(PDFDataRangeTransport, [{
    key: "addRangeListener",
    value: function addRangeListener(listener) {
      this._rangeListeners.push(listener);
    }
  }, {
    key: "addProgressListener",
    value: function addProgressListener(listener) {
      this._progressListeners.push(listener);
    }
  }, {
    key: "addProgressiveReadListener",
    value: function addProgressiveReadListener(listener) {
      this._progressiveReadListeners.push(listener);
    }
  }, {
    key: "addProgressiveDoneListener",
    value: function addProgressiveDoneListener(listener) {
      this._progressiveDoneListeners.push(listener);
    }
  }, {
    key: "onDataRange",
    value: function onDataRange(begin, chunk) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this._rangeListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var listener = _step.value;
          listener(begin, chunk);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "onDataProgress",
    value: function onDataProgress(loaded, total) {
      var _this2 = this;

      this._readyCapability.promise.then(function () {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = _this2._progressListeners[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var listener = _step2.value;
            listener(loaded, total);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
              _iterator2["return"]();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      });
    }
  }, {
    key: "onDataProgressiveRead",
    value: function onDataProgressiveRead(chunk) {
      var _this3 = this;

      this._readyCapability.promise.then(function () {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = _this3._progressiveReadListeners[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var listener = _step3.value;
            listener(chunk);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
              _iterator3["return"]();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      });
    }
  }, {
    key: "onDataProgressiveDone",
    value: function onDataProgressiveDone() {
      var _this4 = this;

      this._readyCapability.promise.then(function () {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = _this4._progressiveDoneListeners[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var listener = _step4.value;
            listener();
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
              _iterator4["return"]();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      });
    }
  }, {
    key: "transportReady",
    value: function transportReady() {
      this._readyCapability.resolve();
    }
  }, {
    key: "requestDataRange",
    value: function requestDataRange(begin, end) {
      (0, _util.unreachable)('Abstract method PDFDataRangeTransport.requestDataRange');
    }
  }, {
    key: "abort",
    value: function abort() {}
  }]);

  return PDFDataRangeTransport;
}();

exports.PDFDataRangeTransport = PDFDataRangeTransport;

var PDFDocumentProxy =
/*#__PURE__*/
function () {
  function PDFDocumentProxy(pdfInfo, transport) {
    _classCallCheck(this, PDFDocumentProxy);

    this._pdfInfo = pdfInfo;
    this._transport = transport;
  }

  _createClass(PDFDocumentProxy, [{
    key: "getPage",
    value: function getPage(pageNumber) {
      return this._transport.getPage(pageNumber);
    }
  }, {
    key: "getPageIndex",
    value: function getPageIndex(ref) {
      return this._transport.getPageIndex(ref);
    }
  }, {
    key: "getDestinations",
    value: function getDestinations() {
      return this._transport.getDestinations();
    }
  }, {
    key: "getDestination",
    value: function getDestination(id) {
      return this._transport.getDestination(id);
    }
  }, {
    key: "getPageLabels",
    value: function getPageLabels() {
      return this._transport.getPageLabels();
    }
  }, {
    key: "getPageLayout",
    value: function getPageLayout() {
      return this._transport.getPageLayout();
    }
  }, {
    key: "getPageMode",
    value: function getPageMode() {
      return this._transport.getPageMode();
    }
  }, {
    key: "getViewerPreferences",
    value: function getViewerPreferences() {
      return this._transport.getViewerPreferences();
    }
  }, {
    key: "getOpenActionDestination",
    value: function getOpenActionDestination() {
      return this._transport.getOpenActionDestination();
    }
  }, {
    key: "getAttachments",
    value: function getAttachments() {
      return this._transport.getAttachments();
    }
  }, {
    key: "getJavaScript",
    value: function getJavaScript() {
      return this._transport.getJavaScript();
    }
  }, {
    key: "getOutline",
    value: function getOutline() {
      return this._transport.getOutline();
    }
  }, {
    key: "getPermissions",
    value: function getPermissions() {
      return this._transport.getPermissions();
    }
  }, {
    key: "getMetadata",
    value: function getMetadata() {
      return this._transport.getMetadata();
    }
  }, {
    key: "getData",
    value: function getData() {
      return this._transport.getData();
    }
  }, {
    key: "getDownloadInfo",
    value: function getDownloadInfo() {
      return this._transport.downloadInfoCapability.promise;
    }
  }, {
    key: "getStats",
    value: function getStats() {
      return this._transport.getStats();
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      this._transport.startCleanup();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      return this.loadingTask.destroy();
    }
  }, {
    key: "numPages",
    get: function get() {
      return this._pdfInfo.numPages;
    }
  }, {
    key: "fingerprint",
    get: function get() {
      return this._pdfInfo.fingerprint;
    }
  }, {
    key: "loadingParams",
    get: function get() {
      return this._transport.loadingParams;
    }
  }, {
    key: "loadingTask",
    get: function get() {
      return this._transport.loadingTask;
    }
  }]);

  return PDFDocumentProxy;
}();

exports.PDFDocumentProxy = PDFDocumentProxy;

var PDFPageProxy =
/*#__PURE__*/
function () {
  function PDFPageProxy(pageIndex, pageInfo, transport) {
    var pdfBug = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    _classCallCheck(this, PDFPageProxy);

    this.pageIndex = pageIndex;
    this._pageInfo = pageInfo;
    this._transport = transport;
    this._stats = pdfBug ? new _display_utils.StatTimer() : _display_utils.DummyStatTimer;
    this._pdfBug = pdfBug;
    this.commonObjs = transport.commonObjs;
    this.objs = new PDFObjects();
    this.cleanupAfterRender = false;
    this.pendingCleanup = false;
    this.intentStates = Object.create(null);
    this.destroyed = false;
  }

  _createClass(PDFPageProxy, [{
    key: "getViewport",
    value: function getViewport() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          scale = _ref.scale,
          _ref$rotation = _ref.rotation,
          rotation = _ref$rotation === void 0 ? this.rotate : _ref$rotation,
          _ref$dontFlip = _ref.dontFlip,
          dontFlip = _ref$dontFlip === void 0 ? false : _ref$dontFlip;

      if (arguments.length > 1 || typeof arguments[0] === 'number') {
        (0, _display_utils.deprecated)('getViewport is called with obsolete arguments.');
        scale = arguments[0];
        rotation = typeof arguments[1] === 'number' ? arguments[1] : this.rotate;
        dontFlip = typeof arguments[2] === 'boolean' ? arguments[2] : false;
      }

      return new _display_utils.PageViewport({
        viewBox: this.view,
        scale: scale,
        rotation: rotation,
        dontFlip: dontFlip
      });
    }
  }, {
    key: "getAnnotations",
    value: function getAnnotations() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$intent = _ref2.intent,
          intent = _ref2$intent === void 0 ? null : _ref2$intent;

      if (!this.annotationsPromise || this.annotationsIntent !== intent) {
        this.annotationsPromise = this._transport.getAnnotations(this.pageIndex, intent);
        this.annotationsIntent = intent;
      }

      return this.annotationsPromise;
    }
  }, {
    key: "render",
    value: function render(_ref3) {
      var _this5 = this;

      var canvasContext = _ref3.canvasContext,
          viewport = _ref3.viewport,
          _ref3$intent = _ref3.intent,
          intent = _ref3$intent === void 0 ? 'display' : _ref3$intent,
          _ref3$enableWebGL = _ref3.enableWebGL,
          enableWebGL = _ref3$enableWebGL === void 0 ? false : _ref3$enableWebGL,
          _ref3$renderInteracti = _ref3.renderInteractiveForms,
          renderInteractiveForms = _ref3$renderInteracti === void 0 ? false : _ref3$renderInteracti,
          _ref3$transform = _ref3.transform,
          transform = _ref3$transform === void 0 ? null : _ref3$transform,
          _ref3$imageLayer = _ref3.imageLayer,
          imageLayer = _ref3$imageLayer === void 0 ? null : _ref3$imageLayer,
          _ref3$canvasFactory = _ref3.canvasFactory,
          canvasFactory = _ref3$canvasFactory === void 0 ? null : _ref3$canvasFactory,
          _ref3$background = _ref3.background,
          background = _ref3$background === void 0 ? null : _ref3$background;
      var stats = this._stats;
      stats.time('Overall');
      this.pendingCleanup = false;
      var renderingIntent = intent === 'print' ? 'print' : 'display';
      var canvasFactoryInstance = canvasFactory || new _display_utils.DOMCanvasFactory();
      var webGLContext = new _webgl.WebGLContext({
        enable: enableWebGL
      });

      if (!this.intentStates[renderingIntent]) {
        this.intentStates[renderingIntent] = Object.create(null);
      }

      var intentState = this.intentStates[renderingIntent];

      if (!intentState.displayReadyCapability) {
        intentState.receivingOperatorList = true;
        intentState.displayReadyCapability = (0, _util.createPromiseCapability)();
        intentState.operatorList = {
          fnArray: [],
          argsArray: [],
          lastChunk: false
        };
        stats.time('Page Request');

        this._transport.messageHandler.send('RenderPageRequest', {
          pageIndex: this.pageNumber - 1,
          intent: renderingIntent,
          renderInteractiveForms: renderInteractiveForms === true
        });
      }

      var complete = function complete(error) {
        var i = intentState.renderTasks.indexOf(internalRenderTask);

        if (i >= 0) {
          intentState.renderTasks.splice(i, 1);
        }

        if (_this5.cleanupAfterRender || renderingIntent === 'print') {
          _this5.pendingCleanup = true;
        }

        _this5._tryCleanup();

        if (error) {
          internalRenderTask.capability.reject(error);
        } else {
          internalRenderTask.capability.resolve();
        }

        stats.timeEnd('Rendering');
        stats.timeEnd('Overall');
      };

      var internalRenderTask = new InternalRenderTask({
        callback: complete,
        params: {
          canvasContext: canvasContext,
          viewport: viewport,
          transform: transform,
          imageLayer: imageLayer,
          background: background
        },
        objs: this.objs,
        commonObjs: this.commonObjs,
        operatorList: intentState.operatorList,
        pageNumber: this.pageNumber,
        canvasFactory: canvasFactoryInstance,
        webGLContext: webGLContext,
        useRequestAnimationFrame: renderingIntent !== 'print',
        pdfBug: this._pdfBug
      });

      if (!intentState.renderTasks) {
        intentState.renderTasks = [];
      }

      intentState.renderTasks.push(internalRenderTask);
      var renderTask = internalRenderTask.task;
      intentState.displayReadyCapability.promise.then(function (transparency) {
        if (_this5.pendingCleanup) {
          complete();
          return;
        }

        stats.time('Rendering');
        internalRenderTask.initializeGraphics(transparency);
        internalRenderTask.operatorListChanged();
      })["catch"](complete);
      return renderTask;
    }
  }, {
    key: "getOperatorList",
    value: function getOperatorList() {
      function operatorListChanged() {
        if (intentState.operatorList.lastChunk) {
          intentState.opListReadCapability.resolve(intentState.operatorList);
          var i = intentState.renderTasks.indexOf(opListTask);

          if (i >= 0) {
            intentState.renderTasks.splice(i, 1);
          }
        }
      }

      var renderingIntent = 'oplist';

      if (!this.intentStates[renderingIntent]) {
        this.intentStates[renderingIntent] = Object.create(null);
      }

      var intentState = this.intentStates[renderingIntent];
      var opListTask;

      if (!intentState.opListReadCapability) {
        opListTask = {};
        opListTask.operatorListChanged = operatorListChanged;
        intentState.receivingOperatorList = true;
        intentState.opListReadCapability = (0, _util.createPromiseCapability)();
        intentState.renderTasks = [];
        intentState.renderTasks.push(opListTask);
        intentState.operatorList = {
          fnArray: [],
          argsArray: [],
          lastChunk: false
        };

        this._stats.time('Page Request');

        this._transport.messageHandler.send('RenderPageRequest', {
          pageIndex: this.pageIndex,
          intent: renderingIntent
        });
      }

      return intentState.opListReadCapability.promise;
    }
  }, {
    key: "streamTextContent",
    value: function streamTextContent() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$normalizeWhites = _ref4.normalizeWhitespace,
          normalizeWhitespace = _ref4$normalizeWhites === void 0 ? false : _ref4$normalizeWhites,
          _ref4$disableCombineT = _ref4.disableCombineTextItems,
          disableCombineTextItems = _ref4$disableCombineT === void 0 ? false : _ref4$disableCombineT;

      var TEXT_CONTENT_CHUNK_SIZE = 100;
      return this._transport.messageHandler.sendWithStream('GetTextContent', {
        pageIndex: this.pageNumber - 1,
        normalizeWhitespace: normalizeWhitespace === true,
        combineTextItems: disableCombineTextItems !== true
      }, {
        highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
        size: function size(textContent) {
          return textContent.items.length;
        }
      });
    }
  }, {
    key: "getTextContent",
    value: function getTextContent() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var readableStream = this.streamTextContent(params);
      return new Promise(function (resolve, reject) {
        function pump() {
          reader.read().then(function (_ref5) {
            var _textContent$items;

            var value = _ref5.value,
                done = _ref5.done;

            if (done) {
              resolve(textContent);
              return;
            }

            Object.assign(textContent.styles, value.styles);

            (_textContent$items = textContent.items).push.apply(_textContent$items, _toConsumableArray(value.items));

            pump();
          }, reject);
        }

        var reader = readableStream.getReader();
        var textContent = {
          items: [],
          styles: Object.create(null)
        };
        pump();
      });
    }
  }, {
    key: "_destroy",
    value: function _destroy() {
      this.destroyed = true;
      this._transport.pageCache[this.pageIndex] = null;
      var waitOn = [];
      Object.keys(this.intentStates).forEach(function (intent) {
        if (intent === 'oplist') {
          return;
        }

        var intentState = this.intentStates[intent];
        intentState.renderTasks.forEach(function (renderTask) {
          var renderCompleted = renderTask.capability.promise["catch"](function () {});
          waitOn.push(renderCompleted);
          renderTask.cancel();
        });
      }, this);
      this.objs.clear();
      this.annotationsPromise = null;
      this.pendingCleanup = false;
      return Promise.all(waitOn);
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      var resetStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.pendingCleanup = true;

      this._tryCleanup(resetStats);
    }
  }, {
    key: "_tryCleanup",
    value: function _tryCleanup() {
      var resetStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.pendingCleanup || Object.keys(this.intentStates).some(function (intent) {
        var intentState = this.intentStates[intent];
        return intentState.renderTasks.length !== 0 || intentState.receivingOperatorList;
      }, this)) {
        return;
      }

      Object.keys(this.intentStates).forEach(function (intent) {
        delete this.intentStates[intent];
      }, this);
      this.objs.clear();
      this.annotationsPromise = null;

      if (resetStats && this._stats instanceof _display_utils.StatTimer) {
        this._stats = new _display_utils.StatTimer();
      }

      this.pendingCleanup = false;
    }
  }, {
    key: "_startRenderPage",
    value: function _startRenderPage(transparency, intent) {
      var intentState = this.intentStates[intent];

      if (intentState.displayReadyCapability) {
        intentState.displayReadyCapability.resolve(transparency);
      }
    }
  }, {
    key: "_renderPageChunk",
    value: function _renderPageChunk(operatorListChunk, intent) {
      var intentState = this.intentStates[intent];

      for (var i = 0, ii = operatorListChunk.length; i < ii; i++) {
        intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
        intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
      }

      intentState.operatorList.lastChunk = operatorListChunk.lastChunk;

      for (var _i = 0; _i < intentState.renderTasks.length; _i++) {
        intentState.renderTasks[_i].operatorListChanged();
      }

      if (operatorListChunk.lastChunk) {
        intentState.receivingOperatorList = false;

        this._tryCleanup();
      }
    }
  }, {
    key: "pageNumber",
    get: function get() {
      return this.pageIndex + 1;
    }
  }, {
    key: "rotate",
    get: function get() {
      return this._pageInfo.rotate;
    }
  }, {
    key: "ref",
    get: function get() {
      return this._pageInfo.ref;
    }
  }, {
    key: "userUnit",
    get: function get() {
      return this._pageInfo.userUnit;
    }
  }, {
    key: "view",
    get: function get() {
      return this._pageInfo.view;
    }
  }, {
    key: "stats",
    get: function get() {
      return this._stats instanceof _display_utils.StatTimer ? this._stats : null;
    }
  }]);

  return PDFPageProxy;
}();

exports.PDFPageProxy = PDFPageProxy;

var LoopbackPort =
/*#__PURE__*/
function () {
  function LoopbackPort() {
    var defer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    _classCallCheck(this, LoopbackPort);

    this._listeners = [];
    this._defer = defer;
    this._deferred = Promise.resolve(undefined);
  }

  _createClass(LoopbackPort, [{
    key: "postMessage",
    value: function postMessage(obj, transfers) {
      var _this6 = this;

      function cloneValue(value) {
        if (_typeof(value) !== 'object' || value === null) {
          return value;
        }

        if (cloned.has(value)) {
          return cloned.get(value);
        }

        var buffer, result;

        if ((buffer = value.buffer) && (0, _util.isArrayBuffer)(buffer)) {
          var transferable = transfers && transfers.includes(buffer);

          if (value === buffer) {
            result = value;
          } else if (transferable) {
            result = new value.constructor(buffer, value.byteOffset, value.byteLength);
          } else {
            result = new value.constructor(value);
          }

          cloned.set(value, result);
          return result;
        }

        result = Array.isArray(value) ? [] : {};
        cloned.set(value, result);

        for (var i in value) {
          var desc = void 0,
              p = value;

          while (!(desc = Object.getOwnPropertyDescriptor(p, i))) {
            p = Object.getPrototypeOf(p);
          }

          if (typeof desc.value === 'undefined' || typeof desc.value === 'function') {
            continue;
          }

          result[i] = cloneValue(desc.value);
        }

        return result;
      }

      if (!this._defer) {
        this._listeners.forEach(function (listener) {
          listener.call(this, {
            data: obj
          });
        }, this);

        return;
      }

      var cloned = new WeakMap();
      var e = {
        data: cloneValue(obj)
      };

      this._deferred.then(function () {
        _this6._listeners.forEach(function (listener) {
          listener.call(this, e);
        }, _this6);
      });
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(name, listener) {
      this._listeners.push(listener);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(name, listener) {
      var i = this._listeners.indexOf(listener);

      this._listeners.splice(i, 1);
    }
  }, {
    key: "terminate",
    value: function terminate() {
      this._listeners.length = 0;
    }
  }]);

  return LoopbackPort;
}();

exports.LoopbackPort = LoopbackPort;

var PDFWorker = function PDFWorkerClosure() {
  var pdfWorkerPorts = new WeakMap();
  var nextFakeWorkerId = 0;
  var fakeWorkerFilesLoadedCapability;

  function _getWorkerSrc() {
    if (_worker_options.GlobalWorkerOptions.workerSrc) {
      return _worker_options.GlobalWorkerOptions.workerSrc;
    }

    if (typeof fallbackWorkerSrc !== 'undefined') {
      return fallbackWorkerSrc;
    }

    throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
  }

  function getMainThreadWorkerMessageHandler() {
    try {
      if (typeof window !== 'undefined') {
        return window.pdfjsWorker && window.pdfjsWorker.WorkerMessageHandler;
      }
    } catch (ex) {}

    return null;
  }

  function setupFakeWorkerGlobal() {
    if (fakeWorkerFilesLoadedCapability) {
      return fakeWorkerFilesLoadedCapability.promise;
    }

    fakeWorkerFilesLoadedCapability = (0, _util.createPromiseCapability)();
    var mainWorkerMessageHandler = getMainThreadWorkerMessageHandler();

    if (mainWorkerMessageHandler) {
      fakeWorkerFilesLoadedCapability.resolve(mainWorkerMessageHandler);
      return fakeWorkerFilesLoadedCapability.promise;
    }

    var loader = fakeWorkerFilesLoader || function () {
      return (0, _display_utils.loadScript)(_getWorkerSrc()).then(function () {
        return window.pdfjsWorker.WorkerMessageHandler;
      });
    };

    loader().then(fakeWorkerFilesLoadedCapability.resolve, fakeWorkerFilesLoadedCapability.reject);
    return fakeWorkerFilesLoadedCapability.promise;
  }

  function createCDNWrapper(url) {
    var wrapper = 'importScripts(\'' + url + '\');';
    return _util.URL.createObjectURL(new Blob([wrapper]));
  }

  var PDFWorker =
  /*#__PURE__*/
  function () {
    function PDFWorker() {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref6$name = _ref6.name,
          name = _ref6$name === void 0 ? null : _ref6$name,
          _ref6$port = _ref6.port,
          port = _ref6$port === void 0 ? null : _ref6$port,
          _ref6$postMessageTran = _ref6.postMessageTransfers,
          postMessageTransfers = _ref6$postMessageTran === void 0 ? true : _ref6$postMessageTran,
          _ref6$verbosity = _ref6.verbosity,
          verbosity = _ref6$verbosity === void 0 ? (0, _util.getVerbosityLevel)() : _ref6$verbosity;

      _classCallCheck(this, PDFWorker);

      if (port && pdfWorkerPorts.has(port)) {
        throw new Error('Cannot use more than one PDFWorker per port');
      }

      this.name = name;
      this.destroyed = false;
      this.postMessageTransfers = postMessageTransfers !== false;
      this.verbosity = verbosity;
      this._readyCapability = (0, _util.createPromiseCapability)();
      this._port = null;
      this._webWorker = null;
      this._messageHandler = null;

      if (port) {
        pdfWorkerPorts.set(port, this);

        this._initializeFromPort(port);

        return;
      }

      this._initialize();
    }

    _createClass(PDFWorker, [{
      key: "_initializeFromPort",
      value: function _initializeFromPort(port) {
        this._port = port;
        this._messageHandler = new _message_handler.MessageHandler('main', 'worker', port);

        this._messageHandler.on('ready', function () {});

        this._readyCapability.resolve();
      }
    }, {
      key: "_initialize",
      value: function _initialize() {
        var _this7 = this;

        if (typeof Worker !== 'undefined' && !isWorkerDisabled && !getMainThreadWorkerMessageHandler()) {
          var workerSrc = _getWorkerSrc();

          try {
            if (!(0, _util.isSameOrigin)(window.location.href, workerSrc)) {
              workerSrc = createCDNWrapper(new _util.URL(workerSrc, window.location).href);
            }

            var worker = new Worker(workerSrc);
            var messageHandler = new _message_handler.MessageHandler('main', 'worker', worker);

            var terminateEarly = function terminateEarly() {
              worker.removeEventListener('error', onWorkerError);
              messageHandler.destroy();
              worker.terminate();

              if (_this7.destroyed) {
                _this7._readyCapability.reject(new Error('Worker was destroyed'));
              } else {
                _this7._setupFakeWorker();
              }
            };

            var onWorkerError = function onWorkerError() {
              if (!_this7._webWorker) {
                terminateEarly();
              }
            };

            worker.addEventListener('error', onWorkerError);
            messageHandler.on('test', function (data) {
              worker.removeEventListener('error', onWorkerError);

              if (_this7.destroyed) {
                terminateEarly();
                return;
              }

              if (data && data.supportTypedArray) {
                _this7._messageHandler = messageHandler;
                _this7._port = worker;
                _this7._webWorker = worker;

                if (!data.supportTransfers) {
                  _this7.postMessageTransfers = false;
                }

                _this7._readyCapability.resolve();

                messageHandler.send('configure', {
                  verbosity: _this7.verbosity
                });
              } else {
                _this7._setupFakeWorker();

                messageHandler.destroy();
                worker.terminate();
              }
            });
            messageHandler.on('ready', function (data) {
              worker.removeEventListener('error', onWorkerError);

              if (_this7.destroyed) {
                terminateEarly();
                return;
              }

              try {
                sendTest();
              } catch (e) {
                _this7._setupFakeWorker();
              }
            });

            var sendTest = function sendTest() {
              var testObj = new Uint8Array([_this7.postMessageTransfers ? 255 : 0]);

              try {
                messageHandler.send('test', testObj, [testObj.buffer]);
              } catch (ex) {
                (0, _util.info)('Cannot use postMessage transfers');
                testObj[0] = 0;
                messageHandler.send('test', testObj);
              }
            };

            sendTest();
            return;
          } catch (e) {
            (0, _util.info)('The worker has been disabled.');
          }
        }

        this._setupFakeWorker();
      }
    }, {
      key: "_setupFakeWorker",
      value: function _setupFakeWorker() {
        var _this8 = this;

        if (!isWorkerDisabled) {
          (0, _util.warn)('Setting up fake worker.');
          isWorkerDisabled = true;
        }

        setupFakeWorkerGlobal().then(function (WorkerMessageHandler) {
          if (_this8.destroyed) {
            _this8._readyCapability.reject(new Error('Worker was destroyed'));

            return;
          }

          var port = new LoopbackPort();
          _this8._port = port;
          var id = 'fake' + nextFakeWorkerId++;
          var workerHandler = new _message_handler.MessageHandler(id + '_worker', id, port);
          WorkerMessageHandler.setup(workerHandler, port);
          var messageHandler = new _message_handler.MessageHandler(id, id + '_worker', port);
          _this8._messageHandler = messageHandler;

          _this8._readyCapability.resolve();
        })["catch"](function (reason) {
          _this8._readyCapability.reject(new Error("Setting up fake worker failed: \"".concat(reason.message, "\".")));
        });
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this.destroyed = true;

        if (this._webWorker) {
          this._webWorker.terminate();

          this._webWorker = null;
        }

        pdfWorkerPorts["delete"](this._port);
        this._port = null;

        if (this._messageHandler) {
          this._messageHandler.destroy();

          this._messageHandler = null;
        }
      }
    }, {
      key: "promise",
      get: function get() {
        return this._readyCapability.promise;
      }
    }, {
      key: "port",
      get: function get() {
        return this._port;
      }
    }, {
      key: "messageHandler",
      get: function get() {
        return this._messageHandler;
      }
    }], [{
      key: "fromPort",
      value: function fromPort(params) {
        if (!params || !params.port) {
          throw new Error('PDFWorker.fromPort - invalid method signature.');
        }

        if (pdfWorkerPorts.has(params.port)) {
          return pdfWorkerPorts.get(params.port);
        }

        return new PDFWorker(params);
      }
    }, {
      key: "getWorkerSrc",
      value: function getWorkerSrc() {
        return _getWorkerSrc();
      }
    }]);

    return PDFWorker;
  }();

  return PDFWorker;
}();

exports.PDFWorker = PDFWorker;

var WorkerTransport =
/*#__PURE__*/
function () {
  function WorkerTransport(messageHandler, loadingTask, networkStream, params) {
    _classCallCheck(this, WorkerTransport);

    this.messageHandler = messageHandler;
    this.loadingTask = loadingTask;
    this.commonObjs = new PDFObjects();
    this.fontLoader = new _font_loader.FontLoader({
      docId: loadingTask.docId,
      onUnsupportedFeature: this._onUnsupportedFeature.bind(this)
    });
    this._params = params;
    this.CMapReaderFactory = new params.CMapReaderFactory({
      baseUrl: params.cMapUrl,
      isCompressed: params.cMapPacked
    });
    this.destroyed = false;
    this.destroyCapability = null;
    this._passwordCapability = null;
    this._networkStream = networkStream;
    this._fullReader = null;
    this._lastProgress = null;
    this.pageCache = [];
    this.pagePromises = [];
    this.downloadInfoCapability = (0, _util.createPromiseCapability)();
    this.setupMessageHandler();
  }

  _createClass(WorkerTransport, [{
    key: "destroy",
    value: function destroy() {
      var _this9 = this;

      if (this.destroyCapability) {
        return this.destroyCapability.promise;
      }

      this.destroyed = true;
      this.destroyCapability = (0, _util.createPromiseCapability)();

      if (this._passwordCapability) {
        this._passwordCapability.reject(new Error('Worker was destroyed during onPassword callback'));
      }

      var waitOn = [];
      this.pageCache.forEach(function (page) {
        if (page) {
          waitOn.push(page._destroy());
        }
      });
      this.pageCache.length = 0;
      this.pagePromises.length = 0;
      var terminated = this.messageHandler.sendWithPromise('Terminate', null);
      waitOn.push(terminated);
      Promise.all(waitOn).then(function () {
        _this9.fontLoader.clear();

        if (_this9._networkStream) {
          _this9._networkStream.cancelAllRequests();
        }

        if (_this9.messageHandler) {
          _this9.messageHandler.destroy();

          _this9.messageHandler = null;
        }

        _this9.destroyCapability.resolve();
      }, this.destroyCapability.reject);
      return this.destroyCapability.promise;
    }
  }, {
    key: "setupMessageHandler",
    value: function setupMessageHandler() {
      var messageHandler = this.messageHandler,
          loadingTask = this.loadingTask;
      messageHandler.on('GetReader', function (data, sink) {
        var _this10 = this;

        (0, _util.assert)(this._networkStream);
        this._fullReader = this._networkStream.getFullReader();

        this._fullReader.onProgress = function (evt) {
          _this10._lastProgress = {
            loaded: evt.loaded,
            total: evt.total
          };
        };

        sink.onPull = function () {
          _this10._fullReader.read().then(function (_ref7) {
            var value = _ref7.value,
                done = _ref7.done;

            if (done) {
              sink.close();
              return;
            }

            (0, _util.assert)((0, _util.isArrayBuffer)(value));
            sink.enqueue(new Uint8Array(value), 1, [value]);
          })["catch"](function (reason) {
            sink.error(reason);
          });
        };

        sink.onCancel = function (reason) {
          _this10._fullReader.cancel(reason);
        };
      }, this);
      messageHandler.on('ReaderHeadersReady', function (data) {
        var _this11 = this;

        var headersCapability = (0, _util.createPromiseCapability)();
        var fullReader = this._fullReader;
        fullReader.headersReady.then(function () {
          if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
            if (_this11._lastProgress && loadingTask.onProgress) {
              loadingTask.onProgress(_this11._lastProgress);
            }

            fullReader.onProgress = function (evt) {
              if (loadingTask.onProgress) {
                loadingTask.onProgress({
                  loaded: evt.loaded,
                  total: evt.total
                });
              }
            };
          }

          headersCapability.resolve({
            isStreamingSupported: fullReader.isStreamingSupported,
            isRangeSupported: fullReader.isRangeSupported,
            contentLength: fullReader.contentLength
          });
        }, headersCapability.reject);
        return headersCapability.promise;
      }, this);
      messageHandler.on('GetRangeReader', function (data, sink) {
        (0, _util.assert)(this._networkStream);

        var rangeReader = this._networkStream.getRangeReader(data.begin, data.end);

        if (!rangeReader) {
          sink.close();
          return;
        }

        sink.onPull = function () {
          rangeReader.read().then(function (_ref8) {
            var value = _ref8.value,
                done = _ref8.done;

            if (done) {
              sink.close();
              return;
            }

            (0, _util.assert)((0, _util.isArrayBuffer)(value));
            sink.enqueue(new Uint8Array(value), 1, [value]);
          })["catch"](function (reason) {
            sink.error(reason);
          });
        };

        sink.onCancel = function (reason) {
          rangeReader.cancel(reason);
        };
      }, this);
      messageHandler.on('GetDoc', function (_ref9) {
        var pdfInfo = _ref9.pdfInfo;
        this._numPages = pdfInfo.numPages;

        loadingTask._capability.resolve(new PDFDocumentProxy(pdfInfo, this));
      }, this);
      messageHandler.on('PasswordRequest', function (exception) {
        var _this12 = this;

        this._passwordCapability = (0, _util.createPromiseCapability)();

        if (loadingTask.onPassword) {
          var updatePassword = function updatePassword(password) {
            _this12._passwordCapability.resolve({
              password: password
            });
          };

          try {
            loadingTask.onPassword(updatePassword, exception.code);
          } catch (ex) {
            this._passwordCapability.reject(ex);
          }
        } else {
          this._passwordCapability.reject(new _util.PasswordException(exception.message, exception.code));
        }

        return this._passwordCapability.promise;
      }, this);
      messageHandler.on('PasswordException', function (exception) {
        loadingTask._capability.reject(new _util.PasswordException(exception.message, exception.code));
      }, this);
      messageHandler.on('InvalidPDF', function (exception) {
        loadingTask._capability.reject(new _util.InvalidPDFException(exception.message));
      }, this);
      messageHandler.on('MissingPDF', function (exception) {
        loadingTask._capability.reject(new _util.MissingPDFException(exception.message));
      }, this);
      messageHandler.on('UnexpectedResponse', function (exception) {
        loadingTask._capability.reject(new _util.UnexpectedResponseException(exception.message, exception.status));
      }, this);
      messageHandler.on('UnknownError', function (exception) {
        loadingTask._capability.reject(new _util.UnknownErrorException(exception.message, exception.details));
      }, this);
      messageHandler.on('DataLoaded', function (data) {
        if (loadingTask.onProgress) {
          loadingTask.onProgress({
            loaded: data.length,
            total: data.length
          });
        }

        this.downloadInfoCapability.resolve(data);
      }, this);
      messageHandler.on('StartRenderPage', function (data) {
        if (this.destroyed) {
          return;
        }

        var page = this.pageCache[data.pageIndex];

        page._stats.timeEnd('Page Request');

        page._startRenderPage(data.transparency, data.intent);
      }, this);
      messageHandler.on('RenderPageChunk', function (data) {
        if (this.destroyed) {
          return;
        }

        var page = this.pageCache[data.pageIndex];

        page._renderPageChunk(data.operatorList, data.intent);
      }, this);
      messageHandler.on('commonobj', function (data) {
        var _this13 = this;

        if (this.destroyed) {
          return;
        }

        var _data = _slicedToArray(data, 3),
            id = _data[0],
            type = _data[1],
            exportedData = _data[2];

        if (this.commonObjs.has(id)) {
          return;
        }

        switch (type) {
          case 'Font':
            var params = this._params;

            if ('error' in exportedData) {
              var exportedError = exportedData.error;
              (0, _util.warn)("Error during font loading: ".concat(exportedError));
              this.commonObjs.resolve(id, exportedError);
              break;
            }

            var fontRegistry = null;

            if (params.pdfBug && _global_scope["default"].FontInspector && _global_scope["default"].FontInspector.enabled) {
              fontRegistry = {
                registerFont: function registerFont(font, url) {
                  _global_scope["default"]['FontInspector'].fontAdded(font, url);
                }
              };
            }

            var font = new _font_loader.FontFaceObject(exportedData, {
              isEvalSupported: params.isEvalSupported,
              disableFontFace: params.disableFontFace,
              ignoreErrors: params.ignoreErrors,
              onUnsupportedFeature: this._onUnsupportedFeature.bind(this),
              fontRegistry: fontRegistry
            });
            this.fontLoader.bind(font).then(function () {
              _this13.commonObjs.resolve(id, font);
            }, function (reason) {
              messageHandler.sendWithPromise('FontFallback', {
                id: id
              })["finally"](function () {
                _this13.commonObjs.resolve(id, font);
              });
            });
            break;

          case 'FontPath':
          case 'FontType3Res':
            this.commonObjs.resolve(id, exportedData);
            break;

          default:
            throw new Error("Got unknown common object type ".concat(type));
        }
      }, this);
      messageHandler.on('obj', function (data) {
        if (this.destroyed) {
          return undefined;
        }

        var _data2 = _slicedToArray(data, 4),
            id = _data2[0],
            pageIndex = _data2[1],
            type = _data2[2],
            imageData = _data2[3];

        var pageProxy = this.pageCache[pageIndex];

        if (pageProxy.objs.has(id)) {
          return undefined;
        }

        switch (type) {
          case 'JpegStream':
            return new Promise(function (resolve, reject) {
              var img = new Image();

              img.onload = function () {
                resolve(img);
              };

              img.onerror = function () {
                reject(new Error('Error during JPEG image loading'));
                (0, _display_utils.releaseImageResources)(img);
              };

              img.src = imageData;
            }).then(function (img) {
              pageProxy.objs.resolve(id, img);
            });

          case 'Image':
            pageProxy.objs.resolve(id, imageData);
            var MAX_IMAGE_SIZE_TO_STORE = 8000000;

            if (imageData && 'data' in imageData && imageData.data.length > MAX_IMAGE_SIZE_TO_STORE) {
              pageProxy.cleanupAfterRender = true;
            }

            break;

          default:
            throw new Error("Got unknown object type ".concat(type));
        }

        return undefined;
      }, this);
      messageHandler.on('DocProgress', function (data) {
        if (this.destroyed) {
          return;
        }

        if (loadingTask.onProgress) {
          loadingTask.onProgress({
            loaded: data.loaded,
            total: data.total
          });
        }
      }, this);
      messageHandler.on('PageError', function (data) {
        if (this.destroyed) {
          return;
        }

        var page = this.pageCache[data.pageIndex];
        var intentState = page.intentStates[data.intent];

        if (intentState.displayReadyCapability) {
          intentState.displayReadyCapability.reject(new Error(data.error));
        } else {
          throw new Error(data.error);
        }

        if (intentState.operatorList) {
          intentState.operatorList.lastChunk = true;

          for (var i = 0; i < intentState.renderTasks.length; i++) {
            intentState.renderTasks[i].operatorListChanged();
          }
        }
      }, this);
      messageHandler.on('UnsupportedFeature', this._onUnsupportedFeature, this);
      messageHandler.on('JpegDecode', function (data) {
        if (this.destroyed) {
          return Promise.reject(new Error('Worker was destroyed'));
        }

        if (typeof document === 'undefined') {
          return Promise.reject(new Error('"document" is not defined.'));
        }

        var _data3 = _slicedToArray(data, 2),
            imageUrl = _data3[0],
            components = _data3[1];

        if (components !== 3 && components !== 1) {
          return Promise.reject(new Error('Only 3 components or 1 component can be returned'));
        }

        return new Promise(function (resolve, reject) {
          var img = new Image();

          img.onload = function () {
            var width = img.width,
                height = img.height;
            var size = width * height;
            var rgbaLength = size * 4;
            var buf = new Uint8ClampedArray(size * components);
            var tmpCanvas = document.createElement('canvas');
            tmpCanvas.width = width;
            tmpCanvas.height = height;
            var tmpCtx = tmpCanvas.getContext('2d');
            tmpCtx.drawImage(img, 0, 0);
            var data = tmpCtx.getImageData(0, 0, width, height).data;

            if (components === 3) {
              for (var i = 0, j = 0; i < rgbaLength; i += 4, j += 3) {
                buf[j] = data[i];
                buf[j + 1] = data[i + 1];
                buf[j + 2] = data[i + 2];
              }
            } else if (components === 1) {
              for (var _i2 = 0, _j = 0; _i2 < rgbaLength; _i2 += 4, _j++) {
                buf[_j] = data[_i2];
              }
            }

            resolve({
              data: buf,
              width: width,
              height: height
            });
            (0, _display_utils.releaseImageResources)(img);
            tmpCanvas.width = 0;
            tmpCanvas.height = 0;
            tmpCanvas = null;
            tmpCtx = null;
          };

          img.onerror = function () {
            reject(new Error('JpegDecode failed to load image'));
            (0, _display_utils.releaseImageResources)(img);
          };

          img.src = imageUrl;
        });
      }, this);
      messageHandler.on('FetchBuiltInCMap', function (data) {
        if (this.destroyed) {
          return Promise.reject(new Error('Worker was destroyed'));
        }

        return this.CMapReaderFactory.fetch({
          name: data.name
        });
      }, this);
    }
  }, {
    key: "_onUnsupportedFeature",
    value: function _onUnsupportedFeature(_ref10) {
      var featureId = _ref10.featureId;

      if (this.destroyed) {
        return;
      }

      if (this.loadingTask.onUnsupportedFeature) {
        this.loadingTask.onUnsupportedFeature(featureId);
      }
    }
  }, {
    key: "getData",
    value: function getData() {
      return this.messageHandler.sendWithPromise('GetData', null);
    }
  }, {
    key: "getPage",
    value: function getPage(pageNumber) {
      var _this14 = this;

      if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this._numPages) {
        return Promise.reject(new Error('Invalid page request'));
      }

      var pageIndex = pageNumber - 1;

      if (pageIndex in this.pagePromises) {
        return this.pagePromises[pageIndex];
      }

      var promise = this.messageHandler.sendWithPromise('GetPage', {
        pageIndex: pageIndex
      }).then(function (pageInfo) {
        if (_this14.destroyed) {
          throw new Error('Transport destroyed');
        }

        var page = new PDFPageProxy(pageIndex, pageInfo, _this14, _this14._params.pdfBug);
        _this14.pageCache[pageIndex] = page;
        return page;
      });
      this.pagePromises[pageIndex] = promise;
      return promise;
    }
  }, {
    key: "getPageIndex",
    value: function getPageIndex(ref) {
      return this.messageHandler.sendWithPromise('GetPageIndex', {
        ref: ref
      })["catch"](function (reason) {
        return Promise.reject(new Error(reason));
      });
    }
  }, {
    key: "getAnnotations",
    value: function getAnnotations(pageIndex, intent) {
      return this.messageHandler.sendWithPromise('GetAnnotations', {
        pageIndex: pageIndex,
        intent: intent
      });
    }
  }, {
    key: "getDestinations",
    value: function getDestinations() {
      return this.messageHandler.sendWithPromise('GetDestinations', null);
    }
  }, {
    key: "getDestination",
    value: function getDestination(id) {
      if (typeof id !== 'string') {
        return Promise.reject(new Error('Invalid destination request.'));
      }

      return this.messageHandler.sendWithPromise('GetDestination', {
        id: id
      });
    }
  }, {
    key: "getPageLabels",
    value: function getPageLabels() {
      return this.messageHandler.sendWithPromise('GetPageLabels', null);
    }
  }, {
    key: "getPageLayout",
    value: function getPageLayout() {
      return this.messageHandler.sendWithPromise('GetPageLayout', null);
    }
  }, {
    key: "getPageMode",
    value: function getPageMode() {
      return this.messageHandler.sendWithPromise('GetPageMode', null);
    }
  }, {
    key: "getViewerPreferences",
    value: function getViewerPreferences() {
      return this.messageHandler.sendWithPromise('GetViewerPreferences', null);
    }
  }, {
    key: "getOpenActionDestination",
    value: function getOpenActionDestination() {
      return this.messageHandler.sendWithPromise('GetOpenActionDestination', null);
    }
  }, {
    key: "getAttachments",
    value: function getAttachments() {
      return this.messageHandler.sendWithPromise('GetAttachments', null);
    }
  }, {
    key: "getJavaScript",
    value: function getJavaScript() {
      return this.messageHandler.sendWithPromise('GetJavaScript', null);
    }
  }, {
    key: "getOutline",
    value: function getOutline() {
      return this.messageHandler.sendWithPromise('GetOutline', null);
    }
  }, {
    key: "getPermissions",
    value: function getPermissions() {
      return this.messageHandler.sendWithPromise('GetPermissions', null);
    }
  }, {
    key: "getMetadata",
    value: function getMetadata() {
      var _this15 = this;

      return this.messageHandler.sendWithPromise('GetMetadata', null).then(function (results) {
        return {
          info: results[0],
          metadata: results[1] ? new _metadata.Metadata(results[1]) : null,
          contentDispositionFilename: _this15._fullReader ? _this15._fullReader.filename : null
        };
      });
    }
  }, {
    key: "getStats",
    value: function getStats() {
      return this.messageHandler.sendWithPromise('GetStats', null);
    }
  }, {
    key: "startCleanup",
    value: function startCleanup() {
      var _this16 = this;

      this.messageHandler.sendWithPromise('Cleanup', null).then(function () {
        for (var i = 0, ii = _this16.pageCache.length; i < ii; i++) {
          var page = _this16.pageCache[i];

          if (page) {
            page.cleanup();
          }
        }

        _this16.commonObjs.clear();

        _this16.fontLoader.clear();
      });
    }
  }, {
    key: "loadingParams",
    get: function get() {
      var params = this._params;
      return (0, _util.shadow)(this, 'loadingParams', {
        disableAutoFetch: params.disableAutoFetch,
        disableCreateObjectURL: params.disableCreateObjectURL,
        disableFontFace: params.disableFontFace,
        nativeImageDecoderSupport: params.nativeImageDecoderSupport
      });
    }
  }]);

  return WorkerTransport;
}();

var PDFObjects =
/*#__PURE__*/
function () {
  function PDFObjects() {
    _classCallCheck(this, PDFObjects);

    this._objs = Object.create(null);
  }

  _createClass(PDFObjects, [{
    key: "_ensureObj",
    value: function _ensureObj(objId) {
      if (this._objs[objId]) {
        return this._objs[objId];
      }

      return this._objs[objId] = {
        capability: (0, _util.createPromiseCapability)(),
        data: null,
        resolved: false
      };
    }
  }, {
    key: "get",
    value: function get(objId) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (callback) {
        this._ensureObj(objId).capability.promise.then(callback);

        return null;
      }

      var obj = this._objs[objId];

      if (!obj || !obj.resolved) {
        throw new Error("Requesting object that isn't resolved yet ".concat(objId, "."));
      }

      return obj.data;
    }
  }, {
    key: "has",
    value: function has(objId) {
      var obj = this._objs[objId];
      return obj ? obj.resolved : false;
    }
  }, {
    key: "resolve",
    value: function resolve(objId, data) {
      var obj = this._ensureObj(objId);

      obj.resolved = true;
      obj.data = data;
      obj.capability.resolve(data);
    }
  }, {
    key: "clear",
    value: function clear() {
      for (var objId in this._objs) {
        var data = this._objs[objId].data;

        if (typeof Image !== 'undefined' && data instanceof Image) {
          (0, _display_utils.releaseImageResources)(data);
        }
      }

      this._objs = Object.create(null);
    }
  }]);

  return PDFObjects;
}();

var RenderTask =
/*#__PURE__*/
function () {
  function RenderTask(internalRenderTask) {
    _classCallCheck(this, RenderTask);

    this._internalRenderTask = internalRenderTask;
    this.onContinue = null;
  }

  _createClass(RenderTask, [{
    key: "cancel",
    value: function cancel() {
      this._internalRenderTask.cancel();
    }
  }, {
    key: "then",
    value: function then(onFulfilled, onRejected) {
      (0, _display_utils.deprecated)('RenderTask.then method, use the `promise` getter instead.');
      return this.promise.then.apply(this.promise, arguments);
    }
  }, {
    key: "promise",
    get: function get() {
      return this._internalRenderTask.capability.promise;
    }
  }]);

  return RenderTask;
}();

var InternalRenderTask = function InternalRenderTaskClosure() {
  var canvasInRendering = new WeakSet();

  var InternalRenderTask =
  /*#__PURE__*/
  function () {
    function InternalRenderTask(_ref11) {
      var callback = _ref11.callback,
          params = _ref11.params,
          objs = _ref11.objs,
          commonObjs = _ref11.commonObjs,
          operatorList = _ref11.operatorList,
          pageNumber = _ref11.pageNumber,
          canvasFactory = _ref11.canvasFactory,
          webGLContext = _ref11.webGLContext,
          _ref11$useRequestAnim = _ref11.useRequestAnimationFrame,
          useRequestAnimationFrame = _ref11$useRequestAnim === void 0 ? false : _ref11$useRequestAnim,
          _ref11$pdfBug = _ref11.pdfBug,
          pdfBug = _ref11$pdfBug === void 0 ? false : _ref11$pdfBug;

      _classCallCheck(this, InternalRenderTask);

      this.callback = callback;
      this.params = params;
      this.objs = objs;
      this.commonObjs = commonObjs;
      this.operatorListIdx = null;
      this.operatorList = operatorList;
      this.pageNumber = pageNumber;
      this.canvasFactory = canvasFactory;
      this.webGLContext = webGLContext;
      this._pdfBug = pdfBug;
      this.running = false;
      this.graphicsReadyCallback = null;
      this.graphicsReady = false;
      this._useRequestAnimationFrame = useRequestAnimationFrame === true && typeof window !== 'undefined';
      this.cancelled = false;
      this.capability = (0, _util.createPromiseCapability)();
      this.task = new RenderTask(this);
      this._continueBound = this._continue.bind(this);
      this._scheduleNextBound = this._scheduleNext.bind(this);
      this._nextBound = this._next.bind(this);
      this._canvas = params.canvasContext.canvas;
    }

    _createClass(InternalRenderTask, [{
      key: "initializeGraphics",
      value: function initializeGraphics() {
        var transparency = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        if (this.cancelled) {
          return;
        }

        if (this._canvas) {
          if (canvasInRendering.has(this._canvas)) {
            throw new Error('Cannot use the same canvas during multiple render() operations. ' + 'Use different canvas or ensure previous operations were ' + 'cancelled or completed.');
          }

          canvasInRendering.add(this._canvas);
        }

        if (this._pdfBug && _global_scope["default"].StepperManager && _global_scope["default"].StepperManager.enabled) {
          this.stepper = _global_scope["default"].StepperManager.create(this.pageNumber - 1);
          this.stepper.init(this.operatorList);
          this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
        }

        var _this$params = this.params,
            canvasContext = _this$params.canvasContext,
            viewport = _this$params.viewport,
            transform = _this$params.transform,
            imageLayer = _this$params.imageLayer,
            background = _this$params.background;
        this.gfx = new _canvas.CanvasGraphics(canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.webGLContext, imageLayer);
        this.gfx.beginDrawing({
          transform: transform,
          viewport: viewport,
          transparency: transparency,
          background: background
        });
        this.operatorListIdx = 0;
        this.graphicsReady = true;

        if (this.graphicsReadyCallback) {
          this.graphicsReadyCallback();
        }
      }
    }, {
      key: "cancel",
      value: function cancel() {
        var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        this.running = false;
        this.cancelled = true;

        if (this.gfx) {
          this.gfx.endDrawing();
        }

        if (this._canvas) {
          canvasInRendering["delete"](this._canvas);
        }

        this.callback(error || new _display_utils.RenderingCancelledException("Rendering cancelled, page ".concat(this.pageNumber), 'canvas'));
      }
    }, {
      key: "operatorListChanged",
      value: function operatorListChanged() {
        if (!this.graphicsReady) {
          if (!this.graphicsReadyCallback) {
            this.graphicsReadyCallback = this._continueBound;
          }

          return;
        }

        if (this.stepper) {
          this.stepper.updateOperatorList(this.operatorList);
        }

        if (this.running) {
          return;
        }

        this._continue();
      }
    }, {
      key: "_continue",
      value: function _continue() {
        this.running = true;

        if (this.cancelled) {
          return;
        }

        if (this.task.onContinue) {
          this.task.onContinue(this._scheduleNextBound);
        } else {
          this._scheduleNext();
        }
      }
    }, {
      key: "_scheduleNext",
      value: function _scheduleNext() {
        var _this17 = this;

        if (this._useRequestAnimationFrame) {
          window.requestAnimationFrame(function () {
            _this17._nextBound()["catch"](_this17.cancel.bind(_this17));
          });
        } else {
          Promise.resolve().then(this._nextBound)["catch"](this.cancel.bind(this));
        }
      }
    }, {
      key: "_next",
      value: function () {
        var _next2 = _asyncToGenerator(
        /*#__PURE__*/
        _regenerator["default"].mark(function _callee() {
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!this.cancelled) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt("return");

                case 2:
                  this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);

                  if (this.operatorListIdx === this.operatorList.argsArray.length) {
                    this.running = false;

                    if (this.operatorList.lastChunk) {
                      this.gfx.endDrawing();

                      if (this._canvas) {
                        canvasInRendering["delete"](this._canvas);
                      }

                      this.callback();
                    }
                  }

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function _next() {
          return _next2.apply(this, arguments);
        }

        return _next;
      }()
    }]);

    return InternalRenderTask;
  }();

  return InternalRenderTask;
}();

var version = '2.2.228';
exports.version = version;
var build = 'd7afb74a';
exports.build = build;

/***/ }),
/* 148 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = __w_pdfjs_require__(149);

/***/ }),
/* 149 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var runtime = function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined;
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);
    generator._invoke = makeInvokeMethod(innerFn, self, context);
    return generator;
  }

  exports.wrap = wrap;

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};

  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      prototype[method] = function (arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor ? ctor === GeneratorFunction || (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
  };

  exports.mark = function (genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;

      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }

    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  exports.awrap = function (arg) {
    return {
      __await: arg
    };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;

        if (value && _typeof(value) === "object" && hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function (unwrapped) {
          result.value = unwrapped;
          resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    }

    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);

  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };

  exports.AsyncIterator = AsyncIterator;

  exports.async = function (innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;
    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;

        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);

          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;
        var record = tryCatch(innerFn, self, context);

        if (record.type === "normal") {
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted;
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (method === undefined) {
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator["return"]) {
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (!info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      context[delegate.resultName] = info.value;
      context.next = delegate.nextLoc;

      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }
    } else {
      return info;
    }

    context.delegate = null;
    return ContinueSentinel;
  }

  defineIteratorMethods(Gp);
  Gp[toStringTagSymbol] = "Generator";

  Gp[iteratorSymbol] = function () {
    return this;
  };

  Gp.toString = function () {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    keys.reverse();
    return function next() {
      while (keys.length) {
        var key = keys.pop();

        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];

      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;
          return next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  exports.values = values;

  function doneResult() {
    return {
      value: undefined,
      done: true
    };
  }

  Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;
      this.method = "next";
      this.arg = undefined;
      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },
    stop: function stop() {
      this.done = true;
      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;

      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;

      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          context.method = "next";
          context.arg = undefined;
        }

        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" || record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
  return exports;
}(( false ? undefined : _typeof(module)) === "object" ? module.exports : {});

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  Function("r", "regeneratorRuntime = r")(runtime);
}
/* WEBPACK VAR INJECTION */}.call(this, __w_pdfjs_require__(150)(module)))

/***/ }),
/* 150 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (module) {
  if (!module.webpackPolyfill) {
    module.deprecate = function () {};

    module.paths = [];
    if (!module.children) module.children = [];
    Object.defineProperty(module, "loaded", {
      enumerable: true,
      get: function get() {
        return module.l;
      }
    });
    Object.defineProperty(module, "id", {
      enumerable: true,
      get: function get() {
        return module.i;
      }
    });
    module.webpackPolyfill = 1;
  }

  return module;
};

/***/ }),
/* 151 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addLinkAttributes = addLinkAttributes;
exports.getFilenameFromUrl = getFilenameFromUrl;
exports.isFetchSupported = isFetchSupported;
exports.isValidFetchUrl = isValidFetchUrl;
exports.loadScript = loadScript;
exports.deprecated = deprecated;
exports.releaseImageResources = releaseImageResources;
exports.PDFDateString = exports.DummyStatTimer = exports.StatTimer = exports.DOMSVGFactory = exports.DOMCMapReaderFactory = exports.DOMCanvasFactory = exports.DEFAULT_LINK_REL = exports.LinkTarget = exports.RenderingCancelledException = exports.PageViewport = void 0;

var _regenerator = _interopRequireDefault(__w_pdfjs_require__(148));

var _util = __w_pdfjs_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DEFAULT_LINK_REL = 'noopener noreferrer nofollow';
exports.DEFAULT_LINK_REL = DEFAULT_LINK_REL;
var SVG_NS = 'http://www.w3.org/2000/svg';

var DOMCanvasFactory =
/*#__PURE__*/
function () {
  function DOMCanvasFactory() {
    _classCallCheck(this, DOMCanvasFactory);
  }

  _createClass(DOMCanvasFactory, [{
    key: "create",
    value: function create(width, height) {
      if (width <= 0 || height <= 0) {
        throw new Error('Invalid canvas size');
      }

      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = width;
      canvas.height = height;
      return {
        canvas: canvas,
        context: context
      };
    }
  }, {
    key: "reset",
    value: function reset(canvasAndContext, width, height) {
      if (!canvasAndContext.canvas) {
        throw new Error('Canvas is not specified');
      }

      if (width <= 0 || height <= 0) {
        throw new Error('Invalid canvas size');
      }

      canvasAndContext.canvas.width = width;
      canvasAndContext.canvas.height = height;
    }
  }, {
    key: "destroy",
    value: function destroy(canvasAndContext) {
      if (!canvasAndContext.canvas) {
        throw new Error('Canvas is not specified');
      }

      canvasAndContext.canvas.width = 0;
      canvasAndContext.canvas.height = 0;
      canvasAndContext.canvas = null;
      canvasAndContext.context = null;
    }
  }]);

  return DOMCanvasFactory;
}();

exports.DOMCanvasFactory = DOMCanvasFactory;

var DOMCMapReaderFactory =
/*#__PURE__*/
function () {
  function DOMCMapReaderFactory(_ref) {
    var _ref$baseUrl = _ref.baseUrl,
        baseUrl = _ref$baseUrl === void 0 ? null : _ref$baseUrl,
        _ref$isCompressed = _ref.isCompressed,
        isCompressed = _ref$isCompressed === void 0 ? false : _ref$isCompressed;

    _classCallCheck(this, DOMCMapReaderFactory);

    this.baseUrl = baseUrl;
    this.isCompressed = isCompressed;
  }

  _createClass(DOMCMapReaderFactory, [{
    key: "fetch",
    value: function (_fetch) {
      function fetch(_x) {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }(
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee2(_ref2) {
        var _this = this;

        var name, url, compressionType;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                name = _ref2.name;

                if (this.baseUrl) {
                  _context2.next = 3;
                  break;
                }

                throw new Error('The CMap "baseUrl" parameter must be specified, ensure that ' + 'the "cMapUrl" and "cMapPacked" API parameters are provided.');

              case 3:
                if (name) {
                  _context2.next = 5;
                  break;
                }

                throw new Error('CMap name must be specified.');

              case 5:
                url = this.baseUrl + name + (this.isCompressed ? '.bcmap' : '');
                compressionType = this.isCompressed ? _util.CMapCompressionType.BINARY : _util.CMapCompressionType.NONE;

                if (!(isFetchSupported() && isValidFetchUrl(url, document.baseURI))) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return", fetch(url).then(
                /*#__PURE__*/
                function () {
                  var _ref4 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regenerator["default"].mark(function _callee(response) {
                    var cMapData;
                    return _regenerator["default"].wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (response.ok) {
                              _context.next = 2;
                              break;
                            }

                            throw new Error(response.statusText);

                          case 2:
                            if (!_this.isCompressed) {
                              _context.next = 10;
                              break;
                            }

                            _context.t0 = Uint8Array;
                            _context.next = 6;
                            return response.arrayBuffer();

                          case 6:
                            _context.t1 = _context.sent;
                            cMapData = new _context.t0(_context.t1);
                            _context.next = 15;
                            break;

                          case 10:
                            _context.t2 = _util.stringToBytes;
                            _context.next = 13;
                            return response.text();

                          case 13:
                            _context.t3 = _context.sent;
                            cMapData = (0, _context.t2)(_context.t3);

                          case 15:
                            return _context.abrupt("return", {
                              cMapData: cMapData,
                              compressionType: compressionType
                            });

                          case 16:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x3) {
                    return _ref4.apply(this, arguments);
                  };
                }())["catch"](function (reason) {
                  throw new Error("Unable to load ".concat(_this.isCompressed ? 'binary ' : '') + "CMap at: ".concat(url));
                }));

              case 9:
                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  var request = new XMLHttpRequest();
                  request.open('GET', url, true);

                  if (_this.isCompressed) {
                    request.responseType = 'arraybuffer';
                  }

                  request.onreadystatechange = function () {
                    if (request.readyState !== XMLHttpRequest.DONE) {
                      return;
                    }

                    if (request.status === 200 || request.status === 0) {
                      var cMapData;

                      if (_this.isCompressed && request.response) {
                        cMapData = new Uint8Array(request.response);
                      } else if (!_this.isCompressed && request.responseText) {
                        cMapData = (0, _util.stringToBytes)(request.responseText);
                      }

                      if (cMapData) {
                        resolve({
                          cMapData: cMapData,
                          compressionType: compressionType
                        });
                        return;
                      }
                    }

                    reject(new Error(request.statusText));
                  };

                  request.send(null);
                })["catch"](function (reason) {
                  throw new Error("Unable to load ".concat(_this.isCompressed ? 'binary ' : '') + "CMap at: ".concat(url));
                }));

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }())
  }]);

  return DOMCMapReaderFactory;
}();

exports.DOMCMapReaderFactory = DOMCMapReaderFactory;

var DOMSVGFactory =
/*#__PURE__*/
function () {
  function DOMSVGFactory() {
    _classCallCheck(this, DOMSVGFactory);
  }

  _createClass(DOMSVGFactory, [{
    key: "create",
    value: function create(width, height) {
      (0, _util.assert)(width > 0 && height > 0, 'Invalid SVG dimensions');
      var svg = document.createElementNS(SVG_NS, 'svg:svg');
      svg.setAttribute('version', '1.1');
      svg.setAttribute('width', width + 'px');
      svg.setAttribute('height', height + 'px');
      svg.setAttribute('preserveAspectRatio', 'none');
      svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
      return svg;
    }
  }, {
    key: "createElement",
    value: function createElement(type) {
      (0, _util.assert)(typeof type === 'string', 'Invalid SVG element type');
      return document.createElementNS(SVG_NS, type);
    }
  }]);

  return DOMSVGFactory;
}();

exports.DOMSVGFactory = DOMSVGFactory;

var PageViewport =
/*#__PURE__*/
function () {
  function PageViewport(_ref5) {
    var viewBox = _ref5.viewBox,
        scale = _ref5.scale,
        rotation = _ref5.rotation,
        _ref5$offsetX = _ref5.offsetX,
        offsetX = _ref5$offsetX === void 0 ? 0 : _ref5$offsetX,
        _ref5$offsetY = _ref5.offsetY,
        offsetY = _ref5$offsetY === void 0 ? 0 : _ref5$offsetY,
        _ref5$dontFlip = _ref5.dontFlip,
        dontFlip = _ref5$dontFlip === void 0 ? false : _ref5$dontFlip;

    _classCallCheck(this, PageViewport);

    this.viewBox = viewBox;
    this.scale = scale;
    this.rotation = rotation;
    this.offsetX = offsetX;
    this.offsetY = offsetY;
    var centerX = (viewBox[2] + viewBox[0]) / 2;
    var centerY = (viewBox[3] + viewBox[1]) / 2;
    var rotateA, rotateB, rotateC, rotateD;
    rotation = rotation % 360;
    rotation = rotation < 0 ? rotation + 360 : rotation;

    switch (rotation) {
      case 180:
        rotateA = -1;
        rotateB = 0;
        rotateC = 0;
        rotateD = 1;
        break;

      case 90:
        rotateA = 0;
        rotateB = 1;
        rotateC = 1;
        rotateD = 0;
        break;

      case 270:
        rotateA = 0;
        rotateB = -1;
        rotateC = -1;
        rotateD = 0;
        break;

      default:
        rotateA = 1;
        rotateB = 0;
        rotateC = 0;
        rotateD = -1;
        break;
    }

    if (dontFlip) {
      rotateC = -rotateC;
      rotateD = -rotateD;
    }

    var offsetCanvasX, offsetCanvasY;
    var width, height;

    if (rotateA === 0) {
      offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
      offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
      width = Math.abs(viewBox[3] - viewBox[1]) * scale;
      height = Math.abs(viewBox[2] - viewBox[0]) * scale;
    } else {
      offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
      offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
      width = Math.abs(viewBox[2] - viewBox[0]) * scale;
      height = Math.abs(viewBox[3] - viewBox[1]) * scale;
    }

    this.transform = [rotateA * scale, rotateB * scale, rotateC * scale, rotateD * scale, offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY, offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY];
    this.width = width;
    this.height = height;
  }

  _createClass(PageViewport, [{
    key: "clone",
    value: function clone() {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref6$scale = _ref6.scale,
          scale = _ref6$scale === void 0 ? this.scale : _ref6$scale,
          _ref6$rotation = _ref6.rotation,
          rotation = _ref6$rotation === void 0 ? this.rotation : _ref6$rotation,
          _ref6$dontFlip = _ref6.dontFlip,
          dontFlip = _ref6$dontFlip === void 0 ? false : _ref6$dontFlip;

      return new PageViewport({
        viewBox: this.viewBox.slice(),
        scale: scale,
        rotation: rotation,
        offsetX: this.offsetX,
        offsetY: this.offsetY,
        dontFlip: dontFlip
      });
    }
  }, {
    key: "convertToViewportPoint",
    value: function convertToViewportPoint(x, y) {
      return _util.Util.applyTransform([x, y], this.transform);
    }
  }, {
    key: "convertToViewportRectangle",
    value: function convertToViewportRectangle(rect) {
      var topLeft = _util.Util.applyTransform([rect[0], rect[1]], this.transform);

      var bottomRight = _util.Util.applyTransform([rect[2], rect[3]], this.transform);

      return [topLeft[0], topLeft[1], bottomRight[0], bottomRight[1]];
    }
  }, {
    key: "convertToPdfPoint",
    value: function convertToPdfPoint(x, y) {
      return _util.Util.applyInverseTransform([x, y], this.transform);
    }
  }]);

  return PageViewport;
}();

exports.PageViewport = PageViewport;

var RenderingCancelledException = function RenderingCancelledException() {
  function RenderingCancelledException(msg, type) {
    this.message = msg;
    this.type = type;
  }

  RenderingCancelledException.prototype = new Error();
  RenderingCancelledException.prototype.name = 'RenderingCancelledException';
  RenderingCancelledException.constructor = RenderingCancelledException;
  return RenderingCancelledException;
}();

exports.RenderingCancelledException = RenderingCancelledException;
var LinkTarget = {
  NONE: 0,
  SELF: 1,
  BLANK: 2,
  PARENT: 3,
  TOP: 4
};
exports.LinkTarget = LinkTarget;
var LinkTargetStringMap = ['', '_self', '_blank', '_parent', '_top'];

function addLinkAttributes(link) {
  var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      url = _ref7.url,
      target = _ref7.target,
      rel = _ref7.rel;

  link.href = link.title = url ? (0, _util.removeNullCharacters)(url) : '';

  if (url) {
    var LinkTargetValues = Object.values(LinkTarget);
    var targetIndex = LinkTargetValues.includes(target) ? target : LinkTarget.NONE;
    link.target = LinkTargetStringMap[targetIndex];
    link.rel = typeof rel === 'string' ? rel : DEFAULT_LINK_REL;
  }
}

function getFilenameFromUrl(url) {
  var anchor = url.indexOf('#');
  var query = url.indexOf('?');
  var end = Math.min(anchor > 0 ? anchor : url.length, query > 0 ? query : url.length);
  return url.substring(url.lastIndexOf('/', end) + 1, end);
}

var StatTimer =
/*#__PURE__*/
function () {
  function StatTimer() {
    var enable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    _classCallCheck(this, StatTimer);

    this.enabled = !!enable;
    this.started = Object.create(null);
    this.times = [];
  }

  _createClass(StatTimer, [{
    key: "time",
    value: function time(name) {
      if (!this.enabled) {
        return;
      }

      if (name in this.started) {
        (0, _util.warn)('Timer is already running for ' + name);
      }

      this.started[name] = Date.now();
    }
  }, {
    key: "timeEnd",
    value: function timeEnd(name) {
      if (!this.enabled) {
        return;
      }

      if (!(name in this.started)) {
        (0, _util.warn)('Timer has not been started for ' + name);
      }

      this.times.push({
        'name': name,
        'start': this.started[name],
        'end': Date.now()
      });
      delete this.started[name];
    }
  }, {
    key: "toString",
    value: function toString() {
      var out = '',
          longest = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.times[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var time = _step.value;
          var name = time.name;

          if (name.length > longest) {
            longest = name.length;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.times[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _time = _step2.value;
          var duration = _time.end - _time.start;
          out += "".concat(_time.name.padEnd(longest), " ").concat(duration, "ms\n");
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return out;
    }
  }]);

  return StatTimer;
}();

exports.StatTimer = StatTimer;

var DummyStatTimer =
/*#__PURE__*/
function () {
  function DummyStatTimer() {
    _classCallCheck(this, DummyStatTimer);

    (0, _util.unreachable)('Cannot initialize DummyStatTimer.');
  }

  _createClass(DummyStatTimer, null, [{
    key: "time",
    value: function time(name) {}
  }, {
    key: "timeEnd",
    value: function timeEnd(name) {}
  }, {
    key: "toString",
    value: function toString() {
      return '';
    }
  }]);

  return DummyStatTimer;
}();

exports.DummyStatTimer = DummyStatTimer;

function isFetchSupported() {
  return typeof fetch !== 'undefined' && typeof Response !== 'undefined' && 'body' in Response.prototype && typeof ReadableStream !== 'undefined';
}

function isValidFetchUrl(url, baseUrl) {
  try {
    var _ref8 = baseUrl ? new _util.URL(url, baseUrl) : new _util.URL(url),
        protocol = _ref8.protocol;

    return protocol === 'http:' || protocol === 'https:';
  } catch (ex) {
    return false;
  }
}

function loadScript(src) {
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.src = src;
    script.onload = resolve;

    script.onerror = function () {
      reject(new Error("Cannot load script at: ".concat(script.src)));
    };

    (document.head || document.documentElement).appendChild(script);
  });
}

function deprecated(details) {
  console.log('Deprecated API usage: ' + details);
}

function releaseImageResources(img) {
  (0, _util.assert)(img instanceof Image, 'Invalid `img` parameter.');
  var url = img.src;

  if (typeof url === 'string' && url.startsWith('blob:') && _util.URL.revokeObjectURL) {
    _util.URL.revokeObjectURL(url);
  }

  img.removeAttribute('src');
}

var pdfDateStringRegex;

var PDFDateString =
/*#__PURE__*/
function () {
  function PDFDateString() {
    _classCallCheck(this, PDFDateString);
  }

  _createClass(PDFDateString, null, [{
    key: "toDateObject",
    value: function toDateObject(input) {
      if (!input || !(0, _util.isString)(input)) {
        return null;
      }

      if (!pdfDateStringRegex) {
        pdfDateStringRegex = new RegExp('^D:' + '(\\d{4})' + '(\\d{2})?' + '(\\d{2})?' + '(\\d{2})?' + '(\\d{2})?' + '(\\d{2})?' + '([Z|+|-])?' + '(\\d{2})?' + '\'?' + '(\\d{2})?' + '\'?');
      }

      var matches = pdfDateStringRegex.exec(input);

      if (!matches) {
        return null;
      }

      var year = parseInt(matches[1], 10);
      var month = parseInt(matches[2], 10);
      month = month >= 1 && month <= 12 ? month - 1 : 0;
      var day = parseInt(matches[3], 10);
      day = day >= 1 && day <= 31 ? day : 1;
      var hour = parseInt(matches[4], 10);
      hour = hour >= 0 && hour <= 23 ? hour : 0;
      var minute = parseInt(matches[5], 10);
      minute = minute >= 0 && minute <= 59 ? minute : 0;
      var second = parseInt(matches[6], 10);
      second = second >= 0 && second <= 59 ? second : 0;
      var universalTimeRelation = matches[7] || 'Z';
      var offsetHour = parseInt(matches[8], 10);
      offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0;
      var offsetMinute = parseInt(matches[9], 10) || 0;
      offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0;

      if (universalTimeRelation === '-') {
        hour += offsetHour;
        minute += offsetMinute;
      } else if (universalTimeRelation === '+') {
        hour -= offsetHour;
        minute -= offsetMinute;
      }

      return new Date(Date.UTC(year, month, day, hour, minute, second));
    }
  }]);

  return PDFDateString;
}();

exports.PDFDateString = PDFDateString;

/***/ }),
/* 152 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontLoader = exports.FontFaceObject = void 0;

var _regenerator = _interopRequireDefault(__w_pdfjs_require__(148));

var _util = __w_pdfjs_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var BaseFontLoader =
/*#__PURE__*/
function () {
  function BaseFontLoader(_ref) {
    var docId = _ref.docId,
        onUnsupportedFeature = _ref.onUnsupportedFeature;

    _classCallCheck(this, BaseFontLoader);

    if (this.constructor === BaseFontLoader) {
      (0, _util.unreachable)('Cannot initialize BaseFontLoader.');
    }

    this.docId = docId;
    this._onUnsupportedFeature = onUnsupportedFeature;
    this.nativeFontFaces = [];
    this.styleElement = null;
  }

  _createClass(BaseFontLoader, [{
    key: "addNativeFontFace",
    value: function addNativeFontFace(nativeFontFace) {
      this.nativeFontFaces.push(nativeFontFace);
      document.fonts.add(nativeFontFace);
    }
  }, {
    key: "insertRule",
    value: function insertRule(rule) {
      var styleElement = this.styleElement;

      if (!styleElement) {
        styleElement = this.styleElement = document.createElement('style');
        styleElement.id = "PDFJS_FONT_STYLE_TAG_".concat(this.docId);
        document.documentElement.getElementsByTagName('head')[0].appendChild(styleElement);
      }

      var styleSheet = styleElement.sheet;
      styleSheet.insertRule(rule, styleSheet.cssRules.length);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.nativeFontFaces.forEach(function (nativeFontFace) {
        document.fonts["delete"](nativeFontFace);
      });
      this.nativeFontFaces.length = 0;

      if (this.styleElement) {
        this.styleElement.remove();
        this.styleElement = null;
      }
    }
  }, {
    key: "bind",
    value: function () {
      var _bind = _asyncToGenerator(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee(font) {
        var _this = this;

        var nativeFontFace, rule;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(font.attached || font.missingFile)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", undefined);

              case 2:
                font.attached = true;

                if (!this.isFontLoadingAPISupported) {
                  _context.next = 19;
                  break;
                }

                nativeFontFace = font.createNativeFontFace();

                if (!nativeFontFace) {
                  _context.next = 18;
                  break;
                }

                this.addNativeFontFace(nativeFontFace);
                _context.prev = 7;
                _context.next = 10;
                return nativeFontFace.loaded;

              case 10:
                _context.next = 18;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](7);

                this._onUnsupportedFeature({
                  featureId: _util.UNSUPPORTED_FEATURES.font
                });

                (0, _util.warn)("Failed to load font '".concat(nativeFontFace.family, "': '").concat(_context.t0, "'."));
                font.disableFontFace = true;
                throw _context.t0;

              case 18:
                return _context.abrupt("return", undefined);

              case 19:
                rule = font.createFontFaceRule();

                if (!rule) {
                  _context.next = 25;
                  break;
                }

                this.insertRule(rule);

                if (!this.isSyncFontLoadingSupported) {
                  _context.next = 24;
                  break;
                }

                return _context.abrupt("return", undefined);

              case 24:
                return _context.abrupt("return", new Promise(function (resolve) {
                  var request = _this._queueLoadingCallback(resolve);

                  _this._prepareFontLoadEvent([rule], [font], request);
                }));

              case 25:
                return _context.abrupt("return", undefined);

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 12]]);
      }));

      function bind(_x) {
        return _bind.apply(this, arguments);
      }

      return bind;
    }()
  }, {
    key: "_queueLoadingCallback",
    value: function _queueLoadingCallback(callback) {
      (0, _util.unreachable)('Abstract method `_queueLoadingCallback`.');
    }
  }, {
    key: "_prepareFontLoadEvent",
    value: function _prepareFontLoadEvent(rules, fontsToLoad, request) {
      (0, _util.unreachable)('Abstract method `_prepareFontLoadEvent`.');
    }
  }, {
    key: "isFontLoadingAPISupported",
    get: function get() {
      (0, _util.unreachable)('Abstract method `isFontLoadingAPISupported`.');
    }
  }, {
    key: "isSyncFontLoadingSupported",
    get: function get() {
      (0, _util.unreachable)('Abstract method `isSyncFontLoadingSupported`.');
    }
  }, {
    key: "_loadTestFont",
    get: function get() {
      (0, _util.unreachable)('Abstract method `_loadTestFont`.');
    }
  }]);

  return BaseFontLoader;
}();

var FontLoader;
exports.FontLoader = FontLoader;
{
  exports.FontLoader = FontLoader =
  /*#__PURE__*/
  function (_BaseFontLoader) {
    _inherits(GenericFontLoader, _BaseFontLoader);

    function GenericFontLoader(docId) {
      var _this2;

      _classCallCheck(this, GenericFontLoader);

      _this2 = _possibleConstructorReturn(this, _getPrototypeOf(GenericFontLoader).call(this, docId));
      _this2.loadingContext = {
        requests: [],
        nextRequestId: 0
      };
      _this2.loadTestFontId = 0;
      return _this2;
    }

    _createClass(GenericFontLoader, [{
      key: "_queueLoadingCallback",
      value: function _queueLoadingCallback(callback) {
        function completeRequest() {
          (0, _util.assert)(!request.done, 'completeRequest() cannot be called twice.');
          request.done = true;

          while (context.requests.length > 0 && context.requests[0].done) {
            var otherRequest = context.requests.shift();
            setTimeout(otherRequest.callback, 0);
          }
        }

        var context = this.loadingContext;
        var request = {
          id: "pdfjs-font-loading-".concat(context.nextRequestId++),
          done: false,
          complete: completeRequest,
          callback: callback
        };
        context.requests.push(request);
        return request;
      }
    }, {
      key: "_prepareFontLoadEvent",
      value: function _prepareFontLoadEvent(rules, fonts, request) {
        function int32(data, offset) {
          return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
        }

        function spliceString(s, offset, remove, insert) {
          var chunk1 = s.substring(0, offset);
          var chunk2 = s.substring(offset + remove);
          return chunk1 + insert + chunk2;
        }

        var i, ii;
        var canvas = document.createElement('canvas');
        canvas.width = 1;
        canvas.height = 1;
        var ctx = canvas.getContext('2d');
        var called = 0;

        function isFontReady(name, callback) {
          called++;

          if (called > 30) {
            (0, _util.warn)('Load test font never loaded.');
            callback();
            return;
          }

          ctx.font = '30px ' + name;
          ctx.fillText('.', 0, 20);
          var imageData = ctx.getImageData(0, 0, 1, 1);

          if (imageData.data[3] > 0) {
            callback();
            return;
          }

          setTimeout(isFontReady.bind(null, name, callback));
        }

        var loadTestFontId = "lt".concat(Date.now()).concat(this.loadTestFontId++);
        var data = this._loadTestFont;
        var COMMENT_OFFSET = 976;
        data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
        var CFF_CHECKSUM_OFFSET = 16;
        var XXXX_VALUE = 0x58585858;
        var checksum = int32(data, CFF_CHECKSUM_OFFSET);

        for (i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4) {
          checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
        }

        if (i < loadTestFontId.length) {
          checksum = checksum - XXXX_VALUE + int32(loadTestFontId + 'XXX', i) | 0;
        }

        data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, (0, _util.string32)(checksum));
        var url = "url(data:font/opentype;base64,".concat(btoa(data), ");");
        var rule = "@font-face {font-family:\"".concat(loadTestFontId, "\";src:").concat(url, "}");
        this.insertRule(rule);
        var names = [];

        for (i = 0, ii = fonts.length; i < ii; i++) {
          names.push(fonts[i].loadedName);
        }

        names.push(loadTestFontId);
        var div = document.createElement('div');
        div.setAttribute('style', 'visibility: hidden;' + 'width: 10px; height: 10px;' + 'position: absolute; top: 0px; left: 0px;');

        for (i = 0, ii = names.length; i < ii; ++i) {
          var span = document.createElement('span');
          span.textContent = 'Hi';
          span.style.fontFamily = names[i];
          div.appendChild(span);
        }

        document.body.appendChild(div);
        isFontReady(loadTestFontId, function () {
          document.body.removeChild(div);
          request.complete();
        });
      }
    }, {
      key: "isFontLoadingAPISupported",
      get: function get() {
        var supported = typeof document !== 'undefined' && !!document.fonts;

        if (supported && typeof navigator !== 'undefined') {
          var m = /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent);

          if (m && m[1] < 63) {
            supported = false;
          }
        }

        return (0, _util.shadow)(this, 'isFontLoadingAPISupported', supported);
      }
    }, {
      key: "isSyncFontLoadingSupported",
      get: function get() {
        var supported = false;

        if (typeof navigator === 'undefined') {
          supported = true;
        } else {
          var m = /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent);

          if (m && m[1] >= 14) {
            supported = true;
          }
        }

        return (0, _util.shadow)(this, 'isSyncFontLoadingSupported', supported);
      }
    }, {
      key: "_loadTestFont",
      get: function get() {
        var getLoadTestFont = function getLoadTestFont() {
          return atob('T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQA' + 'FQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAA' + 'ALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgA' + 'AAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1' + 'AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD' + '6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACM' + 'AooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4D' + 'IP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAA' + 'AAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUA' + 'AQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgAB' + 'AAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABY' + 'AAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAA' + 'AC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAA' + 'AAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQAC' + 'AQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3' + 'Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTj' + 'FQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==');
        };

        return (0, _util.shadow)(this, '_loadTestFont', getLoadTestFont());
      }
    }]);

    return GenericFontLoader;
  }(BaseFontLoader);
}
var IsEvalSupportedCached = {
  get value() {
    return (0, _util.shadow)(this, 'value', (0, _util.isEvalSupported)());
  }

};

var FontFaceObject =
/*#__PURE__*/
function () {
  function FontFaceObject(translatedData, _ref2) {
    var _ref2$isEvalSupported = _ref2.isEvalSupported,
        isEvalSupported = _ref2$isEvalSupported === void 0 ? true : _ref2$isEvalSupported,
        _ref2$disableFontFace = _ref2.disableFontFace,
        disableFontFace = _ref2$disableFontFace === void 0 ? false : _ref2$disableFontFace,
        _ref2$ignoreErrors = _ref2.ignoreErrors,
        ignoreErrors = _ref2$ignoreErrors === void 0 ? false : _ref2$ignoreErrors,
        _ref2$onUnsupportedFe = _ref2.onUnsupportedFeature,
        onUnsupportedFeature = _ref2$onUnsupportedFe === void 0 ? null : _ref2$onUnsupportedFe,
        _ref2$fontRegistry = _ref2.fontRegistry,
        fontRegistry = _ref2$fontRegistry === void 0 ? null : _ref2$fontRegistry;

    _classCallCheck(this, FontFaceObject);

    this.compiledGlyphs = Object.create(null);

    for (var i in translatedData) {
      this[i] = translatedData[i];
    }

    this.isEvalSupported = isEvalSupported !== false;
    this.disableFontFace = disableFontFace === true;
    this.ignoreErrors = ignoreErrors === true;
    this._onUnsupportedFeature = onUnsupportedFeature;
    this.fontRegistry = fontRegistry;
  }

  _createClass(FontFaceObject, [{
    key: "createNativeFontFace",
    value: function createNativeFontFace() {
      if (!this.data || this.disableFontFace) {
        return null;
      }

      var nativeFontFace = new FontFace(this.loadedName, this.data, {});

      if (this.fontRegistry) {
        this.fontRegistry.registerFont(this);
      }

      return nativeFontFace;
    }
  }, {
    key: "createFontFaceRule",
    value: function createFontFaceRule() {
      if (!this.data || this.disableFontFace) {
        return null;
      }

      var data = (0, _util.bytesToString)(new Uint8Array(this.data));
      var url = "url(data:".concat(this.mimetype, ";base64,").concat(btoa(data), ");");
      var rule = "@font-face {font-family:\"".concat(this.loadedName, "\";src:").concat(url, "}");

      if (this.fontRegistry) {
        this.fontRegistry.registerFont(this, url);
      }

      return rule;
    }
  }, {
    key: "getPathGenerator",
    value: function getPathGenerator(objs, character) {
      if (this.compiledGlyphs[character] !== undefined) {
        return this.compiledGlyphs[character];
      }

      var cmds, current;

      try {
        cmds = objs.get(this.loadedName + '_path_' + character);
      } catch (ex) {
        if (!this.ignoreErrors) {
          throw ex;
        }

        if (this._onUnsupportedFeature) {
          this._onUnsupportedFeature({
            featureId: _util.UNSUPPORTED_FEATURES.font
          });
        }

        (0, _util.warn)("getPathGenerator - ignoring character: \"".concat(ex, "\"."));
        return this.compiledGlyphs[character] = function (c, size) {};
      }

      if (this.isEvalSupported && IsEvalSupportedCached.value) {
        var args,
            js = '';

        for (var i = 0, ii = cmds.length; i < ii; i++) {
          current = cmds[i];

          if (current.args !== undefined) {
            args = current.args.join(',');
          } else {
            args = '';
          }

          js += 'c.' + current.cmd + '(' + args + ');\n';
        }

        return this.compiledGlyphs[character] = new Function('c', 'size', js);
      }

      return this.compiledGlyphs[character] = function (c, size) {
        for (var _i = 0, _ii = cmds.length; _i < _ii; _i++) {
          current = cmds[_i];

          if (current.cmd === 'scale') {
            current.args = [size, -size];
          }

          c[current.cmd].apply(c, current.args);
        }
      };
    }
  }]);

  return FontFaceObject;
}();

exports.FontFaceObject = FontFaceObject;

/***/ }),
/* 153 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var compatibilityParams = Object.create(null);
{
  var isNodeJS = __w_pdfjs_require__(4);

  var userAgent = typeof navigator !== 'undefined' && navigator.userAgent || '';
  var isIE = /Trident/.test(userAgent);
  var isIOSChrome = /CriOS/.test(userAgent);

  (function checkOnBlobSupport() {
    if (isIE || isIOSChrome) {
      compatibilityParams.disableCreateObjectURL = true;
    }
  })();

  (function checkFontFaceAndImage() {
    if (isNodeJS()) {
      compatibilityParams.disableFontFace = true;
      compatibilityParams.nativeImageDecoderSupport = 'none';
    }
  })();
}
exports.apiCompatibilityParams = Object.freeze(compatibilityParams);

/***/ }),
/* 154 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CanvasGraphics = void 0;

var _util = __w_pdfjs_require__(1);

var _pattern_helper = __w_pdfjs_require__(155);

var MIN_FONT_SIZE = 16;
var MAX_FONT_SIZE = 100;
var MAX_GROUP_SIZE = 4096;
var MIN_WIDTH_FACTOR = 0.65;
var COMPILE_TYPE3_GLYPHS = true;
var MAX_SIZE_TO_COMPILE = 1000;
var FULL_CHUNK_HEIGHT = 16;
var IsLittleEndianCached = {
  get value() {
    return (0, _util.shadow)(IsLittleEndianCached, 'value', (0, _util.isLittleEndian)());
  }

};

function addContextCurrentTransform(ctx) {
  if (!ctx.mozCurrentTransform) {
    ctx._originalSave = ctx.save;
    ctx._originalRestore = ctx.restore;
    ctx._originalRotate = ctx.rotate;
    ctx._originalScale = ctx.scale;
    ctx._originalTranslate = ctx.translate;
    ctx._originalTransform = ctx.transform;
    ctx._originalSetTransform = ctx.setTransform;
    ctx._transformMatrix = ctx._transformMatrix || [1, 0, 0, 1, 0, 0];
    ctx._transformStack = [];
    Object.defineProperty(ctx, 'mozCurrentTransform', {
      get: function getCurrentTransform() {
        return this._transformMatrix;
      }
    });
    Object.defineProperty(ctx, 'mozCurrentTransformInverse', {
      get: function getCurrentTransformInverse() {
        var m = this._transformMatrix;
        var a = m[0],
            b = m[1],
            c = m[2],
            d = m[3],
            e = m[4],
            f = m[5];
        var ad_bc = a * d - b * c;
        var bc_ad = b * c - a * d;
        return [d / ad_bc, b / bc_ad, c / bc_ad, a / ad_bc, (d * e - c * f) / bc_ad, (b * e - a * f) / ad_bc];
      }
    });

    ctx.save = function ctxSave() {
      var old = this._transformMatrix;

      this._transformStack.push(old);

      this._transformMatrix = old.slice(0, 6);

      this._originalSave();
    };

    ctx.restore = function ctxRestore() {
      var prev = this._transformStack.pop();

      if (prev) {
        this._transformMatrix = prev;

        this._originalRestore();
      }
    };

    ctx.translate = function ctxTranslate(x, y) {
      var m = this._transformMatrix;
      m[4] = m[0] * x + m[2] * y + m[4];
      m[5] = m[1] * x + m[3] * y + m[5];

      this._originalTranslate(x, y);
    };

    ctx.scale = function ctxScale(x, y) {
      var m = this._transformMatrix;
      m[0] = m[0] * x;
      m[1] = m[1] * x;
      m[2] = m[2] * y;
      m[3] = m[3] * y;

      this._originalScale(x, y);
    };

    ctx.transform = function ctxTransform(a, b, c, d, e, f) {
      var m = this._transformMatrix;
      this._transformMatrix = [m[0] * a + m[2] * b, m[1] * a + m[3] * b, m[0] * c + m[2] * d, m[1] * c + m[3] * d, m[0] * e + m[2] * f + m[4], m[1] * e + m[3] * f + m[5]];

      ctx._originalTransform(a, b, c, d, e, f);
    };

    ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
      this._transformMatrix = [a, b, c, d, e, f];

      ctx._originalSetTransform(a, b, c, d, e, f);
    };

    ctx.rotate = function ctxRotate(angle) {
      var cosValue = Math.cos(angle);
      var sinValue = Math.sin(angle);
      var m = this._transformMatrix;
      this._transformMatrix = [m[0] * cosValue + m[2] * sinValue, m[1] * cosValue + m[3] * sinValue, m[0] * -sinValue + m[2] * cosValue, m[1] * -sinValue + m[3] * cosValue, m[4], m[5]];

      this._originalRotate(angle);
    };
  }
}

var CachedCanvases = function CachedCanvasesClosure() {
  function CachedCanvases(canvasFactory) {
    this.canvasFactory = canvasFactory;
    this.cache = Object.create(null);
  }

  CachedCanvases.prototype = {
    getCanvas: function CachedCanvases_getCanvas(id, width, height, trackTransform) {
      var canvasEntry;

      if (this.cache[id] !== undefined) {
        canvasEntry = this.cache[id];
        this.canvasFactory.reset(canvasEntry, width, height);
        canvasEntry.context.setTransform(1, 0, 0, 1, 0, 0);
      } else {
        canvasEntry = this.canvasFactory.create(width, height);
        this.cache[id] = canvasEntry;
      }

      if (trackTransform) {
        addContextCurrentTransform(canvasEntry.context);
      }

      return canvasEntry;
    },
    clear: function clear() {
      for (var id in this.cache) {
        var canvasEntry = this.cache[id];
        this.canvasFactory.destroy(canvasEntry);
        delete this.cache[id];
      }
    }
  };
  return CachedCanvases;
}();

function compileType3Glyph(imgData) {
  var POINT_TO_PROCESS_LIMIT = 1000;
  var width = imgData.width,
      height = imgData.height;
  var i,
      j,
      j0,
      width1 = width + 1;
  var points = new Uint8Array(width1 * (height + 1));
  var POINT_TYPES = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]);
  var lineSize = width + 7 & ~7,
      data0 = imgData.data;
  var data = new Uint8Array(lineSize * height),
      pos = 0,
      ii;

  for (i = 0, ii = data0.length; i < ii; i++) {
    var mask = 128,
        elem = data0[i];

    while (mask > 0) {
      data[pos++] = elem & mask ? 0 : 255;
      mask >>= 1;
    }
  }

  var count = 0;
  pos = 0;

  if (data[pos] !== 0) {
    points[0] = 1;
    ++count;
  }

  for (j = 1; j < width; j++) {
    if (data[pos] !== data[pos + 1]) {
      points[j] = data[pos] ? 2 : 1;
      ++count;
    }

    pos++;
  }

  if (data[pos] !== 0) {
    points[j] = 2;
    ++count;
  }

  for (i = 1; i < height; i++) {
    pos = i * lineSize;
    j0 = i * width1;

    if (data[pos - lineSize] !== data[pos]) {
      points[j0] = data[pos] ? 1 : 8;
      ++count;
    }

    var sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);

    for (j = 1; j < width; j++) {
      sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);

      if (POINT_TYPES[sum]) {
        points[j0 + j] = POINT_TYPES[sum];
        ++count;
      }

      pos++;
    }

    if (data[pos - lineSize] !== data[pos]) {
      points[j0 + j] = data[pos] ? 2 : 4;
      ++count;
    }

    if (count > POINT_TO_PROCESS_LIMIT) {
      return null;
    }
  }

  pos = lineSize * (height - 1);
  j0 = i * width1;

  if (data[pos] !== 0) {
    points[j0] = 8;
    ++count;
  }

  for (j = 1; j < width; j++) {
    if (data[pos] !== data[pos + 1]) {
      points[j0 + j] = data[pos] ? 4 : 8;
      ++count;
    }

    pos++;
  }

  if (data[pos] !== 0) {
    points[j0 + j] = 4;
    ++count;
  }

  if (count > POINT_TO_PROCESS_LIMIT) {
    return null;
  }

  var steps = new Int32Array([0, width1, -1, 0, -width1, 0, 0, 0, 1]);
  var outlines = [];

  for (i = 0; count && i <= height; i++) {
    var p = i * width1;
    var end = p + width;

    while (p < end && !points[p]) {
      p++;
    }

    if (p === end) {
      continue;
    }

    var coords = [p % width1, i];
    var type = points[p],
        p0 = p,
        pp;

    do {
      var step = steps[type];

      do {
        p += step;
      } while (!points[p]);

      pp = points[p];

      if (pp !== 5 && pp !== 10) {
        type = pp;
        points[p] = 0;
      } else {
        type = pp & 0x33 * type >> 4;
        points[p] &= type >> 2 | type << 2;
      }

      coords.push(p % width1);
      coords.push(p / width1 | 0);

      if (!points[p]) {
        --count;
      }
    } while (p0 !== p);

    outlines.push(coords);
    --i;
  }

  var drawOutline = function drawOutline(c) {
    c.save();
    c.scale(1 / width, -1 / height);
    c.translate(0, -height);
    c.beginPath();

    for (var i = 0, ii = outlines.length; i < ii; i++) {
      var o = outlines[i];
      c.moveTo(o[0], o[1]);

      for (var j = 2, jj = o.length; j < jj; j += 2) {
        c.lineTo(o[j], o[j + 1]);
      }
    }

    c.fill();
    c.beginPath();
    c.restore();
  };

  return drawOutline;
}

var CanvasExtraState = function CanvasExtraStateClosure() {
  function CanvasExtraState() {
    this.alphaIsShape = false;
    this.fontSize = 0;
    this.fontSizeScale = 1;
    this.textMatrix = _util.IDENTITY_MATRIX;
    this.textMatrixScale = 1;
    this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
    this.leading = 0;
    this.x = 0;
    this.y = 0;
    this.lineX = 0;
    this.lineY = 0;
    this.charSpacing = 0;
    this.wordSpacing = 0;
    this.textHScale = 1;
    this.textRenderingMode = _util.TextRenderingMode.FILL;
    this.textRise = 0;
    this.fillColor = '#000000';
    this.strokeColor = '#000000';
    this.patternFill = false;
    this.fillAlpha = 1;
    this.strokeAlpha = 1;
    this.lineWidth = 1;
    this.activeSMask = null;
    this.resumeSMaskCtx = null;
  }

  CanvasExtraState.prototype = {
    clone: function CanvasExtraState_clone() {
      return Object.create(this);
    },
    setCurrentPoint: function CanvasExtraState_setCurrentPoint(x, y) {
      this.x = x;
      this.y = y;
    }
  };
  return CanvasExtraState;
}();

var CanvasGraphics = function CanvasGraphicsClosure() {
  var EXECUTION_TIME = 15;
  var EXECUTION_STEPS = 10;

  function CanvasGraphics(canvasCtx, commonObjs, objs, canvasFactory, webGLContext, imageLayer) {
    this.ctx = canvasCtx;
    this.current = new CanvasExtraState();
    this.stateStack = [];
    this.pendingClip = null;
    this.pendingEOFill = false;
    this.res = null;
    this.xobjs = null;
    this.commonObjs = commonObjs;
    this.objs = objs;
    this.canvasFactory = canvasFactory;
    this.webGLContext = webGLContext;
    this.imageLayer = imageLayer;
    this.groupStack = [];
    this.processingType3 = null;
    this.baseTransform = null;
    this.baseTransformStack = [];
    this.groupLevel = 0;
    this.smaskStack = [];
    this.smaskCounter = 0;
    this.tempSMask = null;
    this.cachedCanvases = new CachedCanvases(this.canvasFactory);

    if (canvasCtx) {
      addContextCurrentTransform(canvasCtx);
    }

    this._cachedGetSinglePixelWidth = null;
  }

  function putBinaryImageData(ctx, imgData) {
    if (typeof ImageData !== 'undefined' && imgData instanceof ImageData) {
      ctx.putImageData(imgData, 0, 0);
      return;
    }

    var height = imgData.height,
        width = imgData.width;
    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
    var srcPos = 0,
        destPos;
    var src = imgData.data;
    var dest = chunkImgData.data;
    var i, j, thisChunkHeight, elemsInThisChunk;

    if (imgData.kind === _util.ImageKind.GRAYSCALE_1BPP) {
      var srcLength = src.byteLength;
      var dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
      var dest32DataLength = dest32.length;
      var fullSrcDiff = width + 7 >> 3;
      var white = 0xFFFFFFFF;
      var black = IsLittleEndianCached.value ? 0xFF000000 : 0x000000FF;

      for (i = 0; i < totalChunks; i++) {
        thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
        destPos = 0;

        for (j = 0; j < thisChunkHeight; j++) {
          var srcDiff = srcLength - srcPos;
          var k = 0;
          var kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
          var kEndUnrolled = kEnd & ~7;
          var mask = 0;
          var srcByte = 0;

          for (; k < kEndUnrolled; k += 8) {
            srcByte = src[srcPos++];
            dest32[destPos++] = srcByte & 128 ? white : black;
            dest32[destPos++] = srcByte & 64 ? white : black;
            dest32[destPos++] = srcByte & 32 ? white : black;
            dest32[destPos++] = srcByte & 16 ? white : black;
            dest32[destPos++] = srcByte & 8 ? white : black;
            dest32[destPos++] = srcByte & 4 ? white : black;
            dest32[destPos++] = srcByte & 2 ? white : black;
            dest32[destPos++] = srcByte & 1 ? white : black;
          }

          for (; k < kEnd; k++) {
            if (mask === 0) {
              srcByte = src[srcPos++];
              mask = 128;
            }

            dest32[destPos++] = srcByte & mask ? white : black;
            mask >>= 1;
          }
        }

        while (destPos < dest32DataLength) {
          dest32[destPos++] = 0;
        }

        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
      }
    } else if (imgData.kind === _util.ImageKind.RGBA_32BPP) {
      j = 0;
      elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;

      for (i = 0; i < fullChunks; i++) {
        dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
        srcPos += elemsInThisChunk;
        ctx.putImageData(chunkImgData, 0, j);
        j += FULL_CHUNK_HEIGHT;
      }

      if (i < totalChunks) {
        elemsInThisChunk = width * partialChunkHeight * 4;
        dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
        ctx.putImageData(chunkImgData, 0, j);
      }
    } else if (imgData.kind === _util.ImageKind.RGB_24BPP) {
      thisChunkHeight = FULL_CHUNK_HEIGHT;
      elemsInThisChunk = width * thisChunkHeight;

      for (i = 0; i < totalChunks; i++) {
        if (i >= fullChunks) {
          thisChunkHeight = partialChunkHeight;
          elemsInThisChunk = width * thisChunkHeight;
        }

        destPos = 0;

        for (j = elemsInThisChunk; j--;) {
          dest[destPos++] = src[srcPos++];
          dest[destPos++] = src[srcPos++];
          dest[destPos++] = src[srcPos++];
          dest[destPos++] = 255;
        }

        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
      }
    } else {
      throw new Error("bad image kind: ".concat(imgData.kind));
    }
  }

  function putBinaryImageMask(ctx, imgData) {
    var height = imgData.height,
        width = imgData.width;
    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
    var srcPos = 0;
    var src = imgData.data;
    var dest = chunkImgData.data;

    for (var i = 0; i < totalChunks; i++) {
      var thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
      var destPos = 3;

      for (var j = 0; j < thisChunkHeight; j++) {
        var mask = 0;

        for (var k = 0; k < width; k++) {
          if (!mask) {
            var elem = src[srcPos++];
            mask = 128;
          }

          dest[destPos] = elem & mask ? 0 : 255;
          destPos += 4;
          mask >>= 1;
        }
      }

      ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
    }
  }

  function copyCtxState(sourceCtx, destCtx) {
    var properties = ['strokeStyle', 'fillStyle', 'fillRule', 'globalAlpha', 'lineWidth', 'lineCap', 'lineJoin', 'miterLimit', 'globalCompositeOperation', 'font'];

    for (var i = 0, ii = properties.length; i < ii; i++) {
      var property = properties[i];

      if (sourceCtx[property] !== undefined) {
        destCtx[property] = sourceCtx[property];
      }
    }

    if (sourceCtx.setLineDash !== undefined) {
      destCtx.setLineDash(sourceCtx.getLineDash());
      destCtx.lineDashOffset = sourceCtx.lineDashOffset;
    }
  }

  function resetCtxToDefault(ctx) {
    ctx.strokeStyle = '#000000';
    ctx.fillStyle = '#000000';
    ctx.fillRule = 'nonzero';
    ctx.globalAlpha = 1;
    ctx.lineWidth = 1;
    ctx.lineCap = 'butt';
    ctx.lineJoin = 'miter';
    ctx.miterLimit = 10;
    ctx.globalCompositeOperation = 'source-over';
    ctx.font = '10px sans-serif';

    if (ctx.setLineDash !== undefined) {
      ctx.setLineDash([]);
      ctx.lineDashOffset = 0;
    }
  }

  function composeSMaskBackdrop(bytes, r0, g0, b0) {
    var length = bytes.length;

    for (var i = 3; i < length; i += 4) {
      var alpha = bytes[i];

      if (alpha === 0) {
        bytes[i - 3] = r0;
        bytes[i - 2] = g0;
        bytes[i - 1] = b0;
      } else if (alpha < 255) {
        var alpha_ = 255 - alpha;
        bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
        bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
        bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
      }
    }
  }

  function composeSMaskAlpha(maskData, layerData, transferMap) {
    var length = maskData.length;
    var scale = 1 / 255;

    for (var i = 3; i < length; i += 4) {
      var alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
      layerData[i] = layerData[i] * alpha * scale | 0;
    }
  }

  function composeSMaskLuminosity(maskData, layerData, transferMap) {
    var length = maskData.length;

    for (var i = 3; i < length; i += 4) {
      var y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
      layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
    }
  }

  function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap) {
    var hasBackdrop = !!backdrop;
    var r0 = hasBackdrop ? backdrop[0] : 0;
    var g0 = hasBackdrop ? backdrop[1] : 0;
    var b0 = hasBackdrop ? backdrop[2] : 0;
    var composeFn;

    if (subtype === 'Luminosity') {
      composeFn = composeSMaskLuminosity;
    } else {
      composeFn = composeSMaskAlpha;
    }

    var PIXELS_TO_PROCESS = 1048576;
    var chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));

    for (var row = 0; row < height; row += chunkSize) {
      var chunkHeight = Math.min(chunkSize, height - row);
      var maskData = maskCtx.getImageData(0, row, width, chunkHeight);
      var layerData = layerCtx.getImageData(0, row, width, chunkHeight);

      if (hasBackdrop) {
        composeSMaskBackdrop(maskData.data, r0, g0, b0);
      }

      composeFn(maskData.data, layerData.data, transferMap);
      maskCtx.putImageData(layerData, 0, row);
    }
  }

  function composeSMask(ctx, smask, layerCtx, webGLContext) {
    var mask = smask.canvas;
    var maskCtx = smask.context;
    ctx.setTransform(smask.scaleX, 0, 0, smask.scaleY, smask.offsetX, smask.offsetY);
    var backdrop = smask.backdrop || null;

    if (!smask.transferMap && webGLContext.isEnabled) {
      var composed = webGLContext.composeSMask({
        layer: layerCtx.canvas,
        mask: mask,
        properties: {
          subtype: smask.subtype,
          backdrop: backdrop
        }
      });
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.drawImage(composed, smask.offsetX, smask.offsetY);
      return;
    }

    genericComposeSMask(maskCtx, layerCtx, mask.width, mask.height, smask.subtype, backdrop, smask.transferMap);
    ctx.drawImage(mask, 0, 0);
  }

  var LINE_CAP_STYLES = ['butt', 'round', 'square'];
  var LINE_JOIN_STYLES = ['miter', 'round', 'bevel'];
  var NORMAL_CLIP = {};
  var EO_CLIP = {};
  CanvasGraphics.prototype = {
    beginDrawing: function beginDrawing(_ref) {
      var transform = _ref.transform,
          viewport = _ref.viewport,
          _ref$transparency = _ref.transparency,
          transparency = _ref$transparency === void 0 ? false : _ref$transparency,
          _ref$background = _ref.background,
          background = _ref$background === void 0 ? null : _ref$background;
      var width = this.ctx.canvas.width;
      var height = this.ctx.canvas.height;
      this.ctx.save();
      this.ctx.fillStyle = background || 'rgb(255, 255, 255)';
      this.ctx.fillRect(0, 0, width, height);
      this.ctx.restore();

      if (transparency) {
        var transparentCanvas = this.cachedCanvases.getCanvas('transparent', width, height, true);
        this.compositeCtx = this.ctx;
        this.transparentCanvas = transparentCanvas.canvas;
        this.ctx = transparentCanvas.context;
        this.ctx.save();
        this.ctx.transform.apply(this.ctx, this.compositeCtx.mozCurrentTransform);
      }

      this.ctx.save();
      resetCtxToDefault(this.ctx);

      if (transform) {
        this.ctx.transform.apply(this.ctx, transform);
      }

      this.ctx.transform.apply(this.ctx, viewport.transform);
      this.baseTransform = this.ctx.mozCurrentTransform.slice();

      if (this.imageLayer) {
        this.imageLayer.beginLayout();
      }
    },
    executeOperatorList: function CanvasGraphics_executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
      var argsArray = operatorList.argsArray;
      var fnArray = operatorList.fnArray;
      var i = executionStartIdx || 0;
      var argsArrayLen = argsArray.length;

      if (argsArrayLen === i) {
        return i;
      }

      var chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === 'function';
      var endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
      var steps = 0;
      var commonObjs = this.commonObjs;
      var objs = this.objs;
      var fnId;

      while (true) {
        if (stepper !== undefined && i === stepper.nextBreakPoint) {
          stepper.breakIt(i, continueCallback);
          return i;
        }

        fnId = fnArray[i];

        if (fnId !== _util.OPS.dependency) {
          this[fnId].apply(this, argsArray[i]);
        } else {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = argsArray[i][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var depObjId = _step.value;
              var objsPool = depObjId.startsWith('g_') ? commonObjs : objs;

              if (!objsPool.has(depObjId)) {
                objsPool.get(depObjId, continueCallback);
                return i;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }

        i++;

        if (i === argsArrayLen) {
          return i;
        }

        if (chunkOperations && ++steps > EXECUTION_STEPS) {
          if (Date.now() > endTime) {
            continueCallback();
            return i;
          }

          steps = 0;
        }
      }
    },
    endDrawing: function CanvasGraphics_endDrawing() {
      if (this.current.activeSMask !== null) {
        this.endSMaskGroup();
      }

      this.ctx.restore();

      if (this.transparentCanvas) {
        this.ctx = this.compositeCtx;
        this.ctx.save();
        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
        this.ctx.drawImage(this.transparentCanvas, 0, 0);
        this.ctx.restore();
        this.transparentCanvas = null;
      }

      this.cachedCanvases.clear();
      this.webGLContext.clear();

      if (this.imageLayer) {
        this.imageLayer.endLayout();
      }
    },
    setLineWidth: function CanvasGraphics_setLineWidth(width) {
      this.current.lineWidth = width;
      this.ctx.lineWidth = width;
    },
    setLineCap: function CanvasGraphics_setLineCap(style) {
      this.ctx.lineCap = LINE_CAP_STYLES[style];
    },
    setLineJoin: function CanvasGraphics_setLineJoin(style) {
      this.ctx.lineJoin = LINE_JOIN_STYLES[style];
    },
    setMiterLimit: function CanvasGraphics_setMiterLimit(limit) {
      this.ctx.miterLimit = limit;
    },
    setDash: function CanvasGraphics_setDash(dashArray, dashPhase) {
      var ctx = this.ctx;

      if (ctx.setLineDash !== undefined) {
        ctx.setLineDash(dashArray);
        ctx.lineDashOffset = dashPhase;
      }
    },
    setRenderingIntent: function setRenderingIntent(intent) {},
    setFlatness: function setFlatness(flatness) {},
    setGState: function CanvasGraphics_setGState(states) {
      for (var i = 0, ii = states.length; i < ii; i++) {
        var state = states[i];
        var key = state[0];
        var value = state[1];

        switch (key) {
          case 'LW':
            this.setLineWidth(value);
            break;

          case 'LC':
            this.setLineCap(value);
            break;

          case 'LJ':
            this.setLineJoin(value);
            break;

          case 'ML':
            this.setMiterLimit(value);
            break;

          case 'D':
            this.setDash(value[0], value[1]);
            break;

          case 'RI':
            this.setRenderingIntent(value);
            break;

          case 'FL':
            this.setFlatness(value);
            break;

          case 'Font':
            this.setFont(value[0], value[1]);
            break;

          case 'CA':
            this.current.strokeAlpha = state[1];
            break;

          case 'ca':
            this.current.fillAlpha = state[1];
            this.ctx.globalAlpha = state[1];
            break;

          case 'BM':
            this.ctx.globalCompositeOperation = value;
            break;

          case 'SMask':
            if (this.current.activeSMask) {
              if (this.stateStack.length > 0 && this.stateStack[this.stateStack.length - 1].activeSMask === this.current.activeSMask) {
                this.suspendSMaskGroup();
              } else {
                this.endSMaskGroup();
              }
            }

            this.current.activeSMask = value ? this.tempSMask : null;

            if (this.current.activeSMask) {
              this.beginSMaskGroup();
            }

            this.tempSMask = null;
            break;
        }
      }
    },
    beginSMaskGroup: function CanvasGraphics_beginSMaskGroup() {
      var activeSMask = this.current.activeSMask;
      var drawnWidth = activeSMask.canvas.width;
      var drawnHeight = activeSMask.canvas.height;
      var cacheId = 'smaskGroupAt' + this.groupLevel;
      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
      var currentCtx = this.ctx;
      var currentTransform = currentCtx.mozCurrentTransform;
      this.ctx.save();
      var groupCtx = scratchCanvas.context;
      groupCtx.scale(1 / activeSMask.scaleX, 1 / activeSMask.scaleY);
      groupCtx.translate(-activeSMask.offsetX, -activeSMask.offsetY);
      groupCtx.transform.apply(groupCtx, currentTransform);
      activeSMask.startTransformInverse = groupCtx.mozCurrentTransformInverse;
      copyCtxState(currentCtx, groupCtx);
      this.ctx = groupCtx;
      this.setGState([['BM', 'source-over'], ['ca', 1], ['CA', 1]]);
      this.groupStack.push(currentCtx);
      this.groupLevel++;
    },
    suspendSMaskGroup: function CanvasGraphics_endSMaskGroup() {
      var groupCtx = this.ctx;
      this.groupLevel--;
      this.ctx = this.groupStack.pop();
      composeSMask(this.ctx, this.current.activeSMask, groupCtx, this.webGLContext);
      this.ctx.restore();
      this.ctx.save();
      copyCtxState(groupCtx, this.ctx);
      this.current.resumeSMaskCtx = groupCtx;

      var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);

      this.ctx.transform.apply(this.ctx, deltaTransform);
      groupCtx.save();
      groupCtx.setTransform(1, 0, 0, 1, 0, 0);
      groupCtx.clearRect(0, 0, groupCtx.canvas.width, groupCtx.canvas.height);
      groupCtx.restore();
    },
    resumeSMaskGroup: function CanvasGraphics_endSMaskGroup() {
      var groupCtx = this.current.resumeSMaskCtx;
      var currentCtx = this.ctx;
      this.ctx = groupCtx;
      this.groupStack.push(currentCtx);
      this.groupLevel++;
    },
    endSMaskGroup: function CanvasGraphics_endSMaskGroup() {
      var groupCtx = this.ctx;
      this.groupLevel--;
      this.ctx = this.groupStack.pop();
      composeSMask(this.ctx, this.current.activeSMask, groupCtx, this.webGLContext);
      this.ctx.restore();
      copyCtxState(groupCtx, this.ctx);

      var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);

      this.ctx.transform.apply(this.ctx, deltaTransform);
    },
    save: function CanvasGraphics_save() {
      this.ctx.save();
      var old = this.current;
      this.stateStack.push(old);
      this.current = old.clone();
      this.current.resumeSMaskCtx = null;
    },
    restore: function CanvasGraphics_restore() {
      if (this.current.resumeSMaskCtx) {
        this.resumeSMaskGroup();
      }

      if (this.current.activeSMask !== null && (this.stateStack.length === 0 || this.stateStack[this.stateStack.length - 1].activeSMask !== this.current.activeSMask)) {
        this.endSMaskGroup();
      }

      if (this.stateStack.length !== 0) {
        this.current = this.stateStack.pop();
        this.ctx.restore();
        this.pendingClip = null;
        this._cachedGetSinglePixelWidth = null;
      }
    },
    transform: function CanvasGraphics_transform(a, b, c, d, e, f) {
      this.ctx.transform(a, b, c, d, e, f);
      this._cachedGetSinglePixelWidth = null;
    },
    constructPath: function CanvasGraphics_constructPath(ops, args) {
      var ctx = this.ctx;
      var current = this.current;
      var x = current.x,
          y = current.y;

      for (var i = 0, j = 0, ii = ops.length; i < ii; i++) {
        switch (ops[i] | 0) {
          case _util.OPS.rectangle:
            x = args[j++];
            y = args[j++];
            var width = args[j++];
            var height = args[j++];

            if (width === 0) {
              width = this.getSinglePixelWidth();
            }

            if (height === 0) {
              height = this.getSinglePixelWidth();
            }

            var xw = x + width;
            var yh = y + height;
            this.ctx.moveTo(x, y);
            this.ctx.lineTo(xw, y);
            this.ctx.lineTo(xw, yh);
            this.ctx.lineTo(x, yh);
            this.ctx.lineTo(x, y);
            this.ctx.closePath();
            break;

          case _util.OPS.moveTo:
            x = args[j++];
            y = args[j++];
            ctx.moveTo(x, y);
            break;

          case _util.OPS.lineTo:
            x = args[j++];
            y = args[j++];
            ctx.lineTo(x, y);
            break;

          case _util.OPS.curveTo:
            x = args[j + 4];
            y = args[j + 5];
            ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
            j += 6;
            break;

          case _util.OPS.curveTo2:
            ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
            x = args[j + 2];
            y = args[j + 3];
            j += 4;
            break;

          case _util.OPS.curveTo3:
            x = args[j + 2];
            y = args[j + 3];
            ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
            j += 4;
            break;

          case _util.OPS.closePath:
            ctx.closePath();
            break;
        }
      }

      current.setCurrentPoint(x, y);
    },
    closePath: function CanvasGraphics_closePath() {
      this.ctx.closePath();
    },
    stroke: function CanvasGraphics_stroke(consumePath) {
      consumePath = typeof consumePath !== 'undefined' ? consumePath : true;
      var ctx = this.ctx;
      var strokeColor = this.current.strokeColor;
      ctx.lineWidth = Math.max(this.getSinglePixelWidth() * MIN_WIDTH_FACTOR, this.current.lineWidth);
      ctx.globalAlpha = this.current.strokeAlpha;

      if (strokeColor && strokeColor.hasOwnProperty('type') && strokeColor.type === 'Pattern') {
        ctx.save();
        ctx.strokeStyle = strokeColor.getPattern(ctx, this);
        ctx.stroke();
        ctx.restore();
      } else {
        ctx.stroke();
      }

      if (consumePath) {
        this.consumePath();
      }

      ctx.globalAlpha = this.current.fillAlpha;
    },
    closeStroke: function CanvasGraphics_closeStroke() {
      this.closePath();
      this.stroke();
    },
    fill: function CanvasGraphics_fill(consumePath) {
      consumePath = typeof consumePath !== 'undefined' ? consumePath : true;
      var ctx = this.ctx;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      var needRestore = false;

      if (isPatternFill) {
        ctx.save();

        if (this.baseTransform) {
          ctx.setTransform.apply(ctx, this.baseTransform);
        }

        ctx.fillStyle = fillColor.getPattern(ctx, this);
        needRestore = true;
      }

      if (this.pendingEOFill) {
        ctx.fill('evenodd');
        this.pendingEOFill = false;
      } else {
        ctx.fill();
      }

      if (needRestore) {
        ctx.restore();
      }

      if (consumePath) {
        this.consumePath();
      }
    },
    eoFill: function CanvasGraphics_eoFill() {
      this.pendingEOFill = true;
      this.fill();
    },
    fillStroke: function CanvasGraphics_fillStroke() {
      this.fill(false);
      this.stroke(false);
      this.consumePath();
    },
    eoFillStroke: function CanvasGraphics_eoFillStroke() {
      this.pendingEOFill = true;
      this.fillStroke();
    },
    closeFillStroke: function CanvasGraphics_closeFillStroke() {
      this.closePath();
      this.fillStroke();
    },
    closeEOFillStroke: function CanvasGraphics_closeEOFillStroke() {
      this.pendingEOFill = true;
      this.closePath();
      this.fillStroke();
    },
    endPath: function CanvasGraphics_endPath() {
      this.consumePath();
    },
    clip: function CanvasGraphics_clip() {
      this.pendingClip = NORMAL_CLIP;
    },
    eoClip: function CanvasGraphics_eoClip() {
      this.pendingClip = EO_CLIP;
    },
    beginText: function CanvasGraphics_beginText() {
      this.current.textMatrix = _util.IDENTITY_MATRIX;
      this.current.textMatrixScale = 1;
      this.current.x = this.current.lineX = 0;
      this.current.y = this.current.lineY = 0;
    },
    endText: function CanvasGraphics_endText() {
      var paths = this.pendingTextPaths;
      var ctx = this.ctx;

      if (paths === undefined) {
        ctx.beginPath();
        return;
      }

      ctx.save();
      ctx.beginPath();

      for (var i = 0; i < paths.length; i++) {
        var path = paths[i];
        ctx.setTransform.apply(ctx, path.transform);
        ctx.translate(path.x, path.y);
        path.addToPath(ctx, path.fontSize);
      }

      ctx.restore();
      ctx.clip();
      ctx.beginPath();
      delete this.pendingTextPaths;
    },
    setCharSpacing: function CanvasGraphics_setCharSpacing(spacing) {
      this.current.charSpacing = spacing;
    },
    setWordSpacing: function CanvasGraphics_setWordSpacing(spacing) {
      this.current.wordSpacing = spacing;
    },
    setHScale: function CanvasGraphics_setHScale(scale) {
      this.current.textHScale = scale / 100;
    },
    setLeading: function CanvasGraphics_setLeading(leading) {
      this.current.leading = -leading;
    },
    setFont: function CanvasGraphics_setFont(fontRefName, size) {
      var fontObj = this.commonObjs.get(fontRefName);
      var current = this.current;

      if (!fontObj) {
        throw new Error("Can't find font for ".concat(fontRefName));
      }

      current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;

      if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) {
        (0, _util.warn)('Invalid font matrix for font ' + fontRefName);
      }

      if (size < 0) {
        size = -size;
        current.fontDirection = -1;
      } else {
        current.fontDirection = 1;
      }

      this.current.font = fontObj;
      this.current.fontSize = size;

      if (fontObj.isType3Font) {
        return;
      }

      var name = fontObj.loadedName || 'sans-serif';
      var bold = fontObj.black ? '900' : fontObj.bold ? 'bold' : 'normal';
      var italic = fontObj.italic ? 'italic' : 'normal';
      var typeface = "\"".concat(name, "\", ").concat(fontObj.fallbackName);
      var browserFontSize = size < MIN_FONT_SIZE ? MIN_FONT_SIZE : size > MAX_FONT_SIZE ? MAX_FONT_SIZE : size;
      this.current.fontSizeScale = size / browserFontSize;
      this.ctx.font = "".concat(italic, " ").concat(bold, " ").concat(browserFontSize, "px ").concat(typeface);
    },
    setTextRenderingMode: function CanvasGraphics_setTextRenderingMode(mode) {
      this.current.textRenderingMode = mode;
    },
    setTextRise: function CanvasGraphics_setTextRise(rise) {
      this.current.textRise = rise;
    },
    moveText: function CanvasGraphics_moveText(x, y) {
      this.current.x = this.current.lineX += x;
      this.current.y = this.current.lineY += y;
    },
    setLeadingMoveText: function CanvasGraphics_setLeadingMoveText(x, y) {
      this.setLeading(-y);
      this.moveText(x, y);
    },
    setTextMatrix: function CanvasGraphics_setTextMatrix(a, b, c, d, e, f) {
      this.current.textMatrix = [a, b, c, d, e, f];
      this.current.textMatrixScale = Math.sqrt(a * a + b * b);
      this.current.x = this.current.lineX = 0;
      this.current.y = this.current.lineY = 0;
    },
    nextLine: function CanvasGraphics_nextLine() {
      this.moveText(0, this.current.leading);
    },
    paintChar: function paintChar(character, x, y, patternTransform) {
      var ctx = this.ctx;
      var current = this.current;
      var font = current.font;
      var textRenderingMode = current.textRenderingMode;
      var fontSize = current.fontSize / current.fontSizeScale;
      var fillStrokeMode = textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
      var isAddToPathSet = !!(textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
      var patternFill = current.patternFill && font.data;
      var addToPath;

      if (font.disableFontFace || isAddToPathSet || patternFill) {
        addToPath = font.getPathGenerator(this.commonObjs, character);
      }

      if (font.disableFontFace || patternFill) {
        ctx.save();
        ctx.translate(x, y);
        ctx.beginPath();
        addToPath(ctx, fontSize);

        if (patternTransform) {
          ctx.setTransform.apply(ctx, patternTransform);
        }

        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.fill();
        }

        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.stroke();
        }

        ctx.restore();
      } else {
        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.fillText(character, x, y);
        }

        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.strokeText(character, x, y);
        }
      }

      if (isAddToPathSet) {
        var paths = this.pendingTextPaths || (this.pendingTextPaths = []);
        paths.push({
          transform: ctx.mozCurrentTransform,
          x: x,
          y: y,
          fontSize: fontSize,
          addToPath: addToPath
        });
      }
    },

    get isFontSubpixelAAEnabled() {
      var _this$cachedCanvases$ = this.cachedCanvases.getCanvas('isFontSubpixelAAEnabled', 10, 10),
          ctx = _this$cachedCanvases$.context;

      ctx.scale(1.5, 1);
      ctx.fillText('I', 0, 10);
      var data = ctx.getImageData(0, 0, 10, 10).data;
      var enabled = false;

      for (var i = 3; i < data.length; i += 4) {
        if (data[i] > 0 && data[i] < 255) {
          enabled = true;
          break;
        }
      }

      return (0, _util.shadow)(this, 'isFontSubpixelAAEnabled', enabled);
    },

    showText: function CanvasGraphics_showText(glyphs) {
      var current = this.current;
      var font = current.font;

      if (font.isType3Font) {
        return this.showType3Text(glyphs);
      }

      var fontSize = current.fontSize;

      if (fontSize === 0) {
        return undefined;
      }

      var ctx = this.ctx;
      var fontSizeScale = current.fontSizeScale;
      var charSpacing = current.charSpacing;
      var wordSpacing = current.wordSpacing;
      var fontDirection = current.fontDirection;
      var textHScale = current.textHScale * fontDirection;
      var glyphsLength = glyphs.length;
      var vertical = font.vertical;
      var spacingDir = vertical ? 1 : -1;
      var defaultVMetrics = font.defaultVMetrics;
      var widthAdvanceScale = fontSize * current.fontMatrix[0];
      var simpleFillText = current.textRenderingMode === _util.TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
      ctx.save();
      var patternTransform;

      if (current.patternFill) {
        ctx.save();
        var pattern = current.fillColor.getPattern(ctx, this);
        patternTransform = ctx.mozCurrentTransform;
        ctx.restore();
        ctx.fillStyle = pattern;
      }

      ctx.transform.apply(ctx, current.textMatrix);
      ctx.translate(current.x, current.y + current.textRise);

      if (fontDirection > 0) {
        ctx.scale(textHScale, -1);
      } else {
        ctx.scale(textHScale, 1);
      }

      var lineWidth = current.lineWidth;
      var scale = current.textMatrixScale;

      if (scale === 0 || lineWidth === 0) {
        var fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;

        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          this._cachedGetSinglePixelWidth = null;
          lineWidth = this.getSinglePixelWidth() * MIN_WIDTH_FACTOR;
        }
      } else {
        lineWidth /= scale;
      }

      if (fontSizeScale !== 1.0) {
        ctx.scale(fontSizeScale, fontSizeScale);
        lineWidth /= fontSizeScale;
      }

      ctx.lineWidth = lineWidth;
      var x = 0,
          i;

      for (i = 0; i < glyphsLength; ++i) {
        var glyph = glyphs[i];

        if ((0, _util.isNum)(glyph)) {
          x += spacingDir * glyph * fontSize / 1000;
          continue;
        }

        var restoreNeeded = false;
        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
        var character = glyph.fontChar;
        var accent = glyph.accent;
        var scaledX, scaledY, scaledAccentX, scaledAccentY;
        var width = glyph.width;

        if (vertical) {
          var vmetric, vx, vy;
          vmetric = glyph.vmetric || defaultVMetrics;
          vx = glyph.vmetric ? vmetric[1] : width * 0.5;
          vx = -vx * widthAdvanceScale;
          vy = vmetric[2] * widthAdvanceScale;
          width = vmetric ? -vmetric[0] : width;
          scaledX = vx / fontSizeScale;
          scaledY = (x + vy) / fontSizeScale;
        } else {
          scaledX = x / fontSizeScale;
          scaledY = 0;
        }

        if (font.remeasure && width > 0) {
          var measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;

          if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
            var characterScaleX = width / measuredWidth;
            restoreNeeded = true;
            ctx.save();
            ctx.scale(characterScaleX, 1);
            scaledX /= characterScaleX;
          } else if (width !== measuredWidth) {
            scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
          }
        }

        if (glyph.isInFont || font.missingFile) {
          if (simpleFillText && !accent) {
            ctx.fillText(character, scaledX, scaledY);
          } else {
            this.paintChar(character, scaledX, scaledY, patternTransform);

            if (accent) {
              scaledAccentX = scaledX + accent.offset.x / fontSizeScale;
              scaledAccentY = scaledY - accent.offset.y / fontSizeScale;
              this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY, patternTransform);
            }
          }
        }

        var charWidth = width * widthAdvanceScale + spacing * fontDirection;
        x += charWidth;

        if (restoreNeeded) {
          ctx.restore();
        }
      }

      if (vertical) {
        current.y -= x * textHScale;
      } else {
        current.x += x * textHScale;
      }

      ctx.restore();
    },
    showType3Text: function CanvasGraphics_showType3Text(glyphs) {
      var ctx = this.ctx;
      var current = this.current;
      var font = current.font;
      var fontSize = current.fontSize;
      var fontDirection = current.fontDirection;
      var spacingDir = font.vertical ? 1 : -1;
      var charSpacing = current.charSpacing;
      var wordSpacing = current.wordSpacing;
      var textHScale = current.textHScale * fontDirection;
      var fontMatrix = current.fontMatrix || _util.FONT_IDENTITY_MATRIX;
      var glyphsLength = glyphs.length;
      var isTextInvisible = current.textRenderingMode === _util.TextRenderingMode.INVISIBLE;
      var i, glyph, width, spacingLength;

      if (isTextInvisible || fontSize === 0) {
        return;
      }

      this._cachedGetSinglePixelWidth = null;
      ctx.save();
      ctx.transform.apply(ctx, current.textMatrix);
      ctx.translate(current.x, current.y);
      ctx.scale(textHScale, fontDirection);

      for (i = 0; i < glyphsLength; ++i) {
        glyph = glyphs[i];

        if ((0, _util.isNum)(glyph)) {
          spacingLength = spacingDir * glyph * fontSize / 1000;
          this.ctx.translate(spacingLength, 0);
          current.x += spacingLength * textHScale;
          continue;
        }

        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
        var operatorList = font.charProcOperatorList[glyph.operatorListId];

        if (!operatorList) {
          (0, _util.warn)("Type3 character \"".concat(glyph.operatorListId, "\" is not available."));
          continue;
        }

        this.processingType3 = glyph;
        this.save();
        ctx.scale(fontSize, fontSize);
        ctx.transform.apply(ctx, fontMatrix);
        this.executeOperatorList(operatorList);
        this.restore();

        var transformed = _util.Util.applyTransform([glyph.width, 0], fontMatrix);

        width = transformed[0] * fontSize + spacing;
        ctx.translate(width, 0);
        current.x += width * textHScale;
      }

      ctx.restore();
      this.processingType3 = null;
    },
    setCharWidth: function CanvasGraphics_setCharWidth(xWidth, yWidth) {},
    setCharWidthAndBounds: function CanvasGraphics_setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
      this.ctx.rect(llx, lly, urx - llx, ury - lly);
      this.clip();
      this.endPath();
    },
    getColorN_Pattern: function CanvasGraphics_getColorN_Pattern(IR) {
      var _this = this;

      var pattern;

      if (IR[0] === 'TilingPattern') {
        var color = IR[1];
        var baseTransform = this.baseTransform || this.ctx.mozCurrentTransform.slice();
        var canvasGraphicsFactory = {
          createCanvasGraphics: function createCanvasGraphics(ctx) {
            return new CanvasGraphics(ctx, _this.commonObjs, _this.objs, _this.canvasFactory, _this.webGLContext);
          }
        };
        pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
      } else {
        pattern = (0, _pattern_helper.getShadingPatternFromIR)(IR);
      }

      return pattern;
    },
    setStrokeColorN: function CanvasGraphics_setStrokeColorN() {
      this.current.strokeColor = this.getColorN_Pattern(arguments);
    },
    setFillColorN: function CanvasGraphics_setFillColorN() {
      this.current.fillColor = this.getColorN_Pattern(arguments);
      this.current.patternFill = true;
    },
    setStrokeRGBColor: function CanvasGraphics_setStrokeRGBColor(r, g, b) {
      var color = _util.Util.makeCssRgb(r, g, b);

      this.ctx.strokeStyle = color;
      this.current.strokeColor = color;
    },
    setFillRGBColor: function CanvasGraphics_setFillRGBColor(r, g, b) {
      var color = _util.Util.makeCssRgb(r, g, b);

      this.ctx.fillStyle = color;
      this.current.fillColor = color;
      this.current.patternFill = false;
    },
    shadingFill: function CanvasGraphics_shadingFill(patternIR) {
      var ctx = this.ctx;
      this.save();
      var pattern = (0, _pattern_helper.getShadingPatternFromIR)(patternIR);
      ctx.fillStyle = pattern.getPattern(ctx, this, true);
      var inv = ctx.mozCurrentTransformInverse;

      if (inv) {
        var canvas = ctx.canvas;
        var width = canvas.width;
        var height = canvas.height;

        var bl = _util.Util.applyTransform([0, 0], inv);

        var br = _util.Util.applyTransform([0, height], inv);

        var ul = _util.Util.applyTransform([width, 0], inv);

        var ur = _util.Util.applyTransform([width, height], inv);

        var x0 = Math.min(bl[0], br[0], ul[0], ur[0]);
        var y0 = Math.min(bl[1], br[1], ul[1], ur[1]);
        var x1 = Math.max(bl[0], br[0], ul[0], ur[0]);
        var y1 = Math.max(bl[1], br[1], ul[1], ur[1]);
        this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
      } else {
        this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
      }

      this.restore();
    },
    beginInlineImage: function CanvasGraphics_beginInlineImage() {
      (0, _util.unreachable)('Should not call beginInlineImage');
    },
    beginImageData: function CanvasGraphics_beginImageData() {
      (0, _util.unreachable)('Should not call beginImageData');
    },
    paintFormXObjectBegin: function CanvasGraphics_paintFormXObjectBegin(matrix, bbox) {
      this.save();
      this.baseTransformStack.push(this.baseTransform);

      if (Array.isArray(matrix) && matrix.length === 6) {
        this.transform.apply(this, matrix);
      }

      this.baseTransform = this.ctx.mozCurrentTransform;

      if (bbox) {
        var width = bbox[2] - bbox[0];
        var height = bbox[3] - bbox[1];
        this.ctx.rect(bbox[0], bbox[1], width, height);
        this.clip();
        this.endPath();
      }
    },
    paintFormXObjectEnd: function CanvasGraphics_paintFormXObjectEnd() {
      this.restore();
      this.baseTransform = this.baseTransformStack.pop();
    },
    beginGroup: function CanvasGraphics_beginGroup(group) {
      this.save();
      var currentCtx = this.ctx;

      if (!group.isolated) {
        (0, _util.info)('TODO: Support non-isolated groups.');
      }

      if (group.knockout) {
        (0, _util.warn)('Knockout groups not supported.');
      }

      var currentTransform = currentCtx.mozCurrentTransform;

      if (group.matrix) {
        currentCtx.transform.apply(currentCtx, group.matrix);
      }

      if (!group.bbox) {
        throw new Error('Bounding box is required.');
      }

      var bounds = _util.Util.getAxialAlignedBoundingBox(group.bbox, currentCtx.mozCurrentTransform);

      var canvasBounds = [0, 0, currentCtx.canvas.width, currentCtx.canvas.height];
      bounds = _util.Util.intersect(bounds, canvasBounds) || [0, 0, 0, 0];
      var offsetX = Math.floor(bounds[0]);
      var offsetY = Math.floor(bounds[1]);
      var drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
      var drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
      var scaleX = 1,
          scaleY = 1;

      if (drawnWidth > MAX_GROUP_SIZE) {
        scaleX = drawnWidth / MAX_GROUP_SIZE;
        drawnWidth = MAX_GROUP_SIZE;
      }

      if (drawnHeight > MAX_GROUP_SIZE) {
        scaleY = drawnHeight / MAX_GROUP_SIZE;
        drawnHeight = MAX_GROUP_SIZE;
      }

      var cacheId = 'groupAt' + this.groupLevel;

      if (group.smask) {
        cacheId += '_smask_' + this.smaskCounter++ % 2;
      }

      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
      var groupCtx = scratchCanvas.context;
      groupCtx.scale(1 / scaleX, 1 / scaleY);
      groupCtx.translate(-offsetX, -offsetY);
      groupCtx.transform.apply(groupCtx, currentTransform);

      if (group.smask) {
        this.smaskStack.push({
          canvas: scratchCanvas.canvas,
          context: groupCtx,
          offsetX: offsetX,
          offsetY: offsetY,
          scaleX: scaleX,
          scaleY: scaleY,
          subtype: group.smask.subtype,
          backdrop: group.smask.backdrop,
          transferMap: group.smask.transferMap || null,
          startTransformInverse: null
        });
      } else {
        currentCtx.setTransform(1, 0, 0, 1, 0, 0);
        currentCtx.translate(offsetX, offsetY);
        currentCtx.scale(scaleX, scaleY);
      }

      copyCtxState(currentCtx, groupCtx);
      this.ctx = groupCtx;
      this.setGState([['BM', 'source-over'], ['ca', 1], ['CA', 1]]);
      this.groupStack.push(currentCtx);
      this.groupLevel++;
      this.current.activeSMask = null;
    },
    endGroup: function CanvasGraphics_endGroup(group) {
      this.groupLevel--;
      var groupCtx = this.ctx;
      this.ctx = this.groupStack.pop();

      if (this.ctx.imageSmoothingEnabled !== undefined) {
        this.ctx.imageSmoothingEnabled = false;
      } else {
        this.ctx.mozImageSmoothingEnabled = false;
      }

      if (group.smask) {
        this.tempSMask = this.smaskStack.pop();
      } else {
        this.ctx.drawImage(groupCtx.canvas, 0, 0);
      }

      this.restore();
    },
    beginAnnotations: function CanvasGraphics_beginAnnotations() {
      this.save();

      if (this.baseTransform) {
        this.ctx.setTransform.apply(this.ctx, this.baseTransform);
      }
    },
    endAnnotations: function CanvasGraphics_endAnnotations() {
      this.restore();
    },
    beginAnnotation: function CanvasGraphics_beginAnnotation(rect, transform, matrix) {
      this.save();
      resetCtxToDefault(this.ctx);
      this.current = new CanvasExtraState();

      if (Array.isArray(rect) && rect.length === 4) {
        var width = rect[2] - rect[0];
        var height = rect[3] - rect[1];
        this.ctx.rect(rect[0], rect[1], width, height);
        this.clip();
        this.endPath();
      }

      this.transform.apply(this, transform);
      this.transform.apply(this, matrix);
    },
    endAnnotation: function CanvasGraphics_endAnnotation() {
      this.restore();
    },
    paintJpegXObject: function CanvasGraphics_paintJpegXObject(objId, w, h) {
      var domImage = this.processingType3 ? this.commonObjs.get(objId) : this.objs.get(objId);

      if (!domImage) {
        (0, _util.warn)('Dependent image isn\'t ready yet');
        return;
      }

      this.save();
      var ctx = this.ctx;
      ctx.scale(1 / w, -1 / h);
      ctx.drawImage(domImage, 0, 0, domImage.width, domImage.height, 0, -h, w, h);

      if (this.imageLayer) {
        var currentTransform = ctx.mozCurrentTransformInverse;
        var position = this.getCanvasPosition(0, 0);
        this.imageLayer.appendImage({
          objId: objId,
          left: position[0],
          top: position[1],
          width: w / currentTransform[0],
          height: h / currentTransform[3]
        });
      }

      this.restore();
    },
    paintImageMaskXObject: function CanvasGraphics_paintImageMaskXObject(img) {
      var ctx = this.ctx;
      var width = img.width,
          height = img.height;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      var glyph = this.processingType3;

      if (COMPILE_TYPE3_GLYPHS && glyph && glyph.compiled === undefined) {
        if (width <= MAX_SIZE_TO_COMPILE && height <= MAX_SIZE_TO_COMPILE) {
          glyph.compiled = compileType3Glyph({
            data: img.data,
            width: width,
            height: height
          });
        } else {
          glyph.compiled = null;
        }
      }

      if (glyph && glyph.compiled) {
        glyph.compiled(ctx);
        return;
      }

      var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
      var maskCtx = maskCanvas.context;
      maskCtx.save();
      putBinaryImageMask(maskCtx, img);
      maskCtx.globalCompositeOperation = 'source-in';
      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
      maskCtx.fillRect(0, 0, width, height);
      maskCtx.restore();
      this.paintInlineImageXObject(maskCanvas.canvas);
    },
    paintImageMaskXObjectRepeat: function CanvasGraphics_paintImageMaskXObjectRepeat(imgData, scaleX, scaleY, positions) {
      var width = imgData.width;
      var height = imgData.height;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
      var maskCtx = maskCanvas.context;
      maskCtx.save();
      putBinaryImageMask(maskCtx, imgData);
      maskCtx.globalCompositeOperation = 'source-in';
      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
      maskCtx.fillRect(0, 0, width, height);
      maskCtx.restore();
      var ctx = this.ctx;

      for (var i = 0, ii = positions.length; i < ii; i += 2) {
        ctx.save();
        ctx.transform(scaleX, 0, 0, scaleY, positions[i], positions[i + 1]);
        ctx.scale(1, -1);
        ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
        ctx.restore();
      }
    },
    paintImageMaskXObjectGroup: function CanvasGraphics_paintImageMaskXObjectGroup(images) {
      var ctx = this.ctx;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;

      for (var i = 0, ii = images.length; i < ii; i++) {
        var image = images[i];
        var width = image.width,
            height = image.height;
        var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
        var maskCtx = maskCanvas.context;
        maskCtx.save();
        putBinaryImageMask(maskCtx, image);
        maskCtx.globalCompositeOperation = 'source-in';
        maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
        maskCtx.fillRect(0, 0, width, height);
        maskCtx.restore();
        ctx.save();
        ctx.transform.apply(ctx, image.transform);
        ctx.scale(1, -1);
        ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
        ctx.restore();
      }
    },
    paintImageXObject: function CanvasGraphics_paintImageXObject(objId) {
      var imgData = this.processingType3 ? this.commonObjs.get(objId) : this.objs.get(objId);

      if (!imgData) {
        (0, _util.warn)('Dependent image isn\'t ready yet');
        return;
      }

      this.paintInlineImageXObject(imgData);
    },
    paintImageXObjectRepeat: function CanvasGraphics_paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
      var imgData = this.processingType3 ? this.commonObjs.get(objId) : this.objs.get(objId);

      if (!imgData) {
        (0, _util.warn)('Dependent image isn\'t ready yet');
        return;
      }

      var width = imgData.width;
      var height = imgData.height;
      var map = [];

      for (var i = 0, ii = positions.length; i < ii; i += 2) {
        map.push({
          transform: [scaleX, 0, 0, scaleY, positions[i], positions[i + 1]],
          x: 0,
          y: 0,
          w: width,
          h: height
        });
      }

      this.paintInlineImageXObjectGroup(imgData, map);
    },
    paintInlineImageXObject: function CanvasGraphics_paintInlineImageXObject(imgData) {
      var width = imgData.width;
      var height = imgData.height;
      var ctx = this.ctx;
      this.save();
      ctx.scale(1 / width, -1 / height);
      var currentTransform = ctx.mozCurrentTransformInverse;
      var a = currentTransform[0],
          b = currentTransform[1];
      var widthScale = Math.max(Math.sqrt(a * a + b * b), 1);
      var c = currentTransform[2],
          d = currentTransform[3];
      var heightScale = Math.max(Math.sqrt(c * c + d * d), 1);
      var imgToPaint, tmpCanvas;

      if (typeof HTMLElement === 'function' && imgData instanceof HTMLElement || !imgData.data) {
        imgToPaint = imgData;
      } else {
        tmpCanvas = this.cachedCanvases.getCanvas('inlineImage', width, height);
        var tmpCtx = tmpCanvas.context;
        putBinaryImageData(tmpCtx, imgData);
        imgToPaint = tmpCanvas.canvas;
      }

      var paintWidth = width,
          paintHeight = height;
      var tmpCanvasId = 'prescale1';

      while (widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1) {
        var newWidth = paintWidth,
            newHeight = paintHeight;

        if (widthScale > 2 && paintWidth > 1) {
          newWidth = Math.ceil(paintWidth / 2);
          widthScale /= paintWidth / newWidth;
        }

        if (heightScale > 2 && paintHeight > 1) {
          newHeight = Math.ceil(paintHeight / 2);
          heightScale /= paintHeight / newHeight;
        }

        tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
        tmpCtx = tmpCanvas.context;
        tmpCtx.clearRect(0, 0, newWidth, newHeight);
        tmpCtx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
        imgToPaint = tmpCanvas.canvas;
        paintWidth = newWidth;
        paintHeight = newHeight;
        tmpCanvasId = tmpCanvasId === 'prescale1' ? 'prescale2' : 'prescale1';
      }

      ctx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, -height, width, height);

      if (this.imageLayer) {
        var position = this.getCanvasPosition(0, -height);
        this.imageLayer.appendImage({
          imgData: imgData,
          left: position[0],
          top: position[1],
          width: width / currentTransform[0],
          height: height / currentTransform[3]
        });
      }

      this.restore();
    },
    paintInlineImageXObjectGroup: function CanvasGraphics_paintInlineImageXObjectGroup(imgData, map) {
      var ctx = this.ctx;
      var w = imgData.width;
      var h = imgData.height;
      var tmpCanvas = this.cachedCanvases.getCanvas('inlineImage', w, h);
      var tmpCtx = tmpCanvas.context;
      putBinaryImageData(tmpCtx, imgData);

      for (var i = 0, ii = map.length; i < ii; i++) {
        var entry = map[i];
        ctx.save();
        ctx.transform.apply(ctx, entry.transform);
        ctx.scale(1, -1);
        ctx.drawImage(tmpCanvas.canvas, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);

        if (this.imageLayer) {
          var position = this.getCanvasPosition(entry.x, entry.y);
          this.imageLayer.appendImage({
            imgData: imgData,
            left: position[0],
            top: position[1],
            width: w,
            height: h
          });
        }

        ctx.restore();
      }
    },
    paintSolidColorImageMask: function CanvasGraphics_paintSolidColorImageMask() {
      this.ctx.fillRect(0, 0, 1, 1);
    },
    paintXObject: function CanvasGraphics_paintXObject() {
      (0, _util.warn)('Unsupported \'paintXObject\' command.');
    },
    markPoint: function CanvasGraphics_markPoint(tag) {},
    markPointProps: function CanvasGraphics_markPointProps(tag, properties) {},
    beginMarkedContent: function CanvasGraphics_beginMarkedContent(tag) {},
    beginMarkedContentProps: function CanvasGraphics_beginMarkedContentProps(tag, properties) {},
    endMarkedContent: function CanvasGraphics_endMarkedContent() {},
    beginCompat: function CanvasGraphics_beginCompat() {},
    endCompat: function CanvasGraphics_endCompat() {},
    consumePath: function CanvasGraphics_consumePath() {
      var ctx = this.ctx;

      if (this.pendingClip) {
        if (this.pendingClip === EO_CLIP) {
          ctx.clip('evenodd');
        } else {
          ctx.clip();
        }

        this.pendingClip = null;
      }

      ctx.beginPath();
    },
    getSinglePixelWidth: function getSinglePixelWidth(scale) {
      if (this._cachedGetSinglePixelWidth === null) {
        var inverse = this.ctx.mozCurrentTransformInverse;
        this._cachedGetSinglePixelWidth = Math.sqrt(Math.max(inverse[0] * inverse[0] + inverse[1] * inverse[1], inverse[2] * inverse[2] + inverse[3] * inverse[3]));
      }

      return this._cachedGetSinglePixelWidth;
    },
    getCanvasPosition: function CanvasGraphics_getCanvasPosition(x, y) {
      var transform = this.ctx.mozCurrentTransform;
      return [transform[0] * x + transform[2] * y + transform[4], transform[1] * x + transform[3] * y + transform[5]];
    }
  };

  for (var op in _util.OPS) {
    CanvasGraphics.prototype[_util.OPS[op]] = CanvasGraphics.prototype[op];
  }

  return CanvasGraphics;
}();

exports.CanvasGraphics = CanvasGraphics;

/***/ }),
/* 155 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShadingPatternFromIR = getShadingPatternFromIR;
exports.TilingPattern = void 0;

var _util = __w_pdfjs_require__(1);

var ShadingIRs = {};
ShadingIRs.RadialAxial = {
  fromIR: function RadialAxial_fromIR(raw) {
    var type = raw[1];
    var colorStops = raw[2];
    var p0 = raw[3];
    var p1 = raw[4];
    var r0 = raw[5];
    var r1 = raw[6];
    return {
      type: 'Pattern',
      getPattern: function RadialAxial_getPattern(ctx) {
        var grad;

        if (type === 'axial') {
          grad = ctx.createLinearGradient(p0[0], p0[1], p1[0], p1[1]);
        } else if (type === 'radial') {
          grad = ctx.createRadialGradient(p0[0], p0[1], r0, p1[0], p1[1], r1);
        }

        for (var i = 0, ii = colorStops.length; i < ii; ++i) {
          var c = colorStops[i];
          grad.addColorStop(c[0], c[1]);
        }

        return grad;
      }
    };
  }
};

var createMeshCanvas = function createMeshCanvasClosure() {
  function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
    var coords = context.coords,
        colors = context.colors;
    var bytes = data.data,
        rowSize = data.width * 4;
    var tmp;

    if (coords[p1 + 1] > coords[p2 + 1]) {
      tmp = p1;
      p1 = p2;
      p2 = tmp;
      tmp = c1;
      c1 = c2;
      c2 = tmp;
    }

    if (coords[p2 + 1] > coords[p3 + 1]) {
      tmp = p2;
      p2 = p3;
      p3 = tmp;
      tmp = c2;
      c2 = c3;
      c3 = tmp;
    }

    if (coords[p1 + 1] > coords[p2 + 1]) {
      tmp = p1;
      p1 = p2;
      p2 = tmp;
      tmp = c1;
      c1 = c2;
      c2 = tmp;
    }

    var x1 = (coords[p1] + context.offsetX) * context.scaleX;
    var y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
    var x2 = (coords[p2] + context.offsetX) * context.scaleX;
    var y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
    var x3 = (coords[p3] + context.offsetX) * context.scaleX;
    var y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;

    if (y1 >= y3) {
      return;
    }

    var c1r = colors[c1],
        c1g = colors[c1 + 1],
        c1b = colors[c1 + 2];
    var c2r = colors[c2],
        c2g = colors[c2 + 1],
        c2b = colors[c2 + 2];
    var c3r = colors[c3],
        c3g = colors[c3 + 1],
        c3b = colors[c3 + 2];
    var minY = Math.round(y1),
        maxY = Math.round(y3);
    var xa, car, cag, cab;
    var xb, cbr, cbg, cbb;
    var k;

    for (var y = minY; y <= maxY; y++) {
      if (y < y2) {
        k = y < y1 ? 0 : y1 === y2 ? 1 : (y1 - y) / (y1 - y2);
        xa = x1 - (x1 - x2) * k;
        car = c1r - (c1r - c2r) * k;
        cag = c1g - (c1g - c2g) * k;
        cab = c1b - (c1b - c2b) * k;
      } else {
        k = y > y3 ? 1 : y2 === y3 ? 0 : (y2 - y) / (y2 - y3);
        xa = x2 - (x2 - x3) * k;
        car = c2r - (c2r - c3r) * k;
        cag = c2g - (c2g - c3g) * k;
        cab = c2b - (c2b - c3b) * k;
      }

      k = y < y1 ? 0 : y > y3 ? 1 : (y1 - y) / (y1 - y3);
      xb = x1 - (x1 - x3) * k;
      cbr = c1r - (c1r - c3r) * k;
      cbg = c1g - (c1g - c3g) * k;
      cbb = c1b - (c1b - c3b) * k;
      var x1_ = Math.round(Math.min(xa, xb));
      var x2_ = Math.round(Math.max(xa, xb));
      var j = rowSize * y + x1_ * 4;

      for (var x = x1_; x <= x2_; x++) {
        k = (xa - x) / (xa - xb);
        k = k < 0 ? 0 : k > 1 ? 1 : k;
        bytes[j++] = car - (car - cbr) * k | 0;
        bytes[j++] = cag - (cag - cbg) * k | 0;
        bytes[j++] = cab - (cab - cbb) * k | 0;
        bytes[j++] = 255;
      }
    }
  }

  function drawFigure(data, figure, context) {
    var ps = figure.coords;
    var cs = figure.colors;
    var i, ii;

    switch (figure.type) {
      case 'lattice':
        var verticesPerRow = figure.verticesPerRow;
        var rows = Math.floor(ps.length / verticesPerRow) - 1;
        var cols = verticesPerRow - 1;

        for (i = 0; i < rows; i++) {
          var q = i * verticesPerRow;

          for (var j = 0; j < cols; j++, q++) {
            drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
            drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
          }
        }

        break;

      case 'triangles':
        for (i = 0, ii = ps.length; i < ii; i += 3) {
          drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
        }

        break;

      default:
        throw new Error('illegal figure');
    }
  }

  function createMeshCanvas(bounds, combinesScale, coords, colors, figures, backgroundColor, cachedCanvases, webGLContext) {
    var EXPECTED_SCALE = 1.1;
    var MAX_PATTERN_SIZE = 3000;
    var BORDER_SIZE = 2;
    var offsetX = Math.floor(bounds[0]);
    var offsetY = Math.floor(bounds[1]);
    var boundsWidth = Math.ceil(bounds[2]) - offsetX;
    var boundsHeight = Math.ceil(bounds[3]) - offsetY;
    var width = Math.min(Math.ceil(Math.abs(boundsWidth * combinesScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
    var height = Math.min(Math.ceil(Math.abs(boundsHeight * combinesScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
    var scaleX = boundsWidth / width;
    var scaleY = boundsHeight / height;
    var context = {
      coords: coords,
      colors: colors,
      offsetX: -offsetX,
      offsetY: -offsetY,
      scaleX: 1 / scaleX,
      scaleY: 1 / scaleY
    };
    var paddedWidth = width + BORDER_SIZE * 2;
    var paddedHeight = height + BORDER_SIZE * 2;
    var canvas, tmpCanvas, i, ii;

    if (webGLContext.isEnabled) {
      canvas = webGLContext.drawFigures({
        width: width,
        height: height,
        backgroundColor: backgroundColor,
        figures: figures,
        context: context
      });
      tmpCanvas = cachedCanvases.getCanvas('mesh', paddedWidth, paddedHeight, false);
      tmpCanvas.context.drawImage(canvas, BORDER_SIZE, BORDER_SIZE);
      canvas = tmpCanvas.canvas;
    } else {
      tmpCanvas = cachedCanvases.getCanvas('mesh', paddedWidth, paddedHeight, false);
      var tmpCtx = tmpCanvas.context;
      var data = tmpCtx.createImageData(width, height);

      if (backgroundColor) {
        var bytes = data.data;

        for (i = 0, ii = bytes.length; i < ii; i += 4) {
          bytes[i] = backgroundColor[0];
          bytes[i + 1] = backgroundColor[1];
          bytes[i + 2] = backgroundColor[2];
          bytes[i + 3] = 255;
        }
      }

      for (i = 0; i < figures.length; i++) {
        drawFigure(data, figures[i], context);
      }

      tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
      canvas = tmpCanvas.canvas;
    }

    return {
      canvas: canvas,
      offsetX: offsetX - BORDER_SIZE * scaleX,
      offsetY: offsetY - BORDER_SIZE * scaleY,
      scaleX: scaleX,
      scaleY: scaleY
    };
  }

  return createMeshCanvas;
}();

ShadingIRs.Mesh = {
  fromIR: function Mesh_fromIR(raw) {
    var coords = raw[2];
    var colors = raw[3];
    var figures = raw[4];
    var bounds = raw[5];
    var matrix = raw[6];
    var background = raw[8];
    return {
      type: 'Pattern',
      getPattern: function Mesh_getPattern(ctx, owner, shadingFill) {
        var scale;

        if (shadingFill) {
          scale = _util.Util.singularValueDecompose2dScale(ctx.mozCurrentTransform);
        } else {
          scale = _util.Util.singularValueDecompose2dScale(owner.baseTransform);

          if (matrix) {
            var matrixScale = _util.Util.singularValueDecompose2dScale(matrix);

            scale = [scale[0] * matrixScale[0], scale[1] * matrixScale[1]];
          }
        }

        var temporaryPatternCanvas = createMeshCanvas(bounds, scale, coords, colors, figures, shadingFill ? null : background, owner.cachedCanvases, owner.webGLContext);

        if (!shadingFill) {
          ctx.setTransform.apply(ctx, owner.baseTransform);

          if (matrix) {
            ctx.transform.apply(ctx, matrix);
          }
        }

        ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
        ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
        return ctx.createPattern(temporaryPatternCanvas.canvas, 'no-repeat');
      }
    };
  }
};
ShadingIRs.Dummy = {
  fromIR: function Dummy_fromIR() {
    return {
      type: 'Pattern',
      getPattern: function Dummy_fromIR_getPattern() {
        return 'hotpink';
      }
    };
  }
};

function getShadingPatternFromIR(raw) {
  var shadingIR = ShadingIRs[raw[0]];

  if (!shadingIR) {
    throw new Error("Unknown IR type: ".concat(raw[0]));
  }

  return shadingIR.fromIR(raw);
}

var TilingPattern = function TilingPatternClosure() {
  var PaintType = {
    COLORED: 1,
    UNCOLORED: 2
  };
  var MAX_PATTERN_SIZE = 3000;

  function TilingPattern(IR, color, ctx, canvasGraphicsFactory, baseTransform) {
    this.operatorList = IR[2];
    this.matrix = IR[3] || [1, 0, 0, 1, 0, 0];
    this.bbox = IR[4];
    this.xstep = IR[5];
    this.ystep = IR[6];
    this.paintType = IR[7];
    this.tilingType = IR[8];
    this.color = color;
    this.canvasGraphicsFactory = canvasGraphicsFactory;
    this.baseTransform = baseTransform;
    this.type = 'Pattern';
    this.ctx = ctx;
  }

  TilingPattern.prototype = {
    createPatternCanvas: function TilinPattern_createPatternCanvas(owner) {
      var operatorList = this.operatorList;
      var bbox = this.bbox;
      var xstep = this.xstep;
      var ystep = this.ystep;
      var paintType = this.paintType;
      var tilingType = this.tilingType;
      var color = this.color;
      var canvasGraphicsFactory = this.canvasGraphicsFactory;
      (0, _util.info)('TilingType: ' + tilingType);
      var x0 = bbox[0],
          y0 = bbox[1],
          x1 = bbox[2],
          y1 = bbox[3];

      var matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);

      var curMatrixScale = _util.Util.singularValueDecompose2dScale(this.baseTransform);

      var combinedScale = [matrixScale[0] * curMatrixScale[0], matrixScale[1] * curMatrixScale[1]];
      var dimx = this.getSizeAndScale(xstep, this.ctx.canvas.width, combinedScale[0]);
      var dimy = this.getSizeAndScale(ystep, this.ctx.canvas.height, combinedScale[1]);
      var tmpCanvas = owner.cachedCanvases.getCanvas('pattern', dimx.size, dimy.size, true);
      var tmpCtx = tmpCanvas.context;
      var graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
      graphics.groupLevel = owner.groupLevel;
      this.setFillAndStrokeStyleToContext(graphics, paintType, color);
      graphics.transform(dimx.scale, 0, 0, dimy.scale, 0, 0);
      graphics.transform(1, 0, 0, 1, -x0, -y0);
      this.clipBbox(graphics, bbox, x0, y0, x1, y1);
      graphics.executeOperatorList(operatorList);
      this.ctx.transform(1, 0, 0, 1, x0, y0);
      this.ctx.scale(1 / dimx.scale, 1 / dimy.scale);
      return tmpCanvas.canvas;
    },
    getSizeAndScale: function TilingPattern_getSizeAndScale(step, realOutputSize, scale) {
      step = Math.abs(step);
      var maxSize = Math.max(MAX_PATTERN_SIZE, realOutputSize);
      var size = Math.ceil(step * scale);

      if (size >= maxSize) {
        size = maxSize;
      } else {
        scale = size / step;
      }

      return {
        scale: scale,
        size: size
      };
    },
    clipBbox: function clipBbox(graphics, bbox, x0, y0, x1, y1) {
      if (Array.isArray(bbox) && bbox.length === 4) {
        var bboxWidth = x1 - x0;
        var bboxHeight = y1 - y0;
        graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
        graphics.clip();
        graphics.endPath();
      }
    },
    setFillAndStrokeStyleToContext: function setFillAndStrokeStyleToContext(graphics, paintType, color) {
      var context = graphics.ctx,
          current = graphics.current;

      switch (paintType) {
        case PaintType.COLORED:
          var ctx = this.ctx;
          context.fillStyle = ctx.fillStyle;
          context.strokeStyle = ctx.strokeStyle;
          current.fillColor = ctx.fillStyle;
          current.strokeColor = ctx.strokeStyle;
          break;

        case PaintType.UNCOLORED:
          var cssColor = _util.Util.makeCssRgb(color[0], color[1], color[2]);

          context.fillStyle = cssColor;
          context.strokeStyle = cssColor;
          current.fillColor = cssColor;
          current.strokeColor = cssColor;
          break;

        default:
          throw new _util.FormatError("Unsupported paint type: ".concat(paintType));
      }
    },
    getPattern: function TilingPattern_getPattern(ctx, owner) {
      ctx = this.ctx;
      ctx.setTransform.apply(ctx, this.baseTransform);
      ctx.transform.apply(ctx, this.matrix);
      var temporaryPatternCanvas = this.createPatternCanvas(owner);
      return ctx.createPattern(temporaryPatternCanvas, 'repeat');
    }
  };
  return TilingPattern;
}();

exports.TilingPattern = TilingPattern;

/***/ }),
/* 156 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalWorkerOptions = void 0;
var GlobalWorkerOptions = Object.create(null);
exports.GlobalWorkerOptions = GlobalWorkerOptions;
GlobalWorkerOptions.workerPort = GlobalWorkerOptions.workerPort === undefined ? null : GlobalWorkerOptions.workerPort;
GlobalWorkerOptions.workerSrc = GlobalWorkerOptions.workerSrc === undefined ? '' : GlobalWorkerOptions.workerSrc;

/***/ }),
/* 157 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageHandler = MessageHandler;

var _regenerator = _interopRequireDefault(__w_pdfjs_require__(148));

var _util = __w_pdfjs_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function resolveCall(_x, _x2) {
  return _resolveCall.apply(this, arguments);
}

function _resolveCall() {
  _resolveCall = _asyncToGenerator(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee(fn, args) {
    var thisArg,
        _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            thisArg = _args.length > 2 && _args[2] !== undefined ? _args[2] : null;

            if (fn) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", undefined);

          case 3:
            return _context.abrupt("return", fn.apply(thisArg, args));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _resolveCall.apply(this, arguments);
}

function wrapReason(reason) {
  if (_typeof(reason) !== 'object') {
    return reason;
  }

  switch (reason.name) {
    case 'AbortException':
      return new _util.AbortException(reason.message);

    case 'MissingPDFException':
      return new _util.MissingPDFException(reason.message);

    case 'UnexpectedResponseException':
      return new _util.UnexpectedResponseException(reason.message, reason.status);

    default:
      return new _util.UnknownErrorException(reason.message, reason.details);
  }
}

function makeReasonSerializable(reason) {
  if (!(reason instanceof Error) || reason instanceof _util.AbortException || reason instanceof _util.MissingPDFException || reason instanceof _util.UnexpectedResponseException || reason instanceof _util.UnknownErrorException) {
    return reason;
  }

  return new _util.UnknownErrorException(reason.message, reason.toString());
}

function resolveOrReject(capability, success, reason) {
  if (success) {
    capability.resolve();
  } else {
    capability.reject(reason);
  }
}

function finalize(promise) {
  return Promise.resolve(promise)["catch"](function () {});
}

function MessageHandler(sourceName, targetName, comObj) {
  var _this = this;

  this.sourceName = sourceName;
  this.targetName = targetName;
  this.comObj = comObj;
  this.callbackId = 1;
  this.streamId = 1;
  this.postMessageTransfers = true;
  this.streamSinks = Object.create(null);
  this.streamControllers = Object.create(null);
  var callbacksCapabilities = this.callbacksCapabilities = Object.create(null);
  var ah = this.actionHandler = Object.create(null);

  this._onComObjOnMessage = function (event) {
    var data = event.data;

    if (data.targetName !== _this.sourceName) {
      return;
    }

    if (data.stream) {
      _this._processStreamMessage(data);
    } else if (data.isReply) {
      var callbackId = data.callbackId;

      if (data.callbackId in callbacksCapabilities) {
        var callback = callbacksCapabilities[callbackId];
        delete callbacksCapabilities[callbackId];

        if ('error' in data) {
          callback.reject(wrapReason(data.error));
        } else {
          callback.resolve(data.data);
        }
      } else {
        throw new Error("Cannot resolve callback ".concat(callbackId));
      }
    } else if (data.action in ah) {
      var action = ah[data.action];

      if (data.callbackId) {
        var _sourceName = _this.sourceName;
        var _targetName = data.sourceName;
        Promise.resolve().then(function () {
          return action[0].call(action[1], data.data);
        }).then(function (result) {
          comObj.postMessage({
            sourceName: _sourceName,
            targetName: _targetName,
            isReply: true,
            callbackId: data.callbackId,
            data: result
          });
        }, function (reason) {
          comObj.postMessage({
            sourceName: _sourceName,
            targetName: _targetName,
            isReply: true,
            callbackId: data.callbackId,
            error: makeReasonSerializable(reason)
          });
        });
      } else if (data.streamId) {
        _this._createStreamSink(data);
      } else {
        action[0].call(action[1], data.data);
      }
    } else {
      throw new Error("Unknown action from worker: ".concat(data.action));
    }
  };

  comObj.addEventListener('message', this._onComObjOnMessage);
}

MessageHandler.prototype = {
  on: function on(actionName, handler, scope) {
    var ah = this.actionHandler;

    if (ah[actionName]) {
      throw new Error("There is already an actionName called \"".concat(actionName, "\""));
    }

    ah[actionName] = [handler, scope];
  },
  send: function send(actionName, data, transfers) {
    var message = {
      sourceName: this.sourceName,
      targetName: this.targetName,
      action: actionName,
      data: data
    };
    this.postMessage(message, transfers);
  },
  sendWithPromise: function sendWithPromise(actionName, data, transfers) {
    var callbackId = this.callbackId++;
    var message = {
      sourceName: this.sourceName,
      targetName: this.targetName,
      action: actionName,
      data: data,
      callbackId: callbackId
    };
    var capability = (0, _util.createPromiseCapability)();
    this.callbacksCapabilities[callbackId] = capability;

    try {
      this.postMessage(message, transfers);
    } catch (e) {
      capability.reject(e);
    }

    return capability.promise;
  },
  sendWithStream: function sendWithStream(actionName, data, queueingStrategy, transfers) {
    var _this2 = this;

    var streamId = this.streamId++;
    var sourceName = this.sourceName;
    var targetName = this.targetName;
    return new _util.ReadableStream({
      start: function start(controller) {
        var startCapability = (0, _util.createPromiseCapability)();
        _this2.streamControllers[streamId] = {
          controller: controller,
          startCall: startCapability,
          isClosed: false
        };

        _this2.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          action: actionName,
          streamId: streamId,
          data: data,
          desiredSize: controller.desiredSize
        });

        return startCapability.promise;
      },
      pull: function pull(controller) {
        var pullCapability = (0, _util.createPromiseCapability)();
        _this2.streamControllers[streamId].pullCall = pullCapability;

        _this2.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          stream: 'pull',
          streamId: streamId,
          desiredSize: controller.desiredSize
        });

        return pullCapability.promise;
      },
      cancel: function cancel(reason) {
        var cancelCapability = (0, _util.createPromiseCapability)();
        _this2.streamControllers[streamId].cancelCall = cancelCapability;
        _this2.streamControllers[streamId].isClosed = true;

        _this2.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          stream: 'cancel',
          reason: reason,
          streamId: streamId
        });

        return cancelCapability.promise;
      }
    }, queueingStrategy);
  },
  _createStreamSink: function _createStreamSink(data) {
    var _this3 = this;

    var self = this;
    var action = this.actionHandler[data.action];
    var streamId = data.streamId;
    var desiredSize = data.desiredSize;
    var sourceName = this.sourceName;
    var targetName = data.sourceName;
    var capability = (0, _util.createPromiseCapability)();

    var sendStreamRequest = function sendStreamRequest(_ref) {
      var stream = _ref.stream,
          chunk = _ref.chunk,
          transfers = _ref.transfers,
          success = _ref.success,
          reason = _ref.reason;

      _this3.postMessage({
        sourceName: sourceName,
        targetName: targetName,
        stream: stream,
        streamId: streamId,
        chunk: chunk,
        success: success,
        reason: reason
      }, transfers);
    };

    var streamSink = {
      enqueue: function enqueue(chunk) {
        var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var transfers = arguments.length > 2 ? arguments[2] : undefined;

        if (this.isCancelled) {
          return;
        }

        var lastDesiredSize = this.desiredSize;
        this.desiredSize -= size;

        if (lastDesiredSize > 0 && this.desiredSize <= 0) {
          this.sinkCapability = (0, _util.createPromiseCapability)();
          this.ready = this.sinkCapability.promise;
        }

        sendStreamRequest({
          stream: 'enqueue',
          chunk: chunk,
          transfers: transfers
        });
      },
      close: function close() {
        if (this.isCancelled) {
          return;
        }

        this.isCancelled = true;
        sendStreamRequest({
          stream: 'close'
        });
        delete self.streamSinks[streamId];
      },
      error: function error(reason) {
        if (this.isCancelled) {
          return;
        }

        this.isCancelled = true;
        sendStreamRequest({
          stream: 'error',
          reason: reason
        });
      },
      sinkCapability: capability,
      onPull: null,
      onCancel: null,
      isCancelled: false,
      desiredSize: desiredSize,
      ready: null
    };
    streamSink.sinkCapability.resolve();
    streamSink.ready = streamSink.sinkCapability.promise;
    this.streamSinks[streamId] = streamSink;
    resolveCall(action[0], [data.data, streamSink], action[1]).then(function () {
      sendStreamRequest({
        stream: 'start_complete',
        success: true
      });
    }, function (reason) {
      sendStreamRequest({
        stream: 'start_complete',
        success: false,
        reason: reason
      });
    });
  },
  _processStreamMessage: function _processStreamMessage(data) {
    var _this4 = this;

    var sourceName = this.sourceName;
    var targetName = data.sourceName;
    var streamId = data.streamId;

    var sendStreamResponse = function sendStreamResponse(_ref2) {
      var stream = _ref2.stream,
          success = _ref2.success,
          reason = _ref2.reason;

      _this4.comObj.postMessage({
        sourceName: sourceName,
        targetName: targetName,
        stream: stream,
        success: success,
        streamId: streamId,
        reason: reason
      });
    };

    var deleteStreamController = function deleteStreamController() {
      Promise.all([_this4.streamControllers[data.streamId].startCall, _this4.streamControllers[data.streamId].pullCall, _this4.streamControllers[data.streamId].cancelCall].map(function (capability) {
        return capability && finalize(capability.promise);
      })).then(function () {
        delete _this4.streamControllers[data.streamId];
      });
    };

    switch (data.stream) {
      case 'start_complete':
        resolveOrReject(this.streamControllers[data.streamId].startCall, data.success, wrapReason(data.reason));
        break;

      case 'pull_complete':
        resolveOrReject(this.streamControllers[data.streamId].pullCall, data.success, wrapReason(data.reason));
        break;

      case 'pull':
        if (!this.streamSinks[data.streamId]) {
          sendStreamResponse({
            stream: 'pull_complete',
            success: true
          });
          break;
        }

        if (this.streamSinks[data.streamId].desiredSize <= 0 && data.desiredSize > 0) {
          this.streamSinks[data.streamId].sinkCapability.resolve();
        }

        this.streamSinks[data.streamId].desiredSize = data.desiredSize;
        resolveCall(this.streamSinks[data.streamId].onPull).then(function () {
          sendStreamResponse({
            stream: 'pull_complete',
            success: true
          });
        }, function (reason) {
          sendStreamResponse({
            stream: 'pull_complete',
            success: false,
            reason: reason
          });
        });
        break;

      case 'enqueue':
        (0, _util.assert)(this.streamControllers[data.streamId], 'enqueue should have stream controller');

        if (!this.streamControllers[data.streamId].isClosed) {
          this.streamControllers[data.streamId].controller.enqueue(data.chunk);
        }

        break;

      case 'close':
        (0, _util.assert)(this.streamControllers[data.streamId], 'close should have stream controller');

        if (this.streamControllers[data.streamId].isClosed) {
          break;
        }

        this.streamControllers[data.streamId].isClosed = true;
        this.streamControllers[data.streamId].controller.close();
        deleteStreamController();
        break;

      case 'error':
        (0, _util.assert)(this.streamControllers[data.streamId], 'error should have stream controller');
        this.streamControllers[data.streamId].controller.error(wrapReason(data.reason));
        deleteStreamController();
        break;

      case 'cancel_complete':
        resolveOrReject(this.streamControllers[data.streamId].cancelCall, data.success, wrapReason(data.reason));
        deleteStreamController();
        break;

      case 'cancel':
        if (!this.streamSinks[data.streamId]) {
          break;
        }

        resolveCall(this.streamSinks[data.streamId].onCancel, [wrapReason(data.reason)]).then(function () {
          sendStreamResponse({
            stream: 'cancel_complete',
            success: true
          });
        }, function (reason) {
          sendStreamResponse({
            stream: 'cancel_complete',
            success: false,
            reason: reason
          });
        });
        this.streamSinks[data.streamId].sinkCapability.reject(wrapReason(data.reason));
        this.streamSinks[data.streamId].isCancelled = true;
        delete this.streamSinks[data.streamId];
        break;

      default:
        throw new Error('Unexpected stream case');
    }
  },
  postMessage: function postMessage(message, transfers) {
    if (transfers && this.postMessageTransfers) {
      this.comObj.postMessage(message, transfers);
    } else {
      this.comObj.postMessage(message);
    }
  },
  destroy: function destroy() {
    this.comObj.removeEventListener('message', this._onComObjOnMessage);
  }
};

/***/ }),
/* 158 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Metadata = void 0;

var _util = __w_pdfjs_require__(1);

var _xml_parser = __w_pdfjs_require__(159);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Metadata =
/*#__PURE__*/
function () {
  function Metadata(data) {
    _classCallCheck(this, Metadata);

    (0, _util.assert)(typeof data === 'string', 'Metadata: input is not a string');
    data = this._repair(data);
    var parser = new _xml_parser.SimpleXMLParser();
    var xmlDocument = parser.parseFromString(data);
    this._metadata = Object.create(null);

    if (xmlDocument) {
      this._parse(xmlDocument);
    }
  }

  _createClass(Metadata, [{
    key: "_repair",
    value: function _repair(data) {
      return data.replace(/^([^<]+)/, '').replace(/>\\376\\377([^<]+)/g, function (all, codes) {
        var bytes = codes.replace(/\\([0-3])([0-7])([0-7])/g, function (code, d1, d2, d3) {
          return String.fromCharCode(d1 * 64 + d2 * 8 + d3 * 1);
        }).replace(/&(amp|apos|gt|lt|quot);/g, function (str, name) {
          switch (name) {
            case 'amp':
              return '&';

            case 'apos':
              return '\'';

            case 'gt':
              return '>';

            case 'lt':
              return '<';

            case 'quot':
              return '\"';
          }

          throw new Error("_repair: ".concat(name, " isn't defined."));
        });
        var chars = '';

        for (var i = 0, ii = bytes.length; i < ii; i += 2) {
          var code = bytes.charCodeAt(i) * 256 + bytes.charCodeAt(i + 1);

          if (code >= 32 && code < 127 && code !== 60 && code !== 62 && code !== 38) {
            chars += String.fromCharCode(code);
          } else {
            chars += '&#x' + (0x10000 + code).toString(16).substring(1) + ';';
          }
        }

        return '>' + chars;
      });
    }
  }, {
    key: "_parse",
    value: function _parse(xmlDocument) {
      var rdf = xmlDocument.documentElement;

      if (rdf.nodeName.toLowerCase() !== 'rdf:rdf') {
        rdf = rdf.firstChild;

        while (rdf && rdf.nodeName.toLowerCase() !== 'rdf:rdf') {
          rdf = rdf.nextSibling;
        }
      }

      var nodeName = rdf ? rdf.nodeName.toLowerCase() : null;

      if (!rdf || nodeName !== 'rdf:rdf' || !rdf.hasChildNodes()) {
        return;
      }

      var children = rdf.childNodes;

      for (var i = 0, ii = children.length; i < ii; i++) {
        var desc = children[i];

        if (desc.nodeName.toLowerCase() !== 'rdf:description') {
          continue;
        }

        for (var j = 0, jj = desc.childNodes.length; j < jj; j++) {
          if (desc.childNodes[j].nodeName.toLowerCase() !== '#text') {
            var entry = desc.childNodes[j];
            var name = entry.nodeName.toLowerCase();
            this._metadata[name] = entry.textContent.trim();
          }
        }
      }
    }
  }, {
    key: "get",
    value: function get(name) {
      var data = this._metadata[name];
      return typeof data !== 'undefined' ? data : null;
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return this._metadata;
    }
  }, {
    key: "has",
    value: function has(name) {
      return typeof this._metadata[name] !== 'undefined';
    }
  }]);

  return Metadata;
}();

exports.Metadata = Metadata;

/***/ }),
/* 159 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleXMLParser = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var XMLParserErrorCode = {
  NoError: 0,
  EndOfDocument: -1,
  UnterminatedCdat: -2,
  UnterminatedXmlDeclaration: -3,
  UnterminatedDoctypeDeclaration: -4,
  UnterminatedComment: -5,
  MalformedElement: -6,
  OutOfMemory: -7,
  UnterminatedAttributeValue: -8,
  UnterminatedElement: -9,
  ElementNeverBegun: -10
};

function isWhitespace(s, index) {
  var ch = s[index];
  return ch === ' ' || ch === '\n' || ch === '\r' || ch === '\t';
}

function isWhitespaceString(s) {
  for (var i = 0, ii = s.length; i < ii; i++) {
    if (!isWhitespace(s, i)) {
      return false;
    }
  }

  return true;
}

var XMLParserBase =
/*#__PURE__*/
function () {
  function XMLParserBase() {
    _classCallCheck(this, XMLParserBase);
  }

  _createClass(XMLParserBase, [{
    key: "_resolveEntities",
    value: function _resolveEntities(s) {
      var _this = this;

      return s.replace(/&([^;]+);/g, function (all, entity) {
        if (entity.substring(0, 2) === '#x') {
          return String.fromCharCode(parseInt(entity.substring(2), 16));
        } else if (entity.substring(0, 1) === '#') {
          return String.fromCharCode(parseInt(entity.substring(1), 10));
        }

        switch (entity) {
          case 'lt':
            return '<';

          case 'gt':
            return '>';

          case 'amp':
            return '&';

          case 'quot':
            return '\"';
        }

        return _this.onResolveEntity(entity);
      });
    }
  }, {
    key: "_parseContent",
    value: function _parseContent(s, start) {
      var pos = start,
          name,
          attributes = [];

      function skipWs() {
        while (pos < s.length && isWhitespace(s, pos)) {
          ++pos;
        }
      }

      while (pos < s.length && !isWhitespace(s, pos) && s[pos] !== '>' && s[pos] !== '/') {
        ++pos;
      }

      name = s.substring(start, pos);
      skipWs();

      while (pos < s.length && s[pos] !== '>' && s[pos] !== '/' && s[pos] !== '?') {
        skipWs();
        var attrName = '',
            attrValue = '';

        while (pos < s.length && !isWhitespace(s, pos) && s[pos] !== '=') {
          attrName += s[pos];
          ++pos;
        }

        skipWs();

        if (s[pos] !== '=') {
          return null;
        }

        ++pos;
        skipWs();
        var attrEndChar = s[pos];

        if (attrEndChar !== '\"' && attrEndChar !== '\'') {
          return null;
        }

        var attrEndIndex = s.indexOf(attrEndChar, ++pos);

        if (attrEndIndex < 0) {
          return null;
        }

        attrValue = s.substring(pos, attrEndIndex);
        attributes.push({
          name: attrName,
          value: this._resolveEntities(attrValue)
        });
        pos = attrEndIndex + 1;
        skipWs();
      }

      return {
        name: name,
        attributes: attributes,
        parsed: pos - start
      };
    }
  }, {
    key: "_parseProcessingInstruction",
    value: function _parseProcessingInstruction(s, start) {
      var pos = start,
          name,
          value;

      function skipWs() {
        while (pos < s.length && isWhitespace(s, pos)) {
          ++pos;
        }
      }

      while (pos < s.length && !isWhitespace(s, pos) && s[pos] !== '>' && s[pos] !== '/') {
        ++pos;
      }

      name = s.substring(start, pos);
      skipWs();
      var attrStart = pos;

      while (pos < s.length && (s[pos] !== '?' || s[pos + 1] !== '>')) {
        ++pos;
      }

      value = s.substring(attrStart, pos);
      return {
        name: name,
        value: value,
        parsed: pos - start
      };
    }
  }, {
    key: "parseXml",
    value: function parseXml(s) {
      var i = 0;

      while (i < s.length) {
        var ch = s[i];
        var j = i;

        if (ch === '<') {
          ++j;
          var ch2 = s[j];
          var q = void 0;

          switch (ch2) {
            case '/':
              ++j;
              q = s.indexOf('>', j);

              if (q < 0) {
                this.onError(XMLParserErrorCode.UnterminatedElement);
                return;
              }

              this.onEndElement(s.substring(j, q));
              j = q + 1;
              break;

            case '?':
              ++j;

              var pi = this._parseProcessingInstruction(s, j);

              if (s.substring(j + pi.parsed, j + pi.parsed + 2) !== '?>') {
                this.onError(XMLParserErrorCode.UnterminatedXmlDeclaration);
                return;
              }

              this.onPi(pi.name, pi.value);
              j += pi.parsed + 2;
              break;

            case '!':
              if (s.substring(j + 1, j + 3) === '--') {
                q = s.indexOf('-->', j + 3);

                if (q < 0) {
                  this.onError(XMLParserErrorCode.UnterminatedComment);
                  return;
                }

                this.onComment(s.substring(j + 3, q));
                j = q + 3;
              } else if (s.substring(j + 1, j + 8) === '[CDATA[') {
                q = s.indexOf(']]>', j + 8);

                if (q < 0) {
                  this.onError(XMLParserErrorCode.UnterminatedCdat);
                  return;
                }

                this.onCdata(s.substring(j + 8, q));
                j = q + 3;
              } else if (s.substring(j + 1, j + 8) === 'DOCTYPE') {
                var q2 = s.indexOf('[', j + 8);
                var complexDoctype = false;
                q = s.indexOf('>', j + 8);

                if (q < 0) {
                  this.onError(XMLParserErrorCode.UnterminatedDoctypeDeclaration);
                  return;
                }

                if (q2 > 0 && q > q2) {
                  q = s.indexOf(']>', j + 8);

                  if (q < 0) {
                    this.onError(XMLParserErrorCode.UnterminatedDoctypeDeclaration);
                    return;
                  }

                  complexDoctype = true;
                }

                var doctypeContent = s.substring(j + 8, q + (complexDoctype ? 1 : 0));
                this.onDoctype(doctypeContent);
                j = q + (complexDoctype ? 2 : 1);
              } else {
                this.onError(XMLParserErrorCode.MalformedElement);
                return;
              }

              break;

            default:
              var content = this._parseContent(s, j);

              if (content === null) {
                this.onError(XMLParserErrorCode.MalformedElement);
                return;
              }

              var isClosed = false;

              if (s.substring(j + content.parsed, j + content.parsed + 2) === '/>') {
                isClosed = true;
              } else if (s.substring(j + content.parsed, j + content.parsed + 1) !== '>') {
                this.onError(XMLParserErrorCode.UnterminatedElement);
                return;
              }

              this.onBeginElement(content.name, content.attributes, isClosed);
              j += content.parsed + (isClosed ? 2 : 1);
              break;
          }
        } else {
          while (j < s.length && s[j] !== '<') {
            j++;
          }

          var text = s.substring(i, j);
          this.onText(this._resolveEntities(text));
        }

        i = j;
      }
    }
  }, {
    key: "onResolveEntity",
    value: function onResolveEntity(name) {
      return "&".concat(name, ";");
    }
  }, {
    key: "onPi",
    value: function onPi(name, value) {}
  }, {
    key: "onComment",
    value: function onComment(text) {}
  }, {
    key: "onCdata",
    value: function onCdata(text) {}
  }, {
    key: "onDoctype",
    value: function onDoctype(doctypeContent) {}
  }, {
    key: "onText",
    value: function onText(text) {}
  }, {
    key: "onBeginElement",
    value: function onBeginElement(name, attributes, isEmpty) {}
  }, {
    key: "onEndElement",
    value: function onEndElement(name) {}
  }, {
    key: "onError",
    value: function onError(code) {}
  }]);

  return XMLParserBase;
}();

var SimpleDOMNode =
/*#__PURE__*/
function () {
  function SimpleDOMNode(nodeName, nodeValue) {
    _classCallCheck(this, SimpleDOMNode);

    this.nodeName = nodeName;
    this.nodeValue = nodeValue;
    Object.defineProperty(this, 'parentNode', {
      value: null,
      writable: true
    });
  }

  _createClass(SimpleDOMNode, [{
    key: "hasChildNodes",
    value: function hasChildNodes() {
      return this.childNodes && this.childNodes.length > 0;
    }
  }, {
    key: "firstChild",
    get: function get() {
      return this.childNodes && this.childNodes[0];
    }
  }, {
    key: "nextSibling",
    get: function get() {
      var childNodes = this.parentNode.childNodes;

      if (!childNodes) {
        return undefined;
      }

      var index = childNodes.indexOf(this);

      if (index === -1) {
        return undefined;
      }

      return childNodes[index + 1];
    }
  }, {
    key: "textContent",
    get: function get() {
      if (!this.childNodes) {
        return this.nodeValue || '';
      }

      return this.childNodes.map(function (child) {
        return child.textContent;
      }).join('');
    }
  }]);

  return SimpleDOMNode;
}();

var SimpleXMLParser =
/*#__PURE__*/
function (_XMLParserBase) {
  _inherits(SimpleXMLParser, _XMLParserBase);

  function SimpleXMLParser() {
    var _this2;

    _classCallCheck(this, SimpleXMLParser);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(SimpleXMLParser).call(this));
    _this2._currentFragment = null;
    _this2._stack = null;
    _this2._errorCode = XMLParserErrorCode.NoError;
    return _this2;
  }

  _createClass(SimpleXMLParser, [{
    key: "parseFromString",
    value: function parseFromString(data) {
      this._currentFragment = [];
      this._stack = [];
      this._errorCode = XMLParserErrorCode.NoError;
      this.parseXml(data);

      if (this._errorCode !== XMLParserErrorCode.NoError) {
        return undefined;
      }

      var _this$_currentFragmen = _slicedToArray(this._currentFragment, 1),
          documentElement = _this$_currentFragmen[0];

      if (!documentElement) {
        return undefined;
      }

      return {
        documentElement: documentElement
      };
    }
  }, {
    key: "onResolveEntity",
    value: function onResolveEntity(name) {
      switch (name) {
        case 'apos':
          return '\'';
      }

      return _get(_getPrototypeOf(SimpleXMLParser.prototype), "onResolveEntity", this).call(this, name);
    }
  }, {
    key: "onText",
    value: function onText(text) {
      if (isWhitespaceString(text)) {
        return;
      }

      var node = new SimpleDOMNode('#text', text);

      this._currentFragment.push(node);
    }
  }, {
    key: "onCdata",
    value: function onCdata(text) {
      var node = new SimpleDOMNode('#text', text);

      this._currentFragment.push(node);
    }
  }, {
    key: "onBeginElement",
    value: function onBeginElement(name, attributes, isEmpty) {
      var node = new SimpleDOMNode(name);
      node.childNodes = [];

      this._currentFragment.push(node);

      if (isEmpty) {
        return;
      }

      this._stack.push(this._currentFragment);

      this._currentFragment = node.childNodes;
    }
  }, {
    key: "onEndElement",
    value: function onEndElement(name) {
      this._currentFragment = this._stack.pop() || [];
      var lastElement = this._currentFragment[this._currentFragment.length - 1];

      if (!lastElement) {
        return;
      }

      for (var i = 0, ii = lastElement.childNodes.length; i < ii; i++) {
        lastElement.childNodes[i].parentNode = lastElement;
      }
    }
  }, {
    key: "onError",
    value: function onError(code) {
      this._errorCode = code;
    }
  }]);

  return SimpleXMLParser;
}(XMLParserBase);

exports.SimpleXMLParser = SimpleXMLParser;

/***/ }),
/* 160 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFDataTransportStream = void 0;

var _regenerator = _interopRequireDefault(__w_pdfjs_require__(148));

var _util = __w_pdfjs_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PDFDataTransportStream =
/*#__PURE__*/
function () {
  function PDFDataTransportStream(params, pdfDataRangeTransport) {
    var _this = this;

    _classCallCheck(this, PDFDataTransportStream);

    (0, _util.assert)(pdfDataRangeTransport);
    this._queuedChunks = [];
    this._progressiveDone = params.progressiveDone || false;
    var initialData = params.initialData;

    if (initialData && initialData.length > 0) {
      var buffer = new Uint8Array(initialData).buffer;

      this._queuedChunks.push(buffer);
    }

    this._pdfDataRangeTransport = pdfDataRangeTransport;
    this._isStreamingSupported = !params.disableStream;
    this._isRangeSupported = !params.disableRange;
    this._contentLength = params.length;
    this._fullRequestReader = null;
    this._rangeReaders = [];

    this._pdfDataRangeTransport.addRangeListener(function (begin, chunk) {
      _this._onReceiveData({
        begin: begin,
        chunk: chunk
      });
    });

    this._pdfDataRangeTransport.addProgressListener(function (loaded, total) {
      _this._onProgress({
        loaded: loaded,
        total: total
      });
    });

    this._pdfDataRangeTransport.addProgressiveReadListener(function (chunk) {
      _this._onReceiveData({
        chunk: chunk
      });
    });

    this._pdfDataRangeTransport.addProgressiveDoneListener(function () {
      _this._onProgressiveDone();
    });

    this._pdfDataRangeTransport.transportReady();
  }

  _createClass(PDFDataTransportStream, [{
    key: "_onReceiveData",
    value: function _onReceiveData(args) {
      var buffer = new Uint8Array(args.chunk).buffer;

      if (args.begin === undefined) {
        if (this._fullRequestReader) {
          this._fullRequestReader._enqueue(buffer);
        } else {
          this._queuedChunks.push(buffer);
        }
      } else {
        var found = this._rangeReaders.some(function (rangeReader) {
          if (rangeReader._begin !== args.begin) {
            return false;
          }

          rangeReader._enqueue(buffer);

          return true;
        });

        (0, _util.assert)(found);
      }
    }
  }, {
    key: "_onProgress",
    value: function _onProgress(evt) {
      if (evt.total === undefined) {
        var firstReader = this._rangeReaders[0];

        if (firstReader && firstReader.onProgress) {
          firstReader.onProgress({
            loaded: evt.loaded
          });
        }
      } else {
        var fullReader = this._fullRequestReader;

        if (fullReader && fullReader.onProgress) {
          fullReader.onProgress({
            loaded: evt.loaded,
            total: evt.total
          });
        }
      }
    }
  }, {
    key: "_onProgressiveDone",
    value: function _onProgressiveDone() {
      if (this._fullRequestReader) {
        this._fullRequestReader.progressiveDone();
      }

      this._progressiveDone = true;
    }
  }, {
    key: "_removeRangeReader",
    value: function _removeRangeReader(reader) {
      var i = this._rangeReaders.indexOf(reader);

      if (i >= 0) {
        this._rangeReaders.splice(i, 1);
      }
    }
  }, {
    key: "getFullReader",
    value: function getFullReader() {
      (0, _util.assert)(!this._fullRequestReader);
      var queuedChunks = this._queuedChunks;
      this._queuedChunks = null;
      return new PDFDataTransportStreamReader(this, queuedChunks, this._progressiveDone);
    }
  }, {
    key: "getRangeReader",
    value: function getRangeReader(begin, end) {
      if (end <= this._progressiveDataLength) {
        return null;
      }

      var reader = new PDFDataTransportStreamRangeReader(this, begin, end);

      this._pdfDataRangeTransport.requestDataRange(begin, end);

      this._rangeReaders.push(reader);

      return reader;
    }
  }, {
    key: "cancelAllRequests",
    value: function cancelAllRequests(reason) {
      if (this._fullRequestReader) {
        this._fullRequestReader.cancel(reason);
      }

      var readers = this._rangeReaders.slice(0);

      readers.forEach(function (rangeReader) {
        rangeReader.cancel(reason);
      });

      this._pdfDataRangeTransport.abort();
    }
  }, {
    key: "_progressiveDataLength",
    get: function get() {
      return this._fullRequestReader ? this._fullRequestReader._loaded : 0;
    }
  }]);

  return PDFDataTransportStream;
}();

exports.PDFDataTransportStream = PDFDataTransportStream;

var PDFDataTransportStreamReader =
/*#__PURE__*/
function () {
  function PDFDataTransportStreamReader(stream, queuedChunks) {
    var progressiveDone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck(this, PDFDataTransportStreamReader);

    this._stream = stream;
    this._done = progressiveDone || false;
    this._filename = null;
    this._queuedChunks = queuedChunks || [];
    this._loaded = 0;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = this._queuedChunks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var chunk = _step.value;
        this._loaded += chunk.byteLength;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    this._requests = [];
    this._headersReady = Promise.resolve();
    stream._fullRequestReader = this;
    this.onProgress = null;
  }

  _createClass(PDFDataTransportStreamReader, [{
    key: "_enqueue",
    value: function _enqueue(chunk) {
      if (this._done) {
        return;
      }

      if (this._requests.length > 0) {
        var requestCapability = this._requests.shift();

        requestCapability.resolve({
          value: chunk,
          done: false
        });
      } else {
        this._queuedChunks.push(chunk);
      }

      this._loaded += chunk.byteLength;
    }
  }, {
    key: "read",
    value: function () {
      var _read = _asyncToGenerator(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee() {
        var chunk, requestCapability;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this._queuedChunks.length > 0)) {
                  _context.next = 3;
                  break;
                }

                chunk = this._queuedChunks.shift();
                return _context.abrupt("return", {
                  value: chunk,
                  done: false
                });

              case 3:
                if (!this._done) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", {
                  value: undefined,
                  done: true
                });

              case 5:
                requestCapability = (0, _util.createPromiseCapability)();

                this._requests.push(requestCapability);

                return _context.abrupt("return", requestCapability.promise);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function read() {
        return _read.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: "cancel",
    value: function cancel(reason) {
      this._done = true;

      this._requests.forEach(function (requestCapability) {
        requestCapability.resolve({
          value: undefined,
          done: true
        });
      });

      this._requests = [];
    }
  }, {
    key: "progressiveDone",
    value: function progressiveDone() {
      if (this._done) {
        return;
      }

      this._done = true;
    }
  }, {
    key: "headersReady",
    get: function get() {
      return this._headersReady;
    }
  }, {
    key: "filename",
    get: function get() {
      return this._filename;
    }
  }, {
    key: "isRangeSupported",
    get: function get() {
      return this._stream._isRangeSupported;
    }
  }, {
    key: "isStreamingSupported",
    get: function get() {
      return this._stream._isStreamingSupported;
    }
  }, {
    key: "contentLength",
    get: function get() {
      return this._stream._contentLength;
    }
  }]);

  return PDFDataTransportStreamReader;
}();

var PDFDataTransportStreamRangeReader =
/*#__PURE__*/
function () {
  function PDFDataTransportStreamRangeReader(stream, begin, end) {
    _classCallCheck(this, PDFDataTransportStreamRangeReader);

    this._stream = stream;
    this._begin = begin;
    this._end = end;
    this._queuedChunk = null;
    this._requests = [];
    this._done = false;
    this.onProgress = null;
  }

  _createClass(PDFDataTransportStreamRangeReader, [{
    key: "_enqueue",
    value: function _enqueue(chunk) {
      if (this._done) {
        return;
      }

      if (this._requests.length === 0) {
        this._queuedChunk = chunk;
      } else {
        var requestsCapability = this._requests.shift();

        requestsCapability.resolve({
          value: chunk,
          done: false
        });

        this._requests.forEach(function (requestCapability) {
          requestCapability.resolve({
            value: undefined,
            done: true
          });
        });

        this._requests = [];
      }

      this._done = true;

      this._stream._removeRangeReader(this);
    }
  }, {
    key: "read",
    value: function () {
      var _read2 = _asyncToGenerator(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee2() {
        var chunk, requestCapability;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this._queuedChunk) {
                  _context2.next = 4;
                  break;
                }

                chunk = this._queuedChunk;
                this._queuedChunk = null;
                return _context2.abrupt("return", {
                  value: chunk,
                  done: false
                });

              case 4:
                if (!this._done) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return", {
                  value: undefined,
                  done: true
                });

              case 6:
                requestCapability = (0, _util.createPromiseCapability)();

                this._requests.push(requestCapability);

                return _context2.abrupt("return", requestCapability.promise);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function read() {
        return _read2.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: "cancel",
    value: function cancel(reason) {
      this._done = true;

      this._requests.forEach(function (requestCapability) {
        requestCapability.resolve({
          value: undefined,
          done: true
        });
      });

      this._requests = [];

      this._stream._removeRangeReader(this);
    }
  }, {
    key: "isStreamingSupported",
    get: function get() {
      return false;
    }
  }]);

  return PDFDataTransportStreamRangeReader;
}();

/***/ }),
/* 161 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebGLContext = void 0;

var _util = __w_pdfjs_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var WebGLContext =
/*#__PURE__*/
function () {
  function WebGLContext(_ref) {
    var _ref$enable = _ref.enable,
        enable = _ref$enable === void 0 ? false : _ref$enable;

    _classCallCheck(this, WebGLContext);

    this._enabled = enable === true;
  }

  _createClass(WebGLContext, [{
    key: "composeSMask",
    value: function composeSMask(_ref2) {
      var layer = _ref2.layer,
          mask = _ref2.mask,
          properties = _ref2.properties;
      return WebGLUtils.composeSMask(layer, mask, properties);
    }
  }, {
    key: "drawFigures",
    value: function drawFigures(_ref3) {
      var width = _ref3.width,
          height = _ref3.height,
          backgroundColor = _ref3.backgroundColor,
          figures = _ref3.figures,
          context = _ref3.context;
      return WebGLUtils.drawFigures(width, height, backgroundColor, figures, context);
    }
  }, {
    key: "clear",
    value: function clear() {
      WebGLUtils.cleanup();
    }
  }, {
    key: "isEnabled",
    get: function get() {
      var enabled = this._enabled;

      if (enabled) {
        enabled = WebGLUtils.tryInitGL();
      }

      return (0, _util.shadow)(this, 'isEnabled', enabled);
    }
  }]);

  return WebGLContext;
}();

exports.WebGLContext = WebGLContext;

var WebGLUtils = function WebGLUtilsClosure() {
  function loadShader(gl, code, shaderType) {
    var shader = gl.createShader(shaderType);
    gl.shaderSource(shader, code);
    gl.compileShader(shader);
    var compiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS);

    if (!compiled) {
      var errorMsg = gl.getShaderInfoLog(shader);
      throw new Error('Error during shader compilation: ' + errorMsg);
    }

    return shader;
  }

  function createVertexShader(gl, code) {
    return loadShader(gl, code, gl.VERTEX_SHADER);
  }

  function createFragmentShader(gl, code) {
    return loadShader(gl, code, gl.FRAGMENT_SHADER);
  }

  function createProgram(gl, shaders) {
    var program = gl.createProgram();

    for (var i = 0, ii = shaders.length; i < ii; ++i) {
      gl.attachShader(program, shaders[i]);
    }

    gl.linkProgram(program);
    var linked = gl.getProgramParameter(program, gl.LINK_STATUS);

    if (!linked) {
      var errorMsg = gl.getProgramInfoLog(program);
      throw new Error('Error during program linking: ' + errorMsg);
    }

    return program;
  }

  function createTexture(gl, image, textureId) {
    gl.activeTexture(textureId);
    var texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
    return texture;
  }

  var currentGL, currentCanvas;

  function generateGL() {
    if (currentGL) {
      return;
    }

    currentCanvas = document.createElement('canvas');
    currentGL = currentCanvas.getContext('webgl', {
      premultipliedalpha: false
    });
  }

  var smaskVertexShaderCode = '\
  attribute vec2 a_position;                                    \
  attribute vec2 a_texCoord;                                    \
                                                                \
  uniform vec2 u_resolution;                                    \
                                                                \
  varying vec2 v_texCoord;                                      \
                                                                \
  void main() {                                                 \
    vec2 clipSpace = (a_position / u_resolution) * 2.0 - 1.0;   \
    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
                                                                \
    v_texCoord = a_texCoord;                                    \
  }                                                             ';
  var smaskFragmentShaderCode = '\
  precision mediump float;                                      \
                                                                \
  uniform vec4 u_backdrop;                                      \
  uniform int u_subtype;                                        \
  uniform sampler2D u_image;                                    \
  uniform sampler2D u_mask;                                     \
                                                                \
  varying vec2 v_texCoord;                                      \
                                                                \
  void main() {                                                 \
    vec4 imageColor = texture2D(u_image, v_texCoord);           \
    vec4 maskColor = texture2D(u_mask, v_texCoord);             \
    if (u_backdrop.a > 0.0) {                                   \
      maskColor.rgb = maskColor.rgb * maskColor.a +             \
                      u_backdrop.rgb * (1.0 - maskColor.a);     \
    }                                                           \
    float lum;                                                  \
    if (u_subtype == 0) {                                       \
      lum = maskColor.a;                                        \
    } else {                                                    \
      lum = maskColor.r * 0.3 + maskColor.g * 0.59 +            \
            maskColor.b * 0.11;                                 \
    }                                                           \
    imageColor.a *= lum;                                        \
    imageColor.rgb *= imageColor.a;                             \
    gl_FragColor = imageColor;                                  \
  }                                                             ';
  var smaskCache = null;

  function initSmaskGL() {
    var canvas, gl;
    generateGL();
    canvas = currentCanvas;
    currentCanvas = null;
    gl = currentGL;
    currentGL = null;
    var vertexShader = createVertexShader(gl, smaskVertexShaderCode);
    var fragmentShader = createFragmentShader(gl, smaskFragmentShaderCode);
    var program = createProgram(gl, [vertexShader, fragmentShader]);
    gl.useProgram(program);
    var cache = {};
    cache.gl = gl;
    cache.canvas = canvas;
    cache.resolutionLocation = gl.getUniformLocation(program, 'u_resolution');
    cache.positionLocation = gl.getAttribLocation(program, 'a_position');
    cache.backdropLocation = gl.getUniformLocation(program, 'u_backdrop');
    cache.subtypeLocation = gl.getUniformLocation(program, 'u_subtype');
    var texCoordLocation = gl.getAttribLocation(program, 'a_texCoord');
    var texLayerLocation = gl.getUniformLocation(program, 'u_image');
    var texMaskLocation = gl.getUniformLocation(program, 'u_mask');
    var texCoordBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, texCoordBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 1.0, 1.0]), gl.STATIC_DRAW);
    gl.enableVertexAttribArray(texCoordLocation);
    gl.vertexAttribPointer(texCoordLocation, 2, gl.FLOAT, false, 0, 0);
    gl.uniform1i(texLayerLocation, 0);
    gl.uniform1i(texMaskLocation, 1);
    smaskCache = cache;
  }

  function composeSMask(layer, mask, properties) {
    var width = layer.width,
        height = layer.height;

    if (!smaskCache) {
      initSmaskGL();
    }

    var cache = smaskCache,
        canvas = cache.canvas,
        gl = cache.gl;
    canvas.width = width;
    canvas.height = height;
    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
    gl.uniform2f(cache.resolutionLocation, width, height);

    if (properties.backdrop) {
      gl.uniform4f(cache.resolutionLocation, properties.backdrop[0], properties.backdrop[1], properties.backdrop[2], 1);
    } else {
      gl.uniform4f(cache.resolutionLocation, 0, 0, 0, 0);
    }

    gl.uniform1i(cache.subtypeLocation, properties.subtype === 'Luminosity' ? 1 : 0);
    var texture = createTexture(gl, layer, gl.TEXTURE0);
    var maskTexture = createTexture(gl, mask, gl.TEXTURE1);
    var buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0, 0, width, 0, 0, height, 0, height, width, 0, width, height]), gl.STATIC_DRAW);
    gl.enableVertexAttribArray(cache.positionLocation);
    gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
    gl.clearColor(0, 0, 0, 0);
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
    gl.clear(gl.COLOR_BUFFER_BIT);
    gl.drawArrays(gl.TRIANGLES, 0, 6);
    gl.flush();
    gl.deleteTexture(texture);
    gl.deleteTexture(maskTexture);
    gl.deleteBuffer(buffer);
    return canvas;
  }

  var figuresVertexShaderCode = '\
  attribute vec2 a_position;                                    \
  attribute vec3 a_color;                                       \
                                                                \
  uniform vec2 u_resolution;                                    \
  uniform vec2 u_scale;                                         \
  uniform vec2 u_offset;                                        \
                                                                \
  varying vec4 v_color;                                         \
                                                                \
  void main() {                                                 \
    vec2 position = (a_position + u_offset) * u_scale;          \
    vec2 clipSpace = (position / u_resolution) * 2.0 - 1.0;     \
    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
                                                                \
    v_color = vec4(a_color / 255.0, 1.0);                       \
  }                                                             ';
  var figuresFragmentShaderCode = '\
  precision mediump float;                                      \
                                                                \
  varying vec4 v_color;                                         \
                                                                \
  void main() {                                                 \
    gl_FragColor = v_color;                                     \
  }                                                             ';
  var figuresCache = null;

  function initFiguresGL() {
    var canvas, gl;
    generateGL();
    canvas = currentCanvas;
    currentCanvas = null;
    gl = currentGL;
    currentGL = null;
    var vertexShader = createVertexShader(gl, figuresVertexShaderCode);
    var fragmentShader = createFragmentShader(gl, figuresFragmentShaderCode);
    var program = createProgram(gl, [vertexShader, fragmentShader]);
    gl.useProgram(program);
    var cache = {};
    cache.gl = gl;
    cache.canvas = canvas;
    cache.resolutionLocation = gl.getUniformLocation(program, 'u_resolution');
    cache.scaleLocation = gl.getUniformLocation(program, 'u_scale');
    cache.offsetLocation = gl.getUniformLocation(program, 'u_offset');
    cache.positionLocation = gl.getAttribLocation(program, 'a_position');
    cache.colorLocation = gl.getAttribLocation(program, 'a_color');
    figuresCache = cache;
  }

  function drawFigures(width, height, backgroundColor, figures, context) {
    if (!figuresCache) {
      initFiguresGL();
    }

    var cache = figuresCache,
        canvas = cache.canvas,
        gl = cache.gl;
    canvas.width = width;
    canvas.height = height;
    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
    gl.uniform2f(cache.resolutionLocation, width, height);
    var count = 0;
    var i, ii, rows;

    for (i = 0, ii = figures.length; i < ii; i++) {
      switch (figures[i].type) {
        case 'lattice':
          rows = figures[i].coords.length / figures[i].verticesPerRow | 0;
          count += (rows - 1) * (figures[i].verticesPerRow - 1) * 6;
          break;

        case 'triangles':
          count += figures[i].coords.length;
          break;
      }
    }

    var coords = new Float32Array(count * 2);
    var colors = new Uint8Array(count * 3);
    var coordsMap = context.coords,
        colorsMap = context.colors;
    var pIndex = 0,
        cIndex = 0;

    for (i = 0, ii = figures.length; i < ii; i++) {
      var figure = figures[i],
          ps = figure.coords,
          cs = figure.colors;

      switch (figure.type) {
        case 'lattice':
          var cols = figure.verticesPerRow;
          rows = ps.length / cols | 0;

          for (var row = 1; row < rows; row++) {
            var offset = row * cols + 1;

            for (var col = 1; col < cols; col++, offset++) {
              coords[pIndex] = coordsMap[ps[offset - cols - 1]];
              coords[pIndex + 1] = coordsMap[ps[offset - cols - 1] + 1];
              coords[pIndex + 2] = coordsMap[ps[offset - cols]];
              coords[pIndex + 3] = coordsMap[ps[offset - cols] + 1];
              coords[pIndex + 4] = coordsMap[ps[offset - 1]];
              coords[pIndex + 5] = coordsMap[ps[offset - 1] + 1];
              colors[cIndex] = colorsMap[cs[offset - cols - 1]];
              colors[cIndex + 1] = colorsMap[cs[offset - cols - 1] + 1];
              colors[cIndex + 2] = colorsMap[cs[offset - cols - 1] + 2];
              colors[cIndex + 3] = colorsMap[cs[offset - cols]];
              colors[cIndex + 4] = colorsMap[cs[offset - cols] + 1];
              colors[cIndex + 5] = colorsMap[cs[offset - cols] + 2];
              colors[cIndex + 6] = colorsMap[cs[offset - 1]];
              colors[cIndex + 7] = colorsMap[cs[offset - 1] + 1];
              colors[cIndex + 8] = colorsMap[cs[offset - 1] + 2];
              coords[pIndex + 6] = coords[pIndex + 2];
              coords[pIndex + 7] = coords[pIndex + 3];
              coords[pIndex + 8] = coords[pIndex + 4];
              coords[pIndex + 9] = coords[pIndex + 5];
              coords[pIndex + 10] = coordsMap[ps[offset]];
              coords[pIndex + 11] = coordsMap[ps[offset] + 1];
              colors[cIndex + 9] = colors[cIndex + 3];
              colors[cIndex + 10] = colors[cIndex + 4];
              colors[cIndex + 11] = colors[cIndex + 5];
              colors[cIndex + 12] = colors[cIndex + 6];
              colors[cIndex + 13] = colors[cIndex + 7];
              colors[cIndex + 14] = colors[cIndex + 8];
              colors[cIndex + 15] = colorsMap[cs[offset]];
              colors[cIndex + 16] = colorsMap[cs[offset] + 1];
              colors[cIndex + 17] = colorsMap[cs[offset] + 2];
              pIndex += 12;
              cIndex += 18;
            }
          }

          break;

        case 'triangles':
          for (var j = 0, jj = ps.length; j < jj; j++) {
            coords[pIndex] = coordsMap[ps[j]];
            coords[pIndex + 1] = coordsMap[ps[j] + 1];
            colors[cIndex] = colorsMap[cs[j]];
            colors[cIndex + 1] = colorsMap[cs[j] + 1];
            colors[cIndex + 2] = colorsMap[cs[j] + 2];
            pIndex += 2;
            cIndex += 3;
          }

          break;
      }
    }

    if (backgroundColor) {
      gl.clearColor(backgroundColor[0] / 255, backgroundColor[1] / 255, backgroundColor[2] / 255, 1.0);
    } else {
      gl.clearColor(0, 0, 0, 0);
    }

    gl.clear(gl.COLOR_BUFFER_BIT);
    var coordsBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, coordsBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, coords, gl.STATIC_DRAW);
    gl.enableVertexAttribArray(cache.positionLocation);
    gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
    var colorsBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, colorsBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, colors, gl.STATIC_DRAW);
    gl.enableVertexAttribArray(cache.colorLocation);
    gl.vertexAttribPointer(cache.colorLocation, 3, gl.UNSIGNED_BYTE, false, 0, 0);
    gl.uniform2f(cache.scaleLocation, context.scaleX, context.scaleY);
    gl.uniform2f(cache.offsetLocation, context.offsetX, context.offsetY);
    gl.drawArrays(gl.TRIANGLES, 0, count);
    gl.flush();
    gl.deleteBuffer(coordsBuffer);
    gl.deleteBuffer(colorsBuffer);
    return canvas;
  }

  return {
    tryInitGL: function tryInitGL() {
      try {
        generateGL();
        return !!currentGL;
      } catch (ex) {}

      return false;
    },
    composeSMask: composeSMask,
    drawFigures: drawFigures,
    cleanup: function cleanup() {
      if (smaskCache && smaskCache.canvas) {
        smaskCache.canvas.width = 0;
        smaskCache.canvas.height = 0;
      }

      if (figuresCache && figuresCache.canvas) {
        figuresCache.canvas.width = 0;
        figuresCache.canvas.height = 0;
      }

      smaskCache = null;
      figuresCache = null;
    }
  };
}();

/***/ }),
/* 162 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderTextLayer = void 0;

var _util = __w_pdfjs_require__(1);

var _global_scope = _interopRequireDefault(__w_pdfjs_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var renderTextLayer = function renderTextLayerClosure() {
  var MAX_TEXT_DIVS_TO_RENDER = 100000;
  var NonWhitespaceRegexp = /\S/;

  function isAllWhitespace(str) {
    return !NonWhitespaceRegexp.test(str);
  }

  var styleBuf = ['left: ', 0, 'px; top: ', 0, 'px; font-size: ', 0, 'px; font-family: ', '', ';'];

  function appendText(task, geom, styles) {
    var textDiv = document.createElement('span');
    var textDivProperties = {
      style: null,
      angle: 0,
      canvasWidth: 0,
      isWhitespace: false,
      originalTransform: null,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      scale: 1
    };

    task._textDivs.push(textDiv);

    if (isAllWhitespace(geom.str)) {
      textDivProperties.isWhitespace = true;

      task._textDivProperties.set(textDiv, textDivProperties);

      return;
    }

    var tx = _util.Util.transform(task._viewport.transform, geom.transform);

    var angle = Math.atan2(tx[1], tx[0]);
    var style = styles[geom.fontName];

    if (style.vertical) {
      angle += Math.PI / 2;
    }

    var fontHeight = Math.sqrt(tx[2] * tx[2] + tx[3] * tx[3]);
    var fontAscent = fontHeight;

    if (style.ascent) {
      fontAscent = style.ascent * fontAscent;
    } else if (style.descent) {
      fontAscent = (1 + style.descent) * fontAscent;
    }

    var left;
    var top;

    if (angle === 0) {
      left = tx[4];
      top = tx[5] - fontAscent;
    } else {
      left = tx[4] + fontAscent * Math.sin(angle);
      top = tx[5] - fontAscent * Math.cos(angle);
    }

    styleBuf[1] = left;
    styleBuf[3] = top;
    styleBuf[5] = fontHeight;
    styleBuf[7] = style.fontFamily;
    textDivProperties.style = styleBuf.join('');
    textDiv.setAttribute('style', textDivProperties.style);
    textDiv.textContent = geom.str;

    if (task._fontInspectorEnabled) {
      textDiv.dataset.fontName = geom.fontName;
    }

    if (angle !== 0) {
      textDivProperties.angle = angle * (180 / Math.PI);
    }

    if (geom.str.length > 1) {
      if (style.vertical) {
        textDivProperties.canvasWidth = geom.height * task._viewport.scale;
      } else {
        textDivProperties.canvasWidth = geom.width * task._viewport.scale;
      }
    }

    task._textDivProperties.set(textDiv, textDivProperties);

    if (task._textContentStream) {
      task._layoutText(textDiv);
    }

    if (task._enhanceTextSelection) {
      var angleCos = 1,
          angleSin = 0;

      if (angle !== 0) {
        angleCos = Math.cos(angle);
        angleSin = Math.sin(angle);
      }

      var divWidth = (style.vertical ? geom.height : geom.width) * task._viewport.scale;
      var divHeight = fontHeight;
      var m, b;

      if (angle !== 0) {
        m = [angleCos, angleSin, -angleSin, angleCos, left, top];
        b = _util.Util.getAxialAlignedBoundingBox([0, 0, divWidth, divHeight], m);
      } else {
        b = [left, top, left + divWidth, top + divHeight];
      }

      task._bounds.push({
        left: b[0],
        top: b[1],
        right: b[2],
        bottom: b[3],
        div: textDiv,
        size: [divWidth, divHeight],
        m: m
      });
    }
  }

  function render(task) {
    if (task._canceled) {
      return;
    }

    var textDivs = task._textDivs;
    var capability = task._capability;
    var textDivsLength = textDivs.length;

    if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
      task._renderingDone = true;
      capability.resolve();
      return;
    }

    if (!task._textContentStream) {
      for (var i = 0; i < textDivsLength; i++) {
        task._layoutText(textDivs[i]);
      }
    }

    task._renderingDone = true;
    capability.resolve();
  }

  function expand(task) {
    var bounds = task._bounds;
    var viewport = task._viewport;
    var expanded = expandBounds(viewport.width, viewport.height, bounds);

    for (var i = 0; i < expanded.length; i++) {
      var div = bounds[i].div;

      var divProperties = task._textDivProperties.get(div);

      if (divProperties.angle === 0) {
        divProperties.paddingLeft = bounds[i].left - expanded[i].left;
        divProperties.paddingTop = bounds[i].top - expanded[i].top;
        divProperties.paddingRight = expanded[i].right - bounds[i].right;
        divProperties.paddingBottom = expanded[i].bottom - bounds[i].bottom;

        task._textDivProperties.set(div, divProperties);

        continue;
      }

      var e = expanded[i],
          b = bounds[i];
      var m = b.m,
          c = m[0],
          s = m[1];
      var points = [[0, 0], [0, b.size[1]], [b.size[0], 0], b.size];
      var ts = new Float64Array(64);
      points.forEach(function (p, i) {
        var t = _util.Util.applyTransform(p, m);

        ts[i + 0] = c && (e.left - t[0]) / c;
        ts[i + 4] = s && (e.top - t[1]) / s;
        ts[i + 8] = c && (e.right - t[0]) / c;
        ts[i + 12] = s && (e.bottom - t[1]) / s;
        ts[i + 16] = s && (e.left - t[0]) / -s;
        ts[i + 20] = c && (e.top - t[1]) / c;
        ts[i + 24] = s && (e.right - t[0]) / -s;
        ts[i + 28] = c && (e.bottom - t[1]) / c;
        ts[i + 32] = c && (e.left - t[0]) / -c;
        ts[i + 36] = s && (e.top - t[1]) / -s;
        ts[i + 40] = c && (e.right - t[0]) / -c;
        ts[i + 44] = s && (e.bottom - t[1]) / -s;
        ts[i + 48] = s && (e.left - t[0]) / s;
        ts[i + 52] = c && (e.top - t[1]) / -c;
        ts[i + 56] = s && (e.right - t[0]) / s;
        ts[i + 60] = c && (e.bottom - t[1]) / -c;
      });

      var findPositiveMin = function findPositiveMin(ts, offset, count) {
        var result = 0;

        for (var i = 0; i < count; i++) {
          var t = ts[offset++];

          if (t > 0) {
            result = result ? Math.min(t, result) : t;
          }
        }

        return result;
      };

      var boxScale = 1 + Math.min(Math.abs(c), Math.abs(s));
      divProperties.paddingLeft = findPositiveMin(ts, 32, 16) / boxScale;
      divProperties.paddingTop = findPositiveMin(ts, 48, 16) / boxScale;
      divProperties.paddingRight = findPositiveMin(ts, 0, 16) / boxScale;
      divProperties.paddingBottom = findPositiveMin(ts, 16, 16) / boxScale;

      task._textDivProperties.set(div, divProperties);
    }
  }

  function expandBounds(width, height, boxes) {
    var bounds = boxes.map(function (box, i) {
      return {
        x1: box.left,
        y1: box.top,
        x2: box.right,
        y2: box.bottom,
        index: i,
        x1New: undefined,
        x2New: undefined
      };
    });
    expandBoundsLTR(width, bounds);
    var expanded = new Array(boxes.length);
    bounds.forEach(function (b) {
      var i = b.index;
      expanded[i] = {
        left: b.x1New,
        top: 0,
        right: b.x2New,
        bottom: 0
      };
    });
    boxes.map(function (box, i) {
      var e = expanded[i],
          b = bounds[i];
      b.x1 = box.top;
      b.y1 = width - e.right;
      b.x2 = box.bottom;
      b.y2 = width - e.left;
      b.index = i;
      b.x1New = undefined;
      b.x2New = undefined;
    });
    expandBoundsLTR(height, bounds);
    bounds.forEach(function (b) {
      var i = b.index;
      expanded[i].top = b.x1New;
      expanded[i].bottom = b.x2New;
    });
    return expanded;
  }

  function expandBoundsLTR(width, bounds) {
    bounds.sort(function (a, b) {
      return a.x1 - b.x1 || a.index - b.index;
    });
    var fakeBoundary = {
      x1: -Infinity,
      y1: -Infinity,
      x2: 0,
      y2: Infinity,
      index: -1,
      x1New: 0,
      x2New: 0
    };
    var horizon = [{
      start: -Infinity,
      end: Infinity,
      boundary: fakeBoundary
    }];
    bounds.forEach(function (boundary) {
      var i = 0;

      while (i < horizon.length && horizon[i].end <= boundary.y1) {
        i++;
      }

      var j = horizon.length - 1;

      while (j >= 0 && horizon[j].start >= boundary.y2) {
        j--;
      }

      var horizonPart, affectedBoundary;
      var q,
          k,
          maxXNew = -Infinity;

      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;
        var xNew;

        if (affectedBoundary.x2 > boundary.x1) {
          xNew = affectedBoundary.index > boundary.index ? affectedBoundary.x1New : boundary.x1;
        } else if (affectedBoundary.x2New === undefined) {
          xNew = (affectedBoundary.x2 + boundary.x1) / 2;
        } else {
          xNew = affectedBoundary.x2New;
        }

        if (xNew > maxXNew) {
          maxXNew = xNew;
        }
      }

      boundary.x1New = maxXNew;

      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;

        if (affectedBoundary.x2New === undefined) {
          if (affectedBoundary.x2 > boundary.x1) {
            if (affectedBoundary.index > boundary.index) {
              affectedBoundary.x2New = affectedBoundary.x2;
            }
          } else {
            affectedBoundary.x2New = maxXNew;
          }
        } else if (affectedBoundary.x2New > maxXNew) {
          affectedBoundary.x2New = Math.max(maxXNew, affectedBoundary.x2);
        }
      }

      var changedHorizon = [],
          lastBoundary = null;

      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;
        var useBoundary = affectedBoundary.x2 > boundary.x2 ? affectedBoundary : boundary;

        if (lastBoundary === useBoundary) {
          changedHorizon[changedHorizon.length - 1].end = horizonPart.end;
        } else {
          changedHorizon.push({
            start: horizonPart.start,
            end: horizonPart.end,
            boundary: useBoundary
          });
          lastBoundary = useBoundary;
        }
      }

      if (horizon[i].start < boundary.y1) {
        changedHorizon[0].start = boundary.y1;
        changedHorizon.unshift({
          start: horizon[i].start,
          end: boundary.y1,
          boundary: horizon[i].boundary
        });
      }

      if (boundary.y2 < horizon[j].end) {
        changedHorizon[changedHorizon.length - 1].end = boundary.y2;
        changedHorizon.push({
          start: boundary.y2,
          end: horizon[j].end,
          boundary: horizon[j].boundary
        });
      }

      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;

        if (affectedBoundary.x2New !== undefined) {
          continue;
        }

        var used = false;

        for (k = i - 1; !used && k >= 0 && horizon[k].start >= affectedBoundary.y1; k--) {
          used = horizon[k].boundary === affectedBoundary;
        }

        for (k = j + 1; !used && k < horizon.length && horizon[k].end <= affectedBoundary.y2; k++) {
          used = horizon[k].boundary === affectedBoundary;
        }

        for (k = 0; !used && k < changedHorizon.length; k++) {
          used = changedHorizon[k].boundary === affectedBoundary;
        }

        if (!used) {
          affectedBoundary.x2New = maxXNew;
        }
      }

      Array.prototype.splice.apply(horizon, [i, j - i + 1].concat(changedHorizon));
    });
    horizon.forEach(function (horizonPart) {
      var affectedBoundary = horizonPart.boundary;

      if (affectedBoundary.x2New === undefined) {
        affectedBoundary.x2New = Math.max(width, affectedBoundary.x2);
      }
    });
  }

  function TextLayerRenderTask(_ref) {
    var _this = this;

    var textContent = _ref.textContent,
        textContentStream = _ref.textContentStream,
        container = _ref.container,
        viewport = _ref.viewport,
        textDivs = _ref.textDivs,
        textContentItemsStr = _ref.textContentItemsStr,
        enhanceTextSelection = _ref.enhanceTextSelection;
    this._textContent = textContent;
    this._textContentStream = textContentStream;
    this._container = container;
    this._viewport = viewport;
    this._textDivs = textDivs || [];
    this._textContentItemsStr = textContentItemsStr || [];
    this._enhanceTextSelection = !!enhanceTextSelection;
    this._fontInspectorEnabled = !!(_global_scope["default"].FontInspector && _global_scope["default"].FontInspector.enabled);
    this._reader = null;
    this._layoutTextLastFontSize = null;
    this._layoutTextLastFontFamily = null;
    this._layoutTextCtx = null;
    this._textDivProperties = new WeakMap();
    this._renderingDone = false;
    this._canceled = false;
    this._capability = (0, _util.createPromiseCapability)();
    this._renderTimer = null;
    this._bounds = [];

    this._capability.promise["finally"](function () {
      if (_this._layoutTextCtx) {
        _this._layoutTextCtx.canvas.width = 0;
        _this._layoutTextCtx.canvas.height = 0;
        _this._layoutTextCtx = null;
      }
    });
  }

  TextLayerRenderTask.prototype = {
    get promise() {
      return this._capability.promise;
    },

    cancel: function TextLayer_cancel() {
      this._canceled = true;

      if (this._reader) {
        this._reader.cancel(new _util.AbortException('TextLayer task cancelled.'));

        this._reader = null;
      }

      if (this._renderTimer !== null) {
        clearTimeout(this._renderTimer);
        this._renderTimer = null;
      }

      this._capability.reject(new Error('TextLayer task cancelled.'));
    },
    _processItems: function _processItems(items, styleCache) {
      for (var i = 0, len = items.length; i < len; i++) {
        this._textContentItemsStr.push(items[i].str);

        appendText(this, items[i], styleCache);
      }
    },
    _layoutText: function _layoutText(textDiv) {
      var textLayerFrag = this._container;

      var textDivProperties = this._textDivProperties.get(textDiv);

      if (textDivProperties.isWhitespace) {
        return;
      }

      var fontSize = textDiv.style.fontSize;
      var fontFamily = textDiv.style.fontFamily;

      if (fontSize !== this._layoutTextLastFontSize || fontFamily !== this._layoutTextLastFontFamily) {
        this._layoutTextCtx.font = fontSize + ' ' + fontFamily;
        this._layoutTextLastFontSize = fontSize;
        this._layoutTextLastFontFamily = fontFamily;
      }

      var width = this._layoutTextCtx.measureText(textDiv.textContent).width;

      var transform = '';

      if (textDivProperties.canvasWidth !== 0 && width > 0) {
        textDivProperties.scale = textDivProperties.canvasWidth / width;
        transform = "scaleX(".concat(textDivProperties.scale, ")");
      }

      if (textDivProperties.angle !== 0) {
        transform = "rotate(".concat(textDivProperties.angle, "deg) ").concat(transform);
      }

      if (transform.length > 0) {
        textDivProperties.originalTransform = transform;
        textDiv.style.transform = transform;
      }

      this._textDivProperties.set(textDiv, textDivProperties);

      textLayerFrag.appendChild(textDiv);
    },
    _render: function TextLayer_render(timeout) {
      var _this2 = this;

      var capability = (0, _util.createPromiseCapability)();
      var styleCache = Object.create(null);
      var canvas = document.createElement('canvas');
      canvas.mozOpaque = true;
      this._layoutTextCtx = canvas.getContext('2d', {
        alpha: false
      });

      if (this._textContent) {
        var textItems = this._textContent.items;
        var textStyles = this._textContent.styles;

        this._processItems(textItems, textStyles);

        capability.resolve();
      } else if (this._textContentStream) {
        var pump = function pump() {
          _this2._reader.read().then(function (_ref2) {
            var value = _ref2.value,
                done = _ref2.done;

            if (done) {
              capability.resolve();
              return;
            }

            Object.assign(styleCache, value.styles);

            _this2._processItems(value.items, styleCache);

            pump();
          }, capability.reject);
        };

        this._reader = this._textContentStream.getReader();
        pump();
      } else {
        throw new Error('Neither "textContent" nor "textContentStream"' + ' parameters specified.');
      }

      capability.promise.then(function () {
        styleCache = null;

        if (!timeout) {
          render(_this2);
        } else {
          _this2._renderTimer = setTimeout(function () {
            render(_this2);
            _this2._renderTimer = null;
          }, timeout);
        }
      }, this._capability.reject);
    },
    expandTextDivs: function TextLayer_expandTextDivs(expandDivs) {
      if (!this._enhanceTextSelection || !this._renderingDone) {
        return;
      }

      if (this._bounds !== null) {
        expand(this);
        this._bounds = null;
      }

      for (var i = 0, ii = this._textDivs.length; i < ii; i++) {
        var div = this._textDivs[i];

        var divProperties = this._textDivProperties.get(div);

        if (divProperties.isWhitespace) {
          continue;
        }

        if (expandDivs) {
          var transform = '',
              padding = '';

          if (divProperties.scale !== 1) {
            transform = 'scaleX(' + divProperties.scale + ')';
          }

          if (divProperties.angle !== 0) {
            transform = 'rotate(' + divProperties.angle + 'deg) ' + transform;
          }

          if (divProperties.paddingLeft !== 0) {
            padding += ' padding-left: ' + divProperties.paddingLeft / divProperties.scale + 'px;';
            transform += ' translateX(' + -divProperties.paddingLeft / divProperties.scale + 'px)';
          }

          if (divProperties.paddingTop !== 0) {
            padding += ' padding-top: ' + divProperties.paddingTop + 'px;';
            transform += ' translateY(' + -divProperties.paddingTop + 'px)';
          }

          if (divProperties.paddingRight !== 0) {
            padding += ' padding-right: ' + divProperties.paddingRight / divProperties.scale + 'px;';
          }

          if (divProperties.paddingBottom !== 0) {
            padding += ' padding-bottom: ' + divProperties.paddingBottom + 'px;';
          }

          if (padding !== '') {
            div.setAttribute('style', divProperties.style + padding);
          }

          if (transform !== '') {
            div.style.transform = transform;
          }
        } else {
          div.style.padding = 0;
          div.style.transform = divProperties.originalTransform || '';
        }
      }
    }
  };

  function renderTextLayer(renderParameters) {
    var task = new TextLayerRenderTask({
      textContent: renderParameters.textContent,
      textContentStream: renderParameters.textContentStream,
      container: renderParameters.container,
      viewport: renderParameters.viewport,
      textDivs: renderParameters.textDivs,
      textContentItemsStr: renderParameters.textContentItemsStr,
      enhanceTextSelection: renderParameters.enhanceTextSelection
    });

    task._render(renderParameters.timeout);

    return task;
  }

  return renderTextLayer;
}();

exports.renderTextLayer = renderTextLayer;

/***/ }),
/* 163 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnotationLayer = void 0;

var _display_utils = __w_pdfjs_require__(151);

var _util = __w_pdfjs_require__(1);

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AnnotationElementFactory =
/*#__PURE__*/
function () {
  function AnnotationElementFactory() {
    _classCallCheck(this, AnnotationElementFactory);
  }

  _createClass(AnnotationElementFactory, null, [{
    key: "create",
    value: function create(parameters) {
      var subtype = parameters.data.annotationType;

      switch (subtype) {
        case _util.AnnotationType.LINK:
          return new LinkAnnotationElement(parameters);

        case _util.AnnotationType.TEXT:
          return new TextAnnotationElement(parameters);

        case _util.AnnotationType.WIDGET:
          var fieldType = parameters.data.fieldType;

          switch (fieldType) {
            case 'Tx':
              return new TextWidgetAnnotationElement(parameters);

            case 'Btn':
              if (parameters.data.radioButton) {
                return new RadioButtonWidgetAnnotationElement(parameters);
              } else if (parameters.data.checkBox) {
                return new CheckboxWidgetAnnotationElement(parameters);
              }

              return new PushButtonWidgetAnnotationElement(parameters);

            case 'Ch':
              return new ChoiceWidgetAnnotationElement(parameters);
          }

          return new WidgetAnnotationElement(parameters);

        case _util.AnnotationType.POPUP:
          return new PopupAnnotationElement(parameters);

        case _util.AnnotationType.FREETEXT:
          return new FreeTextAnnotationElement(parameters);

        case _util.AnnotationType.LINE:
          return new LineAnnotationElement(parameters);

        case _util.AnnotationType.SQUARE:
          return new SquareAnnotationElement(parameters);

        case _util.AnnotationType.CIRCLE:
          return new CircleAnnotationElement(parameters);

        case _util.AnnotationType.POLYLINE:
          return new PolylineAnnotationElement(parameters);

        case _util.AnnotationType.CARET:
          return new CaretAnnotationElement(parameters);

        case _util.AnnotationType.INK:
          return new InkAnnotationElement(parameters);

        case _util.AnnotationType.POLYGON:
          return new PolygonAnnotationElement(parameters);

        case _util.AnnotationType.HIGHLIGHT:
          return new HighlightAnnotationElement(parameters);

        case _util.AnnotationType.UNDERLINE:
          return new UnderlineAnnotationElement(parameters);

        case _util.AnnotationType.SQUIGGLY:
          return new SquigglyAnnotationElement(parameters);

        case _util.AnnotationType.STRIKEOUT:
          return new StrikeOutAnnotationElement(parameters);

        case _util.AnnotationType.STAMP:
          return new StampAnnotationElement(parameters);

        case _util.AnnotationType.FILEATTACHMENT:
          return new FileAttachmentAnnotationElement(parameters);

        default:
          return new AnnotationElement(parameters);
      }
    }
  }]);

  return AnnotationElementFactory;
}();

var AnnotationElement =
/*#__PURE__*/
function () {
  function AnnotationElement(parameters) {
    var isRenderable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var ignoreBorder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck(this, AnnotationElement);

    this.isRenderable = isRenderable;
    this.data = parameters.data;
    this.layer = parameters.layer;
    this.page = parameters.page;
    this.viewport = parameters.viewport;
    this.linkService = parameters.linkService;
    this.downloadManager = parameters.downloadManager;
    this.imageResourcesPath = parameters.imageResourcesPath;
    this.renderInteractiveForms = parameters.renderInteractiveForms;
    this.svgFactory = parameters.svgFactory;

    if (isRenderable) {
      this.container = this._createContainer(ignoreBorder);
    }
  }

  _createClass(AnnotationElement, [{
    key: "_createContainer",
    value: function _createContainer() {
      var ignoreBorder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var data = this.data,
          page = this.page,
          viewport = this.viewport;
      var container = document.createElement('section');
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      container.setAttribute('data-annotation-id', data.id);

      var rect = _util.Util.normalizeRect([data.rect[0], page.view[3] - data.rect[1] + page.view[1], data.rect[2], page.view[3] - data.rect[3] + page.view[1]]);

      container.style.transform = 'matrix(' + viewport.transform.join(',') + ')';
      container.style.transformOrigin = -rect[0] + 'px ' + -rect[1] + 'px';

      if (!ignoreBorder && data.borderStyle.width > 0) {
        container.style.borderWidth = data.borderStyle.width + 'px';

        if (data.borderStyle.style !== _util.AnnotationBorderStyleType.UNDERLINE) {
          width = width - 2 * data.borderStyle.width;
          height = height - 2 * data.borderStyle.width;
        }

        var horizontalRadius = data.borderStyle.horizontalCornerRadius;
        var verticalRadius = data.borderStyle.verticalCornerRadius;

        if (horizontalRadius > 0 || verticalRadius > 0) {
          var radius = horizontalRadius + 'px / ' + verticalRadius + 'px';
          container.style.borderRadius = radius;
        }

        switch (data.borderStyle.style) {
          case _util.AnnotationBorderStyleType.SOLID:
            container.style.borderStyle = 'solid';
            break;

          case _util.AnnotationBorderStyleType.DASHED:
            container.style.borderStyle = 'dashed';
            break;

          case _util.AnnotationBorderStyleType.BEVELED:
            (0, _util.warn)('Unimplemented border style: beveled');
            break;

          case _util.AnnotationBorderStyleType.INSET:
            (0, _util.warn)('Unimplemented border style: inset');
            break;

          case _util.AnnotationBorderStyleType.UNDERLINE:
            container.style.borderBottomStyle = 'solid';
            break;

          default:
            break;
        }

        if (data.color) {
          container.style.borderColor = _util.Util.makeCssRgb(data.color[0] | 0, data.color[1] | 0, data.color[2] | 0);
        } else {
          container.style.borderWidth = 0;
        }
      }

      container.style.left = rect[0] + 'px';
      container.style.top = rect[1] + 'px';
      container.style.width = width + 'px';
      container.style.height = height + 'px';
      return container;
    }
  }, {
    key: "_createPopup",
    value: function _createPopup(container, trigger, data) {
      if (!trigger) {
        trigger = document.createElement('div');
        trigger.style.height = container.style.height;
        trigger.style.width = container.style.width;
        container.appendChild(trigger);
      }

      var popupElement = new PopupElement({
        container: container,
        trigger: trigger,
        color: data.color,
        title: data.title,
        modificationDate: data.modificationDate,
        contents: data.contents,
        hideWrapper: true
      });
      var popup = popupElement.render();
      popup.style.left = container.style.width;
      container.appendChild(popup);
    }
  }, {
    key: "render",
    value: function render() {
      (0, _util.unreachable)('Abstract method `AnnotationElement.render` called');
    }
  }]);

  return AnnotationElement;
}();

var LinkAnnotationElement =
/*#__PURE__*/
function (_AnnotationElement) {
  _inherits(LinkAnnotationElement, _AnnotationElement);

  function LinkAnnotationElement(parameters) {
    _classCallCheck(this, LinkAnnotationElement);

    var isRenderable = !!(parameters.data.url || parameters.data.dest || parameters.data.action);
    return _possibleConstructorReturn(this, _getPrototypeOf(LinkAnnotationElement).call(this, parameters, isRenderable));
  }

  _createClass(LinkAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = 'linkAnnotation';
      var data = this.data,
          linkService = this.linkService;
      var link = document.createElement('a');
      (0, _display_utils.addLinkAttributes)(link, {
        url: data.url,
        target: data.newWindow ? _display_utils.LinkTarget.BLANK : linkService.externalLinkTarget,
        rel: linkService.externalLinkRel
      });

      if (!data.url) {
        if (data.action) {
          this._bindNamedAction(link, data.action);
        } else {
          this._bindLink(link, data.dest);
        }
      }

      this.container.appendChild(link);
      return this.container;
    }
  }, {
    key: "_bindLink",
    value: function _bindLink(link, destination) {
      var _this = this;

      link.href = this.linkService.getDestinationHash(destination);

      link.onclick = function () {
        if (destination) {
          _this.linkService.navigateTo(destination);
        }

        return false;
      };

      if (destination) {
        link.className = 'internalLink';
      }
    }
  }, {
    key: "_bindNamedAction",
    value: function _bindNamedAction(link, action) {
      var _this2 = this;

      link.href = this.linkService.getAnchorUrl('');

      link.onclick = function () {
        _this2.linkService.executeNamedAction(action);

        return false;
      };

      link.className = 'internalLink';
    }
  }]);

  return LinkAnnotationElement;
}(AnnotationElement);

var TextAnnotationElement =
/*#__PURE__*/
function (_AnnotationElement2) {
  _inherits(TextAnnotationElement, _AnnotationElement2);

  function TextAnnotationElement(parameters) {
    _classCallCheck(this, TextAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, _getPrototypeOf(TextAnnotationElement).call(this, parameters, isRenderable));
  }

  _createClass(TextAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = 'textAnnotation';
      var image = document.createElement('img');
      image.style.height = this.container.style.height;
      image.style.width = this.container.style.width;
      image.src = this.imageResourcesPath + 'annotation-' + this.data.name.toLowerCase() + '.svg';
      image.alt = '[{{type}} Annotation]';
      image.dataset.l10nId = 'text_annotation_type';
      image.dataset.l10nArgs = JSON.stringify({
        type: this.data.name
      });

      if (!this.data.hasPopup) {
        this._createPopup(this.container, image, this.data);
      }

      this.container.appendChild(image);
      return this.container;
    }
  }]);

  return TextAnnotationElement;
}(AnnotationElement);

var WidgetAnnotationElement =
/*#__PURE__*/
function (_AnnotationElement3) {
  _inherits(WidgetAnnotationElement, _AnnotationElement3);

  function WidgetAnnotationElement() {
    _classCallCheck(this, WidgetAnnotationElement);

    return _possibleConstructorReturn(this, _getPrototypeOf(WidgetAnnotationElement).apply(this, arguments));
  }

  _createClass(WidgetAnnotationElement, [{
    key: "render",
    value: function render() {
      return this.container;
    }
  }]);

  return WidgetAnnotationElement;
}(AnnotationElement);

var TextWidgetAnnotationElement =
/*#__PURE__*/
function (_WidgetAnnotationElem) {
  _inherits(TextWidgetAnnotationElement, _WidgetAnnotationElem);

  function TextWidgetAnnotationElement(parameters) {
    _classCallCheck(this, TextWidgetAnnotationElement);

    var isRenderable = parameters.renderInteractiveForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
    return _possibleConstructorReturn(this, _getPrototypeOf(TextWidgetAnnotationElement).call(this, parameters, isRenderable));
  }

  _createClass(TextWidgetAnnotationElement, [{
    key: "render",
    value: function render() {
      var TEXT_ALIGNMENT = ['left', 'center', 'right'];
      this.container.className = 'textWidgetAnnotation';
      var element = null;

      if (this.renderInteractiveForms) {
        if (this.data.multiLine) {
          element = document.createElement('textarea');
          element.textContent = this.data.fieldValue;
        } else {
          element = document.createElement('input');
          element.type = 'text';
          element.setAttribute('value', this.data.fieldValue);
        }

        element.disabled = this.data.readOnly;

        if (this.data.maxLen !== null) {
          element.maxLength = this.data.maxLen;
        }

        if (this.data.comb) {
          var fieldWidth = this.data.rect[2] - this.data.rect[0];
          var combWidth = fieldWidth / this.data.maxLen;
          element.classList.add('comb');
          element.style.letterSpacing = 'calc(' + combWidth + 'px - 1ch)';
        }
      } else {
        element = document.createElement('div');
        element.textContent = this.data.fieldValue;
        element.style.verticalAlign = 'middle';
        element.style.display = 'table-cell';
        var font = null;

        if (this.data.fontRefName && this.page.commonObjs.has(this.data.fontRefName)) {
          font = this.page.commonObjs.get(this.data.fontRefName);
        }

        this._setTextStyle(element, font);
      }

      if (this.data.textAlignment !== null) {
        element.style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
      }

      this.container.appendChild(element);
      return this.container;
    }
  }, {
    key: "_setTextStyle",
    value: function _setTextStyle(element, font) {
      var style = element.style;
      style.fontSize = this.data.fontSize + 'px';
      style.direction = this.data.fontDirection < 0 ? 'rtl' : 'ltr';

      if (!font) {
        return;
      }

      style.fontWeight = font.black ? font.bold ? '900' : 'bold' : font.bold ? 'bold' : 'normal';
      style.fontStyle = font.italic ? 'italic' : 'normal';
      var fontFamily = font.loadedName ? '"' + font.loadedName + '", ' : '';
      var fallbackName = font.fallbackName || 'Helvetica, sans-serif';
      style.fontFamily = fontFamily + fallbackName;
    }
  }]);

  return TextWidgetAnnotationElement;
}(WidgetAnnotationElement);

var CheckboxWidgetAnnotationElement =
/*#__PURE__*/
function (_WidgetAnnotationElem2) {
  _inherits(CheckboxWidgetAnnotationElement, _WidgetAnnotationElem2);

  function CheckboxWidgetAnnotationElement(parameters) {
    _classCallCheck(this, CheckboxWidgetAnnotationElement);

    return _possibleConstructorReturn(this, _getPrototypeOf(CheckboxWidgetAnnotationElement).call(this, parameters, parameters.renderInteractiveForms));
  }

  _createClass(CheckboxWidgetAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = 'buttonWidgetAnnotation checkBox';
      var element = document.createElement('input');
      element.disabled = this.data.readOnly;
      element.type = 'checkbox';

      if (this.data.fieldValue && this.data.fieldValue !== 'Off') {
        element.setAttribute('checked', true);
      }

      this.container.appendChild(element);
      return this.container;
    }
  }]);

  return CheckboxWidgetAnnotationElement;
}(WidgetAnnotationElement);

var RadioButtonWidgetAnnotationElement =
/*#__PURE__*/
function (_WidgetAnnotationElem3) {
  _inherits(RadioButtonWidgetAnnotationElement, _WidgetAnnotationElem3);

  function RadioButtonWidgetAnnotationElement(parameters) {
    _classCallCheck(this, RadioButtonWidgetAnnotationElement);

    return _possibleConstructorReturn(this, _getPrototypeOf(RadioButtonWidgetAnnotationElement).call(this, parameters, parameters.renderInteractiveForms));
  }

  _createClass(RadioButtonWidgetAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = 'buttonWidgetAnnotation radioButton';
      var element = document.createElement('input');
      element.disabled = this.data.readOnly;
      element.type = 'radio';
      element.name = this.data.fieldName;

      if (this.data.fieldValue === this.data.buttonValue) {
        element.setAttribute('checked', true);
      }

      this.container.appendChild(element);
      return this.container;
    }
  }]);

  return RadioButtonWidgetAnnotationElement;
}(WidgetAnnotationElement);

var PushButtonWidgetAnnotationElement =
/*#__PURE__*/
function (_LinkAnnotationElemen) {
  _inherits(PushButtonWidgetAnnotationElement, _LinkAnnotationElemen);

  function PushButtonWidgetAnnotationElement() {
    _classCallCheck(this, PushButtonWidgetAnnotationElement);

    return _possibleConstructorReturn(this, _getPrototypeOf(PushButtonWidgetAnnotationElement).apply(this, arguments));
  }

  _createClass(PushButtonWidgetAnnotationElement, [{
    key: "render",
    value: function render() {
      var container = _get(_getPrototypeOf(PushButtonWidgetAnnotationElement.prototype), "render", this).call(this);

      container.className = 'buttonWidgetAnnotation pushButton';
      return container;
    }
  }]);

  return PushButtonWidgetAnnotationElement;
}(LinkAnnotationElement);

var ChoiceWidgetAnnotationElement =
/*#__PURE__*/
function (_WidgetAnnotationElem4) {
  _inherits(ChoiceWidgetAnnotationElement, _WidgetAnnotationElem4);

  function ChoiceWidgetAnnotationElement(parameters) {
    _classCallCheck(this, ChoiceWidgetAnnotationElement);

    return _possibleConstructorReturn(this, _getPrototypeOf(ChoiceWidgetAnnotationElement).call(this, parameters, parameters.renderInteractiveForms));
  }

  _createClass(ChoiceWidgetAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = 'choiceWidgetAnnotation';
      var selectElement = document.createElement('select');
      selectElement.disabled = this.data.readOnly;

      if (!this.data.combo) {
        selectElement.size = this.data.options.length;

        if (this.data.multiSelect) {
          selectElement.multiple = true;
        }
      }

      for (var i = 0, ii = this.data.options.length; i < ii; i++) {
        var option = this.data.options[i];
        var optionElement = document.createElement('option');
        optionElement.textContent = option.displayValue;
        optionElement.value = option.exportValue;

        if (this.data.fieldValue.includes(option.displayValue)) {
          optionElement.setAttribute('selected', true);
        }

        selectElement.appendChild(optionElement);
      }

      this.container.appendChild(selectElement);
      return this.container;
    }
  }]);

  return ChoiceWidgetAnnotationElement;
}(WidgetAnnotationElement);

var PopupAnnotationElement =
/*#__PURE__*/
function (_AnnotationElement4) {
  _inherits(PopupAnnotationElement, _AnnotationElement4);

  function PopupAnnotationElement(parameters) {
    _classCallCheck(this, PopupAnnotationElement);

    var isRenderable = !!(parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, _getPrototypeOf(PopupAnnotationElement).call(this, parameters, isRenderable));
  }

  _createClass(PopupAnnotationElement, [{
    key: "render",
    value: function render() {
      var IGNORE_TYPES = ['Line', 'Square', 'Circle', 'PolyLine', 'Polygon', 'Ink'];
      this.container.className = 'popupAnnotation';

      if (IGNORE_TYPES.includes(this.data.parentType)) {
        return this.container;
      }

      var selector = '[data-annotation-id="' + this.data.parentId + '"]';
      var parentElement = this.layer.querySelector(selector);

      if (!parentElement) {
        return this.container;
      }

      var popup = new PopupElement({
        container: this.container,
        trigger: parentElement,
        color: this.data.color,
        title: this.data.title,
        modificationDate: this.data.modificationDate,
        contents: this.data.contents
      });
      var parentLeft = parseFloat(parentElement.style.left);
      var parentWidth = parseFloat(parentElement.style.width);
      this.container.style.transformOrigin = -(parentLeft + parentWidth) + 'px -' + parentElement.style.top;
      this.container.style.left = parentLeft + parentWidth + 'px';
      this.container.appendChild(popup.render());
      return this.container;
    }
  }]);

  return PopupAnnotationElement;
}(AnnotationElement);

var PopupElement =
/*#__PURE__*/
function () {
  function PopupElement(parameters) {
    _classCallCheck(this, PopupElement);

    this.container = parameters.container;
    this.trigger = parameters.trigger;
    this.color = parameters.color;
    this.title = parameters.title;
    this.modificationDate = parameters.modificationDate;
    this.contents = parameters.contents;
    this.hideWrapper = parameters.hideWrapper || false;
    this.pinned = false;
  }

  _createClass(PopupElement, [{
    key: "render",
    value: function render() {
      var BACKGROUND_ENLIGHT = 0.7;
      var wrapper = document.createElement('div');
      wrapper.className = 'popupWrapper';
      this.hideElement = this.hideWrapper ? wrapper : this.container;
      this.hideElement.setAttribute('hidden', true);
      var popup = document.createElement('div');
      popup.className = 'popup';
      var color = this.color;

      if (color) {
        var r = BACKGROUND_ENLIGHT * (255 - color[0]) + color[0];
        var g = BACKGROUND_ENLIGHT * (255 - color[1]) + color[1];
        var b = BACKGROUND_ENLIGHT * (255 - color[2]) + color[2];
        popup.style.backgroundColor = _util.Util.makeCssRgb(r | 0, g | 0, b | 0);
      }

      var title = document.createElement('h1');
      title.textContent = this.title;
      popup.appendChild(title);

      var dateObject = _display_utils.PDFDateString.toDateObject(this.modificationDate);

      if (dateObject) {
        var modificationDate = document.createElement('span');
        modificationDate.textContent = '{{date}}, {{time}}';
        modificationDate.dataset.l10nId = 'annotation_date_string';
        modificationDate.dataset.l10nArgs = JSON.stringify({
          date: dateObject.toLocaleDateString(),
          time: dateObject.toLocaleTimeString()
        });
        popup.appendChild(modificationDate);
      }

      var contents = this._formatContents(this.contents);

      popup.appendChild(contents);
      this.trigger.addEventListener('click', this._toggle.bind(this));
      this.trigger.addEventListener('mouseover', this._show.bind(this, false));
      this.trigger.addEventListener('mouseout', this._hide.bind(this, false));
      popup.addEventListener('click', this._hide.bind(this, true));
      wrapper.appendChild(popup);
      return wrapper;
    }
  }, {
    key: "_formatContents",
    value: function _formatContents(contents) {
      var p = document.createElement('p');
      var lines = contents.split(/(?:\r\n?|\n)/);

      for (var i = 0, ii = lines.length; i < ii; ++i) {
        var line = lines[i];
        p.appendChild(document.createTextNode(line));

        if (i < ii - 1) {
          p.appendChild(document.createElement('br'));
        }
      }

      return p;
    }
  }, {
    key: "_toggle",
    value: function _toggle() {
      if (this.pinned) {
        this._hide(true);
      } else {
        this._show(true);
      }
    }
  }, {
    key: "_show",
    value: function _show() {
      var pin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (pin) {
        this.pinned = true;
      }

      if (this.hideElement.hasAttribute('hidden')) {
        this.hideElement.removeAttribute('hidden');
        this.container.style.zIndex += 1;
      }
    }
  }, {
    key: "_hide",
    value: function _hide() {
      var unpin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (unpin) {
        this.pinned = false;
      }

      if (!this.hideElement.hasAttribute('hidden') && !this.pinned) {
        this.hideElement.setAttribute('hidden', true);
        this.container.style.zIndex -= 1;
      }
    }
  }]);

  return PopupElement;
}();

var FreeTextAnnotationElement =
/*#__PURE__*/
function (_AnnotationElement5) {
  _inherits(FreeTextAnnotationElement, _AnnotationElement5);

  function FreeTextAnnotationElement(parameters) {
    _classCallCheck(this, FreeTextAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, _getPrototypeOf(FreeTextAnnotationElement).call(this, parameters, isRenderable, true));
  }

  _createClass(FreeTextAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = 'freeTextAnnotation';

      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }

      return this.container;
    }
  }]);

  return FreeTextAnnotationElement;
}(AnnotationElement);

var LineAnnotationElement =
/*#__PURE__*/
function (_AnnotationElement6) {
  _inherits(LineAnnotationElement, _AnnotationElement6);

  function LineAnnotationElement(parameters) {
    _classCallCheck(this, LineAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, _getPrototypeOf(LineAnnotationElement).call(this, parameters, isRenderable, true));
  }

  _createClass(LineAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = 'lineAnnotation';
      var data = this.data;
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      var svg = this.svgFactory.create(width, height);
      var line = this.svgFactory.createElement('svg:line');
      line.setAttribute('x1', data.rect[2] - data.lineCoordinates[0]);
      line.setAttribute('y1', data.rect[3] - data.lineCoordinates[1]);
      line.setAttribute('x2', data.rect[2] - data.lineCoordinates[2]);
      line.setAttribute('y2', data.rect[3] - data.lineCoordinates[3]);
      line.setAttribute('stroke-width', data.borderStyle.width);
      line.setAttribute('stroke', 'transparent');
      svg.appendChild(line);
      this.container.append(svg);

      this._createPopup(this.container, line, data);

      return this.container;
    }
  }]);

  return LineAnnotationElement;
}(AnnotationElement);

var SquareAnnotationElement =
/*#__PURE__*/
function (_AnnotationElement7) {
  _inherits(SquareAnnotationElement, _AnnotationElement7);

  function SquareAnnotationElement(parameters) {
    _classCallCheck(this, SquareAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, _getPrototypeOf(SquareAnnotationElement).call(this, parameters, isRenderable, true));
  }

  _createClass(SquareAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = 'squareAnnotation';
      var data = this.data;
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      var svg = this.svgFactory.create(width, height);
      var borderWidth = data.borderStyle.width;
      var square = this.svgFactory.createElement('svg:rect');
      square.setAttribute('x', borderWidth / 2);
      square.setAttribute('y', borderWidth / 2);
      square.setAttribute('width', width - borderWidth);
      square.setAttribute('height', height - borderWidth);
      square.setAttribute('stroke-width', borderWidth);
      square.setAttribute('stroke', 'transparent');
      square.setAttribute('fill', 'none');
      svg.appendChild(square);
      this.container.append(svg);

      this._createPopup(this.container, square, data);

      return this.container;
    }
  }]);

  return SquareAnnotationElement;
}(AnnotationElement);

var CircleAnnotationElement =
/*#__PURE__*/
function (_AnnotationElement8) {
  _inherits(CircleAnnotationElement, _AnnotationElement8);

  function CircleAnnotationElement(parameters) {
    _classCallCheck(this, CircleAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, _getPrototypeOf(CircleAnnotationElement).call(this, parameters, isRenderable, true));
  }

  _createClass(CircleAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = 'circleAnnotation';
      var data = this.data;
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      var svg = this.svgFactory.create(width, height);
      var borderWidth = data.borderStyle.width;
      var circle = this.svgFactory.createElement('svg:ellipse');
      circle.setAttribute('cx', width / 2);
      circle.setAttribute('cy', height / 2);
      circle.setAttribute('rx', width / 2 - borderWidth / 2);
      circle.setAttribute('ry', height / 2 - borderWidth / 2);
      circle.setAttribute('stroke-width', borderWidth);
      circle.setAttribute('stroke', 'transparent');
      circle.setAttribute('fill', 'none');
      svg.appendChild(circle);
      this.container.append(svg);

      this._createPopup(this.container, circle, data);

      return this.container;
    }
  }]);

  return CircleAnnotationElement;
}(AnnotationElement);

var PolylineAnnotationElement =
/*#__PURE__*/
function (_AnnotationElement9) {
  _inherits(PolylineAnnotationElement, _AnnotationElement9);

  function PolylineAnnotationElement(parameters) {
    var _this3;

    _classCallCheck(this, PolylineAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(PolylineAnnotationElement).call(this, parameters, isRenderable, true));
    _this3.containerClassName = 'polylineAnnotation';
    _this3.svgElementName = 'svg:polyline';
    return _this3;
  }

  _createClass(PolylineAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = this.containerClassName;
      var data = this.data;
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      var svg = this.svgFactory.create(width, height);
      var vertices = data.vertices;
      var points = [];

      for (var i = 0, ii = vertices.length; i < ii; i++) {
        var x = vertices[i].x - data.rect[0];
        var y = data.rect[3] - vertices[i].y;
        points.push(x + ',' + y);
      }

      points = points.join(' ');
      var borderWidth = data.borderStyle.width;
      var polyline = this.svgFactory.createElement(this.svgElementName);
      polyline.setAttribute('points', points);
      polyline.setAttribute('stroke-width', borderWidth);
      polyline.setAttribute('stroke', 'transparent');
      polyline.setAttribute('fill', 'none');
      svg.appendChild(polyline);
      this.container.append(svg);

      this._createPopup(this.container, polyline, data);

      return this.container;
    }
  }]);

  return PolylineAnnotationElement;
}(AnnotationElement);

var PolygonAnnotationElement =
/*#__PURE__*/
function (_PolylineAnnotationEl) {
  _inherits(PolygonAnnotationElement, _PolylineAnnotationEl);

  function PolygonAnnotationElement(parameters) {
    var _this4;

    _classCallCheck(this, PolygonAnnotationElement);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(PolygonAnnotationElement).call(this, parameters));
    _this4.containerClassName = 'polygonAnnotation';
    _this4.svgElementName = 'svg:polygon';
    return _this4;
  }

  return PolygonAnnotationElement;
}(PolylineAnnotationElement);

var CaretAnnotationElement =
/*#__PURE__*/
function (_AnnotationElement10) {
  _inherits(CaretAnnotationElement, _AnnotationElement10);

  function CaretAnnotationElement(parameters) {
    _classCallCheck(this, CaretAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, _getPrototypeOf(CaretAnnotationElement).call(this, parameters, isRenderable, true));
  }

  _createClass(CaretAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = 'caretAnnotation';

      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }

      return this.container;
    }
  }]);

  return CaretAnnotationElement;
}(AnnotationElement);

var InkAnnotationElement =
/*#__PURE__*/
function (_AnnotationElement11) {
  _inherits(InkAnnotationElement, _AnnotationElement11);

  function InkAnnotationElement(parameters) {
    var _this5;

    _classCallCheck(this, InkAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(InkAnnotationElement).call(this, parameters, isRenderable, true));
    _this5.containerClassName = 'inkAnnotation';
    _this5.svgElementName = 'svg:polyline';
    return _this5;
  }

  _createClass(InkAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = this.containerClassName;
      var data = this.data;
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      var svg = this.svgFactory.create(width, height);
      var inkLists = data.inkLists;

      for (var i = 0, ii = inkLists.length; i < ii; i++) {
        var inkList = inkLists[i];
        var points = [];

        for (var j = 0, jj = inkList.length; j < jj; j++) {
          var x = inkList[j].x - data.rect[0];
          var y = data.rect[3] - inkList[j].y;
          points.push(x + ',' + y);
        }

        points = points.join(' ');
        var borderWidth = data.borderStyle.width;
        var polyline = this.svgFactory.createElement(this.svgElementName);
        polyline.setAttribute('points', points);
        polyline.setAttribute('stroke-width', borderWidth);
        polyline.setAttribute('stroke', 'transparent');
        polyline.setAttribute('fill', 'none');

        this._createPopup(this.container, polyline, data);

        svg.appendChild(polyline);
      }

      this.container.append(svg);
      return this.container;
    }
  }]);

  return InkAnnotationElement;
}(AnnotationElement);

var HighlightAnnotationElement =
/*#__PURE__*/
function (_AnnotationElement12) {
  _inherits(HighlightAnnotationElement, _AnnotationElement12);

  function HighlightAnnotationElement(parameters) {
    _classCallCheck(this, HighlightAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, _getPrototypeOf(HighlightAnnotationElement).call(this, parameters, isRenderable, true));
  }

  _createClass(HighlightAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = 'highlightAnnotation';

      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }

      return this.container;
    }
  }]);

  return HighlightAnnotationElement;
}(AnnotationElement);

var UnderlineAnnotationElement =
/*#__PURE__*/
function (_AnnotationElement13) {
  _inherits(UnderlineAnnotationElement, _AnnotationElement13);

  function UnderlineAnnotationElement(parameters) {
    _classCallCheck(this, UnderlineAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, _getPrototypeOf(UnderlineAnnotationElement).call(this, parameters, isRenderable, true));
  }

  _createClass(UnderlineAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = 'underlineAnnotation';

      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }

      return this.container;
    }
  }]);

  return UnderlineAnnotationElement;
}(AnnotationElement);

var SquigglyAnnotationElement =
/*#__PURE__*/
function (_AnnotationElement14) {
  _inherits(SquigglyAnnotationElement, _AnnotationElement14);

  function SquigglyAnnotationElement(parameters) {
    _classCallCheck(this, SquigglyAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, _getPrototypeOf(SquigglyAnnotationElement).call(this, parameters, isRenderable, true));
  }

  _createClass(SquigglyAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = 'squigglyAnnotation';

      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }

      return this.container;
    }
  }]);

  return SquigglyAnnotationElement;
}(AnnotationElement);

var StrikeOutAnnotationElement =
/*#__PURE__*/
function (_AnnotationElement15) {
  _inherits(StrikeOutAnnotationElement, _AnnotationElement15);

  function StrikeOutAnnotationElement(parameters) {
    _classCallCheck(this, StrikeOutAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, _getPrototypeOf(StrikeOutAnnotationElement).call(this, parameters, isRenderable, true));
  }

  _createClass(StrikeOutAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = 'strikeoutAnnotation';

      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }

      return this.container;
    }
  }]);

  return StrikeOutAnnotationElement;
}(AnnotationElement);

var StampAnnotationElement =
/*#__PURE__*/
function (_AnnotationElement16) {
  _inherits(StampAnnotationElement, _AnnotationElement16);

  function StampAnnotationElement(parameters) {
    _classCallCheck(this, StampAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, _getPrototypeOf(StampAnnotationElement).call(this, parameters, isRenderable, true));
  }

  _createClass(StampAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = 'stampAnnotation';

      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }

      return this.container;
    }
  }]);

  return StampAnnotationElement;
}(AnnotationElement);

var FileAttachmentAnnotationElement =
/*#__PURE__*/
function (_AnnotationElement17) {
  _inherits(FileAttachmentAnnotationElement, _AnnotationElement17);

  function FileAttachmentAnnotationElement(parameters) {
    var _this6;

    _classCallCheck(this, FileAttachmentAnnotationElement);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(FileAttachmentAnnotationElement).call(this, parameters, true));
    var _this6$data$file = _this6.data.file,
        filename = _this6$data$file.filename,
        content = _this6$data$file.content;
    _this6.filename = (0, _display_utils.getFilenameFromUrl)(filename);
    _this6.content = content;

    if (_this6.linkService.eventBus) {
      _this6.linkService.eventBus.dispatch('fileattachmentannotation', {
        source: _assertThisInitialized(_this6),
        id: (0, _util.stringToPDFString)(filename),
        filename: filename,
        content: content
      });
    }

    return _this6;
  }

  _createClass(FileAttachmentAnnotationElement, [{
    key: "render",
    value: function render() {
      this.container.className = 'fileAttachmentAnnotation';
      var trigger = document.createElement('div');
      trigger.style.height = this.container.style.height;
      trigger.style.width = this.container.style.width;
      trigger.addEventListener('dblclick', this._download.bind(this));

      if (!this.data.hasPopup && (this.data.title || this.data.contents)) {
        this._createPopup(this.container, trigger, this.data);
      }

      this.container.appendChild(trigger);
      return this.container;
    }
  }, {
    key: "_download",
    value: function _download() {
      if (!this.downloadManager) {
        (0, _util.warn)('Download cannot be started due to unavailable download manager');
        return;
      }

      this.downloadManager.downloadData(this.content, this.filename, '');
    }
  }]);

  return FileAttachmentAnnotationElement;
}(AnnotationElement);

var AnnotationLayer =
/*#__PURE__*/
function () {
  function AnnotationLayer() {
    _classCallCheck(this, AnnotationLayer);
  }

  _createClass(AnnotationLayer, null, [{
    key: "render",
    value: function render(parameters) {
      for (var i = 0, ii = parameters.annotations.length; i < ii; i++) {
        var data = parameters.annotations[i];

        if (!data) {
          continue;
        }

        var element = AnnotationElementFactory.create({
          data: data,
          layer: parameters.div,
          page: parameters.page,
          viewport: parameters.viewport,
          linkService: parameters.linkService,
          downloadManager: parameters.downloadManager,
          imageResourcesPath: parameters.imageResourcesPath || '',
          renderInteractiveForms: parameters.renderInteractiveForms || false,
          svgFactory: new _display_utils.DOMSVGFactory()
        });

        if (element.isRenderable) {
          parameters.div.appendChild(element.render());
        }
      }
    }
  }, {
    key: "update",
    value: function update(parameters) {
      for (var i = 0, ii = parameters.annotations.length; i < ii; i++) {
        var data = parameters.annotations[i];
        var element = parameters.div.querySelector('[data-annotation-id="' + data.id + '"]');

        if (element) {
          element.style.transform = 'matrix(' + parameters.viewport.transform.join(',') + ')';
        }
      }

      parameters.div.removeAttribute('hidden');
    }
  }]);

  return AnnotationLayer;
}();

exports.AnnotationLayer = AnnotationLayer;

/***/ }),
/* 164 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SVGGraphics = void 0;

var _util = __w_pdfjs_require__(1);

var _display_utils = __w_pdfjs_require__(151);

var _is_node = _interopRequireDefault(__w_pdfjs_require__(4));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SVGGraphics = function SVGGraphics() {
  throw new Error('Not implemented: SVGGraphics');
};

exports.SVGGraphics = SVGGraphics;
{
  var opListToTree = function opListToTree(opList) {
    var opTree = [];
    var tmp = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = opList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var opListElement = _step.value;

        if (opListElement.fn === 'save') {
          opTree.push({
            'fnId': 92,
            'fn': 'group',
            'items': []
          });
          tmp.push(opTree);
          opTree = opTree[opTree.length - 1].items;
          continue;
        }

        if (opListElement.fn === 'restore') {
          opTree = tmp.pop();
        } else {
          opTree.push(opListElement);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return opTree;
  };

  var pf = function pf(value) {
    if (Number.isInteger(value)) {
      return value.toString();
    }

    var s = value.toFixed(10);
    var i = s.length - 1;

    if (s[i] !== '0') {
      return s;
    }

    do {
      i--;
    } while (s[i] === '0');

    return s.substring(0, s[i] === '.' ? i : i + 1);
  };

  var pm = function pm(m) {
    if (m[4] === 0 && m[5] === 0) {
      if (m[1] === 0 && m[2] === 0) {
        if (m[0] === 1 && m[3] === 1) {
          return '';
        }

        return "scale(".concat(pf(m[0]), " ").concat(pf(m[3]), ")");
      }

      if (m[0] === m[3] && m[1] === -m[2]) {
        var a = Math.acos(m[0]) * 180 / Math.PI;
        return "rotate(".concat(pf(a), ")");
      }
    } else {
      if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) {
        return "translate(".concat(pf(m[4]), " ").concat(pf(m[5]), ")");
      }
    }

    return "matrix(".concat(pf(m[0]), " ").concat(pf(m[1]), " ").concat(pf(m[2]), " ").concat(pf(m[3]), " ").concat(pf(m[4]), " ") + "".concat(pf(m[5]), ")");
  };

  var SVG_DEFAULTS = {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fillColor: '#000000'
  };
  var XML_NS = 'http://www.w3.org/XML/1998/namespace';
  var XLINK_NS = 'http://www.w3.org/1999/xlink';
  var LINE_CAP_STYLES = ['butt', 'round', 'square'];
  var LINE_JOIN_STYLES = ['miter', 'round', 'bevel'];

  var convertImgDataToPng = function () {
    var PNG_HEADER = new Uint8Array([0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]);
    var CHUNK_WRAPPER_SIZE = 12;
    var crcTable = new Int32Array(256);

    for (var i = 0; i < 256; i++) {
      var c = i;

      for (var h = 0; h < 8; h++) {
        if (c & 1) {
          c = 0xedB88320 ^ c >> 1 & 0x7fffffff;
        } else {
          c = c >> 1 & 0x7fffffff;
        }
      }

      crcTable[i] = c;
    }

    function crc32(data, start, end) {
      var crc = -1;

      for (var _i = start; _i < end; _i++) {
        var a = (crc ^ data[_i]) & 0xff;
        var b = crcTable[a];
        crc = crc >>> 8 ^ b;
      }

      return crc ^ -1;
    }

    function writePngChunk(type, body, data, offset) {
      var p = offset;
      var len = body.length;
      data[p] = len >> 24 & 0xff;
      data[p + 1] = len >> 16 & 0xff;
      data[p + 2] = len >> 8 & 0xff;
      data[p + 3] = len & 0xff;
      p += 4;
      data[p] = type.charCodeAt(0) & 0xff;
      data[p + 1] = type.charCodeAt(1) & 0xff;
      data[p + 2] = type.charCodeAt(2) & 0xff;
      data[p + 3] = type.charCodeAt(3) & 0xff;
      p += 4;
      data.set(body, p);
      p += body.length;
      var crc = crc32(data, offset + 4, p);
      data[p] = crc >> 24 & 0xff;
      data[p + 1] = crc >> 16 & 0xff;
      data[p + 2] = crc >> 8 & 0xff;
      data[p + 3] = crc & 0xff;
    }

    function adler32(data, start, end) {
      var a = 1;
      var b = 0;

      for (var _i2 = start; _i2 < end; ++_i2) {
        a = (a + (data[_i2] & 0xff)) % 65521;
        b = (b + a) % 65521;
      }

      return b << 16 | a;
    }

    function deflateSync(literals) {
      if (!(0, _is_node["default"])()) {
        return deflateSyncUncompressed(literals);
      }

      try {
        var input;

        if (parseInt(process.versions.node) >= 8) {
          input = literals;
        } else {
          input = new Buffer(literals);
        }

        var output = __webpack_require__(746).deflateSync(input, {
          level: 9
        });

        return output instanceof Uint8Array ? output : new Uint8Array(output);
      } catch (e) {
        (0, _util.warn)('Not compressing PNG because zlib.deflateSync is unavailable: ' + e);
      }

      return deflateSyncUncompressed(literals);
    }

    function deflateSyncUncompressed(literals) {
      var len = literals.length;
      var maxBlockLength = 0xFFFF;
      var deflateBlocks = Math.ceil(len / maxBlockLength);
      var idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
      var pi = 0;
      idat[pi++] = 0x78;
      idat[pi++] = 0x9c;
      var pos = 0;

      while (len > maxBlockLength) {
        idat[pi++] = 0x00;
        idat[pi++] = 0xff;
        idat[pi++] = 0xff;
        idat[pi++] = 0x00;
        idat[pi++] = 0x00;
        idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
        pi += maxBlockLength;
        pos += maxBlockLength;
        len -= maxBlockLength;
      }

      idat[pi++] = 0x01;
      idat[pi++] = len & 0xff;
      idat[pi++] = len >> 8 & 0xff;
      idat[pi++] = ~len & 0xffff & 0xff;
      idat[pi++] = (~len & 0xffff) >> 8 & 0xff;
      idat.set(literals.subarray(pos), pi);
      pi += literals.length - pos;
      var adler = adler32(literals, 0, literals.length);
      idat[pi++] = adler >> 24 & 0xff;
      idat[pi++] = adler >> 16 & 0xff;
      idat[pi++] = adler >> 8 & 0xff;
      idat[pi++] = adler & 0xff;
      return idat;
    }

    function encode(imgData, kind, forceDataSchema, isMask) {
      var width = imgData.width;
      var height = imgData.height;
      var bitDepth, colorType, lineSize;
      var bytes = imgData.data;

      switch (kind) {
        case _util.ImageKind.GRAYSCALE_1BPP:
          colorType = 0;
          bitDepth = 1;
          lineSize = width + 7 >> 3;
          break;

        case _util.ImageKind.RGB_24BPP:
          colorType = 2;
          bitDepth = 8;
          lineSize = width * 3;
          break;

        case _util.ImageKind.RGBA_32BPP:
          colorType = 6;
          bitDepth = 8;
          lineSize = width * 4;
          break;

        default:
          throw new Error('invalid format');
      }

      var literals = new Uint8Array((1 + lineSize) * height);
      var offsetLiterals = 0,
          offsetBytes = 0;

      for (var y = 0; y < height; ++y) {
        literals[offsetLiterals++] = 0;
        literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
        offsetBytes += lineSize;
        offsetLiterals += lineSize;
      }

      if (kind === _util.ImageKind.GRAYSCALE_1BPP && isMask) {
        offsetLiterals = 0;

        for (var _y = 0; _y < height; _y++) {
          offsetLiterals++;

          for (var _i3 = 0; _i3 < lineSize; _i3++) {
            literals[offsetLiterals++] ^= 0xFF;
          }
        }
      }

      var ihdr = new Uint8Array([width >> 24 & 0xff, width >> 16 & 0xff, width >> 8 & 0xff, width & 0xff, height >> 24 & 0xff, height >> 16 & 0xff, height >> 8 & 0xff, height & 0xff, bitDepth, colorType, 0x00, 0x00, 0x00]);
      var idat = deflateSync(literals);
      var pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
      var data = new Uint8Array(pngLength);
      var offset = 0;
      data.set(PNG_HEADER, offset);
      offset += PNG_HEADER.length;
      writePngChunk('IHDR', ihdr, data, offset);
      offset += CHUNK_WRAPPER_SIZE + ihdr.length;
      writePngChunk('IDATA', idat, data, offset);
      offset += CHUNK_WRAPPER_SIZE + idat.length;
      writePngChunk('IEND', new Uint8Array(0), data, offset);
      return (0, _util.createObjectURL)(data, 'image/png', forceDataSchema);
    }

    return function convertImgDataToPng(imgData, forceDataSchema, isMask) {
      var kind = imgData.kind === undefined ? _util.ImageKind.GRAYSCALE_1BPP : imgData.kind;
      return encode(imgData, kind, forceDataSchema, isMask);
    };
  }();

  var SVGExtraState =
  /*#__PURE__*/
  function () {
    function SVGExtraState() {
      _classCallCheck(this, SVGExtraState);

      this.fontSizeScale = 1;
      this.fontWeight = SVG_DEFAULTS.fontWeight;
      this.fontSize = 0;
      this.textMatrix = _util.IDENTITY_MATRIX;
      this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
      this.leading = 0;
      this.textRenderingMode = _util.TextRenderingMode.FILL;
      this.textMatrixScale = 1;
      this.x = 0;
      this.y = 0;
      this.lineX = 0;
      this.lineY = 0;
      this.charSpacing = 0;
      this.wordSpacing = 0;
      this.textHScale = 1;
      this.textRise = 0;
      this.fillColor = SVG_DEFAULTS.fillColor;
      this.strokeColor = '#000000';
      this.fillAlpha = 1;
      this.strokeAlpha = 1;
      this.lineWidth = 1;
      this.lineJoin = '';
      this.lineCap = '';
      this.miterLimit = 0;
      this.dashArray = [];
      this.dashPhase = 0;
      this.dependencies = [];
      this.activeClipUrl = null;
      this.clipGroup = null;
      this.maskId = '';
    }

    _createClass(SVGExtraState, [{
      key: "clone",
      value: function clone() {
        return Object.create(this);
      }
    }, {
      key: "setCurrentPoint",
      value: function setCurrentPoint(x, y) {
        this.x = x;
        this.y = y;
      }
    }]);

    return SVGExtraState;
  }();

  var clipCount = 0;
  var maskCount = 0;
  var shadingCount = 0;

  exports.SVGGraphics = SVGGraphics =
  /*#__PURE__*/
  function () {
    function SVGGraphics(commonObjs, objs, forceDataSchema) {
      _classCallCheck(this, SVGGraphics);

      this.svgFactory = new _display_utils.DOMSVGFactory();
      this.current = new SVGExtraState();
      this.transformMatrix = _util.IDENTITY_MATRIX;
      this.transformStack = [];
      this.extraStack = [];
      this.commonObjs = commonObjs;
      this.objs = objs;
      this.pendingClip = null;
      this.pendingEOFill = false;
      this.embedFonts = false;
      this.embeddedFonts = Object.create(null);
      this.cssStyle = null;
      this.forceDataSchema = !!forceDataSchema;
      this._operatorIdMapping = [];

      for (var op in _util.OPS) {
        this._operatorIdMapping[_util.OPS[op]] = op;
      }
    }

    _createClass(SVGGraphics, [{
      key: "save",
      value: function save() {
        this.transformStack.push(this.transformMatrix);
        var old = this.current;
        this.extraStack.push(old);
        this.current = old.clone();
      }
    }, {
      key: "restore",
      value: function restore() {
        this.transformMatrix = this.transformStack.pop();
        this.current = this.extraStack.pop();
        this.pendingClip = null;
        this.tgrp = null;
      }
    }, {
      key: "group",
      value: function group(items) {
        this.save();
        this.executeOpTree(items);
        this.restore();
      }
    }, {
      key: "loadDependencies",
      value: function loadDependencies(operatorList) {
        var _this = this;

        var fnArray = operatorList.fnArray;
        var argsArray = operatorList.argsArray;

        for (var i = 0, ii = fnArray.length; i < ii; i++) {
          if (fnArray[i] !== _util.OPS.dependency) {
            continue;
          }

          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            var _loop = function _loop() {
              var obj = _step2.value;
              var objsPool = obj.startsWith('g_') ? _this.commonObjs : _this.objs;
              var promise = new Promise(function (resolve) {
                objsPool.get(obj, resolve);
              });

              _this.current.dependencies.push(promise);
            };

            for (var _iterator2 = argsArray[i][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              _loop();
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                _iterator2["return"]();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }

        return Promise.all(this.current.dependencies);
      }
    }, {
      key: "transform",
      value: function transform(a, b, c, d, e, f) {
        var transformMatrix = [a, b, c, d, e, f];
        this.transformMatrix = _util.Util.transform(this.transformMatrix, transformMatrix);
        this.tgrp = null;
      }
    }, {
      key: "getSVG",
      value: function getSVG(operatorList, viewport) {
        var _this2 = this;

        this.viewport = viewport;

        var svgElement = this._initialize(viewport);

        return this.loadDependencies(operatorList).then(function () {
          _this2.transformMatrix = _util.IDENTITY_MATRIX;

          _this2.executeOpTree(_this2.convertOpList(operatorList));

          return svgElement;
        });
      }
    }, {
      key: "convertOpList",
      value: function convertOpList(operatorList) {
        var operatorIdMapping = this._operatorIdMapping;
        var argsArray = operatorList.argsArray;
        var fnArray = operatorList.fnArray;
        var opList = [];

        for (var i = 0, ii = fnArray.length; i < ii; i++) {
          var fnId = fnArray[i];
          opList.push({
            'fnId': fnId,
            'fn': operatorIdMapping[fnId],
            'args': argsArray[i]
          });
        }

        return opListToTree(opList);
      }
    }, {
      key: "executeOpTree",
      value: function executeOpTree(opTree) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = opTree[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var opTreeElement = _step3.value;
            var fn = opTreeElement.fn;
            var fnId = opTreeElement.fnId;
            var args = opTreeElement.args;

            switch (fnId | 0) {
              case _util.OPS.beginText:
                this.beginText();
                break;

              case _util.OPS.dependency:
                break;

              case _util.OPS.setLeading:
                this.setLeading(args);
                break;

              case _util.OPS.setLeadingMoveText:
                this.setLeadingMoveText(args[0], args[1]);
                break;

              case _util.OPS.setFont:
                this.setFont(args);
                break;

              case _util.OPS.showText:
                this.showText(args[0]);
                break;

              case _util.OPS.showSpacedText:
                this.showText(args[0]);
                break;

              case _util.OPS.endText:
                this.endText();
                break;

              case _util.OPS.moveText:
                this.moveText(args[0], args[1]);
                break;

              case _util.OPS.setCharSpacing:
                this.setCharSpacing(args[0]);
                break;

              case _util.OPS.setWordSpacing:
                this.setWordSpacing(args[0]);
                break;

              case _util.OPS.setHScale:
                this.setHScale(args[0]);
                break;

              case _util.OPS.setTextMatrix:
                this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                break;

              case _util.OPS.setTextRise:
                this.setTextRise(args[0]);
                break;

              case _util.OPS.setTextRenderingMode:
                this.setTextRenderingMode(args[0]);
                break;

              case _util.OPS.setLineWidth:
                this.setLineWidth(args[0]);
                break;

              case _util.OPS.setLineJoin:
                this.setLineJoin(args[0]);
                break;

              case _util.OPS.setLineCap:
                this.setLineCap(args[0]);
                break;

              case _util.OPS.setMiterLimit:
                this.setMiterLimit(args[0]);
                break;

              case _util.OPS.setFillRGBColor:
                this.setFillRGBColor(args[0], args[1], args[2]);
                break;

              case _util.OPS.setStrokeRGBColor:
                this.setStrokeRGBColor(args[0], args[1], args[2]);
                break;

              case _util.OPS.setStrokeColorN:
                this.setStrokeColorN(args);
                break;

              case _util.OPS.setFillColorN:
                this.setFillColorN(args);
                break;

              case _util.OPS.shadingFill:
                this.shadingFill(args[0]);
                break;

              case _util.OPS.setDash:
                this.setDash(args[0], args[1]);
                break;

              case _util.OPS.setRenderingIntent:
                this.setRenderingIntent(args[0]);
                break;

              case _util.OPS.setFlatness:
                this.setFlatness(args[0]);
                break;

              case _util.OPS.setGState:
                this.setGState(args[0]);
                break;

              case _util.OPS.fill:
                this.fill();
                break;

              case _util.OPS.eoFill:
                this.eoFill();
                break;

              case _util.OPS.stroke:
                this.stroke();
                break;

              case _util.OPS.fillStroke:
                this.fillStroke();
                break;

              case _util.OPS.eoFillStroke:
                this.eoFillStroke();
                break;

              case _util.OPS.clip:
                this.clip('nonzero');
                break;

              case _util.OPS.eoClip:
                this.clip('evenodd');
                break;

              case _util.OPS.paintSolidColorImageMask:
                this.paintSolidColorImageMask();
                break;

              case _util.OPS.paintJpegXObject:
                this.paintJpegXObject(args[0], args[1], args[2]);
                break;

              case _util.OPS.paintImageXObject:
                this.paintImageXObject(args[0]);
                break;

              case _util.OPS.paintInlineImageXObject:
                this.paintInlineImageXObject(args[0]);
                break;

              case _util.OPS.paintImageMaskXObject:
                this.paintImageMaskXObject(args[0]);
                break;

              case _util.OPS.paintFormXObjectBegin:
                this.paintFormXObjectBegin(args[0], args[1]);
                break;

              case _util.OPS.paintFormXObjectEnd:
                this.paintFormXObjectEnd();
                break;

              case _util.OPS.closePath:
                this.closePath();
                break;

              case _util.OPS.closeStroke:
                this.closeStroke();
                break;

              case _util.OPS.closeFillStroke:
                this.closeFillStroke();
                break;

              case _util.OPS.closeEOFillStroke:
                this.closeEOFillStroke();
                break;

              case _util.OPS.nextLine:
                this.nextLine();
                break;

              case _util.OPS.transform:
                this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
                break;

              case _util.OPS.constructPath:
                this.constructPath(args[0], args[1]);
                break;

              case _util.OPS.endPath:
                this.endPath();
                break;

              case 92:
                this.group(opTreeElement.items);
                break;

              default:
                (0, _util.warn)("Unimplemented operator ".concat(fn));
                break;
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
              _iterator3["return"]();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }
    }, {
      key: "setWordSpacing",
      value: function setWordSpacing(wordSpacing) {
        this.current.wordSpacing = wordSpacing;
      }
    }, {
      key: "setCharSpacing",
      value: function setCharSpacing(charSpacing) {
        this.current.charSpacing = charSpacing;
      }
    }, {
      key: "nextLine",
      value: function nextLine() {
        this.moveText(0, this.current.leading);
      }
    }, {
      key: "setTextMatrix",
      value: function setTextMatrix(a, b, c, d, e, f) {
        var current = this.current;
        current.textMatrix = current.lineMatrix = [a, b, c, d, e, f];
        current.textMatrixScale = Math.sqrt(a * a + b * b);
        current.x = current.lineX = 0;
        current.y = current.lineY = 0;
        current.xcoords = [];
        current.tspan = this.svgFactory.createElement('svg:tspan');
        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
        current.tspan.setAttributeNS(null, 'font-size', "".concat(pf(current.fontSize), "px"));
        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
        current.txtElement = this.svgFactory.createElement('svg:text');
        current.txtElement.appendChild(current.tspan);
      }
    }, {
      key: "beginText",
      value: function beginText() {
        var current = this.current;
        current.x = current.lineX = 0;
        current.y = current.lineY = 0;
        current.textMatrix = _util.IDENTITY_MATRIX;
        current.lineMatrix = _util.IDENTITY_MATRIX;
        current.textMatrixScale = 1;
        current.tspan = this.svgFactory.createElement('svg:tspan');
        current.txtElement = this.svgFactory.createElement('svg:text');
        current.txtgrp = this.svgFactory.createElement('svg:g');
        current.xcoords = [];
      }
    }, {
      key: "moveText",
      value: function moveText(x, y) {
        var current = this.current;
        current.x = current.lineX += x;
        current.y = current.lineY += y;
        current.xcoords = [];
        current.tspan = this.svgFactory.createElement('svg:tspan');
        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
        current.tspan.setAttributeNS(null, 'font-size', "".concat(pf(current.fontSize), "px"));
        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
      }
    }, {
      key: "showText",
      value: function showText(glyphs) {
        var current = this.current;
        var font = current.font;
        var fontSize = current.fontSize;

        if (fontSize === 0) {
          return;
        }

        var charSpacing = current.charSpacing;
        var wordSpacing = current.wordSpacing;
        var fontDirection = current.fontDirection;
        var textHScale = current.textHScale * fontDirection;
        var vertical = font.vertical;
        var widthAdvanceScale = fontSize * current.fontMatrix[0];
        var x = 0;
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = glyphs[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var glyph = _step4.value;

            if (glyph === null) {
              x += fontDirection * wordSpacing;
              continue;
            } else if ((0, _util.isNum)(glyph)) {
              x += -glyph * fontSize * 0.001;
              continue;
            }

            var width = glyph.width;
            var character = glyph.fontChar;
            var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
            var charWidth = width * widthAdvanceScale + spacing * fontDirection;

            if (!glyph.isInFont && !font.missingFile) {
              x += charWidth;
              continue;
            }

            current.xcoords.push(current.x + x * textHScale);
            current.tspan.textContent += character;
            x += charWidth;
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
              _iterator4["return"]();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        if (vertical) {
          current.y -= x * textHScale;
        } else {
          current.x += x * textHScale;
        }

        current.tspan.setAttributeNS(null, 'x', current.xcoords.map(pf).join(' '));
        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
        current.tspan.setAttributeNS(null, 'font-size', "".concat(pf(current.fontSize), "px"));

        if (current.fontStyle !== SVG_DEFAULTS.fontStyle) {
          current.tspan.setAttributeNS(null, 'font-style', current.fontStyle);
        }

        if (current.fontWeight !== SVG_DEFAULTS.fontWeight) {
          current.tspan.setAttributeNS(null, 'font-weight', current.fontWeight);
        }

        var fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;

        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          if (current.fillColor !== SVG_DEFAULTS.fillColor) {
            current.tspan.setAttributeNS(null, 'fill', current.fillColor);
          }

          if (current.fillAlpha < 1) {
            current.tspan.setAttributeNS(null, 'fill-opacity', current.fillAlpha);
          }
        } else if (current.textRenderingMode === _util.TextRenderingMode.ADD_TO_PATH) {
          current.tspan.setAttributeNS(null, 'fill', 'transparent');
        } else {
          current.tspan.setAttributeNS(null, 'fill', 'none');
        }

        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          var lineWidthScale = 1 / (current.textMatrixScale || 1);

          this._setStrokeAttributes(current.tspan, lineWidthScale);
        }

        var textMatrix = current.textMatrix;

        if (current.textRise !== 0) {
          textMatrix = textMatrix.slice();
          textMatrix[5] += current.textRise;
        }

        current.txtElement.setAttributeNS(null, 'transform', "".concat(pm(textMatrix), " scale(1, -1)"));
        current.txtElement.setAttributeNS(XML_NS, 'xml:space', 'preserve');
        current.txtElement.appendChild(current.tspan);
        current.txtgrp.appendChild(current.txtElement);

        this._ensureTransformGroup().appendChild(current.txtElement);
      }
    }, {
      key: "setLeadingMoveText",
      value: function setLeadingMoveText(x, y) {
        this.setLeading(-y);
        this.moveText(x, y);
      }
    }, {
      key: "addFontStyle",
      value: function addFontStyle(fontObj) {
        if (!this.cssStyle) {
          this.cssStyle = this.svgFactory.createElement('svg:style');
          this.cssStyle.setAttributeNS(null, 'type', 'text/css');
          this.defs.appendChild(this.cssStyle);
        }

        var url = (0, _util.createObjectURL)(fontObj.data, fontObj.mimetype, this.forceDataSchema);
        this.cssStyle.textContent += "@font-face { font-family: \"".concat(fontObj.loadedName, "\";") + " src: url(".concat(url, "); }\n");
      }
    }, {
      key: "setFont",
      value: function setFont(details) {
        var current = this.current;
        var fontObj = this.commonObjs.get(details[0]);
        var size = details[1];
        current.font = fontObj;

        if (this.embedFonts && fontObj.data && !this.embeddedFonts[fontObj.loadedName]) {
          this.addFontStyle(fontObj);
          this.embeddedFonts[fontObj.loadedName] = fontObj;
        }

        current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;
        var bold = fontObj.black ? fontObj.bold ? 'bolder' : 'bold' : fontObj.bold ? 'bold' : 'normal';
        var italic = fontObj.italic ? 'italic' : 'normal';

        if (size < 0) {
          size = -size;
          current.fontDirection = -1;
        } else {
          current.fontDirection = 1;
        }

        current.fontSize = size;
        current.fontFamily = fontObj.loadedName;
        current.fontWeight = bold;
        current.fontStyle = italic;
        current.tspan = this.svgFactory.createElement('svg:tspan');
        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
        current.xcoords = [];
      }
    }, {
      key: "endText",
      value: function endText() {
        var current = this.current;

        if (current.textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG && current.txtElement && current.txtElement.hasChildNodes()) {
          current.element = current.txtElement;
          this.clip('nonzero');
          this.endPath();
        }
      }
    }, {
      key: "setLineWidth",
      value: function setLineWidth(width) {
        if (width > 0) {
          this.current.lineWidth = width;
        }
      }
    }, {
      key: "setLineCap",
      value: function setLineCap(style) {
        this.current.lineCap = LINE_CAP_STYLES[style];
      }
    }, {
      key: "setLineJoin",
      value: function setLineJoin(style) {
        this.current.lineJoin = LINE_JOIN_STYLES[style];
      }
    }, {
      key: "setMiterLimit",
      value: function setMiterLimit(limit) {
        this.current.miterLimit = limit;
      }
    }, {
      key: "setStrokeAlpha",
      value: function setStrokeAlpha(strokeAlpha) {
        this.current.strokeAlpha = strokeAlpha;
      }
    }, {
      key: "setStrokeRGBColor",
      value: function setStrokeRGBColor(r, g, b) {
        this.current.strokeColor = _util.Util.makeCssRgb(r, g, b);
      }
    }, {
      key: "setFillAlpha",
      value: function setFillAlpha(fillAlpha) {
        this.current.fillAlpha = fillAlpha;
      }
    }, {
      key: "setFillRGBColor",
      value: function setFillRGBColor(r, g, b) {
        this.current.fillColor = _util.Util.makeCssRgb(r, g, b);
        this.current.tspan = this.svgFactory.createElement('svg:tspan');
        this.current.xcoords = [];
      }
    }, {
      key: "setStrokeColorN",
      value: function setStrokeColorN(args) {
        this.current.strokeColor = this._makeColorN_Pattern(args);
      }
    }, {
      key: "setFillColorN",
      value: function setFillColorN(args) {
        this.current.fillColor = this._makeColorN_Pattern(args);
      }
    }, {
      key: "shadingFill",
      value: function shadingFill(args) {
        var width = this.viewport.width;
        var height = this.viewport.height;

        var inv = _util.Util.inverseTransform(this.transformMatrix);

        var bl = _util.Util.applyTransform([0, 0], inv);

        var br = _util.Util.applyTransform([0, height], inv);

        var ul = _util.Util.applyTransform([width, 0], inv);

        var ur = _util.Util.applyTransform([width, height], inv);

        var x0 = Math.min(bl[0], br[0], ul[0], ur[0]);
        var y0 = Math.min(bl[1], br[1], ul[1], ur[1]);
        var x1 = Math.max(bl[0], br[0], ul[0], ur[0]);
        var y1 = Math.max(bl[1], br[1], ul[1], ur[1]);
        var rect = this.svgFactory.createElement('svg:rect');
        rect.setAttributeNS(null, 'x', x0);
        rect.setAttributeNS(null, 'y', y0);
        rect.setAttributeNS(null, 'width', x1 - x0);
        rect.setAttributeNS(null, 'height', y1 - y0);
        rect.setAttributeNS(null, 'fill', this._makeShadingPattern(args));

        this._ensureTransformGroup().appendChild(rect);
      }
    }, {
      key: "_makeColorN_Pattern",
      value: function _makeColorN_Pattern(args) {
        if (args[0] === 'TilingPattern') {
          return this._makeTilingPattern(args);
        }

        return this._makeShadingPattern(args);
      }
    }, {
      key: "_makeTilingPattern",
      value: function _makeTilingPattern(args) {
        var color = args[1];
        var operatorList = args[2];
        var matrix = args[3] || _util.IDENTITY_MATRIX;

        var _args$ = _slicedToArray(args[4], 4),
            x0 = _args$[0],
            y0 = _args$[1],
            x1 = _args$[2],
            y1 = _args$[3];

        var xstep = args[5];
        var ystep = args[6];
        var paintType = args[7];
        var tilingId = "shading".concat(shadingCount++);

        var _Util$applyTransform = _util.Util.applyTransform([x0, y0], matrix),
            _Util$applyTransform2 = _slicedToArray(_Util$applyTransform, 2),
            tx0 = _Util$applyTransform2[0],
            ty0 = _Util$applyTransform2[1];

        var _Util$applyTransform3 = _util.Util.applyTransform([x1, y1], matrix),
            _Util$applyTransform4 = _slicedToArray(_Util$applyTransform3, 2),
            tx1 = _Util$applyTransform4[0],
            ty1 = _Util$applyTransform4[1];

        var _Util$singularValueDe = _util.Util.singularValueDecompose2dScale(matrix),
            _Util$singularValueDe2 = _slicedToArray(_Util$singularValueDe, 2),
            xscale = _Util$singularValueDe2[0],
            yscale = _Util$singularValueDe2[1];

        var txstep = xstep * xscale;
        var tystep = ystep * yscale;
        var tiling = this.svgFactory.createElement('svg:pattern');
        tiling.setAttributeNS(null, 'id', tilingId);
        tiling.setAttributeNS(null, 'patternUnits', 'userSpaceOnUse');
        tiling.setAttributeNS(null, 'width', txstep);
        tiling.setAttributeNS(null, 'height', tystep);
        tiling.setAttributeNS(null, 'x', "".concat(tx0));
        tiling.setAttributeNS(null, 'y', "".concat(ty0));
        var svg = this.svg;
        var transformMatrix = this.transformMatrix;
        var fillColor = this.current.fillColor;
        var strokeColor = this.current.strokeColor;
        var bbox = this.svgFactory.create(tx1 - tx0, ty1 - ty0);
        this.svg = bbox;
        this.transformMatrix = matrix;

        if (paintType === 2) {
          var cssColor = _util.Util.makeCssRgb.apply(_util.Util, _toConsumableArray(color));

          this.current.fillColor = cssColor;
          this.current.strokeColor = cssColor;
        }

        this.executeOpTree(this.convertOpList(operatorList));
        this.svg = svg;
        this.transformMatrix = transformMatrix;
        this.current.fillColor = fillColor;
        this.current.strokeColor = strokeColor;
        tiling.appendChild(bbox.childNodes[0]);
        this.defs.appendChild(tiling);
        return "url(#".concat(tilingId, ")");
      }
    }, {
      key: "_makeShadingPattern",
      value: function _makeShadingPattern(args) {
        switch (args[0]) {
          case 'RadialAxial':
            var shadingId = "shading".concat(shadingCount++);
            var colorStops = args[2];
            var gradient;

            switch (args[1]) {
              case 'axial':
                var point0 = args[3];
                var point1 = args[4];
                gradient = this.svgFactory.createElement('svg:linearGradient');
                gradient.setAttributeNS(null, 'id', shadingId);
                gradient.setAttributeNS(null, 'gradientUnits', 'userSpaceOnUse');
                gradient.setAttributeNS(null, 'x1', point0[0]);
                gradient.setAttributeNS(null, 'y1', point0[1]);
                gradient.setAttributeNS(null, 'x2', point1[0]);
                gradient.setAttributeNS(null, 'y2', point1[1]);
                break;

              case 'radial':
                var focalPoint = args[3];
                var circlePoint = args[4];
                var focalRadius = args[5];
                var circleRadius = args[6];
                gradient = this.svgFactory.createElement('svg:radialGradient');
                gradient.setAttributeNS(null, 'id', shadingId);
                gradient.setAttributeNS(null, 'gradientUnits', 'userSpaceOnUse');
                gradient.setAttributeNS(null, 'cx', circlePoint[0]);
                gradient.setAttributeNS(null, 'cy', circlePoint[1]);
                gradient.setAttributeNS(null, 'r', circleRadius);
                gradient.setAttributeNS(null, 'fx', focalPoint[0]);
                gradient.setAttributeNS(null, 'fy', focalPoint[1]);
                gradient.setAttributeNS(null, 'fr', focalRadius);
                break;

              default:
                throw new Error("Unknown RadialAxial type: ".concat(args[1]));
            }

            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
              for (var _iterator5 = colorStops[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var colorStop = _step5.value;
                var stop = this.svgFactory.createElement('svg:stop');
                stop.setAttributeNS(null, 'offset', colorStop[0]);
                stop.setAttributeNS(null, 'stop-color', colorStop[1]);
                gradient.appendChild(stop);
              }
            } catch (err) {
              _didIteratorError5 = true;
              _iteratorError5 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion5 && _iterator5["return"] != null) {
                  _iterator5["return"]();
                }
              } finally {
                if (_didIteratorError5) {
                  throw _iteratorError5;
                }
              }
            }

            this.defs.appendChild(gradient);
            return "url(#".concat(shadingId, ")");

          case 'Mesh':
            (0, _util.warn)('Unimplemented pattern Mesh');
            return null;

          case 'Dummy':
            return 'hotpink';

          default:
            throw new Error("Unknown IR type: ".concat(args[0]));
        }
      }
    }, {
      key: "setDash",
      value: function setDash(dashArray, dashPhase) {
        this.current.dashArray = dashArray;
        this.current.dashPhase = dashPhase;
      }
    }, {
      key: "constructPath",
      value: function constructPath(ops, args) {
        var current = this.current;
        var x = current.x,
            y = current.y;
        var d = [];
        var j = 0;
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = ops[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var op = _step6.value;

            switch (op | 0) {
              case _util.OPS.rectangle:
                x = args[j++];
                y = args[j++];
                var width = args[j++];
                var height = args[j++];
                var xw = x + width;
                var yh = y + height;
                d.push('M', pf(x), pf(y), 'L', pf(xw), pf(y), 'L', pf(xw), pf(yh), 'L', pf(x), pf(yh), 'Z');
                break;

              case _util.OPS.moveTo:
                x = args[j++];
                y = args[j++];
                d.push('M', pf(x), pf(y));
                break;

              case _util.OPS.lineTo:
                x = args[j++];
                y = args[j++];
                d.push('L', pf(x), pf(y));
                break;

              case _util.OPS.curveTo:
                x = args[j + 4];
                y = args[j + 5];
                d.push('C', pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
                j += 6;
                break;

              case _util.OPS.curveTo2:
                x = args[j + 2];
                y = args[j + 3];
                d.push('C', pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
                j += 4;
                break;

              case _util.OPS.curveTo3:
                x = args[j + 2];
                y = args[j + 3];
                d.push('C', pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
                j += 4;
                break;

              case _util.OPS.closePath:
                d.push('Z');
                break;
            }
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6["return"] != null) {
              _iterator6["return"]();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }

        d = d.join(' ');

        if (current.path && ops.length > 0 && ops[0] !== _util.OPS.rectangle && ops[0] !== _util.OPS.moveTo) {
          d = current.path.getAttributeNS(null, 'd') + d;
        } else {
          current.path = this.svgFactory.createElement('svg:path');

          this._ensureTransformGroup().appendChild(current.path);
        }

        current.path.setAttributeNS(null, 'd', d);
        current.path.setAttributeNS(null, 'fill', 'none');
        current.element = current.path;
        current.setCurrentPoint(x, y);
      }
    }, {
      key: "endPath",
      value: function endPath() {
        var current = this.current;
        current.path = null;

        if (!this.pendingClip) {
          return;
        }

        if (!current.element) {
          this.pendingClip = null;
          return;
        }

        var clipId = "clippath".concat(clipCount++);
        var clipPath = this.svgFactory.createElement('svg:clipPath');
        clipPath.setAttributeNS(null, 'id', clipId);
        clipPath.setAttributeNS(null, 'transform', pm(this.transformMatrix));
        var clipElement = current.element.cloneNode(true);

        if (this.pendingClip === 'evenodd') {
          clipElement.setAttributeNS(null, 'clip-rule', 'evenodd');
        } else {
          clipElement.setAttributeNS(null, 'clip-rule', 'nonzero');
        }

        this.pendingClip = null;
        clipPath.appendChild(clipElement);
        this.defs.appendChild(clipPath);

        if (current.activeClipUrl) {
          current.clipGroup = null;
          this.extraStack.forEach(function (prev) {
            prev.clipGroup = null;
          });
          clipPath.setAttributeNS(null, 'clip-path', current.activeClipUrl);
        }

        current.activeClipUrl = "url(#".concat(clipId, ")");
        this.tgrp = null;
      }
    }, {
      key: "clip",
      value: function clip(type) {
        this.pendingClip = type;
      }
    }, {
      key: "closePath",
      value: function closePath() {
        var current = this.current;

        if (current.path) {
          var d = "".concat(current.path.getAttributeNS(null, 'd'), "Z");
          current.path.setAttributeNS(null, 'd', d);
        }
      }
    }, {
      key: "setLeading",
      value: function setLeading(leading) {
        this.current.leading = -leading;
      }
    }, {
      key: "setTextRise",
      value: function setTextRise(textRise) {
        this.current.textRise = textRise;
      }
    }, {
      key: "setTextRenderingMode",
      value: function setTextRenderingMode(textRenderingMode) {
        this.current.textRenderingMode = textRenderingMode;
      }
    }, {
      key: "setHScale",
      value: function setHScale(scale) {
        this.current.textHScale = scale / 100;
      }
    }, {
      key: "setRenderingIntent",
      value: function setRenderingIntent(intent) {}
    }, {
      key: "setFlatness",
      value: function setFlatness(flatness) {}
    }, {
      key: "setGState",
      value: function setGState(states) {
        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
          for (var _iterator7 = states[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            var _step7$value = _slicedToArray(_step7.value, 2),
                key = _step7$value[0],
                value = _step7$value[1];

            switch (key) {
              case 'LW':
                this.setLineWidth(value);
                break;

              case 'LC':
                this.setLineCap(value);
                break;

              case 'LJ':
                this.setLineJoin(value);
                break;

              case 'ML':
                this.setMiterLimit(value);
                break;

              case 'D':
                this.setDash(value[0], value[1]);
                break;

              case 'RI':
                this.setRenderingIntent(value);
                break;

              case 'FL':
                this.setFlatness(value);
                break;

              case 'Font':
                this.setFont(value);
                break;

              case 'CA':
                this.setStrokeAlpha(value);
                break;

              case 'ca':
                this.setFillAlpha(value);
                break;

              default:
                (0, _util.warn)("Unimplemented graphic state operator ".concat(key));
                break;
            }
          }
        } catch (err) {
          _didIteratorError7 = true;
          _iteratorError7 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion7 && _iterator7["return"] != null) {
              _iterator7["return"]();
            }
          } finally {
            if (_didIteratorError7) {
              throw _iteratorError7;
            }
          }
        }
      }
    }, {
      key: "fill",
      value: function fill() {
        var current = this.current;

        if (current.element) {
          current.element.setAttributeNS(null, 'fill', current.fillColor);
          current.element.setAttributeNS(null, 'fill-opacity', current.fillAlpha);
          this.endPath();
        }
      }
    }, {
      key: "stroke",
      value: function stroke() {
        var current = this.current;

        if (current.element) {
          this._setStrokeAttributes(current.element);

          current.element.setAttributeNS(null, 'fill', 'none');
          this.endPath();
        }
      }
    }, {
      key: "_setStrokeAttributes",
      value: function _setStrokeAttributes(element) {
        var lineWidthScale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var current = this.current;
        var dashArray = current.dashArray;

        if (lineWidthScale !== 1 && dashArray.length > 0) {
          dashArray = dashArray.map(function (value) {
            return lineWidthScale * value;
          });
        }

        element.setAttributeNS(null, 'stroke', current.strokeColor);
        element.setAttributeNS(null, 'stroke-opacity', current.strokeAlpha);
        element.setAttributeNS(null, 'stroke-miterlimit', pf(current.miterLimit));
        element.setAttributeNS(null, 'stroke-linecap', current.lineCap);
        element.setAttributeNS(null, 'stroke-linejoin', current.lineJoin);
        element.setAttributeNS(null, 'stroke-width', pf(lineWidthScale * current.lineWidth) + 'px');
        element.setAttributeNS(null, 'stroke-dasharray', dashArray.map(pf).join(' '));
        element.setAttributeNS(null, 'stroke-dashoffset', pf(lineWidthScale * current.dashPhase) + 'px');
      }
    }, {
      key: "eoFill",
      value: function eoFill() {
        if (this.current.element) {
          this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd');
        }

        this.fill();
      }
    }, {
      key: "fillStroke",
      value: function fillStroke() {
        this.stroke();
        this.fill();
      }
    }, {
      key: "eoFillStroke",
      value: function eoFillStroke() {
        if (this.current.element) {
          this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd');
        }

        this.fillStroke();
      }
    }, {
      key: "closeStroke",
      value: function closeStroke() {
        this.closePath();
        this.stroke();
      }
    }, {
      key: "closeFillStroke",
      value: function closeFillStroke() {
        this.closePath();
        this.fillStroke();
      }
    }, {
      key: "closeEOFillStroke",
      value: function closeEOFillStroke() {
        this.closePath();
        this.eoFillStroke();
      }
    }, {
      key: "paintSolidColorImageMask",
      value: function paintSolidColorImageMask() {
        var rect = this.svgFactory.createElement('svg:rect');
        rect.setAttributeNS(null, 'x', '0');
        rect.setAttributeNS(null, 'y', '0');
        rect.setAttributeNS(null, 'width', '1px');
        rect.setAttributeNS(null, 'height', '1px');
        rect.setAttributeNS(null, 'fill', this.current.fillColor);

        this._ensureTransformGroup().appendChild(rect);
      }
    }, {
      key: "paintJpegXObject",
      value: function paintJpegXObject(objId, w, h) {
        var imgObj = this.objs.get(objId);
        var imgEl = this.svgFactory.createElement('svg:image');
        imgEl.setAttributeNS(XLINK_NS, 'xlink:href', imgObj.src);
        imgEl.setAttributeNS(null, 'width', pf(w));
        imgEl.setAttributeNS(null, 'height', pf(h));
        imgEl.setAttributeNS(null, 'x', '0');
        imgEl.setAttributeNS(null, 'y', pf(-h));
        imgEl.setAttributeNS(null, 'transform', "scale(".concat(pf(1 / w), " ").concat(pf(-1 / h), ")"));

        this._ensureTransformGroup().appendChild(imgEl);
      }
    }, {
      key: "paintImageXObject",
      value: function paintImageXObject(objId) {
        var imgData = this.objs.get(objId);

        if (!imgData) {
          (0, _util.warn)("Dependent image with object ID ".concat(objId, " is not ready yet"));
          return;
        }

        this.paintInlineImageXObject(imgData);
      }
    }, {
      key: "paintInlineImageXObject",
      value: function paintInlineImageXObject(imgData, mask) {
        var width = imgData.width;
        var height = imgData.height;
        var imgSrc = convertImgDataToPng(imgData, this.forceDataSchema, !!mask);
        var cliprect = this.svgFactory.createElement('svg:rect');
        cliprect.setAttributeNS(null, 'x', '0');
        cliprect.setAttributeNS(null, 'y', '0');
        cliprect.setAttributeNS(null, 'width', pf(width));
        cliprect.setAttributeNS(null, 'height', pf(height));
        this.current.element = cliprect;
        this.clip('nonzero');
        var imgEl = this.svgFactory.createElement('svg:image');
        imgEl.setAttributeNS(XLINK_NS, 'xlink:href', imgSrc);
        imgEl.setAttributeNS(null, 'x', '0');
        imgEl.setAttributeNS(null, 'y', pf(-height));
        imgEl.setAttributeNS(null, 'width', pf(width) + 'px');
        imgEl.setAttributeNS(null, 'height', pf(height) + 'px');
        imgEl.setAttributeNS(null, 'transform', "scale(".concat(pf(1 / width), " ").concat(pf(-1 / height), ")"));

        if (mask) {
          mask.appendChild(imgEl);
        } else {
          this._ensureTransformGroup().appendChild(imgEl);
        }
      }
    }, {
      key: "paintImageMaskXObject",
      value: function paintImageMaskXObject(imgData) {
        var current = this.current;
        var width = imgData.width;
        var height = imgData.height;
        var fillColor = current.fillColor;
        current.maskId = "mask".concat(maskCount++);
        var mask = this.svgFactory.createElement('svg:mask');
        mask.setAttributeNS(null, 'id', current.maskId);
        var rect = this.svgFactory.createElement('svg:rect');
        rect.setAttributeNS(null, 'x', '0');
        rect.setAttributeNS(null, 'y', '0');
        rect.setAttributeNS(null, 'width', pf(width));
        rect.setAttributeNS(null, 'height', pf(height));
        rect.setAttributeNS(null, 'fill', fillColor);
        rect.setAttributeNS(null, 'mask', "url(#".concat(current.maskId, ")"));
        this.defs.appendChild(mask);

        this._ensureTransformGroup().appendChild(rect);

        this.paintInlineImageXObject(imgData, mask);
      }
    }, {
      key: "paintFormXObjectBegin",
      value: function paintFormXObjectBegin(matrix, bbox) {
        if (Array.isArray(matrix) && matrix.length === 6) {
          this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
        }

        if (bbox) {
          var width = bbox[2] - bbox[0];
          var height = bbox[3] - bbox[1];
          var cliprect = this.svgFactory.createElement('svg:rect');
          cliprect.setAttributeNS(null, 'x', bbox[0]);
          cliprect.setAttributeNS(null, 'y', bbox[1]);
          cliprect.setAttributeNS(null, 'width', pf(width));
          cliprect.setAttributeNS(null, 'height', pf(height));
          this.current.element = cliprect;
          this.clip('nonzero');
          this.endPath();
        }
      }
    }, {
      key: "paintFormXObjectEnd",
      value: function paintFormXObjectEnd() {}
    }, {
      key: "_initialize",
      value: function _initialize(viewport) {
        var svg = this.svgFactory.create(viewport.width, viewport.height);
        var definitions = this.svgFactory.createElement('svg:defs');
        svg.appendChild(definitions);
        this.defs = definitions;
        var rootGroup = this.svgFactory.createElement('svg:g');
        rootGroup.setAttributeNS(null, 'transform', pm(viewport.transform));
        svg.appendChild(rootGroup);
        this.svg = rootGroup;
        return svg;
      }
    }, {
      key: "_ensureClipGroup",
      value: function _ensureClipGroup() {
        if (!this.current.clipGroup) {
          var clipGroup = this.svgFactory.createElement('svg:g');
          clipGroup.setAttributeNS(null, 'clip-path', this.current.activeClipUrl);
          this.svg.appendChild(clipGroup);
          this.current.clipGroup = clipGroup;
        }

        return this.current.clipGroup;
      }
    }, {
      key: "_ensureTransformGroup",
      value: function _ensureTransformGroup() {
        if (!this.tgrp) {
          this.tgrp = this.svgFactory.createElement('svg:g');
          this.tgrp.setAttributeNS(null, 'transform', pm(this.transformMatrix));

          if (this.current.activeClipUrl) {
            this._ensureClipGroup().appendChild(this.tgrp);
          } else {
            this.svg.appendChild(this.tgrp);
          }
        }

        return this.tgrp;
      }
    }]);

    return SVGGraphics;
  }();
}

/***/ }),
/* 165 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFNodeStream = void 0;

var _regenerator = _interopRequireDefault(__w_pdfjs_require__(148));

var _util = __w_pdfjs_require__(1);

var _network_utils = __w_pdfjs_require__(166);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var fs = __webpack_require__(747);

var http = __webpack_require__(748);

var https = __webpack_require__(749);

var url = __webpack_require__(750);

var fileUriRegex = /^file:\/\/\/[a-zA-Z]:\//;

function parseUrl(sourceUrl) {
  var parsedUrl = url.parse(sourceUrl);

  if (parsedUrl.protocol === 'file:' || parsedUrl.host) {
    return parsedUrl;
  }

  if (/^[a-z]:[/\\]/i.test(sourceUrl)) {
    return url.parse("file:///".concat(sourceUrl));
  }

  if (!parsedUrl.host) {
    parsedUrl.protocol = 'file:';
  }

  return parsedUrl;
}

var PDFNodeStream =
/*#__PURE__*/
function () {
  function PDFNodeStream(source) {
    _classCallCheck(this, PDFNodeStream);

    this.source = source;
    this.url = parseUrl(source.url);
    this.isHttp = this.url.protocol === 'http:' || this.url.protocol === 'https:';
    this.isFsUrl = this.url.protocol === 'file:';
    this.httpHeaders = this.isHttp && source.httpHeaders || {};
    this._fullRequestReader = null;
    this._rangeRequestReaders = [];
  }

  _createClass(PDFNodeStream, [{
    key: "getFullReader",
    value: function getFullReader() {
      (0, _util.assert)(!this._fullRequestReader);
      this._fullRequestReader = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this);
      return this._fullRequestReader;
    }
  }, {
    key: "getRangeReader",
    value: function getRangeReader(start, end) {
      if (end <= this._progressiveDataLength) {
        return null;
      }

      var rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start, end) : new PDFNodeStreamRangeReader(this, start, end);

      this._rangeRequestReaders.push(rangeReader);

      return rangeReader;
    }
  }, {
    key: "cancelAllRequests",
    value: function cancelAllRequests(reason) {
      if (this._fullRequestReader) {
        this._fullRequestReader.cancel(reason);
      }

      var readers = this._rangeRequestReaders.slice(0);

      readers.forEach(function (reader) {
        reader.cancel(reason);
      });
    }
  }, {
    key: "_progressiveDataLength",
    get: function get() {
      return this._fullRequestReader ? this._fullRequestReader._loaded : 0;
    }
  }]);

  return PDFNodeStream;
}();

exports.PDFNodeStream = PDFNodeStream;

var BaseFullReader =
/*#__PURE__*/
function () {
  function BaseFullReader(stream) {
    _classCallCheck(this, BaseFullReader);

    this._url = stream.url;
    this._done = false;
    this._storedError = null;
    this.onProgress = null;
    var source = stream.source;
    this._contentLength = source.length;
    this._loaded = 0;
    this._filename = null;
    this._disableRange = source.disableRange || false;
    this._rangeChunkSize = source.rangeChunkSize;

    if (!this._rangeChunkSize && !this._disableRange) {
      this._disableRange = true;
    }

    this._isStreamingSupported = !source.disableStream;
    this._isRangeSupported = !source.disableRange;
    this._readableStream = null;
    this._readCapability = (0, _util.createPromiseCapability)();
    this._headersCapability = (0, _util.createPromiseCapability)();
  }

  _createClass(BaseFullReader, [{
    key: "read",
    value: function () {
      var _read = _asyncToGenerator(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee() {
        var chunk, buffer;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._readCapability.promise;

              case 2:
                if (!this._done) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", {
                  value: undefined,
                  done: true
                });

              case 4:
                if (!this._storedError) {
                  _context.next = 6;
                  break;
                }

                throw this._storedError;

              case 6:
                chunk = this._readableStream.read();

                if (!(chunk === null)) {
                  _context.next = 10;
                  break;
                }

                this._readCapability = (0, _util.createPromiseCapability)();
                return _context.abrupt("return", this.read());

              case 10:
                this._loaded += chunk.length;

                if (this.onProgress) {
                  this.onProgress({
                    loaded: this._loaded,
                    total: this._contentLength
                  });
                }

                buffer = new Uint8Array(chunk).buffer;
                return _context.abrupt("return", {
                  value: buffer,
                  done: false
                });

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function read() {
        return _read.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: "cancel",
    value: function cancel(reason) {
      if (!this._readableStream) {
        this._error(reason);

        return;
      }

      this._readableStream.destroy(reason);
    }
  }, {
    key: "_error",
    value: function _error(reason) {
      this._storedError = reason;

      this._readCapability.resolve();
    }
  }, {
    key: "_setReadableStream",
    value: function _setReadableStream(readableStream) {
      var _this = this;

      this._readableStream = readableStream;
      readableStream.on('readable', function () {
        _this._readCapability.resolve();
      });
      readableStream.on('end', function () {
        readableStream.destroy();
        _this._done = true;

        _this._readCapability.resolve();
      });
      readableStream.on('error', function (reason) {
        _this._error(reason);
      });

      if (!this._isStreamingSupported && this._isRangeSupported) {
        this._error(new _util.AbortException('streaming is disabled'));
      }

      if (this._storedError) {
        this._readableStream.destroy(this._storedError);
      }
    }
  }, {
    key: "headersReady",
    get: function get() {
      return this._headersCapability.promise;
    }
  }, {
    key: "filename",
    get: function get() {
      return this._filename;
    }
  }, {
    key: "contentLength",
    get: function get() {
      return this._contentLength;
    }
  }, {
    key: "isRangeSupported",
    get: function get() {
      return this._isRangeSupported;
    }
  }, {
    key: "isStreamingSupported",
    get: function get() {
      return this._isStreamingSupported;
    }
  }]);

  return BaseFullReader;
}();

var BaseRangeReader =
/*#__PURE__*/
function () {
  function BaseRangeReader(stream) {
    _classCallCheck(this, BaseRangeReader);

    this._url = stream.url;
    this._done = false;
    this._storedError = null;
    this.onProgress = null;
    this._loaded = 0;
    this._readableStream = null;
    this._readCapability = (0, _util.createPromiseCapability)();
    var source = stream.source;
    this._isStreamingSupported = !source.disableStream;
  }

  _createClass(BaseRangeReader, [{
    key: "read",
    value: function () {
      var _read2 = _asyncToGenerator(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee2() {
        var chunk, buffer;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._readCapability.promise;

              case 2:
                if (!this._done) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", {
                  value: undefined,
                  done: true
                });

              case 4:
                if (!this._storedError) {
                  _context2.next = 6;
                  break;
                }

                throw this._storedError;

              case 6:
                chunk = this._readableStream.read();

                if (!(chunk === null)) {
                  _context2.next = 10;
                  break;
                }

                this._readCapability = (0, _util.createPromiseCapability)();
                return _context2.abrupt("return", this.read());

              case 10:
                this._loaded += chunk.length;

                if (this.onProgress) {
                  this.onProgress({
                    loaded: this._loaded
                  });
                }

                buffer = new Uint8Array(chunk).buffer;
                return _context2.abrupt("return", {
                  value: buffer,
                  done: false
                });

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function read() {
        return _read2.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: "cancel",
    value: function cancel(reason) {
      if (!this._readableStream) {
        this._error(reason);

        return;
      }

      this._readableStream.destroy(reason);
    }
  }, {
    key: "_error",
    value: function _error(reason) {
      this._storedError = reason;

      this._readCapability.resolve();
    }
  }, {
    key: "_setReadableStream",
    value: function _setReadableStream(readableStream) {
      var _this2 = this;

      this._readableStream = readableStream;
      readableStream.on('readable', function () {
        _this2._readCapability.resolve();
      });
      readableStream.on('end', function () {
        readableStream.destroy();
        _this2._done = true;

        _this2._readCapability.resolve();
      });
      readableStream.on('error', function (reason) {
        _this2._error(reason);
      });

      if (this._storedError) {
        this._readableStream.destroy(this._storedError);
      }
    }
  }, {
    key: "isStreamingSupported",
    get: function get() {
      return this._isStreamingSupported;
    }
  }]);

  return BaseRangeReader;
}();

function createRequestOptions(url, headers) {
  return {
    protocol: url.protocol,
    auth: url.auth,
    host: url.hostname,
    port: url.port,
    path: url.path,
    method: 'GET',
    headers: headers
  };
}

var PDFNodeStreamFullReader =
/*#__PURE__*/
function (_BaseFullReader) {
  _inherits(PDFNodeStreamFullReader, _BaseFullReader);

  function PDFNodeStreamFullReader(stream) {
    var _this3;

    _classCallCheck(this, PDFNodeStreamFullReader);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(PDFNodeStreamFullReader).call(this, stream));

    var handleResponse = function handleResponse(response) {
      if (response.statusCode === 404) {
        var error = new _util.MissingPDFException("Missing PDF \"".concat(_this3._url, "\"."));
        _this3._storedError = error;

        _this3._headersCapability.reject(error);

        return;
      }

      _this3._headersCapability.resolve();

      _this3._setReadableStream(response);

      var getResponseHeader = function getResponseHeader(name) {
        return _this3._readableStream.headers[name.toLowerCase()];
      };

      var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
        getResponseHeader: getResponseHeader,
        isHttp: stream.isHttp,
        rangeChunkSize: _this3._rangeChunkSize,
        disableRange: _this3._disableRange
      }),
          allowRangeRequests = _validateRangeRequest.allowRangeRequests,
          suggestedLength = _validateRangeRequest.suggestedLength;

      _this3._isRangeSupported = allowRangeRequests;
      _this3._contentLength = suggestedLength || _this3._contentLength;
      _this3._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
    };

    _this3._request = null;

    if (_this3._url.protocol === 'http:') {
      _this3._request = http.request(createRequestOptions(_this3._url, stream.httpHeaders), handleResponse);
    } else {
      _this3._request = https.request(createRequestOptions(_this3._url, stream.httpHeaders), handleResponse);
    }

    _this3._request.on('error', function (reason) {
      _this3._storedError = reason;

      _this3._headersCapability.reject(reason);
    });

    _this3._request.end();

    return _this3;
  }

  return PDFNodeStreamFullReader;
}(BaseFullReader);

var PDFNodeStreamRangeReader =
/*#__PURE__*/
function (_BaseRangeReader) {
  _inherits(PDFNodeStreamRangeReader, _BaseRangeReader);

  function PDFNodeStreamRangeReader(stream, start, end) {
    var _this4;

    _classCallCheck(this, PDFNodeStreamRangeReader);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(PDFNodeStreamRangeReader).call(this, stream));
    _this4._httpHeaders = {};

    for (var property in stream.httpHeaders) {
      var value = stream.httpHeaders[property];

      if (typeof value === 'undefined') {
        continue;
      }

      _this4._httpHeaders[property] = value;
    }

    _this4._httpHeaders['Range'] = "bytes=".concat(start, "-").concat(end - 1);

    var handleResponse = function handleResponse(response) {
      if (response.statusCode === 404) {
        var error = new _util.MissingPDFException("Missing PDF \"".concat(_this4._url, "\"."));
        _this4._storedError = error;
        return;
      }

      _this4._setReadableStream(response);
    };

    _this4._request = null;

    if (_this4._url.protocol === 'http:') {
      _this4._request = http.request(createRequestOptions(_this4._url, _this4._httpHeaders), handleResponse);
    } else {
      _this4._request = https.request(createRequestOptions(_this4._url, _this4._httpHeaders), handleResponse);
    }

    _this4._request.on('error', function (reason) {
      _this4._storedError = reason;
    });

    _this4._request.end();

    return _this4;
  }

  return PDFNodeStreamRangeReader;
}(BaseRangeReader);

var PDFNodeStreamFsFullReader =
/*#__PURE__*/
function (_BaseFullReader2) {
  _inherits(PDFNodeStreamFsFullReader, _BaseFullReader2);

  function PDFNodeStreamFsFullReader(stream) {
    var _this5;

    _classCallCheck(this, PDFNodeStreamFsFullReader);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(PDFNodeStreamFsFullReader).call(this, stream));
    var path = decodeURIComponent(_this5._url.path);

    if (fileUriRegex.test(_this5._url.href)) {
      path = path.replace(/^\//, '');
    }

    fs.lstat(path, function (error, stat) {
      if (error) {
        if (error.code === 'ENOENT') {
          error = new _util.MissingPDFException("Missing PDF \"".concat(path, "\"."));
        }

        _this5._storedError = error;

        _this5._headersCapability.reject(error);

        return;
      }

      _this5._contentLength = stat.size;

      _this5._setReadableStream(fs.createReadStream(path));

      _this5._headersCapability.resolve();
    });
    return _this5;
  }

  return PDFNodeStreamFsFullReader;
}(BaseFullReader);

var PDFNodeStreamFsRangeReader =
/*#__PURE__*/
function (_BaseRangeReader2) {
  _inherits(PDFNodeStreamFsRangeReader, _BaseRangeReader2);

  function PDFNodeStreamFsRangeReader(stream, start, end) {
    var _this6;

    _classCallCheck(this, PDFNodeStreamFsRangeReader);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(PDFNodeStreamFsRangeReader).call(this, stream));
    var path = decodeURIComponent(_this6._url.path);

    if (fileUriRegex.test(_this6._url.href)) {
      path = path.replace(/^\//, '');
    }

    _this6._setReadableStream(fs.createReadStream(path, {
      start: start,
      end: end - 1
    }));

    return _this6;
  }

  return PDFNodeStreamFsRangeReader;
}(BaseRangeReader);

/***/ }),
/* 166 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createResponseStatusError = createResponseStatusError;
exports.extractFilenameFromHeader = extractFilenameFromHeader;
exports.validateRangeRequestCapabilities = validateRangeRequestCapabilities;
exports.validateResponseStatus = validateResponseStatus;

var _util = __w_pdfjs_require__(1);

var _content_disposition = __w_pdfjs_require__(167);

function validateRangeRequestCapabilities(_ref) {
  var getResponseHeader = _ref.getResponseHeader,
      isHttp = _ref.isHttp,
      rangeChunkSize = _ref.rangeChunkSize,
      disableRange = _ref.disableRange;
  (0, _util.assert)(rangeChunkSize > 0, 'Range chunk size must be larger than zero');
  var returnValues = {
    allowRangeRequests: false,
    suggestedLength: undefined
  };
  var length = parseInt(getResponseHeader('Content-Length'), 10);

  if (!Number.isInteger(length)) {
    return returnValues;
  }

  returnValues.suggestedLength = length;

  if (length <= 2 * rangeChunkSize) {
    return returnValues;
  }

  if (disableRange || !isHttp) {
    return returnValues;
  }

  if (getResponseHeader('Accept-Ranges') !== 'bytes') {
    return returnValues;
  }

  var contentEncoding = getResponseHeader('Content-Encoding') || 'identity';

  if (contentEncoding !== 'identity') {
    return returnValues;
  }

  returnValues.allowRangeRequests = true;
  return returnValues;
}

function extractFilenameFromHeader(getResponseHeader) {
  var contentDisposition = getResponseHeader('Content-Disposition');

  if (contentDisposition) {
    var filename = (0, _content_disposition.getFilenameFromContentDispositionHeader)(contentDisposition);

    if (/\.pdf$/i.test(filename)) {
      return filename;
    }
  }

  return null;
}

function createResponseStatusError(status, url) {
  if (status === 404 || status === 0 && /^file:/.test(url)) {
    return new _util.MissingPDFException('Missing PDF "' + url + '".');
  }

  return new _util.UnexpectedResponseException('Unexpected server response (' + status + ') while retrieving PDF "' + url + '".', status);
}

function validateResponseStatus(status) {
  return status === 200 || status === 206;
}

/***/ }),
/* 167 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilenameFromContentDispositionHeader = getFilenameFromContentDispositionHeader;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function getFilenameFromContentDispositionHeader(contentDisposition) {
  var needsEncodingFixup = true;
  var tmp = toParamRegExp('filename\\*', 'i').exec(contentDisposition);

  if (tmp) {
    tmp = tmp[1];
    var filename = rfc2616unquote(tmp);
    filename = unescape(filename);
    filename = rfc5987decode(filename);
    filename = rfc2047decode(filename);
    return fixupEncoding(filename);
  }

  tmp = rfc2231getparam(contentDisposition);

  if (tmp) {
    var _filename = rfc2047decode(tmp);

    return fixupEncoding(_filename);
  }

  tmp = toParamRegExp('filename', 'i').exec(contentDisposition);

  if (tmp) {
    tmp = tmp[1];

    var _filename2 = rfc2616unquote(tmp);

    _filename2 = rfc2047decode(_filename2);
    return fixupEncoding(_filename2);
  }

  function toParamRegExp(attributePattern, flags) {
    return new RegExp('(?:^|;)\\s*' + attributePattern + '\\s*=\\s*' + '(' + '[^";\\s][^;\\s]*' + '|' + '"(?:[^"\\\\]|\\\\"?)+"?' + ')', flags);
  }

  function textdecode(encoding, value) {
    if (encoding) {
      if (!/^[\x00-\xFF]+$/.test(value)) {
        return value;
      }

      try {
        var decoder = new TextDecoder(encoding, {
          fatal: true
        });
        var bytes = Array.from(value, function (ch) {
          return ch.charCodeAt(0) & 0xFF;
        });
        value = decoder.decode(new Uint8Array(bytes));
        needsEncodingFixup = false;
      } catch (e) {
        if (/^utf-?8$/i.test(encoding)) {
          try {
            value = decodeURIComponent(escape(value));
            needsEncodingFixup = false;
          } catch (err) {}
        }
      }
    }

    return value;
  }

  function fixupEncoding(value) {
    if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
      value = textdecode('utf-8', value);

      if (needsEncodingFixup) {
        value = textdecode('iso-8859-1', value);
      }
    }

    return value;
  }

  function rfc2231getparam(contentDisposition) {
    var matches = [],
        match;
    var iter = toParamRegExp('filename\\*((?!0\\d)\\d+)(\\*?)', 'ig');

    while ((match = iter.exec(contentDisposition)) !== null) {
      var _match = match,
          _match2 = _slicedToArray(_match, 4),
          n = _match2[1],
          quot = _match2[2],
          part = _match2[3];

      n = parseInt(n, 10);

      if (n in matches) {
        if (n === 0) {
          break;
        }

        continue;
      }

      matches[n] = [quot, part];
    }

    var parts = [];

    for (var n = 0; n < matches.length; ++n) {
      if (!(n in matches)) {
        break;
      }

      var _matches$n = _slicedToArray(matches[n], 2),
          quot = _matches$n[0],
          part = _matches$n[1];

      part = rfc2616unquote(part);

      if (quot) {
        part = unescape(part);

        if (n === 0) {
          part = rfc5987decode(part);
        }
      }

      parts.push(part);
    }

    return parts.join('');
  }

  function rfc2616unquote(value) {
    if (value.startsWith('"')) {
      var parts = value.slice(1).split('\\"');

      for (var i = 0; i < parts.length; ++i) {
        var quotindex = parts[i].indexOf('"');

        if (quotindex !== -1) {
          parts[i] = parts[i].slice(0, quotindex);
          parts.length = i + 1;
        }

        parts[i] = parts[i].replace(/\\(.)/g, '$1');
      }

      value = parts.join('"');
    }

    return value;
  }

  function rfc5987decode(extvalue) {
    var encodingend = extvalue.indexOf('\'');

    if (encodingend === -1) {
      return extvalue;
    }

    var encoding = extvalue.slice(0, encodingend);
    var langvalue = extvalue.slice(encodingend + 1);
    var value = langvalue.replace(/^[^']*'/, '');
    return textdecode(encoding, value);
  }

  function rfc2047decode(value) {
    if (!value.startsWith('=?') || /[\x00-\x19\x80-\xff]/.test(value)) {
      return value;
    }

    return value.replace(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function (_, charset, encoding, text) {
      if (encoding === 'q' || encoding === 'Q') {
        text = text.replace(/_/g, ' ');
        text = text.replace(/=([0-9a-fA-F]{2})/g, function (_, hex) {
          return String.fromCharCode(parseInt(hex, 16));
        });
        return textdecode(charset, text);
      }

      try {
        text = atob(text);
      } catch (e) {}

      return textdecode(charset, text);
    });
  }

  return '';
}

/***/ }),
/* 168 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFNetworkStream = void 0;

var _regenerator = _interopRequireDefault(__w_pdfjs_require__(148));

var _util = __w_pdfjs_require__(1);

var _network_utils = __w_pdfjs_require__(166);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

;
var OK_RESPONSE = 200;
var PARTIAL_CONTENT_RESPONSE = 206;

function getArrayBuffer(xhr) {
  var data = xhr.response;

  if (typeof data !== 'string') {
    return data;
  }

  var array = (0, _util.stringToBytes)(data);
  return array.buffer;
}

var NetworkManager =
/*#__PURE__*/
function () {
  function NetworkManager(url, args) {
    _classCallCheck(this, NetworkManager);

    this.url = url;
    args = args || {};
    this.isHttp = /^https?:/i.test(url);
    this.httpHeaders = this.isHttp && args.httpHeaders || {};
    this.withCredentials = args.withCredentials || false;

    this.getXhr = args.getXhr || function NetworkManager_getXhr() {
      return new XMLHttpRequest();
    };

    this.currXhrId = 0;
    this.pendingRequests = Object.create(null);
  }

  _createClass(NetworkManager, [{
    key: "requestRange",
    value: function requestRange(begin, end, listeners) {
      var args = {
        begin: begin,
        end: end
      };

      for (var prop in listeners) {
        args[prop] = listeners[prop];
      }

      return this.request(args);
    }
  }, {
    key: "requestFull",
    value: function requestFull(listeners) {
      return this.request(listeners);
    }
  }, {
    key: "request",
    value: function request(args) {
      var xhr = this.getXhr();
      var xhrId = this.currXhrId++;
      var pendingRequest = this.pendingRequests[xhrId] = {
        xhr: xhr
      };
      xhr.open('GET', this.url);
      xhr.withCredentials = this.withCredentials;

      for (var property in this.httpHeaders) {
        var value = this.httpHeaders[property];

        if (typeof value === 'undefined') {
          continue;
        }

        xhr.setRequestHeader(property, value);
      }

      if (this.isHttp && 'begin' in args && 'end' in args) {
        xhr.setRequestHeader('Range', "bytes=".concat(args.begin, "-").concat(args.end - 1));
        pendingRequest.expectedStatus = PARTIAL_CONTENT_RESPONSE;
      } else {
        pendingRequest.expectedStatus = OK_RESPONSE;
      }

      xhr.responseType = 'arraybuffer';

      if (args.onError) {
        xhr.onerror = function (evt) {
          args.onError(xhr.status);
        };
      }

      xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
      xhr.onprogress = this.onProgress.bind(this, xhrId);
      pendingRequest.onHeadersReceived = args.onHeadersReceived;
      pendingRequest.onDone = args.onDone;
      pendingRequest.onError = args.onError;
      pendingRequest.onProgress = args.onProgress;
      xhr.send(null);
      return xhrId;
    }
  }, {
    key: "onProgress",
    value: function onProgress(xhrId, evt) {
      var pendingRequest = this.pendingRequests[xhrId];

      if (!pendingRequest) {
        return;
      }

      if (pendingRequest.onProgress) {
        pendingRequest.onProgress(evt);
      }
    }
  }, {
    key: "onStateChange",
    value: function onStateChange(xhrId, evt) {
      var pendingRequest = this.pendingRequests[xhrId];

      if (!pendingRequest) {
        return;
      }

      var xhr = pendingRequest.xhr;

      if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
        pendingRequest.onHeadersReceived();
        delete pendingRequest.onHeadersReceived;
      }

      if (xhr.readyState !== 4) {
        return;
      }

      if (!(xhrId in this.pendingRequests)) {
        return;
      }

      delete this.pendingRequests[xhrId];

      if (xhr.status === 0 && this.isHttp) {
        if (pendingRequest.onError) {
          pendingRequest.onError(xhr.status);
        }

        return;
      }

      var xhrStatus = xhr.status || OK_RESPONSE;
      var ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;

      if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
        if (pendingRequest.onError) {
          pendingRequest.onError(xhr.status);
        }

        return;
      }

      var chunk = getArrayBuffer(xhr);

      if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
        var rangeHeader = xhr.getResponseHeader('Content-Range');
        var matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
        pendingRequest.onDone({
          begin: parseInt(matches[1], 10),
          chunk: chunk
        });
      } else if (chunk) {
        pendingRequest.onDone({
          begin: 0,
          chunk: chunk
        });
      } else if (pendingRequest.onError) {
        pendingRequest.onError(xhr.status);
      }
    }
  }, {
    key: "hasPendingRequests",
    value: function hasPendingRequests() {
      for (var xhrId in this.pendingRequests) {
        return true;
      }

      return false;
    }
  }, {
    key: "getRequestXhr",
    value: function getRequestXhr(xhrId) {
      return this.pendingRequests[xhrId].xhr;
    }
  }, {
    key: "isPendingRequest",
    value: function isPendingRequest(xhrId) {
      return xhrId in this.pendingRequests;
    }
  }, {
    key: "abortAllRequests",
    value: function abortAllRequests() {
      for (var xhrId in this.pendingRequests) {
        this.abortRequest(xhrId | 0);
      }
    }
  }, {
    key: "abortRequest",
    value: function abortRequest(xhrId) {
      var xhr = this.pendingRequests[xhrId].xhr;
      delete this.pendingRequests[xhrId];
      xhr.abort();
    }
  }]);

  return NetworkManager;
}();

var PDFNetworkStream =
/*#__PURE__*/
function () {
  function PDFNetworkStream(source) {
    _classCallCheck(this, PDFNetworkStream);

    this._source = source;
    this._manager = new NetworkManager(source.url, {
      httpHeaders: source.httpHeaders,
      withCredentials: source.withCredentials
    });
    this._rangeChunkSize = source.rangeChunkSize;
    this._fullRequestReader = null;
    this._rangeRequestReaders = [];
  }

  _createClass(PDFNetworkStream, [{
    key: "_onRangeRequestReaderClosed",
    value: function _onRangeRequestReaderClosed(reader) {
      var i = this._rangeRequestReaders.indexOf(reader);

      if (i >= 0) {
        this._rangeRequestReaders.splice(i, 1);
      }
    }
  }, {
    key: "getFullReader",
    value: function getFullReader() {
      (0, _util.assert)(!this._fullRequestReader);
      this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._source);
      return this._fullRequestReader;
    }
  }, {
    key: "getRangeReader",
    value: function getRangeReader(begin, end) {
      var reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
      reader.onClosed = this._onRangeRequestReaderClosed.bind(this);

      this._rangeRequestReaders.push(reader);

      return reader;
    }
  }, {
    key: "cancelAllRequests",
    value: function cancelAllRequests(reason) {
      if (this._fullRequestReader) {
        this._fullRequestReader.cancel(reason);
      }

      var readers = this._rangeRequestReaders.slice(0);

      readers.forEach(function (reader) {
        reader.cancel(reason);
      });
    }
  }]);

  return PDFNetworkStream;
}();

exports.PDFNetworkStream = PDFNetworkStream;

var PDFNetworkStreamFullRequestReader =
/*#__PURE__*/
function () {
  function PDFNetworkStreamFullRequestReader(manager, source) {
    _classCallCheck(this, PDFNetworkStreamFullRequestReader);

    this._manager = manager;
    var args = {
      onHeadersReceived: this._onHeadersReceived.bind(this),
      onDone: this._onDone.bind(this),
      onError: this._onError.bind(this),
      onProgress: this._onProgress.bind(this)
    };
    this._url = source.url;
    this._fullRequestId = manager.requestFull(args);
    this._headersReceivedCapability = (0, _util.createPromiseCapability)();
    this._disableRange = source.disableRange || false;
    this._contentLength = source.length;
    this._rangeChunkSize = source.rangeChunkSize;

    if (!this._rangeChunkSize && !this._disableRange) {
      this._disableRange = true;
    }

    this._isStreamingSupported = false;
    this._isRangeSupported = false;
    this._cachedChunks = [];
    this._requests = [];
    this._done = false;
    this._storedError = undefined;
    this._filename = null;
    this.onProgress = null;
  }

  _createClass(PDFNetworkStreamFullRequestReader, [{
    key: "_onHeadersReceived",
    value: function _onHeadersReceived() {
      var fullRequestXhrId = this._fullRequestId;

      var fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);

      var getResponseHeader = function getResponseHeader(name) {
        return fullRequestXhr.getResponseHeader(name);
      };

      var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
        getResponseHeader: getResponseHeader,
        isHttp: this._manager.isHttp,
        rangeChunkSize: this._rangeChunkSize,
        disableRange: this._disableRange
      }),
          allowRangeRequests = _validateRangeRequest.allowRangeRequests,
          suggestedLength = _validateRangeRequest.suggestedLength;

      if (allowRangeRequests) {
        this._isRangeSupported = true;
      }

      this._contentLength = suggestedLength || this._contentLength;
      this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);

      if (this._isRangeSupported) {
        this._manager.abortRequest(fullRequestXhrId);
      }

      this._headersReceivedCapability.resolve();
    }
  }, {
    key: "_onDone",
    value: function _onDone(args) {
      if (args) {
        if (this._requests.length > 0) {
          var requestCapability = this._requests.shift();

          requestCapability.resolve({
            value: args.chunk,
            done: false
          });
        } else {
          this._cachedChunks.push(args.chunk);
        }
      }

      this._done = true;

      if (this._cachedChunks.length > 0) {
        return;
      }

      this._requests.forEach(function (requestCapability) {
        requestCapability.resolve({
          value: undefined,
          done: true
        });
      });

      this._requests = [];
    }
  }, {
    key: "_onError",
    value: function _onError(status) {
      var url = this._url;
      var exception = (0, _network_utils.createResponseStatusError)(status, url);
      this._storedError = exception;

      this._headersReceivedCapability.reject(exception);

      this._requests.forEach(function (requestCapability) {
        requestCapability.reject(exception);
      });

      this._requests = [];
      this._cachedChunks = [];
    }
  }, {
    key: "_onProgress",
    value: function _onProgress(data) {
      if (this.onProgress) {
        this.onProgress({
          loaded: data.loaded,
          total: data.lengthComputable ? data.total : this._contentLength
        });
      }
    }
  }, {
    key: "read",
    value: function () {
      var _read = _asyncToGenerator(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee() {
        var chunk, requestCapability;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this._storedError) {
                  _context.next = 2;
                  break;
                }

                throw this._storedError;

              case 2:
                if (!(this._cachedChunks.length > 0)) {
                  _context.next = 5;
                  break;
                }

                chunk = this._cachedChunks.shift();
                return _context.abrupt("return", {
                  value: chunk,
                  done: false
                });

              case 5:
                if (!this._done) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", {
                  value: undefined,
                  done: true
                });

              case 7:
                requestCapability = (0, _util.createPromiseCapability)();

                this._requests.push(requestCapability);

                return _context.abrupt("return", requestCapability.promise);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function read() {
        return _read.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: "cancel",
    value: function cancel(reason) {
      this._done = true;

      this._headersReceivedCapability.reject(reason);

      this._requests.forEach(function (requestCapability) {
        requestCapability.resolve({
          value: undefined,
          done: true
        });
      });

      this._requests = [];

      if (this._manager.isPendingRequest(this._fullRequestId)) {
        this._manager.abortRequest(this._fullRequestId);
      }

      this._fullRequestReader = null;
    }
  }, {
    key: "filename",
    get: function get() {
      return this._filename;
    }
  }, {
    key: "isRangeSupported",
    get: function get() {
      return this._isRangeSupported;
    }
  }, {
    key: "isStreamingSupported",
    get: function get() {
      return this._isStreamingSupported;
    }
  }, {
    key: "contentLength",
    get: function get() {
      return this._contentLength;
    }
  }, {
    key: "headersReady",
    get: function get() {
      return this._headersReceivedCapability.promise;
    }
  }]);

  return PDFNetworkStreamFullRequestReader;
}();

var PDFNetworkStreamRangeRequestReader =
/*#__PURE__*/
function () {
  function PDFNetworkStreamRangeRequestReader(manager, begin, end) {
    _classCallCheck(this, PDFNetworkStreamRangeRequestReader);

    this._manager = manager;
    var args = {
      onDone: this._onDone.bind(this),
      onProgress: this._onProgress.bind(this)
    };
    this._requestId = manager.requestRange(begin, end, args);
    this._requests = [];
    this._queuedChunk = null;
    this._done = false;
    this.onProgress = null;
    this.onClosed = null;
  }

  _createClass(PDFNetworkStreamRangeRequestReader, [{
    key: "_close",
    value: function _close() {
      if (this.onClosed) {
        this.onClosed(this);
      }
    }
  }, {
    key: "_onDone",
    value: function _onDone(data) {
      var chunk = data.chunk;

      if (this._requests.length > 0) {
        var requestCapability = this._requests.shift();

        requestCapability.resolve({
          value: chunk,
          done: false
        });
      } else {
        this._queuedChunk = chunk;
      }

      this._done = true;

      this._requests.forEach(function (requestCapability) {
        requestCapability.resolve({
          value: undefined,
          done: true
        });
      });

      this._requests = [];

      this._close();
    }
  }, {
    key: "_onProgress",
    value: function _onProgress(evt) {
      if (!this.isStreamingSupported && this.onProgress) {
        this.onProgress({
          loaded: evt.loaded
        });
      }
    }
  }, {
    key: "read",
    value: function () {
      var _read2 = _asyncToGenerator(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee2() {
        var chunk, requestCapability;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this._queuedChunk !== null)) {
                  _context2.next = 4;
                  break;
                }

                chunk = this._queuedChunk;
                this._queuedChunk = null;
                return _context2.abrupt("return", {
                  value: chunk,
                  done: false
                });

              case 4:
                if (!this._done) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return", {
                  value: undefined,
                  done: true
                });

              case 6:
                requestCapability = (0, _util.createPromiseCapability)();

                this._requests.push(requestCapability);

                return _context2.abrupt("return", requestCapability.promise);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function read() {
        return _read2.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: "cancel",
    value: function cancel(reason) {
      this._done = true;

      this._requests.forEach(function (requestCapability) {
        requestCapability.resolve({
          value: undefined,
          done: true
        });
      });

      this._requests = [];

      if (this._manager.isPendingRequest(this._requestId)) {
        this._manager.abortRequest(this._requestId);
      }

      this._close();
    }
  }, {
    key: "isStreamingSupported",
    get: function get() {
      return false;
    }
  }]);

  return PDFNetworkStreamRangeRequestReader;
}();

/***/ }),
/* 169 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFFetchStream = void 0;

var _regenerator = _interopRequireDefault(__w_pdfjs_require__(148));

var _util = __w_pdfjs_require__(1);

var _network_utils = __w_pdfjs_require__(166);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function createFetchOptions(headers, withCredentials, abortController) {
  return {
    method: 'GET',
    headers: headers,
    signal: abortController && abortController.signal,
    mode: 'cors',
    credentials: withCredentials ? 'include' : 'same-origin',
    redirect: 'follow'
  };
}

var PDFFetchStream =
/*#__PURE__*/
function () {
  function PDFFetchStream(source) {
    _classCallCheck(this, PDFFetchStream);

    this.source = source;
    this.isHttp = /^https?:/i.test(source.url);
    this.httpHeaders = this.isHttp && source.httpHeaders || {};
    this._fullRequestReader = null;
    this._rangeRequestReaders = [];
  }

  _createClass(PDFFetchStream, [{
    key: "getFullReader",
    value: function getFullReader() {
      (0, _util.assert)(!this._fullRequestReader);
      this._fullRequestReader = new PDFFetchStreamReader(this);
      return this._fullRequestReader;
    }
  }, {
    key: "getRangeReader",
    value: function getRangeReader(begin, end) {
      if (end <= this._progressiveDataLength) {
        return null;
      }

      var reader = new PDFFetchStreamRangeReader(this, begin, end);

      this._rangeRequestReaders.push(reader);

      return reader;
    }
  }, {
    key: "cancelAllRequests",
    value: function cancelAllRequests(reason) {
      if (this._fullRequestReader) {
        this._fullRequestReader.cancel(reason);
      }

      var readers = this._rangeRequestReaders.slice(0);

      readers.forEach(function (reader) {
        reader.cancel(reason);
      });
    }
  }, {
    key: "_progressiveDataLength",
    get: function get() {
      return this._fullRequestReader ? this._fullRequestReader._loaded : 0;
    }
  }]);

  return PDFFetchStream;
}();

exports.PDFFetchStream = PDFFetchStream;

var PDFFetchStreamReader =
/*#__PURE__*/
function () {
  function PDFFetchStreamReader(stream) {
    var _this = this;

    _classCallCheck(this, PDFFetchStreamReader);

    this._stream = stream;
    this._reader = null;
    this._loaded = 0;
    this._filename = null;
    var source = stream.source;
    this._withCredentials = source.withCredentials || false;
    this._contentLength = source.length;
    this._headersCapability = (0, _util.createPromiseCapability)();
    this._disableRange = source.disableRange || false;
    this._rangeChunkSize = source.rangeChunkSize;

    if (!this._rangeChunkSize && !this._disableRange) {
      this._disableRange = true;
    }

    if (typeof AbortController !== 'undefined') {
      this._abortController = new AbortController();
    }

    this._isStreamingSupported = !source.disableStream;
    this._isRangeSupported = !source.disableRange;
    this._headers = new Headers();

    for (var property in this._stream.httpHeaders) {
      var value = this._stream.httpHeaders[property];

      if (typeof value === 'undefined') {
        continue;
      }

      this._headers.append(property, value);
    }

    var url = source.url;
    fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then(function (response) {
      if (!(0, _network_utils.validateResponseStatus)(response.status)) {
        throw (0, _network_utils.createResponseStatusError)(response.status, url);
      }

      _this._reader = response.body.getReader();

      _this._headersCapability.resolve();

      var getResponseHeader = function getResponseHeader(name) {
        return response.headers.get(name);
      };

      var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
        getResponseHeader: getResponseHeader,
        isHttp: _this._stream.isHttp,
        rangeChunkSize: _this._rangeChunkSize,
        disableRange: _this._disableRange
      }),
          allowRangeRequests = _validateRangeRequest.allowRangeRequests,
          suggestedLength = _validateRangeRequest.suggestedLength;

      _this._isRangeSupported = allowRangeRequests;
      _this._contentLength = suggestedLength || _this._contentLength;
      _this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);

      if (!_this._isStreamingSupported && _this._isRangeSupported) {
        _this.cancel(new _util.AbortException('Streaming is disabled.'));
      }
    })["catch"](this._headersCapability.reject);
    this.onProgress = null;
  }

  _createClass(PDFFetchStreamReader, [{
    key: "read",
    value: function () {
      var _read = _asyncToGenerator(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee() {
        var _ref, value, done, buffer;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._headersCapability.promise;

              case 2:
                _context.next = 4;
                return this._reader.read();

              case 4:
                _ref = _context.sent;
                value = _ref.value;
                done = _ref.done;

                if (!done) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", {
                  value: value,
                  done: done
                });

              case 9:
                this._loaded += value.byteLength;

                if (this.onProgress) {
                  this.onProgress({
                    loaded: this._loaded,
                    total: this._contentLength
                  });
                }

                buffer = new Uint8Array(value).buffer;
                return _context.abrupt("return", {
                  value: buffer,
                  done: false
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function read() {
        return _read.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: "cancel",
    value: function cancel(reason) {
      if (this._reader) {
        this._reader.cancel(reason);
      }

      if (this._abortController) {
        this._abortController.abort();
      }
    }
  }, {
    key: "headersReady",
    get: function get() {
      return this._headersCapability.promise;
    }
  }, {
    key: "filename",
    get: function get() {
      return this._filename;
    }
  }, {
    key: "contentLength",
    get: function get() {
      return this._contentLength;
    }
  }, {
    key: "isRangeSupported",
    get: function get() {
      return this._isRangeSupported;
    }
  }, {
    key: "isStreamingSupported",
    get: function get() {
      return this._isStreamingSupported;
    }
  }]);

  return PDFFetchStreamReader;
}();

var PDFFetchStreamRangeReader =
/*#__PURE__*/
function () {
  function PDFFetchStreamRangeReader(stream, begin, end) {
    var _this2 = this;

    _classCallCheck(this, PDFFetchStreamRangeReader);

    this._stream = stream;
    this._reader = null;
    this._loaded = 0;
    var source = stream.source;
    this._withCredentials = source.withCredentials || false;
    this._readCapability = (0, _util.createPromiseCapability)();
    this._isStreamingSupported = !source.disableStream;

    if (typeof AbortController !== 'undefined') {
      this._abortController = new AbortController();
    }

    this._headers = new Headers();

    for (var property in this._stream.httpHeaders) {
      var value = this._stream.httpHeaders[property];

      if (typeof value === 'undefined') {
        continue;
      }

      this._headers.append(property, value);
    }

    this._headers.append('Range', "bytes=".concat(begin, "-").concat(end - 1));

    var url = source.url;
    fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then(function (response) {
      if (!(0, _network_utils.validateResponseStatus)(response.status)) {
        throw (0, _network_utils.createResponseStatusError)(response.status, url);
      }

      _this2._readCapability.resolve();

      _this2._reader = response.body.getReader();
    });
    this.onProgress = null;
  }

  _createClass(PDFFetchStreamRangeReader, [{
    key: "read",
    value: function () {
      var _read2 = _asyncToGenerator(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee2() {
        var _ref2, value, done, buffer;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._readCapability.promise;

              case 2:
                _context2.next = 4;
                return this._reader.read();

              case 4:
                _ref2 = _context2.sent;
                value = _ref2.value;
                done = _ref2.done;

                if (!done) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return", {
                  value: value,
                  done: done
                });

              case 9:
                this._loaded += value.byteLength;

                if (this.onProgress) {
                  this.onProgress({
                    loaded: this._loaded
                  });
                }

                buffer = new Uint8Array(value).buffer;
                return _context2.abrupt("return", {
                  value: buffer,
                  done: false
                });

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function read() {
        return _read2.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: "cancel",
    value: function cancel(reason) {
      if (this._reader) {
        this._reader.cancel(reason);
      }

      if (this._abortController) {
        this._abortController.abort();
      }
    }
  }, {
    key: "isStreamingSupported",
    get: function get() {
      return this._isStreamingSupported;
    }
  }]);

  return PDFFetchStreamRangeReader;
}();

/***/ })
/******/ ]);
});
//# sourceMappingURL=pdf.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(340).Buffer, __webpack_require__(49), __webpack_require__(126)))

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 744 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 745 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 746 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 747 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 748 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 749 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__(751);
var util = __webpack_require__(752);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__(753);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return punycode;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(210)(module), __webpack_require__(49)))

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(754);
exports.encode = exports.stringify = __webpack_require__(755);


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function() {
  return new Worker(__webpack_require__.p + "30c6d840750438921d3c.worker.js");
};

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[(_vm.material != null)?[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"btn-back margin-right-10"},[_c('a',{staticClass:"router-link-active",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.$router.push('/materials/')}}},[_vm._v("Назад")])]),_vm._v(" "),(_vm.material.new)?_c('p',{staticClass:"caption-help margin-right-10"},[_vm._v("Добавление материала")]):_vm._e(),_vm._v(" "),(!_vm.material.new)?_c('p',{staticClass:"caption-help"},[_vm._v("Редактирование материала #"+_vm._s(_vm.material.Id))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[_c('div',{staticClass:"btns flex"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.savingInProgress},on:{"click":function($event){return _vm.saveMaterial()}}},[_vm._v("Сохранить")]),_vm._v(" "),(_vm.material.ConvectorStatus !== 1)?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteMaterial()}}},[_vm._v("\n                        Удалить\n                    ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page"},[_c('div',{staticClass:"body-panel"},[_c('div',{staticClass:"block-in-page closed"},[_c('h2',{staticClass:"margin-bottom-10 block-in-page-collapce"},[_vm._v("Общие настройки")]),_vm._v(" "),_c('div',{staticClass:"block-in-page-detail"},[_c('div',{staticClass:"form-field"},[_vm._m(0),_vm._v(" "),_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.material.Name),expression:"material.Name"}],class:['input-memo', {'input-error': _vm.errors.has('Name')}],staticStyle:{"height":"60px"},attrs:{"name":"Name","rows":"2"},domProps:{"value":(_vm.material.Name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.material, "Name", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Name')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(1),_vm._v(" "),_c('froala-editor',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"Description",class:[{'input-error': _vm.errors.has('Description')}],attrs:{"name":"Description","height":"200","imageUploadURL":_vm.config.apiUrl + '/api/materials/uploadFiles?fileType=Image&materialId=' + _vm.material.Id + '&projectId=' + _vm.material.ProjectId},model:{value:(_vm.material.Description),callback:function ($$v) {_vm.$set(_vm.material, "Description", $$v)},expression:"material.Description"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Description')))])],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Категория\n                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.material.Category),expression:"material.Category"}],class:['input-text', {'input-error': _vm.errors.has('Category')}],attrs:{"name":"Category","type":"text"},domProps:{"value":(_vm.material.Category)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.material, "Category", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Расположение материала\n                            ")]),_vm._v(" "),_c('drop-down',{attrs:{"withSelectItem":'true',"items":_vm.folders,"dataField":'Id',"textField":'Name'},model:{value:(_vm.material.FolderId),callback:function ($$v) {_vm.$set(_vm.material, "FolderId", $$v)},expression:"material.FolderId"}})],1),_vm._v(" "),_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-20"}),_vm._v(" "),(!_vm.material.new)?[_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.material.Status),expression:"material.Status",modifiers:{"number":true}}],staticClass:"input-checkbox",attrs:{"name":"Status","id":"St2","value":"2","type":"radio"},domProps:{"checked":_vm._q(_vm.material.Status,_vm._n("2"))},on:{"change":[function($event){_vm.$set(_vm.material, "Status", _vm._n("2"))},function($event){return _vm.onStatusChanged($event)}]}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"St2"}},[_vm._v("Активен")])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.material.Status),expression:"material.Status",modifiers:{"number":true}}],staticClass:"input-checkbox",attrs:{"name":"Status","id":"St3","value":"3","type":"radio"},domProps:{"checked":_vm._q(_vm.material.Status,_vm._n("3"))},on:{"change":[function($event){_vm.$set(_vm.material, "Status", _vm._n("3"))},function($event){return _vm.onStatusChanged($event)}]}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"St3"}},[_vm._v("В архиве")])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-20"}),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.material.LikesEnabled),expression:"material.LikesEnabled"}],staticClass:"input-checkbox",attrs:{"id":"LikesEnabled","name":"LikesEnabled","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.material.LikesEnabled)?_vm._i(_vm.material.LikesEnabled,"true")>-1:(_vm.material.LikesEnabled)},on:{"change":function($event){var $$a=_vm.material.LikesEnabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.material, "LikesEnabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.material, "LikesEnabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.material, "LikesEnabled", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"LikesEnabled"}},[_vm._v("Разрешить ставить лайки")])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.material.DisplayViews),expression:"material.DisplayViews"}],staticClass:"input-checkbox",attrs:{"id":"DisplayViews","name":"DisplayViews","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.material.DisplayViews)?_vm._i(_vm.material.DisplayViews,"true")>-1:(_vm.material.DisplayViews)},on:{"change":function($event){var $$a=_vm.material.DisplayViews,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.material, "DisplayViews", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.material, "DisplayViews", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.material, "DisplayViews", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"DisplayViews"}},[_vm._v("Отображать просмотры")])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Последовательность прохождения\n                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.material.FilesOrderLocked),expression:"material.FilesOrderLocked"}],staticClass:"input-radio",attrs:{"id":"FilesOrderLocked1","name":"FilesOrderLocked","value":"false","type":"radio"},domProps:{"checked":_vm._q(_vm.material.FilesOrderLocked,"false")},on:{"change":function($event){return _vm.$set(_vm.material, "FilesOrderLocked", "false")}}}),_vm._v(" "),_c('label',{staticClass:"input-radio-lbl",attrs:{"for":"FilesOrderLocked1"}},[_vm._v("Произвольная")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.material.FilesOrderLocked),expression:"material.FilesOrderLocked"}],staticClass:"input-radio",attrs:{"id":"FilesOrderLocked2","name":"FilesOrderLocked","value":"true","type":"radio"},domProps:{"checked":_vm._q(_vm.material.FilesOrderLocked,"true")},on:{"change":function($event){return _vm.$set(_vm.material, "FilesOrderLocked", "true")}}}),_vm._v(" "),_c('label',{staticClass:"input-radio-lbl",attrs:{"for":"FilesOrderLocked2"}},[_vm._v("Фиксированная")])]),_vm._v(" "),_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{attrs:{"name":"StartDateFormatted"},model:{value:(_vm.material.StartDateFormatted),callback:function ($$v) {_vm.$set(_vm.material, "StartDateFormatted", $$v)},expression:"material.StartDateFormatted"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{attrs:{"name":"EndDateFormatted"},model:{value:(_vm.material.EndDateFormatted),callback:function ($$v) {_vm.$set(_vm.material, "EndDateFormatted", $$v)},expression:"material.EndDateFormatted"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Наименование кнопки просмотра\n                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.material.ViewButtonName),expression:"material.ViewButtonName"}],class:['input-text', {'input-error': _vm.errors.has('ViewButtonName')}],attrs:{"name":"ViewButtonName","placeholder":"по умолчанию - Просмотр","type":"text"},domProps:{"value":(_vm.material.ViewButtonName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.material, "ViewButtonName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('ViewButtonName')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Наименование кнопки теста\n                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.material.TestButtonName),expression:"material.TestButtonName"}],class:['input-text', {'input-error': _vm.errors.has('TestButtonName')}],attrs:{"name":"TestButtonName","placeholder":"по умолчанию - Пройти тест","type":"text"},domProps:{"value":(_vm.material.TestButtonName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.material, "TestButtonName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('TestButtonName')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Наименование раздела Курс\n                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.material.CourseTabName),expression:"material.CourseTabName"}],class:['input-text', {'input-error': _vm.errors.has('CourseTabName')}],attrs:{"name":"CourseTabName","placeholder":"по умолчанию - Курс","type":"text"},domProps:{"value":(_vm.material.CourseTabName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.material, "CourseTabName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('CourseTabName')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Наименование раздела тест\n                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.material.TestTabName),expression:"material.TestTabName"}],class:['input-text', {'input-error': _vm.errors.has('TestTabName')}],attrs:{"name":"TestTabName","placeholder":"по умолчанию - Тест","type":"text"},domProps:{"value":(_vm.material.TestTabName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.material, "TestTabName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('TestTabName')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Наименование раздела рейтинга\n                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.material.RatingTabName),expression:"material.RatingTabName"}],class:['input-text', {'input-error': _vm.errors.has('RatingTabName')}],attrs:{"name":"RatingTabName","placeholder":"по умолчанию - Рейтинг","type":"text"},domProps:{"value":(_vm.material.RatingTabName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.material, "RatingTabName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('RatingTabName')))])])],2)]),_vm._v(" "),_c('div',{staticClass:"block-in-page closed"},[_c('h2',{staticClass:"margin-bottom-10 block-in-page-collapce"},[_vm._v("Настройка тестирования")]),_vm._v(" "),_c('div',{staticClass:"block-in-page-detail"},[_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.material.TestDisabled),expression:"material.TestDisabled"}],staticClass:"input-checkbox",attrs:{"name":"TestDisabled","id":"TestDisabled","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.material.TestDisabled)?_vm._i(_vm.material.TestDisabled,"true")>-1:(_vm.material.TestDisabled)},on:{"change":[function($event){var $$a=_vm.material.TestDisabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.material, "TestDisabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.material, "TestDisabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.material, "TestDisabled", $$c)}},function($event){$event.stopPropagation();return _vm.toggleTestDisabled.apply(null, arguments)}]}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"TestDisabled"}},[_vm._v("Отключить тест")])]),_vm._v(" "),(!_vm.material.TestDisabled)?[_c('div',{staticClass:"form-field margin-top-20"},[(!_vm.material.new)?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.goToQuestions()}}},[_vm._v("Управление вопросами")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-10"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Тип теста\n                                ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":[{Id: _vm.testTypes.Simple, Name: 'Простой'}, {Id: _vm.testTypes.Interactive, Name: 'Интерактивный'}],"dataField":'Id',"textField":'Name'},model:{value:(_vm.material.TestType),callback:function ($$v) {_vm.$set(_vm.material, "TestType", $$v)},expression:"material.TestType"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Комментарий\n                                ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.material.TestComment),expression:"material.TestComment"}],class:['input-memo', {'input-error': _vm.errors.has('TestComment')}],staticStyle:{"height":"50px"},attrs:{"name":"TestComment","rows":"10"},domProps:{"value":(_vm.material.TestComment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.material, "TestComment", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(4),_vm._v(" "),_c('froala-editor',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"TestGreeting",class:[{'input-error': _vm.errors.has('TestGreeting')}],attrs:{"name":"TestGreeting","height":"150","imageUploadURL":_vm.config.apiUrl + '/api/materials/uploadFiles?fileType=Image&materialId=' + _vm.material.Id + '&projectId=' + _vm.material.ProjectId},model:{value:(_vm.material.TestGreeting),callback:function ($$v) {_vm.$set(_vm.material, "TestGreeting", $$v)},expression:"material.TestGreeting"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('TestGreeting')))])],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Сколько вопросов задать пользователю? (сейчас "+_vm._s(_vm.material.ActiveQuestionsCount)+" активных "+_vm._s(_vm.get_text_ending(_vm.material.ActiveQuestionsCount, ['вопрос','вопроса','вопросов']))+")\n                                ")]),_vm._v(" "),_c('touch-spin',{attrs:{"max":_vm.material.ActiveQuestionsCount},model:{value:(_vm.material.QuestionsToAsk),callback:function ($$v) {_vm.$set(_vm.material, "QuestionsToAsk", $$v)},expression:"material.QuestionsToAsk"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    На сколько вопросов должен ответить пользователь, чтобы сдать тест?\n                                ")]),_vm._v(" "),_c('touch-spin',{attrs:{"max":_vm.MaxQuestionsToPass},model:{value:(_vm.material.QuestionsToPass),callback:function ($$v) {_vm.$set(_vm.material, "QuestionsToPass", $$v)},expression:"material.QuestionsToPass"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.material.RandomOrder),expression:"material.RandomOrder"}],staticClass:"input-checkbox",attrs:{"id":"QuestSort","name":"QuestSort","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.material.RandomOrder)?_vm._i(_vm.material.RandomOrder,"true")>-1:(_vm.material.RandomOrder)},on:{"change":function($event){var $$a=_vm.material.RandomOrder,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.material, "RandomOrder", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.material, "RandomOrder", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.material, "RandomOrder", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"QuestSort"}},[_vm._v("Отображать вопросы в случайном порядке")])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Количество попыток сдачи теста\n                                ")]),_vm._v(" "),_c('touch-spin',{model:{value:(_vm.material.TestAttemptsNumber),callback:function ($$v) {_vm.$set(_vm.material, "TestAttemptsNumber", $$v)},expression:"material.TestAttemptsNumber"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Интервал прохождения теста (ЧЧ:ММ:СС)\n                                ")]),_vm._v(" "),_c('input-time',{class:['input-text', {'input-error': _vm.errors.has('TestAttemptsIntervalFormatted')}],attrs:{"name":"TestAttemptsIntervalFormatted","showSeconds":"true","maxHours":"8760"},on:{"input":function($event){return _vm.onChangeTestAttemptsInterval()}},model:{value:(_vm.material.TestAttemptsIntervalFormatted),callback:function ($$v) {_vm.$set(_vm.material, "TestAttemptsIntervalFormatted", $$v)},expression:"material.TestAttemptsIntervalFormatted"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Время на тест (в минутах)\n                                ")]),_vm._v(" "),_c('touch-spin',{directives:[{name:"validate",rawName:"v-validate",value:({ required: this.testInteractiveRequiredRule }),expression:"{ required: this.testInteractiveRequiredRule }"}],class:['input-text', {'input-error': _vm.errors.has('TestTime')}],attrs:{"name":"TestTime"},model:{value:(_vm.material.TestTime),callback:function ($$v) {_vm.$set(_vm.material, "TestTime", $$v)},expression:"material.TestTime"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('TestTime')))])],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Количество баллов за тест\n                                ")]),_vm._v(" "),_c('touch-spin',{directives:[{name:"validate",rawName:"v-validate",value:({ required: this.testInteractiveRequiredRule }),expression:"{ required: this.testInteractiveRequiredRule }"}],class:['input-text', {'input-error': _vm.errors.has('Bonus')}],attrs:{"name":"Bonus"},model:{value:(_vm.material.Bonus),callback:function ($$v) {_vm.$set(_vm.material, "Bonus", $$v)},expression:"material.Bonus"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Bonus')))])],1),_vm._v(" "),(_vm.material.TestType === _vm.testTypes.Interactive)?[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Стоимость верного ответа\n                                    ")]),_vm._v(" "),_c('touch-spin',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],class:['input-text', {'input-error': _vm.errors.has('TestRightAnswerBonus')}],attrs:{"name":"TestRightAnswerBonus"},model:{value:(_vm.material.TestRightAnswerBonus),callback:function ($$v) {_vm.$set(_vm.material, "TestRightAnswerBonus", $$v)},expression:"material.TestRightAnswerBonus"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('TestRightAnswerBonus')))])],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Стоимость неверного ответа\n                                    ")]),_vm._v(" "),_c('touch-spin',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],class:['input-text', {'input-error': _vm.errors.has('TestWrongAnswerBonus')}],attrs:{"name":"TestWrongAnswerBonus"},model:{value:(_vm.material.TestWrongAnswerBonus),callback:function ($$v) {_vm.$set(_vm.material, "TestWrongAnswerBonus", $$v)},expression:"material.TestWrongAnswerBonus"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('TestWrongAnswerBonus')))])],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Стоимость 1 секунды\n                                    ")]),_vm._v(" "),_c('touch-spin',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],class:['input-text', {'input-error': _vm.errors.has('TestSecondBonus')}],attrs:{"name":"TestSecondBonus","decimals":2,"step":0.01},model:{value:(_vm.material.TestSecondBonus),callback:function ($$v) {_vm.$set(_vm.material, "TestSecondBonus", $$v)},expression:"material.TestSecondBonus"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('TestSecondBonus')))])],1)]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.material.TestDisplayRating),expression:"material.TestDisplayRating"}],staticClass:"input-checkbox",attrs:{"id":"TestDisplayRating","name":"TestDisplayRating","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.material.TestDisplayRating)?_vm._i(_vm.material.TestDisplayRating,"true")>-1:(_vm.material.TestDisplayRating)},on:{"change":function($event){var $$a=_vm.material.TestDisplayRating,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.material, "TestDisplayRating", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.material, "TestDisplayRating", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.material, "TestDisplayRating", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"TestDisplayRating"}},[_vm._v("Показать рейтинг")])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.material.TestDisplayStats),expression:"material.TestDisplayStats"}],staticClass:"input-checkbox",attrs:{"id":"TestDisplayStats","name":"TestDisplayStats","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.material.TestDisplayStats)?_vm._i(_vm.material.TestDisplayStats,"true")>-1:(_vm.material.TestDisplayStats)},on:{"change":function($event){var $$a=_vm.material.TestDisplayStats,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.material, "TestDisplayStats", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.material, "TestDisplayStats", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.material, "TestDisplayStats", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"TestDisplayStats"}},[_vm._v("Показать статистику ответов")])])]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"block-in-page closed"},[_c('h2',{staticClass:"margin-bottom-10 block-in-page-collapce"},[_vm._v("Настройка изображения для сайта")]),_vm._v(" "),_c('div',{staticClass:"block-in-page-detail flex"},[_c('image-setting',{attrs:{"img":_vm.imgSite,"name":'site',"parentImage":true},on:{"onImageViewChanged":_vm.onImageViewChanged}}),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"300px","min-width":"300px","margin-left":"20px"}},[_c('div',{staticClass:"panel-block panel-block-new",staticStyle:{"margin-right":"0"}},[_c('div',{staticClass:"panel-block-img-base"},[_c('div',{staticClass:"panel-block-img"},[(_vm.imgSitePath)?_c('img',{style:(_vm.imageStyleFormatted),attrs:{"src":_vm.imgSitePath,"alt":""}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"panel-block-info"},[_c('p',{staticClass:"panel-block-header margin-bottom-10"},[_vm._v(_vm._s(_vm.material.Name))]),_vm._v(" "),_c('p',{staticClass:"panel-body-desc"},[_vm._v(_vm._s(_vm.material.Description))])]),_vm._v(" "),_c('div',{staticClass:"panel-body-actions"},[_c('button',{staticClass:"btn"},[_vm._v(_vm._s(_vm.material.ViewButtonName || 'Просмотр'))])])])])],1)]),_vm._v(" "),_c('div',{staticClass:"block-in-page closed"},[_c('h2',{staticClass:"margin-bottom-10 block-in-page-collapce"},[_vm._v("Настройка изображения для мобильного приложения")]),_vm._v(" "),_c('div',{staticClass:"block-in-page-detail flex"},[_c('image-setting',{attrs:{"img":_vm.imgMobile,"parentImgPath":_vm.imgSitePath,"name":'mobile'},on:{"onImageViewChanged":_vm.onImageViewChanged}}),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"500px","min-width":"500px","margin-left":"20px"}},[_c('div',{staticClass:"panel-block panel-block-new panel-block-mobile",staticStyle:{"margin-right":"0"}},[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"panel-block-img panel-block-img-mobile"},[(_vm.imgMobilePath)?_c('img',{style:(_vm.imageStyleMobileFormatted),attrs:{"src":_vm.imgMobilePath,"alt":""}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"panel-block-info"},[_c('p',{staticClass:"panel-block-header margin-bottom-10"},[_vm._v(_vm._s(_vm.material.Name))])])]),_vm._v(" "),_c('div',{staticClass:"panel-body-actions"},[_c('button',{staticClass:"btn"},[_vm._v(_vm._s(_vm.material.ViewButtonName || 'Просмотр'))])])])])],1)]),_vm._v(" "),_c('Container',{attrs:{"lock-axis":'y'},on:{"drop":_vm.onDrop}},_vm._l((_vm.materialFilesOrdered),function(materialFile,i){return _c('Draggable',[_c('div',{staticClass:"block-in-page closed"},[_c('h2',{staticClass:"margin-bottom-10 block-in-page-collapce"},[_vm._v(_vm._s(materialFile.Name))]),_vm._v(" "),_c('div',{staticClass:"block-in-page-detail flex"},[_c('div',{staticStyle:{"width":"100%"}},[(materialFile.ActiveContentType !== 1)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                            Тип контента\n                                        ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.activeContentTypes,"dataField":'Id',"textField":'Name'},on:{"change":function($event){return _vm.onActiveContentTypesChange(materialFile)}},model:{value:(materialFile.ActiveContentType),callback:function ($$v) {_vm.$set(materialFile, "ActiveContentType", $$v)},expression:"materialFile.ActiveContentType"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                            Название\n                                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])]),_vm._v(" "),_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(materialFile.Name),expression:"materialFile.Name"}],class:['input-memo', {'input-error': _vm.errors.has('FileName' + i)}],staticStyle:{"height":"60px"},attrs:{"name":'FileName' + i,"rows":"2"},domProps:{"value":(materialFile.Name)},on:{"mousedown":function($event){$event.stopPropagation();},"input":function($event){if($event.target.composing){ return; }_vm.$set(materialFile, "Name", $event.target.value)}}})]),_vm._v(" "),(materialFile.ActiveContentType === 1)?_c('div',{staticClass:"form-field"},[_c('drop-down',{attrs:{"items":[{Id: 1, Name: 'MS PowerPoint презентация (ppt, pptx)'}],"dataField":'Id',"textField":'Name'},model:{value:(materialFile.ActiveContentType),callback:function ($$v) {_vm.$set(materialFile, "ActiveContentType", $$v)},expression:"materialFile.ActiveContentType"}})],1):_vm._e(),_vm._v(" "),(materialFile.ActiveContentType === 2)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                            URL на ролик на youtube (например, https://www.youtube.com/embed/ID)\n                                        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({url: true, youtube: true}),expression:"{url: true, youtube: true}"},{name:"model",rawName:"v-model",value:(materialFile.ContentFileName),expression:"materialFile.ContentFileName"}],class:['input-text', {'input-error': _vm.errors.has('ContentLink' + i)}],attrs:{"name":'ContentLink' + i,"type":"text","data-vv-as":"URL на ролик на youtube"},domProps:{"value":(materialFile.ContentFileName)},on:{"mousedown":function($event){$event.stopPropagation();},"input":function($event){if($event.target.composing){ return; }_vm.$set(materialFile, "ContentFileName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('ContentLink' + i)))])]):_vm._e(),_vm._v(" "),(materialFile.ActiveContentType === 3)?_c('div',{staticClass:"form-field-group margin-top-20 margin-bottom-20"},[_c('div',{staticClass:"form-field"},[_c('div',{staticClass:"file-upload-zone",class:[{'input-error': _vm.errors.has('pdfDropFiles' + i)}]},[_c('input',{ref:'pdfDropFiles' + i,refInFor:true,staticClass:"file-upload-zone-btn",attrs:{"type":"file","accept":".pdf","id":'pdfDropFiles' + i,"name":'pdfDropFiles' + i},on:{"change":function($event){return _vm.onFileChange($event, materialFile)}}}),_vm._v(" "),_c('label',{staticClass:"file-upload-zone-lbl",attrs:{"for":'pdfDropFiles' + i}},[_vm._v("Выберите материал (pdf файл)")])]),_vm._v(" "),(materialFile.ContentFileName != null)?_c('div',{staticClass:"fileList"},[_vm._v("\n                                                Выбран файл: "+_vm._s(materialFile.ContentFileName.replace('uploads/materials/' + _vm.material.ProjectId + '/' + _vm.material.Id + '/', ''))+"\n                                            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"btns flex"},[(materialFile.ContentFileName && !materialFile.DeleteContentFile)?_c('button',{staticClass:"btn btn-delete margin-top-15",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeContentFile(materialFile)}}},[_vm._v("\n                                                    Удалить\n                                                ")]):_vm._e()])])]):_vm._e(),_vm._v(" "),(materialFile.ActiveContentType === 4)?_c('div',{staticClass:"form-field-group margin-top-20 margin-bottom-20"},[_c('div',{staticClass:"form-field"},[_c('input',{ref:'videoDropFiles' + i,refInFor:true,staticClass:"file-upload-zone-btn",attrs:{"type":"file","id":'videoDropFiles' + i,"name":'videoDropFiles' + i,"accept":".mp4"},on:{"change":function($event){return _vm.onVideoFileChange($event, materialFile)}}}),_vm._v(" "),(materialFile.ContentFileName == null)?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){_vm.$refs['videoDropFiles' + i][0].click()}}},[_vm._v("\n                                                Загрузить\n                                            ")]):_vm._e(),_vm._v(" "),(materialFile.ContentFileName != null)?_c('div',{staticClass:"fileList"},[_vm._v("\n                                                Выбран файл: "+_vm._s(materialFile.ContentFileName.replace('uploads/materials/' + _vm.material.ProjectId + '/' + _vm.material.Id + '/', ''))+"\n                                            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"btns flex"},[(materialFile.ContentFileName && !materialFile.DeleteContentFile)?_c('button',{staticClass:"btn btn-delete margin-top-15",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeContentFile(materialFile)}}},[_vm._v("\n                                                    Удалить\n                                                ")]):_vm._e()])])]):_vm._e(),_vm._v(" "),(materialFile.ActiveContentType === 5)?_c('div',{staticClass:"form-field-group margin-top-20 margin-bottom-20"},[_c('div',{staticClass:"form-field"},[_c('div',{staticClass:"file-upload-zone",class:[{'input-error': _vm.errors.has('scormDropFiles' + i)}]},[_c('input',{ref:'scormDropFiles' + i,refInFor:true,staticClass:"file-upload-zone-btn",attrs:{"type":"file","accept":".zip","id":'scormDropFiles' + i,"name":'scormDropFiles' + i},on:{"change":function($event){return _vm.onFileChange($event, materialFile)}}}),_vm._v(" "),_c('label',{staticClass:"file-upload-zone-lbl",attrs:{"for":'scormDropFiles' + i}},[_vm._v("Выберите материал (zip файл)")])]),_vm._v(" "),(materialFile.ContentFileName != null)?_c('div',{staticClass:"fileList"},[_vm._v("\n                                                Выбран файл: "+_vm._s(materialFile.ContentFileName.replace('uploads/materials/' + _vm.material.ProjectId + '/' + _vm.material.Id + '/', ''))+"\n                                            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"btns flex"},[(materialFile.ContentFileName && !materialFile.DeleteContentFile)?_c('button',{staticClass:"btn btn-delete margin-top-15",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeContentFile(materialFile)}}},[_vm._v("\n                                                    Удалить\n                                                ")]):_vm._e()])])]):_vm._e(),_vm._v(" "),(materialFile.ActiveContentType === 5)?_c('div',{staticClass:"form-field margin-bottom-20"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                            Локальный путь к начальной странице scorm (например, /data/index.html)\n                                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"},{name:"model",rawName:"v-model",value:(materialFile.ScormStartPath),expression:"materialFile.ScormStartPath"}],class:['input-text', {'input-error': _vm.errors.has('ScormStartPath' + i)}],attrs:{"name":'ScormStartPath' + i,"type":"text","data-vv-as":"Локальный путь"},domProps:{"value":(materialFile.ScormStartPath)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(materialFile, "ScormStartPath", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('ScormStartPath' + i)))])]):_vm._e(),_vm._v(" "),(materialFile.ActiveContentType === 5)?_c('div',{staticClass:"form-field-group margin-top-20 margin-bottom-20"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                                Изображение-заглушка для scorm-курса\n                                            ")]),_vm._v(" "),_c('input',{ref:'scormStubDropFiles' + i,refInFor:true,staticClass:"file-upload-zone-btn",attrs:{"type":"file","id":'scormStubDropFiles' + i,"name":'scormStubDropFiles' + i,"accept":".jpg,.jpeg,.png"},on:{"change":function($event){return _vm.onScormStubFileChange($event, materialFile)}}}),_vm._v(" "),(materialFile.ScormStubFileName == null)?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){_vm.$refs['scormStubDropFiles' + i][0].click()}}},[_vm._v("\n                                                Загрузить\n                                            ")]):_vm._e(),_vm._v(" "),(materialFile.ScormStubFileName != null)?_c('div',{staticClass:"fileList"},[_vm._v("\n                                                Выбран файл: "+_vm._s(materialFile.ScormStubFileName.replace('uploads/materials/' + _vm.material.ProjectId + '/' + _vm.material.Id + '/', ''))+"\n                                            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"btns flex"},[(materialFile.ScormStubFileName && !materialFile.DeleteScormStubFile)?_c('button',{staticClass:"btn btn-delete margin-top-15",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeScormStubFile(materialFile)}}},[_vm._v("\n                                                    Удалить\n                                                ")]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteFileMaterial(i)}}},[_vm._v("Удалить материал")])])])])])}),1),_vm._v(" "),(!_vm.material.TestDisabled)?[_c('div',{staticClass:"block-in-page closed"},[_c('h2',{staticClass:"margin-bottom-10 block-in-page-collapce"},[_vm._v("Выдать сертификат")]),_vm._v(" "),_c('div',{staticClass:"block-in-page-detail"},[_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.material.CertificateSettings.Issuance.Actived),expression:"material.CertificateSettings.Issuance.Actived"}],staticClass:"input-checkbox",attrs:{"name":"SertActived","id":"SertActived","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.material.CertificateSettings.Issuance.Actived)?_vm._i(_vm.material.CertificateSettings.Issuance.Actived,"true")>-1:(_vm.material.CertificateSettings.Issuance.Actived)},on:{"change":function($event){var $$a=_vm.material.CertificateSettings.Issuance.Actived,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.material.CertificateSettings.Issuance, "Actived", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.material.CertificateSettings.Issuance, "Actived", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.material.CertificateSettings.Issuance, "Actived", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"SertActived"}},[_vm._v("Активировать")])]),_vm._v(" "),(_vm.material.CertificateSettings.Issuance.Actived)?[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Перед сдачей\n                                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.material.CertificateSettings.Issuance.data.front),expression:"material.CertificateSettings.Issuance.data.front"}],class:['input-text', {'input-error': _vm.errors.has('Sertificate')}],attrs:{"name":"SertBeforeSurrender","type":"text"},domProps:{"value":(_vm.material.CertificateSettings.Issuance.data.front)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.material.CertificateSettings.Issuance.data, "front", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        До выдачи\n                                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.material.CertificateSettings.Issuance.data.before),expression:"material.CertificateSettings.Issuance.data.before"}],class:['input-text', {'input-error': _vm.errors.has('Sertificate')}],attrs:{"name":"SertBeforeIssuance","type":"text"},domProps:{"value":(_vm.material.CertificateSettings.Issuance.data.before)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.material.CertificateSettings.Issuance.data, "before", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        После выдачи\n                                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.material.CertificateSettings.Issuance.data.after),expression:"material.CertificateSettings.Issuance.data.after"}],class:['input-text', {'input-error': _vm.errors.has('Sertificate')}],attrs:{"name":"SertAftreIssuance","type":"text"},domProps:{"value":(_vm.material.CertificateSettings.Issuance.data.after)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.material.CertificateSettings.Issuance.data, "after", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-20"}),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.material.CertificateSettings.Issuance.data.email),expression:"material.CertificateSettings.Issuance.data.email"}],staticClass:"input-checkbox",attrs:{"id":"sertEmailEnabled","name":"SertEmailEnabled","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.material.CertificateSettings.Issuance.data.email)?_vm._i(_vm.material.CertificateSettings.Issuance.data.email,"true")>-1:(_vm.material.CertificateSettings.Issuance.data.email)},on:{"change":function($event){var $$a=_vm.material.CertificateSettings.Issuance.data.email,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.material.CertificateSettings.Issuance.data, "email", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.material.CertificateSettings.Issuance.data, "email", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.material.CertificateSettings.Issuance.data, "email", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"sertEmailEnabled"}},[_vm._v("email")])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.material.CertificateSettings.Issuance.data.sms),expression:"material.CertificateSettings.Issuance.data.sms"}],staticClass:"input-checkbox",attrs:{"id":"sertSmsEnabled","name":"SertSmsEnabled","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.material.CertificateSettings.Issuance.data.sms)?_vm._i(_vm.material.CertificateSettings.Issuance.data.sms,"true")>-1:(_vm.material.CertificateSettings.Issuance.data.sms)},on:{"change":function($event){var $$a=_vm.material.CertificateSettings.Issuance.data.sms,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.material.CertificateSettings.Issuance.data, "sms", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.material.CertificateSettings.Issuance.data, "sms", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.material.CertificateSettings.Issuance.data, "sms", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"sertSmsEnabled"}},[_vm._v("sms")])])]:_vm._e()],2)])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"block-in-page-detail",staticStyle:{"min-height":"40px"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.addFileMaterial()}}},[_vm._v("Добавить материал")])])],2)])]:_vm._e(),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Материалы"}})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Название\n                                "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Описание материала\n                                "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Дата включения\n                                    "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Дата выключения\n                                    "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Приветственное сообщение\n                                    "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Тип уведомления\n                                    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RewardEdit_vue__ = __webpack_require__(276);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1453bf78_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RewardEdit_vue__ = __webpack_require__(761);
function injectStyle (ssrContext) {
  __webpack_require__(759)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1453bf78"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RewardEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1453bf78_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RewardEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(760);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6aaa191c", content, true, {});

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".products[data-v-1453bf78]{display:flex;flex-wrap:wrap}.products>div[data-v-1453bf78]{width:25%}.products .product-item[data-v-1453bf78]{display:flex;flex-direction:column;align-items:center;margin:0 0 20px 20px;cursor:pointer}.products .product-item img[data-v-1453bf78]{width:100%}.input-checkbox-lbl.error-lbl[data-v-1453bf78]:before{border-color:red}@media (min-width:1px) and (max-width:768px){.products>div[data-v-1453bf78]{width:50%}}", ""]);

// exports


/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[(_vm.reward != null)?[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"btn-back margin-right-10"},[_c('a',{staticClass:"router-link-active",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.back.apply(null, arguments)}}},[_vm._v("Назад")])]),_vm._v(" "),(_vm.reward.new)?_c('p',{staticClass:"caption-help margin-right-10"},[_vm._v("Новое вознаграждение")]):_vm._e(),_vm._v(" "),(!_vm.reward.new)?_c('p',{staticClass:"caption-help"},[_vm._v(_vm._s(_vm.reward.Name))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[_c('div',{staticClass:"btns flex"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.savingInProgress},on:{"click":function($event){return _vm.saveEntity()}}},[_vm._v("Сохранить")]),_vm._v(" "),_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":_vm.deleteEntity}},[_vm._v("Удалить")])])])]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page"},[_c('div',{staticClass:"block-in-page"},[_c('div',{staticClass:"form-field"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reward.Name),expression:"reward.Name"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-text', {'input-error': _vm.errors.has('Name')}],attrs:{"name":"Name","type":"text"},domProps:{"value":(_vm.reward.Name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reward, "Name", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Name')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(1),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.reward.Description),expression:"reward.Description"}],class:['input-memo', {'input-error': _vm.errors.has('Description')}],staticStyle:{"height":"150px"},attrs:{"name":"Description","rows":"10"},domProps:{"value":(_vm.reward.Description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reward, "Description", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Description')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(2),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.types,"dataField":'Id',"textField":'Name'},on:{"change":_vm.onRewardTypeChenge},model:{value:(_vm.reward.RewardType),callback:function ($$v) {_vm.$set(_vm.reward, "RewardType", $$v)},expression:"reward.RewardType"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('RoleId')))])],1),_vm._v(" "),(_vm.reward.RewardType === 1)?_c('div',{staticClass:"form-field"},[(_vm.reward.GifteryId)?[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("\n                            Связано с Giftery, id "+_vm._s(_vm.reward.GifteryId)+"\n                        ")]),_vm._v(" "),(_vm.reward.HasOrders)?_c('span',[_vm._v("\n                            (отвязать нельзя, есть заказы)\n                        ")]):_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.reward.GifteryId=null}}},[_vm._v("Отвязать")])]:_c('div',{staticClass:"btns flex"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onGifteryModal.apply(null, arguments)}}},[_vm._v("Связать с Giftery")])]),_vm._v(" "),_c('div',[_vm._v("Баланс: "+_vm._s(_vm.giftery.balance ? _vm.giftery.balance.toFixed(2) : 0))])],2):_vm._e(),_vm._v(" "),(_vm.reward.RewardType === 1 || _vm.reward.RewardType === 2)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                        Ссылка на сайт\n                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reward.WebLink),expression:"reward.WebLink"},{name:"validate",rawName:"v-validate",value:('url'),expression:"'url'"}],class:['input-text', {'input-error': _vm.errors.has('WebLink')}],attrs:{"name":"WebLink","type":"text"},domProps:{"value":(_vm.reward.WebLink)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reward, "WebLink", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('WebLink')))])]):_vm._e(),_vm._v(" "),(_vm.domainFolders.length)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                        Папка\n                    ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.domainFolders,"dataField":'Id',"textField":'Name'},model:{value:(_vm.reward.DomainFolderId),callback:function ($$v) {_vm.$set(_vm.reward, "DomainFolderId", $$v)},expression:"reward.DomainFolderId"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('DomainFolderId')))])],1):_vm._e(),_vm._v(" "),(_vm.rewardGroups.length)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                        Группа\n                    ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.rewardGroups,"dataField":'Id',"textField":'Name'},model:{value:(_vm.reward.GroupId),callback:function ($$v) {_vm.$set(_vm.reward, "GroupId", $$v)},expression:"reward.GroupId"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('GroupId')))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                        Порядковый номер\n                    ")]),_vm._v(" "),_c('touch-spin',{model:{value:(_vm.reward.Order),callback:function ($$v) {_vm.$set(_vm.reward, "Order", _vm._n($$v))},expression:"reward.Order"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Order')))])],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reward.Disabled),expression:"reward.Disabled"}],staticClass:"input-checkbox",attrs:{"id":"Disabled","name":"Disabled","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.reward.Disabled)?_vm._i(_vm.reward.Disabled,"true")>-1:(_vm.reward.Disabled)},on:{"change":function($event){var $$a=_vm.reward.Disabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.reward, "Disabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.reward, "Disabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.reward, "Disabled", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"Disabled"}},[_vm._v("Отключить вознаграждение")])]),_vm._v(" "),(_vm.reward.RewardType !== 4)?_c('div',{staticClass:"form-field margin-top-10"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                        Номиналы\n                    ")]),_vm._v(" "),[_c('table',{staticClass:"table-view margin-top-5"},[_c('thead',{staticClass:"head-show"},[_c('tr',{staticStyle:{"text-align":"center"}},[_c('th',[_vm._v(_vm._s(_vm.currencyEquivalentLabel))]),_vm._v(" "),_c('th',[_vm._v("Стоимость в баллах")]),_vm._v(" "),_c('th',[_vm._v("Можно выбрать")]),_vm._v(" "),_c('th')])]),_vm._v(" "),_vm._l((_vm.reward.Prices),function(item,i){return _c('tr',[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.Nominal),expression:"item.Nominal"},{name:"validate",rawName:"v-validate",value:({ regex: /^\d{1,}(\.|\,)?\d{0,}$/ }),expression:"{ regex: /^\\d{1,}(\\.|\\,)?\\d{0,}$/ }"}],class:['input-text', {'input-error': _vm.errors.has('Nominal' + i) }],attrs:{"type":"text","name":'Nominal' + i,"placeholder":"номинал (руб.)","disabled":_vm.reward.GifteryId},domProps:{"value":(item.Nominal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "Nominal", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.Price),expression:"item.Price"},{name:"validate",rawName:"v-validate",value:({ positive: true, required: true, regex: /^\d{1,}(\.|\,)?\d{0,}$/ }),expression:"{ positive: true, required: true, regex: /^\\d{1,}(\\.|\\,)?\\d{0,}$/ }"}],class:['input-text', {'input-error': _vm.errors.has('Price' + i) }],attrs:{"type":"text","name":'Price' + i,"placeholder":"баллы (за сколько баллов)","disabled":_vm.reward.GifteryId},domProps:{"value":(item.Price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "Price", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"value-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.Active),expression:"item.Active"}],class:['input-checkbox'],attrs:{"value":"true","type":"checkbox","id":'Active' + i,"name":'Active' + i},domProps:{"checked":Array.isArray(item.Active)?_vm._i(item.Active,"true")>-1:(item.Active)},on:{"change":function($event){var $$a=item.Active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "Active", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "Active", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "Active", $$c)}}}}),_vm._v(" "),_c('label',{class:['input-checkbox-lbl', {'error-lbl': item.Comment}],attrs:{"for":'Active' + i,"title":item.Comment}},[_vm._v("Вкл.")])]),_vm._v(" "),_c('td',{staticClass:"bit"},[(item.CanBeDeleted)?_c('button',{staticClass:"btn btn-default btn-img",attrs:{"type":"button"},on:{"click":function($event){return _vm.removePrice(item, i)}}},[_c('img',{attrs:{"src":__webpack_require__(17),"alt":""}})]):_vm._e()])])})],2),_vm._v(" "),(_vm.reward.GifteryId)?_c('button',{staticClass:"btn margin-top-10",attrs:{"type":"button","disabled":_vm.giftery.loading},on:{"click":function($event){$event.stopPropagation();return _vm.onGifteryUpdate.apply(null, arguments)}}},[(_vm.giftery.loading)?[_vm._v("\n                                Идёт обновление, подождите...\n                            ")]:[_vm._v("\n                                Обновить из Giftery\n                            ")]],2):_vm._e()],_vm._v(" "),(!_vm.reward.GifteryId)?_c('button',{staticClass:"btn btn-primary margin-top-5 btn-img",attrs:{"type":"button"},on:{"click":function($event){return _vm.addPrice()}}},[_c('img',{attrs:{"src":__webpack_require__(43),"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.allowManualNominal)?_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reward.ManualNominal),expression:"reward.ManualNominal"}],staticClass:"input-checkbox",attrs:{"id":"ManualNominal","name":"ManualNominal","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.reward.ManualNominal)?_vm._i(_vm.reward.ManualNominal,"true")>-1:(_vm.reward.ManualNominal)},on:{"change":function($event){var $$a=_vm.reward.ManualNominal,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.reward, "ManualNominal", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.reward, "ManualNominal", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.reward, "ManualNominal", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"ManualNominal"}},[_vm._v("Ввести сумму")])]):_vm._e(),_vm._v(" "),(_vm.reward.ManualNominal)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Процент (от 0 до 100)\n                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reward.ManualNominalPercent),expression:"reward.ManualNominalPercent"},{name:"validate",rawName:"v-validate",value:({ percent: true, positive: true }),expression:"{ percent: true, positive: true }"}],class:['input-text', {'input-error': _vm.errors.has('ManualNominalPercent') }],attrs:{"type":"text","name":"ManualNominalPercent","placeholder":"Процент"},domProps:{"value":(_vm.reward.ManualNominalPercent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reward, "ManualNominalPercent", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.reward.ManualNominal)?_c('div',{staticClass:"form-field-group mob-inline"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Минимальное значение\n                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reward.ManualNominalMin),expression:"reward.ManualNominalMin"},{name:"validate",rawName:"v-validate",value:({ numeric: true, positive: true }),expression:"{ numeric: true, positive: true }"}],class:['input-text', {'input-error': _vm.errors.has('ManualNominalMin') }],attrs:{"type":"number","name":"ManualNominalMin","placeholder":"Минимальное значение"},domProps:{"value":(_vm.reward.ManualNominalMin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reward, "ManualNominalMin", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Максимальное значение\n                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reward.ManualNominalMax),expression:"reward.ManualNominalMax"},{name:"validate",rawName:"v-validate",value:({ numeric: true, positive: true }),expression:"{ numeric: true, positive: true }"}],class:['input-text', {'input-error': _vm.errors.has('ManualNominalMax') }],attrs:{"type":"number","name":"ManualNominalMax","placeholder":"Максимальное значение"},domProps:{"value":(_vm.reward.ManualNominalMax)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reward, "ManualNominalMax", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Шаг к сумме\n                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reward.ManualNominalStep),expression:"reward.ManualNominalStep"},{name:"validate",rawName:"v-validate",value:({ numeric: true, positive: true }),expression:"{ numeric: true, positive: true }"}],class:['input-text', {'input-error': _vm.errors.has('ManualNominalStep') }],attrs:{"type":"number","name":"ManualNominalStep","placeholder":"Шаг к сумме"},domProps:{"value":(_vm.reward.ManualNominalStep)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reward, "ManualNominalStep", $event.target.value)}}})])]):_vm._e()],2):_c('div',[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                        Стоимость в баллах\n                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reward.Prices[0].Price),expression:"reward.Prices[0].Price"},{name:"validate",rawName:"v-validate",value:({ positive: true, required: true, regex: /^\d{1,}(\.|\,)?\d{0,}$/ }),expression:"{ positive: true, required: true, regex: /^\\d{1,}(\\.|\\,)?\\d{0,}$/ }"}],class:['input-text', {'input-error': _vm.errors.has('Price') }],attrs:{"type":"text","name":'Price',"placeholder":"баллы"},domProps:{"value":(_vm.reward.Prices[0].Price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reward.Prices[0], "Price", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"block-in-page"},[_c('div',{staticClass:"flex"},[_c('image-setting',{attrs:{"img":_vm.imgSite,"name":'site',"parentImage":true},on:{"onImageViewChanged":_vm.onImageViewChanged}}),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"300px","min-width":"300px","margin-left":"20px"}},[_c('div',{staticClass:"panel-block panel-block-new",staticStyle:{"margin-right":"0"}},[_c('div',{staticClass:"panel-block-img-base"},[_c('div',{staticClass:"panel-block-img"},[(_vm.imgSitePath)?_c('img',{style:(_vm.imageStyleFormatted),attrs:{"src":_vm.imgSitePath,"alt":""}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"panel-block-info"},[_c('p',{staticClass:"panel-block-header margin-bottom-10"},[_vm._v(_vm._s(_vm.reward.Name))])]),_vm._v(" "),_vm._m(3)])])],1)]),_vm._v(" "),_c('div',{staticClass:"block-in-page"},[_c('div',{staticClass:"flex"},[_c('image-setting',{attrs:{"img":_vm.imgMobile,"parentImgPath":_vm.imgSitePath,"name":'mobile'},on:{"onImageViewChanged":_vm.onImageViewChanged}}),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"500px","min-width":"500px","margin-left":"20px"}},[_c('div',{staticClass:"panel-block panel-block-new panel-block-mobile",staticStyle:{"margin-right":"0"}},[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"panel-block-img panel-block-img-mobile"},[(_vm.imgMobilePath)?_c('img',{style:(_vm.imageStyleMobileFormatted),attrs:{"src":_vm.imgMobilePath,"alt":""}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"panel-block-info"},[_c('div',[_c('p',{staticClass:"panel-block-header margin-bottom-10"},[_vm._v(_vm._s(_vm.reward.Name))]),_vm._v(" "),_c('p',{staticClass:"panel-block-header margin-bottom-10"},[_vm._v(_vm._s(_vm.reward.Description))])])])]),_vm._v(" "),_vm._m(4)])])],1)])])]:_vm._e(),_vm._v(" "),_c('popup-window',{ref:"ppGiftery",attrs:{"title":'Сертификаты Giftery',"width":'80%'}},[_c('p',{staticClass:"p-header-1"}),_vm._v(" "),_c('div',[(_vm.giftery.loading)?_c('span',[_vm._v("Идёт загрузка...")]):_vm._e(),_vm._v(" "),(_vm.giftery.data && _vm.giftery.data.length && !_vm.giftery.loading)?_c('div',{staticClass:"products"},_vm._l((_vm.giftery.data),function(item){return _c('div',[_c('div',{staticClass:"product-item",on:{"click":function($event){$event.stopPropagation();return _vm.onGifterySelect(item)}}},[_c('p',{staticClass:"p-header-1"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('img',{attrs:{"src":item.main_image.small,"alt":item.title,"title":item.brief}})])])}),0):_vm._e()])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Вознаграждения"}})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                        Название\n                        "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                        Описание\n                        "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                        Тип\n                        "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-body-actions"},[_c('button',{staticClass:"btn",attrs:{"type":"button"}},[_vm._v("Выбрать")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-body-actions"},[_c('button',{staticClass:"btn",attrs:{"type":"button"}},[_vm._v("Выбрать")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuestionsEdit_vue__ = __webpack_require__(277);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_151d83cc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuestionsEdit_vue__ = __webpack_require__(765);
function injectStyle (ssrContext) {
  __webpack_require__(763)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-151d83cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuestionsEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_151d83cc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuestionsEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(764);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("0f8702d8", content, true, {});

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"btn-back margin-right-10"},[_c('a',{staticClass:"router-link-active",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.$router.push('/materials/edit/' + _vm.material.Id)}}},[_vm._v("Назад")])])])]),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[_c('div',{staticClass:"btns flex"},[_c('input',{ref:"dropFiles",staticClass:"file-upload-zone-btn",attrs:{"type":"file","id":"dropFiles","name":"dropFiles","accept":".xlsx"},on:{"change":function($event){return _vm.onImporFileChange()}}}),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button","onclick":"document.getElementById('dropFiles').click()"}},[_vm._v("\n                        Импорт\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onExportModal()}}},[_vm._v("\n                        Экспорт\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveQuestions()}}},[_vm._v("Сохранить")])])])]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page"},[_c('div',{staticClass:"block-in-page"},[_c('h2',{staticClass:"margin-bottom-10"},[_vm._v("Вопросы теста")]),_vm._v(" "),_vm._l((_vm.questions),function(question,i){return _c('div',{key:'w' + i + '_' + _vm.backgroundImageKey},[_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_vm._m(0,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(question.Name),expression:"question.Name"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-text', {'input-error': _vm.errors.has('QuestionName' + i) }],attrs:{"type":"text","placeholder":"Заголовок","name":'QuestionName' + i},domProps:{"value":(question.Name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(question, "Name", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"})]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(1,true),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.questionTypes,"dataField":'Id',"textField":'Name'},on:{"change":function($event){return _vm.onChangeQuestionType(question)}},model:{value:(question.QuestionType),callback:function ($$v) {_vm.$set(question, "QuestionType", $$v)},expression:"question.QuestionType"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"130px","min-width":"130px","padding-top":"25px"}},[_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.removeQuestion(i)}}},[_vm._v("\n                                Удалить вопрос\n                            ")])])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(question.Active),expression:"question.Active"}],staticClass:"input-checkbox",attrs:{"id":'Active' + i,"name":'Active' + i,"type":"checkbox"},domProps:{"checked":Array.isArray(question.Active)?_vm._i(question.Active,null)>-1:(question.Active)},on:{"change":function($event){var $$a=question.Active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(question, "Active", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(question, "Active", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(question, "Active", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'Active' + i}},[_vm._v("Активировать вопрос")])]),_vm._v(" "),_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_c('div',[_vm._m(2,true),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(question.Description),expression:"question.Description"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-memo', {'input-error': _vm.errors.has('QuestionDescription' + i) }],staticStyle:{"height":"150px"},attrs:{"name":'QuestionDescription' + i,"rows":"10"},domProps:{"value":(question.Description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(question, "Description", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"})]),_vm._v(" "),_c('div',[_vm._m(3,true),_vm._v(" "),_c('div',{staticClass:"thumbnail-img-block"},_vm._l((question.Images),function(img,imgIndex){return _c('div',{staticClass:"thumbnail-img"},[(img.FileData)?_c('a',{staticClass:"lightzoom",attrs:{"href":img.FileData,"rel":"group"}},[_c('img',{attrs:{"src":img.FileData}})]):_vm._e(),_vm._v(" "),(!img.FileData && img.Image)?_c('a',{staticClass:"lightzoom",attrs:{"href":img.Image,"rel":"group"}},[_c('img',{attrs:{"src":img.Image}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"thumbnail-img-delete",on:{"click":function($event){return _vm.removeImage(i, imgIndex)}}})])}),0),_vm._v(" "),_c('div',{staticClass:"file-upload-zone",staticStyle:{"height":"100px"}},[_c('div',{staticClass:"file-upload-zone",staticStyle:{"height":"100%"}},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({ rules: { required: false } }),expression:"{ rules: { required: false } }"}],ref:'dropFiles' + i,refInFor:true,staticClass:"file-upload-zone-btn dropFiles",attrs:{"type":"file","id":'dropFiles' + i,"name":'dropFiles' + i,"data-index":i,"accept":".jpg,.jpeg,.png","multiple":""}}),_vm._v(" "),_c('label',{staticClass:"file-upload-zone-lbl",attrs:{"for":'dropFiles' + i}},[_vm._v("Прикрепите изображения")])])])])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(4,true),_vm._v(" "),(question.BackgroundSite.FileData || question.BackgroundSite.FilePath)?_c('div',{staticClass:"thumbnail-img-block"},[_c('div',{staticClass:"thumbnail-img"},[(question.BackgroundSite.FileData)?_c('a',{staticClass:"lightzoom",attrs:{"href":question.BackgroundSite.FileData,"rel":"group"}},[_c('img',{attrs:{"src":question.BackgroundSite.FileData}})]):_vm._e(),_vm._v(" "),(!question.BackgroundSite.FileData && question.BackgroundSite.FilePath)?_c('a',{staticClass:"lightzoom",attrs:{"href":question.BackgroundSite.FilePath,"rel":"group"}},[_c('img',{attrs:{"src":question.BackgroundSite.FilePath}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"thumbnail-img-delete",on:{"click":function($event){return _vm.removeImageBackground(i, 'site')}}})])]):_c('div',{staticClass:"file-upload-zone",staticStyle:{"height":"100px"}},[_c('drop-zone',{staticClass:"drop-area file-upload-zone",staticStyle:{"height":"100px"},attrs:{"dataId":i,"accept":".jpg,.jpeg,.png"},on:{"files-dropped":_vm.onDropFilesBackgroundSite}},[_c('input',{ref:'dropFilesBackgroundSite'+i,refInFor:true,staticClass:"file-upload-zone-btn",attrs:{"type":"file","accept":".jpg,.jpeg,.png","id":'dropFilesBackgroundSite'+i,"data-fieldid":i,"data-client":'site',"name":"dropFilesBackground"}}),_vm._v(" "),_c('label',{staticClass:"file-upload-zone-lbl",attrs:{"id":"'dropFilesLblBackgroundSite'+i","for":'dropFilesBackgroundSite'+i}},[_vm._v("Прикрепите изображение")])])],1),_vm._v(" "),_c('div',{staticClass:"margin-bottom-10"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Выравнивание текста")]),_vm._v(" "),_c('drop-down',{attrs:{"items":[{Id: 'top', Name: 'По верхнему краю'}, {Id: 'bottom', Name: 'По нижнему краю'}],"dataField":'Id',"textField":'Name'},model:{value:(question.BackgroundSite.Align),callback:function ($$v) {_vm.$set(question.BackgroundSite, "Align", $$v)},expression:"question.BackgroundSite.Align"}})],1),_vm._v(" "),(question.BackgroundSite.FileData || question.BackgroundSite.FilePath)?_c('div',{staticClass:"btns margin-bottom-10"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onBackgroundPreviewModal(question.BackgroundSite, i, 'site')}}},[_vm._v("Предварительный просмотр")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(5,true),_vm._v(" "),(question.BackgroundMobile.FileData || question.BackgroundMobile.FilePath)?_c('div',{staticClass:"thumbnail-img-block"},[_c('div',{staticClass:"thumbnail-img"},[(question.BackgroundMobile.FileData)?_c('a',{staticClass:"lightzoom",attrs:{"href":question.BackgroundMobile.FileData,"rel":"group"}},[_c('img',{attrs:{"src":question.BackgroundMobile.FileData}})]):_vm._e(),_vm._v(" "),(!question.BackgroundMobile.FileData && question.BackgroundMobile.FilePath)?_c('a',{staticClass:"lightzoom",attrs:{"href":question.BackgroundMobile.FilePath,"rel":"group"}},[_c('img',{attrs:{"src":question.BackgroundMobile.FilePath}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"thumbnail-img-delete",on:{"click":function($event){return _vm.removeImageBackground(i, 'mobile')}}})])]):_c('div',{staticClass:"file-upload-zone",staticStyle:{"height":"100px"}},[_c('drop-zone',{staticClass:"drop-area file-upload-zone",staticStyle:{"height":"100px"},attrs:{"dataId":i,"accept":".jpg,.jpeg,.png"},on:{"files-dropped":_vm.onDropFilesBackgroundMobile}},[_c('input',{ref:'dropFilesBackgroundMobile'+i,refInFor:true,staticClass:"file-upload-zone-btn",attrs:{"type":"file","accept":".jpg,.jpeg,.png","id":'dropFilesBackgroundMobile'+i,"data-fieldid":i,"data-client":'mobile',"name":"dropFilesBackground"}}),_vm._v(" "),_c('label',{staticClass:"file-upload-zone-lbl",attrs:{"id":"'dropFilesLblBackgroundMobile'+i","for":'dropFilesBackgroundMobile'+i}},[_vm._v("Прикрепите изображение")])])],1),_vm._v(" "),_c('div',{staticClass:"margin-bottom-10"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Выравнивание текста")]),_vm._v(" "),_c('drop-down',{attrs:{"items":[{Id: 'top', Name: 'По верхнему краю'}, {Id: 'bottom', Name: 'По нижнему краю'}],"dataField":'Id',"textField":'Name'},model:{value:(question.BackgroundMobile.Align),callback:function ($$v) {_vm.$set(question.BackgroundMobile, "Align", $$v)},expression:"question.BackgroundMobile.Align"}})],1),_vm._v(" "),(question.BackgroundMobile.FileData || question.BackgroundMobile.FilePath)?_c('div',{staticClass:"btns margin-bottom-10"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onBackgroundPreviewModal(question.BackgroundMobile, i, 'mobile')}}},[_vm._v("Предварительный просмотр")])]):_vm._e()])]),_vm._v(" "),(question.QuestionType !== 3)?[_c('p',{staticClass:"input-text-lbl"},[_vm._v("Варианты ответов")]),_vm._v(" "),_vm._l((question.Answers),function(answer,j){return _c('div',[_c('div',{staticClass:"form-field-group with-out-lbl"},[_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(answer.Value),expression:"answer.Value"}],staticClass:"input-text",attrs:{"type":"text","placeholder":""},domProps:{"value":(answer.Value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(answer, "Value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"160px","min-width":"160px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(answer.Correct),expression:"answer.Correct"}],staticClass:"input-checkbox",attrs:{"id":'Correct_q_' + i + '_a_' + j,"name":'Correct_q_' + i + '_a_' + j,"value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(answer.Correct)?_vm._i(answer.Correct,"true")>-1:(answer.Correct)},on:{"change":[function($event){var $$a=answer.Correct,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(answer, "Correct", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(answer, "Correct", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(answer, "Correct", $$c)}},function($event){return _vm.onCorrectChange(question, answer)}]}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'Correct_q_' + i + '_a_' + j}},[_vm._v("Правильный ответ")])]),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"35px","min-width":"35px"}},[_c('button',{staticClass:"btn btn-default btn-img",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.removeAnswer(question, j)}}},[_c('img',{attrs:{"src":__webpack_require__(17),"alt":""}})])])])])}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-img",attrs:{"type":"button"},on:{"click":function($event){return _vm.addAnswer(question)}}},[_c('img',{attrs:{"src":__webpack_require__(43),"alt":""}})])]:_vm._e(),_vm._v(" "),(question.QuestionType === 3)?[_c('p',{staticClass:"input-text-lbl"},[_vm._v("Вариант ответа")]),_vm._v(" "),_c('div',{staticClass:"form-field-group with-out-lbl"},[_c('div',{staticClass:"form-field"},[_vm._m(6,true),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.answerTypes,"dataField":'Id',"textField":'Name'},on:{"change":function($event){return _vm.onChangeAnswerType(question)}},model:{value:(question.AnswerType),callback:function ($$v) {_vm.$set(question, "AnswerType", $$v)},expression:"question.AnswerType"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(7,true),_vm._v(" "),(question.AnswerType === 1)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(question.Answers[0].Value),expression:"question.Answers[0].Value"},{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],key:"type1",staticClass:"input-text",class:['input-text', {'input-error': _vm.errors.has('QuestionFreeAnswer' + i) }],attrs:{"type":"text","name":'QuestionFreeAnswer' + i},domProps:{"value":(question.Answers[0].Value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(question.Answers[0], "Value", $event.target.value)}}}):_vm._e(),_vm._v(" "),(question.AnswerType === 2)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(question.Answers[0].Value),expression:"question.Answers[0].Value"},{name:"validate",rawName:"v-validate",value:({ required: true, regex: /^\d{1,}$/ }),expression:"{ required: true, regex: /^\\d{1,}$/ }"}],key:"type2",class:['input-text', {'input-error': _vm.errors.has('QuestionFreeAnswer' + i) }],attrs:{"type":"text","name":'QuestionFreeAnswer' + i},domProps:{"value":(question.Answers[0].Value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(question.Answers[0], "Value", $event.target.value)}}}):_vm._e(),_vm._v(" "),(question.AnswerType === 3)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(question.Answers[0].Value),expression:"question.Answers[0].Value"},{name:"validate",rawName:"v-validate",value:({ required: true, regex: /^\d{1,}(\.|\,)?\d{0,}$/ }),expression:"{ required: true, regex: /^\\d{1,}(\\.|\\,)?\\d{0,}$/ }"}],key:"type3",class:['input-text', {'input-error': _vm.errors.has('QuestionFreeAnswer' + i) }],attrs:{"type":"text","name":'QuestionFreeAnswer' + i},domProps:{"value":(question.Answers[0].Value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(question.Answers[0], "Value", $event.target.value)}}}):_vm._e(),_vm._v(" "),(question.AnswerType === 4)?_c('input-date',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],key:"type4",class:[{'input-error': _vm.errors.has('QuestionFreeAnswer' + i)}],attrs:{"name":'QuestionFreeAnswer' + i},model:{value:(question.Answers[0].Value),callback:function ($$v) {_vm.$set(question.Answers[0], "Value", $$v)},expression:"question.Answers[0].Value"}}):_vm._e()],1)])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"block-in-page-separator"})],2)}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary margin-top-15",attrs:{"type":"button"},on:{"click":function($event){return _vm.addQuestion()}}},[_vm._v("\n                    Добавить вопрос\n                ")])],2)])],_vm._v(" "),_c('popup-window',{ref:"ppExport",attrs:{"title":'Выгрузка результатов',"width":800}},[_c('div',{},[_c('div',{staticClass:"form-field flex mob-inline"},[_c('input-date',{staticClass:"input-text input-date",attrs:{"name":"dateStart"},model:{value:(_vm.exportDateStart),callback:function ($$v) {_vm.exportDateStart=$$v},expression:"exportDateStart"}}),_vm._v(" "),_c('span',{staticClass:"margin-left-10 margin-right-10 margin-top-5"},[_vm._v("-")]),_vm._v(" "),_c('input-date',{staticClass:"input-text input-date",attrs:{"name":"dateEnd"},model:{value:(_vm.exportDateEnd),callback:function ($$v) {_vm.exportDateEnd=$$v},expression:"exportDateEnd"}})],1),_vm._v(" "),_c('div',{staticClass:"margin-top-20"},[_c('complex-filter',{ref:"complexFilter",attrs:{"filters":_vm.filters,"searchFunction":_vm.searchFunction,"tableName":'[dbo].[TradePoint]',"withTableNameInClause":true},on:{"onFilterChange":_vm.onFilterChange}})],1),_vm._v(" "),_c('div',{staticClass:"margin-top-20 margin-bottom-200"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onExport()}}},[_vm._v("\n                    Готово\n                ")])])])]),_vm._v(" "),_c('popup-window',{ref:"ppBackgroundPreview",attrs:{"title":_vm.headerBackgroundPreview}},[_c('div',{},[_c('div',{staticClass:"background-image"},[_c('img',{attrs:{"src":_vm.backgroundImage}}),_vm._v(" "),_c('p',{class:[{'top': _vm.backgroundImageTop }, {'bottom': !_vm.backgroundImageTop }]},[_vm._v(_vm._s(_vm.backgroundImageText))])]),_vm._v(" "),_c('div',{staticClass:"margin-top-20 btns"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.closeModal('ppBackgroundPreview')}}},[_vm._v("Готово")])])])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Вопросы к материалу"}})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Название вопроса\n                                "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Тип вопроса\n                                "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Текст вопроса\n                                    "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Изображения\n                                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Фон вопроса для отображения на сайте\n                                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Фон вопроса для отображения в мобильном приложении\n                                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Тип ответа\n                                    "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Правильный ответ\n                                    "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FolderEdit_vue__ = __webpack_require__(278);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8b25f9a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FolderEdit_vue__ = __webpack_require__(769);
function injectStyle (ssrContext) {
  __webpack_require__(767)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c8b25f9a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FolderEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8b25f9a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FolderEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(768);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("bba7645c", content, true, {});

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel"},[(_vm.folder != null)?[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"btn-back margin-right-10"},[_c('a',{staticClass:"router-link-active",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.back.apply(null, arguments)}}},[_vm._v("Назад")])]),_vm._v(" "),(_vm.folder.new)?_c('p',{staticClass:"caption-help margin-right-10"},[_vm._v("Добавление папки")]):_vm._e(),_vm._v(" "),(!_vm.folder.new)?_c('p',{staticClass:"caption-help"},[_vm._v("Редактирование папки #"+_vm._s(_vm.folder.Id))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[_c('div',{staticClass:"btns flex"},[(_vm.folder.DateArchive == null && !_vm.folder.new)?[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.savingInProgress},on:{"click":function($event){return _vm.archiveFolder(true)}}},[_vm._v("Архивировать все")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.savingInProgress},on:{"click":function($event){return _vm.archiveFolder(false)}}},[_vm._v("Архивировать папку")])]:(!_vm.folder.new)?[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.savingInProgress},on:{"click":function($event){return _vm.openSelectFolderModal(true)}}},[_vm._v("Восстановить все")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.savingInProgress},on:{"click":function($event){return _vm.openSelectFolderModal(false)}}},[_vm._v("Восстановить папку")])]:_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.savingInProgress},on:{"click":function($event){return _vm.saveFolder()}}},[_vm._v("Сохранить")]),_vm._v(" "),_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":_vm.deleteFolder}},[_vm._v("Удалить")])],2)])]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page"},[_c('div',{staticClass:"body-panel page-content-block"},[_c('form',{ref:"myForm",staticClass:"form-horizontal",attrs:{"novalidate":"novalidate","method":"post","enctype":"multipart/form-data"}},[_c('div',{staticClass:"block-in-page"},[_c('div',{staticClass:"form-field"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.folder.Name),expression:"folder.Name"}],class:['input-text', {'input-error': _vm.errors.has('Name')}],attrs:{"name":"Name","type":"text"},domProps:{"value":(_vm.folder.Name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.folder, "Name", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Name')))])])]),_vm._v(" "),_c('div',{staticClass:"block-in-page"},[_c('div',{staticClass:"flex"},[_c('image-setting',{attrs:{"img":_vm.imgSite,"name":'site',"parentImage":true},on:{"onImageViewChanged":_vm.onImageViewChanged}}),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"300px","min-width":"300px","margin-left":"20px"}},[_c('div',{staticClass:"panel-block panel-block-new",staticStyle:{"margin-right":"0"}},[_c('div',{staticClass:"panel-block-img-base"},[_c('div',{staticClass:"panel-block-img"},[(_vm.imgSitePath)?_c('img',{style:(_vm.imageStyleFormatted),attrs:{"src":_vm.imgSitePath,"alt":""}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"panel-block-info"},[_c('p',{staticClass:"panel-block-header margin-bottom-10"},[_vm._v(_vm._s(_vm.folder.Name))])]),_vm._v(" "),_vm._m(1)])])],1)]),_vm._v(" "),_c('div',{staticClass:"block-in-page"},[_c('div',{staticClass:"flex"},[_c('image-setting',{attrs:{"img":_vm.imgMobile,"parentImgPath":_vm.imgSitePath,"name":'mobile'},on:{"onImageViewChanged":_vm.onImageViewChanged}}),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"400px","min-width":"400px","margin-left":"20px"}},[_c('div',{staticClass:"panel-block panel-block-new panel-block-mobile",staticStyle:{"margin-right":"0"}},[_c('div',{staticClass:"panel-block-img-base panel-block-img-mobile-folder"},[_c('div',{staticClass:"panel-block-img panel-block-img-mobile-folder"},[(_vm.imgMobilePath)?_c('img',{style:(_vm.imageStyleMobileFormatted),attrs:{"src":_vm.imgMobilePath,"alt":""}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"panel-block-info"},[_c('p',{staticClass:"panel-block-header margin-bottom-10"},[_vm._v(_vm._s(_vm.folder.Name))])])]),_vm._v(" "),_vm._m(2)])])],1)])])])])]:_vm._e(),_vm._v(" "),_c('popup-window',{ref:"ppFolderList",attrs:{"title":'Восстановление в папку',"width":600}},[_c('p',{staticClass:"caption-help"}),_vm._v(" "),_c('div',{key:_vm.componentKey},_vm._l((_vm.folders),function(item,i){return _c('div',{class:['list-select-text', {'active':item.Checked}],on:{"click":function($event){return _vm.onSelectFolder(item, i, $event)}}},[_c('label',{staticClass:"input-text-lbl"},[_vm._v(_vm._s(item.Name))])])}),0),_vm._v(" "),_c('button',{staticClass:"btn btn-primary margin-top-10",attrs:{"type":"button"},on:{"click":function($event){return _vm.restoreFolder()}}},[_vm._v("Выбрать")])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Папки материалов"}})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Название папки\n                                "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-body-actions"},[_c('button',{staticClass:"btn"},[_vm._v("Просмотр")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-body-actions"},[_c('button',{staticClass:"btn"},[_vm._v("Просмотр")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SkuFolderEdit_vue__ = __webpack_require__(279);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_638ba63e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkuFolderEdit_vue__ = __webpack_require__(773);
function injectStyle (ssrContext) {
  __webpack_require__(771)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-638ba63e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SkuFolderEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_638ba63e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkuFolderEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(772);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("32139218", content, true, {});

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel"},[(_vm.folder != null)?[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"btn-back margin-right-10"},[_c('a',{staticClass:"router-link-active",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.back.apply(null, arguments)}}},[_vm._v("Назад")])]),_vm._v(" "),(_vm.folder.new)?_c('p',{staticClass:"caption-help margin-right-10"},[_vm._v("Добавление папки")]):_vm._e(),_vm._v(" "),(!_vm.folder.new)?_c('p',{staticClass:"caption-help"},[_vm._v("Редактирование папки #"+_vm._s(_vm.folder.Name))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[_c('div',{staticClass:"btns flex"},[(_vm.folder.DateArchive == null && !_vm.folder.new)?[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.savingInProgress},on:{"click":function($event){return _vm.archiveFolder(true)}}},[_vm._v("Архивировать все")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.savingInProgress},on:{"click":function($event){return _vm.archiveFolder(false)}}},[_vm._v("Архивировать папку")])]:(!_vm.folder.new)?[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.savingInProgress},on:{"click":function($event){return _vm.openSelectFolderModal(true)}}},[_vm._v("Восстановить все")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.savingInProgress},on:{"click":function($event){return _vm.openSelectFolderModal(false)}}},[_vm._v("Восстановить папку")])]:_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.savingInProgress},on:{"click":function($event){return _vm.saveFolder()}}},[_vm._v("Сохранить")]),_vm._v(" "),_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":_vm.deleteFolder}},[_vm._v("Удалить")])],2)])]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page"},[_c('div',{staticClass:"body-panel"},[_c('domain-folder',{attrs:{"folder":_vm.folder,"folderPath":'/uploads/domain-folders/',"parentFolders":_vm.domainFolders},on:{"update":_vm.onUpdate}})],1)])]:_vm._e(),_vm._v(" "),_c('popup-window',{ref:"ppFolderList",attrs:{"title":'Восстановление в папку',"width":600}},[_c('p',{staticClass:"caption-help"}),_vm._v(" "),_c('div',{key:_vm.componentKey},_vm._l((_vm.domainFolders),function(item,i){return _c('div',{class:['list-select-text', {'active':item.Checked}],on:{"click":function($event){return _vm.onSelectFolder(item, i, $event)}}},[_c('label',{staticClass:"input-text-lbl"},[_vm._v(_vm._s(item.Name))])])}),0),_vm._v(" "),_c('button',{staticClass:"btn btn-primary margin-top-10",attrs:{"type":"button"},on:{"click":function($event){return _vm.restoreFolder()}}},[_vm._v("Выбрать")])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Папки sku"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RewardFolderEdit_vue__ = __webpack_require__(280);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dc4e80a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RewardFolderEdit_vue__ = __webpack_require__(777);
function injectStyle (ssrContext) {
  __webpack_require__(775)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2dc4e80a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RewardFolderEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dc4e80a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RewardFolderEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(776);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("0273da4e", content, true, {});

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel"},[(_vm.folder != null)?[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"btn-back margin-right-10"},[_c('a',{staticClass:"router-link-active",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.back.apply(null, arguments)}}},[_vm._v("Назад")])]),_vm._v(" "),(_vm.folder.new)?_c('p',{staticClass:"caption-help margin-right-10"},[_vm._v("Добавление папки")]):_vm._e(),_vm._v(" "),(!_vm.folder.new)?_c('p',{staticClass:"caption-help"},[_vm._v("Редактирование папки #"+_vm._s(_vm.folder.Name))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[_c('div',{staticClass:"btns flex"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.savingInProgress},on:{"click":function($event){return _vm.saveFolder()}}},[_vm._v("Сохранить")]),_vm._v(" "),_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":_vm.deleteFolder}},[_vm._v("Удалить")])])])]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page"},[_c('div',{staticClass:"body-panel"},[_c('domain-folder',{attrs:{"folder":_vm.folder,"folderPath":'/uploads/domain-folders/'},on:{"update":_vm.onUpdate}})],1)])]:_vm._e(),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Папки sku"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Activation_vue__ = __webpack_require__(281);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e565026e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Activation_vue__ = __webpack_require__(781);
function injectStyle (ssrContext) {
  __webpack_require__(779)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e565026e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Activation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e565026e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Activation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(780);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("12cdc43f", content, true, {});

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel"},[_c('div',{staticClass:"body-panel-content"},[_c('div',{staticClass:"body-panel-content-start flex"},[_c('div',{staticClass:"login-page-bg"}),_vm._v(" "),_c('div',{staticClass:"login-page"},[(_vm.info.StartImage != null)?_c('div',{staticClass:"login-logo"},[_c('img',{staticClass:"login-logo-img",attrs:{"src":_vm.info.StartImage}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"login"},[_c('div',{staticClass:"form-header"},[_vm._v("\n                        Активация аккаунта\n                    ")]),_vm._v(" "),(_vm.result != null)?[_c('div',{staticClass:"auth-content-block"},[_c('div',{staticClass:"form-field"},[_c('b',[_vm._v("Логин:")]),_vm._v(" "+_vm._s(_vm.result.login)+"\n                            ")]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],class:['input-text', {'input-error': _vm.errors.has('password')}],attrs:{"name":"UserPassword","type":"password","placeholder":"Пароль","data-vv-as":"\"Пароль\""},domProps:{"value":(_vm.password)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.password=$event.target.value},_vm.onNewPasswordChange]}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('password'))+_vm._s(_vm.passwordError))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, confirmed:_vm.password}),expression:"{required: true, confirmed:password}"},{name:"model",rawName:"v-model",value:(_vm.passwordConfirm),expression:"passwordConfirm"}],class:['input-text', {'input-error': _vm.errors.has('passwordConfirm')}],attrs:{"name":"PasswordConfirm","type":"password","placeholder":"Повторите пароль","data-vv-as":"\"Повторите пароль\""},domProps:{"value":(_vm.passwordConfirm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.passwordConfirm=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('passwordConfirm')))])])]),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('div',{staticClass:"form-btns"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"},on:{"click":_vm.setPassword}},[_vm._v("\n                                    Установить пароль\n                                ")])])])]:_vm._e()],2)])])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Активация аккаунта"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TasksEdit_vue__ = __webpack_require__(282);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42d317c2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TasksEdit_vue__ = __webpack_require__(785);
function injectStyle (ssrContext) {
  __webpack_require__(783)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42d317c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TasksEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42d317c2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TasksEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(784);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("43046548", content, true, {});

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".block-in-page.opened .block-in-page-detail[data-v-42d317c2]{overflow:visible}.fancybox-inner[data-v-42d317c2]{overflow:hidden!important}.fancybox-nav[data-v-42d317c2]{width:40px!important}", ""]);

// exports


/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[(_vm.task != null)?[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"btn-back margin-right-10"},[_c('a',{staticClass:"router-link-active",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.back.apply(null, arguments)}}},[_vm._v("Назад")])]),_vm._v(" "),(_vm.task.new)?_c('p',{staticClass:"caption-help margin-right-10"},[_vm._v("Создание нового задания")]):_vm._e(),_vm._v(" "),(!_vm.task.new)?_c('p',{staticClass:"caption-help"},[_vm._v("Редактирование задания #"+_vm._s(_vm.task.Id))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[_c('div',{staticClass:"btns flex"},[(!_vm.task.new)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.copyTasksSettingsModal()}}},[_vm._v("Дублировать задание")]):_vm._e(),_vm._v(" "),(_vm.allowEdit)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveTasks()}}},[_vm._v("Сохранить")]):_vm._e(),_vm._v(" "),(!_vm.task.new && _vm.allowEdit)?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":_vm.deleteTasks}},[_vm._v("Удалить")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page"},[_c('div',{staticClass:"body-panel"},[_c('div',{staticClass:"block-in-page closed"},[_c('h2',{staticClass:"margin-bottom-20 block-in-page-collapce"},[_vm._v("Общее")]),_vm._v(" "),_c('div',{staticClass:"block-in-page-detail"},[_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-15"}),_vm._v(" "),_c('div',{staticClass:"form-field-group mob-inline"},[_c('div',{staticClass:"form-field"},[_c('div',[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.task.Name),expression:"task.Name"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-text', {'input-error': _vm.errors.has('SettingsName')}],attrs:{"maxlength":"256","type":"text","name":'SettingsName',"disabled":!_vm.allowEdit,"data-vv-as":"Название"},domProps:{"value":(_vm.task.Name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.task, "Name", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('SettingsName')))])]),_vm._v(" "),_c('div',{staticClass:"margin-top-5"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.task.VisualSettings.AnswerBtnAddText),expression:"task.VisualSettings.AnswerBtnAddText"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-text', {'input-error': _vm.errors.has('AnswerBtnAddText')}],attrs:{"maxlength":"256","type":"text","name":'AnswerBtnAddText',"disabled":!_vm.allowEdit,"data-vv-as":"Название кнопки добавления ответа"},domProps:{"value":(_vm.task.VisualSettings.AnswerBtnAddText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.task.VisualSettings, "AnswerBtnAddText", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('AnswerBtnAddText')))])])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('div',[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-text', {'input-error': _vm.errors.has('StartDateFormatted')}],attrs:{"name":"StartDateFormatted","disabled":!_vm.allowEdit,"todayHighlight":"true","data-vv-as":"Дата начала"},on:{"input":function($event){return _vm.onChangeDate(_vm.task, 'StartDateFormatted', 'StartDate')}},model:{value:(_vm.task.StartDateFormatted),callback:function ($$v) {_vm.$set(_vm.task, "StartDateFormatted", $$v)},expression:"task.StartDateFormatted"}})],1),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('StartDateFormatted')))])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"2px"}},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-text', {'input-error': _vm.errors.has('EndDateFormatted')}],attrs:{"name":"EndDateFormatted","disabled":!_vm.allowEdit,"todayHighlight":"true","data-vv-as":"Дата окончания"},on:{"input":function($event){return _vm.onChangeDate(_vm.task, 'EndDateFormatted', 'EndDate')}},model:{value:(_vm.task.EndDateFormatted),callback:function ($$v) {_vm.$set(_vm.task, "EndDateFormatted", $$v)},expression:"task.EndDateFormatted"}})],1),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('EndDateFormatted')))])]),_vm._v(" "),_c('div',{staticClass:"margin-top-3"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Тип задания")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.taskTypeItems,"dataField":'Value',"textField":'Name',"disabled":!_vm.allowEdit},on:{"change":function($event){return _vm.onTaskTypeChange()}},model:{value:(_vm.task.TaskType),callback:function ($$v) {_vm.$set(_vm.task, "TaskType", $$v)},expression:"task.TaskType"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-field with-upload-zone"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Вложения")]),_vm._v(" "),_c('div',{staticClass:"flex",staticStyle:{"flex-wrap":"wrap"}},_vm._l((_vm.task.TasksAttachments),function(item,i){return _c('div',{class:['', {'thumbnail-img-file' : !item.isImage}, {'task-photo thumbnail-img' : item.isImage}]},[(!item.isImage)?[(item.TypeId==='docx')?_c('svg',{staticClass:"tasks-svg svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg?v2#Docx"}})]):_vm._e(),_vm._v(" "),(item.TypeId==='xlsx')?_c('svg',{staticClass:"tasks-svg svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg?v2#Xlsx"}})]):_vm._e(),_vm._v(" "),(item.TypeId==='pdf')?_c('svg',{staticClass:"tasks-svg svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg?v2#Pdf"}})]):_vm._e(),_vm._v(" "),(item.FileData)?_c('span',[_vm._v(_vm._s(item.FilePath))]):_vm._e(),_vm._v(" "),(!item.FileData && item.FilePath)?_c('a',{attrs:{"target":"_blank","href":item.FilePath}},[_vm._v("\n                                                    "+_vm._s(item.FileName)+"\n                                                ")]):_vm._e(),_vm._v(" "),(_vm.allowEdit)?_c('div',{staticClass:"thumbnail-img-delete",on:{"click":function($event){return _vm.onRemoveAttachment(i)}}}):_vm._e()]:_vm._e(),_vm._v(" "),(item.isImage)?[(item.FileData)?_c('a',{staticClass:"lightzoom",attrs:{"target":"_blank","rel":"group"}},[_c('img',{attrs:{"src":item.FileData}})]):_vm._e(),_vm._v(" "),(!item.FileData && item.FilePath)?_c('a',{staticClass:"lightzoom",attrs:{"target":"_blank","href":item.FilePath,"rel":"group"}},[_c('img',{attrs:{"src":item.FilePath}})]):_vm._e(),_vm._v(" "),(_vm.allowEdit)?_c('button',{staticClass:"btn btn-default btn-img",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onRemoveAttachment(i)}}},[_c('img',{attrs:{"src":__webpack_require__(17),"alt":""}})]):_vm._e()]:_vm._e()],2)}),0),_vm._v(" "),(_vm.allowEdit)?_c('div',{staticClass:"file-upload-zone"},[_c('drop-zone',{staticClass:"drop-area",on:{"files-dropped":_vm.onAttachFiles}},[_c('input',{ref:"dropFiles2",staticClass:"file-upload-zone-btn",attrs:{"type":"file","id":"dropFiles2","name":"dropFiles2","accept":".jpg,.jpeg,.png,.pdf,.docx,.xlsx","multiple":""}}),_vm._v(" "),_c('label',{staticClass:"file-upload-zone-lbl",attrs:{"id":"dropFiles2BtnLbl","for":"dropFiles2"}},[_vm._v("Перетащите файлы или нажмите, чтобы выбрать")])])],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"margin-top-5"},[_vm._m(4),_vm._v(" "),_c('froala-editor',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"SettingsDescription",class:[{'input-error': _vm.errors.has('SettingsDescription')}],attrs:{"name":"SettingsDescription","disabled":!_vm.allowEdit},model:{value:(_vm.task.Caption),callback:function ($$v) {_vm.$set(_vm.task, "Caption", $$v)},expression:"task.Caption"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('SettingsDescription')))])],1)])]),_vm._v(" "),_c('div',{staticClass:"block-in-page closed"},[_c('h2',{staticClass:"margin-bottom-20 block-in-page-collapce"},[_vm._v("Настройки")]),_vm._v(" "),_c('div',{staticClass:"block-in-page-detail"},[_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-15"}),_vm._v(" "),_c('div',{staticClass:"form-field-group mob-inline"},[_c('div',{staticClass:"form-field"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"margin-top-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.task.FixTT),expression:"task.FixTT"}],staticClass:"input-checkbox",attrs:{"name":"FixTT","id":"FixTT","value":"true","type":"checkbox","disabled":!_vm.allowEdit},domProps:{"checked":Array.isArray(_vm.task.FixTT)?_vm._i(_vm.task.FixTT,"true")>-1:(_vm.task.FixTT)},on:{"change":[function($event){var $$a=_vm.task.FixTT,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.task, "FixTT", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.task, "FixTT", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.task, "FixTT", $$c)}},function($event){return _vm.onFixTTChange()}]}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"FixTT"}},[_vm._v("Фиксировать торговую точку")])]),_vm._v(" "),_c('div',{staticClass:"margin-top-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.task.DenyExecutionOnSite),expression:"task.DenyExecutionOnSite"}],staticClass:"input-checkbox",attrs:{"name":"DenyExecutionOnSite","id":"DenyExecutionOnSite","value":"true","type":"checkbox","disabled":!_vm.allowEdit},domProps:{"checked":Array.isArray(_vm.task.DenyExecutionOnSite)?_vm._i(_vm.task.DenyExecutionOnSite,"true")>-1:(_vm.task.DenyExecutionOnSite)},on:{"change":function($event){var $$a=_vm.task.DenyExecutionOnSite,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.task, "DenyExecutionOnSite", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.task, "DenyExecutionOnSite", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.task, "DenyExecutionOnSite", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"DenyExecutionOnSite"}},[_vm._v("Запретить выполнение задания через сайт")])]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('div',{staticClass:"margin-top-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.task.AllowToAttachPhotoMP),expression:"task.AllowToAttachPhotoMP"}],staticClass:"input-checkbox",attrs:{"name":"AllowToAttachPhotoMP","id":"AllowToAttachPhotoMP","value":"true","type":"checkbox","disabled":!_vm.allowEdit},domProps:{"checked":Array.isArray(_vm.task.AllowToAttachPhotoMP)?_vm._i(_vm.task.AllowToAttachPhotoMP,"true")>-1:(_vm.task.AllowToAttachPhotoMP)},on:{"change":function($event){var $$a=_vm.task.AllowToAttachPhotoMP,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.task, "AllowToAttachPhotoMP", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.task, "AllowToAttachPhotoMP", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.task, "AllowToAttachPhotoMP", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"AllowToAttachPhotoMP"}},[_vm._v("Разрешить прикреплять фото из галереи в мобильном приложении")])]),_vm._v(" "),_c('div',{staticClass:"margin-top-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.task.RunInStore),expression:"task.RunInStore"}],staticClass:"input-checkbox",attrs:{"name":"RunInStore","id":"RunInStore","value":"true","type":"checkbox","disabled":!_vm.allowEdit || !_vm.task.FixTT},domProps:{"checked":Array.isArray(_vm.task.RunInStore)?_vm._i(_vm.task.RunInStore,"true")>-1:(_vm.task.RunInStore)},on:{"change":function($event){var $$a=_vm.task.RunInStore,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.task, "RunInStore", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.task, "RunInStore", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.task, "RunInStore", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"RunInStore"}},[_vm._v("Выполнение задания возможно только в точке")])])])])])]),_vm._v(" "),_c('div',{staticClass:"block-in-page closed"},[_c('h2',{staticClass:"margin-bottom-20 block-in-page-collapce"},[_vm._v("Поля задания")]),_vm._v(" "),_c('div',{staticClass:"block-in-page-detail"},[_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-15"}),_vm._v(" "),_c('div',{staticClass:"form-field-group mob-inline"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Тип ввода")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.fieldInputTypes,"dataField":'Value',"textField":'Name',"disabled":!_vm.allowEdit},model:{value:(_vm.task.FieldInputType),callback:function ($$v) {_vm.$set(_vm.task, "FieldInputType", $$v)},expression:"task.FieldInputType"}})],1),_vm._v(" "),(_vm.task.FieldInputType === _vm.FieldType.Table)?[_c('div',{staticClass:"form-field"},[_vm._m(7),_vm._v(" "),_c('touch-spin',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],class:['input-text', {'input-error': _vm.errors.has('FieldTableMinRows')}],attrs:{"name":"FieldTableMinRows","decimals":0,"step":1.00,"min":1,"max":45,"disabled":!_vm.allowEdit,"data-vv-as":"Значение"},on:{"change":function($event){return _vm.onTableRowsChange('min')}},model:{value:(_vm.task.FieldTableMinRows),callback:function ($$v) {_vm.$set(_vm.task, "FieldTableMinRows", $$v)},expression:"task.FieldTableMinRows"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('FieldTableMinRows')))])],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                            Сколько строк может добавить участник\n                                        ")]),_vm._v(" "),_c('touch-spin',{class:['input-text'],attrs:{"name":"FieldTableMaxRows","decimals":0,"step":1.00,"max":45,"disabled":!_vm.allowEdit},on:{"change":function($event){return _vm.onTableRowsChange('max')}},model:{value:(_vm.task.FieldTableMaxRows),callback:function ($$v) {_vm.$set(_vm.task, "FieldTableMaxRows", $$v)},expression:"task.FieldTableMaxRows"}})],1)]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-15"}),_vm._v(" "),_c('Container',{attrs:{"lock-axis":'y'},on:{"drop":_vm.onFieldSettingsDrop}},_vm._l((_vm.fieldSettingsOrdered),function(settings,i){return _c('Draggable',[_c('div',{staticClass:"draggable-item"},[_c('div',{staticClass:"form-field-group mob-inline"},[_c('div',{staticClass:"form-field"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                                        Название поля в ответе\n                                                        "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(settings.name),expression:"settings.name"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"input-text",class:['input-text', {'input-error': _vm.errors.has('settingsName' + i)}],attrs:{"type":"text","placeholder":"Название","maxlength":"245","name":'settingsName' + i,"disabled":!_vm.allowEdit,"data-vv-as":"Название"},domProps:{"value":(settings.name)},on:{"change":function($event){return _vm.onSettingsFieldChange(settings)},"input":function($event){if($event.target.composing){ return; }_vm.$set(settings, "name", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('settingsName' + i)))])]),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-5"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                                        Тип поля\n                                                    ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.getFieldSettingsTypes(settings),"dataField":'Id',"textField":'Name',"disabled":!_vm.allowEdit},on:{"change":function($event){return _vm.onSettingsFieldChange(settings)}},model:{value:(settings.type),callback:function ($$v) {_vm.$set(settings, "type", $$v)},expression:"settings.type"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                                        Описание\n                                                    ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(settings.description),expression:"settings.description"}],class:['input-memo', {'input-error': _vm.errors.has('SettingsDescription' + i)}],staticStyle:{"height":"70px"},attrs:{"maxlength":"245","name":'SettingsDescription' + i,"disabled":!_vm.allowEdit,"data-vv-as":"Описание"},domProps:{"value":(settings.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(settings, "description", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(settings.deleted),expression:"settings.deleted"}],staticClass:"input-checkbox",attrs:{"id":'settingsDeleted' + i,"name":'settingsDeleted' + i,"value":"true","type":"checkbox","disabled":!_vm.allowEdit},domProps:{"checked":Array.isArray(settings.deleted)?_vm._i(settings.deleted,"true")>-1:(settings.deleted)},on:{"change":[function($event){var $$a=settings.deleted,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(settings, "deleted", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(settings, "deleted", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(settings, "deleted", $$c)}},function($event){return _vm.onSettingsFieldChange(settings)}]}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",staticStyle:{"margin-top":"0"},attrs:{"for":'settingsDeleted' + i}},[_vm._v("Отключить поле")])])]),_vm._v(" "),(settings.type === 'sku')?_c('div',{staticClass:"form-field flex",staticStyle:{"width":"200px","min-width":"200px","padding-top":"23px"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.skuSetUpSelection(settings)}}},[_vm._v("Настроить выбор")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.skuSetUpList(_vm.task.skuList)}}},[_vm._v("Настроить SKU")])]):_vm._e(),_vm._v(" "),((_vm.task.new || settings.new) && _vm.allowEdit)?_c('div',{staticClass:"form-field",staticStyle:{"width":"35px","min-width":"35px","padding-top":"23px"}},[_c('button',{staticClass:"btn btn-default btn-img",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onRemoveFieldSettings(settings, i)}}},[_c('img',{attrs:{"src":__webpack_require__(17),"alt":""}})])]):_vm._e()]),_vm._v(" "),(settings.type === 'attach')?_c('div',{staticClass:"margin-top-5"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                                Выберите тип допустимых вложений\n                                                "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"form-field-group margin-top-5"},[_c('div',{staticClass:"form-field",staticStyle:{"width":"auto"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(settings.attach_photo),expression:"settings.attach_photo"}],staticClass:"input-checkbox",attrs:{"id":'PhotoFilesEnable' + i,"name":'PhotoFilesEnable' + i,"value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(settings.attach_photo)?_vm._i(settings.attach_photo,"true")>-1:(settings.attach_photo)},on:{"change":function($event){var $$a=settings.attach_photo,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(settings, "attach_photo", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(settings, "attach_photo", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(settings, "attach_photo", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",staticStyle:{"margin-top":"0"},attrs:{"for":'PhotoFilesEnable' + i}},[_vm._v("JPG, JPEG, PNG")])]),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"auto"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(settings.attach_doc),expression:"settings.attach_doc"}],staticClass:"input-checkbox",attrs:{"id":'DocFilesEnable' + i,"name":'DocFilesEnable' + i,"value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(settings.attach_doc)?_vm._i(settings.attach_doc,"true")>-1:(settings.attach_doc)},on:{"change":function($event){var $$a=settings.attach_doc,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(settings, "attach_doc", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(settings, "attach_doc", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(settings, "attach_doc", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",staticStyle:{"margin-top":"0"},attrs:{"for":'DocFilesEnable' + i}},[_vm._v("Excel, Word")])])])]):_vm._e(),_vm._v(" "),(settings.type === 'select')?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                                Массив вариантов выпадающего списка в формате [\"Вариант-1\", \"Вариант-2\"]"),_c('br'),_vm._v(" "),_c('span',{staticClass:"test-wrong"},[_vm._v("Двойные кавычки используются только для обозначения границ слова")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(settings.options),expression:"settings.options"},{name:"validate",rawName:"v-validate",value:({required: true, jsonArray: true}),expression:"{required: true, jsonArray: true}"}],class:['input-text', {'input-error': _vm.errors.has('settingsNameSelect' + i)}],attrs:{"type":"text","name":'settingsNameSelect' + i,"placeholder":"Массив вариантов через запятую, напр.: [\"Вариант-1\", \"Вариант-2\"]","data-vv-as":"Массив","disabled":!_vm.allowEdit},domProps:{"value":(settings.options)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(settings, "options", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('settingsNameSelect' + i)))])]):_vm._e(),_vm._v(" "),(settings.type === 'string')?_c('div',{staticClass:"form-field margin-top-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(settings.scanner),expression:"settings.scanner"}],staticClass:"input-checkbox",attrs:{"name":'settingsNameString' + i,"id":'settingsNameString' + i,"value":"true","type":"checkbox","disabled":!_vm.allowEdit},domProps:{"checked":Array.isArray(settings.scanner)?_vm._i(settings.scanner,"true")>-1:(settings.scanner)},on:{"change":function($event){var $$a=settings.scanner,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(settings, "scanner", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(settings, "scanner", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(settings, "scanner", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'settingsNameString' + i}},[_vm._v("Сканер")])]):_vm._e()])])}),1),_vm._v(" "),(_vm.allowEdit)?_c('button',{staticClass:"btn btn-primary margin-top-15 btn-img",attrs:{"type":"button"},on:{"click":function($event){return _vm.addFieldSettings()}}},[_c('img',{attrs:{"src":__webpack_require__(43),"alt":""}})]):_vm._e()],1)]),_vm._v(" "),(_vm.task.TaskType === _vm.TaskTypes.Cumulative)?_c('div',{staticClass:"block-in-page closed"},[_c('h2',{staticClass:"margin-bottom-20 block-in-page-collapce"},[_vm._v("Цель")]),_vm._v(" "),_c('div',{staticClass:"block-in-page-detail"},[_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-15"}),_vm._v(" "),(_vm.task.FixTT && _vm.task.PurposeType === _vm.PurposeType.Count)?_c('div',{staticClass:"form-field-group mob-inline"},[_c('div',{staticClass:"margin-bottom-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.task.PurposeOneAnswerTT),expression:"task.PurposeOneAnswerTT"}],staticClass:"input-checkbox",attrs:{"name":"PurposeOneAnswerTT","id":"PurposeOneAnswerTT","value":"true","type":"checkbox","disabled":!_vm.allowEdit},domProps:{"checked":Array.isArray(_vm.task.PurposeOneAnswerTT)?_vm._i(_vm.task.PurposeOneAnswerTT,"true")>-1:(_vm.task.PurposeOneAnswerTT)},on:{"change":[function($event){var $$a=_vm.task.PurposeOneAnswerTT,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.task, "PurposeOneAnswerTT", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.task, "PurposeOneAnswerTT", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.task, "PurposeOneAnswerTT", $$c)}},function($event){return _vm.onPurposeOneAnswerTTChange()}]}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"PurposeOneAnswerTT"}},[_vm._v("Требуется один ответ с торговой точки")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field-group mob-inline"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Тип цели")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.purposeTypeItems,"dataField":'Value',"textField":'Name',"disabled":!_vm.allowEdit || _vm.task.PurposeOneAnswerTT},model:{value:(_vm.task.PurposeType),callback:function ($$v) {_vm.$set(_vm.task, "PurposeType", $$v)},expression:"task.PurposeType"}})],1),_vm._v(" "),(!_vm.numberFieldExist && _vm.task.PurposeType === _vm.PurposeType.Summ)?_c('div',{staticClass:"error"},[_vm._v("\n                                    Необходимо добавить хотя бы одно числовое поле\n                                ")]):_vm._e(),_vm._v(" "),(_vm.numberFieldExist && _vm.task.PurposeType === _vm.PurposeType.Summ)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Выбор поля ответа")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.purposeFieldItems,"dataField":'Value',"textField":'Name',"disabled":!_vm.allowEdit},model:{value:(_vm.task.PurposeField),callback:function ($$v) {_vm.$set(_vm.task, "PurposeField", $$v)},expression:"task.PurposeField"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(8),_vm._v(" "),_c('touch-spin',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],class:['input-text', {'input-error': _vm.errors.has('PurposeValue')}],attrs:{"name":"PurposeValue","decimals":0,"step":1.00,"min":1,"disabled":!_vm.allowEdit || _vm.task.PurposeOneAnswerTT,"data-vv-as":"Значение"},model:{value:(_vm.task.PurposeValue),callback:function ($$v) {_vm.$set(_vm.task, "PurposeValue", $$v)},expression:"task.PurposeValue"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('PurposeValue')))])],1)]),_vm._v(" "),(_vm.task.PurposeOneAnswerTT)?_c('div',{staticClass:"form-field-group mob-inline"},[_c('div',{staticClass:"form-field"},[_vm._m(9),_vm._v(" "),_c('input-time',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],class:['input-text', {'input-error': _vm.errors.has('PurposeTimeToCompleteFormatted')}],attrs:{"name":"PurposeTimeToCompleteFormatted","showSeconds":"true","maxHours":"8760","disabled":!_vm.allowEdit,"data-vv-as":"Значение"},on:{"input":function($event){return _vm.onChangePurposeTimeToComplete(_vm.task, 'PurposeTimeToCompleteFormatted', 'PurposeTimeToComplete')}},model:{value:(_vm.task.PurposeTimeToCompleteFormatted),callback:function ($$v) {_vm.$set(_vm.task, "PurposeTimeToCompleteFormatted", $$v)},expression:"task.PurposeTimeToCompleteFormatted"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('PurposeTimeToCompleteFormatted')))])],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(10),_vm._v(" "),_c('input-time',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],class:['input-text', {'input-error': _vm.errors.has('PurposeAllowAfterCompleteFormatted')}],attrs:{"name":"PurposeAllowAfterCompleteFormatted","showSeconds":"true","maxHours":"8760","disabled":!_vm.allowEdit,"data-vv-as":"Значение"},on:{"input":function($event){return _vm.onChangePurposeTimeToComplete(_vm.task, 'PurposeAllowAfterCompleteFormatted', 'PurposeAllowAfterComplete')}},model:{value:(_vm.task.PurposeAllowAfterCompleteFormatted),callback:function ($$v) {_vm.$set(_vm.task, "PurposeAllowAfterCompleteFormatted", $$v)},expression:"task.PurposeAllowAfterCompleteFormatted"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('PurposeAllowAfterCompleteFormatted')))])],1)]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"block-in-page closed"},[_c('h2',{staticClass:"margin-bottom-20 block-in-page-collapce"},[_vm._v(_vm._s(_vm.scoringHeader))]),_vm._v(" "),_c('div',{staticClass:"block-in-page-detail"},[_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-15"}),_vm._v(" "),_c('div',{staticClass:"form-field-group mob-inline"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Вариант начисления")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.scoringAccrualItems,"dataField":'Value',"textField":'Name',"disabled":!_vm.allowEdit},on:{"change":function($event){return _vm.purposeFieldItemsChange()}},model:{value:(_vm.task.ScoringAccrual),callback:function ($$v) {_vm.$set(_vm.task, "ScoringAccrual", $$v)},expression:"task.ScoringAccrual"}})],1),_vm._v(" "),(_vm.task.ScoringAccrual === _vm.ScoringAccrualTypes.DependingOnSku)?_c('div',{staticClass:"form-field",staticStyle:{"width":"200px","min-width":"200px","padding-top":"23px"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.skuSetUpList(_vm.task.skuList)}}},[_vm._v("Настроить SKU")])]):_vm._e(),_vm._v(" "),[(!_vm.numberFieldExist && _vm.task.ScoringAccrual === _vm.ScoringAccrualTypes.SumPercent)?_c('div',{staticClass:"error"},[_vm._v("\n                                        Необходимо добавить хотя бы одно числовое поле\n                                    ")]):_vm._e(),_vm._v(" "),(_vm.numberFieldExist && _vm.task.ScoringAccrual === _vm.ScoringAccrualTypes.SumPercent || _vm.task.ScoringAccrual === _vm.ScoringAccrualTypes.DependingOnSku)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v(_vm._s(_vm.task.ScoringAccrual === _vm.ScoringAccrualTypes.DependingOnSku ? 'Множитель' : 'Выберите поле для суммы'))]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.scoringAccrualField,"dataField":'Value',"textField":'Name',"disabled":!_vm.allowEdit},model:{value:(_vm.task.ScoringAccrualField),callback:function ($$v) {_vm.$set(_vm.task, "ScoringAccrualField", $$v)},expression:"task.ScoringAccrualField"}})],1):_vm._e()],_vm._v(" "),(_vm.task.ScoringAccrual !== _vm.ScoringAccrualTypes.DependingOnSku)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        "+_vm._s(_vm.scoringAccrualHeader)+"\n                                        "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])]),_vm._v(" "),_c('touch-spin',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],class:['input-text', {'input-error': _vm.errors.has('ScoringAccrualSum')}],attrs:{"name":"ScoringAccrualSum","min":0,"decimals":2,"step":0.01,"disabled":!_vm.allowEdit,"data-vv-as":(_vm.scoringAccrualHeader)},model:{value:(_vm.task.ScoringAccrualSum),callback:function ($$v) {_vm.$set(_vm.task, "ScoringAccrualSum", $$v)},expression:"task.ScoringAccrualSum"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('ScoringAccrualSum')))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Текст в плашке задания (за что баллы)\n                                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.task.ScoringAccrualText),expression:"task.ScoringAccrualText"}],staticClass:"input-text",attrs:{"type":"text","placeholder":"баллов в награду","maxlength":"50","name":'scoringAccrualText',"disabled":!_vm.allowEdit},domProps:{"value":(_vm.task.ScoringAccrualText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.task, "ScoringAccrualText", $event.target.value)}}})])],2),_vm._v(" "),_c('div',{staticClass:"form-field-group margin-top-5 mob-inline"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Активировать баллы")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.scoringActivationPeriod,"dataField":'Value',"textField":'Name',"disabled":!_vm.allowEdit},on:{"change":function($event){return _vm.scoringActivationPeriodChange()}},model:{value:(_vm.task.ScoringActivationPeriod),callback:function ($$v) {_vm.$set(_vm.task, "ScoringActivationPeriod", $$v)},expression:"task.ScoringActivationPeriod"}})],1),_vm._v(" "),(_vm.task.ScoringActivationPeriod === _vm.ScoringActivation.CumulativeForPeriod)?_c('div',{staticClass:"form-field"},[_vm._m(11),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.scoringActivationPeriodField,"dataField":'Value',"textField":'Name',"disabled":!_vm.allowEdit},model:{value:(_vm.task.ScoringActivationPeriodField),callback:function ($$v) {_vm.$set(_vm.task, "ScoringActivationPeriodField", $$v)},expression:"task.ScoringActivationPeriodField"}})],1):_vm._e(),_vm._v(" "),(_vm.task.ScoringActivationPeriod !== _vm.ScoringActivation.OnDay)?_c('div',{staticClass:"form-field"},[_vm._m(12),_vm._v(" "),_c('touch-spin',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],class:['input-text', {'input-error': _vm.errors.has('ScoringActivationCount')}],attrs:{"name":"ScoringActivationCount","decimals":0,"step":1.00,"disabled":!_vm.allowEdit,"data-vv-as":"Значение"},model:{value:(_vm.task.ScoringActivationCount),callback:function ($$v) {_vm.$set(_vm.task, "ScoringActivationCount", $$v)},expression:"task.ScoringActivationCount"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('ScoringActivationCount')))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Срок сгорания баллов")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.scoringBurningTime,"dataField":'Value',"textField":'Name',"disabled":!_vm.allowEdit},model:{value:(_vm.task.ScoringBurningTime),callback:function ($$v) {_vm.$set(_vm.task, "ScoringBurningTime", $$v)},expression:"task.ScoringBurningTime"}})],1),_vm._v(" "),(_vm.task.ScoringBurningTime === _vm.ScoringBurningTime.InDays)?_c('div',{staticClass:"form-field"},[_vm._m(13),_vm._v(" "),_c('touch-spin',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],class:['input-text', {'input-error': _vm.errors.has('ScoringBurningCount')}],attrs:{"name":"ScoringBurningCount","decimals":0,"step":1.00,"disabled":!_vm.allowEdit,"data-vv-as":"Значение"},model:{value:(_vm.task.ScoringBurningCount),callback:function ($$v) {_vm.$set(_vm.task, "ScoringBurningCount", $$v)},expression:"task.ScoringBurningCount"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('ScoringBurningCount')))])],1):_vm._e(),_vm._v(" "),(_vm.task.ScoringBurningTime === _vm.ScoringBurningTime.OnDate)?_c('div',{staticClass:"form-field"},[_vm._m(14),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-text', {'input-error': _vm.errors.has('ScoringBurningDateFormatted')}],attrs:{"name":"ScoringBurningDateFormatted","disabled":!_vm.allowEdit,"todayHighlight":"true","data-vv-as":"Значение"},on:{"input":function($event){return _vm.onChangeDate(_vm.task, 'ScoringBurningDateFormatted', 'ScoringBurningDate')}},model:{value:(_vm.task.ScoringBurningDateFormatted),callback:function ($$v) {_vm.$set(_vm.task, "ScoringBurningDateFormatted", $$v)},expression:"task.ScoringBurningDateFormatted"}})],1),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('ScoringBurningDateFormatted')))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"block-in-page closed"},[_c('h2',{staticClass:"margin-bottom-20 block-in-page-collapce"},[_vm._v("Фильтр участников")]),_vm._v(" "),_c('div',{staticClass:"block-in-page-detail"},[_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.task.MemberFilterActivation),expression:"task.MemberFilterActivation"}],staticClass:"input-checkbox",attrs:{"name":"MemberFilterActivation","id":"MemberFilterActivation","value":"true","type":"checkbox","disabled":!_vm.allowEdit},domProps:{"checked":Array.isArray(_vm.task.MemberFilterActivation)?_vm._i(_vm.task.MemberFilterActivation,"true")>-1:(_vm.task.MemberFilterActivation)},on:{"change":[function($event){var $$a=_vm.task.MemberFilterActivation,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.task, "MemberFilterActivation", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.task, "MemberFilterActivation", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.task, "MemberFilterActivation", $$c)}},function($event){return _vm.changedFilterActivation()}]}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"MemberFilterActivation"}},[_vm._v("Активация фильтра")])]),_vm._v(" "),(_vm.task.MemberFilterActivation)?[_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-15"}),_vm._v(" "),_c('div',{staticClass:"form-field-group mob-inline"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Тип фильтра")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.memberFilterVariant,"dataField":'Value',"textField":'Name',"disabled":!_vm.allowEdit},on:{"change":function($event){return _vm.changedFilterVariant()}},model:{value:(_vm.task.MemberFilterVariant),callback:function ($$v) {_vm.$set(_vm.task, "MemberFilterVariant", $$v)},expression:"task.MemberFilterVariant"}})],1),_vm._v(" "),(_vm.task.MemberFilterVariant === _vm.MemberFilters.Users)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Выберите участников")]),_vm._v(" "),_c('checked-down',{attrs:{"items":_vm.memberFilterUsers,"dataField":'UserId',"textField":'UserFio',"idPref":'filteruser',"disabled":!_vm.allowEdit},on:{"onBottomScrolled":_vm.onCheckedDownScroll},model:{value:(_vm.task.MemberFilterUsers),callback:function ($$v) {_vm.$set(_vm.task, "MemberFilterUsers", $$v)},expression:"task.MemberFilterUsers"}})],1):(_vm.task.MemberFilterVariant === _vm.MemberFilters.TradePoints)?[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Выберите поле для фильтра")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.memberFilterField,"dataField":'Value',"textField":'Name',"disabled":!_vm.allowEdit},on:{"change":function($event){return _vm.changedFilterField()}},model:{value:(_vm.task.MemberFilterField),callback:function ($$v) {_vm.$set(_vm.task, "MemberFilterField", $$v)},expression:"task.MemberFilterField"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Значения")]),_vm._v(" "),_c('checked-down',{attrs:{"items":_vm.memberFilterValue,"name":_vm.task.MemberFilterField,"dataField":'Id',"textField":'Name',"idPref":'filtervalue',"disabled":!_vm.allowEdit},on:{"onBottomScrolled":_vm.onCheckedDownScroll},model:{value:(_vm.task.MemberFilterValue),callback:function ($$v) {_vm.$set(_vm.task, "MemberFilterValue", $$v)},expression:"task.MemberFilterValue"}})],1)]:(_vm.task.MemberFilterVariant === _vm.MemberFilters.Roles)?[_c('div',{staticClass:"form-field"},[_c('div',[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Выберите роль для фильтра")]),_vm._v(" "),_c('checked-down',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],attrs:{"items":_vm.memberFilterRoles,"name":'MemberFilterFieldRoles',"dataField":'Value',"textField":'Name',"idPref":'filterrole',"disabled":!_vm.allowEdit,"hasErrors":_vm.errors.has('MemberFilterFieldRoles'),"data-vv-as":"Роль для фильтра"},on:{"change":function($event){return _vm.changedMemberFilterRole()}},model:{value:(_vm.task.MemberFilterField.Roles),callback:function ($$v) {_vm.$set(_vm.task.MemberFilterField, "Roles", $$v)},expression:"task.MemberFilterField.Roles"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('MemberFilterFieldRoles')))])],1),_vm._v(" "),(_vm.useGradeOnSelectedRoles)?_c('div',{},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Выберите грейд для фильтра")]),_vm._v(" "),_c('checked-down',{attrs:{"items":_vm.memberFilterGrades,"dataField":'Value',"textField":'Name',"idPref":'filtergrade',"disabled":!_vm.allowEdit},on:{"change":function($event){return _vm.changedMemberFilterGrade()}},model:{value:(_vm.task.MemberFilterField.Grades),callback:function ($$v) {_vm.$set(_vm.task.MemberFilterField, "Grades", $$v)},expression:"task.MemberFilterField.Grades"}})],1):_vm._e()])]:_vm._e()],2)]:_vm._e()],2)])])])]:_vm._e(),_vm._v(" "),_c('popup-window',{ref:"ppSkuFieldSettings",attrs:{"title":'Настройка отображения полей SKU в текущем задании',"width":800}},[_c('p',{staticClass:"caption-help"},[_vm._v("Настройка отображения и использования полей справочника в текущем задании")]),_vm._v(" "),_c('table',{staticClass:"table-view",attrs:{"id":"tSkuFieldSett"}},[_c('thead',{staticClass:"head-show"},[_c('tr',{staticClass:"heading"},[_c('th',[_vm._v("Название поля")]),_vm._v(" "),_c('th',[_vm._v("Осуществлять поиск")]),_vm._v(" "),_c('th',[_vm._v("Сцепить для показа")])])]),_vm._v(" "),(_vm.dialogSkuSettings != null)?_c('tbody',_vm._l((_vm.skuSettingsOrdered),function(skuSettingsItem,s){return _c('tr',{key:s},[_c('td',[_vm._v("\n                            "+_vm._s(skuSettingsItem.Title)+"\n                        ")]),_vm._v(" "),_c('td',{staticClass:"bit"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(skuSettingsItem.search),expression:"skuSettingsItem.search"}],staticClass:"input-checkbox",attrs:{"id":'list' + s,"name":'list' + s,"value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(skuSettingsItem.search)?_vm._i(skuSettingsItem.search,"true")>-1:(skuSettingsItem.search)},on:{"change":function($event){var $$a=skuSettingsItem.search,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(skuSettingsItem, "search", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(skuSettingsItem, "search", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(skuSettingsItem, "search", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl no-text",attrs:{"for":'list' + s}})]),_vm._v(" "),_c('td',{staticClass:"bit"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(skuSettingsItem.attached),expression:"skuSettingsItem.attached"}],staticClass:"input-checkbox",attrs:{"id":'det' + s,"name":'det' + s,"value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(skuSettingsItem.attached)?_vm._i(skuSettingsItem.attached,"true")>-1:(skuSettingsItem.attached)},on:{"change":function($event){var $$a=skuSettingsItem.attached,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(skuSettingsItem, "attached", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(skuSettingsItem, "attached", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(skuSettingsItem, "attached", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl no-text",attrs:{"for":'det' + s}})])])}),0):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.updateSkuSelectionItem()}}},[_vm._v("Ок")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.ppSkuFieldSettings.close()}}},[_vm._v("Отмена")])])]),_vm._v(" "),_c('popup-window',{ref:"ppSkuFieldList",attrs:{"title":_vm.titlePopap,"width":800},on:{"onBottomScrolled":_vm.onSkuListScroll}},[_c('div',[_c('div',{staticClass:"control-block-left margin-bottom-10"},[_c('p',{staticClass:"caption-help"},[_vm._v(_vm._s(_vm.ppSkuFieldListCaption))])]),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[(_vm.allowEdit)?_c('div',{staticClass:"btns flex"},[_c('input',{ref:"dropFiles",staticClass:"file-upload-zone-btn",attrs:{"type":"file","id":"dropFiles","name":"dropFiles","accept":".xlsx"},on:{"change":function($event){return _vm.onFileChange()}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.onSkuListExport()}}},[_vm._v("Экспорт")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.onSkuListImport()}}},[_vm._v("Импорт")])]):_vm._e()])]),_vm._v(" "),_c('table',{staticClass:"table-view",attrs:{"id":"tSkuFieldSett"}},[_c('thead',{staticClass:"head-show"},[_c('tr',{staticClass:"heading"},[_c('th',[_vm._v("SKU")]),_vm._v(" "),_c('th',[_vm._v("Активность")]),_vm._v(" "),(_vm.dependingOnSku)?_c('th',[_vm._v("Баллы")]):_vm._e()])]),_vm._v(" "),_c('tbody',_vm._l((_vm.skuListForeach),function(ref,i){
var key = ref[0];
var sku = ref[1];
return _c('tr',[_c('td',[_vm._v(_vm._s(sku.name))]),_vm._v(" "),_c('td',{staticClass:"bit"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(sku.active),expression:"sku.active"}],staticClass:"input-checkbox",attrs:{"id":'skulist_' + i,"name":"skulist","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(sku.active)?_vm._i(sku.active,"true")>-1:(sku.active)},on:{"change":function($event){var $$a=sku.active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(sku, "active", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(sku, "active", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(sku, "active", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl no-text",attrs:{"for":'skulist_' + i}})]),_vm._v(" "),(_vm.dependingOnSku)?_c('td',{staticClass:"int"},[_c('touch-spin',{class:['input-text'],attrs:{"name":"skudet","decimals":0,"step":1.00},model:{value:(sku.bonus),callback:function ($$v) {_vm.$set(sku, "bonus", $$v)},expression:"sku.bonus"}})],1):_vm._e()])}),0)]),_vm._v(" "),_c('div',{staticClass:"popup-footer btns flex",attrs:{"slot":"footer","data-toggle":"buttons"},slot:"footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.updateSkuListItem()}}},[_vm._v("Ок")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.ppSkuFieldList.close()}}},[_vm._v("Отмена")])])]),_vm._v(" "),_c('popup-window',{ref:"ppCopyTasksSettings",attrs:{"title":'Дублировать задание',"width":600,"modal":true}},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                    Название\n                    "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.taskCopy.Name),expression:"taskCopy.Name"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-text', {'input-error': _vm.errors.has('CopySettingsName')}],attrs:{"maxlength":"256","type":"text","name":'CopySettingsName',"data-vv-as":"Название"},domProps:{"value":(_vm.taskCopy.Name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.taskCopy, "Name", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('SCopyettingsName')))])]),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-5"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                    Описание\n                    "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.taskCopy.Caption),expression:"taskCopy.Caption"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-memo', {'input-error': _vm.errors.has('CopySettingsDescription')}],attrs:{"rows":"10","maxlength":"2000","name":'CopySettingsDescription',"data-vv-as":"Описание"},domProps:{"value":(_vm.taskCopy.Caption)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.taskCopy, "Caption", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('CopySettingsDescription')))])]),_vm._v(" "),_c('div',{staticClass:"form-field flex"},[_c('div',[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                        Дата начала\n                        "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-text', {'input-error': _vm.errors.has('CopyStartDateFormatted')}],attrs:{"name":"CopyStartDateFormatted","todayHighlight":"true","data-vv-as":"Дата начала"},on:{"input":function($event){return _vm.onChangeDate(_vm.taskCopy, 'StartDateFormatted', 'StartDate')}},model:{value:(_vm.taskCopy.StartDateFormatted),callback:function ($$v) {_vm.$set(_vm.taskCopy, "StartDateFormatted", $$v)},expression:"taskCopy.StartDateFormatted"}})],1),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('CopyStartDateFormatted')))])]),_vm._v(" "),_c('div',{staticClass:"margin-left-15"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                        Дата окончания\n                        "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-text', {'input-error': _vm.errors.has('CopyEndDateFormatted')}],attrs:{"name":"CopyEndDateFormatted","todayHighlight":"true","data-vv-as":"Дата окончания"},on:{"input":function($event){return _vm.onChangeDate(_vm.taskCopy, 'EndDateFormatted', 'EndDate')}},model:{value:(_vm.taskCopy.EndDateFormatted),callback:function ($$v) {_vm.$set(_vm.taskCopy, "EndDateFormatted", $$v)},expression:"taskCopy.EndDateFormatted"}})],1),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('CopyEndDateFormatted')))])])]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.copyTasks()}}},[_vm._v("Ок")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.ppCopyTasksSettings.close()}}},[_vm._v("Отмена")])])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Задания"}})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                            Название\n                                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                            Название кнопки добавления ответа\n                                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                            Дата начала\n                                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                            Дата окончания\n                                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Описание\n                                    "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                            Общие настройки\n                                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"margin-top-20"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                            Настройки для мобильного приложения\n                                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                            Сколько пустых строк показывать\n                                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Значение цели\n                                        "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Время на выполнение задания (ЧЧ:ММ:СС)\n                                        "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Через какое время можно повторно приступить к выполнению задания (ЧЧ:ММ:СС)\n                                        "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Дата начала периода\n                                        "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Кол-во дней\n                                        "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Кол-во дней\n                                        "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Выберите дату\n                                        "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TasksDetails_vue__ = __webpack_require__(283);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c93e460_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TasksDetails_vue__ = __webpack_require__(789);
function injectStyle (ssrContext) {
  __webpack_require__(787)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c93e460"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TasksDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c93e460_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TasksDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(788);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("8cdfe530", content, true, {});

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".btn[data-v-6c93e460]{margin-right:10px}", ""]);

// exports


/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[(_vm.task != null)?[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex top-menu"},[_c('p',{staticClass:"btn-back margin-right-10"},[_c('a',{staticClass:"router-link-active",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.back.apply(null, arguments)}}},[_vm._v("Назад")])]),_vm._v(" "),(_vm.info.User && (_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.tasksEdit) || _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.tasksController) || _vm.info.User.MainRole === 'administrators'))?[_c('div',{staticClass:"form-field margin-right-20"},[_c('drop-down',{attrs:{"items":_vm.statuses,"dataField":'Id',"textField":'Name'},on:{"change":function($event){return _vm.onStatusChange($event)}},model:{value:(_vm.statusId),callback:function ($$v) {_vm.statusId=$$v},expression:"statusId"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field margin-right-20"},[_c('drop-down',{attrs:{"items":_vm.dateTypes,"dataField":'Id',"textField":'Name'},on:{"change":function($event){return _vm.onStatusChange($event)}},model:{value:(_vm.dateTypeId),callback:function ($$v) {_vm.dateTypeId=$$v},expression:"dateTypeId"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field flex"},[_c('input-date',{staticClass:"input-text input-date",attrs:{"name":"dateStart","todayHighlight":"true"},on:{"input":_vm.onDateChange},model:{value:(_vm.dateStart),callback:function ($$v) {_vm.dateStart=$$v},expression:"dateStart"}}),_vm._v(" "),_c('span',{staticClass:"margin-left-10 margin-right-10 margin-top-5"},[_vm._v("-")]),_vm._v(" "),_c('input-date',{staticClass:"input-text input-date",attrs:{"name":"dateEnd","todayHighlight":"true"},on:{"input":_vm.onDateChange},model:{value:(_vm.dateEnd),callback:function ($$v) {_vm.dateEnd=$$v},expression:"dateEnd"}})],1),_vm._v(" "),(_vm.statusId || _vm.dateStart || _vm.dateEnd || _vm.dateTypeId)?_c('div',{staticClass:"form-field margin-left-20"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.clearFilterState}},[_vm._v("Сбросить")])]):_vm._e()]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[_c('div',{class:{'flex': !_vm.isMobile}},[(_vm.selectedAnswers.length)?_c('div',{staticStyle:{"margin":"auto 10px"}},[_vm._v("\n                      Выбрано "+_vm._s(_vm.selectedAnswers.length)+" из "+_vm._s(_vm.answers.length)+"\n                    ")]):_vm._e(),_vm._v(" "),(_vm.selectedAnswers.length)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.updateMultipleAnswerStatuses(2, '')}}},[_vm._v("Принять")]):_vm._e(),_vm._v(" "),(_vm.selectedAnswers.length)?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){return _vm.btnReject(4)}}},[_vm._v("Доработать")]):_vm._e(),_vm._v(" "),(_vm.selectedAnswers.length)?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){return _vm.btnReject(5)}}},[_vm._v("Отклонить")]):_vm._e(),_vm._v(" "),(_vm.selectedAnswers.length)?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.selectedCancel()}}},[_vm._v("Отмена")]):_vm._e(),_vm._v(" "),(_vm.selectedAnswers.length)?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeAnswers()}}},[_vm._v("Удалить")]):_vm._e(),_vm._v(" "),(_vm.exportEnabled)?_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.onDetailExport()}}},[_vm._v("\n                        Выгрузка по отчетам\n                    ")]):_vm._e(),_vm._v(" "),(_vm.allowAdd)?_c('div',{key:_vm.detail.ResponsibleId,class:{'flex': !_vm.isMobile}},[_c('p',{staticClass:"caption-help margin-right-10"},[_vm._v(_vm._s(_vm.pageInfoMessage))]),_vm._v(" "),(!_vm.detail.ResponsibleBlock)?_c('div',{staticClass:"btns flex"},[(_vm.task.PurposeOneAnswerTT && _vm.detail.ResponsibleId == null)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmShow('setResponsible')}}},[_vm._v(_vm._s(_vm.detail.AnswerBtnAddText))]):_vm._e(),_vm._v(" "),(_vm.task.PurposeOneAnswerTT && _vm.detail.AllowResponsibleAdd)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmShow('setRefuse')}}},[_vm._v("Отказаться от выполнения")]):_vm._e(),_vm._v(" "),(!_vm.task.PurposeOneAnswerTT || _vm.detail.AllowResponsibleAdd)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.addAnswer}},[_vm._v(_vm._s(_vm.detail.AnswerBtnAddText))]):_vm._e()]):_vm._e()]):_vm._e()])]),_vm._v(" "),(_vm.info.User && (_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.tasksEdit) || _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.tasksController) || _vm.info.User.MainRole === 'administrators'))?_c('div',{staticClass:"body-panel-control-separator"},[_c('complex-filter',{ref:"complexFilter",attrs:{"cacheKey":'reportsComplexFilter',"filters":_vm.userFilters,"searchFunction":_vm.searchFunction,"tableName":'[dbo].[AspNetUsers]',"withTableNameInClause":true},on:{"onFilterChange":_vm.onFilterChange}})],1):_vm._e(),_vm._v(" "),(_vm.task.PurposeOneAnswerTT && _vm.allowAdd)?_c('div',{staticClass:"body-panel-control-separator"},[_c('label',{staticClass:"input-text-lbl margin-bottom-5"},[_vm._v("Торговая точка")]),_vm._v(" "),_c('search-filter',{directives:[{name:"validate",rawName:"v-validate",value:({ rules: { required: true} }),expression:"{ rules: { required: true} }"}],attrs:{"name":'TradePointName',"hasErrors":_vm.errors.has('TradePointName'),"extra":0,"placeholder":'Выберите точку из списка',"searchFunction":_vm.searchTPFunction,"selectedItem":_vm.getTPSelectedItem(_vm.tradePointSelected),"searchOnSelect":true,"scrollable":true,"disabled":_vm.detail.MyTradePoints.length < 2},on:{"onFilterChange":function($event){return _vm.onChangeTPSearch.apply(void 0, arguments)}}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page",on:{"scroll":_vm.onScroll}},[_c('div',{staticStyle:{"width":"100%"}},[_c('h1',{staticClass:"margin-bottom-20"},[_vm._v(_vm._s(_vm.task.Name))])]),_vm._v(" "),_c('div',{staticClass:"flex mob-flex-to-block"},[_c('div',{staticClass:"block-in-page task-content-info"},[_c('div',{staticClass:"block-in-page-detail"},[_c('div',{staticClass:"flex"},[_c('h2',{staticStyle:{"width":"80%"}},[_vm._v(_vm._s(_vm.task.TaskType === _vm.TaskTypes.Simple ? 'Количество выполнений' : 'Прогресс выполнения'))]),_vm._v(" "),_c('h2',{staticStyle:{"width":"20%","text-align":"right"}},[_vm._v(_vm._s(_vm.bonus.QntDone)+" "+_vm._s(_vm.task.TaskType === _vm.TaskTypes.Cumulative ? '%' : ''))])]),_vm._v(" "),_c('div',{staticClass:"margin-top-10"},[_c('span',{staticClass:"caption-help"},[_vm._v("Дата начала: "+_vm._s(_vm.task.StartDateFormatted))]),_vm._v(" "),_c('span',{staticClass:"caption-help margin-left-10"},[_vm._v(_vm._s(_vm.task.StateText))])]),_vm._v(" "),_c('div',{staticClass:"margin-top-10"},[_c('div',{staticClass:"task-count green"},[_c('span',[_vm._v("Принято")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.bonus.QntFact))])]),_vm._v(" "),_c('div',{staticClass:"task-count red"},[_c('span',[_vm._v("Отклонено")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.bonus.QntRejected))])]),_vm._v(" "),_c('div',{staticClass:"task-count blue"},[_c('span',[_vm._v("На доработке")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.bonus.QntBeingFinalized))])]),_vm._v(" "),_c('div',{staticClass:"task-count yellow"},[_c('span',[_vm._v("Ждет проверки")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.bonus.QntWaitingVerification))])])]),_vm._v(" "),(_vm.task.TaskType === _vm.TaskTypes.Cumulative)?[_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-10"}),_vm._v(" "),_c('div',[_c('div',{staticClass:"tasks-progress margin-top-5"},[_c('div',{staticClass:"tasks-progress-line",style:({width: _vm.bonus.QntDone + '%'})})]),_vm._v(" "),_c('div',{staticClass:"flex margin-top-5"},[_c('div',{staticStyle:{"width":"50%"}},[_c('p',{staticClass:"input-text-lbl"},[_vm._v("План: "+_vm._s(_vm.bonus.PurposeValue))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%"}},[_c('p',{staticStyle:{"text-align":"right"}},[_vm._v("Факт: "+_vm._s(_vm.bonus.Fact))])])])])]:_vm._e(),_vm._v(" "),(_vm.task.ScoringAccrual === _vm.ScoringAccrualTypes.DependingOnSku || _vm.task.ScoringAccrualSumText!=='0')?[_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-10"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticStyle:{"width":"50%"}},[_c('p',{staticClass:"input-text-lbl"},[_vm._v("Баллов за выполнение")]),_vm._v(" "),_c('div',{class:[_vm.task.ScoringAccrual === _vm.ScoringAccrualTypes.DependingOnSku ? 'fz-24' : 'fz-50']},[_vm._v(_vm._s(_vm.task.ScoringAccrualSumText))]),_vm._v(" "),(_vm.task.ScoringAccrual === _vm.ScoringAccrualTypes.DependingOnSku)?_c('div',{staticClass:"margin-top-15"},[_c('a',{staticClass:"reglink",on:{"click":_vm.moreSKU}},[_c('span',[_vm._v("подробнее")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%"}},[_c('p',{staticClass:"input-text-lbl"},[_vm._v("Баллов получено")]),_vm._v(" "),_c('div',{staticStyle:{"color":"#32D673","font-size":"50px"}},[_vm._v(_vm._s(_vm.bonus.Scoring))])])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-15"}),_vm._v(" "),_c('div',[_c('p',{staticClass:"task-header"},[_vm._v("Описание задачи")]),_vm._v(" "),_c('p',{staticClass:"caption-help",domProps:{"innerHTML":_vm._s(_vm.task.CaptionFormatted)}})]),_vm._v(" "),(_vm.taskAttachmentsImage.length > 0 || _vm.taskAttachmentsNoImage.length > 0)?[_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-15"}),_vm._v(" "),_c('div',{staticClass:"form-field-group"},[(_vm.taskAttachmentsNoImage.length > 0)?_c('div',{staticClass:"form-field",staticStyle:{"width":"50%"}},[_c('p',{staticClass:"task-header"},[_vm._v("Файлы")]),_vm._v(" "),_c('div',{staticClass:"flex",staticStyle:{"flex-wrap":"wrap"}},_vm._l((_vm.taskAttachmentsNoImage),function(item,i){return _c('div',{staticClass:"task-photo"},[_c('a',{staticClass:"task-photo-file",attrs:{"target":"_blank","href":item.FilePath}},[(item.Extension==='docx')?_c('svg',{staticClass:"tasks-svg svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg?v2#Docx"}})]):_vm._e(),_vm._v(" "),(item.Extension==='xlsx')?_c('svg',{staticClass:"tasks-svg svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg?v2#Xlsx"}})]):_vm._e(),_vm._v(" "),(item.Extension==='pdf')?_c('svg',{staticClass:"tasks-svg svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg?v2#Pdf"}})]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.FileName))])])])}),0)]):_vm._e(),_vm._v(" "),(_vm.taskAttachmentsImage.length > 0)?_c('div',{staticClass:"form-field",staticStyle:{"width":"50%"}},[_c('p',{staticClass:"task-header"},[_vm._v("Фото")]),_vm._v(" "),_c('div',{staticClass:"flex",staticStyle:{"flex-wrap":"wrap"}},_vm._l((_vm.taskAttachmentsImage),function(item,i){return _c('div',{staticClass:"task-photo"},[_c('a',{staticClass:"lightzoom",attrs:{"target":"_blank","href":item.FilePath,"rel":"group"}},[_c('img',{attrs:{"src":item.FilePath}})])])}),0)]):_vm._e()])]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"block-in-page task-content-answer"},[_c('h2',[_vm._v("Ответы")]),_vm._v(" "),_c('table',{staticClass:"table-view margin-top-10",attrs:{"id":"dataTable"}},[_c('thead',{staticClass:"head-show"},[_c('tr',{staticClass:"heading"},[(_vm.hasClaimsOrAdmin(_vm.info.User, _vm.claimEnums.tasksController) || _vm.hasClaimsOrAdmin(_vm.info.User, _vm.claimEnums.tasksEdit))?_c('th',{staticClass:"check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectAll),expression:"selectAll"}],staticClass:"input-checkbox",attrs:{"id":"selectAll","name":"selectAll","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectAll)?_vm._i(_vm.selectAll,"true")>-1:(_vm.selectAll)},on:{"change":[function($event){var $$a=_vm.selectAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectAll=$$c}},function($event){return _vm.onSelectAllChange($event)}]}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"selectAll"}})]):_vm._e(),_vm._v(" "),_c('th',[_vm._v("ID")]),_vm._v(" "),(_vm.task.FixTT)?_c('th',[_vm._v("Торговая точка")]):_vm._e(),_vm._v(" "),(_vm.canBeShowFIO)?_c('th',[_vm._v("Пользователь")]):_vm._e(),_vm._v(" "),_c('th',[_vm._v("Дан ответ")]),_vm._v(" "),_c('th',[_vm._v("Статус")]),_vm._v(" "),_c('th',[_vm._v("Изменен статус")]),_vm._v(" "),_c('th',[_vm._v("Начислено баллов")]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.answers),function(item,i){return [[_c('tr',{on:{"click":function($event){$event.stopPropagation();return _vm.editAnswer(item.Id, item.LastStatus)}}},[(_vm.hasClaimsOrAdmin(_vm.info.User, _vm.claimEnums.tasksController) || _vm.hasClaimsOrAdmin(_vm.info.User, _vm.claimEnums.tasksEdit))?_c('td',{staticClass:"check",on:{"click":function($event){$event.stopPropagation();}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAnswers),expression:"selectedAnswers"}],staticClass:"input-checkbox",attrs:{"id":'select' + i,"type":"checkbox"},domProps:{"value":item,"checked":Array.isArray(_vm.selectedAnswers)?_vm._i(_vm.selectedAnswers,item)>-1:(_vm.selectedAnswers)},on:{"change":[function($event){var $$a=_vm.selectedAnswers,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedAnswers=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedAnswers=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedAnswers=$$c}},function($event){return _vm.onCheckChange(item)}]}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'select' + i}})]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"id"},[_vm._v(_vm._s(item.Id))]),_vm._v(" "),(_vm.task.FixTT)?_c('td',{staticClass:"string"},[_vm._v(_vm._s(item.ttName))]):_vm._e(),_vm._v(" "),(_vm.canBeShowFIO)?_c('td',{staticClass:"string"},[_vm._v(_vm._s(item.User.Fio))]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"date"},[_vm._v(_vm._s(_vm._f("date-short")(item.FillingDate)))]),_vm._v(" "),_c('td',{class:['state', _vm.getStateClass(item)]},[_vm._v(_vm._s(item.LastStatusFormatted))]),_vm._v(" "),_c('td',{staticClass:"date"},[_vm._v(_vm._s(_vm._f("date-short")(item.DateStatus)))]),_vm._v(" "),_c('td',{staticClass:"value"},[_vm._v(_vm._s(item.Scoring))]),_vm._v(" "),_c('td',{staticClass:"obtn-short-auto"},[_c('button',{staticClass:"btn",attrs:{"type":"button","title":"Открыть"},on:{"click":function($event){$event.stopPropagation();return _vm.editAnswer(item.Id, item.LastStatus)}}},[_vm._v("Открыть")])])])]]})],2)])])])])]:_vm._e(),_vm._v(" "),_c('popup-window',{ref:"ppSkuList",attrs:{"title":'Начисления баллов за каждое SKU',"width":"800"},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('div',{staticClass:"popup-footer"},[_c('div',{staticClass:"btns flex",staticStyle:{"justify-content":"flex-end"},attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeModal('ppSkuList')}}},[_vm._v("Закрыть")])])])]},proxy:true}])},[_c('div',[_c('table',{staticClass:"table-view margin-top-20"},[_c('thead',{staticStyle:{"display":"table-header-group !important"}},[_c('tr',[_c('th',[_vm._v("SKU")]),_vm._v(" "),_c('th',[_vm._v("Баллы")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.skuBonusList),function(sku){return _c('tr',[_c('td',[_vm._v(_vm._s(sku.SkuName))]),_vm._v(" "),_c('td',{staticClass:"valueshort"},[_vm._v(_vm._s(sku.Bonus))])])}),0)])])]),_vm._v(" "),_c('popup-window',{ref:"ppConfirm",attrs:{"title":'Подтверждение',"width":600}},[_c('div',{},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                    "+_vm._s(_vm.confirmText)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",staticStyle:{"justify-content":"flex-end"},attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmOk()}}},[_vm._v("Подтвердить")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.closeModal('ppConfirm')}}},[_vm._v("Отмена")])])])]),_vm._v(" "),_c('popup-window',{ref:"ppActionModal",attrs:{"title":'Обработка ответов',"modal":true}},[_c('div',{staticClass:"form-group"},[(!_vm.actionState.done)?_c('p',[_vm._v("\n          Ответ "+_vm._s(_vm.actionState.currentAnswer.index)+" / "+_vm._s(_vm.actionState.total)+" от "+_vm._s(_vm.formatDate(_vm.actionState.currentAnswer.date, 'DD.MM.YYYY HH:mm'))+" в процессе "+_vm._s(_vm.actionState.currentAnswer.time)+" сек.\n        ")]):_c('p',[(_vm.actionState.doneMessage)?[_vm._v("\n            "+_vm._s(_vm.actionState.doneMessage)+"\n          ")]:[_vm._v("\n            Обработка завершена\n          ")]],2),_vm._v(" "),_c('div',{staticClass:"margin-top-20",staticStyle:{"max-height":"300px","overflow":"auto"}},_vm._l((_vm.actionState.messages),function(m){return _c('p',{staticClass:"caption-help",style:(m.error ? 'color:red': '')},[_vm._v("\n            "+_vm._s(m.message)+"\n          ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[(_vm.actionState.done || _vm.actionState.test)?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.ppActionModalClose}},[_vm._v("Закрыть")]):_vm._e()])]),_vm._v(" "),_c('popup-window',{ref:"ppComment",attrs:{"title":_vm.popuptitle,"width":800}},[_c('div',{},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"}),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.commentStatus),expression:"commentStatus"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-memo', {'input-error': _vm.errors.has('SettingsDescription', 'edition')}],attrs:{"rows":"10","name":'SettingsDescription',"data-vv-scope":"edition"},domProps:{"value":(_vm.commentStatus)},on:{"input":function($event){if($event.target.composing){ return; }_vm.commentStatus=$event.target.value}}}),_vm._v(" "),(_vm.errors.has('SettingsDescription', 'edition'))?_c('span',{staticClass:"field-validation-valid"},[_vm._v("Заполните поле")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20 margin-bottom-20"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.tryChangeStatus()}}},[_vm._v("Принять")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.closeModal('ppComment')}}},[_vm._v("Отмена")])])])]),_vm._v(" "),_c('popup-window',{ref:"ppConfirmDelete",attrs:{"title":'Подтверждение удаления',"modal":true}},[_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("Вы уверены, что хотите удалить "+_vm._s(_vm.selectedAnswers.length)+" "+_vm._s(_vm.getAnswerWord(_vm.selectedAnswers.length))+"?")]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":_vm.confirmDeleteAnswers}},[_vm._v("Да")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.cancelDelete}},[_vm._v("Нет")])])])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Задание"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TasksAnswerEdit_vue__ = __webpack_require__(284);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52b5418e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TasksAnswerEdit_vue__ = __webpack_require__(793);
function injectStyle (ssrContext) {
  __webpack_require__(791)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52b5418e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TasksAnswerEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52b5418e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TasksAnswerEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(792);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("579e0c00", content, true, {});

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "button.img-download[data-v-52b5418e]{left:50%;position:relative;argin-left:-35px}.fancybox-inner[data-v-52b5418e]{overflow:hidden!important}.fancybox-nav[data-v-52b5418e]{width:40px!important}.thumbnail-img-file[data-v-52b5418e]{width:auto;height:50px;padding:10px 25px 10px 10px}.thumbnail-img-file .thumbnail-img-delete[data-v-52b5418e]{right:0;bottom:16px}.panel-block-large.panel-block[data-v-52b5418e]{overflow:visible;z-index:auto}.panel-block-large .panel-block-info[data-v-52b5418e]{z-index:auto}.panel-block-field[data-v-52b5418e]{width:100%}.thumbnail-img-rotateleft[data-v-52b5418e]{right:55px}.thumbnail-img-rotateright[data-v-52b5418e]{right:35px}", ""]);

// exports


/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[(_vm.task != null)?[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex mob-inline"},[_c('p',{staticClass:"btn-back margin-right-10"},[_c('a',{staticClass:"router-link-active",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.back.apply(null, arguments)}}},[_vm._v("Назад")])]),_vm._v(" "),(_vm.answerId === 0)?_c('p',{staticClass:"caption-help margin-right-10"},[_vm._v("Новый ответ")]):_vm._e(),_vm._v(" "),(_vm.answerId > 0)?_c('p',{staticClass:"caption-help margin-right-10"},[_vm._v("Статус: "+_vm._s(_vm.stateFormatted))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[(_vm.isController)?_c('div',{staticClass:"btns flex"},[_c('div',{staticClass:"svg-container margin-right-10 margin-top-3",attrs:{"v_if":"task.DenyExecutionOnSite"},on:{"click":_vm.onInfoOpen}},[_c('svg',{staticClass:"svg-icon",staticStyle:{"width":"24px","height":"24px"},attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":'/Content/dist/images.svg#MenuHelp'}})])]),_vm._v(" "),(_vm.enableBtnSave(_vm.task.LastStatusSelectAnswer.Id))?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveAnswer(null, null, true)}}},[_vm._v("Сохранить")]):_vm._e(),_vm._v(" "),(_vm.enableBtnAccept(_vm.task.LastStatusSelectAnswer.Id))?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveAnswer(2, null)}}},[_vm._v("Принять")]):_vm._e(),_vm._v(" "),(_vm.enableBtnFinalize(_vm.task.LastStatusSelectAnswer.Id))?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){return _vm.btnReject(4)}}},[_vm._v("Доработать")]):_vm._e(),_vm._v(" "),(_vm.enableBtnFinalize(_vm.task.LastStatusSelectAnswer.Id))?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){return _vm.btnReject(5)}}},[_vm._v("Отклонить")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.back}},[_vm._v("Отмена")]),_vm._v(" "),(_vm.info.User.MainRole === 'administrators')?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){return _vm.btnAccept(10, null)}}},[_vm._v("Удалить")]):_vm._e()]):_c('div',{staticClass:"btns flex"},[(_vm.allowEdit && !_vm.isController)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveAnswer(null, null)}}},[_vm._v("Сохранить")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page"},[(_vm.tradePointSelected)?[_c('h1',{staticClass:"margin-bottom-20"},[_vm._v(_vm._s(_vm.task.Name))]),_vm._v(" "),_c('div',{staticClass:"flex mob-flex-to-block margin-bottom-20"},[_c('div',{staticClass:"panel-block panel-block-large"},[_c('div',{staticClass:"panel-block-info"},[_c('p',{staticClass:"task-header"},[_vm._v("Описание задачи")]),_vm._v(" "),_c('span',{staticClass:"block-descr",staticStyle:{"height":"auto"},domProps:{"innerHTML":_vm._s(_vm.task.CaptionFormatted)}})])]),_vm._v(" "),_c('div',{staticClass:"panel-block panel-block-large"},[_c('div',{staticClass:"panel-block-info"},[_c('div',{staticClass:"flex task-photo-block"},[_c('div',{staticClass:"form-field",staticStyle:{"width":"50%"}},[_c('p',{staticClass:"task-header"},[_vm._v("Файлы")]),_vm._v(" "),_c('div',{staticClass:"flex",staticStyle:{"flex-wrap":"wrap"}},_vm._l((_vm.taskAttachmentsNoImage),function(item,i){return _c('div',{staticClass:"task-photo"},[_c('a',{staticClass:"task-photo-file",attrs:{"target":"_blank","href":item.FilePath}},[(item.Extension==='docx')?_c('svg',{staticClass:"tasks-svg svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg?v2#Docx"}})]):_vm._e(),_vm._v(" "),(item.Extension==='xlsx')?_c('svg',{staticClass:"tasks-svg svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg?v2#Xlsx"}})]):_vm._e(),_vm._v(" "),(item.Extension==='pdf')?_c('svg',{staticClass:"tasks-svg svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg?v2#Pdf"}})]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.FileName))])])])}),0),_vm._v(" "),(_vm.taskAttachmentsNoImage.length === 0)?_c('p',{staticClass:"input-text-lbl"},[_vm._v("Файлы отсутствуют")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"50%"}},[_c('p',{staticClass:"task-header"},[_vm._v("Фото")]),_vm._v(" "),_vm._l((_vm.taskAttachmentsImage),function(item,i){return _c('div',{staticClass:"task-photo flex"},[_c('a',{staticClass:"lightzoom",attrs:{"target":"_blank","href":item.FilePath,"rel":"group"}},[_c('img',{attrs:{"src":item.FilePath}})])])}),_vm._v(" "),(_vm.taskAttachmentsImage.length === 0)?_c('p',{staticClass:"input-text-lbl"},[_vm._v("Фото отсутствуют")]):_vm._e()],2)])])])])]:_vm._e(),_vm._v(" "),(!_vm.tradePointSelected)?_c('div',{staticClass:"block-in-page",on:{"scroll":_vm.onReportItemsScroll}},[_c('div',[_c('div',{staticClass:"body-panel-control-separator flex"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ttSearch),expression:"ttSearch"}],staticClass:"input-text",attrs:{"type":"text","value":"1","placeholder":"Введите название или адрес торговой точки, после чего выберите из списка"},domProps:{"value":(_vm.ttSearch)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.ttSearch=$event.target.value},_vm.onChangeTradeSearch]}})])]),_vm._v(" "),_c('div',[_c('br'),_vm._v(" "),_c('table',{staticClass:"table-view",attrs:{"id":"dataTable"}},[_c('tbody',_vm._l((_vm.ttData),function(item){return _c('tr',[_c('td',[_vm._v(_vm._s(item.FullName))]),_vm._v(" "),_c('td',{staticClass:"phone"},[(!item.Error)?_c('button',{staticClass:"btn btn-primary",staticStyle:{"display":"unset"},attrs:{"type":"button"},on:{"click":function($event){return _vm.onSelectTradePoint(item)}}},[_vm._v("Добавить")]):_vm._e(),_vm._v(" "),(item.Error)?_c('span',[_vm._v("\n                                        "+_vm._s(item.Error)+"\n                                    ")]):_vm._e()])])}),0)]),_vm._v(" "),(_vm.ttSearched && !_vm.ttData.length && !_vm.ttIsLoading)?_c('div',[_c('span',[_vm._v("Ничего не найдено...")])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.currentAnswer.TradePoint && !_vm.currentAnswer.TradePoint.Error || _vm.tradePointSelected && _vm.answerId > 0)?_c('div',{staticClass:"block-in-page"},[(_vm.currentAnswer.TradePoint && !_vm.currentAnswer.TradePoint.Error)?_c('div',[_vm._v("\n                    Торговая точка: "),_c('strong',[_vm._v(_vm._s(_vm.formatTradePointName(_vm.currentAnswer.TradePoint)))])]):_vm._e(),_vm._v(" "),(_vm.tradePointSelected && _vm.answerId > 0)?_c('div',[_c('div',[_vm._v("\n                        ID ответа: "),_c('strong',[_vm._v(_vm._s(_vm.currentAnswer.Id))])]),_vm._v(" "),_c('div',[_vm._v("\n                        ФИО: "),_c('strong',[_vm._v(_vm._s(_vm.currentAnswer.User.Fio))])])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.currentAnswer.TradePoint && _vm.currentAnswer.TradePoint.Error)?_c('div',{staticClass:"error"},[_vm._v("\n                "+_vm._s(_vm.currentAnswer.TradePoint.Error)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.tradePointSelected)?_c('h2',{staticClass:"margin-bottom-20"},[_vm._v("Детали ответа")]):_vm._e(),_vm._v(" "),(_vm.tradePointSelected)?_c('div',{staticClass:"margin-bottom-20"},[_vm._v("\n                Дата ответа:\n                "),_c('input-date',{staticClass:"'input-text input-date'",attrs:{"name":"'dateAnswer'","disabled":"true"},model:{value:(_vm.currentAnswer.FillingDateFormatted),callback:function ($$v) {_vm.$set(_vm.currentAnswer, "FillingDateFormatted", $$v)},expression:"currentAnswer.FillingDateFormatted"}})],1):_vm._e(),_vm._v(" "),(_vm.tradePointSelected)?_c('div',[(_vm.currentAnswer.CommentStatus && _vm.currentAnswer.LastStatus === _vm.TaskAnswerStates.OnEdition)?_c('div',{staticClass:"error"},[_vm._v("\n                    "+_vm._s(_vm.currentAnswer.CommentStatus)+"\n                ")]):(_vm.currentAnswer.CommentStatus && _vm.currentAnswer.LastStatus === _vm.TaskAnswerStates.Finalized)?_c('div',{staticClass:"error"},[_vm._v("\n                    Ранее ответ был отправлен на доработку с комментарием: "+_vm._s(_vm.currentAnswer.CommentStatus)+"\n                ")]):(_vm.currentAnswer.CommentStatus && _vm.currentAnswer.LastStatus === _vm.TaskAnswerStates.Rejected)?_c('div',{staticClass:"error"},[_vm._v("\n                    Ранее ответ был отклонен с комментарием: "+_vm._s(_vm.currentAnswer.CommentStatus)+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.task.FieldInputType === _vm.FieldType.Table)?_c('div',{staticClass:"report-block-items margin-bottom-20"},[(_vm.task.FieldInputType === _vm.FieldType.Table)?_c('report-items-table',{ref:"reportItems",staticClass:"report-items",attrs:{"bonusSettings":_vm.fieldTable.bonusSettings,"tradePoint":_vm.fieldTable.TradePoint,"reportSettings":_vm.fieldTable.reportSettings,"equipmentTypes":_vm.fieldTable.equipmentTypes,"sku":_vm.fieldTable.sku,"canBeEdited":_vm.fieldTable.canBeEdited,"minItems":_vm.fieldTable.minItems,"maxItems":_vm.fieldTable.maxItems,"skuBonusList":_vm.fieldTable.skuBonusList,"isNewAnswer":_vm.answerId === 0},model:{value:(_vm.fieldTable.ReportItems),callback:function ($$v) {_vm.$set(_vm.fieldTable, "ReportItems", $$v)},expression:"fieldTable.ReportItems"}}):_vm._e()],1):_vm._e(),_vm._v(" "),((!_vm.isController || _vm.allowEdit) && (_vm.task.FieldInputType === _vm.FieldType.Single || _vm.existsAttach))?_c('div',{staticClass:"flex",staticStyle:{"flex-wrap":"wrap"}},[_vm._l((_vm.fieldSettingsOrdered),function(settings,i){return [(_vm.task.FieldInputType === _vm.FieldType.Single && settings.type !== 'attach')?_c('div',{staticClass:"panel-block panel-block-large panel-block-field"},[_c('div',{staticClass:"panel-block-info"},[_c('div',{staticClass:"form-field"},[_c('p',{staticClass:"task-header"},[_vm._v(_vm._s(settings.caption))]),_vm._v(" "),_c('label',{staticClass:"input-text-lbl margin-bottom-5"},[_vm._v(_vm._s(settings.description))]),_vm._v(" "),(settings.type === 'int')?[_c('touch-spin',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],class:['input-text', {'input-error': _vm.errors.has('settingsAnswer' + i)}],attrs:{"name":'settingsAnswer' + i,"decimals":0,"step":1.00,"disabled":!_vm.allowEdit},model:{value:(_vm.fieldTable.ReportItems[0].Fields[settings.index].Value),callback:function ($$v) {_vm.$set(_vm.fieldTable.ReportItems[0].Fields[settings.index], "Value", $$v)},expression:"fieldTable.ReportItems[0].Fields[settings.index].Value"}}),_vm._v(" "),(_vm.errors.has('settingsAnswer' + i))?_c('span',{staticClass:"field-validation-valid"},[_vm._v("Обязательно для заполнения")]):_vm._e()]:(settings.type === 'date')?[_c('input-date',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-text', {'input-error': _vm.errors.has('settingsAnswer' + i)}],attrs:{"name":'settingsAnswer' + i,"disabled":!_vm.allowEdit,"todayHighlight":"true"},on:{"input":function($event){return _vm.onChangeDate(_vm.fieldTable.ReportItems[0].Fields[settings.index], 'Title', 'Value')}},model:{value:(_vm.fieldTable.ReportItems[0].Fields[settings.index].Title),callback:function ($$v) {_vm.$set(_vm.fieldTable.ReportItems[0].Fields[settings.index], "Title", $$v)},expression:"fieldTable.ReportItems[0].Fields[settings.index].Title"}}),_vm._v(" "),(_vm.errors.has('settingsAnswer' + i))?_c('span',{staticClass:"field-validation-valid"},[_vm._v("Обязательно для заполнения")]):_vm._e()]:(settings.type === 'decimal')?[_c('touch-spin',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true }),expression:"{ required: true }"}],class:['input-text', {'input-error': _vm.errors.has('settingsAnswer' + i)}],attrs:{"name":'settingsAnswer' + i,"decimals":2,"step":0.01,"disabled":!_vm.allowEdit},model:{value:(_vm.fieldTable.ReportItems[0].Fields[settings.index].Value),callback:function ($$v) {_vm.$set(_vm.fieldTable.ReportItems[0].Fields[settings.index], "Value", $$v)},expression:"fieldTable.ReportItems[0].Fields[settings.index].Value"}}),_vm._v(" "),(_vm.errors.has('settingsAnswer' + i))?_c('span',{staticClass:"field-validation-valid"},[_vm._v("Обязательно для заполнения")]):_vm._e()]:(settings.type === 'string')?[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fieldTable.ReportItems[0].Fields[settings.index].Value),expression:"fieldTable.ReportItems[0].Fields[settings.index].Value"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-text', {'input-error': _vm.errors.has('settingsAnswer' + i)}],attrs:{"type":"text","placeholder":"Ответ","name":'settingsAnswer' + i,"disabled":!_vm.allowEdit},domProps:{"value":(_vm.fieldTable.ReportItems[0].Fields[settings.index].Value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.fieldTable.ReportItems[0].Fields[settings.index], "Value", $event.target.value)}}}),_vm._v(" "),(_vm.errors.has('settingsAnswer' + i))?_c('span',{staticClass:"field-validation-valid"},[_vm._v("Обязательно для заполнения")]):_vm._e()]:(settings.type === 'bool')?[_c('drop-down',{attrs:{"items":_vm.fieldSettingsBool,"dataField":'Id',"textField":'Name',"disabled":!_vm.allowEdit},model:{value:(_vm.fieldTable.ReportItems[0].Fields[settings.index].Value),callback:function ($$v) {_vm.$set(_vm.fieldTable.ReportItems[0].Fields[settings.index], "Value", $$v)},expression:"fieldTable.ReportItems[0].Fields[settings.index].Value"}}),_vm._v(" "),(_vm.errors.has('settingsAnswer' + i))?_c('span',{staticClass:"field-validation-valid"},[_vm._v("Обязательно для заполнения")]):_vm._e()]:(settings.type === 'sku')?[_c('search-filter',{directives:[{name:"validate",rawName:"v-validate",value:({ rules: { required: true} }),expression:"{ rules: { required: true} }"}],ref:"searchfilter",refInFor:true,attrs:{"name":'settingsAnswer' + i,"hasErrors":_vm.errors.has('settingsAnswer' + i),"extra":0,"placeholder":('Выберите sku'),"searchFunction":_vm.searchSkuFunction,"selectedItem":_vm.getSkuSelectedItem(_vm.fieldTable.ReportItems[0].Fields[settings.index]),"searchOnSelect":true,"scrollable":true,"fieldName":settings.name,"disabled":!_vm.allowEdit,"valueItem":_vm.skuValueItem},on:{"onFilterChange":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
return _vm.onChangeSkuSearch.apply(void 0, argsArray.concat( [settings.name] ))}}})]:(settings.type === 'select')?[_c('drop-down',{attrs:{"items":settings.optionsItems,"dataField":'Value',"textField":'Name',"disabled":!_vm.allowEdit},model:{value:(_vm.fieldTable.ReportItems[0].Fields[settings.index].Value),callback:function ($$v) {_vm.$set(_vm.fieldTable.ReportItems[0].Fields[settings.index], "Value", $$v)},expression:"fieldTable.ReportItems[0].Fields[settings.index].Value"}})]:_vm._e()],2)])]):_vm._e(),_vm._v(" "),(settings.type === 'attach')?_c('div',{staticClass:"task-files-newline"}):_vm._e(),_vm._v(" "),(settings.type === 'attach')?_c('div',{staticClass:"panel-block task-files-block",staticStyle:{"min-width":"200px"}},[_c('div',{staticClass:"panel-block-info"},[_c('div',{staticClass:"form-field"},[_c('p',{staticClass:"task-header"},[_vm._v(_vm._s(settings.caption))]),_vm._v(" "),_c('label',{staticClass:"input-text-lbl margin-bottom-5"},[_vm._v(_vm._s(settings.description))]),_vm._v(" "),_c('div',{staticClass:"flex",staticStyle:{"flex-wrap":"wrap"}},_vm._l((settings.Attachments),function(item,j){return _c('div',{class:['task-photo', {'thumbnail-img' : item.isImage}]},[(!item.isImage)?[(!item.FileData && item.FilePath)?_c('a',{staticClass:"task-photo-file",attrs:{"target":"_blank","href":item.FilePath}},[(item.Extension==='docx')?_c('svg',{staticClass:"tasks-svg svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg?v2#Docx"}})]):_vm._e(),_vm._v(" "),(item.Extension==='xlsx')?_c('svg',{staticClass:"tasks-svg svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg?v2#Xlsx"}})]):_vm._e(),_vm._v(" "),(item.Extension==='pdf')?_c('svg',{staticClass:"tasks-svg svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg?v2#Pdf"}})]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.FileName))]),_vm._v(" "),(_vm.allowEdit)?_c('span',{staticClass:"file-del",on:{"click":function($event){return _vm.onRemoveAttachment(settings, j)}}},[_vm._v("удалить")]):_vm._e()]):_c('div',{staticClass:"task-photo-file"},[(item.Extension==='docx')?_c('svg',{staticClass:"tasks-svg svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg?v2#Docx"}})]):_vm._e(),_vm._v(" "),(item.Extension==='xlsx')?_c('svg',{staticClass:"tasks-svg svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg?v2#Xlsx"}})]):_vm._e(),_vm._v(" "),(item.Extension==='pdf')?_c('svg',{staticClass:"tasks-svg svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg?v2#Pdf"}})]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.FileName))]),_vm._v(" "),(_vm.allowEdit)?_c('span',{staticClass:"file-del",on:{"click":function($event){return _vm.onRemoveAttachment(settings, j)}}},[_vm._v("удалить")]):_vm._e()])]:_vm._e(),_vm._v(" "),(item.isImage)?[(item.FileData)?_c('a',{staticClass:"lightzoom-type2",attrs:{"target":"_blank","rel":"group"}},[_c('img',{attrs:{"src":item.FileData}})]):_vm._e(),_vm._v(" "),(!item.FileData && item.FilePath)?_c('a',{staticClass:"lightzoom-type2",attrs:{"target":"_blank","href":item.FilePath,"rel":"group"}},[_c('img',{attrs:{"src":item.FilePath}})]):_vm._e(),_vm._v(" "),(_vm.allowEdit)?_c('button',{staticClass:"btn btn-default btn-img",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onRemoveAttachment(settings, j)}}},[_c('img',{attrs:{"src":__webpack_require__(17),"alt":""}})]):_vm._e(),_vm._v(" "),(!item.FileData && item.FilePath && _vm.allowEdit)?_c('div',{staticClass:"thumbnail-img-rotateleft",on:{"click":function($event){return _vm.rotateImage('left', item)}}}):_vm._e(),_vm._v(" "),(!item.FileData && item.FilePath && _vm.allowEdit)?_c('div',{staticClass:"thumbnail-img-rotateright",on:{"click":function($event){return _vm.rotateImage('right', item)}}}):_vm._e()]:_vm._e()],2)}),0),_vm._v(" "),_c('div',{staticClass:"file-upload-zone"},[_c('drop-zone',{staticClass:"drop-area",attrs:{"dataId":settings.id,"accept":settings.accept},on:{"files-dropped":_vm.onAttachFiles}},[(_vm.allowEdit)?_c('input',{ref:'atDropFiles2'+i,refInFor:true,staticClass:"file-upload-zone-btn",attrs:{"type":"file","multiple":"","accept":settings.accept,"id":'atDropFiles2'+i,"data-fieldid":settings.id,"name":"atDropFiles2"}}):_vm._e(),_vm._v(" "),(_vm.allowEdit)?_c('label',{staticClass:"file-upload-zone-lbl",attrs:{"id":"'atLblDropFiles2'+i","for":'atDropFiles2'+i}},[_vm._v("Перетащите файлы или нажмите, чтобы выбрать")]):_vm._e()])],1)])])]):_vm._e(),_vm._v(" "),(settings.type === 'attach')?_c('div',{staticClass:"task-files-newline"}):_vm._e()]})],2):_vm._e(),_vm._v(" "),(_vm.isController && !_vm.allowEdit)?_c('div',[(_vm.task.FieldInputType === _vm.FieldType.Single || _vm.existsAttach)?_c('div',{staticClass:"flex margin-bottom-30",staticStyle:{"flex-wrap":"wrap"}},[_vm._l((_vm.fieldSettingsOrdered),function(settings,i){return [(_vm.task.FieldInputType === _vm.FieldType.Single && settings.type !== 'attach')?_c('div',{staticClass:"panel-block panel-block-large"},[_c('div',{staticClass:"panel-block-info"},[_c('div',{staticClass:"form-field"},[_c('p',{staticClass:"task-header"},[_vm._v(_vm._s(settings.caption))]),_vm._v(" "),_c('label',{staticClass:"input-text-lbl margin-bottom-5"},[_vm._v(_vm._s(settings.description))]),_vm._v(" "),(settings.type === 'int' || settings.type === 'decimal' || settings.type === 'string' || settings.type === 'select')?[_c('p',[_vm._v(_vm._s(_vm.fieldTable.ReportItems[0].Fields[settings.index].Value))])]:[_c('p',[_vm._v(_vm._s(_vm.fieldTable.ReportItems[0].Fields[settings.index].Title))])]],2)])]):_vm._e(),_vm._v(" "),(settings.type === 'attach')?_c('div',{staticClass:"task-files-newline"}):_vm._e(),_vm._v(" "),(settings.type === 'attach')?_c('div',{staticClass:"panel-block task-files-block"},[_c('div',{staticClass:"panel-block-info"},[_c('p',{staticClass:"task-header"},[_vm._v(_vm._s(settings.caption))]),_vm._v(" "),_c('label',{staticClass:"input-text-lbl margin-bottom-5"},[_vm._v(_vm._s(settings.description))]),_vm._v(" "),_c('div',{staticClass:"flex",staticStyle:{"flex-wrap":"wrap"}},_vm._l((settings.Attachments),function(item,j){return _c('div',{staticClass:"task-photo"},[(!item.isImage)?[(item.FilePath)?_c('a',{staticClass:"task-photo-file",attrs:{"target":"_blank","href":item.FilePath}},[(item.Extension==='docx')?_c('svg',{staticClass:"tasks-svg svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg?v2#Docx"}})]):_vm._e(),_vm._v(" "),(item.Extension==='xlsx')?_c('svg',{staticClass:"tasks-svg svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg?v2#Xlsx"}})]):_vm._e(),_vm._v(" "),(item.Extension==='pdf')?_c('svg',{staticClass:"tasks-svg svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg?v2#Pdf"}})]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.FileName))])]):_vm._e()]:_c('a',{staticClass:"lightzoom-type2",attrs:{"target":"_blank","href":item.FilePath,"rel":"group"}},[_c('img',{attrs:{"src":item.FilePath}})])],2)}),0)])]):_vm._e(),_vm._v(" "),(settings.type === 'attach')?_c('div',{staticClass:"task-files-newline"}):_vm._e()]})],2):_vm._e()]):_vm._e()]):_vm._e()],2)]:_vm._e(),_vm._v(" "),_c('popup-window',{ref:"ppComment",attrs:{"title":_vm.popuptitle,"width":800}},[_c('div',{},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"}),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.commentStatus),expression:"commentStatus"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-memo', {'input-error': _vm.errors.has('SettingsDescription', 'edition')}],attrs:{"rows":"10","name":'SettingsDescription',"data-vv-scope":"edition"},domProps:{"value":(_vm.commentStatus)},on:{"input":function($event){if($event.target.composing){ return; }_vm.commentStatus=$event.target.value}}}),_vm._v(" "),(_vm.errors.has('SettingsDescription', 'edition'))?_c('span',{staticClass:"field-validation-valid"},[_vm._v("Заполните поле")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20 margin-bottom-20"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.validatePopup()}}},[_vm._v("Принять")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.closeModal('ppComment')}}},[_vm._v("Отмена")])])])]),_vm._v(" "),_c('popup-window',{ref:"ppInfo",attrs:{"title":"Информация","width":800}},[_c('div',{},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Время открытия ответа: "+_vm._s(_vm.currentAnswer.DateOpenLong))]),_vm._v(" "),_c('label',{staticClass:"input-text-lbl"},[_vm._v("Время сохранения ответа: "+_vm._s(_vm.currentAnswer.FillingDateLong))]),_vm._v(" "),_c('label',{staticClass:"input-text-lbl"},[_vm._v("Координаты заполнения ответа: "+_vm._s(_vm.currentAnswer.Latitude)+" "+_vm._s(_vm.currentAnswer.Longitude))])]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20 margin-bottom-20"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.closeModal('ppInfo')}}},[_vm._v("Ок")])])])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":_vm.titleName}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Analytics_vue__ = __webpack_require__(285);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_238e47b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Analytics_vue__ = __webpack_require__(797);
function injectStyle (ssrContext) {
  __webpack_require__(795)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Analytics_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_238e47b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Analytics_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(796);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("43d541dd", content, true, {});

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".dropdown-block.stick-right .dropdown-list{right:0;left:auto!important}.table-view thead{display:table-header-group}", ""]);

// exports


/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"body-panel-control-separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[(_vm.info.User && (_vm.info.User.MainRole === 'administrators' || _vm.info.ProjectsLength > 1))?_c('project-select',{attrs:{"user":_vm.info.User},on:{"onChange":_vm.onProjectChange}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-date-lbl margin-right-10"},[_c('input-date',{staticClass:"input-text input-date",attrs:{"name":"dateStart"},on:{"input":_vm.reload},model:{value:(_vm.dateStart),callback:function ($$v) {_vm.dateStart=$$v},expression:"dateStart"}})],1),_vm._v(" "),_c('span',{staticClass:"margin-right-10 margin-top-5"},[_vm._v("-")]),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{staticClass:"input-text input-date",attrs:{"name":"dateEnd"},on:{"input":_vm.reload},model:{value:(_vm.dateEnd),callback:function ($$v) {_vm.dateEnd=$$v},expression:"dateEnd"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"form-field "},[(_vm.project != null)?_c('div',{staticClass:"btns flex"},[(_vm.analyticsReportEnabled)?_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.onExportByReports()}}},[_vm._v("\n                                Выгрузка по отчетам\n                            ")]):_vm._e(),_vm._v(" "),(_vm.project.AnalyticsReportEnabled && _vm.analyticsSettingsForRole.ReportEnabled)?_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.onExport()}}},[_vm._v("\n                                Экспорт\n                            ")]):_vm._e(),_vm._v(" "),(_vm.analyticsSettingsForRole.SwitcherEnabled)?_c('drop-down',{staticClass:"margin-right-20",attrs:{"items":_vm.measureTypes,"dataField":'Value',"textField":'Name'},on:{"change":_vm.reload},model:{value:(_vm.measureType),callback:function ($$v) {_vm.measureType=$$v},expression:"measureType"}}):_vm._e(),_vm._v(" "),(_vm.analyticsSettingsForRole.PeriodsEnabled)?_c('drop-down',{class:['margin-right-20 stick-right'],attrs:{"name":"units","items":_vm.units,"dataField":'Value',"textField":'Name'},on:{"change":_vm.reload},model:{value:(_vm.unit),callback:function ($$v) {_vm.unit=$$v},expression:"unit"}}):_vm._e()],1):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"body-panel-control-separator"},[_c('complex-filter',{ref:"complexFilter",attrs:{"filters":_vm.filters,"searchFunction":_vm.searchFunction,"tableName":'[dbo].[TradePoint]',"withTableNameInClause":true},on:{"onFilterChange":_vm.onFilterChange}})],1)]),_vm._v(" "),(_vm.analyticsSettingsForRole)?_c('div',{staticClass:"body-panel-content body-panel-content-page"},[_c('div',{staticClass:"block-in-page",staticStyle:{"height":"100%"}},[(_vm.chartOptions && _vm.analyticsSettingsForRole.DataTypeId === 0)?_c('chart',{ref:"chartObj",attrs:{"chartData":_vm.chartData,"chartOptions":_vm.chartOptions,"controlClick":_vm.analyticsSettingsForRole.DetailEnabled === true},on:{"onBarClick":_vm.onBarClick}}):_vm._e(),_vm._v(" "),(_vm.tableData && _vm.analyticsSettingsForRole.DataTypeId === 1)?_c('table',{staticClass:"table-view"},[_c('thead',[_c('tr',{staticClass:"heading"},_vm._l((_vm.tableData.Columns),function(type,name){return (name !== 'CustomField')?_c('th',[_vm._v("\n                            "+_vm._s(name)+"\n                        ")]):_vm._e()}),0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.tableData.Table),function(tableRow,index){return _c('tr',{class:[{'selected': tableRow.Expanded}, {'details': tableRow.DetailsTable }],on:{"click":function($event){$event.stopPropagation();return _vm.onTableClick(tableRow, index)}}},[(tableRow.DetailsTable)?[_c('td',{attrs:{"colspan":_vm.tableData.ColumnsLength}},[_c('table',{staticClass:"table-details"},[_c('thead',[_c('tr',_vm._l((tableRow.DetailsTable.Columns),function(type,name){return _c('th',[_vm._v("\n                                                "+_vm._s(name)+"\n                                            ")])}),0)]),_vm._v(" "),_c('tbody',[_vm._l((tableRow.DetailsTable.Table),function(detailsRow){return _c('tr',_vm._l((detailsRow),function(value,name){return _c('td',{class:_vm.getTdClass(tableRow.DetailsTable.Columns[name])},[_vm._v("\n                                                "+_vm._s(_vm.formatTableDetailsValue(value, tableRow.DetailsTable.Columns[name]))+"\n                                            ")])}),0)}),_vm._v(" "),(!tableRow.DetailsTable.Table.length)?_c('tr',[_c('td',{staticStyle:{"text-align":"center"},attrs:{"colspan":tableRow.DetailsTable.ColumnsLength}},[_vm._v("\n                                                Нет данных\n                                            ")])]):_vm._e()],2)])])]:_vm._l((tableRow),function(value,name){return (name !== 'CustomField' && name !== 'Expanded')?_c('td',{class:_vm.getTdClass(_vm.tableData.Columns[name])},[_vm._v("\n                                "+_vm._s(_vm.formatTableValue(value, _vm.tableData.Columns[name]))+"\n                            ")]):_vm._e()})],2)}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"chart-details-container",style:({display: (_vm.chartDetailsData ? 'block': 'none') }),attrs:{"id":"chartDetails"}},[(_vm.chartDetailsData)?[_c('table',{staticClass:"chart-details-table"},[_c('thead',[_c('tr',{},_vm._l((_vm.chartDetailsData.Columns),function(type,name){return _c('th',[_vm._v("\n                                "+_vm._s(name)+"\n                            ")])}),0)]),_vm._v(" "),_c('tbody',[_vm._l((_vm.chartDetailsData.Table),function(detailsRow){return _c('tr',_vm._l((detailsRow),function(value,name){return _c('td',{class:_vm.getTdClass(_vm.chartDetailsData.Columns[name])},[_vm._v("\n                                "+_vm._s(_vm.formatTableDetailsValue(value, _vm.chartDetailsData.Columns[name]))+"\n                            ")])}),0)}),_vm._v(" "),(!_vm.chartDetailsData.Table.length)?_c('tr',[_c('td',{staticStyle:{"text-align":"center"},attrs:{"colspan":_vm.chartDetailsData.ColumnsLength}},[_vm._v("\n                                Нет данных\n                            ")])]):_vm._e()],2)])]:_vm._e()],2)],1)]):_vm._e(),_vm._v(" "),_c('vue-headful',{attrs:{"title":_vm.getPageTitle()}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Materials_vue__ = __webpack_require__(286);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d34fd3f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Materials_vue__ = __webpack_require__(799);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Materials_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d34fd3f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Materials_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[(_vm.info.User && (_vm.info.User.MainRole === 'administrators' || _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.materialCreate) || _vm.info.ProjectsLength > 1 || _vm.$route.query.folderId))?_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[(_vm.$route.query.folderId)?_c('p',{staticClass:"btn-back margin-right-10"},[_c('a',{staticClass:"router-link-active",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.back.apply(null, arguments)}}},[_vm._v("Назад")])]):_vm._e(),_vm._v(" "),((_vm.info.User.MainRole === 'administrators' || _vm.info.ProjectsLength > 1))?_c('project-select',{attrs:{"user":_vm.info.User},on:{"onChange":_vm.onProjectChange}}):_vm._e()],1)]),_vm._v(" "),(_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.materialCreate) || _vm.info.User.MainRole === 'administrators')?_c('div',{staticClass:"control-block-right"},[_c('div',{staticClass:"btns flex",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-news",on:{"click":_vm.addFolder}},[_vm._v("Добавить папку")]),_vm._v(" "),_c('button',{staticClass:"btn btn-news",on:{"click":_vm.addMaterial}},[_vm._v("Добавить материал")]),_vm._v(" "),(_vm.enabledCertificate)?_c('button',{staticClass:"btn btn-news",on:{"click":_vm.goToCertificate}},[_vm._v("Выдача сертификатов")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"switch margin-left-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.active),expression:"active"}],attrs:{"type":"checkbox","id":"s5","checked":"checked"},domProps:{"checked":Array.isArray(_vm.active)?_vm._i(_vm.active,null)>-1:(_vm.active)},on:{"change":[function($event){var $$a=_vm.active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.active=$$a.concat([$$v]))}else{$$i>-1&&(_vm.active=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.active=$$c}},_vm.reload]}}),_vm._v(" "),_c('label',{staticClass:"slider-v3",attrs:{"for":"s5"}})])])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page panel-block-news no-padding-right"},[_c('div',{staticClass:"body-panel-content-center"},[_c('div',{staticStyle:{"width":"100%"}},[(_vm.materialStats)?_c('div',{staticClass:"materials-info"},[_c('div',{staticClass:"materials-info-item"},[_c('div',{staticClass:"doughnut-wrap"},[(_vm.chartData.length > 0)?_c('chart',{key:'1',attrs:{"chartData":_vm.chartData[0],"chartOptions":_vm.chartOptions[0],"type":'doughnut'}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"margin-left-10"},[_vm._v("\n                            "+_vm._s(_vm.materialStats.learnedMaterials)+"/"+_vm._s(_vm.materialStats.allMaterials)),_c('br'),_vm._v("\n                            Изучено"),_c('br'),_vm._v("\n                            материалов\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"materials-info-item"},[_c('div',{staticClass:"doughnut-wrap"},[(_vm.chartData.length > 1)?_c('chart',{key:'2',attrs:{"chartData":_vm.chartData[1],"chartOptions":_vm.chartOptions[1],"type":'doughnut'}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"margin-left-10"},[_vm._v("\n                            "+_vm._s(_vm.materialStats.passedTests)+"/"+_vm._s(_vm.materialStats.allTests)),_c('br'),_vm._v("\n                            Пройдено"),_c('br'),_vm._v("\n                            тестов\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"materials-info-item"},[_c('div',{staticClass:"doughnut-wrap"},[(_vm.chartData.length > 2)?_c('chart',{attrs:{"chartData":_vm.chartData[2],"chartOptions":_vm.chartOptions[2],"type":'doughnut'}}):_vm._e()],1),_vm._v(" "),_vm._m(0)])]):_vm._e()]),_vm._v(" "),_vm._l((_vm.materials),function(item){return _c('div',{class:['panel-block panel-block-new', { 'learned': item.Complete }, {'not-read': !item.ReadByUser}],on:{"click":function($event){return _vm.onItemClick(item)}}},[_c('div',{staticClass:"panel-block-img-base"},[_c('div',{staticClass:"panel-block-img"},[(item.ImagePath)?_c('img',{style:(_vm.getImageStyleFormatted(item.ImageStyle)),attrs:{"src":item.ImagePath}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"panel-block-info"},[_c('p',{staticClass:"panel-block-header margin-bottom-10"},[_vm._v(_vm._s(item.Name))]),_vm._v(" "),_c('p',{staticClass:"block-descr"},[_vm._v(_vm._s(item.Category))]),_vm._v(" "),_c('p',{staticClass:"block-progress"},[_vm._v(_vm._s(item.ProgressStatus))])]),_vm._v(" "),(!item.IsFolder)?_c('div',{staticClass:"panel-body-actions flex"},[_c('div',{staticClass:"panel-body-actions-part"},[_c('button',{staticClass:"btn",on:{"click":function($event){$event.stopPropagation();return _vm.goToMaterial(item.Id)}}},[_vm._v(_vm._s(item.ViewButtonName || 'Просмотр'))]),_vm._v(" "),(_vm.info.User && (_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.materialCreate) || _vm.info.User.MainRole === 'administrators'))?_c('div',{staticClass:"btn btn-img",on:{"click":function($event){$event.stopPropagation();return _vm.goToMaterialEdit(item.Id)}}},[_c('img',{attrs:{"src":__webpack_require__(31),"alt":""}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"panel-body-actions-part"},[(item.CertificateSettings && item.CertificateSettings.Issuance!=='undefined' && item.CertificateSettings.Issuance.Actived)?_c('div',{staticClass:"panel-body-actions-info"},[_c('svg',{class:['svg-icon', {'active': item.CertificateExists === true && !(_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.materialCreate) || _vm.info.User.MainRole === 'administrators')}],attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Sert"}})])]):_vm._e()])]):_vm._e(),_vm._v(" "),(item.IsFolder)?_c('div',{staticClass:"panel-body-actions"},[_c('button',{staticClass:"btn",on:{"click":function($event){$event.stopPropagation();return _vm.goToFolder(item.Id)}}},[_vm._v(_vm._s(item.ViewButtonName || 'Просмотр'))]),_vm._v(" "),(_vm.info.User && (_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.materialCreate) || _vm.info.User.MainRole === 'administrators'))?_c('a',{staticClass:"btn btn-img",attrs:{"href":""},on:{"click":function($event){$event.stopPropagation();return _vm.goToFolderEdit(item.Id)}}},[_c('img',{attrs:{"src":__webpack_require__(31),"alt":""}})]):_vm._e()]):_vm._e(),_vm._v(" "),(item.LikesEnabled)?_c('div',{staticClass:"panel-body-stats"},[_c('p',{class:['news-actions like', {'bold': item.MyVote === true}],attrs:{"title":"Нравится"},on:{"click":function($event){$event.stopPropagation();return _vm.onMakeMark(item, _vm.i)}}},[_c('svg',{staticClass:"svg-icon like-1",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Like"}})]),_vm._v(" "),_c('svg',{staticClass:"svg-icon like-2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Like2"}})]),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"400","line-height":"1.3"}},[_vm._v(_vm._s(item.LikesCount))])])]):_vm._e()])})],2)]),_vm._v(" "),_c('vue-headful',{attrs:{"title":_vm.getPageTitle()}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"margin-left-10"},[_vm._v("\n                            Средний"),_c('br'),_vm._v("\n                            процент верных"),_c('br'),_vm._v("\n                            ответов\n                        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Motivation_vue__ = __webpack_require__(287);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5622f764_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Motivation_vue__ = __webpack_require__(803);
function injectStyle (ssrContext) {
  __webpack_require__(801)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5622f764"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Motivation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5622f764_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Motivation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(802);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("60f5074f", content, true, {});

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[(_vm.info.User && (_vm.info.User.MainRole === 'administrators' || _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.motivationEdit) || _vm.info.ProjectsLength > 1))?_c('div',{staticClass:"body-panel-control separator"},[(_vm.info.User && (_vm.info.User.MainRole === 'administrators' || _vm.info.ProjectsLength > 1))?_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[_c('project-select',{attrs:{"user":_vm.info.User},on:{"onChange":_vm.onProjectChange}})],1)]):_vm._e(),_vm._v(" "),(_vm.info.User.MainRole === 'administrators' || _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.motivationEdit))?_c('div',{staticClass:"control-block-right"},[_c('div',{staticClass:"btns flex"},[_c('input',{ref:"dropFiles",staticClass:"file-upload-zone-btn",attrs:{"type":"file","id":"dropFiles","name":"dropFiles","accept":".pdf"},on:{"change":function($event){return _vm.onFileChange()}}}),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button","onclick":"document.getElementById('dropFiles').click()"}},[_vm._v("Загрузить презентацию")]),_vm._v(" "),(_vm.project != null && _vm.project.MotivationFile != null)?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteMotivation()}}},[_vm._v("Удалить презентацию")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onShowModal('ppYoutubeLink')}}},[_vm._v("Видео")]),_vm._v(" "),(_vm.project != null && (_vm.project.MotivationYoutubeLink || _vm.project.MotivationVideoPath))?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){return _vm.onDeleteYoutubeLink()}}},[_vm._v("Удалить видео")]):_vm._e()])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.project != null)?_c('div',{staticClass:"body-panel-content body-panel-content-page"},[(_vm.project.MotivationYoutubeLink || _vm.project.MotivationVideoPath)?_c('div',{staticClass:"block-in-page-transparent"},[_c('video-viewer',{ref:"videoView",attrs:{"auto":false}})],1):_vm._e(),_vm._v(" "),(_vm.project.MotivationFile != null)?_c('div',{staticClass:"block-in-page-transparent"},[_c('pdf-viewer',{ref:"pdfView"})],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.project != null)?_c('popup-window',{ref:"ppYoutubeLink",attrs:{"title":'Добавление видео',"width":800}},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                    Тип видео\n                ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":[{Id: 1, Name: 'Youtube ссылка'}, {Id: 2, Name: 'Файл'}],"dataField":'Id',"textField":'Name'},model:{value:(_vm.project.MotivationVideoTypeId),callback:function ($$v) {_vm.$set(_vm.project, "MotivationVideoTypeId", $$v)},expression:"project.MotivationVideoTypeId"}})],1),_vm._v(" "),(_vm.project.MotivationVideoTypeId === 1)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                    URL на ролик на youtube (например, https://www.youtube.com/embed/ID)\n                    "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('url'),expression:"'url'"},{name:"model",rawName:"v-model",value:(_vm.project.MotivationYoutubeLink),expression:"project.MotivationYoutubeLink"}],class:['input-text', {'input-error': _vm.errors.has('MotivationYoutubeLink')}],attrs:{"name":"MotivationYoutubeLink","type":"text"},domProps:{"value":(_vm.project.MotivationYoutubeLink)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.project, "MotivationYoutubeLink", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('MotivationYoutubeLink')))])]):_vm._e(),_vm._v(" "),(_vm.project.MotivationVideoTypeId === 2)?_c('div',{staticClass:"form-field-group margin-top-20 margin-bottom-20"},[_c('div',{staticClass:"form-field"},[_c('input',{ref:'videoDropFiles',staticClass:"file-upload-zone-btn",attrs:{"type":"file","id":'videoDropFiles',"name":'videoDropFiles',"accept":".mp4"},on:{"change":function($event){return _vm.onVideoFileChange($event)}}}),_vm._v(" "),(_vm.project.MotivationVideoName == null || _vm.project.DeleteMotivationVideo)?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs['videoDropFiles'].click()}}},[_vm._v("\n                        Загрузить\n                    ")]):_vm._e(),_vm._v(" "),(_vm.project.MotivationVideoName != null && !_vm.project.DeleteMotivationVideo)?_c('div',{staticClass:"fileList"},[_vm._v("\n                        Выбран файл: "+_vm._s(_vm.project.MotivationVideoName)+"\n                    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"btns flex"},[(_vm.project.MotivationVideoName && !_vm.project.DeleteMotivationVideo)?_c('button',{staticClass:"btn btn-delete margin-top-15",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.removeVideo()}}},[_vm._v("\n                            Удалить\n                        ")]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex btns"},[_c('button',{staticClass:"btn margin-top-10",on:{"click":function($event){$event.stopPropagation();return _vm.onSaveYoutubeLink.apply(null, arguments)}}},[_vm._v("Сохранить")]),_vm._v(" "),_c('button',{staticClass:"btn margin-top-10",on:{"click":function($event){$event.stopPropagation();return _vm.closeModal('ppYoutubeLink')}}},[_vm._v("Отмена")])])]):_vm._e(),_vm._v(" "),_c('vue-headful',{attrs:{"title":_vm.getPageTitle()}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RatingNew_vue__ = __webpack_require__(288);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e4ddfae_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RatingNew_vue__ = __webpack_require__(807);
function injectStyle (ssrContext) {
  __webpack_require__(805)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e4ddfae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RatingNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e4ddfae_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RatingNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(806);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("8c6f1bac", content, true, {});

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".table-view thead[data-v-0e4ddfae]{display:table-row-group}.heading .sortable[data-v-0e4ddfae]{cursor:pointer}", ""]);

// exports


/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[_c('div',{staticClass:"body-panel-control"},[(_vm.project && _vm.info.User && (_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.ratingExport) ||
        _vm.info.User.MainRole === 'administrators' || (_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.ratingSwitcher) && _vm.project.RatingSwitcherEnabled && _vm.ratingRoles.length) ))?_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"body-panel-control-separator"},[_c('div',{staticClass:"control-block-left"},[(_vm.info.User.MainRole === 'administrators' || _vm.info.ProjectsLength > 1 || (_vm.project.RatingSwitcherEnabled && _vm.ratingRoles.length && _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.ratingSwitcher)))?_c('div',{staticClass:"flex"},[((_vm.info.User.MainRole === 'administrators' || _vm.info.ProjectsLength > 1))?_c('project-select',{attrs:{"user":_vm.info.User},on:{"onChange":_vm.onProjectChange}}):_vm._e(),_vm._v(" "),(_vm.project.RatingSwitcherEnabled && _vm.ratingRoles.length > 1 && (_vm.info.User.MainRole === 'administrators' || _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.ratingSwitcher)))?_c('div',{staticClass:"form-field margin-right-10"},[_c('drop-down',{attrs:{"items":_vm.ratingRoles,"dataField":'Value',"textField":'Name'},on:{"change":_vm.reload},model:{value:(_vm.ratingRole),callback:function ($$v) {_vm.ratingRole=$$v},expression:"ratingRole"}})],1):_vm._e()],1):_vm._e()]),_vm._v(" "),((_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.ratingExport) || _vm.info.User.MainRole === 'administrators'))?_c('div',{staticClass:"control-block-right"},[_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.onExport()}}},[_vm._v("\n                        Экспорт\n                    ")])]):_vm._e()]),_vm._v(" "),(!_vm.isDaccordUser)?_c('div',{staticClass:"body-panel-control-separator"},[_c('complex-filter',{ref:"complexFilter",attrs:{"filters":_vm.filters,"searchFunction":_vm.searchFunction,"tableName":'[dbo].[TradePoint]',"withTableNameInClause":true},on:{"onFilterChange":_vm.onFilterChange}})],1):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page"},[(_vm.project)?_c('table',{staticClass:"t-data",staticStyle:{"max-width":"1000px","margin":"0 auto"},attrs:{"id":"dataTable"}},[_c('thead',[_c('tr',{staticClass:"heading"},[_c('th',{staticClass:"fix"}),_vm._v(" "),_c('th',{staticClass:"number"},[_vm._v("Место")]),_vm._v(" "),_c('th',{staticClass:"with-img mob-hide"},[_vm._v("Участник")]),_vm._v(" "),(!_vm.project.RatingColumn2AsPercent)?_c('th',{staticClass:"w150-r sortable",on:{"click":function($event){$event.stopPropagation();return _vm.sort('BonusesAmountMonth')}}},[(_vm.project.RatingColumn1 && _vm.project.RatingColumn1 !== 'ТекМесяцГод')?[_vm._v(_vm._s(_vm.project.RatingColumn1))]:[(_vm.projectId === 1 && _vm.ratingRole === 'distr')?[_vm._v("\n                                    ТОП-10 август-сентябрь\n                                ")]:[_vm._v("\n                                    "+_vm._s(_vm.currentMonth())+"\n                                ")]],_vm._v(" "),(_vm.sortColumn === 'BonusesAmountMonth')?[(_vm.sortDirection === 'desc')?_c('span',{staticClass:"margin-left-5"},[_c('img',{staticClass:"sort-img",attrs:{"src":__webpack_require__(289)}})]):_vm._e(),_vm._v(" "),(_vm.sortDirection === 'asc')?_c('span',{staticClass:"margin-left-5"},[_c('img',{staticClass:"sort-img",attrs:{"src":__webpack_require__(290)}})]):_vm._e()]:_vm._e()],2):_vm._e(),_vm._v(" "),_c('th',{staticClass:"w150-r sortable",on:{"click":function($event){$event.stopPropagation();return _vm.sort('BonusesAmount')}}},[(_vm.project.RatingColumn2)?[_vm._v(_vm._s(_vm.project.RatingColumn2))]:[_vm._v("Всего")],_vm._v(" "),(_vm.sortColumn === 'BonusesAmount')?[(_vm.sortDirection === 'desc')?_c('span',{staticClass:"margin-left-5"},[_c('img',{staticClass:"sort-img",attrs:{"src":__webpack_require__(289)}})]):_vm._e(),_vm._v(" "),(_vm.sortDirection === 'asc')?_c('span',{staticClass:"margin-left-5"},[_c('img',{staticClass:"sort-img",attrs:{"src":__webpack_require__(290)}})]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('th',{staticClass:"fix-2"})])]),_vm._v(" "),_c('tbody',{on:{"scroll":_vm.onScroll}},[_vm._l((_vm.data),function(item){return [(_vm.data.length > 2 && (item.Place - 1 > _vm.data[_vm.data.length - 2].Place) && item.Selected)?_c('tr',[_c('td',{attrs:{"colspan":"3"}},[_vm._v("\n                                 \n                            ")])]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('tr',{class:['', {'selected': item.Selected}]},[_c('td',{staticClass:"number"},[(item.UserImage !== null)?_c('img',{attrs:{"src":item.UserImage}}):(_vm.faceDefault !== null)?_c('img',{attrs:{"src":__webpack_require__(55)}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"with-img"},[_c('span',{domProps:{"innerHTML":_vm._s(item.Fio)}})])]):_vm._e(),_vm._v(" "),_c('tr',{class:{'selected': item.Selected}},[_c('td',{staticClass:"number"},[_vm._v("\n                                "+_vm._s(item.Place)+"\n                            ")]),_vm._v(" "),(!_vm.isMobile)?_c('td',{staticClass:"with-img"},[(item.UserImage !== null)?_c('img',{attrs:{"src":item.UserImage}}):(_vm.faceDefault !== null)?_c('img',{attrs:{"src":__webpack_require__(55)}}):_vm._e(),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(item.Fio)}})]):_vm._e(),_vm._v(" "),(!_vm.project.RatingColumn2AsPercent)?_c('td',{staticClass:"w150-r",staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.formatInt(item.BonusesAmountMonth)))]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"w150-r",staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.Column2Value(item)))])])]})],2)]):_vm._e()]),_vm._v(" "),_c('vue-headful',{attrs:{"title":_vm.getPageTitle()}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sellers_vue__ = __webpack_require__(291);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34257616_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sellers_vue__ = __webpack_require__(811);
function injectStyle (ssrContext) {
  __webpack_require__(809)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34257616"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sellers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34257616_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sellers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(810);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2006b829", content, true, {});

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel"},[_c('div',{staticClass:"body-panel-control separator"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){}}},[_vm._v("Добавить")])])]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page"}),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Продавцы"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sku_vue__ = __webpack_require__(292);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_950da7d2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sku_vue__ = __webpack_require__(815);
function injectStyle (ssrContext) {
  __webpack_require__(813)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-950da7d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sku_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_950da7d2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sku_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(814);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1911e7a7", content, true, {});

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".panel-block-news h2[data-v-950da7d2]{letter-spacing:normal}#tSkuFieldSett tr.smooth-dnd-draggable-wrapper[data-v-950da7d2]{display:table-row}#tSkuFieldSett .smooth-dnd-ghost[data-v-950da7d2]{display:table-row!important}#tSkuFieldSett .smooth-dnd-ghost>td[data-v-950da7d2]:first-child{width:100%}.result-import[data-v-950da7d2]{letter-spacing:0;background:#fff}.panel-body-actions-false[data-v-950da7d2]{border-top:none;height:62px}.panel-body-actions-footer[data-v-950da7d2]{position:absolute;bottom:0;width:100%}", ""]);

// exports


/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel sku"},[_c('div',{staticClass:"body-panel-control separator"},[(_vm.info.User && (_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.skuCreate) || _vm.info.User.MainRole === 'administrators' || _vm.info.ProjectsLength > 1))?_c('div',{staticClass:"body-panel-control-separator"},[(_vm.info.User && (_vm.info.User.MainRole === 'administrators' || _vm.info.ProjectsLength > 1))?_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[_c('project-select',{attrs:{"user":_vm.info.User},on:{"onChange":_vm.onProjectChange}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[_c('div',{staticClass:"btns flex",attrs:{"data-toggle":"buttons"}},[_c('input',{ref:"dropFiles",staticClass:"file-upload-zone-btn",attrs:{"type":"file","id":"dropFiles","name":"dropFiles","accept":".xlsx"},on:{"change":function($event){return _vm.onFileChange()}}}),_vm._v(" "),_c('input',{ref:"dropFiles2",staticClass:"file-upload-zone-btn",attrs:{"type":"file","id":"dropFiles2","name":"dropFiles2","accept":".xlsx"},on:{"change":function($event){return _vm.onFileSkuLinkChange()}}}),_vm._v(" "),(_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.skuCreate) || _vm.info.User.MainRole === 'administrators')?_c('button',{directives:[{name:"context-menu",rawName:"v-context-menu",value:('settingsList'),expression:"'settingsList'"}],staticClass:"btn",attrs:{"type":"button"}},[_vm._v("\n                        Настройки\n                    ")]):_vm._e(),_vm._v(" "),_c('button',{directives:[{name:"context-menu",rawName:"v-context-menu",value:('exportList'),expression:"'exportList'"}],staticClass:"btn",attrs:{"type":"button"}},[_vm._v("\n                        Экспорт и импорт\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-list",attrs:{"id":"settingsList"}},[_c('a',{staticClass:"dropdown-menu-item",on:{"click":_vm.onAddSku}},[_c('span',[_vm._v("Добавить SKU")])]),_vm._v(" "),_c('a',{staticClass:"dropdown-menu-item",on:{"click":_vm.onAddFolder}},[_c('span',[_vm._v("Добавить папку")])]),_vm._v(" "),_c('a',{staticClass:"dropdown-menu-item",on:{"click":function($event){return _vm.onShowModal('ppGroups')}}},[_c('span',[_vm._v("Управление группами")])]),_vm._v(" "),_c('a',{staticClass:"dropdown-menu-item",on:{"click":function($event){return _vm.onShowModal('ppSkuFieldSettings')}}},[_c('span',[_vm._v("Настройка полей SKU")])])]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-list",attrs:{"id":"exportList"}},[(_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.skuCreate) || _vm.info.User.MainRole === 'administrators')?_c('a',{staticClass:"dropdown-menu-item",attrs:{"href":"javascript:document.getElementById('dropFiles2').click()"}},[_c('span',[_vm._v("Импорт или обновление связей")])]):_vm._e(),_vm._v(" "),(_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.skuLinkExport) || _vm.info.User.MainRole === 'administrators')?_c('a',{staticClass:"dropdown-menu-item",on:{"click":function($event){return _vm.onSkuLinkExport()}}},[_c('span',[_vm._v("Экспорт связей")])]):_vm._e(),_vm._v(" "),(_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.skuCreate) || _vm.info.User.MainRole === 'administrators')?_c('a',{staticClass:"dropdown-menu-item",attrs:{"href":"javascript:document.getElementById('dropFiles').click()"}},[_c('span',[_vm._v("Импорт или обновление SKU")])]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"dropdown-menu-item",on:{"click":function($event){return _vm.onExport()}}},[_c('span',[_vm._v("Экспорт SKU")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"body-panel-control-separator flex"},[(_vm.$route.query.folderId)?_c('p',{staticClass:"btn-back margin-right-10"},[_c('a',{staticClass:"router-link-active",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.back.apply(null, arguments)}}},[_vm._v("Назад")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"input-text",attrs:{"type":"text","placeholder":"Поиск по названию и описанию"},domProps:{"value":(_vm.search)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.search=$event.target.value},function($event){return _vm.onSearchChange($event)}]}}),_vm._v(" "),(_vm.search)?_c('button',{staticClass:"btn btn-img input-group-addon",attrs:{"type":"button","title":"Очистить"},on:{"click":_vm.onSearchClear}},[_c('i',{staticClass:"fa fa-close"})]):_vm._e()]),_vm._v(" "),(_vm.info.User && (_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.skuCreate) || _vm.info.User.MainRole === 'administrators'))?_c('div',{staticClass:"switch margin-left-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.active),expression:"active"}],attrs:{"type":"checkbox","id":"s5","checked":"checked"},domProps:{"checked":Array.isArray(_vm.active)?_vm._i(_vm.active,null)>-1:(_vm.active)},on:{"change":[function($event){var $$a=_vm.active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.active=$$a.concat([$$v]))}else{$$i>-1&&(_vm.active=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.active=$$c}},_vm.reload]}}),_vm._v(" "),_c('label',{staticClass:"slider-v3",attrs:{"for":"s5"}})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page panel-block-news no-padding-right"},[(_vm.importResult != null)?_c('div',{staticClass:"result-import margin-bottom-20"},[_vm._v("\n            Успешно импортировано: "+_vm._s(_vm.importResult.SuccessfullyExported)+" "+_vm._s(_vm.get_text_ending(_vm.importResult.SuccessfullyExported, ['строка', 'строки', 'строк']))),_c('br'),_c('br'),_vm._v(" "),(_vm.importResult.Errors.length)?[_vm._v("\n                Ошибки:\n                "),_c('br'),_vm._v(" "),_c('ul',_vm._l((_vm.importResult.Errors),function(error){return _c('li',[_vm._v("\n                        "+_vm._s(error)+"\n                    ")])}),0)]:_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn",on:{"click":function($event){_vm.importResult = null;}}},[_vm._v("Закрыть")])],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"body-panel-content-center"},[_vm._l((_vm.sku),function(item,i){return (_vm.skuSettings != null)?[(item.Group && item.Group.Name != null)?_c('h2',{staticClass:"group-header"},[_vm._v(_vm._s(item.Group.Name))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"panel-block panel-block-new",on:{"click":function($event){return _vm.onItemClick(item)}}},[_c('div',{staticClass:"panel-block-img-base"},[_c('div',{staticClass:"panel-block-img"},[(!item.IsFolder)?_c('img',{style:(_vm.getImageStyleFormatted(item.ImageStyle)),attrs:{"src":item.Image,"alt":""}}):_vm._e(),_vm._v(" "),(item.IsFolder)?_c('img',{style:(_vm.getImageStyleFormatted(item.ImageStyle)),attrs:{"src":item.Image,"alt":""}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"panel-block-info"},[(item.IsFolder)?[_c('p',{staticClass:"panel-block-header margin-bottom-10"},[_vm._v(_vm._s(item.Name))]),_vm._v(" "),_c('p',{staticClass:"panel-body-desc",domProps:{"innerHTML":_vm._s(item.DescriptionFormatted)}})]:_vm._e(),_vm._v(" "),(!item.IsFolder)?[(_vm.skuSettings.Name.ShowInList)?_c('p',{staticClass:"panel-block-header margin-bottom-10"},[_vm._v(_vm._s(item.Name))]):_vm._e(),_vm._v(" "),_vm._l((_vm.skuSettingsOrdered),function(s){return (s.FieldName !== 'Name' && s.ShowInList)?[(s.FieldName === 'Description')?_c('p',{staticClass:"panel-body-desc",domProps:{"innerHTML":_vm._s(item.DescriptionFormatted)}}):(item[s.FieldName])?_c('p',{class:['input-text-lbl', s.FieldName]},[_c('span',[_vm._v(_vm._s(s.Title)+":  ")]),_vm._v(_vm._s(item[s.FieldName])),(s.FieldName === 'RRC')?[_vm._v(" руб.")]:_vm._e()],2):_vm._e()]:_vm._e()}),_vm._v(" "),(item.AmountForUser)?_c('p',{staticClass:"input-text-lbl"},[_c('span',[_vm._v("Баллы за отчёт: "+_vm._s(_vm.formatAmountForUser(item.AmountForUser)))])]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"panel-body-actions panel-body-actions-false"}),_vm._v(" "),(!item.IsFolder)?_c('div',{staticClass:"panel-body-actions panel-body-actions-footer"},[_c('button',{staticClass:"btn",on:{"click":function($event){$event.stopPropagation();return _vm.goToSku(item.Id)}}},[_vm._v("Подробнее")]),_vm._v(" "),(item.Id > 0 && _vm.info.User && (_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.skuCreate) || _vm.info.User.MainRole === 'administrators'))?_c('button',{staticClass:"btn btn-img",on:{"click":function($event){$event.stopPropagation();return _vm.goToSkuEdit(item.Id)}}},[_c('img',{attrs:{"src":__webpack_require__(31),"alt":""}})]):_vm._e()]):_vm._e(),_vm._v(" "),(item.IsFolder)?_c('div',{staticClass:"panel-body-actions panel-body-actions-footer"},[_c('button',{staticClass:"btn",on:{"click":function($event){$event.stopPropagation();return _vm.goToFolder(item.Id)}}},[_vm._v("Подробнее")]),_vm._v(" "),(item.Id > 0 && _vm.info.User && (_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.skuCreate) || _vm.info.User.MainRole === 'administrators'))?_c('button',{staticClass:"btn btn-img",on:{"click":function($event){$event.stopPropagation();return _vm.goToFolderEdit(item.Id)}}},[_c('img',{attrs:{"src":__webpack_require__(31),"alt":""}})]):_vm._e()]):_vm._e()])]:_vm._e()}),_vm._v(" "),(_vm.emptyResults)?[_c('h2',[_vm._v("Ничего не найдено...")])]:_vm._e()],2)]),_vm._v(" "),_c('popup-window',{ref:"ppSkuFieldSettings",attrs:{"title":'Настройка отображения полей SKU',"width":800,"modal":true}},[_c('div',[_c('p',{staticClass:"caption-help"},[_vm._v("Настройка отображения и использования полей справочника в данном проекте")]),_vm._v(" "),_c('table',{staticClass:"table-view",attrs:{"id":"tSkuFieldSett"}},[_c('thead',{staticClass:"head-show"},[_c('tr',{staticClass:"heading"},[_c('th',[_vm._v("Название поля")]),_vm._v(" "),_c('th',[_vm._v("Список")]),_vm._v(" "),_c('th',[_vm._v("Детали")]),_vm._v(" "),(_vm.customSettingsFieldsCount > 0)?_c('th',{staticStyle:{"width":"100px"}}):_vm._e()])]),_vm._v(" "),(_vm.skuSettingsOrdered != null)?_c('Container',{attrs:{"lock-axis":'y',"tag":"tbody"},on:{"drop":_vm.onSkuSettingsDrop,"drag-start":_vm.onDragStart}},_vm._l((_vm.skuSettingsOrdered),function(skuSettingsItem,s){return _c('Draggable',{key:s,attrs:{"tag":"tr","lock-axis":'x'}},[_c('td',[(skuSettingsItem.Edited)?[_c('input',{directives:[{name:"model",rawName:"v-model",value:(skuSettingsItem.Title),expression:"skuSettingsItem.Title"}],staticClass:"input-text",attrs:{"type":"text","name":'settings_' + skuSettingsItem.FieldName},domProps:{"value":(skuSettingsItem.Title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(skuSettingsItem, "Title", $event.target.value)}}})]:[_vm._v("\n                                "+_vm._s(skuSettingsItem.Title)+"\n                            ")]],2),_vm._v(" "),_c('td',{staticClass:"bit"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(skuSettingsItem.ShowInList),expression:"skuSettingsItem.ShowInList"}],staticClass:"input-checkbox",attrs:{"id":'list' + s,"name":'list' + s,"value":"true","type":"checkbox","disabled":_vm.checkDisabledSettingsItem(skuSettingsItem.FieldName)},domProps:{"checked":Array.isArray(skuSettingsItem.ShowInList)?_vm._i(skuSettingsItem.ShowInList,"true")>-1:(skuSettingsItem.ShowInList)},on:{"change":function($event){var $$a=skuSettingsItem.ShowInList,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(skuSettingsItem, "ShowInList", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(skuSettingsItem, "ShowInList", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(skuSettingsItem, "ShowInList", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl no-text",attrs:{"for":'list' + s}})]),_vm._v(" "),_c('td',{staticClass:"bit"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(skuSettingsItem.ShowInDetails),expression:"skuSettingsItem.ShowInDetails"}],staticClass:"input-checkbox",attrs:{"id":'det' + s,"name":'det' + s,"value":"true","type":"checkbox","disabled":skuSettingsItem.FieldName === 'Name'},domProps:{"checked":Array.isArray(skuSettingsItem.ShowInDetails)?_vm._i(skuSettingsItem.ShowInDetails,"true")>-1:(skuSettingsItem.ShowInDetails)},on:{"change":function($event){var $$a=skuSettingsItem.ShowInDetails,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(skuSettingsItem, "ShowInDetails", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(skuSettingsItem, "ShowInDetails", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(skuSettingsItem, "ShowInDetails", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl no-text",attrs:{"for":'det' + s}})]),_vm._v(" "),(_vm.customSettingsFieldsCount > 0)?_c('td',[(skuSettingsItem.Edited)?[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onSettingsOkBtn(skuSettingsItem)}}},[_vm._v("Ok")])]:_vm._e(),_vm._v(" "),(skuSettingsItem.FieldName.startsWith('CustomField') && !skuSettingsItem.Edited)?[_c('div',{staticClass:"btns flex"},[_c('button',{staticClass:"btn btn-img",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onSettingsEditBtn(skuSettingsItem)}}},[_c('img',{attrs:{"src":__webpack_require__(31),"alt":""}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-img",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onSettingsRemoveBtn(skuSettingsItem)}}},[_c('img',{attrs:{"src":__webpack_require__(17),"alt":""}})])])]:_vm._e()],2):_vm._e()])}),1):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"flex btns"},[(_vm.customSettingsFieldsCount < 50)?_c('button',{staticClass:"btn margin-top-20",on:{"click":function($event){$event.stopPropagation();return _vm.onAddNewSettings.apply(null, arguments)}}},[_vm._v("Добавить")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.onSaveSettings}},[_vm._v("Сохранить")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.onCloseSettings}},[_vm._v("Отмена")])])]),_vm._v(" "),_c('popup-window',{ref:"ppGroups",attrs:{"title":'Управление группами SKU',"width":800}},[_c('Container',{attrs:{"lock-axis":'y'},on:{"drop":_vm.onDrop}},_vm._l((_vm.groupsOrdered),function(group,i){return _c('Draggable',[_c('div',{staticClass:"draggable-item",on:{"click":function($event){return _vm.onGroupSelect(group)}}},[(group.Edited)?[_c('div',{staticClass:"flex"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(group.Name),expression:"group.Name"}],staticClass:"input-text",attrs:{"type":"text"},domProps:{"value":(group.Name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(group, "Name", $event.target.value)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.stopPropagation();return _vm.onSaveGroup(group)}}},[_vm._v("\n                                Ok\n                            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){$event.stopPropagation();return _vm.onGroupEditCancel(group)}}},[_vm._v("\n                                Отмена\n                            ")])])]:_vm._e(),_vm._v(" "),(!group.Edited)?[_vm._v("\n                        "+_vm._s(group.Name)+"\n                        "),_c('div',{staticClass:"btns flex",staticStyle:{"float":"right","margin-top":"-6px"}},[_c('button',{staticClass:"btn btn-default btn-img",on:{"click":function($event){$event.stopPropagation();return _vm.onGroupEdit(group)}}},[_c('img',{attrs:{"src":__webpack_require__(31),"alt":""}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-img",on:{"click":function($event){$event.stopPropagation();return _vm.onRemoveGroup(group, i)}}},[_c('img',{attrs:{"src":__webpack_require__(17),"alt":""}})])])]:_vm._e()],2)])}),1),_vm._v(" "),_c('div',{staticClass:"flex btns"},[_c('button',{staticClass:"btn margin-top-10",on:{"click":function($event){$event.stopPropagation();return _vm.onAddNewGroup.apply(null, arguments)}}},[_vm._v("Добавить")]),_vm._v(" "),(_vm.groupsChanged)?_c('button',{staticClass:"btn margin-top-10",on:{"click":function($event){$event.stopPropagation();return _vm.saveGroups.apply(null, arguments)}}},[_vm._v("Сохранить")]):_vm._e()])],1),_vm._v(" "),_c('vue-headful',{attrs:{"title":_vm.getPageTitle()}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpendBonuses_vue__ = __webpack_require__(293);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a76e37a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpendBonuses_vue__ = __webpack_require__(817);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpendBonuses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a76e37a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpendBonuses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[(_vm.project != null && _vm.info.User && ((_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.bonusSpend) && _vm.project.Id !== 7) || _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.rewardsEdit) || _vm.info.User.MainRole === 'administrators' || _vm.info.ProjectsLength > 1))?_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"body-panel-control-separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[(_vm.$route.query.folderId != null)?_c('p',{staticClass:"btn-back"},[_c('a',{staticClass:"router-link-active",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.$router.back()}}},[_vm._v("Назад")])]):_vm._e(),_vm._v(" "),(_vm.info.User && (_vm.info.User.MainRole === 'administrators' || _vm.info.ProjectsLength > 1))?_c('project-select',{attrs:{"user":_vm.info.User},on:{"onChange":_vm.onProjectChange}}):_vm._e()],1)]),_vm._v(" "),(_vm.info.User && _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.bonusSpend))?_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex",staticStyle:{"align-items":"flex-start","flex-direction":"column","margin-top":"10px"}},[(_vm.project.RewardUnitTypeId === 1)?_c('div',{staticClass:"flex",staticStyle:{"align-items":"center"}},[_c('p',{staticClass:"line-text"},[_vm._v("Всего баллов")]),_vm._v(" "),_c('p',{staticClass:"menu-item-info grey margin-left-5"},[_vm._v(_vm._s(_vm.formatInt(_vm.info.User.PotentialBalance)))]),_vm._v(" "),_c('p',{staticClass:"line-text margin-left-5"},[_vm._v("из них доступно")]),_vm._v(" "),_c('p',{staticClass:"menu-item-info green margin-left-5"},[_vm._v(_vm._s(_vm.formatInt(_vm.info.User.ActiveBalanceWithOrders)))])]):_vm._e(),_vm._v(" "),(_vm.project.RewardUnitTypeId === 2)?_c('div',{staticClass:"flex"},[_c('p',[_vm._v("Выдано купонов")]),_vm._v(" "),_c('p',{staticClass:"menu-item-info grey"},[_vm._v(_vm._s(_vm.formatInt(_vm.info.User.PotentialBalance)))])]):_vm._e(),_vm._v(" "),(_vm.info.User && _vm.info.User.MainRole !== 'administrators')?[((_vm.info.User.PassportVerificationState === 0))?_c('div',{staticClass:"error",staticStyle:{"padding":"5px 15px 0px 40px"}},[_vm._v("\n                            Для выбора вознаграждения загрузите паспортные данные в "),_c('span',{staticStyle:{"border-bottom":"1px solid #8394a0","cursor":"pointer"},on:{"click":function($event){return _vm.goToProfile()}}},[_vm._v("профиле")])]):_vm._e(),_vm._v(" "),(_vm.info.User.PassportVerificationState === 1)?_c('div',{staticClass:"error",staticStyle:{"padding":"5px 15px 0px 40px"}},[_vm._v("\n                            Мы проверяем загруженные документы. Скоро Вы сможете выбрать вознаграждение!\n                        ")]):_vm._e(),_vm._v(" "),((_vm.info.User.PassportVerificationState === 3))?_c('div',{staticClass:"error",staticStyle:{"padding":"5px 15px 0px 40px"}},[_vm._v("\n                            Мы не смогли принять загруженные документы, ознакомьтесь с причиной в "),_c('span',{staticStyle:{"border-bottom":"1px solid #8394a0","cursor":"pointer"},on:{"click":function($event){return _vm.goToProfile()}}},[_vm._v("профиле")]),_vm._v(" и исправьте ошибки.\n                        ")]):_vm._e()]:_vm._e()],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[_c('div',{staticClass:"flex btns"},[(_vm.info.User && (_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.rewardsEdit) || _vm.info.User.MainRole === 'administrators'))?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onShowGroupsModal.apply(null, arguments)}}},[_vm._v("\n                        Управление группами\n                    ")]):_vm._e(),_vm._v(" "),(_vm.info.User && (_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.rewardsEdit) || _vm.info.User.MainRole === 'administrators'))?_c('button',{staticClass:"btn btn-news",on:{"click":_vm.onAddFolder}},[_vm._v("\n                        Добавить папку\n                    ")]):_vm._e(),_vm._v(" "),(_vm.info.User && (_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.rewardsEdit) || _vm.info.User.MainRole === 'administrators'))?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onAddReward()}}},[_vm._v("\n                        Добавить\n                    ")]):_vm._e(),_vm._v(" "),(_vm.info.User && _vm.info.User.MainRole === 'administrators')?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onExport()}}},[_vm._v("\n                        Экспорт\n                    ")]):_vm._e(),_vm._v(" "),((_vm.project.RewardUnitTypeId === 1 || _vm.project.RewardUnitTypeId === 2) && _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.bonusSpend))?_c('router-link',{staticClass:"header-menu-right-item",attrs:{"to":"/bonus-history"}},[_vm._v("\n                        История начислений баллов\n                    ")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"body-panel-control-separator flex"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"input-text",attrs:{"type":"text","placeholder":"Поиск по названию и описанию"},domProps:{"value":(_vm.search)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.search=$event.target.value},function($event){return _vm.onSearchChange($event)}]}}),_vm._v(" "),(_vm.search)?_c('button',{staticClass:"btn btn-img input-group-addon",attrs:{"type":"button","title":"Очистить"},on:{"click":_vm.onSearchClear}},[_c('i',{staticClass:"fa fa-close"})]):_vm._e()]),_vm._v(" "),(_vm.info.User && (_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.rewardsEdit) || _vm.info.User.MainRole === 'administrators'))?_c('div',{staticClass:"switch margin-left-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.active),expression:"active"}],attrs:{"type":"checkbox","id":"s5","checked":"checked"},domProps:{"checked":Array.isArray(_vm.active)?_vm._i(_vm.active,null)>-1:(_vm.active)},on:{"change":[function($event){var $$a=_vm.active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.active=$$a.concat([$$v]))}else{$$i>-1&&(_vm.active=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.active=$$c}},_vm.reload]}}),_vm._v(" "),_c('label',{staticClass:"slider-v3",attrs:{"for":"s5"}})]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page no-padding-right"},[(_vm.rewardTypes.length)?_c('div',{staticClass:"body-panel-content-center flex btns margin-bottom-20"},[_c('button',{class:['btn', {'active': _vm.rewardTypeId === 0 }],attrs:{"type":"button"},on:{"click":function($event){return _vm.onRewardTypeChange(0)}}},[_vm._v("Все")]),_vm._v(" "),_vm._l((_vm.rewardTypes),function(type){return _c('button',{class:['btn', {'active': _vm.rewardTypeId === type }],attrs:{"type":"button"},on:{"click":function($event){return _vm.onRewardTypeChange(type)}}},[_vm._v("\n                "+_vm._s(_vm.getRewardTypeName(type))+"\n            ")])})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"body-panel-content-center"},[_vm._l((_vm.rewards),function(item){return [(item.Group && item.Group.Name != null)?_c('h2',{staticClass:"group-header"},[_vm._v(_vm._s(item.Group.Name))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"panel-block panel-block-new",on:{"click":function($event){return _vm.onItemClick(item)}}},[_c('div',{staticClass:"panel-block-img-base"},[(item.Image)?_c('div',{staticClass:"panel-block-img"},[_c('img',{style:(_vm.getImageStyleFormatted(item.ImageStyle)),attrs:{"src":item.Image,"alt":""}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"panel-block-info"},[_c('p',{staticClass:"panel-block-header"},[_vm._v(_vm._s(item.Name))]),_vm._v(" "),_c('p',{staticClass:"panel-body-desc",domProps:{"innerHTML":_vm._s(item.DescriptionFormatted)}}),_vm._v(" "),(item.WebLink)?_c('p',[_c('button',{staticClass:"btn",attrs:{"title":item.WebLink,"onclick":'window.open(\'' + item.WebLink + '\',\'_blank\')'}},[_vm._v("Перейти на сайт")])]):_vm._e()]),_vm._v(" "),(item.IsFolder || 
                         (
                            _vm.info.User && 
                            (_vm.info.User.PassportVerificationState === 2 || _vm.info.User.MainRole === 'administrators' || _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.rewardsEdit)) &&
                            (
                             _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.bonusSpend) || 
                             _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.rewardsEdit) || 
                             _vm.info.User.MainRole === 'administrators'
                            )
                         ))?_c('div',{staticClass:"panel-body-actions flex"},[(item.RewardType !== 4)?[(item.RewardType === 3 && (!_vm.info.User.PaymentSettings || _vm.info.User.PaymentSettings.VerificationState !== 2))?_c('div',[_vm._v("\n                                Необходимо заполнить раздел \"Банковская карта\" в Профиле\n                            ")]):[(item.ManualNominalPercent == null && item.Prices && item.Prices.length === 1)?_c('button',{staticClass:"btn",on:{"click":function($event){$event.stopPropagation();return _vm.getReward(item.Id, item.Prices[0].Id, item.RewardType)}}},[_vm._v("\n                                    "+_vm._s(_vm.getFormattedPriceDescription(item.Prices[0]))+"\n                                ")]):_vm._e(),_vm._v(" "),(!item.Prices && item.ManualNominalPercent != null)?_c('button',{staticClass:"btn",on:{"click":function($event){$event.stopPropagation();return _vm.onShowManualNominalModal(item)}}},[_vm._v("\n                                    Ввести вручную\n                                ")]):_vm._e(),_vm._v(" "),(item.Prices != null && (item.Prices.length > 1 || item.ManualNominalPercent != null) && _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.bonusSpend))?_c('slide-down',{attrs:{"items":_vm.getPriceItemsForDropdown(item),"selectText":'Выбрать номинал',"dataField":'Id',"textField":'Name'},on:{"change":function($event){
                         var i = arguments.length, argsArray = Array(i);
                         while ( i-- ) argsArray[i] = arguments[i];
return _vm.onPriceChange.apply(void 0, argsArray.concat( [item] ))}}}):_vm._e()]]:_vm._e(),_vm._v(" "),(item.Prices != null && item.RewardType === 4)?[(_vm.info.User && _vm.info.User.PassportVerificationState === 2
                                    && _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.bonusSpend)
                                    && item.Prices.length === 1
                                    && _vm.info.User.ActiveBalance >= item.Prices[0].Price)?_c('button',{staticClass:"btn",on:{"click":function($event){$event.stopPropagation();return _vm.getReward(item.Id, item.Prices[0].Id, item.RewardType)}}},[_vm._v("\n                                "+_vm._s(_vm.getFormattedPriceDescription(item.Prices[0]))+"\n                            ")]):_vm._e(),_vm._v(" "),(_vm.info.User
                                    && _vm.info.User.PassportVerificationState === 2
                                    && _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.bonusSpend)
                                    && item.Prices.length > 1)?_c('slide-down',{attrs:{"items":_vm.getPriceItemsForDropdown(item),"selectText":'Выбрать номинал',"dataField":'Id',"textField":'Name'},on:{"change":function($event){
                                    var i = arguments.length, argsArray = Array(i);
                                    while ( i-- ) argsArray[i] = arguments[i];
return _vm.onPriceChange.apply(void 0, argsArray.concat( [item] ))}}}):_vm._e()]:_vm._e(),_vm._v(" "),(item.IsFolder)?_c('button',{staticClass:"btn",on:{"click":function($event){$event.stopPropagation();return _vm.goToFolder(item.Id)}}},[_vm._v("\n                            Подробнее\n                        ")]):_vm._e(),_vm._v(" "),(item.Id > 0 && _vm.info.User && (_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.rewardsEdit) || _vm.info.User.MainRole === 'administrators'))?_c('button',{staticClass:"btn btn-img",on:{"click":function($event){$event.stopPropagation();return _vm.editReward(item)}}},[_c('img',{attrs:{"src":__webpack_require__(31),"alt":""}})]):_vm._e()],2):_vm._e()])]})],2)]),_vm._v(" "),_c('popup-window',{ref:"ppGroups",attrs:{"title":'Управление группами вознаграждений',"width":800,"modal":true}},[_c('div',[_c('Container',{attrs:{"lock-axis":'y'},on:{"drop":_vm.onDrop,"drag-start":_vm.onDragStart}},_vm._l((_vm.groupsOrdered),function(group,i){return _c('Draggable',[_c('div',{staticClass:"draggable-item",on:{"click":function($event){return _vm.onGroupSelect(group)}}},[(group.Edited)?[_c('div',{staticClass:"flex"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(group.Name),expression:"group.Name"}],staticClass:"input-text",attrs:{"type":"text"},domProps:{"value":(group.Name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(group, "Name", $event.target.value)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.stopPropagation();return _vm.onSaveGroup(group)}}},[_vm._v("\n                                    Ok\n                                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){$event.stopPropagation();return _vm.onGroupEditCancel(group)}}},[_vm._v("\n                                    Отмена\n                                ")])])]:_vm._e(),_vm._v(" "),(!group.Edited)?[_vm._v("\n                            "+_vm._s(group.Name)+"\n                            "),_c('div',{staticClass:"btns flex",staticStyle:{"float":"right","margin-top":"-6px"}},[_c('button',{staticClass:"btn btn-default btn-img",on:{"click":function($event){$event.stopPropagation();return _vm.onGroupEdit(group)}}},[_c('img',{attrs:{"src":__webpack_require__(31),"alt":""}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-img",on:{"click":function($event){$event.stopPropagation();return _vm.onRemoveGroup(group, i)}}},[_c('img',{attrs:{"src":__webpack_require__(17),"alt":""}})])])]:_vm._e()],2)])}),1)],1),_vm._v(" "),_c('div',{staticClass:"flex btns"},[_c('button',{staticClass:"btn margin-top-10",on:{"click":function($event){$event.stopPropagation();return _vm.onAddNewGroup.apply(null, arguments)}}},[_vm._v("Добавить")]),_vm._v(" "),(_vm.groupsChanged)?_c('button',{staticClass:"btn margin-top-10",on:{"click":function($event){$event.stopPropagation();return _vm.saveGroups.apply(null, arguments)}}},[_vm._v("Сохранить")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn margin-top-10",on:{"click":function($event){$event.stopPropagation();return _vm.closeModal('ppGroups')}}},[_vm._v("Отмена")])])]),_vm._v(" "),_c('popup-window',{ref:"ppManualNominal",attrs:{"title":'Укажите необходимую сумму',"width":800,"modal":true}},[_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, positive: true}),expression:"{required: true, positive: true}"},{name:"model",rawName:"v-model",value:(_vm.manual.sum),expression:"manual.sum"}],class:['input-text', {'input-error': _vm.errors.has('ManualSum', 'manual')}],attrs:{"name":"ManualSum","type":"text","data-vv-as":"Сумма","data-vv-scope":"manual"},domProps:{"value":(_vm.manual.sum)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.manual, "sum", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('ManualSum')))])]),_vm._v(" "),_c('div',{staticClass:"margin-bottom-20"},[_vm._v("\n            "+_vm._s(_vm.getCommissionText())+" "+_vm._s((_vm.totalManualSumWithComission ? _vm.totalManualSumWithComission.toFixed(2) : null))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"flex btns"},[_c('button',{staticClass:"btn margin-top-10",on:{"click":function($event){$event.stopPropagation();return _vm.onManualNominalAdd.apply(null, arguments)}}},[_vm._v("Готово")]),_vm._v(" "),_c('button',{staticClass:"btn margin-top-10",on:{"click":function($event){$event.stopPropagation();return _vm.$refs['ppManualNominal'].close()}}},[_vm._v("Отмена")])])]),_vm._v(" "),_c('popup-window',{ref:"ppAddress",attrs:{"title":'Укажите адрес доставки',"width":800,"height":'90%',"modal":true},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('div',{staticClass:"popup-footer"},[_c('div',{staticClass:"btns flex",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn margin-top-10",on:{"click":function($event){$event.stopPropagation();return _vm.onGetRewardWithAddress.apply(null, arguments)}}},[_vm._v("Готово")]),_vm._v(" "),_c('button',{staticClass:"btn margin-top-10",on:{"click":function($event){$event.stopPropagation();return _vm.$refs['ppAddress'].close()}}},[_vm._v("Отмена")])])])]},proxy:true}])},[_c('div',{staticClass:"form-field"},[_c('drop-down',{attrs:{"items":_vm.address.list,"dataField":'Id',"textField":'DisplayName'},on:{"change":_vm.onAddressChange},model:{value:(_vm.address.addressId),callback:function ($$v) {_vm.$set(_vm.address, "addressId", $$v)},expression:"address.addressId"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Получатель")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"},{name:"model",rawName:"v-model",value:(_vm.address.data.Fio),expression:"address.data.Fio"}],class:['input-text', {'input-error': _vm.errors.has('addressFio', 'address')}],attrs:{"name":"addressFio","type":"text","data-vv-as":"Фио","data-vv-scope":"address"},domProps:{"value":(_vm.address.data.Fio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address.data, "Fio", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('addressFio')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Телефон")]),_vm._v(" "),_c('the-mask',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, regex: /^\d{11}$/ }),expression:"{ required: true, regex: /^\\d{11}$/ }"}],class:['input-text', {'input-error': _vm.errors.has('addressPhoneNumber', 'address')}],attrs:{"mask":'# (###) ###-##-##',"name":"addressPhoneNumber","data-vv-scope":"address","data-vv-as":"Телефон"},model:{value:(_vm.address.data.PhoneNumber),callback:function ($$v) {_vm.$set(_vm.address.data, "PhoneNumber", $$v)},expression:"address.data.PhoneNumber"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('addressPhoneNumber')))])],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Адрес")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"},{name:"model",rawName:"v-model",value:(_vm.address.data.FullAddress),expression:"address.data.FullAddress"}],class:['input-text', {'input-error': _vm.errors.has('addressFullAddress', 'address')}],attrs:{"name":"addressFullAddress","id":"addressFullAddress","type":"text","data-vv-as":"Адрес","data-vv-scope":"address"},domProps:{"value":(_vm.address.data.FullAddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address.data, "FullAddress", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"})])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":_vm.getPageTitle()}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TradePoints_vue__ = __webpack_require__(294);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d78e061_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TradePoints_vue__ = __webpack_require__(821);
function injectStyle (ssrContext) {
  __webpack_require__(819)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d78e061"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TradePoints_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d78e061_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TradePoints_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(820);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("0b810706", content, true, {});

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".table-point-address[data-v-5d78e061]{width:500px!important;min-width:500px!important;margin:0 30px}", ""]);

// exports


/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"body-panel-control-separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"btn-back caption-help margin-right-10"},[_c('router-link',{attrs:{"to":_vm.$route.query.returnUrl ? _vm.$route.query.returnUrl : '/projects/' + _vm.$route.params.projectId}},[_vm._v("Проект")])],1),_vm._v(" "),_c('p',{staticClass:"caption-help margin-right-10"},[_vm._v("\n                            Торговые точки\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[_c('div',{staticClass:"btns flex"},[_c('input',{ref:"dropFiles",staticClass:"file-upload-zone-btn",attrs:{"type":"file","id":"dropFiles","name":"dropFiles","accept":".xlsx"},on:{"change":function($event){return _vm.onFileChange()}}}),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button","onclick":"document.getElementById('dropFiles').click()"}},[_vm._v("\n                            Импорт\n                        ")]),_vm._v(" "),_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.onExport()}}},[_vm._v("\n                            Экспорт\n                        ")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"id":"sample_editable_1_2_new"},on:{"click":function($event){$event.stopPropagation();return _vm.onAddItem()}}},[_vm._v("\n                            Добавить\n                        ")])])])]),_vm._v(" "),_c('div',{staticClass:"body-panel-control-separator"},[_c('complex-filter',{attrs:{"filters":_vm.tradePointsFilters,"searchFunction":_vm.searchFunction,"tableName":'[dbo].[TradePoint]'},on:{"onFilterChange":_vm.onFilterChange}})],1)]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page"},[(_vm.importResult != null)?_c('div',[_vm._v("\n                Успешно импортировано: "+_vm._s(_vm.importResult.SuccessfullyExported)+" строк"),_c('br'),_c('br'),_vm._v(" "),(_vm.importResult.Errors.length)?[_vm._v("\n                    Ошибки:"),_c('br'),_vm._v(" "),_c('ul',_vm._l((_vm.importResult.Errors),function(error){return _c('li',[_vm._v("\n                            "+_vm._s(error)+"\n                        ")])}),0)]:_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn",on:{"click":function($event){_vm.importResult = null;}}},[_vm._v("Закрыть")])],2):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table-view",attrs:{"id":"dataTable"}},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.tradePoints),function(item,i){return _c('tr',{class:{ 'table-point-row-off': !item.Enabled },on:{"click":function($event){$event.stopPropagation();return _vm.onItemClick(item, i)}}},[_c('td',{staticClass:"table-point-name"},[_vm._v(_vm._s(item.Name)),_c('p',{staticClass:"input-text-lbl"},[_vm._v(_vm._s(item.ExternalId))])]),_vm._v(" "),_c('td',{staticClass:"table-point-address"},[_vm._v(_vm._s(item.Region)+", "+_vm._s(item.City)+", "+_vm._s(item.Address)+", "+_vm._s(item.Shop))]),_vm._v(" "),_c('td',{staticClass:"table-point-daterange"},[_vm._v(_vm._s(_vm.formatDate(item.CreateDate))+" - "+_vm._s(_vm.formatDate(item.EndDate)))]),_vm._v(" "),_c('td',{staticClass:"table-point-users"},_vm._l((_vm.getGroupedRoles(item.Roles)),function(role){return _c('div',[_c('span',[_vm._v(_vm._s(role.RoleName)+":")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(role.Users.filter(function (x) { return !x.Disabled; }).join('; ')))])])}),0),_vm._v(" "),_c('td',{staticClass:"obtn"})])}),0)])]),_vm._v(" "),(_vm.selectedTradepoint != null)?_c('popup-window',{ref:"ppTradepointEdit",attrs:{"title":'Редактирование торговой точки',"width":'1200px',"modal":false}},[_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"table-point-name"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Название")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTradepoint.Name),expression:"selectedTradepoint.Name"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-text', {'input-error': _vm.errors.has('Name')}],attrs:{"placeholder":"Название","type":"text","name":"Name"},domProps:{"value":(_vm.selectedTradepoint.Name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedTradepoint, "Name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-5"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Внешний ID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTradepoint.ExternalId),expression:"selectedTradepoint.ExternalId"}],staticClass:"input-text",attrs:{"placeholder":"Внешний ID","type":"text","name":"ExternalId"},domProps:{"value":(_vm.selectedTradepoint.ExternalId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedTradepoint, "ExternalId", $event.target.value)}}})]),_vm._v(" "),(_vm.linkingEnabled)?_c('div',{staticClass:"form-field margin-top-5"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Поле для связи")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTradepoint.SkuLink),expression:"selectedTradepoint.SkuLink"}],class:['input-text', {'input-error': _vm.errors.has('SkuLink')}],attrs:{"placeholder":"","type":"text","name":"SkuLink"},domProps:{"value":(_vm.selectedTradepoint.SkuLink)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedTradepoint, "SkuLink", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-5"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Широта")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTradepoint.Latitude),expression:"selectedTradepoint.Latitude"},{name:"validate",rawName:"v-validate",value:({lonlat: true}),expression:"{lonlat: true}"}],class:['input-text', {'input-error': _vm.errors.has('Latitude')}],attrs:{"placeholder":"Широта","type":"text","name":"Latitude","data-vv-as":"Широта"},domProps:{"value":(_vm.selectedTradepoint.Latitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedTradepoint, "Latitude", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Latitude')))])]),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-5"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Долгота")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTradepoint.Longitude),expression:"selectedTradepoint.Longitude"},{name:"validate",rawName:"v-validate",value:({lonlat: true}),expression:"{lonlat: true}"}],class:['input-text', {'input-error': _vm.errors.has('Longitude')}],attrs:{"placeholder":"Долгота","type":"text","name":"Longitude","data-vv-as":"Долгота"},domProps:{"value":(_vm.selectedTradepoint.Longitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedTradepoint, "Longitude", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Longitude')))])]),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTradepoint.Enabled),expression:"selectedTradepoint.Enabled"}],staticClass:"input-checkbox",attrs:{"id":"Enabled","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectedTradepoint.Enabled)?_vm._i(_vm.selectedTradepoint.Enabled,null)>-1:(_vm.selectedTradepoint.Enabled)},on:{"change":function($event){var $$a=_vm.selectedTradepoint.Enabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedTradepoint, "Enabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedTradepoint, "Enabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedTradepoint, "Enabled", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"Enabled"}},[_vm._v("Активна")])])]),_vm._v(" "),_c('div',{staticClass:"table-point-address"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Регион")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTradepoint.Region),expression:"selectedTradepoint.Region"}],class:['input-text', {'input-error': _vm.errors.has('Region')}],attrs:{"placeholder":"Регион","type":"text","name":"Region"},domProps:{"value":(_vm.selectedTradepoint.Region)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedTradepoint, "Region", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-5"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Область")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTradepoint.Area),expression:"selectedTradepoint.Area"}],class:['input-text', {'input-error': _vm.errors.has('Area')}],attrs:{"placeholder":"Область","type":"text","name":"Area"},domProps:{"value":(_vm.selectedTradepoint.Area)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedTradepoint, "Area", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-5"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Город")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTradepoint.City),expression:"selectedTradepoint.City"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-text', {'input-error': _vm.errors.has('City')}],attrs:{"placeholder":"Город","type":"text","name":"City"},domProps:{"value":(_vm.selectedTradepoint.City)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedTradepoint, "City", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-5"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Адрес")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTradepoint.Address),expression:"selectedTradepoint.Address"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-text', {'input-error': _vm.errors.has('Address')}],attrs:{"placeholder":"Адрес","type":"text","name":"Address"},domProps:{"value":(_vm.selectedTradepoint.Address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedTradepoint, "Address", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-5"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Магазин")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedTradepoint.Shop),expression:"selectedTradepoint.Shop"}],staticClass:"input-text",attrs:{"placeholder":"Магазин","type":"text","name":"Shop"},domProps:{"value":(_vm.selectedTradepoint.Shop)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedTradepoint, "Shop", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-field"},_vm._l((_vm.tradepointRolesGrouped),function(roles,rolesIndex){return _c('div',{staticClass:"form-field"},[_c('div',{staticClass:"flex margin-bottom-10"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v("\n                                "+_vm._s(roles[0].RoleName)+":\n                            ")]),_vm._v(" "),_c('div',{staticClass:"form-field"},_vm._l((roles),function(role,index){return _c('div',{staticClass:"form-field-group margin-bottom-5"},[_c('div',{staticClass:"form-field"},[_c('search-filter',{key:'TradeSearch' + role.ControlUniqueId,attrs:{"searchOnSelect":true,"placeholder":'Выберите пользователя',"extra":role.RoleId,"searchFunction":_vm.searchUserFunction,"selectedItem":_vm.getFilterValue(role),"disabled":role.Disabled},on:{"onFilterChange":function($event){return _vm.tradePointUserChange($event, role)}}})],1),_vm._v(" "),_c('div',{},[(roles.length > 1)?_c('button',{staticClass:"btn btn-default btn-img",attrs:{"type":"button"},on:{"click":function($event){return _vm.onRemoveUser(roles, index, rolesIndex)}}},[_c('img',{attrs:{"src":__webpack_require__(17),"alt":""}})]):_vm._e()]),_vm._v(" "),_c('div',{},[_c('button',{staticClass:"btn btn-default btn-img",attrs:{"type":"button","title":(role.Disabled ? 'Включить' : 'Отключить')},on:{"click":function($event){return _vm.onDisableUser(roles, index, rolesIndex)}}},[_c('i',{class:['fa', {'fa-chain': role.Disabled}, {'fa-chain-broken': !role.Disabled}]})])]),_vm._v(" "),(index === roles.length-1)?_c('div',{},[_c('button',{staticClass:"btn btn-default btn-img",attrs:{"type":"button"},on:{"click":function($event){return _vm.onAddUser(roles, role)}}},[_c('i',{staticClass:"fa fa-plus"})])]):_vm._e()])}),0)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveItem(_vm.selectedTradepoint)}}},[_vm._v("Сохранить")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onCancel(_vm.selectedTradepoint)}}},[_vm._v("Отмена")])])]):_vm._e(),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Торговые точки"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"heading"},[_c('th',[_vm._v("Наименование")]),_vm._v(" "),_c('th',[_vm._v("Внешний ID")]),_vm._v(" "),_c('th',[_vm._v("Регион")]),_vm._v(" "),_c('th',[_vm._v("Область")]),_vm._v(" "),_c('th',[_vm._v("Город")]),_vm._v(" "),_c('th',[_vm._v("Адрес")]),_vm._v(" "),_c('th',[_vm._v("Дата")]),_vm._v(" "),_c('th',[_vm._v("Включена?")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(295);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40b394de_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(827);
function injectStyle (ssrContext) {
  __webpack_require__(823)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40b394de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40b394de_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(824);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("aedbcfd8", content, true, {});

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".external-login-item[data-v-40b394de]{display:flex;align-items:center}.external-login-item div[data-v-40b394de]{display:flex;flex-direction:column}.external-login-item div span[data-v-40b394de]{margin-bottom:5px}", ""]);

// exports


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Cropper v4.1.0
 * https://fengyuanchen.github.io/cropper
 *
 * Copyright 2014-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2019-10-12T07:43:51.850Z
 */

(function (global, factory) {
   true ? factory(__webpack_require__(6)) :
  typeof define === 'function' && define.amd ? define(['jquery'], factory) :
  (global = global || self, factory(global.jQuery));
}(this, function ($) { 'use strict';

  $ = $ && $.hasOwnProperty('default') ? $['default'] : $;

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(source, true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(source).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

      return arr2;
    }
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  var IS_BROWSER = typeof window !== 'undefined' && typeof window.document !== 'undefined';
  var WINDOW = IS_BROWSER ? window : {};
  var IS_TOUCH_DEVICE = IS_BROWSER ? 'ontouchstart' in WINDOW.document.documentElement : false;
  var HAS_POINTER_EVENT = IS_BROWSER ? 'PointerEvent' in WINDOW : false;
  var NAMESPACE = 'cropper'; // Actions

  var ACTION_ALL = 'all';
  var ACTION_CROP = 'crop';
  var ACTION_MOVE = 'move';
  var ACTION_ZOOM = 'zoom';
  var ACTION_EAST = 'e';
  var ACTION_WEST = 'w';
  var ACTION_SOUTH = 's';
  var ACTION_NORTH = 'n';
  var ACTION_NORTH_EAST = 'ne';
  var ACTION_NORTH_WEST = 'nw';
  var ACTION_SOUTH_EAST = 'se';
  var ACTION_SOUTH_WEST = 'sw'; // Classes

  var CLASS_CROP = "".concat(NAMESPACE, "-crop");
  var CLASS_DISABLED = "".concat(NAMESPACE, "-disabled");
  var CLASS_HIDDEN = "".concat(NAMESPACE, "-hidden");
  var CLASS_HIDE = "".concat(NAMESPACE, "-hide");
  var CLASS_INVISIBLE = "".concat(NAMESPACE, "-invisible");
  var CLASS_MODAL = "".concat(NAMESPACE, "-modal");
  var CLASS_MOVE = "".concat(NAMESPACE, "-move"); // Data keys

  var DATA_ACTION = "".concat(NAMESPACE, "Action");
  var DATA_PREVIEW = "".concat(NAMESPACE, "Preview"); // Drag modes

  var DRAG_MODE_CROP = 'crop';
  var DRAG_MODE_MOVE = 'move';
  var DRAG_MODE_NONE = 'none'; // Events

  var EVENT_CROP = 'crop';
  var EVENT_CROP_END = 'cropend';
  var EVENT_CROP_MOVE = 'cropmove';
  var EVENT_CROP_START = 'cropstart';
  var EVENT_DBLCLICK = 'dblclick';
  var EVENT_TOUCH_START = IS_TOUCH_DEVICE ? 'touchstart' : 'mousedown';
  var EVENT_TOUCH_MOVE = IS_TOUCH_DEVICE ? 'touchmove' : 'mousemove';
  var EVENT_TOUCH_END = IS_TOUCH_DEVICE ? 'touchend touchcancel' : 'mouseup';
  var EVENT_POINTER_DOWN = HAS_POINTER_EVENT ? 'pointerdown' : EVENT_TOUCH_START;
  var EVENT_POINTER_MOVE = HAS_POINTER_EVENT ? 'pointermove' : EVENT_TOUCH_MOVE;
  var EVENT_POINTER_UP = HAS_POINTER_EVENT ? 'pointerup pointercancel' : EVENT_TOUCH_END;
  var EVENT_READY = 'ready';
  var EVENT_RESIZE = 'resize';
  var EVENT_WHEEL = 'wheel';
  var EVENT_ZOOM = 'zoom'; // Mime types

  var MIME_TYPE_JPEG = 'image/jpeg'; // RegExps

  var REGEXP_ACTIONS = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/;
  var REGEXP_DATA_URL = /^data:/;
  var REGEXP_DATA_URL_JPEG = /^data:image\/jpeg;base64,/;
  var REGEXP_TAG_NAME = /^img|canvas$/i; // Misc
  // Inspired by the default width and height of a canvas element.

  var MIN_CONTAINER_WIDTH = 200;
  var MIN_CONTAINER_HEIGHT = 100;

  var DEFAULTS = {
    // Define the view mode of the cropper
    viewMode: 0,
    // 0, 1, 2, 3
    // Define the dragging mode of the cropper
    dragMode: DRAG_MODE_CROP,
    // 'crop', 'move' or 'none'
    // Define the initial aspect ratio of the crop box
    initialAspectRatio: NaN,
    // Define the aspect ratio of the crop box
    aspectRatio: NaN,
    // An object with the previous cropping result data
    data: null,
    // A selector for adding extra containers to preview
    preview: '',
    // Re-render the cropper when resize the window
    responsive: true,
    // Restore the cropped area after resize the window
    restore: true,
    // Check if the current image is a cross-origin image
    checkCrossOrigin: true,
    // Check the current image's Exif Orientation information
    checkOrientation: true,
    // Show the black modal
    modal: true,
    // Show the dashed lines for guiding
    guides: true,
    // Show the center indicator for guiding
    center: true,
    // Show the white modal to highlight the crop box
    highlight: true,
    // Show the grid background
    background: true,
    // Enable to crop the image automatically when initialize
    autoCrop: true,
    // Define the percentage of automatic cropping area when initializes
    autoCropArea: 0.8,
    // Enable to move the image
    movable: true,
    // Enable to rotate the image
    rotatable: true,
    // Enable to scale the image
    scalable: true,
    // Enable to zoom the image
    zoomable: true,
    // Enable to zoom the image by dragging touch
    zoomOnTouch: true,
    // Enable to zoom the image by wheeling mouse
    zoomOnWheel: true,
    // Define zoom ratio when zoom the image by wheeling mouse
    wheelZoomRatio: 0.1,
    // Enable to move the crop box
    cropBoxMovable: true,
    // Enable to resize the crop box
    cropBoxResizable: true,
    // Toggle drag mode between "crop" and "move" when click twice on the cropper
    toggleDragModeOnDblclick: true,
    // Size limitation
    minCanvasWidth: 0,
    minCanvasHeight: 0,
    minCropBoxWidth: 0,
    minCropBoxHeight: 0,
    minContainerWidth: 200,
    minContainerHeight: 100,
    // Shortcuts of events
    ready: null,
    cropstart: null,
    cropmove: null,
    cropend: null,
    crop: null,
    zoom: null
  };

  var TEMPLATE = '<div class="cropper-container" touch-action="none">' + '<div class="cropper-wrap-box">' + '<div class="cropper-canvas"></div>' + '</div>' + '<div class="cropper-drag-box"></div>' + '<div class="cropper-crop-box">' + '<span class="cropper-view-box"></span>' + '<span class="cropper-dashed dashed-h"></span>' + '<span class="cropper-dashed dashed-v"></span>' + '<span class="cropper-center"></span>' + '<span class="cropper-face"></span>' + '<span class="cropper-line line-e" data-cropper-action="e"></span>' + '<span class="cropper-line line-n" data-cropper-action="n"></span>' + '<span class="cropper-line line-w" data-cropper-action="w"></span>' + '<span class="cropper-line line-s" data-cropper-action="s"></span>' + '<span class="cropper-point point-e" data-cropper-action="e"></span>' + '<span class="cropper-point point-n" data-cropper-action="n"></span>' + '<span class="cropper-point point-w" data-cropper-action="w"></span>' + '<span class="cropper-point point-s" data-cropper-action="s"></span>' + '<span class="cropper-point point-ne" data-cropper-action="ne"></span>' + '<span class="cropper-point point-nw" data-cropper-action="nw"></span>' + '<span class="cropper-point point-sw" data-cropper-action="sw"></span>' + '<span class="cropper-point point-se" data-cropper-action="se"></span>' + '</div>' + '</div>';

  /**
   * Check if the given value is not a number.
   */

  var isNaN = Number.isNaN || WINDOW.isNaN;
  /**
   * Check if the given value is a number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a number, else `false`.
   */

  function isNumber(value) {
    return typeof value === 'number' && !isNaN(value);
  }
  /**
   * Check if the given value is a positive number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a positive number, else `false`.
   */

  var isPositiveNumber = function isPositiveNumber(value) {
    return value > 0 && value < Infinity;
  };
  /**
   * Check if the given value is undefined.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is undefined, else `false`.
   */

  function isUndefined(value) {
    return typeof value === 'undefined';
  }
  /**
   * Check if the given value is an object.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is an object, else `false`.
   */

  function isObject(value) {
    return _typeof(value) === 'object' && value !== null;
  }
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  /**
   * Check if the given value is a plain object.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a plain object, else `false`.
   */

  function isPlainObject(value) {
    if (!isObject(value)) {
      return false;
    }

    try {
      var _constructor = value.constructor;
      var prototype = _constructor.prototype;
      return _constructor && prototype && hasOwnProperty.call(prototype, 'isPrototypeOf');
    } catch (error) {
      return false;
    }
  }
  /**
   * Check if the given value is a function.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a function, else `false`.
   */

  function isFunction(value) {
    return typeof value === 'function';
  }
  var slice = Array.prototype.slice;
  /**
   * Convert array-like or iterable object to an array.
   * @param {*} value - The value to convert.
   * @returns {Array} Returns a new array.
   */

  function toArray(value) {
    return Array.from ? Array.from(value) : slice.call(value);
  }
  /**
   * Iterate the given data.
   * @param {*} data - The data to iterate.
   * @param {Function} callback - The process function for each element.
   * @returns {*} The original data.
   */

  function forEach(data, callback) {
    if (data && isFunction(callback)) {
      if (Array.isArray(data) || isNumber(data.length)
      /* array-like */
      ) {
          toArray(data).forEach(function (value, key) {
            callback.call(data, value, key, data);
          });
        } else if (isObject(data)) {
        Object.keys(data).forEach(function (key) {
          callback.call(data, data[key], key, data);
        });
      }
    }

    return data;
  }
  /**
   * Extend the given object.
   * @param {*} target - The target object to extend.
   * @param {*} args - The rest objects for merging to the target object.
   * @returns {Object} The extended object.
   */

  var assign = Object.assign || function assign(target) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (isObject(target) && args.length > 0) {
      args.forEach(function (arg) {
        if (isObject(arg)) {
          Object.keys(arg).forEach(function (key) {
            target[key] = arg[key];
          });
        }
      });
    }

    return target;
  };
  var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/;
  /**
   * Normalize decimal number.
   * Check out {@link http://0.30000000000000004.com/}
   * @param {number} value - The value to normalize.
   * @param {number} [times=100000000000] - The times for normalizing.
   * @returns {number} Returns the normalized number.
   */

  function normalizeDecimalNumber(value) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000000000;
    return REGEXP_DECIMALS.test(value) ? Math.round(value * times) / times : value;
  }
  var REGEXP_SUFFIX = /^width|height|left|top|marginLeft|marginTop$/;
  /**
   * Apply styles to the given element.
   * @param {Element} element - The target element.
   * @param {Object} styles - The styles for applying.
   */

  function setStyle(element, styles) {
    var style = element.style;
    forEach(styles, function (value, property) {
      if (REGEXP_SUFFIX.test(property) && isNumber(value)) {
        value = "".concat(value, "px");
      }

      style[property] = value;
    });
  }
  /**
   * Check if the given element has a special class.
   * @param {Element} element - The element to check.
   * @param {string} value - The class to search.
   * @returns {boolean} Returns `true` if the special class was found.
   */

  function hasClass(element, value) {
    return element.classList ? element.classList.contains(value) : element.className.indexOf(value) > -1;
  }
  /**
   * Add classes to the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be added.
   */

  function addClass(element, value) {
    if (!value) {
      return;
    }

    if (isNumber(element.length)) {
      forEach(element, function (elem) {
        addClass(elem, value);
      });
      return;
    }

    if (element.classList) {
      element.classList.add(value);
      return;
    }

    var className = element.className.trim();

    if (!className) {
      element.className = value;
    } else if (className.indexOf(value) < 0) {
      element.className = "".concat(className, " ").concat(value);
    }
  }
  /**
   * Remove classes from the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be removed.
   */

  function removeClass(element, value) {
    if (!value) {
      return;
    }

    if (isNumber(element.length)) {
      forEach(element, function (elem) {
        removeClass(elem, value);
      });
      return;
    }

    if (element.classList) {
      element.classList.remove(value);
      return;
    }

    if (element.className.indexOf(value) >= 0) {
      element.className = element.className.replace(value, '');
    }
  }
  /**
   * Add or remove classes from the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be toggled.
   * @param {boolean} added - Add only.
   */

  function toggleClass(element, value, added) {
    if (!value) {
      return;
    }

    if (isNumber(element.length)) {
      forEach(element, function (elem) {
        toggleClass(elem, value, added);
      });
      return;
    } // IE10-11 doesn't support the second parameter of `classList.toggle`


    if (added) {
      addClass(element, value);
    } else {
      removeClass(element, value);
    }
  }
  var REGEXP_CAMEL_CASE = /([a-z\d])([A-Z])/g;
  /**
   * Transform the given string from camelCase to kebab-case
   * @param {string} value - The value to transform.
   * @returns {string} The transformed value.
   */

  function toParamCase(value) {
    return value.replace(REGEXP_CAMEL_CASE, '$1-$2').toLowerCase();
  }
  /**
   * Get data from the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to get.
   * @returns {string} The data value.
   */

  function getData(element, name) {
    if (isObject(element[name])) {
      return element[name];
    }

    if (element.dataset) {
      return element.dataset[name];
    }

    return element.getAttribute("data-".concat(toParamCase(name)));
  }
  /**
   * Set data to the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to set.
   * @param {string} data - The data value.
   */

  function setData(element, name, data) {
    if (isObject(data)) {
      element[name] = data;
    } else if (element.dataset) {
      element.dataset[name] = data;
    } else {
      element.setAttribute("data-".concat(toParamCase(name)), data);
    }
  }
  /**
   * Remove data from the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to remove.
   */

  function removeData(element, name) {
    if (isObject(element[name])) {
      try {
        delete element[name];
      } catch (error) {
        element[name] = undefined;
      }
    } else if (element.dataset) {
      // #128 Safari not allows to delete dataset property
      try {
        delete element.dataset[name];
      } catch (error) {
        element.dataset[name] = undefined;
      }
    } else {
      element.removeAttribute("data-".concat(toParamCase(name)));
    }
  }
  var REGEXP_SPACES = /\s\s*/;

  var onceSupported = function () {
    var supported = false;

    if (IS_BROWSER) {
      var once = false;

      var listener = function listener() {};

      var options = Object.defineProperty({}, 'once', {
        get: function get() {
          supported = true;
          return once;
        },

        /**
         * This setter can fix a `TypeError` in strict mode
         * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
         * @param {boolean} value - The value to set
         */
        set: function set(value) {
          once = value;
        }
      });
      WINDOW.addEventListener('test', listener, options);
      WINDOW.removeEventListener('test', listener, options);
    }

    return supported;
  }();
  /**
   * Remove event listener from the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Function} listener - The event listener.
   * @param {Object} options - The event options.
   */


  function removeListener(element, type, listener) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var handler = listener;
    type.trim().split(REGEXP_SPACES).forEach(function (event) {
      if (!onceSupported) {
        var listeners = element.listeners;

        if (listeners && listeners[event] && listeners[event][listener]) {
          handler = listeners[event][listener];
          delete listeners[event][listener];

          if (Object.keys(listeners[event]).length === 0) {
            delete listeners[event];
          }

          if (Object.keys(listeners).length === 0) {
            delete element.listeners;
          }
        }
      }

      element.removeEventListener(event, handler, options);
    });
  }
  /**
   * Add event listener to the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Function} listener - The event listener.
   * @param {Object} options - The event options.
   */

  function addListener(element, type, listener) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var _handler = listener;
    type.trim().split(REGEXP_SPACES).forEach(function (event) {
      if (options.once && !onceSupported) {
        var _element$listeners = element.listeners,
            listeners = _element$listeners === void 0 ? {} : _element$listeners;

        _handler = function handler() {
          delete listeners[event][listener];
          element.removeEventListener(event, _handler, options);

          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          listener.apply(element, args);
        };

        if (!listeners[event]) {
          listeners[event] = {};
        }

        if (listeners[event][listener]) {
          element.removeEventListener(event, listeners[event][listener], options);
        }

        listeners[event][listener] = _handler;
        element.listeners = listeners;
      }

      element.addEventListener(event, _handler, options);
    });
  }
  /**
   * Dispatch event on the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Object} data - The additional event data.
   * @returns {boolean} Indicate if the event is default prevented or not.
   */

  function dispatchEvent(element, type, data) {
    var event; // Event and CustomEvent on IE9-11 are global objects, not constructors

    if (isFunction(Event) && isFunction(CustomEvent)) {
      event = new CustomEvent(type, {
        detail: data,
        bubbles: true,
        cancelable: true
      });
    } else {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(type, true, true, data);
    }

    return element.dispatchEvent(event);
  }
  /**
   * Get the offset base on the document.
   * @param {Element} element - The target element.
   * @returns {Object} The offset data.
   */

  function getOffset(element) {
    var box = element.getBoundingClientRect();
    return {
      left: box.left + (window.pageXOffset - document.documentElement.clientLeft),
      top: box.top + (window.pageYOffset - document.documentElement.clientTop)
    };
  }
  var location = WINDOW.location;
  var REGEXP_ORIGINS = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
  /**
   * Check if the given URL is a cross origin URL.
   * @param {string} url - The target URL.
   * @returns {boolean} Returns `true` if the given URL is a cross origin URL, else `false`.
   */

  function isCrossOriginURL(url) {
    var parts = url.match(REGEXP_ORIGINS);
    return parts !== null && (parts[1] !== location.protocol || parts[2] !== location.hostname || parts[3] !== location.port);
  }
  /**
   * Add timestamp to the given URL.
   * @param {string} url - The target URL.
   * @returns {string} The result URL.
   */

  function addTimestamp(url) {
    var timestamp = "timestamp=".concat(new Date().getTime());
    return url + (url.indexOf('?') === -1 ? '?' : '&') + timestamp;
  }
  /**
   * Get transforms base on the given object.
   * @param {Object} obj - The target object.
   * @returns {string} A string contains transform values.
   */

  function getTransforms(_ref) {
    var rotate = _ref.rotate,
        scaleX = _ref.scaleX,
        scaleY = _ref.scaleY,
        translateX = _ref.translateX,
        translateY = _ref.translateY;
    var values = [];

    if (isNumber(translateX) && translateX !== 0) {
      values.push("translateX(".concat(translateX, "px)"));
    }

    if (isNumber(translateY) && translateY !== 0) {
      values.push("translateY(".concat(translateY, "px)"));
    } // Rotate should come first before scale to match orientation transform


    if (isNumber(rotate) && rotate !== 0) {
      values.push("rotate(".concat(rotate, "deg)"));
    }

    if (isNumber(scaleX) && scaleX !== 1) {
      values.push("scaleX(".concat(scaleX, ")"));
    }

    if (isNumber(scaleY) && scaleY !== 1) {
      values.push("scaleY(".concat(scaleY, ")"));
    }

    var transform = values.length ? values.join(' ') : 'none';
    return {
      WebkitTransform: transform,
      msTransform: transform,
      transform: transform
    };
  }
  /**
   * Get the max ratio of a group of pointers.
   * @param {string} pointers - The target pointers.
   * @returns {number} The result ratio.
   */

  function getMaxZoomRatio(pointers) {
    var pointers2 = _objectSpread2({}, pointers);

    var ratios = [];
    forEach(pointers, function (pointer, pointerId) {
      delete pointers2[pointerId];
      forEach(pointers2, function (pointer2) {
        var x1 = Math.abs(pointer.startX - pointer2.startX);
        var y1 = Math.abs(pointer.startY - pointer2.startY);
        var x2 = Math.abs(pointer.endX - pointer2.endX);
        var y2 = Math.abs(pointer.endY - pointer2.endY);
        var z1 = Math.sqrt(x1 * x1 + y1 * y1);
        var z2 = Math.sqrt(x2 * x2 + y2 * y2);
        var ratio = (z2 - z1) / z1;
        ratios.push(ratio);
      });
    });
    ratios.sort(function (a, b) {
      return Math.abs(a) < Math.abs(b);
    });
    return ratios[0];
  }
  /**
   * Get a pointer from an event object.
   * @param {Object} event - The target event object.
   * @param {boolean} endOnly - Indicates if only returns the end point coordinate or not.
   * @returns {Object} The result pointer contains start and/or end point coordinates.
   */

  function getPointer(_ref2, endOnly) {
    var pageX = _ref2.pageX,
        pageY = _ref2.pageY;
    var end = {
      endX: pageX,
      endY: pageY
    };
    return endOnly ? end : _objectSpread2({
      startX: pageX,
      startY: pageY
    }, end);
  }
  /**
   * Get the center point coordinate of a group of pointers.
   * @param {Object} pointers - The target pointers.
   * @returns {Object} The center point coordinate.
   */

  function getPointersCenter(pointers) {
    var pageX = 0;
    var pageY = 0;
    var count = 0;
    forEach(pointers, function (_ref3) {
      var startX = _ref3.startX,
          startY = _ref3.startY;
      pageX += startX;
      pageY += startY;
      count += 1;
    });
    pageX /= count;
    pageY /= count;
    return {
      pageX: pageX,
      pageY: pageY
    };
  }
  /**
   * Get the max sizes in a rectangle under the given aspect ratio.
   * @param {Object} data - The original sizes.
   * @param {string} [type='contain'] - The adjust type.
   * @returns {Object} The result sizes.
   */

  function getAdjustedSizes(_ref4) // or 'cover'
  {
    var aspectRatio = _ref4.aspectRatio,
        height = _ref4.height,
        width = _ref4.width;
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'contain';
    var isValidWidth = isPositiveNumber(width);
    var isValidHeight = isPositiveNumber(height);

    if (isValidWidth && isValidHeight) {
      var adjustedWidth = height * aspectRatio;

      if (type === 'contain' && adjustedWidth > width || type === 'cover' && adjustedWidth < width) {
        height = width / aspectRatio;
      } else {
        width = height * aspectRatio;
      }
    } else if (isValidWidth) {
      height = width / aspectRatio;
    } else if (isValidHeight) {
      width = height * aspectRatio;
    }

    return {
      width: width,
      height: height
    };
  }
  /**
   * Get the new sizes of a rectangle after rotated.
   * @param {Object} data - The original sizes.
   * @returns {Object} The result sizes.
   */

  function getRotatedSizes(_ref5) {
    var width = _ref5.width,
        height = _ref5.height,
        degree = _ref5.degree;
    degree = Math.abs(degree) % 180;

    if (degree === 90) {
      return {
        width: height,
        height: width
      };
    }

    var arc = degree % 90 * Math.PI / 180;
    var sinArc = Math.sin(arc);
    var cosArc = Math.cos(arc);
    var newWidth = width * cosArc + height * sinArc;
    var newHeight = width * sinArc + height * cosArc;
    return degree > 90 ? {
      width: newHeight,
      height: newWidth
    } : {
      width: newWidth,
      height: newHeight
    };
  }
  /**
   * Get a canvas which drew the given image.
   * @param {HTMLImageElement} image - The image for drawing.
   * @param {Object} imageData - The image data.
   * @param {Object} canvasData - The canvas data.
   * @param {Object} options - The options.
   * @returns {HTMLCanvasElement} The result canvas.
   */

  function getSourceCanvas(image, _ref6, _ref7, _ref8) {
    var imageAspectRatio = _ref6.aspectRatio,
        imageNaturalWidth = _ref6.naturalWidth,
        imageNaturalHeight = _ref6.naturalHeight,
        _ref6$rotate = _ref6.rotate,
        rotate = _ref6$rotate === void 0 ? 0 : _ref6$rotate,
        _ref6$scaleX = _ref6.scaleX,
        scaleX = _ref6$scaleX === void 0 ? 1 : _ref6$scaleX,
        _ref6$scaleY = _ref6.scaleY,
        scaleY = _ref6$scaleY === void 0 ? 1 : _ref6$scaleY;
    var aspectRatio = _ref7.aspectRatio,
        naturalWidth = _ref7.naturalWidth,
        naturalHeight = _ref7.naturalHeight;
    var _ref8$fillColor = _ref8.fillColor,
        fillColor = _ref8$fillColor === void 0 ? 'transparent' : _ref8$fillColor,
        _ref8$imageSmoothingE = _ref8.imageSmoothingEnabled,
        imageSmoothingEnabled = _ref8$imageSmoothingE === void 0 ? true : _ref8$imageSmoothingE,
        _ref8$imageSmoothingQ = _ref8.imageSmoothingQuality,
        imageSmoothingQuality = _ref8$imageSmoothingQ === void 0 ? 'low' : _ref8$imageSmoothingQ,
        _ref8$maxWidth = _ref8.maxWidth,
        maxWidth = _ref8$maxWidth === void 0 ? Infinity : _ref8$maxWidth,
        _ref8$maxHeight = _ref8.maxHeight,
        maxHeight = _ref8$maxHeight === void 0 ? Infinity : _ref8$maxHeight,
        _ref8$minWidth = _ref8.minWidth,
        minWidth = _ref8$minWidth === void 0 ? 0 : _ref8$minWidth,
        _ref8$minHeight = _ref8.minHeight,
        minHeight = _ref8$minHeight === void 0 ? 0 : _ref8$minHeight;
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    var maxSizes = getAdjustedSizes({
      aspectRatio: aspectRatio,
      width: maxWidth,
      height: maxHeight
    });
    var minSizes = getAdjustedSizes({
      aspectRatio: aspectRatio,
      width: minWidth,
      height: minHeight
    }, 'cover');
    var width = Math.min(maxSizes.width, Math.max(minSizes.width, naturalWidth));
    var height = Math.min(maxSizes.height, Math.max(minSizes.height, naturalHeight)); // Note: should always use image's natural sizes for drawing as
    // imageData.naturalWidth === canvasData.naturalHeight when rotate % 180 === 90

    var destMaxSizes = getAdjustedSizes({
      aspectRatio: imageAspectRatio,
      width: maxWidth,
      height: maxHeight
    });
    var destMinSizes = getAdjustedSizes({
      aspectRatio: imageAspectRatio,
      width: minWidth,
      height: minHeight
    }, 'cover');
    var destWidth = Math.min(destMaxSizes.width, Math.max(destMinSizes.width, imageNaturalWidth));
    var destHeight = Math.min(destMaxSizes.height, Math.max(destMinSizes.height, imageNaturalHeight));
    var params = [-destWidth / 2, -destHeight / 2, destWidth, destHeight];
    canvas.width = normalizeDecimalNumber(width);
    canvas.height = normalizeDecimalNumber(height);
    context.fillStyle = fillColor;
    context.fillRect(0, 0, width, height);
    context.save();
    context.translate(width / 2, height / 2);
    context.rotate(rotate * Math.PI / 180);
    context.scale(scaleX, scaleY);
    context.imageSmoothingEnabled = imageSmoothingEnabled;
    context.imageSmoothingQuality = imageSmoothingQuality;
    context.drawImage.apply(context, [image].concat(_toConsumableArray(params.map(function (param) {
      return Math.floor(normalizeDecimalNumber(param));
    }))));
    context.restore();
    return canvas;
  }
  var fromCharCode = String.fromCharCode;
  /**
   * Get string from char code in data view.
   * @param {DataView} dataView - The data view for read.
   * @param {number} start - The start index.
   * @param {number} length - The read length.
   * @returns {string} The read result.
   */

  function getStringFromCharCode(dataView, start, length) {
    var str = '';
    length += start;

    for (var i = start; i < length; i += 1) {
      str += fromCharCode(dataView.getUint8(i));
    }

    return str;
  }
  var REGEXP_DATA_URL_HEAD = /^data:.*,/;
  /**
   * Transform Data URL to array buffer.
   * @param {string} dataURL - The Data URL to transform.
   * @returns {ArrayBuffer} The result array buffer.
   */

  function dataURLToArrayBuffer(dataURL) {
    var base64 = dataURL.replace(REGEXP_DATA_URL_HEAD, '');
    var binary = atob(base64);
    var arrayBuffer = new ArrayBuffer(binary.length);
    var uint8 = new Uint8Array(arrayBuffer);
    forEach(uint8, function (value, i) {
      uint8[i] = binary.charCodeAt(i);
    });
    return arrayBuffer;
  }
  /**
   * Transform array buffer to Data URL.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
   * @param {string} mimeType - The mime type of the Data URL.
   * @returns {string} The result Data URL.
   */

  function arrayBufferToDataURL(arrayBuffer, mimeType) {
    var chunks = []; // Chunk Typed Array for better performance (#435)

    var chunkSize = 8192;
    var uint8 = new Uint8Array(arrayBuffer);

    while (uint8.length > 0) {
      // XXX: Babel's `toConsumableArray` helper will throw error in IE or Safari 9
      // eslint-disable-next-line prefer-spread
      chunks.push(fromCharCode.apply(null, toArray(uint8.subarray(0, chunkSize))));
      uint8 = uint8.subarray(chunkSize);
    }

    return "data:".concat(mimeType, ";base64,").concat(btoa(chunks.join('')));
  }
  /**
   * Get orientation value from given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
   * @returns {number} The read orientation value.
   */

  function resetAndGetOrientation(arrayBuffer) {
    var dataView = new DataView(arrayBuffer);
    var orientation; // Ignores range error when the image does not have correct Exif information

    try {
      var littleEndian;
      var app1Start;
      var ifdStart; // Only handle JPEG image (start by 0xFFD8)

      if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
        var length = dataView.byteLength;
        var offset = 2;

        while (offset + 1 < length) {
          if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
            app1Start = offset;
            break;
          }

          offset += 1;
        }
      }

      if (app1Start) {
        var exifIDCode = app1Start + 4;
        var tiffOffset = app1Start + 10;

        if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
          var endianness = dataView.getUint16(tiffOffset);
          littleEndian = endianness === 0x4949;

          if (littleEndian || endianness === 0x4D4D
          /* bigEndian */
          ) {
              if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
                var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);

                if (firstIFDOffset >= 0x00000008) {
                  ifdStart = tiffOffset + firstIFDOffset;
                }
              }
            }
        }
      }

      if (ifdStart) {
        var _length = dataView.getUint16(ifdStart, littleEndian);

        var _offset;

        var i;

        for (i = 0; i < _length; i += 1) {
          _offset = ifdStart + i * 12 + 2;

          if (dataView.getUint16(_offset, littleEndian) === 0x0112
          /* Orientation */
          ) {
              // 8 is the offset of the current tag's value
              _offset += 8; // Get the original orientation value

              orientation = dataView.getUint16(_offset, littleEndian); // Override the orientation with its default value

              dataView.setUint16(_offset, 1, littleEndian);
              break;
            }
        }
      }
    } catch (error) {
      orientation = 1;
    }

    return orientation;
  }
  /**
   * Parse Exif Orientation value.
   * @param {number} orientation - The orientation to parse.
   * @returns {Object} The parsed result.
   */

  function parseOrientation(orientation) {
    var rotate = 0;
    var scaleX = 1;
    var scaleY = 1;

    switch (orientation) {
      // Flip horizontal
      case 2:
        scaleX = -1;
        break;
      // Rotate left 180°

      case 3:
        rotate = -180;
        break;
      // Flip vertical

      case 4:
        scaleY = -1;
        break;
      // Flip vertical and rotate right 90°

      case 5:
        rotate = 90;
        scaleY = -1;
        break;
      // Rotate right 90°

      case 6:
        rotate = 90;
        break;
      // Flip horizontal and rotate right 90°

      case 7:
        rotate = 90;
        scaleX = -1;
        break;
      // Rotate left 90°

      case 8:
        rotate = -90;
        break;

      default:
    }

    return {
      rotate: rotate,
      scaleX: scaleX,
      scaleY: scaleY
    };
  }

  var render = {
    render: function render() {
      this.initContainer();
      this.initCanvas();
      this.initCropBox();
      this.renderCanvas();

      if (this.cropped) {
        this.renderCropBox();
      }
    },
    initContainer: function initContainer() {
      var element = this.element,
          options = this.options,
          container = this.container,
          cropper = this.cropper;
      addClass(cropper, CLASS_HIDDEN);
      removeClass(element, CLASS_HIDDEN);
      var containerData = {
        width: Math.max(container.offsetWidth, Number(options.minContainerWidth) || 200),
        height: Math.max(container.offsetHeight, Number(options.minContainerHeight) || 100)
      };
      this.containerData = containerData;
      setStyle(cropper, {
        width: containerData.width,
        height: containerData.height
      });
      addClass(element, CLASS_HIDDEN);
      removeClass(cropper, CLASS_HIDDEN);
    },
    // Canvas (image wrapper)
    initCanvas: function initCanvas() {
      var containerData = this.containerData,
          imageData = this.imageData;
      var viewMode = this.options.viewMode;
      var rotated = Math.abs(imageData.rotate) % 180 === 90;
      var naturalWidth = rotated ? imageData.naturalHeight : imageData.naturalWidth;
      var naturalHeight = rotated ? imageData.naturalWidth : imageData.naturalHeight;
      var aspectRatio = naturalWidth / naturalHeight;
      var canvasWidth = containerData.width;
      var canvasHeight = containerData.height;

      if (containerData.height * aspectRatio > containerData.width) {
        if (viewMode === 3) {
          canvasWidth = containerData.height * aspectRatio;
        } else {
          canvasHeight = containerData.width / aspectRatio;
        }
      } else if (viewMode === 3) {
        canvasHeight = containerData.width / aspectRatio;
      } else {
        canvasWidth = containerData.height * aspectRatio;
      }

      var canvasData = {
        aspectRatio: aspectRatio,
        naturalWidth: naturalWidth,
        naturalHeight: naturalHeight,
        width: canvasWidth,
        height: canvasHeight
      };
      canvasData.left = (containerData.width - canvasWidth) / 2;
      canvasData.top = (containerData.height - canvasHeight) / 2;
      canvasData.oldLeft = canvasData.left;
      canvasData.oldTop = canvasData.top;
      this.canvasData = canvasData;
      this.limited = viewMode === 1 || viewMode === 2;
      this.limitCanvas(true, true);
      this.initialImageData = assign({}, imageData);
      this.initialCanvasData = assign({}, canvasData);
    },
    limitCanvas: function limitCanvas(sizeLimited, positionLimited) {
      var options = this.options,
          containerData = this.containerData,
          canvasData = this.canvasData,
          cropBoxData = this.cropBoxData;
      var viewMode = options.viewMode;
      var aspectRatio = canvasData.aspectRatio;
      var cropped = this.cropped && cropBoxData;

      if (sizeLimited) {
        var minCanvasWidth = Number(options.minCanvasWidth) || 0;
        var minCanvasHeight = Number(options.minCanvasHeight) || 0;

        if (viewMode > 1) {
          minCanvasWidth = Math.max(minCanvasWidth, containerData.width);
          minCanvasHeight = Math.max(minCanvasHeight, containerData.height);

          if (viewMode === 3) {
            if (minCanvasHeight * aspectRatio > minCanvasWidth) {
              minCanvasWidth = minCanvasHeight * aspectRatio;
            } else {
              minCanvasHeight = minCanvasWidth / aspectRatio;
            }
          }
        } else if (viewMode > 0) {
          if (minCanvasWidth) {
            minCanvasWidth = Math.max(minCanvasWidth, cropped ? cropBoxData.width : 0);
          } else if (minCanvasHeight) {
            minCanvasHeight = Math.max(minCanvasHeight, cropped ? cropBoxData.height : 0);
          } else if (cropped) {
            minCanvasWidth = cropBoxData.width;
            minCanvasHeight = cropBoxData.height;

            if (minCanvasHeight * aspectRatio > minCanvasWidth) {
              minCanvasWidth = minCanvasHeight * aspectRatio;
            } else {
              minCanvasHeight = minCanvasWidth / aspectRatio;
            }
          }
        }

        var _getAdjustedSizes = getAdjustedSizes({
          aspectRatio: aspectRatio,
          width: minCanvasWidth,
          height: minCanvasHeight
        });

        minCanvasWidth = _getAdjustedSizes.width;
        minCanvasHeight = _getAdjustedSizes.height;
        canvasData.minWidth = minCanvasWidth;
        canvasData.minHeight = minCanvasHeight;
        canvasData.maxWidth = Infinity;
        canvasData.maxHeight = Infinity;
      }

      if (positionLimited) {
        if (viewMode > (cropped ? 0 : 1)) {
          var newCanvasLeft = containerData.width - canvasData.width;
          var newCanvasTop = containerData.height - canvasData.height;
          canvasData.minLeft = Math.min(0, newCanvasLeft);
          canvasData.minTop = Math.min(0, newCanvasTop);
          canvasData.maxLeft = Math.max(0, newCanvasLeft);
          canvasData.maxTop = Math.max(0, newCanvasTop);

          if (cropped && this.limited) {
            canvasData.minLeft = Math.min(cropBoxData.left, cropBoxData.left + (cropBoxData.width - canvasData.width));
            canvasData.minTop = Math.min(cropBoxData.top, cropBoxData.top + (cropBoxData.height - canvasData.height));
            canvasData.maxLeft = cropBoxData.left;
            canvasData.maxTop = cropBoxData.top;

            if (viewMode === 2) {
              if (canvasData.width >= containerData.width) {
                canvasData.minLeft = Math.min(0, newCanvasLeft);
                canvasData.maxLeft = Math.max(0, newCanvasLeft);
              }

              if (canvasData.height >= containerData.height) {
                canvasData.minTop = Math.min(0, newCanvasTop);
                canvasData.maxTop = Math.max(0, newCanvasTop);
              }
            }
          }
        } else {
          canvasData.minLeft = -canvasData.width;
          canvasData.minTop = -canvasData.height;
          canvasData.maxLeft = containerData.width;
          canvasData.maxTop = containerData.height;
        }
      }
    },
    renderCanvas: function renderCanvas(changed, transformed) {
      var canvasData = this.canvasData,
          imageData = this.imageData;

      if (transformed) {
        var _getRotatedSizes = getRotatedSizes({
          width: imageData.naturalWidth * Math.abs(imageData.scaleX || 1),
          height: imageData.naturalHeight * Math.abs(imageData.scaleY || 1),
          degree: imageData.rotate || 0
        }),
            naturalWidth = _getRotatedSizes.width,
            naturalHeight = _getRotatedSizes.height;

        var width = canvasData.width * (naturalWidth / canvasData.naturalWidth);
        var height = canvasData.height * (naturalHeight / canvasData.naturalHeight);
        canvasData.left -= (width - canvasData.width) / 2;
        canvasData.top -= (height - canvasData.height) / 2;
        canvasData.width = width;
        canvasData.height = height;
        canvasData.aspectRatio = naturalWidth / naturalHeight;
        canvasData.naturalWidth = naturalWidth;
        canvasData.naturalHeight = naturalHeight;
        this.limitCanvas(true, false);
      }

      if (canvasData.width > canvasData.maxWidth || canvasData.width < canvasData.minWidth) {
        canvasData.left = canvasData.oldLeft;
      }

      if (canvasData.height > canvasData.maxHeight || canvasData.height < canvasData.minHeight) {
        canvasData.top = canvasData.oldTop;
      }

      canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
      canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
      this.limitCanvas(false, true);
      canvasData.left = Math.min(Math.max(canvasData.left, canvasData.minLeft), canvasData.maxLeft);
      canvasData.top = Math.min(Math.max(canvasData.top, canvasData.minTop), canvasData.maxTop);
      canvasData.oldLeft = canvasData.left;
      canvasData.oldTop = canvasData.top;
      setStyle(this.canvas, assign({
        width: canvasData.width,
        height: canvasData.height
      }, getTransforms({
        translateX: canvasData.left,
        translateY: canvasData.top
      })));
      this.renderImage(changed);

      if (this.cropped && this.limited) {
        this.limitCropBox(true, true);
      }
    },
    renderImage: function renderImage(changed) {
      var canvasData = this.canvasData,
          imageData = this.imageData;
      var width = imageData.naturalWidth * (canvasData.width / canvasData.naturalWidth);
      var height = imageData.naturalHeight * (canvasData.height / canvasData.naturalHeight);
      assign(imageData, {
        width: width,
        height: height,
        left: (canvasData.width - width) / 2,
        top: (canvasData.height - height) / 2
      });
      setStyle(this.image, assign({
        width: imageData.width,
        height: imageData.height
      }, getTransforms(assign({
        translateX: imageData.left,
        translateY: imageData.top
      }, imageData))));

      if (changed) {
        this.output();
      }
    },
    initCropBox: function initCropBox() {
      var options = this.options,
          canvasData = this.canvasData;
      var aspectRatio = options.aspectRatio || options.initialAspectRatio;
      var autoCropArea = Number(options.autoCropArea) || 0.8;
      var cropBoxData = {
        width: canvasData.width,
        height: canvasData.height
      };

      if (aspectRatio) {
        if (canvasData.height * aspectRatio > canvasData.width) {
          cropBoxData.height = cropBoxData.width / aspectRatio;
        } else {
          cropBoxData.width = cropBoxData.height * aspectRatio;
        }
      }

      this.cropBoxData = cropBoxData;
      this.limitCropBox(true, true); // Initialize auto crop area

      cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
      cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight); // The width/height of auto crop area must large than "minWidth/Height"

      cropBoxData.width = Math.max(cropBoxData.minWidth, cropBoxData.width * autoCropArea);
      cropBoxData.height = Math.max(cropBoxData.minHeight, cropBoxData.height * autoCropArea);
      cropBoxData.left = canvasData.left + (canvasData.width - cropBoxData.width) / 2;
      cropBoxData.top = canvasData.top + (canvasData.height - cropBoxData.height) / 2;
      cropBoxData.oldLeft = cropBoxData.left;
      cropBoxData.oldTop = cropBoxData.top;
      this.initialCropBoxData = assign({}, cropBoxData);
    },
    limitCropBox: function limitCropBox(sizeLimited, positionLimited) {
      var options = this.options,
          containerData = this.containerData,
          canvasData = this.canvasData,
          cropBoxData = this.cropBoxData,
          limited = this.limited;
      var aspectRatio = options.aspectRatio;

      if (sizeLimited) {
        var minCropBoxWidth = Number(options.minCropBoxWidth) || 0;
        var minCropBoxHeight = Number(options.minCropBoxHeight) || 0;
        var maxCropBoxWidth = limited ? Math.min(containerData.width, canvasData.width, canvasData.width + canvasData.left, containerData.width - canvasData.left) : containerData.width;
        var maxCropBoxHeight = limited ? Math.min(containerData.height, canvasData.height, canvasData.height + canvasData.top, containerData.height - canvasData.top) : containerData.height; // The min/maxCropBoxWidth/Height must be less than container's width/height

        minCropBoxWidth = Math.min(minCropBoxWidth, containerData.width);
        minCropBoxHeight = Math.min(minCropBoxHeight, containerData.height);

        if (aspectRatio) {
          if (minCropBoxWidth && minCropBoxHeight) {
            if (minCropBoxHeight * aspectRatio > minCropBoxWidth) {
              minCropBoxHeight = minCropBoxWidth / aspectRatio;
            } else {
              minCropBoxWidth = minCropBoxHeight * aspectRatio;
            }
          } else if (minCropBoxWidth) {
            minCropBoxHeight = minCropBoxWidth / aspectRatio;
          } else if (minCropBoxHeight) {
            minCropBoxWidth = minCropBoxHeight * aspectRatio;
          }

          if (maxCropBoxHeight * aspectRatio > maxCropBoxWidth) {
            maxCropBoxHeight = maxCropBoxWidth / aspectRatio;
          } else {
            maxCropBoxWidth = maxCropBoxHeight * aspectRatio;
          }
        } // The minWidth/Height must be less than maxWidth/Height


        cropBoxData.minWidth = Math.min(minCropBoxWidth, maxCropBoxWidth);
        cropBoxData.minHeight = Math.min(minCropBoxHeight, maxCropBoxHeight);
        cropBoxData.maxWidth = maxCropBoxWidth;
        cropBoxData.maxHeight = maxCropBoxHeight;
      }

      if (positionLimited) {
        if (limited) {
          cropBoxData.minLeft = Math.max(0, canvasData.left);
          cropBoxData.minTop = Math.max(0, canvasData.top);
          cropBoxData.maxLeft = Math.min(containerData.width, canvasData.left + canvasData.width) - cropBoxData.width;
          cropBoxData.maxTop = Math.min(containerData.height, canvasData.top + canvasData.height) - cropBoxData.height;
        } else {
          cropBoxData.minLeft = 0;
          cropBoxData.minTop = 0;
          cropBoxData.maxLeft = containerData.width - cropBoxData.width;
          cropBoxData.maxTop = containerData.height - cropBoxData.height;
        }
      }
    },
    renderCropBox: function renderCropBox() {
      var options = this.options,
          containerData = this.containerData,
          cropBoxData = this.cropBoxData;

      if (cropBoxData.width > cropBoxData.maxWidth || cropBoxData.width < cropBoxData.minWidth) {
        cropBoxData.left = cropBoxData.oldLeft;
      }

      if (cropBoxData.height > cropBoxData.maxHeight || cropBoxData.height < cropBoxData.minHeight) {
        cropBoxData.top = cropBoxData.oldTop;
      }

      cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
      cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);
      this.limitCropBox(false, true);
      cropBoxData.left = Math.min(Math.max(cropBoxData.left, cropBoxData.minLeft), cropBoxData.maxLeft);
      cropBoxData.top = Math.min(Math.max(cropBoxData.top, cropBoxData.minTop), cropBoxData.maxTop);
      cropBoxData.oldLeft = cropBoxData.left;
      cropBoxData.oldTop = cropBoxData.top;

      if (options.movable && options.cropBoxMovable) {
        // Turn to move the canvas when the crop box is equal to the container
        setData(this.face, DATA_ACTION, cropBoxData.width >= containerData.width && cropBoxData.height >= containerData.height ? ACTION_MOVE : ACTION_ALL);
      }

      setStyle(this.cropBox, assign({
        width: cropBoxData.width,
        height: cropBoxData.height
      }, getTransforms({
        translateX: cropBoxData.left,
        translateY: cropBoxData.top
      })));

      if (this.cropped && this.limited) {
        this.limitCanvas(true, true);
      }

      if (!this.disabled) {
        this.output();
      }
    },
    output: function output() {
      this.preview();
      dispatchEvent(this.element, EVENT_CROP, this.getData());
    }
  };

  var preview = {
    initPreview: function initPreview() {
      var element = this.element,
          crossOrigin = this.crossOrigin;
      var preview = this.options.preview;
      var url = crossOrigin ? this.crossOriginUrl : this.url;
      var alt = element.alt || 'The image to preview';
      var image = document.createElement('img');

      if (crossOrigin) {
        image.crossOrigin = crossOrigin;
      }

      image.src = url;
      image.alt = alt;
      this.viewBox.appendChild(image);
      this.viewBoxImage = image;

      if (!preview) {
        return;
      }

      var previews = preview;

      if (typeof preview === 'string') {
        previews = element.ownerDocument.querySelectorAll(preview);
      } else if (preview.querySelector) {
        previews = [preview];
      }

      this.previews = previews;
      forEach(previews, function (el) {
        var img = document.createElement('img'); // Save the original size for recover

        setData(el, DATA_PREVIEW, {
          width: el.offsetWidth,
          height: el.offsetHeight,
          html: el.innerHTML
        });

        if (crossOrigin) {
          img.crossOrigin = crossOrigin;
        }

        img.src = url;
        img.alt = alt;
        /**
         * Override img element styles
         * Add `display:block` to avoid margin top issue
         * Add `height:auto` to override `height` attribute on IE8
         * (Occur only when margin-top <= -height)
         */

        img.style.cssText = 'display:block;' + 'width:100%;' + 'height:auto;' + 'min-width:0!important;' + 'min-height:0!important;' + 'max-width:none!important;' + 'max-height:none!important;' + 'image-orientation:0deg!important;"';
        el.innerHTML = '';
        el.appendChild(img);
      });
    },
    resetPreview: function resetPreview() {
      forEach(this.previews, function (element) {
        var data = getData(element, DATA_PREVIEW);
        setStyle(element, {
          width: data.width,
          height: data.height
        });
        element.innerHTML = data.html;
        removeData(element, DATA_PREVIEW);
      });
    },
    preview: function preview() {
      var imageData = this.imageData,
          canvasData = this.canvasData,
          cropBoxData = this.cropBoxData;
      var cropBoxWidth = cropBoxData.width,
          cropBoxHeight = cropBoxData.height;
      var width = imageData.width,
          height = imageData.height;
      var left = cropBoxData.left - canvasData.left - imageData.left;
      var top = cropBoxData.top - canvasData.top - imageData.top;

      if (!this.cropped || this.disabled) {
        return;
      }

      setStyle(this.viewBoxImage, assign({
        width: width,
        height: height
      }, getTransforms(assign({
        translateX: -left,
        translateY: -top
      }, imageData))));
      forEach(this.previews, function (element) {
        var data = getData(element, DATA_PREVIEW);
        var originalWidth = data.width;
        var originalHeight = data.height;
        var newWidth = originalWidth;
        var newHeight = originalHeight;
        var ratio = 1;

        if (cropBoxWidth) {
          ratio = originalWidth / cropBoxWidth;
          newHeight = cropBoxHeight * ratio;
        }

        if (cropBoxHeight && newHeight > originalHeight) {
          ratio = originalHeight / cropBoxHeight;
          newWidth = cropBoxWidth * ratio;
          newHeight = originalHeight;
        }

        setStyle(element, {
          width: newWidth,
          height: newHeight
        });
        setStyle(element.getElementsByTagName('img')[0], assign({
          width: width * ratio,
          height: height * ratio
        }, getTransforms(assign({
          translateX: -left * ratio,
          translateY: -top * ratio
        }, imageData))));
      });
    }
  };

  var events = {
    bind: function bind() {
      var element = this.element,
          options = this.options,
          cropper = this.cropper;

      if (isFunction(options.cropstart)) {
        addListener(element, EVENT_CROP_START, options.cropstart);
      }

      if (isFunction(options.cropmove)) {
        addListener(element, EVENT_CROP_MOVE, options.cropmove);
      }

      if (isFunction(options.cropend)) {
        addListener(element, EVENT_CROP_END, options.cropend);
      }

      if (isFunction(options.crop)) {
        addListener(element, EVENT_CROP, options.crop);
      }

      if (isFunction(options.zoom)) {
        addListener(element, EVENT_ZOOM, options.zoom);
      }

      addListener(cropper, EVENT_POINTER_DOWN, this.onCropStart = this.cropStart.bind(this));

      if (options.zoomable && options.zoomOnWheel) {
        addListener(cropper, EVENT_WHEEL, this.onWheel = this.wheel.bind(this), {
          passive: false,
          capture: true
        });
      }

      if (options.toggleDragModeOnDblclick) {
        addListener(cropper, EVENT_DBLCLICK, this.onDblclick = this.dblclick.bind(this));
      }

      addListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove = this.cropMove.bind(this));
      addListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd = this.cropEnd.bind(this));

      if (options.responsive) {
        addListener(window, EVENT_RESIZE, this.onResize = this.resize.bind(this));
      }
    },
    unbind: function unbind() {
      var element = this.element,
          options = this.options,
          cropper = this.cropper;

      if (isFunction(options.cropstart)) {
        removeListener(element, EVENT_CROP_START, options.cropstart);
      }

      if (isFunction(options.cropmove)) {
        removeListener(element, EVENT_CROP_MOVE, options.cropmove);
      }

      if (isFunction(options.cropend)) {
        removeListener(element, EVENT_CROP_END, options.cropend);
      }

      if (isFunction(options.crop)) {
        removeListener(element, EVENT_CROP, options.crop);
      }

      if (isFunction(options.zoom)) {
        removeListener(element, EVENT_ZOOM, options.zoom);
      }

      removeListener(cropper, EVENT_POINTER_DOWN, this.onCropStart);

      if (options.zoomable && options.zoomOnWheel) {
        removeListener(cropper, EVENT_WHEEL, this.onWheel, {
          passive: false,
          capture: true
        });
      }

      if (options.toggleDragModeOnDblclick) {
        removeListener(cropper, EVENT_DBLCLICK, this.onDblclick);
      }

      removeListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove);
      removeListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd);

      if (options.responsive) {
        removeListener(window, EVENT_RESIZE, this.onResize);
      }
    }
  };

  var handlers = {
    resize: function resize() {
      var options = this.options,
          container = this.container,
          containerData = this.containerData;
      var minContainerWidth = Number(options.minContainerWidth) || MIN_CONTAINER_WIDTH;
      var minContainerHeight = Number(options.minContainerHeight) || MIN_CONTAINER_HEIGHT;

      if (this.disabled || containerData.width <= minContainerWidth || containerData.height <= minContainerHeight) {
        return;
      }

      var ratio = container.offsetWidth / containerData.width; // Resize when width changed or height changed

      if (ratio !== 1 || container.offsetHeight !== containerData.height) {
        var canvasData;
        var cropBoxData;

        if (options.restore) {
          canvasData = this.getCanvasData();
          cropBoxData = this.getCropBoxData();
        }

        this.render();

        if (options.restore) {
          this.setCanvasData(forEach(canvasData, function (n, i) {
            canvasData[i] = n * ratio;
          }));
          this.setCropBoxData(forEach(cropBoxData, function (n, i) {
            cropBoxData[i] = n * ratio;
          }));
        }
      }
    },
    dblclick: function dblclick() {
      if (this.disabled || this.options.dragMode === DRAG_MODE_NONE) {
        return;
      }

      this.setDragMode(hasClass(this.dragBox, CLASS_CROP) ? DRAG_MODE_MOVE : DRAG_MODE_CROP);
    },
    wheel: function wheel(event) {
      var _this = this;

      var ratio = Number(this.options.wheelZoomRatio) || 0.1;
      var delta = 1;

      if (this.disabled) {
        return;
      }

      event.preventDefault(); // Limit wheel speed to prevent zoom too fast (#21)

      if (this.wheeling) {
        return;
      }

      this.wheeling = true;
      setTimeout(function () {
        _this.wheeling = false;
      }, 50);

      if (event.deltaY) {
        delta = event.deltaY > 0 ? 1 : -1;
      } else if (event.wheelDelta) {
        delta = -event.wheelDelta / 120;
      } else if (event.detail) {
        delta = event.detail > 0 ? 1 : -1;
      }

      this.zoom(-delta * ratio, event);
    },
    cropStart: function cropStart(event) {
      var buttons = event.buttons,
          button = event.button;

      if (this.disabled // Handle mouse event and pointer event and ignore touch event
      || (event.type === 'mousedown' || event.type === 'pointerdown' && event.pointerType === 'mouse') && ( // No primary button (Usually the left button)
      isNumber(buttons) && buttons !== 1 || isNumber(button) && button !== 0 // Open context menu
      || event.ctrlKey)) {
        return;
      }

      var options = this.options,
          pointers = this.pointers;
      var action;

      if (event.changedTouches) {
        // Handle touch event
        forEach(event.changedTouches, function (touch) {
          pointers[touch.identifier] = getPointer(touch);
        });
      } else {
        // Handle mouse event and pointer event
        pointers[event.pointerId || 0] = getPointer(event);
      }

      if (Object.keys(pointers).length > 1 && options.zoomable && options.zoomOnTouch) {
        action = ACTION_ZOOM;
      } else {
        action = getData(event.target, DATA_ACTION);
      }

      if (!REGEXP_ACTIONS.test(action)) {
        return;
      }

      if (dispatchEvent(this.element, EVENT_CROP_START, {
        originalEvent: event,
        action: action
      }) === false) {
        return;
      } // This line is required for preventing page zooming in iOS browsers


      event.preventDefault();
      this.action = action;
      this.cropping = false;

      if (action === ACTION_CROP) {
        this.cropping = true;
        addClass(this.dragBox, CLASS_MODAL);
      }
    },
    cropMove: function cropMove(event) {
      var action = this.action;

      if (this.disabled || !action) {
        return;
      }

      var pointers = this.pointers;
      event.preventDefault();

      if (dispatchEvent(this.element, EVENT_CROP_MOVE, {
        originalEvent: event,
        action: action
      }) === false) {
        return;
      }

      if (event.changedTouches) {
        forEach(event.changedTouches, function (touch) {
          // The first parameter should not be undefined (#432)
          assign(pointers[touch.identifier] || {}, getPointer(touch, true));
        });
      } else {
        assign(pointers[event.pointerId || 0] || {}, getPointer(event, true));
      }

      this.change(event);
    },
    cropEnd: function cropEnd(event) {
      if (this.disabled) {
        return;
      }

      var action = this.action,
          pointers = this.pointers;

      if (event.changedTouches) {
        forEach(event.changedTouches, function (touch) {
          delete pointers[touch.identifier];
        });
      } else {
        delete pointers[event.pointerId || 0];
      }

      if (!action) {
        return;
      }

      event.preventDefault();

      if (!Object.keys(pointers).length) {
        this.action = '';
      }

      if (this.cropping) {
        this.cropping = false;
        toggleClass(this.dragBox, CLASS_MODAL, this.cropped && this.options.modal);
      }

      dispatchEvent(this.element, EVENT_CROP_END, {
        originalEvent: event,
        action: action
      });
    }
  };

  var change = {
    change: function change(event) {
      var options = this.options,
          canvasData = this.canvasData,
          containerData = this.containerData,
          cropBoxData = this.cropBoxData,
          pointers = this.pointers;
      var action = this.action;
      var aspectRatio = options.aspectRatio;
      var left = cropBoxData.left,
          top = cropBoxData.top,
          width = cropBoxData.width,
          height = cropBoxData.height;
      var right = left + width;
      var bottom = top + height;
      var minLeft = 0;
      var minTop = 0;
      var maxWidth = containerData.width;
      var maxHeight = containerData.height;
      var renderable = true;
      var offset; // Locking aspect ratio in "free mode" by holding shift key

      if (!aspectRatio && event.shiftKey) {
        aspectRatio = width && height ? width / height : 1;
      }

      if (this.limited) {
        minLeft = cropBoxData.minLeft;
        minTop = cropBoxData.minTop;
        maxWidth = minLeft + Math.min(containerData.width, canvasData.width, canvasData.left + canvasData.width);
        maxHeight = minTop + Math.min(containerData.height, canvasData.height, canvasData.top + canvasData.height);
      }

      var pointer = pointers[Object.keys(pointers)[0]];
      var range = {
        x: pointer.endX - pointer.startX,
        y: pointer.endY - pointer.startY
      };

      var check = function check(side) {
        switch (side) {
          case ACTION_EAST:
            if (right + range.x > maxWidth) {
              range.x = maxWidth - right;
            }

            break;

          case ACTION_WEST:
            if (left + range.x < minLeft) {
              range.x = minLeft - left;
            }

            break;

          case ACTION_NORTH:
            if (top + range.y < minTop) {
              range.y = minTop - top;
            }

            break;

          case ACTION_SOUTH:
            if (bottom + range.y > maxHeight) {
              range.y = maxHeight - bottom;
            }

            break;

          default:
        }
      };

      switch (action) {
        // Move crop box
        case ACTION_ALL:
          left += range.x;
          top += range.y;
          break;
        // Resize crop box

        case ACTION_EAST:
          if (range.x >= 0 && (right >= maxWidth || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
            renderable = false;
            break;
          }

          check(ACTION_EAST);
          width += range.x;

          if (width < 0) {
            action = ACTION_WEST;
            width = -width;
            left -= width;
          }

          if (aspectRatio) {
            height = width / aspectRatio;
            top += (cropBoxData.height - height) / 2;
          }

          break;

        case ACTION_NORTH:
          if (range.y <= 0 && (top <= minTop || aspectRatio && (left <= minLeft || right >= maxWidth))) {
            renderable = false;
            break;
          }

          check(ACTION_NORTH);
          height -= range.y;
          top += range.y;

          if (height < 0) {
            action = ACTION_SOUTH;
            height = -height;
            top -= height;
          }

          if (aspectRatio) {
            width = height * aspectRatio;
            left += (cropBoxData.width - width) / 2;
          }

          break;

        case ACTION_WEST:
          if (range.x <= 0 && (left <= minLeft || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
            renderable = false;
            break;
          }

          check(ACTION_WEST);
          width -= range.x;
          left += range.x;

          if (width < 0) {
            action = ACTION_EAST;
            width = -width;
            left -= width;
          }

          if (aspectRatio) {
            height = width / aspectRatio;
            top += (cropBoxData.height - height) / 2;
          }

          break;

        case ACTION_SOUTH:
          if (range.y >= 0 && (bottom >= maxHeight || aspectRatio && (left <= minLeft || right >= maxWidth))) {
            renderable = false;
            break;
          }

          check(ACTION_SOUTH);
          height += range.y;

          if (height < 0) {
            action = ACTION_NORTH;
            height = -height;
            top -= height;
          }

          if (aspectRatio) {
            width = height * aspectRatio;
            left += (cropBoxData.width - width) / 2;
          }

          break;

        case ACTION_NORTH_EAST:
          if (aspectRatio) {
            if (range.y <= 0 && (top <= minTop || right >= maxWidth)) {
              renderable = false;
              break;
            }

            check(ACTION_NORTH);
            height -= range.y;
            top += range.y;
            width = height * aspectRatio;
          } else {
            check(ACTION_NORTH);
            check(ACTION_EAST);

            if (range.x >= 0) {
              if (right < maxWidth) {
                width += range.x;
              } else if (range.y <= 0 && top <= minTop) {
                renderable = false;
              }
            } else {
              width += range.x;
            }

            if (range.y <= 0) {
              if (top > minTop) {
                height -= range.y;
                top += range.y;
              }
            } else {
              height -= range.y;
              top += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_SOUTH_WEST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_NORTH_WEST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_SOUTH_EAST;
            height = -height;
            top -= height;
          }

          break;

        case ACTION_NORTH_WEST:
          if (aspectRatio) {
            if (range.y <= 0 && (top <= minTop || left <= minLeft)) {
              renderable = false;
              break;
            }

            check(ACTION_NORTH);
            height -= range.y;
            top += range.y;
            width = height * aspectRatio;
            left += cropBoxData.width - width;
          } else {
            check(ACTION_NORTH);
            check(ACTION_WEST);

            if (range.x <= 0) {
              if (left > minLeft) {
                width -= range.x;
                left += range.x;
              } else if (range.y <= 0 && top <= minTop) {
                renderable = false;
              }
            } else {
              width -= range.x;
              left += range.x;
            }

            if (range.y <= 0) {
              if (top > minTop) {
                height -= range.y;
                top += range.y;
              }
            } else {
              height -= range.y;
              top += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_SOUTH_EAST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_NORTH_EAST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_SOUTH_WEST;
            height = -height;
            top -= height;
          }

          break;

        case ACTION_SOUTH_WEST:
          if (aspectRatio) {
            if (range.x <= 0 && (left <= minLeft || bottom >= maxHeight)) {
              renderable = false;
              break;
            }

            check(ACTION_WEST);
            width -= range.x;
            left += range.x;
            height = width / aspectRatio;
          } else {
            check(ACTION_SOUTH);
            check(ACTION_WEST);

            if (range.x <= 0) {
              if (left > minLeft) {
                width -= range.x;
                left += range.x;
              } else if (range.y >= 0 && bottom >= maxHeight) {
                renderable = false;
              }
            } else {
              width -= range.x;
              left += range.x;
            }

            if (range.y >= 0) {
              if (bottom < maxHeight) {
                height += range.y;
              }
            } else {
              height += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_NORTH_EAST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_SOUTH_EAST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_NORTH_WEST;
            height = -height;
            top -= height;
          }

          break;

        case ACTION_SOUTH_EAST:
          if (aspectRatio) {
            if (range.x >= 0 && (right >= maxWidth || bottom >= maxHeight)) {
              renderable = false;
              break;
            }

            check(ACTION_EAST);
            width += range.x;
            height = width / aspectRatio;
          } else {
            check(ACTION_SOUTH);
            check(ACTION_EAST);

            if (range.x >= 0) {
              if (right < maxWidth) {
                width += range.x;
              } else if (range.y >= 0 && bottom >= maxHeight) {
                renderable = false;
              }
            } else {
              width += range.x;
            }

            if (range.y >= 0) {
              if (bottom < maxHeight) {
                height += range.y;
              }
            } else {
              height += range.y;
            }
          }

          if (width < 0 && height < 0) {
            action = ACTION_NORTH_WEST;
            height = -height;
            width = -width;
            top -= height;
            left -= width;
          } else if (width < 0) {
            action = ACTION_SOUTH_WEST;
            width = -width;
            left -= width;
          } else if (height < 0) {
            action = ACTION_NORTH_EAST;
            height = -height;
            top -= height;
          }

          break;
        // Move canvas

        case ACTION_MOVE:
          this.move(range.x, range.y);
          renderable = false;
          break;
        // Zoom canvas

        case ACTION_ZOOM:
          this.zoom(getMaxZoomRatio(pointers), event);
          renderable = false;
          break;
        // Create crop box

        case ACTION_CROP:
          if (!range.x || !range.y) {
            renderable = false;
            break;
          }

          offset = getOffset(this.cropper);
          left = pointer.startX - offset.left;
          top = pointer.startY - offset.top;
          width = cropBoxData.minWidth;
          height = cropBoxData.minHeight;

          if (range.x > 0) {
            action = range.y > 0 ? ACTION_SOUTH_EAST : ACTION_NORTH_EAST;
          } else if (range.x < 0) {
            left -= width;
            action = range.y > 0 ? ACTION_SOUTH_WEST : ACTION_NORTH_WEST;
          }

          if (range.y < 0) {
            top -= height;
          } // Show the crop box if is hidden


          if (!this.cropped) {
            removeClass(this.cropBox, CLASS_HIDDEN);
            this.cropped = true;

            if (this.limited) {
              this.limitCropBox(true, true);
            }
          }

          break;

        default:
      }

      if (renderable) {
        cropBoxData.width = width;
        cropBoxData.height = height;
        cropBoxData.left = left;
        cropBoxData.top = top;
        this.action = action;
        this.renderCropBox();
      } // Override


      forEach(pointers, function (p) {
        p.startX = p.endX;
        p.startY = p.endY;
      });
    }
  };

  var methods = {
    // Show the crop box manually
    crop: function crop() {
      if (this.ready && !this.cropped && !this.disabled) {
        this.cropped = true;
        this.limitCropBox(true, true);

        if (this.options.modal) {
          addClass(this.dragBox, CLASS_MODAL);
        }

        removeClass(this.cropBox, CLASS_HIDDEN);
        this.setCropBoxData(this.initialCropBoxData);
      }

      return this;
    },
    // Reset the image and crop box to their initial states
    reset: function reset() {
      if (this.ready && !this.disabled) {
        this.imageData = assign({}, this.initialImageData);
        this.canvasData = assign({}, this.initialCanvasData);
        this.cropBoxData = assign({}, this.initialCropBoxData);
        this.renderCanvas();

        if (this.cropped) {
          this.renderCropBox();
        }
      }

      return this;
    },
    // Clear the crop box
    clear: function clear() {
      if (this.cropped && !this.disabled) {
        assign(this.cropBoxData, {
          left: 0,
          top: 0,
          width: 0,
          height: 0
        });
        this.cropped = false;
        this.renderCropBox();
        this.limitCanvas(true, true); // Render canvas after crop box rendered

        this.renderCanvas();
        removeClass(this.dragBox, CLASS_MODAL);
        addClass(this.cropBox, CLASS_HIDDEN);
      }

      return this;
    },

    /**
     * Replace the image's src and rebuild the cropper
     * @param {string} url - The new URL.
     * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
     * @returns {Cropper} this
     */
    replace: function replace(url) {
      var hasSameSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!this.disabled && url) {
        if (this.isImg) {
          this.element.src = url;
        }

        if (hasSameSize) {
          this.url = url;
          this.image.src = url;

          if (this.ready) {
            this.viewBoxImage.src = url;
            forEach(this.previews, function (element) {
              element.getElementsByTagName('img')[0].src = url;
            });
          }
        } else {
          if (this.isImg) {
            this.replaced = true;
          }

          this.options.data = null;
          this.uncreate();
          this.load(url);
        }
      }

      return this;
    },
    // Enable (unfreeze) the cropper
    enable: function enable() {
      if (this.ready && this.disabled) {
        this.disabled = false;
        removeClass(this.cropper, CLASS_DISABLED);
      }

      return this;
    },
    // Disable (freeze) the cropper
    disable: function disable() {
      if (this.ready && !this.disabled) {
        this.disabled = true;
        addClass(this.cropper, CLASS_DISABLED);
      }

      return this;
    },

    /**
     * Destroy the cropper and remove the instance from the image
     * @returns {Cropper} this
     */
    destroy: function destroy() {
      var element = this.element;

      if (!element[NAMESPACE]) {
        return this;
      }

      element[NAMESPACE] = undefined;

      if (this.isImg && this.replaced) {
        element.src = this.originalUrl;
      }

      this.uncreate();
      return this;
    },

    /**
     * Move the canvas with relative offsets
     * @param {number} offsetX - The relative offset distance on the x-axis.
     * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
     * @returns {Cropper} this
     */
    move: function move(offsetX) {
      var offsetY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : offsetX;
      var _this$canvasData = this.canvasData,
          left = _this$canvasData.left,
          top = _this$canvasData.top;
      return this.moveTo(isUndefined(offsetX) ? offsetX : left + Number(offsetX), isUndefined(offsetY) ? offsetY : top + Number(offsetY));
    },

    /**
     * Move the canvas to an absolute point
     * @param {number} x - The x-axis coordinate.
     * @param {number} [y=x] - The y-axis coordinate.
     * @returns {Cropper} this
     */
    moveTo: function moveTo(x) {
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
      var canvasData = this.canvasData;
      var changed = false;
      x = Number(x);
      y = Number(y);

      if (this.ready && !this.disabled && this.options.movable) {
        if (isNumber(x)) {
          canvasData.left = x;
          changed = true;
        }

        if (isNumber(y)) {
          canvasData.top = y;
          changed = true;
        }

        if (changed) {
          this.renderCanvas(true);
        }
      }

      return this;
    },

    /**
     * Zoom the canvas with a relative ratio
     * @param {number} ratio - The target ratio.
     * @param {Event} _originalEvent - The original event if any.
     * @returns {Cropper} this
     */
    zoom: function zoom(ratio, _originalEvent) {
      var canvasData = this.canvasData;
      ratio = Number(ratio);

      if (ratio < 0) {
        ratio = 1 / (1 - ratio);
      } else {
        ratio = 1 + ratio;
      }

      return this.zoomTo(canvasData.width * ratio / canvasData.naturalWidth, null, _originalEvent);
    },

    /**
     * Zoom the canvas to an absolute ratio
     * @param {number} ratio - The target ratio.
     * @param {Object} pivot - The zoom pivot point coordinate.
     * @param {Event} _originalEvent - The original event if any.
     * @returns {Cropper} this
     */
    zoomTo: function zoomTo(ratio, pivot, _originalEvent) {
      var options = this.options,
          canvasData = this.canvasData;
      var width = canvasData.width,
          height = canvasData.height,
          naturalWidth = canvasData.naturalWidth,
          naturalHeight = canvasData.naturalHeight;
      ratio = Number(ratio);

      if (ratio >= 0 && this.ready && !this.disabled && options.zoomable) {
        var newWidth = naturalWidth * ratio;
        var newHeight = naturalHeight * ratio;

        if (dispatchEvent(this.element, EVENT_ZOOM, {
          ratio: ratio,
          oldRatio: width / naturalWidth,
          originalEvent: _originalEvent
        }) === false) {
          return this;
        }

        if (_originalEvent) {
          var pointers = this.pointers;
          var offset = getOffset(this.cropper);
          var center = pointers && Object.keys(pointers).length ? getPointersCenter(pointers) : {
            pageX: _originalEvent.pageX,
            pageY: _originalEvent.pageY
          }; // Zoom from the triggering point of the event

          canvasData.left -= (newWidth - width) * ((center.pageX - offset.left - canvasData.left) / width);
          canvasData.top -= (newHeight - height) * ((center.pageY - offset.top - canvasData.top) / height);
        } else if (isPlainObject(pivot) && isNumber(pivot.x) && isNumber(pivot.y)) {
          canvasData.left -= (newWidth - width) * ((pivot.x - canvasData.left) / width);
          canvasData.top -= (newHeight - height) * ((pivot.y - canvasData.top) / height);
        } else {
          // Zoom from the center of the canvas
          canvasData.left -= (newWidth - width) / 2;
          canvasData.top -= (newHeight - height) / 2;
        }

        canvasData.width = newWidth;
        canvasData.height = newHeight;
        this.renderCanvas(true);
      }

      return this;
    },

    /**
     * Rotate the canvas with a relative degree
     * @param {number} degree - The rotate degree.
     * @returns {Cropper} this
     */
    rotate: function rotate(degree) {
      return this.rotateTo((this.imageData.rotate || 0) + Number(degree));
    },

    /**
     * Rotate the canvas to an absolute degree
     * @param {number} degree - The rotate degree.
     * @returns {Cropper} this
     */
    rotateTo: function rotateTo(degree) {
      degree = Number(degree);

      if (isNumber(degree) && this.ready && !this.disabled && this.options.rotatable) {
        this.imageData.rotate = degree % 360;
        this.renderCanvas(true, true);
      }

      return this;
    },

    /**
     * Scale the image on the x-axis.
     * @param {number} scaleX - The scale ratio on the x-axis.
     * @returns {Cropper} this
     */
    scaleX: function scaleX(_scaleX) {
      var scaleY = this.imageData.scaleY;
      return this.scale(_scaleX, isNumber(scaleY) ? scaleY : 1);
    },

    /**
     * Scale the image on the y-axis.
     * @param {number} scaleY - The scale ratio on the y-axis.
     * @returns {Cropper} this
     */
    scaleY: function scaleY(_scaleY) {
      var scaleX = this.imageData.scaleX;
      return this.scale(isNumber(scaleX) ? scaleX : 1, _scaleY);
    },

    /**
     * Scale the image
     * @param {number} scaleX - The scale ratio on the x-axis.
     * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
     * @returns {Cropper} this
     */
    scale: function scale(scaleX) {
      var scaleY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scaleX;
      var imageData = this.imageData;
      var transformed = false;
      scaleX = Number(scaleX);
      scaleY = Number(scaleY);

      if (this.ready && !this.disabled && this.options.scalable) {
        if (isNumber(scaleX)) {
          imageData.scaleX = scaleX;
          transformed = true;
        }

        if (isNumber(scaleY)) {
          imageData.scaleY = scaleY;
          transformed = true;
        }

        if (transformed) {
          this.renderCanvas(true, true);
        }
      }

      return this;
    },

    /**
     * Get the cropped area position and size data (base on the original image)
     * @param {boolean} [rounded=false] - Indicate if round the data values or not.
     * @returns {Object} The result cropped data.
     */
    getData: function getData() {
      var rounded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var options = this.options,
          imageData = this.imageData,
          canvasData = this.canvasData,
          cropBoxData = this.cropBoxData;
      var data;

      if (this.ready && this.cropped) {
        data = {
          x: cropBoxData.left - canvasData.left,
          y: cropBoxData.top - canvasData.top,
          width: cropBoxData.width,
          height: cropBoxData.height
        };
        var ratio = imageData.width / imageData.naturalWidth;
        forEach(data, function (n, i) {
          data[i] = n / ratio;
        });

        if (rounded) {
          // In case rounding off leads to extra 1px in right or bottom border
          // we should round the top-left corner and the dimension (#343).
          var bottom = Math.round(data.y + data.height);
          var right = Math.round(data.x + data.width);
          data.x = Math.round(data.x);
          data.y = Math.round(data.y);
          data.width = right - data.x;
          data.height = bottom - data.y;
        }
      } else {
        data = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }

      if (options.rotatable) {
        data.rotate = imageData.rotate || 0;
      }

      if (options.scalable) {
        data.scaleX = imageData.scaleX || 1;
        data.scaleY = imageData.scaleY || 1;
      }

      return data;
    },

    /**
     * Set the cropped area position and size with new data
     * @param {Object} data - The new data.
     * @returns {Cropper} this
     */
    setData: function setData(data) {
      var options = this.options,
          imageData = this.imageData,
          canvasData = this.canvasData;
      var cropBoxData = {};

      if (this.ready && !this.disabled && isPlainObject(data)) {
        var transformed = false;

        if (options.rotatable) {
          if (isNumber(data.rotate) && data.rotate !== imageData.rotate) {
            imageData.rotate = data.rotate;
            transformed = true;
          }
        }

        if (options.scalable) {
          if (isNumber(data.scaleX) && data.scaleX !== imageData.scaleX) {
            imageData.scaleX = data.scaleX;
            transformed = true;
          }

          if (isNumber(data.scaleY) && data.scaleY !== imageData.scaleY) {
            imageData.scaleY = data.scaleY;
            transformed = true;
          }
        }

        if (transformed) {
          this.renderCanvas(true, true);
        }

        var ratio = imageData.width / imageData.naturalWidth;

        if (isNumber(data.x)) {
          cropBoxData.left = data.x * ratio + canvasData.left;
        }

        if (isNumber(data.y)) {
          cropBoxData.top = data.y * ratio + canvasData.top;
        }

        if (isNumber(data.width)) {
          cropBoxData.width = data.width * ratio;
        }

        if (isNumber(data.height)) {
          cropBoxData.height = data.height * ratio;
        }

        this.setCropBoxData(cropBoxData);
      }

      return this;
    },

    /**
     * Get the container size data.
     * @returns {Object} The result container data.
     */
    getContainerData: function getContainerData() {
      return this.ready ? assign({}, this.containerData) : {};
    },

    /**
     * Get the image position and size data.
     * @returns {Object} The result image data.
     */
    getImageData: function getImageData() {
      return this.sized ? assign({}, this.imageData) : {};
    },

    /**
     * Get the canvas position and size data.
     * @returns {Object} The result canvas data.
     */
    getCanvasData: function getCanvasData() {
      var canvasData = this.canvasData;
      var data = {};

      if (this.ready) {
        forEach(['left', 'top', 'width', 'height', 'naturalWidth', 'naturalHeight'], function (n) {
          data[n] = canvasData[n];
        });
      }

      return data;
    },

    /**
     * Set the canvas position and size with new data.
     * @param {Object} data - The new canvas data.
     * @returns {Cropper} this
     */
    setCanvasData: function setCanvasData(data) {
      var canvasData = this.canvasData;
      var aspectRatio = canvasData.aspectRatio;

      if (this.ready && !this.disabled && isPlainObject(data)) {
        if (isNumber(data.left)) {
          canvasData.left = data.left;
        }

        if (isNumber(data.top)) {
          canvasData.top = data.top;
        }

        if (isNumber(data.width)) {
          canvasData.width = data.width;
          canvasData.height = data.width / aspectRatio;
        } else if (isNumber(data.height)) {
          canvasData.height = data.height;
          canvasData.width = data.height * aspectRatio;
        }

        this.renderCanvas(true);
      }

      return this;
    },

    /**
     * Get the crop box position and size data.
     * @returns {Object} The result crop box data.
     */
    getCropBoxData: function getCropBoxData() {
      var cropBoxData = this.cropBoxData;
      var data;

      if (this.ready && this.cropped) {
        data = {
          left: cropBoxData.left,
          top: cropBoxData.top,
          width: cropBoxData.width,
          height: cropBoxData.height
        };
      }

      return data || {};
    },

    /**
     * Set the crop box position and size with new data.
     * @param {Object} data - The new crop box data.
     * @returns {Cropper} this
     */
    setCropBoxData: function setCropBoxData(data) {
      var cropBoxData = this.cropBoxData;
      var aspectRatio = this.options.aspectRatio;
      var widthChanged;
      var heightChanged;

      if (this.ready && this.cropped && !this.disabled && isPlainObject(data)) {
        if (isNumber(data.left)) {
          cropBoxData.left = data.left;
        }

        if (isNumber(data.top)) {
          cropBoxData.top = data.top;
        }

        if (isNumber(data.width) && data.width !== cropBoxData.width) {
          widthChanged = true;
          cropBoxData.width = data.width;
        }

        if (isNumber(data.height) && data.height !== cropBoxData.height) {
          heightChanged = true;
          cropBoxData.height = data.height;
        }

        if (aspectRatio) {
          if (widthChanged) {
            cropBoxData.height = cropBoxData.width / aspectRatio;
          } else if (heightChanged) {
            cropBoxData.width = cropBoxData.height * aspectRatio;
          }
        }

        this.renderCropBox();
      }

      return this;
    },

    /**
     * Get a canvas drawn the cropped image.
     * @param {Object} [options={}] - The config options.
     * @returns {HTMLCanvasElement} - The result canvas.
     */
    getCroppedCanvas: function getCroppedCanvas() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!this.ready || !window.HTMLCanvasElement) {
        return null;
      }

      var canvasData = this.canvasData;
      var source = getSourceCanvas(this.image, this.imageData, canvasData, options); // Returns the source canvas if it is not cropped.

      if (!this.cropped) {
        return source;
      }

      var _this$getData = this.getData(),
          initialX = _this$getData.x,
          initialY = _this$getData.y,
          initialWidth = _this$getData.width,
          initialHeight = _this$getData.height;

      var ratio = source.width / Math.floor(canvasData.naturalWidth);

      if (ratio !== 1) {
        initialX *= ratio;
        initialY *= ratio;
        initialWidth *= ratio;
        initialHeight *= ratio;
      }

      var aspectRatio = initialWidth / initialHeight;
      var maxSizes = getAdjustedSizes({
        aspectRatio: aspectRatio,
        width: options.maxWidth || Infinity,
        height: options.maxHeight || Infinity
      });
      var minSizes = getAdjustedSizes({
        aspectRatio: aspectRatio,
        width: options.minWidth || 0,
        height: options.minHeight || 0
      }, 'cover');

      var _getAdjustedSizes = getAdjustedSizes({
        aspectRatio: aspectRatio,
        width: options.width || (ratio !== 1 ? source.width : initialWidth),
        height: options.height || (ratio !== 1 ? source.height : initialHeight)
      }),
          width = _getAdjustedSizes.width,
          height = _getAdjustedSizes.height;

      width = Math.min(maxSizes.width, Math.max(minSizes.width, width));
      height = Math.min(maxSizes.height, Math.max(minSizes.height, height));
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = normalizeDecimalNumber(width);
      canvas.height = normalizeDecimalNumber(height);
      context.fillStyle = options.fillColor || 'transparent';
      context.fillRect(0, 0, width, height);
      var _options$imageSmoothi = options.imageSmoothingEnabled,
          imageSmoothingEnabled = _options$imageSmoothi === void 0 ? true : _options$imageSmoothi,
          imageSmoothingQuality = options.imageSmoothingQuality;
      context.imageSmoothingEnabled = imageSmoothingEnabled;

      if (imageSmoothingQuality) {
        context.imageSmoothingQuality = imageSmoothingQuality;
      } // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D.drawImage


      var sourceWidth = source.width;
      var sourceHeight = source.height; // Source canvas parameters

      var srcX = initialX;
      var srcY = initialY;
      var srcWidth;
      var srcHeight; // Destination canvas parameters

      var dstX;
      var dstY;
      var dstWidth;
      var dstHeight;

      if (srcX <= -initialWidth || srcX > sourceWidth) {
        srcX = 0;
        srcWidth = 0;
        dstX = 0;
        dstWidth = 0;
      } else if (srcX <= 0) {
        dstX = -srcX;
        srcX = 0;
        srcWidth = Math.min(sourceWidth, initialWidth + srcX);
        dstWidth = srcWidth;
      } else if (srcX <= sourceWidth) {
        dstX = 0;
        srcWidth = Math.min(initialWidth, sourceWidth - srcX);
        dstWidth = srcWidth;
      }

      if (srcWidth <= 0 || srcY <= -initialHeight || srcY > sourceHeight) {
        srcY = 0;
        srcHeight = 0;
        dstY = 0;
        dstHeight = 0;
      } else if (srcY <= 0) {
        dstY = -srcY;
        srcY = 0;
        srcHeight = Math.min(sourceHeight, initialHeight + srcY);
        dstHeight = srcHeight;
      } else if (srcY <= sourceHeight) {
        dstY = 0;
        srcHeight = Math.min(initialHeight, sourceHeight - srcY);
        dstHeight = srcHeight;
      }

      var params = [srcX, srcY, srcWidth, srcHeight]; // Avoid "IndexSizeError"

      if (dstWidth > 0 && dstHeight > 0) {
        var scale = width / initialWidth;
        params.push(dstX * scale, dstY * scale, dstWidth * scale, dstHeight * scale);
      } // All the numerical parameters should be integer for `drawImage`
      // https://github.com/fengyuanchen/cropper/issues/476


      context.drawImage.apply(context, [source].concat(_toConsumableArray(params.map(function (param) {
        return Math.floor(normalizeDecimalNumber(param));
      }))));
      return canvas;
    },

    /**
     * Change the aspect ratio of the crop box.
     * @param {number} aspectRatio - The new aspect ratio.
     * @returns {Cropper} this
     */
    setAspectRatio: function setAspectRatio(aspectRatio) {
      var options = this.options;

      if (!this.disabled && !isUndefined(aspectRatio)) {
        // 0 -> NaN
        options.aspectRatio = Math.max(0, aspectRatio) || NaN;

        if (this.ready) {
          this.initCropBox();

          if (this.cropped) {
            this.renderCropBox();
          }
        }
      }

      return this;
    },

    /**
     * Change the drag mode.
     * @param {string} mode - The new drag mode.
     * @returns {Cropper} this
     */
    setDragMode: function setDragMode(mode) {
      var options = this.options,
          dragBox = this.dragBox,
          face = this.face;

      if (this.ready && !this.disabled) {
        var croppable = mode === DRAG_MODE_CROP;
        var movable = options.movable && mode === DRAG_MODE_MOVE;
        mode = croppable || movable ? mode : DRAG_MODE_NONE;
        options.dragMode = mode;
        setData(dragBox, DATA_ACTION, mode);
        toggleClass(dragBox, CLASS_CROP, croppable);
        toggleClass(dragBox, CLASS_MOVE, movable);

        if (!options.cropBoxMovable) {
          // Sync drag mode to crop box when it is not movable
          setData(face, DATA_ACTION, mode);
          toggleClass(face, CLASS_CROP, croppable);
          toggleClass(face, CLASS_MOVE, movable);
        }
      }

      return this;
    }
  };

  var AnotherCropper = WINDOW.Cropper;

  var Cropper =
  /*#__PURE__*/
  function () {
    /**
     * Create a new Cropper.
     * @param {Element} element - The target element for cropping.
     * @param {Object} [options={}] - The configuration options.
     */
    function Cropper(element) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, Cropper);

      if (!element || !REGEXP_TAG_NAME.test(element.tagName)) {
        throw new Error('The first argument is required and must be an <img> or <canvas> element.');
      }

      this.element = element;
      this.options = assign({}, DEFAULTS, isPlainObject(options) && options);
      this.cropped = false;
      this.disabled = false;
      this.pointers = {};
      this.ready = false;
      this.reloading = false;
      this.replaced = false;
      this.sized = false;
      this.sizing = false;
      this.init();
    }

    _createClass(Cropper, [{
      key: "init",
      value: function init() {
        var element = this.element;
        var tagName = element.tagName.toLowerCase();
        var url;

        if (element[NAMESPACE]) {
          return;
        }

        element[NAMESPACE] = this;

        if (tagName === 'img') {
          this.isImg = true; // e.g.: "img/picture.jpg"

          url = element.getAttribute('src') || '';
          this.originalUrl = url; // Stop when it's a blank image

          if (!url) {
            return;
          } // e.g.: "http://example.com/img/picture.jpg"


          url = element.src;
        } else if (tagName === 'canvas' && window.HTMLCanvasElement) {
          url = element.toDataURL();
        }

        this.load(url);
      }
    }, {
      key: "load",
      value: function load(url) {
        var _this = this;

        if (!url) {
          return;
        }

        this.url = url;
        this.imageData = {};
        var element = this.element,
            options = this.options;

        if (!options.rotatable && !options.scalable) {
          options.checkOrientation = false;
        } // Only IE10+ supports Typed Arrays


        if (!options.checkOrientation || !window.ArrayBuffer) {
          this.clone();
          return;
        } // Detect the mime type of the image directly if it is a Data URL


        if (REGEXP_DATA_URL.test(url)) {
          // Read ArrayBuffer from Data URL of JPEG images directly for better performance
          if (REGEXP_DATA_URL_JPEG.test(url)) {
            this.read(dataURLToArrayBuffer(url));
          } else {
            // Only a JPEG image may contains Exif Orientation information,
            // the rest types of Data URLs are not necessary to check orientation at all.
            this.clone();
          }

          return;
        } // 1. Detect the mime type of the image by a XMLHttpRequest.
        // 2. Load the image as ArrayBuffer for reading orientation if its a JPEG image.


        var xhr = new XMLHttpRequest();
        var clone = this.clone.bind(this);
        this.reloading = true;
        this.xhr = xhr; // 1. Cross origin requests are only supported for protocol schemes:
        // http, https, data, chrome, chrome-extension.
        // 2. Access to XMLHttpRequest from a Data URL will be blocked by CORS policy
        // in some browsers as IE11 and Safari.

        xhr.onabort = clone;
        xhr.onerror = clone;
        xhr.ontimeout = clone;

        xhr.onprogress = function () {
          // Abort the request directly if it not a JPEG image for better performance
          if (xhr.getResponseHeader('content-type') !== MIME_TYPE_JPEG) {
            xhr.abort();
          }
        };

        xhr.onload = function () {
          _this.read(xhr.response);
        };

        xhr.onloadend = function () {
          _this.reloading = false;
          _this.xhr = null;
        }; // Bust cache when there is a "crossOrigin" property to avoid browser cache error


        if (options.checkCrossOrigin && isCrossOriginURL(url) && element.crossOrigin) {
          url = addTimestamp(url);
        }

        xhr.open('GET', url);
        xhr.responseType = 'arraybuffer';
        xhr.withCredentials = element.crossOrigin === 'use-credentials';
        xhr.send();
      }
    }, {
      key: "read",
      value: function read(arrayBuffer) {
        var options = this.options,
            imageData = this.imageData; // Reset the orientation value to its default value 1
        // as some iOS browsers will render image with its orientation

        var orientation = resetAndGetOrientation(arrayBuffer);
        var rotate = 0;
        var scaleX = 1;
        var scaleY = 1;

        if (orientation > 1) {
          // Generate a new URL which has the default orientation value
          this.url = arrayBufferToDataURL(arrayBuffer, MIME_TYPE_JPEG);

          var _parseOrientation = parseOrientation(orientation);

          rotate = _parseOrientation.rotate;
          scaleX = _parseOrientation.scaleX;
          scaleY = _parseOrientation.scaleY;
        }

        if (options.rotatable) {
          imageData.rotate = rotate;
        }

        if (options.scalable) {
          imageData.scaleX = scaleX;
          imageData.scaleY = scaleY;
        }

        this.clone();
      }
    }, {
      key: "clone",
      value: function clone() {
        var element = this.element,
            url = this.url;
        var crossOrigin = element.crossOrigin;
        var crossOriginUrl = url;

        if (this.options.checkCrossOrigin && isCrossOriginURL(url)) {
          if (!crossOrigin) {
            crossOrigin = 'anonymous';
          } // Bust cache when there is not a "crossOrigin" property (#519)


          crossOriginUrl = addTimestamp(url);
        }

        this.crossOrigin = crossOrigin;
        this.crossOriginUrl = crossOriginUrl;
        var image = document.createElement('img');

        if (crossOrigin) {
          image.crossOrigin = crossOrigin;
        }

        image.src = crossOriginUrl || url;
        image.alt = element.alt || 'The image to crop';
        this.image = image;
        image.onload = this.start.bind(this);
        image.onerror = this.stop.bind(this);
        addClass(image, CLASS_HIDE);
        element.parentNode.insertBefore(image, element.nextSibling);
      }
    }, {
      key: "start",
      value: function start() {
        var _this2 = this;

        var image = this.image;
        image.onload = null;
        image.onerror = null;
        this.sizing = true; // Match all browsers that use WebKit as the layout engine in iOS devices,
        // such as Safari for iOS, Chrome for iOS, and in-app browsers.

        var isIOSWebKit = WINDOW.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(WINDOW.navigator.userAgent);

        var done = function done(naturalWidth, naturalHeight) {
          assign(_this2.imageData, {
            naturalWidth: naturalWidth,
            naturalHeight: naturalHeight,
            aspectRatio: naturalWidth / naturalHeight
          });
          _this2.sizing = false;
          _this2.sized = true;

          _this2.build();
        }; // Most modern browsers (excepts iOS WebKit)


        if (image.naturalWidth && !isIOSWebKit) {
          done(image.naturalWidth, image.naturalHeight);
          return;
        }

        var sizingImage = document.createElement('img');
        var body = document.body || document.documentElement;
        this.sizingImage = sizingImage;

        sizingImage.onload = function () {
          done(sizingImage.width, sizingImage.height);

          if (!isIOSWebKit) {
            body.removeChild(sizingImage);
          }
        };

        sizingImage.src = image.src; // iOS WebKit will convert the image automatically
        // with its orientation once append it into DOM (#279)

        if (!isIOSWebKit) {
          sizingImage.style.cssText = 'left:0;' + 'max-height:none!important;' + 'max-width:none!important;' + 'min-height:0!important;' + 'min-width:0!important;' + 'opacity:0;' + 'position:absolute;' + 'top:0;' + 'z-index:-1;';
          body.appendChild(sizingImage);
        }
      }
    }, {
      key: "stop",
      value: function stop() {
        var image = this.image;
        image.onload = null;
        image.onerror = null;
        image.parentNode.removeChild(image);
        this.image = null;
      }
    }, {
      key: "build",
      value: function build() {
        if (!this.sized || this.ready) {
          return;
        }

        var element = this.element,
            options = this.options,
            image = this.image; // Create cropper elements

        var container = element.parentNode;
        var template = document.createElement('div');
        template.innerHTML = TEMPLATE;
        var cropper = template.querySelector(".".concat(NAMESPACE, "-container"));
        var canvas = cropper.querySelector(".".concat(NAMESPACE, "-canvas"));
        var dragBox = cropper.querySelector(".".concat(NAMESPACE, "-drag-box"));
        var cropBox = cropper.querySelector(".".concat(NAMESPACE, "-crop-box"));
        var face = cropBox.querySelector(".".concat(NAMESPACE, "-face"));
        this.container = container;
        this.cropper = cropper;
        this.canvas = canvas;
        this.dragBox = dragBox;
        this.cropBox = cropBox;
        this.viewBox = cropper.querySelector(".".concat(NAMESPACE, "-view-box"));
        this.face = face;
        canvas.appendChild(image); // Hide the original image

        addClass(element, CLASS_HIDDEN); // Inserts the cropper after to the current image

        container.insertBefore(cropper, element.nextSibling); // Show the image if is hidden

        if (!this.isImg) {
          removeClass(image, CLASS_HIDE);
        }

        this.initPreview();
        this.bind();
        options.initialAspectRatio = Math.max(0, options.initialAspectRatio) || NaN;
        options.aspectRatio = Math.max(0, options.aspectRatio) || NaN;
        options.viewMode = Math.max(0, Math.min(3, Math.round(options.viewMode))) || 0;
        addClass(cropBox, CLASS_HIDDEN);

        if (!options.guides) {
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-dashed")), CLASS_HIDDEN);
        }

        if (!options.center) {
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-center")), CLASS_HIDDEN);
        }

        if (options.background) {
          addClass(cropper, "".concat(NAMESPACE, "-bg"));
        }

        if (!options.highlight) {
          addClass(face, CLASS_INVISIBLE);
        }

        if (options.cropBoxMovable) {
          addClass(face, CLASS_MOVE);
          setData(face, DATA_ACTION, ACTION_ALL);
        }

        if (!options.cropBoxResizable) {
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-line")), CLASS_HIDDEN);
          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-point")), CLASS_HIDDEN);
        }

        this.render();
        this.ready = true;
        this.setDragMode(options.dragMode);

        if (options.autoCrop) {
          this.crop();
        }

        this.setData(options.data);

        if (isFunction(options.ready)) {
          addListener(element, EVENT_READY, options.ready, {
            once: true
          });
        }

        dispatchEvent(element, EVENT_READY);
      }
    }, {
      key: "unbuild",
      value: function unbuild() {
        if (!this.ready) {
          return;
        }

        this.ready = false;
        this.unbind();
        this.resetPreview();
        this.cropper.parentNode.removeChild(this.cropper);
        removeClass(this.element, CLASS_HIDDEN);
      }
    }, {
      key: "uncreate",
      value: function uncreate() {
        if (this.ready) {
          this.unbuild();
          this.ready = false;
          this.cropped = false;
        } else if (this.sizing) {
          this.sizingImage.onload = null;
          this.sizing = false;
          this.sized = false;
        } else if (this.reloading) {
          this.xhr.onabort = null;
          this.xhr.abort();
        } else if (this.image) {
          this.stop();
        }
      }
      /**
       * Get the no conflict cropper class.
       * @returns {Cropper} The cropper class.
       */

    }], [{
      key: "noConflict",
      value: function noConflict() {
        window.Cropper = AnotherCropper;
        return Cropper;
      }
      /**
       * Change the default options.
       * @param {Object} options - The new default options.
       */

    }, {
      key: "setDefaults",
      value: function setDefaults(options) {
        assign(DEFAULTS, isPlainObject(options) && options);
      }
    }]);

    return Cropper;
  }();

  assign(Cropper.prototype, render, preview, events, handlers, change, methods);

  if ($.fn) {
    var AnotherCropper$1 = $.fn.cropper;
    var NAMESPACE$1 = 'cropper';

    $.fn.cropper = function jQueryCropper(option) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var result;
      this.each(function (i, element) {
        var $element = $(element);
        var isDestroy = option === 'destroy';
        var cropper = $element.data(NAMESPACE$1);

        if (!cropper) {
          if (isDestroy) {
            return;
          }

          var options = $.extend({}, $element.data(), $.isPlainObject(option) && option);
          cropper = new Cropper(element, options);
          $element.data(NAMESPACE$1, cropper);
        }

        if (typeof option === 'string') {
          var fn = cropper[option];

          if ($.isFunction(fn)) {
            result = fn.apply(cropper, args);

            if (result === cropper) {
              result = undefined;
            }

            if (isDestroy) {
              $element.removeData(NAMESPACE$1);
            }
          }
        }
      });
      return result !== undefined ? result : this;
    };

    $.fn.cropper.Constructor = Cropper;
    $.fn.cropper.setDefaults = Cropper.setDefaults;

    $.fn.cropper.noConflict = function noConflict() {
      $.fn.cropper = AnotherCropper$1;
      return this;
    };
  }

}));


/***/ }),
/* 826 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[(_vm.profile != null)?_c('div',{staticClass:"body-panel-control separator"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"control-block-right flex"},[_c('button',{staticClass:"btn",on:{"click":function($event){$event.stopPropagation();return _vm.onShowModal('ppChangePassword')}}},[_vm._v("Сменить пароль")]),_vm._v(" "),(_vm.profile.TermsConfirmed)?_c('button',{staticClass:"btn btn-primary margin-left-20",attrs:{"disabled":_vm.errorMessage != null},on:{"click":_vm.saveData}},[_vm._v("Сохранить")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.profile != null)?_c('div',{staticClass:"body-panel-content body-panel-content-page"},[_c('div',{staticClass:"test-result-header flex profile"},[_c('div',{class:['test-result-header-div', {'select': _vm.tabs.active === 'info'}],on:{"click":function($event){_vm.tabs.active='info'}}},[_vm._v("Основные данные")]),_vm._v(" "),(_vm.info.User && _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.bonusSpend))?_c('div',{class:['test-result-header-div', {'select': _vm.tabs.active === 'docs'}],on:{"click":function($event){_vm.tabs.active='docs'; _vm.$validator.validateAll('docs')}}},[_vm._v("Документы")]):_vm._e(),_vm._v(" "),(_vm.profile.ProjectsHavePhysicalBankCardReward && _vm.info.User && _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.bonusSpend))?_c('div',{class:['test-result-header-div', {'select': _vm.tabs.active === 'card'}],on:{"click":function($event){_vm.tabs.active='card'; _vm.$validator.validateAll('card')}}},[_vm._v("Банковская карта")]):_vm._e(),_vm._v(" "),(_vm.external.length && _vm.info.User.MainRole !== 'administrators')?_c('div',{class:['test-result-header-div', {'select': _vm.tabs.active === 'external'}],on:{"click":function($event){_vm.tabs.active='external'; _vm.$validator.validateAll('external')}}},[_vm._v("Вход через соц. сети")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"block-in-page",style:({display: _vm.tabs.active === 'info' ? 'block' : 'none'})},[(!_vm.profile.TermsConfirmed)?_c('div',{staticClass:"error"},[_vm._v("\n                Для продолжения работы в системе Вы должны согласиться с условиями использования сервиса\n            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"profile-edit"},[_c('div',{staticClass:"profile-images"},[_c('div',{staticClass:"profile-img margin-bottom-10"},[_c('div',{staticClass:"profile-img-cell"},[(_vm.profile.Image && !_vm.profile.DeleteImage)?_c('img',{attrs:{"src":_vm.profile.Image}}):_c('img',{attrs:{"src":__webpack_require__(55)}})])]),_vm._v(" "),(!_vm.profile.Image || _vm.profile.DeleteImage)?_c('div',{staticClass:"file-upload-zone"},[_c('input',{ref:"dropFiles",staticClass:"file-upload-zone-btn",attrs:{"type":"file","id":"dropFiles","name":"dropFiles","accept":".jpg,.jpeg,.png"}}),_vm._v(" "),_c('label',{staticClass:"file-upload-zone-lbl",attrs:{"id":"dropFilesBtnLbl","for":"dropFiles"}},[_vm._v("Добавьте фото профиля")])]):_vm._e(),_vm._v(" "),(_vm.profile.FileName != null)?_c('div',{staticClass:"fileList",attrs:{"id":"fileList"}},[_vm._v("\n                        Выбран файл: "+_vm._s(_vm.profile.FileName)+"\n                    ")]):_vm._e(),_vm._v(" "),((_vm.profile.Image || _vm.profile.FileName) && !_vm.profile.DeleteImage)?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeImage()}}},[_vm._v("\n                        Удалить\n                    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"profile-data"},[(_vm.errorMessage)?_c('div',{staticClass:"error"},[_vm._v("\n                        "+_vm._s(_vm.errorMessage.message)+"\n                    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.FirstName),expression:"profile.FirstName"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-text', {'input-error': _vm.errors.has('FirstName', 'info')}],attrs:{"name":"FirstName","type":"text","disabled":!_vm.profile.PersonalDataEditingAccept || _vm.profile.PassportVerificationState === 1 || _vm.profile.PassportVerificationState === 2,"data-vv-scope":"info","data-vv-as":"Имя"},domProps:{"value":(_vm.profile.FirstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile, "FirstName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"})]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.LastName),expression:"profile.LastName"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-text', {'input-error': _vm.errors.has('LastName', 'info')}],attrs:{"name":"LastName","type":"text","disabled":!_vm.profile.PersonalDataEditingAccept || _vm.profile.PassportVerificationState === 1 || _vm.profile.PassportVerificationState === 2,"data-vv-scope":"info","data-vv-as":"Фамилия"},domProps:{"value":(_vm.profile.LastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile, "LastName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"})]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(3),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.MiddleName),expression:"profile.MiddleName"}],class:['input-text', {'input-error': _vm.errors.has('MiddleName', 'info')}],attrs:{"name":"MiddleName","type":"text","disabled":!_vm.profile.PersonalDataEditingAccept || _vm.profile.PassportVerificationState === 1 || _vm.profile.PassportVerificationState === 2,"data-vv-scope":"info"},domProps:{"value":(_vm.profile.MiddleName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile, "MiddleName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"})]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(4),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.Email),expression:"profile.Email"},{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],class:['input-text', {'input-error': _vm.errors.has('Email', 'info')}],attrs:{"name":"Email","data-vv-scope":"info","type":"text"},domProps:{"value":(_vm.profile.Email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile, "Email", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"})]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(5),_vm._v(" "),_c('the-mask',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, regex: /^\d{11,}$/ }),expression:"{ required: true, regex: /^\\d{11,}$/ }"}],class:['input-text', {'input-error': _vm.errors.has('PhoneNumber', 'info')}],attrs:{"mask":['### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ###'],"name":"PhoneNumber","data-vv-scope":"info","data-vv-as":"Телефон"},model:{value:(_vm.profile.PhoneNumber),callback:function ($$v) {_vm.$set(_vm.profile, "PhoneNumber", $$v)},expression:"profile.PhoneNumber"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"})],1),_vm._v(" "),(_vm.info.User && (_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.projectPage) || _vm.info.User.MainRole === 'administrators'))?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Внешний идентификатор\n                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.ExternalId),expression:"profile.ExternalId"}],staticClass:"input-text",attrs:{"name":"ExternalId","type":"text"},domProps:{"value":(_vm.profile.ExternalId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile, "ExternalId", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-text', {'input-error': _vm.errors.has('BirthDateFormatted', 'info')}],attrs:{"name":"BirthDateFormatted","disabled":!_vm.profile.PersonalDataEditingAccept || _vm.profile.PassportVerificationState === 1 || _vm.profile.PassportVerificationState === 2,"data-vv-scope":"info","data-vv-as":"Дата рождения"},on:{"input":function($event){return _vm.onChangeDate(_vm.profile, 'BirthDateFormatted', 'BirthDate')}},model:{value:(_vm.profile.BirthDateFormatted),callback:function ($$v) {_vm.$set(_vm.profile, "BirthDateFormatted", $$v)},expression:"profile.BirthDateFormatted"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(7),_vm._v(" "),(_vm.genders.length > 0)?_c('drop-down',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"}],class:[{'input-error': _vm.errors.has('Sex', 'info')}],attrs:{"name":'Sex',"items":_vm.genders,"dataField":'Value',"textField":'Name',"withSelectItem":'true',"data-vv-as":"\"Пол\"","data-vv-scope":"info"},model:{value:(_vm.profile.Sex),callback:function ($$v) {_vm.$set(_vm.profile, "Sex", $$v)},expression:"profile.Sex"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Sex')))])],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.NotificationsEnabled),expression:"profile.NotificationsEnabled"}],staticClass:"input-checkbox",attrs:{"id":"NotificationsEnabled","name":"NotificationsEnabled","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.profile.NotificationsEnabled)?_vm._i(_vm.profile.NotificationsEnabled,"true")>-1:(_vm.profile.NotificationsEnabled)},on:{"change":function($event){var $$a=_vm.profile.NotificationsEnabled,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.profile, "NotificationsEnabled", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.profile, "NotificationsEnabled", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.profile, "NotificationsEnabled", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"NotificationsEnabled"}},[_vm._v("Я хочу получать новости и оповещения по email и sms")])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.TermsConfirmed),expression:"profile.TermsConfirmed"}],staticClass:"input-checkbox",attrs:{"id":"TermsConfirmed","name":"TermsConfirmed","value":"true","type":"checkbox","disabled":_vm.profile.TermsConfirmed},domProps:{"checked":Array.isArray(_vm.profile.TermsConfirmed)?_vm._i(_vm.profile.TermsConfirmed,"true")>-1:(_vm.profile.TermsConfirmed)},on:{"change":function($event){var $$a=_vm.profile.TermsConfirmed,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.profile, "TermsConfirmed", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.profile, "TermsConfirmed", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.profile, "TermsConfirmed", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"TermsConfirmed"}},[_vm._v("\n                            Я согласен с "),(_vm.info.RulesFile)?_c('a',{staticStyle:{"color":"#ff0000"},attrs:{"href":"javascript:;"},on:{"click":function($event){$event.stopPropagation();return _vm.onShowRulesClick.apply(null, arguments)}}},[_vm._v("правилами программы")]):_vm._e(),_vm._v(" "),(!_vm.info.RulesFile)?_c('span',[_vm._v("правилами программы")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.PersonalDataEditingAccept),expression:"profile.PersonalDataEditingAccept"}],staticClass:"input-checkbox",attrs:{"id":"PersonalDataEditingAccept","name":"PersonalDataEditingAccept","value":"true","type":"checkbox","disabled":_vm.profile.PersonalDataEditingAccept},domProps:{"checked":Array.isArray(_vm.profile.PersonalDataEditingAccept)?_vm._i(_vm.profile.PersonalDataEditingAccept,"true")>-1:(_vm.profile.PersonalDataEditingAccept)},on:{"change":function($event){var $$a=_vm.profile.PersonalDataEditingAccept,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.profile, "PersonalDataEditingAccept", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.profile, "PersonalDataEditingAccept", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.profile, "PersonalDataEditingAccept", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"PersonalDataEditingAccept"}},[_vm._v("\n                            Я согласен на обработку\n                            "),(_vm.info.PolicyFile)?_c('a',{staticStyle:{"color":"#ff0000"},attrs:{"href":"javascript:;"},on:{"click":function($event){$event.stopPropagation();return _vm.onShowPolicyClick.apply(null, arguments)}}},[_vm._v("персональных данных")]):_vm._e(),(!_vm.info.PolicyFile)?_c('span',[_vm._v("персональных данных")]):_vm._e()])])])])]),_vm._v(" "),(_vm.info.User && _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.bonusSpend))?_c('div',{class:['block-in-page', {'notAllowed' : !_vm.profile.PersonalDataEditingAccept || _vm.profile.PassportVerificationState === 1 || _vm.profile.PassportVerificationState === 2 }],style:({display: _vm.tabs.active === 'docs' ? 'block' : 'none'})},[(_vm.profile.PassportVerificationState === 0)?_c('div',{staticClass:"error"},[_vm._v("\n                Данные документов необходимы для того, чтобы Вы могли выбрать приз\n            ")]):_vm._e(),_vm._v(" "),(_vm.profile.PassportVerificationState === 1)?_c('div',{staticClass:"error"},[_vm._v("\n                Паспортные данные находятся на проверке\n            ")]):_vm._e(),_vm._v(" "),(_vm.profile.PassportVerificationState === 2)?_c('div',{staticClass:"approve"},[_vm._v("\n                Паспортные данные успешно проверены\n            ")]):_vm._e(),_vm._v(" "),(_vm.profile.PassportVerificationState === 3)?_c('div',{staticClass:"error"},[_vm._v("\n                Паспортные данные были отклонены по следующей причине:\n                "),_c('p',{staticStyle:{"color":"#728a9a"}},[_vm._v(_vm._s(_vm.profile.PassportVerificationComment))])]):_vm._e(),_vm._v(" "),(_vm.errorMessage)?_c('div',{staticClass:"error"},[_vm._v("\n                "+_vm._s(_vm.errorMessage.message)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.errorMessage == null || _vm.errorMessage.type !== 'birthdate')?_c('div',{staticClass:"profile-edit"},[_c('div',{staticClass:"profile-data"},[_c('div',{staticClass:"form-field"},[_vm._m(8),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.documentTypes,"dataField":'Id',"textField":'Name'},model:{value:(_vm.profile.DocumentType),callback:function ($$v) {_vm.$set(_vm.profile, "DocumentType", $$v)},expression:"profile.DocumentType"}})],1),_vm._v(" "),(_vm.profile.DocumentType === 2)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Страна выдачи\n                            "),(_vm.passportFields.PassportIssuedCountry)?_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.PassportIssuedCountry),expression:"profile.PassportIssuedCountry"},{name:"validate",rawName:"v-validate",value:({ rules: { required: this.passportFieldsRequired && _vm.passportFields.PassportIssuedCountry} }),expression:"{ rules: { required: this.passportFieldsRequired && passportFields.PassportIssuedCountry} }"}],class:['input-text', {'input-error': _vm.errors.has('PassportIssuedCountry', 'docs')}],attrs:{"name":"PassportIssuedCountry","data-vv-scope":"docs","type":"text"},domProps:{"value":(_vm.profile.PassportIssuedCountry)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile, "PassportIssuedCountry", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Серия паспорта\n                            "),(_vm.passportFields.PassportSeries && _vm.profile.DocumentType !== 2)?_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")]):_vm._e()]),_vm._v(" "),(_vm.profile.DocumentType === 2)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.PassportSeries),expression:"profile.PassportSeries"}],staticClass:"input-text",attrs:{"name":"PassportSeries2","type":"text","autocomplete":"off"},domProps:{"value":(_vm.profile.PassportSeries)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile, "PassportSeries", $event.target.value)}}}):_c('the-mask',{directives:[{name:"validate",rawName:"v-validate",value:({ passportSeries: _vm.PassportSeriesMaxLength }),expression:"{ passportSeries: PassportSeriesMaxLength }"}],class:['input-text', {'input-error': _vm.errors.has('PassportSeries', 'docs')}],attrs:{"mask":_vm.PassportSeriesMask,"name":"PassportSeries","data-vv-scope":"docs"},model:{value:(_vm.profile.PassportSeries),callback:function ($$v) {_vm.$set(_vm.profile, "PassportSeries", $$v)},expression:"profile.PassportSeries"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('PassportSeries', 'docs')))])],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Номер паспорта\n                            "),(_vm.passportFields.PassportNumber && _vm.profile.DocumentType !== 2)?_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.PassportNumber),expression:"profile.PassportNumber"},{name:"validate",rawName:"v-validate",value:({ passportNumber: _vm.PassportNumberMaxLength }),expression:"{ passportNumber: PassportNumberMaxLength }"}],class:['input-text', {'input-error': _vm.errors.has('PassportNumber', 'docs')}],attrs:{"name":"PassportNumber","data-vv-scope":"docs","type":"text","autocomplete":"off"},domProps:{"value":(_vm.profile.PassportNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile, "PassportNumber", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('PassportNumber', 'docs')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Кем выдан\n                            "),(_vm.passportFields.PassportIssuedBy)?_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.PassportIssuedBy),expression:"profile.PassportIssuedBy"},{name:"validate",rawName:"v-validate",value:({ rules: { required: this.passportFieldsRequired && _vm.passportFields.PassportIssuedBy} }),expression:"{ rules: { required: this.passportFieldsRequired && passportFields.PassportIssuedBy} }"}],class:['input-text', {'input-error': _vm.errors.has('PassportIssuedBy', 'docs')}],attrs:{"name":"PassportIssuedBy","data-vv-scope":"docs","type":"text"},domProps:{"value":(_vm.profile.PassportIssuedBy)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile, "PassportIssuedBy", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"})]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Номер подразделения\n                            "),(_vm.passportFields.PassportIssuedCode)?_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('the-mask',{directives:[{name:"validate",rawName:"v-validate",value:({ rules: { required: this.passportFieldsRequired && _vm.passportFields.PassportIssuedCode} }),expression:"{ rules: { required: this.passportFieldsRequired && passportFields.PassportIssuedCode} }"}],class:['input-text', {'input-error': _vm.errors.has('PassportIssuedCode', 'docs')}],attrs:{"mask":'###-###',"name":"PassportIssuedCode","data-vv-scope":"docs","data-vv-as":"Номер подразделения"},model:{value:(_vm.profile.PassportIssuedCode),callback:function ($$v) {_vm.$set(_vm.profile, "PassportIssuedCode", $$v)},expression:"profile.PassportIssuedCode"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Дата выдачи\n                            "),(_vm.passportFields.PassportIssuedDateFormatted)?_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{directives:[{name:"validate",rawName:"v-validate",value:({ rules: { required: this.passportFieldsRequired && _vm.passportFields.PassportIssuedDateFormatted} }),expression:"{ rules: { required: this.passportFieldsRequired && passportFields.PassportIssuedDateFormatted} }"}],class:['input-text', {'input-error': _vm.errors.has('PassportIssuedDateFormatted', 'docs')}],attrs:{"name":"PassportIssuedDateFormatted","data-vv-scope":"docs"},on:{"input":function($event){return _vm.onChangeDate(_vm.profile, 'PassportIssuedDateFormatted', 'PassportIssuedDate')}},model:{value:(_vm.profile.PassportIssuedDateFormatted),callback:function ($$v) {_vm.$set(_vm.profile, "PassportIssuedDateFormatted", $$v)},expression:"profile.PassportIssuedDateFormatted"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Адрес регистрации\n                            "),(_vm.passportFields.PassportRegistrationAddress)?_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.PassportRegistrationAddress),expression:"profile.PassportRegistrationAddress"},{name:"validate",rawName:"v-validate",value:({ rules: { required: this.passportFieldsRequired && _vm.passportFields.PassportRegistrationAddress} }),expression:"{ rules: { required: this.passportFieldsRequired && passportFields.PassportRegistrationAddress} }"}],class:['input-text', {'input-error': _vm.errors.has('PassportRegistrationAddress', 'docs')}],attrs:{"name":"PassportRegistrationAddress","data-vv-scope":"docs","type":"text"},domProps:{"value":(_vm.profile.PassportRegistrationAddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile, "PassportRegistrationAddress", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"})]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            "+_vm._s(_vm.profile.DocumentType === 2 ? 'ИНН/ИНП/ИИН' : 'ИНН')+"\n                            "),(_vm.passportFields.Inn)?_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.Inn),expression:"profile.Inn"},{name:"validate",rawName:"v-validate",value:({ required: this.passportFieldsRequired && _vm.passportFields.Inn, innfl: _vm.profile.DocumentType !== 2, regex: /^[0-9a-z\u017F\u0430-\u044F\u0451\u1C80-\u1C86\u212A]*$/i }),expression:"{ required: this.passportFieldsRequired && passportFields.Inn, innfl: profile.DocumentType !== 2, regex: /^[a-zа-яё0-9]*$/iu }"}],class:['input-text', {'input-error': _vm.errors.has('INN', 'docs')}],attrs:{"name":"INN","data-vv-as":"ИНН","data-vv-scope":"docs","type":"text"},domProps:{"value":(_vm.profile.Inn)},on:{"blur":function($event){},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile, "Inn", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('INN', 'docs')))])])]),_vm._v(" "),_c('div',{staticClass:"profile-images right",class:['thumbnail-img-block', {'input-error': _vm.errors.has('dropFiles2')}]},[_c('div',{staticClass:"form-field"},[_c('div',{staticClass:"file-upload-zone",staticStyle:{"min-height":"150px"}},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({ rules: { required: this.dropFiles2Required} }),expression:"{ rules: { required: this.dropFiles2Required} }"}],ref:"dropFiles2",staticClass:"file-upload-zone-btn",attrs:{"type":"file","id":"dropFiles2","data-vv-scope":"docs","name":"dropFiles2","accept":".jpg,.jpeg,.png","multiple":""}}),_vm._v(" "),_c('label',{staticClass:"file-upload-zone-lbl",class:{'input-error': _vm.errors.has('dropFiles2', 'docs')},attrs:{"id":"dropFiles2BtnLbl","for":"dropFiles2"}},[_vm._v(_vm._s(_vm.passportFields.dropFilesText))])])]),_vm._v(" "),_c('div',{staticClass:"margin-top-20"},_vm._l((_vm.profile.Images),function(img,i){return _c('div',{staticClass:"thumbnail-img"},[(img.FileData)?_c('img',{attrs:{"src":img.FileData}}):(img.FileName)?_c('img',{attrs:{"src":img.FileName}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"thumbnail-img-delete",on:{"click":function($event){return _vm.removeDocument(i)}}})])}),0)])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{class:['block-in-page', {'notAllowed': _vm.profile.PaymentSettings != null &&
        (_vm.profile.PaymentSettings.VerificationState === _vm.VerificationStates.NeedToCheck || _vm.profile.PaymentSettings.VerificationState === _vm.VerificationStates.Verified) }],style:({display: _vm.tabs.active === 'card' ? 'block' : 'none'})},[(_vm.profile.PaymentSettings.VerificationState === 1)?_c('div',{staticClass:"error"},[_vm._v("\n                Данные банковской карты находятся на проверке\n            ")]):_vm._e(),_vm._v(" "),(_vm.profile.PaymentSettings.VerificationState === 2)?_c('div',{staticClass:"approve"},[_vm._v("\n                Данные банковской карты успешно проверены\n            ")]):_vm._e(),_vm._v(" "),(_vm.profile.PaymentSettings.VerificationState === 3)?_c('div',{staticClass:"error"},[_vm._v("\n                Данные банковской карты были отклонены по следующей причине:\n                "),_c('p',[_vm._v(_vm._s(_vm.profile.PaymentSettings.Comment))])]):_vm._e(),_vm._v(" "),(_vm.errorMessage)?_c('div',{staticClass:"error"},[_vm._v("\n                "+_vm._s(_vm.errorMessage.message)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.errorMessage == null)?_c('div',{staticClass:"profile-edit"},[_c('div',{staticClass:"profile-data"},[_c('div',{staticClass:"margin-bottom-20"},[_vm._v("\n                        Банковская карта должна принадлежать «"+_vm._s([_vm.profile.LastName,_vm.profile.FirstName,_vm.profile.MiddleName].join(' ').trim())+"» – перевод будет\n                        осуществляться на Ваше имя.\n                    ")]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(9),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.PaymentSettings.BankBik),expression:"profile.PaymentSettings.BankBik"},{name:"validate",rawName:"v-validate",value:({ rules: { required: true, bik: true} }),expression:"{ rules: { required: true, bik: true} }"}],class:['input-text', {'input-error': _vm.errors.has('BankBik', 'card')}],attrs:{"name":"BankBik","data-vv-scope":"card","data-vv-as":"БИК банка","type":"text"},domProps:{"value":(_vm.profile.PaymentSettings.BankBik)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile.PaymentSettings, "BankBik", $event.target.value)},_vm.onBankBikChanged]}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('BankBik', 'card')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(10),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.PaymentSettings.BankCorrAccount),expression:"profile.PaymentSettings.BankCorrAccount"},{name:"validate",rawName:"v-validate",value:({ rules: { required: true, cs: _vm.profile.PaymentSettings.BankBik } }),expression:"{ rules: { required: true, cs: profile.PaymentSettings.BankBik } }"}],class:['input-text', {'input-error': _vm.errors.has('BankCorrAccount', 'card')}],attrs:{"name":"BankCorrAccount","data-vv-scope":"card","data-vv-as":"Корреспондентский счёт","type":"text"},domProps:{"value":(_vm.profile.PaymentSettings.BankCorrAccount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile.PaymentSettings, "BankCorrAccount", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('BankCorrAccount', 'card')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(11),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.PaymentSettings.BankName),expression:"profile.PaymentSettings.BankName"},{name:"validate",rawName:"v-validate",value:({ rules: { required: true} }),expression:"{ rules: { required: true} }"}],class:['input-text', {'input-error': _vm.errors.has('BankName', 'card')}],attrs:{"name":"BankName","data-vv-scope":"card","data-vv-as":"Наименование банка","type":"text"},domProps:{"value":(_vm.profile.PaymentSettings.BankName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile.PaymentSettings, "BankName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('BankName', 'card')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_vm._m(12),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profile.PaymentSettings.BankPaymentAccount),expression:"profile.PaymentSettings.BankPaymentAccount"},{name:"validate",rawName:"v-validate",value:({ rules: { required: true, rs: _vm.profile.PaymentSettings.BankBik} }),expression:"{ rules: { required: true, rs: profile.PaymentSettings.BankBik} }"}],class:['input-text', {'input-error': _vm.errors.has('BankPaymentAccount', 'card')}],attrs:{"name":"BankPaymentAccount","data-vv-scope":"card","data-vv-as":"Расчётный счёт","type":"text"},domProps:{"value":(_vm.profile.PaymentSettings.BankPaymentAccount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.profile.PaymentSettings, "BankPaymentAccount", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('BankPaymentAccount', 'card')))])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"block-in-page",style:({display: _vm.tabs.active === 'external' ? 'block' : 'none'})},[(_vm.errorMessage)?_c('div',{staticClass:"error"},[_vm._v("\n                "+_vm._s(_vm.errorMessage.message)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.errorMessage == null)?_c('div',{staticClass:"profile-edit"},[_c('div',{staticClass:"profile-data"},[_c('div',{staticClass:"margin-bottom-20"},[_vm._v("\n                        Способы авторизации\n                    ")]),_vm._v(" "),_vm._l((_vm.external),function(externalItem){return _c('div',{staticClass:"form-field external-login-item"},[_c('a',{attrs:{"href":externalItem.Link,"target":"_blank"}},[_c('img',{attrs:{"src":__webpack_require__(55),"width":"50px"}})]),_vm._v(" "),_c('div',[_c('span',[_vm._v(_vm._s(externalItem.providerName))]),_vm._v(" "),(externalItem.data == null)?_c('a',{attrs:{"href":externalItem.attachLink}},[_vm._v("Привязать")]):_c('a',{staticClass:"red-text",attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();return _vm.onExternalRemove(externalItem)}}},[_vm._v("Отвязать")])])])})],2)]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('popup-window',{ref:"ppPolicy",attrs:{"title":'Политика конфиденциальности сервиса',"width":800,"height":'90%'}},[_c('p',{staticClass:"p-header-1"}),_vm._v(" "),(_vm.info.PolicyFile)?[(_vm.fileExtensionIsHtml(_vm.info.PolicyFile))?_c('iframe',{attrs:{"src":_vm.info.PolicyFile}}):_c('pdf-viewer',{ref:"pdfViewPolicy"})]:_vm._e()],2),_vm._v(" "),_c('popup-window',{ref:"ppRules",attrs:{"title":'Правила программы',"width":800,"height":'90%'}},[_c('p',{staticClass:"p-header-1"}),_vm._v(" "),(_vm.info.RulesFile)?[(_vm.fileExtensionIsHtml(_vm.info.RulesFile))?_c('iframe',{attrs:{"src":_vm.info.RulesFile}}):_c('pdf-viewer',{ref:"pdfViewRules"})]:_vm._e()],2),_vm._v(" "),_c('popup-window',{ref:"ppAvatar",attrs:{"title":'Настройте фото профиля',"width":800},on:{"onClose":function($event){return _vm.onCloseAvatarModal()}}},[_c('p',{staticClass:"p-header-1"}),_vm._v(" "),_c('div',{staticClass:"upload-img-sett"},[(_vm.uploadedFile != null)?_c('img',{staticStyle:{"max-width":"700px"},attrs:{"id":"sourceImage","src":_vm.uploadedFile.FileData}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.onSaveAvatarModal()}}},[_vm._v("Выбрать")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeAvatarModal()}}},[_vm._v("Отмена")])])]),_vm._v(" "),_c('popup-window',{ref:"ppChangePassword",attrs:{"title":'Смена пароля',"width":600}},[_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.password.oldPassword),expression:"password.oldPassword"}],staticClass:"input-text",class:['input-text', {'input-error': _vm.errors.has('PasswordChanging', 'changingPassword')}],attrs:{"name":"PasswordChanging","placeholder":"Старый пароль","type":"password","data-vv-as":"Старый пароль","data-vv-scope":"changingPassword"},domProps:{"value":(_vm.password.oldPassword)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.password, "oldPassword", $event.target.value)},function($event){_vm.password.error = null}]}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('PasswordChanging', 'changingPassword')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"},{name:"model",rawName:"v-model",value:(_vm.password.newPassword),expression:"password.newPassword"}],staticClass:"input-text",class:['input-text', {'input-error': _vm.password.regexError || _vm.errors.has('newPassword', 'changingPassword')}],attrs:{"name":"newPassword","placeholder":"Новый пароль","type":"password","data-vv-as":"Новый пароль","data-vv-scope":"changingPassword"},domProps:{"value":(_vm.password.newPassword)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.password, "newPassword", $event.target.value)},_vm.onNewPasswordChange]}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('newPassword', 'changingPassword'))+_vm._s(_vm.password.regexError))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, confirmed:_vm.password.newPassword}),expression:"{required: true, confirmed:password.newPassword}"},{name:"model",rawName:"v-model",value:(_vm.password.newPasswordConfirm),expression:"password.newPasswordConfirm"}],staticClass:"input-text",class:['input-text', {'input-error': _vm.errors.has('newPasswordConfirm', 'changingPassword')}],attrs:{"name":"newPasswordConfirm","placeholder":"Повторите пароль","type":"password","data-vv-as":"\"Повторите пароль\"","data-vv-scope":"changingPassword"},domProps:{"value":(_vm.password.newPasswordConfirm)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.password, "newPasswordConfirm", $event.target.value)},function($event){_vm.password.error = null}]}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('newPasswordConfirm', 'changingPassword'))+_vm._s(_vm.password.error))])]),_vm._v(" "),_c('div',{staticClass:"form-actions"},[_c('div',{staticClass:"form-btns"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.changePassword()}}},[_vm._v("\n                    Сменить\n                ")])])])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Профиль"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control-block-left"},[_c('p',{staticClass:"caption-help"},[_vm._v("Изменение личных данных")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Имя\n                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Фамилия\n                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Отчество\n                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Email\n                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Телефон\n                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Дата рождения\n                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Пол\n                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Вид документа\n                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            БИК банка\n                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Корреспондентский счёт\n                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Наименование банка\n                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Расчётный счёт\n                            "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Roles_vue__ = __webpack_require__(296);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23530708_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Roles_vue__ = __webpack_require__(829);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Roles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23530708_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Roles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"btn-back caption-help margin-right-10"},[_c('router-link',{attrs:{"to":_vm.$route.query.returnUrl ? _vm.$route.query.returnUrl : ('/projects/' + _vm.$route.params.projectId)}},[_vm._v("Проект")])],1),_vm._v(" "),_c('p',{staticClass:"caption-help margin-right-10"},[_vm._v("\n                    Роли\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page"},[_c('div',{staticClass:"profile-edit block-in-page"},[_c('div',{staticClass:"profile-roles"},[_c('Container',{attrs:{"lock-axis":'y'},on:{"drop":_vm.onDrop}},_vm._l((_vm.rolesOrdered),function(role,i){return _c('Draggable',[_c('div',{staticClass:"draggable-item",on:{"dblclick":function($event){return _vm.onRoleEdit(role)},"click":function($event){return _vm.onRoleSelect(role)}}},[(role.Edited)?[_c('input',{directives:[{name:"model",rawName:"v-model",value:(role.Name),expression:"role.Name"}],staticClass:"input-text",attrs:{"type":"text"},domProps:{"value":(role.Name)},on:{"click":function($event){$event.stopPropagation();},"change":function($event){return _vm.onNameChange(role)},"input":function($event){if($event.target.composing){ return; }_vm.$set(role, "Name", $event.target.value)}}})]:_vm._e(),_vm._v(" "),(!role.Edited)?[_vm._v("\n                                "+_vm._s(role.Name)+"\n                                "),_c('div',{staticClass:"btns flex",staticStyle:{"float":"right","margin-top":"-6px"}},[_c('button',{staticClass:"btn btn-default btn-img",on:{"click":function($event){$event.stopPropagation();return _vm.onRoleEdit(role)}}},[_c('img',{attrs:{"src":__webpack_require__(31),"alt":""}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-img",on:{"click":function($event){$event.stopPropagation();return _vm.removeRole(role, i)}}},[_c('img',{attrs:{"src":__webpack_require__(17),"alt":""}})])])]:_vm._e()],2)])}),1),_vm._v(" "),_c('button',{staticClass:"btn margin-top-10",on:{"click":function($event){$event.stopPropagation();return _vm.addNew.apply(null, arguments)}}},[_vm._v("Добавить")])],1),_vm._v(" "),_c('div',{staticClass:"profile-setting"},[(_vm.roleSelected)?[_c('p',{staticClass:"panel-block-header"},[_vm._v(_vm._s(_vm.roleSelected.Name))]),_vm._v(" "),_c('p',{staticClass:"caption-help"},[_vm._v("Параметры роли")]),_vm._v(" "),_c('ul',{staticClass:"hidden-list margin-top-15"},_vm._l((_vm.claims.filter(function (x) {return x.GroupId === 1 && x.Id !== _vm.claimEnums.mainPageSettings && x.Id !== _vm.claimEnums.reportAdd })),function(claim){return _c('li',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.roleSelected.Claims),expression:"roleSelected.Claims"}],staticClass:"input-checkbox",attrs:{"type":"checkbox","id":'claim' + claim.Id,"disabled":claim.Id === _vm.claimEnums.newRepliesNotification && !_vm.isTasksControllerSelected},domProps:{"value":_vm.bindClaim(claim, _vm.getRoleClaim(_vm.roleSelected, claim.Id)),"checked":Array.isArray(_vm.roleSelected.Claims)?_vm._i(_vm.roleSelected.Claims,_vm.bindClaim(claim, _vm.getRoleClaim(_vm.roleSelected, claim.Id)))>-1:(_vm.roleSelected.Claims)},on:{"change":[function($event){var $$a=_vm.roleSelected.Claims,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.bindClaim(claim, _vm.getRoleClaim(_vm.roleSelected, claim.Id)),$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.roleSelected, "Claims", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.roleSelected, "Claims", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.roleSelected, "Claims", $$c)}},function($event){return _vm.onClaimChange(_vm.roleSelected, claim)}]}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'claim' + claim.Id}},[_vm._v(_vm._s(claim.Name))])])}),0),_vm._v(" "),_c('div',{staticClass:"line-separator"}),_vm._v(" "),_c('p',{staticClass:"caption-help"},[_vm._v("Доступ к меню")]),_vm._v(" "),_c('ul',{staticClass:"hidden-list margin-top-15"},_vm._l((_vm.claims.filter(function (x) {return x.GroupId === 2 || x.Id === _vm.claimEnums.reportAdd;})),function(claim){return _c('li',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.roleSelected.Claims),expression:"roleSelected.Claims"}],staticClass:"input-checkbox",attrs:{"type":"checkbox","id":'claim' + claim.Id},domProps:{"value":_vm.bindClaim(claim, _vm.getRoleClaim(_vm.roleSelected, claim.Id)),"checked":Array.isArray(_vm.roleSelected.Claims)?_vm._i(_vm.roleSelected.Claims,_vm.bindClaim(claim, _vm.getRoleClaim(_vm.roleSelected, claim.Id)))>-1:(_vm.roleSelected.Claims)},on:{"change":[function($event){var $$a=_vm.roleSelected.Claims,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.bindClaim(claim, _vm.getRoleClaim(_vm.roleSelected, claim.Id)),$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.roleSelected, "Claims", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.roleSelected, "Claims", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.roleSelected, "Claims", $$c)}},function($event){return _vm.onClaimChange(_vm.roleSelected)}]}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'claim' + claim.Id}},[_vm._v(_vm._s(claim.Name))]),_vm._v(" "),(claim.HasValue && _vm.getRoleClaim(_vm.roleSelected, claim.Id) != null)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.getRoleClaim(_vm.roleSelected, claim.Id).Value),expression:"getRoleClaim(roleSelected, claim.Id).Value"}],staticClass:"input-text",attrs:{"type":"text"},domProps:{"value":(_vm.getRoleClaim(_vm.roleSelected, claim.Id).Value)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.getRoleClaim(_vm.roleSelected, claim.Id), "Value", $event.target.value)},function($event){return _vm.onClaimChange(_vm.roleSelected)}]}}):_vm._e()])}),0),_vm._v(" "),_c('div',{staticClass:"line-separator"}),_vm._v(" "),_c('p',{staticClass:"caption-help"},[_vm._v("Стартовая страница")]),_vm._v(" "),_c('div',{staticStyle:{"position":"relative"}},[(_vm.getRoleClaim(_vm.roleSelected, _vm.mainPageSettingsClaim.Id) != null)?_c('drop-down',{attrs:{"items":_vm.pages,"dataField":'Path',"textField":'Name'},on:{"change":function($event){return _vm.onClaimChange(_vm.roleSelected)}},model:{value:(_vm.getRoleClaim(_vm.roleSelected, _vm.mainPageSettingsClaim.Id).Value),callback:function ($$v) {_vm.$set(_vm.getRoleClaim(_vm.roleSelected, _vm.mainPageSettingsClaim.Id), "Value", $$v)},expression:"getRoleClaim(roleSelected, mainPageSettingsClaim.Id).Value"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"line-separator"}),_vm._v(" "),(_vm.isRatingSelected)?_c('div',[_c('p',{staticClass:"caption-help"},[_vm._v("Настройка рейтингов")]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Поля адресной программы")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.tradePointFields,"dataField":'Id',"textField":'Name'},on:{"change":function($event){return _vm.onClaimChange(_vm.roleSelected)}},model:{value:(_vm.roleSelected.RatingSettings.TradePointField),callback:function ($$v) {_vm.$set(_vm.roleSelected.RatingSettings, "TradePointField", $$v)},expression:"roleSelected.RatingSettings.TradePointField"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Кол-во на странице")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.roleSelected.RatingSettings.PageSize),expression:"roleSelected.RatingSettings.PageSize"}],staticClass:"input-text",attrs:{"type":"text"},domProps:{"value":(_vm.roleSelected.RatingSettings.PageSize)},on:{"change":function($event){return _vm.onClaimChange(_vm.roleSelected)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.roleSelected.RatingSettings, "PageSize", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Рейтинг по-умолчанию")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.project.RatingRoles,"dataField":'Value',"textField":'Name',"withSelectItem":'true'},on:{"change":function($event){return _vm.onClaimChange(_vm.roleSelected)}},model:{value:(_vm.roleSelected.RatingSettings.DefaultProjectRatingRole),callback:function ($$v) {_vm.$set(_vm.roleSelected.RatingSettings, "DefaultProjectRatingRole", $$v)},expression:"roleSelected.RatingSettings.DefaultProjectRatingRole"}})],1)]):_vm._e()]:_vm._e()],2)])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":"Роли"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cart_vue__ = __webpack_require__(297);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab60df66_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cart_vue__ = __webpack_require__(833);
function injectStyle (ssrContext) {
  __webpack_require__(831)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ab60df66"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab60df66_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(832);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6835e43c", content, true, {});

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".table-view thead[data-v-ab60df66]{display:table-header-group}", ""]);

// exports


/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[(_vm.info.User && _vm.info.ProjectsLength > 1)?_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('project-select',{attrs:{"user":_vm.info.User},on:{"onChange":_vm.onProjectChange}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page",on:{"scroll":_vm.onScroll}},[_c('div',{staticClass:"block-in-page"},[(!_vm.items.length)?_c('div',[_c('p',{staticClass:"input-text-lbl"},[_vm._v("Выберите вознаграждения в разделе «"+_vm._s(_vm.getPageTitle('/spend-bonuses'))+"»")])]):_vm._e(),_vm._v(" "),(_vm.items.length > 0)?_c('div',[_c('h2',{staticClass:"margin-bottom-20"},[_vm._v("Подтверждение выбранных вознаграждений")]),_vm._v(" "),(_vm.isMobile)?_c('div',_vm._l((_vm.items),function(item){return _c('div',{staticClass:"table-div"},[_c('div',{staticStyle:{"font-weight":"600","font-size":"14px"}},[_vm._v(_vm._s(item.Name))]),_vm._v(" "),_c('div',{staticClass:"flex margin-top-2"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v("Номинал")]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"right"}},[_vm._v(_vm._s(item.Price))])]),_vm._v(" "),_c('div',{staticClass:"flex margin-top-2"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v("Количество")]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"right"}},[(item.RewardType !== 1 && item.RewardType !== 2)?_c('touch-spin',{on:{"change":function($event){return _vm.onCountChange(item)}},model:{value:(item.Count),callback:function ($$v) {_vm.$set(item, "Count", _vm._n($$v))},expression:"item.Count"}}):_vm._e(),_vm._v(" "),(item.RewardType === 1 || item.RewardType === 2)?[_vm._v("\n                                    "+_vm._s(item.Count)+"\n                                ")]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"flex margin-top-2"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v("Сумма")]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"right"}},[_vm._v(_vm._s((item.Price * item.Count).toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"margin-top-5",staticStyle:{"text-align":"right"}},[_c('button',{staticClass:"btn btn-default btn-img",staticStyle:{"display":"initial"},attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onRemoveItem(item)}}},[_c('img',{attrs:{"src":__webpack_require__(17),"alt":""}})])])])}),0):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('table',{staticClass:"table-view margin-top-10",attrs:{"id":"dataTable","cellspacing":"0"}},[_vm._m(0),_vm._v(" "),_c('tbody',[_vm._l((_vm.items),function(item){return _c('tr',[_c('td',[_vm._v(_vm._s(item.Name))]),_vm._v(" "),_c('td',{staticClass:"value"},[_vm._v(_vm._s(item.Price))]),_vm._v(" "),_c('td',{staticClass:"value"},[(item.RewardType !== 1 && item.RewardType !== 2)?_c('touch-spin',{on:{"change":function($event){return _vm.onCountChange(item)}},model:{value:(item.Count),callback:function ($$v) {_vm.$set(item, "Count", _vm._n($$v))},expression:"item.Count"}}):_vm._e(),_vm._v(" "),(item.RewardType === 1 || item.RewardType === 2)?[_vm._v("\n                                    "+_vm._s(item.Count)+"\n                                ")]:_vm._e()],2),_vm._v(" "),_c('td',{staticClass:"value"},[_vm._v("\n                                "+_vm._s((item.Price * item.Count).toFixed(2))+"\n                            ")]),_vm._v(" "),_c('td',{staticClass:"obtn"},[_c('button',{staticClass:"btn btn-default btn-img",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onRemoveItem(item)}}},[_c('img',{attrs:{"src":__webpack_require__(17),"alt":""}})])])])}),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"4"}},[_c('strong',[_vm._v("Итого: "+_vm._s(_vm.getTotalPrice().toFixed(2)))])]),_vm._v(" "),_c('td')])],2)]):_vm._e(),_vm._v(" "),(_vm.info.User && _vm.info.User.ActiveBalanceWithOrders < _vm.getTotalPrice())?_c('div',{staticClass:"margin-top-15"},[_c('span',{staticClass:"error"},[_vm._v("\n                        Стоимость вознаграждения превышает количество баллов, доступных для оплаты.\n                    ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"margin-top-15"},[_c('button',{staticClass:"btn",attrs:{"type":"button","disabled":_vm.info.User && _vm.info.User.ActiveBalanceWithOrders < _vm.getTotalPrice()},on:{"click":function($event){return _vm.makeOrder()}}},[_vm._v("\n                        Оформить заказ\n                    ")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"block-in-page"},[(_vm.orders.length)?_c('div',[_c('h2',{staticClass:"margin-bottom-20"},[_vm._v("Подтвержденные вознаграждения")]),_vm._v(" "),(_vm.isMobile)?_c('div',_vm._l((_vm.orders),function(order){return _c('div',{staticClass:"table-div"},[_c('div',{staticClass:"caption-help"},[_vm._v("\n                            "+_vm._s(_vm.formatDate(order.CreateDate, 'DD.MM.YYYY HH:mm'))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"flex margin-top-5"},[_c('div',{staticStyle:{"width":"50%","font-weight":"600","font-size":"14px"}},[_vm._v(_vm._s(order.Reward.Name))]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"right"}},[_vm._v(_vm._s(order.Count)+" шт.")])]),_vm._v(" "),_c('div',{staticClass:"flex margin-top-2"},[_c('div',{staticStyle:{"width":"50%"}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.getOrderStatus(order))}})]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"right"}},[_vm._v(_vm._s((order.Amount).toFixed(2)))])]),_vm._v(" "),(order.Status === 1 || order.Status === 4 || order.Status === 5)?_c('div',{staticClass:"margin-top-5"},[(order.Reward.RewardType === 1 && (order.Status === 4 || order.Status === 5))?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.receiveOrder(order)}}},[_vm._v("\n                                Скачать\n                            ")]):_vm._e(),_vm._v(" "),(order.Reward.RewardType === 2 && order.Status === 4)?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.receiveOrder(order)}}},[_vm._v("\n                                Карта получена\n                            ")]):_vm._e(),_vm._v(" "),(order.Status === 1)?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeOrder(order)}}},[_vm._v("\n                                Отменить заказ\n                            ")]):_vm._e()]):_vm._e()])}),0):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('table',{staticClass:"table-view",attrs:{"cellspacing":"0"}},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.orders),function(order){return _c('tr',[_c('td',{staticClass:"datetime"},[_vm._v(_vm._s(_vm.formatDate(order.CreateDate, 'DD.MM.YYYY HH:mm')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(order.Reward.Name))]),_vm._v(" "),_c('td',{staticClass:"value-center"},[_vm._v(_vm._s(order.Count))]),_vm._v(" "),_c('td',{staticClass:"value-center"},[_vm._v("\n                                "+_vm._s((order.Amount).toFixed(2))+"\n                            ")]),_vm._v(" "),_c('td',{staticClass:"state"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.getOrderStatus(order))}})]),_vm._v(" "),_c('td',{staticClass:"obtn"},[(order.Reward.RewardType === 1 && (order.Status === 4 || order.Status === 5))?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.receiveOrder(order)}}},[_vm._v("\n                                    Скачать\n                                ")]):_vm._e(),_vm._v(" "),(order.Reward.RewardType === 2 && order.Status === 4)?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.receiveOrder(order)}}},[_vm._v("\n                                    Карта получена\n                                ")]):_vm._e(),_vm._v(" "),(order.Status === 1)?_c('button',{staticClass:"btn btn-img",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeOrder(order)}}},[_c('img',{attrs:{"src":__webpack_require__(17),"alt":""}})]):_vm._e()])])}),0)]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":_vm.getPageTitle()}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"heading"},[_c('th',[_vm._v("Наименование")]),_vm._v(" "),_c('th',[_vm._v("Номинал")]),_vm._v(" "),_c('th',[_vm._v("Кол-во")]),_vm._v(" "),_c('th',[_vm._v("Сумма")]),_vm._v(" "),_c('th')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"heading"},[_c('th',[_vm._v("Дата размещения")]),_vm._v(" "),_c('th',[_vm._v("Наименование")]),_vm._v(" "),_c('th',[_vm._v("Кол-во")]),_vm._v(" "),_c('th',[_vm._v("Сумма")]),_vm._v(" "),_c('th',[_vm._v("Статус")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Orders_vue__ = __webpack_require__(298);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dfca259_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Orders_vue__ = __webpack_require__(837);
function injectStyle (ssrContext) {
  __webpack_require__(835)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5dfca259"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Orders_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dfca259_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Orders_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(836);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("74bc0fc0", content, true, {});

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".table-view thead[data-v-5dfca259]{display:table-header-group}.table-view td.state .certificate[data-v-5dfca259]{align-items:center;margin-top:5px}.info-error[data-v-5dfca259]{border:1px solid #ef0348;border-radius:15px}", ""]);

// exports


/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"body-panel-control-separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[(_vm.info.ProjectsLength > 1)?_c('project-select',{attrs:{"user":_vm.info.User},on:{"onChange":_vm.onProjectChange}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field margin-right-10"},[_c('drop-down',{attrs:{"items":[{Id: 1, Name: 'Дата размещения'},{Id: 4, Name: 'Дата выдачи'},{Id: 5, Name: 'Дата скачивания'}],"dataField":'Id',"textField":'Name'},on:{"change":_vm.reload},model:{value:(_vm.orderDateTypeId),callback:function ($$v) {_vm.orderDateTypeId=$$v},expression:"orderDateTypeId"}})],1),_vm._v(" "),_c('div',{staticClass:"input-date-lbl margin-right-10"},[_c('input-date',{staticClass:"input-text input-date",attrs:{"name":"dateStart"},on:{"input":_vm.reload},model:{value:(_vm.dateStart),callback:function ($$v) {_vm.dateStart=$$v},expression:"dateStart"}})],1),_vm._v(" "),_c('span',{staticClass:"margin-right-10 margin-top-5"},[_vm._v("-")]),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{staticClass:"input-text input-date",attrs:{"name":"dateEnd"},on:{"input":_vm.reload},model:{value:(_vm.dateEnd),callback:function ($$v) {_vm.dateEnd=$$v},expression:"dateEnd"}})],1),_vm._v(" "),(_vm.dateStart || _vm.dateEnd)?_c('div',{staticClass:"form-field margin-left-20"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.clearFilterDate}},[_vm._v("Сбросить")])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[_c('div',{staticClass:"btns flex"},[(_vm.selectedOrders.length)?_c('div',{staticStyle:{"margin":"auto 10px"}},[_vm._v("\n                            Выбрано "+_vm._s(_vm.selectedOrders.length)+" из "+_vm._s(_vm.totalOrders)+"\n                        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.onExport()}}},[_vm._v("\n                            Экспорт\n                        ")]),_vm._v(" "),(_vm.showProcessAll)?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.processSelected.apply(null, arguments)}}},[_vm._v("\n                            В работу\n                        ")]):_vm._e(),_vm._v(" "),(_vm.showCompleteAll)?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.completeSelected.apply(null, arguments)}}},[_vm._v("\n                            Выдать\n                        ")]):_vm._e(),_vm._v(" "),(_vm.showGetGifteryAll)?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.makeGifteryOrder(null)}}},[_vm._v("\n                            Получить сертификат\n                        ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"body-panel-control-separator"},[_c('complex-filter',{ref:"complexFilter",attrs:{"filters":_vm.filters,"searchFunction":_vm.searchFunction,"tableName":'[dbo].[TradePoint]',"withTableNameInClause":true,"getByIdFilters":['User','OrderStatus']},on:{"onFilterChange":_vm.onFilterChange}}),_vm._v(" "),_c('button',{staticClass:"btn",staticStyle:{"display":"none"},attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onMarkupTest.apply(null, arguments)}}},[_vm._v("\n                    Тест вёрстки\n                ")])],1)]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page scroll-x-ok",on:{"scroll":_vm.onScroll}},[(_vm.rewardTypes.length)?_c('div',{staticClass:"flex btns margin-bottom-10"},[_c('button',{class:['btn', {'active': _vm.rewardTypeId === 0 }],attrs:{"type":"button"},on:{"click":function($event){_vm.rewardTypeId = 0}}},[_vm._v("Все")]),_vm._v(" "),_vm._l((_vm.rewardTypes),function(type){return _c('button',{class:['btn', {'active': _vm.rewardTypeId === type }],attrs:{"type":"button"},on:{"click":function($event){_vm.rewardTypeId = type}}},[_vm._v("\n                    "+_vm._s(_vm.getRewardTypeName(type))+"\n                ")])})],2):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table-view",attrs:{"cellspacing":"0"}},[_c('thead',[_c('tr',{staticClass:"heading"},[_c('th',{staticClass:"check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectAll),expression:"selectAll"}],staticClass:"input-checkbox",attrs:{"id":"selectAll","name":"selectAll","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectAll)?_vm._i(_vm.selectAll,"true")>-1:(_vm.selectAll)},on:{"change":[function($event){var $$a=_vm.selectAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectAll=$$c}},_vm.onSelectAllChange]}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"selectAll"}})]),_vm._v(" "),_c('th',[_vm._v("Дата")]),_vm._v(" "),_c('th',[_vm._v("Пользователь")]),_vm._v(" "),_c('th',[_vm._v("Баланс")]),_vm._v(" "),_c('th',[_vm._v("Вознаграждение")]),_vm._v(" "),_c('th',[_vm._v("Количество")]),_vm._v(" "),_c('th',[_vm._v("Сумма")]),_vm._v(" "),_c('th',[_vm._v("Статус")]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',_vm._l((_vm.orders),function(order,i){return _c('tr',[_c('td',{staticClass:"check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedOrders),expression:"selectedOrders"}],staticClass:"input-checkbox",attrs:{"id":'select' + i,"type":"checkbox"},domProps:{"value":order,"checked":Array.isArray(_vm.selectedOrders)?_vm._i(_vm.selectedOrders,order)>-1:(_vm.selectedOrders)},on:{"change":function($event){var $$a=_vm.selectedOrders,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=order,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedOrders=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedOrders=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedOrders=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'select' + i}})]),_vm._v(" "),_c('td',{staticClass:"datetime-2"},[_c('p',{staticStyle:{"white-space":"nowrap"}},[_c('span',[_vm._v("Создан ")]),_vm._v(_vm._s(_vm.formatDate(order.CreateDate, 'DD.MM.YYYY HH:mm')))]),_vm._v(" "),_c('p',{staticStyle:{"white-space":"nowrap"}},[_c('span',[_vm._v("Выдан ")]),_vm._v(_vm._s(_vm.formatDate(order.FirstCompleteDate, 'DD.MM.YYYY HH:mm')))]),_vm._v(" "),(order.Reward.RewardType	 !== 3 && order.Reward.RewardType !== 4)?_c('p',{staticStyle:{"white-space":"nowrap"}},[_c('span',[_vm._v("Скачан ")]),_vm._v(_vm._s(_vm.formatDate(order.FirstRecievedDate, 'DD.MM.YYYY HH:mm'))+"\n                            ")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"string"},[_vm._v("#"+_vm._s(order.Id)+" "+_vm._s(order.UserFio))]),_vm._v(" "),_c('td',{staticClass:"valueshort"},[_vm._v(_vm._s(_vm.formatInt(order.UserActiveBalance)))]),_vm._v(" "),_c('td',{staticClass:"datetime string"},[_vm._v("\n                            "+_vm._s(order.Reward.Name)+"\n                            "),(order.Reward.GifteryId)?_c('span',{staticStyle:{"font-style":"italic"}},[_vm._v("(Giftery)")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"valueshort"},[_vm._v(_vm._s(order.Count))]),_vm._v(" "),_c('td',{staticClass:"valueshort"},[_vm._v(_vm._s(_vm.formatInt((order.Amount).toFixed(0))))]),_vm._v(" "),_c('td',{staticClass:"state"},[_c('span',{staticClass:"margin-right-5"},[_vm._v(_vm._s(_vm.getOrderStatus(order)))]),_vm._v(" "),(order.Reward.RewardType === 1 && order.ExtraData)?[_c('button',{staticClass:"btn btn-img",staticStyle:{"display":"inline-block"},attrs:{"type":"button","title":"Просмотр сертификата"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onShowExtraDataModal(order.ExtraData, order.Reward.OzonCertificate)}}},[_c('img',{attrs:{"src":__webpack_require__(838),"alt":""}})]),_vm._v(" "),(order.Status === 6 && !order.Reward.GifteryId)?_c('button',{staticClass:"btn btn-img",staticStyle:{"display":"inline-block"},attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onCertificateDelete(order.Id)}}},[_c('img',{attrs:{"src":__webpack_require__(17),"alt":""}})]):_vm._e()]:_vm._e(),_vm._v(" "),(order.Status === 2 && order.Reward.RewardType === 1 && !order.ExtraData)?[(order.Reward.GifteryId)?[_c('button',{staticClass:"btn btn-img",staticStyle:{"display":"inline-block"},attrs:{"type":"button","title":"Получить сертификат"},on:{"click":function($event){$event.stopPropagation();return _vm.makeGifteryOrder(order.Id, order.CreateDate)}}},[_c('img',{attrs:{"src":__webpack_require__(167),"alt":""}})])]:(order.Reward.OzonCertificate)?[_c('button',{staticClass:"btn btn-img",staticStyle:{"display":"inline-block"},attrs:{"type":"button","title":"Получить сертификат"},on:{"click":function($event){$event.stopPropagation();return _vm.makeOzonOrder(order)}}},[_c('img',{attrs:{"src":__webpack_require__(167),"alt":""}})])]:[_c('input',{ref:'dropFiles' + i,refInFor:true,staticClass:"file-upload-zone-btn",attrs:{"type":"file","accept":".pdf","id":'dropFiles' + i,"name":'dropFiles' + i},on:{"change":function($event){return _vm.onCertificateChange(order.Id, 'dropFiles' + i)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-img",staticStyle:{"display":"inline-block"},attrs:{"type":"button","title":"Загрузить сертификат"},on:{"click":function($event){return _vm.onCertificateClick('dropFiles' + i)}}},[_c('img',{attrs:{"src":__webpack_require__(167),"alt":""}})])]]:_vm._e(),_vm._v(" "),(order.Status === _vm.OrderStatuses.GifteryDelayed)?[_c('img',{staticStyle:{"display":"inline-block"},attrs:{"src":__webpack_require__(839),"title":"Нажмите для дополнительной информации"},on:{"click":function($event){$event.stopPropagation();return _vm.showGifteryOrderHistory(order)}}})]:_vm._e()],2),_vm._v(" "),_c('td',{staticClass:"obtn-short"},[_c('div',{staticClass:"btns-col"},[(order.Status === 1)?_c('button',{staticClass:"btn btn-img",attrs:{"type":"button","title":"Принять в работу"},on:{"click":function($event){return _vm.processOrder([order.Id])}}},[_c('img',{attrs:{"src":__webpack_require__(840),"alt":""}})]):_vm._e(),_vm._v(" "),(order.Status === 1 || order.Status === 2 || order.Status === 8)?_c('button',{staticClass:"btn btn-img",attrs:{"type":"button","title":"Отказать"},on:{"click":function($event){$event.stopPropagation();return _vm.cancelOrderModal(order)}}},[_c('img',{attrs:{"src":__webpack_require__(841),"alt":""}})]):_vm._e(),_vm._v(" "),(order.Status === 6 && order.Reward.RewardType === 1 && order.ExtraData)?_c('button',{staticClass:"btn btn-img",attrs:{"type":"button","title":"Выдать сертификат пользователю"},on:{"click":function($event){return _vm.completeOrder([order.Id])}}},[_c('img',{attrs:{"src":__webpack_require__(43),"alt":""}})]):_vm._e(),_vm._v(" "),(order.Status === 2 && (order.Reward.RewardType === 2 || order.Reward.RewardType === 3 || order.Reward.RewardType === 4))?_c('button',{staticClass:"btn btn-img",attrs:{"type":"button","title":_vm.getCompleteBtnTitle(order)},on:{"click":function($event){return _vm.completeOrder([order.Id])}}},[_c('img',{attrs:{"src":__webpack_require__(43),"alt":""}})]):_vm._e(),_vm._v(" "),(order.Status === 1 && order.Reward.RewardType === 4)?_c('button',{staticClass:"btn btn-img",style:({'border-color': (order.AddressConfirmed ? 'green' : 'red') + ' !important'}),attrs:{"type":"button","title":'Адрес доставки'},on:{"click":function($event){return _vm.onAddressModalOpen(order)}}},[_c('img',{attrs:{"src":__webpack_require__(842),"alt":""}})]):_vm._e(),_vm._v(" "),(order.Status === 4 && order.Reward.RewardType === 4)?_c('button',{staticClass:"btn btn-img",attrs:{"type":"button","title":"Получен"},on:{"click":function($event){$event.stopPropagation();return _vm.receiveOrderModal(order)}}},[_c('img',{attrs:{"src":__webpack_require__(843),"alt":""}})]):_vm._e()])])])}),0)])]),_vm._v(" "),_c('popup-window',{ref:"ppCancelModal",attrs:{"title":'Отмена заказа'}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                    Напишите причину отказа\n                ")]),_vm._v(" "),_c('textarea',{ref:"Comment",staticClass:"input-memo",staticStyle:{"height":"150px","width":"100%"},attrs:{"name":"Comment","rows":"10"}})]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.cancelOrder()}}},[_vm._v("Готово")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeModal('ppCancelModal')}}},[_vm._v("Отмена")])])]),_vm._v(" "),_c('popup-window',{ref:"ppActionModal",attrs:{"title":'Обработка заказов',"modal":true}},[_c('div',{staticClass:"form-group"},[(!_vm.actionState.done)?_c('p',[_vm._v("\n                    Заказ "+_vm._s(_vm.actionState.currentOrder.index)+" / "+_vm._s(_vm.actionState.total)+" от "+_vm._s(_vm.formatDate(_vm.actionState.currentOrder.date, 'DD.MM.YYYY HH:mm'))+" в процессе "+_vm._s(_vm.actionState.currentOrder.time)+" сек.\n                ")]):_c('p',[(_vm.actionState.doneMessage)?[_vm._v("\n                        "+_vm._s(_vm.actionState.doneMessage)+"\n                    ")]:[_vm._v("\n                        Обработка завершена\n                    ")]],2),_vm._v(" "),_c('div',{staticClass:"margin-top-20",staticStyle:{"max-height":"300px","overflow":"auto"}},_vm._l((_vm.actionState.messages),function(m){return _c('p',{staticClass:"caption-help",style:(m.error ? 'color:red': '')},[_vm._v("\n                        "+_vm._s(m.message)+"\n                    ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[(_vm.actionState.done || _vm.actionState.test)?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.ppActionModalClose}},[_vm._v("Закрыть")]):_vm._e()])]),_vm._v(" "),_c('popup-window',{ref:"ppExtraData",attrs:{"title":'Сертификат',"modal":true,"width":800}},[_c('div',{ref:"ppExtraDataContainer",staticStyle:{"height":"300px"}}),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeModal('ppExtraData')}}},[_vm._v("Закрыть")])])]),_vm._v(" "),_c('popup-window',{ref:"ppAddress",attrs:{"title":'Адрес доставки',"modal":true,"width":800},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('div',{staticClass:"popup-footer"},[_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeModal('ppAddress')}}},[_vm._v("Закрыть")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.onAddressConfirm}},[_vm._v("Подтвердить адрес")])])])]},proxy:true}])},[(_vm.address.data != null)?[(_vm.address.list.length > 1)?_c('div',{staticClass:"form-field"},[_c('drop-down',{attrs:{"items":_vm.address.list,"dataField":'Id',"textField":'DisplayAddress'},on:{"change":_vm.onAddressChange},model:{value:(_vm.address.addressId),callback:function ($$v) {_vm.$set(_vm.address, "addressId", $$v)},expression:"address.addressId"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Получатель")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"},{name:"model",rawName:"v-model",value:(_vm.address.data.Fio),expression:"address.data.Fio"}],class:['input-text', {'input-error': _vm.errors.has('addressFio', 'address')}],attrs:{"name":"addressFio","type":"text","data-vv-as":"Фио","data-vv-scope":"address"},domProps:{"value":(_vm.address.data.Fio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address.data, "Fio", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('addressFio')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Телефон")]),_vm._v(" "),_c('the-mask',{directives:[{name:"validate",rawName:"v-validate",value:({ required: true, regex: /^\d{11}$/ }),expression:"{ required: true, regex: /^\\d{11}$/ }"}],class:['input-text', {'input-error': _vm.errors.has('addressPhoneNumber', 'address')}],attrs:{"mask":'# (###) ###-##-##',"name":"addressPhoneNumber","data-vv-scope":"address","data-vv-as":"Телефон"},model:{value:(_vm.address.data.PhoneNumber),callback:function ($$v) {_vm.$set(_vm.address.data, "PhoneNumber", $$v)},expression:"address.data.PhoneNumber"}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('addressPhoneNumber')))])],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Адрес")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true}),expression:"{required: true}"},{name:"model",rawName:"v-model",value:(_vm.address.data.FullAddress),expression:"address.data.FullAddress"}],class:['input-text', {'input-error': _vm.errors.has('addressFullAddress', 'address')}],attrs:{"name":"addressFullAddress","type":"text","data-vv-as":"Адрес","data-vv-scope":"address"},domProps:{"value":(_vm.address.data.FullAddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address.data, "FullAddress", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"})])]:_vm._e()],2),_vm._v(" "),_c('popup-window',{ref:"ppReceiveOrder",attrs:{"title":'Получение заказа',"modal":true}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                    Отметьте дату получения\n                    "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-text', {'input-error': _vm.errors.has('ReceiveDateFormatted', 'receive')}],attrs:{"name":"ReceiveDateFormatted","data-vv-scope":"receive","data-vv-as":"Дата получения"},on:{"input":function($event){return _vm.onChangeReceiveDate()}},model:{value:(_vm.receiveDateFormatted),callback:function ($$v) {_vm.receiveDateFormatted=$$v},expression:"receiveDateFormatted"}})],1)]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.receiveOrder()}}},[_vm._v("Готово")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeModal('ppReceiveOrder')}}},[_vm._v("Отмена")])])]),_vm._v(" "),_c('popup-window',{ref:"ppOrderHistory",attrs:{"title":'История получения заказа',"modal":true,"width":800}},[_c('div',{staticClass:"margin-bottom-10"},[_c('p',[_vm._v("Сертификат: "),_c('b',[_vm._v(_vm._s(_vm.orderHistory.sert_name))]),_vm._v(", номинал: "),_c('b',[_vm._v(_vm._s(_vm.orderHistory.sert_nominal))])])]),_vm._v(" "),_c('div',{staticClass:"margin-bottom-10"},[_vm._v("\n                "+_vm._s(_vm.getDelayedTitle(_vm.orderHistory.id))+"\n                "),(_vm.orderHistory.nextTryingDate)?_c('p',[_vm._v("\n                    Следующая попытка получить: "+_vm._s(_vm._f("date-long")(_vm.orderHistory.nextTryingDate))+"\n                ")]):_vm._e()]),_vm._v(" "),(_vm.orderHistory.data !== null && _vm.orderHistory.data[0].StatusId === _vm.OrderStatuses.OrdersMonitoringTry)?_c('div',[_c('button',{staticClass:"btn btn-primary margin-top-10",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onCheckGiftery(_vm.orderHistory.data[0].GifteryId)}}},[_vm._v("Проверить доступные номиналы")]),_vm._v(" "),(_vm.orderHistory.giftery.loading)?_c('span',[_vm._v("Идёт загрузка...")]):(_vm.orderHistory.giftery.data)?_c('div',{staticClass:"margin-top-5"},[_vm._v("\n                    В данный момент доступны: "+_vm._s(_vm.orderHistory.giftery.data.join(', '))+"\n                ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.orderHistory.data == null)?_c('div',[_vm._v("\n                Идёт загрузка...\n            ")]):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table-view margin-top-20"},[_c('thead',{staticStyle:{"display":"table-header-group !important"}},[_c('tr',[_c('th',[_vm._v("Дата")]),_vm._v(" "),_c('th',[_vm._v("Статус")]),_vm._v(" "),_c('th',[_vm._v("Комментарий")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.orderHistory.data),function(item,u){return _c('tr',[_c('td',[_vm._v("\n                            "+_vm._s(_vm._f("date-long")(item.ActionDate))+"\n                        ")]),_vm._v(" "),_c('td',[_vm._v("\n                            "+_vm._s(_vm.getOrderStatus({Status: item.StatusId}))+"\n                        ")]),_vm._v(" "),_c('td',[(item.GifteryQueueId)?_c('div',[_vm._v("Id заявки в Giftery: "+_vm._s(item.GifteryQueueId))]):_vm._e(),_vm._v(" "),(item.GifteryQueueId)?_c('div',[_vm._v("Id вознаграждения в Giftery: "+_vm._s(item.GifteryId))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"margin-top-5"},[_vm._v(_vm._s(item.Comment))])])])}),0)]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs['ppOrderHistory'].close()}}},[_vm._v("Ok")])])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":_vm.getPageTitle()}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon-rep.png?6de7e84e5df93a95f8ed74fa351eac2f";

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon-info.png?39210b744aba540a3aa945f78e0d64b6";

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon-flag.png?b72b6c56a0d63a735fa5cbd88d26e37f";

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon-close.png?5770202fecb1913aa90b351f127f1bba";

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon-home.png?aef526907d150a84f8c09513fdde8ebc";

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon-date.png?aa418b316af24ff8655b403050f93ef9";

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BonusHistory_vue__ = __webpack_require__(299);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc4a9852_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BonusHistory_vue__ = __webpack_require__(847);
function injectStyle (ssrContext) {
  __webpack_require__(845)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fc4a9852"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BonusHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc4a9852_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BonusHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(846);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2b8f8736", content, true, {});

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[_c('div',{staticClass:"body-panel-control separator"},[(_vm.info.User)?_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex mob-inline"},[_c('p',{staticClass:"btn-back margin-right-10"},[_c('a',{staticClass:"router-link-active",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.back.apply(null, arguments)}}},[_vm._v("Назад")])]),_vm._v(" "),_c('div',{staticClass:"form-field margin-right-10"},[_c('drop-down',{attrs:{"items":[{Id: '', Name: 'Все'},
                            {Id: 10, Name: 'Начисление'},
                            {Id: 20, Name: 'Возврат'},
                            {Id: 21, Name: 'Расход'},
                            {Id: 22, Name: 'Отмена отчёта'},
                            {Id: 23, Name: 'Заморозка баллов'}],"dataField":'Id',"textField":'Name'},on:{"change":_vm.historyReload},model:{value:(_vm.bonusOperationTypeId),callback:function ($$v) {_vm.bonusOperationTypeId=$$v},expression:"bonusOperationTypeId"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('p',{staticClass:"menu-item-info grey",staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(_vm.formatInt(_vm.total || 0)))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[_c('div',{staticClass:"flex mob-inline"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.onExport}},[_vm._v("Экспорт")])])]),_vm._v(" "),_c('div',{staticClass:"body-panel-control-separator flex"},[_c('complex-filter',{ref:"complexFilter",attrs:{"filters":_vm.monthFilters,"searchFunction":_vm.searchFunction},on:{"onFilterChange":_vm.onFilterChange}})],1),_vm._v(" "),_c('div',{staticClass:"body-panel-control-separator flex"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"input-text",attrs:{"type":"text","placeholder":"Поиск"},domProps:{"value":(_vm.search)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.search=$event.target.value},function($event){return _vm.onSearchChange()}]}})])]),_vm._v(" "),(_vm.project != null)?_c('div',{staticClass:"body-panel-content body-panel-content-page"},[(_vm.info.User && _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.bonusSpend) && _vm.project.RewardUnitTypeId === 1)?_c('div',{staticClass:"block-in-page"},[_c('div',{staticStyle:{"height":"250px"}},[_c('chart',{attrs:{"chartData":_vm.chartData,"chartOptions":_vm.chartOptions}})],1)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('div',{staticClass:"block-in-page"},_vm._l((_vm.data),function(item){return _c('div',{class:['table-div', {'': item.BonusOperationTypeId === 0, 'ball-add': item.BonusOperationTypeId === 10, 'ball-off': item.BonusOperationTypeId !== 10, 'ball-used': item.BonusSpent, 'ball-burned': item.BonusBurned}]},[_c('div',{staticClass:"caption-help"},[_vm._v("\n                    "+_vm._s(_vm.formatDate(item.CreateDate, 'DD.MM.YYYY HH:mm'))+", "+_vm._s(item.OperationTypeName)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"flex margin-top-5",staticStyle:{"font-weight":"600","font-size":"14px"}},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v("Сумма")]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"right"}},[_vm._v(_vm._s(_vm.formatInt(item.Amount)))])]),_vm._v(" "),_c('div',{staticClass:"flex margin-top-2"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v("Дата активации")]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"right"}},[_vm._v(_vm._s(_vm.formatDate(item.BonusStartDate, 'DD.MM.YYYY HH:mm')))])]),_vm._v(" "),_c('div',{staticClass:"flex margin-top-2"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v("Дата сгорания")]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"right"}},[_vm._v(_vm._s(_vm.formatDate(item.BonusEndDate, 'DD.MM.YYYY HH:mm')))])]),_vm._v(" "),_c('div',{staticClass:"caption-help margin-top-2"},[_vm._v("\n                    "+_vm._s(item.TradePointName)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"caption-help margin-top-2"},[_vm._v("\n                    "+_vm._s(item.Comment)+"\n                ")])])}),0):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('table',{staticClass:"table-view margin-top-20"},[_c('thead',{staticClass:"head-show"},[_c('tr',{staticStyle:{"text-align":"center"}},[_c('th',[_vm._v("Тип операции")]),_vm._v(" "),_c('th',{staticClass:"value-center"},[_vm._v("Кол-во")]),_vm._v(" "),_c('th',{staticClass:"datetime"},[_vm._v("Дата операции")]),_vm._v(" "),(_vm.project.RewardUnitTypeId === 1)?_c('th',{staticClass:"datetime"},[_vm._v("Дата активации")]):_vm._e(),_vm._v(" "),(_vm.project.RewardUnitTypeId === 1)?_c('th',{staticClass:"datetime"},[_vm._v("Дата сгорания")]):_vm._e(),_vm._v(" "),_c('th',[_vm._v("Торговая точка")]),_vm._v(" "),_c('th',[_vm._v("Комментарий")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',{class:{'ball-add': item.BonusOperationTypeId === 10, 'ball-off': item.BonusOperationTypeId !== 10, 'ball-used': item.BonusSpent, 'ball-burned': item.BonusBurned}},[_c('td',[_vm._v(_vm._s(item.OperationTypeName))]),_vm._v(" "),_c('td',{staticClass:"value-center"},[_vm._v(_vm._s(_vm.formatInt(item.Amount)))]),_vm._v(" "),_c('td',{staticClass:"datetime"},[_vm._v(_vm._s(_vm.formatDate(item.CreateDate, 'DD.MM.YYYY HH:mm')))]),_vm._v(" "),(_vm.project.RewardUnitTypeId === 1)?_c('td',{staticClass:"datetime"},[_vm._v(_vm._s(_vm.formatDate(item.BonusStartDate, 'DD.MM.YYYY HH:mm')))]):_vm._e(),_vm._v(" "),(_vm.project.RewardUnitTypeId === 1)?_c('td',{staticClass:"datetime"},[_vm._v(_vm._s(_vm.formatDate(item.BonusEndDate, 'DD.MM.YYYY HH:mm')))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.TradePointName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.Comment))])])}),0)]):_vm._e()]):_vm._e(),_vm._v(" "),_c('vue-headful',{attrs:{"title":"История начислений баллов"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FaqPage_vue__ = __webpack_require__(300);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0acca584_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FaqPage_vue__ = __webpack_require__(851);
function injectStyle (ssrContext) {
  __webpack_require__(849)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0acca584"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FaqPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0acca584_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FaqPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(850);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("e055c3b8", content, true, {});

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%","overflow":"hidden"}},[_c('faq-component',{attrs:{"info":_vm.info},on:{"projectChange":_vm.onProjectChange},model:{value:(_vm.infoData.Faq),callback:function ($$v) {_vm.$set(_vm.infoData, "Faq", $$v)},expression:"infoData.Faq"}}),_vm._v(" "),_c('vue-headful',{attrs:{"title":_vm.getPageTitle()}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sender_vue__ = __webpack_require__(301);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_215d924e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sender_vue__ = __webpack_require__(855);
function injectStyle (ssrContext) {
  __webpack_require__(853)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sender_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_215d924e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sender_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(854);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("768bd0c0", content, true, {});

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".material-body{overflow:auto!important}", ""]);

// exports


/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[_c('div',{staticClass:"body-panel-control separator"},[(_vm.info.User && (_vm.info.User.MainRole === 'administrators' || _vm.info.ProjectsLength > 1))?_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex mob-inline"},[_c('project-select',{attrs:{"user":_vm.info.User},on:{"onChange":_vm.onProjectChange}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page"},[_c('div',{staticClass:"mob-flex-to-block height-full mob-height-auto material-conteiner"},[_c('div',{staticClass:"test-result-header flex"},[_c('div',{class:['test-result-header-div', {'select': _vm.activeTab === 'notification'}],on:{"click":function($event){return _vm.onTabChange('notification')}}},[_vm._v("Уведомления")]),_vm._v(" "),_c('div',{class:['test-result-header-div', {'select': _vm.activeTab === 'sms'}],on:{"click":function($event){return _vm.onTabChange('sms')}}},[_vm._v("SMS")]),_vm._v(" "),_c('div',{class:['test-result-header-div', {'select': _vm.activeTab === 'email'}],on:{"click":function($event){return _vm.onTabChange('email')}}},[_vm._v("Email")]),_vm._v(" "),_c('div',{class:['test-result-header-div', {'select': _vm.activeTab === 'history'}],on:{"click":function($event){return _vm.onTabChange('history')}}},[_vm._v("История")]),_vm._v(" "),_c('div',{class:['test-result-header-div', {'select': _vm.activeTab === 'log'}],on:{"click":function($event){return _vm.onTabChange('log')}}},[_vm._v("Сервисные сообщения")])]),_vm._v(" "),_c('div',{staticClass:"material-body",style:({display: _vm.activeTab === 'email' || _vm.activeTab === 'sms' || _vm.activeTab === 'notification' ? 'block' : 'none'})},[_c('div',{staticClass:"flex m-s-cont"},[_c('div',{staticClass:"m-s-cont-left"},[(!_vm.templatesByCurrentType.length)?_c('div',[_vm._v("\n                            Нажмите на \"+\", чтобы добавить шаблон\n                        ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.templatesByCurrentType),function(template,index){return _c('div',{class:['m-s-cont-tmpl ', {'active': _vm.currentTemplate != null && template.Id == _vm.currentTemplate.Id}],on:{"click":function($event){return _vm.onTemplateSelect(template)}}},[_c('div',{staticStyle:{"float":"right","margin-top":"10px"}},[_c('button',{staticClass:"btn btn-default btn-img",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onRemoveTemplate(template, index)}}},[_c('img',{attrs:{"src":__webpack_require__(17),"alt":""}})])]),_vm._v(" "),_c('span',{staticClass:"m-s-cont-tmpl-item-header"},[_vm._v("\n                                "+_vm._s(template.Name)+"\n                                "),(template.Id === 0)?[_vm._v("\n                                    *\n                                ")]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"m-s-cont-tmpl-item-info"},[_vm._v("\n                                "+_vm._s(_vm._f("date-long")(template.CreateDate))),_c('br'),_vm._v("\n                                Автор: "+_vm._s(template.CreatorFio)+"\n                            ")])])}),_vm._v(" "),(_vm.showAddTemplateBtn)?_c('button',{staticClass:"btn btn-primary margin-top-15 btn-img",attrs:{"type":"button","title":"Добавить"},on:{"click":function($event){return _vm.addTemplate()}}},[_c('img',{attrs:{"src":__webpack_require__(43),"alt":""}})]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"m-s-cont-right"},[(_vm.currentTemplate != null)?[(_vm.activeTab === 'sms' || _vm.activeTab === 'notification')?_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Название шаблона (макс. 250 символов)\n                            ")]):_vm._e(),_vm._v(" "),(_vm.activeTab === 'email')?_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Тема письма (макс. 250 символов)\n                            ")]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, max: 250}),expression:"{required: true, max: 250}"},{name:"model",rawName:"v-model",value:(_vm.currentTemplate.Name),expression:"currentTemplate.Name"}],class:['input-text', {'input-error': _vm.errors.has('TemplateName')}],attrs:{"name":"TemplateName","type":"text"},domProps:{"value":(_vm.currentTemplate.Name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentTemplate, "Name", $event.target.value)}}}),_vm._v(" "),(_vm.activeTab === 'email')?[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Адрес для отправки\n                                    ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.smtpSettings,"dataField":'Id',"textField":'Name'},model:{value:(_vm.smtpServerId),callback:function ($$v) {_vm.smtpServerId=$$v},expression:"smtpServerId"}})],1)]:_vm._e(),_vm._v(" "),(_vm.activeTab === 'notification')?[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Заголовок уведомления (макс. 128 символов)\n                                    ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, max: 128}),expression:"{required: true, max: 128}"},{name:"model",rawName:"v-model",value:(_vm.currentTemplate.Header),expression:"currentTemplate.Header"}],class:['input-text', {'input-error': _vm.errors.has('TemplateHeader')}],attrs:{"name":"TemplateHeader","type":"text"},domProps:{"value":(_vm.currentTemplate.Header)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentTemplate, "Header", $event.target.value)}}})])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"sender-template-info"},[_c('div',{staticClass:"m-s-cont-send-autotmpl"},[_c('p',{staticClass:"input-text-lbl"},[_vm._v("Автоподставляемые значения")]),_vm._v(" "),_c('div',{staticClass:"btns"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onPushTemplateVariable('%ФИО%')}}},[_vm._v("Полное ФИО")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onPushTemplateVariable('%Фамилия%')}}},[_vm._v("Фамилия")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onPushTemplateVariable('%Имя%')}}},[_vm._v("Имя")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onPushTemplateVariable('%Отчество%')}}},[_vm._v("Отчество")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onPushTemplateVariable('%БаллыАктивные%')}}},[_vm._v("Сколько баллов активно")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onPushTemplateVariable('%БаллыПотенциальные%')}}},[_vm._v("Сколько баллов будет активно")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onPushTemplateVariable('%АктивацияАккаунта%')}}},[_vm._v("Активация аккаунта")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onPushTemplateVariable('%БаллыТекМесяц%')}}},[_vm._v("БаллыТекМесяц")])])]),_vm._v(" "),_c('div',[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                        Сообщение\n                                    ")]),_vm._v(" "),(_vm.activeTab === 'sms')?_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentTemplate.Body),expression:"currentTemplate.Body"}],ref:"smsBody",staticClass:"input-memo",staticStyle:{"height":"150px"},attrs:{"name":"SmsBody","rows":"10"},domProps:{"value":(_vm.currentTemplate.Body)},on:{"change":_vm.calculateSmsTextInfo,"keyup":_vm.calculateSmsTextInfo,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentTemplate, "Body", $event.target.value)}}}):_vm._e(),_vm._v(" "),(_vm.activeTab === 'email' || _vm.activeTab === 'notification')?_c('froala-editor',{ref:"EmailBody",attrs:{"name":"EmailBody"},model:{value:(_vm.currentTemplate.Body),callback:function ($$v) {_vm.$set(_vm.currentTemplate, "Body", $$v)},expression:"currentTemplate.Body"}}):_vm._e(),_vm._v(" "),(_vm.activeTab === 'sms')?_c('div',{staticStyle:{"text-align":"right"}},[_vm._v("\n                                        "+_vm._s(_vm.smsTextInfo.symbolsLeft)+"/"+_vm._s(_vm.smsTextInfo.symbolsTotal)+"\n                                        ("+_vm._s(_vm.smsTextInfo.messages)+" сообщение)\n                                    ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"m-s-cont-send-filter margin-top-10"},[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"form-field",staticStyle:{"width":"200px","min-width":"200px"}},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                                Роль пользователя\n                                            ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.roles,"dataField":'Id',"textField":'Name'},on:{"change":_vm.onRoleChange},model:{value:(_vm.roleId),callback:function ($$v) {_vm.roleId=$$v},expression:"roleId"}})],1),_vm._v(" "),_c('div',{staticClass:"margin-left-20 margin-top-20"},[_c('p',[_vm._v("Отфильтровано пользователей: "+_vm._s(_vm.usersCount))]),_vm._v(" "),_c('p',[_vm._v("Выбрано для отправки: "+_vm._s(_vm.resultUsersCount))])]),_vm._v(" "),_c('div',{staticClass:"margin-left-20 margin-top-20 flex btns",staticStyle:{"height":"34px"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.openCurrentUsers()}}},[_vm._v("Уточнить выбор")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.clearFilterState}},[_vm._v("Очистить")])])]),_vm._v(" "),(_vm.activeTab === 'sms')?[_c('p',[_vm._v("Примерная стоимость: "+_vm._s(_vm.smsTextInfo.averagePrice)+" руб.")])]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"margin-top-30"},[_c('div',{staticClass:"btns flex"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onTemplateSave()}}},[_vm._v("Сохранить шаблон")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onSendToMe.apply(null, arguments)}}},[_vm._v("Отправить мне")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button","disabled":_vm.activeTab === 'sms' && !_vm.smsSendingAllowed,"title":_vm.activeTab !== 'sms' || _vm.smsSendingAllowed ? '' : 'Будет превышен дневной лимит отправки сообщений'},on:{"click":function($event){$event.stopPropagation();return _vm.onStartSending()}}},[_vm._v("\n                                        "+_vm._s(_vm.startSendingText)+"\n                                    ")]),_vm._v(" "),(_vm.activeTab === 'sms' && _vm.smsLimits != null)?_c('div',{staticClass:"margin-top-5"},[_vm._v("Дневной лимит "+_vm._s(_vm.smsLimits.today)+" из "+_vm._s(_vm.smsLimits.total))]):_vm._e()])]),_vm._v(" "),(_vm.activeTab === 'notification')?_c('div',{staticClass:"form-field flex margin-top-5"},[_c('div',{staticClass:"margin-right-20"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Запланировать отправку")]),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{staticClass:"input-text",attrs:{"name":"DateStartSent","todayHighlight":"true"},model:{value:(_vm.dateStartSent),callback:function ($$v) {_vm.dateStartSent=$$v},expression:"dateStartSent"}})],1)]),_vm._v(" "),_c('div',[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Время")]),_vm._v(" "),_c('input-time',{staticClass:"input-text",attrs:{"name":"TimeStartSent","showSeconds":"true","maxHours":"23"},model:{value:(_vm.timeStartSent),callback:function ($$v) {_vm.timeStartSent=$$v},expression:"timeStartSent"}})],1)]):_vm._e()]:_c('div',[_vm._v("\n                            Выберите шаблон в левой колонке\n                        ")])],2)])]),_vm._v(" "),_c('div',{staticClass:"material-body",style:({display: _vm.activeTab === 'history' ? 'block' : 'none'})},[_c('div',{staticClass:"m-s-cont"},[_c('div',{staticClass:"flex margin-top-15",staticStyle:{"width":"50%"}},[_c('div',{staticClass:"form-field"},[_c('drop-down',{attrs:{"items":_vm.bulkSendingTypes,"dataField":'Id',"textField":'Name'},on:{"change":_vm.bulkSendingReload},model:{value:(_vm.historyBulkSendingType),callback:function ($$v) {_vm.historyBulkSendingType=$$v},expression:"historyBulkSendingType"}})],1),_vm._v(" "),_c('div',{staticClass:"flex margin-left-10"},[_c('input-date',{staticClass:"input-text input-date",attrs:{"name":"dateStart"},on:{"input":_vm.bulkSendingReload},model:{value:(_vm.historyDateStart),callback:function ($$v) {_vm.historyDateStart=$$v},expression:"historyDateStart"}}),_vm._v(" "),_c('span',{staticClass:"margin-left-10 margin-right-10 margin-top-5"},[_vm._v("-")]),_vm._v(" "),_c('input-date',{staticClass:"input-text input-date",attrs:{"name":"dateEnd"},on:{"input":_vm.bulkSendingReload},model:{value:(_vm.historyDateEnd),callback:function ($$v) {_vm.historyDateEnd=$$v},expression:"historyDateEnd"}})],1),_vm._v(" "),_c('div',{staticClass:"margin-left-20"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onHistoryFilterClear()}}},[_vm._v("Сбросить")])]),_vm._v(" "),_c('div',{staticClass:"margin-left-20"},[_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.onExportDetails()}}},[_vm._v("Экспорт")])])]),_vm._v(" "),_c('table',{staticClass:"t-data",staticStyle:{"margin":"20px 0 0"}},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.bulkSending.data),function(history){return _c('tr',{on:{"click":function($event){$event.stopPropagation();return _vm.onReceiversClick(history)}}},[_c('td',{staticClass:"number-short"},[_vm._v("\n                                    "+_vm._s(history.Id)+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"w150-c"},[_vm._v(_vm._s(history.BulkSendingType))]),_vm._v(" "),_c('td',{staticClass:"w150-c"},[_vm._v(_vm._s(_vm._f("date-long")(history.CreateDate)))]),_vm._v(" "),_c('td',{staticClass:"t-data-str w200"},[_vm._v(_vm._s(history.TemplateName))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"progress-line"},[_c('div',{staticClass:"progress-line-col green",style:([{left:0}, {width: (history.DeliveredCount / history.ReceiversCount * 100) + '%'}])}),_vm._v(" "),_c('div',{staticClass:"progress-line-col yellow",style:([{left: (history.DeliveredCount / history.ReceiversCount * 100) + '%'}, {width: ((history.SentCount - history.DeliveredCount - history.NotDeliveredCount) / history.ReceiversCount * 100) + '%'}])}),_vm._v(" "),_c('div',{staticClass:"progress-line-col red",style:([{left: ((history.SentCount - history.NotDeliveredCount) / history.ReceiversCount * 100) + '%'}, {width: (history.NotDeliveredCount / history.ReceiversCount * 100) + '%'}])}),_vm._v(" "),_c('div',{staticClass:"progress-line-col grey",style:([{right:0}, {width: (history.NotSentCount / history.ReceiversCount * 100) + '%'}])})])]),_vm._v(" "),_c('td',{staticClass:"number"},[_vm._v(_vm._s(_vm.formatInt(history.TotalCost)))]),_vm._v(" "),_c('td',{staticClass:"w100-c"},[_c('button',{staticClass:"btn btn-img",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onReceiversClick(history)}}},[_vm._v("\n                                        >\n\n                                        "),_c('img',{attrs:{"src":__webpack_require__(856),"alt":""}})])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"material-body",style:({display: _vm.activeTab === 'log' ? 'block' : 'none'})},[_c('div',{staticClass:"m-s-cont"},[_c('table',{staticClass:"t-data",staticStyle:{"margin":"20px 0 0"}},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.log.data),function(item){return _c('tr',[_c('td',{staticClass:"w50-c"},[_vm._v("\n                                    "+_vm._s(item.Id)+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"w150-c"},[_vm._v(_vm._s(_vm._f("date-long")(item.CreateDate)))]),_vm._v(" "),_c('td',{staticClass:"t-data-str"},[_vm._v(_vm._s(item.Message))])])}),0)])])])])]),_vm._v(" "),_c('popup-window',{ref:"ppCurrentUsers",attrs:{"title":'Получатели рассылки',"width":"95%","height":"95%"},on:{"onBottomScrolled":_vm.onCurrentUsersSroll,"click":function($event){$event.stopPropagation();},"onClose":function($event){return _vm.ppCurrentUsersClosed()}},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('div',{staticClass:"popup-footer"},[_c('div',{staticClass:"flex"},[_c('div',{staticStyle:{"width":"50%"}},[_vm._v("\n                        Отфильтровано: "+_vm._s(_vm.usersCount)+", выбрано "+_vm._s(_vm.resultUsersCount)+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"btns flex",staticStyle:{"justify-content":"flex-end","width":"50%"},attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onCurrentUsersExport()}}},[_vm._v("\n                            Экспорт\n                        ")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.closeModal('ppCurrentUsers')}}},[_vm._v("Закрыть")])])])])]},proxy:true}])},[_c('div',[_c('div',[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"form-field",staticStyle:{"width":"200px","min-width":"200px"}},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                            Роль пользователя\n                        ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.roles,"dataField":'Id',"textField":'Name'},on:{"change":_vm.onRoleChangeFromPopup},model:{value:(_vm.roleId),callback:function ($$v) {_vm.roleId=$$v},expression:"roleId"}})],1),_vm._v(" "),_c('div',{staticClass:"margin-left-20",staticStyle:{"width":"100%"}},[_c('p',{staticClass:"input-text-lbl"},[_vm._v("Фильтрация по датам")]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"form-field",staticStyle:{"width":"250px"}},[_c('drop-down',{attrs:{"items":_vm.dateSortTypes,"dataField":'Id',"textField":'Name'},on:{"change":function($event){return _vm.onSortTypeChange($event)}},model:{value:(_vm.dateSortType),callback:function ($$v) {_vm.dateSortType=$$v},expression:"dateSortType"}})],1),_vm._v(" "),(!_vm.dateSortEmpty)?_c('div',{staticClass:"flex margin-left-10"},[_c('input-date',{staticClass:"input-text input-date",attrs:{"name":"dateStart"},on:{"input":_vm.onDateChange},model:{value:(_vm.dateStart),callback:function ($$v) {_vm.dateStart=$$v},expression:"dateStart"}}),_vm._v(" "),_c('span',{staticClass:"margin-left-10 margin-right-10 margin-top-5"},[_vm._v("-")]),_vm._v(" "),_c('input-date',{staticClass:"input-text input-date",attrs:{"name":"dateEnd"},on:{"input":_vm.onDateChange},model:{value:(_vm.dateEnd),callback:function ($$v) {_vm.dateEnd=$$v},expression:"dateEnd"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex margin-left-10",staticStyle:{"min-width":"100px","padding-top":"7px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateSortEmpty),expression:"dateSortEmpty"}],staticClass:"input-checkbox",attrs:{"id":'dateSortEmpty',"value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.dateSortEmpty)?_vm._i(_vm.dateSortEmpty,"true")>-1:(_vm.dateSortEmpty)},on:{"change":[function($event){var $$a=_vm.dateSortEmpty,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.dateSortEmpty=$$a.concat([$$v]))}else{$$i>-1&&(_vm.dateSortEmpty=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.dateSortEmpty=$$c}},function($event){return _vm.onDateSortEmptyChange()}]}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'dateSortEmpty'}},[_vm._v("Пустая дата")])])])])]),_vm._v(" "),_c('div',{staticClass:"margin-top-10"},[_c('p',{staticClass:"input-text-lbl"},[_vm._v("Динамические фильтры")]),_vm._v(" "),_c('complex-filter',{ref:"complexFilter",attrs:{"filters":_vm.userFilters,"searchFunction":_vm.searchFunction,"tableName":'[dbo].[AspNetUsers]',"withTableNameInClause":true,"cacheKey":"senderCurrentUsersFilterKey"},on:{"onFilterChange":_vm.onFilterChange}})],1)]),_vm._v(" "),_c('div',{staticClass:"margin-top-15",staticStyle:{"margin-left":"21px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.allCurrentUsersSelected),expression:"allCurrentUsersSelected"}],staticClass:"input-checkbox",attrs:{"id":"currentSelectAll","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.allCurrentUsersSelected)?_vm._i(_vm.allCurrentUsersSelected,null)>-1:(_vm.allCurrentUsersSelected)},on:{"change":[function($event){var $$a=_vm.allCurrentUsersSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.allCurrentUsersSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.allCurrentUsersSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.allCurrentUsersSelected=$$c}},function($event){$event.stopPropagation();return _vm.currentUsersSelectAll.apply(null, arguments)}]}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl no-wrap",attrs:{"for":"currentSelectAll"}},[_vm._v("\n                    Выбрать всех\n                ")])]),_vm._v(" "),_c('table',{staticClass:"table-view margin-top-5"},[_c('tbody',_vm._l((_vm.users.data),function(user,u){return _c('tr',{on:{"click":function($event){user.Included = !user.Included}}},[_c('td',{staticClass:"bit"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(user.Included),expression:"user.Included"}],staticClass:"input-checkbox",attrs:{"id":'user_' + u,"value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(user.Included)?_vm._i(user.Included,"true")>-1:(user.Included)},on:{"change":function($event){var $$a=user.Included,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(user, "Included", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(user, "Included", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(user, "Included", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl no-text",attrs:{"for":'user_' + u},on:{"click":function($event){$event.stopPropagation();}}})]),_vm._v(" "),_c('td',[_vm._v("\n                            "+_vm._s(user.Fio)+"\n                        ")]),_vm._v(" "),_c('td',[_vm._v("\n                            "+_vm._s(user.Email)+"\n                        ")]),_vm._v(" "),_c('td',[_vm._v("\n                            "+_vm._s(user.PhoneNumber)+"\n                        ")])])}),0)])])]),_vm._v(" "),_c('popup-window',{ref:"ppReceivers",attrs:{"title":'Детализация рассылки',"width":"800"},on:{"onBottomScrolled":_vm.onReceiversSroll},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_c('div',{staticClass:"popup-footer"},[_c('div',{staticClass:"btns flex",staticStyle:{"justify-content":"flex-end"},attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onRepeat()}}},[_vm._v("Повторить")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onExportDetails(_vm.receivers.id)}}},[_vm._v("\n                        Экспорт\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeModal('ppReceivers')}}},[_vm._v("Закрыть")])])])]},proxy:true}])},[_c('div',[(_vm.receivers.BulkSendingTypeId==3 && _vm.receivers.AllowEdit)?_c('div',{staticClass:"form-field"},[_c('p',{staticClass:"input-text-lbl",staticStyle:{"cursor":"pointer"},on:{"click":function($event){$event.stopPropagation();return _vm.onReceiversSheduleClick.apply(null, arguments)}}},[_vm._v("Запланированное уведомление. Подробнее")]),_vm._v(" "),_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-15"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"send-view"},[_c('p',{staticClass:"input-text-lbl"},[_vm._v("Текст сообщения")]),_vm._v(" "),_c('div',{staticClass:"margin-top-5",domProps:{"innerHTML":_vm._s(_vm.receivers.body)}})]),_vm._v(" "),_c('div',{staticClass:"send-view-chart"},[_c('chart',{attrs:{"type":'doughnut',"chartOptions":_vm.chartOptions,"chartData":_vm.chartData}})],1)]),_vm._v(" "),_c('div',{staticClass:"margin-top-5",staticStyle:{"text-align":"center"}},[_vm._v("Всего получателей: "+_vm._s(_vm.receivers.RecTotal))]),_vm._v(" "),_c('table',{staticClass:"table-view margin-top-20"},[_c('thead',{staticStyle:{"display":"table-header-group !important"}},[_c('tr',[_c('th',[_vm._v("ФИО")]),_vm._v(" "),_c('th',[_vm._v("Статус")]),_vm._v(" "),(_vm.receivers.bulkSendingType === 'SMS')?_c('th',[_vm._v("Цена")]):_vm._e()])]),_vm._v(" "),_c('tbody',_vm._l((_vm.receivers.data),function(user,u){return _c('tr',[_c('td',[_vm._v("\n                            "+_vm._s(user.Fio)+"\n                        ")]),_vm._v(" "),_c('td',{staticClass:"state"},[_vm._v("\n                            "+_vm._s(user.StatusFormatted)+"\n                        ")]),_vm._v(" "),(_vm.receivers.bulkSendingType === 'SMS')?_c('td',{staticClass:"valueshort"},[_vm._v("\n                            "+_vm._s(_vm.formatInt((user.Cost || 0).toFixed(2)))+"\n                        ")]):_vm._e()])}),0)])])]),_vm._v(" "),_c('popup-window',{ref:"ppReceiversShedule",attrs:{"title":'Запланированное уведомление',"width":"800"}},[_c('div',[_c('div',{staticClass:"form-field flex"},[_c('div',{staticClass:"margin-right-20"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Дата отправки")]),_vm._v(" "),_c('div',{staticClass:"input-date-lbl"},[_c('input-date',{staticClass:"input-text",attrs:{"name":"StartDate","todayHighlight":"true"},model:{value:(_vm.currentTemplate.StartDateFormatted),callback:function ($$v) {_vm.$set(_vm.currentTemplate, "StartDateFormatted", $$v)},expression:"currentTemplate.StartDateFormatted"}})],1)]),_vm._v(" "),_c('div',[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Время отправки")]),_vm._v(" "),_c('input-time',{class:['input-text', {'input-error': _vm.errors.has('StartSendTime')}],attrs:{"name":"StartSendTime","showSeconds":"true","maxHours":"23"},model:{value:(_vm.currentTemplate.StartSendTimeFormatted),callback:function ($$v) {_vm.$set(_vm.currentTemplate, "StartSendTimeFormatted", $$v)},expression:"currentTemplate.StartSendTimeFormatted"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                    Название шаблона (макс. 250 символов)\n                ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, max: 250}),expression:"{required: true, max: 250}"},{name:"model",rawName:"v-model",value:(_vm.currentTemplate.Name),expression:"currentTemplate.Name"}],class:['input-text', {'input-error': _vm.errors.has('SheduleTemplateName')}],attrs:{"name":"SheduleTemplateName","type":"text"},domProps:{"value":(_vm.currentTemplate.Name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentTemplate, "Name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                    Заголовок уведомления (макс. 128 символов)\n                ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:({required: true, max: 128}),expression:"{required: true, max: 128}"},{name:"model",rawName:"v-model",value:(_vm.currentTemplate.Header),expression:"currentTemplate.Header"}],class:['input-text', {'input-error': _vm.errors.has('SheduleTemplateHeader')}],attrs:{"name":"SheduleTemplateHeader","type":"text"},domProps:{"value":(_vm.currentTemplate.Header)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentTemplate, "Header", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"sender-template-info"},[_c('div',{staticClass:"m-s-cont-send-autotmpl"},[_c('p',{staticClass:"input-text-lbl"},[_vm._v("Автоподставляемые значения")]),_vm._v(" "),_c('div',{staticClass:"btns"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onPushSheduleTemplateVariable('%ФИО%')}}},[_vm._v("Полное ФИО")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onPushSheduleTemplateVariable('%Фамилия%')}}},[_vm._v("Фамилия")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onPushSheduleTemplateVariable('%Имя%')}}},[_vm._v("Имя")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onPushSheduleTemplateVariable('%Отчество%')}}},[_vm._v("Отчество")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onPushSheduleTemplateVariable('%БаллыАктивные%')}}},[_vm._v("Сколько баллов активно")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onPushSheduleTemplateVariable('%БаллыПотенциальные%')}}},[_vm._v("Сколько баллов будет активно")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onPushSheduleTemplateVariable('%АктивацияАккаунта%')}}},[_vm._v("Активация аккаунта")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.onPushSheduleTemplateVariable('%БаллыТекМесяц%')}}},[_vm._v("БаллыТекМесяц")])])]),_vm._v(" "),_c('div',[_c('label',{staticClass:"input-text-lbl"},[_vm._v("Сообщение")]),_vm._v(" "),_c('froala-editor',{ref:"SheduleEmailBody",attrs:{"name":"SheduleEmailBody"},model:{value:(_vm.currentTemplate.Body),callback:function ($$v) {_vm.$set(_vm.currentTemplate, "Body", $$v)},expression:"currentTemplate.Body"}})],1),_vm._v(" "),_c('div',{staticClass:"m-s-cont-send-filter margin-top-10"},[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"form-field",staticStyle:{"width":"200px","min-width":"200px"}},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                Роль пользователя\n                            ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.roles,"dataField":'Id',"textField":'Name'},on:{"change":_vm.onRoleChange},model:{value:(_vm.roleId),callback:function ($$v) {_vm.roleId=$$v},expression:"roleId"}})],1),_vm._v(" "),_c('div',{staticClass:"margin-left-20 margin-top-20"},[_c('p',[_vm._v("Отфильтровано пользователей: "+_vm._s(_vm.usersCount))]),_vm._v(" "),_c('p',[_vm._v("Выбрано для отправки: "+_vm._s(_vm.resultUsersCount))])]),_vm._v(" "),_c('div',{staticClass:"margin-left-20 margin-top-20 flex btns",staticStyle:{"height":"34px"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.openCurrentUsers(); _vm.closeModal('ppReceiversShedule');}}},[_vm._v("Уточнить выбор")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.clearFilterState}},[_vm._v("Очистить")])])])])])]),_vm._v(" "),_c('div',{staticClass:"popup-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"btns",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn",staticStyle:{"float":"left"},attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onBulkSendingDelete.apply(null, arguments)}}},[_vm._v("Отменить отправку")]),_vm._v(" "),_c('div',{staticClass:"flex",staticStyle:{"justify-content":"flex-end"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.onBulkSendingSave()}}},[_vm._v("Сохранить изменения")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.closeModal('ppReceiversShedule')}}},[_vm._v("Закрыть")])])])])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":_vm.getPageTitle()}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"heading"},[_c('th',{staticClass:"fix"}),_vm._v(" "),_c('th',{staticClass:"number-short"},[_vm._v("Id")]),_vm._v(" "),_c('th',{staticClass:"w150-c"},[_vm._v("Тип")]),_vm._v(" "),_c('th',{staticClass:"w150-c"},[_vm._v("Дата")]),_vm._v(" "),_c('th',{staticClass:"w200"},[_vm._v("Шаблон")]),_vm._v(" "),_c('th',[_vm._v("Прогресс")]),_vm._v(" "),_c('th',{staticClass:"number"},[_vm._v("Стоимость")]),_vm._v(" "),_c('th',{staticClass:"w100-c"},[_vm._v("Детали")]),_vm._v(" "),_c('th',{staticClass:"fix-2"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"heading"},[_c('th',{staticClass:"w50-c"},[_vm._v("Id")]),_vm._v(" "),_c('th',{staticClass:"w150-c"},[_vm._v("Дата")]),_vm._v(" "),_c('th',[_vm._v("Сообщение")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon-analit.png?bae26c13d7f19cd87c3da19b472e3e79";

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tasks_vue__ = __webpack_require__(302);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d63628ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tasks_vue__ = __webpack_require__(858);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tasks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d63628ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tasks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[(_vm.info.User && (_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.tasksEdit) || _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.tasksController) || _vm.info.User.MainRole === 'administrators' || _vm.info.ProjectsLength > 1))?_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex"},[(_vm.info.User && (_vm.info.User.MainRole === 'administrators' || _vm.info.ProjectsLength > 1))?_c('project-select',{attrs:{"user":_vm.info.User},on:{"onChange":_vm.onProjectChange}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[_c('div',{staticClass:"btns flex",attrs:{"data-toggle":"buttons"}},[(_vm.hasClaimsOrAdmin(_vm.info.User, _vm.claimEnums.tasksEdit))?_c('button',{staticClass:"btn btn-news",on:{"click":_vm.addTask}},[_vm._v("Добавить задание")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-news",on:{"click":_vm.tasksTable}},[_vm._v("Ответы на задания")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page panel-block-news"},[_c('div',{staticClass:"flex body-panel-content-center margin-bottom-20",attrs:{"data-toggle":"buttons"}},[_c('button',{class:['btn-switcher', {'active': !_vm.tasksCompleted}],attrs:{"type":"button"},on:{"click":function($event){return _vm.onTasksCompleted(0)}}},[_vm._v("\n                Актуальные\n            ")]),_vm._v(" "),_c('button',{class:['btn-switcher', {'active': _vm.tasksCompleted}],attrs:{"type":"button"},on:{"click":function($event){return _vm.onTasksCompleted(1)}}},[_vm._v("\n                Завершенные\n            ")])]),_vm._v(" "),_c('div',{staticClass:"body-panel-content-center"},_vm._l((_vm.tasks),function(item,i){return _c('div',{class:['panel-block', 'panel-block-large'],attrs:{"data-id":item.Id}},[_c('div',{staticClass:"panel-block-info",staticStyle:{"border-top":"none"},on:{"click":function($event){return _vm.onItemClick(item.Id)}}},[_c('div',{staticClass:"flex margin-bottom-10"},[_c('div',{staticStyle:{"width":"100%"}},[_c('p',{class:['tasks-header', { 'short': item.TaskType === _vm.TaskTypes.Cumulative }]},[_vm._v(_vm._s(item.Name))])]),_vm._v(" "),(item.ScoringAccrual === _vm.ScoringAccrualTypes.DependingOnSku || item.ScoringAccrualSumText!=='0')?_c('div',{staticClass:"tasks-tile-right"},[_c('div',{staticStyle:{"text-align":"right"},attrs:{"title":[_vm.onScoringAccrualSum(item)]}},[_c('svg',{staticClass:"svg-big tasks-svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg?v2#RewardPoints"}})]),_vm._v(" "),_c('span',{staticClass:"tasks-balls"},[_vm._v(_vm._s(_vm.onScoringAccrualSum(item)))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"input-text-lbl",staticStyle:{"text-align":"right"},attrs:{"title":[item.ScoringAccrualText]}},[_vm._v(_vm._s(item.ScoringAccrualText))])])]):_vm._e()]),_vm._v(" "),(item.TaskType === _vm.TaskTypes.Simple)?_c('div',{staticClass:"flex",staticStyle:{"padding-top":"3px"}},[_c('div',{staticStyle:{"width":"50%"}},[_c('p',{staticClass:"input-text-lbl"},[_vm._v(_vm._s(item.StateText))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%"}},[_c('p',{staticStyle:{"text-align":"right"}},[_vm._v("Выполнено: "+_vm._s(item.QntDone))])])]):_vm._e(),_vm._v(" "),(item.TaskType === _vm.TaskTypes.Cumulative)?_c('div',[(item.TaskType === _vm.TaskTypes.Cumulative)?_c('p',{staticClass:"input-text-lbl"},[_vm._v(_vm._s(item.StateText))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"tasks-progress margin-top-5"},[_c('div',{staticClass:"tasks-progress-line",style:({width: item.QntDone + '%'})})]),_vm._v(" "),_c('div',{staticClass:"flex margin-top-5"},[_c('div',{staticStyle:{"width":"50%"}},[_c('p',{staticClass:"input-text-lbl"},[_vm._v("План: "+_vm._s(item.PurposeValue))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%"}},[_c('p',{staticStyle:{"text-align":"right"}},[_vm._v("Факт: "+_vm._s(item.Fact))])])])]):_vm._e()]),_vm._v(" "),(_vm.info.User && (_vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.tasksEdit) || _vm.info.User.MainRole === 'administrators'))?_c('div',{staticClass:"panel-body-actions"},[_c('button',{staticClass:"btn btn-img",staticStyle:{"height":"40px"},attrs:{"title":"Настройки задания"},on:{"click":function($event){return _vm.onEditTask(item.Id)}}},[_c('svg',{staticClass:"svg-icon svg-big",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg?v2#Setting"}})])])]):_vm._e()])}),0)]),_vm._v(" "),_c('vue-headful',{attrs:{"title":_vm.getPageTitle()}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TasksTable_vue__ = __webpack_require__(303);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02e798f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TasksTable_vue__ = __webpack_require__(860);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TasksTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02e798f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TasksTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel sku"},[_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('div',{staticClass:"flex mob-inline"},[(_vm.info.User && (_vm.info.User.MainRole === 'administrators' || _vm.info.ProjectsLength > 1))?_c('project-select',{attrs:{"user":_vm.info.User},on:{"onChange":_vm.onProjectChange}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field margin-right-20"},[_c('drop-down',{attrs:{"items":_vm.statuses,"dataField":'Id',"textField":'Name'},on:{"change":function($event){return _vm.onStatusChange($event)}},model:{value:(_vm.statusId),callback:function ($$v) {_vm.statusId=$$v},expression:"statusId"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field margin-right-20"},[_c('drop-down',{attrs:{"items":_vm.dateTypes,"dataField":'Id',"textField":'Name'},on:{"change":function($event){return _vm.onStatusChange($event)}},model:{value:(_vm.dateTypeId),callback:function ($$v) {_vm.dateTypeId=$$v},expression:"dateTypeId"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field flex mob-inline"},[_c('input-date',{staticClass:"input-text input-date",attrs:{"name":"dateStart","todayHighlight":"true"},on:{"input":_vm.onDateChange},model:{value:(_vm.dateStart),callback:function ($$v) {_vm.dateStart=$$v},expression:"dateStart"}}),_vm._v(" "),_c('span',{staticClass:"margin-left-10 margin-right-10 margin-top-5"},[_vm._v("-")]),_vm._v(" "),_c('input-date',{staticClass:"input-text input-date",attrs:{"name":"dateEnd","todayHighlight":"true"},on:{"input":_vm.onDateChange},model:{value:(_vm.dateEnd),callback:function ($$v) {_vm.dateEnd=$$v},expression:"dateEnd"}})],1),_vm._v(" "),(_vm.statusId || _vm.dateStart || _vm.dateEnd || _vm.dateTypeId)?_c('div',{staticClass:"form-field margin-left-20"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.clearFilterState}},[_vm._v("Сбросить")])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"control-block-right btns flex"},[_c('input',{ref:"dropFiles",staticClass:"file-upload-zone-btn",attrs:{"type":"file","id":"dropFiles","name":"dropFiles","accept":".xlsx"},on:{"change":function($event){return _vm.onFileChange()}}}),_vm._v(" "),(_vm.selectedAnswers.length)?_c('div',{staticStyle:{"margin":"auto 10px"}},[_vm._v("\n        Выбрано "+_vm._s(_vm.selectedAnswers.length)+" из "+_vm._s(_vm.totalCount)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.projectId === _vm.currentProjectIds.Opus && (_vm.hasClaimsOrAdmin(_vm.info.User, _vm.claimEnums.tasksController) || _vm.hasClaimsOrAdmin(_vm.info.User, _vm.claimEnums.tasksEdit)) && _vm.answers.length > 0)?_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.onExportReport()}}},[_vm._v("\n        Отчет\n      ")]):_vm._e(),_vm._v(" "),((_vm.projectId === _vm.currentProjectIds.Cersanit || _vm.projectId === _vm.currentProjectIds.Jeelex) && (_vm.hasClaimsOrAdmin(_vm.info.User, _vm.claimEnums.tasksController) || _vm.hasClaimsOrAdmin(_vm.info.User, _vm.claimEnums.tasksEdit)) && _vm.answers.length > 0)?_c('button',{staticClass:"btn",on:{"click":_vm.handleExportAnalytics}},[_vm._v("\n        Аналитика\n      ")]):_vm._e(),_vm._v(" "),((_vm.hasClaimsOrAdmin(_vm.info.User, _vm.claimEnums.tasksController) || _vm.hasClaimsOrAdmin(_vm.info.User, _vm.claimEnums.tasksEdit)) && _vm.answers.length > 0)?_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.onGeneralExport()}}},[_vm._v("\n        Общая выгрузка\n      ")]):_vm._e(),_vm._v(" "),((_vm.hasClaimsOrAdmin(_vm.info.User, _vm.claimEnums.tasksController) || _vm.hasClaimsOrAdmin(_vm.info.User, _vm.claimEnums.tasksEdit)))?_c('button',{staticClass:"btn",attrs:{"type":"button","onclick":"document.getElementById('dropFiles').click()"}},[_vm._v("\n        Смена Статуса\n      ")]):_vm._e(),_vm._v(" "),((_vm.hasClaimsOrAdmin(_vm.info.User, _vm.claimEnums.tasksController) || _vm.hasClaimsOrAdmin(_vm.info.User, _vm.claimEnums.tasksEdit)) && _vm.answers.length > 0)?_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.onExport()}}},[_vm._v("\n        Экспорт\n      ")]):_vm._e(),_vm._v(" "),(_vm.selectedAnswers.length)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.updateMultipleAnswerStatuses(2, '')}}},[_vm._v("Принять")]):_vm._e(),_vm._v(" "),(_vm.selectedAnswers.length)?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){return _vm.btnReject(4)}}},[_vm._v("Доработать")]):_vm._e(),_vm._v(" "),(_vm.selectedAnswers.length)?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){return _vm.btnReject(5)}}},[_vm._v("Отклонить")]):_vm._e(),_vm._v(" "),(_vm.selectedAnswers.length)?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.selectedCancel()}}},[_vm._v("Отмена")]):_vm._e(),_vm._v(" "),(_vm.selectedAnswers.length)?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeAnswers()}}},[_vm._v("Удалить")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"body-panel-control-separator"},[_c('complex-filter',{ref:"complexFilter",attrs:{"cacheKey":'reportsComplexFilter',"filters":_vm.filteredUserFilters,"searchFunction":_vm.searchFunction,"tableName":'[dbo].[AspNetUsers]',"withTableNameInClause":true},on:{"onFilterChange":_vm.onFilterChange}})],1)]),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page",on:{"scroll":_vm.onScroll}},[_c('table',{staticClass:"table-view",attrs:{"id":"dataTable"}},[_c('thead',{staticClass:"head-show"},[_c('tr',{staticClass:"heading"},[(_vm.hasClaimsOrAdmin(_vm.info.User, _vm.claimEnums.tasksController) || _vm.hasClaimsOrAdmin(_vm.info.User, _vm.claimEnums.tasksEdit))?_c('th',{staticClass:"check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectAll),expression:"selectAll"}],staticClass:"input-checkbox",attrs:{"id":"selectAll","name":"selectAll","value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectAll)?_vm._i(_vm.selectAll,"true")>-1:(_vm.selectAll)},on:{"change":[function($event){var $$a=_vm.selectAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectAll=$$c}},function($event){return _vm.onSelectAllChange($event)}]}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":"selectAll"}})]):_vm._e(),_vm._v(" "),_c('th',[_vm._v("Id")]),_vm._v(" "),_c('th',[_vm._v("Задание")]),_vm._v(" "),_c('th',[_vm._v("Пользователь")]),_vm._v(" "),_c('th',[_vm._v("Статус")]),_vm._v(" "),_c('th',[_vm._v("Заполнение")]),_vm._v(" "),_c('th',[_vm._v("Изменение статуса")]),_vm._v(" "),_c('th',[_vm._v("Окончание задания")]),_vm._v(" "),_c('th',[_vm._v("Состояние задания")]),_vm._v(" "),(_vm.hasClaimsOrAdmin(_vm.info.User, _vm.claimEnums.tasksController) || _vm.hasClaimsOrAdmin(_vm.info.User, _vm.claimEnums.tasksEdit))?_c('th',[_vm._v("Кто последний поменял статус")]):_vm._e(),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',_vm._l((_vm.answers),function(item,i){return _c('tr',{on:{"click":function($event){$event.stopPropagation();return _vm.openAnswerTest(item.TasksId, item.Id, item.LastStatus)}}},[(_vm.hasClaimsOrAdmin(_vm.info.User, _vm.claimEnums.tasksController) || _vm.hasClaimsOrAdmin(_vm.info.User, _vm.claimEnums.tasksEdit))?_c('td',{staticClass:"check",on:{"click":function($event){$event.stopPropagation();}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAnswers),expression:"selectedAnswers"}],staticClass:"input-checkbox",attrs:{"id":'select' + i,"type":"checkbox"},domProps:{"value":item,"checked":Array.isArray(_vm.selectedAnswers)?_vm._i(_vm.selectedAnswers,item)>-1:(_vm.selectedAnswers)},on:{"change":[function($event){var $$a=_vm.selectedAnswers,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedAnswers=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedAnswers=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedAnswers=$$c}},function($event){return _vm.onCheckChange(item)}]}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":'select' + i}})]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"id"},[_vm._v(_vm._s(item.Id))]),_vm._v(" "),_c('td',{staticClass:"string"},[_vm._v(_vm._s(item.TaskName))]),_vm._v(" "),_c('td',{staticClass:"date-range"},[_vm._v(_vm._s(item.User.Fio))]),_vm._v(" "),_c('td',{class:['state', _vm.getStateClass(item)]},[_vm._v(_vm._s(item.LastStatusFormatted))]),_vm._v(" "),_c('td',{staticClass:"date"},[_vm._v(_vm._s(_vm._f("date-short")(item.FillingDate)))]),_vm._v(" "),_c('td',{staticClass:"date"},[_vm._v(_vm._s(_vm._f("date-short")(item.DateStatus)))]),_vm._v(" "),_c('td',{staticClass:"date"},[_vm._v(_vm._s(_vm._f("date-short")(item.TaskEndDate)))]),_vm._v(" "),_c('td',{staticClass:"value-center"},[_vm._v(_vm._s(item.TaskActive ? 'Активно' : 'Завершено'))]),_vm._v(" "),(_vm.hasClaimsOrAdmin(_vm.info.User, _vm.claimEnums.tasksController) || _vm.hasClaimsOrAdmin(_vm.info.User, _vm.claimEnums.tasksEdit))?_c('td',{staticClass:"date-range"},[_vm._v(_vm._s(item.LastActionUser.Fio))]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"value-center"},[_c('button',{staticClass:"btn",attrs:{"type":"button","title":"Открыть"},on:{"click":function($event){$event.stopPropagation();return _vm.openAnswerTest(item.TasksId, item.Id, item.LastStatus)}}},[_vm._v("Открыть")])])])}),0)])]),_vm._v(" "),_c('popup-window',{ref:"ppActionModal",attrs:{"title":'Обработка ответов',"modal":true}},[_c('div',{staticClass:"form-group"},[(!_vm.actionState.done)?_c('p',[_vm._v("\n        Ответ "+_vm._s(_vm.actionState.currentAnswer.index)+" / "+_vm._s(_vm.actionState.total)+" от "+_vm._s(_vm.formatDate(_vm.actionState.currentAnswer.date, 'DD.MM.YYYY HH:mm'))+" в процессе "+_vm._s(_vm.actionState.currentAnswer.time)+" сек.\n      ")]):_c('p',[(_vm.actionState.doneMessage)?[_vm._v("\n          "+_vm._s(_vm.actionState.doneMessage)+"\n        ")]:[_vm._v("\n          Обработка завершена\n        ")]],2),_vm._v(" "),_c('div',{staticClass:"margin-top-20",staticStyle:{"max-height":"300px","overflow":"auto"}},_vm._l((_vm.actionState.messages),function(m){return _c('p',{staticClass:"caption-help",style:(m.error ? 'color:red': '')},[_vm._v("\n          "+_vm._s(m.message)+"\n        ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[(_vm.actionState.done || _vm.actionState.test)?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.ppActionModalClose}},[_vm._v("Закрыть")]):_vm._e()])]),_vm._v(" "),_c('popup-window',{ref:"ppComment",attrs:{"title":_vm.popuptitle,"width":800}},[_c('div',{},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"}),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.commentStatus),expression:"commentStatus"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:['input-memo', {'input-error': _vm.errors.has('SettingsDescription', 'edition')}],attrs:{"rows":"10","name":'SettingsDescription',"data-vv-scope":"edition"},domProps:{"value":(_vm.commentStatus)},on:{"input":function($event){if($event.target.composing){ return; }_vm.commentStatus=$event.target.value}}}),_vm._v(" "),(_vm.errors.has('SettingsDescription', 'edition'))?_c('span',{staticClass:"field-validation-valid"},[_vm._v("Заполните поле")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20 margin-bottom-20"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.tryChangeStatus()}}},[_vm._v("Принять")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.closeModal('ppComment')}}},[_vm._v("Отмена")])])])]),_vm._v(" "),_c('popup-window',{ref:"ppConfirmDelete",attrs:{"title":'Подтверждение удаления',"modal":true}},[_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("Вы уверены, что хотите удалить "+_vm._s(_vm.selectedAnswers.length)+" "+_vm._s(_vm.getAnswerWord(_vm.selectedAnswers.length))+"?")]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-20",attrs:{"data-toggle":"buttons"}},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":_vm.confirmDeleteAnswers}},[_vm._v("Да")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":_vm.cancelDelete}},[_vm._v("Нет")])])])]),_vm._v(" "),_c('vue-headful',{attrs:{"title":_vm.getPageTitle()}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyProgress_vue__ = __webpack_require__(304);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ff2a76a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyProgress_vue__ = __webpack_require__(910);
function injectStyle (ssrContext) {
  __webpack_require__(862)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ff2a76a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyProgress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ff2a76a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyProgress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(863);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("7efbfac1", content, true, {});

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".table-view thead[data-v-1ff2a76a]{display:table-header-group}", ""]);

// exports


/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DaccordBanner_vue__ = __webpack_require__(305);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2d0ae6e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DaccordBanner_vue__ = __webpack_require__(909);
function injectStyle (ssrContext) {
  __webpack_require__(865)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e2d0ae6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DaccordBanner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2d0ae6e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DaccordBanner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(866);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("529ee3fe", content, true, {});

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(638);
exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".cashback[data-v-e2d0ae6e]{font-size:30px}a[data-v-e2d0ae6e]{text-decoration:none;color:#fff}.block-in-page[data-v-e2d0ae6e]{border-radius:40px;width:100%;max-width:1920px;height:1040px;font-family:Montserrat,sans-serif;display:flex;flex-direction:column;margin:0 auto}.block-header[data-v-e2d0ae6e]{display:flex;justify-content:space-between;margin:29px 114px 32px 118px}.block-header-left[data-v-e2d0ae6e]{display:flex;flex-direction:column}.my-balance[data-v-e2d0ae6e]{font-weight:600;font-size:39px;color:#000}.balance-info[data-v-e2d0ae6e]{font-weight:600;font-size:30px;color:#000}.block-header-left span[data-v-e2d0ae6e]{font-weight:700;font-size:51px;color:#e6362c}.block-header-right[data-v-e2d0ae6e]{font-weight:600;font-size:16px;color:#e6362c}.links[data-v-e2d0ae6e]{display:flex;align-items:center;padding-top:10px;gap:11px}.custom-btn[data-v-e2d0ae6e]{padding:15px 36px;border-radius:8px;height:44px;box-shadow:0 2px 7px 0 rgba(0,0,0,.1);font-weight:600;font-size:16px;outline:none;display:flex;align-items:center;cursor:pointer;position:relative}.custom-btn[data-v-e2d0ae6e]:hover{top:2px}.custom-btn[data-v-e2d0ae6e]:active{box-shadow:none;top:4px}.btn-icon[data-v-e2d0ae6e]{border-radius:24px;padding:9px;width:48px;height:48px}.main[data-v-e2d0ae6e]{flex:1;justify-content:space-between;padding-left:118px;padding-right:90px;display:flex}.main-left[data-v-e2d0ae6e]{display:flex;gap:13px}.card[data-v-e2d0ae6e]{width:211px;height:226px;border-radius:17px;outline:none;border:none;display:block;position:relative;&:hover{transform:rotateX(--x-rotation) rotateY(--y-rotation) scale(1.1)}}.card[data-v-e2d0ae6e]:active{border:none;box-shadow:none;top:4px}.card1[data-v-e2d0ae6e]{box-shadow:0 2px 7px 0 rgba(0,0,0,.1);background:#f6fafd;cursor:pointer}.card1 p[data-v-e2d0ae6e]{margin-top:24px;margin-left:19px;font-weight:600;font-size:17px;color:#e6362c}.card1 img[data-v-e2d0ae6e]{margin-left:77px;position:relative;bottom:15px}.card2[data-v-e2d0ae6e]{padding-top:25px;padding-left:15px;box-shadow:0 2px 7px 0 rgba(0,0,0,.1);background:#e6362c url(" + escape(__webpack_require__(867)) + ") no-repeat bottom;cursor:pointer}.card2-text[data-v-e2d0ae6e]{font-weight:600;font-size:17.44px;color:#fff;line-height:21.26px;span{font-size:21.59px;font-weight:600;line-height:26.32px}strong{font-size:57.13px;font-weight:900;line-height:69.64px}b{font-size:26.93px;font-weight:600;line-height:32.82px;margin-left:60px}}.footer[data-v-e2d0ae6e]{display:flex;justify-content:end}.logo[data-v-e2d0ae6e]{text-align:end;font-weight:400;font-size:11px;color:#2d2d2d}.block-footer-right[data-v-e2d0ae6e]{font-weight:600;font-size:16px;color:#e6362c;display:none}.score[data-v-e2d0ae6e]{font-size:30px!important}@media (max-width:1500px){.block-header[data-v-e2d0ae6e]{margin:29px 50px 32px}.main[data-v-e2d0ae6e]{padding-left:50px;padding-right:0}}@media (max-width:1400px){.block-in-page[data-v-e2d0ae6e]{padding:16px;height:900px;width:100%}.block-header[data-v-e2d0ae6e]{display:block;margin:0}.main[data-v-e2d0ae6e]{padding-left:0;padding-right:0;max-height:700px}.links[data-v-e2d0ae6e]{p{font-size:14px;width:123px}:nth-child(2){flex-grow:1;max-width:144px}}.card[data-v-e2d0ae6e]{width:166px;height:180px}.card2[data-v-e2d0ae6e]{padding-top:20px;padding-left:12px;box-shadow:0 2px 7px 0 rgba(0,0,0,.1);background-size:95%;background-position:0 100%;cursor:pointer}.card2-text[data-v-e2d0ae6e]{font-size:14px;color:#fff;line-height:17px;span{font-size:17px;line-height:21px}strong{font-size:45.5px;font-weight:900;line-height:55.46px}b{font-size:21.45px;line-height:26.14px;margin-left:50px}}.card1 p[data-v-e2d0ae6e]{font-size:14px}.card1 img[data-v-e2d0ae6e]{width:96px;margin-left:65px;bottom:20px}.main[data-v-e2d0ae6e]{margin-top:20px}.block-header-left span[data-v-e2d0ae6e],.my-balance[data-v-e2d0ae6e]{font-size:28px}.balance-info[data-v-e2d0ae6e]{font-size:20px}.main-left[data-v-e2d0ae6e]{gap:10px}.score[data-v-e2d0ae6e]{font-size:30px!important}}@media (max-width:800px){.block-header-right[data-v-e2d0ae6e]{display:none}.block-in-page[data-v-e2d0ae6e]{height:1000px;border-radius:0}.score[data-v-e2d0ae6e]{font-size:20px!important}.balance-info[data-v-e2d0ae6e]{display:flex;gap:40px}.footer[data-v-e2d0ae6e]{margin:0;justify-content:flex-start;position:relative;bottom:-100px;.logo{display:none}}.block-footer-right[data-v-e2d0ae6e]{display:block;width:100%}}", ""]);

// exports


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "road-banner.svg?b8de5bff056c7bb680cf6be7f6b58ec3";

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "telegram.svg?be972cb292f25f7f4369068c3207f681";

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "wallet.svg?9f8cffe400233439212e2b99b79aec07";

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "daccordLogo.png?8e5babc45bf8eb233c7eef20a9838d8e";

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoadAndCar_vue__ = __webpack_require__(307);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_241cb108_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoadAndCar_vue__ = __webpack_require__(908);
function injectStyle (ssrContext) {
  __webpack_require__(872)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-241cb108"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoadAndCar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_241cb108_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoadAndCar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(873);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("32ae4511", content, true, {});

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".roadWrap[data-v-241cb108]{position:absolute;height:624px;left:70px;bottom:0;width:1214px;overflow-y:hidden}@media (max-width:1700px){.roadWrap[data-v-241cb108]{width:calc(100% - 70px)}}@media (max-width:1400px){.roadWrap[data-v-241cb108]{left:0;overflow-x:scroll}}@media (max-width:800px){.roadWrap[data-v-241cb108]{bottom:90px;width:100%}}.car[data-v-241cb108],.road[data-v-241cb108]{position:absolute;top:0;left:0}.point1[data-v-241cb108]{position:absolute;left:0;bottom:0;margin-left:100px;margin-bottom:58px}.point2[data-v-241cb108]{position:absolute;left:0;bottom:0;margin-left:350px;margin-bottom:78px}.point3[data-v-241cb108]{position:absolute;left:0;bottom:0;margin-left:580px;margin-bottom:178px}.point4[data-v-241cb108]{position:absolute;left:0;bottom:0;margin-left:840px;margin-bottom:204px}.point5[data-v-241cb108]{position:absolute;left:0;bottom:0;margin-left:1040px;margin-bottom:358px}", ""]);

// exports


/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Car_vue__ = __webpack_require__(308);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d543312_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Car_vue__ = __webpack_require__(877);
function injectStyle (ssrContext) {
  __webpack_require__(875)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0d543312"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Car_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d543312_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Car_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(876);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("aaa43fe4", content, true, {});

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".car[data-v-0d543312]{pointer-events:none;position:absolute;bottom:0;left:0;z-index:20;top:270px;height:134px;width:134px}.smoke[data-v-0d543312]{animation:smoke-data-v-0d543312 1.5s infinite linear;display:block;height:40px;position:absolute;top:55px;left:-20px;transform:rotate(345deg)}@keyframes smoke-data-v-0d543312{0%{opacity:1}to{opacity:0;left:-30px}}", ""]);

// exports


/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"car",staticClass:"car"},[_c('img',{attrs:{"src":__webpack_require__(878),"alt":"car"}}),_vm._v(" "),_c('img',{staticClass:"smoke",attrs:{"src":__webpack_require__(879),"alt":"smoke"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "car.png?c963c9707be961460dd8a44c7f252e89";

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "smoke.png?e91254b270e96d3c0e4d8e746e852369";

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Road_vue__ = __webpack_require__(309);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfa0d06e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Road_vue__ = __webpack_require__(883);
function injectStyle (ssrContext) {
  __webpack_require__(881)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dfa0d06e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Road_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfa0d06e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Road_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(882);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1de41b1c", content, true, {});

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".img-block[data-v-dfa0d06e]{position:absolute;top:0;left:0;margin-left:132px;margin-top:27px;height:328px;overflow:hidden;transition:all 1s linear}.road-wrap[data-v-dfa0d06e]{position:absolute;width:1204px;height:400px;bottom:0}.splash[data-v-dfa0d06e]{object-fit:none;display:block;transition:all 1s linear;height:327px;object-position:left top}", ""]);

// exports


/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"road-wrap"},[_c('img',{staticClass:"road",attrs:{"src":__webpack_require__(884),"alt":"road","width":"1204","height":"400"}}),_vm._v(" "),_c('div',{staticClass:"img-block"},[_c('img',{ref:"road",staticClass:"splash",attrs:{"src":__webpack_require__(885),"alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "road.png?ca6bfc7d3152d48d34dadc5b8e23d855";

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "road-splash.png?2b9db43e23d6b78dc85d44cc1a3ac69e";

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckPoint_vue__ = __webpack_require__(310);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44832f28_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckPoint_vue__ = __webpack_require__(895);
function injectStyle (ssrContext) {
  __webpack_require__(887)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44832f28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckPoint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44832f28_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckPoint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(888);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("88eeb60a", content, true, {});

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".banner-text[data-v-44832f28]{position:absolute;z-index:22;bottom:0;left:0;margin-left:-100px;margin-bottom:120px;border-radius:20px;padding:15px 18px;width:300px;transition:all 1s linear;box-shadow:0 2px 4px 0 rgba(0,0,0,.1);background:#f6fafd;font-family:Montserrat,sans-serif;font-weight:500;font-size:16px;font-style:normal;color:#000;animation:fadeInMove-data-v-44832f28 .5s ease forwards,wobble-data-v-44832f28 .3s ease-in-out .5s 1}@media (max-width:600px){.banner-text[data-v-44832f28]{width:300px;margin-left:-90px}}.banner-finish[data-v-44832f28]{display:flex;justify-content:center;position:absolute;z-index:22;bottom:0;left:0;margin-left:-110px;margin-bottom:120px;border-radius:20px;transition:all 1s linear;box-shadow:0 2px 4px 0 rgba(0,0,0,.1);background:transparent;font-family:Montserrat,sans-serif;font-weight:500;font-size:16px;font-style:normal;color:#000;animation:fadeInMove-data-v-44832f28 .5s ease forwards,wobble-data-v-44832f28 .3s ease-in-out .5s 1}@keyframes fadeInMove-data-v-44832f28{0%{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}@keyframes wobble-data-v-44832f28{0%{transform:rotate(0deg)}25%{transform:rotate(1deg)}50%{transform:rotate(-2deg)}75%{transform:rotate(1deg)}to{transform:rotate(0deg)}}.i[data-v-44832f28]{display:block;height:112px;width:61.2px;cursor:pointer;transition:all 1s linear}.content[data-v-44832f28]{position:absolute;top:0;left:0;margin-left:7px;margin-top:14px}.chechpoint[data-v-44832f28]{position:absolute;bottom:-20px;left:12px}.close-btn[data-v-44832f28]{position:absolute;top:0;width:25px;margin-top:10px;margin-right:5px;right:0}", ""]);

// exports


/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Flag_vue__ = __webpack_require__(311);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b8f3ce0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Flag_vue__ = __webpack_require__(890);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Flag_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b8f3ce0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Flag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"62","height":"86","viewBox":"0 0 62 86","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M42.5768 60.1631C42.935 59.1158 43.718 58.2758 44.6999 57.765C54.504 52.6659 61.2 42.4149 61.2 30.6C61.2 13.7001 47.4999 0 30.6 0C13.7001 0 0 13.7001 0 30.6C0 42.7497 7.08089 53.2456 17.341 58.1861C18.3804 58.6865 19.2137 59.5507 19.5872 60.6421L27.2154 82.9382C28.4494 86.545 33.5506 86.545 34.7846 82.9382L42.5768 60.1631Z","fill":_vm.isActive ? '#E6362C' : '#646464'}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlagWrap_vue__ = __webpack_require__(312);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b4d657f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlagWrap_vue__ = __webpack_require__(892);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlagWrap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b4d657f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlagWrap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"38","height":"38","viewBox":"0 0 38 38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"filter":"url(#filter0_d_1128_969)"}},[_c('rect',{attrs:{"x":"4","width":"30","height":"30","rx":"15","fill":"white","shape-rendering":"crispEdges"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"19","cy":"15","r":"10","fill":_vm.isActive ? '#E6362C' : '#646464'}})]),_vm._v(" "),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1128_969","x":"0","y":"0","width":"38","height":"38","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_vm._v(" "),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","type":"matrix","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_vm._v(" "),_c('feOffset',{attrs:{"dy":"4"}}),_vm._v(" "),_c('feGaussianBlur',{attrs:{"stdDeviation":"2"}}),_vm._v(" "),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_vm._v(" "),_c('feColorMatrix',{attrs:{"type":"matrix","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"}}),_vm._v(" "),_c('feBlend',{attrs:{"mode":"normal","in2":"BackgroundImageFix","result":"effect1_dropShadow_1128_969"}}),_vm._v(" "),_c('feBlend',{attrs:{"mode":"normal","in":"SourceGraphic","in2":"effect1_dropShadow_1128_969","result":"shape"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CloseIcon_vue__ = __webpack_require__(313);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6100674_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CloseIcon_vue__ = __webpack_require__(894);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CloseIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6100674_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CloseIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"10","height":"10","viewBox":"0 0 10 10","fill":this.color,"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0.791847 10L0 9.20815L4.20815 5L0 0.791847L0.791847 0L5 4.20815L9.20815 0L10 0.791847L5.79185 5L10 9.20815L9.20815 10L5 5.79185L0.791847 10Z","fill":this.color}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{ref:"checkpoint",staticClass:"i",on:{"click":_vm.handleClick}},[(_vm.isCurrentFlagActive)?_c('div',{class:{ 'banner-text': !_vm.isFinish, 'banner-finish': _vm.isFinish }},[_vm._t("banner"),_vm._v(" "),_vm._t("text"),_vm._v(" "),_c('CloseIcon',{staticClass:"close-btn",attrs:{"color":this.color}})],2):_vm._e(),_vm._v(" "),_c('Flag',{attrs:{"isActive":_vm.changeColor}}),_vm._v(" "),_c('i',{staticClass:"content"},[_vm._t("default")],2),_vm._v(" "),_c('FlagWrap',{staticClass:"chechpoint",attrs:{"isActive":_vm.changeColor}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartFlag_vue__ = __webpack_require__(314);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ae193de_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartFlag_vue__ = __webpack_require__(897);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StartFlag_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ae193de_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StartFlag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"margin-left":"4px"},attrs:{"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('rect',{attrs:{"width":"36","height":"36","fill":"url(#pattern0_1128_980)"}}),_vm._v(" "),_c('defs',[_c('pattern',{attrs:{"id":"pattern0_1128_980","patternContentUnits":"objectBoundingBox","width":"1","height":"1"}},[_c('use',{attrs:{"xlink:href":"#image0_1128_980","transform":"scale(0.00195312)"}})]),_vm._v(" "),_c('image',{attrs:{"id":"image0_1128_980","width":"512","height":"512","xlink:href":"data:image/png;base64,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"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b38e3da_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinishFlag_vue__ = __webpack_require__(899);
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b38e3da_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinishFlag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"margin-left":"4px"},attrs:{"width":"43","height":"43","viewBox":"0 0 43 43","fill":"none","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('rect',{attrs:{"width":"43","height":"43","fill":"url(#pattern0_1137_1041)"}}),_vm._v(" "),_c('defs',[_c('pattern',{attrs:{"id":"pattern0_1137_1041","patternContentUnits":"objectBoundingBox","width":"1","height":"1"}},[_c('use',{attrs:{"xlink:href":"#image0_1137_1041","transform":"scale(0.00390625)"}})]),_vm._v(" "),_c('image',{attrs:{"id":"image0_1137_1041","width":"256","height":"256","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEACAYAAABccqhmAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAIABJREFUeJztnXe0JUXVvt9NjgOIkgTJGQmSERBRgiBBATGAIqYPzIqC/NAPUUQERcwEEQH9STKhiKJIkiAgccgMDGkIQxhmiBOe7499Bi+Xm7pOd1Xfc/ez1lnDGqa73qpzend31a79moKXAeaRtLKkVSS9QdISkpaRtJSkcZIWlrRI5zNH57CFJM0t6WlJSHpR0nOSnur83dOSJkt6WNIDkiZJmiDpXjObnqNfQTAYVlpACYAFJW0kaV1Jq0latfNZXtKcmWTMkHSfpDsl3Szphs7nLjObmUlDMMYZMAAAr5f0bknbSFpaflE8Iulfkn5rZnfnEtgtgElaXdKmnc/mktaRNFdJXUMwTdK/JV0h6UpJ/zKzKWUlBWMCYGHgeOBFBmcmcCqwZGm9gwG8FvgA8Gtg8hB9GQ1MB64ADgfeDOR6QgnGAC8/AQArSPqTpLVHeOz9knY1sxsb0FUJ/C6/vqSdJO0saRPle5TPzWRJ50n6g6S/mdnzhfUEoxiTJGCc/JFzpBf/bB6VtLGZPVC3sJEALCvpA5I+In+HH2s8Lw/ap0u6ICYVg6rMDgCnS9on8Rz/NLNt65M0NMDCkvaU9CFJW2uMTmQOwCOSzpB0kpndWVpMMDowYF1J1+u/y1opvMPMLqhJ04B0dH5e0nskLdBkW6McJP1T0gnyCdsZhfUELWYOSfuqu4tfkj5Yg5YBAbYEzpMvke2nuPiHwyRtK+lMSfd3Jg8XK6wpaCkG3CBpvS7PM9nMXleHIEkC5pX0fklfkC/ZBd0xRdJPJX3PzB4vLSZoDwY8KamOO8RCZvZsNycA5pC0h6SjJa1Yg6bglTwr6eeSjjKzR0qLCcpjwAuS5q3hXEua2WOpBwO7SjpK0lo1aAmGZpqk70o61symlRYTlMOAByQt2+V5ZkqaNyWFFXiz/I7/5i41BNV5RNL/SjolJgvHJnNIuqaG89xQ9eIHlgHOknS5xu7F/6Ck30i6Sz57n5ul5KsF44F9Istw7DGHpN/VcJ6bRvoPgTmAAyTdKmmvGtoezSwt6atmtpqk10jaUf4adIWknEk9q8mTicbjKdTdrgoFowTDt8DeJd/+msqLklY3s4lD/SNgHfkdZ4su2qrCo5Jau2ehw8lm9rH+f4nvWHybPLV5J3X/mlaF2yR9Q9I5kV04BgB2wDf5dMOPhzj/vMA3gZe6bGMkTAS+C2wGGPDvDG12w4t4SvNw39GGwHfw/uXiIeDr+O7Qngd4DbA2sD6wNL7HZGwAfAaY1cWP5Xlg6QHOuypwXVc/w+F5FvglsBX9vjRg94bbroPjKnxPhu8KPAl4JpO+6cC5wHb02EUBvAk4CrhxgH4/DJwAjI2VKeA9wFNd/FCO6Xe+fWn2R3oTcACwyBB9MuCWBjXUwTTgtQnf10LA/sA1GbVOAI4BNmeUzhXgd/gjgbtG2OeZwE+A+UprbxxgceAbwH0JP46pneMXwmsGNMEs4AIq3I3wGe62840uv7ctgXOAGRk1Pwj8CNgWaGuBFQHzATsCPwDu7qK/1wKLlu5PnQx6AQGLy/f8V829P12+H3/1LnQNxCz5ktm3zGx8lQM7P847JK1Us6Y6eUrSCmb2TDcnAVaSdIh8t+Q8dQgbIVPlqxeXS7pU0r/N7IWM7b8MMLekN8mXl7eV9FbVt4fkEklv75W8iSHvoMDxkj6TScugMiSdK+nwqhf+K04Cn5D0s9pUNcMhZnZ0HScC3iDpYEkfVd5AMJsX5Tkm10m6XR6AbzezSXU2gu8bWVNey2Idecm3jdXsprHPm9n3Gzx/NoYLAMtKukdlfkCSdJGkL5rZDd2eqPNDmSCv8ttWHpG0Up1VfoCVJR0p30bdhgm8KfJg8KC8utFkSU/0+fR9ahin/1Z2Wlj+3S0hT2Ca/VlR+es7TpG0opk9lbnd/AAndvHOlMpdwO4N9OWLBfpSlU/W3e9O3zcBLivduR7ia018T7kZ9o6A30FuV54o+7ykIyQdZ2Yv1n1yYCF5Ke7F6z53jdwnabWmEnCAHSQdLmmzJs4/hnhCPmczqjdTDbuMY2b3SDorg5bLJL3JzL7dxMUvSZ0v64dNnLtGVpD0vqZObmZ/NbPNJW0nLz8epLG4pP8pLaJbRrqMtrY837+Jdd8pkg6S9HMza3xDDF4dZ6L8nbKt3CZpHTOb1XRDwDslHSb3TAiqUfucTW5GdEF3Zt//0ED7V0va0MxOznHxS1Jn4qbtqwFrSqp9DmQgzOxPZraZ3CnpRLmtWTAylpK0f2kR3TDiWWFgA/mSTh0zyTPkBSm+WmKzCW5qcq+k+XO3XYHr5cEx6zZhPKtyb0mfkweiYGgekLSKmb1UWkgKI36kN7PrJf21hjYnSdrGzA4ptdPMzB6V9IsSbVdgA/l7elbMbIqZnShfU3/VLsUeZqqks1V9G/ZySi+pX5xKd3Ngc3m2VypXSNqz7mSQFPBEmbvlzr5t5WIze2tJAcC1kjYsqaFBnpIbq5wn6XwzexY4VZ5FWYV7JK3RK9mBQwJckrhu+lO89kBrwHcQtp1ctRMGG6O9Sg9AjcwC/oPv/nsrA+xfAFYnbT/Fe0t8P91S+X0eX0dOMQHZ2swuSziuMYA1Jd2iZlY36uLPZvbOUo3jO/5uVf17O3IwS679Svn+hAs7r39DApwpz5ysws2S1ss9Z9MtSRN6wDXyWeMq/NXMdkxpr0mAc+SlyNsKkjYoacIKfFjSKaXaHyEvSbpTfsHfLM9xuDrFWh1YTz4JW/X62N3Mmlgta4zUALC70moJbmxm16a02RTAhpJapWkAzjSzYo+Y+O66u9Vd2bhuuUPSY/L39iflewlmf+6RdE+dk8rAHyXtUvGwf5tZ7+dT4EU2bkp4Tzq3tPaBwOsLtJkZwGqFx+gzhccg64oEsGmizuwrN0UA3p8wOLPwwqCtAtg68cvOyUmFx2g+YFLB/t9D5qIjwD8SdF6cU2MxgDmBOxMG6PTS2geC9u+Uewlfuiw5RocWHoPG9kgM0t9tE3VumVNnMYCPJgzODGDV0tr7A+yU+GXnZMTFQxsao3F0VzOyW8aTuQ4hcHmCzvNzaiwGMDdptQNPKK19IPCab23mWaA2F+bEMfpW4THYNXN/d07UWXWVrAhd5/UDn5b0g4qHvSRpZTN7sNv26wTYS81ufX5S0sPymetnJD0tT0GdJq+FMBCLSlqo83mdvMbdA53zPCDpIXkNgdskjTezJ5qTLwFLyPdRNFlyayiu6mxnzgJeePY/ktaveOhvzazNy8uS6gkA88t/EFUdeI43s891236dUE/Sy6Odc9whL6Rym3x8Hqxj2yjD52A8Lmm8pBslXSXpyuEcmxI0/EDSp+s8Z0XeZmYX5Wos8cYwS9K63dSxHDUAByc8Ij3buZu0CmC/Cn2Yis8UHwW8ixE4/NSg710JYz0J+D3wWWCNGjS8gTwuT4Px9zrGskJ/5wBuS9B5Rk6dxcAnh55MGKBvldbeH4ae15iOTwodjtfhz76RCP8xjk8Y677chzvevBtIepQHTulSQ7dkTbgBPpigcTpeUq/3wT3kqvI0LTRaAD7VR+M04CzgvcC40tqklx2X6mIacCawB/46N1INq9O9n2Q3/L7JMR6gv3PhrkhVKZq/kQ3cEWhqwgAdVlr7bHBHo/2AK4DncF/B1hUN6eLHOBxTgTOAbRiB6xIeGEuRPakM+J8EnSMyf+0JcM+4qjyOW2GX1L0xcDKv9jHcqaSuocA9EZvkduALuEPUYBo2oDtD2W75VeYxnxd3TK7K8Tl1FgNYCncJrsoXCmidE38HHioD8PLcukYKnpr7cMJYV+V54Bf41umBdJyfQcNgzCDzOzYeFKvSygnvRsDNIqvyEJmcV/EofiAjf4TeOoeuFIAvJYx1KjPxlYTN+2nYKqOGgciaVAYsiD+1VuXbOXUWA1ietCWiRmus4xf+J4EHKupKKX6SBWBh4ImEse6Wi4Gt+ui4tICG2bwAvD7zuP+/BJ1T8JL0vQ9pS0QTaGC3F75stj/VL/y+tLYmHr4kWYrzgHWAdxTUAPC9zGO+KL6CVZWesBMbFmA10uqqfbBmHdsBNybo6M85deqqE9JXX+piBnAqZbcKTwNem3ncj0zQORm3p+t9gN8kDNBt1LDbC1gJ+FNC+4Mxkxoy6JoCOLbGvo5Wjsg85q/DA09VvpRTZzGAdUlbItqzizbnwd/PnktodzhOrXF4agVYBn8XbgN1PHGl8CSZE7WA4xJ0TqJFuSWN7a02s5vk9darcigjSELpD/BmSTdI+qaacfx5P7B8A+ftGjN7WNKppXV0+LWk7dWdf0QKi0k6IHObx0qqamQ76u3ERgzpddVGnICDz+4fTdqcQ1V+1OR4dQP+2jM9wxgMxyN07nDA9sCF5EsWerntjOP+swSdEymwj6QIwN8TBujKEZ57HdzoIRfPA0s3PWap4Gm8beBT/XStBhyPJ8Q0zSczj3lq4P1wTp3FwPPKU9hmmPN+ijLvva1N6ADWpmxq7mwGvMMBr8W3JF/fYNv3DdR2w+N+WoLOO4E5c+osBvCvhAG6cJBzjaPsJpQptHAH42yA3xUcm74MeYcD1sMn0brJzxiM/TIN9+y+7Jmoc1TaiVWG9IKbm/Y7zxtJq0RcN63ZwdgfYJPSg9PhdkawpIt7TGwCfBu4o6a2a1lOHkLzEnhZ/FNJ2xw0m5tImPAedeBfcsq7+h/6nGMXXr1brxTFdzAOBT7x1gb2StC+Ap65eQbdbXZKXk7up2cuYC28HsSx+OtLna9Zu9WhM5Vs0afzhZxd9TB5McbtJR2tdpl4ft7Mvl9axEAAb5WUrWbeEFwvacNuDDOBFSVtLK+DuJGkdSUNukW5D/+RtNFI2sbvwkt0PstIWqPTznqS1pbU5Ea1onZiOQPAHHIn3gG3lQ7BY/Ivpm08KK9s/FJpIQOBr6RsVlqHpJ3NrNY6+XiNgtXkxVtXkrS0fH19yc5/LyjPC/iNvPqy5LkhfS/kBeQX+5Ly31dW16F+bG9mA855NU3W9w881/+XOdtsmI+Z2cmlRQwEXj+/DU61Wct4z6YTJO6Tl1NvO5eY2TYlGs4dAOaUl8peJWe7DXKPpDXMbEZpIf3pPNZeJ2mD0lokvcXMLs3dKL5L8PO5201kKzPLXoAm6zu1mc2U9N2cbTbMypJqmWyqm86777GldXQ4tFC731X1VN1SFBmj7EsQwLzyO2fWIg4NcpOk9buZ6GqKzhPXbZLa4MW4sZldm7tR4ERJWa3FuyD7GGWfVTezFyVlLeDQMOtK2rm0iIHoPHEdU1pHh0MKtfttSa17RRuEr+RusEgSAm5GcZ/c664XuNrM2jDj/irwtNi7JRW1Fpcv6b6xhFUW8GtJWa3FE0FuJ3ZLrgaLrKub2XOSeqlU8qYMs3ehFGY2XVIb8hVM0pcLtf1NuVdf2zFJB+dusAh48YaJcvfbXuBvZrZDaRED0aInrhmSVjOze3M3DPxR0i65201gpqQ1zeyuHI0Vy6wzs2ck/aRU+w2wPbBxaRED0Xni+mFpHfJkm4MKtX1koXarMqekbGXDim5EGGXJGiOhtZ7wwCLyJ65FCkt5UdJKnSpGWQEukvTW3O0mMF3SKmZ2f9MNFc2tN7MnJLUyky6Rd5HZr26kmNkUST8rrUPSvJI+V6jtowq1W5W5JWVxyyq+FRGvsDNBzW64yMlpZvah0iIGAlhS0r1qpmZiFZ6VtIKZTc7dMHCFpOypyQm8IH9SmtRkI8UDgOR11SR9orSOmmh0oqszobecfPPLYpLG9fv05yX5Bfe0pOfl47xFE9oqcriZfT13o8Dukn6Xu91EjjazRvMn2hIAVpR0p8ruyKqTn5rZgakH4xZSa0haS77jbQ1JK8qzJ+uwl3pS0pnyQLJc57xZjTU6GpY3s2k5G+3sSr1Jvs237Twjf1J6qqkGWhEAJK+rJmnf0jpq4gVJK5rZI8P9w84d/U2SNul8NpW0QqPqnI3M7Lo+OhaUB5q1+3zeqGYTiL5kZtn3KwD7SDo9d7uJ/K+ZNWZ60qYAsKa8XkCbin50wzFm9qrEF9z/cCNJb+98Npc0T2ZtknSumQ27kQlYRl5XYIvOnxvJJ/LqYJL8PfeFms43IjrfwZ3yp6q284T8KaCRJ6XWBABJAs5WS3fXJTBV/oj7VOfuupOkPSTtqPJLcZJnxq1tZrdXOajzxLKNvB87qvuNRgea2U+7PEdlcDfq7O0m8mUza2RPR9sCwAbyPeyt0tUFZ8nv7juo/Mz7QPzSzPbr5gTASpJ2l7S3/BWmKvfKJ02zbtgB5pOvPrXW56EPj8iflJ6v+8Stetw2s+sl/aW0jpq4Sv5uv7vaefFLNdidmdkEM/tep67dSvIdbTdWOMWKKrBRp/PaMVp2pTZmJ9a6Oy2wmaQROQO1kKfkhU9/YmY3AnvL69K1mR+Z2afrPimwoaSPS3q/hs/0vE3SOmaWdcNO59XsPuVfAUnhAXl2YCtrUNYK8M+aSi7n4jpgH2Cefv2Yk/pq3TfFc3iCUFPf5TjgQGD8MDre3ZSGYfQd3vQA18iYMRV9e+mRHgGzcBeerYfpy/6FdY6Exu3OcG+IXRncJeqapjUMomtxYGquge6SMWUndlXp0R6EmcDZwLoj7Mc8wP1lJQ9LVrszYCvgzwPo2D6Xhn56js062t0xZuzEdi090v2YhV/4lTf7AJ8prH0kZLc7A7YALuuj4eLcGjo6lqGM0WwKY8pO7MbCgz2bfwNbddGXBYBHC/dhOCYDRbZl4698N3R0bFlIw8+KjXx1di0xRtnB/dhKMhHYmxoiLvCVwn0ZCaW26c6eMN0ft/c+gH4TqhnaXwmYXnDsq3B1zrEpBuVm0acDxwML19iXccBTBfpShQfIfOENME6/6GiZCHwcT9vN1fYZhcY9he1yjUtRgA9nHtjLgTc21JcjM/clhY820fcKY7Q6PtE6m9uAj+KZe023vQ71Ov82ycVNj0crAOYG7s0woM8DB9PgMgu+5DQtQ1+64W4y3nUHGaezB9D1GPBtvIBMk23/Pudgd0mR+ZLsAJ9seCCvA7LsD8dfLdpO0aUmYAMGvxM/B5wObEsDs+HAppnGuA56JW1+aID5gUkNDOAs4CjcPCNXX5YDXmygL3VyI4WXmoDzR6BzAvA1fENSnW3/vcnBrZkN6+x7awG+VPPAPU259NOTa+5LE7yzxNj0GaPNK+odj78ibEmXwQt4W92D2SDndtPXUZNQgK9RT5T0mhpOd7Wkvc1sYg3nqgywqnwDTJvTOq80s6K1A4FLJaXkX9wr6R+SLpb0z5QS5MBV8upMTfOkpIsk/U2+dfxHFY+fJbcTy265lh38ca9bTsMdikv35Tc19KVptik8RjvW1I/b8OXFT+NPCMMmPAG71dR2f6bgm90Ow+cb5uzT5hzArQnnPCN1jEfNE4D0crHMiZJS1ueRdJiko9pg5Q2sJ+l6tfs7uNDMiuTnzwa4Tl5XoU5myS3qZ38mdD4PS3pc0mRJ0+TFQ7vxeXhMXhvhP53P9ZLuHur3B+wr6bSK7cyQtIaZ3VNVYJt/fAOC71xLMVDc18ySI2UTAOdJKvquPQI2MbMiO/UkCdhTXmMhNy/JbxrT5RfybJ6TuxtN6fy/Zzp/d598z/7sz30pFXzwJdg75MVVqnCymX2sanujDmBJ4NmEx6Tai150C7BZQj9y09UkUw1jNAdwS8H+Z8+OBD6RoPMlEqo7taok2Egws0cl/Tzh0C/n/iKHw8yukk9UtZmidmedKkHZS4f3YVnlL1d/iqSqvoDZ7MSKAyxL2lr6R0pr7w+wfUI/cvPLwmOUKxt0MO4mcyEO4HMJOp+n4UzJ1kDaWnrxNNeBwLcbt5kZwMqFx+hThcfgPZn7m7qFfLQYoHYHsDJp2zezV6AdDuDdCf3IzY8Lj9F8wMMF+38DmbMjgUMTdE7BV8t6H+DXCQM0HveHaw148ZObE/qSkxdwl6CS43Rw4THYKXN/xwFPJuj82kjbaNWFkMA35Wu6VVhL0i4NaEmmsy78ndI6hmFeSZ8trOEn8tLrpfhqzsbM7BlJKU9en6XGWhathrTtm9fRsrpqePGTuxL6kpNpwOKFx+mIwmMwZBXoBvq7OPBMgs6DRnL+0f4EIElHyBM2qvAmuTFnazCzmWq/U82Ckj5ZWMPx8iy9UnwlZ2Nm9oSkExMOPQhoqyNVvQB/TYiQF5fW3R9gXuChhL7k5AkKFQ/tM07fKzwGWbfgAkvhdRCqMmywbtVjcCr4Y9klCYduZWaX162nG/BHt0acYGvkH5KukfSgPGHlAUkTzSzL+znwenkOf6lNXeeY2V45G8RXYQ6seNj9cjux6YP9g54IAFLy1tELzOwdTehJhXq3PefmYUnjJd0i6VZJN0i6cagfYCrACXLvwRIkWat3A57me5c8468KHzGzUxqQ1C5I3zrauooqjC6/uuF4DrgU+A6wO1CLESeeBzKjYL9+UUc/Kvb5lASdQ9qJ9cwTgCTh/nIbVTzsXDPbswk9qQCvke8u69WlnFslnSfp75IuTXW8BX4ldx8uwXRJq+YsKgOsIul2VS8k8z4za7tLdfcA70qIkDOBtUpr7wuwEPCXhL6MRp7G6/HvRsXS35Qv4/2Dpn4DQ/Q5pZDMmLETS906enoLtM+HpwSfRdqMby8wBQ8GuzLCQq3AHwrqfQ5YounfRr/+rkta0Nstp85iAPskDM4MvE5fCb1r4cUsJyfo7mUm4SXUhyzXDmxSWOeRuX4rffr8xwSdY8ZObC58119VTsiocT7c7abtuwDbwCzgIuA9DDKZRdky3k8Di+T67XT6mxr0ipZ3ywbwsYTBeQl4Q8O6XodvaGl7sk9buRcfv0X6jWvpMt6HNvm7GeS3dGGCzotz6ywCMA9eyqkqxzWkZzngx3jBhqB7ngS+BbyuzxhfVVDPo8ACTfx2hvhNbZOo9RV2Yr2wF+BVdJaVUspIfZwaJ3WAJfAipnfKs7gaN7gcIywmz8m/F58/WUxSyUIYS0jKWm3KzC6WlJLF+oqnlZ4MAB1O0iuruY6EBVTDlldgUeAYeUbfwYoLvykWlI/vBEnrynMnSnEQGS3mOnwr4Zh30Cf5rafXBoFDVP3OMEXSCmb2dEJ7c0s6QNLXJBXdNtuHyfJANPtzn6RJ8n4+2/k8I2mqvL685DeG2e/ZC0uaS96fpeVFMpeStJykJeXlq7MuhbWY/c0sW4YgvrZ/rar7JvzWzPaQej8AjJP/4KuWSDrMzCot7wDbyW2dVqvYVl1Ml3SzpOs6n2sl3WFmjW+d7bw2rStpvc6f68oLr7SqCnMG7pC0VqeScRZwf8uqpdvHlJ1YSgGJx4EFR3j+pYBfJU7IdMM04Dzc7mpjWmB31hd8InZrfF/DZfgqy1gg9y7BOfAyd1U5Q+rxJwDJK6rInwKq7mH/gpkNuiqAP359VF7Ka9FkgdW4WdIFkv4q6XIzezFTu12DB9StJW0raTdJRRKvMnC9pA1z2s8B+0iqms06Q9Xdh0YnwLEJEfIhBrmrAsswMv/6OhgPHELDOQq5ATYEjgHuzzSOOcm6xZz05LcUi73RB7A0aWvwnxjgXB8grVJrFR4Fvk8LtyrXDV4ReUvgh/ROOvSlBcYxJfktpYjO6ARPxKnKBDpGIsCCwKkJ56jCRfhGmNaZl+QAmB//Id/U8DjnYMvhe1zLmM0FbEfab/OhHBpbAbACaRNRHwTWJm2iZSRMx/0Nev5uXwVgW7zi88yGxr1pzm9wbBbGd46ehE9Yp/Jcz08C9gWv4rJfxcMelk/y1Z3qOVWerHS8mVU1ghwzACtJ+pI80y53ok03IJ8MvL7rE/kE6qbykndvkbSl6hmLh8daAFhdXrMuq9FjP16SdIKkI8xsckEdowrcm/AISe/V6MlgPcvM9q5yAO6+tKo8l2J9SRtIWkfNBL9Lx1QAkCTgTElZjR5nNy1P2PiKmd1doP2eAFhX0pGS3llaywiYKel9+q+b0VzyzMpF5cvSi0l6vTyjcjlJK8vTm3Nx2FgMAOvJ12pz9v1fkg4ys6syttnTAFvI07yzOvX0ENMlrTFaHqVqw8xulPTnTM09KemDZrZlXPz1YmZXmNlbJO0s6abSekYhPzezCWPuCUCSgM0kXdlwM+dI+pSZPdpwO2Me3O35fZK+Ln+MDobmdkmbmtkzY+4JQJI6d+N/NHT6RyTtYWZ7xcWfBzObZWa/krS6fJLwP4UltZn7Je3ecR4eu+DrzHVzOl6cIigMnhxzIWXLhreNfwBLlv5uWgNwRU0D+zzwsdL9CV4NsBruSvRoTd/1aGMWcDmw80DjMybnAGbTGZQ/dXmaCZL2MrN47GwxwDySdpcngr1doyupKIX7JZ0m6TQzu2uwfzTWA4DJ3xfXTzzFeZI+lMsVN6gH3HptN3k+yNvUO8FgoqTfdj5XjKQwyZgOAJKEF3A4K+HQ4yR9Mee+76B+OsFge0nbdT7LlVVUiemSrpJ7LP7ZzK6reoIIAL6ENF7SGhUPPcPM9m1AUlAQYE35K8JmkjaRtEpZRa/gWXmpt6skXSbpkm5Lvo35ACBJwIcknVrxsBmS1jCze+pXFLQF3M58E3nhzbXkNR9XV/UKU5Walb/D3yq/Od0qz169xcxmDHVgVSIA6OVqvndKWqHioSeZ2cfrVxS0HbxC0/LyXP6l+vy5iKT55QVRF5RvPBsnf1yffbd+Tl6J+Ql5tuiTkh6SX/QTJd0/msq99QTAAQlLLI3biQVBkAFgXtI8+75fWnsQBDUAfDEhADwPLFVaexAEXYLX/XssIQikWDQFQdA2gK8mBIApxB6AIBj9AIsATyUEga+W1h4EQQ3g3vNVeQJYuLT2IAi6BFgcmJoQBA4qrT0IghrAnXmq8ggwf2ntQRB0CbAs8EJCEDiwtPYgCGoAODEhANyP7z0AHkJGAAAEo0lEQVQPgmA0A6yEW3dV5cOltQdBUAN4nb+q3A2UdB8KgqAOgDVJM6isZAkVBEFLAc5NCAC34MVGgiAYzQDrk1ZeetfS2oMgqAHgLwkB4OrSuoMgqAFg84QAAPD20tqDIKgB4JKEAPDP0rqDIKgBYPvEp4AtS2sPgqAGSLMTO7+07iAIagDYLfEpYKPS2oMg6BLAgJsSAsA5pbUHQVADwPsSAsAsYJ3S2oMg6BJgTuCOhCBwemntQRDUAPCRhAAwA1i1tPYgCLoEmBu4LyEInFBaexAENQB8OiEAhJ1YEPQCwHzAwwlBIOzEgqAXAL6cEACeBZYorT0Igi7B7cQeTwgCYScWBL0AcHhCAAg7sSDoBYDXAM8kBIGwEwuCXgD4TkIACDuxIOgFgCWB5xKCQNiJBUEvAPwoIQCEnVgQ9ALAcsCLCUEg7MSCoBcAfp4QAMJOLAh6AWBlwk4sCMYuwP9PCABhJxYEvQCwFmEnFgRjF+APCQEg7MSCoBcANkkIABB2YkHQGwAXJgSAsBMLgl4A2CbxKSDsxIKgFwAuSwgAYScWBL0A8I7Ep4CwEwuCXgC4JiEAhJ1YEPQCwB6JTwFhJxYEox3cTuzmhAAQdmJB0AsA+yYEgLATC4JeALcTuyshCISdWBD0AsAnEgJA2IkFQS+A24lNTAgCYScWBL0A8LmEABB2YkHQCwALAI8mBIGwEwuCXgA4NCEAhJ1YEPQCwDjgqYQgEHZiQdALAN9MCABhJxYEvQCwODA1IQiEnVgQ9ALAdxMCQNiJBUEvACxFmp3YF0trD4KgBoCfJgSASYSdWBCMfoA34Ik+VQk7sSDoBYBfJgSAsBMLgl4AWIM0I5H9SmsPgqAGgLMTAsBdhJ1YEIx+gPXwAiBVCTuxIOgFgD8lBICwEwuCXgDYNCEAAOxSWnsQBDUAXJQQAMJOLAh6AeBtiU8BYScWBL0A8K+EABB2YkHQCwC7JD4FhJ1YEIx2cCOR6xICwJ9Law+CoAaAvROfAsJOLAhGO7iRyO0JASDsxIKgFwD2SwgAYScWBL0AbiRyb0IQOK209iAIagA4MCEAhJ1YEPQCwLzAQwlBIOzEgqAXAA5KCABhJxYEvQCwIPB4QhA4rrT2IAhqAPhaQgAIO7Eg6AWARQg7sSAYuwBHJQSAsBMLgl4AeC0wLSEIhJ1YEPQCwPEJASDsxIKgFwCWBV5MCAJhJxYEvQBwUkIACDuxIOgFgJWA6QlBIOzEgqAXAH6VEADCTiwIegFgTcJOLAjGLsBvEwJA2IkFQS8AbEDYiQXB2AW4ICEAhJ1YEPQCwOYJAQDCTiwIegPg0oQAEHZiQdALADskPgWEnVgQ9ALANQkBIOzEgqAXAN6V+BSwVmntQTliJrh3+L2kWxKO26ZmHcEoIgJAj2BmSDoq4dAl69YSjB4iAPQWZ0q6u+Ixk5sQEowOIgD0EGY2U9LRFQ+7pAktQRAUAJgHuHmEE4B/K603CIKaATYEpg5z8U8Cli+tNQiCBgDWA24b5OK/HFi5tMagPFZaQNAc+IafHSRtIWlpSY9J+oukyzurBkEQBEEQBEEQBMHY4f8Ab3+4tb791uMAAAAASUVORK5CYII="}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlagText_vue__ = __webpack_require__(315);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fbdc896_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlagText_vue__ = __webpack_require__(903);
function injectStyle (ssrContext) {
  __webpack_require__(901)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3fbdc896"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlagText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fbdc896_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlagText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(902);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("59acdee6", content, true, {});

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".price[data-v-3fbdc896]{font-size:20px;font-weight:700;color:#fff;font-style:normal}", ""]);

// exports


/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"price"},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d9511a4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinishBanner_vue__ = __webpack_require__(907);
function injectStyle (ssrContext) {
  __webpack_require__(905)
}
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d9511a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d9511a4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinishBanner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(906);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("3fe9cd47", content, true, {});

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".card3[data-v-2d9511a4]{display:flex;align-items:center;justify-content:space-between;border-radius:20px;padding:15px 18px;width:281px;box-shadow:0 2px 4px 0 rgba(0,0,0,.1);background:#e6362c;font-weight:700;font-size:17px;color:#fff;line-height:22px}.fs18[data-v-2d9511a4]{font-size:18px}", ""]);

// exports


/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card3"},[_c('p',[_c('span',{staticClass:"fs18"},[_vm._v("\n      Финиш!\n    ")]),_vm._v("\n    Запоминающая поездка на завод ждет тебя\n  ")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(306),"alt":"factory icon"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"roadWrap"},[_c('Car',{staticClass:"car",attrs:{"oldPosition":this.oldPosition,"newPosition":this.newPosition,"currentPosition":this.currentPosition,"calcTiming":this.calcTiming,"linear":this.linear},on:{"changePosition":this.getPosition}}),_vm._v(" "),_c('Road',{attrs:{"oldPosition":this.oldPosition,"newPosition":this.newPosition,"calcTiming":this.calcTiming,"linear":this.linear}}),_vm._v(" "),_vm._l((this.checkpoints),function(checkpoint){return _c('CheckPoint',{class:checkpoint.class,attrs:{"index":checkpoint.index,"currentPosition":_vm.currentPosition,"oldPosition":_vm.oldPosition,"position":checkpoint.position,"visibleFlag":_vm.visibleFlag,"toggleFlag":_vm.toggleFlag,"color":"#000000"},scopedSlots:_vm._u([{key:"text",fn:function(){return [_c('p',[_vm._v(_vm._s(checkpoint.text))])]},proxy:true}],null,true)},[_vm._v(" "),_c(checkpoint.element,{tag:"component",attrs:{"text":checkpoint.props}})],1)}),_vm._v(" "),_c('CheckPoint',{staticClass:"point5",attrs:{"index":5,"currentPosition":_vm.currentPosition,"oldPosition":_vm.oldPosition,"position":100,"visibleFlag":_vm.visibleFlag,"toggleFlag":_vm.toggleFlag,"isFinish":true},scopedSlots:_vm._u([{key:"banner",fn:function(){return [_c('FinishBanner')]},proxy:true}])},[_vm._v(" "),_c('FinishFlag')],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-in-page"},[_c('div',{staticClass:"block-header"},[_c('div',{staticClass:"block-header-left"},[_c('div',{staticClass:"my-balance"},[_vm._v("Вы проехали "),_c('span',[_vm._v(_vm._s(_vm.balance)+" км")])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"block-header-right"},[_c('div',{staticClass:"links"},[_c('p',[_vm._v("Регистрируйте чеки")]),_vm._v(" "),_c('a',{staticClass:"btn custom-btn",attrs:{"target":"_blank","href":"https://daccord.club/tasks/666"}},[_vm._v("\n                    На сайте\n                ")]),_vm._v(" "),_c('a',{staticClass:"btn custom-btn btn-icon",attrs:{"target":"_blank","href":"https://t.me/daccord_club_bot"}},[_c('img',{attrs:{"src":_vm.telegram,"alt":"Telegram icon"}})])])])]),_vm._v(" "),_c('div',{staticClass:"main"},[_c('div',{staticClass:"main-left"},[_c('a',{staticClass:"card card1",attrs:{"target":"_blank","href":"https://daccord.club/tasks/666"}},[_vm._m(1),_vm._v(" "),_c('img',{attrs:{"src":_vm.wallet,"alt":"wallet icon"}})]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('RoadAndCar',{attrs:{"newBalance":_vm.balance}}),_vm._v(" "),_c('footer',{staticClass:"footer"},[_c('div',{staticClass:"block-footer-right"},[_c('div',{staticClass:"links"},[_c('p',[_vm._v("Регистрируйте чеки")]),_vm._v(" "),_c('a',{staticClass:"btn custom-btn",attrs:{"target":"_blank","href":"https://daccord.club/tasks/666"}},[_vm._v("\n                    На сайте\n                ")]),_vm._v(" "),_c('a',{staticClass:"btn custom-btn btn-icon",attrs:{"target":"_blank","href":"https://t.me/daccord_club_bot"}},[_c('img',{attrs:{"src":_vm.telegram,"alt":"Telegram icon"}})])])]),_vm._v(" "),_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.logo,"alt":"logo icon"}})])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"balance-info"},[_c('p',[_vm._v("1 км = "),_c('span',{staticClass:"score"},[_vm._v("1 балл ")]),_vm._v(" = 1 ₽")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Загружай чеки"),_c('br'),_vm._v("и получай кешбэк"),_c('br'),_c('span',{staticClass:"cashback"},[_vm._v("7%")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"card card2",attrs:{"target":"_blank","href":"https://daccord.club/tasks"}},[_c('p',{staticClass:"card2-text"},[_vm._v("Выполняй новые "),_c('br'),_vm._v(" задания - получай "),_c('br'),_vm._v(" "),_c('span',[_vm._v("до "),_c('strong',[_vm._v("1000")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("баллов!")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[(_vm.info.User && _vm.info.ProjectsLength > 1)?_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[_c('project-select',{attrs:{"user":_vm.info.User},on:{"onChange":_vm.onProjectChange}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page"},[(_vm.info.SelectedProject.Id === _vm.currentProjectIds.Daccord)?_c('div',[_c('daccord-banner',{attrs:{"balance":_vm.currentBalance}})],1):_vm._e()]),_vm._v(" "),_c('vue-headful',{attrs:{"title":_vm.getPageTitle()}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
  * vue-router v3.5.4
  * (c) 2022 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (!condition) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function extend (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
    .replace(encodeReserveRE, encodeReserveReplacer)
    .replace(commaRE, ','); };

function decode (str) {
  try {
    return decodeURIComponent(str)
  } catch (err) {
    if (false) {
      warn(false, ("Error decoding \"" + str + "\". Leaving it intact."));
    }
  }
  return str
}

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    var value = extraQuery[key];
    parsedQuery[key] = Array.isArray(value)
      ? value.map(castQueryParamValue)
      : castQueryParamValue(value);
  }
  return parsedQuery
}

var castQueryParamValue = function (value) { return (value == null || typeof value === 'object' ? value : String(value)); };

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0 ? decode(parts.join('=')) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj
    ? Object.keys(obj)
      .map(function (key) {
        var val = obj[key];

        if (val === undefined) {
          return ''
        }

        if (val === null) {
          return encode(key)
        }

        if (Array.isArray(val)) {
          var result = [];
          val.forEach(function (val2) {
            if (val2 === undefined) {
              return
            }
            if (val2 === null) {
              result.push(encode(key));
            } else {
              result.push(encode(key) + '=' + encode(val2));
            }
          });
          return result.join('&')
        }

        return encode(key) + '=' + encode(val)
      })
      .filter(function (x) { return x.length > 0; })
      .join('&')
    : null;
  return res ? ("?" + res) : ''
}

/*  */

var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b, onlyPath) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') && (onlyPath ||
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query))
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      (onlyPath || (
        a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params))
      )
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a).sort();
  var bKeys = Object.keys(b).sort();
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key, i) {
    var aVal = a[key];
    var bKey = bKeys[i];
    if (bKey !== key) { return false }
    var bVal = b[key];
    // query values can be null and undefined
    if (aVal == null || bVal == null) { return aVal === bVal }
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

function handleRouteEntered (route) {
  for (var i = 0; i < route.matched.length; i++) {
    var record = route.matched[i];
    for (var name in record.instances) {
      var instance = record.instances[name];
      var cbs = record.enteredCbs[name];
      if (!instance || !cbs) { continue }
      delete record.enteredCbs[name];
      for (var i$1 = 0; i$1 < cbs.length; i$1++) {
        if (!instance._isBeingDestroyed) { cbs[i$1](instance); }
      }
    }
  }
}

var View = {
  name: 'RouterView',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    // used by devtools to display a router-view badge
    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      var vnodeData = parent.$vnode ? parent.$vnode.data : {};
      if (vnodeData.routerView) {
        depth++;
      }
      if (vnodeData.keepAlive && parent._directInactive && parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      var cachedData = cache[name];
      var cachedComponent = cachedData && cachedData.component;
      if (cachedComponent) {
        // #2301
        // pass props
        if (cachedData.configProps) {
          fillPropsinData(cachedComponent, data, cachedData.route, cachedData.configProps);
        }
        return h(cachedComponent, data, children)
      } else {
        // render previous empty view
        return h()
      }
    }

    var matched = route.matched[depth];
    var component = matched && matched.components[name];

    // render empty node if no matched route or no config component
    if (!matched || !component) {
      cache[name] = null;
      return h()
    }

    // cache component
    cache[name] = { component: component };

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // register instance in init hook
    // in case kept-alive component be actived when routes changed
    data.hook.init = function (vnode) {
      if (vnode.data.keepAlive &&
        vnode.componentInstance &&
        vnode.componentInstance !== matched.instances[name]
      ) {
        matched.instances[name] = vnode.componentInstance;
      }

      // if the route transition has already been confirmed then we weren't
      // able to call the cbs during confirmation as the component was not
      // registered yet, so we call it here.
      handleRouteEntered(route);
    };

    var configProps = matched.props && matched.props[name];
    // save route and configProps in cache
    if (configProps) {
      extend(cache[name], {
        route: route,
        configProps: configProps
      });
      fillPropsinData(component, data, route, configProps);
    }

    return h(component, data, children)
  }
};

function fillPropsinData (component, data, route, configProps) {
  // resolve props
  var propsToPass = data.props = resolveProps(route, configProps);
  if (propsToPass) {
    // clone to prevent mutation
    propsToPass = data.props = extend({}, propsToPass);
    // pass non-declared props as attrs
    var attrs = data.attrs = data.attrs || {};
    for (var key in propsToPass) {
      if (!component.props || !(key in component.props)) {
        attrs[key] = propsToPass[key];
        delete propsToPass[key];
      }
    }
  }
}

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/(?:\s*\/)+/g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options));
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}
pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  params = params || {};
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));

    // Fix #2505 resolving asterisk routes { name: 'not-found', params: { pathMatch: '/not-found' }}
    // and fix #3106 so that you can work with location descriptor object having params.pathMatch equal to empty string
    if (typeof params.pathMatch === 'string') { params[0] = params.pathMatch; }

    return filler(params, { pretty: true })
  } catch (e) {
    if (false) {
      // Fix #3072 no warn if `pathMatch` is string
      warn(typeof params.pathMatch === 'string', ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  } finally {
    // delete the 0 if it was added
    delete params[0];
  }
}

/*  */

function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next._normalized) {
    return next
  } else if (next.name) {
    next = extend({}, raw);
    var params = next.params;
    if (params && typeof params === 'object') {
      next.params = extend({}, params);
    }
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = extend({}, next);
    next._normalized = true;
    var params$1 = extend(extend({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params$1;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params$1, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var noop = function () {};

var warnedCustomSlot;
var warnedTagProp;
var warnedEventProp;

var Link = {
  name: 'RouterLink',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    custom: Boolean,
    exact: Boolean,
    exactPath: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    ariaCurrentValue: {
      type: String,
      default: 'page'
    },
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(
      this.to,
      current,
      this.append
    );
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback =
      globalActiveClass == null ? 'router-link-active' : globalActiveClass;
    var exactActiveClassFallback =
      globalExactActiveClass == null
        ? 'router-link-exact-active'
        : globalExactActiveClass;
    var activeClass =
      this.activeClass == null ? activeClassFallback : this.activeClass;
    var exactActiveClass =
      this.exactActiveClass == null
        ? exactActiveClassFallback
        : this.exactActiveClass;

    var compareTarget = route.redirectedFrom
      ? createRoute(null, normalizeLocation(route.redirectedFrom), null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget, this.exactPath);
    classes[activeClass] = this.exact || this.exactPath
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var ariaCurrentValue = classes[exactActiveClass] ? this.ariaCurrentValue : null;

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location, noop);
        } else {
          router.push(location, noop);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) {
        on[e] = handler;
      });
    } else {
      on[this.event] = handler;
    }

    var data = { class: classes };

    var scopedSlot =
      !this.$scopedSlots.$hasNormal &&
      this.$scopedSlots.default &&
      this.$scopedSlots.default({
        href: href,
        route: route,
        navigate: handler,
        isActive: classes[activeClass],
        isExactActive: classes[exactActiveClass]
      });

    if (scopedSlot) {
      if (false) {
        !warnedCustomSlot && warn(false, 'In Vue Router 4, the v-slot API will by default wrap its content with an <a> element. Use the custom prop to remove this warning:\n<router-link v-slot="{ navigate, href }" custom></router-link>\n');
        warnedCustomSlot = true;
      }
      if (scopedSlot.length === 1) {
        return scopedSlot[0]
      } else if (scopedSlot.length > 1 || !scopedSlot.length) {
        if (false) {
          warn(
            false,
            ("<router-link> with to=\"" + (this.to) + "\" is trying to use a scoped slot but it didn't provide exactly one child. Wrapping the content with a span element.")
          );
        }
        return scopedSlot.length === 0 ? h() : h('span', {}, scopedSlot)
      }
    }

    if (false) {
      if ('tag' in this.$options.propsData && !warnedTagProp) {
        warn(
          false,
          "<router-link>'s tag prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
        );
        warnedTagProp = true;
      }
      if ('event' in this.$options.propsData && !warnedEventProp) {
        warn(
          false,
          "<router-link>'s event prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
        );
        warnedEventProp = true;
      }
    }

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href, 'aria-current': ariaCurrentValue };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var aData = (a.data = extend({}, a.data));
        aData.on = aData.on || {};
        // transform existing events in both objects into arrays so we can push later
        for (var event in aData.on) {
          var handler$1 = aData.on[event];
          if (event in on) {
            aData.on[event] = Array.isArray(handler$1) ? handler$1 : [handler$1];
          }
        }
        // append new listeners for router-link
        for (var event$1 in on) {
          if (event$1 in aData.on) {
            // on[event] is always a function
            aData.on[event$1].push(on[event$1]);
          } else {
            aData.on[event$1] = handler;
          }
        }

        var aAttrs = (a.data.attrs = extend({}, a.data.attrs));
        aAttrs.href = href;
        aAttrs['aria-current'] = ariaCurrentValue;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('RouterView', View);
  Vue.component('RouterLink', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap,
  parentRoute
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route, parentRoute);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  if (false) {
    // warn if routes do not include leading slashes
    var found = pathList
    // check for missing leading slash
      .filter(function (path) { return path && path.charAt(0) !== '*' && path.charAt(0) !== '/'; });

    if (found.length > 0) {
      var pathNames = found.map(function (path) { return ("- " + path); }).join('\n');
      warn(false, ("Non-nested routes must include a leading slash character. Fix the following routes: \n" + pathNames));
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(
        path || name
      )) + " cannot be a " + "string id. Use an actual component instead."
    );

    warn(
      // eslint-disable-next-line no-control-regex
      !/[^\u0000-\u007F]+/.test(path),
      "Route with path \"" + path + "\" contains unencoded characters, make sure " +
        "your path is correctly encoded before passing it to the router. Use " +
        "encodeURI to encode static segments of your path."
    );
  }

  var pathToRegexpOptions =
    route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(path, parent, pathToRegexpOptions.strict);

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    alias: route.alias
      ? typeof route.alias === 'string'
        ? [route.alias]
        : route.alias
      : [],
    instances: {},
    enteredCbs: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props:
      route.props == null
        ? {}
        : route.components
          ? route.props
          : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (
        route.name &&
        !route.redirect &&
        route.children.some(function (child) { return /^\/?$/.test(child.path); })
      ) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
            "When navigating to this named route (:to=\"{name: '" + (route.name) + "'}\"), " +
            "the default child route will not be rendered. Remove the name from " +
            "this route and use the name of the default child route for named " +
            "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias) ? route.alias : [route.alias];
    for (var i = 0; i < aliases.length; ++i) {
      var alias = aliases[i];
      if (false) {
        warn(
          false,
          ("Found an alias with the same value as the path: \"" + path + "\". You have to remove that alias. It will be ignored in development.")
        );
        // skip in dev to make it work
        continue
      }

      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    }
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
          "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (
  path,
  pathToRegexpOptions
) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(
        !keys[key.name],
        ("Duplicate param keys in route with path: \"" + path + "\"")
      );
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (
  path,
  parent,
  strict
) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */



function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function addRoute (parentOrRoute, route) {
    var parent = (typeof parentOrRoute !== 'object') ? nameMap[parentOrRoute] : undefined;
    // $flow-disable-line
    createRouteMap([route || parentOrRoute], pathList, pathMap, nameMap, parent);

    // add aliases of parent
    if (parent && parent.alias.length) {
      createRouteMap(
        // $flow-disable-line route is defined if parent is
        parent.alias.map(function (alias) { return ({ path: alias, children: [route] }); }),
        pathList,
        pathMap,
        nameMap,
        parent
      );
    }
  }

  function getRoutes () {
    return pathList.map(function (path) { return pathMap[path]; })
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
      return _createRoute(record, location, redirectedFrom)
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
      ? originalRedirect(createRoute(record, location, null, router))
      : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoute: addRoute,
    getRoutes: getRoutes,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    if (key) {
      // Fix #1994: using * with props: true generates a param named 0
      params[key.name || 'pathMatch'] = typeof m[i] === 'string' ? decode(m[i]) : m[i];
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */

// use User Timing api (if present) for more accurate key precision
var Time =
  inBrowser && window.performance && window.performance.now
    ? window.performance
    : Date;

function genStateKey () {
  return Time.now().toFixed(3)
}

var _key = genStateKey();

function getStateKey () {
  return _key
}

function setStateKey (key) {
  return (_key = key)
}

/*  */

var positionStore = Object.create(null);

function setupScroll () {
  // Prevent browser scroll behavior on History popstate
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  // Fix for #1585 for Firefox
  // Fix for #2195 Add optional third attribute to workaround a bug in safari https://bugs.webkit.org/show_bug.cgi?id=182678
  // Fix for #2774 Support for apps loaded from Windows file shares not mapped to network drives: replaced location.origin with
  // window.location.protocol + '//' + window.location.host
  // location.host contains the port and location.hostname doesn't
  var protocolAndPath = window.location.protocol + '//' + window.location.host;
  var absolutePath = window.location.href.replace(protocolAndPath, '');
  // preserve existing history state as it could be overriden by the user
  var stateCopy = extend({}, window.history.state);
  stateCopy.key = getStateKey();
  window.history.replaceState(stateCopy, '', absolutePath);
  window.addEventListener('popstate', handlePopState);
  return function () {
    window.removeEventListener('popstate', handlePopState);
  }
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior.call(
      router,
      to,
      from,
      isPop ? position : null
    );

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll
        .then(function (shouldScroll) {
          scrollToPosition((shouldScroll), position);
        })
        .catch(function (err) {
          if (false) {
            assert(false, err.toString());
          }
        });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function handlePopState (e) {
  saveScrollPosition();
  if (e.state && e.state.key) {
    setStateKey(e.state.key);
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

var hashStartsWithNumberRE = /^#\d/;

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    // getElementById would still fail if the selector contains a more complicated query like #main[data-attr]
    // but at the same time, it doesn't make much sense to select an element with an id and an extra selector
    var el = hashStartsWithNumberRE.test(shouldScroll.selector) // $flow-disable-line
      ? document.getElementById(shouldScroll.selector.slice(1)) // $flow-disable-line
      : document.querySelector(shouldScroll.selector);

    if (el) {
      var offset =
        shouldScroll.offset && typeof shouldScroll.offset === 'object'
          ? shouldScroll.offset
          : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    // $flow-disable-line
    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({
        left: position.x,
        top: position.y,
        // $flow-disable-line
        behavior: shouldScroll.behavior
      });
    } else {
      window.scrollTo(position.x, position.y);
    }
  }
}

/*  */

var supportsPushState =
  inBrowser &&
  (function () {
    var ua = window.navigator.userAgent;

    if (
      (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
      ua.indexOf('Mobile Safari') !== -1 &&
      ua.indexOf('Chrome') === -1 &&
      ua.indexOf('Windows Phone') === -1
    ) {
      return false
    }

    return window.history && typeof window.history.pushState === 'function'
  })();

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      // preserve existing history state as it could be overriden by the user
      var stateCopy = extend({}, history.state);
      stateCopy.key = getStateKey();
      history.replaceState(stateCopy, '', url);
    } else {
      history.pushState({ key: setStateKey(genStateKey()) }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

// When changing thing, also edit router.d.ts
var NavigationFailureType = {
  redirected: 2,
  aborted: 4,
  cancelled: 8,
  duplicated: 16
};

function createNavigationRedirectedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.redirected,
    ("Redirected when going from \"" + (from.fullPath) + "\" to \"" + (stringifyRoute(
      to
    )) + "\" via a navigation guard.")
  )
}

function createNavigationDuplicatedError (from, to) {
  var error = createRouterError(
    from,
    to,
    NavigationFailureType.duplicated,
    ("Avoided redundant navigation to current location: \"" + (from.fullPath) + "\".")
  );
  // backwards compatible with the first introduction of Errors
  error.name = 'NavigationDuplicated';
  return error
}

function createNavigationCancelledError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.cancelled,
    ("Navigation cancelled from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" with a new navigation.")
  )
}

function createNavigationAbortedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.aborted,
    ("Navigation aborted from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" via a navigation guard.")
  )
}

function createRouterError (from, to, type, message) {
  var error = new Error(message);
  error._isRouter = true;
  error.from = from;
  error.to = to;
  error.type = type;

  return error
}

var propertiesToLog = ['params', 'query', 'hash'];

function stringifyRoute (to) {
  if (typeof to === 'string') { return to }
  if ('path' in to) { return to.path }
  var location = {};
  propertiesToLog.forEach(function (key) {
    if (key in to) { location[key] = to[key]; }
  });
  return JSON.stringify(location, null, 2)
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

function isNavigationFailure (err, errorType) {
  return (
    isError(err) &&
    err._isRouter &&
    (errorType == null || err.type === errorType)
  )
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
  this.listeners = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (
  location,
  onComplete,
  onAbort
) {
    var this$1 = this;

  var route;
  // catch redirect option https://github.com/vuejs/vue-router/issues/3201
  try {
    route = this.router.match(location, this.current);
  } catch (e) {
    this.errorCbs.forEach(function (cb) {
      cb(e);
    });
    // Exception should still be thrown
    throw e
  }
  var prev = this.current;
  this.confirmTransition(
    route,
    function () {
      this$1.updateRoute(route);
      onComplete && onComplete(route);
      this$1.ensureURL();
      this$1.router.afterHooks.forEach(function (hook) {
        hook && hook(route, prev);
      });

      // fire ready cbs once
      if (!this$1.ready) {
        this$1.ready = true;
        this$1.readyCbs.forEach(function (cb) {
          cb(route);
        });
      }
    },
    function (err) {
      if (onAbort) {
        onAbort(err);
      }
      if (err && !this$1.ready) {
        // Initial redirection should not mark the history as ready yet
        // because it's triggered by the redirection instead
        // https://github.com/vuejs/vue-router/issues/3225
        // https://github.com/vuejs/vue-router/issues/3331
        if (!isNavigationFailure(err, NavigationFailureType.redirected) || prev !== START) {
          this$1.ready = true;
          this$1.readyErrorCbs.forEach(function (cb) {
            cb(err);
          });
        }
      }
    }
  );
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  this.pending = route;
  var abort = function (err) {
    // changed after adding errors with
    // https://github.com/vuejs/vue-router/pull/3047 before that change,
    // redirect and aborted navigation would produce an err == null
    if (!isNavigationFailure(err) && isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) {
          cb(err);
        });
      } else {
        if (false) {
          warn(false, 'uncaught error during route navigation:');
        }
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  var lastRouteIndex = route.matched.length - 1;
  var lastCurrentIndex = current.matched.length - 1;
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    lastRouteIndex === lastCurrentIndex &&
    route.matched[lastRouteIndex] === current.matched[lastCurrentIndex]
  ) {
    this.ensureURL();
    if (route.hash) {
      handleScroll(this.router, current, route, false);
    }
    return abort(createNavigationDuplicatedError(current, route))
  }

  var ref = resolveQueue(
    this.current.matched,
    route.matched
  );
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort(createNavigationCancelledError(current, route))
    }
    try {
      hook(route, current, function (to) {
        if (to === false) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(createNavigationAbortedError(current, route));
        } else if (isError(to)) {
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' &&
            (typeof to.path === 'string' || typeof to.name === 'string'))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort(createNavigationRedirectedError(current, route));
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort(createNavigationCancelledError(current, route))
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          handleRouteEntered(route);
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  this.current = route;
  this.cb && this.cb(route);
};

History.prototype.setupListeners = function setupListeners () {
  // Default implementation is empty
};

History.prototype.teardown = function teardown () {
  // clean up event listeners
  // https://github.com/vuejs/vue-router/issues/2341
  this.listeners.forEach(function (cleanupListener) {
    cleanupListener();
  });
  this.listeners = [];

  // reset current history route
  // https://github.com/vuejs/vue-router/issues/3294
  this.current = START;
  this.pending = null;
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated
) {
  return extractGuards(
    activated,
    'beforeRouteEnter',
    function (guard, _, match, key) {
      return bindEnterGuard(guard, match, key)
    }
  )
}

function bindEnterGuard (
  guard,
  match,
  key
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      if (typeof cb === 'function') {
        if (!match.enteredCbs[key]) {
          match.enteredCbs[key] = [];
        }
        match.enteredCbs[key].push(cb);
      }
      next(cb);
    })
  }
}

/*  */

var HTML5History = /*@__PURE__*/(function (History) {
  function HTML5History (router, base) {
    History.call(this, router, base);

    this._startLocation = getLocation(this.base);
  }

  if ( History ) HTML5History.__proto__ = History;
  HTML5History.prototype = Object.create( History && History.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === this$1._startLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (supportsScroll) {
          handleScroll(router, route, current, true);
        }
      });
    };
    window.addEventListener('popstate', handleRoutingEvent);
    this.listeners.push(function () {
      window.removeEventListener('popstate', handleRoutingEvent);
    });
  };

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  var pathLowerCase = path.toLowerCase();
  var baseLowerCase = base.toLowerCase();
  // base="/a" shouldn't turn path="/app" into "/a/pp"
  // https://github.com/vuejs/vue-router/issues/3555
  // so we ensure the trailing slash in the base
  if (base && ((pathLowerCase === baseLowerCase) ||
    (pathLowerCase.indexOf(cleanPath(baseLowerCase + '/')) === 0))) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */

var HashHistory = /*@__PURE__*/(function (History) {
  function HashHistory (router, base, fallback) {
    History.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History ) HashHistory.__proto__ = History;
  HashHistory.prototype = Object.create( History && History.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    };
    var eventType = supportsPushState ? 'popstate' : 'hashchange';
    window.addEventListener(
      eventType,
      handleRoutingEvent
    );
    this.listeners.push(function () {
      window.removeEventListener(eventType, handleRoutingEvent);
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        pushHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        replaceHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(cleanPath(base + '/#' + location));
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  // empty path
  if (index < 0) { return '' }

  href = href.slice(index + 1);

  return href
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */

var AbstractHistory = /*@__PURE__*/(function (History) {
  function AbstractHistory (router, base) {
    History.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History ) AbstractHistory.__proto__ = History;
  AbstractHistory.prototype = Object.create( History && History.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
        this$1.index++;
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(
      route,
      function () {
        var prev = this$1.current;
        this$1.index = targetIndex;
        this$1.updateRoute(route);
        this$1.router.afterHooks.forEach(function (hook) {
          hook && hook(route, prev);
        });
      },
      function (err) {
        if (isNavigationFailure(err, NavigationFailureType.duplicated)) {
          this$1.index = targetIndex;
        }
      }
    );
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  if (false) {
    warn(this instanceof VueRouter, "Router must be called with the new operator.");
  }
  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback =
    mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (raw, current, redirectedFrom) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' &&
    assert(
      install.installed,
      "not installed. Make sure to call `Vue.use(VueRouter)` " +
        "before creating root instance."
    );

  this.apps.push(app);

  // set up app destroyed handler
  // https://github.com/vuejs/vue-router/issues/2639
  app.$once('hook:destroyed', function () {
    // clean out app from this.apps array once destroyed
    var index = this$1.apps.indexOf(app);
    if (index > -1) { this$1.apps.splice(index, 1); }
    // ensure we still have a main app or null if no apps
    // we do not release the router so it can be reused
    if (this$1.app === app) { this$1.app = this$1.apps[0] || null; }

    if (!this$1.app) { this$1.history.teardown(); }
  });

  // main app previously initialized
  // return as we don't need to set up new history listener
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History || history instanceof HashHistory) {
    var handleInitialScroll = function (routeOrError) {
      var from = history.current;
      var expectScroll = this$1.options.scrollBehavior;
      var supportsScroll = supportsPushState && expectScroll;

      if (supportsScroll && 'fullPath' in routeOrError) {
        handleScroll(this$1, routeOrError, from, false);
      }
    };
    var setupListeners = function (routeOrError) {
      history.setupListeners();
      handleInitialScroll(routeOrError);
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupListeners,
      setupListeners
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.push(location, resolve, reject);
    })
  } else {
    this.history.push(location, onComplete, onAbort);
  }
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.replace(location, resolve, reject);
    })
  } else {
    this.history.replace(location, onComplete, onAbort);
  }
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply(
    [],
    route.matched.map(function (m) {
      return Object.keys(m.components).map(function (key) {
        return m.components[key]
      })
    })
  )
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  current = current || this.history.current;
  var location = normalizeLocation(to, current, append, this);
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.getRoutes = function getRoutes () {
  return this.matcher.getRoutes()
};

VueRouter.prototype.addRoute = function addRoute (parentOrRoute, route) {
  this.matcher.addRoute(parentOrRoute, route);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  if (false) {
    warn(false, 'router.addRoutes() is deprecated and has been removed in Vue Router 4. Use router.addRoute() instead.');
  }
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.5.4';
VueRouter.isNavigationFailure = isNavigationFailure;
VueRouter.NavigationFailureType = NavigationFailureType;
VueRouter.START_LOCATION = START;

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Touchspin_vue__ = __webpack_require__(316);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0acfc620_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Touchspin_vue__ = __webpack_require__(917);
function injectStyle (ssrContext) {
  __webpack_require__(913)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0acfc620"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Touchspin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0acfc620_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Touchspin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(914);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6b05b2fe", content, true, {});

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports
exports.i(__webpack_require__(915), "");

// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".bootstrap-touchspin .input-group-btn-vertical{position:absolute;right:0;height:100%;z-index:11}.bootstrap-touchspin .input-group-btn-vertical>.btn{position:absolute;right:0;height:50%;padding:0;width:2em;text-align:center;line-height:1}.bootstrap-touchspin .input-group-btn-vertical .bootstrap-touchspin-up{border-radius:0 4px 0 0;top:0}.bootstrap-touchspin .input-group-btn-vertical .bootstrap-touchspin-down{border-radius:0 0 4px 0;bottom:0}", ""]);

// exports


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
 *  Bootstrap TouchSpin - v4.2.5
 *  A mobile and touch friendly input spinner component for Bootstrap 3 & 4.
 *  http://www.virtuosoft.eu/code/bootstrap-touchspin/
 *
 *  Made by István Ujj-Mészáros
 *  Under Apache License v2.0 License
 */

!function (o) {
   true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6)], __WEBPACK_AMD_DEFINE_FACTORY__ = (o),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports ? module.exports = function (t, n) {
    return void 0 === n && (n = "undefined" != typeof window ? require("jquery") : require("jquery")(t)), o(n), n;
  } : o(jQuery);
}(function (j) {
  "use strict";
  var D = 0;j.fn.TouchSpin = function (y) {
    var k = { min: 0, max: 100, initval: "", replacementval: "", step: 1, decimals: 0, stepinterval: 100, forcestepdivisibility: "round", stepintervaldelay: 500, verticalbuttons: !1, verticalup: "+", verticaldown: "-", verticalupclass: "", verticaldownclass: "", prefix: "", postfix: "", prefix_extraclass: "", postfix_extraclass: "", booster: !0, boostat: 10, maxboostedstep: !1, mousewheel: !0, buttondown_class: "btn btn-primary", buttonup_class: "btn btn-primary", buttondown_txt: "-", buttonup_txt: "+", callback_before_calculation: function callback_before_calculation(t) {
        return t;
      }, callback_after_calculation: function callback_after_calculation(t) {
        return t;
      } },
        C = { min: "min", max: "max", initval: "init-val", replacementval: "replacement-val", step: "step", decimals: "decimals", stepinterval: "step-interval", verticalbuttons: "vertical-buttons", verticalupclass: "vertical-up-class", verticaldownclass: "vertical-down-class", forcestepdivisibility: "force-step-divisibility", stepintervaldelay: "step-interval-delay", prefix: "prefix", postfix: "postfix", prefix_extraclass: "prefix-extra-class", postfix_extraclass: "postfix-extra-class", booster: "booster", boostat: "boostat", maxboostedstep: "max-boosted-step", mousewheel: "mouse-wheel", buttondown_class: "button-down-class", buttonup_class: "button-up-class", buttondown_txt: "button-down-txt", buttonup_txt: "button-up-txt" };return this.each(function () {
      var i,
          p,
          a,
          u,
          o,
          s,
          t,
          n,
          e,
          r,
          c = j(this),
          l = c.data(),
          d = 0,
          f = !1;function b() {
        "" === i.prefix && (p = o.prefix.detach()), "" === i.postfix && (a = o.postfix.detach());
      }function h() {
        var t, n, o;"" !== (t = i.callback_before_calculation(c.val())) ? 0 < i.decimals && "." === t || (n = parseFloat(t), isNaN(n) && (n = "" !== i.replacementval ? i.replacementval : 0), (o = n).toString() !== t && (o = n), null !== i.min && n < i.min && (o = i.min), null !== i.max && n > i.max && (o = i.max), o = function (t) {
          switch (i.forcestepdivisibility) {case "round":
              return (Math.round(t / i.step) * i.step).toFixed(i.decimals);case "floor":
              return (Math.floor(t / i.step) * i.step).toFixed(i.decimals);case "ceil":
              return (Math.ceil(t / i.step) * i.step).toFixed(i.decimals);default:
              return t;}
        }(o), Number(t).toString() !== o.toString() && (c.val(o), c.trigger("change"))) : "" !== i.replacementval && (c.val(i.replacementval), c.trigger("change"));
      }function v() {
        if (i.booster) {
          var t = Math.pow(2, Math.floor(d / i.boostat)) * i.step;return i.maxboostedstep && t > i.maxboostedstep && (t = i.maxboostedstep, s = Math.round(s / t) * t), Math.max(i.step, t);
        }return i.step;
      }function x() {
        h(), s = parseFloat(i.callback_before_calculation(o.input.val())), isNaN(s) && (s = 0);var t = s,
            n = v();s += n, null !== i.max && s > i.max && (s = i.max, c.trigger("touchspin.on.max"), _()), o.input.val(i.callback_after_calculation(Number(s).toFixed(i.decimals))), t !== s && c.trigger("change");
      }function g() {
        h(), s = parseFloat(i.callback_before_calculation(o.input.val())), isNaN(s) && (s = 0);var t = s,
            n = v();s -= n, null !== i.min && s < i.min && (s = i.min, c.trigger("touchspin.on.min"), _()), o.input.val(i.callback_after_calculation(Number(s).toFixed(i.decimals))), t !== s && c.trigger("change");
      }function m() {
        _(), d = 0, f = "down", c.trigger("touchspin.on.startspin"), c.trigger("touchspin.on.startdownspin"), e = setTimeout(function () {
          t = setInterval(function () {
            d++, g();
          }, i.stepinterval);
        }, i.stepintervaldelay);
      }function w() {
        _(), d = 0, f = "up", c.trigger("touchspin.on.startspin"), c.trigger("touchspin.on.startupspin"), r = setTimeout(function () {
          n = setInterval(function () {
            d++, x();
          }, i.stepinterval);
        }, i.stepintervaldelay);
      }function _() {
        switch (clearTimeout(e), clearTimeout(r), clearInterval(t), clearInterval(n), f) {case "up":
            c.trigger("touchspin.on.stopupspin"), c.trigger("touchspin.on.stopspin");break;case "down":
            c.trigger("touchspin.on.stopdownspin"), c.trigger("touchspin.on.stopspin");}d = 0, f = !1;
      }!function () {
        if (c.data("alreadyinitialized")) return;if (c.data("alreadyinitialized", !0), D += 1, c.data("spinnerid", D), !c.is("input")) return console.log("Must be an input.");i = j.extend({}, k, l, (s = {}, j.each(C, function (t, n) {
          var o = "bts-" + n;c.is("[data-" + o + "]") && (s[t] = c.data(o));
        }), s), y), "" !== i.initval && "" === c.val() && c.val(i.initval), h(), function () {
          var t = c.val(),
              n = c.parent();"" !== t && (t = i.callback_after_calculation(Number(t).toFixed(i.decimals)));c.data("initvalue", t).val(t), c.addClass("form-control"), n.hasClass("input-group") ? function (t) {
            t.addClass("bootstrap-touchspin");var n,
                o,
                s = c.prev(),
                p = c.next(),
                a = '<span class="input-group-addon input-group-prepend bootstrap-touchspin-prefix input-group-prepend bootstrap-touchspin-injected"><span class="input-group-text">' + i.prefix + "</span></span>",
                e = '<span class="input-group-addon input-group-append bootstrap-touchspin-postfix input-group-append bootstrap-touchspin-injected"><span class="input-group-text">' + i.postfix + "</span></span>";s.hasClass("input-group-btn") || s.hasClass("input-group-prepend") ? (n = '<button class="' + i.buttondown_class + ' bootstrap-touchspin-down bootstrap-touchspin-injected" type="button">' + i.buttondown_txt + "</button>", s.append(n)) : (n = '<span class="input-group-btn input-group-prepend bootstrap-touchspin-injected"><button class="' + i.buttondown_class + ' bootstrap-touchspin-down" type="button">' + i.buttondown_txt + "</button></span>", j(n).insertBefore(c));p.hasClass("input-group-btn") || p.hasClass("input-group-append") ? (o = '<button class="' + i.buttonup_class + ' bootstrap-touchspin-up bootstrap-touchspin-injected" type="button">' + i.buttonup_txt + "</button>", p.prepend(o)) : (o = '<span class="input-group-btn input-group-append bootstrap-touchspin-injected"><button class="' + i.buttonup_class + ' bootstrap-touchspin-up" type="button">' + i.buttonup_txt + "</button></span>", j(o).insertAfter(c));j(a).insertBefore(c), j(e).insertAfter(c), u = t;
          }(n) : function () {
            var t,
                n = "";c.hasClass("input-sm") && (n = "input-group-sm");c.hasClass("input-lg") && (n = "input-group-lg");t = i.verticalbuttons ? '<div class="input-group ' + n + ' bootstrap-touchspin bootstrap-touchspin-injected"><span class="input-group-addon input-group-prepend bootstrap-touchspin-prefix"><span class="input-group-text">' + i.prefix + '</span></span><span class="input-group-addon bootstrap-touchspin-postfix input-group-append"><span class="input-group-text">' + i.postfix + '</span></span><span class="input-group-btn-vertical"><button class="' + i.buttondown_class + " bootstrap-touchspin-up " + i.verticalupclass + '" type="button">' + i.verticalup + '</button><button class="' + i.buttonup_class + " bootstrap-touchspin-down " + i.verticaldownclass + '" type="button">' + i.verticaldown + "</button></span></div>" : '<div class="input-group bootstrap-touchspin bootstrap-touchspin-injected"><span class="input-group-btn input-group-prepend"><button class="' + i.buttondown_class + ' bootstrap-touchspin-down" type="button">' + i.buttondown_txt + '</button></span><span class="input-group-addon bootstrap-touchspin-prefix input-group-prepend"><span class="input-group-text">' + i.prefix + '</span></span><span class="input-group-addon bootstrap-touchspin-postfix input-group-append"><span class="input-group-text">' + i.postfix + '</span></span><span class="input-group-btn input-group-append"><button class="' + i.buttonup_class + ' bootstrap-touchspin-up" type="button">' + i.buttonup_txt + "</button></span></div>";u = j(t).insertBefore(c), j(".bootstrap-touchspin-prefix", u).after(c), c.hasClass("input-sm") ? u.addClass("input-group-sm") : c.hasClass("input-lg") && u.addClass("input-group-lg");
          }();
        }(), o = { down: j(".bootstrap-touchspin-down", u), up: j(".bootstrap-touchspin-up", u), input: j("input", u), prefix: j(".bootstrap-touchspin-prefix", u).addClass(i.prefix_extraclass), postfix: j(".bootstrap-touchspin-postfix", u).addClass(i.postfix_extraclass) }, b(), c.on("keydown.touchspin", function (t) {
          var n = t.keyCode || t.which;38 === n ? ("up" !== f && (x(), w()), t.preventDefault()) : 40 === n && ("down" !== f && (g(), m()), t.preventDefault());
        }), c.on("keyup.touchspin", function (t) {
          var n = t.keyCode || t.which;38 === n ? _() : 40 === n && _();
        }), c.on("blur.touchspin", function () {
          h(), c.val(i.callback_after_calculation(c.val()));
        }), o.down.on("keydown", function (t) {
          var n = t.keyCode || t.which;32 !== n && 13 !== n || ("down" !== f && (g(), m()), t.preventDefault());
        }), o.down.on("keyup.touchspin", function (t) {
          var n = t.keyCode || t.which;32 !== n && 13 !== n || _();
        }), o.up.on("keydown.touchspin", function (t) {
          var n = t.keyCode || t.which;32 !== n && 13 !== n || ("up" !== f && (x(), w()), t.preventDefault());
        }), o.up.on("keyup.touchspin", function (t) {
          var n = t.keyCode || t.which;32 !== n && 13 !== n || _();
        }), o.down.on("mousedown.touchspin", function (t) {
          o.down.off("touchstart.touchspin"), c.is(":disabled") || (g(), m(), t.preventDefault(), t.stopPropagation());
        }), o.down.on("touchstart.touchspin", function (t) {
          o.down.off("mousedown.touchspin"), c.is(":disabled") || (g(), m(), t.preventDefault(), t.stopPropagation());
        }), o.up.on("mousedown.touchspin", function (t) {
          o.up.off("touchstart.touchspin"), c.is(":disabled") || (x(), w(), t.preventDefault(), t.stopPropagation());
        }), o.up.on("touchstart.touchspin", function (t) {
          o.up.off("mousedown.touchspin"), c.is(":disabled") || (x(), w(), t.preventDefault(), t.stopPropagation());
        }), o.up.on("mouseup.touchspin mouseout.touchspin touchleave.touchspin touchend.touchspin touchcancel.touchspin", function (t) {
          f && (t.stopPropagation(), _());
        }), o.down.on("mouseup.touchspin mouseout.touchspin touchleave.touchspin touchend.touchspin touchcancel.touchspin", function (t) {
          f && (t.stopPropagation(), _());
        }), o.down.on("mousemove.touchspin touchmove.touchspin", function (t) {
          f && (t.stopPropagation(), t.preventDefault());
        }), o.up.on("mousemove.touchspin touchmove.touchspin", function (t) {
          f && (t.stopPropagation(), t.preventDefault());
        }), c.on("mousewheel.touchspin DOMMouseScroll.touchspin", function (t) {
          if (i.mousewheel && c.is(":focus")) {
            var n = t.originalEvent.wheelDelta || -t.originalEvent.deltaY || -t.originalEvent.detail;t.stopPropagation(), t.preventDefault(), n < 0 ? g() : x();
          }
        }), c.on("touchspin.destroy", function () {
          var t;t = c.parent(), _(), c.off(".touchspin"), t.hasClass("bootstrap-touchspin-injected") ? (c.siblings().remove(), c.unwrap()) : (j(".bootstrap-touchspin-injected", t).remove(), t.removeClass("bootstrap-touchspin")), c.data("alreadyinitialized", !1);
        }), c.on("touchspin.uponce", function () {
          _(), x();
        }), c.on("touchspin.downonce", function () {
          _(), g();
        }), c.on("touchspin.startupspin", function () {
          w();
        }), c.on("touchspin.startdownspin", function () {
          m();
        }), c.on("touchspin.stopspin", function () {
          _();
        }), c.on("touchspin.updatesettings", function (t, n) {
          !function (t) {
            (function (t) {
              if (i = j.extend({}, i, t), t.postfix) {
                var n = c.parent().find(".bootstrap-touchspin-postfix");0 === n.length && a.insertAfter(c), c.parent().find(".bootstrap-touchspin-postfix .input-group-text").text(t.postfix);
              }if (t.prefix) {
                var o = c.parent().find(".bootstrap-touchspin-prefix");0 === o.length && p.insertBefore(c), c.parent().find(".bootstrap-touchspin-prefix .input-group-text").text(t.prefix);
              }b();
            })(t), h();var n = o.input.val();"" !== n && (n = Number(i.callback_before_calculation(o.input.val())), o.input.val(i.callback_after_calculation(Number(n).toFixed(i.decimals))));
          }(n);
        });var s;
      }();
    });
  };
});

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{ref:"touchInput",class:'input-text',attrs:{"type":"text","name":_vm.name,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateValue()},"click":_vm.onClick}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputDate_vue__ = __webpack_require__(317);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_306915e0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputDate_vue__ = __webpack_require__(923);
function injectStyle (ssrContext) {
  __webpack_require__(919)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-306915e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputDate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_306915e0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputDate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(920);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("88ea2518", content, true, {});

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * Datepicker for Bootstrap v1.5.1 (https://github.com/eternicode/bootstrap-datepicker)
 *
 * Copyright 2012 Stefan Petre
 * Improvements by Andrew Rowls
 * Licensed under the Apache License v2.0 (http://www.apache.org/licenses/LICENSE-2.0)
 */
!function (a) {
   true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6)], __WEBPACK_AMD_DEFINE_FACTORY__ = (a),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : a("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? require("jquery") : jQuery);
}(function (a, b) {
  function c() {
    return new Date(Date.UTC.apply(Date, arguments));
  }function d() {
    var a = new Date();return c(a.getFullYear(), a.getMonth(), a.getDate());
  }function e(a, b) {
    return a.getUTCFullYear() === b.getUTCFullYear() && a.getUTCMonth() === b.getUTCMonth() && a.getUTCDate() === b.getUTCDate();
  }function f(a) {
    return function () {
      return this[a].apply(this, arguments);
    };
  }function g(a) {
    return a && !isNaN(a.getTime());
  }function h(b, c) {
    function d(a, b) {
      return b.toLowerCase();
    }var e,
        f = a(b).data(),
        g = {},
        h = new RegExp("^" + c.toLowerCase() + "([A-Z])");c = new RegExp("^" + c.toLowerCase());for (var i in f) {
      c.test(i) && (e = i.replace(h, d), g[e] = f[i]);
    }return g;
  }function i(b) {
    var c = {};if (q[b] || (b = b.split("-")[0], q[b])) {
      var d = q[b];return a.each(p, function (a, b) {
        b in d && (c[b] = d[b]);
      }), c;
    }
  }var j = function () {
    var b = { get: function get(a) {
        return this.slice(a)[0];
      }, contains: function contains(a) {
        for (var b = a && a.valueOf(), c = 0, d = this.length; d > c; c++) {
          if (this[c].valueOf() === b) return c;
        }return -1;
      }, remove: function remove(a) {
        this.splice(a, 1);
      }, replace: function replace(b) {
        b && (a.isArray(b) || (b = [b]), this.clear(), this.push.apply(this, b));
      }, clear: function clear() {
        this.length = 0;
      }, copy: function copy() {
        var a = new j();return a.replace(this), a;
      } };return function () {
      var c = [];return c.push.apply(c, arguments), a.extend(c, b), c;
    };
  }(),
      k = function k(b, c) {
    a(b).data("datepicker", this), this._process_options(c), this.dates = new j(), this.viewDate = this.o.defaultViewDate, this.focusDate = null, this.element = a(b), this.isInline = !1, this.isInput = this.element.is("input"), this.component = this.element.hasClass("date") ? this.element.find(".add-on, .input-group-addon, .btn") : !1, this.hasInput = this.component && this.element.find("input").length, this.component && 0 === this.component.length && (this.component = !1), this.picker = a(r.template), this._buildEvents(), this._attachEvents(), this.isInline ? this.picker.addClass("datepicker-inline").appendTo(this.element) : this.picker.addClass("datepicker-dropdown dropdown-menu"), this.o.rtl && this.picker.addClass("datepicker-rtl"), this.viewMode = this.o.startView, this.o.calendarWeeks && this.picker.find("thead .datepicker-title, tfoot .today, tfoot .clear").attr("colspan", function (a, b) {
      return parseInt(b) + 1;
    }), this._allow_update = !1, this.setStartDate(this._o.startDate), this.setEndDate(this._o.endDate), this.setDaysOfWeekDisabled(this.o.daysOfWeekDisabled), this.setDaysOfWeekHighlighted(this.o.daysOfWeekHighlighted), this.setDatesDisabled(this.o.datesDisabled), this.fillDow(), this.fillMonths(), this._allow_update = !0, this.update(), this.showMode(), this.isInline && this.show();
  };k.prototype = { constructor: k, _process_options: function _process_options(b) {
      this._o = a.extend({}, this._o, b);var e = this.o = a.extend({}, this._o),
          f = e.language;switch (q[f] || (f = f.split("-")[0], q[f] || (f = o.language)), e.language = f, e.startView) {case 2:case "decade":
          e.startView = 2;break;case 1:case "year":
          e.startView = 1;break;default:
          e.startView = 0;}switch (e.minViewMode) {case 1:case "months":
          e.minViewMode = 1;break;case 2:case "years":
          e.minViewMode = 2;break;default:
          e.minViewMode = 0;}switch (e.maxViewMode) {case 0:case "days":
          e.maxViewMode = 0;break;case 1:case "months":
          e.maxViewMode = 1;break;default:
          e.maxViewMode = 2;}e.startView = Math.min(e.startView, e.maxViewMode), e.startView = Math.max(e.startView, e.minViewMode), e.multidate !== !0 && (e.multidate = Number(e.multidate) || !1, e.multidate !== !1 && (e.multidate = Math.max(0, e.multidate))), e.multidateSeparator = String(e.multidateSeparator), e.weekStart %= 7, e.weekEnd = (e.weekStart + 6) % 7;var g = r.parseFormat(e.format);if (e.startDate !== -(1 / 0) && (e.startDate ? e.startDate instanceof Date ? e.startDate = this._local_to_utc(this._zero_time(e.startDate)) : e.startDate = r.parseDate(e.startDate, g, e.language) : e.startDate = -(1 / 0)), e.endDate !== 1 / 0 && (e.endDate ? e.endDate instanceof Date ? e.endDate = this._local_to_utc(this._zero_time(e.endDate)) : e.endDate = r.parseDate(e.endDate, g, e.language) : e.endDate = 1 / 0), e.daysOfWeekDisabled = e.daysOfWeekDisabled || [], a.isArray(e.daysOfWeekDisabled) || (e.daysOfWeekDisabled = e.daysOfWeekDisabled.split(/[,\s]*/)), e.daysOfWeekDisabled = a.map(e.daysOfWeekDisabled, function (a) {
        return parseInt(a, 10);
      }), e.daysOfWeekHighlighted = e.daysOfWeekHighlighted || [], a.isArray(e.daysOfWeekHighlighted) || (e.daysOfWeekHighlighted = e.daysOfWeekHighlighted.split(/[,\s]*/)), e.daysOfWeekHighlighted = a.map(e.daysOfWeekHighlighted, function (a) {
        return parseInt(a, 10);
      }), e.datesDisabled = e.datesDisabled || [], !a.isArray(e.datesDisabled)) {
        var h = [];h.push(r.parseDate(e.datesDisabled, g, e.language)), e.datesDisabled = h;
      }e.datesDisabled = a.map(e.datesDisabled, function (a) {
        return r.parseDate(a, g, e.language);
      });var i = String(e.orientation).toLowerCase().split(/\s+/g),
          j = e.orientation.toLowerCase();if (i = a.grep(i, function (a) {
        return (/^auto|left|right|top|bottom$/.test(a)
        );
      }), e.orientation = { x: "auto", y: "auto" }, j && "auto" !== j) {
        if (1 === i.length) switch (i[0]) {case "top":case "bottom":
            e.orientation.y = i[0];break;case "left":case "right":
            e.orientation.x = i[0];} else j = a.grep(i, function (a) {
          return (/^left|right$/.test(a)
          );
        }), e.orientation.x = j[0] || "auto", j = a.grep(i, function (a) {
          return (/^top|bottom$/.test(a)
          );
        }), e.orientation.y = j[0] || "auto";
      } else ;if (e.defaultViewDate) {
        var k = e.defaultViewDate.year || new Date().getFullYear(),
            l = e.defaultViewDate.month || 0,
            m = e.defaultViewDate.day || 1;e.defaultViewDate = c(k, l, m);
      } else e.defaultViewDate = d();
    }, _events: [], _secondaryEvents: [], _applyEvents: function _applyEvents(a) {
      for (var c, d, e, f = 0; f < a.length; f++) {
        c = a[f][0], 2 === a[f].length ? (d = b, e = a[f][1]) : 3 === a[f].length && (d = a[f][1], e = a[f][2]), c.on(e, d);
      }
    }, _unapplyEvents: function _unapplyEvents(a) {
      for (var c, d, e, f = 0; f < a.length; f++) {
        c = a[f][0], 2 === a[f].length ? (e = b, d = a[f][1]) : 3 === a[f].length && (e = a[f][1], d = a[f][2]), c.off(d, e);
      }
    }, _buildEvents: function _buildEvents() {
      var b = { keyup: a.proxy(function (b) {
          -1 === a.inArray(b.keyCode, [27, 37, 39, 38, 40, 32, 13, 9]) && this.update();
        }, this), keydown: a.proxy(this.keydown, this), paste: a.proxy(this.paste, this) };this.o.showOnFocus === !0 && (b.focus = a.proxy(this.show, this)), this.isInput ? this._events = [[this.element, b]] : this.component && this.hasInput ? this._events = [[this.element.find("input"), b], [this.component, { click: a.proxy(this.show, this) }]] : this.element.is("div") ? this.isInline = !0 : this._events = [[this.element, { click: a.proxy(this.show, this) }]], this._events.push([this.element, "*", { blur: a.proxy(function (a) {
          this._focused_from = a.target;
        }, this) }], [this.element, { blur: a.proxy(function (a) {
          this._focused_from = a.target;
        }, this) }]), this.o.immediateUpdates && this._events.push([this.element, { "changeYear changeMonth": a.proxy(function (a) {
          this.update(a.date);
        }, this) }]), this._secondaryEvents = [[this.picker, { click: a.proxy(this.click, this) }], [a(window), { resize: a.proxy(this.place, this) }], [a(document), { mousedown: a.proxy(function (a) {
          this.element.is(a.target) || this.element.find(a.target).length || this.picker.is(a.target) || this.picker.find(a.target).length || this.picker.hasClass("datepicker-inline") || this.hide();
        }, this) }]];
    }, _attachEvents: function _attachEvents() {
      this._detachEvents(), this._applyEvents(this._events);
    }, _detachEvents: function _detachEvents() {
      this._unapplyEvents(this._events);
    }, _attachSecondaryEvents: function _attachSecondaryEvents() {
      this._detachSecondaryEvents(), this._applyEvents(this._secondaryEvents);
    }, _detachSecondaryEvents: function _detachSecondaryEvents() {
      this._unapplyEvents(this._secondaryEvents);
    }, _trigger: function _trigger(b, c) {
      var d = c || this.dates.get(-1),
          e = this._utc_to_local(d);this.element.trigger({ type: b, date: e, dates: a.map(this.dates, this._utc_to_local), format: a.proxy(function (a, b) {
          0 === arguments.length ? (a = this.dates.length - 1, b = this.o.format) : "string" == typeof a && (b = a, a = this.dates.length - 1), b = b || this.o.format;var c = this.dates.get(a);return r.formatDate(c, b, this.o.language);
        }, this) });
    }, show: function show() {
      var b = this.component ? this.element.find("input") : this.element;if (!b.attr("readonly") || this.o.enableOnReadonly !== !1) return this.isInline || this.picker.appendTo(this.o.container), this.place(), this.picker.show(), this._attachSecondaryEvents(), this._trigger("show"), (window.navigator.msMaxTouchPoints || "ontouchstart" in document) && this.o.disableTouchKeyboard && a(this.element).blur(), this;
    }, hide: function hide() {
      return this.isInline ? this : this.picker.is(":visible") ? (this.focusDate = null, this.picker.hide().detach(), this._detachSecondaryEvents(), this.viewMode = this.o.startView, this.showMode(), this.o.forceParse && (this.isInput && this.element.val() || this.hasInput && this.element.find("input").val()) && this.setValue(), this._trigger("hide"), this) : this;
    }, remove: function remove() {
      return this.hide(), this._detachEvents(), this._detachSecondaryEvents(), this.picker.remove(), delete this.element.data().datepicker, this.isInput || delete this.element.data().date, this;
    }, paste: function paste(b) {
      var c;if (b.originalEvent.clipboardData && b.originalEvent.clipboardData.types && -1 !== a.inArray("text/plain", b.originalEvent.clipboardData.types)) c = b.originalEvent.clipboardData.getData("text/plain");else {
        if (!window.clipboardData) return;c = window.clipboardData.getData("Text");
      }this.setDate(c), this.update(), b.preventDefault();
    }, _utc_to_local: function _utc_to_local(a) {
      return a && new Date(a.getTime() + 6e4 * a.getTimezoneOffset());
    }, _local_to_utc: function _local_to_utc(a) {
      return a && new Date(a.getTime() - 6e4 * a.getTimezoneOffset());
    }, _zero_time: function _zero_time(a) {
      return a && new Date(a.getFullYear(), a.getMonth(), a.getDate());
    }, _zero_utc_time: function _zero_utc_time(a) {
      return a && new Date(Date.UTC(a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate()));
    }, getDates: function getDates() {
      return a.map(this.dates, this._utc_to_local);
    }, getUTCDates: function getUTCDates() {
      return a.map(this.dates, function (a) {
        return new Date(a);
      });
    }, getDate: function getDate() {
      return this._utc_to_local(this.getUTCDate());
    }, getUTCDate: function getUTCDate() {
      var a = this.dates.get(-1);return "undefined" != typeof a ? new Date(a) : null;
    }, clearDates: function clearDates() {
      var a;this.isInput ? a = this.element : this.component && (a = this.element.find("input")), a && a.val(""), this.update(), this._trigger("changeDate"), this.o.autoclose && this.hide();
    }, setDates: function setDates() {
      var b = a.isArray(arguments[0]) ? arguments[0] : arguments;return this.update.apply(this, b), this._trigger("changeDate"), this.setValue(), this;
    }, setUTCDates: function setUTCDates() {
      var b = a.isArray(arguments[0]) ? arguments[0] : arguments;return this.update.apply(this, a.map(b, this._utc_to_local)), this._trigger("changeDate"), this.setValue(), this;
    }, setDate: f("setDates"), setUTCDate: f("setUTCDates"), setValue: function setValue() {
      var a = this.getFormattedDate();return this.isInput ? this.element.val(a) : this.component && this.element.find("input").val(a), this;
    }, getFormattedDate: function getFormattedDate(c) {
      c === b && (c = this.o.format);var d = this.o.language;return a.map(this.dates, function (a) {
        return r.formatDate(a, c, d);
      }).join(this.o.multidateSeparator);
    }, setStartDate: function setStartDate(a) {
      return this._process_options({ startDate: a }), this.update(), this.updateNavArrows(), this;
    }, setEndDate: function setEndDate(a) {
      return this._process_options({ endDate: a }), this.update(), this.updateNavArrows(), this;
    }, setDaysOfWeekDisabled: function setDaysOfWeekDisabled(a) {
      return this._process_options({ daysOfWeekDisabled: a }), this.update(), this.updateNavArrows(), this;
    }, setDaysOfWeekHighlighted: function setDaysOfWeekHighlighted(a) {
      return this._process_options({ daysOfWeekHighlighted: a }), this.update(), this;
    }, setDatesDisabled: function setDatesDisabled(a) {
      this._process_options({ datesDisabled: a }), this.update(), this.updateNavArrows();
    }, place: function place() {
      if (this.isInline) return this;var b = this.picker.outerWidth(),
          c = this.picker.outerHeight(),
          d = 10,
          e = a(this.o.container),
          f = e.width(),
          g = "body" === this.o.container ? a(document).scrollTop() : e.scrollTop(),
          h = e.offset(),
          i = [];this.element.parents().each(function () {
        var b = a(this).css("z-index");"auto" !== b && 0 !== b && i.push(parseInt(b));
      });var j = Math.max.apply(Math, i) + this.o.zIndexOffset,
          k = this.component ? this.component.parent().offset() : this.element.offset(),
          l = this.component ? this.component.outerHeight(!0) : this.element.outerHeight(!1),
          m = this.component ? this.component.outerWidth(!0) : this.element.outerWidth(!1),
          n = k.left - h.left,
          o = k.top - h.top;"body" !== this.o.container && (o += g), this.picker.removeClass("datepicker-orient-top datepicker-orient-bottom datepicker-orient-right datepicker-orient-left"), "auto" !== this.o.orientation.x ? (this.picker.addClass("datepicker-orient-" + this.o.orientation.x), "right" === this.o.orientation.x && (n -= b - m)) : k.left < 0 ? (this.picker.addClass("datepicker-orient-left"), n -= k.left - d) : n + b > f ? (this.picker.addClass("datepicker-orient-right"), n += m - b) : this.picker.addClass("datepicker-orient-left");var p,
          q = this.o.orientation.y;if ("auto" === q && (p = -g + o - c, q = 0 > p ? "bottom" : "top"), this.picker.addClass("datepicker-orient-" + q), "top" === q ? o -= c + parseInt(this.picker.css("padding-top")) : o += l, this.o.rtl) {
        var r = f - (n + m);this.picker.css({ top: o, right: r, zIndex: j });
      } else this.picker.css({ top: o, left: n, zIndex: j });return this;
    }, _allow_update: !0, update: function update() {
      if (!this._allow_update) return this;var b = this.dates.copy(),
          c = [],
          d = !1;return arguments.length ? (a.each(arguments, a.proxy(function (a, b) {
        b instanceof Date && (b = this._local_to_utc(b)), c.push(b);
      }, this)), d = !0) : (c = this.isInput ? this.element.val() : this.element.data("date") || this.element.find("input").val(), c = c && this.o.multidate ? c.split(this.o.multidateSeparator) : [c], delete this.element.data().date), c = a.map(c, a.proxy(function (a) {
        return r.parseDate(a, this.o.format, this.o.language);
      }, this)), c = a.grep(c, a.proxy(function (a) {
        return !this.dateWithinRange(a) || !a;
      }, this), !0), this.dates.replace(c), this.dates.length ? this.viewDate = new Date(this.dates.get(-1)) : this.viewDate < this.o.startDate ? this.viewDate = new Date(this.o.startDate) : this.viewDate > this.o.endDate ? this.viewDate = new Date(this.o.endDate) : this.viewDate = this.o.defaultViewDate, d ? this.setValue() : c.length && String(b) !== String(this.dates) && this._trigger("changeDate"), !this.dates.length && b.length && this._trigger("clearDate"), this.fill(), this.element.change(), this;
    }, fillDow: function fillDow() {
      var a = this.o.weekStart,
          b = "<tr>";for (this.o.calendarWeeks && (this.picker.find(".datepicker-days .datepicker-switch").attr("colspan", function (a, b) {
        return parseInt(b) + 1;
      }), b += '<th class="cw">&#160;</th>'); a < this.o.weekStart + 7;) {
        b += '<th class="dow">' + q[this.o.language].daysMin[a++ % 7] + "</th>";
      }b += "</tr>", this.picker.find(".datepicker-days thead").append(b);
    }, fillMonths: function fillMonths() {
      for (var a = "", b = 0; 12 > b;) {
        a += '<span class="month">' + q[this.o.language].monthsShort[b++] + "</span>";
      }this.picker.find(".datepicker-months td").html(a);
    }, setRange: function setRange(b) {
      b && b.length ? this.range = a.map(b, function (a) {
        return a.valueOf();
      }) : delete this.range, this.fill();
    }, getClassNames: function getClassNames(b) {
      var c = [],
          d = this.viewDate.getUTCFullYear(),
          e = this.viewDate.getUTCMonth(),
          f = new Date();return b.getUTCFullYear() < d || b.getUTCFullYear() === d && b.getUTCMonth() < e ? c.push("old") : (b.getUTCFullYear() > d || b.getUTCFullYear() === d && b.getUTCMonth() > e) && c.push("new"), this.focusDate && b.valueOf() === this.focusDate.valueOf() && c.push("focused"), this.o.todayHighlight && b.getUTCFullYear() === f.getFullYear() && b.getUTCMonth() === f.getMonth() && b.getUTCDate() === f.getDate() && c.push("today"), -1 !== this.dates.contains(b) && c.push("active"), (!this.dateWithinRange(b) || this.dateIsDisabled(b)) && c.push("disabled"), -1 !== a.inArray(b.getUTCDay(), this.o.daysOfWeekHighlighted) && c.push("highlighted"), this.range && (b > this.range[0] && b < this.range[this.range.length - 1] && c.push("range"), -1 !== a.inArray(b.valueOf(), this.range) && c.push("selected"), b.valueOf() === this.range[0] && c.push("range-start"), b.valueOf() === this.range[this.range.length - 1] && c.push("range-end")), c;
    }, fill: function fill() {
      var d,
          e = new Date(this.viewDate),
          f = e.getUTCFullYear(),
          g = e.getUTCMonth(),
          h = this.o.startDate !== -(1 / 0) ? this.o.startDate.getUTCFullYear() : -(1 / 0),
          i = this.o.startDate !== -(1 / 0) ? this.o.startDate.getUTCMonth() : -(1 / 0),
          j = this.o.endDate !== 1 / 0 ? this.o.endDate.getUTCFullYear() : 1 / 0,
          k = this.o.endDate !== 1 / 0 ? this.o.endDate.getUTCMonth() : 1 / 0,
          l = q[this.o.language].today || q.en.today || "",
          m = q[this.o.language].clear || q.en.clear || "",
          n = q[this.o.language].titleFormat || q.en.titleFormat;if (!isNaN(f) && !isNaN(g)) {
        this.picker.find(".datepicker-days thead .datepicker-switch").text(r.formatDate(new c(f, g), n, this.o.language)), this.picker.find("tfoot .today").text(l).toggle(this.o.todayBtn !== !1), this.picker.find("tfoot .clear").text(m).toggle(this.o.clearBtn !== !1), this.picker.find("thead .datepicker-title").text(this.o.title).toggle("" !== this.o.title), this.updateNavArrows(), this.fillMonths();var o = c(f, g - 1, 28),
            p = r.getDaysInMonth(o.getUTCFullYear(), o.getUTCMonth());o.setUTCDate(p), o.setUTCDate(p - (o.getUTCDay() - this.o.weekStart + 7) % 7);var s = new Date(o);o.getUTCFullYear() < 100 && s.setUTCFullYear(o.getUTCFullYear()), s.setUTCDate(s.getUTCDate() + 42), s = s.valueOf();for (var t, u = []; o.valueOf() < s;) {
          if (o.getUTCDay() === this.o.weekStart && (u.push("<tr>"), this.o.calendarWeeks)) {
            var v = new Date(+o + (this.o.weekStart - o.getUTCDay() - 7) % 7 * 864e5),
                w = new Date(Number(v) + (11 - v.getUTCDay()) % 7 * 864e5),
                x = new Date(Number(x = c(w.getUTCFullYear(), 0, 1)) + (11 - x.getUTCDay()) % 7 * 864e5),
                y = (w - x) / 864e5 / 7 + 1;u.push('<td class="cw">' + y + "</td>");
          }if (t = this.getClassNames(o), t.push("day"), this.o.beforeShowDay !== a.noop) {
            var z = this.o.beforeShowDay(this._utc_to_local(o));z === b ? z = {} : "boolean" == typeof z ? z = { enabled: z } : "string" == typeof z && (z = { classes: z }), z.enabled === !1 && t.push("disabled"), z.classes && (t = t.concat(z.classes.split(/\s+/))), z.tooltip && (d = z.tooltip);
          }t = a.unique(t), u.push('<td class="' + t.join(" ") + '"' + (d ? ' title="' + d + '"' : "") + ">" + o.getUTCDate() + "</td>"), d = null, o.getUTCDay() === this.o.weekEnd && u.push("</tr>"), o.setUTCDate(o.getUTCDate() + 1);
        }this.picker.find(".datepicker-days tbody").empty().append(u.join(""));var A = q[this.o.language].monthsTitle || q.en.monthsTitle || "Months",
            B = this.picker.find(".datepicker-months").find(".datepicker-switch").text(this.o.maxViewMode < 2 ? A : f).end().find("span").removeClass("active");if (a.each(this.dates, function (a, b) {
          b.getUTCFullYear() === f && B.eq(b.getUTCMonth()).addClass("active");
        }), (h > f || f > j) && B.addClass("disabled"), f === h && B.slice(0, i).addClass("disabled"), f === j && B.slice(k + 1).addClass("disabled"), this.o.beforeShowMonth !== a.noop) {
          var C = this;a.each(B, function (b, c) {
            if (!a(c).hasClass("disabled")) {
              var d = new Date(f, b, 1),
                  e = C.o.beforeShowMonth(d);e === !1 && a(c).addClass("disabled");
            }
          });
        }u = "", f = 10 * parseInt(f / 10, 10);var D = this.picker.find(".datepicker-years").find(".datepicker-switch").text(f + "-" + (f + 9)).end().find("td");f -= 1;for (var E, F = a.map(this.dates, function (a) {
          return a.getUTCFullYear();
        }), G = -1; 11 > G; G++) {
          if (E = ["year"], d = null, -1 === G ? E.push("old") : 10 === G && E.push("new"), -1 !== a.inArray(f, F) && E.push("active"), (h > f || f > j) && E.push("disabled"), this.o.beforeShowYear !== a.noop) {
            var H = this.o.beforeShowYear(new Date(f, 0, 1));H === b ? H = {} : "boolean" == typeof H ? H = { enabled: H } : "string" == typeof H && (H = { classes: H }), H.enabled === !1 && E.push("disabled"), H.classes && (E = E.concat(H.classes.split(/\s+/))), H.tooltip && (d = H.tooltip);
          }u += '<span class="' + E.join(" ") + '"' + (d ? ' title="' + d + '"' : "") + ">" + f + "</span>", f += 1;
        }D.html(u);
      }
    }, updateNavArrows: function updateNavArrows() {
      if (this._allow_update) {
        var a = new Date(this.viewDate),
            b = a.getUTCFullYear(),
            c = a.getUTCMonth();switch (this.viewMode) {case 0:
            this.o.startDate !== -(1 / 0) && b <= this.o.startDate.getUTCFullYear() && c <= this.o.startDate.getUTCMonth() ? this.picker.find(".prev").css({ visibility: "hidden" }) : this.picker.find(".prev").css({ visibility: "visible" }), this.o.endDate !== 1 / 0 && b >= this.o.endDate.getUTCFullYear() && c >= this.o.endDate.getUTCMonth() ? this.picker.find(".next").css({ visibility: "hidden" }) : this.picker.find(".next").css({ visibility: "visible" });break;case 1:case 2:
            this.o.startDate !== -(1 / 0) && b <= this.o.startDate.getUTCFullYear() || this.o.maxViewMode < 2 ? this.picker.find(".prev").css({ visibility: "hidden" }) : this.picker.find(".prev").css({ visibility: "visible" }), this.o.endDate !== 1 / 0 && b >= this.o.endDate.getUTCFullYear() || this.o.maxViewMode < 2 ? this.picker.find(".next").css({ visibility: "hidden" }) : this.picker.find(".next").css({ visibility: "visible" });}
      }
    }, click: function click(b) {
      b.preventDefault(), b.stopPropagation();var e,
          f,
          g,
          h = a(b.target).closest("span, td, th");if (1 === h.length) switch (h[0].nodeName.toLowerCase()) {case "th":
          switch (h[0].className) {case "datepicker-switch":
              this.showMode(1);break;case "prev":case "next":
              var i = r.modes[this.viewMode].navStep * ("prev" === h[0].className ? -1 : 1);switch (this.viewMode) {case 0:
                  this.viewDate = this.moveMonth(this.viewDate, i), this._trigger("changeMonth", this.viewDate);break;case 1:case 2:
                  this.viewDate = this.moveYear(this.viewDate, i), 1 === this.viewMode && this._trigger("changeYear", this.viewDate);}this.fill();break;case "today":
              this.showMode(-2);var j = "linked" === this.o.todayBtn ? null : "view";this._setDate(d(), j);break;case "clear":
              this.clearDates();}break;case "span":
          h.hasClass("disabled") || (this.viewDate.setUTCDate(1), h.hasClass("month") ? (g = 1, f = h.parent().find("span").index(h), e = this.viewDate.getUTCFullYear(), this.viewDate.setUTCMonth(f), this._trigger("changeMonth", this.viewDate), 1 === this.o.minViewMode ? (this._setDate(c(e, f, g)), this.showMode()) : this.showMode(-1)) : (g = 1, f = 0, e = parseInt(h.text(), 10) || 0, this.viewDate.setUTCFullYear(e), this._trigger("changeYear", this.viewDate), 2 === this.o.minViewMode && this._setDate(c(e, f, g)), this.showMode(-1)), this.fill());break;case "td":
          h.hasClass("day") && !h.hasClass("disabled") && (g = parseInt(h.text(), 10) || 1, e = this.viewDate.getUTCFullYear(), f = this.viewDate.getUTCMonth(), h.hasClass("old") ? 0 === f ? (f = 11, e -= 1) : f -= 1 : h.hasClass("new") && (11 === f ? (f = 0, e += 1) : f += 1), this._setDate(c(e, f, g)));}this.picker.is(":visible") && this._focused_from && a(this._focused_from).focus(), delete this._focused_from;
    }, _toggle_multidate: function _toggle_multidate(a) {
      var b = this.dates.contains(a);if (a || this.dates.clear(), -1 !== b ? (this.o.multidate === !0 || this.o.multidate > 1 || this.o.toggleActive) && this.dates.remove(b) : this.o.multidate === !1 ? (this.dates.clear(), this.dates.push(a)) : this.dates.push(a), "number" == typeof this.o.multidate) for (; this.dates.length > this.o.multidate;) {
        this.dates.remove(0);
      }
    }, _setDate: function _setDate(a, b) {
      b && "date" !== b || this._toggle_multidate(a && new Date(a)), b && "view" !== b || (this.viewDate = a && new Date(a)), this.fill(), this.setValue(), b && "view" === b || this._trigger("changeDate");var c;this.isInput ? c = this.element : this.component && (c = this.element.find("input")), c && c.change(), !this.o.autoclose || b && "date" !== b || this.hide();
    }, moveDay: function moveDay(a, b) {
      var c = new Date(a);return c.setUTCDate(a.getUTCDate() + b), c;
    }, moveWeek: function moveWeek(a, b) {
      return this.moveDay(a, 7 * b);
    }, moveMonth: function moveMonth(a, b) {
      if (!g(a)) return this.o.defaultViewDate;if (!b) return a;var c,
          d,
          e = new Date(a.valueOf()),
          f = e.getUTCDate(),
          h = e.getUTCMonth(),
          i = Math.abs(b);if (b = b > 0 ? 1 : -1, 1 === i) d = -1 === b ? function () {
        return e.getUTCMonth() === h;
      } : function () {
        return e.getUTCMonth() !== c;
      }, c = h + b, e.setUTCMonth(c), (0 > c || c > 11) && (c = (c + 12) % 12);else {
        for (var j = 0; i > j; j++) {
          e = this.moveMonth(e, b);
        }c = e.getUTCMonth(), e.setUTCDate(f), d = function d() {
          return c !== e.getUTCMonth();
        };
      }for (; d();) {
        e.setUTCDate(--f), e.setUTCMonth(c);
      }return e;
    }, moveYear: function moveYear(a, b) {
      return this.moveMonth(a, 12 * b);
    }, moveAvailableDate: function moveAvailableDate(a, b, c) {
      do {
        if (a = this[c](a, b), !this.dateWithinRange(a)) return !1;c = "moveDay";
      } while (this.dateIsDisabled(a));return a;
    }, weekOfDateIsDisabled: function weekOfDateIsDisabled(b) {
      return -1 !== a.inArray(b.getUTCDay(), this.o.daysOfWeekDisabled);
    }, dateIsDisabled: function dateIsDisabled(b) {
      return this.weekOfDateIsDisabled(b) || a.grep(this.o.datesDisabled, function (a) {
        return e(b, a);
      }).length > 0;
    }, dateWithinRange: function dateWithinRange(a) {
      return a >= this.o.startDate && a <= this.o.endDate;
    }, keydown: function keydown(a) {
      if (!this.picker.is(":visible")) return void ((40 === a.keyCode || 27 === a.keyCode) && (this.show(), a.stopPropagation()));var b,
          c,
          d = !1,
          e = this.focusDate || this.viewDate;switch (a.keyCode) {case 27:
          this.focusDate ? (this.focusDate = null, this.viewDate = this.dates.get(-1) || this.viewDate, this.fill()) : this.hide(), a.preventDefault(), a.stopPropagation();break;case 37:case 38:case 39:case 40:
          if (!this.o.keyboardNavigation || 7 === this.o.daysOfWeekDisabled.length) break;b = 37 === a.keyCode || 38 === a.keyCode ? -1 : 1, a.ctrlKey ? (c = this.moveAvailableDate(e, b, "moveYear"), c && this._trigger("changeYear", this.viewDate)) : a.shiftKey ? (c = this.moveAvailableDate(e, b, "moveMonth"), c && this._trigger("changeMonth", this.viewDate)) : 37 === a.keyCode || 39 === a.keyCode ? c = this.moveAvailableDate(e, b, "moveDay") : this.weekOfDateIsDisabled(e) || (c = this.moveAvailableDate(e, b, "moveWeek")), c && (this.focusDate = this.viewDate = c, this.setValue(), this.fill(), a.preventDefault());break;case 13:
          if (!this.o.forceParse) break;e = this.focusDate || this.dates.get(-1) || this.viewDate, this.o.keyboardNavigation && (this._toggle_multidate(e), d = !0), this.focusDate = null, this.viewDate = this.dates.get(-1) || this.viewDate, this.setValue(), this.fill(), this.picker.is(":visible") && (a.preventDefault(), a.stopPropagation(), this.o.autoclose && this.hide());break;case 9:
          this.focusDate = null, this.viewDate = this.dates.get(-1) || this.viewDate, this.fill(), this.hide();}if (d) {
        this.dates.length ? this._trigger("changeDate") : this._trigger("clearDate");var f;this.isInput ? f = this.element : this.component && (f = this.element.find("input")), f && f.change();
      }
    }, showMode: function showMode(a) {
      a && (this.viewMode = Math.max(this.o.minViewMode, Math.min(this.o.maxViewMode, this.viewMode + a))), this.picker.children("div").hide().filter(".datepicker-" + r.modes[this.viewMode].clsName).show(), this.updateNavArrows();
    } };var l = function l(b, c) {
    a(b).data("datepicker", this), this.element = a(b), this.inputs = a.map(c.inputs, function (a) {
      return a.jquery ? a[0] : a;
    }), delete c.inputs, n.call(a(this.inputs), c).on("changeDate", a.proxy(this.dateUpdated, this)), this.pickers = a.map(this.inputs, function (b) {
      return a(b).data("datepicker");
    }), this.updateDates();
  };l.prototype = { updateDates: function updateDates() {
      this.dates = a.map(this.pickers, function (a) {
        return a.getUTCDate();
      }), this.updateRanges();
    }, updateRanges: function updateRanges() {
      var b = a.map(this.dates, function (a) {
        return a.valueOf();
      });a.each(this.pickers, function (a, c) {
        c.setRange(b);
      });
    }, dateUpdated: function dateUpdated(b) {
      if (!this.updating) {
        this.updating = !0;var c = a(b.target).data("datepicker");if ("undefined" != typeof c) {
          var d = c.getUTCDate(),
              e = a.inArray(b.target, this.inputs),
              f = e - 1,
              g = e + 1,
              h = this.inputs.length;if (-1 !== e) {
            if (a.each(this.pickers, function (a, b) {
              b.getUTCDate() || b.setUTCDate(d);
            }), d < this.dates[f]) for (; f >= 0 && d < this.dates[f];) {
              this.pickers[f--].setUTCDate(d);
            } else if (d > this.dates[g]) for (; h > g && d > this.dates[g];) {
              this.pickers[g++].setUTCDate(d);
            }this.updateDates(), delete this.updating;
          }
        }
      }
    }, remove: function remove() {
      a.map(this.pickers, function (a) {
        a.remove();
      }), delete this.element.data().datepicker;
    } };var m = a.fn.datepicker,
      n = function n(c) {
    var d = Array.apply(null, arguments);d.shift();var e;if (this.each(function () {
      var b = a(this),
          f = b.data("datepicker"),
          g = "object" == (typeof c === "undefined" ? "undefined" : _typeof(c)) && c;if (!f) {
        var j = h(this, "date"),
            m = a.extend({}, o, j, g),
            n = i(m.language),
            p = a.extend({}, o, n, j, g);b.hasClass("input-daterange") || p.inputs ? (a.extend(p, { inputs: p.inputs || b.find("input").toArray() }), f = new l(this, p)) : f = new k(this, p), b.data("datepicker", f);
      }"string" == typeof c && "function" == typeof f[c] && (e = f[c].apply(f, d));
    }), e === b || e instanceof k || e instanceof l) return this;if (this.length > 1) throw new Error("Using only allowed for the collection of a single element (" + c + " function)");return e;
  };a.fn.datepicker = n;var o = a.fn.datepicker.defaults = { autoclose: !1, beforeShowDay: a.noop, beforeShowMonth: a.noop, beforeShowYear: a.noop, calendarWeeks: !1, clearBtn: !1, toggleActive: !1, daysOfWeekDisabled: [], daysOfWeekHighlighted: [], datesDisabled: [], endDate: 1 / 0, forceParse: !0, format: "mm/dd/yyyy", keyboardNavigation: !0, language: "en", minViewMode: 0, maxViewMode: 2, multidate: !1, multidateSeparator: ",", orientation: "auto", rtl: !1, startDate: -(1 / 0), startView: 0, todayBtn: !1, todayHighlight: !1, weekStart: 0, disableTouchKeyboard: !1, enableOnReadonly: !0, showOnFocus: !0, zIndexOffset: 10, container: "body", immediateUpdates: !1, title: "" },
      p = a.fn.datepicker.locale_opts = ["format", "rtl", "weekStart"];a.fn.datepicker.Constructor = k;var q = a.fn.datepicker.dates = { en: { days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"], months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], today: "Today", clear: "Clear", titleFormat: "MM yyyy" } },
      r = { modes: [{ clsName: "days", navFnc: "Month", navStep: 1 }, { clsName: "months", navFnc: "FullYear", navStep: 1 }, { clsName: "years", navFnc: "FullYear", navStep: 10 }], isLeapYear: function isLeapYear(a) {
      return a % 4 === 0 && a % 100 !== 0 || a % 400 === 0;
    }, getDaysInMonth: function getDaysInMonth(a, b) {
      return [31, r.isLeapYear(a) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][b];
    }, validParts: /dd?|DD?|mm?|MM?|yy(?:yy)?/g, nonpunctuation: /[^ -\/:-@\[\u3400-\u9fff-`{-~\t\n\r]+/g, parseFormat: function parseFormat(a) {
      if ("function" == typeof a.toValue && "function" == typeof a.toDisplay) return a;var b = a.replace(this.validParts, "\x00").split("\x00"),
          c = a.match(this.validParts);if (!b || !b.length || !c || 0 === c.length) throw new Error("Invalid date format.");return { separators: b, parts: c };
    }, parseDate: function parseDate(e, f, g) {
      function h() {
        var a = this.slice(0, o[l].length),
            b = o[l].slice(0, a.length);return a.toLowerCase() === b.toLowerCase();
      }if (!e) return b;if (e instanceof Date) return e;if ("string" == typeof f && (f = r.parseFormat(f)), f.toValue) return f.toValue(e, f, g);var i,
          j,
          l,
          m,
          n = /([\-+]\d+)([dmwy])/,
          o = e.match(/([\-+]\d+)([dmwy])/g),
          p = { d: "moveDay", m: "moveMonth", w: "moveWeek", y: "moveYear" };if (/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/.test(e)) {
        for (e = new Date(), l = 0; l < o.length; l++) {
          i = n.exec(o[l]), j = parseInt(i[1]), m = p[i[2]], e = k.prototype[m](e, j);
        }return c(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate());
      }o = e && e.match(this.nonpunctuation) || [], e = new Date();var s,
          t,
          u = {},
          v = ["yyyy", "yy", "M", "MM", "m", "mm", "d", "dd"],
          w = { yyyy: function yyyy(a, b) {
          return a.setUTCFullYear(b);
        }, yy: function yy(a, b) {
          return a.setUTCFullYear(2e3 + b);
        }, m: function m(a, b) {
          if (isNaN(a)) return a;for (b -= 1; 0 > b;) {
            b += 12;
          }for (b %= 12, a.setUTCMonth(b); a.getUTCMonth() !== b;) {
            a.setUTCDate(a.getUTCDate() - 1);
          }return a;
        }, d: function d(a, b) {
          return a.setUTCDate(b);
        } };w.M = w.MM = w.mm = w.m, w.dd = w.d, e = d();var x = f.parts.slice();if (o.length !== x.length && (x = a(x).filter(function (b, c) {
        return -1 !== a.inArray(c, v);
      }).toArray()), o.length === x.length) {
        var y;for (l = 0, y = x.length; y > l; l++) {
          if (s = parseInt(o[l], 10), i = x[l], isNaN(s)) switch (i) {case "MM":
              t = a(q[g].months).filter(h), s = a.inArray(t[0], q[g].months) + 1;break;case "M":
              t = a(q[g].monthsShort).filter(h), s = a.inArray(t[0], q[g].monthsShort) + 1;}u[i] = s;
        }var z, A;for (l = 0; l < v.length; l++) {
          A = v[l], A in u && !isNaN(u[A]) && (z = new Date(e), w[A](z, u[A]), isNaN(z) || (e = z));
        }
      }return e;
    }, formatDate: function formatDate(b, c, d) {
      if (!b) return "";if ("string" == typeof c && (c = r.parseFormat(c)), c.toDisplay) return c.toDisplay(b, c, d);var e = { d: b.getUTCDate(), D: q[d].daysShort[b.getUTCDay()], DD: q[d].days[b.getUTCDay()], m: b.getUTCMonth() + 1, M: q[d].monthsShort[b.getUTCMonth()], MM: q[d].months[b.getUTCMonth()], yy: b.getUTCFullYear().toString().substring(2), yyyy: b.getUTCFullYear() };e.dd = (e.d < 10 ? "0" : "") + e.d, e.mm = (e.m < 10 ? "0" : "") + e.m, b = [];for (var f = a.extend([], c.separators), g = 0, h = c.parts.length; h >= g; g++) {
        f.length && b.push(f.shift()), b.push(e[c.parts[g]]);
      }return b.join("");
    }, headTemplate: '<thead><tr><th colspan="7" class="datepicker-title"></th></tr><tr><th class="prev"><i class="fa fa-angle-left"></i></th><th colspan="5" class="datepicker-switch"></th><th class="next"><i class="fa fa-angle-right"></i></th></tr></thead>', contTemplate: '<tbody><tr><td colspan="7"></td></tr></tbody>', footTemplate: '<tfoot><tr><th colspan="7" class="today"></th></tr><tr><th colspan="7" class="clear"></th></tr></tfoot>' };r.template = '<div class="datepicker"><div class="datepicker-days"><table class=" table-condensed">' + r.headTemplate + "<tbody></tbody>" + r.footTemplate + '</table></div><div class="datepicker-months"><table class="table-condensed">' + r.headTemplate + r.contTemplate + r.footTemplate + '</table></div><div class="datepicker-years"><table class="table-condensed">' + r.headTemplate + r.contTemplate + r.footTemplate + "</table></div></div>", a.fn.datepicker.DPGlobal = r, a.fn.datepicker.noConflict = function () {
    return a.fn.datepicker = m, this;
  }, a.fn.datepicker.version = "1.5.1", a(document).on("focus.datepicker.data-api click.datepicker.data-api", '[data-provide="datepicker"]', function (b) {
    var c = a(this);c.data("datepicker") || (b.preventDefault(), n.call(c, "show"));
  }), a(function () {
    n.call(a('[data-provide="datepicker-inline"]'));
  });
});

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
(function ($) {
    $.fn.datepicker.dates['ru'] = {
        days: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
        daysShort: ["Вск", "Пнд", "Втр", "Срд", "Чтв", "Птн", "Суб"],
        daysMin: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
        months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
        monthsShort: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
        today: "Сегодня",
        clear: "Очистить",
        format: "dd.mm.yyyy",
        weekStart: 1,
        monthsTitle: 'Месяцы'
    };
})(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a);

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.withMask)?_c('the-mask',{ref:"dateInput",staticClass:"input-text input-date",attrs:{"mask":_vm.mask,"masked":true,"type":"text","autocomplete":"off","name":_vm.name,"value":_vm.value},on:{"change":function($event){return _vm.$emit('change')},"focus":function($event){return _vm.$emit('focus')}},nativeOn:{"blur":function($event){return _vm.onBlur.apply(null, arguments)}}}):_c('input',{ref:"dateInput",staticClass:"input-text input-date",attrs:{"type":"text","autocomplete":"off","name":_vm.name},domProps:{"value":_vm.value},on:{"change":function($event){return _vm.$emit('change')},"blur":_vm.onBlur,"focus":function($event){return _vm.$emit('focus')}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropDown_vue__ = __webpack_require__(318);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_311fe064_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropDown_vue__ = __webpack_require__(927);
function injectStyle (ssrContext) {
  __webpack_require__(925)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-311fe064"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropDown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_311fe064_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropDown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(926);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("a18220aa", content, true, {});

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickOutside),expression:"onClickOutside"}],class:['dropdown-block', { 'dropdown-menu-open': _vm.dropDownOpen, 'top': _vm.isOverflown, 'disabled': _vm.disabled}],attrs:{"name":_vm.name}},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.dropDownOpen = !_vm.dropDownOpen}}},[(_vm.selectedItem != null)?_c('span',{staticClass:"dropdown-menu-item-selected"},[_vm._v(_vm._s(_vm.selectedItem[_vm.textField]))]):_vm._e(),_vm._v(" "),_c('img',{staticClass:"dropdown-img",attrs:{"src":__webpack_require__(928),"alt":""}})]),_vm._v(" "),(!_vm.disabled)?_c('div',{staticClass:"dropdown-menu dropdown-list"},_vm._l((_vm.dropItems),function(item){return _c('a',{staticClass:"dropdown-menu-item",class:{ 'selected': item.Selected === true },on:{"click":function($event){return _vm.onSelect(item)}}},[_c('span',[_vm._v(_vm._s(item[_vm.textField]))])])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "arrow.png?833c187787baf797c6d3fbf7bec86320";

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectSelect_vue__ = __webpack_require__(319);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f301d606_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectSelect_vue__ = __webpack_require__(933);
function injectStyle (ssrContext) {
  __webpack_require__(930)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f301d606"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f301d606_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(931);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("27e698fd", content, true, {});

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["a"] = ({
    getClaimByRouteName: function getClaimByRouteName(name) {
        var pageClaim = void 0;
        switch (name) {
            case 'materials':
                pageClaim = __WEBPACK_IMPORTED_MODULE_0__enums__["b" /* ClaimEnums */].materialsPage;
                break;
            case 'materialEdit':
            case 'folderEdit':
            case 'questionEdit':
                pageClaim = __WEBPACK_IMPORTED_MODULE_0__enums__["b" /* ClaimEnums */].materialCreate;
                break;
            case 'motivation':
                pageClaim = __WEBPACK_IMPORTED_MODULE_0__enums__["b" /* ClaimEnums */].motivationPage;
                break;
            case 'news':
            case 'newsEdit':
            case 'newsDetails':
                pageClaim = __WEBPACK_IMPORTED_MODULE_0__enums__["b" /* ClaimEnums */].newsPage;
                break;
            case 'projects':
            case 'projectEdit':
            case 'trade-points':
            case 'users':
            case 'userEdit':
            case 'roles':
                pageClaim = __WEBPACK_IMPORTED_MODULE_0__enums__["b" /* ClaimEnums */].projectPage;
                break;
            case 'rewardEdit':
            case 'rewardFolderEdit':
                pageClaim = __WEBPACK_IMPORTED_MODULE_0__enums__["b" /* ClaimEnums */].rewardsEdit;
                break;
            case 'rating':
                pageClaim = __WEBPACK_IMPORTED_MODULE_0__enums__["b" /* ClaimEnums */].ratingPage;
                break;
            case 'reports':
            case 'reportDetails':
                pageClaim = __WEBPACK_IMPORTED_MODULE_0__enums__["b" /* ClaimEnums */].reportsPage;
                break;
            case 'spend-bonuses':
                pageClaim = __WEBPACK_IMPORTED_MODULE_0__enums__["b" /* ClaimEnums */].spendBonusesPage;
                break;
            case 'analytics':
                pageClaim = __WEBPACK_IMPORTED_MODULE_0__enums__["b" /* ClaimEnums */].analyticsPage;
                break;
            case 'sku':
            case 'skuEdit':
            case 'skuDetails':
            case 'skuFolderEdit':
                pageClaim = __WEBPACK_IMPORTED_MODULE_0__enums__["b" /* ClaimEnums */].skuPage;
                break;
            case 'cart':
                pageClaim = __WEBPACK_IMPORTED_MODULE_0__enums__["b" /* ClaimEnums */].bonusSpend;
                break;
            case 'orders':
                pageClaim = __WEBPACK_IMPORTED_MODULE_0__enums__["b" /* ClaimEnums */].ordersPage;
                break;
            case 'sender':
                pageClaim = __WEBPACK_IMPORTED_MODULE_0__enums__["b" /* ClaimEnums */].senderPage;
                break;
            case 'faq':
                pageClaim = __WEBPACK_IMPORTED_MODULE_0__enums__["b" /* ClaimEnums */].faqPage;
                break;
            case 'tasks':
            case 'tasksTable':
            case 'tasksDetails':
            case 'tasksAnswerEdit':
                pageClaim = __WEBPACK_IMPORTED_MODULE_0__enums__["b" /* ClaimEnums */].tasksPage;
                break;
            case 'tasksEdit':
                pageClaim = __WEBPACK_IMPORTED_MODULE_0__enums__["b" /* ClaimEnums */].tasksEdit;
                break;
        }
        return pageClaim;
    }
});

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-field margin-right-10 select-project"},[(_vm.projects.length > 1)?_c('drop-down',{attrs:{"items":_vm.projects,"dataField":'Id',"textField":'Name',"selectedValue":_vm.projectId,"cssClass":'margin-right-10'},on:{"change":function($event){return _vm.onProjectChange($event)}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComplexFilter_vue__ = __webpack_require__(320);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b38e212_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComplexFilter_vue__ = __webpack_require__(937);
function injectStyle (ssrContext) {
  __webpack_require__(935)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b38e212"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComplexFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b38e212_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComplexFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(936);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("5cf5de82", content, true, {});

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".svg-icon.plus[data-v-1b38e212]{margin:0 0 0 10px;width:20px;height:20px}", ""]);

// exports


/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['dyn-filter', {'loading': _vm.loading }],attrs:{"id":"aTable"}},[(!_vm.filterRows.length)?_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.applyFilter()}}},[_vm._v("Добавить фильтр")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dyn-filter-rows flex"},[_c('div',{staticStyle:{"width":"100%"}},[_vm._l((_vm.filterRows),function(row,i){return [_c('div',{staticClass:"dyn-filter-row",attrs:{"id":'dfRow' + i}},[_c('div',{staticClass:"dyn-filter-field"},[(row != null)?_c('drop-down',{key:'filter_' + row.Index,attrs:{"items":_vm.getNotUsedFilters(row.FilterValue),"dataField":'Value',"textField":'Name',"name":'filter_' + row.Index},on:{"change":function($event){return _vm.onFilterChange(row, $event, i)}},model:{value:(row.FilterValue),callback:function ($$v) {_vm.$set(row, "FilterValue", $$v)},expression:"row.FilterValue"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"dyn-filter-values"},[_vm._l((row.values),function(valueObj,j){return _c('div',{staticClass:"dyn-filter-values-selected",on:{"click":function($event){return _vm.onRemoveFilterValue(valueObj, i, j)}}},[_vm._v("\n                            "+_vm._s(valueObj.Name)+"\n                        ")])}),_vm._v(" "),(row.Selected)?_c('input',{ref:'filterInput' + i,refInFor:true,staticClass:"dyn-filter-values-input",attrs:{"type":"text"},on:{"input":function($event){return _vm.onFilterInputChange(row, $event.target, i)},"click":function($event){$event.stopPropagation();}}}):_vm._e(),_vm._v(" "),_c('svg',{staticClass:"svg-icon plus",staticStyle:{"display":"inline-block"},attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"},on:{"click":function($event){$event.stopPropagation();return _vm.onAddFilterValue(row, i)}}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Plus"}})])],2),_vm._v(" "),_c('div',{staticClass:"dyn-filter-btns"},[((i === _vm.filterRows.length - 1) && _vm.notUsedFilters.length)?_c('img',{staticClass:"dyn-filter-plus",attrs:{"src":__webpack_require__(938),"alt":"добавить фильтр"},on:{"click":function($event){return _vm.onFilterRowAdd()}}}):_vm._e(),_vm._v(" "),_c('img',{staticClass:"dyn-filter-minus",staticStyle:{"display":"block"},attrs:{"src":__webpack_require__(939),"alt":"удалить фильтр"},on:{"click":function($event){return _vm.onFilterRowRemove(row, i)}}})]),_vm._v(" "),(row.Selected)?_c('div',{ref:'filterResults' + i,refInFor:true,staticClass:"dyn-filter-values-select",staticStyle:{"min-height":"30px"},style:({width: 1529 + 'px', top: (45 + i*35) + 'px', left: row.resultListLeftPos + 'px'}),attrs:{"id":"dfValues1227"},on:{"scroll":_vm.onScroll}},[_vm._l((_vm.getUniqueSearchResults(row)),function(res){return _c('p',{staticClass:"dyn-filter-select-value",on:{"click":function($event){$event.stopPropagation();return _vm.onSearchResultClick(row, res, i)}}},[_vm._v(_vm._s(res.Name))])}),_vm._v(" "),(_vm.getUniqueSearchResults(row).length === 0 && !_vm.loading)?_c('p',{staticClass:"dyn-filter-select-novalue"},[_vm._v("\n                            Нет значений\n                        ")]):_vm._e()],2):_vm._e()])]})],2),_vm._v(" "),(_vm.filterRows.length && _vm.cacheKey)?_c('div',{staticClass:"margin-left-5",staticStyle:{"width":"35px","min-width":"35px"}},[_c('button',{staticClass:"btn",attrs:{"type":"button","title":"Очистить"},on:{"click":_vm.onCancelClick}},[_c('img',{attrs:{"src":__webpack_require__(17),"alt":""}})])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "IconPlus32.png?c1b22df3ad99854b201d7125d49899f9";

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "IconDelete32.png?ab5bea6a78de7602c5a727f8375da890";

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PopupWindow_vue__ = __webpack_require__(321);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab84fe78_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PopupWindow_vue__ = __webpack_require__(943);
function injectStyle (ssrContext) {
  __webpack_require__(941)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ab84fe78"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PopupWindow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab84fe78_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PopupWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(942);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("187a5ca6", content, true, {});

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".fade-enter-active[data-v-ab84fe78],.fade-leave-active[data-v-ab84fe78]{transition:opacity .5s}.fade-enter[data-v-ab84fe78],.fade-leave-to[data-v-ab84fe78]{opacity:0}", ""]);

// exports


/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"popup",attrs:{"name":_vm.name},on:{"click":function($event){return _vm.$emit('click', $event)}}},[(!_vm.modal)?_c('div',{staticClass:"popup-bg",on:{"click":_vm.onClickOutside}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"popup-content",style:({ width: _vm.windowWidth, height: _vm.windowHeight })},[(!_vm.modal)?_c('div',{staticClass:"popup-close",on:{"click":function($event){return _vm.close()}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"popup-header"},[_vm._v("\n                "+_vm._s(_vm.title)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"popup-body",on:{"scroll":_vm.onScroll}},[_vm._t("default")],2),_vm._v(" "),_vm._t("footer")],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchFilter_vue__ = __webpack_require__(322);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_335953f8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchFilter_vue__ = __webpack_require__(947);
function injectStyle (ssrContext) {
  __webpack_require__(945)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-335953f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_335953f8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(946);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("dfd1f41e", content, true, {});

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-search",class:{ 'dropdown-menu-open': _vm.dropDownOpen},on:{"click":function($event){$event.stopPropagation();}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],ref:"SearchInput",class:['input-text', {'input-error': _vm.hasErrors}],attrs:{"type":"text","placeholder":_vm.placeholder,"name":_vm.name,"autocomplete":"off","disabled":_vm.disabled},domProps:{"value":(_vm.searchText)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value},function($event){return _vm.onChangeSearchInput($event)}],"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();},"blur":function($event){return _vm.$emit('blur')},"focus":_vm.onFocus,"focusout":_vm.onFocusOut}}),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-list"},_vm._l((_vm.searchResults),function(item){return _c('a',{staticClass:"dropdown-menu-item",style:({'white-space': _vm.isMobile ? 'normal' : 'nowrap'}),on:{"click":function($event){$event.stopPropagation();return _vm.onSelectResult(item)}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.highLightItem(item.Name))}})])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart_vue__ = __webpack_require__(323);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_914ad710_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chart_vue__ = __webpack_require__(952);
function injectStyle (ssrContext) {
  __webpack_require__(949)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-914ad710"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_914ad710_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(950);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("5529c4ac", content, true, {});

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);


__WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.pluginService.register({
            beforeDraw: function beforeDraw(chart) {
                        if (chart.config.options.elements.center) {
                                    //Get ctx from string
                                    var ctx = chart.chart.ctx;

                                    //Get options from the center object in options
                                    var centerConfig = chart.config.options.elements.center;
                                    var fontStyle = centerConfig.fontStyle || 'Arial';
                                    var txt = centerConfig.text;
                                    var color = centerConfig.color || '#000';
                                    var sidePadding = centerConfig.sidePadding || 20;
                                    var sidePaddingCalculated = sidePadding / 100 * (chart.innerRadius * 2);
                                    //Start with a base font of 30px
                                    ctx.font = "30px " + fontStyle;

                                    //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
                                    var stringWidth = ctx.measureText(txt).width;
                                    var elementWidth = chart.innerRadius * 2 - sidePaddingCalculated;

                                    // Find out how much the font can grow in width.
                                    var widthRatio = elementWidth / stringWidth;
                                    var newFontSize = Math.floor(30 * widthRatio);
                                    var elementHeight = chart.innerRadius * 2;

                                    // Pick a new font size so it will not be larger than the height of label.
                                    var fontSizeToUse = Math.min(newFontSize, elementHeight);

                                    //Set font settings to draw it correctly.
                                    ctx.textAlign = 'center';
                                    ctx.textBaseline = 'middle';
                                    var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
                                    var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
                                    ctx.font = (centerConfig.fontSize || fontSizeToUse) + "px " + fontStyle;
                                    ctx.fillStyle = color;

                                    //Draw text in center
                                    ctx.fillText(txt, centerX, centerY);
                        }
            }
});

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative","width":"100%","height":"100%"}},[_c('canvas',{ref:"myChart",staticStyle:{"width":"100%","height":"100%"},on:{"click":function($event){$event.stopPropagation();}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SlideDown_vue__ = __webpack_require__(325);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c12231de_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SlideDown_vue__ = __webpack_require__(956);
function injectStyle (ssrContext) {
  __webpack_require__(954)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c12231de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SlideDown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c12231de_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SlideDown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(955);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("227be914", content, true, {});

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slidedown"},[_c('div',{staticClass:"select"},[(_vm.selectedItem == null)?_c('span',[_vm._v(_vm._s(_vm.selectText))]):_vm._e(),_vm._v(" "),(_vm.selectedItem != null)?_c('span',[_vm._v(_vm._s(_vm.selectedItem[_vm.textField]))]):_vm._e()]),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":_vm.name}}),_vm._v(" "),_c('ul',{staticClass:"slidedown-menu"},_vm._l((_vm.dropItems),function(item){return _c('li',{attrs:{"id":item[_vm.dataField]}},[_vm._v(_vm._s(item[_vm.textField]))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FaqComponent_vue__ = __webpack_require__(326);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fc3aac3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FaqComponent_vue__ = __webpack_require__(959);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FaqComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fc3aac3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FaqComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "faq_svg.svg?3c25de09f9cc52dc34d8a2152d4f5fc9";

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-panel dataContent"},[(_vm.info.User && (_vm.info.User.MainRole === 'administrators' || _vm.info.ProjectsLength > 1 || _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.faqEdit)))?_c('div',{staticClass:"body-panel-control separator"},[_c('div',{staticClass:"control-block-left"},[((_vm.info.User.MainRole === 'administrators' || _vm.info.ProjectsLength > 1))?_c('project-select',{attrs:{"user":_vm.info.User},on:{"onChange":_vm.onProjectChange}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"control-block-right"},[((_vm.info.User.MainRole === 'administrators' || _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.faqEdit)))?_c('button',{staticClass:"btn edit",on:{"click":function($event){$event.stopPropagation();return _vm.add()}}},[_vm._v("Добавить")]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"body-panel-content body-panel-content-page"},[_c('Container',{attrs:{"lock-axis":_vm.lockAxis,"drag-handle-selector":".svg-icon"},on:{"drop":_vm.onFieldSettingsDrop}},_vm._l((_vm.editItemsOrdered),function(item,i){return _c('Draggable',[_c('div',[(!item.editing)?[_c('div',{class:['lite-block block-in-page-collapce', {'expanded': item.expanded}]},[_c('div',{staticClass:"flex padding-right-20",on:{"click":function($event){return _vm.onItemSelect(item)}}},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":'/Content/dist/faq_svg.svg#' + item.svgName}})]),_vm._v(" "),_c('p',{staticClass:"header",domProps:{"innerHTML":_vm._s(_vm.formatMarkdownLiteToHtml(item.title))}})]),_vm._v(" "),_c('div',{staticClass:"lite-block-detail"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.formatMarkdownLiteToHtml(item.body))}}),_vm._v(" "),(!item.editing && item.expanded && _vm.info.User && (_vm.info.User.MainRole === 'administrators' || _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.faqEdit)))?_c('button',{staticClass:"btn edit btn-img",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteItem(item, i)}}},[_c('img',{attrs:{"src":__webpack_require__(17),"alt":""}})]):_vm._e(),_vm._v(" "),(!item.editing && item.expanded && _vm.info.User && (_vm.info.User.MainRole === 'administrators' || _vm.hasClaims(_vm.info.User.DynamicRole, _vm.claimEnums.faqEdit)))?_c('button',{staticClass:"btn edit btn-img",on:{"click":function($event){$event.stopPropagation();return _vm.onItemEdit(item, i)}}},[_c('img',{attrs:{"src":__webpack_require__(31),"alt":""}})]):_vm._e()])])]:_vm._e(),_vm._v(" "),(item.editing)?[_c('div',{staticClass:"block-in-page lite-block"},[_c('div',{staticClass:"flex padding-right-20"},[_c('svg',{staticClass:"svg-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":'/Content/dist/faq_svg.svg#' + item.svgName}})]),_vm._v(" "),_c('p',{staticClass:"header",domProps:{"innerHTML":_vm._s(_vm.formatMarkdownLiteToHtml(item.title))}})]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Заголовок вопроса\n                                    "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(item.title),expression:"item.title"}],class:['input-text', {'input-error': _vm.errors.has('Title' + i)}],attrs:{"type":"text","name":'Title' + i,"data-vv-as":"Заголовок"},domProps:{"value":(item.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "title", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Title' + i)))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Текст ответа\n                                    "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])]),_vm._v(" "),_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(item.body),expression:"item.body"}],class:['input-memo', {'input-error': _vm.errors.has('Body' + i)}],staticStyle:{"height":"100px"},attrs:{"rows":"10","name":'Body' + i,"data-vv-as":"Текст ответа"},domProps:{"value":(item.body)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "body", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Body' + i)))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                                    Иконка\n                                ")]),_vm._v(" "),_c('div',{staticClass:"svg-container margin-top-5"},_vm._l((_vm.icons),function(icon){return _c('svg',{class:['svg-icon', {selected: icon === item.svgName}],attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"},on:{"click":function($event){return _vm.onIconSelect(i, icon)}}},[_c('use',{attrs:{"xlink:href":'/Content/dist/faq_svg.svg#' + icon}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"btns flex margin-top-10"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.save(item)}}},[_vm._v("Сохранить")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.itemCancelEditing()}}},[_vm._v("Отмена")])])])]:_vm._e()],2)])}),1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirstLaunch_vue__ = __webpack_require__(327);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_467f3eab_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirstLaunch_vue__ = __webpack_require__(963);
function injectStyle (ssrContext) {
  __webpack_require__(961)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-467f3eab"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirstLaunch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_467f3eab_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirstLaunch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(962);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("44414c5f", content, true, {});

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".btn.btn-action-close[data-v-467f3eab]{margin:10px auto 0}", ""]);

// exports


/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popup-window',{ref:"ppModal",attrs:{"title":_vm.currentAction ? _vm.currentAction.Title : '',"width":"50%","modal":true}},[_c('div',{ref:"ppContent",staticClass:"first-launch-content",staticStyle:{"height":"400px"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-action-close",attrs:{"type":"button"},on:{"click":_vm.onActionClose}},[_vm._v("Закрыть")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DomainFolder_vue__ = __webpack_require__(328);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae3aa106_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DomainFolder_vue__ = __webpack_require__(967);
function injectStyle (ssrContext) {
  __webpack_require__(965)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ae3aa106"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DomainFolder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae3aa106_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DomainFolder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(966);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1caaee21", content, true, {});

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"block-in-page"},[_c('div',{staticClass:"form-field"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.folder.Name),expression:"folder.Name"}],class:['input-text', {'input-error': _vm.errors.has('Name')}],attrs:{"name":"Name","type":"text"},domProps:{"value":(_vm.folder.Name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.folder, "Name", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Name')))])]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                Описание\n            ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.folder.Description),expression:"folder.Description"}],staticClass:"input-memo",staticStyle:{"height":"150px"},attrs:{"name":"Description","rows":"10"},domProps:{"value":(_vm.folder.Description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.folder, "Description", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"field-validation-valid"},[_vm._v(_vm._s(_vm.errors.first('Description')))])]),_vm._v(" "),(_vm.parentFolders && _vm.parentFolders.length)?_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                Родительская папка\n            ")]),_vm._v(" "),_c('drop-down',{attrs:{"items":_vm.parentFolders,"dataField":'Id',"textField":'Name'},model:{value:(_vm.folder.ParentId),callback:function ($$v) {_vm.$set(_vm.folder, "ParentId", $$v)},expression:"folder.ParentId"}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"block-in-page"},[_c('div',{staticClass:"flex"},[_c('image-setting',{attrs:{"img":_vm.imgSite,"name":'site',"parentImage":true},on:{"onImageViewChanged":_vm.onImageViewChanged,"onImageStyleParamsChanged":_vm.onImageStyleParamsChanged}}),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"300px","min-width":"300px","margin-left":"20px"}},[_c('div',{staticClass:"panel-block panel-block-new",staticStyle:{"margin-right":"0"}},[_c('div',{staticClass:"panel-block-img-base"},[_c('div',{staticClass:"panel-block-img"},[(_vm.imgSitePath)?_c('img',{style:(_vm.imageStyleFormatted),attrs:{"src":_vm.imgSitePath,"alt":""}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"panel-block-info"},[_c('p',{staticClass:"panel-block-header margin-bottom-10"},[_vm._v(_vm._s(_vm.folder.Name))]),_vm._v(" "),_c('p',{staticClass:"panel-body-desc",domProps:{"innerHTML":_vm._s(_vm.folder.DescriptionFormatted)}})]),_vm._v(" "),_vm._m(1)])])],1)]),_vm._v(" "),_c('div',{staticClass:"block-in-page"},[_c('div',{staticClass:"flex"},[_c('image-setting',{attrs:{"img":_vm.imgMobile,"parentImgPath":_vm.imgSitePath,"name":'mobile'},on:{"onImageViewChanged":_vm.onImageViewChanged,"onImageStyleParamsChanged":_vm.onImageStyleParamsChanged}}),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"400px","min-width":"400px","margin-left":"20px"}},[_c('div',{staticClass:"panel-block panel-block-new panel-block-mobile",staticStyle:{"margin-right":"0"}},[_c('div',{staticClass:"panel-block-img-base panel-block-img-mobile-folder"},[_c('div',{staticClass:"panel-block-img panel-block-img-mobile-folder"},[(_vm.imgMobilePath)?_c('img',{style:(_vm.imageStyleMobileFormatted),attrs:{"src":_vm.imgMobilePath,"alt":""}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"panel-block-info"},[_c('p',{staticClass:"panel-block-header margin-bottom-10"},[_vm._v(_vm._s(_vm.folder.Name))]),_vm._v(" "),_c('p',{staticClass:"panel-body-desc",domProps:{"innerHTML":_vm._s(_vm.folder.DescriptionFormatted)}})])]),_vm._v(" "),_vm._m(2)])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                Название папки\n                "),_c('span',{staticClass:"required",attrs:{"aria-required":"true"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-body-actions"},[_c('button',{staticClass:"btn"},[_vm._v("Подробнее")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-body-actions"},[_c('button',{staticClass:"btn"},[_vm._v("Подробнее")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(9);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('date-short', function (val) {
   if (val === undefined || val === null) {
      return '';
   }
   return Object(__WEBPACK_IMPORTED_MODULE_1_moment__["default"])(val).format('DD.MM.YYYY');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('date-long', function (val) {
   if (val === undefined) {
      return '';
   }
   return Object(__WEBPACK_IMPORTED_MODULE_1_moment__["default"])(val).format('DD.MM.YYYY HH:mm');
});

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(79);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('context-menu', {
    bind: function bind(el, binding) {
        el.directiveEvent = function (ev) {
            el.$target = el.$target || $('#' + binding.value);
            el.$target.appendTo('body');
            el.$target.toggle();

            var docWidth = $(document).width(),
                docHeight = $(document).height(),
                elOffset = $(el).offset(),
                elWidth = $(el).outerWidth(),
                elHeight = $(el).outerHeight(),
                targetWidth = el.$target.outerWidth();

            el.$target.css({
                right: 'auto',
                bottom: 'auto',
                left: docWidth < elOffset.left + targetWidth ? elOffset.left - (targetWidth - elWidth) : elOffset.left + 'px',
                top: elOffset.top + elHeight + 5 + 'px'
            });
        };
        el.hideEvent = function (ev) {
            if (el.$target && el != ev.target) {
                el.$target.hide();
            }
        };

        el.addEventListener('click', el.directiveEvent);
        document.body.addEventListener('click', el.hideEvent);
    },
    unbind: function unbind(el, binding) {
        el.removeEventListener('click', el.directiveEvent);
        document.body.removeEventListener('click', el.hideEvent);
        if (el.$target) {
            el.$target.remove();
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(30)))

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vee_validate__ = __webpack_require__(204);


__WEBPACK_IMPORTED_MODULE_0_vee_validate__["a" /* Validator */].extend('positive', {
    getMessage: function getMessage(field) {
        return 'The ' + field + ' value is not positive.';
    },
    validate: function validate(value) {
        if (value === '' || value === undefined) {
            return false;
        }
        var n = parseFloat((value + '').replace(',', '.'));
        return n >= 0;
    }
});

__WEBPACK_IMPORTED_MODULE_0_vee_validate__["a" /* Validator */].extend('youtube', {
    getMessage: function getMessage(field) {
        return 'Поле "' + field + '" имеет не верный формат для ссылки Youtube';
    },
    validate: function validate(value) {
        if (value === '' || value === undefined) {
            return false;
        }
        var regExp = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
        return regExp.test(value);
        //return (/^https:\/\/(www\.)?youtube.com\/embed\/.*/ig).test(value);
    }
});

__WEBPACK_IMPORTED_MODULE_0_vee_validate__["a" /* Validator */].extend('percent', {
    getMessage: function getMessage(field) {
        return 'Поле "' + field + '" имеет не верное значение';
    },
    validate: function validate(value) {
        if (value === '' || value === undefined) {
            return false;
        }

        if (!/^\-?\d{1,}(?:\.|\,)?\d{0,}$/ig.test(value)) {
            return false;
        }

        var percentNumber = parseFloat(value);
        if (isNaN(percentNumber)) {
            return false;
        }

        return Math.abs(percentNumber) <= 100;
    }
});

__WEBPACK_IMPORTED_MODULE_0_vee_validate__["a" /* Validator */].extend('bik', {
    getMessage: function getMessage(field) {
        return 'Поле "' + field + '" имеет не верный формат';
    },
    validate: function validate(value) {
        if (value === '' || value === undefined) {
            return false;
        }
        return (/^04\d{7}$/ig.test(value)
        );
    }
});

__WEBPACK_IMPORTED_MODULE_0_vee_validate__["a" /* Validator */].extend('cs', {
    getMessage: function getMessage(field) {
        return 'Поле "' + field + '" имеет не верный формат';
    },
    validate: function validate(value, args) {
        if (value === '' || value === undefined) {
            return false;
        }
        if (!/^\d{20}$/ig.test(value)) {
            return false;
        }
        if (args.length && args[0]) {
            var bikCs = '0' + args[0].slice(4, 6) + value;
            var checksum = 0;
            var coefficients = [7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1];
            for (var i in coefficients) {
                checksum += coefficients[i] * (bikCs[i] % 10);
            }
            return checksum % 10 === 0;
        } else {
            return true;
        }
    }
});

__WEBPACK_IMPORTED_MODULE_0_vee_validate__["a" /* Validator */].extend('rs', {
    getMessage: function getMessage(field) {
        return 'Поле "' + field + '" имеет не верный формат';
    },
    validate: function validate(value, args) {
        if (value === '' || value === undefined) {
            return false;
        }
        if (!/^\d{20}$/ig.test(value)) {
            return false;
        }
        if (args.length && args[0]) {
            var bikRs = args[0].slice(-3) + value;
            var checksum = 0;
            var coefficients = [7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1];
            for (var i in coefficients) {
                checksum += coefficients[i] * (bikRs[i] % 10);
            }
            //console.info('checksum', checksum);
            return checksum % 10 === 0;
        } else {
            return true;
        }
    }
});

__WEBPACK_IMPORTED_MODULE_0_vee_validate__["a" /* Validator */].extend('jsonArray', {
    getMessage: function getMessage(field) {
        return 'Поле "' + field + '" имеет не верный формат для типа Список';
    },
    validate: function validate(value) {
        if (value === '' || value === undefined) {
            return false;
        }
        try {
            var obj = JSON.parse(value);
            if (Array.isArray(obj) && obj.length > 0 && typeof obj[0] === 'string') {
                return true;
            }
        } catch (e) {
            //console.info('valid jsonArray er: ', e);
        }
        return false;
    }
});

__WEBPACK_IMPORTED_MODULE_0_vee_validate__["a" /* Validator */].extend('lonlat', {
    getMessage: function getMessage(field) {
        return 'Поле "' + field + '" имеет не верный формат';
    },
    validate: function validate(value) {
        if (value === '' || value === undefined) {
            return false;
        }
        var regExp = /^-?([1][0-8][0-9]|[1-9][0-9]?)[.|,]\d{1,6}$/ig;
        return regExp.test(value);
    }
});

__WEBPACK_IMPORTED_MODULE_0_vee_validate__["a" /* Validator */].extend('passportSeries', {
    getMessage: function getMessage(field) {
        return 'Серия паспорта должна состоять из 4 цифр';
    },
    validate: function validate(value, args) {
        if (value === '' || value === undefined) {
            return false;
        }
        if (args.length > 0 && args[0] === 2) {
            return (/^\d{2}$/ig.test(value)
            );
        } else {
            return (/^\d{4}$/ig.test(value)
            );
        }
    }
});

__WEBPACK_IMPORTED_MODULE_0_vee_validate__["a" /* Validator */].extend('passportNumber', {
    getMessage: function getMessage(field) {
        return 'Номер паспорта должен состоять из 6 цифр';
    },
    validate: function validate(value, args) {
        if (value === '' || value === undefined) {
            return false;
        }
        if (args.length > 0 && args[0] === 7) {
            return (/^\d{7}$/ig.test(value)
            );
        } else {
            return (/^\d{6}$/ig.test(value)
            );
        }
    }
});

__WEBPACK_IMPORTED_MODULE_0_vee_validate__["a" /* Validator */].extend('innfl', {
    getMessage: function getMessage(field) {
        return 'ИНН физического лица должен состоять из 12 цифр';
    },
    validate: function validate(value) {
        if (value === '' || value === undefined) {
            return false;
        }
        var regExp = /^\d{12}$/ig;
        return regExp.test(value);
    }
});

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/**
 * vue-outside-events @ 1.1.3
 * Nicholas Hutchind <nicholas@hutchind.com>
 *
 * Vue directive to react to various events outside the current element
 *
 * License: MIT
 */
!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):e["vue-outside-events"]=t()}(this,function(){"use strict";var e="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},t=function(t,i){var n={};return n.directiveName=t,n.eventName=i,n.bind=function(n,o,u){var d=void 0!==console.error?console.error:console.log,r=null,v=void 0;if("function"!=typeof o.value)if("object"===e(o.value)&&o.value.hasOwnProperty("handler")&&"function"==typeof o.value.handler)r=o.value.handler,delete(v=Object.assign({},o.value)).handler;else{var a="["+t+"]: provided expression '"+o.expression+"' must be a function or an object containing a property named 'handler' that is a function.";u.context.name&&(a+="\nFound in component '"+u.context.name+"'"),d(a)}else r=o.value;var c=function(e){n.contains(e.target)||n===e.target||r(e,n,v)};n["__vueEventOutside__"+i]=c,document.addEventListener(i,c)},n.unbind=function(e,t){document.removeEventListener(i,e["__vueEventOutside__"+i]),e["__vueEventOutside__"+i]=null},n},i={directiveName:"event-outside",bind:function(t,i,n){var o=void 0!==console.error?console.error:console.log,u=void 0;if("object"!==e(i.value)||void 0===i.value.name||"string"!=typeof i.value.name||void 0===i.value.handler||"function"!=typeof i.value.handler){var d="[v-event-outside]: provided expression '"+i.expression+'\' must be an object containing a "name" string and a "handler" function.';return n.context.name&&(d+="\nFound in component '"+n.context.name+"'"),void o(d)}if(delete(u=Object.assign({},i.value)).name,delete u.handler,i.modifiers.jquery&&void 0===window.$&&void 0===window.jQuery){var r="[v-event-outside]: jQuery is not present in window.";return n.context.name&&(r+="\nFound in component '"+n.context.name+"'"),void o(r)}var v=function(e){t.contains(e.target)||t===e.target||i.value.handler(e,t,u)};t["__vueEventOutside__"+i.value.name]=v,i.modifiers.jquery?jQuery(document).on(i.value.name,v):document.addEventListener(i.value.name,v)},unbind:function(e,t){t.modifiers.jquery?jQuery(document).off(t.value.name,e["__vueEventOutside__"+t.value.name]):document.removeEventListener(t.value.name,e["__vueEventOutside__"+t.value.name]),e["__vueEventOutside__"+t.value.name]=null}},n=t("click-outside","click"),o=t("dblclick-outside","dblclick"),u=t("focus-outside","focusin"),d=t("blur-outside","focusout"),r=t("mousemove-outside","mousemove"),v=t("mousedown-outside","mousedown"),a=t("mouseup-outside","mouseup"),c=t("mouseover-outside","mouseover"),s=t("mouseout-outside","mouseout"),m=t("change-outside","change"),l=t("select-outside","select"),f=t("submit-outside","submit"),p=t("keydown-outside","keydown"),y=t("keypress-outside","keypress"),_=t("keyup-outside","keyup"),b={install:function(e){e.directive(n.directiveName,n),e.directive(o.directiveName,o),e.directive(u.directiveName,u),e.directive(d.directiveName,d),e.directive(r.directiveName,r),e.directive(v.directiveName,v),e.directive(a.directiveName,a),e.directive(c.directiveName,c),e.directive(s.directiveName,s),e.directive(m.directiveName,m),e.directive(l.directiveName,l),e.directive(f.directiveName,f),e.directive(p.directiveName,p),e.directive(y.directiveName,y),e.directive(y.directiveName,y),e.directive(_.directiveName,_),e.directive(i.directiveName,i)}};return"undefined"!=typeof window&&window.Vue&&window.Vue.use(b),b});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputTime_vue__ = __webpack_require__(329);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5875a157_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputTime_vue__ = __webpack_require__(976);
function injectStyle (ssrContext) {
  __webpack_require__(973)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5875a157"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputTime_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5875a157_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputTime_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(974);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("27aa8730", content, true, {});

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * Timepicker Component for Twitter Bootstrap
 *
 * Copyright 2013 Joris de Wit and bootstrap-timepicker contributors
 *
 * Contributors https://github.com/jdewit/bootstrap-timepicker/graphs/contributors
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
(function (define) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {

        // TIMEPICKER PUBLIC CLASS DEFINITION
        var Timepicker = function Timepicker(element, options) {
            this.widget = '';
            this.$element = $(element);
            this.defaultTime = options.defaultTime;
            this.disableFocus = options.disableFocus;
            this.disableMousewheel = options.disableMousewheel;
            this.isOpen = options.isOpen;
            this.minuteStep = options.minuteStep;
            this.modalBackdrop = options.modalBackdrop;
            this.orientation = options.orientation;
            this.secondStep = options.secondStep;
            this.snapToStep = options.snapToStep;
            this.showInputs = options.showInputs;
            this.showMeridian = options.showMeridian;
            this.showSeconds = options.showSeconds;
            this.template = options.template;
            this.appendWidgetTo = options.appendWidgetTo;
            this.showWidgetOnAddonClick = options.showWidgetOnAddonClick;
            this.icons = options.icons;
            this.maxHours = options.maxHours;
            this.explicitMode = options.explicitMode; // If true 123 = 1:23, 12345 = 1:23:45, else invalid.

            this.handleDocumentClick = function (e) {
                var self = e.data.scope;
                // This condition was inspired by bootstrap-datepicker.
                // The element the timepicker is invoked on is the input but it has a sibling for addon/button.
                if (!(self.$element.parent().find(e.target).length || self.$widget.is(e.target) || self.$widget.find(e.target).length)) {
                    self.hideWidget();
                }
            };

            this._init();
        };

        Timepicker.prototype = {

            constructor: Timepicker,
            _init: function _init() {
                var self = this;

                if (this.showWidgetOnAddonClick && this.$element.parent().hasClass('input-group') && this.$element.parent().hasClass('bootstrap-timepicker')) {
                    this.$element.parent('.input-group.bootstrap-timepicker').find('.input-group-addon').on({
                        'click.timepicker': $.proxy(this.showWidget, this)
                    });
                    this.$element.on({
                        'focus.timepicker': $.proxy(this.highlightUnit, this),
                        'click.timepicker': $.proxy(this.highlightUnit, this),
                        'keydown.timepicker': $.proxy(this.elementKeydown, this),
                        'blur.timepicker': $.proxy(this.blurElement, this),
                        'mousewheel.timepicker DOMMouseScroll.timepicker': $.proxy(this.mousewheel, this)
                    });
                } else {
                    if (this.template) {
                        this.$element.on({
                            'focus.timepicker': $.proxy(this.showWidget, this),
                            'click.timepicker': $.proxy(this.showWidget, this),
                            'blur.timepicker': $.proxy(this.blurElement, this),
                            'mousewheel.timepicker DOMMouseScroll.timepicker': $.proxy(this.mousewheel, this)
                        });
                    } else {
                        this.$element.on({
                            'focus.timepicker': $.proxy(this.highlightUnit, this),
                            'click.timepicker': $.proxy(this.highlightUnit, this),
                            'keydown.timepicker': $.proxy(this.elementKeydown, this),
                            'blur.timepicker': $.proxy(this.blurElement, this),
                            'mousewheel.timepicker DOMMouseScroll.timepicker': $.proxy(this.mousewheel, this)
                        });
                    }
                }

                if (this.template !== false) {
                    this.$widget = $(this.getTemplate()).on('click', $.proxy(this.widgetClick, this));
                } else {
                    this.$widget = false;
                }

                if (this.showInputs && this.$widget !== false) {
                    this.$widget.find('input').each(function () {
                        $(this).on({
                            'click.timepicker': function clickTimepicker() {
                                $(this).select();
                            },
                            'keydown.timepicker': $.proxy(self.widgetKeydown, self),
                            'keyup.timepicker': $.proxy(self.widgetKeyup, self)
                        });
                    });
                }

                this.setDefaultTime(this.defaultTime);
            },

            blurElement: function blurElement() {
                this.highlightedUnit = null;
                this.updateFromElementVal();
            },

            clear: function clear() {
                this.hour = '';
                this.minute = '';
                this.second = '';
                this.meridian = '';

                this.$element.val('');
            },

            decrementHour: function decrementHour() {
                if (this.showMeridian) {
                    if (this.hour === 1) {
                        this.hour = 12;
                    } else if (this.hour === 12) {
                        this.hour--;

                        return this.toggleMeridian();
                    } else if (this.hour === 0) {
                        this.hour = 11;

                        return this.toggleMeridian();
                    } else {
                        this.hour--;
                    }
                } else {
                    if (this.hour <= 0) {
                        this.hour = this.maxHours - 1;
                    } else {
                        this.hour--;
                    }
                }
            },

            decrementMinute: function decrementMinute(step) {
                var newVal;

                if (step) {
                    newVal = this.minute - step;
                } else {
                    newVal = this.minute - this.minuteStep;
                }

                if (newVal < 0) {
                    this.decrementHour();
                    this.minute = newVal + 60;
                } else {
                    this.minute = newVal;
                }
            },

            decrementSecond: function decrementSecond() {
                var newVal = this.second - this.secondStep;

                if (newVal < 0) {
                    this.decrementMinute(true);
                    this.second = newVal + 60;
                } else {
                    this.second = newVal;
                }
            },

            elementKeydown: function elementKeydown(e) {
                switch (e.which) {
                    case 9:
                        //tab
                        if (e.shiftKey) {
                            if (this.highlightedUnit === 'hour') {
                                this.hideWidget();
                                break;
                            }
                            this.highlightPrevUnit();
                        } else if (this.showMeridian && this.highlightedUnit === 'meridian' || this.showSeconds && this.highlightedUnit === 'second' || !this.showMeridian && !this.showSeconds && this.highlightedUnit === 'minute') {
                            this.hideWidget();
                            break;
                        } else {
                            this.highlightNextUnit();
                        }
                        e.preventDefault();
                        this.updateFromElementVal();
                        break;
                    case 27:
                        // escape
                        this.updateFromElementVal();
                        break;
                    case 37:
                        // left arrow
                        e.preventDefault();
                        this.highlightPrevUnit();
                        this.updateFromElementVal();
                        break;
                    case 38:
                        // up arrow
                        e.preventDefault();
                        switch (this.highlightedUnit) {
                            case 'hour':
                                this.incrementHour();
                                this.highlightHour();
                                break;
                            case 'minute':
                                this.incrementMinute();
                                this.highlightMinute();
                                break;
                            case 'second':
                                this.incrementSecond();
                                this.highlightSecond();
                                break;
                            case 'meridian':
                                this.toggleMeridian();
                                this.highlightMeridian();
                                break;
                        }
                        this.update();
                        break;
                    case 39:
                        // right arrow
                        e.preventDefault();
                        this.highlightNextUnit();
                        this.updateFromElementVal();
                        break;
                    case 40:
                        // down arrow
                        e.preventDefault();
                        switch (this.highlightedUnit) {
                            case 'hour':
                                this.decrementHour();
                                this.highlightHour();
                                break;
                            case 'minute':
                                this.decrementMinute();
                                this.highlightMinute();
                                break;
                            case 'second':
                                this.decrementSecond();
                                this.highlightSecond();
                                break;
                            case 'meridian':
                                this.toggleMeridian();
                                this.highlightMeridian();
                                break;
                        }

                        this.update();
                        break;
                }
            },

            getCursorPosition: function getCursorPosition() {
                var input = this.$element.get(0);

                if ('selectionStart' in input) {
                    // Standard-compliant browsers

                    return input.selectionStart;
                } else if (document.selection) {
                    // IE fix
                    input.focus();
                    var sel = document.selection.createRange(),
                        selLen = document.selection.createRange().text.length;

                    sel.moveStart('character', -input.value.length);

                    return sel.text.length - selLen;
                }
            },

            getTemplate: function getTemplate() {
                var template, hourTemplate, minuteTemplate, secondTemplate, meridianTemplate, templateContent;

                if (this.showInputs) {
                    hourTemplate = '<input type="text" class="bootstrap-timepicker-hour" maxlength="2"/>';
                    minuteTemplate = '<input type="text" class="bootstrap-timepicker-minute" maxlength="2"/>';
                    secondTemplate = '<input type="text" class="bootstrap-timepicker-second" maxlength="2"/>';
                    meridianTemplate = '<input type="text" class="bootstrap-timepicker-meridian" maxlength="2"/>';
                } else {
                    hourTemplate = '<span class="bootstrap-timepicker-hour"></span>';
                    minuteTemplate = '<span class="bootstrap-timepicker-minute"></span>';
                    secondTemplate = '<span class="bootstrap-timepicker-second"></span>';
                    meridianTemplate = '<span class="bootstrap-timepicker-meridian"></span>';
                }

                templateContent = '<table>' + '<tr>' + '<td><a href="#" data-action="incrementHour"><span class="' + this.icons.up + '"></span></a></td>' + '<td class="separator">&nbsp;</td>' + '<td><a href="#" data-action="incrementMinute"><span class="' + this.icons.up + '"></span></a></td>' + (this.showSeconds ? '<td class="separator">&nbsp;</td>' + '<td><a href="#" data-action="incrementSecond"><span class="' + this.icons.up + '"></span></a></td>' : '') + (this.showMeridian ? '<td class="separator">&nbsp;</td>' + '<td class="meridian-column"><a href="#" data-action="toggleMeridian"><span class="' + this.icons.up + '"></span></a></td>' : '') + '</tr>' + '<tr>' + '<td>' + hourTemplate + '</td> ' + '<td class="separator">:</td>' + '<td>' + minuteTemplate + '</td> ' + (this.showSeconds ? '<td class="separator">:</td>' + '<td>' + secondTemplate + '</td>' : '') + (this.showMeridian ? '<td class="separator">&nbsp;</td>' + '<td>' + meridianTemplate + '</td>' : '') + '</tr>' + '<tr>' + '<td><a href="#" data-action="decrementHour"><span class="' + this.icons.down + '"></span></a></td>' + '<td class="separator"></td>' + '<td><a href="#" data-action="decrementMinute"><span class="' + this.icons.down + '"></span></a></td>' + (this.showSeconds ? '<td class="separator">&nbsp;</td>' + '<td><a href="#" data-action="decrementSecond"><span class="' + this.icons.down + '"></span></a></td>' : '') + (this.showMeridian ? '<td class="separator">&nbsp;</td>' + '<td><a href="#" data-action="toggleMeridian"><span class="' + this.icons.down + '"></span></a></td>' : '') + '</tr>' + '</table>';

                switch (this.template) {
                    case 'modal':
                        template = '<div class="bootstrap-timepicker-widget modal hide fade in" data-backdrop="' + (this.modalBackdrop ? 'true' : 'false') + '">' + '<div class="modal-header">' + '<a href="#" class="close" data-dismiss="modal">&times;</a>' + '<h3>Pick a Time</h3>' + '</div>' + '<div class="modal-content">' + templateContent + '</div>' + '<div class="modal-footer">' + '<a href="#" class="btn btn-primary" data-dismiss="modal">OK</a>' + '</div>' + '</div>';
                        break;
                    case 'dropdown':
                        template = '<div class="bootstrap-timepicker-widget dropdown-menu">' + templateContent + '</div>';
                        break;
                }

                return template;
            },

            getTime: function getTime() {
                if (this.hour === '') {
                    return '';
                }

                return this.hour + ':' + (this.minute.toString().length === 1 ? '0' + this.minute : this.minute) + (this.showSeconds ? ':' + (this.second.toString().length === 1 ? '0' + this.second : this.second) : '') + (this.showMeridian ? ' ' + this.meridian : '');
            },

            hideWidget: function hideWidget() {
                if (this.isOpen === false) {
                    return;
                }

                this.$element.trigger({
                    'type': 'hide.timepicker',
                    'time': {
                        'value': this.getTime(),
                        'hours': this.hour,
                        'minutes': this.minute,
                        'seconds': this.second,
                        'meridian': this.meridian
                    }
                });

                if (this.template === 'modal' && this.$widget.modal) {
                    this.$widget.modal('hide');
                } else {
                    this.$widget.removeClass('open');
                }

                $(document).off('mousedown.timepicker, touchend.timepicker', this.handleDocumentClick);

                this.isOpen = false;
                // show/hide approach taken by datepicker
                this.$widget.detach();
            },

            highlightUnit: function highlightUnit() {
                this.position = this.getCursorPosition();
                if (this.position >= 0 && this.position <= 2) {
                    this.highlightHour();
                } else if (this.position >= 3 && this.position <= 5) {
                    this.highlightMinute();
                } else if (this.position >= 6 && this.position <= 8) {
                    if (this.showSeconds) {
                        this.highlightSecond();
                    } else {
                        this.highlightMeridian();
                    }
                } else if (this.position >= 9 && this.position <= 11) {
                    this.highlightMeridian();
                }
            },

            highlightNextUnit: function highlightNextUnit() {
                switch (this.highlightedUnit) {
                    case 'hour':
                        this.highlightMinute();
                        break;
                    case 'minute':
                        if (this.showSeconds) {
                            this.highlightSecond();
                        } else if (this.showMeridian) {
                            this.highlightMeridian();
                        } else {
                            this.highlightHour();
                        }
                        break;
                    case 'second':
                        if (this.showMeridian) {
                            this.highlightMeridian();
                        } else {
                            this.highlightHour();
                        }
                        break;
                    case 'meridian':
                        this.highlightHour();
                        break;
                }
            },

            highlightPrevUnit: function highlightPrevUnit() {
                switch (this.highlightedUnit) {
                    case 'hour':
                        if (this.showMeridian) {
                            this.highlightMeridian();
                        } else if (this.showSeconds) {
                            this.highlightSecond();
                        } else {
                            this.highlightMinute();
                        }
                        break;
                    case 'minute':
                        this.highlightHour();
                        break;
                    case 'second':
                        this.highlightMinute();
                        break;
                    case 'meridian':
                        if (this.showSeconds) {
                            this.highlightSecond();
                        } else {
                            this.highlightMinute();
                        }
                        break;
                }
            },

            highlightHour: function highlightHour() {
                var $element = this.$element.get(0),
                    self = this;

                this.highlightedUnit = 'hour';

                if ($element.setSelectionRange) {
                    setTimeout(function () {
                        if (self.hour < 10) {
                            $element.setSelectionRange(0, 1);
                        } else {
                            $element.setSelectionRange(0, 2);
                        }
                    }, 0);
                }
            },

            highlightMinute: function highlightMinute() {
                var $element = this.$element.get(0),
                    self = this;

                this.highlightedUnit = 'minute';

                if ($element.setSelectionRange) {
                    setTimeout(function () {
                        if (self.hour < 10) {
                            $element.setSelectionRange(2, 4);
                        } else {
                            $element.setSelectionRange(3, 5);
                        }
                    }, 0);
                }
            },

            highlightSecond: function highlightSecond() {
                var $element = this.$element.get(0),
                    self = this;

                this.highlightedUnit = 'second';

                if ($element.setSelectionRange) {
                    setTimeout(function () {
                        if (self.hour < 10) {
                            $element.setSelectionRange(5, 7);
                        } else {
                            $element.setSelectionRange(6, 8);
                        }
                    }, 0);
                }
            },

            highlightMeridian: function highlightMeridian() {
                var $element = this.$element.get(0),
                    self = this;

                this.highlightedUnit = 'meridian';

                if ($element.setSelectionRange) {
                    if (this.showSeconds) {
                        setTimeout(function () {
                            if (self.hour < 10) {
                                $element.setSelectionRange(8, 10);
                            } else {
                                $element.setSelectionRange(9, 11);
                            }
                        }, 0);
                    } else {
                        setTimeout(function () {
                            if (self.hour < 10) {
                                $element.setSelectionRange(5, 7);
                            } else {
                                $element.setSelectionRange(6, 8);
                            }
                        }, 0);
                    }
                }
            },

            incrementHour: function incrementHour() {
                if (this.showMeridian) {
                    if (this.hour === 11) {
                        this.hour++;
                        return this.toggleMeridian();
                    } else if (this.hour === 12) {
                        this.hour = 0;
                    }
                }
                if (this.hour === this.maxHours - 1) {
                    this.hour = 0;

                    return;
                }
                this.hour++;
            },

            incrementMinute: function incrementMinute(step) {
                var newVal;

                if (step) {
                    newVal = this.minute + step;
                } else {
                    newVal = this.minute + this.minuteStep - this.minute % this.minuteStep;
                }

                if (newVal > 59) {
                    this.incrementHour();
                    this.minute = newVal - 60;
                } else {
                    this.minute = newVal;
                }
            },

            incrementSecond: function incrementSecond() {
                var newVal = this.second + this.secondStep - this.second % this.secondStep;

                if (newVal > 59) {
                    this.incrementMinute(true);
                    this.second = newVal - 60;
                } else {
                    this.second = newVal;
                }
            },

            mousewheel: function mousewheel(e) {
                if (this.disableMousewheel) {
                    return;
                }

                e.preventDefault();
                e.stopPropagation();

                var delta = e.originalEvent.wheelDelta || -e.originalEvent.detail,
                    scrollTo = null;

                if (e.type === 'mousewheel') {
                    scrollTo = e.originalEvent.wheelDelta * -1;
                } else if (e.type === 'DOMMouseScroll') {
                    scrollTo = 40 * e.originalEvent.detail;
                }

                if (scrollTo) {
                    e.preventDefault();
                    $(this).scrollTop(scrollTo + $(this).scrollTop());
                }

                switch (this.highlightedUnit) {
                    case 'minute':
                        if (delta > 0) {
                            this.incrementMinute();
                        } else {
                            this.decrementMinute();
                        }
                        this.highlightMinute();
                        break;
                    case 'second':
                        if (delta > 0) {
                            this.incrementSecond();
                        } else {
                            this.decrementSecond();
                        }
                        this.highlightSecond();
                        break;
                    case 'meridian':
                        this.toggleMeridian();
                        this.highlightMeridian();
                        break;
                    default:
                        if (delta > 0) {
                            this.incrementHour();
                        } else {
                            this.decrementHour();
                        }
                        this.highlightHour();
                        break;
                }

                return false;
            },

            /**
             * Given a segment value like 43, will round and snap the segment
             * to the nearest "step", like 45 if step is 15. Segment will
             * "overflow" to 0 if it's larger than 59 or would otherwise
             * round up to 60.
             */
            changeToNearestStep: function changeToNearestStep(segment, step) {
                if (segment % step === 0) {
                    return segment;
                }
                if (Math.round(segment % step / step)) {
                    return (segment + (step - segment % step)) % 60;
                } else {
                    return segment - segment % step;
                }
            },

            // This method was adapted from bootstrap-datepicker.
            place: function place() {
                if (this.isInline) {
                    return;
                }
                var widgetWidth = this.$widget.outerWidth(),
                    widgetHeight = this.$widget.outerHeight(),
                    visualPadding = 10,
                    windowWidth = $(window).width(),
                    windowHeight = $(window).height(),
                    scrollTop = $(window).scrollTop();

                var zIndex = parseInt(this.$element.parents().filter(function () {
                    return $(this).css('z-index') !== 'auto';
                }).first().css('z-index'), 10) + 10;
                var offset = this.component ? this.component.parent().offset() : this.$element.offset();
                var height = this.component ? this.component.outerHeight(true) : this.$element.outerHeight(false);
                var width = this.component ? this.component.outerWidth(true) : this.$element.outerWidth(false);
                var left = offset.left,
                    top = offset.top;

                this.$widget.removeClass('timepicker-orient-top timepicker-orient-bottom timepicker-orient-right timepicker-orient-left');

                if (this.orientation.x !== 'auto') {
                    this.$widget.addClass('timepicker-orient-' + this.orientation.x);
                    if (this.orientation.x === 'right') {
                        left -= widgetWidth - width;
                    }
                } else {
                    // auto x orientation is best-placement: if it crosses a window edge, fudge it sideways
                    // Default to left
                    this.$widget.addClass('timepicker-orient-left');
                    if (offset.left < 0) {
                        left -= offset.left - visualPadding;
                    } else if (offset.left + widgetWidth > windowWidth) {
                        left = windowWidth - widgetWidth - visualPadding;
                    }
                }
                // auto y orientation is best-situation: top or bottom, no fudging, decision based on which shows more of the widget
                var yorient = this.orientation.y,
                    topOverflow,
                    bottomOverflow;
                if (yorient === 'auto') {
                    topOverflow = -scrollTop + offset.top - widgetHeight;
                    bottomOverflow = scrollTop + windowHeight - (offset.top + height + widgetHeight);
                    if (Math.max(topOverflow, bottomOverflow) === bottomOverflow) {
                        yorient = 'top';
                    } else {
                        yorient = 'bottom';
                    }
                }
                this.$widget.addClass('timepicker-orient-' + yorient);
                if (yorient === 'top') {
                    top += height;
                } else {
                    top -= widgetHeight + parseInt(this.$widget.css('padding-top'), 10);
                }

                this.$widget.css({
                    top: top,
                    left: left,
                    zIndex: zIndex
                });
            },

            remove: function remove() {
                $('document').off('.timepicker');
                if (this.$widget) {
                    this.$widget.remove();
                }
                delete this.$element.data().timepicker;
            },

            setDefaultTime: function setDefaultTime(defaultTime) {
                if (!this.$element.val()) {
                    if (defaultTime === 'current') {
                        var dTime = new Date(),
                            hours = dTime.getHours(),
                            minutes = dTime.getMinutes(),
                            seconds = dTime.getSeconds(),
                            meridian = 'AM';

                        if (seconds !== 0) {
                            seconds = Math.ceil(dTime.getSeconds() / this.secondStep) * this.secondStep;
                            if (seconds === 60) {
                                minutes += 1;
                                seconds = 0;
                            }
                        }

                        if (minutes !== 0) {
                            minutes = Math.ceil(dTime.getMinutes() / this.minuteStep) * this.minuteStep;
                            if (minutes === 60) {
                                hours += 1;
                                minutes = 0;
                            }
                        }

                        if (this.showMeridian) {
                            if (hours === 0) {
                                hours = 12;
                            } else if (hours >= 12) {
                                if (hours > 12) {
                                    hours = hours - 12;
                                }
                                meridian = 'PM';
                            } else {
                                meridian = 'AM';
                            }
                        }

                        this.hour = hours;
                        this.minute = minutes;
                        this.second = seconds;
                        this.meridian = meridian;

                        this.update();
                    } else if (defaultTime === false) {
                        this.hour = 0;
                        this.minute = 0;
                        this.second = 0;
                        this.meridian = 'AM';
                    } else {
                        this.setTime(defaultTime);
                    }
                } else {
                    this.updateFromElementVal();
                }
            },

            setTime: function setTime(time, ignoreWidget) {
                if (!time) {
                    this.clear();
                    return;
                }

                var timeMode, timeArray, hour, minute, second, meridian;

                if ((typeof time === 'undefined' ? 'undefined' : _typeof(time)) === 'object' && time.getMonth) {
                    // this is a date object
                    hour = time.getHours();
                    minute = time.getMinutes();
                    second = time.getSeconds();

                    if (this.showMeridian) {
                        meridian = 'AM';
                        if (hour > 12) {
                            meridian = 'PM';
                            hour = hour % 12;
                        }

                        if (hour === 12) {
                            meridian = 'PM';
                        }
                    }
                } else {
                    timeMode = (/a/i.test(time) ? 1 : 0) + (/p/i.test(time) ? 2 : 0); // 0 = none, 1 = AM, 2 = PM, 3 = BOTH.
                    if (timeMode > 2) {
                        // If both are present, fail.
                        this.clear();
                        return;
                    }

                    timeArray = time.replace(/[^0-9\:]/g, '').split(':');

                    hour = timeArray[0] ? timeArray[0].toString() : timeArray.toString();

                    if (this.explicitMode && hour.length > 2 && hour.length % 2 !== 0) {
                        this.clear();
                        return;
                    }

                    minute = timeArray[1] ? timeArray[1].toString() : '';
                    second = timeArray[2] ? timeArray[2].toString() : '';

                    // adaptive time parsing
                    if (hour.length > 4) {
                        second = hour.slice(-2);
                        hour = hour.slice(0, -2);
                    }

                    if (hour.length > 2) {
                        minute = hour.slice(-2);
                        hour = hour.slice(0, -2);
                    }

                    if (minute.length > 2) {
                        second = minute.slice(-2);
                        minute = minute.slice(0, -2);
                    }

                    hour = parseInt(hour, 10);
                    minute = parseInt(minute, 10);
                    second = parseInt(second, 10);

                    if (isNaN(hour)) {
                        hour = 0;
                    }
                    if (isNaN(minute)) {
                        minute = 0;
                    }
                    if (isNaN(second)) {
                        second = 0;
                    }

                    // Adjust the time based upon unit boundary.
                    // NOTE: Negatives will never occur due to time.replace() above.
                    if (second > 59) {
                        second = 59;
                    }

                    if (minute > 59) {
                        minute = 59;
                    }

                    if (hour >= this.maxHours) {
                        // No day/date handling.
                        hour = this.maxHours - 1;
                    }

                    if (this.showMeridian) {
                        if (hour > 12) {
                            // Force PM.
                            timeMode = 2;
                            hour -= 12;
                        }
                        if (!timeMode) {
                            timeMode = 1;
                        }
                        if (hour === 0) {
                            hour = 12; // AM or PM, reset to 12.  0 AM = 12 AM.  0 PM = 12 PM, etc.
                        }
                        meridian = timeMode === 1 ? 'AM' : 'PM';
                    } else if (hour < 12 && timeMode === 2) {
                        hour += 12;
                    } else {
                        if (hour >= this.maxHours) {
                            hour = this.maxHours - 1;
                        } else if (hour < 0 || hour === 12 && timeMode === 1) {
                            hour = 0;
                        }
                    }
                }

                this.hour = hour;
                if (this.snapToStep) {
                    this.minute = this.changeToNearestStep(minute, this.minuteStep);
                    this.second = this.changeToNearestStep(second, this.secondStep);
                } else {
                    this.minute = minute;
                    this.second = second;
                }
                this.meridian = meridian;

                this.update(ignoreWidget);
            },

            showWidget: function showWidget() {
                if (this.isOpen) {
                    return;
                }

                if (this.$element.is(':disabled')) {
                    return;
                }

                // show/hide approach taken by datepicker
                this.$widget.appendTo(this.appendWidgetTo);
                $(document).on('mousedown.timepicker, touchend.timepicker', { scope: this }, this.handleDocumentClick);

                this.$element.trigger({
                    'type': 'show.timepicker',
                    'time': {
                        'value': this.getTime(),
                        'hours': this.hour,
                        'minutes': this.minute,
                        'seconds': this.second,
                        'meridian': this.meridian
                    }
                });

                this.place();
                if (this.disableFocus) {
                    this.$element.blur();
                }

                // widget shouldn't be empty on open
                if (this.hour === '') {
                    if (this.defaultTime) {
                        this.setDefaultTime(this.defaultTime);
                    } else {
                        this.setTime('0:0:0');
                    }
                }

                if (this.template === 'modal' && this.$widget.modal) {
                    this.$widget.modal('show').on('hidden', $.proxy(this.hideWidget, this));
                } else {
                    if (this.isOpen === false) {
                        this.$widget.addClass('open');
                    }
                }

                this.isOpen = true;
            },

            toggleMeridian: function toggleMeridian() {
                this.meridian = this.meridian === 'AM' ? 'PM' : 'AM';
            },

            update: function update(ignoreWidget) {
                this.updateElement();
                if (!ignoreWidget) {
                    this.updateWidget();
                }

                this.$element.trigger({
                    'type': 'changeTime.timepicker',
                    'time': {
                        'value': this.getTime(),
                        'hours': this.hour,
                        'minutes': this.minute,
                        'seconds': this.second,
                        'meridian': this.meridian
                    }
                });
            },

            updateElement: function updateElement() {
                this.$element.val(this.getTime()).change();
            },

            updateFromElementVal: function updateFromElementVal() {
                this.setTime(this.$element.val());
            },

            updateWidget: function updateWidget() {
                if (this.$widget === false) {
                    return;
                }

                var hour = this.hour,
                    minute = this.minute.toString().length === 1 ? '0' + this.minute : this.minute,
                    second = this.second.toString().length === 1 ? '0' + this.second : this.second;

                if (this.showInputs) {
                    this.$widget.find('input.bootstrap-timepicker-hour').val(hour);
                    this.$widget.find('input.bootstrap-timepicker-minute').val(minute);

                    if (this.showSeconds) {
                        this.$widget.find('input.bootstrap-timepicker-second').val(second);
                    }
                    if (this.showMeridian) {
                        this.$widget.find('input.bootstrap-timepicker-meridian').val(this.meridian);
                    }
                } else {
                    this.$widget.find('span.bootstrap-timepicker-hour').text(hour);
                    this.$widget.find('span.bootstrap-timepicker-minute').text(minute);

                    if (this.showSeconds) {
                        this.$widget.find('span.bootstrap-timepicker-second').text(second);
                    }
                    if (this.showMeridian) {
                        this.$widget.find('span.bootstrap-timepicker-meridian').text(this.meridian);
                    }
                }
            },

            updateFromWidgetInputs: function updateFromWidgetInputs() {
                if (this.$widget === false) {
                    return;
                }

                var t = this.$widget.find('input.bootstrap-timepicker-hour').val() + ':' + this.$widget.find('input.bootstrap-timepicker-minute').val() + (this.showSeconds ? ':' + this.$widget.find('input.bootstrap-timepicker-second').val() : '') + (this.showMeridian ? this.$widget.find('input.bootstrap-timepicker-meridian').val() : '');

                this.setTime(t, true);
            },

            widgetClick: function widgetClick(e) {
                e.stopPropagation();
                e.preventDefault();

                var $input = $(e.target),
                    action = $input.closest('a').data('action');

                if (action) {
                    this[action]();
                }
                this.update();

                if ($input.is('input')) {
                    $input.get(0).setSelectionRange(0, 2);
                }
            },

            widgetKeydown: function widgetKeydown(e) {
                var $input = $(e.target),
                    name = $input.attr('class').replace('bootstrap-timepicker-', '');

                switch (e.which) {
                    case 9:
                        //tab
                        if (e.shiftKey) {
                            if (name === 'hour') {
                                return this.hideWidget();
                            }
                        } else if (this.showMeridian && name === 'meridian' || this.showSeconds && name === 'second' || !this.showMeridian && !this.showSeconds && name === 'minute') {
                            return this.hideWidget();
                        }
                        break;
                    case 27:
                        // escape
                        this.hideWidget();
                        break;
                    case 38:
                        // up arrow
                        e.preventDefault();
                        switch (name) {
                            case 'hour':
                                this.incrementHour();
                                break;
                            case 'minute':
                                this.incrementMinute();
                                break;
                            case 'second':
                                this.incrementSecond();
                                break;
                            case 'meridian':
                                this.toggleMeridian();
                                break;
                        }
                        this.setTime(this.getTime());
                        $input.get(0).setSelectionRange(0, 2);
                        break;
                    case 40:
                        // down arrow
                        e.preventDefault();
                        switch (name) {
                            case 'hour':
                                this.decrementHour();
                                break;
                            case 'minute':
                                this.decrementMinute();
                                break;
                            case 'second':
                                this.decrementSecond();
                                break;
                            case 'meridian':
                                this.toggleMeridian();
                                break;
                        }
                        this.setTime(this.getTime());
                        $input.get(0).setSelectionRange(0, 2);
                        break;
                }
            },

            widgetKeyup: function widgetKeyup(e) {
                if (e.which === 65 || e.which === 77 || e.which === 80 || e.which === 46 || e.which === 8 || e.which >= 48 && e.which <= 57 || e.which >= 96 && e.which <= 105) {
                    this.updateFromWidgetInputs();
                }
            }
        };

        //TIMEPICKER PLUGIN DEFINITION
        $.fn.timepicker = function (option) {
            var args = Array.apply(null, arguments);
            args.shift();
            return this.each(function () {
                var $this = $(this),
                    data = $this.data('timepicker'),
                    options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object' && option;

                if (!data) {
                    $this.data('timepicker', data = new Timepicker(this, $.extend({}, $.fn.timepicker.defaults, options, $(this).data())));
                }

                if (typeof option === 'string') {
                    data[option].apply(data, args);
                }
            });
        };

        $.fn.timepicker.defaults = {
            defaultTime: 'current',
            disableFocus: false,
            disableMousewheel: false,
            isOpen: false,
            minuteStep: 15,
            modalBackdrop: false,
            orientation: { x: 'auto', y: 'auto' },
            secondStep: 15,
            snapToStep: false,
            showSeconds: false,
            showInputs: true,
            showMeridian: true,
            template: 'dropdown',
            appendWidgetTo: 'body',
            showWidgetOnAddonClick: true,
            icons: {
                up: 'glyphicon glyphicon-chevron-up',
                down: 'glyphicon glyphicon-chevron-down'
            },
            maxHours: 24,
            explicitMode: false
        };

        $.fn.timepicker.Constructor = Timepicker;

        $(document).on('focus.timepicker.data-api click.timepicker.data-api', '[data-provide="timepicker"]', function (e) {
            var $this = $(this);
            if ($this.data('timepicker')) {
                return;
            }
            e.preventDefault();
            // component click requires us to explicitly show it
            $this.timepicker();
        });
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
})(__webpack_require__(217));

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"timeInput",staticClass:"input-text input-time",attrs:{"type":"text","name":_vm.name},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateDate()},"change":function($event){return _vm.$emit('change')},"blur":function($event){return _vm.$emit('blur')},"focus":function($event){return _vm.$emit('focus')}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseCounter_vue__ = __webpack_require__(330);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52bdf604_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseCounter_vue__ = __webpack_require__(980);
function injectStyle (ssrContext) {
  __webpack_require__(978)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52bdf604"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseCounter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52bdf604_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseCounter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(979);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("299eb150", content, true, {});

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('canvas',{staticStyle:{"width":"100%"},attrs:{"name":_vm.name}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PdfViewer_vue__ = __webpack_require__(331);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eb164c6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PdfViewer_vue__ = __webpack_require__(984);
function injectStyle (ssrContext) {
  __webpack_require__(982)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PdfViewer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eb164c6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PdfViewer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(983);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2c5925bf", content, true, {});

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".pdf-content .toolbar{margin:0 auto;display:flex}.pdf-next .svg-icon,.pdf-prev .svg-icon{width:25px}.player.full-screen{background:#fff}.player.full-screen .pdf-content{margin:0 auto;height:100%!important}", ""]);

// exports


/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{class:['player', {'full-screen': _vm.inFullMode}],attrs:{"name":"ppPdfView"}},[_c('div',{staticClass:"pdf-content",staticStyle:{"visibility":"hidden"},attrs:{"id":"PlayerContent"}},[_c('canvas',{attrs:{"id":"pdfCanvas"}}),_vm._v(" "),_c('div',{staticClass:"toolbar",staticStyle:{"align-items":"center"}},[_c('button',{staticClass:"pdf-prev",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.goToPage(_vm.currentPage - 1)}}},[_c('svg',{staticClass:"svg-icon svg-big",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Next"}})])]),_vm._v(" "),_c('button',{staticClass:"pdf-next",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.goToPage(_vm.currentPage + 1)}}},[_c('svg',{staticClass:"svg-icon svg-big",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Next"}})])]),_vm._v(" "),_c('div',{staticClass:"progress-info"},[_c('div',{staticClass:"progress-bar"},[_c('div',{style:({width: (_vm.progress*100).toFixed(2) + '%'})})])]),_vm._v(" "),_c('span',{staticClass:"pdf-number"},[_vm._v(_vm._s(_vm.currentPage)+" / "+_vm._s(_vm.numPages))]),_vm._v(" "),_c('a',{staticClass:"pdf-next",staticStyle:{"display":"flex","align-items":"center"},attrs:{"href":_vm.src,"target":"_blank"}},[_c('svg',{staticClass:"svg-icon svg-big",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#FillScr"}})])]),_vm._v(" "),(!_vm.isMobile)?_c('button',{staticClass:"pdf-next",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleFullScreen.apply(null, arguments)}}}):_vm._e()])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoViewer_vue__ = __webpack_require__(332);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_886c85fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoViewer_vue__ = __webpack_require__(990);
function injectStyle (ssrContext) {
  __webpack_require__(986)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoViewer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_886c85fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoViewer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(987);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("9f43cbda", content, true, {});

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".pagefade-enter-active,.pagefade-leave-active{transition:opacity .2s}.pagefade-enter,.pagefade-leave-to{opacity:0}.pagefade{background:#fff;height:100%;width:100%;position:absolute;opacity:.5}.plyr__video-embed iframe{top:-50%;height:200%}", ""]);

// exports


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, jQuery) {"object"==typeof navigator&&function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("Plyr",t):(e=e||self).Plyr=t()}(this,function(){"use strict";function e(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function t(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}function n(e,n,i){return n&&t(e.prototype,n),i&&t(e,i),e}function i(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function a(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){var n=[],i=!0,a=!1,s=void 0;try{for(var r,o=e[Symbol.iterator]();!(i=(r=o.next()).done)&&(n.push(r.value),!t||n.length!==t);i=!0);}catch(e){a=!0,s=e}finally{try{i||null==o.return||o.return()}finally{if(a)throw s}}return n}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function s(e){return function(e){if(Array.isArray(e)){for(var t=0,n=new Array(e.length);t<e.length;t++)n[t]=e[t];return n}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var r={addCSS:!0,thumbWidth:15,watch:!0};var o=function(e){return null!=e?e.constructor:null},l=function(e,t){return Boolean(e&&t&&e instanceof t)},c=function(e){return null==e},u=function(e){return o(e)===Object},d=function(e){return o(e)===String},h=function(e){return Array.isArray(e)},m=function(e){return l(e,NodeList)},p={nullOrUndefined:c,object:u,number:function(e){return o(e)===Number&&!Number.isNaN(e)},string:d,boolean:function(e){return o(e)===Boolean},function:function(e){return o(e)===Function},array:h,nodeList:m,element:function(e){return l(e,Element)},event:function(e){return l(e,Event)},empty:function(e){return c(e)||(d(e)||h(e)||m(e))&&!e.length||u(e)&&!Object.keys(e).length}};function f(e,t){if(t<1){var n=(i="".concat(t).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/))?Math.max(0,(i[1]?i[1].length:0)-(i[2]?+i[2]:0)):0;return parseFloat(e.toFixed(n))}var i;return Math.round(e/t)*t}var g,y,v,b=function(){function t(n,i){e(this,t),p.element(n)?this.element=n:p.string(n)&&(this.element=document.querySelector(n)),p.element(this.element)&&p.empty(this.element.rangeTouch)&&(this.config=Object.assign({},r,i),this.init())}return n(t,[{key:"init",value:function(){t.enabled&&(this.config.addCSS&&(this.element.style.userSelect="none",this.element.style.webKitUserSelect="none",this.element.style.touchAction="manipulation"),this.listeners(!0),this.element.rangeTouch=this)}},{key:"destroy",value:function(){t.enabled&&(this.listeners(!1),this.element.rangeTouch=null)}},{key:"listeners",value:function(e){var t=this,n=e?"addEventListener":"removeEventListener";["touchstart","touchmove","touchend"].forEach(function(e){t.element[n](e,function(e){return t.set(e)},!1)})}},{key:"get",value:function(e){if(!t.enabled||!p.event(e))return null;var n,i=e.target,a=e.changedTouches[0],s=parseFloat(i.getAttribute("min"))||0,r=parseFloat(i.getAttribute("max"))||100,o=parseFloat(i.getAttribute("step"))||1,l=r-s,c=i.getBoundingClientRect(),u=100/c.width*(this.config.thumbWidth/2)/100;return(n=100/c.width*(a.clientX-c.left))<0?n=0:n>100&&(n=100),n<50?n-=(100-2*n)*u:n>50&&(n+=2*(n-50)*u),s+f(l*(n/100),o)}},{key:"set",value:function(e){t.enabled&&p.event(e)&&!e.target.disabled&&(e.preventDefault(),e.target.value=this.get(e),function(e,t){if(e&&t){var n=new Event(t);e.dispatchEvent(n)}}(e.target,"touchend"===e.type?"change":"input"))}}],[{key:"setup",value:function(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=null;if(p.empty(e)||p.string(e)?i=Array.from(document.querySelectorAll(p.string(e)?e:'input[type="range"]')):p.element(e)?i=[e]:p.nodeList(e)?i=Array.from(e):p.array(e)&&(i=e.filter(p.element)),p.empty(i))return null;var a=Object.assign({},r,n);p.string(e)&&a.watch&&new MutationObserver(function(n){Array.from(n).forEach(function(n){Array.from(n.addedNodes).forEach(function(n){if(p.element(n)&&function(){return Array.from(document.querySelectorAll(i)).includes(this)}.call(n,i=e)){var i;new t(n,a)}})})}).observe(document.body,{childList:!0,subtree:!0});return i.map(function(e){return new t(e,n)})}},{key:"enabled",get:function(){return"ontouchstart"in document.documentElement}}]),t}(),k=function(e){return null!=e?e.constructor:null},w=function(e,t){return Boolean(e&&t&&e instanceof t)},T=function(e){return null==e},C=function(e){return k(e)===Object},A=function(e){return k(e)===String},E=function(e){return Array.isArray(e)},S=function(e){return w(e,NodeList)},P=function(e){return T(e)||(A(e)||E(e)||S(e))&&!e.length||C(e)&&!Object.keys(e).length},N={nullOrUndefined:T,object:C,number:function(e){return k(e)===Number&&!Number.isNaN(e)},string:A,boolean:function(e){return k(e)===Boolean},function:function(e){return k(e)===Function},array:E,weakMap:function(e){return w(e,WeakMap)},nodeList:S,element:function(e){return w(e,Element)},textNode:function(e){return k(e)===Text},event:function(e){return w(e,Event)},keyboardEvent:function(e){return w(e,KeyboardEvent)},cue:function(e){return w(e,window.TextTrackCue)||w(e,window.VTTCue)},track:function(e){return w(e,TextTrack)||!T(e)&&A(e.kind)},promise:function(e){return w(e,Promise)},url:function(e){if(w(e,window.URL))return!0;if(!A(e))return!1;var t=e;e.startsWith("http://")&&e.startsWith("https://")||(t="http://".concat(e));try{return!P(new URL(t).hostname)}catch(e){return!1}},empty:P},M=(g=document.createElement("span"),y={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"},v=Object.keys(y).find(function(e){return void 0!==g.style[e]}),!!N.string(v)&&y[v]);function x(e,t){setTimeout(function(){try{e.hidden=!0,e.offsetHeight,e.hidden=!1}catch(e){}},t)}var L={isIE:!!document.documentMode,isEdge:window.navigator.userAgent.includes("Edge"),isWebkit:"WebkitAppearance"in document.documentElement.style&&!/Edge/.test(navigator.userAgent),isIPhone:/(iPhone|iPod)/gi.test(navigator.platform),isIos:/(iPad|iPhone|iPod)/gi.test(navigator.platform)},I=function(){var e=!1;try{var t=Object.defineProperty({},"passive",{get:function(){return e=!0,null}});window.addEventListener("test",null,t),window.removeEventListener("test",null,t)}catch(e){}return e}();function _(e,t,n){var i=this,a=arguments.length>3&&void 0!==arguments[3]&&arguments[3],s=!(arguments.length>4&&void 0!==arguments[4])||arguments[4],r=arguments.length>5&&void 0!==arguments[5]&&arguments[5];if(e&&"addEventListener"in e&&!N.empty(t)&&N.function(n)){var o=t.split(" "),l=r;I&&(l={passive:s,capture:r}),o.forEach(function(t){i&&i.eventListeners&&a&&i.eventListeners.push({element:e,type:t,callback:n,options:l}),e[a?"addEventListener":"removeEventListener"](t,n,l)})}}function O(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",n=arguments.length>2?arguments[2]:void 0,i=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],a=arguments.length>4&&void 0!==arguments[4]&&arguments[4];_.call(this,e,t,n,!0,i,a)}function j(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",n=arguments.length>2?arguments[2]:void 0,i=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],a=arguments.length>4&&void 0!==arguments[4]&&arguments[4];_.call(this,e,t,n,!1,i,a)}function q(e){var t=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",i=arguments.length>2?arguments[2]:void 0,a=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],s=arguments.length>4&&void 0!==arguments[4]&&arguments[4];_.call(this,e,n,function r(){j(e,n,r,a,s);for(var o=arguments.length,l=new Array(o),c=0;c<o;c++)l[c]=arguments[c];i.apply(t,l)},!0,a,s)}function H(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{};if(N.element(e)&&!N.empty(t)){var a=new CustomEvent(t,{bubbles:n,detail:Object.assign({},i,{plyr:this})});e.dispatchEvent(a)}}function D(e,t){return t.split(".").reduce(function(e,t){return e&&e[t]},e)}function F(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length,n=new Array(t>1?t-1:0),a=1;a<t;a++)n[a-1]=arguments[a];if(!n.length)return e;var s=n.shift();return N.object(s)?(Object.keys(s).forEach(function(t){N.object(s[t])?(Object.keys(e).includes(t)||Object.assign(e,i({},t,{})),F(e[t],s[t])):Object.assign(e,i({},t,s[t]))}),F.apply(void 0,[e].concat(n))):e}function R(e,t){var n=e.length?e:[e];Array.from(n).reverse().forEach(function(e,n){var i=n>0?t.cloneNode(!0):t,a=e.parentNode,s=e.nextSibling;i.appendChild(e),s?a.insertBefore(i,s):a.appendChild(i)})}function V(e,t){N.element(e)&&!N.empty(t)&&Object.entries(t).filter(function(e){var t=a(e,2)[1];return!N.nullOrUndefined(t)}).forEach(function(t){var n=a(t,2),i=n[0],s=n[1];return e.setAttribute(i,s)})}function B(e,t,n){var i=document.createElement(e);return N.object(t)&&V(i,t),N.string(n)&&(i.innerText=n),i}function U(e,t,n,i){N.element(t)&&t.appendChild(B(e,n,i))}function W(e){N.nodeList(e)||N.array(e)?Array.from(e).forEach(W):N.element(e)&&N.element(e.parentNode)&&e.parentNode.removeChild(e)}function z(e){if(N.element(e))for(var t=e.childNodes.length;t>0;)e.removeChild(e.lastChild),t-=1}function K(e,t){return N.element(t)&&N.element(t.parentNode)&&N.element(e)?(t.parentNode.replaceChild(e,t),e):null}function Y(e,t){if(!N.string(e)||N.empty(e))return{};var n={},i=F({},t);return e.split(",").forEach(function(e){var t=e.trim(),s=t.replace(".",""),r=t.replace(/[[\]]/g,"").split("="),o=a(r,1)[0],l=r.length>1?r[1].replace(/["']/g,""):"";switch(t.charAt(0)){case".":N.string(i.class)?n.class="".concat(i.class," ").concat(s):n.class=s;break;case"#":n.id=t.replace("#","");break;case"[":n[o]=l}}),F(i,n)}function Q(e,t){if(N.element(e)){var n=t;N.boolean(n)||(n=!e.hidden),e.hidden=n}}function X(e,t,n){if(N.nodeList(e))return Array.from(e).map(function(e){return X(e,t,n)});if(N.element(e)){var i="toggle";return void 0!==n&&(i=n?"add":"remove"),e.classList[i](t),e.classList.contains(t)}return!1}function J(e,t){return N.element(e)&&e.classList.contains(t)}function $(e,t){return function(){return Array.from(document.querySelectorAll(t)).includes(this)}.call(e,t)}function G(e){return this.elements.container.querySelectorAll(e)}function Z(e){return this.elements.container.querySelector(e)}function ee(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];N.element(e)&&(e.focus({preventScroll:!0}),t&&X(e,this.config.classNames.tabFocus))}var te,ne={"audio/ogg":"vorbis","audio/wav":"1","video/webm":"vp8, vorbis","video/mp4":"avc1.42E01E, mp4a.40.2","video/ogg":"theora"},ie={audio:"canPlayType"in document.createElement("audio"),video:"canPlayType"in document.createElement("video"),check:function(e,t,n){var i=L.isIPhone&&n&&ie.playsinline,a=ie[e]||"html5"!==t;return{api:a,ui:a&&ie.rangeInput&&("video"!==e||!L.isIPhone||i)}},pip:!(L.isIPhone||!N.function(B("video").webkitSetPresentationMode)&&(!document.pictureInPictureEnabled||B("video").disablePictureInPicture)),airplay:N.function(window.WebKitPlaybackTargetAvailabilityEvent),playsinline:"playsInline"in document.createElement("video"),mime:function(e){if(N.empty(e))return!1;var t=a(e.split("/"),1)[0],n=e;if(!this.isHTML5||t!==this.type)return!1;Object.keys(ne).includes(n)&&(n+='; codecs="'.concat(ne[e],'"'));try{return Boolean(n&&this.media.canPlayType(n).replace(/no/,""))}catch(e){return!1}},textTracks:"textTracks"in document.createElement("video"),rangeInput:(te=document.createElement("input"),te.type="range","range"===te.type),touch:"ontouchstart"in document.documentElement,transitions:!1!==M,reducedMotion:"matchMedia"in window&&window.matchMedia("(prefers-reduced-motion)").matches};function ae(e){return!!(N.array(e)||N.string(e)&&e.includes(":"))&&(N.array(e)?e:e.split(":")).map(Number).every(N.number)}function se(e){if(!N.array(e)||!e.every(N.number))return null;var t=a(e,2),n=t[0],i=t[1],s=function e(t,n){return 0===n?t:e(n,t%n)}(n,i);return[n/s,i/s]}function re(e){var t=function(e){return ae(e)?e.split(":").map(Number):null},n=t(e);if(null===n&&(n=t(this.config.ratio)),null===n&&!N.empty(this.embed)&&N.array(this.embed.ratio)&&(n=this.embed.ratio),null===n&&this.isHTML5){var i=this.media;n=se([i.videoWidth,i.videoHeight])}return n}function oe(e){if(!this.isVideo)return{};var t=re.call(this,e),n=a(N.array(t)?t:[0,0],2),i=100/n[0]*n[1];if(this.elements.wrapper.style.paddingBottom="".concat(i,"%"),this.isVimeo&&this.supported.ui){var s=(240-i)/4.8;this.media.style.transform="translateY(-".concat(s,"%)")}else this.isHTML5&&this.elements.wrapper.classList.toggle(this.config.classNames.videoFixedRatio,null!==t);return{padding:i,ratio:t}}var le={getSources:function(){var e=this;return this.isHTML5?Array.from(this.media.querySelectorAll("source")).filter(function(t){var n=t.getAttribute("type");return!!N.empty(n)||ie.mime.call(e,n)}):[]},getQualityOptions:function(){return le.getSources.call(this).map(function(e){return Number(e.getAttribute("size"))}).filter(Boolean)},extend:function(){if(this.isHTML5){var e=this;N.empty(this.config.ratio)||oe.call(e),Object.defineProperty(e.media,"quality",{get:function(){var t=le.getSources.call(e).find(function(t){return t.getAttribute("src")===e.source});return t&&Number(t.getAttribute("size"))},set:function(t){var n=le.getSources.call(e).find(function(e){return Number(e.getAttribute("size"))===t});if(n){var i=e.media,a=i.currentTime,s=i.paused,r=i.preload,o=i.readyState;e.media.src=n.getAttribute("src"),("none"!==r||o)&&(e.once("loadedmetadata",function(){e.currentTime=a,s||e.play()}),e.media.load()),H.call(e,e.media,"qualitychange",!1,{quality:t})}}})}},cancelRequests:function(){this.isHTML5&&(W(le.getSources.call(this)),this.media.setAttribute("src",this.config.blankVideo),this.media.load(),this.debug.log("Cancelled network requests"))}};function ce(e){return N.array(e)?e.filter(function(t,n){return e.indexOf(t)===n}):e}function ue(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),i=1;i<t;i++)n[i-1]=arguments[i];return N.empty(e)?e:e.toString().replace(/{(\d+)}/g,function(e,t){return n[t].toString()})}function de(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"";return e.replace(new RegExp(t.toString().replace(/([.*+?^=!:${}()|[\]\/\\])/g,"\\$1"),"g"),n.toString())}function he(){return(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"").toString().replace(/\w\S*/g,function(e){return e.charAt(0).toUpperCase()+e.substr(1).toLowerCase()})}function me(){var e=(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"").toString();return(e=function(){var e=(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"").toString();return e=de(e,"-"," "),e=de(e,"_"," "),de(e=he(e)," ","")}(e)).charAt(0).toLowerCase()+e.slice(1)}function pe(e){var t=document.createElement("div");return t.appendChild(e),t.innerHTML}var fe={pip:"PIP",airplay:"AirPlay",html5:"HTML5",vimeo:"Vimeo",youtube:"YouTube"},ge=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(N.empty(e)||N.empty(t))return"";var n=D(t.i18n,e);if(N.empty(n))return Object.keys(fe).includes(e)?fe[e]:"";var i={"{seektime}":t.seekTime,"{title}":t.title};return Object.entries(i).forEach(function(e){var t=a(e,2),i=t[0],s=t[1];n=de(n,i,s)}),n},ye=function(){function t(n){e(this,t),this.enabled=n.config.storage.enabled,this.key=n.config.storage.key}return n(t,[{key:"get",value:function(e){if(!t.supported||!this.enabled)return null;var n=window.localStorage.getItem(this.key);if(N.empty(n))return null;var i=JSON.parse(n);return N.string(e)&&e.length?i[e]:i}},{key:"set",value:function(e){if(t.supported&&this.enabled&&N.object(e)){var n=this.get();N.empty(n)&&(n={}),F(n,e),window.localStorage.setItem(this.key,JSON.stringify(n))}}}],[{key:"supported",get:function(){try{if(!("localStorage"in window))return!1;return window.localStorage.setItem("___test","___test"),window.localStorage.removeItem("___test"),!0}catch(e){return!1}}}]),t}();function ve(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"text";return new Promise(function(n,i){try{var a=new XMLHttpRequest;if(!("withCredentials"in a))return;a.addEventListener("load",function(){if("text"===t)try{n(JSON.parse(a.responseText))}catch(e){n(a.responseText)}else n(a.response)}),a.addEventListener("error",function(){throw new Error(a.status)}),a.open("GET",e,!0),a.responseType=t,a.send()}catch(e){i(e)}})}function be(e,t){if(N.string(e)){var n=N.string(t),i=function(){return null!==document.getElementById(t)},a=function(e,t){e.innerHTML=t,n&&i()||document.body.insertAdjacentElement("afterbegin",e)};if(!n||!i()){var s=ye.supported,r=document.createElement("div");if(r.setAttribute("hidden",""),n&&r.setAttribute("id",t),s){var o=window.localStorage.getItem("".concat("cache","-").concat(t));if(null!==o){var l=JSON.parse(o);a(r,l.content)}}ve(e).then(function(e){N.empty(e)||(s&&window.localStorage.setItem("".concat("cache","-").concat(t),JSON.stringify({content:e})),a(r,e))}).catch(function(){})}}}var ke=function(e){return Math.trunc(e/60/60%60,10)},we=function(e){return Math.trunc(e/60%60,10)},Te=function(e){return Math.trunc(e%60,10)};function Ce(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if(!N.number(e))return Ce(null,t,n);var i=function(e){return"0".concat(e).slice(-2)},a=ke(e),s=we(e),r=Te(e);return a=t||a>0?"".concat(a,":"):"","".concat(n&&e>0?"-":"").concat(a).concat(i(s),":").concat(i(r))}var Ae={getIconUrl:function(){var e=new URL(this.config.iconUrl,window.location).host!==window.location.host||L.isIE&&!window.svg4everybody;return{url:this.config.iconUrl,cors:e}},findElements:function(){try{return this.elements.controls=Z.call(this,this.config.selectors.controls.wrapper),this.elements.buttons={play:G.call(this,this.config.selectors.buttons.play),pause:Z.call(this,this.config.selectors.buttons.pause),restart:Z.call(this,this.config.selectors.buttons.restart),rewind:Z.call(this,this.config.selectors.buttons.rewind),fastForward:Z.call(this,this.config.selectors.buttons.fastForward),mute:Z.call(this,this.config.selectors.buttons.mute),pip:Z.call(this,this.config.selectors.buttons.pip),airplay:Z.call(this,this.config.selectors.buttons.airplay),settings:Z.call(this,this.config.selectors.buttons.settings),captions:Z.call(this,this.config.selectors.buttons.captions),fullscreen:Z.call(this,this.config.selectors.buttons.fullscreen)},this.elements.progress=Z.call(this,this.config.selectors.progress),this.elements.inputs={seek:Z.call(this,this.config.selectors.inputs.seek),volume:Z.call(this,this.config.selectors.inputs.volume)},this.elements.display={buffer:Z.call(this,this.config.selectors.display.buffer),currentTime:Z.call(this,this.config.selectors.display.currentTime),duration:Z.call(this,this.config.selectors.display.duration)},N.element(this.elements.progress)&&(this.elements.display.seekTooltip=this.elements.progress.querySelector(".".concat(this.config.classNames.tooltip))),!0}catch(e){return this.debug.warn("It looks like there is a problem with your custom controls HTML",e),this.toggleNativeControls(!0),!1}},createIcon:function(e,t){var n=Ae.getIconUrl.call(this),i="".concat(n.cors?"":n.url,"#").concat(this.config.iconPrefix),a=document.createElementNS("http://www.w3.org/2000/svg","svg");V(a,F(t,{role:"presentation",focusable:"false"}));var s=document.createElementNS("http://www.w3.org/2000/svg","use"),r="".concat(i,"-").concat(e);return"href"in s&&s.setAttributeNS("http://www.w3.org/1999/xlink","href",r),s.setAttributeNS("http://www.w3.org/1999/xlink","xlink:href",r),a.appendChild(s),a},createLabel:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=ge(e,this.config);return B("span",Object.assign({},t,{class:[t.class,this.config.classNames.hidden].filter(Boolean).join(" ")}),n)},createBadge:function(e){if(N.empty(e))return null;var t=B("span",{class:this.config.classNames.menu.value});return t.appendChild(B("span",{class:this.config.classNames.menu.badge},e)),t},createButton:function(e,t){var n=this,i=F({},t),a=me(e),s={element:"button",toggle:!1,label:null,icon:null,labelPressed:null,iconPressed:null};switch(["element","icon","label"].forEach(function(e){Object.keys(i).includes(e)&&(s[e]=i[e],delete i[e])}),"button"!==s.element||Object.keys(i).includes("type")||(i.type="button"),Object.keys(i).includes("class")?i.class.split(" ").some(function(e){return e===n.config.classNames.control})||F(i,{class:"".concat(i.class," ").concat(this.config.classNames.control)}):i.class=this.config.classNames.control,e){case"play":s.toggle=!0,s.label="play",s.labelPressed="pause",s.icon="play",s.iconPressed="pause";break;case"mute":s.toggle=!0,s.label="mute",s.labelPressed="unmute",s.icon="volume",s.iconPressed="muted";break;case"captions":s.toggle=!0,s.label="enableCaptions",s.labelPressed="disableCaptions",s.icon="captions-off",s.iconPressed="captions-on";break;case"fullscreen":s.toggle=!0,s.label="enterFullscreen",s.labelPressed="exitFullscreen",s.icon="enter-fullscreen",s.iconPressed="exit-fullscreen";break;case"play-large":i.class+=" ".concat(this.config.classNames.control,"--overlaid"),a="play",s.label="play",s.icon="play";break;default:N.empty(s.label)&&(s.label=a),N.empty(s.icon)&&(s.icon=e)}var r=B(s.element);return s.toggle?(r.appendChild(Ae.createIcon.call(this,s.iconPressed,{class:"icon--pressed"})),r.appendChild(Ae.createIcon.call(this,s.icon,{class:"icon--not-pressed"})),r.appendChild(Ae.createLabel.call(this,s.labelPressed,{class:"label--pressed"})),r.appendChild(Ae.createLabel.call(this,s.label,{class:"label--not-pressed"}))):(r.appendChild(Ae.createIcon.call(this,s.icon)),r.appendChild(Ae.createLabel.call(this,s.label))),F(i,Y(this.config.selectors.buttons[a],i)),V(r,i),"play"===a?(N.array(this.elements.buttons[a])||(this.elements.buttons[a]=[]),this.elements.buttons[a].push(r)):this.elements.buttons[a]=r,r},createRange:function(e,t){var n=B("input",F(Y(this.config.selectors.inputs[e]),{type:"range",min:0,max:100,step:.01,value:0,autocomplete:"off",role:"slider","aria-label":ge(e,this.config),"aria-valuemin":0,"aria-valuemax":100,"aria-valuenow":0},t));return this.elements.inputs[e]=n,Ae.updateRangeFill.call(this,n),b.setup(n),n},createProgress:function(e,t){var n=B("progress",F(Y(this.config.selectors.display[e]),{min:0,max:100,value:0,role:"progressbar","aria-hidden":!0},t));if("volume"!==e){n.appendChild(B("span",null,"0"));var i={played:"played",buffer:"buffered"}[e],a=i?ge(i,this.config):"";n.innerText="% ".concat(a.toLowerCase())}return this.elements.display[e]=n,n},createTime:function(e,t){var n=Y(this.config.selectors.display[e],t),i=B("div",F(n,{class:"".concat(n.class?n.class:""," ").concat(this.config.classNames.display.time," ").trim(),"aria-label":ge(e,this.config)}),"00:00");return this.elements.display[e]=i,i},bindMenuItemShortcuts:function(e,t){var n=this;O(e,"keydown keyup",function(i){if([32,38,39,40].includes(i.which)&&(i.preventDefault(),i.stopPropagation(),"keydown"!==i.type)){var a,s=$(e,'[role="menuitemradio"]');if(!s&&[32,39].includes(i.which))Ae.showMenuPanel.call(n,t,!0);else 32!==i.which&&(40===i.which||s&&39===i.which?(a=e.nextElementSibling,N.element(a)||(a=e.parentNode.firstElementChild)):(a=e.previousElementSibling,N.element(a)||(a=e.parentNode.lastElementChild)),ee.call(n,a,!0))}},!1),O(e,"keyup",function(e){13===e.which&&Ae.focusFirstMenuItem.call(n,null,!0)})},createMenuItem:function(e){var t=this,n=e.value,i=e.list,a=e.type,s=e.title,r=e.badge,o=void 0===r?null:r,l=e.checked,c=void 0!==l&&l,u=Y(this.config.selectors.inputs[a]),d=B("button",F(u,{type:"button",role:"menuitemradio",class:"".concat(this.config.classNames.control," ").concat(u.class?u.class:"").trim(),"aria-checked":c,value:n})),h=B("span");h.innerHTML=s,N.element(o)&&h.appendChild(o),d.appendChild(h),Object.defineProperty(d,"checked",{enumerable:!0,get:function(){return"true"===d.getAttribute("aria-checked")},set:function(e){e&&Array.from(d.parentNode.children).filter(function(e){return $(e,'[role="menuitemradio"]')}).forEach(function(e){return e.setAttribute("aria-checked","false")}),d.setAttribute("aria-checked",e?"true":"false")}}),this.listeners.bind(d,"click keyup",function(e){if(!N.keyboardEvent(e)||32===e.which){switch(e.preventDefault(),e.stopPropagation(),d.checked=!0,a){case"language":t.currentTrack=Number(n);break;case"quality":t.quality=n;break;case"speed":t.speed=parseFloat(n)}Ae.showMenuPanel.call(t,"home",N.keyboardEvent(e))}},a,!1),Ae.bindMenuItemShortcuts.call(this,d,a),i.appendChild(d)},formatTime:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];return N.number(e)?Ce(e,ke(this.duration)>0,t):e},updateTimeDisplay:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];N.element(e)&&N.number(t)&&(e.innerText=Ae.formatTime(t,n))},updateVolume:function(){this.supported.ui&&(N.element(this.elements.inputs.volume)&&Ae.setRange.call(this,this.elements.inputs.volume,this.muted?0:this.volume),N.element(this.elements.buttons.mute)&&(this.elements.buttons.mute.pressed=this.muted||0===this.volume))},setRange:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;N.element(e)&&(e.value=t,Ae.updateRangeFill.call(this,e))},updateProgress:function(e){var t=this;if(this.supported.ui&&N.event(e)){var n,i,a=0;if(e)switch(e.type){case"timeupdate":case"seeking":case"seeked":n=this.currentTime,i=this.duration,a=0===n||0===i||Number.isNaN(n)||Number.isNaN(i)?0:(n/i*100).toFixed(2),"timeupdate"===e.type&&Ae.setRange.call(this,this.elements.inputs.seek,a);break;case"playing":case"progress":!function(e,n){var i=N.number(n)?n:0,a=N.element(e)?e:t.elements.display.buffer;if(N.element(a)){a.value=i;var s=a.getElementsByTagName("span")[0];N.element(s)&&(s.childNodes[0].nodeValue=i)}}(this.elements.display.buffer,100*this.buffered)}}},updateRangeFill:function(e){var t=N.event(e)?e.target:e;if(N.element(t)&&"range"===t.getAttribute("type")){if($(t,this.config.selectors.inputs.seek)){t.setAttribute("aria-valuenow",this.currentTime);var n=Ae.formatTime(this.currentTime),i=Ae.formatTime(this.duration),a=ge("seekLabel",this.config);t.setAttribute("aria-valuetext",a.replace("{currentTime}",n).replace("{duration}",i))}else if($(t,this.config.selectors.inputs.volume)){var s=100*t.value;t.setAttribute("aria-valuenow",s),t.setAttribute("aria-valuetext","".concat(s.toFixed(1),"%"))}else t.setAttribute("aria-valuenow",t.value);L.isWebkit&&t.style.setProperty("--value","".concat(t.value/t.max*100,"%"))}},updateSeekTooltip:function(e){var t=this;if(this.config.tooltips.seek&&N.element(this.elements.inputs.seek)&&N.element(this.elements.display.seekTooltip)&&0!==this.duration){var n="".concat(this.config.classNames.tooltip,"--visible"),i=function(e){return X(t.elements.display.seekTooltip,n,e)};if(this.touch)i(!1);else{var a=0,s=this.elements.progress.getBoundingClientRect();if(N.event(e))a=100/s.width*(e.pageX-s.left);else{if(!J(this.elements.display.seekTooltip,n))return;a=parseFloat(this.elements.display.seekTooltip.style.left,10)}a<0?a=0:a>100&&(a=100),Ae.updateTimeDisplay.call(this,this.elements.display.seekTooltip,this.duration/100*a),this.elements.display.seekTooltip.style.left="".concat(a,"%"),N.event(e)&&["mouseenter","mouseleave"].includes(e.type)&&i("mouseenter"===e.type)}}},timeUpdate:function(e){var t=!N.element(this.elements.display.duration)&&this.config.invertTime;Ae.updateTimeDisplay.call(this,this.elements.display.currentTime,t?this.duration-this.currentTime:this.currentTime,t),e&&"timeupdate"===e.type&&this.media.seeking||Ae.updateProgress.call(this,e)},durationUpdate:function(){if(this.supported.ui&&(this.config.invertTime||!this.currentTime)){if(this.duration>=Math.pow(2,32))return Q(this.elements.display.currentTime,!0),void Q(this.elements.progress,!0);N.element(this.elements.inputs.seek)&&this.elements.inputs.seek.setAttribute("aria-valuemax",this.duration);var e=N.element(this.elements.display.duration);!e&&this.config.displayDuration&&this.paused&&Ae.updateTimeDisplay.call(this,this.elements.display.currentTime,this.duration),e&&Ae.updateTimeDisplay.call(this,this.elements.display.duration,this.duration),Ae.updateSeekTooltip.call(this)}},toggleMenuButton:function(e,t){Q(this.elements.settings.buttons[e],!t)},updateSetting:function(e,t,n){var i=this.elements.settings.panels[e],a=null,s=t;if("captions"===e)a=this.currentTrack;else{if(a=N.empty(n)?this[e]:n,N.empty(a)&&(a=this.config[e].default),!N.empty(this.options[e])&&!this.options[e].includes(a))return void this.debug.warn("Unsupported value of '".concat(a,"' for ").concat(e));if(!this.config[e].options.includes(a))return void this.debug.warn("Disabled value of '".concat(a,"' for ").concat(e))}if(N.element(s)||(s=i&&i.querySelector('[role="menu"]')),N.element(s)){this.elements.settings.buttons[e].querySelector(".".concat(this.config.classNames.menu.value)).innerHTML=Ae.getLabel.call(this,e,a);var r=s&&s.querySelector('[value="'.concat(a,'"]'));N.element(r)&&(r.checked=!0)}},getLabel:function(e,t){switch(e){case"speed":return 1===t?ge("normal",this.config):"".concat(t,"&times;");case"quality":if(N.number(t)){var n=ge("qualityLabel.".concat(t),this.config);return n.length?n:"".concat(t,"p")}return he(t);case"captions":return Pe.getLabel.call(this);default:return null}},setQualityMenu:function(e){var t=this;if(N.element(this.elements.settings.panels.quality)){var n=this.elements.settings.panels.quality.querySelector('[role="menu"]');N.array(e)&&(this.options.quality=ce(e).filter(function(e){return t.config.quality.options.includes(e)}));var i=!N.empty(this.options.quality)&&this.options.quality.length>1;if(Ae.toggleMenuButton.call(this,"quality",i),z(n),Ae.checkMenu.call(this),i){var a=function(e){var n=ge("qualityBadge.".concat(e),t.config);return n.length?Ae.createBadge.call(t,n):null};this.options.quality.sort(function(e,n){var i=t.config.quality.options;return i.indexOf(e)>i.indexOf(n)?1:-1}).forEach(function(e){Ae.createMenuItem.call(t,{value:e,list:n,type:"quality",title:Ae.getLabel.call(t,"quality",e),badge:a(e)})}),Ae.updateSetting.call(this,"quality",n)}}},setCaptionsMenu:function(){var e=this;if(N.element(this.elements.settings.panels.captions)){var t=this.elements.settings.panels.captions.querySelector('[role="menu"]'),n=Pe.getTracks.call(this),i=Boolean(n.length);if(Ae.toggleMenuButton.call(this,"captions",i),z(t),Ae.checkMenu.call(this),i){var a=n.map(function(n,i){return{value:i,checked:e.captions.toggled&&e.currentTrack===i,title:Pe.getLabel.call(e,n),badge:n.language&&Ae.createBadge.call(e,n.language.toUpperCase()),list:t,type:"language"}});a.unshift({value:-1,checked:!this.captions.toggled,title:ge("disabled",this.config),list:t,type:"language"}),a.forEach(Ae.createMenuItem.bind(this)),Ae.updateSetting.call(this,"captions",t)}}},setSpeedMenu:function(e){var t=this;if(N.element(this.elements.settings.panels.speed)){var n=this.elements.settings.panels.speed.querySelector('[role="menu"]');N.array(e)?this.options.speed=e:(this.isHTML5||this.isVimeo)&&(this.options.speed=[.5,.75,1,1.25,1.5,1.75,2]),this.options.speed=this.options.speed.filter(function(e){return t.config.speed.options.includes(e)});var i=!N.empty(this.options.speed)&&this.options.speed.length>1;Ae.toggleMenuButton.call(this,"speed",i),z(n),Ae.checkMenu.call(this),i&&(this.options.speed.forEach(function(e){Ae.createMenuItem.call(t,{value:e,list:n,type:"speed",title:Ae.getLabel.call(t,"speed",e)})}),Ae.updateSetting.call(this,"speed",n))}},checkMenu:function(){var e=this.elements.settings.buttons,t=!N.empty(e)&&Object.values(e).some(function(e){return!e.hidden});Q(this.elements.settings.menu,!t)},focusFirstMenuItem:function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(!this.elements.settings.popup.hidden){var n=e;N.element(n)||(n=Object.values(this.elements.settings.panels).find(function(e){return!e.hidden}));var i=n.querySelector('[role^="menuitem"]');ee.call(this,i,t)}},toggleMenu:function(e){var t=this.elements.settings.popup,n=this.elements.buttons.settings;if(N.element(t)&&N.element(n)){var i=t.hidden,a=i;if(N.boolean(e))a=e;else if(N.keyboardEvent(e)&&27===e.which)a=!1;else if(N.event(e)){var s=N.function(e.composedPath)?e.composedPath()[0]:e.target,r=t.contains(s);if(r||!r&&e.target!==n&&a)return}n.setAttribute("aria-expanded",a),Q(t,!a),X(this.elements.container,this.config.classNames.menu.open,a),a&&N.keyboardEvent(e)?Ae.focusFirstMenuItem.call(this,null,!0):a||i||ee.call(this,n,N.keyboardEvent(e))}},getMenuSize:function(e){var t=e.cloneNode(!0);t.style.position="absolute",t.style.opacity=0,t.removeAttribute("hidden"),e.parentNode.appendChild(t);var n=t.scrollWidth,i=t.scrollHeight;return W(t),{width:n,height:i}},showMenuPanel:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",n=arguments.length>1&&void 0!==arguments[1]&&arguments[1],i=this.elements.container.querySelector("#plyr-settings-".concat(this.id,"-").concat(t));if(N.element(i)){var a=i.parentNode,s=Array.from(a.children).find(function(e){return!e.hidden});if(ie.transitions&&!ie.reducedMotion){a.style.width="".concat(s.scrollWidth,"px"),a.style.height="".concat(s.scrollHeight,"px");var r=Ae.getMenuSize.call(this,i);O.call(this,a,M,function t(n){n.target===a&&["width","height"].includes(n.propertyName)&&(a.style.width="",a.style.height="",j.call(e,a,M,t))}),a.style.width="".concat(r.width,"px"),a.style.height="".concat(r.height,"px")}Q(s,!0),Q(i,!1),Ae.focusFirstMenuItem.call(this,i,n)}},setDownloadUrl:function(){var e=this.elements.buttons.download;N.element(e)&&e.setAttribute("href",this.download)},create:function(e){var t=this,n=Ae.bindMenuItemShortcuts,i=Ae.createButton,a=Ae.createProgress,s=Ae.createRange,r=Ae.createTime,o=Ae.setQualityMenu,l=Ae.setSpeedMenu,c=Ae.showMenuPanel;this.elements.controls=null,this.config.controls.includes("play-large")&&this.elements.container.appendChild(i.call(this,"play-large"));var u=B("div",Y(this.config.selectors.controls.wrapper));this.elements.controls=u;var d={class:"plyr__controls__item"};return ce(this.config.controls).forEach(function(o){if("restart"===o&&u.appendChild(i.call(t,"restart",d)),"rewind"===o&&u.appendChild(i.call(t,"rewind",d)),"play"===o&&u.appendChild(i.call(t,"play",d)),"fast-forward"===o&&u.appendChild(i.call(t,"fast-forward",d)),"progress"===o){var l=B("div",{class:"".concat(d.class," plyr__progress__container")}),h=B("div",Y(t.config.selectors.progress));if(h.appendChild(s.call(t,"seek",{id:"plyr-seek-".concat(e.id)})),h.appendChild(a.call(t,"buffer")),t.config.tooltips.seek){var m=B("span",{class:t.config.classNames.tooltip},"00:00");h.appendChild(m),t.elements.display.seekTooltip=m}t.elements.progress=h,l.appendChild(t.elements.progress),u.appendChild(l)}if("current-time"===o&&u.appendChild(r.call(t,"currentTime",d)),"duration"===o&&u.appendChild(r.call(t,"duration",d)),"mute"===o||"volume"===o){var p=t.elements.volume;if(N.element(p)&&u.contains(p)||(p=B("div",F({},d,{class:"".concat(d.class," plyr__volume").trim()})),t.elements.volume=p,u.appendChild(p)),"mute"===o&&p.appendChild(i.call(t,"mute")),"volume"===o){var f={max:1,step:.05,value:t.config.volume};p.appendChild(s.call(t,"volume",F(f,{id:"plyr-volume-".concat(e.id)})))}}if("captions"===o&&u.appendChild(i.call(t,"captions",d)),"settings"===o&&!N.empty(t.config.settings)){var g=B("div",F({},d,{class:"".concat(d.class," plyr__menu").trim(),hidden:""}));g.appendChild(i.call(t,"settings",{"aria-haspopup":!0,"aria-controls":"plyr-settings-".concat(e.id),"aria-expanded":!1}));var y=B("div",{class:"plyr__menu__container",id:"plyr-settings-".concat(e.id),hidden:""}),v=B("div"),b=B("div",{id:"plyr-settings-".concat(e.id,"-home")}),k=B("div",{role:"menu"});b.appendChild(k),v.appendChild(b),t.elements.settings.panels.home=b,t.config.settings.forEach(function(i){var a=B("button",F(Y(t.config.selectors.buttons.settings),{type:"button",class:"".concat(t.config.classNames.control," ").concat(t.config.classNames.control,"--forward"),role:"menuitem","aria-haspopup":!0,hidden:""}));n.call(t,a,i),O(a,"click",function(){c.call(t,i,!1)});var s=B("span",null,ge(i,t.config)),r=B("span",{class:t.config.classNames.menu.value});r.innerHTML=e[i],s.appendChild(r),a.appendChild(s),k.appendChild(a);var o=B("div",{id:"plyr-settings-".concat(e.id,"-").concat(i),hidden:""}),l=B("button",{type:"button",class:"".concat(t.config.classNames.control," ").concat(t.config.classNames.control,"--back")});l.appendChild(B("span",{"aria-hidden":!0},ge(i,t.config))),l.appendChild(B("span",{class:t.config.classNames.hidden},ge("menuBack",t.config))),O(o,"keydown",function(e){37===e.which&&(e.preventDefault(),e.stopPropagation(),c.call(t,"home",!0))},!1),O(l,"click",function(){c.call(t,"home",!1)}),o.appendChild(l),o.appendChild(B("div",{role:"menu"})),v.appendChild(o),t.elements.settings.buttons[i]=a,t.elements.settings.panels[i]=o}),y.appendChild(v),g.appendChild(y),u.appendChild(g),t.elements.settings.popup=y,t.elements.settings.menu=g}if("pip"===o&&ie.pip&&u.appendChild(i.call(t,"pip",d)),"airplay"===o&&ie.airplay&&u.appendChild(i.call(t,"airplay",d)),"download"===o){var w=F({},d,{element:"a",href:t.download,target:"_blank"}),T=t.config.urls.download;!N.url(T)&&t.isEmbed&&F(w,{icon:"logo-".concat(t.provider),label:t.provider}),u.appendChild(i.call(t,"download",w))}"fullscreen"===o&&u.appendChild(i.call(t,"fullscreen",d))}),this.isHTML5&&o.call(this,le.getQualityOptions.call(this)),l.call(this),u},inject:function(){var e=this;if(this.config.loadSprite){var t=Ae.getIconUrl.call(this);t.cors&&be(t.url,"sprite-plyr")}this.id=Math.floor(1e4*Math.random());var n=null;this.elements.controls=null;var i={id:this.id,seektime:this.config.seekTime,title:this.config.title},s=!0;N.function(this.config.controls)&&(this.config.controls=this.config.controls.call(this,i)),this.config.controls||(this.config.controls=[]),N.element(this.config.controls)||N.string(this.config.controls)?n=this.config.controls:(n=Ae.create.call(this,{id:this.id,seektime:this.config.seekTime,speed:this.speed,quality:this.quality,captions:Pe.getLabel.call(this)}),s=!1);var r,o=function(e){var t=e;return Object.entries(i).forEach(function(e){var n=a(e,2),i=n[0],s=n[1];t=de(t,"{".concat(i,"}"),s)}),t};if(s&&(N.string(this.config.controls)?n=o(n):N.element(n)&&(n.innerHTML=o(n.innerHTML))),N.string(this.config.selectors.controls.container)&&(r=document.querySelector(this.config.selectors.controls.container)),N.element(r)||(r=this.elements.container),r[N.element(n)?"insertAdjacentElement":"insertAdjacentHTML"]("afterbegin",n),N.element(this.elements.controls)||Ae.findElements.call(this),!N.empty(this.elements.buttons)){var l=function(t){var n=e.config.classNames.controlPressed;Object.defineProperty(t,"pressed",{enumerable:!0,get:function(){return J(t,n)},set:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];X(t,n,e)}})};Object.values(this.elements.buttons).filter(Boolean).forEach(function(e){N.array(e)||N.nodeList(e)?Array.from(e).filter(Boolean).forEach(l):l(e)})}if(L.isEdge&&x(r),this.config.tooltips.controls){var c=this.config,u=c.classNames,d=c.selectors,h="".concat(d.controls.wrapper," ").concat(d.labels," .").concat(u.hidden),m=G.call(this,h);Array.from(m).forEach(function(t){X(t,e.config.classNames.hidden,!1),X(t,e.config.classNames.tooltip,!0)})}}};function Ee(e){var t=e;if(!(arguments.length>1&&void 0!==arguments[1])||arguments[1]){var n=document.createElement("a");n.href=t,t=n.href}try{return new URL(t)}catch(e){return null}}function Se(e){var t=new URLSearchParams;return N.object(e)&&Object.entries(e).forEach(function(e){var n=a(e,2),i=n[0],s=n[1];t.set(i,s)}),t}var Pe={setup:function(){if(this.supported.ui)if(!this.isVideo||this.isYouTube||this.isHTML5&&!ie.textTracks)N.array(this.config.controls)&&this.config.controls.includes("settings")&&this.config.settings.includes("captions")&&Ae.setCaptionsMenu.call(this);else{if(N.element(this.elements.captions)||(this.elements.captions=B("div",Y(this.config.selectors.captions)),function(e,t){N.element(e)&&N.element(t)&&t.parentNode.insertBefore(e,t.nextSibling)}(this.elements.captions,this.elements.wrapper)),L.isIE&&window.URL){var e=this.media.querySelectorAll("track");Array.from(e).forEach(function(e){var t=e.getAttribute("src"),n=Ee(t);null!==n&&n.hostname!==window.location.href.hostname&&["http:","https:"].includes(n.protocol)&&ve(t,"blob").then(function(t){e.setAttribute("src",window.URL.createObjectURL(t))}).catch(function(){W(e)})})}var t=ce((navigator.languages||[navigator.language||navigator.userLanguage||"en"]).map(function(e){return e.split("-")[0]})),n=(this.storage.get("language")||this.config.captions.language||"auto").toLowerCase();if("auto"===n)n=a(t,1)[0];var i=this.storage.get("captions");if(N.boolean(i)||(i=this.config.captions.active),Object.assign(this.captions,{toggled:!1,active:i,language:n,languages:t}),this.isHTML5){var s=this.config.captions.update?"addtrack removetrack":"removetrack";O.call(this,this.media.textTracks,s,Pe.update.bind(this))}setTimeout(Pe.update.bind(this),0)}},update:function(){var e=this,t=Pe.getTracks.call(this,!0),n=this.captions,i=n.active,a=n.language,s=n.meta,r=n.currentTrackNode,o=Boolean(t.find(function(e){return e.language===a}));this.isHTML5&&this.isVideo&&t.filter(function(e){return!s.get(e)}).forEach(function(t){e.debug.log("Track added",t),s.set(t,{default:"showing"===t.mode}),t.mode="hidden",O.call(e,t,"cuechange",function(){return Pe.updateCues.call(e)})}),(o&&this.language!==a||!t.includes(r))&&(Pe.setLanguage.call(this,a),Pe.toggle.call(this,i&&o)),X(this.elements.container,this.config.classNames.captions.enabled,!N.empty(t)),(this.config.controls||[]).includes("settings")&&this.config.settings.includes("captions")&&Ae.setCaptionsMenu.call(this)},toggle:function(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(this.supported.ui){var n=this.captions.toggled,i=this.config.classNames.captions.active,a=N.nullOrUndefined(e)?!n:e;if(a!==n){if(t||(this.captions.active=a,this.storage.set({captions:a})),!this.language&&a&&!t){var r=Pe.getTracks.call(this),o=Pe.findTrack.call(this,[this.captions.language].concat(s(this.captions.languages)),!0);return this.captions.language=o.language,void Pe.set.call(this,r.indexOf(o))}this.elements.buttons.captions&&(this.elements.buttons.captions.pressed=a),X(this.elements.container,i,a),this.captions.toggled=a,Ae.updateSetting.call(this,"captions"),H.call(this,this.media,a?"captionsenabled":"captionsdisabled")}}},set:function(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],n=Pe.getTracks.call(this);if(-1!==e)if(N.number(e))if(e in n){if(this.captions.currentTrack!==e){this.captions.currentTrack=e;var i=n[e],a=(i||{}).language;this.captions.currentTrackNode=i,Ae.updateSetting.call(this,"captions"),t||(this.captions.language=a,this.storage.set({language:a})),this.isVimeo&&this.embed.enableTextTrack(a),H.call(this,this.media,"languagechange")}Pe.toggle.call(this,!0,t),this.isHTML5&&this.isVideo&&Pe.updateCues.call(this)}else this.debug.warn("Track not found",e);else this.debug.warn("Invalid caption argument",e);else Pe.toggle.call(this,!1,t)},setLanguage:function(e){var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(N.string(e)){var n=e.toLowerCase();this.captions.language=n;var i=Pe.getTracks.call(this),a=Pe.findTrack.call(this,[n]);Pe.set.call(this,i.indexOf(a),t)}else this.debug.warn("Invalid language argument",e)},getTracks:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];return Array.from((this.media||{}).textTracks||[]).filter(function(n){return!e.isHTML5||t||e.captions.meta.has(n)}).filter(function(e){return["captions","subtitles"].includes(e.kind)})},findTrack:function(e){var t,n=this,i=arguments.length>1&&void 0!==arguments[1]&&arguments[1],a=Pe.getTracks.call(this),s=function(e){return Number((n.captions.meta.get(e)||{}).default)},r=Array.from(a).sort(function(e,t){return s(t)-s(e)});return e.every(function(e){return!(t=r.find(function(t){return t.language===e}))}),t||(i?r[0]:void 0)},getCurrentTrack:function(){return Pe.getTracks.call(this)[this.currentTrack]},getLabel:function(e){var t=e;return!N.track(t)&&ie.textTracks&&this.captions.toggled&&(t=Pe.getCurrentTrack.call(this)),N.track(t)?N.empty(t.label)?N.empty(t.language)?ge("enabled",this.config):e.language.toUpperCase():t.label:ge("disabled",this.config)},updateCues:function(e){if(this.supported.ui)if(N.element(this.elements.captions))if(N.nullOrUndefined(e)||Array.isArray(e)){var t=e;if(!t){var n=Pe.getCurrentTrack.call(this);t=Array.from((n||{}).activeCues||[]).map(function(e){return e.getCueAsHTML()}).map(pe)}var i=t.map(function(e){return e.trim()}).join("\n");if(i!==this.elements.captions.innerHTML){z(this.elements.captions);var a=B("span",Y(this.config.selectors.caption));a.innerHTML=i,this.elements.captions.appendChild(a),H.call(this,this.media,"cuechange")}}else this.debug.warn("updateCues: Invalid input",e);else this.debug.warn("No captions element to render to")}},Ne={enabled:!0,title:"",debug:!1,autoplay:!1,autopause:!0,playsinline:!0,seekTime:10,volume:1,muted:!1,duration:null,displayDuration:!0,invertTime:!0,toggleInvert:!0,ratio:null,clickToPlay:!0,hideControls:!0,resetOnEnd:!1,disableContextMenu:!0,loadSprite:!0,iconPrefix:"plyr",iconUrl:"https://cdn.plyr.io/3.5.6/plyr.svg",blankVideo:"https://cdn.plyr.io/static/blank.mp4",quality:{default:576,options:[4320,2880,2160,1440,1080,720,576,480,360,240]},loop:{active:!1},speed:{selected:1,options:[.5,.75,1,1.25,1.5,1.75,2]},keyboard:{focused:!0,global:!1},tooltips:{controls:!1,seek:!0},captions:{active:!1,language:"auto",update:!1},fullscreen:{enabled:!0,fallback:!0,iosNative:!1},storage:{enabled:!0,key:"plyr"},controls:["play-large","play","progress","current-time","mute","volume","captions","settings","pip","airplay","fullscreen"],settings:["captions","quality","speed"],i18n:{restart:"Restart",rewind:"Rewind {seektime}s",play:"Play",pause:"Pause",fastForward:"Forward {seektime}s",seek:"Seek",seekLabel:"{currentTime} of {duration}",played:"Played",buffered:"Buffered",currentTime:"Current time",duration:"Duration",volume:"Volume",mute:"Mute",unmute:"Unmute",enableCaptions:"Enable captions",disableCaptions:"Disable captions",download:"Download",enterFullscreen:"Enter fullscreen",exitFullscreen:"Exit fullscreen",frameTitle:"Player for {title}",captions:"Captions",settings:"Settings",menuBack:"Go back to previous menu",speed:"Speed",normal:"Normal",quality:"Quality",loop:"Loop",start:"Start",end:"End",all:"All",reset:"Reset",disabled:"Disabled",enabled:"Enabled",advertisement:"Ad",qualityBadge:{2160:"4K",1440:"HD",1080:"HD",720:"HD",576:"SD",480:"SD"}},urls:{download:null,vimeo:{sdk:"https://player.vimeo.com/api/player.js",iframe:"https://player.vimeo.com/video/{0}?{1}",api:"https://vimeo.com/api/v2/video/{0}.json"},youtube:{sdk:"https://www.youtube.com/iframe_api",api:"https://noembed.com/embed?url=https://www.youtube.com/watch?v={0}"},googleIMA:{sdk:"https://imasdk.googleapis.com/js/sdkloader/ima3.js"}},listeners:{seek:null,play:null,pause:null,restart:null,rewind:null,fastForward:null,mute:null,volume:null,captions:null,download:null,fullscreen:null,pip:null,airplay:null,speed:null,quality:null,loop:null,language:null},events:["ended","progress","stalled","playing","waiting","canplay","canplaythrough","loadstart","loadeddata","loadedmetadata","timeupdate","volumechange","play","pause","error","seeking","seeked","emptied","ratechange","cuechange","download","enterfullscreen","exitfullscreen","captionsenabled","captionsdisabled","languagechange","controlshidden","controlsshown","ready","statechange","qualitychange","adsloaded","adscontentpause","adscontentresume","adstarted","adsmidpoint","adscomplete","adsallcomplete","adsimpression","adsclick"],selectors:{editable:"input, textarea, select, [contenteditable]",container:".plyr",controls:{container:null,wrapper:".plyr__controls"},labels:"[data-plyr]",buttons:{play:'[data-plyr="play"]',pause:'[data-plyr="pause"]',restart:'[data-plyr="restart"]',rewind:'[data-plyr="rewind"]',fastForward:'[data-plyr="fast-forward"]',mute:'[data-plyr="mute"]',captions:'[data-plyr="captions"]',download:'[data-plyr="download"]',fullscreen:'[data-plyr="fullscreen"]',pip:'[data-plyr="pip"]',airplay:'[data-plyr="airplay"]',settings:'[data-plyr="settings"]',loop:'[data-plyr="loop"]'},inputs:{seek:'[data-plyr="seek"]',volume:'[data-plyr="volume"]',speed:'[data-plyr="speed"]',language:'[data-plyr="language"]',quality:'[data-plyr="quality"]'},display:{currentTime:".plyr__time--current",duration:".plyr__time--duration",buffer:".plyr__progress__buffer",loop:".plyr__progress__loop",volume:".plyr__volume--display"},progress:".plyr__progress",captions:".plyr__captions",caption:".plyr__caption"},classNames:{type:"plyr--{0}",provider:"plyr--{0}",video:"plyr__video-wrapper",embed:"plyr__video-embed",videoFixedRatio:"plyr__video-wrapper--fixed-ratio",embedContainer:"plyr__video-embed__container",poster:"plyr__poster",posterEnabled:"plyr__poster-enabled",ads:"plyr__ads",control:"plyr__control",controlPressed:"plyr__control--pressed",playing:"plyr--playing",paused:"plyr--paused",stopped:"plyr--stopped",loading:"plyr--loading",hover:"plyr--hover",tooltip:"plyr__tooltip",cues:"plyr__cues",hidden:"plyr__sr-only",hideControls:"plyr--hide-controls",isIos:"plyr--is-ios",isTouch:"plyr--is-touch",uiSupported:"plyr--full-ui",noTransition:"plyr--no-transition",display:{time:"plyr__time"},menu:{value:"plyr__menu__value",badge:"plyr__badge",open:"plyr--menu-open"},captions:{enabled:"plyr--captions-enabled",active:"plyr--captions-active"},fullscreen:{enabled:"plyr--fullscreen-enabled",fallback:"plyr--fullscreen-fallback"},pip:{supported:"plyr--pip-supported",active:"plyr--pip-active"},airplay:{supported:"plyr--airplay-supported",active:"plyr--airplay-active"},tabFocus:"plyr__tab-focus",previewThumbnails:{thumbContainer:"plyr__preview-thumb",thumbContainerShown:"plyr__preview-thumb--is-shown",imageContainer:"plyr__preview-thumb__image-container",timeContainer:"plyr__preview-thumb__time-container",scrubbingContainer:"plyr__preview-scrubbing",scrubbingContainerShown:"plyr__preview-scrubbing--is-shown"}},attributes:{embed:{provider:"data-plyr-provider",id:"data-plyr-embed-id"}},ads:{enabled:!1,publisherId:"",tagUrl:""},previewThumbnails:{enabled:!1,src:""},vimeo:{byline:!1,portrait:!1,title:!1,speed:!0,transparent:!1},youtube:{noCookie:!1,rel:0,showinfo:0,iv_load_policy:3,modestbranding:1}},Me="picture-in-picture",xe="inline",Le={html5:"html5",youtube:"youtube",vimeo:"vimeo"},Ie={audio:"audio",video:"video"};var _e=function(){},Oe=function(){function t(){var n=arguments.length>0&&void 0!==arguments[0]&&arguments[0];e(this,t),this.enabled=window.console&&n,this.enabled&&this.log("Debugging enabled")}return n(t,[{key:"log",get:function(){return this.enabled?Function.prototype.bind.call(console.log,console):_e}},{key:"warn",get:function(){return this.enabled?Function.prototype.bind.call(console.warn,console):_e}},{key:"error",get:function(){return this.enabled?Function.prototype.bind.call(console.error,console):_e}}]),t}();function je(){if(this.enabled){var e=this.player.elements.buttons.fullscreen;N.element(e)&&(e.pressed=this.active),H.call(this.player,this.target,this.active?"enterfullscreen":"exitfullscreen",!0),L.isIos||function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(N.element(e)){var n=G.call(this,"button:not(:disabled), input:not(:disabled), [tabindex]"),i=n[0],a=n[n.length-1];_.call(this,this.elements.container,"keydown",function(e){if("Tab"===e.key&&9===e.keyCode){var t=document.activeElement;t!==a||e.shiftKey?t===i&&e.shiftKey&&(a.focus(),e.preventDefault()):(i.focus(),e.preventDefault())}},t,!1)}}.call(this.player,this.target,this.active)}}function qe(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(e?this.scrollPosition={x:window.scrollX||0,y:window.scrollY||0}:window.scrollTo(this.scrollPosition.x,this.scrollPosition.y),document.body.style.overflow=e?"hidden":"",X(this.target,this.player.config.classNames.fullscreen.fallback,e),L.isIos){var t=document.head.querySelector('meta[name="viewport"]'),n="viewport-fit=cover";t||(t=document.createElement("meta")).setAttribute("name","viewport");var i=N.string(t.content)&&t.content.includes(n);e?(this.cleanupViewport=!i,i||(t.content+=",".concat(n))):this.cleanupViewport&&(t.content=t.content.split(",").filter(function(e){return e.trim()!==n}).join(","))}je.call(this)}var He=function(){function t(n){var i=this;e(this,t),this.player=n,this.prefix=t.prefix,this.property=t.property,this.scrollPosition={x:0,y:0},this.forceFallback="force"===n.config.fullscreen.fallback,O.call(this.player,document,"ms"===this.prefix?"MSFullscreenChange":"".concat(this.prefix,"fullscreenchange"),function(){je.call(i)}),O.call(this.player,this.player.elements.container,"dblclick",function(e){N.element(i.player.elements.controls)&&i.player.elements.controls.contains(e.target)||i.toggle()}),this.update()}return n(t,[{key:"update",value:function(){var e;this.enabled?(e=this.forceFallback?"Fallback (forced)":t.native?"Native":"Fallback",this.player.debug.log("".concat(e," fullscreen enabled"))):this.player.debug.log("Fullscreen not supported and fallback disabled");X(this.player.elements.container,this.player.config.classNames.fullscreen.enabled,this.enabled)}},{key:"enter",value:function(){this.enabled&&(L.isIos&&this.player.config.fullscreen.iosNative?this.target.webkitEnterFullscreen():!t.native||this.forceFallback?qe.call(this,!0):this.prefix?N.empty(this.prefix)||this.target["".concat(this.prefix,"Request").concat(this.property)]():this.target.requestFullscreen())}},{key:"exit",value:function(){if(this.enabled)if(L.isIos&&this.player.config.fullscreen.iosNative)this.target.webkitExitFullscreen(),this.player.play();else if(!t.native||this.forceFallback)qe.call(this,!1);else if(this.prefix){if(!N.empty(this.prefix)){var e="moz"===this.prefix?"Cancel":"Exit";document["".concat(this.prefix).concat(e).concat(this.property)]()}}else(document.cancelFullScreen||document.exitFullscreen).call(document)}},{key:"toggle",value:function(){this.active?this.exit():this.enter()}},{key:"usingNative",get:function(){return t.native&&!this.forceFallback}},{key:"enabled",get:function(){return(t.native||this.player.config.fullscreen.fallback)&&this.player.config.fullscreen.enabled&&this.player.supported.ui&&this.player.isVideo}},{key:"active",get:function(){return!!this.enabled&&(!t.native||this.forceFallback?J(this.target,this.player.config.classNames.fullscreen.fallback):(this.prefix?document["".concat(this.prefix).concat(this.property,"Element")]:document.fullscreenElement)===this.target)}},{key:"target",get:function(){return L.isIos&&this.player.config.fullscreen.iosNative?this.player.media:this.player.elements.container}}],[{key:"native",get:function(){return!!(document.fullscreenEnabled||document.webkitFullscreenEnabled||document.mozFullScreenEnabled||document.msFullscreenEnabled)}},{key:"prefix",get:function(){if(N.function(document.exitFullscreen))return"";var e="";return["webkit","moz","ms"].some(function(t){return!(!N.function(document["".concat(t,"ExitFullscreen")])&&!N.function(document["".concat(t,"CancelFullScreen")]))&&(e=t,!0)}),e}},{key:"property",get:function(){return"moz"===this.prefix?"FullScreen":"Fullscreen"}}]),t}();function De(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1;return new Promise(function(n,i){var a=new Image,s=function(){delete a.onload,delete a.onerror,(a.naturalWidth>=t?n:i)(a)};Object.assign(a,{onload:s,onerror:s,src:e})})}var Fe={addStyleHook:function(){X(this.elements.container,this.config.selectors.container.replace(".",""),!0),X(this.elements.container,this.config.classNames.uiSupported,this.supported.ui)},toggleNativeControls:function(){arguments.length>0&&void 0!==arguments[0]&&arguments[0]&&this.isHTML5?this.media.setAttribute("controls",""):this.media.removeAttribute("controls")},build:function(){var e=this;if(this.listeners.media(),!this.supported.ui)return this.debug.warn("Basic support only for ".concat(this.provider," ").concat(this.type)),void Fe.toggleNativeControls.call(this,!0);N.element(this.elements.controls)||(Ae.inject.call(this),this.listeners.controls()),Fe.toggleNativeControls.call(this),this.isHTML5&&Pe.setup.call(this),this.volume=null,this.muted=null,this.loop=null,this.quality=null,this.speed=null,Ae.updateVolume.call(this),Ae.timeUpdate.call(this),Fe.checkPlaying.call(this),X(this.elements.container,this.config.classNames.pip.supported,ie.pip&&this.isHTML5&&this.isVideo),X(this.elements.container,this.config.classNames.airplay.supported,ie.airplay&&this.isHTML5),X(this.elements.container,this.config.classNames.isIos,L.isIos),X(this.elements.container,this.config.classNames.isTouch,this.touch),this.ready=!0,setTimeout(function(){H.call(e,e.media,"ready")},0),Fe.setTitle.call(this),this.poster&&Fe.setPoster.call(this,this.poster,!1).catch(function(){}),this.config.duration&&Ae.durationUpdate.call(this)},setTitle:function(){var e=ge("play",this.config);if(N.string(this.config.title)&&!N.empty(this.config.title)&&(e+=", ".concat(this.config.title)),Array.from(this.elements.buttons.play||[]).forEach(function(t){t.setAttribute("aria-label",e)}),this.isEmbed){var t=Z.call(this,"iframe");if(!N.element(t))return;var n=N.empty(this.config.title)?"video":this.config.title,i=ge("frameTitle",this.config);t.setAttribute("title",i.replace("{title}",n))}},togglePoster:function(e){X(this.elements.container,this.config.classNames.posterEnabled,e)},setPoster:function(e){var t=this;return arguments.length>1&&void 0!==arguments[1]&&!arguments[1]||!this.poster?(this.media.setAttribute("poster",e),function(){var e=this;return new Promise(function(t){return e.ready?setTimeout(t,0):O.call(e,e.elements.container,"ready",t)}).then(function(){})}.call(this).then(function(){return De(e)}).catch(function(n){throw e===t.poster&&Fe.togglePoster.call(t,!1),n}).then(function(){if(e!==t.poster)throw new Error("setPoster cancelled by later call to setPoster")}).then(function(){return Object.assign(t.elements.poster.style,{backgroundImage:"url('".concat(e,"')"),backgroundSize:""}),Fe.togglePoster.call(t,!0),e})):Promise.reject(new Error("Poster already set"))},checkPlaying:function(e){var t=this;X(this.elements.container,this.config.classNames.playing,this.playing),X(this.elements.container,this.config.classNames.paused,this.paused),X(this.elements.container,this.config.classNames.stopped,this.stopped),Array.from(this.elements.buttons.play||[]).forEach(function(e){Object.assign(e,{pressed:t.playing})}),N.event(e)&&"timeupdate"===e.type||Fe.toggleControls.call(this)},checkLoading:function(e){var t=this;this.loading=["stalled","waiting"].includes(e.type),clearTimeout(this.timers.loading),this.timers.loading=setTimeout(function(){X(t.elements.container,t.config.classNames.loading,t.loading),Fe.toggleControls.call(t)},this.loading?250:0)},toggleControls:function(e){var t=this.elements.controls;if(t&&this.config.hideControls){var n=this.touch&&this.lastSeekTime+2e3>Date.now();this.toggleControls(Boolean(e||this.loading||this.paused||t.pressed||t.hover||n))}}},Re=function(){function t(n){e(this,t),this.player=n,this.lastKey=null,this.focusTimer=null,this.lastKeyDown=null,this.handleKey=this.handleKey.bind(this),this.toggleMenu=this.toggleMenu.bind(this),this.setTabFocus=this.setTabFocus.bind(this),this.firstTouch=this.firstTouch.bind(this)}return n(t,[{key:"handleKey",value:function(e){var t=this.player,n=t.elements,i=e.keyCode?e.keyCode:e.which,a="keydown"===e.type,s=a&&i===this.lastKey;if(!(e.altKey||e.ctrlKey||e.metaKey||e.shiftKey)&&N.number(i)){if(a){var r=document.activeElement;if(N.element(r)){var o=t.config.selectors.editable;if(r!==n.inputs.seek&&$(r,o))return;if(32===e.which&&$(r,'button, [role^="menuitem"]'))return}switch([32,37,38,39,40,48,49,50,51,52,53,54,56,57,67,70,73,75,76,77,79].includes(i)&&(e.preventDefault(),e.stopPropagation()),i){case 48:case 49:case 50:case 51:case 52:case 53:case 54:case 55:case 56:case 57:s||(t.currentTime=t.duration/10*(i-48));break;case 32:case 75:s||t.togglePlay();break;case 38:t.increaseVolume(.1);break;case 40:t.decreaseVolume(.1);break;case 77:s||(t.muted=!t.muted);break;case 39:t.forward();break;case 37:t.rewind();break;case 70:t.fullscreen.toggle();break;case 67:s||t.toggleCaptions();break;case 76:t.loop=!t.loop}27===i&&!t.fullscreen.usingNative&&t.fullscreen.active&&t.fullscreen.toggle(),this.lastKey=i}else this.lastKey=null}}},{key:"toggleMenu",value:function(e){Ae.toggleMenu.call(this.player,e)}},{key:"firstTouch",value:function(){var e=this.player,t=e.elements;e.touch=!0,X(t.container,e.config.classNames.isTouch,!0)}},{key:"setTabFocus",value:function(e){var t=this.player,n=t.elements;if(clearTimeout(this.focusTimer),"keydown"!==e.type||9===e.which){"keydown"===e.type&&(this.lastKeyDown=e.timeStamp);var i,a=e.timeStamp-this.lastKeyDown<=20;if("focus"!==e.type||a)i=t.config.classNames.tabFocus,X(G.call(t,".".concat(i)),i,!1),this.focusTimer=setTimeout(function(){var e=document.activeElement;n.container.contains(e)&&X(document.activeElement,t.config.classNames.tabFocus,!0)},10)}}},{key:"global",value:function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0],t=this.player;t.config.keyboard.global&&_.call(t,window,"keydown keyup",this.handleKey,e,!1),_.call(t,document.body,"click",this.toggleMenu,e),q.call(t,document.body,"touchstart",this.firstTouch),_.call(t,document.body,"keydown focus blur",this.setTabFocus,e,!1,!0)}},{key:"container",value:function(){var e=this.player,t=e.config,n=e.elements,i=e.timers;!t.keyboard.global&&t.keyboard.focused&&O.call(e,n.container,"keydown keyup",this.handleKey,!1),O.call(e,n.container,"mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen",function(t){var a=n.controls;a&&"enterfullscreen"===t.type&&(a.pressed=!1,a.hover=!1);var s=0;["touchstart","touchmove","mousemove"].includes(t.type)&&(Fe.toggleControls.call(e,!0),s=e.touch?3e3:2e3),clearTimeout(i.controls),i.controls=setTimeout(function(){return Fe.toggleControls.call(e,!1)},s)});var s=function(t){if(!t)return oe.call(e);var i=n.container.getBoundingClientRect(),a=i.width,s=i.height;return oe.call(e,"".concat(a,":").concat(s))},r=function(){clearTimeout(i.resized),i.resized=setTimeout(s,50)};O.call(e,n.container,"enterfullscreen exitfullscreen",function(t){var i=e.fullscreen,o=i.target,l=i.usingNative;if(o===n.container&&(e.isEmbed||!N.empty(e.config.ratio))){var c="enterfullscreen"===t.type,u=s(c);u.padding;!function(t,n,i){if(e.isVimeo){var s=e.elements.wrapper.firstChild,r=a(t,2)[1],o=a(re.call(e),2),l=o[0],c=o[1];s.style.maxWidth=i?"".concat(r/c*l,"px"):null,s.style.margin=i?"0 auto":null}}(u.ratio,0,c),l||(c?O.call(e,window,"resize",r):j.call(e,window,"resize",r))}})}},{key:"media",value:function(){var e=this,t=this.player,n=t.elements;if(O.call(t,t.media,"timeupdate seeking seeked",function(e){return Ae.timeUpdate.call(t,e)}),O.call(t,t.media,"durationchange loadeddata loadedmetadata",function(e){return Ae.durationUpdate.call(t,e)}),O.call(t,t.media,"canplay loadeddata",function(){Q(n.volume,!t.hasAudio),Q(n.buttons.mute,!t.hasAudio)}),O.call(t,t.media,"ended",function(){t.isHTML5&&t.isVideo&&t.config.resetOnEnd&&t.restart()}),O.call(t,t.media,"progress playing seeking seeked",function(e){return Ae.updateProgress.call(t,e)}),O.call(t,t.media,"volumechange",function(e){return Ae.updateVolume.call(t,e)}),O.call(t,t.media,"playing play pause ended emptied timeupdate",function(e){return Fe.checkPlaying.call(t,e)}),O.call(t,t.media,"waiting canplay seeked playing",function(e){return Fe.checkLoading.call(t,e)}),t.supported.ui&&t.config.clickToPlay&&!t.isAudio){var i=Z.call(t,".".concat(t.config.classNames.video));if(!N.element(i))return;O.call(t,n.container,"click",function(a){([n.container,i].includes(a.target)||i.contains(a.target))&&(t.touch&&t.config.hideControls||(t.ended?(e.proxy(a,t.restart,"restart"),e.proxy(a,t.play,"play")):e.proxy(a,t.togglePlay,"play")))})}t.supported.ui&&t.config.disableContextMenu&&O.call(t,n.wrapper,"contextmenu",function(e){e.preventDefault()},!1),O.call(t,t.media,"volumechange",function(){t.storage.set({volume:t.volume,muted:t.muted})}),O.call(t,t.media,"ratechange",function(){Ae.updateSetting.call(t,"speed"),t.storage.set({speed:t.speed})}),O.call(t,t.media,"qualitychange",function(e){Ae.updateSetting.call(t,"quality",null,e.detail.quality)}),O.call(t,t.media,"ready qualitychange",function(){Ae.setDownloadUrl.call(t)});var a=t.config.events.concat(["keyup","keydown"]).join(" ");O.call(t,t.media,a,function(e){var i=e.detail,a=void 0===i?{}:i;"error"===e.type&&(a=t.media.error),H.call(t,n.container,e.type,!0,a)})}},{key:"proxy",value:function(e,t,n){var i=this.player,a=i.config.listeners[n],s=!0;N.function(a)&&(s=a.call(i,e)),s&&N.function(t)&&t.call(i,e)}},{key:"bind",value:function(e,t,n,i){var a=this,s=!(arguments.length>4&&void 0!==arguments[4])||arguments[4],r=this.player,o=r.config.listeners[i],l=N.function(o);O.call(r,e,t,function(e){return a.proxy(e,n,i)},s&&!l)}},{key:"controls",value:function(){var e=this,t=this.player,n=t.elements,i=L.isIE?"change":"input";if(n.buttons.play&&Array.from(n.buttons.play).forEach(function(n){e.bind(n,"click",t.togglePlay,"play")}),this.bind(n.buttons.restart,"click",t.restart,"restart"),this.bind(n.buttons.rewind,"click",t.rewind,"rewind"),this.bind(n.buttons.fastForward,"click",t.forward,"fastForward"),this.bind(n.buttons.mute,"click",function(){t.muted=!t.muted},"mute"),this.bind(n.buttons.captions,"click",function(){return t.toggleCaptions()}),this.bind(n.buttons.download,"click",function(){H.call(t,t.media,"download")},"download"),this.bind(n.buttons.fullscreen,"click",function(){t.fullscreen.toggle()},"fullscreen"),this.bind(n.buttons.pip,"click",function(){t.pip="toggle"},"pip"),this.bind(n.buttons.airplay,"click",t.airplay,"airplay"),this.bind(n.buttons.settings,"click",function(e){e.stopPropagation(),Ae.toggleMenu.call(t,e)}),this.bind(n.buttons.settings,"keyup",function(e){var n=e.which;[13,32].includes(n)&&(13!==n?(e.preventDefault(),e.stopPropagation(),Ae.toggleMenu.call(t,e)):Ae.focusFirstMenuItem.call(t,null,!0))},null,!1),this.bind(n.settings.menu,"keydown",function(e){27===e.which&&Ae.toggleMenu.call(t,e)}),this.bind(n.inputs.seek,"mousedown mousemove",function(e){var t=n.progress.getBoundingClientRect(),i=100/t.width*(e.pageX-t.left);e.currentTarget.setAttribute("seek-value",i)}),this.bind(n.inputs.seek,"mousedown mouseup keydown keyup touchstart touchend",function(e){var n=e.currentTarget,i=e.keyCode?e.keyCode:e.which;if(!N.keyboardEvent(e)||39===i||37===i){t.lastSeekTime=Date.now();var a=n.hasAttribute("play-on-seeked"),s=["mouseup","touchend","keyup"].includes(e.type);a&&s?(n.removeAttribute("play-on-seeked"),t.play()):!s&&t.playing&&(n.setAttribute("play-on-seeked",""),t.pause())}}),L.isIos){var s=G.call(t,'input[type="range"]');Array.from(s).forEach(function(t){return e.bind(t,i,function(e){return x(e.target)})})}this.bind(n.inputs.seek,i,function(e){var n=e.currentTarget,i=n.getAttribute("seek-value");N.empty(i)&&(i=n.value),n.removeAttribute("seek-value"),t.currentTime=i/n.max*t.duration},"seek"),this.bind(n.progress,"mouseenter mouseleave mousemove",function(e){return Ae.updateSeekTooltip.call(t,e)}),this.bind(n.progress,"mousemove touchmove",function(e){var n=t.previewThumbnails;n&&n.loaded&&n.startMove(e)}),this.bind(n.progress,"mouseleave click",function(){var e=t.previewThumbnails;e&&e.loaded&&e.endMove(!1,!0)}),this.bind(n.progress,"mousedown touchstart",function(e){var n=t.previewThumbnails;n&&n.loaded&&n.startScrubbing(e)}),this.bind(n.progress,"mouseup touchend",function(e){var n=t.previewThumbnails;n&&n.loaded&&n.endScrubbing(e)}),L.isWebkit&&Array.from(G.call(t,'input[type="range"]')).forEach(function(n){e.bind(n,"input",function(e){return Ae.updateRangeFill.call(t,e.target)})}),t.config.toggleInvert&&!N.element(n.display.duration)&&this.bind(n.display.currentTime,"click",function(){0!==t.currentTime&&(t.config.invertTime=!t.config.invertTime,Ae.timeUpdate.call(t))}),this.bind(n.inputs.volume,i,function(e){t.volume=e.target.value},"volume"),this.bind(n.controls,"mouseenter mouseleave",function(e){n.controls.hover=!t.touch&&"mouseenter"===e.type}),this.bind(n.controls,"mousedown mouseup touchstart touchend touchcancel",function(e){n.controls.pressed=["mousedown","touchstart"].includes(e.type)}),this.bind(n.controls,"focusin",function(){var i=t.config,a=t.timers;X(n.controls,i.classNames.noTransition,!0),Fe.toggleControls.call(t,!0),setTimeout(function(){X(n.controls,i.classNames.noTransition,!1)},0);var s=e.touch?3e3:4e3;clearTimeout(a.controls),a.controls=setTimeout(function(){return Fe.toggleControls.call(t,!1)},s)}),this.bind(n.inputs.volume,"wheel",function(e){var n=e.webkitDirectionInvertedFromDevice,i=a([e.deltaX,-e.deltaY].map(function(e){return n?-e:e}),2),s=i[0],r=i[1],o=Math.sign(Math.abs(s)>Math.abs(r)?s:r);t.increaseVolume(o/50);var l=t.media.volume;(1===o&&l<1||-1===o&&l>0)&&e.preventDefault()},"volume",!1)}}]),t}();"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self&&self;var Ve=function(e,t){return e(t={exports:{}},t.exports),t.exports}(function(e,t){e.exports=function(){var e=function(){},t={},n={},i={};function a(e,t){if(e){var a=i[e];if(n[e]=t,a)for(;a.length;)a[0](e,t),a.splice(0,1)}}function s(t,n){t.call&&(t={success:t}),n.length?(t.error||e)(n):(t.success||e)(t)}function r(t,n,i,a){var s,o,l=document,c=i.async,u=(i.numRetries||0)+1,d=i.before||e,h=t.replace(/^(css|img)!/,"");a=a||0,/(^css!|\.css$)/.test(t)?((o=l.createElement("link")).rel="stylesheet",o.href=h,(s="hideFocus"in o)&&o.relList&&(s=0,o.rel="preload",o.as="style")):/(^img!|\.(png|gif|jpg|svg)$)/.test(t)?(o=l.createElement("img")).src=h:((o=l.createElement("script")).src=t,o.async=void 0===c||c),o.onload=o.onerror=o.onbeforeload=function(e){var l=e.type[0];if(s)try{o.sheet.cssText.length||(l="e")}catch(e){18!=e.code&&(l="e")}if("e"==l){if((a+=1)<u)return r(t,n,i,a)}else if("preload"==o.rel&&"style"==o.as)return o.rel="stylesheet";n(t,l,e.defaultPrevented)},!1!==d(t,o)&&l.head.appendChild(o)}function o(e,n,i){var o,l;if(n&&n.trim&&(o=n),l=(o?i:n)||{},o){if(o in t)throw"LoadJS";t[o]=!0}function c(t,n){!function(e,t,n){var i,a,s=(e=e.push?e:[e]).length,o=s,l=[];for(i=function(e,n,i){if("e"==n&&l.push(e),"b"==n){if(!i)return;l.push(e)}--s||t(l)},a=0;a<o;a++)r(e[a],i,n)}(e,function(e){s(l,e),t&&s({success:t,error:n},e),a(o,e)},l)}if(l.returnPromise)return new Promise(c);c()}return o.ready=function(e,t){return function(e,t){e=e.push?e:[e];var a,s,r,o=[],l=e.length,c=l;for(a=function(e,n){n.length&&o.push(e),--c||t(o)};l--;)s=e[l],(r=n[s])?a(s,r):(i[s]=i[s]||[]).push(a)}(e,function(e){s(t,e)}),o},o.done=function(e){a(e,[])},o.reset=function(){t={},n={},i={}},o.isDefined=function(e){return e in t},o}()});function Be(e){return new Promise(function(t,n){Ve(e,{success:t,error:n})})}function Ue(e){e&&!this.embed.hasPlayed&&(this.embed.hasPlayed=!0),this.media.paused===e&&(this.media.paused=!e,H.call(this,this.media,e?"play":"pause"))}var We={setup:function(){var e=this;X(this.elements.wrapper,this.config.classNames.embed,!0),oe.call(this),N.object(window.Vimeo)?We.ready.call(this):Be(this.config.urls.vimeo.sdk).then(function(){We.ready.call(e)}).catch(function(t){e.debug.warn("Vimeo SDK (player.js) failed to load",t)})},ready:function(){var e=this,t=this,n=t.config.vimeo,i=Se(F({},{loop:t.config.loop.active,autoplay:t.autoplay,muted:t.muted,gesture:"media",playsinline:!this.config.fullscreen.iosNative},n)),s=t.media.getAttribute("src");N.empty(s)&&(s=t.media.getAttribute(t.config.attributes.embed.id));var r,o=(r=s,N.empty(r)?null:N.number(Number(r))?r:r.match(/^.*(vimeo.com\/|video\/)(\d+).*/)?RegExp.$2:r),l=B("iframe"),c=ue(t.config.urls.vimeo.iframe,o,i);l.setAttribute("src",c),l.setAttribute("allowfullscreen",""),l.setAttribute("allowtransparency",""),l.setAttribute("allow","autoplay");var u=B("div",{poster:t.poster,class:t.config.classNames.embedContainer});u.appendChild(l),t.media=K(u,t.media),ve(ue(t.config.urls.vimeo.api,o),"json").then(function(e){if(!N.empty(e)){var n=new URL(e[0].thumbnail_large);n.pathname="".concat(n.pathname.split("_")[0],".jpg"),Fe.setPoster.call(t,n.href).catch(function(){})}}),t.embed=new window.Vimeo.Player(l,{autopause:t.config.autopause,muted:t.muted}),t.media.paused=!0,t.media.currentTime=0,t.supported.ui&&t.embed.disableTextTrack(),t.media.play=function(){return Ue.call(t,!0),t.embed.play()},t.media.pause=function(){return Ue.call(t,!1),t.embed.pause()},t.media.stop=function(){t.pause(),t.currentTime=0};var d=t.media.currentTime;Object.defineProperty(t.media,"currentTime",{get:function(){return d},set:function(e){var n=t.embed,i=t.media,a=t.paused,s=t.volume,r=a&&!n.hasPlayed;i.seeking=!0,H.call(t,i,"seeking"),Promise.resolve(r&&n.setVolume(0)).then(function(){return n.setCurrentTime(e)}).then(function(){return r&&n.pause()}).then(function(){return r&&n.setVolume(s)}).catch(function(){})}});var h=t.config.speed.selected;Object.defineProperty(t.media,"playbackRate",{get:function(){return h},set:function(e){t.embed.setPlaybackRate(e).then(function(){h=e,H.call(t,t.media,"ratechange")}).catch(function(e){"Error"===e.name&&Ae.setSpeedMenu.call(t,[])})}});var m=t.config.volume;Object.defineProperty(t.media,"volume",{get:function(){return m},set:function(e){t.embed.setVolume(e).then(function(){m=e,H.call(t,t.media,"volumechange")})}});var p=t.config.muted;Object.defineProperty(t.media,"muted",{get:function(){return p},set:function(e){var n=!!N.boolean(e)&&e;t.embed.setVolume(n?0:t.config.volume).then(function(){p=n,H.call(t,t.media,"volumechange")})}});var f,g=t.config.loop;Object.defineProperty(t.media,"loop",{get:function(){return g},set:function(e){var n=N.boolean(e)?e:t.config.loop.active;t.embed.setLoop(n).then(function(){g=n})}}),t.embed.getVideoUrl().then(function(e){f=e,Ae.setDownloadUrl.call(t)}).catch(function(t){e.debug.warn(t)}),Object.defineProperty(t.media,"currentSrc",{get:function(){return f}}),Object.defineProperty(t.media,"ended",{get:function(){return t.currentTime===t.duration}}),Promise.all([t.embed.getVideoWidth(),t.embed.getVideoHeight()]).then(function(n){var i=a(n,2),s=i[0],r=i[1];t.embed.ratio=[s,r],oe.call(e)}),t.embed.setAutopause(t.config.autopause).then(function(e){t.config.autopause=e}),t.embed.getVideoTitle().then(function(n){t.config.title=n,Fe.setTitle.call(e)}),t.embed.getCurrentTime().then(function(e){d=e,H.call(t,t.media,"timeupdate")}),t.embed.getDuration().then(function(e){t.media.duration=e,H.call(t,t.media,"durationchange")}),t.embed.getTextTracks().then(function(e){t.media.textTracks=e,Pe.setup.call(t)}),t.embed.on("cuechange",function(e){var n=e.cues,i=(void 0===n?[]:n).map(function(e){return function(e){var t=document.createDocumentFragment(),n=document.createElement("div");return t.appendChild(n),n.innerHTML=e,t.firstChild.innerText}(e.text)});Pe.updateCues.call(t,i)}),t.embed.on("loaded",function(){(t.embed.getPaused().then(function(e){Ue.call(t,!e),e||H.call(t,t.media,"playing")}),N.element(t.embed.element)&&t.supported.ui)&&t.embed.element.setAttribute("tabindex",-1)}),t.embed.on("play",function(){Ue.call(t,!0),H.call(t,t.media,"playing")}),t.embed.on("pause",function(){Ue.call(t,!1)}),t.embed.on("timeupdate",function(e){t.media.seeking=!1,d=e.seconds,H.call(t,t.media,"timeupdate")}),t.embed.on("progress",function(e){t.media.buffered=e.percent,H.call(t,t.media,"progress"),1===parseInt(e.percent,10)&&H.call(t,t.media,"canplaythrough"),t.embed.getDuration().then(function(e){e!==t.media.duration&&(t.media.duration=e,H.call(t,t.media,"durationchange"))})}),t.embed.on("seeked",function(){t.media.seeking=!1,H.call(t,t.media,"seeked")}),t.embed.on("ended",function(){t.media.paused=!0,H.call(t,t.media,"ended")}),t.embed.on("error",function(e){t.media.error=e,H.call(t,t.media,"error")}),setTimeout(function(){return Fe.build.call(t)},0)}};function ze(e){e&&!this.embed.hasPlayed&&(this.embed.hasPlayed=!0),this.media.paused===e&&(this.media.paused=!e,H.call(this,this.media,e?"play":"pause"))}function Ke(e){return e.noCookie?"https://www.youtube-nocookie.com":"http:"===window.location.protocol?"http://www.youtube.com":void 0}var Ye={setup:function(){var e=this;if(X(this.elements.wrapper,this.config.classNames.embed,!0),N.object(window.YT)&&N.function(window.YT.Player))Ye.ready.call(this);else{var t=window.onYouTubeIframeAPIReady;window.onYouTubeIframeAPIReady=function(){N.function(t)&&t(),Ye.ready.call(e)},Be(this.config.urls.youtube.sdk).catch(function(t){e.debug.warn("YouTube API failed to load",t)})}},getTitle:function(e){var t=this;ve(ue(this.config.urls.youtube.api,e)).then(function(e){if(N.object(e)){var n=e.title,i=e.height,a=e.width;t.config.title=n,Fe.setTitle.call(t),t.embed.ratio=[a,i]}oe.call(t)}).catch(function(){oe.call(t)})},ready:function(){var e=this,t=e.media&&e.media.getAttribute("id");if(N.empty(t)||!t.startsWith("youtube-")){var n=e.media.getAttribute("src");N.empty(n)&&(n=e.media.getAttribute(this.config.attributes.embed.id));var i,a,s=(i=n,N.empty(i)?null:i.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/)?RegExp.$2:i),r=(a=e.provider,"".concat(a,"-").concat(Math.floor(1e4*Math.random()))),o=B("div",{id:r,poster:e.poster});e.media=K(o,e.media);var l=function(e){return"https://i.ytimg.com/vi/".concat(s,"/").concat(e,"default.jpg")};De(l("maxres"),121).catch(function(){return De(l("sd"),121)}).catch(function(){return De(l("hq"))}).then(function(t){return Fe.setPoster.call(e,t.src)}).then(function(t){t.includes("maxres")||(e.elements.poster.style.backgroundSize="cover")}).catch(function(){});var c=e.config.youtube;e.embed=new window.YT.Player(r,{videoId:s,host:Ke(c),playerVars:F({},{autoplay:e.config.autoplay?1:0,hl:e.config.hl,controls:e.supported.ui?0:1,disablekb:1,playsinline:e.config.fullscreen.iosNative?0:1,cc_load_policy:e.captions.active?1:0,cc_lang_pref:e.config.captions.language,widget_referrer:window?window.location.href:null},c),events:{onError:function(t){if(!e.media.error){var n=t.data,i={2:"The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.",5:"The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.",100:"The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.",101:"The owner of the requested video does not allow it to be played in embedded players.",150:"The owner of the requested video does not allow it to be played in embedded players."}[n]||"An unknown error occured";e.media.error={code:n,message:i},H.call(e,e.media,"error")}},onPlaybackRateChange:function(t){var n=t.target;e.media.playbackRate=n.getPlaybackRate(),H.call(e,e.media,"ratechange")},onReady:function(t){if(!N.function(e.media.play)){var n=t.target;Ye.getTitle.call(e,s),e.media.play=function(){ze.call(e,!0),n.playVideo()},e.media.pause=function(){ze.call(e,!1),n.pauseVideo()},e.media.stop=function(){n.stopVideo()},e.media.duration=n.getDuration(),e.media.paused=!0,e.media.currentTime=0,Object.defineProperty(e.media,"currentTime",{get:function(){return Number(n.getCurrentTime())},set:function(t){e.paused&&!e.embed.hasPlayed&&e.embed.mute(),e.media.seeking=!0,H.call(e,e.media,"seeking"),n.seekTo(t)}}),Object.defineProperty(e.media,"playbackRate",{get:function(){return n.getPlaybackRate()},set:function(e){n.setPlaybackRate(e)}});var i=e.config.volume;Object.defineProperty(e.media,"volume",{get:function(){return i},set:function(t){i=t,n.setVolume(100*i),H.call(e,e.media,"volumechange")}});var a=e.config.muted;Object.defineProperty(e.media,"muted",{get:function(){return a},set:function(t){var i=N.boolean(t)?t:a;a=i,n[i?"mute":"unMute"](),H.call(e,e.media,"volumechange")}}),Object.defineProperty(e.media,"currentSrc",{get:function(){return n.getVideoUrl()}}),Object.defineProperty(e.media,"ended",{get:function(){return e.currentTime===e.duration}}),e.options.speed=n.getAvailablePlaybackRates(),e.supported.ui&&e.media.setAttribute("tabindex",-1),H.call(e,e.media,"timeupdate"),H.call(e,e.media,"durationchange"),clearInterval(e.timers.buffering),e.timers.buffering=setInterval(function(){e.media.buffered=n.getVideoLoadedFraction(),(null===e.media.lastBuffered||e.media.lastBuffered<e.media.buffered)&&H.call(e,e.media,"progress"),e.media.lastBuffered=e.media.buffered,1===e.media.buffered&&(clearInterval(e.timers.buffering),H.call(e,e.media,"canplaythrough"))},200),setTimeout(function(){return Fe.build.call(e)},50)}},onStateChange:function(t){var n=t.target;switch(clearInterval(e.timers.playing),e.media.seeking&&[1,2].includes(t.data)&&(e.media.seeking=!1,H.call(e,e.media,"seeked")),t.data){case-1:H.call(e,e.media,"timeupdate"),e.media.buffered=n.getVideoLoadedFraction(),H.call(e,e.media,"progress");break;case 0:ze.call(e,!1),e.media.loop?(n.stopVideo(),n.playVideo()):H.call(e,e.media,"ended");break;case 1:e.config.autoplay||!e.media.paused||e.embed.hasPlayed?(ze.call(e,!0),H.call(e,e.media,"playing"),e.timers.playing=setInterval(function(){H.call(e,e.media,"timeupdate")},50),e.media.duration!==n.getDuration()&&(e.media.duration=n.getDuration(),H.call(e,e.media,"durationchange"))):e.media.pause();break;case 2:e.muted||e.embed.unMute(),ze.call(e,!1)}H.call(e,e.elements.container,"statechange",!1,{code:t.data})}}})}}},Qe={setup:function(){this.media?(X(this.elements.container,this.config.classNames.type.replace("{0}",this.type),!0),X(this.elements.container,this.config.classNames.provider.replace("{0}",this.provider),!0),this.isEmbed&&X(this.elements.container,this.config.classNames.type.replace("{0}","video"),!0),this.isVideo&&(this.elements.wrapper=B("div",{class:this.config.classNames.video}),R(this.media,this.elements.wrapper),this.elements.poster=B("div",{class:this.config.classNames.poster}),this.elements.wrapper.appendChild(this.elements.poster)),this.isHTML5?le.extend.call(this):this.isYouTube?Ye.setup.call(this):this.isVimeo&&We.setup.call(this)):this.debug.warn("No media element found!")}},Xe=function(){function t(n){var i=this;e(this,t),this.player=n,this.config=n.config.ads,this.playing=!1,this.initialized=!1,this.elements={container:null,displayContainer:null},this.manager=null,this.loader=null,this.cuePoints=null,this.events={},this.safetyTimer=null,this.countdownTimer=null,this.managerPromise=new Promise(function(e,t){i.on("loaded",e),i.on("error",t)}),this.load()}return n(t,[{key:"load",value:function(){var e=this;this.enabled&&(N.object(window.google)&&N.object(window.google.ima)?this.ready():Be(this.player.config.urls.googleIMA.sdk).then(function(){e.ready()}).catch(function(){e.trigger("error",new Error("Google IMA SDK failed to load"))}))}},{key:"ready",value:function(){var e,t=this;this.enabled||((e=this).manager&&e.manager.destroy(),e.elements.displayContainer&&e.elements.displayContainer.destroy(),e.elements.container.remove()),this.startSafetyTimer(12e3,"ready()"),this.managerPromise.then(function(){t.clearSafetyTimer("onAdsManagerLoaded()")}),this.listeners(),this.setupIMA()}},{key:"setupIMA",value:function(){this.elements.container=B("div",{class:this.player.config.classNames.ads}),this.player.elements.container.appendChild(this.elements.container),google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED),google.ima.settings.setLocale(this.player.config.ads.language),google.ima.settings.setDisableCustomPlaybackForIOS10Plus(this.player.config.playsinline),this.elements.displayContainer=new google.ima.AdDisplayContainer(this.elements.container,this.player.media),this.requestAds()}},{key:"requestAds",value:function(){var e=this,t=this.player.elements.container;try{this.loader=new google.ima.AdsLoader(this.elements.displayContainer),this.loader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,function(t){return e.onAdsManagerLoaded(t)},!1),this.loader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR,function(t){return e.onAdError(t)},!1);var n=new google.ima.AdsRequest;n.adTagUrl=this.tagUrl,n.linearAdSlotWidth=t.offsetWidth,n.linearAdSlotHeight=t.offsetHeight,n.nonLinearAdSlotWidth=t.offsetWidth,n.nonLinearAdSlotHeight=t.offsetHeight,n.forceNonLinearFullSlot=!1,n.setAdWillPlayMuted(!this.player.muted),this.loader.requestAds(n)}catch(e){this.onAdError(e)}}},{key:"pollCountdown",value:function(){var e=this;if(!(arguments.length>0&&void 0!==arguments[0]&&arguments[0]))return clearInterval(this.countdownTimer),void this.elements.container.removeAttribute("data-badge-text");this.countdownTimer=setInterval(function(){var t=Ce(Math.max(e.manager.getRemainingTime(),0)),n="".concat(ge("advertisement",e.player.config)," - ").concat(t);e.elements.container.setAttribute("data-badge-text",n)},100)}},{key:"onAdsManagerLoaded",value:function(e){var t=this;if(this.enabled){var n=new google.ima.AdsRenderingSettings;n.restoreCustomPlaybackStateOnAdBreakComplete=!0,n.enablePreloading=!0,this.manager=e.getAdsManager(this.player,n),this.cuePoints=this.manager.getCuePoints(),this.manager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR,function(e){return t.onAdError(e)}),Object.keys(google.ima.AdEvent.Type).forEach(function(e){t.manager.addEventListener(google.ima.AdEvent.Type[e],function(e){return t.onAdEvent(e)})}),this.trigger("loaded")}}},{key:"addCuePoints",value:function(){var e=this;N.empty(this.cuePoints)||this.cuePoints.forEach(function(t){if(0!==t&&-1!==t&&t<e.player.duration){var n=e.player.elements.progress;if(N.element(n)){var i=100/e.player.duration*t,a=B("span",{class:e.player.config.classNames.cues});a.style.left="".concat(i.toString(),"%"),n.appendChild(a)}}})}},{key:"onAdEvent",value:function(e){var t=this,n=this.player.elements.container,i=e.getAd(),a=e.getAdData();switch(function(e){H.call(t.player,t.player.media,"ads".concat(e.replace(/_/g,"").toLowerCase()))}(e.type),e.type){case google.ima.AdEvent.Type.LOADED:this.trigger("loaded"),this.pollCountdown(!0),i.isLinear()||(i.width=n.offsetWidth,i.height=n.offsetHeight);break;case google.ima.AdEvent.Type.STARTED:this.manager.setVolume(this.player.volume);break;case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:this.loadAds();break;case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:this.pauseContent();break;case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:this.pollCountdown(),this.resumeContent();break;case google.ima.AdEvent.Type.LOG:a.adError&&this.player.debug.warn("Non-fatal ad error: ".concat(a.adError.getMessage()))}}},{key:"onAdError",value:function(e){this.cancel(),this.player.debug.warn("Ads error",e)}},{key:"listeners",value:function(){var e,t=this,n=this.player.elements.container;this.player.on("canplay",function(){t.addCuePoints()}),this.player.on("ended",function(){t.loader.contentComplete()}),this.player.on("timeupdate",function(){e=t.player.currentTime}),this.player.on("seeked",function(){var n=t.player.currentTime;N.empty(t.cuePoints)||t.cuePoints.forEach(function(i,a){e<i&&i<n&&(t.manager.discardAdBreak(),t.cuePoints.splice(a,1))})}),window.addEventListener("resize",function(){t.manager&&t.manager.resize(n.offsetWidth,n.offsetHeight,google.ima.ViewMode.NORMAL)})}},{key:"play",value:function(){var e=this,t=this.player.elements.container;this.managerPromise||this.resumeContent(),this.managerPromise.then(function(){e.manager.setVolume(e.player.volume),e.elements.displayContainer.initialize();try{e.initialized||(e.manager.init(t.offsetWidth,t.offsetHeight,google.ima.ViewMode.NORMAL),e.manager.start()),e.initialized=!0}catch(t){e.onAdError(t)}}).catch(function(){})}},{key:"resumeContent",value:function(){this.elements.container.style.zIndex="",this.playing=!1,this.player.media.play()}},{key:"pauseContent",value:function(){this.elements.container.style.zIndex=3,this.playing=!0,this.player.media.pause()}},{key:"cancel",value:function(){this.initialized&&this.resumeContent(),this.trigger("error"),this.loadAds()}},{key:"loadAds",value:function(){var e=this;this.managerPromise.then(function(){e.manager&&e.manager.destroy(),e.managerPromise=new Promise(function(t){e.on("loaded",t),e.player.debug.log(e.manager)}),e.requestAds()}).catch(function(){})}},{key:"trigger",value:function(e){for(var t=this,n=arguments.length,i=new Array(n>1?n-1:0),a=1;a<n;a++)i[a-1]=arguments[a];var s=this.events[e];N.array(s)&&s.forEach(function(e){N.function(e)&&e.apply(t,i)})}},{key:"on",value:function(e,t){return N.array(this.events[e])||(this.events[e]=[]),this.events[e].push(t),this}},{key:"startSafetyTimer",value:function(e,t){var n=this;this.player.debug.log("Safety timer invoked from: ".concat(t)),this.safetyTimer=setTimeout(function(){n.cancel(),n.clearSafetyTimer("startSafetyTimer()")},e)}},{key:"clearSafetyTimer",value:function(e){N.nullOrUndefined(this.safetyTimer)||(this.player.debug.log("Safety timer cleared from: ".concat(e)),clearTimeout(this.safetyTimer),this.safetyTimer=null)}},{key:"enabled",get:function(){var e=this.config;return this.player.isHTML5&&this.player.isVideo&&e.enabled&&(!N.empty(e.publisherId)||N.url(e.tagUrl))}},{key:"tagUrl",get:function(){var e=this.config;if(N.url(e.tagUrl))return e.tagUrl;var t={AV_PUBLISHERID:"58c25bb0073ef448b1087ad6",AV_CHANNELID:"5a0458dc28a06145e4519d21",AV_URL:window.location.hostname,cb:Date.now(),AV_WIDTH:640,AV_HEIGHT:480,AV_CDIM2:this.publisherId};return"".concat("https://go.aniview.com/api/adserver6/vast/","?").concat(Se(t))}}]),t}(),Je=function(){function t(n){e(this,t),this.player=n,this.thumbnails=[],this.loaded=!1,this.lastMouseMoveTime=Date.now(),this.mouseDown=!1,this.loadedImages=[],this.elements={thumb:{},scrubbing:{}},this.load()}return n(t,[{key:"load",value:function(){var e=this;this.player.elements.display.seekTooltip&&(this.player.elements.display.seekTooltip.hidden=this.enabled),this.enabled&&this.getThumbnails().then(function(){e.enabled&&(e.render(),e.determineContainerAutoSizing(),e.loaded=!0)})}},{key:"getThumbnails",value:function(){var e=this;return new Promise(function(t){var n=e.player.config.previewThumbnails.src;if(N.empty(n))throw new Error("Missing previewThumbnails.src config attribute");var i=(N.string(n)?[n]:n).map(function(t){return e.getThumbnail(t)});Promise.all(i).then(function(){e.thumbnails.sort(function(e,t){return e.height-t.height}),e.player.debug.log("Preview thumbnails",e.thumbnails),t()})})}},{key:"getThumbnail",value:function(e){var t=this;return new Promise(function(n){ve(e).then(function(i){var s,r,o={frames:(s=i,r=[],s.split(/\r\n\r\n|\n\n|\r\r/).forEach(function(e){var t={};e.split(/\r\n|\n|\r/).forEach(function(e){if(N.number(t.startTime)){if(!N.empty(e.trim())&&N.empty(t.text)){var n=e.trim().split("#xywh="),i=a(n,1);if(t.text=i[0],n[1]){var s=a(n[1].split(","),4);t.x=s[0],t.y=s[1],t.w=s[2],t.h=s[3]}}}else{var r=e.match(/([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})( ?--> ?)([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})/);r&&(t.startTime=60*Number(r[1]||0)*60+60*Number(r[2])+Number(r[3])+Number("0.".concat(r[4])),t.endTime=60*Number(r[6]||0)*60+60*Number(r[7])+Number(r[8])+Number("0.".concat(r[9])))}}),t.text&&r.push(t)}),r),height:null,urlPrefix:""};o.frames[0].text.startsWith("/")||o.frames[0].text.startsWith("http://")||o.frames[0].text.startsWith("https://")||(o.urlPrefix=e.substring(0,e.lastIndexOf("/")+1));var l=new Image;l.onload=function(){o.height=l.naturalHeight,o.width=l.naturalWidth,t.thumbnails.push(o),n()},l.src=o.urlPrefix+o.frames[0].text})})}},{key:"startMove",value:function(e){if(this.loaded&&N.event(e)&&["touchmove","mousemove"].includes(e.type)&&this.player.media.duration){if("touchmove"===e.type)this.seekTime=this.player.media.duration*(this.player.elements.inputs.seek.value/100);else{var t=this.player.elements.progress.getBoundingClientRect(),n=100/t.width*(e.pageX-t.left);this.seekTime=this.player.media.duration*(n/100),this.seekTime<0&&(this.seekTime=0),this.seekTime>this.player.media.duration-1&&(this.seekTime=this.player.media.duration-1),this.mousePosX=e.pageX,this.elements.thumb.time.innerText=Ce(this.seekTime)}this.showImageAtCurrentTime()}}},{key:"endMove",value:function(){this.toggleThumbContainer(!1,!0)}},{key:"startScrubbing",value:function(e){!1!==e.button&&0!==e.button||(this.mouseDown=!0,this.player.media.duration&&(this.toggleScrubbingContainer(!0),this.toggleThumbContainer(!1,!0),this.showImageAtCurrentTime()))}},{key:"endScrubbing",value:function(){var e=this;this.mouseDown=!1,Math.ceil(this.lastTime)===Math.ceil(this.player.media.currentTime)?this.toggleScrubbingContainer(!1):q.call(this.player,this.player.media,"timeupdate",function(){e.mouseDown||e.toggleScrubbingContainer(!1)})}},{key:"listeners",value:function(){var e=this;this.player.on("play",function(){e.toggleThumbContainer(!1,!0)}),this.player.on("seeked",function(){e.toggleThumbContainer(!1)}),this.player.on("timeupdate",function(){e.lastTime=e.player.media.currentTime})}},{key:"render",value:function(){this.elements.thumb.container=B("div",{class:this.player.config.classNames.previewThumbnails.thumbContainer}),this.elements.thumb.imageContainer=B("div",{class:this.player.config.classNames.previewThumbnails.imageContainer}),this.elements.thumb.container.appendChild(this.elements.thumb.imageContainer);var e=B("div",{class:this.player.config.classNames.previewThumbnails.timeContainer});this.elements.thumb.time=B("span",{},"00:00"),e.appendChild(this.elements.thumb.time),this.elements.thumb.container.appendChild(e),N.element(this.player.elements.progress)&&this.player.elements.progress.appendChild(this.elements.thumb.container),this.elements.scrubbing.container=B("div",{class:this.player.config.classNames.previewThumbnails.scrubbingContainer}),this.player.elements.wrapper.appendChild(this.elements.scrubbing.container)}},{key:"showImageAtCurrentTime",value:function(){var e=this;this.mouseDown?this.setScrubbingContainerSize():this.setThumbContainerSizeAndPos();var t=this.thumbnails[0].frames.findIndex(function(t){return e.seekTime>=t.startTime&&e.seekTime<=t.endTime}),n=t>=0,i=0;this.mouseDown||this.toggleThumbContainer(n),n&&(this.thumbnails.forEach(function(n,a){e.loadedImages.includes(n.frames[t].text)&&(i=a)}),t!==this.showingThumb&&(this.showingThumb=t,this.loadImage(i)))}},{key:"loadImage",value:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,n=this.showingThumb,i=this.thumbnails[t],a=i.urlPrefix,s=i.frames[n],r=i.frames[n].text,o=a+r;if(this.currentImageElement&&this.currentImageElement.dataset.filename===r)this.showImage(this.currentImageElement,s,t,n,r,!1),this.currentImageElement.dataset.index=n,this.removeOldImages(this.currentImageElement);else{this.loadingImage&&this.usingSprites&&(this.loadingImage.onload=null);var l=new Image;l.src=o,l.dataset.index=n,l.dataset.filename=r,this.showingThumbFilename=r,this.player.debug.log("Loading image: ".concat(o)),l.onload=function(){return e.showImage(l,s,t,n,r,!0)},this.loadingImage=l,this.removeOldImages(l)}}},{key:"showImage",value:function(e,t,n,i,a){var s=!(arguments.length>5&&void 0!==arguments[5])||arguments[5];this.player.debug.log("Showing thumb: ".concat(a,". num: ").concat(i,". qual: ").concat(n,". newimg: ").concat(s)),this.setImageSizeAndOffset(e,t),s&&(this.currentImageContainer.appendChild(e),this.currentImageElement=e,this.loadedImages.includes(a)||this.loadedImages.push(a)),this.preloadNearby(i,!0).then(this.preloadNearby(i,!1)).then(this.getHigherQuality(n,e,t,a))}},{key:"removeOldImages",value:function(e){var t=this;Array.from(this.currentImageContainer.children).forEach(function(n){if("img"===n.tagName.toLowerCase()){var i=t.usingSprites?500:1e3;if(n.dataset.index!==e.dataset.index&&!n.dataset.deleting){n.dataset.deleting=!0;var a=t.currentImageContainer;setTimeout(function(){a.removeChild(n),t.player.debug.log("Removing thumb: ".concat(n.dataset.filename))},i)}}})}},{key:"preloadNearby",value:function(e){var t=this,n=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];return new Promise(function(i){setTimeout(function(){var a=t.thumbnails[0].frames[e].text;if(t.showingThumbFilename===a){var s;s=n?t.thumbnails[0].frames.slice(e):t.thumbnails[0].frames.slice(0,e).reverse();var r=!1;s.forEach(function(e){var n=e.text;if(n!==a&&!t.loadedImages.includes(n)){r=!0,t.player.debug.log("Preloading thumb filename: ".concat(n));var s=t.thumbnails[0].urlPrefix+n,o=new Image;o.src=s,o.onload=function(){t.player.debug.log("Preloaded thumb filename: ".concat(n)),t.loadedImages.includes(n)||t.loadedImages.push(n),i()}}}),r||i()}},300)})}},{key:"getHigherQuality",value:function(e,t,n,i){var a=this;if(e<this.thumbnails.length-1){var s=t.naturalHeight;this.usingSprites&&(s=n.h),s<this.thumbContainerHeight&&setTimeout(function(){a.showingThumbFilename===i&&(a.player.debug.log("Showing higher quality thumb for: ".concat(i)),a.loadImage(e+1))},300)}}},{key:"toggleThumbContainer",value:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0],t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=this.player.config.classNames.previewThumbnails.thumbContainerShown;this.elements.thumb.container.classList.toggle(n,e),!e&&t&&(this.showingThumb=null,this.showingThumbFilename=null)}},{key:"toggleScrubbingContainer",value:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0],t=this.player.config.classNames.previewThumbnails.scrubbingContainerShown;this.elements.scrubbing.container.classList.toggle(t,e),e||(this.showingThumb=null,this.showingThumbFilename=null)}},{key:"determineContainerAutoSizing",value:function(){this.elements.thumb.imageContainer.clientHeight>20&&(this.sizeSpecifiedInCSS=!0)}},{key:"setThumbContainerSizeAndPos",value:function(){if(!this.sizeSpecifiedInCSS){var e=Math.floor(this.thumbContainerHeight*this.thumbAspectRatio);this.elements.thumb.imageContainer.style.height="".concat(this.thumbContainerHeight,"px"),this.elements.thumb.imageContainer.style.width="".concat(e,"px")}this.setThumbContainerPos()}},{key:"setThumbContainerPos",value:function(){var e=this.player.elements.progress.getBoundingClientRect(),t=this.player.elements.container.getBoundingClientRect(),n=this.elements.thumb.container,i=t.left-e.left+10,a=t.right-e.left-n.clientWidth-10,s=this.mousePosX-e.left-n.clientWidth/2;s<i&&(s=i),s>a&&(s=a),n.style.left="".concat(s,"px")}},{key:"setScrubbingContainerSize",value:function(){this.elements.scrubbing.container.style.width="".concat(this.player.media.clientWidth,"px"),this.elements.scrubbing.container.style.height="".concat(this.player.media.clientWidth/this.thumbAspectRatio,"px")}},{key:"setImageSizeAndOffset",value:function(e,t){if(this.usingSprites){var n=this.thumbContainerHeight/t.h;e.style.height="".concat(Math.floor(e.naturalHeight*n),"px"),e.style.width="".concat(Math.floor(e.naturalWidth*n),"px"),e.style.left="-".concat(t.x*n,"px"),e.style.top="-".concat(t.y*n,"px")}}},{key:"enabled",get:function(){return this.player.isHTML5&&this.player.isVideo&&this.player.config.previewThumbnails.enabled}},{key:"currentImageContainer",get:function(){return this.mouseDown?this.elements.scrubbing.container:this.elements.thumb.imageContainer}},{key:"usingSprites",get:function(){return Object.keys(this.thumbnails[0].frames[0]).includes("w")}},{key:"thumbAspectRatio",get:function(){return this.usingSprites?this.thumbnails[0].frames[0].w/this.thumbnails[0].frames[0].h:this.thumbnails[0].width/this.thumbnails[0].height}},{key:"thumbContainerHeight",get:function(){return this.mouseDown?Math.floor(this.player.media.clientWidth/this.thumbAspectRatio):Math.floor(this.player.media.clientWidth/this.thumbAspectRatio/4)}},{key:"currentImageElement",get:function(){return this.mouseDown?this.currentScrubbingImageElement:this.currentThumbnailImageElement},set:function(e){this.mouseDown?this.currentScrubbingImageElement=e:this.currentThumbnailImageElement=e}}]),t}(),$e={insertElements:function(e,t){var n=this;N.string(t)?U(e,this.media,{src:t}):N.array(t)&&t.forEach(function(t){U(e,n.media,t)})},change:function(e){var t=this;D(e,"sources.length")?(le.cancelRequests.call(this),this.destroy.call(this,function(){t.options.quality=[],W(t.media),t.media=null,N.element(t.elements.container)&&t.elements.container.removeAttribute("class");var n=e.sources,i=e.type,s=a(n,1)[0],r=s.provider,o=void 0===r?Le.html5:r,l=s.src,c="html5"===o?i:"div",u="html5"===o?{}:{src:l};Object.assign(t,{provider:o,type:i,supported:ie.check(i,o,t.config.playsinline),media:B(c,u)}),t.elements.container.appendChild(t.media),N.boolean(e.autoplay)&&(t.config.autoplay=e.autoplay),t.isHTML5&&(t.config.crossorigin&&t.media.setAttribute("crossorigin",""),t.config.autoplay&&t.media.setAttribute("autoplay",""),N.empty(e.poster)||(t.poster=e.poster),t.config.loop.active&&t.media.setAttribute("loop",""),t.config.muted&&t.media.setAttribute("muted",""),t.config.playsinline&&t.media.setAttribute("playsinline","")),Fe.addStyleHook.call(t),t.isHTML5&&$e.insertElements.call(t,"source",n),t.config.title=e.title,Qe.setup.call(t),t.isHTML5&&Object.keys(e).includes("tracks")&&$e.insertElements.call(t,"track",e.tracks),(t.isHTML5||t.isEmbed&&!t.supported.ui)&&Fe.build.call(t),t.isHTML5&&t.media.load(),t.previewThumbnails&&t.previewThumbnails.load(),t.fullscreen.update()},!0)):this.debug.warn("Invalid source format")}};var Ge,Ze=function(){function t(n,i){var a=this;if(e(this,t),this.timers={},this.ready=!1,this.loading=!1,this.failed=!1,this.touch=ie.touch,this.media=n,N.string(this.media)&&(this.media=document.querySelectorAll(this.media)),(window.jQuery&&this.media instanceof jQuery||N.nodeList(this.media)||N.array(this.media))&&(this.media=this.media[0]),this.config=F({},Ne,t.defaults,i||{},function(){try{return JSON.parse(a.media.getAttribute("data-plyr-config"))}catch(e){return{}}}()),this.elements={container:null,captions:null,buttons:{},display:{},progress:{},inputs:{},settings:{popup:null,menu:null,panels:{},buttons:{}}},this.captions={active:null,currentTrack:-1,meta:new WeakMap},this.fullscreen={active:!1},this.options={speed:[],quality:[]},this.debug=new Oe(this.config.debug),this.debug.log("Config",this.config),this.debug.log("Support",ie),!N.nullOrUndefined(this.media)&&N.element(this.media))if(this.media.plyr)this.debug.warn("Target already setup");else if(this.config.enabled)if(ie.check().api){var s=this.media.cloneNode(!0);s.autoplay=!1,this.elements.original=s;var r=this.media.tagName.toLowerCase(),o=null,l=null;switch(r){case"div":if(o=this.media.querySelector("iframe"),N.element(o)){if(l=Ee(o.getAttribute("src")),this.provider=function(e){return/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(e)?Le.youtube:/^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(e)?Le.vimeo:null}(l.toString()),this.elements.container=this.media,this.media=o,this.elements.container.className="",l.search.length){var c=["1","true"];c.includes(l.searchParams.get("autoplay"))&&(this.config.autoplay=!0),c.includes(l.searchParams.get("loop"))&&(this.config.loop.active=!0),this.isYouTube?(this.config.playsinline=c.includes(l.searchParams.get("playsinline")),this.config.youtube.hl=l.searchParams.get("hl")):this.config.playsinline=!0}}else this.provider=this.media.getAttribute(this.config.attributes.embed.provider),this.media.removeAttribute(this.config.attributes.embed.provider);if(N.empty(this.provider)||!Object.keys(Le).includes(this.provider))return void this.debug.error("Setup failed: Invalid provider");this.type=Ie.video;break;case"video":case"audio":this.type=r,this.provider=Le.html5,this.media.hasAttribute("crossorigin")&&(this.config.crossorigin=!0),this.media.hasAttribute("autoplay")&&(this.config.autoplay=!0),(this.media.hasAttribute("playsinline")||this.media.hasAttribute("webkit-playsinline"))&&(this.config.playsinline=!0),this.media.hasAttribute("muted")&&(this.config.muted=!0),this.media.hasAttribute("loop")&&(this.config.loop.active=!0);break;default:return void this.debug.error("Setup failed: unsupported type")}this.supported=ie.check(this.type,this.provider,this.config.playsinline),this.supported.api?(this.eventListeners=[],this.listeners=new Re(this),this.storage=new ye(this),this.media.plyr=this,N.element(this.elements.container)||(this.elements.container=B("div",{tabindex:0}),R(this.media,this.elements.container)),Fe.addStyleHook.call(this),Qe.setup.call(this),this.config.debug&&O.call(this,this.elements.container,this.config.events.join(" "),function(e){a.debug.log("event: ".concat(e.type))}),(this.isHTML5||this.isEmbed&&!this.supported.ui)&&Fe.build.call(this),this.listeners.container(),this.listeners.global(),this.fullscreen=new He(this),this.config.ads.enabled&&(this.ads=new Xe(this)),this.isHTML5&&this.config.autoplay&&setTimeout(function(){return a.play()},10),this.lastSeekTime=0,this.config.previewThumbnails.enabled&&(this.previewThumbnails=new Je(this))):this.debug.error("Setup failed: no support")}else this.debug.error("Setup failed: no support");else this.debug.error("Setup failed: disabled by config");else this.debug.error("Setup failed: no suitable element passed")}return n(t,[{key:"play",value:function(){var e=this;return N.function(this.media.play)?(this.ads&&this.ads.enabled&&this.ads.managerPromise.then(function(){return e.ads.play()}).catch(function(){return e.media.play()}),this.media.play()):null}},{key:"pause",value:function(){this.playing&&N.function(this.media.pause)&&this.media.pause()}},{key:"togglePlay",value:function(e){(N.boolean(e)?e:!this.playing)?this.play():this.pause()}},{key:"stop",value:function(){this.isHTML5?(this.pause(),this.restart()):N.function(this.media.stop)&&this.media.stop()}},{key:"restart",value:function(){this.currentTime=0}},{key:"rewind",value:function(e){this.currentTime=this.currentTime-(N.number(e)?e:this.config.seekTime)}},{key:"forward",value:function(e){this.currentTime=this.currentTime+(N.number(e)?e:this.config.seekTime)}},{key:"increaseVolume",value:function(e){var t=this.media.muted?0:this.volume;this.volume=t+(N.number(e)?e:0)}},{key:"decreaseVolume",value:function(e){this.increaseVolume(-e)}},{key:"toggleCaptions",value:function(e){Pe.toggle.call(this,e,!1)}},{key:"airplay",value:function(){ie.airplay&&this.media.webkitShowPlaybackTargetPicker()}},{key:"toggleControls",value:function(e){if(this.supported.ui&&!this.isAudio){var t=J(this.elements.container,this.config.classNames.hideControls),n=void 0===e?void 0:!e,i=X(this.elements.container,this.config.classNames.hideControls,n);if(i&&this.config.controls.includes("settings")&&!N.empty(this.config.settings)&&Ae.toggleMenu.call(this,!1),i!==t){var a=i?"controlshidden":"controlsshown";H.call(this,this.media,a)}return!i}return!1}},{key:"on",value:function(e,t){O.call(this,this.elements.container,e,t)}},{key:"once",value:function(e,t){q.call(this,this.elements.container,e,t)}},{key:"off",value:function(e,t){j(this.elements.container,e,t)}},{key:"destroy",value:function(e){var t=this,n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(this.ready){var i=function(){document.body.style.overflow="",t.embed=null,n?(Object.keys(t.elements).length&&(W(t.elements.buttons.play),W(t.elements.captions),W(t.elements.controls),W(t.elements.wrapper),t.elements.buttons.play=null,t.elements.captions=null,t.elements.controls=null,t.elements.wrapper=null),N.function(e)&&e()):(function(){this&&this.eventListeners&&(this.eventListeners.forEach(function(e){var t=e.element,n=e.type,i=e.callback,a=e.options;t.removeEventListener(n,i,a)}),this.eventListeners=[])}.call(t),K(t.elements.original,t.elements.container),H.call(t,t.elements.original,"destroyed",!0),N.function(e)&&e.call(t.elements.original),t.ready=!1,setTimeout(function(){t.elements=null,t.media=null},200))};this.stop(),clearTimeout(this.timers.loading),clearTimeout(this.timers.controls),clearTimeout(this.timers.resized),this.isHTML5?(Fe.toggleNativeControls.call(this,!0),i()):this.isYouTube?(clearInterval(this.timers.buffering),clearInterval(this.timers.playing),null!==this.embed&&N.function(this.embed.destroy)&&this.embed.destroy(),i()):this.isVimeo&&(null!==this.embed&&this.embed.unload().then(i),setTimeout(i,200))}}},{key:"supports",value:function(e){return ie.mime.call(this,e)}},{key:"isHTML5",get:function(){return this.provider===Le.html5}},{key:"isEmbed",get:function(){return this.isYouTube||this.isVimeo}},{key:"isYouTube",get:function(){return this.provider===Le.youtube}},{key:"isVimeo",get:function(){return this.provider===Le.vimeo}},{key:"isVideo",get:function(){return this.type===Ie.video}},{key:"isAudio",get:function(){return this.type===Ie.audio}},{key:"playing",get:function(){return Boolean(this.ready&&!this.paused&&!this.ended)}},{key:"paused",get:function(){return Boolean(this.media.paused)}},{key:"stopped",get:function(){return Boolean(this.paused&&0===this.currentTime)}},{key:"ended",get:function(){return Boolean(this.media.ended)}},{key:"currentTime",set:function(e){if(this.duration){var t=N.number(e)&&e>0;this.media.currentTime=t?Math.min(e,this.duration):0,this.debug.log("Seeking to ".concat(this.currentTime," seconds"))}},get:function(){return Number(this.media.currentTime)}},{key:"buffered",get:function(){var e=this.media.buffered;return N.number(e)?e:e&&e.length&&this.duration>0?e.end(0)/this.duration:0}},{key:"seeking",get:function(){return Boolean(this.media.seeking)}},{key:"duration",get:function(){var e=parseFloat(this.config.duration),t=(this.media||{}).duration,n=N.number(t)&&t!==1/0?t:0;return e||n}},{key:"volume",set:function(e){var t=e;N.string(t)&&(t=Number(t)),N.number(t)||(t=this.storage.get("volume")),N.number(t)||(t=this.config.volume),t>1&&(t=1),t<0&&(t=0),this.config.volume=t,this.media.volume=t,!N.empty(e)&&this.muted&&t>0&&(this.muted=!1)},get:function(){return Number(this.media.volume)}},{key:"muted",set:function(e){var t=e;N.boolean(t)||(t=this.storage.get("muted")),N.boolean(t)||(t=this.config.muted),this.config.muted=t,this.media.muted=t},get:function(){return Boolean(this.media.muted)}},{key:"hasAudio",get:function(){return!this.isHTML5||(!!this.isAudio||(Boolean(this.media.mozHasAudio)||Boolean(this.media.webkitAudioDecodedByteCount)||Boolean(this.media.audioTracks&&this.media.audioTracks.length)))}},{key:"speed",set:function(e){var t=this,n=null;N.number(e)&&(n=e),N.number(n)||(n=this.storage.get("speed")),N.number(n)||(n=this.config.speed.selected);var i=this.minimumSpeed,a=this.maximumSpeed;n=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:255;return Math.min(Math.max(e,t),n)}(n,i,a),this.config.speed.selected=n,setTimeout(function(){t.media.playbackRate=n},0)},get:function(){return Number(this.media.playbackRate)}},{key:"minimumSpeed",get:function(){return this.isYouTube?Math.min.apply(Math,s(this.options.speed)):this.isVimeo?.5:.0625}},{key:"maximumSpeed",get:function(){return this.isYouTube?Math.max.apply(Math,s(this.options.speed)):this.isVimeo?2:16}},{key:"quality",set:function(e){var t=this.config.quality,n=this.options.quality;if(n.length){var i=[!N.empty(e)&&Number(e),this.storage.get("quality"),t.selected,t.default].find(N.number),a=!0;if(!n.includes(i)){var s=function(e,t){return N.array(e)&&e.length?e.reduce(function(e,n){return Math.abs(n-t)<Math.abs(e-t)?n:e}):null}(n,i);this.debug.warn("Unsupported quality option: ".concat(i,", using ").concat(s," instead")),i=s,a=!1}t.selected=i,this.media.quality=i,a&&this.storage.set({quality:i})}},get:function(){return this.media.quality}},{key:"loop",set:function(e){var t=N.boolean(e)?e:this.config.loop.active;this.config.loop.active=t,this.media.loop=t},get:function(){return Boolean(this.media.loop)}},{key:"source",set:function(e){$e.change.call(this,e)},get:function(){return this.media.currentSrc}},{key:"download",get:function(){var e=this.config.urls.download;return N.url(e)?e:this.source},set:function(e){N.url(e)&&(this.config.urls.download=e,Ae.setDownloadUrl.call(this))}},{key:"poster",set:function(e){this.isVideo?Fe.setPoster.call(this,e,!1).catch(function(){}):this.debug.warn("Poster can only be set for video")},get:function(){return this.isVideo?this.media.getAttribute("poster"):null}},{key:"ratio",get:function(){if(!this.isVideo)return null;var e=se(re.call(this));return N.array(e)?e.join(":"):e},set:function(e){this.isVideo?N.string(e)&&ae(e)?(this.config.ratio=e,oe.call(this)):this.debug.error("Invalid aspect ratio specified (".concat(e,")")):this.debug.warn("Aspect ratio can only be set for video")}},{key:"autoplay",set:function(e){var t=N.boolean(e)?e:this.config.autoplay;this.config.autoplay=t},get:function(){return Boolean(this.config.autoplay)}},{key:"currentTrack",set:function(e){Pe.set.call(this,e,!1)},get:function(){var e=this.captions,t=e.toggled,n=e.currentTrack;return t?n:-1}},{key:"language",set:function(e){Pe.setLanguage.call(this,e,!1)},get:function(){return(Pe.getCurrentTrack.call(this)||{}).language}},{key:"pip",set:function(e){if(ie.pip){var t=N.boolean(e)?e:!this.pip;N.function(this.media.webkitSetPresentationMode)&&this.media.webkitSetPresentationMode(t?Me:xe),N.function(this.media.requestPictureInPicture)&&(!this.pip&&t?this.media.requestPictureInPicture():this.pip&&!t&&document.exitPictureInPicture())}},get:function(){return ie.pip?N.empty(this.media.webkitPresentationMode)?this.media===document.pictureInPictureElement:this.media.webkitPresentationMode===Me:null}}],[{key:"supported",value:function(e,t,n){return ie.check(e,t,n)}},{key:"loadSprite",value:function(e,t){return be(e,t)}},{key:"setup",value:function(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=null;return N.string(e)?i=Array.from(document.querySelectorAll(e)):N.nodeList(e)?i=Array.from(e):N.array(e)&&(i=e.filter(N.element)),N.empty(i)?null:i.map(function(e){return new t(e,n)})}}]),t}();return Ze.defaults=(Ge=Ne,JSON.parse(JSON.stringify(Ge))),Ze});
//# sourceMappingURL=plyr.min.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49), __webpack_require__(30)))

/***/ }),
/* 989 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"player",attrs:{"name":"ppPdfView"}},[_c('div',{staticClass:"pdf-content"},[(_vm.videoPlayerLoaded && !_vm.inFrame)?_c('video',{attrs:{"src":_vm.src,"id":"player","controls":"","allow":"autoplay"}}):_vm._e(),_vm._v(" "),(_vm.videoPlayerLoaded && _vm.inFrame)?_c('div',{staticClass:"plyr__video-embed",attrs:{"id":"player"}},[_c('iframe',{attrs:{"src":_vm.src,"allowfullscreen":"","allowtransparency":"","allow":"autoplay"}})]):_vm._e()])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PresentationViewer_vue__ = __webpack_require__(333);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36558f2a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PresentationViewer_vue__ = __webpack_require__(994);
function injectStyle (ssrContext) {
  __webpack_require__(992)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PresentationViewer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36558f2a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PresentationViewer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(993);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("287099a4", content, true, {});

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".pagefade-enter-active,.pagefade-leave-active{transition:all .05s linear}.pagefade-enter,.pagefade-leave-to{opacity:0}", ""]);

// exports


/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"player",attrs:{"name":"ppPdfView"}},[_c('div',{staticClass:"pdf-content"},[_c('iframe',{attrs:{"src":_vm.src}})])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScormViewer_vue__ = __webpack_require__(334);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26d4aea8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScormViewer_vue__ = __webpack_require__(998);
function injectStyle (ssrContext) {
  __webpack_require__(996)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26d4aea8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScormViewer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26d4aea8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScormViewer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(997);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("66b2f274", content, true, {});

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".pagefade-enter-active[data-v-26d4aea8],.pagefade-leave-active[data-v-26d4aea8]{transition:all .05s linear}.pagefade-enter[data-v-26d4aea8],.pagefade-leave-to[data-v-26d4aea8]{opacity:0}iframe[data-v-26d4aea8]{width:100%;height:100%}.scorm-show[data-v-26d4aea8]{position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:11000}.scorm-show-close[data-v-26d4aea8]{position:fixed;top:50px;right:15px;background:url(/Content/dist/icon-close.png?5770202fecb1913aa90b351f127f1bba) 50% no-repeat;height:20px;width:20px;cursor:pointer;z-index:12000}", ""]);

// exports


/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"player",attrs:{"name":"ppPdfView"}},[_c('div',{staticClass:"pdf-content scorm",attrs:{"id":"PlayerContent"}},[_c('div',{staticClass:"player-play",on:{"click":function($event){$event.stopPropagation();return _vm.toFullScreen.apply(null, arguments)}}},[_c('svg',{staticClass:"svg-icon",staticStyle:{"margin-right":"7px"},attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":"/Content/dist/image_svg.svg#Play"}})])]),_vm._v(" "),_c('div',{staticClass:"scorm-img",style:(_vm.img),attrs:{"id":"PlayerContentImg"}}),_vm._v(" "),_c('div',{staticClass:"scorm-show-close",staticStyle:{"display":"none"},on:{"click":function($event){$event.stopPropagation();return _vm.iosFullScreenClose.apply(null, arguments)}}}),_vm._v(" "),_c('iframe',{staticStyle:{"display":"none"},attrs:{"src":_vm.src}})])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FroalaEditor_vue__ = __webpack_require__(335);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f963a91_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FroalaEditor_vue__ = __webpack_require__(1000);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FroalaEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f963a91_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FroalaEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"input-memo",staticStyle:{"height":"250px"},attrs:{"name":_vm.name,"rows":"10"},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckedDown_vue__ = __webpack_require__(336);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66cfd5a4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckedDown_vue__ = __webpack_require__(1004);
function injectStyle (ssrContext) {
  __webpack_require__(1002)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66cfd5a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckedDown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66cfd5a4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckedDown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1003);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("b6369cc8", content, true, {});

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".dropdown-block .dropdown-menu-item-selected[data-v-66cfd5a4]{max-width:550px;display:inline-block}.dropdown-block .input-text[data-v-66cfd5a4]{min-height:auto;border:none;padding:0}.dropdown-block.dropdown-error[data-v-66cfd5a4]{border-color:#ef0348}", ""]);

// exports


/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickOutside),expression:"onClickOutside"}],class:['dropdown-block', { 'dropdown-menu-open': _vm.dropDownOpen, 'top': _vm.isOverflown, }, {'dropdown-error': _vm.hasErrors && !_vm.dropDownOpen}],attrs:{"name":_vm.name}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],ref:"SearchInput",staticClass:"input-text",attrs:{"type":"text","placeholder":_vm.selectedText,"name":_vm.name,"autocomplete":"off","disabled":_vm.disabled},domProps:{"value":(_vm.searchText)},on:{"click":function($event){return _vm.onDropDownOpen()},"input":[function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value},function($event){return _vm.onChangeSearchInput($event)}],"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();},"blur":function($event){return _vm.$emit('blur')}}}),_vm._v(" "),(!_vm.disabled)?_c('div',{key:_vm.dropdownKey,staticClass:"dropdown-menu dropdown-list",on:{"scroll":_vm.onScroll}},_vm._l((_vm.dropItems),function(item,i){return (!item.Hidden)?_c('div',{staticClass:"dropdown-menu-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.Checked),expression:"item.Checked"}],staticClass:"input-checkbox",attrs:{"id":_vm.idPref + i,"value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(item.Checked)?_vm._i(item.Checked,"true")>-1:(item.Checked)},on:{"click":function($event){return _vm.onSelect(item, i, $event)},"change":function($event){var $$a=item.Checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "Checked", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "Checked", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "Checked", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":_vm.idPref + i}},[_vm._v(_vm._s(item[_vm.textField]))])]):_vm._e()}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropZone_vue__ = __webpack_require__(337);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f953c4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropZone_vue__ = __webpack_require__(1008);
function injectStyle (ssrContext) {
  __webpack_require__(1006)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39f953c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DropZone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f953c4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DropZone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1007);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("61bba393", content, true, {});

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".dragover-active[data-v-39f953c4]{background:#eceff1}", ""]);

// exports


/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dropzone",class:[{'dragover-active' : _vm.active.value}],on:{"dragenter":function($event){$event.preventDefault();return _vm.setActive.apply(null, arguments)},"dragover":function($event){$event.preventDefault();return _vm.setActive.apply(null, arguments)},"dragleave":function($event){$event.preventDefault();return _vm.setInactive.apply(null, arguments)},"drop":function($event){$event.preventDefault();return _vm.onDrop.apply(null, arguments)}}},[_vm._t("default",null,{"dropZoneActive":_vm.active})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageSetting_vue__ = __webpack_require__(338);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b19cf62_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageSetting_vue__ = __webpack_require__(1012);
function injectStyle (ssrContext) {
  __webpack_require__(1010)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b19cf62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageSetting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b19cf62_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageSetting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1011);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("41c6c7bb", content, true, {});

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"form-field-group"},[(!_vm.parentImage && !_vm.img.ImagePath && !_vm.img.Image.FileData)?_c('div',{staticClass:"form-field"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.img.ImageStyle.useMainPhoto),expression:"img.ImageStyle.useMainPhoto"}],staticClass:"input-checkbox",attrs:{"name":_vm.name + 'UseMainPhoto',"id":_vm.name + 'UseMainPhoto',"value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.img.ImageStyle.useMainPhoto)?_vm._i(_vm.img.ImageStyle.useMainPhoto,"true")>-1:(_vm.img.ImageStyle.useMainPhoto)},on:{"change":[function($event){var $$a=_vm.img.ImageStyle.useMainPhoto,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.img.ImageStyle, "useMainPhoto", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.img.ImageStyle, "useMainPhoto", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.img.ImageStyle, "useMainPhoto", $$c)}},function($event){return _vm.onChangeUseMainPhoto($event)}]}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl",attrs:{"for":_vm.name + 'UseMainPhoto'}},[_vm._v("Использовать одну фотографию")])]):_vm._e(),_vm._v(" "),(_vm.img.ImagePath && !_vm.img.ImageStyle.useMainPhoto)?_c('div',{staticClass:"form-field file-uploaded"},[_c('img',{attrs:{"src":_vm.img.ImagePath}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('div',{staticClass:"flex"},[(!_vm.img.ImageStyle.useMainPhoto)?_c('div',{staticClass:"file-upload-zone"},[_c('input',{staticClass:"file-upload-zone-btn",attrs:{"type":"file","id":_vm.name + 'dropFiles',"name":_vm.name + 'dropFiles',"accept":".jpg,.jpeg,.png,.gif,.bmp"}}),_vm._v(" "),_c('label',{staticClass:"file-upload-zone-lbl",attrs:{"id":"dropFilesBtnLbl","for":_vm.name + 'dropFiles'}},[_vm._v("\n                        Загрузить\n                    ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"margin-left-10",staticStyle:{"display":"inline-block"}},[(_vm.img.ImagePath || _vm.img.Image.FileData)?_c('button',{staticClass:"btn btn-delete",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeImage()}}},[_vm._v("\n                        Удалить\n                    ")]):_vm._e()])]),_vm._v(" "),(_vm.filename && !_vm.img.ImageStyle.useMainPhoto)?_c('div',{staticClass:"fileList margin-top-5"},[_vm._v("\n                Выбран файл: "+_vm._s(_vm.filename)+"\n            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-field margin-top-10"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                    Размер изображения, %\n                ")]),_vm._v(" "),_c('touch-spin',{attrs:{"min":0,"defaultValue":0},model:{value:(_vm.img.ImageStyle.size),callback:function ($$v) {_vm.$set(_vm.img.ImageStyle, "size", $$v)},expression:"img.ImageStyle.size"}})],1),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.img.ImageStyle.resizeType),expression:"img.ImageStyle.resizeType",modifiers:{"number":true}}],staticClass:"input-checkbox",attrs:{"name":_vm.name + 'Size',"id":_vm.name + 'St1',"value":"1","type":"radio","selected":""},domProps:{"checked":_vm._q(_vm.img.ImageStyle.resizeType,_vm._n("1"))},on:{"change":[function($event){_vm.$set(_vm.img.ImageStyle, "resizeType", _vm._n("1"))},function($event){}]}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl no-margin-top",attrs:{"for":_vm.name + 'St1'}},[_vm._v("Высота или")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.img.ImageStyle.resizeType),expression:"img.ImageStyle.resizeType",modifiers:{"number":true}}],staticClass:"input-checkbox",attrs:{"name":_vm.name + 'Size',"id":_vm.name + 'St2',"value":"2","type":"radio"},domProps:{"checked":_vm._q(_vm.img.ImageStyle.resizeType,_vm._n("2"))},on:{"change":[function($event){_vm.$set(_vm.img.ImageStyle, "resizeType", _vm._n("2"))},function($event){}]}}),_vm._v(" "),_c('label',{staticClass:"input-checkbox-lbl no-margin-top",attrs:{"for":_vm.name + 'St2'}},[_vm._v("Ширина")])])])]),_vm._v(" "),_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-15"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                Расположение, %\n            ")]),_vm._v(" "),_c('touch-spin',{attrs:{"min":-100,"max":100,"defaultValue":0},model:{value:(_vm.img.ImageStyle.top),callback:function ($$v) {_vm.$set(_vm.img.ImageStyle, "top", $$v)},expression:"img.ImageStyle.top"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                Выравнивание, %\n            ")]),_vm._v(" "),_c('touch-spin',{attrs:{"min":-100,"max":100,"defaultValue":0},model:{value:(_vm.img.ImageStyle.translateY),callback:function ($$v) {_vm.$set(_vm.img.ImageStyle, "translateY", $$v)},expression:"img.ImageStyle.translateY"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"35px","min-width":"35px","padding-top":"23px"}},[_c('button',{staticClass:"btn btn-default btn-img",attrs:{"type":"button"},on:{"click":function($event){return _vm.setImageStyleParams({top: 0, translateY: 0})}}},[_c('img',{attrs:{"src":__webpack_require__(1013),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"35px","min-width":"35px","padding-top":"23px"}},[_c('button',{staticClass:"btn btn-default btn-img",attrs:{"type":"button"},on:{"click":function($event){return _vm.setImageStyleParams({top: 50, translateY: -50})}}},[_c('img',{attrs:{"src":__webpack_require__(1014),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"35px","min-width":"35px","padding-top":"23px"}},[_c('button',{staticClass:"btn btn-default btn-img",attrs:{"type":"button"},on:{"click":function($event){return _vm.setImageStyleParams({top: 100, translateY: -100})}}},[_c('img',{attrs:{"src":__webpack_require__(1015),"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"line-separator margin-bottom-15 margin-top-15"}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"form-field-group"},[_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                Расположение, %\n            ")]),_vm._v(" "),_c('touch-spin',{attrs:{"min":-100,"max":100,"defaultValue":0},model:{value:(_vm.img.ImageStyle.left),callback:function ($$v) {_vm.$set(_vm.img.ImageStyle, "left", $$v)},expression:"img.ImageStyle.left"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('label',{staticClass:"input-text-lbl"},[_vm._v("\n                Выравнивание, %\n            ")]),_vm._v(" "),_c('touch-spin',{attrs:{"min":-100,"max":100,"defaultValue":0},model:{value:(_vm.img.ImageStyle.translateX),callback:function ($$v) {_vm.$set(_vm.img.ImageStyle, "translateX", $$v)},expression:"img.ImageStyle.translateX"}})],1),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"35px","min-width":"35px","padding-top":"23px"}},[_c('button',{staticClass:"btn btn-default btn-img",attrs:{"type":"button"},on:{"click":function($event){return _vm.setImageStyleParams({left: 0, translateX: 0})}}},[_c('img',{attrs:{"src":__webpack_require__(1016),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"35px","min-width":"35px","padding-top":"23px"}},[_c('button',{staticClass:"btn btn-default btn-img",attrs:{"type":"button"},on:{"click":function($event){return _vm.setImageStyleParams({left: 50, translateX: -50})}}},[_c('img',{attrs:{"src":__webpack_require__(1017),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"form-field",staticStyle:{"width":"35px","min-width":"35px","padding-top":"23px"}},[_c('button',{staticClass:"btn btn-default btn-img",attrs:{"type":"button"},on:{"click":function($event){return _vm.setImageStyleParams({left: 100, translateX: -100})}}},[_c('img',{attrs:{"src":__webpack_require__(1018),"alt":""}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"input-text-lbl"},[_c('b',[_vm._v("Вертикаль")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"input-text-lbl"},[_c('b',[_vm._v("Горизонталь")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "align-top.png?801374faca0c27539d656e9166a44721";

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "align-middle.png?06c096c3777aee923958120b5befce26";

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "align-bottom.png?876952a1ae82652ab3664962acc8e466";

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "align-left.png?4081d370134c5936eb189157a964dcd7";

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "align-center.png?188dcf1ef548329ad68d17fe5734197f";

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "align-right.png?d224db687bf09f158129b3f16679cb1b";

/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__ = __webpack_require__(339);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_201eb749_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__ = __webpack_require__(1022);
function injectStyle (ssrContext) {
  __webpack_require__(1020)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-201eb749"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_201eb749_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1021);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("3892d94f", content, true, {});

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".notification-circle[data-v-201eb749]{width:15px;height:15px;border-radius:50%}", ""]);

// exports


/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickOutside),expression:"onClickOutside"}],class:['notification', { 'top': _vm.isOverflown}],attrs:{"name":_vm.name}},[_c('div',{staticClass:"flex"},[_c('div',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('a',{staticClass:"flex",attrs:{"href":"javascript:;"},on:{"click":_vm.menuClick}},[_c('svg',{staticClass:"svg-icon",style:(_vm.styleBell),attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":'/Content/dist/image_svg.svg?v1#Bell'}})]),_vm._v(" "),_c('span',{staticClass:"menu-item-info count-info"},[_vm._v(_vm._s(_vm.totalCount))])])]),_vm._v(" "),_c('div',{class:['notification-block', {'notification-open': _vm.notificationOpen}]},[_c('div',{staticClass:"notification-list"},_vm._l((_vm.notificationItems),function(item){return _c('div',{class:['notification-item', {'no-viwed':!item.Viewed}],style:([item.Viewed ? {'border-color': 'none'} : {'border-color': _vm.menuColor}])},[_c('div',{staticClass:"flex",on:{"click":function($event){return _vm.gotoPage(item)}}},[_c('div',[_c('svg',{staticClass:"svg-icon",style:({fill: _vm.menuColor }),attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":item.img}})]),_vm._v(" "),(!item.Viewed)?_c('div',{staticClass:"notification-circle margin-top-10 margin-left-5",style:({background: _vm.menuColor })}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-field"},[_c('span',[_vm._v(_vm._s(item.PageText))]),_vm._v(" "),(item.isSystem)?_c('p',{staticClass:"panel-body-desc"},[_vm._v(_vm._s(item.Body))]):_c('p',{staticClass:"panel-body-desc",domProps:{"innerHTML":_vm._s(item.Body)}}),_vm._v(" "),_c('p',{staticClass:"input-text-lbl"},[_vm._v(_vm._s(item.CreateDateFormatted))])])])])}),0),_vm._v(" "),_c('div',{staticClass:"flex margin-top-20 margin-right-10"},[(_vm.canBeLoaded)?_c('div',{staticClass:"flex margin-top-3",staticStyle:{"width":"120px"},on:{"click":function($event){return _vm.loadNext()}}},[_c('svg',{staticClass:"svg-icon",style:({fill: _vm.menuColor }),attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('use',{attrs:{"xlink:href":'/Content/dist/image_svg.svg?v1#ArrowDownCircle'}})]),_vm._v(" "),_c('span',[_vm._v("Показать ещё")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticClass:"margin-top-3"},[_c('span',{on:{"click":function($event){return _vm.close()}}},[_vm._v("Отмена")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js